/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/garage48-vrideas/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1464);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Vec3;

var Mat3 = __webpack_require__(32);

/**
 * 3-dimensional vector
 * @class Vec3
 * @constructor
 * @param {Number} x
 * @param {Number} y
 * @param {Number} z
 * @author schteppe
 * @example
 *     var v = new Vec3(1, 2, 3);
 *     console.log('x=' + v.x); // x=1
 */
function Vec3(x,y,z){
    /**
     * @property x
     * @type {Number}
     */
    this.x = x||0.0;

    /**
     * @property y
     * @type {Number}
     */
    this.y = y||0.0;

    /**
     * @property z
     * @type {Number}
     */
    this.z = z||0.0;
}

/**
 * @static
 * @property {Vec3} ZERO
 */
Vec3.ZERO = new Vec3(0, 0, 0);

/**
 * @static
 * @property {Vec3} UNIT_X
 */
Vec3.UNIT_X = new Vec3(1, 0, 0);

/**
 * @static
 * @property {Vec3} UNIT_Y
 */
Vec3.UNIT_Y = new Vec3(0, 1, 0);

/**
 * @static
 * @property {Vec3} UNIT_Z
 */
Vec3.UNIT_Z = new Vec3(0, 0, 1);

/**
 * Vector cross product
 * @method cross
 * @param {Vec3} v
 * @param {Vec3} target Optional. Target to save in.
 * @return {Vec3}
 */
Vec3.prototype.cross = function(v,target){
    var vx=v.x, vy=v.y, vz=v.z, x=this.x, y=this.y, z=this.z;
    target = target || new Vec3();

    target.x = (y * vz) - (z * vy);
    target.y = (z * vx) - (x * vz);
    target.z = (x * vy) - (y * vx);

    return target;
};

/**
 * Set the vectors' 3 elements
 * @method set
 * @param {Number} x
 * @param {Number} y
 * @param {Number} z
 * @return Vec3
 */
Vec3.prototype.set = function(x,y,z){
    this.x = x;
    this.y = y;
    this.z = z;
    return this;
};

/**
 * Set all components of the vector to zero.
 * @method setZero
 */
Vec3.prototype.setZero = function(){
    this.x = this.y = this.z = 0;
};

/**
 * Vector addition
 * @method vadd
 * @param {Vec3} v
 * @param {Vec3} target Optional.
 * @return {Vec3}
 */
Vec3.prototype.vadd = function(v,target){
    if(target){
        target.x = v.x + this.x;
        target.y = v.y + this.y;
        target.z = v.z + this.z;
    } else {
        return new Vec3(this.x + v.x,
                               this.y + v.y,
                               this.z + v.z);
    }
};

/**
 * Vector subtraction
 * @method vsub
 * @param {Vec3} v
 * @param {Vec3} target Optional. Target to save in.
 * @return {Vec3}
 */
Vec3.prototype.vsub = function(v,target){
    if(target){
        target.x = this.x - v.x;
        target.y = this.y - v.y;
        target.z = this.z - v.z;
    } else {
        return new Vec3(this.x-v.x,
                               this.y-v.y,
                               this.z-v.z);
    }
};

/**
 * Get the cross product matrix a_cross from a vector, such that a x b = a_cross * b = c
 * @method crossmat
 * @see http://www8.cs.umu.se/kurser/TDBD24/VT06/lectures/Lecture6.pdf
 * @return {Mat3}
 */
Vec3.prototype.crossmat = function(){
    return new Mat3([     0,  -this.z,   this.y,
                            this.z,        0,  -this.x,
                           -this.y,   this.x,        0]);
};

/**
 * Normalize the vector. Note that this changes the values in the vector.
 * @method normalize
 * @return {Number} Returns the norm of the vector
 */
Vec3.prototype.normalize = function(){
    var x=this.x, y=this.y, z=this.z;
    var n = Math.sqrt(x*x + y*y + z*z);
    if(n>0.0){
        var invN = 1/n;
        this.x *= invN;
        this.y *= invN;
        this.z *= invN;
    } else {
        // Make something up
        this.x = 0;
        this.y = 0;
        this.z = 0;
    }
    return n;
};

/**
 * Get the version of this vector that is of length 1.
 * @method unit
 * @param {Vec3} target Optional target to save in
 * @return {Vec3} Returns the unit vector
 */
Vec3.prototype.unit = function(target){
    target = target || new Vec3();
    var x=this.x, y=this.y, z=this.z;
    var ninv = Math.sqrt(x*x + y*y + z*z);
    if(ninv>0.0){
        ninv = 1.0/ninv;
        target.x = x * ninv;
        target.y = y * ninv;
        target.z = z * ninv;
    } else {
        target.x = 1;
        target.y = 0;
        target.z = 0;
    }
    return target;
};

/**
 * Get the length of the vector
 * @method norm
 * @return {Number}
 * @deprecated Use .length() instead
 */
Vec3.prototype.norm = function(){
    var x=this.x, y=this.y, z=this.z;
    return Math.sqrt(x*x + y*y + z*z);
};

/**
 * Get the length of the vector
 * @method length
 * @return {Number}
 */
Vec3.prototype.length = Vec3.prototype.norm;

/**
 * Get the squared length of the vector
 * @method norm2
 * @return {Number}
 * @deprecated Use .lengthSquared() instead.
 */
Vec3.prototype.norm2 = function(){
    return this.dot(this);
};

/**
 * Get the squared length of the vector.
 * @method lengthSquared
 * @return {Number}
 */
Vec3.prototype.lengthSquared = Vec3.prototype.norm2;

/**
 * Get distance from this point to another point
 * @method distanceTo
 * @param  {Vec3} p
 * @return {Number}
 */
Vec3.prototype.distanceTo = function(p){
    var x=this.x, y=this.y, z=this.z;
    var px=p.x, py=p.y, pz=p.z;
    return Math.sqrt((px-x)*(px-x)+
                     (py-y)*(py-y)+
                     (pz-z)*(pz-z));
};

/**
 * Get squared distance from this point to another point
 * @method distanceSquared
 * @param  {Vec3} p
 * @return {Number}
 */
Vec3.prototype.distanceSquared = function(p){
    var x=this.x, y=this.y, z=this.z;
    var px=p.x, py=p.y, pz=p.z;
    return (px-x)*(px-x) + (py-y)*(py-y) + (pz-z)*(pz-z);
};

/**
 * Multiply all the components of the vector with a scalar.
 * @deprecated Use .scale instead
 * @method mult
 * @param {Number} scalar
 * @param {Vec3} target The vector to save the result in.
 * @return {Vec3}
 * @deprecated Use .scale() instead
 */
Vec3.prototype.mult = function(scalar,target){
    target = target || new Vec3();
    var x = this.x,
        y = this.y,
        z = this.z;
    target.x = scalar * x;
    target.y = scalar * y;
    target.z = scalar * z;
    return target;
};

/**
 * Multiply the vector with an other vector, component-wise.
 * @method mult
 * @param {Number} vector
 * @param {Vec3} target The vector to save the result in.
 * @return {Vec3}
 */
Vec3.prototype.vmul = function(vector, target){
    target = target || new Vec3();
    target.x = vector.x * this.x;
    target.y = vector.y * this.y;
    target.z = vector.z * this.z;
    return target;
};

/**
 * Multiply the vector with a scalar.
 * @method scale
 * @param {Number} scalar
 * @param {Vec3} target
 * @return {Vec3}
 */
Vec3.prototype.scale = Vec3.prototype.mult;

/**
 * Scale a vector and add it to this vector. Save the result in "target". (target = this + vector * scalar)
 * @method addScaledVector
 * @param {Number} scalar
 * @param {Vec3} vector
 * @param {Vec3} target The vector to save the result in.
 * @return {Vec3}
 */
Vec3.prototype.addScaledVector = function(scalar, vector, target){
    target = target || new Vec3();
    target.x = this.x + scalar * vector.x;
    target.y = this.y + scalar * vector.y;
    target.z = this.z + scalar * vector.z;
    return target;
};

/**
 * Calculate dot product
 * @method dot
 * @param {Vec3} v
 * @return {Number}
 */
Vec3.prototype.dot = function(v){
    return this.x * v.x + this.y * v.y + this.z * v.z;
};

/**
 * @method isZero
 * @return bool
 */
Vec3.prototype.isZero = function(){
    return this.x===0 && this.y===0 && this.z===0;
};

/**
 * Make the vector point in the opposite direction.
 * @method negate
 * @param {Vec3} target Optional target to save in
 * @return {Vec3}
 */
Vec3.prototype.negate = function(target){
    target = target || new Vec3();
    target.x = -this.x;
    target.y = -this.y;
    target.z = -this.z;
    return target;
};

/**
 * Compute two artificial tangents to the vector
 * @method tangents
 * @param {Vec3} t1 Vector object to save the first tangent in
 * @param {Vec3} t2 Vector object to save the second tangent in
 */
var Vec3_tangents_n = new Vec3();
var Vec3_tangents_randVec = new Vec3();
Vec3.prototype.tangents = function(t1,t2){
    var norm = this.norm();
    if(norm>0.0){
        var n = Vec3_tangents_n;
        var inorm = 1/norm;
        n.set(this.x*inorm,this.y*inorm,this.z*inorm);
        var randVec = Vec3_tangents_randVec;
        if(Math.abs(n.x) < 0.9){
            randVec.set(1,0,0);
            n.cross(randVec,t1);
        } else {
            randVec.set(0,1,0);
            n.cross(randVec,t1);
        }
        n.cross(t1,t2);
    } else {
        // The normal length is zero, make something up
        t1.set(1, 0, 0);
        t2.set(0, 1, 0);
    }
};

/**
 * Converts to a more readable format
 * @method toString
 * @return string
 */
Vec3.prototype.toString = function(){
    return this.x+","+this.y+","+this.z;
};

/**
 * Converts to an array
 * @method toArray
 * @return Array
 */
Vec3.prototype.toArray = function(){
    return [this.x, this.y, this.z];
};

/**
 * Copies value of source to this vector.
 * @method copy
 * @param {Vec3} source
 * @return {Vec3} this
 */
Vec3.prototype.copy = function(source){
    this.x = source.x;
    this.y = source.y;
    this.z = source.z;
    return this;
};


/**
 * Do a linear interpolation between two vectors
 * @method lerp
 * @param {Vec3} v
 * @param {Number} t A number between 0 and 1. 0 will make this function return u, and 1 will make it return v. Numbers in between will generate a vector in between them.
 * @param {Vec3} target
 */
Vec3.prototype.lerp = function(v,t,target){
    var x=this.x, y=this.y, z=this.z;
    target.x = x + (v.x-x)*t;
    target.y = y + (v.y-y)*t;
    target.z = z + (v.z-z)*t;
};

/**
 * Check if a vector equals is almost equal to another one.
 * @method almostEquals
 * @param {Vec3} v
 * @param {Number} precision
 * @return bool
 */
Vec3.prototype.almostEquals = function(v,precision){
    if(precision===undefined){
        precision = 1e-6;
    }
    if( Math.abs(this.x-v.x)>precision ||
        Math.abs(this.y-v.y)>precision ||
        Math.abs(this.z-v.z)>precision){
        return false;
    }
    return true;
};

/**
 * Check if a vector is almost zero
 * @method almostZero
 * @param {Number} precision
 */
Vec3.prototype.almostZero = function(precision){
    if(precision===undefined){
        precision = 1e-6;
    }
    if( Math.abs(this.x)>precision ||
        Math.abs(this.y)>precision ||
        Math.abs(this.z)>precision){
        return false;
    }
    return true;
};

var antip_neg = new Vec3();

/**
 * Check if the vector is anti-parallel to another vector.
 * @method isAntiparallelTo
 * @param  {Vec3}  v
 * @param  {Number}  precision Set to zero for exact comparisons
 * @return {Boolean}
 */
Vec3.prototype.isAntiparallelTo = function(v,precision){
    this.negate(antip_neg);
    return antip_neg.almostEquals(v,precision);
};

/**
 * Clone the vector
 * @method clone
 * @return {Vec3}
 */
Vec3.prototype.clone = function(){
    return new Vec3(this.x, this.y, this.z);
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertionError = exports.assert = undefined;

var _constants = __webpack_require__(86);

/**
 * Throws an error if the provided assertion is falsy
 * @param {*} assertion The assertion to be tested for falsiness
 * @param {!string} message The message to display if the check fails
 */
var assert = exports.assert = function assert(assertion, message) {
  if (!assertion) {
    throw assertionError(message);
  }
};
/**
 * Returns an Error object suitable for throwing.
 * @param {string} message
 * @return {!Error}
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var assertionError = exports.assertionError = function assertionError(message) {
  return new Error('Firebase Database (' + _constants.CONSTANTS.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
//# sourceMappingURL=assert.js.map


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setTimeoutNonBlocking = exports.exportPropGetter = exports.beingCrawled = exports.callUserCallback = exports.exceptionGuard = exports.tryParseInt = exports.INTEGER_REGEXP_ = exports.errorForServerCode = exports.isWindowsStoreApp = exports.isChromeExtensionContentScript = exports.doubleToIEEE754String = exports.bindCallback = exports.each = exports.splitStringBySize = exports.ObjectToUniqueKey = exports.requireKey = exports.stringCompare = exports.nameCompare = exports.MAX_NAME = exports.MIN_NAME = exports.executeWhenDOMReady = exports.isInvalidJSONNumber = exports.warnAboutUnsupportedMethod = exports.warnIfPageIsSecure = exports.warn = exports.fatal = exports.error = exports.logWrapper = exports.log = exports.enableLogging = exports.logger = exports.sha1 = exports.base64Decode = exports.base64Encode = exports.LUIDGenerator = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Copyright 2017 Google Inc.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Licensed under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                               * you may not use this file except in compliance with the License.
                                                                                                                                                                                                                                                                               * You may obtain a copy of the License at
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               *   http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Unless required by applicable law or agreed to in writing, software
                                                                                                                                                                                                                                                                               * distributed under the License is distributed on an "AS IS" BASIS,
                                                                                                                                                                                                                                                                               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                                                                                                                                                                                                               * See the License for the specific language governing permissions and
                                                                                                                                                                                                                                                                               * limitations under the License.
                                                                                                                                                                                                                                                                               */


exports.setBufferImpl = setBufferImpl;

var _assert = __webpack_require__(2);

var _obj = __webpack_require__(7);

var _crypt = __webpack_require__(436);

var _Sha = __webpack_require__(435);

var _utf = __webpack_require__(115);

var _json = __webpack_require__(23);

var _storage = __webpack_require__(80);

var _environment = __webpack_require__(50);

/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 * @type {function(): number} Generated ID.
 */
var LUIDGenerator = exports.LUIDGenerator = function () {
    var id = 1;
    return function () {
        return id++;
    };
}();
/**
 * URL-safe base64 encoding
 * @param {!string} str
 * @return {!string}
 */
var base64Encode = exports.base64Encode = function base64Encode(str) {
    var utf8Bytes = (0, _utf.stringToByteArray)(str);
    return _crypt.base64.encodeByteArray(utf8Bytes, /*useWebSafe=*/true);
};
var BufferImpl;
function setBufferImpl(impl) {
    BufferImpl = impl;
}
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param {string} str To be decoded
 * @return {?string} Decoded result, if possible
 */
var base64Decode = exports.base64Decode = function base64Decode(str) {
    try {
        if (BufferImpl) {
            return new BufferImpl(str, 'base64').toString('utf8');
        } else {
            return _crypt.base64.decodeString(str, /*useWebSafe=*/true);
        }
    } catch (e) {
        log('base64Decode failed: ', e);
    }
    return null;
};
/**
 * Sha1 hash of the input string
 * @param {!string} str The string to hash
 * @return {!string} The resulting hash
 */
var sha1 = exports.sha1 = function sha1(str) {
    var utf8Bytes = (0, _utf.stringToByteArray)(str);
    var sha1 = new _Sha.Sha1();
    sha1.update(utf8Bytes);
    var sha1Bytes = sha1.digest();
    return _crypt.base64.encodeByteArray(sha1Bytes);
};
/**
 * @param {...*} var_args
 * @return {string}
 * @private
 */
var buildLogMessage_ = function buildLogMessage_() {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = '';
    for (var i = 0; i < var_args.length; i++) {
        if (Array.isArray(var_args[i]) || var_args[i] && _typeof(var_args[i]) === 'object' && typeof var_args[i].length === 'number') {
            message += buildLogMessage_.apply(null, var_args[i]);
        } else if (_typeof(var_args[i]) === 'object') {
            message += (0, _json.stringify)(var_args[i]);
        } else {
            message += var_args[i];
        }
        message += ' ';
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 * @type {?function(string)}
 */
var logger = exports.logger = null;
/**
 * Flag to check for log availability on first log message
 * @type {boolean}
 * @private
 */
var firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param {boolean|?function(string)} logger_ A flag to turn on logging, or a custom logger
 * @param {boolean=} persistent Whether or not to persist logging settings across refreshes
 */
var enableLogging = exports.enableLogging = function enableLogging(logger_, persistent) {
    (0, _assert.assert)(!persistent || logger_ === true || logger_ === false, "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        if (typeof console !== 'undefined') {
            if (typeof console.log === 'function') {
                exports.logger = logger = console.log.bind(console);
            } else if (_typeof(console.log) === 'object') {
                // IE does this.
                exports.logger = logger = function logger(message) {
                    console.log(message);
                };
            }
        }
        if (persistent) _storage.SessionStorage.set('logging_enabled', true);
    } else if (typeof logger_ === 'function') {
        exports.logger = logger = logger_;
    } else {
        exports.logger = logger = null;
        _storage.SessionStorage.remove('logging_enabled');
    }
};
/**
 *
 * @param {...(string|Arguments)} var_args
 */
var log = exports.log = function log() {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    if (firstLog_ === true) {
        firstLog_ = false;
        if (logger === null && _storage.SessionStorage.get('logging_enabled') === true) enableLogging(true);
    }
    if (logger) {
        var message = buildLogMessage_.apply(null, var_args);
        logger(message);
    }
};
/**
 * @param {!string} prefix
 * @return {function(...[*])}
 */
var logWrapper = exports.logWrapper = function logWrapper(prefix) {
    return function () {
        var var_args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            var_args[_i] = arguments[_i];
        }
        log.apply(void 0, [prefix].concat(var_args));
    };
};
/**
 * @param {...string} var_args
 */
var error = exports.error = function error() {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    if (typeof console !== 'undefined') {
        var message = 'FIREBASE INTERNAL ERROR: ' + buildLogMessage_.apply(void 0, var_args);
        if (typeof console.error !== 'undefined') {
            console.error(message);
        } else {
            console.log(message);
        }
    }
};
/**
 * @param {...string} var_args
 */
var fatal = exports.fatal = function fatal() {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = buildLogMessage_.apply(void 0, var_args);
    throw new Error('FIREBASE FATAL ERROR: ' + message);
};
/**
 * @param {...*} var_args
 */
var warn = exports.warn = function warn() {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    if (typeof console !== 'undefined') {
        var message = 'FIREBASE WARNING: ' + buildLogMessage_.apply(void 0, var_args);
        if (typeof console.warn !== 'undefined') {
            console.warn(message);
        } else {
            console.log(message);
        }
    }
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */
var warnIfPageIsSecure = exports.warnIfPageIsSecure = function warnIfPageIsSecure() {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== 'undefined' && window.location && window.location.protocol && window.location.protocol.indexOf('https:') !== -1) {
        warn('Insecure Firebase access from a secure page. ' + 'Please use https in calls to new Firebase().');
    }
};
/**
 * @param {!String} methodName
 */
var warnAboutUnsupportedMethod = exports.warnAboutUnsupportedMethod = function warnAboutUnsupportedMethod(methodName) {
    warn(methodName + ' is unsupported and will likely change soon.  ' + 'Please do not use.');
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 * @param {*} data
 * @return {boolean}
 */
var isInvalidJSONNumber = exports.isInvalidJSONNumber = function isInvalidJSONNumber(data) {
    return typeof data === 'number' && (data != data || // NaN
    data == Number.POSITIVE_INFINITY || data == Number.NEGATIVE_INFINITY);
};
/**
 * @param {function()} fn
 */
var executeWhenDOMReady = exports.executeWhenDOMReady = function executeWhenDOMReady(fn) {
    if ((0, _environment.isNodeSdk)() || document.readyState === 'complete') {
        fn();
    } else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        var called_1 = false;
        var wrappedFn_1 = function wrappedFn_1() {
            if (!document.body) {
                setTimeout(wrappedFn_1, Math.floor(10));
                return;
            }
            if (!called_1) {
                called_1 = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', wrappedFn_1, false);
            // fallback to onload.
            window.addEventListener('load', wrappedFn_1, false);
        } else if (document.attachEvent) {
            // IE.
            document.attachEvent('onreadystatechange', function () {
                if (document.readyState === 'complete') wrappedFn_1();
            });
            // fallback to onload.
            window.attachEvent('onload', wrappedFn_1);
            // jQuery has an extra hack for IE that we could employ (based on
            // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
            // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 * @type {!string}
 */
var MIN_NAME = exports.MIN_NAME = '[MIN_NAME]';
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 * @type {!string}
 */
var MAX_NAME = exports.MAX_NAME = '[MAX_NAME]';
/**
 * Compares valid Firebase key names, plus min and max name
 * @param {!string} a
 * @param {!string} b
 * @return {!number}
 */
var nameCompare = exports.nameCompare = function nameCompare(a, b) {
    if (a === b) {
        return 0;
    } else if (a === MIN_NAME || b === MAX_NAME) {
        return -1;
    } else if (b === MIN_NAME || a === MAX_NAME) {
        return 1;
    } else {
        var aAsInt = tryParseInt(a),
            bAsInt = tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) {
                return aAsInt - bAsInt == 0 ? a.length - b.length : aAsInt - bAsInt;
            } else {
                return -1;
            }
        } else if (bAsInt !== null) {
            return 1;
        } else {
            return a < b ? -1 : 1;
        }
    }
};
/**
 * @param {!string} a
 * @param {!string} b
 * @return {!number} comparison result.
 */
var stringCompare = exports.stringCompare = function stringCompare(a, b) {
    if (a === b) {
        return 0;
    } else if (a < b) {
        return -1;
    } else {
        return 1;
    }
};
/**
 * @param {string} key
 * @param {Object} obj
 * @return {*}
 */
var requireKey = exports.requireKey = function requireKey(key, obj) {
    if (obj && key in obj) {
        return obj[key];
    } else {
        throw new Error('Missing required key (' + key + ') in object: ' + (0, _json.stringify)(obj));
    }
};
/**
 * @param {*} obj
 * @return {string}
 */
var ObjectToUniqueKey = exports.ObjectToUniqueKey = function ObjectToUniqueKey(obj) {
    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) return (0, _json.stringify)(obj);
    var keys = [];
    for (var k in obj) {
        keys.push(k);
    }
    // Export as json, but with the keys sorted.
    keys.sort();
    var key = '{';
    for (var i = 0; i < keys.length; i++) {
        if (i !== 0) key += ',';
        key += (0, _json.stringify)(keys[i]);
        key += ':';
        key += ObjectToUniqueKey(obj[keys[i]]);
    }
    key += '}';
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param {!string} str The string
 * @param {!number} segsize The maximum number of chars in the string.
 * @return {Array.<string>} The string, split into appropriately-sized chunks
 */
var splitStringBySize = exports.splitStringBySize = function splitStringBySize(str, segsize) {
    var len = str.length;
    if (len <= segsize) {
        return [str];
    }
    var dataSegs = [];
    for (var c = 0; c < len; c += segsize) {
        if (c + segsize > len) {
            dataSegs.push(str.substring(c, len));
        } else {
            dataSegs.push(str.substring(c, c + segsize));
        }
    }
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param {!(Object|Array)} obj The object or array to iterate over
 * @param {function(?, ?)} fn The function to apply
 */
var each = exports.each = function each(obj, fn) {
    if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; ++i) {
            fn(i, obj[i]);
        }
    } else {
        /**
         * in the conversion of code we removed the goog.object.forEach
         * function which did a value,key callback. We standardized on
         * a single impl that does a key, value callback. So we invert
         * to not have to touch the `each` code points
         */
        (0, _obj.forEach)(obj, function (key, val) {
            return fn(val, key);
        });
    }
};
/**
 * Like goog.bind, but doesn't bother to create a closure if opt_context is null/undefined.
 * @param {function(*)} callback Callback function.
 * @param {?Object=} context Optional context to bind to.
 * @return {function(*)}
 */
var bindCallback = exports.bindCallback = function bindCallback(callback, context) {
    return context ? callback.bind(context) : callback;
};
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param {!number} v A double
 * @return {string}
 */
var doubleToIEEE754String = exports.doubleToIEEE754String = function doubleToIEEE754String(v) {
    (0, _assert.assert)(!isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
    var ebits = 11,
        fbits = 52;
    var bias = (1 << ebits - 1) - 1,
        s,
        e,
        f,
        ln,
        i,
        bits,
        str;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    } else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        } else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    bits = [];
    for (i = fbits; i; i -= 1) {
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for (i = ebits; i; i -= 1) {
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    str = bits.join('');
    // Return the data as a hex string. --MJL
    var hexByteString = '';
    for (i = 0; i < 64; i += 8) {
        var hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1) hexByte = '0' + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 * @return {boolean}
 */
var isChromeExtensionContentScript = exports.isChromeExtensionContentScript = function isChromeExtensionContentScript() {
    return !!((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window['chrome'] && window['chrome']['extension'] && !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 * @return {boolean}
 */
var isWindowsStoreApp = exports.isWindowsStoreApp = function isWindowsStoreApp() {
    // Check for the presence of a couple WinRT globals
    return (typeof Windows === 'undefined' ? 'undefined' : _typeof(Windows)) === 'object' && _typeof(Windows.UI) === 'object';
};
/**
 * Converts a server error code to a Javascript Error
 * @param {!string} code
 * @param {!Query} query
 * @return {Error}
 */
var errorForServerCode = exports.errorForServerCode = function errorForServerCode(code, query) {
    var reason = 'Unknown Error';
    if (code === 'too_big') {
        reason = 'The data requested exceeds the maximum size ' + 'that can be accessed with a single request.';
    } else if (code == 'permission_denied') {
        reason = "Client doesn't have permission to access the desired data.";
    } else if (code == 'unavailable') {
        reason = 'The service is unavailable';
    }
    var error = new Error(code + ' at ' + query.path.toString() + ': ' + reason);
    error.code = code.toUpperCase();
    return error;
};
/**
 * Used to test for integer-looking strings
 * @type {RegExp}
 * @private
 */
var INTEGER_REGEXP_ = exports.INTEGER_REGEXP_ = new RegExp('^-?\\d{1,10}$');
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 * @param {!string} str
 * @return {?number}
 */
var tryParseInt = exports.tryParseInt = function tryParseInt(str) {
    if (INTEGER_REGEXP_.test(str)) {
        var intVal = Number(str);
        if (intVal >= -2147483648 && intVal <= 2147483647) {
            return intVal;
        }
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param {!function()} fn The code to guard.
 */
var exceptionGuard = exports.exceptionGuard = function exceptionGuard(fn) {
    try {
        fn();
    } catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(function () {
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            var stack = e.stack || '';
            warn('Exception was thrown by user callback.', stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * Helper function to safely call opt_callback with the specified arguments.  It:
 * 1. Turns into a no-op if opt_callback is null or undefined.
 * 2. Wraps the call inside exceptionGuard to prevent exceptions from breaking our state.
 *
 * @param {?Function=} callback Optional onComplete callback.
 * @param {...*} var_args Arbitrary args to be passed to opt_onComplete
 */
var callUserCallback = exports.callUserCallback = function callUserCallback(callback) {
    var var_args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        var_args[_i - 1] = arguments[_i];
    }
    if (typeof callback === 'function') {
        exceptionGuard(function () {
            callback.apply(void 0, var_args);
        });
    }
};
/**
 * @return {boolean} true if we think we're currently being crawled.
 */
var beingCrawled = exports.beingCrawled = function beingCrawled() {
    var userAgent = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window['navigator'] && window['navigator']['userAgent'] || '';
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0;
};
/**
 * Export a property of an object using a getter function.
 *
 * @param {!Object} object
 * @param {string} name
 * @param {!function(): *} fnGet
 */
var exportPropGetter = exports.exportPropGetter = function exportPropGetter(object, name, fnGet) {
    Object.defineProperty(object, name, { get: fnGet });
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param {Function} fn Function to run.
 * @param {number} time Milliseconds to wait before running.
 * @return {number|Object} The setTimeout() return value.
 */
var setTimeoutNonBlocking = exports.setTimeoutNonBlocking = function setTimeoutNonBlocking(fn, time) {
    var timeout = setTimeout(fn, time);
    if ((typeof timeout === 'undefined' ? 'undefined' : _typeof(timeout)) === 'object' && timeout['unref']) {
        timeout['unref']();
    }
    return timeout;
};
//# sourceMappingURL=util.js.map


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(18);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  (function () {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  })();
}

module.exports = warning;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(54);


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// See http://www.devthought.com/2012/01/18/an-object-is-not-a-hash/
var contains = exports.contains = function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var safeGet = exports.safeGet = function safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    // else return undefined.
};
/**
 * Enumerates the keys/values in an object, excluding keys defined on the prototype.
 *
 * @param {?Object.<K,V>} obj Object to enumerate.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
var forEach = exports.forEach = function forEach(obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn(key, obj[key]);
        }
    }
};
/**
 * Copies all the (own) properties from one object to another.
 * @param {!Object} objTo
 * @param {!Object} objFrom
 * @return {!Object} objTo
 */
var extend = exports.extend = function extend(objTo, objFrom) {
    forEach(objFrom, function (key, value) {
        objTo[key] = value;
    });
    return objTo;
};
/**
 * Returns a clone of the specified object.
 * @param {!Object} obj
 * @return {!Object} cloned obj.
 */
var clone = exports.clone = function clone(obj) {
    return extend({}, obj);
};
/**
 * Returns true if obj has typeof "object" and is not null.  Unlike goog.isObject(), does not return true
 * for functions.
 *
 * @param obj {*} A potential object.
 * @returns {boolean} True if it's an object.
 */
var isNonNullObject = exports.isNonNullObject = function isNonNullObject(obj) {
    return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj !== null;
};
var isEmpty = exports.isEmpty = function isEmpty(obj) {
    for (var key in obj) {
        return false;
    }
    return true;
};
var getCount = exports.getCount = function getCount(obj) {
    var rv = 0;
    for (var key in obj) {
        rv++;
    }
    return rv;
};
var map = exports.map = function map(obj, f, opt_obj) {
    var res = {};
    for (var key in obj) {
        res[key] = f.call(opt_obj, obj[key], key, obj);
    }
    return res;
};
var findKey = exports.findKey = function findKey(obj, fn, opt_this) {
    for (var key in obj) {
        if (fn.call(opt_this, obj[key], key, obj)) {
            return key;
        }
    }
    return undefined;
};
var findValue = exports.findValue = function findValue(obj, fn, opt_this) {
    var key = findKey(obj, fn, opt_this);
    return key && obj[key];
};
var getAnyKey = exports.getAnyKey = function getAnyKey(obj) {
    for (var key in obj) {
        return key;
    }
};
var getValues = exports.getValues = function getValues(obj) {
    var res = [];
    var i = 0;
    for (var key in obj) {
        res[i++] = obj[key];
    }
    return res;
};
/**
 * Tests whether every key/value pair in an object pass the test implemented
 * by the provided function
 *
 * @param {?Object.<K,V>} obj Object to test.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
var every = exports.every = function every(obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (!fn(key, obj[key])) {
                return false;
            }
        }
    }
    return true;
};
//# sourceMappingURL=obj.js.map


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ValidationPath = exports.Path = undefined;

var _util = __webpack_require__(3);

var _utf = __webpack_require__(115);

/**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Path = /** @class */function () {
    /**
     * @param {string|Array.<string>} pathOrString Path string to parse,
     *      or another path, or the raw tokens array
     * @param {number=} pieceNum
     */
    function Path(pathOrString, pieceNum) {
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split('/');
            // Remove empty pieces.
            var copyTo = 0;
            for (var i = 0; i < this.pieces_.length; i++) {
                if (this.pieces_[i].length > 0) {
                    this.pieces_[copyTo] = this.pieces_[i];
                    copyTo++;
                }
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        } else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    Object.defineProperty(Path, "Empty", {
        /**
         * Singleton to represent an empty path
         *
         * @const
         */
        get: function get() {
            return new Path('');
        },
        enumerable: true,
        configurable: true
    });
    Path.prototype.getFront = function () {
        if (this.pieceNum_ >= this.pieces_.length) return null;
        return this.pieces_[this.pieceNum_];
    };
    /**
     * @return {number} The number of segments in this path
     */
    Path.prototype.getLength = function () {
        return this.pieces_.length - this.pieceNum_;
    };
    /**
     * @return {!Path}
     */
    Path.prototype.popFront = function () {
        var pieceNum = this.pieceNum_;
        if (pieceNum < this.pieces_.length) {
            pieceNum++;
        }
        return new Path(this.pieces_, pieceNum);
    };
    /**
     * @return {?string}
     */
    Path.prototype.getBack = function () {
        if (this.pieceNum_ < this.pieces_.length) return this.pieces_[this.pieces_.length - 1];
        return null;
    };
    Path.prototype.toString = function () {
        var pathString = '';
        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
            if (this.pieces_[i] !== '') pathString += '/' + this.pieces_[i];
        }
        return pathString || '/';
    };
    Path.prototype.toUrlEncodedString = function () {
        var pathString = '';
        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
            if (this.pieces_[i] !== '') pathString += '/' + encodeURIComponent(String(this.pieces_[i]));
        }
        return pathString || '/';
    };
    /**
     * Shallow copy of the parts of the path.
     *
     * @param {number=} begin
     * @return {!Array<string>}
     */
    Path.prototype.slice = function (begin) {
        if (begin === void 0) {
            begin = 0;
        }
        return this.pieces_.slice(this.pieceNum_ + begin);
    };
    /**
     * @return {?Path}
     */
    Path.prototype.parent = function () {
        if (this.pieceNum_ >= this.pieces_.length) return null;
        var pieces = [];
        for (var i = this.pieceNum_; i < this.pieces_.length - 1; i++) {
            pieces.push(this.pieces_[i]);
        }return new Path(pieces, 0);
    };
    /**
     * @param {string|!Path} childPathObj
     * @return {!Path}
     */
    Path.prototype.child = function (childPathObj) {
        var pieces = [];
        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
            pieces.push(this.pieces_[i]);
        }if (childPathObj instanceof Path) {
            for (var i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++) {
                pieces.push(childPathObj.pieces_[i]);
            }
        } else {
            var childPieces = childPathObj.split('/');
            for (var i = 0; i < childPieces.length; i++) {
                if (childPieces[i].length > 0) pieces.push(childPieces[i]);
            }
        }
        return new Path(pieces, 0);
    };
    /**
     * @return {boolean} True if there are no segments in this path
     */
    Path.prototype.isEmpty = function () {
        return this.pieceNum_ >= this.pieces_.length;
    };
    /**
     * @param {!Path} outerPath
     * @param {!Path} innerPath
     * @return {!Path} The path from outerPath to innerPath
     */
    Path.relativePath = function (outerPath, innerPath) {
        var outer = outerPath.getFront(),
            inner = innerPath.getFront();
        if (outer === null) {
            return innerPath;
        } else if (outer === inner) {
            return Path.relativePath(outerPath.popFront(), innerPath.popFront());
        } else {
            throw new Error('INTERNAL ERROR: innerPath (' + innerPath + ') is not within ' + 'outerPath (' + outerPath + ')');
        }
    };
    /**
     * @param {!Path} left
     * @param {!Path} right
     * @return {number} -1, 0, 1 if left is less, equal, or greater than the right.
     */
    Path.comparePaths = function (left, right) {
        var leftKeys = left.slice();
        var rightKeys = right.slice();
        for (var i = 0; i < leftKeys.length && i < rightKeys.length; i++) {
            var cmp = (0, _util.nameCompare)(leftKeys[i], rightKeys[i]);
            if (cmp !== 0) return cmp;
        }
        if (leftKeys.length === rightKeys.length) return 0;
        return leftKeys.length < rightKeys.length ? -1 : 1;
    };
    /**
     *
     * @param {Path} other
     * @return {boolean} true if paths are the same.
     */
    Path.prototype.equals = function (other) {
        if (this.getLength() !== other.getLength()) {
            return false;
        }
        for (var i = this.pieceNum_, j = other.pieceNum_; i <= this.pieces_.length; i++, j++) {
            if (this.pieces_[i] !== other.pieces_[j]) {
                return false;
            }
        }
        return true;
    };
    /**
     *
     * @param {!Path} other
     * @return {boolean} True if this path is a parent (or the same as) other
     */
    Path.prototype.contains = function (other) {
        var i = this.pieceNum_;
        var j = other.pieceNum_;
        if (this.getLength() > other.getLength()) {
            return false;
        }
        while (i < this.pieces_.length) {
            if (this.pieces_[i] !== other.pieces_[j]) {
                return false;
            }
            ++i;
            ++j;
        }
        return true;
    };
    return Path;
}(); // end Path
exports.Path = Path;
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */

var ValidationPath = /** @class */function () {
    /**
     * @param {!Path} path Initial Path.
     * @param {string} errorPrefix_ Prefix for any error messages.
     */
    function ValidationPath(path, errorPrefix_) {
        this.errorPrefix_ = errorPrefix_;
        /** @type {!Array<string>} */
        this.parts_ = path.slice();
        /** @type {number} Initialize to number of '/' chars needed in path. */
        this.byteLength_ = Math.max(1, this.parts_.length);
        for (var i = 0; i < this.parts_.length; i++) {
            this.byteLength_ += (0, _utf.stringLength)(this.parts_[i]);
        }
        this.checkValid_();
    }
    Object.defineProperty(ValidationPath, "MAX_PATH_DEPTH", {
        /** @const {number} Maximum key depth. */
        get: function get() {
            return 32;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ValidationPath, "MAX_PATH_LENGTH_BYTES", {
        /** @const {number} Maximum number of (UTF8) bytes in a Firebase path. */
        get: function get() {
            return 768;
        },
        enumerable: true,
        configurable: true
    });
    /** @param {string} child */
    ValidationPath.prototype.push = function (child) {
        // Count the needed '/'
        if (this.parts_.length > 0) {
            this.byteLength_ += 1;
        }
        this.parts_.push(child);
        this.byteLength_ += (0, _utf.stringLength)(child);
        this.checkValid_();
    };
    ValidationPath.prototype.pop = function () {
        var last = this.parts_.pop();
        this.byteLength_ -= (0, _utf.stringLength)(last);
        // Un-count the previous '/'
        if (this.parts_.length > 0) {
            this.byteLength_ -= 1;
        }
    };
    ValidationPath.prototype.checkValid_ = function () {
        if (this.byteLength_ > ValidationPath.MAX_PATH_LENGTH_BYTES) {
            throw new Error(this.errorPrefix_ + 'has a key path longer than ' + ValidationPath.MAX_PATH_LENGTH_BYTES + ' bytes (' + this.byteLength_ + ').');
        }
        if (this.parts_.length > ValidationPath.MAX_PATH_DEPTH) {
            throw new Error(this.errorPrefix_ + 'path specified exceeds the maximum depth that can be written (' + ValidationPath.MAX_PATH_DEPTH + ') or object contains a cycle ' + this.toErrorString());
        }
    };
    /**
     * String for use in error messages - uses '.' notation for path.
     *
     * @return {string}
     */
    ValidationPath.prototype.toErrorString = function () {
        if (this.parts_.length == 0) {
            return '';
        }
        return "in property '" + this.parts_.join('.') + "'";
    };
    return ValidationPath;
}();
exports.ValidationPath = ValidationPath;
//# sourceMappingURL=Path.js.map


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var DOMProperty = __webpack_require__(52);
var ReactDOMComponentFlags = __webpack_require__(203);

var invariant = __webpack_require__(1);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scene = exports.Entity = exports.options = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(6);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var nonEntityPropNames = ['children', 'events', 'primitive'];
var filterNonEntityPropNames = function filterNonEntityPropNames(propName) {
  return nonEntityPropNames.indexOf(propName) === -1;
};

var options = {
  // React needs this because React serializes.
  // Preact does not because Preact runs `.setAttribute` on its own.
  runSetAttributeOnUpdates: true
};
exports.options = options;

/**
 * Call `.setAttribute()` on the `ref`, passing prop data directly to A-Frame.
 */

function doSetAttribute(el, props, propName) {
  if (propName === 'className') {
    el.setAttribute('class', props.className);
  } else if (props[propName] && props[propName].constructor === Function) {
    return;
  } else {
    el.setAttribute(propName, props[propName]);
  }
}

/**
 * Handle diffing of previous and current attributes.
 *
 * @param {Element} el
 * @param {Object|null} prevProps - Previous props map.
 * @param {Object} props - Current props map.
 */
function updateAttributes(el, prevProps, props) {
  if (!props || prevProps === props) {
    return;
  }

  // Set attributes.
  Object.keys(props).filter(filterNonEntityPropNames).forEach(function (propName) {
    doSetAttribute(el, props, propName);
  });

  // See if attributes were removed.
  if (prevProps) {
    Object.keys(prevProps).filter(filterNonEntityPropNames).forEach(function (propName) {
      if (props[propName] === undefined) {
        el.removeAttribute(propName);
      }
    });
  }
}

/**
 * Render <a-entity>.
 * Tell React to use A-Frame's .setAttribute() on the DOM element for all prop initializations
 * and updates.
 */

var Entity = exports.Entity = function (_React$Component) {
  _inherits(Entity, _React$Component);

  function Entity() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Entity);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Entity.__proto__ || Object.getPrototypeOf(Entity)).call.apply(_ref, [this].concat(args))), _this), _this.initEntity = function (el) {
      var props = _this.props;
      if (!el) {
        return;
      }

      // Store.
      _this.el = el;

      // Attach events.
      if (props.events) {
        Object.keys(props.events).forEach(function (eventName) {
          addEventListeners(el, eventName, props.events[eventName]);
        });
      }

      // Update entity.
      updateAttributes(el, null, props);

      // Allow ref.
      if (props._ref) {
        props._ref(el);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  /**
   * In response to initial `ref` callback.
   */


  _createClass(Entity, [{
    key: 'componentDidUpdate',


    /**
     * Handle updates after the initial render.
     */
    value: function componentDidUpdate(prevProps, prevState) {
      var el = this.el;
      var props = this.props;

      // Update events.
      updateEventListeners(el, prevProps.events, props.events);

      // Update entity.
      if (options.runSetAttributeOnUpdates) {
        updateAttributes(el, prevProps, props);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var el = this.el;
      var props = this.props;

      if (props.events) {
        // Remove events.
        Object.keys(props.events).forEach(function (eventName) {
          removeEventListeners(el, eventName, props.events[eventName]);
        });
      }
    }

    /**
     * Render A-Frame DOM with ref: https://facebook.github.io/react/docs/refs-and-the-dom.html
     */

  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var elementName = this.isScene ? 'a-scene' : props.primitive || 'a-entity';

      // Let through props that are OK to render initially.
      var reactProps = {};
      Object.keys(props).forEach(function (propName) {
        if (['className', 'id', 'mixin'].indexOf(propName) !== -1 || propName.indexOf('data-') === 0) {
          reactProps[propName] = props[propName];
        }
      });

      return _react2.default.createElement(elementName, _extends({ ref: this.initEntity }, reactProps), props.children);
    }
  }]);

  return Entity;
}(_react2.default.Component);

/**
 * Render <a-scene>.
 * <a-scene> extends from <a-entity> in A-Frame so we reuse <Entity/>.
 */


var Scene = exports.Scene = function (_Entity) {
  _inherits(Scene, _Entity);

  function Scene(props) {
    _classCallCheck(this, Scene);

    var _this2 = _possibleConstructorReturn(this, (Scene.__proto__ || Object.getPrototypeOf(Scene)).call(this, props));

    _this2.isScene = true;
    return _this2;
  }

  return Scene;
}(Entity);

/**
 * Handle diffing of previous and current event maps.
 *
 * @param {Element} el
 * @param {Object} prevEvents - Previous event map.
 * @param {Object} events - Current event map.
 */


function updateEventListeners(el, prevEvents, events) {
  if (!prevEvents || !events || prevEvents === events) {
    return;
  }

  Object.keys(events).forEach(function (eventName) {
    // Didn't change.
    if (prevEvents[eventName] === events[eventName]) {
      return;
    }

    // If changed, remove old previous event listeners.
    if (prevEvents[eventName]) {
      removeEventListeners(el, eventName, prevEvents[eventName]);
    }

    // Add new event listeners.
    addEventListeners(el, eventName, events[eventName]);
  });

  // See if event handlers were removed.
  Object.keys(prevEvents).forEach(function (eventName) {
    if (!events[eventName]) {
      removeEventListeners(el, eventName, prevEvents[eventName]);
    }
  });
}

/**
 * Register event handlers for an event name to ref.
 *
 * @param {Element} el - DOM element.
 * @param {string} eventName
 * @param {array|function} eventHandlers - Handler function or array of handler functions.
 */
function addEventListeners(el, eventName, handlers) {
  if (!handlers) {
    return;
  }

  // Convert to array.
  if (handlers.constructor === Function) {
    handlers = [handlers];
  }

  // Register.
  handlers.forEach(function (handler) {
    el.addEventListener(eventName, handler);
  });
}

/**
 * Unregister event handlers for an event name to ref.
 *
 * @param {Element} el - DOM element.
 * @param {string} eventName
 * @param {array|function} eventHandlers - Handler function or array of handler functions.
 */
function removeEventListeners(el, eventName, handlers) {
  if (!handlers) {
    return;
  }

  // Convert to array.
  if (handlers.constructor === Function) {
    handlers = [handlers];
  }

  // Unregister.
  handlers.forEach(function (handler) {
    el.removeEventListener(eventName, handler);
  });
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Shape;

var Shape = __webpack_require__(12);
var Vec3 = __webpack_require__(0);
var Quaternion = __webpack_require__(13);
var Material = __webpack_require__(59);

/**
 * Base class for shapes
 * @class Shape
 * @constructor
 * @author schteppe
 * @todo Should have a mechanism for caching bounding sphere radius instead of calculating it each time
 */
function Shape(){

    /**
     * Identifyer of the Shape.
     * @property {number} id
     */
    this.id = Shape.idCounter++;

    /**
     * The type of this shape. Must be set to an int > 0 by subclasses.
     * @property type
     * @type {Number}
     * @see Shape.types
     */
    this.type = 0;

    /**
     * The local bounding sphere radius of this shape.
     * @property {Number} boundingSphereRadius
     */
    this.boundingSphereRadius = 0;

    /**
     * Whether to produce contact forces when in contact with other bodies. Note that contacts will be generated, but they will be disabled.
     * @property {boolean} collisionResponse
     */
    this.collisionResponse = true;

    /**
     * @property {Material} material
     */
    this.material = null;

    /**
     * @property {Body} body
     */
    this.body = null;
}
Shape.prototype.constructor = Shape;

/**
 * Computes the bounding sphere radius. The result is stored in the property .boundingSphereRadius
 * @method updateBoundingSphereRadius
 */
Shape.prototype.updateBoundingSphereRadius = function(){
    throw "computeBoundingSphereRadius() not implemented for shape type "+this.type;
};

/**
 * Get the volume of this shape
 * @method volume
 * @return {Number}
 */
Shape.prototype.volume = function(){
    throw "volume() not implemented for shape type "+this.type;
};

/**
 * Calculates the inertia in the local frame for this shape.
 * @method calculateLocalInertia
 * @param {Number} mass
 * @param {Vec3} target
 * @see http://en.wikipedia.org/wiki/List_of_moments_of_inertia
 */
Shape.prototype.calculateLocalInertia = function(mass,target){
    throw "calculateLocalInertia() not implemented for shape type "+this.type;
};

Shape.idCounter = 0;

/**
 * The available shape types.
 * @static
 * @property types
 * @type {Object}
 */
Shape.types = {
    SPHERE:1,
    PLANE:2,
    BOX:4,
    COMPOUND:8,
    CONVEXPOLYHEDRON:16,
    HEIGHTFIELD:32,
    PARTICLE:64,
    CYLINDER:128,
    TRIMESH:256
};



/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Quaternion;

var Vec3 = __webpack_require__(0);

/**
 * A Quaternion describes a rotation in 3D space. The Quaternion is mathematically defined as Q = x*i + y*j + z*k + w, where (i,j,k) are imaginary basis vectors. (x,y,z) can be seen as a vector related to the axis of rotation, while the real multiplier, w, is related to the amount of rotation.
 * @class Quaternion
 * @constructor
 * @param {Number} x Multiplier of the imaginary basis vector i.
 * @param {Number} y Multiplier of the imaginary basis vector j.
 * @param {Number} z Multiplier of the imaginary basis vector k.
 * @param {Number} w Multiplier of the real part.
 * @see http://en.wikipedia.org/wiki/Quaternion
 */
function Quaternion(x,y,z,w){
    /**
     * @property {Number} x
     */
    this.x = x!==undefined ? x : 0;

    /**
     * @property {Number} y
     */
    this.y = y!==undefined ? y : 0;

    /**
     * @property {Number} z
     */
    this.z = z!==undefined ? z : 0;

    /**
     * The multiplier of the real quaternion basis vector.
     * @property {Number} w
     */
    this.w = w!==undefined ? w : 1;
}

/**
 * Set the value of the quaternion.
 * @method set
 * @param {Number} x
 * @param {Number} y
 * @param {Number} z
 * @param {Number} w
 */
Quaternion.prototype.set = function(x,y,z,w){
    this.x = x;
    this.y = y;
    this.z = z;
    this.w = w;
    return this;
};

/**
 * Convert to a readable format
 * @method toString
 * @return string
 */
Quaternion.prototype.toString = function(){
    return this.x+","+this.y+","+this.z+","+this.w;
};

/**
 * Convert to an Array
 * @method toArray
 * @return Array
 */
Quaternion.prototype.toArray = function(){
    return [this.x, this.y, this.z, this.w];
};

/**
 * Set the quaternion components given an axis and an angle.
 * @method setFromAxisAngle
 * @param {Vec3} axis
 * @param {Number} angle in radians
 */
Quaternion.prototype.setFromAxisAngle = function(axis,angle){
    var s = Math.sin(angle*0.5);
    this.x = axis.x * s;
    this.y = axis.y * s;
    this.z = axis.z * s;
    this.w = Math.cos(angle*0.5);
    return this;
};

/**
 * Converts the quaternion to axis/angle representation.
 * @method toAxisAngle
 * @param {Vec3} [targetAxis] A vector object to reuse for storing the axis.
 * @return {Array} An array, first elemnt is the axis and the second is the angle in radians.
 */
Quaternion.prototype.toAxisAngle = function(targetAxis){
    targetAxis = targetAxis || new Vec3();
    this.normalize(); // if w>1 acos and sqrt will produce errors, this cant happen if quaternion is normalised
    var angle = 2 * Math.acos(this.w);
    var s = Math.sqrt(1-this.w*this.w); // assuming quaternion normalised then w is less than 1, so term always positive.
    if (s < 0.001) { // test to avoid divide by zero, s is always positive due to sqrt
        // if s close to zero then direction of axis not important
        targetAxis.x = this.x; // if it is important that axis is normalised then replace with x=1; y=z=0;
        targetAxis.y = this.y;
        targetAxis.z = this.z;
    } else {
        targetAxis.x = this.x / s; // normalise axis
        targetAxis.y = this.y / s;
        targetAxis.z = this.z / s;
    }
    return [targetAxis,angle];
};

var sfv_t1 = new Vec3(),
    sfv_t2 = new Vec3();

/**
 * Set the quaternion value given two vectors. The resulting rotation will be the needed rotation to rotate u to v.
 * @method setFromVectors
 * @param {Vec3} u
 * @param {Vec3} v
 */
Quaternion.prototype.setFromVectors = function(u,v){
    if(u.isAntiparallelTo(v)){
        var t1 = sfv_t1;
        var t2 = sfv_t2;

        u.tangents(t1,t2);
        this.setFromAxisAngle(t1,Math.PI);
    } else {
        var a = u.cross(v);
        this.x = a.x;
        this.y = a.y;
        this.z = a.z;
        this.w = Math.sqrt(Math.pow(u.norm(),2) * Math.pow(v.norm(),2)) + u.dot(v);
        this.normalize();
    }
    return this;
};

/**
 * Quaternion multiplication
 * @method mult
 * @param {Quaternion} q
 * @param {Quaternion} target Optional.
 * @return {Quaternion}
 */
var Quaternion_mult_va = new Vec3();
var Quaternion_mult_vb = new Vec3();
var Quaternion_mult_vaxvb = new Vec3();
Quaternion.prototype.mult = function(q,target){
    target = target || new Quaternion();

    var ax = this.x, ay = this.y, az = this.z, aw = this.w,
        bx = q.x, by = q.y, bz = q.z, bw = q.w;

    target.x = ax * bw + aw * bx + ay * bz - az * by;
    target.y = ay * bw + aw * by + az * bx - ax * bz;
    target.z = az * bw + aw * bz + ax * by - ay * bx;
    target.w = aw * bw - ax * bx - ay * by - az * bz;

    return target;
};

/**
 * Get the inverse quaternion rotation.
 * @method inverse
 * @param {Quaternion} target
 * @return {Quaternion}
 */
Quaternion.prototype.inverse = function(target){
    var x = this.x, y = this.y, z = this.z, w = this.w;
    target = target || new Quaternion();

    this.conjugate(target);
    var inorm2 = 1/(x*x + y*y + z*z + w*w);
    target.x *= inorm2;
    target.y *= inorm2;
    target.z *= inorm2;
    target.w *= inorm2;

    return target;
};

/**
 * Get the quaternion conjugate
 * @method conjugate
 * @param {Quaternion} target
 * @return {Quaternion}
 */
Quaternion.prototype.conjugate = function(target){
    target = target || new Quaternion();

    target.x = -this.x;
    target.y = -this.y;
    target.z = -this.z;
    target.w = this.w;

    return target;
};

/**
 * Normalize the quaternion. Note that this changes the values of the quaternion.
 * @method normalize
 */
Quaternion.prototype.normalize = function(){
    var l = Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w);
    if ( l === 0 ) {
        this.x = 0;
        this.y = 0;
        this.z = 0;
        this.w = 0;
    } else {
        l = 1 / l;
        this.x *= l;
        this.y *= l;
        this.z *= l;
        this.w *= l;
    }
    return this;
};

/**
 * Approximation of quaternion normalization. Works best when quat is already almost-normalized.
 * @method normalizeFast
 * @see http://jsperf.com/fast-quaternion-normalization
 * @author unphased, https://github.com/unphased
 */
Quaternion.prototype.normalizeFast = function () {
    var f = (3.0-(this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w))/2.0;
    if ( f === 0 ) {
        this.x = 0;
        this.y = 0;
        this.z = 0;
        this.w = 0;
    } else {
        this.x *= f;
        this.y *= f;
        this.z *= f;
        this.w *= f;
    }
    return this;
};

/**
 * Multiply the quaternion by a vector
 * @method vmult
 * @param {Vec3} v
 * @param {Vec3} target Optional
 * @return {Vec3}
 */
Quaternion.prototype.vmult = function(v,target){
    target = target || new Vec3();

    var x = v.x,
        y = v.y,
        z = v.z;

    var qx = this.x,
        qy = this.y,
        qz = this.z,
        qw = this.w;

    // q*v
    var ix =  qw * x + qy * z - qz * y,
    iy =  qw * y + qz * x - qx * z,
    iz =  qw * z + qx * y - qy * x,
    iw = -qx * x - qy * y - qz * z;

    target.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    target.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    target.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;

    return target;
};

/**
 * Copies value of source to this quaternion.
 * @method copy
 * @param {Quaternion} source
 * @return {Quaternion} this
 */
Quaternion.prototype.copy = function(source){
    this.x = source.x;
    this.y = source.y;
    this.z = source.z;
    this.w = source.w;
    return this;
};

/**
 * Convert the quaternion to euler angle representation. Order: YZX, as this page describes: http://www.euclideanspace.com/maths/standards/index.htm
 * @method toEuler
 * @param {Vec3} target
 * @param string order Three-character string e.g. "YZX", which also is default.
 */
Quaternion.prototype.toEuler = function(target,order){
    order = order || "YZX";

    var heading, attitude, bank;
    var x = this.x, y = this.y, z = this.z, w = this.w;

    switch(order){
    case "YZX":
        var test = x*y + z*w;
        if (test > 0.499) { // singularity at north pole
            heading = 2 * Math.atan2(x,w);
            attitude = Math.PI/2;
            bank = 0;
        }
        if (test < -0.499) { // singularity at south pole
            heading = -2 * Math.atan2(x,w);
            attitude = - Math.PI/2;
            bank = 0;
        }
        if(isNaN(heading)){
            var sqx = x*x;
            var sqy = y*y;
            var sqz = z*z;
            heading = Math.atan2(2*y*w - 2*x*z , 1 - 2*sqy - 2*sqz); // Heading
            attitude = Math.asin(2*test); // attitude
            bank = Math.atan2(2*x*w - 2*y*z , 1 - 2*sqx - 2*sqz); // bank
        }
        break;
    default:
        throw new Error("Euler order "+order+" not supported yet.");
    }

    target.y = heading;
    target.z = attitude;
    target.x = bank;
};

/**
 * See http://www.mathworks.com/matlabcentral/fileexchange/20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/content/SpinCalc.m
 * @method setFromEuler
 * @param {Number} x
 * @param {Number} y
 * @param {Number} z
 * @param {String} order The order to apply angles: 'XYZ' or 'YXZ' or any other combination
 */
Quaternion.prototype.setFromEuler = function ( x, y, z, order ) {
    order = order || "XYZ";

    var c1 = Math.cos( x / 2 );
    var c2 = Math.cos( y / 2 );
    var c3 = Math.cos( z / 2 );
    var s1 = Math.sin( x / 2 );
    var s2 = Math.sin( y / 2 );
    var s3 = Math.sin( z / 2 );

    if ( order === 'XYZ' ) {

        this.x = s1 * c2 * c3 + c1 * s2 * s3;
        this.y = c1 * s2 * c3 - s1 * c2 * s3;
        this.z = c1 * c2 * s3 + s1 * s2 * c3;
        this.w = c1 * c2 * c3 - s1 * s2 * s3;

    } else if ( order === 'YXZ' ) {

        this.x = s1 * c2 * c3 + c1 * s2 * s3;
        this.y = c1 * s2 * c3 - s1 * c2 * s3;
        this.z = c1 * c2 * s3 - s1 * s2 * c3;
        this.w = c1 * c2 * c3 + s1 * s2 * s3;

    } else if ( order === 'ZXY' ) {

        this.x = s1 * c2 * c3 - c1 * s2 * s3;
        this.y = c1 * s2 * c3 + s1 * c2 * s3;
        this.z = c1 * c2 * s3 + s1 * s2 * c3;
        this.w = c1 * c2 * c3 - s1 * s2 * s3;

    } else if ( order === 'ZYX' ) {

        this.x = s1 * c2 * c3 - c1 * s2 * s3;
        this.y = c1 * s2 * c3 + s1 * c2 * s3;
        this.z = c1 * c2 * s3 - s1 * s2 * c3;
        this.w = c1 * c2 * c3 + s1 * s2 * s3;

    } else if ( order === 'YZX' ) {

        this.x = s1 * c2 * c3 + c1 * s2 * s3;
        this.y = c1 * s2 * c3 + s1 * c2 * s3;
        this.z = c1 * c2 * s3 - s1 * s2 * c3;
        this.w = c1 * c2 * c3 - s1 * s2 * s3;

    } else if ( order === 'XZY' ) {

        this.x = s1 * c2 * c3 - c1 * s2 * s3;
        this.y = c1 * s2 * c3 - s1 * c2 * s3;
        this.z = c1 * c2 * s3 + s1 * s2 * c3;
        this.w = c1 * c2 * c3 + s1 * s2 * s3;

    }

    return this;
};

/**
 * @method clone
 * @return {Quaternion}
 */
Quaternion.prototype.clone = function(){
    return new Quaternion(this.x, this.y, this.z, this.w);
};

/**
 * Performs a spherical linear interpolation between two quat
 *
 * @method slerp
 * @param {Quaternion} toQuat second operand
 * @param {Number} t interpolation amount between the self quaternion and toQuat
 * @param {Quaternion} [target] A quaternion to store the result in. If not provided, a new one will be created.
 * @returns {Quaternion} The "target" object
 */
Quaternion.prototype.slerp = function (toQuat, t, target) {
    target = target || new Quaternion();

    var ax = this.x,
        ay = this.y,
        az = this.z,
        aw = this.w,
        bx = toQuat.x,
        by = toQuat.y,
        bz = toQuat.z,
        bw = toQuat.w;

    var omega, cosom, sinom, scale0, scale1;

    // calc cosine
    cosom = ax * bx + ay * by + az * bz + aw * bw;

    // adjust signs (if necessary)
    if ( cosom < 0.0 ) {
        cosom = -cosom;
        bx = - bx;
        by = - by;
        bz = - bz;
        bw = - bw;
    }

    // calculate coefficients
    if ( (1.0 - cosom) > 0.000001 ) {
        // standard case (slerp)
        omega  = Math.acos(cosom);
        sinom  = Math.sin(omega);
        scale0 = Math.sin((1.0 - t) * omega) / sinom;
        scale1 = Math.sin(t * omega) / sinom;
    } else {
        // "from" and "to" quaternions are very close
        //  ... so we can do a linear interpolation
        scale0 = 1.0 - t;
        scale1 = t;
    }

    // calculate final values
    target.x = scale0 * ax + scale1 * bx;
    target.y = scale0 * ay + scale1 * by;
    target.z = scale0 * az + scale1 * bz;
    target.w = scale0 * aw + scale1 * bw;

    return target;
};

/**
 * Rotate an absolute orientation quaternion given an angular velocity and a time step.
 * @param  {Vec3} angularVelocity
 * @param  {number} dt
 * @param  {Vec3} angularFactor
 * @param  {Quaternion} target
 * @return {Quaternion} The "target" object
 */
Quaternion.prototype.integrate = function(angularVelocity, dt, angularFactor, target){
    target = target || new Quaternion();

    var ax = angularVelocity.x * angularFactor.x,
        ay = angularVelocity.y * angularFactor.y,
        az = angularVelocity.z * angularFactor.z,
        bx = this.x,
        by = this.y,
        bz = this.z,
        bw = this.w;

    var half_dt = dt * 0.5;

    target.x += half_dt * (ax * bw + ay * bz - az * by);
    target.y += half_dt * (ay * bw + az * bx - ax * bz);
    target.z += half_dt * (az * bw + ax * by - ay * bx);
    target.w += half_dt * (- ax * bx - ay * by - az * bz);

    return target;
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PRIORITY_INDEX = exports.PriorityIndex = undefined;
exports.setNodeFromJSON = setNodeFromJSON;
exports.setMaxNode = setMaxNode;

var _Index = __webpack_require__(79);

var _util = __webpack_require__(3);

var _Node = __webpack_require__(19);

var _LeafNode = __webpack_require__(78);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();

var nodeFromJSON;
var MAX_NODE;
function setNodeFromJSON(val) {
    nodeFromJSON = val;
}
function setMaxNode(val) {
    MAX_NODE = val;
}
/**
 * @constructor
 * @extends {Index}
 * @private
 */
var PriorityIndex = /** @class */function (_super) {
    __extends(PriorityIndex, _super);
    function PriorityIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.compare = function (a, b) {
        var aPriority = a.node.getPriority();
        var bPriority = b.node.getPriority();
        var indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) {
            return (0, _util.nameCompare)(a.name, b.name);
        } else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.isDefinedOn = function (node) {
        return !node.getPriority().isEmpty();
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.minPost = function () {
        return _Node.NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.maxPost = function () {
        return new _Node.NamedNode(_util.MAX_NAME, new _LeafNode.LeafNode('[PRIORITY-POST]', MAX_NODE));
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    PriorityIndex.prototype.makePost = function (indexValue, name) {
        var priorityNode = nodeFromJSON(indexValue);
        return new _Node.NamedNode(name, new _LeafNode.LeafNode('[PRIORITY-POST]', priorityNode));
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    PriorityIndex.prototype.toString = function () {
        return '.priority';
    };
    return PriorityIndex;
}(_Index.Index);
exports.PriorityIndex = PriorityIndex;
var PRIORITY_INDEX = exports.PRIORITY_INDEX = new PriorityIndex();
//# sourceMappingURL=PriorityIndex.js.map


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_NODE = exports.MaxNode = exports.ChildrenNode = undefined;

var _assert = __webpack_require__(2);

var _util = __webpack_require__(3);

var _SortedMap = __webpack_require__(108);

var _Node = __webpack_require__(19);

var _snap = __webpack_require__(172);

var _PriorityIndex = __webpack_require__(15);

var _KeyIndex = __webpack_require__(61);

var _IndexMap = __webpack_require__(167);

var _LeafNode = __webpack_require__(78);

var _comparators = __webpack_require__(169);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();

// TODO: For memory savings, don't store priorityNode_ if it's empty.
var EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 *
 * @constructor
 * @implements {Node}
 */
var ChildrenNode = /** @class */function () {
    /**
     *
     * @param {!SortedMap.<string, !Node>} children_ List of children
     * of this node..
     * @param {?Node} priorityNode_ The priority of this node (as a snapshot node).
     * @param {!IndexMap} indexMap_
     */
    function ChildrenNode(children_, priorityNode_, indexMap_) {
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */
        if (this.priorityNode_) {
            (0, _snap.validatePriorityNode)(this.priorityNode_);
        }
        if (this.children_.isEmpty()) {
            (0, _assert.assert)(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
        }
    }
    Object.defineProperty(ChildrenNode, "EMPTY_NODE", {
        get: function get() {
            return EMPTY_NODE || (EMPTY_NODE = new ChildrenNode(new _SortedMap.SortedMap(_comparators.NAME_COMPARATOR), null, _IndexMap.IndexMap.Default));
        },
        enumerable: true,
        configurable: true
    });
    /** @inheritDoc */
    ChildrenNode.prototype.isLeafNode = function () {
        return false;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getPriority = function () {
        return this.priorityNode_ || EMPTY_NODE;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updatePriority = function (newPriorityNode) {
        if (this.children_.isEmpty()) {
            // Don't allow priorities on empty nodes
            return this;
        } else {
            return new ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getImmediateChild = function (childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') {
            return this.getPriority();
        } else {
            var child = this.children_.get(childName);
            return child === null ? EMPTY_NODE : child;
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getChild = function (path) {
        var front = path.getFront();
        if (front === null) return this;
        return this.getImmediateChild(front).getChild(path.popFront());
    };
    /** @inheritDoc */
    ChildrenNode.prototype.hasChild = function (childName) {
        return this.children_.get(childName) !== null;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updateImmediateChild = function (childName, newChildNode) {
        (0, _assert.assert)(newChildNode, 'We should always be passing snapshot nodes');
        if (childName === '.priority') {
            return this.updatePriority(newChildNode);
        } else {
            var namedNode = new _Node.NamedNode(childName, newChildNode);
            var newChildren = void 0,
                newIndexMap = void 0,
                newPriority = void 0;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            } else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            newPriority = newChildren.isEmpty() ? EMPTY_NODE : this.priorityNode_;
            return new ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updateChild = function (path, newChildNode) {
        var front = path.getFront();
        if (front === null) {
            return newChildNode;
        } else {
            (0, _assert.assert)(path.getFront() !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
            var newImmediateChild = this.getImmediateChild(front).updateChild(path.popFront(), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.isEmpty = function () {
        return this.children_.isEmpty();
    };
    /** @inheritDoc */
    ChildrenNode.prototype.numChildren = function () {
        return this.children_.count();
    };
    /** @inheritDoc */
    ChildrenNode.prototype.val = function (exportFormat) {
        if (this.isEmpty()) return null;
        var obj = {};
        var numKeys = 0,
            maxKey = 0,
            allIntegerKeys = true;
        this.forEachChild(_PriorityIndex.PRIORITY_INDEX, function (key, childNode) {
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && ChildrenNode.INTEGER_REGEXP_.test(key)) {
                maxKey = Math.max(maxKey, Number(key));
            } else {
                allIntegerKeys = false;
            }
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            var array = [];
            for (var key in obj) {
                array[key] = obj[key];
            }return array;
        } else {
            if (exportFormat && !this.getPriority().isEmpty()) {
                obj['.priority'] = this.getPriority().val();
            }
            return obj;
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.hash = function () {
        if (this.lazyHash_ === null) {
            var toHash_1 = '';
            if (!this.getPriority().isEmpty()) toHash_1 += 'priority:' + (0, _snap.priorityHashText)(this.getPriority().val()) + ':';
            this.forEachChild(_PriorityIndex.PRIORITY_INDEX, function (key, childNode) {
                var childHash = childNode.hash();
                if (childHash !== '') toHash_1 += ':' + key + ':' + childHash;
            });
            this.lazyHash_ = toHash_1 === '' ? '' : (0, _util.sha1)(toHash_1);
        }
        return this.lazyHash_;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getPredecessorChildName = function (childName, childNode, index) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            var predecessor = idx.getPredecessorKey(new _Node.NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        } else {
            return this.children_.getPredecessorKey(childName);
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?string}
     */
    ChildrenNode.prototype.getFirstChildName = function (indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var minKey = idx.minKey();
            return minKey && minKey.name;
        } else {
            return this.children_.minKey();
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */
    ChildrenNode.prototype.getFirstChild = function (indexDefinition) {
        var minKey = this.getFirstChildName(indexDefinition);
        if (minKey) {
            return new _Node.NamedNode(minKey, this.children_.get(minKey));
        } else {
            return null;
        }
    };
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     * @param {!Index} indexDefinition
     * @return {?string}
     */
    ChildrenNode.prototype.getLastChildName = function (indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        } else {
            return this.children_.maxKey();
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */
    ChildrenNode.prototype.getLastChild = function (indexDefinition) {
        var maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) {
            return new _Node.NamedNode(maxKey, this.children_.get(maxKey));
        } else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.forEachChild = function (index, action) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            return idx.inorderTraversal(function (wrappedNode) {
                return action(wrappedNode.name, wrappedNode.node);
            });
        } else {
            return this.children_.inorderTraversal(action);
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {SortedMapIterator}
     */
    ChildrenNode.prototype.getIterator = function (indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    };
    /**
     *
     * @param {!NamedNode} startPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getIteratorFrom = function (startPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            return idx.getIteratorFrom(startPost, function (key) {
                return key;
            });
        } else {
            var iterator = this.children_.getIteratorFrom(startPost.name, _Node.NamedNode.Wrap);
            var next = iterator.peek();
            while (next != null && indexDefinition.compare(next, startPost) < 0) {
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getReverseIterator = function (indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    };
    /**
     * @param {!NamedNode} endPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getReverseIteratorFrom = function (endPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            return idx.getReverseIteratorFrom(endPost, function (key) {
                return key;
            });
        } else {
            var iterator = this.children_.getReverseIteratorFrom(endPost.name, _Node.NamedNode.Wrap);
            var next = iterator.peek();
            while (next != null && indexDefinition.compare(next, endPost) > 0) {
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.compareTo = function (other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) {
                return 0;
            } else {
                return -1;
            }
        } else if (other.isLeafNode() || other.isEmpty()) {
            return 1;
        } else if (other === MAX_NODE) {
            return -1;
        } else {
            // Must be another node with children.
            return 0;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.withIndex = function (indexDefinition) {
        if (indexDefinition === _KeyIndex.KEY_INDEX || this.indexMap_.hasIndex(indexDefinition)) {
            return this;
        } else {
            var newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.isIndexed = function (index) {
        return index === _KeyIndex.KEY_INDEX || this.indexMap_.hasIndex(index);
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.equals = function (other) {
        if (other === this) {
            return true;
        } else if (other.isLeafNode()) {
            return false;
        } else {
            var otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) {
                return false;
            } else if (this.children_.count() === otherChildrenNode.children_.count()) {
                var thisIter = this.getIterator(_PriorityIndex.PRIORITY_INDEX);
                var otherIter = otherChildrenNode.getIterator(_PriorityIndex.PRIORITY_INDEX);
                var thisCurrent = thisIter.getNext();
                var otherCurrent = otherIter.getNext();
                while (thisCurrent && otherCurrent) {
                    if (thisCurrent.name !== otherCurrent.name || !thisCurrent.node.equals(otherCurrent.node)) {
                        return false;
                    }
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            } else {
                return false;
            }
        }
    };
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     * @private
     * @param {!Index} indexDefinition
     * @return {?SortedMap.<NamedNode, Node>}
     */
    ChildrenNode.prototype.resolveIndex_ = function (indexDefinition) {
        if (indexDefinition === _KeyIndex.KEY_INDEX) {
            return null;
        } else {
            return this.indexMap_.get(indexDefinition.toString());
        }
    };
    /**
     * @private
     * @type {RegExp}
     */
    ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
    return ChildrenNode;
}();
exports.ChildrenNode = ChildrenNode;
/**
 * @constructor
 * @extends {ChildrenNode}
 * @private
 */

var MaxNode = /** @class */function (_super) {
    __extends(MaxNode, _super);
    function MaxNode() {
        return _super.call(this, new _SortedMap.SortedMap(_comparators.NAME_COMPARATOR), ChildrenNode.EMPTY_NODE, _IndexMap.IndexMap.Default) || this;
    }
    MaxNode.prototype.compareTo = function (other) {
        if (other === this) {
            return 0;
        } else {
            return 1;
        }
    };
    MaxNode.prototype.equals = function (other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    };
    MaxNode.prototype.getPriority = function () {
        return this;
    };
    MaxNode.prototype.getImmediateChild = function (childName) {
        return ChildrenNode.EMPTY_NODE;
    };
    MaxNode.prototype.isEmpty = function () {
        return false;
    };
    return MaxNode;
}(ChildrenNode);
exports.MaxNode = MaxNode;
/**
 * Marker that will sort higher than any other snapshot.
 * @type {!MAX_NODE}
 * @const
 */

var MAX_NODE = exports.MAX_NODE = new MaxNode();
Object.defineProperties(_Node.NamedNode, {
    MIN: {
        value: new _Node.NamedNode(_util.MIN_NAME, ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new _Node.NamedNode(_util.MAX_NAME, MAX_NODE)
    }
});
/**
 * Reference Extensions
 */
_KeyIndex.KeyIndex.__EMPTY_NODE = ChildrenNode.EMPTY_NODE;
_LeafNode.LeafNode.__childrenNodeConstructor = ChildrenNode;
(0, _snap.setMaxNode)(MAX_NODE);
(0, _PriorityIndex.setMaxNode)(MAX_NODE);
//# sourceMappingURL=ChildrenNode.js.map


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, setImmediate) {var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.AFRAME = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
var str = Object.prototype.toString

module.exports = anArray

function anArray(arr) {
  return (
       arr.BYTES_PER_ELEMENT
    && str.call(arr.buffer) === '[object ArrayBuffer]'
    || Array.isArray(arr)
  )
}

},{}],2:[function(_dereq_,module,exports){
module.exports = function numtype(num, def) {
	return typeof num === 'number'
		? num 
		: (typeof def === 'number' ? def : 0)
}
},{}],3:[function(_dereq_,module,exports){
'use strict';
// For more information about browser field, check out the browser field at https://github.com/substack/browserify-handbook#browser-field.

module.exports = {
    // Create a <link> tag with optional data attributes
    createLink: function(href, attributes) {
        var head = document.head || document.getElementsByTagName('head')[0];
        var link = document.createElement('link');

        link.href = href;
        link.rel = 'stylesheet';

        for (var key in attributes) {
            if ( ! attributes.hasOwnProperty(key)) {
                continue;
            }
            var value = attributes[key];
            link.setAttribute('data-' + key, value);
        }

        head.appendChild(link);
    },
    // Create a <style> tag with optional data attributes
    createStyle: function(cssText, attributes) {
        var head = document.head || document.getElementsByTagName('head')[0],
            style = document.createElement('style');

        style.type = 'text/css';

        for (var key in attributes) {
            if ( ! attributes.hasOwnProperty(key)) {
                continue;
            }
            var value = attributes[key];
            style.setAttribute('data-' + key, value);
        }
        
        if (style.sheet) { // for jsdom and IE9+
            style.innerHTML = cssText;
            style.sheet.cssText = cssText;
            head.appendChild(style);
        } else if (style.styleSheet) { // for IE8 and below
            head.appendChild(style);
            style.styleSheet.cssText = cssText;
        } else { // for Chrome, Firefox, and Safari
            style.appendChild(document.createTextNode(cssText));
            head.appendChild(style);
        }
    }
};

},{}],4:[function(_dereq_,module,exports){
(function (global){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = _dereq_('base64-js')
var ieee754 = _dereq_('ieee754')
var isArray = _dereq_('isarray')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"base64-js":5,"ieee754":6,"isarray":7}],5:[function(_dereq_,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return b64.length * 3 / 4 - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, j, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr(len * 3 / 4 - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0, j = 0; i < l; i += 4, j += 3) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}

},{}],6:[function(_dereq_,module,exports){
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],7:[function(_dereq_,module,exports){
var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

},{}],8:[function(_dereq_,module,exports){
(function (process){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe =
    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
var splitPath = function(filename) {
  return splitPathRe.exec(filename).slice(1);
};

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function(path) {
  var result = splitPath(path),
      root = result[0],
      dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
};


exports.basename = function(path, ext) {
  var f = splitPath(path)[2];
  // TODO: make this comparison case-insensitive on windows?
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};


exports.extname = function(path) {
  return splitPath(path)[3];
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

}).call(this,_dereq_('_process'))

},{"_process":9}],9:[function(_dereq_,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],10:[function(_dereq_,module,exports){
var Buffer = _dereq_('buffer').Buffer; // for use with browserify

module.exports = function (a, b) {
    if (!Buffer.isBuffer(a)) return undefined;
    if (!Buffer.isBuffer(b)) return undefined;
    if (typeof a.equals === 'function') return a.equals(b);
    if (a.length !== b.length) return false;
    
    for (var i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
    }
    
    return true;
};

},{"buffer":4}],11:[function(_dereq_,module,exports){
(function (process){

/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = _dereq_('./debug');
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (window.console && (console.firebug || (console.exception && console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs() {
  var args = arguments;
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return args;

  var c = 'color: ' + this.color;
  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
  return args;
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    return exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (typeof process !== 'undefined' && 'env' in process) {
    return process.env.DEBUG;
  }
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage(){
  try {
    return window.localStorage;
  } catch (e) {}
}

}).call(this,_dereq_('_process'))

},{"./debug":12,"_process":9}],12:[function(_dereq_,module,exports){

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = debug.debug = debug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = _dereq_('ms');

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lowercased letter, i.e. "n".
 */

exports.formatters = {};

/**
 * Previously assigned color.
 */

var prevColor = 0;

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 *
 * @return {Number}
 * @api private
 */

function selectColor() {
  return exports.colors[prevColor++ % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function debug(namespace) {

  // define the `disabled` version
  function disabled() {
  }
  disabled.enabled = false;

  // define the `enabled` version
  function enabled() {

    var self = enabled;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // add the `color` if not set
    if (null == self.useColors) self.useColors = exports.useColors();
    if (null == self.color && self.useColors) self.color = selectColor();

    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %o
      args = ['%o'].concat(args);
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting
    args = exports.formatArgs.apply(self, args);

    var logFn = enabled.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }
  enabled.enabled = true;

  var fn = exports.enabled(namespace) ? enabled : disabled;

  fn.namespace = namespace;

  return fn;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  var split = (namespaces || '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/[\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}

},{"ms":13}],13:[function(_dereq_,module,exports){
/**
 * Helpers.
 */

var s = 1000
var m = s * 60
var h = m * 60
var d = h * 24
var y = d * 365.25

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} options
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {}
  var type = typeof val
  if (type === 'string' && val.length > 0) {
    return parse(val)
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ?
			fmtLong(val) :
			fmtShort(val)
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
}

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str)
  if (str.length > 10000) {
    return
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
  if (!match) {
    return
  }
  var n = parseFloat(match[1])
  var type = (match[2] || 'ms').toLowerCase()
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y
    case 'days':
    case 'day':
    case 'd':
      return n * d
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n
    default:
      return undefined
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd'
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h'
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm'
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's'
  }
  return ms + 'ms'
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms'
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name
  }
  return Math.ceil(ms / n) + ' ' + name + 's'
}

},{}],14:[function(_dereq_,module,exports){
'use strict';
var isObj = _dereq_('is-obj');
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Sources cannot be null or undefined');
	}

	return Object(val);
}

function assignKey(to, from, key) {
	var val = from[key];

	if (val === undefined || val === null) {
		return;
	}

	if (hasOwnProperty.call(to, key)) {
		if (to[key] === undefined || to[key] === null) {
			throw new TypeError('Cannot convert undefined or null to object (' + key + ')');
		}
	}

	if (!hasOwnProperty.call(to, key) || !isObj(val)) {
		to[key] = val;
	} else {
		to[key] = assign(Object(to[key]), from[key]);
	}
}

function assign(to, from) {
	if (to === from) {
		return to;
	}

	from = Object(from);

	for (var key in from) {
		if (hasOwnProperty.call(from, key)) {
			assignKey(to, from, key);
		}
	}

	if (Object.getOwnPropertySymbols) {
		var symbols = Object.getOwnPropertySymbols(from);

		for (var i = 0; i < symbols.length; i++) {
			if (propIsEnumerable.call(from, symbols[i])) {
				assignKey(to, from, symbols[i]);
			}
		}
	}

	return to;
}

module.exports = function deepAssign(target) {
	target = toObject(target);

	for (var s = 1; s < arguments.length; s++) {
		assign(target, arguments[s]);
	}

	return target;
};

},{"is-obj":15}],15:[function(_dereq_,module,exports){
'use strict';
module.exports = function (x) {
	var type = typeof x;
	return x !== null && (type === 'object' || type === 'function');
};

},{}],16:[function(_dereq_,module,exports){
/*! (C) WebReflection Mit Style License */
(function(t,n,r,i){"use strict";function st(e,t){for(var n=0,r=e.length;n<r;n++)gt(e[n],t)}function ot(e){for(var t=0,n=e.length,r;t<n;t++)r=e[t],it(r,w[at(r)])}function ut(e){return function(t){F(t)&&(gt(t,e),st(t.querySelectorAll(E),e))}}function at(e){var t=R.call(e,"is"),n=e.nodeName.toUpperCase(),r=x.call(b,t?m+t.toUpperCase():v+n);return t&&-1<r&&!ft(n,t)?-1:r}function ft(e,t){return-1<E.indexOf(e+'[is="'+t+'"]')}function lt(e){var t=e.currentTarget,n=e.attrChange,r=e.attrName,i=e.target;Y&&(!i||i===t)&&t.attributeChangedCallback&&r!=="style"&&e.prevValue!==e.newValue&&t.attributeChangedCallback(r,n===e[f]?null:e.prevValue,n===e[c]?null:e.newValue)}function ct(e){var t=ut(e);return function(e){$.push(t,e.target)}}function ht(e){G&&(G=!1,e.currentTarget.removeEventListener(p,ht)),st((e.target||n).querySelectorAll(E),e.detail===u?u:o),j&&vt()}function pt(e,t){var n=this;U.call(n,e,t),Z.call(n,{target:n})}function dt(e,t){P(e,t),nt?nt.observe(e,X):(Q&&(e.setAttribute=pt,e[s]=tt(e),e.addEventListener(d,Z)),e.addEventListener(h,lt)),e.createdCallback&&Y&&(e.created=!0,e.createdCallback(),e.created=!1)}function vt(){for(var e,t=0,n=I.length;t<n;t++)e=I[t],S.contains(e)||(n--,I.splice(t--,1),gt(e,u))}function mt(e){throw new Error("A "+e+" type is already registered")}function gt(e,t){var n,r=at(e);-1<r&&(rt(e,w[r]),r=0,t===o&&!e[o]?(e[u]=!1,e[o]=!0,r=1,j&&x.call(I,e)<0&&I.push(e)):t===u&&!e[u]&&(e[o]=!1,e[u]=!0,r=1),r&&(n=e[t+"Callback"])&&n.call(e))}if(i in n)return;var s="__"+i+(Math.random()*1e5>>0),o="attached",u="detached",a="extends",f="ADDITION",l="MODIFICATION",c="REMOVAL",h="DOMAttrModified",p="DOMContentLoaded",d="DOMSubtreeModified",v="<",m="=",g=/^[A-Z][A-Z0-9]*(?:-[A-Z0-9]+)+$/,y=["ANNOTATION-XML","COLOR-PROFILE","FONT-FACE","FONT-FACE-SRC","FONT-FACE-URI","FONT-FACE-FORMAT","FONT-FACE-NAME","MISSING-GLYPH"],b=[],w=[],E="",S=n.documentElement,x=b.indexOf||function(e){for(var t=this.length;t--&&this[t]!==e;);return t},T=r.prototype,N=T.hasOwnProperty,C=T.isPrototypeOf,k=r.defineProperty,L=r.getOwnPropertyDescriptor,A=r.getOwnPropertyNames,O=r.getPrototypeOf,M=r.setPrototypeOf,_=!!r.__proto__,D=r.create||function yt(e){return e?(yt.prototype=e,new yt):this},P=M||(_?function(e,t){return e.__proto__=t,e}:A&&L?function(){function e(e,t){for(var n,r=A(t),i=0,s=r.length;i<s;i++)n=r[i],N.call(e,n)||k(e,n,L(t,n))}return function(t,n){do e(t,n);while((n=O(n))&&!C.call(n,t));return t}}():function(e,t){for(var n in t)e[n]=t[n];return e}),H=t.MutationObserver||t.WebKitMutationObserver,B=(t.HTMLElement||t.Element||t.Node).prototype,j=!C.call(B,S),F=j?function(e){return e.nodeType===1}:function(e){return C.call(B,e)},I=j&&[],q=B.cloneNode,R=B.getAttribute,U=B.setAttribute,z=B.removeAttribute,W=n.createElement,X=H&&{attributes:!0,characterData:!0,attributeOldValue:!0},V=H||function(e){Q=!1,S.removeEventListener(h,V)},$,J=t.requestAnimationFrame||t.webkitRequestAnimationFrame||t.mozRequestAnimationFrame||t.msRequestAnimationFrame||function(e){setTimeout(e,10)},K=!1,Q=!0,G=!0,Y=!0,Z,et,tt,nt,rt,it;M||_?(rt=function(e,t){C.call(t,e)||dt(e,t)},it=dt):(rt=function(e,t){e[s]||(e[s]=r(!0),dt(e,t))},it=rt),j?(Q=!1,function(){var t=L(B,"addEventListener"),n=t.value,r=function(e){var t=new CustomEvent(h,{bubbles:!0});t.attrName=e,t.prevValue=R.call(this,e),t.newValue=null,t[c]=t.attrChange=2,z.call(this,e),this.dispatchEvent(t)},i=function(t,n){var r=this.hasAttribute(t),i=r&&R.call(this,t);e=new CustomEvent(h,{bubbles:!0}),U.call(this,t,n),e.attrName=t,e.prevValue=r?i:null,e.newValue=n,r?e[l]=e.attrChange=1:e[f]=e.attrChange=0,this.dispatchEvent(e)},o=function(e){var t=e.currentTarget,n=t[s],r=e.propertyName,i;n.hasOwnProperty(r)&&(n=n[r],i=new CustomEvent(h,{bubbles:!0}),i.attrName=n.name,i.prevValue=n.value||null,i.newValue=n.value=t[r]||null,i.prevValue==null?i[f]=i.attrChange=0:i[l]=i.attrChange=1,t.dispatchEvent(i))};t.value=function(e,t,u){e===h&&this.attributeChangedCallback&&this.setAttribute!==i&&(this[s]={className:{name:"class",value:this.className}},this.setAttribute=i,this.removeAttribute=r,n.call(this,"propertychange",o)),n.call(this,e,t,u)},k(B,"addEventListener",t)}()):H||(S.addEventListener(h,V),S.setAttribute(s,1),S.removeAttribute(s),Q&&(Z=function(e){var t=this,n,r,i;if(t===e.target){n=t[s],t[s]=r=tt(t);for(i in r){if(!(i in n))return et(0,t,i,n[i],r[i],f);if(r[i]!==n[i])return et(1,t,i,n[i],r[i],l)}for(i in n)if(!(i in r))return et(2,t,i,n[i],r[i],c)}},et=function(e,t,n,r,i,s){var o={attrChange:e,currentTarget:t,attrName:n,prevValue:r,newValue:i};o[s]=e,lt(o)},tt=function(e){for(var t,n,r={},i=e.attributes,s=0,o=i.length;s<o;s++)t=i[s],n=t.name,n!=="setAttribute"&&(r[n]=t.value);return r})),n[i]=function(t,r){c=t.toUpperCase(),K||(K=!0,H?(nt=function(e,t){function n(e,t){for(var n=0,r=e.length;n<r;t(e[n++]));}return new H(function(r){for(var i,s,o,u=0,a=r.length;u<a;u++)i=r[u],i.type==="childList"?(n(i.addedNodes,e),n(i.removedNodes,t)):(s=i.target,Y&&s.attributeChangedCallback&&i.attributeName!=="style"&&(o=R.call(s,i.attributeName),o!==i.oldValue&&s.attributeChangedCallback(i.attributeName,i.oldValue,o)))})}(ut(o),ut(u)),nt.observe(n,{childList:!0,subtree:!0})):($=[],J(function d(){while($.length)$.shift().call(null,$.shift());J(d)}),n.addEventListener("DOMNodeInserted",ct(o)),n.addEventListener("DOMNodeRemoved",ct(u))),n.addEventListener(p,ht),n.addEventListener("readystatechange",ht),n.createElement=function(e,t){var r=W.apply(n,arguments),i=""+e,s=x.call(b,(t?m:v)+(t||i).toUpperCase()),o=-1<s;return t&&(r.setAttribute("is",t=t.toLowerCase()),o&&(o=ft(i.toUpperCase(),t))),Y=!n.createElement.innerHTMLHelper,o&&it(r,w[s]),r},B.cloneNode=function(e){var t=q.call(this,!!e),n=at(t);return-1<n&&it(t,w[n]),e&&ot(t.querySelectorAll(E)),t}),-2<x.call(b,m+c)+x.call(b,v+c)&&mt(t);if(!g.test(c)||-1<x.call(y,c))throw new Error("The type "+t+" is invalid");var i=function(){return f?n.createElement(l,c):n.createElement(l)},s=r||T,f=N.call(s,a),l=f?r[a].toUpperCase():c,c,h;return f&&-1<x.call(b,v+l)&&mt(l),h=b.push((f?m:v)+c)-1,E=E.concat(E.length?",":"",f?l+'[is="'+t.toLowerCase()+'"]':l),i.prototype=w[h]=N.call(s,"prototype")?s.prototype:D(B),st(n.querySelectorAll(E),o),i}})(window,document,Object,"registerElement");
},{}],17:[function(_dereq_,module,exports){
module.exports = function(dtype) {
  switch (dtype) {
    case 'int8':
      return Int8Array
    case 'int16':
      return Int16Array
    case 'int32':
      return Int32Array
    case 'uint8':
      return Uint8Array
    case 'uint16':
      return Uint16Array
    case 'uint32':
      return Uint32Array
    case 'float32':
      return Float32Array
    case 'float64':
      return Float64Array
    case 'array':
      return Array
    case 'uint8_clamped':
      return Uint8ClampedArray
  }
}

},{}],18:[function(_dereq_,module,exports){
/*eslint new-cap:0*/
var dtype = _dereq_('dtype')
module.exports = flattenVertexData
function flattenVertexData (data, output, offset) {
  if (!data) throw new TypeError('must specify data as first parameter')
  offset = +(offset || 0) | 0

  if (Array.isArray(data) && Array.isArray(data[0])) {
    var dim = data[0].length
    var length = data.length * dim

    // no output specified, create a new typed array
    if (!output || typeof output === 'string') {
      output = new (dtype(output || 'float32'))(length + offset)
    }

    var dstLength = output.length - offset
    if (length !== dstLength) {
      throw new Error('source length ' + length + ' (' + dim + 'x' + data.length + ')' +
        ' does not match destination length ' + dstLength)
    }

    for (var i = 0, k = offset; i < data.length; i++) {
      for (var j = 0; j < dim; j++) {
        output[k++] = data[i][j]
      }
    }
  } else {
    if (!output || typeof output === 'string') {
      // no output, create a new one
      var Ctor = dtype(output || 'float32')
      if (offset === 0) {
        output = new Ctor(data)
      } else {
        output = new Ctor(data.length + offset)
        output.set(data, offset)
      }
    } else {
      // store output in existing array
      output.set(data, offset)
    }
  }

  return output
}

},{"dtype":17}],19:[function(_dereq_,module,exports){
var isFunction = _dereq_('is-function')

module.exports = forEach

var toString = Object.prototype.toString
var hasOwnProperty = Object.prototype.hasOwnProperty

function forEach(list, iterator, context) {
    if (!isFunction(iterator)) {
        throw new TypeError('iterator must be a function')
    }

    if (arguments.length < 3) {
        context = this
    }
    
    if (toString.call(list) === '[object Array]')
        forEachArray(list, iterator, context)
    else if (typeof list === 'string')
        forEachString(list, iterator, context)
    else
        forEachObject(list, iterator, context)
}

function forEachArray(array, iterator, context) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            iterator.call(context, array[i], i, array)
        }
    }
}

function forEachString(string, iterator, context) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        iterator.call(context, string.charAt(i), i, string)
    }
}

function forEachObject(object, iterator, context) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            iterator.call(context, object[k], k, object)
        }
    }
}

},{"is-function":24}],20:[function(_dereq_,module,exports){
(function (global){
if (typeof window !== "undefined") {
    module.exports = window;
} else if (typeof global !== "undefined") {
    module.exports = global;
} else if (typeof self !== "undefined"){
    module.exports = self;
} else {
    module.exports = {};
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],21:[function(_dereq_,module,exports){
module.exports = function compile(property) {
	if (!property || typeof property !== 'string')
		throw new Error('must specify property for indexof search')

	return new Function('array', 'value', 'start', [
		'start = start || 0',
		'for (var i=start; i<array.length; i++)',
		'  if (array[i]["' + property +'"] === value)',
		'      return i',
		'return -1'
	].join('\n'))
}
},{}],22:[function(_dereq_,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}

},{}],23:[function(_dereq_,module,exports){
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}

},{}],24:[function(_dereq_,module,exports){
module.exports = isFunction

var toString = Object.prototype.toString

function isFunction (fn) {
  var string = toString.call(fn)
  return string === '[object Function]' ||
    (typeof fn === 'function' && string !== '[object RegExp]') ||
    (typeof window !== 'undefined' &&
     // IE8 and below
     (fn === window.setTimeout ||
      fn === window.alert ||
      fn === window.confirm ||
      fn === window.prompt))
};

},{}],25:[function(_dereq_,module,exports){
var wordWrap = _dereq_('word-wrapper')
var xtend = _dereq_('xtend')
var findChar = _dereq_('indexof-property')('id')
var number = _dereq_('as-number')

var X_HEIGHTS = ['x', 'e', 'a', 'o', 'n', 's', 'r', 'c', 'u', 'm', 'v', 'w', 'z']
var M_WIDTHS = ['m', 'w']
var CAP_HEIGHTS = ['H', 'I', 'N', 'E', 'F', 'K', 'L', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']


var TAB_ID = '\t'.charCodeAt(0)
var SPACE_ID = ' '.charCodeAt(0)
var ALIGN_LEFT = 0, 
    ALIGN_CENTER = 1, 
    ALIGN_RIGHT = 2

module.exports = function createLayout(opt) {
  return new TextLayout(opt)
}

function TextLayout(opt) {
  this.glyphs = []
  this._measure = this.computeMetrics.bind(this)
  this.update(opt)
}

TextLayout.prototype.update = function(opt) {
  opt = xtend({
    measure: this._measure
  }, opt)
  this._opt = opt
  this._opt.tabSize = number(this._opt.tabSize, 4)

  if (!opt.font)
    throw new Error('must provide a valid bitmap font')

  var glyphs = this.glyphs
  var text = opt.text||'' 
  var font = opt.font
  this._setupSpaceGlyphs(font)
  
  var lines = wordWrap.lines(text, opt)
  var minWidth = opt.width || 0

  //clear glyphs
  glyphs.length = 0

  //get max line width
  var maxLineWidth = lines.reduce(function(prev, line) {
    return Math.max(prev, line.width, minWidth)
  }, 0)

  //the pen position
  var x = 0
  var y = 0
  var lineHeight = number(opt.lineHeight, font.common.lineHeight)
  var baseline = font.common.base
  var descender = lineHeight-baseline
  var letterSpacing = opt.letterSpacing || 0
  var height = lineHeight * lines.length - descender
  var align = getAlignType(this._opt.align)

  //draw text along baseline
  y -= height
  
  //the metrics for this text layout
  this._width = maxLineWidth
  this._height = height
  this._descender = lineHeight - baseline
  this._baseline = baseline
  this._xHeight = getXHeight(font)
  this._capHeight = getCapHeight(font)
  this._lineHeight = lineHeight
  this._ascender = lineHeight - descender - this._xHeight
    
  //layout each glyph
  var self = this
  lines.forEach(function(line, lineIndex) {
    var start = line.start
    var end = line.end
    var lineWidth = line.width
    var lastGlyph
    
    //for each glyph in that line...
    for (var i=start; i<end; i++) {
      var id = text.charCodeAt(i)
      var glyph = self.getGlyph(font, id)
      if (glyph) {
        if (lastGlyph) 
          x += getKerning(font, lastGlyph.id, glyph.id)

        var tx = x
        if (align === ALIGN_CENTER) 
          tx += (maxLineWidth-lineWidth)/2
        else if (align === ALIGN_RIGHT)
          tx += (maxLineWidth-lineWidth)

        glyphs.push({
          position: [tx, y],
          data: glyph,
          index: i,
          line: lineIndex
        })  

        //move pen forward
        x += glyph.xadvance + letterSpacing
        lastGlyph = glyph
      }
    }

    //next line down
    y += lineHeight
    x = 0
  })
  this._linesTotal = lines.length;
}

TextLayout.prototype._setupSpaceGlyphs = function(font) {
  //These are fallbacks, when the font doesn't include
  //' ' or '\t' glyphs
  this._fallbackSpaceGlyph = null
  this._fallbackTabGlyph = null

  if (!font.chars || font.chars.length === 0)
    return

  //try to get space glyph
  //then fall back to the 'm' or 'w' glyphs
  //then fall back to the first glyph available
  var space = getGlyphById(font, SPACE_ID) 
          || getMGlyph(font) 
          || font.chars[0]

  //and create a fallback for tab
  var tabWidth = this._opt.tabSize * space.xadvance
  this._fallbackSpaceGlyph = space
  this._fallbackTabGlyph = xtend(space, {
    x: 0, y: 0, xadvance: tabWidth, id: TAB_ID, 
    xoffset: 0, yoffset: 0, width: 0, height: 0
  })
}

TextLayout.prototype.getGlyph = function(font, id) {
  var glyph = getGlyphById(font, id)
  if (glyph)
    return glyph
  else if (id === TAB_ID) 
    return this._fallbackTabGlyph
  else if (id === SPACE_ID) 
    return this._fallbackSpaceGlyph
  return null
}

TextLayout.prototype.computeMetrics = function(text, start, end, width) {
  var letterSpacing = this._opt.letterSpacing || 0
  var font = this._opt.font
  var curPen = 0
  var curWidth = 0
  var count = 0
  var glyph
  var lastGlyph

  if (!font.chars || font.chars.length === 0) {
    return {
      start: start,
      end: start,
      width: 0
    }
  }

  end = Math.min(text.length, end)
  for (var i=start; i < end; i++) {
    var id = text.charCodeAt(i)
    var glyph = this.getGlyph(font, id)

    if (glyph) {
      //move pen forward
      var xoff = glyph.xoffset
      var kern = lastGlyph ? getKerning(font, lastGlyph.id, glyph.id) : 0
      curPen += kern

      var nextPen = curPen + glyph.xadvance + letterSpacing
      var nextWidth = curPen + glyph.width

      //we've hit our limit; we can't move onto the next glyph
      if (nextWidth >= width || nextPen >= width)
        break

      //otherwise continue along our line
      curPen = nextPen
      curWidth = nextWidth
      lastGlyph = glyph
    }
    count++
  }
  
  //make sure rightmost edge lines up with rendered glyphs
  if (lastGlyph)
    curWidth += lastGlyph.xoffset

  return {
    start: start,
    end: start + count,
    width: curWidth
  }
}

//getters for the private vars
;['width', 'height', 
  'descender', 'ascender',
  'xHeight', 'baseline',
  'capHeight',
  'lineHeight' ].forEach(addGetter)

function addGetter(name) {
  Object.defineProperty(TextLayout.prototype, name, {
    get: wrapper(name),
    configurable: true
  })
}

//create lookups for private vars
function wrapper(name) {
  return (new Function([
    'return function '+name+'() {',
    '  return this._'+name,
    '}'
  ].join('\n')))()
}

function getGlyphById(font, id) {
  if (!font.chars || font.chars.length === 0)
    return null

  var glyphIdx = findChar(font.chars, id)
  if (glyphIdx >= 0)
    return font.chars[glyphIdx]
  return null
}

function getXHeight(font) {
  for (var i=0; i<X_HEIGHTS.length; i++) {
    var id = X_HEIGHTS[i].charCodeAt(0)
    var idx = findChar(font.chars, id)
    if (idx >= 0) 
      return font.chars[idx].height
  }
  return 0
}

function getMGlyph(font) {
  for (var i=0; i<M_WIDTHS.length; i++) {
    var id = M_WIDTHS[i].charCodeAt(0)
    var idx = findChar(font.chars, id)
    if (idx >= 0) 
      return font.chars[idx]
  }
  return 0
}

function getCapHeight(font) {
  for (var i=0; i<CAP_HEIGHTS.length; i++) {
    var id = CAP_HEIGHTS[i].charCodeAt(0)
    var idx = findChar(font.chars, id)
    if (idx >= 0) 
      return font.chars[idx].height
  }
  return 0
}

function getKerning(font, left, right) {
  if (!font.kernings || font.kernings.length === 0)
    return 0

  var table = font.kernings
  for (var i=0; i<table.length; i++) {
    var kern = table[i]
    if (kern.first === left && kern.second === right)
      return kern.amount
  }
  return 0
}

function getAlignType(align) {
  if (align === 'center')
    return ALIGN_CENTER
  else if (align === 'right')
    return ALIGN_RIGHT
  return ALIGN_LEFT
}
},{"as-number":2,"indexof-property":21,"word-wrapper":51,"xtend":54}],26:[function(_dereq_,module,exports){
(function (Buffer){
var xhr = _dereq_('xhr')
var noop = function(){}
var parseASCII = _dereq_('parse-bmfont-ascii')
var parseXML = _dereq_('parse-bmfont-xml')
var readBinary = _dereq_('parse-bmfont-binary')
var isBinaryFormat = _dereq_('./lib/is-binary')
var xtend = _dereq_('xtend')

var xml2 = (function hasXML2() {
  return self.XMLHttpRequest && "withCredentials" in new XMLHttpRequest
})()

module.exports = function(opt, cb) {
  cb = typeof cb === 'function' ? cb : noop

  if (typeof opt === 'string')
    opt = { uri: opt }
  else if (!opt)
    opt = {}

  var expectBinary = opt.binary
  if (expectBinary)
    opt = getBinaryOpts(opt)

  xhr(opt, function(err, res, body) {
    if (err)
      return cb(err)
    if (!/^2/.test(res.statusCode))
      return cb(new Error('http status code: '+res.statusCode))
    if (!body)
      return cb(new Error('no body result'))

    var binary = false 

    //if the response type is an array buffer,
    //we need to convert it into a regular Buffer object
    if (isArrayBuffer(body)) {
      var array = new Uint8Array(body)
      body = new Buffer(array, 'binary')
    }

    //now check the string/Buffer response
    //and see if it has a binary BMF header
    if (isBinaryFormat(body)) {
      binary = true
      //if we have a string, turn it into a Buffer
      if (typeof body === 'string') 
        body = new Buffer(body, 'binary')
    } 

    //we are not parsing a binary format, just ASCII/XML/etc
    if (!binary) {
      //might still be a buffer if responseType is 'arraybuffer'
      if (Buffer.isBuffer(body))
        body = body.toString(opt.encoding)
      body = body.trim()
    }

    var result
    try {
      var type = res.headers['content-type']
      if (binary)
        result = readBinary(body)
      else if (/json/.test(type) || body.charAt(0) === '{')
        result = JSON.parse(body)
      else if (/xml/.test(type)  || body.charAt(0) === '<')
        result = parseXML(body)
      else
        result = parseASCII(body)
    } catch (e) {
      cb(new Error('error parsing font '+e.message))
      cb = noop
    }
    cb(null, result)
  })
}

function isArrayBuffer(arr) {
  var str = Object.prototype.toString
  return str.call(arr) === '[object ArrayBuffer]'
}

function getBinaryOpts(opt) {
  //IE10+ and other modern browsers support array buffers
  if (xml2)
    return xtend(opt, { responseType: 'arraybuffer' })
  
  if (typeof self.XMLHttpRequest === 'undefined')
    throw new Error('your browser does not support XHR loading')

  //IE9 and XML1 browsers could still use an override
  var req = new self.XMLHttpRequest()
  req.overrideMimeType('text/plain; charset=x-user-defined')
  return xtend({
    xhr: req
  }, opt)
}

}).call(this,_dereq_("buffer").Buffer)

},{"./lib/is-binary":27,"buffer":4,"parse-bmfont-ascii":29,"parse-bmfont-binary":30,"parse-bmfont-xml":31,"xhr":52,"xtend":54}],27:[function(_dereq_,module,exports){
(function (Buffer){
var equal = _dereq_('buffer-equal')
var HEADER = new Buffer([66, 77, 70, 3])

module.exports = function(buf) {
  if (typeof buf === 'string')
    return buf.substring(0, 3) === 'BMF'
  return buf.length > 4 && equal(buf.slice(0, 4), HEADER)
}
}).call(this,_dereq_("buffer").Buffer)

},{"buffer":4,"buffer-equal":10}],28:[function(_dereq_,module,exports){
'use strict';
/* eslint-disable no-unused-vars */
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (e) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (Object.getOwnPropertySymbols) {
			symbols = Object.getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

},{}],29:[function(_dereq_,module,exports){
module.exports = function parseBMFontAscii(data) {
  if (!data)
    throw new Error('no data provided')
  data = data.toString().trim()

  var output = {
    pages: [],
    chars: [],
    kernings: []
  }

  var lines = data.split(/\r\n?|\n/g)

  if (lines.length === 0)
    throw new Error('no data in BMFont file')

  for (var i = 0; i < lines.length; i++) {
    var lineData = splitLine(lines[i], i)
    if (!lineData) //skip empty lines
      continue

    if (lineData.key === 'page') {
      if (typeof lineData.data.id !== 'number')
        throw new Error('malformed file at line ' + i + ' -- needs page id=N')
      if (typeof lineData.data.file !== 'string')
        throw new Error('malformed file at line ' + i + ' -- needs page file="path"')
      output.pages[lineData.data.id] = lineData.data.file
    } else if (lineData.key === 'chars' || lineData.key === 'kernings') {
      //... do nothing for these two ...
    } else if (lineData.key === 'char') {
      output.chars.push(lineData.data)
    } else if (lineData.key === 'kerning') {
      output.kernings.push(lineData.data)
    } else {
      output[lineData.key] = lineData.data
    }
  }

  return output
}

function splitLine(line, idx) {
  line = line.replace(/\t+/g, ' ').trim()
  if (!line)
    return null

  var space = line.indexOf(' ')
  if (space === -1) 
    throw new Error("no named row at line " + idx)

  var key = line.substring(0, space)

  line = line.substring(space + 1)
  //clear "letter" field as it is non-standard and
  //requires additional complexity to parse " / = symbols
  line = line.replace(/letter=[\'\"]\S+[\'\"]/gi, '')  
  line = line.split("=")
  line = line.map(function(str) {
    return str.trim().match((/(".*?"|[^"\s]+)+(?=\s*|\s*$)/g))
  })

  var data = []
  for (var i = 0; i < line.length; i++) {
    var dt = line[i]
    if (i === 0) {
      data.push({
        key: dt[0],
        data: ""
      })
    } else if (i === line.length - 1) {
      data[data.length - 1].data = parseData(dt[0])
    } else {
      data[data.length - 1].data = parseData(dt[0])
      data.push({
        key: dt[1],
        data: ""
      })
    }
  }

  var out = {
    key: key,
    data: {}
  }

  data.forEach(function(v) {
    out.data[v.key] = v.data;
  })

  return out
}

function parseData(data) {
  if (!data || data.length === 0)
    return ""

  if (data.indexOf('"') === 0 || data.indexOf("'") === 0)
    return data.substring(1, data.length - 1)
  if (data.indexOf(',') !== -1)
    return parseIntList(data)
  return parseInt(data, 10)
}

function parseIntList(data) {
  return data.split(',').map(function(val) {
    return parseInt(val, 10)
  })
}
},{}],30:[function(_dereq_,module,exports){
var HEADER = [66, 77, 70]

module.exports = function readBMFontBinary(buf) {
  if (buf.length < 6)
    throw new Error('invalid buffer length for BMFont')

  var header = HEADER.every(function(byte, i) {
    return buf.readUInt8(i) === byte
  })

  if (!header)
    throw new Error('BMFont missing BMF byte header')

  var i = 3
  var vers = buf.readUInt8(i++)
  if (vers > 3)
    throw new Error('Only supports BMFont Binary v3 (BMFont App v1.10)')
  
  var target = { kernings: [], chars: [] }
  for (var b=0; b<5; b++)
    i += readBlock(target, buf, i)
  return target
}

function readBlock(target, buf, i) {
  if (i > buf.length-1)
    return 0

  var blockID = buf.readUInt8(i++)
  var blockSize = buf.readInt32LE(i)
  i += 4

  switch(blockID) {
    case 1: 
      target.info = readInfo(buf, i)
      break
    case 2:
      target.common = readCommon(buf, i)
      break
    case 3:
      target.pages = readPages(buf, i, blockSize)
      break
    case 4:
      target.chars = readChars(buf, i, blockSize)
      break
    case 5:
      target.kernings = readKernings(buf, i, blockSize)
      break
  }
  return 5 + blockSize
}

function readInfo(buf, i) {
  var info = {}
  info.size = buf.readInt16LE(i)

  var bitField = buf.readUInt8(i+2)
  info.smooth = (bitField >> 7) & 1
  info.unicode = (bitField >> 6) & 1
  info.italic = (bitField >> 5) & 1
  info.bold = (bitField >> 4) & 1
  
  //fixedHeight is only mentioned in binary spec 
  if ((bitField >> 3) & 1)
    info.fixedHeight = 1
  
  info.charset = buf.readUInt8(i+3) || ''
  info.stretchH = buf.readUInt16LE(i+4)
  info.aa = buf.readUInt8(i+6)
  info.padding = [
    buf.readInt8(i+7),
    buf.readInt8(i+8),
    buf.readInt8(i+9),
    buf.readInt8(i+10)
  ]
  info.spacing = [
    buf.readInt8(i+11),
    buf.readInt8(i+12)
  ]
  info.outline = buf.readUInt8(i+13)
  info.face = readStringNT(buf, i+14)
  return info
}

function readCommon(buf, i) {
  var common = {}
  common.lineHeight = buf.readUInt16LE(i)
  common.base = buf.readUInt16LE(i+2)
  common.scaleW = buf.readUInt16LE(i+4)
  common.scaleH = buf.readUInt16LE(i+6)
  common.pages = buf.readUInt16LE(i+8)
  var bitField = buf.readUInt8(i+10)
  common.packed = 0
  common.alphaChnl = buf.readUInt8(i+11)
  common.redChnl = buf.readUInt8(i+12)
  common.greenChnl = buf.readUInt8(i+13)
  common.blueChnl = buf.readUInt8(i+14)
  return common
}

function readPages(buf, i, size) {
  var pages = []
  var text = readNameNT(buf, i)
  var len = text.length+1
  var count = size / len
  for (var c=0; c<count; c++) {
    pages[c] = buf.slice(i, i+text.length).toString('utf8')
    i += len
  }
  return pages
}

function readChars(buf, i, blockSize) {
  var chars = []

  var count = blockSize / 20
  for (var c=0; c<count; c++) {
    var char = {}
    var off = c*20
    char.id = buf.readUInt32LE(i + 0 + off)
    char.x = buf.readUInt16LE(i + 4 + off)
    char.y = buf.readUInt16LE(i + 6 + off)
    char.width = buf.readUInt16LE(i + 8 + off)
    char.height = buf.readUInt16LE(i + 10 + off)
    char.xoffset = buf.readInt16LE(i + 12 + off)
    char.yoffset = buf.readInt16LE(i + 14 + off)
    char.xadvance = buf.readInt16LE(i + 16 + off)
    char.page = buf.readUInt8(i + 18 + off)
    char.chnl = buf.readUInt8(i + 19 + off)
    chars[c] = char
  }
  return chars
}

function readKernings(buf, i, blockSize) {
  var kernings = []
  var count = blockSize / 10
  for (var c=0; c<count; c++) {
    var kern = {}
    var off = c*10
    kern.first = buf.readUInt32LE(i + 0 + off)
    kern.second = buf.readUInt32LE(i + 4 + off)
    kern.amount = buf.readInt16LE(i + 8 + off)
    kernings[c] = kern
  }
  return kernings
}

function readNameNT(buf, offset) {
  var pos=offset
  for (; pos<buf.length; pos++) {
    if (buf[pos] === 0x00) 
      break
  }
  return buf.slice(offset, pos)
}

function readStringNT(buf, offset) {
  return readNameNT(buf, offset).toString('utf8')
}
},{}],31:[function(_dereq_,module,exports){
var parseAttributes = _dereq_('./parse-attribs')
var parseFromString = _dereq_('xml-parse-from-string')

//In some cases element.attribute.nodeName can return
//all lowercase values.. so we need to map them to the correct 
//case
var NAME_MAP = {
  scaleh: 'scaleH',
  scalew: 'scaleW',
  stretchh: 'stretchH',
  lineheight: 'lineHeight',
  alphachnl: 'alphaChnl',
  redchnl: 'redChnl',
  greenchnl: 'greenChnl',
  bluechnl: 'blueChnl'
}

module.exports = function parse(data) {
  data = data.toString()
  
  var xmlRoot = parseFromString(data)
  var output = {
    pages: [],
    chars: [],
    kernings: []
  }

  //get config settings
  ;['info', 'common'].forEach(function(key) {
    var element = xmlRoot.getElementsByTagName(key)[0]
    if (element)
      output[key] = parseAttributes(getAttribs(element))
  })

  //get page info
  var pageRoot = xmlRoot.getElementsByTagName('pages')[0]
  if (!pageRoot)
    throw new Error('malformed file -- no <pages> element')
  var pages = pageRoot.getElementsByTagName('page')
  for (var i=0; i<pages.length; i++) {
    var p = pages[i]
    var id = parseInt(p.getAttribute('id'), 10)
    var file = p.getAttribute('file')
    if (isNaN(id))
      throw new Error('malformed file -- page "id" attribute is NaN')
    if (!file)
      throw new Error('malformed file -- needs page "file" attribute')
    output.pages[parseInt(id, 10)] = file
  }

  //get kernings / chars
  ;['chars', 'kernings'].forEach(function(key) {
    var element = xmlRoot.getElementsByTagName(key)[0]
    if (!element)
      return
    var childTag = key.substring(0, key.length-1)
    var children = element.getElementsByTagName(childTag)
    for (var i=0; i<children.length; i++) {      
      var child = children[i]
      output[key].push(parseAttributes(getAttribs(child)))
    }
  })
  return output
}

function getAttribs(element) {
  var attribs = getAttribList(element)
  return attribs.reduce(function(dict, attrib) {
    var key = mapName(attrib.nodeName)
    dict[key] = attrib.nodeValue
    return dict
  }, {})
}

function getAttribList(element) {
  //IE8+ and modern browsers
  var attribs = []
  for (var i=0; i<element.attributes.length; i++)
    attribs.push(element.attributes[i])
  return attribs
}

function mapName(nodeName) {
  return NAME_MAP[nodeName.toLowerCase()] || nodeName
}
},{"./parse-attribs":32,"xml-parse-from-string":53}],32:[function(_dereq_,module,exports){
//Some versions of GlyphDesigner have a typo
//that causes some bugs with parsing. 
//Need to confirm with recent version of the software
//to see whether this is still an issue or not.
var GLYPH_DESIGNER_ERROR = 'chasrset'

module.exports = function parseAttributes(obj) {
  if (GLYPH_DESIGNER_ERROR in obj) {
    obj['charset'] = obj[GLYPH_DESIGNER_ERROR]
    delete obj[GLYPH_DESIGNER_ERROR]
  }

  for (var k in obj) {
    if (k === 'face' || k === 'charset') 
      continue
    else if (k === 'padding' || k === 'spacing')
      obj[k] = parseIntList(obj[k])
    else
      obj[k] = parseInt(obj[k], 10) 
  }
  return obj
}

function parseIntList(data) {
  return data.split(',').map(function(val) {
    return parseInt(val, 10)
  })
}
},{}],33:[function(_dereq_,module,exports){
var trim = _dereq_('trim')
  , forEach = _dereq_('for-each')
  , isArray = function(arg) {
      return Object.prototype.toString.call(arg) === '[object Array]';
    }

module.exports = function (headers) {
  if (!headers)
    return {}

  var result = {}

  forEach(
      trim(headers).split('\n')
    , function (row) {
        var index = row.indexOf(':')
          , key = trim(row.slice(0, index)).toLowerCase()
          , value = trim(row.slice(index + 1))

        if (typeof(result[key]) === 'undefined') {
          result[key] = value
        } else if (isArray(result[key])) {
          result[key].push(value)
        } else {
          result[key] = [ result[key], value ]
        }
      }
  )

  return result
}
},{"for-each":19,"trim":48}],34:[function(_dereq_,module,exports){
(function (global){
var performance = global.performance || {};

var present = (function () {
  var names = ['now', 'webkitNow', 'msNow', 'mozNow', 'oNow'];
  while (names.length) {
    var name = names.shift();
    if (name in performance) {
      return performance[name].bind(performance);
    }
  }

  var dateNow = Date.now || function () { return new Date().getTime(); };
  var navigationStart = (performance.timing || {}).navigationStart || dateNow();
  return function () {
    return dateNow() - navigationStart;
  };
}());

present.performanceNow = performance.now;
present.noConflict = function () {
  performance.now = present.performanceNow;
};
present.conflict = function () {
  performance.now = present;
};
present.conflict();

module.exports = present;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],35:[function(_dereq_,module,exports){
(function(root) {

	// Store setTimeout reference so promise-polyfill will be unaffected by
	// other code modifying setTimeout (like sinon.useFakeTimers())
	var setTimeoutFunc = setTimeout;

	// Use polyfill for setImmediate for performance gains
	var asap = (typeof setImmediate === 'function' && setImmediate) ||
		function(fn) { setTimeoutFunc(fn, 1); };

	// Polyfill for Function.prototype.bind
	function bind(fn, thisArg) {
		return function() {
			fn.apply(thisArg, arguments);
		}
	}

	var isArray = Array.isArray || function(value) { return Object.prototype.toString.call(value) === "[object Array]" };

	function Promise(fn) {
		if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
		if (typeof fn !== 'function') throw new TypeError('not a function');
		this._state = null;
		this._value = null;
		this._deferreds = []

		doResolve(fn, bind(resolve, this), bind(reject, this))
	}

	function handle(deferred) {
		var me = this;
		if (this._state === null) {
			this._deferreds.push(deferred);
			return
		}
		asap(function() {
			var cb = me._state ? deferred.onFulfilled : deferred.onRejected
			if (cb === null) {
				(me._state ? deferred.resolve : deferred.reject)(me._value);
				return;
			}
			var ret;
			try {
				ret = cb(me._value);
			}
			catch (e) {
				deferred.reject(e);
				return;
			}
			deferred.resolve(ret);
		})
	}

	function resolve(newValue) {
		try { //Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
			if (newValue === this) throw new TypeError('A promise cannot be resolved with itself.');
			if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
				var then = newValue.then;
				if (typeof then === 'function') {
					doResolve(bind(then, newValue), bind(resolve, this), bind(reject, this));
					return;
				}
			}
			this._state = true;
			this._value = newValue;
			finale.call(this);
		} catch (e) { reject.call(this, e); }
	}

	function reject(newValue) {
		this._state = false;
		this._value = newValue;
		finale.call(this);
	}

	function finale() {
		for (var i = 0, len = this._deferreds.length; i < len; i++) {
			handle.call(this, this._deferreds[i]);
		}
		this._deferreds = null;
	}

	function Handler(onFulfilled, onRejected, resolve, reject){
		this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
		this.onRejected = typeof onRejected === 'function' ? onRejected : null;
		this.resolve = resolve;
		this.reject = reject;
	}

	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, onFulfilled, onRejected) {
		var done = false;
		try {
			fn(function (value) {
				if (done) return;
				done = true;
				onFulfilled(value);
			}, function (reason) {
				if (done) return;
				done = true;
				onRejected(reason);
			})
		} catch (ex) {
			if (done) return;
			done = true;
			onRejected(ex);
		}
	}

	Promise.prototype['catch'] = function (onRejected) {
		return this.then(null, onRejected);
	};

	Promise.prototype.then = function(onFulfilled, onRejected) {
		var me = this;
		return new Promise(function(resolve, reject) {
			handle.call(me, new Handler(onFulfilled, onRejected, resolve, reject));
		})
	};

	Promise.all = function () {
		var args = Array.prototype.slice.call(arguments.length === 1 && isArray(arguments[0]) ? arguments[0] : arguments);

		return new Promise(function (resolve, reject) {
			if (args.length === 0) return resolve([]);
			var remaining = args.length;
			function res(i, val) {
				try {
					if (val && (typeof val === 'object' || typeof val === 'function')) {
						var then = val.then;
						if (typeof then === 'function') {
							then.call(val, function (val) { res(i, val) }, reject);
							return;
						}
					}
					args[i] = val;
					if (--remaining === 0) {
						resolve(args);
					}
				} catch (ex) {
					reject(ex);
				}
			}
			for (var i = 0; i < args.length; i++) {
				res(i, args[i]);
			}
		});
	};

	Promise.resolve = function (value) {
		if (value && typeof value === 'object' && value.constructor === Promise) {
			return value;
		}

		return new Promise(function (resolve) {
			resolve(value);
		});
	};

	Promise.reject = function (value) {
		return new Promise(function (resolve, reject) {
			reject(value);
		});
	};

	Promise.race = function (values) {
		return new Promise(function (resolve, reject) {
			for(var i = 0, len = values.length; i < len; i++) {
				values[i].then(resolve, reject);
			}
		});
	};

	/**
	 * Set the immediate function to execute callbacks
	 * @param fn {function} Function to execute
	 * @private
	 */
	Promise._setImmediateFn = function _setImmediateFn(fn) {
		asap = fn;
	};

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = Promise;
	} else if (!root.Promise) {
		root.Promise = Promise;
	}

})(this);

},{}],36:[function(_dereq_,module,exports){
var dtype = _dereq_('dtype')
var anArray = _dereq_('an-array')
var isBuffer = _dereq_('is-buffer')

var CW = [0, 2, 3]
var CCW = [2, 1, 3]

module.exports = function createQuadElements(array, opt) {
    //if user didn't specify an output array
    if (!array || !(anArray(array) || isBuffer(array))) {
        opt = array || {}
        array = null
    }

    if (typeof opt === 'number') //backwards-compatible
        opt = { count: opt }
    else
        opt = opt || {}

    var type = typeof opt.type === 'string' ? opt.type : 'uint16'
    var count = typeof opt.count === 'number' ? opt.count : 1
    var start = (opt.start || 0) 

    var dir = opt.clockwise !== false ? CW : CCW,
        a = dir[0], 
        b = dir[1],
        c = dir[2]

    var numIndices = count * 6

    var indices = array || new (dtype(type))(numIndices)
    for (var i = 0, j = 0; i < numIndices; i += 6, j += 4) {
        var x = i + start
        indices[x + 0] = j + 0
        indices[x + 1] = j + 1
        indices[x + 2] = j + 2
        indices[x + 3] = j + a
        indices[x + 4] = j + b
        indices[x + 5] = j + c
    }
    return indices
}
},{"an-array":1,"dtype":17,"is-buffer":23}],37:[function(_dereq_,module,exports){


/*:: type Attr = { [key: string]: string } */

/*

style-attr
====

Very simple parsing and stringifying of style attributes.

`parse`
----

Convert a style attribute string to an object.

*/

/*:: declare function parse (raw: string): Attr */
function parse(raw) {
  var trim = function (s) {
    return s.trim();
  };
  var obj = {};

  getKeyValueChunks(raw).map(trim).filter(Boolean).forEach(function (item) {
    // split with `.indexOf` rather than `.split` because the value may also contain colons.
    var pos = item.indexOf(':');
    var key = item.substr(0, pos).trim();
    var val = item.substr(pos + 1).trim();

    obj[key] = val;
  });

  return obj;
}

/*

`getKeyValueChunks`
----

Split a string into chunks matching `<key>: <value>`

*/
/*:: declare function getKeyValueChunks (raw: string): Array<string> */
function getKeyValueChunks(raw) {
  var chunks = [];
  var offset = 0;
  var sep = ';';
  var hasUnclosedUrl = /url\([^\)]+$/;
  var chunk = '';
  var nextSplit;
  while (offset < raw.length) {
    nextSplit = raw.indexOf(sep, offset);
    if (nextSplit === -1) {
      nextSplit = raw.length;
    }

    chunk += raw.substring(offset, nextSplit);

    // data URIs can contain semicolons, so make sure we get the whole thing
    if (hasUnclosedUrl.test(chunk)) {
      chunk += ';';
      offset = nextSplit + 1;
      continue;
    }

    chunks.push(chunk);
    chunk = '';
    offset = nextSplit + 1;
  }

  return chunks;
}

/*

`stringify`
----

Convert an object into an attribute string

*/
/*:: declare function stringify (obj: Attr): string */
function stringify(obj) {
  return Object.keys(obj).map(function (key) {
    return key + ':' + obj[key];
  }).join(';');
}

/*

`normalize`
----

Normalize an attribute string (eg. collapse duplicates)

*/
/*:: declare function normalize (str: string): string */
function normalize(str) {
  return stringify(parse(str));
}

module.exports.parse = parse;
module.exports.stringify = stringify;
module.exports.normalize = normalize;
},{}],38:[function(_dereq_,module,exports){
var createLayout = _dereq_('layout-bmfont-text')
var inherits = _dereq_('inherits')
var createIndices = _dereq_('quad-indices')
var buffer = _dereq_('three-buffer-vertex-data')
var assign = _dereq_('object-assign')

var vertices = _dereq_('./lib/vertices')
var utils = _dereq_('./lib/utils')

var Base = THREE.BufferGeometry

module.exports = function createTextGeometry (opt) {
  return new TextGeometry(opt)
}

function TextGeometry (opt) {
  Base.call(this)

  if (typeof opt === 'string') {
    opt = { text: opt }
  }

  // use these as default values for any subsequent
  // calls to update()
  this._opt = assign({}, opt)

  // also do an initial setup...
  if (opt) this.update(opt)
}

inherits(TextGeometry, Base)

TextGeometry.prototype.update = function (opt) {
  if (typeof opt === 'string') {
    opt = { text: opt }
  }

  // use constructor defaults
  opt = assign({}, this._opt, opt)

  if (!opt.font) {
    throw new TypeError('must specify a { font } in options')
  }

  this.layout = createLayout(opt)

  // get vec2 texcoords
  var flipY = opt.flipY !== false

  // the desired BMFont data
  var font = opt.font

  // determine texture size from font file
  var texWidth = font.common.scaleW
  var texHeight = font.common.scaleH

  // get visible glyphs
  var glyphs = this.layout.glyphs.filter(function (glyph) {
    var bitmap = glyph.data
    return bitmap.width * bitmap.height > 0
  })

  // provide visible glyphs for convenience
  this.visibleGlyphs = glyphs

  // get common vertex data
  var positions = vertices.positions(glyphs)
  var uvs = vertices.uvs(glyphs, texWidth, texHeight, flipY)
  var indices = createIndices({
    clockwise: true,
    type: 'uint16',
    count: glyphs.length
  })

  // update vertex data
  buffer.index(this, indices, 1, 'uint16')
  buffer.attr(this, 'position', positions, 2)
  buffer.attr(this, 'uv', uvs, 2)

  // update multipage data
  if (!opt.multipage && 'page' in this.attributes) {
    // disable multipage rendering
    this.removeAttribute('page')
  } else if (opt.multipage) {
    var pages = vertices.pages(glyphs)
    // enable multipage rendering
    buffer.attr(this, 'page', pages, 1)
  }
}

TextGeometry.prototype.computeBoundingSphere = function () {
  if (this.boundingSphere === null) {
    this.boundingSphere = new THREE.Sphere()
  }

  var positions = this.attributes.position.array
  var itemSize = this.attributes.position.itemSize
  if (!positions || !itemSize || positions.length < 2) {
    this.boundingSphere.radius = 0
    this.boundingSphere.center.set(0, 0, 0)
    return
  }
  utils.computeSphere(positions, this.boundingSphere)
  if (isNaN(this.boundingSphere.radius)) {
    console.error('THREE.BufferGeometry.computeBoundingSphere(): ' +
      'Computed radius is NaN. The ' +
      '"position" attribute is likely to have NaN values.')
  }
}

TextGeometry.prototype.computeBoundingBox = function () {
  if (this.boundingBox === null) {
    this.boundingBox = new THREE.Box3()
  }

  var bbox = this.boundingBox
  var positions = this.attributes.position.array
  var itemSize = this.attributes.position.itemSize
  if (!positions || !itemSize || positions.length < 2) {
    bbox.makeEmpty()
    return
  }
  utils.computeBox(positions, bbox)
}

},{"./lib/utils":39,"./lib/vertices":40,"inherits":22,"layout-bmfont-text":25,"object-assign":28,"quad-indices":36,"three-buffer-vertex-data":41}],39:[function(_dereq_,module,exports){
var itemSize = 2
var box = { min: [0, 0], max: [0, 0] }

function bounds (positions) {
  var count = positions.length / itemSize
  box.min[0] = positions[0]
  box.min[1] = positions[1]
  box.max[0] = positions[0]
  box.max[1] = positions[1]

  for (var i = 0; i < count; i++) {
    var x = positions[i * itemSize + 0]
    var y = positions[i * itemSize + 1]
    box.min[0] = Math.min(x, box.min[0])
    box.min[1] = Math.min(y, box.min[1])
    box.max[0] = Math.max(x, box.max[0])
    box.max[1] = Math.max(y, box.max[1])
  }
}

module.exports.computeBox = function (positions, output) {
  bounds(positions)
  output.min.set(box.min[0], box.min[1], 0)
  output.max.set(box.max[0], box.max[1], 0)
}

module.exports.computeSphere = function (positions, output) {
  bounds(positions)
  var minX = box.min[0]
  var minY = box.min[1]
  var maxX = box.max[0]
  var maxY = box.max[1]
  var width = maxX - minX
  var height = maxY - minY
  var length = Math.sqrt(width * width + height * height)
  output.center.set(minX + width / 2, minY + height / 2, 0)
  output.radius = length / 2
}

},{}],40:[function(_dereq_,module,exports){
module.exports.pages = function pages (glyphs) {
  var pages = new Float32Array(glyphs.length * 4 * 1)
  var i = 0
  glyphs.forEach(function (glyph) {
    var id = glyph.data.page || 0
    pages[i++] = id
    pages[i++] = id
    pages[i++] = id
    pages[i++] = id
  })
  return pages
}

module.exports.uvs = function uvs (glyphs, texWidth, texHeight, flipY) {
  var uvs = new Float32Array(glyphs.length * 4 * 2)
  var i = 0
  glyphs.forEach(function (glyph) {
    var bitmap = glyph.data
    var bw = (bitmap.x + bitmap.width)
    var bh = (bitmap.y + bitmap.height)

    // top left position
    var u0 = bitmap.x / texWidth
    var v1 = bitmap.y / texHeight
    var u1 = bw / texWidth
    var v0 = bh / texHeight

    if (flipY) {
      v1 = (texHeight - bitmap.y) / texHeight
      v0 = (texHeight - bh) / texHeight
    }

    // BL
    uvs[i++] = u0
    uvs[i++] = v1
    // TL
    uvs[i++] = u0
    uvs[i++] = v0
    // TR
    uvs[i++] = u1
    uvs[i++] = v0
    // BR
    uvs[i++] = u1
    uvs[i++] = v1
  })
  return uvs
}

module.exports.positions = function positions (glyphs) {
  var positions = new Float32Array(glyphs.length * 4 * 2)
  var i = 0
  glyphs.forEach(function (glyph) {
    var bitmap = glyph.data

    // bottom left position
    var x = glyph.position[0] + bitmap.xoffset
    var y = glyph.position[1] + bitmap.yoffset

    // quad size
    var w = bitmap.width
    var h = bitmap.height

    // BL
    positions[i++] = x
    positions[i++] = y
    // TL
    positions[i++] = x
    positions[i++] = y + h
    // TR
    positions[i++] = x + w
    positions[i++] = y + h
    // BR
    positions[i++] = x + w
    positions[i++] = y
  })
  return positions
}

},{}],41:[function(_dereq_,module,exports){
var flatten = _dereq_('flatten-vertex-data')
var warned = false;

module.exports.attr = setAttribute
module.exports.index = setIndex

function setIndex (geometry, data, itemSize, dtype) {
  if (typeof itemSize !== 'number') itemSize = 1
  if (typeof dtype !== 'string') dtype = 'uint16'

  var isR69 = !geometry.index && typeof geometry.setIndex !== 'function'
  var attrib = isR69 ? geometry.getAttribute('index') : geometry.index
  var newAttrib = updateAttribute(attrib, data, itemSize, dtype)
  if (newAttrib) {
    if (isR69) geometry.addAttribute('index', newAttrib)
    else geometry.index = newAttrib
  }
}

function setAttribute (geometry, key, data, itemSize, dtype) {
  if (typeof itemSize !== 'number') itemSize = 3
  if (typeof dtype !== 'string') dtype = 'float32'
  if (Array.isArray(data) &&
    Array.isArray(data[0]) &&
    data[0].length !== itemSize) {
    throw new Error('Nested vertex array has unexpected size; expected ' +
      itemSize + ' but found ' + data[0].length)
  }

  var attrib = geometry.getAttribute(key)
  var newAttrib = updateAttribute(attrib, data, itemSize, dtype)
  if (newAttrib) {
    geometry.addAttribute(key, newAttrib)
  }
}

function updateAttribute (attrib, data, itemSize, dtype) {
  data = data || []
  if (!attrib || rebuildAttribute(attrib, data, itemSize)) {
    // create a new array with desired type
    data = flatten(data, dtype)

    var needsNewBuffer = attrib && typeof attrib.setArray !== 'function'
    if (!attrib || needsNewBuffer) {
      // We are on an old version of ThreeJS which can't
      // support growing / shrinking buffers, so we need
      // to build a new buffer
      if (needsNewBuffer && !warned) {
        warned = true
        console.warn([
          'A WebGL buffer is being updated with a new size or itemSize, ',
          'however this version of ThreeJS only supports fixed-size buffers.',
          '\nThe old buffer may still be kept in memory.\n',
          'To avoid memory leaks, it is recommended that you dispose ',
          'your geometries and create new ones, or update to ThreeJS r82 or newer.\n',
          'See here for discussion:\n',
          'https://github.com/mrdoob/three.js/pull/9631'
        ].join(''))
      }

      // Build a new attribute
      attrib = new THREE.BufferAttribute(data, itemSize);
    }

    attrib.itemSize = itemSize
    attrib.needsUpdate = true

    // New versions of ThreeJS suggest using setArray
    // to change the data. It will use bufferData internally,
    // so you can change the array size without any issues
    if (typeof attrib.setArray === 'function') {
      attrib.setArray(data)
    }

    return attrib
  } else {
    // copy data into the existing array
    flatten(data, attrib.array)
    attrib.needsUpdate = true
    return null
  }
}

// Test whether the attribute needs to be re-created,
// returns false if we can re-use it as-is.
function rebuildAttribute (attrib, data, itemSize) {
  if (attrib.itemSize !== itemSize) return true
  if (!attrib.array) return true
  var attribLength = attrib.array.length
  if (Array.isArray(data) && Array.isArray(data[0])) {
    // [ [ x, y, z ] ]
    return attribLength !== data.length * itemSize
  } else {
    // [ x, y, z ]
    return attribLength !== data.length
  }
  return false
}

},{"flatten-vertex-data":18}],42:[function(_dereq_,module,exports){
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.THREE = global.THREE || {})));
}(this, (function (exports) { 'use strict';

	// Polyfills

	if ( Number.EPSILON === undefined ) {

		Number.EPSILON = Math.pow( 2, - 52 );

	}

	//

	if ( Math.sign === undefined ) {

		// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign

		Math.sign = function ( x ) {

			return ( x < 0 ) ? - 1 : ( x > 0 ) ? 1 : + x;

		};

	}

	if ( Function.prototype.name === undefined ) {

		// Missing in IE9-11.
		// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/name

		Object.defineProperty( Function.prototype, 'name', {

			get: function () {

				return this.toString().match( /^\s*function\s*([^\(\s]*)/ )[ 1 ];

			}

		} );

	}

	if ( Object.assign === undefined ) {

		// Missing in IE.
		// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign

		( function () {

			Object.assign = function ( target ) {

				'use strict';

				if ( target === undefined || target === null ) {

					throw new TypeError( 'Cannot convert undefined or null to object' );

				}

				var output = Object( target );

				for ( var index = 1; index < arguments.length; index ++ ) {

					var source = arguments[ index ];

					if ( source !== undefined && source !== null ) {

						for ( var nextKey in source ) {

							if ( Object.prototype.hasOwnProperty.call( source, nextKey ) ) {

								output[ nextKey ] = source[ nextKey ];

							}

						}

					}

				}

				return output;

			};

		} )();

	}

	/**
	 * https://github.com/mrdoob/eventdispatcher.js/
	 */

	function EventDispatcher() {}

	Object.assign( EventDispatcher.prototype, {

		addEventListener: function ( type, listener ) {

			if ( this._listeners === undefined ) this._listeners = {};

			var listeners = this._listeners;

			if ( listeners[ type ] === undefined ) {

				listeners[ type ] = [];

			}

			if ( listeners[ type ].indexOf( listener ) === - 1 ) {

				listeners[ type ].push( listener );

			}

		},

		hasEventListener: function ( type, listener ) {

			if ( this._listeners === undefined ) return false;

			var listeners = this._listeners;

			return listeners[ type ] !== undefined && listeners[ type ].indexOf( listener ) !== - 1;

		},

		removeEventListener: function ( type, listener ) {

			if ( this._listeners === undefined ) return;

			var listeners = this._listeners;
			var listenerArray = listeners[ type ];

			if ( listenerArray !== undefined ) {

				var index = listenerArray.indexOf( listener );

				if ( index !== - 1 ) {

					listenerArray.splice( index, 1 );

				}

			}

		},

		dispatchEvent: function ( event ) {

			if ( this._listeners === undefined ) return;

			var listeners = this._listeners;
			var listenerArray = listeners[ event.type ];

			if ( listenerArray !== undefined ) {

				event.target = this;

				var array = [], i = 0;
				var length = listenerArray.length;

				for ( i = 0; i < length; i ++ ) {

					array[ i ] = listenerArray[ i ];

				}

				for ( i = 0; i < length; i ++ ) {

					array[ i ].call( this, event );

				}

			}

		}

	} );

	var REVISION = '83';
	var MOUSE = { LEFT: 0, MIDDLE: 1, RIGHT: 2 };
	var CullFaceNone = 0;
	var CullFaceBack = 1;
	var CullFaceFront = 2;
	var CullFaceFrontBack = 3;
	var FrontFaceDirectionCW = 0;
	var FrontFaceDirectionCCW = 1;
	var BasicShadowMap = 0;
	var PCFShadowMap = 1;
	var PCFSoftShadowMap = 2;
	var FrontSide = 0;
	var BackSide = 1;
	var DoubleSide = 2;
	var FlatShading = 1;
	var SmoothShading = 2;
	var NoColors = 0;
	var FaceColors = 1;
	var VertexColors = 2;
	var NoBlending = 0;
	var NormalBlending = 1;
	var AdditiveBlending = 2;
	var SubtractiveBlending = 3;
	var MultiplyBlending = 4;
	var CustomBlending = 5;
	var BlendingMode = {
		NoBlending: NoBlending,
		NormalBlending: NormalBlending,
		AdditiveBlending: AdditiveBlending,
		SubtractiveBlending: SubtractiveBlending,
		MultiplyBlending: MultiplyBlending,
		CustomBlending: CustomBlending
	};
	var AddEquation = 100;
	var SubtractEquation = 101;
	var ReverseSubtractEquation = 102;
	var MinEquation = 103;
	var MaxEquation = 104;
	var ZeroFactor = 200;
	var OneFactor = 201;
	var SrcColorFactor = 202;
	var OneMinusSrcColorFactor = 203;
	var SrcAlphaFactor = 204;
	var OneMinusSrcAlphaFactor = 205;
	var DstAlphaFactor = 206;
	var OneMinusDstAlphaFactor = 207;
	var DstColorFactor = 208;
	var OneMinusDstColorFactor = 209;
	var SrcAlphaSaturateFactor = 210;
	var NeverDepth = 0;
	var AlwaysDepth = 1;
	var LessDepth = 2;
	var LessEqualDepth = 3;
	var EqualDepth = 4;
	var GreaterEqualDepth = 5;
	var GreaterDepth = 6;
	var NotEqualDepth = 7;
	var MultiplyOperation = 0;
	var MixOperation = 1;
	var AddOperation = 2;
	var NoToneMapping = 0;
	var LinearToneMapping = 1;
	var ReinhardToneMapping = 2;
	var Uncharted2ToneMapping = 3;
	var CineonToneMapping = 4;
	var UVMapping = 300;
	var CubeReflectionMapping = 301;
	var CubeRefractionMapping = 302;
	var EquirectangularReflectionMapping = 303;
	var EquirectangularRefractionMapping = 304;
	var SphericalReflectionMapping = 305;
	var CubeUVReflectionMapping = 306;
	var CubeUVRefractionMapping = 307;
	var TextureMapping = {
		UVMapping: UVMapping,
		CubeReflectionMapping: CubeReflectionMapping,
		CubeRefractionMapping: CubeRefractionMapping,
		EquirectangularReflectionMapping: EquirectangularReflectionMapping,
		EquirectangularRefractionMapping: EquirectangularRefractionMapping,
		SphericalReflectionMapping: SphericalReflectionMapping,
		CubeUVReflectionMapping: CubeUVReflectionMapping,
		CubeUVRefractionMapping: CubeUVRefractionMapping
	};
	var RepeatWrapping = 1000;
	var ClampToEdgeWrapping = 1001;
	var MirroredRepeatWrapping = 1002;
	var TextureWrapping = {
		RepeatWrapping: RepeatWrapping,
		ClampToEdgeWrapping: ClampToEdgeWrapping,
		MirroredRepeatWrapping: MirroredRepeatWrapping
	};
	var NearestFilter = 1003;
	var NearestMipMapNearestFilter = 1004;
	var NearestMipMapLinearFilter = 1005;
	var LinearFilter = 1006;
	var LinearMipMapNearestFilter = 1007;
	var LinearMipMapLinearFilter = 1008;
	var TextureFilter = {
		NearestFilter: NearestFilter,
		NearestMipMapNearestFilter: NearestMipMapNearestFilter,
		NearestMipMapLinearFilter: NearestMipMapLinearFilter,
		LinearFilter: LinearFilter,
		LinearMipMapNearestFilter: LinearMipMapNearestFilter,
		LinearMipMapLinearFilter: LinearMipMapLinearFilter
	};
	var UnsignedByteType = 1009;
	var ByteType = 1010;
	var ShortType = 1011;
	var UnsignedShortType = 1012;
	var IntType = 1013;
	var UnsignedIntType = 1014;
	var FloatType = 1015;
	var HalfFloatType = 1016;
	var UnsignedShort4444Type = 1017;
	var UnsignedShort5551Type = 1018;
	var UnsignedShort565Type = 1019;
	var UnsignedInt248Type = 1020;
	var AlphaFormat = 1021;
	var RGBFormat = 1022;
	var RGBAFormat = 1023;
	var LuminanceFormat = 1024;
	var LuminanceAlphaFormat = 1025;
	var RGBEFormat = RGBAFormat;
	var DepthFormat = 1026;
	var DepthStencilFormat = 1027;
	var RGB_S3TC_DXT1_Format = 2001;
	var RGBA_S3TC_DXT1_Format = 2002;
	var RGBA_S3TC_DXT3_Format = 2003;
	var RGBA_S3TC_DXT5_Format = 2004;
	var RGB_PVRTC_4BPPV1_Format = 2100;
	var RGB_PVRTC_2BPPV1_Format = 2101;
	var RGBA_PVRTC_4BPPV1_Format = 2102;
	var RGBA_PVRTC_2BPPV1_Format = 2103;
	var RGB_ETC1_Format = 2151;
	var LoopOnce = 2200;
	var LoopRepeat = 2201;
	var LoopPingPong = 2202;
	var InterpolateDiscrete = 2300;
	var InterpolateLinear = 2301;
	var InterpolateSmooth = 2302;
	var ZeroCurvatureEnding = 2400;
	var ZeroSlopeEnding = 2401;
	var WrapAroundEnding = 2402;
	var TrianglesDrawMode = 0;
	var TriangleStripDrawMode = 1;
	var TriangleFanDrawMode = 2;
	var LinearEncoding = 3000;
	var sRGBEncoding = 3001;
	var GammaEncoding = 3007;
	var RGBEEncoding = 3002;
	var LogLuvEncoding = 3003;
	var RGBM7Encoding = 3004;
	var RGBM16Encoding = 3005;
	var RGBDEncoding = 3006;
	var BasicDepthPacking = 3200;
	var RGBADepthPacking = 3201;

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author mrdoob / http://mrdoob.com/
	 */

	var _Math = {

		DEG2RAD: Math.PI / 180,
		RAD2DEG: 180 / Math.PI,

		generateUUID: function () {

			// http://www.broofa.com/Tools/Math.uuid.htm

			var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split( '' );
			var uuid = new Array( 36 );
			var rnd = 0, r;

			return function generateUUID() {

				for ( var i = 0; i < 36; i ++ ) {

					if ( i === 8 || i === 13 || i === 18 || i === 23 ) {

						uuid[ i ] = '-';

					} else if ( i === 14 ) {

						uuid[ i ] = '4';

					} else {

						if ( rnd <= 0x02 ) rnd = 0x2000000 + ( Math.random() * 0x1000000 ) | 0;
						r = rnd & 0xf;
						rnd = rnd >> 4;
						uuid[ i ] = chars[ ( i === 19 ) ? ( r & 0x3 ) | 0x8 : r ];

					}

				}

				return uuid.join( '' );

			};

		}(),

		clamp: function ( value, min, max ) {

			return Math.max( min, Math.min( max, value ) );

		},

		// compute euclidian modulo of m % n
		// https://en.wikipedia.org/wiki/Modulo_operation

		euclideanModulo: function ( n, m ) {

			return ( ( n % m ) + m ) % m;

		},

		// Linear mapping from range <a1, a2> to range <b1, b2>

		mapLinear: function ( x, a1, a2, b1, b2 ) {

			return b1 + ( x - a1 ) * ( b2 - b1 ) / ( a2 - a1 );

		},

		// https://en.wikipedia.org/wiki/Linear_interpolation

		lerp: function ( x, y, t ) {

			return ( 1 - t ) * x + t * y;

		},

		// http://en.wikipedia.org/wiki/Smoothstep

		smoothstep: function ( x, min, max ) {

			if ( x <= min ) return 0;
			if ( x >= max ) return 1;

			x = ( x - min ) / ( max - min );

			return x * x * ( 3 - 2 * x );

		},

		smootherstep: function ( x, min, max ) {

			if ( x <= min ) return 0;
			if ( x >= max ) return 1;

			x = ( x - min ) / ( max - min );

			return x * x * x * ( x * ( x * 6 - 15 ) + 10 );

		},

		// Random integer from <low, high> interval

		randInt: function ( low, high ) {

			return low + Math.floor( Math.random() * ( high - low + 1 ) );

		},

		// Random float from <low, high> interval

		randFloat: function ( low, high ) {

			return low + Math.random() * ( high - low );

		},

		// Random float from <-range/2, range/2> interval

		randFloatSpread: function ( range ) {

			return range * ( 0.5 - Math.random() );

		},

		degToRad: function ( degrees ) {

			return degrees * _Math.DEG2RAD;

		},

		radToDeg: function ( radians ) {

			return radians * _Math.RAD2DEG;

		},

		isPowerOfTwo: function ( value ) {

			return ( value & ( value - 1 ) ) === 0 && value !== 0;

		},

		nearestPowerOfTwo: function ( value ) {

			return Math.pow( 2, Math.round( Math.log( value ) / Math.LN2 ) );

		},

		nextPowerOfTwo: function ( value ) {

			value --;
			value |= value >> 1;
			value |= value >> 2;
			value |= value >> 4;
			value |= value >> 8;
			value |= value >> 16;
			value ++;

			return value;

		}

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author philogb / http://blog.thejit.org/
	 * @author egraether / http://egraether.com/
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 */

	function Vector2( x, y ) {

		this.x = x || 0;
		this.y = y || 0;

	}

	Vector2.prototype = {

		constructor: Vector2,

		isVector2: true,

		get width() {

			return this.x;

		},

		set width( value ) {

			this.x = value;

		},

		get height() {

			return this.y;

		},

		set height( value ) {

			this.y = value;

		},

		//

		set: function ( x, y ) {

			this.x = x;
			this.y = y;

			return this;

		},

		setScalar: function ( scalar ) {

			this.x = scalar;
			this.y = scalar;

			return this;

		},

		setX: function ( x ) {

			this.x = x;

			return this;

		},

		setY: function ( y ) {

			this.y = y;

			return this;

		},

		setComponent: function ( index, value ) {

			switch ( index ) {

				case 0: this.x = value; break;
				case 1: this.y = value; break;
				default: throw new Error( 'index is out of range: ' + index );

			}

			return this;

		},

		getComponent: function ( index ) {

			switch ( index ) {

				case 0: return this.x;
				case 1: return this.y;
				default: throw new Error( 'index is out of range: ' + index );

			}

		},

		clone: function () {

			return new this.constructor( this.x, this.y );

		},

		copy: function ( v ) {

			this.x = v.x;
			this.y = v.y;

			return this;

		},

		add: function ( v, w ) {

			if ( w !== undefined ) {

				console.warn( 'THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
				return this.addVectors( v, w );

			}

			this.x += v.x;
			this.y += v.y;

			return this;

		},

		addScalar: function ( s ) {

			this.x += s;
			this.y += s;

			return this;

		},

		addVectors: function ( a, b ) {

			this.x = a.x + b.x;
			this.y = a.y + b.y;

			return this;

		},

		addScaledVector: function ( v, s ) {

			this.x += v.x * s;
			this.y += v.y * s;

			return this;

		},

		sub: function ( v, w ) {

			if ( w !== undefined ) {

				console.warn( 'THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
				return this.subVectors( v, w );

			}

			this.x -= v.x;
			this.y -= v.y;

			return this;

		},

		subScalar: function ( s ) {

			this.x -= s;
			this.y -= s;

			return this;

		},

		subVectors: function ( a, b ) {

			this.x = a.x - b.x;
			this.y = a.y - b.y;

			return this;

		},

		multiply: function ( v ) {

			this.x *= v.x;
			this.y *= v.y;

			return this;

		},

		multiplyScalar: function ( scalar ) {

			if ( isFinite( scalar ) ) {

				this.x *= scalar;
				this.y *= scalar;

			} else {

				this.x = 0;
				this.y = 0;

			}

			return this;

		},

		divide: function ( v ) {

			this.x /= v.x;
			this.y /= v.y;

			return this;

		},

		divideScalar: function ( scalar ) {

			return this.multiplyScalar( 1 / scalar );

		},

		min: function ( v ) {

			this.x = Math.min( this.x, v.x );
			this.y = Math.min( this.y, v.y );

			return this;

		},

		max: function ( v ) {

			this.x = Math.max( this.x, v.x );
			this.y = Math.max( this.y, v.y );

			return this;

		},

		clamp: function ( min, max ) {

			// This function assumes min < max, if this assumption isn't true it will not operate correctly

			this.x = Math.max( min.x, Math.min( max.x, this.x ) );
			this.y = Math.max( min.y, Math.min( max.y, this.y ) );

			return this;

		},

		clampScalar: function () {

			var min, max;

			return function clampScalar( minVal, maxVal ) {

				if ( min === undefined ) {

					min = new Vector2();
					max = new Vector2();

				}

				min.set( minVal, minVal );
				max.set( maxVal, maxVal );

				return this.clamp( min, max );

			};

		}(),

		clampLength: function ( min, max ) {

			var length = this.length();

			return this.multiplyScalar( Math.max( min, Math.min( max, length ) ) / length );

		},

		floor: function () {

			this.x = Math.floor( this.x );
			this.y = Math.floor( this.y );

			return this;

		},

		ceil: function () {

			this.x = Math.ceil( this.x );
			this.y = Math.ceil( this.y );

			return this;

		},

		round: function () {

			this.x = Math.round( this.x );
			this.y = Math.round( this.y );

			return this;

		},

		roundToZero: function () {

			this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
			this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );

			return this;

		},

		negate: function () {

			this.x = - this.x;
			this.y = - this.y;

			return this;

		},

		dot: function ( v ) {

			return this.x * v.x + this.y * v.y;

		},

		lengthSq: function () {

			return this.x * this.x + this.y * this.y;

		},

		length: function () {

			return Math.sqrt( this.x * this.x + this.y * this.y );

		},

		lengthManhattan: function() {

			return Math.abs( this.x ) + Math.abs( this.y );

		},

		normalize: function () {

			return this.divideScalar( this.length() );

		},

		angle: function () {

			// computes the angle in radians with respect to the positive x-axis

			var angle = Math.atan2( this.y, this.x );

			if ( angle < 0 ) angle += 2 * Math.PI;

			return angle;

		},

		distanceTo: function ( v ) {

			return Math.sqrt( this.distanceToSquared( v ) );

		},

		distanceToSquared: function ( v ) {

			var dx = this.x - v.x, dy = this.y - v.y;
			return dx * dx + dy * dy;

		},

		distanceToManhattan: function ( v ) {

			return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y );

		},

		setLength: function ( length ) {

			return this.multiplyScalar( length / this.length() );

		},

		lerp: function ( v, alpha ) {

			this.x += ( v.x - this.x ) * alpha;
			this.y += ( v.y - this.y ) * alpha;

			return this;

		},

		lerpVectors: function ( v1, v2, alpha ) {

			return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );

		},

		equals: function ( v ) {

			return ( ( v.x === this.x ) && ( v.y === this.y ) );

		},

		fromArray: function ( array, offset ) {

			if ( offset === undefined ) offset = 0;

			this.x = array[ offset ];
			this.y = array[ offset + 1 ];

			return this;

		},

		toArray: function ( array, offset ) {

			if ( array === undefined ) array = [];
			if ( offset === undefined ) offset = 0;

			array[ offset ] = this.x;
			array[ offset + 1 ] = this.y;

			return array;

		},

		fromAttribute: function ( attribute, index, offset ) {

			if ( offset !== undefined ) {

				console.warn( 'THREE.Vector2: offset has been removed from .fromAttribute().' );

			}

			this.x = attribute.getX( index );
			this.y = attribute.getY( index );

			return this;

		},

		rotateAround: function ( center, angle ) {

			var c = Math.cos( angle ), s = Math.sin( angle );

			var x = this.x - center.x;
			var y = this.y - center.y;

			this.x = x * c - y * s + center.x;
			this.y = x * s + y * c + center.y;

			return this;

		}

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 * @author szimek / https://github.com/szimek/
	 */

	var textureId = 0;

	function Texture( image, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding ) {

		Object.defineProperty( this, 'id', { value: textureId ++ } );

		this.uuid = _Math.generateUUID();

		this.name = '';

		this.image = image !== undefined ? image : Texture.DEFAULT_IMAGE;
		this.mipmaps = [];

		this.mapping = mapping !== undefined ? mapping : Texture.DEFAULT_MAPPING;

		this.wrapS = wrapS !== undefined ? wrapS : ClampToEdgeWrapping;
		this.wrapT = wrapT !== undefined ? wrapT : ClampToEdgeWrapping;

		this.magFilter = magFilter !== undefined ? magFilter : LinearFilter;
		this.minFilter = minFilter !== undefined ? minFilter : LinearMipMapLinearFilter;

		this.anisotropy = anisotropy !== undefined ? anisotropy : 1;

		this.format = format !== undefined ? format : RGBAFormat;
		this.type = type !== undefined ? type : UnsignedByteType;

		this.offset = new Vector2( 0, 0 );
		this.repeat = new Vector2( 1, 1 );

		this.generateMipmaps = true;
		this.premultiplyAlpha = false;
		this.flipY = true;
		this.unpackAlignment = 4;	// valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)


		// Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
		//
		// Also changing the encoding after already used by a Material will not automatically make the Material
		// update.  You need to explicitly call Material.needsUpdate to trigger it to recompile.
		this.encoding = encoding !== undefined ? encoding : LinearEncoding;

		this.version = 0;
		this.onUpdate = null;

	}

	Texture.DEFAULT_IMAGE = undefined;
	Texture.DEFAULT_MAPPING = UVMapping;

	Texture.prototype = {

		constructor: Texture,

		isTexture: true,

		set needsUpdate( value ) {

			if ( value === true ) this.version ++;

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( source ) {

			this.image = source.image;
			this.mipmaps = source.mipmaps.slice( 0 );

			this.mapping = source.mapping;

			this.wrapS = source.wrapS;
			this.wrapT = source.wrapT;

			this.magFilter = source.magFilter;
			this.minFilter = source.minFilter;

			this.anisotropy = source.anisotropy;

			this.format = source.format;
			this.type = source.type;

			this.offset.copy( source.offset );
			this.repeat.copy( source.repeat );

			this.generateMipmaps = source.generateMipmaps;
			this.premultiplyAlpha = source.premultiplyAlpha;
			this.flipY = source.flipY;
			this.unpackAlignment = source.unpackAlignment;
			this.encoding = source.encoding;

			return this;

		},

		toJSON: function ( meta ) {

			if ( meta.textures[ this.uuid ] !== undefined ) {

				return meta.textures[ this.uuid ];

			}

			function getDataURL( image ) {

				var canvas;

				if ( image.toDataURL !== undefined ) {

					canvas = image;

				} else {

					canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
					canvas.width = image.width;
					canvas.height = image.height;

					canvas.getContext( '2d' ).drawImage( image, 0, 0, image.width, image.height );

				}

				if ( canvas.width > 2048 || canvas.height > 2048 ) {

					return canvas.toDataURL( 'image/jpeg', 0.6 );

				} else {

					return canvas.toDataURL( 'image/png' );

				}

			}

			var output = {
				metadata: {
					version: 4.4,
					type: 'Texture',
					generator: 'Texture.toJSON'
				},

				uuid: this.uuid,
				name: this.name,

				mapping: this.mapping,

				repeat: [ this.repeat.x, this.repeat.y ],
				offset: [ this.offset.x, this.offset.y ],
				wrap: [ this.wrapS, this.wrapT ],

				minFilter: this.minFilter,
				magFilter: this.magFilter,
				anisotropy: this.anisotropy,

				flipY: this.flipY
			};

			if ( this.image !== undefined ) {

				// TODO: Move to THREE.Image

				var image = this.image;

				if ( image.uuid === undefined ) {

					image.uuid = _Math.generateUUID(); // UGH

				}

				if ( meta.images[ image.uuid ] === undefined ) {

					meta.images[ image.uuid ] = {
						uuid: image.uuid,
						url: getDataURL( image )
					};

				}

				output.image = image.uuid;

			}

			meta.textures[ this.uuid ] = output;

			return output;

		},

		dispose: function () {

			this.dispatchEvent( { type: 'dispose' } );

		},

		transformUv: function ( uv ) {

			if ( this.mapping !== UVMapping ) return;

			uv.multiply( this.repeat );
			uv.add( this.offset );

			if ( uv.x < 0 || uv.x > 1 ) {

				switch ( this.wrapS ) {

					case RepeatWrapping:

						uv.x = uv.x - Math.floor( uv.x );
						break;

					case ClampToEdgeWrapping:

						uv.x = uv.x < 0 ? 0 : 1;
						break;

					case MirroredRepeatWrapping:

						if ( Math.abs( Math.floor( uv.x ) % 2 ) === 1 ) {

							uv.x = Math.ceil( uv.x ) - uv.x;

						} else {

							uv.x = uv.x - Math.floor( uv.x );

						}
						break;

				}

			}

			if ( uv.y < 0 || uv.y > 1 ) {

				switch ( this.wrapT ) {

					case RepeatWrapping:

						uv.y = uv.y - Math.floor( uv.y );
						break;

					case ClampToEdgeWrapping:

						uv.y = uv.y < 0 ? 0 : 1;
						break;

					case MirroredRepeatWrapping:

						if ( Math.abs( Math.floor( uv.y ) % 2 ) === 1 ) {

							uv.y = Math.ceil( uv.y ) - uv.y;

						} else {

							uv.y = uv.y - Math.floor( uv.y );

						}
						break;

				}

			}

			if ( this.flipY ) {

				uv.y = 1 - uv.y;

			}

		}

	};

	Object.assign( Texture.prototype, EventDispatcher.prototype );

	/**
	 * @author supereggbert / http://www.paulbrunt.co.uk/
	 * @author philogb / http://blog.thejit.org/
	 * @author mikael emtinger / http://gomo.se/
	 * @author egraether / http://egraether.com/
	 * @author WestLangley / http://github.com/WestLangley
	 */

	function Vector4( x, y, z, w ) {

		this.x = x || 0;
		this.y = y || 0;
		this.z = z || 0;
		this.w = ( w !== undefined ) ? w : 1;

	}

	Vector4.prototype = {

		constructor: Vector4,

		isVector4: true,

		set: function ( x, y, z, w ) {

			this.x = x;
			this.y = y;
			this.z = z;
			this.w = w;

			return this;

		},

		setScalar: function ( scalar ) {

			this.x = scalar;
			this.y = scalar;
			this.z = scalar;
			this.w = scalar;

			return this;

		},

		setX: function ( x ) {

			this.x = x;

			return this;

		},

		setY: function ( y ) {

			this.y = y;

			return this;

		},

		setZ: function ( z ) {

			this.z = z;

			return this;

		},

		setW: function ( w ) {

			this.w = w;

			return this;

		},

		setComponent: function ( index, value ) {

			switch ( index ) {

				case 0: this.x = value; break;
				case 1: this.y = value; break;
				case 2: this.z = value; break;
				case 3: this.w = value; break;
				default: throw new Error( 'index is out of range: ' + index );

			}

			return this;

		},

		getComponent: function ( index ) {

			switch ( index ) {

				case 0: return this.x;
				case 1: return this.y;
				case 2: return this.z;
				case 3: return this.w;
				default: throw new Error( 'index is out of range: ' + index );

			}

		},

		clone: function () {

			return new this.constructor( this.x, this.y, this.z, this.w );

		},

		copy: function ( v ) {

			this.x = v.x;
			this.y = v.y;
			this.z = v.z;
			this.w = ( v.w !== undefined ) ? v.w : 1;

			return this;

		},

		add: function ( v, w ) {

			if ( w !== undefined ) {

				console.warn( 'THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
				return this.addVectors( v, w );

			}

			this.x += v.x;
			this.y += v.y;
			this.z += v.z;
			this.w += v.w;

			return this;

		},

		addScalar: function ( s ) {

			this.x += s;
			this.y += s;
			this.z += s;
			this.w += s;

			return this;

		},

		addVectors: function ( a, b ) {

			this.x = a.x + b.x;
			this.y = a.y + b.y;
			this.z = a.z + b.z;
			this.w = a.w + b.w;

			return this;

		},

		addScaledVector: function ( v, s ) {

			this.x += v.x * s;
			this.y += v.y * s;
			this.z += v.z * s;
			this.w += v.w * s;

			return this;

		},

		sub: function ( v, w ) {

			if ( w !== undefined ) {

				console.warn( 'THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
				return this.subVectors( v, w );

			}

			this.x -= v.x;
			this.y -= v.y;
			this.z -= v.z;
			this.w -= v.w;

			return this;

		},

		subScalar: function ( s ) {

			this.x -= s;
			this.y -= s;
			this.z -= s;
			this.w -= s;

			return this;

		},

		subVectors: function ( a, b ) {

			this.x = a.x - b.x;
			this.y = a.y - b.y;
			this.z = a.z - b.z;
			this.w = a.w - b.w;

			return this;

		},

		multiplyScalar: function ( scalar ) {

			if ( isFinite( scalar ) ) {

				this.x *= scalar;
				this.y *= scalar;
				this.z *= scalar;
				this.w *= scalar;

			} else {

				this.x = 0;
				this.y = 0;
				this.z = 0;
				this.w = 0;

			}

			return this;

		},

		applyMatrix4: function ( m ) {

			var x = this.x, y = this.y, z = this.z, w = this.w;
			var e = m.elements;

			this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z + e[ 12 ] * w;
			this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z + e[ 13 ] * w;
			this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] * w;
			this.w = e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] * w;

			return this;

		},

		divideScalar: function ( scalar ) {

			return this.multiplyScalar( 1 / scalar );

		},

		setAxisAngleFromQuaternion: function ( q ) {

			// http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm

			// q is assumed to be normalized

			this.w = 2 * Math.acos( q.w );

			var s = Math.sqrt( 1 - q.w * q.w );

			if ( s < 0.0001 ) {

				 this.x = 1;
				 this.y = 0;
				 this.z = 0;

			} else {

				 this.x = q.x / s;
				 this.y = q.y / s;
				 this.z = q.z / s;

			}

			return this;

		},

		setAxisAngleFromRotationMatrix: function ( m ) {

			// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm

			// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

			var angle, x, y, z,		// variables for result
				epsilon = 0.01,		// margin to allow for rounding errors
				epsilon2 = 0.1,		// margin to distinguish between 0 and 180 degrees

				te = m.elements,

				m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
				m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
				m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];

			if ( ( Math.abs( m12 - m21 ) < epsilon ) &&
			     ( Math.abs( m13 - m31 ) < epsilon ) &&
			     ( Math.abs( m23 - m32 ) < epsilon ) ) {

				// singularity found
				// first check for identity matrix which must have +1 for all terms
				// in leading diagonal and zero in other terms

				if ( ( Math.abs( m12 + m21 ) < epsilon2 ) &&
				     ( Math.abs( m13 + m31 ) < epsilon2 ) &&
				     ( Math.abs( m23 + m32 ) < epsilon2 ) &&
				     ( Math.abs( m11 + m22 + m33 - 3 ) < epsilon2 ) ) {

					// this singularity is identity matrix so angle = 0

					this.set( 1, 0, 0, 0 );

					return this; // zero angle, arbitrary axis

				}

				// otherwise this singularity is angle = 180

				angle = Math.PI;

				var xx = ( m11 + 1 ) / 2;
				var yy = ( m22 + 1 ) / 2;
				var zz = ( m33 + 1 ) / 2;
				var xy = ( m12 + m21 ) / 4;
				var xz = ( m13 + m31 ) / 4;
				var yz = ( m23 + m32 ) / 4;

				if ( ( xx > yy ) && ( xx > zz ) ) {

					// m11 is the largest diagonal term

					if ( xx < epsilon ) {

						x = 0;
						y = 0.707106781;
						z = 0.707106781;

					} else {

						x = Math.sqrt( xx );
						y = xy / x;
						z = xz / x;

					}

				} else if ( yy > zz ) {

					// m22 is the largest diagonal term

					if ( yy < epsilon ) {

						x = 0.707106781;
						y = 0;
						z = 0.707106781;

					} else {

						y = Math.sqrt( yy );
						x = xy / y;
						z = yz / y;

					}

				} else {

					// m33 is the largest diagonal term so base result on this

					if ( zz < epsilon ) {

						x = 0.707106781;
						y = 0.707106781;
						z = 0;

					} else {

						z = Math.sqrt( zz );
						x = xz / z;
						y = yz / z;

					}

				}

				this.set( x, y, z, angle );

				return this; // return 180 deg rotation

			}

			// as we have reached here there are no singularities so we can handle normally

			var s = Math.sqrt( ( m32 - m23 ) * ( m32 - m23 ) +
			                   ( m13 - m31 ) * ( m13 - m31 ) +
			                   ( m21 - m12 ) * ( m21 - m12 ) ); // used to normalize

			if ( Math.abs( s ) < 0.001 ) s = 1;

			// prevent divide by zero, should not happen if matrix is orthogonal and should be
			// caught by singularity test above, but I've left it in just in case

			this.x = ( m32 - m23 ) / s;
			this.y = ( m13 - m31 ) / s;
			this.z = ( m21 - m12 ) / s;
			this.w = Math.acos( ( m11 + m22 + m33 - 1 ) / 2 );

			return this;

		},

		min: function ( v ) {

			this.x = Math.min( this.x, v.x );
			this.y = Math.min( this.y, v.y );
			this.z = Math.min( this.z, v.z );
			this.w = Math.min( this.w, v.w );

			return this;

		},

		max: function ( v ) {

			this.x = Math.max( this.x, v.x );
			this.y = Math.max( this.y, v.y );
			this.z = Math.max( this.z, v.z );
			this.w = Math.max( this.w, v.w );

			return this;

		},

		clamp: function ( min, max ) {

			// This function assumes min < max, if this assumption isn't true it will not operate correctly

			this.x = Math.max( min.x, Math.min( max.x, this.x ) );
			this.y = Math.max( min.y, Math.min( max.y, this.y ) );
			this.z = Math.max( min.z, Math.min( max.z, this.z ) );
			this.w = Math.max( min.w, Math.min( max.w, this.w ) );

			return this;

		},

		clampScalar: function () {

			var min, max;

			return function clampScalar( minVal, maxVal ) {

				if ( min === undefined ) {

					min = new Vector4();
					max = new Vector4();

				}

				min.set( minVal, minVal, minVal, minVal );
				max.set( maxVal, maxVal, maxVal, maxVal );

				return this.clamp( min, max );

			};

		}(),

		floor: function () {

			this.x = Math.floor( this.x );
			this.y = Math.floor( this.y );
			this.z = Math.floor( this.z );
			this.w = Math.floor( this.w );

			return this;

		},

		ceil: function () {

			this.x = Math.ceil( this.x );
			this.y = Math.ceil( this.y );
			this.z = Math.ceil( this.z );
			this.w = Math.ceil( this.w );

			return this;

		},

		round: function () {

			this.x = Math.round( this.x );
			this.y = Math.round( this.y );
			this.z = Math.round( this.z );
			this.w = Math.round( this.w );

			return this;

		},

		roundToZero: function () {

			this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
			this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );
			this.z = ( this.z < 0 ) ? Math.ceil( this.z ) : Math.floor( this.z );
			this.w = ( this.w < 0 ) ? Math.ceil( this.w ) : Math.floor( this.w );

			return this;

		},

		negate: function () {

			this.x = - this.x;
			this.y = - this.y;
			this.z = - this.z;
			this.w = - this.w;

			return this;

		},

		dot: function ( v ) {

			return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;

		},

		lengthSq: function () {

			return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;

		},

		length: function () {

			return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w );

		},

		lengthManhattan: function () {

			return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z ) + Math.abs( this.w );

		},

		normalize: function () {

			return this.divideScalar( this.length() );

		},

		setLength: function ( length ) {

			return this.multiplyScalar( length / this.length() );

		},

		lerp: function ( v, alpha ) {

			this.x += ( v.x - this.x ) * alpha;
			this.y += ( v.y - this.y ) * alpha;
			this.z += ( v.z - this.z ) * alpha;
			this.w += ( v.w - this.w ) * alpha;

			return this;

		},

		lerpVectors: function ( v1, v2, alpha ) {

			return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );

		},

		equals: function ( v ) {

			return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) && ( v.w === this.w ) );

		},

		fromArray: function ( array, offset ) {

			if ( offset === undefined ) offset = 0;

			this.x = array[ offset ];
			this.y = array[ offset + 1 ];
			this.z = array[ offset + 2 ];
			this.w = array[ offset + 3 ];

			return this;

		},

		toArray: function ( array, offset ) {

			if ( array === undefined ) array = [];
			if ( offset === undefined ) offset = 0;

			array[ offset ] = this.x;
			array[ offset + 1 ] = this.y;
			array[ offset + 2 ] = this.z;
			array[ offset + 3 ] = this.w;

			return array;

		},

		fromAttribute: function ( attribute, index, offset ) {

			if ( offset !== undefined ) {

				console.warn( 'THREE.Vector4: offset has been removed from .fromAttribute().' );

			}

			this.x = attribute.getX( index );
			this.y = attribute.getY( index );
			this.z = attribute.getZ( index );
			this.w = attribute.getW( index );

			return this;

		}

	};

	/**
	 * @author szimek / https://github.com/szimek/
	 * @author alteredq / http://alteredqualia.com/
	 * @author Marius Kintel / https://github.com/kintel
	 */

	/*
	 In options, we can specify:
	 * Texture parameters for an auto-generated target texture
	 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
	*/
	function WebGLRenderTarget( width, height, options ) {

		this.uuid = _Math.generateUUID();

		this.width = width;
		this.height = height;

		this.scissor = new Vector4( 0, 0, width, height );
		this.scissorTest = false;

		this.viewport = new Vector4( 0, 0, width, height );

		options = options || {};

		if ( options.minFilter === undefined ) options.minFilter = LinearFilter;

		this.texture = new Texture( undefined, undefined, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding );

		this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
		this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : true;
		this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;

	}

	Object.assign( WebGLRenderTarget.prototype, EventDispatcher.prototype, {

		isWebGLRenderTarget: true,

		setSize: function ( width, height ) {

			if ( this.width !== width || this.height !== height ) {

				this.width = width;
				this.height = height;

				this.dispose();

			}

			this.viewport.set( 0, 0, width, height );
			this.scissor.set( 0, 0, width, height );

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( source ) {

			this.width = source.width;
			this.height = source.height;

			this.viewport.copy( source.viewport );

			this.texture = source.texture.clone();

			this.depthBuffer = source.depthBuffer;
			this.stencilBuffer = source.stencilBuffer;
			this.depthTexture = source.depthTexture;

			return this;

		},

		dispose: function () {

			this.dispatchEvent( { type: 'dispose' } );

		}

	} );

	/**
	 * @author alteredq / http://alteredqualia.com
	 */

	function WebGLRenderTargetCube( width, height, options ) {

		WebGLRenderTarget.call( this, width, height, options );

		this.activeCubeFace = 0; // PX 0, NX 1, PY 2, NY 3, PZ 4, NZ 5
		this.activeMipMapLevel = 0;

	}

	WebGLRenderTargetCube.prototype = Object.create( WebGLRenderTarget.prototype );
	WebGLRenderTargetCube.prototype.constructor = WebGLRenderTargetCube;

	WebGLRenderTargetCube.prototype.isWebGLRenderTargetCube = true;

	/**
	 * @author mikael emtinger / http://gomo.se/
	 * @author alteredq / http://alteredqualia.com/
	 * @author WestLangley / http://github.com/WestLangley
	 * @author bhouston / http://clara.io
	 */

	function Quaternion( x, y, z, w ) {

		this._x = x || 0;
		this._y = y || 0;
		this._z = z || 0;
		this._w = ( w !== undefined ) ? w : 1;

	}

	Quaternion.prototype = {

		constructor: Quaternion,

		get x () {

			return this._x;

		},

		set x ( value ) {

			this._x = value;
			this.onChangeCallback();

		},

		get y () {

			return this._y;

		},

		set y ( value ) {

			this._y = value;
			this.onChangeCallback();

		},

		get z () {

			return this._z;

		},

		set z ( value ) {

			this._z = value;
			this.onChangeCallback();

		},

		get w () {

			return this._w;

		},

		set w ( value ) {

			this._w = value;
			this.onChangeCallback();

		},

		set: function ( x, y, z, w ) {

			this._x = x;
			this._y = y;
			this._z = z;
			this._w = w;

			this.onChangeCallback();

			return this;

		},

		clone: function () {

			return new this.constructor( this._x, this._y, this._z, this._w );

		},

		copy: function ( quaternion ) {

			this._x = quaternion.x;
			this._y = quaternion.y;
			this._z = quaternion.z;
			this._w = quaternion.w;

			this.onChangeCallback();

			return this;

		},

		setFromEuler: function ( euler, update ) {

			if ( (euler && euler.isEuler) === false ) {

				throw new Error( 'THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.' );

			}

			// http://www.mathworks.com/matlabcentral/fileexchange/
			// 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
			//	content/SpinCalc.m

			var c1 = Math.cos( euler._x / 2 );
			var c2 = Math.cos( euler._y / 2 );
			var c3 = Math.cos( euler._z / 2 );
			var s1 = Math.sin( euler._x / 2 );
			var s2 = Math.sin( euler._y / 2 );
			var s3 = Math.sin( euler._z / 2 );

			var order = euler.order;

			if ( order === 'XYZ' ) {

				this._x = s1 * c2 * c3 + c1 * s2 * s3;
				this._y = c1 * s2 * c3 - s1 * c2 * s3;
				this._z = c1 * c2 * s3 + s1 * s2 * c3;
				this._w = c1 * c2 * c3 - s1 * s2 * s3;

			} else if ( order === 'YXZ' ) {

				this._x = s1 * c2 * c3 + c1 * s2 * s3;
				this._y = c1 * s2 * c3 - s1 * c2 * s3;
				this._z = c1 * c2 * s3 - s1 * s2 * c3;
				this._w = c1 * c2 * c3 + s1 * s2 * s3;

			} else if ( order === 'ZXY' ) {

				this._x = s1 * c2 * c3 - c1 * s2 * s3;
				this._y = c1 * s2 * c3 + s1 * c2 * s3;
				this._z = c1 * c2 * s3 + s1 * s2 * c3;
				this._w = c1 * c2 * c3 - s1 * s2 * s3;

			} else if ( order === 'ZYX' ) {

				this._x = s1 * c2 * c3 - c1 * s2 * s3;
				this._y = c1 * s2 * c3 + s1 * c2 * s3;
				this._z = c1 * c2 * s3 - s1 * s2 * c3;
				this._w = c1 * c2 * c3 + s1 * s2 * s3;

			} else if ( order === 'YZX' ) {

				this._x = s1 * c2 * c3 + c1 * s2 * s3;
				this._y = c1 * s2 * c3 + s1 * c2 * s3;
				this._z = c1 * c2 * s3 - s1 * s2 * c3;
				this._w = c1 * c2 * c3 - s1 * s2 * s3;

			} else if ( order === 'XZY' ) {

				this._x = s1 * c2 * c3 - c1 * s2 * s3;
				this._y = c1 * s2 * c3 - s1 * c2 * s3;
				this._z = c1 * c2 * s3 + s1 * s2 * c3;
				this._w = c1 * c2 * c3 + s1 * s2 * s3;

			}

			if ( update !== false ) this.onChangeCallback();

			return this;

		},

		setFromAxisAngle: function ( axis, angle ) {

			// http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm

			// assumes axis is normalized

			var halfAngle = angle / 2, s = Math.sin( halfAngle );

			this._x = axis.x * s;
			this._y = axis.y * s;
			this._z = axis.z * s;
			this._w = Math.cos( halfAngle );

			this.onChangeCallback();

			return this;

		},

		setFromRotationMatrix: function ( m ) {

			// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm

			// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

			var te = m.elements,

				m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
				m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
				m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ],

				trace = m11 + m22 + m33,
				s;

			if ( trace > 0 ) {

				s = 0.5 / Math.sqrt( trace + 1.0 );

				this._w = 0.25 / s;
				this._x = ( m32 - m23 ) * s;
				this._y = ( m13 - m31 ) * s;
				this._z = ( m21 - m12 ) * s;

			} else if ( m11 > m22 && m11 > m33 ) {

				s = 2.0 * Math.sqrt( 1.0 + m11 - m22 - m33 );

				this._w = ( m32 - m23 ) / s;
				this._x = 0.25 * s;
				this._y = ( m12 + m21 ) / s;
				this._z = ( m13 + m31 ) / s;

			} else if ( m22 > m33 ) {

				s = 2.0 * Math.sqrt( 1.0 + m22 - m11 - m33 );

				this._w = ( m13 - m31 ) / s;
				this._x = ( m12 + m21 ) / s;
				this._y = 0.25 * s;
				this._z = ( m23 + m32 ) / s;

			} else {

				s = 2.0 * Math.sqrt( 1.0 + m33 - m11 - m22 );

				this._w = ( m21 - m12 ) / s;
				this._x = ( m13 + m31 ) / s;
				this._y = ( m23 + m32 ) / s;
				this._z = 0.25 * s;

			}

			this.onChangeCallback();

			return this;

		},

		setFromUnitVectors: function () {

			// http://lolengine.net/blog/2014/02/24/quaternion-from-two-vectors-final

			// assumes direction vectors vFrom and vTo are normalized

			var v1, r;

			var EPS = 0.000001;

			return function setFromUnitVectors( vFrom, vTo ) {

				if ( v1 === undefined ) v1 = new Vector3();

				r = vFrom.dot( vTo ) + 1;

				if ( r < EPS ) {

					r = 0;

					if ( Math.abs( vFrom.x ) > Math.abs( vFrom.z ) ) {

						v1.set( - vFrom.y, vFrom.x, 0 );

					} else {

						v1.set( 0, - vFrom.z, vFrom.y );

					}

				} else {

					v1.crossVectors( vFrom, vTo );

				}

				this._x = v1.x;
				this._y = v1.y;
				this._z = v1.z;
				this._w = r;

				return this.normalize();

			};

		}(),

		inverse: function () {

			return this.conjugate().normalize();

		},

		conjugate: function () {

			this._x *= - 1;
			this._y *= - 1;
			this._z *= - 1;

			this.onChangeCallback();

			return this;

		},

		dot: function ( v ) {

			return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;

		},

		lengthSq: function () {

			return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;

		},

		length: function () {

			return Math.sqrt( this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w );

		},

		normalize: function () {

			var l = this.length();

			if ( l === 0 ) {

				this._x = 0;
				this._y = 0;
				this._z = 0;
				this._w = 1;

			} else {

				l = 1 / l;

				this._x = this._x * l;
				this._y = this._y * l;
				this._z = this._z * l;
				this._w = this._w * l;

			}

			this.onChangeCallback();

			return this;

		},

		multiply: function ( q, p ) {

			if ( p !== undefined ) {

				console.warn( 'THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.' );
				return this.multiplyQuaternions( q, p );

			}

			return this.multiplyQuaternions( this, q );

		},

		premultiply: function ( q ) {

			return this.multiplyQuaternions( q, this );

		},

		multiplyQuaternions: function ( a, b ) {

			// from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm

			var qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
			var qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;

			this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
			this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
			this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
			this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;

			this.onChangeCallback();

			return this;

		},

		slerp: function ( qb, t ) {

			if ( t === 0 ) return this;
			if ( t === 1 ) return this.copy( qb );

			var x = this._x, y = this._y, z = this._z, w = this._w;

			// http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/

			var cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;

			if ( cosHalfTheta < 0 ) {

				this._w = - qb._w;
				this._x = - qb._x;
				this._y = - qb._y;
				this._z = - qb._z;

				cosHalfTheta = - cosHalfTheta;

			} else {

				this.copy( qb );

			}

			if ( cosHalfTheta >= 1.0 ) {

				this._w = w;
				this._x = x;
				this._y = y;
				this._z = z;

				return this;

			}

			var sinHalfTheta = Math.sqrt( 1.0 - cosHalfTheta * cosHalfTheta );

			if ( Math.abs( sinHalfTheta ) < 0.001 ) {

				this._w = 0.5 * ( w + this._w );
				this._x = 0.5 * ( x + this._x );
				this._y = 0.5 * ( y + this._y );
				this._z = 0.5 * ( z + this._z );

				return this;

			}

			var halfTheta = Math.atan2( sinHalfTheta, cosHalfTheta );
			var ratioA = Math.sin( ( 1 - t ) * halfTheta ) / sinHalfTheta,
			ratioB = Math.sin( t * halfTheta ) / sinHalfTheta;

			this._w = ( w * ratioA + this._w * ratioB );
			this._x = ( x * ratioA + this._x * ratioB );
			this._y = ( y * ratioA + this._y * ratioB );
			this._z = ( z * ratioA + this._z * ratioB );

			this.onChangeCallback();

			return this;

		},

		equals: function ( quaternion ) {

			return ( quaternion._x === this._x ) && ( quaternion._y === this._y ) && ( quaternion._z === this._z ) && ( quaternion._w === this._w );

		},

		fromArray: function ( array, offset ) {

			if ( offset === undefined ) offset = 0;

			this._x = array[ offset ];
			this._y = array[ offset + 1 ];
			this._z = array[ offset + 2 ];
			this._w = array[ offset + 3 ];

			this.onChangeCallback();

			return this;

		},

		toArray: function ( array, offset ) {

			if ( array === undefined ) array = [];
			if ( offset === undefined ) offset = 0;

			array[ offset ] = this._x;
			array[ offset + 1 ] = this._y;
			array[ offset + 2 ] = this._z;
			array[ offset + 3 ] = this._w;

			return array;

		},

		onChange: function ( callback ) {

			this.onChangeCallback = callback;

			return this;

		},

		onChangeCallback: function () {}

	};

	Object.assign( Quaternion, {

		slerp: function( qa, qb, qm, t ) {

			return qm.copy( qa ).slerp( qb, t );

		},

		slerpFlat: function(
				dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t ) {

			// fuzz-free, array-based Quaternion SLERP operation

			var x0 = src0[ srcOffset0 + 0 ],
				y0 = src0[ srcOffset0 + 1 ],
				z0 = src0[ srcOffset0 + 2 ],
				w0 = src0[ srcOffset0 + 3 ],

				x1 = src1[ srcOffset1 + 0 ],
				y1 = src1[ srcOffset1 + 1 ],
				z1 = src1[ srcOffset1 + 2 ],
				w1 = src1[ srcOffset1 + 3 ];

			if ( w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1 ) {

				var s = 1 - t,

					cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1,

					dir = ( cos >= 0 ? 1 : - 1 ),
					sqrSin = 1 - cos * cos;

				// Skip the Slerp for tiny steps to avoid numeric problems:
				if ( sqrSin > Number.EPSILON ) {

					var sin = Math.sqrt( sqrSin ),
						len = Math.atan2( sin, cos * dir );

					s = Math.sin( s * len ) / sin;
					t = Math.sin( t * len ) / sin;

				}

				var tDir = t * dir;

				x0 = x0 * s + x1 * tDir;
				y0 = y0 * s + y1 * tDir;
				z0 = z0 * s + z1 * tDir;
				w0 = w0 * s + w1 * tDir;

				// Normalize in case we just did a lerp:
				if ( s === 1 - t ) {

					var f = 1 / Math.sqrt( x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0 );

					x0 *= f;
					y0 *= f;
					z0 *= f;
					w0 *= f;

				}

			}

			dst[ dstOffset ] = x0;
			dst[ dstOffset + 1 ] = y0;
			dst[ dstOffset + 2 ] = z0;
			dst[ dstOffset + 3 ] = w0;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author *kile / http://kile.stravaganza.org/
	 * @author philogb / http://blog.thejit.org/
	 * @author mikael emtinger / http://gomo.se/
	 * @author egraether / http://egraether.com/
	 * @author WestLangley / http://github.com/WestLangley
	 */

	function Vector3( x, y, z ) {

		this.x = x || 0;
		this.y = y || 0;
		this.z = z || 0;

	}

	Vector3.prototype = {

		constructor: Vector3,

		isVector3: true,

		set: function ( x, y, z ) {

			this.x = x;
			this.y = y;
			this.z = z;

			return this;

		},

		setScalar: function ( scalar ) {

			this.x = scalar;
			this.y = scalar;
			this.z = scalar;

			return this;

		},

		setX: function ( x ) {

			this.x = x;

			return this;

		},

		setY: function ( y ) {

			this.y = y;

			return this;

		},

		setZ: function ( z ) {

			this.z = z;

			return this;

		},

		setComponent: function ( index, value ) {

			switch ( index ) {

				case 0: this.x = value; break;
				case 1: this.y = value; break;
				case 2: this.z = value; break;
				default: throw new Error( 'index is out of range: ' + index );

			}

			return this;

		},

		getComponent: function ( index ) {

			switch ( index ) {

				case 0: return this.x;
				case 1: return this.y;
				case 2: return this.z;
				default: throw new Error( 'index is out of range: ' + index );

			}

		},

		clone: function () {

			return new this.constructor( this.x, this.y, this.z );

		},

		copy: function ( v ) {

			this.x = v.x;
			this.y = v.y;
			this.z = v.z;

			return this;

		},

		add: function ( v, w ) {

			if ( w !== undefined ) {

				console.warn( 'THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
				return this.addVectors( v, w );

			}

			this.x += v.x;
			this.y += v.y;
			this.z += v.z;

			return this;

		},

		addScalar: function ( s ) {

			this.x += s;
			this.y += s;
			this.z += s;

			return this;

		},

		addVectors: function ( a, b ) {

			this.x = a.x + b.x;
			this.y = a.y + b.y;
			this.z = a.z + b.z;

			return this;

		},

		addScaledVector: function ( v, s ) {

			this.x += v.x * s;
			this.y += v.y * s;
			this.z += v.z * s;

			return this;

		},

		sub: function ( v, w ) {

			if ( w !== undefined ) {

				console.warn( 'THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
				return this.subVectors( v, w );

			}

			this.x -= v.x;
			this.y -= v.y;
			this.z -= v.z;

			return this;

		},

		subScalar: function ( s ) {

			this.x -= s;
			this.y -= s;
			this.z -= s;

			return this;

		},

		subVectors: function ( a, b ) {

			this.x = a.x - b.x;
			this.y = a.y - b.y;
			this.z = a.z - b.z;

			return this;

		},

		multiply: function ( v, w ) {

			if ( w !== undefined ) {

				console.warn( 'THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.' );
				return this.multiplyVectors( v, w );

			}

			this.x *= v.x;
			this.y *= v.y;
			this.z *= v.z;

			return this;

		},

		multiplyScalar: function ( scalar ) {

			if ( isFinite( scalar ) ) {

				this.x *= scalar;
				this.y *= scalar;
				this.z *= scalar;

			} else {

				this.x = 0;
				this.y = 0;
				this.z = 0;

			}

			return this;

		},

		multiplyVectors: function ( a, b ) {

			this.x = a.x * b.x;
			this.y = a.y * b.y;
			this.z = a.z * b.z;

			return this;

		},

		applyEuler: function () {

			var quaternion;

			return function applyEuler( euler ) {

				if ( (euler && euler.isEuler) === false ) {

					console.error( 'THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.' );

				}

				if ( quaternion === undefined ) quaternion = new Quaternion();

				return this.applyQuaternion( quaternion.setFromEuler( euler ) );

			};

		}(),

		applyAxisAngle: function () {

			var quaternion;

			return function applyAxisAngle( axis, angle ) {

				if ( quaternion === undefined ) quaternion = new Quaternion();

				return this.applyQuaternion( quaternion.setFromAxisAngle( axis, angle ) );

			};

		}(),

		applyMatrix3: function ( m ) {

			var x = this.x, y = this.y, z = this.z;
			var e = m.elements;

			this.x = e[ 0 ] * x + e[ 3 ] * y + e[ 6 ] * z;
			this.y = e[ 1 ] * x + e[ 4 ] * y + e[ 7 ] * z;
			this.z = e[ 2 ] * x + e[ 5 ] * y + e[ 8 ] * z;

			return this;

		},

		applyMatrix4: function ( m ) {

			// input: THREE.Matrix4 affine matrix

			var x = this.x, y = this.y, z = this.z;
			var e = m.elements;

			this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ]  * z + e[ 12 ];
			this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ]  * z + e[ 13 ];
			this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ];

			return this;

		},

		applyProjection: function ( m ) {

			// input: THREE.Matrix4 projection matrix

			var x = this.x, y = this.y, z = this.z;
			var e = m.elements;
			var d = 1 / ( e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] ); // perspective divide

			this.x = ( e[ 0 ] * x + e[ 4 ] * y + e[ 8 ]  * z + e[ 12 ] ) * d;
			this.y = ( e[ 1 ] * x + e[ 5 ] * y + e[ 9 ]  * z + e[ 13 ] ) * d;
			this.z = ( e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] ) * d;

			return this;

		},

		applyQuaternion: function ( q ) {

			var x = this.x, y = this.y, z = this.z;
			var qx = q.x, qy = q.y, qz = q.z, qw = q.w;

			// calculate quat * vector

			var ix =  qw * x + qy * z - qz * y;
			var iy =  qw * y + qz * x - qx * z;
			var iz =  qw * z + qx * y - qy * x;
			var iw = - qx * x - qy * y - qz * z;

			// calculate result * inverse quat

			this.x = ix * qw + iw * - qx + iy * - qz - iz * - qy;
			this.y = iy * qw + iw * - qy + iz * - qx - ix * - qz;
			this.z = iz * qw + iw * - qz + ix * - qy - iy * - qx;

			return this;

		},

		project: function () {

			var matrix;

			return function project( camera ) {

				if ( matrix === undefined ) matrix = new Matrix4();

				matrix.multiplyMatrices( camera.projectionMatrix, matrix.getInverse( camera.matrixWorld ) );
				return this.applyProjection( matrix );

			};

		}(),

		unproject: function () {

			var matrix;

			return function unproject( camera ) {

				if ( matrix === undefined ) matrix = new Matrix4();

				matrix.multiplyMatrices( camera.matrixWorld, matrix.getInverse( camera.projectionMatrix ) );
				return this.applyProjection( matrix );

			};

		}(),

		transformDirection: function ( m ) {

			// input: THREE.Matrix4 affine matrix
			// vector interpreted as a direction

			var x = this.x, y = this.y, z = this.z;
			var e = m.elements;

			this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ]  * z;
			this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ]  * z;
			this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z;

			return this.normalize();

		},

		divide: function ( v ) {

			this.x /= v.x;
			this.y /= v.y;
			this.z /= v.z;

			return this;

		},

		divideScalar: function ( scalar ) {

			return this.multiplyScalar( 1 / scalar );

		},

		min: function ( v ) {

			this.x = Math.min( this.x, v.x );
			this.y = Math.min( this.y, v.y );
			this.z = Math.min( this.z, v.z );

			return this;

		},

		max: function ( v ) {

			this.x = Math.max( this.x, v.x );
			this.y = Math.max( this.y, v.y );
			this.z = Math.max( this.z, v.z );

			return this;

		},

		clamp: function ( min, max ) {

			// This function assumes min < max, if this assumption isn't true it will not operate correctly

			this.x = Math.max( min.x, Math.min( max.x, this.x ) );
			this.y = Math.max( min.y, Math.min( max.y, this.y ) );
			this.z = Math.max( min.z, Math.min( max.z, this.z ) );

			return this;

		},

		clampScalar: function () {

			var min, max;

			return function clampScalar( minVal, maxVal ) {

				if ( min === undefined ) {

					min = new Vector3();
					max = new Vector3();

				}

				min.set( minVal, minVal, minVal );
				max.set( maxVal, maxVal, maxVal );

				return this.clamp( min, max );

			};

		}(),

		clampLength: function ( min, max ) {

			var length = this.length();

			return this.multiplyScalar( Math.max( min, Math.min( max, length ) ) / length );

		},

		floor: function () {

			this.x = Math.floor( this.x );
			this.y = Math.floor( this.y );
			this.z = Math.floor( this.z );

			return this;

		},

		ceil: function () {

			this.x = Math.ceil( this.x );
			this.y = Math.ceil( this.y );
			this.z = Math.ceil( this.z );

			return this;

		},

		round: function () {

			this.x = Math.round( this.x );
			this.y = Math.round( this.y );
			this.z = Math.round( this.z );

			return this;

		},

		roundToZero: function () {

			this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
			this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );
			this.z = ( this.z < 0 ) ? Math.ceil( this.z ) : Math.floor( this.z );

			return this;

		},

		negate: function () {

			this.x = - this.x;
			this.y = - this.y;
			this.z = - this.z;

			return this;

		},

		dot: function ( v ) {

			return this.x * v.x + this.y * v.y + this.z * v.z;

		},

		lengthSq: function () {

			return this.x * this.x + this.y * this.y + this.z * this.z;

		},

		length: function () {

			return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z );

		},

		lengthManhattan: function () {

			return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z );

		},

		normalize: function () {

			return this.divideScalar( this.length() );

		},

		setLength: function ( length ) {

			return this.multiplyScalar( length / this.length() );

		},

		lerp: function ( v, alpha ) {

			this.x += ( v.x - this.x ) * alpha;
			this.y += ( v.y - this.y ) * alpha;
			this.z += ( v.z - this.z ) * alpha;

			return this;

		},

		lerpVectors: function ( v1, v2, alpha ) {

			return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );

		},

		cross: function ( v, w ) {

			if ( w !== undefined ) {

				console.warn( 'THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.' );
				return this.crossVectors( v, w );

			}

			var x = this.x, y = this.y, z = this.z;

			this.x = y * v.z - z * v.y;
			this.y = z * v.x - x * v.z;
			this.z = x * v.y - y * v.x;

			return this;

		},

		crossVectors: function ( a, b ) {

			var ax = a.x, ay = a.y, az = a.z;
			var bx = b.x, by = b.y, bz = b.z;

			this.x = ay * bz - az * by;
			this.y = az * bx - ax * bz;
			this.z = ax * by - ay * bx;

			return this;

		},

		projectOnVector: function ( vector ) {

			var scalar = vector.dot( this ) / vector.lengthSq();

			return this.copy( vector ).multiplyScalar( scalar );

		},

		projectOnPlane: function () {

			var v1;

			return function projectOnPlane( planeNormal ) {

				if ( v1 === undefined ) v1 = new Vector3();

				v1.copy( this ).projectOnVector( planeNormal );

				return this.sub( v1 );

			};

		}(),

		reflect: function () {

			// reflect incident vector off plane orthogonal to normal
			// normal is assumed to have unit length

			var v1;

			return function reflect( normal ) {

				if ( v1 === undefined ) v1 = new Vector3();

				return this.sub( v1.copy( normal ).multiplyScalar( 2 * this.dot( normal ) ) );

			};

		}(),

		angleTo: function ( v ) {

			var theta = this.dot( v ) / ( Math.sqrt( this.lengthSq() * v.lengthSq() ) );

			// clamp, to handle numerical problems

			return Math.acos( _Math.clamp( theta, - 1, 1 ) );

		},

		distanceTo: function ( v ) {

			return Math.sqrt( this.distanceToSquared( v ) );

		},

		distanceToSquared: function ( v ) {

			var dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;

			return dx * dx + dy * dy + dz * dz;

		},

		distanceToManhattan: function ( v ) {

			return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y ) + Math.abs( this.z - v.z );

		},

		setFromSpherical: function( s ) {

			var sinPhiRadius = Math.sin( s.phi ) * s.radius;

			this.x = sinPhiRadius * Math.sin( s.theta );
			this.y = Math.cos( s.phi ) * s.radius;
			this.z = sinPhiRadius * Math.cos( s.theta );

			return this;

		},

		setFromCylindrical: function( c ) {

			this.x = c.radius * Math.sin( c.theta );
			this.y = c.y;
			this.z = c.radius * Math.cos( c.theta );

			return this;

		},

		setFromMatrixPosition: function ( m ) {

			return this.setFromMatrixColumn( m, 3 );

		},

		setFromMatrixScale: function ( m ) {

			var sx = this.setFromMatrixColumn( m, 0 ).length();
			var sy = this.setFromMatrixColumn( m, 1 ).length();
			var sz = this.setFromMatrixColumn( m, 2 ).length();

			this.x = sx;
			this.y = sy;
			this.z = sz;

			return this;

		},

		setFromMatrixColumn: function ( m, index ) {

			if ( typeof m === 'number' ) {

				console.warn( 'THREE.Vector3: setFromMatrixColumn now expects ( matrix, index ).' );
				var temp = m;
				m = index;
				index = temp;

			}

			return this.fromArray( m.elements, index * 4 );

		},

		equals: function ( v ) {

			return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) );

		},

		fromArray: function ( array, offset ) {

			if ( offset === undefined ) offset = 0;

			this.x = array[ offset ];
			this.y = array[ offset + 1 ];
			this.z = array[ offset + 2 ];

			return this;

		},

		toArray: function ( array, offset ) {

			if ( array === undefined ) array = [];
			if ( offset === undefined ) offset = 0;

			array[ offset ] = this.x;
			array[ offset + 1 ] = this.y;
			array[ offset + 2 ] = this.z;

			return array;

		},

		fromAttribute: function ( attribute, index, offset ) {

			if ( offset !== undefined ) {

				console.warn( 'THREE.Vector3: offset has been removed from .fromAttribute().' );

			}

			this.x = attribute.getX( index );
			this.y = attribute.getY( index );
			this.z = attribute.getZ( index );

			return this;

		}

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author supereggbert / http://www.paulbrunt.co.uk/
	 * @author philogb / http://blog.thejit.org/
	 * @author jordi_ros / http://plattsoft.com
	 * @author D1plo1d / http://github.com/D1plo1d
	 * @author alteredq / http://alteredqualia.com/
	 * @author mikael emtinger / http://gomo.se/
	 * @author timknip / http://www.floorplanner.com/
	 * @author bhouston / http://clara.io
	 * @author WestLangley / http://github.com/WestLangley
	 */

	function Matrix4() {

		this.elements = new Float32Array( [

			1, 0, 0, 0,
			0, 1, 0, 0,
			0, 0, 1, 0,
			0, 0, 0, 1

		] );

		if ( arguments.length > 0 ) {

			console.error( 'THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.' );

		}

	}

	Matrix4.prototype = {

		constructor: Matrix4,

		isMatrix4: true,

		set: function ( n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44 ) {

			var te = this.elements;

			te[ 0 ] = n11; te[ 4 ] = n12; te[ 8 ] = n13; te[ 12 ] = n14;
			te[ 1 ] = n21; te[ 5 ] = n22; te[ 9 ] = n23; te[ 13 ] = n24;
			te[ 2 ] = n31; te[ 6 ] = n32; te[ 10 ] = n33; te[ 14 ] = n34;
			te[ 3 ] = n41; te[ 7 ] = n42; te[ 11 ] = n43; te[ 15 ] = n44;

			return this;

		},

		identity: function () {

			this.set(

				1, 0, 0, 0,
				0, 1, 0, 0,
				0, 0, 1, 0,
				0, 0, 0, 1

			);

			return this;

		},

		clone: function () {

			return new Matrix4().fromArray( this.elements );

		},

		copy: function ( m ) {

			this.elements.set( m.elements );

			return this;

		},

		copyPosition: function ( m ) {

			var te = this.elements;
			var me = m.elements;

			te[ 12 ] = me[ 12 ];
			te[ 13 ] = me[ 13 ];
			te[ 14 ] = me[ 14 ];

			return this;

		},

		extractBasis: function ( xAxis, yAxis, zAxis ) {

			xAxis.setFromMatrixColumn( this, 0 );
			yAxis.setFromMatrixColumn( this, 1 );
			zAxis.setFromMatrixColumn( this, 2 );

			return this;

		},

		makeBasis: function ( xAxis, yAxis, zAxis ) {

			this.set(
				xAxis.x, yAxis.x, zAxis.x, 0,
				xAxis.y, yAxis.y, zAxis.y, 0,
				xAxis.z, yAxis.z, zAxis.z, 0,
				0,       0,       0,       1
			);

			return this;

		},

		extractRotation: function () {

			var v1;

			return function extractRotation( m ) {

				if ( v1 === undefined ) v1 = new Vector3();

				var te = this.elements;
				var me = m.elements;

				var scaleX = 1 / v1.setFromMatrixColumn( m, 0 ).length();
				var scaleY = 1 / v1.setFromMatrixColumn( m, 1 ).length();
				var scaleZ = 1 / v1.setFromMatrixColumn( m, 2 ).length();

				te[ 0 ] = me[ 0 ] * scaleX;
				te[ 1 ] = me[ 1 ] * scaleX;
				te[ 2 ] = me[ 2 ] * scaleX;

				te[ 4 ] = me[ 4 ] * scaleY;
				te[ 5 ] = me[ 5 ] * scaleY;
				te[ 6 ] = me[ 6 ] * scaleY;

				te[ 8 ] = me[ 8 ] * scaleZ;
				te[ 9 ] = me[ 9 ] * scaleZ;
				te[ 10 ] = me[ 10 ] * scaleZ;

				return this;

			};

		}(),

		makeRotationFromEuler: function ( euler ) {

			if ( (euler && euler.isEuler) === false ) {

				console.error( 'THREE.Matrix: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.' );

			}

			var te = this.elements;

			var x = euler.x, y = euler.y, z = euler.z;
			var a = Math.cos( x ), b = Math.sin( x );
			var c = Math.cos( y ), d = Math.sin( y );
			var e = Math.cos( z ), f = Math.sin( z );

			if ( euler.order === 'XYZ' ) {

				var ae = a * e, af = a * f, be = b * e, bf = b * f;

				te[ 0 ] = c * e;
				te[ 4 ] = - c * f;
				te[ 8 ] = d;

				te[ 1 ] = af + be * d;
				te[ 5 ] = ae - bf * d;
				te[ 9 ] = - b * c;

				te[ 2 ] = bf - ae * d;
				te[ 6 ] = be + af * d;
				te[ 10 ] = a * c;

			} else if ( euler.order === 'YXZ' ) {

				var ce = c * e, cf = c * f, de = d * e, df = d * f;

				te[ 0 ] = ce + df * b;
				te[ 4 ] = de * b - cf;
				te[ 8 ] = a * d;

				te[ 1 ] = a * f;
				te[ 5 ] = a * e;
				te[ 9 ] = - b;

				te[ 2 ] = cf * b - de;
				te[ 6 ] = df + ce * b;
				te[ 10 ] = a * c;

			} else if ( euler.order === 'ZXY' ) {

				var ce = c * e, cf = c * f, de = d * e, df = d * f;

				te[ 0 ] = ce - df * b;
				te[ 4 ] = - a * f;
				te[ 8 ] = de + cf * b;

				te[ 1 ] = cf + de * b;
				te[ 5 ] = a * e;
				te[ 9 ] = df - ce * b;

				te[ 2 ] = - a * d;
				te[ 6 ] = b;
				te[ 10 ] = a * c;

			} else if ( euler.order === 'ZYX' ) {

				var ae = a * e, af = a * f, be = b * e, bf = b * f;

				te[ 0 ] = c * e;
				te[ 4 ] = be * d - af;
				te[ 8 ] = ae * d + bf;

				te[ 1 ] = c * f;
				te[ 5 ] = bf * d + ae;
				te[ 9 ] = af * d - be;

				te[ 2 ] = - d;
				te[ 6 ] = b * c;
				te[ 10 ] = a * c;

			} else if ( euler.order === 'YZX' ) {

				var ac = a * c, ad = a * d, bc = b * c, bd = b * d;

				te[ 0 ] = c * e;
				te[ 4 ] = bd - ac * f;
				te[ 8 ] = bc * f + ad;

				te[ 1 ] = f;
				te[ 5 ] = a * e;
				te[ 9 ] = - b * e;

				te[ 2 ] = - d * e;
				te[ 6 ] = ad * f + bc;
				te[ 10 ] = ac - bd * f;

			} else if ( euler.order === 'XZY' ) {

				var ac = a * c, ad = a * d, bc = b * c, bd = b * d;

				te[ 0 ] = c * e;
				te[ 4 ] = - f;
				te[ 8 ] = d * e;

				te[ 1 ] = ac * f + bd;
				te[ 5 ] = a * e;
				te[ 9 ] = ad * f - bc;

				te[ 2 ] = bc * f - ad;
				te[ 6 ] = b * e;
				te[ 10 ] = bd * f + ac;

			}

			// last column
			te[ 3 ] = 0;
			te[ 7 ] = 0;
			te[ 11 ] = 0;

			// bottom row
			te[ 12 ] = 0;
			te[ 13 ] = 0;
			te[ 14 ] = 0;
			te[ 15 ] = 1;

			return this;

		},

		makeRotationFromQuaternion: function ( q ) {

			var te = this.elements;

			var x = q.x, y = q.y, z = q.z, w = q.w;
			var x2 = x + x, y2 = y + y, z2 = z + z;
			var xx = x * x2, xy = x * y2, xz = x * z2;
			var yy = y * y2, yz = y * z2, zz = z * z2;
			var wx = w * x2, wy = w * y2, wz = w * z2;

			te[ 0 ] = 1 - ( yy + zz );
			te[ 4 ] = xy - wz;
			te[ 8 ] = xz + wy;

			te[ 1 ] = xy + wz;
			te[ 5 ] = 1 - ( xx + zz );
			te[ 9 ] = yz - wx;

			te[ 2 ] = xz - wy;
			te[ 6 ] = yz + wx;
			te[ 10 ] = 1 - ( xx + yy );

			// last column
			te[ 3 ] = 0;
			te[ 7 ] = 0;
			te[ 11 ] = 0;

			// bottom row
			te[ 12 ] = 0;
			te[ 13 ] = 0;
			te[ 14 ] = 0;
			te[ 15 ] = 1;

			return this;

		},

		lookAt: function () {

			var x, y, z;

			return function lookAt( eye, target, up ) {

				if ( x === undefined ) {

					x = new Vector3();
					y = new Vector3();
					z = new Vector3();

				}

				var te = this.elements;

				z.subVectors( eye, target ).normalize();

				if ( z.lengthSq() === 0 ) {

					z.z = 1;

				}

				x.crossVectors( up, z ).normalize();

				if ( x.lengthSq() === 0 ) {

					z.z += 0.0001;
					x.crossVectors( up, z ).normalize();

				}

				y.crossVectors( z, x );


				te[ 0 ] = x.x; te[ 4 ] = y.x; te[ 8 ] = z.x;
				te[ 1 ] = x.y; te[ 5 ] = y.y; te[ 9 ] = z.y;
				te[ 2 ] = x.z; te[ 6 ] = y.z; te[ 10 ] = z.z;

				return this;

			};

		}(),

		multiply: function ( m, n ) {

			if ( n !== undefined ) {

				console.warn( 'THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.' );
				return this.multiplyMatrices( m, n );

			}

			return this.multiplyMatrices( this, m );

		},

		premultiply: function ( m ) {

			return this.multiplyMatrices( m, this );

		},

		multiplyMatrices: function ( a, b ) {

			var ae = a.elements;
			var be = b.elements;
			var te = this.elements;

			var a11 = ae[ 0 ], a12 = ae[ 4 ], a13 = ae[ 8 ], a14 = ae[ 12 ];
			var a21 = ae[ 1 ], a22 = ae[ 5 ], a23 = ae[ 9 ], a24 = ae[ 13 ];
			var a31 = ae[ 2 ], a32 = ae[ 6 ], a33 = ae[ 10 ], a34 = ae[ 14 ];
			var a41 = ae[ 3 ], a42 = ae[ 7 ], a43 = ae[ 11 ], a44 = ae[ 15 ];

			var b11 = be[ 0 ], b12 = be[ 4 ], b13 = be[ 8 ], b14 = be[ 12 ];
			var b21 = be[ 1 ], b22 = be[ 5 ], b23 = be[ 9 ], b24 = be[ 13 ];
			var b31 = be[ 2 ], b32 = be[ 6 ], b33 = be[ 10 ], b34 = be[ 14 ];
			var b41 = be[ 3 ], b42 = be[ 7 ], b43 = be[ 11 ], b44 = be[ 15 ];

			te[ 0 ] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
			te[ 4 ] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
			te[ 8 ] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
			te[ 12 ] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;

			te[ 1 ] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
			te[ 5 ] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
			te[ 9 ] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
			te[ 13 ] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;

			te[ 2 ] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
			te[ 6 ] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
			te[ 10 ] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
			te[ 14 ] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;

			te[ 3 ] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
			te[ 7 ] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
			te[ 11 ] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
			te[ 15 ] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;

			return this;

		},

		multiplyToArray: function ( a, b, r ) {

			var te = this.elements;

			this.multiplyMatrices( a, b );

			r[ 0 ] = te[ 0 ]; r[ 1 ] = te[ 1 ]; r[ 2 ] = te[ 2 ]; r[ 3 ] = te[ 3 ];
			r[ 4 ] = te[ 4 ]; r[ 5 ] = te[ 5 ]; r[ 6 ] = te[ 6 ]; r[ 7 ] = te[ 7 ];
			r[ 8 ]  = te[ 8 ]; r[ 9 ]  = te[ 9 ]; r[ 10 ] = te[ 10 ]; r[ 11 ] = te[ 11 ];
			r[ 12 ] = te[ 12 ]; r[ 13 ] = te[ 13 ]; r[ 14 ] = te[ 14 ]; r[ 15 ] = te[ 15 ];

			return this;

		},

		multiplyScalar: function ( s ) {

			var te = this.elements;

			te[ 0 ] *= s; te[ 4 ] *= s; te[ 8 ] *= s; te[ 12 ] *= s;
			te[ 1 ] *= s; te[ 5 ] *= s; te[ 9 ] *= s; te[ 13 ] *= s;
			te[ 2 ] *= s; te[ 6 ] *= s; te[ 10 ] *= s; te[ 14 ] *= s;
			te[ 3 ] *= s; te[ 7 ] *= s; te[ 11 ] *= s; te[ 15 ] *= s;

			return this;

		},

		applyToVector3Array: function () {

			var v1;

			return function applyToVector3Array( array, offset, length ) {

				if ( v1 === undefined ) v1 = new Vector3();
				if ( offset === undefined ) offset = 0;
				if ( length === undefined ) length = array.length;

				for ( var i = 0, j = offset; i < length; i += 3, j += 3 ) {

					v1.fromArray( array, j );
					v1.applyMatrix4( this );
					v1.toArray( array, j );

				}

				return array;

			};

		}(),

		applyToBufferAttribute: function () {

			var v1;

			return function applyToBufferAttribute( attribute ) {

				if ( v1 === undefined ) v1 = new Vector3();

				for ( var i = 0, l = attribute.count; i < l; i ++ ) {

					v1.x = attribute.getX( i );
					v1.y = attribute.getY( i );
					v1.z = attribute.getZ( i );

					v1.applyMatrix4( this );

					attribute.setXYZ( i, v1.x, v1.y, v1.z );

				}

				return attribute;

			};

		}(),

		determinant: function () {

			var te = this.elements;

			var n11 = te[ 0 ], n12 = te[ 4 ], n13 = te[ 8 ], n14 = te[ 12 ];
			var n21 = te[ 1 ], n22 = te[ 5 ], n23 = te[ 9 ], n24 = te[ 13 ];
			var n31 = te[ 2 ], n32 = te[ 6 ], n33 = te[ 10 ], n34 = te[ 14 ];
			var n41 = te[ 3 ], n42 = te[ 7 ], n43 = te[ 11 ], n44 = te[ 15 ];

			//TODO: make this more efficient
			//( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )

			return (
				n41 * (
					+ n14 * n23 * n32
					 - n13 * n24 * n32
					 - n14 * n22 * n33
					 + n12 * n24 * n33
					 + n13 * n22 * n34
					 - n12 * n23 * n34
				) +
				n42 * (
					+ n11 * n23 * n34
					 - n11 * n24 * n33
					 + n14 * n21 * n33
					 - n13 * n21 * n34
					 + n13 * n24 * n31
					 - n14 * n23 * n31
				) +
				n43 * (
					+ n11 * n24 * n32
					 - n11 * n22 * n34
					 - n14 * n21 * n32
					 + n12 * n21 * n34
					 + n14 * n22 * n31
					 - n12 * n24 * n31
				) +
				n44 * (
					- n13 * n22 * n31
					 - n11 * n23 * n32
					 + n11 * n22 * n33
					 + n13 * n21 * n32
					 - n12 * n21 * n33
					 + n12 * n23 * n31
				)

			);

		},

		transpose: function () {

			var te = this.elements;
			var tmp;

			tmp = te[ 1 ]; te[ 1 ] = te[ 4 ]; te[ 4 ] = tmp;
			tmp = te[ 2 ]; te[ 2 ] = te[ 8 ]; te[ 8 ] = tmp;
			tmp = te[ 6 ]; te[ 6 ] = te[ 9 ]; te[ 9 ] = tmp;

			tmp = te[ 3 ]; te[ 3 ] = te[ 12 ]; te[ 12 ] = tmp;
			tmp = te[ 7 ]; te[ 7 ] = te[ 13 ]; te[ 13 ] = tmp;
			tmp = te[ 11 ]; te[ 11 ] = te[ 14 ]; te[ 14 ] = tmp;

			return this;

		},

		setPosition: function ( v ) {

			var te = this.elements;

			te[ 12 ] = v.x;
			te[ 13 ] = v.y;
			te[ 14 ] = v.z;

			return this;

		},

		getInverse: function ( m, throwOnDegenerate ) {

			// based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
			var te = this.elements,
				me = m.elements,

				n11 = me[ 0 ], n21 = me[ 1 ], n31 = me[ 2 ], n41 = me[ 3 ],
				n12 = me[ 4 ], n22 = me[ 5 ], n32 = me[ 6 ], n42 = me[ 7 ],
				n13 = me[ 8 ], n23 = me[ 9 ], n33 = me[ 10 ], n43 = me[ 11 ],
				n14 = me[ 12 ], n24 = me[ 13 ], n34 = me[ 14 ], n44 = me[ 15 ],

				t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44,
				t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44,
				t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44,
				t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;

			var det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;

			if ( det === 0 ) {

				var msg = "THREE.Matrix4.getInverse(): can't invert matrix, determinant is 0";

				if ( throwOnDegenerate === true ) {

					throw new Error( msg );

				} else {

					console.warn( msg );

				}

				return this.identity();

			}

			var detInv = 1 / det;

			te[ 0 ] = t11 * detInv;
			te[ 1 ] = ( n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44 ) * detInv;
			te[ 2 ] = ( n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44 ) * detInv;
			te[ 3 ] = ( n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43 ) * detInv;

			te[ 4 ] = t12 * detInv;
			te[ 5 ] = ( n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44 ) * detInv;
			te[ 6 ] = ( n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44 ) * detInv;
			te[ 7 ] = ( n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43 ) * detInv;

			te[ 8 ] = t13 * detInv;
			te[ 9 ] = ( n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44 ) * detInv;
			te[ 10 ] = ( n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44 ) * detInv;
			te[ 11 ] = ( n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43 ) * detInv;

			te[ 12 ] = t14 * detInv;
			te[ 13 ] = ( n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34 ) * detInv;
			te[ 14 ] = ( n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34 ) * detInv;
			te[ 15 ] = ( n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33 ) * detInv;

			return this;

		},

		scale: function ( v ) {

			var te = this.elements;
			var x = v.x, y = v.y, z = v.z;

			te[ 0 ] *= x; te[ 4 ] *= y; te[ 8 ] *= z;
			te[ 1 ] *= x; te[ 5 ] *= y; te[ 9 ] *= z;
			te[ 2 ] *= x; te[ 6 ] *= y; te[ 10 ] *= z;
			te[ 3 ] *= x; te[ 7 ] *= y; te[ 11 ] *= z;

			return this;

		},

		getMaxScaleOnAxis: function () {

			var te = this.elements;

			var scaleXSq = te[ 0 ] * te[ 0 ] + te[ 1 ] * te[ 1 ] + te[ 2 ] * te[ 2 ];
			var scaleYSq = te[ 4 ] * te[ 4 ] + te[ 5 ] * te[ 5 ] + te[ 6 ] * te[ 6 ];
			var scaleZSq = te[ 8 ] * te[ 8 ] + te[ 9 ] * te[ 9 ] + te[ 10 ] * te[ 10 ];

			return Math.sqrt( Math.max( scaleXSq, scaleYSq, scaleZSq ) );

		},

		makeTranslation: function ( x, y, z ) {

			this.set(

				1, 0, 0, x,
				0, 1, 0, y,
				0, 0, 1, z,
				0, 0, 0, 1

			);

			return this;

		},

		makeRotationX: function ( theta ) {

			var c = Math.cos( theta ), s = Math.sin( theta );

			this.set(

				1, 0,  0, 0,
				0, c, - s, 0,
				0, s,  c, 0,
				0, 0,  0, 1

			);

			return this;

		},

		makeRotationY: function ( theta ) {

			var c = Math.cos( theta ), s = Math.sin( theta );

			this.set(

				 c, 0, s, 0,
				 0, 1, 0, 0,
				- s, 0, c, 0,
				 0, 0, 0, 1

			);

			return this;

		},

		makeRotationZ: function ( theta ) {

			var c = Math.cos( theta ), s = Math.sin( theta );

			this.set(

				c, - s, 0, 0,
				s,  c, 0, 0,
				0,  0, 1, 0,
				0,  0, 0, 1

			);

			return this;

		},

		makeRotationAxis: function ( axis, angle ) {

			// Based on http://www.gamedev.net/reference/articles/article1199.asp

			var c = Math.cos( angle );
			var s = Math.sin( angle );
			var t = 1 - c;
			var x = axis.x, y = axis.y, z = axis.z;
			var tx = t * x, ty = t * y;

			this.set(

				tx * x + c, tx * y - s * z, tx * z + s * y, 0,
				tx * y + s * z, ty * y + c, ty * z - s * x, 0,
				tx * z - s * y, ty * z + s * x, t * z * z + c, 0,
				0, 0, 0, 1

			);

			 return this;

		},

		makeScale: function ( x, y, z ) {

			this.set(

				x, 0, 0, 0,
				0, y, 0, 0,
				0, 0, z, 0,
				0, 0, 0, 1

			);

			return this;

		},

		makeShear: function ( x, y, z ) {

			this.set(

				1, y, z, 0,
				x, 1, z, 0,
				x, y, 1, 0,
				0, 0, 0, 1

			);

			return this;

		},

		compose: function ( position, quaternion, scale ) {

			this.makeRotationFromQuaternion( quaternion );
			this.scale( scale );
			this.setPosition( position );

			return this;

		},

		decompose: function () {

			var vector, matrix;

			return function decompose( position, quaternion, scale ) {

				if ( vector === undefined ) {

					vector = new Vector3();
					matrix = new Matrix4();

				}

				var te = this.elements;

				var sx = vector.set( te[ 0 ], te[ 1 ], te[ 2 ] ).length();
				var sy = vector.set( te[ 4 ], te[ 5 ], te[ 6 ] ).length();
				var sz = vector.set( te[ 8 ], te[ 9 ], te[ 10 ] ).length();

				// if determine is negative, we need to invert one scale
				var det = this.determinant();
				if ( det < 0 ) {

					sx = - sx;

				}

				position.x = te[ 12 ];
				position.y = te[ 13 ];
				position.z = te[ 14 ];

				// scale the rotation part

				matrix.elements.set( this.elements ); // at this point matrix is incomplete so we can't use .copy()

				var invSX = 1 / sx;
				var invSY = 1 / sy;
				var invSZ = 1 / sz;

				matrix.elements[ 0 ] *= invSX;
				matrix.elements[ 1 ] *= invSX;
				matrix.elements[ 2 ] *= invSX;

				matrix.elements[ 4 ] *= invSY;
				matrix.elements[ 5 ] *= invSY;
				matrix.elements[ 6 ] *= invSY;

				matrix.elements[ 8 ] *= invSZ;
				matrix.elements[ 9 ] *= invSZ;
				matrix.elements[ 10 ] *= invSZ;

				quaternion.setFromRotationMatrix( matrix );

				scale.x = sx;
				scale.y = sy;
				scale.z = sz;

				return this;

			};

		}(),

		makeFrustum: function ( left, right, bottom, top, near, far ) {

			var te = this.elements;
			var x = 2 * near / ( right - left );
			var y = 2 * near / ( top - bottom );

			var a = ( right + left ) / ( right - left );
			var b = ( top + bottom ) / ( top - bottom );
			var c = - ( far + near ) / ( far - near );
			var d = - 2 * far * near / ( far - near );

			te[ 0 ] = x;	te[ 4 ] = 0;	te[ 8 ] = a;	te[ 12 ] = 0;
			te[ 1 ] = 0;	te[ 5 ] = y;	te[ 9 ] = b;	te[ 13 ] = 0;
			te[ 2 ] = 0;	te[ 6 ] = 0;	te[ 10 ] = c;	te[ 14 ] = d;
			te[ 3 ] = 0;	te[ 7 ] = 0;	te[ 11 ] = - 1;	te[ 15 ] = 0;

			return this;

		},

		makePerspective: function ( fov, aspect, near, far ) {

			var ymax = near * Math.tan( _Math.DEG2RAD * fov * 0.5 );
			var ymin = - ymax;
			var xmin = ymin * aspect;
			var xmax = ymax * aspect;

			return this.makeFrustum( xmin, xmax, ymin, ymax, near, far );

		},

		makeOrthographic: function ( left, right, top, bottom, near, far ) {

			var te = this.elements;
			var w = 1.0 / ( right - left );
			var h = 1.0 / ( top - bottom );
			var p = 1.0 / ( far - near );

			var x = ( right + left ) * w;
			var y = ( top + bottom ) * h;
			var z = ( far + near ) * p;

			te[ 0 ] = 2 * w;	te[ 4 ] = 0;	te[ 8 ] = 0;	te[ 12 ] = - x;
			te[ 1 ] = 0;	te[ 5 ] = 2 * h;	te[ 9 ] = 0;	te[ 13 ] = - y;
			te[ 2 ] = 0;	te[ 6 ] = 0;	te[ 10 ] = - 2 * p;	te[ 14 ] = - z;
			te[ 3 ] = 0;	te[ 7 ] = 0;	te[ 11 ] = 0;	te[ 15 ] = 1;

			return this;

		},

		equals: function ( matrix ) {

			var te = this.elements;
			var me = matrix.elements;

			for ( var i = 0; i < 16; i ++ ) {

				if ( te[ i ] !== me[ i ] ) return false;

			}

			return true;

		},

		fromArray: function ( array, offset ) {

			if ( offset === undefined ) offset = 0;

			for( var i = 0; i < 16; i ++ ) {

				this.elements[ i ] = array[ i + offset ];

			}

			return this;

		},

		toArray: function ( array, offset ) {

			if ( array === undefined ) array = [];
			if ( offset === undefined ) offset = 0;

			var te = this.elements;

			array[ offset ] = te[ 0 ];
			array[ offset + 1 ] = te[ 1 ];
			array[ offset + 2 ] = te[ 2 ];
			array[ offset + 3 ] = te[ 3 ];

			array[ offset + 4 ] = te[ 4 ];
			array[ offset + 5 ] = te[ 5 ];
			array[ offset + 6 ] = te[ 6 ];
			array[ offset + 7 ] = te[ 7 ];

			array[ offset + 8 ]  = te[ 8 ];
			array[ offset + 9 ]  = te[ 9 ];
			array[ offset + 10 ] = te[ 10 ];
			array[ offset + 11 ] = te[ 11 ];

			array[ offset + 12 ] = te[ 12 ];
			array[ offset + 13 ] = te[ 13 ];
			array[ offset + 14 ] = te[ 14 ];
			array[ offset + 15 ] = te[ 15 ];

			return array;

		}

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function CubeTexture( images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding ) {

		images = images !== undefined ? images : [];
		mapping = mapping !== undefined ? mapping : CubeReflectionMapping;

		Texture.call( this, images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );

		this.flipY = false;

	}

	CubeTexture.prototype = Object.create( Texture.prototype );
	CubeTexture.prototype.constructor = CubeTexture;

	CubeTexture.prototype.isCubeTexture = true;

	Object.defineProperty( CubeTexture.prototype, 'images', {

		get: function () {

			return this.image;

		},

		set: function ( value ) {

			this.image = value;

		}

	} );

	/**
	 * @author tschw
	 *
	 * Uniforms of a program.
	 * Those form a tree structure with a special top-level container for the root,
	 * which you get by calling 'new WebGLUniforms( gl, program, renderer )'.
	 *
	 *
	 * Properties of inner nodes including the top-level container:
	 *
	 * .seq - array of nested uniforms
	 * .map - nested uniforms by name
	 *
	 *
	 * Methods of all nodes except the top-level container:
	 *
	 * .setValue( gl, value, [renderer] )
	 *
	 * 		uploads a uniform value(s)
	 *  	the 'renderer' parameter is needed for sampler uniforms
	 *
	 *
	 * Static methods of the top-level container (renderer factorizations):
	 *
	 * .upload( gl, seq, values, renderer )
	 *
	 * 		sets uniforms in 'seq' to 'values[id].value'
	 *
	 * .seqWithValue( seq, values ) : filteredSeq
	 *
	 * 		filters 'seq' entries with corresponding entry in values
	 *
	 *
	 * Methods of the top-level container (renderer factorizations):
	 *
	 * .setValue( gl, name, value )
	 *
	 * 		sets uniform with  name 'name' to 'value'
	 *
	 * .set( gl, obj, prop )
	 *
	 * 		sets uniform from object and property with same name than uniform
	 *
	 * .setOptional( gl, obj, prop )
	 *
	 * 		like .set for an optional property of the object
	 *
	 */

	var emptyTexture = new Texture();
	var emptyCubeTexture = new CubeTexture();

	// --- Base for inner nodes (including the root) ---

	function UniformContainer() {

		this.seq = [];
		this.map = {};

	}

	// --- Utilities ---

	// Array Caches (provide typed arrays for temporary by size)

	var arrayCacheF32 = [];
	var arrayCacheI32 = [];

	// Flattening for arrays of vectors and matrices

	function flatten( array, nBlocks, blockSize ) {

		var firstElem = array[ 0 ];

		if ( firstElem <= 0 || firstElem > 0 ) return array;
		// unoptimized: ! isNaN( firstElem )
		// see http://jacksondunstan.com/articles/983

		var n = nBlocks * blockSize,
			r = arrayCacheF32[ n ];

		if ( r === undefined ) {

			r = new Float32Array( n );
			arrayCacheF32[ n ] = r;

		}

		if ( nBlocks !== 0 ) {

			firstElem.toArray( r, 0 );

			for ( var i = 1, offset = 0; i !== nBlocks; ++ i ) {

				offset += blockSize;
				array[ i ].toArray( r, offset );

			}

		}

		return r;

	}

	// Texture unit allocation

	function allocTexUnits( renderer, n ) {

		var r = arrayCacheI32[ n ];

		if ( r === undefined ) {

			r = new Int32Array( n );
			arrayCacheI32[ n ] = r;

		}

		for ( var i = 0; i !== n; ++ i )
			r[ i ] = renderer.allocTextureUnit();

		return r;

	}

	// --- Setters ---

	// Note: Defining these methods externally, because they come in a bunch
	// and this way their names minify.

	// Single scalar

	function setValue1f( gl, v ) { gl.uniform1f( this.addr, v ); }
	function setValue1i( gl, v ) { gl.uniform1i( this.addr, v ); }

	// Single float vector (from flat array or THREE.VectorN)

	function setValue2fv( gl, v ) {

		if ( v.x === undefined ) gl.uniform2fv( this.addr, v );
		else gl.uniform2f( this.addr, v.x, v.y );

	}

	function setValue3fv( gl, v ) {

		if ( v.x !== undefined )
			gl.uniform3f( this.addr, v.x, v.y, v.z );
		else if ( v.r !== undefined )
			gl.uniform3f( this.addr, v.r, v.g, v.b );
		else
			gl.uniform3fv( this.addr, v );

	}

	function setValue4fv( gl, v ) {

		if ( v.x === undefined ) gl.uniform4fv( this.addr, v );
		else gl.uniform4f( this.addr, v.x, v.y, v.z, v.w );

	}

	// Single matrix (from flat array or MatrixN)

	function setValue2fm( gl, v ) {

		gl.uniformMatrix2fv( this.addr, false, v.elements || v );

	}

	function setValue3fm( gl, v ) {

		gl.uniformMatrix3fv( this.addr, false, v.elements || v );

	}

	function setValue4fm( gl, v ) {

		gl.uniformMatrix4fv( this.addr, false, v.elements || v );

	}

	// Single texture (2D / Cube)

	function setValueT1( gl, v, renderer ) {

		var unit = renderer.allocTextureUnit();
		gl.uniform1i( this.addr, unit );
		renderer.setTexture2D( v || emptyTexture, unit );

	}

	function setValueT6( gl, v, renderer ) {

		var unit = renderer.allocTextureUnit();
		gl.uniform1i( this.addr, unit );
		renderer.setTextureCube( v || emptyCubeTexture, unit );

	}

	// Integer / Boolean vectors or arrays thereof (always flat arrays)

	function setValue2iv( gl, v ) { gl.uniform2iv( this.addr, v ); }
	function setValue3iv( gl, v ) { gl.uniform3iv( this.addr, v ); }
	function setValue4iv( gl, v ) { gl.uniform4iv( this.addr, v ); }

	// Helper to pick the right setter for the singular case

	function getSingularSetter( type ) {

		switch ( type ) {

			case 0x1406: return setValue1f; // FLOAT
			case 0x8b50: return setValue2fv; // _VEC2
			case 0x8b51: return setValue3fv; // _VEC3
			case 0x8b52: return setValue4fv; // _VEC4

			case 0x8b5a: return setValue2fm; // _MAT2
			case 0x8b5b: return setValue3fm; // _MAT3
			case 0x8b5c: return setValue4fm; // _MAT4

			case 0x8b5e: return setValueT1; // SAMPLER_2D
			case 0x8b60: return setValueT6; // SAMPLER_CUBE

			case 0x1404: case 0x8b56: return setValue1i; // INT, BOOL
			case 0x8b53: case 0x8b57: return setValue2iv; // _VEC2
			case 0x8b54: case 0x8b58: return setValue3iv; // _VEC3
			case 0x8b55: case 0x8b59: return setValue4iv; // _VEC4

		}

	}

	// Array of scalars

	function setValue1fv( gl, v ) { gl.uniform1fv( this.addr, v ); }
	function setValue1iv( gl, v ) { gl.uniform1iv( this.addr, v ); }

	// Array of vectors (flat or from THREE classes)

	function setValueV2a( gl, v ) {

		gl.uniform2fv( this.addr, flatten( v, this.size, 2 ) );

	}

	function setValueV3a( gl, v ) {

		gl.uniform3fv( this.addr, flatten( v, this.size, 3 ) );

	}

	function setValueV4a( gl, v ) {

		gl.uniform4fv( this.addr, flatten( v, this.size, 4 ) );

	}

	// Array of matrices (flat or from THREE clases)

	function setValueM2a( gl, v ) {

		gl.uniformMatrix2fv( this.addr, false, flatten( v, this.size, 4 ) );

	}

	function setValueM3a( gl, v ) {

		gl.uniformMatrix3fv( this.addr, false, flatten( v, this.size, 9 ) );

	}

	function setValueM4a( gl, v ) {

		gl.uniformMatrix4fv( this.addr, false, flatten( v, this.size, 16 ) );

	}

	// Array of textures (2D / Cube)

	function setValueT1a( gl, v, renderer ) {

		var n = v.length,
			units = allocTexUnits( renderer, n );

		gl.uniform1iv( this.addr, units );

		for ( var i = 0; i !== n; ++ i ) {

			renderer.setTexture2D( v[ i ] || emptyTexture, units[ i ] );

		}

	}

	function setValueT6a( gl, v, renderer ) {

		var n = v.length,
			units = allocTexUnits( renderer, n );

		gl.uniform1iv( this.addr, units );

		for ( var i = 0; i !== n; ++ i ) {

			renderer.setTextureCube( v[ i ] || emptyCubeTexture, units[ i ] );

		}

	}

	// Helper to pick the right setter for a pure (bottom-level) array

	function getPureArraySetter( type ) {

		switch ( type ) {

			case 0x1406: return setValue1fv; // FLOAT
			case 0x8b50: return setValueV2a; // _VEC2
			case 0x8b51: return setValueV3a; // _VEC3
			case 0x8b52: return setValueV4a; // _VEC4

			case 0x8b5a: return setValueM2a; // _MAT2
			case 0x8b5b: return setValueM3a; // _MAT3
			case 0x8b5c: return setValueM4a; // _MAT4

			case 0x8b5e: return setValueT1a; // SAMPLER_2D
			case 0x8b60: return setValueT6a; // SAMPLER_CUBE

			case 0x1404: case 0x8b56: return setValue1iv; // INT, BOOL
			case 0x8b53: case 0x8b57: return setValue2iv; // _VEC2
			case 0x8b54: case 0x8b58: return setValue3iv; // _VEC3
			case 0x8b55: case 0x8b59: return setValue4iv; // _VEC4

		}

	}

	// --- Uniform Classes ---

	function SingleUniform( id, activeInfo, addr ) {

		this.id = id;
		this.addr = addr;
		this.setValue = getSingularSetter( activeInfo.type );

		// this.path = activeInfo.name; // DEBUG

	}

	function PureArrayUniform( id, activeInfo, addr ) {

		this.id = id;
		this.addr = addr;
		this.size = activeInfo.size;
		this.setValue = getPureArraySetter( activeInfo.type );

		// this.path = activeInfo.name; // DEBUG

	}

	function StructuredUniform( id ) {

		this.id = id;

		UniformContainer.call( this ); // mix-in

	}

	StructuredUniform.prototype.setValue = function( gl, value ) {

		// Note: Don't need an extra 'renderer' parameter, since samplers
		// are not allowed in structured uniforms.

		var seq = this.seq;

		for ( var i = 0, n = seq.length; i !== n; ++ i ) {

			var u = seq[ i ];
			u.setValue( gl, value[ u.id ] );

		}

	};

	// --- Top-level ---

	// Parser - builds up the property tree from the path strings

	var RePathPart = /([\w\d_]+)(\])?(\[|\.)?/g;

	// extracts
	// 	- the identifier (member name or array index)
	//  - followed by an optional right bracket (found when array index)
	//  - followed by an optional left bracket or dot (type of subscript)
	//
	// Note: These portions can be read in a non-overlapping fashion and
	// allow straightforward parsing of the hierarchy that WebGL encodes
	// in the uniform names.

	function addUniform( container, uniformObject ) {

		container.seq.push( uniformObject );
		container.map[ uniformObject.id ] = uniformObject;

	}

	function parseUniform( activeInfo, addr, container ) {

		var path = activeInfo.name,
			pathLength = path.length;

		// reset RegExp object, because of the early exit of a previous run
		RePathPart.lastIndex = 0;

		for (; ;) {

			var match = RePathPart.exec( path ),
				matchEnd = RePathPart.lastIndex,

				id = match[ 1 ],
				idIsIndex = match[ 2 ] === ']',
				subscript = match[ 3 ];

			if ( idIsIndex ) id = id | 0; // convert to integer

			if ( subscript === undefined ||
					subscript === '[' && matchEnd + 2 === pathLength ) {
				// bare name or "pure" bottom-level array "[0]" suffix

				addUniform( container, subscript === undefined ?
						new SingleUniform( id, activeInfo, addr ) :
						new PureArrayUniform( id, activeInfo, addr ) );

				break;

			} else {
				// step into inner node / create it in case it doesn't exist

				var map = container.map,
					next = map[ id ];

				if ( next === undefined ) {

					next = new StructuredUniform( id );
					addUniform( container, next );

				}

				container = next;

			}

		}

	}

	// Root Container

	function WebGLUniforms( gl, program, renderer ) {

		UniformContainer.call( this );

		this.renderer = renderer;

		var n = gl.getProgramParameter( program, gl.ACTIVE_UNIFORMS );

		for ( var i = 0; i !== n; ++ i ) {

			var info = gl.getActiveUniform( program, i ),
				path = info.name,
				addr = gl.getUniformLocation( program, path );

			parseUniform( info, addr, this );

		}

	}

	WebGLUniforms.prototype.setValue = function( gl, name, value ) {

		var u = this.map[ name ];

		if ( u !== undefined ) u.setValue( gl, value, this.renderer );

	};

	WebGLUniforms.prototype.set = function( gl, object, name ) {

		var u = this.map[ name ];

		if ( u !== undefined ) u.setValue( gl, object[ name ], this.renderer );

	};

	WebGLUniforms.prototype.setOptional = function( gl, object, name ) {

		var v = object[ name ];

		if ( v !== undefined ) this.setValue( gl, name, v );

	};


	// Static interface

	WebGLUniforms.upload = function( gl, seq, values, renderer ) {

		for ( var i = 0, n = seq.length; i !== n; ++ i ) {

			var u = seq[ i ],
				v = values[ u.id ];

			if ( v.needsUpdate !== false ) {
				// note: always updating when .needsUpdate is undefined

				u.setValue( gl, v.value, renderer );

			}

		}

	};

	WebGLUniforms.seqWithValue = function( seq, values ) {

		var r = [];

		for ( var i = 0, n = seq.length; i !== n; ++ i ) {

			var u = seq[ i ];
			if ( u.id in values ) r.push( u );

		}

		return r;

	};

	/**
	 * Uniform Utilities
	 */

	var UniformsUtils = {

		merge: function ( uniforms ) {

			var merged = {};

			for ( var u = 0; u < uniforms.length; u ++ ) {

				var tmp = this.clone( uniforms[ u ] );

				for ( var p in tmp ) {

					merged[ p ] = tmp[ p ];

				}

			}

			return merged;

		},

		clone: function ( uniforms_src ) {

			var uniforms_dst = {};

			for ( var u in uniforms_src ) {

				uniforms_dst[ u ] = {};

				for ( var p in uniforms_src[ u ] ) {

					var parameter_src = uniforms_src[ u ][ p ];

					if ( parameter_src && ( parameter_src.isColor ||
						parameter_src.isMatrix3 || parameter_src.isMatrix4 ||
						parameter_src.isVector2 || parameter_src.isVector3 || parameter_src.isVector4 ||
						parameter_src.isTexture ) ) {

						uniforms_dst[ u ][ p ] = parameter_src.clone();

					} else if ( Array.isArray( parameter_src ) ) {

						uniforms_dst[ u ][ p ] = parameter_src.slice();

					} else {

						uniforms_dst[ u ][ p ] = parameter_src;

					}

				}

			}

			return uniforms_dst;

		}

	};

	var alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif\n";

	var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif\n";

	var alphatest_fragment = "#ifdef ALPHATEST\n\tif ( diffuseColor.a < ALPHATEST ) discard;\n#endif\n";

	var aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.specularRoughness );\n\t#endif\n#endif\n";

	var aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";

	var begin_vertex = "\nvec3 transformed = vec3( position );\n";

	var beginnormal_vertex = "\nvec3 objectNormal = vec3( normal );\n";

	var bsdfs = "float punctualLightIntensityToIrradianceFactor( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\t\tif( decayExponent > 0.0 ) {\n#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\t\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\t\tfloat maxDistanceCutoffFactor = pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\t\treturn distanceFalloff * maxDistanceCutoffFactor;\n#else\n\t\t\treturn pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );\n#endif\n\t\t}\n\t\treturn 1.0;\n}\nvec3 BRDF_Diffuse_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 specularColor, const in float dotLH ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotLH - 6.98316 ) * dotLH );\n\treturn ( 1.0 - specularColor ) * fresnel + specularColor;\n}\nfloat G_GGX_Smith( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gl = dotNL + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\tfloat gv = dotNV + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\treturn 1.0 / ( gl * gv );\n}\nfloat G_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_Specular_GGX( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNL = saturate( dot( geometry.normal, incidentLight.direction ) );\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( G * D );\n}\nvec2 ltcTextureCoords( const in GeometricContext geometry, const in float roughness ) {\n\tconst float LUT_SIZE  = 64.0;\n\tconst float LUT_SCALE = (LUT_SIZE - 1.0)/LUT_SIZE;\n\tconst float LUT_BIAS  = 0.5/LUT_SIZE;\n\tvec3 N = geometry.normal;\n\tvec3 V = geometry.viewDir;\n\tvec3 P = geometry.position;\n\tfloat theta = acos( dot( N, V ) );\n\tvec2 uv = vec2(\n\t\tsqrt( saturate( roughness ) ),\n\t\tsaturate( theta / ( 0.5 * PI ) ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nvoid clipQuadToHorizon( inout vec3 L[5], out int n ) {\n\tint config = 0;\n\tif ( L[0].z > 0.0 ) config += 1;\n\tif ( L[1].z > 0.0 ) config += 2;\n\tif ( L[2].z > 0.0 ) config += 4;\n\tif ( L[3].z > 0.0 ) config += 8;\n\tn = 0;\n\tif ( config == 0 ) {\n\t} else if ( config == 1 ) {\n\t\tn = 3;\n\t\tL[1] = -L[1].z * L[0] + L[0].z * L[1];\n\t\tL[2] = -L[3].z * L[0] + L[0].z * L[3];\n\t} else if ( config == 2 ) {\n\t\tn = 3;\n\t\tL[0] = -L[0].z * L[1] + L[1].z * L[0];\n\t\tL[2] = -L[2].z * L[1] + L[1].z * L[2];\n\t} else if ( config == 3 ) {\n\t\tn = 4;\n\t\tL[2] = -L[2].z * L[1] + L[1].z * L[2];\n\t\tL[3] = -L[3].z * L[0] + L[0].z * L[3];\n\t} else if ( config == 4 ) {\n\t\tn = 3;\n\t\tL[0] = -L[3].z * L[2] + L[2].z * L[3];\n\t\tL[1] = -L[1].z * L[2] + L[2].z * L[1];\n\t} else if ( config == 5 ) {\n\t\tn = 0;\n\t} else if ( config == 6 ) {\n\t\tn = 4;\n\t\tL[0] = -L[0].z * L[1] + L[1].z * L[0];\n\t\tL[3] = -L[3].z * L[2] + L[2].z * L[3];\n\t} else if ( config == 7 ) {\n\t\tn = 5;\n\t\tL[4] = -L[3].z * L[0] + L[0].z * L[3];\n\t\tL[3] = -L[3].z * L[2] + L[2].z * L[3];\n\t} else if ( config == 8 ) {\n\t\tn = 3;\n\t\tL[0] = -L[0].z * L[3] + L[3].z * L[0];\n\t\tL[1] = -L[2].z * L[3] + L[3].z * L[2];\n\t\tL[2] =  L[3];\n\t} else if ( config == 9 ) {\n\t\tn = 4;\n\t\tL[1] = -L[1].z * L[0] + L[0].z * L[1];\n\t\tL[2] = -L[2].z * L[3] + L[3].z * L[2];\n\t} else if ( config == 10 ) {\n\t\tn = 0;\n\t} else if ( config == 11 ) {\n\t\tn = 5;\n\t\tL[4] = L[3];\n\t\tL[3] = -L[2].z * L[3] + L[3].z * L[2];\n\t\tL[2] = -L[2].z * L[1] + L[1].z * L[2];\n\t} else if ( config == 12 ) {\n\t\tn = 4;\n\t\tL[1] = -L[1].z * L[2] + L[2].z * L[1];\n\t\tL[0] = -L[0].z * L[3] + L[3].z * L[0];\n\t} else if ( config == 13 ) {\n\t\tn = 5;\n\t\tL[4] = L[3];\n\t\tL[3] = L[2];\n\t\tL[2] = -L[1].z * L[2] + L[2].z * L[1];\n\t\tL[1] = -L[1].z * L[0] + L[0].z * L[1];\n\t} else if ( config == 14 ) {\n\t\tn = 5;\n\t\tL[4] = -L[0].z * L[3] + L[3].z * L[0];\n\t\tL[0] = -L[0].z * L[1] + L[1].z * L[0];\n\t} else if ( config == 15 ) {\n\t\tn = 4;\n\t}\n\tif ( n == 3 )\n\t\tL[3] = L[0];\n\tif ( n == 4 )\n\t\tL[4] = L[0];\n}\nfloat integrateLtcBrdfOverRectEdge( vec3 v1, vec3 v2 ) {\n\tfloat cosTheta = dot( v1, v2 );\n\tfloat theta = acos( cosTheta );\n\tfloat res = cross( v1, v2 ).z * ( ( theta > 0.001 ) ? theta / sin( theta ) : 1.0 );\n\treturn res;\n}\nvoid initRectPoints( const in vec3 pos, const in vec3 halfWidth, const in vec3 halfHeight, out vec3 rectPoints[4] ) {\n\trectPoints[0] = pos - halfWidth - halfHeight;\n\trectPoints[1] = pos + halfWidth - halfHeight;\n\trectPoints[2] = pos + halfWidth + halfHeight;\n\trectPoints[3] = pos - halfWidth + halfHeight;\n}\nvec3 integrateLtcBrdfOverRect( const in GeometricContext geometry, const in mat3 brdfMat, const in vec3 rectPoints[4] ) {\n\tvec3 N = geometry.normal;\n\tvec3 V = geometry.viewDir;\n\tvec3 P = geometry.position;\n\tvec3 T1, T2;\n\tT1 = normalize(V - N * dot( V, N ));\n\tT2 = - cross( N, T1 );\n\tmat3 brdfWrtSurface = brdfMat * transpose( mat3( T1, T2, N ) );\n\tvec3 clippedRect[5];\n\tclippedRect[0] = brdfWrtSurface * ( rectPoints[0] - P );\n\tclippedRect[1] = brdfWrtSurface * ( rectPoints[1] - P );\n\tclippedRect[2] = brdfWrtSurface * ( rectPoints[2] - P );\n\tclippedRect[3] = brdfWrtSurface * ( rectPoints[3] - P );\n\tint n;\n\tclipQuadToHorizon(clippedRect, n);\n\tif ( n == 0 )\n\t\treturn vec3( 0, 0, 0 );\n\tclippedRect[0] = normalize( clippedRect[0] );\n\tclippedRect[1] = normalize( clippedRect[1] );\n\tclippedRect[2] = normalize( clippedRect[2] );\n\tclippedRect[3] = normalize( clippedRect[3] );\n\tclippedRect[4] = normalize( clippedRect[4] );\n\tfloat sum = 0.0;\n\tsum += integrateLtcBrdfOverRectEdge( clippedRect[0], clippedRect[1] );\n\tsum += integrateLtcBrdfOverRectEdge( clippedRect[1], clippedRect[2] );\n\tsum += integrateLtcBrdfOverRectEdge( clippedRect[2], clippedRect[3] );\n\tif (n >= 4)\n\t\tsum += integrateLtcBrdfOverRectEdge( clippedRect[3], clippedRect[4] );\n\tif (n == 5)\n\t\tsum += integrateLtcBrdfOverRectEdge( clippedRect[4], clippedRect[0] );\n\tsum = max( 0.0, sum );\n\tvec3 Lo_i = vec3( sum, sum, sum );\n\treturn Lo_i;\n}\nvec3 Rect_Area_Light_Specular_Reflectance(\n\t\tconst in GeometricContext geometry,\n\t\tconst in vec3 lightPos, const in vec3 lightHalfWidth, const in vec3 lightHalfHeight,\n\t\tconst in float roughness,\n\t\tconst in sampler2D ltcMat, const in sampler2D ltcMag ) {\n\tvec3 rectPoints[4];\n\tinitRectPoints( lightPos, lightHalfWidth, lightHalfHeight, rectPoints );\n\tvec2 uv = ltcTextureCoords( geometry, roughness );\n\tvec4 brdfLtcApproxParams, t;\n\tbrdfLtcApproxParams = texture2D( ltcMat, uv );\n\tt = texture2D( ltcMat, uv );\n\tfloat brdfLtcScalar = texture2D( ltcMag, uv ).a;\n\tmat3 brdfLtcApproxMat = mat3(\n\t\tvec3(   1,   0, t.y ),\n\t\tvec3(   0, t.z,   0 ),\n\t\tvec3( t.w,   0, t.x )\n\t);\n\tvec3 specularReflectance = integrateLtcBrdfOverRect( geometry, brdfLtcApproxMat, rectPoints );\n\tspecularReflectance *= brdfLtcScalar;\n\treturn specularReflectance;\n}\nvec3 Rect_Area_Light_Diffuse_Reflectance(\n\t\tconst in GeometricContext geometry,\n\t\tconst in vec3 lightPos, const in vec3 lightHalfWidth, const in vec3 lightHalfHeight ) {\n\tvec3 rectPoints[4];\n\tinitRectPoints( lightPos, lightHalfWidth, lightHalfHeight, rectPoints );\n\tmat3 diffuseBrdfMat = mat3(1);\n\tvec3 diffuseReflectance = integrateLtcBrdfOverRect( geometry, diffuseBrdfMat, rectPoints );\n\treturn diffuseReflectance;\n}\nvec3 BRDF_Specular_GGX_Environment( const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 AB = vec2( -1.04, 1.04 ) * a004 + r.zw;\n\treturn specularColor * AB.x + AB.y;\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_Specular_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\nfloat GGXRoughnessToBlinnExponent( const in float ggxRoughness ) {\n\treturn ( 2.0 / pow2( ggxRoughness + 0.0001 ) - 2.0 );\n}\nfloat BlinnExponentToGGXRoughness( const in float blinnExponent ) {\n\treturn sqrt( 2.0 / ( blinnExponent + 2.0 ) );\n}\n";

	var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy ) {\n\t\tvec3 vSigmaX = dFdx( surf_pos );\n\t\tvec3 vSigmaY = dFdy( surf_pos );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 );\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif\n";

	var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; ++ i ) {\n\t\tvec4 plane = clippingPlanes[ i ];\n\t\tif ( dot( vViewPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t\t\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; ++ i ) {\n\t\t\tvec4 plane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vViewPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\tif ( clipped ) discard;\n\t\n\t#endif\n#endif\n";

	var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\t#if ! defined( PHYSICAL ) && ! defined( PHONG )\n\t\tvarying vec3 vViewPosition;\n\t#endif\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif\n";

	var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvarying vec3 vViewPosition;\n#endif\n";

	var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n";

	var color_fragment = "#ifdef USE_COLOR\n\tdiffuseColor.rgb *= vColor;\n#endif";

	var color_pars_fragment = "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif\n";

	var color_pars_vertex = "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif";

	var color_vertex = "#ifdef USE_COLOR\n\tvColor.xyz = color.xyz;\n#endif";

	var common = "#define PI 3.14159265359\n#define PI2 6.28318530718\n#define PI_HALF 1.5707963267949\n#define RECIPROCAL_PI 0.31830988618\n#define RECIPROCAL_PI2 0.15915494\n#define LOG2 1.442695\n#define EPSILON 1e-6\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#define whiteCompliment(a) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract(sin(sn) * c);\n}\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\tfloat distance = dot( planeNormal, point - pointOnPlane );\n\treturn - distance * planeNormal + point;\n}\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn sign( dot( point - pointOnPlane, planeNormal ) );\n}\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) ) + pointOnLine;\n}\nmat3 transpose( const in mat3 v ) {\n\tmat3 tmp;\n\ttmp[0] = vec3(v[0].x, v[1].x, v[2].x);\n\ttmp[1] = vec3(v[0].y, v[1].y, v[2].y);\n\ttmp[2] = vec3(v[0].z, v[1].z, v[2].z);\n\treturn tmp;\n}\n";

	var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n#define cubeUV_textureSize (1024.0)\nint getFaceFromDirection(vec3 direction) {\n\tvec3 absDirection = abs(direction);\n\tint face = -1;\n\tif( absDirection.x > absDirection.z ) {\n\t\tif(absDirection.x > absDirection.y )\n\t\t\tface = direction.x > 0.0 ? 0 : 3;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\telse {\n\t\tif(absDirection.z > absDirection.y )\n\t\t\tface = direction.z > 0.0 ? 2 : 5;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\treturn face;\n}\n#define cubeUV_maxLods1  (log2(cubeUV_textureSize*0.25) - 1.0)\n#define cubeUV_rangeClamp (exp2((6.0 - 1.0) * 2.0))\nvec2 MipLevelInfo( vec3 vec, float roughnessLevel, float roughness ) {\n\tfloat scale = exp2(cubeUV_maxLods1 - roughnessLevel);\n\tfloat dxRoughness = dFdx(roughness);\n\tfloat dyRoughness = dFdy(roughness);\n\tvec3 dx = dFdx( vec * scale * dxRoughness );\n\tvec3 dy = dFdy( vec * scale * dyRoughness );\n\tfloat d = max( dot( dx, dx ), dot( dy, dy ) );\n\td = clamp(d, 1.0, cubeUV_rangeClamp);\n\tfloat mipLevel = 0.5 * log2(d);\n\treturn vec2(floor(mipLevel), fract(mipLevel));\n}\n#define cubeUV_maxLods2 (log2(cubeUV_textureSize*0.25) - 2.0)\n#define cubeUV_rcpTextureSize (1.0 / cubeUV_textureSize)\nvec2 getCubeUV(vec3 direction, float roughnessLevel, float mipLevel) {\n\tmipLevel = roughnessLevel > cubeUV_maxLods2 - 3.0 ? 0.0 : mipLevel;\n\tfloat a = 16.0 * cubeUV_rcpTextureSize;\n\tvec2 exp2_packed = exp2( vec2( roughnessLevel, mipLevel ) );\n\tvec2 rcp_exp2_packed = vec2( 1.0 ) / exp2_packed;\n\tfloat powScale = exp2_packed.x * exp2_packed.y;\n\tfloat scale = rcp_exp2_packed.x * rcp_exp2_packed.y * 0.25;\n\tfloat mipOffset = 0.75*(1.0 - rcp_exp2_packed.y) * rcp_exp2_packed.x;\n\tbool bRes = mipLevel == 0.0;\n\tscale =  bRes && (scale < a) ? a : scale;\n\tvec3 r;\n\tvec2 offset;\n\tint face = getFaceFromDirection(direction);\n\tfloat rcpPowScale = 1.0 / powScale;\n\tif( face == 0) {\n\t\tr = vec3(direction.x, -direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ?  a : offset.y;\n\t}\n\telse if( face == 1) {\n\t\tr = vec3(direction.y, direction.x, direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ?  a : offset.y;\n\t}\n\telse if( face == 2) {\n\t\tr = vec3(direction.z, direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ?  a : offset.y;\n\t}\n\telse if( face == 3) {\n\t\tr = vec3(direction.x, direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ?  0.0 : offset.y;\n\t}\n\telse if( face == 4) {\n\t\tr = vec3(direction.y, direction.x, -direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ?  0.0 : offset.y;\n\t}\n\telse {\n\t\tr = vec3(direction.z, -direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ?  0.0 : offset.y;\n\t}\n\tr = normalize(r);\n\tfloat texelOffset = 0.5 * cubeUV_rcpTextureSize;\n\tvec2 s = ( r.yz / abs( r.x ) + vec2( 1.0 ) ) * 0.5;\n\tvec2 base = offset + vec2( texelOffset );\n\treturn base + s * ( scale - 2.0 * texelOffset );\n}\n#define cubeUV_maxLods3 (log2(cubeUV_textureSize*0.25) - 3.0)\nvec4 textureCubeUV(vec3 reflectedDirection, float roughness ) {\n\tfloat roughnessVal = roughness* cubeUV_maxLods3;\n\tfloat r1 = floor(roughnessVal);\n\tfloat r2 = r1 + 1.0;\n\tfloat t = fract(roughnessVal);\n\tvec2 mipInfo = MipLevelInfo(reflectedDirection, r1, roughness);\n\tfloat s = mipInfo.y;\n\tfloat level0 = mipInfo.x;\n\tfloat level1 = level0 + 1.0;\n\tlevel1 = level1 > 5.0 ? 5.0 : level1;\n\tlevel0 += min( floor( s + 0.5 ), 5.0 );\n\tvec2 uv_10 = getCubeUV(reflectedDirection, r1, level0);\n\tvec4 color10 = envMapTexelToLinear(texture2D(envMap, uv_10));\n\tvec2 uv_20 = getCubeUV(reflectedDirection, r2, level0);\n\tvec4 color20 = envMapTexelToLinear(texture2D(envMap, uv_20));\n\tvec4 result = mix(color10, color20, t);\n\treturn vec4(result.rgb, 1.0);\n}\n#endif\n";

	var defaultnormal_vertex = "#ifdef FLIP_SIDED\n\tobjectNormal = -objectNormal;\n#endif\nvec3 transformedNormal = normalMatrix * objectNormal;\n";

	var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif\n";

	var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normal * ( texture2D( displacementMap, uv ).x * displacementScale + displacementBias );\n#endif\n";

	var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\temissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif\n";

	var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif\n";

	var encodings_fragment = "  gl_FragColor = linearToOutputTexel( gl_FragColor );\n";

	var encodings_pars_fragment = "\nvec4 LinearToLinear( in vec4 value ) {\n  return value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n  return vec4( pow( value.xyz, vec3( gammaFactor ) ), value.w );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n  return vec4( pow( value.xyz, vec3( 1.0 / gammaFactor ) ), value.w );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n  return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.w );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n  return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.w );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n  return vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n  float maxComponent = max( max( value.r, value.g ), value.b );\n  float fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n  return vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n  return vec4( value.xyz * value.w * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n  float maxRGB = max( value.x, max( value.g, value.b ) );\n  float M      = clamp( maxRGB / maxRange, 0.0, 1.0 );\n  M            = ceil( M * 255.0 ) / 255.0;\n  return vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n    return vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n    float maxRGB = max( value.x, max( value.g, value.b ) );\n    float D      = max( maxRange / maxRGB, 1.0 );\n    D            = min( floor( D ) / 255.0, 1.0 );\n    return vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value )  {\n  vec3 Xp_Y_XYZp = value.rgb * cLogLuvM;\n  Xp_Y_XYZp = max(Xp_Y_XYZp, vec3(1e-6, 1e-6, 1e-6));\n  vec4 vResult;\n  vResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n  float Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n  vResult.w = fract(Le);\n  vResult.z = (Le - (floor(vResult.w*255.0))/255.0)/255.0;\n  return vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n  float Le = value.z * 255.0 + value.w;\n  vec3 Xp_Y_XYZp;\n  Xp_Y_XYZp.y = exp2((Le - 127.0) / 2.0);\n  Xp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n  Xp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n  vec3 vRGB = Xp_Y_XYZp.rgb * cLogLuvInverseM;\n  return vec4( max(vRGB, 0.0), 1.0 );\n}\n";

	var envmap_fragment = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvec3 cameraToVertex = normalize( vWorldPosition - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, flipNormal * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\tvec2 sampleUV;\n\t\tsampleUV.y = saturate( flipNormal * reflectVec.y * 0.5 + 0.5 );\n\t\tsampleUV.x = atan( flipNormal * reflectVec.z, flipNormal * reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\tvec4 envColor = texture2D( envMap, sampleUV );\n\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\tvec3 reflectView = flipNormal * normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0, 0.0, 1.0 ) );\n\t\tvec4 envColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\tenvColor = envMapTexelToLinear( envColor );\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif\n";

	var envmap_pars_fragment = "#if defined( USE_ENVMAP ) || defined( PHYSICAL )\n\tuniform float reflectivity;\n\tuniform float envMapIntensity;\n#endif\n#ifdef USE_ENVMAP\n\t#if ! defined( PHYSICAL ) && ( defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) )\n\t\tvarying vec3 vWorldPosition;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\tuniform float flipEnvMap;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( PHYSICAL )\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif\n";

	var envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif\n";

	var envmap_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif\n";

	var fog_fragment = "#ifdef USE_FOG\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tfloat depth = gl_FragDepthEXT / gl_FragCoord.w;\n\t#else\n\t\tfloat depth = gl_FragCoord.z / gl_FragCoord.w;\n\t#endif\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = whiteCompliment( exp2( - fogDensity * fogDensity * depth * depth * LOG2 ) );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, depth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif\n";

	var fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";

	var gradientmap_pars_fragment = "#ifdef TOON\n\tuniform sampler2D gradientMap;\n\tvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\t\tfloat dotNL = dot( normal, lightDirection );\n\t\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t\t#ifdef USE_GRADIENTMAP\n\t\t\treturn texture2D( gradientMap, coord ).rgb;\n\t\t#else\n\t\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t\t#endif\n\t}\n#endif\n";

	var lightmap_fragment = "#ifdef USE_LIGHTMAP\n\treflectedLight.indirectDiffuse += PI * texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n#endif\n";

	var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";

	var lights_lambert_vertex = "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\n#if NUM_POINT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointDirectLightIrradiance( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotDirectLightIrradiance( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t}\n#endif\n#if NUM_DIR_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalDirectLightIrradiance( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvLightFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n\t\t#endif\n\t}\n#endif\n";

	var lights_pars = "uniform vec3 ambientLightColor;\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treturn irradiance;\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalDirectLightIrradiance( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tdirectLight.color = directionalLight.color;\n\t\tdirectLight.direction = directionalLight.direction;\n\t\tdirectLight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointDirectLightIrradiance( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tdirectLight.color = pointLight.color;\n\t\tdirectLight.color *= punctualLightIntensityToIrradianceFactor( lightDistance, pointLight.distance, pointLight.decay );\n\t\tdirectLight.visible = ( directLight.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotDirectLightIrradiance( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight directLight  ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tfloat angleCos = dot( directLight.direction, spotLight.direction );\n\t\tif ( angleCos > spotLight.coneCos ) {\n\t\t\tfloat spotEffect = smoothstep( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\t\tdirectLight.color = spotLight.color;\n\t\t\tdirectLight.color *= spotEffect * punctualLightIntensityToIrradianceFactor( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tdirectLight.visible = true;\n\t\t} else {\n\t\t\tdirectLight.color = vec3( 0.0 );\n\t\t\tdirectLight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltcMat;\tuniform sampler2D ltcMag;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n\t\tfloat dotNL = dot( geometry.normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tirradiance *= PI;\n\t\t#endif\n\t\treturn irradiance;\n\t}\n#endif\n#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\tvec3 getLightProbeIndirectIrradiance( const in GeometricContext geometry, const in int maxMIPLevel ) {\n\t\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\tvec4 envMapColor = textureCubeUV( queryVec, 1.0 );\n\t\t#else\n\t\t\tvec4 envMapColor = vec4( 0.0 );\n\t\t#endif\n\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t}\n\tfloat getSpecularMIPLevel( const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\tfloat maxMIPLevelScalar = float( maxMIPLevel );\n\t\tfloat desiredMIPLevel = maxMIPLevelScalar - 0.79248 - 0.5 * log2( pow2( blinnShininessExponent ) + 1.0 );\n\t\treturn clamp( desiredMIPLevel, 0.0, maxMIPLevelScalar );\n\t}\n\tvec3 getLightProbeIndirectRadiance( const in GeometricContext geometry, const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( -geometry.viewDir, geometry.normal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( -geometry.viewDir, geometry.normal, refractionRatio );\n\t\t#endif\n\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\tfloat specularMIPLevel = getSpecularMIPLevel( blinnShininessExponent, maxMIPLevel );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\tvec4 envMapColor = textureCubeUV(queryReflectVec, BlinnExponentToGGXRoughness(blinnShininessExponent));\n\t\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\t\tvec2 sampleUV;\n\t\t\tsampleUV.y = saturate( reflectVec.y * 0.5 + 0.5 );\n\t\t\tsampleUV.x = atan( reflectVec.z, reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, sampleUV, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, sampleUV, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\t\tvec3 reflectView = normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0,0.0,1.0 ) );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#endif\n\t\treturn envMapColor.rgb * envMapIntensity;\n\t}\n#endif\n";

	var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;\n";

	var lights_phong_pars_fragment = "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct BlinnPhongMaterial {\n\tvec3\tdiffuseColor;\n\tvec3\tspecularColor;\n\tfloat\tspecularShininess;\n\tfloat\tspecularStrength;\n};\n#if NUM_RECT_AREA_LIGHTS > 0\n    void RE_Direct_RectArea_BlinnPhong( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n        vec3 matDiffColor = material.diffuseColor;\n        vec3 matSpecColor = material.specularColor;\n        vec3 lightColor   = rectAreaLight.color;\n        float roughness = BlinnExponentToGGXRoughness( material.specularShininess );\n        vec3 spec = Rect_Area_Light_Specular_Reflectance(\n                geometry,\n                rectAreaLight.position, rectAreaLight.halfWidth, rectAreaLight.halfHeight,\n                roughness,\n                ltcMat, ltcMag );\n        vec3 diff = Rect_Area_Light_Diffuse_Reflectance(\n                geometry,\n                rectAreaLight.position, rectAreaLight.halfWidth, rectAreaLight.halfHeight );\n        reflectedLight.directSpecular += lightColor * matSpecColor * spec / PI2;\n        reflectedLight.directDiffuse  += lightColor * matDiffColor * diff / PI2;\n    }\n#endif\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifdef TOON\n\t\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\t#else\n\t\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\t\tvec3 irradiance = dotNL * directLight.color;\n\t#endif\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_Specular_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)\n";

	var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nmaterial.specularRoughness = clamp( roughnessFactor, 0.04, 1.0 );\n#ifdef STANDARD\n\tmaterial.specularColor = mix( vec3( DEFAULT_SPECULAR_COEFFICIENT ), diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( MAXIMUM_SPECULAR_COEFFICIENT * pow2( reflectivity ) ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.clearCoat = saturate( clearCoat );\tmaterial.clearCoatRoughness = clamp( clearCoatRoughness, 0.04, 1.0 );\n#endif\n";

	var lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3\tdiffuseColor;\n\tfloat\tspecularRoughness;\n\tvec3\tspecularColor;\n\t#ifndef STANDARD\n\t\tfloat clearCoat;\n\t\tfloat clearCoatRoughness;\n\t#endif\n};\n#define MAXIMUM_SPECULAR_COEFFICIENT 0.16\n#define DEFAULT_SPECULAR_COEFFICIENT 0.04\nfloat clearCoatDHRApprox( const in float roughness, const in float dotNL ) {\n\treturn DEFAULT_SPECULAR_COEFFICIENT + ( 1.0 - DEFAULT_SPECULAR_COEFFICIENT ) * ( pow( 1.0 - dotNL, 5.0 ) * pow( 1.0 - roughness, 2.0 ) );\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n    void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n        vec3 matDiffColor = material.diffuseColor;\n        vec3 matSpecColor = material.specularColor;\n        vec3 lightColor   = rectAreaLight.color;\n        float roughness = material.specularRoughness;\n        vec3 spec = Rect_Area_Light_Specular_Reflectance(\n                geometry,\n                rectAreaLight.position, rectAreaLight.halfWidth, rectAreaLight.halfHeight,\n                roughness,\n                ltcMat, ltcMag );\n        vec3 diff = Rect_Area_Light_Diffuse_Reflectance(\n                geometry,\n                rectAreaLight.position, rectAreaLight.halfWidth, rectAreaLight.halfHeight );\n        reflectedLight.directSpecular += lightColor * matSpecColor * spec;\n        reflectedLight.directDiffuse  += lightColor * matDiffColor * diff;\n    }\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\t#ifndef STANDARD\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.directSpecular += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Specular_GGX( directLight, geometry, material.specularColor, material.specularRoughness );\n\treflectedLight.directDiffuse += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\t#ifndef STANDARD\n\t\treflectedLight.directSpecular += irradiance * material.clearCoat * BRDF_Specular_GGX( directLight, geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 clearCoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifndef STANDARD\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\tfloat dotNL = dotNV;\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.indirectSpecular += ( 1.0 - clearCoatDHR ) * radiance * BRDF_Specular_GGX_Environment( geometry, material.specularColor, material.specularRoughness );\n\t#ifndef STANDARD\n\t\treflectedLight.indirectSpecular += clearCoatRadiance * material.clearCoat * BRDF_Specular_GGX_Environment( geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\n#define Material_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.specularRoughness )\n#define Material_ClearCoat_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.clearCoatRoughness )\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}\n";

	var lights_template = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = normalize( vViewPosition );\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointDirectLightIrradiance( pointLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( pointLight.shadow, directLight.visible ) ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotDirectLightIrradiance( spotLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( spotLight.shadow, directLight.visible ) ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalDirectLightIrradiance( directionalLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( directionalLight.shadow, directLight.visible ) ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#ifdef USE_LIGHTMAP\n\t\tvec3 lightMapIrradiance = texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tlightMapIrradiance *= PI;\n\t\t#endif\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t}\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t \tirradiance += getLightProbeIndirectIrradiance( geometry, 8 );\n\t#endif\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tvec3 radiance = getLightProbeIndirectRadiance( geometry, Material_BlinnShininessExponent( material ), 8 );\n\t#ifndef STANDARD\n\t\tvec3 clearCoatRadiance = getLightProbeIndirectRadiance( geometry, Material_ClearCoat_BlinnShininessExponent( material ), 8 );\n\t#else\n\t\tvec3 clearCoatRadiance = vec3( 0.0 );\n\t#endif\n\t\t\n\tRE_IndirectSpecular( radiance, clearCoatRadiance, geometry, material, reflectedLight );\n#endif\n";

	var logdepthbuf_fragment = "#if defined(USE_LOGDEPTHBUF) && defined(USE_LOGDEPTHBUF_EXT)\n\tgl_FragDepthEXT = log2(vFragDepth) * logDepthBufFC * 0.5;\n#endif";

	var logdepthbuf_pars_fragment = "#ifdef USE_LOGDEPTHBUF\n\tuniform float logDepthBufFC;\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n#endif\n";

	var logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n\tuniform float logDepthBufFC;\n#endif";

	var logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\tgl_Position.z = log2(max( EPSILON, gl_Position.w + 1.0 )) * logDepthBufFC;\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t#else\n\t\tgl_Position.z = (gl_Position.z - 1.0) * gl_Position.w;\n\t#endif\n#endif\n";

	var map_fragment = "#ifdef USE_MAP\n\tvec4 texelColor = texture2D( map, vUv );\n\ttexelColor = mapTexelToLinear( texelColor );\n\tdiffuseColor *= texelColor;\n#endif\n";

	var map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n";

	var map_particle_fragment = "#ifdef USE_MAP\n\tvec4 mapTexel = texture2D( map, vec2( gl_PointCoord.x, 1.0 - gl_PointCoord.y ) * offsetRepeat.zw + offsetRepeat.xy );\n\tdiffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n";

	var map_particle_pars_fragment = "#ifdef USE_MAP\n\tuniform vec4 offsetRepeat;\n\tuniform sampler2D map;\n#endif\n";

	var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.r;\n#endif\n";

	var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";

	var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal += ( morphNormal0 - normal ) * morphTargetInfluences[ 0 ];\n\tobjectNormal += ( morphNormal1 - normal ) * morphTargetInfluences[ 1 ];\n\tobjectNormal += ( morphNormal2 - normal ) * morphTargetInfluences[ 2 ];\n\tobjectNormal += ( morphNormal3 - normal ) * morphTargetInfluences[ 3 ];\n#endif\n";

	var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_MORPHNORMALS\n\tuniform float morphTargetInfluences[ 8 ];\n\t#else\n\tuniform float morphTargetInfluences[ 4 ];\n\t#endif\n#endif";

	var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed += ( morphTarget0 - position ) * morphTargetInfluences[ 0 ];\n\ttransformed += ( morphTarget1 - position ) * morphTargetInfluences[ 1 ];\n\ttransformed += ( morphTarget2 - position ) * morphTargetInfluences[ 2 ];\n\ttransformed += ( morphTarget3 - position ) * morphTargetInfluences[ 3 ];\n\t#ifndef USE_MORPHNORMALS\n\ttransformed += ( morphTarget4 - position ) * morphTargetInfluences[ 4 ];\n\ttransformed += ( morphTarget5 - position ) * morphTargetInfluences[ 5 ];\n\ttransformed += ( morphTarget6 - position ) * morphTargetInfluences[ 6 ];\n\ttransformed += ( morphTarget7 - position ) * morphTargetInfluences[ 7 ];\n\t#endif\n#endif\n";

	var normal_flip = "#ifdef DOUBLE_SIDED\n\tfloat flipNormal = ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n#else\n\tfloat flipNormal = 1.0;\n#endif\n";

	var normal_fragment = "#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal ) * flipNormal;\n#endif\n#ifdef USE_NORMALMAP\n\tnormal = perturbNormal2Arb( -vViewPosition, normal );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd() );\n#endif\n";

	var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 S = normalize( q0 * st1.t - q1 * st0.t );\n\t\tvec3 T = normalize( -q0 * st1.s + q1 * st0.s );\n\t\tvec3 N = normalize( surf_norm );\n\t\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t\tmapN.xy = normalScale * mapN.xy;\n\t\tmat3 tsn = mat3( S, T, N );\n\t\treturn normalize( tsn * mapN );\n\t}\n#endif\n";

	var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n  return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n  return 1.0 - 2.0 * rgb.xyz;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256.,  256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n  return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n  return linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n  return (( near + viewZ ) * far ) / (( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n  return ( near * far ) / ( ( far - near ) * invClipZ - far );\n}\n";

	var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif\n";

	var project_vertex = "#ifdef USE_SKINNING\n\tvec4 mvPosition = modelViewMatrix * skinned;\n#else\n\tvec4 mvPosition = modelViewMatrix * vec4( transformed, 1.0 );\n#endif\ngl_Position = projectionMatrix * mvPosition;\n";

	var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.r;\n#endif\n";

	var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";

	var shadowmap_pars_fragment = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n    #if NUM_RECT_AREA_LIGHTS > 0\n    #endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tfloat texture2DShadowLerp( sampler2D depths, vec2 size, vec2 uv, float compare ) {\n\t\tconst vec2 offset = vec2( 0.0, 1.0 );\n\t\tvec2 texelSize = vec2( 1.0 ) / size;\n\t\tvec2 centroidUV = floor( uv * size + 0.5 ) / size;\n\t\tfloat lb = texture2DCompare( depths, centroidUV + texelSize * offset.xx, compare );\n\t\tfloat lt = texture2DCompare( depths, centroidUV + texelSize * offset.xy, compare );\n\t\tfloat rb = texture2DCompare( depths, centroidUV + texelSize * offset.yx, compare );\n\t\tfloat rt = texture2DCompare( depths, centroidUV + texelSize * offset.yy, compare );\n\t\tvec2 f = fract( uv * size + 0.5 );\n\t\tfloat a = mix( lb, lt, f.y );\n\t\tfloat b = mix( rb, rt, f.y );\n\t\tfloat c = mix( a, b, f.x );\n\t\treturn c;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\treturn (\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn 1.0;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\tfloat dp = ( length( lightToPosition ) - shadowBias ) / 1000.0;\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif\n";

	var shadowmap_pars_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n    #if NUM_RECT_AREA_LIGHTS > 0\n    #endif\n#endif\n";

	var shadowmap_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n    #if NUM_RECT_AREA_LIGHTS > 0\n    #endif\n#endif\n";

	var shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\tDirectionalLight directionalLight;\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tshadow *= bool( directionalLight.shadow ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\tSpotLight spotLight;\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tshadow *= bool( spotLight.shadow ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\tPointLight pointLight;\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tshadow *= bool( pointLight.shadow ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_RECT_AREA_LIGHTS > 0\n\t#endif\n\t#endif\n\treturn shadow;\n}\n";

	var skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";

	var skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform sampler2D boneTexture;\n\t\tuniform int boneTextureWidth;\n\t\tuniform int boneTextureHeight;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureWidth ) );\n\t\t\tfloat y = floor( j / float( boneTextureWidth ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureWidth );\n\t\t\tfloat dy = 1.0 / float( boneTextureHeight );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif\n";

	var skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\tskinned  = bindMatrixInverse * skinned;\n#endif\n";

	var skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix  = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n#endif\n";

	var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";

	var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";

	var tonemapping_fragment = "#if defined( TONE_MAPPING )\n  gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif\n";

	var tonemapping_pars_fragment = "#define saturate(a) clamp( a, 0.0, 1.0 )\nuniform float toneMappingExposure;\nuniform float toneMappingWhitePoint;\nvec3 LinearToneMapping( vec3 color ) {\n  return toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n  color *= toneMappingExposure;\n  return saturate( color / ( vec3( 1.0 ) + color ) );\n}\n#define Uncharted2Helper( x ) max( ( ( x * ( 0.15 * x + 0.10 * 0.50 ) + 0.20 * 0.02 ) / ( x * ( 0.15 * x + 0.50 ) + 0.20 * 0.30 ) ) - 0.02 / 0.30, vec3( 0.0 ) )\nvec3 Uncharted2ToneMapping( vec3 color ) {\n  color *= toneMappingExposure;\n  return saturate( Uncharted2Helper( color ) / Uncharted2Helper( vec3( toneMappingWhitePoint ) ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n  color *= toneMappingExposure;\n  color = max( vec3( 0.0 ), color - 0.004 );\n  return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\n";

	var uv_pars_fragment = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n#endif";

	var uv_pars_vertex = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n\tuniform vec4 offsetRepeat;\n#endif\n";

	var uv_vertex = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvUv = uv * offsetRepeat.zw + offsetRepeat.xy;\n#endif";

	var uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif";

	var uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n#endif";

	var uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = uv2;\n#endif";

	var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( PHONG ) || defined( PHYSICAL ) || defined( LAMBERT ) || defined ( USE_SHADOWMAP )\n\t#ifdef USE_SKINNING\n\t\tvec4 worldPosition = modelMatrix * skinned;\n\t#else\n\t\tvec4 worldPosition = modelMatrix * vec4( transformed, 1.0 );\n\t#endif\n#endif\n";

	var cube_frag = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tgl_FragColor = textureCube( tCube, vec3( tFlip * vWorldPosition.x, vWorldPosition.yz ) );\n\tgl_FragColor.a *= opacity;\n}\n";

	var cube_vert = "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}\n";

	var depth_frag = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( gl_FragCoord.z ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( gl_FragCoord.z );\n\t#endif\n}\n";

	var depth_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#include <begin_vertex>\n\t#include <displacementmap_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n}\n";

	var distanceRGBA_frag = "uniform vec3 lightPos;\nvarying vec4 vWorldPosition;\n#include <common>\n#include <packing>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tgl_FragColor = packDepthToRGBA( length( vWorldPosition.xyz - lightPos.xyz ) / 1000.0 );\n}\n";

	var distanceRGBA_vert = "varying vec4 vWorldPosition;\n#include <common>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <skinbase_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition;\n}\n";

	var equirect_frag = "uniform sampler2D tEquirect;\nuniform float tFlip;\nvarying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldPosition );\n\tvec2 sampleUV;\n\tsampleUV.y = saturate( tFlip * direction.y * -0.5 + 0.5 );\n\tsampleUV.x = atan( direction.z, direction.x ) * RECIPROCAL_PI2 + 0.5;\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n}\n";

	var equirect_vert = "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}\n";

	var linedashed_frag = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";

	var linedashed_vert = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\tvLineDistance = scale * lineDistance;\n\tvec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n}\n";

	var meshbasic_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\treflectedLight.indirectDiffuse += texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <normal_flip>\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";

	var meshbasic_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_ENVMAP\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <envmap_vertex>\n}\n";

	var meshlambert_frag = "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <packing>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <bsdfs>\n#include <lights_pars>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\treflectedLight.indirectDiffuse = getAmbientLightIrradiance( ambientLightColor );\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <normal_flip>\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";

	var meshlambert_vert = "#define LAMBERT\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars>\n#include <color_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n}\n";

	var meshphong_frag = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_flip>\n\t#include <normal_fragment>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_template>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";

	var meshphong_vert = "#define PHONG\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <displacementmap_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n}\n";

	var meshphysical_frag = "#define PHYSICAL\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifndef STANDARD\n\tuniform float clearCoat;\n\tuniform float clearCoatRoughness;\n#endif\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <packing>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <lights_pars>\n#include <lights_physical_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_flip>\n\t#include <normal_fragment>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_template>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";

	var meshphysical_vert = "#define PHYSICAL\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <displacementmap_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n}\n";

	var normal_frag = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED  ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\t#include <normal_flip>\n\t#include <normal_fragment>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n\t#include <premultiplied_alpha_fragment>\n\t#include <encodings_fragment>\n}\n";

	var normal_vert = "#define NORMAL\n#if defined( FLAT_SHADED  ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <displacementmap_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n#if defined( FLAT_SHADED  ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}\n";

	var points_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";

	var points_vert = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#ifdef USE_SIZEATTENUATION\n\t\tgl_PointSize = size * ( scale / - mvPosition.z );\n\t#else\n\t\tgl_PointSize = size;\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n}\n";

	var shadow_frag = "uniform float opacity;\n#include <common>\n#include <packing>\n#include <bsdfs>\n#include <lights_pars>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( 0.0, 0.0, 0.0, opacity * ( 1.0  - getShadowMask() ) );\n}\n";

	var shadow_vert = "#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n}\n";

	var ShaderChunk = {
		alphamap_fragment: alphamap_fragment,
		alphamap_pars_fragment: alphamap_pars_fragment,
		alphatest_fragment: alphatest_fragment,
		aomap_fragment: aomap_fragment,
		aomap_pars_fragment: aomap_pars_fragment,
		begin_vertex: begin_vertex,
		beginnormal_vertex: beginnormal_vertex,
		bsdfs: bsdfs,
		bumpmap_pars_fragment: bumpmap_pars_fragment,
		clipping_planes_fragment: clipping_planes_fragment,
		clipping_planes_pars_fragment: clipping_planes_pars_fragment,
		clipping_planes_pars_vertex: clipping_planes_pars_vertex,
		clipping_planes_vertex: clipping_planes_vertex,
		color_fragment: color_fragment,
		color_pars_fragment: color_pars_fragment,
		color_pars_vertex: color_pars_vertex,
		color_vertex: color_vertex,
		common: common,
		cube_uv_reflection_fragment: cube_uv_reflection_fragment,
		defaultnormal_vertex: defaultnormal_vertex,
		displacementmap_pars_vertex: displacementmap_pars_vertex,
		displacementmap_vertex: displacementmap_vertex,
		emissivemap_fragment: emissivemap_fragment,
		emissivemap_pars_fragment: emissivemap_pars_fragment,
		encodings_fragment: encodings_fragment,
		encodings_pars_fragment: encodings_pars_fragment,
		envmap_fragment: envmap_fragment,
		envmap_pars_fragment: envmap_pars_fragment,
		envmap_pars_vertex: envmap_pars_vertex,
		envmap_vertex: envmap_vertex,
		fog_fragment: fog_fragment,
		fog_pars_fragment: fog_pars_fragment,
		gradientmap_pars_fragment: gradientmap_pars_fragment,
		lightmap_fragment: lightmap_fragment,
		lightmap_pars_fragment: lightmap_pars_fragment,
		lights_lambert_vertex: lights_lambert_vertex,
		lights_pars: lights_pars,
		lights_phong_fragment: lights_phong_fragment,
		lights_phong_pars_fragment: lights_phong_pars_fragment,
		lights_physical_fragment: lights_physical_fragment,
		lights_physical_pars_fragment: lights_physical_pars_fragment,
		lights_template: lights_template,
		logdepthbuf_fragment: logdepthbuf_fragment,
		logdepthbuf_pars_fragment: logdepthbuf_pars_fragment,
		logdepthbuf_pars_vertex: logdepthbuf_pars_vertex,
		logdepthbuf_vertex: logdepthbuf_vertex,
		map_fragment: map_fragment,
		map_pars_fragment: map_pars_fragment,
		map_particle_fragment: map_particle_fragment,
		map_particle_pars_fragment: map_particle_pars_fragment,
		metalnessmap_fragment: metalnessmap_fragment,
		metalnessmap_pars_fragment: metalnessmap_pars_fragment,
		morphnormal_vertex: morphnormal_vertex,
		morphtarget_pars_vertex: morphtarget_pars_vertex,
		morphtarget_vertex: morphtarget_vertex,
		normal_flip: normal_flip,
		normal_fragment: normal_fragment,
		normalmap_pars_fragment: normalmap_pars_fragment,
		packing: packing,
		premultiplied_alpha_fragment: premultiplied_alpha_fragment,
		project_vertex: project_vertex,
		roughnessmap_fragment: roughnessmap_fragment,
		roughnessmap_pars_fragment: roughnessmap_pars_fragment,
		shadowmap_pars_fragment: shadowmap_pars_fragment,
		shadowmap_pars_vertex: shadowmap_pars_vertex,
		shadowmap_vertex: shadowmap_vertex,
		shadowmask_pars_fragment: shadowmask_pars_fragment,
		skinbase_vertex: skinbase_vertex,
		skinning_pars_vertex: skinning_pars_vertex,
		skinning_vertex: skinning_vertex,
		skinnormal_vertex: skinnormal_vertex,
		specularmap_fragment: specularmap_fragment,
		specularmap_pars_fragment: specularmap_pars_fragment,
		tonemapping_fragment: tonemapping_fragment,
		tonemapping_pars_fragment: tonemapping_pars_fragment,
		uv_pars_fragment: uv_pars_fragment,
		uv_pars_vertex: uv_pars_vertex,
		uv_vertex: uv_vertex,
		uv2_pars_fragment: uv2_pars_fragment,
		uv2_pars_vertex: uv2_pars_vertex,
		uv2_vertex: uv2_vertex,
		worldpos_vertex: worldpos_vertex,

		cube_frag: cube_frag,
		cube_vert: cube_vert,
		depth_frag: depth_frag,
		depth_vert: depth_vert,
		distanceRGBA_frag: distanceRGBA_frag,
		distanceRGBA_vert: distanceRGBA_vert,
		equirect_frag: equirect_frag,
		equirect_vert: equirect_vert,
		linedashed_frag: linedashed_frag,
		linedashed_vert: linedashed_vert,
		meshbasic_frag: meshbasic_frag,
		meshbasic_vert: meshbasic_vert,
		meshlambert_frag: meshlambert_frag,
		meshlambert_vert: meshlambert_vert,
		meshphong_frag: meshphong_frag,
		meshphong_vert: meshphong_vert,
		meshphysical_frag: meshphysical_frag,
		meshphysical_vert: meshphysical_vert,
		normal_frag: normal_frag,
		normal_vert: normal_vert,
		points_frag: points_frag,
		points_vert: points_vert,
		shadow_frag: shadow_frag,
		shadow_vert: shadow_vert
	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function Color( r, g, b ) {

		if ( g === undefined && b === undefined ) {

			// r is THREE.Color, hex or string
			return this.set( r );

		}

		return this.setRGB( r, g, b );

	}

	Color.prototype = {

		constructor: Color,

		isColor: true,

		r: 1, g: 1, b: 1,

		set: function ( value ) {

			if ( value && value.isColor ) {

				this.copy( value );

			} else if ( typeof value === 'number' ) {

				this.setHex( value );

			} else if ( typeof value === 'string' ) {

				this.setStyle( value );

			}

			return this;

		},

		setScalar: function ( scalar ) {

			this.r = scalar;
			this.g = scalar;
			this.b = scalar;

			return this;

		},

		setHex: function ( hex ) {

			hex = Math.floor( hex );

			this.r = ( hex >> 16 & 255 ) / 255;
			this.g = ( hex >> 8 & 255 ) / 255;
			this.b = ( hex & 255 ) / 255;

			return this;

		},

		setRGB: function ( r, g, b ) {

			this.r = r;
			this.g = g;
			this.b = b;

			return this;

		},

		setHSL: function () {

			function hue2rgb( p, q, t ) {

				if ( t < 0 ) t += 1;
				if ( t > 1 ) t -= 1;
				if ( t < 1 / 6 ) return p + ( q - p ) * 6 * t;
				if ( t < 1 / 2 ) return q;
				if ( t < 2 / 3 ) return p + ( q - p ) * 6 * ( 2 / 3 - t );
				return p;

			}

			return function setHSL( h, s, l ) {

				// h,s,l ranges are in 0.0 - 1.0
				h = _Math.euclideanModulo( h, 1 );
				s = _Math.clamp( s, 0, 1 );
				l = _Math.clamp( l, 0, 1 );

				if ( s === 0 ) {

					this.r = this.g = this.b = l;

				} else {

					var p = l <= 0.5 ? l * ( 1 + s ) : l + s - ( l * s );
					var q = ( 2 * l ) - p;

					this.r = hue2rgb( q, p, h + 1 / 3 );
					this.g = hue2rgb( q, p, h );
					this.b = hue2rgb( q, p, h - 1 / 3 );

				}

				return this;

			};

		}(),

		setStyle: function ( style ) {

			function handleAlpha( string ) {

				if ( string === undefined ) return;

				if ( parseFloat( string ) < 1 ) {

					console.warn( 'THREE.Color: Alpha component of ' + style + ' will be ignored.' );

				}

			}


			var m;

			if ( m = /^((?:rgb|hsl)a?)\(\s*([^\)]*)\)/.exec( style ) ) {

				// rgb / hsl

				var color;
				var name = m[ 1 ];
				var components = m[ 2 ];

				switch ( name ) {

					case 'rgb':
					case 'rgba':

						if ( color = /^(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {

							// rgb(255,0,0) rgba(255,0,0,0.5)
							this.r = Math.min( 255, parseInt( color[ 1 ], 10 ) ) / 255;
							this.g = Math.min( 255, parseInt( color[ 2 ], 10 ) ) / 255;
							this.b = Math.min( 255, parseInt( color[ 3 ], 10 ) ) / 255;

							handleAlpha( color[ 5 ] );

							return this;

						}

						if ( color = /^(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {

							// rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
							this.r = Math.min( 100, parseInt( color[ 1 ], 10 ) ) / 100;
							this.g = Math.min( 100, parseInt( color[ 2 ], 10 ) ) / 100;
							this.b = Math.min( 100, parseInt( color[ 3 ], 10 ) ) / 100;

							handleAlpha( color[ 5 ] );

							return this;

						}

						break;

					case 'hsl':
					case 'hsla':

						if ( color = /^([0-9]*\.?[0-9]+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {

							// hsl(120,50%,50%) hsla(120,50%,50%,0.5)
							var h = parseFloat( color[ 1 ] ) / 360;
							var s = parseInt( color[ 2 ], 10 ) / 100;
							var l = parseInt( color[ 3 ], 10 ) / 100;

							handleAlpha( color[ 5 ] );

							return this.setHSL( h, s, l );

						}

						break;

				}

			} else if ( m = /^\#([A-Fa-f0-9]+)$/.exec( style ) ) {

				// hex color

				var hex = m[ 1 ];
				var size = hex.length;

				if ( size === 3 ) {

					// #ff0
					this.r = parseInt( hex.charAt( 0 ) + hex.charAt( 0 ), 16 ) / 255;
					this.g = parseInt( hex.charAt( 1 ) + hex.charAt( 1 ), 16 ) / 255;
					this.b = parseInt( hex.charAt( 2 ) + hex.charAt( 2 ), 16 ) / 255;

					return this;

				} else if ( size === 6 ) {

					// #ff0000
					this.r = parseInt( hex.charAt( 0 ) + hex.charAt( 1 ), 16 ) / 255;
					this.g = parseInt( hex.charAt( 2 ) + hex.charAt( 3 ), 16 ) / 255;
					this.b = parseInt( hex.charAt( 4 ) + hex.charAt( 5 ), 16 ) / 255;

					return this;

				}

			}

			if ( style && style.length > 0 ) {

				// color keywords
				var hex = ColorKeywords[ style ];

				if ( hex !== undefined ) {

					// red
					this.setHex( hex );

				} else {

					// unknown color
					console.warn( 'THREE.Color: Unknown color ' + style );

				}

			}

			return this;

		},

		clone: function () {

			return new this.constructor( this.r, this.g, this.b );

		},

		copy: function ( color ) {

			this.r = color.r;
			this.g = color.g;
			this.b = color.b;

			return this;

		},

		copyGammaToLinear: function ( color, gammaFactor ) {

			if ( gammaFactor === undefined ) gammaFactor = 2.0;

			this.r = Math.pow( color.r, gammaFactor );
			this.g = Math.pow( color.g, gammaFactor );
			this.b = Math.pow( color.b, gammaFactor );

			return this;

		},

		copyLinearToGamma: function ( color, gammaFactor ) {

			if ( gammaFactor === undefined ) gammaFactor = 2.0;

			var safeInverse = ( gammaFactor > 0 ) ? ( 1.0 / gammaFactor ) : 1.0;

			this.r = Math.pow( color.r, safeInverse );
			this.g = Math.pow( color.g, safeInverse );
			this.b = Math.pow( color.b, safeInverse );

			return this;

		},

		convertGammaToLinear: function () {

			var r = this.r, g = this.g, b = this.b;

			this.r = r * r;
			this.g = g * g;
			this.b = b * b;

			return this;

		},

		convertLinearToGamma: function () {

			this.r = Math.sqrt( this.r );
			this.g = Math.sqrt( this.g );
			this.b = Math.sqrt( this.b );

			return this;

		},

		getHex: function () {

			return ( this.r * 255 ) << 16 ^ ( this.g * 255 ) << 8 ^ ( this.b * 255 ) << 0;

		},

		getHexString: function () {

			return ( '000000' + this.getHex().toString( 16 ) ).slice( - 6 );

		},

		getHSL: function ( optionalTarget ) {

			// h,s,l ranges are in 0.0 - 1.0

			var hsl = optionalTarget || { h: 0, s: 0, l: 0 };

			var r = this.r, g = this.g, b = this.b;

			var max = Math.max( r, g, b );
			var min = Math.min( r, g, b );

			var hue, saturation;
			var lightness = ( min + max ) / 2.0;

			if ( min === max ) {

				hue = 0;
				saturation = 0;

			} else {

				var delta = max - min;

				saturation = lightness <= 0.5 ? delta / ( max + min ) : delta / ( 2 - max - min );

				switch ( max ) {

					case r: hue = ( g - b ) / delta + ( g < b ? 6 : 0 ); break;
					case g: hue = ( b - r ) / delta + 2; break;
					case b: hue = ( r - g ) / delta + 4; break;

				}

				hue /= 6;

			}

			hsl.h = hue;
			hsl.s = saturation;
			hsl.l = lightness;

			return hsl;

		},

		getStyle: function () {

			return 'rgb(' + ( ( this.r * 255 ) | 0 ) + ',' + ( ( this.g * 255 ) | 0 ) + ',' + ( ( this.b * 255 ) | 0 ) + ')';

		},

		offsetHSL: function ( h, s, l ) {

			var hsl = this.getHSL();

			hsl.h += h; hsl.s += s; hsl.l += l;

			this.setHSL( hsl.h, hsl.s, hsl.l );

			return this;

		},

		add: function ( color ) {

			this.r += color.r;
			this.g += color.g;
			this.b += color.b;

			return this;

		},

		addColors: function ( color1, color2 ) {

			this.r = color1.r + color2.r;
			this.g = color1.g + color2.g;
			this.b = color1.b + color2.b;

			return this;

		},

		addScalar: function ( s ) {

			this.r += s;
			this.g += s;
			this.b += s;

			return this;

		},

		sub: function( color ) {

			this.r = Math.max( 0, this.r - color.r );
			this.g = Math.max( 0, this.g - color.g );
			this.b = Math.max( 0, this.b - color.b );

			return this;

		},

		multiply: function ( color ) {

			this.r *= color.r;
			this.g *= color.g;
			this.b *= color.b;

			return this;

		},

		multiplyScalar: function ( s ) {

			this.r *= s;
			this.g *= s;
			this.b *= s;

			return this;

		},

		lerp: function ( color, alpha ) {

			this.r += ( color.r - this.r ) * alpha;
			this.g += ( color.g - this.g ) * alpha;
			this.b += ( color.b - this.b ) * alpha;

			return this;

		},

		equals: function ( c ) {

			return ( c.r === this.r ) && ( c.g === this.g ) && ( c.b === this.b );

		},

		fromArray: function ( array, offset ) {

			if ( offset === undefined ) offset = 0;

			this.r = array[ offset ];
			this.g = array[ offset + 1 ];
			this.b = array[ offset + 2 ];

			return this;

		},

		toArray: function ( array, offset ) {

			if ( array === undefined ) array = [];
			if ( offset === undefined ) offset = 0;

			array[ offset ] = this.r;
			array[ offset + 1 ] = this.g;
			array[ offset + 2 ] = this.b;

			return array;

		},

		toJSON: function () {

			return this.getHex();

		}

	};

	var ColorKeywords = { 'aliceblue': 0xF0F8FF, 'antiquewhite': 0xFAEBD7, 'aqua': 0x00FFFF, 'aquamarine': 0x7FFFD4, 'azure': 0xF0FFFF,
	'beige': 0xF5F5DC, 'bisque': 0xFFE4C4, 'black': 0x000000, 'blanchedalmond': 0xFFEBCD, 'blue': 0x0000FF, 'blueviolet': 0x8A2BE2,
	'brown': 0xA52A2A, 'burlywood': 0xDEB887, 'cadetblue': 0x5F9EA0, 'chartreuse': 0x7FFF00, 'chocolate': 0xD2691E, 'coral': 0xFF7F50,
	'cornflowerblue': 0x6495ED, 'cornsilk': 0xFFF8DC, 'crimson': 0xDC143C, 'cyan': 0x00FFFF, 'darkblue': 0x00008B, 'darkcyan': 0x008B8B,
	'darkgoldenrod': 0xB8860B, 'darkgray': 0xA9A9A9, 'darkgreen': 0x006400, 'darkgrey': 0xA9A9A9, 'darkkhaki': 0xBDB76B, 'darkmagenta': 0x8B008B,
	'darkolivegreen': 0x556B2F, 'darkorange': 0xFF8C00, 'darkorchid': 0x9932CC, 'darkred': 0x8B0000, 'darksalmon': 0xE9967A, 'darkseagreen': 0x8FBC8F,
	'darkslateblue': 0x483D8B, 'darkslategray': 0x2F4F4F, 'darkslategrey': 0x2F4F4F, 'darkturquoise': 0x00CED1, 'darkviolet': 0x9400D3,
	'deeppink': 0xFF1493, 'deepskyblue': 0x00BFFF, 'dimgray': 0x696969, 'dimgrey': 0x696969, 'dodgerblue': 0x1E90FF, 'firebrick': 0xB22222,
	'floralwhite': 0xFFFAF0, 'forestgreen': 0x228B22, 'fuchsia': 0xFF00FF, 'gainsboro': 0xDCDCDC, 'ghostwhite': 0xF8F8FF, 'gold': 0xFFD700,
	'goldenrod': 0xDAA520, 'gray': 0x808080, 'green': 0x008000, 'greenyellow': 0xADFF2F, 'grey': 0x808080, 'honeydew': 0xF0FFF0, 'hotpink': 0xFF69B4,
	'indianred': 0xCD5C5C, 'indigo': 0x4B0082, 'ivory': 0xFFFFF0, 'khaki': 0xF0E68C, 'lavender': 0xE6E6FA, 'lavenderblush': 0xFFF0F5, 'lawngreen': 0x7CFC00,
	'lemonchiffon': 0xFFFACD, 'lightblue': 0xADD8E6, 'lightcoral': 0xF08080, 'lightcyan': 0xE0FFFF, 'lightgoldenrodyellow': 0xFAFAD2, 'lightgray': 0xD3D3D3,
	'lightgreen': 0x90EE90, 'lightgrey': 0xD3D3D3, 'lightpink': 0xFFB6C1, 'lightsalmon': 0xFFA07A, 'lightseagreen': 0x20B2AA, 'lightskyblue': 0x87CEFA,
	'lightslategray': 0x778899, 'lightslategrey': 0x778899, 'lightsteelblue': 0xB0C4DE, 'lightyellow': 0xFFFFE0, 'lime': 0x00FF00, 'limegreen': 0x32CD32,
	'linen': 0xFAF0E6, 'magenta': 0xFF00FF, 'maroon': 0x800000, 'mediumaquamarine': 0x66CDAA, 'mediumblue': 0x0000CD, 'mediumorchid': 0xBA55D3,
	'mediumpurple': 0x9370DB, 'mediumseagreen': 0x3CB371, 'mediumslateblue': 0x7B68EE, 'mediumspringgreen': 0x00FA9A, 'mediumturquoise': 0x48D1CC,
	'mediumvioletred': 0xC71585, 'midnightblue': 0x191970, 'mintcream': 0xF5FFFA, 'mistyrose': 0xFFE4E1, 'moccasin': 0xFFE4B5, 'navajowhite': 0xFFDEAD,
	'navy': 0x000080, 'oldlace': 0xFDF5E6, 'olive': 0x808000, 'olivedrab': 0x6B8E23, 'orange': 0xFFA500, 'orangered': 0xFF4500, 'orchid': 0xDA70D6,
	'palegoldenrod': 0xEEE8AA, 'palegreen': 0x98FB98, 'paleturquoise': 0xAFEEEE, 'palevioletred': 0xDB7093, 'papayawhip': 0xFFEFD5, 'peachpuff': 0xFFDAB9,
	'peru': 0xCD853F, 'pink': 0xFFC0CB, 'plum': 0xDDA0DD, 'powderblue': 0xB0E0E6, 'purple': 0x800080, 'red': 0xFF0000, 'rosybrown': 0xBC8F8F,
	'royalblue': 0x4169E1, 'saddlebrown': 0x8B4513, 'salmon': 0xFA8072, 'sandybrown': 0xF4A460, 'seagreen': 0x2E8B57, 'seashell': 0xFFF5EE,
	'sienna': 0xA0522D, 'silver': 0xC0C0C0, 'skyblue': 0x87CEEB, 'slateblue': 0x6A5ACD, 'slategray': 0x708090, 'slategrey': 0x708090, 'snow': 0xFFFAFA,
	'springgreen': 0x00FF7F, 'steelblue': 0x4682B4, 'tan': 0xD2B48C, 'teal': 0x008080, 'thistle': 0xD8BFD8, 'tomato': 0xFF6347, 'turquoise': 0x40E0D0,
	'violet': 0xEE82EE, 'wheat': 0xF5DEB3, 'white': 0xFFFFFF, 'whitesmoke': 0xF5F5F5, 'yellow': 0xFFFF00, 'yellowgreen': 0x9ACD32 };

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	function DataTexture( data, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding ) {

		Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );

		this.image = { data: data, width: width, height: height };

		this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
		this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;

		this.generateMipmaps  = false;
		this.flipY = false;
		this.unpackAlignment = 1;

	}

	DataTexture.prototype = Object.create( Texture.prototype );
	DataTexture.prototype.constructor = DataTexture;

	DataTexture.prototype.isDataTexture = true;

	/**
	 * Uniforms library for shared webgl shaders
	 */

	var UniformsLib = {

		common: {

			diffuse: { value: new Color( 0xeeeeee ) },
			opacity: { value: 1.0 },

			map: { value: null },
			offsetRepeat: { value: new Vector4( 0, 0, 1, 1 ) },

			specularMap: { value: null },
			alphaMap: { value: null },

			envMap: { value: null },
			flipEnvMap: { value: - 1 },
			reflectivity: { value: 1.0 },
			refractionRatio: { value: 0.98 }

		},

		aomap: {

			aoMap: { value: null },
			aoMapIntensity: { value: 1 }

		},

		lightmap: {

			lightMap: { value: null },
			lightMapIntensity: { value: 1 }

		},

		emissivemap: {

			emissiveMap: { value: null }

		},

		bumpmap: {

			bumpMap: { value: null },
			bumpScale: { value: 1 }

		},

		normalmap: {

			normalMap: { value: null },
			normalScale: { value: new Vector2( 1, 1 ) }

		},

		displacementmap: {

			displacementMap: { value: null },
			displacementScale: { value: 1 },
			displacementBias: { value: 0 }

		},

		roughnessmap: {

			roughnessMap: { value: null }

		},

		metalnessmap: {

			metalnessMap: { value: null }

		},

		gradientmap: {

			gradientMap: { value: null }

		},

		fog: {

			fogDensity: { value: 0.00025 },
			fogNear: { value: 1 },
			fogFar: { value: 2000 },
			fogColor: { value: new Color( 0xffffff ) }

		},

		lights: {

			ambientLightColor: { value: [] },

			directionalLights: { value: [], properties: {
				direction: {},
				color: {},

				shadow: {},
				shadowBias: {},
				shadowRadius: {},
				shadowMapSize: {}
			} },

			directionalShadowMap: { value: [] },
			directionalShadowMatrix: { value: [] },

			spotLights: { value: [], properties: {
				color: {},
				position: {},
				direction: {},
				distance: {},
				coneCos: {},
				penumbraCos: {},
				decay: {},

				shadow: {},
				shadowBias: {},
				shadowRadius: {},
				shadowMapSize: {}
			} },

			spotShadowMap: { value: [] },
			spotShadowMatrix: { value: [] },

			pointLights: { value: [], properties: {
				color: {},
				position: {},
				decay: {},
				distance: {},

				shadow: {},
				shadowBias: {},
				shadowRadius: {},
				shadowMapSize: {}
			} },

			pointShadowMap: { value: [] },
			pointShadowMatrix: { value: [] },

			hemisphereLights: { value: [], properties: {
				direction: {},
				skyColor: {},
				groundColor: {}
			} },

	        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
	        rectAreaLights: { value: [], properties: {
	            color: {},
	            position: {},
	            width: {},
	            height: {},
	        } }

		},

		points: {

			diffuse: { value: new Color( 0xeeeeee ) },
			opacity: { value: 1.0 },
			size: { value: 1.0 },
			scale: { value: 1.0 },
			map: { value: null },
			offsetRepeat: { value: new Vector4( 0, 0, 1, 1 ) }

		}

	};

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author mrdoob / http://mrdoob.com/
	 * @author mikael emtinger / http://gomo.se/
	 */

	var ShaderLib = {

		basic: {

			uniforms: UniformsUtils.merge( [
				UniformsLib.common,
				UniformsLib.aomap,
				UniformsLib.lightmap,
				UniformsLib.fog
			] ),

			vertexShader: ShaderChunk.meshbasic_vert,
			fragmentShader: ShaderChunk.meshbasic_frag

		},

		lambert: {

			uniforms: UniformsUtils.merge( [
				UniformsLib.common,
				UniformsLib.aomap,
				UniformsLib.lightmap,
				UniformsLib.emissivemap,
				UniformsLib.fog,
				UniformsLib.lights,
				{
					emissive: { value: new Color( 0x000000 ) }
				}
			] ),

			vertexShader: ShaderChunk.meshlambert_vert,
			fragmentShader: ShaderChunk.meshlambert_frag

		},

		phong: {

			uniforms: UniformsUtils.merge( [
				UniformsLib.common,
				UniformsLib.aomap,
				UniformsLib.lightmap,
				UniformsLib.emissivemap,
				UniformsLib.bumpmap,
				UniformsLib.normalmap,
				UniformsLib.displacementmap,
				UniformsLib.gradientmap,
				UniformsLib.fog,
				UniformsLib.lights,
				{
					emissive: { value: new Color( 0x000000 ) },
					specular: { value: new Color( 0x111111 ) },
					shininess: { value: 30 }
				}
			] ),

			vertexShader: ShaderChunk.meshphong_vert,
			fragmentShader: ShaderChunk.meshphong_frag

		},

		standard: {

			uniforms: UniformsUtils.merge( [
				UniformsLib.common,
				UniformsLib.aomap,
				UniformsLib.lightmap,
				UniformsLib.emissivemap,
				UniformsLib.bumpmap,
				UniformsLib.normalmap,
				UniformsLib.displacementmap,
				UniformsLib.roughnessmap,
				UniformsLib.metalnessmap,
				UniformsLib.fog,
				UniformsLib.lights,
				{
					emissive: { value: new Color( 0x000000 ) },
					roughness: { value: 0.5 },
					metalness: { value: 0 },
					envMapIntensity: { value: 1 } // temporary
				}
			] ),

			vertexShader: ShaderChunk.meshphysical_vert,
			fragmentShader: ShaderChunk.meshphysical_frag

		},

		points: {

			uniforms: UniformsUtils.merge( [
				UniformsLib.points,
				UniformsLib.fog
			] ),

			vertexShader: ShaderChunk.points_vert,
			fragmentShader: ShaderChunk.points_frag

		},

		dashed: {

			uniforms: UniformsUtils.merge( [
				UniformsLib.common,
				UniformsLib.fog,
				{
					scale: { value: 1 },
					dashSize: { value: 1 },
					totalSize: { value: 2 }
				}
			] ),

			vertexShader: ShaderChunk.linedashed_vert,
			fragmentShader: ShaderChunk.linedashed_frag

		},

		depth: {

			uniforms: UniformsUtils.merge( [
				UniformsLib.common,
				UniformsLib.displacementmap
			] ),

			vertexShader: ShaderChunk.depth_vert,
			fragmentShader: ShaderChunk.depth_frag

		},

		normal: {

			uniforms: UniformsUtils.merge( [
				UniformsLib.common,
				UniformsLib.bumpmap,
				UniformsLib.normalmap,
				UniformsLib.displacementmap,
				{
					opacity: { value: 1.0 }
				}
			] ),

			vertexShader: ShaderChunk.normal_vert,
			fragmentShader: ShaderChunk.normal_frag

		},

		/* -------------------------------------------------------------------------
		//	Cube map shader
		 ------------------------------------------------------------------------- */

		cube: {

			uniforms: {
				tCube: { value: null },
				tFlip: { value: - 1 },
				opacity: { value: 1.0 }
			},

			vertexShader: ShaderChunk.cube_vert,
			fragmentShader: ShaderChunk.cube_frag

		},

		/* -------------------------------------------------------------------------
		//	Cube map shader
		 ------------------------------------------------------------------------- */

		equirect: {

			uniforms: {
				tEquirect: { value: null },
				tFlip: { value: - 1 }
			},

			vertexShader: ShaderChunk.equirect_vert,
			fragmentShader: ShaderChunk.equirect_frag

		},

		distanceRGBA: {

			uniforms: {
				lightPos: { value: new Vector3() }
			},

			vertexShader: ShaderChunk.distanceRGBA_vert,
			fragmentShader: ShaderChunk.distanceRGBA_frag

		}

	};

	ShaderLib.physical = {

		uniforms: UniformsUtils.merge( [
			ShaderLib.standard.uniforms,
			{
				clearCoat: { value: 0 },
				clearCoatRoughness: { value: 0 }
			}
		] ),

		vertexShader: ShaderChunk.meshphysical_vert,
		fragmentShader: ShaderChunk.meshphysical_frag

	};

	/**
	 * @author bhouston / http://clara.io
	 */

	function Box2( min, max ) {

		this.min = ( min !== undefined ) ? min : new Vector2( + Infinity, + Infinity );
		this.max = ( max !== undefined ) ? max : new Vector2( - Infinity, - Infinity );

	}

	Box2.prototype = {

		constructor: Box2,

		set: function ( min, max ) {

			this.min.copy( min );
			this.max.copy( max );

			return this;

		},

		setFromPoints: function ( points ) {

			this.makeEmpty();

			for ( var i = 0, il = points.length; i < il; i ++ ) {

				this.expandByPoint( points[ i ] );

			}

			return this;

		},

		setFromCenterAndSize: function () {

			var v1 = new Vector2();

			return function setFromCenterAndSize( center, size ) {

				var halfSize = v1.copy( size ).multiplyScalar( 0.5 );
				this.min.copy( center ).sub( halfSize );
				this.max.copy( center ).add( halfSize );

				return this;

			};

		}(),

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( box ) {

			this.min.copy( box.min );
			this.max.copy( box.max );

			return this;

		},

		makeEmpty: function () {

			this.min.x = this.min.y = + Infinity;
			this.max.x = this.max.y = - Infinity;

			return this;

		},

		isEmpty: function () {

			// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes

			return ( this.max.x < this.min.x ) || ( this.max.y < this.min.y );

		},

		getCenter: function ( optionalTarget ) {

			var result = optionalTarget || new Vector2();
			return this.isEmpty() ? result.set( 0, 0 ) : result.addVectors( this.min, this.max ).multiplyScalar( 0.5 );

		},

		getSize: function ( optionalTarget ) {

			var result = optionalTarget || new Vector2();
			return this.isEmpty() ? result.set( 0, 0 ) : result.subVectors( this.max, this.min );

		},

		expandByPoint: function ( point ) {

			this.min.min( point );
			this.max.max( point );

			return this;

		},

		expandByVector: function ( vector ) {

			this.min.sub( vector );
			this.max.add( vector );

			return this;

		},

		expandByScalar: function ( scalar ) {

			this.min.addScalar( - scalar );
			this.max.addScalar( scalar );

			return this;

		},

		containsPoint: function ( point ) {

			return point.x < this.min.x || point.x > this.max.x ||
				point.y < this.min.y || point.y > this.max.y ? false : true;

		},

		containsBox: function ( box ) {

			return this.min.x <= box.min.x && box.max.x <= this.max.x &&
				this.min.y <= box.min.y && box.max.y <= this.max.y;

		},

		getParameter: function ( point, optionalTarget ) {

			// This can potentially have a divide by zero if the box
			// has a size dimension of 0.

			var result = optionalTarget || new Vector2();

			return result.set(
				( point.x - this.min.x ) / ( this.max.x - this.min.x ),
				( point.y - this.min.y ) / ( this.max.y - this.min.y )
			);

		},

		intersectsBox: function ( box ) {

			// using 6 splitting planes to rule out intersections.
			return box.max.x < this.min.x || box.min.x > this.max.x ||
				box.max.y < this.min.y || box.min.y > this.max.y ? false : true;

		},

		clampPoint: function ( point, optionalTarget ) {

			var result = optionalTarget || new Vector2();
			return result.copy( point ).clamp( this.min, this.max );

		},

		distanceToPoint: function () {

			var v1 = new Vector2();

			return function distanceToPoint( point ) {

				var clampedPoint = v1.copy( point ).clamp( this.min, this.max );
				return clampedPoint.sub( point ).length();

			};

		}(),

		intersect: function ( box ) {

			this.min.max( box.min );
			this.max.min( box.max );

			return this;

		},

		union: function ( box ) {

			this.min.min( box.min );
			this.max.max( box.max );

			return this;

		},

		translate: function ( offset ) {

			this.min.add( offset );
			this.max.add( offset );

			return this;

		},

		equals: function ( box ) {

			return box.min.equals( this.min ) && box.max.equals( this.max );

		}

	};

	/**
	 * @author mikael emtinger / http://gomo.se/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function LensFlarePlugin( renderer, flares ) {

		var gl = renderer.context;
		var state = renderer.state;

		var vertexBuffer, elementBuffer;
		var shader, program, attributes, uniforms;

		var tempTexture, occlusionTexture;

		function init() {

			var vertices = new Float32Array( [
				- 1, - 1,  0, 0,
				 1, - 1,  1, 0,
				 1,  1,  1, 1,
				- 1,  1,  0, 1
			] );

			var faces = new Uint16Array( [
				0, 1, 2,
				0, 2, 3
			] );

			// buffers

			vertexBuffer     = gl.createBuffer();
			elementBuffer    = gl.createBuffer();

			gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
			gl.bufferData( gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW );

			gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );
			gl.bufferData( gl.ELEMENT_ARRAY_BUFFER, faces, gl.STATIC_DRAW );

			// textures

			tempTexture      = gl.createTexture();
			occlusionTexture = gl.createTexture();

			state.bindTexture( gl.TEXTURE_2D, tempTexture );
			gl.texImage2D( gl.TEXTURE_2D, 0, gl.RGB, 16, 16, 0, gl.RGB, gl.UNSIGNED_BYTE, null );
			gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE );
			gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE );
			gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST );
			gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST );

			state.bindTexture( gl.TEXTURE_2D, occlusionTexture );
			gl.texImage2D( gl.TEXTURE_2D, 0, gl.RGBA, 16, 16, 0, gl.RGBA, gl.UNSIGNED_BYTE, null );
			gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE );
			gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE );
			gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST );
			gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST );

			shader = {

				vertexShader: [

					"uniform lowp int renderType;",

					"uniform vec3 screenPosition;",
					"uniform vec2 scale;",
					"uniform float rotation;",

					"uniform sampler2D occlusionMap;",

					"attribute vec2 position;",
					"attribute vec2 uv;",

					"varying vec2 vUV;",
					"varying float vVisibility;",

					"void main() {",

						"vUV = uv;",

						"vec2 pos = position;",

						"if ( renderType == 2 ) {",

							"vec4 visibility = texture2D( occlusionMap, vec2( 0.1, 0.1 ) );",
							"visibility += texture2D( occlusionMap, vec2( 0.5, 0.1 ) );",
							"visibility += texture2D( occlusionMap, vec2( 0.9, 0.1 ) );",
							"visibility += texture2D( occlusionMap, vec2( 0.9, 0.5 ) );",
							"visibility += texture2D( occlusionMap, vec2( 0.9, 0.9 ) );",
							"visibility += texture2D( occlusionMap, vec2( 0.5, 0.9 ) );",
							"visibility += texture2D( occlusionMap, vec2( 0.1, 0.9 ) );",
							"visibility += texture2D( occlusionMap, vec2( 0.1, 0.5 ) );",
							"visibility += texture2D( occlusionMap, vec2( 0.5, 0.5 ) );",

							"vVisibility =        visibility.r / 9.0;",
							"vVisibility *= 1.0 - visibility.g / 9.0;",
							"vVisibility *=       visibility.b / 9.0;",
							"vVisibility *= 1.0 - visibility.a / 9.0;",

							"pos.x = cos( rotation ) * position.x - sin( rotation ) * position.y;",
							"pos.y = sin( rotation ) * position.x + cos( rotation ) * position.y;",

						"}",

						"gl_Position = vec4( ( pos * scale + screenPosition.xy ).xy, screenPosition.z, 1.0 );",

					"}"

				].join( "\n" ),

				fragmentShader: [

					"uniform lowp int renderType;",

					"uniform sampler2D map;",
					"uniform float opacity;",
					"uniform vec3 color;",

					"varying vec2 vUV;",
					"varying float vVisibility;",

					"void main() {",

						// pink square

						"if ( renderType == 0 ) {",

							"gl_FragColor = vec4( 1.0, 0.0, 1.0, 0.0 );",

						// restore

						"} else if ( renderType == 1 ) {",

							"gl_FragColor = texture2D( map, vUV );",

						// flare

						"} else {",

							"vec4 texture = texture2D( map, vUV );",
							"texture.a *= opacity * vVisibility;",
							"gl_FragColor = texture;",
							"gl_FragColor.rgb *= color;",

						"}",

					"}"

				].join( "\n" )

			};

			program = createProgram( shader );

			attributes = {
				vertex: gl.getAttribLocation ( program, "position" ),
				uv:     gl.getAttribLocation ( program, "uv" )
			};

			uniforms = {
				renderType:     gl.getUniformLocation( program, "renderType" ),
				map:            gl.getUniformLocation( program, "map" ),
				occlusionMap:   gl.getUniformLocation( program, "occlusionMap" ),
				opacity:        gl.getUniformLocation( program, "opacity" ),
				color:          gl.getUniformLocation( program, "color" ),
				scale:          gl.getUniformLocation( program, "scale" ),
				rotation:       gl.getUniformLocation( program, "rotation" ),
				screenPosition: gl.getUniformLocation( program, "screenPosition" )
			};

		}

		/*
		 * Render lens flares
		 * Method: renders 16x16 0xff00ff-colored points scattered over the light source area,
		 *         reads these back and calculates occlusion.
		 */

		this.render = function ( scene, camera, viewport ) {

			if ( flares.length === 0 ) return;

			var tempPosition = new Vector3();

			var invAspect = viewport.w / viewport.z,
				halfViewportWidth = viewport.z * 0.5,
				halfViewportHeight = viewport.w * 0.5;

			var size = 16 / viewport.w,
				scale = new Vector2( size * invAspect, size );

			var screenPosition = new Vector3( 1, 1, 0 ),
				screenPositionPixels = new Vector2( 1, 1 );

			var validArea = new Box2();

			validArea.min.set( viewport.x, viewport.y );
			validArea.max.set( viewport.x + ( viewport.z - 16 ), viewport.y + ( viewport.w - 16 ) );

			if ( program === undefined ) {

				init();

			}

			gl.useProgram( program );

			state.initAttributes();
			state.enableAttribute( attributes.vertex );
			state.enableAttribute( attributes.uv );
			state.disableUnusedAttributes();

			// loop through all lens flares to update their occlusion and positions
			// setup gl and common used attribs/uniforms

			gl.uniform1i( uniforms.occlusionMap, 0 );
			gl.uniform1i( uniforms.map, 1 );

			gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
			gl.vertexAttribPointer( attributes.vertex, 2, gl.FLOAT, false, 2 * 8, 0 );
			gl.vertexAttribPointer( attributes.uv, 2, gl.FLOAT, false, 2 * 8, 8 );

			gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );

			state.disable( gl.CULL_FACE );
			state.setDepthWrite( false );

			for ( var i = 0, l = flares.length; i < l; i ++ ) {

				size = 16 / viewport.w;
				scale.set( size * invAspect, size );

				// calc object screen position

				var flare = flares[ i ];

				tempPosition.set( flare.matrixWorld.elements[ 12 ], flare.matrixWorld.elements[ 13 ], flare.matrixWorld.elements[ 14 ] );

				tempPosition.applyMatrix4( camera.matrixWorldInverse );
				tempPosition.applyProjection( camera.projectionMatrix );

				// setup arrays for gl programs

				screenPosition.copy( tempPosition );

				// horizontal and vertical coordinate of the lower left corner of the pixels to copy

				screenPositionPixels.x = viewport.x + ( screenPosition.x * halfViewportWidth ) + halfViewportWidth - 8;
				screenPositionPixels.y = viewport.y + ( screenPosition.y * halfViewportHeight ) + halfViewportHeight - 8;

				// screen cull

				if ( validArea.containsPoint( screenPositionPixels ) === true ) {

					// save current RGB to temp texture

					state.activeTexture( gl.TEXTURE0 );
					state.bindTexture( gl.TEXTURE_2D, null );
					state.activeTexture( gl.TEXTURE1 );
					state.bindTexture( gl.TEXTURE_2D, tempTexture );
					gl.copyTexImage2D( gl.TEXTURE_2D, 0, gl.RGB, screenPositionPixels.x, screenPositionPixels.y, 16, 16, 0 );


					// render pink quad

					gl.uniform1i( uniforms.renderType, 0 );
					gl.uniform2f( uniforms.scale, scale.x, scale.y );
					gl.uniform3f( uniforms.screenPosition, screenPosition.x, screenPosition.y, screenPosition.z );

					state.disable( gl.BLEND );
					state.enable( gl.DEPTH_TEST );

					gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );


					// copy result to occlusionMap

					state.activeTexture( gl.TEXTURE0 );
					state.bindTexture( gl.TEXTURE_2D, occlusionTexture );
					gl.copyTexImage2D( gl.TEXTURE_2D, 0, gl.RGBA, screenPositionPixels.x, screenPositionPixels.y, 16, 16, 0 );


					// restore graphics

					gl.uniform1i( uniforms.renderType, 1 );
					state.disable( gl.DEPTH_TEST );

					state.activeTexture( gl.TEXTURE1 );
					state.bindTexture( gl.TEXTURE_2D, tempTexture );
					gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );


					// update object positions

					flare.positionScreen.copy( screenPosition );

					if ( flare.customUpdateCallback ) {

						flare.customUpdateCallback( flare );

					} else {

						flare.updateLensFlares();

					}

					// render flares

					gl.uniform1i( uniforms.renderType, 2 );
					state.enable( gl.BLEND );

					for ( var j = 0, jl = flare.lensFlares.length; j < jl; j ++ ) {

						var sprite = flare.lensFlares[ j ];

						if ( sprite.opacity > 0.001 && sprite.scale > 0.001 ) {

							screenPosition.x = sprite.x;
							screenPosition.y = sprite.y;
							screenPosition.z = sprite.z;

							size = sprite.size * sprite.scale / viewport.w;

							scale.x = size * invAspect;
							scale.y = size;

							gl.uniform3f( uniforms.screenPosition, screenPosition.x, screenPosition.y, screenPosition.z );
							gl.uniform2f( uniforms.scale, scale.x, scale.y );
							gl.uniform1f( uniforms.rotation, sprite.rotation );

							gl.uniform1f( uniforms.opacity, sprite.opacity );
							gl.uniform3f( uniforms.color, sprite.color.r, sprite.color.g, sprite.color.b );

							state.setBlending( sprite.blending, sprite.blendEquation, sprite.blendSrc, sprite.blendDst );
							renderer.setTexture2D( sprite.texture, 1 );

							gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );

						}

					}

				}

			}

			// restore gl

			state.enable( gl.CULL_FACE );
			state.enable( gl.DEPTH_TEST );
			state.setDepthWrite( true );

			renderer.resetGLState();

		};

		function createProgram( shader ) {

			var program = gl.createProgram();

			var fragmentShader = gl.createShader( gl.FRAGMENT_SHADER );
			var vertexShader = gl.createShader( gl.VERTEX_SHADER );

			var prefix = "precision " + renderer.getPrecision() + " float;\n";

			gl.shaderSource( fragmentShader, prefix + shader.fragmentShader );
			gl.shaderSource( vertexShader, prefix + shader.vertexShader );

			gl.compileShader( fragmentShader );
			gl.compileShader( vertexShader );

			gl.attachShader( program, fragmentShader );
			gl.attachShader( program, vertexShader );

			gl.linkProgram( program );

			return program;

		}

	}

	/**
	 * @author mikael emtinger / http://gomo.se/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function SpritePlugin( renderer, sprites ) {

		var gl = renderer.context;
		var state = renderer.state;

		var vertexBuffer, elementBuffer;
		var program, attributes, uniforms;

		var texture;

		// decompose matrixWorld

		var spritePosition = new Vector3();
		var spriteRotation = new Quaternion();
		var spriteScale = new Vector3();

		function init() {

			var vertices = new Float32Array( [
				- 0.5, - 0.5,  0, 0,
				  0.5, - 0.5,  1, 0,
				  0.5,   0.5,  1, 1,
				- 0.5,   0.5,  0, 1
			] );

			var faces = new Uint16Array( [
				0, 1, 2,
				0, 2, 3
			] );

			vertexBuffer  = gl.createBuffer();
			elementBuffer = gl.createBuffer();

			gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
			gl.bufferData( gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW );

			gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );
			gl.bufferData( gl.ELEMENT_ARRAY_BUFFER, faces, gl.STATIC_DRAW );

			program = createProgram();

			attributes = {
				position:			gl.getAttribLocation ( program, 'position' ),
				uv:					gl.getAttribLocation ( program, 'uv' )
			};

			uniforms = {
				uvOffset:			gl.getUniformLocation( program, 'uvOffset' ),
				uvScale:			gl.getUniformLocation( program, 'uvScale' ),

				rotation:			gl.getUniformLocation( program, 'rotation' ),
				scale:				gl.getUniformLocation( program, 'scale' ),

				color:				gl.getUniformLocation( program, 'color' ),
				map:				gl.getUniformLocation( program, 'map' ),
				opacity:			gl.getUniformLocation( program, 'opacity' ),

				modelViewMatrix: 	gl.getUniformLocation( program, 'modelViewMatrix' ),
				projectionMatrix:	gl.getUniformLocation( program, 'projectionMatrix' ),

				fogType:			gl.getUniformLocation( program, 'fogType' ),
				fogDensity:			gl.getUniformLocation( program, 'fogDensity' ),
				fogNear:			gl.getUniformLocation( program, 'fogNear' ),
				fogFar:				gl.getUniformLocation( program, 'fogFar' ),
				fogColor:			gl.getUniformLocation( program, 'fogColor' ),

				alphaTest:			gl.getUniformLocation( program, 'alphaTest' )
			};

			var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
			canvas.width = 8;
			canvas.height = 8;

			var context = canvas.getContext( '2d' );
			context.fillStyle = 'white';
			context.fillRect( 0, 0, 8, 8 );

			texture = new Texture( canvas );
			texture.needsUpdate = true;

		}

		this.render = function ( scene, camera ) {

			if ( sprites.length === 0 ) return;

			// setup gl

			if ( program === undefined ) {

				init();

			}

			gl.useProgram( program );

			state.initAttributes();
			state.enableAttribute( attributes.position );
			state.enableAttribute( attributes.uv );
			state.disableUnusedAttributes();

			state.disable( gl.CULL_FACE );
			state.enable( gl.BLEND );

			gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
			gl.vertexAttribPointer( attributes.position, 2, gl.FLOAT, false, 2 * 8, 0 );
			gl.vertexAttribPointer( attributes.uv, 2, gl.FLOAT, false, 2 * 8, 8 );

			gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );

			gl.uniformMatrix4fv( uniforms.projectionMatrix, false, camera.projectionMatrix.elements );

			state.activeTexture( gl.TEXTURE0 );
			gl.uniform1i( uniforms.map, 0 );

			var oldFogType = 0;
			var sceneFogType = 0;
			var fog = scene.fog;

			if ( fog ) {

				gl.uniform3f( uniforms.fogColor, fog.color.r, fog.color.g, fog.color.b );

				if ( fog.isFog ) {

					gl.uniform1f( uniforms.fogNear, fog.near );
					gl.uniform1f( uniforms.fogFar, fog.far );

					gl.uniform1i( uniforms.fogType, 1 );
					oldFogType = 1;
					sceneFogType = 1;

				} else if ( fog.isFogExp2 ) {

					gl.uniform1f( uniforms.fogDensity, fog.density );

					gl.uniform1i( uniforms.fogType, 2 );
					oldFogType = 2;
					sceneFogType = 2;

				}

			} else {

				gl.uniform1i( uniforms.fogType, 0 );
				oldFogType = 0;
				sceneFogType = 0;

			}


			// update positions and sort

			for ( var i = 0, l = sprites.length; i < l; i ++ ) {

				var sprite = sprites[ i ];

				sprite.modelViewMatrix.multiplyMatrices( camera.matrixWorldInverse, sprite.matrixWorld );
				sprite.z = - sprite.modelViewMatrix.elements[ 14 ];

			}

			sprites.sort( painterSortStable );

			// render all sprites

			var scale = [];

			for ( var i = 0, l = sprites.length; i < l; i ++ ) {

				var sprite = sprites[ i ];
				var material = sprite.material;

				if ( material.visible === false ) continue;

				gl.uniform1f( uniforms.alphaTest, material.alphaTest );
				gl.uniformMatrix4fv( uniforms.modelViewMatrix, false, sprite.modelViewMatrix.elements );

				sprite.matrixWorld.decompose( spritePosition, spriteRotation, spriteScale );

				scale[ 0 ] = spriteScale.x;
				scale[ 1 ] = spriteScale.y;

				var fogType = 0;

				if ( scene.fog && material.fog ) {

					fogType = sceneFogType;

				}

				if ( oldFogType !== fogType ) {

					gl.uniform1i( uniforms.fogType, fogType );
					oldFogType = fogType;

				}

				if ( material.map !== null ) {

					gl.uniform2f( uniforms.uvOffset, material.map.offset.x, material.map.offset.y );
					gl.uniform2f( uniforms.uvScale, material.map.repeat.x, material.map.repeat.y );

				} else {

					gl.uniform2f( uniforms.uvOffset, 0, 0 );
					gl.uniform2f( uniforms.uvScale, 1, 1 );

				}

				gl.uniform1f( uniforms.opacity, material.opacity );
				gl.uniform3f( uniforms.color, material.color.r, material.color.g, material.color.b );

				gl.uniform1f( uniforms.rotation, material.rotation );
				gl.uniform2fv( uniforms.scale, scale );

				state.setBlending( material.blending, material.blendEquation, material.blendSrc, material.blendDst );
				state.setDepthTest( material.depthTest );
				state.setDepthWrite( material.depthWrite );

				if ( material.map ) {

					renderer.setTexture2D( material.map, 0 );

				} else {

					renderer.setTexture2D( texture, 0 );

				}

				gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );

			}

			// restore gl

			state.enable( gl.CULL_FACE );

			renderer.resetGLState();

		};

		function createProgram() {

			var program = gl.createProgram();

			var vertexShader = gl.createShader( gl.VERTEX_SHADER );
			var fragmentShader = gl.createShader( gl.FRAGMENT_SHADER );

			gl.shaderSource( vertexShader, [

				'precision ' + renderer.getPrecision() + ' float;',

				'uniform mat4 modelViewMatrix;',
				'uniform mat4 projectionMatrix;',
				'uniform float rotation;',
				'uniform vec2 scale;',
				'uniform vec2 uvOffset;',
				'uniform vec2 uvScale;',

				'attribute vec2 position;',
				'attribute vec2 uv;',

				'varying vec2 vUV;',

				'void main() {',

					'vUV = uvOffset + uv * uvScale;',

					'vec2 alignedPosition = position * scale;',

					'vec2 rotatedPosition;',
					'rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;',
					'rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;',

					'vec4 finalPosition;',

					'finalPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );',
					'finalPosition.xy += rotatedPosition;',
					'finalPosition = projectionMatrix * finalPosition;',

					'gl_Position = finalPosition;',

				'}'

			].join( '\n' ) );

			gl.shaderSource( fragmentShader, [

				'precision ' + renderer.getPrecision() + ' float;',

				'uniform vec3 color;',
				'uniform sampler2D map;',
				'uniform float opacity;',

				'uniform int fogType;',
				'uniform vec3 fogColor;',
				'uniform float fogDensity;',
				'uniform float fogNear;',
				'uniform float fogFar;',
				'uniform float alphaTest;',

				'varying vec2 vUV;',

				'void main() {',

					'vec4 texture = texture2D( map, vUV );',

					'if ( texture.a < alphaTest ) discard;',

					'gl_FragColor = vec4( color * texture.xyz, texture.a * opacity );',

					'if ( fogType > 0 ) {',

						'float depth = gl_FragCoord.z / gl_FragCoord.w;',
						'float fogFactor = 0.0;',

						'if ( fogType == 1 ) {',

							'fogFactor = smoothstep( fogNear, fogFar, depth );',

						'} else {',

							'const float LOG2 = 1.442695;',
							'fogFactor = exp2( - fogDensity * fogDensity * depth * depth * LOG2 );',
							'fogFactor = 1.0 - clamp( fogFactor, 0.0, 1.0 );',

						'}',

						'gl_FragColor = mix( gl_FragColor, vec4( fogColor, gl_FragColor.w ), fogFactor );',

					'}',

				'}'

			].join( '\n' ) );

			gl.compileShader( vertexShader );
			gl.compileShader( fragmentShader );

			gl.attachShader( program, vertexShader );
			gl.attachShader( program, fragmentShader );

			gl.linkProgram( program );

			return program;

		}

		function painterSortStable( a, b ) {

			if ( a.renderOrder !== b.renderOrder ) {

				return a.renderOrder - b.renderOrder;

			} else if ( a.z !== b.z ) {

				return b.z - a.z;

			} else {

				return b.id - a.id;

			}

		}

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 */

	var materialId = 0;

	function Material() {

		Object.defineProperty( this, 'id', { value: materialId ++ } );

		this.uuid = _Math.generateUUID();

		this.name = '';
		this.type = 'Material';

		this.fog = true;
		this.lights = true;

		this.blending = NormalBlending;
		this.side = FrontSide;
		this.shading = SmoothShading; // THREE.FlatShading, THREE.SmoothShading
		this.vertexColors = NoColors; // THREE.NoColors, THREE.VertexColors, THREE.FaceColors

		this.opacity = 1;
		this.transparent = false;

		this.blendSrc = SrcAlphaFactor;
		this.blendDst = OneMinusSrcAlphaFactor;
		this.blendEquation = AddEquation;
		this.blendSrcAlpha = null;
		this.blendDstAlpha = null;
		this.blendEquationAlpha = null;

		this.depthFunc = LessEqualDepth;
		this.depthTest = true;
		this.depthWrite = true;

		this.clippingPlanes = null;
		this.clipIntersection = false;
		this.clipShadows = false;

		this.colorWrite = true;

		this.precision = null; // override the renderer's default precision for this material

		this.polygonOffset = false;
		this.polygonOffsetFactor = 0;
		this.polygonOffsetUnits = 0;

		this.alphaTest = 0;
		this.premultipliedAlpha = false;

		this.overdraw = 0; // Overdrawn pixels (typically between 0 and 1) for fixing antialiasing gaps in CanvasRenderer

		this.visible = true;

		this._needsUpdate = true;

	}

	Material.prototype = {

		constructor: Material,

		isMaterial: true,

		get needsUpdate() {

			return this._needsUpdate;

		},

		set needsUpdate( value ) {

			if ( value === true ) this.update();
			this._needsUpdate = value;

		},

		setValues: function ( values ) {

			if ( values === undefined ) return;

			for ( var key in values ) {

				var newValue = values[ key ];

				if ( newValue === undefined ) {

					console.warn( "THREE.Material: '" + key + "' parameter is undefined." );
					continue;

				}

				var currentValue = this[ key ];

				if ( currentValue === undefined ) {

					console.warn( "THREE." + this.type + ": '" + key + "' is not a property of this material." );
					continue;

				}

				if ( currentValue && currentValue.isColor ) {

					currentValue.set( newValue );

				} else if ( (currentValue && currentValue.isVector3) && (newValue && newValue.isVector3) ) {

					currentValue.copy( newValue );

				} else if ( key === 'overdraw' ) {

					// ensure overdraw is backwards-compatible with legacy boolean type
					this[ key ] = Number( newValue );

				} else {

					this[ key ] = newValue;

				}

			}

		},

		toJSON: function ( meta ) {

			var isRoot = meta === undefined;

			if ( isRoot ) {

				meta = {
					textures: {},
					images: {}
				};

			}

			var data = {
				metadata: {
					version: 4.4,
					type: 'Material',
					generator: 'Material.toJSON'
				}
			};

			// standard Material serialization
			data.uuid = this.uuid;
			data.type = this.type;

			if ( this.name !== '' ) data.name = this.name;

			if ( this.color && this.color.isColor ) data.color = this.color.getHex();

			if ( this.roughness !== undefined ) data.roughness = this.roughness;
			if ( this.metalness !== undefined ) data.metalness = this.metalness;

			if ( this.emissive && this.emissive.isColor ) data.emissive = this.emissive.getHex();
			if ( this.specular && this.specular.isColor ) data.specular = this.specular.getHex();
			if ( this.shininess !== undefined ) data.shininess = this.shininess;
			if ( this.clearCoat !== undefined ) data.clearCoat = this.clearCoat;
			if ( this.clearCoatRoughness !== undefined ) data.clearCoatRoughness = this.clearCoatRoughness;

			if ( this.map && this.map.isTexture ) data.map = this.map.toJSON( meta ).uuid;
			if ( this.alphaMap && this.alphaMap.isTexture ) data.alphaMap = this.alphaMap.toJSON( meta ).uuid;
			if ( this.lightMap && this.lightMap.isTexture ) data.lightMap = this.lightMap.toJSON( meta ).uuid;
			if ( this.bumpMap && this.bumpMap.isTexture ) {

				data.bumpMap = this.bumpMap.toJSON( meta ).uuid;
				data.bumpScale = this.bumpScale;

			}
			if ( this.normalMap && this.normalMap.isTexture ) {

				data.normalMap = this.normalMap.toJSON( meta ).uuid;
				data.normalScale = this.normalScale.toArray();

			}
			if ( this.displacementMap && this.displacementMap.isTexture ) {

				data.displacementMap = this.displacementMap.toJSON( meta ).uuid;
				data.displacementScale = this.displacementScale;
				data.displacementBias = this.displacementBias;

			}
			if ( this.roughnessMap && this.roughnessMap.isTexture ) data.roughnessMap = this.roughnessMap.toJSON( meta ).uuid;
			if ( this.metalnessMap && this.metalnessMap.isTexture ) data.metalnessMap = this.metalnessMap.toJSON( meta ).uuid;

			if ( this.emissiveMap && this.emissiveMap.isTexture ) data.emissiveMap = this.emissiveMap.toJSON( meta ).uuid;
			if ( this.specularMap && this.specularMap.isTexture ) data.specularMap = this.specularMap.toJSON( meta ).uuid;

			if ( this.envMap && this.envMap.isTexture ) {

				data.envMap = this.envMap.toJSON( meta ).uuid;
				data.reflectivity = this.reflectivity; // Scale behind envMap

			}

			if ( this.gradientMap && this.gradientMap.isTexture ) {

				data.gradientMap = this.gradientMap.toJSON( meta ).uuid;

			}

			if ( this.size !== undefined ) data.size = this.size;
			if ( this.sizeAttenuation !== undefined ) data.sizeAttenuation = this.sizeAttenuation;

			if ( this.blending !== NormalBlending ) data.blending = this.blending;
			if ( this.shading !== SmoothShading ) data.shading = this.shading;
			if ( this.side !== FrontSide ) data.side = this.side;
			if ( this.vertexColors !== NoColors ) data.vertexColors = this.vertexColors;

			if ( this.opacity < 1 ) data.opacity = this.opacity;
			if ( this.transparent === true ) data.transparent = this.transparent;

			data.depthFunc = this.depthFunc;
			data.depthTest = this.depthTest;
			data.depthWrite = this.depthWrite;

			if ( this.alphaTest > 0 ) data.alphaTest = this.alphaTest;
			if ( this.premultipliedAlpha === true ) data.premultipliedAlpha = this.premultipliedAlpha;
			if ( this.wireframe === true ) data.wireframe = this.wireframe;
			if ( this.wireframeLinewidth > 1 ) data.wireframeLinewidth = this.wireframeLinewidth;
			if ( this.wireframeLinecap !== 'round' ) data.wireframeLinecap = this.wireframeLinecap;
			if ( this.wireframeLinejoin !== 'round' ) data.wireframeLinejoin = this.wireframeLinejoin;

			data.skinning = this.skinning;
			data.morphTargets = this.morphTargets;

			// TODO: Copied from Object3D.toJSON

			function extractFromCache( cache ) {

				var values = [];

				for ( var key in cache ) {

					var data = cache[ key ];
					delete data.metadata;
					values.push( data );

				}

				return values;

			}

			if ( isRoot ) {

				var textures = extractFromCache( meta.textures );
				var images = extractFromCache( meta.images );

				if ( textures.length > 0 ) data.textures = textures;
				if ( images.length > 0 ) data.images = images;

			}

			return data;

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( source ) {

			this.name = source.name;

			this.fog = source.fog;
			this.lights = source.lights;

			this.blending = source.blending;
			this.side = source.side;
			this.shading = source.shading;
			this.vertexColors = source.vertexColors;

			this.opacity = source.opacity;
			this.transparent = source.transparent;

			this.blendSrc = source.blendSrc;
			this.blendDst = source.blendDst;
			this.blendEquation = source.blendEquation;
			this.blendSrcAlpha = source.blendSrcAlpha;
			this.blendDstAlpha = source.blendDstAlpha;
			this.blendEquationAlpha = source.blendEquationAlpha;

			this.depthFunc = source.depthFunc;
			this.depthTest = source.depthTest;
			this.depthWrite = source.depthWrite;

			this.colorWrite = source.colorWrite;

			this.precision = source.precision;

			this.polygonOffset = source.polygonOffset;
			this.polygonOffsetFactor = source.polygonOffsetFactor;
			this.polygonOffsetUnits = source.polygonOffsetUnits;

			this.alphaTest = source.alphaTest;

			this.premultipliedAlpha = source.premultipliedAlpha;

			this.overdraw = source.overdraw;

			this.visible = source.visible;
			this.clipShadows = source.clipShadows;
			this.clipIntersection = source.clipIntersection;

			var srcPlanes = source.clippingPlanes,
				dstPlanes = null;

			if ( srcPlanes !== null ) {

				var n = srcPlanes.length;
				dstPlanes = new Array( n );

				for ( var i = 0; i !== n; ++ i )
					dstPlanes[ i ] = srcPlanes[ i ].clone();

			}

			this.clippingPlanes = dstPlanes;

			return this;

		},

		update: function () {

			this.dispatchEvent( { type: 'update' } );

		},

		dispose: function () {

			this.dispatchEvent( { type: 'dispose' } );

		}

	};

	Object.assign( Material.prototype, EventDispatcher.prototype );

	/**
	 * @author alteredq / http://alteredqualia.com/
	 *
	 * parameters = {
	 *  defines: { "label" : "value" },
	 *  uniforms: { "parameter1": { value: 1.0 }, "parameter2": { value2: 2 } },
	 *
	 *  fragmentShader: <string>,
	 *  vertexShader: <string>,
	 *
	 *  wireframe: <boolean>,
	 *  wireframeLinewidth: <float>,
	 *
	 *  lights: <bool>,
	 *
	 *  skinning: <bool>,
	 *  morphTargets: <bool>,
	 *  morphNormals: <bool>
	 * }
	 */

	function ShaderMaterial( parameters ) {

		Material.call( this );

		this.type = 'ShaderMaterial';

		this.defines = {};
		this.uniforms = {};

		this.vertexShader = 'void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}';
		this.fragmentShader = 'void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}';

		this.linewidth = 1;

		this.wireframe = false;
		this.wireframeLinewidth = 1;

		this.fog = false; // set to use scene fog
		this.lights = false; // set to use scene lights
		this.clipping = false; // set to use user-defined clipping planes

		this.skinning = false; // set to use skinning attribute streams
		this.morphTargets = false; // set to use morph targets
		this.morphNormals = false; // set to use morph normals

		this.extensions = {
			derivatives: false, // set to use derivatives
			fragDepth: false, // set to use fragment depth values
			drawBuffers: false, // set to use draw buffers
			shaderTextureLOD: false // set to use shader texture LOD
		};

		// When rendered geometry doesn't include these attributes but the material does,
		// use these default values in WebGL. This avoids errors when buffer data is missing.
		this.defaultAttributeValues = {
			'color': [ 1, 1, 1 ],
			'uv': [ 0, 0 ],
			'uv2': [ 0, 0 ]
		};

		this.index0AttributeName = undefined;

		if ( parameters !== undefined ) {

			if ( parameters.attributes !== undefined ) {

				console.error( 'THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.' );

			}

			this.setValues( parameters );

		}

	}

	ShaderMaterial.prototype = Object.create( Material.prototype );
	ShaderMaterial.prototype.constructor = ShaderMaterial;

	ShaderMaterial.prototype.isShaderMaterial = true;

	ShaderMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.fragmentShader = source.fragmentShader;
		this.vertexShader = source.vertexShader;

		this.uniforms = UniformsUtils.clone( source.uniforms );

		this.defines = source.defines;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;

		this.lights = source.lights;
		this.clipping = source.clipping;

		this.skinning = source.skinning;

		this.morphTargets = source.morphTargets;
		this.morphNormals = source.morphNormals;

		this.extensions = source.extensions;

		return this;

	};

	ShaderMaterial.prototype.toJSON = function ( meta ) {

		var data = Material.prototype.toJSON.call( this, meta );

		data.uniforms = this.uniforms;
		data.vertexShader = this.vertexShader;
		data.fragmentShader = this.fragmentShader;

		return data;

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 * @author bhouston / https://clara.io
	 * @author WestLangley / http://github.com/WestLangley
	 *
	 * parameters = {
	 *
	 *  opacity: <float>,
	 *
	 *  map: new THREE.Texture( <Image> ),
	 *
	 *  alphaMap: new THREE.Texture( <Image> ),
	 *
	 *  displacementMap: new THREE.Texture( <Image> ),
	 *  displacementScale: <float>,
	 *  displacementBias: <float>,
	 *
	 *  wireframe: <boolean>,
	 *  wireframeLinewidth: <float>
	 * }
	 */

	function MeshDepthMaterial( parameters ) {

		Material.call( this );

		this.type = 'MeshDepthMaterial';

		this.depthPacking = BasicDepthPacking;

		this.skinning = false;
		this.morphTargets = false;

		this.map = null;

		this.alphaMap = null;

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.wireframe = false;
		this.wireframeLinewidth = 1;

		this.fog = false;
		this.lights = false;

		this.setValues( parameters );

	}

	MeshDepthMaterial.prototype = Object.create( Material.prototype );
	MeshDepthMaterial.prototype.constructor = MeshDepthMaterial;

	MeshDepthMaterial.prototype.isMeshDepthMaterial = true;

	MeshDepthMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.depthPacking = source.depthPacking;

		this.skinning = source.skinning;
		this.morphTargets = source.morphTargets;

		this.map = source.map;

		this.alphaMap = source.alphaMap;

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;

		return this;

	};

	/**
	 * @author bhouston / http://clara.io
	 * @author WestLangley / http://github.com/WestLangley
	 */

	function Box3( min, max ) {

		this.min = ( min !== undefined ) ? min : new Vector3( + Infinity, + Infinity, + Infinity );
		this.max = ( max !== undefined ) ? max : new Vector3( - Infinity, - Infinity, - Infinity );

	}

	Box3.prototype = {

		constructor: Box3,

		isBox3: true,

		set: function ( min, max ) {

			this.min.copy( min );
			this.max.copy( max );

			return this;

		},

		setFromArray: function ( array ) {

			var minX = + Infinity;
			var minY = + Infinity;
			var minZ = + Infinity;

			var maxX = - Infinity;
			var maxY = - Infinity;
			var maxZ = - Infinity;

			for ( var i = 0, l = array.length; i < l; i += 3 ) {

				var x = array[ i ];
				var y = array[ i + 1 ];
				var z = array[ i + 2 ];

				if ( x < minX ) minX = x;
				if ( y < minY ) minY = y;
				if ( z < minZ ) minZ = z;

				if ( x > maxX ) maxX = x;
				if ( y > maxY ) maxY = y;
				if ( z > maxZ ) maxZ = z;

			}

			this.min.set( minX, minY, minZ );
			this.max.set( maxX, maxY, maxZ );

		},

		setFromBufferAttribute: function ( attribute ) {

			var minX = + Infinity;
			var minY = + Infinity;
			var minZ = + Infinity;

			var maxX = - Infinity;
			var maxY = - Infinity;
			var maxZ = - Infinity;

			for ( var i = 0, l = attribute.count; i < l; i ++ ) {

				var x = attribute.getX( i );
				var y = attribute.getY( i );
				var z = attribute.getZ( i );

				if ( x < minX ) minX = x;
				if ( y < minY ) minY = y;
				if ( z < minZ ) minZ = z;

				if ( x > maxX ) maxX = x;
				if ( y > maxY ) maxY = y;
				if ( z > maxZ ) maxZ = z;

			}

			this.min.set( minX, minY, minZ );
			this.max.set( maxX, maxY, maxZ );

		},

		setFromPoints: function ( points ) {

			this.makeEmpty();

			for ( var i = 0, il = points.length; i < il; i ++ ) {

				this.expandByPoint( points[ i ] );

			}

			return this;

		},

		setFromCenterAndSize: function () {

			var v1 = new Vector3();

			return function setFromCenterAndSize( center, size ) {

				var halfSize = v1.copy( size ).multiplyScalar( 0.5 );

				this.min.copy( center ).sub( halfSize );
				this.max.copy( center ).add( halfSize );

				return this;

			};

		}(),

		setFromObject: function () {

			// Computes the world-axis-aligned bounding box of an object (including its children),
			// accounting for both the object's, and children's, world transforms

			var v1 = new Vector3();

			return function setFromObject( object ) {

				var scope = this;

				object.updateMatrixWorld( true );

				this.makeEmpty();

				object.traverse( function ( node ) {

					var i, l;

					var geometry = node.geometry;

					if ( geometry !== undefined ) {

						if ( geometry.isGeometry ) {

							var vertices = geometry.vertices;

							for ( i = 0, l = vertices.length; i < l; i ++ ) {

								v1.copy( vertices[ i ] );
								v1.applyMatrix4( node.matrixWorld );

								scope.expandByPoint( v1 );

							}

						} else if ( geometry.isBufferGeometry ) {

							var attribute = geometry.attributes.position;

							if ( attribute !== undefined ) {

								for ( i = 0, l = attribute.count; i < l; i ++ ) {

									v1.fromAttribute( attribute, i ).applyMatrix4( node.matrixWorld );

									scope.expandByPoint( v1 );

								}

							}

						}

					}

				} );

				return this;

			};

		}(),

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( box ) {

			this.min.copy( box.min );
			this.max.copy( box.max );

			return this;

		},

		makeEmpty: function () {

			this.min.x = this.min.y = this.min.z = + Infinity;
			this.max.x = this.max.y = this.max.z = - Infinity;

			return this;

		},

		isEmpty: function () {

			// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes

			return ( this.max.x < this.min.x ) || ( this.max.y < this.min.y ) || ( this.max.z < this.min.z );

		},

		getCenter: function ( optionalTarget ) {

			var result = optionalTarget || new Vector3();
			return this.isEmpty() ? result.set( 0, 0, 0 ) : result.addVectors( this.min, this.max ).multiplyScalar( 0.5 );

		},

		getSize: function ( optionalTarget ) {

			var result = optionalTarget || new Vector3();
			return this.isEmpty() ? result.set( 0, 0, 0 ) : result.subVectors( this.max, this.min );

		},

		expandByPoint: function ( point ) {

			this.min.min( point );
			this.max.max( point );

			return this;

		},

		expandByVector: function ( vector ) {

			this.min.sub( vector );
			this.max.add( vector );

			return this;

		},

		expandByScalar: function ( scalar ) {

			this.min.addScalar( - scalar );
			this.max.addScalar( scalar );

			return this;

		},

		containsPoint: function ( point ) {

			return point.x < this.min.x || point.x > this.max.x ||
				point.y < this.min.y || point.y > this.max.y ||
				point.z < this.min.z || point.z > this.max.z ? false : true;

		},

		containsBox: function ( box ) {

			return this.min.x <= box.min.x && box.max.x <= this.max.x &&
				this.min.y <= box.min.y && box.max.y <= this.max.y &&
				this.min.z <= box.min.z && box.max.z <= this.max.z;

		},

		getParameter: function ( point, optionalTarget ) {

			// This can potentially have a divide by zero if the box
			// has a size dimension of 0.

			var result = optionalTarget || new Vector3();

			return result.set(
				( point.x - this.min.x ) / ( this.max.x - this.min.x ),
				( point.y - this.min.y ) / ( this.max.y - this.min.y ),
				( point.z - this.min.z ) / ( this.max.z - this.min.z )
			);

		},

		intersectsBox: function ( box ) {

			// using 6 splitting planes to rule out intersections.
			return box.max.x < this.min.x || box.min.x > this.max.x ||
				box.max.y < this.min.y || box.min.y > this.max.y ||
				box.max.z < this.min.z || box.min.z > this.max.z ? false : true;

		},

		intersectsSphere: ( function () {

			var closestPoint;

			return function intersectsSphere( sphere ) {

				if ( closestPoint === undefined ) closestPoint = new Vector3();

				// Find the point on the AABB closest to the sphere center.
				this.clampPoint( sphere.center, closestPoint );

				// If that point is inside the sphere, the AABB and sphere intersect.
				return closestPoint.distanceToSquared( sphere.center ) <= ( sphere.radius * sphere.radius );

			};

		} )(),

		intersectsPlane: function ( plane ) {

			// We compute the minimum and maximum dot product values. If those values
			// are on the same side (back or front) of the plane, then there is no intersection.

			var min, max;

			if ( plane.normal.x > 0 ) {

				min = plane.normal.x * this.min.x;
				max = plane.normal.x * this.max.x;

			} else {

				min = plane.normal.x * this.max.x;
				max = plane.normal.x * this.min.x;

			}

			if ( plane.normal.y > 0 ) {

				min += plane.normal.y * this.min.y;
				max += plane.normal.y * this.max.y;

			} else {

				min += plane.normal.y * this.max.y;
				max += plane.normal.y * this.min.y;

			}

			if ( plane.normal.z > 0 ) {

				min += plane.normal.z * this.min.z;
				max += plane.normal.z * this.max.z;

			} else {

				min += plane.normal.z * this.max.z;
				max += plane.normal.z * this.min.z;

			}

			return ( min <= plane.constant && max >= plane.constant );

		},

		clampPoint: function ( point, optionalTarget ) {

			var result = optionalTarget || new Vector3();
			return result.copy( point ).clamp( this.min, this.max );

		},

		distanceToPoint: function () {

			var v1 = new Vector3();

			return function distanceToPoint( point ) {

				var clampedPoint = v1.copy( point ).clamp( this.min, this.max );
				return clampedPoint.sub( point ).length();

			};

		}(),

		getBoundingSphere: function () {

			var v1 = new Vector3();

			return function getBoundingSphere( optionalTarget ) {

				var result = optionalTarget || new Sphere();

				this.getCenter( result.center );

				result.radius = this.getSize( v1 ).length() * 0.5;

				return result;

			};

		}(),

		intersect: function ( box ) {

			this.min.max( box.min );
			this.max.min( box.max );

			// ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
			if( this.isEmpty() ) this.makeEmpty();

			return this;

		},

		union: function ( box ) {

			this.min.min( box.min );
			this.max.max( box.max );

			return this;

		},

		applyMatrix4: function () {

			var points = [
				new Vector3(),
				new Vector3(),
				new Vector3(),
				new Vector3(),
				new Vector3(),
				new Vector3(),
				new Vector3(),
				new Vector3()
			];

			return function applyMatrix4( matrix ) {

				// transform of empty box is an empty box.
				if( this.isEmpty() ) return this;

				// NOTE: I am using a binary pattern to specify all 2^3 combinations below
				points[ 0 ].set( this.min.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 000
				points[ 1 ].set( this.min.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 001
				points[ 2 ].set( this.min.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 010
				points[ 3 ].set( this.min.x, this.max.y, this.max.z ).applyMatrix4( matrix ); // 011
				points[ 4 ].set( this.max.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 100
				points[ 5 ].set( this.max.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 101
				points[ 6 ].set( this.max.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 110
				points[ 7 ].set( this.max.x, this.max.y, this.max.z ).applyMatrix4( matrix );	// 111

				this.setFromPoints( points );

				return this;

			};

		}(),

		translate: function ( offset ) {

			this.min.add( offset );
			this.max.add( offset );

			return this;

		},

		equals: function ( box ) {

			return box.min.equals( this.min ) && box.max.equals( this.max );

		}

	};

	/**
	 * @author bhouston / http://clara.io
	 * @author mrdoob / http://mrdoob.com/
	 */

	function Sphere( center, radius ) {

		this.center = ( center !== undefined ) ? center : new Vector3();
		this.radius = ( radius !== undefined ) ? radius : 0;

	}

	Sphere.prototype = {

		constructor: Sphere,

		set: function ( center, radius ) {

			this.center.copy( center );
			this.radius = radius;

			return this;

		},

		setFromPoints: function () {

			var box = new Box3();

			return function setFromPoints( points, optionalCenter ) {

				var center = this.center;

				if ( optionalCenter !== undefined ) {

					center.copy( optionalCenter );

				} else {

					box.setFromPoints( points ).getCenter( center );

				}

				var maxRadiusSq = 0;

				for ( var i = 0, il = points.length; i < il; i ++ ) {

					maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( points[ i ] ) );

				}

				this.radius = Math.sqrt( maxRadiusSq );

				return this;

			};

		}(),

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( sphere ) {

			this.center.copy( sphere.center );
			this.radius = sphere.radius;

			return this;

		},

		empty: function () {

			return ( this.radius <= 0 );

		},

		containsPoint: function ( point ) {

			return ( point.distanceToSquared( this.center ) <= ( this.radius * this.radius ) );

		},

		distanceToPoint: function ( point ) {

			return ( point.distanceTo( this.center ) - this.radius );

		},

		intersectsSphere: function ( sphere ) {

			var radiusSum = this.radius + sphere.radius;

			return sphere.center.distanceToSquared( this.center ) <= ( radiusSum * radiusSum );

		},

		intersectsBox: function ( box ) {

			return box.intersectsSphere( this );

		},

		intersectsPlane: function ( plane ) {

			// We use the following equation to compute the signed distance from
			// the center of the sphere to the plane.
			//
			// distance = q * n - d
			//
			// If this distance is greater than the radius of the sphere,
			// then there is no intersection.

			return Math.abs( this.center.dot( plane.normal ) - plane.constant ) <= this.radius;

		},

		clampPoint: function ( point, optionalTarget ) {

			var deltaLengthSq = this.center.distanceToSquared( point );

			var result = optionalTarget || new Vector3();

			result.copy( point );

			if ( deltaLengthSq > ( this.radius * this.radius ) ) {

				result.sub( this.center ).normalize();
				result.multiplyScalar( this.radius ).add( this.center );

			}

			return result;

		},

		getBoundingBox: function ( optionalTarget ) {

			var box = optionalTarget || new Box3();

			box.set( this.center, this.center );
			box.expandByScalar( this.radius );

			return box;

		},

		applyMatrix4: function ( matrix ) {

			this.center.applyMatrix4( matrix );
			this.radius = this.radius * matrix.getMaxScaleOnAxis();

			return this;

		},

		translate: function ( offset ) {

			this.center.add( offset );

			return this;

		},

		equals: function ( sphere ) {

			return sphere.center.equals( this.center ) && ( sphere.radius === this.radius );

		}

	};

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author WestLangley / http://github.com/WestLangley
	 * @author bhouston / http://clara.io
	 * @author tschw
	 */

	function Matrix3() {

		this.elements = new Float32Array( [

			1, 0, 0,
			0, 1, 0,
			0, 0, 1

		] );

		if ( arguments.length > 0 ) {

			console.error( 'THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.' );

		}

	}

	Matrix3.prototype = {

		constructor: Matrix3,

		isMatrix3: true,

		set: function ( n11, n12, n13, n21, n22, n23, n31, n32, n33 ) {

			var te = this.elements;

			te[ 0 ] = n11; te[ 1 ] = n21; te[ 2 ] = n31;
			te[ 3 ] = n12; te[ 4 ] = n22; te[ 5 ] = n32;
			te[ 6 ] = n13; te[ 7 ] = n23; te[ 8 ] = n33;

			return this;

		},

		identity: function () {

			this.set(

				1, 0, 0,
				0, 1, 0,
				0, 0, 1

			);

			return this;

		},

		clone: function () {

			return new this.constructor().fromArray( this.elements );

		},

		copy: function ( m ) {

			var me = m.elements;

			this.set(

				me[ 0 ], me[ 3 ], me[ 6 ],
				me[ 1 ], me[ 4 ], me[ 7 ],
				me[ 2 ], me[ 5 ], me[ 8 ]

			);

			return this;

		},

		setFromMatrix4: function( m ) {

			var me = m.elements;

			this.set(

				me[ 0 ], me[ 4 ], me[  8 ],
				me[ 1 ], me[ 5 ], me[  9 ],
				me[ 2 ], me[ 6 ], me[ 10 ]

			);

			return this;

		},

		applyToVector3Array: function () {

			var v1;

			return function applyToVector3Array( array, offset, length ) {

				if ( v1 === undefined ) v1 = new Vector3();
				if ( offset === undefined ) offset = 0;
				if ( length === undefined ) length = array.length;

				for ( var i = 0, j = offset; i < length; i += 3, j += 3 ) {

					v1.fromArray( array, j );
					v1.applyMatrix3( this );
					v1.toArray( array, j );

				}

				return array;

			};

		}(),

		applyToBufferAttribute: function () {

			var v1;

			return function applyToBufferAttribute( attribute ) {

				if ( v1 === undefined ) v1 = new Vector3();

				for ( var i = 0, l = attribute.count; i < l; i ++ ) {

					v1.x = attribute.getX( i );
					v1.y = attribute.getY( i );
					v1.z = attribute.getZ( i );

					v1.applyMatrix3( this );

					attribute.setXYZ( i, v1.x, v1.y, v1.z );

				}

				return attribute;

			};

		}(),

		multiplyScalar: function ( s ) {

			var te = this.elements;

			te[ 0 ] *= s; te[ 3 ] *= s; te[ 6 ] *= s;
			te[ 1 ] *= s; te[ 4 ] *= s; te[ 7 ] *= s;
			te[ 2 ] *= s; te[ 5 ] *= s; te[ 8 ] *= s;

			return this;

		},

		determinant: function () {

			var te = this.elements;

			var a = te[ 0 ], b = te[ 1 ], c = te[ 2 ],
				d = te[ 3 ], e = te[ 4 ], f = te[ 5 ],
				g = te[ 6 ], h = te[ 7 ], i = te[ 8 ];

			return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;

		},

		getInverse: function ( matrix, throwOnDegenerate ) {

			if ( matrix && matrix.isMatrix4 ) {

				console.error( "THREE.Matrix3.getInverse no longer takes a Matrix4 argument." );

			}

			var me = matrix.elements,
				te = this.elements,

				n11 = me[ 0 ], n21 = me[ 1 ], n31 = me[ 2 ],
				n12 = me[ 3 ], n22 = me[ 4 ], n32 = me[ 5 ],
				n13 = me[ 6 ], n23 = me[ 7 ], n33 = me[ 8 ],

				t11 = n33 * n22 - n32 * n23,
				t12 = n32 * n13 - n33 * n12,
				t13 = n23 * n12 - n22 * n13,

				det = n11 * t11 + n21 * t12 + n31 * t13;

			if ( det === 0 ) {

				var msg = "THREE.Matrix3.getInverse(): can't invert matrix, determinant is 0";

				if ( throwOnDegenerate === true ) {

					throw new Error( msg );

				} else {

					console.warn( msg );

				}

				return this.identity();
			}

			var detInv = 1 / det;

			te[ 0 ] = t11 * detInv;
			te[ 1 ] = ( n31 * n23 - n33 * n21 ) * detInv;
			te[ 2 ] = ( n32 * n21 - n31 * n22 ) * detInv;

			te[ 3 ] = t12 * detInv;
			te[ 4 ] = ( n33 * n11 - n31 * n13 ) * detInv;
			te[ 5 ] = ( n31 * n12 - n32 * n11 ) * detInv;

			te[ 6 ] = t13 * detInv;
			te[ 7 ] = ( n21 * n13 - n23 * n11 ) * detInv;
			te[ 8 ] = ( n22 * n11 - n21 * n12 ) * detInv;

			return this;

		},

		transpose: function () {

			var tmp, m = this.elements;

			tmp = m[ 1 ]; m[ 1 ] = m[ 3 ]; m[ 3 ] = tmp;
			tmp = m[ 2 ]; m[ 2 ] = m[ 6 ]; m[ 6 ] = tmp;
			tmp = m[ 5 ]; m[ 5 ] = m[ 7 ]; m[ 7 ] = tmp;

			return this;

		},

		getNormalMatrix: function ( matrix4 ) {

			return this.setFromMatrix4( matrix4 ).getInverse( this ).transpose();

		},

		transposeIntoArray: function ( r ) {

			var m = this.elements;

			r[ 0 ] = m[ 0 ];
			r[ 1 ] = m[ 3 ];
			r[ 2 ] = m[ 6 ];
			r[ 3 ] = m[ 1 ];
			r[ 4 ] = m[ 4 ];
			r[ 5 ] = m[ 7 ];
			r[ 6 ] = m[ 2 ];
			r[ 7 ] = m[ 5 ];
			r[ 8 ] = m[ 8 ];

			return this;

		},

		fromArray: function ( array, offset ) {

			if ( offset === undefined ) offset = 0;

			for( var i = 0; i < 9; i ++ ) {

				this.elements[ i ] = array[ i + offset ];

			}

			return this;

		},

		toArray: function ( array, offset ) {

			if ( array === undefined ) array = [];
			if ( offset === undefined ) offset = 0;

			var te = this.elements;

			array[ offset ] = te[ 0 ];
			array[ offset + 1 ] = te[ 1 ];
			array[ offset + 2 ] = te[ 2 ];

			array[ offset + 3 ] = te[ 3 ];
			array[ offset + 4 ] = te[ 4 ];
			array[ offset + 5 ] = te[ 5 ];

			array[ offset + 6 ] = te[ 6 ];
			array[ offset + 7 ] = te[ 7 ];
			array[ offset + 8 ]  = te[ 8 ];

			return array;

		}

	};

	/**
	 * @author bhouston / http://clara.io
	 */

	function Plane( normal, constant ) {

		this.normal = ( normal !== undefined ) ? normal : new Vector3( 1, 0, 0 );
		this.constant = ( constant !== undefined ) ? constant : 0;

	}

	Plane.prototype = {

		constructor: Plane,

		set: function ( normal, constant ) {

			this.normal.copy( normal );
			this.constant = constant;

			return this;

		},

		setComponents: function ( x, y, z, w ) {

			this.normal.set( x, y, z );
			this.constant = w;

			return this;

		},

		setFromNormalAndCoplanarPoint: function ( normal, point ) {

			this.normal.copy( normal );
			this.constant = - point.dot( this.normal );	// must be this.normal, not normal, as this.normal is normalized

			return this;

		},

		setFromCoplanarPoints: function () {

			var v1 = new Vector3();
			var v2 = new Vector3();

			return function setFromCoplanarPoints( a, b, c ) {

				var normal = v1.subVectors( c, b ).cross( v2.subVectors( a, b ) ).normalize();

				// Q: should an error be thrown if normal is zero (e.g. degenerate plane)?

				this.setFromNormalAndCoplanarPoint( normal, a );

				return this;

			};

		}(),

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( plane ) {

			this.normal.copy( plane.normal );
			this.constant = plane.constant;

			return this;

		},

		normalize: function () {

			// Note: will lead to a divide by zero if the plane is invalid.

			var inverseNormalLength = 1.0 / this.normal.length();
			this.normal.multiplyScalar( inverseNormalLength );
			this.constant *= inverseNormalLength;

			return this;

		},

		negate: function () {

			this.constant *= - 1;
			this.normal.negate();

			return this;

		},

		distanceToPoint: function ( point ) {

			return this.normal.dot( point ) + this.constant;

		},

		distanceToSphere: function ( sphere ) {

			return this.distanceToPoint( sphere.center ) - sphere.radius;

		},

		projectPoint: function ( point, optionalTarget ) {

			return this.orthoPoint( point, optionalTarget ).sub( point ).negate();

		},

		orthoPoint: function ( point, optionalTarget ) {

			var perpendicularMagnitude = this.distanceToPoint( point );

			var result = optionalTarget || new Vector3();
			return result.copy( this.normal ).multiplyScalar( perpendicularMagnitude );

		},

		intersectLine: function () {

			var v1 = new Vector3();

			return function intersectLine( line, optionalTarget ) {

				var result = optionalTarget || new Vector3();

				var direction = line.delta( v1 );

				var denominator = this.normal.dot( direction );

				if ( denominator === 0 ) {

					// line is coplanar, return origin
					if ( this.distanceToPoint( line.start ) === 0 ) {

						return result.copy( line.start );

					}

					// Unsure if this is the correct method to handle this case.
					return undefined;

				}

				var t = - ( line.start.dot( this.normal ) + this.constant ) / denominator;

				if ( t < 0 || t > 1 ) {

					return undefined;

				}

				return result.copy( direction ).multiplyScalar( t ).add( line.start );

			};

		}(),

		intersectsLine: function ( line ) {

			// Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.

			var startSign = this.distanceToPoint( line.start );
			var endSign = this.distanceToPoint( line.end );

			return ( startSign < 0 && endSign > 0 ) || ( endSign < 0 && startSign > 0 );

		},

		intersectsBox: function ( box ) {

			return box.intersectsPlane( this );

		},

		intersectsSphere: function ( sphere ) {

			return sphere.intersectsPlane( this );

		},

		coplanarPoint: function ( optionalTarget ) {

			var result = optionalTarget || new Vector3();
			return result.copy( this.normal ).multiplyScalar( - this.constant );

		},

		applyMatrix4: function () {

			var v1 = new Vector3();
			var m1 = new Matrix3();

			return function applyMatrix4( matrix, optionalNormalMatrix ) {

				var referencePoint = this.coplanarPoint( v1 ).applyMatrix4( matrix );

				// transform normal based on theory here:
				// http://www.songho.ca/opengl/gl_normaltransform.html
				var normalMatrix = optionalNormalMatrix || m1.getNormalMatrix( matrix );
				var normal = this.normal.applyMatrix3( normalMatrix ).normalize();

				// recalculate constant (like in setFromNormalAndCoplanarPoint)
				this.constant = - referencePoint.dot( normal );

				return this;

			};

		}(),

		translate: function ( offset ) {

			this.constant = this.constant - offset.dot( this.normal );

			return this;

		},

		equals: function ( plane ) {

			return plane.normal.equals( this.normal ) && ( plane.constant === this.constant );

		}

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 * @author bhouston / http://clara.io
	 */

	function Frustum( p0, p1, p2, p3, p4, p5 ) {

		this.planes = [

			( p0 !== undefined ) ? p0 : new Plane(),
			( p1 !== undefined ) ? p1 : new Plane(),
			( p2 !== undefined ) ? p2 : new Plane(),
			( p3 !== undefined ) ? p3 : new Plane(),
			( p4 !== undefined ) ? p4 : new Plane(),
			( p5 !== undefined ) ? p5 : new Plane()

		];

	}

	Frustum.prototype = {

		constructor: Frustum,

		set: function ( p0, p1, p2, p3, p4, p5 ) {

			var planes = this.planes;

			planes[ 0 ].copy( p0 );
			planes[ 1 ].copy( p1 );
			planes[ 2 ].copy( p2 );
			planes[ 3 ].copy( p3 );
			planes[ 4 ].copy( p4 );
			planes[ 5 ].copy( p5 );

			return this;

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( frustum ) {

			var planes = this.planes;

			for ( var i = 0; i < 6; i ++ ) {

				planes[ i ].copy( frustum.planes[ i ] );

			}

			return this;

		},

		setFromMatrix: function ( m ) {

			var planes = this.planes;
			var me = m.elements;
			var me0 = me[ 0 ], me1 = me[ 1 ], me2 = me[ 2 ], me3 = me[ 3 ];
			var me4 = me[ 4 ], me5 = me[ 5 ], me6 = me[ 6 ], me7 = me[ 7 ];
			var me8 = me[ 8 ], me9 = me[ 9 ], me10 = me[ 10 ], me11 = me[ 11 ];
			var me12 = me[ 12 ], me13 = me[ 13 ], me14 = me[ 14 ], me15 = me[ 15 ];

			planes[ 0 ].setComponents( me3 - me0, me7 - me4, me11 - me8, me15 - me12 ).normalize();
			planes[ 1 ].setComponents( me3 + me0, me7 + me4, me11 + me8, me15 + me12 ).normalize();
			planes[ 2 ].setComponents( me3 + me1, me7 + me5, me11 + me9, me15 + me13 ).normalize();
			planes[ 3 ].setComponents( me3 - me1, me7 - me5, me11 - me9, me15 - me13 ).normalize();
			planes[ 4 ].setComponents( me3 - me2, me7 - me6, me11 - me10, me15 - me14 ).normalize();
			planes[ 5 ].setComponents( me3 + me2, me7 + me6, me11 + me10, me15 + me14 ).normalize();

			return this;

		},

		intersectsObject: function () {

			var sphere = new Sphere();

			return function intersectsObject( object ) {

				var geometry = object.geometry;

				if ( geometry.boundingSphere === null )
					geometry.computeBoundingSphere();

				sphere.copy( geometry.boundingSphere )
					.applyMatrix4( object.matrixWorld );

				return this.intersectsSphere( sphere );

			};

		}(),

		intersectsSprite: function () {

			var sphere = new Sphere();

			return function intersectsSprite( sprite ) {

				sphere.center.set( 0, 0, 0 );
				sphere.radius = 0.7071067811865476;
				sphere.applyMatrix4( sprite.matrixWorld );

				return this.intersectsSphere( sphere );

			};

		}(),

		intersectsSphere: function ( sphere ) {

			var planes = this.planes;
			var center = sphere.center;
			var negRadius = - sphere.radius;

			for ( var i = 0; i < 6; i ++ ) {

				var distance = planes[ i ].distanceToPoint( center );

				if ( distance < negRadius ) {

					return false;

				}

			}

			return true;

		},

		intersectsBox: function () {

			var p1 = new Vector3(),
				p2 = new Vector3();

			return function intersectsBox( box ) {

				var planes = this.planes;

				for ( var i = 0; i < 6 ; i ++ ) {

					var plane = planes[ i ];

					p1.x = plane.normal.x > 0 ? box.min.x : box.max.x;
					p2.x = plane.normal.x > 0 ? box.max.x : box.min.x;
					p1.y = plane.normal.y > 0 ? box.min.y : box.max.y;
					p2.y = plane.normal.y > 0 ? box.max.y : box.min.y;
					p1.z = plane.normal.z > 0 ? box.min.z : box.max.z;
					p2.z = plane.normal.z > 0 ? box.max.z : box.min.z;

					var d1 = plane.distanceToPoint( p1 );
					var d2 = plane.distanceToPoint( p2 );

					// if both outside plane, no intersection

					if ( d1 < 0 && d2 < 0 ) {

						return false;

					}

				}

				return true;

			};

		}(),


		containsPoint: function ( point ) {

			var planes = this.planes;

			for ( var i = 0; i < 6; i ++ ) {

				if ( planes[ i ].distanceToPoint( point ) < 0 ) {

					return false;

				}

			}

			return true;

		}

	};

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLShadowMap( _renderer, _lights, _objects, capabilities ) {

		var _gl = _renderer.context,
		_state = _renderer.state,
		_frustum = new Frustum(),
		_projScreenMatrix = new Matrix4(),

		_lightShadows = _lights.shadows,

		_shadowMapSize = new Vector2(),
		_maxShadowMapSize = new Vector2( capabilities.maxTextureSize, capabilities.maxTextureSize ),

		_lookTarget = new Vector3(),
		_lightPositionWorld = new Vector3(),

		_renderList = [],

		_MorphingFlag = 1,
		_SkinningFlag = 2,

		_NumberOfMaterialVariants = ( _MorphingFlag | _SkinningFlag ) + 1,

		_depthMaterials = new Array( _NumberOfMaterialVariants ),
		_distanceMaterials = new Array( _NumberOfMaterialVariants ),

		_materialCache = {};

		var cubeDirections = [
			new Vector3( 1, 0, 0 ), new Vector3( - 1, 0, 0 ), new Vector3( 0, 0, 1 ),
			new Vector3( 0, 0, - 1 ), new Vector3( 0, 1, 0 ), new Vector3( 0, - 1, 0 )
		];

		var cubeUps = [
			new Vector3( 0, 1, 0 ), new Vector3( 0, 1, 0 ), new Vector3( 0, 1, 0 ),
			new Vector3( 0, 1, 0 ), new Vector3( 0, 0, 1 ),	new Vector3( 0, 0, - 1 )
		];

		var cube2DViewPorts = [
			new Vector4(), new Vector4(), new Vector4(),
			new Vector4(), new Vector4(), new Vector4()
		];

		// init

		var depthMaterialTemplate = new MeshDepthMaterial();
		depthMaterialTemplate.depthPacking = RGBADepthPacking;
		depthMaterialTemplate.clipping = true;

		var distanceShader = ShaderLib[ "distanceRGBA" ];
		var distanceUniforms = UniformsUtils.clone( distanceShader.uniforms );

		for ( var i = 0; i !== _NumberOfMaterialVariants; ++ i ) {

			var useMorphing = ( i & _MorphingFlag ) !== 0;
			var useSkinning = ( i & _SkinningFlag ) !== 0;

			var depthMaterial = depthMaterialTemplate.clone();
			depthMaterial.morphTargets = useMorphing;
			depthMaterial.skinning = useSkinning;

			_depthMaterials[ i ] = depthMaterial;

			var distanceMaterial = new ShaderMaterial( {
				defines: {
					'USE_SHADOWMAP': ''
				},
				uniforms: distanceUniforms,
				vertexShader: distanceShader.vertexShader,
				fragmentShader: distanceShader.fragmentShader,
				morphTargets: useMorphing,
				skinning: useSkinning,
				clipping: true
			} );

			_distanceMaterials[ i ] = distanceMaterial;

		}

		//

		var scope = this;

		this.enabled = false;

		this.autoUpdate = true;
		this.needsUpdate = false;

		this.type = PCFShadowMap;

		this.renderReverseSided = true;
		this.renderSingleSided = true;

		this.render = function ( scene, camera ) {

			if ( scope.enabled === false ) return;
			if ( scope.autoUpdate === false && scope.needsUpdate === false ) return;

			if ( _lightShadows.length === 0 ) return;

			// Set GL state for depth map.
			_state.buffers.color.setClear( 1, 1, 1, 1 );
			_state.disable( _gl.BLEND );
			_state.setDepthTest( true );
			_state.setScissorTest( false );

			// render depth map

			var faceCount, isPointLight;

			for ( var i = 0, il = _lightShadows.length; i < il; i ++ ) {

				var light = _lightShadows[ i ];
				var shadow = light.shadow;

				if ( shadow === undefined ) {

					console.warn( 'THREE.WebGLShadowMap:', light, 'has no shadow.' );
					continue;

				}

				var shadowCamera = shadow.camera;

				_shadowMapSize.copy( shadow.mapSize );
				_shadowMapSize.min( _maxShadowMapSize );

				if ( light && light.isPointLight ) {

					faceCount = 6;
					isPointLight = true;

					var vpWidth = _shadowMapSize.x;
					var vpHeight = _shadowMapSize.y;

					// These viewports map a cube-map onto a 2D texture with the
					// following orientation:
					//
					//  xzXZ
					//   y Y
					//
					// X - Positive x direction
					// x - Negative x direction
					// Y - Positive y direction
					// y - Negative y direction
					// Z - Positive z direction
					// z - Negative z direction

					// positive X
					cube2DViewPorts[ 0 ].set( vpWidth * 2, vpHeight, vpWidth, vpHeight );
					// negative X
					cube2DViewPorts[ 1 ].set( 0, vpHeight, vpWidth, vpHeight );
					// positive Z
					cube2DViewPorts[ 2 ].set( vpWidth * 3, vpHeight, vpWidth, vpHeight );
					// negative Z
					cube2DViewPorts[ 3 ].set( vpWidth, vpHeight, vpWidth, vpHeight );
					// positive Y
					cube2DViewPorts[ 4 ].set( vpWidth * 3, 0, vpWidth, vpHeight );
					// negative Y
					cube2DViewPorts[ 5 ].set( vpWidth, 0, vpWidth, vpHeight );

					_shadowMapSize.x *= 4.0;
					_shadowMapSize.y *= 2.0;

				} else {

					faceCount = 1;
					isPointLight = false;

				}

				if ( shadow.map === null ) {

					var pars = { minFilter: NearestFilter, magFilter: NearestFilter, format: RGBAFormat };

					shadow.map = new WebGLRenderTarget( _shadowMapSize.x, _shadowMapSize.y, pars );

					shadowCamera.updateProjectionMatrix();

				}

				if ( shadow.isSpotLightShadow ) {

					shadow.update( light );

				}

				// TODO (abelnation / sam-g-steel): is this needed?
				if (shadow && shadow.isRectAreaLightShadow ) {

					shadow.update( light );

				}

				var shadowMap = shadow.map;
				var shadowMatrix = shadow.matrix;

				_lightPositionWorld.setFromMatrixPosition( light.matrixWorld );
				shadowCamera.position.copy( _lightPositionWorld );

				_renderer.setRenderTarget( shadowMap );
				_renderer.clear();

				// render shadow map for each cube face (if omni-directional) or
				// run a single pass if not

				for ( var face = 0; face < faceCount; face ++ ) {

					if ( isPointLight ) {

						_lookTarget.copy( shadowCamera.position );
						_lookTarget.add( cubeDirections[ face ] );
						shadowCamera.up.copy( cubeUps[ face ] );
						shadowCamera.lookAt( _lookTarget );

						var vpDimensions = cube2DViewPorts[ face ];
						_state.viewport( vpDimensions );

					} else {

						_lookTarget.setFromMatrixPosition( light.target.matrixWorld );
						shadowCamera.lookAt( _lookTarget );

					}

					shadowCamera.updateMatrixWorld();
					shadowCamera.matrixWorldInverse.getInverse( shadowCamera.matrixWorld );

					// compute shadow matrix

					shadowMatrix.set(
						0.5, 0.0, 0.0, 0.5,
						0.0, 0.5, 0.0, 0.5,
						0.0, 0.0, 0.5, 0.5,
						0.0, 0.0, 0.0, 1.0
					);

					shadowMatrix.multiply( shadowCamera.projectionMatrix );
					shadowMatrix.multiply( shadowCamera.matrixWorldInverse );

					// update camera matrices and frustum

					_projScreenMatrix.multiplyMatrices( shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse );
					_frustum.setFromMatrix( _projScreenMatrix );

					// set object matrices & frustum culling

					_renderList.length = 0;

					projectObject( scene, camera, shadowCamera );

					// render shadow map
					// render regular objects

					for ( var j = 0, jl = _renderList.length; j < jl; j ++ ) {

						var object = _renderList[ j ];
						var geometry = _objects.update( object );
						var material = object.material;

						if ( material && material.isMultiMaterial ) {

							var groups = geometry.groups;
							var materials = material.materials;

							for ( var k = 0, kl = groups.length; k < kl; k ++ ) {

								var group = groups[ k ];
								var groupMaterial = materials[ group.materialIndex ];

								if ( groupMaterial.visible === true ) {

									var depthMaterial = getDepthMaterial( object, groupMaterial, isPointLight, _lightPositionWorld );
									_renderer.renderBufferDirect( shadowCamera, null, geometry, depthMaterial, object, group );

								}

							}

						} else {

							var depthMaterial = getDepthMaterial( object, material, isPointLight, _lightPositionWorld );
							_renderer.renderBufferDirect( shadowCamera, null, geometry, depthMaterial, object, null );

						}

					}

				}

			}

			// Restore GL state.
			var clearColor = _renderer.getClearColor(),
			clearAlpha = _renderer.getClearAlpha();
			_renderer.setClearColor( clearColor, clearAlpha );

			scope.needsUpdate = false;

		};

		function getDepthMaterial( object, material, isPointLight, lightPositionWorld ) {

			var geometry = object.geometry;

			var result = null;

			var materialVariants = _depthMaterials;
			var customMaterial = object.customDepthMaterial;

			if ( isPointLight ) {

				materialVariants = _distanceMaterials;
				customMaterial = object.customDistanceMaterial;

			}

			if ( ! customMaterial ) {

				var useMorphing = false;

				if ( material.morphTargets ) {

					if ( geometry && geometry.isBufferGeometry ) {

						useMorphing = geometry.morphAttributes && geometry.morphAttributes.position && geometry.morphAttributes.position.length > 0;

					} else if ( geometry && geometry.isGeometry ) {

						useMorphing = geometry.morphTargets && geometry.morphTargets.length > 0;

					}

				}

				var useSkinning = object.isSkinnedMesh && material.skinning;

				var variantIndex = 0;

				if ( useMorphing ) variantIndex |= _MorphingFlag;
				if ( useSkinning ) variantIndex |= _SkinningFlag;

				result = materialVariants[ variantIndex ];

			} else {

				result = customMaterial;

			}

			if ( _renderer.localClippingEnabled &&
				 material.clipShadows === true &&
					material.clippingPlanes.length !== 0 ) {

				// in this case we need a unique material instance reflecting the
				// appropriate state

				var keyA = result.uuid, keyB = material.uuid;

				var materialsForVariant = _materialCache[ keyA ];

				if ( materialsForVariant === undefined ) {

					materialsForVariant = {};
					_materialCache[ keyA ] = materialsForVariant;

				}

				var cachedMaterial = materialsForVariant[ keyB ];

				if ( cachedMaterial === undefined ) {

					cachedMaterial = result.clone();
					materialsForVariant[ keyB ] = cachedMaterial;

				}

				result = cachedMaterial;

			}

			result.visible = material.visible;
			result.wireframe = material.wireframe;

			var side = material.side;

			if ( scope.renderSingleSided && side == DoubleSide ) {

				side = FrontSide;

			}

			if ( scope.renderReverseSided ) {

				if ( side === FrontSide ) side = BackSide;
				else if ( side === BackSide ) side = FrontSide;

			}

			result.side = side;

			result.clipShadows = material.clipShadows;
			result.clippingPlanes = material.clippingPlanes;

			result.wireframeLinewidth = material.wireframeLinewidth;
			result.linewidth = material.linewidth;

			if ( isPointLight && result.uniforms.lightPos !== undefined ) {

				result.uniforms.lightPos.value.copy( lightPositionWorld );

			}

			return result;

		}

		function projectObject( object, camera, shadowCamera ) {

			if ( object.visible === false ) return;

			var visible = ( object.layers.mask & camera.layers.mask ) !== 0;

			if ( visible && ( object.isMesh || object.isLine || object.isPoints ) ) {

				if ( object.castShadow && ( object.frustumCulled === false || _frustum.intersectsObject( object ) === true ) ) {

					var material = object.material;

					if ( material.visible === true ) {

						object.modelViewMatrix.multiplyMatrices( shadowCamera.matrixWorldInverse, object.matrixWorld );
						_renderList.push( object );

					}

				}

			}

			var children = object.children;

			for ( var i = 0, l = children.length; i < l; i ++ ) {

				projectObject( children[ i ], camera, shadowCamera );

			}

		}

	}

	/**
	 * @author bhouston / http://clara.io
	 */

	function Ray( origin, direction ) {

		this.origin = ( origin !== undefined ) ? origin : new Vector3();
		this.direction = ( direction !== undefined ) ? direction : new Vector3();

	}

	Ray.prototype = {

		constructor: Ray,

		set: function ( origin, direction ) {

			this.origin.copy( origin );
			this.direction.copy( direction );

			return this;

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( ray ) {

			this.origin.copy( ray.origin );
			this.direction.copy( ray.direction );

			return this;

		},

		at: function ( t, optionalTarget ) {

			var result = optionalTarget || new Vector3();

			return result.copy( this.direction ).multiplyScalar( t ).add( this.origin );

		},

		lookAt: function ( v ) {

			this.direction.copy( v ).sub( this.origin ).normalize();

			return this;

		},

		recast: function () {

			var v1 = new Vector3();

			return function recast( t ) {

				this.origin.copy( this.at( t, v1 ) );

				return this;

			};

		}(),

		closestPointToPoint: function ( point, optionalTarget ) {

			var result = optionalTarget || new Vector3();
			result.subVectors( point, this.origin );
			var directionDistance = result.dot( this.direction );

			if ( directionDistance < 0 ) {

				return result.copy( this.origin );

			}

			return result.copy( this.direction ).multiplyScalar( directionDistance ).add( this.origin );

		},

		distanceToPoint: function ( point ) {

			return Math.sqrt( this.distanceSqToPoint( point ) );

		},

		distanceSqToPoint: function () {

			var v1 = new Vector3();

			return function distanceSqToPoint( point ) {

				var directionDistance = v1.subVectors( point, this.origin ).dot( this.direction );

				// point behind the ray

				if ( directionDistance < 0 ) {

					return this.origin.distanceToSquared( point );

				}

				v1.copy( this.direction ).multiplyScalar( directionDistance ).add( this.origin );

				return v1.distanceToSquared( point );

			};

		}(),

		distanceSqToSegment: function () {

			var segCenter = new Vector3();
			var segDir = new Vector3();
			var diff = new Vector3();

			return function distanceSqToSegment( v0, v1, optionalPointOnRay, optionalPointOnSegment ) {

				// from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteDistRaySegment.h
				// It returns the min distance between the ray and the segment
				// defined by v0 and v1
				// It can also set two optional targets :
				// - The closest point on the ray
				// - The closest point on the segment

				segCenter.copy( v0 ).add( v1 ).multiplyScalar( 0.5 );
				segDir.copy( v1 ).sub( v0 ).normalize();
				diff.copy( this.origin ).sub( segCenter );

				var segExtent = v0.distanceTo( v1 ) * 0.5;
				var a01 = - this.direction.dot( segDir );
				var b0 = diff.dot( this.direction );
				var b1 = - diff.dot( segDir );
				var c = diff.lengthSq();
				var det = Math.abs( 1 - a01 * a01 );
				var s0, s1, sqrDist, extDet;

				if ( det > 0 ) {

					// The ray and segment are not parallel.

					s0 = a01 * b1 - b0;
					s1 = a01 * b0 - b1;
					extDet = segExtent * det;

					if ( s0 >= 0 ) {

						if ( s1 >= - extDet ) {

							if ( s1 <= extDet ) {

								// region 0
								// Minimum at interior points of ray and segment.

								var invDet = 1 / det;
								s0 *= invDet;
								s1 *= invDet;
								sqrDist = s0 * ( s0 + a01 * s1 + 2 * b0 ) + s1 * ( a01 * s0 + s1 + 2 * b1 ) + c;

							} else {

								// region 1

								s1 = segExtent;
								s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
								sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

							}

						} else {

							// region 5

							s1 = - segExtent;
							s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
							sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

						}

					} else {

						if ( s1 <= - extDet ) {

							// region 4

							s0 = Math.max( 0, - ( - a01 * segExtent + b0 ) );
							s1 = ( s0 > 0 ) ? - segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
							sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

						} else if ( s1 <= extDet ) {

							// region 3

							s0 = 0;
							s1 = Math.min( Math.max( - segExtent, - b1 ), segExtent );
							sqrDist = s1 * ( s1 + 2 * b1 ) + c;

						} else {

							// region 2

							s0 = Math.max( 0, - ( a01 * segExtent + b0 ) );
							s1 = ( s0 > 0 ) ? segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
							sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

						}

					}

				} else {

					// Ray and segment are parallel.

					s1 = ( a01 > 0 ) ? - segExtent : segExtent;
					s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
					sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

				}

				if ( optionalPointOnRay ) {

					optionalPointOnRay.copy( this.direction ).multiplyScalar( s0 ).add( this.origin );

				}

				if ( optionalPointOnSegment ) {

					optionalPointOnSegment.copy( segDir ).multiplyScalar( s1 ).add( segCenter );

				}

				return sqrDist;

			};

		}(),

		intersectSphere: function () {

			var v1 = new Vector3();

			return function intersectSphere( sphere, optionalTarget ) {

				v1.subVectors( sphere.center, this.origin );
				var tca = v1.dot( this.direction );
				var d2 = v1.dot( v1 ) - tca * tca;
				var radius2 = sphere.radius * sphere.radius;

				if ( d2 > radius2 ) return null;

				var thc = Math.sqrt( radius2 - d2 );

				// t0 = first intersect point - entrance on front of sphere
				var t0 = tca - thc;

				// t1 = second intersect point - exit point on back of sphere
				var t1 = tca + thc;

				// test to see if both t0 and t1 are behind the ray - if so, return null
				if ( t0 < 0 && t1 < 0 ) return null;

				// test to see if t0 is behind the ray:
				// if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
				// in order to always return an intersect point that is in front of the ray.
				if ( t0 < 0 ) return this.at( t1, optionalTarget );

				// else t0 is in front of the ray, so return the first collision point scaled by t0
				return this.at( t0, optionalTarget );

			};

		}(),

		intersectsSphere: function ( sphere ) {

			return this.distanceToPoint( sphere.center ) <= sphere.radius;

		},

		distanceToPlane: function ( plane ) {

			var denominator = plane.normal.dot( this.direction );

			if ( denominator === 0 ) {

				// line is coplanar, return origin
				if ( plane.distanceToPoint( this.origin ) === 0 ) {

					return 0;

				}

				// Null is preferable to undefined since undefined means.... it is undefined

				return null;

			}

			var t = - ( this.origin.dot( plane.normal ) + plane.constant ) / denominator;

			// Return if the ray never intersects the plane

			return t >= 0 ? t :  null;

		},

		intersectPlane: function ( plane, optionalTarget ) {

			var t = this.distanceToPlane( plane );

			if ( t === null ) {

				return null;

			}

			return this.at( t, optionalTarget );

		},



		intersectsPlane: function ( plane ) {

			// check if the ray lies on the plane first

			var distToPoint = plane.distanceToPoint( this.origin );

			if ( distToPoint === 0 ) {

				return true;

			}

			var denominator = plane.normal.dot( this.direction );

			if ( denominator * distToPoint < 0 ) {

				return true;

			}

			// ray origin is behind the plane (and is pointing behind it)

			return false;

		},

		intersectBox: function ( box, optionalTarget ) {

			var tmin, tmax, tymin, tymax, tzmin, tzmax;

			var invdirx = 1 / this.direction.x,
				invdiry = 1 / this.direction.y,
				invdirz = 1 / this.direction.z;

			var origin = this.origin;

			if ( invdirx >= 0 ) {

				tmin = ( box.min.x - origin.x ) * invdirx;
				tmax = ( box.max.x - origin.x ) * invdirx;

			} else {

				tmin = ( box.max.x - origin.x ) * invdirx;
				tmax = ( box.min.x - origin.x ) * invdirx;

			}

			if ( invdiry >= 0 ) {

				tymin = ( box.min.y - origin.y ) * invdiry;
				tymax = ( box.max.y - origin.y ) * invdiry;

			} else {

				tymin = ( box.max.y - origin.y ) * invdiry;
				tymax = ( box.min.y - origin.y ) * invdiry;

			}

			if ( ( tmin > tymax ) || ( tymin > tmax ) ) return null;

			// These lines also handle the case where tmin or tmax is NaN
			// (result of 0 * Infinity). x !== x returns true if x is NaN

			if ( tymin > tmin || tmin !== tmin ) tmin = tymin;

			if ( tymax < tmax || tmax !== tmax ) tmax = tymax;

			if ( invdirz >= 0 ) {

				tzmin = ( box.min.z - origin.z ) * invdirz;
				tzmax = ( box.max.z - origin.z ) * invdirz;

			} else {

				tzmin = ( box.max.z - origin.z ) * invdirz;
				tzmax = ( box.min.z - origin.z ) * invdirz;

			}

			if ( ( tmin > tzmax ) || ( tzmin > tmax ) ) return null;

			if ( tzmin > tmin || tmin !== tmin ) tmin = tzmin;

			if ( tzmax < tmax || tmax !== tmax ) tmax = tzmax;

			//return point closest to the ray (positive side)

			if ( tmax < 0 ) return null;

			return this.at( tmin >= 0 ? tmin : tmax, optionalTarget );

		},

		intersectsBox: ( function () {

			var v = new Vector3();

			return function intersectsBox( box ) {

				return this.intersectBox( box, v ) !== null;

			};

		} )(),

		intersectTriangle: function () {

			// Compute the offset origin, edges, and normal.
			var diff = new Vector3();
			var edge1 = new Vector3();
			var edge2 = new Vector3();
			var normal = new Vector3();

			return function intersectTriangle( a, b, c, backfaceCulling, optionalTarget ) {

				// from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h

				edge1.subVectors( b, a );
				edge2.subVectors( c, a );
				normal.crossVectors( edge1, edge2 );

				// Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
				// E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
				//   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
				//   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
				//   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
				var DdN = this.direction.dot( normal );
				var sign;

				if ( DdN > 0 ) {

					if ( backfaceCulling ) return null;
					sign = 1;

				} else if ( DdN < 0 ) {

					sign = - 1;
					DdN = - DdN;

				} else {

					return null;

				}

				diff.subVectors( this.origin, a );
				var DdQxE2 = sign * this.direction.dot( edge2.crossVectors( diff, edge2 ) );

				// b1 < 0, no intersection
				if ( DdQxE2 < 0 ) {

					return null;

				}

				var DdE1xQ = sign * this.direction.dot( edge1.cross( diff ) );

				// b2 < 0, no intersection
				if ( DdE1xQ < 0 ) {

					return null;

				}

				// b1+b2 > 1, no intersection
				if ( DdQxE2 + DdE1xQ > DdN ) {

					return null;

				}

				// Line intersects triangle, check if ray does.
				var QdN = - sign * diff.dot( normal );

				// t < 0, no intersection
				if ( QdN < 0 ) {

					return null;

				}

				// Ray intersects triangle.
				return this.at( QdN / DdN, optionalTarget );

			};

		}(),

		applyMatrix4: function ( matrix4 ) {

			this.direction.add( this.origin ).applyMatrix4( matrix4 );
			this.origin.applyMatrix4( matrix4 );
			this.direction.sub( this.origin );
			this.direction.normalize();

			return this;

		},

		equals: function ( ray ) {

			return ray.origin.equals( this.origin ) && ray.direction.equals( this.direction );

		}

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author WestLangley / http://github.com/WestLangley
	 * @author bhouston / http://clara.io
	 */

	function Euler( x, y, z, order ) {

		this._x = x || 0;
		this._y = y || 0;
		this._z = z || 0;
		this._order = order || Euler.DefaultOrder;

	}

	Euler.RotationOrders = [ 'XYZ', 'YZX', 'ZXY', 'XZY', 'YXZ', 'ZYX' ];

	Euler.DefaultOrder = 'XYZ';

	Euler.prototype = {

		constructor: Euler,

		isEuler: true,

		get x () {

			return this._x;

		},

		set x ( value ) {

			this._x = value;
			this.onChangeCallback();

		},

		get y () {

			return this._y;

		},

		set y ( value ) {

			this._y = value;
			this.onChangeCallback();

		},

		get z () {

			return this._z;

		},

		set z ( value ) {

			this._z = value;
			this.onChangeCallback();

		},

		get order () {

			return this._order;

		},

		set order ( value ) {

			this._order = value;
			this.onChangeCallback();

		},

		set: function ( x, y, z, order ) {

			this._x = x;
			this._y = y;
			this._z = z;
			this._order = order || this._order;

			this.onChangeCallback();

			return this;

		},

		clone: function () {

			return new this.constructor( this._x, this._y, this._z, this._order );

		},

		copy: function ( euler ) {

			this._x = euler._x;
			this._y = euler._y;
			this._z = euler._z;
			this._order = euler._order;

			this.onChangeCallback();

			return this;

		},

		setFromRotationMatrix: function ( m, order, update ) {

			var clamp = _Math.clamp;

			// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

			var te = m.elements;
			var m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ];
			var m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ];
			var m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];

			order = order || this._order;

			if ( order === 'XYZ' ) {

				this._y = Math.asin( clamp( m13, - 1, 1 ) );

				if ( Math.abs( m13 ) < 0.99999 ) {

					this._x = Math.atan2( - m23, m33 );
					this._z = Math.atan2( - m12, m11 );

				} else {

					this._x = Math.atan2( m32, m22 );
					this._z = 0;

				}

			} else if ( order === 'YXZ' ) {

				this._x = Math.asin( - clamp( m23, - 1, 1 ) );

				if ( Math.abs( m23 ) < 0.99999 ) {

					this._y = Math.atan2( m13, m33 );
					this._z = Math.atan2( m21, m22 );

				} else {

					this._y = Math.atan2( - m31, m11 );
					this._z = 0;

				}

			} else if ( order === 'ZXY' ) {

				this._x = Math.asin( clamp( m32, - 1, 1 ) );

				if ( Math.abs( m32 ) < 0.99999 ) {

					this._y = Math.atan2( - m31, m33 );
					this._z = Math.atan2( - m12, m22 );

				} else {

					this._y = 0;
					this._z = Math.atan2( m21, m11 );

				}

			} else if ( order === 'ZYX' ) {

				this._y = Math.asin( - clamp( m31, - 1, 1 ) );

				if ( Math.abs( m31 ) < 0.99999 ) {

					this._x = Math.atan2( m32, m33 );
					this._z = Math.atan2( m21, m11 );

				} else {

					this._x = 0;
					this._z = Math.atan2( - m12, m22 );

				}

			} else if ( order === 'YZX' ) {

				this._z = Math.asin( clamp( m21, - 1, 1 ) );

				if ( Math.abs( m21 ) < 0.99999 ) {

					this._x = Math.atan2( - m23, m22 );
					this._y = Math.atan2( - m31, m11 );

				} else {

					this._x = 0;
					this._y = Math.atan2( m13, m33 );

				}

			} else if ( order === 'XZY' ) {

				this._z = Math.asin( - clamp( m12, - 1, 1 ) );

				if ( Math.abs( m12 ) < 0.99999 ) {

					this._x = Math.atan2( m32, m22 );
					this._y = Math.atan2( m13, m11 );

				} else {

					this._x = Math.atan2( - m23, m33 );
					this._y = 0;

				}

			} else {

				console.warn( 'THREE.Euler: .setFromRotationMatrix() given unsupported order: ' + order );

			}

			this._order = order;

			if ( update !== false ) this.onChangeCallback();

			return this;

		},

		setFromQuaternion: function () {

			var matrix;

			return function setFromQuaternion( q, order, update ) {

				if ( matrix === undefined ) matrix = new Matrix4();

				matrix.makeRotationFromQuaternion( q );

				return this.setFromRotationMatrix( matrix, order, update );

			};

		}(),

		setFromVector3: function ( v, order ) {

			return this.set( v.x, v.y, v.z, order || this._order );

		},

		reorder: function () {

			// WARNING: this discards revolution information -bhouston

			var q = new Quaternion();

			return function reorder( newOrder ) {

				q.setFromEuler( this );

				return this.setFromQuaternion( q, newOrder );

			};

		}(),

		equals: function ( euler ) {

			return ( euler._x === this._x ) && ( euler._y === this._y ) && ( euler._z === this._z ) && ( euler._order === this._order );

		},

		fromArray: function ( array ) {

			this._x = array[ 0 ];
			this._y = array[ 1 ];
			this._z = array[ 2 ];
			if ( array[ 3 ] !== undefined ) this._order = array[ 3 ];

			this.onChangeCallback();

			return this;

		},

		toArray: function ( array, offset ) {

			if ( array === undefined ) array = [];
			if ( offset === undefined ) offset = 0;

			array[ offset ] = this._x;
			array[ offset + 1 ] = this._y;
			array[ offset + 2 ] = this._z;
			array[ offset + 3 ] = this._order;

			return array;

		},

		toVector3: function ( optionalResult ) {

			if ( optionalResult ) {

				return optionalResult.set( this._x, this._y, this._z );

			} else {

				return new Vector3( this._x, this._y, this._z );

			}

		},

		onChange: function ( callback ) {

			this.onChangeCallback = callback;

			return this;

		},

		onChangeCallback: function () {}

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function Layers() {

		this.mask = 1;

	}

	Layers.prototype = {

		constructor: Layers,

		set: function ( channel ) {

			this.mask = 1 << channel;

		},

		enable: function ( channel ) {

			this.mask |= 1 << channel;

		},

		toggle: function ( channel ) {

			this.mask ^= 1 << channel;

		},

		disable: function ( channel ) {

			this.mask &= ~ ( 1 << channel );

		},

		test: function ( layers ) {

			return ( this.mask & layers.mask ) !== 0;

		}

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author mikael emtinger / http://gomo.se/
	 * @author alteredq / http://alteredqualia.com/
	 * @author WestLangley / http://github.com/WestLangley
	 * @author elephantatwork / www.elephantatwork.ch
	 */

	var object3DId = 0;

	function Object3D() {

		Object.defineProperty( this, 'id', { value: object3DId ++ } );

		this.uuid = _Math.generateUUID();

		this.name = '';
		this.type = 'Object3D';

		this.parent = null;
		this.children = [];

		this.up = Object3D.DefaultUp.clone();

		var position = new Vector3();
		var rotation = new Euler();
		var quaternion = new Quaternion();
		var scale = new Vector3( 1, 1, 1 );

		function onRotationChange() {

			quaternion.setFromEuler( rotation, false );

		}

		function onQuaternionChange() {

			rotation.setFromQuaternion( quaternion, undefined, false );

		}

		rotation.onChange( onRotationChange );
		quaternion.onChange( onQuaternionChange );

		Object.defineProperties( this, {
			position: {
				enumerable: true,
				value: position
			},
			rotation: {
				enumerable: true,
				value: rotation
			},
			quaternion: {
				enumerable: true,
				value: quaternion
			},
			scale: {
				enumerable: true,
				value: scale
			},
			modelViewMatrix: {
				value: new Matrix4()
			},
			normalMatrix: {
				value: new Matrix3()
			}
		} );

		this.matrix = new Matrix4();
		this.matrixWorld = new Matrix4();

		this.matrixAutoUpdate = Object3D.DefaultMatrixAutoUpdate;
		this.matrixWorldNeedsUpdate = false;

		this.layers = new Layers();
		this.visible = true;

		this.castShadow = false;
		this.receiveShadow = false;

		this.frustumCulled = true;
		this.renderOrder = 0;

		this.userData = {};

		this.onBeforeRender = function () {};
		this.onAfterRender = function () {};

	}

	Object3D.DefaultUp = new Vector3( 0, 1, 0 );
	Object3D.DefaultMatrixAutoUpdate = true;

	Object.assign( Object3D.prototype, EventDispatcher.prototype, {

		isObject3D: true,

		applyMatrix: function ( matrix ) {

			this.matrix.multiplyMatrices( matrix, this.matrix );

			this.matrix.decompose( this.position, this.quaternion, this.scale );

		},

		setRotationFromAxisAngle: function ( axis, angle ) {

			// assumes axis is normalized

			this.quaternion.setFromAxisAngle( axis, angle );

		},

		setRotationFromEuler: function ( euler ) {

			this.quaternion.setFromEuler( euler, true );

		},

		setRotationFromMatrix: function ( m ) {

			// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

			this.quaternion.setFromRotationMatrix( m );

		},

		setRotationFromQuaternion: function ( q ) {

			// assumes q is normalized

			this.quaternion.copy( q );

		},

		rotateOnAxis: function () {

			// rotate object on axis in object space
			// axis is assumed to be normalized

			var q1 = new Quaternion();

			return function rotateOnAxis( axis, angle ) {

				q1.setFromAxisAngle( axis, angle );

				this.quaternion.multiply( q1 );

				return this;

			};

		}(),

		rotateX: function () {

			var v1 = new Vector3( 1, 0, 0 );

			return function rotateX( angle ) {

				return this.rotateOnAxis( v1, angle );

			};

		}(),

		rotateY: function () {

			var v1 = new Vector3( 0, 1, 0 );

			return function rotateY( angle ) {

				return this.rotateOnAxis( v1, angle );

			};

		}(),

		rotateZ: function () {

			var v1 = new Vector3( 0, 0, 1 );

			return function rotateZ( angle ) {

				return this.rotateOnAxis( v1, angle );

			};

		}(),

		translateOnAxis: function () {

			// translate object by distance along axis in object space
			// axis is assumed to be normalized

			var v1 = new Vector3();

			return function translateOnAxis( axis, distance ) {

				v1.copy( axis ).applyQuaternion( this.quaternion );

				this.position.add( v1.multiplyScalar( distance ) );

				return this;

			};

		}(),

		translateX: function () {

			var v1 = new Vector3( 1, 0, 0 );

			return function translateX( distance ) {

				return this.translateOnAxis( v1, distance );

			};

		}(),

		translateY: function () {

			var v1 = new Vector3( 0, 1, 0 );

			return function translateY( distance ) {

				return this.translateOnAxis( v1, distance );

			};

		}(),

		translateZ: function () {

			var v1 = new Vector3( 0, 0, 1 );

			return function translateZ( distance ) {

				return this.translateOnAxis( v1, distance );

			};

		}(),

		localToWorld: function ( vector ) {

			return vector.applyMatrix4( this.matrixWorld );

		},

		worldToLocal: function () {

			var m1 = new Matrix4();

			return function worldToLocal( vector ) {

				return vector.applyMatrix4( m1.getInverse( this.matrixWorld ) );

			};

		}(),

		lookAt: function () {

			// This routine does not support objects with rotated and/or translated parent(s)

			var m1 = new Matrix4();

			return function lookAt( vector ) {

				m1.lookAt( vector, this.position, this.up );

				this.quaternion.setFromRotationMatrix( m1 );

			};

		}(),

		add: function ( object ) {

			if ( arguments.length > 1 ) {

				for ( var i = 0; i < arguments.length; i ++ ) {

					this.add( arguments[ i ] );

				}

				return this;

			}

			if ( object === this ) {

				console.error( "THREE.Object3D.add: object can't be added as a child of itself.", object );
				return this;

			}

			if ( ( object && object.isObject3D ) ) {

				if ( object.parent !== null ) {

					object.parent.remove( object );

				}

				object.parent = this;
				object.dispatchEvent( { type: 'added' } );

				this.children.push( object );

			} else {

				console.error( "THREE.Object3D.add: object not an instance of THREE.Object3D.", object );

			}

			return this;

		},

		remove: function ( object ) {

			if ( arguments.length > 1 ) {

				for ( var i = 0; i < arguments.length; i ++ ) {

					this.remove( arguments[ i ] );

				}

			}

			var index = this.children.indexOf( object );

			if ( index !== - 1 ) {

				object.parent = null;

				object.dispatchEvent( { type: 'removed' } );

				this.children.splice( index, 1 );

			}

		},

		getObjectById: function ( id ) {

			return this.getObjectByProperty( 'id', id );

		},

		getObjectByName: function ( name ) {

			return this.getObjectByProperty( 'name', name );

		},

		getObjectByProperty: function ( name, value ) {

			if ( this[ name ] === value ) return this;

			for ( var i = 0, l = this.children.length; i < l; i ++ ) {

				var child = this.children[ i ];
				var object = child.getObjectByProperty( name, value );

				if ( object !== undefined ) {

					return object;

				}

			}

			return undefined;

		},

		getWorldPosition: function ( optionalTarget ) {

			var result = optionalTarget || new Vector3();

			this.updateMatrixWorld( true );

			return result.setFromMatrixPosition( this.matrixWorld );

		},

		getWorldQuaternion: function () {

			var position = new Vector3();
			var scale = new Vector3();

			return function getWorldQuaternion( optionalTarget ) {

				var result = optionalTarget || new Quaternion();

				this.updateMatrixWorld( true );

				this.matrixWorld.decompose( position, result, scale );

				return result;

			};

		}(),

		getWorldRotation: function () {

			var quaternion = new Quaternion();

			return function getWorldRotation( optionalTarget ) {

				var result = optionalTarget || new Euler();

				this.getWorldQuaternion( quaternion );

				return result.setFromQuaternion( quaternion, this.rotation.order, false );

			};

		}(),

		getWorldScale: function () {

			var position = new Vector3();
			var quaternion = new Quaternion();

			return function getWorldScale( optionalTarget ) {

				var result = optionalTarget || new Vector3();

				this.updateMatrixWorld( true );

				this.matrixWorld.decompose( position, quaternion, result );

				return result;

			};

		}(),

		getWorldDirection: function () {

			var quaternion = new Quaternion();

			return function getWorldDirection( optionalTarget ) {

				var result = optionalTarget || new Vector3();

				this.getWorldQuaternion( quaternion );

				return result.set( 0, 0, 1 ).applyQuaternion( quaternion );

			};

		}(),

		raycast: function () {},

		traverse: function ( callback ) {

			callback( this );

			var children = this.children;

			for ( var i = 0, l = children.length; i < l; i ++ ) {

				children[ i ].traverse( callback );

			}

		},

		traverseVisible: function ( callback ) {

			if ( this.visible === false ) return;

			callback( this );

			var children = this.children;

			for ( var i = 0, l = children.length; i < l; i ++ ) {

				children[ i ].traverseVisible( callback );

			}

		},

		traverseAncestors: function ( callback ) {

			var parent = this.parent;

			if ( parent !== null ) {

				callback( parent );

				parent.traverseAncestors( callback );

			}

		},

		updateMatrix: function () {

			this.matrix.compose( this.position, this.quaternion, this.scale );

			this.matrixWorldNeedsUpdate = true;

		},

		updateMatrixWorld: function ( force ) {

			if ( this.matrixAutoUpdate === true ) this.updateMatrix();

			if ( this.matrixWorldNeedsUpdate === true || force === true ) {

				if ( this.parent === null ) {

					this.matrixWorld.copy( this.matrix );

				} else {

					this.matrixWorld.multiplyMatrices( this.parent.matrixWorld, this.matrix );

				}

				this.matrixWorldNeedsUpdate = false;

				force = true;

			}

			// update children

			var children = this.children;

			for ( var i = 0, l = children.length; i < l; i ++ ) {

				children[ i ].updateMatrixWorld( force );

			}

		},

		toJSON: function ( meta ) {

			// meta is '' when called from JSON.stringify
			var isRootObject = ( meta === undefined || meta === '' );

			var output = {};

			// meta is a hash used to collect geometries, materials.
			// not providing it implies that this is the root object
			// being serialized.
			if ( isRootObject ) {

				// initialize meta obj
				meta = {
					geometries: {},
					materials: {},
					textures: {},
					images: {}
				};

				output.metadata = {
					version: 4.4,
					type: 'Object',
					generator: 'Object3D.toJSON'
				};

			}

			// standard Object3D serialization

			var object = {};

			object.uuid = this.uuid;
			object.type = this.type;

			if ( this.name !== '' ) object.name = this.name;
			if ( JSON.stringify( this.userData ) !== '{}' ) object.userData = this.userData;
			if ( this.castShadow === true ) object.castShadow = true;
			if ( this.receiveShadow === true ) object.receiveShadow = true;
			if ( this.visible === false ) object.visible = false;

			object.matrix = this.matrix.toArray();

			//

			if ( this.geometry !== undefined ) {

				if ( meta.geometries[ this.geometry.uuid ] === undefined ) {

					meta.geometries[ this.geometry.uuid ] = this.geometry.toJSON( meta );

				}

				object.geometry = this.geometry.uuid;

			}

			if ( this.material !== undefined ) {

				if ( meta.materials[ this.material.uuid ] === undefined ) {

					meta.materials[ this.material.uuid ] = this.material.toJSON( meta );

				}

				object.material = this.material.uuid;

			}

			//

			if ( this.children.length > 0 ) {

				object.children = [];

				for ( var i = 0; i < this.children.length; i ++ ) {

					object.children.push( this.children[ i ].toJSON( meta ).object );

				}

			}

			if ( isRootObject ) {

				var geometries = extractFromCache( meta.geometries );
				var materials = extractFromCache( meta.materials );
				var textures = extractFromCache( meta.textures );
				var images = extractFromCache( meta.images );

				if ( geometries.length > 0 ) output.geometries = geometries;
				if ( materials.length > 0 ) output.materials = materials;
				if ( textures.length > 0 ) output.textures = textures;
				if ( images.length > 0 ) output.images = images;

			}

			output.object = object;

			return output;

			// extract data from the cache hash
			// remove metadata on each item
			// and return as array
			function extractFromCache( cache ) {

				var values = [];
				for ( var key in cache ) {

					var data = cache[ key ];
					delete data.metadata;
					values.push( data );

				}
				return values;

			}

		},

		clone: function ( recursive ) {

			return new this.constructor().copy( this, recursive );

		},

		copy: function ( source, recursive ) {

			if ( recursive === undefined ) recursive = true;

			this.name = source.name;

			this.up.copy( source.up );

			this.position.copy( source.position );
			this.quaternion.copy( source.quaternion );
			this.scale.copy( source.scale );

			this.matrix.copy( source.matrix );
			this.matrixWorld.copy( source.matrixWorld );

			this.matrixAutoUpdate = source.matrixAutoUpdate;
			this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;

			this.layers.mask = source.layers.mask;
			this.visible = source.visible;

			this.castShadow = source.castShadow;
			this.receiveShadow = source.receiveShadow;

			this.frustumCulled = source.frustumCulled;
			this.renderOrder = source.renderOrder;

			this.userData = JSON.parse( JSON.stringify( source.userData ) );

			if ( recursive === true ) {

				for ( var i = 0; i < source.children.length; i ++ ) {

					var child = source.children[ i ];
					this.add( child.clone() );

				}

			}

			return this;

		}

	} );

	/**
	 * @author bhouston / http://clara.io
	 */

	function Line3( start, end ) {

		this.start = ( start !== undefined ) ? start : new Vector3();
		this.end = ( end !== undefined ) ? end : new Vector3();

	}

	Line3.prototype = {

		constructor: Line3,

		set: function ( start, end ) {

			this.start.copy( start );
			this.end.copy( end );

			return this;

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( line ) {

			this.start.copy( line.start );
			this.end.copy( line.end );

			return this;

		},

		getCenter: function ( optionalTarget ) {

			var result = optionalTarget || new Vector3();
			return result.addVectors( this.start, this.end ).multiplyScalar( 0.5 );

		},

		delta: function ( optionalTarget ) {

			var result = optionalTarget || new Vector3();
			return result.subVectors( this.end, this.start );

		},

		distanceSq: function () {

			return this.start.distanceToSquared( this.end );

		},

		distance: function () {

			return this.start.distanceTo( this.end );

		},

		at: function ( t, optionalTarget ) {

			var result = optionalTarget || new Vector3();

			return this.delta( result ).multiplyScalar( t ).add( this.start );

		},

		closestPointToPointParameter: function () {

			var startP = new Vector3();
			var startEnd = new Vector3();

			return function closestPointToPointParameter( point, clampToLine ) {

				startP.subVectors( point, this.start );
				startEnd.subVectors( this.end, this.start );

				var startEnd2 = startEnd.dot( startEnd );
				var startEnd_startP = startEnd.dot( startP );

				var t = startEnd_startP / startEnd2;

				if ( clampToLine ) {

					t = _Math.clamp( t, 0, 1 );

				}

				return t;

			};

		}(),

		closestPointToPoint: function ( point, clampToLine, optionalTarget ) {

			var t = this.closestPointToPointParameter( point, clampToLine );

			var result = optionalTarget || new Vector3();

			return this.delta( result ).multiplyScalar( t ).add( this.start );

		},

		applyMatrix4: function ( matrix ) {

			this.start.applyMatrix4( matrix );
			this.end.applyMatrix4( matrix );

			return this;

		},

		equals: function ( line ) {

			return line.start.equals( this.start ) && line.end.equals( this.end );

		}

	};

	/**
	 * @author bhouston / http://clara.io
	 * @author mrdoob / http://mrdoob.com/
	 */

	function Triangle( a, b, c ) {

		this.a = ( a !== undefined ) ? a : new Vector3();
		this.b = ( b !== undefined ) ? b : new Vector3();
		this.c = ( c !== undefined ) ? c : new Vector3();

	}

	Triangle.normal = function () {

		var v0 = new Vector3();

		return function normal( a, b, c, optionalTarget ) {

			var result = optionalTarget || new Vector3();

			result.subVectors( c, b );
			v0.subVectors( a, b );
			result.cross( v0 );

			var resultLengthSq = result.lengthSq();
			if ( resultLengthSq > 0 ) {

				return result.multiplyScalar( 1 / Math.sqrt( resultLengthSq ) );

			}

			return result.set( 0, 0, 0 );

		};

	}();

	// static/instance method to calculate barycentric coordinates
	// based on: http://www.blackpawn.com/texts/pointinpoly/default.html
	Triangle.barycoordFromPoint = function () {

		var v0 = new Vector3();
		var v1 = new Vector3();
		var v2 = new Vector3();

		return function barycoordFromPoint( point, a, b, c, optionalTarget ) {

			v0.subVectors( c, a );
			v1.subVectors( b, a );
			v2.subVectors( point, a );

			var dot00 = v0.dot( v0 );
			var dot01 = v0.dot( v1 );
			var dot02 = v0.dot( v2 );
			var dot11 = v1.dot( v1 );
			var dot12 = v1.dot( v2 );

			var denom = ( dot00 * dot11 - dot01 * dot01 );

			var result = optionalTarget || new Vector3();

			// collinear or singular triangle
			if ( denom === 0 ) {

				// arbitrary location outside of triangle?
				// not sure if this is the best idea, maybe should be returning undefined
				return result.set( - 2, - 1, - 1 );

			}

			var invDenom = 1 / denom;
			var u = ( dot11 * dot02 - dot01 * dot12 ) * invDenom;
			var v = ( dot00 * dot12 - dot01 * dot02 ) * invDenom;

			// barycentric coordinates must always sum to 1
			return result.set( 1 - u - v, v, u );

		};

	}();

	Triangle.containsPoint = function () {

		var v1 = new Vector3();

		return function containsPoint( point, a, b, c ) {

			var result = Triangle.barycoordFromPoint( point, a, b, c, v1 );

			return ( result.x >= 0 ) && ( result.y >= 0 ) && ( ( result.x + result.y ) <= 1 );

		};

	}();

	Triangle.prototype = {

		constructor: Triangle,

		set: function ( a, b, c ) {

			this.a.copy( a );
			this.b.copy( b );
			this.c.copy( c );

			return this;

		},

		setFromPointsAndIndices: function ( points, i0, i1, i2 ) {

			this.a.copy( points[ i0 ] );
			this.b.copy( points[ i1 ] );
			this.c.copy( points[ i2 ] );

			return this;

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( triangle ) {

			this.a.copy( triangle.a );
			this.b.copy( triangle.b );
			this.c.copy( triangle.c );

			return this;

		},

		area: function () {

			var v0 = new Vector3();
			var v1 = new Vector3();

			return function area() {

				v0.subVectors( this.c, this.b );
				v1.subVectors( this.a, this.b );

				return v0.cross( v1 ).length() * 0.5;

			};

		}(),

		midpoint: function ( optionalTarget ) {

			var result = optionalTarget || new Vector3();
			return result.addVectors( this.a, this.b ).add( this.c ).multiplyScalar( 1 / 3 );

		},

		normal: function ( optionalTarget ) {

			return Triangle.normal( this.a, this.b, this.c, optionalTarget );

		},

		plane: function ( optionalTarget ) {

			var result = optionalTarget || new Plane();

			return result.setFromCoplanarPoints( this.a, this.b, this.c );

		},

		barycoordFromPoint: function ( point, optionalTarget ) {

			return Triangle.barycoordFromPoint( point, this.a, this.b, this.c, optionalTarget );

		},

		containsPoint: function ( point ) {

			return Triangle.containsPoint( point, this.a, this.b, this.c );

		},

		closestPointToPoint: function () {

			var plane, edgeList, projectedPoint, closestPoint;

			return function closestPointToPoint( point, optionalTarget ) {

				if ( plane === undefined ) {

					plane = new Plane();
					edgeList = [ new Line3(), new Line3(), new Line3() ];
					projectedPoint = new Vector3();
					closestPoint = new Vector3();

				}

				var result = optionalTarget || new Vector3();
				var minDistance = Infinity;

				// project the point onto the plane of the triangle

				plane.setFromCoplanarPoints( this.a, this.b, this.c );
				plane.projectPoint( point, projectedPoint );

				// check if the projection lies within the triangle

				if( this.containsPoint( projectedPoint ) === true ) {

					// if so, this is the closest point

					result.copy( projectedPoint );

				} else {

					// if not, the point falls outside the triangle. the result is the closest point to the triangle's edges or vertices

					edgeList[ 0 ].set( this.a, this.b );
					edgeList[ 1 ].set( this.b, this.c );
					edgeList[ 2 ].set( this.c, this.a );

					for( var i = 0; i < edgeList.length; i ++ ) {

						edgeList[ i ].closestPointToPoint( projectedPoint, true, closestPoint );

						var distance = projectedPoint.distanceToSquared( closestPoint );

						if( distance < minDistance ) {

							minDistance = distance;

							result.copy( closestPoint );

						}

					}

				}

				return result;

			};

		}(),

		equals: function ( triangle ) {

			return triangle.a.equals( this.a ) && triangle.b.equals( this.b ) && triangle.c.equals( this.c );

		}

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function Face3( a, b, c, normal, color, materialIndex ) {

		this.a = a;
		this.b = b;
		this.c = c;

		this.normal = (normal && normal.isVector3) ? normal : new Vector3();
		this.vertexNormals = Array.isArray( normal ) ? normal : [];

		this.color = (color && color.isColor) ? color : new Color();
		this.vertexColors = Array.isArray( color ) ? color : [];

		this.materialIndex = materialIndex !== undefined ? materialIndex : 0;

	}

	Face3.prototype = {

		constructor: Face3,

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( source ) {

			this.a = source.a;
			this.b = source.b;
			this.c = source.c;

			this.normal.copy( source.normal );
			this.color.copy( source.color );

			this.materialIndex = source.materialIndex;

			for ( var i = 0, il = source.vertexNormals.length; i < il; i ++ ) {

				this.vertexNormals[ i ] = source.vertexNormals[ i ].clone();

			}

			for ( var i = 0, il = source.vertexColors.length; i < il; i ++ ) {

				this.vertexColors[ i ] = source.vertexColors[ i ].clone();

			}

			return this;

		}

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 *
	 * parameters = {
	 *  color: <hex>,
	 *  opacity: <float>,
	 *  map: new THREE.Texture( <Image> ),
	 *
	 *  lightMap: new THREE.Texture( <Image> ),
	 *  lightMapIntensity: <float>
	 *
	 *  aoMap: new THREE.Texture( <Image> ),
	 *  aoMapIntensity: <float>
	 *
	 *  specularMap: new THREE.Texture( <Image> ),
	 *
	 *  alphaMap: new THREE.Texture( <Image> ),
	 *
	 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
	 *  combine: THREE.Multiply,
	 *  reflectivity: <float>,
	 *  refractionRatio: <float>,
	 *
	 *  shading: THREE.SmoothShading,
	 *  depthTest: <bool>,
	 *  depthWrite: <bool>,
	 *
	 *  wireframe: <boolean>,
	 *  wireframeLinewidth: <float>,
	 *
	 *  skinning: <bool>,
	 *  morphTargets: <bool>
	 * }
	 */

	function MeshBasicMaterial( parameters ) {

		Material.call( this );

		this.type = 'MeshBasicMaterial';

		this.color = new Color( 0xffffff ); // emissive

		this.map = null;

		this.lightMap = null;
		this.lightMapIntensity = 1.0;

		this.aoMap = null;
		this.aoMapIntensity = 1.0;

		this.specularMap = null;

		this.alphaMap = null;

		this.envMap = null;
		this.combine = MultiplyOperation;
		this.reflectivity = 1;
		this.refractionRatio = 0.98;

		this.wireframe = false;
		this.wireframeLinewidth = 1;
		this.wireframeLinecap = 'round';
		this.wireframeLinejoin = 'round';

		this.skinning = false;
		this.morphTargets = false;

		this.lights = false;

		this.setValues( parameters );

	}

	MeshBasicMaterial.prototype = Object.create( Material.prototype );
	MeshBasicMaterial.prototype.constructor = MeshBasicMaterial;

	MeshBasicMaterial.prototype.isMeshBasicMaterial = true;

	MeshBasicMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.color.copy( source.color );

		this.map = source.map;

		this.lightMap = source.lightMap;
		this.lightMapIntensity = source.lightMapIntensity;

		this.aoMap = source.aoMap;
		this.aoMapIntensity = source.aoMapIntensity;

		this.specularMap = source.specularMap;

		this.alphaMap = source.alphaMap;

		this.envMap = source.envMap;
		this.combine = source.combine;
		this.reflectivity = source.reflectivity;
		this.refractionRatio = source.refractionRatio;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;
		this.wireframeLinecap = source.wireframeLinecap;
		this.wireframeLinejoin = source.wireframeLinejoin;

		this.skinning = source.skinning;
		this.morphTargets = source.morphTargets;

		return this;

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function BufferAttribute( array, itemSize, normalized ) {

		if ( Array.isArray( array ) ) {

			throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );

		}

		this.uuid = _Math.generateUUID();

		this.array = array;
		this.itemSize = itemSize;
		this.count = array !== undefined ? array.length / itemSize : 0;
		this.normalized = normalized === true;

		this.dynamic = false;
		this.updateRange = { offset: 0, count: - 1 };

		this.onUploadCallback = function () {};

		this.version = 0;

	}

	BufferAttribute.prototype = {

		constructor: BufferAttribute,

		isBufferAttribute: true,

		set needsUpdate( value ) {

			if ( value === true ) this.version ++;

		},

		setArray: function ( array ) {

			if ( Array.isArray( array ) ) {

				throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );

			}

			this.count = array !== undefined ? array.length / this.itemSize : 0;
			this.array = array;

		},

		setDynamic: function ( value ) {

			this.dynamic = value;

			return this;

		},

		copy: function ( source ) {

			this.array = new source.array.constructor( source.array );
			this.itemSize = source.itemSize;
			this.count = source.count;
			this.normalized = source.normalized;

			this.dynamic = source.dynamic;

			return this;

		},

		copyAt: function ( index1, attribute, index2 ) {

			index1 *= this.itemSize;
			index2 *= attribute.itemSize;

			for ( var i = 0, l = this.itemSize; i < l; i ++ ) {

				this.array[ index1 + i ] = attribute.array[ index2 + i ];

			}

			return this;

		},

		copyArray: function ( array ) {

			this.array.set( array );

			return this;

		},

		copyColorsArray: function ( colors ) {

			var array = this.array, offset = 0;

			for ( var i = 0, l = colors.length; i < l; i ++ ) {

				var color = colors[ i ];

				if ( color === undefined ) {

					console.warn( 'THREE.BufferAttribute.copyColorsArray(): color is undefined', i );
					color = new Color();

				}

				array[ offset ++ ] = color.r;
				array[ offset ++ ] = color.g;
				array[ offset ++ ] = color.b;

			}

			return this;

		},

		copyIndicesArray: function ( indices ) {

			var array = this.array, offset = 0;

			for ( var i = 0, l = indices.length; i < l; i ++ ) {

				var index = indices[ i ];

				array[ offset ++ ] = index.a;
				array[ offset ++ ] = index.b;
				array[ offset ++ ] = index.c;

			}

			return this;

		},

		copyVector2sArray: function ( vectors ) {

			var array = this.array, offset = 0;

			for ( var i = 0, l = vectors.length; i < l; i ++ ) {

				var vector = vectors[ i ];

				if ( vector === undefined ) {

					console.warn( 'THREE.BufferAttribute.copyVector2sArray(): vector is undefined', i );
					vector = new Vector2();

				}

				array[ offset ++ ] = vector.x;
				array[ offset ++ ] = vector.y;

			}

			return this;

		},

		copyVector3sArray: function ( vectors ) {

			var array = this.array, offset = 0;

			for ( var i = 0, l = vectors.length; i < l; i ++ ) {

				var vector = vectors[ i ];

				if ( vector === undefined ) {

					console.warn( 'THREE.BufferAttribute.copyVector3sArray(): vector is undefined', i );
					vector = new Vector3();

				}

				array[ offset ++ ] = vector.x;
				array[ offset ++ ] = vector.y;
				array[ offset ++ ] = vector.z;

			}

			return this;

		},

		copyVector4sArray: function ( vectors ) {

			var array = this.array, offset = 0;

			for ( var i = 0, l = vectors.length; i < l; i ++ ) {

				var vector = vectors[ i ];

				if ( vector === undefined ) {

					console.warn( 'THREE.BufferAttribute.copyVector4sArray(): vector is undefined', i );
					vector = new Vector4();

				}

				array[ offset ++ ] = vector.x;
				array[ offset ++ ] = vector.y;
				array[ offset ++ ] = vector.z;
				array[ offset ++ ] = vector.w;

			}

			return this;

		},

		set: function ( value, offset ) {

			if ( offset === undefined ) offset = 0;

			this.array.set( value, offset );

			return this;

		},

		getX: function ( index ) {

			return this.array[ index * this.itemSize ];

		},

		setX: function ( index, x ) {

			this.array[ index * this.itemSize ] = x;

			return this;

		},

		getY: function ( index ) {

			return this.array[ index * this.itemSize + 1 ];

		},

		setY: function ( index, y ) {

			this.array[ index * this.itemSize + 1 ] = y;

			return this;

		},

		getZ: function ( index ) {

			return this.array[ index * this.itemSize + 2 ];

		},

		setZ: function ( index, z ) {

			this.array[ index * this.itemSize + 2 ] = z;

			return this;

		},

		getW: function ( index ) {

			return this.array[ index * this.itemSize + 3 ];

		},

		setW: function ( index, w ) {

			this.array[ index * this.itemSize + 3 ] = w;

			return this;

		},

		setXY: function ( index, x, y ) {

			index *= this.itemSize;

			this.array[ index + 0 ] = x;
			this.array[ index + 1 ] = y;

			return this;

		},

		setXYZ: function ( index, x, y, z ) {

			index *= this.itemSize;

			this.array[ index + 0 ] = x;
			this.array[ index + 1 ] = y;
			this.array[ index + 2 ] = z;

			return this;

		},

		setXYZW: function ( index, x, y, z, w ) {

			index *= this.itemSize;

			this.array[ index + 0 ] = x;
			this.array[ index + 1 ] = y;
			this.array[ index + 2 ] = z;
			this.array[ index + 3 ] = w;

			return this;

		},

		onUpload: function ( callback ) {

			this.onUploadCallback = callback;

			return this;

		},

		clone: function () {

			return new this.constructor().copy( this );

		}

	};

	//

	function Int8BufferAttribute( array, itemSize ) {

		BufferAttribute.call( this, new Int8Array( array ), itemSize );

	}

	Int8BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
	Int8BufferAttribute.prototype.constructor = Int8BufferAttribute;


	function Uint8BufferAttribute( array, itemSize ) {

		BufferAttribute.call( this, new Uint8Array( array ), itemSize );

	}

	Uint8BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
	Uint8BufferAttribute.prototype.constructor = Uint8BufferAttribute;


	function Uint8ClampedBufferAttribute( array, itemSize ) {

		BufferAttribute.call( this, new Uint8ClampedArray( array ), itemSize );

	}

	Uint8ClampedBufferAttribute.prototype = Object.create( BufferAttribute.prototype );
	Uint8ClampedBufferAttribute.prototype.constructor = Uint8ClampedBufferAttribute;


	function Int16BufferAttribute( array, itemSize ) {

		BufferAttribute.call( this, new Int16Array( array ), itemSize );

	}

	Int16BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
	Int16BufferAttribute.prototype.constructor = Int16BufferAttribute;


	function Uint16BufferAttribute( array, itemSize ) {

		BufferAttribute.call( this, new Uint16Array( array ), itemSize );

	}

	Uint16BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
	Uint16BufferAttribute.prototype.constructor = Uint16BufferAttribute;


	function Int32BufferAttribute( array, itemSize ) {

		BufferAttribute.call( this, new Int32Array( array ), itemSize );

	}

	Int32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
	Int32BufferAttribute.prototype.constructor = Int32BufferAttribute;


	function Uint32BufferAttribute( array, itemSize ) {

		BufferAttribute.call( this, new Uint32Array( array ), itemSize );

	}

	Uint32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
	Uint32BufferAttribute.prototype.constructor = Uint32BufferAttribute;


	function Float32BufferAttribute( array, itemSize ) {

		BufferAttribute.call( this, new Float32Array( array ), itemSize );

	}

	Float32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
	Float32BufferAttribute.prototype.constructor = Float32BufferAttribute;


	function Float64BufferAttribute( array, itemSize ) {

		BufferAttribute.call( this, new Float64Array( array ), itemSize );

	}

	Float64BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
	Float64BufferAttribute.prototype.constructor = Float64BufferAttribute;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function DirectGeometry() {

		this.indices = [];
		this.vertices = [];
		this.normals = [];
		this.colors = [];
		this.uvs = [];
		this.uvs2 = [];

		this.groups = [];

		this.morphTargets = {};

		this.skinWeights = [];
		this.skinIndices = [];

		// this.lineDistances = [];

		this.boundingBox = null;
		this.boundingSphere = null;

		// update flags

		this.verticesNeedUpdate = false;
		this.normalsNeedUpdate = false;
		this.colorsNeedUpdate = false;
		this.uvsNeedUpdate = false;
		this.groupsNeedUpdate = false;

	}

	Object.assign( DirectGeometry.prototype, {

		computeGroups: function ( geometry ) {

			var group;
			var groups = [];
			var materialIndex = undefined;

			var faces = geometry.faces;

			for ( var i = 0; i < faces.length; i ++ ) {

				var face = faces[ i ];

				// materials

				if ( face.materialIndex !== materialIndex ) {

					materialIndex = face.materialIndex;

					if ( group !== undefined ) {

						group.count = ( i * 3 ) - group.start;
						groups.push( group );

					}

					group = {
						start: i * 3,
						materialIndex: materialIndex
					};

				}

			}

			if ( group !== undefined ) {

				group.count = ( i * 3 ) - group.start;
				groups.push( group );

			}

			this.groups = groups;

		},

		fromGeometry: function ( geometry ) {

			var faces = geometry.faces;
			var vertices = geometry.vertices;
			var faceVertexUvs = geometry.faceVertexUvs;

			var hasFaceVertexUv = faceVertexUvs[ 0 ] && faceVertexUvs[ 0 ].length > 0;
			var hasFaceVertexUv2 = faceVertexUvs[ 1 ] && faceVertexUvs[ 1 ].length > 0;

			// morphs

			var morphTargets = geometry.morphTargets;
			var morphTargetsLength = morphTargets.length;

			var morphTargetsPosition;

			if ( morphTargetsLength > 0 ) {

				morphTargetsPosition = [];

				for ( var i = 0; i < morphTargetsLength; i ++ ) {

					morphTargetsPosition[ i ] = [];

				}

				this.morphTargets.position = morphTargetsPosition;

			}

			var morphNormals = geometry.morphNormals;
			var morphNormalsLength = morphNormals.length;

			var morphTargetsNormal;

			if ( morphNormalsLength > 0 ) {

				morphTargetsNormal = [];

				for ( var i = 0; i < morphNormalsLength; i ++ ) {

					morphTargetsNormal[ i ] = [];

				}

				this.morphTargets.normal = morphTargetsNormal;

			}

			// skins

			var skinIndices = geometry.skinIndices;
			var skinWeights = geometry.skinWeights;

			var hasSkinIndices = skinIndices.length === vertices.length;
			var hasSkinWeights = skinWeights.length === vertices.length;

			//

			for ( var i = 0; i < faces.length; i ++ ) {

				var face = faces[ i ];

				this.vertices.push( vertices[ face.a ], vertices[ face.b ], vertices[ face.c ] );

				var vertexNormals = face.vertexNormals;

				if ( vertexNormals.length === 3 ) {

					this.normals.push( vertexNormals[ 0 ], vertexNormals[ 1 ], vertexNormals[ 2 ] );

				} else {

					var normal = face.normal;

					this.normals.push( normal, normal, normal );

				}

				var vertexColors = face.vertexColors;

				if ( vertexColors.length === 3 ) {

					this.colors.push( vertexColors[ 0 ], vertexColors[ 1 ], vertexColors[ 2 ] );

				} else {

					var color = face.color;

					this.colors.push( color, color, color );

				}

				if ( hasFaceVertexUv === true ) {

					var vertexUvs = faceVertexUvs[ 0 ][ i ];

					if ( vertexUvs !== undefined ) {

						this.uvs.push( vertexUvs[ 0 ], vertexUvs[ 1 ], vertexUvs[ 2 ] );

					} else {

						console.warn( 'THREE.DirectGeometry.fromGeometry(): Undefined vertexUv ', i );

						this.uvs.push( new Vector2(), new Vector2(), new Vector2() );

					}

				}

				if ( hasFaceVertexUv2 === true ) {

					var vertexUvs = faceVertexUvs[ 1 ][ i ];

					if ( vertexUvs !== undefined ) {

						this.uvs2.push( vertexUvs[ 0 ], vertexUvs[ 1 ], vertexUvs[ 2 ] );

					} else {

						console.warn( 'THREE.DirectGeometry.fromGeometry(): Undefined vertexUv2 ', i );

						this.uvs2.push( new Vector2(), new Vector2(), new Vector2() );

					}

				}

				// morphs

				for ( var j = 0; j < morphTargetsLength; j ++ ) {

					var morphTarget = morphTargets[ j ].vertices;

					morphTargetsPosition[ j ].push( morphTarget[ face.a ], morphTarget[ face.b ], morphTarget[ face.c ] );

				}

				for ( var j = 0; j < morphNormalsLength; j ++ ) {

					var morphNormal = morphNormals[ j ].vertexNormals[ i ];

					morphTargetsNormal[ j ].push( morphNormal.a, morphNormal.b, morphNormal.c );

				}

				// skins

				if ( hasSkinIndices ) {

					this.skinIndices.push( skinIndices[ face.a ], skinIndices[ face.b ], skinIndices[ face.c ] );

				}

				if ( hasSkinWeights ) {

					this.skinWeights.push( skinWeights[ face.a ], skinWeights[ face.b ], skinWeights[ face.c ] );

				}

			}

			this.computeGroups( geometry );

			this.verticesNeedUpdate = geometry.verticesNeedUpdate;
			this.normalsNeedUpdate = geometry.normalsNeedUpdate;
			this.colorsNeedUpdate = geometry.colorsNeedUpdate;
			this.uvsNeedUpdate = geometry.uvsNeedUpdate;
			this.groupsNeedUpdate = geometry.groupsNeedUpdate;

			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author kile / http://kile.stravaganza.org/
	 * @author alteredq / http://alteredqualia.com/
	 * @author mikael emtinger / http://gomo.se/
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 * @author bhouston / http://clara.io
	 */

	function Geometry() {

		Object.defineProperty( this, 'id', { value: GeometryIdCount() } );

		this.uuid = _Math.generateUUID();

		this.name = '';
		this.type = 'Geometry';

		this.vertices = [];
		this.colors = [];
		this.faces = [];
		this.faceVertexUvs = [ [] ];

		this.morphTargets = [];
		this.morphNormals = [];

		this.skinWeights = [];
		this.skinIndices = [];

		this.lineDistances = [];

		this.boundingBox = null;
		this.boundingSphere = null;

		// update flags

		this.elementsNeedUpdate = false;
		this.verticesNeedUpdate = false;
		this.uvsNeedUpdate = false;
		this.normalsNeedUpdate = false;
		this.colorsNeedUpdate = false;
		this.lineDistancesNeedUpdate = false;
		this.groupsNeedUpdate = false;

	}

	Object.assign( Geometry.prototype, EventDispatcher.prototype, {

		isGeometry: true,

		applyMatrix: function ( matrix ) {

			var normalMatrix = new Matrix3().getNormalMatrix( matrix );

			for ( var i = 0, il = this.vertices.length; i < il; i ++ ) {

				var vertex = this.vertices[ i ];
				vertex.applyMatrix4( matrix );

			}

			for ( var i = 0, il = this.faces.length; i < il; i ++ ) {

				var face = this.faces[ i ];
				face.normal.applyMatrix3( normalMatrix ).normalize();

				for ( var j = 0, jl = face.vertexNormals.length; j < jl; j ++ ) {

					face.vertexNormals[ j ].applyMatrix3( normalMatrix ).normalize();

				}

			}

			if ( this.boundingBox !== null ) {

				this.computeBoundingBox();

			}

			if ( this.boundingSphere !== null ) {

				this.computeBoundingSphere();

			}

			this.verticesNeedUpdate = true;
			this.normalsNeedUpdate = true;

			return this;

		},

		rotateX: function () {

			// rotate geometry around world x-axis

			var m1;

			return function rotateX( angle ) {

				if ( m1 === undefined ) m1 = new Matrix4();

				m1.makeRotationX( angle );

				this.applyMatrix( m1 );

				return this;

			};

		}(),

		rotateY: function () {

			// rotate geometry around world y-axis

			var m1;

			return function rotateY( angle ) {

				if ( m1 === undefined ) m1 = new Matrix4();

				m1.makeRotationY( angle );

				this.applyMatrix( m1 );

				return this;

			};

		}(),

		rotateZ: function () {

			// rotate geometry around world z-axis

			var m1;

			return function rotateZ( angle ) {

				if ( m1 === undefined ) m1 = new Matrix4();

				m1.makeRotationZ( angle );

				this.applyMatrix( m1 );

				return this;

			};

		}(),

		translate: function () {

			// translate geometry

			var m1;

			return function translate( x, y, z ) {

				if ( m1 === undefined ) m1 = new Matrix4();

				m1.makeTranslation( x, y, z );

				this.applyMatrix( m1 );

				return this;

			};

		}(),

		scale: function () {

			// scale geometry

			var m1;

			return function scale( x, y, z ) {

				if ( m1 === undefined ) m1 = new Matrix4();

				m1.makeScale( x, y, z );

				this.applyMatrix( m1 );

				return this;

			};

		}(),

		lookAt: function () {

			var obj;

			return function lookAt( vector ) {

				if ( obj === undefined ) obj = new Object3D();

				obj.lookAt( vector );

				obj.updateMatrix();

				this.applyMatrix( obj.matrix );

			};

		}(),

		fromBufferGeometry: function ( geometry ) {

			var scope = this;

			var indices = geometry.index !== null ? geometry.index.array : undefined;
			var attributes = geometry.attributes;

			var positions = attributes.position.array;
			var normals = attributes.normal !== undefined ? attributes.normal.array : undefined;
			var colors = attributes.color !== undefined ? attributes.color.array : undefined;
			var uvs = attributes.uv !== undefined ? attributes.uv.array : undefined;
			var uvs2 = attributes.uv2 !== undefined ? attributes.uv2.array : undefined;

			if ( uvs2 !== undefined ) this.faceVertexUvs[ 1 ] = [];

			var tempNormals = [];
			var tempUVs = [];
			var tempUVs2 = [];

			for ( var i = 0, j = 0; i < positions.length; i += 3, j += 2 ) {

				scope.vertices.push( new Vector3( positions[ i ], positions[ i + 1 ], positions[ i + 2 ] ) );

				if ( normals !== undefined ) {

					tempNormals.push( new Vector3( normals[ i ], normals[ i + 1 ], normals[ i + 2 ] ) );

				}

				if ( colors !== undefined ) {

					scope.colors.push( new Color( colors[ i ], colors[ i + 1 ], colors[ i + 2 ] ) );

				}

				if ( uvs !== undefined ) {

					tempUVs.push( new Vector2( uvs[ j ], uvs[ j + 1 ] ) );

				}

				if ( uvs2 !== undefined ) {

					tempUVs2.push( new Vector2( uvs2[ j ], uvs2[ j + 1 ] ) );

				}

			}

			function addFace( a, b, c, materialIndex ) {

				var vertexNormals = normals !== undefined ? [ tempNormals[ a ].clone(), tempNormals[ b ].clone(), tempNormals[ c ].clone() ] : [];
				var vertexColors = colors !== undefined ? [ scope.colors[ a ].clone(), scope.colors[ b ].clone(), scope.colors[ c ].clone() ] : [];

				var face = new Face3( a, b, c, vertexNormals, vertexColors, materialIndex );

				scope.faces.push( face );

				if ( uvs !== undefined ) {

					scope.faceVertexUvs[ 0 ].push( [ tempUVs[ a ].clone(), tempUVs[ b ].clone(), tempUVs[ c ].clone() ] );

				}

				if ( uvs2 !== undefined ) {

					scope.faceVertexUvs[ 1 ].push( [ tempUVs2[ a ].clone(), tempUVs2[ b ].clone(), tempUVs2[ c ].clone() ] );

				}

			}

			if ( indices !== undefined ) {

				var groups = geometry.groups;

				if ( groups.length > 0 ) {

					for ( var i = 0; i < groups.length; i ++ ) {

						var group = groups[ i ];

						var start = group.start;
						var count = group.count;

						for ( var j = start, jl = start + count; j < jl; j += 3 ) {

							addFace( indices[ j ], indices[ j + 1 ], indices[ j + 2 ], group.materialIndex  );

						}

					}

				} else {

					for ( var i = 0; i < indices.length; i += 3 ) {

						addFace( indices[ i ], indices[ i + 1 ], indices[ i + 2 ] );

					}

				}

			} else {

				for ( var i = 0; i < positions.length / 3; i += 3 ) {

					addFace( i, i + 1, i + 2 );

				}

			}

			this.computeFaceNormals();

			if ( geometry.boundingBox !== null ) {

				this.boundingBox = geometry.boundingBox.clone();

			}

			if ( geometry.boundingSphere !== null ) {

				this.boundingSphere = geometry.boundingSphere.clone();

			}

			return this;

		},

		center: function () {

			this.computeBoundingBox();

			var offset = this.boundingBox.getCenter().negate();

			this.translate( offset.x, offset.y, offset.z );

			return offset;

		},

		normalize: function () {

			this.computeBoundingSphere();

			var center = this.boundingSphere.center;
			var radius = this.boundingSphere.radius;

			var s = radius === 0 ? 1 : 1.0 / radius;

			var matrix = new Matrix4();
			matrix.set(
				s, 0, 0, - s * center.x,
				0, s, 0, - s * center.y,
				0, 0, s, - s * center.z,
				0, 0, 0, 1
			);

			this.applyMatrix( matrix );

			return this;

		},

		computeFaceNormals: function () {

			var cb = new Vector3(), ab = new Vector3();

			for ( var f = 0, fl = this.faces.length; f < fl; f ++ ) {

				var face = this.faces[ f ];

				var vA = this.vertices[ face.a ];
				var vB = this.vertices[ face.b ];
				var vC = this.vertices[ face.c ];

				cb.subVectors( vC, vB );
				ab.subVectors( vA, vB );
				cb.cross( ab );

				cb.normalize();

				face.normal.copy( cb );

			}

		},

		computeVertexNormals: function ( areaWeighted ) {

			if ( areaWeighted === undefined ) areaWeighted = true;

			var v, vl, f, fl, face, vertices;

			vertices = new Array( this.vertices.length );

			for ( v = 0, vl = this.vertices.length; v < vl; v ++ ) {

				vertices[ v ] = new Vector3();

			}

			if ( areaWeighted ) {

				// vertex normals weighted by triangle areas
				// http://www.iquilezles.org/www/articles/normals/normals.htm

				var vA, vB, vC;
				var cb = new Vector3(), ab = new Vector3();

				for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

					face = this.faces[ f ];

					vA = this.vertices[ face.a ];
					vB = this.vertices[ face.b ];
					vC = this.vertices[ face.c ];

					cb.subVectors( vC, vB );
					ab.subVectors( vA, vB );
					cb.cross( ab );

					vertices[ face.a ].add( cb );
					vertices[ face.b ].add( cb );
					vertices[ face.c ].add( cb );

				}

			} else {

				this.computeFaceNormals();

				for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

					face = this.faces[ f ];

					vertices[ face.a ].add( face.normal );
					vertices[ face.b ].add( face.normal );
					vertices[ face.c ].add( face.normal );

				}

			}

			for ( v = 0, vl = this.vertices.length; v < vl; v ++ ) {

				vertices[ v ].normalize();

			}

			for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

				face = this.faces[ f ];

				var vertexNormals = face.vertexNormals;

				if ( vertexNormals.length === 3 ) {

					vertexNormals[ 0 ].copy( vertices[ face.a ] );
					vertexNormals[ 1 ].copy( vertices[ face.b ] );
					vertexNormals[ 2 ].copy( vertices[ face.c ] );

				} else {

					vertexNormals[ 0 ] = vertices[ face.a ].clone();
					vertexNormals[ 1 ] = vertices[ face.b ].clone();
					vertexNormals[ 2 ] = vertices[ face.c ].clone();

				}

			}

			if ( this.faces.length > 0 ) {

				this.normalsNeedUpdate = true;

			}

		},

		computeFlatVertexNormals: function () {

			var f, fl, face;

			this.computeFaceNormals();

			for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

				face = this.faces[ f ];

				var vertexNormals = face.vertexNormals;

				if ( vertexNormals.length === 3 ) {

					vertexNormals[ 0 ].copy( face.normal );
					vertexNormals[ 1 ].copy( face.normal );
					vertexNormals[ 2 ].copy( face.normal );

				} else {

					vertexNormals[ 0 ] = face.normal.clone();
					vertexNormals[ 1 ] = face.normal.clone();
					vertexNormals[ 2 ] = face.normal.clone();

				}

			}

			if ( this.faces.length > 0 ) {

				this.normalsNeedUpdate = true;

			}

		},

		computeMorphNormals: function () {

			var i, il, f, fl, face;

			// save original normals
			// - create temp variables on first access
			//   otherwise just copy (for faster repeated calls)

			for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

				face = this.faces[ f ];

				if ( ! face.__originalFaceNormal ) {

					face.__originalFaceNormal = face.normal.clone();

				} else {

					face.__originalFaceNormal.copy( face.normal );

				}

				if ( ! face.__originalVertexNormals ) face.__originalVertexNormals = [];

				for ( i = 0, il = face.vertexNormals.length; i < il; i ++ ) {

					if ( ! face.__originalVertexNormals[ i ] ) {

						face.__originalVertexNormals[ i ] = face.vertexNormals[ i ].clone();

					} else {

						face.__originalVertexNormals[ i ].copy( face.vertexNormals[ i ] );

					}

				}

			}

			// use temp geometry to compute face and vertex normals for each morph

			var tmpGeo = new Geometry();
			tmpGeo.faces = this.faces;

			for ( i = 0, il = this.morphTargets.length; i < il; i ++ ) {

				// create on first access

				if ( ! this.morphNormals[ i ] ) {

					this.morphNormals[ i ] = {};
					this.morphNormals[ i ].faceNormals = [];
					this.morphNormals[ i ].vertexNormals = [];

					var dstNormalsFace = this.morphNormals[ i ].faceNormals;
					var dstNormalsVertex = this.morphNormals[ i ].vertexNormals;

					var faceNormal, vertexNormals;

					for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

						faceNormal = new Vector3();
						vertexNormals = { a: new Vector3(), b: new Vector3(), c: new Vector3() };

						dstNormalsFace.push( faceNormal );
						dstNormalsVertex.push( vertexNormals );

					}

				}

				var morphNormals = this.morphNormals[ i ];

				// set vertices to morph target

				tmpGeo.vertices = this.morphTargets[ i ].vertices;

				// compute morph normals

				tmpGeo.computeFaceNormals();
				tmpGeo.computeVertexNormals();

				// store morph normals

				var faceNormal, vertexNormals;

				for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

					face = this.faces[ f ];

					faceNormal = morphNormals.faceNormals[ f ];
					vertexNormals = morphNormals.vertexNormals[ f ];

					faceNormal.copy( face.normal );

					vertexNormals.a.copy( face.vertexNormals[ 0 ] );
					vertexNormals.b.copy( face.vertexNormals[ 1 ] );
					vertexNormals.c.copy( face.vertexNormals[ 2 ] );

				}

			}

			// restore original normals

			for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

				face = this.faces[ f ];

				face.normal = face.__originalFaceNormal;
				face.vertexNormals = face.__originalVertexNormals;

			}

		},

		computeLineDistances: function () {

			var d = 0;
			var vertices = this.vertices;

			for ( var i = 0, il = vertices.length; i < il; i ++ ) {

				if ( i > 0 ) {

					d += vertices[ i ].distanceTo( vertices[ i - 1 ] );

				}

				this.lineDistances[ i ] = d;

			}

		},

		computeBoundingBox: function () {

			if ( this.boundingBox === null ) {

				this.boundingBox = new Box3();

			}

			this.boundingBox.setFromPoints( this.vertices );

		},

		computeBoundingSphere: function () {

			if ( this.boundingSphere === null ) {

				this.boundingSphere = new Sphere();

			}

			this.boundingSphere.setFromPoints( this.vertices );

		},

		merge: function ( geometry, matrix, materialIndexOffset ) {

			if ( (geometry && geometry.isGeometry) === false ) {

				console.error( 'THREE.Geometry.merge(): geometry not an instance of THREE.Geometry.', geometry );
				return;

			}

			var normalMatrix,
			vertexOffset = this.vertices.length,
			vertices1 = this.vertices,
			vertices2 = geometry.vertices,
			faces1 = this.faces,
			faces2 = geometry.faces,
			uvs1 = this.faceVertexUvs[ 0 ],
			uvs2 = geometry.faceVertexUvs[ 0 ],
			colors1 = this.colors,
			colors2 = geometry.colors;

			if ( materialIndexOffset === undefined ) materialIndexOffset = 0;

			if ( matrix !== undefined ) {

				normalMatrix = new Matrix3().getNormalMatrix( matrix );

			}

			// vertices

			for ( var i = 0, il = vertices2.length; i < il; i ++ ) {

				var vertex = vertices2[ i ];

				var vertexCopy = vertex.clone();

				if ( matrix !== undefined ) vertexCopy.applyMatrix4( matrix );

				vertices1.push( vertexCopy );

			}

			// colors

			for ( var i = 0, il = colors2.length; i < il; i ++ ) {

				colors1.push( colors2[ i ].clone() );

			}

			// faces

			for ( i = 0, il = faces2.length; i < il; i ++ ) {

				var face = faces2[ i ], faceCopy, normal, color,
				faceVertexNormals = face.vertexNormals,
				faceVertexColors = face.vertexColors;

				faceCopy = new Face3( face.a + vertexOffset, face.b + vertexOffset, face.c + vertexOffset );
				faceCopy.normal.copy( face.normal );

				if ( normalMatrix !== undefined ) {

					faceCopy.normal.applyMatrix3( normalMatrix ).normalize();

				}

				for ( var j = 0, jl = faceVertexNormals.length; j < jl; j ++ ) {

					normal = faceVertexNormals[ j ].clone();

					if ( normalMatrix !== undefined ) {

						normal.applyMatrix3( normalMatrix ).normalize();

					}

					faceCopy.vertexNormals.push( normal );

				}

				faceCopy.color.copy( face.color );

				for ( var j = 0, jl = faceVertexColors.length; j < jl; j ++ ) {

					color = faceVertexColors[ j ];
					faceCopy.vertexColors.push( color.clone() );

				}

				faceCopy.materialIndex = face.materialIndex + materialIndexOffset;

				faces1.push( faceCopy );

			}

			// uvs

			for ( i = 0, il = uvs2.length; i < il; i ++ ) {

				var uv = uvs2[ i ], uvCopy = [];

				if ( uv === undefined ) {

					continue;

				}

				for ( var j = 0, jl = uv.length; j < jl; j ++ ) {

					uvCopy.push( uv[ j ].clone() );

				}

				uvs1.push( uvCopy );

			}

		},

		mergeMesh: function ( mesh ) {

			if ( (mesh && mesh.isMesh) === false ) {

				console.error( 'THREE.Geometry.mergeMesh(): mesh not an instance of THREE.Mesh.', mesh );
				return;

			}

			mesh.matrixAutoUpdate && mesh.updateMatrix();

			this.merge( mesh.geometry, mesh.matrix );

		},

		/*
		 * Checks for duplicate vertices with hashmap.
		 * Duplicated vertices are removed
		 * and faces' vertices are updated.
		 */

		mergeVertices: function () {

			var verticesMap = {}; // Hashmap for looking up vertices by position coordinates (and making sure they are unique)
			var unique = [], changes = [];

			var v, key;
			var precisionPoints = 4; // number of decimal points, e.g. 4 for epsilon of 0.0001
			var precision = Math.pow( 10, precisionPoints );
			var i, il, face;
			var indices, j, jl;

			for ( i = 0, il = this.vertices.length; i < il; i ++ ) {

				v = this.vertices[ i ];
				key = Math.round( v.x * precision ) + '_' + Math.round( v.y * precision ) + '_' + Math.round( v.z * precision );

				if ( verticesMap[ key ] === undefined ) {

					verticesMap[ key ] = i;
					unique.push( this.vertices[ i ] );
					changes[ i ] = unique.length - 1;

				} else {

					//console.log('Duplicate vertex found. ', i, ' could be using ', verticesMap[key]);
					changes[ i ] = changes[ verticesMap[ key ] ];

				}

			}


			// if faces are completely degenerate after merging vertices, we
			// have to remove them from the geometry.
			var faceIndicesToRemove = [];

			for ( i = 0, il = this.faces.length; i < il; i ++ ) {

				face = this.faces[ i ];

				face.a = changes[ face.a ];
				face.b = changes[ face.b ];
				face.c = changes[ face.c ];

				indices = [ face.a, face.b, face.c ];

				var dupIndex = - 1;

				// if any duplicate vertices are found in a Face3
				// we have to remove the face as nothing can be saved
				for ( var n = 0; n < 3; n ++ ) {

					if ( indices[ n ] === indices[ ( n + 1 ) % 3 ] ) {

						dupIndex = n;
						faceIndicesToRemove.push( i );
						break;

					}

				}

			}

			for ( i = faceIndicesToRemove.length - 1; i >= 0; i -- ) {

				var idx = faceIndicesToRemove[ i ];

				this.faces.splice( idx, 1 );

				for ( j = 0, jl = this.faceVertexUvs.length; j < jl; j ++ ) {

					this.faceVertexUvs[ j ].splice( idx, 1 );

				}

			}

			// Use unique set of vertices

			var diff = this.vertices.length - unique.length;
			this.vertices = unique;
			return diff;

		},

		sortFacesByMaterialIndex: function () {

			var faces = this.faces;
			var length = faces.length;

			// tag faces

			for ( var i = 0; i < length; i ++ ) {

				faces[ i ]._id = i;

			}

			// sort faces

			function materialIndexSort( a, b ) {

				return a.materialIndex - b.materialIndex;

			}

			faces.sort( materialIndexSort );

			// sort uvs

			var uvs1 = this.faceVertexUvs[ 0 ];
			var uvs2 = this.faceVertexUvs[ 1 ];

			var newUvs1, newUvs2;

			if ( uvs1 && uvs1.length === length ) newUvs1 = [];
			if ( uvs2 && uvs2.length === length ) newUvs2 = [];

			for ( var i = 0; i < length; i ++ ) {

				var id = faces[ i ]._id;

				if ( newUvs1 ) newUvs1.push( uvs1[ id ] );
				if ( newUvs2 ) newUvs2.push( uvs2[ id ] );

			}

			if ( newUvs1 ) this.faceVertexUvs[ 0 ] = newUvs1;
			if ( newUvs2 ) this.faceVertexUvs[ 1 ] = newUvs2;

		},

		toJSON: function () {

			var data = {
				metadata: {
					version: 4.4,
					type: 'Geometry',
					generator: 'Geometry.toJSON'
				}
			};

			// standard Geometry serialization

			data.uuid = this.uuid;
			data.type = this.type;
			if ( this.name !== '' ) data.name = this.name;

			if ( this.parameters !== undefined ) {

				var parameters = this.parameters;

				for ( var key in parameters ) {

					if ( parameters[ key ] !== undefined ) data[ key ] = parameters[ key ];

				}

				return data;

			}

			var vertices = [];

			for ( var i = 0; i < this.vertices.length; i ++ ) {

				var vertex = this.vertices[ i ];
				vertices.push( vertex.x, vertex.y, vertex.z );

			}

			var faces = [];
			var normals = [];
			var normalsHash = {};
			var colors = [];
			var colorsHash = {};
			var uvs = [];
			var uvsHash = {};

			for ( var i = 0; i < this.faces.length; i ++ ) {

				var face = this.faces[ i ];

				var hasMaterial = true;
				var hasFaceUv = false; // deprecated
				var hasFaceVertexUv = this.faceVertexUvs[ 0 ][ i ] !== undefined;
				var hasFaceNormal = face.normal.length() > 0;
				var hasFaceVertexNormal = face.vertexNormals.length > 0;
				var hasFaceColor = face.color.r !== 1 || face.color.g !== 1 || face.color.b !== 1;
				var hasFaceVertexColor = face.vertexColors.length > 0;

				var faceType = 0;

				faceType = setBit( faceType, 0, 0 ); // isQuad
				faceType = setBit( faceType, 1, hasMaterial );
				faceType = setBit( faceType, 2, hasFaceUv );
				faceType = setBit( faceType, 3, hasFaceVertexUv );
				faceType = setBit( faceType, 4, hasFaceNormal );
				faceType = setBit( faceType, 5, hasFaceVertexNormal );
				faceType = setBit( faceType, 6, hasFaceColor );
				faceType = setBit( faceType, 7, hasFaceVertexColor );

				faces.push( faceType );
				faces.push( face.a, face.b, face.c );
				faces.push( face.materialIndex );

				if ( hasFaceVertexUv ) {

					var faceVertexUvs = this.faceVertexUvs[ 0 ][ i ];

					faces.push(
						getUvIndex( faceVertexUvs[ 0 ] ),
						getUvIndex( faceVertexUvs[ 1 ] ),
						getUvIndex( faceVertexUvs[ 2 ] )
					);

				}

				if ( hasFaceNormal ) {

					faces.push( getNormalIndex( face.normal ) );

				}

				if ( hasFaceVertexNormal ) {

					var vertexNormals = face.vertexNormals;

					faces.push(
						getNormalIndex( vertexNormals[ 0 ] ),
						getNormalIndex( vertexNormals[ 1 ] ),
						getNormalIndex( vertexNormals[ 2 ] )
					);

				}

				if ( hasFaceColor ) {

					faces.push( getColorIndex( face.color ) );

				}

				if ( hasFaceVertexColor ) {

					var vertexColors = face.vertexColors;

					faces.push(
						getColorIndex( vertexColors[ 0 ] ),
						getColorIndex( vertexColors[ 1 ] ),
						getColorIndex( vertexColors[ 2 ] )
					);

				}

			}

			function setBit( value, position, enabled ) {

				return enabled ? value | ( 1 << position ) : value & ( ~ ( 1 << position ) );

			}

			function getNormalIndex( normal ) {

				var hash = normal.x.toString() + normal.y.toString() + normal.z.toString();

				if ( normalsHash[ hash ] !== undefined ) {

					return normalsHash[ hash ];

				}

				normalsHash[ hash ] = normals.length / 3;
				normals.push( normal.x, normal.y, normal.z );

				return normalsHash[ hash ];

			}

			function getColorIndex( color ) {

				var hash = color.r.toString() + color.g.toString() + color.b.toString();

				if ( colorsHash[ hash ] !== undefined ) {

					return colorsHash[ hash ];

				}

				colorsHash[ hash ] = colors.length;
				colors.push( color.getHex() );

				return colorsHash[ hash ];

			}

			function getUvIndex( uv ) {

				var hash = uv.x.toString() + uv.y.toString();

				if ( uvsHash[ hash ] !== undefined ) {

					return uvsHash[ hash ];

				}

				uvsHash[ hash ] = uvs.length / 2;
				uvs.push( uv.x, uv.y );

				return uvsHash[ hash ];

			}

			data.data = {};

			data.data.vertices = vertices;
			data.data.normals = normals;
			if ( colors.length > 0 ) data.data.colors = colors;
			if ( uvs.length > 0 ) data.data.uvs = [ uvs ]; // temporal backward compatibility
			data.data.faces = faces;

			return data;

		},

		clone: function () {

			/*
			// Handle primitives

			var parameters = this.parameters;

			if ( parameters !== undefined ) {

				var values = [];

				for ( var key in parameters ) {

					values.push( parameters[ key ] );

				}

				var geometry = Object.create( this.constructor.prototype );
				this.constructor.apply( geometry, values );
				return geometry;

			}

			return new this.constructor().copy( this );
			*/

			return new Geometry().copy( this );

		},

		copy: function ( source ) {

			this.vertices = [];
			this.faces = [];
			this.faceVertexUvs = [ [] ];
			this.colors = [];

			var vertices = source.vertices;

			for ( var i = 0, il = vertices.length; i < il; i ++ ) {

				this.vertices.push( vertices[ i ].clone() );

			}

			var colors = source.colors;

			for ( var i = 0, il = colors.length; i < il; i ++ ) {

				this.colors.push( colors[ i ].clone() );

			}

			var faces = source.faces;

			for ( var i = 0, il = faces.length; i < il; i ++ ) {

				this.faces.push( faces[ i ].clone() );

			}

			for ( var i = 0, il = source.faceVertexUvs.length; i < il; i ++ ) {

				var faceVertexUvs = source.faceVertexUvs[ i ];

				if ( this.faceVertexUvs[ i ] === undefined ) {

					this.faceVertexUvs[ i ] = [];

				}

				for ( var j = 0, jl = faceVertexUvs.length; j < jl; j ++ ) {

					var uvs = faceVertexUvs[ j ], uvsCopy = [];

					for ( var k = 0, kl = uvs.length; k < kl; k ++ ) {

						var uv = uvs[ k ];

						uvsCopy.push( uv.clone() );

					}

					this.faceVertexUvs[ i ].push( uvsCopy );

				}

			}

			return this;

		},

		dispose: function () {

			this.dispatchEvent( { type: 'dispose' } );

		}

	} );

	var count = 0;
	function GeometryIdCount() { return count++; }

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author mrdoob / http://mrdoob.com/
	 */

	function BufferGeometry() {

		Object.defineProperty( this, 'id', { value: GeometryIdCount() } );

		this.uuid = _Math.generateUUID();

		this.name = '';
		this.type = 'BufferGeometry';

		this.index = null;
		this.attributes = {};

		this.morphAttributes = {};

		this.groups = [];

		this.boundingBox = null;
		this.boundingSphere = null;

		this.drawRange = { start: 0, count: Infinity };

	}

	Object.assign( BufferGeometry.prototype, EventDispatcher.prototype, {

		isBufferGeometry: true,

		getIndex: function () {

			return this.index;

		},

		setIndex: function ( index ) {

			this.index = index;

		},

		addAttribute: function ( name, attribute ) {

			if ( ( attribute && attribute.isBufferAttribute ) === false && ( attribute && attribute.isInterleavedBufferAttribute ) === false ) {

				console.warn( 'THREE.BufferGeometry: .addAttribute() now expects ( name, attribute ).' );

				this.addAttribute( name, new BufferAttribute( arguments[ 1 ], arguments[ 2 ] ) );

				return;

			}

			if ( name === 'index' ) {

				console.warn( 'THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute.' );
				this.setIndex( attribute );

				return;

			}

			this.attributes[ name ] = attribute;

			return this;

		},

		getAttribute: function ( name ) {

			return this.attributes[ name ];

		},

		removeAttribute: function ( name ) {

			delete this.attributes[ name ];

			return this;

		},

		addGroup: function ( start, count, materialIndex ) {

			this.groups.push( {

				start: start,
				count: count,
				materialIndex: materialIndex !== undefined ? materialIndex : 0

			} );

		},

		clearGroups: function () {

			this.groups = [];

		},

		setDrawRange: function ( start, count ) {

			this.drawRange.start = start;
			this.drawRange.count = count;

		},

		applyMatrix: function ( matrix ) {

			var position = this.attributes.position;

			if ( position !== undefined ) {

				matrix.applyToVector3Array( position.array );
				position.needsUpdate = true;

			}

			var normal = this.attributes.normal;

			if ( normal !== undefined ) {

				var normalMatrix = new Matrix3().getNormalMatrix( matrix );

				normalMatrix.applyToVector3Array( normal.array );
				normal.needsUpdate = true;

			}

			if ( this.boundingBox !== null ) {

				this.computeBoundingBox();

			}

			if ( this.boundingSphere !== null ) {

				this.computeBoundingSphere();

			}

			return this;

		},

		rotateX: function () {

			// rotate geometry around world x-axis

			var m1;

			return function rotateX( angle ) {

				if ( m1 === undefined ) m1 = new Matrix4();

				m1.makeRotationX( angle );

				this.applyMatrix( m1 );

				return this;

			};

		}(),

		rotateY: function () {

			// rotate geometry around world y-axis

			var m1;

			return function rotateY( angle ) {

				if ( m1 === undefined ) m1 = new Matrix4();

				m1.makeRotationY( angle );

				this.applyMatrix( m1 );

				return this;

			};

		}(),

		rotateZ: function () {

			// rotate geometry around world z-axis

			var m1;

			return function rotateZ( angle ) {

				if ( m1 === undefined ) m1 = new Matrix4();

				m1.makeRotationZ( angle );

				this.applyMatrix( m1 );

				return this;

			};

		}(),

		translate: function () {

			// translate geometry

			var m1;

			return function translate( x, y, z ) {

				if ( m1 === undefined ) m1 = new Matrix4();

				m1.makeTranslation( x, y, z );

				this.applyMatrix( m1 );

				return this;

			};

		}(),

		scale: function () {

			// scale geometry

			var m1;

			return function scale( x, y, z ) {

				if ( m1 === undefined ) m1 = new Matrix4();

				m1.makeScale( x, y, z );

				this.applyMatrix( m1 );

				return this;

			};

		}(),

		lookAt: function () {

			var obj;

			return function lookAt( vector ) {

				if ( obj === undefined ) obj = new Object3D();

				obj.lookAt( vector );

				obj.updateMatrix();

				this.applyMatrix( obj.matrix );

			};

		}(),

		center: function () {

			this.computeBoundingBox();

			var offset = this.boundingBox.getCenter().negate();

			this.translate( offset.x, offset.y, offset.z );

			return offset;

		},

		setFromObject: function ( object ) {

			// console.log( 'THREE.BufferGeometry.setFromObject(). Converting', object, this );

			var geometry = object.geometry;

			if ( object.isPoints || object.isLine ) {

				var positions = new Float32BufferAttribute( geometry.vertices.length * 3, 3 );
				var colors = new Float32BufferAttribute( geometry.colors.length * 3, 3 );

				this.addAttribute( 'position', positions.copyVector3sArray( geometry.vertices ) );
				this.addAttribute( 'color', colors.copyColorsArray( geometry.colors ) );

				if ( geometry.lineDistances && geometry.lineDistances.length === geometry.vertices.length ) {

					var lineDistances = new Float32BufferAttribute( geometry.lineDistances.length, 1 );

					this.addAttribute( 'lineDistance', lineDistances.copyArray( geometry.lineDistances ) );

				}

				if ( geometry.boundingSphere !== null ) {

					this.boundingSphere = geometry.boundingSphere.clone();

				}

				if ( geometry.boundingBox !== null ) {

					this.boundingBox = geometry.boundingBox.clone();

				}

			} else if ( object.isMesh ) {

				if ( geometry && geometry.isGeometry ) {

					this.fromGeometry( geometry );

				}

			}

			return this;

		},

		updateFromObject: function ( object ) {

			var geometry = object.geometry;

			if ( object.isMesh ) {

				var direct = geometry.__directGeometry;

				if ( geometry.elementsNeedUpdate === true ) {

					direct = undefined;
					geometry.elementsNeedUpdate = false;

				}

				if ( direct === undefined ) {

					return this.fromGeometry( geometry );

				}

				direct.verticesNeedUpdate = geometry.verticesNeedUpdate;
				direct.normalsNeedUpdate = geometry.normalsNeedUpdate;
				direct.colorsNeedUpdate = geometry.colorsNeedUpdate;
				direct.uvsNeedUpdate = geometry.uvsNeedUpdate;
				direct.groupsNeedUpdate = geometry.groupsNeedUpdate;

				geometry.verticesNeedUpdate = false;
				geometry.normalsNeedUpdate = false;
				geometry.colorsNeedUpdate = false;
				geometry.uvsNeedUpdate = false;
				geometry.groupsNeedUpdate = false;

				geometry = direct;

			}

			var attribute;

			if ( geometry.verticesNeedUpdate === true ) {

				attribute = this.attributes.position;

				if ( attribute !== undefined ) {

					attribute.copyVector3sArray( geometry.vertices );
					attribute.needsUpdate = true;

				}

				geometry.verticesNeedUpdate = false;

			}

			if ( geometry.normalsNeedUpdate === true ) {

				attribute = this.attributes.normal;

				if ( attribute !== undefined ) {

					attribute.copyVector3sArray( geometry.normals );
					attribute.needsUpdate = true;

				}

				geometry.normalsNeedUpdate = false;

			}

			if ( geometry.colorsNeedUpdate === true ) {

				attribute = this.attributes.color;

				if ( attribute !== undefined ) {

					attribute.copyColorsArray( geometry.colors );
					attribute.needsUpdate = true;

				}

				geometry.colorsNeedUpdate = false;

			}

			if ( geometry.uvsNeedUpdate ) {

				attribute = this.attributes.uv;

				if ( attribute !== undefined ) {

					attribute.copyVector2sArray( geometry.uvs );
					attribute.needsUpdate = true;

				}

				geometry.uvsNeedUpdate = false;

			}

			if ( geometry.lineDistancesNeedUpdate ) {

				attribute = this.attributes.lineDistance;

				if ( attribute !== undefined ) {

					attribute.copyArray( geometry.lineDistances );
					attribute.needsUpdate = true;

				}

				geometry.lineDistancesNeedUpdate = false;

			}

			if ( geometry.groupsNeedUpdate ) {

				geometry.computeGroups( object.geometry );
				this.groups = geometry.groups;

				geometry.groupsNeedUpdate = false;

			}

			return this;

		},

		fromGeometry: function ( geometry ) {

			geometry.__directGeometry = new DirectGeometry().fromGeometry( geometry );

			return this.fromDirectGeometry( geometry.__directGeometry );

		},

		fromDirectGeometry: function ( geometry ) {

			var positions = new Float32Array( geometry.vertices.length * 3 );
			this.addAttribute( 'position', new BufferAttribute( positions, 3 ).copyVector3sArray( geometry.vertices ) );

			if ( geometry.normals.length > 0 ) {

				var normals = new Float32Array( geometry.normals.length * 3 );
				this.addAttribute( 'normal', new BufferAttribute( normals, 3 ).copyVector3sArray( geometry.normals ) );

			}

			if ( geometry.colors.length > 0 ) {

				var colors = new Float32Array( geometry.colors.length * 3 );
				this.addAttribute( 'color', new BufferAttribute( colors, 3 ).copyColorsArray( geometry.colors ) );

			}

			if ( geometry.uvs.length > 0 ) {

				var uvs = new Float32Array( geometry.uvs.length * 2 );
				this.addAttribute( 'uv', new BufferAttribute( uvs, 2 ).copyVector2sArray( geometry.uvs ) );

			}

			if ( geometry.uvs2.length > 0 ) {

				var uvs2 = new Float32Array( geometry.uvs2.length * 2 );
				this.addAttribute( 'uv2', new BufferAttribute( uvs2, 2 ).copyVector2sArray( geometry.uvs2 ) );

			}

			if ( geometry.indices.length > 0 ) {

				var TypeArray = geometry.vertices.length > 65535 ? Uint32Array : Uint16Array;
				var indices = new TypeArray( geometry.indices.length * 3 );
				this.setIndex( new BufferAttribute( indices, 1 ).copyIndicesArray( geometry.indices ) );

			}

			// groups

			this.groups = geometry.groups;

			// morphs

			for ( var name in geometry.morphTargets ) {

				var array = [];
				var morphTargets = geometry.morphTargets[ name ];

				for ( var i = 0, l = morphTargets.length; i < l; i ++ ) {

					var morphTarget = morphTargets[ i ];

					var attribute = new Float32BufferAttribute( morphTarget.length * 3, 3 );

					array.push( attribute.copyVector3sArray( morphTarget ) );

				}

				this.morphAttributes[ name ] = array;

			}

			// skinning

			if ( geometry.skinIndices.length > 0 ) {

				var skinIndices = new Float32BufferAttribute( geometry.skinIndices.length * 4, 4 );
				this.addAttribute( 'skinIndex', skinIndices.copyVector4sArray( geometry.skinIndices ) );

			}

			if ( geometry.skinWeights.length > 0 ) {

				var skinWeights = new Float32BufferAttribute( geometry.skinWeights.length * 4, 4 );
				this.addAttribute( 'skinWeight', skinWeights.copyVector4sArray( geometry.skinWeights ) );

			}

			//

			if ( geometry.boundingSphere !== null ) {

				this.boundingSphere = geometry.boundingSphere.clone();

			}

			if ( geometry.boundingBox !== null ) {

				this.boundingBox = geometry.boundingBox.clone();

			}

			return this;

		},

		computeBoundingBox: function () {

			if ( this.boundingBox === null ) {

				this.boundingBox = new Box3();

			}

			var position = this.attributes.position;

			if ( position !== undefined ) {

				this.boundingBox.setFromBufferAttribute( position );

			} else {

				this.boundingBox.makeEmpty();

			}

			if ( isNaN( this.boundingBox.min.x ) || isNaN( this.boundingBox.min.y ) || isNaN( this.boundingBox.min.z ) ) {

				console.error( 'THREE.BufferGeometry.computeBoundingBox: Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this );

			}

		},

		computeBoundingSphere: function () {

			var box = new Box3();
			var vector = new Vector3();

			return function computeBoundingSphere() {

				if ( this.boundingSphere === null ) {

					this.boundingSphere = new Sphere();

				}

				var position = this.attributes.position;

				if ( position ) {

					var center = this.boundingSphere.center;

					box.setFromBufferAttribute( position );
					box.getCenter( center );

					// hoping to find a boundingSphere with a radius smaller than the
					// boundingSphere of the boundingBox: sqrt(3) smaller in the best case

					var maxRadiusSq = 0;

					for ( var i = 0, il = position.count; i < il; i ++ ) {

						vector.x = position.getX( i );
						vector.y = position.getY( i );
						vector.z = position.getZ( i );
						maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( vector ) );

					}

					this.boundingSphere.radius = Math.sqrt( maxRadiusSq );

					if ( isNaN( this.boundingSphere.radius ) ) {

						console.error( 'THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this );

					}

				}

			};

		}(),

		computeFaceNormals: function () {

			// backwards compatibility

		},

		computeVertexNormals: function () {

			var index = this.index;
			var attributes = this.attributes;
			var groups = this.groups;

			if ( attributes.position ) {

				var positions = attributes.position.array;

				if ( attributes.normal === undefined ) {

					this.addAttribute( 'normal', new BufferAttribute( new Float32Array( positions.length ), 3 ) );

				} else {

					// reset existing normals to zero

					var array = attributes.normal.array;

					for ( var i = 0, il = array.length; i < il; i ++ ) {

						array[ i ] = 0;

					}

				}

				var normals = attributes.normal.array;

				var vA, vB, vC;
				var pA = new Vector3(), pB = new Vector3(), pC = new Vector3();
				var cb = new Vector3(), ab = new Vector3();

				// indexed elements

				if ( index ) {

					var indices = index.array;

					if ( groups.length === 0 ) {

						this.addGroup( 0, indices.length );

					}

					for ( var j = 0, jl = groups.length; j < jl; ++ j ) {

						var group = groups[ j ];

						var start = group.start;
						var count = group.count;

						for ( var i = start, il = start + count; i < il; i += 3 ) {

							vA = indices[ i + 0 ] * 3;
							vB = indices[ i + 1 ] * 3;
							vC = indices[ i + 2 ] * 3;

							pA.fromArray( positions, vA );
							pB.fromArray( positions, vB );
							pC.fromArray( positions, vC );

							cb.subVectors( pC, pB );
							ab.subVectors( pA, pB );
							cb.cross( ab );

							normals[ vA ] += cb.x;
							normals[ vA + 1 ] += cb.y;
							normals[ vA + 2 ] += cb.z;

							normals[ vB ] += cb.x;
							normals[ vB + 1 ] += cb.y;
							normals[ vB + 2 ] += cb.z;

							normals[ vC ] += cb.x;
							normals[ vC + 1 ] += cb.y;
							normals[ vC + 2 ] += cb.z;

						}

					}

				} else {

					// non-indexed elements (unconnected triangle soup)

					for ( var i = 0, il = positions.length; i < il; i += 9 ) {

						pA.fromArray( positions, i );
						pB.fromArray( positions, i + 3 );
						pC.fromArray( positions, i + 6 );

						cb.subVectors( pC, pB );
						ab.subVectors( pA, pB );
						cb.cross( ab );

						normals[ i ] = cb.x;
						normals[ i + 1 ] = cb.y;
						normals[ i + 2 ] = cb.z;

						normals[ i + 3 ] = cb.x;
						normals[ i + 4 ] = cb.y;
						normals[ i + 5 ] = cb.z;

						normals[ i + 6 ] = cb.x;
						normals[ i + 7 ] = cb.y;
						normals[ i + 8 ] = cb.z;

					}

				}

				this.normalizeNormals();

				attributes.normal.needsUpdate = true;

			}

		},

		merge: function ( geometry, offset ) {

			if ( ( geometry && geometry.isBufferGeometry ) === false ) {

				console.error( 'THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.', geometry );
				return;

			}

			if ( offset === undefined ) offset = 0;

			var attributes = this.attributes;

			for ( var key in attributes ) {

				if ( geometry.attributes[ key ] === undefined ) continue;

				var attribute1 = attributes[ key ];
				var attributeArray1 = attribute1.array;

				var attribute2 = geometry.attributes[ key ];
				var attributeArray2 = attribute2.array;

				var attributeSize = attribute2.itemSize;

				for ( var i = 0, j = attributeSize * offset; i < attributeArray2.length; i ++, j ++ ) {

					attributeArray1[ j ] = attributeArray2[ i ];

				}

			}

			return this;

		},

		normalizeNormals: function () {

			var normals = this.attributes.normal.array;

			var x, y, z, n;

			for ( var i = 0, il = normals.length; i < il; i += 3 ) {

				x = normals[ i ];
				y = normals[ i + 1 ];
				z = normals[ i + 2 ];

				n = 1.0 / Math.sqrt( x * x + y * y + z * z );

				normals[ i ] *= n;
				normals[ i + 1 ] *= n;
				normals[ i + 2 ] *= n;

			}

		},

		toNonIndexed: function () {

			if ( this.index === null ) {

				console.warn( 'THREE.BufferGeometry.toNonIndexed(): Geometry is already non-indexed.' );
				return this;

			}

			var geometry2 = new BufferGeometry();

			var indices = this.index.array;
			var attributes = this.attributes;

			for ( var name in attributes ) {

				var attribute = attributes[ name ];

				var array = attribute.array;
				var itemSize = attribute.itemSize;

				var array2 = new array.constructor( indices.length * itemSize );

				var index = 0, index2 = 0;

				for ( var i = 0, l = indices.length; i < l; i ++ ) {

					index = indices[ i ] * itemSize;

					for ( var j = 0; j < itemSize; j ++ ) {

						array2[ index2 ++ ] = array[ index ++ ];

					}

				}

				geometry2.addAttribute( name, new BufferAttribute( array2, itemSize ) );

			}

			return geometry2;

		},

		toJSON: function () {

			var data = {
				metadata: {
					version: 4.4,
					type: 'BufferGeometry',
					generator: 'BufferGeometry.toJSON'
				}
			};

			// standard BufferGeometry serialization

			data.uuid = this.uuid;
			data.type = this.type;
			if ( this.name !== '' ) data.name = this.name;

			if ( this.parameters !== undefined ) {

				var parameters = this.parameters;

				for ( var key in parameters ) {

					if ( parameters[ key ] !== undefined ) data[ key ] = parameters[ key ];

				}

				return data;

			}

			data.data = { attributes: {} };

			var index = this.index;

			if ( index !== null ) {

				var array = Array.prototype.slice.call( index.array );

				data.data.index = {
					type: index.array.constructor.name,
					array: array
				};

			}

			var attributes = this.attributes;

			for ( var key in attributes ) {

				var attribute = attributes[ key ];

				var array = Array.prototype.slice.call( attribute.array );

				data.data.attributes[ key ] = {
					itemSize: attribute.itemSize,
					type: attribute.array.constructor.name,
					array: array,
					normalized: attribute.normalized
				};

			}

			var groups = this.groups;

			if ( groups.length > 0 ) {

				data.data.groups = JSON.parse( JSON.stringify( groups ) );

			}

			var boundingSphere = this.boundingSphere;

			if ( boundingSphere !== null ) {

				data.data.boundingSphere = {
					center: boundingSphere.center.toArray(),
					radius: boundingSphere.radius
				};

			}

			return data;

		},

		clone: function () {

			/*
			// Handle primitives

			var parameters = this.parameters;

			if ( parameters !== undefined ) {

				var values = [];

				for ( var key in parameters ) {

					values.push( parameters[ key ] );

				}

				var geometry = Object.create( this.constructor.prototype );
				this.constructor.apply( geometry, values );
				return geometry;

			}

			return new this.constructor().copy( this );
			*/

			return new BufferGeometry().copy( this );

		},

		copy: function ( source ) {

			var index = source.index;

			if ( index !== null ) {

				this.setIndex( index.clone() );

			}

			var attributes = source.attributes;

			for ( var name in attributes ) {

				var attribute = attributes[ name ];
				this.addAttribute( name, attribute.clone() );

			}

			var groups = source.groups;

			for ( var i = 0, l = groups.length; i < l; i ++ ) {

				var group = groups[ i ];
				this.addGroup( group.start, group.count, group.materialIndex );

			}

			return this;

		},

		dispose: function () {

			this.dispatchEvent( { type: 'dispose' } );

		}

	} );

	BufferGeometry.MaxIndex = 65535;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 * @author mikael emtinger / http://gomo.se/
	 * @author jonobr1 / http://jonobr1.com/
	 */

	function Mesh( geometry, material ) {

		Object3D.call( this );

		this.type = 'Mesh';

		this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
		this.material = material !== undefined ? material : new MeshBasicMaterial( { color: Math.random() * 0xffffff } );

		this.drawMode = TrianglesDrawMode;

		this.updateMorphTargets();

	}

	Mesh.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: Mesh,

		isMesh: true,

		setDrawMode: function ( value ) {

			this.drawMode = value;

		},

		copy: function ( source ) {

			Object3D.prototype.copy.call( this, source );

			this.drawMode = source.drawMode;

			return this;

		},

		updateMorphTargets: function () {

			var morphTargets = this.geometry.morphTargets;

			if ( morphTargets !== undefined && morphTargets.length > 0 ) {

				this.morphTargetInfluences = [];
				this.morphTargetDictionary = {};

				for ( var m = 0, ml = morphTargets.length; m < ml; m ++ ) {

					this.morphTargetInfluences.push( 0 );
					this.morphTargetDictionary[ morphTargets[ m ].name ] = m;

				}

			}

		},

		raycast: ( function () {

			var inverseMatrix = new Matrix4();
			var ray = new Ray();
			var sphere = new Sphere();

			var vA = new Vector3();
			var vB = new Vector3();
			var vC = new Vector3();

			var tempA = new Vector3();
			var tempB = new Vector3();
			var tempC = new Vector3();

			var uvA = new Vector2();
			var uvB = new Vector2();
			var uvC = new Vector2();

			var barycoord = new Vector3();

			var intersectionPoint = new Vector3();
			var intersectionPointWorld = new Vector3();

			function uvIntersection( point, p1, p2, p3, uv1, uv2, uv3 ) {

				Triangle.barycoordFromPoint( point, p1, p2, p3, barycoord );

				uv1.multiplyScalar( barycoord.x );
				uv2.multiplyScalar( barycoord.y );
				uv3.multiplyScalar( barycoord.z );

				uv1.add( uv2 ).add( uv3 );

				return uv1.clone();

			}

			function checkIntersection( object, raycaster, ray, pA, pB, pC, point ) {

				var intersect;
				var material = object.material;

				if ( material.side === BackSide ) {

					intersect = ray.intersectTriangle( pC, pB, pA, true, point );

				} else {

					intersect = ray.intersectTriangle( pA, pB, pC, material.side !== DoubleSide, point );

				}

				if ( intersect === null ) return null;

				intersectionPointWorld.copy( point );
				intersectionPointWorld.applyMatrix4( object.matrixWorld );

				var distance = raycaster.ray.origin.distanceTo( intersectionPointWorld );

				if ( distance < raycaster.near || distance > raycaster.far ) return null;

				return {
					distance: distance,
					point: intersectionPointWorld.clone(),
					object: object
				};

			}

			function checkBufferGeometryIntersection( object, raycaster, ray, positions, uvs, a, b, c ) {

				vA.fromArray( positions, a * 3 );
				vB.fromArray( positions, b * 3 );
				vC.fromArray( positions, c * 3 );

				var intersection = checkIntersection( object, raycaster, ray, vA, vB, vC, intersectionPoint );

				if ( intersection ) {

					if ( uvs ) {

						uvA.fromArray( uvs, a * 2 );
						uvB.fromArray( uvs, b * 2 );
						uvC.fromArray( uvs, c * 2 );

						intersection.uv = uvIntersection( intersectionPoint,  vA, vB, vC,  uvA, uvB, uvC );

					}

					intersection.face = new Face3( a, b, c, Triangle.normal( vA, vB, vC ) );
					intersection.faceIndex = a;

				}

				return intersection;

			}

			return function raycast( raycaster, intersects ) {

				var geometry = this.geometry;
				var material = this.material;
				var matrixWorld = this.matrixWorld;

				if ( material === undefined ) return;

				// Checking boundingSphere distance to ray

				if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

				sphere.copy( geometry.boundingSphere );
				sphere.applyMatrix4( matrixWorld );

				if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;

				//

				inverseMatrix.getInverse( matrixWorld );
				ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );

				// Check boundingBox before continuing

				if ( geometry.boundingBox !== null ) {

					if ( ray.intersectsBox( geometry.boundingBox ) === false ) return;

				}

				var uvs, intersection;

				if ( geometry.isBufferGeometry ) {

					var a, b, c;
					var index = geometry.index;
					var attributes = geometry.attributes;
					var positions = attributes.position.array;

					if ( attributes.uv !== undefined ) {

						uvs = attributes.uv.array;

					}

					if ( index !== null ) {

						var indices = index.array;

						for ( var i = 0, l = indices.length; i < l; i += 3 ) {

							a = indices[ i ];
							b = indices[ i + 1 ];
							c = indices[ i + 2 ];

							intersection = checkBufferGeometryIntersection( this, raycaster, ray, positions, uvs, a, b, c );

							if ( intersection ) {

								intersection.faceIndex = Math.floor( i / 3 ); // triangle number in indices buffer semantics
								intersects.push( intersection );

							}

						}

					} else {


						for ( var i = 0, l = positions.length; i < l; i += 9 ) {

							a = i / 3;
							b = a + 1;
							c = a + 2;

							intersection = checkBufferGeometryIntersection( this, raycaster, ray, positions, uvs, a, b, c );

							if ( intersection ) {

								intersection.index = a; // triangle number in positions buffer semantics
								intersects.push( intersection );

							}

						}

					}

				} else if ( geometry.isGeometry ) {

					var fvA, fvB, fvC;
					var isFaceMaterial = (material && material.isMultiMaterial);
					var materials = isFaceMaterial === true ? material.materials : null;

					var vertices = geometry.vertices;
					var faces = geometry.faces;
					var faceVertexUvs = geometry.faceVertexUvs[ 0 ];
					if ( faceVertexUvs.length > 0 ) uvs = faceVertexUvs;

					for ( var f = 0, fl = faces.length; f < fl; f ++ ) {

						var face = faces[ f ];
						var faceMaterial = isFaceMaterial === true ? materials[ face.materialIndex ] : material;

						if ( faceMaterial === undefined ) continue;

						fvA = vertices[ face.a ];
						fvB = vertices[ face.b ];
						fvC = vertices[ face.c ];

						if ( faceMaterial.morphTargets === true ) {

							var morphTargets = geometry.morphTargets;
							var morphInfluences = this.morphTargetInfluences;

							vA.set( 0, 0, 0 );
							vB.set( 0, 0, 0 );
							vC.set( 0, 0, 0 );

							for ( var t = 0, tl = morphTargets.length; t < tl; t ++ ) {

								var influence = morphInfluences[ t ];

								if ( influence === 0 ) continue;

								var targets = morphTargets[ t ].vertices;

								vA.addScaledVector( tempA.subVectors( targets[ face.a ], fvA ), influence );
								vB.addScaledVector( tempB.subVectors( targets[ face.b ], fvB ), influence );
								vC.addScaledVector( tempC.subVectors( targets[ face.c ], fvC ), influence );

							}

							vA.add( fvA );
							vB.add( fvB );
							vC.add( fvC );

							fvA = vA;
							fvB = vB;
							fvC = vC;

						}

						intersection = checkIntersection( this, raycaster, ray, fvA, fvB, fvC, intersectionPoint );

						if ( intersection ) {

							if ( uvs ) {

								var uvs_f = uvs[ f ];
								uvA.copy( uvs_f[ 0 ] );
								uvB.copy( uvs_f[ 1 ] );
								uvC.copy( uvs_f[ 2 ] );

								intersection.uv = uvIntersection( intersectionPoint, fvA, fvB, fvC, uvA, uvB, uvC );

							}

							intersection.face = face;
							intersection.faceIndex = f;
							intersects.push( intersection );

						}

					}

				}

			};

		}() ),

		clone: function () {

			return new this.constructor( this.geometry, this.material ).copy( this );

		}

	} );

	/**
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	function BoxBufferGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) {

		BufferGeometry.call( this );

		this.type = 'BoxBufferGeometry';

		this.parameters = {
			width: width,
			height: height,
			depth: depth,
			widthSegments: widthSegments,
			heightSegments: heightSegments,
			depthSegments: depthSegments
		};

		var scope = this;

		// segments
		widthSegments = Math.floor( widthSegments ) || 1;
		heightSegments = Math.floor( heightSegments ) || 1;
		depthSegments = Math.floor( depthSegments ) || 1;

		// these are used to calculate buffer length
		var vertexCount = calculateVertexCount( widthSegments, heightSegments, depthSegments );
		var indexCount = calculateIndexCount( widthSegments, heightSegments, depthSegments );

		// buffers
		var indices = new ( indexCount > 65535 ? Uint32Array : Uint16Array )( indexCount );
		var vertices = new Float32Array( vertexCount * 3 );
		var normals = new Float32Array( vertexCount * 3 );
		var uvs = new Float32Array( vertexCount * 2 );

		// offset variables
		var vertexBufferOffset = 0;
		var uvBufferOffset = 0;
		var indexBufferOffset = 0;
		var numberOfVertices = 0;

		// group variables
		var groupStart = 0;

		// build each side of the box geometry
		buildPlane( 'z', 'y', 'x', - 1, - 1, depth, height,   width,  depthSegments, heightSegments, 0 ); // px
		buildPlane( 'z', 'y', 'x',   1, - 1, depth, height, - width,  depthSegments, heightSegments, 1 ); // nx
		buildPlane( 'x', 'z', 'y',   1,   1, width, depth,    height, widthSegments, depthSegments,  2 ); // py
		buildPlane( 'x', 'z', 'y',   1, - 1, width, depth,  - height, widthSegments, depthSegments,  3 ); // ny
		buildPlane( 'x', 'y', 'z',   1, - 1, width, height,   depth,  widthSegments, heightSegments, 4 ); // pz
		buildPlane( 'x', 'y', 'z', - 1, - 1, width, height, - depth,  widthSegments, heightSegments, 5 ); // nz

		// build geometry
		this.setIndex( new BufferAttribute( indices, 1 ) );
		this.addAttribute( 'position', new BufferAttribute( vertices, 3 ) );
		this.addAttribute( 'normal', new BufferAttribute( normals, 3 ) );
		this.addAttribute( 'uv', new BufferAttribute( uvs, 2 ) );

		// helper functions

		function calculateVertexCount( w, h, d ) {

			var vertices = 0;

			// calculate the amount of vertices for each side (plane)
			vertices += (w + 1) * (h + 1) * 2; // xy
			vertices += (w + 1) * (d + 1) * 2; // xz
			vertices += (d + 1) * (h + 1) * 2; // zy

			return vertices;

		}

		function calculateIndexCount( w, h, d ) {

			var index = 0;

			// calculate the amount of squares for each side
			index += w * h * 2; // xy
			index += w * d * 2; // xz
			index += d * h * 2; // zy

			return index * 6; // two triangles per square => six vertices per square

		}

		function buildPlane( u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex ) {

			var segmentWidth	= width / gridX;
			var segmentHeight = height / gridY;

			var widthHalf = width / 2;
			var heightHalf = height / 2;
			var depthHalf = depth / 2;

			var gridX1 = gridX + 1;
			var gridY1 = gridY + 1;

			var vertexCounter = 0;
			var groupCount = 0;

			var vector = new Vector3();

			// generate vertices, normals and uvs

			for ( var iy = 0; iy < gridY1; iy ++ ) {

				var y = iy * segmentHeight - heightHalf;

				for ( var ix = 0; ix < gridX1; ix ++ ) {

					var x = ix * segmentWidth - widthHalf;

					// set values to correct vector component
					vector[ u ] = x * udir;
					vector[ v ] = y * vdir;
					vector[ w ] = depthHalf;

					// now apply vector to vertex buffer
					vertices[ vertexBufferOffset ] = vector.x;
					vertices[ vertexBufferOffset + 1 ] = vector.y;
					vertices[ vertexBufferOffset + 2 ] = vector.z;

					// set values to correct vector component
					vector[ u ] = 0;
					vector[ v ] = 0;
					vector[ w ] = depth > 0 ? 1 : - 1;

					// now apply vector to normal buffer
					normals[ vertexBufferOffset ] = vector.x;
					normals[ vertexBufferOffset + 1 ] = vector.y;
					normals[ vertexBufferOffset + 2 ] = vector.z;

					// uvs
					uvs[ uvBufferOffset ] = ix / gridX;
					uvs[ uvBufferOffset + 1 ] = 1 - ( iy / gridY );

					// update offsets and counters
					vertexBufferOffset += 3;
					uvBufferOffset += 2;
					vertexCounter += 1;

				}

			}

			// 1. you need three indices to draw a single face
			// 2. a single segment consists of two faces
			// 3. so we need to generate six (2*3) indices per segment

			for ( iy = 0; iy < gridY; iy ++ ) {

				for ( ix = 0; ix < gridX; ix ++ ) {

					// indices
					var a = numberOfVertices + ix + gridX1 * iy;
					var b = numberOfVertices + ix + gridX1 * ( iy + 1 );
					var c = numberOfVertices + ( ix + 1 ) + gridX1 * ( iy + 1 );
					var d = numberOfVertices + ( ix + 1 ) + gridX1 * iy;

					// face one
					indices[ indexBufferOffset ] = a;
					indices[ indexBufferOffset + 1 ] = b;
					indices[ indexBufferOffset + 2 ] = d;

					// face two
					indices[ indexBufferOffset + 3 ] = b;
					indices[ indexBufferOffset + 4 ] = c;
					indices[ indexBufferOffset + 5 ] = d;

					// update offsets and counters
					indexBufferOffset += 6;
					groupCount += 6;

				}

			}

			// add a group to the geometry. this will ensure multi material support
			scope.addGroup( groupStart, groupCount, materialIndex );

			// calculate new start value for groups
			groupStart += groupCount;

			// update total number of vertices
			numberOfVertices += vertexCounter;

		}

	}

	BoxBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	BoxBufferGeometry.prototype.constructor = BoxBufferGeometry;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * based on http://papervision3d.googlecode.com/svn/trunk/as3/trunk/src/org/papervision3d/objects/primitives/Plane.as
	 */

	function PlaneBufferGeometry( width, height, widthSegments, heightSegments ) {

		BufferGeometry.call( this );

		this.type = 'PlaneBufferGeometry';

		this.parameters = {
			width: width,
			height: height,
			widthSegments: widthSegments,
			heightSegments: heightSegments
		};

		var width_half = width / 2;
		var height_half = height / 2;

		var gridX = Math.floor( widthSegments ) || 1;
		var gridY = Math.floor( heightSegments ) || 1;

		var gridX1 = gridX + 1;
		var gridY1 = gridY + 1;

		var segment_width = width / gridX;
		var segment_height = height / gridY;

		var vertices = new Float32Array( gridX1 * gridY1 * 3 );
		var normals = new Float32Array( gridX1 * gridY1 * 3 );
		var uvs = new Float32Array( gridX1 * gridY1 * 2 );

		var offset = 0;
		var offset2 = 0;

		for ( var iy = 0; iy < gridY1; iy ++ ) {

			var y = iy * segment_height - height_half;

			for ( var ix = 0; ix < gridX1; ix ++ ) {

				var x = ix * segment_width - width_half;

				vertices[ offset ] = x;
				vertices[ offset + 1 ] = - y;

				normals[ offset + 2 ] = 1;

				uvs[ offset2 ] = ix / gridX;
				uvs[ offset2 + 1 ] = 1 - ( iy / gridY );

				offset += 3;
				offset2 += 2;

			}

		}

		offset = 0;

		var indices = new ( ( vertices.length / 3 ) > 65535 ? Uint32Array : Uint16Array )( gridX * gridY * 6 );

		for ( var iy = 0; iy < gridY; iy ++ ) {

			for ( var ix = 0; ix < gridX; ix ++ ) {

				var a = ix + gridX1 * iy;
				var b = ix + gridX1 * ( iy + 1 );
				var c = ( ix + 1 ) + gridX1 * ( iy + 1 );
				var d = ( ix + 1 ) + gridX1 * iy;

				indices[ offset ] = a;
				indices[ offset + 1 ] = b;
				indices[ offset + 2 ] = d;

				indices[ offset + 3 ] = b;
				indices[ offset + 4 ] = c;
				indices[ offset + 5 ] = d;

				offset += 6;

			}

		}

		this.setIndex( new BufferAttribute( indices, 1 ) );
		this.addAttribute( 'position', new BufferAttribute( vertices, 3 ) );
		this.addAttribute( 'normal', new BufferAttribute( normals, 3 ) );
		this.addAttribute( 'uv', new BufferAttribute( uvs, 2 ) );

	}

	PlaneBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	PlaneBufferGeometry.prototype.constructor = PlaneBufferGeometry;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author mikael emtinger / http://gomo.se/
	 * @author WestLangley / http://github.com/WestLangley
	*/

	function Camera() {

		Object3D.call( this );

		this.type = 'Camera';

		this.matrixWorldInverse = new Matrix4();
		this.projectionMatrix = new Matrix4();

	}

	Camera.prototype = Object.create( Object3D.prototype );
	Camera.prototype.constructor = Camera;

	Camera.prototype.isCamera = true;

	Camera.prototype.getWorldDirection = function () {

		var quaternion = new Quaternion();

		return function getWorldDirection( optionalTarget ) {

			var result = optionalTarget || new Vector3();

			this.getWorldQuaternion( quaternion );

			return result.set( 0, 0, - 1 ).applyQuaternion( quaternion );

		};

	}();

	Camera.prototype.lookAt = function () {

		// This routine does not support cameras with rotated and/or translated parent(s)

		var m1 = new Matrix4();

		return function lookAt( vector ) {

			m1.lookAt( this.position, vector, this.up );

			this.quaternion.setFromRotationMatrix( m1 );

		};

	}();

	Camera.prototype.clone = function () {

		return new this.constructor().copy( this );

	};

	Camera.prototype.copy = function ( source ) {

		Object3D.prototype.copy.call( this, source );

		this.matrixWorldInverse.copy( source.matrixWorldInverse );
		this.projectionMatrix.copy( source.projectionMatrix );

		return this;

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author greggman / http://games.greggman.com/
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 * @author tschw
	 */

	function PerspectiveCamera( fov, aspect, near, far ) {

		Camera.call( this );

		this.type = 'PerspectiveCamera';

		this.fov = fov !== undefined ? fov : 50;
		this.zoom = 1;

		this.near = near !== undefined ? near : 0.1;
		this.far = far !== undefined ? far : 2000;
		this.focus = 10;

		this.aspect = aspect !== undefined ? aspect : 1;
		this.view = null;

		this.filmGauge = 35;	// width of the film (default in millimeters)
		this.filmOffset = 0;	// horizontal film offset (same unit as gauge)

		this.updateProjectionMatrix();

	}

	PerspectiveCamera.prototype = Object.assign( Object.create( Camera.prototype ), {

		constructor: PerspectiveCamera,

		isPerspectiveCamera: true,

		copy: function ( source ) {

			Camera.prototype.copy.call( this, source );

			this.fov = source.fov;
			this.zoom = source.zoom;

			this.near = source.near;
			this.far = source.far;
			this.focus = source.focus;

			this.aspect = source.aspect;
			this.view = source.view === null ? null : Object.assign( {}, source.view );

			this.filmGauge = source.filmGauge;
			this.filmOffset = source.filmOffset;

			return this;

		},

		/**
		 * Sets the FOV by focal length in respect to the current .filmGauge.
		 *
		 * The default film gauge is 35, so that the focal length can be specified for
		 * a 35mm (full frame) camera.
		 *
		 * Values for focal length and film gauge must have the same unit.
		 */
		setFocalLength: function ( focalLength ) {

			// see http://www.bobatkins.com/photography/technical/field_of_view.html
			var vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;

			this.fov = _Math.RAD2DEG * 2 * Math.atan( vExtentSlope );
			this.updateProjectionMatrix();

		},

		/**
		 * Calculates the focal length from the current .fov and .filmGauge.
		 */
		getFocalLength: function () {

			var vExtentSlope = Math.tan( _Math.DEG2RAD * 0.5 * this.fov );

			return 0.5 * this.getFilmHeight() / vExtentSlope;

		},

		getEffectiveFOV: function () {

			return _Math.RAD2DEG * 2 * Math.atan(
					Math.tan( _Math.DEG2RAD * 0.5 * this.fov ) / this.zoom );

		},

		getFilmWidth: function () {

			// film not completely covered in portrait format (aspect < 1)
			return this.filmGauge * Math.min( this.aspect, 1 );

		},

		getFilmHeight: function () {

			// film not completely covered in landscape format (aspect > 1)
			return this.filmGauge / Math.max( this.aspect, 1 );

		},

		/**
		 * Sets an offset in a larger frustum. This is useful for multi-window or
		 * multi-monitor/multi-machine setups.
		 *
		 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
		 * the monitors are in grid like this
		 *
		 *   +---+---+---+
		 *   | A | B | C |
		 *   +---+---+---+
		 *   | D | E | F |
		 *   +---+---+---+
		 *
		 * then for each monitor you would call it like this
		 *
		 *   var w = 1920;
		 *   var h = 1080;
		 *   var fullWidth = w * 3;
		 *   var fullHeight = h * 2;
		 *
		 *   --A--
		 *   camera.setOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
		 *   --B--
		 *   camera.setOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
		 *   --C--
		 *   camera.setOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
		 *   --D--
		 *   camera.setOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
		 *   --E--
		 *   camera.setOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
		 *   --F--
		 *   camera.setOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
		 *
		 *   Note there is no reason monitors have to be the same size or in a grid.
		 */
		setViewOffset: function ( fullWidth, fullHeight, x, y, width, height ) {

			this.aspect = fullWidth / fullHeight;

			this.view = {
				fullWidth: fullWidth,
				fullHeight: fullHeight,
				offsetX: x,
				offsetY: y,
				width: width,
				height: height
			};

			this.updateProjectionMatrix();

		},

		clearViewOffset: function() {

			this.view = null;
			this.updateProjectionMatrix();

		},

		updateProjectionMatrix: function () {

			var near = this.near,
				top = near * Math.tan(
						_Math.DEG2RAD * 0.5 * this.fov ) / this.zoom,
				height = 2 * top,
				width = this.aspect * height,
				left = - 0.5 * width,
				view = this.view;

			if ( view !== null ) {

				var fullWidth = view.fullWidth,
					fullHeight = view.fullHeight;

				left += view.offsetX * width / fullWidth;
				top -= view.offsetY * height / fullHeight;
				width *= view.width / fullWidth;
				height *= view.height / fullHeight;

			}

			var skew = this.filmOffset;
			if ( skew !== 0 ) left += near * skew / this.getFilmWidth();

			this.projectionMatrix.makeFrustum(
					left, left + width, top - height, top, near, this.far );

		},

		toJSON: function ( meta ) {

			var data = Object3D.prototype.toJSON.call( this, meta );

			data.object.fov = this.fov;
			data.object.zoom = this.zoom;

			data.object.near = this.near;
			data.object.far = this.far;
			data.object.focus = this.focus;

			data.object.aspect = this.aspect;

			if ( this.view !== null ) data.object.view = Object.assign( {}, this.view );

			data.object.filmGauge = this.filmGauge;
			data.object.filmOffset = this.filmOffset;

			return data;

		}

	} );

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author arose / http://github.com/arose
	 */

	function OrthographicCamera( left, right, top, bottom, near, far ) {

		Camera.call( this );

		this.type = 'OrthographicCamera';

		this.zoom = 1;
		this.view = null;

		this.left = left;
		this.right = right;
		this.top = top;
		this.bottom = bottom;

		this.near = ( near !== undefined ) ? near : 0.1;
		this.far = ( far !== undefined ) ? far : 2000;

		this.updateProjectionMatrix();

	}

	OrthographicCamera.prototype = Object.assign( Object.create( Camera.prototype ), {

		constructor: OrthographicCamera,

		isOrthographicCamera: true,

		copy: function ( source ) {

			Camera.prototype.copy.call( this, source );

			this.left = source.left;
			this.right = source.right;
			this.top = source.top;
			this.bottom = source.bottom;
			this.near = source.near;
			this.far = source.far;

			this.zoom = source.zoom;
			this.view = source.view === null ? null : Object.assign( {}, source.view );

			return this;

		},

		setViewOffset: function( fullWidth, fullHeight, x, y, width, height ) {

			this.view = {
				fullWidth: fullWidth,
				fullHeight: fullHeight,
				offsetX: x,
				offsetY: y,
				width: width,
				height: height
			};

			this.updateProjectionMatrix();

		},

		clearViewOffset: function() {

			this.view = null;
			this.updateProjectionMatrix();

		},

		updateProjectionMatrix: function () {

			var dx = ( this.right - this.left ) / ( 2 * this.zoom );
			var dy = ( this.top - this.bottom ) / ( 2 * this.zoom );
			var cx = ( this.right + this.left ) / 2;
			var cy = ( this.top + this.bottom ) / 2;

			var left = cx - dx;
			var right = cx + dx;
			var top = cy + dy;
			var bottom = cy - dy;

			if ( this.view !== null ) {

				var zoomW = this.zoom / ( this.view.width / this.view.fullWidth );
				var zoomH = this.zoom / ( this.view.height / this.view.fullHeight );
				var scaleW = ( this.right - this.left ) / this.view.width;
				var scaleH = ( this.top - this.bottom ) / this.view.height;

				left += scaleW * ( this.view.offsetX / zoomW );
				right = left + scaleW * ( this.view.width / zoomW );
				top -= scaleH * ( this.view.offsetY / zoomH );
				bottom = top - scaleH * ( this.view.height / zoomH );

			}

			this.projectionMatrix.makeOrthographic( left, right, top, bottom, this.near, this.far );

		},

		toJSON: function ( meta ) {

			var data = Object3D.prototype.toJSON.call( this, meta );

			data.object.zoom = this.zoom;
			data.object.left = this.left;
			data.object.right = this.right;
			data.object.top = this.top;
			data.object.bottom = this.bottom;
			data.object.near = this.near;
			data.object.far = this.far;

			if ( this.view !== null ) data.object.view = Object.assign( {}, this.view );

			return data;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLIndexedBufferRenderer( gl, extensions, infoRender ) {

		var mode;

		function setMode( value ) {

			mode = value;

		}

		var type, size;

		function setIndex( index ) {

			if ( index.array instanceof Uint32Array && extensions.get( 'OES_element_index_uint' ) ) {

				type = gl.UNSIGNED_INT;
				size = 4;

			} else if ( index.array instanceof Uint16Array ) {

				type = gl.UNSIGNED_SHORT;
				size = 2;

			} else {
				
				type = gl.UNSIGNED_BYTE;
				size = 1;
			}

		}

		function render( start, count ) {

			gl.drawElements( mode, count, type, start * size );

			infoRender.calls ++;
			infoRender.vertices += count;

			if ( mode === gl.TRIANGLES ) infoRender.faces += count / 3;

		}

		function renderInstances( geometry, start, count ) {

			var extension = extensions.get( 'ANGLE_instanced_arrays' );

			if ( extension === null ) {

				console.error( 'THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
				return;

			}

			extension.drawElementsInstancedANGLE( mode, count, type, start * size, geometry.maxInstancedCount );

			infoRender.calls ++;
			infoRender.vertices += count * geometry.maxInstancedCount;

			if ( mode === gl.TRIANGLES ) infoRender.faces += geometry.maxInstancedCount * count / 3;

		}

		return {

			setMode: setMode,
			setIndex: setIndex,
			render: render,
			renderInstances: renderInstances

		};

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLBufferRenderer( gl, extensions, infoRender ) {

		var mode;

		function setMode( value ) {

			mode = value;

		}

		function render( start, count ) {

			gl.drawArrays( mode, start, count );

			infoRender.calls ++;
			infoRender.vertices += count;

			if ( mode === gl.TRIANGLES ) infoRender.faces += count / 3;

		}

		function renderInstances( geometry ) {

			var extension = extensions.get( 'ANGLE_instanced_arrays' );

			if ( extension === null ) {

				console.error( 'THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
				return;

			}

			var position = geometry.attributes.position;

			var count = 0;

			if ( position.isInterleavedBufferAttribute ) {

				count = position.data.count;

				extension.drawArraysInstancedANGLE( mode, 0, count, geometry.maxInstancedCount );

			} else {

				count = position.count;

				extension.drawArraysInstancedANGLE( mode, 0, count, geometry.maxInstancedCount );

			}

			infoRender.calls ++;
			infoRender.vertices += count * geometry.maxInstancedCount;

			if ( mode === gl.TRIANGLES ) infoRender.faces += geometry.maxInstancedCount * count / 3;

		}

		return {
			setMode: setMode,
			render: render,
			renderInstances: renderInstances
		};

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLLights() {

		var lights = {};

		return {

			get: function ( light ) {

				if ( lights[ light.id ] !== undefined ) {

					return lights[ light.id ];

				}

				var uniforms;

				switch ( light.type ) {

					case 'DirectionalLight':
						uniforms = {
							direction: new Vector3(),
							color: new Color(),

							shadow: false,
							shadowBias: 0,
							shadowRadius: 1,
							shadowMapSize: new Vector2()
						};
						break;

					case 'SpotLight':
						uniforms = {
							position: new Vector3(),
							direction: new Vector3(),
							color: new Color(),
							distance: 0,
							coneCos: 0,
							penumbraCos: 0,
							decay: 0,

							shadow: false,
							shadowBias: 0,
							shadowRadius: 1,
							shadowMapSize: new Vector2()
						};
						break;

					case 'PointLight':
						uniforms = {
							position: new Vector3(),
							color: new Color(),
							distance: 0,
							decay: 0,

							shadow: false,
							shadowBias: 0,
							shadowRadius: 1,
							shadowMapSize: new Vector2()
						};
						break;

					case 'HemisphereLight':
						uniforms = {
							direction: new Vector3(),
							skyColor: new Color(),
							groundColor: new Color()
						};
						break;

					case 'RectAreaLight':
						uniforms = {
							color: new Color(),
							position: new Vector3(),
							halfWidth: new Vector3(),
							halfHeight: new Vector3()
							// TODO (abelnation): set RectAreaLight shadow uniforms
						};
						break;

				}

				lights[ light.id ] = uniforms;

				return uniforms;

			}

		};

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function addLineNumbers( string ) {

		var lines = string.split( '\n' );

		for ( var i = 0; i < lines.length; i ++ ) {

			lines[ i ] = ( i + 1 ) + ': ' + lines[ i ];

		}

		return lines.join( '\n' );

	}

	function WebGLShader( gl, type, string ) {

		var shader = gl.createShader( type );

		gl.shaderSource( shader, string );
		gl.compileShader( shader );

		if ( gl.getShaderParameter( shader, gl.COMPILE_STATUS ) === false ) {

			console.error( 'THREE.WebGLShader: Shader couldn\'t compile.' );

		}

		if ( gl.getShaderInfoLog( shader ) !== '' ) {

			console.warn( 'THREE.WebGLShader: gl.getShaderInfoLog()', type === gl.VERTEX_SHADER ? 'vertex' : 'fragment', gl.getShaderInfoLog( shader ), addLineNumbers( string ) );

		}

		// --enable-privileged-webgl-extension
		// console.log( type, gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );

		return shader;

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	var programIdCount = 0;

	function getEncodingComponents( encoding ) {

		switch ( encoding ) {

			case LinearEncoding:
				return [ 'Linear','( value )' ];
			case sRGBEncoding:
				return [ 'sRGB','( value )' ];
			case RGBEEncoding:
				return [ 'RGBE','( value )' ];
			case RGBM7Encoding:
				return [ 'RGBM','( value, 7.0 )' ];
			case RGBM16Encoding:
				return [ 'RGBM','( value, 16.0 )' ];
			case RGBDEncoding:
				return [ 'RGBD','( value, 256.0 )' ];
			case GammaEncoding:
				return [ 'Gamma','( value, float( GAMMA_FACTOR ) )' ];
			default:
				throw new Error( 'unsupported encoding: ' + encoding );

		}

	}

	function getTexelDecodingFunction( functionName, encoding ) {

		var components = getEncodingComponents( encoding );
		return "vec4 " + functionName + "( vec4 value ) { return " + components[ 0 ] + "ToLinear" + components[ 1 ] + "; }";

	}

	function getTexelEncodingFunction( functionName, encoding ) {

		var components = getEncodingComponents( encoding );
		return "vec4 " + functionName + "( vec4 value ) { return LinearTo" + components[ 0 ] + components[ 1 ] + "; }";

	}

	function getToneMappingFunction( functionName, toneMapping ) {

		var toneMappingName;

		switch ( toneMapping ) {

			case LinearToneMapping:
				toneMappingName = "Linear";
				break;

			case ReinhardToneMapping:
				toneMappingName = "Reinhard";
				break;

			case Uncharted2ToneMapping:
				toneMappingName = "Uncharted2";
				break;

			case CineonToneMapping:
				toneMappingName = "OptimizedCineon";
				break;

			default:
				throw new Error( 'unsupported toneMapping: ' + toneMapping );

		}

		return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";

	}

	function generateExtensions( extensions, parameters, rendererExtensions ) {

		extensions = extensions || {};

		var chunks = [
			( extensions.derivatives || parameters.envMapCubeUV || parameters.bumpMap || parameters.normalMap || parameters.flatShading ) ? '#extension GL_OES_standard_derivatives : enable' : '',
			( extensions.fragDepth || parameters.logarithmicDepthBuffer ) && rendererExtensions.get( 'EXT_frag_depth' ) ? '#extension GL_EXT_frag_depth : enable' : '',
			( extensions.drawBuffers ) && rendererExtensions.get( 'WEBGL_draw_buffers' ) ? '#extension GL_EXT_draw_buffers : require' : '',
			( extensions.shaderTextureLOD || parameters.envMap ) && rendererExtensions.get( 'EXT_shader_texture_lod' ) ? '#extension GL_EXT_shader_texture_lod : enable' : ''
		];

		return chunks.filter( filterEmptyLine ).join( '\n' );

	}

	function generateDefines( defines ) {

		var chunks = [];

		for ( var name in defines ) {

			var value = defines[ name ];

			if ( value === false ) continue;

			chunks.push( '#define ' + name + ' ' + value );

		}

		return chunks.join( '\n' );

	}

	function fetchAttributeLocations( gl, program, identifiers ) {

		var attributes = {};

		var n = gl.getProgramParameter( program, gl.ACTIVE_ATTRIBUTES );

		for ( var i = 0; i < n; i ++ ) {

			var info = gl.getActiveAttrib( program, i );
			var name = info.name;

			// console.log("THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:", name, i );

			attributes[ name ] = gl.getAttribLocation( program, name );

		}

		return attributes;

	}

	function filterEmptyLine( string ) {

		return string !== '';

	}

	function replaceLightNums( string, parameters ) {

		return string
			.replace( /NUM_DIR_LIGHTS/g, parameters.numDirLights )
			.replace( /NUM_SPOT_LIGHTS/g, parameters.numSpotLights )
			.replace( /NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights )
			.replace( /NUM_POINT_LIGHTS/g, parameters.numPointLights )
			.replace( /NUM_HEMI_LIGHTS/g, parameters.numHemiLights );

	}

	function parseIncludes( string ) {

		var pattern = /#include +<([\w\d.]+)>/g;

		function replace( match, include ) {

			var replace = ShaderChunk[ include ];

			if ( replace === undefined ) {

				throw new Error( 'Can not resolve #include <' + include + '>' );

			}

			return parseIncludes( replace );

		}

		return string.replace( pattern, replace );

	}

	function unrollLoops( string ) {

		var pattern = /for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;

		function replace( match, start, end, snippet ) {

			var unroll = '';

			for ( var i = parseInt( start ); i < parseInt( end ); i ++ ) {

				unroll += snippet.replace( /\[ i \]/g, '[ ' + i + ' ]' );

			}

			return unroll;

		}

		return string.replace( pattern, replace );

	}

	function WebGLProgram( renderer, code, material, parameters ) {

		var gl = renderer.context;

		var extensions = material.extensions;
		var defines = material.defines;

		var vertexShader = material.__webglShader.vertexShader;
		var fragmentShader = material.__webglShader.fragmentShader;

		var shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';

		if ( parameters.shadowMapType === PCFShadowMap ) {

			shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';

		} else if ( parameters.shadowMapType === PCFSoftShadowMap ) {

			shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';

		}

		var envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
		var envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
		var envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';

		if ( parameters.envMap ) {

			switch ( material.envMap.mapping ) {

				case CubeReflectionMapping:
				case CubeRefractionMapping:
					envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
					break;

				case CubeUVReflectionMapping:
				case CubeUVRefractionMapping:
					envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
					break;

				case EquirectangularReflectionMapping:
				case EquirectangularRefractionMapping:
					envMapTypeDefine = 'ENVMAP_TYPE_EQUIREC';
					break;

				case SphericalReflectionMapping:
					envMapTypeDefine = 'ENVMAP_TYPE_SPHERE';
					break;

			}

			switch ( material.envMap.mapping ) {

				case CubeRefractionMapping:
				case EquirectangularRefractionMapping:
					envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
					break;

			}

			switch ( material.combine ) {

				case MultiplyOperation:
					envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
					break;

				case MixOperation:
					envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
					break;

				case AddOperation:
					envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
					break;

			}

		}

		var gammaFactorDefine = ( renderer.gammaFactor > 0 ) ? renderer.gammaFactor : 1.0;

		// console.log( 'building new program ' );

		//

		var customExtensions = generateExtensions( extensions, parameters, renderer.extensions );

		var customDefines = generateDefines( defines );

		//

		var program = gl.createProgram();

		var prefixVertex, prefixFragment;

		if ( material.isRawShaderMaterial ) {

			prefixVertex = [

				customDefines,

				'\n'

			].filter( filterEmptyLine ).join( '\n' );

			prefixFragment = [

				customExtensions,
				customDefines,

				'\n'

			].filter( filterEmptyLine ).join( '\n' );

		} else {

			prefixVertex = [

				'precision ' + parameters.precision + ' float;',
				'precision ' + parameters.precision + ' int;',

				'#define SHADER_NAME ' + material.__webglShader.name,

				customDefines,

				parameters.supportsVertexTextures ? '#define VERTEX_TEXTURES' : '',

				'#define GAMMA_FACTOR ' + gammaFactorDefine,

				'#define MAX_BONES ' + parameters.maxBones,

				parameters.map ? '#define USE_MAP' : '',
				parameters.envMap ? '#define USE_ENVMAP' : '',
				parameters.envMap ? '#define ' + envMapModeDefine : '',
				parameters.lightMap ? '#define USE_LIGHTMAP' : '',
				parameters.aoMap ? '#define USE_AOMAP' : '',
				parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
				parameters.bumpMap ? '#define USE_BUMPMAP' : '',
				parameters.normalMap ? '#define USE_NORMALMAP' : '',
				parameters.displacementMap && parameters.supportsVertexTextures ? '#define USE_DISPLACEMENTMAP' : '',
				parameters.specularMap ? '#define USE_SPECULARMAP' : '',
				parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
				parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
				parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
				parameters.vertexColors ? '#define USE_COLOR' : '',

				parameters.flatShading ? '#define FLAT_SHADED' : '',

				parameters.skinning ? '#define USE_SKINNING' : '',
				parameters.useVertexTexture ? '#define BONE_TEXTURE' : '',

				parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
				parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
				parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
				parameters.flipSided ? '#define FLIP_SIDED' : '',

				'#define NUM_CLIPPING_PLANES ' + parameters.numClippingPlanes,

				parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
				parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',

				parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',

				parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
				parameters.logarithmicDepthBuffer && renderer.extensions.get( 'EXT_frag_depth' ) ? '#define USE_LOGDEPTHBUF_EXT' : '',

				'uniform mat4 modelMatrix;',
				'uniform mat4 modelViewMatrix;',
				'uniform mat4 projectionMatrix;',
				'uniform mat4 viewMatrix;',
				'uniform mat3 normalMatrix;',
				'uniform vec3 cameraPosition;',

				'attribute vec3 position;',
				'attribute vec3 normal;',
				'attribute vec2 uv;',

				'#ifdef USE_COLOR',

				'	attribute vec3 color;',

				'#endif',

				'#ifdef USE_MORPHTARGETS',

				'	attribute vec3 morphTarget0;',
				'	attribute vec3 morphTarget1;',
				'	attribute vec3 morphTarget2;',
				'	attribute vec3 morphTarget3;',

				'	#ifdef USE_MORPHNORMALS',

				'		attribute vec3 morphNormal0;',
				'		attribute vec3 morphNormal1;',
				'		attribute vec3 morphNormal2;',
				'		attribute vec3 morphNormal3;',

				'	#else',

				'		attribute vec3 morphTarget4;',
				'		attribute vec3 morphTarget5;',
				'		attribute vec3 morphTarget6;',
				'		attribute vec3 morphTarget7;',

				'	#endif',

				'#endif',

				'#ifdef USE_SKINNING',

				'	attribute vec4 skinIndex;',
				'	attribute vec4 skinWeight;',

				'#endif',

				'\n'

			].filter( filterEmptyLine ).join( '\n' );

			prefixFragment = [

				customExtensions,

				'precision ' + parameters.precision + ' float;',
				'precision ' + parameters.precision + ' int;',

				'#define SHADER_NAME ' + material.__webglShader.name,

				customDefines,

				parameters.alphaTest ? '#define ALPHATEST ' + parameters.alphaTest : '',

				'#define GAMMA_FACTOR ' + gammaFactorDefine,

				( parameters.useFog && parameters.fog ) ? '#define USE_FOG' : '',
				( parameters.useFog && parameters.fogExp ) ? '#define FOG_EXP2' : '',

				parameters.map ? '#define USE_MAP' : '',
				parameters.envMap ? '#define USE_ENVMAP' : '',
				parameters.envMap ? '#define ' + envMapTypeDefine : '',
				parameters.envMap ? '#define ' + envMapModeDefine : '',
				parameters.envMap ? '#define ' + envMapBlendingDefine : '',
				parameters.lightMap ? '#define USE_LIGHTMAP' : '',
				parameters.aoMap ? '#define USE_AOMAP' : '',
				parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
				parameters.bumpMap ? '#define USE_BUMPMAP' : '',
				parameters.normalMap ? '#define USE_NORMALMAP' : '',
				parameters.specularMap ? '#define USE_SPECULARMAP' : '',
				parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
				parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
				parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
				parameters.vertexColors ? '#define USE_COLOR' : '',

				parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',

				parameters.flatShading ? '#define FLAT_SHADED' : '',

				parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
				parameters.flipSided ? '#define FLIP_SIDED' : '',

				'#define NUM_CLIPPING_PLANES ' + parameters.numClippingPlanes,
				'#define UNION_CLIPPING_PLANES ' + (parameters.numClippingPlanes - parameters.numClipIntersection),

				parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
				parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',

				parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : '',

				parameters.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : '',

				parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
				parameters.logarithmicDepthBuffer && renderer.extensions.get( 'EXT_frag_depth' ) ? '#define USE_LOGDEPTHBUF_EXT' : '',

				parameters.envMap && renderer.extensions.get( 'EXT_shader_texture_lod' ) ? '#define TEXTURE_LOD_EXT' : '',

				'uniform mat4 viewMatrix;',
				'uniform vec3 cameraPosition;',

				( parameters.toneMapping !== NoToneMapping ) ? "#define TONE_MAPPING" : '',
				( parameters.toneMapping !== NoToneMapping ) ? ShaderChunk[ 'tonemapping_pars_fragment' ] : '',  // this code is required here because it is used by the toneMapping() function defined below
				( parameters.toneMapping !== NoToneMapping ) ? getToneMappingFunction( "toneMapping", parameters.toneMapping ) : '',

				( parameters.outputEncoding || parameters.mapEncoding || parameters.envMapEncoding || parameters.emissiveMapEncoding ) ? ShaderChunk[ 'encodings_pars_fragment' ] : '', // this code is required here because it is used by the various encoding/decoding function defined below
				parameters.mapEncoding ? getTexelDecodingFunction( 'mapTexelToLinear', parameters.mapEncoding ) : '',
				parameters.envMapEncoding ? getTexelDecodingFunction( 'envMapTexelToLinear', parameters.envMapEncoding ) : '',
				parameters.emissiveMapEncoding ? getTexelDecodingFunction( 'emissiveMapTexelToLinear', parameters.emissiveMapEncoding ) : '',
				parameters.outputEncoding ? getTexelEncodingFunction( "linearToOutputTexel", parameters.outputEncoding ) : '',

				parameters.depthPacking ? "#define DEPTH_PACKING " + material.depthPacking : '',

				'\n'

			].filter( filterEmptyLine ).join( '\n' );

		}

		vertexShader = parseIncludes( vertexShader, parameters );
		vertexShader = replaceLightNums( vertexShader, parameters );

		fragmentShader = parseIncludes( fragmentShader, parameters );
		fragmentShader = replaceLightNums( fragmentShader, parameters );

		if ( ! material.isShaderMaterial ) {

			vertexShader = unrollLoops( vertexShader );
			fragmentShader = unrollLoops( fragmentShader );

		}

		var vertexGlsl = prefixVertex + vertexShader;
		var fragmentGlsl = prefixFragment + fragmentShader;

		// console.log( '*VERTEX*', vertexGlsl );
		// console.log( '*FRAGMENT*', fragmentGlsl );

		var glVertexShader = WebGLShader( gl, gl.VERTEX_SHADER, vertexGlsl );
		var glFragmentShader = WebGLShader( gl, gl.FRAGMENT_SHADER, fragmentGlsl );

		gl.attachShader( program, glVertexShader );
		gl.attachShader( program, glFragmentShader );

		// Force a particular attribute to index 0.

		if ( material.index0AttributeName !== undefined ) {

			gl.bindAttribLocation( program, 0, material.index0AttributeName );

		} else if ( parameters.morphTargets === true ) {

			// programs with morphTargets displace position out of attribute 0
			gl.bindAttribLocation( program, 0, 'position' );

		}

		gl.linkProgram( program );

		var programLog = gl.getProgramInfoLog( program );
		var vertexLog = gl.getShaderInfoLog( glVertexShader );
		var fragmentLog = gl.getShaderInfoLog( glFragmentShader );

		var runnable = true;
		var haveDiagnostics = true;

		// console.log( '**VERTEX**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( glVertexShader ) );
		// console.log( '**FRAGMENT**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( glFragmentShader ) );

		if ( gl.getProgramParameter( program, gl.LINK_STATUS ) === false ) {

			runnable = false;

			console.error( 'THREE.WebGLProgram: shader error: ', gl.getError(), 'gl.VALIDATE_STATUS', gl.getProgramParameter( program, gl.VALIDATE_STATUS ), 'gl.getProgramInfoLog', programLog, vertexLog, fragmentLog );

		} else if ( programLog !== '' ) {

			console.warn( 'THREE.WebGLProgram: gl.getProgramInfoLog()', programLog );

		} else if ( vertexLog === '' || fragmentLog === '' ) {

			haveDiagnostics = false;

		}

		if ( haveDiagnostics ) {

			this.diagnostics = {

				runnable: runnable,
				material: material,

				programLog: programLog,

				vertexShader: {

					log: vertexLog,
					prefix: prefixVertex

				},

				fragmentShader: {

					log: fragmentLog,
					prefix: prefixFragment

				}

			};

		}

		// clean up

		gl.deleteShader( glVertexShader );
		gl.deleteShader( glFragmentShader );

		// set up caching for uniform locations

		var cachedUniforms;

		this.getUniforms = function() {

			if ( cachedUniforms === undefined ) {

				cachedUniforms =
					new WebGLUniforms( gl, program, renderer );

			}

			return cachedUniforms;

		};

		// set up caching for attribute locations

		var cachedAttributes;

		this.getAttributes = function() {

			if ( cachedAttributes === undefined ) {

				cachedAttributes = fetchAttributeLocations( gl, program );

			}

			return cachedAttributes;

		};

		// free resource

		this.destroy = function() {

			gl.deleteProgram( program );
			this.program = undefined;

		};

		// DEPRECATED

		Object.defineProperties( this, {

			uniforms: {
				get: function() {

					console.warn( 'THREE.WebGLProgram: .uniforms is now .getUniforms().' );
					return this.getUniforms();

				}
			},

			attributes: {
				get: function() {

					console.warn( 'THREE.WebGLProgram: .attributes is now .getAttributes().' );
					return this.getAttributes();

				}
			}

		} );


		//

		this.id = programIdCount ++;
		this.code = code;
		this.usedTimes = 1;
		this.program = program;
		this.vertexShader = glVertexShader;
		this.fragmentShader = glFragmentShader;

		return this;

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLPrograms( renderer, capabilities ) {

		var programs = [];

		var shaderIDs = {
			MeshDepthMaterial: 'depth',
			MeshNormalMaterial: 'normal',
			MeshBasicMaterial: 'basic',
			MeshLambertMaterial: 'lambert',
			MeshPhongMaterial: 'phong',
			MeshToonMaterial: 'phong',
			MeshStandardMaterial: 'physical',
			MeshPhysicalMaterial: 'physical',
			LineBasicMaterial: 'basic',
			LineDashedMaterial: 'dashed',
			PointsMaterial: 'points'
		};

		var parameterNames = [
			"precision", "supportsVertexTextures", "map", "mapEncoding", "envMap", "envMapMode", "envMapEncoding",
			"lightMap", "aoMap", "emissiveMap", "emissiveMapEncoding", "bumpMap", "normalMap", "displacementMap", "specularMap",
			"roughnessMap", "metalnessMap", "gradientMap",
			"alphaMap", "combine", "vertexColors", "fog", "useFog", "fogExp",
			"flatShading", "sizeAttenuation", "logarithmicDepthBuffer", "skinning",
			"maxBones", "useVertexTexture", "morphTargets", "morphNormals",
			"maxMorphTargets", "maxMorphNormals", "premultipliedAlpha",
			"numDirLights", "numPointLights", "numSpotLights", "numHemiLights", "numRectAreaLights",
			"shadowMapEnabled", "shadowMapType", "toneMapping", 'physicallyCorrectLights',
			"alphaTest", "doubleSided", "flipSided", "numClippingPlanes", "numClipIntersection", "depthPacking"
		];


		function allocateBones( object ) {

			if ( capabilities.floatVertexTextures && object && object.skeleton && object.skeleton.useVertexTexture ) {

				return 1024;

			} else {

				// default for when object is not specified
				// ( for example when prebuilding shader to be used with multiple objects )
				//
				//  - leave some extra space for other uniforms
				//  - limit here is ANGLE's 254 max uniform vectors
				//    (up to 54 should be safe)

				var nVertexUniforms = capabilities.maxVertexUniforms;
				var nVertexMatrices = Math.floor( ( nVertexUniforms - 20 ) / 4 );

				var maxBones = nVertexMatrices;

				if ( object !== undefined && (object && object.isSkinnedMesh) ) {

					maxBones = Math.min( object.skeleton.bones.length, maxBones );

					if ( maxBones < object.skeleton.bones.length ) {

						console.warn( 'WebGLRenderer: too many bones - ' + object.skeleton.bones.length + ', this GPU supports just ' + maxBones + ' (try OpenGL instead of ANGLE)' );

					}

				}

				return maxBones;

			}

		}

		function getTextureEncodingFromMap( map, gammaOverrideLinear ) {

			var encoding;

			if ( ! map ) {

				encoding = LinearEncoding;

			} else if ( map.isTexture ) {

				encoding = map.encoding;

			} else if ( map.isWebGLRenderTarget ) {

				console.warn( "THREE.WebGLPrograms.getTextureEncodingFromMap: don't use render targets as textures. Use their .texture property instead." );
				encoding = map.texture.encoding;

			}

			// add backwards compatibility for WebGLRenderer.gammaInput/gammaOutput parameter, should probably be removed at some point.
			if ( encoding === LinearEncoding && gammaOverrideLinear ) {

				encoding = GammaEncoding;

			}

			return encoding;

		}

		this.getParameters = function ( material, lights, fog, nClipPlanes, nClipIntersection, object ) {

			var shaderID = shaderIDs[ material.type ];

			// heuristics to create shader parameters according to lights in the scene
			// (not to blow over maxLights budget)

			var maxBones = allocateBones( object );
			var precision = renderer.getPrecision();

			if ( material.precision !== null ) {

				precision = capabilities.getMaxPrecision( material.precision );

				if ( precision !== material.precision ) {

					console.warn( 'THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.' );

				}

			}

			var currentRenderTarget = renderer.getCurrentRenderTarget();

			var parameters = {

				shaderID: shaderID,

				precision: precision,
				supportsVertexTextures: capabilities.vertexTextures,
				outputEncoding: getTextureEncodingFromMap( ( ! currentRenderTarget ) ? null : currentRenderTarget.texture, renderer.gammaOutput ),
				map: !! material.map,
				mapEncoding: getTextureEncodingFromMap( material.map, renderer.gammaInput ),
				envMap: !! material.envMap,
				envMapMode: material.envMap && material.envMap.mapping,
				envMapEncoding: getTextureEncodingFromMap( material.envMap, renderer.gammaInput ),
				envMapCubeUV: ( !! material.envMap ) && ( ( material.envMap.mapping === CubeUVReflectionMapping ) || ( material.envMap.mapping === CubeUVRefractionMapping ) ),
				lightMap: !! material.lightMap,
				aoMap: !! material.aoMap,
				emissiveMap: !! material.emissiveMap,
				emissiveMapEncoding: getTextureEncodingFromMap( material.emissiveMap, renderer.gammaInput ),
				bumpMap: !! material.bumpMap,
				normalMap: !! material.normalMap,
				displacementMap: !! material.displacementMap,
				roughnessMap: !! material.roughnessMap,
				metalnessMap: !! material.metalnessMap,
				specularMap: !! material.specularMap,
				alphaMap: !! material.alphaMap,

				gradientMap: !! material.gradientMap,

				combine: material.combine,

				vertexColors: material.vertexColors,

				fog: !! fog,
				useFog: material.fog,
				fogExp: (fog && fog.isFogExp2),

				flatShading: material.shading === FlatShading,

				sizeAttenuation: material.sizeAttenuation,
				logarithmicDepthBuffer: capabilities.logarithmicDepthBuffer,

				skinning: material.skinning,
				maxBones: maxBones,
				useVertexTexture: capabilities.floatVertexTextures && object && object.skeleton && object.skeleton.useVertexTexture,

				morphTargets: material.morphTargets,
				morphNormals: material.morphNormals,
				maxMorphTargets: renderer.maxMorphTargets,
				maxMorphNormals: renderer.maxMorphNormals,

				numDirLights: lights.directional.length,
				numPointLights: lights.point.length,
				numSpotLights: lights.spot.length,
				numRectAreaLights: lights.rectArea.length,
				numHemiLights: lights.hemi.length,

				numClippingPlanes: nClipPlanes,
				numClipIntersection: nClipIntersection,

				shadowMapEnabled: renderer.shadowMap.enabled && object.receiveShadow && lights.shadows.length > 0,
				shadowMapType: renderer.shadowMap.type,

				toneMapping: renderer.toneMapping,
				physicallyCorrectLights: renderer.physicallyCorrectLights,

				premultipliedAlpha: material.premultipliedAlpha,

				alphaTest: material.alphaTest,
				doubleSided: material.side === DoubleSide,
				flipSided: material.side === BackSide,

				depthPacking: ( material.depthPacking !== undefined ) ? material.depthPacking : false

			};

			return parameters;

		};

		this.getProgramCode = function ( material, parameters ) {

			var array = [];

			if ( parameters.shaderID ) {

				array.push( parameters.shaderID );

			} else {

				array.push( material.fragmentShader );
				array.push( material.vertexShader );

			}

			if ( material.defines !== undefined ) {

				for ( var name in material.defines ) {

					array.push( name );
					array.push( material.defines[ name ] );

				}

			}

			for ( var i = 0; i < parameterNames.length; i ++ ) {

				array.push( parameters[ parameterNames[ i ] ] );

			}

			return array.join();

		};

		this.acquireProgram = function ( material, parameters, code ) {

			var program;

			// Check if code has been already compiled
			for ( var p = 0, pl = programs.length; p < pl; p ++ ) {

				var programInfo = programs[ p ];

				if ( programInfo.code === code ) {

					program = programInfo;
					++ program.usedTimes;

					break;

				}

			}

			if ( program === undefined ) {

				program = new WebGLProgram( renderer, code, material, parameters );
				programs.push( program );

			}

			return program;

		};

		this.releaseProgram = function( program ) {

			if ( -- program.usedTimes === 0 ) {

				// Remove from unordered set
				var i = programs.indexOf( program );
				programs[ i ] = programs[ programs.length - 1 ];
				programs.pop();

				// Free WebGL resources
				program.destroy();

			}

		};

		// Exposed for resource monitoring & error feedback via renderer.info:
		this.programs = programs;

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLGeometries( gl, properties, info ) {

		var geometries = {};

		function onGeometryDispose( event ) {

			var geometry = event.target;
			var buffergeometry = geometries[ geometry.id ];

			if ( buffergeometry.index !== null ) {

				deleteAttribute( buffergeometry.index );

			}

			deleteAttributes( buffergeometry.attributes );

			geometry.removeEventListener( 'dispose', onGeometryDispose );

			delete geometries[ geometry.id ];

			// TODO

			var property = properties.get( geometry );

			if ( property.wireframe ) {

				deleteAttribute( property.wireframe );

			}

			properties.delete( geometry );

			var bufferproperty = properties.get( buffergeometry );

			if ( bufferproperty.wireframe ) {

				deleteAttribute( bufferproperty.wireframe );

			}

			properties.delete( buffergeometry );

			//

			info.memory.geometries --;

		}

		function getAttributeBuffer( attribute ) {

			if ( attribute.isInterleavedBufferAttribute ) {

				return properties.get( attribute.data ).__webglBuffer;

			}

			return properties.get( attribute ).__webglBuffer;

		}

		function deleteAttribute( attribute ) {

			var buffer = getAttributeBuffer( attribute );

			if ( buffer !== undefined ) {

				gl.deleteBuffer( buffer );
				removeAttributeBuffer( attribute );

			}

		}

		function deleteAttributes( attributes ) {

			for ( var name in attributes ) {

				deleteAttribute( attributes[ name ] );

			}

		}

		function removeAttributeBuffer( attribute ) {

			if ( attribute.isInterleavedBufferAttribute ) {

				properties.delete( attribute.data );

			} else {

				properties.delete( attribute );

			}

		}

		return {

			get: function ( object ) {

				var geometry = object.geometry;

				if ( geometries[ geometry.id ] !== undefined ) {

					return geometries[ geometry.id ];

				}

				geometry.addEventListener( 'dispose', onGeometryDispose );

				var buffergeometry;

				if ( geometry.isBufferGeometry ) {

					buffergeometry = geometry;

				} else if ( geometry.isGeometry ) {

					if ( geometry._bufferGeometry === undefined ) {

						geometry._bufferGeometry = new BufferGeometry().setFromObject( object );

					}

					buffergeometry = geometry._bufferGeometry;

				}

				geometries[ geometry.id ] = buffergeometry;

				info.memory.geometries ++;

				return buffergeometry;

			}

		};

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLObjects( gl, properties, info ) {

		var geometries = new WebGLGeometries( gl, properties, info );

		//

		function update( object ) {

			// TODO: Avoid updating twice (when using shadowMap). Maybe add frame counter.

			var geometry = geometries.get( object );

			if ( object.geometry.isGeometry ) {

				geometry.updateFromObject( object );

			}

			var index = geometry.index;
			var attributes = geometry.attributes;

			if ( index !== null ) {

				updateAttribute( index, gl.ELEMENT_ARRAY_BUFFER );

			}

			for ( var name in attributes ) {

				updateAttribute( attributes[ name ], gl.ARRAY_BUFFER );

			}

			// morph targets

			var morphAttributes = geometry.morphAttributes;

			for ( var name in morphAttributes ) {

				var array = morphAttributes[ name ];

				for ( var i = 0, l = array.length; i < l; i ++ ) {

					updateAttribute( array[ i ], gl.ARRAY_BUFFER );

				}

			}

			return geometry;

		}

		function updateAttribute( attribute, bufferType ) {

			var data = ( attribute.isInterleavedBufferAttribute ) ? attribute.data : attribute;

			var attributeProperties = properties.get( data );

			if ( attributeProperties.__webglBuffer === undefined ) {

				createBuffer( attributeProperties, data, bufferType );

			} else if ( attributeProperties.version !== data.version ) {

				updateBuffer( attributeProperties, data, bufferType );

			}

		}

		function createBuffer( attributeProperties, data, bufferType ) {

			attributeProperties.__webglBuffer = gl.createBuffer();
			gl.bindBuffer( bufferType, attributeProperties.__webglBuffer );

			var usage = data.dynamic ? gl.DYNAMIC_DRAW : gl.STATIC_DRAW;

			gl.bufferData( bufferType, data.array, usage );

			var type = gl.FLOAT;
			var array = data.array;

			if ( array instanceof Float32Array ) {

				type = gl.FLOAT;

			} else if ( array instanceof Float64Array ) {

				console.warn( "Unsupported data buffer format: Float64Array" );

			} else if ( array instanceof Uint16Array ) {

				type = gl.UNSIGNED_SHORT;

			} else if ( array instanceof Int16Array ) {

				type = gl.SHORT;

			} else if ( array instanceof Uint32Array ) {

				type = gl.UNSIGNED_INT;

			} else if ( array instanceof Int32Array ) {

				type = gl.INT;

			} else if ( array instanceof Int8Array ) {

				type = gl.BYTE;

			} else if ( array instanceof Uint8Array ) {

				type = gl.UNSIGNED_BYTE;

			}

			attributeProperties.bytesPerElement = array.BYTES_PER_ELEMENT;
			attributeProperties.type = type;
			attributeProperties.version = data.version;

			data.onUploadCallback();

		}

		function updateBuffer( attributeProperties, data, bufferType ) {

			gl.bindBuffer( bufferType, attributeProperties.__webglBuffer );

			if ( data.dynamic === false ) {

				gl.bufferData( bufferType, data.array, gl.STATIC_DRAW );

			} else if ( data.updateRange.count === - 1 ) {

				// Not using update ranges

				gl.bufferSubData( bufferType, 0, data.array );

			} else if ( data.updateRange.count === 0 ) {

				console.error( 'THREE.WebGLObjects.updateBuffer: dynamic THREE.BufferAttribute marked as needsUpdate but updateRange.count is 0, ensure you are using set methods or updating manually.' );

			} else {

				gl.bufferSubData( bufferType, data.updateRange.offset * data.array.BYTES_PER_ELEMENT,
								  data.array.subarray( data.updateRange.offset, data.updateRange.offset + data.updateRange.count ) );

				data.updateRange.count = 0; // reset range

			}

			attributeProperties.version = data.version;

		}

		function getAttributeBuffer( attribute ) {

			if ( attribute.isInterleavedBufferAttribute ) {

				return properties.get( attribute.data ).__webglBuffer;

			}

			return properties.get( attribute ).__webglBuffer;

		}

		function getAttributeProperties( attribute ) {

			if ( attribute.isInterleavedBufferAttribute ) {

				return properties.get( attribute.data );

			}

			return properties.get( attribute );

		}

		function getWireframeAttribute( geometry ) {

			var property = properties.get( geometry );

			if ( property.wireframe !== undefined ) {

				return property.wireframe;

			}

			var indices = [];

			var index = geometry.index;
			var attributes = geometry.attributes;
			var position = attributes.position;

			// console.time( 'wireframe' );

			if ( index !== null ) {

				var edges = {};
				var array = index.array;

				for ( var i = 0, l = array.length; i < l; i += 3 ) {

					var a = array[ i + 0 ];
					var b = array[ i + 1 ];
					var c = array[ i + 2 ];

					indices.push( a, b, b, c, c, a );

				}

			} else {

				var array = attributes.position.array;

				for ( var i = 0, l = ( array.length / 3 ) - 1; i < l; i += 3 ) {

					var a = i + 0;
					var b = i + 1;
					var c = i + 2;

					indices.push( a, b, b, c, c, a );

				}

			}

			// console.timeEnd( 'wireframe' );

			var TypeArray = position.count > 65535 ? Uint32Array : Uint16Array;
			var attribute = new BufferAttribute( new TypeArray( indices ), 1 );

			updateAttribute( attribute, gl.ELEMENT_ARRAY_BUFFER );

			property.wireframe = attribute;

			return attribute;

		}

		return {

			getAttributeBuffer: getAttributeBuffer,
			getAttributeProperties: getAttributeProperties,
			getWireframeAttribute: getWireframeAttribute,

			update: update

		};

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLTextures( _gl, extensions, state, properties, capabilities, paramThreeToGL, info ) {

		var _infoMemory = info.memory;
		var _isWebGL2 = ( typeof WebGL2RenderingContext !== 'undefined' && _gl instanceof WebGL2RenderingContext );

		//

		function clampToMaxSize( image, maxSize ) {

			if ( image.width > maxSize || image.height > maxSize ) {

				// Warning: Scaling through the canvas will only work with images that use
				// premultiplied alpha.

				var scale = maxSize / Math.max( image.width, image.height );

				var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
				canvas.width = Math.floor( image.width * scale );
				canvas.height = Math.floor( image.height * scale );

				var context = canvas.getContext( '2d' );
				context.drawImage( image, 0, 0, image.width, image.height, 0, 0, canvas.width, canvas.height );

				console.warn( 'THREE.WebGLRenderer: image is too big (' + image.width + 'x' + image.height + '). Resized to ' + canvas.width + 'x' + canvas.height, image );

				return canvas;

			}

			return image;

		}

		function isPowerOfTwo( image ) {

			return _Math.isPowerOfTwo( image.width ) && _Math.isPowerOfTwo( image.height );

		}

		function makePowerOfTwo( image ) {

			if ( image instanceof HTMLImageElement || image instanceof HTMLCanvasElement ) {

				var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
				canvas.width = _Math.nearestPowerOfTwo( image.width );
				canvas.height = _Math.nearestPowerOfTwo( image.height );

				var context = canvas.getContext( '2d' );
				context.drawImage( image, 0, 0, canvas.width, canvas.height );

				console.warn( 'THREE.WebGLRenderer: image is not power of two (' + image.width + 'x' + image.height + '). Resized to ' + canvas.width + 'x' + canvas.height, image );

				return canvas;

			}

			return image;

		}

		function textureNeedsPowerOfTwo( texture ) {

			return ( texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping ) ||
				( texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter );

		}

		// Fallback filters for non-power-of-2 textures

		function filterFallback( f ) {

			if ( f === NearestFilter || f === NearestMipMapNearestFilter || f === NearestMipMapLinearFilter ) {

				return _gl.NEAREST;

			}

			return _gl.LINEAR;

		}

		//

		function onTextureDispose( event ) {

			var texture = event.target;

			texture.removeEventListener( 'dispose', onTextureDispose );

			deallocateTexture( texture );

			_infoMemory.textures --;


		}

		function onRenderTargetDispose( event ) {

			var renderTarget = event.target;

			renderTarget.removeEventListener( 'dispose', onRenderTargetDispose );

			deallocateRenderTarget( renderTarget );

			_infoMemory.textures --;

		}

		//

		function deallocateTexture( texture ) {

			var textureProperties = properties.get( texture );

			if ( texture.image && textureProperties.__image__webglTextureCube ) {

				// cube texture

				_gl.deleteTexture( textureProperties.__image__webglTextureCube );

			} else {

				// 2D texture

				if ( textureProperties.__webglInit === undefined ) return;

				_gl.deleteTexture( textureProperties.__webglTexture );

			}

			// remove all webgl properties
			properties.delete( texture );

		}

		function deallocateRenderTarget( renderTarget ) {

			var renderTargetProperties = properties.get( renderTarget );
			var textureProperties = properties.get( renderTarget.texture );

			if ( ! renderTarget ) return;

			if ( textureProperties.__webglTexture !== undefined ) {

				_gl.deleteTexture( textureProperties.__webglTexture );

			}

			if ( renderTarget.depthTexture ) {

				renderTarget.depthTexture.dispose();

			}

			if ( renderTarget.isWebGLRenderTargetCube ) {

				for ( var i = 0; i < 6; i ++ ) {

					_gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer[ i ] );
					if ( renderTargetProperties.__webglDepthbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthbuffer[ i ] );

				}

			} else {

				_gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer );
				if ( renderTargetProperties.__webglDepthbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthbuffer );

			}

			properties.delete( renderTarget.texture );
			properties.delete( renderTarget );

		}

		//



		function setTexture2D( texture, slot ) {

			var textureProperties = properties.get( texture );

			if ( texture.version > 0 && textureProperties.__version !== texture.version ) {

				var image = texture.image;

				if ( image === undefined ) {

					console.warn( 'THREE.WebGLRenderer: Texture marked for update but image is undefined', texture );

				} else if ( image.complete === false ) {

					console.warn( 'THREE.WebGLRenderer: Texture marked for update but image is incomplete', texture );

				} else {

					uploadTexture( textureProperties, texture, slot );
					return;

				}

			}

			state.activeTexture( _gl.TEXTURE0 + slot );
			state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );

		}

		function setTextureCube( texture, slot ) {

			var textureProperties = properties.get( texture );

			if ( texture.image.length === 6 ) {

				if ( texture.version > 0 && textureProperties.__version !== texture.version ) {

					if ( ! textureProperties.__image__webglTextureCube ) {

						texture.addEventListener( 'dispose', onTextureDispose );

						textureProperties.__image__webglTextureCube = _gl.createTexture();

						_infoMemory.textures ++;

					}

					state.activeTexture( _gl.TEXTURE0 + slot );
					state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__image__webglTextureCube );

					_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, texture.flipY );

					var isCompressed = ( texture && texture.isCompressedTexture );
					var isDataTexture = ( texture.image[ 0 ] && texture.image[ 0 ].isDataTexture );

					var cubeImage = [];

					for ( var i = 0; i < 6; i ++ ) {

						if ( ! isCompressed && ! isDataTexture ) {

							cubeImage[ i ] = clampToMaxSize( texture.image[ i ], capabilities.maxCubemapSize );

						} else {

							cubeImage[ i ] = isDataTexture ? texture.image[ i ].image : texture.image[ i ];

						}

					}

					var image = cubeImage[ 0 ],
					isPowerOfTwoImage = isPowerOfTwo( image ),
					glFormat = paramThreeToGL( texture.format ),
					glType = paramThreeToGL( texture.type );

					setTextureParameters( _gl.TEXTURE_CUBE_MAP, texture, isPowerOfTwoImage );

					for ( var i = 0; i < 6; i ++ ) {

						if ( ! isCompressed ) {

							if ( isDataTexture ) {

								state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glFormat, cubeImage[ i ].width, cubeImage[ i ].height, 0, glFormat, glType, cubeImage[ i ].data );

							} else {

								state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glFormat, glFormat, glType, cubeImage[ i ] );

							}

						} else {

							var mipmap, mipmaps = cubeImage[ i ].mipmaps;

							for ( var j = 0, jl = mipmaps.length; j < jl; j ++ ) {

								mipmap = mipmaps[ j ];

								if ( texture.format !== RGBAFormat && texture.format !== RGBFormat ) {

									if ( state.getCompressedTextureFormats().indexOf( glFormat ) > - 1 ) {

										state.compressedTexImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glFormat, mipmap.width, mipmap.height, 0, mipmap.data );

									} else {

										console.warn( "THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()" );

									}

								} else {

									state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

								}

							}

						}

					}

					if ( texture.generateMipmaps && isPowerOfTwoImage ) {

						_gl.generateMipmap( _gl.TEXTURE_CUBE_MAP );

					}

					textureProperties.__version = texture.version;

					if ( texture.onUpdate ) texture.onUpdate( texture );

				} else {

					state.activeTexture( _gl.TEXTURE0 + slot );
					state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__image__webglTextureCube );

				}

			}

		}

		function setTextureCubeDynamic( texture, slot ) {

			state.activeTexture( _gl.TEXTURE0 + slot );
			state.bindTexture( _gl.TEXTURE_CUBE_MAP, properties.get( texture ).__webglTexture );

		}

		function setTextureParameters( textureType, texture, isPowerOfTwoImage ) {

			var extension;

			if ( isPowerOfTwoImage ) {

				_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_S, paramThreeToGL( texture.wrapS ) );
				_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_T, paramThreeToGL( texture.wrapT ) );

				_gl.texParameteri( textureType, _gl.TEXTURE_MAG_FILTER, paramThreeToGL( texture.magFilter ) );
				_gl.texParameteri( textureType, _gl.TEXTURE_MIN_FILTER, paramThreeToGL( texture.minFilter ) );

			} else {

				_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_S, _gl.CLAMP_TO_EDGE );
				_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_T, _gl.CLAMP_TO_EDGE );

				if ( texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping ) {

					console.warn( 'THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.', texture );

				}

				_gl.texParameteri( textureType, _gl.TEXTURE_MAG_FILTER, filterFallback( texture.magFilter ) );
				_gl.texParameteri( textureType, _gl.TEXTURE_MIN_FILTER, filterFallback( texture.minFilter ) );

				if ( texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter ) {

					console.warn( 'THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.', texture );

				}

			}

			extension = extensions.get( 'EXT_texture_filter_anisotropic' );

			if ( extension ) {

				if ( texture.type === FloatType && extensions.get( 'OES_texture_float_linear' ) === null ) return;
				if ( texture.type === HalfFloatType && extensions.get( 'OES_texture_half_float_linear' ) === null ) return;

				if ( texture.anisotropy > 1 || properties.get( texture ).__currentAnisotropy ) {

					_gl.texParameterf( textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min( texture.anisotropy, capabilities.getMaxAnisotropy() ) );
					properties.get( texture ).__currentAnisotropy = texture.anisotropy;

				}

			}

		}

		function uploadTexture( textureProperties, texture, slot ) {

			if ( textureProperties.__webglInit === undefined ) {

				textureProperties.__webglInit = true;

				texture.addEventListener( 'dispose', onTextureDispose );

				textureProperties.__webglTexture = _gl.createTexture();

				_infoMemory.textures ++;

			}

			state.activeTexture( _gl.TEXTURE0 + slot );
			state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );

			_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, texture.flipY );
			_gl.pixelStorei( _gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha );
			_gl.pixelStorei( _gl.UNPACK_ALIGNMENT, texture.unpackAlignment );

			var image = clampToMaxSize( texture.image, capabilities.maxTextureSize );

			if ( textureNeedsPowerOfTwo( texture ) && isPowerOfTwo( image ) === false ) {

				image = makePowerOfTwo( image );

			}

			var isPowerOfTwoImage = isPowerOfTwo( image ),
			glFormat = paramThreeToGL( texture.format ),
			glType = paramThreeToGL( texture.type );

			setTextureParameters( _gl.TEXTURE_2D, texture, isPowerOfTwoImage );

			var mipmap, mipmaps = texture.mipmaps;

			if ( texture.isDepthTexture ) {

				// populate depth texture with dummy data

				var internalFormat = _gl.DEPTH_COMPONENT;

				if ( texture.type === FloatType ) {

					if ( !_isWebGL2 ) throw new Error('Float Depth Texture only supported in WebGL2.0');
					internalFormat = _gl.DEPTH_COMPONENT32F;

				} else if ( _isWebGL2 ) {

					// WebGL 2.0 requires signed internalformat for glTexImage2D
					internalFormat = _gl.DEPTH_COMPONENT16;

				}

				if ( texture.format === DepthFormat && internalFormat === _gl.DEPTH_COMPONENT ) {

					// The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
					// DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
					// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
					if ( texture.type !== UnsignedShortType && texture.type !== UnsignedIntType ) {

					        console.warn( 'THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.' );

						texture.type = UnsignedShortType;
						glType = paramThreeToGL( texture.type );

					}

				}

				// Depth stencil textures need the DEPTH_STENCIL internal format
				// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
				if ( texture.format === DepthStencilFormat ) {

					internalFormat = _gl.DEPTH_STENCIL;

					// The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
					// DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
					// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
					if ( texture.type !== UnsignedInt248Type ) {

					        console.warn( 'THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.' );

						texture.type = UnsignedInt248Type;
						glType = paramThreeToGL( texture.type );

					}

				}

				state.texImage2D( _gl.TEXTURE_2D, 0, internalFormat, image.width, image.height, 0, glFormat, glType, null );

			} else if ( texture.isDataTexture ) {

				// use manually created mipmaps if available
				// if there are no manual mipmaps
				// set 0 level mipmap and then use GL to generate other mipmap levels

				if ( mipmaps.length > 0 && isPowerOfTwoImage ) {

					for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {

						mipmap = mipmaps[ i ];
						state.texImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

					}

					texture.generateMipmaps = false;

				} else {

					state.texImage2D( _gl.TEXTURE_2D, 0, glFormat, image.width, image.height, 0, glFormat, glType, image.data );

				}

			} else if ( texture.isCompressedTexture ) {

				for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {

					mipmap = mipmaps[ i ];

					if ( texture.format !== RGBAFormat && texture.format !== RGBFormat ) {

						if ( state.getCompressedTextureFormats().indexOf( glFormat ) > - 1 ) {

							state.compressedTexImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, mipmap.data );

						} else {

							console.warn( "THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()" );

						}

					} else {

						state.texImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

					}

				}

			} else {

				// regular Texture (image, video, canvas)

				// use manually created mipmaps if available
				// if there are no manual mipmaps
				// set 0 level mipmap and then use GL to generate other mipmap levels

				if ( mipmaps.length > 0 && isPowerOfTwoImage ) {

					for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {

						mipmap = mipmaps[ i ];
						state.texImage2D( _gl.TEXTURE_2D, i, glFormat, glFormat, glType, mipmap );

					}

					texture.generateMipmaps = false;

				} else {

					state.texImage2D( _gl.TEXTURE_2D, 0, glFormat, glFormat, glType, image );

				}

			}

			if ( texture.generateMipmaps && isPowerOfTwoImage ) _gl.generateMipmap( _gl.TEXTURE_2D );

			textureProperties.__version = texture.version;

			if ( texture.onUpdate ) texture.onUpdate( texture );

		}

		// Render targets

		// Setup storage for target texture and bind it to correct framebuffer
		function setupFrameBufferTexture( framebuffer, renderTarget, attachment, textureTarget ) {

			var glFormat = paramThreeToGL( renderTarget.texture.format );
			var glType = paramThreeToGL( renderTarget.texture.type );
			state.texImage2D( textureTarget, 0, glFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null );
			_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );
			_gl.framebufferTexture2D( _gl.FRAMEBUFFER, attachment, textureTarget, properties.get( renderTarget.texture ).__webglTexture, 0 );
			_gl.bindFramebuffer( _gl.FRAMEBUFFER, null );

		}

		// Setup storage for internal depth/stencil buffers and bind to correct framebuffer
		function setupRenderBufferStorage( renderbuffer, renderTarget ) {

			_gl.bindRenderbuffer( _gl.RENDERBUFFER, renderbuffer );

			if ( renderTarget.depthBuffer && ! renderTarget.stencilBuffer ) {

				_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.DEPTH_COMPONENT16, renderTarget.width, renderTarget.height );
				_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer );

			} else if ( renderTarget.depthBuffer && renderTarget.stencilBuffer ) {

				_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.DEPTH_STENCIL, renderTarget.width, renderTarget.height );
				_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer );

			} else {

				// FIXME: We don't support !depth !stencil
				_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.RGBA4, renderTarget.width, renderTarget.height );

			}

			_gl.bindRenderbuffer( _gl.RENDERBUFFER, null );

		}

		// Setup resources for a Depth Texture for a FBO (needs an extension)
		function setupDepthTexture( framebuffer, renderTarget ) {

			var isCube = ( renderTarget && renderTarget.isWebGLRenderTargetCube );
			if ( isCube ) throw new Error('Depth Texture with cube render targets is not supported!');

			_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

			if ( !( renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture ) ) {

				throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');

			}

			// upload an empty depth texture with framebuffer size
			if ( !properties.get( renderTarget.depthTexture ).__webglTexture ||
					renderTarget.depthTexture.image.width !== renderTarget.width ||
					renderTarget.depthTexture.image.height !== renderTarget.height ) {
				renderTarget.depthTexture.image.width = renderTarget.width;
				renderTarget.depthTexture.image.height = renderTarget.height;
				renderTarget.depthTexture.needsUpdate = true;
			}

			setTexture2D( renderTarget.depthTexture, 0 );

			var webglDepthTexture = properties.get( renderTarget.depthTexture ).__webglTexture;

			if ( renderTarget.depthTexture.format === DepthFormat ) {

				_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0 );

			} else if ( renderTarget.depthTexture.format === DepthStencilFormat ) {

				_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0 );

			} else {

				throw new Error('Unknown depthTexture format')

			}

		}

		// Setup GL resources for a non-texture depth buffer
		function setupDepthRenderbuffer( renderTarget ) {

			var renderTargetProperties = properties.get( renderTarget );

			var isCube = ( renderTarget.isWebGLRenderTargetCube === true );

			if ( renderTarget.depthTexture ) {

				if ( isCube ) throw new Error('target.depthTexture not supported in Cube render targets');

				setupDepthTexture( renderTargetProperties.__webglFramebuffer, renderTarget );

			} else {

				if ( isCube ) {

					renderTargetProperties.__webglDepthbuffer = [];

					for ( var i = 0; i < 6; i ++ ) {

						_gl.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[ i ] );
						renderTargetProperties.__webglDepthbuffer[ i ] = _gl.createRenderbuffer();
						setupRenderBufferStorage( renderTargetProperties.__webglDepthbuffer[ i ], renderTarget );

					}

				} else {

					_gl.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer );
					renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
					setupRenderBufferStorage( renderTargetProperties.__webglDepthbuffer, renderTarget );

				}

			}

			_gl.bindFramebuffer( _gl.FRAMEBUFFER, null );

		}

		// Set up GL resources for the render target
		function setupRenderTarget( renderTarget ) {

			var renderTargetProperties = properties.get( renderTarget );
			var textureProperties = properties.get( renderTarget.texture );

			renderTarget.addEventListener( 'dispose', onRenderTargetDispose );

			textureProperties.__webglTexture = _gl.createTexture();

			_infoMemory.textures ++;

			var isCube = ( renderTarget.isWebGLRenderTargetCube === true );
			var isTargetPowerOfTwo = isPowerOfTwo( renderTarget );

			// Setup framebuffer

			if ( isCube ) {

				renderTargetProperties.__webglFramebuffer = [];

				for ( var i = 0; i < 6; i ++ ) {

					renderTargetProperties.__webglFramebuffer[ i ] = _gl.createFramebuffer();

				}

			} else {

				renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();

			}

			// Setup color buffer

			if ( isCube ) {

				state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture );
				setTextureParameters( _gl.TEXTURE_CUBE_MAP, renderTarget.texture, isTargetPowerOfTwo );

				for ( var i = 0; i < 6; i ++ ) {

					setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer[ i ], renderTarget, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i );

				}

				if ( renderTarget.texture.generateMipmaps && isTargetPowerOfTwo ) _gl.generateMipmap( _gl.TEXTURE_CUBE_MAP );
				state.bindTexture( _gl.TEXTURE_CUBE_MAP, null );

			} else {

				state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );
				setTextureParameters( _gl.TEXTURE_2D, renderTarget.texture, isTargetPowerOfTwo );
				setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer, renderTarget, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D );

				if ( renderTarget.texture.generateMipmaps && isTargetPowerOfTwo ) _gl.generateMipmap( _gl.TEXTURE_2D );
				state.bindTexture( _gl.TEXTURE_2D, null );

			}

			// Setup depth and stencil buffers

			if ( renderTarget.depthBuffer ) {

				setupDepthRenderbuffer( renderTarget );

			}

		}

		function updateRenderTargetMipmap( renderTarget ) {

			var texture = renderTarget.texture;

			if ( texture.generateMipmaps && isPowerOfTwo( renderTarget ) &&
					texture.minFilter !== NearestFilter &&
					texture.minFilter !== LinearFilter ) {

				var target = (renderTarget && renderTarget.isWebGLRenderTargetCube) ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
				var webglTexture = properties.get( texture ).__webglTexture;

				state.bindTexture( target, webglTexture );
				_gl.generateMipmap( target );
				state.bindTexture( target, null );

			}

		}

		this.setTexture2D = setTexture2D;
		this.setTextureCube = setTextureCube;
		this.setTextureCubeDynamic = setTextureCubeDynamic;
		this.setupRenderTarget = setupRenderTarget;
		this.updateRenderTargetMipmap = updateRenderTargetMipmap;

	}

	/**
	 * @author fordacious / fordacious.github.io
	 */

	function WebGLProperties() {

		var properties = {};

		return {

			get: function ( object ) {

				var uuid = object.uuid;
				var map = properties[ uuid ];

				if ( map === undefined ) {

					map = {};
					properties[ uuid ] = map;

				}

				return map;

			},

			delete: function ( object ) {

				delete properties[ object.uuid ];

			},

			clear: function () {

				properties = {};

			}

		};

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLState( gl, extensions, paramThreeToGL ) {

		function ColorBuffer() {

			var locked = false;

			var color = new Vector4();
			var currentColorMask = null;
			var currentColorClear = new Vector4();

			return {

				setMask: function ( colorMask ) {

					if ( currentColorMask !== colorMask && ! locked ) {

						gl.colorMask( colorMask, colorMask, colorMask, colorMask );
						currentColorMask = colorMask;

					}

				},

				setLocked: function ( lock ) {

					locked = lock;

				},

				setClear: function ( r, g, b, a, premultipliedAlpha ) {

					if ( premultipliedAlpha === true ) {

						r *= a; g *= a; b *= a;

					}

					color.set( r, g, b, a );

					if ( currentColorClear.equals( color ) === false ) {

						gl.clearColor( r, g, b, a );
						currentColorClear.copy( color );

					}

				},

				reset: function () {

					locked = false;

					currentColorMask = null;
					currentColorClear.set( 0, 0, 0, 1 );

				}

			};

		}

		function DepthBuffer() {

			var locked = false;

			var currentDepthMask = null;
			var currentDepthFunc = null;
			var currentDepthClear = null;

			return {

				setTest: function ( depthTest ) {

					if ( depthTest ) {

						enable( gl.DEPTH_TEST );

					} else {

						disable( gl.DEPTH_TEST );

					}

				},

				setMask: function ( depthMask ) {

					if ( currentDepthMask !== depthMask && ! locked ) {

						gl.depthMask( depthMask );
						currentDepthMask = depthMask;

					}

				},

				setFunc: function ( depthFunc ) {

					if ( currentDepthFunc !== depthFunc ) {

						if ( depthFunc ) {

							switch ( depthFunc ) {

								case NeverDepth:

									gl.depthFunc( gl.NEVER );
									break;

								case AlwaysDepth:

									gl.depthFunc( gl.ALWAYS );
									break;

								case LessDepth:

									gl.depthFunc( gl.LESS );
									break;

								case LessEqualDepth:

									gl.depthFunc( gl.LEQUAL );
									break;

								case EqualDepth:

									gl.depthFunc( gl.EQUAL );
									break;

								case GreaterEqualDepth:

									gl.depthFunc( gl.GEQUAL );
									break;

								case GreaterDepth:

									gl.depthFunc( gl.GREATER );
									break;

								case NotEqualDepth:

									gl.depthFunc( gl.NOTEQUAL );
									break;

								default:

									gl.depthFunc( gl.LEQUAL );

							}

						} else {

							gl.depthFunc( gl.LEQUAL );

						}

						currentDepthFunc = depthFunc;

					}

				},

				setLocked: function ( lock ) {

					locked = lock;

				},

				setClear: function ( depth ) {

					if ( currentDepthClear !== depth ) {

						gl.clearDepth( depth );
						currentDepthClear = depth;

					}

				},

				reset: function () {

					locked = false;

					currentDepthMask = null;
					currentDepthFunc = null;
					currentDepthClear = null;

				}

			};

		}

		function StencilBuffer() {

			var locked = false;

			var currentStencilMask = null;
			var currentStencilFunc = null;
			var currentStencilRef = null;
			var currentStencilFuncMask = null;
			var currentStencilFail = null;
			var currentStencilZFail = null;
			var currentStencilZPass = null;
			var currentStencilClear = null;

			return {

				setTest: function ( stencilTest ) {

					if ( stencilTest ) {

						enable( gl.STENCIL_TEST );

					} else {

						disable( gl.STENCIL_TEST );

					}

				},

				setMask: function ( stencilMask ) {

					if ( currentStencilMask !== stencilMask && ! locked ) {

						gl.stencilMask( stencilMask );
						currentStencilMask = stencilMask;

					}

				},

				setFunc: function ( stencilFunc, stencilRef, stencilMask ) {

					if ( currentStencilFunc !== stencilFunc ||
					     currentStencilRef 	!== stencilRef 	||
					     currentStencilFuncMask !== stencilMask ) {

						gl.stencilFunc( stencilFunc, stencilRef, stencilMask );

						currentStencilFunc = stencilFunc;
						currentStencilRef = stencilRef;
						currentStencilFuncMask = stencilMask;

					}

				},

				setOp: function ( stencilFail, stencilZFail, stencilZPass ) {

					if ( currentStencilFail	 !== stencilFail 	||
					     currentStencilZFail !== stencilZFail ||
					     currentStencilZPass !== stencilZPass ) {

						gl.stencilOp( stencilFail, stencilZFail, stencilZPass );

						currentStencilFail = stencilFail;
						currentStencilZFail = stencilZFail;
						currentStencilZPass = stencilZPass;

					}

				},

				setLocked: function ( lock ) {

					locked = lock;

				},

				setClear: function ( stencil ) {

					if ( currentStencilClear !== stencil ) {

						gl.clearStencil( stencil );
						currentStencilClear = stencil;

					}

				},

				reset: function () {

					locked = false;

					currentStencilMask = null;
					currentStencilFunc = null;
					currentStencilRef = null;
					currentStencilFuncMask = null;
					currentStencilFail = null;
					currentStencilZFail = null;
					currentStencilZPass = null;
					currentStencilClear = null;

				}

			};

		}

		//

		var colorBuffer = new ColorBuffer();
		var depthBuffer = new DepthBuffer();
		var stencilBuffer = new StencilBuffer();

		var maxVertexAttributes = gl.getParameter( gl.MAX_VERTEX_ATTRIBS );
		var newAttributes = new Uint8Array( maxVertexAttributes );
		var enabledAttributes = new Uint8Array( maxVertexAttributes );
		var attributeDivisors = new Uint8Array( maxVertexAttributes );

		var capabilities = {};

		var compressedTextureFormats = null;

		var currentBlending = null;
		var currentBlendEquation = null;
		var currentBlendSrc = null;
		var currentBlendDst = null;
		var currentBlendEquationAlpha = null;
		var currentBlendSrcAlpha = null;
		var currentBlendDstAlpha = null;
		var currentPremultipledAlpha = false;

		var currentFlipSided = null;
		var currentCullFace = null;

		var currentLineWidth = null;

		var currentPolygonOffsetFactor = null;
		var currentPolygonOffsetUnits = null;

		var currentScissorTest = null;

		var maxTextures = gl.getParameter( gl.MAX_TEXTURE_IMAGE_UNITS );

		var version = parseFloat( /^WebGL\ ([0-9])/.exec( gl.getParameter( gl.VERSION ) )[ 1 ] );
		var lineWidthAvailable = parseFloat( version ) >= 1.0;

		var currentTextureSlot = null;
		var currentBoundTextures = {};

		var currentScissor = new Vector4();
		var currentViewport = new Vector4();

		function createTexture( type, target, count ) {

			var data = new Uint8Array( 4 ); // 4 is required to match default unpack alignment of 4.
			var texture = gl.createTexture();

			gl.bindTexture( type, texture );
			gl.texParameteri( type, gl.TEXTURE_MIN_FILTER, gl.NEAREST );
			gl.texParameteri( type, gl.TEXTURE_MAG_FILTER, gl.NEAREST );

			for ( var i = 0; i < count; i ++ ) {

				gl.texImage2D( target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data );

			}

			return texture;

		}

		var emptyTextures = {};
		emptyTextures[ gl.TEXTURE_2D ] = createTexture( gl.TEXTURE_2D, gl.TEXTURE_2D, 1 );
		emptyTextures[ gl.TEXTURE_CUBE_MAP ] = createTexture( gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6 );

		//

		function init() {

			colorBuffer.setClear( 0, 0, 0, 1 );
			depthBuffer.setClear( 1 );
			stencilBuffer.setClear( 0 );

			enable( gl.DEPTH_TEST );
			setDepthFunc( LessEqualDepth );

			setFlipSided( false );
			setCullFace( CullFaceBack );
			enable( gl.CULL_FACE );

			enable( gl.BLEND );
			setBlending( NormalBlending );

		}

		function initAttributes() {

			for ( var i = 0, l = newAttributes.length; i < l; i ++ ) {

				newAttributes[ i ] = 0;

			}

		}

		function enableAttribute( attribute ) {

			newAttributes[ attribute ] = 1;

			if ( enabledAttributes[ attribute ] === 0 ) {

				gl.enableVertexAttribArray( attribute );
				enabledAttributes[ attribute ] = 1;

			}

			if ( attributeDivisors[ attribute ] !== 0 ) {

				var extension = extensions.get( 'ANGLE_instanced_arrays' );

				extension.vertexAttribDivisorANGLE( attribute, 0 );
				attributeDivisors[ attribute ] = 0;

			}

		}

		function enableAttributeAndDivisor( attribute, meshPerAttribute, extension ) {

			newAttributes[ attribute ] = 1;

			if ( enabledAttributes[ attribute ] === 0 ) {

				gl.enableVertexAttribArray( attribute );
				enabledAttributes[ attribute ] = 1;

			}

			if ( attributeDivisors[ attribute ] !== meshPerAttribute ) {

				extension.vertexAttribDivisorANGLE( attribute, meshPerAttribute );
				attributeDivisors[ attribute ] = meshPerAttribute;

			}

		}

		function disableUnusedAttributes() {

			for ( var i = 0, l = enabledAttributes.length; i !== l; ++ i ) {

				if ( enabledAttributes[ i ] !== newAttributes[ i ] ) {

					gl.disableVertexAttribArray( i );
					enabledAttributes[ i ] = 0;

				}

			}

		}

		function enable( id ) {

			if ( capabilities[ id ] !== true ) {

				gl.enable( id );
				capabilities[ id ] = true;

			}

		}

		function disable( id ) {

			if ( capabilities[ id ] !== false ) {

				gl.disable( id );
				capabilities[ id ] = false;

			}

		}

		function getCompressedTextureFormats() {

			if ( compressedTextureFormats === null ) {

				compressedTextureFormats = [];

				if ( extensions.get( 'WEBGL_compressed_texture_pvrtc' ) ||
				     extensions.get( 'WEBGL_compressed_texture_s3tc' ) ||
				     extensions.get( 'WEBGL_compressed_texture_etc1' ) ) {

					var formats = gl.getParameter( gl.COMPRESSED_TEXTURE_FORMATS );

					for ( var i = 0; i < formats.length; i ++ ) {

						compressedTextureFormats.push( formats[ i ] );

					}

				}

			}

			return compressedTextureFormats;

		}

		function setBlending( blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha ) {

			if ( blending !== NoBlending ) {

				enable( gl.BLEND );

			} else {

				disable( gl.BLEND );

			}

			if ( blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha ) {

				if ( blending === AdditiveBlending ) {

					if ( premultipliedAlpha ) {

						gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
						gl.blendFuncSeparate( gl.ONE, gl.ONE, gl.ONE, gl.ONE );

					} else {

						gl.blendEquation( gl.FUNC_ADD );
						gl.blendFunc( gl.SRC_ALPHA, gl.ONE );

					}

				} else if ( blending === SubtractiveBlending ) {

					if ( premultipliedAlpha ) {

						gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
						gl.blendFuncSeparate( gl.ZERO, gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ONE_MINUS_SRC_ALPHA );

					} else {

						gl.blendEquation( gl.FUNC_ADD );
						gl.blendFunc( gl.ZERO, gl.ONE_MINUS_SRC_COLOR );

					}

				} else if ( blending === MultiplyBlending ) {

					if ( premultipliedAlpha ) {

						gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
						gl.blendFuncSeparate( gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA );

					} else {

						gl.blendEquation( gl.FUNC_ADD );
						gl.blendFunc( gl.ZERO, gl.SRC_COLOR );

					}

				} else {

					if ( premultipliedAlpha ) {

						gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
						gl.blendFuncSeparate( gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA );

					} else {

						gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
						gl.blendFuncSeparate( gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA );

					}

				}

				currentBlending = blending;
				currentPremultipledAlpha = premultipliedAlpha;

			}

			if ( blending === CustomBlending ) {

				blendEquationAlpha = blendEquationAlpha || blendEquation;
				blendSrcAlpha = blendSrcAlpha || blendSrc;
				blendDstAlpha = blendDstAlpha || blendDst;

				if ( blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha ) {

					gl.blendEquationSeparate( paramThreeToGL( blendEquation ), paramThreeToGL( blendEquationAlpha ) );

					currentBlendEquation = blendEquation;
					currentBlendEquationAlpha = blendEquationAlpha;

				}

				if ( blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha ) {

					gl.blendFuncSeparate( paramThreeToGL( blendSrc ), paramThreeToGL( blendDst ), paramThreeToGL( blendSrcAlpha ), paramThreeToGL( blendDstAlpha ) );

					currentBlendSrc = blendSrc;
					currentBlendDst = blendDst;
					currentBlendSrcAlpha = blendSrcAlpha;
					currentBlendDstAlpha = blendDstAlpha;

				}

			} else {

				currentBlendEquation = null;
				currentBlendSrc = null;
				currentBlendDst = null;
				currentBlendEquationAlpha = null;
				currentBlendSrcAlpha = null;
				currentBlendDstAlpha = null;

			}

		}

		// TODO Deprecate

		function setColorWrite( colorWrite ) {

			colorBuffer.setMask( colorWrite );

		}

		function setDepthTest( depthTest ) {

			depthBuffer.setTest( depthTest );

		}

		function setDepthWrite( depthWrite ) {

			depthBuffer.setMask( depthWrite );

		}

		function setDepthFunc( depthFunc ) {

			depthBuffer.setFunc( depthFunc );

		}

		function setStencilTest( stencilTest ) {

			stencilBuffer.setTest( stencilTest );

		}

		function setStencilWrite( stencilWrite ) {

			stencilBuffer.setMask( stencilWrite );

		}

		function setStencilFunc( stencilFunc, stencilRef, stencilMask ) {

			stencilBuffer.setFunc( stencilFunc, stencilRef, stencilMask );

		}

		function setStencilOp( stencilFail, stencilZFail, stencilZPass ) {

			stencilBuffer.setOp( stencilFail, stencilZFail, stencilZPass );

		}

		//

		function setFlipSided( flipSided ) {

			if ( currentFlipSided !== flipSided ) {

				if ( flipSided ) {

					gl.frontFace( gl.CW );

				} else {

					gl.frontFace( gl.CCW );

				}

				currentFlipSided = flipSided;

			}

		}

		function setCullFace( cullFace ) {

			if ( cullFace !== CullFaceNone ) {

				enable( gl.CULL_FACE );

				if ( cullFace !== currentCullFace ) {

					if ( cullFace === CullFaceBack ) {

						gl.cullFace( gl.BACK );

					} else if ( cullFace === CullFaceFront ) {

						gl.cullFace( gl.FRONT );

					} else {

						gl.cullFace( gl.FRONT_AND_BACK );

					}

				}

			} else {

				disable( gl.CULL_FACE );

			}

			currentCullFace = cullFace;

		}

		function setLineWidth( width ) {

			if ( width !== currentLineWidth ) {

				if ( lineWidthAvailable ) gl.lineWidth( width );

				currentLineWidth = width;

			}

		}

		function setPolygonOffset( polygonOffset, factor, units ) {

			if ( polygonOffset ) {

				enable( gl.POLYGON_OFFSET_FILL );

				if ( currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units ) {

					gl.polygonOffset( factor, units );

					currentPolygonOffsetFactor = factor;
					currentPolygonOffsetUnits = units;

				}

			} else {

				disable( gl.POLYGON_OFFSET_FILL );

			}

		}

		function getScissorTest() {

			return currentScissorTest;

		}

		function setScissorTest( scissorTest ) {

			currentScissorTest = scissorTest;

			if ( scissorTest ) {

				enable( gl.SCISSOR_TEST );

			} else {

				disable( gl.SCISSOR_TEST );

			}

		}

		// texture

		function activeTexture( webglSlot ) {

			if ( webglSlot === undefined ) webglSlot = gl.TEXTURE0 + maxTextures - 1;

			if ( currentTextureSlot !== webglSlot ) {

				gl.activeTexture( webglSlot );
				currentTextureSlot = webglSlot;

			}

		}

		function bindTexture( webglType, webglTexture ) {

			if ( currentTextureSlot === null ) {

				activeTexture();

			}

			var boundTexture = currentBoundTextures[ currentTextureSlot ];

			if ( boundTexture === undefined ) {

				boundTexture = { type: undefined, texture: undefined };
				currentBoundTextures[ currentTextureSlot ] = boundTexture;

			}

			if ( boundTexture.type !== webglType || boundTexture.texture !== webglTexture ) {

				gl.bindTexture( webglType, webglTexture || emptyTextures[ webglType ] );

				boundTexture.type = webglType;
				boundTexture.texture = webglTexture;

			}

		}

		function compressedTexImage2D() {

			try {

				gl.compressedTexImage2D.apply( gl, arguments );

			} catch ( error ) {

				console.error( error );

			}

		}

		function texImage2D() {

			try {

				gl.texImage2D.apply( gl, arguments );

			} catch ( error ) {

				console.error( error );

			}

		}

		//

		function scissor( scissor ) {

			if ( currentScissor.equals( scissor ) === false ) {

				gl.scissor( scissor.x, scissor.y, scissor.z, scissor.w );
				currentScissor.copy( scissor );

			}

		}

		function viewport( viewport ) {

			if ( currentViewport.equals( viewport ) === false ) {

				gl.viewport( viewport.x, viewport.y, viewport.z, viewport.w );
				currentViewport.copy( viewport );

			}

		}

		//

		function reset() {

			for ( var i = 0; i < enabledAttributes.length; i ++ ) {

				if ( enabledAttributes[ i ] === 1 ) {

					gl.disableVertexAttribArray( i );
					enabledAttributes[ i ] = 0;

				}

			}

			capabilities = {};

			compressedTextureFormats = null;

			currentTextureSlot = null;
			currentBoundTextures = {};

			currentBlending = null;

			currentFlipSided = null;
			currentCullFace = null;

			colorBuffer.reset();
			depthBuffer.reset();
			stencilBuffer.reset();

		}

		return {

			buffers: {
				color: colorBuffer,
				depth: depthBuffer,
				stencil: stencilBuffer
			},

			init: init,
			initAttributes: initAttributes,
			enableAttribute: enableAttribute,
			enableAttributeAndDivisor: enableAttributeAndDivisor,
			disableUnusedAttributes: disableUnusedAttributes,
			enable: enable,
			disable: disable,
			getCompressedTextureFormats: getCompressedTextureFormats,

			setBlending: setBlending,

			setColorWrite: setColorWrite,
			setDepthTest: setDepthTest,
			setDepthWrite: setDepthWrite,
			setDepthFunc: setDepthFunc,
			setStencilTest: setStencilTest,
			setStencilWrite: setStencilWrite,
			setStencilFunc: setStencilFunc,
			setStencilOp: setStencilOp,

			setFlipSided: setFlipSided,
			setCullFace: setCullFace,

			setLineWidth: setLineWidth,
			setPolygonOffset: setPolygonOffset,

			getScissorTest: getScissorTest,
			setScissorTest: setScissorTest,

			activeTexture: activeTexture,
			bindTexture: bindTexture,
			compressedTexImage2D: compressedTexImage2D,
			texImage2D: texImage2D,

			scissor: scissor,
			viewport: viewport,

			reset: reset

		};

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLCapabilities( gl, extensions, parameters ) {

		var maxAnisotropy;

		function getMaxAnisotropy() {

			if ( maxAnisotropy !== undefined ) return maxAnisotropy;

			var extension = extensions.get( 'EXT_texture_filter_anisotropic' );

			if ( extension !== null ) {

				maxAnisotropy = gl.getParameter( extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT );

			} else {

				maxAnisotropy = 0;

			}

			return maxAnisotropy;

		}

		function getMaxPrecision( precision ) {

			if ( precision === 'highp' ) {

				if ( gl.getShaderPrecisionFormat( gl.VERTEX_SHADER, gl.HIGH_FLOAT ).precision > 0 &&
				     gl.getShaderPrecisionFormat( gl.FRAGMENT_SHADER, gl.HIGH_FLOAT ).precision > 0 ) {

					return 'highp';

				}

				precision = 'mediump';

			}

			if ( precision === 'mediump' ) {

				if ( gl.getShaderPrecisionFormat( gl.VERTEX_SHADER, gl.MEDIUM_FLOAT ).precision > 0 &&
				     gl.getShaderPrecisionFormat( gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT ).precision > 0 ) {

					return 'mediump';

				}

			}

			return 'lowp';

		}

		var precision = parameters.precision !== undefined ? parameters.precision : 'highp';
		var maxPrecision = getMaxPrecision( precision );

		if ( maxPrecision !== precision ) {

			console.warn( 'THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.' );
			precision = maxPrecision;

		}

		var logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true && !! extensions.get( 'EXT_frag_depth' );

		var maxTextures = gl.getParameter( gl.MAX_TEXTURE_IMAGE_UNITS );
		var maxVertexTextures = gl.getParameter( gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS );
		var maxTextureSize = gl.getParameter( gl.MAX_TEXTURE_SIZE );
		var maxCubemapSize = gl.getParameter( gl.MAX_CUBE_MAP_TEXTURE_SIZE );

		var maxAttributes = gl.getParameter( gl.MAX_VERTEX_ATTRIBS );
		var maxVertexUniforms = gl.getParameter( gl.MAX_VERTEX_UNIFORM_VECTORS );
		var maxVaryings = gl.getParameter( gl.MAX_VARYING_VECTORS );
		var maxFragmentUniforms = gl.getParameter( gl.MAX_FRAGMENT_UNIFORM_VECTORS );

		var vertexTextures = maxVertexTextures > 0;
		var floatFragmentTextures = !! extensions.get( 'OES_texture_float' );
		var floatVertexTextures = vertexTextures && floatFragmentTextures;

		return {

			getMaxAnisotropy: getMaxAnisotropy,
			getMaxPrecision: getMaxPrecision,

			precision: precision,
			logarithmicDepthBuffer: logarithmicDepthBuffer,

			maxTextures: maxTextures,
			maxVertexTextures: maxVertexTextures,
			maxTextureSize: maxTextureSize,
			maxCubemapSize: maxCubemapSize,

			maxAttributes: maxAttributes,
			maxVertexUniforms: maxVertexUniforms,
			maxVaryings: maxVaryings,
			maxFragmentUniforms: maxFragmentUniforms,

			vertexTextures: vertexTextures,
			floatFragmentTextures: floatFragmentTextures,
			floatVertexTextures: floatVertexTextures

		};

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLExtensions( gl ) {

		var extensions = {};

		return {

			get: function ( name ) {

				if ( extensions[ name ] !== undefined ) {

					return extensions[ name ];

				}

				var extension;

				switch ( name ) {

					case 'WEBGL_depth_texture':
						extension = gl.getExtension( 'WEBGL_depth_texture' ) || gl.getExtension( 'MOZ_WEBGL_depth_texture' ) || gl.getExtension( 'WEBKIT_WEBGL_depth_texture' );
						break;

					case 'EXT_texture_filter_anisotropic':
						extension = gl.getExtension( 'EXT_texture_filter_anisotropic' ) || gl.getExtension( 'MOZ_EXT_texture_filter_anisotropic' ) || gl.getExtension( 'WEBKIT_EXT_texture_filter_anisotropic' );
						break;

					case 'WEBGL_compressed_texture_s3tc':
						extension = gl.getExtension( 'WEBGL_compressed_texture_s3tc' ) || gl.getExtension( 'MOZ_WEBGL_compressed_texture_s3tc' ) || gl.getExtension( 'WEBKIT_WEBGL_compressed_texture_s3tc' );
						break;

					case 'WEBGL_compressed_texture_pvrtc':
						extension = gl.getExtension( 'WEBGL_compressed_texture_pvrtc' ) || gl.getExtension( 'WEBKIT_WEBGL_compressed_texture_pvrtc' );
						break;

					case 'WEBGL_compressed_texture_etc1':
						extension = gl.getExtension( 'WEBGL_compressed_texture_etc1' );
						break;

					default:
						extension = gl.getExtension( name );

				}

				if ( extension === null ) {

					console.warn( 'THREE.WebGLRenderer: ' + name + ' extension not supported.' );

				}

				extensions[ name ] = extension;

				return extension;

			}

		};

	}

	/**
	 * @author tschw
	 */

	function WebGLClipping() {

		var scope = this,

			globalState = null,
			numGlobalPlanes = 0,
			localClippingEnabled = false,
			renderingShadows = false,

			plane = new Plane(),
			viewNormalMatrix = new Matrix3(),

			uniform = { value: null, needsUpdate: false };

		this.uniform = uniform;
		this.numPlanes = 0;
		this.numIntersection = 0;

		this.init = function( planes, enableLocalClipping, camera ) {

			var enabled =
				planes.length !== 0 ||
				enableLocalClipping ||
				// enable state of previous frame - the clipping code has to
				// run another frame in order to reset the state:
				numGlobalPlanes !== 0 ||
				localClippingEnabled;

			localClippingEnabled = enableLocalClipping;

			globalState = projectPlanes( planes, camera, 0 );
			numGlobalPlanes = planes.length;

			return enabled;

		};

		this.beginShadows = function() {

			renderingShadows = true;
			projectPlanes( null );

		};

		this.endShadows = function() {

			renderingShadows = false;
			resetGlobalState();

		};

		this.setState = function( planes, clipIntersection, clipShadows, camera, cache, fromCache ) {

			if ( ! localClippingEnabled ||
					planes === null || planes.length === 0 ||
					renderingShadows && ! clipShadows ) {
				// there's no local clipping

				if ( renderingShadows ) {
					// there's no global clipping

					projectPlanes( null );

				} else {

					resetGlobalState();
				}

			} else {

				var nGlobal = renderingShadows ? 0 : numGlobalPlanes,
					lGlobal = nGlobal * 4,

					dstArray = cache.clippingState || null;

				uniform.value = dstArray; // ensure unique state

				dstArray = projectPlanes( planes, camera, lGlobal, fromCache );

				for ( var i = 0; i !== lGlobal; ++ i ) {

					dstArray[ i ] = globalState[ i ];

				}

				cache.clippingState = dstArray;
				this.numIntersection = clipIntersection ? this.numPlanes : 0;
				this.numPlanes += nGlobal;

			}


		};

		function resetGlobalState() {

			if ( uniform.value !== globalState ) {

				uniform.value = globalState;
				uniform.needsUpdate = numGlobalPlanes > 0;

			}

			scope.numPlanes = numGlobalPlanes;
			scope.numIntersection = 0;

		}

		function projectPlanes( planes, camera, dstOffset, skipTransform ) {

			var nPlanes = planes !== null ? planes.length : 0,
				dstArray = null;

			if ( nPlanes !== 0 ) {

				dstArray = uniform.value;

				if ( skipTransform !== true || dstArray === null ) {

					var flatSize = dstOffset + nPlanes * 4,
						viewMatrix = camera.matrixWorldInverse;

					viewNormalMatrix.getNormalMatrix( viewMatrix );

					if ( dstArray === null || dstArray.length < flatSize ) {

						dstArray = new Float32Array( flatSize );

					}

					for ( var i = 0, i4 = dstOffset;
										i !== nPlanes; ++ i, i4 += 4 ) {

						plane.copy( planes[ i ] ).
								applyMatrix4( viewMatrix, viewNormalMatrix );

						plane.normal.toArray( dstArray, i4 );
						dstArray[ i4 + 3 ] = plane.constant;

					}

				}

				uniform.value = dstArray;
				uniform.needsUpdate = true;

			}

			scope.numPlanes = nPlanes;
			
			return dstArray;

		}

	}

	/**
	 * @author supereggbert / http://www.paulbrunt.co.uk/
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 * @author szimek / https://github.com/szimek/
	 * @author tschw
	 */

	function WebGLRenderer( parameters ) {

		console.log( 'THREE.WebGLRenderer', REVISION );

		parameters = parameters || {};

		var _canvas = parameters.canvas !== undefined ? parameters.canvas : document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' ),
			_context = parameters.context !== undefined ? parameters.context : null,

			_alpha = parameters.alpha !== undefined ? parameters.alpha : false,
			_depth = parameters.depth !== undefined ? parameters.depth : true,
			_stencil = parameters.stencil !== undefined ? parameters.stencil : true,
			_antialias = parameters.antialias !== undefined ? parameters.antialias : false,
			_premultipliedAlpha = parameters.premultipliedAlpha !== undefined ? parameters.premultipliedAlpha : true,
			_preserveDrawingBuffer = parameters.preserveDrawingBuffer !== undefined ? parameters.preserveDrawingBuffer : false;

		var lights = [];

		var opaqueObjects = [];
		var opaqueObjectsLastIndex = - 1;
		var transparentObjects = [];
		var transparentObjectsLastIndex = - 1;

		var morphInfluences = new Float32Array( 8 );

		var sprites = [];
		var lensFlares = [];

		// public properties

		this.domElement = _canvas;
		this.context = null;

		// clearing

		this.autoClear = true;
		this.autoClearColor = true;
		this.autoClearDepth = true;
		this.autoClearStencil = true;

		// scene graph

		this.sortObjects = true;

		// user-defined clipping

		this.clippingPlanes = [];
		this.localClippingEnabled = false;

		// physically based shading

		this.gammaFactor = 2.0;	// for backwards compatibility
		this.gammaInput = false;
		this.gammaOutput = false;

		// physical lights

		this.physicallyCorrectLights = false;

		// tone mapping

		this.toneMapping = LinearToneMapping;
		this.toneMappingExposure = 1.0;
		this.toneMappingWhitePoint = 1.0;

		// morphs

		this.maxMorphTargets = 8;
		this.maxMorphNormals = 4;

		// internal properties

		var _this = this,

			// internal state cache

			_currentProgram = null,
			_currentRenderTarget = null,
			_currentFramebuffer = null,
			_currentMaterialId = - 1,
			_currentGeometryProgram = '',
			_currentCamera = null,

			_currentScissor = new Vector4(),
			_currentScissorTest = null,

			_currentViewport = new Vector4(),

			//

			_usedTextureUnits = 0,

			//

			_clearColor = new Color( 0x000000 ),
			_clearAlpha = 0,

			_width = _canvas.width,
			_height = _canvas.height,

			_pixelRatio = 1,

			_scissor = new Vector4( 0, 0, _width, _height ),
			_scissorTest = false,

			_viewport = new Vector4( 0, 0, _width, _height ),

			// frustum

			_frustum = new Frustum(),

			// clipping

			_clipping = new WebGLClipping(),
			_clippingEnabled = false,
			_localClippingEnabled = false,

			_sphere = new Sphere(),

			// camera matrices cache

			_projScreenMatrix = new Matrix4(),

			_vector3 = new Vector3(),
			_matrix4 = new Matrix4(),
			_matrix42 = new Matrix4(),

			// light arrays cache

			_lights = {

				hash: '',

			ambient: [ 0, 0, 0 ],
			directional: [],
			directionalShadowMap: [],
			directionalShadowMatrix: [],
			spot: [],
			spotShadowMap: [],
			spotShadowMatrix: [],
			rectArea: [],
			point: [],
			pointShadowMap: [],
			pointShadowMatrix: [],
			hemi: [],

				shadows: []

			},

			// info

			_infoRender = {

				calls: 0,
				vertices: 0,
				faces: 0,
				points: 0

			};

		this.info = {

			render: _infoRender,
			memory: {

				geometries: 0,
				textures: 0

			},
			programs: null

		};


		// initialize

		var _gl;

		try {

			var attributes = {
				alpha: _alpha,
				depth: _depth,
				stencil: _stencil,
				antialias: _antialias,
				premultipliedAlpha: _premultipliedAlpha,
				preserveDrawingBuffer: _preserveDrawingBuffer
			};

			_gl = _context || _canvas.getContext( 'webgl', attributes ) || _canvas.getContext( 'experimental-webgl', attributes );

			if ( _gl === null ) {

				if ( _canvas.getContext( 'webgl' ) !== null ) {

					throw 'Error creating WebGL context with your selected attributes.';

				} else {

					throw 'Error creating WebGL context.';

				}

			}

			// Some experimental-webgl implementations do not have getShaderPrecisionFormat

			if ( _gl.getShaderPrecisionFormat === undefined ) {

				_gl.getShaderPrecisionFormat = function () {

					return { 'rangeMin': 1, 'rangeMax': 1, 'precision': 1 };

				};

			}

			_canvas.addEventListener( 'webglcontextlost', onContextLost, false );

		} catch ( error ) {

			console.error( 'THREE.WebGLRenderer: ' + error );

		}

		var extensions = new WebGLExtensions( _gl );

		extensions.get( 'WEBGL_depth_texture' );
		extensions.get( 'OES_texture_float' );
		extensions.get( 'OES_texture_float_linear' );
		extensions.get( 'OES_texture_half_float' );
		extensions.get( 'OES_texture_half_float_linear' );
		extensions.get( 'OES_standard_derivatives' );
		extensions.get( 'ANGLE_instanced_arrays' );

		if ( extensions.get( 'OES_element_index_uint' ) ) {

			BufferGeometry.MaxIndex = 4294967296;

		}

		var capabilities = new WebGLCapabilities( _gl, extensions, parameters );

		var state = new WebGLState( _gl, extensions, paramThreeToGL );
		var properties = new WebGLProperties();
		var textures = new WebGLTextures( _gl, extensions, state, properties, capabilities, paramThreeToGL, this.info );
		var objects = new WebGLObjects( _gl, properties, this.info );
		var programCache = new WebGLPrograms( this, capabilities );
		var lightCache = new WebGLLights();

		this.info.programs = programCache.programs;

		var bufferRenderer = new WebGLBufferRenderer( _gl, extensions, _infoRender );
		var indexedBufferRenderer = new WebGLIndexedBufferRenderer( _gl, extensions, _infoRender );

		//

		var backgroundCamera = new OrthographicCamera( - 1, 1, 1, - 1, 0, 1 );
		var backgroundCamera2 = new PerspectiveCamera();
		var backgroundPlaneMesh = new Mesh(
			new PlaneBufferGeometry( 2, 2 ),
			new MeshBasicMaterial( { depthTest: false, depthWrite: false, fog: false } )
		);
		var backgroundBoxShader = ShaderLib[ 'cube' ];
		var backgroundBoxMesh = new Mesh(
			new BoxBufferGeometry( 5, 5, 5 ),
			new ShaderMaterial( {
				uniforms: backgroundBoxShader.uniforms,
				vertexShader: backgroundBoxShader.vertexShader,
				fragmentShader: backgroundBoxShader.fragmentShader,
				side: BackSide,
				depthTest: false,
				depthWrite: false,
				fog: false
			} )
		);

		//

		function getTargetPixelRatio() {

			return _currentRenderTarget === null ? _pixelRatio : 1;

		}

		function setDefaultGLState() {

			state.init();

			state.scissor( _currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio ) );
			state.viewport( _currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio ) );

			state.buffers.color.setClear( _clearColor.r, _clearColor.g, _clearColor.b, _clearAlpha, _premultipliedAlpha );

		}

		function resetGLState() {

			_currentProgram = null;
			_currentCamera = null;

			_currentGeometryProgram = '';
			_currentMaterialId = - 1;

			state.reset();

		}

		setDefaultGLState();

		this.context = _gl;
		this.capabilities = capabilities;
		this.extensions = extensions;
		this.properties = properties;
		this.state = state;

		// shadow map

		var shadowMap = new WebGLShadowMap( this, _lights, objects, capabilities );

		this.shadowMap = shadowMap;


		// Plugins

		var spritePlugin = new SpritePlugin( this, sprites );
		var lensFlarePlugin = new LensFlarePlugin( this, lensFlares );

		// API

		this.getContext = function () {

			return _gl;

		};

		this.getContextAttributes = function () {

			return _gl.getContextAttributes();

		};

		this.forceContextLoss = function () {

			extensions.get( 'WEBGL_lose_context' ).loseContext();

		};

		this.getMaxAnisotropy = function () {

			return capabilities.getMaxAnisotropy();

		};

		this.getPrecision = function () {

			return capabilities.precision;

		};

		this.getPixelRatio = function () {

			return _pixelRatio;

		};

		this.setPixelRatio = function ( value ) {

			if ( value === undefined ) return;

			_pixelRatio = value;

			this.setSize( _viewport.z, _viewport.w, false );

		};

		this.getSize = function () {

			return {
				width: _width,
				height: _height
			};

		};

		this.setSize = function ( width, height, updateStyle ) {

			_width = width;
			_height = height;

			_canvas.width = width * _pixelRatio;
			_canvas.height = height * _pixelRatio;

			if ( updateStyle !== false ) {

				_canvas.style.width = width + 'px';
				_canvas.style.height = height + 'px';

			}

			this.setViewport( 0, 0, width, height );

		};

		this.setViewport = function ( x, y, width, height ) {

			state.viewport( _viewport.set( x, y, width, height ) );

		};

		this.setScissor = function ( x, y, width, height ) {

			state.scissor( _scissor.set( x, y, width, height ) );

		};

		this.setScissorTest = function ( boolean ) {

			state.setScissorTest( _scissorTest = boolean );

		};

		// Clearing

		this.getClearColor = function () {

			return _clearColor;

		};

		this.setClearColor = function ( color, alpha ) {

			_clearColor.set( color );

			_clearAlpha = alpha !== undefined ? alpha : 1;

			state.buffers.color.setClear( _clearColor.r, _clearColor.g, _clearColor.b, _clearAlpha, _premultipliedAlpha );

		};

		this.getClearAlpha = function () {

			return _clearAlpha;

		};

		this.setClearAlpha = function ( alpha ) {

			_clearAlpha = alpha;

			state.buffers.color.setClear( _clearColor.r, _clearColor.g, _clearColor.b, _clearAlpha, _premultipliedAlpha );

		};

		this.clear = function ( color, depth, stencil ) {

			var bits = 0;

			if ( color === undefined || color ) bits |= _gl.COLOR_BUFFER_BIT;
			if ( depth === undefined || depth ) bits |= _gl.DEPTH_BUFFER_BIT;
			if ( stencil === undefined || stencil ) bits |= _gl.STENCIL_BUFFER_BIT;

			_gl.clear( bits );

		};

		this.clearColor = function () {

			this.clear( true, false, false );

		};

		this.clearDepth = function () {

			this.clear( false, true, false );

		};

		this.clearStencil = function () {

			this.clear( false, false, true );

		};

		this.clearTarget = function ( renderTarget, color, depth, stencil ) {

			this.setRenderTarget( renderTarget );
			this.clear( color, depth, stencil );

		};

		// Reset

		this.resetGLState = resetGLState;

		this.dispose = function() {

			transparentObjects = [];
			transparentObjectsLastIndex = -1;
			opaqueObjects = [];
			opaqueObjectsLastIndex = -1;

			_canvas.removeEventListener( 'webglcontextlost', onContextLost, false );

		};

		// Events

		function onContextLost( event ) {

			event.preventDefault();

			resetGLState();
			setDefaultGLState();

			properties.clear();

		}

		function onMaterialDispose( event ) {

			var material = event.target;

			material.removeEventListener( 'dispose', onMaterialDispose );

			deallocateMaterial( material );

		}

		// Buffer deallocation

		function deallocateMaterial( material ) {

			releaseMaterialProgramReference( material );

			properties.delete( material );

		}


		function releaseMaterialProgramReference( material ) {

			var programInfo = properties.get( material ).program;

			material.program = undefined;

			if ( programInfo !== undefined ) {

				programCache.releaseProgram( programInfo );

			}

		}

		// Buffer rendering

		this.renderBufferImmediate = function ( object, program, material ) {

			state.initAttributes();

			var buffers = properties.get( object );

			if ( object.hasPositions && ! buffers.position ) buffers.position = _gl.createBuffer();
			if ( object.hasNormals && ! buffers.normal ) buffers.normal = _gl.createBuffer();
			if ( object.hasUvs && ! buffers.uv ) buffers.uv = _gl.createBuffer();
			if ( object.hasColors && ! buffers.color ) buffers.color = _gl.createBuffer();

			var attributes = program.getAttributes();

			if ( object.hasPositions ) {

				_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.position );
				_gl.bufferData( _gl.ARRAY_BUFFER, object.positionArray, _gl.DYNAMIC_DRAW );

				state.enableAttribute( attributes.position );
				_gl.vertexAttribPointer( attributes.position, 3, _gl.FLOAT, false, 0, 0 );

			}

			if ( object.hasNormals ) {

				_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.normal );

				if ( ! material.isMeshPhongMaterial &&
					! material.isMeshStandardMaterial &&
					! material.isMeshNormalMaterial &&
					material.shading === FlatShading ) {

					for ( var i = 0, l = object.count * 3; i < l; i += 9 ) {

						var array = object.normalArray;

						var nx = ( array[ i + 0 ] + array[ i + 3 ] + array[ i + 6 ] ) / 3;
						var ny = ( array[ i + 1 ] + array[ i + 4 ] + array[ i + 7 ] ) / 3;
						var nz = ( array[ i + 2 ] + array[ i + 5 ] + array[ i + 8 ] ) / 3;

						array[ i + 0 ] = nx;
						array[ i + 1 ] = ny;
						array[ i + 2 ] = nz;

						array[ i + 3 ] = nx;
						array[ i + 4 ] = ny;
						array[ i + 5 ] = nz;

						array[ i + 6 ] = nx;
						array[ i + 7 ] = ny;
						array[ i + 8 ] = nz;

					}

				}

				_gl.bufferData( _gl.ARRAY_BUFFER, object.normalArray, _gl.DYNAMIC_DRAW );

				state.enableAttribute( attributes.normal );

				_gl.vertexAttribPointer( attributes.normal, 3, _gl.FLOAT, false, 0, 0 );

			}

			if ( object.hasUvs && material.map ) {

				_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.uv );
				_gl.bufferData( _gl.ARRAY_BUFFER, object.uvArray, _gl.DYNAMIC_DRAW );

				state.enableAttribute( attributes.uv );

				_gl.vertexAttribPointer( attributes.uv, 2, _gl.FLOAT, false, 0, 0 );

			}

			if ( object.hasColors && material.vertexColors !== NoColors ) {

				_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.color );
				_gl.bufferData( _gl.ARRAY_BUFFER, object.colorArray, _gl.DYNAMIC_DRAW );

				state.enableAttribute( attributes.color );

				_gl.vertexAttribPointer( attributes.color, 3, _gl.FLOAT, false, 0, 0 );

			}

			state.disableUnusedAttributes();

			_gl.drawArrays( _gl.TRIANGLES, 0, object.count );

			object.count = 0;

		};

		this.renderBufferDirect = function ( camera, fog, geometry, material, object, group ) {

			setMaterial( material );

			var program = setProgram( camera, fog, material, object );

			var updateBuffers = false;
			var geometryProgram = geometry.id + '_' + program.id + '_' + material.wireframe;

			if ( geometryProgram !== _currentGeometryProgram ) {

				_currentGeometryProgram = geometryProgram;
				updateBuffers = true;

			}

			// morph targets

			var morphTargetInfluences = object.morphTargetInfluences;

			if ( morphTargetInfluences !== undefined ) {

				var activeInfluences = [];

				for ( var i = 0, l = morphTargetInfluences.length; i < l; i ++ ) {

					var influence = morphTargetInfluences[ i ];
					activeInfluences.push( [ influence, i ] );

				}

				activeInfluences.sort( absNumericalSort );

				if ( activeInfluences.length > 8 ) {

					activeInfluences.length = 8;

				}

				var morphAttributes = geometry.morphAttributes;

				for ( var i = 0, l = activeInfluences.length; i < l; i ++ ) {

					var influence = activeInfluences[ i ];
					morphInfluences[ i ] = influence[ 0 ];

					if ( influence[ 0 ] !== 0 ) {

						var index = influence[ 1 ];

						if ( material.morphTargets === true && morphAttributes.position ) geometry.addAttribute( 'morphTarget' + i, morphAttributes.position[ index ] );
						if ( material.morphNormals === true && morphAttributes.normal ) geometry.addAttribute( 'morphNormal' + i, morphAttributes.normal[ index ] );

					} else {

						if ( material.morphTargets === true ) geometry.removeAttribute( 'morphTarget' + i );
						if ( material.morphNormals === true ) geometry.removeAttribute( 'morphNormal' + i );

					}

				}

				for ( var i = activeInfluences.length, il = morphInfluences.length; i < il; i ++ ) {

					morphInfluences[ i ] = 0.0;

				}

				program.getUniforms().setValue(
					_gl, 'morphTargetInfluences', morphInfluences );

				updateBuffers = true;

			}

			//

			var index = geometry.index;
			var position = geometry.attributes.position;
			var rangeFactor = 1;

			if ( material.wireframe === true ) {

				index = objects.getWireframeAttribute( geometry );
				rangeFactor = 2;

			}

			var renderer;

			if ( index !== null ) {

				renderer = indexedBufferRenderer;
				renderer.setIndex( index );

			} else {

				renderer = bufferRenderer;

			}

			if ( updateBuffers ) {

				setupVertexAttributes( material, program, geometry );

				if ( index !== null ) {

					_gl.bindBuffer( _gl.ELEMENT_ARRAY_BUFFER, objects.getAttributeBuffer( index ) );

				}

			}

			//

			var dataCount = 0;

			if ( index !== null ) {

				dataCount = index.count;

			} else if ( position !== undefined ) {

				dataCount = position.count;

			}

			var rangeStart = geometry.drawRange.start * rangeFactor;
			var rangeCount = geometry.drawRange.count * rangeFactor;

			var groupStart = group !== null ? group.start * rangeFactor : 0;
			var groupCount = group !== null ? group.count * rangeFactor : Infinity;

			var drawStart = Math.max( rangeStart, groupStart );
			var drawEnd = Math.min( dataCount, rangeStart + rangeCount, groupStart + groupCount ) - 1;

			var drawCount = Math.max( 0, drawEnd - drawStart + 1 );

			if ( drawCount === 0 ) return;

			//

			if ( object.isMesh ) {

				if ( material.wireframe === true ) {

					state.setLineWidth( material.wireframeLinewidth * getTargetPixelRatio() );
					renderer.setMode( _gl.LINES );

				} else {

					switch ( object.drawMode ) {

						case TrianglesDrawMode:
							renderer.setMode( _gl.TRIANGLES );
							break;

						case TriangleStripDrawMode:
							renderer.setMode( _gl.TRIANGLE_STRIP );
							break;

						case TriangleFanDrawMode:
							renderer.setMode( _gl.TRIANGLE_FAN );
							break;

					}

				}


			} else if ( object.isLine ) {

				var lineWidth = material.linewidth;

				if ( lineWidth === undefined ) lineWidth = 1; // Not using Line*Material

				state.setLineWidth( lineWidth * getTargetPixelRatio() );

				if ( object.isLineSegments ) {

					renderer.setMode( _gl.LINES );

				} else {

					renderer.setMode( _gl.LINE_STRIP );

				}

			} else if ( object.isPoints ) {

				renderer.setMode( _gl.POINTS );

			}

			if ( geometry && geometry.isInstancedBufferGeometry ) {

				if ( geometry.maxInstancedCount > 0 ) {

					renderer.renderInstances( geometry, drawStart, drawCount );

				}

			} else {

				renderer.render( drawStart, drawCount );

			}

		};

		function setupVertexAttributes( material, program, geometry, startIndex ) {

			var extension;

			if ( geometry && geometry.isInstancedBufferGeometry ) {

				extension = extensions.get( 'ANGLE_instanced_arrays' );

				if ( extension === null ) {

					console.error( 'THREE.WebGLRenderer.setupVertexAttributes: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
					return;

				}

			}

			if ( startIndex === undefined ) startIndex = 0;

			state.initAttributes();

			var geometryAttributes = geometry.attributes;

			var programAttributes = program.getAttributes();

			var materialDefaultAttributeValues = material.defaultAttributeValues;

			for ( var name in programAttributes ) {

				var programAttribute = programAttributes[ name ];

				if ( programAttribute >= 0 ) {

					var geometryAttribute = geometryAttributes[ name ];

					if ( geometryAttribute !== undefined ) {

						var normalized = geometryAttribute.normalized;
						var size = geometryAttribute.itemSize;

						var attributeProperties = objects.getAttributeProperties( geometryAttribute );

						var buffer = attributeProperties.__webglBuffer;
						var type = attributeProperties.type;
						var bytesPerElement = attributeProperties.bytesPerElement;

						if ( geometryAttribute.isInterleavedBufferAttribute ) {

							var data = geometryAttribute.data;
							var stride = data.stride;
							var offset = geometryAttribute.offset;

							if ( data && data.isInstancedInterleavedBuffer ) {

								state.enableAttributeAndDivisor( programAttribute, data.meshPerAttribute, extension );

								if ( geometry.maxInstancedCount === undefined ) {

									geometry.maxInstancedCount = data.meshPerAttribute * data.count;

								}

							} else {

								state.enableAttribute( programAttribute );

							}

							_gl.bindBuffer( _gl.ARRAY_BUFFER, buffer );
							_gl.vertexAttribPointer( programAttribute, size, type, normalized, stride * bytesPerElement, ( startIndex * stride + offset ) * bytesPerElement );

						} else {

							if ( geometryAttribute.isInstancedBufferAttribute ) {

								state.enableAttributeAndDivisor( programAttribute, geometryAttribute.meshPerAttribute, extension );

								if ( geometry.maxInstancedCount === undefined ) {

									geometry.maxInstancedCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;

								}

							} else {

								state.enableAttribute( programAttribute );

							}

							_gl.bindBuffer( _gl.ARRAY_BUFFER, buffer );
							_gl.vertexAttribPointer( programAttribute, size, type, normalized, 0, startIndex * size * bytesPerElement );

						}

					} else if ( materialDefaultAttributeValues !== undefined ) {

						var value = materialDefaultAttributeValues[ name ];

						if ( value !== undefined ) {

							switch ( value.length ) {

								case 2:
									_gl.vertexAttrib2fv( programAttribute, value );
									break;

								case 3:
									_gl.vertexAttrib3fv( programAttribute, value );
									break;

								case 4:
									_gl.vertexAttrib4fv( programAttribute, value );
									break;

								default:
									_gl.vertexAttrib1fv( programAttribute, value );

							}

						}

					}

				}

			}

			state.disableUnusedAttributes();

		}

		// Sorting

		function absNumericalSort( a, b ) {

			return Math.abs( b[ 0 ] ) - Math.abs( a[ 0 ] );

		}

		function painterSortStable( a, b ) {

			if ( a.object.renderOrder !== b.object.renderOrder ) {

				return a.object.renderOrder - b.object.renderOrder;

			} else if ( a.material.program && b.material.program && a.material.program !== b.material.program ) {

				return a.material.program.id - b.material.program.id;

			} else if ( a.material.id !== b.material.id ) {

				return a.material.id - b.material.id;

			} else if ( a.z !== b.z ) {

				return a.z - b.z;

			} else {

				return a.id - b.id;

			}

		}

		function reversePainterSortStable( a, b ) {

			if ( a.object.renderOrder !== b.object.renderOrder ) {

				return a.object.renderOrder - b.object.renderOrder;

			} if ( a.z !== b.z ) {

				return b.z - a.z;

			} else {

				return a.id - b.id;

			}

		}

		// Rendering

		this.render = function ( scene, camera, renderTarget, forceClear ) {

			if ( camera !== undefined && camera.isCamera !== true ) {

				console.error( 'THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.' );
				return;

			}

			// reset caching for this frame

			_currentGeometryProgram = '';
			_currentMaterialId = - 1;
			_currentCamera = null;

			// update scene graph

			if ( scene.autoUpdate === true ) scene.updateMatrixWorld();

			// update camera matrices and frustum

			if ( camera.parent === null ) camera.updateMatrixWorld();

			camera.matrixWorldInverse.getInverse( camera.matrixWorld );

			_projScreenMatrix.multiplyMatrices( camera.projectionMatrix, camera.matrixWorldInverse );
			_frustum.setFromMatrix( _projScreenMatrix );

			lights.length = 0;

			opaqueObjectsLastIndex = - 1;
			transparentObjectsLastIndex = - 1;

			sprites.length = 0;
			lensFlares.length = 0;

			_localClippingEnabled = this.localClippingEnabled;
			_clippingEnabled = _clipping.init( this.clippingPlanes, _localClippingEnabled, camera );

			projectObject( scene, camera );

			opaqueObjects.length = opaqueObjectsLastIndex + 1;
			transparentObjects.length = transparentObjectsLastIndex + 1;

			if ( _this.sortObjects === true ) {

				opaqueObjects.sort( painterSortStable );
				transparentObjects.sort( reversePainterSortStable );

			}

			//

			if ( _clippingEnabled ) _clipping.beginShadows();

			setupShadows( lights );

			shadowMap.render( scene, camera );

			setupLights( lights, camera );

			if ( _clippingEnabled ) _clipping.endShadows();

			//

			_infoRender.calls = 0;
			_infoRender.vertices = 0;
			_infoRender.faces = 0;
			_infoRender.points = 0;

			if ( renderTarget === undefined ) {

				renderTarget = null;

			}

			this.setRenderTarget( renderTarget );

			//

			var background = scene.background;

			if ( background === null ) {

				state.buffers.color.setClear( _clearColor.r, _clearColor.g, _clearColor.b, _clearAlpha, _premultipliedAlpha );

			} else if ( background && background.isColor ) {

				state.buffers.color.setClear( background.r, background.g, background.b, 1, _premultipliedAlpha );
				forceClear = true;

			}

			if ( this.autoClear || forceClear ) {

				this.clear( this.autoClearColor, this.autoClearDepth, this.autoClearStencil );

			}

			if ( background && background.isCubeTexture ) {

				backgroundCamera2.projectionMatrix.copy( camera.projectionMatrix );

				backgroundCamera2.matrixWorld.extractRotation( camera.matrixWorld );
				backgroundCamera2.matrixWorldInverse.getInverse( backgroundCamera2.matrixWorld );

				backgroundBoxMesh.material.uniforms[ "tCube" ].value = background;
				backgroundBoxMesh.modelViewMatrix.multiplyMatrices( backgroundCamera2.matrixWorldInverse, backgroundBoxMesh.matrixWorld );

				objects.update( backgroundBoxMesh );

				_this.renderBufferDirect( backgroundCamera2, null, backgroundBoxMesh.geometry, backgroundBoxMesh.material, backgroundBoxMesh, null );

			} else if ( background && background.isTexture ) {

				backgroundPlaneMesh.material.map = background;

				objects.update( backgroundPlaneMesh );

				_this.renderBufferDirect( backgroundCamera, null, backgroundPlaneMesh.geometry, backgroundPlaneMesh.material, backgroundPlaneMesh, null );

			}

			//

			if ( scene.overrideMaterial ) {

				var overrideMaterial = scene.overrideMaterial;

				renderObjects( opaqueObjects, scene, camera, overrideMaterial );
				renderObjects( transparentObjects, scene, camera, overrideMaterial );

			} else {

				// opaque pass (front-to-back order)

				state.setBlending( NoBlending );
				renderObjects( opaqueObjects, scene, camera );

				// transparent pass (back-to-front order)

				renderObjects( transparentObjects, scene, camera );

			}

			// custom render plugins (post pass)

			spritePlugin.render( scene, camera );
			lensFlarePlugin.render( scene, camera, _currentViewport );

			// Generate mipmap if we're using any kind of mipmap filtering

			if ( renderTarget ) {

				textures.updateRenderTargetMipmap( renderTarget );

			}

			// Ensure depth buffer writing is enabled so it can be cleared on next render

			state.setDepthTest( true );
			state.setDepthWrite( true );
			state.setColorWrite( true );

			// _gl.finish();

		};

		function pushRenderItem( object, geometry, material, z, group ) {

			var array, index;

			// allocate the next position in the appropriate array

			if ( material.transparent ) {

				array = transparentObjects;
				index = ++ transparentObjectsLastIndex;

			} else {

				array = opaqueObjects;
				index = ++ opaqueObjectsLastIndex;

			}

			// recycle existing render item or grow the array

			var renderItem = array[ index ];

			if ( renderItem !== undefined ) {

				renderItem.id = object.id;
				renderItem.object = object;
				renderItem.geometry = geometry;
				renderItem.material = material;
				renderItem.z = _vector3.z;
				renderItem.group = group;

			} else {

				renderItem = {
					id: object.id,
					object: object,
					geometry: geometry,
					material: material,
					z: _vector3.z,
					group: group
				};

				// assert( index === array.length );
				array.push( renderItem );

			}

		}

		// TODO Duplicated code (Frustum)

		function isObjectViewable( object ) {

			var geometry = object.geometry;

			if ( geometry.boundingSphere === null )
				geometry.computeBoundingSphere();

			_sphere.copy( geometry.boundingSphere ).
			applyMatrix4( object.matrixWorld );

			return isSphereViewable( _sphere );

		}

		function isSpriteViewable( sprite ) {

			_sphere.center.set( 0, 0, 0 );
			_sphere.radius = 0.7071067811865476;
			_sphere.applyMatrix4( sprite.matrixWorld );

			return isSphereViewable( _sphere );

		}

		function isSphereViewable( sphere ) {

			if ( ! _frustum.intersectsSphere( sphere ) ) return false;

			var numPlanes = _clipping.numPlanes;

			if ( numPlanes === 0 ) return true;

			var planes = _this.clippingPlanes,

				center = sphere.center,
				negRad = - sphere.radius,
				i = 0;

			do {

				// out when deeper than radius in the negative halfspace
				if ( planes[ i ].distanceToPoint( center ) < negRad ) return false;

			} while ( ++ i !== numPlanes );

			return true;

		}

		function projectObject( object, camera ) {

			if ( object.visible === false ) return;

			var visible = ( object.layers.mask & camera.layers.mask ) !== 0;

			if ( visible ) {

				if ( object.isLight ) {

					lights.push( object );

				} else if ( object.isSprite ) {

					if ( object.frustumCulled === false || isSpriteViewable( object ) === true ) {

						sprites.push( object );

					}

				} else if ( object.isLensFlare ) {

					lensFlares.push( object );

				} else if ( object.isImmediateRenderObject ) {

					if ( _this.sortObjects === true ) {

						_vector3.setFromMatrixPosition( object.matrixWorld );
						_vector3.applyProjection( _projScreenMatrix );

					}

					pushRenderItem( object, null, object.material, _vector3.z, null );

				} else if ( object.isMesh || object.isLine || object.isPoints ) {

					if ( object.isSkinnedMesh ) {

						object.skeleton.update();

					}

					if ( object.frustumCulled === false || isObjectViewable( object ) === true ) {

						var material = object.material;

						if ( material.visible === true ) {

							if ( _this.sortObjects === true ) {

								_vector3.setFromMatrixPosition( object.matrixWorld );
								_vector3.applyProjection( _projScreenMatrix );

							}

							var geometry = objects.update( object );

							if ( material.isMultiMaterial ) {

								var groups = geometry.groups;
								var materials = material.materials;

								for ( var i = 0, l = groups.length; i < l; i ++ ) {

									var group = groups[ i ];
									var groupMaterial = materials[ group.materialIndex ];

									if ( groupMaterial.visible === true ) {

										pushRenderItem( object, geometry, groupMaterial, _vector3.z, group );

									}

								}

							} else {

								pushRenderItem( object, geometry, material, _vector3.z, null );

							}

						}

					}

				}

			}

			var children = object.children;

			for ( var i = 0, l = children.length; i < l; i ++ ) {

				projectObject( children[ i ], camera );

			}

		}

		function renderObjects( renderList, scene, camera, overrideMaterial ) {

			for ( var i = 0, l = renderList.length; i < l; i ++ ) {

				var renderItem = renderList[ i ];

				var object = renderItem.object;
				var geometry = renderItem.geometry;
				var material = overrideMaterial === undefined ? renderItem.material : overrideMaterial;
				var group = renderItem.group;

				object.modelViewMatrix.multiplyMatrices( camera.matrixWorldInverse, object.matrixWorld );
				object.normalMatrix.getNormalMatrix( object.modelViewMatrix );

				object.onBeforeRender( _this, scene, camera, geometry, material, group );

				if ( object.isImmediateRenderObject ) {

					setMaterial( material );

					var program = setProgram( camera, scene.fog, material, object );

					_currentGeometryProgram = '';

					object.render( function ( object ) {

						_this.renderBufferImmediate( object, program, material );

					} );

				} else {

					_this.renderBufferDirect( camera, scene.fog, geometry, material, object, group );

				}

				object.onAfterRender( _this, scene, camera, geometry, material, group );


			}

		}

		function initMaterial( material, fog, object ) {

			var materialProperties = properties.get( material );

			var parameters = programCache.getParameters(
				material, _lights, fog, _clipping.numPlanes, _clipping.numIntersection, object );

			var code = programCache.getProgramCode( material, parameters );

			var program = materialProperties.program;
			var programChange = true;

			if ( program === undefined ) {

				// new material
				material.addEventListener( 'dispose', onMaterialDispose );

			} else if ( program.code !== code ) {

				// changed glsl or parameters
				releaseMaterialProgramReference( material );

			} else if ( parameters.shaderID !== undefined ) {

				// same glsl and uniform list
				return;

			} else {

				// only rebuild uniform list
				programChange = false;

			}

			if ( programChange ) {

				if ( parameters.shaderID ) {

					var shader = ShaderLib[ parameters.shaderID ];

					materialProperties.__webglShader = {
						name: material.type,
						uniforms: UniformsUtils.clone( shader.uniforms ),
						vertexShader: shader.vertexShader,
						fragmentShader: shader.fragmentShader
					};

				} else {

					materialProperties.__webglShader = {
						name: material.type,
						uniforms: material.uniforms,
						vertexShader: material.vertexShader,
						fragmentShader: material.fragmentShader
					};

				}

				material.__webglShader = materialProperties.__webglShader;

				program = programCache.acquireProgram( material, parameters, code );

				materialProperties.program = program;
				material.program = program;

			}

			var attributes = program.getAttributes();

			if ( material.morphTargets ) {

				material.numSupportedMorphTargets = 0;

				for ( var i = 0; i < _this.maxMorphTargets; i ++ ) {

					if ( attributes[ 'morphTarget' + i ] >= 0 ) {

						material.numSupportedMorphTargets ++;

					}

				}

			}

			if ( material.morphNormals ) {

				material.numSupportedMorphNormals = 0;

				for ( var i = 0; i < _this.maxMorphNormals; i ++ ) {

					if ( attributes[ 'morphNormal' + i ] >= 0 ) {

						material.numSupportedMorphNormals ++;

					}

				}

			}

			var uniforms = materialProperties.__webglShader.uniforms;

			if ( ! material.isShaderMaterial &&
				! material.isRawShaderMaterial ||
				material.clipping === true ) {

				materialProperties.numClippingPlanes = _clipping.numPlanes;
				materialProperties.numIntersection = _clipping.numIntersection;
				uniforms.clippingPlanes = _clipping.uniform;

			}

			materialProperties.fog = fog;

			// store the light setup it was created for

			materialProperties.lightsHash = _lights.hash;

			if ( material.lights ) {

				// wire up the material to this renderer's lighting state

				uniforms.ambientLightColor.value = _lights.ambient;
				uniforms.directionalLights.value = _lights.directional;
				uniforms.spotLights.value = _lights.spot;
				uniforms.rectAreaLights.value = _lights.rectArea;
				uniforms.pointLights.value = _lights.point;
				uniforms.hemisphereLights.value = _lights.hemi;

				uniforms.directionalShadowMap.value = _lights.directionalShadowMap;
				uniforms.directionalShadowMatrix.value = _lights.directionalShadowMatrix;
				uniforms.spotShadowMap.value = _lights.spotShadowMap;
				uniforms.spotShadowMatrix.value = _lights.spotShadowMatrix;
				uniforms.pointShadowMap.value = _lights.pointShadowMap;
				uniforms.pointShadowMatrix.value = _lights.pointShadowMatrix;
				// TODO (abelnation): add area lights shadow info to uniforms

			}

			var progUniforms = materialProperties.program.getUniforms(),
				uniformsList =
					WebGLUniforms.seqWithValue( progUniforms.seq, uniforms );

			materialProperties.uniformsList = uniformsList;

		}

		function setMaterial( material ) {

			material.side === DoubleSide
				? state.disable( _gl.CULL_FACE )
				: state.enable( _gl.CULL_FACE );

			state.setFlipSided( material.side === BackSide );

			material.transparent === true
				? state.setBlending( material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha )
				: state.setBlending( NoBlending );

			state.setDepthFunc( material.depthFunc );
			state.setDepthTest( material.depthTest );
			state.setDepthWrite( material.depthWrite );
			state.setColorWrite( material.colorWrite );
			state.setPolygonOffset( material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits );

		}

		function setProgram( camera, fog, material, object ) {

			_usedTextureUnits = 0;

			var materialProperties = properties.get( material );

			if ( _clippingEnabled ) {

				if ( _localClippingEnabled || camera !== _currentCamera ) {

					var useCache =
						camera === _currentCamera &&
						material.id === _currentMaterialId;

					// we might want to call this function with some ClippingGroup
					// object instead of the material, once it becomes feasible
					// (#8465, #8379)
					_clipping.setState(
						material.clippingPlanes, material.clipIntersection, material.clipShadows,
						camera, materialProperties, useCache );

				}

			}

			if ( material.needsUpdate === false ) {

				if ( materialProperties.program === undefined ) {

					material.needsUpdate = true;

				} else if ( material.fog && materialProperties.fog !== fog ) {

					material.needsUpdate = true;

				} else if ( material.lights && materialProperties.lightsHash !== _lights.hash ) {

					material.needsUpdate = true;

				} else if ( materialProperties.numClippingPlanes !== undefined &&
					( materialProperties.numClippingPlanes !== _clipping.numPlanes ||
					materialProperties.numIntersection  !== _clipping.numIntersection ) ) {

					material.needsUpdate = true;

				}

			}

			if ( material.needsUpdate ) {

				initMaterial( material, fog, object );
				material.needsUpdate = false;

			}

			var refreshProgram = false;
			var refreshMaterial = false;
			var refreshLights = false;

			var program = materialProperties.program,
				p_uniforms = program.getUniforms(),
				m_uniforms = materialProperties.__webglShader.uniforms;

			if ( program.id !== _currentProgram ) {

				_gl.useProgram( program.program );
				_currentProgram = program.id;

				refreshProgram = true;
				refreshMaterial = true;
				refreshLights = true;

			}

			if ( material.id !== _currentMaterialId ) {

				_currentMaterialId = material.id;

				refreshMaterial = true;

			}

			if ( refreshProgram || camera !== _currentCamera ) {

				p_uniforms.set( _gl, camera, 'projectionMatrix' );

				if ( capabilities.logarithmicDepthBuffer ) {

					p_uniforms.setValue( _gl, 'logDepthBufFC',
						2.0 / ( Math.log( camera.far + 1.0 ) / Math.LN2 ) );

				}


				if ( camera !== _currentCamera ) {

					_currentCamera = camera;

					// lighting uniforms depend on the camera so enforce an update
					// now, in case this material supports lights - or later, when
					// the next material that does gets activated:

					refreshMaterial = true;		// set to true on material change
					refreshLights = true;		// remains set until update done

				}

				// load material specific uniforms
				// (shader material also gets them for the sake of genericity)

				if ( material.isShaderMaterial ||
					material.isMeshPhongMaterial ||
					material.isMeshStandardMaterial ||
					material.envMap ) {

					var uCamPos = p_uniforms.map.cameraPosition;

					if ( uCamPos !== undefined ) {

						uCamPos.setValue( _gl,
							_vector3.setFromMatrixPosition( camera.matrixWorld ) );

					}

				}

				if ( material.isMeshPhongMaterial ||
					material.isMeshLambertMaterial ||
					material.isMeshBasicMaterial ||
					material.isMeshStandardMaterial ||
					material.isShaderMaterial ||
					material.skinning ) {

					p_uniforms.setValue( _gl, 'viewMatrix', camera.matrixWorldInverse );

				}

				p_uniforms.set( _gl, _this, 'toneMappingExposure' );
				p_uniforms.set( _gl, _this, 'toneMappingWhitePoint' );

			}

			// skinning uniforms must be set even if material didn't change
			// auto-setting of texture unit for bone texture must go before other textures
			// not sure why, but otherwise weird things happen

			if ( material.skinning ) {

				p_uniforms.setOptional( _gl, object, 'bindMatrix' );
				p_uniforms.setOptional( _gl, object, 'bindMatrixInverse' );

				var skeleton = object.skeleton;

				if ( skeleton ) {

					if ( capabilities.floatVertexTextures && skeleton.useVertexTexture ) {

						p_uniforms.set( _gl, skeleton, 'boneTexture' );
						p_uniforms.set( _gl, skeleton, 'boneTextureWidth' );
						p_uniforms.set( _gl, skeleton, 'boneTextureHeight' );

					} else {

						p_uniforms.setOptional( _gl, skeleton, 'boneMatrices' );

					}

				}

			}

			if ( refreshMaterial ) {

				if ( material.lights ) {

					// the current material requires lighting info

					// note: all lighting uniforms are always set correctly
					// they simply reference the renderer's state for their
					// values
					//
					// use the current material's .needsUpdate flags to set
					// the GL state when required

					markUniformsLightsNeedsUpdate( m_uniforms, refreshLights );

				}

				// refresh uniforms common to several materials

				if ( fog && material.fog ) {

					refreshUniformsFog( m_uniforms, fog );

				}

				if ( material.isMeshBasicMaterial ||
					material.isMeshLambertMaterial ||
					material.isMeshPhongMaterial ||
					material.isMeshStandardMaterial ||
					material.isMeshNormalMaterial ||
					material.isMeshDepthMaterial ) {

					refreshUniformsCommon( m_uniforms, material );

				}

				// refresh single material specific uniforms

				if ( material.isLineBasicMaterial ) {

					refreshUniformsLine( m_uniforms, material );

				} else if ( material.isLineDashedMaterial ) {

					refreshUniformsLine( m_uniforms, material );
					refreshUniformsDash( m_uniforms, material );

				} else if ( material.isPointsMaterial ) {

					refreshUniformsPoints( m_uniforms, material );

				} else if ( material.isMeshLambertMaterial ) {

					refreshUniformsLambert( m_uniforms, material );

				} else if ( material.isMeshToonMaterial ) {

					refreshUniformsToon( m_uniforms, material );

				} else if ( material.isMeshPhongMaterial ) {

					refreshUniformsPhong( m_uniforms, material );

				} else if ( material.isMeshPhysicalMaterial ) {

					refreshUniformsPhysical( m_uniforms, material );

				} else if ( material.isMeshStandardMaterial ) {

					refreshUniformsStandard( m_uniforms, material );

				} else if ( material.isMeshDepthMaterial ) {

					if ( material.displacementMap ) {

						m_uniforms.displacementMap.value = material.displacementMap;
						m_uniforms.displacementScale.value = material.displacementScale;
						m_uniforms.displacementBias.value = material.displacementBias;

					}

				} else if ( material.isMeshNormalMaterial ) {

					refreshUniformsNormal( m_uniforms, material );

				}

				// RectAreaLight Texture
				// TODO (mrdoob): Find a nicer implementation

				if ( m_uniforms.ltcMat !== undefined ) m_uniforms.ltcMat.value = THREE.UniformsLib.LTC_MAT_TEXTURE;
				if ( m_uniforms.ltcMag !== undefined ) m_uniforms.ltcMag.value = THREE.UniformsLib.LTC_MAG_TEXTURE;

				WebGLUniforms.upload(
					_gl, materialProperties.uniformsList, m_uniforms, _this );

			}


			// common matrices

			p_uniforms.set( _gl, object, 'modelViewMatrix' );
			p_uniforms.set( _gl, object, 'normalMatrix' );
			p_uniforms.setValue( _gl, 'modelMatrix', object.matrixWorld );

			return program;

		}

		// Uniforms (refresh uniforms objects)

		function refreshUniformsCommon( uniforms, material ) {

			uniforms.opacity.value = material.opacity;

			uniforms.diffuse.value = material.color;

			if ( material.emissive ) {

				uniforms.emissive.value.copy( material.emissive ).multiplyScalar( material.emissiveIntensity );

			}

			uniforms.map.value = material.map;
			uniforms.specularMap.value = material.specularMap;
			uniforms.alphaMap.value = material.alphaMap;

			if ( material.lightMap ) {

				uniforms.lightMap.value = material.lightMap;
				uniforms.lightMapIntensity.value = material.lightMapIntensity;

			}

			if ( material.aoMap ) {

				uniforms.aoMap.value = material.aoMap;
				uniforms.aoMapIntensity.value = material.aoMapIntensity;

			}

			// uv repeat and offset setting priorities
			// 1. color map
			// 2. specular map
			// 3. normal map
			// 4. bump map
			// 5. alpha map
			// 6. emissive map

			var uvScaleMap;

			if ( material.map ) {

				uvScaleMap = material.map;

			} else if ( material.specularMap ) {

				uvScaleMap = material.specularMap;

			} else if ( material.displacementMap ) {

				uvScaleMap = material.displacementMap;

			} else if ( material.normalMap ) {

				uvScaleMap = material.normalMap;

			} else if ( material.bumpMap ) {

				uvScaleMap = material.bumpMap;

			} else if ( material.roughnessMap ) {

				uvScaleMap = material.roughnessMap;

			} else if ( material.metalnessMap ) {

				uvScaleMap = material.metalnessMap;

			} else if ( material.alphaMap ) {

				uvScaleMap = material.alphaMap;

			} else if ( material.emissiveMap ) {

				uvScaleMap = material.emissiveMap;

			}

			if ( uvScaleMap !== undefined ) {

				// backwards compatibility
				if ( uvScaleMap.isWebGLRenderTarget ) {

					uvScaleMap = uvScaleMap.texture;

				}

				var offset = uvScaleMap.offset;
				var repeat = uvScaleMap.repeat;

				uniforms.offsetRepeat.value.set( offset.x, offset.y, repeat.x, repeat.y );

			}

			uniforms.envMap.value = material.envMap;

			// don't flip CubeTexture envMaps, flip everything else:
			//  WebGLRenderTargetCube will be flipped for backwards compatibility
			//  WebGLRenderTargetCube.texture will be flipped because it's a Texture and NOT a CubeTexture
			// this check must be handled differently, or removed entirely, if WebGLRenderTargetCube uses a CubeTexture in the future
			uniforms.flipEnvMap.value = ( ! ( material.envMap && material.envMap.isCubeTexture ) ) ? 1 : - 1;

			uniforms.reflectivity.value = material.reflectivity;
			uniforms.refractionRatio.value = material.refractionRatio;

		}

		function refreshUniformsLine( uniforms, material ) {

			uniforms.diffuse.value = material.color;
			uniforms.opacity.value = material.opacity;

		}

		function refreshUniformsDash( uniforms, material ) {

			uniforms.dashSize.value = material.dashSize;
			uniforms.totalSize.value = material.dashSize + material.gapSize;
			uniforms.scale.value = material.scale;

		}

		function refreshUniformsPoints( uniforms, material ) {

			uniforms.diffuse.value = material.color;
			uniforms.opacity.value = material.opacity;
			uniforms.size.value = material.size * _pixelRatio;
			uniforms.scale.value = _height * 0.5;

			uniforms.map.value = material.map;

			if ( material.map !== null ) {

				var offset = material.map.offset;
				var repeat = material.map.repeat;

				uniforms.offsetRepeat.value.set( offset.x, offset.y, repeat.x, repeat.y );

			}

		}

		function refreshUniformsFog( uniforms, fog ) {

			uniforms.fogColor.value = fog.color;

			if ( fog.isFog ) {

				uniforms.fogNear.value = fog.near;
				uniforms.fogFar.value = fog.far;

			} else if ( fog.isFogExp2 ) {

				uniforms.fogDensity.value = fog.density;

			}

		}

		function refreshUniformsLambert( uniforms, material ) {

			if ( material.emissiveMap ) {

				uniforms.emissiveMap.value = material.emissiveMap;

			}

		}

		function refreshUniformsPhong( uniforms, material ) {

			uniforms.specular.value = material.specular;
			uniforms.shininess.value = Math.max( material.shininess, 1e-4 ); // to prevent pow( 0.0, 0.0 )

			if ( material.emissiveMap ) {

				uniforms.emissiveMap.value = material.emissiveMap;

			}

			if ( material.bumpMap ) {

				uniforms.bumpMap.value = material.bumpMap;
				uniforms.bumpScale.value = material.bumpScale;

			}

			if ( material.normalMap ) {

				uniforms.normalMap.value = material.normalMap;
				uniforms.normalScale.value.copy( material.normalScale );

			}

			if ( material.displacementMap ) {

				uniforms.displacementMap.value = material.displacementMap;
				uniforms.displacementScale.value = material.displacementScale;
				uniforms.displacementBias.value = material.displacementBias;

			}

		}

		function refreshUniformsToon( uniforms, material ) {

			refreshUniformsPhong( uniforms, material );

			if ( material.gradientMap ) {

				uniforms.gradientMap.value = material.gradientMap;

			}

		}

		function refreshUniformsStandard( uniforms, material ) {

			uniforms.roughness.value = material.roughness;
			uniforms.metalness.value = material.metalness;

			if ( material.roughnessMap ) {

				uniforms.roughnessMap.value = material.roughnessMap;

			}

			if ( material.metalnessMap ) {

				uniforms.metalnessMap.value = material.metalnessMap;

			}

			if ( material.emissiveMap ) {

				uniforms.emissiveMap.value = material.emissiveMap;

			}

			if ( material.bumpMap ) {

				uniforms.bumpMap.value = material.bumpMap;
				uniforms.bumpScale.value = material.bumpScale;

			}

			if ( material.normalMap ) {

				uniforms.normalMap.value = material.normalMap;
				uniforms.normalScale.value.copy( material.normalScale );

			}

			if ( material.displacementMap ) {

				uniforms.displacementMap.value = material.displacementMap;
				uniforms.displacementScale.value = material.displacementScale;
				uniforms.displacementBias.value = material.displacementBias;

			}

			if ( material.envMap ) {

				//uniforms.envMap.value = material.envMap; // part of uniforms common
				uniforms.envMapIntensity.value = material.envMapIntensity;

			}

		}

		function refreshUniformsPhysical( uniforms, material ) {

			uniforms.clearCoat.value = material.clearCoat;
			uniforms.clearCoatRoughness.value = material.clearCoatRoughness;

			refreshUniformsStandard( uniforms, material );

		}

		function refreshUniformsNormal( uniforms, material ) {

			if ( material.bumpMap ) {

				uniforms.bumpMap.value = material.bumpMap;
				uniforms.bumpScale.value = material.bumpScale;

			}

			if ( material.normalMap ) {

				uniforms.normalMap.value = material.normalMap;
				uniforms.normalScale.value.copy( material.normalScale );

			}

			if ( material.displacementMap ) {

				uniforms.displacementMap.value = material.displacementMap;
				uniforms.displacementScale.value = material.displacementScale;
				uniforms.displacementBias.value = material.displacementBias;

			}

		}

		// If uniforms are marked as clean, they don't need to be loaded to the GPU.

		function markUniformsLightsNeedsUpdate( uniforms, value ) {

			uniforms.ambientLightColor.needsUpdate = value;

			uniforms.directionalLights.needsUpdate = value;
			uniforms.pointLights.needsUpdate = value;
			uniforms.spotLights.needsUpdate = value;
			uniforms.rectAreaLights.needsUpdate = value;
			uniforms.hemisphereLights.needsUpdate = value;

		}

		// Lighting

		function setupShadows( lights ) {

			var lightShadowsLength = 0;

			for ( var i = 0, l = lights.length; i < l; i ++ ) {

				var light = lights[ i ];

				if ( light.castShadow ) {

					_lights.shadows[ lightShadowsLength ++ ] = light;

				}

			}

			_lights.shadows.length = lightShadowsLength;

		}

		function setupLights( lights, camera ) {

			var l, ll, light,
				r = 0, g = 0, b = 0,
				color,
				intensity,
				distance,
				shadowMap,

				viewMatrix = camera.matrixWorldInverse,

			directionalLength = 0,
			pointLength = 0,
			spotLength = 0,
			rectAreaLength = 0,
			hemiLength = 0;

			for ( l = 0, ll = lights.length; l < ll; l ++ ) {

				light = lights[ l ];

				color = light.color;
				intensity = light.intensity;
				distance = light.distance;

				shadowMap = ( light.shadow && light.shadow.map ) ? light.shadow.map.texture : null;

				if ( light.isAmbientLight ) {

					r += color.r * intensity;
					g += color.g * intensity;
					b += color.b * intensity;

				} else if ( light.isDirectionalLight ) {

					var uniforms = lightCache.get( light );

					uniforms.color.copy( light.color ).multiplyScalar( light.intensity );
					uniforms.direction.setFromMatrixPosition( light.matrixWorld );
					_vector3.setFromMatrixPosition( light.target.matrixWorld );
					uniforms.direction.sub( _vector3 );
					uniforms.direction.transformDirection( viewMatrix );

					uniforms.shadow = light.castShadow;

					if ( light.castShadow ) {

						uniforms.shadowBias = light.shadow.bias;
						uniforms.shadowRadius = light.shadow.radius;
						uniforms.shadowMapSize = light.shadow.mapSize;

					}

					_lights.directionalShadowMap[ directionalLength ] = shadowMap;
					_lights.directionalShadowMatrix[ directionalLength ] = light.shadow.matrix;
					_lights.directional[ directionalLength ++ ] = uniforms;

				} else if ( light.isSpotLight ) {

					var uniforms = lightCache.get( light );

					uniforms.position.setFromMatrixPosition( light.matrixWorld );
					uniforms.position.applyMatrix4( viewMatrix );

					uniforms.color.copy( color ).multiplyScalar( intensity );
					uniforms.distance = distance;

					uniforms.direction.setFromMatrixPosition( light.matrixWorld );
					_vector3.setFromMatrixPosition( light.target.matrixWorld );
					uniforms.direction.sub( _vector3 );
					uniforms.direction.transformDirection( viewMatrix );

					uniforms.coneCos = Math.cos( light.angle );
					uniforms.penumbraCos = Math.cos( light.angle * ( 1 - light.penumbra ) );
					uniforms.decay = ( light.distance === 0 ) ? 0.0 : light.decay;

					uniforms.shadow = light.castShadow;

					if ( light.castShadow ) {

						uniforms.shadowBias = light.shadow.bias;
						uniforms.shadowRadius = light.shadow.radius;
						uniforms.shadowMapSize = light.shadow.mapSize;

					}

					_lights.spotShadowMap[ spotLength ] = shadowMap;
					_lights.spotShadowMatrix[ spotLength ] = light.shadow.matrix;
					_lights.spot[ spotLength ++ ] = uniforms;

				} else if ( light.isRectAreaLight ) {

					var uniforms = lightCache.get( light );

					// (a) intensity controls irradiance of entire light
					uniforms.color
						.copy( color )
						.multiplyScalar( intensity / ( light.width * light.height ) );

					// (b) intensity controls the radiance per light area
					// uniforms.color.copy( color ).multiplyScalar( intensity );

					uniforms.position.setFromMatrixPosition( light.matrixWorld );
					uniforms.position.applyMatrix4( viewMatrix );

					// extract local rotation of light to derive width/height half vectors
					_matrix42.identity();
					_matrix4.copy( light.matrixWorld );
					_matrix4.premultiply( viewMatrix );
					_matrix42.extractRotation( _matrix4 );

					uniforms.halfWidth.set( light.width * 0.5,                0.0, 0.0 );
					uniforms.halfHeight.set(              0.0, light.height * 0.5, 0.0 );

					uniforms.halfWidth.applyMatrix4( _matrix42 );
					uniforms.halfHeight.applyMatrix4( _matrix42 );

					// TODO (abelnation): RectAreaLight distance?
					// uniforms.distance = distance;

					_lights.rectArea[ rectAreaLength ++ ] = uniforms;

				} else if ( light.isPointLight ) {

					var uniforms = lightCache.get( light );

					uniforms.position.setFromMatrixPosition( light.matrixWorld );
					uniforms.position.applyMatrix4( viewMatrix );

					uniforms.color.copy( light.color ).multiplyScalar( light.intensity );
					uniforms.distance = light.distance;
					uniforms.decay = ( light.distance === 0 ) ? 0.0 : light.decay;

					uniforms.shadow = light.castShadow;

					if ( light.castShadow ) {

						uniforms.shadowBias = light.shadow.bias;
						uniforms.shadowRadius = light.shadow.radius;
						uniforms.shadowMapSize = light.shadow.mapSize;

					}

					_lights.pointShadowMap[ pointLength ] = shadowMap;

					if ( _lights.pointShadowMatrix[ pointLength ] === undefined ) {

						_lights.pointShadowMatrix[ pointLength ] = new Matrix4();

					}

					// for point lights we set the shadow matrix to be a translation-only matrix
					// equal to inverse of the light's position
					_vector3.setFromMatrixPosition( light.matrixWorld ).negate();
					_lights.pointShadowMatrix[ pointLength ].identity().setPosition( _vector3 );

					_lights.point[ pointLength ++ ] = uniforms;

				} else if ( light.isHemisphereLight ) {

					var uniforms = lightCache.get( light );

					uniforms.direction.setFromMatrixPosition( light.matrixWorld );
					uniforms.direction.transformDirection( viewMatrix );
					uniforms.direction.normalize();

					uniforms.skyColor.copy( light.color ).multiplyScalar( intensity );
					uniforms.groundColor.copy( light.groundColor ).multiplyScalar( intensity );

					_lights.hemi[ hemiLength ++ ] = uniforms;

				}

			}

			_lights.ambient[ 0 ] = r;
			_lights.ambient[ 1 ] = g;
			_lights.ambient[ 2 ] = b;

			_lights.directional.length = directionalLength;
			_lights.spot.length = spotLength;
			_lights.rectArea.length = rectAreaLength;
			_lights.point.length = pointLength;
			_lights.hemi.length = hemiLength;

			// TODO (sam-g-steel) why aren't we using join
			_lights.hash = directionalLength + ',' + pointLength + ',' + spotLength + ',' + rectAreaLength + ',' + hemiLength + ',' + _lights.shadows.length;

		}

		// GL state setting

		this.setFaceCulling = function ( cullFace, frontFaceDirection ) {

			state.setCullFace( cullFace );
			state.setFlipSided( frontFaceDirection === FrontFaceDirectionCW );

		};

		// Textures

		function allocTextureUnit() {

			var textureUnit = _usedTextureUnits;

			if ( textureUnit >= capabilities.maxTextures ) {

				console.warn( 'WebGLRenderer: trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures );

			}

			_usedTextureUnits += 1;

			return textureUnit;

		}

		this.allocTextureUnit = allocTextureUnit;

		// this.setTexture2D = setTexture2D;
		this.setTexture2D = ( function() {

			var warned = false;

			// backwards compatibility: peel texture.texture
			return function setTexture2D( texture, slot ) {

				if ( texture && texture.isWebGLRenderTarget ) {

					if ( ! warned ) {

						console.warn( "THREE.WebGLRenderer.setTexture2D: don't use render targets as textures. Use their .texture property instead." );
						warned = true;

					}

					texture = texture.texture;

				}

				textures.setTexture2D( texture, slot );

			};

		}() );

		this.setTexture = ( function() {

			var warned = false;

			return function setTexture( texture, slot ) {

				if ( ! warned ) {

					console.warn( "THREE.WebGLRenderer: .setTexture is deprecated, use setTexture2D instead." );
					warned = true;

				}

				textures.setTexture2D( texture, slot );

			};

		}() );

		this.setTextureCube = ( function() {

			var warned = false;

			return function setTextureCube( texture, slot ) {

				// backwards compatibility: peel texture.texture
				if ( texture && texture.isWebGLRenderTargetCube ) {

					if ( ! warned ) {

						console.warn( "THREE.WebGLRenderer.setTextureCube: don't use cube render targets as textures. Use their .texture property instead." );
						warned = true;

					}

					texture = texture.texture;

				}

				// currently relying on the fact that WebGLRenderTargetCube.texture is a Texture and NOT a CubeTexture
				// TODO: unify these code paths
				if ( ( texture && texture.isCubeTexture ) ||
					( Array.isArray( texture.image ) && texture.image.length === 6 ) ) {

					// CompressedTexture can have Array in image :/

					// this function alone should take care of cube textures
					textures.setTextureCube( texture, slot );

				} else {

					// assumed: texture property of THREE.WebGLRenderTargetCube

					textures.setTextureCubeDynamic( texture, slot );

				}

			};

		}() );

		this.getCurrentRenderTarget = function() {

			return _currentRenderTarget;

		};

		this.setRenderTarget = function ( renderTarget ) {

			_currentRenderTarget = renderTarget;

			if ( renderTarget && properties.get( renderTarget ).__webglFramebuffer === undefined ) {

				textures.setupRenderTarget( renderTarget );

			}

			var isCube = ( renderTarget && renderTarget.isWebGLRenderTargetCube );
			var framebuffer;

			if ( renderTarget ) {

				var renderTargetProperties = properties.get( renderTarget );

				if ( isCube ) {

					framebuffer = renderTargetProperties.__webglFramebuffer[ renderTarget.activeCubeFace ];

				} else {

					framebuffer = renderTargetProperties.__webglFramebuffer;

				}

				_currentScissor.copy( renderTarget.scissor );
				_currentScissorTest = renderTarget.scissorTest;

				_currentViewport.copy( renderTarget.viewport );

			} else {

				framebuffer = null;

				_currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio );
				_currentScissorTest = _scissorTest;

				_currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio );

			}

			if ( _currentFramebuffer !== framebuffer ) {

				_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );
				_currentFramebuffer = framebuffer;

			}

			state.scissor( _currentScissor );
			state.setScissorTest( _currentScissorTest );

			state.viewport( _currentViewport );

			if ( isCube ) {

				var textureProperties = properties.get( renderTarget.texture );
				_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + renderTarget.activeCubeFace, textureProperties.__webglTexture, renderTarget.activeMipMapLevel );

			}

		};

		this.readRenderTargetPixels = function ( renderTarget, x, y, width, height, buffer ) {

			if ( ( renderTarget && renderTarget.isWebGLRenderTarget ) === false ) {

				console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.' );
				return;

			}

			var framebuffer = properties.get( renderTarget ).__webglFramebuffer;

			if ( framebuffer ) {

				var restore = false;

				if ( framebuffer !== _currentFramebuffer ) {

					_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

					restore = true;

				}

				try {

					var texture = renderTarget.texture;
					var textureFormat = texture.format;
					var textureType = texture.type;

					if ( textureFormat !== RGBAFormat && paramThreeToGL( textureFormat ) !== _gl.getParameter( _gl.IMPLEMENTATION_COLOR_READ_FORMAT ) ) {

						console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.' );
						return;

					}

					if ( textureType !== UnsignedByteType && paramThreeToGL( textureType ) !== _gl.getParameter( _gl.IMPLEMENTATION_COLOR_READ_TYPE ) && // IE11, Edge and Chrome Mac < 52 (#9513)
						! ( textureType === FloatType && ( extensions.get( 'OES_texture_float' ) || extensions.get( 'WEBGL_color_buffer_float' ) ) ) && // Chrome Mac >= 52 and Firefox
						! ( textureType === HalfFloatType && extensions.get( 'EXT_color_buffer_half_float' ) ) ) {

						console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.' );
						return;

					}

					if ( _gl.checkFramebufferStatus( _gl.FRAMEBUFFER ) === _gl.FRAMEBUFFER_COMPLETE ) {

						// the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)

						if ( ( x >= 0 && x <= ( renderTarget.width - width ) ) && ( y >= 0 && y <= ( renderTarget.height - height ) ) ) {

							_gl.readPixels( x, y, width, height, paramThreeToGL( textureFormat ), paramThreeToGL( textureType ), buffer );

						}

					} else {

						console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.' );

					}

				} finally {

					if ( restore ) {

						_gl.bindFramebuffer( _gl.FRAMEBUFFER, _currentFramebuffer );

					}

				}

			}

		};

		// Map three.js constants to WebGL constants

		function paramThreeToGL( p ) {

			var extension;

			if ( p === RepeatWrapping ) return _gl.REPEAT;
			if ( p === ClampToEdgeWrapping ) return _gl.CLAMP_TO_EDGE;
			if ( p === MirroredRepeatWrapping ) return _gl.MIRRORED_REPEAT;

			if ( p === NearestFilter ) return _gl.NEAREST;
			if ( p === NearestMipMapNearestFilter ) return _gl.NEAREST_MIPMAP_NEAREST;
			if ( p === NearestMipMapLinearFilter ) return _gl.NEAREST_MIPMAP_LINEAR;

			if ( p === LinearFilter ) return _gl.LINEAR;
			if ( p === LinearMipMapNearestFilter ) return _gl.LINEAR_MIPMAP_NEAREST;
			if ( p === LinearMipMapLinearFilter ) return _gl.LINEAR_MIPMAP_LINEAR;

			if ( p === UnsignedByteType ) return _gl.UNSIGNED_BYTE;
			if ( p === UnsignedShort4444Type ) return _gl.UNSIGNED_SHORT_4_4_4_4;
			if ( p === UnsignedShort5551Type ) return _gl.UNSIGNED_SHORT_5_5_5_1;
			if ( p === UnsignedShort565Type ) return _gl.UNSIGNED_SHORT_5_6_5;

			if ( p === ByteType ) return _gl.BYTE;
			if ( p === ShortType ) return _gl.SHORT;
			if ( p === UnsignedShortType ) return _gl.UNSIGNED_SHORT;
			if ( p === IntType ) return _gl.INT;
			if ( p === UnsignedIntType ) return _gl.UNSIGNED_INT;
			if ( p === FloatType ) return _gl.FLOAT;

			if ( p === HalfFloatType ) {

				extension = extensions.get( 'OES_texture_half_float' );

				if ( extension !== null ) return extension.HALF_FLOAT_OES;

			}

			if ( p === AlphaFormat ) return _gl.ALPHA;
			if ( p === RGBFormat ) return _gl.RGB;
			if ( p === RGBAFormat ) return _gl.RGBA;
			if ( p === LuminanceFormat ) return _gl.LUMINANCE;
			if ( p === LuminanceAlphaFormat ) return _gl.LUMINANCE_ALPHA;
			if ( p === DepthFormat ) return _gl.DEPTH_COMPONENT;
			if ( p === DepthStencilFormat ) return _gl.DEPTH_STENCIL;

			if ( p === AddEquation ) return _gl.FUNC_ADD;
			if ( p === SubtractEquation ) return _gl.FUNC_SUBTRACT;
			if ( p === ReverseSubtractEquation ) return _gl.FUNC_REVERSE_SUBTRACT;

			if ( p === ZeroFactor ) return _gl.ZERO;
			if ( p === OneFactor ) return _gl.ONE;
			if ( p === SrcColorFactor ) return _gl.SRC_COLOR;
			if ( p === OneMinusSrcColorFactor ) return _gl.ONE_MINUS_SRC_COLOR;
			if ( p === SrcAlphaFactor ) return _gl.SRC_ALPHA;
			if ( p === OneMinusSrcAlphaFactor ) return _gl.ONE_MINUS_SRC_ALPHA;
			if ( p === DstAlphaFactor ) return _gl.DST_ALPHA;
			if ( p === OneMinusDstAlphaFactor ) return _gl.ONE_MINUS_DST_ALPHA;

			if ( p === DstColorFactor ) return _gl.DST_COLOR;
			if ( p === OneMinusDstColorFactor ) return _gl.ONE_MINUS_DST_COLOR;
			if ( p === SrcAlphaSaturateFactor ) return _gl.SRC_ALPHA_SATURATE;

			if ( p === RGB_S3TC_DXT1_Format || p === RGBA_S3TC_DXT1_Format ||
				p === RGBA_S3TC_DXT3_Format || p === RGBA_S3TC_DXT5_Format ) {

				extension = extensions.get( 'WEBGL_compressed_texture_s3tc' );

				if ( extension !== null ) {

					if ( p === RGB_S3TC_DXT1_Format ) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
					if ( p === RGBA_S3TC_DXT1_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
					if ( p === RGBA_S3TC_DXT3_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
					if ( p === RGBA_S3TC_DXT5_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;

				}

			}

			if ( p === RGB_PVRTC_4BPPV1_Format || p === RGB_PVRTC_2BPPV1_Format ||
				p === RGBA_PVRTC_4BPPV1_Format || p === RGBA_PVRTC_2BPPV1_Format ) {

				extension = extensions.get( 'WEBGL_compressed_texture_pvrtc' );

				if ( extension !== null ) {

					if ( p === RGB_PVRTC_4BPPV1_Format ) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
					if ( p === RGB_PVRTC_2BPPV1_Format ) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
					if ( p === RGBA_PVRTC_4BPPV1_Format ) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
					if ( p === RGBA_PVRTC_2BPPV1_Format ) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;

				}

			}

			if ( p === RGB_ETC1_Format ) {

				extension = extensions.get( 'WEBGL_compressed_texture_etc1' );

				if ( extension !== null ) return extension.COMPRESSED_RGB_ETC1_WEBGL;

			}

			if ( p === MinEquation || p === MaxEquation ) {

				extension = extensions.get( 'EXT_blend_minmax' );

				if ( extension !== null ) {

					if ( p === MinEquation ) return extension.MIN_EXT;
					if ( p === MaxEquation ) return extension.MAX_EXT;

				}

			}

			if ( p === UnsignedInt248Type ) {

				extension = extensions.get( 'WEBGL_depth_texture' );

				if ( extension !== null ) return extension.UNSIGNED_INT_24_8_WEBGL;

			}

			return 0;

		}

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function FogExp2 ( color, density ) {

		this.name = '';

		this.color = new Color( color );
		this.density = ( density !== undefined ) ? density : 0.00025;

	}

	FogExp2.prototype.isFogExp2 = true;

	FogExp2.prototype.clone = function () {

		return new FogExp2( this.color.getHex(), this.density );

	};

	FogExp2.prototype.toJSON = function ( meta ) {

		return {
			type: 'FogExp2',
			color: this.color.getHex(),
			density: this.density
		};

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function Fog ( color, near, far ) {

		this.name = '';

		this.color = new Color( color );

		this.near = ( near !== undefined ) ? near : 1;
		this.far = ( far !== undefined ) ? far : 1000;

	}

	Fog.prototype.isFog = true;

	Fog.prototype.clone = function () {

		return new Fog( this.color.getHex(), this.near, this.far );

	};

	Fog.prototype.toJSON = function ( meta ) {

		return {
			type: 'Fog',
			color: this.color.getHex(),
			near: this.near,
			far: this.far
		};

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function Scene () {

		Object3D.call( this );

		this.type = 'Scene';

		this.background = null;
		this.fog = null;
		this.overrideMaterial = null;

		this.autoUpdate = true; // checked by the renderer

	}

	Scene.prototype = Object.create( Object3D.prototype );

	Scene.prototype.constructor = Scene;

	Scene.prototype.copy = function ( source, recursive ) {

		Object3D.prototype.copy.call( this, source, recursive );

		if ( source.background !== null ) this.background = source.background.clone();
		if ( source.fog !== null ) this.fog = source.fog.clone();
		if ( source.overrideMaterial !== null ) this.overrideMaterial = source.overrideMaterial.clone();

		this.autoUpdate = source.autoUpdate;
		this.matrixAutoUpdate = source.matrixAutoUpdate;

		return this;

	};

	Scene.prototype.toJSON = function ( meta ) {

		var data = Object3D.prototype.toJSON.call( this, meta );

		if ( this.background !== null ) data.object.background = this.background.toJSON( meta );
		if ( this.fog !== null ) data.object.fog = this.fog.toJSON();

		return data;

	};

	/**
	 * @author mikael emtinger / http://gomo.se/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function LensFlare( texture, size, distance, blending, color ) {

		Object3D.call( this );

		this.lensFlares = [];

		this.positionScreen = new Vector3();
		this.customUpdateCallback = undefined;

		if ( texture !== undefined ) {

			this.add( texture, size, distance, blending, color );

		}

	}

	LensFlare.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: LensFlare,

		isLensFlare: true,

		copy: function ( source ) {

			Object3D.prototype.copy.call( this, source );

			this.positionScreen.copy( source.positionScreen );
			this.customUpdateCallback = source.customUpdateCallback;

			for ( var i = 0, l = source.lensFlares.length; i < l; i ++ ) {

				this.lensFlares.push( source.lensFlares[ i ] );

			}

			return this;

		},

		add: function ( texture, size, distance, blending, color, opacity ) {

			if ( size === undefined ) size = - 1;
			if ( distance === undefined ) distance = 0;
			if ( opacity === undefined ) opacity = 1;
			if ( color === undefined ) color = new Color( 0xffffff );
			if ( blending === undefined ) blending = NormalBlending;

			distance = Math.min( distance, Math.max( 0, distance ) );

			this.lensFlares.push( {
				texture: texture,	// THREE.Texture
				size: size, 		// size in pixels (-1 = use texture.width)
				distance: distance, 	// distance (0-1) from light source (0=at light source)
				x: 0, y: 0, z: 0,	// screen position (-1 => 1) z = 0 is in front z = 1 is back
				scale: 1, 		// scale
				rotation: 0, 		// rotation
				opacity: opacity,	// opacity
				color: color,		// color
				blending: blending	// blending
			} );

		},

		/*
		 * Update lens flares update positions on all flares based on the screen position
		 * Set myLensFlare.customUpdateCallback to alter the flares in your project specific way.
		 */

		updateLensFlares: function () {

			var f, fl = this.lensFlares.length;
			var flare;
			var vecX = - this.positionScreen.x * 2;
			var vecY = - this.positionScreen.y * 2;

			for ( f = 0; f < fl; f ++ ) {

				flare = this.lensFlares[ f ];

				flare.x = this.positionScreen.x + vecX * flare.distance;
				flare.y = this.positionScreen.y + vecY * flare.distance;

				flare.wantedRotation = flare.x * Math.PI * 0.25;
				flare.rotation += ( flare.wantedRotation - flare.rotation ) * 0.25;

			}

		}

	} );

	/**
	 * @author alteredq / http://alteredqualia.com/
	 *
	 * parameters = {
	 *  color: <hex>,
	 *  opacity: <float>,
	 *  map: new THREE.Texture( <Image> ),
	 *
	 *	uvOffset: new THREE.Vector2(),
	 *	uvScale: new THREE.Vector2()
	 * }
	 */

	function SpriteMaterial( parameters ) {

		Material.call( this );

		this.type = 'SpriteMaterial';

		this.color = new Color( 0xffffff );
		this.map = null;

		this.rotation = 0;

		this.fog = false;
		this.lights = false;

		this.setValues( parameters );

	}

	SpriteMaterial.prototype = Object.create( Material.prototype );
	SpriteMaterial.prototype.constructor = SpriteMaterial;

	SpriteMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.color.copy( source.color );
		this.map = source.map;

		this.rotation = source.rotation;

		return this;

	};

	/**
	 * @author mikael emtinger / http://gomo.se/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function Sprite( material ) {

		Object3D.call( this );

		this.type = 'Sprite';

		this.material = ( material !== undefined ) ? material : new SpriteMaterial();

	}

	Sprite.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: Sprite,

		isSprite: true,

		raycast: ( function () {

			var matrixPosition = new Vector3();

			return function raycast( raycaster, intersects ) {

				matrixPosition.setFromMatrixPosition( this.matrixWorld );

				var distanceSq = raycaster.ray.distanceSqToPoint( matrixPosition );
				var guessSizeSq = this.scale.x * this.scale.y / 4;

				if ( distanceSq > guessSizeSq ) {

					return;

				}

				intersects.push( {

					distance: Math.sqrt( distanceSq ),
					point: this.position,
					face: null,
					object: this

				} );

			};

		}() ),

		clone: function () {

			return new this.constructor( this.material ).copy( this );

		}

	} );

	/**
	 * @author mikael emtinger / http://gomo.se/
	 * @author alteredq / http://alteredqualia.com/
	 * @author mrdoob / http://mrdoob.com/
	 */

	function LOD() {

		Object3D.call( this );

		this.type = 'LOD';

		Object.defineProperties( this, {
			levels: {
				enumerable: true,
				value: []
			}
		} );

	}


	LOD.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: LOD,

		copy: function ( source ) {

			Object3D.prototype.copy.call( this, source, false );

			var levels = source.levels;

			for ( var i = 0, l = levels.length; i < l; i ++ ) {

				var level = levels[ i ];

				this.addLevel( level.object.clone(), level.distance );

			}

			return this;

		},

		addLevel: function ( object, distance ) {

			if ( distance === undefined ) distance = 0;

			distance = Math.abs( distance );

			var levels = this.levels;

			for ( var l = 0; l < levels.length; l ++ ) {

				if ( distance < levels[ l ].distance ) {

					break;

				}

			}

			levels.splice( l, 0, { distance: distance, object: object } );

			this.add( object );

		},

		getObjectForDistance: function ( distance ) {

			var levels = this.levels;

			for ( var i = 1, l = levels.length; i < l; i ++ ) {

				if ( distance < levels[ i ].distance ) {

					break;

				}

			}

			return levels[ i - 1 ].object;

		},

		raycast: ( function () {

			var matrixPosition = new Vector3();

			return function raycast( raycaster, intersects ) {

				matrixPosition.setFromMatrixPosition( this.matrixWorld );

				var distance = raycaster.ray.origin.distanceTo( matrixPosition );

				this.getObjectForDistance( distance ).raycast( raycaster, intersects );

			};

		}() ),

		update: function () {

			var v1 = new Vector3();
			var v2 = new Vector3();

			return function update( camera ) {

				var levels = this.levels;

				if ( levels.length > 1 ) {

					v1.setFromMatrixPosition( camera.matrixWorld );
					v2.setFromMatrixPosition( this.matrixWorld );

					var distance = v1.distanceTo( v2 );

					levels[ 0 ].object.visible = true;

					for ( var i = 1, l = levels.length; i < l; i ++ ) {

						if ( distance >= levels[ i ].distance ) {

							levels[ i - 1 ].object.visible = false;
							levels[ i ].object.visible = true;

						} else {

							break;

						}

					}

					for ( ; i < l; i ++ ) {

						levels[ i ].object.visible = false;

					}

				}

			};

		}(),

		toJSON: function ( meta ) {

			var data = Object3D.prototype.toJSON.call( this, meta );

			data.object.levels = [];

			var levels = this.levels;

			for ( var i = 0, l = levels.length; i < l; i ++ ) {

				var level = levels[ i ];

				data.object.levels.push( {
					object: level.object.uuid,
					distance: level.distance
				} );

			}

			return data;

		}

	} );

	/**
	 * @author mikael emtinger / http://gomo.se/
	 * @author alteredq / http://alteredqualia.com/
	 * @author michael guerrero / http://realitymeltdown.com
	 * @author ikerr / http://verold.com
	 */

	function Skeleton( bones, boneInverses, useVertexTexture ) {

		this.useVertexTexture = useVertexTexture !== undefined ? useVertexTexture : true;

		this.identityMatrix = new Matrix4();

		// copy the bone array

		bones = bones || [];

		this.bones = bones.slice( 0 );

		// create a bone texture or an array of floats

		if ( this.useVertexTexture ) {

			// layout (1 matrix = 4 pixels)
			//      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
			//  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
			//       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
			//       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
			//       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)


			var size = Math.sqrt( this.bones.length * 4 ); // 4 pixels needed for 1 matrix
			size = _Math.nextPowerOfTwo( Math.ceil( size ) );
			size = Math.max( size, 4 );

			this.boneTextureWidth = size;
			this.boneTextureHeight = size;

			this.boneMatrices = new Float32Array( this.boneTextureWidth * this.boneTextureHeight * 4 ); // 4 floats per RGBA pixel
			this.boneTexture = new DataTexture( this.boneMatrices, this.boneTextureWidth, this.boneTextureHeight, RGBAFormat, FloatType );

		} else {

			this.boneMatrices = new Float32Array( 16 * this.bones.length );

		}

		// use the supplied bone inverses or calculate the inverses

		if ( boneInverses === undefined ) {

			this.calculateInverses();

		} else {

			if ( this.bones.length === boneInverses.length ) {

				this.boneInverses = boneInverses.slice( 0 );

			} else {

				console.warn( 'THREE.Skeleton bonInverses is the wrong length.' );

				this.boneInverses = [];

				for ( var b = 0, bl = this.bones.length; b < bl; b ++ ) {

					this.boneInverses.push( new Matrix4() );

				}

			}

		}

	}

	Object.assign( Skeleton.prototype, {

		calculateInverses: function () {

			this.boneInverses = [];

			for ( var b = 0, bl = this.bones.length; b < bl; b ++ ) {

				var inverse = new Matrix4();

				if ( this.bones[ b ] ) {

					inverse.getInverse( this.bones[ b ].matrixWorld );

				}

				this.boneInverses.push( inverse );

			}

		},

		pose: function () {

			var bone;

			// recover the bind-time world matrices

			for ( var b = 0, bl = this.bones.length; b < bl; b ++ ) {

				bone = this.bones[ b ];

				if ( bone ) {

					bone.matrixWorld.getInverse( this.boneInverses[ b ] );

				}

			}

			// compute the local matrices, positions, rotations and scales

			for ( var b = 0, bl = this.bones.length; b < bl; b ++ ) {

				bone = this.bones[ b ];

				if ( bone ) {

					if ( bone.parent && bone.parent.isBone ) {

						bone.matrix.getInverse( bone.parent.matrixWorld );
						bone.matrix.multiply( bone.matrixWorld );

					} else {

						bone.matrix.copy( bone.matrixWorld );

					}

					bone.matrix.decompose( bone.position, bone.quaternion, bone.scale );

				}

			}

		},

		update: ( function () {

			var offsetMatrix = new Matrix4();

			return function update() {

				// flatten bone matrices to array

				for ( var b = 0, bl = this.bones.length; b < bl; b ++ ) {

					// compute the offset between the current and the original transform

					var matrix = this.bones[ b ] ? this.bones[ b ].matrixWorld : this.identityMatrix;

					offsetMatrix.multiplyMatrices( matrix, this.boneInverses[ b ] );
					offsetMatrix.toArray( this.boneMatrices, b * 16 );

				}

				if ( this.useVertexTexture ) {

					this.boneTexture.needsUpdate = true;

				}

			};

		} )(),

		clone: function () {

			return new Skeleton( this.bones, this.boneInverses, this.useVertexTexture );

		}

	} );

	/**
	 * @author mikael emtinger / http://gomo.se/
	 * @author alteredq / http://alteredqualia.com/
	 * @author ikerr / http://verold.com
	 */

	function Bone() {

		Object3D.call( this );

		this.type = 'Bone';

	}

	Bone.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: Bone,

		isBone: true

	} );

	/**
	 * @author mikael emtinger / http://gomo.se/
	 * @author alteredq / http://alteredqualia.com/
	 * @author ikerr / http://verold.com
	 */

	function SkinnedMesh( geometry, material, useVertexTexture ) {

		Mesh.call( this, geometry, material );

		this.type = 'SkinnedMesh';

		this.bindMode = "attached";
		this.bindMatrix = new Matrix4();
		this.bindMatrixInverse = new Matrix4();

		// init bones

		// TODO: remove bone creation as there is no reason (other than
		// convenience) for THREE.SkinnedMesh to do this.

		var bones = [];

		if ( this.geometry && this.geometry.bones !== undefined ) {

			var bone, gbone;

			for ( var b = 0, bl = this.geometry.bones.length; b < bl; ++ b ) {

				gbone = this.geometry.bones[ b ];

				bone = new Bone();
				bones.push( bone );

				bone.name = gbone.name;
				bone.position.fromArray( gbone.pos );
				bone.quaternion.fromArray( gbone.rotq );
				if ( gbone.scl !== undefined ) bone.scale.fromArray( gbone.scl );

			}

			for ( var b = 0, bl = this.geometry.bones.length; b < bl; ++ b ) {

				gbone = this.geometry.bones[ b ];

				if ( gbone.parent !== - 1 && gbone.parent !== null &&
						bones[ gbone.parent ] !== undefined ) {

					bones[ gbone.parent ].add( bones[ b ] );

				} else {

					this.add( bones[ b ] );

				}

			}

		}

		this.normalizeSkinWeights();

		this.updateMatrixWorld( true );
		this.bind( new Skeleton( bones, undefined, useVertexTexture ), this.matrixWorld );

	}


	SkinnedMesh.prototype = Object.assign( Object.create( Mesh.prototype ), {

		constructor: SkinnedMesh,

		isSkinnedMesh: true,

		bind: function( skeleton, bindMatrix ) {

			this.skeleton = skeleton;

			if ( bindMatrix === undefined ) {

				this.updateMatrixWorld( true );

				this.skeleton.calculateInverses();

				bindMatrix = this.matrixWorld;

			}

			this.bindMatrix.copy( bindMatrix );
			this.bindMatrixInverse.getInverse( bindMatrix );

		},

		pose: function () {

			this.skeleton.pose();

		},

		normalizeSkinWeights: function () {

			if ( this.geometry && this.geometry.isGeometry ) {

				for ( var i = 0; i < this.geometry.skinWeights.length; i ++ ) {

					var sw = this.geometry.skinWeights[ i ];

					var scale = 1.0 / sw.lengthManhattan();

					if ( scale !== Infinity ) {

						sw.multiplyScalar( scale );

					} else {

						sw.set( 1, 0, 0, 0 ); // do something reasonable

					}

				}

			} else if ( this.geometry && this.geometry.isBufferGeometry ) {

				var vec = new Vector4();

				var skinWeight = this.geometry.attributes.skinWeight;

				for ( var i = 0; i < skinWeight.count; i ++ ) {

					vec.x = skinWeight.getX( i );
					vec.y = skinWeight.getY( i );
					vec.z = skinWeight.getZ( i );
					vec.w = skinWeight.getW( i );

					var scale = 1.0 / vec.lengthManhattan();

					if ( scale !== Infinity ) {

						vec.multiplyScalar( scale );

					} else {

						vec.set( 1, 0, 0, 0 ); // do something reasonable

					}

					skinWeight.setXYZW( i, vec.x, vec.y, vec.z, vec.w );

				}

			}

		},

		updateMatrixWorld: function( force ) {

			Mesh.prototype.updateMatrixWorld.call( this, true );

			if ( this.bindMode === "attached" ) {

				this.bindMatrixInverse.getInverse( this.matrixWorld );

			} else if ( this.bindMode === "detached" ) {

				this.bindMatrixInverse.getInverse( this.bindMatrix );

			} else {

				console.warn( 'THREE.SkinnedMesh unrecognized bindMode: ' + this.bindMode );

			}

		},

		clone: function() {

			return new this.constructor( this.geometry, this.material, this.skeleton.useVertexTexture ).copy( this );

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 *
	 * parameters = {
	 *  color: <hex>,
	 *  opacity: <float>,
	 *
	 *  linewidth: <float>,
	 *  linecap: "round",
	 *  linejoin: "round"
	 * }
	 */

	function LineBasicMaterial( parameters ) {

		Material.call( this );

		this.type = 'LineBasicMaterial';

		this.color = new Color( 0xffffff );

		this.linewidth = 1;
		this.linecap = 'round';
		this.linejoin = 'round';

		this.lights = false;

		this.setValues( parameters );

	}

	LineBasicMaterial.prototype = Object.create( Material.prototype );
	LineBasicMaterial.prototype.constructor = LineBasicMaterial;

	LineBasicMaterial.prototype.isLineBasicMaterial = true;

	LineBasicMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.color.copy( source.color );

		this.linewidth = source.linewidth;
		this.linecap = source.linecap;
		this.linejoin = source.linejoin;

		return this;

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function Line( geometry, material, mode ) {

		if ( mode === 1 ) {

			console.warn( 'THREE.Line: parameter THREE.LinePieces no longer supported. Created THREE.LineSegments instead.' );
			return new LineSegments( geometry, material );

		}

		Object3D.call( this );

		this.type = 'Line';

		this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
		this.material = material !== undefined ? material : new LineBasicMaterial( { color: Math.random() * 0xffffff } );

	}

	Line.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: Line,

		isLine: true,

		raycast: ( function () {

			var inverseMatrix = new Matrix4();
			var ray = new Ray();
			var sphere = new Sphere();

			return function raycast( raycaster, intersects ) {

				var precision = raycaster.linePrecision;
				var precisionSq = precision * precision;

				var geometry = this.geometry;
				var matrixWorld = this.matrixWorld;

				// Checking boundingSphere distance to ray

				if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

				sphere.copy( geometry.boundingSphere );
				sphere.applyMatrix4( matrixWorld );

				if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;

				//

				inverseMatrix.getInverse( matrixWorld );
				ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );

				var vStart = new Vector3();
				var vEnd = new Vector3();
				var interSegment = new Vector3();
				var interRay = new Vector3();
				var step = (this && this.isLineSegments) ? 2 : 1;

				if ( geometry.isBufferGeometry ) {

					var index = geometry.index;
					var attributes = geometry.attributes;
					var positions = attributes.position.array;

					if ( index !== null ) {

						var indices = index.array;

						for ( var i = 0, l = indices.length - 1; i < l; i += step ) {

							var a = indices[ i ];
							var b = indices[ i + 1 ];

							vStart.fromArray( positions, a * 3 );
							vEnd.fromArray( positions, b * 3 );

							var distSq = ray.distanceSqToSegment( vStart, vEnd, interRay, interSegment );

							if ( distSq > precisionSq ) continue;

							interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation

							var distance = raycaster.ray.origin.distanceTo( interRay );

							if ( distance < raycaster.near || distance > raycaster.far ) continue;

							intersects.push( {

								distance: distance,
								// What do we want? intersection point on the ray or on the segment??
								// point: raycaster.ray.at( distance ),
								point: interSegment.clone().applyMatrix4( this.matrixWorld ),
								index: i,
								face: null,
								faceIndex: null,
								object: this

							} );

						}

					} else {

						for ( var i = 0, l = positions.length / 3 - 1; i < l; i += step ) {

							vStart.fromArray( positions, 3 * i );
							vEnd.fromArray( positions, 3 * i + 3 );

							var distSq = ray.distanceSqToSegment( vStart, vEnd, interRay, interSegment );

							if ( distSq > precisionSq ) continue;

							interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation

							var distance = raycaster.ray.origin.distanceTo( interRay );

							if ( distance < raycaster.near || distance > raycaster.far ) continue;

							intersects.push( {

								distance: distance,
								// What do we want? intersection point on the ray or on the segment??
								// point: raycaster.ray.at( distance ),
								point: interSegment.clone().applyMatrix4( this.matrixWorld ),
								index: i,
								face: null,
								faceIndex: null,
								object: this

							} );

						}

					}

				} else if ( geometry.isGeometry ) {

					var vertices = geometry.vertices;
					var nbVertices = vertices.length;

					for ( var i = 0; i < nbVertices - 1; i += step ) {

						var distSq = ray.distanceSqToSegment( vertices[ i ], vertices[ i + 1 ], interRay, interSegment );

						if ( distSq > precisionSq ) continue;

						interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation

						var distance = raycaster.ray.origin.distanceTo( interRay );

						if ( distance < raycaster.near || distance > raycaster.far ) continue;

						intersects.push( {

							distance: distance,
							// What do we want? intersection point on the ray or on the segment??
							// point: raycaster.ray.at( distance ),
							point: interSegment.clone().applyMatrix4( this.matrixWorld ),
							index: i,
							face: null,
							faceIndex: null,
							object: this

						} );

					}

				}

			};

		}() ),

		clone: function () {

			return new this.constructor( this.geometry, this.material ).copy( this );

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function LineSegments( geometry, material ) {

		Line.call( this, geometry, material );

		this.type = 'LineSegments';

	}

	LineSegments.prototype = Object.assign( Object.create( Line.prototype ), {

		constructor: LineSegments,

		isLineSegments: true

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 *
	 * parameters = {
	 *  color: <hex>,
	 *  opacity: <float>,
	 *  map: new THREE.Texture( <Image> ),
	 *
	 *  size: <float>,
	 *  sizeAttenuation: <bool>
	 * }
	 */

	function PointsMaterial( parameters ) {

		Material.call( this );

		this.type = 'PointsMaterial';

		this.color = new Color( 0xffffff );

		this.map = null;

		this.size = 1;
		this.sizeAttenuation = true;

		this.lights = false;

		this.setValues( parameters );

	}

	PointsMaterial.prototype = Object.create( Material.prototype );
	PointsMaterial.prototype.constructor = PointsMaterial;

	PointsMaterial.prototype.isPointsMaterial = true;

	PointsMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.color.copy( source.color );

		this.map = source.map;

		this.size = source.size;
		this.sizeAttenuation = source.sizeAttenuation;

		return this;

	};

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	function Points( geometry, material ) {

		Object3D.call( this );

		this.type = 'Points';

		this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
		this.material = material !== undefined ? material : new PointsMaterial( { color: Math.random() * 0xffffff } );

	}

	Points.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: Points,

		isPoints: true,

		raycast: ( function () {

			var inverseMatrix = new Matrix4();
			var ray = new Ray();
			var sphere = new Sphere();

			return function raycast( raycaster, intersects ) {

				var object = this;
				var geometry = this.geometry;
				var matrixWorld = this.matrixWorld;
				var threshold = raycaster.params.Points.threshold;

				// Checking boundingSphere distance to ray

				if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

				sphere.copy( geometry.boundingSphere );
				sphere.applyMatrix4( matrixWorld );

				if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;

				//

				inverseMatrix.getInverse( matrixWorld );
				ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );

				var localThreshold = threshold / ( ( this.scale.x + this.scale.y + this.scale.z ) / 3 );
				var localThresholdSq = localThreshold * localThreshold;
				var position = new Vector3();

				function testPoint( point, index ) {

					var rayPointDistanceSq = ray.distanceSqToPoint( point );

					if ( rayPointDistanceSq < localThresholdSq ) {

						var intersectPoint = ray.closestPointToPoint( point );
						intersectPoint.applyMatrix4( matrixWorld );

						var distance = raycaster.ray.origin.distanceTo( intersectPoint );

						if ( distance < raycaster.near || distance > raycaster.far ) return;

						intersects.push( {

							distance: distance,
							distanceToRay: Math.sqrt( rayPointDistanceSq ),
							point: intersectPoint.clone(),
							index: index,
							face: null,
							object: object

						} );

					}

				}

				if ( geometry.isBufferGeometry ) {

					var index = geometry.index;
					var attributes = geometry.attributes;
					var positions = attributes.position.array;

					if ( index !== null ) {

						var indices = index.array;

						for ( var i = 0, il = indices.length; i < il; i ++ ) {

							var a = indices[ i ];

							position.fromArray( positions, a * 3 );

							testPoint( position, a );

						}

					} else {

						for ( var i = 0, l = positions.length / 3; i < l; i ++ ) {

							position.fromArray( positions, i * 3 );

							testPoint( position, i );

						}

					}

				} else {

					var vertices = geometry.vertices;

					for ( var i = 0, l = vertices.length; i < l; i ++ ) {

						testPoint( vertices[ i ], i );

					}

				}

			};

		}() ),

		clone: function () {

			return new this.constructor( this.geometry, this.material ).copy( this );

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function Group() {

		Object3D.call( this );

		this.type = 'Group';

	}

	Group.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: Group

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function VideoTexture( video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy ) {

		Texture.call( this, video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );

		this.generateMipmaps = false;

		var scope = this;

		function update() {

			requestAnimationFrame( update );

			if ( video.readyState >= video.HAVE_CURRENT_DATA ) {

				scope.needsUpdate = true;

			}

		}

		update();

	}

	VideoTexture.prototype = Object.create( Texture.prototype );
	VideoTexture.prototype.constructor = VideoTexture;

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	function CompressedTexture( mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding ) {

		Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );

		this.image = { width: width, height: height };
		this.mipmaps = mipmaps;

		// no flipping for cube textures
		// (also flipping doesn't work for compressed textures )

		this.flipY = false;

		// can't generate mipmaps for compressed textures
		// mips must be embedded in DDS files

		this.generateMipmaps = false;

	}

	CompressedTexture.prototype = Object.create( Texture.prototype );
	CompressedTexture.prototype.constructor = CompressedTexture;

	CompressedTexture.prototype.isCompressedTexture = true;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function CanvasTexture( canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy ) {

		Texture.call( this, canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );

		this.needsUpdate = true;

	}

	CanvasTexture.prototype = Object.create( Texture.prototype );
	CanvasTexture.prototype.constructor = CanvasTexture;

	/**
	 * @author Matt DesLauriers / @mattdesl
	 * @author atix / arthursilber.de
	 */

	function DepthTexture( width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format ) {

		format = format !== undefined ? format : DepthFormat;

		if ( format !== DepthFormat && format !== DepthStencilFormat ) {

			throw new Error( 'DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat' )

		}

		if ( type === undefined && format === DepthFormat ) type = UnsignedShortType;
		if ( type === undefined && format === DepthStencilFormat ) type = UnsignedInt248Type;

		Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );

		this.image = { width: width, height: height };

		this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
		this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;

		this.flipY = false;
		this.generateMipmaps	= false;

	}

	DepthTexture.prototype = Object.create( Texture.prototype );
	DepthTexture.prototype.constructor = DepthTexture;
	DepthTexture.prototype.isDepthTexture = true;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WireframeGeometry( geometry ) {

		BufferGeometry.call( this );

		var edge = [ 0, 0 ], hash = {};

		function sortFunction( a, b ) {

			return a - b;

		}

		var keys = [ 'a', 'b', 'c' ];

		if ( geometry && geometry.isGeometry ) {

			var vertices = geometry.vertices;
			var faces = geometry.faces;
			var numEdges = 0;

			// allocate maximal size
			var edges = new Uint32Array( 6 * faces.length );

			for ( var i = 0, l = faces.length; i < l; i ++ ) {

				var face = faces[ i ];

				for ( var j = 0; j < 3; j ++ ) {

					edge[ 0 ] = face[ keys[ j ] ];
					edge[ 1 ] = face[ keys[ ( j + 1 ) % 3 ] ];
					edge.sort( sortFunction );

					var key = edge.toString();

					if ( hash[ key ] === undefined ) {

						edges[ 2 * numEdges ] = edge[ 0 ];
						edges[ 2 * numEdges + 1 ] = edge[ 1 ];
						hash[ key ] = true;
						numEdges ++;

					}

				}

			}

			var coords = new Float32Array( numEdges * 2 * 3 );

			for ( var i = 0, l = numEdges; i < l; i ++ ) {

				for ( var j = 0; j < 2; j ++ ) {

					var vertex = vertices[ edges [ 2 * i + j ] ];

					var index = 6 * i + 3 * j;
					coords[ index + 0 ] = vertex.x;
					coords[ index + 1 ] = vertex.y;
					coords[ index + 2 ] = vertex.z;

				}

			}

			this.addAttribute( 'position', new BufferAttribute( coords, 3 ) );

		} else if ( geometry && geometry.isBufferGeometry ) {

			if ( geometry.index !== null ) {

				// Indexed BufferGeometry

				var indices = geometry.index.array;
				var vertices = geometry.attributes.position;
				var groups = geometry.groups;
				var numEdges = 0;

				if ( groups.length === 0 ) {

					geometry.addGroup( 0, indices.length );

				}

				// allocate maximal size
				var edges = new Uint32Array( 2 * indices.length );

				for ( var o = 0, ol = groups.length; o < ol; ++ o ) {

					var group = groups[ o ];

					var start = group.start;
					var count = group.count;

					for ( var i = start, il = start + count; i < il; i += 3 ) {

						for ( var j = 0; j < 3; j ++ ) {

							edge[ 0 ] = indices[ i + j ];
							edge[ 1 ] = indices[ i + ( j + 1 ) % 3 ];
							edge.sort( sortFunction );

							var key = edge.toString();

							if ( hash[ key ] === undefined ) {

								edges[ 2 * numEdges ] = edge[ 0 ];
								edges[ 2 * numEdges + 1 ] = edge[ 1 ];
								hash[ key ] = true;
								numEdges ++;

							}

						}

					}

				}

				var coords = new Float32Array( numEdges * 2 * 3 );

				for ( var i = 0, l = numEdges; i < l; i ++ ) {

					for ( var j = 0; j < 2; j ++ ) {

						var index = 6 * i + 3 * j;
						var index2 = edges[ 2 * i + j ];

						coords[ index + 0 ] = vertices.getX( index2 );
						coords[ index + 1 ] = vertices.getY( index2 );
						coords[ index + 2 ] = vertices.getZ( index2 );

					}

				}

				this.addAttribute( 'position', new BufferAttribute( coords, 3 ) );

			} else {

				// non-indexed BufferGeometry

				var vertices = geometry.attributes.position.array;
				var numEdges = vertices.length / 3;
				var numTris = numEdges / 3;

				var coords = new Float32Array( numEdges * 2 * 3 );

				for ( var i = 0, l = numTris; i < l; i ++ ) {

					for ( var j = 0; j < 3; j ++ ) {

						var index = 18 * i + 6 * j;

						var index1 = 9 * i + 3 * j;
						coords[ index + 0 ] = vertices[ index1 ];
						coords[ index + 1 ] = vertices[ index1 + 1 ];
						coords[ index + 2 ] = vertices[ index1 + 2 ];

						var index2 = 9 * i + 3 * ( ( j + 1 ) % 3 );
						coords[ index + 3 ] = vertices[ index2 ];
						coords[ index + 4 ] = vertices[ index2 + 1 ];
						coords[ index + 5 ] = vertices[ index2 + 2 ];

					}

				}

				this.addAttribute( 'position', new BufferAttribute( coords, 3 ) );

			}

		}

	}

	WireframeGeometry.prototype = Object.create( BufferGeometry.prototype );
	WireframeGeometry.prototype.constructor = WireframeGeometry;

	/**
	 * @author Mugen87 / https://github.com/Mugen87
	 *
	 * Parametric Surfaces Geometry
	 * based on the brilliant article by @prideout http://prideout.net/blog/?p=44
	 */

	function ParametricBufferGeometry( func, slices, stacks ) {

		BufferGeometry.call( this );

		this.type = 'ParametricBufferGeometry';

		this.parameters = {
			func: func,
			slices: slices,
			stacks: stacks
		};

		// generate vertices and uvs

		var vertices = [];
		var uvs = [];

		var i, j, p;
		var u, v;

		var sliceCount = slices + 1;

		for ( i = 0; i <= stacks; i ++ ) {

			v = i / stacks;

			for ( j = 0; j <= slices; j ++ ) {

				u = j / slices;

				p = func( u, v );
				vertices.push( p.x, p.y, p.z );

				uvs.push( u, v );

			}

		}

		// generate indices

		var indices = [];
		var a, b, c, d;

		for ( i = 0; i < stacks; i ++ ) {

			for ( j = 0; j < slices; j ++ ) {

				a = i * sliceCount + j;
				b = i * sliceCount + j + 1;
				c = ( i + 1 ) * sliceCount + j + 1;
				d = ( i + 1 ) * sliceCount + j;

				// faces one and two

				indices.push( a, b, d );
				indices.push( b, c, d );

			}

		}

		// build geometry

		this.setIndex( new ( indices.length > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute )( indices, 1 ) );
		this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

		// generate normals

		this.computeVertexNormals();

	}

	ParametricBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	ParametricBufferGeometry.prototype.constructor = ParametricBufferGeometry;

	/**
	 * @author zz85 / https://github.com/zz85
	 *
	 * Parametric Surfaces Geometry
	 * based on the brilliant article by @prideout http://prideout.net/blog/?p=44
	 */

	function ParametricGeometry( func, slices, stacks ) {

		Geometry.call( this );

		this.type = 'ParametricGeometry';

		this.parameters = {
			func: func,
			slices: slices,
			stacks: stacks
		};

		this.fromBufferGeometry( new ParametricBufferGeometry( func, slices, stacks ) );
		this.mergeVertices();

	}

	ParametricGeometry.prototype = Object.create( Geometry.prototype );
	ParametricGeometry.prototype.constructor = ParametricGeometry;

	/**
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	function PolyhedronBufferGeometry( vertices, indices, radius, detail ) {

		BufferGeometry.call( this );

		this.type = 'PolyhedronBufferGeometry';

		this.parameters = {
			vertices: vertices,
			indices: indices,
			radius: radius,
			detail: detail
		};

		radius = radius || 1;
		detail = detail || 0;

		// default buffer data

		var vertexBuffer = [];
		var uvBuffer = [];

		// the subdivision creates the vertex buffer data

		subdivide( detail );

		// all vertices should lie on a conceptual sphere with a given radius

		appplyRadius( radius );

		// finally, create the uv data

		generateUVs();

		// build non-indexed geometry

		this.addAttribute( 'position', new Float32BufferAttribute( vertexBuffer, 3 ) );
		this.addAttribute( 'normal', new Float32BufferAttribute( vertexBuffer.slice(), 3 ) );
		this.addAttribute( 'uv', new Float32BufferAttribute( uvBuffer, 2 ) );
		this.normalizeNormals();

		this.boundingSphere = new Sphere( new Vector3(), radius );

		// helper functions

		function subdivide( detail ) {

			var a = new Vector3();
			var b = new Vector3();
			var c = new Vector3();

			// iterate over all faces and apply a subdivison with the given detail value

			for ( var i = 0; i < indices.length; i += 3 ) {

				// get the vertices of the face

				getVertexByIndex( indices[ i + 0 ], a );
				getVertexByIndex( indices[ i + 1 ], b );
				getVertexByIndex( indices[ i + 2 ], c );

				// perform subdivision

				subdivideFace( a, b, c, detail );

			}

		}

		function subdivideFace( a, b, c, detail ) {

			var cols = Math.pow( 2, detail );

			// we use this multidimensional array as a data structure for creating the subdivision

			var v = [];

			var i, j;

			// construct all of the vertices for this subdivision

			for ( i = 0 ; i <= cols; i ++ ) {

				v[ i ] = [];

				var aj = a.clone().lerp( c, i / cols );
				var bj = b.clone().lerp( c, i / cols );

				var rows = cols - i;

				for ( j = 0; j <= rows; j ++ ) {

					if ( j === 0 && i === cols ) {

						v[ i ][ j ] = aj;

					} else {

						v[ i ][ j ] = aj.clone().lerp( bj, j / rows );

					}

				}

			}

			// construct all of the faces

			for ( i = 0; i < cols ; i ++ ) {

				for ( j = 0; j < 2 * ( cols - i ) - 1; j ++ ) {

					var k = Math.floor( j / 2 );

					if ( j % 2 === 0 ) {

						pushVertex( v[ i ][ k + 1 ] );
						pushVertex( v[ i + 1 ][ k ] );
						pushVertex( v[ i ][ k ] );

					} else {

						pushVertex( v[ i ][ k + 1 ] );
						pushVertex( v[ i + 1 ][ k + 1 ] );
						pushVertex( v[ i + 1 ][ k ] );

					}

				}

			}

		}

		function appplyRadius( radius ) {

			var vertex = new Vector3();

			// iterate over the entire buffer and apply the radius to each vertex

			for ( var i = 0; i < vertexBuffer.length; i += 3 ) {

				vertex.x = vertexBuffer[ i + 0 ];
				vertex.y = vertexBuffer[ i + 1 ];
				vertex.z = vertexBuffer[ i + 2 ];

				vertex.normalize().multiplyScalar( radius );

				vertexBuffer[ i + 0 ] = vertex.x;
				vertexBuffer[ i + 1 ] = vertex.y;
				vertexBuffer[ i + 2 ] = vertex.z;

			}

		}

		function generateUVs() {

			var vertex = new Vector3();

			for ( var i = 0; i < vertexBuffer.length; i += 3 ) {

				vertex.x = vertexBuffer[ i + 0 ];
				vertex.y = vertexBuffer[ i + 1 ];
				vertex.z = vertexBuffer[ i + 2 ];

				var u = azimuth( vertex ) / 2 / Math.PI + 0.5;
				var v = inclination( vertex ) / Math.PI + 0.5;
				uvBuffer.push( u, 1 - v );

			}

			correctUVs();

			correctSeam();

		}

		function correctSeam() {

			// handle case when face straddles the seam, see #3269

			for ( var i = 0; i < uvBuffer.length; i += 6 ) {

				// uv data of a single face

				var x0 = uvBuffer[ i + 0 ];
				var x1 = uvBuffer[ i + 2 ];
				var x2 = uvBuffer[ i + 4 ];

				var max = Math.max( x0, x1, x2 );
				var min = Math.min( x0, x1, x2 );

				// 0.9 is somewhat arbitrary

				if ( max > 0.9 && min < 0.1 ) {

					if ( x0 < 0.2 ) uvBuffer[ i + 0 ] += 1;
					if ( x1 < 0.2 ) uvBuffer[ i + 2 ] += 1;
					if ( x2 < 0.2 ) uvBuffer[ i + 4 ] += 1;

				}

			}

		}

		function pushVertex( vertex ) {

			vertexBuffer.push( vertex.x, vertex.y, vertex.z );

		}

		function getVertexByIndex( index, vertex ) {

			var stride = index * 3;

			vertex.x = vertices[ stride + 0 ];
			vertex.y = vertices[ stride + 1 ];
			vertex.z = vertices[ stride + 2 ];

		}

		function correctUVs() {

			var a = new Vector3();
			var b = new Vector3();
			var c = new Vector3();

			var centroid = new Vector3();

			var uvA = new Vector2();
			var uvB = new Vector2();
			var uvC = new Vector2();

			for ( var i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6 ) {

				a.set( vertexBuffer[ i + 0 ], vertexBuffer[ i + 1 ], vertexBuffer[ i + 2 ] );
				b.set( vertexBuffer[ i + 3 ], vertexBuffer[ i + 4 ], vertexBuffer[ i + 5 ] );
				c.set( vertexBuffer[ i + 6 ], vertexBuffer[ i + 7 ], vertexBuffer[ i + 8 ] );

				uvA.set( uvBuffer[ j + 0 ], uvBuffer[ j + 1 ] );
				uvB.set( uvBuffer[ j + 2 ], uvBuffer[ j + 3 ] );
				uvC.set( uvBuffer[ j + 4 ], uvBuffer[ j + 5 ] );

				centroid.copy( a ).add( b ).add( c ).divideScalar( 3 );

				var azi = azimuth( centroid );

				correctUV( uvA, j + 0, a, azi );
				correctUV( uvB, j + 2, b, azi );
				correctUV( uvC, j + 4, c, azi );

			}

		}

		function correctUV( uv, stride, vector, azimuth  ) {

			if ( ( azimuth < 0 ) && ( uv.x === 1 ) ) {

				uvBuffer[ stride ] =  uv.x - 1;

			}

			if ( ( vector.x === 0 ) && ( vector.z === 0 ) ) {

				uvBuffer[ stride ] = azimuth / 2 / Math.PI + 0.5;

			}

		}

		// Angle around the Y axis, counter-clockwise when looking from above.

		function azimuth( vector ) {

			return Math.atan2( vector.z, - vector.x );

		}


		// Angle above the XZ plane.

		function inclination( vector ) {

			return Math.atan2( - vector.y, Math.sqrt( ( vector.x * vector.x ) + ( vector.z * vector.z ) ) );

		}

	}

	PolyhedronBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	PolyhedronBufferGeometry.prototype.constructor = PolyhedronBufferGeometry;

	/**
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	function TetrahedronBufferGeometry( radius, detail ) {

		var vertices = [
			1,  1,  1,   - 1, - 1,  1,   - 1,  1, - 1,    1, - 1, - 1
		];

		var indices = [
			2,  1,  0,    0,  3,  2,    1,  3,  0,    2,  3,  1
		];

		PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );

		this.type = 'TetrahedronBufferGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

	}

	TetrahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
	TetrahedronBufferGeometry.prototype.constructor = TetrahedronBufferGeometry;

	/**
	 * @author timothypratley / https://github.com/timothypratley
	 */

	function TetrahedronGeometry( radius, detail ) {

		Geometry.call( this );

		this.type = 'TetrahedronGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

		this.fromBufferGeometry( new TetrahedronBufferGeometry( radius, detail ) );
		this.mergeVertices();

	}

	TetrahedronGeometry.prototype = Object.create( Geometry.prototype );
	TetrahedronGeometry.prototype.constructor = TetrahedronGeometry;

	/**
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	function OctahedronBufferGeometry( radius,detail ) {

		var vertices = [
			1, 0, 0,   - 1, 0, 0,    0, 1, 0,    0, - 1, 0,    0, 0, 1,    0, 0, - 1
		];

		var indices = [
			0, 2, 4,    0, 4, 3,    0, 3, 5,    0, 5, 2,    1, 2, 5,    1, 5, 3,    1, 3, 4,    1, 4, 2
		];

		PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );

		this.type = 'OctahedronBufferGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

	}

	OctahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
	OctahedronBufferGeometry.prototype.constructor = OctahedronBufferGeometry;

	/**
	 * @author timothypratley / https://github.com/timothypratley
	 */

	function OctahedronGeometry( radius, detail ) {

		Geometry.call( this );

		this.type = 'OctahedronGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

		this.fromBufferGeometry( new OctahedronBufferGeometry( radius, detail ) );
		this.mergeVertices();

	}

	OctahedronGeometry.prototype = Object.create( Geometry.prototype );
	OctahedronGeometry.prototype.constructor = OctahedronGeometry;

	/**
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	function IcosahedronBufferGeometry( radius, detail ) {

		var t = ( 1 + Math.sqrt( 5 ) ) / 2;

		var vertices = [
			- 1,  t,  0,    1,  t,  0,   - 1, - t,  0,    1, - t,  0,
			 0, - 1,  t,    0,  1,  t,    0, - 1, - t,    0,  1, - t,
			 t,  0, - 1,    t,  0,  1,   - t,  0, - 1,   - t,  0,  1
		];

		var indices = [
			 0, 11,  5,    0,  5,  1,    0,  1,  7,    0,  7, 10,    0, 10, 11,
			 1,  5,  9,    5, 11,  4,   11, 10,  2,   10,  7,  6,    7,  1,  8,
			 3,  9,  4,    3,  4,  2,    3,  2,  6,    3,  6,  8,    3,  8,  9,
			 4,  9,  5,    2,  4, 11,    6,  2, 10,    8,  6,  7,    9,  8,  1
		];

		PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );

		this.type = 'IcosahedronBufferGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

	}

	IcosahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
	IcosahedronBufferGeometry.prototype.constructor = IcosahedronBufferGeometry;

	/**
	 * @author timothypratley / https://github.com/timothypratley
	 */

	function IcosahedronGeometry( radius, detail ) {

	 	Geometry.call( this );

		this.type = 'IcosahedronGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

		this.fromBufferGeometry( new IcosahedronBufferGeometry( radius, detail ) );
		this.mergeVertices();

	}

	IcosahedronGeometry.prototype = Object.create( Geometry.prototype );
	IcosahedronGeometry.prototype.constructor = IcosahedronGeometry;

	/**
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	function DodecahedronBufferGeometry( radius, detail ) {

		var t = ( 1 + Math.sqrt( 5 ) ) / 2;
		var r = 1 / t;

		var vertices = [

			// (±1, ±1, ±1)
			- 1, - 1, - 1,    - 1, - 1,  1,
			- 1,  1, - 1,    - 1,  1,  1,
			 1, - 1, - 1,     1, - 1,  1,
			 1,  1, - 1,     1,  1,  1,

			// (0, ±1/φ, ±φ)
			 0, - r, - t,     0, - r,  t,
			 0,  r, - t,     0,  r,  t,

			// (±1/φ, ±φ, 0)
			- r, - t,  0,    - r,  t,  0,
			 r, - t,  0,     r,  t,  0,

			// (±φ, 0, ±1/φ)
			- t,  0, - r,     t,  0, - r,
			- t,  0,  r,     t,  0,  r
		];

		var indices = [
			 3, 11,  7,      3,  7, 15,      3, 15, 13,
			 7, 19, 17,      7, 17,  6,      7,  6, 15,
			17,  4,  8,     17,  8, 10,     17, 10,  6,
			 8,  0, 16,      8, 16,  2,      8,  2, 10,
			 0, 12,  1,      0,  1, 18,      0, 18, 16,
			 6, 10,  2,      6,  2, 13,      6, 13, 15,
			 2, 16, 18,      2, 18,  3,      2,  3, 13,
			18,  1,  9,     18,  9, 11,     18, 11,  3,
			 4, 14, 12,      4, 12,  0,      4,  0,  8,
			11,  9,  5,     11,  5, 19,     11, 19,  7,
			19,  5, 14,     19, 14,  4,     19,  4, 17,
			 1, 12, 14,      1, 14,  5,      1,  5,  9
		];

		PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );

		this.type = 'DodecahedronBufferGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

	}

	DodecahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
	DodecahedronBufferGeometry.prototype.constructor = DodecahedronBufferGeometry;

	/**
	 * @author Abe Pazos / https://hamoid.com
	 */

	function DodecahedronGeometry( radius, detail ) {

		Geometry.call( this );

		this.type = 'DodecahedronGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

		this.fromBufferGeometry( new DodecahedronBufferGeometry( radius, detail ) );
		this.mergeVertices();

	}

	DodecahedronGeometry.prototype = Object.create( Geometry.prototype );
	DodecahedronGeometry.prototype.constructor = DodecahedronGeometry;

	/**
	 * @author clockworkgeek / https://github.com/clockworkgeek
	 * @author timothypratley / https://github.com/timothypratley
	 * @author WestLangley / http://github.com/WestLangley
	*/

	function PolyhedronGeometry( vertices, indices, radius, detail ) {

		Geometry.call( this );

		this.type = 'PolyhedronGeometry';

		this.parameters = {
			vertices: vertices,
			indices: indices,
			radius: radius,
			detail: detail
		};

		this.fromBufferGeometry( new PolyhedronBufferGeometry( vertices, indices, radius, detail ) );
		this.mergeVertices();

	}

	PolyhedronGeometry.prototype = Object.create( Geometry.prototype );
	PolyhedronGeometry.prototype.constructor = PolyhedronGeometry;

	/**
	 * @author Mugen87 / https://github.com/Mugen87
	 *
	 * Creates a tube which extrudes along a 3d spline.
	 *
	 */

	function TubeBufferGeometry( path, tubularSegments, radius, radialSegments, closed ) {

		BufferGeometry.call( this );

		this.type = 'TubeBufferGeometry';

		this.parameters = {
			path: path,
			tubularSegments: tubularSegments,
			radius: radius,
			radialSegments: radialSegments,
			closed: closed
		};

		tubularSegments = tubularSegments || 64;
		radius = radius || 1;
		radialSegments = radialSegments || 8;
		closed = closed || false;

		var frames = path.computeFrenetFrames( tubularSegments, closed );

		// expose internals

		this.tangents = frames.tangents;
		this.normals = frames.normals;
		this.binormals = frames.binormals;

		// helper variables

		var vertex = new Vector3();
		var normal = new Vector3();
		var uv = new Vector2();

		var i, j;

		// buffer

		var vertices = [];
		var normals = [];
		var uvs = [];
		var indices = [];

		// create buffer data

		generateBufferData();

		// build geometry

		this.setIndex( new ( indices.length > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute )( indices, 1 ) );
		this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

		// functions

		function generateBufferData() {

			for ( i = 0; i < tubularSegments; i ++ ) {

				generateSegment( i );

			}

			// if the geometry is not closed, generate the last row of vertices and normals
			// at the regular position on the given path
			//
			// if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)

			generateSegment( ( closed === false ) ? tubularSegments : 0 );

			// uvs are generated in a separate function.
			// this makes it easy compute correct values for closed geometries

			generateUVs();

			// finally create faces

			generateIndices();

		}

		function generateSegment( i ) {

			// we use getPointAt to sample evenly distributed points from the given path

			var P = path.getPointAt( i / tubularSegments );

			// retrieve corresponding normal and binormal

			var N = frames.normals[ i ];
			var B = frames.binormals[ i ];

			// generate normals and vertices for the current segment

			for ( j = 0; j <= radialSegments; j ++ ) {

				var v = j / radialSegments * Math.PI * 2;

				var sin =   Math.sin( v );
				var cos = - Math.cos( v );

				// normal

				normal.x = ( cos * N.x + sin * B.x );
				normal.y = ( cos * N.y + sin * B.y );
				normal.z = ( cos * N.z + sin * B.z );
				normal.normalize();

				normals.push( normal.x, normal.y, normal.z );

				// vertex

				vertex.x = P.x + radius * normal.x;
				vertex.y = P.y + radius * normal.y;
				vertex.z = P.z + radius * normal.z;

				vertices.push( vertex.x, vertex.y, vertex.z );

			}

		}

		function generateIndices() {

			for ( j = 1; j <= tubularSegments; j ++ ) {

				for ( i = 1; i <= radialSegments; i ++ ) {

					var a = ( radialSegments + 1 ) * ( j - 1 ) + ( i - 1 );
					var b = ( radialSegments + 1 ) * j + ( i - 1 );
					var c = ( radialSegments + 1 ) * j + i;
					var d = ( radialSegments + 1 ) * ( j - 1 ) + i;

					// faces

					indices.push( a, b, d );
					indices.push( b, c, d );

				}

			}

		}

		function generateUVs() {

			for ( i = 0; i <= tubularSegments; i ++ ) {

				for ( j = 0; j <= radialSegments; j ++ ) {

					uv.x = i / tubularSegments;
					uv.y = j / radialSegments;

					uvs.push( uv.x, uv.y );

				}

			}

		}

	}

	TubeBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	TubeBufferGeometry.prototype.constructor = TubeBufferGeometry;

	/**
	 * @author oosmoxiecode / https://github.com/oosmoxiecode
	 * @author WestLangley / https://github.com/WestLangley
	 * @author zz85 / https://github.com/zz85
	 * @author miningold / https://github.com/miningold
	 * @author jonobr1 / https://github.com/jonobr1
	 *
	 * Creates a tube which extrudes along a 3d spline.
	 */

	function TubeGeometry( path, tubularSegments, radius, radialSegments, closed, taper ) {

		Geometry.call( this );

		this.type = 'TubeGeometry';

		this.parameters = {
			path: path,
			tubularSegments: tubularSegments,
			radius: radius,
			radialSegments: radialSegments,
			closed: closed
		};

		if ( taper !== undefined ) console.warn( 'THREE.TubeGeometry: taper has been removed.' );

		var bufferGeometry = new TubeBufferGeometry( path, tubularSegments, radius, radialSegments, closed );

		// expose internals

		this.tangents = bufferGeometry.tangents;
		this.normals = bufferGeometry.normals;
		this.binormals = bufferGeometry.binormals;

		// create geometry

		this.fromBufferGeometry( bufferGeometry );
		this.mergeVertices();

	}

	TubeGeometry.prototype = Object.create( Geometry.prototype );
	TubeGeometry.prototype.constructor = TubeGeometry;

	/**
	 * @author Mugen87 / https://github.com/Mugen87
	 *
	 * see: http://www.blackpawn.com/texts/pqtorus/
	 */
	function TorusKnotBufferGeometry( radius, tube, tubularSegments, radialSegments, p, q ) {

		BufferGeometry.call( this );

		this.type = 'TorusKnotBufferGeometry';

		this.parameters = {
			radius: radius,
			tube: tube,
			tubularSegments: tubularSegments,
			radialSegments: radialSegments,
			p: p,
			q: q
		};

		radius = radius || 100;
		tube = tube || 40;
		tubularSegments = Math.floor( tubularSegments ) || 64;
		radialSegments = Math.floor( radialSegments ) || 8;
		p = p || 2;
		q = q || 3;

		// used to calculate buffer length
		var vertexCount = ( ( radialSegments + 1 ) * ( tubularSegments + 1 ) );
		var indexCount = radialSegments * tubularSegments * 2 * 3;

		// buffers
		var indices = new BufferAttribute( new ( indexCount > 65535 ? Uint32Array : Uint16Array )( indexCount ) , 1 );
		var vertices = new BufferAttribute( new Float32Array( vertexCount * 3 ), 3 );
		var normals = new BufferAttribute( new Float32Array( vertexCount * 3 ), 3 );
		var uvs = new BufferAttribute( new Float32Array( vertexCount * 2 ), 2 );

		// helper variables
		var i, j, index = 0, indexOffset = 0;

		var vertex = new Vector3();
		var normal = new Vector3();
		var uv = new Vector2();

		var P1 = new Vector3();
		var P2 = new Vector3();

		var B = new Vector3();
		var T = new Vector3();
		var N = new Vector3();

		// generate vertices, normals and uvs

		for ( i = 0; i <= tubularSegments; ++ i ) {

			// the radian "u" is used to calculate the position on the torus curve of the current tubular segement

			var u = i / tubularSegments * p * Math.PI * 2;

			// now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
			// these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions

			calculatePositionOnCurve( u, p, q, radius, P1 );
			calculatePositionOnCurve( u + 0.01, p, q, radius, P2 );

			// calculate orthonormal basis

			T.subVectors( P2, P1 );
			N.addVectors( P2, P1 );
			B.crossVectors( T, N );
			N.crossVectors( B, T );

			// normalize B, N. T can be ignored, we don't use it

			B.normalize();
			N.normalize();

			for ( j = 0; j <= radialSegments; ++ j ) {

				// now calculate the vertices. they are nothing more than an extrusion of the torus curve.
				// because we extrude a shape in the xy-plane, there is no need to calculate a z-value.

				var v = j / radialSegments * Math.PI * 2;
				var cx = - tube * Math.cos( v );
				var cy = tube * Math.sin( v );

				// now calculate the final vertex position.
				// first we orient the extrusion with our basis vectos, then we add it to the current position on the curve

				vertex.x = P1.x + ( cx * N.x + cy * B.x );
				vertex.y = P1.y + ( cx * N.y + cy * B.y );
				vertex.z = P1.z + ( cx * N.z + cy * B.z );

				// vertex
				vertices.setXYZ( index, vertex.x, vertex.y, vertex.z );

				// normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
				normal.subVectors( vertex, P1 ).normalize();
				normals.setXYZ( index, normal.x, normal.y, normal.z );

				// uv
				uv.x = i / tubularSegments;
				uv.y = j / radialSegments;
				uvs.setXY( index, uv.x, uv.y );

				// increase index
				index ++;

			}

		}

		// generate indices

		for ( j = 1; j <= tubularSegments; j ++ ) {

			for ( i = 1; i <= radialSegments; i ++ ) {

				// indices
				var a = ( radialSegments + 1 ) * ( j - 1 ) + ( i - 1 );
				var b = ( radialSegments + 1 ) * j + ( i - 1 );
				var c = ( radialSegments + 1 ) * j + i;
				var d = ( radialSegments + 1 ) * ( j - 1 ) + i;

				// face one
				indices.setX( indexOffset, a ); indexOffset++;
				indices.setX( indexOffset, b ); indexOffset++;
				indices.setX( indexOffset, d ); indexOffset++;

				// face two
				indices.setX( indexOffset, b ); indexOffset++;
				indices.setX( indexOffset, c ); indexOffset++;
				indices.setX( indexOffset, d ); indexOffset++;

			}

		}

		// build geometry

		this.setIndex( indices );
		this.addAttribute( 'position', vertices );
		this.addAttribute( 'normal', normals );
		this.addAttribute( 'uv', uvs );

		// this function calculates the current position on the torus curve

		function calculatePositionOnCurve( u, p, q, radius, position ) {

			var cu = Math.cos( u );
			var su = Math.sin( u );
			var quOverP = q / p * u;
			var cs = Math.cos( quOverP );

			position.x = radius * ( 2 + cs ) * 0.5 * cu;
			position.y = radius * ( 2 + cs ) * su * 0.5;
			position.z = radius * Math.sin( quOverP ) * 0.5;

		}

	}

	TorusKnotBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	TorusKnotBufferGeometry.prototype.constructor = TorusKnotBufferGeometry;

	/**
	 * @author oosmoxiecode
	 */

	function TorusKnotGeometry( radius, tube, tubularSegments, radialSegments, p, q, heightScale ) {

		Geometry.call( this );

		this.type = 'TorusKnotGeometry';

		this.parameters = {
			radius: radius,
			tube: tube,
			tubularSegments: tubularSegments,
			radialSegments: radialSegments,
			p: p,
			q: q
		};

		if( heightScale !== undefined ) console.warn( 'THREE.TorusKnotGeometry: heightScale has been deprecated. Use .scale( x, y, z ) instead.' );

		this.fromBufferGeometry( new TorusKnotBufferGeometry( radius, tube, tubularSegments, radialSegments, p, q ) );
		this.mergeVertices();

	}

	TorusKnotGeometry.prototype = Object.create( Geometry.prototype );
	TorusKnotGeometry.prototype.constructor = TorusKnotGeometry;

	/**
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	function TorusBufferGeometry( radius, tube, radialSegments, tubularSegments, arc ) {

		BufferGeometry.call( this );

		this.type = 'TorusBufferGeometry';

		this.parameters = {
			radius: radius,
			tube: tube,
			radialSegments: radialSegments,
			tubularSegments: tubularSegments,
			arc: arc
		};

		radius = radius || 100;
		tube = tube || 40;
		radialSegments = Math.floor( radialSegments ) || 8;
		tubularSegments = Math.floor( tubularSegments ) || 6;
		arc = arc || Math.PI * 2;

		// used to calculate buffer length
		var vertexCount = ( ( radialSegments + 1 ) * ( tubularSegments + 1 ) );
		var indexCount = radialSegments * tubularSegments * 2 * 3;

		// buffers
		var indices = new ( indexCount > 65535 ? Uint32Array : Uint16Array )( indexCount );
		var vertices = new Float32Array( vertexCount * 3 );
		var normals = new Float32Array( vertexCount * 3 );
		var uvs = new Float32Array( vertexCount * 2 );

		// offset variables
		var vertexBufferOffset = 0;
		var uvBufferOffset = 0;
		var indexBufferOffset = 0;

		// helper variables
		var center = new Vector3();
		var vertex = new Vector3();
		var normal = new Vector3();

		var j, i;

		// generate vertices, normals and uvs

		for ( j = 0; j <= radialSegments; j ++ ) {

			for ( i = 0; i <= tubularSegments; i ++ ) {

				var u = i / tubularSegments * arc;
				var v = j / radialSegments * Math.PI * 2;

				// vertex
				vertex.x = ( radius + tube * Math.cos( v ) ) * Math.cos( u );
				vertex.y = ( radius + tube * Math.cos( v ) ) * Math.sin( u );
				vertex.z = tube * Math.sin( v );

				vertices[ vertexBufferOffset ] = vertex.x;
				vertices[ vertexBufferOffset + 1 ] = vertex.y;
				vertices[ vertexBufferOffset + 2 ] = vertex.z;

				// this vector is used to calculate the normal
				center.x = radius * Math.cos( u );
				center.y = radius * Math.sin( u );

				// normal
				normal.subVectors( vertex, center ).normalize();

				normals[ vertexBufferOffset ] = normal.x;
				normals[ vertexBufferOffset + 1 ] = normal.y;
				normals[ vertexBufferOffset + 2 ] = normal.z;

				// uv
				uvs[ uvBufferOffset ] = i / tubularSegments;
				uvs[ uvBufferOffset + 1 ] = j / radialSegments;

				// update offsets
				vertexBufferOffset += 3;
				uvBufferOffset += 2;

			}

		}

		// generate indices

		for ( j = 1; j <= radialSegments; j ++ ) {

			for ( i = 1; i <= tubularSegments; i ++ ) {

				// indices
				var a = ( tubularSegments + 1 ) * j + i - 1;
				var b = ( tubularSegments + 1 ) * ( j - 1 ) + i - 1;
				var c = ( tubularSegments + 1 ) * ( j - 1 ) + i;
				var d = ( tubularSegments + 1 ) * j + i;

				// face one
				indices[ indexBufferOffset ] = a;
				indices[ indexBufferOffset + 1 ] = b;
				indices[ indexBufferOffset + 2 ] = d;

				// face two
				indices[ indexBufferOffset + 3 ] = b;
				indices[ indexBufferOffset + 4 ] = c;
				indices[ indexBufferOffset + 5 ] = d;

				// update offset
				indexBufferOffset += 6;

			}

		}

		// build geometry
		this.setIndex( new BufferAttribute( indices, 1 ) );
		this.addAttribute( 'position', new BufferAttribute( vertices, 3 ) );
		this.addAttribute( 'normal', new BufferAttribute( normals, 3 ) );
		this.addAttribute( 'uv', new BufferAttribute( uvs, 2 ) );

	}

	TorusBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	TorusBufferGeometry.prototype.constructor = TorusBufferGeometry;

	/**
	 * @author oosmoxiecode
	 * @author mrdoob / http://mrdoob.com/
	 * based on http://code.google.com/p/away3d/source/browse/trunk/fp10/Away3DLite/src/away3dlite/primitives/Torus.as?r=2888
	 */

	function TorusGeometry( radius, tube, radialSegments, tubularSegments, arc ) {

		Geometry.call( this );

		this.type = 'TorusGeometry';

		this.parameters = {
			radius: radius,
			tube: tube,
			radialSegments: radialSegments,
			tubularSegments: tubularSegments,
			arc: arc
		};

		this.fromBufferGeometry( new TorusBufferGeometry( radius, tube, radialSegments, tubularSegments, arc ) );

	}

	TorusGeometry.prototype = Object.create( Geometry.prototype );
	TorusGeometry.prototype.constructor = TorusGeometry;

	/**
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 */

	var ShapeUtils = {

		// calculate area of the contour polygon

		area: function ( contour ) {

			var n = contour.length;
			var a = 0.0;

			for ( var p = n - 1, q = 0; q < n; p = q ++ ) {

				a += contour[ p ].x * contour[ q ].y - contour[ q ].x * contour[ p ].y;

			}

			return a * 0.5;

		},

		triangulate: ( function () {

			/**
			 * This code is a quick port of code written in C++ which was submitted to
			 * flipcode.com by John W. Ratcliff  // July 22, 2000
			 * See original code and more information here:
			 * http://www.flipcode.com/archives/Efficient_Polygon_Triangulation.shtml
			 *
			 * ported to actionscript by Zevan Rosser
			 * www.actionsnippet.com
			 *
			 * ported to javascript by Joshua Koo
			 * http://www.lab4games.net/zz85/blog
			 *
			 */

			function snip( contour, u, v, w, n, verts ) {

				var p;
				var ax, ay, bx, by;
				var cx, cy, px, py;

				ax = contour[ verts[ u ] ].x;
				ay = contour[ verts[ u ] ].y;

				bx = contour[ verts[ v ] ].x;
				by = contour[ verts[ v ] ].y;

				cx = contour[ verts[ w ] ].x;
				cy = contour[ verts[ w ] ].y;

				if ( ( bx - ax ) * ( cy - ay ) - ( by - ay ) * ( cx - ax ) <= 0 ) return false;

				var aX, aY, bX, bY, cX, cY;
				var apx, apy, bpx, bpy, cpx, cpy;
				var cCROSSap, bCROSScp, aCROSSbp;

				aX = cx - bx;  aY = cy - by;
				bX = ax - cx;  bY = ay - cy;
				cX = bx - ax;  cY = by - ay;

				for ( p = 0; p < n; p ++ ) {

					px = contour[ verts[ p ] ].x;
					py = contour[ verts[ p ] ].y;

					if ( ( ( px === ax ) && ( py === ay ) ) ||
						 ( ( px === bx ) && ( py === by ) ) ||
						 ( ( px === cx ) && ( py === cy ) ) )	continue;

					apx = px - ax;  apy = py - ay;
					bpx = px - bx;  bpy = py - by;
					cpx = px - cx;  cpy = py - cy;

					// see if p is inside triangle abc

					aCROSSbp = aX * bpy - aY * bpx;
					cCROSSap = cX * apy - cY * apx;
					bCROSScp = bX * cpy - bY * cpx;

					if ( ( aCROSSbp >= - Number.EPSILON ) && ( bCROSScp >= - Number.EPSILON ) && ( cCROSSap >= - Number.EPSILON ) ) return false;

				}

				return true;

			}

			// takes in an contour array and returns

			return function triangulate( contour, indices ) {

				var n = contour.length;

				if ( n < 3 ) return null;

				var result = [],
					verts = [],
					vertIndices = [];

				/* we want a counter-clockwise polygon in verts */

				var u, v, w;

				if ( ShapeUtils.area( contour ) > 0.0 ) {

					for ( v = 0; v < n; v ++ ) verts[ v ] = v;

				} else {

					for ( v = 0; v < n; v ++ ) verts[ v ] = ( n - 1 ) - v;

				}

				var nv = n;

				/*  remove nv - 2 vertices, creating 1 triangle every time */

				var count = 2 * nv;   /* error detection */

				for ( v = nv - 1; nv > 2; ) {

					/* if we loop, it is probably a non-simple polygon */

					if ( ( count -- ) <= 0 ) {

						//** Triangulate: ERROR - probable bad polygon!

						//throw ( "Warning, unable to triangulate polygon!" );
						//return null;
						// Sometimes warning is fine, especially polygons are triangulated in reverse.
						console.warn( 'THREE.ShapeUtils: Unable to triangulate polygon! in triangulate()' );

						if ( indices ) return vertIndices;
						return result;

					}

					/* three consecutive vertices in current polygon, <u,v,w> */

					u = v; 	 	if ( nv <= u ) u = 0;     /* previous */
					v = u + 1;  if ( nv <= v ) v = 0;     /* new v    */
					w = v + 1;  if ( nv <= w ) w = 0;     /* next     */

					if ( snip( contour, u, v, w, nv, verts ) ) {

						var a, b, c, s, t;

						/* true names of the vertices */

						a = verts[ u ];
						b = verts[ v ];
						c = verts[ w ];

						/* output Triangle */

						result.push( [ contour[ a ],
							contour[ b ],
							contour[ c ] ] );


						vertIndices.push( [ verts[ u ], verts[ v ], verts[ w ] ] );

						/* remove v from the remaining polygon */

						for ( s = v, t = v + 1; t < nv; s ++, t ++ ) {

							verts[ s ] = verts[ t ];

						}

						nv --;

						/* reset error detection counter */

						count = 2 * nv;

					}

				}

				if ( indices ) return vertIndices;
				return result;

			}

		} )(),

		triangulateShape: function ( contour, holes ) {

			function removeDupEndPts(points) {

				var l = points.length;

				if ( l > 2 && points[ l - 1 ].equals( points[ 0 ] ) ) {

					points.pop();

				}

			}

			removeDupEndPts( contour );
			holes.forEach( removeDupEndPts );

			function point_in_segment_2D_colin( inSegPt1, inSegPt2, inOtherPt ) {

				// inOtherPt needs to be collinear to the inSegment
				if ( inSegPt1.x !== inSegPt2.x ) {

					if ( inSegPt1.x < inSegPt2.x ) {

						return	( ( inSegPt1.x <= inOtherPt.x ) && ( inOtherPt.x <= inSegPt2.x ) );

					} else {

						return	( ( inSegPt2.x <= inOtherPt.x ) && ( inOtherPt.x <= inSegPt1.x ) );

					}

				} else {

					if ( inSegPt1.y < inSegPt2.y ) {

						return	( ( inSegPt1.y <= inOtherPt.y ) && ( inOtherPt.y <= inSegPt2.y ) );

					} else {

						return	( ( inSegPt2.y <= inOtherPt.y ) && ( inOtherPt.y <= inSegPt1.y ) );

					}

				}

			}

			function intersect_segments_2D( inSeg1Pt1, inSeg1Pt2, inSeg2Pt1, inSeg2Pt2, inExcludeAdjacentSegs ) {

				var seg1dx = inSeg1Pt2.x - inSeg1Pt1.x,   seg1dy = inSeg1Pt2.y - inSeg1Pt1.y;
				var seg2dx = inSeg2Pt2.x - inSeg2Pt1.x,   seg2dy = inSeg2Pt2.y - inSeg2Pt1.y;

				var seg1seg2dx = inSeg1Pt1.x - inSeg2Pt1.x;
				var seg1seg2dy = inSeg1Pt1.y - inSeg2Pt1.y;

				var limit		= seg1dy * seg2dx - seg1dx * seg2dy;
				var perpSeg1	= seg1dy * seg1seg2dx - seg1dx * seg1seg2dy;

				if ( Math.abs( limit ) > Number.EPSILON ) {

					// not parallel

					var perpSeg2;
					if ( limit > 0 ) {

						if ( ( perpSeg1 < 0 ) || ( perpSeg1 > limit ) ) 		return [];
						perpSeg2 = seg2dy * seg1seg2dx - seg2dx * seg1seg2dy;
						if ( ( perpSeg2 < 0 ) || ( perpSeg2 > limit ) ) 		return [];

					} else {

						if ( ( perpSeg1 > 0 ) || ( perpSeg1 < limit ) ) 		return [];
						perpSeg2 = seg2dy * seg1seg2dx - seg2dx * seg1seg2dy;
						if ( ( perpSeg2 > 0 ) || ( perpSeg2 < limit ) ) 		return [];

					}

					// i.e. to reduce rounding errors
					// intersection at endpoint of segment#1?
					if ( perpSeg2 === 0 ) {

						if ( ( inExcludeAdjacentSegs ) &&
							 ( ( perpSeg1 === 0 ) || ( perpSeg1 === limit ) ) )		return [];
						return [ inSeg1Pt1 ];

					}
					if ( perpSeg2 === limit ) {

						if ( ( inExcludeAdjacentSegs ) &&
							 ( ( perpSeg1 === 0 ) || ( perpSeg1 === limit ) ) )		return [];
						return [ inSeg1Pt2 ];

					}
					// intersection at endpoint of segment#2?
					if ( perpSeg1 === 0 )		return [ inSeg2Pt1 ];
					if ( perpSeg1 === limit )	return [ inSeg2Pt2 ];

					// return real intersection point
					var factorSeg1 = perpSeg2 / limit;
					return	[ { x: inSeg1Pt1.x + factorSeg1 * seg1dx,
								y: inSeg1Pt1.y + factorSeg1 * seg1dy } ];

				} else {

					// parallel or collinear
					if ( ( perpSeg1 !== 0 ) ||
						 ( seg2dy * seg1seg2dx !== seg2dx * seg1seg2dy ) ) 			return [];

					// they are collinear or degenerate
					var seg1Pt = ( ( seg1dx === 0 ) && ( seg1dy === 0 ) );	// segment1 is just a point?
					var seg2Pt = ( ( seg2dx === 0 ) && ( seg2dy === 0 ) );	// segment2 is just a point?
					// both segments are points
					if ( seg1Pt && seg2Pt ) {

						if ( ( inSeg1Pt1.x !== inSeg2Pt1.x ) ||
							 ( inSeg1Pt1.y !== inSeg2Pt1.y ) )		return [];	// they are distinct  points
						return [ inSeg1Pt1 ];                 						// they are the same point

					}
					// segment#1  is a single point
					if ( seg1Pt ) {

						if ( ! point_in_segment_2D_colin( inSeg2Pt1, inSeg2Pt2, inSeg1Pt1 ) )		return [];		// but not in segment#2
						return [ inSeg1Pt1 ];

					}
					// segment#2  is a single point
					if ( seg2Pt ) {

						if ( ! point_in_segment_2D_colin( inSeg1Pt1, inSeg1Pt2, inSeg2Pt1 ) )		return [];		// but not in segment#1
						return [ inSeg2Pt1 ];

					}

					// they are collinear segments, which might overlap
					var seg1min, seg1max, seg1minVal, seg1maxVal;
					var seg2min, seg2max, seg2minVal, seg2maxVal;
					if ( seg1dx !== 0 ) {

						// the segments are NOT on a vertical line
						if ( inSeg1Pt1.x < inSeg1Pt2.x ) {

							seg1min = inSeg1Pt1; seg1minVal = inSeg1Pt1.x;
							seg1max = inSeg1Pt2; seg1maxVal = inSeg1Pt2.x;

						} else {

							seg1min = inSeg1Pt2; seg1minVal = inSeg1Pt2.x;
							seg1max = inSeg1Pt1; seg1maxVal = inSeg1Pt1.x;

						}
						if ( inSeg2Pt1.x < inSeg2Pt2.x ) {

							seg2min = inSeg2Pt1; seg2minVal = inSeg2Pt1.x;
							seg2max = inSeg2Pt2; seg2maxVal = inSeg2Pt2.x;

						} else {

							seg2min = inSeg2Pt2; seg2minVal = inSeg2Pt2.x;
							seg2max = inSeg2Pt1; seg2maxVal = inSeg2Pt1.x;

						}

					} else {

						// the segments are on a vertical line
						if ( inSeg1Pt1.y < inSeg1Pt2.y ) {

							seg1min = inSeg1Pt1; seg1minVal = inSeg1Pt1.y;
							seg1max = inSeg1Pt2; seg1maxVal = inSeg1Pt2.y;

						} else {

							seg1min = inSeg1Pt2; seg1minVal = inSeg1Pt2.y;
							seg1max = inSeg1Pt1; seg1maxVal = inSeg1Pt1.y;

						}
						if ( inSeg2Pt1.y < inSeg2Pt2.y ) {

							seg2min = inSeg2Pt1; seg2minVal = inSeg2Pt1.y;
							seg2max = inSeg2Pt2; seg2maxVal = inSeg2Pt2.y;

						} else {

							seg2min = inSeg2Pt2; seg2minVal = inSeg2Pt2.y;
							seg2max = inSeg2Pt1; seg2maxVal = inSeg2Pt1.y;

						}

					}
					if ( seg1minVal <= seg2minVal ) {

						if ( seg1maxVal <  seg2minVal )	return [];
						if ( seg1maxVal === seg2minVal )	{

							if ( inExcludeAdjacentSegs )		return [];
							return [ seg2min ];

						}
						if ( seg1maxVal <= seg2maxVal )	return [ seg2min, seg1max ];
						return	[ seg2min, seg2max ];

					} else {

						if ( seg1minVal >  seg2maxVal )	return [];
						if ( seg1minVal === seg2maxVal )	{

							if ( inExcludeAdjacentSegs )		return [];
							return [ seg1min ];

						}
						if ( seg1maxVal <= seg2maxVal )	return [ seg1min, seg1max ];
						return	[ seg1min, seg2max ];

					}

				}

			}

			function isPointInsideAngle( inVertex, inLegFromPt, inLegToPt, inOtherPt ) {

				// The order of legs is important

				// translation of all points, so that Vertex is at (0,0)
				var legFromPtX	= inLegFromPt.x - inVertex.x,  legFromPtY	= inLegFromPt.y - inVertex.y;
				var legToPtX	= inLegToPt.x	- inVertex.x,  legToPtY		= inLegToPt.y	- inVertex.y;
				var otherPtX	= inOtherPt.x	- inVertex.x,  otherPtY		= inOtherPt.y	- inVertex.y;

				// main angle >0: < 180 deg.; 0: 180 deg.; <0: > 180 deg.
				var from2toAngle	= legFromPtX * legToPtY - legFromPtY * legToPtX;
				var from2otherAngle	= legFromPtX * otherPtY - legFromPtY * otherPtX;

				if ( Math.abs( from2toAngle ) > Number.EPSILON ) {

					// angle != 180 deg.

					var other2toAngle		= otherPtX * legToPtY - otherPtY * legToPtX;
					// console.log( "from2to: " + from2toAngle + ", from2other: " + from2otherAngle + ", other2to: " + other2toAngle );

					if ( from2toAngle > 0 ) {

						// main angle < 180 deg.
						return	( ( from2otherAngle >= 0 ) && ( other2toAngle >= 0 ) );

					} else {

						// main angle > 180 deg.
						return	( ( from2otherAngle >= 0 ) || ( other2toAngle >= 0 ) );

					}

				} else {

					// angle == 180 deg.
					// console.log( "from2to: 180 deg., from2other: " + from2otherAngle  );
					return	( from2otherAngle > 0 );

				}

			}


			function removeHoles( contour, holes ) {

				var shape = contour.concat(); // work on this shape
				var hole;

				function isCutLineInsideAngles( inShapeIdx, inHoleIdx ) {

					// Check if hole point lies within angle around shape point
					var lastShapeIdx = shape.length - 1;

					var prevShapeIdx = inShapeIdx - 1;
					if ( prevShapeIdx < 0 )			prevShapeIdx = lastShapeIdx;

					var nextShapeIdx = inShapeIdx + 1;
					if ( nextShapeIdx > lastShapeIdx )	nextShapeIdx = 0;

					var insideAngle = isPointInsideAngle( shape[ inShapeIdx ], shape[ prevShapeIdx ], shape[ nextShapeIdx ], hole[ inHoleIdx ] );
					if ( ! insideAngle ) {

						// console.log( "Vertex (Shape): " + inShapeIdx + ", Point: " + hole[inHoleIdx].x + "/" + hole[inHoleIdx].y );
						return	false;

					}

					// Check if shape point lies within angle around hole point
					var lastHoleIdx = hole.length - 1;

					var prevHoleIdx = inHoleIdx - 1;
					if ( prevHoleIdx < 0 )			prevHoleIdx = lastHoleIdx;

					var nextHoleIdx = inHoleIdx + 1;
					if ( nextHoleIdx > lastHoleIdx )	nextHoleIdx = 0;

					insideAngle = isPointInsideAngle( hole[ inHoleIdx ], hole[ prevHoleIdx ], hole[ nextHoleIdx ], shape[ inShapeIdx ] );
					if ( ! insideAngle ) {

						// console.log( "Vertex (Hole): " + inHoleIdx + ", Point: " + shape[inShapeIdx].x + "/" + shape[inShapeIdx].y );
						return	false;

					}

					return	true;

				}

				function intersectsShapeEdge( inShapePt, inHolePt ) {

					// checks for intersections with shape edges
					var sIdx, nextIdx, intersection;
					for ( sIdx = 0; sIdx < shape.length; sIdx ++ ) {

						nextIdx = sIdx + 1; nextIdx %= shape.length;
						intersection = intersect_segments_2D( inShapePt, inHolePt, shape[ sIdx ], shape[ nextIdx ], true );
						if ( intersection.length > 0 )		return	true;

					}

					return	false;

				}

				var indepHoles = [];

				function intersectsHoleEdge( inShapePt, inHolePt ) {

					// checks for intersections with hole edges
					var ihIdx, chkHole,
						hIdx, nextIdx, intersection;
					for ( ihIdx = 0; ihIdx < indepHoles.length; ihIdx ++ ) {

						chkHole = holes[ indepHoles[ ihIdx ]];
						for ( hIdx = 0; hIdx < chkHole.length; hIdx ++ ) {

							nextIdx = hIdx + 1; nextIdx %= chkHole.length;
							intersection = intersect_segments_2D( inShapePt, inHolePt, chkHole[ hIdx ], chkHole[ nextIdx ], true );
							if ( intersection.length > 0 )		return	true;

						}

					}
					return	false;

				}

				var holeIndex, shapeIndex,
					shapePt, holePt,
					holeIdx, cutKey, failedCuts = [],
					tmpShape1, tmpShape2,
					tmpHole1, tmpHole2;

				for ( var h = 0, hl = holes.length; h < hl; h ++ ) {

					indepHoles.push( h );

				}

				var minShapeIndex = 0;
				var counter = indepHoles.length * 2;
				while ( indepHoles.length > 0 ) {

					counter --;
					if ( counter < 0 ) {

						console.log( "Infinite Loop! Holes left:" + indepHoles.length + ", Probably Hole outside Shape!" );
						break;

					}

					// search for shape-vertex and hole-vertex,
					// which can be connected without intersections
					for ( shapeIndex = minShapeIndex; shapeIndex < shape.length; shapeIndex ++ ) {

						shapePt = shape[ shapeIndex ];
						holeIndex	= - 1;

						// search for hole which can be reached without intersections
						for ( var h = 0; h < indepHoles.length; h ++ ) {

							holeIdx = indepHoles[ h ];

							// prevent multiple checks
							cutKey = shapePt.x + ":" + shapePt.y + ":" + holeIdx;
							if ( failedCuts[ cutKey ] !== undefined )			continue;

							hole = holes[ holeIdx ];
							for ( var h2 = 0; h2 < hole.length; h2 ++ ) {

								holePt = hole[ h2 ];
								if ( ! isCutLineInsideAngles( shapeIndex, h2 ) )		continue;
								if ( intersectsShapeEdge( shapePt, holePt ) )		continue;
								if ( intersectsHoleEdge( shapePt, holePt ) )		continue;

								holeIndex = h2;
								indepHoles.splice( h, 1 );

								tmpShape1 = shape.slice( 0, shapeIndex + 1 );
								tmpShape2 = shape.slice( shapeIndex );
								tmpHole1 = hole.slice( holeIndex );
								tmpHole2 = hole.slice( 0, holeIndex + 1 );

								shape = tmpShape1.concat( tmpHole1 ).concat( tmpHole2 ).concat( tmpShape2 );

								minShapeIndex = shapeIndex;

								// Debug only, to show the selected cuts
								// glob_CutLines.push( [ shapePt, holePt ] );

								break;

							}
							if ( holeIndex >= 0 )	break;		// hole-vertex found

							failedCuts[ cutKey ] = true;			// remember failure

						}
						if ( holeIndex >= 0 )	break;		// hole-vertex found

					}

				}

				return shape; 			/* shape with no holes */

			}


			var i, il, f, face,
				key, index,
				allPointsMap = {};

			// To maintain reference to old shape, one must match coordinates, or offset the indices from original arrays. It's probably easier to do the first.

			var allpoints = contour.concat();

			for ( var h = 0, hl = holes.length; h < hl; h ++ ) {

				Array.prototype.push.apply( allpoints, holes[ h ] );

			}

			//console.log( "allpoints",allpoints, allpoints.length );

			// prepare all points map

			for ( i = 0, il = allpoints.length; i < il; i ++ ) {

				key = allpoints[ i ].x + ":" + allpoints[ i ].y;

				if ( allPointsMap[ key ] !== undefined ) {

					console.warn( "THREE.ShapeUtils: Duplicate point", key, i );

				}

				allPointsMap[ key ] = i;

			}

			// remove holes by cutting paths to holes and adding them to the shape
			var shapeWithoutHoles = removeHoles( contour, holes );

			var triangles = ShapeUtils.triangulate( shapeWithoutHoles, false ); // True returns indices for points of spooled shape
			//console.log( "triangles",triangles, triangles.length );

			// check all face vertices against all points map

			for ( i = 0, il = triangles.length; i < il; i ++ ) {

				face = triangles[ i ];

				for ( f = 0; f < 3; f ++ ) {

					key = face[ f ].x + ":" + face[ f ].y;

					index = allPointsMap[ key ];

					if ( index !== undefined ) {

						face[ f ] = index;

					}

				}

			}

			return triangles.concat();

		},

		isClockWise: function ( pts ) {

			return ShapeUtils.area( pts ) < 0;

		},

		// Bezier Curves formulas obtained from
		// http://en.wikipedia.org/wiki/B%C3%A9zier_curve

		// Quad Bezier Functions

		b2: ( function () {

			function b2p0( t, p ) {

				var k = 1 - t;
				return k * k * p;

			}

			function b2p1( t, p ) {

				return 2 * ( 1 - t ) * t * p;

			}

			function b2p2( t, p ) {

				return t * t * p;

			}

			return function b2( t, p0, p1, p2 ) {

				return b2p0( t, p0 ) + b2p1( t, p1 ) + b2p2( t, p2 );

			};

		} )(),

		// Cubic Bezier Functions

		b3: ( function () {

			function b3p0( t, p ) {

				var k = 1 - t;
				return k * k * k * p;

			}

			function b3p1( t, p ) {

				var k = 1 - t;
				return 3 * k * k * t * p;

			}

			function b3p2( t, p ) {

				var k = 1 - t;
				return 3 * k * t * t * p;

			}

			function b3p3( t, p ) {

				return t * t * t * p;

			}

			return function b3( t, p0, p1, p2, p3 ) {

				return b3p0( t, p0 ) + b3p1( t, p1 ) + b3p2( t, p2 ) + b3p3( t, p3 );

			};

		} )()

	};

	/**
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 *
	 * Creates extruded geometry from a path shape.
	 *
	 * parameters = {
	 *
	 *  curveSegments: <int>, // number of points on the curves
	 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
	 *  amount: <int>, // Depth to extrude the shape
	 *
	 *  bevelEnabled: <bool>, // turn on bevel
	 *  bevelThickness: <float>, // how deep into the original shape bevel goes
	 *  bevelSize: <float>, // how far from shape outline is bevel
	 *  bevelSegments: <int>, // number of bevel layers
	 *
	 *  extrudePath: <THREE.Curve> // curve to extrude shape along
	 *  frames: <Object> // containing arrays of tangents, normals, binormals
	 *
	 *  uvGenerator: <Object> // object that provides UV generator functions
	 *
	 * }
	 **/

	function ExtrudeGeometry( shapes, options ) {

		if ( typeof( shapes ) === "undefined" ) {

			shapes = [];
			return;

		}

		Geometry.call( this );

		this.type = 'ExtrudeGeometry';

		shapes = Array.isArray( shapes ) ? shapes : [ shapes ];

		this.addShapeList( shapes, options );

		this.computeFaceNormals();

		// can't really use automatic vertex normals
		// as then front and back sides get smoothed too
		// should do separate smoothing just for sides

		//this.computeVertexNormals();

		//console.log( "took", ( Date.now() - startTime ) );

	}

	ExtrudeGeometry.prototype = Object.create( Geometry.prototype );
	ExtrudeGeometry.prototype.constructor = ExtrudeGeometry;

	ExtrudeGeometry.prototype.addShapeList = function ( shapes, options ) {

		var sl = shapes.length;

		for ( var s = 0; s < sl; s ++ ) {

			var shape = shapes[ s ];
			this.addShape( shape, options );

		}

	};

	ExtrudeGeometry.prototype.addShape = function ( shape, options ) {

		var amount = options.amount !== undefined ? options.amount : 100;

		var bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 6; // 10
		var bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 2; // 8
		var bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;

		var bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true; // false

		var curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;

		var steps = options.steps !== undefined ? options.steps : 1;

		var extrudePath = options.extrudePath;
		var extrudePts, extrudeByPath = false;

		// Use default WorldUVGenerator if no UV generators are specified.
		var uvgen = options.UVGenerator !== undefined ? options.UVGenerator : ExtrudeGeometry.WorldUVGenerator;

		var splineTube, binormal, normal, position2;
		if ( extrudePath ) {

			extrudePts = extrudePath.getSpacedPoints( steps );

			extrudeByPath = true;
			bevelEnabled = false; // bevels not supported for path extrusion

			// SETUP TNB variables

			// TODO1 - have a .isClosed in spline?

			splineTube = options.frames !== undefined ? options.frames : extrudePath.computeFrenetFrames( steps, false );

			// console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);

			binormal = new Vector3();
			normal = new Vector3();
			position2 = new Vector3();

		}

		// Safeguards if bevels are not enabled

		if ( ! bevelEnabled ) {

			bevelSegments = 0;
			bevelThickness = 0;
			bevelSize = 0;

		}

		// Variables initialization

		var ahole, h, hl; // looping of holes
		var scope = this;

		var shapesOffset = this.vertices.length;

		var shapePoints = shape.extractPoints( curveSegments );

		var vertices = shapePoints.shape;
		var holes = shapePoints.holes;

		var reverse = ! ShapeUtils.isClockWise( vertices );

		if ( reverse ) {

			vertices = vertices.reverse();

			// Maybe we should also check if holes are in the opposite direction, just to be safe ...

			for ( h = 0, hl = holes.length; h < hl; h ++ ) {

				ahole = holes[ h ];

				if ( ShapeUtils.isClockWise( ahole ) ) {

					holes[ h ] = ahole.reverse();

				}

			}

			reverse = false; // If vertices are in order now, we shouldn't need to worry about them again (hopefully)!

		}


		var faces = ShapeUtils.triangulateShape( vertices, holes );

		/* Vertices */

		var contour = vertices; // vertices has all points but contour has only points of circumference

		for ( h = 0, hl = holes.length; h < hl; h ++ ) {

			ahole = holes[ h ];

			vertices = vertices.concat( ahole );

		}


		function scalePt2( pt, vec, size ) {

			if ( ! vec ) console.error( "THREE.ExtrudeGeometry: vec does not exist" );

			return vec.clone().multiplyScalar( size ).add( pt );

		}

		var b, bs, t, z,
			vert, vlen = vertices.length,
			face, flen = faces.length;


		// Find directions for point movement


		function getBevelVec( inPt, inPrev, inNext ) {

			// computes for inPt the corresponding point inPt' on a new contour
			//   shifted by 1 unit (length of normalized vector) to the left
			// if we walk along contour clockwise, this new contour is outside the old one
			//
			// inPt' is the intersection of the two lines parallel to the two
			//  adjacent edges of inPt at a distance of 1 unit on the left side.

			var v_trans_x, v_trans_y, shrink_by = 1;		// resulting translation vector for inPt

			// good reading for geometry algorithms (here: line-line intersection)
			// http://geomalgorithms.com/a05-_intersect-1.html

			var v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
			var v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;

			var v_prev_lensq = ( v_prev_x * v_prev_x + v_prev_y * v_prev_y );

			// check for collinear edges
			var collinear0 = ( v_prev_x * v_next_y - v_prev_y * v_next_x );

			if ( Math.abs( collinear0 ) > Number.EPSILON ) {

				// not collinear

				// length of vectors for normalizing

				var v_prev_len = Math.sqrt( v_prev_lensq );
				var v_next_len = Math.sqrt( v_next_x * v_next_x + v_next_y * v_next_y );

				// shift adjacent points by unit vectors to the left

				var ptPrevShift_x = ( inPrev.x - v_prev_y / v_prev_len );
				var ptPrevShift_y = ( inPrev.y + v_prev_x / v_prev_len );

				var ptNextShift_x = ( inNext.x - v_next_y / v_next_len );
				var ptNextShift_y = ( inNext.y + v_next_x / v_next_len );

				// scaling factor for v_prev to intersection point

				var sf = (  ( ptNextShift_x - ptPrevShift_x ) * v_next_y -
							( ptNextShift_y - ptPrevShift_y ) * v_next_x    ) /
						  ( v_prev_x * v_next_y - v_prev_y * v_next_x );

				// vector from inPt to intersection point

				v_trans_x = ( ptPrevShift_x + v_prev_x * sf - inPt.x );
				v_trans_y = ( ptPrevShift_y + v_prev_y * sf - inPt.y );

				// Don't normalize!, otherwise sharp corners become ugly
				//  but prevent crazy spikes
				var v_trans_lensq = ( v_trans_x * v_trans_x + v_trans_y * v_trans_y );
				if ( v_trans_lensq <= 2 ) {

					return	new Vector2( v_trans_x, v_trans_y );

				} else {

					shrink_by = Math.sqrt( v_trans_lensq / 2 );

				}

			} else {

				// handle special case of collinear edges

				var direction_eq = false;		// assumes: opposite
				if ( v_prev_x > Number.EPSILON ) {

					if ( v_next_x > Number.EPSILON ) {

						direction_eq = true;

					}

				} else {

					if ( v_prev_x < - Number.EPSILON ) {

						if ( v_next_x < - Number.EPSILON ) {

							direction_eq = true;

						}

					} else {

						if ( Math.sign( v_prev_y ) === Math.sign( v_next_y ) ) {

							direction_eq = true;

						}

					}

				}

				if ( direction_eq ) {

					// console.log("Warning: lines are a straight sequence");
					v_trans_x = - v_prev_y;
					v_trans_y =  v_prev_x;
					shrink_by = Math.sqrt( v_prev_lensq );

				} else {

					// console.log("Warning: lines are a straight spike");
					v_trans_x = v_prev_x;
					v_trans_y = v_prev_y;
					shrink_by = Math.sqrt( v_prev_lensq / 2 );

				}

			}

			return	new Vector2( v_trans_x / shrink_by, v_trans_y / shrink_by );

		}


		var contourMovements = [];

		for ( var i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i ++, j ++, k ++ ) {

			if ( j === il ) j = 0;
			if ( k === il ) k = 0;

			//  (j)---(i)---(k)
			// console.log('i,j,k', i, j , k)

			contourMovements[ i ] = getBevelVec( contour[ i ], contour[ j ], contour[ k ] );

		}

		var holesMovements = [], oneHoleMovements, verticesMovements = contourMovements.concat();

		for ( h = 0, hl = holes.length; h < hl; h ++ ) {

			ahole = holes[ h ];

			oneHoleMovements = [];

			for ( i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i ++, j ++, k ++ ) {

				if ( j === il ) j = 0;
				if ( k === il ) k = 0;

				//  (j)---(i)---(k)
				oneHoleMovements[ i ] = getBevelVec( ahole[ i ], ahole[ j ], ahole[ k ] );

			}

			holesMovements.push( oneHoleMovements );
			verticesMovements = verticesMovements.concat( oneHoleMovements );

		}


		// Loop bevelSegments, 1 for the front, 1 for the back

		for ( b = 0; b < bevelSegments; b ++ ) {

			//for ( b = bevelSegments; b > 0; b -- ) {

			t = b / bevelSegments;
			z = bevelThickness * Math.cos( t * Math.PI / 2 );
			bs = bevelSize * Math.sin( t * Math.PI / 2 );

			// contract shape

			for ( i = 0, il = contour.length; i < il; i ++ ) {

				vert = scalePt2( contour[ i ], contourMovements[ i ], bs );

				v( vert.x, vert.y,  - z );

			}

			// expand holes

			for ( h = 0, hl = holes.length; h < hl; h ++ ) {

				ahole = holes[ h ];
				oneHoleMovements = holesMovements[ h ];

				for ( i = 0, il = ahole.length; i < il; i ++ ) {

					vert = scalePt2( ahole[ i ], oneHoleMovements[ i ], bs );

					v( vert.x, vert.y,  - z );

				}

			}

		}

		bs = bevelSize;

		// Back facing vertices

		for ( i = 0; i < vlen; i ++ ) {

			vert = bevelEnabled ? scalePt2( vertices[ i ], verticesMovements[ i ], bs ) : vertices[ i ];

			if ( ! extrudeByPath ) {

				v( vert.x, vert.y, 0 );

			} else {

				// v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );

				normal.copy( splineTube.normals[ 0 ] ).multiplyScalar( vert.x );
				binormal.copy( splineTube.binormals[ 0 ] ).multiplyScalar( vert.y );

				position2.copy( extrudePts[ 0 ] ).add( normal ).add( binormal );

				v( position2.x, position2.y, position2.z );

			}

		}

		// Add stepped vertices...
		// Including front facing vertices

		var s;

		for ( s = 1; s <= steps; s ++ ) {

			for ( i = 0; i < vlen; i ++ ) {

				vert = bevelEnabled ? scalePt2( vertices[ i ], verticesMovements[ i ], bs ) : vertices[ i ];

				if ( ! extrudeByPath ) {

					v( vert.x, vert.y, amount / steps * s );

				} else {

					// v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );

					normal.copy( splineTube.normals[ s ] ).multiplyScalar( vert.x );
					binormal.copy( splineTube.binormals[ s ] ).multiplyScalar( vert.y );

					position2.copy( extrudePts[ s ] ).add( normal ).add( binormal );

					v( position2.x, position2.y, position2.z );

				}

			}

		}


		// Add bevel segments planes

		//for ( b = 1; b <= bevelSegments; b ++ ) {
		for ( b = bevelSegments - 1; b >= 0; b -- ) {

			t = b / bevelSegments;
			z = bevelThickness * Math.cos ( t * Math.PI / 2 );
			bs = bevelSize * Math.sin( t * Math.PI / 2 );

			// contract shape

			for ( i = 0, il = contour.length; i < il; i ++ ) {

				vert = scalePt2( contour[ i ], contourMovements[ i ], bs );
				v( vert.x, vert.y,  amount + z );

			}

			// expand holes

			for ( h = 0, hl = holes.length; h < hl; h ++ ) {

				ahole = holes[ h ];
				oneHoleMovements = holesMovements[ h ];

				for ( i = 0, il = ahole.length; i < il; i ++ ) {

					vert = scalePt2( ahole[ i ], oneHoleMovements[ i ], bs );

					if ( ! extrudeByPath ) {

						v( vert.x, vert.y,  amount + z );

					} else {

						v( vert.x, vert.y + extrudePts[ steps - 1 ].y, extrudePts[ steps - 1 ].x + z );

					}

				}

			}

		}

		/* Faces */

		// Top and bottom faces

		buildLidFaces();

		// Sides faces

		buildSideFaces();


		/////  Internal functions

		function buildLidFaces() {

			if ( bevelEnabled ) {

				var layer = 0; // steps + 1
				var offset = vlen * layer;

				// Bottom faces

				for ( i = 0; i < flen; i ++ ) {

					face = faces[ i ];
					f3( face[ 2 ] + offset, face[ 1 ] + offset, face[ 0 ] + offset );

				}

				layer = steps + bevelSegments * 2;
				offset = vlen * layer;

				// Top faces

				for ( i = 0; i < flen; i ++ ) {

					face = faces[ i ];
					f3( face[ 0 ] + offset, face[ 1 ] + offset, face[ 2 ] + offset );

				}

			} else {

				// Bottom faces

				for ( i = 0; i < flen; i ++ ) {

					face = faces[ i ];
					f3( face[ 2 ], face[ 1 ], face[ 0 ] );

				}

				// Top faces

				for ( i = 0; i < flen; i ++ ) {

					face = faces[ i ];
					f3( face[ 0 ] + vlen * steps, face[ 1 ] + vlen * steps, face[ 2 ] + vlen * steps );

				}

			}

		}

		// Create faces for the z-sides of the shape

		function buildSideFaces() {

			var layeroffset = 0;
			sidewalls( contour, layeroffset );
			layeroffset += contour.length;

			for ( h = 0, hl = holes.length; h < hl; h ++ ) {

				ahole = holes[ h ];
				sidewalls( ahole, layeroffset );

				//, true
				layeroffset += ahole.length;

			}

		}

		function sidewalls( contour, layeroffset ) {

			var j, k;
			i = contour.length;

			while ( -- i >= 0 ) {

				j = i;
				k = i - 1;
				if ( k < 0 ) k = contour.length - 1;

				//console.log('b', i,j, i-1, k,vertices.length);

				var s = 0, sl = steps  + bevelSegments * 2;

				for ( s = 0; s < sl; s ++ ) {

					var slen1 = vlen * s;
					var slen2 = vlen * ( s + 1 );

					var a = layeroffset + j + slen1,
						b = layeroffset + k + slen1,
						c = layeroffset + k + slen2,
						d = layeroffset + j + slen2;

					f4( a, b, c, d, contour, s, sl, j, k );

				}

			}

		}


		function v( x, y, z ) {

			scope.vertices.push( new Vector3( x, y, z ) );

		}

		function f3( a, b, c ) {

			a += shapesOffset;
			b += shapesOffset;
			c += shapesOffset;

			scope.faces.push( new Face3( a, b, c, null, null, 0 ) );

			var uvs = uvgen.generateTopUV( scope, a, b, c );

			scope.faceVertexUvs[ 0 ].push( uvs );

		}

		function f4( a, b, c, d, wallContour, stepIndex, stepsLength, contourIndex1, contourIndex2 ) {

			a += shapesOffset;
			b += shapesOffset;
			c += shapesOffset;
			d += shapesOffset;

			scope.faces.push( new Face3( a, b, d, null, null, 1 ) );
			scope.faces.push( new Face3( b, c, d, null, null, 1 ) );

			var uvs = uvgen.generateSideWallUV( scope, a, b, c, d );

			scope.faceVertexUvs[ 0 ].push( [ uvs[ 0 ], uvs[ 1 ], uvs[ 3 ] ] );
			scope.faceVertexUvs[ 0 ].push( [ uvs[ 1 ], uvs[ 2 ], uvs[ 3 ] ] );

		}

	};

	ExtrudeGeometry.WorldUVGenerator = {

		generateTopUV: function ( geometry, indexA, indexB, indexC ) {

			var vertices = geometry.vertices;

			var a = vertices[ indexA ];
			var b = vertices[ indexB ];
			var c = vertices[ indexC ];

			return [
				new Vector2( a.x, a.y ),
				new Vector2( b.x, b.y ),
				new Vector2( c.x, c.y )
			];

		},

		generateSideWallUV: function ( geometry, indexA, indexB, indexC, indexD ) {

			var vertices = geometry.vertices;

			var a = vertices[ indexA ];
			var b = vertices[ indexB ];
			var c = vertices[ indexC ];
			var d = vertices[ indexD ];

			if ( Math.abs( a.y - b.y ) < 0.01 ) {

				return [
					new Vector2( a.x, 1 - a.z ),
					new Vector2( b.x, 1 - b.z ),
					new Vector2( c.x, 1 - c.z ),
					new Vector2( d.x, 1 - d.z )
				];

			} else {

				return [
					new Vector2( a.y, 1 - a.z ),
					new Vector2( b.y, 1 - b.z ),
					new Vector2( c.y, 1 - c.z ),
					new Vector2( d.y, 1 - d.z )
				];

			}

		}
	};

	/**
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 * @author alteredq / http://alteredqualia.com/
	 *
	 * Text = 3D Text
	 *
	 * parameters = {
	 *  font: <THREE.Font>, // font
	 *
	 *  size: <float>, // size of the text
	 *  height: <float>, // thickness to extrude text
	 *  curveSegments: <int>, // number of points on the curves
	 *
	 *  bevelEnabled: <bool>, // turn on bevel
	 *  bevelThickness: <float>, // how deep into text bevel goes
	 *  bevelSize: <float> // how far from text outline is bevel
	 * }
	 */

	function TextGeometry( text, parameters ) {

		parameters = parameters || {};

		var font = parameters.font;

		if ( (font && font.isFont) === false ) {

			console.error( 'THREE.TextGeometry: font parameter is not an instance of THREE.Font.' );
			return new Geometry();

		}

		var shapes = font.generateShapes( text, parameters.size, parameters.curveSegments );

		// translate parameters to ExtrudeGeometry API

		parameters.amount = parameters.height !== undefined ? parameters.height : 50;

		// defaults

		if ( parameters.bevelThickness === undefined ) parameters.bevelThickness = 10;
		if ( parameters.bevelSize === undefined ) parameters.bevelSize = 8;
		if ( parameters.bevelEnabled === undefined ) parameters.bevelEnabled = false;

		ExtrudeGeometry.call( this, shapes, parameters );

		this.type = 'TextGeometry';

	}

	TextGeometry.prototype = Object.create( ExtrudeGeometry.prototype );
	TextGeometry.prototype.constructor = TextGeometry;

	/**
	 * @author benaadams / https://twitter.com/ben_a_adams
	 * based on THREE.SphereGeometry
	 */

	function SphereBufferGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) {

		BufferGeometry.call( this );

		this.type = 'SphereBufferGeometry';

		this.parameters = {
			radius: radius,
			widthSegments: widthSegments,
			heightSegments: heightSegments,
			phiStart: phiStart,
			phiLength: phiLength,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		radius = radius || 50;

		widthSegments = Math.max( 3, Math.floor( widthSegments ) || 8 );
		heightSegments = Math.max( 2, Math.floor( heightSegments ) || 6 );

		phiStart = phiStart !== undefined ? phiStart : 0;
		phiLength = phiLength !== undefined ? phiLength : Math.PI * 2;

		thetaStart = thetaStart !== undefined ? thetaStart : 0;
		thetaLength = thetaLength !== undefined ? thetaLength : Math.PI;

		var thetaEnd = thetaStart + thetaLength;

		var vertexCount = ( ( widthSegments + 1 ) * ( heightSegments + 1 ) );

		var positions = new BufferAttribute( new Float32Array( vertexCount * 3 ), 3 );
		var normals = new BufferAttribute( new Float32Array( vertexCount * 3 ), 3 );
		var uvs = new BufferAttribute( new Float32Array( vertexCount * 2 ), 2 );

		var index = 0, vertices = [], normal = new Vector3();

		for ( var y = 0; y <= heightSegments; y ++ ) {

			var verticesRow = [];

			var v = y / heightSegments;

			for ( var x = 0; x <= widthSegments; x ++ ) {

				var u = x / widthSegments;

				var px = - radius * Math.cos( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );
				var py = radius * Math.cos( thetaStart + v * thetaLength );
				var pz = radius * Math.sin( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );

				normal.set( px, py, pz ).normalize();

				positions.setXYZ( index, px, py, pz );
				normals.setXYZ( index, normal.x, normal.y, normal.z );
				uvs.setXY( index, u, 1 - v );

				verticesRow.push( index );

				index ++;

			}

			vertices.push( verticesRow );

		}

		var indices = [];

		for ( var y = 0; y < heightSegments; y ++ ) {

			for ( var x = 0; x < widthSegments; x ++ ) {

				var v1 = vertices[ y ][ x + 1 ];
				var v2 = vertices[ y ][ x ];
				var v3 = vertices[ y + 1 ][ x ];
				var v4 = vertices[ y + 1 ][ x + 1 ];

				if ( y !== 0 || thetaStart > 0 ) indices.push( v1, v2, v4 );
				if ( y !== heightSegments - 1 || thetaEnd < Math.PI ) indices.push( v2, v3, v4 );

			}

		}

		this.setIndex( new ( positions.count > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute )( indices, 1 ) );
		this.addAttribute( 'position', positions );
		this.addAttribute( 'normal', normals );
		this.addAttribute( 'uv', uvs );

		this.boundingSphere = new Sphere( new Vector3(), radius );

	}

	SphereBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	SphereBufferGeometry.prototype.constructor = SphereBufferGeometry;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function SphereGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) {

		Geometry.call( this );

		this.type = 'SphereGeometry';

		this.parameters = {
			radius: radius,
			widthSegments: widthSegments,
			heightSegments: heightSegments,
			phiStart: phiStart,
			phiLength: phiLength,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		this.fromBufferGeometry( new SphereBufferGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) );

	}

	SphereGeometry.prototype = Object.create( Geometry.prototype );
	SphereGeometry.prototype.constructor = SphereGeometry;

	/**
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	function RingBufferGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) {

		BufferGeometry.call( this );

		this.type = 'RingBufferGeometry';

		this.parameters = {
			innerRadius: innerRadius,
			outerRadius: outerRadius,
			thetaSegments: thetaSegments,
			phiSegments: phiSegments,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		innerRadius = innerRadius || 20;
		outerRadius = outerRadius || 50;

		thetaStart = thetaStart !== undefined ? thetaStart : 0;
		thetaLength = thetaLength !== undefined ? thetaLength : Math.PI * 2;

		thetaSegments = thetaSegments !== undefined ? Math.max( 3, thetaSegments ) : 8;
		phiSegments = phiSegments !== undefined ? Math.max( 1, phiSegments ) : 1;

		// these are used to calculate buffer length
		var vertexCount = ( thetaSegments + 1 ) * ( phiSegments + 1 );
		var indexCount = thetaSegments * phiSegments * 2 * 3;

		// buffers
		var indices = new BufferAttribute( new ( indexCount > 65535 ? Uint32Array : Uint16Array )( indexCount ) , 1 );
		var vertices = new BufferAttribute( new Float32Array( vertexCount * 3 ), 3 );
		var normals = new BufferAttribute( new Float32Array( vertexCount * 3 ), 3 );
		var uvs = new BufferAttribute( new Float32Array( vertexCount * 2 ), 2 );

		// some helper variables
		var index = 0, indexOffset = 0, segment;
		var radius = innerRadius;
		var radiusStep = ( ( outerRadius - innerRadius ) / phiSegments );
		var vertex = new Vector3();
		var uv = new Vector2();
		var j, i;

		// generate vertices, normals and uvs

		// values are generate from the inside of the ring to the outside

		for ( j = 0; j <= phiSegments; j ++ ) {

			for ( i = 0; i <= thetaSegments; i ++ ) {

				segment = thetaStart + i / thetaSegments * thetaLength;

				// vertex
				vertex.x = radius * Math.cos( segment );
				vertex.y = radius * Math.sin( segment );
				vertices.setXYZ( index, vertex.x, vertex.y, vertex.z );

				// normal
				normals.setXYZ( index, 0, 0, 1 );

				// uv
				uv.x = ( vertex.x / outerRadius + 1 ) / 2;
				uv.y = ( vertex.y / outerRadius + 1 ) / 2;
				uvs.setXY( index, uv.x, uv.y );

				// increase index
				index++;

			}

			// increase the radius for next row of vertices
			radius += radiusStep;

		}

		// generate indices

		for ( j = 0; j < phiSegments; j ++ ) {

			var thetaSegmentLevel = j * ( thetaSegments + 1 );

			for ( i = 0; i < thetaSegments; i ++ ) {

				segment = i + thetaSegmentLevel;

				// indices
				var a = segment;
				var b = segment + thetaSegments + 1;
				var c = segment + thetaSegments + 2;
				var d = segment + 1;

				// face one
				indices.setX( indexOffset, a ); indexOffset++;
				indices.setX( indexOffset, b ); indexOffset++;
				indices.setX( indexOffset, c ); indexOffset++;

				// face two
				indices.setX( indexOffset, a ); indexOffset++;
				indices.setX( indexOffset, c ); indexOffset++;
				indices.setX( indexOffset, d ); indexOffset++;

			}

		}

		// build geometry

		this.setIndex( indices );
		this.addAttribute( 'position', vertices );
		this.addAttribute( 'normal', normals );
		this.addAttribute( 'uv', uvs );

	}

	RingBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	RingBufferGeometry.prototype.constructor = RingBufferGeometry;

	/**
	 * @author Kaleb Murphy
	 */

	function RingGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) {

		Geometry.call( this );

		this.type = 'RingGeometry';

		this.parameters = {
			innerRadius: innerRadius,
			outerRadius: outerRadius,
			thetaSegments: thetaSegments,
			phiSegments: phiSegments,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		this.fromBufferGeometry( new RingBufferGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) );

	}

	RingGeometry.prototype = Object.create( Geometry.prototype );
	RingGeometry.prototype.constructor = RingGeometry;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * based on http://papervision3d.googlecode.com/svn/trunk/as3/trunk/src/org/papervision3d/objects/primitives/Plane.as
	 */

	function PlaneGeometry( width, height, widthSegments, heightSegments ) {

		Geometry.call( this );

		this.type = 'PlaneGeometry';

		this.parameters = {
			width: width,
			height: height,
			widthSegments: widthSegments,
			heightSegments: heightSegments
		};

		this.fromBufferGeometry( new PlaneBufferGeometry( width, height, widthSegments, heightSegments ) );

	}

	PlaneGeometry.prototype = Object.create( Geometry.prototype );
	PlaneGeometry.prototype.constructor = PlaneGeometry;

	/**
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	 // points - to create a closed torus, one must use a set of points
	 //    like so: [ a, b, c, d, a ], see first is the same as last.
	 // segments - the number of circumference segments to create
	 // phiStart - the starting radian
	 // phiLength - the radian (0 to 2PI) range of the lathed section
	 //    2PI is a closed lathe, less than 2PI is a portion.

	function LatheBufferGeometry( points, segments, phiStart, phiLength ) {

		BufferGeometry.call( this );

		this.type = 'LatheBufferGeometry';

		this.parameters = {
			points: points,
			segments: segments,
			phiStart: phiStart,
			phiLength: phiLength
		};

		segments = Math.floor( segments ) || 12;
		phiStart = phiStart || 0;
		phiLength = phiLength || Math.PI * 2;

		// clamp phiLength so it's in range of [ 0, 2PI ]
		phiLength = _Math.clamp( phiLength, 0, Math.PI * 2 );

		// these are used to calculate buffer length
		var vertexCount = ( segments + 1 ) * points.length;
		var indexCount = segments * points.length * 2 * 3;

		// buffers
		var indices = new BufferAttribute( new ( indexCount > 65535 ? Uint32Array : Uint16Array )( indexCount ) , 1 );
		var vertices = new BufferAttribute( new Float32Array( vertexCount * 3 ), 3 );
		var uvs = new BufferAttribute( new Float32Array( vertexCount * 2 ), 2 );

		// helper variables
		var index = 0, indexOffset = 0, base;
		var inverseSegments = 1.0 / segments;
		var vertex = new Vector3();
		var uv = new Vector2();
		var i, j;

		// generate vertices and uvs

		for ( i = 0; i <= segments; i ++ ) {

			var phi = phiStart + i * inverseSegments * phiLength;

			var sin = Math.sin( phi );
			var cos = Math.cos( phi );

			for ( j = 0; j <= ( points.length - 1 ); j ++ ) {

				// vertex
				vertex.x = points[ j ].x * sin;
				vertex.y = points[ j ].y;
				vertex.z = points[ j ].x * cos;
				vertices.setXYZ( index, vertex.x, vertex.y, vertex.z );

				// uv
				uv.x = i / segments;
				uv.y = j / ( points.length - 1 );
				uvs.setXY( index, uv.x, uv.y );

				// increase index
				index ++;

			}

		}

		// generate indices

		for ( i = 0; i < segments; i ++ ) {

			for ( j = 0; j < ( points.length - 1 ); j ++ ) {

				base = j + i * points.length;

				// indices
				var a = base;
				var b = base + points.length;
				var c = base + points.length + 1;
				var d = base + 1;

				// face one
				indices.setX( indexOffset, a ); indexOffset++;
				indices.setX( indexOffset, b ); indexOffset++;
				indices.setX( indexOffset, d ); indexOffset++;

				// face two
				indices.setX( indexOffset, b ); indexOffset++;
				indices.setX( indexOffset, c ); indexOffset++;
				indices.setX( indexOffset, d ); indexOffset++;

			}

		}

		// build geometry

		this.setIndex( indices );
		this.addAttribute( 'position', vertices );
		this.addAttribute( 'uv', uvs );

		// generate normals

		this.computeVertexNormals();

		// if the geometry is closed, we need to average the normals along the seam.
		// because the corresponding vertices are identical (but still have different UVs).

		if( phiLength === Math.PI * 2 ) {

			var normals = this.attributes.normal.array;
			var n1 = new Vector3();
			var n2 = new Vector3();
			var n = new Vector3();

			// this is the buffer offset for the last line of vertices
			base = segments * points.length * 3;

			for( i = 0, j = 0; i < points.length; i ++, j += 3 ) {

				// select the normal of the vertex in the first line
				n1.x = normals[ j + 0 ];
				n1.y = normals[ j + 1 ];
				n1.z = normals[ j + 2 ];

				// select the normal of the vertex in the last line
				n2.x = normals[ base + j + 0 ];
				n2.y = normals[ base + j + 1 ];
				n2.z = normals[ base + j + 2 ];

				// average normals
				n.addVectors( n1, n2 ).normalize();

				// assign the new values to both normals
				normals[ j + 0 ] = normals[ base + j + 0 ] = n.x;
				normals[ j + 1 ] = normals[ base + j + 1 ] = n.y;
				normals[ j + 2 ] = normals[ base + j + 2 ] = n.z;

			} // next row

		}

	}

	LatheBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	LatheBufferGeometry.prototype.constructor = LatheBufferGeometry;

	/**
	 * @author astrodud / http://astrodud.isgreat.org/
	 * @author zz85 / https://github.com/zz85
	 * @author bhouston / http://clara.io
	 */

	// points - to create a closed torus, one must use a set of points
	//    like so: [ a, b, c, d, a ], see first is the same as last.
	// segments - the number of circumference segments to create
	// phiStart - the starting radian
	// phiLength - the radian (0 to 2PI) range of the lathed section
	//    2PI is a closed lathe, less than 2PI is a portion.

	function LatheGeometry( points, segments, phiStart, phiLength ) {

		Geometry.call( this );

		this.type = 'LatheGeometry';

		this.parameters = {
			points: points,
			segments: segments,
			phiStart: phiStart,
			phiLength: phiLength
		};

		this.fromBufferGeometry( new LatheBufferGeometry( points, segments, phiStart, phiLength ) );
		this.mergeVertices();

	}

	LatheGeometry.prototype = Object.create( Geometry.prototype );
	LatheGeometry.prototype.constructor = LatheGeometry;

	/**
	 * @author Mugen87 / https://github.com/Mugen87
	 *
	 * Creates a one-sided polygonal geometry from one or more shapes.
	 *
	 **/

	function ShapeBufferGeometry( shapes, curveSegments ) {

		BufferGeometry.call( this );

		this.type = 'ShapeBufferGeometry';

		this.parameters = {
			shapes: shapes,
			curveSegments: curveSegments
		};

		curveSegments = curveSegments || 12;

		var vertices = [];
		var normals = [];
		var uvs = [];
		var indices = [];

		var groupStart = 0;
		var groupCount = 0;

		// allow single and array values for "shapes" parameter

		if ( Array.isArray( shapes ) === false ) {

			addShape( shapes );

		} else {

			for ( var i = 0; i < shapes.length; i++ ) {

				addShape( shapes[ i ] );

				this.addGroup( groupStart, groupCount, i ); // enables MultiMaterial support

				groupStart += groupCount;
				groupCount = 0;

			}

		}

		// build geometry

		this.setIndex( new ( indices.length > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute )( indices, 1 ) );
		this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );


		// helper functions

		function addShape( shape ) {

			var i, l, shapeHole;

			var indexOffset = vertices.length / 3;
			var points = shape.extractPoints( curveSegments );

			var shapeVertices = points.shape;
			var shapeHoles = points.holes;

			// check direction of vertices

			if ( ShapeUtils.isClockWise( shapeVertices ) === false ) {

				shapeVertices = shapeVertices.reverse();

				// also check if holes are in the opposite direction

				for ( i = 0, l = shapeHoles.length; i < l; i ++ ) {

					shapeHole = shapeHoles[ i ];

					if ( ShapeUtils.isClockWise( shapeHole ) === true ) {

						shapeHoles[ i ] = shapeHole.reverse();

					}

				}

			}

			var faces = ShapeUtils.triangulateShape( shapeVertices, shapeHoles );

			// join vertices of inner and outer paths to a single array

			for ( i = 0, l = shapeHoles.length; i < l; i ++ ) {

				shapeHole = shapeHoles[ i ];
				shapeVertices = shapeVertices.concat( shapeHole );

			}

			// vertices, normals, uvs

			for ( i = 0, l = shapeVertices.length; i < l; i ++ ) {

				var vertex = shapeVertices[ i ];

				vertices.push( vertex.x, vertex.y, 0 );
				normals.push( 0, 0, 1 );
				uvs.push( vertex.x, vertex.y ); // world uvs

			}

			// incides

			for ( i = 0, l = faces.length; i < l; i ++ ) {

				var face = faces[ i ];

				var a = face[ 0 ] + indexOffset;
				var b = face[ 1 ] + indexOffset;
				var c = face[ 2 ] + indexOffset;

				indices.push( a, b, c );
				groupCount += 3;

			}

		}

	}

	ShapeBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	ShapeBufferGeometry.prototype.constructor = ShapeBufferGeometry;

	/**
	 * @author jonobr1 / http://jonobr1.com
	 *
	 * Creates a one-sided polygonal geometry from a path shape.
	 *
	 **/

	function ShapeGeometry( shapes, curveSegments ) {

		Geometry.call( this );

		this.type = 'ShapeGeometry';

		if ( typeof curveSegments === 'object' ) {

			console.warn( 'THREE.ShapeGeometry: Options parameter has been removed.' );

			curveSegments = curveSegments.curveSegments;

		}

		this.parameters = {
			shapes: shapes,
			curveSegments: curveSegments
		};

		this.fromBufferGeometry( new ShapeBufferGeometry( shapes, curveSegments ) );
		this.mergeVertices();

	}

	ShapeGeometry.prototype = Object.create( Geometry.prototype );
	ShapeGeometry.prototype.constructor = ShapeGeometry;

	/**
	 * @author WestLangley / http://github.com/WestLangley
	 */

	function EdgesGeometry( geometry, thresholdAngle ) {

		BufferGeometry.call( this );

		thresholdAngle = ( thresholdAngle !== undefined ) ? thresholdAngle : 1;

		var thresholdDot = Math.cos( _Math.DEG2RAD * thresholdAngle );

		var edge = [ 0, 0 ], hash = {};

		function sortFunction( a, b ) {

			return a - b;

		}

		var keys = [ 'a', 'b', 'c' ];

		var geometry2;

		if ( geometry.isBufferGeometry ) {

			geometry2 = new Geometry();
			geometry2.fromBufferGeometry( geometry );

		} else {

			geometry2 = geometry.clone();

		}

		geometry2.mergeVertices();
		geometry2.computeFaceNormals();

		var vertices = geometry2.vertices;
		var faces = geometry2.faces;

		for ( var i = 0, l = faces.length; i < l; i ++ ) {

			var face = faces[ i ];

			for ( var j = 0; j < 3; j ++ ) {

				edge[ 0 ] = face[ keys[ j ] ];
				edge[ 1 ] = face[ keys[ ( j + 1 ) % 3 ] ];
				edge.sort( sortFunction );

				var key = edge.toString();

				if ( hash[ key ] === undefined ) {

					hash[ key ] = { vert1: edge[ 0 ], vert2: edge[ 1 ], face1: i, face2: undefined };

				} else {

					hash[ key ].face2 = i;

				}

			}

		}

		var coords = [];

		for ( var key in hash ) {

			var h = hash[ key ];

			// An edge is only rendered if the angle (in degrees) between the face normals of the adjoining faces exceeds this value. default = 1 degree.

			if ( h.face2 === undefined || faces[ h.face1 ].normal.dot( faces[ h.face2 ].normal ) <= thresholdDot ) {

				var vertex = vertices[ h.vert1 ];
				coords.push( vertex.x );
				coords.push( vertex.y );
				coords.push( vertex.z );

				vertex = vertices[ h.vert2 ];
				coords.push( vertex.x );
				coords.push( vertex.y );
				coords.push( vertex.z );

			}

		}

		this.addAttribute( 'position', new Float32BufferAttribute( coords, 3 ) );

	}

	EdgesGeometry.prototype = Object.create( BufferGeometry.prototype );
	EdgesGeometry.prototype.constructor = EdgesGeometry;

	/**
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	function CylinderBufferGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {

		BufferGeometry.call( this );

		this.type = 'CylinderBufferGeometry';

		this.parameters = {
			radiusTop: radiusTop,
			radiusBottom: radiusBottom,
			height: height,
			radialSegments: radialSegments,
			heightSegments: heightSegments,
			openEnded: openEnded,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		var scope = this;

		radiusTop = radiusTop !== undefined ? radiusTop : 20;
		radiusBottom = radiusBottom !== undefined ? radiusBottom : 20;
		height = height !== undefined ? height : 100;

		radialSegments = Math.floor( radialSegments ) || 8;
		heightSegments = Math.floor( heightSegments ) || 1;

		openEnded = openEnded !== undefined ? openEnded : false;
		thetaStart = thetaStart !== undefined ? thetaStart : 0.0;
		thetaLength = thetaLength !== undefined ? thetaLength : 2.0 * Math.PI;

		// used to calculate buffer length

		var nbCap = 0;

		if ( openEnded === false ) {

			if ( radiusTop > 0 ) nbCap ++;
			if ( radiusBottom > 0 ) nbCap ++;

		}

		var vertexCount = calculateVertexCount();
		var indexCount = calculateIndexCount();

		// buffers

		var indices = new BufferAttribute( new ( indexCount > 65535 ? Uint32Array : Uint16Array )( indexCount ), 1 );
		var vertices = new BufferAttribute( new Float32Array( vertexCount * 3 ), 3 );
		var normals = new BufferAttribute( new Float32Array( vertexCount * 3 ), 3 );
		var uvs = new BufferAttribute( new Float32Array( vertexCount * 2 ), 2 );

		// helper variables

		var index = 0,
		    indexOffset = 0,
		    indexArray = [],
		    halfHeight = height / 2;

		// group variables
		var groupStart = 0;

		// generate geometry

		generateTorso();

		if ( openEnded === false ) {

			if ( radiusTop > 0 ) generateCap( true );
			if ( radiusBottom > 0 ) generateCap( false );

		}

		// build geometry

		this.setIndex( indices );
		this.addAttribute( 'position', vertices );
		this.addAttribute( 'normal', normals );
		this.addAttribute( 'uv', uvs );

		// helper functions

		function calculateVertexCount() {

			var count = ( radialSegments + 1 ) * ( heightSegments + 1 );

			if ( openEnded === false ) {

				count += ( ( radialSegments + 1 ) * nbCap ) + ( radialSegments * nbCap );

			}

			return count;

		}

		function calculateIndexCount() {

			var count = radialSegments * heightSegments * 2 * 3;

			if ( openEnded === false ) {

				count += radialSegments * nbCap * 3;

			}

			return count;

		}

		function generateTorso() {

			var x, y;
			var normal = new Vector3();
			var vertex = new Vector3();

			var groupCount = 0;

			// this will be used to calculate the normal
			var slope = ( radiusBottom - radiusTop ) / height;

			// generate vertices, normals and uvs

			for ( y = 0; y <= heightSegments; y ++ ) {

				var indexRow = [];

				var v = y / heightSegments;

				// calculate the radius of the current row
				var radius = v * ( radiusBottom - radiusTop ) + radiusTop;

				for ( x = 0; x <= radialSegments; x ++ ) {

					var u = x / radialSegments;

					var theta = u * thetaLength + thetaStart;

					var sinTheta = Math.sin( theta );
					var cosTheta = Math.cos( theta );

					// vertex
					vertex.x = radius * sinTheta;
					vertex.y = - v * height + halfHeight;
					vertex.z = radius * cosTheta;
					vertices.setXYZ( index, vertex.x, vertex.y, vertex.z );

					// normal
					normal.set( sinTheta, slope, cosTheta ).normalize();
					normals.setXYZ( index, normal.x, normal.y, normal.z );

					// uv
					uvs.setXY( index, u, 1 - v );

					// save index of vertex in respective row
					indexRow.push( index );

					// increase index
					index ++;

				}

				// now save vertices of the row in our index array
				indexArray.push( indexRow );

			}

			// generate indices

			for ( x = 0; x < radialSegments; x ++ ) {

				for ( y = 0; y < heightSegments; y ++ ) {

					// we use the index array to access the correct indices
					var i1 = indexArray[ y ][ x ];
					var i2 = indexArray[ y + 1 ][ x ];
					var i3 = indexArray[ y + 1 ][ x + 1 ];
					var i4 = indexArray[ y ][ x + 1 ];

					// face one
					indices.setX( indexOffset, i1 ); indexOffset ++;
					indices.setX( indexOffset, i2 ); indexOffset ++;
					indices.setX( indexOffset, i4 ); indexOffset ++;

					// face two
					indices.setX( indexOffset, i2 ); indexOffset ++;
					indices.setX( indexOffset, i3 ); indexOffset ++;
					indices.setX( indexOffset, i4 ); indexOffset ++;

					// update counters
					groupCount += 6;

				}

			}

			// add a group to the geometry. this will ensure multi material support
			scope.addGroup( groupStart, groupCount, 0 );

			// calculate new start value for groups
			groupStart += groupCount;

		}

		function generateCap( top ) {

			var x, centerIndexStart, centerIndexEnd;

			var uv = new Vector2();
			var vertex = new Vector3();

			var groupCount = 0;

			var radius = ( top === true ) ? radiusTop : radiusBottom;
			var sign = ( top === true ) ? 1 : - 1;

			// save the index of the first center vertex
			centerIndexStart = index;

			// first we generate the center vertex data of the cap.
			// because the geometry needs one set of uvs per face,
			// we must generate a center vertex per face/segment

			for ( x = 1; x <= radialSegments; x ++ ) {

				// vertex
				vertices.setXYZ( index, 0, halfHeight * sign, 0 );

				// normal
				normals.setXYZ( index, 0, sign, 0 );

				// uv
				uv.x = 0.5;
				uv.y = 0.5;

				uvs.setXY( index, uv.x, uv.y );

				// increase index
				index ++;

			}

			// save the index of the last center vertex
			centerIndexEnd = index;

			// now we generate the surrounding vertices, normals and uvs

			for ( x = 0; x <= radialSegments; x ++ ) {

				var u = x / radialSegments;
				var theta = u * thetaLength + thetaStart;

				var cosTheta = Math.cos( theta );
				var sinTheta = Math.sin( theta );

				// vertex
				vertex.x = radius * sinTheta;
				vertex.y = halfHeight * sign;
				vertex.z = radius * cosTheta;
				vertices.setXYZ( index, vertex.x, vertex.y, vertex.z );

				// normal
				normals.setXYZ( index, 0, sign, 0 );

				// uv
				uv.x = ( cosTheta * 0.5 ) + 0.5;
				uv.y = ( sinTheta * 0.5 * sign ) + 0.5;
				uvs.setXY( index, uv.x, uv.y );

				// increase index
				index ++;

			}

			// generate indices

			for ( x = 0; x < radialSegments; x ++ ) {

				var c = centerIndexStart + x;
				var i = centerIndexEnd + x;

				if ( top === true ) {

					// face top
					indices.setX( indexOffset, i ); indexOffset ++;
					indices.setX( indexOffset, i + 1 ); indexOffset ++;
					indices.setX( indexOffset, c ); indexOffset ++;

				} else {

					// face bottom
					indices.setX( indexOffset, i + 1 ); indexOffset ++;
					indices.setX( indexOffset, i ); indexOffset ++;
					indices.setX( indexOffset, c ); indexOffset ++;

				}

				// update counters
				groupCount += 3;

			}

			// add a group to the geometry. this will ensure multi material support
			scope.addGroup( groupStart, groupCount, top === true ? 1 : 2 );

			// calculate new start value for groups
			groupStart += groupCount;

		}

	}

	CylinderBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	CylinderBufferGeometry.prototype.constructor = CylinderBufferGeometry;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function CylinderGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {

		Geometry.call( this );

		this.type = 'CylinderGeometry';

		this.parameters = {
			radiusTop: radiusTop,
			radiusBottom: radiusBottom,
			height: height,
			radialSegments: radialSegments,
			heightSegments: heightSegments,
			openEnded: openEnded,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		this.fromBufferGeometry( new CylinderBufferGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) );
		this.mergeVertices();

	}

	CylinderGeometry.prototype = Object.create( Geometry.prototype );
	CylinderGeometry.prototype.constructor = CylinderGeometry;

	/**
	 * @author abelnation / http://github.com/abelnation
	 */

	function ConeGeometry( radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {

		CylinderGeometry.call( this, 0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength );

		this.type = 'ConeGeometry';

		this.parameters = {
			radius: radius,
			height: height,
			radialSegments: radialSegments,
			heightSegments: heightSegments,
			openEnded: openEnded,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

	}

	ConeGeometry.prototype = Object.create( CylinderGeometry.prototype );
	ConeGeometry.prototype.constructor = ConeGeometry;

	/**
	 * @author: abelnation / http://github.com/abelnation
	 */

	function ConeBufferGeometry( radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {

		CylinderBufferGeometry.call( this, 0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength );

		this.type = 'ConeBufferGeometry';

		this.parameters = {
			radius: radius,
			height: height,
			radialSegments: radialSegments,
			heightSegments: heightSegments,
			openEnded: openEnded,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

	}

	ConeBufferGeometry.prototype = Object.create( CylinderBufferGeometry.prototype );
	ConeBufferGeometry.prototype.constructor = ConeBufferGeometry;

	/**
	 * @author benaadams / https://twitter.com/ben_a_adams
	 */

	function CircleBufferGeometry( radius, segments, thetaStart, thetaLength ) {

		BufferGeometry.call( this );

		this.type = 'CircleBufferGeometry';

		this.parameters = {
			radius: radius,
			segments: segments,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		radius = radius || 50;
		segments = segments !== undefined ? Math.max( 3, segments ) : 8;

		thetaStart = thetaStart !== undefined ? thetaStart : 0;
		thetaLength = thetaLength !== undefined ? thetaLength : Math.PI * 2;

		var vertices = segments + 2;

		var positions = new Float32Array( vertices * 3 );
		var normals = new Float32Array( vertices * 3 );
		var uvs = new Float32Array( vertices * 2 );

		// center data is already zero, but need to set a few extras
		normals[ 2 ] = 1.0;
		uvs[ 0 ] = 0.5;
		uvs[ 1 ] = 0.5;

		for ( var s = 0, i = 3, ii = 2 ; s <= segments; s ++, i += 3, ii += 2 ) {

			var segment = thetaStart + s / segments * thetaLength;

			positions[ i ] = radius * Math.cos( segment );
			positions[ i + 1 ] = radius * Math.sin( segment );

			normals[ i + 2 ] = 1; // normal z

			uvs[ ii ] = ( positions[ i ] / radius + 1 ) / 2;
			uvs[ ii + 1 ] = ( positions[ i + 1 ] / radius + 1 ) / 2;

		}

		var indices = [];

		for ( var i = 1; i <= segments; i ++ ) {

			indices.push( i, i + 1, 0 );

		}

		this.setIndex( new BufferAttribute( new Uint16Array( indices ), 1 ) );
		this.addAttribute( 'position', new BufferAttribute( positions, 3 ) );
		this.addAttribute( 'normal', new BufferAttribute( normals, 3 ) );
		this.addAttribute( 'uv', new BufferAttribute( uvs, 2 ) );

		this.boundingSphere = new Sphere( new Vector3(), radius );

	}

	CircleBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	CircleBufferGeometry.prototype.constructor = CircleBufferGeometry;

	/**
	 * @author hughes
	 */

	function CircleGeometry( radius, segments, thetaStart, thetaLength ) {

		Geometry.call( this );

		this.type = 'CircleGeometry';

		this.parameters = {
			radius: radius,
			segments: segments,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		this.fromBufferGeometry( new CircleBufferGeometry( radius, segments, thetaStart, thetaLength ) );

	}

	CircleGeometry.prototype = Object.create( Geometry.prototype );
	CircleGeometry.prototype.constructor = CircleGeometry;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * based on http://papervision3d.googlecode.com/svn/trunk/as3/trunk/src/org/papervision3d/objects/primitives/Cube.as
	 */

	function BoxGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) {

		Geometry.call( this );

		this.type = 'BoxGeometry';

		this.parameters = {
			width: width,
			height: height,
			depth: depth,
			widthSegments: widthSegments,
			heightSegments: heightSegments,
			depthSegments: depthSegments
		};

		this.fromBufferGeometry( new BoxBufferGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) );
		this.mergeVertices();

	}

	BoxGeometry.prototype = Object.create( Geometry.prototype );
	BoxGeometry.prototype.constructor = BoxGeometry;



	var Geometries = Object.freeze({
		WireframeGeometry: WireframeGeometry,
		ParametricGeometry: ParametricGeometry,
		ParametricBufferGeometry: ParametricBufferGeometry,
		TetrahedronGeometry: TetrahedronGeometry,
		TetrahedronBufferGeometry: TetrahedronBufferGeometry,
		OctahedronGeometry: OctahedronGeometry,
		OctahedronBufferGeometry: OctahedronBufferGeometry,
		IcosahedronGeometry: IcosahedronGeometry,
		IcosahedronBufferGeometry: IcosahedronBufferGeometry,
		DodecahedronGeometry: DodecahedronGeometry,
		DodecahedronBufferGeometry: DodecahedronBufferGeometry,
		PolyhedronGeometry: PolyhedronGeometry,
		PolyhedronBufferGeometry: PolyhedronBufferGeometry,
		TubeGeometry: TubeGeometry,
		TubeBufferGeometry: TubeBufferGeometry,
		TorusKnotGeometry: TorusKnotGeometry,
		TorusKnotBufferGeometry: TorusKnotBufferGeometry,
		TorusGeometry: TorusGeometry,
		TorusBufferGeometry: TorusBufferGeometry,
		TextGeometry: TextGeometry,
		SphereBufferGeometry: SphereBufferGeometry,
		SphereGeometry: SphereGeometry,
		RingGeometry: RingGeometry,
		RingBufferGeometry: RingBufferGeometry,
		PlaneBufferGeometry: PlaneBufferGeometry,
		PlaneGeometry: PlaneGeometry,
		LatheGeometry: LatheGeometry,
		LatheBufferGeometry: LatheBufferGeometry,
		ShapeGeometry: ShapeGeometry,
		ShapeBufferGeometry: ShapeBufferGeometry,
		ExtrudeGeometry: ExtrudeGeometry,
		EdgesGeometry: EdgesGeometry,
		ConeGeometry: ConeGeometry,
		ConeBufferGeometry: ConeBufferGeometry,
		CylinderGeometry: CylinderGeometry,
		CylinderBufferGeometry: CylinderBufferGeometry,
		CircleBufferGeometry: CircleBufferGeometry,
		CircleGeometry: CircleGeometry,
		BoxBufferGeometry: BoxBufferGeometry,
		BoxGeometry: BoxGeometry
	});

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function ShadowMaterial() {

		ShaderMaterial.call( this, {
			uniforms: UniformsUtils.merge( [
				UniformsLib.lights,
				{
					opacity: { value: 1.0 }
				}
			] ),
			vertexShader: ShaderChunk[ 'shadow_vert' ],
			fragmentShader: ShaderChunk[ 'shadow_frag' ]
		} );

		this.lights = true;
		this.transparent = true;

		Object.defineProperties( this, {
			opacity: {
				enumerable: true,
				get: function () {
					return this.uniforms.opacity.value;
				},
				set: function ( value ) {
					this.uniforms.opacity.value = value;
				}
			}
		} );

	}

	ShadowMaterial.prototype = Object.create( ShaderMaterial.prototype );
	ShadowMaterial.prototype.constructor = ShadowMaterial;

	ShadowMaterial.prototype.isShadowMaterial = true;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function RawShaderMaterial( parameters ) {

		ShaderMaterial.call( this, parameters );

		this.type = 'RawShaderMaterial';

	}

	RawShaderMaterial.prototype = Object.create( ShaderMaterial.prototype );
	RawShaderMaterial.prototype.constructor = RawShaderMaterial;

	RawShaderMaterial.prototype.isRawShaderMaterial = true;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function MultiMaterial( materials ) {

		this.uuid = _Math.generateUUID();

		this.type = 'MultiMaterial';

		this.materials = Array.isArray( materials ) ? materials : [];

		this.visible = true;

	}

	MultiMaterial.prototype = {

		constructor: MultiMaterial,

		isMultiMaterial: true,

		toJSON: function ( meta ) {

			var output = {
				metadata: {
					version: 4.2,
					type: 'material',
					generator: 'MaterialExporter'
				},
				uuid: this.uuid,
				type: this.type,
				materials: []
			};

			var materials = this.materials;

			for ( var i = 0, l = materials.length; i < l; i ++ ) {

				var material = materials[ i ].toJSON( meta );
				delete material.metadata;

				output.materials.push( material );

			}

			output.visible = this.visible;

			return output;

		},

		clone: function () {

			var material = new this.constructor();

			for ( var i = 0; i < this.materials.length; i ++ ) {

				material.materials.push( this.materials[ i ].clone() );

			}

			material.visible = this.visible;

			return material;

		}

	};

	/**
	 * @author WestLangley / http://github.com/WestLangley
	 *
	 * parameters = {
	 *  color: <hex>,
	 *  roughness: <float>,
	 *  metalness: <float>,
	 *  opacity: <float>,
	 *
	 *  map: new THREE.Texture( <Image> ),
	 *
	 *  lightMap: new THREE.Texture( <Image> ),
	 *  lightMapIntensity: <float>
	 *
	 *  aoMap: new THREE.Texture( <Image> ),
	 *  aoMapIntensity: <float>
	 *
	 *  emissive: <hex>,
	 *  emissiveIntensity: <float>
	 *  emissiveMap: new THREE.Texture( <Image> ),
	 *
	 *  bumpMap: new THREE.Texture( <Image> ),
	 *  bumpScale: <float>,
	 *
	 *  normalMap: new THREE.Texture( <Image> ),
	 *  normalScale: <Vector2>,
	 *
	 *  displacementMap: new THREE.Texture( <Image> ),
	 *  displacementScale: <float>,
	 *  displacementBias: <float>,
	 *
	 *  roughnessMap: new THREE.Texture( <Image> ),
	 *
	 *  metalnessMap: new THREE.Texture( <Image> ),
	 *
	 *  alphaMap: new THREE.Texture( <Image> ),
	 *
	 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
	 *  envMapIntensity: <float>
	 *
	 *  refractionRatio: <float>,
	 *
	 *  wireframe: <boolean>,
	 *  wireframeLinewidth: <float>,
	 *
	 *  skinning: <bool>,
	 *  morphTargets: <bool>,
	 *  morphNormals: <bool>
	 * }
	 */

	function MeshStandardMaterial( parameters ) {

		Material.call( this );

		this.defines = { 'STANDARD': '' };

		this.type = 'MeshStandardMaterial';

		this.color = new Color( 0xffffff ); // diffuse
		this.roughness = 0.5;
		this.metalness = 0.5;

		this.map = null;

		this.lightMap = null;
		this.lightMapIntensity = 1.0;

		this.aoMap = null;
		this.aoMapIntensity = 1.0;

		this.emissive = new Color( 0x000000 );
		this.emissiveIntensity = 1.0;
		this.emissiveMap = null;

		this.bumpMap = null;
		this.bumpScale = 1;

		this.normalMap = null;
		this.normalScale = new Vector2( 1, 1 );

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.roughnessMap = null;

		this.metalnessMap = null;

		this.alphaMap = null;

		this.envMap = null;
		this.envMapIntensity = 1.0;

		this.refractionRatio = 0.98;

		this.wireframe = false;
		this.wireframeLinewidth = 1;
		this.wireframeLinecap = 'round';
		this.wireframeLinejoin = 'round';

		this.skinning = false;
		this.morphTargets = false;
		this.morphNormals = false;

		this.setValues( parameters );

	}

	MeshStandardMaterial.prototype = Object.create( Material.prototype );
	MeshStandardMaterial.prototype.constructor = MeshStandardMaterial;

	MeshStandardMaterial.prototype.isMeshStandardMaterial = true;

	MeshStandardMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.defines = { 'STANDARD': '' };

		this.color.copy( source.color );
		this.roughness = source.roughness;
		this.metalness = source.metalness;

		this.map = source.map;

		this.lightMap = source.lightMap;
		this.lightMapIntensity = source.lightMapIntensity;

		this.aoMap = source.aoMap;
		this.aoMapIntensity = source.aoMapIntensity;

		this.emissive.copy( source.emissive );
		this.emissiveMap = source.emissiveMap;
		this.emissiveIntensity = source.emissiveIntensity;

		this.bumpMap = source.bumpMap;
		this.bumpScale = source.bumpScale;

		this.normalMap = source.normalMap;
		this.normalScale.copy( source.normalScale );

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.roughnessMap = source.roughnessMap;

		this.metalnessMap = source.metalnessMap;

		this.alphaMap = source.alphaMap;

		this.envMap = source.envMap;
		this.envMapIntensity = source.envMapIntensity;

		this.refractionRatio = source.refractionRatio;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;
		this.wireframeLinecap = source.wireframeLinecap;
		this.wireframeLinejoin = source.wireframeLinejoin;

		this.skinning = source.skinning;
		this.morphTargets = source.morphTargets;
		this.morphNormals = source.morphNormals;

		return this;

	};

	/**
	 * @author WestLangley / http://github.com/WestLangley
	 *
	 * parameters = {
	 *  reflectivity: <float>
	 * }
	 */

	function MeshPhysicalMaterial( parameters ) {

		MeshStandardMaterial.call( this );

		this.defines = { 'PHYSICAL': '' };

		this.type = 'MeshPhysicalMaterial';

		this.reflectivity = 0.5; // maps to F0 = 0.04

		this.clearCoat = 0.0;
		this.clearCoatRoughness = 0.0;

		this.setValues( parameters );

	}

	MeshPhysicalMaterial.prototype = Object.create( MeshStandardMaterial.prototype );
	MeshPhysicalMaterial.prototype.constructor = MeshPhysicalMaterial;

	MeshPhysicalMaterial.prototype.isMeshPhysicalMaterial = true;

	MeshPhysicalMaterial.prototype.copy = function ( source ) {

		MeshStandardMaterial.prototype.copy.call( this, source );

		this.defines = { 'PHYSICAL': '' };

		this.reflectivity = source.reflectivity;

		this.clearCoat = source.clearCoat;
		this.clearCoatRoughness = source.clearCoatRoughness;

		return this;

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 *
	 * parameters = {
	 *  color: <hex>,
	 *  specular: <hex>,
	 *  shininess: <float>,
	 *  opacity: <float>,
	 *
	 *  map: new THREE.Texture( <Image> ),
	 *
	 *  lightMap: new THREE.Texture( <Image> ),
	 *  lightMapIntensity: <float>
	 *
	 *  aoMap: new THREE.Texture( <Image> ),
	 *  aoMapIntensity: <float>
	 *
	 *  emissive: <hex>,
	 *  emissiveIntensity: <float>
	 *  emissiveMap: new THREE.Texture( <Image> ),
	 *
	 *  bumpMap: new THREE.Texture( <Image> ),
	 *  bumpScale: <float>,
	 *
	 *  normalMap: new THREE.Texture( <Image> ),
	 *  normalScale: <Vector2>,
	 *
	 *  displacementMap: new THREE.Texture( <Image> ),
	 *  displacementScale: <float>,
	 *  displacementBias: <float>,
	 *
	 *  specularMap: new THREE.Texture( <Image> ),
	 *
	 *  alphaMap: new THREE.Texture( <Image> ),
	 *
	 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
	 *  combine: THREE.Multiply,
	 *  reflectivity: <float>,
	 *  refractionRatio: <float>,
	 *
	 *  wireframe: <boolean>,
	 *  wireframeLinewidth: <float>,
	 *
	 *  skinning: <bool>,
	 *  morphTargets: <bool>,
	 *  morphNormals: <bool>
	 * }
	 */

	function MeshPhongMaterial( parameters ) {

		Material.call( this );

		this.type = 'MeshPhongMaterial';

		this.color = new Color( 0xffffff ); // diffuse
		this.specular = new Color( 0x111111 );
		this.shininess = 30;

		this.map = null;

		this.lightMap = null;
		this.lightMapIntensity = 1.0;

		this.aoMap = null;
		this.aoMapIntensity = 1.0;

		this.emissive = new Color( 0x000000 );
		this.emissiveIntensity = 1.0;
		this.emissiveMap = null;

		this.bumpMap = null;
		this.bumpScale = 1;

		this.normalMap = null;
		this.normalScale = new Vector2( 1, 1 );

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.specularMap = null;

		this.alphaMap = null;

		this.envMap = null;
		this.combine = MultiplyOperation;
		this.reflectivity = 1;
		this.refractionRatio = 0.98;

		this.wireframe = false;
		this.wireframeLinewidth = 1;
		this.wireframeLinecap = 'round';
		this.wireframeLinejoin = 'round';

		this.skinning = false;
		this.morphTargets = false;
		this.morphNormals = false;

		this.setValues( parameters );

	}

	MeshPhongMaterial.prototype = Object.create( Material.prototype );
	MeshPhongMaterial.prototype.constructor = MeshPhongMaterial;

	MeshPhongMaterial.prototype.isMeshPhongMaterial = true;

	MeshPhongMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.color.copy( source.color );
		this.specular.copy( source.specular );
		this.shininess = source.shininess;

		this.map = source.map;

		this.lightMap = source.lightMap;
		this.lightMapIntensity = source.lightMapIntensity;

		this.aoMap = source.aoMap;
		this.aoMapIntensity = source.aoMapIntensity;

		this.emissive.copy( source.emissive );
		this.emissiveMap = source.emissiveMap;
		this.emissiveIntensity = source.emissiveIntensity;

		this.bumpMap = source.bumpMap;
		this.bumpScale = source.bumpScale;

		this.normalMap = source.normalMap;
		this.normalScale.copy( source.normalScale );

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.specularMap = source.specularMap;

		this.alphaMap = source.alphaMap;

		this.envMap = source.envMap;
		this.combine = source.combine;
		this.reflectivity = source.reflectivity;
		this.refractionRatio = source.refractionRatio;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;
		this.wireframeLinecap = source.wireframeLinecap;
		this.wireframeLinejoin = source.wireframeLinejoin;

		this.skinning = source.skinning;
		this.morphTargets = source.morphTargets;
		this.morphNormals = source.morphNormals;

		return this;

	};

	/**
	 * @author takahirox / http://github.com/takahirox
	 *
	 * parameters = {
	 *  gradientMap: new THREE.Texture( <Image> )
	 * }
	 */

	function MeshToonMaterial( parameters ) {

		MeshPhongMaterial.call( this );

		this.defines = { 'TOON': '' };

		this.type = 'MeshToonMaterial';

		this.gradientMap = null;

		this.setValues( parameters );

	}

	MeshToonMaterial.prototype = Object.create( MeshPhongMaterial.prototype );
	MeshToonMaterial.prototype.constructor = MeshToonMaterial;

	MeshToonMaterial.prototype.isMeshToonMaterial = true;

	MeshToonMaterial.prototype.copy = function ( source ) {

		MeshPhongMaterial.prototype.copy.call( this, source );

		this.gradientMap = source.gradientMap;

		return this;

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author WestLangley / http://github.com/WestLangley
	 *
	 * parameters = {
	 *  opacity: <float>,
	 *
	 *  bumpMap: new THREE.Texture( <Image> ),
	 *  bumpScale: <float>,
	 *
	 *  normalMap: new THREE.Texture( <Image> ),
	 *  normalScale: <Vector2>,
	 *
	 *  displacementMap: new THREE.Texture( <Image> ),
	 *  displacementScale: <float>,
	 *  displacementBias: <float>,
	 *
	 *  wireframe: <boolean>,
	 *  wireframeLinewidth: <float>
	 *
	 *  skinning: <bool>,
	 *  morphTargets: <bool>,
	 *  morphNormals: <bool>
	 * }
	 */

	function MeshNormalMaterial( parameters ) {

		Material.call( this, parameters );

		this.type = 'MeshNormalMaterial';

		this.bumpMap = null;
		this.bumpScale = 1;

		this.normalMap = null;
		this.normalScale = new Vector2( 1, 1 );

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.wireframe = false;
		this.wireframeLinewidth = 1;

		this.fog = false;
		this.lights = false;

		this.skinning = false;
		this.morphTargets = false;
		this.morphNormals = false;

		this.setValues( parameters );

	}

	MeshNormalMaterial.prototype = Object.create( Material.prototype );
	MeshNormalMaterial.prototype.constructor = MeshNormalMaterial;

	MeshNormalMaterial.prototype.isMeshNormalMaterial = true;

	MeshNormalMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.bumpMap = source.bumpMap;
		this.bumpScale = source.bumpScale;

		this.normalMap = source.normalMap;
		this.normalScale.copy( source.normalScale );

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;

		this.skinning = source.skinning;
		this.morphTargets = source.morphTargets;
		this.morphNormals = source.morphNormals;

		return this;

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 *
	 * parameters = {
	 *  color: <hex>,
	 *  opacity: <float>,
	 *
	 *  map: new THREE.Texture( <Image> ),
	 *
	 *  lightMap: new THREE.Texture( <Image> ),
	 *  lightMapIntensity: <float>
	 *
	 *  aoMap: new THREE.Texture( <Image> ),
	 *  aoMapIntensity: <float>
	 *
	 *  emissive: <hex>,
	 *  emissiveIntensity: <float>
	 *  emissiveMap: new THREE.Texture( <Image> ),
	 *
	 *  specularMap: new THREE.Texture( <Image> ),
	 *
	 *  alphaMap: new THREE.Texture( <Image> ),
	 *
	 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
	 *  combine: THREE.Multiply,
	 *  reflectivity: <float>,
	 *  refractionRatio: <float>,
	 *
	 *  wireframe: <boolean>,
	 *  wireframeLinewidth: <float>,
	 *
	 *  skinning: <bool>,
	 *  morphTargets: <bool>,
	 *  morphNormals: <bool>
	 * }
	 */

	function MeshLambertMaterial( parameters ) {

		Material.call( this );

		this.type = 'MeshLambertMaterial';

		this.color = new Color( 0xffffff ); // diffuse

		this.map = null;

		this.lightMap = null;
		this.lightMapIntensity = 1.0;

		this.aoMap = null;
		this.aoMapIntensity = 1.0;

		this.emissive = new Color( 0x000000 );
		this.emissiveIntensity = 1.0;
		this.emissiveMap = null;

		this.specularMap = null;

		this.alphaMap = null;

		this.envMap = null;
		this.combine = MultiplyOperation;
		this.reflectivity = 1;
		this.refractionRatio = 0.98;

		this.wireframe = false;
		this.wireframeLinewidth = 1;
		this.wireframeLinecap = 'round';
		this.wireframeLinejoin = 'round';

		this.skinning = false;
		this.morphTargets = false;
		this.morphNormals = false;

		this.setValues( parameters );

	}

	MeshLambertMaterial.prototype = Object.create( Material.prototype );
	MeshLambertMaterial.prototype.constructor = MeshLambertMaterial;

	MeshLambertMaterial.prototype.isMeshLambertMaterial = true;

	MeshLambertMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.color.copy( source.color );

		this.map = source.map;

		this.lightMap = source.lightMap;
		this.lightMapIntensity = source.lightMapIntensity;

		this.aoMap = source.aoMap;
		this.aoMapIntensity = source.aoMapIntensity;

		this.emissive.copy( source.emissive );
		this.emissiveMap = source.emissiveMap;
		this.emissiveIntensity = source.emissiveIntensity;

		this.specularMap = source.specularMap;

		this.alphaMap = source.alphaMap;

		this.envMap = source.envMap;
		this.combine = source.combine;
		this.reflectivity = source.reflectivity;
		this.refractionRatio = source.refractionRatio;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;
		this.wireframeLinecap = source.wireframeLinecap;
		this.wireframeLinejoin = source.wireframeLinejoin;

		this.skinning = source.skinning;
		this.morphTargets = source.morphTargets;
		this.morphNormals = source.morphNormals;

		return this;

	};

	/**
	 * @author alteredq / http://alteredqualia.com/
	 *
	 * parameters = {
	 *  color: <hex>,
	 *  opacity: <float>,
	 *
	 *  linewidth: <float>,
	 *
	 *  scale: <float>,
	 *  dashSize: <float>,
	 *  gapSize: <float>
	 * }
	 */

	function LineDashedMaterial( parameters ) {

		Material.call( this );

		this.type = 'LineDashedMaterial';

		this.color = new Color( 0xffffff );

		this.linewidth = 1;

		this.scale = 1;
		this.dashSize = 3;
		this.gapSize = 1;

		this.lights = false;

		this.setValues( parameters );

	}

	LineDashedMaterial.prototype = Object.create( Material.prototype );
	LineDashedMaterial.prototype.constructor = LineDashedMaterial;

	LineDashedMaterial.prototype.isLineDashedMaterial = true;

	LineDashedMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.color.copy( source.color );

		this.linewidth = source.linewidth;

		this.scale = source.scale;
		this.dashSize = source.dashSize;
		this.gapSize = source.gapSize;

		return this;

	};



	var Materials = Object.freeze({
		ShadowMaterial: ShadowMaterial,
		SpriteMaterial: SpriteMaterial,
		RawShaderMaterial: RawShaderMaterial,
		ShaderMaterial: ShaderMaterial,
		PointsMaterial: PointsMaterial,
		MultiMaterial: MultiMaterial,
		MeshPhysicalMaterial: MeshPhysicalMaterial,
		MeshStandardMaterial: MeshStandardMaterial,
		MeshPhongMaterial: MeshPhongMaterial,
		MeshToonMaterial: MeshToonMaterial,
		MeshNormalMaterial: MeshNormalMaterial,
		MeshLambertMaterial: MeshLambertMaterial,
		MeshDepthMaterial: MeshDepthMaterial,
		MeshBasicMaterial: MeshBasicMaterial,
		LineDashedMaterial: LineDashedMaterial,
		LineBasicMaterial: LineBasicMaterial,
		Material: Material
	});

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	var Cache = {

		enabled: false,

		files: {},

		add: function ( key, file ) {

			if ( this.enabled === false ) return;

			// console.log( 'THREE.Cache', 'Adding key:', key );

			this.files[ key ] = file;

		},

		get: function ( key ) {

			if ( this.enabled === false ) return;

			// console.log( 'THREE.Cache', 'Checking key:', key );

			return this.files[ key ];

		},

		remove: function ( key ) {

			delete this.files[ key ];

		},

		clear: function () {

			this.files = {};

		}

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function LoadingManager( onLoad, onProgress, onError ) {

		var scope = this;

		var isLoading = false, itemsLoaded = 0, itemsTotal = 0;

		this.onStart = undefined;
		this.onLoad = onLoad;
		this.onProgress = onProgress;
		this.onError = onError;

		this.itemStart = function ( url ) {

			itemsTotal ++;

			if ( isLoading === false ) {

				if ( scope.onStart !== undefined ) {

					scope.onStart( url, itemsLoaded, itemsTotal );

				}

			}

			isLoading = true;

		};

		this.itemEnd = function ( url ) {

			itemsLoaded ++;

			if ( scope.onProgress !== undefined ) {

				scope.onProgress( url, itemsLoaded, itemsTotal );

			}

			if ( itemsLoaded === itemsTotal ) {

				isLoading = false;

				if ( scope.onLoad !== undefined ) {

					scope.onLoad();

				}

			}

		};

		this.itemError = function ( url ) {

			if ( scope.onError !== undefined ) {

				scope.onError( url );

			}

		};

	}

	var DefaultLoadingManager = new LoadingManager();

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function FileLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

	}

	Object.assign( FileLoader.prototype, {

		load: function ( url, onLoad, onProgress, onError ) {

			if ( url === undefined ) url = '';

			if ( this.path !== undefined ) url = this.path + url;

			var scope = this;

			var cached = Cache.get( url );

			if ( cached !== undefined ) {

				scope.manager.itemStart( url );

				setTimeout( function () {

					if ( onLoad ) onLoad( cached );

					scope.manager.itemEnd( url );

				}, 0 );

				return cached;

			}

			// Check for data: URI
			var dataUriRegex = /^data:(.*?)(;base64)?,(.*)$/;
			var dataUriRegexResult = url.match( dataUriRegex );

			// Safari can not handle Data URIs through XMLHttpRequest so process manually
			if ( dataUriRegexResult ) {

				var mimeType = dataUriRegexResult[ 1 ];
				var isBase64 = !! dataUriRegexResult[ 2 ];
				var data = dataUriRegexResult[ 3 ];

				data = window.decodeURIComponent( data );

				if ( isBase64 ) data = window.atob( data );

				try {

					var response;
					var responseType = ( this.responseType || '' ).toLowerCase();

					switch ( responseType ) {

						case 'arraybuffer':
						case 'blob':

						 	response = new ArrayBuffer( data.length );

							var view = new Uint8Array( response );

							for ( var i = 0; i < data.length; i ++ ) {

								view[ i ] = data.charCodeAt( i );

							}

							if ( responseType === 'blob' ) {

								response = new Blob( [ response ], { type: mimeType } );

							}

							break;

						case 'document':

							var parser = new DOMParser();
							response = parser.parseFromString( data, mimeType );

							break;

						case 'json':

							response = JSON.parse( data );

							break;

						default: // 'text' or other

							response = data;

							break;

					}

					// Wait for next browser tick
					window.setTimeout( function () {

						if ( onLoad ) onLoad( response );

						scope.manager.itemEnd( url );

					}, 0 );

				} catch ( error ) {

					// Wait for next browser tick
					window.setTimeout( function () {

						if ( onError ) onError( error );

						scope.manager.itemError( url );

					}, 0 );

				}

			} else {

				var request = new XMLHttpRequest();
				request.open( 'GET', url, true );

				request.addEventListener( 'load', function ( event ) {

					var response = event.target.response;

					Cache.add( url, response );

					if ( this.status === 200 ) {

						if ( onLoad ) onLoad( response );

						scope.manager.itemEnd( url );

					} else if ( this.status === 0 ) {

						// Some browsers return HTTP Status 0 when using non-http protocol
						// e.g. 'file://' or 'data://'. Handle as success.

						console.warn( 'THREE.FileLoader: HTTP Status 0 received.' );

						if ( onLoad ) onLoad( response );

						scope.manager.itemEnd( url );

					} else {

						if ( onError ) onError( event );

						scope.manager.itemError( url );

					}

				}, false );

				if ( onProgress !== undefined ) {

					request.addEventListener( 'progress', function ( event ) {

						onProgress( event );

					}, false );

				}

				request.addEventListener( 'error', function ( event ) {

					if ( onError ) onError( event );

					scope.manager.itemError( url );

				}, false );

				if ( this.responseType !== undefined ) request.responseType = this.responseType;
				if ( this.withCredentials !== undefined ) request.withCredentials = this.withCredentials;

				if ( request.overrideMimeType ) request.overrideMimeType( this.mimeType !== undefined ? this.mimeType : 'text/plain' );

				request.send( null );

			}

			scope.manager.itemStart( url );

			return request;

		},

		setPath: function ( value ) {

			this.path = value;
			return this;

		},

		setResponseType: function ( value ) {

			this.responseType = value;
			return this;

		},

		setWithCredentials: function ( value ) {

			this.withCredentials = value;
			return this;

		},

		setMimeType: function ( value ) {

			this.mimeType = value;
			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 *
	 * Abstract Base class to block based textures loader (dds, pvr, ...)
	 */

	function CompressedTextureLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

		// override in sub classes
		this._parser = null;

	}

	Object.assign( CompressedTextureLoader.prototype, {

		load: function ( url, onLoad, onProgress, onError ) {

			var scope = this;

			var images = [];

			var texture = new CompressedTexture();
			texture.image = images;

			var loader = new FileLoader( this.manager );
			loader.setPath( this.path );
			loader.setResponseType( 'arraybuffer' );

			function loadTexture( i ) {

				loader.load( url[ i ], function ( buffer ) {

					var texDatas = scope._parser( buffer, true );

					images[ i ] = {
						width: texDatas.width,
						height: texDatas.height,
						format: texDatas.format,
						mipmaps: texDatas.mipmaps
					};

					loaded += 1;

					if ( loaded === 6 ) {

						if ( texDatas.mipmapCount === 1 )
							texture.minFilter = LinearFilter;

						texture.format = texDatas.format;
						texture.needsUpdate = true;

						if ( onLoad ) onLoad( texture );

					}

				}, onProgress, onError );

			}

			if ( Array.isArray( url ) ) {

				var loaded = 0;

				for ( var i = 0, il = url.length; i < il; ++ i ) {

					loadTexture( i );

				}

			} else {

				// compressed cubemap texture stored in a single DDS file

				loader.load( url, function ( buffer ) {

					var texDatas = scope._parser( buffer, true );

					if ( texDatas.isCubemap ) {

						var faces = texDatas.mipmaps.length / texDatas.mipmapCount;

						for ( var f = 0; f < faces; f ++ ) {

							images[ f ] = { mipmaps : [] };

							for ( var i = 0; i < texDatas.mipmapCount; i ++ ) {

								images[ f ].mipmaps.push( texDatas.mipmaps[ f * texDatas.mipmapCount + i ] );
								images[ f ].format = texDatas.format;
								images[ f ].width = texDatas.width;
								images[ f ].height = texDatas.height;

							}

						}

					} else {

						texture.image.width = texDatas.width;
						texture.image.height = texDatas.height;
						texture.mipmaps = texDatas.mipmaps;

					}

					if ( texDatas.mipmapCount === 1 ) {

						texture.minFilter = LinearFilter;

					}

					texture.format = texDatas.format;
					texture.needsUpdate = true;

					if ( onLoad ) onLoad( texture );

				}, onProgress, onError );

			}

			return texture;

		},

		setPath: function ( value ) {

			this.path = value;
			return this;

		}

	} );

	/**
	 * @author Nikos M. / https://github.com/foo123/
	 *
	 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
	 */

	var DataTextureLoader = BinaryTextureLoader;
	function BinaryTextureLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

		// override in sub classes
		this._parser = null;

	}

	Object.assign( BinaryTextureLoader.prototype, {

		load: function ( url, onLoad, onProgress, onError ) {

			var scope = this;

			var texture = new DataTexture();

			var loader = new FileLoader( this.manager );
			loader.setResponseType( 'arraybuffer' );

			loader.load( url, function ( buffer ) {

				var texData = scope._parser( buffer );

				if ( ! texData ) return;

				if ( undefined !== texData.image ) {

					texture.image = texData.image;

				} else if ( undefined !== texData.data ) {

					texture.image.width = texData.width;
					texture.image.height = texData.height;
					texture.image.data = texData.data;

				}

				texture.wrapS = undefined !== texData.wrapS ? texData.wrapS : ClampToEdgeWrapping;
				texture.wrapT = undefined !== texData.wrapT ? texData.wrapT : ClampToEdgeWrapping;

				texture.magFilter = undefined !== texData.magFilter ? texData.magFilter : LinearFilter;
				texture.minFilter = undefined !== texData.minFilter ? texData.minFilter : LinearMipMapLinearFilter;

				texture.anisotropy = undefined !== texData.anisotropy ? texData.anisotropy : 1;

				if ( undefined !== texData.format ) {

					texture.format = texData.format;

				}
				if ( undefined !== texData.type ) {

					texture.type = texData.type;

				}

				if ( undefined !== texData.mipmaps ) {

					texture.mipmaps = texData.mipmaps;

				}

				if ( 1 === texData.mipmapCount ) {

					texture.minFilter = LinearFilter;

				}

				texture.needsUpdate = true;

				if ( onLoad ) onLoad( texture, texData );

			}, onProgress, onError );


			return texture;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function ImageLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

	}

	Object.assign( ImageLoader.prototype, {

		load: function ( url, onLoad, onProgress, onError ) {

			var scope = this;

			var image = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'img' );
			image.onload = function () {

				image.onload = null;

				URL.revokeObjectURL( image.src );

				if ( onLoad ) onLoad( image );

				scope.manager.itemEnd( url );

			};
			image.onerror = onError;

			if ( url.indexOf( 'data:' ) === 0 ) {

				image.src = url;

			} else if ( this.crossOrigin !== undefined ) {

				// crossOrigin doesn't work with URL.createObjectURL()?

				image.crossOrigin = this.crossOrigin;
				image.src = url;

			} else {

				var loader = new FileLoader();
				loader.setPath( this.path );
				loader.setResponseType( 'blob' );
				loader.setWithCredentials( this.withCredentials );
				loader.load( url, function ( blob ) {

					image.src = URL.createObjectURL( blob );

				}, onProgress, onError );

			}

			scope.manager.itemStart( url );

			return image;

		},

		setCrossOrigin: function ( value ) {

			this.crossOrigin = value;
			return this;

		},

		setWithCredentials: function ( value ) {

			this.withCredentials = value;
			return this;

		},

		setPath: function ( value ) {

			this.path = value;
			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function CubeTextureLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

	}

	Object.assign( CubeTextureLoader.prototype, {

		load: function ( urls, onLoad, onProgress, onError ) {

			var texture = new CubeTexture();

			var loader = new ImageLoader( this.manager );
			loader.setCrossOrigin( this.crossOrigin );
			loader.setPath( this.path );

			var loaded = 0;

			function loadTexture( i ) {

				loader.load( urls[ i ], function ( image ) {

					texture.images[ i ] = image;

					loaded ++;

					if ( loaded === 6 ) {

						texture.needsUpdate = true;

						if ( onLoad ) onLoad( texture );

					}

				}, undefined, onError );

			}

			for ( var i = 0; i < urls.length; ++ i ) {

				loadTexture( i );

			}

			return texture;

		},

		setCrossOrigin: function ( value ) {

			this.crossOrigin = value;
			return this;

		},

		setPath: function ( value ) {

			this.path = value;
			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function TextureLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

	}

	Object.assign( TextureLoader.prototype, {

		load: function ( url, onLoad, onProgress, onError ) {

			var texture = new Texture();

			var loader = new ImageLoader( this.manager );
			loader.setCrossOrigin( this.crossOrigin );
			loader.setWithCredentials( this.withCredentials );
			loader.setPath( this.path );
			loader.load( url, function ( image ) {

				// JPEGs can't have an alpha channel, so memory can be saved by storing them as RGB.
				var isJPEG = url.search( /\.(jpg|jpeg)$/ ) > 0 || url.search( /^data\:image\/jpeg/ ) === 0;

				texture.format = isJPEG ? RGBFormat : RGBAFormat;
				texture.image = image;
				texture.needsUpdate = true;

				if ( onLoad !== undefined ) {

					onLoad( texture );

				}

			}, onProgress, onError );

			return texture;

		},

		setCrossOrigin: function ( value ) {

			this.crossOrigin = value;
			return this;

		},

		setWithCredentials: function ( value ) {

			this.withCredentials = value;
			return this;

		},

		setPath: function ( value ) {

			this.path = value;
			return this;

		}



	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function Light( color, intensity ) {

		Object3D.call( this );

		this.type = 'Light';

		this.color = new Color( color );
		this.intensity = intensity !== undefined ? intensity : 1;

		this.receiveShadow = undefined;

	}

	Light.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: Light,

		isLight: true,

		copy: function ( source ) {

			Object3D.prototype.copy.call( this, source );

			this.color.copy( source.color );
			this.intensity = source.intensity;

			return this;

		},

		toJSON: function ( meta ) {

			var data = Object3D.prototype.toJSON.call( this, meta );

			data.object.color = this.color.getHex();
			data.object.intensity = this.intensity;

			if ( this.groundColor !== undefined ) data.object.groundColor = this.groundColor.getHex();

			if ( this.distance !== undefined ) data.object.distance = this.distance;
			if ( this.angle !== undefined ) data.object.angle = this.angle;
			if ( this.decay !== undefined ) data.object.decay = this.decay;
			if ( this.penumbra !== undefined ) data.object.penumbra = this.penumbra;

			if ( this.shadow !== undefined ) data.object.shadow = this.shadow.toJSON();

			return data;

		}

	} );

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	function HemisphereLight( skyColor, groundColor, intensity ) {

		Light.call( this, skyColor, intensity );

		this.type = 'HemisphereLight';

		this.castShadow = undefined;

		this.position.copy( Object3D.DefaultUp );
		this.updateMatrix();

		this.groundColor = new Color( groundColor );

	}

	HemisphereLight.prototype = Object.assign( Object.create( Light.prototype ), {

		constructor: HemisphereLight,

		isHemisphereLight: true,

		copy: function ( source ) {

			Light.prototype.copy.call( this, source );

			this.groundColor.copy( source.groundColor );

			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function LightShadow( camera ) {

		this.camera = camera;

		this.bias = 0;
		this.radius = 1;

		this.mapSize = new Vector2( 512, 512 );

		this.map = null;
		this.matrix = new Matrix4();

	}

	Object.assign( LightShadow.prototype, {

		copy: function ( source ) {

			this.camera = source.camera.clone();

			this.bias = source.bias;
			this.radius = source.radius;

			this.mapSize.copy( source.mapSize );

			return this;

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		toJSON: function () {

			var object = {};

			if ( this.bias !== 0 ) object.bias = this.bias;
			if ( this.radius !== 1 ) object.radius = this.radius;
			if ( this.mapSize.x !== 512 || this.mapSize.y !== 512 ) object.mapSize = this.mapSize.toArray();

			object.camera = this.camera.toJSON( false ).object;
			delete object.camera.matrix;

			return object;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function SpotLightShadow() {

		LightShadow.call( this, new PerspectiveCamera( 50, 1, 0.5, 500 ) );

	}

	SpotLightShadow.prototype = Object.assign( Object.create( LightShadow.prototype ), {

		constructor: SpotLightShadow,

		isSpotLightShadow: true,

		update: function ( light ) {

			var fov = _Math.RAD2DEG * 2 * light.angle;
			var aspect = this.mapSize.width / this.mapSize.height;
			var far = light.distance || 500;

			var camera = this.camera;

			if ( fov !== camera.fov || aspect !== camera.aspect || far !== camera.far ) {

				camera.fov = fov;
				camera.aspect = aspect;
				camera.far = far;
				camera.updateProjectionMatrix();

			}

		}

	} );

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	function SpotLight( color, intensity, distance, angle, penumbra, decay ) {

		Light.call( this, color, intensity );

		this.type = 'SpotLight';

		this.position.copy( Object3D.DefaultUp );
		this.updateMatrix();

		this.target = new Object3D();

		Object.defineProperty( this, 'power', {
			get: function () {
				// intensity = power per solid angle.
				// ref: equation (17) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
				return this.intensity * Math.PI;
			},
			set: function ( power ) {
				// intensity = power per solid angle.
				// ref: equation (17) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
				this.intensity = power / Math.PI;
			}
		} );

		this.distance = ( distance !== undefined ) ? distance : 0;
		this.angle = ( angle !== undefined ) ? angle : Math.PI / 3;
		this.penumbra = ( penumbra !== undefined ) ? penumbra : 0;
		this.decay = ( decay !== undefined ) ? decay : 1;	// for physically correct lights, should be 2.

		this.shadow = new SpotLightShadow();

	}

	SpotLight.prototype = Object.assign( Object.create( Light.prototype ), {

		constructor: SpotLight,

		isSpotLight: true,

		copy: function ( source ) {

			Light.prototype.copy.call( this, source );

			this.distance = source.distance;
			this.angle = source.angle;
			this.penumbra = source.penumbra;
			this.decay = source.decay;

			this.target = source.target.clone();

			this.shadow = source.shadow.clone();

			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */


	function PointLight( color, intensity, distance, decay ) {

		Light.call( this, color, intensity );

		this.type = 'PointLight';

		Object.defineProperty( this, 'power', {
			get: function () {
				// intensity = power per solid angle.
				// ref: equation (15) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
				return this.intensity * 4 * Math.PI;

			},
			set: function ( power ) {
				// intensity = power per solid angle.
				// ref: equation (15) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
				this.intensity = power / ( 4 * Math.PI );
			}
		} );

		this.distance = ( distance !== undefined ) ? distance : 0;
		this.decay = ( decay !== undefined ) ? decay : 1;	// for physically correct lights, should be 2.

		this.shadow = new LightShadow( new PerspectiveCamera( 90, 1, 0.5, 500 ) );

	}

	PointLight.prototype = Object.assign( Object.create( Light.prototype ), {

		constructor: PointLight,

		isPointLight: true,

		copy: function ( source ) {

			Light.prototype.copy.call( this, source );

			this.distance = source.distance;
			this.decay = source.decay;

			this.shadow = source.shadow.clone();

			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function DirectionalLightShadow( light ) {

		LightShadow.call( this, new OrthographicCamera( - 5, 5, 5, - 5, 0.5, 500 ) );

	}

	DirectionalLightShadow.prototype = Object.assign( Object.create( LightShadow.prototype ), {

		constructor: DirectionalLightShadow

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function DirectionalLight( color, intensity ) {

		Light.call( this, color, intensity );

		this.type = 'DirectionalLight';

		this.position.copy( Object3D.DefaultUp );
		this.updateMatrix();

		this.target = new Object3D();

		this.shadow = new DirectionalLightShadow();

	}

	DirectionalLight.prototype = Object.assign( Object.create( Light.prototype ), {

		constructor: DirectionalLight,

		isDirectionalLight: true,

		copy: function ( source ) {

			Light.prototype.copy.call( this, source );

			this.target = source.target.clone();

			this.shadow = source.shadow.clone();

			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function AmbientLight( color, intensity ) {

		Light.call( this, color, intensity );

		this.type = 'AmbientLight';

		this.castShadow = undefined;

	}

	AmbientLight.prototype = Object.assign( Object.create( Light.prototype ), {

		constructor: AmbientLight,

		isAmbientLight: true

	} );

	/**
	 * @author tschw
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 */

	var AnimationUtils = {

		// same as Array.prototype.slice, but also works on typed arrays
		arraySlice: function( array, from, to ) {

			if ( AnimationUtils.isTypedArray( array ) ) {

				return new array.constructor( array.subarray( from, to ) );

			}

			return array.slice( from, to );

		},

		// converts an array to a specific type
		convertArray: function( array, type, forceClone ) {

			if ( ! array || // let 'undefined' and 'null' pass
					! forceClone && array.constructor === type ) return array;

			if ( typeof type.BYTES_PER_ELEMENT === 'number' ) {

				return new type( array ); // create typed array

			}

			return Array.prototype.slice.call( array ); // create Array

		},

		isTypedArray: function( object ) {

			return ArrayBuffer.isView( object ) &&
					! ( object instanceof DataView );

		},

		// returns an array by which times and values can be sorted
		getKeyframeOrder: function( times ) {

			function compareTime( i, j ) {

				return times[ i ] - times[ j ];

			}

			var n = times.length;
			var result = new Array( n );
			for ( var i = 0; i !== n; ++ i ) result[ i ] = i;

			result.sort( compareTime );

			return result;

		},

		// uses the array previously returned by 'getKeyframeOrder' to sort data
		sortedArray: function( values, stride, order ) {

			var nValues = values.length;
			var result = new values.constructor( nValues );

			for ( var i = 0, dstOffset = 0; dstOffset !== nValues; ++ i ) {

				var srcOffset = order[ i ] * stride;

				for ( var j = 0; j !== stride; ++ j ) {

					result[ dstOffset ++ ] = values[ srcOffset + j ];

				}

			}

			return result;

		},

		// function for parsing AOS keyframe formats
		flattenJSON: function( jsonKeys, times, values, valuePropertyName ) {

			var i = 1, key = jsonKeys[ 0 ];

			while ( key !== undefined && key[ valuePropertyName ] === undefined ) {

				key = jsonKeys[ i ++ ];

			}

			if ( key === undefined ) return; // no data

			var value = key[ valuePropertyName ];
			if ( value === undefined ) return; // no data

			if ( Array.isArray( value ) ) {

				do {

					value = key[ valuePropertyName ];

					if ( value !== undefined ) {

						times.push( key.time );
						values.push.apply( values, value ); // push all elements

					}

					key = jsonKeys[ i ++ ];

				} while ( key !== undefined );

			} else if ( value.toArray !== undefined ) {
				// ...assume THREE.Math-ish

				do {

					value = key[ valuePropertyName ];

					if ( value !== undefined ) {

						times.push( key.time );
						value.toArray( values, values.length );

					}

					key = jsonKeys[ i ++ ];

				} while ( key !== undefined );

			} else {
				// otherwise push as-is

				do {

					value = key[ valuePropertyName ];

					if ( value !== undefined ) {

						times.push( key.time );
						values.push( value );

					}

					key = jsonKeys[ i ++ ];

				} while ( key !== undefined );

			}

		}

	};

	/**
	 * Abstract base class of interpolants over parametric samples.
	 *
	 * The parameter domain is one dimensional, typically the time or a path
	 * along a curve defined by the data.
	 *
	 * The sample values can have any dimensionality and derived classes may
	 * apply special interpretations to the data.
	 *
	 * This class provides the interval seek in a Template Method, deferring
	 * the actual interpolation to derived classes.
	 *
	 * Time complexity is O(1) for linear access crossing at most two points
	 * and O(log N) for random access, where N is the number of positions.
	 *
	 * References:
	 *
	 * 		http://www.oodesign.com/template-method-pattern.html
	 *
	 * @author tschw
	 */

	function Interpolant(
			parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		this.parameterPositions = parameterPositions;
		this._cachedIndex = 0;

		this.resultBuffer = resultBuffer !== undefined ?
				resultBuffer : new sampleValues.constructor( sampleSize );
		this.sampleValues = sampleValues;
		this.valueSize = sampleSize;

	}

	Interpolant.prototype = {

		constructor: Interpolant,

		evaluate: function( t ) {

			var pp = this.parameterPositions,
				i1 = this._cachedIndex,

				t1 = pp[   i1   ],
				t0 = pp[ i1 - 1 ];

			validate_interval: {

				seek: {

					var right;

					linear_scan: {
	//- See http://jsperf.com/comparison-to-undefined/3
	//- slower code:
	//-
	//- 				if ( t >= t1 || t1 === undefined ) {
						forward_scan: if ( ! ( t < t1 ) ) {

							for ( var giveUpAt = i1 + 2; ;) {

								if ( t1 === undefined ) {

									if ( t < t0 ) break forward_scan;

									// after end

									i1 = pp.length;
									this._cachedIndex = i1;
									return this.afterEnd_( i1 - 1, t, t0 );

								}

								if ( i1 === giveUpAt ) break; // this loop

								t0 = t1;
								t1 = pp[ ++ i1 ];

								if ( t < t1 ) {

									// we have arrived at the sought interval
									break seek;

								}

							}

							// prepare binary search on the right side of the index
							right = pp.length;
							break linear_scan;

						}

	//- slower code:
	//-					if ( t < t0 || t0 === undefined ) {
						if ( ! ( t >= t0 ) ) {

							// looping?

							var t1global = pp[ 1 ];

							if ( t < t1global ) {

								i1 = 2; // + 1, using the scan for the details
								t0 = t1global;

							}

							// linear reverse scan

							for ( var giveUpAt = i1 - 2; ;) {

								if ( t0 === undefined ) {

									// before start

									this._cachedIndex = 0;
									return this.beforeStart_( 0, t, t1 );

								}

								if ( i1 === giveUpAt ) break; // this loop

								t1 = t0;
								t0 = pp[ -- i1 - 1 ];

								if ( t >= t0 ) {

									// we have arrived at the sought interval
									break seek;

								}

							}

							// prepare binary search on the left side of the index
							right = i1;
							i1 = 0;
							break linear_scan;

						}

						// the interval is valid

						break validate_interval;

					} // linear scan

					// binary search

					while ( i1 < right ) {

						var mid = ( i1 + right ) >>> 1;

						if ( t < pp[ mid ] ) {

							right = mid;

						} else {

							i1 = mid + 1;

						}

					}

					t1 = pp[   i1   ];
					t0 = pp[ i1 - 1 ];

					// check boundary cases, again

					if ( t0 === undefined ) {

						this._cachedIndex = 0;
						return this.beforeStart_( 0, t, t1 );

					}

					if ( t1 === undefined ) {

						i1 = pp.length;
						this._cachedIndex = i1;
						return this.afterEnd_( i1 - 1, t0, t );

					}

				} // seek

				this._cachedIndex = i1;

				this.intervalChanged_( i1, t0, t1 );

			} // validate_interval

			return this.interpolate_( i1, t0, t, t1 );

		},

		settings: null, // optional, subclass-specific settings structure
		// Note: The indirection allows central control of many interpolants.

		// --- Protected interface

		DefaultSettings_: {},

		getSettings_: function() {

			return this.settings || this.DefaultSettings_;

		},

		copySampleValue_: function( index ) {

			// copies a sample value to the result buffer

			var result = this.resultBuffer,
				values = this.sampleValues,
				stride = this.valueSize,
				offset = index * stride;

			for ( var i = 0; i !== stride; ++ i ) {

				result[ i ] = values[ offset + i ];

			}

			return result;

		},

		// Template methods for derived classes:

		interpolate_: function( i1, t0, t, t1 ) {

			throw new Error( "call to abstract method" );
			// implementations shall return this.resultBuffer

		},

		intervalChanged_: function( i1, t0, t1 ) {

			// empty

		}

	};

	Object.assign( Interpolant.prototype, {

		beforeStart_: //( 0, t, t0 ), returns this.resultBuffer
			Interpolant.prototype.copySampleValue_,

		afterEnd_: //( N-1, tN-1, t ), returns this.resultBuffer
			Interpolant.prototype.copySampleValue_

	} );

	/**
	 * Fast and simple cubic spline interpolant.
	 *
	 * It was derived from a Hermitian construction setting the first derivative
	 * at each sample position to the linear slope between neighboring positions
	 * over their parameter interval.
	 *
	 * @author tschw
	 */

	function CubicInterpolant(
			parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		Interpolant.call(
				this, parameterPositions, sampleValues, sampleSize, resultBuffer );

		this._weightPrev = -0;
		this._offsetPrev = -0;
		this._weightNext = -0;
		this._offsetNext = -0;

	}

	CubicInterpolant.prototype =
			Object.assign( Object.create( Interpolant.prototype ), {

		constructor: CubicInterpolant,

		DefaultSettings_: {

			endingStart: 	ZeroCurvatureEnding,
			endingEnd:		ZeroCurvatureEnding

		},

		intervalChanged_: function( i1, t0, t1 ) {

			var pp = this.parameterPositions,
				iPrev = i1 - 2,
				iNext = i1 + 1,

				tPrev = pp[ iPrev ],
				tNext = pp[ iNext ];

			if ( tPrev === undefined ) {

				switch ( this.getSettings_().endingStart ) {

					case ZeroSlopeEnding:

						// f'(t0) = 0
						iPrev = i1;
						tPrev = 2 * t0 - t1;

						break;

					case WrapAroundEnding:

						// use the other end of the curve
						iPrev = pp.length - 2;
						tPrev = t0 + pp[ iPrev ] - pp[ iPrev + 1 ];

						break;

					default: // ZeroCurvatureEnding

						// f''(t0) = 0 a.k.a. Natural Spline
						iPrev = i1;
						tPrev = t1;

				}

			}

			if ( tNext === undefined ) {

				switch ( this.getSettings_().endingEnd ) {

					case ZeroSlopeEnding:

						// f'(tN) = 0
						iNext = i1;
						tNext = 2 * t1 - t0;

						break;

					case WrapAroundEnding:

						// use the other end of the curve
						iNext = 1;
						tNext = t1 + pp[ 1 ] - pp[ 0 ];

						break;

					default: // ZeroCurvatureEnding

						// f''(tN) = 0, a.k.a. Natural Spline
						iNext = i1 - 1;
						tNext = t0;

				}

			}

			var halfDt = ( t1 - t0 ) * 0.5,
				stride = this.valueSize;

			this._weightPrev = halfDt / ( t0 - tPrev );
			this._weightNext = halfDt / ( tNext - t1 );
			this._offsetPrev = iPrev * stride;
			this._offsetNext = iNext * stride;

		},

		interpolate_: function( i1, t0, t, t1 ) {

			var result = this.resultBuffer,
				values = this.sampleValues,
				stride = this.valueSize,

				o1 = i1 * stride,		o0 = o1 - stride,
				oP = this._offsetPrev, 	oN = this._offsetNext,
				wP = this._weightPrev,	wN = this._weightNext,

				p = ( t - t0 ) / ( t1 - t0 ),
				pp = p * p,
				ppp = pp * p;

			// evaluate polynomials

			var sP =     - wP   * ppp   +         2 * wP    * pp    -          wP   * p;
			var s0 = ( 1 + wP ) * ppp   + (-1.5 - 2 * wP )  * pp    + ( -0.5 + wP ) * p     + 1;
			var s1 = (-1 - wN ) * ppp   + ( 1.5 +   wN   )  * pp    +    0.5        * p;
			var sN =       wN   * ppp   -           wN      * pp;

			// combine data linearly

			for ( var i = 0; i !== stride; ++ i ) {

				result[ i ] =
						sP * values[ oP + i ] +
						s0 * values[ o0 + i ] +
						s1 * values[ o1 + i ] +
						sN * values[ oN + i ];

			}

			return result;

		}

	} );

	/**
	 * @author tschw
	 */

	function LinearInterpolant(
			parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		Interpolant.call(
				this, parameterPositions, sampleValues, sampleSize, resultBuffer );

	}

	LinearInterpolant.prototype =
			Object.assign( Object.create( Interpolant.prototype ), {

		constructor: LinearInterpolant,

		interpolate_: function( i1, t0, t, t1 ) {

			var result = this.resultBuffer,
				values = this.sampleValues,
				stride = this.valueSize,

				offset1 = i1 * stride,
				offset0 = offset1 - stride,

				weight1 = ( t - t0 ) / ( t1 - t0 ),
				weight0 = 1 - weight1;

			for ( var i = 0; i !== stride; ++ i ) {

				result[ i ] =
						values[ offset0 + i ] * weight0 +
						values[ offset1 + i ] * weight1;

			}

			return result;

		}

	} );

	/**
	 *
	 * Interpolant that evaluates to the sample value at the position preceeding
	 * the parameter.
	 *
	 * @author tschw
	 */

	function DiscreteInterpolant(
			parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		Interpolant.call(
				this, parameterPositions, sampleValues, sampleSize, resultBuffer );

	}

	DiscreteInterpolant.prototype =
			Object.assign( Object.create( Interpolant.prototype ), {

		constructor: DiscreteInterpolant,

		interpolate_: function( i1, t0, t, t1 ) {

			return this.copySampleValue_( i1 - 1 );

		}

	} );

	var KeyframeTrackPrototype;

	KeyframeTrackPrototype = {

		TimeBufferType: Float32Array,
		ValueBufferType: Float32Array,

		DefaultInterpolation: InterpolateLinear,

		InterpolantFactoryMethodDiscrete: function ( result ) {

			return new DiscreteInterpolant(
					this.times, this.values, this.getValueSize(), result );

		},

		InterpolantFactoryMethodLinear: function ( result ) {

			return new LinearInterpolant(
					this.times, this.values, this.getValueSize(), result );

		},

		InterpolantFactoryMethodSmooth: function ( result ) {

			return new CubicInterpolant(
					this.times, this.values, this.getValueSize(), result );

		},

		setInterpolation: function ( interpolation ) {

			var factoryMethod;

			switch ( interpolation ) {

				case InterpolateDiscrete:

					factoryMethod = this.InterpolantFactoryMethodDiscrete;

					break;

				case InterpolateLinear:

					factoryMethod = this.InterpolantFactoryMethodLinear;

					break;

				case InterpolateSmooth:

					factoryMethod = this.InterpolantFactoryMethodSmooth;

					break;

			}

			if ( factoryMethod === undefined ) {

				var message = "unsupported interpolation for " +
						this.ValueTypeName + " keyframe track named " + this.name;

				if ( this.createInterpolant === undefined ) {

					// fall back to default, unless the default itself is messed up
					if ( interpolation !== this.DefaultInterpolation ) {

						this.setInterpolation( this.DefaultInterpolation );

					} else {

						throw new Error( message ); // fatal, in this case

					}

				}

				console.warn( message );
				return;

			}

			this.createInterpolant = factoryMethod;

		},

		getInterpolation: function () {

			switch ( this.createInterpolant ) {

				case this.InterpolantFactoryMethodDiscrete:

					return InterpolateDiscrete;

				case this.InterpolantFactoryMethodLinear:

					return InterpolateLinear;

				case this.InterpolantFactoryMethodSmooth:

					return InterpolateSmooth;

			}

		},

		getValueSize: function () {

			return this.values.length / this.times.length;

		},

		// move all keyframes either forwards or backwards in time
		shift: function ( timeOffset ) {

			if ( timeOffset !== 0.0 ) {

				var times = this.times;

				for ( var i = 0, n = times.length; i !== n; ++ i ) {

					times[ i ] += timeOffset;

				}

			}

			return this;

		},

		// scale all keyframe times by a factor (useful for frame <-> seconds conversions)
		scale: function ( timeScale ) {

			if ( timeScale !== 1.0 ) {

				var times = this.times;

				for ( var i = 0, n = times.length; i !== n; ++ i ) {

					times[ i ] *= timeScale;

				}

			}

			return this;

		},

		// removes keyframes before and after animation without changing any values within the range [startTime, endTime].
		// IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
		trim: function ( startTime, endTime ) {

			var times = this.times,
				nKeys = times.length,
				from = 0,
				to = nKeys - 1;

			while ( from !== nKeys && times[ from ] < startTime ) ++ from;
			while ( to !== - 1 && times[ to ] > endTime ) -- to;

			++ to; // inclusive -> exclusive bound

			if ( from !== 0 || to !== nKeys ) {

				// empty tracks are forbidden, so keep at least one keyframe
				if ( from >= to ) to = Math.max( to, 1 ), from = to - 1;

				var stride = this.getValueSize();
				this.times = AnimationUtils.arraySlice( times, from, to );
				this.values = AnimationUtils.
						arraySlice( this.values, from * stride, to * stride );

			}

			return this;

		},

		// ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
		validate: function () {

			var valid = true;

			var valueSize = this.getValueSize();
			if ( valueSize - Math.floor( valueSize ) !== 0 ) {

				console.error( "invalid value size in track", this );
				valid = false;

			}

			var times = this.times,
				values = this.values,

				nKeys = times.length;

			if ( nKeys === 0 ) {

				console.error( "track is empty", this );
				valid = false;

			}

			var prevTime = null;

			for ( var i = 0; i !== nKeys; i ++ ) {

				var currTime = times[ i ];

				if ( typeof currTime === 'number' && isNaN( currTime ) ) {

					console.error( "time is not a valid number", this, i, currTime );
					valid = false;
					break;

				}

				if ( prevTime !== null && prevTime > currTime ) {

					console.error( "out of order keys", this, i, currTime, prevTime );
					valid = false;
					break;

				}

				prevTime = currTime;

			}

			if ( values !== undefined ) {

				if ( AnimationUtils.isTypedArray( values ) ) {

					for ( var i = 0, n = values.length; i !== n; ++ i ) {

						var value = values[ i ];

						if ( isNaN( value ) ) {

							console.error( "value is not a valid number", this, i, value );
							valid = false;
							break;

						}

					}

				}

			}

			return valid;

		},

		// removes equivalent sequential keys as common in morph target sequences
		// (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
		optimize: function () {

			var times = this.times,
				values = this.values,
				stride = this.getValueSize(),

				smoothInterpolation = this.getInterpolation() === InterpolateSmooth,

				writeIndex = 1,
				lastIndex = times.length - 1;

			for ( var i = 1; i < lastIndex; ++ i ) {

				var keep = false;

				var time = times[ i ];
				var timeNext = times[ i + 1 ];

				// remove adjacent keyframes scheduled at the same time

				if ( time !== timeNext && ( i !== 1 || time !== time[ 0 ] ) ) {

					if ( ! smoothInterpolation ) {

						// remove unnecessary keyframes same as their neighbors

						var offset = i * stride,
							offsetP = offset - stride,
							offsetN = offset + stride;

						for ( var j = 0; j !== stride; ++ j ) {

							var value = values[ offset + j ];

							if ( value !== values[ offsetP + j ] ||
									value !== values[ offsetN + j ] ) {

								keep = true;
								break;

							}

						}

					} else keep = true;

				}

				// in-place compaction

				if ( keep ) {

					if ( i !== writeIndex ) {

						times[ writeIndex ] = times[ i ];

						var readOffset = i * stride,
							writeOffset = writeIndex * stride;

						for ( var j = 0; j !== stride; ++ j )

							values[ writeOffset + j ] = values[ readOffset + j ];

					}

					++ writeIndex;

				}

			}

			// flush last keyframe (compaction looks ahead)

			if ( lastIndex > 0 ) {

				times[ writeIndex ] = times[ lastIndex ];

				for ( var readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++ j )

					values[ writeOffset + j ] = values[ readOffset + j ];

				++ writeIndex;

			}

			if ( writeIndex !== times.length ) {

				this.times = AnimationUtils.arraySlice( times, 0, writeIndex );
				this.values = AnimationUtils.arraySlice( values, 0, writeIndex * stride );

			}

			return this;

		}

	};

	function KeyframeTrackConstructor( name, times, values, interpolation ) {

		if( name === undefined ) throw new Error( "track name is undefined" );

		if( times === undefined || times.length === 0 ) {

			throw new Error( "no keyframes in track named " + name );

		}

		this.name = name;

		this.times = AnimationUtils.convertArray( times, this.TimeBufferType );
		this.values = AnimationUtils.convertArray( values, this.ValueBufferType );

		this.setInterpolation( interpolation || this.DefaultInterpolation );

		this.validate();
		this.optimize();

	}

	/**
	 *
	 * A Track of vectored keyframe values.
	 *
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 */

	function VectorKeyframeTrack( name, times, values, interpolation ) {

		KeyframeTrackConstructor.call( this, name, times, values, interpolation );

	}

	VectorKeyframeTrack.prototype =
			Object.assign( Object.create( KeyframeTrackPrototype ), {

		constructor: VectorKeyframeTrack,

		ValueTypeName: 'vector'

		// ValueBufferType is inherited

		// DefaultInterpolation is inherited

	} );

	/**
	 * Spherical linear unit quaternion interpolant.
	 *
	 * @author tschw
	 */

	function QuaternionLinearInterpolant(
			parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		Interpolant.call(
				this, parameterPositions, sampleValues, sampleSize, resultBuffer );

	}

	QuaternionLinearInterpolant.prototype =
			Object.assign( Object.create( Interpolant.prototype ), {

		constructor: QuaternionLinearInterpolant,

		interpolate_: function( i1, t0, t, t1 ) {

			var result = this.resultBuffer,
				values = this.sampleValues,
				stride = this.valueSize,

				offset = i1 * stride,

				alpha = ( t - t0 ) / ( t1 - t0 );

			for ( var end = offset + stride; offset !== end; offset += 4 ) {

				Quaternion.slerpFlat( result, 0,
						values, offset - stride, values, offset, alpha );

			}

			return result;

		}

	} );

	/**
	 *
	 * A Track of quaternion keyframe values.
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 */

	function QuaternionKeyframeTrack( name, times, values, interpolation ) {

		KeyframeTrackConstructor.call( this, name, times, values, interpolation );

	}

	QuaternionKeyframeTrack.prototype =
			Object.assign( Object.create( KeyframeTrackPrototype ), {

		constructor: QuaternionKeyframeTrack,

		ValueTypeName: 'quaternion',

		// ValueBufferType is inherited

		DefaultInterpolation: InterpolateLinear,

		InterpolantFactoryMethodLinear: function( result ) {

			return new QuaternionLinearInterpolant(
					this.times, this.values, this.getValueSize(), result );

		},

		InterpolantFactoryMethodSmooth: undefined // not yet implemented

	} );

	/**
	 *
	 * A Track of numeric keyframe values.
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 */

	function NumberKeyframeTrack( name, times, values, interpolation ) {

		KeyframeTrackConstructor.call( this, name, times, values, interpolation );

	}

	NumberKeyframeTrack.prototype =
			Object.assign( Object.create( KeyframeTrackPrototype ), {

		constructor: NumberKeyframeTrack,

		ValueTypeName: 'number'

		// ValueBufferType is inherited

		// DefaultInterpolation is inherited

	} );

	/**
	 *
	 * A Track that interpolates Strings
	 *
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 */

	function StringKeyframeTrack( name, times, values, interpolation ) {

		KeyframeTrackConstructor.call( this, name, times, values, interpolation );

	}

	StringKeyframeTrack.prototype =
			Object.assign( Object.create( KeyframeTrackPrototype ), {

		constructor: StringKeyframeTrack,

		ValueTypeName: 'string',
		ValueBufferType: Array,

		DefaultInterpolation: InterpolateDiscrete,

		InterpolantFactoryMethodLinear: undefined,

		InterpolantFactoryMethodSmooth: undefined

	} );

	/**
	 *
	 * A Track of Boolean keyframe values.
	 *
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 */

	function BooleanKeyframeTrack( name, times, values ) {

		KeyframeTrackConstructor.call( this, name, times, values );

	}

	BooleanKeyframeTrack.prototype =
			Object.assign( Object.create( KeyframeTrackPrototype ), {

		constructor: BooleanKeyframeTrack,

		ValueTypeName: 'bool',
		ValueBufferType: Array,

		DefaultInterpolation: InterpolateDiscrete,

		InterpolantFactoryMethodLinear: undefined,
		InterpolantFactoryMethodSmooth: undefined

		// Note: Actually this track could have a optimized / compressed
		// representation of a single value and a custom interpolant that
		// computes "firstValue ^ isOdd( index )".

	} );

	/**
	 *
	 * A Track of keyframe values that represent color.
	 *
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 */

	function ColorKeyframeTrack( name, times, values, interpolation ) {

		KeyframeTrackConstructor.call( this, name, times, values, interpolation );

	}

	ColorKeyframeTrack.prototype =
			Object.assign( Object.create( KeyframeTrackPrototype ), {

		constructor: ColorKeyframeTrack,

		ValueTypeName: 'color'

		// ValueBufferType is inherited

		// DefaultInterpolation is inherited


		// Note: Very basic implementation and nothing special yet.
		// However, this is the place for color space parameterization.

	} );

	/**
	 *
	 * A timed sequence of keyframes for a specific property.
	 *
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 */

	function KeyframeTrack( name, times, values, interpolation ) {

		KeyframeTrackConstructor.apply( this, arguments );

	}

	KeyframeTrack.prototype = KeyframeTrackPrototype;
	KeyframeTrackPrototype.constructor = KeyframeTrack;

	// Static methods:

	Object.assign( KeyframeTrack, {

		// Serialization (in static context, because of constructor invocation
		// and automatic invocation of .toJSON):

		parse: function( json ) {

			if( json.type === undefined ) {

				throw new Error( "track type undefined, can not parse" );

			}

			var trackType = KeyframeTrack._getTrackTypeForValueTypeName( json.type );

			if ( json.times === undefined ) {

				var times = [], values = [];

				AnimationUtils.flattenJSON( json.keys, times, values, 'value' );

				json.times = times;
				json.values = values;

			}

			// derived classes can define a static parse method
			if ( trackType.parse !== undefined ) {

				return trackType.parse( json );

			} else {

				// by default, we asssume a constructor compatible with the base
				return new trackType(
						json.name, json.times, json.values, json.interpolation );

			}

		},

		toJSON: function( track ) {

			var trackType = track.constructor;

			var json;

			// derived classes can define a static toJSON method
			if ( trackType.toJSON !== undefined ) {

				json = trackType.toJSON( track );

			} else {

				// by default, we assume the data can be serialized as-is
				json = {

					'name': track.name,
					'times': AnimationUtils.convertArray( track.times, Array ),
					'values': AnimationUtils.convertArray( track.values, Array )

				};

				var interpolation = track.getInterpolation();

				if ( interpolation !== track.DefaultInterpolation ) {

					json.interpolation = interpolation;

				}

			}

			json.type = track.ValueTypeName; // mandatory

			return json;

		},

		_getTrackTypeForValueTypeName: function( typeName ) {

			switch( typeName.toLowerCase() ) {

				case "scalar":
				case "double":
				case "float":
				case "number":
				case "integer":

					return NumberKeyframeTrack;

				case "vector":
				case "vector2":
				case "vector3":
				case "vector4":

					return VectorKeyframeTrack;

				case "color":

					return ColorKeyframeTrack;

				case "quaternion":

					return QuaternionKeyframeTrack;

				case "bool":
				case "boolean":

					return BooleanKeyframeTrack;

				case "string":

					return StringKeyframeTrack;

			}

			throw new Error( "Unsupported typeName: " + typeName );

		}

	} );

	/**
	 *
	 * Reusable set of Tracks that represent an animation.
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 */

	function AnimationClip( name, duration, tracks ) {

		this.name = name;
		this.tracks = tracks;
		this.duration = ( duration !== undefined ) ? duration : -1;

		this.uuid = _Math.generateUUID();

		// this means it should figure out its duration by scanning the tracks
		if ( this.duration < 0 ) {

			this.resetDuration();

		}

		this.optimize();

	}

	AnimationClip.prototype = {

		constructor: AnimationClip,

		resetDuration: function() {

			var tracks = this.tracks,
				duration = 0;

			for ( var i = 0, n = tracks.length; i !== n; ++ i ) {

				var track = this.tracks[ i ];

				duration = Math.max( duration, track.times[ track.times.length - 1 ] );

			}

			this.duration = duration;

		},

		trim: function() {

			for ( var i = 0; i < this.tracks.length; i ++ ) {

				this.tracks[ i ].trim( 0, this.duration );

			}

			return this;

		},

		optimize: function() {

			for ( var i = 0; i < this.tracks.length; i ++ ) {

				this.tracks[ i ].optimize();

			}

			return this;

		}

	};

	// Static methods:

	Object.assign( AnimationClip, {

		parse: function( json ) {

			var tracks = [],
				jsonTracks = json.tracks,
				frameTime = 1.0 / ( json.fps || 1.0 );

			for ( var i = 0, n = jsonTracks.length; i !== n; ++ i ) {

				tracks.push( KeyframeTrack.parse( jsonTracks[ i ] ).scale( frameTime ) );

			}

			return new AnimationClip( json.name, json.duration, tracks );

		},


		toJSON: function( clip ) {

			var tracks = [],
				clipTracks = clip.tracks;

			var json = {

				'name': clip.name,
				'duration': clip.duration,
				'tracks': tracks

			};

			for ( var i = 0, n = clipTracks.length; i !== n; ++ i ) {

				tracks.push( KeyframeTrack.toJSON( clipTracks[ i ] ) );

			}

			return json;

		},


		CreateFromMorphTargetSequence: function( name, morphTargetSequence, fps, noLoop ) {

			var numMorphTargets = morphTargetSequence.length;
			var tracks = [];

			for ( var i = 0; i < numMorphTargets; i ++ ) {

				var times = [];
				var values = [];

				times.push(
						( i + numMorphTargets - 1 ) % numMorphTargets,
						i,
						( i + 1 ) % numMorphTargets );

				values.push( 0, 1, 0 );

				var order = AnimationUtils.getKeyframeOrder( times );
				times = AnimationUtils.sortedArray( times, 1, order );
				values = AnimationUtils.sortedArray( values, 1, order );

				// if there is a key at the first frame, duplicate it as the
				// last frame as well for perfect loop.
				if ( ! noLoop && times[ 0 ] === 0 ) {

					times.push( numMorphTargets );
					values.push( values[ 0 ] );

				}

				tracks.push(
						new NumberKeyframeTrack(
							'.morphTargetInfluences[' + morphTargetSequence[ i ].name + ']',
							times, values
						).scale( 1.0 / fps ) );
			}

			return new AnimationClip( name, -1, tracks );

		},

		findByName: function( objectOrClipArray, name ) {

			var clipArray = objectOrClipArray;

			if ( ! Array.isArray( objectOrClipArray ) ) {

				var o = objectOrClipArray;
				clipArray = o.geometry && o.geometry.animations || o.animations;

			}

			for ( var i = 0; i < clipArray.length; i ++ ) {

				if ( clipArray[ i ].name === name ) {

					return clipArray[ i ];

				}
			}

			return null;

		},

		CreateClipsFromMorphTargetSequences: function( morphTargets, fps, noLoop ) {

			var animationToMorphTargets = {};

			// tested with https://regex101.com/ on trick sequences
			// such flamingo_flyA_003, flamingo_run1_003, crdeath0059
			var pattern = /^([\w-]*?)([\d]+)$/;

			// sort morph target names into animation groups based
			// patterns like Walk_001, Walk_002, Run_001, Run_002
			for ( var i = 0, il = morphTargets.length; i < il; i ++ ) {

				var morphTarget = morphTargets[ i ];
				var parts = morphTarget.name.match( pattern );

				if ( parts && parts.length > 1 ) {

					var name = parts[ 1 ];

					var animationMorphTargets = animationToMorphTargets[ name ];
					if ( ! animationMorphTargets ) {

						animationToMorphTargets[ name ] = animationMorphTargets = [];

					}

					animationMorphTargets.push( morphTarget );

				}

			}

			var clips = [];

			for ( var name in animationToMorphTargets ) {

				clips.push( AnimationClip.CreateFromMorphTargetSequence( name, animationToMorphTargets[ name ], fps, noLoop ) );

			}

			return clips;

		},

		// parse the animation.hierarchy format
		parseAnimation: function( animation, bones ) {

			if ( ! animation ) {

				console.error( "  no animation in JSONLoader data" );
				return null;

			}

			var addNonemptyTrack = function(
					trackType, trackName, animationKeys, propertyName, destTracks ) {

				// only return track if there are actually keys.
				if ( animationKeys.length !== 0 ) {

					var times = [];
					var values = [];

					AnimationUtils.flattenJSON(
							animationKeys, times, values, propertyName );

					// empty keys are filtered out, so check again
					if ( times.length !== 0 ) {

						destTracks.push( new trackType( trackName, times, values ) );

					}

				}

			};

			var tracks = [];

			var clipName = animation.name || 'default';
			// automatic length determination in AnimationClip.
			var duration = animation.length || -1;
			var fps = animation.fps || 30;

			var hierarchyTracks = animation.hierarchy || [];

			for ( var h = 0; h < hierarchyTracks.length; h ++ ) {

				var animationKeys = hierarchyTracks[ h ].keys;

				// skip empty tracks
				if ( ! animationKeys || animationKeys.length === 0 ) continue;

				// process morph targets in a way exactly compatible
				// with AnimationHandler.init( animation )
				if ( animationKeys[0].morphTargets ) {

					// figure out all morph targets used in this track
					var morphTargetNames = {};
					for ( var k = 0; k < animationKeys.length; k ++ ) {

						if ( animationKeys[k].morphTargets ) {

							for ( var m = 0; m < animationKeys[k].morphTargets.length; m ++ ) {

								morphTargetNames[ animationKeys[k].morphTargets[m] ] = -1;
							}

						}

					}

					// create a track for each morph target with all zero
					// morphTargetInfluences except for the keys in which
					// the morphTarget is named.
					for ( var morphTargetName in morphTargetNames ) {

						var times = [];
						var values = [];

						for ( var m = 0; m !== animationKeys[k].morphTargets.length; ++ m ) {

							var animationKey = animationKeys[k];

							times.push( animationKey.time );
							values.push( ( animationKey.morphTarget === morphTargetName ) ? 1 : 0 );

						}

						tracks.push( new NumberKeyframeTrack('.morphTargetInfluence[' + morphTargetName + ']', times, values ) );

					}

					duration = morphTargetNames.length * ( fps || 1.0 );

				} else {
					// ...assume skeletal animation

					var boneName = '.bones[' + bones[ h ].name + ']';

					addNonemptyTrack(
							VectorKeyframeTrack, boneName + '.position',
							animationKeys, 'pos', tracks );

					addNonemptyTrack(
							QuaternionKeyframeTrack, boneName + '.quaternion',
							animationKeys, 'rot', tracks );

					addNonemptyTrack(
							VectorKeyframeTrack, boneName + '.scale',
							animationKeys, 'scl', tracks );

				}

			}

			if ( tracks.length === 0 ) {

				return null;

			}

			var clip = new AnimationClip( clipName, duration, tracks );

			return clip;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function MaterialLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
		this.textures = {};

	}

	Object.assign( MaterialLoader.prototype, {

		load: function ( url, onLoad, onProgress, onError ) {

			var scope = this;

			var loader = new FileLoader( scope.manager );
			loader.load( url, function ( text ) {

				onLoad( scope.parse( JSON.parse( text ) ) );

			}, onProgress, onError );

		},

		setTextures: function ( value ) {

			this.textures = value;

		},

		parse: function ( json ) {

			var textures = this.textures;

			function getTexture( name ) {

				if ( textures[ name ] === undefined ) {

					console.warn( 'THREE.MaterialLoader: Undefined texture', name );

				}

				return textures[ name ];

			}

			var material = new Materials[ json.type ]();

			if ( json.uuid !== undefined ) material.uuid = json.uuid;
			if ( json.name !== undefined ) material.name = json.name;
			if ( json.color !== undefined ) material.color.setHex( json.color );
			if ( json.roughness !== undefined ) material.roughness = json.roughness;
			if ( json.metalness !== undefined ) material.metalness = json.metalness;
			if ( json.emissive !== undefined ) material.emissive.setHex( json.emissive );
			if ( json.specular !== undefined ) material.specular.setHex( json.specular );
			if ( json.shininess !== undefined ) material.shininess = json.shininess;
			if ( json.clearCoat !== undefined ) material.clearCoat = json.clearCoat;
			if ( json.clearCoatRoughness !== undefined ) material.clearCoatRoughness = json.clearCoatRoughness;
			if ( json.uniforms !== undefined ) material.uniforms = json.uniforms;
			if ( json.vertexShader !== undefined ) material.vertexShader = json.vertexShader;
			if ( json.fragmentShader !== undefined ) material.fragmentShader = json.fragmentShader;
			if ( json.vertexColors !== undefined ) material.vertexColors = json.vertexColors;
			if ( json.fog !== undefined ) material.fog = json.fog;
			if ( json.shading !== undefined ) material.shading = json.shading;
			if ( json.blending !== undefined ) material.blending = json.blending;
			if ( json.side !== undefined ) material.side = json.side;
			if ( json.opacity !== undefined ) material.opacity = json.opacity;
			if ( json.transparent !== undefined ) material.transparent = json.transparent;
			if ( json.alphaTest !== undefined ) material.alphaTest = json.alphaTest;
			if ( json.depthTest !== undefined ) material.depthTest = json.depthTest;
			if ( json.depthWrite !== undefined ) material.depthWrite = json.depthWrite;
			if ( json.colorWrite !== undefined ) material.colorWrite = json.colorWrite;
			if ( json.wireframe !== undefined ) material.wireframe = json.wireframe;
			if ( json.wireframeLinewidth !== undefined ) material.wireframeLinewidth = json.wireframeLinewidth;
			if ( json.wireframeLinecap !== undefined ) material.wireframeLinecap = json.wireframeLinecap;
			if ( json.wireframeLinejoin !== undefined ) material.wireframeLinejoin = json.wireframeLinejoin;
			if ( json.skinning !== undefined ) material.skinning = json.skinning;
			if ( json.morphTargets !== undefined ) material.morphTargets = json.morphTargets;

			// for PointsMaterial

			if ( json.size !== undefined ) material.size = json.size;
			if ( json.sizeAttenuation !== undefined ) material.sizeAttenuation = json.sizeAttenuation;

			// maps

			if ( json.map !== undefined ) material.map = getTexture( json.map );

			if ( json.alphaMap !== undefined ) {

				material.alphaMap = getTexture( json.alphaMap );
				material.transparent = true;

			}

			if ( json.bumpMap !== undefined ) material.bumpMap = getTexture( json.bumpMap );
			if ( json.bumpScale !== undefined ) material.bumpScale = json.bumpScale;

			if ( json.normalMap !== undefined ) material.normalMap = getTexture( json.normalMap );
			if ( json.normalScale !== undefined ) {

				var normalScale = json.normalScale;

				if ( Array.isArray( normalScale ) === false ) {

					// Blender exporter used to export a scalar. See #7459

					normalScale = [ normalScale, normalScale ];

				}

				material.normalScale = new Vector2().fromArray( normalScale );

			}

			if ( json.displacementMap !== undefined ) material.displacementMap = getTexture( json.displacementMap );
			if ( json.displacementScale !== undefined ) material.displacementScale = json.displacementScale;
			if ( json.displacementBias !== undefined ) material.displacementBias = json.displacementBias;

			if ( json.roughnessMap !== undefined ) material.roughnessMap = getTexture( json.roughnessMap );
			if ( json.metalnessMap !== undefined ) material.metalnessMap = getTexture( json.metalnessMap );

			if ( json.emissiveMap !== undefined ) material.emissiveMap = getTexture( json.emissiveMap );
			if ( json.emissiveIntensity !== undefined ) material.emissiveIntensity = json.emissiveIntensity;

			if ( json.specularMap !== undefined ) material.specularMap = getTexture( json.specularMap );

			if ( json.envMap !== undefined ) material.envMap = getTexture( json.envMap );

			if ( json.reflectivity !== undefined ) material.reflectivity = json.reflectivity;

			if ( json.lightMap !== undefined ) material.lightMap = getTexture( json.lightMap );
			if ( json.lightMapIntensity !== undefined ) material.lightMapIntensity = json.lightMapIntensity;

			if ( json.aoMap !== undefined ) material.aoMap = getTexture( json.aoMap );
			if ( json.aoMapIntensity !== undefined ) material.aoMapIntensity = json.aoMapIntensity;

			if ( json.gradientMap !== undefined ) material.gradientMap = getTexture( json.gradientMap );

			// MultiMaterial

			if ( json.materials !== undefined ) {

				for ( var i = 0, l = json.materials.length; i < l; i ++ ) {

					material.materials.push( this.parse( json.materials[ i ] ) );

				}

			}

			return material;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function BufferGeometryLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

	}

	Object.assign( BufferGeometryLoader.prototype, {

		load: function ( url, onLoad, onProgress, onError ) {

			var scope = this;

			var loader = new FileLoader( scope.manager );
			loader.load( url, function ( text ) {

				onLoad( scope.parse( JSON.parse( text ) ) );

			}, onProgress, onError );

		},

		parse: function ( json ) {

			var geometry = new BufferGeometry();

			var index = json.data.index;

			var TYPED_ARRAYS = {
				'Int8Array': Int8Array,
				'Uint8Array': Uint8Array,
				'Uint8ClampedArray': Uint8ClampedArray,
				'Int16Array': Int16Array,
				'Uint16Array': Uint16Array,
				'Int32Array': Int32Array,
				'Uint32Array': Uint32Array,
				'Float32Array': Float32Array,
				'Float64Array': Float64Array
			};

			if ( index !== undefined ) {

				var typedArray = new TYPED_ARRAYS[ index.type ]( index.array );
				geometry.setIndex( new BufferAttribute( typedArray, 1 ) );

			}

			var attributes = json.data.attributes;

			for ( var key in attributes ) {

				var attribute = attributes[ key ];
				var typedArray = new TYPED_ARRAYS[ attribute.type ]( attribute.array );

				geometry.addAttribute( key, new BufferAttribute( typedArray, attribute.itemSize, attribute.normalized ) );

			}

			var groups = json.data.groups || json.data.drawcalls || json.data.offsets;

			if ( groups !== undefined ) {

				for ( var i = 0, n = groups.length; i !== n; ++ i ) {

					var group = groups[ i ];

					geometry.addGroup( group.start, group.count, group.materialIndex );

				}

			}

			var boundingSphere = json.data.boundingSphere;

			if ( boundingSphere !== undefined ) {

				var center = new Vector3();

				if ( boundingSphere.center !== undefined ) {

					center.fromArray( boundingSphere.center );

				}

				geometry.boundingSphere = new Sphere( center, boundingSphere.radius );

			}

			return geometry;

		}

	} );

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	function Loader() {

		this.onLoadStart = function () {};
		this.onLoadProgress = function () {};
		this.onLoadComplete = function () {};

	}

	Loader.prototype = {

		constructor: Loader,

		crossOrigin: undefined,

		extractUrlBase: function ( url ) {

			var parts = url.split( '/' );

			if ( parts.length === 1 ) return './';

			parts.pop();

			return parts.join( '/' ) + '/';

		},

		initMaterials: function ( materials, texturePath, crossOrigin ) {

			var array = [];

			for ( var i = 0; i < materials.length; ++ i ) {

				array[ i ] = this.createMaterial( materials[ i ], texturePath, crossOrigin );

			}

			return array;

		},

		createMaterial: ( function () {

			var color, textureLoader, materialLoader;

			return function createMaterial( m, texturePath, crossOrigin ) {

				if ( color === undefined ) color = new Color();
				if ( textureLoader === undefined ) textureLoader = new TextureLoader();
				if ( materialLoader === undefined ) materialLoader = new MaterialLoader();

				// convert from old material format

				var textures = {};

				function loadTexture( path, repeat, offset, wrap, anisotropy ) {

					var fullPath = texturePath + path;
					var loader = Loader.Handlers.get( fullPath );

					var texture;

					if ( loader !== null ) {

						texture = loader.load( fullPath );

					} else {

						textureLoader.setCrossOrigin( crossOrigin );
						texture = textureLoader.load( fullPath );

					}

					if ( repeat !== undefined ) {

						texture.repeat.fromArray( repeat );

						if ( repeat[ 0 ] !== 1 ) texture.wrapS = RepeatWrapping;
						if ( repeat[ 1 ] !== 1 ) texture.wrapT = RepeatWrapping;

					}

					if ( offset !== undefined ) {

						texture.offset.fromArray( offset );

					}

					if ( wrap !== undefined ) {

						if ( wrap[ 0 ] === 'repeat' ) texture.wrapS = RepeatWrapping;
						if ( wrap[ 0 ] === 'mirror' ) texture.wrapS = MirroredRepeatWrapping;

						if ( wrap[ 1 ] === 'repeat' ) texture.wrapT = RepeatWrapping;
						if ( wrap[ 1 ] === 'mirror' ) texture.wrapT = MirroredRepeatWrapping;

					}

					if ( anisotropy !== undefined ) {

						texture.anisotropy = anisotropy;

					}

					var uuid = _Math.generateUUID();

					textures[ uuid ] = texture;

					return uuid;

				}

				//

				var json = {
					uuid: _Math.generateUUID(),
					type: 'MeshLambertMaterial'
				};

				for ( var name in m ) {

					var value = m[ name ];

					switch ( name ) {
						case 'DbgColor':
						case 'DbgIndex':
						case 'opticalDensity':
						case 'illumination':
							break;
						case 'DbgName':
							json.name = value;
							break;
						case 'blending':
							json.blending = BlendingMode[ value ];
							break;
						case 'colorAmbient':
						case 'mapAmbient':
							console.warn( 'THREE.Loader.createMaterial:', name, 'is no longer supported.' );
							break;
						case 'colorDiffuse':
							json.color = color.fromArray( value ).getHex();
							break;
						case 'colorSpecular':
							json.specular = color.fromArray( value ).getHex();
							break;
						case 'colorEmissive':
							json.emissive = color.fromArray( value ).getHex();
							break;
						case 'specularCoef':
							json.shininess = value;
							break;
						case 'shading':
							if ( value.toLowerCase() === 'basic' ) json.type = 'MeshBasicMaterial';
							if ( value.toLowerCase() === 'phong' ) json.type = 'MeshPhongMaterial';
							if ( value.toLowerCase() === 'standard' ) json.type = 'MeshStandardMaterial';
							break;
						case 'mapDiffuse':
							json.map = loadTexture( value, m.mapDiffuseRepeat, m.mapDiffuseOffset, m.mapDiffuseWrap, m.mapDiffuseAnisotropy );
							break;
						case 'mapDiffuseRepeat':
						case 'mapDiffuseOffset':
						case 'mapDiffuseWrap':
						case 'mapDiffuseAnisotropy':
							break;
						case 'mapEmissive':
							json.emissiveMap = loadTexture( value, m.mapEmissiveRepeat, m.mapEmissiveOffset, m.mapEmissiveWrap, m.mapEmissiveAnisotropy );
							break;
						case 'mapEmissiveRepeat':
						case 'mapEmissiveOffset':
						case 'mapEmissiveWrap':
						case 'mapEmissiveAnisotropy':
							break;
						case 'mapLight':
							json.lightMap = loadTexture( value, m.mapLightRepeat, m.mapLightOffset, m.mapLightWrap, m.mapLightAnisotropy );
							break;
						case 'mapLightRepeat':
						case 'mapLightOffset':
						case 'mapLightWrap':
						case 'mapLightAnisotropy':
							break;
						case 'mapAO':
							json.aoMap = loadTexture( value, m.mapAORepeat, m.mapAOOffset, m.mapAOWrap, m.mapAOAnisotropy );
							break;
						case 'mapAORepeat':
						case 'mapAOOffset':
						case 'mapAOWrap':
						case 'mapAOAnisotropy':
							break;
						case 'mapBump':
							json.bumpMap = loadTexture( value, m.mapBumpRepeat, m.mapBumpOffset, m.mapBumpWrap, m.mapBumpAnisotropy );
							break;
						case 'mapBumpScale':
							json.bumpScale = value;
							break;
						case 'mapBumpRepeat':
						case 'mapBumpOffset':
						case 'mapBumpWrap':
						case 'mapBumpAnisotropy':
							break;
						case 'mapNormal':
							json.normalMap = loadTexture( value, m.mapNormalRepeat, m.mapNormalOffset, m.mapNormalWrap, m.mapNormalAnisotropy );
							break;
						case 'mapNormalFactor':
							json.normalScale = [ value, value ];
							break;
						case 'mapNormalRepeat':
						case 'mapNormalOffset':
						case 'mapNormalWrap':
						case 'mapNormalAnisotropy':
							break;
						case 'mapSpecular':
							json.specularMap = loadTexture( value, m.mapSpecularRepeat, m.mapSpecularOffset, m.mapSpecularWrap, m.mapSpecularAnisotropy );
							break;
						case 'mapSpecularRepeat':
						case 'mapSpecularOffset':
						case 'mapSpecularWrap':
						case 'mapSpecularAnisotropy':
							break;
						case 'mapMetalness':
							json.metalnessMap = loadTexture( value, m.mapMetalnessRepeat, m.mapMetalnessOffset, m.mapMetalnessWrap, m.mapMetalnessAnisotropy );
							break;
						case 'mapMetalnessRepeat':
						case 'mapMetalnessOffset':
						case 'mapMetalnessWrap':
						case 'mapMetalnessAnisotropy':
							break;
						case 'mapRoughness':
							json.roughnessMap = loadTexture( value, m.mapRoughnessRepeat, m.mapRoughnessOffset, m.mapRoughnessWrap, m.mapRoughnessAnisotropy );
							break;
						case 'mapRoughnessRepeat':
						case 'mapRoughnessOffset':
						case 'mapRoughnessWrap':
						case 'mapRoughnessAnisotropy':
							break;
						case 'mapAlpha':
							json.alphaMap = loadTexture( value, m.mapAlphaRepeat, m.mapAlphaOffset, m.mapAlphaWrap, m.mapAlphaAnisotropy );
							break;
						case 'mapAlphaRepeat':
						case 'mapAlphaOffset':
						case 'mapAlphaWrap':
						case 'mapAlphaAnisotropy':
							break;
						case 'flipSided':
							json.side = BackSide;
							break;
						case 'doubleSided':
							json.side = DoubleSide;
							break;
						case 'transparency':
							console.warn( 'THREE.Loader.createMaterial: transparency has been renamed to opacity' );
							json.opacity = value;
							break;
						case 'depthTest':
						case 'depthWrite':
						case 'colorWrite':
						case 'opacity':
						case 'reflectivity':
						case 'transparent':
						case 'visible':
						case 'wireframe':
							json[ name ] = value;
							break;
						case 'vertexColors':
							if ( value === true ) json.vertexColors = VertexColors;
							if ( value === 'face' ) json.vertexColors = FaceColors;
							break;
						default:
							console.error( 'THREE.Loader.createMaterial: Unsupported', name, value );
							break;
					}

				}

				if ( json.type === 'MeshBasicMaterial' ) delete json.emissive;
				if ( json.type !== 'MeshPhongMaterial' ) delete json.specular;

				if ( json.opacity < 1 ) json.transparent = true;

				materialLoader.setTextures( textures );

				return materialLoader.parse( json );

			};

		} )()

	};

	Loader.Handlers = {

		handlers: [],

		add: function ( regex, loader ) {

			this.handlers.push( regex, loader );

		},

		get: function ( file ) {

			var handlers = this.handlers;

			for ( var i = 0, l = handlers.length; i < l; i += 2 ) {

				var regex = handlers[ i ];
				var loader  = handlers[ i + 1 ];

				if ( regex.test( file ) ) {

					return loader;

				}

			}

			return null;

		}

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function JSONLoader( manager ) {

		if ( typeof manager === 'boolean' ) {

			console.warn( 'THREE.JSONLoader: showStatus parameter has been removed from constructor.' );
			manager = undefined;

		}

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

		this.withCredentials = false;

	}

	Object.assign( JSONLoader.prototype, {

		load: function( url, onLoad, onProgress, onError ) {

			var scope = this;

			var texturePath = this.texturePath && ( typeof this.texturePath === "string" ) ? this.texturePath : Loader.prototype.extractUrlBase( url );

			var loader = new FileLoader( this.manager );
			loader.setWithCredentials( this.withCredentials );
			loader.load( url, function ( text ) {

				var json = JSON.parse( text );
				var metadata = json.metadata;

				if ( metadata !== undefined ) {

					var type = metadata.type;

					if ( type !== undefined ) {

						if ( type.toLowerCase() === 'object' ) {

							console.error( 'THREE.JSONLoader: ' + url + ' should be loaded with THREE.ObjectLoader instead.' );
							return;

						}

						if ( type.toLowerCase() === 'scene' ) {

							console.error( 'THREE.JSONLoader: ' + url + ' should be loaded with THREE.SceneLoader instead.' );
							return;

						}

					}

				}

				var object = scope.parse( json, texturePath );
				onLoad( object.geometry, object.materials );

			}, onProgress, onError );

		},

		setTexturePath: function ( value ) {

			this.texturePath = value;

		},

		parse: function ( json, texturePath ) {

			var geometry = new Geometry(),
			scale = ( json.scale !== undefined ) ? 1.0 / json.scale : 1.0;

			parseModel( scale );

			parseSkin();
			parseMorphing( scale );
			parseAnimations();

			geometry.computeFaceNormals();
			geometry.computeBoundingSphere();

			function parseModel( scale ) {

				function isBitSet( value, position ) {

					return value & ( 1 << position );

				}

				var i, j, fi,

				offset, zLength,

			colorIndex, normalIndex, uvIndex, materialIndex,

				type,
				isQuad,
				hasMaterial,
				hasFaceVertexUv,
				hasFaceNormal, hasFaceVertexNormal,
				hasFaceColor, hasFaceVertexColor,

			vertex, face, faceA, faceB, hex, normal,

				uvLayer, uv, u, v,

				faces = json.faces,
				vertices = json.vertices,
				normals = json.normals,
				colors = json.colors,

				nUvLayers = 0;

				if ( json.uvs !== undefined ) {

					// disregard empty arrays

					for ( i = 0; i < json.uvs.length; i ++ ) {

						if ( json.uvs[ i ].length ) nUvLayers ++;

					}

					for ( i = 0; i < nUvLayers; i ++ ) {

						geometry.faceVertexUvs[ i ] = [];

					}

				}

				offset = 0;
				zLength = vertices.length;

				while ( offset < zLength ) {

					vertex = new Vector3();

					vertex.x = vertices[ offset ++ ] * scale;
					vertex.y = vertices[ offset ++ ] * scale;
					vertex.z = vertices[ offset ++ ] * scale;

					geometry.vertices.push( vertex );

				}

				offset = 0;
				zLength = faces.length;

				while ( offset < zLength ) {

					type = faces[ offset ++ ];


					isQuad              = isBitSet( type, 0 );
					hasMaterial         = isBitSet( type, 1 );
					hasFaceVertexUv     = isBitSet( type, 3 );
					hasFaceNormal       = isBitSet( type, 4 );
					hasFaceVertexNormal = isBitSet( type, 5 );
					hasFaceColor	     = isBitSet( type, 6 );
					hasFaceVertexColor  = isBitSet( type, 7 );

					// console.log("type", type, "bits", isQuad, hasMaterial, hasFaceVertexUv, hasFaceNormal, hasFaceVertexNormal, hasFaceColor, hasFaceVertexColor);

					if ( isQuad ) {

						faceA = new Face3();
						faceA.a = faces[ offset ];
						faceA.b = faces[ offset + 1 ];
						faceA.c = faces[ offset + 3 ];

						faceB = new Face3();
						faceB.a = faces[ offset + 1 ];
						faceB.b = faces[ offset + 2 ];
						faceB.c = faces[ offset + 3 ];

						offset += 4;

						if ( hasMaterial ) {

							materialIndex = faces[ offset ++ ];
							faceA.materialIndex = materialIndex;
							faceB.materialIndex = materialIndex;

						}

						// to get face <=> uv index correspondence

						fi = geometry.faces.length;

						if ( hasFaceVertexUv ) {

							for ( i = 0; i < nUvLayers; i ++ ) {

								uvLayer = json.uvs[ i ];

								geometry.faceVertexUvs[ i ][ fi ] = [];
								geometry.faceVertexUvs[ i ][ fi + 1 ] = [];

								for ( j = 0; j < 4; j ++ ) {

									uvIndex = faces[ offset ++ ];

									u = uvLayer[ uvIndex * 2 ];
									v = uvLayer[ uvIndex * 2 + 1 ];

									uv = new Vector2( u, v );

									if ( j !== 2 ) geometry.faceVertexUvs[ i ][ fi ].push( uv );
									if ( j !== 0 ) geometry.faceVertexUvs[ i ][ fi + 1 ].push( uv );

								}

							}

						}

						if ( hasFaceNormal ) {

							normalIndex = faces[ offset ++ ] * 3;

							faceA.normal.set(
								normals[ normalIndex ++ ],
								normals[ normalIndex ++ ],
								normals[ normalIndex ]
							);

							faceB.normal.copy( faceA.normal );

						}

						if ( hasFaceVertexNormal ) {

							for ( i = 0; i < 4; i ++ ) {

								normalIndex = faces[ offset ++ ] * 3;

								normal = new Vector3(
									normals[ normalIndex ++ ],
									normals[ normalIndex ++ ],
									normals[ normalIndex ]
								);


								if ( i !== 2 ) faceA.vertexNormals.push( normal );
								if ( i !== 0 ) faceB.vertexNormals.push( normal );

							}

						}


						if ( hasFaceColor ) {

							colorIndex = faces[ offset ++ ];
							hex = colors[ colorIndex ];

							faceA.color.setHex( hex );
							faceB.color.setHex( hex );

						}


						if ( hasFaceVertexColor ) {

							for ( i = 0; i < 4; i ++ ) {

								colorIndex = faces[ offset ++ ];
								hex = colors[ colorIndex ];

								if ( i !== 2 ) faceA.vertexColors.push( new Color( hex ) );
								if ( i !== 0 ) faceB.vertexColors.push( new Color( hex ) );

							}

						}

						geometry.faces.push( faceA );
						geometry.faces.push( faceB );

					} else {

						face = new Face3();
						face.a = faces[ offset ++ ];
						face.b = faces[ offset ++ ];
						face.c = faces[ offset ++ ];

						if ( hasMaterial ) {

							materialIndex = faces[ offset ++ ];
							face.materialIndex = materialIndex;

						}

						// to get face <=> uv index correspondence

						fi = geometry.faces.length;

						if ( hasFaceVertexUv ) {

							for ( i = 0; i < nUvLayers; i ++ ) {

								uvLayer = json.uvs[ i ];

								geometry.faceVertexUvs[ i ][ fi ] = [];

								for ( j = 0; j < 3; j ++ ) {

									uvIndex = faces[ offset ++ ];

									u = uvLayer[ uvIndex * 2 ];
									v = uvLayer[ uvIndex * 2 + 1 ];

									uv = new Vector2( u, v );

									geometry.faceVertexUvs[ i ][ fi ].push( uv );

								}

							}

						}

						if ( hasFaceNormal ) {

							normalIndex = faces[ offset ++ ] * 3;

							face.normal.set(
								normals[ normalIndex ++ ],
								normals[ normalIndex ++ ],
								normals[ normalIndex ]
							);

						}

						if ( hasFaceVertexNormal ) {

							for ( i = 0; i < 3; i ++ ) {

								normalIndex = faces[ offset ++ ] * 3;

								normal = new Vector3(
									normals[ normalIndex ++ ],
									normals[ normalIndex ++ ],
									normals[ normalIndex ]
								);

								face.vertexNormals.push( normal );

							}

						}


						if ( hasFaceColor ) {

							colorIndex = faces[ offset ++ ];
							face.color.setHex( colors[ colorIndex ] );

						}


						if ( hasFaceVertexColor ) {

							for ( i = 0; i < 3; i ++ ) {

								colorIndex = faces[ offset ++ ];
								face.vertexColors.push( new Color( colors[ colorIndex ] ) );

							}

						}

						geometry.faces.push( face );

					}

				}

			}

			function parseSkin() {

				var influencesPerVertex = ( json.influencesPerVertex !== undefined ) ? json.influencesPerVertex : 2;

				if ( json.skinWeights ) {

					for ( var i = 0, l = json.skinWeights.length; i < l; i += influencesPerVertex ) {

						var x =                               json.skinWeights[ i ];
						var y = ( influencesPerVertex > 1 ) ? json.skinWeights[ i + 1 ] : 0;
						var z = ( influencesPerVertex > 2 ) ? json.skinWeights[ i + 2 ] : 0;
						var w = ( influencesPerVertex > 3 ) ? json.skinWeights[ i + 3 ] : 0;

						geometry.skinWeights.push( new Vector4( x, y, z, w ) );

					}

				}

				if ( json.skinIndices ) {

					for ( var i = 0, l = json.skinIndices.length; i < l; i += influencesPerVertex ) {

						var a =                               json.skinIndices[ i ];
						var b = ( influencesPerVertex > 1 ) ? json.skinIndices[ i + 1 ] : 0;
						var c = ( influencesPerVertex > 2 ) ? json.skinIndices[ i + 2 ] : 0;
						var d = ( influencesPerVertex > 3 ) ? json.skinIndices[ i + 3 ] : 0;

						geometry.skinIndices.push( new Vector4( a, b, c, d ) );

					}

				}

				geometry.bones = json.bones;

				if ( geometry.bones && geometry.bones.length > 0 && ( geometry.skinWeights.length !== geometry.skinIndices.length || geometry.skinIndices.length !== geometry.vertices.length ) ) {

					console.warn( 'When skinning, number of vertices (' + geometry.vertices.length + '), skinIndices (' +
						geometry.skinIndices.length + '), and skinWeights (' + geometry.skinWeights.length + ') should match.' );

				}

			}

			function parseMorphing( scale ) {

				if ( json.morphTargets !== undefined ) {

					for ( var i = 0, l = json.morphTargets.length; i < l; i ++ ) {

						geometry.morphTargets[ i ] = {};
						geometry.morphTargets[ i ].name = json.morphTargets[ i ].name;
						geometry.morphTargets[ i ].vertices = [];

						var dstVertices = geometry.morphTargets[ i ].vertices;
						var srcVertices = json.morphTargets[ i ].vertices;

						for ( var v = 0, vl = srcVertices.length; v < vl; v += 3 ) {

							var vertex = new Vector3();
							vertex.x = srcVertices[ v ] * scale;
							vertex.y = srcVertices[ v + 1 ] * scale;
							vertex.z = srcVertices[ v + 2 ] * scale;

							dstVertices.push( vertex );

						}

					}

				}

				if ( json.morphColors !== undefined && json.morphColors.length > 0 ) {

					console.warn( 'THREE.JSONLoader: "morphColors" no longer supported. Using them as face colors.' );

					var faces = geometry.faces;
					var morphColors = json.morphColors[ 0 ].colors;

					for ( var i = 0, l = faces.length; i < l; i ++ ) {

						faces[ i ].color.fromArray( morphColors, i * 3 );

					}

				}

			}

			function parseAnimations() {

				var outputAnimations = [];

				// parse old style Bone/Hierarchy animations
				var animations = [];

				if ( json.animation !== undefined ) {

					animations.push( json.animation );

				}

				if ( json.animations !== undefined ) {

					if ( json.animations.length ) {

						animations = animations.concat( json.animations );

					} else {

						animations.push( json.animations );

					}

				}

				for ( var i = 0; i < animations.length; i ++ ) {

					var clip = AnimationClip.parseAnimation( animations[ i ], geometry.bones );
					if ( clip ) outputAnimations.push( clip );

				}

				// parse implicit morph animations
				if ( geometry.morphTargets ) {

					// TODO: Figure out what an appropraite FPS is for morph target animations -- defaulting to 10, but really it is completely arbitrary.
					var morphAnimationClips = AnimationClip.CreateClipsFromMorphTargetSequences( geometry.morphTargets, 10 );
					outputAnimations = outputAnimations.concat( morphAnimationClips );

				}

				if ( outputAnimations.length > 0 ) geometry.animations = outputAnimations;

			}

			if ( json.materials === undefined || json.materials.length === 0 ) {

				return { geometry: geometry };

			} else {

				var materials = Loader.prototype.initMaterials( json.materials, texturePath, this.crossOrigin );

				return { geometry: geometry, materials: materials };

			}

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function ObjectLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
		this.texturePath = '';

	}

	Object.assign( ObjectLoader.prototype, {

		load: function ( url, onLoad, onProgress, onError ) {

			if ( this.texturePath === '' ) {

				this.texturePath = url.substring( 0, url.lastIndexOf( '/' ) + 1 );

			}

			var scope = this;

			var loader = new FileLoader( scope.manager );
			loader.load( url, function ( text ) {

				var json = null;

				try {

					json = JSON.parse( text );

				} catch ( error ) {

					console.error( 'THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message );
					return;

				}

				var metadata = json.metadata;

				if ( metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry' ) {

					console.error( 'THREE.ObjectLoader: Can\'t load ' + url + '. Use THREE.JSONLoader instead.' );
					return;

				}

				scope.parse( json, onLoad );

			}, onProgress, onError );

		},

		setTexturePath: function ( value ) {

			this.texturePath = value;

		},

		setCrossOrigin: function ( value ) {

			this.crossOrigin = value;

		},

		parse: function ( json, onLoad ) {

			var geometries = this.parseGeometries( json.geometries );

			var images = this.parseImages( json.images, function () {

				if ( onLoad !== undefined ) onLoad( object );

			} );

			var textures = this.parseTextures( json.textures, images );
			var materials = this.parseMaterials( json.materials, textures );

			var object = this.parseObject( json.object, geometries, materials );

			if ( json.animations ) {

				object.animations = this.parseAnimations( json.animations );

			}

			if ( json.images === undefined || json.images.length === 0 ) {

				if ( onLoad !== undefined ) onLoad( object );

			}

			return object;

		},

		parseGeometries: function ( json ) {

			var geometries = {};

			if ( json !== undefined ) {

				var geometryLoader = new JSONLoader();
				var bufferGeometryLoader = new BufferGeometryLoader();

				for ( var i = 0, l = json.length; i < l; i ++ ) {

					var geometry;
					var data = json[ i ];

					switch ( data.type ) {

						case 'PlaneGeometry':
						case 'PlaneBufferGeometry':

							geometry = new Geometries[ data.type ](
								data.width,
								data.height,
								data.widthSegments,
								data.heightSegments
							);

							break;

						case 'BoxGeometry':
						case 'BoxBufferGeometry':
						case 'CubeGeometry': // backwards compatible

							geometry = new Geometries[ data.type ](
								data.width,
								data.height,
								data.depth,
								data.widthSegments,
								data.heightSegments,
								data.depthSegments
							);

							break;

						case 'CircleGeometry':
						case 'CircleBufferGeometry':

							geometry = new Geometries[ data.type ](
								data.radius,
								data.segments,
								data.thetaStart,
								data.thetaLength
							);

							break;

						case 'CylinderGeometry':
						case 'CylinderBufferGeometry':

							geometry = new Geometries[ data.type ](
								data.radiusTop,
								data.radiusBottom,
								data.height,
								data.radialSegments,
								data.heightSegments,
								data.openEnded,
								data.thetaStart,
								data.thetaLength
							);

							break;

						case 'ConeGeometry':
						case 'ConeBufferGeometry':

							geometry = new Geometries[ data.type ](
								data.radius,
								data.height,
								data.radialSegments,
								data.heightSegments,
								data.openEnded,
								data.thetaStart,
								data.thetaLength
							);

							break;

						case 'SphereGeometry':
						case 'SphereBufferGeometry':

							geometry = new Geometries[ data.type ](
								data.radius,
								data.widthSegments,
								data.heightSegments,
								data.phiStart,
								data.phiLength,
								data.thetaStart,
								data.thetaLength
							);

							break;

						case 'DodecahedronGeometry':
						case 'IcosahedronGeometry':
						case 'OctahedronGeometry':
						case 'TetrahedronGeometry':

							geometry = new Geometries[ data.type ](
								data.radius,
								data.detail
							);

							break;

						case 'RingGeometry':
						case 'RingBufferGeometry':

							geometry = new Geometries[ data.type ](
								data.innerRadius,
								data.outerRadius,
								data.thetaSegments,
								data.phiSegments,
								data.thetaStart,
								data.thetaLength
							);

							break;

						case 'TorusGeometry':
						case 'TorusBufferGeometry':

							geometry = new Geometries[ data.type ](
								data.radius,
								data.tube,
								data.radialSegments,
								data.tubularSegments,
								data.arc
							);

							break;

						case 'TorusKnotGeometry':
						case 'TorusKnotBufferGeometry':

							geometry = new Geometries[ data.type ](
								data.radius,
								data.tube,
								data.tubularSegments,
								data.radialSegments,
								data.p,
								data.q
							);

							break;

						case 'LatheGeometry':
						case 'LatheBufferGeometry':

							geometry = new Geometries[ data.type ](
								data.points,
								data.segments,
								data.phiStart,
								data.phiLength
							);

							break;

						case 'BufferGeometry':

							geometry = bufferGeometryLoader.parse( data );

							break;

						case 'Geometry':

							geometry = geometryLoader.parse( data.data, this.texturePath ).geometry;

							break;

						default:

							console.warn( 'THREE.ObjectLoader: Unsupported geometry type "' + data.type + '"' );

							continue;

					}

					geometry.uuid = data.uuid;

					if ( data.name !== undefined ) geometry.name = data.name;

					geometries[ data.uuid ] = geometry;

				}

			}

			return geometries;

		},

		parseMaterials: function ( json, textures ) {

			var materials = {};

			if ( json !== undefined ) {

				var loader = new MaterialLoader();
				loader.setTextures( textures );

				for ( var i = 0, l = json.length; i < l; i ++ ) {

					var material = loader.parse( json[ i ] );
					materials[ material.uuid ] = material;

				}

			}

			return materials;

		},

		parseAnimations: function ( json ) {

			var animations = [];

			for ( var i = 0; i < json.length; i ++ ) {

				var clip = AnimationClip.parse( json[ i ] );

				animations.push( clip );

			}

			return animations;

		},

		parseImages: function ( json, onLoad ) {

			var scope = this;
			var images = {};

			function loadImage( url ) {

				scope.manager.itemStart( url );

				return loader.load( url, function () {

					scope.manager.itemEnd( url );

				}, undefined, function () {

					scope.manager.itemError( url );

				} );

			}

			if ( json !== undefined && json.length > 0 ) {

				var manager = new LoadingManager( onLoad );

				var loader = new ImageLoader( manager );
				loader.setCrossOrigin( this.crossOrigin );

				for ( var i = 0, l = json.length; i < l; i ++ ) {

					var image = json[ i ];
					var path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test( image.url ) ? image.url : scope.texturePath + image.url;

					images[ image.uuid ] = loadImage( path );

				}

			}

			return images;

		},

		parseTextures: function ( json, images ) {

			function parseConstant( value, type ) {

				if ( typeof( value ) === 'number' ) return value;

				console.warn( 'THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value );

				return type[ value ];

			}

			var textures = {};

			if ( json !== undefined ) {

				for ( var i = 0, l = json.length; i < l; i ++ ) {

					var data = json[ i ];

					if ( data.image === undefined ) {

						console.warn( 'THREE.ObjectLoader: No "image" specified for', data.uuid );

					}

					if ( images[ data.image ] === undefined ) {

						console.warn( 'THREE.ObjectLoader: Undefined image', data.image );

					}

					var texture = new Texture( images[ data.image ] );
					texture.needsUpdate = true;

					texture.uuid = data.uuid;

					if ( data.name !== undefined ) texture.name = data.name;

					if ( data.mapping !== undefined ) texture.mapping = parseConstant( data.mapping, TextureMapping );

					if ( data.offset !== undefined ) texture.offset.fromArray( data.offset );
					if ( data.repeat !== undefined ) texture.repeat.fromArray( data.repeat );
					if ( data.wrap !== undefined ) {

						texture.wrapS = parseConstant( data.wrap[ 0 ], TextureWrapping );
						texture.wrapT = parseConstant( data.wrap[ 1 ], TextureWrapping );

					}

					if ( data.minFilter !== undefined ) texture.minFilter = parseConstant( data.minFilter, TextureFilter );
					if ( data.magFilter !== undefined ) texture.magFilter = parseConstant( data.magFilter, TextureFilter );
					if ( data.anisotropy !== undefined ) texture.anisotropy = data.anisotropy;

					if ( data.flipY !== undefined ) texture.flipY = data.flipY;

					textures[ data.uuid ] = texture;

				}

			}

			return textures;

		},

		parseObject: function () {

			var matrix = new Matrix4();

			return function parseObject( data, geometries, materials ) {

				var object;

				function getGeometry( name ) {

					if ( geometries[ name ] === undefined ) {

						console.warn( 'THREE.ObjectLoader: Undefined geometry', name );

					}

					return geometries[ name ];

				}

				function getMaterial( name ) {

					if ( name === undefined ) return undefined;

					if ( materials[ name ] === undefined ) {

						console.warn( 'THREE.ObjectLoader: Undefined material', name );

					}

					return materials[ name ];

				}

				switch ( data.type ) {

					case 'Scene':

						object = new Scene();

						if ( data.background !== undefined ) {

							if ( Number.isInteger( data.background ) ) {

								object.background = new Color( data.background );

							}

						}

						if ( data.fog !== undefined ) {

							if ( data.fog.type === 'Fog' ) {

								object.fog = new Fog( data.fog.color, data.fog.near, data.fog.far );

							} else if ( data.fog.type === 'FogExp2' ) {

								object.fog = new FogExp2( data.fog.color, data.fog.density );

							}

						}

						break;

					case 'PerspectiveCamera':

						object = new PerspectiveCamera( data.fov, data.aspect, data.near, data.far );

						if ( data.focus !== undefined ) object.focus = data.focus;
						if ( data.zoom !== undefined ) object.zoom = data.zoom;
						if ( data.filmGauge !== undefined ) object.filmGauge = data.filmGauge;
						if ( data.filmOffset !== undefined ) object.filmOffset = data.filmOffset;
						if ( data.view !== undefined ) object.view = Object.assign( {}, data.view );

						break;

					case 'OrthographicCamera':

						object = new OrthographicCamera( data.left, data.right, data.top, data.bottom, data.near, data.far );

						break;

					case 'AmbientLight':

						object = new AmbientLight( data.color, data.intensity );

						break;

					case 'DirectionalLight':

						object = new DirectionalLight( data.color, data.intensity );

						break;

					case 'PointLight':

						object = new PointLight( data.color, data.intensity, data.distance, data.decay );

						break;

					case 'SpotLight':

						object = new SpotLight( data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay );

						break;

					case 'HemisphereLight':

						object = new HemisphereLight( data.color, data.groundColor, data.intensity );

						break;

					case 'Mesh':

						var geometry = getGeometry( data.geometry );
						var material = getMaterial( data.material );

						if ( geometry.bones && geometry.bones.length > 0 ) {

							object = new SkinnedMesh( geometry, material );

						} else {

							object = new Mesh( geometry, material );

						}

						break;

					case 'LOD':

						object = new LOD();

						break;

					case 'Line':

						object = new Line( getGeometry( data.geometry ), getMaterial( data.material ), data.mode );

						break;

					case 'LineSegments':

						object = new LineSegments( getGeometry( data.geometry ), getMaterial( data.material ) );

						break;

					case 'PointCloud':
					case 'Points':

						object = new Points( getGeometry( data.geometry ), getMaterial( data.material ) );

						break;

					case 'Sprite':

						object = new Sprite( getMaterial( data.material ) );

						break;

					case 'Group':

						object = new Group();

						break;

					case 'SkinnedMesh':

						console.warn( 'THREE.ObjectLoader.parseObject() does not support SkinnedMesh type. Instantiates Object3D instead.' );

					default:

						object = new Object3D();

				}

				object.uuid = data.uuid;

				if ( data.name !== undefined ) object.name = data.name;
				if ( data.matrix !== undefined ) {

					matrix.fromArray( data.matrix );
					matrix.decompose( object.position, object.quaternion, object.scale );

				} else {

					if ( data.position !== undefined ) object.position.fromArray( data.position );
					if ( data.rotation !== undefined ) object.rotation.fromArray( data.rotation );
					if ( data.quaternion !== undefined ) object.quaternion.fromArray( data.quaternion );
					if ( data.scale !== undefined ) object.scale.fromArray( data.scale );

				}

				if ( data.castShadow !== undefined ) object.castShadow = data.castShadow;
				if ( data.receiveShadow !== undefined ) object.receiveShadow = data.receiveShadow;

				if ( data.shadow ) {

					if ( data.shadow.bias !== undefined ) object.shadow.bias = data.shadow.bias;
					if ( data.shadow.radius !== undefined ) object.shadow.radius = data.shadow.radius;
					if ( data.shadow.mapSize !== undefined ) object.shadow.mapSize.fromArray( data.shadow.mapSize );
					if ( data.shadow.camera !== undefined ) object.shadow.camera = this.parseObject( data.shadow.camera );

				}

				if ( data.visible !== undefined ) object.visible = data.visible;
				if ( data.userData !== undefined ) object.userData = data.userData;

				if ( data.children !== undefined ) {

					for ( var child in data.children ) {

						object.add( this.parseObject( data.children[ child ], geometries, materials ) );

					}

				}

				if ( data.type === 'LOD' ) {

					var levels = data.levels;

					for ( var l = 0; l < levels.length; l ++ ) {

						var level = levels[ l ];
						var child = object.getObjectByProperty( 'uuid', level.object );

						if ( child !== undefined ) {

							object.addLevel( child, level.distance );

						}

					}

				}

				return object;

			};

		}()

	} );

	/**
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 * Extensible curve object
	 *
	 * Some common of Curve methods
	 * .getPoint(t), getTangent(t)
	 * .getPointAt(u), getTangentAt(u)
	 * .getPoints(), .getSpacedPoints()
	 * .getLength()
	 * .updateArcLengths()
	 *
	 * This following classes subclasses THREE.Curve:
	 *
	 * -- 2d classes --
	 * THREE.LineCurve
	 * THREE.QuadraticBezierCurve
	 * THREE.CubicBezierCurve
	 * THREE.SplineCurve
	 * THREE.ArcCurve
	 * THREE.EllipseCurve
	 *
	 * -- 3d classes --
	 * THREE.LineCurve3
	 * THREE.QuadraticBezierCurve3
	 * THREE.CubicBezierCurve3
	 * THREE.SplineCurve3
	 *
	 * A series of curves can be represented as a THREE.CurvePath
	 *
	 **/

	/**************************************************************
	 *	Abstract Curve base class
	 **************************************************************/

	function Curve() {}

	Curve.prototype = {

		constructor: Curve,

		// Virtual base class method to overwrite and implement in subclasses
		//	- t [0 .. 1]

		getPoint: function ( t ) {

			console.warn( "THREE.Curve: Warning, getPoint() not implemented!" );
			return null;

		},

		// Get point at relative position in curve according to arc length
		// - u [0 .. 1]

		getPointAt: function ( u ) {

			var t = this.getUtoTmapping( u );
			return this.getPoint( t );

		},

		// Get sequence of points using getPoint( t )

		getPoints: function ( divisions ) {

			if ( ! divisions ) divisions = 5;

			var points = [];

			for ( var d = 0; d <= divisions; d ++ ) {

				points.push( this.getPoint( d / divisions ) );

			}

			return points;

		},

		// Get sequence of points using getPointAt( u )

		getSpacedPoints: function ( divisions ) {

			if ( ! divisions ) divisions = 5;

			var points = [];

			for ( var d = 0; d <= divisions; d ++ ) {

				points.push( this.getPointAt( d / divisions ) );

			}

			return points;

		},

		// Get total curve arc length

		getLength: function () {

			var lengths = this.getLengths();
			return lengths[ lengths.length - 1 ];

		},

		// Get list of cumulative segment lengths

		getLengths: function ( divisions ) {

			if ( ! divisions ) divisions = ( this.__arcLengthDivisions ) ? ( this.__arcLengthDivisions ) : 200;

			if ( this.cacheArcLengths
				&& ( this.cacheArcLengths.length === divisions + 1 )
				&& ! this.needsUpdate ) {

				//console.log( "cached", this.cacheArcLengths );
				return this.cacheArcLengths;

			}

			this.needsUpdate = false;

			var cache = [];
			var current, last = this.getPoint( 0 );
			var p, sum = 0;

			cache.push( 0 );

			for ( p = 1; p <= divisions; p ++ ) {

				current = this.getPoint ( p / divisions );
				sum += current.distanceTo( last );
				cache.push( sum );
				last = current;

			}

			this.cacheArcLengths = cache;

			return cache; // { sums: cache, sum:sum }; Sum is in the last element.

		},

		updateArcLengths: function() {

			this.needsUpdate = true;
			this.getLengths();

		},

		// Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant

		getUtoTmapping: function ( u, distance ) {

			var arcLengths = this.getLengths();

			var i = 0, il = arcLengths.length;

			var targetArcLength; // The targeted u distance value to get

			if ( distance ) {

				targetArcLength = distance;

			} else {

				targetArcLength = u * arcLengths[ il - 1 ];

			}

			//var time = Date.now();

			// binary search for the index with largest value smaller than target u distance

			var low = 0, high = il - 1, comparison;

			while ( low <= high ) {

				i = Math.floor( low + ( high - low ) / 2 ); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats

				comparison = arcLengths[ i ] - targetArcLength;

				if ( comparison < 0 ) {

					low = i + 1;

				} else if ( comparison > 0 ) {

					high = i - 1;

				} else {

					high = i;
					break;

					// DONE

				}

			}

			i = high;

			//console.log('b' , i, low, high, Date.now()- time);

			if ( arcLengths[ i ] === targetArcLength ) {

				var t = i / ( il - 1 );
				return t;

			}

			// we could get finer grain at lengths, or use simple interpolation between two points

			var lengthBefore = arcLengths[ i ];
			var lengthAfter = arcLengths[ i + 1 ];

			var segmentLength = lengthAfter - lengthBefore;

			// determine where we are between the 'before' and 'after' points

			var segmentFraction = ( targetArcLength - lengthBefore ) / segmentLength;

			// add that fractional amount to t

			var t = ( i + segmentFraction ) / ( il - 1 );

			return t;

		},

		// Returns a unit vector tangent at t
		// In case any sub curve does not implement its tangent derivation,
		// 2 points a small delta apart will be used to find its gradient
		// which seems to give a reasonable approximation

		getTangent: function( t ) {

			var delta = 0.0001;
			var t1 = t - delta;
			var t2 = t + delta;

			// Capping in case of danger

			if ( t1 < 0 ) t1 = 0;
			if ( t2 > 1 ) t2 = 1;

			var pt1 = this.getPoint( t1 );
			var pt2 = this.getPoint( t2 );

			var vec = pt2.clone().sub( pt1 );
			return vec.normalize();

		},

		getTangentAt: function ( u ) {

			var t = this.getUtoTmapping( u );
			return this.getTangent( t );

		},

		computeFrenetFrames: function ( segments, closed ) {

			// see http://www.cs.indiana.edu/pub/techreports/TR425.pdf

			var normal = new Vector3();

			var tangents = [];
			var normals = [];
			var binormals = [];

			var vec = new Vector3();
			var mat = new Matrix4();

			var i, u, theta;

			// compute the tangent vectors for each segment on the curve

			for ( i = 0; i <= segments; i ++ ) {

				u = i / segments;

				tangents[ i ] = this.getTangentAt( u );
				tangents[ i ].normalize();

			}

			// select an initial normal vector perpendicular to the first tangent vector,
			// and in the direction of the minimum tangent xyz component

			normals[ 0 ] = new Vector3();
			binormals[ 0 ] = new Vector3();
			var min = Number.MAX_VALUE;
			var tx = Math.abs( tangents[ 0 ].x );
			var ty = Math.abs( tangents[ 0 ].y );
			var tz = Math.abs( tangents[ 0 ].z );

			if ( tx <= min ) {

				min = tx;
				normal.set( 1, 0, 0 );

			}

			if ( ty <= min ) {

				min = ty;
				normal.set( 0, 1, 0 );

			}

			if ( tz <= min ) {

				normal.set( 0, 0, 1 );

			}

			vec.crossVectors( tangents[ 0 ], normal ).normalize();

			normals[ 0 ].crossVectors( tangents[ 0 ], vec );
			binormals[ 0 ].crossVectors( tangents[ 0 ], normals[ 0 ] );


			// compute the slowly-varying normal and binormal vectors for each segment on the curve

			for ( i = 1; i <= segments; i ++ ) {

				normals[ i ] = normals[ i - 1 ].clone();

				binormals[ i ] = binormals[ i - 1 ].clone();

				vec.crossVectors( tangents[ i - 1 ], tangents[ i ] );

				if ( vec.length() > Number.EPSILON ) {

					vec.normalize();

					theta = Math.acos( _Math.clamp( tangents[ i - 1 ].dot( tangents[ i ] ), - 1, 1 ) ); // clamp for floating pt errors

					normals[ i ].applyMatrix4( mat.makeRotationAxis( vec, theta ) );

				}

				binormals[ i ].crossVectors( tangents[ i ], normals[ i ] );

			}

			// if the curve is closed, postprocess the vectors so the first and last normal vectors are the same

			if ( closed === true ) {

				theta = Math.acos( _Math.clamp( normals[ 0 ].dot( normals[ segments ] ), - 1, 1 ) );
				theta /= segments;

				if ( tangents[ 0 ].dot( vec.crossVectors( normals[ 0 ], normals[ segments ] ) ) > 0 ) {

					theta = - theta;

				}

				for ( i = 1; i <= segments; i ++ ) {

					// twist a little...
					normals[ i ].applyMatrix4( mat.makeRotationAxis( tangents[ i ], theta * i ) );
					binormals[ i ].crossVectors( tangents[ i ], normals[ i ] );

				}

			}

			return {
				tangents: tangents,
				normals: normals,
				binormals: binormals
			};

		}

	};

	// TODO: Transformation for Curves?

	/**************************************************************
	 *	3D Curves
	 **************************************************************/

	// A Factory method for creating new curve subclasses

	Curve.create = function ( constructor, getPointFunc ) {

		constructor.prototype = Object.create( Curve.prototype );
		constructor.prototype.constructor = constructor;
		constructor.prototype.getPoint = getPointFunc;

		return constructor;

	};

	/**************************************************************
	 *	Line
	 **************************************************************/

	function LineCurve( v1, v2 ) {

		this.v1 = v1;
		this.v2 = v2;

	}

	LineCurve.prototype = Object.create( Curve.prototype );
	LineCurve.prototype.constructor = LineCurve;

	LineCurve.prototype.isLineCurve = true;

	LineCurve.prototype.getPoint = function ( t ) {

		if ( t === 1 ) {

			return this.v2.clone();

		}

		var point = this.v2.clone().sub( this.v1 );
		point.multiplyScalar( t ).add( this.v1 );

		return point;

	};

	// Line curve is linear, so we can overwrite default getPointAt

	LineCurve.prototype.getPointAt = function ( u ) {

		return this.getPoint( u );

	};

	LineCurve.prototype.getTangent = function( t ) {

		var tangent = this.v2.clone().sub( this.v1 );

		return tangent.normalize();

	};

	/**
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 *
	 **/

	/**************************************************************
	 *	Curved Path - a curve path is simply a array of connected
	 *  curves, but retains the api of a curve
	 **************************************************************/

	function CurvePath() {

		this.curves = [];

		this.autoClose = false; // Automatically closes the path

	}

	CurvePath.prototype = Object.assign( Object.create( Curve.prototype ), {

		constructor: CurvePath,

		add: function ( curve ) {

			this.curves.push( curve );

		},

		closePath: function () {

			// Add a line curve if start and end of lines are not connected
			var startPoint = this.curves[ 0 ].getPoint( 0 );
			var endPoint = this.curves[ this.curves.length - 1 ].getPoint( 1 );

			if ( ! startPoint.equals( endPoint ) ) {

				this.curves.push( new LineCurve( endPoint, startPoint ) );

			}

		},

		// To get accurate point with reference to
		// entire path distance at time t,
		// following has to be done:

		// 1. Length of each sub path have to be known
		// 2. Locate and identify type of curve
		// 3. Get t for the curve
		// 4. Return curve.getPointAt(t')

		getPoint: function ( t ) {

			var d = t * this.getLength();
			var curveLengths = this.getCurveLengths();
			var i = 0;

			// To think about boundaries points.

			while ( i < curveLengths.length ) {

				if ( curveLengths[ i ] >= d ) {

					var diff = curveLengths[ i ] - d;
					var curve = this.curves[ i ];

					var segmentLength = curve.getLength();
					var u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;

					return curve.getPointAt( u );

				}

				i ++;

			}

			return null;

			// loop where sum != 0, sum > d , sum+1 <d

		},

		// We cannot use the default THREE.Curve getPoint() with getLength() because in
		// THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
		// getPoint() depends on getLength

		getLength: function () {

			var lens = this.getCurveLengths();
			return lens[ lens.length - 1 ];

		},

		// cacheLengths must be recalculated.
		updateArcLengths: function () {

			this.needsUpdate = true;
			this.cacheLengths = null;
			this.getLengths();

		},

		// Compute lengths and cache them
		// We cannot overwrite getLengths() because UtoT mapping uses it.

		getCurveLengths: function () {

			// We use cache values if curves and cache array are same length

			if ( this.cacheLengths && this.cacheLengths.length === this.curves.length ) {

				return this.cacheLengths;

			}

			// Get length of sub-curve
			// Push sums into cached array

			var lengths = [], sums = 0;

			for ( var i = 0, l = this.curves.length; i < l; i ++ ) {

				sums += this.curves[ i ].getLength();
				lengths.push( sums );

			}

			this.cacheLengths = lengths;

			return lengths;

		},

		getSpacedPoints: function ( divisions ) {

			if ( ! divisions ) divisions = 40;

			var points = [];

			for ( var i = 0; i <= divisions; i ++ ) {

				points.push( this.getPoint( i / divisions ) );

			}

			if ( this.autoClose ) {

				points.push( points[ 0 ] );

			}

			return points;

		},

		getPoints: function ( divisions ) {

			divisions = divisions || 12;

			var points = [], last;

			for ( var i = 0, curves = this.curves; i < curves.length; i ++ ) {

				var curve = curves[ i ];
				var resolution = (curve && curve.isEllipseCurve) ? divisions * 2
					: (curve && curve.isLineCurve) ? 1
					: (curve && curve.isSplineCurve) ? divisions * curve.points.length
					: divisions;

				var pts = curve.getPoints( resolution );

				for ( var j = 0; j < pts.length; j++ ) {

					var point = pts[ j ];

					if ( last && last.equals( point ) ) continue; // ensures no consecutive points are duplicates

					points.push( point );
					last = point;

				}

			}

			if ( this.autoClose && points.length > 1 && !points[ points.length - 1 ].equals( points[ 0 ] ) ) {

				points.push( points[ 0 ] );

			}

			return points;

		},

		/**************************************************************
		 *	Create Geometries Helpers
		 **************************************************************/

		/// Generate geometry from path points (for Line or Points objects)

		createPointsGeometry: function ( divisions ) {

			var pts = this.getPoints( divisions );
			return this.createGeometry( pts );

		},

		// Generate geometry from equidistant sampling along the path

		createSpacedPointsGeometry: function ( divisions ) {

			var pts = this.getSpacedPoints( divisions );
			return this.createGeometry( pts );

		},

		createGeometry: function ( points ) {

			var geometry = new Geometry();

			for ( var i = 0, l = points.length; i < l; i ++ ) {

				var point = points[ i ];
				geometry.vertices.push( new Vector3( point.x, point.y, point.z || 0 ) );

			}

			return geometry;

		}

	} );

	/**************************************************************
	 *	Ellipse curve
	 **************************************************************/

	function EllipseCurve( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {

		this.aX = aX;
		this.aY = aY;

		this.xRadius = xRadius;
		this.yRadius = yRadius;

		this.aStartAngle = aStartAngle;
		this.aEndAngle = aEndAngle;

		this.aClockwise = aClockwise;

		this.aRotation = aRotation || 0;

	}

	EllipseCurve.prototype = Object.create( Curve.prototype );
	EllipseCurve.prototype.constructor = EllipseCurve;

	EllipseCurve.prototype.isEllipseCurve = true;

	EllipseCurve.prototype.getPoint = function( t ) {

		var twoPi = Math.PI * 2;
		var deltaAngle = this.aEndAngle - this.aStartAngle;
		var samePoints = Math.abs( deltaAngle ) < Number.EPSILON;

		// ensures that deltaAngle is 0 .. 2 PI
		while ( deltaAngle < 0 ) deltaAngle += twoPi;
		while ( deltaAngle > twoPi ) deltaAngle -= twoPi;

		if ( deltaAngle < Number.EPSILON ) {

			if ( samePoints ) {

				deltaAngle = 0;

			} else {

				deltaAngle = twoPi;

			}

		}

		if ( this.aClockwise === true && ! samePoints ) {

			if ( deltaAngle === twoPi ) {

				deltaAngle = - twoPi;

			} else {

				deltaAngle = deltaAngle - twoPi;

			}

		}

		var angle = this.aStartAngle + t * deltaAngle;
		var x = this.aX + this.xRadius * Math.cos( angle );
		var y = this.aY + this.yRadius * Math.sin( angle );

		if ( this.aRotation !== 0 ) {

			var cos = Math.cos( this.aRotation );
			var sin = Math.sin( this.aRotation );

			var tx = x - this.aX;
			var ty = y - this.aY;

			// Rotate the point about the center of the ellipse.
			x = tx * cos - ty * sin + this.aX;
			y = tx * sin + ty * cos + this.aY;

		}

		return new Vector2( x, y );

	};

	/**
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 */

	var CurveUtils = {

		tangentQuadraticBezier: function ( t, p0, p1, p2 ) {

			return 2 * ( 1 - t ) * ( p1 - p0 ) + 2 * t * ( p2 - p1 );

		},

		// Puay Bing, thanks for helping with this derivative!

		tangentCubicBezier: function ( t, p0, p1, p2, p3 ) {

			return - 3 * p0 * ( 1 - t ) * ( 1 - t )  +
				3 * p1 * ( 1 - t ) * ( 1 - t ) - 6 * t * p1 * ( 1 - t ) +
				6 * t *  p2 * ( 1 - t ) - 3 * t * t * p2 +
				3 * t * t * p3;

		},

		tangentSpline: function ( t, p0, p1, p2, p3 ) {

			// To check if my formulas are correct

			var h00 = 6 * t * t - 6 * t; 	// derived from 2t^3 − 3t^2 + 1
			var h10 = 3 * t * t - 4 * t + 1; // t^3 − 2t^2 + t
			var h01 = - 6 * t * t + 6 * t; 	// − 2t3 + 3t2
			var h11 = 3 * t * t - 2 * t;	// t3 − t2

			return h00 + h10 + h01 + h11;

		},

		// Catmull-Rom

		interpolate: function( p0, p1, p2, p3, t ) {

			var v0 = ( p2 - p0 ) * 0.5;
			var v1 = ( p3 - p1 ) * 0.5;
			var t2 = t * t;
			var t3 = t * t2;
			return ( 2 * p1 - 2 * p2 + v0 + v1 ) * t3 + ( - 3 * p1 + 3 * p2 - 2 * v0 - v1 ) * t2 + v0 * t + p1;

		}

	};

	/**************************************************************
	 *	Spline curve
	 **************************************************************/

	function SplineCurve( points /* array of Vector2 */ ) {

		this.points = ( points === undefined ) ? [] : points;

	}

	SplineCurve.prototype = Object.create( Curve.prototype );
	SplineCurve.prototype.constructor = SplineCurve;

	SplineCurve.prototype.isSplineCurve = true;

	SplineCurve.prototype.getPoint = function ( t ) {

		var points = this.points;
		var point = ( points.length - 1 ) * t;

		var intPoint = Math.floor( point );
		var weight = point - intPoint;

		var point0 = points[ intPoint === 0 ? intPoint : intPoint - 1 ];
		var point1 = points[ intPoint ];
		var point2 = points[ intPoint > points.length - 2 ? points.length - 1 : intPoint + 1 ];
		var point3 = points[ intPoint > points.length - 3 ? points.length - 1 : intPoint + 2 ];

		var interpolate = CurveUtils.interpolate;

		return new Vector2(
			interpolate( point0.x, point1.x, point2.x, point3.x, weight ),
			interpolate( point0.y, point1.y, point2.y, point3.y, weight )
		);

	};

	/**************************************************************
	 *	Cubic Bezier curve
	 **************************************************************/

	function CubicBezierCurve( v0, v1, v2, v3 ) {

		this.v0 = v0;
		this.v1 = v1;
		this.v2 = v2;
		this.v3 = v3;

	}

	CubicBezierCurve.prototype = Object.create( Curve.prototype );
	CubicBezierCurve.prototype.constructor = CubicBezierCurve;

	CubicBezierCurve.prototype.getPoint = function ( t ) {

		var b3 = ShapeUtils.b3;

		return new Vector2(
			b3( t, this.v0.x, this.v1.x, this.v2.x, this.v3.x ),
			b3( t, this.v0.y, this.v1.y, this.v2.y, this.v3.y )
		);

	};

	CubicBezierCurve.prototype.getTangent = function( t ) {

		var tangentCubicBezier = CurveUtils.tangentCubicBezier;

		return new Vector2(
			tangentCubicBezier( t, this.v0.x, this.v1.x, this.v2.x, this.v3.x ),
			tangentCubicBezier( t, this.v0.y, this.v1.y, this.v2.y, this.v3.y )
		).normalize();

	};

	/**************************************************************
	 *	Quadratic Bezier curve
	 **************************************************************/


	function QuadraticBezierCurve( v0, v1, v2 ) {

		this.v0 = v0;
		this.v1 = v1;
		this.v2 = v2;

	}

	QuadraticBezierCurve.prototype = Object.create( Curve.prototype );
	QuadraticBezierCurve.prototype.constructor = QuadraticBezierCurve;


	QuadraticBezierCurve.prototype.getPoint = function ( t ) {

		var b2 = ShapeUtils.b2;

		return new Vector2(
			b2( t, this.v0.x, this.v1.x, this.v2.x ),
			b2( t, this.v0.y, this.v1.y, this.v2.y )
		);

	};


	QuadraticBezierCurve.prototype.getTangent = function( t ) {

		var tangentQuadraticBezier = CurveUtils.tangentQuadraticBezier;

		return new Vector2(
			tangentQuadraticBezier( t, this.v0.x, this.v1.x, this.v2.x ),
			tangentQuadraticBezier( t, this.v0.y, this.v1.y, this.v2.y )
		).normalize();

	};

	var PathPrototype = Object.assign( Object.create( CurvePath.prototype ), {

		fromPoints: function ( vectors ) {

			this.moveTo( vectors[ 0 ].x, vectors[ 0 ].y );

			for ( var i = 1, l = vectors.length; i < l; i ++ ) {

				this.lineTo( vectors[ i ].x, vectors[ i ].y );

			}

		},

		moveTo: function ( x, y ) {

			this.currentPoint.set( x, y ); // TODO consider referencing vectors instead of copying?

		},

		lineTo: function ( x, y ) {

			var curve = new LineCurve( this.currentPoint.clone(), new Vector2( x, y ) );
			this.curves.push( curve );

			this.currentPoint.set( x, y );

		},

		quadraticCurveTo: function ( aCPx, aCPy, aX, aY ) {

			var curve = new QuadraticBezierCurve(
				this.currentPoint.clone(),
				new Vector2( aCPx, aCPy ),
				new Vector2( aX, aY )
			);

			this.curves.push( curve );

			this.currentPoint.set( aX, aY );

		},

		bezierCurveTo: function ( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY ) {

			var curve = new CubicBezierCurve(
				this.currentPoint.clone(),
				new Vector2( aCP1x, aCP1y ),
				new Vector2( aCP2x, aCP2y ),
				new Vector2( aX, aY )
			);

			this.curves.push( curve );

			this.currentPoint.set( aX, aY );

		},

		splineThru: function ( pts /*Array of Vector*/ ) {

			var npts = [ this.currentPoint.clone() ].concat( pts );

			var curve = new SplineCurve( npts );
			this.curves.push( curve );

			this.currentPoint.copy( pts[ pts.length - 1 ] );

		},

		arc: function ( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {

			var x0 = this.currentPoint.x;
			var y0 = this.currentPoint.y;

			this.absarc( aX + x0, aY + y0, aRadius,
				aStartAngle, aEndAngle, aClockwise );

		},

		absarc: function ( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {

			this.absellipse( aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise );

		},

		ellipse: function ( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {

			var x0 = this.currentPoint.x;
			var y0 = this.currentPoint.y;

			this.absellipse( aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation );

		},

		absellipse: function ( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {

			var curve = new EllipseCurve( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation );

			if ( this.curves.length > 0 ) {

				// if a previous curve is present, attempt to join
				var firstPoint = curve.getPoint( 0 );

				if ( ! firstPoint.equals( this.currentPoint ) ) {

					this.lineTo( firstPoint.x, firstPoint.y );

				}

			}

			this.curves.push( curve );

			var lastPoint = curve.getPoint( 1 );
			this.currentPoint.copy( lastPoint );

		}

	} );

	/**
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 * Defines a 2d shape plane using paths.
	 **/

	// STEP 1 Create a path.
	// STEP 2 Turn path into shape.
	// STEP 3 ExtrudeGeometry takes in Shape/Shapes
	// STEP 3a - Extract points from each shape, turn to vertices
	// STEP 3b - Triangulate each shape, add faces.

	function Shape() {

		Path.apply( this, arguments );

		this.holes = [];

	}

	Shape.prototype = Object.assign( Object.create( PathPrototype ), {

		constructor: Shape,

		getPointsHoles: function ( divisions ) {

			var holesPts = [];

			for ( var i = 0, l = this.holes.length; i < l; i ++ ) {

				holesPts[ i ] = this.holes[ i ].getPoints( divisions );

			}

			return holesPts;

		},

		// Get points of shape and holes (keypoints based on segments parameter)

		extractAllPoints: function ( divisions ) {

			return {

				shape: this.getPoints( divisions ),
				holes: this.getPointsHoles( divisions )

			};

		},

		extractPoints: function ( divisions ) {

			return this.extractAllPoints( divisions );

		}

	} );

	/**
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 * Creates free form 2d path using series of points, lines or curves.
	 *
	 **/

	function Path( points ) {

		CurvePath.call( this );
		this.currentPoint = new Vector2();

		if ( points ) {

			this.fromPoints( points );

		}

	}

	Path.prototype = PathPrototype;
	PathPrototype.constructor = Path;


	// minimal class for proxing functions to Path. Replaces old "extractSubpaths()"
	function ShapePath() {
		this.subPaths = [];
		this.currentPath = null;
	}

	ShapePath.prototype = {
		moveTo: function ( x, y ) {
			this.currentPath = new Path();
			this.subPaths.push(this.currentPath);
			this.currentPath.moveTo( x, y );
		},
		lineTo: function ( x, y ) {
			this.currentPath.lineTo( x, y );
		},
		quadraticCurveTo: function ( aCPx, aCPy, aX, aY ) {
			this.currentPath.quadraticCurveTo( aCPx, aCPy, aX, aY );
		},
		bezierCurveTo: function ( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY ) {
			this.currentPath.bezierCurveTo( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY );
		},
		splineThru: function ( pts ) {
			this.currentPath.splineThru( pts );
		},

		toShapes: function ( isCCW, noHoles ) {

			function toShapesNoHoles( inSubpaths ) {

				var shapes = [];

				for ( var i = 0, l = inSubpaths.length; i < l; i ++ ) {

					var tmpPath = inSubpaths[ i ];

					var tmpShape = new Shape();
					tmpShape.curves = tmpPath.curves;

					shapes.push( tmpShape );

				}

				return shapes;

			}

			function isPointInsidePolygon( inPt, inPolygon ) {

				var polyLen = inPolygon.length;

				// inPt on polygon contour => immediate success    or
				// toggling of inside/outside at every single! intersection point of an edge
				//  with the horizontal line through inPt, left of inPt
				//  not counting lowerY endpoints of edges and whole edges on that line
				var inside = false;
				for ( var p = polyLen - 1, q = 0; q < polyLen; p = q ++ ) {

					var edgeLowPt  = inPolygon[ p ];
					var edgeHighPt = inPolygon[ q ];

					var edgeDx = edgeHighPt.x - edgeLowPt.x;
					var edgeDy = edgeHighPt.y - edgeLowPt.y;

					if ( Math.abs( edgeDy ) > Number.EPSILON ) {

						// not parallel
						if ( edgeDy < 0 ) {

							edgeLowPt  = inPolygon[ q ]; edgeDx = - edgeDx;
							edgeHighPt = inPolygon[ p ]; edgeDy = - edgeDy;

						}
						if ( ( inPt.y < edgeLowPt.y ) || ( inPt.y > edgeHighPt.y ) ) 		continue;

						if ( inPt.y === edgeLowPt.y ) {

							if ( inPt.x === edgeLowPt.x )		return	true;		// inPt is on contour ?
							// continue;				// no intersection or edgeLowPt => doesn't count !!!

						} else {

							var perpEdge = edgeDy * ( inPt.x - edgeLowPt.x ) - edgeDx * ( inPt.y - edgeLowPt.y );
							if ( perpEdge === 0 )				return	true;		// inPt is on contour ?
							if ( perpEdge < 0 ) 				continue;
							inside = ! inside;		// true intersection left of inPt

						}

					} else {

						// parallel or collinear
						if ( inPt.y !== edgeLowPt.y ) 		continue;			// parallel
						// edge lies on the same horizontal line as inPt
						if ( ( ( edgeHighPt.x <= inPt.x ) && ( inPt.x <= edgeLowPt.x ) ) ||
							 ( ( edgeLowPt.x <= inPt.x ) && ( inPt.x <= edgeHighPt.x ) ) )		return	true;	// inPt: Point on contour !
						// continue;

					}

				}

				return	inside;

			}

			var isClockWise = ShapeUtils.isClockWise;

			var subPaths = this.subPaths;
			if ( subPaths.length === 0 ) return [];

			if ( noHoles === true )	return	toShapesNoHoles( subPaths );


			var solid, tmpPath, tmpShape, shapes = [];

			if ( subPaths.length === 1 ) {

				tmpPath = subPaths[ 0 ];
				tmpShape = new Shape();
				tmpShape.curves = tmpPath.curves;
				shapes.push( tmpShape );
				return shapes;

			}

			var holesFirst = ! isClockWise( subPaths[ 0 ].getPoints() );
			holesFirst = isCCW ? ! holesFirst : holesFirst;

			// console.log("Holes first", holesFirst);

			var betterShapeHoles = [];
			var newShapes = [];
			var newShapeHoles = [];
			var mainIdx = 0;
			var tmpPoints;

			newShapes[ mainIdx ] = undefined;
			newShapeHoles[ mainIdx ] = [];

			for ( var i = 0, l = subPaths.length; i < l; i ++ ) {

				tmpPath = subPaths[ i ];
				tmpPoints = tmpPath.getPoints();
				solid = isClockWise( tmpPoints );
				solid = isCCW ? ! solid : solid;

				if ( solid ) {

					if ( ( ! holesFirst ) && ( newShapes[ mainIdx ] ) )	mainIdx ++;

					newShapes[ mainIdx ] = { s: new Shape(), p: tmpPoints };
					newShapes[ mainIdx ].s.curves = tmpPath.curves;

					if ( holesFirst )	mainIdx ++;
					newShapeHoles[ mainIdx ] = [];

					//console.log('cw', i);

				} else {

					newShapeHoles[ mainIdx ].push( { h: tmpPath, p: tmpPoints[ 0 ] } );

					//console.log('ccw', i);

				}

			}

			// only Holes? -> probably all Shapes with wrong orientation
			if ( ! newShapes[ 0 ] )	return	toShapesNoHoles( subPaths );


			if ( newShapes.length > 1 ) {

				var ambiguous = false;
				var toChange = [];

				for ( var sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx ++ ) {

					betterShapeHoles[ sIdx ] = [];

				}

				for ( var sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx ++ ) {

					var sho = newShapeHoles[ sIdx ];

					for ( var hIdx = 0; hIdx < sho.length; hIdx ++ ) {

						var ho = sho[ hIdx ];
						var hole_unassigned = true;

						for ( var s2Idx = 0; s2Idx < newShapes.length; s2Idx ++ ) {

							if ( isPointInsidePolygon( ho.p, newShapes[ s2Idx ].p ) ) {

								if ( sIdx !== s2Idx )	toChange.push( { froms: sIdx, tos: s2Idx, hole: hIdx } );
								if ( hole_unassigned ) {

									hole_unassigned = false;
									betterShapeHoles[ s2Idx ].push( ho );

								} else {

									ambiguous = true;

								}

							}

						}
						if ( hole_unassigned ) {

							betterShapeHoles[ sIdx ].push( ho );

						}

					}

				}
				// console.log("ambiguous: ", ambiguous);
				if ( toChange.length > 0 ) {

					// console.log("to change: ", toChange);
					if ( ! ambiguous )	newShapeHoles = betterShapeHoles;

				}

			}

			var tmpHoles;

			for ( var i = 0, il = newShapes.length; i < il; i ++ ) {

				tmpShape = newShapes[ i ].s;
				shapes.push( tmpShape );
				tmpHoles = newShapeHoles[ i ];

				for ( var j = 0, jl = tmpHoles.length; j < jl; j ++ ) {

					tmpShape.holes.push( tmpHoles[ j ].h );

				}

			}

			//console.log("shape", shapes);

			return shapes;

		}
	};

	/**
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 * @author mrdoob / http://mrdoob.com/
	 */

	function Font( data ) {

		this.data = data;

	}

	Object.assign( Font.prototype, {

		isFont: true,

		generateShapes: function ( text, size, divisions ) {

			function createPaths( text ) {

				var chars = String( text ).split( '' );
				var scale = size / data.resolution;
				var offset = 0;

				var paths = [];

				for ( var i = 0; i < chars.length; i ++ ) {

					var ret = createPath( chars[ i ], scale, offset );
					offset += ret.offset;

					paths.push( ret.path );

				}

				return paths;

			}

			function createPath( c, scale, offset ) {

				var glyph = data.glyphs[ c ] || data.glyphs[ '?' ];

				if ( ! glyph ) return;

				var path = new ShapePath();

				var pts = [], b2 = ShapeUtils.b2, b3 = ShapeUtils.b3;
				var x, y, cpx, cpy, cpx0, cpy0, cpx1, cpy1, cpx2, cpy2, laste;

				if ( glyph.o ) {

					var outline = glyph._cachedOutline || ( glyph._cachedOutline = glyph.o.split( ' ' ) );

					for ( var i = 0, l = outline.length; i < l; ) {

						var action = outline[ i ++ ];

						switch ( action ) {

							case 'm': // moveTo

								x = outline[ i ++ ] * scale + offset;
								y = outline[ i ++ ] * scale;

								path.moveTo( x, y );

								break;

							case 'l': // lineTo

								x = outline[ i ++ ] * scale + offset;
								y = outline[ i ++ ] * scale;

								path.lineTo( x, y );

								break;

							case 'q': // quadraticCurveTo

								cpx  = outline[ i ++ ] * scale + offset;
								cpy  = outline[ i ++ ] * scale;
								cpx1 = outline[ i ++ ] * scale + offset;
								cpy1 = outline[ i ++ ] * scale;

								path.quadraticCurveTo( cpx1, cpy1, cpx, cpy );

								laste = pts[ pts.length - 1 ];

								if ( laste ) {

									cpx0 = laste.x;
									cpy0 = laste.y;

									for ( var i2 = 1; i2 <= divisions; i2 ++ ) {

										var t = i2 / divisions;
										b2( t, cpx0, cpx1, cpx );
										b2( t, cpy0, cpy1, cpy );

									}

								}

								break;

							case 'b': // bezierCurveTo

								cpx  = outline[ i ++ ] * scale + offset;
								cpy  = outline[ i ++ ] * scale;
								cpx1 = outline[ i ++ ] * scale + offset;
								cpy1 = outline[ i ++ ] * scale;
								cpx2 = outline[ i ++ ] * scale + offset;
								cpy2 = outline[ i ++ ] * scale;

								path.bezierCurveTo( cpx1, cpy1, cpx2, cpy2, cpx, cpy );

								laste = pts[ pts.length - 1 ];

								if ( laste ) {

									cpx0 = laste.x;
									cpy0 = laste.y;

									for ( var i2 = 1; i2 <= divisions; i2 ++ ) {

										var t = i2 / divisions;
										b3( t, cpx0, cpx1, cpx2, cpx );
										b3( t, cpy0, cpy1, cpy2, cpy );

									}

								}

								break;

						}

					}

				}

				return { offset: glyph.ha * scale, path: path };

			}

			//

			if ( size === undefined ) size = 100;
			if ( divisions === undefined ) divisions = 4;

			var data = this.data;

			var paths = createPaths( text );
			var shapes = [];

			for ( var p = 0, pl = paths.length; p < pl; p ++ ) {

				Array.prototype.push.apply( shapes, paths[ p ].toShapes() );

			}

			return shapes;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function FontLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

	}

	Object.assign( FontLoader.prototype, {

		load: function ( url, onLoad, onProgress, onError ) {

			var scope = this;

			var loader = new FileLoader( this.manager );
			loader.load( url, function ( text ) {

				var json;

				try {

					json = JSON.parse( text );

				} catch ( e ) {

					console.warn( 'THREE.FontLoader: typeface.js support is being deprecated. Use typeface.json instead.' );
					json = JSON.parse( text.substring( 65, text.length - 2 ) );

				}

				var font = scope.parse( json );

				if ( onLoad ) onLoad( font );

			}, onProgress, onError );

		},

		parse: function ( json ) {

			return new Font( json );

		}

	} );

	var context;

	var AudioContext = {

		getContext: function () {

			if ( context === undefined ) {

				context = new ( window.AudioContext || window.webkitAudioContext )();

			}

			return context;

		},

		setContext: function ( value ) {

			context = value;

		}

	};

	/**
	 * @author Reece Aaron Lecrivain / http://reecenotes.com/
	 */

	function AudioLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

	}

	Object.assign( AudioLoader.prototype, {

		load: function ( url, onLoad, onProgress, onError ) {

			var loader = new FileLoader( this.manager );
			loader.setResponseType( 'arraybuffer' );
			loader.load( url, function ( buffer ) {

				var context = AudioContext.getContext();

				context.decodeAudioData( buffer, function ( audioBuffer ) {

					onLoad( audioBuffer );

				} );

			}, onProgress, onError );

		}

	} );

	/**
	 * @author abelnation / http://github.com/abelnation
	 */

	function RectAreaLight ( color, intensity, width, height ) {

		Light.call( this, color, intensity );

		this.type = 'RectAreaLight';

		this.position.set( 0, 1, 0 );
		this.updateMatrix();

		this.width = ( width !== undefined ) ? width : 10;
		this.height = ( height !== undefined ) ? height : 10;

		// TODO (abelnation): distance/decay

		// TODO (abelnation): update method for RectAreaLight to update transform to lookat target

		// TODO (abelnation): shadows
		// this.shadow = new THREE.RectAreaLightShadow( new THREE.PerspectiveCamera( 90, 1, 0.5, 500 ) );

	}

	// TODO (abelnation): RectAreaLight update when light shape is changed
	RectAreaLight.prototype = Object.assign( Object.create( Light.prototype ), {

		constructor: RectAreaLight,

		isRectAreaLight: true,

		copy: function ( source ) {

			Light.prototype.copy.call( this, source );

			this.width = source.width;
			this.height = source.height;

			// this.shadow = source.shadow.clone();

			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function StereoCamera() {

		this.type = 'StereoCamera';

		this.aspect = 1;

		this.eyeSep = 0.064;

		this.cameraL = new PerspectiveCamera();
		this.cameraL.layers.enable( 1 );
		this.cameraL.matrixAutoUpdate = false;

		this.cameraR = new PerspectiveCamera();
		this.cameraR.layers.enable( 2 );
		this.cameraR.matrixAutoUpdate = false;

	}

	Object.assign( StereoCamera.prototype, {

		update: ( function () {

			var instance, focus, fov, aspect, near, far, zoom;

			var eyeRight = new Matrix4();
			var eyeLeft = new Matrix4();

			return function update( camera ) {

				var needsUpdate = instance !== this || focus !== camera.focus || fov !== camera.fov ||
													aspect !== camera.aspect * this.aspect || near !== camera.near ||
													far !== camera.far || zoom !== camera.zoom;

				if ( needsUpdate ) {

					instance = this;
					focus = camera.focus;
					fov = camera.fov;
					aspect = camera.aspect * this.aspect;
					near = camera.near;
					far = camera.far;
					zoom = camera.zoom;

					// Off-axis stereoscopic effect based on
					// http://paulbourke.net/stereographics/stereorender/

					var projectionMatrix = camera.projectionMatrix.clone();
					var eyeSep = this.eyeSep / 2;
					var eyeSepOnProjection = eyeSep * near / focus;
					var ymax = ( near * Math.tan( _Math.DEG2RAD * fov * 0.5 ) ) / zoom;
					var xmin, xmax;

					// translate xOffset

					eyeLeft.elements[ 12 ] = - eyeSep;
					eyeRight.elements[ 12 ] = eyeSep;

					// for left eye

					xmin = - ymax * aspect + eyeSepOnProjection;
					xmax = ymax * aspect + eyeSepOnProjection;

					projectionMatrix.elements[ 0 ] = 2 * near / ( xmax - xmin );
					projectionMatrix.elements[ 8 ] = ( xmax + xmin ) / ( xmax - xmin );

					this.cameraL.projectionMatrix.copy( projectionMatrix );

					// for right eye

					xmin = - ymax * aspect - eyeSepOnProjection;
					xmax = ymax * aspect - eyeSepOnProjection;

					projectionMatrix.elements[ 0 ] = 2 * near / ( xmax - xmin );
					projectionMatrix.elements[ 8 ] = ( xmax + xmin ) / ( xmax - xmin );

					this.cameraR.projectionMatrix.copy( projectionMatrix );

				}

				this.cameraL.matrixWorld.copy( camera.matrixWorld ).multiply( eyeLeft );
				this.cameraR.matrixWorld.copy( camera.matrixWorld ).multiply( eyeRight );

			};

		} )()

	} );

	/**
	 * Camera for rendering cube maps
	 *	- renders scene into axis-aligned cube
	 *
	 * @author alteredq / http://alteredqualia.com/
	 */

	function CubeCamera( near, far, cubeResolution ) {

		Object3D.call( this );

		this.type = 'CubeCamera';

		var fov = 90, aspect = 1;

		var cameraPX = new PerspectiveCamera( fov, aspect, near, far );
		cameraPX.up.set( 0, - 1, 0 );
		cameraPX.lookAt( new Vector3( 1, 0, 0 ) );
		this.add( cameraPX );

		var cameraNX = new PerspectiveCamera( fov, aspect, near, far );
		cameraNX.up.set( 0, - 1, 0 );
		cameraNX.lookAt( new Vector3( - 1, 0, 0 ) );
		this.add( cameraNX );

		var cameraPY = new PerspectiveCamera( fov, aspect, near, far );
		cameraPY.up.set( 0, 0, 1 );
		cameraPY.lookAt( new Vector3( 0, 1, 0 ) );
		this.add( cameraPY );

		var cameraNY = new PerspectiveCamera( fov, aspect, near, far );
		cameraNY.up.set( 0, 0, - 1 );
		cameraNY.lookAt( new Vector3( 0, - 1, 0 ) );
		this.add( cameraNY );

		var cameraPZ = new PerspectiveCamera( fov, aspect, near, far );
		cameraPZ.up.set( 0, - 1, 0 );
		cameraPZ.lookAt( new Vector3( 0, 0, 1 ) );
		this.add( cameraPZ );

		var cameraNZ = new PerspectiveCamera( fov, aspect, near, far );
		cameraNZ.up.set( 0, - 1, 0 );
		cameraNZ.lookAt( new Vector3( 0, 0, - 1 ) );
		this.add( cameraNZ );

		var options = { format: RGBFormat, magFilter: LinearFilter, minFilter: LinearFilter };

		this.renderTarget = new WebGLRenderTargetCube( cubeResolution, cubeResolution, options );

		this.updateCubeMap = function ( renderer, scene ) {

			if ( this.parent === null ) this.updateMatrixWorld();

			var renderTarget = this.renderTarget;
			var generateMipmaps = renderTarget.texture.generateMipmaps;

			renderTarget.texture.generateMipmaps = false;

			renderTarget.activeCubeFace = 0;
			renderer.render( scene, cameraPX, renderTarget );

			renderTarget.activeCubeFace = 1;
			renderer.render( scene, cameraNX, renderTarget );

			renderTarget.activeCubeFace = 2;
			renderer.render( scene, cameraPY, renderTarget );

			renderTarget.activeCubeFace = 3;
			renderer.render( scene, cameraNY, renderTarget );

			renderTarget.activeCubeFace = 4;
			renderer.render( scene, cameraPZ, renderTarget );

			renderTarget.texture.generateMipmaps = generateMipmaps;

			renderTarget.activeCubeFace = 5;
			renderer.render( scene, cameraNZ, renderTarget );

			renderer.setRenderTarget( null );

		};

	}

	CubeCamera.prototype = Object.create( Object3D.prototype );
	CubeCamera.prototype.constructor = CubeCamera;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function AudioListener() {

		Object3D.call( this );

		this.type = 'AudioListener';

		this.context = AudioContext.getContext();

		this.gain = this.context.createGain();
		this.gain.connect( this.context.destination );

		this.filter = null;

	}

	AudioListener.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: AudioListener,

		getInput: function () {

			return this.gain;

		},

		removeFilter: function ( ) {

			if ( this.filter !== null ) {

				this.gain.disconnect( this.filter );
				this.filter.disconnect( this.context.destination );
				this.gain.connect( this.context.destination );
				this.filter = null;

			}

		},

		getFilter: function () {

			return this.filter;

		},

		setFilter: function ( value ) {

			if ( this.filter !== null ) {

				this.gain.disconnect( this.filter );
				this.filter.disconnect( this.context.destination );

			} else {

				this.gain.disconnect( this.context.destination );

			}

			this.filter = value;
			this.gain.connect( this.filter );
			this.filter.connect( this.context.destination );

		},

		getMasterVolume: function () {

			return this.gain.gain.value;

		},

		setMasterVolume: function ( value ) {

			this.gain.gain.value = value;

		},

		updateMatrixWorld: ( function () {

			var position = new Vector3();
			var quaternion = new Quaternion();
			var scale = new Vector3();

			var orientation = new Vector3();

			return function updateMatrixWorld( force ) {

				Object3D.prototype.updateMatrixWorld.call( this, force );

				var listener = this.context.listener;
				var up = this.up;

				this.matrixWorld.decompose( position, quaternion, scale );

				orientation.set( 0, 0, - 1 ).applyQuaternion( quaternion );

				if ( listener.positionX ) {

					listener.positionX.setValueAtTime( position.x, this.context.currentTime );
					listener.positionY.setValueAtTime( position.y, this.context.currentTime );
					listener.positionZ.setValueAtTime( position.z, this.context.currentTime );
					listener.forwardX.setValueAtTime( orientation.x, this.context.currentTime );
					listener.forwardY.setValueAtTime( orientation.y, this.context.currentTime );
					listener.forwardZ.setValueAtTime( orientation.z, this.context.currentTime );
					listener.upX.setValueAtTime( up.x, this.context.currentTime );
					listener.upY.setValueAtTime( up.y, this.context.currentTime );
					listener.upZ.setValueAtTime( up.z, this.context.currentTime );

				} else {

					listener.setPosition( position.x, position.y, position.z );
					listener.setOrientation( orientation.x, orientation.y, orientation.z, up.x, up.y, up.z );

				}

			};

		} )()

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author Reece Aaron Lecrivain / http://reecenotes.com/
	 */

	function Audio( listener ) {

		Object3D.call( this );

		this.type = 'Audio';

		this.context = listener.context;

		this.gain = this.context.createGain();
		this.gain.connect( listener.getInput() );

		this.autoplay = false;

		this.buffer = null;
		this.loop = false;
		this.startTime = 0;
		this.playbackRate = 1;
		this.isPlaying = false;
		this.hasPlaybackControl = true;
		this.sourceType = 'empty';

		this.filters = [];

	}

	Audio.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: Audio,

		getOutput: function () {

			return this.gain;

		},

		setNodeSource: function ( audioNode ) {

			this.hasPlaybackControl = false;
			this.sourceType = 'audioNode';
			this.source = audioNode;
			this.connect();

			return this;

		},

		setBuffer: function ( audioBuffer ) {

			this.buffer = audioBuffer;
			this.sourceType = 'buffer';

			if ( this.autoplay ) this.play();

			return this;

		},

		play: function () {

			if ( this.isPlaying === true ) {

				console.warn( 'THREE.Audio: Audio is already playing.' );
				return;

			}

			if ( this.hasPlaybackControl === false ) {

				console.warn( 'THREE.Audio: this Audio has no playback control.' );
				return;

			}

			var source = this.context.createBufferSource();

			source.buffer = this.buffer;
			source.loop = this.loop;
			source.onended = this.onEnded.bind( this );
			source.playbackRate.setValueAtTime( this.playbackRate, this.startTime );
			source.start( 0, this.startTime );

			this.isPlaying = true;

			this.source = source;

			return this.connect();

		},

		pause: function () {

			if ( this.hasPlaybackControl === false ) {

				console.warn( 'THREE.Audio: this Audio has no playback control.' );
				return;

			}

			this.source.stop();
			this.startTime = this.context.currentTime;
			this.isPlaying = false;

			return this;

		},

		stop: function () {

			if ( this.hasPlaybackControl === false ) {

				console.warn( 'THREE.Audio: this Audio has no playback control.' );
				return;

			}

			this.source.stop();
			this.startTime = 0;
			this.isPlaying = false;

			return this;

		},

		connect: function () {

			if ( this.filters.length > 0 ) {

				this.source.connect( this.filters[ 0 ] );

				for ( var i = 1, l = this.filters.length; i < l; i ++ ) {

					this.filters[ i - 1 ].connect( this.filters[ i ] );

				}

				this.filters[ this.filters.length - 1 ].connect( this.getOutput() );

			} else {

				this.source.connect( this.getOutput() );

			}

			return this;

		},

		disconnect: function () {

			if ( this.filters.length > 0 ) {

				this.source.disconnect( this.filters[ 0 ] );

				for ( var i = 1, l = this.filters.length; i < l; i ++ ) {

					this.filters[ i - 1 ].disconnect( this.filters[ i ] );

				}

				this.filters[ this.filters.length - 1 ].disconnect( this.getOutput() );

			} else {

				this.source.disconnect( this.getOutput() );

			}

			return this;

		},

		getFilters: function () {

			return this.filters;

		},

		setFilters: function ( value ) {

			if ( ! value ) value = [];

			if ( this.isPlaying === true ) {

				this.disconnect();
				this.filters = value;
				this.connect();

			} else {

				this.filters = value;

			}

			return this;

		},

		getFilter: function () {

			return this.getFilters()[ 0 ];

		},

		setFilter: function ( filter ) {

			return this.setFilters( filter ? [ filter ] : [] );

		},

		setPlaybackRate: function ( value ) {

			if ( this.hasPlaybackControl === false ) {

				console.warn( 'THREE.Audio: this Audio has no playback control.' );
				return;

			}

			this.playbackRate = value;

			if ( this.isPlaying === true ) {

				this.source.playbackRate.setValueAtTime( this.playbackRate, this.context.currentTime );

			}

			return this;

		},

		getPlaybackRate: function () {

			return this.playbackRate;

		},

		onEnded: function () {

			this.isPlaying = false;

		},

		getLoop: function () {

			if ( this.hasPlaybackControl === false ) {

				console.warn( 'THREE.Audio: this Audio has no playback control.' );
				return false;

			}

			return this.loop;

		},

		setLoop: function ( value ) {

			if ( this.hasPlaybackControl === false ) {

				console.warn( 'THREE.Audio: this Audio has no playback control.' );
				return;

			}

			this.loop = value;

			if ( this.isPlaying === true ) {

				this.source.loop = this.loop;

			}

			return this;

		},

		getVolume: function () {

			return this.gain.gain.value;

		},


		setVolume: function ( value ) {

			this.gain.gain.value = value;

			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function PositionalAudio( listener ) {

		Audio.call( this, listener );

		this.panner = this.context.createPanner();
		this.panner.connect( this.gain );

	}

	PositionalAudio.prototype = Object.assign( Object.create( Audio.prototype ), {

		constructor: PositionalAudio,

		getOutput: function () {

			return this.panner;

		},

		getRefDistance: function () {

			return this.panner.refDistance;

		},

		setRefDistance: function ( value ) {

			this.panner.refDistance = value;

		},

		getRolloffFactor: function () {

			return this.panner.rolloffFactor;

		},

		setRolloffFactor: function ( value ) {

			this.panner.rolloffFactor = value;

		},

		getDistanceModel: function () {

			return this.panner.distanceModel;

		},

		setDistanceModel: function ( value ) {

			this.panner.distanceModel = value;

		},

		getMaxDistance: function () {

			return this.panner.maxDistance;

		},

		setMaxDistance: function ( value ) {

			this.panner.maxDistance = value;

		},

		updateMatrixWorld: ( function () {

			var position = new Vector3();

			return function updateMatrixWorld( force ) {

				Object3D.prototype.updateMatrixWorld.call( this, force );

				position.setFromMatrixPosition( this.matrixWorld );

				this.panner.setPosition( position.x, position.y, position.z );

			};

		} )()


	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function AudioAnalyser( audio, fftSize ) {

		this.analyser = audio.context.createAnalyser();
		this.analyser.fftSize = fftSize !== undefined ? fftSize : 2048;

		this.data = new Uint8Array( this.analyser.frequencyBinCount );

		audio.getOutput().connect( this.analyser );

	}

	Object.assign( AudioAnalyser.prototype, {

		getFrequencyData: function () {

			this.analyser.getByteFrequencyData( this.data );

			return this.data;

		},

		getAverageFrequency: function () {

			var value = 0, data = this.getFrequencyData();

			for ( var i = 0; i < data.length; i ++ ) {

				value += data[ i ];

			}

			return value / data.length;

		}

	} );

	/**
	 *
	 * Buffered scene graph property that allows weighted accumulation.
	 *
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 */

	function PropertyMixer( binding, typeName, valueSize ) {

		this.binding = binding;
		this.valueSize = valueSize;

		var bufferType = Float64Array,
			mixFunction;

		switch ( typeName ) {

			case 'quaternion':
				mixFunction = this._slerp;
				break;

			case 'string':
			case 'bool':
				bufferType = Array;
				mixFunction = this._select;
				break;

			default:
				mixFunction = this._lerp;

		}

		this.buffer = new bufferType( valueSize * 4 );
		// layout: [ incoming | accu0 | accu1 | orig ]
		//
		// interpolators can use .buffer as their .result
		// the data then goes to 'incoming'
		//
		// 'accu0' and 'accu1' are used frame-interleaved for
		// the cumulative result and are compared to detect
		// changes
		//
		// 'orig' stores the original state of the property

		this._mixBufferRegion = mixFunction;

		this.cumulativeWeight = 0;

		this.useCount = 0;
		this.referenceCount = 0;

	}

	PropertyMixer.prototype = {

		constructor: PropertyMixer,

		// accumulate data in the 'incoming' region into 'accu<i>'
		accumulate: function( accuIndex, weight ) {

			// note: happily accumulating nothing when weight = 0, the caller knows
			// the weight and shouldn't have made the call in the first place

			var buffer = this.buffer,
				stride = this.valueSize,
				offset = accuIndex * stride + stride,

				currentWeight = this.cumulativeWeight;

			if ( currentWeight === 0 ) {

				// accuN := incoming * weight

				for ( var i = 0; i !== stride; ++ i ) {

					buffer[ offset + i ] = buffer[ i ];

				}

				currentWeight = weight;

			} else {

				// accuN := accuN + incoming * weight

				currentWeight += weight;
				var mix = weight / currentWeight;
				this._mixBufferRegion( buffer, offset, 0, mix, stride );

			}

			this.cumulativeWeight = currentWeight;

		},

		// apply the state of 'accu<i>' to the binding when accus differ
		apply: function( accuIndex ) {

			var stride = this.valueSize,
				buffer = this.buffer,
				offset = accuIndex * stride + stride,

				weight = this.cumulativeWeight,

				binding = this.binding;

			this.cumulativeWeight = 0;

			if ( weight < 1 ) {

				// accuN := accuN + original * ( 1 - cumulativeWeight )

				var originalValueOffset = stride * 3;

				this._mixBufferRegion(
						buffer, offset, originalValueOffset, 1 - weight, stride );

			}

			for ( var i = stride, e = stride + stride; i !== e; ++ i ) {

				if ( buffer[ i ] !== buffer[ i + stride ] ) {

					// value has changed -> update scene graph

					binding.setValue( buffer, offset );
					break;

				}

			}

		},

		// remember the state of the bound property and copy it to both accus
		saveOriginalState: function() {

			var binding = this.binding;

			var buffer = this.buffer,
				stride = this.valueSize,

				originalValueOffset = stride * 3;

			binding.getValue( buffer, originalValueOffset );

			// accu[0..1] := orig -- initially detect changes against the original
			for ( var i = stride, e = originalValueOffset; i !== e; ++ i ) {

				buffer[ i ] = buffer[ originalValueOffset + ( i % stride ) ];

			}

			this.cumulativeWeight = 0;

		},

		// apply the state previously taken via 'saveOriginalState' to the binding
		restoreOriginalState: function() {

			var originalValueOffset = this.valueSize * 3;
			this.binding.setValue( this.buffer, originalValueOffset );

		},


		// mix functions

		_select: function( buffer, dstOffset, srcOffset, t, stride ) {

			if ( t >= 0.5 ) {

				for ( var i = 0; i !== stride; ++ i ) {

					buffer[ dstOffset + i ] = buffer[ srcOffset + i ];

				}

			}

		},

		_slerp: function( buffer, dstOffset, srcOffset, t, stride ) {

			Quaternion.slerpFlat( buffer, dstOffset,
					buffer, dstOffset, buffer, srcOffset, t );

		},

		_lerp: function( buffer, dstOffset, srcOffset, t, stride ) {

			var s = 1 - t;

			for ( var i = 0; i !== stride; ++ i ) {

				var j = dstOffset + i;

				buffer[ j ] = buffer[ j ] * s + buffer[ srcOffset + i ] * t;

			}

		}

	};

	/**
	 *
	 * A reference to a real property in the scene graph.
	 *
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 */

	function PropertyBinding( rootNode, path, parsedPath ) {

		this.path = path;
		this.parsedPath = parsedPath ||
				PropertyBinding.parseTrackName( path );

		this.node = PropertyBinding.findNode(
				rootNode, this.parsedPath.nodeName ) || rootNode;

		this.rootNode = rootNode;

	}

	PropertyBinding.prototype = {

		constructor: PropertyBinding,

		getValue: function getValue_unbound( targetArray, offset ) {

			this.bind();
			this.getValue( targetArray, offset );

			// Note: This class uses a State pattern on a per-method basis:
			// 'bind' sets 'this.getValue' / 'setValue' and shadows the
			// prototype version of these methods with one that represents
			// the bound state. When the property is not found, the methods
			// become no-ops.

		},

		setValue: function getValue_unbound( sourceArray, offset ) {

			this.bind();
			this.setValue( sourceArray, offset );

		},

		// create getter / setter pair for a property in the scene graph
		bind: function() {

			var targetObject = this.node,
				parsedPath = this.parsedPath,

				objectName = parsedPath.objectName,
				propertyName = parsedPath.propertyName,
				propertyIndex = parsedPath.propertyIndex;

			if ( ! targetObject ) {

				targetObject = PropertyBinding.findNode(
						this.rootNode, parsedPath.nodeName ) || this.rootNode;

				this.node = targetObject;

			}

			// set fail state so we can just 'return' on error
			this.getValue = this._getValue_unavailable;
			this.setValue = this._setValue_unavailable;

	 		// ensure there is a value node
			if ( ! targetObject ) {

				console.error( "  trying to update node for track: " + this.path + " but it wasn't found." );
				return;

			}

			if ( objectName ) {

				var objectIndex = parsedPath.objectIndex;

				// special cases were we need to reach deeper into the hierarchy to get the face materials....
				switch ( objectName ) {

					case 'materials':

						if ( ! targetObject.material ) {

							console.error( '  can not bind to material as node does not have a material', this );
							return;

						}

						if ( ! targetObject.material.materials ) {

							console.error( '  can not bind to material.materials as node.material does not have a materials array', this );
							return;

						}

						targetObject = targetObject.material.materials;

						break;

					case 'bones':

						if ( ! targetObject.skeleton ) {

							console.error( '  can not bind to bones as node does not have a skeleton', this );
							return;

						}

						// potential future optimization: skip this if propertyIndex is already an integer
						// and convert the integer string to a true integer.

						targetObject = targetObject.skeleton.bones;

						// support resolving morphTarget names into indices.
						for ( var i = 0; i < targetObject.length; i ++ ) {

							if ( targetObject[ i ].name === objectIndex ) {

								objectIndex = i;
								break;

							}

						}

						break;

					default:

						if ( targetObject[ objectName ] === undefined ) {

							console.error( '  can not bind to objectName of node, undefined', this );
							return;

						}

						targetObject = targetObject[ objectName ];

				}


				if ( objectIndex !== undefined ) {

					if ( targetObject[ objectIndex ] === undefined ) {

						console.error( "  trying to bind to objectIndex of objectName, but is undefined:", this, targetObject );
						return;

					}

					targetObject = targetObject[ objectIndex ];

				}

			}

			// resolve property
			var nodeProperty = targetObject[ propertyName ];

			if ( nodeProperty === undefined ) {

				var nodeName = parsedPath.nodeName;

				console.error( "  trying to update property for track: " + nodeName +
						'.' + propertyName + " but it wasn't found.", targetObject );
				return;

			}

			// determine versioning scheme
			var versioning = this.Versioning.None;

			if ( targetObject.needsUpdate !== undefined ) { // material

				versioning = this.Versioning.NeedsUpdate;
				this.targetObject = targetObject;

			} else if ( targetObject.matrixWorldNeedsUpdate !== undefined ) { // node transform

				versioning = this.Versioning.MatrixWorldNeedsUpdate;
				this.targetObject = targetObject;

			}

			// determine how the property gets bound
			var bindingType = this.BindingType.Direct;

			if ( propertyIndex !== undefined ) {
				// access a sub element of the property array (only primitives are supported right now)

				if ( propertyName === "morphTargetInfluences" ) {
					// potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.

					// support resolving morphTarget names into indices.
					if ( ! targetObject.geometry ) {

						console.error( '  can not bind to morphTargetInfluences becasuse node does not have a geometry', this );
						return;

					}

					if ( ! targetObject.geometry.morphTargets ) {

						console.error( '  can not bind to morphTargetInfluences becasuse node does not have a geometry.morphTargets', this );
						return;

					}

					for ( var i = 0; i < this.node.geometry.morphTargets.length; i ++ ) {

						if ( targetObject.geometry.morphTargets[ i ].name === propertyIndex ) {

							propertyIndex = i;
							break;

						}

					}

				}

				bindingType = this.BindingType.ArrayElement;

				this.resolvedProperty = nodeProperty;
				this.propertyIndex = propertyIndex;

			} else if ( nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined ) {
				// must use copy for Object3D.Euler/Quaternion

				bindingType = this.BindingType.HasFromToArray;

				this.resolvedProperty = nodeProperty;

			} else if ( nodeProperty.length !== undefined ) {

				bindingType = this.BindingType.EntireArray;

				this.resolvedProperty = nodeProperty;

			} else {

				this.propertyName = propertyName;

			}

			// select getter / setter
			this.getValue = this.GetterByBindingType[ bindingType ];
			this.setValue = this.SetterByBindingTypeAndVersioning[ bindingType ][ versioning ];

		},

		unbind: function() {

			this.node = null;

			// back to the prototype version of getValue / setValue
			// note: avoiding to mutate the shape of 'this' via 'delete'
			this.getValue = this._getValue_unbound;
			this.setValue = this._setValue_unbound;

		}

	};

	Object.assign( PropertyBinding.prototype, { // prototype, continued

		// these are used to "bind" a nonexistent property
		_getValue_unavailable: function() {},
		_setValue_unavailable: function() {},

		// initial state of these methods that calls 'bind'
		_getValue_unbound: PropertyBinding.prototype.getValue,
		_setValue_unbound: PropertyBinding.prototype.setValue,

		BindingType: {
			Direct: 0,
			EntireArray: 1,
			ArrayElement: 2,
			HasFromToArray: 3
		},

		Versioning: {
			None: 0,
			NeedsUpdate: 1,
			MatrixWorldNeedsUpdate: 2
		},

		GetterByBindingType: [

			function getValue_direct( buffer, offset ) {

				buffer[ offset ] = this.node[ this.propertyName ];

			},

			function getValue_array( buffer, offset ) {

				var source = this.resolvedProperty;

				for ( var i = 0, n = source.length; i !== n; ++ i ) {

					buffer[ offset ++ ] = source[ i ];

				}

			},

			function getValue_arrayElement( buffer, offset ) {

				buffer[ offset ] = this.resolvedProperty[ this.propertyIndex ];

			},

			function getValue_toArray( buffer, offset ) {

				this.resolvedProperty.toArray( buffer, offset );

			}

		],

		SetterByBindingTypeAndVersioning: [

			[
				// Direct

				function setValue_direct( buffer, offset ) {

					this.node[ this.propertyName ] = buffer[ offset ];

				},

				function setValue_direct_setNeedsUpdate( buffer, offset ) {

					this.node[ this.propertyName ] = buffer[ offset ];
					this.targetObject.needsUpdate = true;

				},

				function setValue_direct_setMatrixWorldNeedsUpdate( buffer, offset ) {

					this.node[ this.propertyName ] = buffer[ offset ];
					this.targetObject.matrixWorldNeedsUpdate = true;

				}

			], [

				// EntireArray

				function setValue_array( buffer, offset ) {

					var dest = this.resolvedProperty;

					for ( var i = 0, n = dest.length; i !== n; ++ i ) {

						dest[ i ] = buffer[ offset ++ ];

					}

				},

				function setValue_array_setNeedsUpdate( buffer, offset ) {

					var dest = this.resolvedProperty;

					for ( var i = 0, n = dest.length; i !== n; ++ i ) {

						dest[ i ] = buffer[ offset ++ ];

					}

					this.targetObject.needsUpdate = true;

				},

				function setValue_array_setMatrixWorldNeedsUpdate( buffer, offset ) {

					var dest = this.resolvedProperty;

					for ( var i = 0, n = dest.length; i !== n; ++ i ) {

						dest[ i ] = buffer[ offset ++ ];

					}

					this.targetObject.matrixWorldNeedsUpdate = true;

				}

			], [

				// ArrayElement

				function setValue_arrayElement( buffer, offset ) {

					this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];

				},

				function setValue_arrayElement_setNeedsUpdate( buffer, offset ) {

					this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
					this.targetObject.needsUpdate = true;

				},

				function setValue_arrayElement_setMatrixWorldNeedsUpdate( buffer, offset ) {

					this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
					this.targetObject.matrixWorldNeedsUpdate = true;

				}

			], [

				// HasToFromArray

				function setValue_fromArray( buffer, offset ) {

					this.resolvedProperty.fromArray( buffer, offset );

				},

				function setValue_fromArray_setNeedsUpdate( buffer, offset ) {

					this.resolvedProperty.fromArray( buffer, offset );
					this.targetObject.needsUpdate = true;

				},

				function setValue_fromArray_setMatrixWorldNeedsUpdate( buffer, offset ) {

					this.resolvedProperty.fromArray( buffer, offset );
					this.targetObject.matrixWorldNeedsUpdate = true;

				}

			]

		]

	} );

	PropertyBinding.Composite =
			function( targetGroup, path, optionalParsedPath ) {

		var parsedPath = optionalParsedPath ||
				PropertyBinding.parseTrackName( path );

		this._targetGroup = targetGroup;
		this._bindings = targetGroup.subscribe_( path, parsedPath );

	};

	PropertyBinding.Composite.prototype = {

		constructor: PropertyBinding.Composite,

		getValue: function( array, offset ) {

			this.bind(); // bind all binding

			var firstValidIndex = this._targetGroup.nCachedObjects_,
				binding = this._bindings[ firstValidIndex ];

			// and only call .getValue on the first
			if ( binding !== undefined ) binding.getValue( array, offset );

		},

		setValue: function( array, offset ) {

			var bindings = this._bindings;

			for ( var i = this._targetGroup.nCachedObjects_,
					n = bindings.length; i !== n; ++ i ) {

				bindings[ i ].setValue( array, offset );

			}

		},

		bind: function() {

			var bindings = this._bindings;

			for ( var i = this._targetGroup.nCachedObjects_,
					n = bindings.length; i !== n; ++ i ) {

				bindings[ i ].bind();

			}

		},

		unbind: function() {

			var bindings = this._bindings;

			for ( var i = this._targetGroup.nCachedObjects_,
					n = bindings.length; i !== n; ++ i ) {

				bindings[ i ].unbind();

			}

		}

	};

	PropertyBinding.create = function( root, path, parsedPath ) {

		if ( ! ( root && root.isAnimationObjectGroup ) ) {

			return new PropertyBinding( root, path, parsedPath );

		} else {

			return new PropertyBinding.Composite( root, path, parsedPath );

		}

	};

	PropertyBinding.parseTrackName = function( trackName ) {

		// matches strings in the form of:
		//    nodeName.property
		//    nodeName.property[accessor]
		//    nodeName.material.property[accessor]
		//    uuid.property[accessor]
		//    uuid.objectName[objectIndex].propertyName[propertyIndex]
		//    parentName/nodeName.property
		//    parentName/parentName/nodeName.property[index]
		//    .bone[Armature.DEF_cog].position
		//    scene:helium_balloon_model:helium_balloon_model.position
		// created and tested via https://regex101.com/#javascript

		var re = /^((?:[\w-]+[\/:])*)([\w-]+)?(?:\.([\w-]+)(?:\[(.+)\])?)?\.([\w-]+)(?:\[(.+)\])?$/;
		var matches = re.exec( trackName );

		if ( ! matches ) {

			throw new Error( "cannot parse trackName at all: " + trackName );

		}

		var results = {
			// directoryName: matches[ 1 ], // (tschw) currently unused
			nodeName: matches[ 2 ], 	// allowed to be null, specified root node.
			objectName: matches[ 3 ],
			objectIndex: matches[ 4 ],
			propertyName: matches[ 5 ],
			propertyIndex: matches[ 6 ]	// allowed to be null, specifies that the whole property is set.
		};

		if ( results.propertyName === null || results.propertyName.length === 0 ) {

			throw new Error( "can not parse propertyName from trackName: " + trackName );

		}

		return results;

	};

	PropertyBinding.findNode = function( root, nodeName ) {

		if ( ! nodeName || nodeName === "" || nodeName === "root" || nodeName === "." || nodeName === -1 || nodeName === root.name || nodeName === root.uuid ) {

			return root;

		}

		// search into skeleton bones.
		if ( root.skeleton ) {

			var searchSkeleton = function( skeleton ) {

				for( var i = 0; i < skeleton.bones.length; i ++ ) {

					var bone = skeleton.bones[ i ];

					if ( bone.name === nodeName ) {

						return bone;

					}
				}

				return null;

			};

			var bone = searchSkeleton( root.skeleton );

			if ( bone ) {

				return bone;

			}
		}

		// search into node subtree.
		if ( root.children ) {

			var searchNodeSubtree = function( children ) {

				for( var i = 0; i < children.length; i ++ ) {

					var childNode = children[ i ];

					if ( childNode.name === nodeName || childNode.uuid === nodeName ) {

						return childNode;

					}

					var result = searchNodeSubtree( childNode.children );

					if ( result ) return result;

				}

				return null;

			};

			var subTreeNode = searchNodeSubtree( root.children );

			if ( subTreeNode ) {

				return subTreeNode;

			}

		}

		return null;

	};

	/**
	 *
	 * A group of objects that receives a shared animation state.
	 *
	 * Usage:
	 *
	 * 	-	Add objects you would otherwise pass as 'root' to the
	 * 		constructor or the .clipAction method of AnimationMixer.
	 *
	 * 	-	Instead pass this object as 'root'.
	 *
	 * 	-	You can also add and remove objects later when the mixer
	 * 		is running.
	 *
	 * Note:
	 *
	 *  	Objects of this class appear as one object to the mixer,
	 *  	so cache control of the individual objects must be done
	 *  	on the group.
	 *
	 * Limitation:
	 *
	 * 	- 	The animated properties must be compatible among the
	 * 		all objects in the group.
	 *
	 *  -	A single property can either be controlled through a
	 *  	target group or directly, but not both.
	 *
	 * @author tschw
	 */

	function AnimationObjectGroup( var_args ) {

		this.uuid = _Math.generateUUID();

		// cached objects followed by the active ones
		this._objects = Array.prototype.slice.call( arguments );

		this.nCachedObjects_ = 0;			// threshold
		// note: read by PropertyBinding.Composite

		var indices = {};
		this._indicesByUUID = indices;		// for bookkeeping

		for ( var i = 0, n = arguments.length; i !== n; ++ i ) {

			indices[ arguments[ i ].uuid ] = i;

		}

		this._paths = [];					// inside: string
		this._parsedPaths = [];				// inside: { we don't care, here }
		this._bindings = []; 				// inside: Array< PropertyBinding >
		this._bindingsIndicesByPath = {}; 	// inside: indices in these arrays

		var scope = this;

		this.stats = {

			objects: {
				get total() { return scope._objects.length; },
				get inUse() { return this.total - scope.nCachedObjects_;  }
			},

			get bindingsPerObject() { return scope._bindings.length; }

		};

	}

	AnimationObjectGroup.prototype = {

		constructor: AnimationObjectGroup,

		isAnimationObjectGroup: true,

		add: function( var_args ) {

			var objects = this._objects,
				nObjects = objects.length,
				nCachedObjects = this.nCachedObjects_,
				indicesByUUID = this._indicesByUUID,
				paths = this._paths,
				parsedPaths = this._parsedPaths,
				bindings = this._bindings,
				nBindings = bindings.length;

			for ( var i = 0, n = arguments.length; i !== n; ++ i ) {

				var object = arguments[ i ],
					uuid = object.uuid,
					index = indicesByUUID[ uuid ],
					knownObject = undefined;

				if ( index === undefined ) {

					// unknown object -> add it to the ACTIVE region

					index = nObjects ++;
					indicesByUUID[ uuid ] = index;
					objects.push( object );

					// accounting is done, now do the same for all bindings

					for ( var j = 0, m = nBindings; j !== m; ++ j ) {

						bindings[ j ].push(
								new PropertyBinding(
									object, paths[ j ], parsedPaths[ j ] ) );

					}

				} else if ( index < nCachedObjects ) {

					knownObject = objects[ index ];

					// move existing object to the ACTIVE region

					var firstActiveIndex = -- nCachedObjects,
						lastCachedObject = objects[ firstActiveIndex ];

					indicesByUUID[ lastCachedObject.uuid ] = index;
					objects[ index ] = lastCachedObject;

					indicesByUUID[ uuid ] = firstActiveIndex;
					objects[ firstActiveIndex ] = object;

					// accounting is done, now do the same for all bindings

					for ( var j = 0, m = nBindings; j !== m; ++ j ) {

						var bindingsForPath = bindings[ j ],
							lastCached = bindingsForPath[ firstActiveIndex ],
							binding = bindingsForPath[ index ];

						bindingsForPath[ index ] = lastCached;

						if ( binding === undefined ) {

							// since we do not bother to create new bindings
							// for objects that are cached, the binding may
							// or may not exist

							binding = new PropertyBinding(
									object, paths[ j ], parsedPaths[ j ] );

						}

						bindingsForPath[ firstActiveIndex ] = binding;

					}

				} else if ( objects[ index ] !== knownObject) {

					console.error( "Different objects with the same UUID " +
							"detected. Clean the caches or recreate your " +
							"infrastructure when reloading scenes..." );

				} // else the object is already where we want it to be

			} // for arguments

			this.nCachedObjects_ = nCachedObjects;

		},

		remove: function( var_args ) {

			var objects = this._objects,
				nCachedObjects = this.nCachedObjects_,
				indicesByUUID = this._indicesByUUID,
				bindings = this._bindings,
				nBindings = bindings.length;

			for ( var i = 0, n = arguments.length; i !== n; ++ i ) {

				var object = arguments[ i ],
					uuid = object.uuid,
					index = indicesByUUID[ uuid ];

				if ( index !== undefined && index >= nCachedObjects ) {

					// move existing object into the CACHED region

					var lastCachedIndex = nCachedObjects ++,
						firstActiveObject = objects[ lastCachedIndex ];

					indicesByUUID[ firstActiveObject.uuid ] = index;
					objects[ index ] = firstActiveObject;

					indicesByUUID[ uuid ] = lastCachedIndex;
					objects[ lastCachedIndex ] = object;

					// accounting is done, now do the same for all bindings

					for ( var j = 0, m = nBindings; j !== m; ++ j ) {

						var bindingsForPath = bindings[ j ],
							firstActive = bindingsForPath[ lastCachedIndex ],
							binding = bindingsForPath[ index ];

						bindingsForPath[ index ] = firstActive;
						bindingsForPath[ lastCachedIndex ] = binding;

					}

				}

			} // for arguments

			this.nCachedObjects_ = nCachedObjects;

		},

		// remove & forget
		uncache: function( var_args ) {

			var objects = this._objects,
				nObjects = objects.length,
				nCachedObjects = this.nCachedObjects_,
				indicesByUUID = this._indicesByUUID,
				bindings = this._bindings,
				nBindings = bindings.length;

			for ( var i = 0, n = arguments.length; i !== n; ++ i ) {

				var object = arguments[ i ],
					uuid = object.uuid,
					index = indicesByUUID[ uuid ];

				if ( index !== undefined ) {

					delete indicesByUUID[ uuid ];

					if ( index < nCachedObjects ) {

						// object is cached, shrink the CACHED region

						var firstActiveIndex = -- nCachedObjects,
							lastCachedObject = objects[ firstActiveIndex ],
							lastIndex = -- nObjects,
							lastObject = objects[ lastIndex ];

						// last cached object takes this object's place
						indicesByUUID[ lastCachedObject.uuid ] = index;
						objects[ index ] = lastCachedObject;

						// last object goes to the activated slot and pop
						indicesByUUID[ lastObject.uuid ] = firstActiveIndex;
						objects[ firstActiveIndex ] = lastObject;
						objects.pop();

						// accounting is done, now do the same for all bindings

						for ( var j = 0, m = nBindings; j !== m; ++ j ) {

							var bindingsForPath = bindings[ j ],
								lastCached = bindingsForPath[ firstActiveIndex ],
								last = bindingsForPath[ lastIndex ];

							bindingsForPath[ index ] = lastCached;
							bindingsForPath[ firstActiveIndex ] = last;
							bindingsForPath.pop();

						}

					} else {

						// object is active, just swap with the last and pop

						var lastIndex = -- nObjects,
							lastObject = objects[ lastIndex ];

						indicesByUUID[ lastObject.uuid ] = index;
						objects[ index ] = lastObject;
						objects.pop();

						// accounting is done, now do the same for all bindings

						for ( var j = 0, m = nBindings; j !== m; ++ j ) {

							var bindingsForPath = bindings[ j ];

							bindingsForPath[ index ] = bindingsForPath[ lastIndex ];
							bindingsForPath.pop();

						}

					} // cached or active

				} // if object is known

			} // for arguments

			this.nCachedObjects_ = nCachedObjects;

		},

		// Internal interface used by befriended PropertyBinding.Composite:

		subscribe_: function( path, parsedPath ) {
			// returns an array of bindings for the given path that is changed
			// according to the contained objects in the group

			var indicesByPath = this._bindingsIndicesByPath,
				index = indicesByPath[ path ],
				bindings = this._bindings;

			if ( index !== undefined ) return bindings[ index ];

			var paths = this._paths,
				parsedPaths = this._parsedPaths,
				objects = this._objects,
				nObjects = objects.length,
				nCachedObjects = this.nCachedObjects_,
				bindingsForPath = new Array( nObjects );

			index = bindings.length;

			indicesByPath[ path ] = index;

			paths.push( path );
			parsedPaths.push( parsedPath );
			bindings.push( bindingsForPath );

			for ( var i = nCachedObjects,
					n = objects.length; i !== n; ++ i ) {

				var object = objects[ i ];

				bindingsForPath[ i ] =
						new PropertyBinding( object, path, parsedPath );

			}

			return bindingsForPath;

		},

		unsubscribe_: function( path ) {
			// tells the group to forget about a property path and no longer
			// update the array previously obtained with 'subscribe_'

			var indicesByPath = this._bindingsIndicesByPath,
				index = indicesByPath[ path ];

			if ( index !== undefined ) {

				var paths = this._paths,
					parsedPaths = this._parsedPaths,
					bindings = this._bindings,
					lastBindingsIndex = bindings.length - 1,
					lastBindings = bindings[ lastBindingsIndex ],
					lastBindingsPath = path[ lastBindingsIndex ];

				indicesByPath[ lastBindingsPath ] = index;

				bindings[ index ] = lastBindings;
				bindings.pop();

				parsedPaths[ index ] = parsedPaths[ lastBindingsIndex ];
				parsedPaths.pop();

				paths[ index ] = paths[ lastBindingsIndex ];
				paths.pop();

			}

		}

	};

	/**
	 *
	 * Action provided by AnimationMixer for scheduling clip playback on specific
	 * objects.
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 *
	 */

	function AnimationAction( mixer, clip, localRoot ) {

		this._mixer = mixer;
		this._clip = clip;
		this._localRoot = localRoot || null;

		var tracks = clip.tracks,
			nTracks = tracks.length,
			interpolants = new Array( nTracks );

		var interpolantSettings = {
				endingStart: 	ZeroCurvatureEnding,
				endingEnd:		ZeroCurvatureEnding
		};

		for ( var i = 0; i !== nTracks; ++ i ) {

			var interpolant = tracks[ i ].createInterpolant( null );
			interpolants[ i ] = interpolant;
			interpolant.settings = interpolantSettings;

		}

		this._interpolantSettings = interpolantSettings;

		this._interpolants = interpolants;	// bound by the mixer

		// inside: PropertyMixer (managed by the mixer)
		this._propertyBindings = new Array( nTracks );

		this._cacheIndex = null;			// for the memory manager
		this._byClipCacheIndex = null;		// for the memory manager

		this._timeScaleInterpolant = null;
		this._weightInterpolant = null;

		this.loop = LoopRepeat;
		this._loopCount = -1;

		// global mixer time when the action is to be started
		// it's set back to 'null' upon start of the action
		this._startTime = null;

		// scaled local time of the action
		// gets clamped or wrapped to 0..clip.duration according to loop
		this.time = 0;

		this.timeScale = 1;
		this._effectiveTimeScale = 1;

		this.weight = 1;
		this._effectiveWeight = 1;

		this.repetitions = Infinity; 		// no. of repetitions when looping

		this.paused = false;				// false -> zero effective time scale
		this.enabled = true;				// true -> zero effective weight

		this.clampWhenFinished 	= false;	// keep feeding the last frame?

		this.zeroSlopeAtStart 	= true;		// for smooth interpolation w/o separate
		this.zeroSlopeAtEnd		= true;		// clips for start, loop and end

	}

	AnimationAction.prototype = {

		constructor: AnimationAction,

		// State & Scheduling

		play: function() {

			this._mixer._activateAction( this );

			return this;

		},

		stop: function() {

			this._mixer._deactivateAction( this );

			return this.reset();

		},

		reset: function() {

			this.paused = false;
			this.enabled = true;

			this.time = 0;			// restart clip
			this._loopCount = -1;	// forget previous loops
			this._startTime = null;	// forget scheduling

			return this.stopFading().stopWarping();

		},

		isRunning: function() {

			return this.enabled && ! this.paused && this.timeScale !== 0 &&
					this._startTime === null && this._mixer._isActiveAction( this );

		},

		// return true when play has been called
		isScheduled: function() {

			return this._mixer._isActiveAction( this );

		},

		startAt: function( time ) {

			this._startTime = time;

			return this;

		},

		setLoop: function( mode, repetitions ) {

			this.loop = mode;
			this.repetitions = repetitions;

			return this;

		},

		// Weight

		// set the weight stopping any scheduled fading
		// although .enabled = false yields an effective weight of zero, this
		// method does *not* change .enabled, because it would be confusing
		setEffectiveWeight: function( weight ) {

			this.weight = weight;

			// note: same logic as when updated at runtime
			this._effectiveWeight = this.enabled ? weight : 0;

			return this.stopFading();

		},

		// return the weight considering fading and .enabled
		getEffectiveWeight: function() {

			return this._effectiveWeight;

		},

		fadeIn: function( duration ) {

			return this._scheduleFading( duration, 0, 1 );

		},

		fadeOut: function( duration ) {

			return this._scheduleFading( duration, 1, 0 );

		},

		crossFadeFrom: function( fadeOutAction, duration, warp ) {

			fadeOutAction.fadeOut( duration );
			this.fadeIn( duration );

			if( warp ) {

				var fadeInDuration = this._clip.duration,
					fadeOutDuration = fadeOutAction._clip.duration,

					startEndRatio = fadeOutDuration / fadeInDuration,
					endStartRatio = fadeInDuration / fadeOutDuration;

				fadeOutAction.warp( 1.0, startEndRatio, duration );
				this.warp( endStartRatio, 1.0, duration );

			}

			return this;

		},

		crossFadeTo: function( fadeInAction, duration, warp ) {

			return fadeInAction.crossFadeFrom( this, duration, warp );

		},

		stopFading: function() {

			var weightInterpolant = this._weightInterpolant;

			if ( weightInterpolant !== null ) {

				this._weightInterpolant = null;
				this._mixer._takeBackControlInterpolant( weightInterpolant );

			}

			return this;

		},

		// Time Scale Control

		// set the weight stopping any scheduled warping
		// although .paused = true yields an effective time scale of zero, this
		// method does *not* change .paused, because it would be confusing
		setEffectiveTimeScale: function( timeScale ) {

			this.timeScale = timeScale;
			this._effectiveTimeScale = this.paused ? 0 :timeScale;

			return this.stopWarping();

		},

		// return the time scale considering warping and .paused
		getEffectiveTimeScale: function() {

			return this._effectiveTimeScale;

		},

		setDuration: function( duration ) {

			this.timeScale = this._clip.duration / duration;

			return this.stopWarping();

		},

		syncWith: function( action ) {

			this.time = action.time;
			this.timeScale = action.timeScale;

			return this.stopWarping();

		},

		halt: function( duration ) {

			return this.warp( this._effectiveTimeScale, 0, duration );

		},

		warp: function( startTimeScale, endTimeScale, duration ) {

			var mixer = this._mixer, now = mixer.time,
				interpolant = this._timeScaleInterpolant,

				timeScale = this.timeScale;

			if ( interpolant === null ) {

				interpolant = mixer._lendControlInterpolant();
				this._timeScaleInterpolant = interpolant;

			}

			var times = interpolant.parameterPositions,
				values = interpolant.sampleValues;

			times[ 0 ] = now;
			times[ 1 ] = now + duration;

			values[ 0 ] = startTimeScale / timeScale;
			values[ 1 ] = endTimeScale / timeScale;

			return this;

		},

		stopWarping: function() {

			var timeScaleInterpolant = this._timeScaleInterpolant;

			if ( timeScaleInterpolant !== null ) {

				this._timeScaleInterpolant = null;
				this._mixer._takeBackControlInterpolant( timeScaleInterpolant );

			}

			return this;

		},

		// Object Accessors

		getMixer: function() {

			return this._mixer;

		},

		getClip: function() {

			return this._clip;

		},

		getRoot: function() {

			return this._localRoot || this._mixer._root;

		},

		// Interna

		_update: function( time, deltaTime, timeDirection, accuIndex ) {
			// called by the mixer

			var startTime = this._startTime;

			if ( startTime !== null ) {

				// check for scheduled start of action

				var timeRunning = ( time - startTime ) * timeDirection;
				if ( timeRunning < 0 || timeDirection === 0 ) {

					return; // yet to come / don't decide when delta = 0

				}

				// start

				this._startTime = null; // unschedule
				deltaTime = timeDirection * timeRunning;

			}

			// apply time scale and advance time

			deltaTime *= this._updateTimeScale( time );
			var clipTime = this._updateTime( deltaTime );

			// note: _updateTime may disable the action resulting in
			// an effective weight of 0

			var weight = this._updateWeight( time );

			if ( weight > 0 ) {

				var interpolants = this._interpolants;
				var propertyMixers = this._propertyBindings;

				for ( var j = 0, m = interpolants.length; j !== m; ++ j ) {

					interpolants[ j ].evaluate( clipTime );
					propertyMixers[ j ].accumulate( accuIndex, weight );

				}

			}

		},

		_updateWeight: function( time ) {

			var weight = 0;

			if ( this.enabled ) {

				weight = this.weight;
				var interpolant = this._weightInterpolant;

				if ( interpolant !== null ) {

					var interpolantValue = interpolant.evaluate( time )[ 0 ];

					weight *= interpolantValue;

					if ( time > interpolant.parameterPositions[ 1 ] ) {

						this.stopFading();

						if ( interpolantValue === 0 ) {

							// faded out, disable
							this.enabled = false;

						}

					}

				}

			}

			this._effectiveWeight = weight;
			return weight;

		},

		_updateTimeScale: function( time ) {

			var timeScale = 0;

			if ( ! this.paused ) {

				timeScale = this.timeScale;

				var interpolant = this._timeScaleInterpolant;

				if ( interpolant !== null ) {

					var interpolantValue = interpolant.evaluate( time )[ 0 ];

					timeScale *= interpolantValue;

					if ( time > interpolant.parameterPositions[ 1 ] ) {

						this.stopWarping();

						if ( timeScale === 0 ) {

							// motion has halted, pause
							this.paused = true;

						} else {

							// warp done - apply final time scale
							this.timeScale = timeScale;

						}

					}

				}

			}

			this._effectiveTimeScale = timeScale;
			return timeScale;

		},

		_updateTime: function( deltaTime ) {

			var time = this.time + deltaTime;

			if ( deltaTime === 0 ) return time;

			var duration = this._clip.duration,

				loop = this.loop,
				loopCount = this._loopCount;

			if ( loop === LoopOnce ) {

				if ( loopCount === -1 ) {
					// just started

					this._loopCount = 0;
					this._setEndings( true, true, false );

				}

				handle_stop: {

					if ( time >= duration ) {

						time = duration;

					} else if ( time < 0 ) {

						time = 0;

					} else break handle_stop;

					if ( this.clampWhenFinished ) this.paused = true;
					else this.enabled = false;

					this._mixer.dispatchEvent( {
						type: 'finished', action: this,
						direction: deltaTime < 0 ? -1 : 1
					} );

				}

			} else { // repetitive Repeat or PingPong

				var pingPong = ( loop === LoopPingPong );

				if ( loopCount === -1 ) {
					// just started

					if ( deltaTime >= 0 ) {

						loopCount = 0;

						this._setEndings(
								true, this.repetitions === 0, pingPong );

					} else {

						// when looping in reverse direction, the initial
						// transition through zero counts as a repetition,
						// so leave loopCount at -1

						this._setEndings(
								this.repetitions === 0, true, pingPong );

					}

				}

				if ( time >= duration || time < 0 ) {
					// wrap around

					var loopDelta = Math.floor( time / duration ); // signed
					time -= duration * loopDelta;

					loopCount += Math.abs( loopDelta );

					var pending = this.repetitions - loopCount;

					if ( pending < 0 ) {
						// have to stop (switch state, clamp time, fire event)

						if ( this.clampWhenFinished ) this.paused = true;
						else this.enabled = false;

						time = deltaTime > 0 ? duration : 0;

						this._mixer.dispatchEvent( {
							type: 'finished', action: this,
							direction: deltaTime > 0 ? 1 : -1
						} );

					} else {
						// keep running

						if ( pending === 0 ) {
							// entering the last round

							var atStart = deltaTime < 0;
							this._setEndings( atStart, ! atStart, pingPong );

						} else {

							this._setEndings( false, false, pingPong );

						}

						this._loopCount = loopCount;

						this._mixer.dispatchEvent( {
							type: 'loop', action: this, loopDelta: loopDelta
						} );

					}

				}

				if ( pingPong && ( loopCount & 1 ) === 1 ) {
					// invert time for the "pong round"

					this.time = time;
					return duration - time;

				}

			}

			this.time = time;
			return time;

		},

		_setEndings: function( atStart, atEnd, pingPong ) {

			var settings = this._interpolantSettings;

			if ( pingPong ) {

				settings.endingStart 	= ZeroSlopeEnding;
				settings.endingEnd		= ZeroSlopeEnding;

			} else {

				// assuming for LoopOnce atStart == atEnd == true

				if ( atStart ) {

					settings.endingStart = this.zeroSlopeAtStart ?
							ZeroSlopeEnding : ZeroCurvatureEnding;

				} else {

					settings.endingStart = WrapAroundEnding;

				}

				if ( atEnd ) {

					settings.endingEnd = this.zeroSlopeAtEnd ?
							ZeroSlopeEnding : ZeroCurvatureEnding;

				} else {

					settings.endingEnd 	 = WrapAroundEnding;

				}

			}

		},

		_scheduleFading: function( duration, weightNow, weightThen ) {

			var mixer = this._mixer, now = mixer.time,
				interpolant = this._weightInterpolant;

			if ( interpolant === null ) {

				interpolant = mixer._lendControlInterpolant();
				this._weightInterpolant = interpolant;

			}

			var times = interpolant.parameterPositions,
				values = interpolant.sampleValues;

			times[ 0 ] = now; 				values[ 0 ] = weightNow;
			times[ 1 ] = now + duration;	values[ 1 ] = weightThen;

			return this;

		}

	};

	/**
	 *
	 * Player for AnimationClips.
	 *
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 */

	function AnimationMixer( root ) {

		this._root = root;
		this._initMemoryManager();
		this._accuIndex = 0;

		this.time = 0;

		this.timeScale = 1.0;

	}

	Object.assign( AnimationMixer.prototype, EventDispatcher.prototype, {

		// return an action for a clip optionally using a custom root target
		// object (this method allocates a lot of dynamic memory in case a
		// previously unknown clip/root combination is specified)
		clipAction: function( clip, optionalRoot ) {

			var root = optionalRoot || this._root,
				rootUuid = root.uuid,

				clipObject = typeof clip === 'string' ?
						AnimationClip.findByName( root, clip ) : clip,

				clipUuid = clipObject !== null ? clipObject.uuid : clip,

				actionsForClip = this._actionsByClip[ clipUuid ],
				prototypeAction = null;

			if ( actionsForClip !== undefined ) {

				var existingAction =
						actionsForClip.actionByRoot[ rootUuid ];

				if ( existingAction !== undefined ) {

					return existingAction;

				}

				// we know the clip, so we don't have to parse all
				// the bindings again but can just copy
				prototypeAction = actionsForClip.knownActions[ 0 ];

				// also, take the clip from the prototype action
				if ( clipObject === null )
					clipObject = prototypeAction._clip;

			}

			// clip must be known when specified via string
			if ( clipObject === null ) return null;

			// allocate all resources required to run it
			var newAction = new AnimationAction( this, clipObject, optionalRoot );

			this._bindAction( newAction, prototypeAction );

			// and make the action known to the memory manager
			this._addInactiveAction( newAction, clipUuid, rootUuid );

			return newAction;

		},

		// get an existing action
		existingAction: function( clip, optionalRoot ) {

			var root = optionalRoot || this._root,
				rootUuid = root.uuid,

				clipObject = typeof clip === 'string' ?
						AnimationClip.findByName( root, clip ) : clip,

				clipUuid = clipObject ? clipObject.uuid : clip,

				actionsForClip = this._actionsByClip[ clipUuid ];

			if ( actionsForClip !== undefined ) {

				return actionsForClip.actionByRoot[ rootUuid ] || null;

			}

			return null;

		},

		// deactivates all previously scheduled actions
		stopAllAction: function() {

			var actions = this._actions,
				nActions = this._nActiveActions,
				bindings = this._bindings,
				nBindings = this._nActiveBindings;

			this._nActiveActions = 0;
			this._nActiveBindings = 0;

			for ( var i = 0; i !== nActions; ++ i ) {

				actions[ i ].reset();

			}

			for ( var i = 0; i !== nBindings; ++ i ) {

				bindings[ i ].useCount = 0;

			}

			return this;

		},

		// advance the time and update apply the animation
		update: function( deltaTime ) {

			deltaTime *= this.timeScale;

			var actions = this._actions,
				nActions = this._nActiveActions,

				time = this.time += deltaTime,
				timeDirection = Math.sign( deltaTime ),

				accuIndex = this._accuIndex ^= 1;

			// run active actions

			for ( var i = 0; i !== nActions; ++ i ) {

				var action = actions[ i ];

				if ( action.enabled ) {

					action._update( time, deltaTime, timeDirection, accuIndex );

				}

			}

			// update scene graph

			var bindings = this._bindings,
				nBindings = this._nActiveBindings;

			for ( var i = 0; i !== nBindings; ++ i ) {

				bindings[ i ].apply( accuIndex );

			}

			return this;

		},

		// return this mixer's root target object
		getRoot: function() {

			return this._root;

		},

		// free all resources specific to a particular clip
		uncacheClip: function( clip ) {

			var actions = this._actions,
				clipUuid = clip.uuid,
				actionsByClip = this._actionsByClip,
				actionsForClip = actionsByClip[ clipUuid ];

			if ( actionsForClip !== undefined ) {

				// note: just calling _removeInactiveAction would mess up the
				// iteration state and also require updating the state we can
				// just throw away

				var actionsToRemove = actionsForClip.knownActions;

				for ( var i = 0, n = actionsToRemove.length; i !== n; ++ i ) {

					var action = actionsToRemove[ i ];

					this._deactivateAction( action );

					var cacheIndex = action._cacheIndex,
						lastInactiveAction = actions[ actions.length - 1 ];

					action._cacheIndex = null;
					action._byClipCacheIndex = null;

					lastInactiveAction._cacheIndex = cacheIndex;
					actions[ cacheIndex ] = lastInactiveAction;
					actions.pop();

					this._removeInactiveBindingsForAction( action );

				}

				delete actionsByClip[ clipUuid ];

			}

		},

		// free all resources specific to a particular root target object
		uncacheRoot: function( root ) {

			var rootUuid = root.uuid,
				actionsByClip = this._actionsByClip;

			for ( var clipUuid in actionsByClip ) {

				var actionByRoot = actionsByClip[ clipUuid ].actionByRoot,
					action = actionByRoot[ rootUuid ];

				if ( action !== undefined ) {

					this._deactivateAction( action );
					this._removeInactiveAction( action );

				}

			}

			var bindingsByRoot = this._bindingsByRootAndName,
				bindingByName = bindingsByRoot[ rootUuid ];

			if ( bindingByName !== undefined ) {

				for ( var trackName in bindingByName ) {

					var binding = bindingByName[ trackName ];
					binding.restoreOriginalState();
					this._removeInactiveBinding( binding );

				}

			}

		},

		// remove a targeted clip from the cache
		uncacheAction: function( clip, optionalRoot ) {

			var action = this.existingAction( clip, optionalRoot );

			if ( action !== null ) {

				this._deactivateAction( action );
				this._removeInactiveAction( action );

			}

		}

	} );

	// Implementation details:

	Object.assign( AnimationMixer.prototype, {

		_bindAction: function( action, prototypeAction ) {

			var root = action._localRoot || this._root,
				tracks = action._clip.tracks,
				nTracks = tracks.length,
				bindings = action._propertyBindings,
				interpolants = action._interpolants,
				rootUuid = root.uuid,
				bindingsByRoot = this._bindingsByRootAndName,
				bindingsByName = bindingsByRoot[ rootUuid ];

			if ( bindingsByName === undefined ) {

				bindingsByName = {};
				bindingsByRoot[ rootUuid ] = bindingsByName;

			}

			for ( var i = 0; i !== nTracks; ++ i ) {

				var track = tracks[ i ],
					trackName = track.name,
					binding = bindingsByName[ trackName ];

				if ( binding !== undefined ) {

					bindings[ i ] = binding;

				} else {

					binding = bindings[ i ];

					if ( binding !== undefined ) {

						// existing binding, make sure the cache knows

						if ( binding._cacheIndex === null ) {

							++ binding.referenceCount;
							this._addInactiveBinding( binding, rootUuid, trackName );

						}

						continue;

					}

					var path = prototypeAction && prototypeAction.
							_propertyBindings[ i ].binding.parsedPath;

					binding = new PropertyMixer(
							PropertyBinding.create( root, trackName, path ),
							track.ValueTypeName, track.getValueSize() );

					++ binding.referenceCount;
					this._addInactiveBinding( binding, rootUuid, trackName );

					bindings[ i ] = binding;

				}

				interpolants[ i ].resultBuffer = binding.buffer;

			}

		},

		_activateAction: function( action ) {

			if ( ! this._isActiveAction( action ) ) {

				if ( action._cacheIndex === null ) {

					// this action has been forgotten by the cache, but the user
					// appears to be still using it -> rebind

					var rootUuid = ( action._localRoot || this._root ).uuid,
						clipUuid = action._clip.uuid,
						actionsForClip = this._actionsByClip[ clipUuid ];

					this._bindAction( action,
							actionsForClip && actionsForClip.knownActions[ 0 ] );

					this._addInactiveAction( action, clipUuid, rootUuid );

				}

				var bindings = action._propertyBindings;

				// increment reference counts / sort out state
				for ( var i = 0, n = bindings.length; i !== n; ++ i ) {

					var binding = bindings[ i ];

					if ( binding.useCount ++ === 0 ) {

						this._lendBinding( binding );
						binding.saveOriginalState();

					}

				}

				this._lendAction( action );

			}

		},

		_deactivateAction: function( action ) {

			if ( this._isActiveAction( action ) ) {

				var bindings = action._propertyBindings;

				// decrement reference counts / sort out state
				for ( var i = 0, n = bindings.length; i !== n; ++ i ) {

					var binding = bindings[ i ];

					if ( -- binding.useCount === 0 ) {

						binding.restoreOriginalState();
						this._takeBackBinding( binding );

					}

				}

				this._takeBackAction( action );

			}

		},

		// Memory manager

		_initMemoryManager: function() {

			this._actions = []; // 'nActiveActions' followed by inactive ones
			this._nActiveActions = 0;

			this._actionsByClip = {};
			// inside:
			// {
			// 		knownActions: Array< AnimationAction >	- used as prototypes
			// 		actionByRoot: AnimationAction			- lookup
			// }


			this._bindings = []; // 'nActiveBindings' followed by inactive ones
			this._nActiveBindings = 0;

			this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >


			this._controlInterpolants = []; // same game as above
			this._nActiveControlInterpolants = 0;

			var scope = this;

			this.stats = {

				actions: {
					get total() { return scope._actions.length; },
					get inUse() { return scope._nActiveActions; }
				},
				bindings: {
					get total() { return scope._bindings.length; },
					get inUse() { return scope._nActiveBindings; }
				},
				controlInterpolants: {
					get total() { return scope._controlInterpolants.length; },
					get inUse() { return scope._nActiveControlInterpolants; }
				}

			};

		},

		// Memory management for AnimationAction objects

		_isActiveAction: function( action ) {

			var index = action._cacheIndex;
			return index !== null && index < this._nActiveActions;

		},

		_addInactiveAction: function( action, clipUuid, rootUuid ) {

			var actions = this._actions,
				actionsByClip = this._actionsByClip,
				actionsForClip = actionsByClip[ clipUuid ];

			if ( actionsForClip === undefined ) {

				actionsForClip = {

					knownActions: [ action ],
					actionByRoot: {}

				};

				action._byClipCacheIndex = 0;

				actionsByClip[ clipUuid ] = actionsForClip;

			} else {

				var knownActions = actionsForClip.knownActions;

				action._byClipCacheIndex = knownActions.length;
				knownActions.push( action );

			}

			action._cacheIndex = actions.length;
			actions.push( action );

			actionsForClip.actionByRoot[ rootUuid ] = action;

		},

		_removeInactiveAction: function( action ) {

			var actions = this._actions,
				lastInactiveAction = actions[ actions.length - 1 ],
				cacheIndex = action._cacheIndex;

			lastInactiveAction._cacheIndex = cacheIndex;
			actions[ cacheIndex ] = lastInactiveAction;
			actions.pop();

			action._cacheIndex = null;


			var clipUuid = action._clip.uuid,
				actionsByClip = this._actionsByClip,
				actionsForClip = actionsByClip[ clipUuid ],
				knownActionsForClip = actionsForClip.knownActions,

				lastKnownAction =
					knownActionsForClip[ knownActionsForClip.length - 1 ],

				byClipCacheIndex = action._byClipCacheIndex;

			lastKnownAction._byClipCacheIndex = byClipCacheIndex;
			knownActionsForClip[ byClipCacheIndex ] = lastKnownAction;
			knownActionsForClip.pop();

			action._byClipCacheIndex = null;


			var actionByRoot = actionsForClip.actionByRoot,
				rootUuid = ( actions._localRoot || this._root ).uuid;

			delete actionByRoot[ rootUuid ];

			if ( knownActionsForClip.length === 0 ) {

				delete actionsByClip[ clipUuid ];

			}

			this._removeInactiveBindingsForAction( action );

		},

		_removeInactiveBindingsForAction: function( action ) {

			var bindings = action._propertyBindings;
			for ( var i = 0, n = bindings.length; i !== n; ++ i ) {

				var binding = bindings[ i ];

				if ( -- binding.referenceCount === 0 ) {

					this._removeInactiveBinding( binding );

				}

			}

		},

		_lendAction: function( action ) {

			// [ active actions |  inactive actions  ]
			// [  active actions >| inactive actions ]
			//                 s        a
			//                  <-swap->
			//                 a        s

			var actions = this._actions,
				prevIndex = action._cacheIndex,

				lastActiveIndex = this._nActiveActions ++,

				firstInactiveAction = actions[ lastActiveIndex ];

			action._cacheIndex = lastActiveIndex;
			actions[ lastActiveIndex ] = action;

			firstInactiveAction._cacheIndex = prevIndex;
			actions[ prevIndex ] = firstInactiveAction;

		},

		_takeBackAction: function( action ) {

			// [  active actions  | inactive actions ]
			// [ active actions |< inactive actions  ]
			//        a        s
			//         <-swap->
			//        s        a

			var actions = this._actions,
				prevIndex = action._cacheIndex,

				firstInactiveIndex = -- this._nActiveActions,

				lastActiveAction = actions[ firstInactiveIndex ];

			action._cacheIndex = firstInactiveIndex;
			actions[ firstInactiveIndex ] = action;

			lastActiveAction._cacheIndex = prevIndex;
			actions[ prevIndex ] = lastActiveAction;

		},

		// Memory management for PropertyMixer objects

		_addInactiveBinding: function( binding, rootUuid, trackName ) {

			var bindingsByRoot = this._bindingsByRootAndName,
				bindingByName = bindingsByRoot[ rootUuid ],

				bindings = this._bindings;

			if ( bindingByName === undefined ) {

				bindingByName = {};
				bindingsByRoot[ rootUuid ] = bindingByName;

			}

			bindingByName[ trackName ] = binding;

			binding._cacheIndex = bindings.length;
			bindings.push( binding );

		},

		_removeInactiveBinding: function( binding ) {

			var bindings = this._bindings,
				propBinding = binding.binding,
				rootUuid = propBinding.rootNode.uuid,
				trackName = propBinding.path,
				bindingsByRoot = this._bindingsByRootAndName,
				bindingByName = bindingsByRoot[ rootUuid ],

				lastInactiveBinding = bindings[ bindings.length - 1 ],
				cacheIndex = binding._cacheIndex;

			lastInactiveBinding._cacheIndex = cacheIndex;
			bindings[ cacheIndex ] = lastInactiveBinding;
			bindings.pop();

			delete bindingByName[ trackName ];

			remove_empty_map: {

				for ( var _ in bindingByName ) break remove_empty_map;

				delete bindingsByRoot[ rootUuid ];

			}

		},

		_lendBinding: function( binding ) {

			var bindings = this._bindings,
				prevIndex = binding._cacheIndex,

				lastActiveIndex = this._nActiveBindings ++,

				firstInactiveBinding = bindings[ lastActiveIndex ];

			binding._cacheIndex = lastActiveIndex;
			bindings[ lastActiveIndex ] = binding;

			firstInactiveBinding._cacheIndex = prevIndex;
			bindings[ prevIndex ] = firstInactiveBinding;

		},

		_takeBackBinding: function( binding ) {

			var bindings = this._bindings,
				prevIndex = binding._cacheIndex,

				firstInactiveIndex = -- this._nActiveBindings,

				lastActiveBinding = bindings[ firstInactiveIndex ];

			binding._cacheIndex = firstInactiveIndex;
			bindings[ firstInactiveIndex ] = binding;

			lastActiveBinding._cacheIndex = prevIndex;
			bindings[ prevIndex ] = lastActiveBinding;

		},


		// Memory management of Interpolants for weight and time scale

		_lendControlInterpolant: function() {

			var interpolants = this._controlInterpolants,
				lastActiveIndex = this._nActiveControlInterpolants ++,
				interpolant = interpolants[ lastActiveIndex ];

			if ( interpolant === undefined ) {

				interpolant = new LinearInterpolant(
						new Float32Array( 2 ), new Float32Array( 2 ),
							1, this._controlInterpolantsResultBuffer );

				interpolant.__cacheIndex = lastActiveIndex;
				interpolants[ lastActiveIndex ] = interpolant;

			}

			return interpolant;

		},

		_takeBackControlInterpolant: function( interpolant ) {

			var interpolants = this._controlInterpolants,
				prevIndex = interpolant.__cacheIndex,

				firstInactiveIndex = -- this._nActiveControlInterpolants,

				lastActiveInterpolant = interpolants[ firstInactiveIndex ];

			interpolant.__cacheIndex = firstInactiveIndex;
			interpolants[ firstInactiveIndex ] = interpolant;

			lastActiveInterpolant.__cacheIndex = prevIndex;
			interpolants[ prevIndex ] = lastActiveInterpolant;

		},

		_controlInterpolantsResultBuffer: new Float32Array( 1 )

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function Uniform( value ) {

		if ( typeof value === 'string' ) {

			console.warn( 'THREE.Uniform: Type parameter is no longer needed.' );
			value = arguments[ 1 ];

		}

		this.value = value;

	}

	Uniform.prototype.clone = function () {

		return new Uniform( this.value.clone === undefined ? this.value : this.value.clone() );

	};

	/**
	 * @author benaadams / https://twitter.com/ben_a_adams
	 */

	function InstancedBufferGeometry() {

		BufferGeometry.call( this );

		this.type = 'InstancedBufferGeometry';
		this.maxInstancedCount = undefined;

	}

	InstancedBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	InstancedBufferGeometry.prototype.constructor = InstancedBufferGeometry;

	InstancedBufferGeometry.prototype.isInstancedBufferGeometry = true;

	InstancedBufferGeometry.prototype.addGroup = function ( start, count, materialIndex ) {

		this.groups.push( {

			start: start,
			count: count,
			materialIndex: materialIndex

		} );

	};

	InstancedBufferGeometry.prototype.copy = function ( source ) {

		var index = source.index;

		if ( index !== null ) {

			this.setIndex( index.clone() );

		}

		var attributes = source.attributes;

		for ( var name in attributes ) {

			var attribute = attributes[ name ];
			this.addAttribute( name, attribute.clone() );

		}

		var groups = source.groups;

		for ( var i = 0, l = groups.length; i < l; i ++ ) {

			var group = groups[ i ];
			this.addGroup( group.start, group.count, group.materialIndex );

		}

		return this;

	};

	/**
	 * @author benaadams / https://twitter.com/ben_a_adams
	 */

	function InterleavedBufferAttribute( interleavedBuffer, itemSize, offset, normalized ) {

		this.uuid = _Math.generateUUID();

		this.data = interleavedBuffer;
		this.itemSize = itemSize;
		this.offset = offset;

		this.normalized = normalized === true;

	}


	InterleavedBufferAttribute.prototype = {

		constructor: InterleavedBufferAttribute,

		isInterleavedBufferAttribute: true,

		get count() {

			return this.data.count;

		},

		get array() {

			return this.data.array;

		},

		setX: function ( index, x ) {

			this.data.array[ index * this.data.stride + this.offset ] = x;

			return this;

		},

		setY: function ( index, y ) {

			this.data.array[ index * this.data.stride + this.offset + 1 ] = y;

			return this;

		},

		setZ: function ( index, z ) {

			this.data.array[ index * this.data.stride + this.offset + 2 ] = z;

			return this;

		},

		setW: function ( index, w ) {

			this.data.array[ index * this.data.stride + this.offset + 3 ] = w;

			return this;

		},

		getX: function ( index ) {

			return this.data.array[ index * this.data.stride + this.offset ];

		},

		getY: function ( index ) {

			return this.data.array[ index * this.data.stride + this.offset + 1 ];

		},

		getZ: function ( index ) {

			return this.data.array[ index * this.data.stride + this.offset + 2 ];

		},

		getW: function ( index ) {

			return this.data.array[ index * this.data.stride + this.offset + 3 ];

		},

		setXY: function ( index, x, y ) {

			index = index * this.data.stride + this.offset;

			this.data.array[ index + 0 ] = x;
			this.data.array[ index + 1 ] = y;

			return this;

		},

		setXYZ: function ( index, x, y, z ) {

			index = index * this.data.stride + this.offset;

			this.data.array[ index + 0 ] = x;
			this.data.array[ index + 1 ] = y;
			this.data.array[ index + 2 ] = z;

			return this;

		},

		setXYZW: function ( index, x, y, z, w ) {

			index = index * this.data.stride + this.offset;

			this.data.array[ index + 0 ] = x;
			this.data.array[ index + 1 ] = y;
			this.data.array[ index + 2 ] = z;
			this.data.array[ index + 3 ] = w;

			return this;

		}

	};

	/**
	 * @author benaadams / https://twitter.com/ben_a_adams
	 */

	function InterleavedBuffer( array, stride ) {

		this.uuid = _Math.generateUUID();

		this.array = array;
		this.stride = stride;
		this.count = array !== undefined ? array.length / stride : 0;

		this.dynamic = false;
		this.updateRange = { offset: 0, count: - 1 };

		this.onUploadCallback = function () {};

		this.version = 0;

	}

	InterleavedBuffer.prototype = {

		constructor: InterleavedBuffer,

		isInterleavedBuffer: true,

		set needsUpdate( value ) {

			if ( value === true ) this.version ++;

		},

		setArray: function ( array ) {

			if ( Array.isArray( array ) ) {

				throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );

			}

			this.count = array !== undefined ? array.length / this.stride : 0;
			this.array = array;

		},

		setDynamic: function ( value ) {

			this.dynamic = value;

			return this;

		},

		copy: function ( source ) {

			this.array = new source.array.constructor( source.array );
			this.count = source.count;
			this.stride = source.stride;
			this.dynamic = source.dynamic;

			return this;

		},

		copyAt: function ( index1, attribute, index2 ) {

			index1 *= this.stride;
			index2 *= attribute.stride;

			for ( var i = 0, l = this.stride; i < l; i ++ ) {

				this.array[ index1 + i ] = attribute.array[ index2 + i ];

			}

			return this;

		},

		set: function ( value, offset ) {

			if ( offset === undefined ) offset = 0;

			this.array.set( value, offset );

			return this;

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		onUpload: function ( callback ) {

			this.onUploadCallback = callback;

			return this;

		}

	};

	/**
	 * @author benaadams / https://twitter.com/ben_a_adams
	 */

	function InstancedInterleavedBuffer( array, stride, meshPerAttribute ) {

		InterleavedBuffer.call( this, array, stride );

		this.meshPerAttribute = meshPerAttribute || 1;

	}

	InstancedInterleavedBuffer.prototype = Object.create( InterleavedBuffer.prototype );
	InstancedInterleavedBuffer.prototype.constructor = InstancedInterleavedBuffer;

	InstancedInterleavedBuffer.prototype.isInstancedInterleavedBuffer = true;

	InstancedInterleavedBuffer.prototype.copy = function ( source ) {

		InterleavedBuffer.prototype.copy.call( this, source );

		this.meshPerAttribute = source.meshPerAttribute;

		return this;

	};

	/**
	 * @author benaadams / https://twitter.com/ben_a_adams
	 */

	function InstancedBufferAttribute( array, itemSize, meshPerAttribute ) {

		BufferAttribute.call( this, array, itemSize );

		this.meshPerAttribute = meshPerAttribute || 1;

	}

	InstancedBufferAttribute.prototype = Object.create( BufferAttribute.prototype );
	InstancedBufferAttribute.prototype.constructor = InstancedBufferAttribute;

	InstancedBufferAttribute.prototype.isInstancedBufferAttribute = true;

	InstancedBufferAttribute.prototype.copy = function ( source ) {

		BufferAttribute.prototype.copy.call( this, source );

		this.meshPerAttribute = source.meshPerAttribute;

		return this;

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author bhouston / http://clara.io/
	 * @author stephomi / http://stephaneginier.com/
	 */

	function Raycaster( origin, direction, near, far ) {

		this.ray = new Ray( origin, direction );
		// direction is assumed to be normalized (for accurate distance calculations)

		this.near = near || 0;
		this.far = far || Infinity;

		this.params = {
			Mesh: {},
			Line: {},
			LOD: {},
			Points: { threshold: 1 },
			Sprite: {}
		};

		Object.defineProperties( this.params, {
			PointCloud: {
				get: function () {
					console.warn( 'THREE.Raycaster: params.PointCloud has been renamed to params.Points.' );
					return this.Points;
				}
			}
		} );

	}

	function ascSort( a, b ) {

		return a.distance - b.distance;

	}

	function intersectObject( object, raycaster, intersects, recursive ) {

		if ( object.visible === false ) return;

		object.raycast( raycaster, intersects );

		if ( recursive === true ) {

			var children = object.children;

			for ( var i = 0, l = children.length; i < l; i ++ ) {

				intersectObject( children[ i ], raycaster, intersects, true );

			}

		}

	}

	//

	Raycaster.prototype = {

		constructor: Raycaster,

		linePrecision: 1,

		set: function ( origin, direction ) {

			// direction is assumed to be normalized (for accurate distance calculations)

			this.ray.set( origin, direction );

		},

		setFromCamera: function ( coords, camera ) {

			if ( (camera && camera.isPerspectiveCamera) ) {

				this.ray.origin.setFromMatrixPosition( camera.matrixWorld );
				this.ray.direction.set( coords.x, coords.y, 0.5 ).unproject( camera ).sub( this.ray.origin ).normalize();

			} else if ( (camera && camera.isOrthographicCamera) ) {

				this.ray.origin.set( coords.x, coords.y, ( camera.near + camera.far ) / ( camera.near - camera.far ) ).unproject( camera ); // set origin in plane of camera
				this.ray.direction.set( 0, 0, - 1 ).transformDirection( camera.matrixWorld );

			} else {

				console.error( 'THREE.Raycaster: Unsupported camera type.' );

			}

		},

		intersectObject: function ( object, recursive ) {

			var intersects = [];

			intersectObject( object, this, intersects, recursive );

			intersects.sort( ascSort );

			return intersects;

		},

		intersectObjects: function ( objects, recursive ) {

			var intersects = [];

			if ( Array.isArray( objects ) === false ) {

				console.warn( 'THREE.Raycaster.intersectObjects: objects is not an Array.' );
				return intersects;

			}

			for ( var i = 0, l = objects.length; i < l; i ++ ) {

				intersectObject( objects[ i ], this, intersects, recursive );

			}

			intersects.sort( ascSort );

			return intersects;

		}

	};

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	function Clock( autoStart ) {

		this.autoStart = ( autoStart !== undefined ) ? autoStart : true;

		this.startTime = 0;
		this.oldTime = 0;
		this.elapsedTime = 0;

		this.running = false;

	}

	Clock.prototype = {

		constructor: Clock,

		start: function () {

			this.startTime = ( performance || Date ).now();

			this.oldTime = this.startTime;
			this.elapsedTime = 0;
			this.running = true;

		},

		stop: function () {

			this.getElapsedTime();
			this.running = false;

		},

		getElapsedTime: function () {

			this.getDelta();
			return this.elapsedTime;

		},

		getDelta: function () {

			var diff = 0;

			if ( this.autoStart && ! this.running ) {

				this.start();

			}

			if ( this.running ) {

				var newTime = ( performance || Date ).now();

				diff = ( newTime - this.oldTime ) / 1000;
				this.oldTime = newTime;

				this.elapsedTime += diff;

			}

			return diff;

		}

	};

	/**
	 * Spline from Tween.js, slightly optimized (and trashed)
	 * http://sole.github.com/tween.js/examples/05_spline.html
	 *
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function Spline( points ) {

		this.points = points;

		var c = [], v3 = { x: 0, y: 0, z: 0 },
		point, intPoint, weight, w2, w3,
		pa, pb, pc, pd;

		this.initFromArray = function ( a ) {

			this.points = [];

			for ( var i = 0; i < a.length; i ++ ) {

				this.points[ i ] = { x: a[ i ][ 0 ], y: a[ i ][ 1 ], z: a[ i ][ 2 ] };

			}

		};

		this.getPoint = function ( k ) {

			point = ( this.points.length - 1 ) * k;
			intPoint = Math.floor( point );
			weight = point - intPoint;

			c[ 0 ] = intPoint === 0 ? intPoint : intPoint - 1;
			c[ 1 ] = intPoint;
			c[ 2 ] = intPoint  > this.points.length - 2 ? this.points.length - 1 : intPoint + 1;
			c[ 3 ] = intPoint  > this.points.length - 3 ? this.points.length - 1 : intPoint + 2;

			pa = this.points[ c[ 0 ] ];
			pb = this.points[ c[ 1 ] ];
			pc = this.points[ c[ 2 ] ];
			pd = this.points[ c[ 3 ] ];

			w2 = weight * weight;
			w3 = weight * w2;

			v3.x = interpolate( pa.x, pb.x, pc.x, pd.x, weight, w2, w3 );
			v3.y = interpolate( pa.y, pb.y, pc.y, pd.y, weight, w2, w3 );
			v3.z = interpolate( pa.z, pb.z, pc.z, pd.z, weight, w2, w3 );

			return v3;

		};

		this.getControlPointsArray = function () {

			var i, p, l = this.points.length,
				coords = [];

			for ( i = 0; i < l; i ++ ) {

				p = this.points[ i ];
				coords[ i ] = [ p.x, p.y, p.z ];

			}

			return coords;

		};

		// approximate length by summing linear segments

		this.getLength = function ( nSubDivisions ) {

			var i, index, nSamples, position,
				point = 0, intPoint = 0, oldIntPoint = 0,
				oldPosition = new Vector3(),
				tmpVec = new Vector3(),
				chunkLengths = [],
				totalLength = 0;

			// first point has 0 length

			chunkLengths[ 0 ] = 0;

			if ( ! nSubDivisions ) nSubDivisions = 100;

			nSamples = this.points.length * nSubDivisions;

			oldPosition.copy( this.points[ 0 ] );

			for ( i = 1; i < nSamples; i ++ ) {

				index = i / nSamples;

				position = this.getPoint( index );
				tmpVec.copy( position );

				totalLength += tmpVec.distanceTo( oldPosition );

				oldPosition.copy( position );

				point = ( this.points.length - 1 ) * index;
				intPoint = Math.floor( point );

				if ( intPoint !== oldIntPoint ) {

					chunkLengths[ intPoint ] = totalLength;
					oldIntPoint = intPoint;

				}

			}

			// last point ends with total length

			chunkLengths[ chunkLengths.length ] = totalLength;

			return { chunks: chunkLengths, total: totalLength };

		};

		this.reparametrizeByArcLength = function ( samplingCoef ) {

			var i, j,
				index, indexCurrent, indexNext,
				realDistance,
				sampling, position,
				newpoints = [],
				tmpVec = new Vector3(),
				sl = this.getLength();

			newpoints.push( tmpVec.copy( this.points[ 0 ] ).clone() );

			for ( i = 1; i < this.points.length; i ++ ) {

				//tmpVec.copy( this.points[ i - 1 ] );
				//linearDistance = tmpVec.distanceTo( this.points[ i ] );

				realDistance = sl.chunks[ i ] - sl.chunks[ i - 1 ];

				sampling = Math.ceil( samplingCoef * realDistance / sl.total );

				indexCurrent = ( i - 1 ) / ( this.points.length - 1 );
				indexNext = i / ( this.points.length - 1 );

				for ( j = 1; j < sampling - 1; j ++ ) {

					index = indexCurrent + j * ( 1 / sampling ) * ( indexNext - indexCurrent );

					position = this.getPoint( index );
					newpoints.push( tmpVec.copy( position ).clone() );

				}

				newpoints.push( tmpVec.copy( this.points[ i ] ).clone() );

			}

			this.points = newpoints;

		};

		// Catmull-Rom

		function interpolate( p0, p1, p2, p3, t, t2, t3 ) {

			var v0 = ( p2 - p0 ) * 0.5,
				v1 = ( p3 - p1 ) * 0.5;

			return ( 2 * ( p1 - p2 ) + v0 + v1 ) * t3 + ( - 3 * ( p1 - p2 ) - 2 * v0 - v1 ) * t2 + v0 * t + p1;

		}

	}

	/**
	 * @author bhouston / http://clara.io
	 * @author WestLangley / http://github.com/WestLangley
	 *
	 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
	 *
	 * The poles (phi) are at the positive and negative y axis.
	 * The equator starts at positive z.
	 */

	function Spherical( radius, phi, theta ) {

		this.radius = ( radius !== undefined ) ? radius : 1.0;
		this.phi = ( phi !== undefined ) ? phi : 0; // up / down towards top and bottom pole
		this.theta = ( theta !== undefined ) ? theta : 0; // around the equator of the sphere

		return this;

	}

	Spherical.prototype = {

		constructor: Spherical,

		set: function ( radius, phi, theta ) {

			this.radius = radius;
			this.phi = phi;
			this.theta = theta;

			return this;

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( other ) {

			this.radius = other.radius;
			this.phi = other.phi;
			this.theta = other.theta;

			return this;

		},

		// restrict phi to be betwee EPS and PI-EPS
		makeSafe: function() {

			var EPS = 0.000001;
			this.phi = Math.max( EPS, Math.min( Math.PI - EPS, this.phi ) );

			return this;

		},

		setFromVector3: function( vec3 ) {

			this.radius = vec3.length();

			if ( this.radius === 0 ) {

				this.theta = 0;
				this.phi = 0;

			} else {

				this.theta = Math.atan2( vec3.x, vec3.z ); // equator angle around y-up axis
				this.phi = Math.acos( _Math.clamp( vec3.y / this.radius, - 1, 1 ) ); // polar angle

			}

			return this;

		}

	};

	/**
	 * @author Mugen87 / https://github.com/Mugen87
	 *
	 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
	 *
	 */

	function Cylindrical( radius, theta, y ) {

		this.radius = ( radius !== undefined ) ? radius : 1.0; // distance from the origin to a point in the x-z plane
		this.theta = ( theta !== undefined ) ? theta : 0; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
		this.y = ( y !== undefined ) ? y : 0; // height above the x-z plane

		return this;

	}

	Cylindrical.prototype = {

		constructor: Cylindrical,

		set: function ( radius, theta, y ) {

			this.radius = radius;
			this.theta = theta;
			this.y = y;

			return this;

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( other ) {

			this.radius = other.radius;
			this.theta = other.theta;
			this.y = other.y;

			return this;

		},

		setFromVector3: function( vec3 ) {

			this.radius = Math.sqrt( vec3.x * vec3.x + vec3.z * vec3.z );
			this.theta = Math.atan2( vec3.x, vec3.z );
			this.y = vec3.y;

			return this;

		}

	};

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	function MorphBlendMesh( geometry, material ) {

		Mesh.call( this, geometry, material );

		this.animationsMap = {};
		this.animationsList = [];

		// prepare default animation
		// (all frames played together in 1 second)

		var numFrames = this.geometry.morphTargets.length;

		var name = "__default";

		var startFrame = 0;
		var endFrame = numFrames - 1;

		var fps = numFrames / 1;

		this.createAnimation( name, startFrame, endFrame, fps );
		this.setAnimationWeight( name, 1 );

	}

	MorphBlendMesh.prototype = Object.create( Mesh.prototype );
	MorphBlendMesh.prototype.constructor = MorphBlendMesh;

	MorphBlendMesh.prototype.createAnimation = function ( name, start, end, fps ) {

		var animation = {

			start: start,
			end: end,

			length: end - start + 1,

			fps: fps,
			duration: ( end - start ) / fps,

			lastFrame: 0,
			currentFrame: 0,

			active: false,

			time: 0,
			direction: 1,
			weight: 1,

			directionBackwards: false,
			mirroredLoop: false

		};

		this.animationsMap[ name ] = animation;
		this.animationsList.push( animation );

	};

	MorphBlendMesh.prototype.autoCreateAnimations = function ( fps ) {

		var pattern = /([a-z]+)_?(\d+)/i;

		var firstAnimation, frameRanges = {};

		var geometry = this.geometry;

		for ( var i = 0, il = geometry.morphTargets.length; i < il; i ++ ) {

			var morph = geometry.morphTargets[ i ];
			var chunks = morph.name.match( pattern );

			if ( chunks && chunks.length > 1 ) {

				var name = chunks[ 1 ];

				if ( ! frameRanges[ name ] ) frameRanges[ name ] = { start: Infinity, end: - Infinity };

				var range = frameRanges[ name ];

				if ( i < range.start ) range.start = i;
				if ( i > range.end ) range.end = i;

				if ( ! firstAnimation ) firstAnimation = name;

			}

		}

		for ( var name in frameRanges ) {

			var range = frameRanges[ name ];
			this.createAnimation( name, range.start, range.end, fps );

		}

		this.firstAnimation = firstAnimation;

	};

	MorphBlendMesh.prototype.setAnimationDirectionForward = function ( name ) {

		var animation = this.animationsMap[ name ];

		if ( animation ) {

			animation.direction = 1;
			animation.directionBackwards = false;

		}

	};

	MorphBlendMesh.prototype.setAnimationDirectionBackward = function ( name ) {

		var animation = this.animationsMap[ name ];

		if ( animation ) {

			animation.direction = - 1;
			animation.directionBackwards = true;

		}

	};

	MorphBlendMesh.prototype.setAnimationFPS = function ( name, fps ) {

		var animation = this.animationsMap[ name ];

		if ( animation ) {

			animation.fps = fps;
			animation.duration = ( animation.end - animation.start ) / animation.fps;

		}

	};

	MorphBlendMesh.prototype.setAnimationDuration = function ( name, duration ) {

		var animation = this.animationsMap[ name ];

		if ( animation ) {

			animation.duration = duration;
			animation.fps = ( animation.end - animation.start ) / animation.duration;

		}

	};

	MorphBlendMesh.prototype.setAnimationWeight = function ( name, weight ) {

		var animation = this.animationsMap[ name ];

		if ( animation ) {

			animation.weight = weight;

		}

	};

	MorphBlendMesh.prototype.setAnimationTime = function ( name, time ) {

		var animation = this.animationsMap[ name ];

		if ( animation ) {

			animation.time = time;

		}

	};

	MorphBlendMesh.prototype.getAnimationTime = function ( name ) {

		var time = 0;

		var animation = this.animationsMap[ name ];

		if ( animation ) {

			time = animation.time;

		}

		return time;

	};

	MorphBlendMesh.prototype.getAnimationDuration = function ( name ) {

		var duration = - 1;

		var animation = this.animationsMap[ name ];

		if ( animation ) {

			duration = animation.duration;

		}

		return duration;

	};

	MorphBlendMesh.prototype.playAnimation = function ( name ) {

		var animation = this.animationsMap[ name ];

		if ( animation ) {

			animation.time = 0;
			animation.active = true;

		} else {

			console.warn( "THREE.MorphBlendMesh: animation[" + name + "] undefined in .playAnimation()" );

		}

	};

	MorphBlendMesh.prototype.stopAnimation = function ( name ) {

		var animation = this.animationsMap[ name ];

		if ( animation ) {

			animation.active = false;

		}

	};

	MorphBlendMesh.prototype.update = function ( delta ) {

		for ( var i = 0, il = this.animationsList.length; i < il; i ++ ) {

			var animation = this.animationsList[ i ];

			if ( ! animation.active ) continue;

			var frameTime = animation.duration / animation.length;

			animation.time += animation.direction * delta;

			if ( animation.mirroredLoop ) {

				if ( animation.time > animation.duration || animation.time < 0 ) {

					animation.direction *= - 1;

					if ( animation.time > animation.duration ) {

						animation.time = animation.duration;
						animation.directionBackwards = true;

					}

					if ( animation.time < 0 ) {

						animation.time = 0;
						animation.directionBackwards = false;

					}

				}

			} else {

				animation.time = animation.time % animation.duration;

				if ( animation.time < 0 ) animation.time += animation.duration;

			}

			var keyframe = animation.start + _Math.clamp( Math.floor( animation.time / frameTime ), 0, animation.length - 1 );
			var weight = animation.weight;

			if ( keyframe !== animation.currentFrame ) {

				this.morphTargetInfluences[ animation.lastFrame ] = 0;
				this.morphTargetInfluences[ animation.currentFrame ] = 1 * weight;

				this.morphTargetInfluences[ keyframe ] = 0;

				animation.lastFrame = animation.currentFrame;
				animation.currentFrame = keyframe;

			}

			var mix = ( animation.time % frameTime ) / frameTime;

			if ( animation.directionBackwards ) mix = 1 - mix;

			if ( animation.currentFrame !== animation.lastFrame ) {

				this.morphTargetInfluences[ animation.currentFrame ] = mix * weight;
				this.morphTargetInfluences[ animation.lastFrame ] = ( 1 - mix ) * weight;

			} else {

				this.morphTargetInfluences[ animation.currentFrame ] = weight;

			}

		}

	};

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	function ImmediateRenderObject( material ) {

		Object3D.call( this );

		this.material = material;
		this.render = function ( renderCallback ) {};

	}

	ImmediateRenderObject.prototype = Object.create( Object3D.prototype );
	ImmediateRenderObject.prototype.constructor = ImmediateRenderObject;

	ImmediateRenderObject.prototype.isImmediateRenderObject = true;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author WestLangley / http://github.com/WestLangley
	*/

	function VertexNormalsHelper( object, size, hex, linewidth ) {

		this.object = object;

		this.size = ( size !== undefined ) ? size : 1;

		var color = ( hex !== undefined ) ? hex : 0xff0000;

		var width = ( linewidth !== undefined ) ? linewidth : 1;

		//

		var nNormals = 0;

		var objGeometry = this.object.geometry;

		if ( objGeometry && objGeometry.isGeometry ) {

			nNormals = objGeometry.faces.length * 3;

		} else if ( objGeometry && objGeometry.isBufferGeometry ) {

			nNormals = objGeometry.attributes.normal.count;

		}

		//

		var geometry = new BufferGeometry();

		var positions = new Float32BufferAttribute( nNormals * 2 * 3, 3 );

		geometry.addAttribute( 'position', positions );

		LineSegments.call( this, geometry, new LineBasicMaterial( { color: color, linewidth: width } ) );

		//

		this.matrixAutoUpdate = false;

		this.update();

	}

	VertexNormalsHelper.prototype = Object.create( LineSegments.prototype );
	VertexNormalsHelper.prototype.constructor = VertexNormalsHelper;

	VertexNormalsHelper.prototype.update = ( function () {

		var v1 = new Vector3();
		var v2 = new Vector3();
		var normalMatrix = new Matrix3();

		return function update() {

			var keys = [ 'a', 'b', 'c' ];

			this.object.updateMatrixWorld( true );

			normalMatrix.getNormalMatrix( this.object.matrixWorld );

			var matrixWorld = this.object.matrixWorld;

			var position = this.geometry.attributes.position;

			//

			var objGeometry = this.object.geometry;

			if ( objGeometry && objGeometry.isGeometry ) {

				var vertices = objGeometry.vertices;

				var faces = objGeometry.faces;

				var idx = 0;

				for ( var i = 0, l = faces.length; i < l; i ++ ) {

					var face = faces[ i ];

					for ( var j = 0, jl = face.vertexNormals.length; j < jl; j ++ ) {

						var vertex = vertices[ face[ keys[ j ] ] ];

						var normal = face.vertexNormals[ j ];

						v1.copy( vertex ).applyMatrix4( matrixWorld );

						v2.copy( normal ).applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );

						position.setXYZ( idx, v1.x, v1.y, v1.z );

						idx = idx + 1;

						position.setXYZ( idx, v2.x, v2.y, v2.z );

						idx = idx + 1;

					}

				}

			} else if ( objGeometry && objGeometry.isBufferGeometry ) {

				var objPos = objGeometry.attributes.position;

				var objNorm = objGeometry.attributes.normal;

				var idx = 0;

				// for simplicity, ignore index and drawcalls, and render every normal

				for ( var j = 0, jl = objPos.count; j < jl; j ++ ) {

					v1.set( objPos.getX( j ), objPos.getY( j ), objPos.getZ( j ) ).applyMatrix4( matrixWorld );

					v2.set( objNorm.getX( j ), objNorm.getY( j ), objNorm.getZ( j ) );

					v2.applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );

					position.setXYZ( idx, v1.x, v1.y, v1.z );

					idx = idx + 1;

					position.setXYZ( idx, v2.x, v2.y, v2.z );

					idx = idx + 1;

				}

			}

			position.needsUpdate = true;

			return this;

		};

	}() );

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author mrdoob / http://mrdoob.com/
	 * @author WestLangley / http://github.com/WestLangley
	*/

	function SpotLightHelper( light ) {

		Object3D.call( this );

		this.light = light;
		this.light.updateMatrixWorld();

		this.matrix = light.matrixWorld;
		this.matrixAutoUpdate = false;

		var geometry = new BufferGeometry();

		var positions = [
			0, 0, 0,   0,   0,   1,
			0, 0, 0,   1,   0,   1,
			0, 0, 0, - 1,   0,   1,
			0, 0, 0,   0,   1,   1,
			0, 0, 0,   0, - 1,   1
		];

		for ( var i = 0, j = 1, l = 32; i < l; i ++, j ++ ) {

			var p1 = ( i / l ) * Math.PI * 2;
			var p2 = ( j / l ) * Math.PI * 2;

			positions.push(
				Math.cos( p1 ), Math.sin( p1 ), 1,
				Math.cos( p2 ), Math.sin( p2 ), 1
			);

		}

		geometry.addAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );

		var material = new LineBasicMaterial( { fog: false } );

		this.cone = new LineSegments( geometry, material );
		this.add( this.cone );

		this.update();

	}

	SpotLightHelper.prototype = Object.create( Object3D.prototype );
	SpotLightHelper.prototype.constructor = SpotLightHelper;

	SpotLightHelper.prototype.dispose = function () {

		this.cone.geometry.dispose();
		this.cone.material.dispose();

	};

	SpotLightHelper.prototype.update = function () {

		var vector = new Vector3();
		var vector2 = new Vector3();

		return function update() {

			var coneLength = this.light.distance ? this.light.distance : 1000;
			var coneWidth = coneLength * Math.tan( this.light.angle );

			this.cone.scale.set( coneWidth, coneWidth, coneLength );

			vector.setFromMatrixPosition( this.light.matrixWorld );
			vector2.setFromMatrixPosition( this.light.target.matrixWorld );

			this.cone.lookAt( vector2.sub( vector ) );

			this.cone.material.color.copy( this.light.color ).multiplyScalar( this.light.intensity );

		};

	}();

	/**
	 * @author Sean Griffin / http://twitter.com/sgrif
	 * @author Michael Guerrero / http://realitymeltdown.com
	 * @author mrdoob / http://mrdoob.com/
	 * @author ikerr / http://verold.com
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	function SkeletonHelper( object ) {

		this.bones = this.getBoneList( object );

		var geometry = new BufferGeometry();

		var vertices = [];
		var colors = [];

		var color1 = new Color( 0, 0, 1 );
		var color2 = new Color( 0, 1, 0 );

		for ( var i = 0; i < this.bones.length; i ++ ) {

			var bone = this.bones[ i ];

			if ( bone.parent && bone.parent.isBone ) {

				vertices.push( 0, 0, 0 );
				vertices.push( 0, 0, 0 );
				colors.push( color1.r, color1.g, color1.b );
				colors.push( color2.r, color2.g, color2.b );

			}

		}

		geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

		var material = new LineBasicMaterial( { vertexColors: VertexColors, depthTest: false, depthWrite: false, transparent: true } );

		LineSegments.call( this, geometry, material );

		this.root = object;

		this.matrix = object.matrixWorld;
		this.matrixAutoUpdate = false;

		this.update();

	}


	SkeletonHelper.prototype = Object.create( LineSegments.prototype );
	SkeletonHelper.prototype.constructor = SkeletonHelper;

	SkeletonHelper.prototype.getBoneList = function( object ) {

		var boneList = [];

		if ( object && object.isBone ) {

			boneList.push( object );

		}

		for ( var i = 0; i < object.children.length; i ++ ) {

			boneList.push.apply( boneList, this.getBoneList( object.children[ i ] ) );

		}

		return boneList;

	};

	SkeletonHelper.prototype.update = function () {

		var vector = new Vector3();

		var boneMatrix = new Matrix4();
		var matrixWorldInv = new Matrix4();

		return function update() {

			var geometry = this.geometry;
			var position = geometry.getAttribute( 'position' );

			matrixWorldInv.getInverse( this.root.matrixWorld );

			for ( var i = 0, j = 0; i < this.bones.length; i ++ ) {

				var bone = this.bones[ i ];

				if ( bone.parent && bone.parent.isBone ) {

					boneMatrix.multiplyMatrices( matrixWorldInv, bone.matrixWorld );
					vector.setFromMatrixPosition( boneMatrix );
					position.setXYZ( j, vector.x, vector.y, vector.z );

					boneMatrix.multiplyMatrices( matrixWorldInv, bone.parent.matrixWorld );
					vector.setFromMatrixPosition( boneMatrix );
					position.setXYZ( j + 1, vector.x, vector.y, vector.z );

					j += 2;

				}

			}

			geometry.getAttribute( 'position' ).needsUpdate = true;

		};

	}();

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author mrdoob / http://mrdoob.com/
	 */

	function PointLightHelper( light, sphereSize ) {

		this.light = light;
		this.light.updateMatrixWorld();

		var geometry = new SphereBufferGeometry( sphereSize, 4, 2 );
		var material = new MeshBasicMaterial( { wireframe: true, fog: false } );
		material.color.copy( this.light.color ).multiplyScalar( this.light.intensity );

		Mesh.call( this, geometry, material );

		this.matrix = this.light.matrixWorld;
		this.matrixAutoUpdate = false;

		/*
		var distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
		var distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

		this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
		this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

		var d = light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.scale.set( d, d, d );

		}

		this.add( this.lightDistance );
		*/

	}

	PointLightHelper.prototype = Object.create( Mesh.prototype );
	PointLightHelper.prototype.constructor = PointLightHelper;

	PointLightHelper.prototype.dispose = function () {

		this.geometry.dispose();
		this.material.dispose();

	};

	PointLightHelper.prototype.update = function () {

		this.material.color.copy( this.light.color ).multiplyScalar( this.light.intensity );

		/*
		var d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/

	};

	/**
	 * @author abelnation / http://github.com/abelnation
	 * @author Mugen87 / http://github.com/Mugen87
	 */

	function RectAreaLightHelper( light ) {

		Object3D.call( this );

		this.light = light;
		this.light.updateMatrixWorld();

		var materialFront = new MeshBasicMaterial( {
			color: light.color,
			fog: false
		} );

		var materialBack = new MeshBasicMaterial( {
			color: light.color,
			fog: false,
			wireframe: true
		} );

		var geometry = new BufferGeometry();

		geometry.addAttribute( 'position', new BufferAttribute( new Float32Array( 6 * 3 ), 3 ) );

		// shows the "front" of the light, e.g. where light comes from

		this.add( new Mesh( geometry, materialFront ) );

		// shows the "back" of the light, which does not emit light

		this.add( new Mesh( geometry, materialBack ) );

		this.update();

	}

	RectAreaLightHelper.prototype = Object.create( Object3D.prototype );
	RectAreaLightHelper.prototype.constructor = RectAreaLightHelper;

	RectAreaLightHelper.prototype.dispose = function () {

		this.children[ 0 ].geometry.dispose();
		this.children[ 0 ].material.dispose();
		this.children[ 1 ].geometry.dispose();
		this.children[ 1 ].material.dispose();

	};

	RectAreaLightHelper.prototype.update = function () {

		var vector1 = new Vector3();
		var vector2 = new Vector3();

		return function update() {

			var mesh1 = this.children[ 0 ];
			var mesh2 = this.children[ 1 ];

			if ( this.light.target ) {

				vector1.setFromMatrixPosition( this.light.matrixWorld );
				vector2.setFromMatrixPosition( this.light.target.matrixWorld );

				var lookVec = vector2.clone().sub( vector1 );
				mesh1.lookAt( lookVec );
				mesh2.lookAt( lookVec );

			}

			// update materials

			mesh1.material.color.copy( this.light.color ).multiplyScalar( this.light.intensity );
			mesh2.material.color.copy( this.light.color ).multiplyScalar( this.light.intensity );

			// calculate new dimensions of the helper

			var hx = this.light.width * 0.5;
			var hy = this.light.height * 0.5;

			// because the buffer attribute is shared over both geometries, we only have to update once

			var position = mesh1.geometry.getAttribute( 'position' );
			var array = position.array;

			// first face

			array[  0 ] =   hx; array[  1 ] = - hy; array[  2 ] = 0;
			array[  3 ] =   hx; array[  4 ] =   hy; array[  5 ] = 0;
			array[  6 ] = - hx; array[  7 ] =   hy; array[  8 ] = 0;

			// second face

			array[  9 ] = - hx; array[ 10 ] =   hy; array[ 11 ] = 0;
			array[ 12 ] = - hx; array[ 13 ] = - hy; array[ 14 ] = 0;
			array[ 15 ] =   hx; array[ 16 ] = - hy; array[ 17 ] = 0;

			position.needsUpdate = true;

		};

	}();

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author mrdoob / http://mrdoob.com/
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	function HemisphereLightHelper( light, size ) {

		Object3D.call( this );

		this.light = light;
		this.light.updateMatrixWorld();

		this.matrix = light.matrixWorld;
		this.matrixAutoUpdate = false;

		var geometry = new OctahedronBufferGeometry( size );
		geometry.rotateY( Math.PI * 0.5 );

		var material = new MeshBasicMaterial( { vertexColors: VertexColors, wireframe: true } );

		var position = geometry.getAttribute( 'position' );
		var colors = new Float32Array( position.count * 3 );

		geometry.addAttribute( 'color', new BufferAttribute( colors, 3 ) );

		this.add( new Mesh( geometry, material ) );

		this.update();

	}

	HemisphereLightHelper.prototype = Object.create( Object3D.prototype );
	HemisphereLightHelper.prototype.constructor = HemisphereLightHelper;

	HemisphereLightHelper.prototype.dispose = function () {

		this.children[ 0 ].geometry.dispose();
		this.children[ 0 ].material.dispose();

	};

	HemisphereLightHelper.prototype.update = function () {

		var vector = new Vector3();

		var color1 = new Color();
		var color2 = new Color();

		return function update() {

			var mesh = this.children[ 0 ];

			var colors = mesh.geometry.getAttribute( 'color' );

			color1.copy( this.light.color ).multiplyScalar( this.light.intensity );
			color2.copy( this.light.groundColor ).multiplyScalar( this.light.intensity );

			for ( var i = 0, l = colors.count; i < l; i ++ ) {

				var color = ( i < ( l / 2 ) ) ? color1 : color2;

				colors.setXYZ( i, color.r, color.g, color.b );

			}

			mesh.lookAt( vector.setFromMatrixPosition( this.light.matrixWorld ).negate() );

			colors.needsUpdate = true;

		};

	}();

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function GridHelper( size, divisions, color1, color2 ) {

		size = size || 10;
		divisions = divisions || 10;
		color1 = new Color( color1 !== undefined ? color1 : 0x444444 );
		color2 = new Color( color2 !== undefined ? color2 : 0x888888 );

		var center = divisions / 2;
		var step = ( size * 2 ) / divisions;
		var vertices = [], colors = [];

		for ( var i = 0, j = 0, k = - size; i <= divisions; i ++, k += step ) {

			vertices.push( - size, 0, k, size, 0, k );
			vertices.push( k, 0, - size, k, 0, size );

			var color = i === center ? color1 : color2;

			color.toArray( colors, j ); j += 3;
			color.toArray( colors, j ); j += 3;
			color.toArray( colors, j ); j += 3;
			color.toArray( colors, j ); j += 3;

		}

		var geometry = new BufferGeometry();
		geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

		var material = new LineBasicMaterial( { vertexColors: VertexColors } );

		LineSegments.call( this, geometry, material );

	}

	GridHelper.prototype = Object.create( LineSegments.prototype );
	GridHelper.prototype.constructor = GridHelper;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author Mugen87 / http://github.com/Mugen87
	 * @author Hectate / http://www.github.com/Hectate
	 */

	function PolarGridHelper( radius, radials, circles, divisions, color1, color2 ) {

		radius = radius || 10;
		radials = radials || 16;
		circles = circles || 8;
		divisions = divisions || 64;
		color1 = new Color( color1 !== undefined ? color1 : 0x444444 );
		color2 = new Color( color2 !== undefined ? color2 : 0x888888 );

		var vertices = [];
		var colors = [];

		var x, z;
		var v, i, j, r, color;

		// create the radials

		for ( i = 0; i <= radials; i ++ ) {

			v = ( i / radials ) * ( Math.PI * 2 );

			x = Math.sin( v ) * radius;
			z = Math.cos( v ) * radius;

			vertices.push( 0, 0, 0 );
			vertices.push( x, 0, z );

			color = ( i & 1 ) ? color1 : color2;

			colors.push( color.r, color.g, color.b );
			colors.push( color.r, color.g, color.b );

		}

		// create the circles

		for ( i = 0; i <= circles; i ++ ) {

			color = ( i & 1 ) ? color1 : color2;

			r = radius - ( radius / circles * i );

			for ( j = 0; j < divisions; j ++ ) {

				// first vertex

				v = ( j / divisions ) * ( Math.PI * 2 );

				x = Math.sin( v ) * r;
				z = Math.cos( v ) * r;

				vertices.push( x, 0, z );
				colors.push( color.r, color.g, color.b );

				// second vertex

				v = ( ( j + 1 ) / divisions ) * ( Math.PI * 2 );

				x = Math.sin( v ) * r;
				z = Math.cos( v ) * r;

				vertices.push( x, 0, z );
				colors.push( color.r, color.g, color.b );

			}

		}

		var geometry = new BufferGeometry();
		geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

		var material = new LineBasicMaterial( { vertexColors: VertexColors } );

		LineSegments.call( this, geometry, material );

	}

	PolarGridHelper.prototype = Object.create( LineSegments.prototype );
	PolarGridHelper.prototype.constructor = PolarGridHelper;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author WestLangley / http://github.com/WestLangley
	*/

	function FaceNormalsHelper( object, size, hex, linewidth ) {

		// FaceNormalsHelper only supports THREE.Geometry

		this.object = object;

		this.size = ( size !== undefined ) ? size : 1;

		var color = ( hex !== undefined ) ? hex : 0xffff00;

		var width = ( linewidth !== undefined ) ? linewidth : 1;

		//

		var nNormals = 0;

		var objGeometry = this.object.geometry;

		if ( objGeometry && objGeometry.isGeometry ) {

			nNormals = objGeometry.faces.length;

		} else {

			console.warn( 'THREE.FaceNormalsHelper: only THREE.Geometry is supported. Use THREE.VertexNormalsHelper, instead.' );

		}

		//

		var geometry = new BufferGeometry();

		var positions = new Float32BufferAttribute( nNormals * 2 * 3, 3 );

		geometry.addAttribute( 'position', positions );

		LineSegments.call( this, geometry, new LineBasicMaterial( { color: color, linewidth: width } ) );

		//

		this.matrixAutoUpdate = false;
		this.update();

	}

	FaceNormalsHelper.prototype = Object.create( LineSegments.prototype );
	FaceNormalsHelper.prototype.constructor = FaceNormalsHelper;

	FaceNormalsHelper.prototype.update = ( function () {

		var v1 = new Vector3();
		var v2 = new Vector3();
		var normalMatrix = new Matrix3();

		return function update() {

			this.object.updateMatrixWorld( true );

			normalMatrix.getNormalMatrix( this.object.matrixWorld );

			var matrixWorld = this.object.matrixWorld;

			var position = this.geometry.attributes.position;

			//

			var objGeometry = this.object.geometry;

			var vertices = objGeometry.vertices;

			var faces = objGeometry.faces;

			var idx = 0;

			for ( var i = 0, l = faces.length; i < l; i ++ ) {

				var face = faces[ i ];

				var normal = face.normal;

				v1.copy( vertices[ face.a ] )
					.add( vertices[ face.b ] )
					.add( vertices[ face.c ] )
					.divideScalar( 3 )
					.applyMatrix4( matrixWorld );

				v2.copy( normal ).applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );

				position.setXYZ( idx, v1.x, v1.y, v1.z );

				idx = idx + 1;

				position.setXYZ( idx, v2.x, v2.y, v2.z );

				idx = idx + 1;

			}

			position.needsUpdate = true;

			return this;

		};

	}() );

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author mrdoob / http://mrdoob.com/
	 * @author WestLangley / http://github.com/WestLangley
	 */

	function DirectionalLightHelper( light, size ) {

		Object3D.call( this );

		this.light = light;
		this.light.updateMatrixWorld();

		this.matrix = light.matrixWorld;
		this.matrixAutoUpdate = false;

		if ( size === undefined ) size = 1;

		var geometry = new BufferGeometry();
		geometry.addAttribute( 'position', new Float32BufferAttribute( [
			- size,   size, 0,
			  size,   size, 0,
			  size, - size, 0,
			- size, - size, 0,
			- size,   size, 0
		], 3 ) );

		var material = new LineBasicMaterial( { fog: false } );

		this.add( new Line( geometry, material ) );

		geometry = new BufferGeometry();
		geometry.addAttribute( 'position', new Float32BufferAttribute( [ 0, 0, 0, 0, 0, 1 ], 3 ) );

		this.add( new Line( geometry, material ));

		this.update();

	}

	DirectionalLightHelper.prototype = Object.create( Object3D.prototype );
	DirectionalLightHelper.prototype.constructor = DirectionalLightHelper;

	DirectionalLightHelper.prototype.dispose = function () {

		var lightPlane = this.children[ 0 ];
		var targetLine = this.children[ 1 ];

		lightPlane.geometry.dispose();
		lightPlane.material.dispose();
		targetLine.geometry.dispose();
		targetLine.material.dispose();

	};

	DirectionalLightHelper.prototype.update = function () {

		var v1 = new Vector3();
		var v2 = new Vector3();
		var v3 = new Vector3();

		return function update() {

			v1.setFromMatrixPosition( this.light.matrixWorld );
			v2.setFromMatrixPosition( this.light.target.matrixWorld );
			v3.subVectors( v2, v1 );

			var lightPlane = this.children[ 0 ];
			var targetLine = this.children[ 1 ];

			lightPlane.lookAt( v3 );
			lightPlane.material.color.copy( this.light.color ).multiplyScalar( this.light.intensity );

			targetLine.lookAt( v3 );
			targetLine.scale.z = v3.length();

		};

	}();

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author Mugen87 / https://github.com/Mugen87
	 *
	 *	- shows frustum, line of sight and up of the camera
	 *	- suitable for fast updates
	 * 	- based on frustum visualization in lightgl.js shadowmap example
	 *		http://evanw.github.com/lightgl.js/tests/shadowmap.html
	 */

	function CameraHelper( camera ) {

		var geometry = new BufferGeometry();
		var material = new LineBasicMaterial( { color: 0xffffff, vertexColors: FaceColors } );

		var vertices = [];
		var colors = [];

		var pointMap = {};

		// colors

		var colorFrustum = new Color( 0xffaa00 );
		var colorCone = new Color( 0xff0000 );
		var colorUp = new Color( 0x00aaff );
		var colorTarget = new Color( 0xffffff );
		var colorCross = new Color( 0x333333 );

		// near

		addLine( "n1", "n2", colorFrustum );
		addLine( "n2", "n4", colorFrustum );
		addLine( "n4", "n3", colorFrustum );
		addLine( "n3", "n1", colorFrustum );

		// far

		addLine( "f1", "f2", colorFrustum );
		addLine( "f2", "f4", colorFrustum );
		addLine( "f4", "f3", colorFrustum );
		addLine( "f3", "f1", colorFrustum );

		// sides

		addLine( "n1", "f1", colorFrustum );
		addLine( "n2", "f2", colorFrustum );
		addLine( "n3", "f3", colorFrustum );
		addLine( "n4", "f4", colorFrustum );

		// cone

		addLine( "p", "n1", colorCone );
		addLine( "p", "n2", colorCone );
		addLine( "p", "n3", colorCone );
		addLine( "p", "n4", colorCone );

		// up

		addLine( "u1", "u2", colorUp );
		addLine( "u2", "u3", colorUp );
		addLine( "u3", "u1", colorUp );

		// target

		addLine( "c", "t", colorTarget );
		addLine( "p", "c", colorCross );

		// cross

		addLine( "cn1", "cn2", colorCross );
		addLine( "cn3", "cn4", colorCross );

		addLine( "cf1", "cf2", colorCross );
		addLine( "cf3", "cf4", colorCross );

		function addLine( a, b, color ) {

			addPoint( a, color );
			addPoint( b, color );

		}

		function addPoint( id, color ) {

			vertices.push( 0, 0, 0 );
			colors.push( color.r, color.g, color.b );

			if ( pointMap[ id ] === undefined ) {

				pointMap[ id ] = [];

			}

			pointMap[ id ].push( ( vertices.length / 3 ) - 1 );

		}

		geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

		LineSegments.call( this, geometry, material );

		this.camera = camera;
		if ( this.camera.updateProjectionMatrix ) this.camera.updateProjectionMatrix();

		this.matrix = camera.matrixWorld;
		this.matrixAutoUpdate = false;

		this.pointMap = pointMap;

		this.update();

	}

	CameraHelper.prototype = Object.create( LineSegments.prototype );
	CameraHelper.prototype.constructor = CameraHelper;

	CameraHelper.prototype.update = function () {

		var geometry, pointMap;

		var vector = new Vector3();
		var camera = new Camera();

		function setPoint( point, x, y, z ) {

			vector.set( x, y, z ).unproject( camera );

			var points = pointMap[ point ];

			if ( points !== undefined ) {

				var position = geometry.getAttribute( 'position' );

				for ( var i = 0, l = points.length; i < l; i ++ ) {

					position.setXYZ( points[ i ], vector.x, vector.y, vector.z );

				}

			}

		}

		return function update() {

			geometry = this.geometry;
			pointMap = this.pointMap;

			var w = 1, h = 1;

			// we need just camera projection matrix
			// world matrix must be identity

			camera.projectionMatrix.copy( this.camera.projectionMatrix );

			// center / target

			setPoint( "c", 0, 0, - 1 );
			setPoint( "t", 0, 0,  1 );

			// near

			setPoint( "n1", - w, - h, - 1 );
			setPoint( "n2",   w, - h, - 1 );
			setPoint( "n3", - w,   h, - 1 );
			setPoint( "n4",   w,   h, - 1 );

			// far

			setPoint( "f1", - w, - h, 1 );
			setPoint( "f2",   w, - h, 1 );
			setPoint( "f3", - w,   h, 1 );
			setPoint( "f4",   w,   h, 1 );

			// up

			setPoint( "u1",   w * 0.7, h * 1.1, - 1 );
			setPoint( "u2", - w * 0.7, h * 1.1, - 1 );
			setPoint( "u3",         0, h * 2,   - 1 );

			// cross

			setPoint( "cf1", - w,   0, 1 );
			setPoint( "cf2",   w,   0, 1 );
			setPoint( "cf3",   0, - h, 1 );
			setPoint( "cf4",   0,   h, 1 );

			setPoint( "cn1", - w,   0, - 1 );
			setPoint( "cn2",   w,   0, - 1 );
			setPoint( "cn3",   0, - h, - 1 );
			setPoint( "cn4",   0,   h, - 1 );

			geometry.getAttribute( 'position' ).needsUpdate = true;

		};

	}();

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function BoxHelper( object, color ) {

		if ( color === undefined ) color = 0xffff00;

		var indices = new Uint16Array( [ 0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7 ] );
		var positions = new Float32Array( 8 * 3 );

		var geometry = new BufferGeometry();
		geometry.setIndex( new BufferAttribute( indices, 1 ) );
		geometry.addAttribute( 'position', new BufferAttribute( positions, 3 ) );

		LineSegments.call( this, geometry, new LineBasicMaterial( { color: color } ) );

		if ( object !== undefined ) {

			this.update( object );

		}

	}

	BoxHelper.prototype = Object.create( LineSegments.prototype );
	BoxHelper.prototype.constructor = BoxHelper;

	BoxHelper.prototype.update = ( function () {

		var box = new Box3();

		return function update( object ) {

			if ( object && object.isBox3 ) {

				box.copy( object );

			} else {

				box.setFromObject( object );

			}

			if ( box.isEmpty() ) return;

			var min = box.min;
			var max = box.max;

			/*
			  5____4
			1/___0/|
			| 6__|_7
			2/___3/

			0: max.x, max.y, max.z
			1: min.x, max.y, max.z
			2: min.x, min.y, max.z
			3: max.x, min.y, max.z
			4: max.x, max.y, min.z
			5: min.x, max.y, min.z
			6: min.x, min.y, min.z
			7: max.x, min.y, min.z
			*/

			var position = this.geometry.attributes.position;
			var array = position.array;

			array[  0 ] = max.x; array[  1 ] = max.y; array[  2 ] = max.z;
			array[  3 ] = min.x; array[  4 ] = max.y; array[  5 ] = max.z;
			array[  6 ] = min.x; array[  7 ] = min.y; array[  8 ] = max.z;
			array[  9 ] = max.x; array[ 10 ] = min.y; array[ 11 ] = max.z;
			array[ 12 ] = max.x; array[ 13 ] = max.y; array[ 14 ] = min.z;
			array[ 15 ] = min.x; array[ 16 ] = max.y; array[ 17 ] = min.z;
			array[ 18 ] = min.x; array[ 19 ] = min.y; array[ 20 ] = min.z;
			array[ 21 ] = max.x; array[ 22 ] = min.y; array[ 23 ] = min.z;

			position.needsUpdate = true;

			this.geometry.computeBoundingSphere();

		};

	} )();

	/**
	 * @author WestLangley / http://github.com/WestLangley
	 * @author zz85 / http://github.com/zz85
	 * @author bhouston / http://clara.io
	 *
	 * Creates an arrow for visualizing directions
	 *
	 * Parameters:
	 *  dir - Vector3
	 *  origin - Vector3
	 *  length - Number
	 *  color - color in hex value
	 *  headLength - Number
	 *  headWidth - Number
	 */

	var lineGeometry = new BufferGeometry();
	lineGeometry.addAttribute( 'position', new Float32BufferAttribute( [ 0, 0, 0, 0, 1, 0 ], 3 ) );

	var coneGeometry = new CylinderBufferGeometry( 0, 0.5, 1, 5, 1 );
	coneGeometry.translate( 0, - 0.5, 0 );

	function ArrowHelper( dir, origin, length, color, headLength, headWidth ) {

		// dir is assumed to be normalized

		Object3D.call( this );

		if ( color === undefined ) color = 0xffff00;
		if ( length === undefined ) length = 1;
		if ( headLength === undefined ) headLength = 0.2 * length;
		if ( headWidth === undefined ) headWidth = 0.2 * headLength;

		this.position.copy( origin );

		this.line = new Line( lineGeometry, new LineBasicMaterial( { color: color } ) );
		this.line.matrixAutoUpdate = false;
		this.add( this.line );

		this.cone = new Mesh( coneGeometry, new MeshBasicMaterial( { color: color } ) );
		this.cone.matrixAutoUpdate = false;
		this.add( this.cone );

		this.setDirection( dir );
		this.setLength( length, headLength, headWidth );

	}

	ArrowHelper.prototype = Object.create( Object3D.prototype );
	ArrowHelper.prototype.constructor = ArrowHelper;

	ArrowHelper.prototype.setDirection = ( function () {

		var axis = new Vector3();
		var radians;

		return function setDirection( dir ) {

			// dir is assumed to be normalized

			if ( dir.y > 0.99999 ) {

				this.quaternion.set( 0, 0, 0, 1 );

			} else if ( dir.y < - 0.99999 ) {

				this.quaternion.set( 1, 0, 0, 0 );

			} else {

				axis.set( dir.z, 0, - dir.x ).normalize();

				radians = Math.acos( dir.y );

				this.quaternion.setFromAxisAngle( axis, radians );

			}

		};

	}() );

	ArrowHelper.prototype.setLength = function ( length, headLength, headWidth ) {

		if ( headLength === undefined ) headLength = 0.2 * length;
		if ( headWidth === undefined ) headWidth = 0.2 * headLength;

		this.line.scale.set( 1, Math.max( 0, length - headLength ), 1 );
		this.line.updateMatrix();

		this.cone.scale.set( headWidth, headLength, headWidth );
		this.cone.position.y = length;
		this.cone.updateMatrix();

	};

	ArrowHelper.prototype.setColor = function ( color ) {

		this.line.material.color.copy( color );
		this.cone.material.color.copy( color );

	};

	/**
	 * @author sroucheray / http://sroucheray.org/
	 * @author mrdoob / http://mrdoob.com/
	 */

	function AxisHelper( size ) {

		size = size || 1;

		var vertices = [
			0, 0, 0,  size, 0, 0,
			0, 0, 0,  0, size, 0,
			0, 0, 0,  0, 0, size
		];

		var colors = [
			1, 0, 0,  1, 0.6, 0,
			0, 1, 0,  0.6, 1, 0,
			0, 0, 1,  0, 0.6, 1
		];

		var geometry = new BufferGeometry();
		geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

		var material = new LineBasicMaterial( { vertexColors: VertexColors } );

		LineSegments.call( this, geometry, material );

	}

	AxisHelper.prototype = Object.create( LineSegments.prototype );
	AxisHelper.prototype.constructor = AxisHelper;

	/**
	 * @author zz85 https://github.com/zz85
	 *
	 * Centripetal CatmullRom Curve - which is useful for avoiding
	 * cusps and self-intersections in non-uniform catmull rom curves.
	 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
	 *
	 * curve.type accepts centripetal(default), chordal and catmullrom
	 * curve.tension is used for catmullrom which defaults to 0.5
	 */

	var CatmullRomCurve3 = ( function() {

		var
			tmp = new Vector3(),
			px = new CubicPoly(),
			py = new CubicPoly(),
			pz = new CubicPoly();

		/*
		Based on an optimized c++ solution in
		 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
		 - http://ideone.com/NoEbVM

		This CubicPoly class could be used for reusing some variables and calculations,
		but for three.js curve use, it could be possible inlined and flatten into a single function call
		which can be placed in CurveUtils.
		*/

		function CubicPoly() {}

		/*
		 * Compute coefficients for a cubic polynomial
		 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
		 * such that
		 *   p(0) = x0, p(1) = x1
		 *  and
		 *   p'(0) = t0, p'(1) = t1.
		 */
		CubicPoly.prototype.init = function( x0, x1, t0, t1 ) {

			this.c0 = x0;
			this.c1 = t0;
			this.c2 = - 3 * x0 + 3 * x1 - 2 * t0 - t1;
			this.c3 = 2 * x0 - 2 * x1 + t0 + t1;

		};

		CubicPoly.prototype.initNonuniformCatmullRom = function( x0, x1, x2, x3, dt0, dt1, dt2 ) {

			// compute tangents when parameterized in [t1,t2]
			var t1 = ( x1 - x0 ) / dt0 - ( x2 - x0 ) / ( dt0 + dt1 ) + ( x2 - x1 ) / dt1;
			var t2 = ( x2 - x1 ) / dt1 - ( x3 - x1 ) / ( dt1 + dt2 ) + ( x3 - x2 ) / dt2;

			// rescale tangents for parametrization in [0,1]
			t1 *= dt1;
			t2 *= dt1;

			// initCubicPoly
			this.init( x1, x2, t1, t2 );

		};

		// standard Catmull-Rom spline: interpolate between x1 and x2 with previous/following points x1/x4
		CubicPoly.prototype.initCatmullRom = function( x0, x1, x2, x3, tension ) {

			this.init( x1, x2, tension * ( x2 - x0 ), tension * ( x3 - x1 ) );

		};

		CubicPoly.prototype.calc = function( t ) {

			var t2 = t * t;
			var t3 = t2 * t;
			return this.c0 + this.c1 * t + this.c2 * t2 + this.c3 * t3;

		};

		// Subclass Three.js curve
		return Curve.create(

			function ( p /* array of Vector3 */ ) {

				this.points = p || [];
				this.closed = false;

			},

			function ( t ) {

				var points = this.points,
					point, intPoint, weight, l;

				l = points.length;

				if ( l < 2 ) console.log( 'duh, you need at least 2 points' );

				point = ( l - ( this.closed ? 0 : 1 ) ) * t;
				intPoint = Math.floor( point );
				weight = point - intPoint;

				if ( this.closed ) {

					intPoint += intPoint > 0 ? 0 : ( Math.floor( Math.abs( intPoint ) / points.length ) + 1 ) * points.length;

				} else if ( weight === 0 && intPoint === l - 1 ) {

					intPoint = l - 2;
					weight = 1;

				}

				var p0, p1, p2, p3; // 4 points

				if ( this.closed || intPoint > 0 ) {

					p0 = points[ ( intPoint - 1 ) % l ];

				} else {

					// extrapolate first point
					tmp.subVectors( points[ 0 ], points[ 1 ] ).add( points[ 0 ] );
					p0 = tmp;

				}

				p1 = points[ intPoint % l ];
				p2 = points[ ( intPoint + 1 ) % l ];

				if ( this.closed || intPoint + 2 < l ) {

					p3 = points[ ( intPoint + 2 ) % l ];

				} else {

					// extrapolate last point
					tmp.subVectors( points[ l - 1 ], points[ l - 2 ] ).add( points[ l - 1 ] );
					p3 = tmp;

				}

				if ( this.type === undefined || this.type === 'centripetal' || this.type === 'chordal' ) {

					// init Centripetal / Chordal Catmull-Rom
					var pow = this.type === 'chordal' ? 0.5 : 0.25;
					var dt0 = Math.pow( p0.distanceToSquared( p1 ), pow );
					var dt1 = Math.pow( p1.distanceToSquared( p2 ), pow );
					var dt2 = Math.pow( p2.distanceToSquared( p3 ), pow );

					// safety check for repeated points
					if ( dt1 < 1e-4 ) dt1 = 1.0;
					if ( dt0 < 1e-4 ) dt0 = dt1;
					if ( dt2 < 1e-4 ) dt2 = dt1;

					px.initNonuniformCatmullRom( p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2 );
					py.initNonuniformCatmullRom( p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2 );
					pz.initNonuniformCatmullRom( p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2 );

				} else if ( this.type === 'catmullrom' ) {

					var tension = this.tension !== undefined ? this.tension : 0.5;
					px.initCatmullRom( p0.x, p1.x, p2.x, p3.x, tension );
					py.initCatmullRom( p0.y, p1.y, p2.y, p3.y, tension );
					pz.initCatmullRom( p0.z, p1.z, p2.z, p3.z, tension );

				}

				var v = new Vector3(
					px.calc( weight ),
					py.calc( weight ),
					pz.calc( weight )
				);

				return v;

			}

		);

	} )();

	/**************************************************************
	 *	Spline 3D curve
	 **************************************************************/


	var SplineCurve3 = Curve.create(

		function ( points /* array of Vector3 */ ) {

			console.warn( 'THREE.SplineCurve3 will be deprecated. Please use THREE.CatmullRomCurve3' );
			this.points = ( points === undefined ) ? [] : points;

		},

		function ( t ) {

			var points = this.points;
			var point = ( points.length - 1 ) * t;

			var intPoint = Math.floor( point );
			var weight = point - intPoint;

			var point0 = points[ intPoint == 0 ? intPoint : intPoint - 1 ];
			var point1 = points[ intPoint ];
			var point2 = points[ intPoint > points.length - 2 ? points.length - 1 : intPoint + 1 ];
			var point3 = points[ intPoint > points.length - 3 ? points.length - 1 : intPoint + 2 ];

			var interpolate = CurveUtils.interpolate;

			return new Vector3(
				interpolate( point0.x, point1.x, point2.x, point3.x, weight ),
				interpolate( point0.y, point1.y, point2.y, point3.y, weight ),
				interpolate( point0.z, point1.z, point2.z, point3.z, weight )
			);

		}

	);

	/**************************************************************
	 *	Cubic Bezier 3D curve
	 **************************************************************/

	var CubicBezierCurve3 = Curve.create(

		function ( v0, v1, v2, v3 ) {

			this.v0 = v0;
			this.v1 = v1;
			this.v2 = v2;
			this.v3 = v3;

		},

		function ( t ) {

			var b3 = ShapeUtils.b3;

			return new Vector3(
				b3( t, this.v0.x, this.v1.x, this.v2.x, this.v3.x ),
				b3( t, this.v0.y, this.v1.y, this.v2.y, this.v3.y ),
				b3( t, this.v0.z, this.v1.z, this.v2.z, this.v3.z )
			);

		}

	);

	/**************************************************************
	 *	Quadratic Bezier 3D curve
	 **************************************************************/

	var QuadraticBezierCurve3 = Curve.create(

		function ( v0, v1, v2 ) {

			this.v0 = v0;
			this.v1 = v1;
			this.v2 = v2;

		},

		function ( t ) {

			var b2 = ShapeUtils.b2;

			return new Vector3(
				b2( t, this.v0.x, this.v1.x, this.v2.x ),
				b2( t, this.v0.y, this.v1.y, this.v2.y ),
				b2( t, this.v0.z, this.v1.z, this.v2.z )
			);

		}

	);

	/**************************************************************
	 *	Line3D
	 **************************************************************/

	var LineCurve3 = Curve.create(

		function ( v1, v2 ) {

			this.v1 = v1;
			this.v2 = v2;

		},

		function ( t ) {

			if ( t === 1 ) {

				return this.v2.clone();

			}

			var vector = new Vector3();

			vector.subVectors( this.v2, this.v1 ); // diff
			vector.multiplyScalar( t );
			vector.add( this.v1 );

			return vector;

		}

	);

	/**************************************************************
	 *	Arc curve
	 **************************************************************/

	function ArcCurve( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {

		EllipseCurve.call( this, aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise );

	}

	ArcCurve.prototype = Object.create( EllipseCurve.prototype );
	ArcCurve.prototype.constructor = ArcCurve;

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	var SceneUtils = {

		createMultiMaterialObject: function ( geometry, materials ) {

			var group = new Group();

			for ( var i = 0, l = materials.length; i < l; i ++ ) {

				group.add( new Mesh( geometry, materials[ i ] ) );

			}

			return group;

		},

		detach: function ( child, parent, scene ) {

			child.applyMatrix( parent.matrixWorld );
			parent.remove( child );
			scene.add( child );

		},

		attach: function ( child, scene, parent ) {

			var matrixWorldInverse = new Matrix4();
			matrixWorldInverse.getInverse( parent.matrixWorld );
			child.applyMatrix( matrixWorldInverse );

			scene.remove( child );
			parent.add( child );

		}

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function Face4( a, b, c, d, normal, color, materialIndex ) {

		console.warn( 'THREE.Face4 has been removed. A THREE.Face3 will be created instead.' );
		return new Face3( a, b, c, normal, color, materialIndex );

	}

	var LineStrip = 0;

	var LinePieces = 1;

	function MeshFaceMaterial( materials ) {

		console.warn( 'THREE.MeshFaceMaterial has been renamed to THREE.MultiMaterial.' );
		return new MultiMaterial( materials );

	}

	function PointCloud( geometry, material ) {

		console.warn( 'THREE.PointCloud has been renamed to THREE.Points.' );
		return new Points( geometry, material );

	}

	function Particle( material ) {

		console.warn( 'THREE.Particle has been renamed to THREE.Sprite.' );
		return new Sprite( material );

	}

	function ParticleSystem( geometry, material ) {

		console.warn( 'THREE.ParticleSystem has been renamed to THREE.Points.' );
		return new Points( geometry, material );

	}

	function PointCloudMaterial( parameters ) {

		console.warn( 'THREE.PointCloudMaterial has been renamed to THREE.PointsMaterial.' );
		return new PointsMaterial( parameters );

	}

	function ParticleBasicMaterial( parameters ) {

		console.warn( 'THREE.ParticleBasicMaterial has been renamed to THREE.PointsMaterial.' );
		return new PointsMaterial( parameters );

	}

	function ParticleSystemMaterial( parameters ) {

		console.warn( 'THREE.ParticleSystemMaterial has been renamed to THREE.PointsMaterial.' );
		return new PointsMaterial( parameters );

	}

	function Vertex( x, y, z ) {

		console.warn( 'THREE.Vertex has been removed. Use THREE.Vector3 instead.' );
		return new Vector3( x, y, z );

	}

	//

	function DynamicBufferAttribute( array, itemSize ) {

		console.warn( 'THREE.DynamicBufferAttribute has been removed. Use new THREE.BufferAttribute().setDynamic( true ) instead.' );
		return new BufferAttribute( array, itemSize ).setDynamic( true );

	}

	function Int8Attribute( array, itemSize ) {

		console.warn( 'THREE.Int8Attribute has been removed. Use new THREE.Int8BufferAttribute() instead.' );
		return new Int8BufferAttribute( array, itemSize );

	}

	function Uint8Attribute( array, itemSize ) {

		console.warn( 'THREE.Uint8Attribute has been removed. Use new THREE.Uint8BufferAttribute() instead.' );
		return new Uint8BufferAttribute( array, itemSize );

	}

	function Uint8ClampedAttribute( array, itemSize ) {

		console.warn( 'THREE.Uint8ClampedAttribute has been removed. Use new THREE.Uint8ClampedBufferAttribute() instead.' );
		return new Uint8ClampedBufferAttribute( array, itemSize );

	}

	function Int16Attribute( array, itemSize ) {

		console.warn( 'THREE.Int16Attribute has been removed. Use new THREE.Int16BufferAttribute() instead.' );
		return new Int16BufferAttribute( array, itemSize );

	}

	function Uint16Attribute( array, itemSize ) {

		console.warn( 'THREE.Uint16Attribute has been removed. Use new THREE.Uint16BufferAttribute() instead.' );
		return new Uint16BufferAttribute( array, itemSize );

	}

	function Int32Attribute( array, itemSize ) {

		console.warn( 'THREE.Int32Attribute has been removed. Use new THREE.Int32BufferAttribute() instead.' );
		return new Int32BufferAttribute( array, itemSize );

	}

	function Uint32Attribute( array, itemSize ) {

		console.warn( 'THREE.Uint32Attribute has been removed. Use new THREE.Uint32BufferAttribute() instead.' );
		return new Uint32BufferAttribute( array, itemSize );

	}

	function Float32Attribute( array, itemSize ) {

		console.warn( 'THREE.Float32Attribute has been removed. Use new THREE.Float32BufferAttribute() instead.' );
		return new Float32BufferAttribute( array, itemSize );

	}

	function Float64Attribute( array, itemSize ) {

		console.warn( 'THREE.Float64Attribute has been removed. Use new THREE.Float64BufferAttribute() instead.' );
		return new Float64BufferAttribute( array, itemSize );

	}

	//

	function ClosedSplineCurve3( points ) {

		console.warn( 'THREE.ClosedSplineCurve3 has been deprecated. Use THREE.CatmullRomCurve3 instead.' );

		CatmullRomCurve3.call( this, points );
		this.type = 'catmullrom';
		this.closed = true;

	}

	ClosedSplineCurve3.prototype = Object.create( CatmullRomCurve3.prototype );


	//
	function BoundingBoxHelper( object, color ) {

		console.warn( 'THREE.BoundingBoxHelper has been deprecated. Creating a THREE.BoxHelper instead.' );
		return new BoxHelper( object, color );

	}

	function EdgesHelper( object, hex ) {

		console.warn( 'THREE.EdgesHelper has been removed. Use THREE.EdgesGeometry instead.' );
		return new LineSegments( new EdgesGeometry( object.geometry ), new LineBasicMaterial( { color: hex !== undefined ? hex : 0xffffff } ) );

	}

	GridHelper.prototype.setColors = function () {

		console.error( 'THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.' );

	};

	function WireframeHelper( object, hex ) {

		console.warn( 'THREE.WireframeHelper has been removed. Use THREE.WireframeGeometry instead.' );
		return new LineSegments( new WireframeGeometry( object.geometry ), new LineBasicMaterial( { color: hex !== undefined ? hex : 0xffffff } ) );

	}

	//

	function XHRLoader( manager ) {

		console.warn( 'THREE.XHRLoader has been renamed to THREE.FileLoader.' );
		return new FileLoader( manager );

	}

	//

	Object.assign( Box2.prototype, {

		center: function ( optionalTarget ) {

			console.warn( 'THREE.Box2: .center() has been renamed to .getCenter().' );
			return this.getCenter( optionalTarget );

		},
		empty: function () {

			console.warn( 'THREE.Box2: .empty() has been renamed to .isEmpty().' );
			return this.isEmpty();

		},
		isIntersectionBox: function ( box ) {

			console.warn( 'THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox().' );
			return this.intersectsBox( box );

		},
		size: function ( optionalTarget ) {

			console.warn( 'THREE.Box2: .size() has been renamed to .getSize().' );
			return this.getSize( optionalTarget );

		}
	} );

	Object.assign( Box3.prototype, {

		center: function ( optionalTarget ) {

			console.warn( 'THREE.Box3: .center() has been renamed to .getCenter().' );
			return this.getCenter( optionalTarget );

		},
		empty: function () {

			console.warn( 'THREE.Box3: .empty() has been renamed to .isEmpty().' );
			return this.isEmpty();

		},
		isIntersectionBox: function ( box ) {

			console.warn( 'THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox().' );
			return this.intersectsBox( box );

		},
		isIntersectionSphere: function ( sphere ) {

			console.warn( 'THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere().' );
			return this.intersectsSphere( sphere );

		},
		size: function ( optionalTarget ) {

			console.warn( 'THREE.Box3: .size() has been renamed to .getSize().' );
			return this.getSize( optionalTarget );

		}
	} );

	Line3.prototype.center = function ( optionalTarget ) {

		console.warn( 'THREE.Line3: .center() has been renamed to .getCenter().' );
		return this.getCenter( optionalTarget );

	};

	_Math.random16 = function () {

		console.warn( 'THREE.Math.random16() has been deprecated. Use Math.random() instead.' );
		return Math.random();

	};

	Object.assign( Matrix3.prototype, {

		flattenToArrayOffset: function ( array, offset ) {

			console.warn( "THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead." );
			return this.toArray( array, offset );

		},
		multiplyVector3: function ( vector ) {

			console.warn( 'THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.' );
			return vector.applyMatrix3( this );

		},
		multiplyVector3Array: function ( a ) {

			console.warn( 'THREE.Matrix3: .multiplyVector3Array() has been renamed. Use matrix.applyToVector3Array( array ) instead.' );
			return this.applyToVector3Array( a );

		},
		applyToBuffer: function( buffer, offset, length ) {

			console.warn( 'THREE.Matrix3: .applyToBuffer() has been removed. Use matrix.applyToBufferAttribute( attribute ) instead.' );
			return this.applyToBufferAttribute( buffer );

		}

	} );

	Object.assign( Matrix4.prototype, {

		extractPosition: function ( m ) {

			console.warn( 'THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().' );
			return this.copyPosition( m );

		},
		flattenToArrayOffset: function ( array, offset ) {

			console.warn( "THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead." );
			return this.toArray( array, offset );

		},
		getPosition: function () {

			var v1;

			return function getPosition() {

				if ( v1 === undefined ) v1 = new Vector3();
				console.warn( 'THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.' );
				return v1.setFromMatrixColumn( this, 3 );

			};

		}(),
		setRotationFromQuaternion: function ( q ) {

			console.warn( 'THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().' );
			return this.makeRotationFromQuaternion( q );

		},
		multiplyVector3: function ( vector ) {

			console.warn( 'THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) or vector.applyProjection( matrix ) instead.' );
			return vector.applyProjection( this );

		},
		multiplyVector4: function ( vector ) {

			console.warn( 'THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.' );
			return vector.applyMatrix4( this );

		},
		multiplyVector3Array: function ( a ) {

			console.warn( 'THREE.Matrix4: .multiplyVector3Array() has been renamed. Use matrix.applyToVector3Array( array ) instead.' );
			return this.applyToVector3Array( a );

		},
		rotateAxis: function ( v ) {

			console.warn( 'THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.' );
			v.transformDirection( this );

		},
		crossVector: function ( vector ) {

			console.warn( 'THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.' );
			return vector.applyMatrix4( this );

		},
		translate: function () {

			console.error( 'THREE.Matrix4: .translate() has been removed.' );

		},
		rotateX: function () {

			console.error( 'THREE.Matrix4: .rotateX() has been removed.' );

		},
		rotateY: function () {

			console.error( 'THREE.Matrix4: .rotateY() has been removed.' );

		},
		rotateZ: function () {

			console.error( 'THREE.Matrix4: .rotateZ() has been removed.' );

		},
		rotateByAxis: function () {

			console.error( 'THREE.Matrix4: .rotateByAxis() has been removed.' );

		},
		applyToBuffer: function( buffer, offset, length ) {

			console.warn( 'THREE.Matrix4: .applyToBuffer() has been removed. Use matrix.applyToBufferAttribute( attribute ) instead.' );
			return this.applyToBufferAttribute( buffer );

		}

	} );

	Plane.prototype.isIntersectionLine = function ( line ) {

		console.warn( 'THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine().' );
		return this.intersectsLine( line );

	};

	Quaternion.prototype.multiplyVector3 = function ( vector ) {

		console.warn( 'THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.' );
		return vector.applyQuaternion( this );

	};

	Object.assign( Ray.prototype, {

		isIntersectionBox: function ( box ) {

			console.warn( 'THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox().' );
			return this.intersectsBox( box );

		},
		isIntersectionPlane: function ( plane ) {

			console.warn( 'THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane().' );
			return this.intersectsPlane( plane );

		},
		isIntersectionSphere: function ( sphere ) {

			console.warn( 'THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere().' );
			return this.intersectsSphere( sphere );

		}

	} );

	Object.assign( Shape.prototype, {

		extrude: function ( options ) {

			console.warn( 'THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead.' );
			return new ExtrudeGeometry( this, options );

		},
		makeGeometry: function ( options ) {

			console.warn( 'THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead.' );
			return new ShapeGeometry( this, options );

		}

	} );

	Object.assign( Vector3.prototype, {

		setEulerFromRotationMatrix: function () {

			console.error( 'THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.' );

		},
		setEulerFromQuaternion: function () {

			console.error( 'THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.' );

		},
		getPositionFromMatrix: function ( m ) {

			console.warn( 'THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().' );
			return this.setFromMatrixPosition( m );

		},
		getScaleFromMatrix: function ( m ) {

			console.warn( 'THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().' );
			return this.setFromMatrixScale( m );

		},
		getColumnFromMatrix: function ( index, matrix ) {

			console.warn( 'THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().' );
			return this.setFromMatrixColumn( matrix, index );

		}

	} );

	//

	Geometry.prototype.computeTangents = function () {

		console.warn( 'THREE.Geometry: .computeTangents() has been removed.' );

	};

	Object.assign( Object3D.prototype, {

		getChildByName: function ( name ) {

			console.warn( 'THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().' );
			return this.getObjectByName( name );

		},
		renderDepth: function () {

			console.warn( 'THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.' );

		},
		translate: function ( distance, axis ) {

			console.warn( 'THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.' );
			return this.translateOnAxis( axis, distance );

		}

	} );

	Object.defineProperties( Object3D.prototype, {

		eulerOrder: {
			get: function () {

				console.warn( 'THREE.Object3D: .eulerOrder is now .rotation.order.' );
				return this.rotation.order;

			},
			set: function ( value ) {

				console.warn( 'THREE.Object3D: .eulerOrder is now .rotation.order.' );
				this.rotation.order = value;

			}
		},
		useQuaternion: {
			get: function () {

				console.warn( 'THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.' );

			},
			set: function () {

				console.warn( 'THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.' );

			}
		}

	} );

	Object.defineProperties( LOD.prototype, {

		objects: {
			get: function () {

				console.warn( 'THREE.LOD: .objects has been renamed to .levels.' );
				return this.levels;

			}
		}

	} );

	//

	PerspectiveCamera.prototype.setLens = function ( focalLength, filmGauge ) {

		console.warn( "THREE.PerspectiveCamera.setLens is deprecated. " +
				"Use .setFocalLength and .filmGauge for a photographic setup." );

		if ( filmGauge !== undefined ) this.filmGauge = filmGauge;
		this.setFocalLength( focalLength );

	};

	//

	Object.defineProperties( Light.prototype, {
		onlyShadow: {
			set: function () {

				console.warn( 'THREE.Light: .onlyShadow has been removed.' );

			}
		},
		shadowCameraFov: {
			set: function ( value ) {

				console.warn( 'THREE.Light: .shadowCameraFov is now .shadow.camera.fov.' );
				this.shadow.camera.fov = value;

			}
		},
		shadowCameraLeft: {
			set: function ( value ) {

				console.warn( 'THREE.Light: .shadowCameraLeft is now .shadow.camera.left.' );
				this.shadow.camera.left = value;

			}
		},
		shadowCameraRight: {
			set: function ( value ) {

				console.warn( 'THREE.Light: .shadowCameraRight is now .shadow.camera.right.' );
				this.shadow.camera.right = value;

			}
		},
		shadowCameraTop: {
			set: function ( value ) {

				console.warn( 'THREE.Light: .shadowCameraTop is now .shadow.camera.top.' );
				this.shadow.camera.top = value;

			}
		},
		shadowCameraBottom: {
			set: function ( value ) {

				console.warn( 'THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom.' );
				this.shadow.camera.bottom = value;

			}
		},
		shadowCameraNear: {
			set: function ( value ) {

				console.warn( 'THREE.Light: .shadowCameraNear is now .shadow.camera.near.' );
				this.shadow.camera.near = value;

			}
		},
		shadowCameraFar: {
			set: function ( value ) {

				console.warn( 'THREE.Light: .shadowCameraFar is now .shadow.camera.far.' );
				this.shadow.camera.far = value;

			}
		},
		shadowCameraVisible: {
			set: function () {

				console.warn( 'THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.' );

			}
		},
		shadowBias: {
			set: function ( value ) {

				console.warn( 'THREE.Light: .shadowBias is now .shadow.bias.' );
				this.shadow.bias = value;

			}
		},
		shadowDarkness: {
			set: function () {

				console.warn( 'THREE.Light: .shadowDarkness has been removed.' );

			}
		},
		shadowMapWidth: {
			set: function ( value ) {

				console.warn( 'THREE.Light: .shadowMapWidth is now .shadow.mapSize.width.' );
				this.shadow.mapSize.width = value;

			}
		},
		shadowMapHeight: {
			set: function ( value ) {

				console.warn( 'THREE.Light: .shadowMapHeight is now .shadow.mapSize.height.' );
				this.shadow.mapSize.height = value;

			}
		}
	} );

	//

	Object.defineProperties( BufferAttribute.prototype, {

		length: {
			get: function () {

				console.warn( 'THREE.BufferAttribute: .length has been deprecated. Use .count instead.' );
				return this.array.length;

			}
		}

	} );

	Object.assign( BufferGeometry.prototype, {

		addIndex: function ( index ) {

			console.warn( 'THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().' );
			this.setIndex( index );

		},
		addDrawCall: function ( start, count, indexOffset ) {

			if ( indexOffset !== undefined ) {

				console.warn( 'THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.' );

			}
			console.warn( 'THREE.BufferGeometry: .addDrawCall() is now .addGroup().' );
			this.addGroup( start, count );

		},
		clearDrawCalls: function () {

			console.warn( 'THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().' );
			this.clearGroups();

		},
		computeTangents: function () {

			console.warn( 'THREE.BufferGeometry: .computeTangents() has been removed.' );

		},
		computeOffsets: function () {

			console.warn( 'THREE.BufferGeometry: .computeOffsets() has been removed.' );

		}

	} );

	Object.defineProperties( BufferGeometry.prototype, {

		drawcalls: {
			get: function () {

				console.error( 'THREE.BufferGeometry: .drawcalls has been renamed to .groups.' );
				return this.groups;

			}
		},
		offsets: {
			get: function () {

				console.warn( 'THREE.BufferGeometry: .offsets has been renamed to .groups.' );
				return this.groups;

			}
		}

	} );

	//

	Object.defineProperties( Uniform.prototype, {

		dynamic: {
			set: function () {

				console.warn( 'THREE.Uniform: .dynamic has been removed. Use object.onBeforeRender() instead.' );

			}
		},
		onUpdate: {
			value: function () {

				console.warn( 'THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead.' );
				return this;

			}
		}

	} );

	//

	Object.defineProperties( Material.prototype, {

		wrapAround: {
			get: function () {

				console.warn( 'THREE.' + this.type + ': .wrapAround has been removed.' );

			},
			set: function () {

				console.warn( 'THREE.' + this.type + ': .wrapAround has been removed.' );

			}
		},
		wrapRGB: {
			get: function () {

				console.warn( 'THREE.' + this.type + ': .wrapRGB has been removed.' );
				return new Color();

			}
		}

	} );

	Object.defineProperties( MeshPhongMaterial.prototype, {

		metal: {
			get: function () {

				console.warn( 'THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead.' );
				return false;

			},
			set: function () {

				console.warn( 'THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead' );

			}
		}

	} );

	Object.defineProperties( ShaderMaterial.prototype, {

		derivatives: {
			get: function () {

				console.warn( 'THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives.' );
				return this.extensions.derivatives;

			},
			set: function ( value ) {

				console.warn( 'THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives.' );
				this.extensions.derivatives = value;

			}
		}

	} );

	//

	EventDispatcher.prototype = Object.assign( Object.create( {

		// Note: Extra base ensures these properties are not 'assign'ed.

		constructor: EventDispatcher,

		apply: function ( target ) {

			console.warn( "THREE.EventDispatcher: .apply is deprecated, " +
					"just inherit or Object.assign the prototype to mix-in." );

			Object.assign( target, this );

		}

	} ), EventDispatcher.prototype );

	//

	Object.assign( WebGLRenderer.prototype, {

		supportsFloatTextures: function () {

			console.warn( 'THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( \'OES_texture_float\' ).' );
			return this.extensions.get( 'OES_texture_float' );

		},
		supportsHalfFloatTextures: function () {

			console.warn( 'THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( \'OES_texture_half_float\' ).' );
			return this.extensions.get( 'OES_texture_half_float' );

		},
		supportsStandardDerivatives: function () {

			console.warn( 'THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( \'OES_standard_derivatives\' ).' );
			return this.extensions.get( 'OES_standard_derivatives' );

		},
		supportsCompressedTextureS3TC: function () {

			console.warn( 'THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( \'WEBGL_compressed_texture_s3tc\' ).' );
			return this.extensions.get( 'WEBGL_compressed_texture_s3tc' );

		},
		supportsCompressedTexturePVRTC: function () {

			console.warn( 'THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( \'WEBGL_compressed_texture_pvrtc\' ).' );
			return this.extensions.get( 'WEBGL_compressed_texture_pvrtc' );

		},
		supportsBlendMinMax: function () {

			console.warn( 'THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( \'EXT_blend_minmax\' ).' );
			return this.extensions.get( 'EXT_blend_minmax' );

		},
		supportsVertexTextures: function () {

			console.warn( 'THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures.' );
			return this.capabilities.vertexTextures;

		},
		supportsInstancedArrays: function () {

			console.warn( 'THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( \'ANGLE_instanced_arrays\' ).' );
			return this.extensions.get( 'ANGLE_instanced_arrays' );

		},
		enableScissorTest: function ( boolean ) {

			console.warn( 'THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest().' );
			this.setScissorTest( boolean );

		},
		initMaterial: function () {

			console.warn( 'THREE.WebGLRenderer: .initMaterial() has been removed.' );

		},
		addPrePlugin: function () {

			console.warn( 'THREE.WebGLRenderer: .addPrePlugin() has been removed.' );

		},
		addPostPlugin: function () {

			console.warn( 'THREE.WebGLRenderer: .addPostPlugin() has been removed.' );

		},
		updateShadowMap: function () {

			console.warn( 'THREE.WebGLRenderer: .updateShadowMap() has been removed.' );

		}

	} );

	Object.defineProperties( WebGLRenderer.prototype, {

		shadowMapEnabled: {
			get: function () {

				return this.shadowMap.enabled;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.' );
				this.shadowMap.enabled = value;

			}
		},
		shadowMapType: {
			get: function () {

				return this.shadowMap.type;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.' );
				this.shadowMap.type = value;

			}
		},
		shadowMapCullFace: {
			get: function () {

				return this.shadowMap.cullFace;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderer: .shadowMapCullFace is now .shadowMap.cullFace.' );
				this.shadowMap.cullFace = value;

			}
		}
	} );

	Object.defineProperties( WebGLShadowMap.prototype, {

		cullFace: {
			get: function () {

				return this.renderReverseSided ? CullFaceFront : CullFaceBack;

			},
			set: function ( cullFace ) {

				var value = ( cullFace !== CullFaceBack );
				console.warn( "WebGLRenderer: .shadowMap.cullFace is deprecated. Set .shadowMap.renderReverseSided to " + value + "." );
				this.renderReverseSided = value;

			}
		}

	} );

	//

	Object.defineProperties( WebGLRenderTarget.prototype, {

		wrapS: {
			get: function () {

				console.warn( 'THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.' );
				return this.texture.wrapS;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.' );
				this.texture.wrapS = value;

			}
		},
		wrapT: {
			get: function () {

				console.warn( 'THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.' );
				return this.texture.wrapT;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.' );
				this.texture.wrapT = value;

			}
		},
		magFilter: {
			get: function () {

				console.warn( 'THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.' );
				return this.texture.magFilter;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.' );
				this.texture.magFilter = value;

			}
		},
		minFilter: {
			get: function () {

				console.warn( 'THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.' );
				return this.texture.minFilter;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.' );
				this.texture.minFilter = value;

			}
		},
		anisotropy: {
			get: function () {

				console.warn( 'THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.' );
				return this.texture.anisotropy;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.' );
				this.texture.anisotropy = value;

			}
		},
		offset: {
			get: function () {

				console.warn( 'THREE.WebGLRenderTarget: .offset is now .texture.offset.' );
				return this.texture.offset;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderTarget: .offset is now .texture.offset.' );
				this.texture.offset = value;

			}
		},
		repeat: {
			get: function () {

				console.warn( 'THREE.WebGLRenderTarget: .repeat is now .texture.repeat.' );
				return this.texture.repeat;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderTarget: .repeat is now .texture.repeat.' );
				this.texture.repeat = value;

			}
		},
		format: {
			get: function () {

				console.warn( 'THREE.WebGLRenderTarget: .format is now .texture.format.' );
				return this.texture.format;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderTarget: .format is now .texture.format.' );
				this.texture.format = value;

			}
		},
		type: {
			get: function () {

				console.warn( 'THREE.WebGLRenderTarget: .type is now .texture.type.' );
				return this.texture.type;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderTarget: .type is now .texture.type.' );
				this.texture.type = value;

			}
		},
		generateMipmaps: {
			get: function () {

				console.warn( 'THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.' );
				return this.texture.generateMipmaps;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.' );
				this.texture.generateMipmaps = value;

			}
		}

	} );

	//

	Audio.prototype.load = function ( file ) {

		console.warn( 'THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.' );
		var scope = this;
		var audioLoader = new AudioLoader();
		audioLoader.load( file, function ( buffer ) {

			scope.setBuffer( buffer );

		} );
		return this;

	};

	AudioAnalyser.prototype.getData = function () {

		console.warn( 'THREE.AudioAnalyser: .getData() is now .getFrequencyData().' );
		return this.getFrequencyData();

	};

	//

	var GeometryUtils = {

		merge: function ( geometry1, geometry2, materialIndexOffset ) {

			console.warn( 'THREE.GeometryUtils: .merge() has been moved to Geometry. Use geometry.merge( geometry2, matrix, materialIndexOffset ) instead.' );
			var matrix;

			if ( geometry2.isMesh ) {

				geometry2.matrixAutoUpdate && geometry2.updateMatrix();

				matrix = geometry2.matrix;
				geometry2 = geometry2.geometry;

			}

			geometry1.merge( geometry2, matrix, materialIndexOffset );

		},

		center: function ( geometry ) {

			console.warn( 'THREE.GeometryUtils: .center() has been moved to Geometry. Use geometry.center() instead.' );
			return geometry.center();

		}

	};

	var ImageUtils = {

		crossOrigin: undefined,

		loadTexture: function ( url, mapping, onLoad, onError ) {

			console.warn( 'THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.' );

			var loader = new TextureLoader();
			loader.setCrossOrigin( this.crossOrigin );

			var texture = loader.load( url, onLoad, undefined, onError );

			if ( mapping ) texture.mapping = mapping;

			return texture;

		},

		loadTextureCube: function ( urls, mapping, onLoad, onError ) {

			console.warn( 'THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.' );

			var loader = new CubeTextureLoader();
			loader.setCrossOrigin( this.crossOrigin );

			var texture = loader.load( urls, onLoad, undefined, onError );

			if ( mapping ) texture.mapping = mapping;

			return texture;

		},

		loadCompressedTexture: function () {

			console.error( 'THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.' );

		},

		loadCompressedTextureCube: function () {

			console.error( 'THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.' );

		}

	};

	//

	function Projector() {

		console.error( 'THREE.Projector has been moved to /examples/js/renderers/Projector.js.' );

		this.projectVector = function ( vector, camera ) {

			console.warn( 'THREE.Projector: .projectVector() is now vector.project().' );
			vector.project( camera );

		};

		this.unprojectVector = function ( vector, camera ) {

			console.warn( 'THREE.Projector: .unprojectVector() is now vector.unproject().' );
			vector.unproject( camera );

		};

		this.pickingRay = function () {

			console.error( 'THREE.Projector: .pickingRay() is now raycaster.setFromCamera().' );

		};

	}

	//

	function CanvasRenderer() {

		console.error( 'THREE.CanvasRenderer has been moved to /examples/js/renderers/CanvasRenderer.js' );

		this.domElement = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
		this.clear = function () {};
		this.render = function () {};
		this.setClearColor = function () {};
		this.setSize = function () {};

	}

	exports.WebGLRenderTargetCube = WebGLRenderTargetCube;
	exports.WebGLRenderTarget = WebGLRenderTarget;
	exports.WebGLRenderer = WebGLRenderer;
	exports.ShaderLib = ShaderLib;
	exports.UniformsLib = UniformsLib;
	exports.UniformsUtils = UniformsUtils;
	exports.ShaderChunk = ShaderChunk;
	exports.FogExp2 = FogExp2;
	exports.Fog = Fog;
	exports.Scene = Scene;
	exports.LensFlare = LensFlare;
	exports.Sprite = Sprite;
	exports.LOD = LOD;
	exports.SkinnedMesh = SkinnedMesh;
	exports.Skeleton = Skeleton;
	exports.Bone = Bone;
	exports.Mesh = Mesh;
	exports.LineSegments = LineSegments;
	exports.Line = Line;
	exports.Points = Points;
	exports.Group = Group;
	exports.VideoTexture = VideoTexture;
	exports.DataTexture = DataTexture;
	exports.CompressedTexture = CompressedTexture;
	exports.CubeTexture = CubeTexture;
	exports.CanvasTexture = CanvasTexture;
	exports.DepthTexture = DepthTexture;
	exports.Texture = Texture;
	exports.CompressedTextureLoader = CompressedTextureLoader;
	exports.BinaryTextureLoader = BinaryTextureLoader;
	exports.DataTextureLoader = DataTextureLoader;
	exports.CubeTextureLoader = CubeTextureLoader;
	exports.TextureLoader = TextureLoader;
	exports.ObjectLoader = ObjectLoader;
	exports.MaterialLoader = MaterialLoader;
	exports.BufferGeometryLoader = BufferGeometryLoader;
	exports.DefaultLoadingManager = DefaultLoadingManager;
	exports.LoadingManager = LoadingManager;
	exports.JSONLoader = JSONLoader;
	exports.ImageLoader = ImageLoader;
	exports.FontLoader = FontLoader;
	exports.FileLoader = FileLoader;
	exports.Loader = Loader;
	exports.Cache = Cache;
	exports.AudioLoader = AudioLoader;
	exports.SpotLightShadow = SpotLightShadow;
	exports.SpotLight = SpotLight;
	exports.PointLight = PointLight;
	exports.RectAreaLight = RectAreaLight;
	exports.HemisphereLight = HemisphereLight;
	exports.DirectionalLightShadow = DirectionalLightShadow;
	exports.DirectionalLight = DirectionalLight;
	exports.AmbientLight = AmbientLight;
	exports.LightShadow = LightShadow;
	exports.Light = Light;
	exports.StereoCamera = StereoCamera;
	exports.PerspectiveCamera = PerspectiveCamera;
	exports.OrthographicCamera = OrthographicCamera;
	exports.CubeCamera = CubeCamera;
	exports.Camera = Camera;
	exports.AudioListener = AudioListener;
	exports.PositionalAudio = PositionalAudio;
	exports.AudioContext = AudioContext;
	exports.AudioAnalyser = AudioAnalyser;
	exports.Audio = Audio;
	exports.VectorKeyframeTrack = VectorKeyframeTrack;
	exports.StringKeyframeTrack = StringKeyframeTrack;
	exports.QuaternionKeyframeTrack = QuaternionKeyframeTrack;
	exports.NumberKeyframeTrack = NumberKeyframeTrack;
	exports.ColorKeyframeTrack = ColorKeyframeTrack;
	exports.BooleanKeyframeTrack = BooleanKeyframeTrack;
	exports.PropertyMixer = PropertyMixer;
	exports.PropertyBinding = PropertyBinding;
	exports.KeyframeTrack = KeyframeTrack;
	exports.AnimationUtils = AnimationUtils;
	exports.AnimationObjectGroup = AnimationObjectGroup;
	exports.AnimationMixer = AnimationMixer;
	exports.AnimationClip = AnimationClip;
	exports.Uniform = Uniform;
	exports.InstancedBufferGeometry = InstancedBufferGeometry;
	exports.BufferGeometry = BufferGeometry;
	exports.GeometryIdCount = GeometryIdCount;
	exports.Geometry = Geometry;
	exports.InterleavedBufferAttribute = InterleavedBufferAttribute;
	exports.InstancedInterleavedBuffer = InstancedInterleavedBuffer;
	exports.InterleavedBuffer = InterleavedBuffer;
	exports.InstancedBufferAttribute = InstancedBufferAttribute;
	exports.Face3 = Face3;
	exports.Object3D = Object3D;
	exports.Raycaster = Raycaster;
	exports.Layers = Layers;
	exports.EventDispatcher = EventDispatcher;
	exports.Clock = Clock;
	exports.QuaternionLinearInterpolant = QuaternionLinearInterpolant;
	exports.LinearInterpolant = LinearInterpolant;
	exports.DiscreteInterpolant = DiscreteInterpolant;
	exports.CubicInterpolant = CubicInterpolant;
	exports.Interpolant = Interpolant;
	exports.Triangle = Triangle;
	exports.Spline = Spline;
	exports.Math = _Math;
	exports.Spherical = Spherical;
	exports.Cylindrical = Cylindrical;
	exports.Plane = Plane;
	exports.Frustum = Frustum;
	exports.Sphere = Sphere;
	exports.Ray = Ray;
	exports.Matrix4 = Matrix4;
	exports.Matrix3 = Matrix3;
	exports.Box3 = Box3;
	exports.Box2 = Box2;
	exports.Line3 = Line3;
	exports.Euler = Euler;
	exports.Vector4 = Vector4;
	exports.Vector3 = Vector3;
	exports.Vector2 = Vector2;
	exports.Quaternion = Quaternion;
	exports.Color = Color;
	exports.MorphBlendMesh = MorphBlendMesh;
	exports.ImmediateRenderObject = ImmediateRenderObject;
	exports.VertexNormalsHelper = VertexNormalsHelper;
	exports.SpotLightHelper = SpotLightHelper;
	exports.SkeletonHelper = SkeletonHelper;
	exports.PointLightHelper = PointLightHelper;
	exports.RectAreaLightHelper = RectAreaLightHelper;
	exports.HemisphereLightHelper = HemisphereLightHelper;
	exports.GridHelper = GridHelper;
	exports.PolarGridHelper = PolarGridHelper;
	exports.FaceNormalsHelper = FaceNormalsHelper;
	exports.DirectionalLightHelper = DirectionalLightHelper;
	exports.CameraHelper = CameraHelper;
	exports.BoxHelper = BoxHelper;
	exports.ArrowHelper = ArrowHelper;
	exports.AxisHelper = AxisHelper;
	exports.CatmullRomCurve3 = CatmullRomCurve3;
	exports.SplineCurve3 = SplineCurve3;
	exports.CubicBezierCurve3 = CubicBezierCurve3;
	exports.QuadraticBezierCurve3 = QuadraticBezierCurve3;
	exports.LineCurve3 = LineCurve3;
	exports.ArcCurve = ArcCurve;
	exports.EllipseCurve = EllipseCurve;
	exports.SplineCurve = SplineCurve;
	exports.CubicBezierCurve = CubicBezierCurve;
	exports.QuadraticBezierCurve = QuadraticBezierCurve;
	exports.LineCurve = LineCurve;
	exports.Shape = Shape;
	exports.ShapePath = ShapePath;
	exports.Path = Path;
	exports.Font = Font;
	exports.CurvePath = CurvePath;
	exports.Curve = Curve;
	exports.ShapeUtils = ShapeUtils;
	exports.SceneUtils = SceneUtils;
	exports.CurveUtils = CurveUtils;
	exports.WireframeGeometry = WireframeGeometry;
	exports.ParametricGeometry = ParametricGeometry;
	exports.ParametricBufferGeometry = ParametricBufferGeometry;
	exports.TetrahedronGeometry = TetrahedronGeometry;
	exports.TetrahedronBufferGeometry = TetrahedronBufferGeometry;
	exports.OctahedronGeometry = OctahedronGeometry;
	exports.OctahedronBufferGeometry = OctahedronBufferGeometry;
	exports.IcosahedronGeometry = IcosahedronGeometry;
	exports.IcosahedronBufferGeometry = IcosahedronBufferGeometry;
	exports.DodecahedronGeometry = DodecahedronGeometry;
	exports.DodecahedronBufferGeometry = DodecahedronBufferGeometry;
	exports.PolyhedronGeometry = PolyhedronGeometry;
	exports.PolyhedronBufferGeometry = PolyhedronBufferGeometry;
	exports.TubeGeometry = TubeGeometry;
	exports.TubeBufferGeometry = TubeBufferGeometry;
	exports.TorusKnotGeometry = TorusKnotGeometry;
	exports.TorusKnotBufferGeometry = TorusKnotBufferGeometry;
	exports.TorusGeometry = TorusGeometry;
	exports.TorusBufferGeometry = TorusBufferGeometry;
	exports.TextGeometry = TextGeometry;
	exports.SphereBufferGeometry = SphereBufferGeometry;
	exports.SphereGeometry = SphereGeometry;
	exports.RingGeometry = RingGeometry;
	exports.RingBufferGeometry = RingBufferGeometry;
	exports.PlaneBufferGeometry = PlaneBufferGeometry;
	exports.PlaneGeometry = PlaneGeometry;
	exports.LatheGeometry = LatheGeometry;
	exports.LatheBufferGeometry = LatheBufferGeometry;
	exports.ShapeGeometry = ShapeGeometry;
	exports.ShapeBufferGeometry = ShapeBufferGeometry;
	exports.ExtrudeGeometry = ExtrudeGeometry;
	exports.EdgesGeometry = EdgesGeometry;
	exports.ConeGeometry = ConeGeometry;
	exports.ConeBufferGeometry = ConeBufferGeometry;
	exports.CylinderGeometry = CylinderGeometry;
	exports.CylinderBufferGeometry = CylinderBufferGeometry;
	exports.CircleBufferGeometry = CircleBufferGeometry;
	exports.CircleGeometry = CircleGeometry;
	exports.BoxBufferGeometry = BoxBufferGeometry;
	exports.BoxGeometry = BoxGeometry;
	exports.ShadowMaterial = ShadowMaterial;
	exports.SpriteMaterial = SpriteMaterial;
	exports.RawShaderMaterial = RawShaderMaterial;
	exports.ShaderMaterial = ShaderMaterial;
	exports.PointsMaterial = PointsMaterial;
	exports.MultiMaterial = MultiMaterial;
	exports.MeshPhysicalMaterial = MeshPhysicalMaterial;
	exports.MeshStandardMaterial = MeshStandardMaterial;
	exports.MeshPhongMaterial = MeshPhongMaterial;
	exports.MeshToonMaterial = MeshToonMaterial;
	exports.MeshNormalMaterial = MeshNormalMaterial;
	exports.MeshLambertMaterial = MeshLambertMaterial;
	exports.MeshDepthMaterial = MeshDepthMaterial;
	exports.MeshBasicMaterial = MeshBasicMaterial;
	exports.LineDashedMaterial = LineDashedMaterial;
	exports.LineBasicMaterial = LineBasicMaterial;
	exports.Material = Material;
	exports.Float64BufferAttribute = Float64BufferAttribute;
	exports.Float32BufferAttribute = Float32BufferAttribute;
	exports.Uint32BufferAttribute = Uint32BufferAttribute;
	exports.Int32BufferAttribute = Int32BufferAttribute;
	exports.Uint16BufferAttribute = Uint16BufferAttribute;
	exports.Int16BufferAttribute = Int16BufferAttribute;
	exports.Uint8ClampedBufferAttribute = Uint8ClampedBufferAttribute;
	exports.Uint8BufferAttribute = Uint8BufferAttribute;
	exports.Int8BufferAttribute = Int8BufferAttribute;
	exports.BufferAttribute = BufferAttribute;
	exports.REVISION = REVISION;
	exports.MOUSE = MOUSE;
	exports.CullFaceNone = CullFaceNone;
	exports.CullFaceBack = CullFaceBack;
	exports.CullFaceFront = CullFaceFront;
	exports.CullFaceFrontBack = CullFaceFrontBack;
	exports.FrontFaceDirectionCW = FrontFaceDirectionCW;
	exports.FrontFaceDirectionCCW = FrontFaceDirectionCCW;
	exports.BasicShadowMap = BasicShadowMap;
	exports.PCFShadowMap = PCFShadowMap;
	exports.PCFSoftShadowMap = PCFSoftShadowMap;
	exports.FrontSide = FrontSide;
	exports.BackSide = BackSide;
	exports.DoubleSide = DoubleSide;
	exports.FlatShading = FlatShading;
	exports.SmoothShading = SmoothShading;
	exports.NoColors = NoColors;
	exports.FaceColors = FaceColors;
	exports.VertexColors = VertexColors;
	exports.NoBlending = NoBlending;
	exports.NormalBlending = NormalBlending;
	exports.AdditiveBlending = AdditiveBlending;
	exports.SubtractiveBlending = SubtractiveBlending;
	exports.MultiplyBlending = MultiplyBlending;
	exports.CustomBlending = CustomBlending;
	exports.BlendingMode = BlendingMode;
	exports.AddEquation = AddEquation;
	exports.SubtractEquation = SubtractEquation;
	exports.ReverseSubtractEquation = ReverseSubtractEquation;
	exports.MinEquation = MinEquation;
	exports.MaxEquation = MaxEquation;
	exports.ZeroFactor = ZeroFactor;
	exports.OneFactor = OneFactor;
	exports.SrcColorFactor = SrcColorFactor;
	exports.OneMinusSrcColorFactor = OneMinusSrcColorFactor;
	exports.SrcAlphaFactor = SrcAlphaFactor;
	exports.OneMinusSrcAlphaFactor = OneMinusSrcAlphaFactor;
	exports.DstAlphaFactor = DstAlphaFactor;
	exports.OneMinusDstAlphaFactor = OneMinusDstAlphaFactor;
	exports.DstColorFactor = DstColorFactor;
	exports.OneMinusDstColorFactor = OneMinusDstColorFactor;
	exports.SrcAlphaSaturateFactor = SrcAlphaSaturateFactor;
	exports.NeverDepth = NeverDepth;
	exports.AlwaysDepth = AlwaysDepth;
	exports.LessDepth = LessDepth;
	exports.LessEqualDepth = LessEqualDepth;
	exports.EqualDepth = EqualDepth;
	exports.GreaterEqualDepth = GreaterEqualDepth;
	exports.GreaterDepth = GreaterDepth;
	exports.NotEqualDepth = NotEqualDepth;
	exports.MultiplyOperation = MultiplyOperation;
	exports.MixOperation = MixOperation;
	exports.AddOperation = AddOperation;
	exports.NoToneMapping = NoToneMapping;
	exports.LinearToneMapping = LinearToneMapping;
	exports.ReinhardToneMapping = ReinhardToneMapping;
	exports.Uncharted2ToneMapping = Uncharted2ToneMapping;
	exports.CineonToneMapping = CineonToneMapping;
	exports.UVMapping = UVMapping;
	exports.CubeReflectionMapping = CubeReflectionMapping;
	exports.CubeRefractionMapping = CubeRefractionMapping;
	exports.EquirectangularReflectionMapping = EquirectangularReflectionMapping;
	exports.EquirectangularRefractionMapping = EquirectangularRefractionMapping;
	exports.SphericalReflectionMapping = SphericalReflectionMapping;
	exports.CubeUVReflectionMapping = CubeUVReflectionMapping;
	exports.CubeUVRefractionMapping = CubeUVRefractionMapping;
	exports.TextureMapping = TextureMapping;
	exports.RepeatWrapping = RepeatWrapping;
	exports.ClampToEdgeWrapping = ClampToEdgeWrapping;
	exports.MirroredRepeatWrapping = MirroredRepeatWrapping;
	exports.TextureWrapping = TextureWrapping;
	exports.NearestFilter = NearestFilter;
	exports.NearestMipMapNearestFilter = NearestMipMapNearestFilter;
	exports.NearestMipMapLinearFilter = NearestMipMapLinearFilter;
	exports.LinearFilter = LinearFilter;
	exports.LinearMipMapNearestFilter = LinearMipMapNearestFilter;
	exports.LinearMipMapLinearFilter = LinearMipMapLinearFilter;
	exports.TextureFilter = TextureFilter;
	exports.UnsignedByteType = UnsignedByteType;
	exports.ByteType = ByteType;
	exports.ShortType = ShortType;
	exports.UnsignedShortType = UnsignedShortType;
	exports.IntType = IntType;
	exports.UnsignedIntType = UnsignedIntType;
	exports.FloatType = FloatType;
	exports.HalfFloatType = HalfFloatType;
	exports.UnsignedShort4444Type = UnsignedShort4444Type;
	exports.UnsignedShort5551Type = UnsignedShort5551Type;
	exports.UnsignedShort565Type = UnsignedShort565Type;
	exports.UnsignedInt248Type = UnsignedInt248Type;
	exports.AlphaFormat = AlphaFormat;
	exports.RGBFormat = RGBFormat;
	exports.RGBAFormat = RGBAFormat;
	exports.LuminanceFormat = LuminanceFormat;
	exports.LuminanceAlphaFormat = LuminanceAlphaFormat;
	exports.RGBEFormat = RGBEFormat;
	exports.DepthFormat = DepthFormat;
	exports.DepthStencilFormat = DepthStencilFormat;
	exports.RGB_S3TC_DXT1_Format = RGB_S3TC_DXT1_Format;
	exports.RGBA_S3TC_DXT1_Format = RGBA_S3TC_DXT1_Format;
	exports.RGBA_S3TC_DXT3_Format = RGBA_S3TC_DXT3_Format;
	exports.RGBA_S3TC_DXT5_Format = RGBA_S3TC_DXT5_Format;
	exports.RGB_PVRTC_4BPPV1_Format = RGB_PVRTC_4BPPV1_Format;
	exports.RGB_PVRTC_2BPPV1_Format = RGB_PVRTC_2BPPV1_Format;
	exports.RGBA_PVRTC_4BPPV1_Format = RGBA_PVRTC_4BPPV1_Format;
	exports.RGBA_PVRTC_2BPPV1_Format = RGBA_PVRTC_2BPPV1_Format;
	exports.RGB_ETC1_Format = RGB_ETC1_Format;
	exports.LoopOnce = LoopOnce;
	exports.LoopRepeat = LoopRepeat;
	exports.LoopPingPong = LoopPingPong;
	exports.InterpolateDiscrete = InterpolateDiscrete;
	exports.InterpolateLinear = InterpolateLinear;
	exports.InterpolateSmooth = InterpolateSmooth;
	exports.ZeroCurvatureEnding = ZeroCurvatureEnding;
	exports.ZeroSlopeEnding = ZeroSlopeEnding;
	exports.WrapAroundEnding = WrapAroundEnding;
	exports.TrianglesDrawMode = TrianglesDrawMode;
	exports.TriangleStripDrawMode = TriangleStripDrawMode;
	exports.TriangleFanDrawMode = TriangleFanDrawMode;
	exports.LinearEncoding = LinearEncoding;
	exports.sRGBEncoding = sRGBEncoding;
	exports.GammaEncoding = GammaEncoding;
	exports.RGBEEncoding = RGBEEncoding;
	exports.LogLuvEncoding = LogLuvEncoding;
	exports.RGBM7Encoding = RGBM7Encoding;
	exports.RGBM16Encoding = RGBM16Encoding;
	exports.RGBDEncoding = RGBDEncoding;
	exports.BasicDepthPacking = BasicDepthPacking;
	exports.RGBADepthPacking = RGBADepthPacking;
	exports.CubeGeometry = BoxGeometry;
	exports.Face4 = Face4;
	exports.LineStrip = LineStrip;
	exports.LinePieces = LinePieces;
	exports.MeshFaceMaterial = MeshFaceMaterial;
	exports.PointCloud = PointCloud;
	exports.Particle = Particle;
	exports.ParticleSystem = ParticleSystem;
	exports.PointCloudMaterial = PointCloudMaterial;
	exports.ParticleBasicMaterial = ParticleBasicMaterial;
	exports.ParticleSystemMaterial = ParticleSystemMaterial;
	exports.Vertex = Vertex;
	exports.DynamicBufferAttribute = DynamicBufferAttribute;
	exports.Int8Attribute = Int8Attribute;
	exports.Uint8Attribute = Uint8Attribute;
	exports.Uint8ClampedAttribute = Uint8ClampedAttribute;
	exports.Int16Attribute = Int16Attribute;
	exports.Uint16Attribute = Uint16Attribute;
	exports.Int32Attribute = Int32Attribute;
	exports.Uint32Attribute = Uint32Attribute;
	exports.Float32Attribute = Float32Attribute;
	exports.Float64Attribute = Float64Attribute;
	exports.ClosedSplineCurve3 = ClosedSplineCurve3;
	exports.BoundingBoxHelper = BoundingBoxHelper;
	exports.EdgesHelper = EdgesHelper;
	exports.WireframeHelper = WireframeHelper;
	exports.XHRLoader = XHRLoader;
	exports.GeometryUtils = GeometryUtils;
	exports.ImageUtils = ImageUtils;
	exports.Projector = Projector;
	exports.CanvasRenderer = CanvasRenderer;

	Object.defineProperty(exports, '__esModule', { value: true });

})));

},{}],43:[function(_dereq_,module,exports){
/**
 * @author Michael Guerrero / http://realitymeltdown.com
 */

THREE.BlendCharacter = function () {

	this.weightSchedule = [];
	this.warpSchedule = [];

	this.load = function ( url, onLoad ) {

		var scope = this;

		var loader = new THREE.ObjectLoader();
		loader.load( url, function( loadedObject ) {

			// The exporter does not currently allow exporting a skinned mesh by itself
			// so we must fish it out of the hierarchy it is embedded in (scene)
			loadedObject.traverse( function( object ) {

				if ( object instanceof THREE.SkinnedMesh ) {

					scope.skinnedMesh = object;

				}

			} );

			THREE.SkinnedMesh.call( scope, scope.skinnedMesh.geometry, scope.skinnedMesh.material );

			// If we didn't successfully find the mesh, bail out
			if ( scope.skinnedMesh == undefined ) {

				console.log( 'unable to find skinned mesh in ' + url );
				return;

			}

			scope.material.skinning = true;

			scope.mixer = new THREE.AnimationMixer( scope );

			// Create the animations
			for ( var i = 0; i < scope.geometry.animations.length; ++ i ) {

				scope.mixer.clipAction( scope.geometry.animations[ i ] );

			}

			// Loading is complete, fire the callback
			if ( onLoad !== undefined ) onLoad();

		} );

	};

	this.loadJSON = function ( url, onLoad ) {

		var scope = this;

		var loader = new THREE.JSONLoader();
		loader.load( url, function( geometry, materials ) {

			var originalMaterial = materials[ 0 ];
			originalMaterial.skinning = true;

			THREE.SkinnedMesh.call( scope, geometry, originalMaterial );

			var mixer = new THREE.AnimationMixer( scope );
			scope.mixer = mixer;

			// Create the animations
			for ( var i = 0; i < geometry.animations.length; ++ i ) {

				mixer.clipAction( geometry.animations[ i ] );

			}

			// Loading is complete, fire the callback
			if ( onLoad !== undefined ) onLoad();

		} );

	};
	
	this.update = function( dt ) {

		this.mixer.update( dt );

	};

	this.play = function( animName, weight ) {

		//console.log("play('%s', %f)", animName, weight);
		return this.mixer.clipAction( animName ).
				setEffectiveWeight( weight ).play();
	};

	this.crossfade = function( fromAnimName, toAnimName, duration ) {

		this.mixer.stopAllAction();

		var fromAction = this.play( fromAnimName, 1 );
		var toAction = this.play( toAnimName, 1 );

		fromAction.crossFadeTo( toAction, duration, false );

	};

	this.warp = function( fromAnimName, toAnimName, duration ) {

		this.mixer.stopAllAction();

		var fromAction = this.play( fromAnimName, 1 );
		var toAction = this.play( toAnimName, 1 );

		fromAction.crossFadeTo( toAction, duration, true );

	};

	this.applyWeight = function( animName, weight ) {

		this.mixer.clipAction( animName ).setEffectiveWeight( weight );

	};

	this.getWeight = function( animName ) {

		return this.mixer.clipAction( animName ).getEffectiveWeight();

	};

	this.pauseAll = function() {

		this.mixer.timeScale = 0;

	};

	this.unPauseAll = function() {

		this.mixer.timeScale = 1;

	};


	this.stopAll = function() {

		this.mixer.stopAllAction();

	};

	this.showModel = function( boolean ) {

		this.visible = boolean;

	};

};


THREE.BlendCharacter.prototype = Object.create( THREE.SkinnedMesh.prototype );
THREE.BlendCharacter.prototype.constructor = THREE.BlendCharacter;

THREE.BlendCharacter.prototype.getForward = function() {

	var forward = new THREE.Vector3();

	return function() {

		// pull the character's forward basis vector out of the matrix
		forward.set(
			- this.matrix.elements[ 8 ],
			- this.matrix.elements[ 9 ],
			- this.matrix.elements[ 10 ]
		);

		return forward;

	}

};


},{}],44:[function(_dereq_,module,exports){
/**
* @author Tim Knip / http://www.floorplanner.com/ / tim at floorplanner.com
* @author Tony Parisi / http://www.tonyparisi.com/
*/

THREE.ColladaLoader = function () {

	var COLLADA = null;
	var scene = null;
	var visualScene;
	var kinematicsModel;

	var readyCallbackFunc = null;

	var sources = {};
	var images = {};
	var animations = {};
	var controllers = {};
	var geometries = {};
	var materials = {};
	var effects = {};
	var cameras = {};
	var lights = {};

	var animData;
	var kinematics;
	var visualScenes;
	var kinematicsModels;
	var baseUrl;
	var morphs;
	var skins;

	var flip_uv = true;
	var preferredShading = THREE.SmoothShading;

	var options = {
		// Force Geometry to always be centered at the local origin of the
		// containing Mesh.
		centerGeometry: false,

		// Axis conversion is done for geometries, animations, and controllers.
		// If we ever pull cameras or lights out of the COLLADA file, they'll
		// need extra work.
		convertUpAxis: false,

		subdivideFaces: true,

		upAxis: 'Y',

		// For reflective or refractive materials we'll use this cubemap
		defaultEnvMap: null

	};

	var colladaUnit = 1.0;
	var colladaUp = 'Y';
	var upConversion = null;

	function load ( url, readyCallback, progressCallback, failCallback ) {

		var length = 0;

		if ( document.implementation && document.implementation.createDocument ) {

			var request = new XMLHttpRequest();

			request.onreadystatechange = function() {

				if ( request.readyState === 4 ) {

					if ( request.status === 0 || request.status === 200 ) {

						if ( request.response ) {

							readyCallbackFunc = readyCallback;
							parse( request.response, undefined, url );

						} else {

							if ( failCallback ) {

								failCallback( { type: 'error', url: url } );

							} else {

								console.error( "ColladaLoader: Empty or non-existing file (" + url + ")" );

							}

						}

					}else{

						if( failCallback ){

							failCallback( { type: 'error', url: url } );

						}else{

							console.error( 'ColladaLoader: Couldn\'t load "' + url + '" (' + request.status + ')' );

						}

					}

				} else if ( request.readyState === 3 ) {

					if ( progressCallback ) {

						if ( length === 0 ) {

							length = request.getResponseHeader( "Content-Length" );

						}

						progressCallback( { total: length, loaded: request.responseText.length } );

					}

				}

			};

			request.open( "GET", url, true );
			request.send( null );

		} else {

			alert( "Don't know how to parse XML!" );

		}

	}

	function parse( text, callBack, url ) {

		COLLADA = new DOMParser().parseFromString( text, 'text/xml' );
		callBack = callBack || readyCallbackFunc;

		if ( url !== undefined ) {

			var parts = url.split( '/' );
			parts.pop();
			baseUrl = ( parts.length < 1 ? '.' : parts.join( '/' ) ) + '/';

		}

		parseAsset();
		setUpConversion();
		images = parseLib( "library_images image", _Image, "image" );
		materials = parseLib( "library_materials material", Material, "material" );
		effects = parseLib( "library_effects effect", Effect, "effect" );
		geometries = parseLib( "library_geometries geometry", Geometry, "geometry" );
		cameras = parseLib( "library_cameras camera", Camera, "camera" );
		lights = parseLib( "library_lights light", Light, "light" );
		controllers = parseLib( "library_controllers controller", Controller, "controller" );
		animations = parseLib( "library_animations animation", Animation, "animation" );
		visualScenes = parseLib( "library_visual_scenes visual_scene", VisualScene, "visual_scene" );
		kinematicsModels = parseLib( "library_kinematics_models kinematics_model", KinematicsModel, "kinematics_model" );

		morphs = [];
		skins = [];

		visualScene = parseScene();
		scene = new THREE.Group();

		for ( var i = 0; i < visualScene.nodes.length; i ++ ) {

			scene.add( createSceneGraph( visualScene.nodes[ i ] ) );

		}

		// unit conversion
		scene.scale.multiplyScalar( colladaUnit );

		createAnimations();

		kinematicsModel = parseKinematicsModel();
		createKinematics();

		var result = {

			scene: scene,
			morphs: morphs,
			skins: skins,
			animations: animData,
			kinematics: kinematics,
			dae: {
				images: images,
				materials: materials,
				cameras: cameras,
				lights: lights,
				effects: effects,
				geometries: geometries,
				controllers: controllers,
				animations: animations,
				visualScenes: visualScenes,
				visualScene: visualScene,
				scene: visualScene,
				kinematicsModels: kinematicsModels,
				kinematicsModel: kinematicsModel
			}

		};

		if ( callBack ) {

			callBack( result );

		}

		return result;

	}

	function setPreferredShading ( shading ) {

		preferredShading = shading;

	}

	function parseAsset () {

		var elements = COLLADA.querySelectorAll('asset');

		var element = elements[0];

		if ( element && element.childNodes ) {

			for ( var i = 0; i < element.childNodes.length; i ++ ) {

				var child = element.childNodes[ i ];

				switch ( child.nodeName ) {

					case 'unit':

						var meter = child.getAttribute( 'meter' );

						if ( meter ) {

							colladaUnit = parseFloat( meter );

						}

						break;

					case 'up_axis':

						colladaUp = child.textContent.charAt(0);
						break;

				}

			}

		}

	}

	function parseLib ( q, classSpec, prefix ) {

		var elements = COLLADA.querySelectorAll(q);

		var lib = {};

		var i = 0;

		var elementsLength = elements.length;

		for ( var j = 0; j < elementsLength; j ++ ) {

			var element = elements[j];
			var daeElement = ( new classSpec() ).parse( element );

			if ( !daeElement.id || daeElement.id.length === 0 ) daeElement.id = prefix + ( i ++ );
			lib[ daeElement.id ] = daeElement;

		}

		return lib;

	}

	function parseScene() {

		var sceneElement = COLLADA.querySelectorAll('scene instance_visual_scene')[0];

		if ( sceneElement ) {

			var url = sceneElement.getAttribute( 'url' ).replace( /^#/, '' );
			return visualScenes[ url.length > 0 ? url : 'visual_scene0' ];

		} else {

			return null;

		}

	}

	function parseKinematicsModel() {

		var kinematicsModelElement = COLLADA.querySelectorAll('instance_kinematics_model')[0];

		if ( kinematicsModelElement ) {

			var url = kinematicsModelElement.getAttribute( 'url' ).replace(/^#/, '');
			return kinematicsModels[ url.length > 0 ? url : 'kinematics_model0' ];

		} else {

			return null;

		}

	}

	function createAnimations() {

		animData = [];

		// fill in the keys
		recurseHierarchy( scene );

	}

	function recurseHierarchy( node ) {

		var n = visualScene.getChildById( node.colladaId, true ),
			newData = null;

		if ( n && n.keys ) {

			newData = {
				fps: 60,
				hierarchy: [ {
					node: n,
					keys: n.keys,
					sids: n.sids
				} ],
				node: node,
				name: 'animation_' + node.name,
				length: 0
			};

			animData.push(newData);

			for ( var i = 0, il = n.keys.length; i < il; i ++ ) {

				newData.length = Math.max( newData.length, n.keys[i].time );

			}

		} else {

			newData = {
				hierarchy: [ {
					keys: [],
					sids: []
				} ]
			}

		}

		for ( var i = 0, il = node.children.length; i < il; i ++ ) {

			var d = recurseHierarchy( node.children[i] );

			for ( var j = 0, jl = d.hierarchy.length; j < jl; j ++ ) {

				newData.hierarchy.push( {
					keys: [],
					sids: []
				} );

			}

		}

		return newData;

	}

	function calcAnimationBounds () {

		var start = 1000000;
		var end = -start;
		var frames = 0;
		var ID;
		for ( var id in animations ) {

			var animation = animations[ id ];
			ID = ID || animation.id;
			for ( var i = 0; i < animation.sampler.length; i ++ ) {

				var sampler = animation.sampler[ i ];

				sampler.create();

				start = Math.min( start, sampler.startTime );
				end = Math.max( end, sampler.endTime );
				frames = Math.max( frames, sampler.input.length );

			}

		}

		return { start:start, end:end, frames:frames,ID:ID };

	}

	function createMorph ( geometry, ctrl ) {

		var morphCtrl = ctrl instanceof InstanceController ? controllers[ ctrl.url ] : ctrl;

		if ( !morphCtrl || !morphCtrl.morph ) {

			console.log("could not find morph controller!");
			return;

		}

		var morph = morphCtrl.morph;

		for ( var i = 0; i < morph.targets.length; i ++ ) {

			var target_id = morph.targets[ i ];
			var daeGeometry = geometries[ target_id ];

			if ( !daeGeometry.mesh ||
				 !daeGeometry.mesh.primitives ||
				 !daeGeometry.mesh.primitives.length ) {
				 continue;
			}

			var target = daeGeometry.mesh.primitives[ 0 ].geometry;

			if ( target.vertices.length === geometry.vertices.length ) {

				geometry.morphTargets.push( { name: "target_1", vertices: target.vertices } );

			}

		}

		geometry.morphTargets.push( { name: "target_Z", vertices: geometry.vertices } );

	}

	function createSkin ( geometry, ctrl, applyBindShape ) {

		var skinCtrl = controllers[ ctrl.url ];

		if ( !skinCtrl || !skinCtrl.skin ) {

			console.log( "could not find skin controller!" );
			return;

		}

		if ( !ctrl.skeleton || !ctrl.skeleton.length ) {

			console.log( "could not find the skeleton for the skin!" );
			return;

		}

		var skin = skinCtrl.skin;
		var skeleton = visualScene.getChildById( ctrl.skeleton[ 0 ] );
		var hierarchy = [];

		applyBindShape = applyBindShape !== undefined ? applyBindShape : true;

		var bones = [];
		geometry.skinWeights = [];
		geometry.skinIndices = [];

		//createBones( geometry.bones, skin, hierarchy, skeleton, null, -1 );
		//createWeights( skin, geometry.bones, geometry.skinIndices, geometry.skinWeights );

		/*
		geometry.animation = {
			name: 'take_001',
			fps: 30,
			length: 2,
			JIT: true,
			hierarchy: hierarchy
		};
		*/

		if ( applyBindShape ) {

			for ( var i = 0; i < geometry.vertices.length; i ++ ) {

				geometry.vertices[ i ].applyMatrix4( skin.bindShapeMatrix );

			}

		}

	}

	function setupSkeleton ( node, bones, frame, parent ) {

		node.world = node.world || new THREE.Matrix4();
		node.localworld = node.localworld || new THREE.Matrix4();
		node.world.copy( node.matrix );
		node.localworld.copy( node.matrix );

		if ( node.channels && node.channels.length ) {

			var channel = node.channels[ 0 ];
			var m = channel.sampler.output[ frame ];

			if ( m instanceof THREE.Matrix4 ) {

				node.world.copy( m );
				node.localworld.copy(m);
				if (frame === 0)
					node.matrix.copy(m);
			}

		}

		if ( parent ) {

			node.world.multiplyMatrices( parent, node.world );

		}

		bones.push( node );

		for ( var i = 0; i < node.nodes.length; i ++ ) {

			setupSkeleton( node.nodes[ i ], bones, frame, node.world );

		}

	}

	function setupSkinningMatrices ( bones, skin ) {

		// FIXME: this is dumb...

		for ( var i = 0; i < bones.length; i ++ ) {

			var bone = bones[ i ];
			var found = -1;

			if ( bone.type != 'JOINT' ) continue;

			for ( var j = 0; j < skin.joints.length; j ++ ) {

				if ( bone.sid === skin.joints[ j ] ) {

					found = j;
					break;

				}

			}

			if ( found >= 0 ) {

				var inv = skin.invBindMatrices[ found ];

				bone.invBindMatrix = inv;
				bone.skinningMatrix = new THREE.Matrix4();
				bone.skinningMatrix.multiplyMatrices(bone.world, inv); // (IBMi * JMi)
				bone.animatrix = new THREE.Matrix4();

				bone.animatrix.copy(bone.localworld);
				bone.weights = [];

				for ( var j = 0; j < skin.weights.length; j ++ ) {

					for (var k = 0; k < skin.weights[ j ].length; k ++ ) {

						var w = skin.weights[ j ][ k ];

						if ( w.joint === found ) {

							bone.weights.push( w );

						}

					}

				}

			} else {

				console.warn( "ColladaLoader: Could not find joint '" + bone.sid + "'." );

				bone.skinningMatrix = new THREE.Matrix4();
				bone.weights = [];

			}
		}

	}

	//Walk the Collada tree and flatten the bones into a list, extract the position, quat and scale from the matrix
	function flattenSkeleton(skeleton) {

		var list = [];
		var walk = function(parentid, node, list) {

			var bone = {};
			bone.name = node.sid;
			bone.parent = parentid;
			bone.matrix = node.matrix;
			var data = [ new THREE.Vector3(),new THREE.Quaternion(),new THREE.Vector3() ];
			bone.matrix.decompose(data[0], data[1], data[2]);

			bone.pos = [ data[0].x,data[0].y,data[0].z ];

			bone.scl = [ data[2].x,data[2].y,data[2].z ];
			bone.rotq = [ data[1].x,data[1].y,data[1].z,data[1].w ];
			list.push(bone);

			for (var i in node.nodes) {

				walk(node.sid, node.nodes[i], list);

			}

		};

		walk(-1, skeleton, list);
		return list;

	}

	//Move the vertices into the pose that is proper for the start of the animation
	function skinToBindPose(geometry,skeleton,skinController) {

		var bones = [];
		setupSkeleton( skeleton, bones, -1 );
		setupSkinningMatrices( bones, skinController.skin );
		var v = new THREE.Vector3();
		var skinned = [];

		for (var i = 0; i < geometry.vertices.length; i ++) {

			skinned.push(new THREE.Vector3());

		}

		for ( i = 0; i < bones.length; i ++ ) {

			if ( bones[ i ].type != 'JOINT' ) continue;

			for ( var j = 0; j < bones[ i ].weights.length; j ++ ) {

				var w = bones[ i ].weights[ j ];
				var vidx = w.index;
				var weight = w.weight;

				var o = geometry.vertices[vidx];
				var s = skinned[vidx];

				v.x = o.x;
				v.y = o.y;
				v.z = o.z;

				v.applyMatrix4( bones[i].skinningMatrix );

				s.x += (v.x * weight);
				s.y += (v.y * weight);
				s.z += (v.z * weight);
			}

		}

		for (var i = 0; i < geometry.vertices.length; i ++) {

			geometry.vertices[i] = skinned[i];

		}

	}

	function applySkin ( geometry, instanceCtrl, frame ) {

		var skinController = controllers[ instanceCtrl.url ];

		frame = frame !== undefined ? frame : 40;

		if ( !skinController || !skinController.skin ) {

			console.log( 'ColladaLoader: Could not find skin controller.' );
			return;

		}

		if ( !instanceCtrl.skeleton || !instanceCtrl.skeleton.length ) {

			console.log( 'ColladaLoader: Could not find the skeleton for the skin. ' );
			return;

		}

		var animationBounds = calcAnimationBounds();
		var skeleton = visualScene.getChildById( instanceCtrl.skeleton[0], true ) || visualScene.getChildBySid( instanceCtrl.skeleton[0], true );

		//flatten the skeleton into a list of bones
		var bonelist = flattenSkeleton(skeleton);
		var joints = skinController.skin.joints;

		//sort that list so that the order reflects the order in the joint list
		var sortedbones = [];
		for (var i = 0; i < joints.length; i ++) {

			for (var j = 0; j < bonelist.length; j ++) {

				if (bonelist[j].name === joints[i]) {

					sortedbones[i] = bonelist[j];

				}

			}

		}

		//hook up the parents by index instead of name
		for (var i = 0; i < sortedbones.length; i ++) {

			for (var j = 0; j < sortedbones.length; j ++) {

				if (sortedbones[i].parent === sortedbones[j].name) {

					sortedbones[i].parent = j;

				}

			}

		}


		var i, j, w, vidx, weight;
		var v = new THREE.Vector3(), o, s;

		// move vertices to bind shape
		for ( i = 0; i < geometry.vertices.length; i ++ ) {
			geometry.vertices[i].applyMatrix4( skinController.skin.bindShapeMatrix );
		}

		var skinIndices = [];
		var skinWeights = [];
		var weights = skinController.skin.weights;

		// hook up the skin weights
		// TODO - this might be a good place to choose greatest 4 weights
		for ( var i =0; i < weights.length; i ++ ) {

			var indicies = new THREE.Vector4(weights[i][0] ? weights[i][0].joint : 0,weights[i][1] ? weights[i][1].joint : 0,weights[i][2] ? weights[i][2].joint : 0,weights[i][3] ? weights[i][3].joint : 0);
			var weight = new THREE.Vector4(weights[i][0] ? weights[i][0].weight : 0,weights[i][1] ? weights[i][1].weight : 0,weights[i][2] ? weights[i][2].weight : 0,weights[i][3] ? weights[i][3].weight : 0);

			skinIndices.push(indicies);
			skinWeights.push(weight);

		}

		geometry.skinIndices = skinIndices;
		geometry.skinWeights = skinWeights;
		geometry.bones = sortedbones;
		// process animation, or simply pose the rig if no animation

		//create an animation for the animated bones
		//NOTE: this has no effect when using morphtargets
		var animationdata = { "name":animationBounds.ID,"fps":30,"length":animationBounds.frames / 30,"hierarchy":[] };

		for (var j = 0; j < sortedbones.length; j ++) {

			animationdata.hierarchy.push({ parent:sortedbones[j].parent, name:sortedbones[j].name, keys:[] });

		}

		console.log( 'ColladaLoader:', animationBounds.ID + ' has ' + sortedbones.length + ' bones.' );



		skinToBindPose(geometry, skeleton, skinController);


		for ( frame = 0; frame < animationBounds.frames; frame ++ ) {

			var bones = [];
			var skinned = [];
			// process the frame and setup the rig with a fresh
			// transform, possibly from the bone's animation channel(s)

			setupSkeleton( skeleton, bones, frame );
			setupSkinningMatrices( bones, skinController.skin );

			for (var i = 0; i < bones.length; i ++) {

				for (var j = 0; j < animationdata.hierarchy.length; j ++) {

					if (animationdata.hierarchy[j].name === bones[i].sid) {

						var key = {};
						key.time = (frame / 30);
						key.matrix = bones[i].animatrix;

						if (frame === 0)
							bones[i].matrix = key.matrix;

						var data = [ new THREE.Vector3(),new THREE.Quaternion(),new THREE.Vector3() ];
						key.matrix.decompose(data[0], data[1], data[2]);

						key.pos = [ data[0].x,data[0].y,data[0].z ];

						key.scl = [ data[2].x,data[2].y,data[2].z ];
						key.rot = data[1];

						animationdata.hierarchy[j].keys.push(key);

					}

				}

			}

			geometry.animation = animationdata;

		}

	}

	function createKinematics() {

		if ( kinematicsModel && kinematicsModel.joints.length === 0 ) {
			kinematics = undefined;
			return;
		}

		var jointMap = {};

		var _addToMap = function( jointIndex, parentVisualElement ) {

			var parentVisualElementId = parentVisualElement.getAttribute( 'id' );
			var colladaNode = visualScene.getChildById( parentVisualElementId, true );
			var joint = kinematicsModel.joints[ jointIndex ];

			scene.traverse(function( node ) {

				if ( node.colladaId == parentVisualElementId ) {

					jointMap[ jointIndex ] = {
						node: node,
						transforms: colladaNode.transforms,
						joint: joint,
						position: joint.zeroPosition
					};

				}

			});

		};

		kinematics = {

			joints: kinematicsModel && kinematicsModel.joints,

			getJointValue: function( jointIndex ) {

				var jointData = jointMap[ jointIndex ];

				if ( jointData ) {

					return jointData.position;

				} else {

					console.log( 'getJointValue: joint ' + jointIndex + ' doesn\'t exist' );

				}

			},

			setJointValue: function( jointIndex, value ) {

				var jointData = jointMap[ jointIndex ];

				if ( jointData ) {

					var joint = jointData.joint;

					if ( value > joint.limits.max || value < joint.limits.min ) {

						console.log( 'setJointValue: joint ' + jointIndex + ' value ' + value + ' outside of limits (min: ' + joint.limits.min + ', max: ' + joint.limits.max + ')' );

					} else if ( joint.static ) {

						console.log( 'setJointValue: joint ' + jointIndex + ' is static' );

					} else {

						var threejsNode = jointData.node;
						var axis = joint.axis;
						var transforms = jointData.transforms;

						var matrix = new THREE.Matrix4();

						for (i = 0; i < transforms.length; i ++ ) {

							var transform = transforms[ i ];

							// kinda ghetto joint detection
							if ( transform.sid && transform.sid.indexOf( 'joint' + jointIndex ) !== -1 ) {

								// apply actual joint value here
								switch ( joint.type ) {

									case 'revolute':

										matrix.multiply( m1.makeRotationAxis( axis, THREE.Math.degToRad(value) ) );
										break;

									case 'prismatic':

										matrix.multiply( m1.makeTranslation(axis.x * value, axis.y * value, axis.z * value ) );
										break;

									default:

										console.warn( 'setJointValue: unknown joint type: ' + joint.type );
										break;

								}

							} else {

								var m1 = new THREE.Matrix4();

								switch ( transform.type ) {

									case 'matrix':

										matrix.multiply( transform.obj );

										break;

									case 'translate':

										matrix.multiply( m1.makeTranslation( transform.obj.x, transform.obj.y, transform.obj.z ) );

										break;

									case 'rotate':

										matrix.multiply( m1.makeRotationAxis( transform.obj, transform.angle ) );

										break;

								}
							}
						}

						// apply the matrix to the threejs node
						var elementsFloat32Arr = matrix.elements;
						var elements = Array.prototype.slice.call( elementsFloat32Arr );

						var elementsRowMajor = [
							elements[ 0 ],
							elements[ 4 ],
							elements[ 8 ],
							elements[ 12 ],
							elements[ 1 ],
							elements[ 5 ],
							elements[ 9 ],
							elements[ 13 ],
							elements[ 2 ],
							elements[ 6 ],
							elements[ 10 ],
							elements[ 14 ],
							elements[ 3 ],
							elements[ 7 ],
							elements[ 11 ],
							elements[ 15 ]
						];

						threejsNode.matrix.set.apply( threejsNode.matrix, elementsRowMajor );
						threejsNode.matrix.decompose( threejsNode.position, threejsNode.quaternion, threejsNode.scale );
					}

				} else {

					console.log( 'setJointValue: joint ' + jointIndex + ' doesn\'t exist' );

				}

			}

		};

		var element = COLLADA.querySelector('scene instance_kinematics_scene');

		if ( element ) {

			for ( var i = 0; i < element.childNodes.length; i ++ ) {

				var child = element.childNodes[ i ];

				if ( child.nodeType != 1 ) continue;

				switch ( child.nodeName ) {

					case 'bind_joint_axis':

						var visualTarget = child.getAttribute( 'target' ).split( '/' ).pop();
						var axis = child.querySelector('axis param').textContent;
						var jointIndex = parseInt( axis.split( 'joint' ).pop().split( '.' )[0] );
						var visualTargetElement = COLLADA.querySelector( '[sid="' + visualTarget + '"]' );

						if ( visualTargetElement ) {
							var parentVisualElement = visualTargetElement.parentElement;
							_addToMap(jointIndex, parentVisualElement);
						}

						break;

					default:

						break;

				}

			}
		}

	}

	function createSceneGraph ( node, parent ) {

		var obj = new THREE.Object3D();
		var skinned = false;
		var skinController;
		var morphController;
		var i, j;

		// FIXME: controllers

		for ( i = 0; i < node.controllers.length; i ++ ) {

			var controller = controllers[ node.controllers[ i ].url ];

			switch ( controller.type ) {

				case 'skin':

					if ( geometries[ controller.skin.source ] ) {

						var inst_geom = new InstanceGeometry();

						inst_geom.url = controller.skin.source;
						inst_geom.instance_material = node.controllers[ i ].instance_material;

						node.geometries.push( inst_geom );
						skinned = true;
						skinController = node.controllers[ i ];

					} else if ( controllers[ controller.skin.source ] ) {

						// urgh: controller can be chained
						// handle the most basic case...

						var second = controllers[ controller.skin.source ];
						morphController = second;
					//	skinController = node.controllers[i];

						if ( second.morph && geometries[ second.morph.source ] ) {

							var inst_geom = new InstanceGeometry();

							inst_geom.url = second.morph.source;
							inst_geom.instance_material = node.controllers[ i ].instance_material;

							node.geometries.push( inst_geom );

						}

					}

					break;

				case 'morph':

					if ( geometries[ controller.morph.source ] ) {

						var inst_geom = new InstanceGeometry();

						inst_geom.url = controller.morph.source;
						inst_geom.instance_material = node.controllers[ i ].instance_material;

						node.geometries.push( inst_geom );
						morphController = node.controllers[ i ];

					}

					console.log( 'ColladaLoader: Morph-controller partially supported.' );

				default:
					break;

			}

		}

		// geometries

		var double_sided_materials = {};

		for ( i = 0; i < node.geometries.length; i ++ ) {

			var instance_geometry = node.geometries[i];
			var instance_materials = instance_geometry.instance_material;
			var geometry = geometries[ instance_geometry.url ];
			var used_materials = {};
			var used_materials_array = [];
			var num_materials = 0;
			var first_material;

			if ( geometry ) {

				if ( !geometry.mesh || !geometry.mesh.primitives )
					continue;

				if ( obj.name.length === 0 ) {

					obj.name = geometry.id;

				}

				// collect used fx for this geometry-instance

				if ( instance_materials ) {

					for ( j = 0; j < instance_materials.length; j ++ ) {

						var instance_material = instance_materials[ j ];
						var mat = materials[ instance_material.target ];
						var effect_id = mat.instance_effect.url;
						var shader = effects[ effect_id ].shader;
						var material3js = shader.material;

						if ( geometry.doubleSided ) {

							if ( !( instance_material.symbol in double_sided_materials ) ) {

								var _copied_material = material3js.clone();
								_copied_material.side = THREE.DoubleSide;
								double_sided_materials[ instance_material.symbol ] = _copied_material;

							}

							material3js = double_sided_materials[ instance_material.symbol ];

						}

						material3js.opacity = !material3js.opacity ? 1 : material3js.opacity;
						used_materials[ instance_material.symbol ] = num_materials;
						used_materials_array.push( material3js );
						first_material = material3js;
						first_material.name = mat.name === null || mat.name === '' ? mat.id : mat.name;
						num_materials ++;

					}

				}

				var mesh;
				var material = first_material || new THREE.MeshLambertMaterial( { color: 0xdddddd, side: geometry.doubleSided ? THREE.DoubleSide : THREE.FrontSide } );
				var geom = geometry.mesh.geometry3js;

				if ( num_materials > 1 ) {

					material = new THREE.MultiMaterial( used_materials_array );
					
					for ( j = 0; j < geom.faces.length; j ++ ) {

						var face = geom.faces[ j ];
						face.materialIndex = used_materials[ face.daeMaterial ]

					}

				}

				if ( skinController !== undefined ) {


					applySkin( geom, skinController );

					if ( geom.morphTargets.length > 0 ) {

						material.morphTargets = true;
						material.skinning = false;

					} else {

						material.morphTargets = false;
						material.skinning = true;

					}


					mesh = new THREE.SkinnedMesh( geom, material, false );


					//mesh.skeleton = skinController.skeleton;
					//mesh.skinController = controllers[ skinController.url ];
					//mesh.skinInstanceController = skinController;
					mesh.name = 'skin_' + skins.length;



					//mesh.animationHandle.setKey(0);
					skins.push( mesh );

				} else if ( morphController !== undefined ) {

					createMorph( geom, morphController );

					material.morphTargets = true;

					mesh = new THREE.Mesh( geom, material );
					mesh.name = 'morph_' + morphs.length;

					morphs.push( mesh );

				} else {

					if ( geom.isLineStrip === true ) {

						mesh = new THREE.Line( geom );

					} else {

						mesh = new THREE.Mesh( geom, material );

					}

				}

				obj.add(mesh);

			}

		}

		for ( i = 0; i < node.cameras.length; i ++ ) {

			var instance_camera = node.cameras[i];
			var cparams = cameras[instance_camera.url];

			var cam = new THREE.PerspectiveCamera(cparams.yfov, parseFloat(cparams.aspect_ratio),
					parseFloat(cparams.znear), parseFloat(cparams.zfar));

			obj.add(cam);
		}

		for ( i = 0; i < node.lights.length; i ++ ) {

			var light = null;
			var instance_light = node.lights[i];
			var lparams = lights[instance_light.url];

			if ( lparams && lparams.technique ) {

				var color = lparams.color.getHex();
				var intensity = lparams.intensity;
				var distance = lparams.distance;
				var angle = lparams.falloff_angle;

				switch ( lparams.technique ) {

					case 'directional':

						light = new THREE.DirectionalLight( color, intensity, distance );
						light.position.set(0, 0, 1);
						break;

					case 'point':

						light = new THREE.PointLight( color, intensity, distance );
						break;

					case 'spot':

						light = new THREE.SpotLight( color, intensity, distance, angle );
						light.position.set(0, 0, 1);
						break;

					case 'ambient':

						light = new THREE.AmbientLight( color );
						break;

				}

			}

			if (light) {
				obj.add(light);
			}
		}

		obj.name = node.name || node.id || "";
		obj.colladaId = node.id || "";
		obj.layer = node.layer || "";
		obj.matrix = node.matrix;
		obj.matrix.decompose( obj.position, obj.quaternion, obj.scale );

		if ( options.centerGeometry && obj.geometry ) {

			var delta = obj.geometry.center();
			delta.multiply( obj.scale );
			delta.applyQuaternion( obj.quaternion );

			obj.position.sub( delta );

		}

		for ( i = 0; i < node.nodes.length; i ++ ) {

			obj.add( createSceneGraph( node.nodes[i], node ) );

		}

		return obj;

	}

	function getJointId( skin, id ) {

		for ( var i = 0; i < skin.joints.length; i ++ ) {

			if ( skin.joints[ i ] === id ) {

				return i;

			}

		}

	}

	function getLibraryNode( id ) {

		var nodes = COLLADA.querySelectorAll('library_nodes node');

		for ( var i = 0; i < nodes.length; i++ ) {

			var attObj = nodes[i].attributes.getNamedItem('id');

			if ( attObj && attObj.value === id ) {

				return nodes[i];

			}

		}

		return undefined;

	}

	function getChannelsForNode ( node ) {

		var channels = [];
		var startTime = 1000000;
		var endTime = -1000000;

		for ( var id in animations ) {

			var animation = animations[id];

			for ( var i = 0; i < animation.channel.length; i ++ ) {

				var channel = animation.channel[i];
				var sampler = animation.sampler[i];
				var id = channel.target.split('/')[0];

				if ( id == node.id ) {

					sampler.create();
					channel.sampler = sampler;
					startTime = Math.min(startTime, sampler.startTime);
					endTime = Math.max(endTime, sampler.endTime);
					channels.push(channel);

				}

			}

		}

		if ( channels.length ) {

			node.startTime = startTime;
			node.endTime = endTime;

		}

		return channels;

	}

	function calcFrameDuration( node ) {

		var minT = 10000000;

		for ( var i = 0; i < node.channels.length; i ++ ) {

			var sampler = node.channels[i].sampler;

			for ( var j = 0; j < sampler.input.length - 1; j ++ ) {

				var t0 = sampler.input[ j ];
				var t1 = sampler.input[ j + 1 ];
				minT = Math.min( minT, t1 - t0 );

			}
		}

		return minT;

	}

	function calcMatrixAt( node, t ) {

		var animated = {};

		var i, j;

		for ( i = 0; i < node.channels.length; i ++ ) {

			var channel = node.channels[ i ];
			animated[ channel.sid ] = channel;

		}

		var matrix = new THREE.Matrix4();

		for ( i = 0; i < node.transforms.length; i ++ ) {

			var transform = node.transforms[ i ];
			var channel = animated[ transform.sid ];

			if ( channel !== undefined ) {

				var sampler = channel.sampler;
				var value;

				for ( j = 0; j < sampler.input.length - 1; j ++ ) {

					if ( sampler.input[ j + 1 ] > t ) {

						value = sampler.output[ j ];
						//console.log(value.flatten)
						break;

					}

				}

				if ( value !== undefined ) {

					if ( value instanceof THREE.Matrix4 ) {

						matrix.multiplyMatrices( matrix, value );

					} else {

						// FIXME: handle other types

						matrix.multiplyMatrices( matrix, transform.matrix );

					}

				} else {

					matrix.multiplyMatrices( matrix, transform.matrix );

				}

			} else {

				matrix.multiplyMatrices( matrix, transform.matrix );

			}

		}

		return matrix;

	}

	function bakeAnimations ( node ) {

		if ( node.channels && node.channels.length ) {

			var keys = [],
				sids = [];

			for ( var i = 0, il = node.channels.length; i < il; i ++ ) {

				var channel = node.channels[i],
					fullSid = channel.fullSid,
					sampler = channel.sampler,
					input = sampler.input,
					transform = node.getTransformBySid( channel.sid ),
					member;

				if ( channel.arrIndices ) {

					member = [];

					for ( var j = 0, jl = channel.arrIndices.length; j < jl; j ++ ) {

						member[ j ] = getConvertedIndex( channel.arrIndices[ j ] );

					}

				} else {

					member = getConvertedMember( channel.member );

				}

				if ( transform ) {

					if ( sids.indexOf( fullSid ) === -1 ) {

						sids.push( fullSid );

					}

					for ( var j = 0, jl = input.length; j < jl; j ++ ) {

						var time = input[j],
							data = sampler.getData( transform.type, j, member ),
							key = findKey( keys, time );

						if ( !key ) {

							key = new Key( time );
							var timeNdx = findTimeNdx( keys, time );
							keys.splice( timeNdx === -1 ? keys.length : timeNdx, 0, key );

						}

						key.addTarget( fullSid, transform, member, data );

					}

				} else {

					console.log( 'Could not find transform "' + channel.sid + '" in node ' + node.id );

				}

			}

			// post process
			for ( var i = 0; i < sids.length; i ++ ) {

				var sid = sids[ i ];

				for ( var j = 0; j < keys.length; j ++ ) {

					var key = keys[ j ];

					if ( !key.hasTarget( sid ) ) {

						interpolateKeys( keys, key, j, sid );

					}

				}

			}

			node.keys = keys;
			node.sids = sids;

		}

	}

	function findKey ( keys, time) {

		var retVal = null;

		for ( var i = 0, il = keys.length; i < il && retVal === null; i ++ ) {

			var key = keys[i];

			if ( key.time === time ) {

				retVal = key;

			} else if ( key.time > time ) {

				break;

			}

		}

		return retVal;

	}

	function findTimeNdx ( keys, time) {

		var ndx = -1;

		for ( var i = 0, il = keys.length; i < il && ndx === -1; i ++ ) {

			var key = keys[i];

			if ( key.time >= time ) {

				ndx = i;

			}

		}

		return ndx;

	}

	function interpolateKeys ( keys, key, ndx, fullSid ) {

		var prevKey = getPrevKeyWith( keys, fullSid, ndx ? ndx - 1 : 0 ),
			nextKey = getNextKeyWith( keys, fullSid, ndx + 1 );

		if ( prevKey && nextKey ) {

			var scale = (key.time - prevKey.time) / (nextKey.time - prevKey.time),
				prevTarget = prevKey.getTarget( fullSid ),
				nextData = nextKey.getTarget( fullSid ).data,
				prevData = prevTarget.data,
				data;

			if ( prevTarget.type === 'matrix' ) {

				data = prevData;

			} else if ( prevData.length ) {

				data = [];

				for ( var i = 0; i < prevData.length; ++ i ) {

					data[ i ] = prevData[ i ] + ( nextData[ i ] - prevData[ i ] ) * scale;

				}

			} else {

				data = prevData + ( nextData - prevData ) * scale;

			}

			key.addTarget( fullSid, prevTarget.transform, prevTarget.member, data );

		}

	}

	// Get next key with given sid

	function getNextKeyWith( keys, fullSid, ndx ) {

		for ( ; ndx < keys.length; ndx ++ ) {

			var key = keys[ ndx ];

			if ( key.hasTarget( fullSid ) ) {

				return key;

			}

		}

		return null;

	}

	// Get previous key with given sid

	function getPrevKeyWith( keys, fullSid, ndx ) {

		ndx = ndx >= 0 ? ndx : ndx + keys.length;

		for ( ; ndx >= 0; ndx -- ) {

			var key = keys[ ndx ];

			if ( key.hasTarget( fullSid ) ) {

				return key;

			}

		}

		return null;

	}

	function _Image() {

		this.id = "";
		this.init_from = "";

	}

	_Image.prototype.parse = function(element) {

		this.id = element.getAttribute('id');

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];

			if ( child.nodeName === 'init_from' ) {

				this.init_from = child.textContent;

			}

		}

		return this;

	};

	function Controller() {

		this.id = "";
		this.name = "";
		this.type = "";
		this.skin = null;
		this.morph = null;

	}

	Controller.prototype.parse = function( element ) {

		this.id = element.getAttribute('id');
		this.name = element.getAttribute('name');
		this.type = "none";

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];

			switch ( child.nodeName ) {

				case 'skin':

					this.skin = (new Skin()).parse(child);
					this.type = child.nodeName;
					break;

				case 'morph':

					this.morph = (new Morph()).parse(child);
					this.type = child.nodeName;
					break;

				default:
					break;

			}
		}

		return this;

	};

	function Morph() {

		this.method = null;
		this.source = null;
		this.targets = null;
		this.weights = null;

	}

	Morph.prototype.parse = function( element ) {

		var sources = {};
		var inputs = [];
		var i;

		this.method = element.getAttribute( 'method' );
		this.source = element.getAttribute( 'source' ).replace( /^#/, '' );

		for ( i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'source':

					var source = ( new Source() ).parse( child );
					sources[ source.id ] = source;
					break;

				case 'targets':

					inputs = this.parseInputs( child );
					break;

				default:

					console.log( child.nodeName );
					break;

			}

		}

		for ( i = 0; i < inputs.length; i ++ ) {

			var input = inputs[ i ];
			var source = sources[ input.source ];

			switch ( input.semantic ) {

				case 'MORPH_TARGET':

					this.targets = source.read();
					break;

				case 'MORPH_WEIGHT':

					this.weights = source.read();
					break;

				default:
					break;

			}
		}

		return this;

	};

	Morph.prototype.parseInputs = function(element) {

		var inputs = [];

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[i];
			if ( child.nodeType != 1) continue;

			switch ( child.nodeName ) {

				case 'input':

					inputs.push( (new Input()).parse(child) );
					break;

				default:
					break;
			}
		}

		return inputs;

	};

	function Skin() {

		this.source = "";
		this.bindShapeMatrix = null;
		this.invBindMatrices = [];
		this.joints = [];
		this.weights = [];

	}

	Skin.prototype.parse = function( element ) {

		var sources = {};
		var joints, weights;

		this.source = element.getAttribute( 'source' ).replace( /^#/, '' );
		this.invBindMatrices = [];
		this.joints = [];
		this.weights = [];

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[i];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'bind_shape_matrix':

					var f = _floats(child.textContent);
					this.bindShapeMatrix = getConvertedMat4( f );
					break;

				case 'source':

					var src = new Source().parse(child);
					sources[ src.id ] = src;
					break;

				case 'joints':

					joints = child;
					break;

				case 'vertex_weights':

					weights = child;
					break;

				default:

					console.log( child.nodeName );
					break;

			}
		}

		this.parseJoints( joints, sources );
		this.parseWeights( weights, sources );

		return this;

	};

	Skin.prototype.parseJoints = function ( element, sources ) {

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'input':

					var input = ( new Input() ).parse( child );
					var source = sources[ input.source ];

					if ( input.semantic === 'JOINT' ) {

						this.joints = source.read();

					} else if ( input.semantic === 'INV_BIND_MATRIX' ) {

						this.invBindMatrices = source.read();

					}

					break;

				default:
					break;
			}

		}

	};

	Skin.prototype.parseWeights = function ( element, sources ) {

		var v, vcount, inputs = [];

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'input':

					inputs.push( ( new Input() ).parse( child ) );
					break;

				case 'v':

					v = _ints( child.textContent );
					break;

				case 'vcount':

					vcount = _ints( child.textContent );
					break;

				default:
					break;

			}

		}

		var index = 0;

		for ( var i = 0; i < vcount.length; i ++ ) {

			var numBones = vcount[i];
			var vertex_weights = [];

			for ( var j = 0; j < numBones; j ++ ) {

				var influence = {};

				for ( var k = 0; k < inputs.length; k ++ ) {

					var input = inputs[ k ];
					var value = v[ index + input.offset ];

					switch ( input.semantic ) {

						case 'JOINT':

							influence.joint = value;//this.joints[value];
							break;

						case 'WEIGHT':

							influence.weight = sources[ input.source ].data[ value ];
							break;

						default:
							break;

					}

				}

				vertex_weights.push( influence );
				index += inputs.length;
			}

			for ( var j = 0; j < vertex_weights.length; j ++ ) {

				vertex_weights[ j ].index = i;

			}

			this.weights.push( vertex_weights );

		}

	};

	function VisualScene () {

		this.id = "";
		this.name = "";
		this.nodes = [];
		this.scene = new THREE.Group();

	}

	VisualScene.prototype.getChildById = function( id, recursive ) {

		for ( var i = 0; i < this.nodes.length; i ++ ) {

			var node = this.nodes[ i ].getChildById( id, recursive );

			if ( node ) {

				return node;

			}

		}

		return null;

	};

	VisualScene.prototype.getChildBySid = function( sid, recursive ) {

		for ( var i = 0; i < this.nodes.length; i ++ ) {

			var node = this.nodes[ i ].getChildBySid( sid, recursive );

			if ( node ) {

				return node;

			}

		}

		return null;

	};

	VisualScene.prototype.parse = function( element ) {

		this.id = element.getAttribute( 'id' );
		this.name = element.getAttribute( 'name' );
		this.nodes = [];

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'node':

					this.nodes.push( ( new Node() ).parse( child ) );
					break;

				default:
					break;

			}

		}

		return this;

	};

	function Node() {

		this.id = "";
		this.name = "";
		this.sid = "";
		this.nodes = [];
		this.controllers = [];
		this.transforms = [];
		this.geometries = [];
		this.channels = [];
		this.matrix = new THREE.Matrix4();

	}

	Node.prototype.getChannelForTransform = function( transformSid ) {

		for ( var i = 0; i < this.channels.length; i ++ ) {

			var channel = this.channels[i];
			var parts = channel.target.split('/');
			var id = parts.shift();
			var sid = parts.shift();
			var dotSyntax = (sid.indexOf(".") >= 0);
			var arrSyntax = (sid.indexOf("(") >= 0);
			var arrIndices;
			var member;

			if ( dotSyntax ) {

				parts = sid.split(".");
				sid = parts.shift();
				member = parts.shift();

			} else if ( arrSyntax ) {

				arrIndices = sid.split("(");
				sid = arrIndices.shift();

				for ( var j = 0; j < arrIndices.length; j ++ ) {

					arrIndices[ j ] = parseInt( arrIndices[ j ].replace( /\)/, '' ) );

				}

			}

			if ( sid === transformSid ) {

				channel.info = { sid: sid, dotSyntax: dotSyntax, arrSyntax: arrSyntax, arrIndices: arrIndices };
				return channel;

			}

		}

		return null;

	};

	Node.prototype.getChildById = function ( id, recursive ) {

		if ( this.id === id ) {

			return this;

		}

		if ( recursive ) {

			for ( var i = 0; i < this.nodes.length; i ++ ) {

				var n = this.nodes[ i ].getChildById( id, recursive );

				if ( n ) {

					return n;

				}

			}

		}

		return null;

	};

	Node.prototype.getChildBySid = function ( sid, recursive ) {

		if ( this.sid === sid ) {

			return this;

		}

		if ( recursive ) {

			for ( var i = 0; i < this.nodes.length; i ++ ) {

				var n = this.nodes[ i ].getChildBySid( sid, recursive );

				if ( n ) {

					return n;

				}

			}
		}

		return null;

	};

	Node.prototype.getTransformBySid = function ( sid ) {

		for ( var i = 0; i < this.transforms.length; i ++ ) {

			if ( this.transforms[ i ].sid === sid ) return this.transforms[ i ];

		}

		return null;

	};

	Node.prototype.parse = function( element ) {

		var url;

		this.id = element.getAttribute('id');
		this.sid = element.getAttribute('sid');
		this.name = element.getAttribute('name');
		this.type = element.getAttribute('type');
		this.layer = element.getAttribute('layer');

		this.type = this.type === 'JOINT' ? this.type : 'NODE';

		this.nodes = [];
		this.transforms = [];
		this.geometries = [];
		this.cameras = [];
		this.lights = [];
		this.controllers = [];
		this.matrix = new THREE.Matrix4();

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'node':

					this.nodes.push( ( new Node() ).parse( child ) );
					break;

				case 'instance_camera':

					this.cameras.push( ( new InstanceCamera() ).parse( child ) );
					break;

				case 'instance_controller':

					this.controllers.push( ( new InstanceController() ).parse( child ) );
					break;

				case 'instance_geometry':

					this.geometries.push( ( new InstanceGeometry() ).parse( child ) );
					break;

				case 'instance_light':

					this.lights.push( ( new InstanceLight() ).parse( child ) );
					break;

				case 'instance_node':

					url = child.getAttribute( 'url' ).replace( /^#/, '' );
					var iNode = getLibraryNode( url );

					if ( iNode ) {

						this.nodes.push( ( new Node() ).parse( iNode )) ;

					}

					break;

				case 'rotate':
				case 'translate':
				case 'scale':
				case 'matrix':
				case 'lookat':
				case 'skew':

					this.transforms.push( ( new Transform() ).parse( child ) );
					break;

				case 'extra':
					break;

				default:

					console.log( child.nodeName );
					break;

			}

		}

		this.channels = getChannelsForNode( this );
		bakeAnimations( this );

		this.updateMatrix();

		return this;

	};

	Node.prototype.updateMatrix = function () {

		this.matrix.identity();

		for ( var i = 0; i < this.transforms.length; i ++ ) {

			this.transforms[ i ].apply( this.matrix );

		}

	};

	function Transform () {

		this.sid = "";
		this.type = "";
		this.data = [];
		this.obj = null;

	}

	Transform.prototype.parse = function ( element ) {

		this.sid = element.getAttribute( 'sid' );
		this.type = element.nodeName;
		this.data = _floats( element.textContent );
		this.convert();

		return this;

	};

	Transform.prototype.convert = function () {

		switch ( this.type ) {

			case 'matrix':

				this.obj = getConvertedMat4( this.data );
				break;

			case 'rotate':

				this.angle = THREE.Math.degToRad( this.data[3] );

			case 'translate':

				fixCoords( this.data, -1 );
				this.obj = new THREE.Vector3( this.data[ 0 ], this.data[ 1 ], this.data[ 2 ] );
				break;

			case 'scale':

				fixCoords( this.data, 1 );
				this.obj = new THREE.Vector3( this.data[ 0 ], this.data[ 1 ], this.data[ 2 ] );
				break;

			default:
				console.log( 'Can not convert Transform of type ' + this.type );
				break;

		}

	};

	Transform.prototype.apply = function () {

		var m1 = new THREE.Matrix4();

		return function ( matrix ) {

			switch ( this.type ) {

				case 'matrix':

					matrix.multiply( this.obj );

					break;

				case 'translate':

					matrix.multiply( m1.makeTranslation( this.obj.x, this.obj.y, this.obj.z ) );

					break;

				case 'rotate':

					matrix.multiply( m1.makeRotationAxis( this.obj, this.angle ) );

					break;

				case 'scale':

					matrix.scale( this.obj );

					break;

			}

		};

	}();

	Transform.prototype.update = function ( data, member ) {

		var members = [ 'X', 'Y', 'Z', 'ANGLE' ];

		switch ( this.type ) {

			case 'matrix':

				if ( ! member ) {

					this.obj.copy( data );

				} else if ( member.length === 1 ) {

					switch ( member[ 0 ] ) {

						case 0:

							this.obj.n11 = data[ 0 ];
							this.obj.n21 = data[ 1 ];
							this.obj.n31 = data[ 2 ];
							this.obj.n41 = data[ 3 ];

							break;

						case 1:

							this.obj.n12 = data[ 0 ];
							this.obj.n22 = data[ 1 ];
							this.obj.n32 = data[ 2 ];
							this.obj.n42 = data[ 3 ];

							break;

						case 2:

							this.obj.n13 = data[ 0 ];
							this.obj.n23 = data[ 1 ];
							this.obj.n33 = data[ 2 ];
							this.obj.n43 = data[ 3 ];

							break;

						case 3:

							this.obj.n14 = data[ 0 ];
							this.obj.n24 = data[ 1 ];
							this.obj.n34 = data[ 2 ];
							this.obj.n44 = data[ 3 ];

							break;

					}

				} else if ( member.length === 2 ) {

					var propName = 'n' + ( member[ 0 ] + 1 ) + ( member[ 1 ] + 1 );
					this.obj[ propName ] = data;

				} else {

					console.log('Incorrect addressing of matrix in transform.');

				}

				break;

			case 'translate':
			case 'scale':

				if ( Object.prototype.toString.call( member ) === '[object Array]' ) {

					member = members[ member[ 0 ] ];

				}

				switch ( member ) {

					case 'X':

						this.obj.x = data;
						break;

					case 'Y':

						this.obj.y = data;
						break;

					case 'Z':

						this.obj.z = data;
						break;

					default:

						this.obj.x = data[ 0 ];
						this.obj.y = data[ 1 ];
						this.obj.z = data[ 2 ];
						break;

				}

				break;

			case 'rotate':

				if ( Object.prototype.toString.call( member ) === '[object Array]' ) {

					member = members[ member[ 0 ] ];

				}

				switch ( member ) {

					case 'X':

						this.obj.x = data;
						break;

					case 'Y':

						this.obj.y = data;
						break;

					case 'Z':

						this.obj.z = data;
						break;

					case 'ANGLE':

						this.angle = THREE.Math.degToRad( data );
						break;

					default:

						this.obj.x = data[ 0 ];
						this.obj.y = data[ 1 ];
						this.obj.z = data[ 2 ];
						this.angle = THREE.Math.degToRad( data[ 3 ] );
						break;

				}
				break;

		}

	};

	function InstanceController() {

		this.url = "";
		this.skeleton = [];
		this.instance_material = [];

	}

	InstanceController.prototype.parse = function ( element ) {

		this.url = element.getAttribute('url').replace(/^#/, '');
		this.skeleton = [];
		this.instance_material = [];

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];
			if ( child.nodeType !== 1 ) continue;

			switch ( child.nodeName ) {

				case 'skeleton':

					this.skeleton.push( child.textContent.replace(/^#/, '') );
					break;

				case 'bind_material':

					var instances = child.querySelectorAll('instance_material');

					for ( var j = 0; j < instances.length; j ++ ) {

						var instance = instances[j];
						this.instance_material.push( (new InstanceMaterial()).parse(instance) );

					}


					break;

				case 'extra':
					break;

				default:
					break;

			}
		}

		return this;

	};

	function InstanceMaterial () {

		this.symbol = "";
		this.target = "";

	}

	InstanceMaterial.prototype.parse = function ( element ) {

		this.symbol = element.getAttribute('symbol');
		this.target = element.getAttribute('target').replace(/^#/, '');
		return this;

	};

	function InstanceGeometry() {

		this.url = "";
		this.instance_material = [];

	}

	InstanceGeometry.prototype.parse = function ( element ) {

		this.url = element.getAttribute('url').replace(/^#/, '');
		this.instance_material = [];

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[i];
			if ( child.nodeType != 1 ) continue;

			if ( child.nodeName === 'bind_material' ) {

				var instances = child.querySelectorAll('instance_material');

				for ( var j = 0; j < instances.length; j ++ ) {

					var instance = instances[j];
					this.instance_material.push( (new InstanceMaterial()).parse(instance) );

				}

				break;

			}

		}

		return this;

	};

	function Geometry() {

		this.id = "";
		this.mesh = null;

	}

	Geometry.prototype.parse = function ( element ) {

		this.id = element.getAttribute('id');

		extractDoubleSided( this, element );

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[i];

			switch ( child.nodeName ) {

				case 'mesh':

					this.mesh = (new Mesh(this)).parse(child);
					break;

				case 'extra':

					// console.log( child );
					break;

				default:
					break;
			}
		}

		return this;

	};

	function Mesh( geometry ) {

		this.geometry = geometry.id;
		this.primitives = [];
		this.vertices = null;
		this.geometry3js = null;

	}

	Mesh.prototype.parse = function ( element ) {

		this.primitives = [];

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];

			switch ( child.nodeName ) {

				case 'source':

					_source( child );
					break;

				case 'vertices':

					this.vertices = ( new Vertices() ).parse( child );
					break;

				case 'linestrips':

					this.primitives.push( ( new LineStrips().parse( child ) ) );
					break;

				case 'triangles':

					this.primitives.push( ( new Triangles().parse( child ) ) );
					break;

				case 'polygons':

					this.primitives.push( ( new Polygons().parse( child ) ) );
					break;

				case 'polylist':

					this.primitives.push( ( new Polylist().parse( child ) ) );
					break;

				default:
					break;

			}

		}

		this.geometry3js = new THREE.Geometry();

		if ( this.vertices === null ) {

			// TODO (mrdoob): Study case when this is null (carrier.dae)

			return this;

		}

		var vertexData = sources[ this.vertices.input['POSITION'].source ].data;

		for ( var i = 0; i < vertexData.length; i += 3 ) {

			this.geometry3js.vertices.push( getConvertedVec3( vertexData, i ).clone() );

		}

		for ( var i = 0; i < this.primitives.length; i ++ ) {

			var primitive = this.primitives[ i ];
			primitive.setVertices( this.vertices );
			this.handlePrimitive( primitive, this.geometry3js );

		}

		if ( this.geometry3js.calcNormals ) {

			this.geometry3js.computeVertexNormals();
			delete this.geometry3js.calcNormals;

		}

		return this;

	};

	Mesh.prototype.handlePrimitive = function ( primitive, geom ) {

		if ( primitive instanceof LineStrips ) {

			// TODO: Handle indices. Maybe easier with BufferGeometry?

			geom.isLineStrip = true;
			return;

		}

		var j, k, pList = primitive.p, inputs = primitive.inputs;
		var input, index, idx32;
		var source, numParams;
		var vcIndex = 0, vcount = 3, maxOffset = 0;
		var texture_sets = [];

		for ( j = 0; j < inputs.length; j ++ ) {

			input = inputs[ j ];

			var offset = input.offset + 1;
			maxOffset = (maxOffset < offset) ? offset : maxOffset;

			switch ( input.semantic ) {

				case 'TEXCOORD':
					texture_sets.push( input.set );
					break;

			}

		}

		for ( var pCount = 0; pCount < pList.length; ++ pCount ) {

			var p = pList[ pCount ], i = 0;

			while ( i < p.length ) {

				var vs = [];
				var ns = [];
				var ts = null;
				var cs = [];

				if ( primitive.vcount ) {

					vcount = primitive.vcount.length ? primitive.vcount[ vcIndex ++ ] : primitive.vcount;

				} else {

					vcount = p.length / maxOffset;

				}


				for ( j = 0; j < vcount; j ++ ) {

					for ( k = 0; k < inputs.length; k ++ ) {

						input = inputs[ k ];
						source = sources[ input.source ];

						index = p[ i + ( j * maxOffset ) + input.offset ];
						numParams = source.accessor.params.length;
						idx32 = index * numParams;

						switch ( input.semantic ) {

							case 'VERTEX':

								vs.push( index );

								break;

							case 'NORMAL':

								ns.push( getConvertedVec3( source.data, idx32 ) );

								break;

							case 'TEXCOORD':

								ts = ts || { };
								if ( ts[ input.set ] === undefined ) ts[ input.set ] = [];
								// invert the V
								ts[ input.set ].push( new THREE.Vector2( source.data[ idx32 ], source.data[ idx32 + 1 ] ) );

								break;

							case 'COLOR':

								cs.push( new THREE.Color().setRGB( source.data[ idx32 ], source.data[ idx32 + 1 ], source.data[ idx32 + 2 ] ) );

								break;

							default:

								break;

						}

					}

				}

				if ( ns.length === 0 ) {

					// check the vertices inputs
					input = this.vertices.input.NORMAL;

					if ( input ) {

						source = sources[ input.source ];
						numParams = source.accessor.params.length;

						for ( var ndx = 0, len = vs.length; ndx < len; ndx ++ ) {

							ns.push( getConvertedVec3( source.data, vs[ ndx ] * numParams ) );

						}

					} else {

						geom.calcNormals = true;

					}

				}

				if ( !ts ) {

					ts = { };
					// check the vertices inputs
					input = this.vertices.input.TEXCOORD;

					if ( input ) {

						texture_sets.push( input.set );
						source = sources[ input.source ];
						numParams = source.accessor.params.length;

						for ( var ndx = 0, len = vs.length; ndx < len; ndx ++ ) {

							idx32 = vs[ ndx ] * numParams;
							if ( ts[ input.set ] === undefined ) ts[ input.set ] = [ ];
							// invert the V
							ts[ input.set ].push( new THREE.Vector2( source.data[ idx32 ], 1.0 - source.data[ idx32 + 1 ] ) );

						}

					}

				}

				if ( cs.length === 0 ) {

					// check the vertices inputs
					input = this.vertices.input.COLOR;

					if ( input ) {

						source = sources[ input.source ];
						numParams = source.accessor.params.length;

						for ( var ndx = 0, len = vs.length; ndx < len; ndx ++ ) {

							idx32 = vs[ ndx ] * numParams;
							cs.push( new THREE.Color().setRGB( source.data[ idx32 ], source.data[ idx32 + 1 ], source.data[ idx32 + 2 ] ) );

						}

					}

				}

				var face = null, faces = [], uv, uvArr;

				if ( vcount === 3 ) {

					faces.push( new THREE.Face3( vs[0], vs[1], vs[2], ns, cs.length ? cs : new THREE.Color() ) );

				} else if ( vcount === 4 ) {

					faces.push( new THREE.Face3( vs[0], vs[1], vs[3], ns.length ? [ ns[0].clone(), ns[1].clone(), ns[3].clone() ] : [], cs.length ? [ cs[0], cs[1], cs[3] ] : new THREE.Color() ) );

					faces.push( new THREE.Face3( vs[1], vs[2], vs[3], ns.length ? [ ns[1].clone(), ns[2].clone(), ns[3].clone() ] : [], cs.length ? [ cs[1], cs[2], cs[3] ] : new THREE.Color() ) );

				} else if ( vcount > 4 && options.subdivideFaces ) {

					var clr = cs.length ? cs : new THREE.Color(),
						vec1, vec2, vec3, v1, v2, norm;

					// subdivide into multiple Face3s

					for ( k = 1; k < vcount - 1; ) {

						faces.push( new THREE.Face3( vs[0], vs[k], vs[k + 1], ns.length ? [ ns[0].clone(), ns[k ++].clone(), ns[k].clone() ] : [], clr ) );

					}

				}

				if ( faces.length ) {

					for ( var ndx = 0, len = faces.length; ndx < len; ndx ++ ) {

						face = faces[ndx];
						face.daeMaterial = primitive.material;
						geom.faces.push( face );

						for ( k = 0; k < texture_sets.length; k ++ ) {

							uv = ts[ texture_sets[k] ];

							if ( vcount > 4 ) {

								// Grab the right UVs for the vertices in this face
								uvArr = [ uv[0], uv[ndx + 1], uv[ndx + 2] ];

							} else if ( vcount === 4 ) {

								if ( ndx === 0 ) {

									uvArr = [ uv[0], uv[1], uv[3] ];

								} else {

									uvArr = [ uv[1].clone(), uv[2], uv[3].clone() ];

								}

							} else {

								uvArr = [ uv[0], uv[1], uv[2] ];

							}

							if ( geom.faceVertexUvs[k] === undefined ) {

								geom.faceVertexUvs[k] = [];

							}

							geom.faceVertexUvs[k].push( uvArr );

						}

					}

				} else {

					console.log( 'dropped face with vcount ' + vcount + ' for geometry with id: ' + geom.id );

				}

				i += maxOffset * vcount;

			}

		}

	};

	function Polygons () {

		this.material = "";
		this.count = 0;
		this.inputs = [];
		this.vcount = null;
		this.p = [];
		this.geometry = new THREE.Geometry();

	}

	Polygons.prototype.setVertices = function ( vertices ) {

		for ( var i = 0; i < this.inputs.length; i ++ ) {

			if ( this.inputs[ i ].source === vertices.id ) {

				this.inputs[ i ].source = vertices.input[ 'POSITION' ].source;

			}

		}

	};

	Polygons.prototype.parse = function ( element ) {

		this.material = element.getAttribute( 'material' );
		this.count = _attr_as_int( element, 'count', 0 );

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];

			switch ( child.nodeName ) {

				case 'input':

					this.inputs.push( ( new Input() ).parse( element.childNodes[ i ] ) );
					break;

				case 'vcount':

					this.vcount = _ints( child.textContent );
					break;

				case 'p':

					this.p.push( _ints( child.textContent ) );
					break;

				case 'ph':

					console.warn( 'polygon holes not yet supported!' );
					break;

				default:
					break;

			}

		}

		return this;

	};

	function Polylist () {

		Polygons.call( this );

		this.vcount = [];

	}

	Polylist.prototype = Object.create( Polygons.prototype );
	Polylist.prototype.constructor = Polylist;

	function LineStrips() {

		Polygons.call( this );

		this.vcount = 1;

	}

	LineStrips.prototype = Object.create( Polygons.prototype );
	LineStrips.prototype.constructor = LineStrips;

	function Triangles () {

		Polygons.call( this );

		this.vcount = 3;

	}

	Triangles.prototype = Object.create( Polygons.prototype );
	Triangles.prototype.constructor = Triangles;

	function Accessor() {

		this.source = "";
		this.count = 0;
		this.stride = 0;
		this.params = [];

	}

	Accessor.prototype.parse = function ( element ) {

		this.params = [];
		this.source = element.getAttribute( 'source' );
		this.count = _attr_as_int( element, 'count', 0 );
		this.stride = _attr_as_int( element, 'stride', 0 );

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];

			if ( child.nodeName === 'param' ) {

				var param = {};
				param[ 'name' ] = child.getAttribute( 'name' );
				param[ 'type' ] = child.getAttribute( 'type' );
				this.params.push( param );

			}

		}

		return this;

	};

	function Vertices() {

		this.input = {};

	}

	Vertices.prototype.parse = function ( element ) {

		this.id = element.getAttribute('id');

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			if ( element.childNodes[i].nodeName === 'input' ) {

				var input = ( new Input() ).parse( element.childNodes[ i ] );
				this.input[ input.semantic ] = input;

			}

		}

		return this;

	};

	function Input () {

		this.semantic = "";
		this.offset = 0;
		this.source = "";
		this.set = 0;

	}

	Input.prototype.parse = function ( element ) {

		this.semantic = element.getAttribute('semantic');
		this.source = element.getAttribute('source').replace(/^#/, '');
		this.set = _attr_as_int(element, 'set', -1);
		this.offset = _attr_as_int(element, 'offset', 0);

		if ( this.semantic === 'TEXCOORD' && this.set < 0 ) {

			this.set = 0;

		}

		return this;

	};

	function Source ( id ) {

		this.id = id;
		this.type = null;

	}

	Source.prototype.parse = function ( element ) {

		this.id = element.getAttribute( 'id' );

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[i];

			switch ( child.nodeName ) {

				case 'bool_array':

					this.data = _bools( child.textContent );
					this.type = child.nodeName;
					break;

				case 'float_array':

					this.data = _floats( child.textContent );
					this.type = child.nodeName;
					break;

				case 'int_array':

					this.data = _ints( child.textContent );
					this.type = child.nodeName;
					break;

				case 'IDREF_array':
				case 'Name_array':

					this.data = _strings( child.textContent );
					this.type = child.nodeName;
					break;

				case 'technique_common':

					for ( var j = 0; j < child.childNodes.length; j ++ ) {

						if ( child.childNodes[ j ].nodeName === 'accessor' ) {

							this.accessor = ( new Accessor() ).parse( child.childNodes[ j ] );
							break;

						}
					}
					break;

				default:
					// console.log(child.nodeName);
					break;

			}

		}

		return this;

	};

	Source.prototype.read = function () {

		var result = [];

		//for (var i = 0; i < this.accessor.params.length; i++) {

		var param = this.accessor.params[ 0 ];

			//console.log(param.name + " " + param.type);

		switch ( param.type ) {

			case 'IDREF':
			case 'Name': case 'name':
			case 'float':

				return this.data;

			case 'float4x4':

				for ( var j = 0; j < this.data.length; j += 16 ) {

					var s = this.data.slice( j, j + 16 );
					var m = getConvertedMat4( s );
					result.push( m );
				}

				break;

			default:

				console.log( 'ColladaLoader: Source: Read dont know how to read ' + param.type + '.' );
				break;

		}

		//}

		return result;

	};

	function Material () {

		this.id = "";
		this.name = "";
		this.instance_effect = null;

	}

	Material.prototype.parse = function ( element ) {

		this.id = element.getAttribute( 'id' );
		this.name = element.getAttribute( 'name' );

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			if ( element.childNodes[ i ].nodeName === 'instance_effect' ) {

				this.instance_effect = ( new InstanceEffect() ).parse( element.childNodes[ i ] );
				break;

			}

		}

		return this;

	};

	function ColorOrTexture () {

		this.color = new THREE.Color();
		this.color.setRGB( Math.random(), Math.random(), Math.random() );
		this.color.a = 1.0;

		this.texture = null;
		this.texcoord = null;
		this.texOpts = null;

	}

	ColorOrTexture.prototype.isColor = function () {

		return ( this.texture === null );

	};

	ColorOrTexture.prototype.isTexture = function () {

		return ( this.texture != null );

	};

	ColorOrTexture.prototype.parse = function ( element ) {

		if (element.nodeName === 'transparent') {

			this.opaque = element.getAttribute('opaque');

		}

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'color':

					var rgba = _floats( child.textContent );
					this.color = new THREE.Color();
					this.color.setRGB( rgba[0], rgba[1], rgba[2] );
					this.color.a = rgba[3];
					break;

				case 'texture':

					this.texture = child.getAttribute('texture');
					this.texcoord = child.getAttribute('texcoord');
					// Defaults from:
					// https://collada.org/mediawiki/index.php/Maya_texture_placement_MAYA_extension
					this.texOpts = {
						offsetU: 0,
						offsetV: 0,
						repeatU: 1,
						repeatV: 1,
						wrapU: 1,
						wrapV: 1
					};
					this.parseTexture( child );
					break;

				default:
					break;

			}

		}

		return this;

	};

	ColorOrTexture.prototype.parseTexture = function ( element ) {

		if ( ! element.childNodes ) return this;

		// This should be supported by Maya, 3dsMax, and MotionBuilder

		if ( element.childNodes[1] && element.childNodes[1].nodeName === 'extra' ) {

			element = element.childNodes[1];

			if ( element.childNodes[1] && element.childNodes[1].nodeName === 'technique' ) {

				element = element.childNodes[1];

			}

		}

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];

			switch ( child.nodeName ) {

				case 'offsetU':
				case 'offsetV':
				case 'repeatU':
				case 'repeatV':

					this.texOpts[ child.nodeName ] = parseFloat( child.textContent );

					break;

				case 'wrapU':
				case 'wrapV':

					// some dae have a value of true which becomes NaN via parseInt

					if ( child.textContent.toUpperCase() === 'TRUE' ) {

						this.texOpts[ child.nodeName ] = 1;

					} else {

						this.texOpts[ child.nodeName ] = parseInt( child.textContent );

					}
					break;

				default:

					this.texOpts[ child.nodeName ] = child.textContent;

					break;

			}

		}

		return this;

	};

	function Shader ( type, effect ) {

		this.type = type;
		this.effect = effect;
		this.material = null;

	}

	Shader.prototype.parse = function ( element ) {

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'emission':
				case 'diffuse':
				case 'specular':
				case 'transparent':

					this[ child.nodeName ] = ( new ColorOrTexture() ).parse( child );
					break;

				case 'bump':

					// If 'bumptype' is 'heightfield', create a 'bump' property
					// Else if 'bumptype' is 'normalmap', create a 'normal' property
					// (Default to 'bump')
					var bumpType = child.getAttribute( 'bumptype' );
					if ( bumpType ) {
						if ( bumpType.toLowerCase() === "heightfield" ) {
							this[ 'bump' ] = ( new ColorOrTexture() ).parse( child );
						} else if ( bumpType.toLowerCase() === "normalmap" ) {
							this[ 'normal' ] = ( new ColorOrTexture() ).parse( child );
						} else {
							console.error( "Shader.prototype.parse: Invalid value for attribute 'bumptype' (" + bumpType + ") - valid bumptypes are 'HEIGHTFIELD' and 'NORMALMAP' - defaulting to 'HEIGHTFIELD'" );
							this[ 'bump' ] = ( new ColorOrTexture() ).parse( child );
						}
					} else {
						console.warn( "Shader.prototype.parse: Attribute 'bumptype' missing from bump node - defaulting to 'HEIGHTFIELD'" );
						this[ 'bump' ] = ( new ColorOrTexture() ).parse( child );
					}

					break;

				case 'shininess':
				case 'reflectivity':
				case 'index_of_refraction':
				case 'transparency':

					var f = child.querySelectorAll('float');

					if ( f.length > 0 )
						this[ child.nodeName ] = parseFloat( f[ 0 ].textContent );

					break;

				default:
					break;

			}

		}

		this.create();
		return this;

	};

	Shader.prototype.create = function() {

		var props = {};

		var transparent = false;

		if (this['transparency'] !== undefined && this['transparent'] !== undefined) {
			// convert transparent color RBG to average value
			var transparentColor = this['transparent'];
			var transparencyLevel = (this.transparent.color.r + this.transparent.color.g + this.transparent.color.b) / 3 * this.transparency;

			if (transparencyLevel > 0) {
				transparent = true;
				props[ 'transparent' ] = true;
				props[ 'opacity' ] = 1 - transparencyLevel;

			}

		}

		var keys = {
			'diffuse':'map',
			'ambient':'lightMap',
			'specular':'specularMap',
			'emission':'emissionMap',
			'bump':'bumpMap',
			'normal':'normalMap'
			};

		for ( var prop in this ) {

			switch ( prop ) {

				case 'ambient':
				case 'emission':
				case 'diffuse':
				case 'specular':
				case 'bump':
				case 'normal':

					var cot = this[ prop ];

					if ( cot instanceof ColorOrTexture ) {

						if ( cot.isTexture() ) {

							var samplerId = cot.texture;
							var surfaceId = this.effect.sampler[samplerId];

							if ( surfaceId !== undefined && surfaceId.source !== undefined ) {

								var surface = this.effect.surface[surfaceId.source];

								if ( surface !== undefined ) {

									var image = images[ surface.init_from ];

									if ( image ) {

										var url = baseUrl + image.init_from;

										var texture;
										var loader = THREE.Loader.Handlers.get( url );

										if ( loader !== null ) {

											texture = loader.load( url );

										} else {

											texture = new THREE.Texture();

											loadTextureImage( texture, url );

										}

										texture.wrapS = cot.texOpts.wrapU ? THREE.RepeatWrapping : THREE.ClampToEdgeWrapping;
										texture.wrapT = cot.texOpts.wrapV ? THREE.RepeatWrapping : THREE.ClampToEdgeWrapping;
										texture.offset.x = cot.texOpts.offsetU;
										texture.offset.y = cot.texOpts.offsetV;
										texture.repeat.x = cot.texOpts.repeatU;
										texture.repeat.y = cot.texOpts.repeatV;
										props[keys[prop]] = texture;

										// Texture with baked lighting?
										if (prop === 'emission') props['emissive'] = 0xffffff;

									}

								}

							}

						} else if ( prop === 'diffuse' || !transparent ) {

							if ( prop === 'emission' ) {

								props[ 'emissive' ] = cot.color.getHex();

							} else {

								props[ prop ] = cot.color.getHex();

							}

						}

					}

					break;

				case 'shininess':

					props[ prop ] = this[ prop ];
					break;

				case 'reflectivity':

					props[ prop ] = this[ prop ];
					if ( props[ prop ] > 0.0 ) props['envMap'] = options.defaultEnvMap;
					props['combine'] = THREE.MixOperation;	//mix regular shading with reflective component
					break;

				case 'index_of_refraction':

					props[ 'refractionRatio' ] = this[ prop ]; //TODO: "index_of_refraction" becomes "refractionRatio" in shader, but I'm not sure if the two are actually comparable
					if ( this[ prop ] !== 1.0 ) props['envMap'] = options.defaultEnvMap;
					break;

				case 'transparency':
					// gets figured out up top
					break;

				default:
					break;

			}

		}

		props[ 'shading' ] = preferredShading;
		props[ 'side' ] = this.effect.doubleSided ? THREE.DoubleSide : THREE.FrontSide;

		if ( props.diffuse !== undefined ) {

			props.color = props.diffuse;
			delete props.diffuse;

		}

		switch ( this.type ) {

			case 'constant':

				if (props.emissive != undefined) props.color = props.emissive;
				this.material = new THREE.MeshBasicMaterial( props );
				break;

			case 'phong':
			case 'blinn':

				this.material = new THREE.MeshPhongMaterial( props );
				break;

			case 'lambert':
			default:

				this.material = new THREE.MeshLambertMaterial( props );
				break;

		}

		return this.material;

	};

	function Surface ( effect ) {

		this.effect = effect;
		this.init_from = null;
		this.format = null;

	}

	Surface.prototype.parse = function ( element ) {

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'init_from':

					this.init_from = child.textContent;
					break;

				case 'format':

					this.format = child.textContent;
					break;

				default:

					console.log( "unhandled Surface prop: " + child.nodeName );
					break;

			}

		}

		return this;

	};

	function Sampler2D ( effect ) {

		this.effect = effect;
		this.source = null;
		this.wrap_s = null;
		this.wrap_t = null;
		this.minfilter = null;
		this.magfilter = null;
		this.mipfilter = null;

	}

	Sampler2D.prototype.parse = function ( element ) {

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'source':

					this.source = child.textContent;
					break;

				case 'minfilter':

					this.minfilter = child.textContent;
					break;

				case 'magfilter':

					this.magfilter = child.textContent;
					break;

				case 'mipfilter':

					this.mipfilter = child.textContent;
					break;

				case 'wrap_s':

					this.wrap_s = child.textContent;
					break;

				case 'wrap_t':

					this.wrap_t = child.textContent;
					break;

				default:

					console.log( "unhandled Sampler2D prop: " + child.nodeName );
					break;

			}

		}

		return this;

	};

	function Effect () {

		this.id = "";
		this.name = "";
		this.shader = null;
		this.surface = {};
		this.sampler = {};

	}

	Effect.prototype.create = function () {

		if ( this.shader === null ) {

			return null;

		}

	};

	Effect.prototype.parse = function ( element ) {

		this.id = element.getAttribute( 'id' );
		this.name = element.getAttribute( 'name' );

		extractDoubleSided( this, element );

		this.shader = null;

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'profile_COMMON':

					this.parseTechnique( this.parseProfileCOMMON( child ) );
					break;

				default:
					break;

			}

		}

		return this;

	};

	Effect.prototype.parseNewparam = function ( element ) {

		var sid = element.getAttribute( 'sid' );

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'surface':

					this.surface[sid] = ( new Surface( this ) ).parse( child );
					break;

				case 'sampler2D':

					this.sampler[sid] = ( new Sampler2D( this ) ).parse( child );
					break;

				case 'extra':

					break;

				default:

					console.log( child.nodeName );
					break;

			}

		}

	};

	Effect.prototype.parseProfileCOMMON = function ( element ) {

		var technique;

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];

			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'profile_COMMON':

					this.parseProfileCOMMON( child );
					break;

				case 'technique':

					technique = child;
					break;

				case 'newparam':

					this.parseNewparam( child );
					break;

				case 'image':

					var _image = ( new _Image() ).parse( child );
					images[ _image.id ] = _image;
					break;

				case 'extra':
					break;

				default:

					console.log( child.nodeName );
					break;

			}

		}

		return technique;

	};

	Effect.prototype.parseTechnique = function ( element ) {

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[i];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'constant':
				case 'lambert':
				case 'blinn':
				case 'phong':

					this.shader = ( new Shader( child.nodeName, this ) ).parse( child );
					break;
				case 'extra':
					this.parseExtra(child);
					break;
				default:
					break;

			}

		}

	};

	Effect.prototype.parseExtra = function ( element ) {

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[i];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'technique':
					this.parseExtraTechnique( child );
					break;
				default:
					break;

			}

		}

	};

	Effect.prototype.parseExtraTechnique = function ( element ) {

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[i];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'bump':
					this.shader.parse( element );
					break;
				default:
					break;

			}

		}

	};

	function InstanceEffect () {

		this.url = "";

	}

	InstanceEffect.prototype.parse = function ( element ) {

		this.url = element.getAttribute( 'url' ).replace( /^#/, '' );
		return this;

	};

	function Animation() {

		this.id = "";
		this.name = "";
		this.source = {};
		this.sampler = [];
		this.channel = [];

	}

	Animation.prototype.parse = function ( element ) {

		this.id = element.getAttribute( 'id' );
		this.name = element.getAttribute( 'name' );
		this.source = {};

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];

			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'animation':

					var anim = ( new Animation() ).parse( child );

					for ( var src in anim.source ) {

						this.source[ src ] = anim.source[ src ];

					}

					for ( var j = 0; j < anim.channel.length; j ++ ) {

						this.channel.push( anim.channel[ j ] );
						this.sampler.push( anim.sampler[ j ] );

					}

					break;

				case 'source':

					var src = ( new Source() ).parse( child );
					this.source[ src.id ] = src;
					break;

				case 'sampler':

					this.sampler.push( ( new Sampler( this ) ).parse( child ) );
					break;

				case 'channel':

					this.channel.push( ( new Channel( this ) ).parse( child ) );
					break;

				default:
					break;

			}

		}

		return this;

	};

	function Channel( animation ) {

		this.animation = animation;
		this.source = "";
		this.target = "";
		this.fullSid = null;
		this.sid = null;
		this.dotSyntax = null;
		this.arrSyntax = null;
		this.arrIndices = null;
		this.member = null;

	}

	Channel.prototype.parse = function ( element ) {

		this.source = element.getAttribute( 'source' ).replace( /^#/, '' );
		this.target = element.getAttribute( 'target' );

		var parts = this.target.split( '/' );

		var id = parts.shift();
		var sid = parts.shift();

		var dotSyntax = ( sid.indexOf(".") >= 0 );
		var arrSyntax = ( sid.indexOf("(") >= 0 );

		if ( dotSyntax ) {

			parts = sid.split(".");
			this.sid = parts.shift();
			this.member = parts.shift();

		} else if ( arrSyntax ) {

			var arrIndices = sid.split("(");
			this.sid = arrIndices.shift();

			for (var j = 0; j < arrIndices.length; j ++ ) {

				arrIndices[j] = parseInt( arrIndices[j].replace(/\)/, '') );

			}

			this.arrIndices = arrIndices;

		} else {

			this.sid = sid;

		}

		this.fullSid = sid;
		this.dotSyntax = dotSyntax;
		this.arrSyntax = arrSyntax;

		return this;

	};

	function Sampler ( animation ) {

		this.id = "";
		this.animation = animation;
		this.inputs = [];
		this.input = null;
		this.output = null;
		this.strideOut = null;
		this.interpolation = null;
		this.startTime = null;
		this.endTime = null;
		this.duration = 0;

	}

	Sampler.prototype.parse = function ( element ) {

		this.id = element.getAttribute( 'id' );
		this.inputs = [];

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'input':

					this.inputs.push( (new Input()).parse( child ) );
					break;

				default:
					break;

			}

		}

		return this;

	};

	Sampler.prototype.create = function () {

		for ( var i = 0; i < this.inputs.length; i ++ ) {

			var input = this.inputs[ i ];
			var source = this.animation.source[ input.source ];

			switch ( input.semantic ) {

				case 'INPUT':

					this.input = source.read();
					break;

				case 'OUTPUT':

					this.output = source.read();
					this.strideOut = source.accessor.stride;
					break;

				case 'INTERPOLATION':

					this.interpolation = source.read();
					break;

				case 'IN_TANGENT':

					break;

				case 'OUT_TANGENT':

					break;

				default:

					console.log(input.semantic);
					break;

			}

		}

		this.startTime = 0;
		this.endTime = 0;
		this.duration = 0;

		if ( this.input.length ) {

			this.startTime = 100000000;
			this.endTime = -100000000;

			for ( var i = 0; i < this.input.length; i ++ ) {

				this.startTime = Math.min( this.startTime, this.input[ i ] );
				this.endTime = Math.max( this.endTime, this.input[ i ] );

			}

			this.duration = this.endTime - this.startTime;

		}

	};

	Sampler.prototype.getData = function ( type, ndx, member ) {

		var data;

		if ( type === 'matrix' && this.strideOut === 16 ) {

			data = this.output[ ndx ];

		} else if ( this.strideOut > 1 ) {

			data = [];
			ndx *= this.strideOut;

			for ( var i = 0; i < this.strideOut; ++ i ) {

				data[ i ] = this.output[ ndx + i ];

			}

			if ( this.strideOut === 3 ) {

				switch ( type ) {

					case 'rotate':
					case 'translate':

						fixCoords( data, -1 );
						break;

					case 'scale':

						fixCoords( data, 1 );
						break;

				}

			} else if ( this.strideOut === 4 && type === 'matrix' ) {

				fixCoords( data, -1 );

			}

		} else {

			data = this.output[ ndx ];

			if ( member && type === 'translate' ) {
				data = getConvertedTranslation( member, data );
			}

		}

		return data;

	};

	function Key ( time ) {

		this.targets = [];
		this.time = time;

	}

	Key.prototype.addTarget = function ( fullSid, transform, member, data ) {

		this.targets.push( {
			sid: fullSid,
			member: member,
			transform: transform,
			data: data
		} );

	};

	Key.prototype.apply = function ( opt_sid ) {

		for ( var i = 0; i < this.targets.length; ++ i ) {

			var target = this.targets[ i ];

			if ( !opt_sid || target.sid === opt_sid ) {

				target.transform.update( target.data, target.member );

			}

		}

	};

	Key.prototype.getTarget = function ( fullSid ) {

		for ( var i = 0; i < this.targets.length; ++ i ) {

			if ( this.targets[ i ].sid === fullSid ) {

				return this.targets[ i ];

			}

		}

		return null;

	};

	Key.prototype.hasTarget = function ( fullSid ) {

		for ( var i = 0; i < this.targets.length; ++ i ) {

			if ( this.targets[ i ].sid === fullSid ) {

				return true;

			}

		}

		return false;

	};

	// TODO: Currently only doing linear interpolation. Should support full COLLADA spec.
	Key.prototype.interpolate = function ( nextKey, time ) {

		for ( var i = 0, l = this.targets.length; i < l; i ++ ) {

			var target = this.targets[ i ],
				nextTarget = nextKey.getTarget( target.sid ),
				data;

			if ( target.transform.type !== 'matrix' && nextTarget ) {

				var scale = ( time - this.time ) / ( nextKey.time - this.time ),
					nextData = nextTarget.data,
					prevData = target.data;

				if ( scale < 0 ) scale = 0;
				if ( scale > 1 ) scale = 1;

				if ( prevData.length ) {

					data = [];

					for ( var j = 0; j < prevData.length; ++ j ) {

						data[ j ] = prevData[ j ] + ( nextData[ j ] - prevData[ j ] ) * scale;

					}

				} else {

					data = prevData + ( nextData - prevData ) * scale;

				}

			} else {

				data = target.data;

			}

			target.transform.update( data, target.member );

		}

	};

	// Camera
	function Camera() {

		this.id = "";
		this.name = "";
		this.technique = "";

	}

	Camera.prototype.parse = function ( element ) {

		this.id = element.getAttribute( 'id' );
		this.name = element.getAttribute( 'name' );

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'optics':

					this.parseOptics( child );
					break;

				default:
					break;

			}

		}

		return this;

	};

	Camera.prototype.parseOptics = function ( element ) {

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			if ( element.childNodes[ i ].nodeName === 'technique_common' ) {

				var technique = element.childNodes[ i ];

				for ( var j = 0; j < technique.childNodes.length; j ++ ) {

					this.technique = technique.childNodes[ j ].nodeName;

					if ( this.technique === 'perspective' ) {

						var perspective = technique.childNodes[ j ];

						for ( var k = 0; k < perspective.childNodes.length; k ++ ) {

							var param = perspective.childNodes[ k ];

							switch ( param.nodeName ) {

								case 'yfov':
									this.yfov = param.textContent;
									break;
								case 'xfov':
									this.xfov = param.textContent;
									break;
								case 'znear':
									this.znear = param.textContent;
									break;
								case 'zfar':
									this.zfar = param.textContent;
									break;
								case 'aspect_ratio':
									this.aspect_ratio = param.textContent;
									break;

							}

						}

					} else if ( this.technique === 'orthographic' ) {

						var orthographic = technique.childNodes[ j ];

						for ( var k = 0; k < orthographic.childNodes.length; k ++ ) {

							var param = orthographic.childNodes[ k ];

							switch ( param.nodeName ) {

								case 'xmag':
									this.xmag = param.textContent;
									break;
								case 'ymag':
									this.ymag = param.textContent;
									break;
								case 'znear':
									this.znear = param.textContent;
									break;
								case 'zfar':
									this.zfar = param.textContent;
									break;
								case 'aspect_ratio':
									this.aspect_ratio = param.textContent;
									break;

							}

						}

					}

				}

			}

		}

		return this;

	};

	function InstanceCamera() {

		this.url = "";

	}

	InstanceCamera.prototype.parse = function ( element ) {

		this.url = element.getAttribute('url').replace(/^#/, '');

		return this;

	};

	// Light

	function Light() {

		this.id = "";
		this.name = "";
		this.technique = "";

	}

	Light.prototype.parse = function ( element ) {

		this.id = element.getAttribute( 'id' );
		this.name = element.getAttribute( 'name' );

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'technique_common':

					this.parseCommon( child );
					break;

				case 'technique':

					this.parseTechnique( child );
					break;

				default:
					break;

			}

		}

		return this;

	};

	Light.prototype.parseCommon = function ( element ) {

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			switch ( element.childNodes[ i ].nodeName ) {

				case 'directional':
				case 'point':
				case 'spot':
				case 'ambient':

					this.technique = element.childNodes[ i ].nodeName;

					var light = element.childNodes[ i ];

					for ( var j = 0; j < light.childNodes.length; j ++ ) {

						var child = light.childNodes[j];

						switch ( child.nodeName ) {

							case 'color':

								var rgba = _floats( child.textContent );
								this.color = new THREE.Color(0);
								this.color.setRGB( rgba[0], rgba[1], rgba[2] );
								this.color.a = rgba[3];
								break;

							case 'falloff_angle':

								this.falloff_angle = parseFloat( child.textContent );
								break;

							case 'quadratic_attenuation':
								var f = parseFloat( child.textContent );
								this.distance = f ? Math.sqrt( 1 / f ) : 0;
						}

					}

			}

		}

		return this;

	};

	Light.prototype.parseTechnique = function ( element ) {

		this.profile = element.getAttribute( 'profile' );

		for ( var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];

			switch ( child.nodeName ) {

				case 'intensity':

					this.intensity = parseFloat(child.textContent);
					break;

			}

		}

		return this;

	};

	function InstanceLight() {

		this.url = "";

	}

	InstanceLight.prototype.parse = function ( element ) {

		this.url = element.getAttribute('url').replace(/^#/, '');

		return this;

	};

	function KinematicsModel( ) {

		this.id = '';
		this.name = '';
		this.joints = [];
		this.links = [];

	}

	KinematicsModel.prototype.parse = function( element ) {

		this.id = element.getAttribute('id');
		this.name = element.getAttribute('name');
		this.joints = [];
		this.links = [];

		for (var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'technique_common':

					this.parseCommon(child);
					break;

				default:
					break;

			}

		}

		return this;

	};

	KinematicsModel.prototype.parseCommon = function( element ) {

		for (var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];
			if ( child.nodeType != 1 ) continue;

			switch ( element.childNodes[ i ].nodeName ) {

				case 'joint':
					this.joints.push( (new Joint()).parse(child) );
					break;

				case 'link':
					this.links.push( (new Link()).parse(child) );
					break;

				default:
					break;

			}

		}

		return this;

	};

	function Joint( ) {

		this.sid = '';
		this.name = '';
		this.axis = new THREE.Vector3();
		this.limits = {
			min: 0,
			max: 0
		};
		this.type = '';
		this.static = false;
		this.zeroPosition = 0.0;
		this.middlePosition = 0.0;

	}

	Joint.prototype.parse = function( element ) {

		this.sid = element.getAttribute('sid');
		this.name = element.getAttribute('name');
		this.axis = new THREE.Vector3();
		this.limits = {
			min: 0,
			max: 0
		};
		this.type = '';
		this.static = false;
		this.zeroPosition = 0.0;
		this.middlePosition = 0.0;

		var axisElement = element.querySelector('axis');
		var _axis = _floats(axisElement.textContent);
		this.axis = getConvertedVec3(_axis, 0);

		var min = element.querySelector('limits min') ? parseFloat(element.querySelector('limits min').textContent) : -360;
		var max = element.querySelector('limits max') ? parseFloat(element.querySelector('limits max').textContent) : 360;

		this.limits = {
			min: min,
			max: max
		};

		var jointTypes = [ 'prismatic', 'revolute' ];
		for (var i = 0; i < jointTypes.length; i ++ ) {

			var type = jointTypes[ i ];

			var jointElement = element.querySelector(type);

			if ( jointElement ) {

				this.type = type;

			}

		}

		// if the min is equal to or somehow greater than the max, consider the joint static
		if ( this.limits.min >= this.limits.max ) {

			this.static = true;

		}

		this.middlePosition = (this.limits.min + this.limits.max) / 2.0;
		return this;

	};

	function Link( ) {

		this.sid = '';
		this.name = '';
		this.transforms = [];
		this.attachments = [];

	}

	Link.prototype.parse = function( element ) {

		this.sid = element.getAttribute('sid');
		this.name = element.getAttribute('name');
		this.transforms = [];
		this.attachments = [];

		for (var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'attachment_full':
					this.attachments.push( (new Attachment()).parse(child) );
					break;

				case 'rotate':
				case 'translate':
				case 'matrix':

					this.transforms.push( (new Transform()).parse(child) );
					break;

				default:

					break;

			}

		}

		return this;

	};

	function Attachment( ) {

		this.joint = '';
		this.transforms = [];
		this.links = [];

	}

	Attachment.prototype.parse = function( element ) {

		this.joint = element.getAttribute('joint').split('/').pop();
		this.links = [];

		for (var i = 0; i < element.childNodes.length; i ++ ) {

			var child = element.childNodes[ i ];
			if ( child.nodeType != 1 ) continue;

			switch ( child.nodeName ) {

				case 'link':
					this.links.push( (new Link()).parse(child) );
					break;

				case 'rotate':
				case 'translate':
				case 'matrix':

					this.transforms.push( (new Transform()).parse(child) );
					break;

				default:

					break;

			}

		}

		return this;

	};

	function _source( element ) {

		var id = element.getAttribute( 'id' );

		if ( sources[ id ] != undefined ) {

			return sources[ id ];

		}

		sources[ id ] = ( new Source(id )).parse( element );
		return sources[ id ];

	}

	function _nsResolver( nsPrefix ) {

		if ( nsPrefix === "dae" ) {

			return "http://www.collada.org/2005/11/COLLADASchema";

		}

		return null;

	}

	function _bools( str ) {

		var raw = _strings( str );
		var data = [];

		for ( var i = 0, l = raw.length; i < l; i ++ ) {

			data.push( (raw[i] === 'true' || raw[i] === '1') ? true : false );

		}

		return data;

	}

	function _floats( str ) {

		var raw = _strings(str);
		var data = [];

		for ( var i = 0, l = raw.length; i < l; i ++ ) {

			data.push( parseFloat( raw[ i ] ) );

		}

		return data;

	}

	function _ints( str ) {

		var raw = _strings( str );
		var data = [];

		for ( var i = 0, l = raw.length; i < l; i ++ ) {

			data.push( parseInt( raw[ i ], 10 ) );

		}

		return data;

	}

	function _strings( str ) {

		return ( str.length > 0 ) ? _trimString( str ).split( /\s+/ ) : [];

	}

	function _trimString( str ) {

		return str.replace( /^\s+/, "" ).replace( /\s+$/, "" );

	}

	function _attr_as_float( element, name, defaultValue ) {

		if ( element.hasAttribute( name ) ) {

			return parseFloat( element.getAttribute( name ) );

		} else {

			return defaultValue;

		}

	}

	function _attr_as_int( element, name, defaultValue ) {

		if ( element.hasAttribute( name ) ) {

			return parseInt( element.getAttribute( name ), 10) ;

		} else {

			return defaultValue;

		}

	}

	function _attr_as_string( element, name, defaultValue ) {

		if ( element.hasAttribute( name ) ) {

			return element.getAttribute( name );

		} else {

			return defaultValue;

		}

	}

	function _format_float( f, num ) {

		if ( f === undefined ) {

			var s = '0.';

			while ( s.length < num + 2 ) {

				s += '0';

			}

			return s;

		}

		num = num || 2;

		var parts = f.toString().split( '.' );
		parts[ 1 ] = parts.length > 1 ? parts[ 1 ].substr( 0, num ) : "0";

		while ( parts[ 1 ].length < num ) {

			parts[ 1 ] += '0';

		}

		return parts.join( '.' );

	}

	function loadTextureImage ( texture, url ) {

		var loader = new THREE.ImageLoader();

		loader.load( url, function ( image ) {

			texture.image = image;
			texture.needsUpdate = true;

		} );

	}

	function extractDoubleSided( obj, element ) {

		obj.doubleSided = false;

		var node = element.querySelectorAll('extra double_sided')[0];

		if ( node ) {

			if ( node && parseInt( node.textContent, 10 ) === 1 ) {

				obj.doubleSided = true;

			}

		}

	}

	// Up axis conversion

	function setUpConversion() {

		if ( options.convertUpAxis !== true || colladaUp === options.upAxis ) {

			upConversion = null;

		} else {

			switch ( colladaUp ) {

				case 'X':

					upConversion = options.upAxis === 'Y' ? 'XtoY' : 'XtoZ';
					break;

				case 'Y':

					upConversion = options.upAxis === 'X' ? 'YtoX' : 'YtoZ';
					break;

				case 'Z':

					upConversion = options.upAxis === 'X' ? 'ZtoX' : 'ZtoY';
					break;

			}

		}

	}

	function fixCoords( data, sign ) {

		if ( options.convertUpAxis !== true || colladaUp === options.upAxis ) {

			return;

		}

		switch ( upConversion ) {

			case 'XtoY':

				var tmp = data[ 0 ];
				data[ 0 ] = sign * data[ 1 ];
				data[ 1 ] = tmp;
				break;

			case 'XtoZ':

				var tmp = data[ 2 ];
				data[ 2 ] = data[ 1 ];
				data[ 1 ] = data[ 0 ];
				data[ 0 ] = tmp;
				break;

			case 'YtoX':

				var tmp = data[ 0 ];
				data[ 0 ] = data[ 1 ];
				data[ 1 ] = sign * tmp;
				break;

			case 'YtoZ':

				var tmp = data[ 1 ];
				data[ 1 ] = sign * data[ 2 ];
				data[ 2 ] = tmp;
				break;

			case 'ZtoX':

				var tmp = data[ 0 ];
				data[ 0 ] = data[ 1 ];
				data[ 1 ] = data[ 2 ];
				data[ 2 ] = tmp;
				break;

			case 'ZtoY':

				var tmp = data[ 1 ];
				data[ 1 ] = data[ 2 ];
				data[ 2 ] = sign * tmp;
				break;

		}

	}

	function getConvertedTranslation( axis, data ) {

		if ( options.convertUpAxis !== true || colladaUp === options.upAxis ) {

			return data;

		}

		switch ( axis ) {
			case 'X':
				data = upConversion === 'XtoY' ? data * -1 : data;
				break;
			case 'Y':
				data = upConversion === 'YtoZ' || upConversion === 'YtoX' ? data * -1 : data;
				break;
			case 'Z':
				data = upConversion === 'ZtoY' ? data * -1 : data ;
				break;
			default:
				break;
		}

		return data;
	}

	function getConvertedVec3( data, offset ) {

		var arr = [ data[ offset ], data[ offset + 1 ], data[ offset + 2 ] ];
		fixCoords( arr, -1 );
		return new THREE.Vector3( arr[ 0 ], arr[ 1 ], arr[ 2 ] );

	}

	function getConvertedMat4( data ) {

		if ( options.convertUpAxis ) {

			// First fix rotation and scale

			// Columns first
			var arr = [ data[ 0 ], data[ 4 ], data[ 8 ] ];
			fixCoords( arr, -1 );
			data[ 0 ] = arr[ 0 ];
			data[ 4 ] = arr[ 1 ];
			data[ 8 ] = arr[ 2 ];
			arr = [ data[ 1 ], data[ 5 ], data[ 9 ] ];
			fixCoords( arr, -1 );
			data[ 1 ] = arr[ 0 ];
			data[ 5 ] = arr[ 1 ];
			data[ 9 ] = arr[ 2 ];
			arr = [ data[ 2 ], data[ 6 ], data[ 10 ] ];
			fixCoords( arr, -1 );
			data[ 2 ] = arr[ 0 ];
			data[ 6 ] = arr[ 1 ];
			data[ 10 ] = arr[ 2 ];
			// Rows second
			arr = [ data[ 0 ], data[ 1 ], data[ 2 ] ];
			fixCoords( arr, -1 );
			data[ 0 ] = arr[ 0 ];
			data[ 1 ] = arr[ 1 ];
			data[ 2 ] = arr[ 2 ];
			arr = [ data[ 4 ], data[ 5 ], data[ 6 ] ];
			fixCoords( arr, -1 );
			data[ 4 ] = arr[ 0 ];
			data[ 5 ] = arr[ 1 ];
			data[ 6 ] = arr[ 2 ];
			arr = [ data[ 8 ], data[ 9 ], data[ 10 ] ];
			fixCoords( arr, -1 );
			data[ 8 ] = arr[ 0 ];
			data[ 9 ] = arr[ 1 ];
			data[ 10 ] = arr[ 2 ];

			// Now fix translation
			arr = [ data[ 3 ], data[ 7 ], data[ 11 ] ];
			fixCoords( arr, -1 );
			data[ 3 ] = arr[ 0 ];
			data[ 7 ] = arr[ 1 ];
			data[ 11 ] = arr[ 2 ];

		}

		return new THREE.Matrix4().set(
			data[0], data[1], data[2], data[3],
			data[4], data[5], data[6], data[7],
			data[8], data[9], data[10], data[11],
			data[12], data[13], data[14], data[15]
			);

	}

	function getConvertedIndex( index ) {

		if ( index > -1 && index < 3 ) {

			var members = [ 'X', 'Y', 'Z' ],
				indices = { X: 0, Y: 1, Z: 2 };

			index = getConvertedMember( members[ index ] );
			index = indices[ index ];

		}

		return index;

	}

	function getConvertedMember( member ) {

		if ( options.convertUpAxis ) {

			switch ( member ) {

				case 'X':

					switch ( upConversion ) {

						case 'XtoY':
						case 'XtoZ':
						case 'YtoX':

							member = 'Y';
							break;

						case 'ZtoX':

							member = 'Z';
							break;

					}

					break;

				case 'Y':

					switch ( upConversion ) {

						case 'XtoY':
						case 'YtoX':
						case 'ZtoX':

							member = 'X';
							break;

						case 'XtoZ':
						case 'YtoZ':
						case 'ZtoY':

							member = 'Z';
							break;

					}

					break;

				case 'Z':

					switch ( upConversion ) {

						case 'XtoZ':

							member = 'X';
							break;

						case 'YtoZ':
						case 'ZtoX':
						case 'ZtoY':

							member = 'Y';
							break;

					}

					break;

			}

		}

		return member;

	}

	return {

		load: load,
		parse: parse,
		setPreferredShading: setPreferredShading,
		applySkin: applySkin,
		geometries : geometries,
		options: options

	};

};

},{}],45:[function(_dereq_,module,exports){
/**
 * @author Rich Tibbett / https://github.com/richtr
 * @author mrdoob / http://mrdoob.com/
 * @author Tony Parisi / http://www.tonyparisi.com/
 */

THREE.GLTFLoader = ( function () {

	function GLTFLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : THREE.DefaultLoadingManager;

	}

	GLTFLoader.prototype = {

		constructor: GLTFLoader,

		load: function ( url, onLoad, onProgress, onError ) {

			var scope = this;

			var path = this.path && ( typeof this.path === "string" ) ? this.path : THREE.Loader.prototype.extractUrlBase( url );

			var loader = new THREE.FileLoader( scope.manager );
			loader.load( url, function ( text ) {

				scope.parse( JSON.parse( text ), onLoad, path );

			}, onProgress, onError );

		},

		setCrossOrigin: function ( value ) {

			this.crossOrigin = value;

		},

		setPath: function ( value ) {

			this.path = value;

		},

		parse: function ( json, callback, path ) {

			console.time( 'GLTFLoader' );

			var parser = new GLTFParser( json, {

				path: path || this.path,
				crossOrigin: !! this.crossOrigin

			} );

			parser.parse( function ( scene, cameras, animations ) {

				console.timeEnd( 'GLTFLoader' );

				var glTF = {
					"scene": scene,
					"cameras": cameras,
					"animations": animations
				};

				callback( glTF );

			} );

		}

	};

	/* GLTFREGISTRY */

	function GLTFRegistry() {

		var objects = {};

		return	{

			get: function ( key ) {

				return objects[ key ];

			},

			add: function ( key, object ) {

				objects[ key ] = object;

			},

			remove: function ( key ) {

				delete objects[ key ];

			},

			removeAll: function () {

				objects = {};

			},

			update: function ( scene, camera ) {

				for ( var name in objects ) {

					var object = objects[ name ];

					if ( object.update ) {

						object.update( scene, camera );

					}

				}

			}

		};

	}

	/* GLTFSHADERS */

	GLTFLoader.Shaders = new GLTFRegistry();

	/* GLTFSHADER */

	function GLTFShader( targetNode, allNodes ) {

		var boundUniforms = {};

		// bind each uniform to its source node

		var uniforms = targetNode.material.uniforms;

		for ( var uniformId in uniforms ) {

			var uniform = uniforms[ uniformId ];

			if ( uniform.semantic ) {

				var sourceNodeRef = uniform.node;

				var sourceNode = targetNode;

				if ( sourceNodeRef ) {

					sourceNode = allNodes[ sourceNodeRef ];

				}

				boundUniforms[ uniformId ] = {
					semantic: uniform.semantic,
					sourceNode: sourceNode,
					targetNode: targetNode,
					uniform: uniform
				};

			}

		}

		this.boundUniforms = boundUniforms;
		this._m4 = new THREE.Matrix4();

	}

	// Update - update all the uniform values
	GLTFShader.prototype.update = function ( scene, camera ) {

		// update scene graph

		scene.updateMatrixWorld();

		// update camera matrices and frustum

		camera.updateMatrixWorld();
		camera.matrixWorldInverse.getInverse( camera.matrixWorld );

		var boundUniforms = this.boundUniforms;

		for ( var name in boundUniforms ) {

			var boundUniform = boundUniforms[ name ];

			switch ( boundUniform.semantic ) {

				case "MODELVIEW":

					var m4 = boundUniform.uniform.value;
					m4.multiplyMatrices( camera.matrixWorldInverse, boundUniform.sourceNode.matrixWorld );
					break;

				case "MODELVIEWINVERSETRANSPOSE":

					var m3 = boundUniform.uniform.value;
					this._m4.multiplyMatrices( camera.matrixWorldInverse, boundUniform.sourceNode.matrixWorld );
					m3.getNormalMatrix( this._m4 );
					break;

				case "PROJECTION":

					var m4 = boundUniform.uniform.value;
					m4.copy( camera.projectionMatrix );
					break;

				case "JOINTMATRIX":

					var m4v = boundUniform.uniform.value;

					for ( var mi = 0; mi < m4v.length; mi ++ ) {

						// So it goes like this:
						// SkinnedMesh world matrix is already baked into MODELVIEW;
						// transform joints to local space,
						// then transform using joint's inverse
						m4v[ mi ]
							.getInverse( boundUniform.sourceNode.matrixWorld )
							.multiply( boundUniform.targetNode.skeleton.bones[ mi ].matrixWorld )
							.multiply( boundUniform.targetNode.skeleton.boneInverses[ mi ] )
							.multiply( boundUniform.targetNode.bindMatrix );

					}

					break;

				default :

					console.warn( "Unhandled shader semantic: " + boundUniform.semantic );
					break;

			}

		}

	};


	/* ANIMATION */

	GLTFLoader.Animations = {

		update: function () {

			console.warn( 'THREE.GLTFLoader.Animation has been deprecated. Use THREE.AnimationMixer instead.' );

		}

	};

	function createAnimation( name, interps ) {

		var tracks = [];

		for ( var i = 0, len = interps.length; i < len; i ++ ) {

			var interp = interps[ i ];

			// KeyframeTrack.optimize() will modify given 'times' and 'values'
			// buffers before creating a truncated copy to keep. Because buffers may
			// be reused by other tracks, make copies here.
			interp.times = THREE.AnimationUtils.arraySlice( interp.times, 0 );
			interp.values = THREE.AnimationUtils.arraySlice( interp.values, 0 );

			interp.target.updateMatrix();
			interp.target.matrixAutoUpdate = true;

			tracks.push( new THREE.KeyframeTrack(
				interp.name,
				interp.times,
				interp.values,
				interp.type
			) );

		}

		return new THREE.AnimationClip( name, undefined, tracks );

	}

	/*********************************/
	/********** INTERNALS ************/
	/*********************************/

	/* CONSTANTS */

	var WEBGL_CONSTANTS = {
		FLOAT: 5126,
		//FLOAT_MAT2: 35674,
		FLOAT_MAT3: 35675,
		FLOAT_MAT4: 35676,
		FLOAT_VEC2: 35664,
		FLOAT_VEC3: 35665,
		FLOAT_VEC4: 35666,
		LINEAR: 9729,
		REPEAT: 10497,
		SAMPLER_2D: 35678,
		TRIANGLES: 4,
		UNSIGNED_BYTE: 5121,
		UNSIGNED_SHORT: 5123,

		VERTEX_SHADER: 35633,
		FRAGMENT_SHADER: 35632
	};

	var WEBGL_TYPE = {
		5126: Number,
		//35674: THREE.Matrix2,
		35675: THREE.Matrix3,
		35676: THREE.Matrix4,
		35664: THREE.Vector2,
		35665: THREE.Vector3,
		35666: THREE.Vector4,
		35678: THREE.Texture
	};

	var WEBGL_COMPONENT_TYPES = {
		5120: Int8Array,
		5121: Uint8Array,
		5122: Int16Array,
		5123: Uint16Array,
		5125: Uint32Array,
		5126: Float32Array
	};

	var WEBGL_FILTERS = {
		9728: THREE.NearestFilter,
		9729: THREE.LinearFilter,
		9984: THREE.NearestMipMapNearestFilter,
		9985: THREE.LinearMipMapNearestFilter,
		9986: THREE.NearestMipMapLinearFilter,
		9987: THREE.LinearMipMapLinearFilter
	};

	var WEBGL_WRAPPINGS = {
		33071: THREE.ClampToEdgeWrapping,
		33648: THREE.MirroredRepeatWrapping,
		10497: THREE.RepeatWrapping
	};

	var WEBGL_TYPE_SIZES = {
		'SCALAR': 1,
		'VEC2': 2,
		'VEC3': 3,
		'VEC4': 4,
		'MAT2': 4,
		'MAT3': 9,
		'MAT4': 16
	};

	var PATH_PROPERTIES = {
		scale: 'scale',
		translation: 'position',
		rotation: 'quaternion'
	};

	var INTERPOLATION = {
		LINEAR: THREE.InterpolateLinear,
		STEP: THREE.InterpolateDiscrete
	};

	/* UTILITY FUNCTIONS */

	function _each( object, callback, thisObj ) {

		if ( !object ) {
			return Promise.resolve();
		}

		var results;
		var fns = [];

		if ( Object.prototype.toString.call( object ) === '[object Array]' ) {

			results = [];

			var length = object.length;
			for ( var idx = 0; idx < length; idx ++ ) {
				var value = callback.call( thisObj || this, object[ idx ], idx );
				if ( value ) {
					fns.push( value );
					if ( value instanceof Promise ) {
						value.then( function( key, value ) {
							results[ idx ] = value;
						}.bind( this, key ));
					} else {
						results[ idx ] = value;
					}
				}
			}

		} else {

			results = {};

			for ( var key in object ) {
				if ( object.hasOwnProperty( key ) ) {
					var value = callback.call( thisObj || this, object[ key ], key );
					if ( value ) {
						fns.push( value );
						if ( value instanceof Promise ) {
							value.then( function( key, value ) {
								results[ key ] = value;
							}.bind( this, key ));
						} else {
							results[ key ] = value;
						}
					}
				}
			}

		}

		return Promise.all( fns ).then( function() {
			return results;
		});

	}

	function resolveURL( url, path ) {

		// Invalid URL
		if ( typeof url !== 'string' || url === '' )
			return '';

		// Absolute URL
		if ( /^https?:\/\//i.test( url ) ) {

			return url;

		}

		// Data URI
		if ( /^data:.*,.*$/i.test( url ) ) {

			return url;

		}

		// Relative URL
		return ( path || '' ) + url;

	}

	// Three.js seems too dependent on attribute names so globally
	// replace those in the shader code
	function replaceTHREEShaderAttributes( shaderText, technique ) {

		// Expected technique attributes
		var attributes = {};

		for ( var attributeId in technique.attributes ) {

			var pname = technique.attributes[ attributeId ];

			var param = technique.parameters[ pname ];
			var atype = param.type;
			var semantic = param.semantic;

			attributes[ attributeId ] = {
				type: atype,
				semantic: semantic
			};

		}

		// Figure out which attributes to change in technique

		var shaderParams = technique.parameters;
		var shaderAttributes = technique.attributes;
		var params = {};

		for ( var attributeId in attributes ) {

			var pname = shaderAttributes[ attributeId ];
			var shaderParam = shaderParams[ pname ];
			var semantic = shaderParam.semantic;
			if ( semantic ) {

				params[ attributeId ] = shaderParam;

			}

		}

		for ( var pname in params ) {

			var param = params[ pname ];
			var semantic = param.semantic;

			var regEx = new RegExp( "\\b" + pname + "\\b", "g" );

			switch ( semantic ) {

				case "POSITION":

					shaderText = shaderText.replace( regEx, 'position' );
					break;

				case "NORMAL":

					shaderText = shaderText.replace( regEx, 'normal' );
					break;

				case 'TEXCOORD_0':
				case 'TEXCOORD0':
				case 'TEXCOORD':

					shaderText = shaderText.replace( regEx, 'uv' );
					break;

				case "WEIGHT":

					shaderText = shaderText.replace( regEx, 'skinWeight' );
					break;

				case "JOINT":

					shaderText = shaderText.replace( regEx, 'skinIndex' );
					break;

			}

		}

		return shaderText;

	}

	// Deferred constructor for RawShaderMaterial types
	function DeferredShaderMaterial( params ) {

		this.isDeferredShaderMaterial = true;

		this.params = params;

	}

	DeferredShaderMaterial.prototype.create = function () {

		var uniforms = THREE.UniformsUtils.clone( this.params.uniforms );

		for ( var uniformId in this.params.uniforms ) {

			var originalUniform = this.params.uniforms[ uniformId ];

			if ( originalUniform.value instanceof THREE.Texture ) {

				uniforms[ uniformId ].value = originalUniform.value;
				uniforms[ uniformId ].value.needsUpdate = true;

			}

			uniforms[ uniformId ].semantic = originalUniform.semantic;
			uniforms[ uniformId ].node = originalUniform.node;

		}

		this.params.uniforms = uniforms;

		return new THREE.RawShaderMaterial( this.params );

	};

	/* GLTF PARSER */

	function GLTFParser( json, options ) {

		this.json = json || {};
		this.options = options || {};

		// loader object cache
		this.cache = new GLTFRegistry();

	}

	GLTFParser.prototype._withDependencies = function ( dependencies ) {

		var _dependencies = {};

		for ( var i = 0; i < dependencies.length; i ++ ) {

			var dependency = dependencies[ i ];
			var fnName = "load" + dependency.charAt( 0 ).toUpperCase() + dependency.slice( 1 );

			var cached = this.cache.get( dependency );

			if ( cached !== undefined ) {

				_dependencies[ dependency ] = cached;

			} else if ( this[ fnName ] ) {

				var fn = this[ fnName ]();
				this.cache.add( dependency, fn );

				_dependencies[ dependency ] = fn;

			}

		}

		return _each( _dependencies, function ( dependency ) {

			return dependency;

		} );

	};

	GLTFParser.prototype.parse = function ( callback ) {

		var json = this.json;

		// Clear the loader cache
		this.cache.removeAll();

		// Fire the callback on complete
		this._withDependencies( [

			"scenes",
			"cameras",
			"animations"

		] ).then( function ( dependencies ) {

			var scene = dependencies.scenes[ json.scene ];

			var cameras = [];

			for ( var name in dependencies.cameras ) {

				var camera = dependencies.cameras[ name ];
				cameras.push( camera );

			}

			var animations = [];

			for ( var name in dependencies.animations ) {

				animations.push( dependencies.animations[ name ] );

			}

			callback( scene, cameras, animations );

		} );

	};

	GLTFParser.prototype.loadShaders = function () {

		var json = this.json;
		var options = this.options;

		return _each( json.shaders, function ( shader ) {

			return new Promise( function ( resolve ) {

				var loader = new THREE.FileLoader();
				loader.responseType = 'text';
				loader.load( resolveURL( shader.uri, options.path ), function ( shaderText ) {

					resolve( shaderText );

				} );

			} );

		} );

	};

	GLTFParser.prototype.loadBuffers = function () {

		var json = this.json;
		var options = this.options;

		return _each( json.buffers, function ( buffer ) {

			if ( buffer.type === 'arraybuffer' ) {

				return new Promise( function ( resolve ) {

					var loader = new THREE.FileLoader();
					loader.responseType = 'arraybuffer';
					loader.load( resolveURL( buffer.uri, options.path ), function ( buffer ) {

						resolve( buffer );

					} );

				} );

			}

		} );

	};

	GLTFParser.prototype.loadBufferViews = function () {

		var json = this.json;

		return this._withDependencies( [

			"buffers"

		] ).then( function ( dependencies ) {

			return _each( json.bufferViews, function ( bufferView ) {

				var arraybuffer = dependencies.buffers[ bufferView.buffer ];

				return arraybuffer.slice( bufferView.byteOffset, bufferView.byteOffset + bufferView.byteLength );

			} );

		} );

	};

	GLTFParser.prototype.loadAccessors = function () {

		var json = this.json;

		return this._withDependencies( [

			"bufferViews"

		] ).then( function ( dependencies ) {

			return _each( json.accessors, function ( accessor ) {

				var arraybuffer = dependencies.bufferViews[ accessor.bufferView ];
				var itemSize = WEBGL_TYPE_SIZES[ accessor.type ];
				var TypedArray = WEBGL_COMPONENT_TYPES[ accessor.componentType ];

				// For VEC3: itemSize is 3, elementBytes is 4, itemBytes is 12.
				var elementBytes = TypedArray.BYTES_PER_ELEMENT;
				var itemBytes = elementBytes * itemSize;

				// The buffer is not interleaved if the stride is the item size in bytes.
				if ( accessor.byteStride && accessor.byteStride !== itemBytes ) {

					// Use the full buffer if it's interleaved.
					var array = new TypedArray( arraybuffer );

					// Integer parameters to IB/IBA are in array elements, not bytes.
					var ib = new THREE.InterleavedBuffer( array, accessor.byteStride / elementBytes );

					return new THREE.InterleavedBufferAttribute( ib, itemSize, accessor.byteOffset / elementBytes );

				} else {

					array = new TypedArray( arraybuffer, accessor.byteOffset, accessor.count * itemSize );

					return new THREE.BufferAttribute( array, itemSize );

				}

			} );

		} );

	};

	GLTFParser.prototype.loadTextures = function () {

		var json = this.json;
		var options = this.options;

		return _each( json.textures, function ( texture ) {

			if ( texture.source ) {

				return new Promise( function ( resolve ) {

					var source = json.images[ texture.source ];

					var textureLoader = THREE.Loader.Handlers.get( source.uri );

					if ( textureLoader === null ) {

						textureLoader = new THREE.TextureLoader();

					}

					textureLoader.crossOrigin = options.crossOrigin || false;

					textureLoader.load( resolveURL( source.uri, options.path ), function ( _texture ) {

						_texture.flipY = false;

						if ( texture.sampler ) {

							var sampler = json.samplers[ texture.sampler ];

							_texture.magFilter = WEBGL_FILTERS[ sampler.magFilter ];
							_texture.minFilter = WEBGL_FILTERS[ sampler.minFilter ];
							_texture.wrapS = WEBGL_WRAPPINGS[ sampler.wrapS ];
							_texture.wrapT = WEBGL_WRAPPINGS[ sampler.wrapT ];

						}

						resolve( _texture );

					}, undefined, function () {

						resolve();

					} );

				} );

			}

		} );

	};

	GLTFParser.prototype.loadMaterials = function () {

		var json = this.json;

		return this._withDependencies( [

			"shaders",
			"textures"

		] ).then( function ( dependencies ) {

			return _each( json.materials, function ( material ) {

				var materialType;
				var materialValues = {};
				var materialParams = {};

				var khr_material;

				if ( material.extensions && material.extensions.KHR_materials_common ) {

					khr_material = material.extensions.KHR_materials_common;

				} else if ( json.extensions && json.extensions.KHR_materials_common ) {

					khr_material = json.extensions.KHR_materials_common;

				}

				if ( khr_material ) {

					switch ( khr_material.technique ) {

						case 'BLINN' :
						case 'PHONG' :
							materialType = THREE.MeshPhongMaterial;
							break;

						case 'LAMBERT' :
							materialType = THREE.MeshLambertMaterial;
							break;

						case 'CONSTANT' :
						default :
							materialType = THREE.MeshBasicMaterial;
							break;

					}

					Object.assign( materialValues, khr_material.values );

					if ( khr_material.doubleSided || materialValues.doubleSided ) {

						materialParams.side = THREE.DoubleSide;

					}

					if ( khr_material.transparent || materialValues.transparent ) {

						materialParams.transparent = true;
						materialParams.opacity = ( materialValues.transparency !== undefined ) ? materialValues.transparency : 1;

					}

				} else if ( material.technique === undefined ) {

					materialType = THREE.MeshPhongMaterial;

					Object.assign( materialValues, material.values );

				} else {

					materialType = DeferredShaderMaterial;

					var technique = json.techniques[ material.technique ];

					materialParams.uniforms = {};

					var program = json.programs[ technique.program ];

					if ( program ) {

						materialParams.fragmentShader = dependencies.shaders[ program.fragmentShader ];

						if ( ! materialParams.fragmentShader ) {

							console.warn( "ERROR: Missing fragment shader definition:", program.fragmentShader );
							materialType = THREE.MeshPhongMaterial;

						}

						var vertexShader = dependencies.shaders[ program.vertexShader ];

						if ( ! vertexShader ) {

							console.warn( "ERROR: Missing vertex shader definition:", program.vertexShader );
							materialType = THREE.MeshPhongMaterial;

						}

						// IMPORTANT: FIX VERTEX SHADER ATTRIBUTE DEFINITIONS
						materialParams.vertexShader = replaceTHREEShaderAttributes( vertexShader, technique );

						var uniforms = technique.uniforms;

						for ( var uniformId in uniforms ) {

							var pname = uniforms[ uniformId ];
							var shaderParam = technique.parameters[ pname ];

							var ptype = shaderParam.type;

							if ( WEBGL_TYPE[ ptype ] ) {

								var pcount = shaderParam.count;
								var value = material.values[ pname ];

								var uvalue = new WEBGL_TYPE[ ptype ]();
								var usemantic = shaderParam.semantic;
								var unode = shaderParam.node;

								switch ( ptype ) {

									case WEBGL_CONSTANTS.FLOAT:

										uvalue = shaderParam.value;

										if ( pname == "transparency" ) {

											materialParams.transparent = true;

										}

										if ( value !== undefined ) {

											uvalue = value;

										}

										break;

									case WEBGL_CONSTANTS.FLOAT_VEC2:
									case WEBGL_CONSTANTS.FLOAT_VEC3:
									case WEBGL_CONSTANTS.FLOAT_VEC4:
									case WEBGL_CONSTANTS.FLOAT_MAT3:

										if ( shaderParam && shaderParam.value ) {

											uvalue.fromArray( shaderParam.value );

										}

										if ( value ) {

											uvalue.fromArray( value );

										}

										break;

									case WEBGL_CONSTANTS.FLOAT_MAT2:

										// what to do?
										console.warn( "FLOAT_MAT2 is not a supported uniform type" );
										break;

									case WEBGL_CONSTANTS.FLOAT_MAT4:

										if ( pcount ) {

											uvalue = new Array( pcount );

											for ( var mi = 0; mi < pcount; mi ++ ) {

												uvalue[ mi ] = new WEBGL_TYPE[ ptype ]();

											}

											if ( shaderParam && shaderParam.value ) {

												var m4v = shaderParam.value;
												uvalue.fromArray( m4v );

											}

											if ( value ) {

												uvalue.fromArray( value );

											}

										}	else {

											if ( shaderParam && shaderParam.value ) {

												var m4 = shaderParam.value;
												uvalue.fromArray( m4 );

											}

											if ( value ) {

												uvalue.fromArray( value );

											}

										}

										break;

									case WEBGL_CONSTANTS.SAMPLER_2D:

										uvalue = value ? dependencies.textures[ value ] : null;

										break;

								}

								materialParams.uniforms[ uniformId ] = {
									value: uvalue,
									semantic: usemantic,
									node: unode
								};

							} else {

								throw new Error( "Unknown shader uniform param type: " + ptype );

							}

						}

					}

				}

				if ( Array.isArray( materialValues.diffuse ) ) {

					materialParams.color = new THREE.Color().fromArray( materialValues.diffuse );

				} else if ( typeof( materialValues.diffuse ) === 'string' ) {

					materialParams.map = dependencies.textures[ materialValues.diffuse ];

				}

				delete materialParams.diffuse;

				if ( typeof( materialValues.reflective ) === 'string' ) {

					materialParams.envMap = dependencies.textures[ materialValues.reflective ];

				}

				if ( typeof( materialValues.bump ) === 'string' ) {

					materialParams.bumpMap = dependencies.textures[ materialValues.bump ];

				}

				if ( Array.isArray( materialValues.emission ) ) {

					if ( materialType === THREE.MeshBasicMaterial ) {

						materialParams.color = new THREE.Color().fromArray( materialValues.emission );

					} else {

						materialParams.emissive = new THREE.Color().fromArray( materialValues.emission );

					}

				} else if ( typeof( materialValues.emission ) === 'string' ) {

					if ( materialType === THREE.MeshBasicMaterial ) {

						materialParams.map = dependencies.textures[ materialValues.emission ];

					} else {

						materialParams.emissiveMap = dependencies.textures[ materialValues.emission ];

					}

				}

				if ( Array.isArray( materialValues.specular ) ) {

					materialParams.specular = new THREE.Color().fromArray( materialValues.specular );

				} else if ( typeof( materialValues.specular ) === 'string' ) {

					materialParams.specularMap = dependencies.textures[ materialValues.specular ];

				}

				if ( materialValues.shininess !== undefined ) {

					materialParams.shininess = materialValues.shininess;

				}

				var _material = new materialType( materialParams );
				_material.name = material.name;

				return _material;

			} );

		} );

	};

	GLTFParser.prototype.loadMeshes = function () {

		var json = this.json;

		return this._withDependencies( [

			"accessors",
			"materials"

		] ).then( function ( dependencies ) {

			return _each( json.meshes, function ( mesh ) {

				var group = new THREE.Object3D();
				group.name = mesh.name;

				var primitives = mesh.primitives;

				for ( var name in primitives ) {

					var primitive = primitives[ name ];

					if ( primitive.mode === WEBGL_CONSTANTS.TRIANGLES || primitive.mode === undefined ) {

						var geometry = new THREE.BufferGeometry();

						var attributes = primitive.attributes;

						for ( var attributeId in attributes ) {

							var attributeEntry = attributes[ attributeId ];

							if ( ! attributeEntry ) return;

							var bufferAttribute = dependencies.accessors[ attributeEntry ];

							switch ( attributeId ) {

								case 'POSITION':
									geometry.addAttribute( 'position', bufferAttribute );
									break;

								case 'NORMAL':
									geometry.addAttribute( 'normal', bufferAttribute );
									break;

								case 'TEXCOORD_0':
								case 'TEXCOORD0':
								case 'TEXCOORD':
									geometry.addAttribute( 'uv', bufferAttribute );
									break;

								case 'WEIGHT':
									geometry.addAttribute( 'skinWeight', bufferAttribute );
									break;

								case 'JOINT':
									geometry.addAttribute( 'skinIndex', bufferAttribute );
									break;

							}

						}

						if ( primitive.indices ) {

							var indexArray = dependencies.accessors[ primitive.indices ];

							geometry.setIndex( indexArray );

							var offset = {
								start: 0,
								index: 0,
								count: indexArray.count
							};

							geometry.groups.push( offset );

							geometry.computeBoundingSphere();

						}


						var material = dependencies.materials[ primitive.material ];

						var meshNode = new THREE.Mesh( geometry, material );
						meshNode.castShadow = true;

						group.add( meshNode );

					} else {

						console.warn( "Non-triangular primitives are not supported" );

					}

				}

				return group;

			} );

		} );

	};

	GLTFParser.prototype.loadCameras = function () {

		var json = this.json;

		return _each( json.cameras, function ( camera ) {

			if ( camera.type == "perspective" && camera.perspective ) {

				var yfov = camera.perspective.yfov;
				var xfov = camera.perspective.xfov;
				var aspect_ratio = camera.perspective.aspect_ratio || 1;

				// According to COLLADA spec...
				// aspect_ratio = xfov / yfov
				xfov = ( xfov === undefined && yfov ) ? yfov * aspect_ratio : xfov;

				// According to COLLADA spec...
				// aspect_ratio = xfov / yfov
				// yfov = ( yfov === undefined && xfov ) ? xfov / aspect_ratio : yfov;

				var _camera = new THREE.PerspectiveCamera( THREE.Math.radToDeg( xfov ), aspect_ratio, camera.perspective.znear || 1, camera.perspective.zfar || 2e6 );
				_camera.name = camera.name;

				return _camera;

			} else if ( camera.type == "orthographic" && camera.orthographic ) {

				var _camera = new THREE.OrthographicCamera( window.innerWidth / - 2, window.innerWidth / 2, window.innerHeight / 2, window.innerHeight / - 2, camera.orthographic.znear, camera.orthographic.zfar );
				_camera.name = camera.name;

				return _camera;

			}

		} );

	};

	GLTFParser.prototype.loadSkins = function () {

		var json = this.json;

		return this._withDependencies( [

			"accessors"

		] ).then( function ( dependencies ) {

			return _each( json.skins, function ( skin ) {

				var _skin = {
					bindShapeMatrix: new THREE.Matrix4().fromArray( skin.bindShapeMatrix ),
					jointNames: skin.jointNames,
					inverseBindMatrices: dependencies.accessors[ skin.inverseBindMatrices ]
				};

				return _skin;

			} );

		} );

	};

	GLTFParser.prototype.loadAnimations = function () {

		var json = this.json;

		return this._withDependencies( [

			"accessors",
			"nodes"

		] ).then( function ( dependencies ) {

			return _each( json.animations, function ( animation, animationId ) {

				var interps = [];

				for ( var channelId in animation.channels ) {

					var channel = animation.channels[ channelId ];
					var sampler = animation.samplers[ channel.sampler ];

					if ( sampler && animation.parameters ) {

						var target = channel.target;
						var name = target.id;
						var input = animation.parameters[ sampler.input ];
						var output = animation.parameters[ sampler.output ];

						var inputAccessor = dependencies.accessors[ input ];
						var outputAccessor = dependencies.accessors[ output ];

						var node = dependencies.nodes[ name ];

						if ( node ) {

							var interp = {
								times: inputAccessor.array,
								values: outputAccessor.array,
								target: node,
								type: INTERPOLATION[ sampler.interpolation ],
								name: node.name + '.' + PATH_PROPERTIES[ target.path ]
							};

							interps.push( interp );

						}

					}

				}

				return createAnimation( "animation_" + animationId, interps );

			} );

		} );

	};

	GLTFParser.prototype.loadNodes = function () {

		var json = this.json;
		var scope = this;

		return _each( json.nodes, function ( node ) {

			var matrix = new THREE.Matrix4();

			var _node;

			if ( node.jointName ) {

				_node = new THREE.Bone();
				_node.jointName = node.jointName;

			} else {

				_node = new THREE.Object3D();

			}

			_node.name = node.name;

			_node.matrixAutoUpdate = false;

			if ( node.matrix !== undefined ) {

				matrix.fromArray( node.matrix );
				_node.applyMatrix( matrix );

			} else {

				if ( node.translation !== undefined ) {

					_node.position.fromArray( node.translation );

				}

				if ( node.rotation !== undefined ) {

					_node.quaternion.fromArray( node.rotation );

				}

				if ( node.scale !== undefined ) {

					_node.scale.fromArray( node.scale );

				}

			}

			return _node;

		} ).then( function ( __nodes ) {

			return scope._withDependencies( [

				"meshes",
				"skins",
				"cameras",
				"extensions"

			] ).then( function ( dependencies ) {

				return _each( __nodes, function ( _node, nodeId ) {

					var node = json.nodes[ nodeId ];

					if ( node.meshes !== undefined ) {

						for ( var meshId in node.meshes ) {

							var mesh = node.meshes[ meshId ];
							var group = dependencies.meshes[ mesh ];

							for ( var childrenId in group.children ) {

								var child = group.children[ childrenId ];

								// clone Mesh to add to _node

								var originalMaterial = child.material;
								var originalGeometry = child.geometry;

								var material;

								if ( originalMaterial.isDeferredShaderMaterial ) {

									originalMaterial = material = originalMaterial.create();

								} else {

									material = originalMaterial;

								}

								child = new THREE.Mesh( originalGeometry, material );
								child.castShadow = true;

								var skinEntry;

								if ( node.skin ) {

									skinEntry = dependencies.skins[ node.skin ];

								}

								// Replace Mesh with SkinnedMesh in library
								if ( skinEntry ) {

									var geometry = originalGeometry;
									var material = originalMaterial;
									material.skinning = true;

									child = new THREE.SkinnedMesh( geometry, material, false );
									child.castShadow = true;

									var bones = [];
									var boneInverses = [];

									var keys = Object.keys( __nodes );

									for ( var i = 0, l = skinEntry.jointNames.length; i < l; i ++ ) {

										var jointId = skinEntry.jointNames[ i ];

										var jointNode;

										for ( var j = 0, jl = keys.length; j < jl; j ++ ) {

											var n = __nodes[ keys[ j ] ];

											if ( n.jointName === jointId ) {

												jointNode = n;
												break;

											}

										}

										if ( jointNode ) {

											jointNode.skin = child;
											bones.push( jointNode );

											var m = skinEntry.inverseBindMatrices.array;
											var mat = new THREE.Matrix4().fromArray( m, i * 16 );
											boneInverses.push( mat );

										} else {

											console.warn( "WARNING: joint: ''" + jointId + "' could not be found" );

										}

									}

									child.bind( new THREE.Skeleton( bones, boneInverses, false ), skinEntry.bindShapeMatrix );

								}

								_node.add( child );

							}

						}

					}

					if ( node.camera !== undefined ) {

						var camera = dependencies.cameras[ node.camera ];

						_node.add( camera );

					}

					if ( node.extensions && node.extensions.KHR_materials_common && node.extensions.KHR_materials_common.light ) {

						var light = dependencies.extensions.KHR_materials_common.lights[ node.extensions.KHR_materials_common.light ];

						_node.add( light );

					}

					return _node;

				} );

			} );

		} );

	};

	GLTFParser.prototype.loadExtensions = function () {

		var json = this.json;

		return _each( json.extensions, function ( extension, extensionId ) {

			switch ( extensionId ) {

				case "KHR_materials_common":

					var extensionNode = {
						lights: {}
					};

					var lights = extension.lights;

					for ( var lightId in lights ) {

						var light = lights[ lightId ];
						var lightNode;

						var lightParams = light[ light.type ];
						var color = new THREE.Color().fromArray( lightParams.color );

						switch ( light.type ) {

							case "directional":
								lightNode = new THREE.DirectionalLight( color );
								lightNode.position.set( 0, 0, 1 );
								break;

							case "point":
								lightNode = new THREE.PointLight( color );
								break;

							case "spot ":
								lightNode = new THREE.SpotLight( color );
								lightNode.position.set( 0, 0, 1 );
								break;

							case "ambient":
								lightNode = new THREE.AmbientLight( color );
								break;

						}

						if ( lightNode ) {

							extensionNode.lights[ lightId ] = lightNode;

						}

					}

					return extensionNode;

					break;

			}

		} );

	};

	GLTFParser.prototype.loadScenes = function () {

		var json = this.json;

		// scene node hierachy builder

		function buildNodeHierachy( nodeId, parentObject, allNodes ) {

			var _node = allNodes[ nodeId ];
			parentObject.add( _node );

			var node = json.nodes[ nodeId ];

			if ( node.children ) {

				var children = node.children;

				for ( var i = 0, l = children.length; i < l; i ++ ) {

					var child = children[ i ];
					buildNodeHierachy( child, _node, allNodes );

				}

			}

		}

		return this._withDependencies( [

			"nodes"

		] ).then( function ( dependencies ) {

			return _each( json.scenes, function ( scene ) {

				var _scene = new THREE.Scene();
				_scene.name = scene.name;

				var nodes = scene.nodes;

				for ( var i = 0, l = nodes.length; i < l; i ++ ) {

					var nodeId = nodes[ i ];
					buildNodeHierachy( nodeId, _scene, dependencies.nodes );

				}

				_scene.traverse( function ( child ) {

					// Register raw material meshes with GLTFLoader.Shaders
					if ( child.material && child.material.isRawShaderMaterial ) {

						var xshader = new GLTFShader( child, dependencies.nodes );
						GLTFLoader.Shaders.add( child.uuid, xshader );

					}

				} );

				return _scene;

			} );

		} );

	};

	return GLTFLoader;

} )();

},{}],46:[function(_dereq_,module,exports){
/**
 * Loads a Wavefront .mtl file specifying materials
 *
 * @author angelxuanchang
 */

THREE.MTLLoader = function( manager ) {

	this.manager = ( manager !== undefined ) ? manager : THREE.DefaultLoadingManager;

};

Object.assign( THREE.MTLLoader.prototype, THREE.EventDispatcher.prototype, {

	/**
	 * Loads and parses a MTL asset from a URL.
	 *
	 * @param {String} url - URL to the MTL file.
	 * @param {Function} [onLoad] - Callback invoked with the loaded object.
	 * @param {Function} [onProgress] - Callback for download progress.
	 * @param {Function} [onError] - Callback for download errors.
	 *
	 * @see setPath setTexturePath
	 *
	 * @note In order for relative texture references to resolve correctly
	 * you must call setPath and/or setTexturePath explicitly prior to load.
	 */
	load: function ( url, onLoad, onProgress, onError ) {

		var scope = this;

		var loader = new THREE.FileLoader( this.manager );
		loader.setPath( this.path );
		loader.load( url, function ( text ) {

			onLoad( scope.parse( text ) );

		}, onProgress, onError );

	},

	/**
	 * Set base path for resolving references.
	 * If set this path will be prepended to each loaded and found reference.
	 *
	 * @see setTexturePath
	 * @param {String} path
	 *
	 * @example
	 *     mtlLoader.setPath( 'assets/obj/' );
	 *     mtlLoader.load( 'my.mtl', ... );
	 */
	setPath: function ( path ) {

		this.path = path;

	},

	/**
	 * Set base path for resolving texture references.
	 * If set this path will be prepended found texture reference.
	 * If not set and setPath is, it will be used as texture base path.
	 *
	 * @see setPath
	 * @param {String} path
	 *
	 * @example
	 *     mtlLoader.setPath( 'assets/obj/' );
	 *     mtlLoader.setTexturePath( 'assets/textures/' );
	 *     mtlLoader.load( 'my.mtl', ... );
	 */
	setTexturePath: function( path ) {

		this.texturePath = path;

	},

	setBaseUrl: function( path ) {

		console.warn( 'THREE.MTLLoader: .setBaseUrl() is deprecated. Use .setTexturePath( path ) for texture path or .setPath( path ) for general base path instead.' );

		this.setTexturePath( path );

	},

	setCrossOrigin: function ( value ) {

		this.crossOrigin = value;

	},

	setMaterialOptions: function ( value ) {

		this.materialOptions = value;

	},

	/**
	 * Parses a MTL file.
	 *
	 * @param {String} text - Content of MTL file
	 * @return {THREE.MTLLoader.MaterialCreator}
	 *
	 * @see setPath setTexturePath
	 *
	 * @note In order for relative texture references to resolve correctly
	 * you must call setPath and/or setTexturePath explicitly prior to parse.
	 */
	parse: function ( text ) {

		var lines = text.split( '\n' );
		var info = {};
		var delimiter_pattern = /\s+/;
		var materialsInfo = {};

		for ( var i = 0; i < lines.length; i ++ ) {

			var line = lines[ i ];
			line = line.trim();

			if ( line.length === 0 || line.charAt( 0 ) === '#' ) {

				// Blank line or comment ignore
				continue;

			}

			var pos = line.indexOf( ' ' );

			var key = ( pos >= 0 ) ? line.substring( 0, pos ) : line;
			key = key.toLowerCase();

			var value = ( pos >= 0 ) ? line.substring( pos + 1 ) : '';
			value = value.trim();

			if ( key === 'newmtl' ) {

				// New material

				info = { name: value };
				materialsInfo[ value ] = info;

			} else if ( info ) {

				if ( key === 'ka' || key === 'kd' || key === 'ks' ) {

					var ss = value.split( delimiter_pattern, 3 );
					info[ key ] = [ parseFloat( ss[ 0 ] ), parseFloat( ss[ 1 ] ), parseFloat( ss[ 2 ] ) ];

				} else {

					info[ key ] = value;

				}

			}

		}

		var materialCreator = new THREE.MTLLoader.MaterialCreator( this.texturePath || this.path, this.materialOptions );
		materialCreator.setCrossOrigin( this.crossOrigin );
		materialCreator.setManager( this.manager );
		materialCreator.setMaterials( materialsInfo );
		return materialCreator;

	}

} );

/**
 * Create a new THREE-MTLLoader.MaterialCreator
 * @param baseUrl - Url relative to which textures are loaded
 * @param options - Set of options on how to construct the materials
 *                  side: Which side to apply the material
 *                        THREE.FrontSide (default), THREE.BackSide, THREE.DoubleSide
 *                  wrap: What type of wrapping to apply for textures
 *                        THREE.RepeatWrapping (default), THREE.ClampToEdgeWrapping, THREE.MirroredRepeatWrapping
 *                  normalizeRGB: RGBs need to be normalized to 0-1 from 0-255
 *                                Default: false, assumed to be already normalized
 *                  ignoreZeroRGBs: Ignore values of RGBs (Ka,Kd,Ks) that are all 0's
 *                                  Default: false
 * @constructor
 */

THREE.MTLLoader.MaterialCreator = function( baseUrl, options ) {

	this.baseUrl = baseUrl || '';
	this.options = options;
	this.materialsInfo = {};
	this.materials = {};
	this.materialsArray = [];
	this.nameLookup = {};

	this.side = ( this.options && this.options.side ) ? this.options.side : THREE.FrontSide;
	this.wrap = ( this.options && this.options.wrap ) ? this.options.wrap : THREE.RepeatWrapping;

};

THREE.MTLLoader.MaterialCreator.prototype = {

	constructor: THREE.MTLLoader.MaterialCreator,

	setCrossOrigin: function ( value ) {

		this.crossOrigin = value;

	},

	setManager: function ( value ) {

		this.manager = value;

	},

	setMaterials: function( materialsInfo ) {

		this.materialsInfo = this.convert( materialsInfo );
		this.materials = {};
		this.materialsArray = [];
		this.nameLookup = {};

	},

	convert: function( materialsInfo ) {

		if ( ! this.options ) return materialsInfo;

		var converted = {};

		for ( var mn in materialsInfo ) {

			// Convert materials info into normalized form based on options

			var mat = materialsInfo[ mn ];

			var covmat = {};

			converted[ mn ] = covmat;

			for ( var prop in mat ) {

				var save = true;
				var value = mat[ prop ];
				var lprop = prop.toLowerCase();

				switch ( lprop ) {

					case 'kd':
					case 'ka':
					case 'ks':

						// Diffuse color (color under white light) using RGB values

						if ( this.options && this.options.normalizeRGB ) {

							value = [ value[ 0 ] / 255, value[ 1 ] / 255, value[ 2 ] / 255 ];

						}

						if ( this.options && this.options.ignoreZeroRGBs ) {

							if ( value[ 0 ] === 0 && value[ 1 ] === 0 && value[ 2 ] === 0 ) {

								// ignore

								save = false;

							}

						}

						break;

					default:

						break;
				}

				if ( save ) {

					covmat[ lprop ] = value;

				}

			}

		}

		return converted;

	},

	preload: function () {

		for ( var mn in this.materialsInfo ) {

			this.create( mn );

		}

	},

	getIndex: function( materialName ) {

		return this.nameLookup[ materialName ];

	},

	getAsArray: function() {

		var index = 0;

		for ( var mn in this.materialsInfo ) {

			this.materialsArray[ index ] = this.create( mn );
			this.nameLookup[ mn ] = index;
			index ++;

		}

		return this.materialsArray;

	},

	create: function ( materialName ) {

		if ( this.materials[ materialName ] === undefined ) {

			this.createMaterial_( materialName );

		}

		return this.materials[ materialName ];

	},

	createMaterial_: function ( materialName ) {

		// Create material

		var scope = this;
		var mat = this.materialsInfo[ materialName ];
		var params = {

			name: materialName,
			side: this.side

		};

		var resolveURL = function ( baseUrl, url ) {

			if ( typeof url !== 'string' || url === '' )
				return '';

			// Absolute URL
			if ( /^https?:\/\//i.test( url ) ) {
				return url;
			}

			return baseUrl + url;
		};
		
		function setMapForType ( mapType, value ) {

			if ( params[ mapType ] ) return; // Keep the first encountered texture

			var texParams = scope.getTextureParams( value, params );
			var map = scope.loadTexture( resolveURL( scope.baseUrl, texParams.url ) );
			
			map.repeat.copy( texParams.scale );
			map.offset.copy( texParams.offset );

			map.wrapS = scope.wrap;
			map.wrapT = scope.wrap;
			
			params[ mapType ] = map;
		}

		for ( var prop in mat ) {

			var value = mat[ prop ];

			if ( value === '' ) continue;

			switch ( prop.toLowerCase() ) {

				// Ns is material specular exponent

				case 'kd':

					// Diffuse color (color under white light) using RGB values

					params.color = new THREE.Color().fromArray( value );

					break;

				case 'ks':

					// Specular color (color when light is reflected from shiny surface) using RGB values
					params.specular = new THREE.Color().fromArray( value );

					break;

				case 'map_kd':

					// Diffuse texture map

					setMapForType( "map", value );

					break;

				case 'map_ks':

					// Specular map
					
					setMapForType( "specularMap", value );

					break;

				case 'map_bump':
				case 'bump':

					// Bump texture map				
					
					setMapForType( "bumpMap", value );

					break;

				case 'ns':

					// The specular exponent (defines the focus of the specular highlight)
					// A high exponent results in a tight, concentrated highlight. Ns values normally range from 0 to 1000.

					params.shininess = parseFloat( value );

					break;

				case 'd':

					if ( value < 1 ) {

						params.opacity = value;
						params.transparent = true;

					}

					break;

				case 'Tr':

					if ( value > 0 ) {

						params.opacity = 1 - value;
						params.transparent = true;

					}

					break;

				default:
					break;

			}

		}

		this.materials[ materialName ] = new THREE.MeshPhongMaterial( params );
		return this.materials[ materialName ];
	},

	getTextureParams: function( value, matParams ) {

		var texParams = {

			scale: new THREE.Vector2( 1, 1 ),
			offset: new THREE.Vector2( 0, 0 )

		 };

		var items = value.split(/\s+/);
		var pos;

		pos = items.indexOf('-bm');
		if (pos >= 0) {

			matParams.bumpScale = parseFloat( items[pos+1] );
			items.splice( pos, 2 );

		}

		pos = items.indexOf('-s');
		if (pos >= 0) {

			texParams.scale.set( parseFloat( items[pos+1] ), parseFloat( items[pos+2] ) );
			items.splice( pos, 4 ); // we expect 3 parameters here!

		}

		pos = items.indexOf('-o');
		if (pos >= 0) {

			texParams.offset.set( parseFloat( items[pos+1] ), parseFloat( items[pos+2] ) );
			items.splice( pos, 4 ); // we expect 3 parameters here!

		}

		texParams.url = items.join(' ').trim();
		return texParams;

	},

	loadTexture: function ( url, mapping, onLoad, onProgress, onError ) {

		var texture;
		var loader = THREE.Loader.Handlers.get( url );
		var manager = ( this.manager !== undefined ) ? this.manager : THREE.DefaultLoadingManager;

		if ( loader === null ) {

			loader = new THREE.TextureLoader( manager );

		}

		if ( loader.setCrossOrigin ) loader.setCrossOrigin( this.crossOrigin );
		texture = loader.load( url, onLoad, onProgress, onError );

		if ( mapping !== undefined ) texture.mapping = mapping;

		return texture;

	}

};

},{}],47:[function(_dereq_,module,exports){
/**
 * @author mrdoob / http://mrdoob.com/
 */

THREE.OBJLoader = function ( manager ) {

	this.manager = ( manager !== undefined ) ? manager : THREE.DefaultLoadingManager;

	this.materials = null;

	this.regexp = {
		// v float float float
		vertex_pattern           : /^v\s+([\d|\.|\+|\-|e|E]+)\s+([\d|\.|\+|\-|e|E]+)\s+([\d|\.|\+|\-|e|E]+)/,
		// vn float float float
		normal_pattern           : /^vn\s+([\d|\.|\+|\-|e|E]+)\s+([\d|\.|\+|\-|e|E]+)\s+([\d|\.|\+|\-|e|E]+)/,
		// vt float float
		uv_pattern               : /^vt\s+([\d|\.|\+|\-|e|E]+)\s+([\d|\.|\+|\-|e|E]+)/,
		// f vertex vertex vertex
		face_vertex              : /^f\s+(-?\d+)\s+(-?\d+)\s+(-?\d+)(?:\s+(-?\d+))?/,
		// f vertex/uv vertex/uv vertex/uv
		face_vertex_uv           : /^f\s+(-?\d+)\/(-?\d+)\s+(-?\d+)\/(-?\d+)\s+(-?\d+)\/(-?\d+)(?:\s+(-?\d+)\/(-?\d+))?/,
		// f vertex/uv/normal vertex/uv/normal vertex/uv/normal
		face_vertex_uv_normal    : /^f\s+(-?\d+)\/(-?\d+)\/(-?\d+)\s+(-?\d+)\/(-?\d+)\/(-?\d+)\s+(-?\d+)\/(-?\d+)\/(-?\d+)(?:\s+(-?\d+)\/(-?\d+)\/(-?\d+))?/,
		// f vertex//normal vertex//normal vertex//normal
		face_vertex_normal       : /^f\s+(-?\d+)\/\/(-?\d+)\s+(-?\d+)\/\/(-?\d+)\s+(-?\d+)\/\/(-?\d+)(?:\s+(-?\d+)\/\/(-?\d+))?/,
		// o object_name | g group_name
		object_pattern           : /^[og]\s*(.+)?/,
		// s boolean
		smoothing_pattern        : /^s\s+(\d+|on|off)/,
		// mtllib file_reference
		material_library_pattern : /^mtllib /,
		// usemtl material_name
		material_use_pattern     : /^usemtl /
	};

};

THREE.OBJLoader.prototype = {

	constructor: THREE.OBJLoader,

	load: function ( url, onLoad, onProgress, onError ) {

		var scope = this;

		var loader = new THREE.FileLoader( scope.manager );
		loader.setPath( this.path );
		loader.load( url, function ( text ) {

			onLoad( scope.parse( text ) );

		}, onProgress, onError );

	},

	setPath: function ( value ) {

		this.path = value;

	},

	setMaterials: function ( materials ) {

		this.materials = materials;

	},

	_createParserState : function () {

		var state = {
			objects  : [],
			object   : {},

			vertices : [],
			normals  : [],
			uvs      : [],

			materialLibraries : [],

			startObject: function ( name, fromDeclaration ) {

				// If the current object (initial from reset) is not from a g/o declaration in the parsed
				// file. We need to use it for the first parsed g/o to keep things in sync.
				if ( this.object && this.object.fromDeclaration === false ) {

					this.object.name = name;
					this.object.fromDeclaration = ( fromDeclaration !== false );
					return;

				}

				var previousMaterial = ( this.object && typeof this.object.currentMaterial === 'function' ? this.object.currentMaterial() : undefined );

				if ( this.object && typeof this.object._finalize === 'function' ) {

					this.object._finalize( true );

				}

				this.object = {
					name : name || '',
					fromDeclaration : ( fromDeclaration !== false ),

					geometry : {
						vertices : [],
						normals  : [],
						uvs      : []
					},
					materials : [],
					smooth : true,

					startMaterial : function( name, libraries ) {

						var previous = this._finalize( false );

						// New usemtl declaration overwrites an inherited material, except if faces were declared
						// after the material, then it must be preserved for proper MultiMaterial continuation.
						if ( previous && ( previous.inherited || previous.groupCount <= 0 ) ) {

							this.materials.splice( previous.index, 1 );

						}

						var material = {
							index      : this.materials.length,
							name       : name || '',
							mtllib     : ( Array.isArray( libraries ) && libraries.length > 0 ? libraries[ libraries.length - 1 ] : '' ),
							smooth     : ( previous !== undefined ? previous.smooth : this.smooth ),
							groupStart : ( previous !== undefined ? previous.groupEnd : 0 ),
							groupEnd   : -1,
							groupCount : -1,
							inherited  : false,

							clone : function( index ) {
								var cloned = {
									index      : ( typeof index === 'number' ? index : this.index ),
									name       : this.name,
									mtllib     : this.mtllib,
									smooth     : this.smooth,
									groupStart : 0,
									groupEnd   : -1,
									groupCount : -1,
									inherited  : false
								};
								cloned.clone = this.clone.bind(cloned);
								return cloned;
							}
						};

						this.materials.push( material );

						return material;

					},

					currentMaterial : function() {

						if ( this.materials.length > 0 ) {
							return this.materials[ this.materials.length - 1 ];
						}

						return undefined;

					},

					_finalize : function( end ) {

						var lastMultiMaterial = this.currentMaterial();
						if ( lastMultiMaterial && lastMultiMaterial.groupEnd === -1 ) {

							lastMultiMaterial.groupEnd = this.geometry.vertices.length / 3;
							lastMultiMaterial.groupCount = lastMultiMaterial.groupEnd - lastMultiMaterial.groupStart;
							lastMultiMaterial.inherited = false;

						}

						// Ignore objects tail materials if no face declarations followed them before a new o/g started.
						if ( end && this.materials.length > 1 ) {

							for ( var mi = this.materials.length - 1; mi >= 0; mi-- ) {
								if ( this.materials[mi].groupCount <= 0 ) {
									this.materials.splice( mi, 1 );
								}
							}

						}

						// Guarantee at least one empty material, this makes the creation later more straight forward.
						if ( end && this.materials.length === 0 ) {

							this.materials.push({
								name   : '',
								smooth : this.smooth
							});

						}

						return lastMultiMaterial;

					}
				};

				// Inherit previous objects material.
				// Spec tells us that a declared material must be set to all objects until a new material is declared.
				// If a usemtl declaration is encountered while this new object is being parsed, it will
				// overwrite the inherited material. Exception being that there was already face declarations
				// to the inherited material, then it will be preserved for proper MultiMaterial continuation.

				if ( previousMaterial && previousMaterial.name && typeof previousMaterial.clone === "function" ) {

					var declared = previousMaterial.clone( 0 );
					declared.inherited = true;
					this.object.materials.push( declared );

				}

				this.objects.push( this.object );

			},

			finalize : function() {

				if ( this.object && typeof this.object._finalize === 'function' ) {

					this.object._finalize( true );

				}

			},

			parseVertexIndex: function ( value, len ) {

				var index = parseInt( value, 10 );
				return ( index >= 0 ? index - 1 : index + len / 3 ) * 3;

			},

			parseNormalIndex: function ( value, len ) {

				var index = parseInt( value, 10 );
				return ( index >= 0 ? index - 1 : index + len / 3 ) * 3;

			},

			parseUVIndex: function ( value, len ) {

				var index = parseInt( value, 10 );
				return ( index >= 0 ? index - 1 : index + len / 2 ) * 2;

			},

			addVertex: function ( a, b, c ) {

				var src = this.vertices;
				var dst = this.object.geometry.vertices;

				dst.push( src[ a + 0 ] );
				dst.push( src[ a + 1 ] );
				dst.push( src[ a + 2 ] );
				dst.push( src[ b + 0 ] );
				dst.push( src[ b + 1 ] );
				dst.push( src[ b + 2 ] );
				dst.push( src[ c + 0 ] );
				dst.push( src[ c + 1 ] );
				dst.push( src[ c + 2 ] );

			},

			addVertexLine: function ( a ) {

				var src = this.vertices;
				var dst = this.object.geometry.vertices;

				dst.push( src[ a + 0 ] );
				dst.push( src[ a + 1 ] );
				dst.push( src[ a + 2 ] );

			},

			addNormal : function ( a, b, c ) {

				var src = this.normals;
				var dst = this.object.geometry.normals;

				dst.push( src[ a + 0 ] );
				dst.push( src[ a + 1 ] );
				dst.push( src[ a + 2 ] );
				dst.push( src[ b + 0 ] );
				dst.push( src[ b + 1 ] );
				dst.push( src[ b + 2 ] );
				dst.push( src[ c + 0 ] );
				dst.push( src[ c + 1 ] );
				dst.push( src[ c + 2 ] );

			},

			addUV: function ( a, b, c ) {

				var src = this.uvs;
				var dst = this.object.geometry.uvs;

				dst.push( src[ a + 0 ] );
				dst.push( src[ a + 1 ] );
				dst.push( src[ b + 0 ] );
				dst.push( src[ b + 1 ] );
				dst.push( src[ c + 0 ] );
				dst.push( src[ c + 1 ] );

			},

			addUVLine: function ( a ) {

				var src = this.uvs;
				var dst = this.object.geometry.uvs;

				dst.push( src[ a + 0 ] );
				dst.push( src[ a + 1 ] );

			},

			addFace: function ( a, b, c, d, ua, ub, uc, ud, na, nb, nc, nd ) {

				var vLen = this.vertices.length;

				var ia = this.parseVertexIndex( a, vLen );
				var ib = this.parseVertexIndex( b, vLen );
				var ic = this.parseVertexIndex( c, vLen );
				var id;

				if ( d === undefined ) {

					this.addVertex( ia, ib, ic );

				} else {

					id = this.parseVertexIndex( d, vLen );

					this.addVertex( ia, ib, id );
					this.addVertex( ib, ic, id );

				}

				if ( ua !== undefined ) {

					var uvLen = this.uvs.length;

					ia = this.parseUVIndex( ua, uvLen );
					ib = this.parseUVIndex( ub, uvLen );
					ic = this.parseUVIndex( uc, uvLen );

					if ( d === undefined ) {

						this.addUV( ia, ib, ic );

					} else {

						id = this.parseUVIndex( ud, uvLen );

						this.addUV( ia, ib, id );
						this.addUV( ib, ic, id );

					}

				}

				if ( na !== undefined ) {

					// Normals are many times the same. If so, skip function call and parseInt.
					var nLen = this.normals.length;
					ia = this.parseNormalIndex( na, nLen );

					ib = na === nb ? ia : this.parseNormalIndex( nb, nLen );
					ic = na === nc ? ia : this.parseNormalIndex( nc, nLen );

					if ( d === undefined ) {

						this.addNormal( ia, ib, ic );

					} else {

						id = this.parseNormalIndex( nd, nLen );

						this.addNormal( ia, ib, id );
						this.addNormal( ib, ic, id );

					}

				}

			},

			addLineGeometry: function ( vertices, uvs ) {

				this.object.geometry.type = 'Line';

				var vLen = this.vertices.length;
				var uvLen = this.uvs.length;

				for ( var vi = 0, l = vertices.length; vi < l; vi ++ ) {

					this.addVertexLine( this.parseVertexIndex( vertices[ vi ], vLen ) );

				}

				for ( var uvi = 0, l = uvs.length; uvi < l; uvi ++ ) {

					this.addUVLine( this.parseUVIndex( uvs[ uvi ], uvLen ) );

				}

			}

		};

		state.startObject( '', false );

		return state;

	},

	parse: function ( text ) {

		console.time( 'OBJLoader' );

		var state = this._createParserState();

		if ( text.indexOf( '\r\n' ) !== - 1 ) {

			// This is faster than String.split with regex that splits on both
			text = text.replace( /\r\n/g, '\n' );

		}

		if ( text.indexOf( '\\\n' ) !== - 1) {

			// join lines separated by a line continuation character (\)
			text = text.replace( /\\\n/g, '' );

		}

		var lines = text.split( '\n' );
		var line = '', lineFirstChar = '', lineSecondChar = '';
		var lineLength = 0;
		var result = [];

		// Faster to just trim left side of the line. Use if available.
		var trimLeft = ( typeof ''.trimLeft === 'function' );

		for ( var i = 0, l = lines.length; i < l; i ++ ) {

			line = lines[ i ];

			line = trimLeft ? line.trimLeft() : line.trim();

			lineLength = line.length;

			if ( lineLength === 0 ) continue;

			lineFirstChar = line.charAt( 0 );

			// @todo invoke passed in handler if any
			if ( lineFirstChar === '#' ) continue;

			if ( lineFirstChar === 'v' ) {

				lineSecondChar = line.charAt( 1 );

				if ( lineSecondChar === ' ' && ( result = this.regexp.vertex_pattern.exec( line ) ) !== null ) {

					// 0                  1      2      3
					// ["v 1.0 2.0 3.0", "1.0", "2.0", "3.0"]

					state.vertices.push(
						parseFloat( result[ 1 ] ),
						parseFloat( result[ 2 ] ),
						parseFloat( result[ 3 ] )
					);

				} else if ( lineSecondChar === 'n' && ( result = this.regexp.normal_pattern.exec( line ) ) !== null ) {

					// 0                   1      2      3
					// ["vn 1.0 2.0 3.0", "1.0", "2.0", "3.0"]

					state.normals.push(
						parseFloat( result[ 1 ] ),
						parseFloat( result[ 2 ] ),
						parseFloat( result[ 3 ] )
					);

				} else if ( lineSecondChar === 't' && ( result = this.regexp.uv_pattern.exec( line ) ) !== null ) {

					// 0               1      2
					// ["vt 0.1 0.2", "0.1", "0.2"]

					state.uvs.push(
						parseFloat( result[ 1 ] ),
						parseFloat( result[ 2 ] )
					);

				} else {

					throw new Error( "Unexpected vertex/normal/uv line: '" + line  + "'" );

				}

			} else if ( lineFirstChar === "f" ) {

				if ( ( result = this.regexp.face_vertex_uv_normal.exec( line ) ) !== null ) {

					// f vertex/uv/normal vertex/uv/normal vertex/uv/normal
					// 0                        1    2    3    4    5    6    7    8    9   10         11         12
					// ["f 1/1/1 2/2/2 3/3/3", "1", "1", "1", "2", "2", "2", "3", "3", "3", undefined, undefined, undefined]

					state.addFace(
						result[ 1 ], result[ 4 ], result[ 7 ], result[ 10 ],
						result[ 2 ], result[ 5 ], result[ 8 ], result[ 11 ],
						result[ 3 ], result[ 6 ], result[ 9 ], result[ 12 ]
					);

				} else if ( ( result = this.regexp.face_vertex_uv.exec( line ) ) !== null ) {

					// f vertex/uv vertex/uv vertex/uv
					// 0                  1    2    3    4    5    6   7          8
					// ["f 1/1 2/2 3/3", "1", "1", "2", "2", "3", "3", undefined, undefined]

					state.addFace(
						result[ 1 ], result[ 3 ], result[ 5 ], result[ 7 ],
						result[ 2 ], result[ 4 ], result[ 6 ], result[ 8 ]
					);

				} else if ( ( result = this.regexp.face_vertex_normal.exec( line ) ) !== null ) {

					// f vertex//normal vertex//normal vertex//normal
					// 0                     1    2    3    4    5    6   7          8
					// ["f 1//1 2//2 3//3", "1", "1", "2", "2", "3", "3", undefined, undefined]

					state.addFace(
						result[ 1 ], result[ 3 ], result[ 5 ], result[ 7 ],
						undefined, undefined, undefined, undefined,
						result[ 2 ], result[ 4 ], result[ 6 ], result[ 8 ]
					);

				} else if ( ( result = this.regexp.face_vertex.exec( line ) ) !== null ) {

					// f vertex vertex vertex
					// 0            1    2    3   4
					// ["f 1 2 3", "1", "2", "3", undefined]

					state.addFace(
						result[ 1 ], result[ 2 ], result[ 3 ], result[ 4 ]
					);

				} else {

					throw new Error( "Unexpected face line: '" + line  + "'" );

				}

			} else if ( lineFirstChar === "l" ) {

				var lineParts = line.substring( 1 ).trim().split( " " );
				var lineVertices = [], lineUVs = [];

				if ( line.indexOf( "/" ) === - 1 ) {

					lineVertices = lineParts;

				} else {

					for ( var li = 0, llen = lineParts.length; li < llen; li ++ ) {

						var parts = lineParts[ li ].split( "/" );

						if ( parts[ 0 ] !== "" ) lineVertices.push( parts[ 0 ] );
						if ( parts[ 1 ] !== "" ) lineUVs.push( parts[ 1 ] );

					}

				}
				state.addLineGeometry( lineVertices, lineUVs );

			} else if ( ( result = this.regexp.object_pattern.exec( line ) ) !== null ) {

				// o object_name
				// or
				// g group_name

				// WORKAROUND: https://bugs.chromium.org/p/v8/issues/detail?id=2869
				// var name = result[ 0 ].substr( 1 ).trim();
				var name = ( " " + result[ 0 ].substr( 1 ).trim() ).substr( 1 );

				state.startObject( name );

			} else if ( this.regexp.material_use_pattern.test( line ) ) {

				// material

				state.object.startMaterial( line.substring( 7 ).trim(), state.materialLibraries );

			} else if ( this.regexp.material_library_pattern.test( line ) ) {

				// mtl file

				state.materialLibraries.push( line.substring( 7 ).trim() );

			} else if ( ( result = this.regexp.smoothing_pattern.exec( line ) ) !== null ) {

				// smooth shading

				// @todo Handle files that have varying smooth values for a set of faces inside one geometry,
				// but does not define a usemtl for each face set.
				// This should be detected and a dummy material created (later MultiMaterial and geometry groups).
				// This requires some care to not create extra material on each smooth value for "normal" obj files.
				// where explicit usemtl defines geometry groups.
				// Example asset: examples/models/obj/cerberus/Cerberus.obj

				var value = result[ 1 ].trim().toLowerCase();
				state.object.smooth = ( value === '1' || value === 'on' );

				var material = state.object.currentMaterial();
				if ( material ) {

					material.smooth = state.object.smooth;

				}

			} else {

				// Handle null terminated files without exception
				if ( line === '\0' ) continue;

				throw new Error( "Unexpected line: '" + line  + "'" );

			}

		}

		state.finalize();

		var container = new THREE.Group();
		container.materialLibraries = [].concat( state.materialLibraries );

		for ( var i = 0, l = state.objects.length; i < l; i ++ ) {

			var object = state.objects[ i ];
			var geometry = object.geometry;
			var materials = object.materials;
			var isLine = ( geometry.type === 'Line' );

			// Skip o/g line declarations that did not follow with any faces
			if ( geometry.vertices.length === 0 ) continue;

			var buffergeometry = new THREE.BufferGeometry();

			buffergeometry.addAttribute( 'position', new THREE.BufferAttribute( new Float32Array( geometry.vertices ), 3 ) );

			if ( geometry.normals.length > 0 ) {

				buffergeometry.addAttribute( 'normal', new THREE.BufferAttribute( new Float32Array( geometry.normals ), 3 ) );

			} else {

				buffergeometry.computeVertexNormals();

			}

			if ( geometry.uvs.length > 0 ) {

				buffergeometry.addAttribute( 'uv', new THREE.BufferAttribute( new Float32Array( geometry.uvs ), 2 ) );

			}

			// Create materials

			var createdMaterials = [];

			for ( var mi = 0, miLen = materials.length; mi < miLen ; mi++ ) {

				var sourceMaterial = materials[mi];
				var material = undefined;

				if ( this.materials !== null ) {

					material = this.materials.create( sourceMaterial.name );

					// mtl etc. loaders probably can't create line materials correctly, copy properties to a line material.
					if ( isLine && material && ! ( material instanceof THREE.LineBasicMaterial ) ) {

						var materialLine = new THREE.LineBasicMaterial();
						materialLine.copy( material );
						material = materialLine;

					}

				}

				if ( ! material ) {

					material = ( ! isLine ? new THREE.MeshPhongMaterial() : new THREE.LineBasicMaterial() );
					material.name = sourceMaterial.name;

				}

				material.shading = sourceMaterial.smooth ? THREE.SmoothShading : THREE.FlatShading;

				createdMaterials.push(material);

			}

			// Create mesh

			var mesh;

			if ( createdMaterials.length > 1 ) {

				for ( var mi = 0, miLen = materials.length; mi < miLen ; mi++ ) {

					var sourceMaterial = materials[mi];
					buffergeometry.addGroup( sourceMaterial.groupStart, sourceMaterial.groupCount, mi );

				}

				var multiMaterial = new THREE.MultiMaterial( createdMaterials );
				mesh = ( ! isLine ? new THREE.Mesh( buffergeometry, multiMaterial ) : new THREE.LineSegments( buffergeometry, multiMaterial ) );

			} else {

				mesh = ( ! isLine ? new THREE.Mesh( buffergeometry, createdMaterials[ 0 ] ) : new THREE.LineSegments( buffergeometry, createdMaterials[ 0 ] ) );
			}

			mesh.name = object.name;

			container.add( mesh );

		}

		console.timeEnd( 'OBJLoader' );

		return container;

	}

};

},{}],48:[function(_dereq_,module,exports){

exports = module.exports = trim;

function trim(str){
  return str.replace(/^\s*|\s*$/g, '');
}

exports.left = function(str){
  return str.replace(/^\s*/, '');
};

exports.right = function(str){
  return str.replace(/\s*$/, '');
};

},{}],49:[function(_dereq_,module,exports){
/**
 * Tween.js - Licensed under the MIT license
 * https://github.com/sole/tween.js
 * ----------------------------------------------
 *
 * See https://github.com/sole/tween.js/graphs/contributors for the full list of contributors.
 * Thank you all, you're awesome!
 */

// performance.now polyfill
( function ( root ) {

	if ( 'performance' in root === false ) {
		root.performance = {};
	}

	// IE 8
	Date.now = ( Date.now || function () {
		return new Date().getTime();
	} );

	if ( 'now' in root.performance === false ) {
		var offset = root.performance.timing && root.performance.timing.navigationStart ? performance.timing.navigationStart
		                                                                                : Date.now();

		root.performance.now = function () {
			return Date.now() - offset;
		};
	}

} )( this );

var TWEEN = TWEEN || ( function () {

	var _tweens = [];

	return {

		REVISION: '14',

		getAll: function () {

			return _tweens;

		},

		removeAll: function () {

			_tweens = [];

		},

		add: function ( tween ) {

			_tweens.push( tween );

		},

		remove: function ( tween ) {

			var i = _tweens.indexOf( tween );

			if ( i !== -1 ) {

				_tweens.splice( i, 1 );

			}

		},

		update: function ( time ) {

			if ( _tweens.length === 0 ) return false;

			var i = 0;

			time = time !== undefined ? time : window.performance.now();

			while ( i < _tweens.length ) {

				if ( _tweens[ i ].update( time ) ) {

					i++;

				} else {

					_tweens.splice( i, 1 );

				}

			}

			return true;

		}
	};

} )();

TWEEN.Tween = function ( object ) {

	var _object = object;
	var _valuesStart = {};
	var _valuesEnd = {};
	var _valuesStartRepeat = {};
	var _duration = 1000;
	var _repeat = 0;
	var _yoyo = false;
	var _isPlaying = false;
	var _reversed = false;
	var _delayTime = 0;
	var _startTime = null;
	var _easingFunction = TWEEN.Easing.Linear.None;
	var _interpolationFunction = TWEEN.Interpolation.Linear;
	var _chainedTweens = [];
	var _onStartCallback = null;
	var _onStartCallbackFired = false;
	var _onUpdateCallback = null;
	var _onCompleteCallback = null;
	var _onStopCallback = null;

	// Set all starting values present on the target object
	for ( var field in object ) {

		_valuesStart[ field ] = parseFloat(object[field], 10);

	}

	this.to = function ( properties, duration ) {

		if ( duration !== undefined ) {

			_duration = duration;

		}

		_valuesEnd = properties;

		return this;

	};

	this.start = function ( time ) {

		TWEEN.add( this );

		_isPlaying = true;

		_onStartCallbackFired = false;

		_startTime = time !== undefined ? time : window.performance.now();
		_startTime += _delayTime;

		for ( var property in _valuesEnd ) {

			// check if an Array was provided as property value
			if ( _valuesEnd[ property ] instanceof Array ) {

				if ( _valuesEnd[ property ].length === 0 ) {

					continue;

				}

				// create a local copy of the Array with the start value at the front
				_valuesEnd[ property ] = [ _object[ property ] ].concat( _valuesEnd[ property ] );

			}

			_valuesStart[ property ] = _object[ property ];

			if( ( _valuesStart[ property ] instanceof Array ) === false ) {
				_valuesStart[ property ] *= 1.0; // Ensures we're using numbers, not strings
			}

			_valuesStartRepeat[ property ] = _valuesStart[ property ] || 0;

		}

		return this;

	};

	this.stop = function () {

		if ( !_isPlaying ) {
			return this;
		}

		TWEEN.remove( this );
		_isPlaying = false;

		if ( _onStopCallback !== null ) {

			_onStopCallback.call( _object );

		}

		this.stopChainedTweens();
		return this;

	};

	this.stopChainedTweens = function () {

		for ( var i = 0, numChainedTweens = _chainedTweens.length; i < numChainedTweens; i++ ) {

			_chainedTweens[ i ].stop();

		}

	};

	this.delay = function ( amount ) {

		_delayTime = amount;
		return this;

	};

	this.repeat = function ( times ) {

		_repeat = times;
		return this;

	};

	this.yoyo = function( yoyo ) {

		_yoyo = yoyo;
		return this;

	};


	this.easing = function ( easing ) {

		_easingFunction = easing;
		return this;

	};

	this.interpolation = function ( interpolation ) {

		_interpolationFunction = interpolation;
		return this;

	};

	this.chain = function () {

		_chainedTweens = arguments;
		return this;

	};

	this.onStart = function ( callback ) {

		_onStartCallback = callback;
		return this;

	};

	this.onUpdate = function ( callback ) {

		_onUpdateCallback = callback;
		return this;

	};

	this.onComplete = function ( callback ) {

		_onCompleteCallback = callback;
		return this;

	};

	this.onStop = function ( callback ) {

		_onStopCallback = callback;
		return this;

	};

	this.update = function ( time ) {

		var property;

		if ( time < _startTime ) {

			return true;

		}

		if ( _onStartCallbackFired === false ) {

			if ( _onStartCallback !== null ) {

				_onStartCallback.call( _object );

			}

			_onStartCallbackFired = true;

		}

		var elapsed = ( time - _startTime ) / _duration;
		elapsed = elapsed > 1 ? 1 : elapsed;

		var value = _easingFunction( elapsed );

		for ( property in _valuesEnd ) {

			var start = _valuesStart[ property ] || 0;
			var end = _valuesEnd[ property ];

			if ( end instanceof Array ) {

				_object[ property ] = _interpolationFunction( end, value );

			} else {

				// Parses relative end values with start as base (e.g.: +10, -3)
				if ( typeof(end) === "string" ) {
					end = start + parseFloat(end, 10);
				}

				// protect against non numeric properties.
				if ( typeof(end) === "number" ) {
					_object[ property ] = start + ( end - start ) * value;
				}

			}

		}

		if ( _onUpdateCallback !== null ) {

			_onUpdateCallback.call( _object, value );

		}

		if ( elapsed == 1 ) {

			if ( _repeat > 0 ) {

				if( isFinite( _repeat ) ) {
					_repeat--;
				}

				// reassign starting values, restart by making startTime = now
				for( property in _valuesStartRepeat ) {

					if ( typeof( _valuesEnd[ property ] ) === "string" ) {
						_valuesStartRepeat[ property ] = _valuesStartRepeat[ property ] + parseFloat(_valuesEnd[ property ], 10);
					}

					if (_yoyo) {
						var tmp = _valuesStartRepeat[ property ];
						_valuesStartRepeat[ property ] = _valuesEnd[ property ];
						_valuesEnd[ property ] = tmp;
					}

					_valuesStart[ property ] = _valuesStartRepeat[ property ];

				}

				if (_yoyo) {
					_reversed = !_reversed;
				}

				_startTime = time + _delayTime;

				return true;

			} else {

				if ( _onCompleteCallback !== null ) {

					_onCompleteCallback.call( _object );

				}

				for ( var i = 0, numChainedTweens = _chainedTweens.length; i < numChainedTweens; i++ ) {

					_chainedTweens[ i ].start( time );

				}

				return false;

			}

		}

		return true;

	};

};


TWEEN.Easing = {

	Linear: {

		None: function ( k ) {

			return k;

		}

	},

	Quadratic: {

		In: function ( k ) {

			return k * k;

		},

		Out: function ( k ) {

			return k * ( 2 - k );

		},

		InOut: function ( k ) {

			if ( ( k *= 2 ) < 1 ) return 0.5 * k * k;
			return - 0.5 * ( --k * ( k - 2 ) - 1 );

		}

	},

	Cubic: {

		In: function ( k ) {

			return k * k * k;

		},

		Out: function ( k ) {

			return --k * k * k + 1;

		},

		InOut: function ( k ) {

			if ( ( k *= 2 ) < 1 ) return 0.5 * k * k * k;
			return 0.5 * ( ( k -= 2 ) * k * k + 2 );

		}

	},

	Quartic: {

		In: function ( k ) {

			return k * k * k * k;

		},

		Out: function ( k ) {

			return 1 - ( --k * k * k * k );

		},

		InOut: function ( k ) {

			if ( ( k *= 2 ) < 1) return 0.5 * k * k * k * k;
			return - 0.5 * ( ( k -= 2 ) * k * k * k - 2 );

		}

	},

	Quintic: {

		In: function ( k ) {

			return k * k * k * k * k;

		},

		Out: function ( k ) {

			return --k * k * k * k * k + 1;

		},

		InOut: function ( k ) {

			if ( ( k *= 2 ) < 1 ) return 0.5 * k * k * k * k * k;
			return 0.5 * ( ( k -= 2 ) * k * k * k * k + 2 );

		}

	},

	Sinusoidal: {

		In: function ( k ) {

			return 1 - Math.cos( k * Math.PI / 2 );

		},

		Out: function ( k ) {

			return Math.sin( k * Math.PI / 2 );

		},

		InOut: function ( k ) {

			return 0.5 * ( 1 - Math.cos( Math.PI * k ) );

		}

	},

	Exponential: {

		In: function ( k ) {

			return k === 0 ? 0 : Math.pow( 1024, k - 1 );

		},

		Out: function ( k ) {

			return k === 1 ? 1 : 1 - Math.pow( 2, - 10 * k );

		},

		InOut: function ( k ) {

			if ( k === 0 ) return 0;
			if ( k === 1 ) return 1;
			if ( ( k *= 2 ) < 1 ) return 0.5 * Math.pow( 1024, k - 1 );
			return 0.5 * ( - Math.pow( 2, - 10 * ( k - 1 ) ) + 2 );

		}

	},

	Circular: {

		In: function ( k ) {

			return 1 - Math.sqrt( 1 - k * k );

		},

		Out: function ( k ) {

			return Math.sqrt( 1 - ( --k * k ) );

		},

		InOut: function ( k ) {

			if ( ( k *= 2 ) < 1) return - 0.5 * ( Math.sqrt( 1 - k * k) - 1);
			return 0.5 * ( Math.sqrt( 1 - ( k -= 2) * k) + 1);

		}

	},

	Elastic: {

		In: function ( k ) {

			var s, a = 0.1, p = 0.4;
			if ( k === 0 ) return 0;
			if ( k === 1 ) return 1;
			if ( !a || a < 1 ) { a = 1; s = p / 4; }
			else s = p * Math.asin( 1 / a ) / ( 2 * Math.PI );
			return - ( a * Math.pow( 2, 10 * ( k -= 1 ) ) * Math.sin( ( k - s ) * ( 2 * Math.PI ) / p ) );

		},

		Out: function ( k ) {

			var s, a = 0.1, p = 0.4;
			if ( k === 0 ) return 0;
			if ( k === 1 ) return 1;
			if ( !a || a < 1 ) { a = 1; s = p / 4; }
			else s = p * Math.asin( 1 / a ) / ( 2 * Math.PI );
			return ( a * Math.pow( 2, - 10 * k) * Math.sin( ( k - s ) * ( 2 * Math.PI ) / p ) + 1 );

		},

		InOut: function ( k ) {

			var s, a = 0.1, p = 0.4;
			if ( k === 0 ) return 0;
			if ( k === 1 ) return 1;
			if ( !a || a < 1 ) { a = 1; s = p / 4; }
			else s = p * Math.asin( 1 / a ) / ( 2 * Math.PI );
			if ( ( k *= 2 ) < 1 ) return - 0.5 * ( a * Math.pow( 2, 10 * ( k -= 1 ) ) * Math.sin( ( k - s ) * ( 2 * Math.PI ) / p ) );
			return a * Math.pow( 2, -10 * ( k -= 1 ) ) * Math.sin( ( k - s ) * ( 2 * Math.PI ) / p ) * 0.5 + 1;

		}

	},

	Back: {

		In: function ( k ) {

			var s = 1.70158;
			return k * k * ( ( s + 1 ) * k - s );

		},

		Out: function ( k ) {

			var s = 1.70158;
			return --k * k * ( ( s + 1 ) * k + s ) + 1;

		},

		InOut: function ( k ) {

			var s = 1.70158 * 1.525;
			if ( ( k *= 2 ) < 1 ) return 0.5 * ( k * k * ( ( s + 1 ) * k - s ) );
			return 0.5 * ( ( k -= 2 ) * k * ( ( s + 1 ) * k + s ) + 2 );

		}

	},

	Bounce: {

		In: function ( k ) {

			return 1 - TWEEN.Easing.Bounce.Out( 1 - k );

		},

		Out: function ( k ) {

			if ( k < ( 1 / 2.75 ) ) {

				return 7.5625 * k * k;

			} else if ( k < ( 2 / 2.75 ) ) {

				return 7.5625 * ( k -= ( 1.5 / 2.75 ) ) * k + 0.75;

			} else if ( k < ( 2.5 / 2.75 ) ) {

				return 7.5625 * ( k -= ( 2.25 / 2.75 ) ) * k + 0.9375;

			} else {

				return 7.5625 * ( k -= ( 2.625 / 2.75 ) ) * k + 0.984375;

			}

		},

		InOut: function ( k ) {

			if ( k < 0.5 ) return TWEEN.Easing.Bounce.In( k * 2 ) * 0.5;
			return TWEEN.Easing.Bounce.Out( k * 2 - 1 ) * 0.5 + 0.5;

		}

	}

};

TWEEN.Interpolation = {

	Linear: function ( v, k ) {

		var m = v.length - 1, f = m * k, i = Math.floor( f ), fn = TWEEN.Interpolation.Utils.Linear;

		if ( k < 0 ) return fn( v[ 0 ], v[ 1 ], f );
		if ( k > 1 ) return fn( v[ m ], v[ m - 1 ], m - f );

		return fn( v[ i ], v[ i + 1 > m ? m : i + 1 ], f - i );

	},

	Bezier: function ( v, k ) {

		var b = 0, n = v.length - 1, pw = Math.pow, bn = TWEEN.Interpolation.Utils.Bernstein, i;

		for ( i = 0; i <= n; i++ ) {
			b += pw( 1 - k, n - i ) * pw( k, i ) * v[ i ] * bn( n, i );
		}

		return b;

	},

	CatmullRom: function ( v, k ) {

		var m = v.length - 1, f = m * k, i = Math.floor( f ), fn = TWEEN.Interpolation.Utils.CatmullRom;

		if ( v[ 0 ] === v[ m ] ) {

			if ( k < 0 ) i = Math.floor( f = m * ( 1 + k ) );

			return fn( v[ ( i - 1 + m ) % m ], v[ i ], v[ ( i + 1 ) % m ], v[ ( i + 2 ) % m ], f - i );

		} else {

			if ( k < 0 ) return v[ 0 ] - ( fn( v[ 0 ], v[ 0 ], v[ 1 ], v[ 1 ], -f ) - v[ 0 ] );
			if ( k > 1 ) return v[ m ] - ( fn( v[ m ], v[ m ], v[ m - 1 ], v[ m - 1 ], f - m ) - v[ m ] );

			return fn( v[ i ? i - 1 : 0 ], v[ i ], v[ m < i + 1 ? m : i + 1 ], v[ m < i + 2 ? m : i + 2 ], f - i );

		}

	},

	Utils: {

		Linear: function ( p0, p1, t ) {

			return ( p1 - p0 ) * t + p0;

		},

		Bernstein: function ( n , i ) {

			var fc = TWEEN.Interpolation.Utils.Factorial;
			return fc( n ) / fc( i ) / fc( n - i );

		},

		Factorial: ( function () {

			var a = [ 1 ];

			return function ( n ) {

				var s = 1, i;
				if ( a[ n ] ) return a[ n ];
				for ( i = n; i > 1; i-- ) s *= i;
				return a[ n ] = s;

			};

		} )(),

		CatmullRom: function ( p0, p1, p2, p3, t ) {

			var v0 = ( p2 - p0 ) * 0.5, v1 = ( p3 - p1 ) * 0.5, t2 = t * t, t3 = t * t2;
			return ( 2 * p1 - 2 * p2 + v0 + v1 ) * t3 + ( - 3 * p1 + 3 * p2 - 2 * v0 - v1 ) * t2 + v0 * t + p1;

		}

	}

};

// UMD (Universal Module Definition)
( function ( root ) {

	if ( typeof define === 'function' && define.amd ) {

		// AMD
		define( [], function () {
			return TWEEN;
		} );

	} else if ( typeof exports === 'object' ) {

		// Node.js
		module.exports = TWEEN;

	} else {

		// Global variable
		root.TWEEN = TWEEN;

	}

} )( this );

},{}],50:[function(_dereq_,module,exports){
(function (global){
(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.WebVRPolyfill = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
'use strict';

var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if ('undefined' !== typeof module) {
  module.exports = EventEmitter;
}

},{}],2:[function(_dereq_,module,exports){
'use strict';
/* eslint-disable no-unused-vars */
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (e) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (Object.getOwnPropertySymbols) {
			symbols = Object.getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

},{}],3:[function(_dereq_,module,exports){
/*
 * Copyright 2015 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Util = _dereq_('./util.js');
var WakeLock = _dereq_('./wakelock.js');

// Start at a higher number to reduce chance of conflict.
var nextDisplayId = 1000;
var hasShowDeprecationWarning = false;

var defaultLeftBounds = [0, 0, 0.5, 1];
var defaultRightBounds = [0.5, 0, 0.5, 1];

/**
 * The base class for all VR frame data.
 */

function VRFrameData() {
  this.leftProjectionMatrix = new Float32Array(16);
  this.leftViewMatrix = new Float32Array(16);
  this.rightProjectionMatrix = new Float32Array(16);
  this.rightViewMatrix = new Float32Array(16);
  this.pose = null;
};

/**
 * The base class for all VR displays.
 */
function VRDisplay() {
  this.isPolyfilled = true;
  this.displayId = nextDisplayId++;
  this.displayName = 'webvr-polyfill displayName';

  this.depthNear = 0.01;
  this.depthFar = 10000.0;

  this.isConnected = true;
  this.isPresenting = false;
  this.capabilities = {
    hasPosition: false,
    hasOrientation: false,
    hasExternalDisplay: false,
    canPresent: false,
    maxLayers: 1
  };
  this.stageParameters = null;

  // "Private" members.
  this.waitingForPresent_ = false;
  this.layer_ = null;

  this.fullscreenElement_ = null;
  this.fullscreenWrapper_ = null;
  this.fullscreenElementCachedStyle_ = null;

  this.fullscreenEventTarget_ = null;
  this.fullscreenChangeHandler_ = null;
  this.fullscreenErrorHandler_ = null;

  this.wakelock_ = new WakeLock();
}

VRDisplay.prototype.getFrameData = function(frameData) {
  // TODO: Technically this should retain it's value for the duration of a frame
  // but I doubt that's practical to do in javascript.
  return Util.frameDataFromPose(frameData, this.getPose(), this);
};

VRDisplay.prototype.getPose = function() {
  // TODO: Technically this should retain it's value for the duration of a frame
  // but I doubt that's practical to do in javascript.
  return this.getImmediatePose();
};

VRDisplay.prototype.requestAnimationFrame = function(callback) {
  return window.requestAnimationFrame(callback);
};

VRDisplay.prototype.cancelAnimationFrame = function(id) {
  return window.cancelAnimationFrame(id);
};

VRDisplay.prototype.wrapForFullscreen = function(element) {
  // Don't wrap in iOS.
  if (Util.isIOS()) {
    return element;
  }
  if (!this.fullscreenWrapper_) {
    this.fullscreenWrapper_ = document.createElement('div');
    var cssProperties = [
      'height: ' + Math.min(screen.height, screen.width) + 'px !important',
      'top: 0 !important',
      'left: 0 !important',
      'right: 0 !important',
      'border: 0',
      'margin: 0',
      'padding: 0',
      'z-index: 999999 !important',
      'position: fixed',
    ];
    this.fullscreenWrapper_.setAttribute('style', cssProperties.join('; ') + ';');
    this.fullscreenWrapper_.classList.add('webvr-polyfill-fullscreen-wrapper');
  }

  if (this.fullscreenElement_ == element) {
    return this.fullscreenWrapper_;
  }

  // Remove any previously applied wrappers
  this.removeFullscreenWrapper();

  this.fullscreenElement_ = element;
  var parent = this.fullscreenElement_.parentElement;
  parent.insertBefore(this.fullscreenWrapper_, this.fullscreenElement_);
  parent.removeChild(this.fullscreenElement_);
  this.fullscreenWrapper_.insertBefore(this.fullscreenElement_, this.fullscreenWrapper_.firstChild);
  this.fullscreenElementCachedStyle_ = this.fullscreenElement_.getAttribute('style');

  var self = this;
  function applyFullscreenElementStyle() {
    if (!self.fullscreenElement_) {
      return;
    }

    var cssProperties = [
      'position: absolute',
      'top: 0',
      'left: 0',
      'width: ' + Math.max(screen.width, screen.height) + 'px',
      'height: ' + Math.min(screen.height, screen.width) + 'px',
      'border: 0',
      'margin: 0',
      'padding: 0',
    ];
    self.fullscreenElement_.setAttribute('style', cssProperties.join('; ') + ';');
  }

  applyFullscreenElementStyle();

  return this.fullscreenWrapper_;
};

VRDisplay.prototype.removeFullscreenWrapper = function() {
  if (!this.fullscreenElement_) {
    return;
  }

  var element = this.fullscreenElement_;
  if (this.fullscreenElementCachedStyle_) {
    element.setAttribute('style', this.fullscreenElementCachedStyle_);
  } else {
    element.removeAttribute('style');
  }
  this.fullscreenElement_ = null;
  this.fullscreenElementCachedStyle_ = null;

  var parent = this.fullscreenWrapper_.parentElement;
  this.fullscreenWrapper_.removeChild(element);
  parent.insertBefore(element, this.fullscreenWrapper_);
  parent.removeChild(this.fullscreenWrapper_);

  return element;
};

VRDisplay.prototype.requestPresent = function(layers) {
  var wasPresenting = this.isPresenting;
  var self = this;

  if (!(layers instanceof Array)) {
    if (!hasShowDeprecationWarning) {
      console.warn("Using a deprecated form of requestPresent. Should pass in an array of VRLayers.");
      hasShowDeprecationWarning = true;
    }
    layers = [layers];
  }

  return new Promise(function(resolve, reject) {
    if (!self.capabilities.canPresent) {
      reject(new Error('VRDisplay is not capable of presenting.'));
      return;
    }

    if (layers.length == 0 || layers.length > self.capabilities.maxLayers) {
      reject(new Error('Invalid number of layers.'));
      return;
    }

    var incomingLayer = layers[0];
    if (!incomingLayer.source) {
      /*
      todo: figure out the correct behavior if the source is not provided.
      see https://github.com/w3c/webvr/issues/58
      */
      resolve();
      return;
    }

    var leftBounds = incomingLayer.leftBounds || defaultLeftBounds;
    var rightBounds = incomingLayer.rightBounds || defaultRightBounds;
    if (wasPresenting) {
      // Already presenting, just changing configuration
      var layer = self.layer_;
      if (layer.source !== incomingLayer.source) {
        layer.source = incomingLayer.source;
      }

      for (var i = 0; i < 4; i++) {
        if (layer.leftBounds[i] !== leftBounds[i]) {
          layer.leftBounds[i] = leftBounds[i];
        }
        if (layer.rightBounds[i] !== rightBounds[i]) {
          layer.rightBounds[i] = rightBounds[i];
        }
      }

      resolve();
      return;
    }

    // Was not already presenting.
    self.layer_ = {
      predistorted: incomingLayer.predistorted,
      source: incomingLayer.source,
      leftBounds: leftBounds.slice(0),
      rightBounds: rightBounds.slice(0)
    };

    self.waitingForPresent_ = false;
    if (self.layer_ && self.layer_.source) {
      var fullscreenElement = self.wrapForFullscreen(self.layer_.source);

      function onFullscreenChange() {
        var actualFullscreenElement = Util.getFullscreenElement();

        self.isPresenting = (fullscreenElement === actualFullscreenElement);
        if (self.isPresenting) {
          if (screen.orientation && screen.orientation.lock) {
            screen.orientation.lock('landscape-primary').catch(function(error){
                    console.error('screen.orientation.lock() failed due to', error.message)
            });
          }
          self.waitingForPresent_ = false;
          self.beginPresent_();
          resolve();
        } else {
          if (screen.orientation && screen.orientation.unlock) {
            screen.orientation.unlock();
          }
          self.removeFullscreenWrapper();
          self.wakelock_.release();
          self.endPresent_();
          self.removeFullscreenListeners_();
        }
        self.fireVRDisplayPresentChange_();
      }
      function onFullscreenError() {
        if (!self.waitingForPresent_) {
          return;
        }

        self.removeFullscreenWrapper();
        self.removeFullscreenListeners_();

        self.wakelock_.release();
        self.waitingForPresent_ = false;
        self.isPresenting = false;

        reject(new Error('Unable to present.'));
      }

      self.addFullscreenListeners_(fullscreenElement,
          onFullscreenChange, onFullscreenError);

      if (Util.requestFullscreen(fullscreenElement)) {
        self.wakelock_.request();
        self.waitingForPresent_ = true;
      } else if (Util.isIOS() || Util.isWebViewAndroid()) {
        // *sigh* Just fake it.
        self.wakelock_.request();
        self.isPresenting = true;
        self.beginPresent_();
        self.fireVRDisplayPresentChange_();
        resolve();
      }
    }

    if (!self.waitingForPresent_ && !Util.isIOS()) {
      Util.exitFullscreen();
      reject(new Error('Unable to present.'));
    }
  });
};

VRDisplay.prototype.exitPresent = function() {
  var wasPresenting = this.isPresenting;
  var self = this;
  this.isPresenting = false;
  this.layer_ = null;
  this.wakelock_.release();

  return new Promise(function(resolve, reject) {
    if (wasPresenting) {
      if (!Util.exitFullscreen() && Util.isIOS()) {
        self.endPresent_();
        self.fireVRDisplayPresentChange_();
      }

      if(Util.isWebViewAndroid()) {
        self.removeFullscreenWrapper();
        self.removeFullscreenListeners_();
        self.endPresent_();
        self.fireVRDisplayPresentChange_();
      }

      resolve();
    } else {
      reject(new Error('Was not presenting to VRDisplay.'));
    }
  });
};

VRDisplay.prototype.getLayers = function() {
  if (this.layer_) {
    return [this.layer_];
  }
  return [];
};

VRDisplay.prototype.fireVRDisplayPresentChange_ = function() {
  var event = new CustomEvent('vrdisplaypresentchange', {detail: {display: this}});
  window.dispatchEvent(event);
};

VRDisplay.prototype.addFullscreenListeners_ = function(element, changeHandler, errorHandler) {
  this.removeFullscreenListeners_();

  this.fullscreenEventTarget_ = element;
  this.fullscreenChangeHandler_ = changeHandler;
  this.fullscreenErrorHandler_ = errorHandler;

  if (changeHandler) {
    if (document.fullscreenEnabled) {
      element.addEventListener('fullscreenchange', changeHandler, false);
    } else if (document.webkitFullscreenEnabled) {
      element.addEventListener('webkitfullscreenchange', changeHandler, false);
    } else if (document.mozFullScreenEnabled) {
      document.addEventListener('mozfullscreenchange', changeHandler, false);
    } else if (document.msFullscreenEnabled) {
      element.addEventListener('msfullscreenchange', changeHandler, false);
    }
  }

  if (errorHandler) {
    if (document.fullscreenEnabled) {
      element.addEventListener('fullscreenerror', errorHandler, false);
    } else if (document.webkitFullscreenEnabled) {
      element.addEventListener('webkitfullscreenerror', errorHandler, false);
    } else if (document.mozFullScreenEnabled) {
      document.addEventListener('mozfullscreenerror', errorHandler, false);
    } else if (document.msFullscreenEnabled) {
      element.addEventListener('msfullscreenerror', errorHandler, false);
    }
  }
};

VRDisplay.prototype.removeFullscreenListeners_ = function() {
  if (!this.fullscreenEventTarget_)
    return;

  var element = this.fullscreenEventTarget_;

  if (this.fullscreenChangeHandler_) {
    var changeHandler = this.fullscreenChangeHandler_;
    element.removeEventListener('fullscreenchange', changeHandler, false);
    element.removeEventListener('webkitfullscreenchange', changeHandler, false);
    document.removeEventListener('mozfullscreenchange', changeHandler, false);
    element.removeEventListener('msfullscreenchange', changeHandler, false);
  }

  if (this.fullscreenErrorHandler_) {
    var errorHandler = this.fullscreenErrorHandler_;
    element.removeEventListener('fullscreenerror', errorHandler, false);
    element.removeEventListener('webkitfullscreenerror', errorHandler, false);
    document.removeEventListener('mozfullscreenerror', errorHandler, false);
    element.removeEventListener('msfullscreenerror', errorHandler, false);
  }

  this.fullscreenEventTarget_ = null;
  this.fullscreenChangeHandler_ = null;
  this.fullscreenErrorHandler_ = null;
};

VRDisplay.prototype.beginPresent_ = function() {
  // Override to add custom behavior when presentation begins.
};

VRDisplay.prototype.endPresent_ = function() {
  // Override to add custom behavior when presentation ends.
};

VRDisplay.prototype.submitFrame = function(pose) {
  // Override to add custom behavior for frame submission.
};

VRDisplay.prototype.getEyeParameters = function(whichEye) {
  // Override to return accurate eye parameters if canPresent is true.
  return null;
};

/*
 * Deprecated classes
 */

/**
 * The base class for all VR devices. (Deprecated)
 */
function VRDevice() {
  this.isPolyfilled = true;
  this.hardwareUnitId = 'webvr-polyfill hardwareUnitId';
  this.deviceId = 'webvr-polyfill deviceId';
  this.deviceName = 'webvr-polyfill deviceName';
}

/**
 * The base class for all VR HMD devices. (Deprecated)
 */
function HMDVRDevice() {
}
HMDVRDevice.prototype = new VRDevice();

/**
 * The base class for all VR position sensor devices. (Deprecated)
 */
function PositionSensorVRDevice() {
}
PositionSensorVRDevice.prototype = new VRDevice();

module.exports.VRFrameData = VRFrameData;
module.exports.VRDisplay = VRDisplay;
module.exports.VRDevice = VRDevice;
module.exports.HMDVRDevice = HMDVRDevice;
module.exports.PositionSensorVRDevice = PositionSensorVRDevice;

},{"./util.js":23,"./wakelock.js":25}],4:[function(_dereq_,module,exports){
/*
 * Copyright 2016 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var CardboardUI = _dereq_('./cardboard-ui.js');
var Util = _dereq_('./util.js');
var WGLUPreserveGLState = _dereq_('./deps/wglu-preserve-state.js');

var distortionVS = [
  'attribute vec2 position;',
  'attribute vec3 texCoord;',

  'varying vec2 vTexCoord;',

  'uniform vec4 viewportOffsetScale[2];',

  'void main() {',
  '  vec4 viewport = viewportOffsetScale[int(texCoord.z)];',
  '  vTexCoord = (texCoord.xy * viewport.zw) + viewport.xy;',
  '  gl_Position = vec4( position, 1.0, 1.0 );',
  '}',
].join('\n');

var distortionFS = [
  'precision mediump float;',
  'uniform sampler2D diffuse;',

  'varying vec2 vTexCoord;',

  'void main() {',
  '  gl_FragColor = texture2D(diffuse, vTexCoord);',
  '}',
].join('\n');

/**
 * A mesh-based distorter.
 */
function CardboardDistorter(gl) {
  this.gl = gl;
  this.ctxAttribs = gl.getContextAttributes();

  this.meshWidth = 20;
  this.meshHeight = 20;

  this.bufferScale = WebVRConfig.BUFFER_SCALE;

  this.bufferWidth = gl.drawingBufferWidth;
  this.bufferHeight = gl.drawingBufferHeight;

  // Patching support
  this.realBindFramebuffer = gl.bindFramebuffer;
  this.realEnable = gl.enable;
  this.realDisable = gl.disable;
  this.realColorMask = gl.colorMask;
  this.realClearColor = gl.clearColor;
  this.realViewport = gl.viewport;

  if (!Util.isIOS()) {
    this.realCanvasWidth = Object.getOwnPropertyDescriptor(gl.canvas.__proto__, 'width');
    this.realCanvasHeight = Object.getOwnPropertyDescriptor(gl.canvas.__proto__, 'height');
  }

  this.isPatched = false;

  // State tracking
  this.lastBoundFramebuffer = null;
  this.cullFace = false;
  this.depthTest = false;
  this.blend = false;
  this.scissorTest = false;
  this.stencilTest = false;
  this.viewport = [0, 0, 0, 0];
  this.colorMask = [true, true, true, true];
  this.clearColor = [0, 0, 0, 0];

  this.attribs = {
    position: 0,
    texCoord: 1
  };
  this.program = Util.linkProgram(gl, distortionVS, distortionFS, this.attribs);
  this.uniforms = Util.getProgramUniforms(gl, this.program);

  this.viewportOffsetScale = new Float32Array(8);
  this.setTextureBounds();

  this.vertexBuffer = gl.createBuffer();
  this.indexBuffer = gl.createBuffer();
  this.indexCount = 0;

  this.renderTarget = gl.createTexture();
  this.framebuffer = gl.createFramebuffer();

  this.depthStencilBuffer = null;
  this.depthBuffer = null;
  this.stencilBuffer = null;

  if (this.ctxAttribs.depth && this.ctxAttribs.stencil) {
    this.depthStencilBuffer = gl.createRenderbuffer();
  } else if (this.ctxAttribs.depth) {
    this.depthBuffer = gl.createRenderbuffer();
  } else if (this.ctxAttribs.stencil) {
    this.stencilBuffer = gl.createRenderbuffer();
  }

  this.patch();

  this.onResize();

  if (!WebVRConfig.CARDBOARD_UI_DISABLED) {
    this.cardboardUI = new CardboardUI(gl);
  }
};

/**
 * Tears down all the resources created by the distorter and removes any
 * patches.
 */
CardboardDistorter.prototype.destroy = function() {
  var gl = this.gl;

  this.unpatch();

  gl.deleteProgram(this.program);
  gl.deleteBuffer(this.vertexBuffer);
  gl.deleteBuffer(this.indexBuffer);
  gl.deleteTexture(this.renderTarget);
  gl.deleteFramebuffer(this.framebuffer);
  if (this.depthStencilBuffer) {
    gl.deleteRenderbuffer(this.depthStencilBuffer);
  }
  if (this.depthBuffer) {
    gl.deleteRenderbuffer(this.depthBuffer);
  }
  if (this.stencilBuffer) {
    gl.deleteRenderbuffer(this.stencilBuffer);
  }

  if (this.cardboardUI) {
    this.cardboardUI.destroy();
  }
};


/**
 * Resizes the backbuffer to match the canvas width and height.
 */
CardboardDistorter.prototype.onResize = function() {
  var gl = this.gl;
  var self = this;

  var glState = [
    gl.RENDERBUFFER_BINDING,
    gl.TEXTURE_BINDING_2D, gl.TEXTURE0
  ];

  WGLUPreserveGLState(gl, glState, function(gl) {
    // Bind real backbuffer and clear it once. We don't need to clear it again
    // after that because we're overwriting the same area every frame.
    self.realBindFramebuffer.call(gl, gl.FRAMEBUFFER, null);

    // Put things in a good state
    if (self.scissorTest) { self.realDisable.call(gl, gl.SCISSOR_TEST); }
    self.realColorMask.call(gl, true, true, true, true);
    self.realViewport.call(gl, 0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    self.realClearColor.call(gl, 0, 0, 0, 1);

    gl.clear(gl.COLOR_BUFFER_BIT);

    // Now bind and resize the fake backbuffer
    self.realBindFramebuffer.call(gl, gl.FRAMEBUFFER, self.framebuffer);

    gl.bindTexture(gl.TEXTURE_2D, self.renderTarget);
    gl.texImage2D(gl.TEXTURE_2D, 0, self.ctxAttribs.alpha ? gl.RGBA : gl.RGB,
        self.bufferWidth, self.bufferHeight, 0,
        self.ctxAttribs.alpha ? gl.RGBA : gl.RGB, gl.UNSIGNED_BYTE, null);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, self.renderTarget, 0);

    if (self.ctxAttribs.depth && self.ctxAttribs.stencil) {
      gl.bindRenderbuffer(gl.RENDERBUFFER, self.depthStencilBuffer);
      gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL,
          self.bufferWidth, self.bufferHeight);
      gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT,
          gl.RENDERBUFFER, self.depthStencilBuffer);
    } else if (self.ctxAttribs.depth) {
      gl.bindRenderbuffer(gl.RENDERBUFFER, self.depthBuffer);
      gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_COMPONENT16,
          self.bufferWidth, self.bufferHeight);
      gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT,
          gl.RENDERBUFFER, self.depthBuffer);
    } else if (self.ctxAttribs.stencil) {
      gl.bindRenderbuffer(gl.RENDERBUFFER, self.stencilBuffer);
      gl.renderbufferStorage(gl.RENDERBUFFER, gl.STENCIL_INDEX8,
          self.bufferWidth, self.bufferHeight);
      gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.STENCIL_ATTACHMENT,
          gl.RENDERBUFFER, self.stencilBuffer);
    }

    if (!gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE) {
      console.error('Framebuffer incomplete!');
    }

    self.realBindFramebuffer.call(gl, gl.FRAMEBUFFER, self.lastBoundFramebuffer);

    if (self.scissorTest) { self.realEnable.call(gl, gl.SCISSOR_TEST); }

    self.realColorMask.apply(gl, self.colorMask);
    self.realViewport.apply(gl, self.viewport);
    self.realClearColor.apply(gl, self.clearColor);
  });

  if (this.cardboardUI) {
    this.cardboardUI.onResize();
  }
};

CardboardDistorter.prototype.patch = function() {
  if (this.isPatched) {
    return;
  }

  var self = this;
  var canvas = this.gl.canvas;
  var gl = this.gl;

  if (!Util.isIOS()) {
    canvas.width = Util.getScreenWidth() * this.bufferScale;
    canvas.height = Util.getScreenHeight() * this.bufferScale;

    Object.defineProperty(canvas, 'width', {
      configurable: true,
      enumerable: true,
      get: function() {
        return self.bufferWidth;
      },
      set: function(value) {
        self.bufferWidth = value;
        self.realCanvasWidth.set.call(canvas, value);
        self.onResize();
      }
    });

    Object.defineProperty(canvas, 'height', {
      configurable: true,
      enumerable: true,
      get: function() {
        return self.bufferHeight;
      },
      set: function(value) {
        self.bufferHeight = value;
        self.realCanvasHeight.set.call(canvas, value);
        self.onResize();
      }
    });
  }

  this.lastBoundFramebuffer = gl.getParameter(gl.FRAMEBUFFER_BINDING);

  if (this.lastBoundFramebuffer == null) {
    this.lastBoundFramebuffer = this.framebuffer;
    this.gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffer);
  }

  this.gl.bindFramebuffer = function(target, framebuffer) {
    self.lastBoundFramebuffer = framebuffer ? framebuffer : self.framebuffer;
    // Silently make calls to bind the default framebuffer bind ours instead.
    self.realBindFramebuffer.call(gl, target, self.lastBoundFramebuffer);
  };

  this.cullFace = gl.getParameter(gl.CULL_FACE);
  this.depthTest = gl.getParameter(gl.DEPTH_TEST);
  this.blend = gl.getParameter(gl.BLEND);
  this.scissorTest = gl.getParameter(gl.SCISSOR_TEST);
  this.stencilTest = gl.getParameter(gl.STENCIL_TEST);

  gl.enable = function(pname) {
    switch (pname) {
      case gl.CULL_FACE: self.cullFace = true; break;
      case gl.DEPTH_TEST: self.depthTest = true; break;
      case gl.BLEND: self.blend = true; break;
      case gl.SCISSOR_TEST: self.scissorTest = true; break;
      case gl.STENCIL_TEST: self.stencilTest = true; break;
    }
    self.realEnable.call(gl, pname);
  };

  gl.disable = function(pname) {
    switch (pname) {
      case gl.CULL_FACE: self.cullFace = false; break;
      case gl.DEPTH_TEST: self.depthTest = false; break;
      case gl.BLEND: self.blend = false; break;
      case gl.SCISSOR_TEST: self.scissorTest = false; break;
      case gl.STENCIL_TEST: self.stencilTest = false; break;
    }
    self.realDisable.call(gl, pname);
  };

  this.colorMask = gl.getParameter(gl.COLOR_WRITEMASK);
  gl.colorMask = function(r, g, b, a) {
    self.colorMask[0] = r;
    self.colorMask[1] = g;
    self.colorMask[2] = b;
    self.colorMask[3] = a;
    self.realColorMask.call(gl, r, g, b, a);
  };

  this.clearColor = gl.getParameter(gl.COLOR_CLEAR_VALUE);
  gl.clearColor = function(r, g, b, a) {
    self.clearColor[0] = r;
    self.clearColor[1] = g;
    self.clearColor[2] = b;
    self.clearColor[3] = a;
    self.realClearColor.call(gl, r, g, b, a);
  };

  this.viewport = gl.getParameter(gl.VIEWPORT);
  gl.viewport = function(x, y, w, h) {
    self.viewport[0] = x;
    self.viewport[1] = y;
    self.viewport[2] = w;
    self.viewport[3] = h;
    self.realViewport.call(gl, x, y, w, h);
  };

  this.isPatched = true;
  Util.safariCssSizeWorkaround(canvas);
};

CardboardDistorter.prototype.unpatch = function() {
  if (!this.isPatched) {
    return;
  }

  var gl = this.gl;
  var canvas = this.gl.canvas;

  if (!Util.isIOS()) {
    Object.defineProperty(canvas, 'width', this.realCanvasWidth);
    Object.defineProperty(canvas, 'height', this.realCanvasHeight);
  }
  canvas.width = this.bufferWidth;
  canvas.height = this.bufferHeight;

  gl.bindFramebuffer = this.realBindFramebuffer;
  gl.enable = this.realEnable;
  gl.disable = this.realDisable;
  gl.colorMask = this.realColorMask;
  gl.clearColor = this.realClearColor;
  gl.viewport = this.realViewport;

  // Check to see if our fake backbuffer is bound and bind the real backbuffer
  // if that's the case.
  if (this.lastBoundFramebuffer == this.framebuffer) {
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
  }

  this.isPatched = false;

  setTimeout(function() {
    Util.safariCssSizeWorkaround(canvas);
  }, 1);
};

CardboardDistorter.prototype.setTextureBounds = function(leftBounds, rightBounds) {
  if (!leftBounds) {
    leftBounds = [0, 0, 0.5, 1];
  }

  if (!rightBounds) {
    rightBounds = [0.5, 0, 0.5, 1];
  }

  // Left eye
  this.viewportOffsetScale[0] = leftBounds[0]; // X
  this.viewportOffsetScale[1] = leftBounds[1]; // Y
  this.viewportOffsetScale[2] = leftBounds[2]; // Width
  this.viewportOffsetScale[3] = leftBounds[3]; // Height

  // Right eye
  this.viewportOffsetScale[4] = rightBounds[0]; // X
  this.viewportOffsetScale[5] = rightBounds[1]; // Y
  this.viewportOffsetScale[6] = rightBounds[2]; // Width
  this.viewportOffsetScale[7] = rightBounds[3]; // Height
};

/**
 * Performs distortion pass on the injected backbuffer, rendering it to the real
 * backbuffer.
 */
CardboardDistorter.prototype.submitFrame = function() {
  var gl = this.gl;
  var self = this;

  var glState = [];

  if (!WebVRConfig.DIRTY_SUBMIT_FRAME_BINDINGS) {
    glState.push(
      gl.CURRENT_PROGRAM,
      gl.ARRAY_BUFFER_BINDING,
      gl.ELEMENT_ARRAY_BUFFER_BINDING,
      gl.TEXTURE_BINDING_2D, gl.TEXTURE0
    );
  }

  WGLUPreserveGLState(gl, glState, function(gl) {
    // Bind the real default framebuffer
    self.realBindFramebuffer.call(gl, gl.FRAMEBUFFER, null);

    // Make sure the GL state is in a good place
    if (self.cullFace) { self.realDisable.call(gl, gl.CULL_FACE); }
    if (self.depthTest) { self.realDisable.call(gl, gl.DEPTH_TEST); }
    if (self.blend) { self.realDisable.call(gl, gl.BLEND); }
    if (self.scissorTest) { self.realDisable.call(gl, gl.SCISSOR_TEST); }
    if (self.stencilTest) { self.realDisable.call(gl, gl.STENCIL_TEST); }
    self.realColorMask.call(gl, true, true, true, true);
    self.realViewport.call(gl, 0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);

    // If the backbuffer has an alpha channel clear every frame so the page
    // doesn't show through.
    if (self.ctxAttribs.alpha || Util.isIOS()) {
      self.realClearColor.call(gl, 0, 0, 0, 1);
      gl.clear(gl.COLOR_BUFFER_BIT);
    }

    // Bind distortion program and mesh
    gl.useProgram(self.program);

    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, self.indexBuffer);

    gl.bindBuffer(gl.ARRAY_BUFFER, self.vertexBuffer);
    gl.enableVertexAttribArray(self.attribs.position);
    gl.enableVertexAttribArray(self.attribs.texCoord);
    gl.vertexAttribPointer(self.attribs.position, 2, gl.FLOAT, false, 20, 0);
    gl.vertexAttribPointer(self.attribs.texCoord, 3, gl.FLOAT, false, 20, 8);

    gl.activeTexture(gl.TEXTURE0);
    gl.uniform1i(self.uniforms.diffuse, 0);
    gl.bindTexture(gl.TEXTURE_2D, self.renderTarget);

    gl.uniform4fv(self.uniforms.viewportOffsetScale, self.viewportOffsetScale);

    // Draws both eyes
    gl.drawElements(gl.TRIANGLES, self.indexCount, gl.UNSIGNED_SHORT, 0);

    if (self.cardboardUI) {
      self.cardboardUI.renderNoState();
    }

    // Bind the fake default framebuffer again
    self.realBindFramebuffer.call(self.gl, gl.FRAMEBUFFER, self.framebuffer);

    // If preserveDrawingBuffer == false clear the framebuffer
    if (!self.ctxAttribs.preserveDrawingBuffer) {
      self.realClearColor.call(gl, 0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT);
    }

    if (!WebVRConfig.DIRTY_SUBMIT_FRAME_BINDINGS) {
      self.realBindFramebuffer.call(gl, gl.FRAMEBUFFER, self.lastBoundFramebuffer);
    }

    // Restore state
    if (self.cullFace) { self.realEnable.call(gl, gl.CULL_FACE); }
    if (self.depthTest) { self.realEnable.call(gl, gl.DEPTH_TEST); }
    if (self.blend) { self.realEnable.call(gl, gl.BLEND); }
    if (self.scissorTest) { self.realEnable.call(gl, gl.SCISSOR_TEST); }
    if (self.stencilTest) { self.realEnable.call(gl, gl.STENCIL_TEST); }

    self.realColorMask.apply(gl, self.colorMask);
    self.realViewport.apply(gl, self.viewport);
    if (self.ctxAttribs.alpha || !self.ctxAttribs.preserveDrawingBuffer) {
      self.realClearColor.apply(gl, self.clearColor);
    }
  });

  // Workaround for the fact that Safari doesn't allow us to patch the canvas
  // width and height correctly. After each submit frame check to see what the
  // real backbuffer size has been set to and resize the fake backbuffer size
  // to match.
  if (Util.isIOS()) {
    var canvas = gl.canvas;
    if (canvas.width != self.bufferWidth || canvas.height != self.bufferHeight) {
      self.bufferWidth = canvas.width;
      self.bufferHeight = canvas.height;
      self.onResize();
    }
  }
};

/**
 * Call when the deviceInfo has changed. At this point we need
 * to re-calculate the distortion mesh.
 */
CardboardDistorter.prototype.updateDeviceInfo = function(deviceInfo) {
  var gl = this.gl;
  var self = this;

  var glState = [gl.ARRAY_BUFFER_BINDING, gl.ELEMENT_ARRAY_BUFFER_BINDING];
  WGLUPreserveGLState(gl, glState, function(gl) {
    var vertices = self.computeMeshVertices_(self.meshWidth, self.meshHeight, deviceInfo);
    gl.bindBuffer(gl.ARRAY_BUFFER, self.vertexBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW);

    // Indices don't change based on device parameters, so only compute once.
    if (!self.indexCount) {
      var indices = self.computeMeshIndices_(self.meshWidth, self.meshHeight);
      gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, self.indexBuffer);
      gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, indices, gl.STATIC_DRAW);
      self.indexCount = indices.length;
    }
  });
};

/**
 * Build the distortion mesh vertices.
 * Based on code from the Unity cardboard plugin.
 */
CardboardDistorter.prototype.computeMeshVertices_ = function(width, height, deviceInfo) {
  var vertices = new Float32Array(2 * width * height * 5);

  var lensFrustum = deviceInfo.getLeftEyeVisibleTanAngles();
  var noLensFrustum = deviceInfo.getLeftEyeNoLensTanAngles();
  var viewport = deviceInfo.getLeftEyeVisibleScreenRect(noLensFrustum);
  var vidx = 0;
  var iidx = 0;
  for (var e = 0; e < 2; e++) {
    for (var j = 0; j < height; j++) {
      for (var i = 0; i < width; i++, vidx++) {
        var u = i / (width - 1);
        var v = j / (height - 1);

        // Grid points regularly spaced in StreoScreen, and barrel distorted in
        // the mesh.
        var s = u;
        var t = v;
        var x = Util.lerp(lensFrustum[0], lensFrustum[2], u);
        var y = Util.lerp(lensFrustum[3], lensFrustum[1], v);
        var d = Math.sqrt(x * x + y * y);
        var r = deviceInfo.distortion.distortInverse(d);
        var p = x * r / d;
        var q = y * r / d;
        u = (p - noLensFrustum[0]) / (noLensFrustum[2] - noLensFrustum[0]);
        v = (q - noLensFrustum[3]) / (noLensFrustum[1] - noLensFrustum[3]);

        // Convert u,v to mesh screen coordinates.
        var aspect = deviceInfo.device.widthMeters / deviceInfo.device.heightMeters;

        // FIXME: The original Unity plugin multiplied U by the aspect ratio
        // and didn't multiply either value by 2, but that seems to get it
        // really close to correct looking for me. I hate this kind of "Don't
        // know why it works" code though, and wold love a more logical
        // explanation of what needs to happen here.
        u = (viewport.x + u * viewport.width - 0.5) * 2.0; //* aspect;
        v = (viewport.y + v * viewport.height - 0.5) * 2.0;

        vertices[(vidx * 5) + 0] = u; // position.x
        vertices[(vidx * 5) + 1] = v; // position.y
        vertices[(vidx * 5) + 2] = s; // texCoord.x
        vertices[(vidx * 5) + 3] = t; // texCoord.y
        vertices[(vidx * 5) + 4] = e; // texCoord.z (viewport index)
      }
    }
    var w = lensFrustum[2] - lensFrustum[0];
    lensFrustum[0] = -(w + lensFrustum[0]);
    lensFrustum[2] = w - lensFrustum[2];
    w = noLensFrustum[2] - noLensFrustum[0];
    noLensFrustum[0] = -(w + noLensFrustum[0]);
    noLensFrustum[2] = w - noLensFrustum[2];
    viewport.x = 1 - (viewport.x + viewport.width);
  }
  return vertices;
}

/**
 * Build the distortion mesh indices.
 * Based on code from the Unity cardboard plugin.
 */
CardboardDistorter.prototype.computeMeshIndices_ = function(width, height) {
  var indices = new Uint16Array(2 * (width - 1) * (height - 1) * 6);
  var halfwidth = width / 2;
  var halfheight = height / 2;
  var vidx = 0;
  var iidx = 0;
  for (var e = 0; e < 2; e++) {
    for (var j = 0; j < height; j++) {
      for (var i = 0; i < width; i++, vidx++) {
        if (i == 0 || j == 0)
          continue;
        // Build a quad.  Lower right and upper left quadrants have quads with
        // the triangle diagonal flipped to get the vignette to interpolate
        // correctly.
        if ((i <= halfwidth) == (j <= halfheight)) {
          // Quad diagonal lower left to upper right.
          indices[iidx++] = vidx;
          indices[iidx++] = vidx - width - 1;
          indices[iidx++] = vidx - width;
          indices[iidx++] = vidx - width - 1;
          indices[iidx++] = vidx;
          indices[iidx++] = vidx - 1;
        } else {
          // Quad diagonal upper left to lower right.
          indices[iidx++] = vidx - 1;
          indices[iidx++] = vidx - width;
          indices[iidx++] = vidx;
          indices[iidx++] = vidx - width;
          indices[iidx++] = vidx - 1;
          indices[iidx++] = vidx - width - 1;
        }
      }
    }
  }
  return indices;
};

CardboardDistorter.prototype.getOwnPropertyDescriptor_ = function(proto, attrName) {
  var descriptor = Object.getOwnPropertyDescriptor(proto, attrName);
  // In some cases (ahem... Safari), the descriptor returns undefined get and
  // set fields. In this case, we need to create a synthetic property
  // descriptor. This works around some of the issues in
  // https://github.com/borismus/webvr-polyfill/issues/46
  if (descriptor.get === undefined || descriptor.set === undefined) {
    descriptor.configurable = true;
    descriptor.enumerable = true;
    descriptor.get = function() {
      return this.getAttribute(attrName);
    };
    descriptor.set = function(val) {
      this.setAttribute(attrName, val);
    };
  }
  return descriptor;
};

module.exports = CardboardDistorter;

},{"./cardboard-ui.js":5,"./deps/wglu-preserve-state.js":7,"./util.js":23}],5:[function(_dereq_,module,exports){
/*
 * Copyright 2016 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Util = _dereq_('./util.js');
var WGLUPreserveGLState = _dereq_('./deps/wglu-preserve-state.js');

var uiVS = [
  'attribute vec2 position;',

  'uniform mat4 projectionMat;',

  'void main() {',
  '  gl_Position = projectionMat * vec4( position, -1.0, 1.0 );',
  '}',
].join('\n');

var uiFS = [
  'precision mediump float;',

  'uniform vec4 color;',

  'void main() {',
  '  gl_FragColor = color;',
  '}',
].join('\n');

var DEG2RAD = Math.PI/180.0;

// The gear has 6 identical sections, each spanning 60 degrees.
var kAnglePerGearSection = 60;

// Half-angle of the span of the outer rim.
var kOuterRimEndAngle = 12;

// Angle between the middle of the outer rim and the start of the inner rim.
var kInnerRimBeginAngle = 20;

// Distance from center to outer rim, normalized so that the entire model
// fits in a [-1, 1] x [-1, 1] square.
var kOuterRadius = 1;

// Distance from center to depressed rim, in model units.
var kMiddleRadius = 0.75;

// Radius of the inner hollow circle, in model units.
var kInnerRadius = 0.3125;

// Center line thickness in DP.
var kCenterLineThicknessDp = 4;

// Button width in DP.
var kButtonWidthDp = 28;

// Factor to scale the touch area that responds to the touch.
var kTouchSlopFactor = 1.5;

var Angles = [
  0, kOuterRimEndAngle, kInnerRimBeginAngle,
  kAnglePerGearSection - kInnerRimBeginAngle,
  kAnglePerGearSection - kOuterRimEndAngle
];

/**
 * Renders the alignment line and "options" gear. It is assumed that the canvas
 * this is rendered into covers the entire screen (or close to it.)
 */
function CardboardUI(gl) {
  this.gl = gl;

  this.attribs = {
    position: 0
  };
  this.program = Util.linkProgram(gl, uiVS, uiFS, this.attribs);
  this.uniforms = Util.getProgramUniforms(gl, this.program);

  this.vertexBuffer = gl.createBuffer();
  this.gearOffset = 0;
  this.gearVertexCount = 0;
  this.arrowOffset = 0;
  this.arrowVertexCount = 0;

  this.projMat = new Float32Array(16);

  this.listener = null;

  this.onResize();
};

/**
 * Tears down all the resources created by the UI renderer.
 */
CardboardUI.prototype.destroy = function() {
  var gl = this.gl;

  if (this.listener) {
    gl.canvas.removeEventListener('click', this.listener, false);
  }

  gl.deleteProgram(this.program);
  gl.deleteBuffer(this.vertexBuffer);
};

/**
 * Adds a listener to clicks on the gear and back icons
 */
CardboardUI.prototype.listen = function(optionsCallback, backCallback) {
  var canvas = this.gl.canvas;
  this.listener = function(event) {
    var midline = canvas.clientWidth / 2;
    var buttonSize = kButtonWidthDp * kTouchSlopFactor;
    // Check to see if the user clicked on (or around) the gear icon
    if (event.clientX > midline - buttonSize &&
        event.clientX < midline + buttonSize &&
        event.clientY > canvas.clientHeight - buttonSize) {
      optionsCallback(event);
    }
    // Check to see if the user clicked on (or around) the back icon
    else if (event.clientX < buttonSize && event.clientY < buttonSize) {
      backCallback(event);
    }
  };
  canvas.addEventListener('click', this.listener, false);
};

/**
 * Builds the UI mesh.
 */
CardboardUI.prototype.onResize = function() {
  var gl = this.gl;
  var self = this;

  var glState = [
    gl.ARRAY_BUFFER_BINDING
  ];

  WGLUPreserveGLState(gl, glState, function(gl) {
    var vertices = [];

    var midline = gl.drawingBufferWidth / 2;

    // Assumes your canvas width and height is scaled proportionately.
    // TODO(smus): The following causes buttons to become huge on iOS, but seems
    // like the right thing to do. For now, added a hack. But really, investigate why.
    var dps = (gl.drawingBufferWidth / (screen.width * window.devicePixelRatio));
    if (!Util.isIOS()) {
      dps *= window.devicePixelRatio;
    }

    var lineWidth = kCenterLineThicknessDp * dps / 2;
    var buttonSize = kButtonWidthDp * kTouchSlopFactor * dps;
    var buttonScale = kButtonWidthDp * dps / 2;
    var buttonBorder = ((kButtonWidthDp * kTouchSlopFactor) - kButtonWidthDp) * dps;

    // Build centerline
    vertices.push(midline - lineWidth, buttonSize);
    vertices.push(midline - lineWidth, gl.drawingBufferHeight);
    vertices.push(midline + lineWidth, buttonSize);
    vertices.push(midline + lineWidth, gl.drawingBufferHeight);

    // Build gear
    self.gearOffset = (vertices.length / 2);

    function addGearSegment(theta, r) {
      var angle = (90 - theta) * DEG2RAD;
      var x = Math.cos(angle);
      var y = Math.sin(angle);
      vertices.push(kInnerRadius * x * buttonScale + midline, kInnerRadius * y * buttonScale + buttonScale);
      vertices.push(r * x * buttonScale + midline, r * y * buttonScale + buttonScale);
    }

    for (var i = 0; i <= 6; i++) {
      var segmentTheta = i * kAnglePerGearSection;

      addGearSegment(segmentTheta, kOuterRadius);
      addGearSegment(segmentTheta + kOuterRimEndAngle, kOuterRadius);
      addGearSegment(segmentTheta + kInnerRimBeginAngle, kMiddleRadius);
      addGearSegment(segmentTheta + (kAnglePerGearSection - kInnerRimBeginAngle), kMiddleRadius);
      addGearSegment(segmentTheta + (kAnglePerGearSection - kOuterRimEndAngle), kOuterRadius);
    }

    self.gearVertexCount = (vertices.length / 2) - self.gearOffset;

    // Build back arrow
    self.arrowOffset = (vertices.length / 2);

    function addArrowVertex(x, y) {
      vertices.push(buttonBorder + x, gl.drawingBufferHeight - buttonBorder - y);
    }

    var angledLineWidth = lineWidth / Math.sin(45 * DEG2RAD);

    addArrowVertex(0, buttonScale);
    addArrowVertex(buttonScale, 0);
    addArrowVertex(buttonScale + angledLineWidth, angledLineWidth);
    addArrowVertex(angledLineWidth, buttonScale + angledLineWidth);

    addArrowVertex(angledLineWidth, buttonScale - angledLineWidth);
    addArrowVertex(0, buttonScale);
    addArrowVertex(buttonScale, buttonScale * 2);
    addArrowVertex(buttonScale + angledLineWidth, (buttonScale * 2) - angledLineWidth);

    addArrowVertex(angledLineWidth, buttonScale - angledLineWidth);
    addArrowVertex(0, buttonScale);

    addArrowVertex(angledLineWidth, buttonScale - lineWidth);
    addArrowVertex(kButtonWidthDp * dps, buttonScale - lineWidth);
    addArrowVertex(angledLineWidth, buttonScale + lineWidth);
    addArrowVertex(kButtonWidthDp * dps, buttonScale + lineWidth);

    self.arrowVertexCount = (vertices.length / 2) - self.arrowOffset;

    // Buffer data
    gl.bindBuffer(gl.ARRAY_BUFFER, self.vertexBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertices), gl.STATIC_DRAW);
  });
};

/**
 * Performs distortion pass on the injected backbuffer, rendering it to the real
 * backbuffer.
 */
CardboardUI.prototype.render = function() {
  var gl = this.gl;
  var self = this;

  var glState = [
    gl.CULL_FACE,
    gl.DEPTH_TEST,
    gl.BLEND,
    gl.SCISSOR_TEST,
    gl.STENCIL_TEST,
    gl.COLOR_WRITEMASK,
    gl.VIEWPORT,

    gl.CURRENT_PROGRAM,
    gl.ARRAY_BUFFER_BINDING
  ];

  WGLUPreserveGLState(gl, glState, function(gl) {
    // Make sure the GL state is in a good place
    gl.disable(gl.CULL_FACE);
    gl.disable(gl.DEPTH_TEST);
    gl.disable(gl.BLEND);
    gl.disable(gl.SCISSOR_TEST);
    gl.disable(gl.STENCIL_TEST);
    gl.colorMask(true, true, true, true);
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);

    self.renderNoState();
  });
};

CardboardUI.prototype.renderNoState = function() {
  var gl = this.gl;

  // Bind distortion program and mesh
  gl.useProgram(this.program);

  gl.bindBuffer(gl.ARRAY_BUFFER, this.vertexBuffer);
  gl.enableVertexAttribArray(this.attribs.position);
  gl.vertexAttribPointer(this.attribs.position, 2, gl.FLOAT, false, 8, 0);

  gl.uniform4f(this.uniforms.color, 1.0, 1.0, 1.0, 1.0);

  Util.orthoMatrix(this.projMat, 0, gl.drawingBufferWidth, 0, gl.drawingBufferHeight, 0.1, 1024.0);
  gl.uniformMatrix4fv(this.uniforms.projectionMat, false, this.projMat);

  // Draws UI element
  gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
  gl.drawArrays(gl.TRIANGLE_STRIP, this.gearOffset, this.gearVertexCount);
  gl.drawArrays(gl.TRIANGLE_STRIP, this.arrowOffset, this.arrowVertexCount);
};

module.exports = CardboardUI;

},{"./deps/wglu-preserve-state.js":7,"./util.js":23}],6:[function(_dereq_,module,exports){
/*
 * Copyright 2016 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var CardboardDistorter = _dereq_('./cardboard-distorter.js');
var CardboardUI = _dereq_('./cardboard-ui.js');
var DeviceInfo = _dereq_('./device-info.js');
var Dpdb = _dereq_('./dpdb/dpdb.js');
var FusionPoseSensor = _dereq_('./sensor-fusion/fusion-pose-sensor.js');
var RotateInstructions = _dereq_('./rotate-instructions.js');
var ViewerSelector = _dereq_('./viewer-selector.js');
var VRDisplay = _dereq_('./base.js').VRDisplay;
var Util = _dereq_('./util.js');

var Eye = {
  LEFT: 'left',
  RIGHT: 'right'
};

/**
 * VRDisplay based on mobile device parameters and DeviceMotion APIs.
 */
function CardboardVRDisplay() {
  this.displayName = 'Cardboard VRDisplay (webvr-polyfill)';

  this.capabilities.hasOrientation = true;
  this.capabilities.canPresent = true;

  // "Private" members.
  this.bufferScale_ = WebVRConfig.BUFFER_SCALE;
  this.poseSensor_ = new FusionPoseSensor();
  this.distorter_ = null;
  this.cardboardUI_ = null;

  this.dpdb_ = new Dpdb(true, this.onDeviceParamsUpdated_.bind(this));
  this.deviceInfo_ = new DeviceInfo(this.dpdb_.getDeviceParams());

  this.viewerSelector_ = new ViewerSelector();
  this.viewerSelector_.on('change', this.onViewerChanged_.bind(this));

  // Set the correct initial viewer.
  this.deviceInfo_.setViewer(this.viewerSelector_.getCurrentViewer());

  if (!WebVRConfig.ROTATE_INSTRUCTIONS_DISABLED) {
    this.rotateInstructions_ = new RotateInstructions();
  }

  if (Util.isIOS()) {
    // Listen for resize events to workaround this awful Safari bug.
    window.addEventListener('resize', this.onResize_.bind(this));
  }
}
CardboardVRDisplay.prototype = new VRDisplay();

CardboardVRDisplay.prototype.getImmediatePose = function() {
  return {
    position: this.poseSensor_.getPosition(),
    orientation: this.poseSensor_.getOrientation(),
    linearVelocity: null,
    linearAcceleration: null,
    angularVelocity: null,
    angularAcceleration: null
  };
};

CardboardVRDisplay.prototype.resetPose = function() {
  this.poseSensor_.resetPose();
};

CardboardVRDisplay.prototype.getEyeParameters = function(whichEye) {
  var offset = [this.deviceInfo_.viewer.interLensDistance * 0.5, 0.0, 0.0];
  var fieldOfView;

  // TODO: FoV can be a little expensive to compute. Cache when device params change.
  if (whichEye == Eye.LEFT) {
    offset[0] *= -1.0;
    fieldOfView = this.deviceInfo_.getFieldOfViewLeftEye();
  } else if (whichEye == Eye.RIGHT) {
    fieldOfView = this.deviceInfo_.getFieldOfViewRightEye();
  } else {
    console.error('Invalid eye provided: %s', whichEye);
    return null;
  }

  return {
    fieldOfView: fieldOfView,
    offset: offset,
    // TODO: Should be able to provide better values than these.
    renderWidth: this.deviceInfo_.device.width * 0.5 * this.bufferScale_,
    renderHeight: this.deviceInfo_.device.height * this.bufferScale_,
  };
};

CardboardVRDisplay.prototype.onDeviceParamsUpdated_ = function(newParams) {
  if (Util.isDebug()) {
    console.log('DPDB reported that device params were updated.');
  }
  this.deviceInfo_.updateDeviceParams(newParams);

  if (this.distorter_) {
    this.distorter_.updateDeviceInfo(this.deviceInfo_);
  }
};

CardboardVRDisplay.prototype.updateBounds_ = function () {
  if (this.layer_ && this.distorter_ && (this.layer_.leftBounds || this.layer_.rightBounds)) {
    this.distorter_.setTextureBounds(this.layer_.leftBounds, this.layer_.rightBounds);
  }
};

CardboardVRDisplay.prototype.beginPresent_ = function() {
  var gl = this.layer_.source.getContext('webgl');
  if (!gl)
    gl = this.layer_.source.getContext('experimental-webgl');
  if (!gl)
    gl = this.layer_.source.getContext('webgl2');

  if (!gl)
    return; // Can't do distortion without a WebGL context.

  // Provides a way to opt out of distortion
  if (this.layer_.predistorted) {
    if (!WebVRConfig.CARDBOARD_UI_DISABLED) {
      gl.canvas.width = Util.getScreenWidth() * this.bufferScale_;
      gl.canvas.height = Util.getScreenHeight() * this.bufferScale_;
      this.cardboardUI_ = new CardboardUI(gl);
    }
  } else {
    // Create a new distorter for the target context
    this.distorter_ = new CardboardDistorter(gl);
    this.distorter_.updateDeviceInfo(this.deviceInfo_);
    this.cardboardUI_ = this.distorter_.cardboardUI;
  }

  if (this.cardboardUI_) {
    this.cardboardUI_.listen(function(e) {
      // Options clicked.
      this.viewerSelector_.show(this.layer_.source.parentElement);
      e.stopPropagation();
      e.preventDefault();
    }.bind(this), function(e) {
      // Back clicked.
      this.exitPresent();
      e.stopPropagation();
      e.preventDefault();
    }.bind(this));
  }

  if (this.rotateInstructions_) {
    if (Util.isLandscapeMode() && Util.isMobile()) {
      // In landscape mode, temporarily show the "put into Cardboard"
      // interstitial. Otherwise, do the default thing.
      this.rotateInstructions_.showTemporarily(3000, this.layer_.source.parentElement);
    } else {
      this.rotateInstructions_.update();
    }
  }

  // Listen for orientation change events in order to show interstitial.
  this.orientationHandler = this.onOrientationChange_.bind(this);
  window.addEventListener('orientationchange', this.orientationHandler);

  // Listen for present display change events in order to update distorter dimensions
  this.vrdisplaypresentchangeHandler = this.updateBounds_.bind(this);
  window.addEventListener('vrdisplaypresentchange', this.vrdisplaypresentchangeHandler);

  // Fire this event initially, to give geometry-distortion clients the chance
  // to do something custom.
  this.fireVRDisplayDeviceParamsChange_();
};

CardboardVRDisplay.prototype.endPresent_ = function() {
  if (this.distorter_) {
    this.distorter_.destroy();
    this.distorter_ = null;
  }
  if (this.cardboardUI_) {
    this.cardboardUI_.destroy();
    this.cardboardUI_ = null;
  }

  if (this.rotateInstructions_) {
    this.rotateInstructions_.hide();
  }
  this.viewerSelector_.hide();

  window.removeEventListener('orientationchange', this.orientationHandler);
  window.removeEventListener('vrdisplaypresentchange', this.vrdisplaypresentchangeHandler);
};

CardboardVRDisplay.prototype.submitFrame = function(pose) {
  if (this.distorter_) {
    this.distorter_.submitFrame();
  } else if (this.cardboardUI_ && this.layer_) {
    // Hack for predistorted: true.
    var canvas = this.layer_.source.getContext('webgl').canvas;
    if (canvas.width != this.lastWidth || canvas.height != this.lastHeight) {
      this.cardboardUI_.onResize();
    }
    this.lastWidth = canvas.width;
    this.lastHeight = canvas.height;

    // Render the Cardboard UI.
    this.cardboardUI_.render();
  }
};

CardboardVRDisplay.prototype.onOrientationChange_ = function(e) {
  // Hide the viewer selector.
  this.viewerSelector_.hide();

  // Update the rotate instructions.
  if (this.rotateInstructions_) {
    this.rotateInstructions_.update();
  }

  this.onResize_();
};

CardboardVRDisplay.prototype.onResize_ = function(e) {
  if (this.layer_) {
    var gl = this.layer_.source.getContext('webgl');
    // Size the CSS canvas.
    // Added padding on right and bottom because iPhone 5 will not
    // hide the URL bar unless content is bigger than the screen.
    // This will not be visible as long as the container element (e.g. body)
    // is set to 'overflow: hidden'.
    var cssProperties = [
      'position: absolute',
      'top: 0',
      'left: 0',
      'width: ' + Math.max(screen.width, screen.height) + 'px',
      'height: ' + Math.min(screen.height, screen.width) + 'px',
      'border: 0',
      'margin: 0',
      'padding: 0 10px 10px 0',
    ];
    gl.canvas.setAttribute('style', cssProperties.join('; ') + ';');

    Util.safariCssSizeWorkaround(gl.canvas);
  }
};

CardboardVRDisplay.prototype.onViewerChanged_ = function(viewer) {
  this.deviceInfo_.setViewer(viewer);

  if (this.distorter_) {
    // Update the distortion appropriately.
    this.distorter_.updateDeviceInfo(this.deviceInfo_);
  }

  // Fire a new event containing viewer and device parameters for clients that
  // want to implement their own geometry-based distortion.
  this.fireVRDisplayDeviceParamsChange_();
};

CardboardVRDisplay.prototype.fireVRDisplayDeviceParamsChange_ = function() {
  var event = new CustomEvent('vrdisplaydeviceparamschange', {
    detail: {
      vrdisplay: this,
      deviceInfo: this.deviceInfo_,
    }
  });
  window.dispatchEvent(event);
};

module.exports = CardboardVRDisplay;

},{"./base.js":3,"./cardboard-distorter.js":4,"./cardboard-ui.js":5,"./device-info.js":8,"./dpdb/dpdb.js":13,"./rotate-instructions.js":17,"./sensor-fusion/fusion-pose-sensor.js":19,"./util.js":23,"./viewer-selector.js":24}],7:[function(_dereq_,module,exports){
/*
Copyright (c) 2016, Brandon Jones.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

/*
Caches specified GL state, runs a callback, and restores the cached state when
done.

Example usage:

var savedState = [
  gl.ARRAY_BUFFER_BINDING,

  // TEXTURE_BINDING_2D or _CUBE_MAP must always be followed by the texure unit.
  gl.TEXTURE_BINDING_2D, gl.TEXTURE0,

  gl.CLEAR_COLOR,
];
// After this call the array buffer, texture unit 0, active texture, and clear
// color will be restored. The viewport will remain changed, however, because
// gl.VIEWPORT was not included in the savedState list.
WGLUPreserveGLState(gl, savedState, function(gl) {
  gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);

  gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
  gl.bufferData(gl.ARRAY_BUFFER, ....);

  gl.activeTexture(gl.TEXTURE0);
  gl.bindTexture(gl.TEXTURE_2D, texture);
  gl.texImage2D(gl.TEXTURE_2D, ...);

  gl.clearColor(1, 0, 0, 1);
  gl.clear(gl.COLOR_BUFFER_BIT);
});

Note that this is not intended to be fast. Managing state in your own code to
avoid redundant state setting and querying will always be faster. This function
is most useful for cases where you may not have full control over the WebGL
calls being made, such as tooling or effect injectors.
*/

function WGLUPreserveGLState(gl, bindings, callback) {
  if (!bindings) {
    callback(gl);
    return;
  }

  var boundValues = [];

  var activeTexture = null;
  for (var i = 0; i < bindings.length; ++i) {
    var binding = bindings[i];
    switch (binding) {
      case gl.TEXTURE_BINDING_2D:
      case gl.TEXTURE_BINDING_CUBE_MAP:
        var textureUnit = bindings[++i];
        if (textureUnit < gl.TEXTURE0 || textureUnit > gl.TEXTURE31) {
          console.error("TEXTURE_BINDING_2D or TEXTURE_BINDING_CUBE_MAP must be followed by a valid texture unit");
          boundValues.push(null, null);
          break;
        }
        if (!activeTexture) {
          activeTexture = gl.getParameter(gl.ACTIVE_TEXTURE);
        }
        gl.activeTexture(textureUnit);
        boundValues.push(gl.getParameter(binding), null);
        break;
      case gl.ACTIVE_TEXTURE:
        activeTexture = gl.getParameter(gl.ACTIVE_TEXTURE);
        boundValues.push(null);
        break;
      default:
        boundValues.push(gl.getParameter(binding));
        break;
    }
  }

  callback(gl);

  for (var i = 0; i < bindings.length; ++i) {
    var binding = bindings[i];
    var boundValue = boundValues[i];
    switch (binding) {
      case gl.ACTIVE_TEXTURE:
        break; // Ignore this binding, since we special-case it to happen last.
      case gl.ARRAY_BUFFER_BINDING:
        gl.bindBuffer(gl.ARRAY_BUFFER, boundValue);
        break;
      case gl.COLOR_CLEAR_VALUE:
        gl.clearColor(boundValue[0], boundValue[1], boundValue[2], boundValue[3]);
        break;
      case gl.COLOR_WRITEMASK:
        gl.colorMask(boundValue[0], boundValue[1], boundValue[2], boundValue[3]);
        break;
      case gl.CURRENT_PROGRAM:
        gl.useProgram(boundValue);
        break;
      case gl.ELEMENT_ARRAY_BUFFER_BINDING:
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, boundValue);
        break;
      case gl.FRAMEBUFFER_BINDING:
        gl.bindFramebuffer(gl.FRAMEBUFFER, boundValue);
        break;
      case gl.RENDERBUFFER_BINDING:
        gl.bindRenderbuffer(gl.RENDERBUFFER, boundValue);
        break;
      case gl.TEXTURE_BINDING_2D:
        var textureUnit = bindings[++i];
        if (textureUnit < gl.TEXTURE0 || textureUnit > gl.TEXTURE31)
          break;
        gl.activeTexture(textureUnit);
        gl.bindTexture(gl.TEXTURE_2D, boundValue);
        break;
      case gl.TEXTURE_BINDING_CUBE_MAP:
        var textureUnit = bindings[++i];
        if (textureUnit < gl.TEXTURE0 || textureUnit > gl.TEXTURE31)
          break;
        gl.activeTexture(textureUnit);
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, boundValue);
        break;
      case gl.VIEWPORT:
        gl.viewport(boundValue[0], boundValue[1], boundValue[2], boundValue[3]);
        break;
      case gl.BLEND:
      case gl.CULL_FACE:
      case gl.DEPTH_TEST:
      case gl.SCISSOR_TEST:
      case gl.STENCIL_TEST:
        if (boundValue) {
          gl.enable(binding);
        } else {
          gl.disable(binding);
        }
        break;
      default:
        console.log("No GL restore behavior for 0x" + binding.toString(16));
        break;
    }

    if (activeTexture) {
      gl.activeTexture(activeTexture);
    }
  }
}

module.exports = WGLUPreserveGLState;
},{}],8:[function(_dereq_,module,exports){
/*
 * Copyright 2015 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Distortion = _dereq_('./distortion/distortion.js');
var MathUtil = _dereq_('./math-util.js');
var Util = _dereq_('./util.js');

function Device(params) {
  this.width = params.width || Util.getScreenWidth();
  this.height = params.height || Util.getScreenHeight();
  this.widthMeters = params.widthMeters;
  this.heightMeters = params.heightMeters;
  this.bevelMeters = params.bevelMeters;
}


// Fallback Android device (based on Nexus 5 measurements) for use when
// we can't recognize an Android device.
var DEFAULT_ANDROID = new Device({
  widthMeters: 0.110,
  heightMeters: 0.062,
  bevelMeters: 0.004
});

// Fallback iOS device (based on iPhone6) for use when
// we can't recognize an Android device.
var DEFAULT_IOS = new Device({
  widthMeters: 0.1038,
  heightMeters: 0.0584,
  bevelMeters: 0.004
});


var Viewers = {
  CardboardV1: new CardboardViewer({
    id: 'CardboardV1',
    label: 'Cardboard I/O 2014',
    fov: 40,
    interLensDistance: 0.060,
    baselineLensDistance: 0.035,
    screenLensDistance: 0.042,
    distortionCoefficients: [0.441, 0.156],
    inverseCoefficients: [-0.4410035, 0.42756155, -0.4804439, 0.5460139,
      -0.58821183, 0.5733938, -0.48303202, 0.33299083, -0.17573841,
      0.0651772, -0.01488963, 0.001559834]
  }),
  CardboardV2: new CardboardViewer({
    id: 'CardboardV2',
    label: 'Cardboard I/O 2015',
    fov: 60,
    interLensDistance: 0.064,
    baselineLensDistance: 0.035,
    screenLensDistance: 0.039,
    distortionCoefficients: [0.34, 0.55],
    inverseCoefficients: [-0.33836704, -0.18162185, 0.862655, -1.2462051,
      1.0560602, -0.58208317, 0.21609078, -0.05444823, 0.009177956,
      -9.904169E-4, 6.183535E-5, -1.6981803E-6]
  })
};


var DEFAULT_LEFT_CENTER = {x: 0.5, y: 0.5};
var DEFAULT_RIGHT_CENTER = {x: 0.5, y: 0.5};

/**
 * Manages information about the device and the viewer.
 *
 * deviceParams indicates the parameters of the device to use (generally
 * obtained from dpdb.getDeviceParams()). Can be null to mean no device
 * params were found.
 */
function DeviceInfo(deviceParams) {
  this.viewer = Viewers.CardboardV2;
  this.updateDeviceParams(deviceParams);
  this.distortion = new Distortion(this.viewer.distortionCoefficients);
}

DeviceInfo.prototype.updateDeviceParams = function(deviceParams) {
  this.device = this.determineDevice_(deviceParams) || this.device;
};

DeviceInfo.prototype.getDevice = function() {
  return this.device;
};

DeviceInfo.prototype.setViewer = function(viewer) {
  this.viewer = viewer;
  this.distortion = new Distortion(this.viewer.distortionCoefficients);
};

DeviceInfo.prototype.determineDevice_ = function(deviceParams) {
  if (!deviceParams) {
    // No parameters, so use a default.
    if (Util.isIOS()) {
      console.warn('Using fallback iOS device measurements.');
      return DEFAULT_IOS;
    } else {
      console.warn('Using fallback Android device measurements.');
      return DEFAULT_ANDROID;
    }
  }

  // Compute device screen dimensions based on deviceParams.
  var METERS_PER_INCH = 0.0254;
  var metersPerPixelX = METERS_PER_INCH / deviceParams.xdpi;
  var metersPerPixelY = METERS_PER_INCH / deviceParams.ydpi;
  var width = Util.getScreenWidth();
  var height = Util.getScreenHeight();
  return new Device({
    widthMeters: metersPerPixelX * width,
    heightMeters: metersPerPixelY * height,
    bevelMeters: deviceParams.bevelMm * 0.001,
  });
};

/**
 * Calculates field of view for the left eye.
 */
DeviceInfo.prototype.getDistortedFieldOfViewLeftEye = function() {
  var viewer = this.viewer;
  var device = this.device;
  var distortion = this.distortion;

  // Device.height and device.width for device in portrait mode, so transpose.
  var eyeToScreenDistance = viewer.screenLensDistance;

  var outerDist = (device.widthMeters - viewer.interLensDistance) / 2;
  var innerDist = viewer.interLensDistance / 2;
  var bottomDist = viewer.baselineLensDistance - device.bevelMeters;
  var topDist = device.heightMeters - bottomDist;

  var outerAngle = MathUtil.radToDeg * Math.atan(
      distortion.distort(outerDist / eyeToScreenDistance));
  var innerAngle = MathUtil.radToDeg * Math.atan(
      distortion.distort(innerDist / eyeToScreenDistance));
  var bottomAngle = MathUtil.radToDeg * Math.atan(
      distortion.distort(bottomDist / eyeToScreenDistance));
  var topAngle = MathUtil.radToDeg * Math.atan(
      distortion.distort(topDist / eyeToScreenDistance));

  return {
    leftDegrees: Math.min(outerAngle, viewer.fov),
    rightDegrees: Math.min(innerAngle, viewer.fov),
    downDegrees: Math.min(bottomAngle, viewer.fov),
    upDegrees: Math.min(topAngle, viewer.fov)
  };
};

/**
 * Calculates the tan-angles from the maximum FOV for the left eye for the
 * current device and screen parameters.
 */
DeviceInfo.prototype.getLeftEyeVisibleTanAngles = function() {
  var viewer = this.viewer;
  var device = this.device;
  var distortion = this.distortion;

  // Tan-angles from the max FOV.
  var fovLeft = Math.tan(-MathUtil.degToRad * viewer.fov);
  var fovTop = Math.tan(MathUtil.degToRad * viewer.fov);
  var fovRight = Math.tan(MathUtil.degToRad * viewer.fov);
  var fovBottom = Math.tan(-MathUtil.degToRad * viewer.fov);
  // Viewport size.
  var halfWidth = device.widthMeters / 4;
  var halfHeight = device.heightMeters / 2;
  // Viewport center, measured from left lens position.
  var verticalLensOffset = (viewer.baselineLensDistance - device.bevelMeters - halfHeight);
  var centerX = viewer.interLensDistance / 2 - halfWidth;
  var centerY = -verticalLensOffset;
  var centerZ = viewer.screenLensDistance;
  // Tan-angles of the viewport edges, as seen through the lens.
  var screenLeft = distortion.distort((centerX - halfWidth) / centerZ);
  var screenTop = distortion.distort((centerY + halfHeight) / centerZ);
  var screenRight = distortion.distort((centerX + halfWidth) / centerZ);
  var screenBottom = distortion.distort((centerY - halfHeight) / centerZ);
  // Compare the two sets of tan-angles and take the value closer to zero on each side.
  var result = new Float32Array(4);
  result[0] = Math.max(fovLeft, screenLeft);
  result[1] = Math.min(fovTop, screenTop);
  result[2] = Math.min(fovRight, screenRight);
  result[3] = Math.max(fovBottom, screenBottom);
  return result;
};

/**
 * Calculates the tan-angles from the maximum FOV for the left eye for the
 * current device and screen parameters, assuming no lenses.
 */
DeviceInfo.prototype.getLeftEyeNoLensTanAngles = function() {
  var viewer = this.viewer;
  var device = this.device;
  var distortion = this.distortion;

  var result = new Float32Array(4);
  // Tan-angles from the max FOV.
  var fovLeft = distortion.distortInverse(Math.tan(-MathUtil.degToRad * viewer.fov));
  var fovTop = distortion.distortInverse(Math.tan(MathUtil.degToRad * viewer.fov));
  var fovRight = distortion.distortInverse(Math.tan(MathUtil.degToRad * viewer.fov));
  var fovBottom = distortion.distortInverse(Math.tan(-MathUtil.degToRad * viewer.fov));
  // Viewport size.
  var halfWidth = device.widthMeters / 4;
  var halfHeight = device.heightMeters / 2;
  // Viewport center, measured from left lens position.
  var verticalLensOffset = (viewer.baselineLensDistance - device.bevelMeters - halfHeight);
  var centerX = viewer.interLensDistance / 2 - halfWidth;
  var centerY = -verticalLensOffset;
  var centerZ = viewer.screenLensDistance;
  // Tan-angles of the viewport edges, as seen through the lens.
  var screenLeft = (centerX - halfWidth) / centerZ;
  var screenTop = (centerY + halfHeight) / centerZ;
  var screenRight = (centerX + halfWidth) / centerZ;
  var screenBottom = (centerY - halfHeight) / centerZ;
  // Compare the two sets of tan-angles and take the value closer to zero on each side.
  result[0] = Math.max(fovLeft, screenLeft);
  result[1] = Math.min(fovTop, screenTop);
  result[2] = Math.min(fovRight, screenRight);
  result[3] = Math.max(fovBottom, screenBottom);
  return result;
};

/**
 * Calculates the screen rectangle visible from the left eye for the
 * current device and screen parameters.
 */
DeviceInfo.prototype.getLeftEyeVisibleScreenRect = function(undistortedFrustum) {
  var viewer = this.viewer;
  var device = this.device;

  var dist = viewer.screenLensDistance;
  var eyeX = (device.widthMeters - viewer.interLensDistance) / 2;
  var eyeY = viewer.baselineLensDistance - device.bevelMeters;
  var left = (undistortedFrustum[0] * dist + eyeX) / device.widthMeters;
  var top = (undistortedFrustum[1] * dist + eyeY) / device.heightMeters;
  var right = (undistortedFrustum[2] * dist + eyeX) / device.widthMeters;
  var bottom = (undistortedFrustum[3] * dist + eyeY) / device.heightMeters;
  return {
    x: left,
    y: bottom,
    width: right - left,
    height: top - bottom
  };
};

DeviceInfo.prototype.getFieldOfViewLeftEye = function(opt_isUndistorted) {
  return opt_isUndistorted ? this.getUndistortedFieldOfViewLeftEye() :
      this.getDistortedFieldOfViewLeftEye();
};

DeviceInfo.prototype.getFieldOfViewRightEye = function(opt_isUndistorted) {
  var fov = this.getFieldOfViewLeftEye(opt_isUndistorted);
  return {
    leftDegrees: fov.rightDegrees,
    rightDegrees: fov.leftDegrees,
    upDegrees: fov.upDegrees,
    downDegrees: fov.downDegrees
  };
};

/**
 * Calculates undistorted field of view for the left eye.
 */
DeviceInfo.prototype.getUndistortedFieldOfViewLeftEye = function() {
  var p = this.getUndistortedParams_();

  return {
    leftDegrees: MathUtil.radToDeg * Math.atan(p.outerDist),
    rightDegrees: MathUtil.radToDeg * Math.atan(p.innerDist),
    downDegrees: MathUtil.radToDeg * Math.atan(p.bottomDist),
    upDegrees: MathUtil.radToDeg * Math.atan(p.topDist)
  };
};

DeviceInfo.prototype.getUndistortedViewportLeftEye = function() {
  var p = this.getUndistortedParams_();
  var viewer = this.viewer;
  var device = this.device;

  // Distances stored in local variables are in tan-angle units unless otherwise
  // noted.
  var eyeToScreenDistance = viewer.screenLensDistance;
  var screenWidth = device.widthMeters / eyeToScreenDistance;
  var screenHeight = device.heightMeters / eyeToScreenDistance;
  var xPxPerTanAngle = device.width / screenWidth;
  var yPxPerTanAngle = device.height / screenHeight;

  var x = Math.round((p.eyePosX - p.outerDist) * xPxPerTanAngle);
  var y = Math.round((p.eyePosY - p.bottomDist) * yPxPerTanAngle);
  return {
    x: x,
    y: y,
    width: Math.round((p.eyePosX + p.innerDist) * xPxPerTanAngle) - x,
    height: Math.round((p.eyePosY + p.topDist) * yPxPerTanAngle) - y
  };
};

DeviceInfo.prototype.getUndistortedParams_ = function() {
  var viewer = this.viewer;
  var device = this.device;
  var distortion = this.distortion;

  // Most of these variables in tan-angle units.
  var eyeToScreenDistance = viewer.screenLensDistance;
  var halfLensDistance = viewer.interLensDistance / 2 / eyeToScreenDistance;
  var screenWidth = device.widthMeters / eyeToScreenDistance;
  var screenHeight = device.heightMeters / eyeToScreenDistance;

  var eyePosX = screenWidth / 2 - halfLensDistance;
  var eyePosY = (viewer.baselineLensDistance - device.bevelMeters) / eyeToScreenDistance;

  var maxFov = viewer.fov;
  var viewerMax = distortion.distortInverse(Math.tan(MathUtil.degToRad * maxFov));
  var outerDist = Math.min(eyePosX, viewerMax);
  var innerDist = Math.min(halfLensDistance, viewerMax);
  var bottomDist = Math.min(eyePosY, viewerMax);
  var topDist = Math.min(screenHeight - eyePosY, viewerMax);

  return {
    outerDist: outerDist,
    innerDist: innerDist,
    topDist: topDist,
    bottomDist: bottomDist,
    eyePosX: eyePosX,
    eyePosY: eyePosY
  };
};


function CardboardViewer(params) {
  // A machine readable ID.
  this.id = params.id;
  // A human readable label.
  this.label = params.label;

  // Field of view in degrees (per side).
  this.fov = params.fov;

  // Distance between lens centers in meters.
  this.interLensDistance = params.interLensDistance;
  // Distance between viewer baseline and lens center in meters.
  this.baselineLensDistance = params.baselineLensDistance;
  // Screen-to-lens distance in meters.
  this.screenLensDistance = params.screenLensDistance;

  // Distortion coefficients.
  this.distortionCoefficients = params.distortionCoefficients;
  // Inverse distortion coefficients.
  // TODO: Calculate these from distortionCoefficients in the future.
  this.inverseCoefficients = params.inverseCoefficients;
}

// Export viewer information.
DeviceInfo.Viewers = Viewers;
module.exports = DeviceInfo;

},{"./distortion/distortion.js":10,"./math-util.js":15,"./util.js":23}],9:[function(_dereq_,module,exports){
/*
 * Copyright 2016 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var VRDisplay = _dereq_('./base.js').VRDisplay;
var HMDVRDevice = _dereq_('./base.js').HMDVRDevice;
var PositionSensorVRDevice = _dereq_('./base.js').PositionSensorVRDevice;

/**
 * Wraps a VRDisplay and exposes it as a HMDVRDevice
 */
function VRDisplayHMDDevice(display) {
  this.display = display;

  this.hardwareUnitId = display.displayId;
  this.deviceId = 'webvr-polyfill:HMD:' + display.displayId;
  this.deviceName = display.displayName + ' (HMD)';
}
VRDisplayHMDDevice.prototype = new HMDVRDevice();

VRDisplayHMDDevice.prototype.getEyeParameters = function(whichEye) {
  var eyeParameters = this.display.getEyeParameters(whichEye);

  return {
    currentFieldOfView: eyeParameters.fieldOfView,
    maximumFieldOfView: eyeParameters.fieldOfView,
    minimumFieldOfView: eyeParameters.fieldOfView,
    recommendedFieldOfView: eyeParameters.fieldOfView,
    eyeTranslation: { x: eyeParameters.offset[0], y: eyeParameters.offset[1], z: eyeParameters.offset[2] },
    renderRect: {
      x: (whichEye == 'right') ? eyeParameters.renderWidth : 0,
      y: 0,
      width: eyeParameters.renderWidth,
      height: eyeParameters.renderHeight
    }
  };
};

VRDisplayHMDDevice.prototype.setFieldOfView =
    function(opt_fovLeft, opt_fovRight, opt_zNear, opt_zFar) {
  // Not supported. getEyeParameters reports that the min, max, and recommended
  // FoV is all the same, so no adjustment can be made.
};

// TODO: Need to hook requestFullscreen to see if a wrapped VRDisplay was passed
// in as an option. If so we should prevent the default fullscreen behavior and
// call VRDisplay.requestPresent instead.

/**
 * Wraps a VRDisplay and exposes it as a PositionSensorVRDevice
 */
function VRDisplayPositionSensorDevice(display) {
  this.display = display;

  this.hardwareUnitId = display.displayId;
  this.deviceId = 'webvr-polyfill:PositionSensor: ' + display.displayId;
  this.deviceName = display.displayName + ' (PositionSensor)';
}
VRDisplayPositionSensorDevice.prototype = new PositionSensorVRDevice();

VRDisplayPositionSensorDevice.prototype.getState = function() {
  var pose = this.display.getPose();
  return {
    position: pose.position ? { x: pose.position[0], y: pose.position[1], z: pose.position[2] } : null,
    orientation: pose.orientation ? { x: pose.orientation[0], y: pose.orientation[1], z: pose.orientation[2], w: pose.orientation[3] } : null,
    linearVelocity: null,
    linearAcceleration: null,
    angularVelocity: null,
    angularAcceleration: null
  };
};

VRDisplayPositionSensorDevice.prototype.resetState = function() {
  return this.positionDevice.resetPose();
};


module.exports.VRDisplayHMDDevice = VRDisplayHMDDevice;
module.exports.VRDisplayPositionSensorDevice = VRDisplayPositionSensorDevice;


},{"./base.js":3}],10:[function(_dereq_,module,exports){
/**
 * TODO(smus): Implement coefficient inversion.
 */
function Distortion(coefficients) {
  this.coefficients = coefficients;
}

/**
 * Calculates the inverse distortion for a radius.
 * </p><p>
 * Allows to compute the original undistorted radius from a distorted one.
 * See also getApproximateInverseDistortion() for a faster but potentially
 * less accurate method.
 *
 * @param {Number} radius Distorted radius from the lens center in tan-angle units.
 * @return {Number} The undistorted radius in tan-angle units.
 */
Distortion.prototype.distortInverse = function(radius) {
  // Secant method.
  var r0 = 0;
  var r1 = 1;
  var dr0 = radius - this.distort(r0);
  while (Math.abs(r1 - r0) > 0.0001 /** 0.1mm */) {
    var dr1 = radius - this.distort(r1);
    var r2 = r1 - dr1 * ((r1 - r0) / (dr1 - dr0));
    r0 = r1;
    r1 = r2;
    dr0 = dr1;
  }
  return r1;
};

/**
 * Distorts a radius by its distortion factor from the center of the lenses.
 *
 * @param {Number} radius Radius from the lens center in tan-angle units.
 * @return {Number} The distorted radius in tan-angle units.
 */
Distortion.prototype.distort = function(radius) {
  var r2 = radius * radius;
  var ret = 0;
  for (var i = 0; i < this.coefficients.length; i++) {
    ret = r2 * (ret + this.coefficients[i]);
  }
  return (ret + 1) * radius;
};

// Functions below roughly ported from
// https://github.com/googlesamples/cardboard-unity/blob/master/Cardboard/Scripts/CardboardProfile.cs#L412

// Solves a small linear equation via destructive gaussian
// elimination and back substitution.  This isn't generic numeric
// code, it's just a quick hack to work with the generally
// well-behaved symmetric matrices for least-squares fitting.
// Not intended for reuse.
//
// @param a Input positive definite symmetrical matrix. Destroyed
//     during calculation.
// @param y Input right-hand-side values. Destroyed during calculation.
// @return Resulting x value vector.
//
Distortion.prototype.solveLinear_ = function(a, y) {
  var n = a.length;

  // Gaussian elimination (no row exchange) to triangular matrix.
  // The input matrix is a A^T A product which should be a positive
  // definite symmetrical matrix, and if I remember my linear
  // algebra right this implies that the pivots will be nonzero and
  // calculations sufficiently accurate without needing row
  // exchange.
  for (var j = 0; j < n - 1; ++j) {
    for (var k = j + 1; k < n; ++k) {
      var p = a[j][k] / a[j][j];
      for (var i = j + 1; i < n; ++i) {
        a[i][k] -= p * a[i][j];
      }
      y[k] -= p * y[j];
    }
  }
  // From this point on, only the matrix elements a[j][i] with i>=j are
  // valid. The elimination doesn't fill in eliminated 0 values.

  var x = new Array(n);

  // Back substitution.
  for (var j = n - 1; j >= 0; --j) {
    var v = y[j];
    for (var i = j + 1; i < n; ++i) {
      v -= a[i][j] * x[i];
    }
    x[j] = v / a[j][j];
  }

  return x;
};

// Solves a least-squares matrix equation.  Given the equation A * x = y, calculate the
// least-square fit x = inverse(A * transpose(A)) * transpose(A) * y.  The way this works
// is that, while A is typically not a square matrix (and hence not invertible), A * transpose(A)
// is always square.  That is:
//   A * x = y
//   transpose(A) * (A * x) = transpose(A) * y   <- multiply both sides by transpose(A)
//   (transpose(A) * A) * x = transpose(A) * y   <- associativity
//   x = inverse(transpose(A) * A) * transpose(A) * y  <- solve for x
// Matrix A's row count (first index) must match y's value count.  A's column count (second index)
// determines the length of the result vector x.
Distortion.prototype.solveLeastSquares_ = function(matA, vecY) {
  var i, j, k, sum;
  var numSamples = matA.length;
  var numCoefficients = matA[0].length;
  if (numSamples != vecY.Length) {
    throw new Error("Matrix / vector dimension mismatch");
  }

  // Calculate transpose(A) * A
  var matATA = new Array(numCoefficients);
  for (k = 0; k < numCoefficients; ++k) {
    matATA[k] = new Array(numCoefficients);
    for (j = 0; j < numCoefficients; ++j) {
      sum = 0;
      for (i = 0; i < numSamples; ++i) {
        sum += matA[j][i] * matA[k][i];
      }
      matATA[k][j] = sum;
    }
  }

  // Calculate transpose(A) * y
  var vecATY = new Array(numCoefficients);
  for (j = 0; j < numCoefficients; ++j) {
    sum = 0;
    for (i = 0; i < numSamples; ++i) {
      sum += matA[j][i] * vecY[i];
    }
    vecATY[j] = sum;
  }

  // Now solve (A * transpose(A)) * x = transpose(A) * y.
  return this.solveLinear_(matATA, vecATY);
};

/// Calculates an approximate inverse to the given radial distortion parameters.
Distortion.prototype.approximateInverse = function(maxRadius, numSamples) {
  maxRadius = maxRadius || 1;
  numSamples = numSamples || 100;
  var numCoefficients = 6;
  var i, j;

  // R + K1*R^3 + K2*R^5 = r, with R = rp = distort(r)
  // Repeating for numSamples:
  //   [ R0^3, R0^5 ] * [ K1 ] = [ r0 - R0 ]
  //   [ R1^3, R1^5 ]   [ K2 ]   [ r1 - R1 ]
  //   [ R2^3, R2^5 ]            [ r2 - R2 ]
  //   [ etc... ]                [ etc... ]
  // That is:
  //   matA * [K1, K2] = y
  // Solve:
  //   [K1, K2] = inverse(transpose(matA) * matA) * transpose(matA) * y
  var matA = new Array(numCoefficients);
  for (j = 0; j < numCoefficients; ++j) {
    matA[j] = new Array(numSamples);
  }
  var vecY = new Array(numSamples);

  for (i = 0; i < numSamples; ++i) {
    var r = maxRadius * (i + 1) / numSamples;
    var rp = this.distort(r);
    var v = rp;
    for (j = 0; j < numCoefficients; ++j) {
      v *= rp * rp;
      matA[j][i] = v;
    }
    vecY[i] = r - rp;
  }

  var inverseCoefficients = this.solveLeastSquares_(matA, vecY);

  return new Distortion(inverseCoefficients);
};

module.exports = Distortion;

},{}],11:[function(_dereq_,module,exports){
/*
 * Copyright 2015 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * DPDB cache.
 */
var DPDB_CACHE = {
  "format": 1,
  "last_updated": "2016-01-20T00:18:35Z",
  "devices": [

  {
    "type": "android",
    "rules": [
      { "mdmh": "asus/*/Nexus 7/*" },
      { "ua": "Nexus 7" }
    ],
    "dpi": [ 320.8, 323.0 ],
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "asus/*/ASUS_Z00AD/*" },
      { "ua": "ASUS_Z00AD" }
    ],
    "dpi": [ 403.0, 404.6 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "Google//Pixel XL/" },
      { "ua": "Pixel XL" }
    ],
    "dpi": [537.9, 533],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "HTC/*/HTC6435LVW/*" },
      { "ua": "HTC6435LVW" }
    ],
    "dpi": [ 449.7, 443.3 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "HTC/*/HTC One XL/*" },
      { "ua": "HTC One XL" }
    ],
    "dpi": [ 315.3, 314.6 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "htc/*/Nexus 9/*" },
      { "ua": "Nexus 9" }
    ],
    "dpi": 289.0,
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "HTC/*/HTC One M9/*" },
      { "ua": "HTC One M9" }
    ],
    "dpi": [ 442.5, 443.3 ],
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "HTC/*/HTC One_M8/*" },
      { "ua": "HTC One_M8" }
    ],
    "dpi": [ 449.7, 447.4 ],
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "HTC/*/HTC One/*" },
      { "ua": "HTC One" }
    ],
    "dpi": 472.8,
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "Huawei/*/Nexus 6P/*" },
      { "ua": "Nexus 6P" }
    ],
    "dpi": [ 515.1, 518.0 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "LGE/*/Nexus 5X/*" },
      { "ua": "Nexus 5X" }
    ],
    "dpi": [ 422.0, 419.9 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "LGE/*/LGMS345/*" },
      { "ua": "LGMS345" }
    ],
    "dpi": [ 221.7, 219.1 ],
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "LGE/*/LG-D800/*" },
      { "ua": "LG-D800" }
    ],
    "dpi": [ 422.0, 424.1 ],
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "LGE/*/LG-D850/*" },
      { "ua": "LG-D850" }
    ],
    "dpi": [ 537.9, 541.9 ],
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "LGE/*/VS985 4G/*" },
      { "ua": "VS985 4G" }
    ],
    "dpi": [ 537.9, 535.6 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "LGE/*/Nexus 5/*" },
      { "ua": "Nexus 5 " }
    ],
    "dpi": [ 442.4, 444.8 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "LGE/*/Nexus 4/*" },
      { "ua": "Nexus 4" }
    ],
    "dpi": [ 319.8, 318.4 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "LGE/*/LG-P769/*" },
      { "ua": "LG-P769" }
    ],
    "dpi": [ 240.6, 247.5 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "LGE/*/LGMS323/*" },
      { "ua": "LGMS323" }
    ],
    "dpi": [ 206.6, 204.6 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "LGE/*/LGLS996/*" },
      { "ua": "LGLS996" }
    ],
    "dpi": [ 403.4, 401.5 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "Micromax/*/4560MMX/*" },
      { "ua": "4560MMX" }
    ],
    "dpi": [ 240.0, 219.4 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "Micromax/*/A250/*" },
      { "ua": "Micromax A250" }
    ],
    "dpi": [ 480.0, 446.4 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "Micromax/*/Micromax AQ4501/*" },
      { "ua": "Micromax AQ4501" }
    ],
    "dpi": 240.0,
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "motorola/*/DROID RAZR/*" },
      { "ua": "DROID RAZR" }
    ],
    "dpi": [ 368.1, 256.7 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "motorola/*/XT830C/*" },
      { "ua": "XT830C" }
    ],
    "dpi": [ 254.0, 255.9 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "motorola/*/XT1021/*" },
      { "ua": "XT1021" }
    ],
    "dpi": [ 254.0, 256.7 ],
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "motorola/*/XT1023/*" },
      { "ua": "XT1023" }
    ],
    "dpi": [ 254.0, 256.7 ],
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "motorola/*/XT1028/*" },
      { "ua": "XT1028" }
    ],
    "dpi": [ 326.6, 327.6 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "motorola/*/XT1034/*" },
      { "ua": "XT1034" }
    ],
    "dpi": [ 326.6, 328.4 ],
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "motorola/*/XT1053/*" },
      { "ua": "XT1053" }
    ],
    "dpi": [ 315.3, 316.1 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "motorola/*/XT1562/*" },
      { "ua": "XT1562" }
    ],
    "dpi": [ 403.4, 402.7 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "motorola/*/Nexus 6/*" },
      { "ua": "Nexus 6 " }
    ],
    "dpi": [ 494.3, 489.7 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "motorola/*/XT1063/*" },
      { "ua": "XT1063" }
    ],
    "dpi": [ 295.0, 296.6 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "motorola/*/XT1064/*" },
      { "ua": "XT1064" }
    ],
    "dpi": [ 295.0, 295.6 ],
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "motorola/*/XT1092/*" },
      { "ua": "XT1092" }
    ],
    "dpi": [ 422.0, 424.1 ],
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "motorola/*/XT1095/*" },
      { "ua": "XT1095" }
    ],
    "dpi": [ 422.0, 423.4 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "motorola/*/G4/*" },
      { "ua": "Moto G (4)" }
    ],
    "dpi": 401.0,
    "bw": 4,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "OnePlus/*/A0001/*" },
      { "ua": "A0001" }
    ],
    "dpi": [ 403.4, 401.0 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "OnePlus/*/ONE E1005/*" },
      { "ua": "ONE E1005" }
    ],
    "dpi": [ 442.4, 441.4 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "OnePlus/*/ONE A2005/*" },
      { "ua": "ONE A2005" }
    ],
    "dpi": [ 391.9, 405.4 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "OPPO/*/X909/*" },
      { "ua": "X909" }
    ],
    "dpi": [ 442.4, 444.1 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/GT-I9082/*" },
      { "ua": "GT-I9082" }
    ],
    "dpi": [ 184.7, 185.4 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SM-G360P/*" },
      { "ua": "SM-G360P" }
    ],
    "dpi": [ 196.7, 205.4 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/Nexus S/*" },
      { "ua": "Nexus S" }
    ],
    "dpi": [ 234.5, 229.8 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/GT-I9300/*" },
      { "ua": "GT-I9300" }
    ],
    "dpi": [ 304.8, 303.9 ],
    "bw": 5,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SM-T230NU/*" },
      { "ua": "SM-T230NU" }
    ],
    "dpi": 216.0,
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SGH-T399/*" },
      { "ua": "SGH-T399" }
    ],
    "dpi": [ 217.7, 231.4 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SM-N9005/*" },
      { "ua": "SM-N9005" }
    ],
    "dpi": [ 386.4, 387.0 ],
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SAMSUNG-SM-N900A/*" },
      { "ua": "SAMSUNG-SM-N900A" }
    ],
    "dpi": [ 386.4, 387.7 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/GT-I9500/*" },
      { "ua": "GT-I9500" }
    ],
    "dpi": [ 442.5, 443.3 ],
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/GT-I9505/*" },
      { "ua": "GT-I9505" }
    ],
    "dpi": 439.4,
    "bw": 4,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SM-G900F/*" },
      { "ua": "SM-G900F" }
    ],
    "dpi": [ 415.6, 431.6 ],
    "bw": 5,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SM-G900M/*" },
      { "ua": "SM-G900M" }
    ],
    "dpi": [ 415.6, 431.6 ],
    "bw": 5,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SM-G800F/*" },
      { "ua": "SM-G800F" }
    ],
    "dpi": 326.8,
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SM-G906S/*" },
      { "ua": "SM-G906S" }
    ],
    "dpi": [ 562.7, 572.4 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/GT-I9300/*" },
      { "ua": "GT-I9300" }
    ],
    "dpi": [ 306.7, 304.8 ],
    "bw": 5,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SM-T535/*" },
      { "ua": "SM-T535" }
    ],
    "dpi": [ 142.6, 136.4 ],
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SM-N920C/*" },
      { "ua": "SM-N920C" }
    ],
    "dpi": [ 515.1, 518.4 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/GT-I9300I/*" },
      { "ua": "GT-I9300I" }
    ],
    "dpi": [ 304.8, 305.8 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/GT-I9195/*" },
      { "ua": "GT-I9195" }
    ],
    "dpi": [ 249.4, 256.7 ],
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SPH-L520/*" },
      { "ua": "SPH-L520" }
    ],
    "dpi": [ 249.4, 255.9 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SAMSUNG-SGH-I717/*" },
      { "ua": "SAMSUNG-SGH-I717" }
    ],
    "dpi": 285.8,
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SPH-D710/*" },
      { "ua": "SPH-D710" }
    ],
    "dpi": [ 217.7, 204.2 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/GT-N7100/*" },
      { "ua": "GT-N7100" }
    ],
    "dpi": 265.1,
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SCH-I605/*" },
      { "ua": "SCH-I605" }
    ],
    "dpi": 265.1,
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/Galaxy Nexus/*" },
      { "ua": "Galaxy Nexus" }
    ],
    "dpi": [ 315.3, 314.2 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SM-N910H/*" },
      { "ua": "SM-N910H" }
    ],
    "dpi": [ 515.1, 518.0 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SM-N910C/*" },
      { "ua": "SM-N910C" }
    ],
    "dpi": [ 515.2, 520.2 ],
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SM-G130M/*" },
      { "ua": "SM-G130M" }
    ],
    "dpi": [ 165.9, 164.8 ],
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SM-G928I/*" },
      { "ua": "SM-G928I" }
    ],
    "dpi": [ 515.1, 518.4 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SM-G920F/*" },
      { "ua": "SM-G920F" }
    ],
    "dpi": 580.6,
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SM-G920P/*" },
      { "ua": "SM-G920P" }
    ],
    "dpi": [ 522.5, 577.0 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SM-G925F/*" },
      { "ua": "SM-G925F" }
    ],
    "dpi": 580.6,
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SM-G925V/*" },
      { "ua": "SM-G925V" }
    ],
    "dpi": [ 522.5, 576.6 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "samsung/*/SM-G935F/*" },
      { "ua": "SM-G935F" }
    ],
    "dpi": 534,
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "Sony/*/C6903/*" },
      { "ua": "C6903" }
    ],
    "dpi": [ 442.5, 443.3 ],
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "Sony/*/D6653/*" },
      { "ua": "D6653" }
    ],
    "dpi": [ 428.6, 427.6 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "Sony/*/E6653/*" },
      { "ua": "E6653" }
    ],
    "dpi": [ 428.6, 425.7 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "Sony/*/E6853/*" },
      { "ua": "E6853" }
    ],
    "dpi": [ 403.4, 401.9 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "Sony/*/SGP321/*" },
      { "ua": "SGP321" }
    ],
    "dpi": [ 224.7, 224.1 ],
    "bw": 3,
    "ac": 500
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "TCT/*/ALCATEL ONE TOUCH Fierce/*" },
      { "ua": "ALCATEL ONE TOUCH Fierce" }
    ],
    "dpi": [ 240.0, 247.5 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "THL/*/thl 5000/*" },
      { "ua": "thl 5000" }
    ],
    "dpi": [ 480.0, 443.3 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "android",
    "rules": [
      { "mdmh": "ZTE/*/ZTE Blade L2/*" },
      { "ua": "ZTE Blade L2" }
    ],
    "dpi": 240.0,
    "bw": 3,
    "ac": 500
  },

  {
    "type": "ios",
    "rules": [ { "res": [ 640, 960 ] } ],
    "dpi": [ 325.1, 328.4 ],
    "bw": 4,
    "ac": 1000
  },

  {
    "type": "ios",
    "rules": [ { "res": [ 640, 1136 ] } ],
    "dpi": [ 317.1, 320.2 ],
    "bw": 3,
    "ac": 1000
  },

  {
    "type": "ios",
    "rules": [ { "res": [ 750, 1334 ] } ],
    "dpi": 326.4,
    "bw": 4,
    "ac": 1000
  },

  {
    "type": "ios",
    "rules": [ { "res": [ 1242, 2208 ] } ],
    "dpi": [ 453.6, 458.4 ],
    "bw": 4,
    "ac": 1000
  },

  {
    "type": "ios",
    "rules": [ { "res": [ 1125, 2001 ] } ],
    "dpi": [ 410.9, 415.4 ],
    "bw": 4,
    "ac": 1000
  }
]};

module.exports = DPDB_CACHE;

},{}],12:[function(_dereq_,module,exports){
module.exports={
  "format":1,
  "last_updated":"2017-01-12T08:41:55Z",
  "devices":[
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"asus/*/Nexus 7/*"
        },
        {
          "ua":"Nexus 7"
        }
      ],
      "dpi":[
        320.8,
        323
      ],
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"asus/*/ASUS_Z00AD/*"
        },
        {
          "ua":"ASUS_Z00AD"
        }
      ],
      "dpi":[
        403,
        404.6
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type": "android",
      "rules": [
        {
          "mdmh": "Google//Pixel XL/"
        },
        {
          "ua": "Pixel XL"
        }
      ],
      "dpi": [
        537.9,
        533
      ],
      "bw": 3,
      "ac": 1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"HTC/*/HTC6435LVW/*"
        },
        {
          "ua":"HTC6435LVW"
        }
      ],
      "dpi":[
        449.7,
        443.3
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"HTC/*/HTC One XL/*"
        },
        {
          "ua":"HTC One XL"
        }
      ],
      "dpi":[
        315.3,
        314.6
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"htc/*/Nexus 9/*"
        },
        {
          "ua":"Nexus 9"
        }
      ],
      "dpi":289,
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"HTC/*/HTC One M9/*"
        },
        {
          "ua":"HTC One M9"
        }
      ],
      "dpi":[
        442.5,
        443.3
      ],
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"HTC/*/HTC One_M8/*"
        },
        {
          "ua":"HTC One_M8"
        }
      ],
      "dpi":[
        449.7,
        447.4
      ],
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"HTC/*/HTC One/*"
        },
        {
          "ua":"HTC One"
        }
      ],
      "dpi":472.8,
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"Huawei/*/Nexus 6P/*"
        },
        {
          "ua":"Nexus 6P"
        }
      ],
      "dpi":[
        515.1,
        518
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"LGE/*/Nexus 5X/*"
        },
        {
          "ua":"Nexus 5X"
        }
      ],
      "dpi":[
        422,
        419.9
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"LGE/*/LGMS345/*"
        },
        {
          "ua":"LGMS345"
        }
      ],
      "dpi":[
        221.7,
        219.1
      ],
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"LGE/*/LG-D800/*"
        },
        {
          "ua":"LG-D800"
        }
      ],
      "dpi":[
        422,
        424.1
      ],
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"LGE/*/LG-D850/*"
        },
        {
          "ua":"LG-D850"
        }
      ],
      "dpi":[
        537.9,
        541.9
      ],
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"LGE/*/VS985 4G/*"
        },
        {
          "ua":"VS985 4G"
        }
      ],
      "dpi":[
        537.9,
        535.6
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"LGE/*/Nexus 5/*"
        },
        {
          "ua":"Nexus 5 B"
        }
      ],
      "dpi":[
        442.4,
        444.8
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"LGE/*/Nexus 4/*"
        },
        {
          "ua":"Nexus 4"
        }
      ],
      "dpi":[
        319.8,
        318.4
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"LGE/*/LG-P769/*"
        },
        {
          "ua":"LG-P769"
        }
      ],
      "dpi":[
        240.6,
        247.5
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"LGE/*/LGMS323/*"
        },
        {
          "ua":"LGMS323"
        }
      ],
      "dpi":[
        206.6,
        204.6
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"LGE/*/LGLS996/*"
        },
        {
          "ua":"LGLS996"
        }
      ],
      "dpi":[
        403.4,
        401.5
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"Micromax/*/4560MMX/*"
        },
        {
          "ua":"4560MMX"
        }
      ],
      "dpi":[
        240,
        219.4
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"Micromax/*/A250/*"
        },
        {
          "ua":"Micromax A250"
        }
      ],
      "dpi":[
        480,
        446.4
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"Micromax/*/Micromax AQ4501/*"
        },
        {
          "ua":"Micromax AQ4501"
        }
      ],
      "dpi":240,
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"motorola/*/DROID RAZR/*"
        },
        {
          "ua":"DROID RAZR"
        }
      ],
      "dpi":[
        368.1,
        256.7
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"motorola/*/XT830C/*"
        },
        {
          "ua":"XT830C"
        }
      ],
      "dpi":[
        254,
        255.9
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"motorola/*/XT1021/*"
        },
        {
          "ua":"XT1021"
        }
      ],
      "dpi":[
        254,
        256.7
      ],
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"motorola/*/XT1023/*"
        },
        {
          "ua":"XT1023"
        }
      ],
      "dpi":[
        254,
        256.7
      ],
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"motorola/*/XT1028/*"
        },
        {
          "ua":"XT1028"
        }
      ],
      "dpi":[
        326.6,
        327.6
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"motorola/*/XT1034/*"
        },
        {
          "ua":"XT1034"
        }
      ],
      "dpi":[
        326.6,
        328.4
      ],
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"motorola/*/XT1053/*"
        },
        {
          "ua":"XT1053"
        }
      ],
      "dpi":[
        315.3,
        316.1
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"motorola/*/XT1562/*"
        },
        {
          "ua":"XT1562"
        }
      ],
      "dpi":[
        403.4,
        402.7
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"motorola/*/Nexus 6/*"
        },
        {
          "ua":"Nexus 6 B"
        }
      ],
      "dpi":[
        494.3,
        489.7
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"motorola/*/XT1063/*"
        },
        {
          "ua":"XT1063"
        }
      ],
      "dpi":[
        295,
        296.6
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"motorola/*/XT1064/*"
        },
        {
          "ua":"XT1064"
        }
      ],
      "dpi":[
        295,
        295.6
      ],
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"motorola/*/XT1092/*"
        },
        {
          "ua":"XT1092"
        }
      ],
      "dpi":[
        422,
        424.1
      ],
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"motorola/*/XT1095/*"
        },
        {
          "ua":"XT1095"
        }
      ],
      "dpi":[
        422,
        423.4
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type": "android",
      "rules": [
        {
          "mdmh": "motorola/*/G4/*"
        },
        {
          "ua": "Moto G (4)"
        }
      ],
      "dpi": 401.0,
      "bw": 4,
      "ac": 1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"OnePlus/*/A0001/*"
        },
        {
          "ua":"A0001"
        }
      ],
      "dpi":[
        403.4,
        401
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"OnePlus/*/ONE E1005/*"
        },
        {
          "ua":"ONE E1005"
        }
      ],
      "dpi":[
        442.4,
        441.4
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"OnePlus/*/ONE A2005/*"
        },
        {
          "ua":"ONE A2005"
        }
      ],
      "dpi":[
        391.9,
        405.4
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"OPPO/*/X909/*"
        },
        {
          "ua":"X909"
        }
      ],
      "dpi":[
        442.4,
        444.1
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/GT-I9082/*"
        },
        {
          "ua":"GT-I9082"
        }
      ],
      "dpi":[
        184.7,
        185.4
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SM-G360P/*"
        },
        {
          "ua":"SM-G360P"
        }
      ],
      "dpi":[
        196.7,
        205.4
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/Nexus S/*"
        },
        {
          "ua":"Nexus S"
        }
      ],
      "dpi":[
        234.5,
        229.8
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/GT-I9300/*"
        },
        {
          "ua":"GT-I9300"
        }
      ],
      "dpi":[
        304.8,
        303.9
      ],
      "bw":5,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SM-T230NU/*"
        },
        {
          "ua":"SM-T230NU"
        }
      ],
      "dpi":216,
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SGH-T399/*"
        },
        {
          "ua":"SGH-T399"
        }
      ],
      "dpi":[
        217.7,
        231.4
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SM-N9005/*"
        },
        {
          "ua":"SM-N9005"
        }
      ],
      "dpi":[
        386.4,
        387
      ],
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SAMSUNG-SM-N900A/*"
        },
        {
          "ua":"SAMSUNG-SM-N900A"
        }
      ],
      "dpi":[
        386.4,
        387.7
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/GT-I9500/*"
        },
        {
          "ua":"GT-I9500"
        }
      ],
      "dpi":[
        442.5,
        443.3
      ],
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/GT-I9505/*"
        },
        {
          "ua":"GT-I9505"
        }
      ],
      "dpi":439.4,
      "bw":4,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SM-G900F/*"
        },
        {
          "ua":"SM-G900F"
        }
      ],
      "dpi":[
        415.6,
        431.6
      ],
      "bw":5,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SM-G900M/*"
        },
        {
          "ua":"SM-G900M"
        }
      ],
      "dpi":[
        415.6,
        431.6
      ],
      "bw":5,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SM-G800F/*"
        },
        {
          "ua":"SM-G800F"
        }
      ],
      "dpi":326.8,
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SM-G906S/*"
        },
        {
          "ua":"SM-G906S"
        }
      ],
      "dpi":[
        562.7,
        572.4
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/GT-I9300/*"
        },
        {
          "ua":"GT-I9300"
        }
      ],
      "dpi":[
        306.7,
        304.8
      ],
      "bw":5,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SM-T535/*"
        },
        {
          "ua":"SM-T535"
        }
      ],
      "dpi":[
        142.6,
        136.4
      ],
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SM-N920C/*"
        },
        {
          "ua":"SM-N920C"
        }
      ],
      "dpi":[
        515.1,
        518.4
      ],
      "bw":3,
      "ac":1000
    },
    {
       "type": "android",
       "rules": [
         {
           "mdmh": "samsung/*/SM-N920W8/*"
         },
         {
           "ua": "SM-N920W8"
         }
       ],
       "dpi": [
         515.1,
         518.4
       ],
       "bw": 3,
       "ac": 1000
     },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/GT-I9300I/*"
        },
        {
          "ua":"GT-I9300I"
        }
      ],
      "dpi":[
        304.8,
        305.8
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/GT-I9195/*"
        },
        {
          "ua":"GT-I9195"
        }
      ],
      "dpi":[
        249.4,
        256.7
      ],
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SPH-L520/*"
        },
        {
          "ua":"SPH-L520"
        }
      ],
      "dpi":[
        249.4,
        255.9
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SAMSUNG-SGH-I717/*"
        },
        {
          "ua":"SAMSUNG-SGH-I717"
        }
      ],
      "dpi":285.8,
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SPH-D710/*"
        },
        {
          "ua":"SPH-D710"
        }
      ],
      "dpi":[
        217.7,
        204.2
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/GT-N7100/*"
        },
        {
          "ua":"GT-N7100"
        }
      ],
      "dpi":265.1,
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SCH-I605/*"
        },
        {
          "ua":"SCH-I605"
        }
      ],
      "dpi":265.1,
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/Galaxy Nexus/*"
        },
        {
          "ua":"Galaxy Nexus"
        }
      ],
      "dpi":[
        315.3,
        314.2
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SM-N910H/*"
        },
        {
          "ua":"SM-N910H"
        }
      ],
      "dpi":[
        515.1,
        518
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SM-N910C/*"
        },
        {
          "ua":"SM-N910C"
        }
      ],
      "dpi":[
        515.2,
        520.2
      ],
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SM-G130M/*"
        },
        {
          "ua":"SM-G130M"
        }
      ],
      "dpi":[
        165.9,
        164.8
      ],
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SM-G928I/*"
        },
        {
          "ua":"SM-G928I"
        }
      ],
      "dpi":[
        515.1,
        518.4
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SM-G920F/*"
        },
        {
          "ua":"SM-G920F"
        }
      ],
      "dpi":580.6,
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SM-G920P/*"
        },
        {
          "ua":"SM-G920P"
        }
      ],
      "dpi":[
        522.5,
        577
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SM-G925F/*"
        },
        {
          "ua":"SM-G925F"
        }
      ],
      "dpi":580.6,
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SM-G925V/*"
        },
        {
          "ua":"SM-G925V"
        }
      ],
      "dpi":[
        522.5,
        576.6
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type": "android",
      "rules": [
        {
          "mdmh": "samsung/*/SM-G930F/*"
        },
        {
          "ua": "SM-G930F"
        }
      ],
      "dpi": 576.6,
      "bw": 3,
      "ac": 1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"samsung/*/SM-G935F/*"
        },
        {
          "ua":"SM-G935F"
        }
      ],
      "dpi":533,
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"Sony/*/C6903/*"
        },
        {
          "ua":"C6903"
        }
      ],
      "dpi":[
        442.5,
        443.3
      ],
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"Sony/*/D6653/*"
        },
        {
          "ua":"D6653"
        }
      ],
      "dpi":[
        428.6,
        427.6
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"Sony/*/E6653/*"
        },
        {
          "ua":"E6653"
        }
      ],
      "dpi":[
        428.6,
        425.7
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"Sony/*/E6853/*"
        },
        {
          "ua":"E6853"
        }
      ],
      "dpi":[
        403.4,
        401.9
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"Sony/*/SGP321/*"
        },
        {
          "ua":"SGP321"
        }
      ],
      "dpi":[
        224.7,
        224.1
      ],
      "bw":3,
      "ac":500
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"TCT/*/ALCATEL ONE TOUCH Fierce/*"
        },
        {
          "ua":"ALCATEL ONE TOUCH Fierce"
        }
      ],
      "dpi":[
        240,
        247.5
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"THL/*/thl 5000/*"
        },
        {
          "ua":"thl 5000"
        }
      ],
      "dpi":[
        480,
        443.3
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"android",
      "rules":[
        {
          "mdmh":"ZTE/*/ZTE Blade L2/*"
        },
        {
          "ua":"ZTE Blade L2"
        }
      ],
      "dpi":240,
      "bw":3,
      "ac":500
    },
    {
      "type":"ios",
      "rules":[
        {
          "res":[
            640,
            960
          ]
        }
      ],
      "dpi":[
        325.1,
        328.4
      ],
      "bw":4,
      "ac":1000
    },
    {
      "type":"ios",
      "rules":[
        {
          "res":[
            640,
            1136
          ]
        }
      ],
      "dpi":[
        317.1,
        320.2
      ],
      "bw":3,
      "ac":1000
    },
    {
      "type":"ios",
      "rules":[
        {
          "res":[
            750,
            1334
          ]
        }
      ],
      "dpi":326.4,
      "bw":4,
      "ac":1000
    },
    {
      "type":"ios",
      "rules":[
        {
          "res":[
            1242,
            2208
          ]
        }
      ],
      "dpi":[
        453.6,
        458.4
      ],
      "bw":4,
      "ac":1000
    },
    {
      "type":"ios",
      "rules":[
        {
          "res":[
            1125,
            2001
          ]
        }
      ],
      "dpi":[
        410.9,
        415.4
      ],
      "bw":4,
      "ac":1000
    }
  ]
}

},{}],13:[function(_dereq_,module,exports){
/*
 * Copyright 2015 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// Offline cache of the DPDB, to be used until we load the online one (and
// as a fallback in case we can't load the online one).
var DPDB_CACHE = _dereq_('./dpdb-cache.js');
var Util = _dereq_('../util.js');

// Online DPDB URL.
var ONLINE_DPDB_URL = _dereq_('./dpdb.json');

/**
 * Calculates device parameters based on the DPDB (Device Parameter Database).
 * Initially, uses the cached DPDB values.
 *
 * If fetchOnline == true, then this object tries to fetch the online version
 * of the DPDB and updates the device info if a better match is found.
 * Calls the onDeviceParamsUpdated callback when there is an update to the
 * device information.
 */
function Dpdb(fetchOnline, onDeviceParamsUpdated) {
  // Start with the offline DPDB cache while we are loading the real one.
  this.dpdb = DPDB_CACHE;

  // Calculate device params based on the offline version of the DPDB.
  this.recalculateDeviceParams_();

  // XHR to fetch online DPDB file, if requested.
  if (fetchOnline) {
    // Set the callback.
    this.onDeviceParamsUpdated = onDeviceParamsUpdated;

    var xhr = new XMLHttpRequest();
    var obj = this;
    xhr.open('GET', ONLINE_DPDB_URL, true);
    xhr.addEventListener('load', function() {
      obj.loading = false;
      if (xhr.status >= 200 && xhr.status <= 299) {
        // Success.
        obj.dpdb = JSON.parse(xhr.response);
        obj.recalculateDeviceParams_();
      } else {
        // Error loading the DPDB.
        console.error('Error loading online DPDB!');
      }
    });
    xhr.send();
  }
}

// Returns the current device parameters.
Dpdb.prototype.getDeviceParams = function() {
  return this.deviceParams;
};

// Recalculates this device's parameters based on the DPDB.
Dpdb.prototype.recalculateDeviceParams_ = function() {
  var newDeviceParams = this.calcDeviceParams_();
  if (newDeviceParams) {
    this.deviceParams = newDeviceParams;
    // Invoke callback, if it is set.
    if (this.onDeviceParamsUpdated) {
      this.onDeviceParamsUpdated(this.deviceParams);
    }
  } else {
    console.error('Failed to recalculate device parameters.');
  }
};

// Returns a DeviceParams object that represents the best guess as to this
// device's parameters. Can return null if the device does not match any
// known devices.
Dpdb.prototype.calcDeviceParams_ = function() {
  var db = this.dpdb; // shorthand
  if (!db) {
    console.error('DPDB not available.');
    return null;
  }
  if (db.format != 1) {
    console.error('DPDB has unexpected format version.');
    return null;
  }
  if (!db.devices || !db.devices.length) {
    console.error('DPDB does not have a devices section.');
    return null;
  }

  // Get the actual user agent and screen dimensions in pixels.
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var width = Util.getScreenWidth();
  var height = Util.getScreenHeight();

  if (!db.devices) {
    console.error('DPDB has no devices section.');
    return null;
  }

  for (var i = 0; i < db.devices.length; i++) {
    var device = db.devices[i];
    if (!device.rules) {
      console.warn('Device[' + i + '] has no rules section.');
      continue;
    }

    if (device.type != 'ios' && device.type != 'android') {
      console.warn('Device[' + i + '] has invalid type.');
      continue;
    }

    // See if this device is of the appropriate type.
    if (Util.isIOS() != (device.type == 'ios')) continue;

    // See if this device matches any of the rules:
    var matched = false;
    for (var j = 0; j < device.rules.length; j++) {
      var rule = device.rules[j];
      if (this.matchRule_(rule, userAgent, width, height)) {
        matched = true;
        break;
      }
    }
    if (!matched) continue;

    // device.dpi might be an array of [ xdpi, ydpi] or just a scalar.
    var xdpi = device.dpi[0] || device.dpi;
    var ydpi = device.dpi[1] || device.dpi;

    return new DeviceParams({ xdpi: xdpi, ydpi: ydpi, bevelMm: device.bw });
  }

  console.warn('No DPDB device match.');
  return null;
};

Dpdb.prototype.matchRule_ = function(rule, ua, screenWidth, screenHeight) {
  // We can only match 'ua' and 'res' rules, not other types like 'mdmh'
  // (which are meant for native platforms).
  if (!rule.ua && !rule.res) return false;

  // If our user agent string doesn't contain the indicated user agent string,
  // the match fails.
  if (rule.ua && ua.indexOf(rule.ua) < 0) return false;

  // If the rule specifies screen dimensions that don't correspond to ours,
  // the match fails.
  if (rule.res) {
    if (!rule.res[0] || !rule.res[1]) return false;
    var resX = rule.res[0];
    var resY = rule.res[1];
    // Compare min and max so as to make the order not matter, i.e., it should
    // be true that 640x480 == 480x640.
    if (Math.min(screenWidth, screenHeight) != Math.min(resX, resY) ||
        (Math.max(screenWidth, screenHeight) != Math.max(resX, resY))) {
      return false;
    }
  }

  return true;
}

function DeviceParams(params) {
  this.xdpi = params.xdpi;
  this.ydpi = params.ydpi;
  this.bevelMm = params.bevelMm;
}

module.exports = Dpdb;

},{"../util.js":23,"./dpdb-cache.js":11,"./dpdb.json":12}],14:[function(_dereq_,module,exports){
/*
 * Copyright 2015 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Util = _dereq_('./util.js');
var WebVRPolyfill = _dereq_('./webvr-polyfill.js').WebVRPolyfill;

// Initialize a WebVRConfig just in case.
window.WebVRConfig = Util.extend({
  // Forces availability of VR mode, even for non-mobile devices.
  FORCE_ENABLE_VR: false,

  // Complementary filter coefficient. 0 for accelerometer, 1 for gyro.
  K_FILTER: 0.98,

  // How far into the future to predict during fast motion (in seconds).
  PREDICTION_TIME_S: 0.040,

  // Flag to enable touch panner. In case you have your own touch controls.
  TOUCH_PANNER_DISABLED: true,

  // Flag to disabled the UI in VR Mode.
  CARDBOARD_UI_DISABLED: false, // Default: false

  // Flag to disable the instructions to rotate your device.
  ROTATE_INSTRUCTIONS_DISABLED: false, // Default: false.

  // Enable yaw panning only, disabling roll and pitch. This can be useful
  // for panoramas with nothing interesting above or below.
  YAW_ONLY: false,

  // To disable keyboard and mouse controls, if you want to use your own
  // implementation.
  MOUSE_KEYBOARD_CONTROLS_DISABLED: false,

  // Prevent the polyfill from initializing immediately. Requires the app
  // to call InitializeWebVRPolyfill() before it can be used.
  DEFER_INITIALIZATION: false,

  // Enable the deprecated version of the API (navigator.getVRDevices).
  ENABLE_DEPRECATED_API: false,

  // Scales the recommended buffer size reported by WebVR, which can improve
  // performance.
  // UPDATE(2016-05-03): Setting this to 0.5 by default since 1.0 does not
  // perform well on many mobile devices.
  BUFFER_SCALE: 0.5,

  // Allow VRDisplay.submitFrame to change gl bindings, which is more
  // efficient if the application code will re-bind its resources on the
  // next frame anyway. This has been seen to cause rendering glitches with
  // THREE.js.
  // Dirty bindings include: gl.FRAMEBUFFER_BINDING, gl.CURRENT_PROGRAM,
  // gl.ARRAY_BUFFER_BINDING, gl.ELEMENT_ARRAY_BUFFER_BINDING,
  // and gl.TEXTURE_BINDING_2D for texture unit 0.
  DIRTY_SUBMIT_FRAME_BINDINGS: false,

  // When set to true, this will cause a polyfilled VRDisplay to always be
  // appended to the list returned by navigator.getVRDisplays(), even if that
  // list includes a native VRDisplay.
  ALWAYS_APPEND_POLYFILL_DISPLAY: false
}, window.WebVRConfig);

if (!window.WebVRConfig.DEFER_INITIALIZATION) {
  new WebVRPolyfill();
} else {
  window.InitializeWebVRPolyfill = function() {
    new WebVRPolyfill();
  }
}

},{"./util.js":23,"./webvr-polyfill.js":26}],15:[function(_dereq_,module,exports){
/*
 * Copyright 2016 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var MathUtil = window.MathUtil || {};

MathUtil.degToRad = Math.PI / 180;
MathUtil.radToDeg = 180 / Math.PI;

// Some minimal math functionality borrowed from THREE.Math and stripped down
// for the purposes of this library.


MathUtil.Vector2 = function ( x, y ) {
  this.x = x || 0;
  this.y = y || 0;
};

MathUtil.Vector2.prototype = {
  constructor: MathUtil.Vector2,

  set: function ( x, y ) {
    this.x = x;
    this.y = y;

    return this;
  },

  copy: function ( v ) {
    this.x = v.x;
    this.y = v.y;

    return this;
  },

  subVectors: function ( a, b ) {
    this.x = a.x - b.x;
    this.y = a.y - b.y;

    return this;
  },
};

MathUtil.Vector3 = function ( x, y, z ) {
  this.x = x || 0;
  this.y = y || 0;
  this.z = z || 0;
};

MathUtil.Vector3.prototype = {
  constructor: MathUtil.Vector3,

  set: function ( x, y, z ) {
    this.x = x;
    this.y = y;
    this.z = z;

    return this;
  },

  copy: function ( v ) {
    this.x = v.x;
    this.y = v.y;
    this.z = v.z;

    return this;
  },

  length: function () {
    return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z );
  },

  normalize: function () {
    var scalar = this.length();

    if ( scalar !== 0 ) {
      var invScalar = 1 / scalar;

      this.multiplyScalar(invScalar);
    } else {
      this.x = 0;
      this.y = 0;
      this.z = 0;
    }

    return this;
  },

  multiplyScalar: function ( scalar ) {
    this.x *= scalar;
    this.y *= scalar;
    this.z *= scalar;
  },

  applyQuaternion: function ( q ) {
    var x = this.x;
    var y = this.y;
    var z = this.z;

    var qx = q.x;
    var qy = q.y;
    var qz = q.z;
    var qw = q.w;

    // calculate quat * vector
    var ix =  qw * x + qy * z - qz * y;
    var iy =  qw * y + qz * x - qx * z;
    var iz =  qw * z + qx * y - qy * x;
    var iw = - qx * x - qy * y - qz * z;

    // calculate result * inverse quat
    this.x = ix * qw + iw * - qx + iy * - qz - iz * - qy;
    this.y = iy * qw + iw * - qy + iz * - qx - ix * - qz;
    this.z = iz * qw + iw * - qz + ix * - qy - iy * - qx;

    return this;
  },

  dot: function ( v ) {
    return this.x * v.x + this.y * v.y + this.z * v.z;
  },

  crossVectors: function ( a, b ) {
    var ax = a.x, ay = a.y, az = a.z;
    var bx = b.x, by = b.y, bz = b.z;

    this.x = ay * bz - az * by;
    this.y = az * bx - ax * bz;
    this.z = ax * by - ay * bx;

    return this;
  },
};

MathUtil.Quaternion = function ( x, y, z, w ) {
  this.x = x || 0;
  this.y = y || 0;
  this.z = z || 0;
  this.w = ( w !== undefined ) ? w : 1;
};

MathUtil.Quaternion.prototype = {
  constructor: MathUtil.Quaternion,

  set: function ( x, y, z, w ) {
    this.x = x;
    this.y = y;
    this.z = z;
    this.w = w;

    return this;
  },

  copy: function ( quaternion ) {
    this.x = quaternion.x;
    this.y = quaternion.y;
    this.z = quaternion.z;
    this.w = quaternion.w;

    return this;
  },

  setFromEulerXYZ: function( x, y, z ) {
    var c1 = Math.cos( x / 2 );
    var c2 = Math.cos( y / 2 );
    var c3 = Math.cos( z / 2 );
    var s1 = Math.sin( x / 2 );
    var s2 = Math.sin( y / 2 );
    var s3 = Math.sin( z / 2 );

    this.x = s1 * c2 * c3 + c1 * s2 * s3;
    this.y = c1 * s2 * c3 - s1 * c2 * s3;
    this.z = c1 * c2 * s3 + s1 * s2 * c3;
    this.w = c1 * c2 * c3 - s1 * s2 * s3;

    return this;
  },

  setFromEulerYXZ: function( x, y, z ) {
    var c1 = Math.cos( x / 2 );
    var c2 = Math.cos( y / 2 );
    var c3 = Math.cos( z / 2 );
    var s1 = Math.sin( x / 2 );
    var s2 = Math.sin( y / 2 );
    var s3 = Math.sin( z / 2 );

    this.x = s1 * c2 * c3 + c1 * s2 * s3;
    this.y = c1 * s2 * c3 - s1 * c2 * s3;
    this.z = c1 * c2 * s3 - s1 * s2 * c3;
    this.w = c1 * c2 * c3 + s1 * s2 * s3;

    return this;
  },

  setFromAxisAngle: function ( axis, angle ) {
    // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
    // assumes axis is normalized

    var halfAngle = angle / 2, s = Math.sin( halfAngle );

    this.x = axis.x * s;
    this.y = axis.y * s;
    this.z = axis.z * s;
    this.w = Math.cos( halfAngle );

    return this;
  },

  multiply: function ( q ) {
    return this.multiplyQuaternions( this, q );
  },

  multiplyQuaternions: function ( a, b ) {
    // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm

    var qax = a.x, qay = a.y, qaz = a.z, qaw = a.w;
    var qbx = b.x, qby = b.y, qbz = b.z, qbw = b.w;

    this.x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
    this.y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
    this.z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
    this.w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;

    return this;
  },

  inverse: function () {
    this.x *= -1;
    this.y *= -1;
    this.z *= -1;

    this.normalize();

    return this;
  },

  normalize: function () {
    var l = Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w );

    if ( l === 0 ) {
      this.x = 0;
      this.y = 0;
      this.z = 0;
      this.w = 1;
    } else {
      l = 1 / l;

      this.x = this.x * l;
      this.y = this.y * l;
      this.z = this.z * l;
      this.w = this.w * l;
    }

    return this;
  },

  slerp: function ( qb, t ) {
    if ( t === 0 ) return this;
    if ( t === 1 ) return this.copy( qb );

    var x = this.x, y = this.y, z = this.z, w = this.w;

    // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/

    var cosHalfTheta = w * qb.w + x * qb.x + y * qb.y + z * qb.z;

    if ( cosHalfTheta < 0 ) {
      this.w = - qb.w;
      this.x = - qb.x;
      this.y = - qb.y;
      this.z = - qb.z;

      cosHalfTheta = - cosHalfTheta;
    } else {
      this.copy( qb );
    }

    if ( cosHalfTheta >= 1.0 ) {
      this.w = w;
      this.x = x;
      this.y = y;
      this.z = z;

      return this;
    }

    var halfTheta = Math.acos( cosHalfTheta );
    var sinHalfTheta = Math.sqrt( 1.0 - cosHalfTheta * cosHalfTheta );

    if ( Math.abs( sinHalfTheta ) < 0.001 ) {
      this.w = 0.5 * ( w + this.w );
      this.x = 0.5 * ( x + this.x );
      this.y = 0.5 * ( y + this.y );
      this.z = 0.5 * ( z + this.z );

      return this;
    }

    var ratioA = Math.sin( ( 1 - t ) * halfTheta ) / sinHalfTheta,
    ratioB = Math.sin( t * halfTheta ) / sinHalfTheta;

    this.w = ( w * ratioA + this.w * ratioB );
    this.x = ( x * ratioA + this.x * ratioB );
    this.y = ( y * ratioA + this.y * ratioB );
    this.z = ( z * ratioA + this.z * ratioB );

    return this;
  },

  setFromUnitVectors: function () {
    // http://lolengine.net/blog/2014/02/24/quaternion-from-two-vectors-final
    // assumes direction vectors vFrom and vTo are normalized

    var v1, r;
    var EPS = 0.000001;

    return function ( vFrom, vTo ) {
      if ( v1 === undefined ) v1 = new MathUtil.Vector3();

      r = vFrom.dot( vTo ) + 1;

      if ( r < EPS ) {
        r = 0;

        if ( Math.abs( vFrom.x ) > Math.abs( vFrom.z ) ) {
          v1.set( - vFrom.y, vFrom.x, 0 );
        } else {
          v1.set( 0, - vFrom.z, vFrom.y );
        }
      } else {
        v1.crossVectors( vFrom, vTo );
      }

      this.x = v1.x;
      this.y = v1.y;
      this.z = v1.z;
      this.w = r;

      this.normalize();

      return this;
    }
  }(),
};

module.exports = MathUtil;

},{}],16:[function(_dereq_,module,exports){
/*
 * Copyright 2016 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var VRDisplay = _dereq_('./base.js').VRDisplay;
var MathUtil = _dereq_('./math-util.js');
var Util = _dereq_('./util.js');

// How much to rotate per key stroke.
var KEY_SPEED = 0.15;
var KEY_ANIMATION_DURATION = 80;

// How much to rotate for mouse events.
var MOUSE_SPEED_X = 0.5;
var MOUSE_SPEED_Y = 0.3;

/**
 * VRDisplay based on mouse and keyboard input. Designed for desktops/laptops
 * where orientation events aren't supported. Cannot present.
 */
function MouseKeyboardVRDisplay() {
  this.displayName = 'Mouse and Keyboard VRDisplay (webvr-polyfill)';

  this.capabilities.hasOrientation = true;

  // Attach to mouse and keyboard events.
  window.addEventListener('keydown', this.onKeyDown_.bind(this));
  window.addEventListener('mousemove', this.onMouseMove_.bind(this));
  window.addEventListener('mousedown', this.onMouseDown_.bind(this));
  window.addEventListener('mouseup', this.onMouseUp_.bind(this));

  // "Private" members.
  this.phi_ = 0;
  this.theta_ = 0;

  // Variables for keyboard-based rotation animation.
  this.targetAngle_ = null;
  this.angleAnimation_ = null;

  // State variables for calculations.
  this.orientation_ = new MathUtil.Quaternion();

  // Variables for mouse-based rotation.
  this.rotateStart_ = new MathUtil.Vector2();
  this.rotateEnd_ = new MathUtil.Vector2();
  this.rotateDelta_ = new MathUtil.Vector2();
  this.isDragging_ = false;

  this.orientationOut_ = new Float32Array(4);
}
MouseKeyboardVRDisplay.prototype = new VRDisplay();

MouseKeyboardVRDisplay.prototype.getImmediatePose = function() {
  this.orientation_.setFromEulerYXZ(this.phi_, this.theta_, 0);

  this.orientationOut_[0] = this.orientation_.x;
  this.orientationOut_[1] = this.orientation_.y;
  this.orientationOut_[2] = this.orientation_.z;
  this.orientationOut_[3] = this.orientation_.w;

  return {
    position: null,
    orientation: this.orientationOut_,
    linearVelocity: null,
    linearAcceleration: null,
    angularVelocity: null,
    angularAcceleration: null
  };
};

MouseKeyboardVRDisplay.prototype.onKeyDown_ = function(e) {
  // Track WASD and arrow keys.
  if (e.keyCode == 38) { // Up key.
    this.animatePhi_(this.phi_ + KEY_SPEED);
  } else if (e.keyCode == 39) { // Right key.
    this.animateTheta_(this.theta_ - KEY_SPEED);
  } else if (e.keyCode == 40) { // Down key.
    this.animatePhi_(this.phi_ - KEY_SPEED);
  } else if (e.keyCode == 37) { // Left key.
    this.animateTheta_(this.theta_ + KEY_SPEED);
  }
};

MouseKeyboardVRDisplay.prototype.animateTheta_ = function(targetAngle) {
  this.animateKeyTransitions_('theta_', targetAngle);
};

MouseKeyboardVRDisplay.prototype.animatePhi_ = function(targetAngle) {
  // Prevent looking too far up or down.
  targetAngle = Util.clamp(targetAngle, -Math.PI/2, Math.PI/2);
  this.animateKeyTransitions_('phi_', targetAngle);
};

/**
 * Start an animation to transition an angle from one value to another.
 */
MouseKeyboardVRDisplay.prototype.animateKeyTransitions_ = function(angleName, targetAngle) {
  // If an animation is currently running, cancel it.
  if (this.angleAnimation_) {
    cancelAnimationFrame(this.angleAnimation_);
  }
  var startAngle = this[angleName];
  var startTime = new Date();
  // Set up an interval timer to perform the animation.
  this.angleAnimation_ = requestAnimationFrame(function animate() {
    // Once we're finished the animation, we're done.
    var elapsed = new Date() - startTime;
    if (elapsed >= KEY_ANIMATION_DURATION) {
      this[angleName] = targetAngle;
      cancelAnimationFrame(this.angleAnimation_);
      return;
    }
    // loop with requestAnimationFrame
    this.angleAnimation_ = requestAnimationFrame(animate.bind(this))
    // Linearly interpolate the angle some amount.
    var percent = elapsed / KEY_ANIMATION_DURATION;
    this[angleName] = startAngle + (targetAngle - startAngle) * percent;
  }.bind(this));
};

MouseKeyboardVRDisplay.prototype.onMouseDown_ = function(e) {
  this.rotateStart_.set(e.clientX, e.clientY);
  this.isDragging_ = true;
};

// Very similar to https://gist.github.com/mrflix/8351020
MouseKeyboardVRDisplay.prototype.onMouseMove_ = function(e) {
  if (!this.isDragging_ && !this.isPointerLocked_()) {
    return;
  }
  // Support pointer lock API.
  if (this.isPointerLocked_()) {
    var movementX = e.movementX || e.mozMovementX || 0;
    var movementY = e.movementY || e.mozMovementY || 0;
    this.rotateEnd_.set(this.rotateStart_.x - movementX, this.rotateStart_.y - movementY);
  } else {
    this.rotateEnd_.set(e.clientX, e.clientY);
  }
  // Calculate how much we moved in mouse space.
  this.rotateDelta_.subVectors(this.rotateEnd_, this.rotateStart_);
  this.rotateStart_.copy(this.rotateEnd_);

  // Keep track of the cumulative euler angles.
  this.phi_ += 2 * Math.PI * this.rotateDelta_.y / screen.height * MOUSE_SPEED_Y;
  this.theta_ += 2 * Math.PI * this.rotateDelta_.x / screen.width * MOUSE_SPEED_X;

  // Prevent looking too far up or down.
  this.phi_ = Util.clamp(this.phi_, -Math.PI/2, Math.PI/2);
};

MouseKeyboardVRDisplay.prototype.onMouseUp_ = function(e) {
  this.isDragging_ = false;
};

MouseKeyboardVRDisplay.prototype.isPointerLocked_ = function() {
  var el = document.pointerLockElement || document.mozPointerLockElement ||
      document.webkitPointerLockElement;
  return el !== undefined;
};

MouseKeyboardVRDisplay.prototype.resetPose = function() {
  this.phi_ = 0;
  this.theta_ = 0;
};

module.exports = MouseKeyboardVRDisplay;

},{"./base.js":3,"./math-util.js":15,"./util.js":23}],17:[function(_dereq_,module,exports){
/*
 * Copyright 2015 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Util = _dereq_('./util.js');

function RotateInstructions() {
  this.loadIcon_();

  var overlay = document.createElement('div');
  var s = overlay.style;
  s.position = 'fixed';
  s.top = 0;
  s.right = 0;
  s.bottom = 0;
  s.left = 0;
  s.backgroundColor = 'gray';
  s.fontFamily = 'sans-serif';
  // Force this to be above the fullscreen canvas, which is at zIndex: 999999.
  s.zIndex = 1000000;

  var img = document.createElement('img');
  img.src = this.icon;
  var s = img.style;
  s.marginLeft = '25%';
  s.marginTop = '25%';
  s.width = '50%';
  overlay.appendChild(img);

  var text = document.createElement('div');
  var s = text.style;
  s.textAlign = 'center';
  s.fontSize = '16px';
  s.lineHeight = '24px';
  s.margin = '24px 25%';
  s.width = '50%';
  text.innerHTML = 'Place your phone into your Cardboard viewer.';
  overlay.appendChild(text);

  var snackbar = document.createElement('div');
  var s = snackbar.style;
  s.backgroundColor = '#CFD8DC';
  s.position = 'fixed';
  s.bottom = 0;
  s.width = '100%';
  s.height = '48px';
  s.padding = '14px 24px';
  s.boxSizing = 'border-box';
  s.color = '#656A6B';
  overlay.appendChild(snackbar);

  var snackbarText = document.createElement('div');
  snackbarText.style.float = 'left';
  snackbarText.innerHTML = 'No Cardboard viewer?';

  var snackbarButton = document.createElement('a');
  snackbarButton.href = 'https://www.google.com/get/cardboard/get-cardboard/';
  snackbarButton.innerHTML = 'get one';
  snackbarButton.target = '_blank';
  var s = snackbarButton.style;
  s.float = 'right';
  s.fontWeight = 600;
  s.textTransform = 'uppercase';
  s.borderLeft = '1px solid gray';
  s.paddingLeft = '24px';
  s.textDecoration = 'none';
  s.color = '#656A6B';

  snackbar.appendChild(snackbarText);
  snackbar.appendChild(snackbarButton);

  this.overlay = overlay;
  this.text = text;

  this.hide();
}

RotateInstructions.prototype.show = function(parent) {
  if (!parent && !this.overlay.parentElement) {
    document.body.appendChild(this.overlay);
  } else if (parent) {
    if (this.overlay.parentElement && this.overlay.parentElement != parent)
      this.overlay.parentElement.removeChild(this.overlay);

    parent.appendChild(this.overlay);
  }

  this.overlay.style.display = 'block';

  var img = this.overlay.querySelector('img');
  var s = img.style;

  if (Util.isLandscapeMode()) {
    s.width = '20%';
    s.marginLeft = '40%';
    s.marginTop = '3%';
  } else {
    s.width = '50%';
    s.marginLeft = '25%';
    s.marginTop = '25%';
  }
};

RotateInstructions.prototype.hide = function() {
  this.overlay.style.display = 'none';
};

RotateInstructions.prototype.showTemporarily = function(ms, parent) {
  this.show(parent);
  this.timer = setTimeout(this.hide.bind(this), ms);
};

RotateInstructions.prototype.disableShowTemporarily = function() {
  clearTimeout(this.timer);
};

RotateInstructions.prototype.update = function() {
  this.disableShowTemporarily();
  // In portrait VR mode, tell the user to rotate to landscape. Otherwise, hide
  // the instructions.
  if (!Util.isLandscapeMode() && Util.isMobile()) {
    this.show();
  } else {
    this.hide();
  }
};

RotateInstructions.prototype.loadIcon_ = function() {
  // Encoded asset_src/rotate-instructions.svg
  this.icon = Util.base64('image/svg+xml', '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');
};

module.exports = RotateInstructions;

},{"./util.js":23}],18:[function(_dereq_,module,exports){
/*
 * Copyright 2015 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var SensorSample = _dereq_('./sensor-sample.js');
var MathUtil = _dereq_('../math-util.js');
var Util = _dereq_('../util.js');

/**
 * An implementation of a simple complementary filter, which fuses gyroscope and
 * accelerometer data from the 'devicemotion' event.
 *
 * Accelerometer data is very noisy, but stable over the long term.
 * Gyroscope data is smooth, but tends to drift over the long term.
 *
 * This fusion is relatively simple:
 * 1. Get orientation estimates from accelerometer by applying a low-pass filter
 *    on that data.
 * 2. Get orientation estimates from gyroscope by integrating over time.
 * 3. Combine the two estimates, weighing (1) in the long term, but (2) for the
 *    short term.
 */
function ComplementaryFilter(kFilter) {
  this.kFilter = kFilter;

  // Raw sensor measurements.
  this.currentAccelMeasurement = new SensorSample();
  this.currentGyroMeasurement = new SensorSample();
  this.previousGyroMeasurement = new SensorSample();

  // Set default look direction to be in the correct direction.
  if (Util.isIOS()) {
    this.filterQ = new MathUtil.Quaternion(-1, 0, 0, 1);
  } else {
    this.filterQ = new MathUtil.Quaternion(1, 0, 0, 1);
  }
  this.previousFilterQ = new MathUtil.Quaternion();
  this.previousFilterQ.copy(this.filterQ);

  // Orientation based on the accelerometer.
  this.accelQ = new MathUtil.Quaternion();
  // Whether or not the orientation has been initialized.
  this.isOrientationInitialized = false;
  // Running estimate of gravity based on the current orientation.
  this.estimatedGravity = new MathUtil.Vector3();
  // Measured gravity based on accelerometer.
  this.measuredGravity = new MathUtil.Vector3();

  // Debug only quaternion of gyro-based orientation.
  this.gyroIntegralQ = new MathUtil.Quaternion();
}

ComplementaryFilter.prototype.addAccelMeasurement = function(vector, timestampS) {
  this.currentAccelMeasurement.set(vector, timestampS);
};

ComplementaryFilter.prototype.addGyroMeasurement = function(vector, timestampS) {
  this.currentGyroMeasurement.set(vector, timestampS);

  var deltaT = timestampS - this.previousGyroMeasurement.timestampS;
  if (Util.isTimestampDeltaValid(deltaT)) {
    this.run_();
  }

  this.previousGyroMeasurement.copy(this.currentGyroMeasurement);
};

ComplementaryFilter.prototype.run_ = function() {

  if (!this.isOrientationInitialized) {
    this.accelQ = this.accelToQuaternion_(this.currentAccelMeasurement.sample);
    this.previousFilterQ.copy(this.accelQ);
    this.isOrientationInitialized = true;
    return;
  }

  var deltaT = this.currentGyroMeasurement.timestampS -
      this.previousGyroMeasurement.timestampS;

  // Convert gyro rotation vector to a quaternion delta.
  var gyroDeltaQ = this.gyroToQuaternionDelta_(this.currentGyroMeasurement.sample, deltaT);
  this.gyroIntegralQ.multiply(gyroDeltaQ);

  // filter_1 = K * (filter_0 + gyro * dT) + (1 - K) * accel.
  this.filterQ.copy(this.previousFilterQ);
  this.filterQ.multiply(gyroDeltaQ);

  // Calculate the delta between the current estimated gravity and the real
  // gravity vector from accelerometer.
  var invFilterQ = new MathUtil.Quaternion();
  invFilterQ.copy(this.filterQ);
  invFilterQ.inverse();

  this.estimatedGravity.set(0, 0, -1);
  this.estimatedGravity.applyQuaternion(invFilterQ);
  this.estimatedGravity.normalize();

  this.measuredGravity.copy(this.currentAccelMeasurement.sample);
  this.measuredGravity.normalize();

  // Compare estimated gravity with measured gravity, get the delta quaternion
  // between the two.
  var deltaQ = new MathUtil.Quaternion();
  deltaQ.setFromUnitVectors(this.estimatedGravity, this.measuredGravity);
  deltaQ.inverse();

  if (Util.isDebug()) {
    console.log('Delta: %d deg, G_est: (%s, %s, %s), G_meas: (%s, %s, %s)',
                MathUtil.radToDeg * Util.getQuaternionAngle(deltaQ),
                (this.estimatedGravity.x).toFixed(1),
                (this.estimatedGravity.y).toFixed(1),
                (this.estimatedGravity.z).toFixed(1),
                (this.measuredGravity.x).toFixed(1),
                (this.measuredGravity.y).toFixed(1),
                (this.measuredGravity.z).toFixed(1));
  }

  // Calculate the SLERP target: current orientation plus the measured-estimated
  // quaternion delta.
  var targetQ = new MathUtil.Quaternion();
  targetQ.copy(this.filterQ);
  targetQ.multiply(deltaQ);

  // SLERP factor: 0 is pure gyro, 1 is pure accel.
  this.filterQ.slerp(targetQ, 1 - this.kFilter);

  this.previousFilterQ.copy(this.filterQ);
};

ComplementaryFilter.prototype.getOrientation = function() {
  return this.filterQ;
};

ComplementaryFilter.prototype.accelToQuaternion_ = function(accel) {
  var normAccel = new MathUtil.Vector3();
  normAccel.copy(accel);
  normAccel.normalize();
  var quat = new MathUtil.Quaternion();
  quat.setFromUnitVectors(new MathUtil.Vector3(0, 0, -1), normAccel);
  quat.inverse();
  return quat;
};

ComplementaryFilter.prototype.gyroToQuaternionDelta_ = function(gyro, dt) {
  // Extract axis and angle from the gyroscope data.
  var quat = new MathUtil.Quaternion();
  var axis = new MathUtil.Vector3();
  axis.copy(gyro);
  axis.normalize();
  quat.setFromAxisAngle(axis, gyro.length() * dt);
  return quat;
};


module.exports = ComplementaryFilter;

},{"../math-util.js":15,"../util.js":23,"./sensor-sample.js":21}],19:[function(_dereq_,module,exports){
/*
 * Copyright 2015 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ComplementaryFilter = _dereq_('./complementary-filter.js');
var PosePredictor = _dereq_('./pose-predictor.js');
var TouchPanner = _dereq_('../touch-panner.js');
var MathUtil = _dereq_('../math-util.js');
var Util = _dereq_('../util.js');

/**
 * The pose sensor, implemented using DeviceMotion APIs.
 */
function FusionPoseSensor() {
  this.deviceId = 'webvr-polyfill:fused';
  this.deviceName = 'VR Position Device (webvr-polyfill:fused)';

  this.accelerometer = new MathUtil.Vector3();
  this.gyroscope = new MathUtil.Vector3();

  this.start();

  this.filter = new ComplementaryFilter(WebVRConfig.K_FILTER);
  this.posePredictor = new PosePredictor(WebVRConfig.PREDICTION_TIME_S);
  this.touchPanner = new TouchPanner();

  this.filterToWorldQ = new MathUtil.Quaternion();

  // Set the filter to world transform, depending on OS.
  if (Util.isIOS()) {
    this.filterToWorldQ.setFromAxisAngle(new MathUtil.Vector3(1, 0, 0), Math.PI / 2);
  } else {
    this.filterToWorldQ.setFromAxisAngle(new MathUtil.Vector3(1, 0, 0), -Math.PI / 2);
  }

  this.inverseWorldToScreenQ = new MathUtil.Quaternion();
  this.worldToScreenQ = new MathUtil.Quaternion();
  this.originalPoseAdjustQ = new MathUtil.Quaternion();
  this.originalPoseAdjustQ.setFromAxisAngle(new MathUtil.Vector3(0, 0, 1),
                                           -window.orientation * Math.PI / 180);

  this.setScreenTransform_();
  // Adjust this filter for being in landscape mode.
  if (Util.isLandscapeMode()) {
    this.filterToWorldQ.multiply(this.inverseWorldToScreenQ);
  }

  // Keep track of a reset transform for resetSensor.
  this.resetQ = new MathUtil.Quaternion();

  this.isFirefoxAndroid = Util.isFirefoxAndroid();
  this.isIOS = Util.isIOS();

  this.orientationOut_ = new Float32Array(4);
}

FusionPoseSensor.prototype.getPosition = function() {
  // This PoseSensor doesn't support position
  return null;
};

FusionPoseSensor.prototype.getOrientation = function() {
  // Convert from filter space to the the same system used by the
  // deviceorientation event.
  var orientation = this.filter.getOrientation();

  // Predict orientation.
  this.predictedQ = this.posePredictor.getPrediction(orientation, this.gyroscope, this.previousTimestampS);

  // Convert to THREE coordinate system: -Z forward, Y up, X right.
  var out = new MathUtil.Quaternion();
  out.copy(this.filterToWorldQ);
  out.multiply(this.resetQ);
  if (!WebVRConfig.TOUCH_PANNER_DISABLED) {
    out.multiply(this.touchPanner.getOrientation());
  }
  out.multiply(this.predictedQ);
  out.multiply(this.worldToScreenQ);

  // Handle the yaw-only case.
  if (WebVRConfig.YAW_ONLY) {
    // Make a quaternion that only turns around the Y-axis.
    out.x = 0;
    out.z = 0;
    out.normalize();
  }

  this.orientationOut_[0] = out.x;
  this.orientationOut_[1] = out.y;
  this.orientationOut_[2] = out.z;
  this.orientationOut_[3] = out.w;
  return this.orientationOut_;
};

FusionPoseSensor.prototype.resetPose = function() {
  // Reduce to inverted yaw-only.
  this.resetQ.copy(this.filter.getOrientation());
  this.resetQ.x = 0;
  this.resetQ.y = 0;
  this.resetQ.z *= -1;
  this.resetQ.normalize();

  // Take into account extra transformations in landscape mode.
  if (Util.isLandscapeMode()) {
    this.resetQ.multiply(this.inverseWorldToScreenQ);
  }

  // Take into account original pose.
  this.resetQ.multiply(this.originalPoseAdjustQ);

  if (!WebVRConfig.TOUCH_PANNER_DISABLED) {
    this.touchPanner.resetSensor();
  }
};

FusionPoseSensor.prototype.onDeviceMotion_ = function(deviceMotion) {
  this.updateDeviceMotion_(deviceMotion);
};

FusionPoseSensor.prototype.updateDeviceMotion_ = function(deviceMotion) {
  var accGravity = deviceMotion.accelerationIncludingGravity;
  var rotRate = deviceMotion.rotationRate;
  var timestampS = deviceMotion.timeStamp / 1000;

  // Firefox Android timeStamp returns one thousandth of a millisecond.
  if (this.isFirefoxAndroid) {
    timestampS /= 1000;
  }

  var deltaS = timestampS - this.previousTimestampS;
  if (deltaS <= Util.MIN_TIMESTEP || deltaS > Util.MAX_TIMESTEP) {
    console.warn('Invalid timestamps detected. Time step between successive ' +
                 'gyroscope sensor samples is very small or not monotonic');
    this.previousTimestampS = timestampS;
    return;
  }
  this.accelerometer.set(-accGravity.x, -accGravity.y, -accGravity.z);
  this.gyroscope.set(rotRate.alpha, rotRate.beta, rotRate.gamma);

  // With iOS and Firefox Android, rotationRate is reported in degrees,
  // so we first convert to radians.
  if (this.isIOS || this.isFirefoxAndroid) {
    this.gyroscope.multiplyScalar(Math.PI / 180);
  }

  this.filter.addAccelMeasurement(this.accelerometer, timestampS);
  this.filter.addGyroMeasurement(this.gyroscope, timestampS);

  this.previousTimestampS = timestampS;
};

FusionPoseSensor.prototype.onOrientationChange_ = function(screenOrientation) {
  this.setScreenTransform_();
};

/**
 * This is only needed if we are in an cross origin iframe on iOS to work around
 * this issue: https://bugs.webkit.org/show_bug.cgi?id=152299.
 */
FusionPoseSensor.prototype.onMessage_ = function(event) {
  var message = event.data;

  // If there's no message type, ignore it.
  if (!message || !message.type) {
    return;
  }

  // Ignore all messages that aren't devicemotion.
  var type = message.type.toLowerCase();
  if (type !== 'devicemotion') {
    return;
  }

  // Update device motion.
  this.updateDeviceMotion_(message.deviceMotionEvent);
};

FusionPoseSensor.prototype.setScreenTransform_ = function() {
  this.worldToScreenQ.set(0, 0, 0, 1);
  switch (window.orientation) {
    case 0:
      break;
    case 90:
      this.worldToScreenQ.setFromAxisAngle(new MathUtil.Vector3(0, 0, 1), -Math.PI / 2);
      break;
    case -90:
      this.worldToScreenQ.setFromAxisAngle(new MathUtil.Vector3(0, 0, 1), Math.PI / 2);
      break;
    case 180:
      // TODO.
      break;
  }
  this.inverseWorldToScreenQ.copy(this.worldToScreenQ);
  this.inverseWorldToScreenQ.inverse();
};

FusionPoseSensor.prototype.start = function() {
  this.onDeviceMotionCallback_ = this.onDeviceMotion_.bind(this);
  this.onOrientationChangeCallback_ = this.onOrientationChange_.bind(this);
  this.onMessageCallback_ = this.onMessage_.bind(this);

  // Only listen for postMessages if we're in an iOS and embedded inside a cross
  // domain IFrame. In this case, the polyfill can still work if the containing
  // page sends synthetic devicemotion events. For an example of this, see
  // iframe-message-sender.js in VR View: https://goo.gl/XDtvFZ
  if (Util.isIOS() && Util.isInsideCrossDomainIFrame()) {
    window.addEventListener('message', this.onMessageCallback_);
  }
  window.addEventListener('orientationchange', this.onOrientationChangeCallback_);
  window.addEventListener('devicemotion', this.onDeviceMotionCallback_);
};

FusionPoseSensor.prototype.stop = function() {
  window.removeEventListener('devicemotion', this.onDeviceMotionCallback_);
  window.removeEventListener('orientationchange', this.onOrientationChangeCallback_);
  window.removeEventListener('message', this.onMessageCallback_);
};

module.exports = FusionPoseSensor;

},{"../math-util.js":15,"../touch-panner.js":22,"../util.js":23,"./complementary-filter.js":18,"./pose-predictor.js":20}],20:[function(_dereq_,module,exports){
/*
 * Copyright 2015 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MathUtil = _dereq_('../math-util');
var Util = _dereq_('../util');

/**
 * Given an orientation and the gyroscope data, predicts the future orientation
 * of the head. This makes rendering appear faster.
 *
 * Also see: http://msl.cs.uiuc.edu/~lavalle/papers/LavYerKatAnt14.pdf
 *
 * @param {Number} predictionTimeS time from head movement to the appearance of
 * the corresponding image.
 */
function PosePredictor(predictionTimeS) {
  this.predictionTimeS = predictionTimeS;

  // The quaternion corresponding to the previous state.
  this.previousQ = new MathUtil.Quaternion();
  // Previous time a prediction occurred.
  this.previousTimestampS = null;

  // The delta quaternion that adjusts the current pose.
  this.deltaQ = new MathUtil.Quaternion();
  // The output quaternion.
  this.outQ = new MathUtil.Quaternion();
}

PosePredictor.prototype.getPrediction = function(currentQ, gyro, timestampS) {
  if (!this.previousTimestampS) {
    this.previousQ.copy(currentQ);
    this.previousTimestampS = timestampS;
    return currentQ;
  }

  // Calculate axis and angle based on gyroscope rotation rate data.
  var axis = new MathUtil.Vector3();
  axis.copy(gyro);
  axis.normalize();

  var angularSpeed = gyro.length();

  // If we're rotating slowly, don't do prediction.
  if (angularSpeed < MathUtil.degToRad * 20) {
    if (Util.isDebug()) {
      console.log('Moving slowly, at %s deg/s: no prediction',
                  (MathUtil.radToDeg * angularSpeed).toFixed(1));
    }
    this.outQ.copy(currentQ);
    this.previousQ.copy(currentQ);
    return this.outQ;
  }

  // Get the predicted angle based on the time delta and latency.
  var deltaT = timestampS - this.previousTimestampS;
  var predictAngle = angularSpeed * this.predictionTimeS;

  this.deltaQ.setFromAxisAngle(axis, predictAngle);
  this.outQ.copy(this.previousQ);
  this.outQ.multiply(this.deltaQ);

  this.previousQ.copy(currentQ);
  this.previousTimestampS = timestampS;

  return this.outQ;
};


module.exports = PosePredictor;

},{"../math-util":15,"../util":23}],21:[function(_dereq_,module,exports){
function SensorSample(sample, timestampS) {
  this.set(sample, timestampS);
};

SensorSample.prototype.set = function(sample, timestampS) {
  this.sample = sample;
  this.timestampS = timestampS;
};

SensorSample.prototype.copy = function(sensorSample) {
  this.set(sensorSample.sample, sensorSample.timestampS);
};

module.exports = SensorSample;

},{}],22:[function(_dereq_,module,exports){
/*
 * Copyright 2015 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MathUtil = _dereq_('./math-util.js');
var Util = _dereq_('./util.js');

var ROTATE_SPEED = 0.5;
/**
 * Provides a quaternion responsible for pre-panning the scene before further
 * transformations due to device sensors.
 */
function TouchPanner() {
  window.addEventListener('touchstart', this.onTouchStart_.bind(this));
  window.addEventListener('touchmove', this.onTouchMove_.bind(this));
  window.addEventListener('touchend', this.onTouchEnd_.bind(this));

  this.isTouching = false;
  this.rotateStart = new MathUtil.Vector2();
  this.rotateEnd = new MathUtil.Vector2();
  this.rotateDelta = new MathUtil.Vector2();

  this.theta = 0;
  this.orientation = new MathUtil.Quaternion();
}

TouchPanner.prototype.getOrientation = function() {
  this.orientation.setFromEulerXYZ(0, 0, this.theta);
  return this.orientation;
};

TouchPanner.prototype.resetSensor = function() {
  this.theta = 0;
};

TouchPanner.prototype.onTouchStart_ = function(e) {
  // Only respond if there is exactly one touch.
  if (e.touches.length != 1) {
    return;
  }
  this.rotateStart.set(e.touches[0].pageX, e.touches[0].pageY);
  this.isTouching = true;
};

TouchPanner.prototype.onTouchMove_ = function(e) {
  if (!this.isTouching) {
    return;
  }
  this.rotateEnd.set(e.touches[0].pageX, e.touches[0].pageY);
  this.rotateDelta.subVectors(this.rotateEnd, this.rotateStart);
  this.rotateStart.copy(this.rotateEnd);

  // On iOS, direction is inverted.
  if (Util.isIOS()) {
    this.rotateDelta.x *= -1;
  }

  var element = document.body;
  this.theta += 2 * Math.PI * this.rotateDelta.x / element.clientWidth * ROTATE_SPEED;
};

TouchPanner.prototype.onTouchEnd_ = function(e) {
  this.isTouching = false;
};

module.exports = TouchPanner;

},{"./math-util.js":15,"./util.js":23}],23:[function(_dereq_,module,exports){
/*
 * Copyright 2015 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var objectAssign = _dereq_('object-assign');

var Util = window.Util || {};

Util.MIN_TIMESTEP = 0.001;
Util.MAX_TIMESTEP = 1;

Util.base64 = function(mimeType, base64) {
  return 'data:' + mimeType + ';base64,' + base64;
};

Util.clamp = function(value, min, max) {
  return Math.min(Math.max(min, value), max);
};

Util.lerp = function(a, b, t) {
  return a + ((b - a) * t);
};

Util.isIOS = (function() {
  var isIOS = /iPad|iPhone|iPod/.test(navigator.platform);
  return function() {
    return isIOS;
  };
})();

Util.isWebViewAndroid = (function() {
  var isWebViewAndroid = navigator.userAgent.indexOf('Version') !== -1 &&
      navigator.userAgent.indexOf('Android') !== -1 &&
      navigator.userAgent.indexOf('Chrome') !== -1;
  return function() {
    return isWebViewAndroid;
  };
})();

Util.isSafari = (function() {
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  return function() {
    return isSafari;
  };
})();

Util.isFirefoxAndroid = (function() {
  var isFirefoxAndroid = navigator.userAgent.indexOf('Firefox') !== -1 &&
      navigator.userAgent.indexOf('Android') !== -1;
  return function() {
    return isFirefoxAndroid;
  };
})();

Util.isLandscapeMode = function() {
  return (window.orientation == 90 || window.orientation == -90);
};

// Helper method to validate the time steps of sensor timestamps.
Util.isTimestampDeltaValid = function(timestampDeltaS) {
  if (isNaN(timestampDeltaS)) {
    return false;
  }
  if (timestampDeltaS <= Util.MIN_TIMESTEP) {
    return false;
  }
  if (timestampDeltaS > Util.MAX_TIMESTEP) {
    return false;
  }
  return true;
};

Util.getScreenWidth = function() {
  return Math.max(window.screen.width, window.screen.height) *
      window.devicePixelRatio;
};

Util.getScreenHeight = function() {
  return Math.min(window.screen.width, window.screen.height) *
      window.devicePixelRatio;
};

Util.requestFullscreen = function(element) {
  if (Util.isWebViewAndroid()) {
      return false;
  }
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  } else {
    return false;
  }

  return true;
};

Util.exitFullscreen = function() {

  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  } else {
    return false;
  }

  return true;
};

Util.getFullscreenElement = function() {
  return document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement;
};

Util.linkProgram = function(gl, vertexSource, fragmentSource, attribLocationMap) {
  // No error checking for brevity.
  var vertexShader = gl.createShader(gl.VERTEX_SHADER);
  gl.shaderSource(vertexShader, vertexSource);
  gl.compileShader(vertexShader);

  var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
  gl.shaderSource(fragmentShader, fragmentSource);
  gl.compileShader(fragmentShader);

  var program = gl.createProgram();
  gl.attachShader(program, vertexShader);
  gl.attachShader(program, fragmentShader);

  for (var attribName in attribLocationMap)
    gl.bindAttribLocation(program, attribLocationMap[attribName], attribName);

  gl.linkProgram(program);

  gl.deleteShader(vertexShader);
  gl.deleteShader(fragmentShader);

  return program;
};

Util.getProgramUniforms = function(gl, program) {
  var uniforms = {};
  var uniformCount = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
  var uniformName = '';
  for (var i = 0; i < uniformCount; i++) {
    var uniformInfo = gl.getActiveUniform(program, i);
    uniformName = uniformInfo.name.replace('[0]', '');
    uniforms[uniformName] = gl.getUniformLocation(program, uniformName);
  }
  return uniforms;
};

Util.orthoMatrix = function (out, left, right, bottom, top, near, far) {
  var lr = 1 / (left - right),
      bt = 1 / (bottom - top),
      nf = 1 / (near - far);
  out[0] = -2 * lr;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = -2 * bt;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 2 * nf;
  out[11] = 0;
  out[12] = (left + right) * lr;
  out[13] = (top + bottom) * bt;
  out[14] = (far + near) * nf;
  out[15] = 1;
  return out;
};

Util.isMobile = function() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

Util.extend = objectAssign;

Util.safariCssSizeWorkaround = function(canvas) {
  // TODO(smus): Remove this workaround when Safari for iOS is fixed.
  // iOS only workaround (for https://bugs.webkit.org/show_bug.cgi?id=152556).
  //
  // "To the last I grapple with thee;
  //  from hell's heart I stab at thee;
  //  for hate's sake I spit my last breath at thee."
  // -- Moby Dick, by Herman Melville
  if (Util.isIOS()) {
    var width = canvas.style.width;
    var height = canvas.style.height;
    canvas.style.width = (parseInt(width) + 1) + 'px';
    canvas.style.height = (parseInt(height)) + 'px';
    setTimeout(function() {
      canvas.style.width = width;
      canvas.style.height = height;
    }, 100);
  }

  // Debug only.
  window.Util = Util;
  window.canvas = canvas;
};

Util.isDebug = function() {
  return Util.getQueryParameter('debug');
};

Util.getQueryParameter = function(name) {
  var name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
};

Util.frameDataFromPose = (function() {
  var piOver180 = Math.PI / 180.0;
  var rad45 = Math.PI * 0.25;

  // Borrowed from glMatrix.
  function mat4_perspectiveFromFieldOfView(out, fov, near, far) {
    var upTan = Math.tan(fov ? (fov.upDegrees * piOver180) : rad45),
    downTan = Math.tan(fov ? (fov.downDegrees * piOver180) : rad45),
    leftTan = Math.tan(fov ? (fov.leftDegrees * piOver180) : rad45),
    rightTan = Math.tan(fov ? (fov.rightDegrees * piOver180) : rad45),
    xScale = 2.0 / (leftTan + rightTan),
    yScale = 2.0 / (upTan + downTan);

    out[0] = xScale;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    out[4] = 0.0;
    out[5] = yScale;
    out[6] = 0.0;
    out[7] = 0.0;
    out[8] = -((leftTan - rightTan) * xScale * 0.5);
    out[9] = ((upTan - downTan) * yScale * 0.5);
    out[10] = far / (near - far);
    out[11] = -1.0;
    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = (far * near) / (near - far);
    out[15] = 0.0;
    return out;
  }

  function mat4_fromRotationTranslation(out, q, v) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3],
        x2 = x + x,
        y2 = y + y,
        z2 = z + z,

        xx = x * x2,
        xy = x * y2,
        xz = x * z2,
        yy = y * y2,
        yz = y * z2,
        zz = z * z2,
        wx = w * x2,
        wy = w * y2,
        wz = w * z2;

    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;

    return out;
  };

  function mat4_translate(out, a, v) {
    var x = v[0], y = v[1], z = v[2],
        a00, a01, a02, a03,
        a10, a11, a12, a13,
        a20, a21, a22, a23;

    if (a === out) {
      out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
      out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
      out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
      out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
      a00 = a[0]; a01 = a[1]; a02 = a[2]; a03 = a[3];
      a10 = a[4]; a11 = a[5]; a12 = a[6]; a13 = a[7];
      a20 = a[8]; a21 = a[9]; a22 = a[10]; a23 = a[11];

      out[0] = a00; out[1] = a01; out[2] = a02; out[3] = a03;
      out[4] = a10; out[5] = a11; out[6] = a12; out[7] = a13;
      out[8] = a20; out[9] = a21; out[10] = a22; out[11] = a23;

      out[12] = a00 * x + a10 * y + a20 * z + a[12];
      out[13] = a01 * x + a11 * y + a21 * z + a[13];
      out[14] = a02 * x + a12 * y + a22 * z + a[14];
      out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }

    return out;
  };

  function mat4_invert(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
        a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
        a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
        a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15],

        b00 = a00 * a11 - a01 * a10,
        b01 = a00 * a12 - a02 * a10,
        b02 = a00 * a13 - a03 * a10,
        b03 = a01 * a12 - a02 * a11,
        b04 = a01 * a13 - a03 * a11,
        b05 = a02 * a13 - a03 * a12,
        b06 = a20 * a31 - a21 * a30,
        b07 = a20 * a32 - a22 * a30,
        b08 = a20 * a33 - a23 * a30,
        b09 = a21 * a32 - a22 * a31,
        b10 = a21 * a33 - a23 * a31,
        b11 = a22 * a33 - a23 * a32,

        // Calculate the determinant
        det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;

    if (!det) {
      return null;
    }
    det = 1.0 / det;

    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;

    return out;
  };

  var defaultOrientation = new Float32Array([0, 0, 0, 1]);
  var defaultPosition = new Float32Array([0, 0, 0]);

  function updateEyeMatrices(projection, view, pose, parameters, vrDisplay) {
    mat4_perspectiveFromFieldOfView(projection, parameters ? parameters.fieldOfView : null, vrDisplay.depthNear, vrDisplay.depthFar);

    var orientation = pose.orientation || defaultOrientation;
    var position = pose.position || defaultPosition;

    mat4_fromRotationTranslation(view, orientation, position);
    if (parameters)
      mat4_translate(view, view, parameters.offset);
    mat4_invert(view, view);
  }

  return function(frameData, pose, vrDisplay) {
    if (!frameData || !pose)
      return false;

    frameData.pose = pose;
    frameData.timestamp = pose.timestamp;

    updateEyeMatrices(
        frameData.leftProjectionMatrix, frameData.leftViewMatrix,
        pose, vrDisplay.getEyeParameters("left"), vrDisplay);
    updateEyeMatrices(
        frameData.rightProjectionMatrix, frameData.rightViewMatrix,
        pose, vrDisplay.getEyeParameters("right"), vrDisplay);

    return true;
  };
})();

Util.isInsideCrossDomainIFrame = function() {
  var isFramed = (window.self !== window.top);
  var refDomain = Util.getDomainFromUrl(document.referrer);
  var thisDomain = Util.getDomainFromUrl(window.location.href);

  return isFramed && (refDomain !== thisDomain);
};

// From http://stackoverflow.com/a/23945027.
Util.getDomainFromUrl = function(url) {
  var domain;
  // Find & remove protocol (http, ftp, etc.) and get domain.
  if (url.indexOf("://") > -1) {
    domain = url.split('/')[2];
  }
  else {
    domain = url.split('/')[0];
  }

  //find & remove port number
  domain = domain.split(':')[0];

  return domain;
}

module.exports = Util;

},{"object-assign":2}],24:[function(_dereq_,module,exports){
/*
 * Copyright 2015 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var DeviceInfo = _dereq_('./device-info.js');
var EventEmitter3 = _dereq_('eventemitter3');
var Util = _dereq_('./util.js');

var DEFAULT_VIEWER = 'CardboardV1';
var VIEWER_KEY = 'WEBVR_CARDBOARD_VIEWER';
var CLASS_NAME = 'webvr-polyfill-viewer-selector';

/**
 * Creates a viewer selector with the options specified. Supports being shown
 * and hidden. Generates events when viewer parameters change. Also supports
 * saving the currently selected index in localStorage.
 */
function ViewerSelector() {
  // Try to load the selected key from local storage. If none exists, use the
  // default key.
  try {
    this.selectedKey = localStorage.getItem(VIEWER_KEY) || DEFAULT_VIEWER;
  } catch (error) {
    console.error('Failed to load viewer profile: %s', error);
  }
  this.dialog = this.createDialog_(DeviceInfo.Viewers);
  this.root = null;
}
ViewerSelector.prototype = new EventEmitter3();

ViewerSelector.prototype.show = function(root) {
  this.root = root;

  root.appendChild(this.dialog);

  // Ensure the currently selected item is checked.
  var selected = this.dialog.querySelector('#' + this.selectedKey);
  selected.checked = true;

  // Show the UI.
  this.dialog.style.display = 'block';
};

ViewerSelector.prototype.hide = function() {
  if (this.root && this.root.contains(this.dialog)) {
    this.root.removeChild(this.dialog);
  }
  this.dialog.style.display = 'none';
};

ViewerSelector.prototype.getCurrentViewer = function() {
  return DeviceInfo.Viewers[this.selectedKey];
};

ViewerSelector.prototype.getSelectedKey_ = function() {
  var input = this.dialog.querySelector('input[name=field]:checked');
  if (input) {
    return input.id;
  }
  return null;
};

ViewerSelector.prototype.onSave_ = function() {
  this.selectedKey = this.getSelectedKey_();
  if (!this.selectedKey || !DeviceInfo.Viewers[this.selectedKey]) {
    console.error('ViewerSelector.onSave_: this should never happen!');
    return;
  }

  this.emit('change', DeviceInfo.Viewers[this.selectedKey]);

  // Attempt to save the viewer profile, but fails in private mode.
  try {
    localStorage.setItem(VIEWER_KEY, this.selectedKey);
  } catch(error) {
    console.error('Failed to save viewer profile: %s', error);
  }
  this.hide();
};

/**
 * Creates the dialog.
 */
ViewerSelector.prototype.createDialog_ = function(options) {
  var container = document.createElement('div');
  container.classList.add(CLASS_NAME);
  container.style.display = 'none';
  // Create an overlay that dims the background, and which goes away when you
  // tap it.
  var overlay = document.createElement('div');
  var s = overlay.style;
  s.position = 'fixed';
  s.left = 0;
  s.top = 0;
  s.width = '100%';
  s.height = '100%';
  s.background = 'rgba(0, 0, 0, 0.3)';
  overlay.addEventListener('click', this.hide.bind(this));

  var width = 280;
  var dialog = document.createElement('div');
  var s = dialog.style;
  s.boxSizing = 'border-box';
  s.position = 'fixed';
  s.top = '24px';
  s.left = '50%';
  s.marginLeft = (-width/2) + 'px';
  s.width = width + 'px';
  s.padding = '24px';
  s.overflow = 'hidden';
  s.background = '#fafafa';
  s.fontFamily = "'Roboto', sans-serif";
  s.boxShadow = '0px 5px 20px #666';

  dialog.appendChild(this.createH1_('Select your viewer'));
  for (var id in options) {
    dialog.appendChild(this.createChoice_(id, options[id].label));
  }
  dialog.appendChild(this.createButton_('Save', this.onSave_.bind(this)));

  container.appendChild(overlay);
  container.appendChild(dialog);

  return container;
};

ViewerSelector.prototype.createH1_ = function(name) {
  var h1 = document.createElement('h1');
  var s = h1.style;
  s.color = 'black';
  s.fontSize = '20px';
  s.fontWeight = 'bold';
  s.marginTop = 0;
  s.marginBottom = '24px';
  h1.innerHTML = name;
  return h1;
};

ViewerSelector.prototype.createChoice_ = function(id, name) {
  /*
  <div class="choice">
  <input id="v1" type="radio" name="field" value="v1">
  <label for="v1">Cardboard V1</label>
  </div>
  */
  var div = document.createElement('div');
  div.style.marginTop = '8px';
  div.style.color = 'black';

  var input = document.createElement('input');
  input.style.fontSize = '30px';
  input.setAttribute('id', id);
  input.setAttribute('type', 'radio');
  input.setAttribute('value', id);
  input.setAttribute('name', 'field');

  var label = document.createElement('label');
  label.style.marginLeft = '4px';
  label.setAttribute('for', id);
  label.innerHTML = name;

  div.appendChild(input);
  div.appendChild(label);

  return div;
};

ViewerSelector.prototype.createButton_ = function(label, onclick) {
  var button = document.createElement('button');
  button.innerHTML = label;
  var s = button.style;
  s.float = 'right';
  s.textTransform = 'uppercase';
  s.color = '#1094f7';
  s.fontSize = '14px';
  s.letterSpacing = 0;
  s.border = 0;
  s.background = 'none';
  s.marginTop = '16px';

  button.addEventListener('click', onclick);

  return button;
};

module.exports = ViewerSelector;

},{"./device-info.js":8,"./util.js":23,"eventemitter3":1}],25:[function(_dereq_,module,exports){
/*
 * Copyright 2015 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Util = _dereq_('./util.js');

/**
 * Android and iOS compatible wakelock implementation.
 *
 * Refactored thanks to dkovalev@.
 */
function AndroidWakeLock() {
  var video = document.createElement('video');

  video.addEventListener('ended', function() {
    video.play();
  });

  this.request = function() {
    if (video.paused) {
      // Base64 version of videos_src/no-sleep-120s.mp4.
      video.src = Util.base64('video/mp4', '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');
      video.play();
    }
  };

  this.release = function() {
    video.pause();
    video.src = '';
  };
}

function iOSWakeLock() {
  var timer = null;

  this.request = function() {
    if (!timer) {
      timer = setInterval(function() {
        window.location = window.location;
        setTimeout(window.stop, 0);
      }, 30000);
    }
  }

  this.release = function() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }
}


function getWakeLock() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
    return iOSWakeLock;
  } else {
    return AndroidWakeLock;
  }
}

module.exports = getWakeLock();
},{"./util.js":23}],26:[function(_dereq_,module,exports){
/*
 * Copyright 2015 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Util = _dereq_('./util.js');
var CardboardVRDisplay = _dereq_('./cardboard-vr-display.js');
var MouseKeyboardVRDisplay = _dereq_('./mouse-keyboard-vr-display.js');
// Uncomment to add positional tracking via webcam.
//var WebcamPositionSensorVRDevice = require('./webcam-position-sensor-vr-device.js');
var VRDisplay = _dereq_('./base.js').VRDisplay;
var VRFrameData = _dereq_('./base.js').VRFrameData;
var HMDVRDevice = _dereq_('./base.js').HMDVRDevice;
var PositionSensorVRDevice = _dereq_('./base.js').PositionSensorVRDevice;
var VRDisplayHMDDevice = _dereq_('./display-wrappers.js').VRDisplayHMDDevice;
var VRDisplayPositionSensorDevice = _dereq_('./display-wrappers.js').VRDisplayPositionSensorDevice;

function WebVRPolyfill() {
  this.displays = [];
  this.devices = []; // For deprecated objects
  this.devicesPopulated = false;
  this.nativeWebVRAvailable = this.isWebVRAvailable();
  this.nativeLegacyWebVRAvailable = this.isDeprecatedWebVRAvailable();
  this.nativeGetVRDisplaysFunc = this.nativeWebVRAvailable ?
                                 navigator.getVRDisplays :
                                 null;

  if (!this.nativeLegacyWebVRAvailable) {
    this.enablePolyfill();
    if (WebVRConfig.ENABLE_DEPRECATED_API) {
      this.enableDeprecatedPolyfill();
    }
  }

  // Put a shim in place to update the API to 1.1 if needed.
  InstallWebVRSpecShim();
}

WebVRPolyfill.prototype.isWebVRAvailable = function() {
  return ('getVRDisplays' in navigator);
};

WebVRPolyfill.prototype.isDeprecatedWebVRAvailable = function() {
  return ('getVRDevices' in navigator) || ('mozGetVRDevices' in navigator);
};

WebVRPolyfill.prototype.populateDevices = function() {
  if (this.devicesPopulated) {
    return;
  }

  // Initialize our virtual VR devices.
  var vrDisplay = null;

  // Add a Cardboard VRDisplay on compatible mobile devices
  if (this.isCardboardCompatible()) {
    vrDisplay = new CardboardVRDisplay();
    this.displays.push(vrDisplay);

    // For backwards compatibility
    if (WebVRConfig.ENABLE_DEPRECATED_API) {
      this.devices.push(new VRDisplayHMDDevice(vrDisplay));
      this.devices.push(new VRDisplayPositionSensorDevice(vrDisplay));
    }
  }

  // Add a Mouse and Keyboard driven VRDisplay for desktops/laptops
  if (!this.isMobile() && !WebVRConfig.MOUSE_KEYBOARD_CONTROLS_DISABLED) {
    vrDisplay = new MouseKeyboardVRDisplay();
    this.displays.push(vrDisplay);

    // For backwards compatibility
    if (WebVRConfig.ENABLE_DEPRECATED_API) {
      this.devices.push(new VRDisplayHMDDevice(vrDisplay));
      this.devices.push(new VRDisplayPositionSensorDevice(vrDisplay));
    }
  }

  // Uncomment to add positional tracking via webcam.
  //if (!this.isMobile() && WebVRConfig.ENABLE_DEPRECATED_API) {
  //  positionDevice = new WebcamPositionSensorVRDevice();
  //  this.devices.push(positionDevice);
  //}

  this.devicesPopulated = true;
};

WebVRPolyfill.prototype.enablePolyfill = function() {
  // Provide navigator.getVRDisplays.
  navigator.getVRDisplays = this.getVRDisplays.bind(this);

  // Provide the VRDisplay object.
  window.VRDisplay = VRDisplay;

  // Provide navigator.vrEnabled.
  var self = this;
  Object.defineProperty(navigator, 'vrEnabled', {
    get: function () {
      return self.isCardboardCompatible() &&
          (self.isFullScreenAvailable() || Util.isIOS());
    }
  });

  if (!'VRFrameData' in window) {
    // Provide the VRFrameData object.
    window.VRFrameData = VRFrameData;
  }
};

WebVRPolyfill.prototype.enableDeprecatedPolyfill = function() {
  // Provide navigator.getVRDevices.
  navigator.getVRDevices = this.getVRDevices.bind(this);

  // Provide the CardboardHMDVRDevice and PositionSensorVRDevice objects.
  window.HMDVRDevice = HMDVRDevice;
  window.PositionSensorVRDevice = PositionSensorVRDevice;
};

WebVRPolyfill.prototype.getVRDisplays = function() {
  this.populateDevices();
  var polyfillDisplays = this.displays;

  if (this.nativeWebVRAvailable) {
    return this.nativeGetVRDisplaysFunc.call(navigator).then(function(nativeDisplays) {
      if (WebVRConfig.ALWAYS_APPEND_POLYFILL_DISPLAY) {
        return nativeDisplays.concat(polyfillDisplays);
      } else {
        return nativeDisplays.length > 0 ? nativeDisplays : polyfillDisplays;
      }
    });
  } else {
    return new Promise(function(resolve, reject) {
      try {
        resolve(polyfillDisplays);
      } catch (e) {
        reject(e);
      }
    });
  }
};

WebVRPolyfill.prototype.getVRDevices = function() {
  console.warn('getVRDevices is deprecated. Please update your code to use getVRDisplays instead.');
  var self = this;
  return new Promise(function(resolve, reject) {
    try {
      if (!self.devicesPopulated) {
        if (self.nativeWebVRAvailable) {
          return navigator.getVRDisplays(function(displays) {
            for (var i = 0; i < displays.length; ++i) {
              self.devices.push(new VRDisplayHMDDevice(displays[i]));
              self.devices.push(new VRDisplayPositionSensorDevice(displays[i]));
            }
            self.devicesPopulated = true;
            resolve(self.devices);
          }, reject);
        }

        if (self.nativeLegacyWebVRAvailable) {
          return (navigator.getVRDDevices || navigator.mozGetVRDevices)(function(devices) {
            for (var i = 0; i < devices.length; ++i) {
              if (devices[i] instanceof HMDVRDevice) {
                self.devices.push(devices[i]);
              }
              if (devices[i] instanceof PositionSensorVRDevice) {
                self.devices.push(devices[i]);
              }
            }
            self.devicesPopulated = true;
            resolve(self.devices);
          }, reject);
        }
      }

      self.populateDevices();
      resolve(self.devices);
    } catch (e) {
      reject(e);
    }
  });
};

/**
 * Determine if a device is mobile.
 */
WebVRPolyfill.prototype.isMobile = function() {
  return /Android/i.test(navigator.userAgent) ||
      /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

WebVRPolyfill.prototype.isCardboardCompatible = function() {
  // For now, support all iOS and Android devices.
  // Also enable the WebVRConfig.FORCE_VR flag for debugging.
  return this.isMobile() || WebVRConfig.FORCE_ENABLE_VR;
};

WebVRPolyfill.prototype.isFullScreenAvailable = function() {
  return (document.fullscreenEnabled ||
          document.mozFullScreenEnabled ||
          document.webkitFullscreenEnabled ||
          false);
};

// Installs a shim that updates a WebVR 1.0 spec implementation to WebVR 1.1
function InstallWebVRSpecShim() {
  if ('VRDisplay' in window && !('VRFrameData' in window)) {
    // Provide the VRFrameData object.
    window.VRFrameData = VRFrameData;

    // A lot of Chrome builds don't have depthNear and depthFar, even
    // though they're in the WebVR 1.0 spec. Patch them in if they're not present.
    if(!('depthNear' in window.VRDisplay.prototype)) {
      window.VRDisplay.prototype.depthNear = 0.01;
    }

    if(!('depthFar' in window.VRDisplay.prototype)) {
      window.VRDisplay.prototype.depthFar = 10000.0;
    }

    window.VRDisplay.prototype.getFrameData = function(frameData) {
      return Util.frameDataFromPose(frameData, this.getPose(), this);
    }
  }
};

module.exports.WebVRPolyfill = WebVRPolyfill;

},{"./base.js":3,"./cardboard-vr-display.js":6,"./display-wrappers.js":9,"./mouse-keyboard-vr-display.js":16,"./util.js":23}]},{},[14])(14)
});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],51:[function(_dereq_,module,exports){
var newline = /\n/
var newlineChar = '\n'
var whitespace = /\s/

module.exports = function(text, opt) {
    var lines = module.exports.lines(text, opt)
    return lines.map(function(line) {
        return text.substring(line.start, line.end)
    }).join('\n')
}

module.exports.lines = function wordwrap(text, opt) {
    opt = opt||{}

    //zero width results in nothing visible
    if (opt.width === 0 && opt.mode !== 'nowrap') 
        return []

    text = text||''
    var width = typeof opt.width === 'number' ? opt.width : Number.MAX_VALUE
    var start = Math.max(0, opt.start||0)
    var end = typeof opt.end === 'number' ? opt.end : text.length
    var mode = opt.mode

    var measure = opt.measure || monospace
    if (mode === 'pre')
        return pre(measure, text, start, end, width)
    else
        return greedy(measure, text, start, end, width, mode)
}

function idxOf(text, chr, start, end) {
    var idx = text.indexOf(chr, start)
    if (idx === -1 || idx > end)
        return end
    return idx
}

function isWhitespace(chr) {
    return whitespace.test(chr)
}

function pre(measure, text, start, end, width) {
    var lines = []
    var lineStart = start
    for (var i=start; i<end && i<text.length; i++) {
        var chr = text.charAt(i)
        var isNewline = newline.test(chr)

        //If we've reached a newline, then step down a line
        //Or if we've reached the EOF
        if (isNewline || i===end-1) {
            var lineEnd = isNewline ? i : i+1
            var measured = measure(text, lineStart, lineEnd, width)
            lines.push(measured)
            
            lineStart = i+1
        }
    }
    return lines
}

function greedy(measure, text, start, end, width, mode) {
    //A greedy word wrapper based on LibGDX algorithm
    //https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/BitmapFontCache.java
    var lines = []

    var testWidth = width
    //if 'nowrap' is specified, we only wrap on newline chars
    if (mode === 'nowrap')
        testWidth = Number.MAX_VALUE

    while (start < end && start < text.length) {
        //get next newline position
        var newLine = idxOf(text, newlineChar, start, end)

        //eat whitespace at start of line
        while (start < newLine) {
            if (!isWhitespace( text.charAt(start) ))
                break
            start++
        }

        //determine visible # of glyphs for the available width
        var measured = measure(text, start, newLine, testWidth)

        var lineEnd = start + (measured.end-measured.start)
        var nextStart = lineEnd + newlineChar.length

        //if we had to cut the line before the next newline...
        if (lineEnd < newLine) {
            //find char to break on
            while (lineEnd > start) {
                if (isWhitespace(text.charAt(lineEnd)))
                    break
                lineEnd--
            }
            if (lineEnd === start) {
                if (nextStart > start + newlineChar.length) nextStart--
                lineEnd = nextStart // If no characters to break, show all.
            } else {
                nextStart = lineEnd
                //eat whitespace at end of line
                while (lineEnd > start) {
                    if (!isWhitespace(text.charAt(lineEnd - newlineChar.length)))
                        break
                    lineEnd--
                }
            }
        }
        if (lineEnd >= start) {
            var result = measure(text, start, lineEnd, testWidth)
            lines.push(result)
        }
        start = nextStart
    }
    return lines
}

//determines the visible number of glyphs within a given width
function monospace(text, start, end, width) {
    var glyphs = Math.min(width, end-start)
    return {
        start: start,
        end: start+glyphs
    }
}
},{}],52:[function(_dereq_,module,exports){
"use strict";
var window = _dereq_("global/window")
var isFunction = _dereq_("is-function")
var parseHeaders = _dereq_("parse-headers")
var xtend = _dereq_("xtend")

module.exports = createXHR
createXHR.XMLHttpRequest = window.XMLHttpRequest || noop
createXHR.XDomainRequest = "withCredentials" in (new createXHR.XMLHttpRequest()) ? createXHR.XMLHttpRequest : window.XDomainRequest

forEachArray(["get", "put", "post", "patch", "head", "delete"], function(method) {
    createXHR[method === "delete" ? "del" : method] = function(uri, options, callback) {
        options = initParams(uri, options, callback)
        options.method = method.toUpperCase()
        return _createXHR(options)
    }
})

function forEachArray(array, iterator) {
    for (var i = 0; i < array.length; i++) {
        iterator(array[i])
    }
}

function isEmpty(obj){
    for(var i in obj){
        if(obj.hasOwnProperty(i)) return false
    }
    return true
}

function initParams(uri, options, callback) {
    var params = uri

    if (isFunction(options)) {
        callback = options
        if (typeof uri === "string") {
            params = {uri:uri}
        }
    } else {
        params = xtend(options, {uri: uri})
    }

    params.callback = callback
    return params
}

function createXHR(uri, options, callback) {
    options = initParams(uri, options, callback)
    return _createXHR(options)
}

function _createXHR(options) {
    if(typeof options.callback === "undefined"){
        throw new Error("callback argument missing")
    }

    var called = false
    var callback = function cbOnce(err, response, body){
        if(!called){
            called = true
            options.callback(err, response, body)
        }
    }

    function readystatechange() {
        if (xhr.readyState === 4) {
            loadFunc()
        }
    }

    function getBody() {
        // Chrome with requestType=blob throws errors arround when even testing access to responseText
        var body = undefined

        if (xhr.response) {
            body = xhr.response
        } else {
            body = xhr.responseText || getXml(xhr)
        }

        if (isJson) {
            try {
                body = JSON.parse(body)
            } catch (e) {}
        }

        return body
    }

    function errorFunc(evt) {
        clearTimeout(timeoutTimer)
        if(!(evt instanceof Error)){
            evt = new Error("" + (evt || "Unknown XMLHttpRequest Error") )
        }
        evt.statusCode = 0
        return callback(evt, failureResponse)
    }

    // will load the data & process the response in a special response object
    function loadFunc() {
        if (aborted) return
        var status
        clearTimeout(timeoutTimer)
        if(options.useXDR && xhr.status===undefined) {
            //IE8 CORS GET successful response doesn't have a status field, but body is fine
            status = 200
        } else {
            status = (xhr.status === 1223 ? 204 : xhr.status)
        }
        var response = failureResponse
        var err = null

        if (status !== 0){
            response = {
                body: getBody(),
                statusCode: status,
                method: method,
                headers: {},
                url: uri,
                rawRequest: xhr
            }
            if(xhr.getAllResponseHeaders){ //remember xhr can in fact be XDR for CORS in IE
                response.headers = parseHeaders(xhr.getAllResponseHeaders())
            }
        } else {
            err = new Error("Internal XMLHttpRequest Error")
        }
        return callback(err, response, response.body)
    }

    var xhr = options.xhr || null

    if (!xhr) {
        if (options.cors || options.useXDR) {
            xhr = new createXHR.XDomainRequest()
        }else{
            xhr = new createXHR.XMLHttpRequest()
        }
    }

    var key
    var aborted
    var uri = xhr.url = options.uri || options.url
    var method = xhr.method = options.method || "GET"
    var body = options.body || options.data
    var headers = xhr.headers = options.headers || {}
    var sync = !!options.sync
    var isJson = false
    var timeoutTimer
    var failureResponse = {
        body: undefined,
        headers: {},
        statusCode: 0,
        method: method,
        url: uri,
        rawRequest: xhr
    }

    if ("json" in options && options.json !== false) {
        isJson = true
        headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json") //Don't override existing accept header declared by user
        if (method !== "GET" && method !== "HEAD") {
            headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json") //Don't override existing accept header declared by user
            body = JSON.stringify(options.json === true ? body : options.json)
        }
    }

    xhr.onreadystatechange = readystatechange
    xhr.onload = loadFunc
    xhr.onerror = errorFunc
    // IE9 must have onprogress be set to a unique function.
    xhr.onprogress = function () {
        // IE must die
    }
    xhr.onabort = function(){
        aborted = true;
    }
    xhr.ontimeout = errorFunc
    xhr.open(method, uri, !sync, options.username, options.password)
    //has to be after open
    if(!sync) {
        xhr.withCredentials = !!options.withCredentials
    }
    // Cannot set timeout with sync request
    // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
    // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
    if (!sync && options.timeout > 0 ) {
        timeoutTimer = setTimeout(function(){
            if (aborted) return
            aborted = true//IE9 may still call readystatechange
            xhr.abort("timeout")
            var e = new Error("XMLHttpRequest timeout")
            e.code = "ETIMEDOUT"
            errorFunc(e)
        }, options.timeout )
    }

    if (xhr.setRequestHeader) {
        for(key in headers){
            if(headers.hasOwnProperty(key)){
                xhr.setRequestHeader(key, headers[key])
            }
        }
    } else if (options.headers && !isEmpty(options.headers)) {
        throw new Error("Headers cannot be set on an XDomainRequest object")
    }

    if ("responseType" in options) {
        xhr.responseType = options.responseType
    }

    if ("beforeSend" in options &&
        typeof options.beforeSend === "function"
    ) {
        options.beforeSend(xhr)
    }

    // Microsoft Edge browser sends "undefined" when send is called with undefined value.
    // XMLHttpRequest spec says to pass null as body to indicate no body
    // See https://github.com/naugtur/xhr/issues/100.
    xhr.send(body || null)

    return xhr


}

function getXml(xhr) {
    if (xhr.responseType === "document") {
        return xhr.responseXML
    }
    var firefoxBugTakenEffect = xhr.status === 204 && xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror"
    if (xhr.responseType === "" && !firefoxBugTakenEffect) {
        return xhr.responseXML
    }

    return null
}

function noop() {}

},{"global/window":20,"is-function":24,"parse-headers":33,"xtend":54}],53:[function(_dereq_,module,exports){
module.exports = (function xmlparser() {
  //common browsers
  if (typeof window.DOMParser !== 'undefined') {
    return function(str) {
      var parser = new window.DOMParser()
      return parser.parseFromString(str, 'application/xml')
    }
  } 

  //IE8 fallback
  if (typeof window.ActiveXObject !== 'undefined'
      && new window.ActiveXObject('Microsoft.XMLDOM')) {
    return function(str) {
      var xmlDoc = new window.ActiveXObject("Microsoft.XMLDOM")
      xmlDoc.async = "false"
      xmlDoc.loadXML(str)
      return xmlDoc
    }
  }

  //last resort fallback
  return function(str) {
    var div = document.createElement('div')
    div.innerHTML = str
    return div
  }
})()
},{}],54:[function(_dereq_,module,exports){
module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}

},{}],55:[function(_dereq_,module,exports){
module.exports={
  "name": "aframe",
  "version": "0.5.0",
  "description": "A web framework for building virtual reality experiences.",
  "homepage": "https://aframe.io/",
  "main": "dist/aframe-master.js",
  "scripts": {
    "browserify": "browserify src/index.js -s 'AFRAME' -p browserify-derequire",
    "build": "mkdirp build/ && npm run browserify -- --debug -t [envify --INSPECTOR_VERSION dev] -o build/aframe.js",
    "codecov": "codecov",
    "dev": "npm run build && cross-env INSPECTOR_VERSION=dev node ./scripts/budo -t envify",
    "dist": "node scripts/updateVersionLog.js && npm run dist:min && npm run dist:max",
    "dist:max": "npm run browserify -s -- --debug | exorcist dist/aframe-master.js.map > dist/aframe-master.js",
    "dist:min": "npm run browserify -s -- --debug -p [minifyify --map aframe-master.min.js.map --output dist/aframe-master.min.js.map] -o dist/aframe-master.min.js",
    "docs": "markserv --dir docs --port 9001",
    "ghpages": "ghpages -p gh-pages/",
    "lint": "semistandard -v | snazzy",
    "precommit": "npm run lint",
    "preghpages": "npm run dist && rimraf gh-pages && mkdirp gh-pages && cp -r {.nojekyll,dist,lib,examples,index.html,style} gh-pages/. 2>/dev/null || : && git checkout dist/ && replace 'build/aframe-master.js' 'dist/aframe-master.min.js' gh-pages/ -r --silent",
    "prerelease": "npm run dist && node scripts/release.js 0.4.0 0.5.0",
    "start": "npm run dev",
    "test": "karma start ./tests/karma.conf.js",
    "test:docs": "node scripts/docsLint.js",
    "test:firefox": "karma start ./tests/karma.conf.js --browsers Firefox",
    "test:chrome": "karma start ./tests/karma.conf.js --browsers Chrome"
  },
  "repository": "aframevr/aframe",
  "license": "MIT",
  "dependencies": {
    "browserify-css": "^0.8.2",
    "debug": "^2.2.0",
    "deep-assign": "^2.0.0",
    "document-register-element": "dmarcos/document-register-element#8ccc532b7",
    "envify": "^3.4.1",
    "load-bmfont": "^1.2.3",
    "object-assign": "^4.0.1",
    "present": "0.0.6",
    "promise-polyfill": "^3.1.0",
    "style-attr": "^1.0.2",
    "three": "^0.83.0",
    "three-bmfont-text": "^2.1.0",
    "tween.js": "^15.0.0",
    "webvr-polyfill": "dmarcos/webvr-polyfill#a02a8089b"
  },
  "devDependencies": {
    "browserify": "^13.1.0",
    "browserify-derequire": "^0.9.4",
    "browserify-istanbul": "^2.0.0",
    "budo": "^9.2.0",
    "chai": "^3.5.0",
    "chai-shallow-deep-equal": "^1.4.0",
    "chalk": "^1.1.3",
    "codecov": "^1.0.1",
    "cross-env": "^3.1.3",
    "exorcist": "^0.4.0",
    "ghpages": "0.0.8",
    "git-rev": "^0.2.1",
    "glob": "^7.1.1",
    "husky": "^0.11.7",
    "istanbul": "^0.4.5",
    "karma": "^1.3.0",
    "karma-browserify": "^5.1.0",
    "karma-chai-shallow-deep-equal": "0.0.4",
    "karma-chrome-launcher": "^2.0.0",
    "karma-coverage": "^1.1.1",
    "karma-env-preprocessor": "^0.1.1",
    "karma-firefox-launcher": "^1.0.0",
    "karma-mocha": "^1.1.1",
    "karma-mocha-reporter": "^2.1.0",
    "karma-sinon-chai": "^1.2.4",
    "lolex": "^1.5.1",
    "markserv": "0.0.20",
    "minifyify": "^7.3.3",
    "mkdirp": "^0.5.1",
    "mocha": "^3.0.2",
    "mozilla-download": "^1.1.1",
    "open": "0.0.5",
    "replace": "^0.3.0",
    "rimraf": "^2.5.4",
    "semistandard": "^9.0.0",
    "sinon": "^1.17.5",
    "sinon-chai": "^2.8.0",
    "snazzy": "^5.0.0",
    "too-wordy": "ngokevin/too-wordy",
    "uglifyjs": "^2.4.10",
    "write-good": "^0.9.1"
  },
  "link": true,
  "browserify": {
    "transform": [
      "browserify-css",
      "envify"
    ]
  },
  "semistandard": {
    "ignore": [
      "build/**",
      "dist/**",
      "examples/**/shaders/*.js",
      "**/vendor/**"
    ]
  },
  "keywords": [
    "3d",
    "aframe",
    "cardboard",
    "components",
    "oculus",
    "three",
    "three.js",
    "rift",
    "vive",
    "vr",
    "web-components",
    "webvr"
  ],
  "browserify-css": {
    "minify": true
  },
  "engines": {
    "node": ">= 4.6.0",
    "npm": "^2.15.9"
  }
}

},{}],56:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../core/component').registerComponent;
var THREE = _dereq_('../lib/three');

/**
 * Blend character model component.
 * Loads a model with skeletal animation blending.
 */
module.exports.Component = registerComponent('blend-character-model', {
  schema: {type: 'asset'},

  init: function () {
    this.model = null;
  },

  update: function () {
    var self = this;
    var el = this.el;
    var src = this.data;

    if (!src) { return; }

    this.remove();
    this.model = new THREE.BlendCharacter();

    this.model.load(src, function () {
      el.setObject3D('mesh', self.model);
      el.emit('model-loaded', {format: 'blend', model: self.model});
      self.model.castShadow = true;
      self.model.receiveShadow = true;
      self.model.material.shading = THREE.FlatShading;
      self.model.geometry.computeBoundingBox();
    });
  },

  remove: function () {
    if (!this.model) { return; }
    this.el.removeObject3D('mesh');
  }
});

},{"../core/component":100,"../lib/three":146}],57:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../core/component').registerComponent;
var THREE = _dereq_('../lib/three');
var utils = _dereq_('../utils/');
var bind = utils.bind;

var checkHasPositionalTracking = utils.device.checkHasPositionalTracking;

/**
 * Camera component.
 * Pairs along with camera system to handle tracking the active camera.
 */
module.exports.Component = registerComponent('camera', {
  schema: {
    active: {default: true},
    far: {default: 10000},
    fov: {default: 80, min: 0},
    near: {default: 0.005, min: 0},
    userHeight: {default: 0, min: 0},
    zoom: {default: 1, min: 0}
  },

  /**
   * Initialize three.js camera and add it to the entity.
   * Add reference from scene to this entity as the camera.
   */
  init: function () {
    var camera;
    var el = this.el;
    var sceneEl = el.sceneEl;

    this.savedPose = null;

    // Create camera.
    camera = this.camera = new THREE.PerspectiveCamera();
    el.setObject3D('camera', camera);

    // Add listeners to save and restore camera pose if headset is present.
    this.onEnterVR = bind(this.onEnterVR, this);
    this.onExitVR = bind(this.onExitVR, this);
    sceneEl.addEventListener('enter-vr', this.onEnterVR);
    sceneEl.addEventListener('exit-vr', this.onExitVR);
  },

  /**
   * Update three.js camera.
   */
  update: function (oldData) {
    var el = this.el;
    var data = this.data;
    var camera = this.camera;
    var system = this.system;

    // Update height offset.
    this.addHeightOffset(oldData.userHeight);

    // Update properties.
    camera.aspect = data.aspect || (window.innerWidth / window.innerHeight);
    camera.far = data.far;
    camera.fov = data.fov;
    camera.near = data.near;
    camera.zoom = data.zoom;
    camera.updateProjectionMatrix();

    // Active property did not change.
    if (oldData && oldData.active === data.active) { return; }

    // If `active` property changes, or first update, handle active camera with system.
    if (data.active && system.activeCameraEl !== el) {
      // Camera enabled. Set camera to this camera.
      system.setActiveCamera(el);
    } else if (!data.active && system.activeCameraEl === el) {
      // Camera disabled. Set camera to another camera.
      system.disableActiveCamera();
    }
  },

  /**
   * Remove camera on remove (callback).
   */
  remove: function () {
    var sceneEl = this.el.sceneEl;
    this.el.removeObject3D('camera');
    sceneEl.removeEventListener('enter-vr', this.onEnterVR);
    sceneEl.removeEventListener('exit-vr', this.onExitVR);
  },

  /**
   * Save pose and remove the offset.
   */
  onEnterVR: function () {
    this.saveCameraPose();
    this.removeHeightOffset();
  },

  /**
   * Restore the pose. Do not need to re-add the offset because it was saved on entering VR.
   */
  onExitVR: function () {
    this.restoreCameraPose();
  },

  /**
   * Offsets the position of the camera to set a human scale perspective
   * This offset is not necessary when using a headset because the SDK
   * will return the real user's head height and position.
   */
  addHeightOffset: function (oldOffset) {
    var el = this.el;
    var currentPosition;
    var userHeightOffset = this.data.userHeight;

    oldOffset = oldOffset || 0;
    currentPosition = el.getAttribute('position') || {x: 0, y: 0, z: 0};
    el.setAttribute('position', {
      x: currentPosition.x,
      y: currentPosition.y - oldOffset + userHeightOffset,
      z: currentPosition.z
    });
  },

  /**
   * Remove the height offset (called when entering VR) since WebVR API gives absolute
   * position.
   */
  removeHeightOffset: function () {
    var currentPosition;
    var el = this.el;
    var hasPositionalTracking;
    var userHeightOffset = this.data.userHeight;

    // Remove the offset if there is positional tracking when entering VR.
    // Necessary for fullscreen mode with no headset.
    // Checking this.hasPositionalTracking to make the value injectable for unit tests.
    hasPositionalTracking = this.hasPositionalTracking || checkHasPositionalTracking();
    if (!userHeightOffset || !hasPositionalTracking) { return; }

    currentPosition = el.getAttribute('position') || {x: 0, y: 0, z: 0};
    el.setAttribute('position', {
      x: currentPosition.x,
      y: currentPosition.y - userHeightOffset,
      z: currentPosition.z
    });
  },

  /**
   * Save camera pose before entering VR to restore later if exiting.
   */
  saveCameraPose: function () {
    var el = this.el;
    var hasPositionalTracking = this.hasPositionalTracking || checkHasPositionalTracking();

    if (this.savedPose || !hasPositionalTracking) { return; }

    this.savedPose = {
      position: el.getAttribute('position'),
      rotation: el.getAttribute('rotation')
    };
  },

  /**
   * Reset camera pose to before entering VR.
   */
  restoreCameraPose: function () {
    var el = this.el;
    var savedPose = this.savedPose;
    var hasPositionalTracking = this.hasPositionalTracking || checkHasPositionalTracking();

    if (!savedPose || !hasPositionalTracking) { return; }

    // Reset camera orientation.
    el.setAttribute('position', savedPose.position);
    el.setAttribute('rotation', savedPose.rotation);
    this.savedPose = null;
  }
});

},{"../core/component":100,"../lib/three":146,"../utils/":167}],58:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../core/component').registerComponent;
var THREE = _dereq_('../lib/three');

module.exports.Component = registerComponent('collada-model', {
  schema: {type: 'asset'},

  init: function () {
    this.model = null;
    this.loader = new THREE.ColladaLoader();
    this.loader.options.convertUpAxis = true;
  },

  update: function () {
    var self = this;
    var el = this.el;
    var src = this.data;

    if (!src) { return; }

    this.remove();

    this.loader.load(src, function (colladaModel) {
      self.model = colladaModel.scene;
      el.setObject3D('mesh', self.model);
      el.emit('model-loaded', {format: 'collada', model: self.model});
    });
  },

  remove: function () {
    if (!this.model) { return; }
    this.el.removeObject3D('mesh');
  }
});

},{"../core/component":100,"../lib/three":146}],59:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../core/component').registerComponent;
var utils = _dereq_('../utils/');
var bind = utils.bind;

var EVENTS = {
  CLICK: 'click',
  FUSING: 'fusing',
  MOUSEENTER: 'mouseenter',
  MOUSEDOWN: 'mousedown',
  MOUSELEAVE: 'mouseleave',
  MOUSEUP: 'mouseup'
};

var STATES = {
  FUSING: 'cursor-fusing',
  HOVERING: 'cursor-hovering',
  HOVERED: 'cursor-hovered'
};

/**
 * Cursor component. Applies the raycaster component specifically for starting the raycaster
 * from the camera and pointing from camera's facing direction, and then only returning the
 * closest intersection. Cursor can be fine-tuned by setting raycaster properties.
 *
 * @member {object} fuseTimeout - Timeout to trigger fuse-click.
 * @member {Element} mouseDownEl - Entity that was last mousedowned during current click.
 * @member {object} intersection - Attributes of the current intersection event, including
 *         3D- and 2D-space coordinates. See: http://threejs.org/docs/api/core/Raycaster.html
 * @member {Element} intersectedEl - Currently-intersected entity. Used to keep track to
 *         emit events when unintersecting.
 */
module.exports.Component = registerComponent('cursor', {
  dependencies: ['raycaster'],

  schema: {
    fuse: {default: utils.device.isMobile()},
    fuseTimeout: {default: 1500, min: 0}
  },

  init: function () {
    var cursorEl = this.el;
    var canvas = cursorEl.sceneEl.canvas;
    this.fuseTimeout = undefined;
    this.mouseDownEl = null;
    this.intersection = null;
    this.intersectedEl = null;

    // Wait for canvas to load.
    if (!canvas) {
      cursorEl.sceneEl.addEventListener('render-target-loaded', bind(this.init, this));
      return;
    }

    // Attach event listeners.
    canvas.addEventListener('mousedown', bind(this.onMouseDown, this));
    canvas.addEventListener('mouseup', bind(this.onMouseUp, this));
    cursorEl.addEventListener('raycaster-intersection', bind(this.onIntersection, this));
    cursorEl.addEventListener('raycaster-intersection-cleared',
                              bind(this.onIntersectionCleared, this));
  },

  /**
   * Trigger mousedown and keep track of the mousedowned entity.
   */
  onMouseDown: function (evt) {
    this.twoWayEmit(EVENTS.MOUSEDOWN);
    this.mouseDownEl = this.intersectedEl;
  },

  /**
   * Trigger mouseup if:
   * - Not fusing (mobile has no mouse).
   * - Currently intersecting an entity.
   * - Currently-intersected entity is the same as the one when mousedown was triggered,
   *   in case user mousedowned one entity, dragged to another, and mouseupped.
   */
  onMouseUp: function (evt) {
    this.twoWayEmit(EVENTS.MOUSEUP);
    if (this.data.fuse || !this.intersectedEl ||
        this.mouseDownEl !== this.intersectedEl) { return; }
    this.twoWayEmit(EVENTS.CLICK);
  },

  /**
   * Handle intersection.
   */
  onIntersection: function (evt) {
    var self = this;
    var cursorEl = this.el;
    var data = this.data;
    var index;
    var intersectedEl;
    var intersection;

    // Select closest object, excluding the cursor.
    index = evt.detail.els[0] === cursorEl ? 1 : 0;
    intersection = evt.detail.intersections[index];
    intersectedEl = evt.detail.els[index];

    // If cursor is the only intersected object, ignore the event.
    if (!intersectedEl) { return; }

    // Already intersecting this entity.
    if (this.intersectedEl === intersectedEl) {
      this.intersection = intersection;
      return;
    }

    // Unset current intersection.
    if (this.intersectedEl) { this.clearCurrentIntersection(); }

    // Set new intersection.
    this.intersection = intersection;
    this.intersectedEl = intersectedEl;

    // Hovering.
    cursorEl.addState(STATES.HOVERING);
    intersectedEl.addState(STATES.HOVERED);
    self.twoWayEmit(EVENTS.MOUSEENTER);

    // Begin fuse if necessary.
    if (data.fuseTimeout === 0 || !data.fuse) { return; }
    cursorEl.addState(STATES.FUSING);
    this.twoWayEmit(EVENTS.FUSING);
    this.fuseTimeout = setTimeout(function fuse () {
      cursorEl.removeState(STATES.FUSING);
      self.twoWayEmit(EVENTS.CLICK);
    }, data.fuseTimeout);
  },

  /**
   * Handle intersection cleared.
   */
  onIntersectionCleared: function (evt) {
    var cursorEl = this.el;
    var intersectedEl = evt.detail.el;

    // Ignore the cursor.
    if (cursorEl === intersectedEl) { return; }

    // Ignore if the event didn't occur on the current intersection.
    if (intersectedEl !== this.intersectedEl) { return; }

    this.clearCurrentIntersection();
  },

  clearCurrentIntersection: function () {
    var cursorEl = this.el;

    // No longer hovering (or fusing).
    this.intersectedEl.removeState(STATES.HOVERED);
    cursorEl.removeState(STATES.HOVERING);
    cursorEl.removeState(STATES.FUSING);
    this.twoWayEmit(EVENTS.MOUSELEAVE);

    // Unset intersected entity (after emitting the event).
    this.intersection = null;
    this.intersectedEl = null;

    // Clear fuseTimeout.
    clearTimeout(this.fuseTimeout);
  },

  /**
   * Helper to emit on both the cursor and the intersected entity (if exists).
   */
  twoWayEmit: function (evtName) {
    var el = this.el;
    var intersectedEl = this.intersectedEl;
    var intersection = this.intersection;
    el.emit(evtName, {intersectedEl: intersectedEl, intersection: intersection});
    if (!intersectedEl) { return; }
    intersectedEl.emit(evtName, {cursorEl: el, intersection: intersection});
  }
});

},{"../core/component":100,"../utils/":167}],60:[function(_dereq_,module,exports){
var debug = _dereq_('../utils/debug');
var geometries = _dereq_('../core/geometry').geometries;
var geometryNames = _dereq_('../core/geometry').geometryNames;
var registerComponent = _dereq_('../core/component').registerComponent;
var THREE = _dereq_('../lib/three');

var dummyGeometry = new THREE.Geometry();
var warn = debug('components:geometry:warn');

/**
 * Geometry component. Combined with material component to make a mesh in 3D object.
 * Extended with registered geometries.
 */
module.exports.Component = registerComponent('geometry', {
  schema: {
    buffer: {default: true},
    mergeTo: {type: 'selector'},
    primitive: {default: 'box', oneOf: geometryNames},
    skipCache: {default: false}
  },

  init: function () {
    this.geometry = null;
  },

  /**
   * Talk to geometry system to get or create geometry.
   */
  update: function (previousData) {
    var data = this.data;
    var mesh = this.el.getOrCreateObject3D('mesh', THREE.Mesh);
    var system = this.system;

    // Dispose old geometry if we created one.
    if (this.geometry) {
      system.unuseGeometry(previousData);
      this.geometry = null;
    }

    // Create new geometry.
    this.geometry = mesh.geometry = system.getOrCreateGeometry(data);
    if (data.mergeTo) {
      this.mergeTo(data.mergeTo);
    }
  },

  /**
   * Merge geometry to another entity's geometry.
   * Remove the entity from the scene. Not a reversible operation.
   *
   * @param {Element} toEl - Entity where the geometry will be merged to.
   */
  mergeTo: function (toEl) {
    var el = this.el;
    var mesh = el.getObject3D('mesh');
    var toMesh;

    if (!toEl || !toEl.isEntity) {
      warn('There is not a valid entity to merge the geometry to');
      return;
    }

    if (toEl === el) {
      warn('Source and target geometries cannot be the same for merge');
      return;
    }

    // Create mesh if entity does not have one.
    toMesh = toEl.getObject3D('mesh');
    if (!toMesh) {
      toMesh = toEl.getOrCreateObject3D('mesh', THREE.Mesh);
      toEl.setAttribute('material', el.getAttribute('material'));
      return;
    }

    if (toMesh.geometry instanceof THREE.Geometry === false ||
        mesh.geometry instanceof THREE.Geometry === false) {
      warn('Geometry merge is only available for `THREE.Geometry` types. ' +
           'Check that both of the merging geometry and the target geometry have `buffer` ' +
           'set to false');
      return;
    }

    if (this.data.skipCache === false) {
      warn('Cached geometries are not allowed to merge. Set `skipCache` to true');
      return;
    }

    mesh.parent.updateMatrixWorld();
    toMesh.geometry.merge(mesh.geometry, mesh.matrixWorld);
    el.emit('geometry-merged', {mergeTarget: toEl});
    el.parentNode.removeChild(el);
  },

  /**
   * Tell geometry system that entity is no longer using the geometry.
   * Unset the geometry on the mesh
   */
  remove: function () {
    this.system.unuseGeometry(this.data);
    this.el.getObject3D('mesh').geometry = dummyGeometry;
    this.geometry = null;
  },

  /**
   * Update geometry component schema based on geometry type.
   *
   * @param {object} data - New data passed by Component.
   */
  updateSchema: function (data) {
    var newGeometryType = data.primitive;
    var currentGeometryType = this.data && this.data.primitive;
    var schema = geometries[newGeometryType] && geometries[newGeometryType].schema;

    // Geometry has no schema.
    if (!schema) { throw new Error('Unknown geometry schema `' + newGeometryType + '`'); }
    // Nothing has changed.
    if (currentGeometryType && currentGeometryType === newGeometryType) { return; }

    this.extendSchema(schema);
  }
});

},{"../core/component":100,"../core/geometry":101,"../lib/three":146,"../utils/debug":163}],61:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../core/component').registerComponent;
var THREE = _dereq_('../lib/three');

/**
 * glTF model loader.
 */
module.exports.Component = registerComponent('gltf-model', {
  schema: {type: 'model'},

  init: function () {
    this.model = null;
    this.loader = new THREE.GLTFLoader();
  },

  update: function () {
    var self = this;
    var el = this.el;
    var src = this.data;

    if (!src) { return; }

    this.remove();

    this.loader.load(src, function gltfLoaded (gltfModel) {
      self.model = gltfModel.scene;
      self.system.registerModel(self.model);
      el.setObject3D('mesh', self.model);
      el.emit('model-loaded', {format: 'gltf', model: self.model});
    });
  },

  remove: function () {
    if (!this.model) { return; }
    this.el.removeObject3D('mesh');
    this.system.unregisterModel(this.model);
  }
});

},{"../core/component":100,"../lib/three":146}],62:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../core/component').registerComponent;

var OCULUS_LEFT_HAND_MODEL_URL = 'https://cdn.aframe.io/controllers/oculus-hands/v2/leftHand.json';
var OCULUS_RIGHT_HAND_MODEL_URL = 'https://cdn.aframe.io/controllers/oculus-hands/v2/rightHand.json';

/**
*
* Hand Controls component
* Auto-detect appropriate controllers
* Handle common events coming from the detected vendor-specific controls
* Translate button events to hand related actions:
* gripclose, gripopen, thumbup, thumbdown, pointup, pointdown
* Load a hand model with gestures that are applied based
* on the button pressed.
*
* @property {left/right} Hand mapping
*/
module.exports.Component = registerComponent('hand-controls', {
  schema: {default: 'left'},

  init: function () {
    var self = this;
    this.touchedButtons = {};
    this.pressedButtons = {};
    this.onGripDown = function () { self.handleButton('grip', 'down'); };
    this.onGripUp = function () { self.handleButton('grip', 'up'); };
    this.onTrackpadDown = function () { self.handleButton('trackpad', 'down'); };
    this.onTrackpadUp = function () { self.handleButton('trackpad', 'up'); };
    this.onTrackpadTouchStart = function () { self.handleButton('trackpad', 'touchstart'); };
    this.onTrackpadTouchEnd = function () { self.handleButton('trackpad', 'touchend'); };
    this.onTriggerDown = function () { self.handleButton('trigger', 'down'); };
    this.onTriggerUp = function () { self.handleButton('trigger', 'up'); };
    this.onTriggerTouchStart = function () { self.handleButton('trigger', 'touchstart'); };
    this.onTriggerTouchEnd = function () { self.handleButton('trigger', 'touchend'); };
    this.onGripTouchStart = function () { self.handleButton('grip', 'touchstart'); };
    this.onGripTouchEnd = function () { self.handleButton('grip', 'touchend'); };
    this.onThumbstickDown = function () { self.handleButton('thumbstick', 'down'); };
    this.onThumbstickUp = function () { self.handleButton('thumbstick', 'up'); };
    this.onAorXTouchStart = function () { self.handleButton('AorX', 'touchstart'); };
    this.onAorXTouchEnd = function () { self.handleButton('AorX', 'touchend'); };
    this.onBorYTouchStart = function () { self.handleButton('BorY', 'touchstart'); };
    this.onBorYTouchEnd = function () { self.handleButton('BorY', 'touchend'); };
    this.onSurfaceTouchStart = function () { self.handleButton('surface', 'touchstart'); };
    this.onSurfaceTouchEnd = function () { self.handleButton('surface', 'touchend'); };
  },

  play: function () {
    this.addEventListeners();
  },

  pause: function () {
    this.removeEventListeners();
  },

  addEventListeners: function () {
    var el = this.el;
    el.addEventListener('gripdown', this.onGripDown);
    el.addEventListener('gripup', this.onGripUp);
    el.addEventListener('trackpaddown', this.onTrackpadDown);
    el.addEventListener('trackpadup', this.onTrackpadUp);
    el.addEventListener('trackpadtouchstart', this.onTrackpadTouchStart);
    el.addEventListener('trackpadtouchend', this.onTrackpadTouchEnd);
    el.addEventListener('triggerdown', this.onTriggerDown);
    el.addEventListener('triggerup', this.onTriggerUp);
    el.addEventListener('triggertouchstart', this.onTriggerTouchStart);
    el.addEventListener('triggertouchend', this.onTriggerTouchEnd);
    el.addEventListener('griptouchstart', this.onGripTouchStart);
    el.addEventListener('griptouchend', this.onGripTouchEnd);
    el.addEventListener('thumbstickdown', this.onThumbstickDown);
    el.addEventListener('thumbstickup', this.onThumbstickUp);
    el.addEventListener('Atouchstart', this.onAorXTouchStart);
    el.addEventListener('Atouchend', this.onAorXTouchEnd);
    el.addEventListener('Btouchstart', this.onBorYTouchStart);
    el.addEventListener('Btouchend', this.onBorYTouchEnd);
    el.addEventListener('Xtouchstart', this.onAorXTouchStart);
    el.addEventListener('Xtouchend', this.onAorXTouchEnd);
    el.addEventListener('Ytouchstart', this.onBorYTouchStart);
    el.addEventListener('Ytouchend', this.onBorYTouchEnd);
    el.addEventListener('surfacetouchstart', this.onSurfaceTouchStart);
    el.addEventListener('surfacetouchend', this.onSurfaceTouchEnd);
  },

  removeEventListeners: function () {
    var el = this.el;
    el.removeEventListener('gripdown', this.onGripDown);
    el.removeEventListener('gripup', this.onGripUp);
    el.removeEventListener('trackpaddown', this.onTrackpadDown);
    el.removeEventListener('trackpadup', this.onTrackpadUp);
    el.removeEventListener('trackpadtouchstart', this.onTrackpadTouchStart);
    el.removeEventListener('trackpadtouchend', this.onTrackpadTouchEnd);
    el.removeEventListener('triggerdown', this.onTriggerDown);
    el.removeEventListener('triggerup', this.onTriggerUp);
    el.removeEventListener('triggertouchstart', this.onTriggerTouchStart);
    el.removeEventListener('triggertouchend', this.onTriggerTouchEnd);
    el.removeEventListener('griptouchstart', this.onGripTouchStart);
    el.removeEventListener('griptouchend', this.onGripTouchEnd);
    el.removeEventListener('thumbstickdown', this.onThumbstickDown);
    el.removeEventListener('thumbstickup', this.onThumbstickUp);
    el.removeEventListener('Atouchstart', this.onAorXTouchStart);
    el.removeEventListener('Atouchend', this.onAorXTouchEnd);
    el.removeEventListener('Btouchstart', this.onBorYTouchStart);
    el.removeEventListener('Btouchend', this.onBorYTouchEnd);
    el.removeEventListener('Xtouchstart', this.onAorXTouchStart);
    el.removeEventListener('Xtouchend', this.onAorXTouchEnd);
    el.removeEventListener('Ytouchstart', this.onBorYTouchStart);
    el.removeEventListener('Ytouchend', this.onBorYTouchEnd);
    el.removeEventListener('surfacetouchstart', this.onSurfaceTouchStart);
    el.removeEventListener('surfacetouchend', this.onSurfaceTouchEnd);
  },

  update: function () {
    var el = this.el;
    var hand = this.data;
    var controlConfiguration = {
      hand: hand,
      model: false,
      rotationOffset: hand === 'left' ? 90 : -90
    };
    var modelUrl;
    if (hand === 'left') {
      modelUrl = 'url(' + OCULUS_LEFT_HAND_MODEL_URL + ')';
    } else {
      modelUrl = 'url(' + OCULUS_RIGHT_HAND_MODEL_URL + ')';
    }
    el.setAttribute('vive-controls', controlConfiguration);
    el.setAttribute('oculus-touch-controls', controlConfiguration);
    el.setAttribute('blend-character-model', modelUrl);
  },

 /** Play the model animations based on the pressed button and kind of event.
   *
   * @param {string} button the name of the button
   * @param {string} evt the event associated to the button
   */
  handleButton: function (button, evt) {
    var isPressed = evt === 'down';
    var isTouched = evt === 'touchstart';
    var lastGesture;
    if (evt.indexOf('touch') === 0) {
      if (isTouched === this.touchedButtons[button]) { return; }
      this.touchedButtons[button] = isTouched;
    } else {
      if (isPressed === this.pressedButtons[button]) { return; }
      this.pressedButtons[button] = isPressed;
    }
    lastGesture = this.gesture;
    this.gesture = this.determineGesture();
    if (this.gesture === lastGesture) { return; }
    this.animateGesture(this.gesture);
    this.emitGestureEvents(this.gesture, lastGesture);
  },

  isOculusTouchController: function () {
    var trackedControls = this.el.components['tracked-controls'];
    var controllerId = trackedControls && trackedControls.controller && trackedControls.controller.id;
    return controllerId && controllerId.indexOf('Oculus Touch') === 0;
  },

  determineGesture: function () {
    var gesture;
    var isGripActive = this.pressedButtons['grip'];
    var isSurfaceActive = this.pressedButtons['surface'] || this.touchedButtons['surface'];
    var isTrackpadActive = this.pressedButtons['trackpad'] || this.touchedButtons['trackpad'];
    var isTriggerActive = this.pressedButtons['trigger'] || this.touchedButtons['trigger'];
    var isABXYActive = this.touchedButtons['AorX'] || this.touchedButtons['BorY'];
    var isOculusTouch = this.isOculusTouchController();
    // this works well with Oculus Touch, but Vive needs tweaks
    if (isGripActive) {
      if (!isOculusTouch) {
        gesture = 'fist';
      } else
      if (isSurfaceActive || isABXYActive || isTrackpadActive) {
        gesture = isTriggerActive ? 'fist' : 'pointing';
      } else {
        gesture = isTriggerActive ? 'thumb' : 'pistol';
      }
    } else
    if (isTriggerActive) {
      gesture = isOculusTouch ? 'touch' : 'fist';
    } else
    if (!isOculusTouch && isTrackpadActive) { gesture = 'pointing'; }
    return gesture;
  },

  gestureAnimationMapping: {
    default: 'Open',
    pointing: 'Point',
    pistol: 'Point + Thumb',
    fist: 'Fist',
    touch: 'Hold',
    thumb: 'Thumb Up'
  },

  animateGesture: function (gesture) {
    var isOculusTouch = this.isOculusTouchController();
    if (!gesture && !isOculusTouch) {
      // for Vive (and other non-Oculus Touch), change rest pose to be thumb down
      this.playAnimation('Open', true);
      return;
    }
    var animation = this.gestureAnimationMapping[gesture || 'default'];
    this.playAnimation(animation || 'Open', !animation && isOculusTouch);
  },

  // map to old vive-specific event names for now
  gestureEventMapping: {
    fist: 'grip',         // fist: e.g. grip active, trigger active, trackpad / surface active
    touch: 'point',       // 'touch' e.g. trigger active, grip not active
    thumb: 'thumb',       // thumbs up: e.g. grip active, trigger active, trackpad / surface not active
    pointing: 'pointing', // pointing: e.g. grip active, trackpad / surface active, trigger not active
    pistol: 'pistol'      // pistol: e.g. grip active, trigger not active, trackpad / surface not active
  },

  gestureEventName: function (gesture, active) {
    if (!gesture) return 0;
    var eventName = this.gestureEventMapping[gesture];
    if (eventName === 'grip') { return eventName + (active ? 'close' : 'open'); }
    if (eventName === 'point' || eventName === 'thumb') { return eventName + (active ? 'up' : 'down'); }
    if (eventName === 'pointing' || eventName === 'pistol') { return eventName + (active ? 'start' : 'end'); }
    return 0;
  },

  emitGestureEvents: function (gesture, lastGesture) {
    var el = this.el;
    var eventName;
    if (lastGesture !== gesture) {
      eventName = this.gestureEventName(lastGesture, false);
      if (eventName) { el.emit(eventName); }
      eventName = this.gestureEventName(gesture, true);
      if (eventName) { el.emit(eventName); }
    }
  },

/**
  * Play the hand animations based on button state.
  *
  * @param {string} animation - the name of the animation.
  * @param {string} reverse - It the animation has to play in reverse.
  */
  playAnimation: function (animation, reverse) {
    var animationActive = this.animationActive;
    var timeScale = 1;
    var mesh = this.el.getObject3D('mesh');
    var clipAction;
    if (!mesh) { return; }

    // determine direction of the animation.
    if (reverse) { timeScale = -1; }

    // stop current animation.
    if (animationActive) { mesh.play(animationActive, 0); }

    // play new animation.
    clipAction = mesh.mixer.clipAction(animation);
    // returning when no clipAction will prevent further issues
    // (e.g. controllers no longer updating pose)
    // but per https://github.com/aframevr/aframe/pull/2191#discussion_r93121878
    // the preference is to NOT prevent the issues to catch bugs earlier in QA.
    clipAction.loop = 2200;
    clipAction.clampWhenFinished = true;
    clipAction.timeScale = timeScale;
    mesh.play(animation, 1);
    this.animationActive = animation;
  }
});

},{"../core/component":100}],63:[function(_dereq_,module,exports){
_dereq_('./blend-character-model');
_dereq_('./camera');
_dereq_('./collada-model');
_dereq_('./cursor');
_dereq_('./geometry');
_dereq_('./gltf-model');
_dereq_('./hand-controls');
_dereq_('./light');
_dereq_('./look-controls');
_dereq_('./material');
_dereq_('./obj-model');
_dereq_('./oculus-touch-controls');
_dereq_('./position');
_dereq_('./raycaster');
_dereq_('./rotation');
_dereq_('./scale');
_dereq_('./sound');
_dereq_('./text');
_dereq_('./tracked-controls');
_dereq_('./visible');
_dereq_('./vive-controls');
_dereq_('./wasd-controls');

_dereq_('./scene/auto-enter-vr');
_dereq_('./scene/canvas');
_dereq_('./scene/debug');
_dereq_('./scene/embedded');
_dereq_('./scene/inspector');
_dereq_('./scene/fog');
_dereq_('./scene/keyboard-shortcuts');
_dereq_('./scene/pool');
_dereq_('./scene/screenshot');
_dereq_('./scene/stats');
_dereq_('./scene/vr-mode-ui');

},{"./blend-character-model":56,"./camera":57,"./collada-model":58,"./cursor":59,"./geometry":60,"./gltf-model":61,"./hand-controls":62,"./light":64,"./look-controls":65,"./material":66,"./obj-model":67,"./oculus-touch-controls":68,"./position":69,"./raycaster":70,"./rotation":71,"./scale":72,"./scene/auto-enter-vr":73,"./scene/canvas":74,"./scene/debug":75,"./scene/embedded":76,"./scene/fog":77,"./scene/inspector":78,"./scene/keyboard-shortcuts":79,"./scene/pool":80,"./scene/screenshot":81,"./scene/stats":82,"./scene/vr-mode-ui":83,"./sound":84,"./text":85,"./tracked-controls":86,"./visible":87,"./vive-controls":88,"./wasd-controls":89}],64:[function(_dereq_,module,exports){
var bind = _dereq_('../utils/bind');
var diff = _dereq_('../utils').diff;
var debug = _dereq_('../utils/debug');
var registerComponent = _dereq_('../core/component').registerComponent;
var THREE = _dereq_('../lib/three');

var degToRad = THREE.Math.degToRad;
var warn = debug('components:light:warn');

/**
 * Light component.
 */
module.exports.Component = registerComponent('light', {
  schema: {
    angle: {default: 60, if: {type: ['spot']}},
    color: {type: 'color'},
    groundColor: {type: 'color', if: {type: ['hemisphere']}},
    decay: {default: 1, if: {type: ['point', 'spot']}},
    distance: {default: 0.0, min: 0, if: {type: ['point', 'spot']}},
    intensity: {default: 1.0, min: 0, if: {type: ['ambient', 'directional', 'hemisphere', 'point', 'spot']}},
    penumbra: {default: 0, min: 0, max: 1, if: {type: ['spot']}},
    type: {default: 'directional', oneOf: ['ambient', 'directional', 'hemisphere', 'point', 'spot']},
    target: {type: 'selector', if: {type: ['spot', 'directional']}}
  },

  /**
   * Notifies scene a light has been added to remove default lighting.
   */
  init: function () {
    var el = this.el;
    this.light = null;
    this.defaultTarget = null;
    this.system.registerLight(el);
  },

  /**
   * (Re)create or update light.
   */
  update: function (oldData) {
    var data = this.data;
    var diffData = diff(data, oldData);
    var light = this.light;
    var self = this;

    // Existing light.
    if (light && !('type' in diffData)) {
      // Light type has not changed. Update light.
      Object.keys(diffData).forEach(function (key) {
        var value = data[key];

        switch (key) {
          case 'color': {
            light.color.set(value);
            break;
          }

          case 'groundColor': {
            light.groundColor.set(value);
            break;
          }

          case 'angle': {
            light.angle = degToRad(value);
            break;
          }

          case 'target': {
            // Reset target if selector is null.
            if (value === null) {
              if (data.type === 'spot' || data.type === 'directional') {
                light.target = self.defaultTarget;
              }
            } else {
              // Target specified, set target to entity's `object3D` when it is loaded.
              if (value.hasLoaded) {
                self.onSetTarget(value);
              } else {
                value.addEventListener('loaded', bind(self.onSetTarget, self, value));
              }
            }
            break;
          }

          default: {
            light[key] = value;
          }
        }
      });
      return;
    }

    // No light yet or light type has changed. Create and add light.
    this.setLight(this.data);
  },

  setLight: function (data) {
    var el = this.el;
    var newLight = this.getLight(data);
    if (newLight) {
      if (this.light) {
        el.removeObject3D('light');
      }

      this.light = newLight;
      this.light.el = el;
      el.setObject3D('light', this.light);

      // HACK solution for issue #1624
      if (data.type === 'spot' || data.type === 'directional' || data.type === 'hemisphere') {
        el.getObject3D('light').translateY(-1);
      }

      // set and position default lighttarget as a child to enable spotlight orientation
      if (data.type === 'spot') {
        el.setObject3D('light-target', this.defaultTarget);
        el.getObject3D('light-target').position.set(0, 0, -1);
      }
    }
  },

  /**
   * Creates a new three.js light object given data object defining the light.
   *
   * @param {object} data
   */
  getLight: function (data) {
    var angle = data.angle;
    var color = new THREE.Color(data.color).getHex();
    var decay = data.decay;
    var distance = data.distance;
    var groundColor = new THREE.Color(data.groundColor).getHex();
    var intensity = data.intensity;
    var type = data.type;
    var target = data.target;
    var light = null;

    switch (type.toLowerCase()) {
      case 'ambient': {
        return new THREE.AmbientLight(color, intensity);
      }

      case 'directional': {
        light = new THREE.DirectionalLight(color, intensity);
        this.defaultTarget = light.target;
        if (target) {
          if (target.hasLoaded) {
            this.onSetTarget(target);
          } else {
            target.addEventListener('loaded', bind(this.onSetTarget, this, target));
          }
        }
        return light;
      }

      case 'hemisphere': {
        return new THREE.HemisphereLight(color, groundColor, intensity);
      }

      case 'point': {
        return new THREE.PointLight(color, intensity, distance, decay);
      }

      case 'spot': {
        light = new THREE.SpotLight(color, intensity, distance, degToRad(angle), data.penumbra, decay);
        this.defaultTarget = light.target;
        if (target) {
          if (target.hasLoaded) {
            this.onSetTarget(target);
          } else {
            target.addEventListener('loaded', bind(this.onSetTarget, this, target));
          }
        }
        return light;
      }

      default: {
        warn('%s is not a valid light type. ' +
           'Choose from ambient, directional, hemisphere, point, spot.', type);
      }
    }
  },

  onSetTarget: function (targetEl) {
    this.light.target = targetEl.object3D;
  },

  /**
   * Remove light on remove (callback).
   */
  remove: function () {
    this.el.removeObject3D('light');
  }
});

},{"../core/component":100,"../lib/three":146,"../utils":167,"../utils/bind":161,"../utils/debug":163}],65:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../core/component').registerComponent;
var THREE = _dereq_('../lib/three');
var isMobile = _dereq_('../utils/').device.isMobile();
var bind = _dereq_('../utils/bind');

// To avoid recalculation at every mouse movement tick
var PI_2 = Math.PI / 2;
var radToDeg = THREE.Math.radToDeg;

module.exports.Component = registerComponent('look-controls', {
  dependencies: ['position', 'rotation'],

  schema: {
    enabled: {default: true},
    hmdEnabled: {default: true},
    reverseMouseDrag: {default: false},
    standing: {default: true}
  },

  init: function () {
    var sceneEl = this.el.sceneEl;

    // Aux variables
    this.previousHMDPosition = new THREE.Vector3();
    this.hmdQuaternion = new THREE.Quaternion();
    this.hmdEuler = new THREE.Euler();

    this.setupMouseControls();
    this.setupHMDControls();
    this.bindMethods();

    // Enable grab cursor class on canvas.
    function enableGrabCursor () { sceneEl.canvas.classList.add('a-grab-cursor'); }
    if (!sceneEl.canvas) {
      sceneEl.addEventListener('render-target-loaded', enableGrabCursor);
    } else {
      enableGrabCursor();
    }
  },

  update: function (oldData) {
    var data = this.data;
    var hmdEnabled = data.hmdEnabled;
    if (!data.enabled) { return; }
    if (!hmdEnabled && oldData && hmdEnabled !== oldData.hmdEnabled) {
      this.pitchObject.rotation.set(0, 0, 0);
      this.yawObject.rotation.set(0, 0, 0);
    }
    this.controls.standing = data.standing;
    this.controls.update();
    this.updateOrientation();
    this.updatePosition();
  },

  play: function () {
    this.addEventListeners();
  },

  pause: function () {
    this.removeEventListeners();
  },

  tick: function (t) {
    this.update();
  },

  remove: function () {
    this.pause();
  },

  bindMethods: function () {
    this.onMouseDown = bind(this.onMouseDown, this);
    this.onMouseMove = bind(this.onMouseMove, this);
    this.releaseMouse = bind(this.releaseMouse, this);
    this.onTouchStart = bind(this.onTouchStart, this);
    this.onTouchMove = bind(this.onTouchMove, this);
    this.onTouchEnd = bind(this.onTouchEnd, this);
  },

  setupMouseControls: function () {
    // The canvas where the scene is painted
    this.mouseDown = false;
    this.pitchObject = new THREE.Object3D();
    this.yawObject = new THREE.Object3D();
    this.yawObject.position.y = 10;
    this.yawObject.add(this.pitchObject);
  },

  setupHMDControls: function () {
    this.dolly = new THREE.Object3D();
    this.euler = new THREE.Euler();
    this.controls = new THREE.VRControls(this.dolly);
    this.controls.userHeight = 0.0;
  },

  addEventListeners: function () {
    var sceneEl = this.el.sceneEl;
    var canvasEl = sceneEl.canvas;

    // listen for canvas to load.
    if (!canvasEl) {
      sceneEl.addEventListener('render-target-loaded', bind(this.addEventListeners, this));
      return;
    }

    // Mouse Events
    canvasEl.addEventListener('mousedown', this.onMouseDown, false);
    window.addEventListener('mousemove', this.onMouseMove, false);
    window.addEventListener('mouseup', this.releaseMouse, false);

    // Touch events
    canvasEl.addEventListener('touchstart', this.onTouchStart);
    window.addEventListener('touchmove', this.onTouchMove);
    window.addEventListener('touchend', this.onTouchEnd);
  },

  removeEventListeners: function () {
    var sceneEl = this.el.sceneEl;
    var canvasEl = sceneEl && sceneEl.canvas;
    if (!canvasEl) { return; }

    // Mouse Events
    canvasEl.removeEventListener('mousedown', this.onMouseDown);
    canvasEl.removeEventListener('mousemove', this.onMouseMove);
    canvasEl.removeEventListener('mouseup', this.releaseMouse);
    canvasEl.removeEventListener('mouseout', this.releaseMouse);

    // Touch events
    canvasEl.removeEventListener('touchstart', this.onTouchStart);
    canvasEl.removeEventListener('touchmove', this.onTouchMove);
    canvasEl.removeEventListener('touchend', this.onTouchEnd);
  },

  updateOrientation: function () {
    var currentRotation;
    var deltaRotation;
    var hmdEuler = this.hmdEuler;
    var pitchObject = this.pitchObject;
    var yawObject = this.yawObject;
    var hmdQuaternion = this.calculateHMDQuaternion();
    var sceneEl = this.el.sceneEl;
    var rotation;
    hmdEuler.setFromQuaternion(hmdQuaternion, 'YXZ');
    if (isMobile) {
      // In mobile we allow camera rotation with touch events and sensors
      rotation = {
        x: radToDeg(hmdEuler.x) + radToDeg(pitchObject.rotation.x),
        y: radToDeg(hmdEuler.y) + radToDeg(yawObject.rotation.y),
        z: radToDeg(hmdEuler.z)
      };
    } else if (!sceneEl.is('vr-mode') || isNullVector(hmdEuler) || !this.data.hmdEnabled) {
      currentRotation = this.el.getAttribute('rotation');
      deltaRotation = this.calculateDeltaRotation();
      // Mouse look only if HMD disabled or no info coming from the sensors
      if (this.data.reverseMouseDrag) {
        rotation = {
          x: currentRotation.x - deltaRotation.x,
          y: currentRotation.y - deltaRotation.y,
          z: currentRotation.z
        };
      } else {
        rotation = {
          x: currentRotation.x + deltaRotation.x,
          y: currentRotation.y + deltaRotation.y,
          z: currentRotation.z
        };
      }
    } else {
      // Mouse rotation ignored with an active headset.
      // The user head rotation takes priority
      rotation = {
        x: radToDeg(hmdEuler.x),
        y: radToDeg(hmdEuler.y),
        z: radToDeg(hmdEuler.z)
      };
    }
    this.el.setAttribute('rotation', rotation);
  },

  calculateDeltaRotation: function () {
    var currentRotationX = radToDeg(this.pitchObject.rotation.x);
    var currentRotationY = radToDeg(this.yawObject.rotation.y);
    var deltaRotation;
    this.previousRotationX = this.previousRotationX || currentRotationX;
    this.previousRotationY = this.previousRotationY || currentRotationY;
    deltaRotation = {
      x: currentRotationX - this.previousRotationX,
      y: currentRotationY - this.previousRotationY
    };
    this.previousRotationX = currentRotationX;
    this.previousRotationY = currentRotationY;
    return deltaRotation;
  },

  calculateHMDQuaternion: function () {
    var hmdQuaternion = this.hmdQuaternion;
    hmdQuaternion.copy(this.dolly.quaternion);
    return hmdQuaternion;
  },

  updatePosition: (function () {
    var deltaHMDPosition = new THREE.Vector3();
    return function () {
      var el = this.el;
      var currentPosition = el.getAttribute('position');
      var currentHMDPosition;
      var previousHMDPosition = this.previousHMDPosition;
      var sceneEl = this.el.sceneEl;
      currentHMDPosition = this.calculateHMDPosition();
      deltaHMDPosition.copy(currentHMDPosition).sub(previousHMDPosition);
      if (!sceneEl.is('vr-mode') || isNullVector(deltaHMDPosition)) { return; }
      previousHMDPosition.copy(currentHMDPosition);
      // Do nothing if we have not moved.
      if (!sceneEl.is('vr-mode')) { return; }
      el.setAttribute('position', {
        x: currentPosition.x + deltaHMDPosition.x,
        y: currentPosition.y + deltaHMDPosition.y,
        z: currentPosition.z + deltaHMDPosition.z
      });
    };
  })(),

  calculateHMDPosition: function () {
    var dolly = this.dolly;
    var position = new THREE.Vector3();
    dolly.updateMatrix();
    position.setFromMatrixPosition(dolly.matrix);
    return position;
  },

  onMouseMove: function (event) {
    var pitchObject = this.pitchObject;
    var yawObject = this.yawObject;
    var previousMouseEvent = this.previousMouseEvent;

    if (!this.mouseDown || !this.data.enabled) { return; }

    var movementX = event.movementX || event.mozMovementX;
    var movementY = event.movementY || event.mozMovementY;

    if (movementX === undefined || movementY === undefined) {
      movementX = event.screenX - previousMouseEvent.screenX;
      movementY = event.screenY - previousMouseEvent.screenY;
    }
    this.previousMouseEvent = event;

    yawObject.rotation.y -= movementX * 0.002;
    pitchObject.rotation.x -= movementY * 0.002;
    pitchObject.rotation.x = Math.max(-PI_2, Math.min(PI_2, pitchObject.rotation.x));
  },

  onMouseDown: function (event) {
    this.mouseDown = true;
    this.previousMouseEvent = event;
    document.body.classList.add('a-grabbing');
  },

  releaseMouse: function () {
    this.mouseDown = false;
    document.body.classList.remove('a-grabbing');
  },

  onTouchStart: function (e) {
    if (e.touches.length !== 1) { return; }
    this.touchStart = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY
    };
    this.touchStarted = true;
  },

  onTouchMove: function (e) {
    var deltaY;
    var yawObject = this.yawObject;
    if (!this.touchStarted) { return; }
    deltaY = 2 * Math.PI * (e.touches[0].pageX - this.touchStart.x) /
            this.el.sceneEl.canvas.clientWidth;
    // Limits touch orientaion to to yaw (y axis)
    yawObject.rotation.y -= deltaY * 0.5;
    this.touchStart = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY
    };
  },

  onTouchEnd: function () {
    this.touchStarted = false;
  }
});

function isNullVector (vector) {
  return vector.x === 0 && vector.y === 0 && vector.z === 0;
}

},{"../core/component":100,"../lib/three":146,"../utils/":167,"../utils/bind":161}],66:[function(_dereq_,module,exports){
/* global Promise */
var utils = _dereq_('../utils/');
var component = _dereq_('../core/component');
var THREE = _dereq_('../lib/three');
var shader = _dereq_('../core/shader');

var error = utils.debug('components:material:error');
var registerComponent = component.registerComponent;
var shaders = shader.shaders;
var shaderNames = shader.shaderNames;

/**
 * Material component.
 *
 * @member {object} shader - Determines how material is shaded. Defaults to `standard`,
 *         three.js's implementation of PBR. Another standard shading model is `flat` which
 *         uses MeshBasicMaterial.
 */
module.exports.Component = registerComponent('material', {
  schema: {
    depthTest: {default: true},
    flatShading: {default: false},
    opacity: {default: 1.0, min: 0.0, max: 1.0},
    shader: {default: 'standard', oneOf: shaderNames},
    side: {default: 'front', oneOf: ['front', 'back', 'double']},
    transparent: {default: false},
    visible: {default: true},
    offset: {type: 'vec2', default: {x: 0, y: 0}},
    repeat: {type: 'vec2', default: {x: 1, y: 1}},
    npot: {default: false}
  },

  init: function () {
    this.material = null;
  },

  /**
   * Update or create material.
   *
   * @param {object|null} oldData
   */
  update: function (oldData) {
    var data = this.data;
    if (!this.shader || data.shader !== oldData.shader) {
      this.updateShader(data.shader);
    }
    this.shader.update(this.data);
    this.updateMaterial();
  },

  updateSchema: function (data) {
    var newShader = data.shader;
    var currentShader = this.data && this.data.shader;
    var shader = newShader || currentShader;
    var schema = shaders[shader] && shaders[shader].schema;
    if (!schema) { error('Unknown shader schema ' + shader); }
    if (currentShader && newShader === currentShader) { return; }
    this.extendSchema(schema);
    this.updateBehavior();
  },

  updateBehavior: function () {
    var schema = this.schema;
    var self = this;
    var sceneEl = this.el.sceneEl;
    var tickProperties = {};
    var tick = function (time, delta) {
      var keys = Object.keys(tickProperties);
      keys.forEach(update);
      function update (key) { tickProperties[key] = time; }
      self.shader.update(tickProperties);
    };
    var keys = Object.keys(schema);
    this.tick = undefined;
    keys.forEach(function (key) {
      if (schema[key].type === 'time') {
        self.tick = tick;
        tickProperties[key] = true;
      }
    });
    if (!sceneEl) { return; }
    if (!this.tick) {
      sceneEl.removeBehavior(this);
    } else {
      sceneEl.addBehavior(this);
    }
  },

  updateShader: function (shaderName) {
    var data = this.data;
    var Shader = shaders[shaderName] && shaders[shaderName].Shader;
    var shaderInstance;

    if (!Shader) { throw new Error('Unknown shader ' + shaderName); }

    // Get material from A-Frame shader.
    shaderInstance = this.shader = new Shader();
    shaderInstance.el = this.el;
    shaderInstance.init(data);
    this.setMaterial(shaderInstance.material);
    this.updateSchema(data);
  },

  updateMaterial: function () {
    var data = this.data;
    var material = this.material;
    material.side = parseSide(data.side);
    material.opacity = data.opacity;
    material.transparent = data.transparent !== false || data.opacity < 1.0;
    material.depthTest = data.depthTest !== false;
    material.shading = data.flatShading ? THREE.FlatShading : THREE.SmoothShading;
    material.visible = data.visible;
  },

  /**
   * Remove material on remove (callback).
   * Dispose of it from memory and unsubscribe from scene updates.
   */
  remove: function () {
    var defaultMaterial = new THREE.MeshBasicMaterial();
    var material = this.material;
    var object3D = this.el.getObject3D('mesh');
    if (object3D) { object3D.material = defaultMaterial; }
    disposeMaterial(material, this.system);
  },

  /**
   * (Re)create new material. Has side-effects of setting `this.material` and updating
   * material registration in scene.
   *
   * @param {object} data - Material component data.
   * @param {object} type - Material type to create.
   * @returns {object} Material.
   */
  setMaterial: function (material) {
    var mesh = this.el.getOrCreateObject3D('mesh', THREE.Mesh);
    var system = this.system;
    if (this.material) { disposeMaterial(this.material, system); }
    this.material = mesh.material = material;
    system.registerMaterial(material);
  }
});

/**
 * Returns a three.js constant determining which material face sides to render
 * based on the side parameter (passed as a component property).
 *
 * @param {string} [side=front] - `front`, `back`, or `double`.
 * @returns {number} THREE.FrontSide, THREE.BackSide, or THREE.DoubleSide.
 */
function parseSide (side) {
  switch (side) {
    case 'back': {
      return THREE.BackSide;
    }
    case 'double': {
      return THREE.DoubleSide;
    }
    default: {
      // Including case `front`.
      return THREE.FrontSide;
    }
  }
}

/**
 * Dispose of material from memory and unsubscribe material from scene updates like fog.
 */
function disposeMaterial (material, system) {
  material.dispose();
  system.unregisterMaterial(material);
}

},{"../core/component":100,"../core/shader":109,"../lib/three":146,"../utils/":167}],67:[function(_dereq_,module,exports){
var debug = _dereq_('../utils/debug');
var registerComponent = _dereq_('../core/component').registerComponent;
var THREE = _dereq_('../lib/three');

var warn = debug('components:obj-model:warn');

module.exports.Component = registerComponent('obj-model', {
  dependencies: ['material'],

  schema: {
    mtl: {type: 'model'},
    obj: {type: 'model'}
  },

  init: function () {
    this.model = null;
    this.objLoader = new THREE.OBJLoader();
    this.mtlLoader = new THREE.MTLLoader(this.objLoader.manager);
    // Allow cross-origin images to be loaded.
    this.mtlLoader.crossOrigin = '';
  },

  update: function () {
    var data = this.data;
    if (!data.obj) { return; }
    this.remove();
    this.loadObj(data.obj, data.mtl);
  },

  remove: function () {
    if (!this.model) { return; }
    this.el.removeObject3D('mesh');
  },

  loadObj: function (objUrl, mtlUrl) {
    var self = this;
    var el = this.el;
    var mtlLoader = this.mtlLoader;
    var objLoader = this.objLoader;

    if (mtlUrl) {
      // .OBJ with an .MTL.
      if (el.hasAttribute('material')) {
        warn('Material component properties are ignored when a .MTL is provided');
      }
      mtlLoader.setTexturePath(mtlUrl.substr(0, mtlUrl.lastIndexOf('/') + 1));
      mtlLoader.load(mtlUrl, function (materials) {
        materials.preload();
        objLoader.setMaterials(materials);
        objLoader.load(objUrl, function (objModel) {
          self.model = objModel;
          el.setObject3D('mesh', objModel);
          el.emit('model-loaded', {format: 'obj', model: objModel});
        });
      });
      return;
    }

    // .OBJ only.
    objLoader.load(objUrl, function (objModel) {
      // Apply material.
      var material = el.components.material;
      if (material) {
        objModel.traverse(function (child) {
          if (child instanceof THREE.Mesh) {
            child.material = material.material;
          }
        });
      }

      self.model = objModel;
      el.setObject3D('mesh', objModel);
      el.emit('model-loaded', {format: 'obj', model: objModel});
    });
  }
});

},{"../core/component":100,"../lib/three":146,"../utils/debug":163}],68:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../core/component').registerComponent;
var bind = _dereq_('../utils/bind');
var isControllerPresent = _dereq_('../utils/tracked-controls').isControllerPresent;

var TOUCH_CONTROLLER_MODEL_BASE_URL = 'https://cdn.aframe.io/controllers/oculus/oculus-touch-controller-';
var TOUCH_CONTROLLER_MODEL_OBJ_URL_L = TOUCH_CONTROLLER_MODEL_BASE_URL + 'left.obj';
var TOUCH_CONTROLLER_MODEL_OBJ_MTL_L = TOUCH_CONTROLLER_MODEL_BASE_URL + 'left.mtl';
var TOUCH_CONTROLLER_MODEL_OBJ_URL_R = TOUCH_CONTROLLER_MODEL_BASE_URL + 'right.obj';
var TOUCH_CONTROLLER_MODEL_OBJ_MTL_R = TOUCH_CONTROLLER_MODEL_BASE_URL + 'right.mtl';

var GAMEPAD_ID_PREFIX = 'Oculus Touch';

var PIVOT_OFFSET = {x: 0, y: -0.015, z: 0.04};

// currently, browser bugs prevent capacitive touch events from firing on trigger and grip;
// however those have analog values, and this (below button-down values) can be used to fake them
var EMULATED_TOUCH_THRESHOLD = 0.001;

/**
 * Oculus Touch Controls Component
 * Interfaces with Oculus Touch controllers and maps Gamepad events to
 * common controller buttons: trackpad, trigger, grip, menu and system
 * It loads a controller model and highlights the pressed buttons
 */
module.exports.Component = registerComponent('oculus-touch-controls', {
  schema: {
    hand: {default: 'left'},
    buttonColor: {type: 'color', default: '#999'},          // Off-white.
    buttonTouchColor: {type: 'color', default: '#8AB'},
    buttonHighlightColor: {type: 'color', default: '#2DF'}, // Light blue.
    model: { default: true },
    rotationOffset: {default: 0} // no default offset; -999 is sentinel value to auto-determine based on hand
  },

  // buttonId
  // 0 - thumbstick
  // 1 - trigger ( intensity value from 0.5 to 1 )
  // 2 - grip
  // 3 - menu ( dispatch but better for menu options )
  // 4 - system ( never dispatched on this layer )
  mapping: {
    'left': {
      axis0: 'thumbstick',
      axis1: 'thumbstick',
      button0: 'thumbstick',
      button1: 'trigger',
      button2: 'grip',
      button3: 'X',
      button4: 'Y',
      button5: 'surface'
    },
    'right': {
      axis0: 'thumbstick',
      axis1: 'thumbstick',
      button0: 'thumbstick',
      button1: 'trigger',
      button2: 'grip',
      button3: 'A',
      button4: 'B',
      button5: 'surface'
    }
  },

  bindMethods: function () {
    this.onModelLoaded = bind(this.onModelLoaded, this);
    this.onControllersUpdate = bind(this.onControllersUpdate, this);
    this.checkIfControllerPresent = bind(this.checkIfControllerPresent, this);
  },

  init: function () {
    var self = this;
    this.animationActive = 'pointing';
    this.onButtonChanged = bind(this.onButtonChanged, this);
    this.onButtonDown = function (evt) { self.onButtonEvent(evt.detail.id, 'down'); };
    this.onButtonUp = function (evt) { self.onButtonEvent(evt.detail.id, 'up'); };
    this.onButtonTouchStart = function (evt) { self.onButtonEvent(evt.detail.id, 'touchstart'); };
    this.onButtonTouchEnd = function (evt) { self.onButtonEvent(evt.detail.id, 'touchend'); };
    this.controllerPresent = false;
    this.everGotGamepadEvent = false;
    this.lastControllerCheck = 0;
    this.previousButtonValues = {};
    this.bindMethods();
    this.isControllerPresent = isControllerPresent; // to allow mock
  },

  addEventListeners: function () {
    var el = this.el;
    el.addEventListener('buttonchanged', this.onButtonChanged);
    el.addEventListener('buttondown', this.onButtonDown);
    el.addEventListener('buttonup', this.onButtonUp);
    el.addEventListener('touchstart', this.onButtonTouchStart);
    el.addEventListener('touchend', this.onButtonTouchEnd);
    el.addEventListener('model-loaded', this.onModelLoaded);
    el.sceneEl.addEventListener('controllersupdated', this.onControllersUpdate, false);
    window.addEventListener('gamepadconnected', this.checkIfControllerPresent, false);
    window.addEventListener('gamepaddisconnected', this.checkIfControllerPresent, false);
  },

  removeEventListeners: function () {
    var el = this.el;
    el.removeEventListener('buttonchanged', this.onButtonChanged);
    el.removeEventListener('buttondown', this.onButtonDown);
    el.removeEventListener('buttonup', this.onButtonUp);
    el.removeEventListener('touchstart', this.onButtonTouchStart);
    el.removeEventListener('touchend', this.onButtonTouchEnd);
    el.removeEventListener('model-loaded', this.onModelLoaded);
    el.sceneEl.removeEventListener('controllersupdated', this.onControllersUpdate, false);
    window.removeEventListener('gamepadconnected', this.checkIfControllerPresent, false);
    window.removeEventListener('gamepaddisconnected', this.checkIfControllerPresent, false);
  },

  checkIfControllerPresent: function () {
    var data = this.data;
    var isPresent = this.isControllerPresent(this.el.sceneEl, GAMEPAD_ID_PREFIX, { hand: data.hand });
    if (isPresent === this.controllerPresent) { return; }
    this.controllerPresent = isPresent;
    if (isPresent) { this.injectTrackedControls(); } // inject track-controls
  },

  play: function () {
    this.checkIfControllerPresent();
    this.addEventListeners();
  },

  pause: function () {
    this.removeEventListeners();
  },

  updateControllerModel: function () {
    var objUrl, mtlUrl;
    if (!this.data.model) { return; }
    if (this.data.hand === 'right') {
      objUrl = 'url(' + TOUCH_CONTROLLER_MODEL_OBJ_URL_R + ')';
      mtlUrl = 'url(' + TOUCH_CONTROLLER_MODEL_OBJ_MTL_R + ')';
    } else {
      objUrl = 'url(' + TOUCH_CONTROLLER_MODEL_OBJ_URL_L + ')';
      mtlUrl = 'url(' + TOUCH_CONTROLLER_MODEL_OBJ_MTL_L + ')';
    }
    this.el.setAttribute('obj-model', {obj: objUrl, mtl: mtlUrl});
  },

  injectTrackedControls: function () {
    var el = this.el;
    var data = this.data;
    var isRightHand = data.hand === 'right';

    // since each hand is named differently, avoid enumeration
    el.setAttribute('tracked-controls', {
      id: isRightHand ? 'Oculus Touch (Right)' : 'Oculus Touch (Left)',
      controller: 0,
      rotationOffset: data.rotationOffset !== -999 ? data.rotationOffset : isRightHand ? -90 : 90
    });
    this.updateControllerModel();
  },

  onControllersUpdate: function () {
    if (!this.everGotGamepadEvent) { this.checkIfControllerPresent(); }
  },

  // currently, browser bugs prevent capacitive touch events from firing on trigger and grip;
  // however those have analog values, and this (below button-down values) can be used to fake them
  isEmulatedTouchEvent: function (analogValue) {
    return analogValue && (analogValue >= EMULATED_TOUCH_THRESHOLD);
  },

  onButtonChanged: function (evt) {
    var button = this.mapping[this.data.hand]['button' + evt.detail.id];
    var buttonMeshes = this.buttonMeshes;
    var isPreviousValueEmulatedTouch;
    var analogValue;
    var isEmulatedTouch;

    // at the moment, if trigger or grip,
    // touch events aren't happening (touched is stuck true);
    // synthesize touch events from very low analog values
    if (button !== 'trigger' && button !== 'grip') { return; }
    analogValue = evt.detail.state.value;
    isPreviousValueEmulatedTouch = this.isEmulatedTouchEvent(this.previousButtonValues[button]);
    this.previousButtonValues[button] = analogValue;
    isEmulatedTouch = this.isEmulatedTouchEvent(analogValue);
    if (isEmulatedTouch !== isPreviousValueEmulatedTouch) {
      (isEmulatedTouch ? this.onButtonTouchStart : this.onButtonTouchEnd)(evt);
    }
    if (!buttonMeshes) { return; }
    if (button === 'trigger' && buttonMeshes.trigger) {
      buttonMeshes.trigger.rotation.x = -analogValue * (Math.PI / 24);
    }
    if (button === 'grip' && buttonMeshes.grip) {
      buttonMeshes.grip.rotation.y = (this.data.hand === 'left' ? -1 : 1) * analogValue * (Math.PI / 60);
    }
  },

  onModelLoaded: function (evt) {
    var controllerObject3D = evt.detail.model;
    var buttonMeshes;
    if (!this.data.model) { return; }

    var leftHand = this.data.hand === 'left';
    buttonMeshes = this.buttonMeshes = {};

    buttonMeshes.grip = controllerObject3D.getObjectByName(leftHand ? 'buttonHand_oculus-touch-controller-left.004' : 'buttonHand_oculus-touch-controller-right.005');
    buttonMeshes.thumbstick = controllerObject3D.getObjectByName(leftHand ? 'stick_oculus-touch-controller-left.007' : 'stick_oculus-touch-controller-right.004');
    buttonMeshes.trigger = controllerObject3D.getObjectByName(leftHand ? 'buttonTrigger_oculus-touch-controller-left.005' : 'buttonTrigger_oculus-touch-controller-right.006');
    buttonMeshes.X = controllerObject3D.getObjectByName('buttonX_oculus-touch-controller-left.002');
    buttonMeshes.A = controllerObject3D.getObjectByName('buttonA_oculus-touch-controller-right.002');
    buttonMeshes.Y = controllerObject3D.getObjectByName('buttonY_oculus-touch-controller-left.001');
    buttonMeshes.B = controllerObject3D.getObjectByName('buttonB_oculus-touch-controller-right.003');

    // Offset pivot point
    controllerObject3D.position = PIVOT_OFFSET;
  },

  onButtonEvent: function (id, evtName) {
    var buttonName = this.mapping[this.data.hand]['button' + id];
    var i;
    if (Array.isArray(buttonName)) {
      for (i = 0; i < buttonName.length; i++) {
        this.el.emit(buttonName[i] + evtName);
      }
    } else {
      this.el.emit(buttonName + evtName);
    }
    this.updateModel(buttonName, evtName);
  },

  updateModel: function (buttonName, evtName) {
    var i;
    if (Array.isArray(buttonName)) {
      for (i = 0; i < buttonName.length; i++) {
        this.updateButtonModel(buttonName[i], evtName);
      }
    } else {
      this.updateButtonModel(buttonName, evtName);
    }
  },

  updateButtonModel: function (buttonName, state) {
    var color = (state === 'up' || state === 'touchend') ? this.data.buttonColor : state === 'touchstart' ? this.data.buttonTouchColor : this.data.buttonHighlightColor;
    var buttonMeshes = this.buttonMeshes;
    if (!this.data.model) { return; }
    if (buttonMeshes && buttonMeshes[buttonName]) {
      buttonMeshes[buttonName].material.color.set(color);
    }
  }
});

},{"../core/component":100,"../utils/bind":161,"../utils/tracked-controls":171}],69:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../core/component').registerComponent;

module.exports.Component = registerComponent('position', {
  schema: {type: 'vec3'},

  update: function () {
    var object3D = this.el.object3D;
    var data = this.data;
    object3D.position.set(data.x, data.y, data.z);
  }
});

},{"../core/component":100}],70:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../core/component').registerComponent;
var THREE = _dereq_('../lib/three');
var bind = _dereq_('../utils/').bind;

var scaleDummy = new THREE.Vector3();

/**
 * Raycaster component.
 *
 * Pass options to three.js Raycaster including which objects to test.
 * Poll for intersections.
 * Emit event on origin entity and on target entity on intersect.
 *
 * @member {array} intersectedEls - List of currently intersected entities.
 * @member {array} objects - Cached list of meshes to intersect.
 * @member {number} prevCheckTime - Previous time intersection was checked. To help interval.
 * @member {object} raycaster - three.js Raycaster.
 */
module.exports.Component = registerComponent('raycaster', {
  schema: {
    far: {default: Infinity}, // Infinity.
    interval: {default: 100},
    near: {default: 0},
    objects: {default: ''},
    recursive: {default: true}
  },

  init: function () {
    this.direction = new THREE.Vector3();
    this.intersectedEls = [];
    this.objects = null;
    this.prevCheckTime = undefined;
    this.raycaster = new THREE.Raycaster();
    this.updateOriginDirection();
    this.refreshObjects = bind(this.refreshObjects, this);
  },

  play: function () {
    this.el.sceneEl.addEventListener('child-attached', this.refreshObjects);
    this.el.sceneEl.addEventListener('child-detached', this.refreshObjects);
  },

  pause: function () {
    this.el.sceneEl.removeEventListener('child-attached', this.refreshObjects);
    this.el.sceneEl.removeEventListener('child-detached', this.refreshObjects);
  },

  /**
   * Create or update raycaster object.
   */
  update: function () {
    var data = this.data;
    var raycaster = this.raycaster;

    // Set raycaster properties.
    raycaster.far = data.far;
    raycaster.near = data.near;

    this.refreshObjects();
  },

  /**
   * Update list of objects to test for intersection.
   */
  refreshObjects: function () {
    var data = this.data;
    var i;
    var objectEls;

    // Push meshes onto list of objects to intersect.
    if (data.objects) {
      objectEls = this.el.sceneEl.querySelectorAll(data.objects);
      this.objects = [];
      for (i = 0; i < objectEls.length; i++) {
        this.objects.push(objectEls[i].object3D);
      }
      return;
    }

    // If objects not defined, intersect with everything.
    this.objects = this.el.sceneEl.object3D.children;
  },

  /**
   * Check for intersections and cleared intersections on an interval.
   */
  tick: function (time) {
    var el = this.el;
    var data = this.data;
    var intersectedEls;
    var intersections;
    var prevCheckTime = this.prevCheckTime;
    var prevIntersectedEls;

    // Only check for intersection if interval time has passed.
    if (prevCheckTime && (time - prevCheckTime < data.interval)) { return; }

    // Update check time.
    this.prevCheckTime = time;

    // Store old previously intersected entities.
    prevIntersectedEls = this.intersectedEls.slice();

    // Raycast.
    this.updateOriginDirection();
    intersections = this.raycaster.intersectObjects(this.objects, data.recursive);

    // Only keep intersections against objects that have a reference to an entity.
    intersections = intersections.filter(function hasEl (intersection) {
      return !!intersection.object.el;
    });

    // Update intersectedEls.
    intersectedEls = this.intersectedEls = intersections.map(function getEl (intersection) {
      return intersection.object.el;
    });

    // Emit intersected on intersected entity per intersected entity.
    intersections.forEach(function emitEvents (intersection) {
      var intersectedEl = intersection.object.el;
      intersectedEl.emit('raycaster-intersected', {el: el, intersection: intersection});
    });

    // Emit all intersections at once on raycasting entity.
    if (intersections.length) {
      el.emit('raycaster-intersection', {
        els: intersectedEls.slice(),
        intersections: intersections
      });
    }

    // Emit intersection cleared on both entities per formerly intersected entity.
    prevIntersectedEls.forEach(function checkStillIntersected (intersectedEl) {
      if (intersectedEls.indexOf(intersectedEl) !== -1) { return; }
      el.emit('raycaster-intersection-cleared', {el: intersectedEl});
      intersectedEl.emit('raycaster-intersected-cleared', {el: el});
    });
  },

  /**
   * Set origin and direction of raycaster using entity position and rotation.
   */
  updateOriginDirection: (function () {
    var directionHelper = new THREE.Quaternion();
    var originVec3 = new THREE.Vector3();

    // Closure to make quaternion/vector3 objects private.
    return function updateOriginDirection () {
      var el = this.el;
      var object3D = el.object3D;

      // Update matrix world.
      object3D.updateMatrixWorld();
      // Grab the position and rotation.
      object3D.matrixWorld.decompose(originVec3, directionHelper, scaleDummy);
      // Apply rotation to a 0, 0, -1 vector.
      this.direction.set(0, 0, -1);
      this.direction.applyQuaternion(directionHelper);

      this.raycaster.set(originVec3, this.direction);
    };
  })()
});

},{"../core/component":100,"../lib/three":146,"../utils/":167}],71:[function(_dereq_,module,exports){
var degToRad = _dereq_('../lib/three').Math.degToRad;
var registerComponent = _dereq_('../core/component').registerComponent;

module.exports.Component = registerComponent('rotation', {
  schema: {type: 'vec3'},

  /**
   * Updates object3D rotation.
   */
  update: function () {
    var data = this.data;
    var object3D = this.el.object3D;
    object3D.rotation.set(degToRad(data.x), degToRad(data.y), degToRad(data.z));
    object3D.rotation.order = 'YXZ';
  }
});

},{"../core/component":100,"../lib/three":146}],72:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../core/component').registerComponent;

// Avoids triggering a zero-determinant which makes object3D matrix non-invertible.
var zeroScale = 0.00001;

module.exports.Component = registerComponent('scale', {
  schema: {
    type: 'vec3',
    default: {x: 1, y: 1, z: 1}
  },

  update: function () {
    var data = this.data;
    var object3D = this.el.object3D;
    var x = data.x === 0 ? zeroScale : data.x;
    var y = data.y === 0 ? zeroScale : data.y;
    var z = data.z === 0 ? zeroScale : data.z;
    object3D.scale.set(x, y, z);
  }
});

},{"../core/component":100}],73:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../../core/component').registerComponent;
var utils = _dereq_('../../utils');

/**
 * Automatically enter VR, either upon vrdisplayactivate (e.g. putting on Rift headset)
 * or immediately (if possible) if display name contains data string.
 * The default data string is 'GearVR' for Carmel browser which only does VR.
 */
module.exports.Component = registerComponent('auto-enter-vr', {
  schema: {
    display: {type: 'string', default: 'GearVR'},
    enabled: {type: 'boolean', default: true}
  },

  init: function () {
    var scene = this.el;
    var self = this;

    // define methods to allow mock testing
    this.enterVR = scene.enterVR.bind(scene);
    this.exitVR = scene.exitVR.bind(scene);
    this.shouldAutoEnterVR = this.shouldAutoEnterVR.bind(this);

    // don't do anything if false
    if (utils.getUrlParameter('auto-enter-vr') === 'false') { return; }

    // enter VR on vrdisplayactivate (e.g. putting on Rift headset)
    window.addEventListener('vrdisplayactivate', function () { self.enterVR(); }, false);

    // exit VR on vrdisplaydeactivate (e.g. taking off Rift headset)
    window.addEventListener('vrdisplaydeactivate', function () { self.exitVR(); }, false);

    // check if we should try to enter VR... turns out we need to wait for next tick
    setTimeout(function () { if (self.shouldAutoEnterVR()) { self.enterVR(); } }, 0);
  },

  update: function () {
    return this.shouldAutoEnterVR() ? this.enterVR() : this.exitVR();
  },

  shouldAutoEnterVR: function () {
    var scene = this.el;
    var data = this.data;
    // if false, we should not auto-enter VR
    if (!data.enabled) { return false; }
    // if we have a data string to match against display name, try and get it;
    // if we can't get display name, or it doesn't match, we should not auto-enter VR
    if (data.display && data.display !== 'all') {
      var display = scene.effect && scene.effect.getVRDisplay && scene.effect.getVRDisplay();
      if (!display || !display.displayName || display.displayName.indexOf(data.display) < 0) { return false; }
    }
    // we should auto-enter VR
    return true;
  }
});


},{"../../core/component":100,"../../utils":167}],74:[function(_dereq_,module,exports){
var bind = _dereq_('../../utils/bind');
var registerComponent = _dereq_('../../core/component').registerComponent;

module.exports.Component = registerComponent('canvas', {
  init: function () {
    var canvasEl;
    var sceneEl = this.el;

    canvasEl = document.createElement('canvas');
    canvasEl.classList.add('a-canvas');
    // Mark canvas as provided/injected by A-Frame.
    canvasEl.dataset.aframeCanvas = true;
    sceneEl.appendChild(canvasEl);

    document.addEventListener('fullscreenchange', onFullScreenChange);
    document.addEventListener('mozfullscreenchange', onFullScreenChange);
    document.addEventListener('webkitfullscreenchange', onFullScreenChange);

    // Prevent overscroll on mobile.
    canvasEl.addEventListener('touchmove', function (event) {
      event.preventDefault();
    });

    // Set canvas on scene.
    sceneEl.canvas = canvasEl;
    sceneEl.emit('render-target-loaded', {target: canvasEl});

    // For unknown reasons a syncrhonous resize does not work on desktop when
    // entering/exiting fullscreen.
    setTimeout(bind(sceneEl.resize, sceneEl), 0);

    function onFullScreenChange () {
      var fullscreenEl =
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement;
      // No fullscren element === exit fullscreen
      if (!fullscreenEl) { sceneEl.exitVR(); }
      document.activeElement.blur();
      document.body.focus();
    }
  }
});

},{"../../core/component":100,"../../utils/bind":161}],75:[function(_dereq_,module,exports){
var register = _dereq_('../../core/component').registerComponent;

module.exports.Component = register('debug', {
  schema: {default: true}
});

},{"../../core/component":100}],76:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../../core/component').registerComponent;

/**
 * Component to embed an a-frame scene within the layout of a 2D page.
 */
module.exports.Component = registerComponent('embedded', {
  dependencies: ['vr-mode-ui'],

  schema: {default: true},

  update: function () {
    var sceneEl = this.el;
    var enterVREl = sceneEl.querySelector('.a-enter-vr');
    if (this.data === true) {
      if (enterVREl) { enterVREl.classList.add('embedded'); }
      sceneEl.removeFullScreenStyles();
    } else {
      if (enterVREl) { enterVREl.classList.remove('embedded'); }
      sceneEl.addFullScreenStyles();
    }
  }

});

},{"../../core/component":100}],77:[function(_dereq_,module,exports){
var register = _dereq_('../../core/component').registerComponent;
var THREE = _dereq_('../../lib/three');
var debug = _dereq_('../../utils/debug');

var warn = debug('components:fog:warn');

/**
 * Fog component.
 * Applies only to the scene entity.
 */
module.exports.Component = register('fog', {
  schema: {
    color: {type: 'color', default: '#000'},
    density: {default: 0.00025},
    far: {default: 1000, min: 0},
    near: {default: 1, min: 0},
    type: {default: 'linear', oneOf: ['linear', 'exponential']}
  },

  update: function () {
    var data = this.data;
    var el = this.el;
    var fog = this.el.object3D.fog;

    if (!el.isScene) {
      warn('Fog component can only be applied to <a-scene>');
      return;
    }

    // (Re)create fog if fog doesn't exist or fog type changed.
    if (!fog || data.type !== fog.name) {
      el.object3D.fog = getFog(data);
      el.systems.material.updateMaterials();
      return;
    }

    // Fog data changed. Update fog.
    Object.keys(this.schema).forEach(function (key) {
      var value = data[key];
      if (key === 'color') { value = new THREE.Color(value); }
      fog[key] = value;
    });
  },

  /**
   * Remove fog on remove (callback).
   */
  remove: function () {
    var fog = this.el.object3D.fog;
    if (!fog) { return; }
    fog.far = 0;
    fog.near = 0.1;
  }
});

/**
 * Creates a fog object. Sets fog.name to be able to detect fog type changes.
 *
 * @param {object} data - Fog data.
 * @returns {object} fog
 */
function getFog (data) {
  var fog;
  if (data.type === 'exponential') {
    fog = new THREE.FogExp2(data.color, data.density);
  } else {
    fog = new THREE.Fog(data.color, data.near, data.far);
  }
  fog.name = data.type;
  return fog;
}

},{"../../core/component":100,"../../lib/three":146,"../../utils/debug":163}],78:[function(_dereq_,module,exports){
(function (process){
/* global AFRAME */
var AFRAME_INJECTED = _dereq_('../../constants').AFRAME_INJECTED;
var bind = _dereq_('../../utils/bind');
var pkg = _dereq_('../../../package');
var registerComponent = _dereq_('../../core/component').registerComponent;

/**
 * 0.4.2 to 0.4.x
 * Will need to update this when A-Frame goes to 1.x.x.
 */
function getFuzzyPatchVersion (version) {
  var split = version.split('.');
  split[2] = 'x';
  return split.join('.');
}

var INSPECTOR_DEV_URL = 'https://aframe.io/aframe-inspector/dist/aframe-inspector.js';
var INSPECTOR_RELEASE_URL = 'https://unpkg.com/aframe-inspector@' + getFuzzyPatchVersion(pkg.version) + '/dist/aframe-inspector.min.js';
var INSPECTOR_URL = process.env.INSPECTOR_VERSION === 'dev' ? INSPECTOR_DEV_URL : INSPECTOR_RELEASE_URL;
var LOADING_MESSAGE = 'Loading Inspector';

module.exports.Component = registerComponent('inspector', {
  schema: {
    url: {default: INSPECTOR_URL}
  },

  init: function () {
    this.onKeydown = bind(this.onKeydown, this);
    this.onMessage = bind(this.onMessage, this);
    this.initOverlay();
    window.addEventListener('keydown', this.onKeydown);
    window.addEventListener('message', this.onMessage);
  },

  initOverlay: function () {
    var dotsHTML = '<span class="dots"><span>.</span><span>.</span><span>.</span></span>';
    this.loadingMessageEl = document.createElement('div');
    this.loadingMessageEl.classList.add('a-inspector-loader');
    this.loadingMessageEl.innerHTML = LOADING_MESSAGE + dotsHTML;
  },

  remove: function () {
    this.removeEventListeners();
  },

  /**
   * <ctrl> + <alt> + i keyboard shortcut.
   */
  onKeydown: function (evt) {
    var shortcutPressed = evt.keyCode === 73 && evt.ctrlKey && evt.altKey;
    if (!this.data || !shortcutPressed) { return; }
    this.injectInspector();
  },

  showLoader: function () {
    document.body.appendChild(this.loadingMessageEl);
  },

  hideLoader: function () {
    this.el.removeChild(this.loadingMessageEl);
  },

  /**
   * postMessage. aframe.io uses this to create a button on examples to open Inspector.
   */
  onMessage: function (evt) {
    if (evt.data === 'INJECT_AFRAME_INSPECTOR') { this.injectInspector(); }
  },

  injectInspector: function () {
    var self = this;
    var script;

    if (AFRAME.INSPECTOR || AFRAME.inspectorInjected) { return; }

    this.showLoader();

    // Inject.
    script = document.createElement('script');
    script.src = this.data.url;
    script.setAttribute('data-name', 'aframe-inspector');
    script.setAttribute(AFRAME_INJECTED, '');
    script.onload = function () {
      AFRAME.INSPECTOR.open();
      self.hideLoader();
      self.removeEventListeners();
    };
    document.head.appendChild(script);
    AFRAME.inspectorInjected = true;
  },

  removeEventListeners: function () {
    window.removeEventListener('keydown', this.onKeydown);
    window.removeEventListener('message', this.onMessage);
  }
});

}).call(this,_dereq_('_process'))

},{"../../../package":55,"../../constants":91,"../../core/component":100,"../../utils/bind":161,"_process":9}],79:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../../core/component').registerComponent;
var shouldCaptureKeyEvent = _dereq_('../../utils/').shouldCaptureKeyEvent;
var THREE = _dereq_('../../lib/three');

var controls = new THREE.VRControls(new THREE.Object3D());

module.exports.Component = registerComponent('keyboard-shortcuts', {
  schema: {
    enterVR: {default: true},
    exitVR: {default: true},
    resetSensor: {default: true}
  },

  init: function () {
    var self = this;
    var scene = this.el;

    this.listener = window.addEventListener('keyup', function (event) {
      if (!shouldCaptureKeyEvent(event)) { return; }
      if (self.enterVREnabled && event.keyCode === 70) {  // f.
        scene.enterVR();
      }
      if (self.enterVREnabled && event.keyCode === 27) {  // escape.
        scene.exitVR();
      }
      if (self.resetSensorEnabled && event.keyCode === 90) {  // z.
        controls.resetSensor();
      }
    }, false);
  },

  update: function (oldData) {
    var data = this.data;
    this.enterVREnabled = data.enterVR;
    this.resetSensorEnabled = data.resetSensor;
  },

  remove: function () {
    window.removeEventListener('keyup', this.listener);
  }
});

},{"../../core/component":100,"../../lib/three":146,"../../utils/":167}],80:[function(_dereq_,module,exports){
var debug = _dereq_('../../utils/debug');
var registerComponent = _dereq_('../../core/component').registerComponent;

var warn = debug('components:pool:warn');

/**
 * Pool component.
 * A pool of entities that will be reused.
 * It avoids creating and destroying the same kind of entities
 * in dynamic scenes. It will help reduce GC pauses. Useful for example
 * in a game where you want to reuse enemies entities.
 *
 * @member {array} availableEls - Available entities in the pool.
 * @member {array} usedEls - Entities of the pool in use.
 *
 */
module.exports.Component = registerComponent('pool', {
  schema: {
    mixin: {default: ''},
    size: {default: 0},
    dynamic: {default: false}
  },

  multiple: true,

  init: function () {
    this.initPool();
  },

  initPool: function () {
    var i;
    var mixin = this.data.mixin;
    if (!mixin) { return; }
    this.availableEls = [];
    this.usedEls = [];
    for (i = 0; i < this.data.size; ++i) {
      this.createEntity();
    }
  },

  update: function (oldData) {
    var data = this.data;
    if (oldData.mixin !== data.mixin || oldData.size !== data.size) {
      this.initPool();
    }
  },

  /**
   * Add a new entity to the list of available entities.
   */
  createEntity: function () {
    var el = document.createElement('a-entity');
    el.play = this.wrapPlay(el.play);
    el.setAttribute('mixin', this.data.mixin);
    el.setAttribute('visible', false);
    this.el.appendChild(el);
    this.availableEls.push(el);
  },

  /**
   * Play wrapper for pooled entities. When pausing and playing
   * a scene we don't want to play the entities that are not in use
   */
  wrapPlay: function (playMethod) {
    var usedEls = this.usedEls;
    return function () {
      if (usedEls.indexOf(this) === -1) { return; }
      playMethod.call(this);
    };
  },

  /**
   * Used to request one of the available entities of the pool
   */
  requestEntity: function () {
    var el;
    if (this.availableEls.length === 0) {
      if (this.data.dynamic === false) {
        warn('Requested entity from empty pool ' + this.name);
        return;
      } else {
        warn('Requested entity from empty pool. This pool is dynamic' +
        'and will resize automatically. You might want to increase its initial size' + this.name);
      }
      this.createEntity();
    }
    el = this.availableEls.shift();
    this.usedEls.push(el);
    el.setAttribute('visible', true);
    return el;
  },

  /**
   * Used to return a used entity to the pool
   */
  returnEntity: function (el) {
    var index = this.usedEls.indexOf(el);
    if (index === -1) {
      warn('The returned entity was not previously pooled from ' + this.name);
      return;
    }
    this.usedEls.splice(index, 1);
    this.availableEls.push(el);
    el.setAttribute('visible', false);
    el.pause();
  }
});

},{"../../core/component":100,"../../utils/debug":163}],81:[function(_dereq_,module,exports){
/* global ImageData, URL */
var registerComponent = _dereq_('../../core/component').registerComponent;
var THREE = _dereq_('../../lib/three');

var VERTEX_SHADER = [
  'attribute vec3 position;',
  'attribute vec2 uv;',
  'uniform mat4 projectionMatrix;',
  'uniform mat4 modelViewMatrix;',
  'varying vec2 vUv;',
  'void main()  {',
  '  vUv = vec2( 1.- uv.x, uv.y );',
  '  gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );',
  '}'
].join('\n');

var FRAGMENT_SHADER = [
  'precision mediump float;',
  'uniform samplerCube map;',
  'varying vec2 vUv;',
  '#define M_PI 3.141592653589793238462643383279',
  'void main() {',
  '  vec2 uv = vUv;',
  '  float longitude = uv.x * 2. * M_PI - M_PI + M_PI / 2.;',
  '  float latitude = uv.y * M_PI;',
  '  vec3 dir = vec3(',
  '    - sin( longitude ) * sin( latitude ),',
  '    cos( latitude ),',
  '    - cos( longitude ) * sin( latitude )',
  '  );',
  '  normalize( dir );',
  '  gl_FragColor = vec4( textureCube( map, dir ).rgb, 1.0 );',
  '}'
].join('\n');

/**
 * Component to take screenshots of the scene using a keboard shortcut (alt+s).
 * It can be configured to either take 360&deg; captures (`equirectangular`)
 * or regular screenshots (`projection`)
 *
 * This is based on https://github.com/spite/THREE.CubemapToEquirectangular
 * To capture an equirectangular projection of the scene a THREE.CubeCamera is used
 * The cube map produced by the CubeCamera is projected on a quad and then rendered to
 * WebGLRenderTarget with an ortographic camera.
 */
module.exports.Component = registerComponent('screenshot', {
  schema: {
    width: {default: 4096},
    height: {default: 2048}
  },

  init: function () {
    var el = this.el;
    var self = this;

    if (el.renderer) {
      setup();
    } else {
      el.addEventListener('render-target-loaded', setup);
    }

    function setup () {
      var gl = el.renderer.getContext();
      self.cubeMapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
      self.material = new THREE.RawShaderMaterial({
        uniforms: {map: {type: 't', value: null}},
        vertexShader: VERTEX_SHADER,
        fragmentShader: FRAGMENT_SHADER,
        side: THREE.DoubleSide
      });
      self.quad = new THREE.Mesh(
        new THREE.PlaneBufferGeometry(1, 1),
        self.material
      );
      self.quad.visible = false;
      self.camera = new THREE.OrthographicCamera(-1 / 2, 1 / 2, 1 / 2, -1 / 2, -10000, 10000);
      self.canvas = document.createElement('canvas');
      self.ctx = self.canvas.getContext('2d');
      if (el.camera) { el.camera.add(self.quad); }
      self.onKeyDown = self.onKeyDown.bind(self);
      self.onCameraActive = self.onCameraActive.bind(self);
      el.addEventListener('camera-set-active', self.onCameraActive);
    }
  },

  getRenderTarget: function (width, height) {
    return new THREE.WebGLRenderTarget(width, height, {
      minFilter: THREE.LinearFilter,
      magFilter: THREE.LinearFilter,
      wrapS: THREE.ClampToEdgeWrapping,
      wrapT: THREE.ClampToEdgeWrapping,
      format: THREE.RGBAFormat,
      type: THREE.UnsignedByteType
    });
  },

  resize: function (width, height) {
    // Resize quad.
    this.quad.scale.set(width, height, 1);

    // Resize camera.
    this.camera.left = -1 * width / 2;
    this.camera.right = width / 2;
    this.camera.top = height / 2;
    this.camera.bottom = -1 * height / 2;
    this.camera.updateProjectionMatrix();

    // Resize canvas.
    this.canvas.width = width;
    this.canvas.height = height;
  },

  play: function () {
    window.addEventListener('keydown', this.onKeyDown);
  },

  onCameraActive: function (evt) {
    var cameraParent = this.quad.parent;
    if (cameraParent) { cameraParent.remove(this.quad); }
    evt.detail.cameraEl.getObject3D('camera').add(this.quad);
  },

  /**
   * <ctrl> + <alt> + s = Regular screenshot.
   * <ctrl> + <alt> + <shift> + s = Equirectangular screenshot.
  */
  onKeyDown: function (evt) {
    var shortcutPressed = evt.keyCode === 83 && evt.ctrlKey && evt.altKey;
    if (!this.data || !shortcutPressed) { return; }
    var projection = evt.shiftKey ? 'equirectangular' : 'perspective';
    this.capture(projection);
  },

  /**
   * Capture a screenshot of the scene.
   *
   * @param {string} projection - Screenshot projection (equirectangular or perspective).
   */
  setCapture: function (projection) {
    var el = this.el;
    var renderer = el.renderer;
    var size;
    var camera;
    var cubeCamera;
    // Configure camera.
    if (projection === 'perspective') {
      // Quad is only used in equirectangular mode. Hide it in this case.
      this.quad.visible = false;
      // Use scene camera.
      camera = el.camera;
      size = renderer.getSize();
    } else {
      // Use ortho camera.
      camera = this.camera;
      // Copy position and rotation of scene camera into the ortho one.
      camera.position.copy(el.camera.getWorldPosition());
      camera.rotation.copy(el.camera.getWorldRotation());
      // Create cube camera and copy position from scene camera.
      cubeCamera = new THREE.CubeCamera(el.camera.near, el.camera.far,
                                        Math.min(this.cubeMapSize, 2048));
      cubeCamera.position.copy(el.camera.getWorldPosition());
      cubeCamera.rotation.copy(el.camera.getWorldRotation());
      // Render scene with cube camera.
      cubeCamera.updateCubeMap(el.renderer, el.object3D);
      this.quad.material.uniforms.map.value = cubeCamera.renderTarget.texture;
      size = {width: this.data.width, height: this.data.height};
      // Use quad to project image taken by the cube camera.
      this.quad.visible = true;
    }
    return {
      camera: camera,
      size: size,
      projection: projection
    };
  },

  /**
   * Maintained for backwards compatibility.
   */
  capture: function (projection) {
    var params = this.setCapture(projection);
    this.renderCapture(params.camera, params.size, params.projection);
    // Trigger file download.
    this.saveCapture();
  },

  /**
   * Return canvas instead of triggering download (e.g., for uploading blob to server).
   */
  getCanvas: function (projection) {
    var params = this.setCapture(projection);
    this.renderCapture(params.camera, params.size, params.projection);
    return this.canvas;
  },

  renderCapture: function (camera, size, projection) {
    var autoClear = this.el.renderer.autoClear;
    var el = this.el;
    var imageData;
    var output;
    var pixels;
    var renderer = this.el.renderer;
    // Create rendering target and buffer to store the read pixels.
    output = this.getRenderTarget(size.width, size.height);
    pixels = new Uint8Array(4 * size.width * size.height);
    // Resize quad, camera, and canvas.
    this.resize(size.width, size.height);
    // Render scene to render target.
    renderer.autoClear = true;
    renderer.render(el.object3D, camera, output, true);
    renderer.autoClear = autoClear;
    // Read image pizels back.
    renderer.readRenderTargetPixels(output, 0, 0, size.width, size.height, pixels);
    if (projection === 'perspective') {
      pixels = this.flipPixelsVertically(pixels, size.width, size.height);
    }
    imageData = new ImageData(new Uint8ClampedArray(pixels), size.width, size.height);
    // Hide quad after projecting the image.
    this.quad.visible = false;
    // Copy pixels into canvas.
    this.ctx.putImageData(imageData, 0, 0);
  },

  flipPixelsVertically: function (pixels, width, height) {
    var flippedPixels = pixels.slice(0);
    for (var x = 0; x < width; ++x) {
      for (var y = 0; y < height; ++y) {
        flippedPixels[x * 4 + y * width * 4] = pixels[x * 4 + (height - y) * width * 4];
        flippedPixels[x * 4 + 1 + y * width * 4] = pixels[x * 4 + 1 + (height - y) * width * 4];
        flippedPixels[x * 4 + 2 + y * width * 4] = pixels[x * 4 + 2 + (height - y) * width * 4];
        flippedPixels[x * 4 + 3 + y * width * 4] = pixels[x * 4 + 3 + (height - y) * width * 4];
      }
    }
    return flippedPixels;
  },

  /**
   * Download capture to file.
   */
  saveCapture: function () {
    this.canvas.toBlob(function (blob) {
      var fileName = 'screenshot-' + document.title.toLowerCase() + '-' + Date.now() + '.png';
      var linkEl = document.createElement('a');
      var url = URL.createObjectURL(blob);
      linkEl.href = url;
      linkEl.setAttribute('download', fileName);
      linkEl.innerHTML = 'downloading...';
      linkEl.style.display = 'none';
      document.body.appendChild(linkEl);
      setTimeout(function () {
        linkEl.click();
        document.body.removeChild(linkEl);
      }, 1);
    }, 'image/png');
  }
});

},{"../../core/component":100,"../../lib/three":146}],82:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../../core/component').registerComponent;
var RStats = _dereq_('../../../vendor/rStats');
var utils = _dereq_('../../utils');
_dereq_('../../../vendor/rStats.extras');
_dereq_('../../lib/rStatsAframe');

var AFrameStats = window.aframeStats;
var bind = utils.bind;
var HIDDEN_CLASS = 'a-hidden';
var ThreeStats = window.threeStats;

/**
 * Stats appended to document.body by RStats.
 */
module.exports.Component = registerComponent('stats', {
  schema: {default: true},

  init: function () {
    var scene = this.el;

    if (utils.getUrlParameter('stats') === 'false') { return; }

    this.stats = createStats(scene);
    this.statsEl = document.querySelector('.rs-base');

    this.hideBound = bind(this.hide, this);
    this.showBound = bind(this.show, this);

    scene.addEventListener('enter-vr', this.hideBound);
    scene.addEventListener('exit-vr', this.showBound);
  },

  update: function () {
    if (!this.stats) { return; }
    return (!this.data) ? this.hide() : this.show();
  },

  remove: function () {
    this.el.removeEventListener('enter-vr', this.hideBound);
    this.el.removeEventListener('exit-vr', this.showBound);
    if (!this.statsEl) { return; }  // Scene detached.
    this.statsEl.parentNode.removeChild(this.statsEl);
  },

  tick: function () {
    var stats = this.stats;

    if (!stats) { return; }

    stats('rAF').tick();
    stats('FPS').frame();
    stats().update();
  },

  hide: function () {
    this.statsEl.classList.add(HIDDEN_CLASS);
  },

  show: function () {
    this.statsEl.classList.remove(HIDDEN_CLASS);
  }
});

function createStats (scene) {
  var threeStats = new ThreeStats(scene.renderer);
  var aframeStats = new AFrameStats(scene);
  var plugins = scene.isMobile ? [] : [threeStats, aframeStats];
  return new RStats({
    css: [],  // Our stylesheet is injected from `src/index.js`.
    values: {
      fps: {caption: 'fps', below: 30}
    },
    groups: [
      {caption: 'Framerate', values: ['fps', 'raf']}
    ],
    plugins: plugins
  });
}

},{"../../../vendor/rStats":175,"../../../vendor/rStats.extras":174,"../../core/component":100,"../../lib/rStatsAframe":145,"../../utils":167}],83:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../../core/component').registerComponent;
var constants = _dereq_('../../constants/');
var utils = _dereq_('../../utils/');
var bind = utils.bind;

var ENTER_VR_CLASS = 'a-enter-vr';
var ENTER_VR_BTN_CLASS = 'a-enter-vr-button';
var HIDDEN_CLASS = 'a-hidden';
var ORIENTATION_MODAL_CLASS = 'a-orientation-modal';

/**
 * UI for entering VR mode.
 */
module.exports.Component = registerComponent('vr-mode-ui', {
  dependencies: ['canvas'],

  schema: {
    enabled: {default: true}
  },

  init: function () {
    var self = this;
    var sceneEl = this.el;

    if (utils.getUrlParameter('ui') === 'false') { return; }

    this.enterVR = bind(sceneEl.enterVR, sceneEl);
    this.exitVR = bind(sceneEl.exitVR, sceneEl);
    this.insideLoader = false;
    this.enterVREl = null;
    this.orientationModalEl = null;

    // Hide/show VR UI when entering/exiting VR mode.
    sceneEl.addEventListener('enter-vr', bind(this.updateEnterVRInterface, this));
    sceneEl.addEventListener('exit-vr', bind(this.updateEnterVRInterface, this));

    window.addEventListener('message', function (event) {
      if (event.data.type === 'loaderReady') {
        self.insideLoader = true;
        self.remove();
      }
    });

    // Modal that tells the user to change orientation if in portrait.
    window.addEventListener('orientationchange', bind(this.toggleOrientationModalIfNeeded, this));
  },

  update: function () {
    var sceneEl = this.el;

    if (!this.data.enabled || this.insideLoader || utils.getUrlParameter('ui') === 'false') {
      return this.remove();
    }
    if (this.enterVREl || this.orientationModalEl) { return; }

    // Add UI if enabled and not already present.
    this.enterVREl = createEnterVRButton(this.enterVR);
    sceneEl.appendChild(this.enterVREl);

    this.orientationModalEl = createOrientationModal(this.exitVR);
    sceneEl.appendChild(this.orientationModalEl);

    this.updateEnterVRInterface();
  },

  remove: function () {
    [this.enterVREl, this.orientationModalEl].forEach(function (uiElement) {
      if (uiElement) {
        uiElement.parentNode.removeChild(uiElement);
      }
    });
  },

  updateEnterVRInterface: function () {
    this.toggleEnterVRButtonIfNeeded();
    this.toggleOrientationModalIfNeeded();
  },

  toggleEnterVRButtonIfNeeded: function () {
    var sceneEl = this.el;
    if (!this.enterVREl) { return; }
    if (sceneEl.is('vr-mode')) {
      this.enterVREl.classList.add(HIDDEN_CLASS);
    } else {
      this.enterVREl.classList.remove(HIDDEN_CLASS);
    }
  },

  toggleOrientationModalIfNeeded: function () {
    var sceneEl = this.el;
    var orientationModalEl = this.orientationModalEl;
    if (!orientationModalEl || !sceneEl.isMobile) { return; }
    if (!utils.device.isLandscape() && sceneEl.is('vr-mode')) {
      // Show if in VR mode on portrait.
      orientationModalEl.classList.remove(HIDDEN_CLASS);
    } else {
      orientationModalEl.classList.add(HIDDEN_CLASS);
    }
  }
});

/**
 * Creates a button that when clicked will enter into stereo-rendering mode for VR.
 *
 * Structure: <div><button></div>
 *
 * @returns {Element} Wrapper <div>.
 */
function createEnterVRButton (enterVRHandler) {
  var vrButton;
  var wrapper;

  // Create elements.
  wrapper = document.createElement('div');
  wrapper.classList.add(ENTER_VR_CLASS);
  wrapper.setAttribute(constants.AFRAME_INJECTED, '');
  vrButton = document.createElement('button');
  vrButton.className = ENTER_VR_BTN_CLASS;
  vrButton.setAttribute(constants.AFRAME_INJECTED, '');

  // Insert elements.
  wrapper.appendChild(vrButton);
  vrButton.addEventListener('click', enterVRHandler);
  return wrapper;
}

/**
 * Create a modal that tells mobile users to orient the phone to landscape.
 * Add a close button that if clicked, exits VR and closes the modal.
 */
function createOrientationModal (exitVRHandler) {
  var modal = document.createElement('div');
  modal.className = ORIENTATION_MODAL_CLASS;
  modal.classList.add(HIDDEN_CLASS);
  modal.setAttribute(constants.AFRAME_INJECTED, '');

  var exit = document.createElement('button');
  exit.setAttribute(constants.AFRAME_INJECTED, '');
  exit.innerHTML = 'Exit VR';

  // Exit VR on close.
  exit.addEventListener('click', exitVRHandler);

  modal.appendChild(exit);

  return modal;
}

},{"../../constants/":91,"../../core/component":100,"../../utils/":167}],84:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../core/component').registerComponent;
var debug = _dereq_('../utils/debug');
var bind = _dereq_('../utils/bind');
var THREE = _dereq_('../lib/three');

var warn = debug('components:sound:warn');

/**
 * Sound component.
 */
module.exports.Component = registerComponent('sound', {
  schema: {
    autoplay: {default: false},
    loop: {default: false},
    on: {default: ''},
    poolSize: {default: 1},
    src: {type: 'audio'},
    volume: {default: 1}
  },

  multiple: true,

  init: function () {
    this.listener = null;
    this.audioLoader = new THREE.AudioLoader();
    this.pool = new THREE.Group();
    this.playSound = bind(this.playSound, this);
  },

  update: function (oldData) {
    var data = this.data;
    var srcChanged = data.src !== oldData.src;
    // Create new sound if not yet created or changing `src`.
    if (srcChanged) {
      if (!data.src) {
        warn('Audio source was not specified with `src`');
        return;
      }
      this.setupSound();
    }

    this.pool.children.forEach(function (sound) {
      sound.autoplay = data.autoplay;
      sound.setLoop(data.loop);
      sound.setVolume(data.volume);
    });

    if (data.on !== oldData.on) {
      this.updateEventListener(oldData.on);
    }

    // All sound values set. Load in `src`.
    if (srcChanged) {
      var self = this;
      this.audioLoader.load(data.src, function (buffer) {
        self.pool.children.forEach(function (sound) {
          sound.setBuffer(buffer);
        });
        // Remove this key from cache, otherwise we can't play it again
        THREE.Cache.remove(data.src);
      });
    }
  },

  pause: function () {
    this.pauseSound();
    this.removeEventListener();
  },

  play: function () {
    if (this.data.autoplay) { this.playSound(); }
    this.updateEventListener();
  },

  remove: function () {
    this.removeEventListener();
    this.el.removeObject3D(this.attrName);
    try {
      this.pool.children.forEach(function (sound) {
        sound.disconnect();
      });
    } catch (e) {
      // disconnect() will throw if it was never connected initially.
      warn('Audio source not properly disconnected');
    }
  },

  /**
  *  Update listener attached to the user defined on event.
  */
  updateEventListener: function (oldEvt) {
    var el = this.el;
    if (oldEvt) { el.removeEventListener(oldEvt, this.playSound); }
    el.addEventListener(this.data.on, this.playSound);
  },

  removeEventListener: function () {
    this.el.removeEventListener(this.data.on, this.playSound);
  },

  /**
   * Removes current sound object, creates new sound object, adds to entity.
   *
   * @returns {object} sound
   */
  setupSound: function () {
    var el = this.el;
    var sceneEl = el.sceneEl;

    if (this.pool.children.length > 0) {
      this.stopSound();
      el.removeObject3D('sound');
    }

    // Only want one AudioListener. Cache it on the scene.
    var listener = this.listener = sceneEl.audioListener || new THREE.AudioListener();
    sceneEl.audioListener = listener;

    if (sceneEl.camera) {
      sceneEl.camera.add(listener);
    }

    // Wait for camera if necessary.
    sceneEl.addEventListener('camera-set-active', function (evt) {
      evt.detail.cameraEl.getObject3D('camera').add(listener);
    });

    // Create [poolSize] audio instances and attach them to pool
    this.pool = new THREE.Group();
    for (var i = 0; i < this.data.poolSize; i++) {
      var sound = new THREE.PositionalAudio(listener);
      this.pool.add(sound);
    }
    el.setObject3D(this.attrName, this.pool);

    this.pool.children.forEach(function (sound) {
      sound.onEnded = function () {
        sound.isPlaying = false;
        el.emit('sound-ended', {index: i});
      };
    });
  },

  /**
   * Pause all the sounds in the pool.
   */
  pauseSound: function () {
    this.pool.children.forEach(function (sound) {
      if (!sound.source || !sound.source.buffer || !sound.isPlaying || !sound.pause) { return; }
      sound.pause();
    });
  },

  /**
   * Look for an unused sound in the pool and play it if found.
   */
  playSound: function () {
    var found = false;
    this.pool.children.forEach(function (sound) {
      if (!sound.isPlaying && sound.buffer && !found) {
        sound.play();
        found = true;
        return;
      }
    });

    if (!found) {
      warn('All the sounds are playing. If you need to play more sounds simultaneously ' +
           'consider increasing the size of pool with the `poolSize` attribute.');
    }
  },

  /**
   * Stop all the sounds in the pool.
   */
  stopSound: function () {
    this.pool.children.forEach(function (sound) {
      if (!sound.source || !sound.source.buffer) { return; }
      sound.stop();
    });
  }
});

},{"../core/component":100,"../lib/three":146,"../utils/bind":161,"../utils/debug":163}],85:[function(_dereq_,module,exports){
var createTextGeometry = _dereq_('three-bmfont-text');
var loadBMFont = _dereq_('load-bmfont');
var path = _dereq_('path');

var registerComponent = _dereq_('../core/component').registerComponent;
var coreShader = _dereq_('../core/shader');
var THREE = _dereq_('../lib/three');
var utils = _dereq_('../utils/');

var error = utils.debug('components:text:error');
var shaders = coreShader.shaders;
var warn = utils.debug('components:text:warn');

// 1 to match other A-Frame default widths.
var DEFAULT_WIDTH = 1;

// @bryik set anisotropy to 16. Improves look of large amounts of text when viewed from angle.
var MAX_ANISOTROPY = 16;

var FONT_BASE_URL = 'https://cdn.aframe.io/fonts/';
var FONTS = {
  aileronsemibold: FONT_BASE_URL + 'Aileron-Semibold.fnt',
  dejavu: FONT_BASE_URL + 'DejaVu-sdf.fnt',
  exo2bold: FONT_BASE_URL + 'Exo2Bold.fnt',
  exo2semibold: FONT_BASE_URL + 'Exo2SemiBold.fnt',
  kelsonsans: FONT_BASE_URL + 'KelsonSans.fnt',
  monoid: FONT_BASE_URL + 'Monoid.fnt',
  mozillavr: FONT_BASE_URL + 'mozillavr.fnt',
  roboto: FONT_BASE_URL + 'Roboto-msdf.json',
  sourcecodepro: FONT_BASE_URL + 'SourceCodePro.fnt'
};
var MSDF_FONTS = ['roboto'];
var DEFAULT_FONT = 'roboto';
module.exports.FONTS = FONTS;

var cache = new PromiseCache();
var fontWidthFactors = {};

/**
 * SDF-based text component.
 * Based on https://github.com/Jam3/three-bmfont-text.
 *
 * All the stock fonts are for the `sdf` registered shader, an improved version of jam3's
 * original `sdf` shader.
 */
module.exports.Component = registerComponent('text', {
  multiple: true,

  schema: {
    align: {type: 'string', default: 'left', oneOf: ['left', 'right', 'center']},
    alphaTest: {default: 0.5},
    // `anchor` defaults to center to match geometries.
    anchor: {default: 'center', oneOf: ['left', 'right', 'center', 'align']},
    baseline: {default: 'center', oneOf: ['top', 'center', 'bottom']},
    color: {type: 'color', default: '#FFF'},
    font: {type: 'string', default: DEFAULT_FONT},
    // `fontImage` defaults to the font name as a .png (e.g., mozillavr.fnt -> mozillavr.png).
    fontImage: {type: 'string'},
    // `height` has no default, will be populated at layout.
    height: {type: 'number'},
    letterSpacing: {type: 'number', default: 0},
    // `lineHeight` defaults to font's `lineHeight` value.
    lineHeight: {type: 'number'},
    opacity: {type: 'number', default: '1.0'},
    shader: {default: 'sdf', oneOf: shaders},
    side: {default: 'front', oneOf: ['front', 'back', 'double']},
    tabSize: {default: 4},
    transparent: {default: true},
    value: {type: 'string'},
    whiteSpace: {default: 'normal', oneOf: ['normal', 'pre', 'nowrap']},
    // `width` defaults to geometry width if present, else `DEFAULT_WIDTH`.
    width: {type: 'number'},
    // `wrapCount` units are about one default font character. Wrap roughly at this number.
    wrapCount: {type: 'number', default: 40},
    // `wrapPixels` will wrap using bmfont pixel units (e.g., dejavu's is 32 pixels).
    wrapPixels: {type: 'number'},
    // `yOffset` to adjust generated fonts from tools that may have incorrect metrics.
    yOffset: {type: 'number', default: 0},
    // `zOffset` will provide a small z offset to avoid z-fighting.
    zOffset: {type: 'number', default: 0.001}
  },

  init: function () {
    this.texture = new THREE.Texture();
    this.texture.anisotropy = MAX_ANISOTROPY;

    this.geometry = createTextGeometry();

    this.createOrUpdateMaterial();
    this.mesh = new THREE.Mesh(this.geometry, this.material);
    this.el.setObject3D(this.attrName, this.mesh);
  },

  update: function (oldData) {
    var data = coerceData(this.data);
    var font = this.currentFont;

    // Update material.
    this.createOrUpdateMaterial();

    // New font. `updateFont` will later change data and layout.
    if (oldData.font !== data.font) {
      this.updateFont();
      return;
    }

    // Update geometry and layout.
    if (font) {
      updateGeometry(this.geometry, data, font);
      this.updateLayout(data);
    }
  },

  /**
   * Clean up geometry, material, texture, mesh, objects.
   */
  remove: function () {
    this.geometry.dispose();
    this.geometry = null;
    this.el.removeObject3D(this.attrName);
    this.material.dispose();
    this.material = null;
    this.texture.dispose();
    this.texture = null;
    if (this.shaderObject) {
      delete this.shaderObject;
    }
  },

  /**
   * Update the shader of the material.
   */
  createOrUpdateMaterial: function () {
    var data = this.data;
    var hasChangedShader;
    var material = this.material;
    var NewShader;
    var shaderData;
    var shaderName;

    // Infer shader if using a stock font (or from `-msdf` filename convention).
    shaderName = data.shader;
    if (MSDF_FONTS.indexOf(data.font) !== -1 || data.font.indexOf('-msdf.') >= 0) {
      shaderName = 'msdf';
    } else if (data.font in FONTS && MSDF_FONTS.indexOf(data.font) === -1) {
      shaderName = 'sdf';
    }

    hasChangedShader = (this.shaderObject && this.shaderObject.name) !== shaderName;
    shaderData = {
      alphaTest: data.alphaTest,
      color: data.color,
      map: this.texture,
      opacity: data.opacity,
      side: parseSide(data.side),
      transparent: data.transparent
    };

    // Shader has not changed, do an update.
    if (!hasChangedShader) {
      // Update shader material.
      this.shaderObject.update(shaderData);
      // Apparently, was not set on `init` nor `update`.
      material.transparent = shaderData.transparent;
      updateBaseMaterial(material, shaderData);
      return;
    }

    // Shader has changed. Create a shader material.
    NewShader = createShader(this.el, shaderName, shaderData);
    this.material = NewShader.material;
    this.shaderObject = NewShader.shader;

    // Set new shader material.
    updateBaseMaterial(this.material, shaderData);
    if (this.mesh) { this.mesh.material = this.material; }
  },

  /**
   * Load font for geometry, load font image for material, and apply.
   */
  updateFont: function () {
    var data = this.data;
    var el = this.el;
    var fontSrc;
    var geometry = this.geometry;
    var self = this;

    if (!data.font) { warn('No font specified. Using the default font.'); }

    // Make invisible during font swap.
    this.mesh.visible = false;

    // Look up font URL to use, and perform cached load.
    fontSrc = this.lookupFont(data.font || DEFAULT_FONT) || data.font;
    cache.get(fontSrc, function doLoadFont () {
      return loadFont(fontSrc, data.yOffset);
    }).then(function setFont (font) {
      var coercedData;
      var fontImgSrc;

      if (font.pages.length !== 1) {
        throw new Error('Currently only single-page bitmap fonts are supported.');
      }

      if (!fontWidthFactors[fontSrc]) {
        font.widthFactor = fontWidthFactors[font] = computeFontWidthFactor(font);
      }

      // Update geometry given font metrics.
      coercedData = coerceData(data);
      updateGeometry(geometry, data, font);

      // Set font and update layout.
      self.currentFont = font;
      self.updateLayout(coercedData);

      // Look up font image URL to use, and perform cached load.
      fontImgSrc = data.fontImage || fontSrc.replace(/(\.fnt)|(\.json)/, '.png') ||
                   path.dirname(data.font) + '/' + font.pages[0];
      cache.get(fontImgSrc, function () {
        return loadTexture(fontImgSrc);
      }).then(function (image) {
        // Make mesh visible and apply font image as texture.
        self.mesh.visible = true;
        self.texture.image = image;
        self.texture.needsUpdate = true;
        el.emit('textfontset', {font: data.font, fontObj: font});
      }).catch(function (err) {
        error(err);
        throw err;
      });
    }).catch(function (err) {
      error(err);
      throw err;
    });
  },

  /**
   * Update layout with anchor, alignment, baseline, and considering any meshes.
   */
  updateLayout: function (data) {
    var anchor;
    var baseline;
    var el = this.el;
    var geometry = this.geometry;
    var geometryComponent = el.getAttribute('geometry');
    var height;
    var layout = geometry.layout;
    var mesh = this.mesh;
    var textRenderWidth;
    var textScale;
    var width;
    var x;
    var y;

    // Determine width to use (defined width, geometry's width, or default width).
    geometryComponent = el.getAttribute('geometry');
    width = data.width || (geometryComponent && geometryComponent.width) || DEFAULT_WIDTH;

    // Determine wrap pixel count. Either specified or by experimental fudge factor.
    // Note that experimental factor will never be correct for variable width fonts.
    textRenderWidth = computeWidth(data.wrapPixels, data.wrapCount,
                                   this.currentFont.widthFactor);
    textScale = width / textRenderWidth;

    // Determine height to use.
    height = textScale * (layout.height + layout.descender);

    // Update geometry dimensions to match text layout if width and height are set to 0.
    // For example, scales a plane to fit text.
    if (geometryComponent) {
      if (!geometryComponent.width) { el.setAttribute('geometry', 'width', width); }
      if (!geometryComponent.height) { el.setAttribute('geometry', 'height', height); }
    }

    // Calculate X position to anchor text left, center, or right.
    anchor = data.anchor === 'align' ? data.align : data.anchor;
    if (anchor === 'left') {
      x = 0;
    } else if (anchor === 'right') {
      x = -1 * layout.width;
    } else if (anchor === 'center') {
      x = -1 * layout.width / 2;
    } else {
      throw new TypeError('Invalid text.anchor property value', anchor);
    }

    // Calculate Y position to anchor text top, center, or bottom.
    baseline = data.baseline;
    if (baseline === 'bottom') {
      y = 0;
    } else if (baseline === 'top') {
      y = -1 * layout.height + layout.ascender;
    } else if (baseline === 'center') {
      y = -1 * layout.height / 2;
    } else {
      throw new TypeError('Invalid text.baseline property value', baseline);
    }

    // Position and scale mesh to apply layout.
    mesh.position.x = x * textScale;
    mesh.position.y = y * textScale;
    // Place text slightly in front to avoid Z-fighting.
    mesh.position.z = data.zOffset;
    mesh.scale.set(textScale, -1 * textScale, textScale);
    this.geometry.computeBoundingSphere();
  },

  /**
   * Grab font from the constant.
   * Set as a method for test stubbing purposes.
   */
  lookupFont: function (key) {
    return FONTS[key];
  }
});

function parseSide (side) {
  switch (side) {
    case 'back': {
      return THREE.BackSide;
    }
    case 'double': {
      return THREE.DoubleSide;
    }
    default: {
      return THREE.FrontSide;
    }
  }
}

/**
 * Coerce some data to numbers.
 * as they will be passed directly into text creation and update
 */
function coerceData (data) {
  data = utils.clone(data);
  if (data.lineHeight !== undefined) {
    data.lineHeight = parseFloat(data.lineHeight);
    if (!isFinite(data.lineHeight)) { data.lineHeight = undefined; }
  }
  if (data.width !== undefined) {
    data.width = parseFloat(data.width);
    if (!isFinite(data.width)) { data.width = undefined; }
  }
  return data;
}

/**
 * @returns {Promise}
 */
function loadFont (src, yOffset) {
  return new Promise(function (resolve, reject) {
    loadBMFont(src, function (err, font) {
      if (err) {
        error('Error loading font', src);
        reject(err);
        return;
      }

      // Fix negative Y offsets for Roboto MSDF font from tool. Experimentally determined.
      if (src.indexOf('/Roboto-msdf.json') >= 0) { yOffset = 30; }
      if (yOffset) { font.chars.map(function doOffset (ch) { ch.yoffset += yOffset; }); }

      resolve(font);
    });
  });
}

/**
 * @returns {Promise}
 */
function loadTexture (src) {
  return new Promise(function (resolve, reject) {
    new THREE.ImageLoader().load(src, function (image) {
      resolve(image);
    }, undefined, function () {
      error('Error loading font image', src);
      reject(null);
    });
  });
}

function createShader (el, shaderName, data) {
  var shader;
  var shaderObject;

  // Set up Shader.
  shaderObject = new shaders[shaderName].Shader();
  shaderObject.el = el;
  shaderObject.init(data);
  shaderObject.update(data);

  // Get material.
  shader = shaderObject.material;
  // Apparently, was not set on `init` nor `update`.
  shader.transparent = data.transparent;

  return {
    material: shader,
    shader: shaderObject
  };
}

/**
 * @todo Add more supported material properties (e.g., `visible`).
 */
function updateBaseMaterial (material, data) {
  material.side = data.side;
}

/**
 * Update the text geometry using `three-bmfont-text.update`.
 */
function updateGeometry (geometry, data, font) {
  geometry.update(utils.extend({}, data, {
    font: font,
    width: computeWidth(data.wrapPixels, data.wrapCount, font.widthFactor),
    text: data.value.replace(/\\n/g, '\n').replace(/\\t/g, '\t'),
    lineHeight: data.lineHeight || font.common.lineHeight
  }));
}

/**
 * Determine wrap pixel count. Either specified or by experimental fudge factor.
 * Note that experimental factor will never be correct for variable width fonts.
 */
function computeWidth (wrapPixels, wrapCount, widthFactor) {
  return wrapPixels || ((0.5 + wrapCount) * widthFactor);
}

/**
 * Compute default font width factor to use.
 */
function computeFontWidthFactor (font) {
  var sum = 0;
  var digitsum = 0;
  var digits = 0;
  font.chars.map(function (ch) {
    sum += ch.xadvance;
    if (ch.id >= 48 && ch.id <= 57) {
      digits++;
      digitsum += ch.xadvance;
    }
  });
  return digits ? digitsum / digits : sum / font.chars.length;
}

/**
 * Get or create a promise given a key and promise generator.
 * @todo Move to a utility and use in other parts of A-Frame.
 */
function PromiseCache () {
  var cache = this.cache = {};

  this.get = function (key, promiseGenerator) {
    if (key in cache) {
      return cache[key];
    }
    cache[key] = promiseGenerator();
    return cache[key];
  };
}

},{"../core/component":100,"../core/shader":109,"../lib/three":146,"../utils/":167,"load-bmfont":26,"path":8,"three-bmfont-text":38}],86:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../core/component').registerComponent;
var THREE = _dereq_('../lib/three');

/**
 * Tracked controls component.
 * Interface with the gamepad API to handled tracked controllers.
 * Select the appropriate controller and apply pose to the entity.
 * Observe buttons state and emit appropriate events.
 *
 * @property {number} controller - Index of the controller in array returned by Gamepad API.
 * @property {string} id - Selected controller among those returned by Gamepad API.
 */
module.exports.Component = registerComponent('tracked-controls', {
  schema: {
    controller: {default: 0},
    id: {type: 'string', default: ''},
    idPrefix: {type: 'string', default: ''},
    rotationOffset: {default: 0}
  },

  init: function () {
    this.buttonStates = {};
    this.previousAxis = [];
    this.previousControllerPosition = new THREE.Vector3();
  },

  update: function () {
    var controllers = this.system.controllers;
    var data = this.data;
    controllers = controllers.filter(hasIdOrPrefix);
    // handId: 0 - right, 1 - left
    this.controller = controllers[data.controller];
    function hasIdOrPrefix (controller) { return data.idPrefix ? controller.id.indexOf(data.idPrefix) === 0 : controller.id === data.id; }
  },

  tick: function (time, delta) {
    var mesh = this.el.getObject3D('mesh');
    // Update mesh animations.
    if (mesh && mesh.update) { mesh.update(delta / 1000); }
    this.updatePose();
    this.updateButtons();
  },

  updatePose: (function () {
    var controllerEuler = new THREE.Euler();
    var controllerPosition = new THREE.Vector3();
    var controllerQuaternion = new THREE.Quaternion();
    var deltaControllerPosition = new THREE.Vector3();
    var dolly = new THREE.Object3D();
    var standingMatrix = new THREE.Matrix4();
    controllerEuler.order = 'YXZ';
    return function () {
      var controller;
      var pose;
      var orientation;
      var position;
      var el = this.el;
      var vrDisplay = this.system.vrDisplay;
      this.update();
      controller = this.controller;
      if (!controller) { return; }
      pose = controller.pose;
      orientation = pose.orientation || [0, 0, 0, 1];
      position = pose.position || [0, 0, 0];
      controllerQuaternion.fromArray(orientation);
      dolly.quaternion.fromArray(orientation);
      dolly.position.fromArray(position);
      dolly.updateMatrix();
      if (vrDisplay && vrDisplay.stageParameters) {
        standingMatrix.fromArray(vrDisplay.stageParameters.sittingToStandingTransform);
        dolly.applyMatrix(standingMatrix);
      }
      controllerEuler.setFromRotationMatrix(dolly.matrix);
      controllerPosition.setFromMatrixPosition(dolly.matrix);
      el.setAttribute('rotation', {
        x: THREE.Math.radToDeg(controllerEuler.x),
        y: THREE.Math.radToDeg(controllerEuler.y),
        z: THREE.Math.radToDeg(controllerEuler.z) + this.data.rotationOffset
      });

      deltaControllerPosition.copy(controllerPosition).sub(this.previousControllerPosition);
      this.previousControllerPosition.copy(controllerPosition);
      var currentPosition = el.getAttribute('position');

      el.setAttribute('position', {
        x: currentPosition.x + deltaControllerPosition.x,
        y: currentPosition.y + deltaControllerPosition.y,
        z: currentPosition.z + deltaControllerPosition.z
      });
    };
  })(),

  updateButtons: function () {
    var i;
    var buttonState;
    var controller = this.controller;
    if (!this.controller) { return; }
    for (i = 0; i < controller.buttons.length; ++i) {
      buttonState = controller.buttons[i];
      this.handleButton(i, buttonState);
    }
    this.handleAxes(controller.axes);
  },

  handleAxes: function (controllerAxes) {
    var previousAxis = this.previousAxis;
    var changed = false;
    var i;
    for (i = 0; i < controllerAxes.length; ++i) {
      if (previousAxis[i] !== controllerAxes[i]) {
        changed = true;
        break;
      }
    }
    if (!changed) { return; }
    this.previousAxis = controllerAxes.slice();
    this.el.emit('axismove', {axis: this.previousAxis});
  },

  handleButton: function (id, buttonState) {
    var changed = false;
    changed = changed || this.handlePress(id, buttonState);
    changed = changed || this.handleTouch(id, buttonState);
    changed = changed || this.handleValue(id, buttonState);
    if (!changed) { return; }
    this.el.emit('buttonchanged', {id: id, state: buttonState});
  },

  /**
   * Determine whether a button press has occured and emit events as appropriate.
   *
   * @param {string} id - id of the button to check.
   * @param {object} buttonState - state of the button to check.
   * @returns {boolean} true if button press state changed, false otherwise.
   */
  handlePress: function (id, buttonState) {
    var buttonStates = this.buttonStates;
    var evtName;
    var previousButtonState = buttonStates[id] = buttonStates[id] || {};
    if (buttonState.pressed === previousButtonState.pressed) { return false; }
    if (buttonState.pressed) {
      evtName = 'down';
    } else {
      evtName = 'up';
    }
    this.el.emit('button' + evtName, {id: id});
    previousButtonState.pressed = buttonState.pressed;
    return true;
  },

  /**
   * Determine whether a button touch has occured and emit events as appropriate.
   *
   * @param {string} id - id of the button to check.
   * @param {object} buttonState - state of the button to check.
   * @returns {boolean} true if button touch state changed, false otherwise.
   */
  handleTouch: function (id, buttonState) {
    var buttonStates = this.buttonStates;
    var evtName;
    var previousButtonState = buttonStates[id] = buttonStates[id] || {};
    if (buttonState.touched === previousButtonState.touched) { return false; }
    if (buttonState.touched) {
      evtName = 'start';
    } else {
      evtName = 'end';
    }
    previousButtonState.touched = buttonState.touched;
    this.el.emit('touch' + evtName, {id: id, state: previousButtonState});
    return true;
  },

  /**
   * Determine whether a button value has changed.
   *
   * @param {string} id - id of the button to check.
   * @param {object} buttonState - state of the button to check.
   * @returns {boolean} true if button value changed, false otherwise.
   */
  handleValue: function (id, buttonState) {
    var buttonStates = this.buttonStates;
    var previousButtonState = buttonStates[id] = buttonStates[id] || {};
    if (buttonState.value === previousButtonState.value) { return false; }
    previousButtonState.value = buttonState.value;
    return true;
  }
});

},{"../core/component":100,"../lib/three":146}],87:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../core/component').registerComponent;

/**
 * Visibility component.
 */
module.exports.Component = registerComponent('visible', {
  schema: {default: true},

  update: function () {
    this.el.object3D.visible = this.data;
  }
});

},{"../core/component":100}],88:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../core/component').registerComponent;
var bind = _dereq_('../utils/bind');
var isControllerPresent = _dereq_('../utils/tracked-controls').isControllerPresent;

var VIVE_CONTROLLER_MODEL_OBJ_URL = 'https://cdn.aframe.io/controllers/vive/vr_controller_vive.obj';
var VIVE_CONTROLLER_MODEL_OBJ_MTL = 'https://cdn.aframe.io/controllers/vive/vr_controller_vive.mtl';

var GAMEPAD_ID_PREFIX = 'OpenVR ';

/**
 * Vive Controls Component
 * Interfaces with vive controllers and maps Gamepad events to
 * common controller buttons: trackpad, trigger, grip, menu and system
 * It loads a controller model and highlights the pressed buttons
 */
module.exports.Component = registerComponent('vive-controls', {
  schema: {
    hand: {default: 'left'},
    buttonColor: {type: 'color', default: '#FAFAFA'},  // Off-white.
    buttonHighlightColor: {type: 'color', default: '#22D1EE'},  // Light blue.
    model: {default: true},
    rotationOffset: {default: 0} // use -999 as sentinel value to auto-determine based on hand
  },

  // buttonId
  // 0 - trackpad
  // 1 - trigger ( intensity value from 0.5 to 1 )
  // 2 - grip
  // 3 - menu ( dispatch but better for menu options )
  // 4 - system ( never dispatched on this layer )
  mapping: {
    axis0: 'trackpad',
    axis1: 'trackpad',
    button0: 'trackpad',
    button1: 'trigger',
    button2: 'grip',
    button3: 'menu',
    button4: 'system'
  },

  bindMethods: function () {
    this.onModelLoaded = bind(this.onModelLoaded, this);
    this.onControllersUpdate = bind(this.onControllersUpdate, this);
    this.checkIfControllerPresent = bind(this.checkIfControllerPresent, this);
    this.removeControllersUpdateListener = bind(this.removeControllersUpdateListener, this);
    this.onGamepadConnected = bind(this.onGamepadConnected, this);
    this.onGamepadDisconnected = bind(this.onGamepadDisconnected, this);
  },

  init: function () {
    var self = this;
    this.animationActive = 'pointing';
    this.onButtonChanged = bind(this.onButtonChanged, this);
    this.onButtonDown = function (evt) { self.onButtonEvent(evt.detail.id, 'down'); };
    this.onButtonUp = function (evt) { self.onButtonEvent(evt.detail.id, 'up'); };
    this.onButtonTouchStart = function (evt) { self.onButtonEvent(evt.detail.id, 'touchstart'); };
    this.onButtonTouchEnd = function (evt) { self.onButtonEvent(evt.detail.id, 'touchend'); };
    this.controllerPresent = false;
    this.everGotGamepadEvent = false;
    this.lastControllerCheck = 0;
    this.bindMethods();
    this.isControllerPresent = isControllerPresent; // to allow mock
  },

  addEventListeners: function () {
    var el = this.el;
    el.addEventListener('buttonchanged', this.onButtonChanged);
    el.addEventListener('buttondown', this.onButtonDown);
    el.addEventListener('buttonup', this.onButtonUp);
    el.addEventListener('touchstart', this.onButtonTouchStart);
    el.addEventListener('touchend', this.onButtonTouchEnd);
    el.addEventListener('model-loaded', this.onModelLoaded);
  },

  removeEventListeners: function () {
    var el = this.el;
    el.removeEventListener('buttonchanged', this.onButtonChanged);
    el.removeEventListener('buttondown', this.onButtonDown);
    el.removeEventListener('buttonup', this.onButtonUp);
    el.removeEventListener('touchstart', this.onButtonTouchStart);
    el.removeEventListener('touchend', this.onButtonTouchEnd);
    el.removeEventListener('model-loaded', this.onModelLoaded);
  },

  checkIfControllerPresent: function () {
    var data = this.data;
    var controller = data.hand === 'right' ? 0 : data.hand === 'left' ? 1 : 2;
    var isPresent = this.isControllerPresent(this.el.sceneEl, GAMEPAD_ID_PREFIX, { index: controller });
    if (isPresent === this.controllerPresent) { return; }
    this.controllerPresent = isPresent;
    if (isPresent) { this.injectTrackedControls(); } // inject track-controls
  },

  onGamepadConnected: function (evt) {
    // for now, don't disable controller update listening, due to
    // apparent issue with FF Nightly only sending one event and seeing one controller;
    // this.everGotGamepadEvent = true;
    // this.removeControllersUpdateListener();
    this.checkIfControllerPresent();
  },

  onGamepadDisconnected: function (evt) {
    // for now, don't disable controller update listening, due to
    // apparent issue with FF Nightly only sending one event and seeing one controller;
    // this.everGotGamepadEvent = true;
    // this.removeControllersUpdateListener();
    this.checkIfControllerPresent();
  },

  play: function () {
    this.checkIfControllerPresent();
    window.addEventListener('gamepadconnected', this.onGamepadConnected, false);
    window.addEventListener('gamepaddisconnected', this.onGamepadDisconnected, false);
    this.addControllersUpdateListener();
    this.addEventListeners();
  },

  pause: function () {
    window.removeEventListener('gamepadconnected', this.onGamepadConnected, false);
    window.removeEventListener('gamepaddisconnected', this.onGamepadDisconnected, false);
    this.removeControllersUpdateListener();
    this.removeEventListeners();
  },

  injectTrackedControls: function () {
    var el = this.el;
    var data = this.data;
    // handId: 0 - right, 1 - left, 2 - anything else...
    var controller = data.hand === 'right' ? 0 : data.hand === 'left' ? 1 : 2;
    // if we have an OpenVR Gamepad, use the fixed mapping
    el.setAttribute('tracked-controls', {idPrefix: GAMEPAD_ID_PREFIX, controller: controller, rotationOffset: data.rotationOffset});
    if (!this.data.model) { return; }
    this.el.setAttribute('obj-model', {
      obj: VIVE_CONTROLLER_MODEL_OBJ_URL,
      mtl: VIVE_CONTROLLER_MODEL_OBJ_MTL
    });
  },

  addControllersUpdateListener: function () {
    this.el.sceneEl.addEventListener('controllersupdated', this.onControllersUpdate, false);
  },

  removeControllersUpdateListener: function () {
    this.el.sceneEl.removeEventListener('controllersupdated', this.onControllersUpdate, false);
  },

  onControllersUpdate: function () {
    if (!this.everGotGamepadEvent) { this.checkIfControllerPresent(); }
  },

  onButtonChanged: function (evt) {
    var button = this.mapping['button' + evt.detail.id];
    var buttonMeshes = this.buttonMeshes;
    var value;
    if (!button || !buttonMeshes || button !== 'trigger') { return; }
    value = evt.detail.state.value;
    buttonMeshes.trigger.rotation.x = -value * (Math.PI / 12);
  },

  onModelLoaded: function (evt) {
    var controllerObject3D = evt.detail.model;
    var buttonMeshes;
    if (!this.data.model) { return; }
    buttonMeshes = this.buttonMeshes = {};
    buttonMeshes.grip = {
      left: controllerObject3D.getObjectByName('leftgrip'),
      right: controllerObject3D.getObjectByName('rightgrip')
    };
    buttonMeshes.menu = controllerObject3D.getObjectByName('menubutton');
    buttonMeshes.system = controllerObject3D.getObjectByName('systembutton');
    buttonMeshes.trackpad = controllerObject3D.getObjectByName('touchpad');
    buttonMeshes.trigger = controllerObject3D.getObjectByName('trigger');
    // Offset pivot point
    controllerObject3D.position.set(0, -0.015, 0.04);
  },

  onButtonEvent: function (id, evtName) {
    var buttonName = this.mapping['button' + id];
    var i;
    if (Array.isArray(buttonName)) {
      for (i = 0; i < buttonName.length; i++) {
        this.el.emit(buttonName[i] + evtName);
      }
    } else {
      this.el.emit(buttonName + evtName);
    }
    this.updateModel(buttonName, evtName);
  },

  updateModel: function (buttonName, evtName) {
    var i;
    if (!this.data.model) { return; }
    if (Array.isArray(buttonName)) {
      for (i = 0; i < buttonName.length; i++) {
        this.updateButtonModel(buttonName[i], evtName);
      }
    } else {
      this.updateButtonModel(buttonName, evtName);
    }
  },

  updateButtonModel: function (buttonName, state) {
    var color = state === 'up' ? this.data.buttonColor : this.data.buttonHighlightColor;
    var buttonMeshes = this.buttonMeshes;
    if (!buttonMeshes) { return; }
    if (buttonName === 'grip') {
      buttonMeshes.grip.left.material.color.set(color);
      buttonMeshes.grip.right.material.color.set(color);
      return;
    }
    buttonMeshes[buttonName].material.color.set(color);
  }
});

},{"../core/component":100,"../utils/bind":161,"../utils/tracked-controls":171}],89:[function(_dereq_,module,exports){
var KEYCODE_TO_CODE = _dereq_('../constants').keyboardevent.KEYCODE_TO_CODE;
var registerComponent = _dereq_('../core/component').registerComponent;
var THREE = _dereq_('../lib/three');
var utils = _dereq_('../utils/');

var bind = utils.bind;
var shouldCaptureKeyEvent = utils.shouldCaptureKeyEvent;

var CLAMP_VELOCITY = 0.00001;
var MAX_DELTA = 0.2;

/**
 * WASD component to control entities using WASD keys.
 */
module.exports.Component = registerComponent('wasd-controls', {
  schema: {
    acceleration: {default: 65},
    adAxis: {default: 'x', oneOf: ['x', 'y', 'z']},
    adEnabled: {default: true},
    adInverted: {default: false},
    easing: {default: 20},
    enabled: {default: true},
    fly: {default: false},
    wsAxis: {default: 'z', oneOf: ['x', 'y', 'z']},
    wsEnabled: {default: true},
    wsInverted: {default: false}
  },

  init: function () {
    // To keep track of the pressed keys.
    this.keys = {};

    this.velocity = new THREE.Vector3();

    // Bind methods and add event listeners.
    this.onBlur = bind(this.onBlur, this);
    this.onFocus = bind(this.onFocus, this);
    this.onKeyDown = bind(this.onKeyDown, this);
    this.onKeyUp = bind(this.onKeyUp, this);
    this.onVisibilityChange = bind(this.onVisibilityChange, this);
    this.attachVisibilityEventListeners();
  },

  tick: function (time, delta) {
    var data = this.data;
    var el = this.el;
    var movementVector;
    var position;
    var velocity = this.velocity;

    // Use seconds.
    delta = delta / 1000;

    // Get velocity.
    this.updateVelocity(delta);
    if (!velocity[data.adAxis] && !velocity[data.wsAxis]) { return; }

    // Get movement vector and translate position.
    movementVector = this.getMovementVector(delta);
    position = el.getAttribute('position');
    el.setAttribute('position', {
      x: position.x + movementVector.x,
      y: position.y + movementVector.y,
      z: position.z + movementVector.z
    });
  },

  remove: function () {
    this.removeKeyEventListeners();
    this.removeVisibilityEventListeners();
  },

  play: function () {
    this.attachKeyEventListeners();
  },

  pause: function () {
    this.keys = {};
    this.removeKeyEventListeners();
  },

  updateVelocity: function (delta) {
    var acceleration;
    var adAxis;
    var adSign;
    var data = this.data;
    var keys = this.keys;
    var velocity = this.velocity;
    var wsAxis;
    var wsSign;

    adAxis = data.adAxis;
    wsAxis = data.wsAxis;

    // If FPS too low, reset velocity.
    if (delta > MAX_DELTA) {
      velocity[adAxis] = 0;
      velocity[wsAxis] = 0;
      return;
    }

    // Decay velocity.
    if (velocity[adAxis] !== 0) {
      velocity[adAxis] -= velocity[adAxis] * data.easing * delta;
    }
    if (velocity[wsAxis] !== 0) {
      velocity[wsAxis] -= velocity[wsAxis] * data.easing * delta;
    }

    // Clamp velocity easing.
    if (Math.abs(velocity[adAxis]) < CLAMP_VELOCITY) { velocity[adAxis] = 0; }
    if (Math.abs(velocity[wsAxis]) < CLAMP_VELOCITY) { velocity[wsAxis] = 0; }

    if (!data.enabled) { return; }

    // Update velocity using keys pressed.
    acceleration = data.acceleration;
    if (data.adEnabled) {
      adSign = data.adInverted ? -1 : 1;
      if (keys.KeyA || keys.ArrowLeft) { velocity[adAxis] -= adSign * acceleration * delta; }
      if (keys.KeyD || keys.ArrowRight) { velocity[adAxis] += adSign * acceleration * delta; }
    }
    if (data.wsEnabled) {
      wsSign = data.wsInverted ? -1 : 1;
      if (keys.KeyW || keys.ArrowUp) { velocity[wsAxis] -= wsSign * acceleration * delta; }
      if (keys.KeyS || keys.ArrowDown) { velocity[wsAxis] += wsSign * acceleration * delta; }
    }
  },

  getMovementVector: (function () {
    var directionVector = new THREE.Vector3(0, 0, 0);
    var rotationEuler = new THREE.Euler(0, 0, 0, 'YXZ');

    return function (delta) {
      var rotation = this.el.getAttribute('rotation');
      var velocity = this.velocity;

      directionVector.copy(velocity);
      directionVector.multiplyScalar(delta);

      // Absolute.
      if (!rotation) { return directionVector; }

      if (!this.data.fly) { rotation.x = 0; }

      // Transform direction relative to heading.
      rotationEuler.set(THREE.Math.degToRad(rotation.x), THREE.Math.degToRad(rotation.y), 0);
      directionVector.applyEuler(rotationEuler);
      return directionVector;
    };
  })(),

  attachVisibilityEventListeners: function () {
    window.addEventListener('blur', this.onBlur);
    window.addEventListener('focus', this.onFocus);
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  },

  removeVisibilityEventListeners: function () {
    window.removeEventListener('blur', this.onBlur);
    window.removeEventListener('focus', this.onFocus);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  },

  attachKeyEventListeners: function () {
    window.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('keyup', this.onKeyUp);
  },

  removeKeyEventListeners: function () {
    window.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('keyup', this.onKeyUp);
  },

  onBlur: function () {
    this.pause();
  },

  onFocus: function () {
    this.play();
  },

  onVisibilityChange: function () {
    if (document.hidden) {
      this.onBlur();
    } else {
      this.onFocus();
    }
  },

  onKeyDown: function (event) {
    var code;
    if (!shouldCaptureKeyEvent(event)) { return; }
    code = event.code || KEYCODE_TO_CODE[event.keyCode];
    this.keys[code] = true;
  },

  onKeyUp: function (event) {
    var code;
    code = event.code || KEYCODE_TO_CODE[event.keyCode];
    this.keys[code] = false;
  }
});

},{"../constants":91,"../core/component":100,"../lib/three":146,"../utils/":167}],90:[function(_dereq_,module,exports){
/**
 * Animation configuration options for TWEEN.js animations.
 * Used by `<a-animation>`.
 */
var TWEEN = _dereq_('tween.js');

var DIRECTIONS = {
  alternate: 'alternate',
  alternateReverse: 'alternate-reverse',
  normal: 'normal',
  reverse: 'reverse'
};

var EASING_FUNCTIONS = {
  'linear': TWEEN.Easing.Linear.None,

  'ease': TWEEN.Easing.Cubic.InOut,
  'ease-in': TWEEN.Easing.Cubic.In,
  'ease-out': TWEEN.Easing.Cubic.Out,
  'ease-in-out': TWEEN.Easing.Cubic.InOut,

  'ease-cubic': TWEEN.Easing.Cubic.In,
  'ease-in-cubic': TWEEN.Easing.Cubic.In,
  'ease-out-cubic': TWEEN.Easing.Cubic.Out,
  'ease-in-out-cubic': TWEEN.Easing.Cubic.InOut,

  'ease-quad': TWEEN.Easing.Quadratic.InOut,
  'ease-in-quad': TWEEN.Easing.Quadratic.In,
  'ease-out-quad': TWEEN.Easing.Quadratic.Out,
  'ease-in-out-quad': TWEEN.Easing.Quadratic.InOut,

  'ease-quart': TWEEN.Easing.Quartic.InOut,
  'ease-in-quart': TWEEN.Easing.Quartic.In,
  'ease-out-quart': TWEEN.Easing.Quartic.Out,
  'ease-in-out-quart': TWEEN.Easing.Quartic.InOut,

  'ease-quint': TWEEN.Easing.Quintic.InOut,
  'ease-in-quint': TWEEN.Easing.Quintic.In,
  'ease-out-quint': TWEEN.Easing.Quintic.Out,
  'ease-in-out-quint': TWEEN.Easing.Quintic.InOut,

  'ease-sine': TWEEN.Easing.Sinusoidal.InOut,
  'ease-in-sine': TWEEN.Easing.Sinusoidal.In,
  'ease-out-sine': TWEEN.Easing.Sinusoidal.Out,
  'ease-in-out-sine': TWEEN.Easing.Sinusoidal.InOut,

  'ease-expo': TWEEN.Easing.Exponential.InOut,
  'ease-in-expo': TWEEN.Easing.Exponential.In,
  'ease-out-expo': TWEEN.Easing.Exponential.Out,
  'ease-in-out-expo': TWEEN.Easing.Exponential.InOut,

  'ease-circ': TWEEN.Easing.Circular.InOut,
  'ease-in-circ': TWEEN.Easing.Circular.In,
  'ease-out-circ': TWEEN.Easing.Circular.Out,
  'ease-in-out-circ': TWEEN.Easing.Circular.InOut,

  'ease-elastic': TWEEN.Easing.Elastic.InOut,
  'ease-in-elastic': TWEEN.Easing.Elastic.In,
  'ease-out-elastic': TWEEN.Easing.Elastic.Out,
  'ease-in-out-elastic': TWEEN.Easing.Elastic.InOut,

  'ease-back': TWEEN.Easing.Back.InOut,
  'ease-in-back': TWEEN.Easing.Back.In,
  'ease-out-back': TWEEN.Easing.Back.Out,
  'ease-in-out-back': TWEEN.Easing.Back.InOut,

  'ease-bounce': TWEEN.Easing.Bounce.InOut,
  'ease-in-bounce': TWEEN.Easing.Bounce.In,
  'ease-out-bounce': TWEEN.Easing.Bounce.Out,
  'ease-in-out-bounce': TWEEN.Easing.Bounce.InOut
};

var FILLS = {
  backwards: 'backwards',
  both: 'both',
  forwards: 'forwards',
  none: 'none'
};

var REPEATS = {
  indefinite: 'indefinite'
};

var DEFAULTS = {
  attribute: 'rotation',
  begin: '',
  end: '',
  delay: 0,
  dur: 1000,
  easing: 'ease',
  direction: DIRECTIONS.normal,
  fill: FILLS.forwards,
  from: undefined,
  repeat: 0,
  to: undefined
};

module.exports.defaults = DEFAULTS;
module.exports.directions = DIRECTIONS;
module.exports.easingFunctions = EASING_FUNCTIONS;
module.exports.fills = FILLS;
module.exports.repeats = REPEATS;

},{"tween.js":49}],91:[function(_dereq_,module,exports){
module.exports = {
  AFRAME_INJECTED: 'aframe-injected',
  DEFAULT_CAMERA_HEIGHT: 1.6,
  animation: _dereq_('./animation'),
  keyboardevent: _dereq_('./keyboardevent')
};

},{"./animation":90,"./keyboardevent":92}],92:[function(_dereq_,module,exports){
module.exports = {
  // Tiny KeyboardEvent.code polyfill.
  KEYCODE_TO_CODE: {
    '38': 'ArrowUp',
    '37': 'ArrowLeft',
    '40': 'ArrowDown',
    '39': 'ArrowRight',
    '87': 'KeyW',
    '65': 'KeyA',
    '83': 'KeyS',
    '68': 'KeyD'
  }
};

},{}],93:[function(_dereq_,module,exports){
var ANode = _dereq_('./a-node');
var animationConstants = _dereq_('../constants/animation');
var coordinates = _dereq_('../utils/').coordinates;
var parseProperty = _dereq_('./schema').parseProperty;
var registerElement = _dereq_('./a-register-element').registerElement;
var TWEEN = _dereq_('tween.js');
var THREE = _dereq_('../lib/three');
var utils = _dereq_('../utils/');
var bind = utils.bind;

var getComponentProperty = utils.entity.getComponentProperty;
var DEFAULTS = animationConstants.defaults;
var DIRECTIONS = animationConstants.directions;
var EASING_FUNCTIONS = animationConstants.easingFunctions;
var FILLS = animationConstants.fills;
var REPEATS = animationConstants.repeats;
var isCoordinate = coordinates.isCoordinate;

/**
 * Animation element that applies Tween animation to parent element (entity).
 * Takes after the Web Animations spec.
 *
 * @member {number} count - Decrementing counter for how many cycles of animations left to
 *         run.
 * @member {Element} el - Entity which the animation is modifying.
 * @member initialValue - Value before animation started. Used to restore state.
 * @member {bool} isRunning - Whether animation is currently running.
 * @member {function} partialSetAttribute -
 *   setAttribute function that is agnostic to whether we are setting an attribute value
 *   or a component property value. The el and the attribute names are bundled with
 *   the function.
 * @member {object} tween - tween.js object.
 */
module.exports.AAnimation = registerElement('a-animation', {
  prototype: Object.create(ANode.prototype, {
    createdCallback: {
      value: function () {
        this.bindMethods();
        this.isRunning = false;
        this.partialSetAttribute = function () { /* no-op */ };
        this.tween = null;
      }
    },

    attachedCallback: {
      value: function () {
        this.el = this.parentNode;
        this.handleMixinUpdate();
        this.update();
        this.load();
      }
    },

    attributeChangedCallback: {
      value: function (attr, oldVal, newVal) {
        if (!this.hasLoaded || !this.isRunning) { return; }
        this.stop();
        this.handleMixinUpdate();
        this.update();
      }
    },

    detachedCallback: {
      value: function () {
        if (!this.isRunning) { return; }
        this.stop();
      }
    },

    /**
     * Builds a Tween object to handle animations.
     * Uses tween.js's from, to, delay, easing, repeat, onUpdate, and onComplete.
     * Note: tween.js takes objects for its `from` and `to` values.
     *
     * @returns {object}
     */
    getTween: {
      value: function () {
        var self = this;
        var data = self.data;
        var el = self.el;
        var animationValues;
        var attribute = data.attribute;
        var delay = parseInt(data.delay, 10);
        var currentValue = getComponentProperty(el, attribute);
        var direction = self.getDirection(data.direction);
        var easing = EASING_FUNCTIONS[data.easing];
        var fill = data.fill;
        var from;
        var repeat = data.repeat === REPEATS.indefinite ? Infinity : 0;
        var to;
        var toTemp;
        var yoyo = false;

        animationValues = getAnimationValues(el, attribute, data.from || self.initialValue, data.to, currentValue);
        from = animationValues.from;
        to = animationValues.to;
        self.partialSetAttribute = animationValues.partialSetAttribute;

        if (self.count === undefined) {
          self.count = repeat === Infinity ? 0 : parseInt(data.repeat, 10);
        }

        if (isNaN(delay)) { delay = 0; }

        // Store initial state.
        self.initialValue = self.initialValue || cloneValue(currentValue);

        // Handle indefinite + forwards + alternate yoyo edge-case (#405).
        if (repeat === Infinity && fill === FILLS.forwards &&
            [DIRECTIONS.alternate,
              DIRECTIONS.alternateReverse].indexOf(data.direction) !== -1) {
          yoyo = true;
        }

        // If reversing, swap from and to.
        if (direction === DIRECTIONS.reverse) {
          toTemp = to;
          to = cloneValue(from);
          from = cloneValue(toTemp);
        }

        // If fill is backwards or both, start animation at the specified from.
        if ([FILLS.backwards, FILLS.both].indexOf(fill) !== -1) {
          self.partialSetAttribute(from);
        }

        // Create Tween.
        return new TWEEN.Tween(cloneValue(from))
          .to(to, data.dur)
          .delay(delay)
          .easing(easing)
          .repeat(repeat)
          .yoyo(yoyo)
          .onUpdate(function () {
            self.partialSetAttribute(this);
          })
          .onComplete(bind(self.onCompleted, self));
      }
    },

    /**
     * Animation parameters changed. Stop current animation, get a new one, and start it.
     */
    update: {
      value: function () {
        var data = this.data;
        // Terminology warning if infinite used instead of indefinite
        if (data.repeat === 'infinite') {
          console.warn("Using 'infinite' as 'repeat' value is invalid.  Use 'indefinite' instead.");
        }
        // Deprecation warning for begin when used as a delay.
        if (data.begin !== '' && !isNaN(data.begin)) {
          console.warn("Using 'begin' to specify a delay is deprecated. Use 'delay' instead.");
          data.delay = data.begin;
          data.begin = '';
        }
        var begin = data.begin;
        var end = data.end;
        // Cancel previous event listeners
        if (this.evt) { this.removeEventListeners(this.evt); }
        // Store new event name.
        this.evt = {begin: begin, end: end};
        // Add new event listeners
        this.addEventListeners(this.evt);
        // If `begin` is not defined, start the animation right away.
        if (begin === '') {
          this.stop();
          this.start();
        }
      },
      writable: window.debug
    },

    /**
     * Callback for when a cycle of an animation is complete. Handles when to completely
     * finish the animation.
     *
     * If `repeat` is set to a value, this method is called after each repeat. Repeats are
     * handled by ending the current animation and creating a new one with `count` updated.
     * Note that this method is *not* called if repeat is set to `indefinite`.
     */
    onCompleted: {
      value: function () {
        var data = this.data;
        this.isRunning = false;
        if ([FILLS.backwards, FILLS.none].indexOf(data.fill) !== -1) {
          this.partialSetAttribute(this.initialValue);
        }
        if (this.count === 0) {
          this.count = undefined;
          this.emit('animationend');
          return;
        }
        this.isRunning = false;
        this.count--;
        this.start();
      }
    },

    start: {
      value: function () {
        var self = this;
        // Postpone animation start until the entity has loaded
        if (!this.el.hasLoaded) {
          this.el.addEventListener('loaded', function () { self.start(); });
          return;
        }
        if (this.isRunning || !this.el.isPlaying) { return; }
        this.tween = this.getTween();
        this.isRunning = true;
        this.tween.start();
        this.emit('animationstart');
      },
      writable: true
    },

    stop: {
      value: function () {
        var tween = this.tween;
        if (!tween) { return; }
        tween.stop();
        this.isRunning = false;
        if ([FILLS.backwards, FILLS.none].indexOf(this.data.fill) !== -1) {
          this.partialSetAttribute(this.initialValue);
        }
        this.emit('animationstop');
      },
      writable: true
    },

    /**
     * Handle alternating directions. Given the current direction, calculate the next one,
     * and store the current one.
     *
     * @param {string} direction
     * @returns {string} Direction that the next individual cycle of the animation will go
     *          towards.
     */
    getDirection: {
      value: function (direction) {
        if (direction === DIRECTIONS.alternate) {
          this.prevDirection =
            this.prevDirection === DIRECTIONS.normal ? DIRECTIONS.reverse : DIRECTIONS.normal;
          return this.prevDirection;
        }
        if (direction === DIRECTIONS.alternateReverse) {
          this.prevDirection =
            this.prevDirection === DIRECTIONS.reverse ? DIRECTIONS.normal : DIRECTIONS.reverse;
          return this.prevDirection;
        }
        return direction;
      }
    },

    /**
     * Preemptive binding to attach/detach event listeners (see `update`).
     */
    bindMethods: {
      value: function () {
        this.start = bind(this.start, this);
        this.stop = bind(this.stop, this);
        this.onStateAdded = bind(this.onStateAdded, this);
        this.onStateRemoved = bind(this.onStateRemoved, this);
      }
    },

    addEventListeners: {
      value: function (evts) {
        var el = this.el;
        var self = this;
        utils.splitString(evts.begin).forEach(function (evt) {
          el.addEventListener(evt, self.start);
        });
        utils.splitString(evts.end).forEach(function (evt) {
          el.addEventListener(evt, self.stop);
        });
        // If "begin" is an event name, wait. If it is not defined, start.
        if (evts.begin === '') { el.addEventListener('play', this.start); }
        el.addEventListener('pause', this.stop);
        el.addEventListener('stateadded', this.onStateAdded);
        el.addEventListener('stateremoved', this.onStateRemoved);
      }
    },

    removeEventListeners: {
      value: function (evts) {
        var el = this.el;
        var start = this.start;
        var stop = this.stop;
        utils.splitString(evts.begin).forEach(function (evt) {
          el.removeEventListener(evt, start);
        });
        utils.splitString(evts.end).forEach(function (evt) {
          el.removeEventListener(evt, stop);
        });
        el.removeEventListener('stateadded', this.onStateAdded);
        el.removeEventListener('stateremoved', this.onStateRemoved);
      }
    },

    onStateAdded: {
      value: function (evt) {
        if (evt.detail.state === this.data.begin) { this.start(); }
      },
      writable: true
    },

    onStateRemoved: {
      value: function (evt) {
        if (evt.detail.state === this.data.begin) { this.stop(); }
      },
      writable: true
    },

    /**
     * Applies animation data from a mixin element.
     * Works the same as component mixins but reimplemented because animations
     * aren't components.
     */
    handleMixinUpdate: {
      value: function () {
        var data = {};
        var elData;
        var mixinData;
        var mixinEl;

        // Get mixin data.
        mixinEl = document.querySelector('#' + this.getAttribute('mixin'));
        mixinData = mixinEl ? utils.getElData(mixinEl, DEFAULTS) : {};

        elData = utils.getElData(this, DEFAULTS);
        utils.extend(data, DEFAULTS, mixinData, elData);
        this.data = data;
      }
    }
  })
});

function cloneValue (val) {
  return utils.extend({}, val);
}

/**
 * Deduces different animation values based on whether we are:
 *   - animating an inner attribute of a component.
 *   - animating a coordinate component.
 *   - animating a boolean.
 *   - animating a number.
 *
 * @param {Element} el
 * @param {string} attribute - Tells what to animate based on whether it is dot-separated.
 * @param {string} dataFrom - Data `from` value.
 * @param {string} dataTo - Data `to` value.
 * @param currentValue
 * @returns {object}
 *   Object with keys [from, to, partialSetAttribute].
 *     `from` and `to`
 *        Objects where key is attribute being animated and value is value.
 *     `partialSetAttribute`
 *        Closured-function that tells tween how to update the component.
 */
function getAnimationValues (el, attribute, dataFrom, dataTo, currentValue) {
  var attributeSplit = attribute.split('.');
  var schema;
  var component;
  var componentPropName;
  var componentName;
  var from = {};
  var partialSetAttribute;
  var to = {};
  if (attributeSplit.length === 2) {
    if (isColor()) {
      getForColorComponent();
    } else {
      getForComponentAttribute();
    }
  } else if (dataTo && isCoordinate(dataTo)) {
    getForCoordinateComponent();
  } else if (['true', 'false'].indexOf(dataTo) !== -1) {
    getForBoolean();
  } else if (isNaN(dataTo)) {
    getForColorComponent();
  } else {
    getForNumber();
  }
  return {
    from: from,
    partialSetAttribute: partialSetAttribute,
    to: to
  };

  /**
   * Match the schema type to color
   * @return {bool} if the schema is of type color
   */
  function isColor () {
    var componentName = attributeSplit[0];
    var propertyName = attributeSplit[1];
    var component = el.components[componentName];
    var schema = component && component.schema;
    return schema && schema[propertyName] && schema[propertyName].type === 'color';
  }

  /**
   * Animating a component that has multiple attributes (e.g., geometry.width).
   */
  function getForComponentAttribute () {
    componentName = attributeSplit[0];
    componentPropName = attributeSplit[1];
    component = el.components[componentName];
    if (!component) {
      el.setAttribute(componentName, '');
      component = el.components[componentName];
    }
    schema = component.schema;
    if (dataFrom === undefined) {  // dataFrom can be 0.
      from[attribute] = getComponentProperty(el, attribute);
    } else {
      from[attribute] = dataFrom;
    }
    from[attribute] = parseProperty(from[attribute], schema[componentPropName]);
    to[attribute] = parseProperty(dataTo, schema[componentPropName]);
    partialSetAttribute = function (value) {
      if (!(attribute in value)) { return; }
      el.setAttribute(componentName, componentPropName, value[attribute]);
    };
  }

  /**
   * Animating a component that is an XYZ coordinate (e.g., position).
   * Will be tweening {x, y, z} all at once.
   */
  function getForCoordinateComponent () {
    from = dataFrom ? coordinates.parse(dataFrom) : currentValue;
    to = coordinates.parse(dataTo);
    partialSetAttribute = function (value) {
      el.setAttribute(attribute, value);
    };
  }

  /**
   * Animation a boolean (e.g., visible).
   * Have to convert from boolean to an integer (0 is false, > 0 is true) for tween.
   */
  function getForBoolean () {
    if (dataFrom === undefined) {
      from[attribute] = false;
    } else {
      from[attribute] = strToBool(dataFrom);
    }
    from[attribute] = boolToNum(from[attribute]);
    to[attribute] = boolToNum(strToBool(dataTo));
    partialSetAttribute = function (value) {
      el.setAttribute(attribute, !!value[attribute]);
    };
  }

  /**
   * Animating a color component
   *   Will convert a hex value to a THREE.Color
   *   Then converts to hex for the setAttribute
   */
  function getForColorComponent () {
    from = new THREE.Color(dataFrom);
    to = new THREE.Color(dataTo);
    partialSetAttribute = function (value) {
      if (attributeSplit.length > 1) {
        el.setAttribute(attributeSplit[0], attributeSplit[1], rgbVectorToHex(value));
      }
      el.setAttribute(attribute, rgbVectorToHex(value));
    };
  }

  /**
   * Animating a numbered attribute (e.g., opacity).
   */
  function getForNumber () {
    if (dataFrom === undefined) {  // dataFrom can be 0.
      from[attribute] = parseFloat(el.getAttribute(attribute));
    } else {
      from[attribute] = parseFloat(dataFrom);
    }
    to[attribute] = parseFloat(dataTo);
    partialSetAttribute = function (value) {
      el.setAttribute(attribute, value[attribute]);
    };
  }
}
module.exports.getAnimationValues = getAnimationValues;

/**
 * Converts string to bool.
 *
 * @param {string} str - `true` or `false`.
 * @returns {bool}
 */
function strToBool (str) {
  if (str === 'true') { return true; }
  return false;
}

/**
 * Converts boolean to number.
 *
 * @param {bool}
 * @returns {number}
 */
function boolToNum (bool) {
  return bool ? 1 : 0;
}

/**
 * Converts a number 0-255 to hex
 * @param {number} color number 0 - 255
 * @returns {string} hex value of number bassed
 */
function componentToHex (color) {
  var hex = color.toString(16);
  return hex.length === 1 ? '0' + hex : hex;
}

/**
 * Clamps a number to 0-1
 * Then converts that number to 0-255
 * @param {number} color number 0 - 1
 * @returns {number} color number 0 - 255
 */
function convertToIntegerColor (color) {
  return Math.floor(Math.min(Math.abs(color), 1) * 255);
}

/**
 * Converts a rgb object into a hex string
 * @param {object} color { r: 1, g: 1, b: 1 }
 * @returns {string} hex value #ffffff
 */
function rgbVectorToHex (color) {
  return '#' + ['r', 'g', 'b'].map(function (prop) {
    return componentToHex(convertToIntegerColor(color[prop]));
  }).join('');
}

},{"../constants/animation":90,"../lib/three":146,"../utils/":167,"./a-node":98,"./a-register-element":99,"./schema":108,"tween.js":49}],94:[function(_dereq_,module,exports){
var ANode = _dereq_('./a-node');
var bind = _dereq_('../utils/bind');
var debug = _dereq_('../utils/debug');
var registerElement = _dereq_('./a-register-element').registerElement;
var THREE = _dereq_('../lib/three');

var fileLoader = new THREE.FileLoader();
var warn = debug('core:a-assets:warn');

/**
 * Asset management system. Handles blocking on asset loading.
 */
module.exports = registerElement('a-assets', {
  prototype: Object.create(ANode.prototype, {
    createdCallback: {
      value: function () {
        this.isAssets = true;
        this.fileLoader = fileLoader;
        this.timeout = null;
      }
    },

    attachedCallback: {
      value: function () {
        var self = this;
        var i;
        var loaded = [];
        var mediaEl;
        var mediaEls;
        var imgEl;
        var imgEls;
        var timeout;

        if (!this.parentNode.isScene) {
          throw new Error('<a-assets> must be a child of a <a-scene>.');
        }

        // Wait for <img>s.
        imgEls = this.querySelectorAll('img');
        for (i = 0; i < imgEls.length; i++) {
          imgEl = fixUpMediaElement(imgEls[i]);
          loaded.push(new Promise(function (resolve, reject) {
            imgEl.onload = resolve;
            imgEl.onerror = reject;
          }));
        }

        // Wait for <audio>s and <video>s.
        mediaEls = this.querySelectorAll('audio, video');
        for (i = 0; i < mediaEls.length; i++) {
          mediaEl = fixUpMediaElement(mediaEls[i]);
          loaded.push(mediaElementLoaded(mediaEl));
        }

        // Trigger loaded for scene to start rendering.
        Promise.all(loaded).then(bind(this.load, this));

        // Timeout to start loading anyways.
        timeout = parseInt(this.getAttribute('timeout'), 10) || 3000;
        this.timeout = setTimeout(function () {
          if (self.hasLoaded) { return; }
          warn('Asset loading timed out in ', timeout, 'ms');
          self.emit('timeout');
          self.load();
        }, timeout);
      }
    },

    detachedCallback: {
      value: function () {
        if (this.timeout) { clearTimeout(this.timeout); }
      }
    },

    load: {
      value: function () {
        ANode.prototype.load.call(this, null, function waitOnFilter (el) {
          return el.isAssetItem && el.hasAttribute('src');
        });
      }
    }
  })
});

/**
 * Preload using XHRLoader for any type of asset.
 */
registerElement('a-asset-item', {
  prototype: Object.create(ANode.prototype, {
    createdCallback: {
      value: function () {
        this.data = null;
        this.isAssetItem = true;
      }
    },

    attachedCallback: {
      value: function () {
        var self = this;
        var src = this.getAttribute('src');
        fileLoader.load(src, function handleOnLoad (textResponse) {
          THREE.Cache.files[src] = textResponse;
          self.data = textResponse;
          /*
            Workaround for a Chrome bug. If another XHR is sent to the same url before the
            previous one closes, the second request never finishes.
            setTimeout finishes the first request and lets the logic triggered by load open
            subsequent requests.
            setTimeout can be removed once the fix for the bug below ships:
            https://bugs.chromium.org/p/chromium/issues/detail?id=633696&q=component%3ABlink%3ENetwork%3EXHR%20&colspec=ID%20Pri%20M%20Stars%20ReleaseBlock%20Component%20Status%20Owner%20Summary%20OS%20Modified
          */
          setTimeout(function load () { ANode.prototype.load.call(self); });
        }, function handleOnProgress (xhr) {
          self.emit('progress', {
            loadedBytes: xhr.loaded,
            totalBytes: xhr.total,
            xhr: xhr
          });
        }, function handleOnError (xhr) {
          self.emit('error', {xhr: xhr});
        });
      }
    }
  })
});

/**
 * Create a Promise that resolves once the media element has finished buffering.
 *
 * @param {Element} el - HTMLMediaElement.
 * @returns {Promise}
 */
function mediaElementLoaded (el) {
  if (!el.hasAttribute('autoplay') && el.getAttribute('preload') !== 'auto') {
    return;
  }

  // If media specifies autoplay or preload, wait until media is completely buffered.
  return new Promise(function (resolve, reject) {
    if (el.readyState === 4) { return resolve(); }  // Already loaded.
    if (el.error) { return reject(); }  // Error.

    el.addEventListener('loadeddata', checkProgress, false);
    el.addEventListener('progress', checkProgress, false);
    el.addEventListener('error', reject, false);

    function checkProgress () {
      // Add up the seconds buffered.
      var secondsBuffered = 0;
      for (var i = 0; i < el.buffered.length; i++) {
        secondsBuffered += el.buffered.end(i) - el.buffered.start(i);
      }

      // Compare seconds buffered to media duration.
      if (secondsBuffered >= el.duration) {
        resolve();
      }
    }
  });
}

/**
 * Automatically add attributes to media elements where convenient.
 * crossorigin, playsinline.
 */
function fixUpMediaElement (mediaEl) {
  // Cross-origin.
  var newMediaEl = setCrossOrigin(mediaEl);

  // Plays inline for mobile.
  if (newMediaEl.tagName === 'VIDEO') {
    newMediaEl.setAttribute('playsinline', '');
    newMediaEl.setAttribute('webkit-playsinline', '');
  }

  if (newMediaEl !== mediaEl) {
    mediaEl.parentNode.appendChild(newMediaEl);
    mediaEl.parentNode.removeChild(mediaEl);
  }
  return newMediaEl;
}

/**
 * Automatically set `crossorigin` if not defined on the media element.
 * If it is not defined, we must create and re-append a new media element <img> and
 * have the browser re-request it with `crossorigin` set.
 *
 * @param {Element} Media element (e.g., <img>, <audio>, <video>).
 * @returns {Element} Media element to be used to listen to for loaded events.
 */
function setCrossOrigin (mediaEl) {
  var newMediaEl;
  var src;

  // Already has crossorigin set.
  if (mediaEl.hasAttribute('crossorigin')) { return mediaEl; }

  src = mediaEl.getAttribute('src');

  if (src !== null) {
    // Does not have protocol.
    if (src.indexOf('://') === -1) { return mediaEl; }

    // Determine if cross origin is actually needed.
    if (extractDomain(src) === window.location.host) { return mediaEl; }
  }

  warn('Cross-origin element was requested without `crossorigin` set. ' +
       'A-Frame will re-request the asset with `crossorigin` attribute set.', src);
  mediaEl.crossOrigin = 'anonymous';
  newMediaEl = mediaEl.cloneNode(true);
  return newMediaEl;
}

/**
 * Extract domain out of URL.
 *
 * @param {string} url
 * @returns {string}
 */
function extractDomain (url) {
  // Find and remove protocol (e.g., http, ftp, etc.) to get domain.
  var domain = url.indexOf('://') > -1 ? url.split('/')[2] : url.split('/')[0];

  // Find and remove port number.
  return domain.split(':')[0];
}

},{"../lib/three":146,"../utils/bind":161,"../utils/debug":163,"./a-node":98,"./a-register-element":99}],95:[function(_dereq_,module,exports){
/* global HTMLElement */
var debug = _dereq_('../utils/debug');
var registerElement = _dereq_('./a-register-element').registerElement;

var warn = debug('core:cubemap:warn');

/**
 * Cubemap element that handles validation and exposes list of URLs.
 * Does not listen to updates.
 */
module.exports = registerElement('a-cubemap', {
  prototype: Object.create(HTMLElement.prototype, {
    /**
     * Calculates this.srcs.
     */
    attachedCallback: {
      value: function () {
        this.srcs = this.validate();
      },
      writable: window.debug
    },

    /**
     * Checks for exactly six elements with [src].
     * Does not check explicitly for <img>s in case user does not want
     * prefetching.
     *
     * @returns {Array|null} - six URLs if valid, else null.
     */
    validate: {
      value: function () {
        var elements = this.querySelectorAll('[src]');
        var i;
        var srcs = [];
        if (elements.length === 6) {
          for (i = 0; i < elements.length; i++) {
            srcs.push(elements[i].getAttribute('src'));
          }
          return srcs;
        }
        // Else if there are not six elements, throw a warning.
        warn(
          '<a-cubemap> did not contain exactly six elements each with a ' +
          '`src` attribute.');
      },
      writable: window.debug
    }
  })
});

},{"../utils/debug":163,"./a-register-element":99}],96:[function(_dereq_,module,exports){
/* global HTMLElement */
var ANode = _dereq_('./a-node');
var COMPONENTS = _dereq_('./component').components;
var registerElement = _dereq_('./a-register-element').registerElement;
var THREE = _dereq_('../lib/three');
var utils = _dereq_('../utils/');

var AEntity;
var bind = utils.bind;
var debug = utils.debug('core:a-entity:debug');
var warn = utils.debug('core:a-entity:warn');

var MULTIPLE_COMPONENT_DELIMITER = '__';

/**
 * Entity is a container object that components are plugged into to comprise everything in
 * the scene. In A-Frame, they inherently have position, rotation, and scale.
 *
 * To be able to take components, the scene element inherits from the entity definition.
 *
 * @member {object} components - entity's currently initialized components.
 * @member {object} object3D - three.js object.
 * @member {array} states
 * @member {boolean} isPlaying - false if dynamic behavior of the entity is paused.
 */
var proto = Object.create(ANode.prototype, {
  defaultComponents: {
    value: {
      position: '',
      rotation: '',
      scale: '',
      visible: ''
    }
  },

  createdCallback: {
    value: function () {
      this.components = {};
      this.isEntity = true;
      this.isPlaying = false;
      this.object3D = new THREE.Group();
      this.object3D.el = this;
      this.object3DMap = {};
      this.parentEl = null;
      this.states = [];
    }
  },

  /**
   * Handle changes coming from the browser DOM inspector.
   */
  attributeChangedCallback: {
    value: function (attr, oldVal, newVal) {
      var component = this.components[attr];
      // If the empty string is passed by the component initialization
      // logic we ignore the component update.
      if (component && component.justInitialized && newVal === '') {
        delete component.justInitialized;
        return;
      }
      // When a component is removed after calling el.removeAttribute('material')
      if (!component && newVal === null) { return; }
      this.setEntityAttribute(attr, oldVal, newVal);
    }
  },

  /**
   * Add to parent, load, play.
   */
  attachedCallback: {
    value: function () {
      var assetsEl;  // Asset management system element.
      var sceneEl = this.sceneEl;
      var self = this;  // Component.

      this.addToParent();

      // Don't .load() scene on attachedCallback.
      if (this.isScene) { return; }

      // Gracefully not error when outside of <a-scene> (e.g., tests).
      if (!sceneEl) {
        this.load();
        return;
      }

      // Wait for asset management system to finish before loading.
      assetsEl = sceneEl.querySelector('a-assets');
      if (assetsEl && !assetsEl.hasLoaded) {
        assetsEl.addEventListener('loaded', function () { self.load(); });
        return;
      }
      this.load();
    }
  },

  /**
   * Tell parent to remove this element's object3D from its object3D.
   * Do not call on scene element because that will cause a call to document.body.remove().
   */
  detachedCallback: {
    value: function () {
      if (!this.parentEl) { return; }

      // Remove components.
      Object.keys(this.components).forEach(bind(this.removeComponent, this));

      if (this.isScene) { return; }

      this.removeFromParent();
      ANode.prototype.detachedCallback.call(this);
    }
  },

  /**
   * Apply mixin to component.
   */
  handleMixinUpdate: {
    value: function (attrName) {
      if (!attrName) {
        this.updateComponents();
        return;
      }
      this.updateComponent(attrName, this.getDOMAttribute(attrName));
    }
  },

  mapStateMixins: {
    value: function (state, op) {
      var mixins = this.getAttribute('mixin');
      var mixinIds;
      if (!mixins) { return; }
      mixinIds = mixins.split(' ');
      mixinIds.forEach(function (id) {
        var mixinId = id + '-' + state;
        op(mixinId);
      });
      this.updateComponents();
    }
  },

  updateStateMixins: {
    value: function (newMixins, oldMixins) {
      var self = this;
      oldMixins = oldMixins || '';
      var newMixinsIds = newMixins.split(' ');
      var oldMixinsIds = oldMixins ? oldMixins.split(' ') : [];
      // The list of mixins that might have been removed on update
      var diff = oldMixinsIds.filter(function (i) { return newMixinsIds.indexOf(i) < 0; });
      // Remove the mixins that are gone on update
      diff.forEach(function (mixinId) {
        var forEach = Array.prototype.forEach;
        // State Mixins
        var stateMixinsEls = document.querySelectorAll('[id^=' + mixinId + '-]');
        forEach.call(stateMixinsEls, function (el) {
          self.unregisterMixin(el.id);
        });
      });
      this.states.forEach(function (state) {
        newMixinsIds.forEach(function (id) {
          var mixinId = id + '-' + state;
          self.registerMixin(mixinId);
        });
      });
    }
  },

  getObject3D: {
    value: function (type) {
      return this.object3DMap[type];
    }
  },

  /**
   * Set a THREE.Object3D into the map.
   *
   * @param {string} type - Developer-set name of the type of object, will be unique per type.
   * @param {object} obj - A THREE.Object3D.
   */
  setObject3D: {
    value: function (type, obj) {
      var oldObj;
      var self = this;

      if (!(obj instanceof THREE.Object3D)) {
        throw new Error(
          '`Entity.setObject3D` was called with an object that was not an instance of ' +
          'THREE.Object3D.'
        );
      }

      // Remove existing object of the type.
      oldObj = this.getObject3D(type);
      if (oldObj) { this.object3D.remove(oldObj); }

      // Set references to A-Frame entity.
      obj.el = this;
      if (obj.children.length) {
        obj.traverse(function bindEl (child) {
          child.el = self;
        });
      }

      // Add.
      this.object3D.add(obj);
      this.object3DMap[type] = obj;
      this.emit('object3dset', {object: obj, type: type});
    }
  },

  /**
   * Remove object from scene and entity object3D map.
   */
  removeObject3D: {
    value: function (type) {
      var obj = this.getObject3D(type);
      if (!obj) {
        warn('Tried to remove `Object3D` of type:', type, 'which was not defined.');
        return;
      }
      this.object3D.remove(obj);
      delete this.object3DMap[type];
      this.emit('object3dremove', {type: type});
    }
  },

  /**
   * Gets or creates an object3D of a given type.
   *
   * @param {string} type - Type of the object3D.
   * @param {string} Constructor - Constructor to use to create the object3D if needed.
   * @returns {object}
   */
  getOrCreateObject3D: {
    value: function (type, Constructor) {
      var object3D = this.getObject3D(type);
      if (!object3D && Constructor) {
        object3D = new Constructor();
        this.setObject3D(type, object3D);
      }
      return object3D;
    }
  },

  /**
   * Add child entity.
   *
   * @param {Element} el - Child entity.
   */
  add: {
    value: function (el) {
      if (!el.object3D) {
        throw new Error("Trying to add an element that doesn't have an `object3D`");
      }
      this.object3D.add(el.object3D);
      this.emit('child-attached', { el: el });
    }
  },

  /**
   * Tell parentNode to add this entity to itself.
   */
  addToParent: {
    value: function () {
      var parentNode = this.parentEl = this.parentNode;

      // `!parentNode` check primarily for unit tests.
      if (!parentNode || !parentNode.add || this.attachedToParent) { return; }

      parentNode.add(this);
      this.attachedToParent = true;  // To prevent multiple attachments to same parent.
    }
  },

  /**
   * Tell parentNode to remove this entity from itself.
   */
  removeFromParent: {
    value: function () {
      var parentEl = this.parentEl;
      this.parentEl.remove(this);
      this.attachedToParent = false;
      this.parentEl = this.parentNode = null;
      parentEl.emit('child-detached', {el: this});
    }
  },

  load: {
    value: function () {
      var self = this;

      if (this.hasLoaded) { return; }

      ANode.prototype.load.call(this, function entityLoadCallback () {
        self.updateComponents();
        if (self.isScene || self.parentEl.isPlaying) { self.play(); }
      });
    },
    writable: window.debug
  },

  /**
   * Remove child entity.
   *
   * @param {Element} el - Child entity.
   */
  remove: {
    value: function (el) {
      this.object3D.remove(el.object3D);
    }
  },

  /**
   * @returns {array} Direct children that are entities.
   */
  getChildEntities: {
    value: function () {
      var children = this.children;
      var childEntities = [];

      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        if (child instanceof AEntity) {
          childEntities.push(child);
        }
      }

      return childEntities;
    }
  },

  /**
   * Initialize component.
   *
   * @param {string} attrName - Attribute name asociated to the component.
   * @param {object} data - Component data
   * @param {boolean} isDependency - True if the component is a dependency.
   */
  initComponent: {
    value: function (attrName, data, isDependency) {
      var component;
      var componentInfo = attrName.split(MULTIPLE_COMPONENT_DELIMITER);
      var componentId = componentInfo[1];
      var componentName = componentInfo[0];
      var isComponentDefined = checkComponentDefined(this, attrName) || data !== undefined;

      // Not a registered component.
      if (!COMPONENTS[componentName]) { return; }

      // Component is not a dependency and is undefined.
      // If a component is a dependency, then it is okay to have no data.
      if (!isComponentDefined && !isDependency) { return; }

      // Component already initialized.
      if (attrName in this.components) { return; }

      // Initialize dependencies first
      this.initComponentDependencies(componentName);

      // If component name has an id we check component type multiplic
      if (componentId && !COMPONENTS[componentName].multiple) {
        throw new Error('Trying to initialize multiple ' +
                        'components of type `' + componentName +
                        '`. There can only be one component of this type per entity.');
      }
      component = this.components[attrName] = new COMPONENTS[componentName].Component(
        this, data, componentId);
      if (this.isPlaying) { component.play(); }

      // Components are reflected in the DOM as attributes but the state is not shown
      // hence we set the attribute to empty string.
      // The flag justInitialized is for attributeChangedCallback to not overwrite
      // the component with the empty string.
      if (!this.hasAttribute(attrName)) {
        component.justInitialized = true;
        HTMLElement.prototype.setAttribute.call(this, attrName, '');
      }

      debug('Component initialized: %s', attrName);
    },
    writable: window.debug
  },

  /**
   * Initialize dependencies of a component.
   *
   * @param {string} name - Root component name.
   */
  initComponentDependencies: {
    value: function (name) {
      var self = this;
      var component = COMPONENTS[name];
      var dependencies;

      // Not a component.
      if (!component) { return; }

      // No dependencies.
      dependencies = COMPONENTS[name].dependencies;

      if (!dependencies) { return; }

      // Initialize dependencies.
      dependencies.forEach(function initializeDependency (componentName) {
        // Call getAttribute to initialize the data from the DOM.
        self.initComponent(
          componentName,
          HTMLElement.prototype.getAttribute.call(self, componentName) || undefined,
          true
        );
      });
    }
  },

  removeComponent: {
    value: function (name) {
      var component;
      var isDefault;
      var isMixedIn;

      // Don't remove default or mixed-in components.
      isDefault = name in this.defaultComponents;
      isMixedIn = isComponentMixedIn(name, this.mixinEls);
      if (isDefault || isMixedIn) { return; }

      component = this.components[name];
      component.pause();
      component.remove();
      delete this.components[name];
      this.emit('componentremoved', {
        id: component.id,
        name: name
      });
    }
  },

  /**
   * Initialize or update all components.
   * Build data using initial components, defined attributes, mixins, and defaults.
   * Update default components before the rest.
   *
   * @member {function} getExtraComponents - Can be implemented to include component data
   *   from other sources (e.g., implemented by primitives).
   */
  updateComponents: {
    value: function () {
      var componentsToUpdate = {};
      var extraComponents = {};
      var i;
      var self = this;

      if (!this.hasLoaded) { return; }

      // Gather mixin-defined components.
      getMixedInComponents(this).forEach(addComponent);

      // Gather from extra initial component data if defined (e.g., primitives).
      if (this.getExtraComponents) {
        extraComponents = this.getExtraComponents();
        Object.keys(extraComponents).forEach(addComponent);
      }

      // Gather entity-defined components.
      for (i = 0; i < this.attributes.length; ++i) {
        addComponent(this.attributes[i].name);
      }

      // Initialze or update default components first.
      Object.keys(this.defaultComponents).forEach(doUpdateComponent);

      // Initialize or update rest of components.
      Object.keys(componentsToUpdate).forEach(doUpdateComponent);

      /**
       * Add component to the list to initialize or update.
       */
      function addComponent (componentName) {
        var name = componentName.split(MULTIPLE_COMPONENT_DELIMITER)[0];
        if (!COMPONENTS[name]) { return; }
        componentsToUpdate[componentName] = true;
      }

      /**
       * Get component data and initialize or update component.
       */
      function doUpdateComponent (name) {
        // Build defined component data.
        var data = mergeComponentData(self.getDOMAttribute(name), extraComponents[name]);
        delete componentsToUpdate[name];
        self.updateComponent(name, data);
      }
    }
  },

  /**
   * Initialize, update, or remove a single component.
   *
   * When initializing, we set the component on `this.components`.
   *
   * @param {string} attr - Component name.
   * @param {object} attrValue - The value of the DOM attribute.
   */
  updateComponent: {
    value: function (attr, attrValue) {
      var component = this.components[attr];
      var isDefault = attr in this.defaultComponents;
      if (component) {
        if (attrValue === null && !isDefault) {
          this.removeComponent(attr);
          return;
        }
        // Component already initialized. Update component.
        component.updateProperties(attrValue);
        return;
      }
      // Component not yet initialized. Initialize component.
      this.initComponent(attr, attrValue, false);
    }
  },

  /**
   * Updates one property of the component
   *
   * @param {string} name - Component name
   * @param {string} property - Component property name
   * @param {any} propertyValue - New property value
   */
  updateComponentProperty: {
    value: function (name, property, propertyValue) {
      var component = this.components[name];
      // Cached attribute value
      var attrValue = component && component.attrValue;
      // Copy cached value
      var componentObj = attrValue ? utils.extend({}, attrValue) : {};
      componentObj[property] = propertyValue;
      this.updateComponent(name, componentObj);
    }
  },

  /**
   * If `attr` is a component name, detach the component from the entity.
   *
   * If `propertyName` is given, reset the component property value to its default.
   *
   * @param {string} attr - Attribute name, which could also be a component name.
   * @param {string} propertyName - Component prop name, if resetting an individual prop.
   */
  removeAttribute: {
    value: function (attr, propertyName) {
      var component = this.components[attr];

      // Remove component.
      if (component && propertyName === undefined) {
        this.setEntityAttribute(attr, undefined, null);
        // Do not remove the component from the DOM if default component.
        if (this.components[attr]) { return; }
      }

      // Reset component property value.
      if (component && propertyName !== undefined) {
        component.resetProperty(propertyName);
        return;
      }

      HTMLElement.prototype.removeAttribute.call(this, attr);
    }
  },

  /**
   * Start dynamic behavior associated with entity such as dynamic components and animations.
   * Tell all children entities to also play.
   */
  play: {
    value: function () {
      var components = this.components;
      var componentKeys = Object.keys(components);

      // Already playing.
      if (this.isPlaying || !this.hasLoaded) { return; }
      this.isPlaying = true;

      // Wake up all components.
      componentKeys.forEach(function playComponent (key) {
        components[key].play();
      });

      // Tell all child entities to play.
      this.getChildEntities().forEach(function play (entity) {
        entity.play();
      });

      this.emit('play');
    },
    writable: true
  },

  /**
   * Pause dynamic behavior associated with entity such as dynamic components and animations.
   * Tell all children entities to also pause.
   */
  pause: {
    value: function () {
      var components = this.components;
      var componentKeys = Object.keys(components);

      if (!this.isPlaying) { return; }
      this.isPlaying = false;

      // Sleep all components.
      componentKeys.forEach(function pauseComponent (key) {
        components[key].pause();
      });

      // Tell all child entities to pause.
      this.getChildEntities().forEach(function pause (obj) {
        obj.pause();
      });

      this.emit('pause');
    },
    writable: true
  },

  /**
   * Deals with updates on entity-specific attributes (i.e., components and mixins).
   *
   * @param {string} attr
   * @param {string} oldVal
   * @param {string|object} newVal
   */
  setEntityAttribute: {
    value: function (attr, oldVal, newVal) {
      if (COMPONENTS[attr] || this.components[attr]) {
        this.updateComponent(attr, newVal);
        return;
      }
      if (attr === 'mixin') {
        this.mixinUpdate(newVal, oldVal);
        return;
      }
    }
  },

  mixinUpdate: {
    value: function (newMixins, oldMixins) {
      oldMixins = oldMixins || this.getAttribute('mixin');
      this.updateStateMixins(newMixins, oldMixins);
      this.updateComponents();
    }
  },

  /**
   * setAttribute can:
   *
   * 1. Set a single property of a multi-property component.
   * 2. Set multiple properties of a multi-property component.
   * 3. Replace properties of a multi-property component.
   * 4. Set a value for a single-property component, mixin, or normal HTML attribute.
   *
   * @param {string} attrName - Component or attribute name.
   * @param {string|object} arg1 - Can be a property name or object of properties.
   * @param {string|bool} arg2 - Can be a value, or boolean indicating whether to update or
   *   replace.
   */
  setAttribute: {
    value: function (attrName, arg1, arg2) {
      var componentName;
      var isDebugMode;

      // Determine which type of setAttribute to call based on the types of the arguments.
      componentName = attrName.split(MULTIPLE_COMPONENT_DELIMITER)[0];
      if (COMPONENTS[componentName]) {
        if (typeof arg1 === 'string' && typeof arg2 !== 'undefined') {
          singlePropertyUpdate(this, attrName, arg1, arg2);
        } else if (typeof arg1 === 'object' && arg2 === true) {
          multiPropertyClobber(this, attrName, arg1);
        } else {
          componentUpdate(this, attrName, arg1);
        }

        // In debug mode, write component data up to the DOM.
        isDebugMode = this.sceneEl && this.sceneEl.getAttribute('debug');
        if (isDebugMode) { this.components[attrName].flushToDOM(); }
        return;
      } else {
        normalSetAttribute(this, attrName, arg1);
      }

      /**
       * Just update one of the component properties.
       * >> setAttribute('foo', 'bar', 'baz')
       */
      function singlePropertyUpdate (el, componentName, propName, propertyValue) {
        el.updateComponentProperty(componentName, propName, propertyValue);
      }

      /**
       * Just update multiple component properties at once for a multi-property component.
       * >> setAttribute('foo', {bar: 'baz'})
       */
      function componentUpdate (el, componentName, propValue) {
        var component = el.components[componentName];
        if (component && typeof propValue === 'object') {
          // Extend existing component attribute value.
          el.updateComponent(
            componentName,
            utils.extendDeep(utils.extendDeep({}, component.attrValue), propValue));
        } else {
          el.updateComponent(componentName, propValue);
        }
      }

      /**
       * Pass in complete data set for a multi-property component.
       * >> setAttribute('foo', {bar: 'baz'}, true)
       */
      function multiPropertyClobber (el, componentName, propObject) {
        el.updateComponent(componentName, propObject);
      }

      /**
       * Just update one of the component properties.
       * >> setAttribute('id', 'myEntity')
       */
      function normalSetAttribute (el, attrName, value) {
        ANode.prototype.setAttribute.call(el, attrName, value);
        if (attrName === 'mixin') { el.mixinUpdate(value); }
      }
    },
    writable: window.debug
  },

  /**
   * Reflect component data in the DOM (as seen from the browser DOM Inspector).
   *
   * @param {bool} recursive - Also flushToDOM on the children.
   **/
  flushToDOM: {
    value: function (recursive) {
      var components = this.components;
      var defaultComponents = this.defaultComponents;
      var child;
      var children = this.children;
      var i;

      // Flush entity's components to DOM.
      Object.keys(components).forEach(function flushComponent (componentName) {
        components[componentName].flushToDOM(componentName in defaultComponents);
      });

      // Recurse.
      if (!recursive) { return; }
      for (i = 0; i < children.length; ++i) {
        child = children[i];
        if (!child.flushToDOM) { continue; }
        child.flushToDOM(recursive);
      }
    }
  },

  /**
   * If `attr` is a component, returns ALL component data including applied mixins and
   * defaults.
   *
   * If `attr` is not a component, fall back to HTML getAttribute.
   *
   * @param {string} attr
   * @returns {object|string} Object if component, else string.
   */
  getAttribute: {
    value: function (attr) {
      // If component, return component data.
      var component = this.components[attr];
      if (component) { return component.getData(); }
      return HTMLElement.prototype.getAttribute.call(this, attr);
    },
    writable: window.debug
  },

  /**
   * `getAttribute` used to be `getDOMAttribute` and `getComputedAttribute` used to be
   * what `getAttribute` is now. Now legacy code.
   *
   * @param {string} attr
   * @returns {object|string} Object if component, else string.
   */
  getComputedAttribute: {
    value: function (attr) {
      warn('`getComputedAttribute` is deprecated. Use `getAttribute` instead.');
      return this.getAttribute(attr);
    }
  },

  /**
   * If `attr` is a component, returns JUST the component data defined on the entity.
   * Like a partial version of `getComputedAttribute` as returned component data
   * does not include applied mixins or defaults.
   *
   * If `attr` is not a component, fall back to HTML getAttribute.
   *
   * @param {string} attr
   * @returns {object|string} Object if component, else string.
   */
  getDOMAttribute: {
    value: function (attr) {
      // If cached value exists, return partial component data.
      var component = this.components[attr];
      if (component) { return component.attrValue; }
      return HTMLElement.prototype.getAttribute.call(this, attr);
    },
    writable: window.debug
  },

  addState: {
    value: function (state) {
      if (this.is(state)) { return; }
      this.states.push(state);
      this.mapStateMixins(state, bind(this.registerMixin, this));
      this.emit('stateadded', {state: state});
    }
  },

  removeState: {
    value: function (state) {
      var stateIndex = this.states.indexOf(state);
      if (stateIndex === -1) { return; }
      this.states.splice(stateIndex, 1);
      this.mapStateMixins(state, bind(this.unregisterMixin, this));
      this.emit('stateremoved', {state: state});
    }
  },

  /**
   * Checks if the element is in a given state. e.g. el.is('alive');
   * @type {string} state - Name of the state we want to check
   */
  is: {
    value: function (state) {
      return this.states.indexOf(state) !== -1;
    }
  }
});

/**
 * Check if a component is *defined* for an entity, including defaults and mixins.
 * Does not check whether the component has been *initialized* for an entity.
 *
 * @param {string} el - Entity.
 * @param {string} name - Component name.
 * @returns {boolean}
 */
function checkComponentDefined (el, name) {
  // Check if default components contain the component.
  if (el.defaultComponents[name] !== undefined) { return true; }

  // Check if element contains the component.
  if (el.components[name] && el.components[name].attrValue) { return true; }

  return isComponentMixedIn(name, el.mixinEls);
}

function getMixedInComponents (entityEl) {
  var components = [];
  entityEl.mixinEls.forEach(function getMixedComponents (mixinEl) {
    Object.keys(mixinEl.componentCache).forEach(addComponent);
    function addComponent (key) {
      components.push(key);
    }
  });
  return components;
}

/**
 * Check if any mixins contains a component.
 *
 * @param {string} name - Component name.
 * @param {array} mixinEls - Array of <a-mixin>s.
 */
function isComponentMixedIn (name, mixinEls) {
  var i;
  var inMixin = false;
  for (i = 0; i < mixinEls.length; ++i) {
    inMixin = mixinEls[i].hasAttribute(name);
    if (inMixin) { break; }
  }
  return inMixin;
}

/**
 * Given entity defined value, merge in extra data if necessary.
 * Handle both single and multi-property components.
 *
 * @param {string} attrValue - Entity data.
 * @param extraData - Entity data from another source to merge in.
 */
function mergeComponentData (attrValue, extraData) {
  // Extra data not defined, just return attrValue.
  if (!extraData) { return attrValue; }

  // Merge multi-property data.
  if (extraData.constructor === Object) {
    return utils.extend(extraData, utils.styleParser.parse(attrValue || {}));
  }

  // Return data, precendence to the defined value.
  return attrValue || extraData;
}

AEntity = registerElement('a-entity', {
  prototype: proto
});
module.exports = AEntity;

},{"../lib/three":146,"../utils/":167,"./a-node":98,"./a-register-element":99,"./component":100}],97:[function(_dereq_,module,exports){
/* global HTMLElement */
var ANode = _dereq_('./a-node');
var registerElement = _dereq_('./a-register-element').registerElement;
var components = _dereq_('./component').components;

var MULTIPLE_COMPONENT_DELIMITER = '__';

/**
 * @member {object} componentCache - Cache of pre-parsed values. An object where the keys
 *         are component names and the values are already parsed by the component.
 */
module.exports = registerElement('a-mixin', {
  prototype: Object.create(ANode.prototype, {
    createdCallback: {
      value: function () {
        this.componentCache = {};
        this.id = this.getAttribute('id');
      }
    },

    attributeChangedCallback: {
      value: function (attr, oldVal, newVal) {
        this.cacheAttribute(attr, newVal);
      }
    },

    attachedCallback: {
      value: function () {
        this.sceneEl = this.closestScene();
        this.cacheAttributes();
        this.updateEntities();
        this.load();
      }
    },

    /**
     * setAttribute that parses and caches component values.
     */
    setAttribute: {
      value: function (attr, value) {
        this.cacheAttribute(attr, value);
        HTMLElement.prototype.setAttribute.call(this, attr, value);
      }
    },

    /**
     * If `attr` is a component, then parse the value using the schema and store it.
     */
    cacheAttribute: {
      value: function (attr, value) {
        var componentName = attr.split(MULTIPLE_COMPONENT_DELIMITER)[0];
        var component = components[componentName];
        if (!component) { return; }
        if (value === undefined) {
          value = HTMLElement.prototype.getAttribute.call(this, attr);
        }
        this.componentCache[attr] = component.parseAttrValueForCache(value);
      }
    },

    /**
     * If `attr` is a component, then grab pre-parsed value from the cache.
     * Else do a normal getAttribute.
     */
    getAttribute: {
      value: function (attr) {
        return this.componentCache[attr] ||
               HTMLElement.prototype.getAttribute.call(this, attr);
      }
    },

    /**
     * Parse and cache every component defined on the mixin.
     */
    cacheAttributes: {
      value: function () {
        var attributes = this.attributes;
        var attrName;
        var i;
        for (i = 0; i < attributes.length; i++) {
          attrName = attributes[i].name;
          this.cacheAttribute(attrName);
        }
      }
    },

    /**
     * For entities that already have been loaded by the time the mixin was attached, tell
     * those entities to register the mixin and refresh their component data.
     */
    updateEntities: {
      value: function () {
        if (!this.sceneEl) { return; }
        var entities = this.sceneEl.querySelectorAll('[mixin~=' + this.id + ']');
        for (var i = 0; i < entities.length; i++) {
          var entity = entities[i];
          if (!entity.hasLoaded) { continue; }
          entity.registerMixin(this.id);
          Object.keys(this.componentCache).forEach(function updateComponent (componentName) {
            entity.updateComponent(componentName);
          });
        }
      }
    }
  })
});

},{"./a-node":98,"./a-register-element":99,"./component":100}],98:[function(_dereq_,module,exports){
/* global HTMLElement, MutationObserver */
var registerElement = _dereq_('./a-register-element').registerElement;
var utils = _dereq_('../utils/');

var bind = utils.bind;
var warn = utils.debug('core:a-node:warn');

/**
 * Base class for A-Frame that manages loading of objects.
 *
 * Nodes can be modified using mixins.
 * Nodes emit a `loaded` event when they and their children have initialized.
 */
module.exports = registerElement('a-node', {
  prototype: Object.create(HTMLElement.prototype, {
    createdCallback: {
      value: function () {
        this.hasLoaded = false;
        this.isNode = true;
        this.mixinEls = [];
        this.mixinObservers = {};
      },
      writable: window.debug
    },

    attachedCallback: {
      value: function () {
        var mixins;
        this.sceneEl = this.closestScene();

        if (!this.sceneEl) {
          warn('You are attempting to attach <' + this.tagName + '> outside of an A-Frame ' +
               'scene. Append this element to `<a-scene>` instead.');
        }

        this.hasLoaded = false;
        this.emit('nodeready', {}, false);

        mixins = this.getAttribute('mixin');
        if (mixins) { this.updateMixins(mixins); }
      },
      writable: window.debug
    },

    attributeChangedCallback: {
      value: function (attr, oldVal, newVal) {
        if (attr === 'mixin') { this.updateMixins(newVal, oldVal); }
      }
    },

   /**
    * Returns the first scene by traversing up the tree starting from and
    * including receiver element.
    */
    closestScene: {
      value: function closest () {
        var element = this;
        while (element) {
          if (element.isScene) { break; }
          element = element.parentElement;
        }
        return element;
      }
    },

    /**
     * Returns first element matching a selector by traversing up the tree starting
     * from and including receiver element.
     *
     * @param {string} selector - Selector of element to find.
     */
    closest: {
      value: function closest (selector) {
        var matches = this.matches || this.mozMatchesSelector ||
          this.msMatchesSelector || this.oMatchesSelector || this.webkitMatchesSelector;
        var element = this;
        while (element) {
          if (matches.call(element, selector)) { break; }
          element = element.parentElement;
        }
        return element;
      }
    },

    detachedCallback: {
      value: function () {
        this.hasLoaded = false;
      }
    },

    /**
     * Wait for children to load, if any.
     * Then emit `loaded` event and set `hasLoaded`.
     */
    load: {
      value: function (cb, childFilter) {
        var children;
        var childrenLoaded;
        var self = this;

        if (this.hasLoaded) { return; }

        // Default to waiting for all nodes.
        childFilter = childFilter || function (el) { return el.isNode; };

        // Wait for children to load (if any), then load.
        children = this.getChildren();
        childrenLoaded = children.filter(childFilter).map(function (child) {
          return new Promise(function waitForLoaded (resolve) {
            if (child.hasLoaded) { return resolve(); }
            child.addEventListener('loaded', resolve);
          });
        });

        Promise.all(childrenLoaded).then(function emitLoaded () {
          self.hasLoaded = true;
          if (cb) { cb(); }
          self.emit('loaded', {}, false);
        });
      },
      writable: true
    },

    getChildren: {
      value: function () {
        return Array.prototype.slice.call(this.children, 0);
      }
    },

    updateMixins: {
      value: function (newMixins, oldMixins) {
        var newMixinsIds = newMixins ? newMixins.trim().split(/\s+/) : [];
        var oldMixinsIds = oldMixins ? oldMixins.trim().split(/\s+/) : [];
        // To determine what listeners will be removed
        var diff = oldMixinsIds.filter(function (i) { return newMixinsIds.indexOf(i) < 0; });
        this.mixinEls = [];
        diff.forEach(bind(this.unregisterMixin, this));
        newMixinsIds.forEach(bind(this.registerMixin, this));
      }
    },

    registerMixin: {
      value: function (mixinId) {
        if (!this.sceneEl) { return; }
        var mixinEl = this.sceneEl.querySelector('a-mixin#' + mixinId);
        if (!mixinEl) { return; }
        this.attachMixinListener(mixinEl);
        this.mixinEls.push(mixinEl);
      }
    },

    setAttribute: {
      value: function (attr, newValue) {
        if (attr === 'mixin') { this.updateMixins(newValue); }
        HTMLElement.prototype.setAttribute.call(this, attr, newValue);
      }
    },

    unregisterMixin: {
      value: function (mixinId) {
        var mixinEls = this.mixinEls;
        var mixinEl;
        var i;
        for (i = 0; i < mixinEls.length; ++i) {
          mixinEl = mixinEls[i];
          if (mixinId === mixinEl.id) {
            mixinEls.splice(i, 1);
            break;
          }
        }
        this.removeMixinListener(mixinId);
      }
    },

    removeMixinListener: {
      value: function (mixinId) {
        var observer = this.mixinObservers[mixinId];
        if (!observer) { return; }
        observer.disconnect();
        this.mixinObservers[mixinId] = null;
      }
    },

    attachMixinListener: {
      value: function (mixinEl) {
        var self = this;
        var mixinId = mixinEl.id;
        var currentObserver = this.mixinObservers[mixinId];
        if (!mixinEl) { return; }
        if (currentObserver) { return; }
        var observer = new MutationObserver(function (mutations) {
          var attr = mutations[0].attributeName;
          self.handleMixinUpdate(attr);
        });
        var config = { attributes: true };
        observer.observe(mixinEl, config);
        this.mixinObservers[mixinId] = observer;
      }
    },

    handleMixinUpdate: {
      value: function () { /* no-op */ }
    },

    /**
     * Emits a DOM event.
     *
     * @param {String} name
     *   Name of event (use a space-delimited string for multiple events).
     * @param {Object=} [detail={}]
     *   Custom data to pass as `detail` to the event.
     * @param {Boolean=} [bubbles=true]
     *   Whether the event should bubble.
     */
    emit: {
      value: function (name, detail, bubbles) {
        var self = this;
        detail = detail || {};
        if (bubbles === undefined) { bubbles = true; }
        var data = { bubbles: !!bubbles, detail: detail };
        return name.split(' ').map(function (eventName) {
          return utils.fireEvent(self, eventName, data);
        });
      }
    },

    /**
     * Returns a closure that emits a DOM event.
     *
     * @param {String} name
     *   Name of event (use a space-delimited string for multiple events).
     * @param {Object} detail
     *   Custom data (optional) to pass as `detail` if the event is to
     *   be a `CustomEvent`.
     * @param {Boolean} bubbles
     *   Whether the event should be bubble.
     */
    emitter: {
      value: function (name, detail, bubbles) {
        var self = this;
        return function () {
          self.emit(name, detail, bubbles);
        };
      }
    }
  })
});

},{"../utils/":167,"./a-register-element":99}],99:[function(_dereq_,module,exports){
/*
  ------------------------------------------------------------
  ------------- WARNING WARNING WARNING WARNING --------------
  ------------------------------------------------------------

  This module wraps registerElement to deal with components that inherit from
  `ANode` and `AEntity`.  It's a pass through in any other case.

  It wraps some of the prototype methods of the created element to make sure
  that the corresponding functions in the base prototypes (`AEntity` and `ANode`)
  are also invoked. The method in the base prototype is always called before the one
  in the derived prototype.
*/

// Polyfill `document.registerElement`.
_dereq_('document-register-element');

var ANode;  // Must declare before AEntity. Initialized at the bottom.
var AEntity;
var knownTags = module.exports.knownTags = {};

function addTagName (tagName) {
  knownTags[tagName.toLowerCase()] = true;
}

/**
 * Return whether the element type is one of our known registered ones.
 *
 * @param {string} node - The name of the tag to register.
 * @returns {boolean} Whether the tag name matches that of our registered custom elements.
 */
module.exports.isNode = function (node) {
  return node.tagName.toLowerCase() in knownTags || node.isNode;
};

/**
 * @param {string} tagName - The name of the tag to register.
 * @param {object} obj - The prototype of the new element.
 * @returns {object} The prototype of the new element.
 */
module.exports.registerElement = function (tagName, obj) {
  var proto = Object.getPrototypeOf(obj.prototype);
  var newObj = obj;
  var isANode = ANode && proto === ANode.prototype;
  var isAEntity = AEntity && proto === AEntity.prototype;

  if (isANode || isAEntity) { addTagName(tagName); }

  // Wrap if element inherits from `ANode`.
  if (isANode) {
    newObj = wrapANodeMethods(obj.prototype);
    newObj = {prototype: Object.create(proto, newObj)};
  }

  // Wrap if element inherits from `AEntity`.
  if (isAEntity) {
    newObj = wrapAEntityMethods(obj.prototype);
    newObj = {prototype: Object.create(proto, newObj)};
  }

  return document.registerElement(tagName, newObj);
};

/**
 * Wrap some obj methods to call those on `ANode` base prototype.
 *
 * @param {object} obj - Object that contains the methods that will be wrapped.
 * @return {object} An object with the same properties as the input parameter but
 * with some of methods wrapped.
 */
function wrapANodeMethods (obj) {
  var newObj = {};
  var ANodeMethods = [
    'attachedCallback',
    'attributeChangedCallback',
    'createdCallback'
  ];
  wrapMethods(newObj, ANodeMethods, obj, ANode.prototype);
  copyProperties(obj, newObj);
  return newObj;
}

/**
 * This wraps some of the obj methods to call those on `AEntity` base prototype.
 *
 * @param {object} obj - The objects that contains the methods that will be wrapped.
 * @return {object} - An object with the same properties as the input parameter but
 * with some of methods wrapped.
 */
function wrapAEntityMethods (obj) {
  var newObj = {};
  var ANodeMethods = [
    'attachedCallback',
    'attributeChangedCallback',
    'createdCallback'
  ];
  var AEntityMethods = [
    'attachedCallback',
    'attributeChangedCallback',
    'createdCallback',
    'detachedCallback'
  ];

  wrapMethods(newObj, ANodeMethods, obj, ANode.prototype);
  wrapMethods(newObj, AEntityMethods, obj, AEntity.prototype);
  // Copies the remaining properties into the new object.
  copyProperties(obj, newObj);
  return newObj;
}

/**
 * Wrap a list a methods to ensure that those in the base prototype are called
 * before the derived one.
 *
 * @param {object} targetObj - Object that will contain the wrapped methods.
 * @param {array} methodList - List of methods from the derivedObj that will be wrapped.
 * @param {object} derivedObject - Object that inherits from the baseObj.
 * @param {object} baseObj - Object that derivedObj inherits from.
 */
function wrapMethods (targetObj, methodList, derivedObj, baseObj) {
  methodList.forEach(function (methodName) {
    wrapMethod(targetObj, methodName, derivedObj, baseObj);
  });
}
module.exports.wrapMethods = wrapMethods;

/**
 * Wrap one method to ensure that the one in the base prototype is called before
 * the one in the derived one.
 *
 * @param {object} obj - Object that will contain the wrapped method.
 * @param {string} methodName - The name of the method that will be wrapped.
 * @param {object} derivedObject - Object that inherits from the baseObj.
 * @param {object} baseObj - Object that derivedObj inherits from.
 */
function wrapMethod (obj, methodName, derivedObj, baseObj) {
  var derivedMethod = derivedObj[methodName];
  var baseMethod = baseObj[methodName];

  // Derived prototype does not define method, no need to wrap.
  if (!derivedMethod || !baseMethod) { return; }

  // Derived prototype doesn't override the one in the base one, no need to wrap.
  if (derivedMethod === baseMethod) { return; }

  // Wrap to ensure the base method is called before the one in the derived prototype.
  obj[methodName] = {
    value: function wrappedMethod () {
      baseMethod.apply(this, arguments);
      return derivedMethod.apply(this, arguments);
    },
    writable: window.debug
  };
}

/**
 * It copies the properties from source to destination object if they don't
 * exist already.
 *
 * @param {object} source - The object where properties are copied from.
 * @param {type} destination - The object where properties are copied to.
 */
function copyProperties (source, destination) {
  var props = Object.getOwnPropertyNames(source);
  props.forEach(function (prop) {
    var desc;
    if (!destination[prop]) {
      desc = Object.getOwnPropertyDescriptor(source, prop);
      destination[prop] = {value: source[prop], writable: desc.writable};
    }
  });
}

ANode = _dereq_('./a-node');
AEntity = _dereq_('./a-entity');

},{"./a-entity":96,"./a-node":98,"document-register-element":16}],100:[function(_dereq_,module,exports){
/* global HTMLElement, Node */
var schema = _dereq_('./schema');
var scenes = _dereq_('./scene/scenes');
var systems = _dereq_('./system');
var utils = _dereq_('../utils/');

var components = module.exports.components = {}; // Keep track of registered components.
var parseProperties = schema.parseProperties;
var parseProperty = schema.parseProperty;
var processSchema = schema.process;
var isSingleProp = schema.isSingleProperty;
var stringifyProperties = schema.stringifyProperties;
var stringifyProperty = schema.stringifyProperty;
var styleParser = utils.styleParser;
var warn = utils.debug('core:component:warn');

var aframeScript = document.currentScript;
var upperCaseRegExp = new RegExp('[A-Z]+');

/**
 * Component class definition.
 *
 * Components configure appearance, modify behavior, or add functionality to
 * entities. The behavior and appearance of an entity can be changed at runtime
 * by adding, removing, or updating components. Entities do not share instances
 * of components.
 *
 * @member {object} el - Reference to the entity element.
 * @member {string} attrValue - Value of the corresponding HTML attribute.
 * @member {object} data - Component data populated by parsing the
 *         mapped attribute of the component plus applying defaults and mixins.
 */
var Component = module.exports.Component = function (el, attrValue, id) {
  this.el = el;
  this.id = id;
  this.attrName = this.name + (id ? '__' + id : '');
  this.updateProperties(attrValue);
};

Component.prototype = {
  /**
   * Contains the type schema and defaults for the data values.
   * Data is coerced into the types of the values of the defaults.
   */
  schema: {},

  /**
   * Init handler. Similar to attachedCallback.
   * Called during component initialization and is only run once.
   * Components can use this to set initial state.
   */
  init: function () { /* no-op */ },

  /**
   * Update handler. Similar to attributeChangedCallback.
   * Called whenever component's data changes.
   * Also called on component initialization when the component receives initial data.
   *
   * @param {object} prevData - Previous attributes of the component.
   */
  update: function (prevData) { /* no-op */ },

  updateSchema: undefined,

  /**
   * Tick handler.
   * Called on each tick of the scene render loop.
   * Affected by play and pause.
   *
   * @param {number} time - Scene tick time.
   * @param {number} timeDelta - Difference in current render time and previous render time.
   */
  tick: undefined,

  /**
   * Called to start any dynamic behavior (e.g., animation, AI, events, physics).
   */
  play: function () { /* no-op */ },

  /**
   * Called to stop any dynamic behavior (e.g., animation, AI, events, physics).
   */
  pause: function () { /* no-op */ },

  /**
   * Remove handler. Similar to detachedCallback.
   * Called whenever component is removed from the entity (i.e., removeAttribute).
   * Components can use this to reset behavior on the entity.
   */
  remove: function () { /* no-op */ },

  /**
   * Parses each property based on property type.
   * If component is single-property, then parses the single property value.
   *
   * @param {string} value - HTML attribute value.
   * @param {boolean} silent - Suppress warning messages.
   * @returns {object} Component data.
   */
  parse: function (value, silent) {
    var schema = this.schema;
    if (isSingleProp(schema)) { return parseProperty(value, schema); }
    return parseProperties(styleParser.parse(value), schema, true, this.name, silent);
  },

  /**
   * Stringify properties if necessary.
   *
   * Only called from `Entity.setAttribute` for properties whose parsers accept a non-string
   * value (e.g., selector, vec3 property types).
   *
   * @param {object} data - Complete component data.
   * @returns {string}
   */
  stringify: function (data) {
    var schema = this.schema;
    if (typeof data === 'string') { return data; }
    if (isSingleProp(schema)) { return stringifyProperty(data, schema); }
    data = stringifyProperties(data, schema);
    return styleParser.stringify(data);
  },

  /**
   * Returns a copy of data such that we don't expose the private this.data.
   *
   * @returns {object} data
   */
  getData: function () {
    var data = this.data;
    if (typeof data !== 'object') { return data; }
    return utils.extend({}, data);
  },

  /**
   * Update the cache of the pre-parsed attribute value.
   *
   * @param {string} value - HTML attribute value.
   */
  updateCachedAttrValue: function (value) {
    var isSinglePropSchema = isSingleProp(this.schema);
    var attrValue = this.parseAttrValueForCache(value);
    this.attrValue = extendProperties({}, attrValue, isSinglePropSchema);
  },

  /**
   * Given an HTML attribute value parses the string
   * based on the component schema. To avoid double parsings of
   * strings into strings we store the original instead
   * of the parsed one
   *
   * @param {string} value - HTML attribute value
   */
  parseAttrValueForCache: function (value) {
    var parsedValue;
    if (typeof value !== 'string') { return value; }
    if (isSingleProp(this.schema)) {
      parsedValue = this.schema.parse(value);
      // To avoid bogus double parsings. The cached values will
      // be parsed when building the component data.
      // For instance when parsing a src id to it's url.
      // We want to cache the original string and not the parsed
      // one (#monster -> models/monster.dae) so when building
      // data we parse the expected value.
      if (typeof parsedValue === 'string') { parsedValue = value; }
    } else {
      // We just parse using the style parser to avoid double parsing
      // of individual properties.
      parsedValue = styleParser.parse(value);
    }
    return parsedValue;
  },

  /**
   * Write cached attribute data to the entity DOM element.
   *
   * @param {bool} isDefault - Whether component is a default component. Always flush for
   *   default components.
   */
  flushToDOM: function (isDefault) {
    var attrValue = isDefault ? this.data : this.attrValue;
    if (!attrValue) { return; }
    HTMLElement.prototype.setAttribute.call(this.el, this.attrName,
                                            this.stringify(attrValue));
  },

  /**
   * Apply new component data if data has changed.
   *
   * @param {string} attrValue - HTML attribute value.
   *        If undefined, use the cached attribute value and continue updating properties.
   */
  updateProperties: function (attrValue) {
    var el = this.el;
    var isSinglePropSchema = isSingleProp(this.schema);
    var oldData = extendProperties({}, this.data, isSinglePropSchema);

    if (attrValue !== undefined) { this.updateCachedAttrValue(attrValue); }

    if (!el.hasLoaded) { return; }

    if (this.updateSchema) {
      this.updateSchema(buildData(el, this.name, this.attrName, this.schema, this.attrValue,
                                  true));
    }
    this.data = buildData(el, this.name, this.attrName, this.schema, this.attrValue);

    if (!this.initialized) {
      // Initialize component.
      this.init();
      this.initialized = true;
      // Play the component if the entity is playing.
      this.update(oldData);
      if (el.isPlaying) { this.play(); }
      el.emit('componentinitialized', {
        id: this.id,
        name: this.name,
        data: this.getData()
      }, false);
    } else {
      // Don't update if properties haven't changed
      if (utils.deepEqual(oldData, this.data)) { return; }

      // Update component.
      this.update(oldData);
      el.emit('componentchanged', {
        id: this.id,
        name: this.name,
        newData: this.getData(),
        oldData: oldData
      }, false);
    }
  },

  /**
   * Reset value of a property to the property's default value.
   * If single-prop component, reset value to component's default value.
   *
   * @param {string} propertyName - Name of property to reset.
   */
  resetProperty: function (propertyName) {
    if (isSingleProp(this.schema)) {
      this.attrValue = undefined;
    } else {
      if (!(propertyName in this.attrValue)) { return; }
      delete this.attrValue[propertyName];
    }
    this.updateProperties(this.attrValue);
  },

  /**
   * Extend schema of component given a partial schema.
   *
   * Some components might want to mutate their schema based on certain properties.
   * e.g., Material component changes its schema based on `shader` to account for different
   * uniforms
   *
   * @param {object} schemaAddon - Schema chunk that extend base schema.
   */
  extendSchema: function (schemaAddon) {
    // Clone base schema.
    var extendedSchema = utils.extend({}, components[this.name].schema);
    // Extend base schema with new schema chunk.
    utils.extend(extendedSchema, schemaAddon);
    this.schema = processSchema(extendedSchema);
    this.el.emit('schemachanged', {component: this.name});
  }
};

// For testing.
if (window.debug) {
  var registrationOrderWarnings = module.exports.registrationOrderWarnings = {};
}

/**
 * Registers a component to A-Frame.
 *
 * @param {string} name - Component name.
 * @param {object} definition - Component schema and lifecycle method handlers.
 * @returns {object} Component.
 */
module.exports.registerComponent = function (name, definition) {
  var NewComponent;
  var proto = {};

  // Warning if component is statically registered after the scene.
  if (document.currentScript && document.currentScript !== aframeScript) {
    scenes.forEach(function checkPosition (sceneEl) {
      // Okay to register component after the scene at runtime.
      if (sceneEl.hasLoaded) { return; }

      // Check that component is declared before the scene.
      if (document.currentScript.compareDocumentPosition(sceneEl) ===
          Node.DOCUMENT_POSITION_FOLLOWING) { return; }

      warn('The component `' + name + '` was registered in a <script> tag after the scene. ' +
           'Component <script> tags in an HTML file should be declared *before* the scene ' +
           'such that the component is available to entities during scene initialization.');

      // For testing.
      if (window.debug) { registrationOrderWarnings[name] = true; }
    });
  }

  if (upperCaseRegExp.test(name) === true) {
    warn('The component name `' + name + '` contains uppercase characters, but ' +
         'HTML will ignore the capitalization of attribute names. ' +
         'Change the name to be lowercase: `' + name.toLowerCase() + '`');
  }

  if (name.indexOf('__') !== -1) {
    throw new Error('The component name `' + name + '` is not allowed. ' +
                    'The sequence __ (double underscore) is reserved to specify an id' +
                    ' for multiple components of the same type');
  }

  // Format definition object to prototype object.
  Object.keys(definition).forEach(function (key) {
    proto[key] = {
      value: definition[key],
      writable: true
    };
  });

  if (components[name]) {
    throw new Error('The component `' + name + '` has been already registered. ' +
                    'Check that you are not loading two versions of the same component ' +
                    'or two different components of the same name.');
  }
  NewComponent = function (el, attr, id) {
    Component.call(this, el, attr, id);
  };

  NewComponent.prototype = Object.create(Component.prototype, proto);
  NewComponent.prototype.name = name;
  NewComponent.prototype.constructor = NewComponent;
  NewComponent.prototype.system = systems && systems.systems[name];
  NewComponent.prototype.play = wrapPlay(NewComponent.prototype.play);
  NewComponent.prototype.pause = wrapPause(NewComponent.prototype.pause);

  components[name] = {
    Component: NewComponent,
    dependencies: NewComponent.prototype.dependencies,
    isSingleProp: isSingleProp(NewComponent.prototype.schema),
    multiple: NewComponent.prototype.multiple,
    parse: NewComponent.prototype.parse,
    parseAttrValueForCache: NewComponent.prototype.parseAttrValueForCache,
    schema: utils.extend(processSchema(NewComponent.prototype.schema)),
    stringify: NewComponent.prototype.stringify,
    type: NewComponent.prototype.type
  };
  return NewComponent;
};

/**
 * Builds component data from the current state of the entity, ultimately
 * updating this.data.
 *
 * If the component was detached completely, set data to null.
 *
 * Precedence:
 * 1. Defaults data
 * 2. Mixin data.
 * 3. Attribute data.
 *
 * Finally coerce the data to the types of the defaults.
 *
 * @param {object} el - Element to build data from.
 * @param {object} name - Component name.
 * @param {object} attrName - Attribute name associated to the component.
 * @param {object} schema - Component schema.
 * @param {object} elData - Element current data.
 * @param {boolean} silent - Suppress warning messages.
 * @return {object} The component data
 */
function buildData (el, name, attrName, schema, elData, silent) {
  var componentDefined = elData !== undefined && elData !== null;
  var data;
  var isSinglePropSchema = isSingleProp(schema);
  var mixinEls = el.mixinEls;

  // 1. Default values (lowest precendence).
  if (isSinglePropSchema) {
    data = schema.default;
  } else {
    data = {};
    Object.keys(schema).forEach(function applyDefault (key) {
      var defaultValue = schema[key].default;
      data[key] = defaultValue && defaultValue.constructor === Object
        ? utils.extend({}, defaultValue)
        : defaultValue;
    });
  }

  // 2. Mixin values.
  mixinEls.forEach(handleMixinUpdate);
  function handleMixinUpdate (mixinEl) {
    var mixinData = mixinEl.getAttribute(attrName);
    if (mixinData) {
      data = extendProperties(data, mixinData, isSinglePropSchema);
    }
  }

  // 3. Attribute values (highest precendence).
  if (componentDefined) {
    if (isSinglePropSchema) { return parseProperty(elData, schema); }
    data = extendProperties(data, elData, isSinglePropSchema);
    return parseProperties(data, schema, undefined, name, silent);
  } else {
     // Parse and coerce using the schema.
    if (isSinglePropSchema) { return parseProperty(data, schema); }
    return parseProperties(data, schema, undefined, name, silent);
  }
}
module.exports.buildData = buildData;

/**
* Object extending with checking for single-property schema.
*
* @param dest - Destination object or value.
* @param source - Source object or value
* @param {boolean} isSinglePropSchema - Whether or not schema is only a single property.
* @returns Overridden object or value.
*/
function extendProperties (dest, source, isSinglePropSchema) {
  if (isSinglePropSchema) { return source; }
  return utils.extend(dest, source);
}

/**
 * Wrapper for user defined pause method
 * Pause component by removing tick behavior and calling user's pause method.
 *
 * @param pauseMethod {function} - user defined pause method
 */
function wrapPause (pauseMethod) {
  return function pause () {
    var sceneEl = this.el.sceneEl;
    if (!this.isPlaying) { return; }
    pauseMethod.call(this);
    this.isPlaying = false;
    // Remove tick behavior.
    if (!this.tick) { return; }
    sceneEl.removeBehavior(this);
  };
}

/**
 * Wrapper for user defined play method
 * Play component by adding tick behavior and calling user's play method.
 *
 * @param playMethod {function} - user defined play method
 *
 */
function wrapPlay (playMethod) {
  return function play () {
    var sceneEl = this.el.sceneEl;
    var shouldPlay = this.el.isPlaying && !this.isPlaying;
    if (!this.initialized || !shouldPlay) { return; }
    playMethod.call(this);
    this.isPlaying = true;
    // Add tick behavior.
    if (!this.tick) { return; }
    sceneEl.addBehavior(this);
  };
}

},{"../utils/":167,"./scene/scenes":106,"./schema":108,"./system":110}],101:[function(_dereq_,module,exports){
var schema = _dereq_('./schema');

var processSchema = schema.process;
var geometries = module.exports.geometries = {};  // Registered geometries.
var geometryNames = module.exports.geometryNames = [];  // Names of registered geometries.
var THREE = _dereq_('../lib/three');

/**
 * Geometry class definition.
 *
 * Geometries extend the geometry component API to create and register geometry types.
 */
var Geometry = module.exports.Geometry = function () {};

Geometry.prototype = {
  /**
   * Contains the type schema and defaults for the data values.
   * Data is coerced into the types of the values of the defaults.
   */
  schema: {},

  /**
   * Init handler. Similar to attachedCallback.
   * Called during shader initialization and is only run once.
   */
  init: function (data) {
    this.geometry = new THREE.Geometry();
    return this.geometry;
  },

  /**
   * Update handler. Similar to attributeChangedCallback.
   * Called whenever the associated geometry data changes.
   *
   * @param {object} data - New geometry data.
   */
  update: function (data) { /* no-op */ }
};

/**
 * Registers a geometry to A-Frame.
 *
 * @param {string} name - Geometry name.
 * @param {object} definition - Geometry property and methods.
 * @returns {object} Geometry.
 */
module.exports.registerGeometry = function (name, definition) {
  var NewGeometry;
  var proto = {};

  // Format definition object to prototype object.
  Object.keys(definition).forEach(function expandDefinition (key) {
    proto[key] = {
      value: definition[key],
      writable: true
    };
  });

  if (geometries[name]) {
    throw new Error('The geometry `' + name + '` has been already registered');
  }
  NewGeometry = function () { Geometry.call(this); };
  NewGeometry.prototype = Object.create(Geometry.prototype, proto);
  NewGeometry.prototype.name = name;
  NewGeometry.prototype.constructor = NewGeometry;
  geometries[name] = {
    Geometry: NewGeometry,
    schema: processSchema(NewGeometry.prototype.schema)
  };
  geometryNames.push(name);
  return NewGeometry;
};

},{"../lib/three":146,"./schema":108}],102:[function(_dereq_,module,exports){
var coordinates = _dereq_('../utils/coordinates');
var debug = _dereq_('debug');

var error = debug('core:propertyTypes:warn');
var warn = debug('core:propertyTypes:warn');

var propertyTypes = module.exports.propertyTypes = {};

// Built-in property types.
registerPropertyType('audio', '', assetParse);
registerPropertyType('array', [], arrayParse, arrayStringify);
registerPropertyType('asset', '', assetParse);
registerPropertyType('boolean', false, boolParse);
registerPropertyType('color', '#FFF', defaultParse, defaultStringify);
registerPropertyType('int', 0, intParse);
registerPropertyType('number', 0, numberParse);
registerPropertyType('map', '', assetParse);
registerPropertyType('model', '', assetParse);
registerPropertyType('selector', '', selectorParse, selectorStringify);
registerPropertyType('selectorAll', '', selectorAllParse, selectorAllStringify);
registerPropertyType('src', '', srcParse);
registerPropertyType('string', '', defaultParse, defaultStringify);
registerPropertyType('time', 0, intParse);
registerPropertyType('vec2', {x: 0, y: 0}, vecParse, coordinates.stringify);
registerPropertyType('vec3', {x: 0, y: 0, z: 0}, vecParse, coordinates.stringify);
registerPropertyType('vec4', {x: 0, y: 0, z: 0, w: 0}, vecParse, coordinates.stringify);

/**
 * Register a parser for re-use such that when someone uses `type` in the schema,
 * `schema.process` will set the property `parse` and `stringify`.
 *
 * @param {string} type - Type name.
 * @param [defaultValue=null] -
 *   Default value to use if component does not define default value.
 * @param {function} [parse=defaultParse] - Parse string function.
 * @param {function} [stringify=defaultStringify] - Stringify to DOM function.
 */
function registerPropertyType (type, defaultValue, parse, stringify) {
  if ('type' in propertyTypes) {
    error('Property type ' + type + ' is already registered.');
    return;
  }

  propertyTypes[type] = {
    default: defaultValue,
    parse: parse || defaultParse,
    stringify: stringify || defaultStringify
  };
}
module.exports.registerPropertyType = registerPropertyType;

function arrayParse (value) {
  if (Array.isArray(value)) { return value; }
  if (!value || typeof value !== 'string') { return []; }
  return value.split(',').map(trim);
  function trim (str) { return str.trim(); }
}

function arrayStringify (value) {
  return value.join(', ');
}

/**
 * For general assets.
 *
 * @param {string} value - Can either be `url(<value>)`, an ID selector to an asset, or
 *   just string.
 * @returns {string} Parsed value from `url(<value>)`, src from `<someasset src>`, or
 *   just string.
 */
function assetParse (value) {
  var el;
  var parsedUrl;

  // If an element was provided (e.g. canvas or video), just return it.
  if (typeof value !== 'string') { return value; }

  // Wrapped `url()` in case of data URI.
  parsedUrl = value.match(/\url\((.+)\)/);
  if (parsedUrl) { return parsedUrl[1]; }

  // ID.
  if (value.charAt(0) === '#') {
    el = selectorParse(value);
    if (el) {
      if (el.tagName === 'CANVAS' || el.tagName === 'VIDEO') { return el; }
      return el.getAttribute('src');
    }
    warn('"' + value + '" asset not found.');
    return;
  }

  // Non-wrapped url().
  return value;
}

function defaultParse (value) {
  return value;
}

function defaultStringify (value) {
  if (value === null) { return 'null'; }
  return value.toString();
}

function boolParse (value) {
  return value !== 'false' && value !== false;
}

function intParse (value) {
  return parseInt(value, 10);
}

function numberParse (value) {
  return parseFloat(value, 10);
}

function selectorParse (value) {
  if (!value) { return null; }
  if (typeof value !== 'string') { return value; }
  return document.querySelector(value);
}

function selectorAllParse (value) {
  if (!value) { return null; }
  if (typeof value !== 'string') { return value; }
  return Array.prototype.slice.call(document.querySelectorAll(value), 0);
}

function selectorStringify (value) {
  if (value.getAttribute) {
    return '#' + value.getAttribute('id');
  }
  return defaultStringify(value);
}

function selectorAllStringify (value) {
  if (value instanceof Array) {
    return value.map(function (element) {
      return '#' + element.getAttribute('id');
    }).join(', ');
  }
  return defaultStringify(value);
}

function srcParse (value) {
  warn('`src` property type is deprecated. Use `asset` instead.');
  return assetParse(value);
}

function vecParse (value) {
  return coordinates.parse(value, this.default);
}

},{"../utils/coordinates":162,"debug":11}],103:[function(_dereq_,module,exports){
/* global Promise, screen */
var initMetaTags = _dereq_('./metaTags').inject;
var initWakelock = _dereq_('./wakelock');
var re = _dereq_('../a-register-element');
var scenes = _dereq_('./scenes');
var systems = _dereq_('../system').systems;
var THREE = _dereq_('../../lib/three');
var TWEEN = _dereq_('tween.js');
var utils = _dereq_('../../utils/');
// Require after.
var AEntity = _dereq_('../a-entity');
var ANode = _dereq_('../a-node');
var initPostMessageAPI = _dereq_('./postMessage');

var bind = utils.bind;
var isIOS = utils.device.isIOS();
var isMobile = utils.device.isMobile();
var registerElement = re.registerElement;
var warn = utils.debug('core:a-scene:warn');

/**
 * Scene element, holds all entities.
 *
 * @member {number} animationFrameID
 * @member {array} behaviors - Component instances that have registered themselves to be
           updated on every tick.
 * @member {object} camera - three.js Camera object.
 * @member {object} canvas
 * @member {bool} isScene - Differentiates as scene entity as opposed to other entites.
 * @member {bool} isMobile - Whether browser is mobile (via UA detection).
 * @member {object} object3D - Root three.js Scene object.
 * @member {object} renderer
 * @member {bool} renderStarted
 * @member (object) effect - three.js VREffect
 * @member {object} systems - Registered instantiated systems.
 * @member {number} time
 */
module.exports = registerElement('a-scene', {
  prototype: Object.create(AEntity.prototype, {
    defaultComponents: {
      value: {
        'canvas': '',
        'inspector': '',
        'keyboard-shortcuts': '',
        'screenshot': '',
        'vr-mode-ui': '',
        'auto-enter-vr': ''
      }
    },

    createdCallback: {
      value: function () {
        this.isIOS = isIOS;
        this.isMobile = isMobile;
        this.isScene = true;
        this.object3D = new THREE.Scene();
        this.render = bind(this.render, this);
        this.systems = {};
        this.time = 0;
        this.init();
      }
    },

    init: {
      value: function () {
        this.behaviors = [];
        this.hasLoaded = false;
        this.isPlaying = false;
        this.originalHTML = this.innerHTML;
        this.addEventListener('render-target-loaded', function () {
          this.setupRenderer();
          this.resize();
        });
        this.addFullScreenStyles();
        initPostMessageAPI(this);
      },
      writable: true
    },

    addFullScreenStyles: {
      value: function () {
        var htmlEl = document.documentElement;
        htmlEl.classList.add('a-html');
        document.body.classList.add('a-body');
        this.classList.add('fullscreen');
      }
    },

    removeFullScreenStyles: {
      value: function () {
        var htmlEl = document.documentElement;
        htmlEl.classList.remove('a-html');
        document.body.classList.remove('a-body');
        this.classList.remove('fullscreen');
      }
    },

    attachedCallback: {
      value: function () {
        var resize = bind(this.resize, this);
        initMetaTags(this);
        initWakelock(this);
        this.initSystems();

        window.addEventListener('load', resize);
        window.addEventListener('resize', resize);
        this.play();

        // Add to scene index.
        scenes.push(this);
      },
      writable: window.debug
    },

    initSystems: {
      value: function () {
        Object.keys(systems).forEach(bind(this.initSystem, this));
      }
    },

    initSystem: {
      value: function (name) {
        var system;
        if (this.systems[name]) { return; }
        system = this.systems[name] = new systems[name](this);
        system.init();
      }
    },

    /**
     * Shuts down scene on detach.
     */
    detachedCallback: {
      value: function () {
        var sceneIndex;
        window.cancelAnimationFrame(this.animationFrameID);
        this.animationFrameID = null;
        // Remove from scene index.
        sceneIndex = scenes.indexOf(this);
        scenes.splice(sceneIndex, 1);
      }
    },

    /**
     * @param {object} behavior - Generally a component. Must implement a .update() method to
     *        be called on every tick.
     */
    addBehavior: {
      value: function (behavior) {
        var behaviors = this.behaviors;
        if (behaviors.indexOf(behavior) !== -1) { return; }
        behaviors.push(behavior);
      }
    },

    /**
     * For tests.
     */
    checkHeadsetConnected: {
      value: utils.device.checkHeadsetConnected,
      writable: window.debug
    },

    /**
     * Call `requestPresent` if WebVR or WebVR polyfill.
     * Call `requestFullscreen` on desktop.
     * Handle events, states, fullscreen styles.
     *
     * @returns {Promise}
     */
    enterVR: {
      value: function (event) {
        var self = this;

        // Don't enter VR if already in VR.
        if (this.is('vr-mode')) { return Promise.resolve('Already in VR.'); }

        if (this.checkHeadsetConnected() || this.isMobile) {
          return this.effect.requestPresent().then(enterVRSuccess, enterVRFailure);
        }
        enterVRSuccess();
        return Promise.resolve();

        function enterVRSuccess () {
          self.addState('vr-mode');
          self.emit('enter-vr', event);

          // Lock to landscape orientation on mobile.
          if (self.isMobile && screen.orientation && screen.orientation.lock) {
            screen.orientation.lock('landscape');
          }
          self.addFullScreenStyles();

          // On mobile, the polyfill handles fullscreen.
          // TODO: 07/16 Chromium builds break when `requestFullscreen`ing on a canvas
          // that we are also `requestPresent`ing. Until then, don't fullscreen if headset
          // connected.
          if (!self.isMobile && !self.checkHeadsetConnected()) {
            requestFullscreen(self.canvas);
          }
          self.resize();
        }

        function enterVRFailure (err) {
          if (err && err.message) {
            throw new Error('Failed to enter VR mode (`requestPresent`): ' + err.message);
          } else {
            throw new Error('Failed to enter VR mode (`requestPresent`).');
          }
        }
      }
    },
     /**
     * Call `exitPresent` if WebVR or WebVR polyfill.
     * Handle events, states, fullscreen styles.
     *
     * @returns {Promise}
     */
    exitVR: {
      value: function () {
        var self = this;

        // Don't exit VR if not in VR.
        if (!this.is('vr-mode')) { return Promise.resolve('Not in VR.'); }

        exitFullscreen();

        if (this.checkHeadsetConnected() || this.isMobile) {
          return this.effect.exitPresent().then(exitVRSuccess, exitVRFailure);
        }
        exitVRSuccess();
        return Promise.resolve();

        function exitVRSuccess () {
          self.removeState('vr-mode');
          // Lock to landscape orientation on mobile.
          if (self.isMobile && screen.orientation && screen.orientation.unlock) {
            screen.orientation.unlock();
          }
          // Exiting VR in embedded mode, no longer need fullscreen styles.
          if (self.hasAttribute('embedded')) { self.removeFullScreenStyles(); }
          self.resize();
          if (self.isIOS) { utils.forceCanvasResizeSafariMobile(this.canvas); }
          self.emit('exit-vr', {target: self});
        }

        function exitVRFailure (err) {
          if (err && err.message) {
            throw new Error('Failed to exit VR mode (`exitPresent`): ' + err.message);
          } else {
            throw new Error('Failed to exit VR mode (`exitPresent`).');
          }
        }
      }
    },

    /**
     * Wraps Entity.getAttribute to take into account for systems.
     * If system exists, then return system data rather than possible component data.
     */
    getAttribute: {
      value: function (attr) {
        var system = this.systems[attr];
        if (system) { return system.data; }
        return AEntity.prototype.getAttribute.call(this, attr);
      }
    },

    /**
     * `getAttribute` used to be `getDOMAttribute` and `getComputedAttribute` used to be
     * what `getAttribute` is now. Now legacy code.
     */
    getComputedAttribute: {
      value: function (attr) {
        warn('`getComputedAttribute` is deprecated. Use `getAttribute` instead.');
        this.getAttribute(attr);
      }
    },

    /**
     * Wraps Entity.getDOMAttribute to take into account for systems.
     * If system exists, then return system data rather than possible component data.
     */
    getDOMAttribute: {
      value: function (attr) {
        var system = this.systems[attr];
        if (system) { return system.data; }
        return AEntity.prototype.getDOMAttribute.call(this, attr);
      }
    },

    /**
     * Wraps Entity.setAttribute to take into account for systems.
     * If system exists, then skip component initialization checks and do a normal
     * setAttribute.
     */
    setAttribute: {
      value: function (attr, value, componentPropValue) {
        var system = this.systems[attr];
        if (system) {
          ANode.prototype.setAttribute.call(this, attr, value);
          return;
        }
        AEntity.prototype.setAttribute.call(this, attr, value, componentPropValue);
      }
    },

    /**
     * @param {object} behavior - Generally a component. Has registered itself to behaviors.
     */
    removeBehavior: {
      value: function (behavior) {
        var behaviors = this.behaviors;
        var index = behaviors.indexOf(behavior);
        if (index === -1) { return; }
        behaviors.splice(index, 1);
      }
    },

    resize: {
      value: function () {
        var camera = this.camera;
        var canvas = this.canvas;
        var embedded = this.getAttribute('embedded') && !this.is('vr-mode');
        var size;
        // Possible camera or canvas not injected yet.
        // ON MOBILE the webvr-polyfill relies on the fullscreen API to enter
        // VR mode. The canvas is resized by VREffect following the values returned
        // by getEyeParameters. We don't want to overwrite the size with the
        // windows width and height.
        if (!camera || !canvas || this.is('vr-mode') && isMobile) { return; }
        // Update camera.
        size = getCanvasSize(canvas, embedded);
        camera.aspect = size.width / size.height;
        camera.updateProjectionMatrix();
        // Notify renderer of size change.
        this.renderer.setSize(size.width, size.height);
      },
      writable: window.debug
    },

    setupRenderer: {
      value: function () {
        var canvas = this.canvas;
        // Set at startup. To enable/disable antialias
        // at runttime we would have to recreate the whole context
        var antialias = this.getAttribute('antialias') === 'true';
        var renderer = this.renderer = new THREE.WebGLRenderer({
          canvas: canvas,
          antialias: antialias || window.hasNativeWebVRImplementation,
          alpha: true
        });
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.sortObjects = false;
        this.effect = new THREE.VREffect(renderer);
      },
      writable: window.debug
    },

    /**
     * Handler attached to elements to help scene know when to kick off.
     * Scene waits for all entities to load.
     */
    play: {
      value: function () {
        var self = this;
        if (this.renderStarted) {
          AEntity.prototype.play.call(this);
          return;
        }

        this.addEventListener('loaded', function () {
          AEntity.prototype.play.call(this);  // .play() *before* render.

          // Wait for camera if necessary before rendering.
          if (this.camera) {
            startRender(this);
            return;
          }
          this.addEventListener('camera-set-active', function () { startRender(this); });

          function startRender (sceneEl) {
            if (sceneEl.renderStarted) { return; }

            sceneEl.resize();

            // Kick off render loop.
            if (sceneEl.renderer) {
              if (window.performance) {
                window.performance.mark('render-started');
              }
              sceneEl.render(0);
              sceneEl.renderStarted = true;
              sceneEl.emit('renderstart');
            }
          }
        });

        // setTimeout to wait for all nodes to attach and run their callbacks.
        setTimeout(function () {
          AEntity.prototype.load.call(self);
        });
      }
    },

    /**
     * Reload the scene to the original DOM content.
     *
     * @param {bool} doPause - Whether to reload the scene with all dynamic behavior paused.
     */
    reload: {
      value: function (doPause) {
        var self = this;
        if (doPause) { this.pause(); }
        this.innerHTML = this.originalHTML;
        this.init();
        ANode.prototype.load.call(this, play);
        function play () {
          if (!self.isPlaying) { return; }
          AEntity.prototype.play.call(self);
        }
      }
    },

    /**
     * Wrap `updateComponent` to not initialize the component if the component has a system
     * (aframevr/aframe#2365).
     */
    updateComponent: {
      value: function (componentName) {
        if (componentName in systems) { return; }
        AEntity.prototype.updateComponent.apply(this, arguments);
      }
    },

    /**
     * Behavior-updater meant to be called from scene render.
     * Abstracted to a different function to facilitate unit testing (`scene.tick()`) without
     * needing to render.
     */
    tick: {
      value: function (time, timeDelta) {
        var systems = this.systems;

        // Animations.
        TWEEN.update(time);
        // Components.
        this.behaviors.forEach(function (component) {
          if (!component.el.isPlaying) { return; }
          component.tick(time, timeDelta);
        });
        // Systems.
        Object.keys(systems).forEach(function (key) {
          if (!systems[key].tick) { return; }
          systems[key].tick(time, timeDelta);
        });
      }
    },

    /**
     * The render loop.
     *
     * Updates animations.
     * Updates behaviors.
     * Renders with request animation frame.
     */
    render: {
      value: function (time) {
        var effect = this.effect;
        var timeDelta = time - this.time;

        if (this.isPlaying) { this.tick(time, timeDelta); }

        this.animationFrameID = effect.requestAnimationFrame(this.render);
        effect.render(this.object3D, this.camera);
        this.time = time;
      },
      writable: true
    }
  })
});

/**
 * Return the canvas size where the scene will be rendered
 * It will be always the window size except when the scene
 * is embedded. The parent size will be returned in that case
 *
 * @param {object} canvasEl - the canvas element
 * @param {boolean} embedded - Is the scene embedded?
 */
function getCanvasSize (canvasEl, embedded) {
  if (embedded) {
    return {
      height: canvasEl.parentElement.offsetHeight,
      width: canvasEl.parentElement.offsetWidth
    };
  }
  return {
    height: window.innerHeight,
    width: window.innerWidth
  };
}

function requestFullscreen (canvas) {
  var requestFullscreen =
    canvas.requestFullscreen ||
    canvas.webkitRequestFullscreen ||
    canvas.mozRequestFullScreen ||  // The capitalized `S` is not a typo.
    canvas.msRequestFullscreen;
  requestFullscreen.apply(canvas);
}

function exitFullscreen () {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }
}

},{"../../lib/three":146,"../../utils/":167,"../a-entity":96,"../a-node":98,"../a-register-element":99,"../system":110,"./metaTags":104,"./postMessage":105,"./scenes":106,"./wakelock":107,"tween.js":49}],104:[function(_dereq_,module,exports){
var constants = _dereq_('../../constants/');
var extend = _dereq_('../../utils').extend;

var MOBILE_HEAD_TAGS = module.exports.MOBILE_HEAD_TAGS = [
  Meta({name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1,shrink-to-fit=no,user-scalable=no,minimal-ui'}),

  // W3C-standardised meta tags.
  Meta({name: 'mobile-web-app-capable', content: 'yes'}),
  Meta({name: 'theme-color', content: 'black'})
];

var MOBILE_IOS_HEAD_TAGS = [
  // iOS-specific meta tags for fullscreen when pinning to homescreen.
  Meta({name: 'apple-mobile-web-app-capable', content: 'yes'}),
  Meta({name: 'apple-mobile-web-app-status-bar-style', content: 'black'}),
  Link({rel: 'apple-touch-icon', href: 'https://aframe.io/images/aframe-logo-152.png'})
];

function Meta (attrs) {
  return {
    tagName: 'meta',
    attributes: attrs,
    exists: function () { return document.querySelector('meta[name="' + attrs.name + '"]'); }
  };
}

function Link (attrs) {
  return {
    tagName: 'link',
    attributes: attrs,
    exists: function () { return document.querySelector('link[rel="' + attrs.rel + '"]'); }
  };
}

/**
 * Injects the necessary metatags in the document for mobile support:
 * 1. Prevent the user to zoom in the document.
 * 2. Ensure that window.innerWidth and window.innerHeight have the correct
 *    values and the canvas is properly scaled.
 * 3. To allow fullscreen mode when pinning a web app on the home screen on
 *    iOS.
 * Adapted from https://www.reddit.com/r/web_design/comments/3la04p/
 *
 * @param {object} scene - Scene element
 * @returns {Array}
 */
module.exports.inject = function injectHeadTags (scene) {
  var headEl = document.head;
  var headScriptEl = headEl.querySelector('script');
  var tag;
  var headTags = [];
  MOBILE_HEAD_TAGS.forEach(createAndInjectTag);
  if (scene.isIOS) {
    MOBILE_IOS_HEAD_TAGS.forEach(createAndInjectTag);
  }
  return headTags;

  function createAndInjectTag (tagObj) {
    if (!tagObj || tagObj.exists()) { return; }

    tag = createTag(tagObj);
    if (!tag) { return; }

    if (headScriptEl) {
      headScriptEl.parentNode.insertBefore(tag, headScriptEl);
    } else {
      headEl.appendChild(tag);
    }

    headTags.push(tag);
  }
};

function createTag (tagObj) {
  if (!tagObj || !tagObj.tagName) { return; }
  var meta = document.createElement(tagObj.tagName);
  meta.setAttribute(constants.AFRAME_INJECTED, '');
  return extend(meta, tagObj.attributes);
}

},{"../../constants/":91,"../../utils":167}],105:[function(_dereq_,module,exports){
var bind = _dereq_('../../utils/bind');
var isIframed = _dereq_('../../utils/').isIframed;

/**
 * Provides a post message API for scenes contained
 * in an iframe.
 */
module.exports = function initPostMessageAPI (scene) {
  // Handles fullscreen behavior when inside an iframe.
  if (!isIframed()) { return; }
  // postMessage API handler
  window.addEventListener('message', bind(postMessageAPIHandler, scene));
};

function postMessageAPIHandler (event) {
  var scene = this;
  if (!event.data) { return; }

  switch (event.data.type) {
    case 'vr': {
      switch (event.data.data) {
        case 'enter':
          scene.enterVR();
          break;
        case 'exit':
          scene.exitVR();
          break;
      }
    }
  }
}

},{"../../utils/":167,"../../utils/bind":161}],106:[function(_dereq_,module,exports){
/*
  Scene index for keeping track of created scenes.
*/
module.exports = [];

},{}],107:[function(_dereq_,module,exports){
var Wakelock = _dereq_('../../../vendor/wakelock/wakelock');

module.exports = function initWakelock (scene) {
  if (!scene.isMobile) { return; }

  var wakelock = scene.wakelock = new Wakelock();
  scene.addEventListener('enter-vr', function () { wakelock.request(); });
  scene.addEventListener('exit-vr', function () { wakelock.release(); });
};

},{"../../../vendor/wakelock/wakelock":177}],108:[function(_dereq_,module,exports){
var debug = _dereq_('../utils/debug');
var propertyTypes = _dereq_('./propertyTypes').propertyTypes;
var warn = debug('core:schema:warn');

/**
 * A schema is classified as a schema for a single property if:
 * - `type` is defined on the schema as a string.
 * - OR `default` is defined on the schema, as a reserved keyword.
 * - OR schema is empty.
 */
function isSingleProperty (schema) {
  if ('type' in schema) {
    return typeof schema.type === 'string';
  }
  return 'default' in schema;
}
module.exports.isSingleProperty = isSingleProperty;

/**
 * Build step to schema to use `type` to inject default value, parser, and stringifier.
 *
 * @param {object} schema
 * @returns {object} Schema.
 */
module.exports.process = function (schema) {
  // For single property schema, run processPropDefinition over the whole schema.
  if (isSingleProperty(schema)) {
    return processPropertyDefinition(schema);
  }

  // For multi-property schema, run processPropDefinition over each property definition.
  Object.keys(schema).forEach(function (propName) {
    schema[propName] = processPropertyDefinition(schema[propName]);
  });
  return schema;
};

/**
 * Inject default value, parser, stringifier for single property.
 */
function processPropertyDefinition (propDefinition) {
  var defaultVal = propDefinition.default;
  var propType;
  var typeName = propDefinition.type;

  // Type inference.
  if (!propDefinition.type) {
    if (defaultVal !== undefined && ['boolean', 'number'].indexOf(typeof defaultVal) !== -1) {
      // Type inference.
      typeName = typeof defaultVal;
    } else if (Array.isArray(defaultVal)) {
      typeName = 'array';
    } else {
      // Fall back to string.
      typeName = 'string';
    }
  } else if (propDefinition.type === 'bool') {
    typeName = 'boolean';
  } else if (propDefinition.type === 'float') {
    typeName = 'number';
  }

  propType = propertyTypes[typeName];
  if (!propType) {
    warn('Unknown property type: ' + typeName);
  }

  // Fill in parse and stringify using property types.
  propDefinition.parse = propDefinition.parse || propType.parse;
  propDefinition.stringify = propDefinition.stringify || propType.stringify;

  // Fill in type name.
  propDefinition.type = typeName;

  // Fill in default value.
  if (!('default' in propDefinition)) {
    propDefinition.default = propType.default;
  }

  return propDefinition;
}
module.exports.processPropertyDefinition = processPropertyDefinition;

/**
 * Parse propData using schema. Use default values if not existing in propData.
 *
 * @param {object} propData - Unparsed properties.
 * @param {object} schema - Property types definition.
 * @param {boolean} getPartialData - Whether to return full component data or just the data
 *        with keys in `propData`.
 * @param {string } componentName - Name of the component, used for the property warning.
 * @param {boolean} silent - Suppress warning messages.
 */
module.exports.parseProperties = function (propData, schema, getPartialData, componentName,
                                           silent) {
  var propNames = Object.keys(getPartialData ? propData : schema);

  if (propData === null || typeof propData !== 'object') { return propData; }

  // Validation errors.
  Object.keys(propData).forEach(function (propName) {
    if (!schema[propName] && !silent) {
      warn('Unknown property `' + propName +
           '` for component/system `' + componentName + '`.');
    }
  });

  propNames.forEach(function parse (propName) {
    var propDefinition = schema[propName];
    var propValue = propData[propName];
    if (!(schema[propName])) { return; }
    propData[propName] = parseProperty(propValue, propDefinition);
  });

  return propData;
};

/**
 * Deserialize a single property.
 */
function parseProperty (value, propDefinition) {
  // Use default value if value is falsy.
  if (value === undefined || value === null || value === '') {
    value = propDefinition.default;
  }
  // Invoke property type parser.
  return propDefinition.parse(value, propDefinition.default);
}
module.exports.parseProperty = parseProperty;

/**
 * Serialize a group of properties.
 */
module.exports.stringifyProperties = function (propData, schema) {
  var stringifiedData = {};
  Object.keys(propData).forEach(function (propName) {
    var propDefinition = schema[propName];
    var propValue = propData[propName];
    var value = propValue;
    if (typeof value === 'object') {
      value = stringifyProperty(propValue, propDefinition);
      if (!propDefinition) { warn('Unknown component property: ' + propName); }
    }
    stringifiedData[propName] = value;
  });
  return stringifiedData;
};

/**
 * Serialize a single property.
 */
function stringifyProperty (value, propDefinition) {
  // This function stringifies but it's used in a context where
  // there's always second stringification pass. By returning the original
  // value when it's not an object we save one unnecessary call
  // to JSON.stringify.
  if (typeof value !== 'object') { return value; }
  // if there's no schema for the property we use standar JSON stringify
  if (!propDefinition || value === null) { return JSON.stringify(value); }
  return propDefinition.stringify(value);
}
module.exports.stringifyProperty = stringifyProperty;

},{"../utils/debug":163,"./propertyTypes":102}],109:[function(_dereq_,module,exports){
var schema = _dereq_('./schema');

var processSchema = schema.process;
var shaders = module.exports.shaders = {};  // Keep track of registered shaders.
var shaderNames = module.exports.shaderNames = [];  // Keep track of the names of registered shaders.
var THREE = _dereq_('../lib/three');
var utils = _dereq_('../utils');

// A-Frame properties to three.js uniform types.
var propertyToThreeMapping = {
  array: 'v3',
  color: 'v3',
  int: 'i',
  number: 'f',
  map: 't',
  time: 'f',
  vec2: 'v2',
  vec3: 'v3',
  vec4: 'v4'
};

/**
 * Shader class definition.
 *
 * Shaders extend the material component API so you can create your own library
 * of customized materials
 *
 */
var Shader = module.exports.Shader = function () {};

Shader.prototype = {
  /**
   * Contains the type schema and defaults for the data values.
   * Data is coerced into the types of the values of the defaults.
   */
  schema: {},

  vertexShader:
    'void main() {' +
      'gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);' +
    '}',

  fragmentShader:
    'void main() {' +
      'gl_FragColor = vec4(1.0, 0.0, 1.0, 1.0);' +
    '}',

  /**
   * Init handler. Similar to attachedCallback.
   * Called during shader initialization and is only run once.
   */
  init: function (data) {
    this.attributes = this.initVariables(data, 'attribute');
    this.uniforms = this.initVariables(data, 'uniform');
    this.material = new (this.raw ? THREE.RawShaderMaterial : THREE.ShaderMaterial)({
      // attributes: this.attributes,
      uniforms: this.uniforms,
      vertexShader: this.vertexShader,
      fragmentShader: this.fragmentShader
    });
    return this.material;
  },

  initVariables: function (data, type) {
    var variables = {};
    var schema = this.schema;
    Object.keys(schema).forEach(function processSchema (key) {
      if (schema[key].is !== type) { return; }
      var varType = propertyToThreeMapping[schema[key].type];
      variables[key] = {
        type: varType,
        value: undefined  // Let updateVariables handle setting these.
      };
    });
    return variables;
  },

  /**
   * Update handler. Similar to attributeChangedCallback.
   * Called whenever the associated material data changes.
   *
   * @param {object} data - New material data.
   */
  update: function (data) {
    this.updateVariables(data, 'attribute');
    this.updateVariables(data, 'uniform');
  },

  updateVariables: function (data, type) {
    var self = this;
    var variables = type === 'uniform' ? this.uniforms : this.attributes;
    var schema = this.schema;
    Object.keys(data).forEach(function processData (key) {
      var materialKey;
      if (!schema[key] || schema[key].is !== type) { return; }

      if (schema[key].type === 'map') {
        // If data unchanged, get out early.
        if (!variables[key] || variables[key].value === data[key]) { return; }

        // Special handling is needed for textures.
        materialKey = '_texture_' + key;

        // We can't actually set the variable correctly until we've loaded the texture.
        self.el.addEventListener('materialtextureloaded', function () {
          variables[key].value = self.material[materialKey];
          variables[key].needsUpdate = true;
        });

        // Kick off the texture update now that handler is added.
        utils.material.updateMapMaterialFromData(materialKey, key, self, data);
        return;
      }
      variables[key].value = self.parseValue(schema[key].type, data[key]);
      variables[key].needsUpdate = true;
    });
  },

  parseValue: function (type, value) {
    var color;
    switch (type) {
      case 'vec2': {
        return new THREE.Vector2(value.x, value.y);
      }
      case 'vec3': {
        return new THREE.Vector3(value.x, value.y, value.z);
      }
      case 'vec4': {
        return new THREE.Vector4(value.x, value.y, value.z, value.w);
      }
      case 'color': {
        color = new THREE.Color(value);
        return new THREE.Vector3(color.r, color.g, color.b);
      }
      default: {
        return value;
      }
    }
  }
};

/**
 * Registers a shader to A-Frame.
 *
 * @param {string} name - shader name.
 * @param {object} definition - shader property and methods.
 * @returns {object} Shader.
 */
module.exports.registerShader = function (name, definition) {
  var NewShader;
  var proto = {};

  // Format definition object to prototype object.
  Object.keys(definition).forEach(function (key) {
    proto[key] = {
      value: definition[key],
      writable: true
    };
  });

  if (shaders[name]) {
    throw new Error('The shader ' + name + ' has been already registered');
  }
  NewShader = function () { Shader.call(this); };
  NewShader.prototype = Object.create(Shader.prototype, proto);
  NewShader.prototype.name = name;
  NewShader.prototype.constructor = NewShader;
  shaders[name] = {
    Shader: NewShader,
    schema: processSchema(NewShader.prototype.schema)
  };
  shaderNames.push(name);
  return NewShader;
};

},{"../lib/three":146,"../utils":167,"./schema":108}],110:[function(_dereq_,module,exports){
/* global HTMLElement */
var components = _dereq_('./component');
var schema = _dereq_('./schema');
var utils = _dereq_('../utils/');

var parseProperties = schema.parseProperties;
var parseProperty = schema.parseProperty;
var processSchema = schema.process;
var isSingleProp = schema.isSingleProperty;
var styleParser = utils.styleParser;

var systems = module.exports.systems = {};  // Keep track of registered systems.

/**
 * System class definition.
 *
 * Systems provide global scope and services to a group of instantiated components of the
 * same class. They can also help abstract logic away from components such that components
 * only have to worry about data.
 * For example, a physics component that creates a physics world that oversees
 * all entities with a physics or rigid body component.
 *
 * @member {string} name - Name that system is registered under.
 * @member {Element} sceneEl - Handle to the scene element where system applies to.
 */
var System = module.exports.System = function (sceneEl) {
  var component = components && components.components[this.name];
  var schema = this.schema;
  var rawData;

  // Set reference to scene.
  this.sceneEl = sceneEl;

  // Set reference to matching component (if exists).
  if (component) { component.Component.prototype.system = this; }

  // Process system configuration.
  if (!Object.keys(schema).length) { return; }
  rawData = HTMLElement.prototype.getAttribute.call(sceneEl, this.name);
  if (isSingleProp(schema)) {
    this.data = parseProperty(rawData, schema);
    return;
  }
  this.data = parseProperties(styleParser.parse(rawData) || {}, schema, false, this.name);
};

System.prototype = {
  /**
   * Schema to configure system.
   */
  schema: {},

  /**
   * Init handler. Called during scene initialization and is only run once.
   * Systems can use this to set initial state.
   */
  init: function () { /* no-op */ },

  /**
   * Tick handler.
   * Called on each tick of the scene render loop.
   * Affected by play and pause.
   *
   * @param {number} time - Scene tick time.
   * @param {number} timeDelta - Difference in current render time and previous render time.
   */
  tick: undefined,

  /**
   * Called to start any dynamic behavior (e.g., animation, AI, events, physics).
   */
  play: function () { /* no-op */ },

  /**
   * Called to stop any dynamic behavior (e.g., animation, AI, events, physics).
   */
  pause: function () { /* no-op */ }
};

/**
 * Registers a system to A-Frame.
 *
 * @param {string} name - Component name.
 * @param {object} definition - Component property and methods.
 * @returns {object} Component.
 */
module.exports.registerSystem = function (name, definition) {
  var i;
  var NewSystem;
  var proto = {};
  var scenes = utils.findAllScenes(document);

  // Format definition object to prototype object.
  Object.keys(definition).forEach(function (key) {
    proto[key] = {
      value: definition[key],
      writable: true
    };
  });

  if (systems[name]) {
    throw new Error('The system `' + name + '` has been already registered. ' +
                    'Check that you are not loading two versions of the same system ' +
                    'or two different systems of the same name.');
  }
  NewSystem = function (sceneEl) { System.call(this, sceneEl); };
  NewSystem.prototype = Object.create(System.prototype, proto);
  NewSystem.prototype.name = name;
  NewSystem.prototype.constructor = NewSystem;
  NewSystem.prototype.schema = utils.extend(processSchema(NewSystem.prototype.schema));
  systems[name] = NewSystem;

  // Initialize systems for existing scenes
  for (i = 0; i < scenes.length; i++) { scenes[i].initSystem(name); }
};

},{"../utils/":167,"./component":100,"./schema":108}],111:[function(_dereq_,module,exports){
_dereq_('./pivot');

},{"./pivot":112}],112:[function(_dereq_,module,exports){
var registerComponent = _dereq_('../../core/component').registerComponent;
var THREE = _dereq_('../../lib/three');

var originalPosition = new THREE.Vector3();
var originalRotation = new THREE.Vector3();

/**
 * Wrap el.object3D within an outer group. Apply pivot to el.object3D as position.
 */
registerComponent('pivot', {
  dependencies: ['position'],

  schema: {type: 'vec3'},

  init: function () {
    var data = this.data;
    var el = this.el;
    var originalParent = el.object3D.parent;
    var originalGroup = el.object3D;
    var outerGroup = new THREE.Group();

    originalPosition.copy(originalGroup.position);
    originalRotation.copy(originalGroup.rotation);

    // Detach current group from parent.
    originalParent.remove(originalGroup);
    outerGroup.add(originalGroup);

    // Set new group as the outer group.
    originalParent.add(outerGroup);

    // Set outer group as new object3D.
    el.object3D = outerGroup;

    // Apply pivot to original group.
    originalGroup.position.set(-1 * data.x, -1 * data.y, -1 * data.z);

    // Offset the pivot so that world position not affected.
    // And restore position onto outer group.
    outerGroup.position.set(data.x + originalPosition.x, data.y + originalPosition.y,
                            data.z + originalPosition.z);

    // Transfer rotation to outer group.
    outerGroup.rotation.copy(originalGroup.rotation);
    originalGroup.rotation.set(0, 0, 0);
  }
});

},{"../../core/component":100,"../../lib/three":146}],113:[function(_dereq_,module,exports){
/**
 * Common mesh defaults, mappings, and transforms.
 */
var components = _dereq_('../../core/component').components;
var shaders = _dereq_('../../core/shader').shaders;
var utils = _dereq_('../../utils/');

var materialMappings = {};
Object.keys(components.material.schema).forEach(addMapping);
Object.keys(shaders.standard.schema).forEach(addMapping);

function addMapping (prop) {
  // To hyphenated.
  var htmlAttrName = prop.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  if (prop === 'fog') { htmlAttrName = 'material-fog'; }
  if (prop === 'visible') { htmlAttrName = 'material-visible'; }
  materialMappings[htmlAttrName] = 'material.' + prop;
}

module.exports = function getMeshMixin () {
  return {
    defaultComponents: {material: {}},
    mappings: utils.extend({}, materialMappings)
  };
};

},{"../../core/component":100,"../../core/shader":109,"../../utils/":167}],114:[function(_dereq_,module,exports){
_dereq_('./primitives/a-camera');
_dereq_('./primitives/a-collada-model');
_dereq_('./primitives/a-cursor');
_dereq_('./primitives/a-curvedimage');
_dereq_('./primitives/a-gltf-model');
_dereq_('./primitives/a-image');
_dereq_('./primitives/a-light');
_dereq_('./primitives/a-obj-model');
_dereq_('./primitives/a-sky');
_dereq_('./primitives/a-sound');
_dereq_('./primitives/a-text');
_dereq_('./primitives/a-video');
_dereq_('./primitives/a-videosphere');
_dereq_('./primitives/meshPrimitives');

},{"./primitives/a-camera":116,"./primitives/a-collada-model":117,"./primitives/a-cursor":118,"./primitives/a-curvedimage":119,"./primitives/a-gltf-model":120,"./primitives/a-image":121,"./primitives/a-light":122,"./primitives/a-obj-model":123,"./primitives/a-sky":124,"./primitives/a-sound":125,"./primitives/a-text":126,"./primitives/a-video":127,"./primitives/a-videosphere":128,"./primitives/meshPrimitives":129}],115:[function(_dereq_,module,exports){
var AEntity = _dereq_('../../core/a-entity');
var components = _dereq_('../../core/component').components;
var registerElement = _dereq_('../../core/a-register-element').registerElement;
var utils = _dereq_('../../utils/');

var debug = utils.debug;
var setComponentProperty = utils.entity.setComponentProperty;
var log = debug('extras:primitives:debug');
var warn = debug('extras:primitives:warn');

var primitives = module.exports.primitives = {};

module.exports.registerPrimitive = function registerPrimitive (name, definition) {
  name = name.toLowerCase();
  log('Registering <%s>', name);

  // Deprecation warning for defaultAttributes usage.
  if (definition.defaultAttributes) {
    warn("The 'defaultAttributes' object is deprecated. Use 'defaultComponents' instead.");
  }

  var primitive = registerElement(name, {
    prototype: Object.create(AEntity.prototype, {
      defaultComponentsFromPrimitive: {
        value: definition.defaultComponents || definition.defaultAttributes || {}
      },
      deprecated: {value: definition.deprecated || null},
      deprecatedMappings: {value: definition.deprecatedMappings || {}},
      mappings: {value: definition.mappings || {}},

      createdCallback: {
        value: function () {
          if (definition.deprecated) { console.warn(definition.deprecated); }
          this.resolveMappingCollisions();
        }
      },

      /**
       * If a mapping collides with a registered component name
       * it renames the mapping to componentname-property
       */
      resolveMappingCollisions: {
        value: function () {
          var mappings = this.mappings;
          var self = this;
          Object.keys(mappings).forEach(function resolveCollision (key) {
            var newAttribute;
            if (components[key]) {
              newAttribute = mappings[key].replace('.', '-');
              mappings[newAttribute] = mappings[key];
              delete mappings[key];
              console.warn('The primitive ' + self.tagName.toLowerCase() + ' has a mapping collision. ' +
                           'The attribute ' + key + ' has the same name as a registered component and' +
                           ' has been renamed to ' + newAttribute);
            }
          });
        }
      },

      getExtraComponents: {
        value: function () {
          var attr;
          var data;
          var i;
          var mapping;
          var mixins;
          var path;
          var self = this;

          // Gather component data from default components.
          data = utils.clone(this.defaultComponentsFromPrimitive);

          // Factor in mixins to overwrite default components.
          mixins = this.getAttribute('mixin');
          if (mixins) {
            mixins = mixins.trim().split(' ');
            mixins.forEach(function applyMixin (mixinId) {
              var mixinComponents = self.sceneEl.querySelector('#' + mixinId).componentCache;
              Object.keys(mixinComponents).forEach(function setComponent (name) {
                data[name] = utils.extendDeep(data[name] || {}, mixinComponents[name]);
              });
            });
          }

          // Gather component data from mappings.
          for (i = 0; i < this.attributes.length; i++) {
            attr = this.attributes[i];
            mapping = this.mappings[attr.name];
            if (mapping) {
              path = utils.entity.getComponentPropertyPath(mapping);
              if (path.constructor === Array) {
                data[path[0]][path[1]] = attr.value;
              } else {
                data[path] = attr.value;
              }
              continue;
            }
          }

          return data;
        }
      },

      /**
       * Sync to attribute to component property whenever mapped attribute changes.
       * If attribute is mapped to a component property, set the component property using
       * the attribute value.
       */
      attributeChangedCallback: {
        value: function (attr, oldVal, value) {
          var componentName = this.mappings[attr];

          if (attr in this.deprecatedMappings) {
            console.warn(this.deprecatedMappings[attr]);
          }

          if (!attr || !componentName) { return; }

          // Set value.
          setComponentProperty(this, componentName, value);
        }
      }
    })
  });

  // Store.
  primitives[name] = primitive;
  return primitive;
};

/**
 * Add component mappings using schema.
 */
function addComponentMapping (componentName, mappings) {
  var schema = components[componentName].schema;
  Object.keys(schema).map(function (prop) {
    // Hyphenate where there is camelCase.
    var attrName = prop.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    // If there is a mapping collision, prefix with component name and hyphen.
    if (mappings[attrName] !== undefined) { attrName = componentName + '-' + prop; }
    mappings[attrName] = componentName + '.' + prop;
  });
}

/**
 * Helper to define a primitive, building mappings using a component schema.
 */
function definePrimitive (tagName, defaultComponents, mappings) {
  // If no initial mappings provided, start from empty map.
  mappings = mappings || {};

  // From the default components, add mapping automagically.
  Object.keys(defaultComponents).map(function buildMappings (componentName) {
    addComponentMapping(componentName, mappings);
  });

  // Register the primitive.
  module.exports.registerPrimitive(tagName, utils.extendDeep({}, null, {
    defaultComponents: defaultComponents,
    mappings: mappings
  }));
}
module.exports.definePrimitive = definePrimitive;

},{"../../core/a-entity":96,"../../core/a-register-element":99,"../../core/component":100,"../../utils/":167}],116:[function(_dereq_,module,exports){
var DEFAULT_CAMERA_HEIGHT = _dereq_('../../../constants/').DEFAULT_CAMERA_HEIGHT;
var registerPrimitive = _dereq_('../primitives').registerPrimitive;

registerPrimitive('a-camera', {
  defaultComponents: {
    camera: {
      userHeight: DEFAULT_CAMERA_HEIGHT
    },
    'look-controls': {},
    'wasd-controls': {}
  },

  mappings: {
    active: 'camera.active',
    far: 'camera.far',
    fov: 'camera.fov',
    'look-controls-enabled': 'look-controls.enabled',
    near: 'camera.near',
    'wasd-controls-enabled': 'wasd-controls.enabled',
    'reverse-mouse-drag': 'look-controls.reverseMouseDrag',
    'user-height': 'camera.userHeight',
    zoom: 'camera.zoom'
  },

  deprecatedMappings: {
    'cursor-color': 'a-camera[cursor-color] has been removed. Use a-cursor[color] instead.',
    'cursor-maxdistance': 'a-camera[cursor-maxdistance] has been removed. Use a-cursor[max-distance] instead.',
    'cursor-offset': 'a-camera[cursor-offset] has been removed. Use a-cursor[position] instead.',
    'cursor-opacity': 'a-camera[cursor-offset] has been removed. Use a-cursor[opacity] instead.',
    'cursor-scale': 'a-camera[cursor-scale] has been removed. Use a-cursor[scale] instead.',
    'cursor-visible': 'a-camera[cursor-visible] has been removed. Use a-cursor[visible] instead.'
  }
});

},{"../../../constants/":91,"../primitives":115}],117:[function(_dereq_,module,exports){
var registerPrimitive = _dereq_('../primitives').registerPrimitive;

registerPrimitive('a-collada-model', {
  mappings: {
    src: 'collada-model'
  }
});

},{"../primitives":115}],118:[function(_dereq_,module,exports){
var getMeshMixin = _dereq_('../getMeshMixin');
var registerPrimitive = _dereq_('../primitives').registerPrimitive;
var utils = _dereq_('../../../utils/');

registerPrimitive('a-cursor', utils.extendDeep({}, getMeshMixin(), {
  defaultComponents: {
    cursor: {},
    geometry: {
      primitive: 'ring',
      radiusOuter: 0.016,
      radiusInner: 0.01,
      segmentsTheta: 64
    },
    material: {
      color: '#000',
      shader: 'flat',
      opacity: 0.8
    },
    position: {
      x: 0,
      y: 0,
      z: -1
    },
    raycaster: {
      far: 1000
    }
  },

  mappings: {
    far: 'raycaster.far',
    fuse: 'cursor.fuse',
    interval: 'raycaster.interval',
    objects: 'raycaster.objects',
    'fuse-timeout': 'cursor.fuseTimeout'
  }
}));

},{"../../../utils/":167,"../getMeshMixin":113,"../primitives":115}],119:[function(_dereq_,module,exports){
var getMeshMixin = _dereq_('../getMeshMixin');
var registerPrimitive = _dereq_('../primitives').registerPrimitive;
var utils = _dereq_('../../../utils/');

registerPrimitive('a-curvedimage', utils.extendDeep({}, getMeshMixin(), {
  defaultComponents: {
    geometry: {
      height: 1,
      primitive: 'cylinder',
      radius: 2,
      segmentsRadial: 48,
      thetaLength: 270,
      openEnded: true,
      thetaStart: 0
    },
    material: {
      color: '#FFF',
      shader: 'flat',
      side: 'double',
      transparent: true,
      repeat: '-1 1'
    }
  },

  mappings: {
    height: 'geometry.height',
    'open-ended': 'geometry.openEnded',
    radius: 'geometry.radius',
    segments: 'geometry.segmentsRadial',
    start: 'geometry.thetaStart',
    'theta-length': 'geometry.thetaLength',
    'theta-start': 'geometry.thetaStart',
    'width': 'geometry.thetaLength'
  }
}));

},{"../../../utils/":167,"../getMeshMixin":113,"../primitives":115}],120:[function(_dereq_,module,exports){
var registerPrimitive = _dereq_('../primitives').registerPrimitive;

registerPrimitive('a-gltf-model', {
  mappings: {
    src: 'gltf-model'
  }
});

},{"../primitives":115}],121:[function(_dereq_,module,exports){
var getMeshMixin = _dereq_('../getMeshMixin');
var registerPrimitive = _dereq_('../primitives').registerPrimitive;
var utils = _dereq_('../../../utils/');

registerPrimitive('a-image', utils.extendDeep({}, getMeshMixin(), {
  defaultComponents: {
    geometry: {
      primitive: 'plane'
    },
    material: {
      color: '#FFF',
      shader: 'flat',
      side: 'double',
      transparent: true
    }
  },

  mappings: {
    height: 'geometry.height',
    width: 'geometry.width'
  }
}));

},{"../../../utils/":167,"../getMeshMixin":113,"../primitives":115}],122:[function(_dereq_,module,exports){
var registerPrimitive = _dereq_('../primitives').registerPrimitive;

registerPrimitive('a-light', {
  defaultComponents: {
    light: {}
  },

  mappings: {
    angle: 'light.angle',
    color: 'light.color',
    'ground-color': 'light.groundColor',
    decay: 'light.decay',
    distance: 'light.distance',
    intensity: 'light.intensity',
    penumbra: 'light.penumbra',
    type: 'light.type',
    target: 'light.target'
  }
});

},{"../primitives":115}],123:[function(_dereq_,module,exports){
var meshMixin = _dereq_('../getMeshMixin')();
var registerPrimitive = _dereq_('../primitives').registerPrimitive;
var utils = _dereq_('../../../utils/');

registerPrimitive('a-obj-model', utils.extendDeep({}, meshMixin, {
  defaultComponents: {
    'obj-model': {}
  },

  mappings: {
    src: 'obj-model.obj',
    mtl: 'obj-model.mtl'
  }
}));

},{"../../../utils/":167,"../getMeshMixin":113,"../primitives":115}],124:[function(_dereq_,module,exports){
var getMeshMixin = _dereq_('../getMeshMixin');
var registerPrimitive = _dereq_('../primitives').registerPrimitive;
var utils = _dereq_('../../../utils/');
var meshPrimitives = _dereq_('./meshPrimitives');

registerPrimitive('a-sky', utils.extendDeep({}, getMeshMixin(), {
  defaultComponents: {
    geometry: {
      primitive: 'sphere',
      radius: 5000,
      segmentsWidth: 64,
      segmentsHeight: 20
    },
    material: {
      color: '#FFF',
      shader: 'flat'
    },
    scale: '-1 1 1'
  },

  mappings: utils.extendDeep({}, meshPrimitives['a-sphere'].prototype.mappings)
}));

},{"../../../utils/":167,"../getMeshMixin":113,"../primitives":115,"./meshPrimitives":129}],125:[function(_dereq_,module,exports){
var registerPrimitive = _dereq_('../primitives').registerPrimitive;

registerPrimitive('a-sound', {
  defaultComponents: {
    sound: {}
  },

  mappings: {
    src: 'sound.src',
    on: 'sound.on',
    autoplay: 'sound.autoplay',
    loop: 'sound.loop',
    volume: 'sound.volume'
  }
});

},{"../primitives":115}],126:[function(_dereq_,module,exports){
// <a-text> using `definePrimitive` helper.
var definePrimitive = _dereq_('../primitives').definePrimitive;
definePrimitive('a-text', {text: {anchor: 'align', width: 5}});

},{"../primitives":115}],127:[function(_dereq_,module,exports){
var getMeshMixin = _dereq_('../getMeshMixin');
var registerPrimitive = _dereq_('../primitives').registerPrimitive;
var utils = _dereq_('../../../utils/');

registerPrimitive('a-video', utils.extendDeep({}, getMeshMixin(), {
  defaultComponents: {
    geometry: {
      primitive: 'plane'
    },
    material: {
      color: '#FFF',
      shader: 'flat',
      side: 'double',
      transparent: true
    }
  },

  mappings: {
    height: 'geometry.height',
    width: 'geometry.width'
  }
}));

},{"../../../utils/":167,"../getMeshMixin":113,"../primitives":115}],128:[function(_dereq_,module,exports){
var getMeshMixin = _dereq_('../getMeshMixin');
var registerPrimitive = _dereq_('../primitives').registerPrimitive;
var utils = _dereq_('../../../utils/');

registerPrimitive('a-videosphere', utils.extendDeep({}, getMeshMixin(), {
  defaultComponents: {
    geometry: {
      primitive: 'sphere',
      radius: 5000,
      segmentsWidth: 64,
      segmentsHeight: 20
    },
    material: {
      color: '#FFF',
      shader: 'flat'
    },
    scale: '-1 1 1'
  },

  mappings: {
    radius: 'geometry.radius',
    'segments-height': 'geometry.segmentsHeight',
    'segments-width': 'geometry.segmentsWidth'
  }
}));

},{"../../../utils/":167,"../getMeshMixin":113,"../primitives":115}],129:[function(_dereq_,module,exports){
/**
 * Automated mesh primitive registration.
 */
var getMeshMixin = _dereq_('../getMeshMixin');
var geometries = _dereq_('../../../core/geometry').geometries;
var geometryNames = _dereq_('../../../core/geometry').geometryNames;
var registerPrimitive = _dereq_('../primitives').registerPrimitive;
var utils = _dereq_('../../../utils/');

// For testing.
var meshPrimitives = module.exports = {};

// Generate primitive for each geometry type.
geometryNames.forEach(function registerMeshPrimitive (geometryName) {
  var geometry = geometries[geometryName];
  var geometryHyphened = unCamelCase(geometryName);

  // Generate mappings.
  var mappings = {};
  Object.keys(geometry.schema).forEach(function createMapping (property) {
    mappings[unCamelCase(property)] = 'geometry.' + property;
  });

  // Register.
  var tagName = 'a-' + geometryHyphened;
  var primitive = registerPrimitive(tagName, utils.extendDeep({}, getMeshMixin(), {
    defaultComponents: {geometry: {primitive: geometryName}},
    mappings: mappings
  }));
  meshPrimitives[tagName] = primitive;
});

/**
 * camelCase to hyphened-string.
 */
function unCamelCase (str) {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

},{"../../../core/geometry":101,"../../../utils/":167,"../getMeshMixin":113,"../primitives":115}],130:[function(_dereq_,module,exports){
var registerGeometry = _dereq_('../core/geometry').registerGeometry;
var THREE = _dereq_('../lib/three');

registerGeometry('box', {
  schema: {
    depth: {default: 1, min: 0},
    height: {default: 1, min: 0},
    width: {default: 1, min: 0},
    segmentsHeight: {default: 1, min: 1, max: 20, type: 'int'},
    segmentsWidth: {default: 1, min: 1, max: 20, type: 'int'},
    segmentsDepth: {default: 1, min: 1, max: 20, type: 'int'}
  },

  init: function (data) {
    this.geometry = new THREE.BoxGeometry(data.width, data.height, data.depth);
  }
});

},{"../core/geometry":101,"../lib/three":146}],131:[function(_dereq_,module,exports){
var registerGeometry = _dereq_('../core/geometry').registerGeometry;
var THREE = _dereq_('../lib/three');

var degToRad = THREE.Math.degToRad;

registerGeometry('circle', {
  schema: {
    radius: {default: 1, min: 0},
    segments: {default: 32, min: 3, type: 'int'},
    thetaLength: {default: 360, min: 0},
    thetaStart: {default: 0}
  },

  init: function (data) {
    this.geometry = new THREE.CircleGeometry(
      data.radius, data.segments, degToRad(data.thetaStart), degToRad(data.thetaLength));
  }
});

},{"../core/geometry":101,"../lib/three":146}],132:[function(_dereq_,module,exports){
var registerGeometry = _dereq_('../core/geometry').registerGeometry;
var THREE = _dereq_('../lib/three');

var degToRad = THREE.Math.degToRad;

registerGeometry('cone', {
  schema: {
    height: {default: 1, min: 0},
    openEnded: {default: false},
    radiusBottom: {default: 1, min: 0},
    radiusTop: {default: 0.8, min: 0},
    segmentsHeight: {default: 18, min: 1, type: 'int'},
    segmentsRadial: {default: 36, min: 3, type: 'int'},
    thetaLength: {default: 360, min: 0},
    thetaStart: {default: 0}
  },

  init: function (data) {
    this.geometry = new THREE.CylinderGeometry(
        data.radiusTop, data.radiusBottom, data.height, data.segmentsRadial,
        data.segmentsHeight, data.openEnded, degToRad(data.thetaStart),
        degToRad(data.thetaLength));
  }
});

},{"../core/geometry":101,"../lib/three":146}],133:[function(_dereq_,module,exports){
var registerGeometry = _dereq_('../core/geometry').registerGeometry;
var THREE = _dereq_('../lib/three');

var degToRad = THREE.Math.degToRad;

registerGeometry('cylinder', {
  schema: {
    height: {default: 1, min: 0},
    openEnded: {default: false},
    radius: {default: 1, min: 0},
    segmentsHeight: {default: 18, min: 1, type: 'int'},
    segmentsRadial: {default: 36, min: 3, type: 'int'},
    thetaLength: {default: 360, min: 0},
    thetaStart: {default: 0}
  },

  init: function (data) {
    this.geometry = new THREE.CylinderGeometry(
        data.radius, data.radius, data.height, data.segmentsRadial, data.segmentsHeight,
        data.openEnded, degToRad(data.thetaStart), degToRad(data.thetaLength));
  }
});

},{"../core/geometry":101,"../lib/three":146}],134:[function(_dereq_,module,exports){
var registerGeometry = _dereq_('../core/geometry').registerGeometry;
var THREE = _dereq_('../lib/three');

registerGeometry('dodecahedron', {
  schema: {
    detail: {default: 0, min: 0, max: 5, type: 'int'},
    radius: {default: 1, min: 0}
  },

  init: function (data) {
    this.geometry = new THREE.DodecahedronGeometry(data.radius, data.detail);
  }
});

},{"../core/geometry":101,"../lib/three":146}],135:[function(_dereq_,module,exports){
var registerGeometry = _dereq_('../core/geometry').registerGeometry;
var THREE = _dereq_('../lib/three');

registerGeometry('icosahedron', {
  schema: {
    detail: {default: 0, min: 0, max: 5, type: 'int'},
    radius: {default: 1, min: 0}
  },

  init: function (data) {
    this.geometry = new THREE.IcosahedronGeometry(data.radius, data.detail);
  }
});

},{"../core/geometry":101,"../lib/three":146}],136:[function(_dereq_,module,exports){
_dereq_('./box.js');
_dereq_('./circle.js');
_dereq_('./cone.js');
_dereq_('./cylinder.js');
_dereq_('./dodecahedron.js');
_dereq_('./icosahedron.js');
_dereq_('./octahedron.js');
_dereq_('./plane.js');
_dereq_('./ring.js');
_dereq_('./sphere.js');
_dereq_('./tetrahedron.js');
_dereq_('./torus.js');
_dereq_('./torusKnot.js');

},{"./box.js":130,"./circle.js":131,"./cone.js":132,"./cylinder.js":133,"./dodecahedron.js":134,"./icosahedron.js":135,"./octahedron.js":137,"./plane.js":138,"./ring.js":139,"./sphere.js":140,"./tetrahedron.js":141,"./torus.js":142,"./torusKnot.js":143}],137:[function(_dereq_,module,exports){
var registerGeometry = _dereq_('../core/geometry').registerGeometry;
var THREE = _dereq_('../lib/three');

registerGeometry('octahedron', {
  schema: {
    detail: {default: 0, min: 0, max: 5, type: 'int'},
    radius: {default: 1, min: 0}
  },

  init: function (data) {
    this.geometry = new THREE.OctahedronGeometry(data.radius, data.detail);
  }
});

},{"../core/geometry":101,"../lib/three":146}],138:[function(_dereq_,module,exports){
var registerGeometry = _dereq_('../core/geometry').registerGeometry;
var THREE = _dereq_('../lib/three');

registerGeometry('plane', {
  schema: {
    height: {default: 1, min: 0},
    width: {default: 1, min: 0},
    segmentsHeight: {default: 1, min: 1, max: 20, type: 'int'},
    segmentsWidth: {default: 1, min: 1, max: 20, type: 'int'}
  },

  init: function (data) {
    this.geometry = new THREE.PlaneGeometry(data.width, data.height);
  }
});

},{"../core/geometry":101,"../lib/three":146}],139:[function(_dereq_,module,exports){
var registerGeometry = _dereq_('../core/geometry').registerGeometry;
var THREE = _dereq_('../lib/three');

var degToRad = THREE.Math.degToRad;

registerGeometry('ring', {
  schema: {
    radiusInner: {default: 0.8, min: 0},
    radiusOuter: {default: 1.2, min: 0},
    segmentsPhi: {default: 10, min: 1, type: 'int'},
    segmentsTheta: {default: 32, min: 3, type: 'int'},
    thetaLength: {default: 360, min: 0},
    thetaStart: {default: 0}
  },

  init: function (data) {
    this.geometry = new THREE.RingGeometry(
        data.radiusInner, data.radiusOuter, data.segmentsTheta, data.segmentsPhi,
        degToRad(data.thetaStart), degToRad(data.thetaLength));
  }
});

},{"../core/geometry":101,"../lib/three":146}],140:[function(_dereq_,module,exports){
var registerGeometry = _dereq_('../core/geometry').registerGeometry;
var THREE = _dereq_('../lib/three');

var degToRad = THREE.Math.degToRad;

registerGeometry('sphere', {
  schema: {
    radius: {default: 1, min: 0},
    phiLength: {default: 360},
    phiStart: {default: 0, min: 0},
    thetaLength: {default: 180, min: 0},
    thetaStart: {default: 0},
    segmentsHeight: {default: 18, min: 2, type: 'int'},
    segmentsWidth: {default: 36, min: 3, type: 'int'}
  },

  init: function (data) {
    this.geometry = new THREE.SphereGeometry(
      data.radius, data.segmentsWidth, data.segmentsHeight, degToRad(data.phiStart),
      degToRad(data.phiLength), degToRad(data.thetaStart), degToRad(data.thetaLength));
  }
});

},{"../core/geometry":101,"../lib/three":146}],141:[function(_dereq_,module,exports){
var registerGeometry = _dereq_('../core/geometry').registerGeometry;
var THREE = _dereq_('../lib/three');

registerGeometry('tetrahedron', {
  schema: {
    detail: {default: 0, min: 0, max: 5, type: 'int'},
    radius: {default: 1, min: 0}
  },

  init: function (data) {
    this.geometry = new THREE.TetrahedronGeometry(data.radius, data.detail);
  }
});

},{"../core/geometry":101,"../lib/three":146}],142:[function(_dereq_,module,exports){
var registerGeometry = _dereq_('../core/geometry').registerGeometry;
var THREE = _dereq_('../lib/three');

var degToRad = THREE.Math.degToRad;

registerGeometry('torus', {
  schema: {
    arc: {default: 360},
    radius: {default: 1, min: 0},
    radiusTubular: {default: 0.2, min: 0},
    segmentsRadial: {default: 36, min: 2, type: 'int'},
    segmentsTubular: {default: 32, min: 3, type: 'int'}
  },

  init: function (data) {
    this.geometry = new THREE.TorusGeometry(
      data.radius, data.radiusTubular * 2, data.segmentsRadial, data.segmentsTubular,
      degToRad(data.arc));
  }
});

},{"../core/geometry":101,"../lib/three":146}],143:[function(_dereq_,module,exports){
var registerGeometry = _dereq_('../core/geometry').registerGeometry;
var THREE = _dereq_('../lib/three');

registerGeometry('torusKnot', {
  schema: {
    p: {default: 2, min: 1},
    q: {default: 3, min: 1},
    radius: {default: 1, min: 0},
    radiusTubular: {default: 0.2, min: 0},
    segmentsRadial: {default: 8, min: 3, type: 'int'},
    segmentsTubular: {default: 100, min: 3, type: 'int'}
  },

  init: function (data) {
    this.geometry = new THREE.TorusKnotGeometry(
      data.radius, data.radiusTubular * 2, data.segmentsTubular, data.segmentsRadial,
      data.p, data.q);
  }
});

},{"../core/geometry":101,"../lib/three":146}],144:[function(_dereq_,module,exports){
var utils = _dereq_('./utils/');

var debug = utils.debug;
var warn = debug('A-Frame:warn');

if (document.currentScript && document.currentScript.parentNode !== document.head &&
    !window.debug) {
  warn('Put the A-Frame <script> tag in the <head> of the HTML *before* the scene to ' +
       'ensure everything for A-Frame is properly registered before they are used from ' +
       'HTML.');
}

// Polyfill `Promise`.
window.Promise = window.Promise || _dereq_('promise-polyfill');

// Check before the polyfill runs
window.hasNativeWebVRImplementation = !!navigator.getVRDisplays || !!navigator.getVRDevices;

window.WebVRConfig = window.WebVRConfig || {
  BUFFER_SCALE: 1,
  CARDBOARD_UI_DISABLED: true,
  ROTATE_INSTRUCTIONS_DISABLED: true,
  TOUCH_PANNER_DISABLED: true,
  MOUSE_KEYBOARD_CONTROLS_DISABLED: true
};

// Workaround for iOS Safari canvas sizing issues in stereo (webvr-polyfill/issues/102).
// Only for iOS on versions older than 10.
if (utils.device.isIOSOlderThan10(navigator.userAgent)) {
  window.WebVRConfig.BUFFER_SCALE = 1 / window.devicePixelRatio;
}

// WebVR polyfill
_dereq_('webvr-polyfill');

_dereq_('present'); // Polyfill `performance.now()`.
// CSS.
_dereq_('./style/aframe.css');
_dereq_('./style/rStats.css');

// Required before `AEntity` so that all components are registered.
var AScene = _dereq_('./core/scene/a-scene');
var components = _dereq_('./core/component').components;
var registerComponent = _dereq_('./core/component').registerComponent;
var registerGeometry = _dereq_('./core/geometry').registerGeometry;
var registerPrimitive = _dereq_('./extras/primitives/primitives').registerPrimitive;
var registerShader = _dereq_('./core/shader').registerShader;
var registerSystem = _dereq_('./core/system').registerSystem;
var shaders = _dereq_('./core/shader').shaders;
var systems = _dereq_('./core/system').systems;
// Exports THREE to window so three.js can be used without alteration.
var THREE = window.THREE = _dereq_('./lib/three');
var TWEEN = window.TWEEN = _dereq_('tween.js');

var pkg = _dereq_('../package');

_dereq_('./components/index'); // Register standard components.
_dereq_('./geometries/index'); // Register standard geometries.
_dereq_('./shaders/index'); // Register standard shaders.
_dereq_('./systems/index'); // Register standard systems.
var ANode = _dereq_('./core/a-node');
var AEntity = _dereq_('./core/a-entity'); // Depends on ANode and core components.

_dereq_('./core/a-animation');
_dereq_('./core/a-assets');
_dereq_('./core/a-cubemap');
_dereq_('./core/a-mixin');

// Extras.
_dereq_('./extras/components/');
_dereq_('./extras/primitives/');

console.log('A-Frame Version: 0.5.0 (Date 10-02-2017, Commit #bf8b8f9)');
console.log('three Version:', pkg.dependencies['three']);
console.log('WebVR Polyfill Version:', pkg.dependencies['webvr-polyfill']);

module.exports = window.AFRAME = {
  AComponent: _dereq_('./core/component').Component,
  AEntity: AEntity,
  ANode: ANode,
  AScene: AScene,
  components: components,
  geometries: _dereq_('./core/geometry').geometries,
  registerComponent: registerComponent,
  registerElement: _dereq_('./core/a-register-element').registerElement,
  registerGeometry: registerGeometry,
  registerPrimitive: registerPrimitive,
  registerShader: registerShader,
  registerSystem: registerSystem,
  primitives: {
    getMeshMixin: _dereq_('./extras/primitives/getMeshMixin'),
    primitives: _dereq_('./extras/primitives/primitives').primitives
  },
  scenes: _dereq_('./core/scene/scenes'),
  schema: _dereq_('./core/schema'),
  shaders: shaders,
  systems: systems,
  THREE: THREE,
  TWEEN: TWEEN,
  utils: utils,
  version: pkg.version
};

},{"../package":55,"./components/index":63,"./core/a-animation":93,"./core/a-assets":94,"./core/a-cubemap":95,"./core/a-entity":96,"./core/a-mixin":97,"./core/a-node":98,"./core/a-register-element":99,"./core/component":100,"./core/geometry":101,"./core/scene/a-scene":103,"./core/scene/scenes":106,"./core/schema":108,"./core/shader":109,"./core/system":110,"./extras/components/":111,"./extras/primitives/":114,"./extras/primitives/getMeshMixin":113,"./extras/primitives/primitives":115,"./geometries/index":136,"./lib/three":146,"./shaders/index":148,"./style/aframe.css":152,"./style/rStats.css":153,"./systems/index":157,"./utils/":167,"present":34,"promise-polyfill":35,"tween.js":49,"webvr-polyfill":50}],145:[function(_dereq_,module,exports){
window.aframeStats = function (scene) {
  var _rS = null;
  var _scene = scene;
  var _values = {
    te: {
      caption: 'Entities'
    },
    lt: {
      caption: 'Load Time'
    }
  };
  var _groups = [ {
    caption: 'A-Frame',
    values: [ 'te', 'lt' ]
  } ];

  function _update () {
    _rS('te').set(getEntityCount());
    if (window.performance.getEntriesByName) {
      _rS('lt').set(window.performance.getEntriesByName('render-started')[0].startTime.toFixed(0));
    }
  }

  function getEntityCount () {
    var elements = _scene.querySelectorAll('*');
    Array.prototype.slice.call(elements).filter(function (el) {
      return el.isEntity;
    });
    return elements.length;
  }

  function _start () {}

  function _end () {}

  function _attach (r) {
    _rS = r;
  }

  return {
    update: _update,
    start: _start,
    end: _end,
    attach: _attach,
    values: _values,
    groups: _groups,
    fractions: []
  };
};

if (typeof module === 'object') {
  module.exports = {
    aframeStats: window.aframeStats
  };
}

},{}],146:[function(_dereq_,module,exports){
(function (global){
var THREE = global.THREE = _dereq_('three');

// Allow cross-origin images to be loaded.

// This should not be on `THREE.Loader` nor `THREE.ImageUtils`.
// Must be on `THREE.TextureLoader`.
if (THREE.TextureLoader) {
  THREE.TextureLoader.prototype.crossOrigin = 'anonymous';
}

// This is for images loaded from the model loaders.
if (THREE.ImageLoader) {
  THREE.ImageLoader.prototype.crossOrigin = 'anonymous';
}

// In-memory caching for XHRs (for images, audio files, textures, etc.).
if (THREE.Cache) {
  THREE.Cache.enabled = true;
}

// TODO: Eventually include these only if they are needed by a component.
_dereq_('three/examples/js/loaders/GLTFLoader');  // THREE.GLTFLoader
_dereq_('three/examples/js/loaders/OBJLoader');  // THREE.OBJLoader
_dereq_('three/examples/js/loaders/MTLLoader');  // THREE.MTLLoader
_dereq_('three/examples/js/BlendCharacter');  // THREE.BlendCharacter
_dereq_('three/examples/js/loaders/ColladaLoader');  // THREE.ColladaLoader
_dereq_('../../vendor/VRControls');  // THREE.VRControls
_dereq_('../../vendor/VREffect');  // THREE.VREffect

THREE.ColladaLoader.prototype.crossOrigin = 'anonymous';
THREE.GLTFLoader.prototype.crossOrigin = 'anonymous';
THREE.MTLLoader.prototype.crossOrigin = 'anonymous';
THREE.OBJLoader.prototype.crossOrigin = 'anonymous';

module.exports = THREE;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../../vendor/VRControls":172,"../../vendor/VREffect":173,"three":42,"three/examples/js/BlendCharacter":43,"three/examples/js/loaders/ColladaLoader":44,"three/examples/js/loaders/GLTFLoader":45,"three/examples/js/loaders/MTLLoader":46,"three/examples/js/loaders/OBJLoader":47}],147:[function(_dereq_,module,exports){
var registerShader = _dereq_('../core/shader').registerShader;
var THREE = _dereq_('../lib/three');
var utils = _dereq_('../utils/');

/**
 * Flat shader using THREE.MeshBasicMaterial.
 */
module.exports.Shader = registerShader('flat', {
  schema: {
    color: {type: 'color'},
    fog: {default: true},
    height: {default: 256},
    offset: {type: 'vec2', default: {x: 0, y: 0}},
    repeat: {type: 'vec2', default: {x: 1, y: 1}},
    src: {type: 'map'},
    width: {default: 512},
    wireframe: {default: false},
    wireframeLinewidth: {default: 2}
  },

  /**
   * Initializes the shader.
   * Adds a reference from the scene to this entity as the camera.
   */
  init: function (data) {
    this.textureSrc = null;
    this.material = new THREE.MeshBasicMaterial(getMaterialData(data));
    utils.material.updateMap(this, data);
  },

  update: function (data) {
    this.updateMaterial(data);
    utils.material.updateMap(this, data);
  },

  /**
   * Updating existing material.
   *
   * @param {object} data - Material component data.
   */
  updateMaterial: function (data) {
    var material = this.material;
    data = getMaterialData(data);
    Object.keys(data).forEach(function (key) {
      material[key] = data[key];
    });
  }
});

/**
 * Builds and normalize material data, normalizing stuff along the way.
 *
 * @param {object} data - Material data.
 * @returns {object} data - Processed material data.
 */
function getMaterialData (data) {
  return {
    fog: data.fog,
    color: new THREE.Color(data.color),
    wireframe: data.wireframe,
    wireframeLinewidth: data.wireframeLinewidth
  };
}

},{"../core/shader":109,"../lib/three":146,"../utils/":167}],148:[function(_dereq_,module,exports){
_dereq_('./flat');
_dereq_('./standard');
_dereq_('./sdf');
_dereq_('./msdf');

},{"./flat":147,"./msdf":149,"./sdf":150,"./standard":151}],149:[function(_dereq_,module,exports){
var registerShader = _dereq_('../core/shader').registerShader;

/**
 * Multi-channel signed distance field.
 * Used by text component.
 */
module.exports.Shader = registerShader('msdf', {
  schema: {
    alphaTest: {type: 'number', is: 'uniform', default: 0.5},
    color: {type: 'color', is: 'uniform', default: 'white'},
    map: {type: 'map', is: 'uniform'},
    opacity: {type: 'number', is: 'uniform', default: 1.0}
  },

  raw: true,

  vertexShader: [
    'attribute vec2 uv;',
    'attribute vec3 position;',
    'uniform mat4 projectionMatrix;',
    'uniform mat4 modelViewMatrix;',
    'varying vec2 vUV;',
    'void main(void) {',
    '  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);',
    '  vUV = uv;',
    '}'
  ].join('\n'),

  fragmentShader: [
    '#ifdef GL_OES_standard_derivatives',
    '#extension GL_OES_standard_derivatives: enable',
    '#endif',

    'precision highp float;',
    // FIXME: Experimentally determined constants.
    '#define BIG_ENOUGH 0.001',
    '#define MODIFIED_ALPHATEST (0.02 * isBigEnough / BIG_ENOUGH)',
    '#define ALL_SMOOTH 0.4',
    '#define ALL_ROUGH 0.02',
    '#define DISCARD_ALPHA (alphaTest / (2.2 - 1.2 * ratio))',
    'uniform sampler2D map;',
    'uniform vec3 color;',
    'uniform float opacity;',
    'uniform float alphaTest;',
    'varying vec2 vUV;',

    'float median(float r, float g, float b) {',
    '  return max(min(r, g), min(max(r, g), b));',
    '}',
    'void main() {',
    '  vec3 sample = 1.0 - texture2D(map, vUV).rgb;',
    '  float sigDist = median(sample.r, sample.g, sample.b) - 0.5;',
    '  float alpha = clamp(sigDist/fwidth(sigDist) + 0.5, 0.0, 1.0);',
    '  float dscale = 0.353505;',
    '  vec2 duv = dscale * (dFdx(vUV) + dFdy(vUV));',
    '  float isBigEnough = max(abs(duv.x), abs(duv.y));',
    // When texel is too small, blend raw alpha value rather than supersampling.
    // FIXME: Experimentally determined constant.
    '  if (isBigEnough > BIG_ENOUGH) {',
    '    float ratio = BIG_ENOUGH / isBigEnough;',
    '    alpha = ratio * alpha + (1.0 - ratio) * (sigDist + 0.5);',
    '  }',

    '  gl_FragColor = vec4(color.xyz, alpha * opacity);',
    // When texel is big enough, do standard alpha test.
    // FIXME: Experimentally determined constant.
    // Looks much better if we *don't* do this, but do we get Z fighting?
    '  if (isBigEnough <= BIG_ENOUGH && gl_FragColor.a < alphaTest) { discard; return; }',
    // Else, do modified alpha test.
    // FIXME: Experimentally determined constant.
    '  if (gl_FragColor.a < alphaTest * MODIFIED_ALPHATEST) { discard; return; }',
    '}'
  ].join('\n')
});

},{"../core/shader":109}],150:[function(_dereq_,module,exports){
var registerShader = _dereq_('../core/shader').registerShader;

/**
 * Signed distance field.
 * Used by text component.
 */
module.exports.Shader = registerShader('sdf', {
  schema: {
    alphaTest: {type: 'number', is: 'uniform', default: 0.5},
    color: {type: 'color', is: 'uniform', default: 'white'},
    map: {type: 'map', is: 'uniform'},
    opacity: {type: 'number', is: 'uniform', default: 1.0}
  },

  raw: true,

  vertexShader: [
    'attribute vec2 uv;',
    'attribute vec3 position;',
    'uniform mat4 projectionMatrix;',
    'uniform mat4 modelViewMatrix;',
    'varying vec2 vUV;',
    'void main(void) {',
    '  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);',
    '  vUV = uv;',
    '}'
  ].join('\n'),

  fragmentShader: [
    '#ifdef GL_OES_standard_derivatives',
    '#extension GL_OES_standard_derivatives: enable',
    '#endif',

    'precision highp float;',
    // FIXME: experimentally determined constants
    '#define BIG_ENOUGH 0.001',
    '#define MODIFIED_ALPHATEST (0.02 * isBigEnough / BIG_ENOUGH)',
    '#define ALL_SMOOTH 0.4',
    '#define ALL_ROUGH 0.02',
    '#define DISCARD_ALPHA (alphaTest / (2.2 - 1.2 * ratio))',
    'uniform sampler2D map;',
    'uniform vec3 color;',
    'uniform float opacity;',
    'uniform float alphaTest;',
    'varying vec2 vUV;',
    '#ifdef GL_OES_standard_derivatives',
    'float contour(float width, float value) {',
    '  return smoothstep(0.5 - value, 0.5 + value, width);',
    '}',
    '#else',
    'float aastep(float value, float afwidth) {',
    '  return smoothstep(0.5 - afwidth, 0.5 + afwidth, value);',
    '}',
    '#endif',
    'void main() {',
    '#ifdef GL_OES_standard_derivatives',
    // when we have derivatives and can get texel size etc., that allows supersampling etc.
    '  vec2 uv = vUV;',
    '  vec4 texColor = texture2D(map, uv);',
    '  float dist = texColor.a;',
    '  float width = fwidth(dist);',
    '  float alpha = contour(dist, width);',
    '  float dscale = 0.353505;',
    '  vec2 duv = dscale * (dFdx(uv) + dFdy(uv));',
    '  float isBigEnough = max(abs(duv.x), abs(duv.y));',
    // when texel is too small, blend raw alpha value rather than supersampling etc.
    // FIXME: experimentally determined constant
    '  if (isBigEnough > BIG_ENOUGH) {',
    '    float ratio = BIG_ENOUGH / isBigEnough;',
    '    alpha = ratio * alpha + (1.0 - ratio) * dist;',
    '  }',
    // otherwise do weighted supersampling
    // FIXME: why this weighting?
    '  else if (isBigEnough <= BIG_ENOUGH) {',
    '    vec4 box = vec4 (uv - duv, uv + duv);',
    '    alpha = (alpha + 0.5 * (',
    '      contour(texture2D(map, box.xy).a, width)',
    '      + contour(texture2D(map, box.zw).a, width)',
    '      + contour(texture2D(map, box.xw).a, width)',
    '      + contour(texture2D(map, box.zy).a, width)',
    '    )) / 3.0;',
    '  }',
    // when texel is big enough, do standard alpha test
    // FIXME: experimentally determined constant
    // looks much better if we DON'T do this, but do we get Z fighting etc.?
    '  if (isBigEnough <= BIG_ENOUGH && alpha < alphaTest) { discard; return; }',
    // else do modified alpha test
    // FIXME: experimentally determined constant
    '  if (alpha < alphaTest * MODIFIED_ALPHATEST) { discard; return; }',
    '#else',
    '  vec4 texColor = texture2D(map, vUV);',
    '  float value = texColor.a;',
    // when we don't have derivatives, use approximations
    // FIXME: if we understood font pixel dimensions, this could probably be improved
    '  float afwidth = (1.0 / 32.0) * (1.4142135623730951 / (2.0 * gl_FragCoord.w));',
    '  float alpha = aastep(value, afwidth);',
    // use gl_FragCoord.w to guess when we should blend
    // FIXME: if we understood font pixel dimensions, this could probably be improved
    '  float ratio = (gl_FragCoord.w >= ALL_SMOOTH) ? 1.0 : (gl_FragCoord.w < ALL_ROUGH) ? 0.0 : (gl_FragCoord.w - ALL_ROUGH) / (ALL_SMOOTH - ALL_ROUGH);',
    '  if (alpha < alphaTest) { if (ratio >= 1.0) { discard; return; } alpha = 0.0; }',
    '  alpha = alpha * ratio + (1.0 - ratio) * value;',
    '  if (ratio < 1.0)',
    '    if (alpha <= DISCARD_ALPHA) { discard; return; }',
    '#endif',
    '  gl_FragColor = vec4(color, opacity * alpha);',
    '}'
  ].join('\n')
});

},{"../core/shader":109}],151:[function(_dereq_,module,exports){
var registerShader = _dereq_('../core/shader').registerShader;
var THREE = _dereq_('../lib/three');
var utils = _dereq_('../utils/');

var CubeLoader = new THREE.CubeTextureLoader();
var texturePromises = {};

/**
 * Standard (physically-based) shader using THREE.MeshStandardMaterial.
 */
module.exports.Shader = registerShader('standard', {
  schema: {
    ambientOcclusionMap: {type: 'map'},
    ambientOcclusionMapIntensity: {default: 1},
    ambientOcclusionTextureOffset: {type: 'vec2'},
    ambientOcclusionTextureRepeat: {type: 'vec2', default: {x: 1, y: 1}},

    color: {type: 'color'},

    displacementMap: {type: 'map'},
    displacementScale: {default: 1},
    displacementBias: {default: 0.5},
    displacementTextureOffset: {type: 'vec2'},
    displacementTextureRepeat: {type: 'vec2', default: {x: 1, y: 1}},
    envMap: {default: ''},

    fog: {default: true},
    height: {default: 256},
    metalness: {default: 0.0, min: 0.0, max: 1.0},

    normalMap: {type: 'map'},
    normalScale: {type: 'vec2', default: '1 1'},
    normalTextureOffset: {type: 'vec2'},
    normalTextureRepeat: {type: 'vec2', default: {x: 1, y: 1}},

    offset: {type: 'vec2', default: {x: 0, y: 0}},
    repeat: {type: 'vec2', default: {x: 1, y: 1}},
    roughness: {default: 0.5, min: 0.0, max: 1.0},
    sphericalEnvMap: {type: 'map'},
    src: {type: 'map'},
    width: {default: 512},
    wireframe: {default: false},
    wireframeLinewidth: {default: 2}
  },

  /**
   * Initializes the shader.
   * Adds a reference from the scene to this entity as the camera.
   */
  init: function (data) {
    this.material = new THREE.MeshStandardMaterial(getMaterialData(data));
    utils.material.updateMap(this, data);
    if (data.normalMap) { utils.material.updateDistortionMap('normal', this, data); }
    if (data.displacementMap) { utils.material.updateDistortionMap('displacement', this, data); }
    if (data.ambientOcclusionMap) { utils.material.updateDistortionMap('ambientOcclusion', this, data); }
    this.updateEnvMap(data);
  },

  update: function (data) {
    this.updateMaterial(data);
    utils.material.updateMap(this, data);
    if (data.normalMap) { utils.material.updateDistortionMap('normal', this, data); }
    if (data.displacementMap) { utils.material.updateDistortionMap('displacement', this, data); }
    if (data.ambientOcclusionMap) { utils.material.updateDistortionMap('ambientOcclusion', this, data); }
    this.updateEnvMap(data);
  },

  /**
   * Updating existing material.
   *
   * @param {object} data - Material component data.
   * @returns {object} Material.
   */
  updateMaterial: function (data) {
    var material = this.material;
    data = getMaterialData(data);
    Object.keys(data).forEach(function (key) {
      material[key] = data[key];
    });
  },

  /**
   * Handle environment cubemap. Textures are cached in texturePromises.
   */
  updateEnvMap: function (data) {
    var self = this;
    var material = this.material;
    var envMap = data.envMap;
    var sphericalEnvMap = data.sphericalEnvMap;

    // No envMap defined or already loading.
    if ((!envMap && !sphericalEnvMap) || this.isLoadingEnvMap) {
      material.envMap = null;
      material.needsUpdate = true;
      return;
    }
    this.isLoadingEnvMap = true;

    // if a spherical env map is defined then use it.
    if (sphericalEnvMap) {
      this.el.sceneEl.systems.material.loadTexture(sphericalEnvMap, {src: sphericalEnvMap}, function textureLoaded (texture) {
        self.isLoadingEnvMap = false;
        texture.mapping = THREE.SphericalReflectionMapping;
        material.envMap = texture;
        utils.material.handleTextureEvents(self.el, texture);
        material.needsUpdate = true;
      });
      return;
    }

    // Another material is already loading this texture. Wait on promise.
    if (texturePromises[envMap]) {
      texturePromises[envMap].then(function (cube) {
        self.isLoadingEnvMap = false;
        material.envMap = cube;
        utils.material.handleTextureEvents(self.el, cube);
        material.needsUpdate = true;
      });
      return;
    }

    // Material is first to load this texture. Load and resolve texture.
    texturePromises[envMap] = new Promise(function (resolve) {
      utils.srcLoader.validateCubemapSrc(envMap, function loadEnvMap (urls) {
        CubeLoader.load(urls, function (cube) {
          // Texture loaded.
          self.isLoadingEnvMap = false;
          material.envMap = cube;
          utils.material.handleTextureEvents(self.el, cube);
          resolve(cube);
        });
      });
    });
  }
});

/**
 * Builds and normalize material data, normalizing stuff along the way.
 *
 * @param {object} data - Material data.
 * @returns {object} data - Processed material data.
 */
function getMaterialData (data) {
  var newData = {
    color: new THREE.Color(data.color),
    fog: data.fog,
    metalness: data.metalness,
    roughness: data.roughness,
    wireframe: data.wireframe,
    wireframeLinewidth: data.wireframeLinewidth
  };

  if (data.normalMap) { newData.normalScale = data.normalScale; }

  if (data.ambientOcclusionMap) { newData.aoMapIntensity = data.ambientOcclusionMapIntensity; }

  if (data.displacementMap) {
    newData.displacementScale = data.displacementScale;
    newData.displacementBias = data.displacementBias;
  }

  return newData;
}

},{"../core/shader":109,"../lib/three":146,"../utils/":167}],152:[function(_dereq_,module,exports){
var css = ".a-html{bottom:0;left:0;position:fixed;right:0;top:0}.a-body{height:100%;margin:0;overflow:hidden;padding:0;width:100%}:-webkit-full-screen{background-color:transparent}.a-hidden{display:none!important}.a-canvas{height:100%;left:0;position:absolute;top:0;width:100%}.a-canvas.a-grab-cursor:hover{cursor:grab;cursor:-moz-grabbing;cursor:-webkit-grab}.a-canvas.a-grab-cursor:active,.a-grabbing{cursor:grabbing;cursor:-moz-grabbing;cursor:-webkit-grabbing}// Class is removed when doing <a-scene embedded>. a-scene.fullscreen .a-canvas{width:100%!important;height:100%!important;top:0!important;left:0!important;right:0!important;bottom:0!important;z-index:999999!important;position:fixed!important}.a-inspector-loader{background-color:#ed3160;position:fixed;left:3px;top:3px;padding:6px 10px;color:#fff;text-decoration:none;font-size:12px;font-family:Roboto,sans-serif;text-align:center;z-index:99999;width:174px}@keyframes dots-1{from{opacity:0}25%{opacity:1}}@keyframes dots-2{from{opacity:0}50%{opacity:1}}@keyframes dots-3{from{opacity:0}75%{opacity:1}}@-webkit-keyframes dots-1{from{opacity:0}25%{opacity:1}}@-webkit-keyframes dots-2{from{opacity:0}50%{opacity:1}}@-webkit-keyframes dots-3{from{opacity:0}75%{opacity:1}}.a-inspector-loader .dots span{animation:dots-1 2s infinite steps(1);-webkit-animation:dots-1 2s infinite steps(1)}.a-inspector-loader .dots span:first-child+span{animation-name:dots-2;-webkit-animation-name:dots-2}.a-inspector-loader .dots span:first-child+span+span{animation-name:dots-3;-webkit-animation-name:dots-3}a-scene{display:block;position:relative;height:100%;width:100%}a-assets,a-scene audio,a-scene img,a-scene video{display:none}.a-enter-vr-modal,.a-orientation-modal{font-family:Consolas,Andale Mono,Courier New,monospace}.a-enter-vr-modal a{border-bottom:1px solid #fff;padding:2px 0;text-decoration:none;transition:.1s color ease-in}.a-enter-vr-modal a:hover{background-color:#fff;color:#111;padding:2px 4px;position:relative;left:-4px}.a-enter-vr{font-family:sans-serif,monospace;font-size:13px;width:100%;font-weight:200;line-height:16px;height:10%;position:absolute;right:20px;bottom:20px}.a-enter-vr.embedded{right:5px;bottom:5px}.a-enter-vr-button,.a-enter-vr-modal,.a-enter-vr-modal a{color:#fff}.a-enter-vr-button{background:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20245.82%20141.73%22%3E%3Cdefs%3E%3Cstyle%3E.a%7Bfill%3A%23fff%3Bfill-rule%3Aevenodd%3B%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Ctitle%3Emask%3C%2Ftitle%3E%3Cpath%20class%3D%22a%22%20d%3D%22M175.56%2C111.37c-22.52%2C0-40.77-18.84-40.77-42.07S153%2C27.24%2C175.56%2C27.24s40.77%2C18.84%2C40.77%2C42.07S198.08%2C111.37%2C175.56%2C111.37ZM26.84%2C69.31c0-23.23%2C18.25-42.07%2C40.77-42.07s40.77%2C18.84%2C40.77%2C42.07-18.26%2C42.07-40.77%2C42.07S26.84%2C92.54%2C26.84%2C69.31ZM27.27%2C0C11.54%2C0%2C0%2C12.34%2C0%2C28.58V110.9c0%2C16.24%2C11.54%2C30.83%2C27.27%2C30.83H99.57c2.17%2C0%2C4.19-1.83%2C5.4-3.7L116.47%2C118a8%2C8%2C0%2C0%2C1%2C12.52-.18l11.51%2C20.34c1.2%2C1.86%2C3.22%2C3.61%2C5.39%2C3.61h72.29c15.74%2C0%2C27.63-14.6%2C27.63-30.83V28.58C245.82%2C12.34%2C233.93%2C0%2C218.19%2C0H27.27Z%22%2F%3E%3C%2Fsvg%3E) 50% 50%/70% 70% no-repeat rgba(0,0,0,.35);border:0;bottom:0;cursor:pointer;min-width:50px;min-height:30px;padding-right:5%;padding-top:4%;position:absolute;right:0;transition:background-color .05s ease;-webkit-transition:background-color .05s ease;z-index:9999}.a-enter-vr-button:active,.a-enter-vr-button:hover{background-color:#666}[data-a-enter-vr-no-webvr] .a-enter-vr-button{border-color:#666;opacity:.65}[data-a-enter-vr-no-webvr] .a-enter-vr-button:active,[data-a-enter-vr-no-webvr] .a-enter-vr-button:hover{background-color:rgba(0,0,0,.35);cursor:not-allowed}.a-enter-vr-modal{background-color:#666;border-radius:0;display:none;min-height:32px;margin-right:70px;padding:9px;width:280px;right:2%;position:absolute}.a-enter-vr-modal:after{border-bottom:10px solid transparent;border-left:10px solid #666;border-top:10px solid transparent;display:inline-block;content:'';position:absolute;right:-5px;top:5px;width:0;height:0}.a-enter-vr-modal a,.a-enter-vr-modal p{display:inline}.a-enter-vr-modal p{margin:0}.a-enter-vr-modal p:after{content:' '}[data-a-enter-vr-no-headset].a-enter-vr:hover .a-enter-vr-modal,[data-a-enter-vr-no-webvr].a-enter-vr:hover .a-enter-vr-modal{display:block}.a-orientation-modal{background:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20version%3D%221.1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2090%2090%22%20enable-background%3D%22new%200%200%2090%2090%22%20xml%3Aspace%3D%22preserve%22%3E%3Cpolygon%20points%3D%220%2C0%200%2C0%200%2C0%20%22%3E%3C/polygon%3E%3Cg%3E%3Cpath%20d%3D%22M71.545%2C48.145h-31.98V20.743c0-2.627-2.138-4.765-4.765-4.765H18.456c-2.628%2C0-4.767%2C2.138-4.767%2C4.765v42.789%20%20%20c0%2C2.628%2C2.138%2C4.766%2C4.767%2C4.766h5.535v0.959c0%2C2.628%2C2.138%2C4.765%2C4.766%2C4.765h42.788c2.628%2C0%2C4.766-2.137%2C4.766-4.765V52.914%20%20%20C76.311%2C50.284%2C74.173%2C48.145%2C71.545%2C48.145z%20M18.455%2C16.935h16.344c2.1%2C0%2C3.808%2C1.708%2C3.808%2C3.808v27.401H37.25V22.636%20%20%20c0-0.264-0.215-0.478-0.479-0.478H16.482c-0.264%2C0-0.479%2C0.214-0.479%2C0.478v36.585c0%2C0.264%2C0.215%2C0.478%2C0.479%2C0.478h7.507v7.644%20%20%20h-5.534c-2.101%2C0-3.81-1.709-3.81-3.81V20.743C14.645%2C18.643%2C16.354%2C16.935%2C18.455%2C16.935z%20M16.96%2C23.116h19.331v25.031h-7.535%20%20%20c-2.628%2C0-4.766%2C2.139-4.766%2C4.768v5.828h-7.03V23.116z%20M71.545%2C73.064H28.757c-2.101%2C0-3.81-1.708-3.81-3.808V52.914%20%20%20c0-2.102%2C1.709-3.812%2C3.81-3.812h42.788c2.1%2C0%2C3.809%2C1.71%2C3.809%2C3.812v16.343C75.354%2C71.356%2C73.645%2C73.064%2C71.545%2C73.064z%22%3E%3C/path%3E%3Cpath%20d%3D%22M28.919%2C58.424c-1.466%2C0-2.659%2C1.193-2.659%2C2.66c0%2C1.466%2C1.193%2C2.658%2C2.659%2C2.658c1.468%2C0%2C2.662-1.192%2C2.662-2.658%20%20%20C31.581%2C59.617%2C30.387%2C58.424%2C28.919%2C58.424z%20M28.919%2C62.786c-0.939%2C0-1.703-0.764-1.703-1.702c0-0.939%2C0.764-1.704%2C1.703-1.704%20%20%20c0.94%2C0%2C1.705%2C0.765%2C1.705%2C1.704C30.623%2C62.022%2C29.858%2C62.786%2C28.919%2C62.786z%22%3E%3C/path%3E%3Cpath%20d%3D%22M69.654%2C50.461H33.069c-0.264%2C0-0.479%2C0.215-0.479%2C0.479v20.288c0%2C0.264%2C0.215%2C0.478%2C0.479%2C0.478h36.585%20%20%20c0.263%2C0%2C0.477-0.214%2C0.477-0.478V50.939C70.131%2C50.676%2C69.917%2C50.461%2C69.654%2C50.461z%20M69.174%2C51.417V70.75H33.548V51.417H69.174z%22%3E%3C/path%3E%3Cpath%20d%3D%22M45.201%2C30.296c6.651%2C0%2C12.233%2C5.351%2C12.551%2C11.977l-3.033-2.638c-0.193-0.165-0.507-0.142-0.675%2C0.048%20%20%20c-0.174%2C0.198-0.153%2C0.501%2C0.045%2C0.676l3.883%2C3.375c0.09%2C0.075%2C0.198%2C0.115%2C0.312%2C0.115c0.141%2C0%2C0.273-0.061%2C0.362-0.166%20%20%20l3.371-3.877c0.173-0.2%2C0.151-0.502-0.047-0.675c-0.194-0.166-0.508-0.144-0.676%2C0.048l-2.592%2C2.979%20%20%20c-0.18-3.417-1.629-6.605-4.099-9.001c-2.538-2.461-5.877-3.817-9.404-3.817c-0.264%2C0-0.479%2C0.215-0.479%2C0.479%20%20%20C44.72%2C30.083%2C44.936%2C30.296%2C45.201%2C30.296z%22%3E%3C/path%3E%3C/g%3E%3C/svg%3E) center/50% 50% no-repeat rgba(244,244,244,1);bottom:0;font-size:14px;font-weight:600;left:0;line-height:20px;right:0;position:fixed;top:0;z-index:9999999}.a-orientation-modal:after{color:#666;content:\"Insert phone into Cardboard holder.\";display:block;position:absolute;text-align:center;top:70%;transform:translateY(-70%);width:100%}.a-orientation-modal button{background:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20version%3D%221.1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%20100%20100%22%20enable-background%3D%22new%200%200%20100%20100%22%20xml%3Aspace%3D%22preserve%22%3E%3Cpath%20fill%3D%22%23000000%22%20d%3D%22M55.209%2C50l17.803-17.803c1.416-1.416%2C1.416-3.713%2C0-5.129c-1.416-1.417-3.713-1.417-5.129%2C0L50.08%2C44.872%20%20L32.278%2C27.069c-1.416-1.417-3.714-1.417-5.129%2C0c-1.417%2C1.416-1.417%2C3.713%2C0%2C5.129L44.951%2C50L27.149%2C67.803%20%20c-1.417%2C1.416-1.417%2C3.713%2C0%2C5.129c0.708%2C0.708%2C1.636%2C1.062%2C2.564%2C1.062c0.928%2C0%2C1.856-0.354%2C2.564-1.062L50.08%2C55.13l17.803%2C17.802%20%20c0.708%2C0.708%2C1.637%2C1.062%2C2.564%2C1.062s1.856-0.354%2C2.564-1.062c1.416-1.416%2C1.416-3.713%2C0-5.129L55.209%2C50z%22%3E%3C/path%3E%3C/svg%3E) no-repeat;border:none;height:50px;text-indent:-9999px;width:50px}"; (_dereq_("browserify-css").createStyle(css, { "href": "src/style/aframe.css"})); module.exports = css;
},{"browserify-css":3}],153:[function(_dereq_,module,exports){
var css = ".rs-base{background-color:#333;color:#fafafa;border-radius:0;font:10px monospace;left:5px;line-height:1em;opacity:.85;overflow:hidden;padding:10px;position:fixed;top:5px;width:300px;z-index:10000}.rs-base div.hidden{display:none}.rs-base h1{color:#fff;cursor:pointer;font-size:1.4em;font-weight:300;margin:0 0 5px;padding:0}.rs-group{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-flex-direction:column-reverse;flex-direction:column-reverse;margin-bottom:5px}.rs-group:last-child{margin-bottom:0}.rs-counter-base{align-items:center;display:-webkit-box;display:-webkit-flex;display:flex;height:10px;-webkit-justify-content:space-between;justify-content:space-between;margin:2px 0}.rs-counter-base.alarm{color:#b70000;text-shadow:0 0 0 #b70000,0 0 1px #fff,0 0 1px #fff,0 0 2px #fff,0 0 2px #fff,0 0 3px #fff,0 0 3px #fff,0 0 4px #fff,0 0 4px #fff}.rs-counter-id{font-weight:300;-webkit-box-ordinal-group:0;-webkit-order:0;order:0;width:54px}.rs-counter-value{font-weight:300;-webkit-box-ordinal-group:1;-webkit-order:1;order:1;text-align:right;width:35px}.rs-canvas{-webkit-box-ordinal-group:2;-webkit-order:2;order:2}@media (min-width:480px){.rs-base{left:20px;top:20px}}"; (_dereq_("browserify-css").createStyle(css, { "href": "src/style/rStats.css"})); module.exports = css;
},{"browserify-css":3}],154:[function(_dereq_,module,exports){
var bind = _dereq_('../utils/bind');
var constants = _dereq_('../constants/');
var registerSystem = _dereq_('../core/system').registerSystem;

var DEFAULT_CAMERA_ATTR = 'data-aframe-default-camera';

/**
 * Camera system. Manages which camera is active among multiple cameras in scene.
 *
 * @member {object} activeCameraEl - Active camera entity.
 */
module.exports.System = registerSystem('camera', {
  init: function () {
    this.activeCameraEl = null;
    // Wait for all entities to fully load before checking for existence of camera.
    // Since entities wait for <a-assets> to load, any cameras attaching to the scene
    // will do so asynchronously.
    this.sceneEl.addEventListener('loaded', bind(this.setupDefaultCamera, this));
  },

  /**
   * Create a default camera if user has not added one during the initial scene traversal.
   *
   * Default camera offset height is at average eye level (~1.6m).
   */
  setupDefaultCamera: function () {
    var sceneEl = this.sceneEl;
    var defaultCameraEl;

    // Camera already defined.
    if (sceneEl.camera) {
      sceneEl.emit('camera-ready', {cameraEl: sceneEl.camera.el});
      return;
    }

    // Set up default camera.
    defaultCameraEl = document.createElement('a-entity');
    defaultCameraEl.setAttribute('position', '0 0 0');
    defaultCameraEl.setAttribute(DEFAULT_CAMERA_ATTR, '');
    defaultCameraEl.setAttribute('camera', {active: true, userHeight: constants.DEFAULT_CAMERA_HEIGHT});
    defaultCameraEl.setAttribute('wasd-controls', '');
    defaultCameraEl.setAttribute('look-controls', '');
    defaultCameraEl.setAttribute(constants.AFRAME_INJECTED, '');
    sceneEl.appendChild(defaultCameraEl);
    sceneEl.addEventListener('enter-vr', this.removeDefaultOffset);
    sceneEl.addEventListener('exit-vr', this.addDefaultOffset);
    sceneEl.emit('camera-ready', {cameraEl: defaultCameraEl});
  },

  /**
   * Set a different active camera.
   * When we choose a (sort of) random scene camera as the replacement, set its `active` to
   * true. The camera component will call `setActiveCamera` and handle passing the torch to
   * the new camera.
   */
  disableActiveCamera: function () {
    var cameraEls = this.sceneEl.querySelectorAll('[camera]');
    var newActiveCameraEl = cameraEls[cameraEls.length - 1];
    newActiveCameraEl.setAttribute('camera', 'active', true);
  },

  /**
   * Set active camera to be used by renderer.
   * Removes the default camera (if present).
   * Disables all other cameras in the scene.
   *
   * @param {Element} newCameraEl - Entity with camera component.
   */
  setActiveCamera: function (newCameraEl) {
    var cameraEl;
    var cameraEls;
    var i;
    var newCamera;
    var previousCamera = this.activeCameraEl;
    var sceneEl = this.sceneEl;

    // Same camera.
    newCamera = newCameraEl.getObject3D('camera');
    if (!newCamera || newCameraEl === this.activeCameraEl) { return; }

    // Grab the default camera.
    var defaultCameraWrapper = sceneEl.querySelector('[' + DEFAULT_CAMERA_ATTR + ']');
    var defaultCameraEl = defaultCameraWrapper &&
                          defaultCameraWrapper.querySelector('[camera]');

    // Remove default camera if new camera is not the default camera.
    if (newCameraEl !== defaultCameraEl) { removeDefaultCamera(sceneEl); }

    // Make new camera active.
    this.activeCameraEl = newCameraEl;
    this.activeCameraEl.play();
    sceneEl.camera = newCamera;

    // Disable current camera
    if (previousCamera) {
      previousCamera.setAttribute('camera', 'active', false);
    }

    // Disable other cameras in the scene
    cameraEls = sceneEl.querySelectorAll('[camera]');
    for (i = 0; i < cameraEls.length; i++) {
      cameraEl = cameraEls[i];
      if (newCameraEl === cameraEl) { continue; }
      cameraEl.setAttribute('camera', 'active', false);
      cameraEl.pause();
    }
    sceneEl.emit('camera-set-active', {cameraEl: newCameraEl});
  }
});

/**
 * Remove injected default camera from scene, if present.
 *
 * @param {Element} sceneEl
 */
function removeDefaultCamera (sceneEl) {
  var defaultCamera;
  var camera = sceneEl.camera;
  if (!camera) { return; }

  // Remove default camera if present.
  defaultCamera = sceneEl.querySelector('[' + DEFAULT_CAMERA_ATTR + ']');
  if (!defaultCamera) { return; }
  sceneEl.removeChild(defaultCamera);
}

},{"../constants/":91,"../core/system":110,"../utils/bind":161}],155:[function(_dereq_,module,exports){
var geometries = _dereq_('../core/geometry').geometries;
var registerSystem = _dereq_('../core/system').registerSystem;
var THREE = _dereq_('../lib/three');

/**
 * System for geometry component.
 * Handle geometry caching.
 *
 * @member {object} cache - Mapping of stringified component data to THREE.Geometry objects.
 * @member {object} cacheCount - Keep track of number of entities using a geometry to
 *         know whether to dispose on removal.
 */
module.exports.System = registerSystem('geometry', {
  init: function () {
    this.cache = {};
    this.cacheCount = {};
  },

  /**
   * Reset cache. Mainly for testing.
   */
  clearCache: function () {
    this.cache = {};
    this.cacheCount = {};
  },

  /**
   * Attempt to retrieve from cache.
   *
   * @returns {Object|null} A geometry if it exists, else null.
   */
  getOrCreateGeometry: function (data) {
    var cache = this.cache;
    var cachedGeometry;
    var hash;

    // Skip all caching logic.
    if (data.skipCache || data.mergeTo) { return createGeometry(data); }

    // Try to retrieve from cache first.
    hash = this.hash(data);
    cachedGeometry = cache[hash];
    incrementCacheCount(this.cacheCount, hash);

    if (cachedGeometry) { return cachedGeometry; }

    // Create geometry.
    cachedGeometry = createGeometry(data);

    // Cache and return geometry.
    cache[hash] = cachedGeometry;
    return cachedGeometry;
  },

  /**
   * Let system know that an entity is no longer using a geometry.
   */
  unuseGeometry: function (data) {
    var cache = this.cache;
    var cacheCount = this.cacheCount;
    var geometry;
    var hash;

    if (data.skipCache || data.mergeTo) { return; }

    hash = this.hash(data);

    if (!cache[hash]) { return; }

    decrementCacheCount(cacheCount, hash);

    // Another entity is still using this geometry. No need to do anything.
    if (cacheCount[hash] > 0) { return; }

    // No more entities are using this geometry. Dispose.
    geometry = cache[hash];
    geometry.dispose();
    delete cache[hash];
    delete cacheCount[hash];
  },

  /**
   * Use JSON.stringify to turn component data into hash.
   * Should be deterministic within a single browser engine.
   * If not, then look into json-stable-stringify.
   */
  hash: function (data) {
    return JSON.stringify(data);
  }
});

/**
 * Create geometry using component data.
 *
 * @param {object} data - Component data.
 * @returns {object} Geometry.
 */
function createGeometry (data) {
  var geometryType = data.primitive;
  var GeometryClass = geometries[geometryType] && geometries[geometryType].Geometry;
  var geometryInstance = new GeometryClass();

  if (!GeometryClass) { throw new Error('Unknown geometry `' + geometryType + '`'); }

  geometryInstance.init(data);
  return toBufferGeometry(geometryInstance.geometry, data.buffer);
}

/**
 * Decreate count of entity using a geometry.
 */
function decrementCacheCount (cacheCount, hash) {
  cacheCount[hash]--;
}

/**
 * Increase count of entity using a geometry.
 */
function incrementCacheCount (cacheCount, hash) {
  cacheCount[hash] = cacheCount[hash] === undefined ? 1 : cacheCount[hash] + 1;
}

/**
 * Transform geometry to BufferGeometry if `doBuffer`.
 *
 * @param {object} geometry
 * @param {boolean} doBuffer
 * @returns {object} Geometry.
 */
function toBufferGeometry (geometry, doBuffer) {
  var bufferGeometry;
  if (!doBuffer) { return geometry; }

  bufferGeometry = new THREE.BufferGeometry().fromGeometry(geometry);
  bufferGeometry.metadata = {type: geometry.type, parameters: geometry.parameters || {}};
  geometry.dispose();  // Dispose no longer needed non-buffer geometry.
  return bufferGeometry;
}

},{"../core/geometry":101,"../core/system":110,"../lib/three":146}],156:[function(_dereq_,module,exports){
var registerSystem = _dereq_('../core/system').registerSystem;
var THREE = _dereq_('../lib/three');

/**
 * glTF model system.
 */
module.exports.System = registerSystem('gltf-model', {
  init: function () {
    this.models = [];
  },

  /**
   * Updates shaders for all glTF models in the system.
   */
  tick: function () {
    var sceneEl = this.sceneEl;
    if (sceneEl.hasLoaded && this.models.length) {
      THREE.GLTFLoader.Shaders.update(sceneEl.object3D, sceneEl.camera);
    }
  },

  /**
   * Registers a glTF asset.
   * @param {object} gltf Asset containing a scene and (optional) animations and cameras.
   */
  registerModel: function (gltf) {
    this.models.push(gltf);
  },

  /**
   * Unregisters a glTF asset.
   * @param  {object} gltf Asset containing a scene and (optional) animations and cameras.
   */
  unregisterModel: function (gltf) {
    var models = this.models;
    var index = models.indexOf(gltf);
    if (index >= 0) {
      models.splice(index, 1);
    }
  }
});

},{"../core/system":110,"../lib/three":146}],157:[function(_dereq_,module,exports){
_dereq_('./camera');
_dereq_('./geometry');
_dereq_('./gltf-model');
_dereq_('./light');
_dereq_('./material');
_dereq_('./tracked-controls');


},{"./camera":154,"./geometry":155,"./gltf-model":156,"./light":158,"./material":159,"./tracked-controls":160}],158:[function(_dereq_,module,exports){
var registerSystem = _dereq_('../core/system').registerSystem;
var bind = _dereq_('../utils/bind');
var constants = _dereq_('../constants/');

var DEFAULT_LIGHT_ATTR = 'data-aframe-default-light';

/**
 * Light system.
 *
 * Prescribes default lighting if not specified (one ambient, one directional).
 * Removes default lighting from the scene when a new light is added.
 *
 * @param {bool} defaultLights - Whether default lighting are defined.
 * @param {bool} userDefinedLights - Whether user lighting is defined.
 */
module.exports.System = registerSystem('light', {
  init: function () {
    this.defaultLights = false;
    this.userDefinedLights = false;
    // Wait for all entities to fully load before checking for existence of lights.
    // Since entities wait for <a-assets> to load, any lights attaching to the scene
    // will do so asynchronously.
    this.sceneEl.addEventListener('loaded', bind(this.setupDefaultLights, this));
  },

  /**
   * Notify scene that light has been added and to remove the default.
   *
   * @param {object} el - element holding the light component.
   */
  registerLight: function (el) {
    if (!el.hasAttribute(DEFAULT_LIGHT_ATTR)) {
      // User added a light, remove default lights through DOM.
      this.removeDefaultLights();
      this.userDefinedLights = true;
    }
  },

  removeDefaultLights: function () {
    var defaultLights;
    var sceneEl = this.sceneEl;

    if (!this.defaultLights) { return; }
    defaultLights = document.querySelectorAll('[' + DEFAULT_LIGHT_ATTR + ']');
    for (var i = 0; i < defaultLights.length; i++) {
      sceneEl.removeChild(defaultLights[i]);
    }
    this.defaultLights = false;
  },

  /**
   * Prescibe default lights to the scene.
   * Does so by injecting markup such that this state is not invisible.
   * These lights are removed if the user adds any lights.
   */
  setupDefaultLights: function () {
    var sceneEl = this.sceneEl;
    var ambientLight;
    var directionalLight;

    if (this.userDefinedLights || this.defaultLights) { return; }
    ambientLight = document.createElement('a-entity');
    directionalLight = document.createElement('a-entity');
    ambientLight.setAttribute('light', {color: '#BBB', type: 'ambient'});
    ambientLight.setAttribute(DEFAULT_LIGHT_ATTR, '');
    ambientLight.setAttribute(constants.AFRAME_INJECTED, '');
    sceneEl.appendChild(ambientLight);

    directionalLight.setAttribute('light', {color: '#FFF', intensity: 0.6});
    directionalLight.setAttribute('position', {x: -0.5, y: 1, z: 1});
    directionalLight.setAttribute(DEFAULT_LIGHT_ATTR, '');
    directionalLight.setAttribute(constants.AFRAME_INJECTED, '');
    sceneEl.appendChild(directionalLight);

    this.defaultLights = true;
  }
});

},{"../constants/":91,"../core/system":110,"../utils/bind":161}],159:[function(_dereq_,module,exports){
var registerSystem = _dereq_('../core/system').registerSystem;
var THREE = _dereq_('../lib/three');
var utils = _dereq_('../utils/');

var debug = utils.debug;
var error = debug('components:texture:error');
var TextureLoader = new THREE.TextureLoader();
var warn = debug('components:texture:warn');

/**
 * System for material component.
 * Handle material registration, updates (for fog), and texture caching.
 *
 * @member materials {object} - Registered materials.
 * @member textureCache {object} - Texture cache for:
 *   - Images: textureCache has mapping of src -> repeat -> cached three.js texture.
 *   - Videos: textureCache has mapping of videoElement -> cached three.js texture.
 */
module.exports.System = registerSystem('material', {
  init: function () {
    this.materials = {};
    this.textureCache = {};
  },

  clearTextureCache: function () {
    this.textureCache = {};
  },

  /**
   * Determine whether `src` is a image or video. Then try to load the asset, then call back.
   *
   * @param {string, or element} src - Texture URL or element.
   * @param {string} data - Relevant texture data used for caching.
   * @param {function} cb - Callback to pass texture to.
   */
  loadTexture: function (src, data, cb) {
    var self = this;

    // Canvas.
    if (src.tagName === 'CANVAS') {
      this.loadCanvas(src, data, cb);
      return;
    }

    // Video element.
    if (src.tagName === 'VIDEO') {
      if (!src.hasAttribute('src') && !src.hasAttribute('srcObject')) {
        warn('Video element was defined without `src` nor `srcObject` attributes.');
      }
      this.loadVideo(src, data, cb);
      return;
    }

    utils.srcLoader.validateSrc(src, loadImageCb, loadVideoCb);
    function loadImageCb (src) { self.loadImage(src, data, cb); }
    function loadVideoCb (src) { self.loadVideo(src, data, cb); }
  },

  /**
   * High-level function for loading image textures (THREE.Texture).
   *
   * @param {Element|string} src - Texture source.
   * @param {object} data - Texture data.
   * @param {function} cb - Callback to pass texture to.
   */
  loadImage: function (src, data, cb) {
    var hash = this.hash(data);
    var handleImageTextureLoaded = cb;
    var textureCache = this.textureCache;

    // Texture already being loaded or already loaded. Wait on promise.
    if (textureCache[hash]) {
      textureCache[hash].then(handleImageTextureLoaded);
      return;
    }

    // Texture not yet being loaded. Start loading it.
    textureCache[hash] = loadImageTexture(src, data);
    textureCache[hash].then(handleImageTextureLoaded);
  },

  /**
   * High-level function for loading canvas textures (THREE.Texture).
   *
   * @param {Element|string} src - Texture source.
   * @param {object} data - Texture data.
   * @param {function} cb - Callback to pass texture to.
   */
  loadCanvas: function (src, data, cb) {
    // Hack readyState and HAVE_CURRENT_DATA on canvas to work with THREE.VideoTexture
    src.readyState = 2;
    src.HAVE_CURRENT_DATA = 2;
    this.loadVideo(src, data, cb);
  },

    /**
   * Load video texture (THREE.VideoTexture).
   * Which is just an image texture that RAFs + needsUpdate.
   * Note that creating a video texture is synchronous unlike loading an image texture.
   * Made asynchronous to be consistent with image textures.
   *
   * @param {Element|string} src - Texture source.
   * @param {object} data - Texture data.
   * @param {function} cb - Callback to pass texture to.
   */
  loadVideo: function (src, data, cb) {
    var hash;
    var texture;
    var textureCache = this.textureCache;
    var videoEl;
    var videoTextureResult;

    function handleVideoTextureLoaded (result) {
      result.texture.needsUpdate = true;
      cb(result.texture, result.videoEl);
    }

    // Video element provided.
    if (typeof src !== 'string') {
      // Check cache before creating texture.
      videoEl = src;
      hash = this.hashVideo(data, videoEl);
      if (textureCache[hash]) {
        textureCache[hash].then(handleVideoTextureLoaded);
        return;
      }
      // If not in cache, fix up the attributes then start to create the texture.
      fixVideoAttributes(videoEl);
    }

    // Only URL provided. Use video element to create texture.
    videoEl = videoEl || createVideoEl(src, data.width, data.height);

    // Generated video element already cached. Use that.
    hash = this.hashVideo(data, videoEl);
    if (textureCache[hash]) {
      textureCache[hash].then(handleVideoTextureLoaded);
      return;
    }

    // Create new video texture.
    texture = new THREE.VideoTexture(videoEl);
    texture.minFilter = THREE.LinearFilter;
    setTextureProperties(texture, data);

    // Cache as promise to be consistent with image texture caching.
    videoTextureResult = {texture: texture, videoEl: videoEl};
    textureCache[hash] = Promise.resolve(videoTextureResult);
    handleVideoTextureLoaded(videoTextureResult);
  },

  hash: function (data) {
    return JSON.stringify(data);
  },

  hashVideo: function (data, videoEl) {
    return calculateVideoCacheHash(data, videoEl);
  },

  /**
   * Keep track of material in case an update trigger is needed (e.g., fog).
   *
   * @param {object} material
   */
  registerMaterial: function (material) {
    this.materials[material.uuid] = material;
  },

  /**
   * Stop tracking material.
   *
   * @param {object} material
   */
  unregisterMaterial: function (material) {
    delete this.materials[material.uuid];
  },

  /**
   * Trigger update to all registered materials.
   */
  updateMaterials: function (material) {
    var materials = this.materials;
    Object.keys(materials).forEach(function (uuid) {
      materials[uuid].needsUpdate = true;
    });
  }
});

/**
 * Calculates consistent hash from a video element using its attributes.
 * If the video element has an ID, use that.
 * Else build a hash that looks like `src:myvideo.mp4;height:200;width:400;`.
 *
 * @param data {object} - Texture data such as repeat.
 * @param videoEl {Element} - Video element.
 * @returns {string}
 */
function calculateVideoCacheHash (data, videoEl) {
  var i;
  var id = videoEl.getAttribute('id');
  var hash;
  var videoAttributes;

  if (id) { return id; }

  // Calculate hash using sorted video attributes.
  hash = '';
  videoAttributes = data || {};
  for (i = 0; i < videoEl.attributes.length; i++) {
    videoAttributes[videoEl.attributes[i].name] = videoEl.attributes[i].value;
  }
  Object.keys(videoAttributes).sort().forEach(function (name) {
    hash += name + ':' + videoAttributes[name] + ';';
  });

  return hash;
}

/**
 * Load image texture.
 *
 * @private
 * @param {string|object} src - An <img> element or url to an image file.
 * @param {object} data - Data to set texture properties like `repeat`.
 * @returns {Promise} Resolves once texture is loaded.
 */
function loadImageTexture (src, data) {
  return new Promise(doLoadImageTexture);

  function doLoadImageTexture (resolve, reject) {
    var isEl = typeof src !== 'string';

    function resolveTexture (texture) {
      setTextureProperties(texture, data);
      texture.needsUpdate = true;
      resolve(texture);
    }

    // Create texture from an element.
    if (isEl) {
      resolveTexture(new THREE.Texture(src));
      return;
    }

    // Load texture from src string. THREE will create underlying element.
    // Use THREE.TextureLoader (src, onLoad, onProgress, onError) to load texture.
    TextureLoader.load(
      src,
      resolveTexture,
      function () { /* no-op */ },
      function (xhr) {
        error('`$s` could not be fetched (Error code: %s; Response: %s)', xhr.status,
              xhr.statusText);
      }
    );
  }
}

/**
 * Set texture properties such as repeat and offset.
 *
 * @param {object} data - With keys like `repeat`.
 */
function setTextureProperties (texture, data) {
  var offset = data.offset || {x: 0, y: 0};
  var repeat = data.repeat || {x: 1, y: 1};
  var npot = data.npot || false;

  // To support NPOT textures, wrap must be ClampToEdge (not Repeat),
  // and filters must not use mipmaps (i.e. Nearest or Linear).
  if (npot) {
    texture.wrapS = THREE.ClampToEdgeWrapping;
    texture.wrapT = THREE.ClampToEdgeWrapping;
    texture.magFilter = THREE.LinearFilter;
    texture.minFilter = THREE.LinearFilter;
  }

  // Don't bother setting repeat if it is 1/1. Power-of-two is required to repeat.
  if (repeat.x !== 1 || repeat.y !== 1) {
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    texture.repeat.set(repeat.x, repeat.y);
  }
  // Don't bother setting offset if it is 0/0.
  if (offset.x !== 0 || offset.y !== 0) {
    texture.offset.set(offset.x, offset.y);
  }
}

/**
 * Create video element to be used as a texture.
 *
 * @param {string} src - Url to a video file.
 * @param {number} width - Width of the video.
 * @param {number} height - Height of the video.
 * @returns {Element} Video element.
 */
function createVideoEl (src, width, height) {
  var videoEl = document.createElement('video');
  videoEl.width = width;
  videoEl.height = height;
  videoEl.setAttribute('webkit-playsinline', '');  // Support inline videos for iOS webviews.
  videoEl.autoplay = true;
  videoEl.loop = true;
  videoEl.crossOrigin = 'anonymous';
  videoEl.addEventListener('error', function () {
    warn('`$s` is not a valid video', src);
  }, true);
  videoEl.src = src;
  return videoEl;
}

/**
 * Fixes a video element's attributes to prevent developers from accidentally passing the
 * wrong attribute values to commonly misused video attributes.
 *
 * <video> does not treat `autoplay`, `controls`, `crossorigin`, `loop`, and `preload` as
 * as booleans. Existence of those attributes will mean truthy.
 *
 * For example, translates <video loop="false"> to <video>.
 *
 * @see https://developer.mozilla.org/docs/Web/HTML/Element/video#Attributes
 * @param {Element} videoEl - Video element.
 * @returns {Element} Video element with the correct properties updated.
 */
function fixVideoAttributes (videoEl) {
  videoEl.autoplay = videoEl.getAttribute('autoplay') !== 'false';
  videoEl.controls = videoEl.getAttribute('controls') !== 'false';
  if (videoEl.getAttribute('loop') === 'false') {
    videoEl.removeAttribute('loop');
  }
  if (videoEl.getAttribute('preload') === 'false') {
    videoEl.preload = 'none';
  }
  videoEl.crossOrigin = videoEl.crossOrigin || 'anonymous';
  // To support inline videos in iOS webviews.
  videoEl.setAttribute('webkit-playsinline', '');
  return videoEl;
}

},{"../core/system":110,"../lib/three":146,"../utils/":167}],160:[function(_dereq_,module,exports){
var registerSystem = _dereq_('../core/system').registerSystem;
var trackedControlsUtils = _dereq_('../utils/tracked-controls');
var utils = _dereq_('../utils');

/**
 * Tracked controls system.
 * It maintains a list with the available tracked controllers
 */
module.exports.System = registerSystem('tracked-controls', {
  init: function () {
    var self = this;
    this.controllers = [];
    this.lastControllersUpdate = 0;
    // Throttle the (renamed) tick handler to minimum 10ms interval.
    this.tick = utils.throttle(this.throttledTick, 10, this);
    if (!navigator.getVRDisplays) { return; }
    navigator.getVRDisplays().then(function (displays) {
      if (displays.length > 0) {
        self.vrDisplay = displays[0];
      }
    });
  },

  updateControllerList: function () {
    var controllers = this.controllers = [];
    var gamepads = trackedControlsUtils.getGamepadsByPrefix('');
    for (var i = 0; i < gamepads.length; i++) {
      var gamepad = gamepads[i];
      if (gamepad && gamepad.pose) { controllers.push(gamepad); }
    }
  },

  /**
   * Update controller list every 10 millseconds.
   */
  throttledTick: function () {
    this.updateControllerList();
    this.sceneEl.emit('controllersupdated', { controllers: this.controllers });
  }
});

},{"../core/system":110,"../utils":167,"../utils/tracked-controls":171}],161:[function(_dereq_,module,exports){
/**
 * Faster version of Function.prototype.bind
 * @param {Function} fn - Function to wrap.
 * @param {Object} ctx - What to bind as context.
 * @param {...*} arguments - Arguments to pass through.
 */
module.exports = function bind (fn, ctx/* , arg1, arg2 */) {
  return (function (prependedArgs) {
    return function bound () {
      // Concat the bound function arguments with those passed to original bind
      var args = prependedArgs.concat(Array.prototype.slice.call(arguments, 0));
      return fn.apply(ctx, args);
    };
  })(Array.prototype.slice.call(arguments, 2));
};

},{}],162:[function(_dereq_,module,exports){
/* global THREE */
var extend = _dereq_('object-assign');
// Coordinate string regex. Handles negative, positive, and decimals.
var regex = /^\s*((-?\d*\.{0,1}\d+)\s+){2,3}(-?\d*\.{0,1}\d+)\s*$/;
module.exports.regex = regex;

/**
 * Parses coordinates from an "x y z" string.
 * Example: "3 10 -5" to {x: 3, y: 10, z: -5}.
 *
 * @param {string} val - An "x y z" string.
 * @param {string} defaults - fallback value.
 * @returns {object} An object with keys [x, y, z].
 */
function parse (value, defaultVec) {
  var coordinate;
  var vec = {};

  if (value && typeof value === 'object') {
    return vecParseFloat({
      x: value.x !== undefined ? value.x : (defaultVec && defaultVec.x),
      y: value.y !== undefined ? value.y : (defaultVec && defaultVec.y),
      z: value.z !== undefined ? value.z : (defaultVec && defaultVec.z),
      w: value.w !== undefined ? value.w : (defaultVec && defaultVec.w)
    });
  }

  if (typeof value !== 'string' || value === null) {
    return typeof defaultVec === 'object' ? extend({}, defaultVec) : defaultVec;
  }

  coordinate = value.trim().replace(/\s+/g, ' ').split(' ');
  vec.x = coordinate[0] || defaultVec && defaultVec.x;
  vec.y = coordinate[1] || defaultVec && defaultVec.y;
  vec.z = coordinate[2] || defaultVec && defaultVec.z;
  vec.w = coordinate[3] || defaultVec && defaultVec.w;
  return vecParseFloat(vec);
}
module.exports.parse = parse;

/**
 * Stringifies coordinates from an object with keys [x y z].
 * Example: {x: 3, y: 10, z: -5} to "3 10 -5".
 *
 * @param {object|string} data - An object with keys [x y z].
 * @returns {string} An "x y z" string.
 */
function stringify (data) {
  if (typeof data !== 'object') { return data; }
  return [data.x, data.y, data.z, data.w].join(' ').trim();
}
module.exports.stringify = stringify;

/**
 * @returns {bool}
 */
module.exports.isCoordinate = function (value) {
  return regex.test(value);
};

function vecParseFloat (vec) {
  Object.keys(vec).forEach(function (key) {
    if (vec[key] === undefined) {
      delete vec[key];
      return;
    }
    vec[key] = parseFloat(vec[key], 10);
  });
  return vec;
}

/**
 * Converts {x, y, z} object to three.js Vector3.
 */
module.exports.toVector3 = function (vec3) {
  return new THREE.Vector3(vec3.x, vec3.y, vec3.z);
};

},{"object-assign":28}],163:[function(_dereq_,module,exports){
(function (process){
var debugLib = _dereq_('debug');
var extend = _dereq_('object-assign');

var settings = {
  colors: {
    debug: 'gray',
    error: 'red',
    info: 'gray',
    warn: 'orange'
  }
};

/**
 * Monkeypatches `debug` so we can colorize error/warning messages.
 *
 * (See issue: https://github.com/visionmedia/debug/issues/137)
 */
var debug = function (namespace) {
  var d = debugLib(namespace);

  d.color = getDebugNamespaceColor(namespace);

  return d;
};
extend(debug, debugLib);

/**
 * Returns the type of the namespace (e.g., `error`, `warn`).
 *
 * @param {String} namespace
 *   The debug logger's namespace (e.g., `components:geometry:warn`).
 * @returns {String} The type of the namespace (e.g., `warn`).
 * @api private
 */
function getDebugNamespaceType (namespace) {
  var chunks = namespace.split(':');

  return chunks[chunks.length - 1];  // Return the last one
}

/**
 * Returns the color of the namespace (e.g., `orange`).
 *
 * @param {String} namespace
 *   The debug logger's namespace (e.g., `components:geometry:warn`).
 * @returns {String} The color of the namespace (e.g., `orange`).
 * @api private
 */
function getDebugNamespaceColor (namespace) {
  var type = getDebugNamespaceType(namespace);

  var color = settings.colors && settings.colors[type];

  return color || null;
}

/**
 * Returns `localStorage` if possible.
 *
 * This is necessary because Safari throws when a user disables
 * cookies or `localStorage` and you attempt to access it.
 *
 * @returns {localStorage}
 * @api private
 */
function storage () {
  try {
    return window.localStorage;
  } catch (e) {
  }
}

/**
 * To enable console logging, type this in the Console of your Dev Tools:
 *
 *   localStorage.logs = 1
 *
 * To disable console logging:
 *
 *   localStorage.logs = 0
 *
 */
var ls = storage();
if (ls && (parseInt(ls.logs, 10) || ls.logs === 'true')) {
  debug.enable('*');
} else {
  debug.enable('*:error,*:info,*:warn');
}

if (process.browser) { window.logs = debug; }

module.exports = debug;

}).call(this,_dereq_('_process'))

},{"_process":9,"debug":11,"object-assign":28}],164:[function(_dereq_,module,exports){
var THREE = _dereq_('../lib/three');
var dolly = new THREE.Object3D();
var controls = new THREE.VRControls(dolly);

/**
 * Determine if a headset is connected by checking if the
 * orientation is available
 */
function checkHeadsetConnected () {
  var orientation;
  controls.update();
  orientation = dolly.quaternion;
  if (orientation._x !== 0 || orientation._y !== 0 || orientation._z !== 0) {
    return true;
  }
  return false;
}
module.exports.checkHeadsetConnected = checkHeadsetConnected;

/**
 * Check for positional tracking.
 */
function checkHasPositionalTracking () {
  var position = new THREE.Vector3();
  return (function () {
    if (isMobile() || isGearVR()) { return false; }
    controls.update();
    dolly.updateMatrix();
    position.setFromMatrixPosition(dolly.matrix);
    if (position.x !== 0 || position.y !== 0 || position.z !== 0) {
      return true;
    }
    return false;
  })();
}
module.exports.checkHasPositionalTracking = checkHasPositionalTracking;

/**
 * Checks if browser is mobile.
 * @return {Boolean} True if mobile browser detected.
 */
var isMobile = (function () {
  var _isMobile = false;
  (function (a) {
    // eslint-disable-next-line no-useless-escape
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
      _isMobile = true;
    }
    if (isIOS()) {
      _isMobile = true;
    }
    if (isGearVR()) {
      _isMobile = false;
    }
  })(navigator.userAgent || navigator.vendor || window.opera);

  return function () { return _isMobile; };
})();
module.exports.isMobile = isMobile;

function isIOS () {
  return /iPad|iPhone|iPod/.test(navigator.platform);
}
module.exports.isIOS = isIOS;

function isGearVR () {
  return /SamsungBrowser.+Mobile VR/i.test(navigator.userAgent);
}
module.exports.isGearVR = isGearVR;

/**
 * Checks mobile device orientation.
 * @return {Boolean} True if landscape orientation.
 */
module.exports.isLandscape = function () {
  return window.orientation === 90 || window.orientation === -90;
};

/**
 * Check if device is iOS and older than version 10.
 */
module.exports.isIOSOlderThan10 = function (userAgent) {
  return /(iphone|ipod|ipad).*os.(7|8|9)/i.test(userAgent);
};

},{"../lib/three":146}],165:[function(_dereq_,module,exports){
/**
 * Split a delimited component property string (e.g., `material.color`) to an object
 * containing `component` name and `property` name. If there is no delimiter, just return the
 * string back.
 */
module.exports.getComponentPropertyPath = function (str, delimiter) {
  delimiter = delimiter || '.';
  if (str.indexOf(delimiter) === -1) { return str; }
  return str.split(delimiter);
};

/**
 * Get component property using encoded component name + component property name with a
 * delimiter.
 */
module.exports.getComponentProperty = function (el, name, delimiter) {
  var splitName;
  delimiter = delimiter || '.';
  if (name.indexOf(delimiter) !== -1) {
    splitName = name.split(delimiter);
    return el.getAttribute(splitName[0])[splitName[1]];
  }
  return el.getAttribute(name);
};

/**
 * Set component property using encoded component name + component property name with a
 * delimiter.
 */
module.exports.setComponentProperty = function (el, name, value, delimiter) {
  var splitName;
  delimiter = delimiter || '.';
  if (name.indexOf(delimiter) !== -1) {
    splitName = name.split(delimiter);
    el.setAttribute(splitName[0], splitName[1], value);
    return;
  }
  el.setAttribute(name, value);
};

},{}],166:[function(_dereq_,module,exports){
module.exports = function forceCanvasResizeSafariMobile (canvasEl) {
  var width = canvasEl.style.width;
  var height = canvasEl.style.height;
  // Taken from webvr-polyfill (https://github.com/borismus/webvr-polyfill/blob/85f657cd502ec9417bf26b87c3cb2afa6a70e079/src/util.js#L200)
  // iOS only workaround for https://bugs.webkit.org/show_bug.cgi?id=152556
  // By changing the size 1 pixel and restoring the previous value
  // we trigger a size recalculation cycle.
  canvasEl.style.width = (parseInt(width, 10) + 1) + 'px';
  canvasEl.style.height = (parseInt(height, 10) + 1) + 'px';
  setTimeout(function () {
    canvasEl.style.width = width;
    canvasEl.style.height = height;
  }, 200);
};

},{}],167:[function(_dereq_,module,exports){
/* global CustomEvent, location */
/* Centralized place to reference utilities since utils is exposed to the user. */
var debug = _dereq_('./debug');
var deepAssign = _dereq_('deep-assign');
var device = _dereq_('./device');
var objectAssign = _dereq_('object-assign');

var warn = debug('utils:warn');

module.exports.bind = _dereq_('./bind');
module.exports.coordinates = _dereq_('./coordinates');
module.exports.debug = debug;
module.exports.device = device;
module.exports.entity = _dereq_('./entity');
module.exports.forceCanvasResizeSafariMobile = _dereq_('./forceCanvasResizeSafariMobile');
module.exports.material = _dereq_('./material');
module.exports.styleParser = _dereq_('./styleParser');
module.exports.trackedControls = _dereq_('./tracked-controls');

module.exports.checkHeadsetConnected = function () {
  warn('`utils.checkHeadsetConnected` has moved to `utils.device.checkHeadsetConnected`');
  return device.checkHeadsetConnected(arguments);
};
module.exports.isGearVR = function () {
  warn('`utils.isGearVR` has moved to `utils.device.isGearVR`');
  return device.isGearVR(arguments);
};
module.exports.isIOS = function () {
  warn('`utils.isIOS` has moved to `utils.device.isIOS`');
  return device.isIOS(arguments);
};
module.exports.isMobile = function () {
  warn('`utils.isMobile has moved to `utils.device.isMobile`');
  return device.isMobile(arguments);
};

/**
 * Returns throttle function that gets called at most once every interval.
 *
 * @param {function} functionToThrottle
 * @param {number} minimumInterval - Minimal interval between calls (milliseconds).
 * @param {object} optionalContext - If given, bind function to throttle to this context.
 * @returns {function} Throttled function.
 */
module.exports.throttle = function (functionToThrottle, minimumInterval, optionalContext) {
  var lastTime;
  if (optionalContext) {
    functionToThrottle = module.exports.bind(functionToThrottle, optionalContext);
  }
  return function () {
    var time = Date.now();
    var sinceLastTime = typeof lastTime === 'undefined' ? minimumInterval : time - lastTime;
    if (typeof lastTime === 'undefined' || (sinceLastTime >= minimumInterval)) {
      lastTime = time;
      functionToThrottle.apply(null, arguments);
    }
  };
};

/**
 * Returns throttle function that gets called at most once every interval.
 * Uses the time/timeDelta timestamps provided by the global render loop for better perf.
 *
 * @param {function} functionToThrottle
 * @param {number} minimumInterval - Minimal interval between calls (milliseconds).
 * @param {object} optionalContext - If given, bind function to throttle to this context.
 * @returns {function} Throttled function.
 */
module.exports.throttleTick = function (functionToThrottle, minimumInterval, optionalContext) {
  var lastTime;
  if (optionalContext) {
    functionToThrottle = module.exports.bind(functionToThrottle, optionalContext);
  }
  return function (time, delta) {
    var sinceLastTime = typeof lastTime === 'undefined' ? delta : time - lastTime;
    if (typeof lastTime === 'undefined' || (sinceLastTime >= minimumInterval)) {
      lastTime = time;
      functionToThrottle(time, sinceLastTime);
    }
  };
};

/**
 * Fires a custom DOM event.
 *
 * @param {Element} el Element on which to fire the event.
 * @param {String} name Name of the event.
 * @param {Object=} [data={bubbles: true, {detail: <el>}}]
 *   Data to pass as `customEventInit` to the event.
 */
module.exports.fireEvent = function (el, name, data) {
  data = data || {};
  data.detail = data.detail || {};
  data.detail.target = data.detail.target || el;
  var evt = new CustomEvent(name, data);
  el.dispatchEvent(evt);
};

/**
 * Mix the properties of source object(s) into a destination object.
 *
 * @param  {object} dest - The object to which properties will be copied.
 * @param  {...object} source - The object(s) from which properties will be copied.
 */
module.exports.extend = objectAssign;
module.exports.extendDeep = deepAssign;

module.exports.clone = function (obj) {
  return JSON.parse(JSON.stringify(obj));
};

/**
 * Checks if two values are equal.
 * Includes objects and arrays and nested objects and arrays.
 * Try to keep this function performant as it will be called often to see if a component
 * should be updated.
 *
 * @param {object} a - First object.
 * @param {object} b - Second object.
 * @returns {boolean} Whether two objects are deeply equal.
 */
function deepEqual (a, b) {
  var i;
  var keysA;
  var keysB;
  var valA;
  var valB;

  // If not objects, compare as values.
  if (typeof a !== 'object' || typeof b !== 'object' ||
      a === null || b === null) { return a === b; }

  // Different number of keys, not equal.
  keysA = Object.keys(a);
  keysB = Object.keys(b);
  if (keysA.length !== keysB.length) { return false; }

  // Return `false` at the first sign of inequality.
  for (i = 0; i < keysA.length; ++i) {
    valA = a[keysA[i]];
    valB = b[keysA[i]];
    // Check nested array and object.
    if ((typeof valA === 'object' || typeof valB === 'object') ||
        (Array.isArray(valA) && Array.isArray(valB))) {
      if (!deepEqual(valA, valB)) { return false; }
    } else if (valA !== valB) {
      return false;
    }
  }
  return true;
}
module.exports.deepEqual = deepEqual;

/**
 * Computes the difference between two objects.
 *
 * @param {object} a - First object to compare (e.g., oldData).
 * @param {object} b - Second object to compare (e.g., newData).
 * @returns {object}
 *   Difference object where set of keys note which values were not equal, and values are
 *   `b`'s values.
 */
module.exports.diff = function (a, b) {
  var diff = {};
  var keys = Object.keys(a);
  Object.keys(b).forEach(function collectKeys (bKey) {
    if (keys.indexOf(bKey) === -1) {
      keys.push(bKey);
    }
  });
  keys.forEach(function doDiff (key) {
    var aVal = a[key];
    var bVal = b[key];
    var isComparingObjects = aVal && bVal &&
                             aVal.constructor === Object && bVal.constructor === Object;
    if ((isComparingObjects && !deepEqual(aVal, bVal)) ||
        (!isComparingObjects && aVal !== bVal)) {
      diff[key] = bVal;
    }
  });
  return diff;
};

/**
 * Returns whether we should capture this keyboard event for keyboard shortcuts.
 * @param {Event} event Event object.
 * @returns {Boolean} Whether the key event should be captured.
 */
module.exports.shouldCaptureKeyEvent = function (event) {
  if (event.metaKey) { return false; }
  return document.activeElement === document.body;
};

/**
 * Splits a string into an array based on a delimiter.
 *
 * @param   {string=} [str='']        Source string
 * @param   {string=} [delimiter=' '] Delimiter to use
 * @returns {array}                   Array of delimited strings
 */
module.exports.splitString = function (str, delimiter) {
  if (typeof delimiter === 'undefined') { delimiter = ' '; }
  // First collapse the whitespace (or whatever the delimiter is).
  var regex = new RegExp(delimiter, 'g');
  str = (str || '').replace(regex, delimiter);
  // Then split.
  return str.split(delimiter);
};

/**
 * Extracts data from the element given an object that contains expected keys.
 *
 * @param {Element} Source element.
 * @param {Object} [defaults={}] Object of default key-value pairs.
 * @returns {Object}
 */
module.exports.getElData = function (el, defaults) {
  defaults = defaults || {};
  var data = {};
  Object.keys(defaults).forEach(copyAttribute);
  function copyAttribute (key) {
    if (el.hasAttribute(key)) {
      data[key] = el.getAttribute(key);
    }
  }
  return data;
};

/**
 * Retrieves querystring value.
 * @param  {String} name Name of querystring key.
 * @return {String}      Value
 */
module.exports.getUrlParameter = function (name) {
  // eslint-disable-next-line no-useless-escape
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

/**
 * Detects whether context is within iframe.
 */
module.exports.isIframed = function () {
  return window.top !== window.self;
};

/**
 * Finds all elements under the element that have the isScene
 * property set to true
 */
module.exports.findAllScenes = function (el) {
  var matchingElements = [];
  var allElements = el.getElementsByTagName('*');
  for (var i = 0, n = allElements.length; i < n; i++) {
    if (allElements[i].isScene) {
      // Element exists with isScene set.
      matchingElements.push(allElements[i]);
    }
  }
  return matchingElements;
};

// Must be at bottom to avoid circular dependency.
module.exports.srcLoader = _dereq_('./src-loader');

},{"./bind":161,"./coordinates":162,"./debug":163,"./device":164,"./entity":165,"./forceCanvasResizeSafariMobile":166,"./material":168,"./src-loader":169,"./styleParser":170,"./tracked-controls":171,"deep-assign":14,"object-assign":28}],168:[function(_dereq_,module,exports){
var THREE = _dereq_('../lib/three');

/**
 * Update `material.map` given `data.src`. For standard and flat shaders.
 *
 * @param {object} shader - A-Frame shader instance.
 * @param {object} data
 */
module.exports.updateMapMaterialFromData = function (materialName, dataName, shader, data) {
  var el = shader.el;
  var material = shader.material;
  var src = data[dataName];
  var shadowSrcName = '_texture_' + dataName;

  if (src) {
    if (src === shader[shadowSrcName]) { return; }
    // Texture added or changed.
    shader[shadowSrcName] = src;
    if (src instanceof THREE.Texture) { setMap(src); return; }
    el.sceneEl.systems.material.loadTexture(src, {src: src, repeat: data.repeat, offset: data.offset, npot: data.npot}, setMap);
    return;
  }

  // Texture removed.
  if (!material[materialName]) { return; }
  shader[shadowSrcName] = null;
  setMap(null);

  function setMap (texture) {
    if (shader[shadowSrcName] !== src) { return; }
    material[materialName] = texture;
    material.needsUpdate = true;
    handleTextureEvents(el, texture);
  }
};

/**
 * Update `material.map` given `data.src`. For standard and flat shaders.
 *
 * @param {object} shader - A-Frame shader instance.
 * @param {object} data
 */
module.exports.updateMap = function (shader, data) {
  return module.exports.updateMapMaterialFromData('map', 'src', shader, data);
};

/**
 * Updates the material's maps which give the illusion of extra geometry.
 *
 * @param {string} longType - The friendly name of the map from the component e.g. ambientOcclusionMap becomes aoMap in THREE.js
 * @param {object} shader - A-Frame shader instance
 * @param {object} data
 */
module.exports.updateDistortionMap = function (longType, shader, data) {
  var shortType = longType;
  if (longType === 'ambientOcclusion') { shortType = 'ao'; }
  var el = shader.el;
  var material = shader.material;
  var src = data[longType + 'Map'];
  var info = {};
  info.src = src;

  // Pass through the repeat and offset to be handled by the material loader.
  info.offset = data[longType + 'TextureOffset'];
  info.repeat = data[longType + 'TextureRepeat'];
  info.wrap = data[longType + 'TextureWrap'];

  if (src) {
    if (src === shader[longType + 'TextureSrc']) { return; }

    // Texture added or changed.
    shader[longType + 'TextureSrc'] = src;
    el.sceneEl.systems.material.loadTexture(src, info, setMap);
    return;
  }

  // Texture removed.
  if (!material.map) { return; }
  setMap(null);

  function setMap (texture) {
    material[shortType + 'Map'] = texture;
    material.needsUpdate = true;
    handleTextureEvents(el, texture);
  }
};

/**
 * Emit event on entities on texture-related events.
 *
 * @param {Element} el - Entity.
 * @param {object} texture - three.js Texture.
 */
function handleTextureEvents (el, texture) {
  if (!texture) { return; }

  el.emit('materialtextureloaded', {src: texture.image, texture: texture});

  // Video events.
  if (!texture.image || texture.image.tagName !== 'VIDEO') { return; }
  texture.image.addEventListener('loadeddata', function emitVideoTextureLoadedDataAll () {
    el.emit('materialvideoloadeddata', {src: texture.image, texture: texture});
  });
  texture.image.addEventListener('ended', function emitVideoTextureEndedAll () {
    // Works for non-looping videos only.
    el.emit('materialvideoended', {src: texture.image, texture: texture});
  });
}
module.exports.handleTextureEvents = handleTextureEvents;

},{"../lib/three":146}],169:[function(_dereq_,module,exports){
/* global Image */
var debug = _dereq_('./debug');

var warn = debug('utils:src-loader:warn');

/**
 * Validates a texture, either as a selector or as a URL.
 * Detects whether `src` is pointing to an image or video and invokes the appropriate
 * callback.
 *
 * The src will be returned on the callback
 *
 * @params {string} src - URL.
 * @params {function} isImageCb - callback if texture is an image.
 * @params {function} isVideoCb - callback if texture is a video.
 */
function validateSrc (src, isImageCb, isVideoCb) {
  validateImageUrl(src, function isAnImageUrl (isImage) {
    if (isImage) {
      isImageCb(src);
      return;
    }
    isVideoCb(src);
  });
}

/**
 * Validates six images as a cubemap, either as selector or comma-separated
 * URLs.
 *
 * @param {string} src - A selector or comma-separated image URLs. Image URLs
          must be wrapped by `url()`.
 * @param {string} src - A selector or comma-separated image URLs. Image URLs
          must be wrapped by `url()`.
 */
function validateCubemapSrc (src, cb) {
  var aCubemap;
  var cubemapSrcRegex = '';
  var i;
  var urls;
  var validatedUrls = [];

  for (i = 0; i < 5; i++) {
    cubemapSrcRegex += '(url\\((?:[^\\)]+)\\),\\s*)';
  }
  cubemapSrcRegex += '(url\\((?:[^\\)]+)\\)\\s*)';
  urls = src.match(new RegExp(cubemapSrcRegex));

  // `src` is a comma-separated list of URLs.
  // In this case, re-use validateSrc for each side of the cube.
  function isImageCb (url) {
    validatedUrls.push(url);
    if (validatedUrls.length === 6) {
      cb(validatedUrls);
    }
  }
  if (urls) {
    for (i = 1; i < 7; i++) {
      // TODO: cubemap property type.
      validateSrc(parseUrl(urls[i]), isImageCb);
    }
    return;
  }

  // `src` is a query selector to <a-cubemap> containing six $([src])s.
  aCubemap = validateAndGetQuerySelector(src);
  if (!aCubemap) { return; }
  if (aCubemap.tagName === 'A-CUBEMAP' && aCubemap.srcs) {
    return cb(aCubemap.srcs);
  }
  // Else if aCubeMap is not a <a-cubemap>.
  warn('Selector "%s" does not point to <a-cubemap>', src);
}

/**
 * Parses src from `url(src)`.
 * @param  {string} src - String to parse.
 * @return {string} The parsed src, if parseable.
 */
function parseUrl (src) {
  var parsedSrc = src.match(/\url\((.+)\)/);
  if (!parsedSrc) { return; }
  return parsedSrc[1];
}

/**
 * Validate src is a valid image url
 * @param  {string} src - url that will be tested
 * @param  {function} onResult - callback with the test result
 */
function validateImageUrl (src, onResult) {
  var tester = new Image();
  tester.addEventListener('load', onLoad);
  function onLoad () { onResult(true); }
  tester.addEventListener('error', onError);
  function onError () { onResult(false); }
  tester.src = src;
}

/**
 * Query and validate a query selector,
 *
 * @param  {string} selector - DOM selector.
 * @return {object|null|undefined} Selected DOM element if exists.
           null if query yields no results.
           undefined if `selector` is not a valid selector.
 */
function validateAndGetQuerySelector (selector) {
  try {
    var el = document.querySelector(selector);
    if (!el) {
      warn('No element was found matching the selector: "%s"', selector);
    }
    return el;
  } catch (e) {  // Capture exception if it's not a valid selector.
    warn('"%s" is not a valid selector', selector);
    return undefined;
  }
}

module.exports = {
  parseUrl: parseUrl,
  validateSrc: validateSrc,
  validateCubemapSrc: validateCubemapSrc
};

},{"./debug":163}],170:[function(_dereq_,module,exports){
/* Utils for parsing style-like strings (e.g., "primitive: box; width: 5; height: 4.5"). */
var styleParser = _dereq_('style-attr');

/**
 * Deserializes style-like string into an object of properties.
 *
 * @param {string} value - HTML attribute value.
 * @returns {object} Property data.
 */
module.exports.parse = function (value) {
  var parsedData;
  if (typeof value !== 'string') { return value; }
  parsedData = styleParser.parse(value);
  // The style parser returns an object { "" : "test"} when fed a string
  if (parsedData['']) { return value; }
  return transformKeysToCamelCase(parsedData);
};

/**
 * Serialize an object of properties into a style-like string.
 *
 * @param {object} data - Property data.
 * @returns {string}
 */
module.exports.stringify = function (data) {
  if (typeof data === 'string') { return data; }
  return styleParser.stringify(data);
};

/**
 * Converts string from hyphen to camelCase.
 *
 * @param {string} str - String to camelCase.
 * @return {string} CamelCased string.
 */
function toCamelCase (str) {
  return str.replace(/-([a-z])/g, camelCase);
  function camelCase (g) { return g[1].toUpperCase(); }
}
module.exports.toCamelCase = toCamelCase;

/**
 * Converts object's keys from hyphens to camelCase (e.g., `max-value` to
 * `maxValue`).
 *
 * @param {object} obj - The object to camelCase keys.
 * @return {object} The object with keys camelCased.
 */
function transformKeysToCamelCase (obj) {
  var keys = Object.keys(obj);
  var camelCaseObj = {};
  keys.forEach(function (key) {
    var camelCaseKey = toCamelCase(key);
    camelCaseObj[camelCaseKey] = obj[key];
  });
  return camelCaseObj;
}
module.exports.transformKeysToCamelCase = transformKeysToCamelCase;

},{"style-attr":37}],171:[function(_dereq_,module,exports){
/**
 * Return enumerated gamepads matching id prefix.
 *
 * @param {object} idPrefix - prefix to match in gamepad id, if any.
 */
module.exports.getGamepadsByPrefix = function (idPrefix) {
  var gamepadsList = [];
  var gamepad;
  var gamepads = navigator.getGamepads && navigator.getGamepads();
  if (!gamepads) { return gamepadsList; }

  for (var i = 0; i < gamepads.length; ++i) {
    gamepad = gamepads[i];
    // need to check that gamepad is valid, since browsers may return array of null values
    if (gamepad) {
      if (!idPrefix || gamepad.id.indexOf(idPrefix) === 0) {
        gamepadsList.push(gamepad);
      }
    }
  }
  return gamepadsList;
};

/**
 * Enumerate controllers (as built by system tick, e.g. that have pose) and check if they match parameters.
 *
 * @param {object} sceneEl - the scene element.
 * @param {object} idPrefix - prefix to match in gamepad id, if any.
 * @param {object} queryObject - map of values to match (hand; index among controllers with idPrefix)
 */
module.exports.isControllerPresent = function (sceneEl, idPrefix, queryObject) {
  var isPresent = false;
  var index = 0;
  var gamepad;
  var isPrefixMatch;
  var gamepads;
  var trackedControlsSystem = sceneEl && sceneEl.systems['tracked-controls'];
  if (!trackedControlsSystem) { return isPresent; }
  gamepads = trackedControlsSystem.controllers;
  if (!gamepads || gamepads.length === 0) {
    trackedControlsSystem.updateControllerList();
    gamepads = trackedControlsSystem.controllers;
  }
  if (!gamepads) { return isPresent; }

  for (var i = 0; i < gamepads.length; ++i) {
    gamepad = gamepads[i];
    isPrefixMatch = (!idPrefix || idPrefix === '' || gamepad.id.indexOf(idPrefix) === 0);
    isPresent = isPrefixMatch;
    if (isPresent && queryObject.hand) {
      isPresent = gamepad.hand === queryObject.hand;
    }
    if (isPresent && queryObject.index) {
      isPresent = index === queryObject.index; // need to use count of gamepads with idPrefix
    }
    if (isPresent) { break; }
    if (isPrefixMatch) { index++; } // update count of gamepads with idPrefix
  }
  return isPresent;
};


},{}],172:[function(_dereq_,module,exports){
/**
 * @author dmarcos / https://github.com/dmarcos
 * @author mrdoob / http://mrdoob.com
 */

THREE.VRControls = function ( object, onError ) {

	var scope = this;

	var vrDisplay, vrDisplays;

	var standingMatrix = new THREE.Matrix4();

	var frameData = null;

	if ( 'VRFrameData' in window ) {

		frameData = new VRFrameData();

	}

	function gotVRDisplays( displays ) {

		vrDisplays = displays;

		if ( displays.length > 0 ) {

			vrDisplay = displays[ 0 ];

		} else {

			if ( onError ) onError( 'VR input not available.' );

		}

	}

	if ( navigator.getVRDisplays ) {

		navigator.getVRDisplays().then( gotVRDisplays ).catch ( function () {

			console.warn( 'THREE.VRControls: Unable to get VR Displays' );

		} );

	}

	// the Rift SDK returns the position in meters
	// this scale factor allows the user to define how meters
	// are converted to scene units.

	this.scale = 1;

	// If true will use "standing space" coordinate system where y=0 is the
	// floor and x=0, z=0 is the center of the room.
	this.standing = false;

	// Distance from the users eyes to the floor in meters. Used when
	// standing=true but the VRDisplay doesn't provide stageParameters.
	this.userHeight = 1.6;

	this.getVRDisplay = function () {

		return vrDisplay;

	};

	this.setVRDisplay = function ( value ) {

		vrDisplay = value;

	};

	this.getVRDisplays = function () {

		console.warn( 'THREE.VRControls: getVRDisplays() is being deprecated.' );
		return vrDisplays;

	};

	this.getStandingMatrix = function () {

		return standingMatrix;

	};

	this.update = function () {

		if ( vrDisplay ) {

			var pose;

			if ( vrDisplay.getFrameData ) {

				vrDisplay.getFrameData( frameData );
				pose = frameData.pose;

			} else if ( vrDisplay.getPose ) {

				pose = vrDisplay.getPose();

			}

			if ( pose.orientation !== null ) {

				object.quaternion.fromArray( pose.orientation );

			}

			if ( pose.position !== null ) {

				object.position.fromArray( pose.position );

			} else {

				object.position.set( 0, 0, 0 );

			}

			if ( this.standing ) {

				if ( vrDisplay.stageParameters ) {

					object.updateMatrix();

					standingMatrix.fromArray( vrDisplay.stageParameters.sittingToStandingTransform );
					object.applyMatrix( standingMatrix );

				} else {

					object.position.setY( object.position.y + this.userHeight );

				}

			}

			object.position.multiplyScalar( scope.scale );

		}

	};

	this.resetPose = function () {

		if ( vrDisplay ) {

			vrDisplay.resetPose();

		}

	};

	this.resetSensor = function () {

		console.warn( 'THREE.VRControls: .resetSensor() is now .resetPose().' );
		this.resetPose();

	};

	this.zeroSensor = function () {

		console.warn( 'THREE.VRControls: .zeroSensor() is now .resetPose().' );
		this.resetPose();

	};

	this.dispose = function () {

		vrDisplay = null;

	};

};

},{}],173:[function(_dereq_,module,exports){
/**
 * @author dmarcos / https://github.com/dmarcos
 * @author mrdoob / http://mrdoob.com
 *
 * WebVR Spec: http://mozvr.github.io/webvr-spec/webvr.html
 *
 * Firefox: http://mozvr.com/downloads/
 * Chromium: https://webvr.info/get-chrome
 *
 */

THREE.VREffect = function( renderer, onError ) {

	var vrDisplay, vrDisplays;
	var eyeTranslationL = new THREE.Vector3();
	var eyeTranslationR = new THREE.Vector3();
	var renderRectL, renderRectR;

	var frameData = null;

	if ( 'VRFrameData' in window ) {

		frameData = new window.VRFrameData();

	}

	function gotVRDisplays( displays ) {

		vrDisplays = displays;

		if ( displays.length > 0 ) {

			vrDisplay = displays[ 0 ];

		} else {

			if ( onError ) onError( 'HMD not available' );

		}

	}

	if ( navigator.getVRDisplays ) {

		navigator.getVRDisplays().then( gotVRDisplays ).catch( function() {

			console.warn( 'THREE.VREffect: Unable to get VR Displays' );

		} );

	}

	//

	this.isPresenting = false;

	var scope = this;

	var rendererSize = renderer.getSize();
	var rendererUpdateStyle = false;
	var rendererPixelRatio = renderer.getPixelRatio();

	this.getVRDisplay = function() {

		return vrDisplay;

	};

	this.setVRDisplay = function( value ) {

		vrDisplay = value;

	};

	this.getVRDisplays = function() {

		console.warn( 'THREE.VREffect: getVRDisplays() is being deprecated.' );
		return vrDisplays;

	};

	this.setSize = function( width, height, updateStyle ) {

		rendererSize = { width: width, height: height };
		rendererUpdateStyle = updateStyle;

		if ( scope.isPresenting ) {

			var eyeParamsL = vrDisplay.getEyeParameters( 'left' );
			renderer.setPixelRatio( 1 );
			renderer.setSize( eyeParamsL.renderWidth * 2, eyeParamsL.renderHeight, false );

		} else {

			renderer.setPixelRatio( rendererPixelRatio );
			renderer.setSize( width, height, updateStyle );

		}

	};

	// VR presentation

	var canvas = renderer.domElement;
	var defaultLeftBounds = [ 0.0, 0.0, 0.5, 1.0 ];
	var defaultRightBounds = [ 0.5, 0.0, 0.5, 1.0 ];

	function onVRDisplayPresentChange() {

		var wasPresenting = scope.isPresenting;
		scope.isPresenting = vrDisplay !== undefined && vrDisplay.isPresenting;

		if ( scope.isPresenting ) {

			var eyeParamsL = vrDisplay.getEyeParameters( 'left' );
			var eyeWidth = eyeParamsL.renderWidth;
			var eyeHeight = eyeParamsL.renderHeight;

			if ( ! wasPresenting ) {

				rendererPixelRatio = renderer.getPixelRatio();
				rendererSize = renderer.getSize();

				renderer.setPixelRatio( 1 );
				renderer.setSize( eyeWidth * 2, eyeHeight, false );

			}

		} else if ( wasPresenting ) {

			renderer.setPixelRatio( rendererPixelRatio );
			renderer.setSize( rendererSize.width, rendererSize.height, rendererUpdateStyle );

		}

	}

	window.addEventListener( 'vrdisplaypresentchange', onVRDisplayPresentChange, false );

	this.setFullScreen = function( boolean ) {

		return new Promise( function( resolve, reject ) {

			if ( vrDisplay === undefined ) {

				reject( new Error( 'No VR hardware found.' ) );
				return;

			}

			if ( scope.isPresenting === boolean ) {

				resolve();
				return;

			}

			if ( boolean ) {

				resolve( vrDisplay.requestPresent( [ { source: canvas } ] ) );

			} else {

				resolve( vrDisplay.exitPresent() );

			}

		} );

	};

	this.requestPresent = function() {

		return this.setFullScreen( true );

	};

	this.exitPresent = function() {

		return this.setFullScreen( false );

	};

	this.requestAnimationFrame = function( f ) {

		if ( vrDisplay !== undefined ) {

			return vrDisplay.requestAnimationFrame( f );

		} else {

			return window.requestAnimationFrame( f );

		}

	};

	this.cancelAnimationFrame = function( h ) {

		if ( vrDisplay !== undefined ) {

			vrDisplay.cancelAnimationFrame( h );

		} else {

			window.cancelAnimationFrame( h );

		}

	};

	this.submitFrame = function() {

		if ( vrDisplay !== undefined && scope.isPresenting ) {

			vrDisplay.submitFrame();

		}

	};

	this.autoSubmitFrame = true;

	// render

	var cameraL = new THREE.PerspectiveCamera();
	cameraL.layers.enable( 1 );

	var cameraR = new THREE.PerspectiveCamera();
	cameraR.layers.enable( 2 );

	this.render = function( scene, camera, renderTarget, forceClear ) {

		if ( vrDisplay && scope.isPresenting ) {

			var autoUpdate = scene.autoUpdate;

			if ( autoUpdate ) {

				scene.updateMatrixWorld();
				scene.autoUpdate = false;

			}

			var eyeParamsL = vrDisplay.getEyeParameters( 'left' );
			var eyeParamsR = vrDisplay.getEyeParameters( 'right' );

			eyeTranslationL.fromArray( eyeParamsL.offset );
			eyeTranslationR.fromArray( eyeParamsR.offset );

			if ( Array.isArray( scene ) ) {

				console.warn( 'THREE.VREffect.render() no longer supports arrays. Use object.layers instead.' );
				scene = scene[ 0 ];

			}

			// When rendering we don't care what the recommended size is, only what the actual size
			// of the backbuffer is.
			var size = renderer.getSize();
			var layers = vrDisplay.getLayers();
			var leftBounds;
			var rightBounds;

			if ( layers.length ) {

				var layer = layers[ 0 ];

				leftBounds = layer.leftBounds !== null && layer.leftBounds.length === 4 ? layer.leftBounds : defaultLeftBounds;
				rightBounds = layer.rightBounds !== null && layer.rightBounds.length === 4 ? layer.rightBounds : defaultRightBounds;

			} else {

				leftBounds = defaultLeftBounds;
				rightBounds = defaultRightBounds;

			}

			renderRectL = {
				x: Math.round( size.width * leftBounds[ 0 ] ),
				y: Math.round( size.height * leftBounds[ 1 ] ),
				width: Math.round( size.width * leftBounds[ 2 ] ),
				height: Math.round( size.height * leftBounds[ 3 ] )
			};
			renderRectR = {
				x: Math.round( size.width * rightBounds[ 0 ] ),
				y: Math.round( size.height * rightBounds[ 1 ] ),
				width: Math.round( size.width * rightBounds[ 2 ] ),
				height: Math.round( size.height * rightBounds[ 3 ] )
			};

			if ( renderTarget ) {

				renderer.setRenderTarget( renderTarget );
				renderTarget.scissorTest = true;

			} else {

				renderer.setRenderTarget( null );
				renderer.setScissorTest( true );

			}

			if ( renderer.autoClear || forceClear ) renderer.clear();

			if ( camera.parent === null ) camera.updateMatrixWorld();

			camera.matrixWorld.decompose( cameraL.position, cameraL.quaternion, cameraL.scale );

			cameraR.position.copy(cameraL.position);
			cameraR.quaternion.copy(cameraL.quaternion);
			cameraR.scale.copy(cameraL.scale);

			cameraL.translateOnAxis( eyeTranslationL, cameraL.scale.x );
			cameraR.translateOnAxis( eyeTranslationR, cameraR.scale.x );

			if ( vrDisplay.getFrameData ) {

				vrDisplay.depthNear = camera.near;
				vrDisplay.depthFar = camera.far;

				vrDisplay.getFrameData( frameData );

				cameraL.projectionMatrix.elements = frameData.leftProjectionMatrix;
				cameraR.projectionMatrix.elements = frameData.rightProjectionMatrix;

			} else {

				cameraL.projectionMatrix = fovToProjection( eyeParamsL.fieldOfView, true, camera.near, camera.far );
				cameraR.projectionMatrix = fovToProjection( eyeParamsR.fieldOfView, true, camera.near, camera.far );

			}

			// render left eye
			if ( renderTarget ) {

				renderTarget.viewport.set( renderRectL.x, renderRectL.y, renderRectL.width, renderRectL.height );
				renderTarget.scissor.set( renderRectL.x, renderRectL.y, renderRectL.width, renderRectL.height );

			} else {

				renderer.setViewport( renderRectL.x, renderRectL.y, renderRectL.width, renderRectL.height );
				renderer.setScissor( renderRectL.x, renderRectL.y, renderRectL.width, renderRectL.height );

			}
			renderer.render( scene, cameraL, renderTarget, forceClear );

			// render right eye
			if ( renderTarget ) {

				renderTarget.viewport.set( renderRectR.x, renderRectR.y, renderRectR.width, renderRectR.height );
				renderTarget.scissor.set( renderRectR.x, renderRectR.y, renderRectR.width, renderRectR.height );

			} else {

				renderer.setViewport( renderRectR.x, renderRectR.y, renderRectR.width, renderRectR.height );
				renderer.setScissor( renderRectR.x, renderRectR.y, renderRectR.width, renderRectR.height );

			}
			renderer.render( scene, cameraR, renderTarget, forceClear );

			if ( renderTarget ) {

				renderTarget.viewport.set( 0, 0, size.width, size.height );
				renderTarget.scissor.set( 0, 0, size.width, size.height );
				renderTarget.scissorTest = false;
				renderer.setRenderTarget( null );

			} else {

				renderer.setViewport( 0, 0, size.width, size.height );
				renderer.setScissorTest( false );

			}

			if ( autoUpdate ) {

				scene.autoUpdate = true;

			}

			if ( scope.autoSubmitFrame ) {

				scope.submitFrame();

			}

			return;

		}

		// Regular render mode if not HMD

		renderer.render( scene, camera, renderTarget, forceClear );

	};

	this.dispose = function() {

		window.removeEventListener( 'vrdisplaypresentchange', onVRDisplayPresentChange, false );

	};

	//

	function fovToNDCScaleOffset( fov ) {

		var pxscale = 2.0 / ( fov.leftTan + fov.rightTan );
		var pxoffset = ( fov.leftTan - fov.rightTan ) * pxscale * 0.5;
		var pyscale = 2.0 / ( fov.upTan + fov.downTan );
		var pyoffset = ( fov.upTan - fov.downTan ) * pyscale * 0.5;
		return { scale: [ pxscale, pyscale ], offset: [ pxoffset, pyoffset ] };

	}

	function fovPortToProjection( fov, rightHanded, zNear, zFar ) {

		rightHanded = rightHanded === undefined ? true : rightHanded;
		zNear = zNear === undefined ? 0.01 : zNear;
		zFar = zFar === undefined ? 10000.0 : zFar;

		var handednessScale = rightHanded ? - 1.0 : 1.0;

		// start with an identity matrix
		var mobj = new THREE.Matrix4();
		var m = mobj.elements;

		// and with scale/offset info for normalized device coords
		var scaleAndOffset = fovToNDCScaleOffset( fov );

		// X result, map clip edges to [-w,+w]
		m[ 0 * 4 + 0 ] = scaleAndOffset.scale[ 0 ];
		m[ 0 * 4 + 1 ] = 0.0;
		m[ 0 * 4 + 2 ] = scaleAndOffset.offset[ 0 ] * handednessScale;
		m[ 0 * 4 + 3 ] = 0.0;

		// Y result, map clip edges to [-w,+w]
		// Y offset is negated because this proj matrix transforms from world coords with Y=up,
		// but the NDC scaling has Y=down (thanks D3D?)
		m[ 1 * 4 + 0 ] = 0.0;
		m[ 1 * 4 + 1 ] = scaleAndOffset.scale[ 1 ];
		m[ 1 * 4 + 2 ] = - scaleAndOffset.offset[ 1 ] * handednessScale;
		m[ 1 * 4 + 3 ] = 0.0;

		// Z result (up to the app)
		m[ 2 * 4 + 0 ] = 0.0;
		m[ 2 * 4 + 1 ] = 0.0;
		m[ 2 * 4 + 2 ] = zFar / ( zNear - zFar ) * - handednessScale;
		m[ 2 * 4 + 3 ] = ( zFar * zNear ) / ( zNear - zFar );

		// W result (= Z in)
		m[ 3 * 4 + 0 ] = 0.0;
		m[ 3 * 4 + 1 ] = 0.0;
		m[ 3 * 4 + 2 ] = handednessScale;
		m[ 3 * 4 + 3 ] = 0.0;

		mobj.transpose();
		return mobj;

	}

	function fovToProjection( fov, rightHanded, zNear, zFar ) {

		var DEG2RAD = Math.PI / 180.0;

		var fovPort = {
			upTan: Math.tan( fov.upDegrees * DEG2RAD ),
			downTan: Math.tan( fov.downDegrees * DEG2RAD ),
			leftTan: Math.tan( fov.leftDegrees * DEG2RAD ),
			rightTan: Math.tan( fov.rightDegrees * DEG2RAD )
		};

		return fovPortToProjection( fovPort, rightHanded, zNear, zFar );

	}

};

},{}],174:[function(_dereq_,module,exports){
window.glStats = function () {

    var _rS = null;

    var _totalDrawArraysCalls = 0,
        _totalDrawElementsCalls = 0,
        _totalUseProgramCalls = 0,
        _totalFaces = 0,
        _totalVertices = 0,
        _totalPoints = 0,
        _totalBindTexures = 0;

    function _h ( f, c ) {
        return function () {
            c.apply( this, arguments );
            f.apply( this, arguments );
        };
    }

    WebGLRenderingContext.prototype.drawArrays = _h( WebGLRenderingContext.prototype.drawArrays, function () {
        _totalDrawArraysCalls++;
        if ( arguments[ 0 ] == this.POINTS ) _totalPoints += arguments[ 2 ];
        else _totalVertices += arguments[ 2 ];
    } );

    WebGLRenderingContext.prototype.drawElements = _h( WebGLRenderingContext.prototype.drawElements, function () {
        _totalDrawElementsCalls++;
        _totalFaces += arguments[ 1 ] / 3;
        _totalVertices += arguments[ 1 ];
    } );

    WebGLRenderingContext.prototype.useProgram = _h( WebGLRenderingContext.prototype.useProgram, function () {
        _totalUseProgramCalls++;
    } );

    WebGLRenderingContext.prototype.bindTexture = _h( WebGLRenderingContext.prototype.bindTexture, function () {
        _totalBindTexures++;
    } );

    var _values = {
        allcalls: {
            over: 3000,
            caption: 'Calls (hook)'
        },
        drawelements: {
            caption: 'drawElements (hook)'
        },
        drawarrays: {
            caption: 'drawArrays (hook)'
        }
    };

    var _groups = [ {
        caption: 'WebGL',
        values: [ 'allcalls', 'drawelements', 'drawarrays', 'useprogram', 'bindtexture', 'glfaces', 'glvertices', 'glpoints' ]
    } ];

    var _fractions = [ {
        base: 'allcalls',
        steps: [ 'drawelements', 'drawarrays' ]
    } ];

    function _update () {
        _rS( 'allcalls' ).set( _totalDrawArraysCalls + _totalDrawElementsCalls );
        _rS( 'drawElements' ).set( _totalDrawElementsCalls );
        _rS( 'drawArrays' ).set( _totalDrawArraysCalls );
        _rS( 'bindTexture' ).set( _totalBindTexures );
        _rS( 'useProgram' ).set( _totalUseProgramCalls );
        _rS( 'glfaces' ).set( _totalFaces );
        _rS( 'glvertices' ).set( _totalVertices );
        _rS( 'glpoints' ).set( _totalPoints );
    }

    function _start () {
        _totalDrawArraysCalls = 0;
        _totalDrawElementsCalls = 0;
        _totalUseProgramCalls = 0;
        _totalFaces = 0;
        _totalVertices = 0;
        _totalPoints = 0;
        _totalBindTexures = 0;
    }

    function _end () {}

    function _attach ( r ) {
        _rS = r;
    }

    return {
        update: _update,
        start: _start,
        end: _end,
        attach: _attach,
        values: _values,
        groups: _groups,
        fractions: _fractions
    };

};

window.threeStats = function ( renderer ) {

    var _rS = null;

    var _values = {
        'renderer.info.memory.geometries': {
            caption: 'Geometries'
        },
        'renderer.info.memory.textures': {
            caption: 'Textures'
        },
        'renderer.info.programs': {
            caption: 'Programs'
        },
        'renderer.info.render.calls': {
            caption: 'Calls'
        },
        'renderer.info.render.faces': {
            caption: 'Faces',
            over: 1000
        },
        'renderer.info.render.points': {
            caption: 'Points'
        },
        'renderer.info.render.vertices': {
            caption: 'Vertices'
        }
    };

    var _groups = [ {
        caption: 'Three.js - Memory',
        values: [ 'renderer.info.memory.geometries', 'renderer.info.programs', 'renderer.info.memory.textures' ]
    }, {
        caption: 'Three.js - Render',
        values: [ 'renderer.info.render.calls', 'renderer.info.render.faces', 'renderer.info.render.points', 'renderer.info.render.vertices' ]
    } ];

    var _fractions = [];

    function _update () {

        _rS( 'renderer.info.memory.geometries' ).set( renderer.info.memory.geometries );
        _rS( 'renderer.info.programs' ).set( renderer.info.programs.length );
        _rS( 'renderer.info.memory.textures' ).set( renderer.info.memory.textures );
        _rS( 'renderer.info.render.calls' ).set( renderer.info.render.calls );
        _rS( 'renderer.info.render.faces' ).set( renderer.info.render.faces );
        _rS( 'renderer.info.render.points' ).set( renderer.info.render.points );
        _rS( 'renderer.info.render.vertices' ).set( renderer.info.render.vertices );

    }

    function _start () {}

    function _end () {}

    function _attach ( r ) {
        _rS = r;
    }

    return {
        update: _update,
        start: _start,
        end: _end,
        attach: _attach,
        values: _values,
        groups: _groups,
        fractions: _fractions
    };

};

/*
 *   From https://github.com/paulirish/memory-stats.js
 */

window.BrowserStats = function () {

    var _rS = null;

    var _usedJSHeapSize = 0,
        _totalJSHeapSize = 0;

    if ( window.performance && !performance.memory ) {
        performance.memory = {
            usedJSHeapSize: 0,
            totalJSHeapSize: 0
        };
    }

    if ( performance.memory.totalJSHeapSize === 0 ) {
        console.warn( 'totalJSHeapSize === 0... performance.memory is only available in Chrome .' );
    }

    var _values = {
        memory: {
            caption: 'Used Memory',
            average: true,
            avgMs: 1000,
            over: 22
        },
        total: {
            caption: 'Total Memory'
        }
    };

    var _groups = [ {
        caption: 'Browser',
        values: [ 'memory', 'total' ]
    } ];

    var _fractions = [ {
        base: 'total',
        steps: [ 'memory' ]
    } ];

    var log1024 = Math.log( 1024 );

    function _size ( v ) {

        var precision = 100; //Math.pow(10, 2);
        var i = Math.floor( Math.log( v ) / log1024 );
        return Math.round( v * precision / Math.pow( 1024, i ) ) / precision; // + ' ' + sizes[i];

    }

    function _update () {
        _usedJSHeapSize = _size( performance.memory.usedJSHeapSize );
        _totalJSHeapSize = _size( performance.memory.totalJSHeapSize );

        _rS( 'memory' ).set( _usedJSHeapSize );
        _rS( 'total' ).set( _totalJSHeapSize );
    }

    function _start () {
        _usedJSHeapSize = 0;
    }

    function _end () {}

    function _attach ( r ) {
        _rS = r;
    }

    return {
        update: _update,
        start: _start,
        end: _end,
        attach: _attach,
        values: _values,
        groups: _groups,
        fractions: _fractions
    };

};

if (typeof module === 'object') {
  module.exports = {
    glStats: window.glStats,
    threeStats: window.threeStats,
    BrowserStats: window.BrowserStats
  };
}

},{}],175:[function(_dereq_,module,exports){
// performance.now() polyfill from https://gist.github.com/paulirish/5438650
'use strict';

( function () {

    // prepare base perf object
    if ( typeof window.performance === 'undefined' ) {
        window.performance = {};
    }

    if ( !window.performance.now ) {

        var nowOffset = Date.now();

        if ( performance.timing && performance.timing.navigationStart ) {
            nowOffset = performance.timing.navigationStart;
        }

        window.performance.now = function now () {
            return Date.now() - nowOffset;
        };

    }

    if( !window.performance.mark ) {
        window.performance.mark = function(){}
    }

    if( !window.performance.measure ) {
        window.performance.measure = function(){}
    }

} )();

window.rStats = function rStats ( settings ) {

    function iterateKeys ( array, callback ) {
        var keys = Object.keys( array );
        for ( var j = 0, l = keys.length; j < l; j++ ) {
            callback( keys[ j ] );
        }
    }

    function importCSS ( url ) {

        var element = document.createElement( 'link' );
        element.href = url;
        element.rel = 'stylesheet';
        element.type = 'text/css';
        document.getElementsByTagName( 'head' )[ 0 ].appendChild( element );

    }

    var _settings = settings || {};
    var _colours = _settings.colours || [ '#850700', '#c74900', '#fcb300', '#284280', '#4c7c0c' ];

    var _cssFont = 'https://fonts.googleapis.com/css?family=Roboto+Condensed:400,700,300';
    var _cssRStats = ( _settings.CSSPath ? _settings.CSSPath : '' ) + 'rStats.css';

    var _css = _settings.css || [ _cssFont, _cssRStats ];
    _css.forEach(function (uri) {
        importCSS( uri );
    });

    if ( !_settings.values ) _settings.values = {};

    var _base, _div, _elHeight = 10, _elWidth = 200;
    var _perfCounters = {};


    function Graph ( _dom, _id, _defArg ) {

        var _def = _defArg || {};
        var _canvas = document.createElement( 'canvas' ),
            _ctx = _canvas.getContext( '2d' ),
            _max = 0,
            _current = 0;

        var c = _def.color ? _def.color : '#666666';

        var _dotCanvas = document.createElement( 'canvas' ),
            _dotCtx = _dotCanvas.getContext( '2d' );
        _dotCanvas.width = 1;
        _dotCanvas.height = 2 * _elHeight;
        _dotCtx.fillStyle = '#444444';
        _dotCtx.fillRect( 0, 0, 1, 2 * _elHeight );
        _dotCtx.fillStyle = c;
        _dotCtx.fillRect( 0, _elHeight, 1, _elHeight );
        _dotCtx.fillStyle = '#ffffff';
        _dotCtx.globalAlpha = 0.5;
        _dotCtx.fillRect( 0, _elHeight, 1, 1 );
        _dotCtx.globalAlpha = 1;

        var _alarmCanvas = document.createElement( 'canvas' ),
            _alarmCtx = _alarmCanvas.getContext( '2d' );
        _alarmCanvas.width = 1;
        _alarmCanvas.height = 2 * _elHeight;
        _alarmCtx.fillStyle = '#444444';
        _alarmCtx.fillRect( 0, 0, 1, 2 * _elHeight );
        _alarmCtx.fillStyle = '#b70000';
        _alarmCtx.fillRect( 0, _elHeight, 1, _elHeight );
        _alarmCtx.globalAlpha = 0.5;
        _alarmCtx.fillStyle = '#ffffff';
        _alarmCtx.fillRect( 0, _elHeight, 1, 1 );
        _alarmCtx.globalAlpha = 1;

        function _init () {

            _canvas.width = _elWidth;
            _canvas.height = _elHeight;
            _canvas.style.width = _canvas.width + 'px';
            _canvas.style.height = _canvas.height + 'px';
            _canvas.className = 'rs-canvas';
            _dom.appendChild( _canvas );

            _ctx.fillStyle = '#444444';
            _ctx.fillRect( 0, 0, _canvas.width, _canvas.height );

        }

        function _draw ( v, alarm ) {
            _current += ( v - _current ) * 0.1;
            _max *= 0.99;
            if ( _current > _max ) _max = _current;
            _ctx.drawImage( _canvas, 1, 0, _canvas.width - 1, _canvas.height, 0, 0, _canvas.width - 1, _canvas.height );
            if ( alarm ) {
                _ctx.drawImage( _alarmCanvas, _canvas.width - 1, _canvas.height - _current * _canvas.height / _max - _elHeight );
            } else {
                _ctx.drawImage( _dotCanvas, _canvas.width - 1, _canvas.height - _current * _canvas.height / _max - _elHeight );
            }
        }

        _init();

        return {
            draw: _draw
        };

    }

    function StackGraph ( _dom, _num ) {

        var _canvas = document.createElement( 'canvas' ),
            _ctx = _canvas.getContext( '2d' );

        function _init () {

            _canvas.width = _elWidth;
            _canvas.height = _elHeight * _num;
            _canvas.style.width = _canvas.width + 'px';
            _canvas.style.height = _canvas.height + 'px';
            _canvas.className = 'rs-canvas';
            _dom.appendChild( _canvas );

            _ctx.fillStyle = '#444444';
            _ctx.fillRect( 0, 0, _canvas.width, _canvas.height );

        }

        function _draw ( v ) {
            _ctx.drawImage( _canvas, 1, 0, _canvas.width - 1, _canvas.height, 0, 0, _canvas.width - 1, _canvas.height );
            var th = 0;
            iterateKeys( v, function ( j ) {
                var h = v[ j ] * _canvas.height;
                _ctx.fillStyle = _colours[ j ];
                _ctx.fillRect( _canvas.width - 1, th, 1, h );
                th += h;
            } );
        }

        _init();

        return {
            draw: _draw
        };

    }

    function PerfCounter ( id, group ) {

        var _id = id,
            _time,
            _value = 0,
            _total = 0,
            _averageValue = 0,
            _accumValue = 0,
            _accumStart = performance.now(),
            _accumSamples = 0,
            _dom = document.createElement( 'div' ),
            _spanId = document.createElement( 'span' ),
            _spanValue = document.createElement( 'div' ),
            _spanValueText = document.createTextNode( '' ),
            _def = _settings ? _settings.values[ _id.toLowerCase() ] : null,
            _graph = new Graph( _dom, _id, _def ),
            _started = false;

        _spanId.className = 'rs-counter-id';
        _spanId.textContent = ( _def && _def.caption ) ? _def.caption : _id;

        _spanValue.className = 'rs-counter-value';
        _spanValue.appendChild( _spanValueText );

        _dom.appendChild( _spanId );
        _dom.appendChild( _spanValue );
        if ( group ) group.div.appendChild( _dom );
        else _div.appendChild( _dom );

        _time = performance.now();

        function _average ( v ) {
            if ( _def && _def.average ) {
                _accumValue += v;
                _accumSamples++;
                var t = performance.now();
                if ( t - _accumStart >= ( _def.avgMs || 1000 ) ) {
                    _averageValue = _accumValue / _accumSamples;
                    _accumValue = 0;
                    _accumStart = t;
                    _accumSamples = 0;
                }
            }
        }

        function _start () {
            _time = performance.now();
            if( _settings.userTimingAPI ) performance.mark( _id + '-start' );
            _started = true;
        }

        function _end () {
            _value = performance.now() - _time;
            if( _settings.userTimingAPI ) {
                performance.mark( _id + '-end' );
                if( _started ) {
                    performance.measure( _id, _id + '-start', _id + '-end' );
                }
            }
            _average( _value );
        }

        function _tick () {
            _end();
            _start();
        }

        function _draw () {
            var v = ( _def && _def.average ) ? _averageValue : _value;
            _spanValueText.nodeValue = Math.round( v * 100 ) / 100;
            var a = ( _def && ( ( _def.below && _value < _def.below ) || ( _def.over && _value > _def.over ) ) );
            _graph.draw( _value, a );
            _dom.className = a ? 'rs-counter-base alarm' : 'rs-counter-base';

        }

        function _frame () {
            var t = performance.now();
            var e = t - _time;
            _total++;
            if ( e > 1000 ) {
                if ( _def && _def.interpolate === false ) {
                    _value = _total;
                } else {
                    _value = _total * 1000 / e;
                }
                _total = 0;
                _time = t;
                _average( _value );
            }
        }

        function _set ( v ) {
            _value = v;
            _average( _value );
        }

        return {
            set: _set,
            start: _start,
            tick: _tick,
            end: _end,
            frame: _frame,
            value: function () {
                return _value;
            },
            draw: _draw
        };

    }

    function sample () {

        var _value = 0;

        function _set ( v ) {
            _value = v;
        }

        return {
            set: _set,
            value: function () {
                return _value;
            }
        };

    }

    function _perf ( idArg ) {

        var id = idArg.toLowerCase();
        if ( id === undefined ) id = 'default';
        if ( _perfCounters[ id ] ) return _perfCounters[ id ];

        var group = null;
        if ( _settings && _settings.groups ) {
            iterateKeys( _settings.groups, function ( j ) {
                var g = _settings.groups[ parseInt( j, 10 ) ];
                if ( !group && g.values.indexOf( id.toLowerCase() ) !== -1 ) {
                    group = g;
                }
            } );
        }

        var p = new PerfCounter( id, group );
        _perfCounters[ id ] = p;
        return p;

    }

    function _init () {

        if ( _settings.plugins ) {
            if ( !_settings.values ) _settings.values = {};
            if ( !_settings.groups ) _settings.groups = [];
            if ( !_settings.fractions ) _settings.fractions = [];
            for ( var j = 0; j < _settings.plugins.length; j++ ) {
                _settings.plugins[ j ].attach( _perf );
                iterateKeys( _settings.plugins[ j ].values, function ( k ) {
                    _settings.values[ k ] = _settings.plugins[ j ].values[ k ];
                } );
                _settings.groups = _settings.groups.concat( _settings.plugins[ j ].groups );
                _settings.fractions = _settings.fractions.concat( _settings.plugins[ j ].fractions );
            }
        } else {
            _settings.plugins = {};
        }

        _base = document.createElement( 'div' );
        _base.className = 'rs-base';
        _div = document.createElement( 'div' );
        _div.className = 'rs-container';
        _div.style.height = 'auto';
        _base.appendChild( _div );
        document.body.appendChild( _base );

        if ( !_settings ) return;

        if ( _settings.groups ) {
            iterateKeys( _settings.groups, function ( j ) {
                var g = _settings.groups[ parseInt( j, 10 ) ];
                var div = document.createElement( 'div' );
                div.className = 'rs-group';
                g.div = div;
                var h1 = document.createElement( 'h1' );
                h1.textContent = g.caption;
                h1.addEventListener( 'click', function ( e ) {
                    this.classList.toggle( 'hidden' );
                    e.preventDefault();
                }.bind( div ) );
                _div.appendChild( h1 );
                _div.appendChild( div );
            } );
        }

        if ( _settings.fractions ) {
            iterateKeys( _settings.fractions, function ( j ) {
                var f = _settings.fractions[ parseInt( j, 10 ) ];
                var div = document.createElement( 'div' );
                div.className = 'rs-fraction';
                var legend = document.createElement( 'div' );
                legend.className = 'rs-legend';

                var h = 0;
                iterateKeys( _settings.fractions[ j ].steps, function ( k ) {
                    var p = document.createElement( 'p' );
                    p.textContent = _settings.fractions[ j ].steps[ k ];
                    p.style.color = _colours[ h ];
                    legend.appendChild( p );
                    h++;
                } );
                div.appendChild( legend );
                div.style.height = h * _elHeight + 'px';
                f.div = div;
                var graph = new StackGraph( div, h );
                f.graph = graph;
                _div.appendChild( div );
            } );
        }

    }

    function _update () {

        iterateKeys( _settings.plugins, function ( j ) {
            _settings.plugins[ j ].update();
        } );

        iterateKeys( _perfCounters, function ( j ) {
            _perfCounters[ j ].draw();
        } );

        if ( _settings && _settings.fractions ) {
            iterateKeys( _settings.fractions, function ( j ) {
                var f = _settings.fractions[ parseInt( j, 10 ) ];
                var v = [];
                var base = _perfCounters[ f.base.toLowerCase() ];
                if ( base ) {
                    base = base.value();
                    iterateKeys( _settings.fractions[ j ].steps, function ( k ) {
                        var s = _settings.fractions[ j ].steps[ parseInt( k, 10 ) ].toLowerCase();
                        var val = _perfCounters[ s ];
                        if ( val ) {
                            v.push( val.value() / base );
                        }
                    } );
                }
                f.graph.draw( v );
            } );
        }

        /*if( _height != _div.clientHeight ) {
            _height = _div.clientHeight;
            _base.style.height = _height + 2 * _elHeight + 'px';
        console.log( _base.clientHeight );
        }*/

    }

    _init();

    return function ( id ) {
        if ( id ) return _perf( id );
        return {
            element: _base,
            update: _update
        };
    };

}

if (typeof module === 'object') {
  module.exports = window.rStats;
}

},{}],176:[function(_dereq_,module,exports){
/*
 * Copyright 2015 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Util = {};

Util.base64 = function(mimeType, base64) {
  return 'data:' + mimeType + ';base64,' + base64;
};

Util.isMobile = function() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

Util.isIOS = function() {
  return /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
};

Util.isIFrame = function() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

Util.appendQueryParameter = function(url, key, value) {
  // Determine delimiter based on if the URL already GET parameters in it.
  var delimiter = (url.indexOf('?') < 0 ? '?' : '&');
  url += delimiter + key + '=' + value;
  return url;
};

// From http://goo.gl/4WX3tg
Util.getQueryParameter = function(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
};

Util.isLandscapeMode = function() {
  return (window.orientation == 90 || window.orientation == -90);
};


module.exports = Util;

},{}],177:[function(_dereq_,module,exports){
/*
 * Copyright 2015 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Util = _dereq_('./util.js');

/**
 * Android and iOS compatible wakelock implementation.
 *
 * Refactored thanks to dkovalev@.
 */
function AndroidWakeLock() {
  var video = document.createElement('video');

  video.addEventListener('ended', function() {
    video.play();
  });

  this.request = function() {
    if (video.paused) {
      // Base64 version of videos_src/no-sleep-60s.webm.
      video.src = Util.base64('video/webm', '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');
      video.play();
    }
  };

  this.release = function() {
    video.pause();
    video.src = '';
  };
}

function iOSWakeLock() {
  var timer = null;

  this.request = function() {
    if (!timer) {
      timer = setInterval(function() {
        window.location = window.location;
        setTimeout(window.stop, 0);
      }, 30000);
    }
  }

  this.release = function() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }
}


function getWakeLock() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
    return iOSWakeLock;
  } else {
    return AndroidWakeLock;
  }
}

module.exports = getWakeLock();

},{"./util.js":176}]},{},[144])(144)
});
//# sourceMappingURL=aframe-master.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42), __webpack_require__(234).setImmediate))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @param {!string} name
 * @param {!Node} node
 * @constructor
 * @struct
 */
var NamedNode = /** @class */function () {
  function NamedNode(name, node) {
    this.name = name;
    this.node = node;
  }
  /**
   *
   * @param {!string} name
   * @param {!Node} node
   * @return {NamedNode}
   */
  NamedNode.Wrap = function (name, node) {
    return new NamedNode(name, node);
  };
  return NamedNode;
}();
exports.NamedNode = NamedNode;
//# sourceMappingURL=Node.js.map


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isDef = isDef;
exports.isJustDef = isJustDef;
exports.isFunction = isFunction;
exports.isObject = isObject;
exports.isNonNullObject = isNonNullObject;
exports.isNonArrayObject = isNonArrayObject;
exports.isString = isString;
exports.isNumber = isNumber;
exports.isNativeBlob = isNativeBlob;
exports.isNativeBlobDefined = isNativeBlobDefined;
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @return False if the object is undefined or null, true otherwise.
 */
function isDef(p) {
    return p != null;
}
function isJustDef(p) {
    return p !== void 0;
}
function isFunction(p) {
    return typeof p === 'function';
}
function isObject(p) {
    return (typeof p === 'undefined' ? 'undefined' : _typeof(p)) === 'object';
}
function isNonNullObject(p) {
    return isObject(p) && p !== null;
}
function isNonArrayObject(p) {
    return isObject(p) && !Array.isArray(p);
}
function isString(p) {
    return typeof p === 'string' || p instanceof String;
}
function isNumber(p) {
    return typeof p === 'number' || p instanceof Number;
}
function isNativeBlob(p) {
    return isNativeBlobDefined() && p instanceof Blob;
}
function isNativeBlobDefined() {
    return typeof Blob !== 'undefined';
}
//# sourceMappingURL=type.js.map


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(232);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
var jsonEval = exports.jsonEval = function jsonEval(str) {
  return JSON.parse(str);
};
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
var stringify = exports.stringify = function stringify(data) {
  return JSON.stringify(data);
};
//# sourceMappingURL=json.js.map


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(8);

var CallbackQueue = __webpack_require__(201);
var PooledClass = __webpack_require__(41);
var ReactFeatureFlags = __webpack_require__(206);
var ReactReconciler = __webpack_require__(53);
var Transaction = __webpack_require__(90);

var invariant = __webpack_require__(1);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setWorldState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setSearchState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addSpace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return switchSpace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateSpaceName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteSpace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return moveBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return addBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setDrag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return saveDrag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return addText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return rmvItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return clearItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return stopInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microphone__ = __webpack_require__(56);



var setWorldState = function setWorldState(state) {
    var sphere = document.getElementById("small-sphere");

    if (state !== "WORLD_VIEW") {
        sphere.emit("sphereopen");
    } else {
        sphere.emit("sphereclose");
    }

    return {
        type: "SET_WORLD_STATE",
        state: state
    };
};

var setSearchState = function setSearchState(state) {

    return {
        type: "SET_SEARCH_STATE",
        state: state
    };
};

var addSpace = function addSpace(name) {
    return {
        type: "ADD_SPACE",
        name: name
    };
};

var switchSpace = function switchSpace(id) {
    return {
        type: "SWITCH_SPACE",
        id: id
    };
};

var updateSpaceName = function updateSpaceName(name, id) {
    return {
        type: "UPDATE_SPACE_NAME",
        name: name,
        id: id
    };
};

var deleteSpace = function deleteSpace(id) {
    return {
        type: "DELETE_SPACE",
        id: id
    };
};

var moveBox = function moveBox(index, depth) {
    return {
        type: "MOVE_BOX",
        z: depth,
        index: index
    };
};

var addBox = function addBox(img, x, y) {
    var sphere = document.getElementById("small-sphere");
    sphere.emit("sphereclose");

    return {
        type: "ADD_IMAGE",
        image: img,

        x: x,
        y: y
    };
};

var setDrag = function setDrag(index, drag) {
    return {
        type: "SET_DRAG",
        index: index,
        drag: drag
    };
};

var saveDrag = function saveDrag(index, rotation) {
    return {
        type: "SAVE_DRAG",

        index: index,

        x: rotation.x,
        y: rotation.y
    };
};

var addText = function addText(text, x, y) {
    var sphere = document.getElementById("small-sphere");
    sphere.emit("sphereclose");

    return {
        type: "ADD_TEXT",
        text: text,

        x: x,
        y: y
    };
};

var rmvItem = function rmvItem(index) {
    return {
        type: "REMOVE_ITEM",

        index: index
    };
};

var clearItems = function clearItems(index) {
    return {
        type: "CLEAR_ALL"
    };
};

var stopInput = function stopInput() {

    return function (dispatch, getState) {

        switch (getState().globalState.worldView) {

            case "WORLD_INPUT":
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__microphone__["a" /* stopSpeech */])());
                break;

            case "WORLD_SELECT":
                dispatch(setWorldState("WORLD_VIEW"));
                break;

            case "WORLD_ICON":
                dispatch(setWorldState("WORLD_VIEW"));
                break;

            case "WORLD_KEYBOARD":
                dispatch(setWorldState("WORLD_VIEW"));
                break;

            default:
                break;
        }
    };
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Code = exports.errors = exports.FirebaseStorageError = undefined;
exports.prependCode = prependCode;
exports.unknown = unknown;
exports.objectNotFound = objectNotFound;
exports.bucketNotFound = bucketNotFound;
exports.projectNotFound = projectNotFound;
exports.quotaExceeded = quotaExceeded;
exports.unauthenticated = unauthenticated;
exports.unauthorized = unauthorized;
exports.retryLimitExceeded = retryLimitExceeded;
exports.invalidChecksum = invalidChecksum;
exports.canceled = canceled;
exports.invalidEventName = invalidEventName;
exports.invalidUrl = invalidUrl;
exports.invalidDefaultBucket = invalidDefaultBucket;
exports.noDefaultBucket = noDefaultBucket;
exports.cannotSliceBlob = cannotSliceBlob;
exports.serverFileWrongSize = serverFileWrongSize;
exports.noDownloadURL = noDownloadURL;
exports.invalidArgument = invalidArgument;
exports.invalidArgumentCount = invalidArgumentCount;
exports.appDeleted = appDeleted;
exports.invalidRootOperation = invalidRootOperation;
exports.invalidFormat = invalidFormat;
exports.internalError = internalError;

var _constants = __webpack_require__(84);

var FirebaseStorageError = /** @class */function () {
    function FirebaseStorageError(code, message) {
        this.code_ = prependCode(code);
        this.message_ = 'Firebase Storage: ' + message;
        this.serverResponse_ = null;
        this.name_ = 'FirebaseError';
    }
    FirebaseStorageError.prototype.codeProp = function () {
        return this.code;
    };
    FirebaseStorageError.prototype.codeEquals = function (code) {
        return prependCode(code) === this.codeProp();
    };
    FirebaseStorageError.prototype.serverResponseProp = function () {
        return this.serverResponse_;
    };
    FirebaseStorageError.prototype.setServerResponseProp = function (serverResponse) {
        this.serverResponse_ = serverResponse;
    };
    Object.defineProperty(FirebaseStorageError.prototype, "name", {
        get: function get() {
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "code", {
        get: function get() {
            return this.code_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "message", {
        get: function get() {
            return this.message_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "serverResponse", {
        get: function get() {
            return this.serverResponse_;
        },
        enumerable: true,
        configurable: true
    });
    return FirebaseStorageError;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.FirebaseStorageError = FirebaseStorageError;
var errors = exports.errors = {};
var Code = exports.Code = {
    // Shared between all platforms
    UNKNOWN: 'unknown',
    OBJECT_NOT_FOUND: 'object-not-found',
    BUCKET_NOT_FOUND: 'bucket-not-found',
    PROJECT_NOT_FOUND: 'project-not-found',
    QUOTA_EXCEEDED: 'quota-exceeded',
    UNAUTHENTICATED: 'unauthenticated',
    UNAUTHORIZED: 'unauthorized',
    RETRY_LIMIT_EXCEEDED: 'retry-limit-exceeded',
    INVALID_CHECKSUM: 'invalid-checksum',
    CANCELED: 'canceled',
    // JS specific
    INVALID_EVENT_NAME: 'invalid-event-name',
    INVALID_URL: 'invalid-url',
    INVALID_DEFAULT_BUCKET: 'invalid-default-bucket',
    NO_DEFAULT_BUCKET: 'no-default-bucket',
    CANNOT_SLICE_BLOB: 'cannot-slice-blob',
    SERVER_FILE_WRONG_SIZE: 'server-file-wrong-size',
    NO_DOWNLOAD_URL: 'no-download-url',
    INVALID_ARGUMENT: 'invalid-argument',
    INVALID_ARGUMENT_COUNT: 'invalid-argument-count',
    APP_DELETED: 'app-deleted',
    INVALID_ROOT_OPERATION: 'invalid-root-operation',
    INVALID_FORMAT: 'invalid-format',
    INTERNAL_ERROR: 'internal-error'
};
function prependCode(code) {
    return 'storage/' + code;
}
function unknown() {
    var message = 'An unknown error occurred, please check the error payload for ' + 'server response.';
    return new FirebaseStorageError(Code.UNKNOWN, message);
}
function objectNotFound(path) {
    return new FirebaseStorageError(Code.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function bucketNotFound(bucket) {
    return new FirebaseStorageError(Code.BUCKET_NOT_FOUND, "Bucket '" + bucket + "' does not exist.");
}
function projectNotFound(project) {
    return new FirebaseStorageError(Code.PROJECT_NOT_FOUND, "Project '" + project + "' does not exist.");
}
function quotaExceeded(bucket) {
    return new FirebaseStorageError(Code.QUOTA_EXCEEDED, "Quota for bucket '" + bucket + "' exceeded, please view quota on " + 'https://firebase.google.com/pricing/.');
}
function unauthenticated() {
    var message = 'User is not authenticated, please authenticate using Firebase ' + 'Authentication and try again.';
    return new FirebaseStorageError(Code.UNAUTHENTICATED, message);
}
function unauthorized(path) {
    return new FirebaseStorageError(Code.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function retryLimitExceeded() {
    return new FirebaseStorageError(Code.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
}
function invalidChecksum(path, checksum, calculated) {
    return new FirebaseStorageError(Code.INVALID_CHECKSUM, "Uploaded/downloaded object '" + path + "' has checksum '" + checksum + "' which does not match '" + calculated + "'. Please retry the upload/download.");
}
function canceled() {
    return new FirebaseStorageError(Code.CANCELED, 'User canceled the upload/download.');
}
function invalidEventName(name) {
    return new FirebaseStorageError(Code.INVALID_EVENT_NAME, "Invalid event name '" + name + "'.");
}
function invalidUrl(url) {
    return new FirebaseStorageError(Code.INVALID_URL, "Invalid URL '" + url + "'.");
}
function invalidDefaultBucket(bucket) {
    return new FirebaseStorageError(Code.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function noDefaultBucket() {
    return new FirebaseStorageError(Code.NO_DEFAULT_BUCKET, 'No default bucket ' + "found. Did you set the '" + _constants.configOption + "' property when initializing the app?");
}
function cannotSliceBlob() {
    return new FirebaseStorageError(Code.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
}
function serverFileWrongSize() {
    return new FirebaseStorageError(Code.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
}
function noDownloadURL() {
    return new FirebaseStorageError(Code.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
}
function invalidArgument(index, fnName, message) {
    return new FirebaseStorageError(Code.INVALID_ARGUMENT, 'Invalid argument in `' + fnName + '` at index ' + index + ': ' + message);
}
function invalidArgumentCount(argMin, argMax, fnName, real) {
    var countPart;
    var plural;
    if (argMin === argMax) {
        countPart = argMin;
        plural = argMin === 1 ? 'argument' : 'arguments';
    } else {
        countPart = 'between ' + argMin + ' and ' + argMax;
        plural = 'arguments';
    }
    return new FirebaseStorageError(Code.INVALID_ARGUMENT_COUNT, 'Invalid argument count in `' + fnName + '`: Expected ' + countPart + ' ' + plural + ', received ' + real + '.');
}
function appDeleted() {
    return new FirebaseStorageError(Code.APP_DELETED, 'The Firebase app was deleted.');
}
/**
 * @param name The name of the operation that was invalid.
 */
function invalidRootOperation(name) {
    return new FirebaseStorageError(Code.INVALID_ROOT_OPERATION, "The operation '" + name + "' cannot be performed on a root reference, create a non-root " + "reference using child, such as .child('file.png').");
}
/**
 * @param format The format that was not valid.
 * @param message A message describing the format violation.
 */
function invalidFormat(format, message) {
    return new FirebaseStorageError(Code.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message A message describing the internal error.
 */
function internalError(message) {
    throw new FirebaseStorageError(Code.INTERNAL_ERROR, 'Internal error: ' + message);
}
//# sourceMappingURL=error.js.map


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var PooledClass = __webpack_require__(41);

var emptyFunction = __webpack_require__(18);
var warning = __webpack_require__(4);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(521);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var Vec3 = __webpack_require__(0);
var Utils = __webpack_require__(60);

module.exports = AABB;

/**
 * Axis aligned bounding box class.
 * @class AABB
 * @constructor
 * @param {Object} [options]
 * @param {Vec3}   [options.upperBound]
 * @param {Vec3}   [options.lowerBound]
 */
function AABB(options){
    options = options || {};

    /**
     * The lower bound of the bounding box.
     * @property lowerBound
     * @type {Vec3}
     */
    this.lowerBound = new Vec3();
    if(options.lowerBound){
        this.lowerBound.copy(options.lowerBound);
    }

    /**
     * The upper bound of the bounding box.
     * @property upperBound
     * @type {Vec3}
     */
    this.upperBound = new Vec3();
    if(options.upperBound){
        this.upperBound.copy(options.upperBound);
    }
}

var tmp = new Vec3();

/**
 * Set the AABB bounds from a set of points.
 * @method setFromPoints
 * @param {Array} points An array of Vec3's.
 * @param {Vec3} position
 * @param {Quaternion} quaternion
 * @param {number} skinSize
 * @return {AABB} The self object
 */
AABB.prototype.setFromPoints = function(points, position, quaternion, skinSize){
    var l = this.lowerBound,
        u = this.upperBound,
        q = quaternion;

    // Set to the first point
    l.copy(points[0]);
    if(q){
        q.vmult(l, l);
    }
    u.copy(l);

    for(var i = 1; i<points.length; i++){
        var p = points[i];

        if(q){
            q.vmult(p, tmp);
            p = tmp;
        }

        if(p.x > u.x){ u.x = p.x; }
        if(p.x < l.x){ l.x = p.x; }
        if(p.y > u.y){ u.y = p.y; }
        if(p.y < l.y){ l.y = p.y; }
        if(p.z > u.z){ u.z = p.z; }
        if(p.z < l.z){ l.z = p.z; }
    }

    // Add offset
    if (position) {
        position.vadd(l, l);
        position.vadd(u, u);
    }

    if(skinSize){
        l.x -= skinSize;
        l.y -= skinSize;
        l.z -= skinSize;
        u.x += skinSize;
        u.y += skinSize;
        u.z += skinSize;
    }

    return this;
};

/**
 * Copy bounds from an AABB to this AABB
 * @method copy
 * @param  {AABB} aabb Source to copy from
 * @return {AABB} The this object, for chainability
 */
AABB.prototype.copy = function(aabb){
    this.lowerBound.copy(aabb.lowerBound);
    this.upperBound.copy(aabb.upperBound);
    return this;
};

/**
 * Clone an AABB
 * @method clone
 */
AABB.prototype.clone = function(){
    return new AABB().copy(this);
};

/**
 * Extend this AABB so that it covers the given AABB too.
 * @method extend
 * @param  {AABB} aabb
 */
AABB.prototype.extend = function(aabb){
    this.lowerBound.x = Math.min(this.lowerBound.x, aabb.lowerBound.x);
    this.upperBound.x = Math.max(this.upperBound.x, aabb.upperBound.x);
    this.lowerBound.y = Math.min(this.lowerBound.y, aabb.lowerBound.y);
    this.upperBound.y = Math.max(this.upperBound.y, aabb.upperBound.y);
    this.lowerBound.z = Math.min(this.lowerBound.z, aabb.lowerBound.z);
    this.upperBound.z = Math.max(this.upperBound.z, aabb.upperBound.z);
};

/**
 * Returns true if the given AABB overlaps this AABB.
 * @method overlaps
 * @param  {AABB} aabb
 * @return {Boolean}
 */
AABB.prototype.overlaps = function(aabb){
    var l1 = this.lowerBound,
        u1 = this.upperBound,
        l2 = aabb.lowerBound,
        u2 = aabb.upperBound;

    //      l2        u2
    //      |---------|
    // |--------|
    // l1       u1

    var overlapsX = ((l2.x <= u1.x && u1.x <= u2.x) || (l1.x <= u2.x && u2.x <= u1.x));
    var overlapsY = ((l2.y <= u1.y && u1.y <= u2.y) || (l1.y <= u2.y && u2.y <= u1.y));
    var overlapsZ = ((l2.z <= u1.z && u1.z <= u2.z) || (l1.z <= u2.z && u2.z <= u1.z));

    return overlapsX && overlapsY && overlapsZ;
};

// Mostly for debugging
AABB.prototype.volume = function(){
    var l = this.lowerBound,
        u = this.upperBound;
    return (u.x - l.x) * (u.y - l.y) * (u.z - l.z);
};


/**
 * Returns true if the given AABB is fully contained in this AABB.
 * @method contains
 * @param {AABB} aabb
 * @return {Boolean}
 */
AABB.prototype.contains = function(aabb){
    var l1 = this.lowerBound,
        u1 = this.upperBound,
        l2 = aabb.lowerBound,
        u2 = aabb.upperBound;

    //      l2        u2
    //      |---------|
    // |---------------|
    // l1              u1

    return (
        (l1.x <= l2.x && u1.x >= u2.x) &&
        (l1.y <= l2.y && u1.y >= u2.y) &&
        (l1.z <= l2.z && u1.z >= u2.z)
    );
};

/**
 * @method getCorners
 * @param {Vec3} a
 * @param {Vec3} b
 * @param {Vec3} c
 * @param {Vec3} d
 * @param {Vec3} e
 * @param {Vec3} f
 * @param {Vec3} g
 * @param {Vec3} h
 */
AABB.prototype.getCorners = function(a, b, c, d, e, f, g, h){
    var l = this.lowerBound,
        u = this.upperBound;

    a.copy(l);
    b.set( u.x, l.y, l.z );
    c.set( u.x, u.y, l.z );
    d.set( l.x, u.y, u.z );
    e.set( u.x, l.y, l.z );
    f.set( l.x, u.y, l.z );
    g.set( l.x, l.y, u.z );
    h.copy(u);
};

var transformIntoFrame_corners = [
    new Vec3(),
    new Vec3(),
    new Vec3(),
    new Vec3(),
    new Vec3(),
    new Vec3(),
    new Vec3(),
    new Vec3()
];

/**
 * Get the representation of an AABB in another frame.
 * @method toLocalFrame
 * @param  {Transform} frame
 * @param  {AABB} target
 * @return {AABB} The "target" AABB object.
 */
AABB.prototype.toLocalFrame = function(frame, target){

    var corners = transformIntoFrame_corners;
    var a = corners[0];
    var b = corners[1];
    var c = corners[2];
    var d = corners[3];
    var e = corners[4];
    var f = corners[5];
    var g = corners[6];
    var h = corners[7];

    // Get corners in current frame
    this.getCorners(a, b, c, d, e, f, g, h);

    // Transform them to new local frame
    for(var i=0; i !== 8; i++){
        var corner = corners[i];
        frame.pointToLocal(corner, corner);
    }

    return target.setFromPoints(corners);
};

/**
 * Get the representation of an AABB in the global frame.
 * @method toWorldFrame
 * @param  {Transform} frame
 * @param  {AABB} target
 * @return {AABB} The "target" AABB object.
 */
AABB.prototype.toWorldFrame = function(frame, target){

    var corners = transformIntoFrame_corners;
    var a = corners[0];
    var b = corners[1];
    var c = corners[2];
    var d = corners[3];
    var e = corners[4];
    var f = corners[5];
    var g = corners[6];
    var h = corners[7];

    // Get corners in current frame
    this.getCorners(a, b, c, d, e, f, g, h);

    // Transform them to new local frame
    for(var i=0; i !== 8; i++){
        var corner = corners[i];
        frame.pointToWorld(corner, corner);
    }

    return target.setFromPoints(corners);
};

/**
 * Check if the AABB is hit by a ray.
 * @param  {Ray} ray
 * @return {number}
 */
AABB.prototype.overlapsRay = function(ray){
    var t = 0;

    // ray.direction is unit direction vector of ray
    var dirFracX = 1 / ray._direction.x;
    var dirFracY = 1 / ray._direction.y;
    var dirFracZ = 1 / ray._direction.z;

    // this.lowerBound is the corner of AABB with minimal coordinates - left bottom, rt is maximal corner
    var t1 = (this.lowerBound.x - ray.from.x) * dirFracX;
    var t2 = (this.upperBound.x - ray.from.x) * dirFracX;
    var t3 = (this.lowerBound.y - ray.from.y) * dirFracY;
    var t4 = (this.upperBound.y - ray.from.y) * dirFracY;
    var t5 = (this.lowerBound.z - ray.from.z) * dirFracZ;
    var t6 = (this.upperBound.z - ray.from.z) * dirFracZ;

    // var tmin = Math.max(Math.max(Math.min(t1, t2), Math.min(t3, t4)));
    // var tmax = Math.min(Math.min(Math.max(t1, t2), Math.max(t3, t4)));
    var tmin = Math.max(Math.max(Math.min(t1, t2), Math.min(t3, t4)), Math.min(t5, t6));
    var tmax = Math.min(Math.min(Math.max(t1, t2), Math.max(t3, t4)), Math.max(t5, t6));

    // if tmax < 0, ray (line) is intersecting AABB, but whole AABB is behing us
    if (tmax < 0){
        //t = tmax;
        return false;
    }

    // if tmin > tmax, ray doesn't intersect AABB
    if (tmin > tmax){
        //t = tmax;
        return false;
    }

    return true;
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = ContactEquation;

var Equation = __webpack_require__(45);
var Vec3 = __webpack_require__(0);
var Mat3 = __webpack_require__(32);

/**
 * Contact/non-penetration constraint equation
 * @class ContactEquation
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @extends Equation
 */
function ContactEquation(bodyA, bodyB, maxForce){
    maxForce = typeof(maxForce) !== 'undefined' ? maxForce : 1e6;
    Equation.call(this, bodyA, bodyB, 0, maxForce);

    /**
     * @property restitution
     * @type {Number}
     */
    this.restitution = 0.0; // "bounciness": u1 = -e*u0

    /**
     * World-oriented vector that goes from the center of bi to the contact point.
     * @property {Vec3} ri
     */
    this.ri = new Vec3();

    /**
     * World-oriented vector that starts in body j position and goes to the contact point.
     * @property {Vec3} rj
     */
    this.rj = new Vec3();

    /**
     * Contact normal, pointing out of body i.
     * @property {Vec3} ni
     */
    this.ni = new Vec3();
}

ContactEquation.prototype = new Equation();
ContactEquation.prototype.constructor = ContactEquation;

var ContactEquation_computeB_temp1 = new Vec3(); // Temp vectors
var ContactEquation_computeB_temp2 = new Vec3();
var ContactEquation_computeB_temp3 = new Vec3();
ContactEquation.prototype.computeB = function(h){
    var a = this.a,
        b = this.b,
        bi = this.bi,
        bj = this.bj,
        ri = this.ri,
        rj = this.rj,
        rixn = ContactEquation_computeB_temp1,
        rjxn = ContactEquation_computeB_temp2,

        vi = bi.velocity,
        wi = bi.angularVelocity,
        fi = bi.force,
        taui = bi.torque,

        vj = bj.velocity,
        wj = bj.angularVelocity,
        fj = bj.force,
        tauj = bj.torque,

        penetrationVec = ContactEquation_computeB_temp3,

        GA = this.jacobianElementA,
        GB = this.jacobianElementB,

        n = this.ni;

    // Caluclate cross products
    ri.cross(n,rixn);
    rj.cross(n,rjxn);

    // g = xj+rj -(xi+ri)
    // G = [ -ni  -rixn  ni  rjxn ]
    n.negate(GA.spatial);
    rixn.negate(GA.rotational);
    GB.spatial.copy(n);
    GB.rotational.copy(rjxn);

    // Calculate the penetration vector
    penetrationVec.copy(bj.position);
    penetrationVec.vadd(rj,penetrationVec);
    penetrationVec.vsub(bi.position,penetrationVec);
    penetrationVec.vsub(ri,penetrationVec);

    var g = n.dot(penetrationVec);

    // Compute iteration
    var ePlusOne = this.restitution + 1;
    var GW = ePlusOne * vj.dot(n) - ePlusOne * vi.dot(n) + wj.dot(rjxn) - wi.dot(rixn);
    var GiMf = this.computeGiMf();

    var B = - g * a - GW * b - h*GiMf;

    return B;
};

var ContactEquation_getImpactVelocityAlongNormal_vi = new Vec3();
var ContactEquation_getImpactVelocityAlongNormal_vj = new Vec3();
var ContactEquation_getImpactVelocityAlongNormal_xi = new Vec3();
var ContactEquation_getImpactVelocityAlongNormal_xj = new Vec3();
var ContactEquation_getImpactVelocityAlongNormal_relVel = new Vec3();

/**
 * Get the current relative velocity in the contact point.
 * @method getImpactVelocityAlongNormal
 * @return {number}
 */
ContactEquation.prototype.getImpactVelocityAlongNormal = function(){
    var vi = ContactEquation_getImpactVelocityAlongNormal_vi;
    var vj = ContactEquation_getImpactVelocityAlongNormal_vj;
    var xi = ContactEquation_getImpactVelocityAlongNormal_xi;
    var xj = ContactEquation_getImpactVelocityAlongNormal_xj;
    var relVel = ContactEquation_getImpactVelocityAlongNormal_relVel;

    this.bi.position.vadd(this.ri, xi);
    this.bj.position.vadd(this.rj, xj);

    this.bi.getVelocityAtWorldPoint(xi, vi);
    this.bj.getVelocityAtWorldPoint(xj, vj);

    vi.vsub(vj, relVel);

    return this.ni.dot(relVel);
};



/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Mat3;

var Vec3 = __webpack_require__(0);

/**
 * A 3x3 matrix.
 * @class Mat3
 * @constructor
 * @param array elements Array of nine elements. Optional.
 * @author schteppe / http://github.com/schteppe
 */
function Mat3(elements){
    /**
     * A vector of length 9, containing all matrix elements
     * @property {Array} elements
     */
    if(elements){
        this.elements = elements;
    } else {
        this.elements = [0,0,0,0,0,0,0,0,0];
    }
}

/**
 * Sets the matrix to identity
 * @method identity
 * @todo Should perhaps be renamed to setIdentity() to be more clear.
 * @todo Create another function that immediately creates an identity matrix eg. eye()
 */
Mat3.prototype.identity = function(){
    var e = this.elements;
    e[0] = 1;
    e[1] = 0;
    e[2] = 0;

    e[3] = 0;
    e[4] = 1;
    e[5] = 0;

    e[6] = 0;
    e[7] = 0;
    e[8] = 1;
};

/**
 * Set all elements to zero
 * @method setZero
 */
Mat3.prototype.setZero = function(){
    var e = this.elements;
    e[0] = 0;
    e[1] = 0;
    e[2] = 0;
    e[3] = 0;
    e[4] = 0;
    e[5] = 0;
    e[6] = 0;
    e[7] = 0;
    e[8] = 0;
};

/**
 * Sets the matrix diagonal elements from a Vec3
 * @method setTrace
 * @param {Vec3} vec3
 */
Mat3.prototype.setTrace = function(vec3){
    var e = this.elements;
    e[0] = vec3.x;
    e[4] = vec3.y;
    e[8] = vec3.z;
};

/**
 * Gets the matrix diagonal elements
 * @method getTrace
 * @return {Vec3}
 */
Mat3.prototype.getTrace = function(target){
    var target = target || new Vec3();
    var e = this.elements;
    target.x = e[0];
    target.y = e[4];
    target.z = e[8];
};

/**
 * Matrix-Vector multiplication
 * @method vmult
 * @param {Vec3} v The vector to multiply with
 * @param {Vec3} target Optional, target to save the result in.
 */
Mat3.prototype.vmult = function(v,target){
    target = target || new Vec3();

    var e = this.elements,
        x = v.x,
        y = v.y,
        z = v.z;
    target.x = e[0]*x + e[1]*y + e[2]*z;
    target.y = e[3]*x + e[4]*y + e[5]*z;
    target.z = e[6]*x + e[7]*y + e[8]*z;

    return target;
};

/**
 * Matrix-scalar multiplication
 * @method smult
 * @param {Number} s
 */
Mat3.prototype.smult = function(s){
    for(var i=0; i<this.elements.length; i++){
        this.elements[i] *= s;
    }
};

/**
 * Matrix multiplication
 * @method mmult
 * @param {Mat3} m Matrix to multiply with from left side.
 * @return {Mat3} The result.
 */
Mat3.prototype.mmult = function(m,target){
    var r = target || new Mat3();
    for(var i=0; i<3; i++){
        for(var j=0; j<3; j++){
            var sum = 0.0;
            for(var k=0; k<3; k++){
                sum += m.elements[i+k*3] * this.elements[k+j*3];
            }
            r.elements[i+j*3] = sum;
        }
    }
    return r;
};

/**
 * Scale each column of the matrix
 * @method scale
 * @param {Vec3} v
 * @return {Mat3} The result.
 */
Mat3.prototype.scale = function(v,target){
    target = target || new Mat3();
    var e = this.elements,
        t = target.elements;
    for(var i=0; i!==3; i++){
        t[3*i + 0] = v.x * e[3*i + 0];
        t[3*i + 1] = v.y * e[3*i + 1];
        t[3*i + 2] = v.z * e[3*i + 2];
    }
    return target;
};

/**
 * Solve Ax=b
 * @method solve
 * @param {Vec3} b The right hand side
 * @param {Vec3} target Optional. Target vector to save in.
 * @return {Vec3} The solution x
 * @todo should reuse arrays
 */
Mat3.prototype.solve = function(b,target){
    target = target || new Vec3();

    // Construct equations
    var nr = 3; // num rows
    var nc = 4; // num cols
    var eqns = [];
    for(var i=0; i<nr*nc; i++){
        eqns.push(0);
    }
    var i,j;
    for(i=0; i<3; i++){
        for(j=0; j<3; j++){
            eqns[i+nc*j] = this.elements[i+3*j];
        }
    }
    eqns[3+4*0] = b.x;
    eqns[3+4*1] = b.y;
    eqns[3+4*2] = b.z;

    // Compute right upper triangular version of the matrix - Gauss elimination
    var n = 3, k = n, np;
    var kp = 4; // num rows
    var p, els;
    do {
        i = k - n;
        if (eqns[i+nc*i] === 0) {
            // the pivot is null, swap lines
            for (j = i + 1; j < k; j++) {
                if (eqns[i+nc*j] !== 0) {
                    np = kp;
                    do {  // do ligne( i ) = ligne( i ) + ligne( k )
                        p = kp - np;
                        eqns[p+nc*i] += eqns[p+nc*j];
                    } while (--np);
                    break;
                }
            }
        }
        if (eqns[i+nc*i] !== 0) {
            for (j = i + 1; j < k; j++) {
                var multiplier = eqns[i+nc*j] / eqns[i+nc*i];
                np = kp;
                do {  // do ligne( k ) = ligne( k ) - multiplier * ligne( i )
                    p = kp - np;
                    eqns[p+nc*j] = p <= i ? 0 : eqns[p+nc*j] - eqns[p+nc*i] * multiplier ;
                } while (--np);
            }
        }
    } while (--n);

    // Get the solution
    target.z = eqns[2*nc+3] / eqns[2*nc+2];
    target.y = (eqns[1*nc+3] - eqns[1*nc+2]*target.z) / eqns[1*nc+1];
    target.x = (eqns[0*nc+3] - eqns[0*nc+2]*target.z - eqns[0*nc+1]*target.y) / eqns[0*nc+0];

    if(isNaN(target.x) || isNaN(target.y) || isNaN(target.z) || target.x===Infinity || target.y===Infinity || target.z===Infinity){
        throw "Could not solve equation! Got x=["+target.toString()+"], b=["+b.toString()+"], A=["+this.toString()+"]";
    }

    return target;
};

/**
 * Get an element in the matrix by index. Index starts at 0, not 1!!!
 * @method e
 * @param {Number} row
 * @param {Number} column
 * @param {Number} value Optional. If provided, the matrix element will be set to this value.
 * @return {Number}
 */
Mat3.prototype.e = function( row , column ,value){
    if(value===undefined){
        return this.elements[column+3*row];
    } else {
        // Set value
        this.elements[column+3*row] = value;
    }
};

/**
 * Copy another matrix into this matrix object.
 * @method copy
 * @param {Mat3} source
 * @return {Mat3} this
 */
Mat3.prototype.copy = function(source){
    for(var i=0; i < source.elements.length; i++){
        this.elements[i] = source.elements[i];
    }
    return this;
};

/**
 * Returns a string representation of the matrix.
 * @method toString
 * @return string
 */
Mat3.prototype.toString = function(){
    var r = "";
    var sep = ",";
    for(var i=0; i<9; i++){
        r += this.elements[i] + sep;
    }
    return r;
};

/**
 * reverse the matrix
 * @method reverse
 * @param {Mat3} target Optional. Target matrix to save in.
 * @return {Mat3} The solution x
 */
Mat3.prototype.reverse = function(target){

    target = target || new Mat3();

    // Construct equations
    var nr = 3; // num rows
    var nc = 6; // num cols
    var eqns = [];
    for(var i=0; i<nr*nc; i++){
        eqns.push(0);
    }
    var i,j;
    for(i=0; i<3; i++){
        for(j=0; j<3; j++){
            eqns[i+nc*j] = this.elements[i+3*j];
        }
    }
    eqns[3+6*0] = 1;
    eqns[3+6*1] = 0;
    eqns[3+6*2] = 0;
    eqns[4+6*0] = 0;
    eqns[4+6*1] = 1;
    eqns[4+6*2] = 0;
    eqns[5+6*0] = 0;
    eqns[5+6*1] = 0;
    eqns[5+6*2] = 1;

    // Compute right upper triangular version of the matrix - Gauss elimination
    var n = 3, k = n, np;
    var kp = nc; // num rows
    var p;
    do {
        i = k - n;
        if (eqns[i+nc*i] === 0) {
            // the pivot is null, swap lines
            for (j = i + 1; j < k; j++) {
                if (eqns[i+nc*j] !== 0) {
                    np = kp;
                    do { // do line( i ) = line( i ) + line( k )
                        p = kp - np;
                        eqns[p+nc*i] += eqns[p+nc*j];
                    } while (--np);
                    break;
                }
            }
        }
        if (eqns[i+nc*i] !== 0) {
            for (j = i + 1; j < k; j++) {
                var multiplier = eqns[i+nc*j] / eqns[i+nc*i];
                np = kp;
                do { // do line( k ) = line( k ) - multiplier * line( i )
                    p = kp - np;
                    eqns[p+nc*j] = p <= i ? 0 : eqns[p+nc*j] - eqns[p+nc*i] * multiplier ;
                } while (--np);
            }
        }
    } while (--n);

    // eliminate the upper left triangle of the matrix
    i = 2;
    do {
        j = i-1;
        do {
            var multiplier = eqns[i+nc*j] / eqns[i+nc*i];
            np = nc;
            do {
                p = nc - np;
                eqns[p+nc*j] =  eqns[p+nc*j] - eqns[p+nc*i] * multiplier ;
            } while (--np);
        } while (j--);
    } while (--i);

    // operations on the diagonal
    i = 2;
    do {
        var multiplier = 1 / eqns[i+nc*i];
        np = nc;
        do {
            p = nc - np;
            eqns[p+nc*i] = eqns[p+nc*i] * multiplier ;
        } while (--np);
    } while (i--);

    i = 2;
    do {
        j = 2;
        do {
            p = eqns[nr+j+nc*i];
            if( isNaN( p ) || p ===Infinity ){
                throw "Could not reverse! A=["+this.toString()+"]";
            }
            target.e( i , j , p );
        } while (j--);
    } while (i--);

    return target;
};

/**
 * Set the matrix from a quaterion
 * @method setRotationFromQuaternion
 * @param {Quaternion} q
 */
Mat3.prototype.setRotationFromQuaternion = function( q ) {
    var x = q.x, y = q.y, z = q.z, w = q.w,
        x2 = x + x, y2 = y + y, z2 = z + z,
        xx = x * x2, xy = x * y2, xz = x * z2,
        yy = y * y2, yz = y * z2, zz = z * z2,
        wx = w * x2, wy = w * y2, wz = w * z2,
        e = this.elements;

    e[3*0 + 0] = 1 - ( yy + zz );
    e[3*0 + 1] = xy - wz;
    e[3*0 + 2] = xz + wy;

    e[3*1 + 0] = xy + wz;
    e[3*1 + 1] = 1 - ( xx + zz );
    e[3*1 + 2] = yz - wx;

    e[3*2 + 0] = xz - wy;
    e[3*2 + 1] = yz + wx;
    e[3*2 + 2] = 1 - ( xx + yy );

    return this;
};

/**
 * Transpose the matrix
 * @method transpose
 * @param  {Mat3} target Where to store the result.
 * @return {Mat3} The target Mat3, or a new Mat3 if target was omitted.
 */
Mat3.prototype.transpose = function( target ) {
    target = target || new Mat3();

    var Mt = target.elements,
        M = this.elements;

    for(var i=0; i!==3; i++){
        for(var j=0; j!==3; j++){
            Mt[3*i + j] = M[3*j + i];
        }
    }

    return target;
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Body;

var EventTarget = __webpack_require__(101);
var Shape = __webpack_require__(12);
var Vec3 = __webpack_require__(0);
var Mat3 = __webpack_require__(32);
var Quaternion = __webpack_require__(13);
var Material = __webpack_require__(59);
var AABB = __webpack_require__(30);
var Box = __webpack_require__(73);

/**
 * Base class for all body types.
 * @class Body
 * @constructor
 * @extends EventTarget
 * @param {object} [options]
 * @param {Vec3} [options.position]
 * @param {Vec3} [options.velocity]
 * @param {Vec3} [options.angularVelocity]
 * @param {Quaternion} [options.quaternion]
 * @param {number} [options.mass]
 * @param {Material} [options.material]
 * @param {number} [options.type]
 * @param {number} [options.linearDamping=0.01]
 * @param {number} [options.angularDamping=0.01]
 * @param {boolean} [options.allowSleep=true]
 * @param {number} [options.sleepSpeedLimit=0.1]
 * @param {number} [options.sleepTimeLimit=1]
 * @param {number} [options.collisionFilterGroup=1]
 * @param {number} [options.collisionFilterMask=1]
 * @param {boolean} [options.fixedRotation=false]
 * @param {Vec3} [options.linearFactor]
 * @param {Vec3} [options.angularFactor]
 * @param {Shape} [options.shape]
 * @example
 *     var body = new Body({
 *         mass: 1
 *     });
 *     var shape = new Sphere(1);
 *     body.addShape(shape);
 *     world.addBody(body);
 */
function Body(options){
    options = options || {};

    EventTarget.apply(this);

    this.id = Body.idCounter++;

    /**
     * Reference to the world the body is living in
     * @property world
     * @type {World}
     */
    this.world = null;

    /**
     * Callback function that is used BEFORE stepping the system. Use it to apply forces, for example. Inside the function, "this" will refer to this Body object.
     * @property preStep
     * @type {Function}
     * @deprecated Use World events instead
     */
    this.preStep = null;

    /**
     * Callback function that is used AFTER stepping the system. Inside the function, "this" will refer to this Body object.
     * @property postStep
     * @type {Function}
     * @deprecated Use World events instead
     */
    this.postStep = null;

    this.vlambda = new Vec3();

    /**
     * @property {Number} collisionFilterGroup
     */
    this.collisionFilterGroup = typeof(options.collisionFilterGroup) === 'number' ? options.collisionFilterGroup : 1;

    /**
     * @property {Number} collisionFilterMask
     */
    this.collisionFilterMask = typeof(options.collisionFilterMask) === 'number' ? options.collisionFilterMask : 1;

    /**
     * Whether to produce contact forces when in contact with other bodies. Note that contacts will be generated, but they will be disabled.
     * @property {Number} collisionResponse
     */
	this.collisionResponse = true;

    /**
     * @property position
     * @type {Vec3}
     */
    this.position = new Vec3();

    /**
     * @property {Vec3} previousPosition
     */
    this.previousPosition = new Vec3();

    /**
     * Interpolated position of the body.
     * @property {Vec3} interpolatedPosition
     */
    this.interpolatedPosition = new Vec3();

    /**
     * Initial position of the body
     * @property initPosition
     * @type {Vec3}
     */
    this.initPosition = new Vec3();

    if(options.position){
        this.position.copy(options.position);
        this.previousPosition.copy(options.position);
        this.interpolatedPosition.copy(options.position);
        this.initPosition.copy(options.position);
    }

    /**
     * @property velocity
     * @type {Vec3}
     */
    this.velocity = new Vec3();

    if(options.velocity){
        this.velocity.copy(options.velocity);
    }

    /**
     * @property initVelocity
     * @type {Vec3}
     */
    this.initVelocity = new Vec3();

    /**
     * Linear force on the body
     * @property force
     * @type {Vec3}
     */
    this.force = new Vec3();

    var mass = typeof(options.mass) === 'number' ? options.mass : 0;

    /**
     * @property mass
     * @type {Number}
     * @default 0
     */
    this.mass = mass;

    /**
     * @property invMass
     * @type {Number}
     */
    this.invMass = mass > 0 ? 1.0 / mass : 0;

    /**
     * @property material
     * @type {Material}
     */
    this.material = options.material || null;

    /**
     * @property linearDamping
     * @type {Number}
     */
    this.linearDamping = typeof(options.linearDamping) === 'number' ? options.linearDamping : 0.01;

    /**
     * One of: Body.DYNAMIC, Body.STATIC and Body.KINEMATIC.
     * @property type
     * @type {Number}
     */
    this.type = (mass <= 0.0 ? Body.STATIC : Body.DYNAMIC);
    if(typeof(options.type) === typeof(Body.STATIC)){
        this.type = options.type;
    }

    /**
     * If true, the body will automatically fall to sleep.
     * @property allowSleep
     * @type {Boolean}
     * @default true
     */
    this.allowSleep = typeof(options.allowSleep) !== 'undefined' ? options.allowSleep : true;

    /**
     * Current sleep state.
     * @property sleepState
     * @type {Number}
     */
    this.sleepState = 0;

    /**
     * If the speed (the norm of the velocity) is smaller than this value, the body is considered sleepy.
     * @property sleepSpeedLimit
     * @type {Number}
     * @default 0.1
     */
    this.sleepSpeedLimit = typeof(options.sleepSpeedLimit) !== 'undefined' ? options.sleepSpeedLimit : 0.1;

    /**
     * If the body has been sleepy for this sleepTimeLimit seconds, it is considered sleeping.
     * @property sleepTimeLimit
     * @type {Number}
     * @default 1
     */
    this.sleepTimeLimit = typeof(options.sleepTimeLimit) !== 'undefined' ? options.sleepTimeLimit : 1;

    this.timeLastSleepy = 0;

    this._wakeUpAfterNarrowphase = false;


    /**
     * Rotational force on the body, around center of mass
     * @property {Vec3} torque
     */
    this.torque = new Vec3();

    /**
     * Orientation of the body
     * @property quaternion
     * @type {Quaternion}
     */
    this.quaternion = new Quaternion();

    /**
     * @property initQuaternion
     * @type {Quaternion}
     */
    this.initQuaternion = new Quaternion();

    /**
     * @property {Quaternion} previousQuaternion
     */
    this.previousQuaternion = new Quaternion();

    /**
     * Interpolated orientation of the body.
     * @property {Quaternion} interpolatedQuaternion
     */
    this.interpolatedQuaternion = new Quaternion();

    if(options.quaternion){
        this.quaternion.copy(options.quaternion);
        this.initQuaternion.copy(options.quaternion);
        this.previousQuaternion.copy(options.quaternion);
        this.interpolatedQuaternion.copy(options.quaternion);
    }

    /**
     * @property angularVelocity
     * @type {Vec3}
     */
    this.angularVelocity = new Vec3();

    if(options.angularVelocity){
        this.angularVelocity.copy(options.angularVelocity);
    }

    /**
     * @property initAngularVelocity
     * @type {Vec3}
     */
    this.initAngularVelocity = new Vec3();

    /**
     * @property shapes
     * @type {array}
     */
    this.shapes = [];

    /**
     * @property shapeOffsets
     * @type {array}
     */
    this.shapeOffsets = [];

    /**
     * @property shapeOrientations
     * @type {array}
     */
    this.shapeOrientations = [];

    /**
     * @property inertia
     * @type {Vec3}
     */
    this.inertia = new Vec3();

    /**
     * @property {Vec3} invInertia
     */
    this.invInertia = new Vec3();

    /**
     * @property {Mat3} invInertiaWorld
     */
    this.invInertiaWorld = new Mat3();

    this.invMassSolve = 0;

    /**
     * @property {Vec3} invInertiaSolve
     */
    this.invInertiaSolve = new Vec3();

    /**
     * @property {Mat3} invInertiaWorldSolve
     */
    this.invInertiaWorldSolve = new Mat3();

    /**
     * Set to true if you don't want the body to rotate. Make sure to run .updateMassProperties() after changing this.
     * @property {Boolean} fixedRotation
     * @default false
     */
    this.fixedRotation = typeof(options.fixedRotation) !== "undefined" ? options.fixedRotation : false;

    /**
     * @property {Number} angularDamping
     */
    this.angularDamping = typeof(options.angularDamping) !== 'undefined' ? options.angularDamping : 0.01;

    /**
     * @property {Vec3} linearFactor
     */
    this.linearFactor = new Vec3(1,1,1);
    if(options.linearFactor){
        this.linearFactor.copy(options.linearFactor);
    }

    /**
     * @property {Vec3} angularFactor
     */
    this.angularFactor = new Vec3(1,1,1);
    if(options.angularFactor){
        this.angularFactor.copy(options.angularFactor);
    }

    /**
     * @property aabb
     * @type {AABB}
     */
    this.aabb = new AABB();

    /**
     * Indicates if the AABB needs to be updated before use.
     * @property aabbNeedsUpdate
     * @type {Boolean}
     */
    this.aabbNeedsUpdate = true;

    this.wlambda = new Vec3();

    if(options.shape){
        this.addShape(options.shape);
    }

    this.updateMassProperties();
}
Body.prototype = new EventTarget();
Body.prototype.constructor = Body;

/**
 * Dispatched after two bodies collide. This event is dispatched on each
 * of the two bodies involved in the collision.
 * @event collide
 * @param {Body} body The body that was involved in the collision.
 * @param {ContactEquation} contact The details of the collision.
 */
Body.COLLIDE_EVENT_NAME = "collide";

/**
 * A dynamic body is fully simulated. Can be moved manually by the user, but normally they move according to forces. A dynamic body can collide with all body types. A dynamic body always has finite, non-zero mass.
 * @static
 * @property DYNAMIC
 * @type {Number}
 */
Body.DYNAMIC = 1;

/**
 * A static body does not move during simulation and behaves as if it has infinite mass. Static bodies can be moved manually by setting the position of the body. The velocity of a static body is always zero. Static bodies do not collide with other static or kinematic bodies.
 * @static
 * @property STATIC
 * @type {Number}
 */
Body.STATIC = 2;

/**
 * A kinematic body moves under simulation according to its velocity. They do not respond to forces. They can be moved manually, but normally a kinematic body is moved by setting its velocity. A kinematic body behaves as if it has infinite mass. Kinematic bodies do not collide with other static or kinematic bodies.
 * @static
 * @property KINEMATIC
 * @type {Number}
 */
Body.KINEMATIC = 4;



/**
 * @static
 * @property AWAKE
 * @type {number}
 */
Body.AWAKE = 0;

/**
 * @static
 * @property SLEEPY
 * @type {number}
 */
Body.SLEEPY = 1;

/**
 * @static
 * @property SLEEPING
 * @type {number}
 */
Body.SLEEPING = 2;

Body.idCounter = 0;

/**
 * Dispatched after a sleeping body has woken up.
 * @event wakeup
 */
Body.wakeupEvent = {
    type: "wakeup"
};

/**
 * Wake the body up.
 * @method wakeUp
 */
Body.prototype.wakeUp = function(){
    var s = this.sleepState;
    this.sleepState = 0;
    this._wakeUpAfterNarrowphase = false;
    if(s === Body.SLEEPING){
        this.dispatchEvent(Body.wakeupEvent);
    }
};

/**
 * Force body sleep
 * @method sleep
 */
Body.prototype.sleep = function(){
    this.sleepState = Body.SLEEPING;
    this.velocity.set(0,0,0);
    this.angularVelocity.set(0,0,0);
    this._wakeUpAfterNarrowphase = false;
};

/**
 * Dispatched after a body has gone in to the sleepy state.
 * @event sleepy
 */
Body.sleepyEvent = {
    type: "sleepy"
};

/**
 * Dispatched after a body has fallen asleep.
 * @event sleep
 */
Body.sleepEvent = {
    type: "sleep"
};

/**
 * Called every timestep to update internal sleep timer and change sleep state if needed.
 * @method sleepTick
 * @param {Number} time The world time in seconds
 */
Body.prototype.sleepTick = function(time){
    if(this.allowSleep){
        var sleepState = this.sleepState;
        var speedSquared = this.velocity.norm2() + this.angularVelocity.norm2();
        var speedLimitSquared = Math.pow(this.sleepSpeedLimit,2);
        if(sleepState===Body.AWAKE && speedSquared < speedLimitSquared){
            this.sleepState = Body.SLEEPY; // Sleepy
            this.timeLastSleepy = time;
            this.dispatchEvent(Body.sleepyEvent);
        } else if(sleepState===Body.SLEEPY && speedSquared > speedLimitSquared){
            this.wakeUp(); // Wake up
        } else if(sleepState===Body.SLEEPY && (time - this.timeLastSleepy ) > this.sleepTimeLimit){
            this.sleep(); // Sleeping
            this.dispatchEvent(Body.sleepEvent);
        }
    }
};

/**
 * If the body is sleeping, it should be immovable / have infinite mass during solve. We solve it by having a separate "solve mass".
 * @method updateSolveMassProperties
 */
Body.prototype.updateSolveMassProperties = function(){
    if(this.sleepState === Body.SLEEPING || this.type === Body.KINEMATIC){
        this.invMassSolve = 0;
        this.invInertiaSolve.setZero();
        this.invInertiaWorldSolve.setZero();
    } else {
        this.invMassSolve = this.invMass;
        this.invInertiaSolve.copy(this.invInertia);
        this.invInertiaWorldSolve.copy(this.invInertiaWorld);
    }
};

/**
 * Convert a world point to local body frame.
 * @method pointToLocalFrame
 * @param  {Vec3} worldPoint
 * @param  {Vec3} result
 * @return {Vec3}
 */
Body.prototype.pointToLocalFrame = function(worldPoint,result){
    var result = result || new Vec3();
    worldPoint.vsub(this.position,result);
    this.quaternion.conjugate().vmult(result,result);
    return result;
};

/**
 * Convert a world vector to local body frame.
 * @method vectorToLocalFrame
 * @param  {Vec3} worldPoint
 * @param  {Vec3} result
 * @return {Vec3}
 */
Body.prototype.vectorToLocalFrame = function(worldVector, result){
    var result = result || new Vec3();
    this.quaternion.conjugate().vmult(worldVector,result);
    return result;
};

/**
 * Convert a local body point to world frame.
 * @method pointToWorldFrame
 * @param  {Vec3} localPoint
 * @param  {Vec3} result
 * @return {Vec3}
 */
Body.prototype.pointToWorldFrame = function(localPoint,result){
    var result = result || new Vec3();
    this.quaternion.vmult(localPoint,result);
    result.vadd(this.position,result);
    return result;
};

/**
 * Convert a local body point to world frame.
 * @method vectorToWorldFrame
 * @param  {Vec3} localVector
 * @param  {Vec3} result
 * @return {Vec3}
 */
Body.prototype.vectorToWorldFrame = function(localVector, result){
    var result = result || new Vec3();
    this.quaternion.vmult(localVector, result);
    return result;
};

var tmpVec = new Vec3();
var tmpQuat = new Quaternion();

/**
 * Add a shape to the body with a local offset and orientation.
 * @method addShape
 * @param {Shape} shape
 * @param {Vec3} [_offset]
 * @param {Quaternion} [_orientation]
 * @return {Body} The body object, for chainability.
 */
Body.prototype.addShape = function(shape, _offset, _orientation){
    var offset = new Vec3();
    var orientation = new Quaternion();

    if(_offset){
        offset.copy(_offset);
    }
    if(_orientation){
        orientation.copy(_orientation);
    }

    this.shapes.push(shape);
    this.shapeOffsets.push(offset);
    this.shapeOrientations.push(orientation);
    this.updateMassProperties();
    this.updateBoundingRadius();

    this.aabbNeedsUpdate = true;

    shape.body = this;

    return this;
};

/**
 * Update the bounding radius of the body. Should be done if any of the shapes are changed.
 * @method updateBoundingRadius
 */
Body.prototype.updateBoundingRadius = function(){
    var shapes = this.shapes,
        shapeOffsets = this.shapeOffsets,
        N = shapes.length,
        radius = 0;

    for(var i=0; i!==N; i++){
        var shape = shapes[i];
        shape.updateBoundingSphereRadius();
        var offset = shapeOffsets[i].norm(),
            r = shape.boundingSphereRadius;
        if(offset + r > radius){
            radius = offset + r;
        }
    }

    this.boundingRadius = radius;
};

var computeAABB_shapeAABB = new AABB();

/**
 * Updates the .aabb
 * @method computeAABB
 * @todo rename to updateAABB()
 */
Body.prototype.computeAABB = function(){
    var shapes = this.shapes,
        shapeOffsets = this.shapeOffsets,
        shapeOrientations = this.shapeOrientations,
        N = shapes.length,
        offset = tmpVec,
        orientation = tmpQuat,
        bodyQuat = this.quaternion,
        aabb = this.aabb,
        shapeAABB = computeAABB_shapeAABB;

    for(var i=0; i!==N; i++){
        var shape = shapes[i];

        // Get shape world position
        bodyQuat.vmult(shapeOffsets[i], offset);
        offset.vadd(this.position, offset);

        // Get shape world quaternion
        shapeOrientations[i].mult(bodyQuat, orientation);

        // Get shape AABB
        shape.calculateWorldAABB(offset, orientation, shapeAABB.lowerBound, shapeAABB.upperBound);

        if(i === 0){
            aabb.copy(shapeAABB);
        } else {
            aabb.extend(shapeAABB);
        }
    }

    this.aabbNeedsUpdate = false;
};

var uiw_m1 = new Mat3(),
    uiw_m2 = new Mat3(),
    uiw_m3 = new Mat3();

/**
 * Update .inertiaWorld and .invInertiaWorld
 * @method updateInertiaWorld
 */
Body.prototype.updateInertiaWorld = function(force){
    var I = this.invInertia;
    if (I.x === I.y && I.y === I.z && !force) {
        // If inertia M = s*I, where I is identity and s a scalar, then
        //    R*M*R' = R*(s*I)*R' = s*R*I*R' = s*R*R' = s*I = M
        // where R is the rotation matrix.
        // In other words, we don't have to transform the inertia if all
        // inertia diagonal entries are equal.
    } else {
        var m1 = uiw_m1,
            m2 = uiw_m2,
            m3 = uiw_m3;
        m1.setRotationFromQuaternion(this.quaternion);
        m1.transpose(m2);
        m1.scale(I,m1);
        m1.mmult(m2,this.invInertiaWorld);
    }
};

/**
 * Apply force to a world point. This could for example be a point on the Body surface. Applying force this way will add to Body.force and Body.torque.
 * @method applyForce
 * @param  {Vec3} force The amount of force to add.
 * @param  {Vec3} relativePoint A point relative to the center of mass to apply the force on.
 */
var Body_applyForce_r = new Vec3();
var Body_applyForce_rotForce = new Vec3();
Body.prototype.applyForce = function(force,relativePoint){
    if(this.type !== Body.DYNAMIC){ // Needed?
        return;
    }

    // Compute produced rotational force
    var rotForce = Body_applyForce_rotForce;
    relativePoint.cross(force,rotForce);

    // Add linear force
    this.force.vadd(force,this.force);

    // Add rotational force
    this.torque.vadd(rotForce,this.torque);
};

/**
 * Apply force to a local point in the body.
 * @method applyLocalForce
 * @param  {Vec3} force The force vector to apply, defined locally in the body frame.
 * @param  {Vec3} localPoint A local point in the body to apply the force on.
 */
var Body_applyLocalForce_worldForce = new Vec3();
var Body_applyLocalForce_relativePointWorld = new Vec3();
Body.prototype.applyLocalForce = function(localForce, localPoint){
    if(this.type !== Body.DYNAMIC){
        return;
    }

    var worldForce = Body_applyLocalForce_worldForce;
    var relativePointWorld = Body_applyLocalForce_relativePointWorld;

    // Transform the force vector to world space
    this.vectorToWorldFrame(localForce, worldForce);
    this.vectorToWorldFrame(localPoint, relativePointWorld);

    this.applyForce(worldForce, relativePointWorld);
};

/**
 * Apply impulse to a world point. This could for example be a point on the Body surface. An impulse is a force added to a body during a short period of time (impulse = force * time). Impulses will be added to Body.velocity and Body.angularVelocity.
 * @method applyImpulse
 * @param  {Vec3} impulse The amount of impulse to add.
 * @param  {Vec3} relativePoint A point relative to the center of mass to apply the force on.
 */
var Body_applyImpulse_r = new Vec3();
var Body_applyImpulse_velo = new Vec3();
var Body_applyImpulse_rotVelo = new Vec3();
Body.prototype.applyImpulse = function(impulse, relativePoint){
    if(this.type !== Body.DYNAMIC){
        return;
    }

    // Compute point position relative to the body center
    var r = relativePoint;

    // Compute produced central impulse velocity
    var velo = Body_applyImpulse_velo;
    velo.copy(impulse);
    velo.mult(this.invMass,velo);

    // Add linear impulse
    this.velocity.vadd(velo, this.velocity);

    // Compute produced rotational impulse velocity
    var rotVelo = Body_applyImpulse_rotVelo;
    r.cross(impulse,rotVelo);

    /*
    rotVelo.x *= this.invInertia.x;
    rotVelo.y *= this.invInertia.y;
    rotVelo.z *= this.invInertia.z;
    */
    this.invInertiaWorld.vmult(rotVelo,rotVelo);

    // Add rotational Impulse
    this.angularVelocity.vadd(rotVelo, this.angularVelocity);
};

/**
 * Apply locally-defined impulse to a local point in the body.
 * @method applyLocalImpulse
 * @param  {Vec3} force The force vector to apply, defined locally in the body frame.
 * @param  {Vec3} localPoint A local point in the body to apply the force on.
 */
var Body_applyLocalImpulse_worldImpulse = new Vec3();
var Body_applyLocalImpulse_relativePoint = new Vec3();
Body.prototype.applyLocalImpulse = function(localImpulse, localPoint){
    if(this.type !== Body.DYNAMIC){
        return;
    }

    var worldImpulse = Body_applyLocalImpulse_worldImpulse;
    var relativePointWorld = Body_applyLocalImpulse_relativePoint;

    // Transform the force vector to world space
    this.vectorToWorldFrame(localImpulse, worldImpulse);
    this.vectorToWorldFrame(localPoint, relativePointWorld);

    this.applyImpulse(worldImpulse, relativePointWorld);
};

var Body_updateMassProperties_halfExtents = new Vec3();

/**
 * Should be called whenever you change the body shape or mass.
 * @method updateMassProperties
 */
Body.prototype.updateMassProperties = function(){
    var halfExtents = Body_updateMassProperties_halfExtents;

    this.invMass = this.mass > 0 ? 1.0 / this.mass : 0;
    var I = this.inertia;
    var fixed = this.fixedRotation;

    // Approximate with AABB box
    this.computeAABB();
    halfExtents.set(
        (this.aabb.upperBound.x-this.aabb.lowerBound.x) / 2,
        (this.aabb.upperBound.y-this.aabb.lowerBound.y) / 2,
        (this.aabb.upperBound.z-this.aabb.lowerBound.z) / 2
    );
    Box.calculateInertia(halfExtents, this.mass, I);

    this.invInertia.set(
        I.x > 0 && !fixed ? 1.0 / I.x : 0,
        I.y > 0 && !fixed ? 1.0 / I.y : 0,
        I.z > 0 && !fixed ? 1.0 / I.z : 0
    );
    this.updateInertiaWorld(true);
};

/**
 * Get world velocity of a point in the body.
 * @method getVelocityAtWorldPoint
 * @param  {Vec3} worldPoint
 * @param  {Vec3} result
 * @return {Vec3} The result vector.
 */
Body.prototype.getVelocityAtWorldPoint = function(worldPoint, result){
    var r = new Vec3();
    worldPoint.vsub(this.position, r);
    this.angularVelocity.cross(r, result);
    this.velocity.vadd(result, result);
    return result;
};

var torque = new Vec3();
var invI_tau_dt = new Vec3();
var w = new Quaternion();
var wq = new Quaternion();

/**
 * Move the body forward in time.
 * @param {number} dt Time step
 * @param {boolean} quatNormalize Set to true to normalize the body quaternion
 * @param {boolean} quatNormalizeFast If the quaternion should be normalized using "fast" quaternion normalization
 */
Body.prototype.integrate = function(dt, quatNormalize, quatNormalizeFast){

    // Save previous position
    this.previousPosition.copy(this.position);
    this.previousQuaternion.copy(this.quaternion);

    if(!(this.type === Body.DYNAMIC || this.type === Body.KINEMATIC) || this.sleepState === Body.SLEEPING){ // Only for dynamic
        return;
    }

    var velo = this.velocity,
        angularVelo = this.angularVelocity,
        pos = this.position,
        force = this.force,
        torque = this.torque,
        quat = this.quaternion,
        invMass = this.invMass,
        invInertia = this.invInertiaWorld,
        linearFactor = this.linearFactor;

    var iMdt = invMass * dt;
    velo.x += force.x * iMdt * linearFactor.x;
    velo.y += force.y * iMdt * linearFactor.y;
    velo.z += force.z * iMdt * linearFactor.z;

    var e = invInertia.elements;
    var angularFactor = this.angularFactor;
    var tx = torque.x * angularFactor.x;
    var ty = torque.y * angularFactor.y;
    var tz = torque.z * angularFactor.z;
    angularVelo.x += dt * (e[0] * tx + e[1] * ty + e[2] * tz);
    angularVelo.y += dt * (e[3] * tx + e[4] * ty + e[5] * tz);
    angularVelo.z += dt * (e[6] * tx + e[7] * ty + e[8] * tz);

    // Use new velocity  - leap frog
    pos.x += velo.x * dt;
    pos.y += velo.y * dt;
    pos.z += velo.z * dt;

    quat.integrate(this.angularVelocity, dt, this.angularFactor, quat);

    if(quatNormalize){
        if(quatNormalizeFast){
            quat.normalizeFast();
        } else {
            quat.normalize();
        }
    }

    this.aabbNeedsUpdate = true;

    // Update world inertia
    this.updateInertiaWorld();
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(439);

var _firebase_app = __webpack_require__(374);

// Export a single instance of firebase app
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Import the needed shims
var firebase = (0, _firebase_app.createFirebaseNamespace)();
// Import the createFirebaseNamespace function
exports.default = firebase;
module.exports = exports['default'];
//# sourceMappingURL=app.js.map


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aframe__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aframe__);



__WEBPACK_IMPORTED_MODULE_0_aframe___default.a.registerComponent('frame-button', {
    schema: {
        button: {
            type: 'boolean',
            default: false
        },

        id: {
            type: 'string',
            default: ""
        },

        cursorFeedback: {
            type: 'boolean',
            default: true
        }
    },

    init: function init() {

        this.hovered = false;
        this.clikedDown = false;

        this.clickDownBinded = this.clickDown.bind(this);
        this.clickUpBinded = this.clickUp.bind(this);

        this.cursorEnterBinded = this.cursorEnter.bind(this);
        this.cursorLeaveBinded = this.cursorLeave.bind(this);

        this.elClickBinded = this.elClick.bind(this);

        this.cursor = document.querySelector("#main-cursor");

        this.el.addEventListener("mouseenter", this.cursorEnterBinded);
        this.el.addEventListener("mouseleave", this.cursorLeaveBinded);

        this.el.sceneEl.addEventListener('mousedown', this.clickDownBinded);
        this.el.sceneEl.addEventListener('mouseup', this.clickUpBinded);

        this.el.sceneEl.addEventListener('touchstart', this.clickDownBinded);
        this.el.sceneEl.addEventListener('touchend', this.clickUpBinded);

        this.el.sceneEl.addEventListener('gamepadbuttondown', this.clickDownBinded);
        this.el.sceneEl.addEventListener('gamepadbuttonup', this.clickUpBinded);

        this.el.addEventListener("click", this.elClickBinded);
    },

    remove: function remove() {
        this.el.removeEventListener("mouseenter", this.cursorEnterBinded);
        this.el.removeEventListener("mouseleave", this.cursorLeaveBinded);

        this.el.sceneEl.removeEventListener('mousedown', this.clickDownBinded);
        this.el.sceneEl.removeEventListener('mouseup', this.clickUpBinded);

        this.el.sceneEl.removeEventListener('touchstart', this.clickDownBinded);
        this.el.sceneEl.removeEventListener('touchend', this.clickUpBinded);

        this.el.sceneEl.removeEventListener('gamepadbuttondown', this.clickDownBinded);
        this.el.sceneEl.removeEventListener('gamepadbuttonup', this.clickUpBinded);

        this.el.removeEventListener('click', this.elClickBinded);
    },

    cursorEnter: function cursorEnter() {
        this.hovered = true;

        this.el.emit("cursorEnter");
        if (this.data.cursorFeedback) this.cursor.emit("cursorEnter");
    },

    cursorLeave: function cursorLeave() {
        this.hovered = false;

        this.el.emit("cursorLeave");
        if (this.data.cursorFeedback) this.cursor.emit("cursorLeave");
    },

    clickDown: function clickDown() {
        if (!this.hovered) return;

        this.clickDown = true;
        this.el.emit("clickDown");
    },

    clickUp: function clickUp() {
        if (this.data.button) {

            if (!this.hovered || !this.clickDown) return;

            this.clickDown = false;
            this.el.emit("clickUp");
        } else {
            this.el.emit("clickUp");
        }
    },

    elClick: function elClick() {
        // console.log("Clickng on it ;)")
        this.el.emit("clickEl");
    }
});

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OperationSource = exports.OperationType = undefined;

var _assert = __webpack_require__(2);

/**
 *
 * @enum
 */
var OperationType = exports.OperationType = undefined; /**
                                                        * Copyright 2017 Google Inc.
                                                        *
                                                        * Licensed under the Apache License, Version 2.0 (the "License");
                                                        * you may not use this file except in compliance with the License.
                                                        * You may obtain a copy of the License at
                                                        *
                                                        *   http://www.apache.org/licenses/LICENSE-2.0
                                                        *
                                                        * Unless required by applicable law or agreed to in writing, software
                                                        * distributed under the License is distributed on an "AS IS" BASIS,
                                                        * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                        * See the License for the specific language governing permissions and
                                                        * limitations under the License.
                                                        */

(function (OperationType) {
  OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
  OperationType[OperationType["MERGE"] = 1] = "MERGE";
  OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
  OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})(OperationType || (exports.OperationType = OperationType = {}));
/**
 * @param {boolean} fromUser
 * @param {boolean} fromServer
 * @param {?string} queryId
 * @param {boolean} tagged
 * @constructor
 */
var OperationSource = /** @class */function () {
  function OperationSource(fromUser, fromServer, queryId, tagged) {
    this.fromUser = fromUser;
    this.fromServer = fromServer;
    this.queryId = queryId;
    this.tagged = tagged;
    (0, _assert.assert)(!tagged || fromServer, 'Tagged queries must be from server.');
  }
  /**
   * @const
   * @type {!OperationSource}
   */
  OperationSource.User = new OperationSource(
  /*fromUser=*/true, false, null,
  /*tagged=*/false);
  /**
   * @const
   * @type {!OperationSource}
   */
  OperationSource.Server = new OperationSource(false,
  /*fromServer=*/true, null,
  /*tagged=*/false);
  /**
   * @param {string} queryId
   * @return {!OperationSource}
   */
  OperationSource.forServerTaggedQuery = function (queryId) {
    return new OperationSource(false,
    /*fromServer=*/true, queryId,
    /*tagged=*/true);
  };
  return OperationSource;
}();
exports.OperationSource = OperationSource;
//# sourceMappingURL=Operation.js.map


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateObjectContainsKey = exports.validateObject = exports.validateString = exports.validateBoolean = exports.validateCredential = exports.validateUrl = exports.validateWritablePath = exports.validateRootPathString = exports.validatePathString = exports.validateKey = exports.validateEventType = exports.validatePriority = exports.validateFirebaseMergeDataArg = exports.validateFirebaseMergePaths = exports.validateFirebaseData = exports.validateFirebaseDataArg = exports.isValidPriority = exports.isValidRootPathString = exports.isValidPathString = exports.isValidKey = exports.MAX_LEAF_SIZE_ = exports.INVALID_PATH_REGEX_ = exports.INVALID_KEY_REGEX_ = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Copyright 2017 Google Inc.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Licensed under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                               * you may not use this file except in compliance with the License.
                                                                                                                                                                                                                                                                               * You may obtain a copy of the License at
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               *   http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Unless required by applicable law or agreed to in writing, software
                                                                                                                                                                                                                                                                               * distributed under the License is distributed on an "AS IS" BASIS,
                                                                                                                                                                                                                                                                               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                                                                                                                                                                                                               * See the License for the specific language governing permissions and
                                                                                                                                                                                                                                                                               * limitations under the License.
                                                                                                                                                                                                                                                                               */


var _Path = __webpack_require__(9);

var _obj = __webpack_require__(7);

var _util = __webpack_require__(3);

var _validation = __webpack_require__(40);

var _utf = __webpack_require__(115);

/**
 * True for invalid Firebase keys
 * @type {RegExp}
 * @private
 */
var INVALID_KEY_REGEX_ = exports.INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 * @type {RegExp}
 * @private
 */
var INVALID_PATH_REGEX_ = exports.INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 * @type {number}
 * @private
 */
var MAX_LEAF_SIZE_ = exports.MAX_LEAF_SIZE_ = 10 * 1024 * 1024;
/**
 * @param {*} key
 * @return {boolean}
 */
var isValidKey = exports.isValidKey = function isValidKey(key) {
    return typeof key === 'string' && key.length !== 0 && !INVALID_KEY_REGEX_.test(key);
};
/**
 * @param {string} pathString
 * @return {boolean}
 */
var isValidPathString = exports.isValidPathString = function isValidPathString(pathString) {
    return typeof pathString === 'string' && pathString.length !== 0 && !INVALID_PATH_REGEX_.test(pathString);
};
/**
 * @param {string} pathString
 * @return {boolean}
 */
var isValidRootPathString = exports.isValidRootPathString = function isValidRootPathString(pathString) {
    if (pathString) {
        // Allow '/.info/' at the beginning.
        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    }
    return isValidPathString(pathString);
};
/**
 * @param {*} priority
 * @return {boolean}
 */
var isValidPriority = exports.isValidPriority = function isValidPriority(priority) {
    return priority === null || typeof priority === 'string' || typeof priority === 'number' && !(0, _util.isInvalidJSONNumber)(priority) || priority && (typeof priority === 'undefined' ? 'undefined' : _typeof(priority)) === 'object' && (0, _obj.contains)(priority, '.sv');
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */
var validateFirebaseDataArg = exports.validateFirebaseDataArg = function validateFirebaseDataArg(fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined) return;
    validateFirebaseData((0, _validation.errorPrefix)(fnName, argumentNumber, optional), data, path);
};
/**
 * Validate a data object client-side before sending to server.
 *
 * @param {string} errorPrefix
 * @param {*} data
 * @param {!Path|!ValidationPath} path_
 */
var validateFirebaseData = exports.validateFirebaseData = function validateFirebaseData(errorPrefix, data, path_) {
    var path = path_ instanceof _Path.Path ? new _Path.ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) {
        throw new Error(errorPrefix + 'contains undefined ' + path.toErrorString());
    }
    if (typeof data === 'function') {
        throw new Error(errorPrefix + 'contains a function ' + path.toErrorString() + ' with contents = ' + data.toString());
    }
    if ((0, _util.isInvalidJSONNumber)(data)) {
        throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + path.toErrorString());
    }
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === 'string' && data.length > MAX_LEAF_SIZE_ / 3 && (0, _utf.stringLength)(data) > MAX_LEAF_SIZE_) {
        throw new Error(errorPrefix + 'contains a string greater than ' + MAX_LEAF_SIZE_ + ' utf8 bytes ' + path.toErrorString() + " ('" + data.substring(0, 50) + "...')");
    }
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
        var hasDotValue_1 = false,
            hasActualChild_1 = false;
        (0, _obj.forEach)(data, function (key, value) {
            if (key === '.value') {
                hasDotValue_1 = true;
            } else if (key !== '.priority' && key !== '.sv') {
                hasActualChild_1 = true;
                if (!isValidKey(key)) {
                    throw new Error(errorPrefix + ' contains an invalid key (' + key + ') ' + path.toErrorString() + '.  Keys must be non-empty strings ' + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
                }
            }
            path.push(key);
            validateFirebaseData(errorPrefix, value, path);
            path.pop();
        });
        if (hasDotValue_1 && hasActualChild_1) {
            throw new Error(errorPrefix + ' contains ".value" child ' + path.toErrorString() + ' in addition to actual children.');
        }
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 *
 * @param {string} errorPrefix
 * @param {Array<!Path>} mergePaths
 */
var validateFirebaseMergePaths = exports.validateFirebaseMergePaths = function validateFirebaseMergePaths(errorPrefix, mergePaths) {
    var i, curPath;
    for (i = 0; i < mergePaths.length; i++) {
        curPath = mergePaths[i];
        var keys = curPath.slice();
        for (var j = 0; j < keys.length; j++) {
            if (keys[j] === '.priority' && j === keys.length - 1) {
                // .priority is OK
            } else if (!isValidKey(keys[j])) {
                throw new Error(errorPrefix + 'contains an invalid key (' + keys[j] + ') in path ' + curPath.toString() + '. Keys must be non-empty strings ' + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort(_Path.Path.comparePaths);
    var prevPath = null;
    for (i = 0; i < mergePaths.length; i++) {
        curPath = mergePaths[i];
        if (prevPath !== null && prevPath.contains(curPath)) {
            throw new Error(errorPrefix + 'contains a path ' + prevPath.toString() + ' that is ancestor of another path ' + curPath.toString());
        }
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */
var validateFirebaseMergeDataArg = exports.validateFirebaseMergeDataArg = function validateFirebaseMergeDataArg(fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined) return;
    var errorPrefix = (0, _validation.errorPrefix)(fnName, argumentNumber, optional);
    if (!(data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') || Array.isArray(data)) {
        throw new Error(errorPrefix + ' must be an object containing the children to replace.');
    }
    var mergePaths = [];
    (0, _obj.forEach)(data, function (key, value) {
        var curPath = new _Path.Path(key);
        validateFirebaseData(errorPrefix, value, path.child(curPath));
        if (curPath.getBack() === '.priority') {
            if (!isValidPriority(value)) {
                throw new Error(errorPrefix + "contains an invalid value for '" + curPath.toString() + "', which must be a valid " + 'Firebase priority (a string, finite number, server value, or null).');
            }
        }
        mergePaths.push(curPath);
    });
    validateFirebaseMergePaths(errorPrefix, mergePaths);
};
var validatePriority = exports.validatePriority = function validatePriority(fnName, argumentNumber, priority, optional) {
    if (optional && priority === undefined) return;
    if ((0, _util.isInvalidJSONNumber)(priority)) throw new Error((0, _validation.errorPrefix)(fnName, argumentNumber, optional) + 'is ' + priority.toString() + ', but must be a valid Firebase priority (a string, finite number, ' + 'server value, or null).');
    // Special case to allow importing data with a .sv.
    if (!isValidPriority(priority)) throw new Error((0, _validation.errorPrefix)(fnName, argumentNumber, optional) + 'must be a valid Firebase priority ' + '(a string, finite number, server value, or null).');
};
var validateEventType = exports.validateEventType = function validateEventType(fnName, argumentNumber, eventType, optional) {
    if (optional && eventType === undefined) return;
    switch (eventType) {
        case 'value':
        case 'child_added':
        case 'child_removed':
        case 'child_changed':
        case 'child_moved':
            break;
        default:
            throw new Error((0, _validation.errorPrefix)(fnName, argumentNumber, optional) + 'must be a valid event type = "value", "child_added", "child_removed", ' + '"child_changed", or "child_moved".');
    }
};
var validateKey = exports.validateKey = function validateKey(fnName, argumentNumber, key, optional) {
    if (optional && key === undefined) return;
    if (!isValidKey(key)) throw new Error((0, _validation.errorPrefix)(fnName, argumentNumber, optional) + 'was an invalid key = "' + key + '".  Firebase keys must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
var validatePathString = exports.validatePathString = function validatePathString(fnName, argumentNumber, pathString, optional) {
    if (optional && pathString === undefined) return;
    if (!isValidPathString(pathString)) throw new Error((0, _validation.errorPrefix)(fnName, argumentNumber, optional) + 'was an invalid path = "' + pathString + '". Paths must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "[", or "]"');
};
var validateRootPathString = exports.validateRootPathString = function validateRootPathString(fnName, argumentNumber, pathString, optional) {
    if (pathString) {
        // Allow '/.info/' at the beginning.
        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    }
    validatePathString(fnName, argumentNumber, pathString, optional);
};
var validateWritablePath = exports.validateWritablePath = function validateWritablePath(fnName, path) {
    if (path.getFront() === '.info') {
        throw new Error(fnName + " failed = Can't modify data under /.info/");
    }
};
var validateUrl = exports.validateUrl = function validateUrl(fnName, argumentNumber, parsedUrl) {
    // TODO = Validate server better.
    var pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === 'string') || parsedUrl.repoInfo.host.length === 0 || !isValidKey(parsedUrl.repoInfo.namespace) || pathString.length !== 0 && !isValidRootPathString(pathString)) {
        throw new Error((0, _validation.errorPrefix)(fnName, argumentNumber, false) + 'must be a valid firebase URL and ' + 'the path can\'t contain ".", "#", "$", "[", or "]".');
    }
};
var validateCredential = exports.validateCredential = function validateCredential(fnName, argumentNumber, cred, optional) {
    if (optional && cred === undefined) return;
    if (!(typeof cred === 'string')) throw new Error((0, _validation.errorPrefix)(fnName, argumentNumber, optional) + 'must be a valid credential (a string).');
};
var validateBoolean = exports.validateBoolean = function validateBoolean(fnName, argumentNumber, bool, optional) {
    if (optional && bool === undefined) return;
    if (typeof bool !== 'boolean') throw new Error((0, _validation.errorPrefix)(fnName, argumentNumber, optional) + 'must be a boolean.');
};
var validateString = exports.validateString = function validateString(fnName, argumentNumber, string, optional) {
    if (optional && string === undefined) return;
    if (!(typeof string === 'string')) {
        throw new Error((0, _validation.errorPrefix)(fnName, argumentNumber, optional) + 'must be a valid string.');
    }
};
var validateObject = exports.validateObject = function validateObject(fnName, argumentNumber, obj, optional) {
    if (optional && obj === undefined) return;
    if (!(obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') || obj === null) {
        throw new Error((0, _validation.errorPrefix)(fnName, argumentNumber, optional) + 'must be a valid object.');
    }
};
var validateObjectContainsKey = exports.validateObjectContainsKey = function validateObjectContainsKey(fnName, argumentNumber, obj, key, optional, opt_type) {
    var objectContainsKey = obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && (0, _obj.contains)(obj, key);
    if (!objectContainsKey) {
        if (optional) {
            return;
        } else {
            throw new Error((0, _validation.errorPrefix)(fnName, argumentNumber, optional) + 'must contain the key "' + key + '"');
        }
    }
    if (opt_type) {
        var val = (0, _obj.safeGet)(obj, key);
        if (opt_type === 'number' && !(typeof val === 'number') || opt_type === 'string' && !(typeof val === 'string') || opt_type === 'boolean' && !(typeof val === 'boolean') || opt_type === 'function' && !(typeof val === 'function') || opt_type === 'object' && !((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') && val) {
            if (optional) {
                throw new Error((0, _validation.errorPrefix)(fnName, argumentNumber, optional) + 'contains invalid value for key "' + key + '" (must be of type "' + opt_type + '")');
            } else {
                throw new Error((0, _validation.errorPrefix)(fnName, argumentNumber, optional) + 'must contain the key "' + key + '" with type "' + opt_type + '"');
            }
        }
    }
};
//# sourceMappingURL=validation.js.map


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.make = make;
exports.resolve = resolve;
exports.reject = reject;

var _promise = __webpack_require__(39);

function make(resolver) {
  return new _promise.PromiseImpl(resolver);
}
/**
 * @template T
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Implements the promise abstraction interface for external
 * (public SDK) packaging, which just passes through to the firebase-app impl.
 */
/**
 * @template T
 * @param {function((function(T): void),
 *                  (function(!Error): void))} resolver
 */
function resolve(value) {
  return _promise.PromiseImpl.resolve(value);
}
function reject(error) {
  return _promise.PromiseImpl.reject(error);
}
//# sourceMappingURL=promise_external.js.map


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.attachDummyErrorHandler = exports.Deferred = exports.PromiseImpl = undefined;

var _globalScope = __webpack_require__(194);

var PromiseImpl = exports.PromiseImpl = _globalScope.globalScope.Promise || __webpack_require__(418);
/**
 * A deferred promise implementation.
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */function () {
    /** @constructor */
    function Deferred() {
        var self = this;
        this.resolve = null;
        this.reject = null;
        this.promise = new PromiseImpl(function (resolve, reject) {
            self.resolve = resolve;
            self.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     * @param {((?function(?(Error)): (?|undefined))| (?function(?(Error),?=): (?|undefined)))=} opt_nodeCallback
     * @return {!function(?(Error), ?=)}
     */
    Deferred.prototype.wrapCallback = function (opt_nodeCallback) {
        var self = this;
        /**
           * @param {?Error} error
           * @param {?=} opt_value
           */
        function meta(error, opt_value) {
            if (error) {
                self.reject(error);
            } else {
                self.resolve(opt_value);
            }
            if (typeof opt_nodeCallback === 'function') {
                attachDummyErrorHandler(self.promise);
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (opt_nodeCallback.length === 1) {
                    opt_nodeCallback(error);
                } else {
                    opt_nodeCallback(error, opt_value);
                }
            }
        }
        return meta;
    };
    return Deferred;
}();
exports.Deferred = Deferred;
/**
 * Chrome (and maybe other browsers) report an Error in the console if you reject a promise
 * and nobody handles the error. This is normally a good thing, but this will confuse devs who
 * never intended to use promises in the first place. So in some cases (in particular, if the
 * developer attached a callback), we should attach a dummy resolver to the promise to suppress
 * this error.
 *
 * Note: We can't do this all the time, since it breaks the Promise spec (though in the obscure
 * 3.3.3 section related to upgrading non-compliant promises).
 * @param {!firebase.Promise} promise
 */

var attachDummyErrorHandler = exports.attachDummyErrorHandler = function attachDummyErrorHandler(promise) {
    promise.catch(function () {});
};
//# sourceMappingURL=promise.js.map


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.errorPrefix = errorPrefix;
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param {!string} fnName The function name
 * @param {!number} minCount The minimum number of arguments to allow for the function call
 * @param {!number} maxCount The maximum number of argument to allow for the function call
 * @param {!number} argCount The actual number of arguments provided.
 */
var validateArgCount = exports.validateArgCount = function validateArgCount(fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    } else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        var error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param {!string} fnName The function name
 * @param {!number} argumentNumber The index of the argument
 * @param {boolean} optional Whether or not the argument is optional
 * @return {!string} The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argumentNumber, optional) {
    var argName = '';
    switch (argumentNumber) {
        case 1:
            argName = optional ? 'first' : 'First';
            break;
        case 2:
            argName = optional ? 'second' : 'Second';
            break;
        case 3:
            argName = optional ? 'third' : 'Third';
            break;
        case 4:
            argName = optional ? 'fourth' : 'Fourth';
            break;
        default:
            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
    }
    var error = fnName + ' failed: ';
    error += argName + ' argument ';
    return error;
}
/**
 * @param {!string} fnName
 * @param {!number} argumentNumber
 * @param {!string} namespace
 * @param {boolean} optional
 */
var validateNamespace = exports.validateNamespace = function validateNamespace(fnName, argumentNumber, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, argumentNumber, optional) + 'must be a valid firebase namespace.');
    }
};
var validateCallback = exports.validateCallback = function validateCallback(fnName, argumentNumber, callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error(errorPrefix(fnName, argumentNumber, optional) + 'must be a valid function.');
};
var validateContextObject = exports.validateContextObject = function validateContextObject(fnName, argumentNumber, context, optional) {
    if (optional && !context) return;
    if ((typeof context === 'undefined' ? 'undefined' : _typeof(context)) !== 'object' || context === null) throw new Error(errorPrefix(fnName, argumentNumber, optional) + 'must be a valid context object.');
};
//# sourceMappingURL=validation.js.map


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(1);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 42 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// Export classes
module.exports = {
    version :                       __webpack_require__(333).version,

    AABB :                          __webpack_require__(30),
    ArrayCollisionMatrix :          __webpack_require__(142),
    Body :                          __webpack_require__(33),
    Box :                           __webpack_require__(73),
    Broadphase :                    __webpack_require__(69),
    Constraint :                    __webpack_require__(44),
    ContactEquation :               __webpack_require__(31),
    Narrowphase :                   __webpack_require__(152),
    ConeTwistConstraint :           __webpack_require__(338),
    ContactMaterial :               __webpack_require__(145),
    ConvexPolyhedron :              __webpack_require__(47),
    Cylinder :                      __webpack_require__(348),
    DistanceConstraint :            __webpack_require__(339),
    Equation :                      __webpack_require__(45),
    EventTarget :                   __webpack_require__(101),
    FrictionEquation :              __webpack_require__(99),
    GSSolver :                      __webpack_require__(149),
    GridBroadphase :                __webpack_require__(334),
    Heightfield :                   __webpack_require__(349),
    HingeConstraint :               __webpack_require__(144),
    LockConstraint :                __webpack_require__(340),
    Mat3 :                          __webpack_require__(32),
    Material :                      __webpack_require__(59),
    NaiveBroadphase :               __webpack_require__(143),
    ObjectCollisionMatrix :         __webpack_require__(335),
    Pool :                          __webpack_require__(150),
    Particle :                      __webpack_require__(146),
    Plane :                         __webpack_require__(147),
    PointToPointConstraint :        __webpack_require__(71),
    Quaternion :                    __webpack_require__(13),
    Ray :                           __webpack_require__(70),
    RaycastVehicle :                __webpack_require__(343),
    RaycastResult :                 __webpack_require__(58),
    RigidVehicle :                  __webpack_require__(344),
    RotationalEquation :            __webpack_require__(72),
    RotationalMotorEquation :       __webpack_require__(100),
    SAPBroadphase :                 __webpack_require__(337),
    SPHSystem :                     __webpack_require__(345),
    Shape :                         __webpack_require__(12),
    Solver :                        __webpack_require__(74),
    Sphere :                        __webpack_require__(148),
    SplitSolver :                   __webpack_require__(351),
    Spring :                        __webpack_require__(346),
    Transform :                     __webpack_require__(46),
    Trimesh :                       __webpack_require__(350),
    Vec3 :                          __webpack_require__(0),
    Vec3Pool :                      __webpack_require__(151),
    World :                         __webpack_require__(354),
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Constraint;

var Utils = __webpack_require__(60);

/**
 * Constraint base class
 * @class Constraint
 * @author schteppe
 * @constructor
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {object} [options]
 * @param {boolean} [options.collideConnected=true]
 * @param {boolean} [options.wakeUpBodies=true]
 */
function Constraint(bodyA, bodyB, options){
    options = Utils.defaults(options,{
        collideConnected : true,
        wakeUpBodies : true,
    });

    /**
     * Equations to be solved in this constraint
     * @property equations
     * @type {Array}
     */
    this.equations = [];

    /**
     * @property {Body} bodyA
     */
    this.bodyA = bodyA;

    /**
     * @property {Body} bodyB
     */
    this.bodyB = bodyB;

    /**
     * @property {Number} id
     */
    this.id = Constraint.idCounter++;

    /**
     * Set to true if you want the bodies to collide when they are connected.
     * @property collideConnected
     * @type {boolean}
     */
    this.collideConnected = options.collideConnected;

    if(options.wakeUpBodies){
        if(bodyA){
            bodyA.wakeUp();
        }
        if(bodyB){
            bodyB.wakeUp();
        }
    }
}

/**
 * Update all the equations with data.
 * @method update
 */
Constraint.prototype.update = function(){
    throw new Error("method update() not implmemented in this Constraint subclass!");
};

/**
 * Enables all equations in the constraint.
 * @method enable
 */
Constraint.prototype.enable = function(){
    var eqs = this.equations;
    for(var i=0; i<eqs.length; i++){
        eqs[i].enabled = true;
    }
};

/**
 * Disables all equations in the constraint.
 * @method disable
 */
Constraint.prototype.disable = function(){
    var eqs = this.equations;
    for(var i=0; i<eqs.length; i++){
        eqs[i].enabled = false;
    }
};

Constraint.idCounter = 0;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Equation;

var JacobianElement = __webpack_require__(342),
    Vec3 = __webpack_require__(0);

/**
 * Equation base class
 * @class Equation
 * @constructor
 * @author schteppe
 * @param {Body} bi
 * @param {Body} bj
 * @param {Number} minForce Minimum (read: negative max) force to be applied by the constraint.
 * @param {Number} maxForce Maximum (read: positive max) force to be applied by the constraint.
 */
function Equation(bi,bj,minForce,maxForce){
    this.id = Equation.id++;

    /**
     * @property {number} minForce
     */
    this.minForce = typeof(minForce)==="undefined" ? -1e6 : minForce;

    /**
     * @property {number} maxForce
     */
    this.maxForce = typeof(maxForce)==="undefined" ? 1e6 : maxForce;

    /**
     * @property bi
     * @type {Body}
     */
    this.bi = bi;

    /**
     * @property bj
     * @type {Body}
     */
    this.bj = bj;

    /**
     * SPOOK parameter
     * @property {number} a
     */
    this.a = 0.0;

    /**
     * SPOOK parameter
     * @property {number} b
     */
    this.b = 0.0;

    /**
     * SPOOK parameter
     * @property {number} eps
     */
    this.eps = 0.0;

    /**
     * @property {JacobianElement} jacobianElementA
     */
    this.jacobianElementA = new JacobianElement();

    /**
     * @property {JacobianElement} jacobianElementB
     */
    this.jacobianElementB = new JacobianElement();

    /**
     * @property {boolean} enabled
     * @default true
     */
    this.enabled = true;

    /**
     * A number, proportional to the force added to the bodies.
     * @property {number} multiplier
     * @readonly
     */
    this.multiplier = 0;

    // Set typical spook params
    this.setSpookParams(1e7,4,1/60);
}
Equation.prototype.constructor = Equation;

Equation.id = 0;

/**
 * Recalculates a,b,eps.
 * @method setSpookParams
 */
Equation.prototype.setSpookParams = function(stiffness,relaxation,timeStep){
    var d = relaxation,
        k = stiffness,
        h = timeStep;
    this.a = 4.0 / (h * (1 + 4 * d));
    this.b = (4.0 * d) / (1 + 4 * d);
    this.eps = 4.0 / (h * h * k * (1 + 4 * d));
};

/**
 * Computes the RHS of the SPOOK equation
 * @method computeB
 * @return {Number}
 */
Equation.prototype.computeB = function(a,b,h){
    var GW = this.computeGW(),
        Gq = this.computeGq(),
        GiMf = this.computeGiMf();
    return - Gq * a - GW * b - GiMf*h;
};

/**
 * Computes G*q, where q are the generalized body coordinates
 * @method computeGq
 * @return {Number}
 */
Equation.prototype.computeGq = function(){
    var GA = this.jacobianElementA,
        GB = this.jacobianElementB,
        bi = this.bi,
        bj = this.bj,
        xi = bi.position,
        xj = bj.position;
    return GA.spatial.dot(xi) + GB.spatial.dot(xj);
};

var zero = new Vec3();

/**
 * Computes G*W, where W are the body velocities
 * @method computeGW
 * @return {Number}
 */
Equation.prototype.computeGW = function(){
    var GA = this.jacobianElementA,
        GB = this.jacobianElementB,
        bi = this.bi,
        bj = this.bj,
        vi = bi.velocity,
        vj = bj.velocity,
        wi = bi.angularVelocity,
        wj = bj.angularVelocity;
    return GA.multiplyVectors(vi,wi) + GB.multiplyVectors(vj,wj);
};


/**
 * Computes G*Wlambda, where W are the body velocities
 * @method computeGWlambda
 * @return {Number}
 */
Equation.prototype.computeGWlambda = function(){
    var GA = this.jacobianElementA,
        GB = this.jacobianElementB,
        bi = this.bi,
        bj = this.bj,
        vi = bi.vlambda,
        vj = bj.vlambda,
        wi = bi.wlambda,
        wj = bj.wlambda;
    return GA.multiplyVectors(vi,wi) + GB.multiplyVectors(vj,wj);
};

/**
 * Computes G*inv(M)*f, where M is the mass matrix with diagonal blocks for each body, and f are the forces on the bodies.
 * @method computeGiMf
 * @return {Number}
 */
var iMfi = new Vec3(),
    iMfj = new Vec3(),
    invIi_vmult_taui = new Vec3(),
    invIj_vmult_tauj = new Vec3();
Equation.prototype.computeGiMf = function(){
    var GA = this.jacobianElementA,
        GB = this.jacobianElementB,
        bi = this.bi,
        bj = this.bj,
        fi = bi.force,
        ti = bi.torque,
        fj = bj.force,
        tj = bj.torque,
        invMassi = bi.invMassSolve,
        invMassj = bj.invMassSolve;

    fi.scale(invMassi,iMfi);
    fj.scale(invMassj,iMfj);

    bi.invInertiaWorldSolve.vmult(ti,invIi_vmult_taui);
    bj.invInertiaWorldSolve.vmult(tj,invIj_vmult_tauj);

    return GA.multiplyVectors(iMfi,invIi_vmult_taui) + GB.multiplyVectors(iMfj,invIj_vmult_tauj);
};

/**
 * Computes G*inv(M)*G'
 * @method computeGiMGt
 * @return {Number}
 */
var tmp = new Vec3();
Equation.prototype.computeGiMGt = function(){
    var GA = this.jacobianElementA,
        GB = this.jacobianElementB,
        bi = this.bi,
        bj = this.bj,
        invMassi = bi.invMassSolve,
        invMassj = bj.invMassSolve,
        invIi = bi.invInertiaWorldSolve,
        invIj = bj.invInertiaWorldSolve,
        result = invMassi + invMassj;

    invIi.vmult(GA.rotational,tmp);
    result += tmp.dot(GA.rotational);

    invIj.vmult(GB.rotational,tmp);
    result += tmp.dot(GB.rotational);

    return  result;
};

var addToWlambda_temp = new Vec3(),
    addToWlambda_Gi = new Vec3(),
    addToWlambda_Gj = new Vec3(),
    addToWlambda_ri = new Vec3(),
    addToWlambda_rj = new Vec3(),
    addToWlambda_Mdiag = new Vec3();

/**
 * Add constraint velocity to the bodies.
 * @method addToWlambda
 * @param {Number} deltalambda
 */
Equation.prototype.addToWlambda = function(deltalambda){
    var GA = this.jacobianElementA,
        GB = this.jacobianElementB,
        bi = this.bi,
        bj = this.bj,
        temp = addToWlambda_temp;

    // Add to linear velocity
    // v_lambda += inv(M) * delta_lamba * G
    bi.vlambda.addScaledVector(bi.invMassSolve * deltalambda, GA.spatial, bi.vlambda);
    bj.vlambda.addScaledVector(bj.invMassSolve * deltalambda, GB.spatial, bj.vlambda);

    // Add to angular velocity
    bi.invInertiaWorldSolve.vmult(GA.rotational,temp);
    bi.wlambda.addScaledVector(deltalambda, temp, bi.wlambda);

    bj.invInertiaWorldSolve.vmult(GB.rotational,temp);
    bj.wlambda.addScaledVector(deltalambda, temp, bj.wlambda);
};

/**
 * Compute the denominator part of the SPOOK equation: C = G*inv(M)*G' + eps
 * @method computeInvC
 * @param  {Number} eps
 * @return {Number}
 */
Equation.prototype.computeC = function(){
    return this.computeGiMGt() + this.eps;
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var Vec3 = __webpack_require__(0);
var Quaternion = __webpack_require__(13);

module.exports = Transform;

/**
 * @class Transform
 * @constructor
 */
function Transform(options) {
    options = options || {};

	/**
	 * @property {Vec3} position
	 */
	this.position = new Vec3();
    if(options.position){
        this.position.copy(options.position);
    }

	/**
	 * @property {Quaternion} quaternion
	 */
	this.quaternion = new Quaternion();
    if(options.quaternion){
        this.quaternion.copy(options.quaternion);
    }
}

var tmpQuat = new Quaternion();

/**
 * @static
 * @method pointToLocaFrame
 * @param {Vec3} position
 * @param {Quaternion} quaternion
 * @param {Vec3} worldPoint
 * @param {Vec3} result
 */
Transform.pointToLocalFrame = function(position, quaternion, worldPoint, result){
    var result = result || new Vec3();
    worldPoint.vsub(position, result);
    quaternion.conjugate(tmpQuat);
    tmpQuat.vmult(result, result);
    return result;
};

/**
 * Get a global point in local transform coordinates.
 * @method pointToLocal
 * @param  {Vec3} point
 * @param  {Vec3} result
 * @return {Vec3} The "result" vector object
 */
Transform.prototype.pointToLocal = function(worldPoint, result){
    return Transform.pointToLocalFrame(this.position, this.quaternion, worldPoint, result);
};

/**
 * @static
 * @method pointToWorldFrame
 * @param {Vec3} position
 * @param {Vec3} quaternion
 * @param {Vec3} localPoint
 * @param {Vec3} result
 */
Transform.pointToWorldFrame = function(position, quaternion, localPoint, result){
    var result = result || new Vec3();
    quaternion.vmult(localPoint, result);
    result.vadd(position, result);
    return result;
};

/**
 * Get a local point in global transform coordinates.
 * @method pointToWorld
 * @param  {Vec3} point
 * @param  {Vec3} result
 * @return {Vec3} The "result" vector object
 */
Transform.prototype.pointToWorld = function(localPoint, result){
    return Transform.pointToWorldFrame(this.position, this.quaternion, localPoint, result);
};


Transform.prototype.vectorToWorldFrame = function(localVector, result){
    var result = result || new Vec3();
    this.quaternion.vmult(localVector, result);
    return result;
};

Transform.vectorToWorldFrame = function(quaternion, localVector, result){
    quaternion.vmult(localVector, result);
    return result;
};

Transform.vectorToLocalFrame = function(position, quaternion, worldVector, result){
    var result = result || new Vec3();
    quaternion.w *= -1;
    quaternion.vmult(worldVector, result);
    quaternion.w *= -1;
    return result;
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = ConvexPolyhedron;

var Shape = __webpack_require__(12);
var Vec3 = __webpack_require__(0);
var Quaternion = __webpack_require__(13);
var Transform = __webpack_require__(46);

/**
 * A set of polygons describing a convex shape.
 * @class ConvexPolyhedron
 * @constructor
 * @extends Shape
 * @description The shape MUST be convex for the code to work properly. No polygons may be coplanar (contained
 * in the same 3D plane), instead these should be merged into one polygon.
 *
 * @param {array} points An array of Vec3's
 * @param {array} faces Array of integer arrays, describing which vertices that is included in each face.
 *
 * @author qiao / https://github.com/qiao (original author, see https://github.com/qiao/three.js/commit/85026f0c769e4000148a67d45a9e9b9c5108836f)
 * @author schteppe / https://github.com/schteppe
 * @see http://www.altdevblogaday.com/2011/05/13/contact-generation-between-3d-convex-meshes/
 * @see http://bullet.googlecode.com/svn/trunk/src/BulletCollision/NarrowPhaseCollision/btPolyhedralContactClipping.cpp
 *
 * @todo Move the clipping functions to ContactGenerator?
 * @todo Automatically merge coplanar polygons in constructor.
 */
function ConvexPolyhedron(points, faces, uniqueAxes) {
    var that = this;
    Shape.call(this);
    this.type = Shape.types.CONVEXPOLYHEDRON;

    /**
     * Array of Vec3
     * @property vertices
     * @type {Array}
     */
    this.vertices = points||[];

    this.worldVertices = []; // World transformed version of .vertices
    this.worldVerticesNeedsUpdate = true;

    /**
     * Array of integer arrays, indicating which vertices each face consists of
     * @property faces
     * @type {Array}
     */
    this.faces = faces||[];

    /**
     * Array of Vec3
     * @property faceNormals
     * @type {Array}
     */
    this.faceNormals = [];
    this.computeNormals();

    this.worldFaceNormalsNeedsUpdate = true;
    this.worldFaceNormals = []; // World transformed version of .faceNormals

    /**
     * Array of Vec3
     * @property uniqueEdges
     * @type {Array}
     */
    this.uniqueEdges = [];

    /**
     * If given, these locally defined, normalized axes are the only ones being checked when doing separating axis check.
     * @property {Array} uniqueAxes
     */
    this.uniqueAxes = uniqueAxes ? uniqueAxes.slice() : null;

    this.computeEdges();
    this.updateBoundingSphereRadius();
}
ConvexPolyhedron.prototype = new Shape();
ConvexPolyhedron.prototype.constructor = ConvexPolyhedron;

var computeEdges_tmpEdge = new Vec3();
/**
 * Computes uniqueEdges
 * @method computeEdges
 */
ConvexPolyhedron.prototype.computeEdges = function(){
    var faces = this.faces;
    var vertices = this.vertices;
    var nv = vertices.length;
    var edges = this.uniqueEdges;

    edges.length = 0;

    var edge = computeEdges_tmpEdge;

    for(var i=0; i !== faces.length; i++){
        var face = faces[i];
        var numVertices = face.length;
        for(var j = 0; j !== numVertices; j++){
            var k = ( j+1 ) % numVertices;
            vertices[face[j]].vsub(vertices[face[k]], edge);
            edge.normalize();
            var found = false;
            for(var p=0; p !== edges.length; p++){
                if (edges[p].almostEquals(edge) || edges[p].almostEquals(edge)){
                    found = true;
                    break;
                }
            }

            if (!found){
                edges.push(edge.clone());
            }
        }
    }
};

/**
 * Compute the normals of the faces. Will reuse existing Vec3 objects in the .faceNormals array if they exist.
 * @method computeNormals
 */
ConvexPolyhedron.prototype.computeNormals = function(){
    this.faceNormals.length = this.faces.length;

    // Generate normals
    for(var i=0; i<this.faces.length; i++){

        // Check so all vertices exists for this face
        for(var j=0; j<this.faces[i].length; j++){
            if(!this.vertices[this.faces[i][j]]){
                throw new Error("Vertex "+this.faces[i][j]+" not found!");
            }
        }

        var n = this.faceNormals[i] || new Vec3();
        this.getFaceNormal(i,n);
        n.negate(n);
        this.faceNormals[i] = n;
        var vertex = this.vertices[this.faces[i][0]];
        if(n.dot(vertex) < 0){
            console.error(".faceNormals[" + i + "] = Vec3("+n.toString()+") looks like it points into the shape? The vertices follow. Make sure they are ordered CCW around the normal, using the right hand rule.");
            for(var j=0; j<this.faces[i].length; j++){
                console.warn(".vertices["+this.faces[i][j]+"] = Vec3("+this.vertices[this.faces[i][j]].toString()+")");
            }
        }
    }
};

/**
 * Get face normal given 3 vertices
 * @static
 * @method getFaceNormal
 * @param {Vec3} va
 * @param {Vec3} vb
 * @param {Vec3} vc
 * @param {Vec3} target
 */
var cb = new Vec3();
var ab = new Vec3();
ConvexPolyhedron.computeNormal = function ( va, vb, vc, target ) {
    vb.vsub(va,ab);
    vc.vsub(vb,cb);
    cb.cross(ab,target);
    if ( !target.isZero() ) {
        target.normalize();
    }
};

/**
 * Compute the normal of a face from its vertices
 * @method getFaceNormal
 * @param  {Number} i
 * @param  {Vec3} target
 */
ConvexPolyhedron.prototype.getFaceNormal = function(i,target){
    var f = this.faces[i];
    var va = this.vertices[f[0]];
    var vb = this.vertices[f[1]];
    var vc = this.vertices[f[2]];
    return ConvexPolyhedron.computeNormal(va,vb,vc,target);
};

/**
 * @method clipAgainstHull
 * @param {Vec3} posA
 * @param {Quaternion} quatA
 * @param {ConvexPolyhedron} hullB
 * @param {Vec3} posB
 * @param {Quaternion} quatB
 * @param {Vec3} separatingNormal
 * @param {Number} minDist Clamp distance
 * @param {Number} maxDist
 * @param {array} result The an array of contact point objects, see clipFaceAgainstHull
 * @see http://bullet.googlecode.com/svn/trunk/src/BulletCollision/NarrowPhaseCollision/btPolyhedralContactClipping.cpp
 */
var cah_WorldNormal = new Vec3();
ConvexPolyhedron.prototype.clipAgainstHull = function(posA,quatA,hullB,posB,quatB,separatingNormal,minDist,maxDist,result){
    var WorldNormal = cah_WorldNormal;
    var hullA = this;
    var curMaxDist = maxDist;
    var closestFaceB = -1;
    var dmax = -Number.MAX_VALUE;
    for(var face=0; face < hullB.faces.length; face++){
        WorldNormal.copy(hullB.faceNormals[face]);
        quatB.vmult(WorldNormal,WorldNormal);
        //posB.vadd(WorldNormal,WorldNormal);
        var d = WorldNormal.dot(separatingNormal);
        if (d > dmax){
            dmax = d;
            closestFaceB = face;
        }
    }
    var worldVertsB1 = [];
    var polyB = hullB.faces[closestFaceB];
    var numVertices = polyB.length;
    for(var e0=0; e0<numVertices; e0++){
        var b = hullB.vertices[polyB[e0]];
        var worldb = new Vec3();
        worldb.copy(b);
        quatB.vmult(worldb,worldb);
        posB.vadd(worldb,worldb);
        worldVertsB1.push(worldb);
    }

    if (closestFaceB>=0){
        this.clipFaceAgainstHull(separatingNormal,
                                 posA,
                                 quatA,
                                 worldVertsB1,
                                 minDist,
                                 maxDist,
                                 result);
    }
};

/**
 * Find the separating axis between this hull and another
 * @method findSeparatingAxis
 * @param {ConvexPolyhedron} hullB
 * @param {Vec3} posA
 * @param {Quaternion} quatA
 * @param {Vec3} posB
 * @param {Quaternion} quatB
 * @param {Vec3} target The target vector to save the axis in
 * @return {bool} Returns false if a separation is found, else true
 */
var fsa_faceANormalWS3 = new Vec3(),
    fsa_Worldnormal1 = new Vec3(),
    fsa_deltaC = new Vec3(),
    fsa_worldEdge0 = new Vec3(),
    fsa_worldEdge1 = new Vec3(),
    fsa_Cross = new Vec3();
ConvexPolyhedron.prototype.findSeparatingAxis = function(hullB,posA,quatA,posB,quatB,target, faceListA, faceListB){
    var faceANormalWS3 = fsa_faceANormalWS3,
        Worldnormal1 = fsa_Worldnormal1,
        deltaC = fsa_deltaC,
        worldEdge0 = fsa_worldEdge0,
        worldEdge1 = fsa_worldEdge1,
        Cross = fsa_Cross;

    var dmin = Number.MAX_VALUE;
    var hullA = this;
    var curPlaneTests=0;

    if(!hullA.uniqueAxes){

        var numFacesA = faceListA ? faceListA.length : hullA.faces.length;

        // Test face normals from hullA
        for(var i=0; i<numFacesA; i++){
            var fi = faceListA ? faceListA[i] : i;

            // Get world face normal
            faceANormalWS3.copy(hullA.faceNormals[fi]);
            quatA.vmult(faceANormalWS3,faceANormalWS3);

            var d = hullA.testSepAxis(faceANormalWS3, hullB, posA, quatA, posB, quatB);
            if(d===false){
                return false;
            }

            if(d<dmin){
                dmin = d;
                target.copy(faceANormalWS3);
            }
        }

    } else {

        // Test unique axes
        for(var i = 0; i !== hullA.uniqueAxes.length; i++){

            // Get world axis
            quatA.vmult(hullA.uniqueAxes[i],faceANormalWS3);

            var d = hullA.testSepAxis(faceANormalWS3, hullB, posA, quatA, posB, quatB);
            if(d===false){
                return false;
            }

            if(d<dmin){
                dmin = d;
                target.copy(faceANormalWS3);
            }
        }
    }

    if(!hullB.uniqueAxes){

        // Test face normals from hullB
        var numFacesB = faceListB ? faceListB.length : hullB.faces.length;
        for(var i=0;i<numFacesB;i++){

            var fi = faceListB ? faceListB[i] : i;

            Worldnormal1.copy(hullB.faceNormals[fi]);
            quatB.vmult(Worldnormal1,Worldnormal1);
            curPlaneTests++;
            var d = hullA.testSepAxis(Worldnormal1, hullB,posA,quatA,posB,quatB);
            if(d===false){
                return false;
            }

            if(d<dmin){
                dmin = d;
                target.copy(Worldnormal1);
            }
        }
    } else {

        // Test unique axes in B
        for(var i = 0; i !== hullB.uniqueAxes.length; i++){
            quatB.vmult(hullB.uniqueAxes[i],Worldnormal1);

            curPlaneTests++;
            var d = hullA.testSepAxis(Worldnormal1, hullB,posA,quatA,posB,quatB);
            if(d===false){
                return false;
            }

            if(d<dmin){
                dmin = d;
                target.copy(Worldnormal1);
            }
        }
    }

    // Test edges
    for(var e0=0; e0 !== hullA.uniqueEdges.length; e0++){

        // Get world edge
        quatA.vmult(hullA.uniqueEdges[e0],worldEdge0);

        for(var e1=0; e1 !== hullB.uniqueEdges.length; e1++){

            // Get world edge 2
            quatB.vmult(hullB.uniqueEdges[e1], worldEdge1);
            worldEdge0.cross(worldEdge1,Cross);

            if(!Cross.almostZero()){
                Cross.normalize();
                var dist = hullA.testSepAxis(Cross, hullB, posA, quatA, posB, quatB);
                if(dist === false){
                    return false;
                }
                if(dist < dmin){
                    dmin = dist;
                    target.copy(Cross);
                }
            }
        }
    }

    posB.vsub(posA,deltaC);
    if((deltaC.dot(target))>0.0){
        target.negate(target);
    }

    return true;
};

var maxminA=[], maxminB=[];

/**
 * Test separating axis against two hulls. Both hulls are projected onto the axis and the overlap size is returned if there is one.
 * @method testSepAxis
 * @param {Vec3} axis
 * @param {ConvexPolyhedron} hullB
 * @param {Vec3} posA
 * @param {Quaternion} quatA
 * @param {Vec3} posB
 * @param {Quaternion} quatB
 * @return {number} The overlap depth, or FALSE if no penetration.
 */
ConvexPolyhedron.prototype.testSepAxis = function(axis, hullB, posA, quatA, posB, quatB){
    var hullA=this;
    ConvexPolyhedron.project(hullA, axis, posA, quatA, maxminA);
    ConvexPolyhedron.project(hullB, axis, posB, quatB, maxminB);
    var maxA = maxminA[0];
    var minA = maxminA[1];
    var maxB = maxminB[0];
    var minB = maxminB[1];
    if(maxA<minB || maxB<minA){
        return false; // Separated
    }
    var d0 = maxA - minB;
    var d1 = maxB - minA;
    var depth = d0<d1 ? d0:d1;
    return depth;
};

var cli_aabbmin = new Vec3(),
    cli_aabbmax = new Vec3();

/**
 * @method calculateLocalInertia
 * @param  {Number} mass
 * @param  {Vec3} target
 */
ConvexPolyhedron.prototype.calculateLocalInertia = function(mass,target){
    // Approximate with box inertia
    // Exact inertia calculation is overkill, but see http://geometrictools.com/Documentation/PolyhedralMassProperties.pdf for the correct way to do it
    this.computeLocalAABB(cli_aabbmin,cli_aabbmax);
    var x = cli_aabbmax.x - cli_aabbmin.x,
        y = cli_aabbmax.y - cli_aabbmin.y,
        z = cli_aabbmax.z - cli_aabbmin.z;
    target.x = 1.0 / 12.0 * mass * ( 2*y*2*y + 2*z*2*z );
    target.y = 1.0 / 12.0 * mass * ( 2*x*2*x + 2*z*2*z );
    target.z = 1.0 / 12.0 * mass * ( 2*y*2*y + 2*x*2*x );
};

/**
 * @method getPlaneConstantOfFace
 * @param  {Number} face_i Index of the face
 * @return {Number}
 */
ConvexPolyhedron.prototype.getPlaneConstantOfFace = function(face_i){
    var f = this.faces[face_i];
    var n = this.faceNormals[face_i];
    var v = this.vertices[f[0]];
    var c = -n.dot(v);
    return c;
};

/**
 * Clip a face against a hull.
 * @method clipFaceAgainstHull
 * @param {Vec3} separatingNormal
 * @param {Vec3} posA
 * @param {Quaternion} quatA
 * @param {Array} worldVertsB1 An array of Vec3 with vertices in the world frame.
 * @param {Number} minDist Distance clamping
 * @param {Number} maxDist
 * @param Array result Array to store resulting contact points in. Will be objects with properties: point, depth, normal. These are represented in world coordinates.
 */
var cfah_faceANormalWS = new Vec3(),
    cfah_edge0 = new Vec3(),
    cfah_WorldEdge0 = new Vec3(),
    cfah_worldPlaneAnormal1 = new Vec3(),
    cfah_planeNormalWS1 = new Vec3(),
    cfah_worldA1 = new Vec3(),
    cfah_localPlaneNormal = new Vec3(),
    cfah_planeNormalWS = new Vec3();
ConvexPolyhedron.prototype.clipFaceAgainstHull = function(separatingNormal, posA, quatA, worldVertsB1, minDist, maxDist,result){
    var faceANormalWS = cfah_faceANormalWS,
        edge0 = cfah_edge0,
        WorldEdge0 = cfah_WorldEdge0,
        worldPlaneAnormal1 = cfah_worldPlaneAnormal1,
        planeNormalWS1 = cfah_planeNormalWS1,
        worldA1 = cfah_worldA1,
        localPlaneNormal = cfah_localPlaneNormal,
        planeNormalWS = cfah_planeNormalWS;

    var hullA = this;
    var worldVertsB2 = [];
    var pVtxIn = worldVertsB1;
    var pVtxOut = worldVertsB2;
    // Find the face with normal closest to the separating axis
    var closestFaceA = -1;
    var dmin = Number.MAX_VALUE;
    for(var face=0; face<hullA.faces.length; face++){
        faceANormalWS.copy(hullA.faceNormals[face]);
        quatA.vmult(faceANormalWS,faceANormalWS);
        //posA.vadd(faceANormalWS,faceANormalWS);
        var d = faceANormalWS.dot(separatingNormal);
        if (d < dmin){
            dmin = d;
            closestFaceA = face;
        }
    }
    if (closestFaceA < 0){
        // console.log("--- did not find any closest face... ---");
        return;
    }
    //console.log("closest A: ",closestFaceA);
    // Get the face and construct connected faces
    var polyA = hullA.faces[closestFaceA];
    polyA.connectedFaces = [];
    for(var i=0; i<hullA.faces.length; i++){
        for(var j=0; j<hullA.faces[i].length; j++){
            if(polyA.indexOf(hullA.faces[i][j])!==-1 /* Sharing a vertex*/ && i!==closestFaceA /* Not the one we are looking for connections from */ && polyA.connectedFaces.indexOf(i)===-1 /* Not already added */ ){
                polyA.connectedFaces.push(i);
            }
        }
    }
    // Clip the polygon to the back of the planes of all faces of hull A, that are adjacent to the witness face
    var numContacts = pVtxIn.length;
    var numVerticesA = polyA.length;
    var res = [];
    for(var e0=0; e0<numVerticesA; e0++){
        var a = hullA.vertices[polyA[e0]];
        var b = hullA.vertices[polyA[(e0+1)%numVerticesA]];
        a.vsub(b,edge0);
        WorldEdge0.copy(edge0);
        quatA.vmult(WorldEdge0,WorldEdge0);
        posA.vadd(WorldEdge0,WorldEdge0);
        worldPlaneAnormal1.copy(this.faceNormals[closestFaceA]);//transA.getBasis()* btVector3(polyA.m_plane[0],polyA.m_plane[1],polyA.m_plane[2]);
        quatA.vmult(worldPlaneAnormal1,worldPlaneAnormal1);
        posA.vadd(worldPlaneAnormal1,worldPlaneAnormal1);
        WorldEdge0.cross(worldPlaneAnormal1,planeNormalWS1);
        planeNormalWS1.negate(planeNormalWS1);
        worldA1.copy(a);
        quatA.vmult(worldA1,worldA1);
        posA.vadd(worldA1,worldA1);
        var planeEqWS1 = -worldA1.dot(planeNormalWS1);
        var planeEqWS;
        if(true){
            var otherFace = polyA.connectedFaces[e0];
            localPlaneNormal.copy(this.faceNormals[otherFace]);
            var localPlaneEq = this.getPlaneConstantOfFace(otherFace);

            planeNormalWS.copy(localPlaneNormal);
            quatA.vmult(planeNormalWS,planeNormalWS);
            //posA.vadd(planeNormalWS,planeNormalWS);
            var planeEqWS = localPlaneEq - planeNormalWS.dot(posA);
        } else  {
            planeNormalWS.copy(planeNormalWS1);
            planeEqWS = planeEqWS1;
        }

        // Clip face against our constructed plane
        this.clipFaceAgainstPlane(pVtxIn, pVtxOut, planeNormalWS, planeEqWS);

        // Throw away all clipped points, but save the reamining until next clip
        while(pVtxIn.length){
            pVtxIn.shift();
        }
        while(pVtxOut.length){
            pVtxIn.push(pVtxOut.shift());
        }
    }

    //console.log("Resulting points after clip:",pVtxIn);

    // only keep contact points that are behind the witness face
    localPlaneNormal.copy(this.faceNormals[closestFaceA]);

    var localPlaneEq = this.getPlaneConstantOfFace(closestFaceA);
    planeNormalWS.copy(localPlaneNormal);
    quatA.vmult(planeNormalWS,planeNormalWS);

    var planeEqWS = localPlaneEq - planeNormalWS.dot(posA);
    for (var i=0; i<pVtxIn.length; i++){
        var depth = planeNormalWS.dot(pVtxIn[i]) + planeEqWS; //???
        /*console.log("depth calc from normal=",planeNormalWS.toString()," and constant "+planeEqWS+" and vertex ",pVtxIn[i].toString()," gives "+depth);*/
        if (depth <=minDist){
            console.log("clamped: depth="+depth+" to minDist="+(minDist+""));
            depth = minDist;
        }

        if (depth <=maxDist){
            var point = pVtxIn[i];
            if(depth<=0){
                /*console.log("Got contact point ",point.toString(),
                  ", depth=",depth,
                  "contact normal=",separatingNormal.toString(),
                  "plane",planeNormalWS.toString(),
                  "planeConstant",planeEqWS);*/
                var p = {
                    point:point,
                    normal:planeNormalWS,
                    depth: depth,
                };
                result.push(p);
            }
        }
    }
};

/**
 * Clip a face in a hull against the back of a plane.
 * @method clipFaceAgainstPlane
 * @param {Array} inVertices
 * @param {Array} outVertices
 * @param {Vec3} planeNormal
 * @param {Number} planeConstant The constant in the mathematical plane equation
 */
ConvexPolyhedron.prototype.clipFaceAgainstPlane = function(inVertices,outVertices, planeNormal, planeConstant){
    var n_dot_first, n_dot_last;
    var numVerts = inVertices.length;

    if(numVerts < 2){
        return outVertices;
    }

    var firstVertex = inVertices[inVertices.length-1],
        lastVertex =   inVertices[0];

    n_dot_first = planeNormal.dot(firstVertex) + planeConstant;

    for(var vi = 0; vi < numVerts; vi++){
        lastVertex = inVertices[vi];
        n_dot_last = planeNormal.dot(lastVertex) + planeConstant;
        if(n_dot_first < 0){
            if(n_dot_last < 0){
                // Start < 0, end < 0, so output lastVertex
                var newv = new Vec3();
                newv.copy(lastVertex);
                outVertices.push(newv);
            } else {
                // Start < 0, end >= 0, so output intersection
                var newv = new Vec3();
                firstVertex.lerp(lastVertex,
                                 n_dot_first / (n_dot_first - n_dot_last),
                                 newv);
                outVertices.push(newv);
            }
        } else {
            if(n_dot_last<0){
                // Start >= 0, end < 0 so output intersection and end
                var newv = new Vec3();
                firstVertex.lerp(lastVertex,
                                 n_dot_first / (n_dot_first - n_dot_last),
                                 newv);
                outVertices.push(newv);
                outVertices.push(lastVertex);
            }
        }
        firstVertex = lastVertex;
        n_dot_first = n_dot_last;
    }
    return outVertices;
};

// Updates .worldVertices and sets .worldVerticesNeedsUpdate to false.
ConvexPolyhedron.prototype.computeWorldVertices = function(position,quat){
    var N = this.vertices.length;
    while(this.worldVertices.length < N){
        this.worldVertices.push( new Vec3() );
    }

    var verts = this.vertices,
        worldVerts = this.worldVertices;
    for(var i=0; i!==N; i++){
        quat.vmult( verts[i] , worldVerts[i] );
        position.vadd( worldVerts[i] , worldVerts[i] );
    }

    this.worldVerticesNeedsUpdate = false;
};

var computeLocalAABB_worldVert = new Vec3();
ConvexPolyhedron.prototype.computeLocalAABB = function(aabbmin,aabbmax){
    var n = this.vertices.length,
        vertices = this.vertices,
        worldVert = computeLocalAABB_worldVert;

    aabbmin.set(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
    aabbmax.set(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);

    for(var i=0; i<n; i++){
        var v = vertices[i];
        if     (v.x < aabbmin.x){
            aabbmin.x = v.x;
        } else if(v.x > aabbmax.x){
            aabbmax.x = v.x;
        }
        if     (v.y < aabbmin.y){
            aabbmin.y = v.y;
        } else if(v.y > aabbmax.y){
            aabbmax.y = v.y;
        }
        if     (v.z < aabbmin.z){
            aabbmin.z = v.z;
        } else if(v.z > aabbmax.z){
            aabbmax.z = v.z;
        }
    }
};

/**
 * Updates .worldVertices and sets .worldVerticesNeedsUpdate to false.
 * @method computeWorldFaceNormals
 * @param  {Quaternion} quat
 */
ConvexPolyhedron.prototype.computeWorldFaceNormals = function(quat){
    var N = this.faceNormals.length;
    while(this.worldFaceNormals.length < N){
        this.worldFaceNormals.push( new Vec3() );
    }

    var normals = this.faceNormals,
        worldNormals = this.worldFaceNormals;
    for(var i=0; i!==N; i++){
        quat.vmult( normals[i] , worldNormals[i] );
    }

    this.worldFaceNormalsNeedsUpdate = false;
};

/**
 * @method updateBoundingSphereRadius
 */
ConvexPolyhedron.prototype.updateBoundingSphereRadius = function(){
    // Assume points are distributed with local (0,0,0) as center
    var max2 = 0;
    var verts = this.vertices;
    for(var i=0, N=verts.length; i!==N; i++) {
        var norm2 = verts[i].norm2();
        if(norm2 > max2){
            max2 = norm2;
        }
    }
    this.boundingSphereRadius = Math.sqrt(max2);
};

var tempWorldVertex = new Vec3();

/**
 * @method calculateWorldAABB
 * @param {Vec3}        pos
 * @param {Quaternion}  quat
 * @param {Vec3}        min
 * @param {Vec3}        max
 */
ConvexPolyhedron.prototype.calculateWorldAABB = function(pos,quat,min,max){
    var n = this.vertices.length, verts = this.vertices;
    var minx,miny,minz,maxx,maxy,maxz;
    for(var i=0; i<n; i++){
        tempWorldVertex.copy(verts[i]);
        quat.vmult(tempWorldVertex,tempWorldVertex);
        pos.vadd(tempWorldVertex,tempWorldVertex);
        var v = tempWorldVertex;
        if     (v.x < minx || minx===undefined){
            minx = v.x;
        } else if(v.x > maxx || maxx===undefined){
            maxx = v.x;
        }

        if     (v.y < miny || miny===undefined){
            miny = v.y;
        } else if(v.y > maxy || maxy===undefined){
            maxy = v.y;
        }

        if     (v.z < minz || minz===undefined){
            minz = v.z;
        } else if(v.z > maxz || maxz===undefined){
            maxz = v.z;
        }
    }
    min.set(minx,miny,minz);
    max.set(maxx,maxy,maxz);
};

/**
 * Get approximate convex volume
 * @method volume
 * @return {Number}
 */
ConvexPolyhedron.prototype.volume = function(){
    return 4.0 * Math.PI * this.boundingSphereRadius / 3.0;
};

/**
 * Get an average of all the vertices positions
 * @method getAveragePointLocal
 * @param  {Vec3} target
 * @return {Vec3}
 */
ConvexPolyhedron.prototype.getAveragePointLocal = function(target){
    target = target || new Vec3();
    var n = this.vertices.length,
        verts = this.vertices;
    for(var i=0; i<n; i++){
        target.vadd(verts[i],target);
    }
    target.mult(1/n,target);
    return target;
};

/**
 * Transform all local points. Will change the .vertices
 * @method transformAllPoints
 * @param  {Vec3} offset
 * @param  {Quaternion} quat
 */
ConvexPolyhedron.prototype.transformAllPoints = function(offset,quat){
    var n = this.vertices.length,
        verts = this.vertices;

    // Apply rotation
    if(quat){
        // Rotate vertices
        for(var i=0; i<n; i++){
            var v = verts[i];
            quat.vmult(v,v);
        }
        // Rotate face normals
        for(var i=0; i<this.faceNormals.length; i++){
            var v = this.faceNormals[i];
            quat.vmult(v,v);
        }
        /*
        // Rotate edges
        for(var i=0; i<this.uniqueEdges.length; i++){
            var v = this.uniqueEdges[i];
            quat.vmult(v,v);
        }*/
    }

    // Apply offset
    if(offset){
        for(var i=0; i<n; i++){
            var v = verts[i];
            v.vadd(offset,v);
        }
    }
};

/**
 * Checks whether p is inside the polyhedra. Must be in local coords. The point lies outside of the convex hull of the other points if and only if the direction of all the vectors from it to those other points are on less than one half of a sphere around it.
 * @method pointIsInside
 * @param  {Vec3} p      A point given in local coordinates
 * @return {Boolean}
 */
var ConvexPolyhedron_pointIsInside = new Vec3();
var ConvexPolyhedron_vToP = new Vec3();
var ConvexPolyhedron_vToPointInside = new Vec3();
ConvexPolyhedron.prototype.pointIsInside = function(p){
    var n = this.vertices.length,
        verts = this.vertices,
        faces = this.faces,
        normals = this.faceNormals;
    var positiveResult = null;
    var N = this.faces.length;
    var pointInside = ConvexPolyhedron_pointIsInside;
    this.getAveragePointLocal(pointInside);
    for(var i=0; i<N; i++){
        var numVertices = this.faces[i].length;
        var n = normals[i];
        var v = verts[faces[i][0]]; // We only need one point in the face

        // This dot product determines which side of the edge the point is
        var vToP = ConvexPolyhedron_vToP;
        p.vsub(v,vToP);
        var r1 = n.dot(vToP);

        var vToPointInside = ConvexPolyhedron_vToPointInside;
        pointInside.vsub(v,vToPointInside);
        var r2 = n.dot(vToPointInside);

        if((r1<0 && r2>0) || (r1>0 && r2<0)){
            return false; // Encountered some other sign. Exit.
        } else {
        }
    }

    // If we got here, all dot products were of the same sign.
    return positiveResult ? 1 : -1;
};

/**
 * Get max and min dot product of a convex hull at position (pos,quat) projected onto an axis. Results are saved in the array maxmin.
 * @static
 * @method project
 * @param {ConvexPolyhedron} hull
 * @param {Vec3} axis
 * @param {Vec3} pos
 * @param {Quaternion} quat
 * @param {array} result result[0] and result[1] will be set to maximum and minimum, respectively.
 */
var project_worldVertex = new Vec3();
var project_localAxis = new Vec3();
var project_localOrigin = new Vec3();
ConvexPolyhedron.project = function(hull, axis, pos, quat, result){
    var n = hull.vertices.length,
        worldVertex = project_worldVertex,
        localAxis = project_localAxis,
        max = 0,
        min = 0,
        localOrigin = project_localOrigin,
        vs = hull.vertices;

    localOrigin.setZero();

    // Transform the axis to local
    Transform.vectorToLocalFrame(pos, quat, axis, localAxis);
    Transform.pointToLocalFrame(pos, quat, localOrigin, localOrigin);
    var add = localOrigin.dot(localAxis);

    min = max = vs[0].dot(localAxis);

    for(var i = 1; i < n; i++){
        var val = vs[i].dot(localAxis);

        if(val > max){
            max = val;
        }

        if(val < min){
            min = val;
        }
    }

    min -= add;
    max -= add;

    if(min > max){
        // Inconsistent - swap
        var temp = min;
        min = max;
        max = temp;
    }
    // Output
    result[0] = max;
    result[1] = min;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @struct
 * @param {!string} type The event type
 * @param {!Node} snapshotNode The data
 * @param {string=} childName The name for this child, if it's a child event
 * @param {Node=} oldSnap Used for intermediate processing of child changed events
 * @param {string=} prevName The name for the previous child, if applicable
 */
var Change = /** @class */function () {
  function Change(type, snapshotNode, childName, oldSnap, prevName) {
    this.type = type;
    this.snapshotNode = snapshotNode;
    this.childName = childName;
    this.oldSnap = oldSnap;
    this.prevName = prevName;
  }
  /**
   * @param {!Node} snapshot
   * @return {!Change}
   */
  Change.valueChange = function (snapshot) {
    return new Change(Change.VALUE, snapshot);
  };
  /**
   * @param {string} childKey
   * @param {!Node} snapshot
   * @return {!Change}
   */
  Change.childAddedChange = function (childKey, snapshot) {
    return new Change(Change.CHILD_ADDED, snapshot, childKey);
  };
  /**
   * @param {string} childKey
   * @param {!Node} snapshot
   * @return {!Change}
   */
  Change.childRemovedChange = function (childKey, snapshot) {
    return new Change(Change.CHILD_REMOVED, snapshot, childKey);
  };
  /**
   * @param {string} childKey
   * @param {!Node} newSnapshot
   * @param {!Node} oldSnapshot
   * @return {!Change}
   */
  Change.childChangedChange = function (childKey, newSnapshot, oldSnapshot) {
    return new Change(Change.CHILD_CHANGED, newSnapshot, childKey, oldSnapshot);
  };
  /**
   * @param {string} childKey
   * @param {!Node} snapshot
   * @return {!Change}
   */
  Change.childMovedChange = function (childKey, snapshot) {
    return new Change(Change.CHILD_MOVED, snapshot, childKey);
  };
  //event types
  /** Event type for a child added */
  Change.CHILD_ADDED = 'child_added';
  /** Event type for a child removed */
  Change.CHILD_REMOVED = 'child_removed';
  /** Event type for a child changed */
  Change.CHILD_CHANGED = 'child_changed';
  /** Event type for a child moved */
  Change.CHILD_MOVED = 'child_moved';
  /** Event type for a value change */
  Change.VALUE = 'value';
  return Change;
}();
exports.Change = Change;
//# sourceMappingURL=Change.js.map


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.contains = contains;
exports.forEach = forEach;
exports.clone = clone;
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Contains methods for working with objects.
 */
function contains(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function forEach(obj, f) {
    for (var key in obj) {
        if (contains(obj, key)) {
            f(key, obj[key]);
        }
    }
}
function clone(obj) {
    if (obj == null) {
        return {};
    }
    var c = {};
    forEach(obj, function (key, val) {
        c[key] = val;
    });
    return c;
}
//# sourceMappingURL=object.js.map


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isNodeSdk = exports.isReactNative = exports.isMobileCordova = exports.getUA = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Copyright 2017 Google Inc.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Licensed under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                               * you may not use this file except in compliance with the License.
                                                                                                                                                                                                                                                                               * You may obtain a copy of the License at
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               *   http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Unless required by applicable law or agreed to in writing, software
                                                                                                                                                                                                                                                                               * distributed under the License is distributed on an "AS IS" BASIS,
                                                                                                                                                                                                                                                                               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                                                                                                                                                                                                               * See the License for the specific language governing permissions and
                                                                                                                                                                                                                                                                               * limitations under the License.
                                                                                                                                                                                                                                                                               */


var _constants = __webpack_require__(86);

/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return {string} user agent string
 */
var getUA = exports.getUA = function getUA() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    } else {
        return '';
    }
};
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap in the Ripple emulator) nor
 * Cordova `onDeviceReady`, which would normally wait for a callback.
 *
 * @return {boolean} isMobileCordova
 */
var isMobileCordova = exports.isMobileCordova = function isMobileCordova() {
    return typeof window !== 'undefined' && !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA());
};
/**
 * Detect React Native.
 *
 * @return {boolean} True if ReactNative environment is detected.
 */
var isReactNative = exports.isReactNative = function isReactNative() {
    return (typeof navigator === 'undefined' ? 'undefined' : _typeof(navigator)) === 'object' && navigator['product'] === 'ReactNative';
};
/**
 * Detect Node.js.
 *
 * @return {boolean} True if Node.js environment is detected.
 */
var isNodeSdk = exports.isNodeSdk = function isNodeSdk() {
    return _constants.CONSTANTS.NODE_CLIENT === true || _constants.CONSTANTS.NODE_ADMIN === true;
};
//# sourceMappingURL=environment.js.map


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(118);
var setInnerHTML = __webpack_require__(92);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(126);
var setTextContent = __webpack_require__(219);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(1);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(493);
var ReactInstrumentation = __webpack_require__(22);

var warning = __webpack_require__(4);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var ReactBaseClasses = __webpack_require__(225);
var ReactChildren = __webpack_require__(531);
var ReactDOMFactories = __webpack_require__(532);
var ReactElement = __webpack_require__(55);
var ReactPropTypes = __webpack_require__(533);
var ReactVersion = __webpack_require__(534);

var createReactClass = __webpack_require__(535);
var onlyChild = __webpack_require__(539);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var ReactCurrentOwner = __webpack_require__(29);

var warning = __webpack_require__(4);
var canDefineProperty = __webpack_require__(229);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(227);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export endSpeech */
/* unused harmony export resetSpeech */
/* unused harmony export setInterimResult */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setFinalResult; });
/* unused harmony export clearResult */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return startSpeech; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return stopSpeech; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stopSpeechKeyboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return abortSpeech; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__search_js__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(25);







var endSpeech = function endSpeech(result, searchType) {

    return function (dispatch) {

        // dispatch( searchFetch(result) )

        return {
            type: "SPEECH_END",
            result: result,
            searchType: searchType
        };
    };
};

var resetSpeech = function resetSpeech() {

    var sphere = document.getElementById("small-sphere");
    sphere.emit("sphereclose");

    return {
        type: "MIC_RESET"
    };
};

var setInterimResult = function setInterimResult(result) {

    return {
        type: "SET_INTERIM_SPEECH",
        result: result
    };
};

var setFinalResult = function setFinalResult(result) {

    return function (dispatch) {

        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__search_js__["a" /* searchFetch */])(result));

        return {
            type: "SET_FINAL_SPEECH",
            result: result
        };
    };
};

var clearResult = function clearResult() {

    return {
        type: "CLEAR_RESULT"
    };
};

// const onnomatch = () => {
//     console.log("DEBUG: Failed To Math Recognition Audio");
// }

var onstart = function onstart() {
    console.log("DEBUG: Speech Recognition Activated");

    return {
        type: "SPEECH_STARTED"
    };
};

var onresult = function onresult(e) {
    console.log("DEBUG: Result", e);

    var interrimResult = "";
    for (var i = e.resultIndex; i < e.results.length; ++i) {

        if (!e.results[i].isFinal) {
            interrimResult += e.results[i][0].transcript;
            console.log(interrimResult);

            __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(setInterimResult(interrimResult));
        } else {
            console.log("DEBUG: Finnished", e.results[i][0].transcript);

            __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(setFinalResult(e.results[i][0].transcript));
        }
    }
};

var onerror = function onerror(e) {
    console.log("DEBUG: Speech Recognition Error", e);

    return {
        type: "SPEECH_ERROR",
        event: e
    };
};

var onend = function onend(e) {

    return function (dispatch, getState) {
        var state = getState();

        console.log("DEBUG: Speech Recognition Endeds");

        if (state.microphone.text.length === 0) {
            console.log("Reseting Speech");

            dispatch(resetSpeech());
            return;
        }

        console.log("Ending Speech");
        dispatch(endSpeech(state.microphone.text, state.globalState.searchType));
    };
};

var recognition = new window.webkitSpeechRecognition();

if (!('webkitSpeechRecognition' in window)) {
    console.error("Webkit Speech Recogntion Not Supported");

    this.props.speechErrorHUD();
} else {

    recognition.lang = "en-US";
    // this.recognition.lang = "uk-UA"

    recognition.continuous = false;
    recognition.interimResults = true;

    recognition.onstart = function () {
        return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(onstart());
    };
    recognition.onresult = function (e) {
        return onresult(e);
    };
    recognition.onerror = function (e) {
        return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(onerror(e));
    };
    recognition.onend = function (e) {
        return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(onend(e));
    };

    // recognition.onnomatch = () => onnomatch()
}

var startSpeech = function startSpeech() {

    var sphere = document.getElementById("small-sphere");
    sphere.emit("sphereopen");

    recognition.start();

    return {
        type: "SPEECH_START"
    };
};

var stopSpeech = function stopSpeech() {

    return function (dispatch) {

        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["e" /* setWorldState */])("WORLD_VIEW"));

        recognition.abort();

        return {
            type: "SPEECH_ABORT"
        };
    };
};

var stopSpeechKeyboard = function stopSpeechKeyboard() {

    return function (dispatch) {
        recognition.abort();
        return {
            type: "SPEECH_ABORT"
        };
    };
};

var abortSpeech = function abortSpeech() {

    var sphere = document.getElementById("small-sphere");
    sphere.emit("sphereclose");

    recognition.stop();

    return {
        type: "SPEECH_STOP"
    };
};

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aframe__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aframe__);


__WEBPACK_IMPORTED_MODULE_0_aframe___default.a.registerComponent('fixed', {
    schema: {
        enabled: {
            type: "boolean",
            default: true
        },

        fixY: {
            type: "boolean",
            default: true
        },

        fixX: {
            type: "boolean",
            default: true
        },

        offsetX: {
            type: "number",
            default: 0.0
        },

        offsetY: {
            type: "number",
            default: 0.0
        }
    },

    init: function init() {
        this.onCameraChangeBinded = this.onCameraChange.bind(this);
        this.camera = document.getElementById('camera');

        var rotation = this.el.getAttribute('rotation');
        var angles = this.camera.getAttribute("rotation");

        if (this.data.enabled) {
            this.el.setAttribute('rotation', {
                x: this.data.fixX ? angles.x : rotation.x,
                y: this.data.fixY ? angles.y : rotation.y
            });
        }

        this.camera.addEventListener('componentchanged', this.onCameraChangeBinded);
    },

    remove: function remove() {
        this.camera.removeEventListener('componentchanged', this.onCameraChangeBinded);
    },

    onCameraChange: function onCameraChange(e) {
        // console.log(this);

        if (e.detail.name !== 'rotation' || !this.data.enabled) {
            return;
        }

        var rotation = this.el.getAttribute('rotation');

        var cameraAngleY = e.detail.newData.y + this.data.offsetY;
        var cameraAngleX = e.detail.newData.x + this.data.offsetX;

        this.el.setAttribute('rotation', {
            x: this.data.fixX ? cameraAngleX : rotation.x,
            y: this.data.fixY ? cameraAngleY : rotation.y
        });
    }

});

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Vec3 = __webpack_require__(0);

module.exports = RaycastResult;

/**
 * Storage for Ray casting data.
 * @class RaycastResult
 * @constructor
 */
function RaycastResult(){

	/**
	 * @property {Vec3} rayFromWorld
	 */
	this.rayFromWorld = new Vec3();

	/**
	 * @property {Vec3} rayToWorld
	 */
	this.rayToWorld = new Vec3();

	/**
	 * @property {Vec3} hitNormalWorld
	 */
	this.hitNormalWorld = new Vec3();

	/**
	 * @property {Vec3} hitPointWorld
	 */
	this.hitPointWorld = new Vec3();

	/**
	 * @property {boolean} hasHit
	 */
	this.hasHit = false;

	/**
	 * The hit shape, or null.
	 * @property {Shape} shape
	 */
	this.shape = null;

	/**
	 * The hit body, or null.
	 * @property {Body} body
	 */
	this.body = null;

	/**
	 * The index of the hit triangle, if the hit shape was a trimesh.
	 * @property {number} hitFaceIndex
	 * @default -1
	 */
	this.hitFaceIndex = -1;

	/**
	 * Distance to the hit. Will be set to -1 if there was no hit.
	 * @property {number} distance
	 * @default -1
	 */
	this.distance = -1;

	/**
	 * If the ray should stop traversing the bodies.
	 * @private
	 * @property {Boolean} _shouldStop
	 * @default false
	 */
	this._shouldStop = false;
}

/**
 * Reset all result data.
 * @method reset
 */
RaycastResult.prototype.reset = function () {
	this.rayFromWorld.setZero();
	this.rayToWorld.setZero();
	this.hitNormalWorld.setZero();
	this.hitPointWorld.setZero();
	this.hasHit = false;
	this.shape = null;
	this.body = null;
	this.hitFaceIndex = -1;
	this.distance = -1;
	this._shouldStop = false;
};

/**
 * @method abort
 */
RaycastResult.prototype.abort = function(){
	this._shouldStop = true;
};

/**
 * @method set
 * @param {Vec3} rayFromWorld
 * @param {Vec3} rayToWorld
 * @param {Vec3} hitNormalWorld
 * @param {Vec3} hitPointWorld
 * @param {Shape} shape
 * @param {Body} body
 * @param {number} distance
 */
RaycastResult.prototype.set = function(
	rayFromWorld,
	rayToWorld,
	hitNormalWorld,
	hitPointWorld,
	shape,
	body,
	distance
){
	this.rayFromWorld.copy(rayFromWorld);
	this.rayToWorld.copy(rayToWorld);
	this.hitNormalWorld.copy(hitNormalWorld);
	this.hitPointWorld.copy(hitPointWorld);
	this.shape = shape;
	this.body = body;
	this.distance = distance;
};

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = Material;

/**
 * Defines a physics material.
 * @class Material
 * @constructor
 * @param {object} [options]
 * @author schteppe
 */
function Material(options){
    var name = '';
    options = options || {};

    // Backwards compatibility fix
    if(typeof(options) === 'string'){
        name = options;
        options = {};
    } else if(typeof(options) === 'object') {
        name = '';
    }

    /**
     * @property name
     * @type {String}
     */
    this.name = name;

    /**
     * material id.
     * @property id
     * @type {number}
     */
    this.id = Material.idCounter++;

    /**
     * Friction for this material. If non-negative, it will be used instead of the friction given by ContactMaterials. If there's no matching ContactMaterial, the value from .defaultContactMaterial in the World will be used.
     * @property {number} friction
     */
    this.friction = typeof(options.friction) !== 'undefined' ? options.friction : -1;

    /**
     * Restitution for this material. If non-negative, it will be used instead of the restitution given by ContactMaterials. If there's no matching ContactMaterial, the value from .defaultContactMaterial in the World will be used.
     * @property {number} restitution
     */
    this.restitution = typeof(options.restitution) !== 'undefined' ? options.restitution : -1;
}

Material.idCounter = 0;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

function Utils(){}

module.exports = Utils;

/**
 * Extend an options object with default values.
 * @static
 * @method defaults
 * @param  {object} options The options object. May be falsy: in this case, a new object is created and returned.
 * @param  {object} defaults An object containing default values.
 * @return {object} The modified options object.
 */
Utils.defaults = function(options, defaults){
    options = options || {};

    for(var key in defaults){
        if(!(key in options)){
            options[key] = defaults[key];
        }
    }

    return options;
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.KEY_INDEX = exports.KeyIndex = undefined;

var _Index = __webpack_require__(79);

var _Node = __webpack_require__(19);

var _util = __webpack_require__(3);

var _assert = __webpack_require__(2);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();

var __EMPTY_NODE;
var KeyIndex = /** @class */function (_super) {
    __extends(KeyIndex, _super);
    function KeyIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(KeyIndex, "__EMPTY_NODE", {
        get: function get() {
            return __EMPTY_NODE;
        },
        set: function set(val) {
            __EMPTY_NODE = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.compare = function (a, b) {
        return (0, _util.nameCompare)(a.name, b.name);
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.isDefinedOn = function (node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw (0, _assert.assertionError)('KeyIndex.isDefinedOn not expected to be called.');
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return false; // The key for a node never changes.
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.minPost = function () {
        return _Node.NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.maxPost = function () {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new _Node.NamedNode(_util.MAX_NAME, __EMPTY_NODE);
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    KeyIndex.prototype.makePost = function (indexValue, name) {
        (0, _assert.assert)(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new _Node.NamedNode(indexValue, __EMPTY_NODE);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    KeyIndex.prototype.toString = function () {
        return '.key';
    };
    return KeyIndex;
}(_Index.Index);
exports.KeyIndex = KeyIndex;
var KEY_INDEX = exports.KEY_INDEX = new KeyIndex();
//# sourceMappingURL=KeyIndex.js.map


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Copyright 2017 Google Inc.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Licensed under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                               * you may not use this file except in compliance with the License.
                                                                                                                                                                                                                                                                               * You may obtain a copy of the License at
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               *   http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Unless required by applicable law or agreed to in writing, software
                                                                                                                                                                                                                                                                               * distributed under the License is distributed on an "AS IS" BASIS,
                                                                                                                                                                                                                                                                               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                                                                                                                                                                                                               * See the License for the specific language governing permissions and
                                                                                                                                                                                                                                                                               * limitations under the License.
                                                                                                                                                                                                                                                                               */


exports.nodeFromJSON = nodeFromJSON;

var _ChildrenNode = __webpack_require__(16);

var _LeafNode = __webpack_require__(78);

var _Node = __webpack_require__(19);

var _obj = __webpack_require__(7);

var _assert = __webpack_require__(2);

var _childSet = __webpack_require__(168);

var _comparators = __webpack_require__(169);

var _IndexMap = __webpack_require__(167);

var _PriorityIndex = __webpack_require__(15);

var USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param {*} json JSON to create a node for.
 * @param {?string|?number=} priority Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 * @return {!Node}
 */
function nodeFromJSON(json, priority) {
    if (priority === void 0) {
        priority = null;
    }
    if (json === null) {
        return _ChildrenNode.ChildrenNode.EMPTY_NODE;
    }
    if ((typeof json === 'undefined' ? 'undefined' : _typeof(json)) === 'object' && '.priority' in json) {
        priority = json['.priority'];
    }
    (0, _assert.assert)(priority === null || typeof priority === 'string' || typeof priority === 'number' || (typeof priority === 'undefined' ? 'undefined' : _typeof(priority)) === 'object' && '.sv' in priority, 'Invalid priority type found: ' + (typeof priority === 'undefined' ? 'undefined' : _typeof(priority)));
    if ((typeof json === 'undefined' ? 'undefined' : _typeof(json)) === 'object' && '.value' in json && json['.value'] !== null) {
        json = json['.value'];
    }
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if ((typeof json === 'undefined' ? 'undefined' : _typeof(json)) !== 'object' || '.sv' in json) {
        var jsonLeaf = json;
        return new _LeafNode.LeafNode(jsonLeaf, nodeFromJSON(priority));
    }
    if (!(json instanceof Array) && USE_HINZE) {
        var children_1 = [];
        var childrenHavePriority_1 = false;
        var hinzeJsonObj_1 = json;
        (0, _obj.forEach)(hinzeJsonObj_1, function (key, child) {
            if (typeof key !== 'string' || key.substring(0, 1) !== '.') {
                // Ignore metadata nodes
                var childNode = nodeFromJSON(hinzeJsonObj_1[key]);
                if (!childNode.isEmpty()) {
                    childrenHavePriority_1 = childrenHavePriority_1 || !childNode.getPriority().isEmpty();
                    children_1.push(new _Node.NamedNode(key, childNode));
                }
            }
        });
        if (children_1.length == 0) {
            return _ChildrenNode.ChildrenNode.EMPTY_NODE;
        }
        var childSet = (0, _childSet.buildChildSet)(children_1, _comparators.NAME_ONLY_COMPARATOR, function (namedNode) {
            return namedNode.name;
        }, _comparators.NAME_COMPARATOR);
        if (childrenHavePriority_1) {
            var sortedChildSet = (0, _childSet.buildChildSet)(children_1, _PriorityIndex.PRIORITY_INDEX.getCompare());
            return new _ChildrenNode.ChildrenNode(childSet, nodeFromJSON(priority), new _IndexMap.IndexMap({ '.priority': sortedChildSet }, { '.priority': _PriorityIndex.PRIORITY_INDEX }));
        } else {
            return new _ChildrenNode.ChildrenNode(childSet, nodeFromJSON(priority), _IndexMap.IndexMap.Default);
        }
    } else {
        var node_1 = _ChildrenNode.ChildrenNode.EMPTY_NODE;
        var jsonObj_1 = json;
        (0, _obj.forEach)(jsonObj_1, function (key, childData) {
            if ((0, _obj.contains)(jsonObj_1, key)) {
                if (key.substring(0, 1) !== '.') {
                    // ignore metadata nodes.
                    var childNode = nodeFromJSON(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty()) node_1 = node_1.updateImmediateChild(key, childNode);
                }
            }
        });
        return node_1.updatePriority(nodeFromJSON(priority));
    }
}
(0, _PriorityIndex.setNodeFromJSON)(nodeFromJSON);
//# sourceMappingURL=nodeFromJSON.js.map


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var EventPluginRegistry = __webpack_require__(119);
var EventPluginUtils = __webpack_require__(120);
var ReactErrorUtils = __webpack_require__(124);

var accumulateInto = __webpack_require__(212);
var forEachAccumulated = __webpack_require__(213);
var invariant = __webpack_require__(1);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(63);
var EventPluginUtils = __webpack_require__(120);

var accumulateInto = __webpack_require__(212);
var forEachAccumulated = __webpack_require__(213);
var warning = __webpack_require__(4);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(27);

var getEventTarget = __webpack_require__(129);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aframe_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var FadeAnimation = function (_Component) {
    _inherits(FadeAnimation, _Component);

    function FadeAnimation() {
        _classCallCheck(this, FadeAnimation);

        return _possibleConstructorReturn(this, (FadeAnimation.__proto__ || Object.getPrototypeOf(FadeAnimation)).apply(this, arguments));
    }

    _createClass(FadeAnimation, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a-animation", {

                id: this.props.id,

                attribute: this.props.attribute,

                dur: this.props.dur,

                from: !this.props.reverse ? this.props.min : this.props.max,
                to: !this.props.reverse ? this.props.max : this.props.min,

                begin: !this.props.reverse ? this.props.begin : this.props.end,
                end: !this.props.reverse ? this.props.end : this.props.begin

            });
        }
    }]);

    return FadeAnimation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FadeAnimation.defaultProps = {
    reverse: false,

    attribute: "material.opacity",

    dur: 100,

    min: 0.1,
    max: 1.0,

    begin: "mouseenter",
    end: "mouseleave"
};

/* harmony default export */ __webpack_exports__["a"] = (FadeAnimation);

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var Body = __webpack_require__(33);
var Vec3 = __webpack_require__(0);
var Quaternion = __webpack_require__(13);
var Shape = __webpack_require__(12);
var Plane = __webpack_require__(147);

module.exports = Broadphase;

/**
 * Base class for broadphase implementations
 * @class Broadphase
 * @constructor
 * @author schteppe
 */
function Broadphase(){
    /**
    * The world to search for collisions in.
    * @property world
    * @type {World}
    */
    this.world = null;

    /**
     * If set to true, the broadphase uses bounding boxes for intersection test, else it uses bounding spheres.
     * @property useBoundingBoxes
     * @type {Boolean}
     */
    this.useBoundingBoxes = false;

    /**
     * Set to true if the objects in the world moved.
     * @property {Boolean} dirty
     */
    this.dirty = true;
}

/**
 * Get the collision pairs from the world
 * @method collisionPairs
 * @param {World} world The world to search in
 * @param {Array} p1 Empty array to be filled with body objects
 * @param {Array} p2 Empty array to be filled with body objects
 */
Broadphase.prototype.collisionPairs = function(world,p1,p2){
    throw new Error("collisionPairs not implemented for this BroadPhase class!");
};

/**
 * Check if a body pair needs to be intersection tested at all.
 * @method needBroadphaseCollision
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @return {bool}
 */
Broadphase.prototype.needBroadphaseCollision = function(bodyA,bodyB){

    // Check collision filter masks
    if( (bodyA.collisionFilterGroup & bodyB.collisionFilterMask)===0 || (bodyB.collisionFilterGroup & bodyA.collisionFilterMask)===0){
        return false;
    }

    // Check types
    if(((bodyA.type & Body.STATIC)!==0 || bodyA.sleepState === Body.SLEEPING) &&
       ((bodyB.type & Body.STATIC)!==0 || bodyB.sleepState === Body.SLEEPING)) {
        // Both bodies are static or sleeping. Skip.
        return false;
    }

    return true;
};

/**
 * Check if the bounding volumes of two bodies intersect.
 * @method intersectionTest
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {array} pairs1
 * @param {array} pairs2
  */
Broadphase.prototype.intersectionTest = function(bodyA, bodyB, pairs1, pairs2){
    if(this.useBoundingBoxes){
        this.doBoundingBoxBroadphase(bodyA,bodyB,pairs1,pairs2);
    } else {
        this.doBoundingSphereBroadphase(bodyA,bodyB,pairs1,pairs2);
    }
};

/**
 * Check if the bounding spheres of two bodies are intersecting.
 * @method doBoundingSphereBroadphase
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Array} pairs1 bodyA is appended to this array if intersection
 * @param {Array} pairs2 bodyB is appended to this array if intersection
 */
var Broadphase_collisionPairs_r = new Vec3(), // Temp objects
    Broadphase_collisionPairs_normal =  new Vec3(),
    Broadphase_collisionPairs_quat =  new Quaternion(),
    Broadphase_collisionPairs_relpos  =  new Vec3();
Broadphase.prototype.doBoundingSphereBroadphase = function(bodyA,bodyB,pairs1,pairs2){
    var r = Broadphase_collisionPairs_r;
    bodyB.position.vsub(bodyA.position,r);
    var boundingRadiusSum2 = Math.pow(bodyA.boundingRadius + bodyB.boundingRadius, 2);
    var norm2 = r.norm2();
    if(norm2 < boundingRadiusSum2){
        pairs1.push(bodyA);
        pairs2.push(bodyB);
    }
};

/**
 * Check if the bounding boxes of two bodies are intersecting.
 * @method doBoundingBoxBroadphase
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Array} pairs1
 * @param {Array} pairs2
 */
Broadphase.prototype.doBoundingBoxBroadphase = function(bodyA,bodyB,pairs1,pairs2){
    if(bodyA.aabbNeedsUpdate){
        bodyA.computeAABB();
    }
    if(bodyB.aabbNeedsUpdate){
        bodyB.computeAABB();
    }

    // Check AABB / AABB
    if(bodyA.aabb.overlaps(bodyB.aabb)){
        pairs1.push(bodyA);
        pairs2.push(bodyB);
    }
};

/**
 * Removes duplicate pairs from the pair arrays.
 * @method makePairsUnique
 * @param {Array} pairs1
 * @param {Array} pairs2
 */
var Broadphase_makePairsUnique_temp = { keys:[] },
    Broadphase_makePairsUnique_p1 = [],
    Broadphase_makePairsUnique_p2 = [];
Broadphase.prototype.makePairsUnique = function(pairs1,pairs2){
    var t = Broadphase_makePairsUnique_temp,
        p1 = Broadphase_makePairsUnique_p1,
        p2 = Broadphase_makePairsUnique_p2,
        N = pairs1.length;

    for(var i=0; i!==N; i++){
        p1[i] = pairs1[i];
        p2[i] = pairs2[i];
    }

    pairs1.length = 0;
    pairs2.length = 0;

    for(var i=0; i!==N; i++){
        var id1 = p1[i].id,
            id2 = p2[i].id;
        var key = id1 < id2 ? id1+","+id2 :  id2+","+id1;
        t[key] = i;
        t.keys.push(key);
    }

    for(var i=0; i!==t.keys.length; i++){
        var key = t.keys.pop(),
            pairIndex = t[key];
        pairs1.push(p1[pairIndex]);
        pairs2.push(p2[pairIndex]);
        delete t[key];
    }
};

/**
 * To be implemented by subcasses
 * @method setWorld
 * @param {World} world
 */
Broadphase.prototype.setWorld = function(world){
};

/**
 * Check if the bounding spheres of two bodies overlap.
 * @method boundingSphereCheck
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @return {boolean}
 */
var bsc_dist = new Vec3();
Broadphase.boundingSphereCheck = function(bodyA,bodyB){
    var dist = bsc_dist;
    bodyA.position.vsub(bodyB.position,dist);
    return Math.pow(bodyA.shape.boundingSphereRadius + bodyB.shape.boundingSphereRadius,2) > dist.norm2();
};

/**
 * Returns all the bodies within the AABB.
 * @method aabbQuery
 * @param  {World} world
 * @param  {AABB} aabb
 * @param  {array} result An array to store resulting bodies in.
 * @return {array}
 */
Broadphase.prototype.aabbQuery = function(world, aabb, result){
    console.warn('.aabbQuery is not implemented in this Broadphase subclass.');
    return [];
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Ray;

var Vec3 = __webpack_require__(0);
var Quaternion = __webpack_require__(13);
var Transform = __webpack_require__(46);
var ConvexPolyhedron = __webpack_require__(47);
var Box = __webpack_require__(73);
var RaycastResult = __webpack_require__(58);
var Shape = __webpack_require__(12);
var AABB = __webpack_require__(30);

/**
 * A line in 3D space that intersects bodies and return points.
 * @class Ray
 * @constructor
 * @param {Vec3} from
 * @param {Vec3} to
 */
function Ray(from, to){
    /**
     * @property {Vec3} from
     */
    this.from = from ? from.clone() : new Vec3();

    /**
     * @property {Vec3} to
     */
    this.to = to ? to.clone() : new Vec3();

    /**
     * @private
     * @property {Vec3} _direction
     */
    this._direction = new Vec3();

    /**
     * The precision of the ray. Used when checking parallelity etc.
     * @property {Number} precision
     */
    this.precision = 0.0001;

    /**
     * Set to true if you want the Ray to take .collisionResponse flags into account on bodies and shapes.
     * @property {Boolean} checkCollisionResponse
     */
    this.checkCollisionResponse = true;

    /**
     * If set to true, the ray skips any hits with normal.dot(rayDirection) < 0.
     * @property {Boolean} skipBackfaces
     */
    this.skipBackfaces = false;

    /**
     * @property {number} collisionFilterMask
     * @default -1
     */
    this.collisionFilterMask = -1;

    /**
     * @property {number} collisionFilterGroup
     * @default -1
     */
    this.collisionFilterGroup = -1;

    /**
     * The intersection mode. Should be Ray.ANY, Ray.ALL or Ray.CLOSEST.
     * @property {number} mode
     */
    this.mode = Ray.ANY;

    /**
     * Current result object.
     * @property {RaycastResult} result
     */
    this.result = new RaycastResult();

    /**
     * Will be set to true during intersectWorld() if the ray hit anything.
     * @property {Boolean} hasHit
     */
    this.hasHit = false;

    /**
     * Current, user-provided result callback. Will be used if mode is Ray.ALL.
     * @property {Function} callback
     */
    this.callback = function(result){};
}
Ray.prototype.constructor = Ray;

Ray.CLOSEST = 1;
Ray.ANY = 2;
Ray.ALL = 4;

var tmpAABB = new AABB();
var tmpArray = [];

/**
 * Do itersection against all bodies in the given World.
 * @method intersectWorld
 * @param  {World} world
 * @param  {object} options
 * @return {Boolean} True if the ray hit anything, otherwise false.
 */
Ray.prototype.intersectWorld = function (world, options) {
    this.mode = options.mode || Ray.ANY;
    this.result = options.result || new RaycastResult();
    this.skipBackfaces = !!options.skipBackfaces;
    this.collisionFilterMask = typeof(options.collisionFilterMask) !== 'undefined' ? options.collisionFilterMask : -1;
    this.collisionFilterGroup = typeof(options.collisionFilterGroup) !== 'undefined' ? options.collisionFilterGroup : -1;
    if(options.from){
        this.from.copy(options.from);
    }
    if(options.to){
        this.to.copy(options.to);
    }
    this.callback = options.callback || function(){};
    this.hasHit = false;

    this.result.reset();
    this._updateDirection();

    this.getAABB(tmpAABB);
    tmpArray.length = 0;
    world.broadphase.aabbQuery(world, tmpAABB, tmpArray);
    this.intersectBodies(tmpArray);

    return this.hasHit;
};

var v1 = new Vec3(),
    v2 = new Vec3();

/*
 * As per "Barycentric Technique" as named here http://www.blackpawn.com/texts/pointinpoly/default.html But without the division
 */
Ray.pointInTriangle = pointInTriangle;
function pointInTriangle(p, a, b, c) {
    c.vsub(a,v0);
    b.vsub(a,v1);
    p.vsub(a,v2);

    var dot00 = v0.dot( v0 );
    var dot01 = v0.dot( v1 );
    var dot02 = v0.dot( v2 );
    var dot11 = v1.dot( v1 );
    var dot12 = v1.dot( v2 );

    var u,v;

    return  ( (u = dot11 * dot02 - dot01 * dot12) >= 0 ) &&
            ( (v = dot00 * dot12 - dot01 * dot02) >= 0 ) &&
            ( u + v < ( dot00 * dot11 - dot01 * dot01 ) );
}

/**
 * Shoot a ray at a body, get back information about the hit.
 * @method intersectBody
 * @private
 * @param {Body} body
 * @param {RaycastResult} [result] Deprecated - set the result property of the Ray instead.
 */
var intersectBody_xi = new Vec3();
var intersectBody_qi = new Quaternion();
Ray.prototype.intersectBody = function (body, result) {
    if(result){
        this.result = result;
        this._updateDirection();
    }
    var checkCollisionResponse = this.checkCollisionResponse;

    if(checkCollisionResponse && !body.collisionResponse){
        return;
    }

    if((this.collisionFilterGroup & body.collisionFilterMask)===0 || (body.collisionFilterGroup & this.collisionFilterMask)===0){
        return;
    }

    var xi = intersectBody_xi;
    var qi = intersectBody_qi;

    for (var i = 0, N = body.shapes.length; i < N; i++) {
        var shape = body.shapes[i];

        if(checkCollisionResponse && !shape.collisionResponse){
            continue; // Skip
        }

        body.quaternion.mult(body.shapeOrientations[i], qi);
        body.quaternion.vmult(body.shapeOffsets[i], xi);
        xi.vadd(body.position, xi);

        this.intersectShape(
            shape,
            qi,
            xi,
            body
        );

        if(this.result._shouldStop){
            break;
        }
    }
};

/**
 * @method intersectBodies
 * @param {Array} bodies An array of Body objects.
 * @param {RaycastResult} [result] Deprecated
 */
Ray.prototype.intersectBodies = function (bodies, result) {
    if(result){
        this.result = result;
        this._updateDirection();
    }

    for ( var i = 0, l = bodies.length; !this.result._shouldStop && i < l; i ++ ) {
        this.intersectBody(bodies[i]);
    }
};

/**
 * Updates the _direction vector.
 * @private
 * @method _updateDirection
 */
Ray.prototype._updateDirection = function(){
    this.to.vsub(this.from, this._direction);
    this._direction.normalize();
};

/**
 * @method intersectShape
 * @private
 * @param {Shape} shape
 * @param {Quaternion} quat
 * @param {Vec3} position
 * @param {Body} body
 */
Ray.prototype.intersectShape = function(shape, quat, position, body){
    var from = this.from;


    // Checking boundingSphere
    var distance = distanceFromIntersection(from, this._direction, position);
    if ( distance > shape.boundingSphereRadius ) {
        return;
    }

    var intersectMethod = this[shape.type];
    if(intersectMethod){
        intersectMethod.call(this, shape, quat, position, body, shape);
    }
};

var vector = new Vec3();
var normal = new Vec3();
var intersectPoint = new Vec3();

var a = new Vec3();
var b = new Vec3();
var c = new Vec3();
var d = new Vec3();

var tmpRaycastResult = new RaycastResult();

/**
 * @method intersectBox
 * @private
 * @param  {Shape} shape
 * @param  {Quaternion} quat
 * @param  {Vec3} position
 * @param  {Body} body
 */
Ray.prototype.intersectBox = function(shape, quat, position, body, reportedShape){
    return this.intersectConvex(shape.convexPolyhedronRepresentation, quat, position, body, reportedShape);
};
Ray.prototype[Shape.types.BOX] = Ray.prototype.intersectBox;

/**
 * @method intersectPlane
 * @private
 * @param  {Shape} shape
 * @param  {Quaternion} quat
 * @param  {Vec3} position
 * @param  {Body} body
 */
Ray.prototype.intersectPlane = function(shape, quat, position, body, reportedShape){
    var from = this.from;
    var to = this.to;
    var direction = this._direction;

    // Get plane normal
    var worldNormal = new Vec3(0, 0, 1);
    quat.vmult(worldNormal, worldNormal);

    var len = new Vec3();
    from.vsub(position, len);
    var planeToFrom = len.dot(worldNormal);
    to.vsub(position, len);
    var planeToTo = len.dot(worldNormal);

    if(planeToFrom * planeToTo > 0){
        // "from" and "to" are on the same side of the plane... bail out
        return;
    }

    if(from.distanceTo(to) < planeToFrom){
        return;
    }

    var n_dot_dir = worldNormal.dot(direction);

    if (Math.abs(n_dot_dir) < this.precision) {
        // No intersection
        return;
    }

    var planePointToFrom = new Vec3();
    var dir_scaled_with_t = new Vec3();
    var hitPointWorld = new Vec3();

    from.vsub(position, planePointToFrom);
    var t = -worldNormal.dot(planePointToFrom) / n_dot_dir;
    direction.scale(t, dir_scaled_with_t);
    from.vadd(dir_scaled_with_t, hitPointWorld);

    this.reportIntersection(worldNormal, hitPointWorld, reportedShape, body, -1);
};
Ray.prototype[Shape.types.PLANE] = Ray.prototype.intersectPlane;

/**
 * Get the world AABB of the ray.
 * @method getAABB
 * @param  {AABB} aabb
 */
Ray.prototype.getAABB = function(result){
    var to = this.to;
    var from = this.from;
    result.lowerBound.x = Math.min(to.x, from.x);
    result.lowerBound.y = Math.min(to.y, from.y);
    result.lowerBound.z = Math.min(to.z, from.z);
    result.upperBound.x = Math.max(to.x, from.x);
    result.upperBound.y = Math.max(to.y, from.y);
    result.upperBound.z = Math.max(to.z, from.z);
};

var intersectConvexOptions = {
    faceList: [0]
};
var worldPillarOffset = new Vec3();
var intersectHeightfield_localRay = new Ray();
var intersectHeightfield_index = [];
var intersectHeightfield_minMax = [];

/**
 * @method intersectHeightfield
 * @private
 * @param  {Shape} shape
 * @param  {Quaternion} quat
 * @param  {Vec3} position
 * @param  {Body} body
 */
Ray.prototype.intersectHeightfield = function(shape, quat, position, body, reportedShape){
    var data = shape.data,
        w = shape.elementSize;

    // Convert the ray to local heightfield coordinates
    var localRay = intersectHeightfield_localRay; //new Ray(this.from, this.to);
    localRay.from.copy(this.from);
    localRay.to.copy(this.to);
    Transform.pointToLocalFrame(position, quat, localRay.from, localRay.from);
    Transform.pointToLocalFrame(position, quat, localRay.to, localRay.to);
    localRay._updateDirection();

    // Get the index of the data points to test against
    var index = intersectHeightfield_index;
    var iMinX, iMinY, iMaxX, iMaxY;

    // Set to max
    iMinX = iMinY = 0;
    iMaxX = iMaxY = shape.data.length - 1;

    var aabb = new AABB();
    localRay.getAABB(aabb);

    shape.getIndexOfPosition(aabb.lowerBound.x, aabb.lowerBound.y, index, true);
    iMinX = Math.max(iMinX, index[0]);
    iMinY = Math.max(iMinY, index[1]);
    shape.getIndexOfPosition(aabb.upperBound.x, aabb.upperBound.y, index, true);
    iMaxX = Math.min(iMaxX, index[0] + 1);
    iMaxY = Math.min(iMaxY, index[1] + 1);

    for(var i = iMinX; i < iMaxX; i++){
        for(var j = iMinY; j < iMaxY; j++){

            if(this.result._shouldStop){
                return;
            }

            shape.getAabbAtIndex(i, j, aabb);
            if(!aabb.overlapsRay(localRay)){
                continue;
            }

            // Lower triangle
            shape.getConvexTrianglePillar(i, j, false);
            Transform.pointToWorldFrame(position, quat, shape.pillarOffset, worldPillarOffset);
            this.intersectConvex(shape.pillarConvex, quat, worldPillarOffset, body, reportedShape, intersectConvexOptions);

            if(this.result._shouldStop){
                return;
            }

            // Upper triangle
            shape.getConvexTrianglePillar(i, j, true);
            Transform.pointToWorldFrame(position, quat, shape.pillarOffset, worldPillarOffset);
            this.intersectConvex(shape.pillarConvex, quat, worldPillarOffset, body, reportedShape, intersectConvexOptions);
        }
    }
};
Ray.prototype[Shape.types.HEIGHTFIELD] = Ray.prototype.intersectHeightfield;

var Ray_intersectSphere_intersectionPoint = new Vec3();
var Ray_intersectSphere_normal = new Vec3();

/**
 * @method intersectSphere
 * @private
 * @param  {Shape} shape
 * @param  {Quaternion} quat
 * @param  {Vec3} position
 * @param  {Body} body
 */
Ray.prototype.intersectSphere = function(shape, quat, position, body, reportedShape){
    var from = this.from,
        to = this.to,
        r = shape.radius;

    var a = Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + Math.pow(to.z - from.z, 2);
    var b = 2 * ((to.x - from.x) * (from.x - position.x) + (to.y - from.y) * (from.y - position.y) + (to.z - from.z) * (from.z - position.z));
    var c = Math.pow(from.x - position.x, 2) + Math.pow(from.y - position.y, 2) + Math.pow(from.z - position.z, 2) - Math.pow(r, 2);

    var delta = Math.pow(b, 2) - 4 * a * c;

    var intersectionPoint = Ray_intersectSphere_intersectionPoint;
    var normal = Ray_intersectSphere_normal;

    if(delta < 0){
        // No intersection
        return;

    } else if(delta === 0){
        // single intersection point
        from.lerp(to, delta, intersectionPoint);

        intersectionPoint.vsub(position, normal);
        normal.normalize();

        this.reportIntersection(normal, intersectionPoint, reportedShape, body, -1);

    } else {
        var d1 = (- b - Math.sqrt(delta)) / (2 * a);
        var d2 = (- b + Math.sqrt(delta)) / (2 * a);

        if(d1 >= 0 && d1 <= 1){
            from.lerp(to, d1, intersectionPoint);
            intersectionPoint.vsub(position, normal);
            normal.normalize();
            this.reportIntersection(normal, intersectionPoint, reportedShape, body, -1);
        }

        if(this.result._shouldStop){
            return;
        }

        if(d2 >= 0 && d2 <= 1){
            from.lerp(to, d2, intersectionPoint);
            intersectionPoint.vsub(position, normal);
            normal.normalize();
            this.reportIntersection(normal, intersectionPoint, reportedShape, body, -1);
        }
    }
};
Ray.prototype[Shape.types.SPHERE] = Ray.prototype.intersectSphere;


var intersectConvex_normal = new Vec3();
var intersectConvex_minDistNormal = new Vec3();
var intersectConvex_minDistIntersect = new Vec3();
var intersectConvex_vector = new Vec3();

/**
 * @method intersectConvex
 * @private
 * @param  {Shape} shape
 * @param  {Quaternion} quat
 * @param  {Vec3} position
 * @param  {Body} body
 * @param {object} [options]
 * @param {array} [options.faceList]
 */
Ray.prototype.intersectConvex = function intersectConvex(
    shape,
    quat,
    position,
    body,
    reportedShape,
    options
){
    var minDistNormal = intersectConvex_minDistNormal;
    var normal = intersectConvex_normal;
    var vector = intersectConvex_vector;
    var minDistIntersect = intersectConvex_minDistIntersect;
    var faceList = (options && options.faceList) || null;

    // Checking faces
    var faces = shape.faces,
        vertices = shape.vertices,
        normals = shape.faceNormals;
    var direction = this._direction;

    var from = this.from;
    var to = this.to;
    var fromToDistance = from.distanceTo(to);

    var minDist = -1;
    var Nfaces = faceList ? faceList.length : faces.length;
    var result = this.result;

    for (var j = 0; !result._shouldStop && j < Nfaces; j++) {
        var fi = faceList ? faceList[j] : j;

        var face = faces[fi];
        var faceNormal = normals[fi];
        var q = quat;
        var x = position;

        // determine if ray intersects the plane of the face
        // note: this works regardless of the direction of the face normal

        // Get plane point in world coordinates...
        vector.copy(vertices[face[0]]);
        q.vmult(vector,vector);
        vector.vadd(x,vector);

        // ...but make it relative to the ray from. We'll fix this later.
        vector.vsub(from,vector);

        // Get plane normal
        q.vmult(faceNormal,normal);

        // If this dot product is negative, we have something interesting
        var dot = direction.dot(normal);

        // Bail out if ray and plane are parallel
        if ( Math.abs( dot ) < this.precision ){
            continue;
        }

        // calc distance to plane
        var scalar = normal.dot(vector) / dot;

        // if negative distance, then plane is behind ray
        if (scalar < 0){
            continue;
        }

        // if (dot < 0) {

        // Intersection point is from + direction * scalar
        direction.mult(scalar,intersectPoint);
        intersectPoint.vadd(from,intersectPoint);

        // a is the point we compare points b and c with.
        a.copy(vertices[face[0]]);
        q.vmult(a,a);
        x.vadd(a,a);

        for(var i = 1; !result._shouldStop && i < face.length - 1; i++){
            // Transform 3 vertices to world coords
            b.copy(vertices[face[i]]);
            c.copy(vertices[face[i+1]]);
            q.vmult(b,b);
            q.vmult(c,c);
            x.vadd(b,b);
            x.vadd(c,c);

            var distance = intersectPoint.distanceTo(from);

            if(!(pointInTriangle(intersectPoint, a, b, c) || pointInTriangle(intersectPoint, b, a, c)) || distance > fromToDistance){
                continue;
            }

            this.reportIntersection(normal, intersectPoint, reportedShape, body, fi);
        }
        // }
    }
};
Ray.prototype[Shape.types.CONVEXPOLYHEDRON] = Ray.prototype.intersectConvex;

var intersectTrimesh_normal = new Vec3();
var intersectTrimesh_localDirection = new Vec3();
var intersectTrimesh_localFrom = new Vec3();
var intersectTrimesh_localTo = new Vec3();
var intersectTrimesh_worldNormal = new Vec3();
var intersectTrimesh_worldIntersectPoint = new Vec3();
var intersectTrimesh_localAABB = new AABB();
var intersectTrimesh_triangles = [];
var intersectTrimesh_treeTransform = new Transform();

/**
 * @method intersectTrimesh
 * @private
 * @param  {Shape} shape
 * @param  {Quaternion} quat
 * @param  {Vec3} position
 * @param  {Body} body
 * @param {object} [options]
 * @todo Optimize by transforming the world to local space first.
 * @todo Use Octree lookup
 */
Ray.prototype.intersectTrimesh = function intersectTrimesh(
    mesh,
    quat,
    position,
    body,
    reportedShape,
    options
){
    var normal = intersectTrimesh_normal;
    var triangles = intersectTrimesh_triangles;
    var treeTransform = intersectTrimesh_treeTransform;
    var minDistNormal = intersectConvex_minDistNormal;
    var vector = intersectConvex_vector;
    var minDistIntersect = intersectConvex_minDistIntersect;
    var localAABB = intersectTrimesh_localAABB;
    var localDirection = intersectTrimesh_localDirection;
    var localFrom = intersectTrimesh_localFrom;
    var localTo = intersectTrimesh_localTo;
    var worldIntersectPoint = intersectTrimesh_worldIntersectPoint;
    var worldNormal = intersectTrimesh_worldNormal;
    var faceList = (options && options.faceList) || null;

    // Checking faces
    var indices = mesh.indices,
        vertices = mesh.vertices,
        normals = mesh.faceNormals;

    var from = this.from;
    var to = this.to;
    var direction = this._direction;

    var minDist = -1;
    treeTransform.position.copy(position);
    treeTransform.quaternion.copy(quat);

    // Transform ray to local space!
    Transform.vectorToLocalFrame(position, quat, direction, localDirection);
    Transform.pointToLocalFrame(position, quat, from, localFrom);
    Transform.pointToLocalFrame(position, quat, to, localTo);

    localTo.x *= mesh.scale.x;
    localTo.y *= mesh.scale.y;
    localTo.z *= mesh.scale.z;
    localFrom.x *= mesh.scale.x;
    localFrom.y *= mesh.scale.y;
    localFrom.z *= mesh.scale.z;

    localTo.vsub(localFrom, localDirection);
    localDirection.normalize();

    var fromToDistanceSquared = localFrom.distanceSquared(localTo);

    mesh.tree.rayQuery(this, treeTransform, triangles);

    for (var i = 0, N = triangles.length; !this.result._shouldStop && i !== N; i++) {
        var trianglesIndex = triangles[i];

        mesh.getNormal(trianglesIndex, normal);

        // determine if ray intersects the plane of the face
        // note: this works regardless of the direction of the face normal

        // Get plane point in world coordinates...
        mesh.getVertex(indices[trianglesIndex * 3], a);

        // ...but make it relative to the ray from. We'll fix this later.
        a.vsub(localFrom,vector);

        // If this dot product is negative, we have something interesting
        var dot = localDirection.dot(normal);

        // Bail out if ray and plane are parallel
        // if (Math.abs( dot ) < this.precision){
        //     continue;
        // }

        // calc distance to plane
        var scalar = normal.dot(vector) / dot;

        // if negative distance, then plane is behind ray
        if (scalar < 0){
            continue;
        }

        // Intersection point is from + direction * scalar
        localDirection.scale(scalar,intersectPoint);
        intersectPoint.vadd(localFrom,intersectPoint);

        // Get triangle vertices
        mesh.getVertex(indices[trianglesIndex * 3 + 1], b);
        mesh.getVertex(indices[trianglesIndex * 3 + 2], c);

        var squaredDistance = intersectPoint.distanceSquared(localFrom);

        if(!(pointInTriangle(intersectPoint, b, a, c) || pointInTriangle(intersectPoint, a, b, c)) || squaredDistance > fromToDistanceSquared){
            continue;
        }

        // transform intersectpoint and normal to world
        Transform.vectorToWorldFrame(quat, normal, worldNormal);
        Transform.pointToWorldFrame(position, quat, intersectPoint, worldIntersectPoint);
        this.reportIntersection(worldNormal, worldIntersectPoint, reportedShape, body, trianglesIndex);
    }
    triangles.length = 0;
};
Ray.prototype[Shape.types.TRIMESH] = Ray.prototype.intersectTrimesh;


/**
 * @method reportIntersection
 * @private
 * @param  {Vec3} normal
 * @param  {Vec3} hitPointWorld
 * @param  {Shape} shape
 * @param  {Body} body
 * @return {boolean} True if the intersections should continue
 */
Ray.prototype.reportIntersection = function(normal, hitPointWorld, shape, body, hitFaceIndex){
    var from = this.from;
    var to = this.to;
    var distance = from.distanceTo(hitPointWorld);
    var result = this.result;

    // Skip back faces?
    if(this.skipBackfaces && normal.dot(this._direction) > 0){
        return;
    }

    result.hitFaceIndex = typeof(hitFaceIndex) !== 'undefined' ? hitFaceIndex : -1;

    switch(this.mode){
    case Ray.ALL:
        this.hasHit = true;
        result.set(
            from,
            to,
            normal,
            hitPointWorld,
            shape,
            body,
            distance
        );
        result.hasHit = true;
        this.callback(result);
        break;

    case Ray.CLOSEST:

        // Store if closer than current closest
        if(distance < result.distance || !result.hasHit){
            this.hasHit = true;
            result.hasHit = true;
            result.set(
                from,
                to,
                normal,
                hitPointWorld,
                shape,
                body,
                distance
            );
        }
        break;

    case Ray.ANY:

        // Report and stop.
        this.hasHit = true;
        result.hasHit = true;
        result.set(
            from,
            to,
            normal,
            hitPointWorld,
            shape,
            body,
            distance
        );
        result._shouldStop = true;
        break;
    }
};

var v0 = new Vec3(),
    intersect = new Vec3();
function distanceFromIntersection(from, direction, position) {

    // v0 is vector from from to position
    position.vsub(from,v0);
    var dot = v0.dot(direction);

    // intersect = direction*dot + from
    direction.mult(dot,intersect);
    intersect.vadd(from,intersect);

    var distance = position.distanceTo(intersect);

    return distance;
}



/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = PointToPointConstraint;

var Constraint = __webpack_require__(44);
var ContactEquation = __webpack_require__(31);
var Vec3 = __webpack_require__(0);

/**
 * Connects two bodies at given offset points.
 * @class PointToPointConstraint
 * @extends Constraint
 * @constructor
 * @param {Body} bodyA
 * @param {Vec3} pivotA The point relative to the center of mass of bodyA which bodyA is constrained to.
 * @param {Body} bodyB Body that will be constrained in a similar way to the same point as bodyA. We will therefore get a link between bodyA and bodyB. If not specified, bodyA will be constrained to a static point.
 * @param {Vec3} pivotB See pivotA.
 * @param {Number} maxForce The maximum force that should be applied to constrain the bodies.
 *
 * @example
 *     var bodyA = new Body({ mass: 1 });
 *     var bodyB = new Body({ mass: 1 });
 *     bodyA.position.set(-1, 0, 0);
 *     bodyB.position.set(1, 0, 0);
 *     bodyA.addShape(shapeA);
 *     bodyB.addShape(shapeB);
 *     world.addBody(bodyA);
 *     world.addBody(bodyB);
 *     var localPivotA = new Vec3(1, 0, 0);
 *     var localPivotB = new Vec3(-1, 0, 0);
 *     var constraint = new PointToPointConstraint(bodyA, localPivotA, bodyB, localPivotB);
 *     world.addConstraint(constraint);
 */
function PointToPointConstraint(bodyA,pivotA,bodyB,pivotB,maxForce){
    Constraint.call(this,bodyA,bodyB);

    maxForce = typeof(maxForce) !== 'undefined' ? maxForce : 1e6;

    /**
     * Pivot, defined locally in bodyA.
     * @property {Vec3} pivotA
     */
    this.pivotA = pivotA ? pivotA.clone() : new Vec3();

    /**
     * Pivot, defined locally in bodyB.
     * @property {Vec3} pivotB
     */
    this.pivotB = pivotB ? pivotB.clone() : new Vec3();

    /**
     * @property {ContactEquation} equationX
     */
    var x = this.equationX = new ContactEquation(bodyA,bodyB);

    /**
     * @property {ContactEquation} equationY
     */
    var y = this.equationY = new ContactEquation(bodyA,bodyB);

    /**
     * @property {ContactEquation} equationZ
     */
    var z = this.equationZ = new ContactEquation(bodyA,bodyB);

    // Equations to be fed to the solver
    this.equations.push(x, y, z);

    // Make the equations bidirectional
    x.minForce = y.minForce = z.minForce = -maxForce;
    x.maxForce = y.maxForce = z.maxForce =  maxForce;

    x.ni.set(1, 0, 0);
    y.ni.set(0, 1, 0);
    z.ni.set(0, 0, 1);
}
PointToPointConstraint.prototype = new Constraint();

PointToPointConstraint.prototype.update = function(){
    var bodyA = this.bodyA;
    var bodyB = this.bodyB;
    var x = this.equationX;
    var y = this.equationY;
    var z = this.equationZ;

    // Rotate the pivots to world space
    bodyA.quaternion.vmult(this.pivotA,x.ri);
    bodyB.quaternion.vmult(this.pivotB,x.rj);

    y.ri.copy(x.ri);
    y.rj.copy(x.rj);
    z.ri.copy(x.ri);
    z.rj.copy(x.rj);
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = RotationalEquation;

var Vec3 = __webpack_require__(0);
var Mat3 = __webpack_require__(32);
var Equation = __webpack_require__(45);

/**
 * Rotational constraint. Works to keep the local vectors orthogonal to each other in world space.
 * @class RotationalEquation
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Vec3} [options.axisA]
 * @param {Vec3} [options.axisB]
 * @param {number} [options.maxForce]
 * @extends Equation
 */
function RotationalEquation(bodyA, bodyB, options){
    options = options || {};
    var maxForce = typeof(options.maxForce) !== 'undefined' ? options.maxForce : 1e6;

    Equation.call(this,bodyA,bodyB,-maxForce, maxForce);

    this.axisA = options.axisA ? options.axisA.clone() : new Vec3(1, 0, 0);
    this.axisB = options.axisB ? options.axisB.clone() : new Vec3(0, 1, 0);

    this.maxAngle = Math.PI / 2;
}

RotationalEquation.prototype = new Equation();
RotationalEquation.prototype.constructor = RotationalEquation;

var tmpVec1 = new Vec3();
var tmpVec2 = new Vec3();

RotationalEquation.prototype.computeB = function(h){
    var a = this.a,
        b = this.b,

        ni = this.axisA,
        nj = this.axisB,

        nixnj = tmpVec1,
        njxni = tmpVec2,

        GA = this.jacobianElementA,
        GB = this.jacobianElementB;

    // Caluclate cross products
    ni.cross(nj, nixnj);
    nj.cross(ni, njxni);

    // g = ni * nj
    // gdot = (nj x ni) * wi + (ni x nj) * wj
    // G = [0 njxni 0 nixnj]
    // W = [vi wi vj wj]
    GA.rotational.copy(njxni);
    GB.rotational.copy(nixnj);

    var g = Math.cos(this.maxAngle) - ni.dot(nj),
        GW = this.computeGW(),
        GiMf = this.computeGiMf();

    var B = - g * a - GW * b - h * GiMf;

    return B;
};



/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Box;

var Shape = __webpack_require__(12);
var Vec3 = __webpack_require__(0);
var ConvexPolyhedron = __webpack_require__(47);

/**
 * A 3d box shape.
 * @class Box
 * @constructor
 * @param {Vec3} halfExtents
 * @author schteppe
 * @extends Shape
 */
function Box(halfExtents){
    Shape.call(this);

    this.type = Shape.types.BOX;

    /**
     * @property halfExtents
     * @type {Vec3}
     */
    this.halfExtents = halfExtents;

    /**
     * Used by the contact generator to make contacts with other convex polyhedra for example
     * @property convexPolyhedronRepresentation
     * @type {ConvexPolyhedron}
     */
    this.convexPolyhedronRepresentation = null;

    this.updateConvexPolyhedronRepresentation();
    this.updateBoundingSphereRadius();
}
Box.prototype = new Shape();
Box.prototype.constructor = Box;

/**
 * Updates the local convex polyhedron representation used for some collisions.
 * @method updateConvexPolyhedronRepresentation
 */
Box.prototype.updateConvexPolyhedronRepresentation = function(){
    var sx = this.halfExtents.x;
    var sy = this.halfExtents.y;
    var sz = this.halfExtents.z;
    var V = Vec3;

    var vertices = [
        new V(-sx,-sy,-sz),
        new V( sx,-sy,-sz),
        new V( sx, sy,-sz),
        new V(-sx, sy,-sz),
        new V(-sx,-sy, sz),
        new V( sx,-sy, sz),
        new V( sx, sy, sz),
        new V(-sx, sy, sz)
    ];

    var indices = [
        [3,2,1,0], // -z
        [4,5,6,7], // +z
        [5,4,0,1], // -y
        [2,3,7,6], // +y
        [0,4,7,3], // -x
        [1,2,6,5], // +x
    ];

    var axes = [
        new V(0, 0, 1),
        new V(0, 1, 0),
        new V(1, 0, 0)
    ];

    var h = new ConvexPolyhedron(vertices, indices);
    this.convexPolyhedronRepresentation = h;
    h.material = this.material;
};

/**
 * @method calculateLocalInertia
 * @param  {Number} mass
 * @param  {Vec3} target
 * @return {Vec3}
 */
Box.prototype.calculateLocalInertia = function(mass,target){
    target = target || new Vec3();
    Box.calculateInertia(this.halfExtents, mass, target);
    return target;
};

Box.calculateInertia = function(halfExtents,mass,target){
    var e = halfExtents;
    target.x = 1.0 / 12.0 * mass * (   2*e.y*2*e.y + 2*e.z*2*e.z );
    target.y = 1.0 / 12.0 * mass * (   2*e.x*2*e.x + 2*e.z*2*e.z );
    target.z = 1.0 / 12.0 * mass * (   2*e.y*2*e.y + 2*e.x*2*e.x );
};

/**
 * Get the box 6 side normals
 * @method getSideNormals
 * @param {array}      sixTargetVectors An array of 6 vectors, to store the resulting side normals in.
 * @param {Quaternion} quat             Orientation to apply to the normal vectors. If not provided, the vectors will be in respect to the local frame.
 * @return {array}
 */
Box.prototype.getSideNormals = function(sixTargetVectors,quat){
    var sides = sixTargetVectors;
    var ex = this.halfExtents;
    sides[0].set(  ex.x,     0,     0);
    sides[1].set(     0,  ex.y,     0);
    sides[2].set(     0,     0,  ex.z);
    sides[3].set( -ex.x,     0,     0);
    sides[4].set(     0, -ex.y,     0);
    sides[5].set(     0,     0, -ex.z);

    if(quat!==undefined){
        for(var i=0; i!==sides.length; i++){
            quat.vmult(sides[i],sides[i]);
        }
    }

    return sides;
};

Box.prototype.volume = function(){
    return 8.0 * this.halfExtents.x * this.halfExtents.y * this.halfExtents.z;
};

Box.prototype.updateBoundingSphereRadius = function(){
    this.boundingSphereRadius = this.halfExtents.norm();
};

var worldCornerTempPos = new Vec3();
var worldCornerTempNeg = new Vec3();
Box.prototype.forEachWorldCorner = function(pos,quat,callback){

    var e = this.halfExtents;
    var corners = [[  e.x,  e.y,  e.z],
                   [ -e.x,  e.y,  e.z],
                   [ -e.x, -e.y,  e.z],
                   [ -e.x, -e.y, -e.z],
                   [  e.x, -e.y, -e.z],
                   [  e.x,  e.y, -e.z],
                   [ -e.x,  e.y, -e.z],
                   [  e.x, -e.y,  e.z]];
    for(var i=0; i<corners.length; i++){
        worldCornerTempPos.set(corners[i][0],corners[i][1],corners[i][2]);
        quat.vmult(worldCornerTempPos,worldCornerTempPos);
        pos.vadd(worldCornerTempPos,worldCornerTempPos);
        callback(worldCornerTempPos.x,
                 worldCornerTempPos.y,
                 worldCornerTempPos.z);
    }
};

var worldCornersTemp = [
    new Vec3(),
    new Vec3(),
    new Vec3(),
    new Vec3(),
    new Vec3(),
    new Vec3(),
    new Vec3(),
    new Vec3()
];
Box.prototype.calculateWorldAABB = function(pos,quat,min,max){

    var e = this.halfExtents;
    worldCornersTemp[0].set(e.x, e.y, e.z);
    worldCornersTemp[1].set(-e.x,  e.y, e.z);
    worldCornersTemp[2].set(-e.x, -e.y, e.z);
    worldCornersTemp[3].set(-e.x, -e.y, -e.z);
    worldCornersTemp[4].set(e.x, -e.y, -e.z);
    worldCornersTemp[5].set(e.x,  e.y, -e.z);
    worldCornersTemp[6].set(-e.x,  e.y, -e.z);
    worldCornersTemp[7].set(e.x, -e.y,  e.z);

    var wc = worldCornersTemp[0];
    quat.vmult(wc, wc);
    pos.vadd(wc, wc);
    max.copy(wc);
    min.copy(wc);
    for(var i=1; i<8; i++){
        var wc = worldCornersTemp[i];
        quat.vmult(wc, wc);
        pos.vadd(wc, wc);
        var x = wc.x;
        var y = wc.y;
        var z = wc.z;
        if(x > max.x){
            max.x = x;
        }
        if(y > max.y){
            max.y = y;
        }
        if(z > max.z){
            max.z = z;
        }

        if(x < min.x){
            min.x = x;
        }
        if(y < min.y){
            min.y = y;
        }
        if(z < min.z){
            min.z = z;
        }
    }

    // Get each axis max
    // min.set(Infinity,Infinity,Infinity);
    // max.set(-Infinity,-Infinity,-Infinity);
    // this.forEachWorldCorner(pos,quat,function(x,y,z){
    //     if(x > max.x){
    //         max.x = x;
    //     }
    //     if(y > max.y){
    //         max.y = y;
    //     }
    //     if(z > max.z){
    //         max.z = z;
    //     }

    //     if(x < min.x){
    //         min.x = x;
    //     }
    //     if(y < min.y){
    //         min.y = y;
    //     }
    //     if(z < min.z){
    //         min.z = z;
    //     }
    // });
};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = Solver;

/**
 * Constraint equation solver base class.
 * @class Solver
 * @constructor
 * @author schteppe / https://github.com/schteppe
 */
function Solver(){
    /**
     * All equations to be solved
     * @property {Array} equations
     */
    this.equations = [];
}

/**
 * Should be implemented in subclasses!
 * @method solve
 * @param  {Number} dt
 * @param  {World} world
 */
Solver.prototype.solve = function(dt,world){
    // Should return the number of iterations done!
    return 0;
};

/**
 * Add an equation
 * @method addEquation
 * @param {Equation} eq
 */
Solver.prototype.addEquation = function(eq){
    if (eq.enabled) {
        this.equations.push(eq);
    }
};

/**
 * Remove an equation
 * @method removeEquation
 * @param {Equation} eq
 */
Solver.prototype.removeEquation = function(eq){
    var eqs = this.equations;
    var i = eqs.indexOf(eq);
    if(i !== -1){
        eqs.splice(i,1);
    }
};

/**
 * Add all equations
 * @method removeAllEquations
 */
Solver.prototype.removeAllEquations = function(){
    this.equations.length = 0;
};



/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/quicksand.ab28d63d.fnt";

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Repo = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Copyright 2017 Google Inc.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Licensed under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                               * you may not use this file except in compliance with the License.
                                                                                                                                                                                                                                                                               * You may obtain a copy of the License at
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               *   http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Unless required by applicable law or agreed to in writing, software
                                                                                                                                                                                                                                                                               * distributed under the License is distributed on an "AS IS" BASIS,
                                                                                                                                                                                                                                                                               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                                                                                                                                                                                                               * See the License for the specific language governing permissions and
                                                                                                                                                                                                                                                                               * limitations under the License.
                                                                                                                                                                                                                                                                               */


var _ServerValues = __webpack_require__(176);

var _nodeFromJSON = __webpack_require__(62);

var _Path = __webpack_require__(9);

var _SparseSnapshotTree = __webpack_require__(164);

var _SyncTree = __webpack_require__(386);

var _SnapshotHolder = __webpack_require__(385);

var _json = __webpack_require__(23);

var _util = __webpack_require__(3);

var _obj = __webpack_require__(7);

var _AuthTokenProvider = __webpack_require__(381);

var _StatsManager = __webpack_require__(106);

var _StatsReporter = __webpack_require__(392);

var _StatsListener = __webpack_require__(173);

var _EventQueue = __webpack_require__(403);

var _PersistentConnection = __webpack_require__(161);

var _ReadonlyRestClient = __webpack_require__(383);

var _Database = __webpack_require__(159);

var INTERRUPT_REASON = 'repo_interrupt';
/**
 * A connection to a single data repository.
 */
var Repo = /** @class */function () {
    /**
     * @param {!RepoInfo} repoInfo_
     * @param {boolean} forceRestClient
     * @param {!FirebaseApp} app
     */
    function Repo(repoInfo_, forceRestClient, app) {
        var _this = this;
        this.repoInfo_ = repoInfo_;
        this.app = app;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new _EventQueue.EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        // A list of data pieces and paths to be set when this client disconnects.
        this.onDisconnect_ = new _SparseSnapshotTree.SparseSnapshotTree();
        /**
         * TODO: This should be @private but it's used by test_access.js and internal.js
         * @type {?PersistentConnection}
         */
        this.persistentConnection_ = null;
        /** @type {!AuthTokenProvider} */
        var authTokenProvider = new _AuthTokenProvider.AuthTokenProvider(app);
        this.stats_ = _StatsManager.StatsManager.getCollection(repoInfo_);
        if (forceRestClient || (0, _util.beingCrawled)()) {
            this.server_ = new _ReadonlyRestClient.ReadonlyRestClient(this.repoInfo_, this.onDataUpdate_.bind(this), authTokenProvider);
            // Minor hack: Fire onConnect immediately, since there's no actual connection.
            setTimeout(this.onConnectStatus_.bind(this, true), 0);
        } else {
            var authOverride = app.options['databaseAuthVariableOverride'];
            // Validate authOverride
            if (typeof authOverride !== 'undefined' && authOverride !== null) {
                if ((typeof authOverride === 'undefined' ? 'undefined' : _typeof(authOverride)) !== 'object') {
                    throw new Error('Only objects are supported for option databaseAuthVariableOverride');
                }
                try {
                    (0, _json.stringify)(authOverride);
                } catch (e) {
                    throw new Error('Invalid authOverride provided: ' + e);
                }
            }
            this.persistentConnection_ = new _PersistentConnection.PersistentConnection(this.repoInfo_, this.onDataUpdate_.bind(this), this.onConnectStatus_.bind(this), this.onServerInfoUpdate_.bind(this), authTokenProvider, authOverride);
            this.server_ = this.persistentConnection_;
        }
        authTokenProvider.addTokenChangeListener(function (token) {
            _this.server_.refreshAuthToken(token);
        });
        // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
        // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
        this.statsReporter_ = _StatsManager.StatsManager.getOrCreateReporter(repoInfo_, function () {
            return new _StatsReporter.StatsReporter(_this.stats_, _this.server_);
        });
        this.transactions_init_();
        // Used for .info.
        this.infoData_ = new _SnapshotHolder.SnapshotHolder();
        this.infoSyncTree_ = new _SyncTree.SyncTree({
            startListening: function startListening(query, tag, currentHashFn, onComplete) {
                var infoEvents = [];
                var node = _this.infoData_.getNode(query.path);
                // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
                // on initial data...
                if (!node.isEmpty()) {
                    infoEvents = _this.infoSyncTree_.applyServerOverwrite(query.path, node);
                    setTimeout(function () {
                        onComplete('ok');
                    }, 0);
                }
                return infoEvents;
            },
            stopListening: function stopListening() {}
        });
        this.updateInfo_('connected', false);
        this.serverSyncTree_ = new _SyncTree.SyncTree({
            startListening: function startListening(query, tag, currentHashFn, onComplete) {
                _this.server_.listen(query, currentHashFn, tag, function (status, data) {
                    var events = onComplete(status, data);
                    _this.eventQueue_.raiseEventsForChangedPath(query.path, events);
                });
                // No synchronous events for network-backed sync trees
                return [];
            },
            stopListening: function stopListening(query, tag) {
                _this.server_.unlisten(query, tag);
            }
        });
    }
    /**
     * @return {string}  The URL corresponding to the root of this Firebase.
     */
    Repo.prototype.toString = function () {
        return (this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host;
    };
    /**
     * @return {!string} The namespace represented by the repo.
     */
    Repo.prototype.name = function () {
        return this.repoInfo_.namespace;
    };
    /**
     * @return {!number} The time in milliseconds, taking the server offset into account if we have one.
     */
    Repo.prototype.serverTime = function () {
        var offsetNode = this.infoData_.getNode(new _Path.Path('.info/serverTimeOffset'));
        var offset = offsetNode.val() || 0;
        return new Date().getTime() + offset;
    };
    /**
     * Generate ServerValues using some variables from the repo object.
     * @return {!Object}
     */
    Repo.prototype.generateServerValues = function () {
        return (0, _ServerValues.generateWithValues)({
            timestamp: this.serverTime()
        });
    };
    /**
     * Called by realtime when we get new messages from the server.
     *
     * @private
     * @param {string} pathString
     * @param {*} data
     * @param {boolean} isMerge
     * @param {?number} tag
     */
    Repo.prototype.onDataUpdate_ = function (pathString, data, isMerge, tag) {
        // For testing.
        this.dataUpdateCount++;
        var path = new _Path.Path(pathString);
        data = this.interceptServerDataCallback_ ? this.interceptServerDataCallback_(pathString, data) : data;
        var events = [];
        if (tag) {
            if (isMerge) {
                var taggedChildren = (0, _obj.map)(data, function (raw) {
                    return (0, _nodeFromJSON.nodeFromJSON)(raw);
                });
                events = this.serverSyncTree_.applyTaggedQueryMerge(path, taggedChildren, tag);
            } else {
                var taggedSnap = (0, _nodeFromJSON.nodeFromJSON)(data);
                events = this.serverSyncTree_.applyTaggedQueryOverwrite(path, taggedSnap, tag);
            }
        } else if (isMerge) {
            var changedChildren = (0, _obj.map)(data, function (raw) {
                return (0, _nodeFromJSON.nodeFromJSON)(raw);
            });
            events = this.serverSyncTree_.applyServerMerge(path, changedChildren);
        } else {
            var snap = (0, _nodeFromJSON.nodeFromJSON)(data);
            events = this.serverSyncTree_.applyServerOverwrite(path, snap);
        }
        var affectedPath = path;
        if (events.length > 0) {
            // Since we have a listener outstanding for each transaction, receiving any events
            // is a proxy for some change having occurred.
            affectedPath = this.rerunTransactions_(path);
        }
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, events);
    };
    /**
     * TODO: This should be @private but it's used by test_access.js and internal.js
     * @param {?function(!string, *):*} callback
     * @private
     */
    Repo.prototype.interceptServerData_ = function (callback) {
        this.interceptServerDataCallback_ = callback;
    };
    /**
     * @param {!boolean} connectStatus
     * @private
     */
    Repo.prototype.onConnectStatus_ = function (connectStatus) {
        this.updateInfo_('connected', connectStatus);
        if (connectStatus === false) {
            this.runOnDisconnectEvents_();
        }
    };
    /**
     * @param {!Object} updates
     * @private
     */
    Repo.prototype.onServerInfoUpdate_ = function (updates) {
        var _this = this;
        (0, _util.each)(updates, function (value, key) {
            _this.updateInfo_(key, value);
        });
    };
    /**
     *
     * @param {!string} pathString
     * @param {*} value
     * @private
     */
    Repo.prototype.updateInfo_ = function (pathString, value) {
        var path = new _Path.Path('/.info/' + pathString);
        var newNode = (0, _nodeFromJSON.nodeFromJSON)(value);
        this.infoData_.updateSnapshot(path, newNode);
        var events = this.infoSyncTree_.applyServerOverwrite(path, newNode);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
    };
    /**
     * @return {!number}
     * @private
     */
    Repo.prototype.getNextWriteId_ = function () {
        return this.nextWriteId_++;
    };
    /**
     * @param {!Path} path
     * @param {*} newVal
     * @param {number|string|null} newPriority
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.setWithPriority = function (path, newVal, newPriority, onComplete) {
        var _this = this;
        this.log_('set', {
            path: path.toString(),
            value: newVal,
            priority: newPriority
        });
        // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
        // (b) store unresolved paths on JSON parse
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = (0, _nodeFromJSON.nodeFromJSON)(newVal, newPriority);
        var newNode = (0, _ServerValues.resolveDeferredValueSnapshot)(newNodeUnresolved, serverValues);
        var writeId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, writeId, true);
        this.eventQueue_.queueEvents(events);
        this.server_.put(path.toString(), newNodeUnresolved.val( /*export=*/true), function (status, errorReason) {
            var success = status === 'ok';
            if (!success) {
                (0, _util.warn)('set at ' + path + ' failed: ' + status);
            }
            var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId, !success);
            _this.eventQueue_.raiseEventsForChangedPath(path, clearEvents);
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
        var affectedPath = this.abortTransactions_(path);
        this.rerunTransactions_(affectedPath);
        // We queued the events above, so just flush the queue here
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, []);
    };
    /**
     * @param {!Path} path
     * @param {!Object} childrenToMerge
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.update = function (path, childrenToMerge, onComplete) {
        var _this = this;
        this.log_('update', { path: path.toString(), value: childrenToMerge });
        // Start with our existing data and merge each child into it.
        var empty = true;
        var serverValues = this.generateServerValues();
        var changedChildren = {};
        (0, _obj.forEach)(childrenToMerge, function (changedKey, changedValue) {
            empty = false;
            var newNodeUnresolved = (0, _nodeFromJSON.nodeFromJSON)(changedValue);
            changedChildren[changedKey] = (0, _ServerValues.resolveDeferredValueSnapshot)(newNodeUnresolved, serverValues);
        });
        if (!empty) {
            var writeId_1 = this.getNextWriteId_();
            var events = this.serverSyncTree_.applyUserMerge(path, changedChildren, writeId_1);
            this.eventQueue_.queueEvents(events);
            this.server_.merge(path.toString(), childrenToMerge, function (status, errorReason) {
                var success = status === 'ok';
                if (!success) {
                    (0, _util.warn)('update at ' + path + ' failed: ' + status);
                }
                var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId_1, !success);
                var affectedPath = clearEvents.length > 0 ? _this.rerunTransactions_(path) : path;
                _this.eventQueue_.raiseEventsForChangedPath(affectedPath, clearEvents);
                _this.callOnCompleteCallback(onComplete, status, errorReason);
            });
            (0, _obj.forEach)(childrenToMerge, function (changedPath) {
                var affectedPath = _this.abortTransactions_(path.child(changedPath));
                _this.rerunTransactions_(affectedPath);
            });
            // We queued the events above, so just flush the queue here
            this.eventQueue_.raiseEventsForChangedPath(path, []);
        } else {
            (0, _util.log)("update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, 'ok');
        }
    };
    /**
     * Applies all of the changes stored up in the onDisconnect_ tree.
     * @private
     */
    Repo.prototype.runOnDisconnectEvents_ = function () {
        var _this = this;
        this.log_('onDisconnectEvents');
        var serverValues = this.generateServerValues();
        var resolvedOnDisconnectTree = (0, _ServerValues.resolveDeferredValueTree)(this.onDisconnect_, serverValues);
        var events = [];
        resolvedOnDisconnectTree.forEachTree(_Path.Path.Empty, function (path, snap) {
            events = events.concat(_this.serverSyncTree_.applyServerOverwrite(path, snap));
            var affectedPath = _this.abortTransactions_(path);
            _this.rerunTransactions_(affectedPath);
        });
        this.onDisconnect_ = new _SparseSnapshotTree.SparseSnapshotTree();
        this.eventQueue_.raiseEventsForChangedPath(_Path.Path.Empty, events);
    };
    /**
     * @param {!Path} path
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectCancel = function (path, onComplete) {
        var _this = this;
        this.server_.onDisconnectCancel(path.toString(), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.forget(path);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} value
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectSet = function (path, value, onComplete) {
        var _this = this;
        var newNode = (0, _nodeFromJSON.nodeFromJSON)(value);
        this.server_.onDisconnectPut(path.toString(), newNode.val( /*export=*/true), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.remember(path, newNode);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} value
     * @param {*} priority
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectSetWithPriority = function (path, value, priority, onComplete) {
        var _this = this;
        var newNode = (0, _nodeFromJSON.nodeFromJSON)(value, priority);
        this.server_.onDisconnectPut(path.toString(), newNode.val( /*export=*/true), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.remember(path, newNode);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} childrenToMerge
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectUpdate = function (path, childrenToMerge, onComplete) {
        var _this = this;
        if ((0, _obj.isEmpty)(childrenToMerge)) {
            (0, _util.log)("onDisconnect().update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, 'ok');
            return;
        }
        this.server_.onDisconnectMerge(path.toString(), childrenToMerge, function (status, errorReason) {
            if (status === 'ok') {
                (0, _obj.forEach)(childrenToMerge, function (childName, childNode) {
                    var newChildNode = (0, _nodeFromJSON.nodeFromJSON)(childNode);
                    _this.onDisconnect_.remember(path.child(childName), newChildNode);
                });
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     */
    Repo.prototype.addEventCallbackForQuery = function (query, eventRegistration) {
        var events;
        if (query.path.getFront() === '.info') {
            events = this.infoSyncTree_.addEventRegistration(query, eventRegistration);
        } else {
            events = this.serverSyncTree_.addEventRegistration(query, eventRegistration);
        }
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    /**
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration
     */
    Repo.prototype.removeEventCallbackForQuery = function (query, eventRegistration) {
        // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
        // a little bit by handling the return values anyways.
        var events;
        if (query.path.getFront() === '.info') {
            events = this.infoSyncTree_.removeEventRegistration(query, eventRegistration);
        } else {
            events = this.serverSyncTree_.removeEventRegistration(query, eventRegistration);
        }
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    Repo.prototype.interrupt = function () {
        if (this.persistentConnection_) {
            this.persistentConnection_.interrupt(INTERRUPT_REASON);
        }
    };
    Repo.prototype.resume = function () {
        if (this.persistentConnection_) {
            this.persistentConnection_.resume(INTERRUPT_REASON);
        }
    };
    Repo.prototype.stats = function (showDelta) {
        if (showDelta === void 0) {
            showDelta = false;
        }
        if (typeof console === 'undefined') return;
        var stats;
        if (showDelta) {
            if (!this.statsListener_) this.statsListener_ = new _StatsListener.StatsListener(this.stats_);
            stats = this.statsListener_.get();
        } else {
            stats = this.stats_.get();
        }
        var longestName = Object.keys(stats).reduce(function (previousValue, currentValue) {
            return Math.max(currentValue.length, previousValue);
        }, 0);
        (0, _obj.forEach)(stats, function (stat, value) {
            // pad stat names to be the same length (plus 2 extra spaces).
            for (var i = stat.length; i < longestName + 2; i++) {
                stat += ' ';
            }console.log(stat + value);
        });
    };
    Repo.prototype.statsIncrementCounter = function (metric) {
        this.stats_.incrementCounter(metric);
        this.statsReporter_.includeStat(metric);
    };
    /**
     * @param {...*} var_args
     * @private
     */
    Repo.prototype.log_ = function () {
        var var_args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            var_args[_i] = arguments[_i];
        }
        var prefix = '';
        if (this.persistentConnection_) {
            prefix = this.persistentConnection_.id + ':';
        }
        _util.log.apply(void 0, [prefix].concat(var_args));
    };
    /**
     * @param {?function(?Error, *=)} callback
     * @param {!string} status
     * @param {?string=} errorReason
     */
    Repo.prototype.callOnCompleteCallback = function (callback, status, errorReason) {
        if (callback) {
            (0, _util.exceptionGuard)(function () {
                if (status == 'ok') {
                    callback(null);
                } else {
                    var code = (status || 'error').toUpperCase();
                    var message = code;
                    if (errorReason) message += ': ' + errorReason;
                    var error = new Error(message);
                    error.code = code;
                    callback(error);
                }
            });
        }
    };
    Object.defineProperty(Repo.prototype, "database", {
        get: function get() {
            return this.__database || (this.__database = new _Database.Database(this));
        },
        enumerable: true,
        configurable: true
    });
    return Repo;
}();
exports.Repo = Repo;
//# sourceMappingURL=Repo.js.map


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LeafNode = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Copyright 2017 Google Inc.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Licensed under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                               * you may not use this file except in compliance with the License.
                                                                                                                                                                                                                                                                               * You may obtain a copy of the License at
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               *   http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Unless required by applicable law or agreed to in writing, software
                                                                                                                                                                                                                                                                               * distributed under the License is distributed on an "AS IS" BASIS,
                                                                                                                                                                                                                                                                               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                                                                                                                                                                                                               * See the License for the specific language governing permissions and
                                                                                                                                                                                                                                                                               * limitations under the License.
                                                                                                                                                                                                                                                                               */


var _assert = __webpack_require__(2);

var _util = __webpack_require__(3);

var _snap = __webpack_require__(172);

var __childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */
var LeafNode = /** @class */function () {
    /**
     * @implements {Node}
     * @param {!(string|number|boolean|Object)} value_ The value to store in this leaf node.
     *                                         The object type is possible in the event of a deferred value
     * @param {!Node=} priorityNode_ The priority of this node.
     */
    function LeafNode(value_, priorityNode_) {
        if (priorityNode_ === void 0) {
            priorityNode_ = LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        }
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        (0, _assert.assert)(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        (0, _snap.validatePriorityNode)(this.priorityNode_);
    }
    Object.defineProperty(LeafNode, "__childrenNodeConstructor", {
        get: function get() {
            return __childrenNodeConstructor;
        },
        set: function set(val) {
            __childrenNodeConstructor = val;
        },
        enumerable: true,
        configurable: true
    });
    /** @inheritDoc */
    LeafNode.prototype.isLeafNode = function () {
        return true;
    };
    /** @inheritDoc */
    LeafNode.prototype.getPriority = function () {
        return this.priorityNode_;
    };
    /** @inheritDoc */
    LeafNode.prototype.updatePriority = function (newPriorityNode) {
        return new LeafNode(this.value_, newPriorityNode);
    };
    /** @inheritDoc */
    LeafNode.prototype.getImmediateChild = function (childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') {
            return this.priorityNode_;
        } else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.getChild = function (path) {
        if (path.isEmpty()) {
            return this;
        } else if (path.getFront() === '.priority') {
            return this.priorityNode_;
        } else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        }
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.hasChild = function () {
        return false;
    };
    /** @inheritDoc */
    LeafNode.prototype.getPredecessorChildName = function (childName, childNode) {
        return null;
    };
    /** @inheritDoc */
    LeafNode.prototype.updateImmediateChild = function (childName, newChildNode) {
        if (childName === '.priority') {
            return this.updatePriority(newChildNode);
        } else if (newChildNode.isEmpty() && childName !== '.priority') {
            return this;
        } else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.updateChild = function (path, newChildNode) {
        var front = path.getFront();
        if (front === null) {
            return newChildNode;
        } else if (newChildNode.isEmpty() && front !== '.priority') {
            return this;
        } else {
            (0, _assert.assert)(front !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
            return this.updateImmediateChild(front, LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild(path.popFront(), newChildNode));
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.isEmpty = function () {
        return false;
    };
    /** @inheritDoc */
    LeafNode.prototype.numChildren = function () {
        return 0;
    };
    /** @inheritDoc */
    LeafNode.prototype.forEachChild = function (index, action) {
        return false;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.val = function (exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty()) return {
            '.value': this.getValue(),
            '.priority': this.getPriority().val()
        };else return this.getValue();
    };
    /** @inheritDoc */
    LeafNode.prototype.hash = function () {
        if (this.lazyHash_ === null) {
            var toHash = '';
            if (!this.priorityNode_.isEmpty()) toHash += 'priority:' + (0, _snap.priorityHashText)(this.priorityNode_.val()) + ':';
            var type = _typeof(this.value_);
            toHash += type + ':';
            if (type === 'number') {
                toHash += (0, _util.doubleToIEEE754String)(this.value_);
            } else {
                toHash += this.value_;
            }
            this.lazyHash_ = (0, _util.sha1)(toHash);
        }
        return this.lazyHash_;
    };
    /**
     * Returns the value of the leaf node.
     * @return {Object|string|number|boolean} The value of the node.
     */
    LeafNode.prototype.getValue = function () {
        return this.value_;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.compareTo = function (other) {
        if (other === LeafNode.__childrenNodeConstructor.EMPTY_NODE) {
            return 1;
        } else if (other instanceof LeafNode.__childrenNodeConstructor) {
            return -1;
        } else {
            (0, _assert.assert)(other.isLeafNode(), 'Unknown node type');
            return this.compareToLeafNode_(other);
        }
    };
    /**
     * Comparison specifically for two leaf nodes
     * @param {!LeafNode} otherLeaf
     * @return {!number}
     * @private
     */
    LeafNode.prototype.compareToLeafNode_ = function (otherLeaf) {
        var otherLeafType = _typeof(otherLeaf.value_);
        var thisLeafType = _typeof(this.value_);
        var otherIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        var thisIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        (0, _assert.assert)(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
        (0, _assert.assert)(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === 'object') {
                // Deferred value nodes are all equal, but we should also never get to this point...
                return 0;
            } else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) {
                    return -1;
                } else if (this.value_ === otherLeaf.value_) {
                    return 0;
                } else {
                    return 1;
                }
            }
        } else {
            return thisIndex - otherIndex;
        }
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.withIndex = function () {
        return this;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.isIndexed = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.equals = function (other) {
        /**
         * @inheritDoc
         */
        if (other === this) {
            return true;
        } else if (other.isLeafNode()) {
            var otherLeaf = other;
            return this.value_ === otherLeaf.value_ && this.priorityNode_.equals(otherLeaf.priorityNode_);
        } else {
            return false;
        }
    };
    /**
     * The sort order for comparing leaf nodes of different types. If two leaf nodes have
     * the same type, the comparison falls back to their value
     * @type {Array.<!string>}
     * @const
     */
    LeafNode.VALUE_TYPE_ORDER = ['object', 'boolean', 'number', 'string'];
    return LeafNode;
}();
exports.LeafNode = LeafNode;
//# sourceMappingURL=LeafNode.js.map


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Index = undefined;

var _Node = __webpack_require__(19);

var _util = __webpack_require__(3);

/**
 *
 * @constructor
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Index = /** @class */function () {
  function Index() {}
  /**
   * @return {function(!NamedNode, !NamedNode):number} A standalone comparison function for
   * this index
   */
  Index.prototype.getCompare = function () {
    return this.compare.bind(this);
  };
  /**
   * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
   * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
   *
   * @param {!Node} oldNode
   * @param {!Node} newNode
   * @return {boolean} True if the portion of the snapshot being indexed changed between oldNode and newNode
   */
  Index.prototype.indexedValueChanged = function (oldNode, newNode) {
    var oldWrapped = new _Node.NamedNode(_util.MIN_NAME, oldNode);
    var newWrapped = new _Node.NamedNode(_util.MIN_NAME, newNode);
    return this.compare(oldWrapped, newWrapped) !== 0;
  };
  /**
   * @return {!NamedNode} a node wrapper that will sort equal to or less than
   * any other node wrapper, using this index
   */
  Index.prototype.minPost = function () {
    return _Node.NamedNode.MIN;
  };
  return Index;
}();
exports.Index = Index;
//# sourceMappingURL=Index.js.map


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SessionStorage = exports.PersistentStorage = undefined;

var _DOMStorageWrapper = __webpack_require__(393);

var _MemoryStorage = __webpack_require__(394);

/**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param {string} domStorageName Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @return {?} Turning off type information until a common interface is defined.
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var createStoragefor = function createStoragefor(domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== 'undefined' && typeof window[domStorageName] !== 'undefined') {
            // Need to test cache. Just because it's here doesn't mean it works
            var domStorage = window[domStorageName];
            domStorage.setItem('firebase:sentinel', 'cache');
            domStorage.removeItem('firebase:sentinel');
            return new _DOMStorageWrapper.DOMStorageWrapper(domStorage);
        }
    } catch (e) {}
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new _MemoryStorage.MemoryStorage();
};
/** A storage object that lasts across sessions */
var PersistentStorage = exports.PersistentStorage = createStoragefor('localStorage');
/** A storage object that only lasts one session */
var SessionStorage = exports.SessionStorage = createStoragefor('sessionStorage');
//# sourceMappingURL=storage.js.map


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */
var CacheNode = /** @class */function () {
  /**
   * @param {!Node} node_
   * @param {boolean} fullyInitialized_
   * @param {boolean} filtered_
   */
  function CacheNode(node_, fullyInitialized_, filtered_) {
    this.node_ = node_;
    this.fullyInitialized_ = fullyInitialized_;
    this.filtered_ = filtered_;
  }
  /**
   * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
   * @return {boolean}
   */
  CacheNode.prototype.isFullyInitialized = function () {
    return this.fullyInitialized_;
  };
  /**
   * Returns whether this node is potentially missing children due to a filter applied to the node
   * @return {boolean}
   */
  CacheNode.prototype.isFiltered = function () {
    return this.filtered_;
  };
  /**
   * @param {!Path} path
   * @return {boolean}
   */
  CacheNode.prototype.isCompleteForPath = function (path) {
    if (path.isEmpty()) {
      return this.isFullyInitialized() && !this.filtered_;
    }
    var childKey = path.getFront();
    return this.isCompleteForChild(childKey);
  };
  /**
   * @param {!string} key
   * @return {boolean}
   */
  CacheNode.prototype.isCompleteForChild = function (key) {
    return this.isFullyInitialized() && !this.filtered_ || this.node_.hasChild(key);
  };
  /**
   * @return {!Node}
   */
  CacheNode.prototype.getNode = function () {
    return this.node_;
  };
  return CacheNode;
}();
exports.CacheNode = CacheNode;
//# sourceMappingURL=CacheNode.js.map


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PROTOCOL_VERSION = exports.PROTOCOL_VERSION = '5';
var VERSION_PARAM = exports.VERSION_PARAM = 'v';
var TRANSPORT_SESSION_PARAM = exports.TRANSPORT_SESSION_PARAM = 's';
var REFERER_PARAM = exports.REFERER_PARAM = 'r';
var FORGE_REF = exports.FORGE_REF = 'f';
var FORGE_DOMAIN = exports.FORGE_DOMAIN = 'firebaseio.com';
var LAST_SESSION_PARAM = exports.LAST_SESSION_PARAM = 'ls';
var WEBSOCKET = exports.WEBSOCKET = 'websocket';
var LONG_POLLING = exports.LONG_POLLING = 'long_polling';
//# sourceMappingURL=Constants.js.map


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


Object.defineProperty(exports, "__esModule", {
    value: true
});
var CODES = {
    AVAILABLE_IN_WINDOW: 'only-available-in-window',
    AVAILABLE_IN_SW: 'only-available-in-sw',
    SHOULD_BE_INHERITED: 'should-be-overriden',
    BAD_SENDER_ID: 'bad-sender-id',
    INCORRECT_GCM_SENDER_ID: 'incorrect-gcm-sender-id',
    PERMISSION_DEFAULT: 'permission-default',
    PERMISSION_BLOCKED: 'permission-blocked',
    UNSUPPORTED_BROWSER: 'unsupported-browser',
    NOTIFICATIONS_BLOCKED: 'notifications-blocked',
    FAILED_DEFAULT_REGISTRATION: 'failed-serviceworker-registration',
    SW_REGISTRATION_EXPECTED: 'sw-registration-expected',
    GET_SUBSCRIPTION_FAILED: 'get-subscription-failed',
    INVALID_SAVED_TOKEN: 'invalid-saved-token',
    SW_REG_REDUNDANT: 'sw-reg-redundant',
    TOKEN_SUBSCRIBE_FAILED: 'token-subscribe-failed',
    TOKEN_SUBSCRIBE_NO_TOKEN: 'token-subscribe-no-token',
    TOKEN_SUBSCRIBE_NO_PUSH_SET: 'token-subscribe-no-push-set',
    USE_SW_BEFORE_GET_TOKEN: 'use-sw-before-get-token',
    INVALID_DELETE_TOKEN: 'invalid-delete-token',
    DELETE_TOKEN_NOT_FOUND: 'delete-token-not-found',
    DELETE_SCOPE_NOT_FOUND: 'delete-scope-not-found',
    BG_HANDLER_FUNCTION_EXPECTED: 'bg-handler-function-expected',
    NO_WINDOW_CLIENT_TO_MSG: 'no-window-client-to-msg',
    UNABLE_TO_RESUBSCRIBE: 'unable-to-resubscribe',
    NO_FCM_TOKEN_FOR_RESUBSCRIBE: 'no-fcm-token-for-resubscribe',
    FAILED_TO_DELETE_TOKEN: 'failed-to-delete-token',
    NO_SW_IN_REG: 'no-sw-in-reg',
    BAD_SCOPE: 'bad-scope',
    BAD_VAPID_KEY: 'bad-vapid-key',
    BAD_SUBSCRIPTION: 'bad-subscription',
    BAD_TOKEN: 'bad-token',
    BAD_PUSH_SET: 'bad-push-set',
    FAILED_DELETE_VAPID_KEY: 'failed-delete-vapid-key'
};
var ERROR_MAP = (_a = {}, _a[CODES.AVAILABLE_IN_WINDOW] = 'This method is available in a Window context.', _a[CODES.AVAILABLE_IN_SW] = 'This method is available in a service worker ' + 'context.', _a[CODES.SHOULD_BE_INHERITED] = 'This method should be overriden by ' + 'extended classes.', _a[CODES.BAD_SENDER_ID] = "Please ensure that 'messagingSenderId' is set " + 'correctly in the options passed into firebase.initializeApp().', _a[CODES.PERMISSION_DEFAULT] = 'The required permissions were not granted and ' + 'dismissed instead.', _a[CODES.PERMISSION_BLOCKED] = 'The required permissions were not granted and ' + 'blocked instead.', _a[CODES.UNSUPPORTED_BROWSER] = "This browser doesn't support the API's " + 'required to use the firebase SDK.', _a[CODES.NOTIFICATIONS_BLOCKED] = 'Notifications have been blocked.', _a[CODES.FAILED_DEFAULT_REGISTRATION] = 'We are unable to register the ' + 'default service worker. {$browserErrorMessage}', _a[CODES.SW_REGISTRATION_EXPECTED] = 'A service worker registration was the ' + 'expected input.', _a[CODES.GET_SUBSCRIPTION_FAILED] = 'There was an error when trying to get ' + 'any existing Push Subscriptions.', _a[CODES.INVALID_SAVED_TOKEN] = 'Unable to access details of the saved token.', _a[CODES.SW_REG_REDUNDANT] = 'The service worker being used for push was made ' + 'redundant.', _a[CODES.TOKEN_SUBSCRIBE_FAILED] = 'A problem occured while subscribing the ' + 'user to FCM: {$message}', _a[CODES.TOKEN_SUBSCRIBE_NO_TOKEN] = 'FCM returned no token when subscribing ' + 'the user to push.', _a[CODES.TOKEN_SUBSCRIBE_NO_PUSH_SET] = 'FCM returned an invalid response ' + 'when getting an FCM token.', _a[CODES.USE_SW_BEFORE_GET_TOKEN] = 'You must call useServiceWorker() before ' + 'calling getToken() to ensure your service worker is used.', _a[CODES.INVALID_DELETE_TOKEN] = 'You must pass a valid token into ' + 'deleteToken(), i.e. the token from getToken().', _a[CODES.DELETE_TOKEN_NOT_FOUND] = 'The deletion attempt for token could not ' + 'be performed as the token was not found.', _a[CODES.DELETE_SCOPE_NOT_FOUND] = 'The deletion attempt for service worker ' + 'scope could not be performed as the scope was not found.', _a[CODES.BG_HANDLER_FUNCTION_EXPECTED] = 'The input to ' + 'setBackgroundMessageHandler() must be a function.', _a[CODES.NO_WINDOW_CLIENT_TO_MSG] = 'An attempt was made to message a ' + 'non-existant window client.', _a[CODES.UNABLE_TO_RESUBSCRIBE] = 'There was an error while re-subscribing ' + 'the FCM token for push messaging. Will have to resubscribe the ' + 'user on next visit. {$message}', _a[CODES.NO_FCM_TOKEN_FOR_RESUBSCRIBE] = 'Could not find an FCM token ' + 'and as a result, unable to resubscribe. Will have to resubscribe the ' + 'user on next visit.', _a[CODES.FAILED_TO_DELETE_TOKEN] = 'Unable to delete the currently saved token.', _a[CODES.NO_SW_IN_REG] = 'Even though the service worker registration was ' + 'successful, there was a problem accessing the service worker itself.', _a[CODES.INCORRECT_GCM_SENDER_ID] = "Please change your web app manifest's " + "'gcm_sender_id' value to '103953800507' to use Firebase messaging.", _a[CODES.BAD_SCOPE] = 'The service worker scope must be a string with at ' + 'least one character.', _a[CODES.BAD_VAPID_KEY] = 'The public VAPID key must be a string with at ' + 'least one character.', _a[CODES.BAD_SUBSCRIPTION] = 'The subscription must be a valid ' + 'PushSubscription.', _a[CODES.BAD_TOKEN] = 'The FCM Token used for storage / lookup was not ' + 'a valid token string.', _a[CODES.BAD_PUSH_SET] = 'The FCM push set used for storage / lookup was not ' + 'not a valid push set string.', _a[CODES.FAILED_DELETE_VAPID_KEY] = 'The VAPID key could not be deleted.', _a);
exports.default = {
    codes: CODES,
    map: ERROR_MAP
};

var _a;
module.exports = exports['default'];
//# sourceMappingURL=errors.js.map


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDomainBase = setDomainBase;
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Constants used in the Firebase Storage library.
 */
/**
 * Domain and scheme for API calls.
 */
var domainBase = exports.domainBase = 'https://firebasestorage.googleapis.com';
/**
 * Domain and scheme for object downloads.
 */
var downloadBase = exports.downloadBase = 'https://firebasestorage.googleapis.com';
/**
 * Base URL for non-upload calls to the API.
 */
var apiBaseUrl = exports.apiBaseUrl = '/v0';
/**
 * Base URL for upload calls to the API.
 */
var apiUploadBaseUrl = exports.apiUploadBaseUrl = '/v0';
function setDomainBase(domainBase) {
  domainBase = domainBase;
}
var configOption = exports.configOption = 'storageBucket';
/**
 * 1 minute
 */
var shortMaxOperationRetryTime = exports.shortMaxOperationRetryTime = 1 * 60 * 1000;
/**
 * 2 minutes
 */
var defaultMaxOperationRetryTime = exports.defaultMaxOperationRetryTime = 2 * 60 * 1000;
/**
 * 10 minutes
 */
var defaultMaxUploadRetryTime = exports.defaultMaxUploadRetryTime = 10 * 60 * 100;
/**
 * This is the value of Number.MIN_SAFE_INTEGER, which is not well supported
 * enough for us to use it directly.
 */
var minSafeInteger = exports.minSafeInteger = -9007199254740991;
//# sourceMappingURL=constants.js.map


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Location = undefined;

var _error = __webpack_require__(26);

var errorsExports = _interopRequireWildcard(_error);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * @struct
 */
var Location = /** @class */function () {
    function Location(bucket, path) {
        this.bucket = bucket;
        this.path_ = path;
    }
    Object.defineProperty(Location.prototype, "path", {
        get: function get() {
            return this.path_;
        },
        enumerable: true,
        configurable: true
    });
    Location.prototype.fullServerUrl = function () {
        var encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
    };
    Location.prototype.bucketOnlyServerUrl = function () {
        var encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o';
    };
    Location.makeFromBucketSpec = function (bucketString) {
        var bucketLocation;
        try {
            bucketLocation = Location.makeFromUrl(bucketString);
        } catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new Location(bucketString, '');
        }
        if (bucketLocation.path === '') {
            return bucketLocation;
        } else {
            throw errorsExports.invalidDefaultBucket(bucketString);
        }
    };
    Location.makeFromUrl = function (url) {
        var location = null;
        var bucketDomain = '([A-Za-z0-9.\\-]+)';
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === '/') {
                loc.path_ = loc.path_.slice(0, -1);
            }
        }
        var gsPath = '(/(.*))?$';
        var path = '(/([^?#]*).*)?$';
        var gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
        var gsIndices = { bucket: 1, path: 3 };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        var version = 'v[A-Za-z0-9_]+';
        var httpRegex = new RegExp('^https?://firebasestorage\\.googleapis\\.com/' + version + '/b/' + bucketDomain + '/o' + path, 'i');
        var httpIndices = { bucket: 1, path: 3 };
        var groups = [{ regex: gsRegex, indices: gsIndices, postModify: gsModify }, { regex: httpRegex, indices: httpIndices, postModify: httpModify }];
        for (var i = 0; i < groups.length; i++) {
            var group = groups[i];
            var captures = group.regex.exec(url);
            if (captures) {
                var bucketValue = captures[group.indices.bucket];
                var pathValue = captures[group.indices.path];
                if (!pathValue) {
                    pathValue = '';
                }
                location = new Location(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) {
            throw errorsExports.invalidUrl(url);
        }
        return location;
    };
    return Location;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
/**
 * @fileoverview Functionality related to the parsing/composition of bucket/
 * object location.
 */
exports.Location = Location;
//# sourceMappingURL=location.js.map


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
var CONSTANTS = exports.CONSTANTS = {
  /**
   * @define {boolean} Whether this is the client Node.js SDK.
   */
  NODE_CLIENT: false,
  /**
   * @define {boolean} Whether this is the Admin Node.js SDK.
   */
  NODE_ADMIN: false,
  /**
   * Firebase SDK Version
   */
  SDK_VERSION: '4.5.0'
};
//# sourceMappingURL=constants.js.map


/***/ }),
/* 87 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var EventPluginRegistry = __webpack_require__(119);
var ReactEventEmitterMixin = __webpack_require__(485);
var ViewportMetrics = __webpack_require__(211);

var getVendorPrefixedEventName = __webpack_require__(517);
var isEventSupported = __webpack_require__(130);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(66);
var ViewportMetrics = __webpack_require__(211);

var getEventModifierState = __webpack_require__(128);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(1);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(14);
var DOMNamespaces = __webpack_require__(118);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(126);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var randomFromSeed = __webpack_require__(553);

var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
var alphabet;
var previousSeed;

var shuffled;

function reset() {
    shuffled = false;
}

function setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if (alphabet !== ORIGINAL) {
            alphabet = ORIGINAL;
            reset();
        }
        return;
    }

    if (_alphabet_ === alphabet) {
        return;
    }

    if (_alphabet_.length !== ORIGINAL.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
    }

    var unique = _alphabet_.split('').filter(function(item, ind, arr){
       return ind !== arr.lastIndexOf(item);
    });

    if (unique.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
    }

    alphabet = _alphabet_;
    reset();
}

function characters(_alphabet_) {
    setCharacters(_alphabet_);
    return alphabet;
}

function setSeed(seed) {
    randomFromSeed.seed(seed);
    if (previousSeed !== seed) {
        reset();
        previousSeed = seed;
    }
}

function shuffle() {
    if (!alphabet) {
        setCharacters(ORIGINAL);
    }

    var sourceArray = alphabet.split('');
    var targetArray = [];
    var r = randomFromSeed.nextValue();
    var characterIndex;

    while (sourceArray.length > 0) {
        r = randomFromSeed.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join('');
}

function getShuffled() {
    if (shuffled) {
        return shuffled;
    }
    shuffled = shuffle();
    return shuffled;
}

/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */
function lookup(index) {
    var alphabetShuffled = getShuffled();
    return alphabetShuffled[index];
}

module.exports = {
    characters: characters,
    seed: setSeed,
    lookup: lookup,
    shuffled: getShuffled
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/quicksand.95529dd4.png";

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var CANNON = __webpack_require__(43),
    math = __webpack_require__(281);

module.exports = {
  'dynamic-body':   __webpack_require__(278),
  'static-body':    __webpack_require__(279),
  'constraint':     __webpack_require__(280),
  'system':         __webpack_require__(285),

  registerAll: function (AFRAME) {
    if (this._registered) return;

    AFRAME = AFRAME || window.AFRAME;

    math.registerAll();
    if (!AFRAME.systems.physics)            AFRAME.registerSystem('physics',         this.system);
    if (!AFRAME.components['dynamic-body']) AFRAME.registerComponent('dynamic-body', this['dynamic-body']);
    if (!AFRAME.components['static-body'])  AFRAME.registerComponent('static-body',  this['static-body']);
    if (!AFRAME.components['constraint'])   AFRAME.registerComponent('constraint',   this['constraint']);

    this._registered = true;
  }
};

// Export CANNON.js.
window.CANNON = window.CANNON || CANNON;


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aframe__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aframe__);


__WEBPACK_IMPORTED_MODULE_0_aframe___default.a.registerComponent('control-box', {
    schema: {

        offset: {
            type: "number",
            default: -5.0 //-30.0
        },

        enableX: {
            type: "boolean",
            default: true
        },

        doubleX: {
            type: "boolean",
            default: false
        },

        offsetY: {
            type: "number",
            default: 25
        },

        enableY: {
            type: "boolean",
            default: true
        }
    },

    init: function init() {
        this.moving = false;
        // this.enableFixed()

        console.log("Control Box Enable");

        this.camDeltaY = 0;

        this.onCameraChangeBinded = this.onCameraChange.bind(this);

        this.camera = document.getElementById('camera');

        var rot = this.el.getAttribute("rotation");
        this.el.setAttribute("rotation", Object.assign({}, rot, {
            x: this.data.enableX ? this.camera.getAttribute("rotation").x : 0,
            y: this.data.enableY ? this.camera.getAttribute("rotation").y : 0
        }));

        this.camera.addEventListener('componentchanged', this.onCameraChangeBinded);
    },

    remove: function remove() {
        this.camera.removeEventListener('componentchanged', this.onCameraChangeBinded);
    },

    enableFixed: function enableFixed() {

        if (!this.moving) {
            this.el.setAttribute('fixed', {
                enabled: true,
                fixX: false,

                offsetY: this.camDelta > 0 ? -this.camDelta : this.camDelta
            });
            this.moving = true;
        }
    },

    disableFixed: function disableFixed() {
        if (this.moving) {
            this.el.setAttribute('fixed', {
                enabled: false
            });
            this.moving = false;
        }
    },

    onCameraChange: function onCameraChange(e) {

        if (e.detail.name !== 'rotation') {
            return;
        }

        var rot = this.el.getAttribute("rotation");

        var cameraAngleX = e.detail.newData.x;
        this.camY = e.detail.newData.y;
        this.camX = e.detail.newData.x;

        this.camDeltaY = e.detail.newData.y - rot.y;
        this.camDeltaX = e.detail.newData.x - rot.x;

        if (cameraAngleX > this.data.offset && this.data.enableX) {

            this.el.setAttribute("rotation", Object.assign({}, rot, {
                y: this.camY
            }));
        } else if (Math.abs(this.camDeltaX) > this.data.offset && this.data.doubleX) {

            this.el.setAttribute("rotation", Object.assign({}, rot, {
                x: this.camX + Math.abs(this.camDeltaX) / this.camDeltaX * this.data.offset * -1
            }));
        } else if (Math.abs(this.camDeltaY) > this.data.offsetY && this.data.enableY) {

            this.el.setAttribute("rotation", Object.assign({}, rot, {
                y: this.camY + Math.abs(this.camDeltaY) / this.camDeltaY * this.data.offsetY * -1
            }));
        }
    }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aframe_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ActionButton = function (_Component) {
    _inherits(ActionButton, _Component);

    function ActionButton(props) {
        _classCallCheck(this, ActionButton);

        var _this = _possibleConstructorReturn(this, (ActionButton.__proto__ || Object.getPrototypeOf(ActionButton)).call(this, props));

        _this.minOpacity = 0.1;
        _this.maxOpacity = 1.0;

        _this.animDur = 100;

        _this.material = {
            opacity: _this.minOpacity,
            flatShading: true,
            side: "front"

            // this.animateIn = {
            //     property: "material.opacity",
            //     dur: 100,

            //     from: iddleOpacity.toString(),
            //     to: maxOpacity.toString(),

            //     startEvents: "mouseenter"
            // }

            // this.animateOut = {
            //     property: "material.opacity",
            //     dur: 100,

            //     from: maxOpacity.toString(),
            //     to: iddleOpacity.toString(),

            //     startEvents: "mouseleave"
            // }
        };return _this;
    }

    _createClass(ActionButton, [{
        key: "getAnimation",
        value: function getAnimation() {
            var reverse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a-animation", {
                attribute: "material.opacity",

                dur: this.animDur,

                from: !reverse ? this.minOpacity : this.maxOpacity,
                to: !reverse ? this.maxOpacity : this.minOpacity,

                begin: !reverse ? "mouseenter" : "mouseleave",
                end: !reverse ? "mouseleave" : "mouseenter"

            });
        }
    }, {
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                {
                    primitive: "a-image",

                    material: this.material,
                    scale: this.props.scale,

                    src: this.props.src,

                    position: this.props.position,

                    width: this.props.width, height: this.props.height

                    // animation__opacityup={this.animateIn}
                    // animation__opacitydown={this.animateOut}

                    , visible: this.props.visible,

                    events: this.props.events,

                    "frame-button": {
                        button: this.props.button
                    }
                },
                this.getAnimation(),
                this.getAnimation(true)
            );
        }
    }]);

    return ActionButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ActionButton.defaultProps = {
    width: 1,
    height: 1,

    position: {
        x: 0,
        y: 0,
        z: 0
    },

    scale: {
        x: 1,
        y: 1,
        z: 1
    },

    visible: true,

    events: {},

    button: false
};

/* harmony default export */ __webpack_exports__["a"] = (ActionButton);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_devtools_extension__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_devtools_extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_devtools_extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UrlHelper__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_url_encoder__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__localAppStorage__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__database__ = __webpack_require__(140);















var uCoder = new __WEBPACK_IMPORTED_MODULE_4__helpers_url_encoder__["a" /* default */]("AIzaSyCb96Oin5QxSdlHOgr9SO5VKUnZge5l5D8");

var savedState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__localAppStorage__["a" /* loadState */])();
var urlData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__UrlHelper__["a" /* getParameterByName */])("data");

/**
 *  Defines black space, if localStorage is empty
 */
if (savedState !== undefined) {
    console.log("STORE STUFF");

    if (Array.isArray(savedState.sceneItems)) {
        savedState = undefined;
    } else if (!Array.isArray(savedState.sceneItems.spaces)) {
        console.log("NO SPACES FOUND.");

        savedState.sceneItems.spaces = [{
            name: "Default Space",
            el: savedState.sceneItems.el
        }];

        savedState.sceneItems.curSpaceId = 0;
    }
}

/**
 *  Initialises Redux Store
 */
var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_6__reducers__["a" /* default */], savedState, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_devtools_extension__["composeWithDevTools"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"])(__WEBPACK_IMPORTED_MODULE_2_redux_thunk___default.a)));

/**
 *  Saves "sceneItems" into local storage on state update
 */
if (!urlData) store.subscribe(function () {
    var data = {
        sceneItems: store.getState().sceneItems
        // Save Items into localstorage
    };__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__localAppStorage__["b" /* saveState */])(data);

    // Upload into firebase
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__database__["a" /* firebaseBackup */])(data);
});

/**
 * 
 * Sets loaded URL data
 * 
 * @param {Object} data 
 * 
 */
var setUrlData = function setUrlData(data) {
    return {
        type: "URL_LOADED",
        data: JSON.parse(data)
    };
};

/**
 *  Asynchronously loads in data from URL
 */
var loadUrlData = function loadUrlData() {

    return function (dispatch) {
        console.log("LOADING " + urlData);

        uCoder.decodeString(urlData).then(function (data) {
            dispatch(setUrlData(data));
        });

        return {
            type: "URL_LOADING"
        };
    };
};

/**
 *  Loads data from URL 
 */
if (urlData) {
    store.dispatch(loadUrlData());
}

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = FrictionEquation;

var Equation = __webpack_require__(45);
var Vec3 = __webpack_require__(0);
var Mat3 = __webpack_require__(32);

/**
 * Constrains the slipping in a contact along a tangent
 * @class FrictionEquation
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Number} slipForce should be +-F_friction = +-mu * F_normal = +-mu * m * g
 * @extends Equation
 */
function FrictionEquation(bodyA, bodyB, slipForce){
    Equation.call(this,bodyA, bodyB, -slipForce, slipForce);
    this.ri = new Vec3();
    this.rj = new Vec3();
    this.t = new Vec3(); // tangent
}

FrictionEquation.prototype = new Equation();
FrictionEquation.prototype.constructor = FrictionEquation;

var FrictionEquation_computeB_temp1 = new Vec3();
var FrictionEquation_computeB_temp2 = new Vec3();
FrictionEquation.prototype.computeB = function(h){
    var a = this.a,
        b = this.b,
        bi = this.bi,
        bj = this.bj,
        ri = this.ri,
        rj = this.rj,
        rixt = FrictionEquation_computeB_temp1,
        rjxt = FrictionEquation_computeB_temp2,
        t = this.t;

    // Caluclate cross products
    ri.cross(t,rixt);
    rj.cross(t,rjxt);

    // G = [-t -rixt t rjxt]
    // And remember, this is a pure velocity constraint, g is always zero!
    var GA = this.jacobianElementA,
        GB = this.jacobianElementB;
    t.negate(GA.spatial);
    rixt.negate(GA.rotational);
    GB.spatial.copy(t);
    GB.rotational.copy(rjxt);

    var GW = this.computeGW();
    var GiMf = this.computeGiMf();

    var B = - GW * b - h * GiMf;

    return B;
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = RotationalMotorEquation;

var Vec3 = __webpack_require__(0);
var Mat3 = __webpack_require__(32);
var Equation = __webpack_require__(45);

/**
 * Rotational motor constraint. Tries to keep the relative angular velocity of the bodies to a given value.
 * @class RotationalMotorEquation
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Number} maxForce
 * @extends Equation
 */
function RotationalMotorEquation(bodyA, bodyB, maxForce){
    maxForce = typeof(maxForce)!=='undefined' ? maxForce : 1e6;
    Equation.call(this,bodyA,bodyB,-maxForce,maxForce);

    /**
     * World oriented rotational axis
     * @property {Vec3} axisA
     */
    this.axisA = new Vec3();

    /**
     * World oriented rotational axis
     * @property {Vec3} axisB
     */
    this.axisB = new Vec3(); // World oriented rotational axis

    /**
     * Motor velocity
     * @property {Number} targetVelocity
     */
    this.targetVelocity = 0;
}

RotationalMotorEquation.prototype = new Equation();
RotationalMotorEquation.prototype.constructor = RotationalMotorEquation;

RotationalMotorEquation.prototype.computeB = function(h){
    var a = this.a,
        b = this.b,
        bi = this.bi,
        bj = this.bj,

        axisA = this.axisA,
        axisB = this.axisB,

        GA = this.jacobianElementA,
        GB = this.jacobianElementB;

    // g = 0
    // gdot = axisA * wi - axisB * wj
    // gdot = G * W = G * [vi wi vj wj]
    // =>
    // G = [0 axisA 0 -axisB]

    GA.rotational.copy(axisA);
    axisB.negate(GB.rotational);

    var GW = this.computeGW() - this.targetVelocity,
        GiMf = this.computeGiMf();

    var B = - GW * b - h * GiMf;

    return B;
};


/***/ }),
/* 101 */
/***/ (function(module, exports) {

/**
 * Base class for objects that dispatches events.
 * @class EventTarget
 * @constructor
 */
var EventTarget = function () {

};

module.exports = EventTarget;

EventTarget.prototype = {
    constructor: EventTarget,

    /**
     * Add an event listener
     * @method addEventListener
     * @param  {String} type
     * @param  {Function} listener
     * @return {EventTarget} The self object, for chainability.
     */
    addEventListener: function ( type, listener ) {
        if ( this._listeners === undefined ){ this._listeners = {}; }
        var listeners = this._listeners;
        if ( listeners[ type ] === undefined ) {
            listeners[ type ] = [];
        }
        if ( listeners[ type ].indexOf( listener ) === - 1 ) {
            listeners[ type ].push( listener );
        }
        return this;
    },

    /**
     * Check if an event listener is added
     * @method hasEventListener
     * @param  {String} type
     * @param  {Function} listener
     * @return {Boolean}
     */
    hasEventListener: function ( type, listener ) {
        if ( this._listeners === undefined ){ return false; }
        var listeners = this._listeners;
        if ( listeners[ type ] !== undefined && listeners[ type ].indexOf( listener ) !== - 1 ) {
            return true;
        }
        return false;
    },

    /**
     * Check if any event listener of the given type is added
     * @method hasAnyEventListener
     * @param  {String} type
     * @return {Boolean}
     */
    hasAnyEventListener: function ( type ) {
        if ( this._listeners === undefined ){ return false; }
        var listeners = this._listeners;
        return ( listeners[ type ] !== undefined );
    },

    /**
     * Remove an event listener
     * @method removeEventListener
     * @param  {String} type
     * @param  {Function} listener
     * @return {EventTarget} The self object, for chainability.
     */
    removeEventListener: function ( type, listener ) {
        if ( this._listeners === undefined ){ return this; }
        var listeners = this._listeners;
        if ( listeners[type] === undefined ){ return this; }
        var index = listeners[ type ].indexOf( listener );
        if ( index !== - 1 ) {
            listeners[ type ].splice( index, 1 );
        }
        return this;
    },

    /**
     * Emit an event.
     * @method dispatchEvent
     * @param  {Object} event
     * @param  {String} event.type
     * @return {EventTarget} The self object, for chainability.
     */
    dispatchEvent: function ( event ) {
        if ( this._listeners === undefined ){ return this; }
        var listeners = this._listeners;
        var listenerArray = listeners[ event.type ];
        if ( listenerArray !== undefined ) {
            event.target = this;
            for ( var i = 0, l = listenerArray.length; i < l; i ++ ) {
                listenerArray[ i ].call( this, event );
            }
        }
        return this;
    }
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.patchCapture = patchCapture;
var ERROR_NAME = 'FirebaseError';
var captureStackTrace = Error.captureStackTrace;
// Export for faking in tests
function patchCapture(captureFake) {
    var result = captureStackTrace;
    captureStackTrace = captureFake;
    return result;
}
var FirebaseError = /** @class */function () {
    function FirebaseError(code, message) {
        this.code = code;
        this.message = message;
        var stack;
        // We want the stack value, if implemented by Error
        if (captureStackTrace) {
            // Patches this.stack, omitted calls above ErrorFactory#create
            captureStackTrace(this, ErrorFactory.prototype.create);
        } else {
            var err_1 = Error.apply(this, arguments);
            this.name = ERROR_NAME;
            // Make non-enumerable getter for the property.
            Object.defineProperty(this, 'stack', {
                get: function get() {
                    return err_1.stack;
                }
            });
        }
    }
    return FirebaseError;
}();
exports.FirebaseError = FirebaseError;
// Back-door inheritance

FirebaseError.prototype = Object.create(Error.prototype);
FirebaseError.prototype.constructor = FirebaseError;
FirebaseError.prototype.name = ERROR_NAME;
var ErrorFactory = /** @class */function () {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
        // Matches {$name}, by default.
        this.pattern = /\{\$([^}]+)}/g;
        // empty
    }
    ErrorFactory.prototype.create = function (code, data) {
        if (data === undefined) {
            data = {};
        }
        var template = this.errors[code];
        var fullCode = this.service + '/' + code;
        var message;
        if (template === undefined) {
            message = 'Error';
        } else {
            message = template.replace(this.pattern, function (match, key) {
                var value = data[key];
                return value !== undefined ? value.toString() : '<' + key + '?>';
            });
        }
        // Service: Error message (service/code).
        message = this.serviceName + ': ' + message + ' (' + fullCode + ').';
        var err = new FirebaseError(fullCode, message);
        // Populate the Error object with message parts for programmatic
        // accesses (e.g., e.file).
        for (var prop in data) {
            if (!data.hasOwnProperty(prop) || prop.slice(-1) === '_') {
                continue;
            }
            err[prop] = data[prop];
        }
        return err;
    };
    return ErrorFactory;
}();
exports.ErrorFactory = ErrorFactory;
//# sourceMappingURL=errors.js.map


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Reference = undefined;

var _onDisconnect = __webpack_require__(379);

var _TransactionResult = __webpack_require__(377);

var _util = __webpack_require__(3);

var _NextPushId = __webpack_require__(395);

var _Query = __webpack_require__(160);

var _Repo = __webpack_require__(77);

var _Path = __webpack_require__(9);

var _QueryParams = __webpack_require__(405);

var _validation = __webpack_require__(37);

var _validation2 = __webpack_require__(40);

var _promise = __webpack_require__(39);

var _SyncPoint = __webpack_require__(165);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();

var Reference = /** @class */function (_super) {
    __extends(Reference, _super);
    /**
     * Call options:
     *   new Reference(Repo, Path) or
     *   new Reference(url: string, string|RepoManager)
     *
     * Externally - this is the firebase.database.Reference type.
     *
     * @param {!Repo} repo
     * @param {(!Path)} path
     * @extends {Query}
     */
    function Reference(repo, path) {
        var _this = this;
        if (!(repo instanceof _Repo.Repo)) {
            throw new Error('new Reference() no longer supported - use app.database().');
        }
        // call Query's constructor, passing in the repo and path.
        _this = _super.call(this, repo, path, _QueryParams.QueryParams.DEFAULT, false) || this;
        return _this;
    }
    /** @return {?string} */
    Reference.prototype.getKey = function () {
        (0, _validation2.validateArgCount)('Reference.key', 0, 0, arguments.length);
        if (this.path.isEmpty()) return null;else return this.path.getBack();
    };
    /**
     * @param {!(string|Path)} pathString
     * @return {!Reference}
     */
    Reference.prototype.child = function (pathString) {
        (0, _validation2.validateArgCount)('Reference.child', 1, 1, arguments.length);
        if (typeof pathString === 'number') {
            pathString = String(pathString);
        } else if (!(pathString instanceof _Path.Path)) {
            if (this.path.getFront() === null) (0, _validation.validateRootPathString)('Reference.child', 1, pathString, false);else (0, _validation.validatePathString)('Reference.child', 1, pathString, false);
        }
        return new Reference(this.repo, this.path.child(pathString));
    };
    /** @return {?Reference} */
    Reference.prototype.getParent = function () {
        (0, _validation2.validateArgCount)('Reference.parent', 0, 0, arguments.length);
        var parentPath = this.path.parent();
        return parentPath === null ? null : new Reference(this.repo, parentPath);
    };
    /** @return {!Reference} */
    Reference.prototype.getRoot = function () {
        (0, _validation2.validateArgCount)('Reference.root', 0, 0, arguments.length);
        var ref = this;
        while (ref.getParent() !== null) {
            ref = ref.getParent();
        }
        return ref;
    };
    /** @return {!Database} */
    Reference.prototype.databaseProp = function () {
        return this.repo.database;
    };
    /**
     * @param {*} newVal
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.set = function (newVal, onComplete) {
        (0, _validation2.validateArgCount)('Reference.set', 1, 2, arguments.length);
        (0, _validation.validateWritablePath)('Reference.set', this.path);
        (0, _validation.validateFirebaseDataArg)('Reference.set', 1, newVal, this.path, false);
        (0, _validation2.validateCallback)('Reference.set', 2, onComplete, true);
        var deferred = new _promise.Deferred();
        this.repo.setWithPriority(this.path, newVal,
        /*priority=*/null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.update = function (objectToMerge, onComplete) {
        (0, _validation2.validateArgCount)('Reference.update', 1, 2, arguments.length);
        (0, _validation.validateWritablePath)('Reference.update', this.path);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for (var i = 0; i < objectToMerge.length; ++i) {
                newObjectToMerge['' + i] = objectToMerge[i];
            }
            objectToMerge = newObjectToMerge;
            (0, _util.warn)('Passing an Array to Firebase.update() is deprecated. ' + 'Use set() if you want to overwrite the existing data, or ' + 'an Object with integer keys if you really do want to ' + 'only update some of the children.');
        }
        (0, _validation.validateFirebaseMergeDataArg)('Reference.update', 1, objectToMerge, this.path, false);
        (0, _validation2.validateCallback)('Reference.update', 2, onComplete, true);
        var deferred = new _promise.Deferred();
        this.repo.update(this.path, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} newVal
     * @param {string|number|null} newPriority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.setWithPriority = function (newVal, newPriority, onComplete) {
        (0, _validation2.validateArgCount)('Reference.setWithPriority', 2, 3, arguments.length);
        (0, _validation.validateWritablePath)('Reference.setWithPriority', this.path);
        (0, _validation.validateFirebaseDataArg)('Reference.setWithPriority', 1, newVal, this.path, false);
        (0, _validation.validatePriority)('Reference.setWithPriority', 2, newPriority, false);
        (0, _validation2.validateCallback)('Reference.setWithPriority', 3, onComplete, true);
        if (this.getKey() === '.length' || this.getKey() === '.keys') throw 'Reference.setWithPriority failed: ' + this.getKey() + ' is a read-only object.';
        var deferred = new _promise.Deferred();
        this.repo.setWithPriority(this.path, newVal, newPriority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.remove = function (onComplete) {
        (0, _validation2.validateArgCount)('Reference.remove', 0, 1, arguments.length);
        (0, _validation.validateWritablePath)('Reference.remove', this.path);
        (0, _validation2.validateCallback)('Reference.remove', 1, onComplete, true);
        return this.set(null, onComplete);
    };
    /**
     * @param {function(*):*} transactionUpdate
     * @param {(function(?Error, boolean, ?DataSnapshot))=} onComplete
     * @param {boolean=} applyLocally
     * @return {!Promise}
     */
    Reference.prototype.transaction = function (transactionUpdate, onComplete, applyLocally) {
        (0, _validation2.validateArgCount)('Reference.transaction', 1, 3, arguments.length);
        (0, _validation.validateWritablePath)('Reference.transaction', this.path);
        (0, _validation2.validateCallback)('Reference.transaction', 1, transactionUpdate, false);
        (0, _validation2.validateCallback)('Reference.transaction', 2, onComplete, true);
        // NOTE: applyLocally is an internal-only option for now.  We need to decide if we want to keep it and how
        // to expose it.
        (0, _validation.validateBoolean)('Reference.transaction', 3, applyLocally, true);
        if (this.getKey() === '.length' || this.getKey() === '.keys') throw 'Reference.transaction failed: ' + this.getKey() + ' is a read-only object.';
        if (applyLocally === undefined) applyLocally = true;
        var deferred = new _promise.Deferred();
        if (typeof onComplete === 'function') {
            (0, _promise.attachDummyErrorHandler)(deferred.promise);
        }
        var promiseComplete = function promiseComplete(error, committed, snapshot) {
            if (error) {
                deferred.reject(error);
            } else {
                deferred.resolve(new _TransactionResult.TransactionResult(committed, snapshot));
            }
            if (typeof onComplete === 'function') {
                onComplete(error, committed, snapshot);
            }
        };
        this.repo.startTransaction(this.path, transactionUpdate, promiseComplete, applyLocally);
        return deferred.promise;
    };
    /**
     * @param {string|number|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.setPriority = function (priority, onComplete) {
        (0, _validation2.validateArgCount)('Reference.setPriority', 1, 2, arguments.length);
        (0, _validation.validateWritablePath)('Reference.setPriority', this.path);
        (0, _validation.validatePriority)('Reference.setPriority', 1, priority, false);
        (0, _validation2.validateCallback)('Reference.setPriority', 2, onComplete, true);
        var deferred = new _promise.Deferred();
        this.repo.setWithPriority(this.path.child('.priority'), priority, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*=} value
     * @param {function(?Error)=} onComplete
     * @return {!Reference}
     */
    Reference.prototype.push = function (value, onComplete) {
        (0, _validation2.validateArgCount)('Reference.push', 0, 2, arguments.length);
        (0, _validation.validateWritablePath)('Reference.push', this.path);
        (0, _validation.validateFirebaseDataArg)('Reference.push', 1, value, this.path, true);
        (0, _validation2.validateCallback)('Reference.push', 2, onComplete, true);
        var now = this.repo.serverTime();
        var name = (0, _NextPushId.nextPushId)(now);
        // push() returns a ThennableReference whose promise is fulfilled with a regular Reference.
        // We use child() to create handles to two different references. The first is turned into a
        // ThennableReference below by adding then() and catch() methods and is used as the
        // return value of push(). The second remains a regular Reference and is used as the fulfilled
        // value of the first ThennableReference.
        var thennablePushRef = this.child(name);
        var pushRef = this.child(name);
        var promise;
        if (value != null) {
            promise = thennablePushRef.set(value, onComplete).then(function () {
                return pushRef;
            });
        } else {
            promise = _promise.PromiseImpl.resolve(pushRef);
        }
        thennablePushRef.then = promise.then.bind(promise);
        thennablePushRef.catch = promise.then.bind(promise, undefined);
        if (typeof onComplete === 'function') {
            (0, _promise.attachDummyErrorHandler)(promise);
        }
        return thennablePushRef;
    };
    /**
     * @return {!OnDisconnect}
     */
    Reference.prototype.onDisconnect = function () {
        (0, _validation.validateWritablePath)('Reference.onDisconnect', this.path);
        return new _onDisconnect.OnDisconnect(this.repo, this.path);
    };
    Object.defineProperty(Reference.prototype, "database", {
        get: function get() {
            return this.databaseProp();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "key", {
        get: function get() {
            return this.getKey();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "parent", {
        get: function get() {
            return this.getParent();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        get: function get() {
            return this.getRoot();
        },
        enumerable: true,
        configurable: true
    });
    return Reference;
}(_Query.Query);
exports.Reference = Reference;
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */

_Query.Query.__referenceConstructor = Reference;
_SyncPoint.SyncPoint.__referenceConstructor = Reference;
//# sourceMappingURL=Reference.js.map


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RepoManager = undefined;

var _obj = __webpack_require__(7);

var _Repo = __webpack_require__(77);

var _util = __webpack_require__(3);

var _parser = __webpack_require__(177);

var _validation = __webpack_require__(37);

__webpack_require__(384);

/** @const {string} */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DATABASE_URL_OPTION = 'databaseURL';
var _staticInstance;
/**
 * Creates and caches Repo instances.
 */
var RepoManager = /** @class */function () {
    function RepoManager() {
        /**
         * @private {!Object.<string, Object<string, !fb.core.Repo>>}
         */
        this.repos_ = {};
        /**
         * If true, new Repos will be created to use ReadonlyRestClient (for testing purposes).
         * @private {boolean}
         */
        this.useRestClient_ = false;
    }
    RepoManager.getInstance = function () {
        if (!_staticInstance) {
            _staticInstance = new RepoManager();
        }
        return _staticInstance;
    };
    // TODO(koss): Remove these functions unless used in tests?
    RepoManager.prototype.interrupt = function () {
        for (var appName in this.repos_) {
            for (var dbUrl in this.repos_[appName]) {
                this.repos_[appName][dbUrl].interrupt();
            }
        }
    };
    RepoManager.prototype.resume = function () {
        for (var appName in this.repos_) {
            for (var dbUrl in this.repos_[appName]) {
                this.repos_[appName][dbUrl].resume();
            }
        }
    };
    /**
     * This function should only ever be called to CREATE a new database instance.
     *
     * @param {!FirebaseApp} app
     * @return {!Database}
     */
    RepoManager.prototype.databaseFromApp = function (app, url) {
        var dbUrl = url || app.options[DATABASE_URL_OPTION];
        if (dbUrl === undefined) {
            (0, _util.fatal)("Can't determine Firebase Database URL.  Be sure to include " + DATABASE_URL_OPTION + ' option when calling firebase.intializeApp().');
        }
        var parsedUrl = (0, _parser.parseRepoInfo)(dbUrl);
        var repoInfo = parsedUrl.repoInfo;
        (0, _validation.validateUrl)('Invalid Firebase Database URL', 1, parsedUrl);
        if (!parsedUrl.path.isEmpty()) {
            (0, _util.fatal)('Database URL must point to the root of a Firebase Database ' + '(not including a child path).');
        }
        var repo = this.createRepo(repoInfo, app);
        return repo.database;
    };
    /**
     * Remove the repo and make sure it is disconnected.
     *
     * @param {!Repo} repo
     */
    RepoManager.prototype.deleteRepo = function (repo) {
        var appRepos = (0, _obj.safeGet)(this.repos_, repo.app.name);
        // This should never happen...
        if (!appRepos || (0, _obj.safeGet)(appRepos, repo.repoInfo_.toURLString()) !== repo) {
            (0, _util.fatal)("Database " + repo.app.name + "(" + repo.repoInfo_ + ") has already been deleted.");
        }
        repo.interrupt();
        delete appRepos[repo.repoInfo_.toURLString()];
    };
    /**
     * Ensures a repo doesn't already exist and then creates one using the
     * provided app.
     *
     * @param {!RepoInfo} repoInfo The metadata about the Repo
     * @param {!FirebaseApp} app
     * @return {!Repo} The Repo object for the specified server / repoName.
     */
    RepoManager.prototype.createRepo = function (repoInfo, app) {
        var appRepos = (0, _obj.safeGet)(this.repos_, app.name);
        if (!appRepos) {
            appRepos = {};
            this.repos_[app.name] = appRepos;
        }
        var repo = (0, _obj.safeGet)(appRepos, repoInfo.toURLString());
        if (repo) {
            (0, _util.fatal)('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
        }
        repo = new _Repo.Repo(repoInfo, this.useRestClient_, app);
        appRepos[repoInfo.toURLString()] = repo;
        return repo;
    };
    /**
     * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
     * @param {boolean} forceRestClient
     */
    RepoManager.prototype.forceRestClient = function (forceRestClient) {
        this.useRestClient_ = forceRestClient;
    };
    return RepoManager;
}();
exports.RepoManager = RepoManager;
//# sourceMappingURL=RepoManager.js.map


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StatsManager = undefined;

var _StatsCollection = __webpack_require__(391);

var StatsManager = /** @class */function () {
    function StatsManager() {}
    StatsManager.getCollection = function (repoInfo) {
        var hashString = repoInfo.toString();
        if (!this.collections_[hashString]) {
            this.collections_[hashString] = new _StatsCollection.StatsCollection();
        }
        return this.collections_[hashString];
    };
    StatsManager.getOrCreateReporter = function (repoInfo, creatorFunction) {
        var hashString = repoInfo.toString();
        if (!this.reporters_[hashString]) {
            this.reporters_[hashString] = creatorFunction();
        }
        return this.reporters_[hashString];
    };
    StatsManager.collections_ = {};
    StatsManager.reporters_ = {};
    return StatsManager;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.StatsManager = StatsManager;
//# sourceMappingURL=StatsManager.js.map


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ImmutableTree = undefined;

var _SortedMap = __webpack_require__(108);

var _Path = __webpack_require__(9);

var _util = __webpack_require__(3);

var _obj = __webpack_require__(7);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 * @const
 * @type {!SortedMap.<string, !ImmutableTree.<?>>}
 */
var EmptyChildren = function EmptyChildren() {
    if (!emptyChildrenSingleton) {
        emptyChildrenSingleton = new _SortedMap.SortedMap(_util.stringCompare);
    }
    return emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */
var ImmutableTree = /** @class */function () {
    /**
     * @template T
     * @param {?T} value
     * @param {SortedMap.<string, !ImmutableTree.<T>>=} children
     */
    function ImmutableTree(value, children) {
        if (children === void 0) {
            children = EmptyChildren();
        }
        this.value = value;
        this.children = children;
    }
    /**
     * @template T
     * @param {!Object.<string, !T>} obj
     * @return {!ImmutableTree.<!T>}
     */
    ImmutableTree.fromObject = function (obj) {
        var tree = ImmutableTree.Empty;
        (0, _obj.forEach)(obj, function (childPath, childSnap) {
            tree = tree.set(new _Path.Path(childPath), childSnap);
        });
        return tree;
    };
    /**
     * True if the value is empty and there are no children
     * @return {boolean}
     */
    ImmutableTree.prototype.isEmpty = function () {
        return this.value === null && this.children.isEmpty();
    };
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of {path: value:} objects
     * on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param {!Path} relativePath The remainder of the path
     * @param {function(T):boolean} predicate The predicate to satisfy to return a
     *   node
     * @return {?{path:!Path, value:!T}}
     */
    ImmutableTree.prototype.findRootMostMatchingPathAndValue = function (relativePath, predicate) {
        if (this.value != null && predicate(this.value)) {
            return { path: _Path.Path.Empty, value: this.value };
        } else {
            if (relativePath.isEmpty()) {
                return null;
            } else {
                var front = relativePath.getFront();
                var child = this.children.get(front);
                if (child !== null) {
                    var childExistingPathAndValue = child.findRootMostMatchingPathAndValue(relativePath.popFront(), predicate);
                    if (childExistingPathAndValue != null) {
                        var fullPath = new _Path.Path(front).child(childExistingPathAndValue.path);
                        return { path: fullPath, value: childExistingPathAndValue.value };
                    } else {
                        return null;
                    }
                } else {
                    return null;
                }
            }
        }
    };
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     * @param {!Path} relativePath
     * @return {?{path: !Path, value: !T}}
     */
    ImmutableTree.prototype.findRootMostValueAndPath = function (relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, function () {
            return true;
        });
    };
    /**
     * @param {!Path} relativePath
     * @return {!ImmutableTree.<T>} The subtree at the given path
     */
    ImmutableTree.prototype.subtree = function (relativePath) {
        if (relativePath.isEmpty()) {
            return this;
        } else {
            var front = relativePath.getFront();
            var childTree = this.children.get(front);
            if (childTree !== null) {
                return childTree.subtree(relativePath.popFront());
            } else {
                return ImmutableTree.Empty;
            }
        }
    };
    /**
     * Sets a value at the specified path.
     *
     * @param {!Path} relativePath Path to set value at.
     * @param {?T} toSet Value to set.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */
    ImmutableTree.prototype.set = function (relativePath, toSet) {
        if (relativePath.isEmpty()) {
            return new ImmutableTree(toSet, this.children);
        } else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.set(relativePath.popFront(), toSet);
            var newChildren = this.children.insert(front, newChild);
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Removes the value at the specified path.
     *
     * @param {!Path} relativePath Path to value to remove.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */
    ImmutableTree.prototype.remove = function (relativePath) {
        if (relativePath.isEmpty()) {
            if (this.children.isEmpty()) {
                return ImmutableTree.Empty;
            } else {
                return new ImmutableTree(null, this.children);
            }
        } else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) {
                var newChild = child.remove(relativePath.popFront());
                var newChildren = void 0;
                if (newChild.isEmpty()) {
                    newChildren = this.children.remove(front);
                } else {
                    newChildren = this.children.insert(front, newChild);
                }
                if (this.value === null && newChildren.isEmpty()) {
                    return ImmutableTree.Empty;
                } else {
                    return new ImmutableTree(this.value, newChildren);
                }
            } else {
                return this;
            }
        }
    };
    /**
     * Gets a value from the tree.
     *
     * @param {!Path} relativePath Path to get value for.
     * @return {?T} Value at path, or null.
     */
    ImmutableTree.prototype.get = function (relativePath) {
        if (relativePath.isEmpty()) {
            return this.value;
        } else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) {
                return child.get(relativePath.popFront());
            } else {
                return null;
            }
        }
    };
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param {!Path} relativePath Path to replace subtree for.
     * @param {!ImmutableTree} newTree New tree.
     * @return {!ImmutableTree} Resulting tree.
     */
    ImmutableTree.prototype.setTree = function (relativePath, newTree) {
        if (relativePath.isEmpty()) {
            return newTree;
        } else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.setTree(relativePath.popFront(), newTree);
            var newChildren = void 0;
            if (newChild.isEmpty()) {
                newChildren = this.children.remove(front);
            } else {
                newChildren = this.children.insert(front, newChild);
            }
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     * @template V
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     */
    ImmutableTree.prototype.fold = function (fn) {
        return this.fold_(_Path.Path.Empty, fn);
    };
    /**
     * Recursive helper for public-facing fold() method
     * @template V
     * @param {!Path} pathSoFar
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     * @private
     */
    ImmutableTree.prototype.fold_ = function (pathSoFar, fn) {
        var accum = {};
        this.children.inorderTraversal(function (childKey, childTree) {
            accum[childKey] = childTree.fold_(pathSoFar.child(childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    };
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     * @template V
     * @param {!Path} path
     * @param {!function(!Path, !T):?V} f
     * @return {?V}
     */
    ImmutableTree.prototype.findOnPath = function (path, f) {
        return this.findOnPath_(path, _Path.Path.Empty, f);
    };
    ImmutableTree.prototype.findOnPath_ = function (pathToFollow, pathSoFar, f) {
        var result = this.value ? f(pathSoFar, this.value) : false;
        if (result) {
            return result;
        } else {
            if (pathToFollow.isEmpty()) {
                return null;
            } else {
                var front = pathToFollow.getFront();
                var nextChild = this.children.get(front);
                if (nextChild) {
                    return nextChild.findOnPath_(pathToFollow.popFront(), pathSoFar.child(front), f);
                } else {
                    return null;
                }
            }
        }
    };
    /**
     *
     * @param {!Path} path
     * @param {!function(!Path, !T)} f
     * @returns {!ImmutableTree.<T>}
     */
    ImmutableTree.prototype.foreachOnPath = function (path, f) {
        return this.foreachOnPath_(path, _Path.Path.Empty, f);
    };
    ImmutableTree.prototype.foreachOnPath_ = function (pathToFollow, currentRelativePath, f) {
        if (pathToFollow.isEmpty()) {
            return this;
        } else {
            if (this.value) {
                f(currentRelativePath, this.value);
            }
            var front = pathToFollow.getFront();
            var nextChild = this.children.get(front);
            if (nextChild) {
                return nextChild.foreachOnPath_(pathToFollow.popFront(), currentRelativePath.child(front), f);
            } else {
                return ImmutableTree.Empty;
            }
        }
    };
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param {function(!Path, !T)} f A function to be called with
     *   the path from the root of the tree to a node, and the value at that node.
     *   Called in depth-first order.
     */
    ImmutableTree.prototype.foreach = function (f) {
        this.foreach_(_Path.Path.Empty, f);
    };
    ImmutableTree.prototype.foreach_ = function (currentRelativePath, f) {
        this.children.inorderTraversal(function (childName, childTree) {
            childTree.foreach_(currentRelativePath.child(childName), f);
        });
        if (this.value) {
            f(currentRelativePath, this.value);
        }
    };
    /**
     *
     * @param {function(string, !T)} f
     */
    ImmutableTree.prototype.foreachChild = function (f) {
        this.children.inorderTraversal(function (childName, childTree) {
            if (childTree.value) {
                f(childName, childTree.value);
            }
        });
    };
    ImmutableTree.Empty = new ImmutableTree(null);
    return ImmutableTree;
}();
exports.ImmutableTree = ImmutableTree;
//# sourceMappingURL=ImmutableTree.js.map


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An iterator over an LLRBNode.
 */
var SortedMapIterator = /** @class */function () {
    /**
     * @template K, V, T
     * @param {LLRBNode|LLRBEmptyNode} node Node to iterate.
     * @param {?K} startKey
     * @param {function(K, K): number} comparator
     * @param {boolean} isReverse_ Whether or not to iterate in reverse
     * @param {(function(K, V):T)=} resultGenerator_
     */
    function SortedMapIterator(node, startKey, comparator, isReverse_, resultGenerator_) {
        if (resultGenerator_ === void 0) {
            resultGenerator_ = null;
        }
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        /** @private
         * @type {Array.<!LLRBNode>}
         */
        this.nodeStack_ = [];
        var cmp = 1;
        while (!node.isEmpty()) {
            node = node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_) cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) {
                    node = node.left;
                } else {
                    node = node.right;
                }
            } else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            } else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) {
                    node = node.right;
                } else {
                    node = node.left;
                }
            }
        }
    }
    SortedMapIterator.prototype.getNext = function () {
        if (this.nodeStack_.length === 0) return null;
        var node = this.nodeStack_.pop();
        var result;
        if (this.resultGenerator_) result = this.resultGenerator_(node.key, node.value);else result = { key: node.key, value: node.value };
        if (this.isReverse_) {
            node = node.left;
            while (!node.isEmpty()) {
                this.nodeStack_.push(node);
                node = node.right;
            }
        } else {
            node = node.right;
            while (!node.isEmpty()) {
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    };
    SortedMapIterator.prototype.hasNext = function () {
        return this.nodeStack_.length > 0;
    };
    SortedMapIterator.prototype.peek = function () {
        if (this.nodeStack_.length === 0) return null;
        var node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) {
            return this.resultGenerator_(node.key, node.value);
        } else {
            return { key: node.key, value: node.value };
        }
    };
    return SortedMapIterator;
}();
exports.SortedMapIterator = SortedMapIterator;
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */

var LLRBNode = /** @class */function () {
    /**
     * @template K, V
     * @param {!K} key Key associated with this node.
     * @param {!V} value Value associated with this node.
     * @param {?boolean} color Whether this node is red.
     * @param {?(LLRBNode|LLRBEmptyNode)=} left Left child.
     * @param {?(LLRBNode|LLRBEmptyNode)=} right Right child.
     */
    function LLRBNode(key, value, color, left, right) {
        this.key = key;
        this.value = value;
        this.color = color != null ? color : LLRBNode.RED;
        this.left = left != null ? left : SortedMap.EMPTY_NODE;
        this.right = right != null ? right : SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param {?K} key New key for the node, or null.
     * @param {?V} value New value for the node, or null.
     * @param {?boolean} color New color for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} left New left child for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} right New right child for the node, or null.
     * @return {!LLRBNode} The node copy.
     */
    LLRBNode.prototype.copy = function (key, value, color, left, right) {
        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */
    LLRBNode.prototype.count = function () {
        return this.left.count() + 1 + this.right.count();
    };
    /**
     * @return {boolean} True if the tree is empty.
     */
    LLRBNode.prototype.isEmpty = function () {
        return false;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */
    LLRBNode.prototype.inorderTraversal = function (action) {
        return this.left.inorderTraversal(action) || action(this.key, this.value) || this.right.inorderTraversal(action);
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!Object, !Object)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {*} True if traversal was aborted.
     */
    LLRBNode.prototype.reverseTraversal = function (action) {
        return this.right.reverseTraversal(action) || action(this.key, this.value) || this.left.reverseTraversal(action);
    };
    /**
     * @return {!Object} The minimum node in the tree.
     * @private
     */
    LLRBNode.prototype.min_ = function () {
        if (this.left.isEmpty()) {
            return this;
        } else {
            return this.left.min_();
        }
    };
    /**
     * @return {!K} The maximum key in the tree.
     */
    LLRBNode.prototype.minKey = function () {
        return this.min_().key;
    };
    /**
     * @return {!K} The maximum key in the tree.
     */
    LLRBNode.prototype.maxKey = function () {
        if (this.right.isEmpty()) {
            return this.key;
        } else {
            return this.right.maxKey();
        }
    };
    /**
     *
     * @param {!Object} key Key to insert.
     * @param {!Object} value Value to insert.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with the key/value added.
     */
    LLRBNode.prototype.insert = function (key, value, comparator) {
        var cmp, n;
        n = this;
        cmp = comparator(key, n.key);
        if (cmp < 0) {
            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        } else if (cmp === 0) {
            n = n.copy(null, value, null, null, null);
        } else {
            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @private
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the minimum key removed.
     */
    LLRBNode.prototype.removeMin_ = function () {
        if (this.left.isEmpty()) {
            return SortedMap.EMPTY_NODE;
        }
        var n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    };
    /**
     * @param {!Object} key The key of the item to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the specified item removed.
     */
    LLRBNode.prototype.remove = function (key, comparator) {
        var n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) {
                n = n.moveRedLeft_();
            }
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        } else {
            if (n.left.isRed_()) n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) {
                n = n.moveRedRight_();
            }
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) {
                    return SortedMap.EMPTY_NODE;
                } else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @private
     * @return {boolean} Whether this is a RED node.
     */
    LLRBNode.prototype.isRed_ = function () {
        return this.color;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree after performing any needed rotations.
     */
    LLRBNode.prototype.fixUp_ = function () {
        var n = this;
        if (n.right.isRed_() && !n.left.isRed_()) n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_()) n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_()) n = n.colorFlip_();
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedLeft.
     */
    LLRBNode.prototype.moveRedLeft_ = function () {
        var n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedRight.
     */
    LLRBNode.prototype.moveRedRight_ = function () {
        var n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateLeft.
     */
    LLRBNode.prototype.rotateLeft_ = function () {
        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateRight.
     */
    LLRBNode.prototype.rotateRight_ = function () {
        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after colorFlip.
     */
    LLRBNode.prototype.colorFlip_ = function () {
        var left = this.left.copy(null, null, !this.left.color, null, null);
        var right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    };
    /**
     * For testing.
     *
     * @private
     * @return {boolean} True if all is well.
     */
    LLRBNode.prototype.checkMaxDepth_ = function () {
        var blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */
    LLRBNode.prototype.check_ = function () {
        var blackDepth;
        if (this.isRed_() && this.left.isRed_()) {
            throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
        }
        if (this.right.isRed_()) {
            throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
        }
        blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) {
            throw new Error('Black depths differ');
        } else {
            return blackDepth + (this.isRed_() ? 0 : 1);
        }
    };
    LLRBNode.RED = true;
    LLRBNode.BLACK = false;
    return LLRBNode;
}();
exports.LLRBNode = LLRBNode;
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */

var LLRBEmptyNode = /** @class */function () {
    function LLRBEmptyNode() {}
    /**
     * Returns a copy of the current node.
     *
     * @return {!LLRBEmptyNode} The node copy.
     */
    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
        return this;
    };
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with item added.
     */
    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
        return new LLRBNode(key, value, null);
    };
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBEmptyNode} New tree, with item removed.
     */
    LLRBEmptyNode.prototype.remove = function (key, comparator) {
        return this;
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */
    LLRBEmptyNode.prototype.count = function () {
        return 0;
    };
    /**
     * @return {boolean} True if the tree is empty.
     */
    LLRBEmptyNode.prototype.isEmpty = function () {
        return true;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */
    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
        return false;
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */
    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
        return false;
    };
    /**
     * @return {null}
     */
    LLRBEmptyNode.prototype.minKey = function () {
        return null;
    };
    /**
     * @return {null}
     */
    LLRBEmptyNode.prototype.maxKey = function () {
        return null;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */
    LLRBEmptyNode.prototype.check_ = function () {
        return 0;
    };
    /**
     * @private
     * @return {boolean} Whether this node is red.
     */
    LLRBEmptyNode.prototype.isRed_ = function () {
        return false;
    };
    return LLRBEmptyNode;
}();
exports.LLRBEmptyNode = LLRBEmptyNode;
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */

var SortedMap = /** @class */function () {
    /**
     * @template K, V
     * @param {function(K, K):number} comparator_ Key comparator.
     * @param {LLRBNode=} root_ (Optional) Root node for the map.
     */
    function SortedMap(comparator_, root_) {
        if (root_ === void 0) {
            root_ = SortedMap.EMPTY_NODE;
        }
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @return {!SortedMap.<K, V>} New map, with item added.
     */
    SortedMap.prototype.insert = function (key, value) {
        return new SortedMap(this.comparator_, this.root_.insert(key, value, this.comparator_).copy(null, null, LLRBNode.BLACK, null, null));
    };
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @return {!SortedMap.<K, V>} New map, with item removed.
     */
    SortedMap.prototype.remove = function (key) {
        return new SortedMap(this.comparator_, this.root_.remove(key, this.comparator_).copy(null, null, LLRBNode.BLACK, null, null));
    };
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param {!K} key The key to look up.
     * @return {?V} The value of the node with the given key, or null if the
     * key doesn't exist.
     */
    SortedMap.prototype.get = function (key) {
        var cmp;
        var node = this.root_;
        while (!node.isEmpty()) {
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                return node.value;
            } else if (cmp < 0) {
                node = node.left;
            } else if (cmp > 0) {
                node = node.right;
            }
        }
        return null;
    };
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param {K} key The key to find the predecessor of
     * @return {?K} The predecessor key.
     */
    SortedMap.prototype.getPredecessorKey = function (key) {
        var cmp,
            node = this.root_,
            rightParent = null;
        while (!node.isEmpty()) {
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while (!node.right.isEmpty()) {
                        node = node.right;
                    }return node.key;
                } else if (rightParent) {
                    return rightParent.key;
                } else {
                    return null; // first item.
                }
            } else if (cmp < 0) {
                node = node.left;
            } else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
    };
    /**
     * @return {boolean} True if the map is empty.
     */
    SortedMap.prototype.isEmpty = function () {
        return this.root_.isEmpty();
    };
    /**
     * @return {number} The total number of nodes in the map.
     */
    SortedMap.prototype.count = function () {
        return this.root_.count();
    };
    /**
     * @return {?K} The minimum key in the map.
     */
    SortedMap.prototype.minKey = function () {
        return this.root_.minKey();
    };
    /**
     * @return {?K} The maximum key in the map.
     */
    SortedMap.prototype.maxKey = function () {
        return this.root_.maxKey();
    };
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!K, !V):*} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */
    SortedMap.prototype.inorderTraversal = function (action) {
        return this.root_.inorderTraversal(action);
    };
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!Object, !Object)} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} True if the traversal was aborted.
     */
    SortedMap.prototype.reverseTraversal = function (action) {
        return this.root_.reverseTraversal(action);
    };
    /**
     * Returns an iterator over the SortedMap.
     * @template T
     * @param {(function(K, V):T)=} resultGenerator
     * @return {SortedMapIterator.<K, V, T>} The iterator.
     */
    SortedMap.prototype.getIterator = function (resultGenerator) {
        return new SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getIteratorFrom = function (key, resultGenerator) {
        return new SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getReverseIteratorFrom = function (key, resultGenerator) {
        return new SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    };
    SortedMap.prototype.getReverseIterator = function (resultGenerator) {
        return new SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    };
    /**
     * Always use the same empty node, to reduce memory.
     * @const
     */
    SortedMap.EMPTY_NODE = new LLRBEmptyNode();
    return SortedMap;
}();
exports.SortedMap = SortedMap;
//# sourceMappingURL=SortedMap.js.map


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IndexedFilter = undefined;

var _assert = __webpack_require__(2);

var _Change = __webpack_require__(48);

var _ChildrenNode = __webpack_require__(16);

var _PriorityIndex = __webpack_require__(15);

/**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 *
 * @constructor
 * @implements {NodeFilter}
 * @param {!Index} index
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var IndexedFilter = /** @class */function () {
    function IndexedFilter(index_) {
        this.index_ = index_;
    }
    IndexedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        (0, _assert.assert)(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
        var oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() == newChild.isEmpty()) {
                // Nothing changed.
                // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
                //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
                return snap;
            }
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) {
                    optChangeAccumulator.trackChildChange(_Change.Change.childRemovedChange(key, oldChild));
                } else {
                    (0, _assert.assert)(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
                }
            } else if (oldChild.isEmpty()) {
                optChangeAccumulator.trackChildChange(_Change.Change.childAddedChange(key, newChild));
            } else {
                optChangeAccumulator.trackChildChange(_Change.Change.childChangedChange(key, newChild, oldChild));
            }
        }
        if (snap.isLeafNode() && newChild.isEmpty()) {
            return snap;
        } else {
            // Make sure the node is indexed
            return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
        }
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) {
                oldSnap.forEachChild(_PriorityIndex.PRIORITY_INDEX, function (key, childNode) {
                    if (!newSnap.hasChild(key)) {
                        optChangeAccumulator.trackChildChange(_Change.Change.childRemovedChange(key, childNode));
                    }
                });
            }
            if (!newSnap.isLeafNode()) {
                newSnap.forEachChild(_PriorityIndex.PRIORITY_INDEX, function (key, childNode) {
                    if (oldSnap.hasChild(key)) {
                        var oldChild = oldSnap.getImmediateChild(key);
                        if (!oldChild.equals(childNode)) {
                            optChangeAccumulator.trackChildChange(_Change.Change.childChangedChange(key, childNode, oldChild));
                        }
                    } else {
                        optChangeAccumulator.trackChildChange(_Change.Change.childAddedChange(key, childNode));
                    }
                });
            }
        }
        return newSnap.withIndex(this.index_);
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        if (oldSnap.isEmpty()) {
            return _ChildrenNode.ChildrenNode.EMPTY_NODE;
        } else {
            return oldSnap.updatePriority(newPriority);
        }
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.filtersNodes = function () {
        return false;
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.getIndexedFilter = function () {
        return this;
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    return IndexedFilter;
}();
exports.IndexedFilter = IndexedFilter;
//# sourceMappingURL=IndexedFilter.js.map


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ArgSpec = undefined;
exports.validate = validate;
exports.and_ = and_;
exports.stringSpec = stringSpec;
exports.uploadDataSpec = uploadDataSpec;
exports.metadataSpec = metadataSpec;
exports.nonNegativeNumberSpec = nonNegativeNumberSpec;
exports.looseObjectSpec = looseObjectSpec;
exports.nullFunctionSpec = nullFunctionSpec;

var _error = __webpack_require__(26);

var errorsExports = _interopRequireWildcard(_error);

var _metadata = __webpack_require__(112);

var MetadataUtils = _interopRequireWildcard(_metadata);

var _type = __webpack_require__(20);

var type = _interopRequireWildcard(_type);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * @param name Name of the function.
 * @param specs Argument specs.
 * @param passed The actual arguments passed to the function.
 * @throws {fbs.Error} If the arguments are invalid.
 */
function validate(name, specs, passed) {
    var minArgs = specs.length;
    var maxArgs = specs.length;
    for (var i = 0; i < specs.length; i++) {
        if (specs[i].optional) {
            minArgs = i;
            break;
        }
    }
    var validLength = minArgs <= passed.length && passed.length <= maxArgs;
    if (!validLength) {
        throw errorsExports.invalidArgumentCount(minArgs, maxArgs, name, passed.length);
    }
    for (var i = 0; i < passed.length; i++) {
        try {
            specs[i].validator(passed[i]);
        } catch (e) {
            if (e instanceof Error) {
                throw errorsExports.invalidArgument(i, name, e.message);
            } else {
                throw errorsExports.invalidArgument(i, name, e);
            }
        }
    }
}
/**
 * @struct
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ArgSpec = /** @class */function () {
    function ArgSpec(validator, opt_optional) {
        var self = this;
        this.validator = function (p) {
            if (self.optional && !type.isJustDef(p)) {
                return;
            }
            validator(p);
        };
        this.optional = !!opt_optional;
    }
    return ArgSpec;
}();
exports.ArgSpec = ArgSpec;
function and_(v1, v2) {
    return function (p) {
        v1(p);
        v2(p);
    };
}
function stringSpec(opt_validator, opt_optional) {
    function stringValidator(p) {
        if (!type.isString(p)) {
            throw 'Expected string.';
        }
    }
    var validator;
    if (opt_validator) {
        validator = and_(stringValidator, opt_validator);
    } else {
        validator = stringValidator;
    }
    return new ArgSpec(validator, opt_optional);
}
function uploadDataSpec() {
    function validator(p) {
        var valid = p instanceof Uint8Array || p instanceof ArrayBuffer || type.isNativeBlobDefined() && p instanceof Blob;
        if (!valid) {
            throw 'Expected Blob or File.';
        }
    }
    return new ArgSpec(validator);
}
function metadataSpec(opt_optional) {
    return new ArgSpec(MetadataUtils.metadataValidator, opt_optional);
}
function nonNegativeNumberSpec() {
    function validator(p) {
        var valid = type.isNumber(p) && p >= 0;
        if (!valid) {
            throw 'Expected a number 0 or greater.';
        }
    }
    return new ArgSpec(validator);
}
function looseObjectSpec(opt_validator, opt_optional) {
    function validator(p) {
        var isLooseObject = p === null || type.isDef(p) && p instanceof Object;
        if (!isLooseObject) {
            throw 'Expected an Object.';
        }
        if (opt_validator !== undefined && opt_validator !== null) {
            opt_validator(p);
        }
    }
    return new ArgSpec(validator, opt_optional);
}
function nullFunctionSpec(opt_optional) {
    function validator(p) {
        var valid = p === null || type.isFunction(p);
        if (!valid) {
            throw 'Expected a Function.';
        }
    }
    return new ArgSpec(validator, opt_optional);
}
//# sourceMappingURL=args.js.map


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contains = contains;
exports.clone = clone;
exports.remove = remove;
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns true if the object is contained in the array (compared with ===).
 * @template T
 */
function contains(array, elem) {
  return array.indexOf(elem) !== -1;
}
/**
 * Returns a shallow copy of the array or array-like object (e.g. arguments).
 * @template T
 */
function clone(arraylike) {
  return Array.prototype.slice.call(arraylike);
}
/**
 * Removes the given element from the given array, if it is contained.
 * Directly modifies the passed-in array.
 * @template T
 */
function remove(array, elem) {
  var i = array.indexOf(elem);
  if (i !== -1) {
    array.splice(i, 1);
  }
}
//# sourceMappingURL=array.js.map


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Mapping = undefined;
exports.noXform_ = noXform_;
exports.xformPath = xformPath;
exports.getMappings = getMappings;
exports.addRef = addRef;
exports.fromResource = fromResource;
exports.fromResourceString = fromResourceString;
exports.toResourceString = toResourceString;
exports.metadataValidator = metadataValidator;

var _json = __webpack_require__(425);

var json = _interopRequireWildcard(_json);

var _location = __webpack_require__(85);

var _path = __webpack_require__(188);

var path = _interopRequireWildcard(_path);

var _type = __webpack_require__(20);

var type = _interopRequireWildcard(_type);

var _url = __webpack_require__(114);

var UrlUtils = _interopRequireWildcard(_url);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function noXform_(metadata, value) {
    return value;
}
/**
 * @struct
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Mapping = /** @class */function () {
    function Mapping(server, opt_local, opt_writable, opt_xform) {
        this.server = server;
        this.local = opt_local || server;
        this.writable = !!opt_writable;
        this.xform = opt_xform || noXform_;
    }
    return Mapping;
}();
exports.Mapping = Mapping;

var mappings_ = null;
function xformPath(fullPath) {
    var valid = type.isString(fullPath);
    if (!valid || fullPath.length < 2) {
        return fullPath;
    } else {
        fullPath = fullPath;
        return path.lastComponent(fullPath);
    }
}
function getMappings() {
    if (mappings_) {
        return mappings_;
    }
    var mappings = [];
    mappings.push(new Mapping('bucket'));
    mappings.push(new Mapping('generation'));
    mappings.push(new Mapping('metageneration'));
    mappings.push(new Mapping('name', 'fullPath', true));
    function mappingsXformPath(metadata, fullPath) {
        return xformPath(fullPath);
    }
    var nameMapping = new Mapping('name');
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */
    function xformSize(metadata, size) {
        if (type.isDef(size)) {
            return +size;
        } else {
            return size;
        }
    }
    var sizeMapping = new Mapping('size');
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new Mapping('timeCreated'));
    mappings.push(new Mapping('updated'));
    mappings.push(new Mapping('md5Hash', null, true));
    mappings.push(new Mapping('cacheControl', null, true));
    mappings.push(new Mapping('contentDisposition', null, true));
    mappings.push(new Mapping('contentEncoding', null, true));
    mappings.push(new Mapping('contentLanguage', null, true));
    mappings.push(new Mapping('contentType', null, true));
    mappings.push(new Mapping('metadata', 'customMetadata', true));
    /**
     * Transforms a comma-separated string of tokens into a list of download
     * URLs.
     */
    function xformTokens(metadata, tokens) {
        var valid = type.isString(tokens) && tokens.length > 0;
        if (!valid) {
            // This can happen if objects are uploaded through GCS and retrieved
            // through list, so we don't want to throw an Error.
            return [];
        }
        var encode = encodeURIComponent;
        var tokensList = tokens.split(',');
        var urls = tokensList.map(function (token) {
            var bucket = metadata['bucket'];
            var path = metadata['fullPath'];
            var urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
            var base = UrlUtils.makeDownloadUrl(urlPart);
            var queryString = UrlUtils.makeQueryString({
                alt: 'media',
                token: token
            });
            return base + queryString;
        });
        return urls;
    }
    mappings.push(new Mapping('downloadTokens', 'downloadURLs', false, xformTokens));
    mappings_ = mappings;
    return mappings_;
}
function addRef(metadata, authWrapper) {
    function generateRef() {
        var bucket = metadata['bucket'];
        var path = metadata['fullPath'];
        var loc = new _location.Location(bucket, path);
        return authWrapper.makeStorageReference(loc);
    }
    Object.defineProperty(metadata, 'ref', { get: generateRef });
}
function fromResource(authWrapper, resource, mappings) {
    var metadata = {};
    metadata['type'] = 'file';
    var len = mappings.length;
    for (var i = 0; i < len; i++) {
        var mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    addRef(metadata, authWrapper);
    return metadata;
}
function fromResourceString(authWrapper, resourceString, mappings) {
    var obj = json.jsonObjectOrNull(resourceString);
    if (obj === null) {
        return null;
    }
    var resource = obj;
    return fromResource(authWrapper, resource, mappings);
}
function toResourceString(metadata, mappings) {
    var resource = {};
    var len = mappings.length;
    for (var i = 0; i < len; i++) {
        var mapping = mappings[i];
        if (mapping.writable) {
            resource[mapping.server] = metadata[mapping.local];
        }
    }
    return JSON.stringify(resource);
}
function metadataValidator(p) {
    var validType = p && type.isObject(p);
    if (!validType) {
        throw 'Expected Metadata object.';
    }
    for (var key in p) {
        var val = p[key];
        if (key === 'customMetadata') {
            if (!type.isObject(val)) {
                throw 'Expected object for \'customMetadata\' mapping.';
            }
        } else {
            if (type.isNonNullObject(val)) {
                throw "Mapping for '" + key + "' cannot be an object.";
            }
        }
    }
}
//# sourceMappingURL=metadata.js.map


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StringData = exports.StringFormat = undefined;
exports.formatValidator = formatValidator;
exports.dataFromString = dataFromString;
exports.utf8Bytes_ = utf8Bytes_;
exports.percentEncodedBytes_ = percentEncodedBytes_;
exports.base64Bytes_ = base64Bytes_;
exports.dataURLBytes_ = dataURLBytes_;
exports.dataURLContentType_ = dataURLContentType_;

var _error = __webpack_require__(26);

var errorsExports = _interopRequireWildcard(_error);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var StringFormat = exports.StringFormat = {
    RAW: 'raw',
    BASE64: 'base64',
    BASE64URL: 'base64url',
    DATA_URL: 'data_url'
}; /**
    * Copyright 2017 Google Inc.
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *   http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */
function formatValidator(stringFormat) {
    switch (stringFormat) {
        case StringFormat.RAW:
        case StringFormat.BASE64:
        case StringFormat.BASE64URL:
        case StringFormat.DATA_URL:
            return;
        default:
            throw 'Expected one of the event types: [' + StringFormat.RAW + ', ' + StringFormat.BASE64 + ', ' + StringFormat.BASE64URL + ', ' + StringFormat.DATA_URL + '].';
    }
}
/**
 * @struct
 */
var StringData = /** @class */function () {
    function StringData(data, opt_contentType) {
        this.data = data;
        this.contentType = opt_contentType || null;
    }
    return StringData;
}();
exports.StringData = StringData;
function dataFromString(format, string) {
    switch (format) {
        case StringFormat.RAW:
            return new StringData(utf8Bytes_(string));
        case StringFormat.BASE64:
        case StringFormat.BASE64URL:
            return new StringData(base64Bytes_(format, string));
        case StringFormat.DATA_URL:
            return new StringData(dataURLBytes_(string), dataURLContentType_(string));
    }
    // assert(false);
    throw errorsExports.unknown();
}
function utf8Bytes_(string) {
    var b = [];
    for (var i = 0; i < string.length; i++) {
        var c = string.charCodeAt(i);
        if (c <= 127) {
            b.push(c);
        } else {
            if (c <= 2047) {
                b.push(192 | c >> 6, 128 | c & 63);
            } else {
                if ((c & 64512) == 55296) {
                    // The start of a surrogate pair.
                    var valid = i < string.length - 1 && (string.charCodeAt(i + 1) & 64512) == 56320;
                    if (!valid) {
                        // The second surrogate wasn't there.
                        b.push(239, 191, 189);
                    } else {
                        var hi = c;
                        var lo = string.charCodeAt(++i);
                        c = 65536 | (hi & 1023) << 10 | lo & 1023;
                        b.push(240 | c >> 18, 128 | c >> 12 & 63, 128 | c >> 6 & 63, 128 | c & 63);
                    }
                } else {
                    if ((c & 64512) == 56320) {
                        // Invalid low surrogate.
                        b.push(239, 191, 189);
                    } else {
                        b.push(224 | c >> 12, 128 | c >> 6 & 63, 128 | c & 63);
                    }
                }
            }
        }
    }
    return new Uint8Array(b);
}
function percentEncodedBytes_(string) {
    var decoded;
    try {
        decoded = decodeURIComponent(string);
    } catch (e) {
        throw errorsExports.invalidFormat(StringFormat.DATA_URL, 'Malformed data URL.');
    }
    return utf8Bytes_(decoded);
}
function base64Bytes_(format, string) {
    switch (format) {
        case StringFormat.BASE64:
            {
                var hasMinus = string.indexOf('-') !== -1;
                var hasUnder = string.indexOf('_') !== -1;
                if (hasMinus || hasUnder) {
                    var invalidChar = hasMinus ? '-' : '_';
                    throw errorsExports.invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64url encoded?");
                }
                break;
            }
        case StringFormat.BASE64URL:
            {
                var hasPlus = string.indexOf('+') !== -1;
                var hasSlash = string.indexOf('/') !== -1;
                if (hasPlus || hasSlash) {
                    var invalidChar = hasPlus ? '+' : '/';
                    throw errorsExports.invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
                }
                string = string.replace(/-/g, '+').replace(/_/g, '/');
                break;
            }
    }
    var bytes;
    try {
        bytes = atob(string);
    } catch (e) {
        throw errorsExports.invalidFormat(format, 'Invalid character found');
    }
    var array = new Uint8Array(bytes.length);
    for (var i = 0; i < bytes.length; i++) {
        array[i] = bytes.charCodeAt(i);
    }
    return array;
}
/**
 * @struct
 */
var DataURLParts = /** @class */function () {
    function DataURLParts(dataURL) {
        this.base64 = false;
        this.contentType = null;
        var matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) {
            throw errorsExports.invalidFormat(StringFormat.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        }
        var middle = matches[1] || null;
        if (middle != null) {
            this.base64 = endsWith(middle, ';base64');
            this.contentType = this.base64 ? middle.substring(0, middle.length - ';base64'.length) : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
    }
    return DataURLParts;
}();
function dataURLBytes_(string) {
    var parts = new DataURLParts(string);
    if (parts.base64) {
        return base64Bytes_(StringFormat.BASE64, parts.rest);
    } else {
        return percentEncodedBytes_(parts.rest);
    }
}
function dataURLContentType_(string) {
    var parts = new DataURLParts(string);
    return parts.contentType;
}
function endsWith(s, end) {
    var longEnough = s.length >= end.length;
    if (!longEnough) {
        return false;
    }
    return s.substring(s.length - end.length) === end;
}
//# sourceMappingURL=string.js.map


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeNormalUrl = makeNormalUrl;
exports.makeDownloadUrl = makeDownloadUrl;
exports.makeUploadUrl = makeUploadUrl;
exports.makeQueryString = makeQueryString;

var _constants = __webpack_require__(84);

var constants = _interopRequireWildcard(_constants);

var _object = __webpack_require__(49);

var object = _interopRequireWildcard(_object);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Functions to create and manipulate URLs for the server API.
 */
function makeNormalUrl(urlPart) {
    return constants.domainBase + constants.apiBaseUrl + urlPart;
}
function makeDownloadUrl(urlPart) {
    return constants.downloadBase + constants.apiBaseUrl + urlPart;
}
function makeUploadUrl(urlPart) {
    return constants.domainBase + constants.apiUploadBaseUrl + urlPart;
}
function makeQueryString(params) {
    var encode = encodeURIComponent;
    var queryPart = '?';
    object.forEach(params, function (key, val) {
        var nextPart = encode(key) + '=' + encode(val);
        queryPart = queryPart + nextPart + '&';
    });
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}
//# sourceMappingURL=url.js.map


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stringLength = exports.stringToByteArray = undefined;

var _assert = __webpack_require__(2);

// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
var stringToByteArray = exports.stringToByteArray = function stringToByteArray(str) {
    var out = [],
        p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            (0, _assert.assert)(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        } else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var stringLength = exports.stringLength = function stringLength(str) {
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        } else if (c < 2048) {
            p += 2;
        } else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else {
            p += 3;
        }
    }
    return p;
};
//# sourceMappingURL=utf8.js.map


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(450);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(51);
var Danger = __webpack_require__(462);
var ReactDOMComponentTree = __webpack_require__(10);
var ReactInstrumentation = __webpack_require__(22);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(126);
var setInnerHTML = __webpack_require__(92);
var setTextContent = __webpack_require__(219);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(1);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactErrorUtils = __webpack_require__(124);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(4);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactPropTypesSecret = __webpack_require__(491);
var propTypesFactory = __webpack_require__(197);

var React = __webpack_require__(54);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(4);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(1);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactCurrentOwner = __webpack_require__(29);
var ReactInstanceMap = __webpack_require__(65);
var ReactInstrumentation = __webpack_require__(22);
var ReactUpdates = __webpack_require__(24);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(4);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(14);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var emptyFunction = __webpack_require__(18);
var warning = __webpack_require__(4);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

/* global AFRAME */

var anime = __webpack_require__(286);

if (typeof AFRAME === 'undefined') {
  throw new Error('Component attempted to register before AFRAME was available.');
}

var utils = AFRAME.utils;
var getComponentProperty = utils.entity.getComponentProperty;
var setComponentProperty = utils.entity.setComponentProperty;
var styleParser = utils.styleParser.parse;

/**
 * Animation component for A-Frame.
 *
 * @member {boolean} animationIsPlaying - Used during initialization and scene resume to see
 *  if animation should be playing.
 */
AFRAME.registerComponent('animation', {
  schema: {
    delay: {default: 0},
    dir: {default: ''},
    dur: {default: 1000},
    easing: {default: 'easeInQuad'},
    elasticity: {default: 400},
    from: {default: ''},
    loop: {default: false},
    property: {default: ''},
    repeat: {default: 0},
    startEvents: {type: 'array'},
    pauseEvents: {type: 'array'},
    resumeEvents: {type: 'array'},
    restartEvents: {type: 'array'},
    to: {default: ''}
  },

  multiple: true,

  init: function () {
    this.animation = null;
    this.animationIsPlaying = false;
    this.config = null;
    this.playAnimationBound = this.playAnimation.bind(this);
    this.pauseAnimationBound = this.pauseAnimation.bind(this);
    this.resumeAnimationBound = this.resumeAnimation.bind(this);
    this.restartAnimationBound = this.restartAnimation.bind(this);
    this.repeat = 0;
  },

  update: function () {
    var attrName = this.attrName;
    var data = this.data;
    var el = this.el;
    var propType = getPropertyType(el, data.property);
    var self = this;

    if (!data.property) { return; }

    // Base config.
    this.repeat = data.repeat;
    var config = {
      autoplay: false,
      begin: function () {
        el.emit('animationbegin');
        el.emit(attrName + '-begin');
      },
      complete: function () {
        el.emit('animationcomplete');
        el.emit(attrName + '-complete');
        // Repeat.
        if (--self.repeat > 0) { self.animation.play(); }
      },
      direction: data.dir,
      duration: data.dur,
      easing: data.easing,
      elasticity: data.elasticity,
      loop: data.loop
    };

    // Customize config based on property type.
    var updateConfig = configDefault;
    if (propType === 'vec2' || propType === 'vec3' || propType === 'vec4') {
      updateConfig = configVector;
    }

    // Config.
    this.config = updateConfig(el, data, config);
    this.animation = anime(this.config);

    // Stop previous animation.
    this.pauseAnimation();

    if (!this.data.startEvents.length) { this.animationIsPlaying = true; }

    // Play animation if no holding event.
    this.removeEventListeners();
    this.addEventListeners();
  },

  /**
   * `remove` handler.
   */
  remove: function () {
    this.pauseAnimation();
    this.removeEventListeners();
  },

  /**
   * `pause` handler.
   */
  pause: function () {
    this.pauseAnimation();
    this.removeEventListeners();
  },

  /**
   * `play` handler.
   */
  play: function () {
    var data = this.data;
    var self = this;

    if (!this.animation || !this.animationIsPlaying) { return; }

    // Delay.
    if (data.delay) {
      setTimeout(play, data.delay);
    } else {
      play();
    }

    function play () {
      self.playAnimation();
      self.addEventListeners();
    }
  },

  addEventListeners: function () {
    var self = this;
    var data = this.data;
    var el = this.el;
    data.startEvents.map(function (eventName) {
      el.addEventListener(eventName, self.playAnimationBound);
    });
    data.pauseEvents.map(function (eventName) {
      el.addEventListener(eventName, self.pauseAnimationBound);
    });
    data.resumeEvents.map(function (eventName) {
      el.addEventListener(eventName, self.resumeAnimationBound);
    });
    data.restartEvents.map(function (eventName) {
      el.addEventListener(eventName, self.restartAnimationBound);
    });
  },

  removeEventListeners: function () {
    var self = this;
    var data = this.data;
    var el = this.el;
    data.startEvents.map(function (eventName) {
      el.removeEventListener(eventName, self.playAnimationBound);
    });
    data.pauseEvents.map(function (eventName) {
      el.removeEventListener(eventName, self.pauseAnimationBound);
    });
    data.resumeEvents.map(function (eventName) {
      el.removeEventListener(eventName, self.resumeAnimationBound);
    });
    data.restartEvents.map(function (eventName) {
      el.removeEventListener(eventName, self.restartAnimationBound);
    });
  },

  playAnimation: function () {
    this.animation = anime(this.config);
    this.animation.play();
  },

  pauseAnimation: function () {
    this.animation.pause();
  },

  resumeAnimation: function () {
    this.animation.play();
  },

  restartAnimation: function () {
    this.animation.restart();
  }
});

/**
 * Stuff property into generic `property` key.
 */
function configDefault (el, data, config) {
  var from = data.from || getComponentProperty(el, data.property);
  return AFRAME.utils.extend({}, config, {
    targets: [{aframeProperty: from}],
    aframeProperty: data.to,
    update: function () {
      setComponentProperty(el, data.property, this.targets[0].aframeProperty);
    }
  });
}

/**
 * Extend x/y/z/w onto the config.
 */
function configVector (el, data, config) {
  var from = getComponentProperty(el, data.property);
  if (data.from) { from = AFRAME.utils.coordinates.parse(data.from); }
  var to = AFRAME.utils.coordinates.parse(data.to);
  return AFRAME.utils.extend({}, config, {
    targets: [from],
    update: function () {
      setComponentProperty(el, data.property, this.targets[0]);
    }
  }, to);
}

function getPropertyType (el, property) {
  var split = property.split('.');
  var componentName = split[0];
  var propertyName = split[1];
  var component = el.components[componentName] || AFRAME.components[componentName];

  // Primitives.
  if (!component) { return null; }

  if (propertyName) {
    return component.schema[propertyName].type;
  }
  return component.schema.type;
}


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var CANNON = __webpack_require__(43),
    mesh2shape = __webpack_require__(559);

__webpack_require__(277);

module.exports = {
  schema: {
    shape: {default: 'auto', oneOf: ['auto', 'box', 'cylinder', 'sphere', 'hull', 'none']},
    cylinderAxis: {default: 'y', oneOf: ['x', 'y', 'z']},
    sphereRadius: {default: NaN}
  },

  /**
   * Initializes a body component, assigning it to the physics system and binding listeners for
   * parsing the elements geometry.
   */
  init: function () {
    this.system = this.el.sceneEl.systems.physics;

    if (this.el.sceneEl.hasLoaded) {
      this.initBody();
    } else {
      this.el.sceneEl.addEventListener('loaded', this.initBody.bind(this));
    }
  },

  /**
   * Parses an element's geometry and component metadata to create a CANNON.Body instance for the
   * component.
   */
  initBody: function () {
    var shape,
        el = this.el,
        data = this.data,
        pos = el.getAttribute('position');

    this.body = new CANNON.Body({
      mass: data.mass || 0,
      material: this.system.material,
      position: new CANNON.Vec3(pos.x, pos.y, pos.z),
      linearDamping: data.linearDamping,
      angularDamping: data.angularDamping
    });

    // Matrix World must be updated at root level, if scale is to be applied – updateMatrixWorld()
    // only checks an object's parent, not the rest of the ancestors. Hence, a wrapping entity with
    // scale="0.5 0.5 0.5" will be ignored.
    // Reference: https://github.com/mrdoob/three.js/blob/master/src/core/Object3D.js#L511-L541
    // Potential fix: https://github.com/mrdoob/three.js/pull/7019
    this.el.object3D.updateMatrixWorld(true);

    if(data.shape !== 'none') {
      var options = data.shape === 'auto' ? undefined : AFRAME.utils.extend({}, this.data, {
        type: mesh2shape.Type[data.shape.toUpperCase()]
      });

      shape = mesh2shape(this.el.object3D, options);

      if (!shape) {
        this.el.addEventListener('model-loaded', this.initBody.bind(this));
        return;
      }

      this.body.addShape(shape, shape.offset, shape.orientation);

      // Show wireframe
      if (this.system.debug) {
        this.createWireframe(this.body, shape);
      }
    }

    // Apply rotation
    var rot = el.getAttribute('rotation');
    this.body.quaternion.setFromEuler(
      THREE.Math.degToRad(rot.x),
      THREE.Math.degToRad(rot.y),
      THREE.Math.degToRad(rot.z),
      'XYZ'
    ).normalize();

    this.el.body = this.body;
    this.body.el = this.el;
    this.isLoaded = true;

    // If component wasn't initialized when play() was called, finish up.
    if (this.isPlaying) {
      this._play();
    }

    this.el.emit('body-loaded', {body: this.el.body});
  },

  /**
   * Registers the component with the physics system, if ready.
   */
  play: function () {
    if (this.isLoaded) this._play();
  },

  /**
   * Internal helper to register component with physics system.
   */
  _play: function () {
    this.system.addBehavior(this, this.system.Phase.SIMULATE);
    this.system.addBody(this.body);
    if (this.wireframe) this.el.sceneEl.object3D.add(this.wireframe);

    this.syncToPhysics();
  },

  /**
   * Unregisters the component with the physics system.
   */
  pause: function () {
    if (!this.isLoaded) return;

    this.system.removeBehavior(this, this.system.Phase.SIMULATE);
    this.system.removeBody(this.body);
    if (this.wireframe) this.el.sceneEl.object3D.remove(this.wireframe);
  },

  /**
   * Removes the component and all physics and scene side effects.
   */
  remove: function () {
    this.pause();
    delete this.body.el;
    delete this.body;
    delete this.el.body;
    delete this.wireframe;
  },

  /**
   * Creates a wireframe for the body, for debugging.
   * TODO(donmccurdy) – Refactor this into a standalone utility or component.
   * @param  {CANNON.Body} body
   * @param  {CANNON.Shape} shape
   */
  createWireframe: function (body, shape) {
    var offset = shape.offset,
        orientation = shape.orientation,
        mesh = CANNON.shape2mesh(body).children[0];

    this.wireframe = new THREE.LineSegments(
      new THREE.EdgesGeometry(mesh.geometry),
      new THREE.LineBasicMaterial({color: 0xff0000})
    );

    if (offset) {
      this.wireframe.offset = offset.clone();
    }

    if (orientation) {
      orientation.inverse(orientation);
      this.wireframe.orientation = new THREE.Quaternion(
        orientation.x,
        orientation.y,
        orientation.z,
        orientation.w
      );
    }

    this.syncWireframe();
  },

  /**
   * Updates the debugging wireframe's position and rotation.
   */
  syncWireframe: function () {
    var offset,
        wireframe = this.wireframe;

    if (!this.wireframe) return;

    // Apply rotation. If the shape required custom orientation, also apply
    // that on the wireframe.
    wireframe.quaternion.copy(this.body.quaternion);
    if (wireframe.orientation) {
      wireframe.quaternion.multiply(wireframe.orientation);
    }

    // Apply position. If the shape required custom offset, also apply that on
    // the wireframe.
    wireframe.position.copy(this.body.position);
    if (wireframe.offset) {
      offset = wireframe.offset.clone().applyQuaternion(wireframe.quaternion);
      wireframe.position.add(offset);
    }

    wireframe.updateMatrix();
  },

  /**
   * Updates the CANNON.Body instance's position, velocity, and rotation, based on the scene.
   */
  syncToPhysics: (function () {
    var q =  new THREE.Quaternion(),
        v = new THREE.Vector3();
    return function () {
      var el = this.el,
          parentEl = el.parentEl,
          body = this.body;

      if (!body) return;

      if (el.components.velocity) body.velocity.copy(el.getAttribute('velocity'));

      if (parentEl.isScene) {
        body.quaternion.copy(el.object3D.quaternion);
        body.position.copy(el.object3D.position);
      } else {
        el.object3D.getWorldQuaternion(q);
        body.quaternion.copy(q);
        el.object3D.getWorldPosition(v);
        body.position.copy(v);
      }

      if (this.wireframe) this.syncWireframe();
    };
  }()),

  /**
   * Updates the scene object's position and rotation, based on the physics simulation.
   */
  syncFromPhysics: (function () {
    var v = new THREE.Vector3(),
        q1 = new THREE.Quaternion(),
        q2 = new THREE.Quaternion();
    return function () {
      var el = this.el,
          parentEl = el.parentEl,
          body = this.body;

      if (!body) return;

      if (parentEl.isScene) {
        el.setAttribute('quaternion', body.quaternion);
        el.setAttribute('position', body.position);
      } else {
        // TODO - Nested rotation doesn't seem to be working as expected.
        q1.copy(body.quaternion);
        parentEl.object3D.getWorldQuaternion(q2);
        q1.multiply(q2.inverse());
        el.setAttribute('quaternion', {x: q1.x, y: q1.y, z: q1.z, w: q1.w});

        v.copy(body.position);
        parentEl.object3D.worldToLocal(v);
        el.setAttribute('position', {x: v.x, y: v.y, z: v.z});
      }

      if (this.wireframe) this.syncWireframe();
    };
  }())
};


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return enableHUD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return disableHUD; });
/* unused harmony export speechErrorHUD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setLinkHUD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return switchSpaceHUD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return generateLinkHUD; });

var resetUnlock = function resetUnlock() {
    document.exitPointerLock();

    var cam = document.getElementById("camera");
    var rot = cam.getAttribute("rotation");

    cam.setAttribute("rotation", {
        x: 0,
        y: 0,
        z: 0
    });
};

var enableHUD = function enableHUD() {

    return {
        type: "HUD_ENABLE"
    };
};

var disableHUD = function disableHUD() {

    return {
        type: "HUD_DISABLE"
    };
};

var speechErrorHUD = function speechErrorHUD() {

    return {
        type: "HUD_SPEECH_ERROR"
    };
};

var setLinkHUD = function setLinkHUD(link) {
    // document.exitPointerLock();
    // resetUnlock()

    return {
        type: "HUD_SET_LINK",
        link: link
    };
};

var switchSpaceHUD = function switchSpaceHUD() {
    resetUnlock();

    return {
        type: "HUD_SPACE_SELECT"
    };
};

var generateLinkHUD = function generateLinkHUD() {
    resetUnlock();

    return {
        type: "HUD_LOADING"
    };
};

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

    // Settings for display grid
    grid: {
        row: 8, // Items per row
        col: 4, // Items per column

        padding: {
            x: 0.2, // X Padding of an image 
            y: 0.2 // Y Padding of an image
        }
    },

    // Settings for single icon
    icon: {
        width: 0.4, // Width of an icon
        height: 0.4, // Height of an icon

        maxScale: "1.5 1.5 1.5" // Scale of hovered element
    },

    // Settings for navigation component
    navigation: {

        buttons: {
            size: 0.3, // Size of navigation button

            // Nav buttons padding
            padding: {
                x: 0.1,
                y: 0
            }
        }
    }

});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__1f004_png__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__1f004_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__1f004_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__1f0cf_png__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__1f0cf_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__1f0cf_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__1f170_png__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__1f170_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__1f170_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__1f171_png__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__1f171_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__1f171_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__1f17e_png__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__1f17e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__1f17e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__1f17f_png__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__1f17f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__1f17f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__1f18e_png__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__1f18e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__1f18e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__1f191_png__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__1f191_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__1f191_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__1f192_png__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__1f192_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__1f192_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__1f193_png__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__1f193_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__1f193_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__1f194_png__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__1f194_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__1f194_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__1f195_png__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__1f195_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__1f195_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__1f196_png__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__1f196_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__1f196_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__1f197_png__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__1f197_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__1f197_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__1f198_png__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__1f198_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__1f198_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__1f199_png__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__1f199_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__1f199_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__1f19a_png__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__1f19a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__1f19a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__1f1e6_png__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__1f1e6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__1f1e6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__1f1e7_png__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__1f1e7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__1f1e7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__1f1e8_1f1f3_png__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__1f1e8_1f1f3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__1f1e8_1f1f3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__1f1e8_png__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__1f1e8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__1f1e8_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__1f1e9_1f1ea_png__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__1f1e9_1f1ea_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__1f1e9_1f1ea_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__1f1e9_png__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__1f1e9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__1f1e9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__1f1ea_1f1f8_png__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__1f1ea_1f1f8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__1f1ea_1f1f8_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__1f1ea_png__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__1f1ea_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__1f1ea_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__1f1eb_1f1f7_png__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__1f1eb_1f1f7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__1f1eb_1f1f7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__1f1eb_png__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__1f1eb_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__1f1eb_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__1f1ec_1f1e7_png__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__1f1ec_1f1e7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__1f1ec_1f1e7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__1f1ec_png__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__1f1ec_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__1f1ec_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__1f1ed_png__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__1f1ed_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__1f1ed_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__1f1ee_1f1f9_png__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__1f1ee_1f1f9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__1f1ee_1f1f9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__1f1ee_png__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__1f1ee_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__1f1ee_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__1f1ef_1f1f5_png__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__1f1ef_1f1f5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__1f1ef_1f1f5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__1f1ef_png__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__1f1ef_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__1f1ef_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__1f1f0_1f1f7_png__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__1f1f0_1f1f7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__1f1f0_1f1f7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__1f1f0_png__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__1f1f0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__1f1f0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__1f1f1_png__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__1f1f1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__1f1f1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__1f1f2_png__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__1f1f2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__1f1f2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__1f1f3_png__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__1f1f3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__1f1f3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__1f1f4_png__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__1f1f4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__1f1f4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__1f1f5_png__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__1f1f5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__1f1f5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__1f1f6_png__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__1f1f6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__1f1f6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__1f1f7_1f1fa_png__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__1f1f7_1f1fa_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__1f1f7_1f1fa_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__1f1f7_png__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__1f1f7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__1f1f7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__1f1f8_png__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__1f1f8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__1f1f8_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__1f1f9_png__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__1f1f9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__1f1f9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__1f1fa_1f1f8_png__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__1f1fa_1f1f8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__1f1fa_1f1f8_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__1f1fa_png__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__1f1fa_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__1f1fa_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__1f1fb_png__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__1f1fb_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__1f1fb_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__1f1fc_png__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__1f1fc_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__1f1fc_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__1f1fd_png__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__1f1fd_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__1f1fd_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__1f1fe_png__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__1f1fe_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__1f1fe_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__1f1ff_png__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__1f1ff_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__1f1ff_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__1f201_png__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__1f201_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__1f201_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__1f202_png__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__1f202_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__1f202_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__1f21a_png__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__1f21a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__1f21a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__1f22f_png__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__1f22f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__1f22f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__1f232_png__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__1f232_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__1f232_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__1f233_png__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__1f233_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__1f233_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__1f234_png__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__1f234_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__1f234_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__1f235_png__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__1f235_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__1f235_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__1f236_png__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__1f236_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__1f236_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__1f237_png__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__1f237_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__1f237_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__1f238_png__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__1f238_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__1f238_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__1f239_png__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__1f239_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__1f239_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__1f23a_png__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__1f23a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__1f23a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__1f250_png__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__1f250_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__1f250_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__1f251_png__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__1f251_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__1f251_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__1f300_png__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__1f300_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__1f300_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__1f301_png__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__1f301_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__1f301_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__1f302_png__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__1f302_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__1f302_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__1f303_png__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__1f303_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__1f303_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__1f304_png__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__1f304_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__1f304_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__1f305_png__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__1f305_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__1f305_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__1f306_png__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__1f306_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__1f306_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__1f307_png__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__1f307_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__1f307_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__1f308_png__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__1f308_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__1f308_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__1f309_png__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__1f309_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__1f309_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__1f30a_png__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__1f30a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__1f30a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__1f30b_png__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__1f30b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__1f30b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__1f30c_png__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__1f30c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__1f30c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__1f30d_png__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__1f30d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__1f30d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__1f30e_png__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__1f30e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__1f30e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__1f30f_png__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__1f30f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__1f30f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__1f310_png__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__1f310_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__1f310_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__1f311_png__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__1f311_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__1f311_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__1f312_png__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__1f312_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__1f312_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__1f313_png__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__1f313_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__1f313_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__1f314_png__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__1f314_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__1f314_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__1f315_png__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__1f315_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__1f315_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__1f316_png__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__1f316_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__1f316_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__1f317_png__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__1f317_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__1f317_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__1f318_png__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__1f318_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__1f318_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__1f319_png__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__1f319_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93__1f319_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__1f31a_png__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__1f31a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__1f31a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__1f31b_png__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__1f31b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95__1f31b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__1f31c_png__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__1f31c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96__1f31c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__1f31d_png__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__1f31d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97__1f31d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__1f31e_png__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__1f31e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98__1f31e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__1f31f_png__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__1f31f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99__1f31f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__1f320_png__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__1f320_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100__1f320_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__1f330_png__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__1f330_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101__1f330_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__1f331_png__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__1f331_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102__1f331_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__1f332_png__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__1f332_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103__1f332_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__1f333_png__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__1f333_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_104__1f333_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__1f334_png__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__1f334_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105__1f334_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__1f335_png__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__1f335_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106__1f335_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__1f337_png__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__1f337_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107__1f337_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__1f338_png__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__1f338_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_108__1f338_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__1f339_png__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__1f339_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_109__1f339_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__1f33a_png__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__1f33a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_110__1f33a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__1f33b_png__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__1f33b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_111__1f33b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__1f33c_png__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__1f33c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_112__1f33c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__1f33d_png__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__1f33d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_113__1f33d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__1f33e_png__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__1f33e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_114__1f33e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__1f33f_png__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__1f33f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_115__1f33f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__1f340_png__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__1f340_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_116__1f340_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__1f341_png__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__1f341_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_117__1f341_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__1f342_png__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__1f342_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_118__1f342_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__1f343_png__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__1f343_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_119__1f343_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__1f344_png__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__1f344_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_120__1f344_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__1f345_png__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__1f345_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_121__1f345_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__1f346_png__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__1f346_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_122__1f346_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__1f347_png__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__1f347_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_123__1f347_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__1f348_png__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__1f348_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_124__1f348_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__1f349_png__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__1f349_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_125__1f349_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__1f34a_png__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__1f34a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_126__1f34a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__1f34b_png__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__1f34b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_127__1f34b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__1f34c_png__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__1f34c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_128__1f34c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__1f34d_png__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__1f34d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_129__1f34d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__1f34e_png__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__1f34e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_130__1f34e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__1f34f_png__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__1f34f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_131__1f34f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__1f350_png__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__1f350_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_132__1f350_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__1f351_png__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__1f351_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_133__1f351_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__1f352_png__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__1f352_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_134__1f352_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__1f353_png__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__1f353_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_135__1f353_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__1f354_png__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__1f354_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_136__1f354_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__1f355_png__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__1f355_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_137__1f355_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__1f356_png__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__1f356_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_138__1f356_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__1f357_png__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__1f357_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_139__1f357_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__1f358_png__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__1f358_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_140__1f358_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__1f359_png__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__1f359_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_141__1f359_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__1f35a_png__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__1f35a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_142__1f35a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__1f35b_png__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__1f35b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_143__1f35b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__1f35c_png__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__1f35c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_144__1f35c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__1f35d_png__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__1f35d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_145__1f35d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__1f35e_png__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__1f35e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_146__1f35e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__1f35f_png__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__1f35f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_147__1f35f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__1f360_png__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__1f360_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_148__1f360_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__1f361_png__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__1f361_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_149__1f361_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__1f362_png__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__1f362_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_150__1f362_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__1f363_png__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__1f363_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_151__1f363_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__1f364_png__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__1f364_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_152__1f364_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__1f365_png__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__1f365_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_153__1f365_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__1f366_png__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__1f366_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_154__1f366_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__1f367_png__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__1f367_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_155__1f367_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__1f368_png__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__1f368_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_156__1f368_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__1f369_png__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__1f369_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_157__1f369_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__1f36a_png__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__1f36a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_158__1f36a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__1f36b_png__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__1f36b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_159__1f36b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__1f36c_png__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__1f36c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_160__1f36c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__1f36d_png__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__1f36d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_161__1f36d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__1f36e_png__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__1f36e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_162__1f36e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__1f36f_png__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__1f36f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_163__1f36f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__1f370_png__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__1f370_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_164__1f370_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__1f371_png__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__1f371_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_165__1f371_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__1f372_png__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__1f372_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_166__1f372_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__1f373_png__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__1f373_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_167__1f373_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__1f374_png__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__1f374_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_168__1f374_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__1f375_png__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__1f375_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_169__1f375_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__1f376_png__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__1f376_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_170__1f376_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__1f377_png__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__1f377_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_171__1f377_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__1f378_png__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__1f378_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_172__1f378_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__1f379_png__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__1f379_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_173__1f379_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__1f37a_png__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__1f37a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_174__1f37a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__1f37b_png__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__1f37b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_175__1f37b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__1f37c_png__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__1f37c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_176__1f37c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__1f380_png__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__1f380_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_177__1f380_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__1f381_png__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__1f381_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_178__1f381_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__1f382_png__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__1f382_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_179__1f382_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__1f383_png__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__1f383_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_180__1f383_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__1f384_png__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__1f384_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_181__1f384_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__1f385_png__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__1f385_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_182__1f385_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__1f386_png__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__1f386_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_183__1f386_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__1f387_png__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__1f387_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_184__1f387_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__1f388_png__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__1f388_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_185__1f388_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__1f389_png__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__1f389_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_186__1f389_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__1f38a_png__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__1f38a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_187__1f38a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__1f38b_png__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__1f38b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_188__1f38b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__1f38c_png__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__1f38c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_189__1f38c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__1f38d_png__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__1f38d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_190__1f38d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__1f38e_png__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__1f38e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_191__1f38e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__1f38f_png__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__1f38f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_192__1f38f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__1f390_png__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__1f390_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_193__1f390_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__1f391_png__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__1f391_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_194__1f391_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__1f392_png__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__1f392_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_195__1f392_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__1f393_png__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__1f393_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_196__1f393_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__1f3a0_png__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__1f3a0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_197__1f3a0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__1f3a1_png__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__1f3a1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_198__1f3a1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__1f3a2_png__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__1f3a2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_199__1f3a2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__1f3a3_png__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__1f3a3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_200__1f3a3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__1f3a4_png__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__1f3a4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_201__1f3a4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__1f3a5_png__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__1f3a5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_202__1f3a5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__1f3a6_png__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__1f3a6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_203__1f3a6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__1f3a7_png__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__1f3a7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_204__1f3a7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__1f3a8_png__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__1f3a8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_205__1f3a8_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__1f3a9_png__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__1f3a9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_206__1f3a9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__1f3aa_png__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__1f3aa_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_207__1f3aa_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__1f3ab_png__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__1f3ab_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_208__1f3ab_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__1f3ac_png__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__1f3ac_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_209__1f3ac_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__1f3ad_png__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__1f3ad_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_210__1f3ad_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__1f3ae_png__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__1f3ae_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_211__1f3ae_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__1f3af_png__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__1f3af_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_212__1f3af_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__1f3b0_png__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__1f3b0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_213__1f3b0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__1f3b1_png__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__1f3b1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_214__1f3b1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__1f3b2_png__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__1f3b2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_215__1f3b2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__1f3b3_png__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__1f3b3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_216__1f3b3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__1f3b4_png__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__1f3b4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_217__1f3b4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__1f3b5_png__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__1f3b5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_218__1f3b5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__1f3b6_png__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__1f3b6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_219__1f3b6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__1f3b7_png__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__1f3b7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_220__1f3b7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221__1f3b8_png__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221__1f3b8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_221__1f3b8_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222__1f3b9_png__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222__1f3b9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_222__1f3b9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223__1f3ba_png__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223__1f3ba_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_223__1f3ba_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224__1f3bb_png__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224__1f3bb_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_224__1f3bb_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225__1f3bc_png__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225__1f3bc_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_225__1f3bc_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226__1f3bd_png__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226__1f3bd_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_226__1f3bd_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227__1f3be_png__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227__1f3be_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_227__1f3be_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228__1f3bf_png__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228__1f3bf_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_228__1f3bf_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229__1f3c0_png__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229__1f3c0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_229__1f3c0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230__1f3c1_png__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230__1f3c1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_230__1f3c1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231__1f3c2_png__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231__1f3c2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_231__1f3c2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232__1f3c3_png__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232__1f3c3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_232__1f3c3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233__1f3c4_png__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233__1f3c4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_233__1f3c4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234__1f3c6_png__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234__1f3c6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_234__1f3c6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235__1f3c7_png__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235__1f3c7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_235__1f3c7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236__1f3c8_png__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236__1f3c8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_236__1f3c8_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237__1f3c9_png__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237__1f3c9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_237__1f3c9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238__1f3ca_png__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238__1f3ca_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_238__1f3ca_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_239__1f3e0_png__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_239__1f3e0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_239__1f3e0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_240__1f3e1_png__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_240__1f3e1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_240__1f3e1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_241__1f3e2_png__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_241__1f3e2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_241__1f3e2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_242__1f3e3_png__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_242__1f3e3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_242__1f3e3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_243__1f3e4_png__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_243__1f3e4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_243__1f3e4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_244__1f3e5_png__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_244__1f3e5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_244__1f3e5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_245__1f3e6_png__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_245__1f3e6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_245__1f3e6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_246__1f3e7_png__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_246__1f3e7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_246__1f3e7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_247__1f3e8_png__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_247__1f3e8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_247__1f3e8_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_248__1f3e9_png__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_248__1f3e9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_248__1f3e9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_249__1f3ea_png__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_249__1f3ea_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_249__1f3ea_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_250__1f3eb_png__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_250__1f3eb_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_250__1f3eb_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_251__1f3ec_png__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_251__1f3ec_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_251__1f3ec_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_252__1f3ed_png__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_252__1f3ed_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_252__1f3ed_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_253__1f3ee_png__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_253__1f3ee_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_253__1f3ee_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_254__1f3ef_png__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_254__1f3ef_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_254__1f3ef_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_255__1f3f0_png__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_255__1f3f0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_255__1f3f0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_256__1f400_png__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_256__1f400_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_256__1f400_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_257__1f401_png__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_257__1f401_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_257__1f401_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_258__1f402_png__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_258__1f402_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_258__1f402_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_259__1f403_png__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_259__1f403_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_259__1f403_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_260__1f404_png__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_260__1f404_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_260__1f404_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_261__1f405_png__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_261__1f405_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_261__1f405_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_262__1f406_png__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_262__1f406_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_262__1f406_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_263__1f407_png__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_263__1f407_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_263__1f407_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_264__1f408_png__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_264__1f408_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_264__1f408_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_265__1f409_png__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_265__1f409_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_265__1f409_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_266__1f40a_png__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_266__1f40a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_266__1f40a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_267__1f40b_png__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_267__1f40b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_267__1f40b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_268__1f40c_png__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_268__1f40c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_268__1f40c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_269__1f40d_png__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_269__1f40d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_269__1f40d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_270__1f40e_png__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_270__1f40e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_270__1f40e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_271__1f40f_png__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_271__1f40f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_271__1f40f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_272__1f410_png__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_272__1f410_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_272__1f410_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_273__1f411_png__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_273__1f411_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_273__1f411_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_274__1f412_png__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_274__1f412_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_274__1f412_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_275__1f413_png__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_275__1f413_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_275__1f413_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_276__1f414_png__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_276__1f414_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_276__1f414_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_277__1f415_png__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_277__1f415_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_277__1f415_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_278__1f416_png__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_278__1f416_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_278__1f416_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_279__1f417_png__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_279__1f417_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_279__1f417_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_280__1f418_png__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_280__1f418_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_280__1f418_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_281__1f419_png__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_281__1f419_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_281__1f419_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_282__1f41a_png__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_282__1f41a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_282__1f41a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_283__1f41b_png__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_283__1f41b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_283__1f41b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_284__1f41c_png__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_284__1f41c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_284__1f41c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_285__1f41d_png__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_285__1f41d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_285__1f41d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_286__1f41e_png__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_286__1f41e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_286__1f41e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_287__1f41f_png__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_287__1f41f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_287__1f41f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_288__1f420_png__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_288__1f420_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_288__1f420_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_289__1f421_png__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_289__1f421_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_289__1f421_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_290__1f422_png__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_290__1f422_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_290__1f422_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_291__1f423_png__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_291__1f423_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_291__1f423_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_292__1f424_png__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_292__1f424_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_292__1f424_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_293__1f425_png__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_293__1f425_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_293__1f425_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_294__1f426_png__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_294__1f426_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_294__1f426_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_295__1f427_png__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_295__1f427_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_295__1f427_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_296__1f428_png__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_296__1f428_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_296__1f428_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_297__1f429_png__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_297__1f429_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_297__1f429_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_298__1f42a_png__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_298__1f42a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_298__1f42a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_299__1f42b_png__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_299__1f42b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_299__1f42b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_300__1f42c_png__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_300__1f42c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_300__1f42c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_301__1f42d_png__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_301__1f42d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_301__1f42d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_302__1f42e_png__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_302__1f42e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_302__1f42e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_303__1f42f_png__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_303__1f42f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_303__1f42f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_304__1f430_png__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_304__1f430_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_304__1f430_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_305__1f431_png__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_305__1f431_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_305__1f431_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_306__1f432_png__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_306__1f432_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_306__1f432_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_307__1f433_png__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_307__1f433_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_307__1f433_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_308__1f434_png__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_308__1f434_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_308__1f434_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_309__1f435_png__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_309__1f435_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_309__1f435_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_310__1f436_png__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_310__1f436_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_310__1f436_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_311__1f437_png__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_311__1f437_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_311__1f437_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_312__1f438_png__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_312__1f438_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_312__1f438_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_313__1f439_png__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_313__1f439_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_313__1f439_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_314__1f43a_png__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_314__1f43a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_314__1f43a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_315__1f43b_png__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_315__1f43b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_315__1f43b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_316__1f43c_png__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_316__1f43c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_316__1f43c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_317__1f43d_png__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_317__1f43d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_317__1f43d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_318__1f43e_png__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_318__1f43e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_318__1f43e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_319__1f440_png__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_319__1f440_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_319__1f440_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_320__1f442_png__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_320__1f442_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_320__1f442_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_321__1f443_png__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_321__1f443_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_321__1f443_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_322__1f444_png__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_322__1f444_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_322__1f444_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_323__1f445_png__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_323__1f445_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_323__1f445_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_324__1f446_png__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_324__1f446_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_324__1f446_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_325__1f447_png__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_325__1f447_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_325__1f447_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_326__1f448_png__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_326__1f448_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_326__1f448_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_327__1f449_png__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_327__1f449_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_327__1f449_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_328__1f44a_png__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_328__1f44a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_328__1f44a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_329__1f44b_png__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_329__1f44b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_329__1f44b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_330__1f44c_png__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_330__1f44c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_330__1f44c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_331__1f44d_png__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_331__1f44d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_331__1f44d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_332__1f44e_png__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_332__1f44e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_332__1f44e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_333__1f44f_png__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_333__1f44f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_333__1f44f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_334__1f450_png__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_334__1f450_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_334__1f450_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_335__1f451_png__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_335__1f451_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_335__1f451_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_336__1f452_png__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_336__1f452_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_336__1f452_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_337__1f453_png__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_337__1f453_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_337__1f453_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_338__1f454_png__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_338__1f454_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_338__1f454_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_339__1f455_png__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_339__1f455_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_339__1f455_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_340__1f456_png__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_340__1f456_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_340__1f456_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_341__1f457_png__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_341__1f457_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_341__1f457_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_342__1f458_png__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_342__1f458_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_342__1f458_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_343__1f459_png__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_343__1f459_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_343__1f459_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_344__1f45a_png__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_344__1f45a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_344__1f45a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_345__1f45b_png__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_345__1f45b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_345__1f45b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_346__1f45c_png__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_346__1f45c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_346__1f45c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_347__1f45d_png__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_347__1f45d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_347__1f45d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_348__1f45e_png__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_348__1f45e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_348__1f45e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_349__1f45f_png__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_349__1f45f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_349__1f45f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_350__1f460_png__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_350__1f460_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_350__1f460_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_351__1f461_png__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_351__1f461_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_351__1f461_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_352__1f462_png__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_352__1f462_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_352__1f462_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_353__1f463_png__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_353__1f463_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_353__1f463_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_354__1f464_png__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_354__1f464_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_354__1f464_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_355__1f465_png__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_355__1f465_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_355__1f465_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_356__1f466_png__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_356__1f466_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_356__1f466_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_357__1f467_png__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_357__1f467_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_357__1f467_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_358__1f468_png__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_358__1f468_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_358__1f468_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_359__1f469_png__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_359__1f469_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_359__1f469_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_360__1f46a_png__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_360__1f46a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_360__1f46a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_361__1f46b_png__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_361__1f46b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_361__1f46b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_362__1f46c_png__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_362__1f46c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_362__1f46c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_363__1f46d_png__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_363__1f46d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_363__1f46d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_364__1f46e_png__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_364__1f46e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_364__1f46e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_365__1f46f_png__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_365__1f46f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_365__1f46f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_366__1f470_png__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_366__1f470_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_366__1f470_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_367__1f471_png__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_367__1f471_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_367__1f471_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_368__1f472_png__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_368__1f472_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_368__1f472_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_369__1f473_png__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_369__1f473_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_369__1f473_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_370__1f474_png__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_370__1f474_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_370__1f474_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_371__1f475_png__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_371__1f475_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_371__1f475_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_372__1f476_png__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_372__1f476_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_372__1f476_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_373__1f477_png__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_373__1f477_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_373__1f477_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_374__1f478_png__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_374__1f478_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_374__1f478_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_375__1f479_png__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_375__1f479_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_375__1f479_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_376__1f47a_png__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_376__1f47a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_376__1f47a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_377__1f47b_png__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_377__1f47b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_377__1f47b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_378__1f47c_png__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_378__1f47c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_378__1f47c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_379__1f47d_png__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_379__1f47d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_379__1f47d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_380__1f47e_png__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_380__1f47e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_380__1f47e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_381__1f47f_png__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_381__1f47f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_381__1f47f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_382__1f480_png__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_382__1f480_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_382__1f480_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_383__1f481_png__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_383__1f481_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_383__1f481_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_384__1f482_png__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_384__1f482_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_384__1f482_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_385__1f483_png__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_385__1f483_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_385__1f483_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_386__1f484_png__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_386__1f484_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_386__1f484_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_387__1f485_png__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_387__1f485_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_387__1f485_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_388__1f486_png__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_388__1f486_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_388__1f486_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_389__1f487_png__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_389__1f487_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_389__1f487_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_390__1f488_png__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_390__1f488_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_390__1f488_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_391__1f489_png__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_391__1f489_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_391__1f489_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_392__1f48a_png__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_392__1f48a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_392__1f48a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_393__1f48b_png__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_393__1f48b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_393__1f48b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_394__1f48c_png__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_394__1f48c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_394__1f48c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_395__1f48d_png__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_395__1f48d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_395__1f48d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_396__1f48e_png__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_396__1f48e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_396__1f48e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_397__1f48f_png__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_397__1f48f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_397__1f48f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_398__1f490_png__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_398__1f490_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_398__1f490_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_399__1f491_png__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_399__1f491_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_399__1f491_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_400__1f492_png__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_400__1f492_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_400__1f492_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_401__1f493_png__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_401__1f493_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_401__1f493_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_402__1f494_png__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_402__1f494_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_402__1f494_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_403__1f495_png__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_403__1f495_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_403__1f495_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_404__1f496_png__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_404__1f496_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_404__1f496_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_405__1f497_png__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_405__1f497_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_405__1f497_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_406__1f498_png__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_406__1f498_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_406__1f498_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_407__1f499_png__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_407__1f499_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_407__1f499_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_408__1f49a_png__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_408__1f49a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_408__1f49a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_409__1f49b_png__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_409__1f49b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_409__1f49b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_410__1f49c_png__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_410__1f49c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_410__1f49c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_411__1f49d_png__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_411__1f49d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_411__1f49d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_412__1f49e_png__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_412__1f49e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_412__1f49e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_413__1f49f_png__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_413__1f49f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_413__1f49f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_414__1f4a0_png__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_414__1f4a0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_414__1f4a0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_415__1f4a1_png__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_415__1f4a1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_415__1f4a1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_416__1f4a2_png__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_416__1f4a2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_416__1f4a2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_417__1f4a3_png__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_417__1f4a3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_417__1f4a3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_418__1f4a4_png__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_418__1f4a4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_418__1f4a4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_419__1f4a5_png__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_419__1f4a5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_419__1f4a5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_420__1f4a6_png__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_420__1f4a6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_420__1f4a6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_421__1f4a7_png__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_421__1f4a7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_421__1f4a7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_422__1f4a8_png__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_422__1f4a8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_422__1f4a8_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_423__1f4a9_png__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_423__1f4a9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_423__1f4a9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_424__1f4aa_png__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_424__1f4aa_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_424__1f4aa_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_425__1f4ab_png__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_425__1f4ab_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_425__1f4ab_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_426__1f4ac_png__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_426__1f4ac_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_426__1f4ac_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_427__1f4ad_png__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_427__1f4ad_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_427__1f4ad_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_428__1f4ae_png__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_428__1f4ae_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_428__1f4ae_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_429__1f4af_png__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_429__1f4af_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_429__1f4af_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_430__1f4b0_png__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_430__1f4b0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_430__1f4b0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_431__1f4b1_png__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_431__1f4b1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_431__1f4b1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_432__1f4b2_png__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_432__1f4b2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_432__1f4b2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_433__1f4b3_png__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_433__1f4b3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_433__1f4b3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_434__1f4b4_png__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_434__1f4b4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_434__1f4b4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_435__1f4b5_png__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_435__1f4b5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_435__1f4b5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_436__1f4b6_png__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_436__1f4b6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_436__1f4b6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_437__1f4b7_png__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_437__1f4b7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_437__1f4b7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_438__1f4b8_png__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_438__1f4b8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_438__1f4b8_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_439__1f4b9_png__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_439__1f4b9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_439__1f4b9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_440__1f4ba_png__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_440__1f4ba_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_440__1f4ba_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_441__1f4bb_png__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_441__1f4bb_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_441__1f4bb_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_442__1f4bc_png__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_442__1f4bc_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_442__1f4bc_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_443__1f4bd_png__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_443__1f4bd_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_443__1f4bd_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_444__1f4be_png__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_444__1f4be_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_444__1f4be_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_445__1f4bf_png__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_445__1f4bf_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_445__1f4bf_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_446__1f4c0_png__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_446__1f4c0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_446__1f4c0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_447__1f4c1_png__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_447__1f4c1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_447__1f4c1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_448__1f4c2_png__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_448__1f4c2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_448__1f4c2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_449__1f4c3_png__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_449__1f4c3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_449__1f4c3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_450__1f4c4_png__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_450__1f4c4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_450__1f4c4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_451__1f4c5_png__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_451__1f4c5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_451__1f4c5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_452__1f4c6_png__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_452__1f4c6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_452__1f4c6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_453__1f4c7_png__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_453__1f4c7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_453__1f4c7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_454__1f4c8_png__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_454__1f4c8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_454__1f4c8_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_455__1f4c9_png__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_455__1f4c9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_455__1f4c9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_456__1f4ca_png__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_456__1f4ca_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_456__1f4ca_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_457__1f4cb_png__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_457__1f4cb_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_457__1f4cb_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_458__1f4cc_png__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_458__1f4cc_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_458__1f4cc_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_459__1f4cd_png__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_459__1f4cd_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_459__1f4cd_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_460__1f4ce_png__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_460__1f4ce_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_460__1f4ce_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_461__1f4cf_png__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_461__1f4cf_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_461__1f4cf_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_462__1f4d0_png__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_462__1f4d0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_462__1f4d0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_463__1f4d1_png__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_463__1f4d1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_463__1f4d1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_464__1f4d2_png__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_464__1f4d2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_464__1f4d2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_465__1f4d3_png__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_465__1f4d3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_465__1f4d3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_466__1f4d4_png__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_466__1f4d4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_466__1f4d4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_467__1f4d5_png__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_467__1f4d5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_467__1f4d5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_468__1f4d6_png__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_468__1f4d6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_468__1f4d6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_469__1f4d7_png__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_469__1f4d7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_469__1f4d7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_470__1f4d8_png__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_470__1f4d8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_470__1f4d8_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_471__1f4d9_png__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_471__1f4d9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_471__1f4d9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_472__1f4da_png__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_472__1f4da_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_472__1f4da_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_473__1f4db_png__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_473__1f4db_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_473__1f4db_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_474__1f4dc_png__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_474__1f4dc_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_474__1f4dc_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_475__1f4dd_png__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_475__1f4dd_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_475__1f4dd_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_476__1f4de_png__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_476__1f4de_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_476__1f4de_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_477__1f4df_png__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_477__1f4df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_477__1f4df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_478__1f4e0_png__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_478__1f4e0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_478__1f4e0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_479__1f4e1_png__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_479__1f4e1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_479__1f4e1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_480__1f4e2_png__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_480__1f4e2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_480__1f4e2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_481__1f4e3_png__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_481__1f4e3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_481__1f4e3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_482__1f4e4_png__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_482__1f4e4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_482__1f4e4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_483__1f4e5_png__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_483__1f4e5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_483__1f4e5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_484__1f4e6_png__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_484__1f4e6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_484__1f4e6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_485__1f4e7_png__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_485__1f4e7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_485__1f4e7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_486__1f4e8_png__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_486__1f4e8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_486__1f4e8_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_487__1f4e9_png__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_487__1f4e9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_487__1f4e9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_488__1f4ea_png__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_488__1f4ea_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_488__1f4ea_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_489__1f4eb_png__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_489__1f4eb_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_489__1f4eb_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_490__1f4ec_png__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_490__1f4ec_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_490__1f4ec_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_491__1f4ed_png__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_491__1f4ed_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_491__1f4ed_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_492__1f4ee_png__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_492__1f4ee_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_492__1f4ee_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_493__1f4ef_png__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_493__1f4ef_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_493__1f4ef_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_494__1f4f0_png__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_494__1f4f0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_494__1f4f0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_495__1f4f1_png__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_495__1f4f1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_495__1f4f1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_496__1f4f2_png__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_496__1f4f2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_496__1f4f2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_497__1f4f3_png__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_497__1f4f3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_497__1f4f3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_498__1f4f4_png__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_498__1f4f4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_498__1f4f4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_499__1f4f5_png__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_499__1f4f5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_499__1f4f5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_500__1f4f6_png__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_500__1f4f6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_500__1f4f6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_501__1f4f7_png__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_501__1f4f7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_501__1f4f7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_502__1f4f9_png__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_502__1f4f9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_502__1f4f9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_503__1f4fa_png__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_503__1f4fa_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_503__1f4fa_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_504__1f4fb_png__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_504__1f4fb_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_504__1f4fb_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_505__1f4fc_png__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_505__1f4fc_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_505__1f4fc_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_506__1f500_png__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_506__1f500_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_506__1f500_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_507__1f501_png__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_507__1f501_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_507__1f501_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_508__1f502_png__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_508__1f502_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_508__1f502_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_509__1f503_png__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_509__1f503_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_509__1f503_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_510__1f504_png__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_510__1f504_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_510__1f504_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_511__1f505_png__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_511__1f505_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_511__1f505_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_512__1f506_png__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_512__1f506_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_512__1f506_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_513__1f507_png__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_513__1f507_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_513__1f507_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_514__1f508_png__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_514__1f508_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_514__1f508_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_515__1f509_png__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_515__1f509_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_515__1f509_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_516__1f50a_png__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_516__1f50a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_516__1f50a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_517__1f50b_png__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_517__1f50b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_517__1f50b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_518__1f50c_png__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_518__1f50c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_518__1f50c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_519__1f50d_png__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_519__1f50d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_519__1f50d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_520__1f50e_png__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_520__1f50e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_520__1f50e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_521__1f50f_png__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_521__1f50f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_521__1f50f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_522__1f510_png__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_522__1f510_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_522__1f510_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_523__1f511_png__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_523__1f511_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_523__1f511_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_524__1f512_png__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_524__1f512_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_524__1f512_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_525__1f513_png__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_525__1f513_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_525__1f513_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_526__1f514_png__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_526__1f514_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_526__1f514_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_527__1f515_png__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_527__1f515_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_527__1f515_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_528__1f516_png__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_528__1f516_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_528__1f516_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_529__1f517_png__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_529__1f517_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_529__1f517_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_530__1f518_png__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_530__1f518_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_530__1f518_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_531__1f519_png__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_531__1f519_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_531__1f519_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_532__1f51a_png__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_532__1f51a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_532__1f51a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_533__1f51b_png__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_533__1f51b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_533__1f51b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_534__1f51c_png__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_534__1f51c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_534__1f51c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_535__1f51d_png__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_535__1f51d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_535__1f51d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_536__1f51e_png__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_536__1f51e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_536__1f51e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_537__1f51f_png__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_537__1f51f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_537__1f51f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_538__1f520_png__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_538__1f520_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_538__1f520_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_539__1f521_png__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_539__1f521_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_539__1f521_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_540__1f522_png__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_540__1f522_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_540__1f522_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_541__1f523_png__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_541__1f523_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_541__1f523_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_542__1f524_png__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_542__1f524_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_542__1f524_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_543__1f525_png__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_543__1f525_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_543__1f525_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_544__1f526_png__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_544__1f526_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_544__1f526_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_545__1f527_png__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_545__1f527_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_545__1f527_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_546__1f528_png__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_546__1f528_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_546__1f528_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_547__1f529_png__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_547__1f529_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_547__1f529_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_548__1f52a_png__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_548__1f52a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_548__1f52a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_549__1f52b_png__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_549__1f52b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_549__1f52b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_550__1f52c_png__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_550__1f52c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_550__1f52c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_551__1f52d_png__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_551__1f52d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_551__1f52d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_552__1f52e_png__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_552__1f52e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_552__1f52e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_553__1f52f_png__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_553__1f52f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_553__1f52f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_554__1f530_png__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_554__1f530_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_554__1f530_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_555__1f531_png__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_555__1f531_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_555__1f531_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_556__1f532_png__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_556__1f532_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_556__1f532_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_557__1f533_png__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_557__1f533_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_557__1f533_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_558__1f534_png__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_558__1f534_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_558__1f534_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_559__1f535_png__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_559__1f535_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_559__1f535_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_560__1f536_png__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_560__1f536_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_560__1f536_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_561__1f537_png__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_561__1f537_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_561__1f537_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_562__1f538_png__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_562__1f538_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_562__1f538_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_563__1f539_png__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_563__1f539_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_563__1f539_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_564__1f53a_png__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_564__1f53a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_564__1f53a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_565__1f53b_png__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_565__1f53b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_565__1f53b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_566__1f53c_png__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_566__1f53c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_566__1f53c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_567__1f53d_png__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_567__1f53d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_567__1f53d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_568__1f550_png__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_568__1f550_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_568__1f550_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_569__1f551_png__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_569__1f551_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_569__1f551_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_570__1f552_png__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_570__1f552_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_570__1f552_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_571__1f553_png__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_571__1f553_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_571__1f553_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_572__1f554_png__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_572__1f554_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_572__1f554_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_573__1f555_png__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_573__1f555_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_573__1f555_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_574__1f556_png__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_574__1f556_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_574__1f556_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_575__1f557_png__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_575__1f557_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_575__1f557_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_576__1f558_png__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_576__1f558_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_576__1f558_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_577__1f559_png__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_577__1f559_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_577__1f559_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_578__1f55a_png__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_578__1f55a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_578__1f55a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_579__1f55b_png__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_579__1f55b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_579__1f55b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_580__1f55c_png__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_580__1f55c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_580__1f55c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_581__1f55d_png__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_581__1f55d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_581__1f55d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_582__1f55e_png__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_582__1f55e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_582__1f55e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_583__1f55f_png__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_583__1f55f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_583__1f55f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_584__1f560_png__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_584__1f560_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_584__1f560_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_585__1f561_png__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_585__1f561_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_585__1f561_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_586__1f562_png__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_586__1f562_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_586__1f562_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_587__1f563_png__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_587__1f563_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_587__1f563_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_588__1f564_png__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_588__1f564_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_588__1f564_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_589__1f565_png__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_589__1f565_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_589__1f565_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_590__1f566_png__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_590__1f566_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_590__1f566_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_591__1f567_png__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_591__1f567_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_591__1f567_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_592__1f5fb_png__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_592__1f5fb_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_592__1f5fb_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_593__1f5fc_png__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_593__1f5fc_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_593__1f5fc_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_594__1f5fd_png__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_594__1f5fd_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_594__1f5fd_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_595__1f5fe_png__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_595__1f5fe_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_595__1f5fe_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_596__1f5ff_png__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_596__1f5ff_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_596__1f5ff_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_597__1f600_png__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_597__1f600_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_597__1f600_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_598__1f601_png__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_598__1f601_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_598__1f601_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_599__1f602_png__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_599__1f602_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_599__1f602_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_600__1f603_png__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_600__1f603_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_600__1f603_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_601__1f604_png__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_601__1f604_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_601__1f604_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_602__1f605_png__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_602__1f605_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_602__1f605_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_603__1f606_png__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_603__1f606_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_603__1f606_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_604__1f607_png__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_604__1f607_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_604__1f607_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_605__1f608_png__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_605__1f608_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_605__1f608_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_606__1f609_png__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_606__1f609_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_606__1f609_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_607__1f60a_png__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_607__1f60a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_607__1f60a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_608__1f60b_png__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_608__1f60b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_608__1f60b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_609__1f60c_png__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_609__1f60c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_609__1f60c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_610__1f60d_png__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_610__1f60d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_610__1f60d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_611__1f60e_png__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_611__1f60e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_611__1f60e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_612__1f60f_png__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_612__1f60f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_612__1f60f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_613__1f610_png__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_613__1f610_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_613__1f610_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_614__1f611_png__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_614__1f611_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_614__1f611_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_615__1f612_png__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_615__1f612_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_615__1f612_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_616__1f613_png__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_616__1f613_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_616__1f613_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_617__1f614_png__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_617__1f614_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_617__1f614_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_618__1f615_png__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_618__1f615_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_618__1f615_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_619__1f616_png__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_619__1f616_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_619__1f616_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_620__1f617_png__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_620__1f617_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_620__1f617_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_621__1f618_png__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_621__1f618_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_621__1f618_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_622__1f619_png__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_622__1f619_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_622__1f619_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_623__1f61a_png__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_623__1f61a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_623__1f61a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_624__1f61b_png__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_624__1f61b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_624__1f61b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_625__1f61c_png__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_625__1f61c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_625__1f61c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_626__1f61d_png__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_626__1f61d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_626__1f61d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_627__1f61e_png__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_627__1f61e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_627__1f61e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_628__1f61f_png__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_628__1f61f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_628__1f61f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_629__1f620_png__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_629__1f620_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_629__1f620_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_630__1f621_png__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_630__1f621_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_630__1f621_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_631__1f622_png__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_631__1f622_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_631__1f622_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_632__1f623_png__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_632__1f623_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_632__1f623_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_633__1f624_png__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_633__1f624_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_633__1f624_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_634__1f625_png__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_634__1f625_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_634__1f625_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_635__1f626_png__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_635__1f626_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_635__1f626_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_636__1f627_png__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_636__1f627_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_636__1f627_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_637__1f628_png__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_637__1f628_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_637__1f628_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_638__1f629_png__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_638__1f629_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_638__1f629_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_639__1f62a_png__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_639__1f62a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_639__1f62a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_640__1f62b_png__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_640__1f62b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_640__1f62b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_641__1f62c_png__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_641__1f62c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_641__1f62c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_642__1f62d_png__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_642__1f62d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_642__1f62d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_643__1f62e_png__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_643__1f62e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_643__1f62e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_644__1f62f_png__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_644__1f62f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_644__1f62f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_645__1f630_png__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_645__1f630_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_645__1f630_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_646__1f631_png__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_646__1f631_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_646__1f631_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_647__1f632_png__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_647__1f632_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_647__1f632_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_648__1f633_png__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_648__1f633_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_648__1f633_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_649__1f634_png__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_649__1f634_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_649__1f634_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_650__1f635_png__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_650__1f635_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_650__1f635_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_651__1f636_png__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_651__1f636_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_651__1f636_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_652__1f637_png__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_652__1f637_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_652__1f637_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_653__1f638_png__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_653__1f638_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_653__1f638_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_654__1f639_png__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_654__1f639_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_654__1f639_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_655__1f63a_png__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_655__1f63a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_655__1f63a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_656__1f63b_png__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_656__1f63b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_656__1f63b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_657__1f63c_png__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_657__1f63c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_657__1f63c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_658__1f63d_png__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_658__1f63d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_658__1f63d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_659__1f63e_png__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_659__1f63e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_659__1f63e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_660__1f63f_png__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_660__1f63f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_660__1f63f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_661__1f640_png__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_661__1f640_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_661__1f640_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_662__1f645_png__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_662__1f645_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_662__1f645_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_663__1f646_png__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_663__1f646_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_663__1f646_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_664__1f647_png__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_664__1f647_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_664__1f647_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_665__1f648_png__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_665__1f648_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_665__1f648_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_666__1f649_png__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_666__1f649_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_666__1f649_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_667__1f64a_png__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_667__1f64a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_667__1f64a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_668__1f64b_png__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_668__1f64b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_668__1f64b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_669__1f64c_png__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_669__1f64c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_669__1f64c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_670__1f64d_png__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_670__1f64d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_670__1f64d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_671__1f64e_png__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_671__1f64e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_671__1f64e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_672__1f64f_png__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_672__1f64f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_672__1f64f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_673__1f680_png__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_673__1f680_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_673__1f680_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_674__1f681_png__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_674__1f681_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_674__1f681_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_675__1f682_png__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_675__1f682_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_675__1f682_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_676__1f683_png__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_676__1f683_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_676__1f683_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_677__1f684_png__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_677__1f684_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_677__1f684_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_678__1f685_png__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_678__1f685_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_678__1f685_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_679__1f686_png__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_679__1f686_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_679__1f686_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_680__1f687_png__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_680__1f687_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_680__1f687_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_681__1f688_png__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_681__1f688_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_681__1f688_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_682__1f689_png__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_682__1f689_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_682__1f689_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_683__1f68a_png__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_683__1f68a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_683__1f68a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_684__1f68b_png__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_684__1f68b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_684__1f68b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_685__1f68c_png__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_685__1f68c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_685__1f68c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_686__1f68d_png__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_686__1f68d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_686__1f68d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_687__1f68e_png__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_687__1f68e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_687__1f68e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_688__1f68f_png__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_688__1f68f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_688__1f68f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_689__1f690_png__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_689__1f690_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_689__1f690_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_690__1f691_png__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_690__1f691_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_690__1f691_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_691__1f692_png__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_691__1f692_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_691__1f692_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_692__1f693_png__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_692__1f693_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_692__1f693_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_693__1f694_png__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_693__1f694_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_693__1f694_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_694__1f695_png__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_694__1f695_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_694__1f695_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_695__1f696_png__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_695__1f696_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_695__1f696_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_696__1f697_png__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_696__1f697_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_696__1f697_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_697__1f698_png__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_697__1f698_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_697__1f698_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_698__1f699_png__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_698__1f699_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_698__1f699_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_699__1f69a_png__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_699__1f69a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_699__1f69a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_700__1f69b_png__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_700__1f69b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_700__1f69b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_701__1f69c_png__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_701__1f69c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_701__1f69c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_702__1f69d_png__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_702__1f69d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_702__1f69d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_703__1f69e_png__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_703__1f69e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_703__1f69e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_704__1f69f_png__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_704__1f69f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_704__1f69f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_705__1f6a0_png__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_705__1f6a0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_705__1f6a0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_706__1f6a1_png__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_706__1f6a1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_706__1f6a1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_707__1f6a2_png__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_707__1f6a2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_707__1f6a2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_708__1f6a3_png__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_708__1f6a3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_708__1f6a3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_709__1f6a4_png__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_709__1f6a4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_709__1f6a4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_710__1f6a5_png__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_710__1f6a5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_710__1f6a5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_711__1f6a6_png__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_711__1f6a6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_711__1f6a6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_712__1f6a7_png__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_712__1f6a7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_712__1f6a7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_713__1f6a8_png__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_713__1f6a8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_713__1f6a8_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_714__1f6a9_png__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_714__1f6a9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_714__1f6a9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_715__1f6aa_png__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_715__1f6aa_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_715__1f6aa_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_716__1f6ab_png__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_716__1f6ab_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_716__1f6ab_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_717__1f6ac_png__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_717__1f6ac_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_717__1f6ac_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_718__1f6ad_png__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_718__1f6ad_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_718__1f6ad_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_719__1f6ae_png__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_719__1f6ae_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_719__1f6ae_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_720__1f6af_png__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_720__1f6af_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_720__1f6af_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_721__1f6b0_png__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_721__1f6b0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_721__1f6b0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_722__1f6b1_png__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_722__1f6b1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_722__1f6b1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_723__1f6b2_png__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_723__1f6b2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_723__1f6b2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_724__1f6b3_png__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_724__1f6b3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_724__1f6b3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_725__1f6b4_png__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_725__1f6b4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_725__1f6b4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_726__1f6b5_png__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_726__1f6b5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_726__1f6b5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_727__1f6b6_png__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_727__1f6b6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_727__1f6b6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_728__1f6b7_png__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_728__1f6b7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_728__1f6b7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_729__1f6b8_png__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_729__1f6b8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_729__1f6b8_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_730__1f6b9_png__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_730__1f6b9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_730__1f6b9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_731__1f6ba_png__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_731__1f6ba_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_731__1f6ba_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_732__1f6bb_png__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_732__1f6bb_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_732__1f6bb_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_733__1f6bc_png__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_733__1f6bc_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_733__1f6bc_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_734__1f6bd_png__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_734__1f6bd_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_734__1f6bd_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_735__1f6be_png__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_735__1f6be_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_735__1f6be_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_736__1f6bf_png__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_736__1f6bf_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_736__1f6bf_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_737__1f6c0_png__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_737__1f6c0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_737__1f6c0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_738__1f6c1_png__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_738__1f6c1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_738__1f6c1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_739__1f6c2_png__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_739__1f6c2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_739__1f6c2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_740__1f6c3_png__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_740__1f6c3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_740__1f6c3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_741__1f6c4_png__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_741__1f6c4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_741__1f6c4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_742__1f6c5_png__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_742__1f6c5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_742__1f6c5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_743__203c_png__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_743__203c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_743__203c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_744__2049_png__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_744__2049_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_744__2049_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_745__2122_png__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_745__2122_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_745__2122_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_746__2139_png__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_746__2139_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_746__2139_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_747__2194_png__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_747__2194_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_747__2194_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_748__2195_png__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_748__2195_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_748__2195_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_749__2196_png__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_749__2196_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_749__2196_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_750__2197_png__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_750__2197_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_750__2197_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_751__2198_png__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_751__2198_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_751__2198_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_752__2199_png__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_752__2199_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_752__2199_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_753__21a9_png__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_753__21a9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_753__21a9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_754__21aa_png__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_754__21aa_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_754__21aa_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_755__23_20e3_png__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_755__23_20e3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_755__23_20e3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_756__231a_png__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_756__231a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_756__231a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_757__231b_png__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_757__231b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_757__231b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_758__23e9_png__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_758__23e9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_758__23e9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_759__23ea_png__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_759__23ea_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_759__23ea_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_760__23eb_png__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_760__23eb_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_760__23eb_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_761__23ec_png__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_761__23ec_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_761__23ec_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_762__23f0_png__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_762__23f0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_762__23f0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_763__23f3_png__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_763__23f3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_763__23f3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_764__24c2_png__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_764__24c2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_764__24c2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_765__25aa_png__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_765__25aa_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_765__25aa_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_766__25ab_png__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_766__25ab_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_766__25ab_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_767__25b6_png__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_767__25b6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_767__25b6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_768__25c0_png__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_768__25c0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_768__25c0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_769__25fb_png__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_769__25fb_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_769__25fb_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_770__25fc_png__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_770__25fc_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_770__25fc_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_771__25fd_png__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_771__25fd_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_771__25fd_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_772__25fe_png__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_772__25fe_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_772__25fe_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_773__2600_png__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_773__2600_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_773__2600_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_774__2601_png__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_774__2601_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_774__2601_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_775__260e_png__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_775__260e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_775__260e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_776__2611_png__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_776__2611_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_776__2611_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_777__2614_png__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_777__2614_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_777__2614_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_778__2615_png__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_778__2615_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_778__2615_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_779__261d_png__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_779__261d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_779__261d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_780__263a_png__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_780__263a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_780__263a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_781__2648_png__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_781__2648_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_781__2648_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_782__2649_png__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_782__2649_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_782__2649_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_783__264a_png__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_783__264a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_783__264a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_784__264b_png__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_784__264b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_784__264b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_785__264c_png__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_785__264c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_785__264c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_786__264d_png__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_786__264d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_786__264d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_787__264e_png__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_787__264e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_787__264e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_788__264f_png__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_788__264f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_788__264f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_789__2650_png__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_789__2650_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_789__2650_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_790__2651_png__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_790__2651_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_790__2651_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_791__2652_png__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_791__2652_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_791__2652_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_792__2653_png__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_792__2653_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_792__2653_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_793__2660_png__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_793__2660_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_793__2660_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_794__2663_png__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_794__2663_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_794__2663_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_795__2665_png__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_795__2665_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_795__2665_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_796__2666_png__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_796__2666_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_796__2666_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_797__2668_png__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_797__2668_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_797__2668_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_798__267b_png__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_798__267b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_798__267b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_799__267f_png__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_799__267f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_799__267f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_800__2693_png__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_800__2693_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_800__2693_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_801__26a0_png__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_801__26a0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_801__26a0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_802__26a1_png__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_802__26a1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_802__26a1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_803__26aa_png__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_803__26aa_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_803__26aa_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_804__26ab_png__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_804__26ab_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_804__26ab_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_805__26bd_png__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_805__26bd_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_805__26bd_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_806__26be_png__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_806__26be_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_806__26be_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_807__26c4_png__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_807__26c4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_807__26c4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_808__26c5_png__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_808__26c5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_808__26c5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_809__26ce_png__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_809__26ce_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_809__26ce_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_810__26d4_png__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_810__26d4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_810__26d4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_811__26ea_png__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_811__26ea_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_811__26ea_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_812__26f2_png__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_812__26f2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_812__26f2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_813__26f3_png__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_813__26f3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_813__26f3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_814__26f5_png__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_814__26f5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_814__26f5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_815__26fa_png__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_815__26fa_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_815__26fa_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_816__26fd_png__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_816__26fd_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_816__26fd_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_817__2702_png__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_817__2702_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_817__2702_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_818__2705_png__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_818__2705_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_818__2705_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_819__2708_png__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_819__2708_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_819__2708_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_820__2709_png__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_820__2709_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_820__2709_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_821__270a_png__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_821__270a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_821__270a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_822__270b_png__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_822__270b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_822__270b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_823__270c_png__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_823__270c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_823__270c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_824__270f_png__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_824__270f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_824__270f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_825__2712_png__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_825__2712_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_825__2712_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_826__2714_png__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_826__2714_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_826__2714_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_827__2716_png__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_827__2716_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_827__2716_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_828__2728_png__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_828__2728_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_828__2728_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_829__2733_png__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_829__2733_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_829__2733_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_830__2734_png__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_830__2734_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_830__2734_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_831__2744_png__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_831__2744_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_831__2744_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_832__2747_png__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_832__2747_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_832__2747_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_833__274c_png__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_833__274c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_833__274c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_834__274e_png__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_834__274e_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_834__274e_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_835__2753_png__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_835__2753_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_835__2753_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_836__2754_png__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_836__2754_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_836__2754_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_837__2755_png__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_837__2755_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_837__2755_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_838__2757_png__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_838__2757_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_838__2757_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_839__2764_png__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_839__2764_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_839__2764_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_840__2795_png__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_840__2795_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_840__2795_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_841__2796_png__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_841__2796_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_841__2796_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_842__2797_png__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_842__2797_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_842__2797_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_843__27a1_png__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_843__27a1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_843__27a1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_844__27b0_png__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_844__27b0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_844__27b0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_845__27bf_png__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_845__27bf_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_845__27bf_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_846__2934_png__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_846__2934_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_846__2934_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_847__2935_png__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_847__2935_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_847__2935_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_848__2b05_png__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_848__2b05_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_848__2b05_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_849__2b06_png__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_849__2b06_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_849__2b06_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_850__2b07_png__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_850__2b07_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_850__2b07_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_851__2b1b_png__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_851__2b1b_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_851__2b1b_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_852__2b1c_png__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_852__2b1c_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_852__2b1c_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_853__2b50_png__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_853__2b50_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_853__2b50_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_854__2b55_png__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_854__2b55_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_854__2b55_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_855__30_20e3_png__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_855__30_20e3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_855__30_20e3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_856__3030_png__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_856__3030_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_856__3030_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_857__303d_png__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_857__303d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_857__303d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_858__31_20e3_png__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_858__31_20e3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_858__31_20e3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_859__32_20e3_png__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_859__32_20e3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_859__32_20e3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_860__3297_png__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_860__3297_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_860__3297_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_861__3299_png__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_861__3299_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_861__3299_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_862__33_20e3_png__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_862__33_20e3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_862__33_20e3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_863__34_20e3_png__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_863__34_20e3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_863__34_20e3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_864__35_20e3_png__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_864__35_20e3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_864__35_20e3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_865__36_20e3_png__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_865__36_20e3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_865__36_20e3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_866__37_20e3_png__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_866__37_20e3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_866__37_20e3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_867__38_20e3_png__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_867__38_20e3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_867__38_20e3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_868__39_20e3_png__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_868__39_20e3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_868__39_20e3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_869__README_md__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_869__README_md___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_869__README_md__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_870__a9_png__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_870__a9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_870__a9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_871__ae_png__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_871__ae_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_871__ae_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_872__e50a_png__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_872__e50a_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_872__e50a_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_873__grid_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_874__manifest_js__ = __webpack_require__(138);












































































































































































































































































































































































































































































































































































































































































































































































































































































































/* harmony default export */ __webpack_exports__["a"] = ({
	icons: [{ src: __WEBPACK_IMPORTED_MODULE_597__1f600_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_598__1f601_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_599__1f602_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_600__1f603_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_601__1f604_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_602__1f605_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_603__1f606_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_604__1f607_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_605__1f608_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_606__1f609_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_607__1f60a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_608__1f60b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_609__1f60c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_610__1f60d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_611__1f60e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_612__1f60f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_613__1f610_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_614__1f611_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_615__1f612_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_616__1f613_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_617__1f614_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_618__1f615_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_619__1f616_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_620__1f617_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_621__1f618_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_622__1f619_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_623__1f61a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_624__1f61b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_625__1f61c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_626__1f61d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_627__1f61e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_628__1f61f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_629__1f620_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_630__1f621_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_631__1f622_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_632__1f623_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_633__1f624_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_634__1f625_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_635__1f626_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_636__1f627_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_637__1f628_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_638__1f629_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_639__1f62a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_640__1f62b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_641__1f62c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_642__1f62d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_643__1f62e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_644__1f62f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_645__1f630_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_646__1f631_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_647__1f632_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_648__1f633_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_649__1f634_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_650__1f635_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_651__1f636_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_652__1f637_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_653__1f638_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_654__1f639_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_655__1f63a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_656__1f63b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_657__1f63c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_658__1f63d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_659__1f63e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_660__1f63f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_661__1f640_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_662__1f645_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_663__1f646_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_664__1f647_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_665__1f648_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_666__1f649_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_667__1f64a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_668__1f64b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_669__1f64c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_670__1f64d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_671__1f64e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_672__1f64f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_673__1f680_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_674__1f681_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_675__1f682_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_676__1f683_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_677__1f684_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_678__1f685_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_679__1f686_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_680__1f687_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_681__1f688_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_682__1f689_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_683__1f68a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_684__1f68b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_685__1f68c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_686__1f68d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_687__1f68e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_688__1f68f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_689__1f690_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_690__1f691_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_691__1f692_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_692__1f693_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_693__1f694_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_694__1f695_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_695__1f696_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_696__1f697_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_697__1f698_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_698__1f699_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_699__1f69a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_700__1f69b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_701__1f69c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_702__1f69d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_703__1f69e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_704__1f69f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_705__1f6a0_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_706__1f6a1_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_707__1f6a2_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_708__1f6a3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_709__1f6a4_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_710__1f6a5_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_711__1f6a6_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_712__1f6a7_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_713__1f6a8_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_714__1f6a9_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_715__1f6aa_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_716__1f6ab_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_717__1f6ac_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_718__1f6ad_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_719__1f6ae_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_720__1f6af_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_721__1f6b0_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_722__1f6b1_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_723__1f6b2_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_724__1f6b3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_725__1f6b4_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_726__1f6b5_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_727__1f6b6_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_728__1f6b7_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_729__1f6b8_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_730__1f6b9_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_731__1f6ba_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_732__1f6bb_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_733__1f6bc_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_734__1f6bd_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_735__1f6be_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_736__1f6bf_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_737__1f6c0_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_738__1f6c1_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_739__1f6c2_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_740__1f6c3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_741__1f6c4_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_742__1f6c5_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_743__203c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_744__2049_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_745__2122_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_746__2139_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_747__2194_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_748__2195_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_749__2196_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_750__2197_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_751__2198_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_752__2199_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_753__21a9_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_754__21aa_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_755__23_20e3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_756__231a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_757__231b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_758__23e9_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_759__23ea_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_760__23eb_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_761__23ec_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_762__23f0_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_763__23f3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_764__24c2_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_765__25aa_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_766__25ab_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_767__25b6_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_768__25c0_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_769__25fb_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_770__25fc_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_771__25fd_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_772__25fe_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_773__2600_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_774__2601_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_775__260e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_776__2611_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_777__2614_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_778__2615_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_779__261d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_780__263a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_781__2648_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_782__2649_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_783__264a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_784__264b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_785__264c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_786__264d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_787__264e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_788__264f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_789__2650_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_790__2651_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_791__2652_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_792__2653_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_793__2660_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_794__2663_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_795__2665_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_796__2666_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_797__2668_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_798__267b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_799__267f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_800__2693_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_801__26a0_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_802__26a1_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_803__26aa_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_804__26ab_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_805__26bd_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_806__26be_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_807__26c4_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_808__26c5_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_809__26ce_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_810__26d4_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_811__26ea_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_812__26f2_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_813__26f3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_814__26f5_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_815__26fa_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_816__26fd_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_817__2702_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_818__2705_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_819__2708_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_820__2709_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_821__270a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_822__270b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_823__270c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_824__270f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_825__2712_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_826__2714_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_827__2716_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_828__2728_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_829__2733_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_830__2734_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_831__2744_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_832__2747_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_833__274c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_834__274e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_835__2753_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_836__2754_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_837__2755_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_838__2757_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_839__2764_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_840__2795_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_841__2796_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_842__2797_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_843__27a1_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_844__27b0_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_845__27bf_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_846__2934_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_847__2935_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_848__2b05_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_849__2b06_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_850__2b07_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_851__2b1b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_852__2b1c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_853__2b50_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_854__2b55_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_855__30_20e3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_856__3030_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_857__303d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_858__31_20e3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_859__32_20e3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_860__3297_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_861__3299_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_862__33_20e3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_863__34_20e3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_864__35_20e3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_865__36_20e3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_866__37_20e3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_867__38_20e3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_868__39_20e3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_869__README_md___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_870__a9_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_871__ae_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_872__e50a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_873__grid_js__["a" /* default */], width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_874__manifest_js__["a" /* default */], width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_0__1f004_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_1__1f0cf_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_2__1f170_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_3__1f171_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_4__1f17e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_5__1f17f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_6__1f18e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_7__1f191_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_8__1f192_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_9__1f193_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_10__1f194_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_11__1f195_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_12__1f196_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_13__1f197_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_14__1f198_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_15__1f199_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_16__1f19a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_17__1f1e6_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_18__1f1e7_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_19__1f1e8_1f1f3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_20__1f1e8_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_21__1f1e9_1f1ea_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_22__1f1e9_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_23__1f1ea_1f1f8_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_24__1f1ea_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_25__1f1eb_1f1f7_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_26__1f1eb_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_27__1f1ec_1f1e7_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_28__1f1ec_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_29__1f1ed_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_30__1f1ee_1f1f9_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_31__1f1ee_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_32__1f1ef_1f1f5_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_33__1f1ef_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_34__1f1f0_1f1f7_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_35__1f1f0_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_36__1f1f1_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_37__1f1f2_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_38__1f1f3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_39__1f1f4_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_40__1f1f5_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_41__1f1f6_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_42__1f1f7_1f1fa_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_43__1f1f7_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_44__1f1f8_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_45__1f1f9_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_46__1f1fa_1f1f8_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_47__1f1fa_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_48__1f1fb_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_49__1f1fc_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_50__1f1fd_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_51__1f1fe_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_52__1f1ff_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_53__1f201_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_54__1f202_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_55__1f21a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_56__1f22f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_57__1f232_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_58__1f233_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_59__1f234_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_60__1f235_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_61__1f236_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_62__1f237_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_63__1f238_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_64__1f239_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_65__1f23a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_66__1f250_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_67__1f251_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_68__1f300_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_69__1f301_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_70__1f302_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_71__1f303_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_72__1f304_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_73__1f305_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_74__1f306_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_75__1f307_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_76__1f308_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_77__1f309_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_78__1f30a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_79__1f30b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_80__1f30c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_81__1f30d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_82__1f30e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_83__1f30f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_84__1f310_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_85__1f311_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_86__1f312_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_87__1f313_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_88__1f314_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_89__1f315_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_90__1f316_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_91__1f317_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_92__1f318_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_93__1f319_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_94__1f31a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_95__1f31b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_96__1f31c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_97__1f31d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_98__1f31e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_99__1f31f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_100__1f320_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_101__1f330_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_102__1f331_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_103__1f332_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_104__1f333_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_105__1f334_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_106__1f335_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_107__1f337_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_108__1f338_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_109__1f339_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_110__1f33a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_111__1f33b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_112__1f33c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_113__1f33d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_114__1f33e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_115__1f33f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_116__1f340_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_117__1f341_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_118__1f342_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_119__1f343_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_120__1f344_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_121__1f345_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_122__1f346_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_123__1f347_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_124__1f348_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_125__1f349_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_126__1f34a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_127__1f34b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_128__1f34c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_129__1f34d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_130__1f34e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_131__1f34f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_132__1f350_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_133__1f351_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_134__1f352_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_135__1f353_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_136__1f354_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_137__1f355_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_138__1f356_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_139__1f357_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_140__1f358_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_141__1f359_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_142__1f35a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_143__1f35b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_144__1f35c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_145__1f35d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_146__1f35e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_147__1f35f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_148__1f360_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_149__1f361_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_150__1f362_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_151__1f363_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_152__1f364_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_153__1f365_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_154__1f366_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_155__1f367_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_156__1f368_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_157__1f369_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_158__1f36a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_159__1f36b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_160__1f36c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_161__1f36d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_162__1f36e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_163__1f36f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_164__1f370_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_165__1f371_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_166__1f372_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_167__1f373_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_168__1f374_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_169__1f375_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_170__1f376_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_171__1f377_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_172__1f378_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_173__1f379_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_174__1f37a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_175__1f37b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_176__1f37c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_177__1f380_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_178__1f381_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_179__1f382_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_180__1f383_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_181__1f384_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_182__1f385_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_183__1f386_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_184__1f387_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_185__1f388_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_186__1f389_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_187__1f38a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_188__1f38b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_189__1f38c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_190__1f38d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_191__1f38e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_192__1f38f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_193__1f390_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_194__1f391_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_195__1f392_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_196__1f393_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_197__1f3a0_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_198__1f3a1_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_199__1f3a2_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_200__1f3a3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_201__1f3a4_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_202__1f3a5_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_203__1f3a6_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_204__1f3a7_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_205__1f3a8_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_206__1f3a9_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_207__1f3aa_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_208__1f3ab_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_209__1f3ac_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_210__1f3ad_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_211__1f3ae_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_212__1f3af_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_213__1f3b0_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_214__1f3b1_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_215__1f3b2_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_216__1f3b3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_217__1f3b4_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_218__1f3b5_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_219__1f3b6_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_220__1f3b7_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_221__1f3b8_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_222__1f3b9_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_223__1f3ba_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_224__1f3bb_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_225__1f3bc_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_226__1f3bd_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_227__1f3be_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_228__1f3bf_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_229__1f3c0_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_230__1f3c1_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_231__1f3c2_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_232__1f3c3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_233__1f3c4_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_234__1f3c6_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_235__1f3c7_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_236__1f3c8_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_237__1f3c9_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_238__1f3ca_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_239__1f3e0_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_240__1f3e1_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_241__1f3e2_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_242__1f3e3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_243__1f3e4_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_244__1f3e5_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_245__1f3e6_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_246__1f3e7_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_247__1f3e8_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_248__1f3e9_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_249__1f3ea_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_250__1f3eb_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_251__1f3ec_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_252__1f3ed_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_253__1f3ee_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_254__1f3ef_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_255__1f3f0_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_256__1f400_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_257__1f401_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_258__1f402_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_259__1f403_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_260__1f404_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_261__1f405_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_262__1f406_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_263__1f407_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_264__1f408_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_265__1f409_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_266__1f40a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_267__1f40b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_268__1f40c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_269__1f40d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_270__1f40e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_271__1f40f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_272__1f410_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_273__1f411_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_274__1f412_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_275__1f413_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_276__1f414_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_277__1f415_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_278__1f416_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_279__1f417_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_280__1f418_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_281__1f419_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_282__1f41a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_283__1f41b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_284__1f41c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_285__1f41d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_286__1f41e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_287__1f41f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_288__1f420_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_289__1f421_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_290__1f422_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_291__1f423_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_292__1f424_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_293__1f425_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_294__1f426_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_295__1f427_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_296__1f428_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_297__1f429_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_298__1f42a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_299__1f42b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_300__1f42c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_301__1f42d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_302__1f42e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_303__1f42f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_304__1f430_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_305__1f431_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_306__1f432_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_307__1f433_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_308__1f434_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_309__1f435_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_310__1f436_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_311__1f437_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_312__1f438_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_313__1f439_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_314__1f43a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_315__1f43b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_316__1f43c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_317__1f43d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_318__1f43e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_319__1f440_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_320__1f442_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_321__1f443_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_322__1f444_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_323__1f445_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_324__1f446_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_325__1f447_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_326__1f448_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_327__1f449_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_328__1f44a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_329__1f44b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_330__1f44c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_331__1f44d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_332__1f44e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_333__1f44f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_334__1f450_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_335__1f451_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_336__1f452_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_337__1f453_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_338__1f454_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_339__1f455_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_340__1f456_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_341__1f457_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_342__1f458_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_343__1f459_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_344__1f45a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_345__1f45b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_346__1f45c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_347__1f45d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_348__1f45e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_349__1f45f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_350__1f460_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_351__1f461_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_352__1f462_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_353__1f463_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_354__1f464_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_355__1f465_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_356__1f466_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_357__1f467_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_358__1f468_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_359__1f469_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_360__1f46a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_361__1f46b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_362__1f46c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_363__1f46d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_364__1f46e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_365__1f46f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_366__1f470_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_367__1f471_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_368__1f472_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_369__1f473_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_370__1f474_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_371__1f475_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_372__1f476_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_373__1f477_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_374__1f478_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_375__1f479_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_376__1f47a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_377__1f47b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_378__1f47c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_379__1f47d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_380__1f47e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_381__1f47f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_382__1f480_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_383__1f481_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_384__1f482_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_385__1f483_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_386__1f484_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_387__1f485_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_388__1f486_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_389__1f487_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_390__1f488_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_391__1f489_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_392__1f48a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_393__1f48b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_394__1f48c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_395__1f48d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_396__1f48e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_397__1f48f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_398__1f490_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_399__1f491_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_400__1f492_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_401__1f493_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_402__1f494_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_403__1f495_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_404__1f496_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_405__1f497_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_406__1f498_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_407__1f499_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_408__1f49a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_409__1f49b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_410__1f49c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_411__1f49d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_412__1f49e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_413__1f49f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_414__1f4a0_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_415__1f4a1_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_416__1f4a2_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_417__1f4a3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_418__1f4a4_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_419__1f4a5_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_420__1f4a6_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_421__1f4a7_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_422__1f4a8_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_423__1f4a9_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_424__1f4aa_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_425__1f4ab_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_426__1f4ac_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_427__1f4ad_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_428__1f4ae_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_429__1f4af_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_430__1f4b0_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_431__1f4b1_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_432__1f4b2_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_433__1f4b3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_434__1f4b4_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_435__1f4b5_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_436__1f4b6_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_437__1f4b7_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_438__1f4b8_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_439__1f4b9_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_440__1f4ba_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_441__1f4bb_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_442__1f4bc_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_443__1f4bd_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_444__1f4be_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_445__1f4bf_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_446__1f4c0_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_447__1f4c1_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_448__1f4c2_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_449__1f4c3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_450__1f4c4_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_451__1f4c5_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_452__1f4c6_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_453__1f4c7_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_454__1f4c8_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_455__1f4c9_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_456__1f4ca_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_457__1f4cb_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_458__1f4cc_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_459__1f4cd_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_460__1f4ce_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_461__1f4cf_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_462__1f4d0_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_463__1f4d1_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_464__1f4d2_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_465__1f4d3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_466__1f4d4_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_467__1f4d5_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_468__1f4d6_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_469__1f4d7_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_470__1f4d8_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_471__1f4d9_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_472__1f4da_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_473__1f4db_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_474__1f4dc_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_475__1f4dd_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_476__1f4de_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_477__1f4df_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_478__1f4e0_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_479__1f4e1_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_480__1f4e2_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_481__1f4e3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_482__1f4e4_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_483__1f4e5_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_484__1f4e6_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_485__1f4e7_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_486__1f4e8_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_487__1f4e9_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_488__1f4ea_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_489__1f4eb_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_490__1f4ec_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_491__1f4ed_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_492__1f4ee_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_493__1f4ef_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_494__1f4f0_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_495__1f4f1_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_496__1f4f2_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_497__1f4f3_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_498__1f4f4_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_499__1f4f5_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_500__1f4f6_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_501__1f4f7_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_502__1f4f9_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_503__1f4fa_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_504__1f4fb_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_505__1f4fc_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_506__1f500_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_507__1f501_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_508__1f502_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_509__1f503_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_510__1f504_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_511__1f505_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_512__1f506_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_513__1f507_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_514__1f508_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_515__1f509_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_516__1f50a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_517__1f50b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_518__1f50c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_519__1f50d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_520__1f50e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_521__1f50f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_522__1f510_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_523__1f511_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_524__1f512_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_525__1f513_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_526__1f514_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_527__1f515_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_528__1f516_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_529__1f517_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_530__1f518_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_531__1f519_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_532__1f51a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_533__1f51b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_534__1f51c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_535__1f51d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_536__1f51e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_537__1f51f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_538__1f520_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_539__1f521_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_540__1f522_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_541__1f523_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_542__1f524_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_543__1f525_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_544__1f526_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_545__1f527_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_546__1f528_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_547__1f529_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_548__1f52a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_549__1f52b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_550__1f52c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_551__1f52d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_552__1f52e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_553__1f52f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_554__1f530_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_555__1f531_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_556__1f532_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_557__1f533_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_558__1f534_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_559__1f535_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_560__1f536_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_561__1f537_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_562__1f538_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_563__1f539_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_564__1f53a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_565__1f53b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_566__1f53c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_567__1f53d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_568__1f550_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_569__1f551_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_570__1f552_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_571__1f553_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_572__1f554_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_573__1f555_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_574__1f556_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_575__1f557_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_576__1f558_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_577__1f559_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_578__1f55a_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_579__1f55b_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_580__1f55c_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_581__1f55d_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_582__1f55e_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_583__1f55f_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_584__1f560_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_585__1f561_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_586__1f562_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_587__1f563_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_588__1f564_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_589__1f565_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_590__1f566_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_591__1f567_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_592__1f5fb_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_593__1f5fc_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_594__1f5fd_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_595__1f5fe_png___default.a, width: 72, height: 72 }, { src: __WEBPACK_IMPORTED_MODULE_596__1f5ff_png___default.a, width: 72, height: 72 }]
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
    // search_key: "AIzaSyAJKtvB_hpQIhu_NXHRn8UV6hwuVbQ9sgo",
    // search_key: "AIzaSyCriPmxhVzD6bYNAPn8c1wOVrTSbQwkcUk",
    search_key: "AIzaSyDUKNVZ3oBjob1f3WIOoGe9XqUmc1A58BY", // GC Platfrom 300$ Trial

    search_cx: "001029405728493086903:nkufjx8pklu",

    client_id: "4HecCqcwYGMwj0i9tXQXJJXrVM5ZIYWG7qVRHyzki8NqMMFQSjnUbSc9HMIBiMEc",
    client_secret: "d55cnDgn8RTO4Hx5ulHPerzs0AVScn9HVqgpB2H33KAglmvlWswNY8XvqDHLOEoD",

    googl_key: "",

    lang: "en-US",

    firebase: {
        apiKey: "AIzaSyACuHsGP88Gyl7bu6FGbmmTBGiCCfhgJAM",
        authDomain: "mind-palace-879c9.firebaseapp.com",
        databaseURL: "https://mind-palace-879c9.firebaseio.com",
        projectId: "mind-palace-879c9",
        storageBucket: "mind-palace-879c9.appspot.com",
        messagingSenderId: "459916442614"
    }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return firebaseBackup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shortid__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shortid__);






/**
 * Retrieves or generates unique user id on the device
 */
var uid = localStorage.getItem('uid');
if (!uid) {
    uid = __WEBPACK_IMPORTED_MODULE_2_shortid___default.a.generate();
    localStorage.setItem('uid', uid);
}

__WEBPACK_IMPORTED_MODULE_0_firebase__["initializeApp"](__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].firebase);
var database = __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]();

var firebaseBackup = function firebaseBackup(data) {
    database.ref('users/' + uid).set(data);
};

/* unused harmony default export */ var _unused_webpack_default_export = (database);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UrlEncoder = function () {

    /**
     * 
     * Initializes URL Encoder Module
     * 
     * @param {String} api_key - API key for goo.gl URL shortener
     * 
     */
    function UrlEncoder(api_key) {
        _classCallCheck(this, UrlEncoder);

        // Goo.Gl API key 
        this.api_key = api_key;

        // this.domain = window.location.protocol + "//" + window.location.host + window.location.pathname
        this.domain = "https://techblogogy.github.io/garage48-vrideas/";
        this.domainSize = this.domain.length;

        this.chunkSize = 2047 - this.domainSize;
        this.splitExp = new RegExp(".{1," + this.chunkSize + "}", "g");
    }

    /**
     * 
     * Function for generating short encoded URLs for data storage
     * 
     * @param {String} data - Data to encode and store 
     * 
     * @return {Promise} Base64 encoded string
     * 
     */


    _createClass(UrlEncoder, [{
        key: "encodeString",
        value: function encodeString(data) {
            var _this = this;

            this.chunks = this.getChunks(data);
            this.received = [];

            return new Promise(function (res, rej) {
                if (_this.chunks.length > 1) _this.getLoop(_this.chunks[0], 0, res, rej);else _this.getShort(_this.chunks[0]).then(function (url) {
                    // return res("https://goo.gl/"+url)
                    return res(_this.domain + "?data=" + btoa(url));
                }).catch(function (err) {
                    return rej(err);
                });
            });
        }

        /**
         * 
         * Function for decoding data from Base64 string
         * 
         * @param {String} chunk - Base64 Encoded String 
         * 
         * @return {Promise} Decoded string with data
         * 
         */

    }, {
        key: "decodeString",
        value: function decodeString(chunk) {
            var _this2 = this;

            this.chunks = this.decodeChunks(chunk);
            this.received = [];

            return new Promise(function (res, rej) {
                if (_this2.chunks[0].length === 6) {
                    _this2.decodeLoop(_this2.chunks[0], 0, res, rej);
                } else {
                    console.log(atob(chunk));
                    return res(atob(chunk));
                }
            });
        }

        /**
         * 
         * Encodes Javascript Object as URL data parameter
         * 
         * @param {Object} json - Object with data
         * 
         * @return {Promise} Base64 Encoded String
         * 
         */

    }, {
        key: "encodeData",
        value: function encodeData(json) {
            return this.encodeString(JSON.stringify(json));
        }

        /**
         * 
         * Recursive loop for encoding chunks of data
         * 
         * @param {String} chunk - Chunk Of Base64 Encoded String 
         * @param {Number} i - Index Of Current Chunk 
         * @param {function} res - Promise resolve function
         * @param {function} rej - Promise reject function 
         * 
         * @return {Promise} 
         * 
         */

    }, {
        key: "getLoop",
        value: function getLoop(chunk, i, res, rej) {
            var _this3 = this;

            this.getShort(chunk).then(function (url) {
                _this3.received.push(url);
                console.log(_this3.received);

                if (i + 1 < _this3.chunks.length) {
                    _this3.getLoop(_this3.chunks[i + 1], i + 1, res, rej);
                } else {
                    _this3.encodeString(_this3.received.join(",")).then(res).catch(rej);
                }
            }).catch(rej);
        }

        /**
         * 
         * Recursive loop for decoding chunks of data
         * 
         * @param {String} Chunk Of goo.gl Encoded Data 
         * @param {Number} i - Index Of Current Chunk
         * @param {function} res - Promise resolve function
         * @param {function} rej - Promise reject function 
         * 
         * @return {Promise} 
         * 
         */

    }, {
        key: "decodeLoop",
        value: function decodeLoop(chunk, i, res, rej) {
            var _this4 = this;

            this.decodeShort(chunk).then(function (url) {
                _this4.received.push(url);
                console.log(_this4.received);

                if (i + 1 < _this4.chunks.length) {
                    _this4.decodeLoop(_this4.chunks[i + 1], i + 1, res, rej);
                } else {
                    _this4.decodeString(_this4.received.join("")).then(res).catch(rej);
                }
            }).catch(rej);
        }

        /**
         * 
         * Splits data string into chunks
         * 
         * @param {String} data 
         * 
         */

    }, {
        key: "getChunks",
        value: function getChunks(data) {
            var utf8String = unescape(encodeURIComponent(data));
            var dataBlob = btoa(utf8String);
            var blobChunks = dataBlob.match(this.splitExp);

            return blobChunks;
        }

        /**
         * 
         * Decodes and splits Base64 chunks
         * 
         * @param {String} encChunks - returns normal data string
         * 
         */

    }, {
        key: "decodeChunks",
        value: function decodeChunks(encChunks) {
            var utf8String = escape(atob(encChunks));
            var data = decodeURIComponent(utf8String);
            var chunks = data.split(",");

            return chunks;
        }

        /**
         * 
         * Encodes chunk as goo.gl URL
         * 
         * @param {String} chunk - Base64 Chunk
         * 
         */

    }, {
        key: "getShort",
        value: function getShort(chunk) {
            var _this5 = this;

            return new Promise(function (done, rej) {

                fetch("https://www.googleapis.com/urlshortener/v1/url?key=" + _this5.api_key, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    method: "POST",
                    body: JSON.stringify({ longUrl: _this5.domain + chunk })
                }).then(function (res) {
                    return res.json();
                }).then(function (res) {
                    var shortUrl = res.id.split("/")[3];
                    return done(shortUrl);
                }).catch(function (err) {
                    return rej(err);
                });
            });
        }

        /**
         * 
         * Decodes goo.gl data chunk 
         * 
         * @param {String} chunk  
         * 
         */

    }, {
        key: "decodeShort",
        value: function decodeShort(chunk) {
            var _this6 = this;

            console.log(chunk);

            return new Promise(function (done, rej) {
                fetch("https://www.googleapis.com/urlshortener/v1/url?key=" + _this6.api_key + "&shortUrl=https://goo.gl/" + chunk).then(function (res) {
                    return res.json();
                }).then(function (res) {
                    var longUrl = res.longUrl;
                    var urlCode = longUrl.replace(_this6.domain, "");

                    return done(urlCode);
                }).catch(function (err) {
                    return rej(err);
                });
            });
        }

        /**
         * 
         * Gets Parameter from URL
         * 
         * @param {*} name - parameter name
         * @param {*} url  - Domain URL
         * 
         */

    }, {
        key: "getParameterByName",
        value: function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }
    }]);

    return UrlEncoder;
}();

/* harmony default export */ __webpack_exports__["a"] = (UrlEncoder);

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = ArrayCollisionMatrix;

/**
 * Collision "matrix". It's actually a triangular-shaped array of whether two bodies are touching this step, for reference next step
 * @class ArrayCollisionMatrix
 * @constructor
 */
function ArrayCollisionMatrix() {

    /**
     * The matrix storage
     * @property matrix
     * @type {Array}
     */
    this.matrix = [];
}

/**
 * Get an element
 * @method get
 * @param  {Number} i
 * @param  {Number} j
 * @return {Number}
 */
ArrayCollisionMatrix.prototype.get = function(i, j) {
    i = i.index;
    j = j.index;
    if (j > i) {
        var temp = j;
        j = i;
        i = temp;
    }
    return this.matrix[(i*(i + 1)>>1) + j-1];
};

/**
 * Set an element
 * @method set
 * @param {Number} i
 * @param {Number} j
 * @param {Number} value
 */
ArrayCollisionMatrix.prototype.set = function(i, j, value) {
    i = i.index;
    j = j.index;
    if (j > i) {
        var temp = j;
        j = i;
        i = temp;
    }
    this.matrix[(i*(i + 1)>>1) + j-1] = value ? 1 : 0;
};

/**
 * Sets all elements to zero
 * @method reset
 */
ArrayCollisionMatrix.prototype.reset = function() {
    for (var i=0, l=this.matrix.length; i!==l; i++) {
        this.matrix[i]=0;
    }
};

/**
 * Sets the max number of objects
 * @method setNumObjects
 * @param {Number} n
 */
ArrayCollisionMatrix.prototype.setNumObjects = function(n) {
    this.matrix.length = n*(n-1)>>1;
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = NaiveBroadphase;

var Broadphase = __webpack_require__(69);
var AABB = __webpack_require__(30);

/**
 * Naive broadphase implementation, used in lack of better ones.
 * @class NaiveBroadphase
 * @constructor
 * @description The naive broadphase looks at all possible pairs without restriction, therefore it has complexity N^2 (which is bad)
 * @extends Broadphase
 */
function NaiveBroadphase(){
    Broadphase.apply(this);
}
NaiveBroadphase.prototype = new Broadphase();
NaiveBroadphase.prototype.constructor = NaiveBroadphase;

/**
 * Get all the collision pairs in the physics world
 * @method collisionPairs
 * @param {World} world
 * @param {Array} pairs1
 * @param {Array} pairs2
 */
NaiveBroadphase.prototype.collisionPairs = function(world,pairs1,pairs2){
    var bodies = world.bodies,
        n = bodies.length,
        i,j,bi,bj;

    // Naive N^2 ftw!
    for(i=0; i!==n; i++){
        for(j=0; j!==i; j++){

            bi = bodies[i];
            bj = bodies[j];

            if(!this.needBroadphaseCollision(bi,bj)){
                continue;
            }

            this.intersectionTest(bi,bj,pairs1,pairs2);
        }
    }
};

var tmpAABB = new AABB();

/**
 * Returns all the bodies within an AABB.
 * @method aabbQuery
 * @param  {World} world
 * @param  {AABB} aabb
 * @param {array} result An array to store resulting bodies in.
 * @return {array}
 */
NaiveBroadphase.prototype.aabbQuery = function(world, aabb, result){
    result = result || [];

    for(var i = 0; i < world.bodies.length; i++){
        var b = world.bodies[i];

        if(b.aabbNeedsUpdate){
            b.computeAABB();
        }

        // Ugly hack until Body gets aabb
        if(b.aabb.overlaps(aabb)){
            result.push(b);
        }
    }

    return result;
};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = HingeConstraint;

var Constraint = __webpack_require__(44);
var PointToPointConstraint = __webpack_require__(71);
var RotationalEquation = __webpack_require__(72);
var RotationalMotorEquation = __webpack_require__(100);
var ContactEquation = __webpack_require__(31);
var Vec3 = __webpack_require__(0);

/**
 * Hinge constraint. Think of it as a door hinge. It tries to keep the door in the correct place and with the correct orientation.
 * @class HingeConstraint
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {object} [options]
 * @param {Vec3} [options.pivotA] A point defined locally in bodyA. This defines the offset of axisA.
 * @param {Vec3} [options.axisA] An axis that bodyA can rotate around, defined locally in bodyA.
 * @param {Vec3} [options.pivotB]
 * @param {Vec3} [options.axisB]
 * @param {Number} [options.maxForce=1e6]
 * @extends PointToPointConstraint
 */
function HingeConstraint(bodyA, bodyB, options){
    options = options || {};
    var maxForce = typeof(options.maxForce) !== 'undefined' ? options.maxForce : 1e6;
    var pivotA = options.pivotA ? options.pivotA.clone() : new Vec3();
    var pivotB = options.pivotB ? options.pivotB.clone() : new Vec3();

    PointToPointConstraint.call(this, bodyA, pivotA, bodyB, pivotB, maxForce);

    /**
     * Rotation axis, defined locally in bodyA.
     * @property {Vec3} axisA
     */
    var axisA = this.axisA = options.axisA ? options.axisA.clone() : new Vec3(1,0,0);
    axisA.normalize();

    /**
     * Rotation axis, defined locally in bodyB.
     * @property {Vec3} axisB
     */
    var axisB = this.axisB = options.axisB ? options.axisB.clone() : new Vec3(1,0,0);
    axisB.normalize();

    /**
     * @property {RotationalEquation} rotationalEquation1
     */
    var r1 = this.rotationalEquation1 = new RotationalEquation(bodyA,bodyB,options);

    /**
     * @property {RotationalEquation} rotationalEquation2
     */
    var r2 = this.rotationalEquation2 = new RotationalEquation(bodyA,bodyB,options);

    /**
     * @property {RotationalMotorEquation} motorEquation
     */
    var motor = this.motorEquation = new RotationalMotorEquation(bodyA,bodyB,maxForce);
    motor.enabled = false; // Not enabled by default

    // Equations to be fed to the solver
    this.equations.push(
        r1, // rotational1
        r2, // rotational2
        motor
    );
}
HingeConstraint.prototype = new PointToPointConstraint();
HingeConstraint.constructor = HingeConstraint;

/**
 * @method enableMotor
 */
HingeConstraint.prototype.enableMotor = function(){
    this.motorEquation.enabled = true;
};

/**
 * @method disableMotor
 */
HingeConstraint.prototype.disableMotor = function(){
    this.motorEquation.enabled = false;
};

/**
 * @method setMotorSpeed
 * @param {number} speed
 */
HingeConstraint.prototype.setMotorSpeed = function(speed){
    this.motorEquation.targetVelocity = speed;
};

/**
 * @method setMotorMaxForce
 * @param {number} maxForce
 */
HingeConstraint.prototype.setMotorMaxForce = function(maxForce){
    this.motorEquation.maxForce = maxForce;
    this.motorEquation.minForce = -maxForce;
};

var HingeConstraint_update_tmpVec1 = new Vec3();
var HingeConstraint_update_tmpVec2 = new Vec3();

HingeConstraint.prototype.update = function(){
    var bodyA = this.bodyA,
        bodyB = this.bodyB,
        motor = this.motorEquation,
        r1 = this.rotationalEquation1,
        r2 = this.rotationalEquation2,
        worldAxisA = HingeConstraint_update_tmpVec1,
        worldAxisB = HingeConstraint_update_tmpVec2;

    var axisA = this.axisA;
    var axisB = this.axisB;

    PointToPointConstraint.prototype.update.call(this);

    // Get world axes
    bodyA.quaternion.vmult(axisA, worldAxisA);
    bodyB.quaternion.vmult(axisB, worldAxisB);

    worldAxisA.tangents(r1.axisA, r2.axisA);
    r1.axisB.copy(worldAxisB);
    r2.axisB.copy(worldAxisB);

    if(this.motorEquation.enabled){
        bodyA.quaternion.vmult(this.axisA, motor.axisA);
        bodyB.quaternion.vmult(this.axisB, motor.axisB);
    }
};



/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Utils = __webpack_require__(60);

module.exports = ContactMaterial;

/**
 * Defines what happens when two materials meet.
 * @class ContactMaterial
 * @constructor
 * @param {Material} m1
 * @param {Material} m2
 * @param {object} [options]
 * @param {Number} [options.friction=0.3]
 * @param {Number} [options.restitution=0.3]
 * @param {number} [options.contactEquationStiffness=1e7]
 * @param {number} [options.contactEquationRelaxation=3]
 * @param {number} [options.frictionEquationStiffness=1e7]
 * @param {Number} [options.frictionEquationRelaxation=3]
 */
function ContactMaterial(m1, m2, options){
    options = Utils.defaults(options, {
        friction: 0.3,
        restitution: 0.3,
        contactEquationStiffness: 1e7,
        contactEquationRelaxation: 3,
        frictionEquationStiffness: 1e7,
        frictionEquationRelaxation: 3
    });

    /**
     * Identifier of this material
     * @property {Number} id
     */
    this.id = ContactMaterial.idCounter++;

    /**
     * Participating materials
     * @property {Array} materials
     * @todo  Should be .materialA and .materialB instead
     */
    this.materials = [m1, m2];

    /**
     * Friction coefficient
     * @property {Number} friction
     */
    this.friction = options.friction;

    /**
     * Restitution coefficient
     * @property {Number} restitution
     */
    this.restitution = options.restitution;

    /**
     * Stiffness of the produced contact equations
     * @property {Number} contactEquationStiffness
     */
    this.contactEquationStiffness = options.contactEquationStiffness;

    /**
     * Relaxation time of the produced contact equations
     * @property {Number} contactEquationRelaxation
     */
    this.contactEquationRelaxation = options.contactEquationRelaxation;

    /**
     * Stiffness of the produced friction equations
     * @property {Number} frictionEquationStiffness
     */
    this.frictionEquationStiffness = options.frictionEquationStiffness;

    /**
     * Relaxation time of the produced friction equations
     * @property {Number} frictionEquationRelaxation
     */
    this.frictionEquationRelaxation = options.frictionEquationRelaxation;
}

ContactMaterial.idCounter = 0;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Particle;

var Shape = __webpack_require__(12);
var Vec3 = __webpack_require__(0);

/**
 * Particle shape.
 * @class Particle
 * @constructor
 * @author schteppe
 * @extends Shape
 */
function Particle(){
    Shape.call(this);

    this.type = Shape.types.PARTICLE;
}
Particle.prototype = new Shape();
Particle.prototype.constructor = Particle;

/**
 * @method calculateLocalInertia
 * @param  {Number} mass
 * @param  {Vec3} target
 * @return {Vec3}
 */
Particle.prototype.calculateLocalInertia = function(mass,target){
    target = target || new Vec3();
    target.set(0, 0, 0);
    return target;
};

Particle.prototype.volume = function(){
    return 0;
};

Particle.prototype.updateBoundingSphereRadius = function(){
    this.boundingSphereRadius = 0;
};

Particle.prototype.calculateWorldAABB = function(pos,quat,min,max){
    // Get each axis max
    min.copy(pos);
    max.copy(pos);
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Plane;

var Shape = __webpack_require__(12);
var Vec3 = __webpack_require__(0);

/**
 * A plane, facing in the Z direction. The plane has its surface at z=0 and everything below z=0 is assumed to be solid plane. To make the plane face in some other direction than z, you must put it inside a RigidBody and rotate that body. See the demos.
 * @class Plane
 * @constructor
 * @extends Shape
 * @author schteppe
 */
function Plane(){
    Shape.call(this);
    this.type = Shape.types.PLANE;

    // World oriented normal
    this.worldNormal = new Vec3();
    this.worldNormalNeedsUpdate = true;

    this.boundingSphereRadius = Number.MAX_VALUE;
}
Plane.prototype = new Shape();
Plane.prototype.constructor = Plane;

Plane.prototype.computeWorldNormal = function(quat){
    var n = this.worldNormal;
    n.set(0,0,1);
    quat.vmult(n,n);
    this.worldNormalNeedsUpdate = false;
};

Plane.prototype.calculateLocalInertia = function(mass,target){
    target = target || new Vec3();
    return target;
};

Plane.prototype.volume = function(){
    return Number.MAX_VALUE; // The plane is infinite...
};

var tempNormal = new Vec3();
Plane.prototype.calculateWorldAABB = function(pos, quat, min, max){
    // The plane AABB is infinite, except if the normal is pointing along any axis
    tempNormal.set(0,0,1); // Default plane normal is z
    quat.vmult(tempNormal,tempNormal);
    var maxVal = Number.MAX_VALUE;
    min.set(-maxVal, -maxVal, -maxVal);
    max.set(maxVal, maxVal, maxVal);

    if(tempNormal.x === 1){ max.x = pos.x; }
    if(tempNormal.y === 1){ max.y = pos.y; }
    if(tempNormal.z === 1){ max.z = pos.z; }

    if(tempNormal.x === -1){ min.x = pos.x; }
    if(tempNormal.y === -1){ min.y = pos.y; }
    if(tempNormal.z === -1){ min.z = pos.z; }
};

Plane.prototype.updateBoundingSphereRadius = function(){
    this.boundingSphereRadius = Number.MAX_VALUE;
};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Sphere;

var Shape = __webpack_require__(12);
var Vec3 = __webpack_require__(0);

/**
 * Spherical shape
 * @class Sphere
 * @constructor
 * @extends Shape
 * @param {Number} radius The radius of the sphere, a non-negative number.
 * @author schteppe / http://github.com/schteppe
 */
function Sphere(radius){
    Shape.call(this);

    /**
     * @property {Number} radius
     */
    this.radius = radius!==undefined ? Number(radius) : 1.0;
    this.type = Shape.types.SPHERE;

    if(this.radius < 0){
        throw new Error('The sphere radius cannot be negative.');
    }

    this.updateBoundingSphereRadius();
}
Sphere.prototype = new Shape();
Sphere.prototype.constructor = Sphere;

Sphere.prototype.calculateLocalInertia = function(mass,target){
    target = target || new Vec3();
    var I = 2.0*mass*this.radius*this.radius/5.0;
    target.x = I;
    target.y = I;
    target.z = I;
    return target;
};

Sphere.prototype.volume = function(){
    return 4.0 * Math.PI * this.radius / 3.0;
};

Sphere.prototype.updateBoundingSphereRadius = function(){
    this.boundingSphereRadius = this.radius;
};

Sphere.prototype.calculateWorldAABB = function(pos,quat,min,max){
    var r = this.radius;
    var axes = ['x','y','z'];
    for(var i=0; i<axes.length; i++){
        var ax = axes[i];
        min[ax] = pos[ax] - r;
        max[ax] = pos[ax] + r;
    }
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = GSSolver;

var Vec3 = __webpack_require__(0);
var Quaternion = __webpack_require__(13);
var Solver = __webpack_require__(74);

/**
 * Constraint equation Gauss-Seidel solver.
 * @class GSSolver
 * @constructor
 * @todo The spook parameters should be specified for each constraint, not globally.
 * @author schteppe / https://github.com/schteppe
 * @see https://www8.cs.umu.se/kurser/5DV058/VT09/lectures/spooknotes.pdf
 * @extends Solver
 */
function GSSolver(){
    Solver.call(this);

    /**
     * The number of solver iterations determines quality of the constraints in the world. The more iterations, the more correct simulation. More iterations need more computations though. If you have a large gravity force in your world, you will need more iterations.
     * @property iterations
     * @type {Number}
     * @todo write more about solver and iterations in the wiki
     */
    this.iterations = 10;

    /**
     * When tolerance is reached, the system is assumed to be converged.
     * @property tolerance
     * @type {Number}
     */
    this.tolerance = 1e-7;
}
GSSolver.prototype = new Solver();

var GSSolver_solve_lambda = []; // Just temporary number holders that we want to reuse each solve.
var GSSolver_solve_invCs = [];
var GSSolver_solve_Bs = [];
GSSolver.prototype.solve = function(dt,world){
    var iter = 0,
        maxIter = this.iterations,
        tolSquared = this.tolerance*this.tolerance,
        equations = this.equations,
        Neq = equations.length,
        bodies = world.bodies,
        Nbodies = bodies.length,
        h = dt,
        q, B, invC, deltalambda, deltalambdaTot, GWlambda, lambdaj;

    // Update solve mass
    if(Neq !== 0){
        for(var i=0; i!==Nbodies; i++){
            bodies[i].updateSolveMassProperties();
        }
    }

    // Things that does not change during iteration can be computed once
    var invCs = GSSolver_solve_invCs,
        Bs = GSSolver_solve_Bs,
        lambda = GSSolver_solve_lambda;
    invCs.length = Neq;
    Bs.length = Neq;
    lambda.length = Neq;
    for(var i=0; i!==Neq; i++){
        var c = equations[i];
        lambda[i] = 0.0;
        Bs[i] = c.computeB(h);
        invCs[i] = 1.0 / c.computeC();
    }

    if(Neq !== 0){

        // Reset vlambda
        for(var i=0; i!==Nbodies; i++){
            var b=bodies[i],
                vlambda=b.vlambda,
                wlambda=b.wlambda;
            vlambda.set(0,0,0);
            wlambda.set(0,0,0);
        }

        // Iterate over equations
        for(iter=0; iter!==maxIter; iter++){

            // Accumulate the total error for each iteration.
            deltalambdaTot = 0.0;

            for(var j=0; j!==Neq; j++){

                var c = equations[j];

                // Compute iteration
                B = Bs[j];
                invC = invCs[j];
                lambdaj = lambda[j];
                GWlambda = c.computeGWlambda();
                deltalambda = invC * ( B - GWlambda - c.eps * lambdaj );

                // Clamp if we are not within the min/max interval
                if(lambdaj + deltalambda < c.minForce){
                    deltalambda = c.minForce - lambdaj;
                } else if(lambdaj + deltalambda > c.maxForce){
                    deltalambda = c.maxForce - lambdaj;
                }
                lambda[j] += deltalambda;

                deltalambdaTot += deltalambda > 0.0 ? deltalambda : -deltalambda; // abs(deltalambda)

                c.addToWlambda(deltalambda);
            }

            // If the total error is small enough - stop iterate
            if(deltalambdaTot*deltalambdaTot < tolSquared){
                break;
            }
        }

        // Add result to velocity
        for(var i=0; i!==Nbodies; i++){
            var b=bodies[i],
                v=b.velocity,
                w=b.angularVelocity;

            b.vlambda.vmul(b.linearFactor, b.vlambda);
            v.vadd(b.vlambda, v);

            b.wlambda.vmul(b.angularFactor, b.wlambda);
            w.vadd(b.wlambda, w);
        }

        // Set the .multiplier property of each equation
        var l = equations.length;
        var invDt = 1 / h;
        while(l--){
            equations[l].multiplier = lambda[l] * invDt;
        }
    }

    return iter;
};


/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = Pool;

/**
 * For pooling objects that can be reused.
 * @class Pool
 * @constructor
 */
function Pool(){
    /**
     * The pooled objects
     * @property {Array} objects
     */
    this.objects = [];

    /**
     * Constructor of the objects
     * @property {mixed} type
     */
    this.type = Object;
}

/**
 * Release an object after use
 * @method release
 * @param {Object} obj
 */
Pool.prototype.release = function(){
    var Nargs = arguments.length;
    for(var i=0; i!==Nargs; i++){
        this.objects.push(arguments[i]);
    }
    return this;
};

/**
 * Get an object
 * @method get
 * @return {mixed}
 */
Pool.prototype.get = function(){
    if(this.objects.length===0){
        return this.constructObject();
    } else {
        return this.objects.pop();
    }
};

/**
 * Construct an object. Should be implmented in each subclass.
 * @method constructObject
 * @return {mixed}
 */
Pool.prototype.constructObject = function(){
    throw new Error("constructObject() not implemented in this Pool subclass yet!");
};

/**
 * @method resize
 * @param {number} size
 * @return {Pool} Self, for chaining
 */
Pool.prototype.resize = function (size) {
    var objects = this.objects;

    while (objects.length > size) {
        objects.pop();
    }

    while (objects.length < size) {
        objects.push(this.constructObject());
    }

    return this;
};



/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Vec3Pool;

var Vec3 = __webpack_require__(0);
var Pool = __webpack_require__(150);

/**
 * @class Vec3Pool
 * @constructor
 * @extends Pool
 */
function Vec3Pool(){
    Pool.call(this);
    this.type = Vec3;
}
Vec3Pool.prototype = new Pool();

/**
 * Construct a vector
 * @method constructObject
 * @return {Vec3}
 */
Vec3Pool.prototype.constructObject = function(){
    return new Vec3();
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Narrowphase;

var AABB = __webpack_require__(30);
var Body = __webpack_require__(33);
var Shape = __webpack_require__(12);
var Ray = __webpack_require__(70);
var Vec3 = __webpack_require__(0);
var Transform = __webpack_require__(46);
var ConvexPolyhedron = __webpack_require__(47);
var Quaternion = __webpack_require__(13);
var Solver = __webpack_require__(74);
var Vec3Pool = __webpack_require__(151);
var ContactEquation = __webpack_require__(31);
var FrictionEquation = __webpack_require__(99);

/**
 * Helper class for the World. Generates ContactEquations.
 * @class Narrowphase
 * @constructor
 * @todo Sphere-ConvexPolyhedron contacts
 * @todo Contact reduction
 * @todo  should move methods to prototype
 */
function Narrowphase(world){

    /**
     * Internal storage of pooled contact points.
     * @property {Array} contactPointPool
     */
    this.contactPointPool = [];

    this.frictionEquationPool = [];

    this.result = [];
    this.frictionResult = [];

    /**
     * Pooled vectors.
     * @property {Vec3Pool} v3pool
     */
    this.v3pool = new Vec3Pool();

    this.world = world;
    this.currentContactMaterial = null;

    /**
     * @property {Boolean} enableFrictionReduction
     */
    this.enableFrictionReduction = false;
}

/**
 * Make a contact object, by using the internal pool or creating a new one.
 * @method createContactEquation
 * @param {Body} bi
 * @param {Body} bj
 * @param {Shape} si
 * @param {Shape} sj
 * @param {Shape} overrideShapeA
 * @param {Shape} overrideShapeB
 * @return {ContactEquation}
 */
Narrowphase.prototype.createContactEquation = function(bi, bj, si, sj, overrideShapeA, overrideShapeB){
    var c;
    if(this.contactPointPool.length){
        c = this.contactPointPool.pop();
        c.bi = bi;
        c.bj = bj;
    } else {
        c = new ContactEquation(bi, bj);
    }

    c.enabled = bi.collisionResponse && bj.collisionResponse && si.collisionResponse && sj.collisionResponse;

    var cm = this.currentContactMaterial;

    c.restitution = cm.restitution;

    c.setSpookParams(
        cm.contactEquationStiffness,
        cm.contactEquationRelaxation,
        this.world.dt
    );

    var matA = si.material || bi.material;
    var matB = sj.material || bj.material;
    if(matA && matB && matA.restitution >= 0 && matB.restitution >= 0){
        c.restitution = matA.restitution * matB.restitution;
    }

    c.si = overrideShapeA || si;
    c.sj = overrideShapeB || sj;

    return c;
};

Narrowphase.prototype.createFrictionEquationsFromContact = function(contactEquation, outArray){
    var bodyA = contactEquation.bi;
    var bodyB = contactEquation.bj;
    var shapeA = contactEquation.si;
    var shapeB = contactEquation.sj;

    var world = this.world;
    var cm = this.currentContactMaterial;

    // If friction or restitution were specified in the material, use them
    var friction = cm.friction;
    var matA = shapeA.material || bodyA.material;
    var matB = shapeB.material || bodyB.material;
    if(matA && matB && matA.friction >= 0 && matB.friction >= 0){
        friction = matA.friction * matB.friction;
    }

    if(friction > 0){

        // Create 2 tangent equations
        var mug = friction * world.gravity.length();
        var reducedMass = (bodyA.invMass + bodyB.invMass);
        if(reducedMass > 0){
            reducedMass = 1/reducedMass;
        }
        var pool = this.frictionEquationPool;
        var c1 = pool.length ? pool.pop() : new FrictionEquation(bodyA,bodyB,mug*reducedMass);
        var c2 = pool.length ? pool.pop() : new FrictionEquation(bodyA,bodyB,mug*reducedMass);

        c1.bi = c2.bi = bodyA;
        c1.bj = c2.bj = bodyB;
        c1.minForce = c2.minForce = -mug*reducedMass;
        c1.maxForce = c2.maxForce = mug*reducedMass;

        // Copy over the relative vectors
        c1.ri.copy(contactEquation.ri);
        c1.rj.copy(contactEquation.rj);
        c2.ri.copy(contactEquation.ri);
        c2.rj.copy(contactEquation.rj);

        // Construct tangents
        contactEquation.ni.tangents(c1.t, c2.t);

        // Set spook params
        c1.setSpookParams(cm.frictionEquationStiffness, cm.frictionEquationRelaxation, world.dt);
        c2.setSpookParams(cm.frictionEquationStiffness, cm.frictionEquationRelaxation, world.dt);

        c1.enabled = c2.enabled = contactEquation.enabled;

        outArray.push(c1, c2);

        return true;
    }

    return false;
};

var averageNormal = new Vec3();
var averageContactPointA = new Vec3();
var averageContactPointB = new Vec3();

// Take the average N latest contact point on the plane.
Narrowphase.prototype.createFrictionFromAverage = function(numContacts){
    // The last contactEquation
    var c = this.result[this.result.length - 1];

    // Create the result: two "average" friction equations
    if (!this.createFrictionEquationsFromContact(c, this.frictionResult) || numContacts === 1) {
        return;
    }

    var f1 = this.frictionResult[this.frictionResult.length - 2];
    var f2 = this.frictionResult[this.frictionResult.length - 1];

    averageNormal.setZero();
    averageContactPointA.setZero();
    averageContactPointB.setZero();

    var bodyA = c.bi;
    var bodyB = c.bj;
    for(var i=0; i!==numContacts; i++){
        c = this.result[this.result.length - 1 - i];
        if(c.bodyA !== bodyA){
            averageNormal.vadd(c.ni, averageNormal);
            averageContactPointA.vadd(c.ri, averageContactPointA);
            averageContactPointB.vadd(c.rj, averageContactPointB);
        } else {
            averageNormal.vsub(c.ni, averageNormal);
            averageContactPointA.vadd(c.rj, averageContactPointA);
            averageContactPointB.vadd(c.ri, averageContactPointB);
        }
    }

    var invNumContacts = 1 / numContacts;
    averageContactPointA.scale(invNumContacts, f1.ri);
    averageContactPointB.scale(invNumContacts, f1.rj);
    f2.ri.copy(f1.ri); // Should be the same
    f2.rj.copy(f1.rj);
    averageNormal.normalize();
    averageNormal.tangents(f1.t, f2.t);
    // return eq;
};


var tmpVec1 = new Vec3();
var tmpVec2 = new Vec3();
var tmpQuat1 = new Quaternion();
var tmpQuat2 = new Quaternion();

/**
 * Generate all contacts between a list of body pairs
 * @method getContacts
 * @param {array} p1 Array of body indices
 * @param {array} p2 Array of body indices
 * @param {World} world
 * @param {array} result Array to store generated contacts
 * @param {array} oldcontacts Optional. Array of reusable contact objects
 */
Narrowphase.prototype.getContacts = function(p1, p2, world, result, oldcontacts, frictionResult, frictionPool){
    // Save old contact objects
    this.contactPointPool = oldcontacts;
    this.frictionEquationPool = frictionPool;
    this.result = result;
    this.frictionResult = frictionResult;

    var qi = tmpQuat1;
    var qj = tmpQuat2;
    var xi = tmpVec1;
    var xj = tmpVec2;

    for(var k=0, N=p1.length; k!==N; k++){

        // Get current collision bodies
        var bi = p1[k],
            bj = p2[k];

        // Get contact material
        var bodyContactMaterial = null;
        if(bi.material && bj.material){
            bodyContactMaterial = world.getContactMaterial(bi.material,bj.material) || null;
        }

        var justTest = (
            (
                (bi.type & Body.KINEMATIC) && (bj.type & Body.STATIC)
            ) || (
                (bi.type & Body.STATIC) && (bj.type & Body.KINEMATIC)
            ) || (
                (bi.type & Body.KINEMATIC) && (bj.type & Body.KINEMATIC)
            )
        );

        for (var i = 0; i < bi.shapes.length; i++) {
            bi.quaternion.mult(bi.shapeOrientations[i], qi);
            bi.quaternion.vmult(bi.shapeOffsets[i], xi);
            xi.vadd(bi.position, xi);
            var si = bi.shapes[i];

            for (var j = 0; j < bj.shapes.length; j++) {

                // Compute world transform of shapes
                bj.quaternion.mult(bj.shapeOrientations[j], qj);
                bj.quaternion.vmult(bj.shapeOffsets[j], xj);
                xj.vadd(bj.position, xj);
                var sj = bj.shapes[j];

                if(xi.distanceTo(xj) > si.boundingSphereRadius + sj.boundingSphereRadius){
                    continue;
                }

                // Get collision material
                var shapeContactMaterial = null;
                if(si.material && sj.material){
                    shapeContactMaterial = world.getContactMaterial(si.material,sj.material) || null;
                }

                this.currentContactMaterial = shapeContactMaterial || bodyContactMaterial || world.defaultContactMaterial;

                // Get contacts
                var resolver = this[si.type | sj.type];
                if(resolver){
                    var retval = false;
                    if (si.type < sj.type) {
                        retval = resolver.call(this, si, sj, xi, xj, qi, qj, bi, bj, si, sj, justTest);
                    } else {
                        retval = resolver.call(this, sj, si, xj, xi, qj, qi, bj, bi, si, sj, justTest);
                    }

                    if(retval && justTest){
                        // Register overlap
                        world.shapeOverlapKeeper.set(si.id, sj.id);
                        world.bodyOverlapKeeper.set(bi.id, bj.id);
                    }
                }
            }
        }
    }
};

var numWarnings = 0;
var maxWarnings = 10;

function warn(msg){
    if(numWarnings > maxWarnings){
        return;
    }

    numWarnings++;

    console.warn(msg);
}

Narrowphase.prototype[Shape.types.BOX | Shape.types.BOX] =
Narrowphase.prototype.boxBox = function(si,sj,xi,xj,qi,qj,bi,bj,rsi,rsj,justTest){
    si.convexPolyhedronRepresentation.material = si.material;
    sj.convexPolyhedronRepresentation.material = sj.material;
    si.convexPolyhedronRepresentation.collisionResponse = si.collisionResponse;
    sj.convexPolyhedronRepresentation.collisionResponse = sj.collisionResponse;
    return this.convexConvex(si.convexPolyhedronRepresentation,sj.convexPolyhedronRepresentation,xi,xj,qi,qj,bi,bj,si,sj,justTest);
};

Narrowphase.prototype[Shape.types.BOX | Shape.types.CONVEXPOLYHEDRON] =
Narrowphase.prototype.boxConvex = function(si,sj,xi,xj,qi,qj,bi,bj,rsi,rsj,justTest){
    si.convexPolyhedronRepresentation.material = si.material;
    si.convexPolyhedronRepresentation.collisionResponse = si.collisionResponse;
    return this.convexConvex(si.convexPolyhedronRepresentation,sj,xi,xj,qi,qj,bi,bj,si,sj,justTest);
};

Narrowphase.prototype[Shape.types.BOX | Shape.types.PARTICLE] =
Narrowphase.prototype.boxParticle = function(si,sj,xi,xj,qi,qj,bi,bj,rsi,rsj,justTest){
    si.convexPolyhedronRepresentation.material = si.material;
    si.convexPolyhedronRepresentation.collisionResponse = si.collisionResponse;
    return this.convexParticle(si.convexPolyhedronRepresentation,sj,xi,xj,qi,qj,bi,bj,si,sj,justTest);
};

/**
 * @method sphereSphere
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
Narrowphase.prototype[Shape.types.SPHERE] =
Narrowphase.prototype.sphereSphere = function(si,sj,xi,xj,qi,qj,bi,bj,rsi,rsj,justTest){
    if(justTest){
        return xi.distanceSquared(xj) < Math.pow(si.radius + sj.radius, 2);
    }

    // We will have only one contact in this case
    var r = this.createContactEquation(bi,bj,si,sj,rsi,rsj);

    // Contact normal
    xj.vsub(xi, r.ni);
    r.ni.normalize();

    // Contact point locations
    r.ri.copy(r.ni);
    r.rj.copy(r.ni);
    r.ri.mult(si.radius, r.ri);
    r.rj.mult(-sj.radius, r.rj);

    r.ri.vadd(xi, r.ri);
    r.ri.vsub(bi.position, r.ri);

    r.rj.vadd(xj, r.rj);
    r.rj.vsub(bj.position, r.rj);

    this.result.push(r);

    this.createFrictionEquationsFromContact(r, this.frictionResult);
};

/**
 * @method planeTrimesh
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
var planeTrimesh_normal = new Vec3();
var planeTrimesh_relpos = new Vec3();
var planeTrimesh_projected = new Vec3();
Narrowphase.prototype[Shape.types.PLANE | Shape.types.TRIMESH] =
Narrowphase.prototype.planeTrimesh = function(
    planeShape,
    trimeshShape,
    planePos,
    trimeshPos,
    planeQuat,
    trimeshQuat,
    planeBody,
    trimeshBody,
    rsi,
    rsj,
    justTest
){
    // Make contacts!
    var v = new Vec3();

    var normal = planeTrimesh_normal;
    normal.set(0,0,1);
    planeQuat.vmult(normal,normal); // Turn normal according to plane

    for(var i=0; i<trimeshShape.vertices.length / 3; i++){

        // Get world vertex from trimesh
        trimeshShape.getVertex(i, v);

        // Safe up
        var v2 = new Vec3();
        v2.copy(v);
        Transform.pointToWorldFrame(trimeshPos, trimeshQuat, v2, v);

        // Check plane side
        var relpos = planeTrimesh_relpos;
        v.vsub(planePos, relpos);
        var dot = normal.dot(relpos);

        if(dot <= 0.0){
            if(justTest){
                return true;
            }

            var r = this.createContactEquation(planeBody,trimeshBody,planeShape,trimeshShape,rsi,rsj);

            r.ni.copy(normal); // Contact normal is the plane normal

            // Get vertex position projected on plane
            var projected = planeTrimesh_projected;
            normal.scale(relpos.dot(normal), projected);
            v.vsub(projected,projected);

            // ri is the projected world position minus plane position
            r.ri.copy(projected);
            r.ri.vsub(planeBody.position, r.ri);

            r.rj.copy(v);
            r.rj.vsub(trimeshBody.position, r.rj);

            // Store result
            this.result.push(r);
            this.createFrictionEquationsFromContact(r, this.frictionResult);
        }
    }
};

/**
 * @method sphereTrimesh
 * @param  {Shape}      sphereShape
 * @param  {Shape}      trimeshShape
 * @param  {Vec3}       spherePos
 * @param  {Vec3}       trimeshPos
 * @param  {Quaternion} sphereQuat
 * @param  {Quaternion} trimeshQuat
 * @param  {Body}       sphereBody
 * @param  {Body}       trimeshBody
 */
var sphereTrimesh_normal = new Vec3();
var sphereTrimesh_relpos = new Vec3();
var sphereTrimesh_projected = new Vec3();
var sphereTrimesh_v = new Vec3();
var sphereTrimesh_v2 = new Vec3();
var sphereTrimesh_edgeVertexA = new Vec3();
var sphereTrimesh_edgeVertexB = new Vec3();
var sphereTrimesh_edgeVector = new Vec3();
var sphereTrimesh_edgeVectorUnit = new Vec3();
var sphereTrimesh_localSpherePos = new Vec3();
var sphereTrimesh_tmp = new Vec3();
var sphereTrimesh_va = new Vec3();
var sphereTrimesh_vb = new Vec3();
var sphereTrimesh_vc = new Vec3();
var sphereTrimesh_localSphereAABB = new AABB();
var sphereTrimesh_triangles = [];
Narrowphase.prototype[Shape.types.SPHERE | Shape.types.TRIMESH] =
Narrowphase.prototype.sphereTrimesh = function (
    sphereShape,
    trimeshShape,
    spherePos,
    trimeshPos,
    sphereQuat,
    trimeshQuat,
    sphereBody,
    trimeshBody,
    rsi,
    rsj,
    justTest
) {

    var edgeVertexA = sphereTrimesh_edgeVertexA;
    var edgeVertexB = sphereTrimesh_edgeVertexB;
    var edgeVector = sphereTrimesh_edgeVector;
    var edgeVectorUnit = sphereTrimesh_edgeVectorUnit;
    var localSpherePos = sphereTrimesh_localSpherePos;
    var tmp = sphereTrimesh_tmp;
    var localSphereAABB = sphereTrimesh_localSphereAABB;
    var v2 = sphereTrimesh_v2;
    var relpos = sphereTrimesh_relpos;
    var triangles = sphereTrimesh_triangles;

    // Convert sphere position to local in the trimesh
    Transform.pointToLocalFrame(trimeshPos, trimeshQuat, spherePos, localSpherePos);

    // Get the aabb of the sphere locally in the trimesh
    var sphereRadius = sphereShape.radius;
    localSphereAABB.lowerBound.set(
        localSpherePos.x - sphereRadius,
        localSpherePos.y - sphereRadius,
        localSpherePos.z - sphereRadius
    );
    localSphereAABB.upperBound.set(
        localSpherePos.x + sphereRadius,
        localSpherePos.y + sphereRadius,
        localSpherePos.z + sphereRadius
    );

    trimeshShape.getTrianglesInAABB(localSphereAABB, triangles);
    //for (var i = 0; i < trimeshShape.indices.length / 3; i++) triangles.push(i); // All

    // Vertices
    var v = sphereTrimesh_v;
    var radiusSquared = sphereShape.radius * sphereShape.radius;
    for(var i=0; i<triangles.length; i++){
        for (var j = 0; j < 3; j++) {

            trimeshShape.getVertex(trimeshShape.indices[triangles[i] * 3 + j], v);

            // Check vertex overlap in sphere
            v.vsub(localSpherePos, relpos);

            if(relpos.norm2() <= radiusSquared){

                // Safe up
                v2.copy(v);
                Transform.pointToWorldFrame(trimeshPos, trimeshQuat, v2, v);

                v.vsub(spherePos, relpos);

                if(justTest){
                    return true;
                }

                var r = this.createContactEquation(sphereBody,trimeshBody,sphereShape,trimeshShape,rsi,rsj);
                r.ni.copy(relpos);
                r.ni.normalize();

                // ri is the vector from sphere center to the sphere surface
                r.ri.copy(r.ni);
                r.ri.scale(sphereShape.radius, r.ri);
                r.ri.vadd(spherePos, r.ri);
                r.ri.vsub(sphereBody.position, r.ri);

                r.rj.copy(v);
                r.rj.vsub(trimeshBody.position, r.rj);

                // Store result
                this.result.push(r);
                this.createFrictionEquationsFromContact(r, this.frictionResult);
            }
        }
    }

    // Check all edges
    for(var i=0; i<triangles.length; i++){
        for (var j = 0; j < 3; j++) {

            trimeshShape.getVertex(trimeshShape.indices[triangles[i] * 3 + j], edgeVertexA);
            trimeshShape.getVertex(trimeshShape.indices[triangles[i] * 3 + ((j+1)%3)], edgeVertexB);
            edgeVertexB.vsub(edgeVertexA, edgeVector);

            // Project sphere position to the edge
            localSpherePos.vsub(edgeVertexB, tmp);
            var positionAlongEdgeB = tmp.dot(edgeVector);

            localSpherePos.vsub(edgeVertexA, tmp);
            var positionAlongEdgeA = tmp.dot(edgeVector);

            if(positionAlongEdgeA > 0 && positionAlongEdgeB < 0){

                // Now check the orthogonal distance from edge to sphere center
                localSpherePos.vsub(edgeVertexA, tmp);

                edgeVectorUnit.copy(edgeVector);
                edgeVectorUnit.normalize();
                positionAlongEdgeA = tmp.dot(edgeVectorUnit);

                edgeVectorUnit.scale(positionAlongEdgeA, tmp);
                tmp.vadd(edgeVertexA, tmp);

                // tmp is now the sphere center position projected to the edge, defined locally in the trimesh frame
                var dist = tmp.distanceTo(localSpherePos);
                if(dist < sphereShape.radius){

                    if(justTest){
                        return true;
                    }

                    var r = this.createContactEquation(sphereBody, trimeshBody, sphereShape, trimeshShape,rsi,rsj);

                    tmp.vsub(localSpherePos, r.ni);
                    r.ni.normalize();
                    r.ni.scale(sphereShape.radius, r.ri);

                    Transform.pointToWorldFrame(trimeshPos, trimeshQuat, tmp, tmp);
                    tmp.vsub(trimeshBody.position, r.rj);

                    Transform.vectorToWorldFrame(trimeshQuat, r.ni, r.ni);
                    Transform.vectorToWorldFrame(trimeshQuat, r.ri, r.ri);

                    this.result.push(r);
                    this.createFrictionEquationsFromContact(r, this.frictionResult);
                }
            }
        }
    }

    // Triangle faces
    var va = sphereTrimesh_va;
    var vb = sphereTrimesh_vb;
    var vc = sphereTrimesh_vc;
    var normal = sphereTrimesh_normal;
    for(var i=0, N = triangles.length; i !== N; i++){
        trimeshShape.getTriangleVertices(triangles[i], va, vb, vc);
        trimeshShape.getNormal(triangles[i], normal);
        localSpherePos.vsub(va, tmp);
        var dist = tmp.dot(normal);
        normal.scale(dist, tmp);
        localSpherePos.vsub(tmp, tmp);

        // tmp is now the sphere position projected to the triangle plane
        dist = tmp.distanceTo(localSpherePos);
        if(Ray.pointInTriangle(tmp, va, vb, vc) && dist < sphereShape.radius){
            if(justTest){
                return true;
            }
            var r = this.createContactEquation(sphereBody, trimeshBody, sphereShape, trimeshShape,rsi,rsj);

            tmp.vsub(localSpherePos, r.ni);
            r.ni.normalize();
            r.ni.scale(sphereShape.radius, r.ri);

            Transform.pointToWorldFrame(trimeshPos, trimeshQuat, tmp, tmp);
            tmp.vsub(trimeshBody.position, r.rj);

            Transform.vectorToWorldFrame(trimeshQuat, r.ni, r.ni);
            Transform.vectorToWorldFrame(trimeshQuat, r.ri, r.ri);

            this.result.push(r);
            this.createFrictionEquationsFromContact(r, this.frictionResult);
        }
    }

    triangles.length = 0;
};

var point_on_plane_to_sphere = new Vec3();
var plane_to_sphere_ortho = new Vec3();

/**
 * @method spherePlane
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
Narrowphase.prototype[Shape.types.SPHERE | Shape.types.PLANE] =
Narrowphase.prototype.spherePlane = function(si,sj,xi,xj,qi,qj,bi,bj,rsi,rsj,justTest){
    // We will have one contact in this case
    var r = this.createContactEquation(bi,bj,si,sj,rsi,rsj);

    // Contact normal
    r.ni.set(0,0,1);
    qj.vmult(r.ni, r.ni);
    r.ni.negate(r.ni); // body i is the sphere, flip normal
    r.ni.normalize(); // Needed?

    // Vector from sphere center to contact point
    r.ni.mult(si.radius, r.ri);

    // Project down sphere on plane
    xi.vsub(xj, point_on_plane_to_sphere);
    r.ni.mult(r.ni.dot(point_on_plane_to_sphere), plane_to_sphere_ortho);
    point_on_plane_to_sphere.vsub(plane_to_sphere_ortho,r.rj); // The sphere position projected to plane

    if(-point_on_plane_to_sphere.dot(r.ni) <= si.radius){

        if(justTest){
            return true;
        }

        // Make it relative to the body
        var ri = r.ri;
        var rj = r.rj;
        ri.vadd(xi, ri);
        ri.vsub(bi.position, ri);
        rj.vadd(xj, rj);
        rj.vsub(bj.position, rj);

        this.result.push(r);
        this.createFrictionEquationsFromContact(r, this.frictionResult);
    }
};

// See http://bulletphysics.com/Bullet/BulletFull/SphereTriangleDetector_8cpp_source.html
var pointInPolygon_edge = new Vec3();
var pointInPolygon_edge_x_normal = new Vec3();
var pointInPolygon_vtp = new Vec3();
function pointInPolygon(verts, normal, p){
    var positiveResult = null;
    var N = verts.length;
    for(var i=0; i!==N; i++){
        var v = verts[i];

        // Get edge to the next vertex
        var edge = pointInPolygon_edge;
        verts[(i+1) % (N)].vsub(v,edge);

        // Get cross product between polygon normal and the edge
        var edge_x_normal = pointInPolygon_edge_x_normal;
        //var edge_x_normal = new Vec3();
        edge.cross(normal,edge_x_normal);

        // Get vector between point and current vertex
        var vertex_to_p = pointInPolygon_vtp;
        p.vsub(v,vertex_to_p);

        // This dot product determines which side of the edge the point is
        var r = edge_x_normal.dot(vertex_to_p);

        // If all such dot products have same sign, we are inside the polygon.
        if(positiveResult===null || (r>0 && positiveResult===true) || (r<=0 && positiveResult===false)){
            if(positiveResult===null){
                positiveResult = r>0;
            }
            continue;
        } else {
            return false; // Encountered some other sign. Exit.
        }
    }

    // If we got here, all dot products were of the same sign.
    return true;
}

var box_to_sphere = new Vec3();
var sphereBox_ns = new Vec3();
var sphereBox_ns1 = new Vec3();
var sphereBox_ns2 = new Vec3();
var sphereBox_sides = [new Vec3(),new Vec3(),new Vec3(),new Vec3(),new Vec3(),new Vec3()];
var sphereBox_sphere_to_corner = new Vec3();
var sphereBox_side_ns = new Vec3();
var sphereBox_side_ns1 = new Vec3();
var sphereBox_side_ns2 = new Vec3();

/**
 * @method sphereBox
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
Narrowphase.prototype[Shape.types.SPHERE | Shape.types.BOX] =
Narrowphase.prototype.sphereBox = function(si,sj,xi,xj,qi,qj,bi,bj,rsi,rsj,justTest){
    var v3pool = this.v3pool;

    // we refer to the box as body j
    var sides = sphereBox_sides;
    xi.vsub(xj,box_to_sphere);
    sj.getSideNormals(sides,qj);
    var R =     si.radius;
    var penetrating_sides = [];

    // Check side (plane) intersections
    var found = false;

    // Store the resulting side penetration info
    var side_ns = sphereBox_side_ns;
    var side_ns1 = sphereBox_side_ns1;
    var side_ns2 = sphereBox_side_ns2;
    var side_h = null;
    var side_penetrations = 0;
    var side_dot1 = 0;
    var side_dot2 = 0;
    var side_distance = null;
    for(var idx=0,nsides=sides.length; idx!==nsides && found===false; idx++){
        // Get the plane side normal (ns)
        var ns = sphereBox_ns;
        ns.copy(sides[idx]);

        var h = ns.norm();
        ns.normalize();

        // The normal/distance dot product tells which side of the plane we are
        var dot = box_to_sphere.dot(ns);

        if(dot<h+R && dot>0){
            // Intersects plane. Now check the other two dimensions
            var ns1 = sphereBox_ns1;
            var ns2 = sphereBox_ns2;
            ns1.copy(sides[(idx+1)%3]);
            ns2.copy(sides[(idx+2)%3]);
            var h1 = ns1.norm();
            var h2 = ns2.norm();
            ns1.normalize();
            ns2.normalize();
            var dot1 = box_to_sphere.dot(ns1);
            var dot2 = box_to_sphere.dot(ns2);
            if(dot1<h1 && dot1>-h1 && dot2<h2 && dot2>-h2){
                var dist = Math.abs(dot-h-R);
                if(side_distance===null || dist < side_distance){
                    side_distance = dist;
                    side_dot1 = dot1;
                    side_dot2 = dot2;
                    side_h = h;
                    side_ns.copy(ns);
                    side_ns1.copy(ns1);
                    side_ns2.copy(ns2);
                    side_penetrations++;

                    if(justTest){
                        return true;
                    }
                }
            }
        }
    }
    if(side_penetrations){
        found = true;
        var r = this.createContactEquation(bi,bj,si,sj,rsi,rsj);
        side_ns.mult(-R,r.ri); // Sphere r
        r.ni.copy(side_ns);
        r.ni.negate(r.ni); // Normal should be out of sphere
        side_ns.mult(side_h,side_ns);
        side_ns1.mult(side_dot1,side_ns1);
        side_ns.vadd(side_ns1,side_ns);
        side_ns2.mult(side_dot2,side_ns2);
        side_ns.vadd(side_ns2,r.rj);

        // Make relative to bodies
        r.ri.vadd(xi, r.ri);
        r.ri.vsub(bi.position, r.ri);
        r.rj.vadd(xj, r.rj);
        r.rj.vsub(bj.position, r.rj);

        this.result.push(r);
        this.createFrictionEquationsFromContact(r, this.frictionResult);
    }

    // Check corners
    var rj = v3pool.get();
    var sphere_to_corner = sphereBox_sphere_to_corner;
    for(var j=0; j!==2 && !found; j++){
        for(var k=0; k!==2 && !found; k++){
            for(var l=0; l!==2 && !found; l++){
                rj.set(0,0,0);
                if(j){
                    rj.vadd(sides[0],rj);
                } else {
                    rj.vsub(sides[0],rj);
                }
                if(k){
                    rj.vadd(sides[1],rj);
                } else {
                    rj.vsub(sides[1],rj);
                }
                if(l){
                    rj.vadd(sides[2],rj);
                } else {
                    rj.vsub(sides[2],rj);
                }

                // World position of corner
                xj.vadd(rj,sphere_to_corner);
                sphere_to_corner.vsub(xi,sphere_to_corner);

                if(sphere_to_corner.norm2() < R*R){
                    if(justTest){
                        return true;
                    }
                    found = true;
                    var r = this.createContactEquation(bi,bj,si,sj,rsi,rsj);
                    r.ri.copy(sphere_to_corner);
                    r.ri.normalize();
                    r.ni.copy(r.ri);
                    r.ri.mult(R,r.ri);
                    r.rj.copy(rj);

                    // Make relative to bodies
                    r.ri.vadd(xi, r.ri);
                    r.ri.vsub(bi.position, r.ri);
                    r.rj.vadd(xj, r.rj);
                    r.rj.vsub(bj.position, r.rj);

                    this.result.push(r);
                    this.createFrictionEquationsFromContact(r, this.frictionResult);
                }
            }
        }
    }
    v3pool.release(rj);
    rj = null;

    // Check edges
    var edgeTangent = v3pool.get();
    var edgeCenter = v3pool.get();
    var r = v3pool.get(); // r = edge center to sphere center
    var orthogonal = v3pool.get();
    var dist = v3pool.get();
    var Nsides = sides.length;
    for(var j=0; j!==Nsides && !found; j++){
        for(var k=0; k!==Nsides && !found; k++){
            if(j%3 !== k%3){
                // Get edge tangent
                sides[k].cross(sides[j],edgeTangent);
                edgeTangent.normalize();
                sides[j].vadd(sides[k], edgeCenter);
                r.copy(xi);
                r.vsub(edgeCenter,r);
                r.vsub(xj,r);
                var orthonorm = r.dot(edgeTangent); // distance from edge center to sphere center in the tangent direction
                edgeTangent.mult(orthonorm,orthogonal); // Vector from edge center to sphere center in the tangent direction

                // Find the third side orthogonal to this one
                var l = 0;
                while(l===j%3 || l===k%3){
                    l++;
                }

                // vec from edge center to sphere projected to the plane orthogonal to the edge tangent
                dist.copy(xi);
                dist.vsub(orthogonal,dist);
                dist.vsub(edgeCenter,dist);
                dist.vsub(xj,dist);

                // Distances in tangent direction and distance in the plane orthogonal to it
                var tdist = Math.abs(orthonorm);
                var ndist = dist.norm();

                if(tdist < sides[l].norm() && ndist<R){
                    if(justTest){
                        return true;
                    }
                    found = true;
                    var res = this.createContactEquation(bi,bj,si,sj,rsi,rsj);
                    edgeCenter.vadd(orthogonal,res.rj); // box rj
                    res.rj.copy(res.rj);
                    dist.negate(res.ni);
                    res.ni.normalize();

                    res.ri.copy(res.rj);
                    res.ri.vadd(xj,res.ri);
                    res.ri.vsub(xi,res.ri);
                    res.ri.normalize();
                    res.ri.mult(R,res.ri);

                    // Make relative to bodies
                    res.ri.vadd(xi, res.ri);
                    res.ri.vsub(bi.position, res.ri);
                    res.rj.vadd(xj, res.rj);
                    res.rj.vsub(bj.position, res.rj);

                    this.result.push(res);
                    this.createFrictionEquationsFromContact(res, this.frictionResult);
                }
            }
        }
    }
    v3pool.release(edgeTangent,edgeCenter,r,orthogonal,dist);
};

var convex_to_sphere = new Vec3();
var sphereConvex_edge = new Vec3();
var sphereConvex_edgeUnit = new Vec3();
var sphereConvex_sphereToCorner = new Vec3();
var sphereConvex_worldCorner = new Vec3();
var sphereConvex_worldNormal = new Vec3();
var sphereConvex_worldPoint = new Vec3();
var sphereConvex_worldSpherePointClosestToPlane = new Vec3();
var sphereConvex_penetrationVec = new Vec3();
var sphereConvex_sphereToWorldPoint = new Vec3();

/**
 * @method sphereConvex
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
Narrowphase.prototype[Shape.types.SPHERE | Shape.types.CONVEXPOLYHEDRON] =
Narrowphase.prototype.sphereConvex = function(si,sj,xi,xj,qi,qj,bi,bj,rsi,rsj,justTest){
    var v3pool = this.v3pool;
    xi.vsub(xj,convex_to_sphere);
    var normals = sj.faceNormals;
    var faces = sj.faces;
    var verts = sj.vertices;
    var R =     si.radius;
    var penetrating_sides = [];

    // if(convex_to_sphere.norm2() > si.boundingSphereRadius + sj.boundingSphereRadius){
    //     return;
    // }

    // Check corners
    for(var i=0; i!==verts.length; i++){
        var v = verts[i];

        // World position of corner
        var worldCorner = sphereConvex_worldCorner;
        qj.vmult(v,worldCorner);
        xj.vadd(worldCorner,worldCorner);
        var sphere_to_corner = sphereConvex_sphereToCorner;
        worldCorner.vsub(xi, sphere_to_corner);
        if(sphere_to_corner.norm2() < R * R){
            if(justTest){
                return true;
            }
            found = true;
            var r = this.createContactEquation(bi,bj,si,sj,rsi,rsj);
            r.ri.copy(sphere_to_corner);
            r.ri.normalize();
            r.ni.copy(r.ri);
            r.ri.mult(R,r.ri);
            worldCorner.vsub(xj,r.rj);

            // Should be relative to the body.
            r.ri.vadd(xi, r.ri);
            r.ri.vsub(bi.position, r.ri);

            // Should be relative to the body.
            r.rj.vadd(xj, r.rj);
            r.rj.vsub(bj.position, r.rj);

            this.result.push(r);
            this.createFrictionEquationsFromContact(r, this.frictionResult);
            return;
        }
    }

    // Check side (plane) intersections
    var found = false;
    for(var i=0, nfaces=faces.length; i!==nfaces && found===false; i++){
        var normal = normals[i];
        var face = faces[i];

        // Get world-transformed normal of the face
        var worldNormal = sphereConvex_worldNormal;
        qj.vmult(normal,worldNormal);

        // Get a world vertex from the face
        var worldPoint = sphereConvex_worldPoint;
        qj.vmult(verts[face[0]],worldPoint);
        worldPoint.vadd(xj,worldPoint);

        // Get a point on the sphere, closest to the face normal
        var worldSpherePointClosestToPlane = sphereConvex_worldSpherePointClosestToPlane;
        worldNormal.mult(-R, worldSpherePointClosestToPlane);
        xi.vadd(worldSpherePointClosestToPlane, worldSpherePointClosestToPlane);

        // Vector from a face point to the closest point on the sphere
        var penetrationVec = sphereConvex_penetrationVec;
        worldSpherePointClosestToPlane.vsub(worldPoint,penetrationVec);

        // The penetration. Negative value means overlap.
        var penetration = penetrationVec.dot(worldNormal);

        var worldPointToSphere = sphereConvex_sphereToWorldPoint;
        xi.vsub(worldPoint, worldPointToSphere);

        if(penetration < 0 && worldPointToSphere.dot(worldNormal)>0){
            // Intersects plane. Now check if the sphere is inside the face polygon
            var faceVerts = []; // Face vertices, in world coords
            for(var j=0, Nverts=face.length; j!==Nverts; j++){
                var worldVertex = v3pool.get();
                qj.vmult(verts[face[j]], worldVertex);
                xj.vadd(worldVertex,worldVertex);
                faceVerts.push(worldVertex);
            }

            if(pointInPolygon(faceVerts,worldNormal,xi)){ // Is the sphere center in the face polygon?
                if(justTest){
                    return true;
                }
                found = true;
                var r = this.createContactEquation(bi,bj,si,sj,rsi,rsj);

                worldNormal.mult(-R, r.ri); // Contact offset, from sphere center to contact
                worldNormal.negate(r.ni); // Normal pointing out of sphere

                var penetrationVec2 = v3pool.get();
                worldNormal.mult(-penetration, penetrationVec2);
                var penetrationSpherePoint = v3pool.get();
                worldNormal.mult(-R, penetrationSpherePoint);

                //xi.vsub(xj).vadd(penetrationSpherePoint).vadd(penetrationVec2 , r.rj);
                xi.vsub(xj,r.rj);
                r.rj.vadd(penetrationSpherePoint,r.rj);
                r.rj.vadd(penetrationVec2 , r.rj);

                // Should be relative to the body.
                r.rj.vadd(xj, r.rj);
                r.rj.vsub(bj.position, r.rj);

                // Should be relative to the body.
                r.ri.vadd(xi, r.ri);
                r.ri.vsub(bi.position, r.ri);

                v3pool.release(penetrationVec2);
                v3pool.release(penetrationSpherePoint);

                this.result.push(r);
                this.createFrictionEquationsFromContact(r, this.frictionResult);

                // Release world vertices
                for(var j=0, Nfaceverts=faceVerts.length; j!==Nfaceverts; j++){
                    v3pool.release(faceVerts[j]);
                }

                return; // We only expect *one* face contact
            } else {
                // Edge?
                for(var j=0; j!==face.length; j++){

                    // Get two world transformed vertices
                    var v1 = v3pool.get();
                    var v2 = v3pool.get();
                    qj.vmult(verts[face[(j+1)%face.length]], v1);
                    qj.vmult(verts[face[(j+2)%face.length]], v2);
                    xj.vadd(v1, v1);
                    xj.vadd(v2, v2);

                    // Construct edge vector
                    var edge = sphereConvex_edge;
                    v2.vsub(v1,edge);

                    // Construct the same vector, but normalized
                    var edgeUnit = sphereConvex_edgeUnit;
                    edge.unit(edgeUnit);

                    // p is xi projected onto the edge
                    var p = v3pool.get();
                    var v1_to_xi = v3pool.get();
                    xi.vsub(v1, v1_to_xi);
                    var dot = v1_to_xi.dot(edgeUnit);
                    edgeUnit.mult(dot, p);
                    p.vadd(v1, p);

                    // Compute a vector from p to the center of the sphere
                    var xi_to_p = v3pool.get();
                    p.vsub(xi, xi_to_p);

                    // Collision if the edge-sphere distance is less than the radius
                    // AND if p is in between v1 and v2
                    if(dot > 0 && dot*dot<edge.norm2() && xi_to_p.norm2() < R*R){ // Collision if the edge-sphere distance is less than the radius
                        // Edge contact!
                        if(justTest){
                            return true;
                        }
                        var r = this.createContactEquation(bi,bj,si,sj,rsi,rsj);
                        p.vsub(xj,r.rj);

                        p.vsub(xi,r.ni);
                        r.ni.normalize();

                        r.ni.mult(R,r.ri);

                        // Should be relative to the body.
                        r.rj.vadd(xj, r.rj);
                        r.rj.vsub(bj.position, r.rj);

                        // Should be relative to the body.
                        r.ri.vadd(xi, r.ri);
                        r.ri.vsub(bi.position, r.ri);

                        this.result.push(r);
                        this.createFrictionEquationsFromContact(r, this.frictionResult);

                        // Release world vertices
                        for(var j=0, Nfaceverts=faceVerts.length; j!==Nfaceverts; j++){
                            v3pool.release(faceVerts[j]);
                        }

                        v3pool.release(v1);
                        v3pool.release(v2);
                        v3pool.release(p);
                        v3pool.release(xi_to_p);
                        v3pool.release(v1_to_xi);

                        return;
                    }

                    v3pool.release(v1);
                    v3pool.release(v2);
                    v3pool.release(p);
                    v3pool.release(xi_to_p);
                    v3pool.release(v1_to_xi);
                }
            }

            // Release world vertices
            for(var j=0, Nfaceverts=faceVerts.length; j!==Nfaceverts; j++){
                v3pool.release(faceVerts[j]);
            }
        }
    }
};

var planeBox_normal = new Vec3();
var plane_to_corner = new Vec3();

/**
 * @method planeBox
 * @param  {Array}      result
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
Narrowphase.prototype[Shape.types.PLANE | Shape.types.BOX] =
Narrowphase.prototype.planeBox = function(si,sj,xi,xj,qi,qj,bi,bj,rsi,rsj,justTest){
    sj.convexPolyhedronRepresentation.material = sj.material;
    sj.convexPolyhedronRepresentation.collisionResponse = sj.collisionResponse;
    sj.convexPolyhedronRepresentation.id = sj.id;
    return this.planeConvex(si,sj.convexPolyhedronRepresentation,xi,xj,qi,qj,bi,bj,si,sj,justTest);
};

var planeConvex_v = new Vec3();
var planeConvex_normal = new Vec3();
var planeConvex_relpos = new Vec3();
var planeConvex_projected = new Vec3();

/**
 * @method planeConvex
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
Narrowphase.prototype[Shape.types.PLANE | Shape.types.CONVEXPOLYHEDRON] =
Narrowphase.prototype.planeConvex = function(
    planeShape,
    convexShape,
    planePosition,
    convexPosition,
    planeQuat,
    convexQuat,
    planeBody,
    convexBody,
    si,
    sj,
    justTest
){
    // Simply return the points behind the plane.
    var worldVertex = planeConvex_v,
        worldNormal = planeConvex_normal;
    worldNormal.set(0,0,1);
    planeQuat.vmult(worldNormal,worldNormal); // Turn normal according to plane orientation

    var numContacts = 0;
    var relpos = planeConvex_relpos;
    for(var i = 0; i !== convexShape.vertices.length; i++){

        // Get world convex vertex
        worldVertex.copy(convexShape.vertices[i]);
        convexQuat.vmult(worldVertex, worldVertex);
        convexPosition.vadd(worldVertex, worldVertex);
        worldVertex.vsub(planePosition, relpos);

        var dot = worldNormal.dot(relpos);
        if(dot <= 0.0){
            if(justTest){
                return true;
            }

            var r = this.createContactEquation(planeBody, convexBody, planeShape, convexShape, si, sj);

            // Get vertex position projected on plane
            var projected = planeConvex_projected;
            worldNormal.mult(worldNormal.dot(relpos),projected);
            worldVertex.vsub(projected, projected);
            projected.vsub(planePosition, r.ri); // From plane to vertex projected on plane

            r.ni.copy(worldNormal); // Contact normal is the plane normal out from plane

            // rj is now just the vector from the convex center to the vertex
            worldVertex.vsub(convexPosition, r.rj);

            // Make it relative to the body
            r.ri.vadd(planePosition, r.ri);
            r.ri.vsub(planeBody.position, r.ri);
            r.rj.vadd(convexPosition, r.rj);
            r.rj.vsub(convexBody.position, r.rj);

            this.result.push(r);
            numContacts++;
            if(!this.enableFrictionReduction){
                this.createFrictionEquationsFromContact(r, this.frictionResult);
            }
        }
    }

    if(this.enableFrictionReduction && numContacts){
        this.createFrictionFromAverage(numContacts);
    }
};

var convexConvex_sepAxis = new Vec3();
var convexConvex_q = new Vec3();

/**
 * @method convexConvex
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
Narrowphase.prototype[Shape.types.CONVEXPOLYHEDRON] =
Narrowphase.prototype.convexConvex = function(si,sj,xi,xj,qi,qj,bi,bj,rsi,rsj,justTest,faceListA,faceListB){
    var sepAxis = convexConvex_sepAxis;

    if(xi.distanceTo(xj) > si.boundingSphereRadius + sj.boundingSphereRadius){
        return;
    }

    if(si.findSeparatingAxis(sj,xi,qi,xj,qj,sepAxis,faceListA,faceListB)){
        var res = [];
        var q = convexConvex_q;
        si.clipAgainstHull(xi,qi,sj,xj,qj,sepAxis,-100,100,res);
        var numContacts = 0;
        for(var j = 0; j !== res.length; j++){
            if(justTest){
                return true;
            }
            var r = this.createContactEquation(bi,bj,si,sj,rsi,rsj),
                ri = r.ri,
                rj = r.rj;
            sepAxis.negate(r.ni);
            res[j].normal.negate(q);
            q.mult(res[j].depth, q);
            res[j].point.vadd(q, ri);
            rj.copy(res[j].point);

            // Contact points are in world coordinates. Transform back to relative
            ri.vsub(xi,ri);
            rj.vsub(xj,rj);

            // Make relative to bodies
            ri.vadd(xi, ri);
            ri.vsub(bi.position, ri);
            rj.vadd(xj, rj);
            rj.vsub(bj.position, rj);

            this.result.push(r);
            numContacts++;
            if(!this.enableFrictionReduction){
                this.createFrictionEquationsFromContact(r, this.frictionResult);
            }
        }
        if(this.enableFrictionReduction && numContacts){
            this.createFrictionFromAverage(numContacts);
        }
    }
};


/**
 * @method convexTrimesh
 * @param  {Array}      result
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
// Narrowphase.prototype[Shape.types.CONVEXPOLYHEDRON | Shape.types.TRIMESH] =
// Narrowphase.prototype.convexTrimesh = function(si,sj,xi,xj,qi,qj,bi,bj,rsi,rsj,faceListA,faceListB){
//     var sepAxis = convexConvex_sepAxis;

//     if(xi.distanceTo(xj) > si.boundingSphereRadius + sj.boundingSphereRadius){
//         return;
//     }

//     // Construct a temp hull for each triangle
//     var hullB = new ConvexPolyhedron();

//     hullB.faces = [[0,1,2]];
//     var va = new Vec3();
//     var vb = new Vec3();
//     var vc = new Vec3();
//     hullB.vertices = [
//         va,
//         vb,
//         vc
//     ];

//     for (var i = 0; i < sj.indices.length / 3; i++) {

//         var triangleNormal = new Vec3();
//         sj.getNormal(i, triangleNormal);
//         hullB.faceNormals = [triangleNormal];

//         sj.getTriangleVertices(i, va, vb, vc);

//         var d = si.testSepAxis(triangleNormal, hullB, xi, qi, xj, qj);
//         if(!d){
//             triangleNormal.scale(-1, triangleNormal);
//             d = si.testSepAxis(triangleNormal, hullB, xi, qi, xj, qj);

//             if(!d){
//                 continue;
//             }
//         }

//         var res = [];
//         var q = convexConvex_q;
//         si.clipAgainstHull(xi,qi,hullB,xj,qj,triangleNormal,-100,100,res);
//         for(var j = 0; j !== res.length; j++){
//             var r = this.createContactEquation(bi,bj,si,sj,rsi,rsj),
//                 ri = r.ri,
//                 rj = r.rj;
//             r.ni.copy(triangleNormal);
//             r.ni.negate(r.ni);
//             res[j].normal.negate(q);
//             q.mult(res[j].depth, q);
//             res[j].point.vadd(q, ri);
//             rj.copy(res[j].point);

//             // Contact points are in world coordinates. Transform back to relative
//             ri.vsub(xi,ri);
//             rj.vsub(xj,rj);

//             // Make relative to bodies
//             ri.vadd(xi, ri);
//             ri.vsub(bi.position, ri);
//             rj.vadd(xj, rj);
//             rj.vsub(bj.position, rj);

//             result.push(r);
//         }
//     }
// };

var particlePlane_normal = new Vec3();
var particlePlane_relpos = new Vec3();
var particlePlane_projected = new Vec3();

/**
 * @method particlePlane
 * @param  {Array}      result
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
Narrowphase.prototype[Shape.types.PLANE | Shape.types.PARTICLE] =
Narrowphase.prototype.planeParticle = function(sj,si,xj,xi,qj,qi,bj,bi,rsi,rsj,justTest){
    var normal = particlePlane_normal;
    normal.set(0,0,1);
    bj.quaternion.vmult(normal,normal); // Turn normal according to plane orientation
    var relpos = particlePlane_relpos;
    xi.vsub(bj.position,relpos);
    var dot = normal.dot(relpos);
    if(dot <= 0.0){

        if(justTest){
            return true;
        }

        var r = this.createContactEquation(bi,bj,si,sj,rsi,rsj);
        r.ni.copy(normal); // Contact normal is the plane normal
        r.ni.negate(r.ni);
        r.ri.set(0,0,0); // Center of particle

        // Get particle position projected on plane
        var projected = particlePlane_projected;
        normal.mult(normal.dot(xi),projected);
        xi.vsub(projected,projected);
        //projected.vadd(bj.position,projected);

        // rj is now the projected world position minus plane position
        r.rj.copy(projected);
        this.result.push(r);
        this.createFrictionEquationsFromContact(r, this.frictionResult);
    }
};

var particleSphere_normal = new Vec3();

/**
 * @method particleSphere
 * @param  {Array}      result
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
Narrowphase.prototype[Shape.types.PARTICLE | Shape.types.SPHERE] =
Narrowphase.prototype.sphereParticle = function(sj,si,xj,xi,qj,qi,bj,bi,rsi,rsj,justTest){
    // The normal is the unit vector from sphere center to particle center
    var normal = particleSphere_normal;
    normal.set(0,0,1);
    xi.vsub(xj,normal);
    var lengthSquared = normal.norm2();

    if(lengthSquared <= sj.radius * sj.radius){
        if(justTest){
            return true;
        }
        var r = this.createContactEquation(bi,bj,si,sj,rsi,rsj);
        normal.normalize();
        r.rj.copy(normal);
        r.rj.mult(sj.radius,r.rj);
        r.ni.copy(normal); // Contact normal
        r.ni.negate(r.ni);
        r.ri.set(0,0,0); // Center of particle
        this.result.push(r);
        this.createFrictionEquationsFromContact(r, this.frictionResult);
    }
};

// WIP
var cqj = new Quaternion();
var convexParticle_local = new Vec3();
var convexParticle_normal = new Vec3();
var convexParticle_penetratedFaceNormal = new Vec3();
var convexParticle_vertexToParticle = new Vec3();
var convexParticle_worldPenetrationVec = new Vec3();

/**
 * @method convexParticle
 * @param  {Array}      result
 * @param  {Shape}      si
 * @param  {Shape}      sj
 * @param  {Vec3}       xi
 * @param  {Vec3}       xj
 * @param  {Quaternion} qi
 * @param  {Quaternion} qj
 * @param  {Body}       bi
 * @param  {Body}       bj
 */
Narrowphase.prototype[Shape.types.PARTICLE | Shape.types.CONVEXPOLYHEDRON] =
Narrowphase.prototype.convexParticle = function(sj,si,xj,xi,qj,qi,bj,bi,rsi,rsj,justTest){
    var penetratedFaceIndex = -1;
    var penetratedFaceNormal = convexParticle_penetratedFaceNormal;
    var worldPenetrationVec = convexParticle_worldPenetrationVec;
    var minPenetration = null;
    var numDetectedFaces = 0;

    // Convert particle position xi to local coords in the convex
    var local = convexParticle_local;
    local.copy(xi);
    local.vsub(xj,local); // Convert position to relative the convex origin
    qj.conjugate(cqj);
    cqj.vmult(local,local);

    if(sj.pointIsInside(local)){

        if(sj.worldVerticesNeedsUpdate){
            sj.computeWorldVertices(xj,qj);
        }
        if(sj.worldFaceNormalsNeedsUpdate){
            sj.computeWorldFaceNormals(qj);
        }

        // For each world polygon in the polyhedra
        for(var i=0,nfaces=sj.faces.length; i!==nfaces; i++){

            // Construct world face vertices
            var verts = [ sj.worldVertices[ sj.faces[i][0] ] ];
            var normal = sj.worldFaceNormals[i];

            // Check how much the particle penetrates the polygon plane.
            xi.vsub(verts[0],convexParticle_vertexToParticle);
            var penetration = -normal.dot(convexParticle_vertexToParticle);
            if(minPenetration===null || Math.abs(penetration)<Math.abs(minPenetration)){

                if(justTest){
                    return true;
                }

                minPenetration = penetration;
                penetratedFaceIndex = i;
                penetratedFaceNormal.copy(normal);
                numDetectedFaces++;
            }
        }

        if(penetratedFaceIndex!==-1){
            // Setup contact
            var r = this.createContactEquation(bi,bj,si,sj,rsi,rsj);
            penetratedFaceNormal.mult(minPenetration, worldPenetrationVec);

            // rj is the particle position projected to the face
            worldPenetrationVec.vadd(xi,worldPenetrationVec);
            worldPenetrationVec.vsub(xj,worldPenetrationVec);
            r.rj.copy(worldPenetrationVec);
            //var projectedToFace = xi.vsub(xj).vadd(worldPenetrationVec);
            //projectedToFace.copy(r.rj);

            //qj.vmult(r.rj,r.rj);
            penetratedFaceNormal.negate( r.ni ); // Contact normal
            r.ri.set(0,0,0); // Center of particle

            var ri = r.ri,
                rj = r.rj;

            // Make relative to bodies
            ri.vadd(xi, ri);
            ri.vsub(bi.position, ri);
            rj.vadd(xj, rj);
            rj.vsub(bj.position, rj);

            this.result.push(r);
            this.createFrictionEquationsFromContact(r, this.frictionResult);
        } else {
            console.warn("Point found inside convex, but did not find penetrating face!");
        }
    }
};

Narrowphase.prototype[Shape.types.BOX | Shape.types.HEIGHTFIELD] =
Narrowphase.prototype.boxHeightfield = function (si,sj,xi,xj,qi,qj,bi,bj,rsi,rsj,justTest){
    si.convexPolyhedronRepresentation.material = si.material;
    si.convexPolyhedronRepresentation.collisionResponse = si.collisionResponse;
    return this.convexHeightfield(si.convexPolyhedronRepresentation,sj,xi,xj,qi,qj,bi,bj,si,sj,justTest);
};

var convexHeightfield_tmp1 = new Vec3();
var convexHeightfield_tmp2 = new Vec3();
var convexHeightfield_faceList = [0];

/**
 * @method convexHeightfield
 */
Narrowphase.prototype[Shape.types.CONVEXPOLYHEDRON | Shape.types.HEIGHTFIELD] =
Narrowphase.prototype.convexHeightfield = function (
    convexShape,
    hfShape,
    convexPos,
    hfPos,
    convexQuat,
    hfQuat,
    convexBody,
    hfBody,
    rsi,
    rsj,
    justTest
){
    var data = hfShape.data,
        w = hfShape.elementSize,
        radius = convexShape.boundingSphereRadius,
        worldPillarOffset = convexHeightfield_tmp2,
        faceList = convexHeightfield_faceList;

    // Get sphere position to heightfield local!
    var localConvexPos = convexHeightfield_tmp1;
    Transform.pointToLocalFrame(hfPos, hfQuat, convexPos, localConvexPos);

    // Get the index of the data points to test against
    var iMinX = Math.floor((localConvexPos.x - radius) / w) - 1,
        iMaxX = Math.ceil((localConvexPos.x + radius) / w) + 1,
        iMinY = Math.floor((localConvexPos.y - radius) / w) - 1,
        iMaxY = Math.ceil((localConvexPos.y + radius) / w) + 1;

    // Bail out if we are out of the terrain
    if(iMaxX < 0 || iMaxY < 0 || iMinX > data.length || iMinY > data[0].length){
        return;
    }

    // Clamp index to edges
    if(iMinX < 0){ iMinX = 0; }
    if(iMaxX < 0){ iMaxX = 0; }
    if(iMinY < 0){ iMinY = 0; }
    if(iMaxY < 0){ iMaxY = 0; }
    if(iMinX >= data.length){ iMinX = data.length - 1; }
    if(iMaxX >= data.length){ iMaxX = data.length - 1; }
    if(iMaxY >= data[0].length){ iMaxY = data[0].length - 1; }
    if(iMinY >= data[0].length){ iMinY = data[0].length - 1; }

    var minMax = [];
    hfShape.getRectMinMax(iMinX, iMinY, iMaxX, iMaxY, minMax);
    var min = minMax[0];
    var max = minMax[1];

    // Bail out if we're cant touch the bounding height box
    if(localConvexPos.z - radius > max || localConvexPos.z + radius < min){
        return;
    }

    for(var i = iMinX; i < iMaxX; i++){
        for(var j = iMinY; j < iMaxY; j++){

            var intersecting = false;

            // Lower triangle
            hfShape.getConvexTrianglePillar(i, j, false);
            Transform.pointToWorldFrame(hfPos, hfQuat, hfShape.pillarOffset, worldPillarOffset);
            if (convexPos.distanceTo(worldPillarOffset) < hfShape.pillarConvex.boundingSphereRadius + convexShape.boundingSphereRadius) {
                intersecting = this.convexConvex(convexShape, hfShape.pillarConvex, convexPos, worldPillarOffset, convexQuat, hfQuat, convexBody, hfBody, null, null, justTest, faceList, null);
            }

            if(justTest && intersecting){
                return true;
            }

            // Upper triangle
            hfShape.getConvexTrianglePillar(i, j, true);
            Transform.pointToWorldFrame(hfPos, hfQuat, hfShape.pillarOffset, worldPillarOffset);
            if (convexPos.distanceTo(worldPillarOffset) < hfShape.pillarConvex.boundingSphereRadius + convexShape.boundingSphereRadius) {
                intersecting = this.convexConvex(convexShape, hfShape.pillarConvex, convexPos, worldPillarOffset, convexQuat, hfQuat, convexBody, hfBody, null, null, justTest, faceList, null);
            }

            if(justTest && intersecting){
                return true;
            }
        }
    }
};

var sphereHeightfield_tmp1 = new Vec3();
var sphereHeightfield_tmp2 = new Vec3();

/**
 * @method sphereHeightfield
 */
Narrowphase.prototype[Shape.types.SPHERE | Shape.types.HEIGHTFIELD] =
Narrowphase.prototype.sphereHeightfield = function (
    sphereShape,
    hfShape,
    spherePos,
    hfPos,
    sphereQuat,
    hfQuat,
    sphereBody,
    hfBody,
    rsi,
    rsj,
    justTest
){
    var data = hfShape.data,
        radius = sphereShape.radius,
        w = hfShape.elementSize,
        worldPillarOffset = sphereHeightfield_tmp2;

    // Get sphere position to heightfield local!
    var localSpherePos = sphereHeightfield_tmp1;
    Transform.pointToLocalFrame(hfPos, hfQuat, spherePos, localSpherePos);

    // Get the index of the data points to test against
    var iMinX = Math.floor((localSpherePos.x - radius) / w) - 1,
        iMaxX = Math.ceil((localSpherePos.x + radius) / w) + 1,
        iMinY = Math.floor((localSpherePos.y - radius) / w) - 1,
        iMaxY = Math.ceil((localSpherePos.y + radius) / w) + 1;

    // Bail out if we are out of the terrain
    if(iMaxX < 0 || iMaxY < 0 || iMinX > data.length || iMaxY > data[0].length){
        return;
    }

    // Clamp index to edges
    if(iMinX < 0){ iMinX = 0; }
    if(iMaxX < 0){ iMaxX = 0; }
    if(iMinY < 0){ iMinY = 0; }
    if(iMaxY < 0){ iMaxY = 0; }
    if(iMinX >= data.length){ iMinX = data.length - 1; }
    if(iMaxX >= data.length){ iMaxX = data.length - 1; }
    if(iMaxY >= data[0].length){ iMaxY = data[0].length - 1; }
    if(iMinY >= data[0].length){ iMinY = data[0].length - 1; }

    var minMax = [];
    hfShape.getRectMinMax(iMinX, iMinY, iMaxX, iMaxY, minMax);
    var min = minMax[0];
    var max = minMax[1];

    // Bail out if we're cant touch the bounding height box
    if(localSpherePos.z - radius > max || localSpherePos.z + radius < min){
        return;
    }

    var result = this.result;
    for(var i = iMinX; i < iMaxX; i++){
        for(var j = iMinY; j < iMaxY; j++){

            var numContactsBefore = result.length;

            var intersecting = false;

            // Lower triangle
            hfShape.getConvexTrianglePillar(i, j, false);
            Transform.pointToWorldFrame(hfPos, hfQuat, hfShape.pillarOffset, worldPillarOffset);
            if (spherePos.distanceTo(worldPillarOffset) < hfShape.pillarConvex.boundingSphereRadius + sphereShape.boundingSphereRadius) {
                intersecting = this.sphereConvex(sphereShape, hfShape.pillarConvex, spherePos, worldPillarOffset, sphereQuat, hfQuat, sphereBody, hfBody, sphereShape, hfShape, justTest);
            }

            if(justTest && intersecting){
                return true;
            }

            // Upper triangle
            hfShape.getConvexTrianglePillar(i, j, true);
            Transform.pointToWorldFrame(hfPos, hfQuat, hfShape.pillarOffset, worldPillarOffset);
            if (spherePos.distanceTo(worldPillarOffset) < hfShape.pillarConvex.boundingSphereRadius + sphereShape.boundingSphereRadius) {
                intersecting = this.sphereConvex(sphereShape, hfShape.pillarConvex, spherePos, worldPillarOffset, sphereQuat, hfQuat, sphereBody, hfBody, sphereShape, hfShape, justTest);
            }

            if(justTest && intersecting){
                return true;
            }

            var numContacts = result.length - numContactsBefore;

            if(numContacts > 2){
                return;
            }
            /*
            // Skip all but 1
            for (var k = 0; k < numContacts - 1; k++) {
                result.pop();
            }
            */
        }
    }
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(18);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/quicksandmedium.2eb64639.fnt";

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.createSubscribe = createSubscribe;
exports.async = async;

var _promise = __webpack_require__(39);

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    var proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
var ObserverProxy = /** @class */function () {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = _promise.PromiseImpl.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(function () {
            executor(_this);
        }).catch(function (e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function (value) {
        this.forEachObserver(function (observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function (error) {
        this.forEachObserver(function (observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function () {
        this.forEachObserver(function (observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, ['next', 'error', 'complete'])) {
            observer = nextOrObserver;
        } else {
            observer = {
                next: nextOrObserver,
                error: error,
                complete: complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            this.task.then(function () {
                try {
                    if (_this.finalError) {
                        observer.error(_this.finalError);
                    } else {
                        observer.complete();
                    }
                } catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function (i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    };
    ObserverProxy.prototype.forEachObserver = function (fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (var i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function (i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        this.task.then(function () {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
                try {
                    fn(_this.observers[i]);
                } catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    };
    ObserverProxy.prototype.close = function (err) {
        var _this = this;
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        this.task.then(function () {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}();
/** Turn synchronous function into one called asynchronously. */
function async(fn, onError) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        _promise.PromiseImpl.resolve(true).then(function () {
            fn.apply(void 0, args);
        }).catch(function (error) {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) {
        return false;
    }
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}
//# sourceMappingURL=subscribe.js.map


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DataSnapshot = undefined;

var _validation = __webpack_require__(40);

var _validation2 = __webpack_require__(37);

var _Path = __webpack_require__(9);

var _PriorityIndex = __webpack_require__(15);

/**
 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
 * surfaces the public methods (val, forEach, etc.) we want to expose.
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DataSnapshot = /** @class */function () {
    /**
     * @param {!Node} node_ A SnapshotNode to wrap.
     * @param {!Reference} ref_ The ref of the location this snapshot came from.
     * @param {!Index} index_ The iteration order for this snapshot
     */
    function DataSnapshot(node_, ref_, index_) {
        this.node_ = node_;
        this.ref_ = ref_;
        this.index_ = index_;
    }
    /**
     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
     * empty.
     *
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */
    DataSnapshot.prototype.val = function () {
        (0, _validation.validateArgCount)('DataSnapshot.val', 0, 0, arguments.length);
        return this.node_.val();
    };
    /**
     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
     * the entire node contents.
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */
    DataSnapshot.prototype.exportVal = function () {
        (0, _validation.validateArgCount)('DataSnapshot.exportVal', 0, 0, arguments.length);
        return this.node_.val(true);
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    DataSnapshot.prototype.toJSON = function () {
        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
        (0, _validation.validateArgCount)('DataSnapshot.toJSON', 0, 1, arguments.length);
        return this.exportVal();
    };
    /**
     * Returns whether the snapshot contains a non-null value.
     *
     * @return {boolean} Whether the snapshot contains a non-null value, or is empty.
     */
    DataSnapshot.prototype.exists = function () {
        (0, _validation.validateArgCount)('DataSnapshot.exists', 0, 0, arguments.length);
        return !this.node_.isEmpty();
    };
    /**
     * Returns a DataSnapshot of the specified child node's contents.
     *
     * @param {!string} childPathString Path to a child.
     * @return {!DataSnapshot} DataSnapshot for child node.
     */
    DataSnapshot.prototype.child = function (childPathString) {
        (0, _validation.validateArgCount)('DataSnapshot.child', 0, 1, arguments.length);
        // Ensure the childPath is a string (can be a number)
        childPathString = String(childPathString);
        (0, _validation2.validatePathString)('DataSnapshot.child', 1, childPathString, false);
        var childPath = new _Path.Path(childPathString);
        var childRef = this.ref_.child(childPath);
        return new DataSnapshot(this.node_.getChild(childPath), childRef, _PriorityIndex.PRIORITY_INDEX);
    };
    /**
     * Returns whether the snapshot contains a child at the specified path.
     *
     * @param {!string} childPathString Path to a child.
     * @return {boolean} Whether the child exists.
     */
    DataSnapshot.prototype.hasChild = function (childPathString) {
        (0, _validation.validateArgCount)('DataSnapshot.hasChild', 1, 1, arguments.length);
        (0, _validation2.validatePathString)('DataSnapshot.hasChild', 1, childPathString, false);
        var childPath = new _Path.Path(childPathString);
        return !this.node_.getChild(childPath).isEmpty();
    };
    /**
     * Returns the priority of the object, or null if no priority was set.
     *
     * @return {string|number|null} The priority.
     */
    DataSnapshot.prototype.getPriority = function () {
        (0, _validation.validateArgCount)('DataSnapshot.getPriority', 0, 0, arguments.length);
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this.node_.getPriority().val();
    };
    /**
     * Iterates through child nodes and calls the specified action for each one.
     *
     * @param {function(!DataSnapshot)} action Callback function to be called
     * for each child.
     * @return {boolean} True if forEach was canceled by action returning true for
     * one of the child nodes.
     */
    DataSnapshot.prototype.forEach = function (action) {
        var _this = this;
        (0, _validation.validateArgCount)('DataSnapshot.forEach', 1, 1, arguments.length);
        (0, _validation.validateCallback)('DataSnapshot.forEach', 1, action, false);
        if (this.node_.isLeafNode()) return false;
        var childrenNode = this.node_;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this.index_, function (key, node) {
            return action(new DataSnapshot(node, _this.ref_.child(key), _PriorityIndex.PRIORITY_INDEX));
        });
    };
    /**
     * Returns whether this DataSnapshot has children.
     * @return {boolean} True if the DataSnapshot contains 1 or more child nodes.
     */
    DataSnapshot.prototype.hasChildren = function () {
        (0, _validation.validateArgCount)('DataSnapshot.hasChildren', 0, 0, arguments.length);
        if (this.node_.isLeafNode()) return false;else return !this.node_.isEmpty();
    };
    Object.defineProperty(DataSnapshot.prototype, "key", {
        get: function get() {
            return this.ref_.getKey();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the number of children for this DataSnapshot.
     * @return {number} The number of children that this DataSnapshot contains.
     */
    DataSnapshot.prototype.numChildren = function () {
        (0, _validation.validateArgCount)('DataSnapshot.numChildren', 0, 0, arguments.length);
        return this.node_.numChildren();
    };
    /**
     * @return {Reference} The Firebase reference for the location this snapshot's data came from.
     */
    DataSnapshot.prototype.getRef = function () {
        (0, _validation.validateArgCount)('DataSnapshot.ref', 0, 0, arguments.length);
        return this.ref_;
    };
    Object.defineProperty(DataSnapshot.prototype, "ref", {
        get: function get() {
            return this.getRef();
        },
        enumerable: true,
        configurable: true
    });
    return DataSnapshot;
}();
exports.DataSnapshot = DataSnapshot;
//# sourceMappingURL=DataSnapshot.js.map


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DatabaseInternals = exports.Database = undefined;

var _util = __webpack_require__(3);

var _parser = __webpack_require__(177);

var _Path = __webpack_require__(9);

var _promise = __webpack_require__(39);

var _Reference = __webpack_require__(104);

var _Repo = __webpack_require__(77);

var _RepoManager = __webpack_require__(105);

var _validation = __webpack_require__(40);

var _validation2 = __webpack_require__(37);

/**
 * Class representing a firebase database.
 * @implements {FirebaseService}
 */
var Database = /** @class */function () {
    /**
     * The constructor should not be called by users of our public API.
     * @param {!Repo} repo_
     */
    function Database(repo_) {
        this.repo_ = repo_;
        if (!(repo_ instanceof _Repo.Repo)) {
            (0, _util.fatal)("Don't call new Database() directly - please use firebase.database().");
        }
        /** @type {Reference} */
        this.root_ = new _Reference.Reference(repo_, _Path.Path.Empty);
        this.INTERNAL = new DatabaseInternals(this);
    }
    Object.defineProperty(Database.prototype, "app", {
        get: function get() {
            return this.repo_.app;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a reference to the root or the path specified in opt_pathString.
     * @param {string=} pathString
     * @return {!Reference} Firebase reference.
     */
    Database.prototype.ref = function (pathString) {
        this.checkDeleted_('ref');
        (0, _validation.validateArgCount)('database.ref', 0, 1, arguments.length);
        return pathString !== undefined ? this.root_.child(pathString) : this.root_;
    };
    /**
     * Returns a reference to the root or the path specified in url.
     * We throw a exception if the url is not in the same domain as the
     * current repo.
     * @param {string} url
     * @return {!Reference} Firebase reference.
     */
    Database.prototype.refFromURL = function (url) {
        /** @const {string} */
        var apiName = 'database.refFromURL';
        this.checkDeleted_(apiName);
        (0, _validation.validateArgCount)(apiName, 1, 1, arguments.length);
        var parsedURL = (0, _parser.parseRepoInfo)(url);
        (0, _validation2.validateUrl)(apiName, 1, parsedURL);
        var repoInfo = parsedURL.repoInfo;
        if (repoInfo.host !== this.repo_.repoInfo_.host) {
            (0, _util.fatal)(apiName + ': Host name does not match the current database: ' + '(found ' + repoInfo.host + ' but expected ' + this.repo_.repoInfo_.host + ')');
        }
        return this.ref(parsedURL.path.toString());
    };
    /**
     * @param {string} apiName
     */
    Database.prototype.checkDeleted_ = function (apiName) {
        if (this.repo_ === null) {
            (0, _util.fatal)('Cannot call ' + apiName + ' on a deleted database.');
        }
    };
    // Make individual repo go offline.
    Database.prototype.goOffline = function () {
        (0, _validation.validateArgCount)('database.goOffline', 0, 0, arguments.length);
        this.checkDeleted_('goOffline');
        this.repo_.interrupt();
    };
    Database.prototype.goOnline = function () {
        (0, _validation.validateArgCount)('database.goOnline', 0, 0, arguments.length);
        this.checkDeleted_('goOnline');
        this.repo_.resume();
    };
    Database.ServerValue = {
        TIMESTAMP: {
            '.sv': 'timestamp'
        }
    };
    return Database;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.Database = Database;

var DatabaseInternals = /** @class */function () {
    /** @param {!Database} database */
    function DatabaseInternals(database) {
        this.database = database;
    }
    /** @return {Promise<void>} */
    DatabaseInternals.prototype.delete = function () {
        this.database.checkDeleted_('delete');
        _RepoManager.RepoManager.getInstance().deleteRepo(this.database.repo_);
        this.database.repo_ = null;
        this.database.root_ = null;
        this.database.INTERNAL = null;
        this.database = null;
        return _promise.PromiseImpl.resolve();
    };
    return DatabaseInternals;
}();
exports.DatabaseInternals = DatabaseInternals;
//# sourceMappingURL=Database.js.map


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Query = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Copyright 2017 Google Inc.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Licensed under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                               * you may not use this file except in compliance with the License.
                                                                                                                                                                                                                                                                               * You may obtain a copy of the License at
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               *   http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Unless required by applicable law or agreed to in writing, software
                                                                                                                                                                                                                                                                               * distributed under the License is distributed on an "AS IS" BASIS,
                                                                                                                                                                                                                                                                               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                                                                                                                                                                                                               * See the License for the specific language governing permissions and
                                                                                                                                                                                                                                                                               * limitations under the License.
                                                                                                                                                                                                                                                                               */


var _assert = __webpack_require__(2);

var _KeyIndex = __webpack_require__(61);

var _PriorityIndex = __webpack_require__(15);

var _ValueIndex = __webpack_require__(171);

var _PathIndex = __webpack_require__(170);

var _util = __webpack_require__(3);

var _Path = __webpack_require__(9);

var _validation = __webpack_require__(37);

var _validation2 = __webpack_require__(40);

var _EventRegistration = __webpack_require__(404);

var _promise = __webpack_require__(39);

var __referenceConstructor;
/**
 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
 *
 * Since every Firebase reference is a query, Firebase inherits from this object.
 */
var Query = /** @class */function () {
    function Query(repo, path, queryParams_, orderByCalled_) {
        this.repo = repo;
        this.path = path;
        this.queryParams_ = queryParams_;
        this.orderByCalled_ = orderByCalled_;
    }
    Object.defineProperty(Query, "__referenceConstructor", {
        get: function get() {
            (0, _assert.assert)(__referenceConstructor, 'Reference.ts has not been loaded');
            return __referenceConstructor;
        },
        set: function set(val) {
            __referenceConstructor = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Validates start/end values for queries.
     * @param {!QueryParams} params
     * @private
     */
    Query.validateQueryEndpoints_ = function (params) {
        var startNode = null;
        var endNode = null;
        if (params.hasStart()) {
            startNode = params.getIndexStartValue();
        }
        if (params.hasEnd()) {
            endNode = params.getIndexEndValue();
        }
        if (params.getIndex() === _KeyIndex.KEY_INDEX) {
            var tooManyArgsError = 'Query: When ordering by key, you may only pass one argument to ' + 'startAt(), endAt(), or equalTo().';
            var wrongArgTypeError = 'Query: When ordering by key, the argument passed to startAt(), endAt(),' + 'or equalTo() must be a string.';
            if (params.hasStart()) {
                var startName = params.getIndexStartName();
                if (startName != _util.MIN_NAME) {
                    throw new Error(tooManyArgsError);
                } else if (typeof startNode !== 'string') {
                    throw new Error(wrongArgTypeError);
                }
            }
            if (params.hasEnd()) {
                var endName = params.getIndexEndName();
                if (endName != _util.MAX_NAME) {
                    throw new Error(tooManyArgsError);
                } else if (typeof endNode !== 'string') {
                    throw new Error(wrongArgTypeError);
                }
            }
        } else if (params.getIndex() === _PriorityIndex.PRIORITY_INDEX) {
            if (startNode != null && !(0, _validation.isValidPriority)(startNode) || endNode != null && !(0, _validation.isValidPriority)(endNode)) {
                throw new Error('Query: When ordering by priority, the first argument passed to startAt(), ' + 'endAt(), or equalTo() must be a valid priority value (null, a number, or a string).');
            }
        } else {
            (0, _assert.assert)(params.getIndex() instanceof _PathIndex.PathIndex || params.getIndex() === _ValueIndex.VALUE_INDEX, 'unknown index type.');
            if (startNode != null && (typeof startNode === 'undefined' ? 'undefined' : _typeof(startNode)) === 'object' || endNode != null && (typeof endNode === 'undefined' ? 'undefined' : _typeof(endNode)) === 'object') {
                throw new Error('Query: First argument passed to startAt(), endAt(), or equalTo() cannot be ' + 'an object.');
            }
        }
    };
    /**
     * Validates that limit* has been called with the correct combination of parameters
     * @param {!QueryParams} params
     * @private
     */
    Query.validateLimit_ = function (params) {
        if (params.hasStart() && params.hasEnd() && params.hasLimit() && !params.hasAnchoredLimit()) {
            throw new Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
        }
    };
    /**
     * Validates that no other order by call has been made
     * @param {!string} fnName
     * @private
     */
    Query.prototype.validateNoPreviousOrderByCall_ = function (fnName) {
        if (this.orderByCalled_ === true) {
            throw new Error(fnName + ": You can't combine multiple orderBy calls.");
        }
    };
    /**
     * @return {!QueryParams}
     */
    Query.prototype.getQueryParams = function () {
        return this.queryParams_;
    };
    /**
     * @return {!Reference}
     */
    Query.prototype.getRef = function () {
        (0, _validation2.validateArgCount)('Query.ref', 0, 0, arguments.length);
        // This is a slight hack. We cannot goog.require('fb.api.Firebase'), since Firebase requires fb.api.Query.
        // However, we will always export 'Firebase' to the global namespace, so it's guaranteed to exist by the time this
        // method gets called.
        return new Query.__referenceConstructor(this.repo, this.path);
    };
    /**
     * @param {!string} eventType
     * @param {!function(DataSnapshot, string=)} callback
     * @param {(function(Error)|Object)=} cancelCallbackOrContext
     * @param {Object=} context
     * @return {!function(DataSnapshot, string=)}
     */
    Query.prototype.on = function (eventType, callback, cancelCallbackOrContext, context) {
        (0, _validation2.validateArgCount)('Query.on', 2, 4, arguments.length);
        (0, _validation.validateEventType)('Query.on', 1, eventType, false);
        (0, _validation2.validateCallback)('Query.on', 2, callback, false);
        var ret = Query.getCancelAndContextArgs_('Query.on', cancelCallbackOrContext, context);
        if (eventType === 'value') {
            this.onValueEvent(callback, ret.cancel, ret.context);
        } else {
            var callbacks = {};
            callbacks[eventType] = callback;
            this.onChildEvent(callbacks, ret.cancel, ret.context);
        }
        return callback;
    };
    /**
     * @param {!function(!DataSnapshot)} callback
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */
    Query.prototype.onValueEvent = function (callback, cancelCallback, context) {
        var container = new _EventRegistration.ValueEventRegistration(callback, cancelCallback || null, context || null);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {!Object.<string, !function(!DataSnapshot, ?string)>} callbacks
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */
    Query.prototype.onChildEvent = function (callbacks, cancelCallback, context) {
        var container = new _EventRegistration.ChildEventRegistration(callbacks, cancelCallback, context);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {string=} eventType
     * @param {(function(!DataSnapshot, ?string=))=} callback
     * @param {Object=} context
     */
    Query.prototype.off = function (eventType, callback, context) {
        (0, _validation2.validateArgCount)('Query.off', 0, 3, arguments.length);
        (0, _validation.validateEventType)('Query.off', 1, eventType, true);
        (0, _validation2.validateCallback)('Query.off', 2, callback, true);
        (0, _validation2.validateContextObject)('Query.off', 3, context, true);
        var container = null;
        var callbacks = null;
        if (eventType === 'value') {
            var valueCallback = callback || null;
            container = new _EventRegistration.ValueEventRegistration(valueCallback, null, context || null);
        } else if (eventType) {
            if (callback) {
                callbacks = {};
                callbacks[eventType] = callback;
            }
            container = new _EventRegistration.ChildEventRegistration(callbacks, null, context || null);
        }
        this.repo.removeEventCallbackForQuery(this, container);
    };
    /**
     * Attaches a listener, waits for the first event, and then removes the listener
     * @param {!string} eventType
     * @param {!function(!DataSnapshot, string=)} userCallback
     * @param cancelOrContext
     * @param context
     * @return {!firebase.Promise}
     */
    Query.prototype.once = function (eventType, userCallback, cancelOrContext, context) {
        var _this = this;
        (0, _validation2.validateArgCount)('Query.once', 1, 4, arguments.length);
        (0, _validation.validateEventType)('Query.once', 1, eventType, false);
        (0, _validation2.validateCallback)('Query.once', 2, userCallback, true);
        var ret = Query.getCancelAndContextArgs_('Query.once', cancelOrContext, context);
        // TODO: Implement this more efficiently (in particular, use 'get' wire protocol for 'value' event)
        // TODO: consider actually wiring the callbacks into the promise. We cannot do this without a breaking change
        // because the API currently expects callbacks will be called synchronously if the data is cached, but this is
        // against the Promise specification.
        var firstCall = true;
        var deferred = new _promise.Deferred();
        (0, _promise.attachDummyErrorHandler)(deferred.promise);
        var onceCallback = function onceCallback(snapshot) {
            // NOTE: Even though we unsubscribe, we may get called multiple times if a single action (e.g. set() with JSON)
            // triggers multiple events (e.g. child_added or child_changed).
            if (firstCall) {
                firstCall = false;
                _this.off(eventType, onceCallback);
                if (userCallback) {
                    userCallback.bind(ret.context)(snapshot);
                }
                deferred.resolve(snapshot);
            }
        };
        this.on(eventType, onceCallback,
        /*cancel=*/function (err) {
            _this.off(eventType, onceCallback);
            if (ret.cancel) ret.cancel.bind(ret.context)(err);
            deferred.reject(err);
        });
        return deferred.promise;
    };
    /**
     * Set a limit and anchor it to the start of the window.
     * @param {!number} limit
     * @return {!Query}
     */
    Query.prototype.limitToFirst = function (limit) {
        (0, _validation2.validateArgCount)('Query.limitToFirst', 1, 1, arguments.length);
        if (typeof limit !== 'number' || Math.floor(limit) !== limit || limit <= 0) {
            throw new Error('Query.limitToFirst: First argument must be a positive integer.');
        }
        if (this.queryParams_.hasLimit()) {
            throw new Error('Query.limitToFirst: Limit was already set (by another call to limit, ' + 'limitToFirst, or limitToLast).');
        }
        return new Query(this.repo, this.path, this.queryParams_.limitToFirst(limit), this.orderByCalled_);
    };
    /**
     * Set a limit and anchor it to the end of the window.
     * @param {!number} limit
     * @return {!Query}
     */
    Query.prototype.limitToLast = function (limit) {
        (0, _validation2.validateArgCount)('Query.limitToLast', 1, 1, arguments.length);
        if (typeof limit !== 'number' || Math.floor(limit) !== limit || limit <= 0) {
            throw new Error('Query.limitToLast: First argument must be a positive integer.');
        }
        if (this.queryParams_.hasLimit()) {
            throw new Error('Query.limitToLast: Limit was already set (by another call to limit, ' + 'limitToFirst, or limitToLast).');
        }
        return new Query(this.repo, this.path, this.queryParams_.limitToLast(limit), this.orderByCalled_);
    };
    /**
     * Given a child path, return a new query ordered by the specified grandchild path.
     * @param {!string} path
     * @return {!Query}
     */
    Query.prototype.orderByChild = function (path) {
        (0, _validation2.validateArgCount)('Query.orderByChild', 1, 1, arguments.length);
        if (path === '$key') {
            throw new Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');
        } else if (path === '$priority') {
            throw new Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');
        } else if (path === '$value') {
            throw new Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');
        }
        (0, _validation.validatePathString)('Query.orderByChild', 1, path, false);
        this.validateNoPreviousOrderByCall_('Query.orderByChild');
        var parsedPath = new _Path.Path(path);
        if (parsedPath.isEmpty()) {
            throw new Error('Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.');
        }
        var index = new _PathIndex.PathIndex(parsedPath);
        var newParams = this.queryParams_.orderBy(index);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/true);
    };
    /**
     * Return a new query ordered by the KeyIndex
     * @return {!Query}
     */
    Query.prototype.orderByKey = function () {
        (0, _validation2.validateArgCount)('Query.orderByKey', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByKey');
        var newParams = this.queryParams_.orderBy(_KeyIndex.KEY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/true);
    };
    /**
     * Return a new query ordered by the PriorityIndex
     * @return {!Query}
     */
    Query.prototype.orderByPriority = function () {
        (0, _validation2.validateArgCount)('Query.orderByPriority', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByPriority');
        var newParams = this.queryParams_.orderBy(_PriorityIndex.PRIORITY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/true);
    };
    /**
     * Return a new query ordered by the ValueIndex
     * @return {!Query}
     */
    Query.prototype.orderByValue = function () {
        (0, _validation2.validateArgCount)('Query.orderByValue', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByValue');
        var newParams = this.queryParams_.orderBy(_ValueIndex.VALUE_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/true);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */
    Query.prototype.startAt = function (value, name) {
        if (value === void 0) {
            value = null;
        }
        (0, _validation2.validateArgCount)('Query.startAt', 0, 2, arguments.length);
        (0, _validation.validateFirebaseDataArg)('Query.startAt', 1, value, this.path, true);
        (0, _validation.validateKey)('Query.startAt', 2, name, true);
        var newParams = this.queryParams_.startAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasStart()) {
            throw new Error('Query.startAt: Starting point was already set (by another call to startAt ' + 'or equalTo).');
        }
        // Calling with no params tells us to start at the beginning.
        if (value === undefined) {
            value = null;
            name = null;
        }
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */
    Query.prototype.endAt = function (value, name) {
        if (value === void 0) {
            value = null;
        }
        (0, _validation2.validateArgCount)('Query.endAt', 0, 2, arguments.length);
        (0, _validation.validateFirebaseDataArg)('Query.endAt', 1, value, this.path, true);
        (0, _validation.validateKey)('Query.endAt', 2, name, true);
        var newParams = this.queryParams_.endAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasEnd()) {
            throw new Error('Query.endAt: Ending point was already set (by another call to endAt or ' + 'equalTo).');
        }
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * Load the selection of children with exactly the specified value, and, optionally,
     * the specified name.
     * @param {number|string|boolean|null} value
     * @param {string=} name
     * @return {!Query}
     */
    Query.prototype.equalTo = function (value, name) {
        (0, _validation2.validateArgCount)('Query.equalTo', 1, 2, arguments.length);
        (0, _validation.validateFirebaseDataArg)('Query.equalTo', 1, value, this.path, false);
        (0, _validation.validateKey)('Query.equalTo', 2, name, true);
        if (this.queryParams_.hasStart()) {
            throw new Error('Query.equalTo: Starting point was already set (by another call to startAt or ' + 'equalTo).');
        }
        if (this.queryParams_.hasEnd()) {
            throw new Error('Query.equalTo: Ending point was already set (by another call to endAt or ' + 'equalTo).');
        }
        return this.startAt(value, name).endAt(value, name);
    };
    /**
     * @return {!string} URL for this location.
     */
    Query.prototype.toString = function () {
        (0, _validation2.validateArgCount)('Query.toString', 0, 0, arguments.length);
        return this.repo.toString() + this.path.toUrlEncodedString();
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users.
    Query.prototype.toJSON = function () {
        // An optional spacer argument is unnecessary for a string.
        (0, _validation2.validateArgCount)('Query.toJSON', 0, 1, arguments.length);
        return this.toString();
    };
    /**
     * An object representation of the query parameters used by this Query.
     * @return {!Object}
     */
    Query.prototype.queryObject = function () {
        return this.queryParams_.getQueryObject();
    };
    /**
     * @return {!string}
     */
    Query.prototype.queryIdentifier = function () {
        var obj = this.queryObject();
        var id = (0, _util.ObjectToUniqueKey)(obj);
        return id === '{}' ? 'default' : id;
    };
    /**
     * Return true if this query and the provided query are equivalent; otherwise, return false.
     * @param {Query} other
     * @return {boolean}
     */
    Query.prototype.isEqual = function (other) {
        (0, _validation2.validateArgCount)('Query.isEqual', 1, 1, arguments.length);
        if (!(other instanceof Query)) {
            var error = 'Query.isEqual failed: First argument must be an instance of firebase.database.Query.';
            throw new Error(error);
        }
        var sameRepo = this.repo === other.repo;
        var samePath = this.path.equals(other.path);
        var sameQueryIdentifier = this.queryIdentifier() === other.queryIdentifier();
        return sameRepo && samePath && sameQueryIdentifier;
    };
    /**
     * Helper used by .on and .once to extract the context and or cancel arguments.
     * @param {!string} fnName The function name (on or once)
     * @param {(function(Error)|Object)=} cancelOrContext
     * @param {Object=} context
     * @return {{cancel: ?function(Error), context: ?Object}}
     * @private
     */
    Query.getCancelAndContextArgs_ = function (fnName, cancelOrContext, context) {
        var ret = { cancel: null, context: null };
        if (cancelOrContext && context) {
            ret.cancel = cancelOrContext;
            (0, _validation2.validateCallback)(fnName, 3, ret.cancel, true);
            ret.context = context;
            (0, _validation2.validateContextObject)(fnName, 4, ret.context, true);
        } else if (cancelOrContext) {
            // we have either a cancel callback or a context.
            if ((typeof cancelOrContext === 'undefined' ? 'undefined' : _typeof(cancelOrContext)) === 'object' && cancelOrContext !== null) {
                // it's a context!
                ret.context = cancelOrContext;
            } else if (typeof cancelOrContext === 'function') {
                ret.cancel = cancelOrContext;
            } else {
                throw new Error((0, _validation2.errorPrefix)(fnName, 3, true) + ' must either be a cancel callback or a context object.');
            }
        }
        return ret;
    };
    Object.defineProperty(Query.prototype, "ref", {
        get: function get() {
            return this.getRef();
        },
        enumerable: true,
        configurable: true
    });
    return Query;
}();
exports.Query = Query;
//# sourceMappingURL=Query.js.map


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PersistentConnection = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _app = __webpack_require__(34);

var _app2 = _interopRequireDefault(_app);

var _obj = __webpack_require__(7);

var _json = __webpack_require__(23);

var _assert = __webpack_require__(2);

var _util = __webpack_require__(3);

var _Path = __webpack_require__(9);

var _VisibilityMonitor = __webpack_require__(398);

var _OnlineMonitor = __webpack_require__(396);

var _jwt = __webpack_require__(438);

var _Connection = __webpack_require__(181);

var _constants = __webpack_require__(86);

var _environment = __webpack_require__(50);

var _ServerActions = __webpack_require__(163);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();

var RECONNECT_MIN_DELAY = 1000;
var RECONNECT_MAX_DELAY_DEFAULT = 60 * 5 * 1000; // 5 minutes in milliseconds (Case: 1858)
var RECONNECT_MAX_DELAY_FOR_ADMINS = 30 * 1000; // 30 seconds for admin clients (likely to be a backend server)
var RECONNECT_DELAY_MULTIPLIER = 1.3;
var RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
var SERVER_KILL_INTERRUPT_REASON = 'server_kill';
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
var INVALID_AUTH_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */
var PersistentConnection = /** @class */function (_super) {
    __extends(PersistentConnection, _super);
    /**
     * @implements {ServerActions}
     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
     * @param onConnectStatus_
     * @param onServerInfoUpdate_
     * @param authTokenProvider_
     * @param authOverride_
     */
    function PersistentConnection(repoInfo_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, authOverride_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.onConnectStatus_ = onConnectStatus_;
        _this.onServerInfoUpdate_ = onServerInfoUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        _this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        _this.id = PersistentConnection.nextPersistentConnectionId_++;
        _this.log_ = (0, _util.logWrapper)('p:' + _this.id + ':');
        /** @private {Object} */
        _this.interruptReasons_ = {};
        _this.listens_ = {};
        _this.outstandingPuts_ = [];
        _this.outstandingPutCount_ = 0;
        _this.onDisconnectRequestQueue_ = [];
        _this.connected_ = false;
        _this.reconnectDelay_ = RECONNECT_MIN_DELAY;
        _this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_DEFAULT;
        _this.securityDebugCallback_ = null;
        _this.lastSessionId = null;
        /** @private {number|null} */
        _this.establishConnectionTimer_ = null;
        /** @private {boolean} */
        _this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        _this.requestCBHash_ = {};
        _this.requestNumber_ = 0;
        /** @private {?{
         *   sendRequest(Object),
         *   close()
         * }} */
        _this.realtime_ = null;
        /** @private {string|null} */
        _this.authToken_ = null;
        _this.forceTokenRefresh_ = false;
        _this.invalidAuthTokenCount_ = 0;
        _this.firstConnection_ = true;
        _this.lastConnectionAttemptTime_ = null;
        _this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !(0, _environment.isNodeSdk)()) {
            throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
        }
        _this.scheduleConnect_(0);
        _VisibilityMonitor.VisibilityMonitor.getInstance().on('visible', _this.onVisible_, _this);
        if (repoInfo_.host.indexOf('fblocal') === -1) {
            _OnlineMonitor.OnlineMonitor.getInstance().on('online', _this.onOnline_, _this);
        }
        return _this;
    }
    /**
     * @param {!string} action
     * @param {*} body
     * @param {function(*)=} onResponse
     * @protected
     */
    PersistentConnection.prototype.sendRequest = function (action, body, onResponse) {
        var curReqNum = ++this.requestNumber_;
        var msg = { r: curReqNum, a: action, b: body };
        this.log_((0, _json.stringify)(msg));
        (0, _assert.assert)(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) {
            this.requestCBHash_[curReqNum] = onResponse;
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.listen = function (query, currentHashFn, tag, onComplete) {
        var queryId = query.queryIdentifier();
        var pathString = query.path.toString();
        this.log_('Listen called for ' + pathString + ' ' + queryId);
        this.listens_[pathString] = this.listens_[pathString] || {};
        (0, _assert.assert)(query.getQueryParams().isDefault() || !query.getQueryParams().loadsAllData(), 'listen() called for non-default but complete query');
        (0, _assert.assert)(!this.listens_[pathString][queryId], 'listen() called twice for same path/queryId.');
        var listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens_[pathString][queryId] = listenSpec;
        if (this.connected_) {
            this.sendListen_(listenSpec);
        }
    };
    /**
     * @param {!{onComplete(),
     *           hashFn():!string,
     *           query: !Query,
     *           tag: ?number}} listenSpec
     * @private
     */
    PersistentConnection.prototype.sendListen_ = function (listenSpec) {
        var _this = this;
        var query = listenSpec.query;
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_('Listen on ' + pathString + ' for ' + queryId);
        var req = { /*path*/p: pathString };
        var action = 'q';
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req['q'] = query.queryObject();
            req['t'] = listenSpec.tag;
        }
        req['h'] = listenSpec.hashFn();
        this.sendRequest(action, req, function (message) {
            var payload = message['d'];
            var status = message['s'];
            // print warnings in any case...
            PersistentConnection.warnOnListenWarnings_(payload, query);
            var currentListenSpec = _this.listens_[pathString] && _this.listens_[pathString][queryId];
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                _this.log_('listen response', message);
                if (status !== 'ok') {
                    _this.removeListen_(pathString, queryId);
                }
                if (listenSpec.onComplete) {
                    listenSpec.onComplete(status, payload);
                }
            }
        });
    };
    /**
     * @param {*} payload
     * @param {!Query} query
     * @private
     */
    PersistentConnection.warnOnListenWarnings_ = function (payload, query) {
        if (payload && (typeof payload === 'undefined' ? 'undefined' : _typeof(payload)) === 'object' && (0, _obj.contains)(payload, 'w')) {
            var warnings = (0, _obj.safeGet)(payload, 'w');
            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
                var indexSpec = '".indexOn": "' + query.getQueryParams().getIndex().toString() + '"';
                var indexPath = query.path.toString();
                (0, _util.warn)("Using an unspecified index. Your data will be downloaded and " + ("filtered on the client. Consider adding " + indexSpec + " at ") + (indexPath + " to your security rules for better performance."));
            }
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.refreshAuthToken = function (token) {
        this.authToken_ = token;
        this.log_('Auth token refreshed');
        if (this.authToken_) {
            this.tryAuth();
        } else {
            //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
            //the credential so we dont become authenticated next time we connect.
            if (this.connected_) {
                this.sendRequest('unauth', {}, function () {});
            }
        }
        this.reduceReconnectDelayIfAdminCredential_(token);
    };
    /**
     * @param {!string} credential
     * @private
     */
    PersistentConnection.prototype.reduceReconnectDelayIfAdminCredential_ = function (credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        var isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || (0, _jwt.isAdmin)(credential)) {
            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
            this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    };
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */
    PersistentConnection.prototype.tryAuth = function () {
        var _this = this;
        if (this.connected_ && this.authToken_) {
            var token_1 = this.authToken_;
            var authMethod = (0, _jwt.isValidFormat)(token_1) ? 'auth' : 'gauth';
            var requestData = { cred: token_1 };
            if (this.authOverride_ === null) {
                requestData['noauth'] = true;
            } else if (_typeof(this.authOverride_) === 'object') {
                requestData['authvar'] = this.authOverride_;
            }
            this.sendRequest(authMethod, requestData, function (res) {
                var status = res['s'];
                var data = res['d'] || 'error';
                if (_this.authToken_ === token_1) {
                    if (status === 'ok') {
                        _this.invalidAuthTokenCount_ = 0;
                    } else {
                        // Triggers reconnect and force refresh for auth token
                        _this.onAuthRevoked_(status, data);
                    }
                }
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.unlisten = function (query, tag) {
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
        (0, _assert.assert)(query.getQueryParams().isDefault() || !query.getQueryParams().loadsAllData(), 'unlisten() called for non-default but complete query');
        var listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) {
            this.sendUnlisten_(pathString, queryId, query.queryObject(), tag);
        }
    };
    PersistentConnection.prototype.sendUnlisten_ = function (pathString, queryId, queryObj, tag) {
        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
        var req = { /*path*/p: pathString };
        var action = 'n';
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req['q'] = queryObj;
            req['t'] = tag;
        }
        this.sendRequest(action, req);
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectPut = function (pathString, data, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('o', pathString, data, onComplete);
        } else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'o',
                data: data,
                onComplete: onComplete
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectMerge = function (pathString, data, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('om', pathString, data, onComplete);
        } else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'om',
                data: data,
                onComplete: onComplete
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectCancel = function (pathString, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('oc', pathString, null, onComplete);
        } else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'oc',
                data: null,
                onComplete: onComplete
            });
        }
    };
    PersistentConnection.prototype.sendOnDisconnect_ = function (action, pathString, data, onComplete) {
        var request = { /*path*/p: pathString, /*data*/d: data };
        this.log_('onDisconnect ' + action, request);
        this.sendRequest(action, request, function (response) {
            if (onComplete) {
                setTimeout(function () {
                    onComplete(response['s'], response['d']);
                }, Math.floor(0));
            }
        });
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.put = function (pathString, data, onComplete, hash) {
        this.putInternal('p', pathString, data, onComplete, hash);
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.merge = function (pathString, data, onComplete, hash) {
        this.putInternal('m', pathString, data, onComplete, hash);
    };
    PersistentConnection.prototype.putInternal = function (action, pathString, data, onComplete, hash) {
        var request = {
            /*path*/p: pathString,
            /*data*/d: data
        };
        if (hash !== undefined) request['h'] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        var index = this.outstandingPuts_.length - 1;
        if (this.connected_) {
            this.sendPut_(index);
        } else {
            this.log_('Buffering put: ' + pathString);
        }
    };
    PersistentConnection.prototype.sendPut_ = function (index) {
        var _this = this;
        var action = this.outstandingPuts_[index].action;
        var request = this.outstandingPuts_[index].request;
        var onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, function (message) {
            _this.log_(action + ' response', message);
            delete _this.outstandingPuts_[index];
            _this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (_this.outstandingPutCount_ === 0) {
                _this.outstandingPuts_ = [];
            }
            if (onComplete) onComplete(message['s'], message['d']);
        });
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.reportStats = function (stats) {
        var _this = this;
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            var request = { /*counters*/c: stats };
            this.log_('reportStats', request);
            this.sendRequest( /*stats*/'s', request, function (result) {
                var status = result['s'];
                if (status !== 'ok') {
                    var errorReason = result['d'];
                    _this.log_('reportStats', 'Error sending stats: ' + errorReason);
                }
            });
        }
    };
    /**
     * @param {*} message
     * @private
     */
    PersistentConnection.prototype.onDataMessage_ = function (message) {
        if ('r' in message) {
            // this is a response
            this.log_('from server: ' + (0, _json.stringify)(message));
            var reqNum = message['r'];
            var onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message['b']);
            }
        } else if ('error' in message) {
            throw 'A server-side error has occurred: ' + message['error'];
        } else if ('a' in message) {
            // a and b are action and body, respectively
            this.onDataPush_(message['a'], message['b']);
        }
    };
    PersistentConnection.prototype.onDataPush_ = function (action, body) {
        this.log_('handleServerMessage', action, body);
        if (action === 'd') this.onDataUpdate_(body['p'], body['d'],
        /*isMerge*/false, body['t']);else if (action === 'm') this.onDataUpdate_(body['p'], body['d'],
        /*isMerge=*/true, body['t']);else if (action === 'c') this.onListenRevoked_(body['p'], body['q']);else if (action === 'ac') this.onAuthRevoked_(body['s'], body['d']);else if (action === 'sd') this.onSecurityDebugPacket_(body);else (0, _util.error)('Unrecognized action received from server: ' + (0, _json.stringify)(action) + '\nAre you using the latest client?');
    };
    PersistentConnection.prototype.onReady_ = function (timestamp, sessionId) {
        this.log_('connection ready');
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) {
            this.sendConnectStats_();
        }
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    };
    PersistentConnection.prototype.scheduleConnect_ = function (timeout) {
        var _this = this;
        (0, _assert.assert)(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) {
            clearTimeout(this.establishConnectionTimer_);
        }
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(function () {
            _this.establishConnectionTimer_ = null;
            _this.establishConnection_();
        }, Math.floor(timeout));
    };
    /**
     * @param {boolean} visible
     * @private
     */
    PersistentConnection.prototype.onVisible_ = function (visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible && !this.visible_ && this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_('Window became visible.  Reducing delay.');
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
        this.visible_ = visible;
    };
    PersistentConnection.prototype.onOnline_ = function (online) {
        if (online) {
            this.log_('Browser went online.');
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        } else {
            this.log_('Browser went offline.  Killing connection.');
            if (this.realtime_) {
                this.realtime_.close();
            }
        }
    };
    PersistentConnection.prototype.onRealtimeDisconnect_ = function () {
        this.log_('data client disconnected');
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            } else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                var timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > RECONNECT_DELAY_RESET_TIMEOUT) this.reconnectDelay_ = RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            var timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
            var reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    };
    PersistentConnection.prototype.establishConnection_ = function () {
        if (this.shouldReconnect_()) {
            this.log_('Making a connection attempt');
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            var onDataMessage_1 = this.onDataMessage_.bind(this);
            var onReady_1 = this.onReady_.bind(this);
            var onDisconnect_1 = this.onRealtimeDisconnect_.bind(this);
            var connId_1 = this.id + ':' + PersistentConnection.nextConnectionId_++;
            var self_1 = this;
            var lastSessionId_1 = this.lastSessionId;
            var canceled_1 = false;
            var connection_1 = null;
            var closeFn_1 = function closeFn_1() {
                if (connection_1) {
                    connection_1.close();
                } else {
                    canceled_1 = true;
                    onDisconnect_1();
                }
            };
            var sendRequestFn = function sendRequestFn(msg) {
                (0, _assert.assert)(connection_1, "sendRequest call when we're not connected not allowed.");
                connection_1.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn_1,
                sendRequest: sendRequestFn
            };
            var forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            // First fetch auth token, and establish connection after fetching the token was successful
            this.authTokenProvider_.getToken(forceRefresh).then(function (result) {
                if (!canceled_1) {
                    (0, _util.log)('getToken() completed. Creating connection.');
                    self_1.authToken_ = result && result.accessToken;
                    connection_1 = new _Connection.Connection(connId_1, self_1.repoInfo_, onDataMessage_1, onReady_1, onDisconnect_1,
                    /* onKill= */function (reason) {
                        (0, _util.warn)(reason + ' (' + self_1.repoInfo_.toString() + ')');
                        self_1.interrupt(SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId_1);
                } else {
                    (0, _util.log)('getToken() completed but was canceled');
                }
            }).then(null, function (error) {
                self_1.log_('Failed to get token: ' + error);
                if (!canceled_1) {
                    if (_constants.CONSTANTS.NODE_ADMIN) {
                        // This may be a critical error for the Admin Node.js SDK, so log a warning.
                        // But getToken() may also just have temporarily failed, so we still want to
                        // continue retrying.
                        (0, _util.warn)(error);
                    }
                    closeFn_1();
                }
            });
        }
    };
    /**
     * @param {string} reason
     */
    PersistentConnection.prototype.interrupt = function (reason) {
        (0, _util.log)('Interrupting connection for reason: ' + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) {
            this.realtime_.close();
        } else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) {
                this.onRealtimeDisconnect_();
            }
        }
    };
    /**
     * @param {string} reason
     */
    PersistentConnection.prototype.resume = function (reason) {
        (0, _util.log)('Resuming connection for reason: ' + reason);
        delete this.interruptReasons_[reason];
        if ((0, _obj.isEmpty)(this.interruptReasons_)) {
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
    };
    PersistentConnection.prototype.handleTimestamp_ = function (timestamp) {
        var delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({ serverTimeOffset: delta });
    };
    PersistentConnection.prototype.cancelSentTransactions_ = function () {
        for (var i = 0; i < this.outstandingPuts_.length; i++) {
            var put = this.outstandingPuts_[i];
            if (put && /*hash*/'h' in put.request && put.queued) {
                if (put.onComplete) put.onComplete('disconnect');
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
    };
    /**
     * @param {!string} pathString
     * @param {Array.<*>=} query
     * @private
     */
    PersistentConnection.prototype.onListenRevoked_ = function (pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        var queryId;
        if (!query) {
            queryId = 'default';
        } else {
            queryId = query.map(function (q) {
                return (0, _util.ObjectToUniqueKey)(q);
            }).join('$');
        }
        var listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete) listen.onComplete('permission_denied');
    };
    /**
     * @param {!string} pathString
     * @param {!string} queryId
     * @return {{queries:Array.<Query>, onComplete:function(string)}}
     * @private
     */
    PersistentConnection.prototype.removeListen_ = function (pathString, queryId) {
        var normalizedPathString = new _Path.Path(pathString).toString(); // normalize path.
        var listen;
        if (this.listens_[normalizedPathString] !== undefined) {
            listen = this.listens_[normalizedPathString][queryId];
            delete this.listens_[normalizedPathString][queryId];
            if ((0, _obj.getCount)(this.listens_[normalizedPathString]) === 0) {
                delete this.listens_[normalizedPathString];
            }
        } else {
            // all listens for this path has already been removed
            listen = undefined;
        }
        return listen;
    };
    PersistentConnection.prototype.onAuthRevoked_ = function (statusCode, explanation) {
        (0, _util.log)('Auth token revoked: ' + statusCode + '/' + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= INVALID_AUTH_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    };
    PersistentConnection.prototype.onSecurityDebugPacket_ = function (body) {
        if (this.securityDebugCallback_) {
            this.securityDebugCallback_(body);
        } else {
            if ('msg' in body && typeof console !== 'undefined') {
                console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
            }
        }
    };
    PersistentConnection.prototype.restoreState_ = function () {
        var _this = this;
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        // Puts depend on having received the corresponding data update from the server before they complete, so we must
        // make sure to send listens before puts.
        (0, _obj.forEach)(this.listens_, function (pathString, queries) {
            (0, _obj.forEach)(queries, function (key, listenSpec) {
                _this.sendListen_(listenSpec);
            });
        });
        for (var i = 0; i < this.outstandingPuts_.length; i++) {
            if (this.outstandingPuts_[i]) this.sendPut_(i);
        }
        while (this.onDisconnectRequestQueue_.length) {
            var request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
    };
    /**
     * Sends client stats for first connection
     * @private
     */
    PersistentConnection.prototype.sendConnectStats_ = function () {
        var stats = {};
        var clientName = 'js';
        if (_constants.CONSTANTS.NODE_ADMIN) {
            clientName = 'admin_node';
        } else if (_constants.CONSTANTS.NODE_CLIENT) {
            clientName = 'node';
        }
        stats['sdk.' + clientName + '.' + _app2.default.SDK_VERSION.replace(/\./g, '-')] = 1;
        if ((0, _environment.isMobileCordova)()) {
            stats['framework.cordova'] = 1;
        } else if ((0, _environment.isReactNative)()) {
            stats['framework.reactnative'] = 1;
        }
        this.reportStats(stats);
    };
    /**
     * @return {boolean}
     * @private
     */
    PersistentConnection.prototype.shouldReconnect_ = function () {
        var online = _OnlineMonitor.OnlineMonitor.getInstance().currentlyOnline();
        return (0, _obj.isEmpty)(this.interruptReasons_) && online;
    };
    /**
     * @private
     */
    PersistentConnection.nextPersistentConnectionId_ = 0;
    /**
     * Counter for number of connections created. Mainly used for tagging in the logs
     * @type {number}
     * @private
     */
    PersistentConnection.nextConnectionId_ = 0;
    return PersistentConnection;
}(_ServerActions.ServerActions);
exports.PersistentConnection = PersistentConnection;
//# sourceMappingURL=PersistentConnection.js.map


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RepoInfo = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Copyright 2017 Google Inc.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Licensed under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                               * you may not use this file except in compliance with the License.
                                                                                                                                                                                                                                                                               * You may obtain a copy of the License at
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               *   http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Unless required by applicable law or agreed to in writing, software
                                                                                                                                                                                                                                                                               * distributed under the License is distributed on an "AS IS" BASIS,
                                                                                                                                                                                                                                                                               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                                                                                                                                                                                                               * See the License for the specific language governing permissions and
                                                                                                                                                                                                                                                                               * limitations under the License.
                                                                                                                                                                                                                                                                               */


var _assert = __webpack_require__(2);

var _obj = __webpack_require__(7);

var _storage = __webpack_require__(80);

var _Constants = __webpack_require__(82);

/**
 * A class that holds metadata about a Repo object
 *
 * @constructor
 */
var RepoInfo = /** @class */function () {
    /**
     * @param {string} host Hostname portion of the url for the repo
     * @param {boolean} secure Whether or not this repo is accessed over ssl
     * @param {string} namespace The namespace represented by the repo
     * @param {boolean} webSocketOnly Whether to prefer websockets over all other transports (used by Nest).
     * @param {string=} persistenceKey Override the default session persistence storage key
     */
    function RepoInfo(host, secure, namespace, webSocketOnly, persistenceKey) {
        if (persistenceKey === void 0) {
            persistenceKey = '';
        }
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.persistenceKey = persistenceKey;
        this.host = host.toLowerCase();
        this.domain = this.host.substr(this.host.indexOf('.') + 1);
        this.internalHost = _storage.PersistentStorage.get('host:' + host) || this.host;
    }
    RepoInfo.prototype.needsQueryParam = function () {
        return this.host !== this.internalHost;
    };
    RepoInfo.prototype.isCacheableHost = function () {
        return this.internalHost.substr(0, 2) === 's-';
    };
    RepoInfo.prototype.isDemoHost = function () {
        return this.domain === 'firebaseio-demo.com';
    };
    RepoInfo.prototype.isCustomHost = function () {
        return this.domain !== 'firebaseio.com' && this.domain !== 'firebaseio-demo.com';
    };
    RepoInfo.prototype.updateHost = function (newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) {
                _storage.PersistentStorage.set('host:' + this.host, this.internalHost);
            }
        }
    };
    /**
     * Returns the websocket URL for this repo
     * @param {string} type of connection
     * @param {Object} params list
     * @return {string} The URL for this repo
     */
    RepoInfo.prototype.connectionURL = function (type, params) {
        (0, _assert.assert)(typeof type === 'string', 'typeof type must == string');
        (0, _assert.assert)((typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object', 'typeof params must == object');
        var connURL;
        if (type === _Constants.WEBSOCKET) {
            connURL = (this.secure ? 'wss://' : 'ws://') + this.internalHost + '/.ws?';
        } else if (type === _Constants.LONG_POLLING) {
            connURL = (this.secure ? 'https://' : 'http://') + this.internalHost + '/.lp?';
        } else {
            throw new Error('Unknown connection type: ' + type);
        }
        if (this.needsQueryParam()) {
            params['ns'] = this.namespace;
        }
        var pairs = [];
        (0, _obj.forEach)(params, function (key, value) {
            pairs.push(key + '=' + value);
        });
        return connURL + pairs.join('&');
    };
    /** @return {string} */
    RepoInfo.prototype.toString = function () {
        var str = this.toURLString();
        if (this.persistenceKey) {
            str += '<' + this.persistenceKey + '>';
        }
        return str;
    };
    /** @return {string} */
    RepoInfo.prototype.toURLString = function () {
        return (this.secure ? 'https://' : 'http://') + this.host;
    };
    return RepoInfo;
}();
exports.RepoInfo = RepoInfo;
//# sourceMappingURL=RepoInfo.js.map


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */
var ServerActions = /** @class */function () {
  function ServerActions() {}
  /**
   * @param {string} pathString
   * @param {*} data
   * @param {function(string, string)=} onComplete
   * @param {string=} hash
   */
  ServerActions.prototype.put = function (pathString, data, onComplete, hash) {};
  /**
   * @param {string} pathString
   * @param {*} data
   * @param {function(string, ?string)} onComplete
   * @param {string=} hash
   */
  ServerActions.prototype.merge = function (pathString, data, onComplete, hash) {};
  /**
   * Refreshes the auth token for the current connection.
   * @param {string} token The authentication token
   */
  ServerActions.prototype.refreshAuthToken = function (token) {};
  /**
   * @param {string} pathString
   * @param {*} data
   * @param {function(string, string)=} onComplete
   */
  ServerActions.prototype.onDisconnectPut = function (pathString, data, onComplete) {};
  /**
   * @param {string} pathString
   * @param {*} data
   * @param {function(string, string)=} onComplete
   */
  ServerActions.prototype.onDisconnectMerge = function (pathString, data, onComplete) {};
  /**
   * @param {string} pathString
   * @param {function(string, string)=} onComplete
   */
  ServerActions.prototype.onDisconnectCancel = function (pathString, onComplete) {};
  /**
   * @param {Object.<string, *>} stats
   */
  ServerActions.prototype.reportStats = function (stats) {};
  return ServerActions;
}();
exports.ServerActions = ServerActions;
//# sourceMappingURL=ServerActions.js.map


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SparseSnapshotTree = undefined;

var _Path = __webpack_require__(9);

var _PriorityIndex = __webpack_require__(15);

var _CountedSet = __webpack_require__(174);

/**
 * Helper class to store a sparse set of snapshots.
 *
 * @constructor
 */
var SparseSnapshotTree = /** @class */function () {
    function SparseSnapshotTree() {
        /**
         * @private
         * @type {Node}
         */
        this.value_ = null;
        /**
         * @private
         * @type {CountedSet}
         */
        this.children_ = null;
    }
    /**
     * Gets the node stored at the given path if one exists.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @return {?Node} The retrieved node, or null.
     */
    SparseSnapshotTree.prototype.find = function (path) {
        if (this.value_ != null) {
            return this.value_.getChild(path);
        } else if (!path.isEmpty() && this.children_ != null) {
            var childKey = path.getFront();
            path = path.popFront();
            if (this.children_.contains(childKey)) {
                var childTree = this.children_.get(childKey);
                return childTree.find(path);
            } else {
                return null;
            }
        } else {
            return null;
        }
    };
    /**
     * Stores the given node at the specified path. If there is already a node
     * at a shallower path, it merges the new data into that snapshot node.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @param {!Node} data The new data, or null.
     */
    SparseSnapshotTree.prototype.remember = function (path, data) {
        if (path.isEmpty()) {
            this.value_ = data;
            this.children_ = null;
        } else if (this.value_ !== null) {
            this.value_ = this.value_.updateChild(path, data);
        } else {
            if (this.children_ == null) {
                this.children_ = new _CountedSet.CountedSet();
            }
            var childKey = path.getFront();
            if (!this.children_.contains(childKey)) {
                this.children_.add(childKey, new SparseSnapshotTree());
            }
            var child = this.children_.get(childKey);
            path = path.popFront();
            child.remember(path, data);
        }
    };
    /**
     * Purge the data at path from the cache.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @return {boolean} True if this node should now be removed.
     */
    SparseSnapshotTree.prototype.forget = function (path) {
        if (path.isEmpty()) {
            this.value_ = null;
            this.children_ = null;
            return true;
        } else {
            if (this.value_ !== null) {
                if (this.value_.isLeafNode()) {
                    // We're trying to forget a node that doesn't exist
                    return false;
                } else {
                    var value = this.value_;
                    this.value_ = null;
                    var self_1 = this;
                    value.forEachChild(_PriorityIndex.PRIORITY_INDEX, function (key, tree) {
                        self_1.remember(new _Path.Path(key), tree);
                    });
                    return this.forget(path);
                }
            } else if (this.children_ !== null) {
                var childKey = path.getFront();
                path = path.popFront();
                if (this.children_.contains(childKey)) {
                    var safeToRemove = this.children_.get(childKey).forget(path);
                    if (safeToRemove) {
                        this.children_.remove(childKey);
                    }
                }
                if (this.children_.isEmpty()) {
                    this.children_ = null;
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        }
    };
    /**
     * Recursively iterates through all of the stored tree and calls the
     * callback on each one.
     *
     * @param {!Path} prefixPath Path to look up node for.
     * @param {!Function} func The function to invoke for each tree.
     */
    SparseSnapshotTree.prototype.forEachTree = function (prefixPath, func) {
        if (this.value_ !== null) {
            func(prefixPath, this.value_);
        } else {
            this.forEachChild(function (key, tree) {
                var path = new _Path.Path(prefixPath.toString() + '/' + key);
                tree.forEachTree(path, func);
            });
        }
    };
    /**
     * Iterates through each immediate child and triggers the callback.
     *
     * @param {!Function} func The function to invoke for each child.
     */
    SparseSnapshotTree.prototype.forEachChild = function (func) {
        if (this.children_ !== null) {
            this.children_.each(function (key, tree) {
                func(key, tree);
            });
        }
    };
    return SparseSnapshotTree;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.SparseSnapshotTree = SparseSnapshotTree;
//# sourceMappingURL=SparseSnapshotTree.js.map


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SyncPoint = undefined;

var _CacheNode = __webpack_require__(81);

var _ChildrenNode = __webpack_require__(16);

var _assert = __webpack_require__(2);

var _obj = __webpack_require__(7);

var _ViewCache = __webpack_require__(178);

var _View = __webpack_require__(406);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __referenceConstructor;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */
var SyncPoint = /** @class */function () {
    function SyncPoint() {
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         *
         * @type {!Object.<!string, !View>}
         * @private
         */
        this.views_ = {};
    }
    Object.defineProperty(SyncPoint, "__referenceConstructor", {
        get: function get() {
            (0, _assert.assert)(__referenceConstructor, 'Reference.ts has not been loaded');
            return __referenceConstructor;
        },
        set: function set(val) {
            (0, _assert.assert)(!__referenceConstructor, '__referenceConstructor has already been defined');
            __referenceConstructor = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {boolean}
     */
    SyncPoint.prototype.isEmpty = function () {
        return (0, _obj.isEmpty)(this.views_);
    };
    /**
     *
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} optCompleteServerCache
     * @return {!Array.<!Event>}
     */
    SyncPoint.prototype.applyOperation = function (operation, writesCache, optCompleteServerCache) {
        var queryId = operation.source.queryId;
        if (queryId !== null) {
            var view = (0, _obj.safeGet)(this.views_, queryId);
            (0, _assert.assert)(view != null, 'SyncTree gave us an op for an invalid query.');
            return view.applyOperation(operation, writesCache, optCompleteServerCache);
        } else {
            var events_1 = [];
            (0, _obj.forEach)(this.views_, function (key, view) {
                events_1 = events_1.concat(view.applyOperation(operation, writesCache, optCompleteServerCache));
            });
            return events_1;
        }
    };
    /**
     * Add an event callback for the specified query.
     *
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache Complete server cache, if we have it.
     * @param {boolean} serverCacheComplete
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncPoint.prototype.addEventRegistration = function (query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
        var queryId = query.queryIdentifier();
        var view = (0, _obj.safeGet)(this.views_, queryId);
        if (!view) {
            // TODO: make writesCache take flag for complete server node
            var eventCache = writesCache.calcCompleteEventCache(serverCacheComplete ? serverCache : null);
            var eventCacheComplete = false;
            if (eventCache) {
                eventCacheComplete = true;
            } else if (serverCache instanceof _ChildrenNode.ChildrenNode) {
                eventCache = writesCache.calcCompleteEventChildren(serverCache);
                eventCacheComplete = false;
            } else {
                eventCache = _ChildrenNode.ChildrenNode.EMPTY_NODE;
                eventCacheComplete = false;
            }
            var viewCache = new _ViewCache.ViewCache(new _CacheNode.CacheNode /** @type {!Node} */ /** @type {!Node} */(eventCache, eventCacheComplete, false), new _CacheNode.CacheNode(serverCache, serverCacheComplete, false));
            view = new _View.View(query, viewCache);
            this.views_[queryId] = view;
        }
        // This is guaranteed to exist now, we just created anything that was missing
        view.addEventRegistration(eventRegistration);
        return view.getInitialEvents(eventRegistration);
    };
    /**
     * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
     *
     * If query is the default query, we'll check all views for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
     *
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {{removed:!Array.<!Query>, events:!Array.<!Event>}} removed queries and any cancel events
     */
    SyncPoint.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
        var queryId = query.queryIdentifier();
        var removed = [];
        var cancelEvents = [];
        var hadCompleteView = this.hasCompleteView();
        if (queryId === 'default') {
            // When you do ref.off(...), we search all views for the registration to remove.
            var self_1 = this;
            (0, _obj.forEach)(this.views_, function (viewQueryId, view) {
                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                if (view.isEmpty()) {
                    delete self_1.views_[viewQueryId];
                    // We'll deal with complete views later.
                    if (!view.getQuery().getQueryParams().loadsAllData()) {
                        removed.push(view.getQuery());
                    }
                }
            });
        } else {
            // remove the callback from the specific view.
            var view = (0, _obj.safeGet)(this.views_, queryId);
            if (view) {
                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                if (view.isEmpty()) {
                    delete this.views_[queryId];
                    // We'll deal with complete views later.
                    if (!view.getQuery().getQueryParams().loadsAllData()) {
                        removed.push(view.getQuery());
                    }
                }
            }
        }
        if (hadCompleteView && !this.hasCompleteView()) {
            // We removed our last complete view.
            removed.push(new SyncPoint.__referenceConstructor(query.repo, query.path));
        }
        return { removed: removed, events: cancelEvents };
    };
    /**
     * @return {!Array.<!View>}
     */
    SyncPoint.prototype.getQueryViews = function () {
        var _this = this;
        var values = Object.keys(this.views_).map(function (key) {
            return _this.views_[key];
        });
        return values.filter(function (view) {
            return !view.getQuery().getQueryParams().loadsAllData();
        });
    };
    /**
     *
     * @param {!Path} path The path to the desired complete snapshot
     * @return {?Node} A complete cache, if it exists
     */
    SyncPoint.prototype.getCompleteServerCache = function (path) {
        var serverCache = null;
        (0, _obj.forEach)(this.views_, function (key, view) {
            serverCache = serverCache || view.getCompleteServerCache(path);
        });
        return serverCache;
    };
    /**
     * @param {!Query} query
     * @return {?View}
     */
    SyncPoint.prototype.viewForQuery = function (query) {
        var params = query.getQueryParams();
        if (params.loadsAllData()) {
            return this.getCompleteView();
        } else {
            var queryId = query.queryIdentifier();
            return (0, _obj.safeGet)(this.views_, queryId);
        }
    };
    /**
     * @param {!Query} query
     * @return {boolean}
     */
    SyncPoint.prototype.viewExistsForQuery = function (query) {
        return this.viewForQuery(query) != null;
    };
    /**
     * @return {boolean}
     */
    SyncPoint.prototype.hasCompleteView = function () {
        return this.getCompleteView() != null;
    };
    /**
     * @return {?View}
     */
    SyncPoint.prototype.getCompleteView = function () {
        var completeView = (0, _obj.findValue)(this.views_, function (view) {
            return view.getQuery().getQueryParams().loadsAllData();
        });
        return completeView || null;
    };
    return SyncPoint;
}();
exports.SyncPoint = SyncPoint;
//# sourceMappingURL=SyncPoint.js.map


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Overwrite = undefined;

var _Operation = __webpack_require__(36);

var _Path = __webpack_require__(9);

/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!Node} snap
 * @constructor
 * @implements {Operation}
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Overwrite = /** @class */function () {
    function Overwrite(source, path, snap) {
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */
        this.type = _Operation.OperationType.OVERWRITE;
    }
    Overwrite.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            return new Overwrite(this.source, _Path.Path.Empty, this.snap.getImmediateChild(childName));
        } else {
            return new Overwrite(this.source, this.path.popFront(), this.snap);
        }
    };
    return Overwrite;
}();
exports.Overwrite = Overwrite;
//# sourceMappingURL=Overwrite.js.map


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IndexMap = undefined;

var _assert = __webpack_require__(2);

var _childSet = __webpack_require__(168);

var _obj = __webpack_require__(7);

var _Node = __webpack_require__(19);

var _PriorityIndex = __webpack_require__(15);

var _KeyIndex = __webpack_require__(61);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _defaultIndexMap;
var fallbackObject = {};
/**
 *
 * @param {Object.<string, FallbackType|SortedMap.<NamedNode, Node>>} indexes
 * @param {Object.<string, Index>} indexSet
 * @constructor
 */
var IndexMap = /** @class */function () {
    function IndexMap(indexes_, indexSet_) {
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    Object.defineProperty(IndexMap, "Default", {
        /**
         * The default IndexMap for nodes without a priority
         * @type {!IndexMap}
         * @const
         */
        get: function get() {
            (0, _assert.assert)(fallbackObject && _PriorityIndex.PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
            _defaultIndexMap = _defaultIndexMap || new IndexMap({ '.priority': fallbackObject }, { '.priority': _PriorityIndex.PRIORITY_INDEX });
            return _defaultIndexMap;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     * @param {!string} indexKey
     * @return {?SortedMap.<NamedNode, Node>}
     */
    IndexMap.prototype.get = function (indexKey) {
        var sortedMap = (0, _obj.safeGet)(this.indexes_, indexKey);
        if (!sortedMap) throw new Error('No index defined for ' + indexKey);
        if (sortedMap === fallbackObject) {
            // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
            // regular child map
            return null;
        } else {
            return sortedMap;
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {boolean}
     */
    IndexMap.prototype.hasIndex = function (indexDefinition) {
        return (0, _obj.contains)(this.indexSet_, indexDefinition.toString());
    };
    /**
     * @param {!Index} indexDefinition
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.addIndex = function (indexDefinition, existingChildren) {
        (0, _assert.assert)(indexDefinition !== _KeyIndex.KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        var childList = [];
        var sawIndexedValue = false;
        var iter = existingChildren.getIterator(_Node.NamedNode.Wrap);
        var next = iter.getNext();
        while (next) {
            sawIndexedValue = sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        var newIndex;
        if (sawIndexedValue) {
            newIndex = (0, _childSet.buildChildSet)(childList, indexDefinition.getCompare());
        } else {
            newIndex = fallbackObject;
        }
        var indexName = indexDefinition.toString();
        var newIndexSet = (0, _obj.clone)(this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        var newIndexes = (0, _obj.clone)(this.indexes_);
        newIndexes[indexName] = newIndex;
        return new IndexMap(newIndexes, newIndexSet);
    };
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     * @param {!NamedNode} namedNode
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.addToIndexes = function (namedNode, existingChildren) {
        var _this = this;
        var newIndexes = (0, _obj.map)(this.indexes_, function (indexedChildren, indexName) {
            var index = (0, _obj.safeGet)(_this.indexSet_, indexName);
            (0, _assert.assert)(index, 'Missing index implementation for ' + indexName);
            if (indexedChildren === fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    var childList = [];
                    var iter = existingChildren.getIterator(_Node.NamedNode.Wrap);
                    var next = iter.getNext();
                    while (next) {
                        if (next.name != namedNode.name) {
                            childList.push(next);
                        }
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return (0, _childSet.buildChildSet)(childList, index.getCompare());
                } else {
                    // No change, this remains a fallback
                    return fallbackObject;
                }
            } else {
                var existingSnap = existingChildren.get(namedNode.name);
                var newChildren = indexedChildren;
                if (existingSnap) {
                    newChildren = newChildren.remove(new _Node.NamedNode(namedNode.name, existingSnap));
                }
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    /**
     * Create a new IndexMap instance with the given value removed
     * @param {!NamedNode} namedNode
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.removeFromIndexes = function (namedNode, existingChildren) {
        var newIndexes = (0, _obj.map)(this.indexes_, function (indexedChildren) {
            if (indexedChildren === fallbackObject) {
                // This is the fallback. Just return it, nothing to do in this case
                return indexedChildren;
            } else {
                var existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) {
                    return indexedChildren.remove(new _Node.NamedNode(namedNode.name, existingSnap));
                } else {
                    // No record of this child
                    return indexedChildren;
                }
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    return IndexMap;
}();
exports.IndexMap = IndexMap;
//# sourceMappingURL=IndexMap.js.map


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildChildSet = undefined;

var _SortedMap = __webpack_require__(108);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_2 = Math.log(2);
/**
 * @constructor
 */
var Base12Num = /** @class */function () {
    /**
     * @param {number} length
     */
    function Base12Num(length) {
        var logBase2 = function logBase2(num) {
            return parseInt(Math.log(num) / LOG_2, 10);
        };
        var bitMask = function bitMask(bits) {
            return parseInt(Array(bits + 1).join('1'), 2);
        };
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        var mask = bitMask(this.count);
        this.bits_ = length + 1 & mask;
    }
    /**
     * @return {boolean}
     */
    Base12Num.prototype.nextBitIsOne = function () {
        //noinspection JSBitwiseOperatorUsage
        var result = !(this.bits_ & 0x1 << this.current_);
        this.current_--;
        return result;
    };
    return Base12Num;
}();
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @template K, V
 * @param {Array.<!NamedNode>} childList Unsorted list of children
 * @param {function(!NamedNode, !NamedNode):number} cmp The comparison method to be used
 * @param {(function(NamedNode):K)=} keyFn An optional function to extract K from a node wrapper, if K's
 *                                                        type is not NamedNode
 * @param {(function(K, K):number)=} mapSortFn An optional override for comparator used by the generated sorted map
 * @return {SortedMap.<K, V>}
 */
var buildChildSet = exports.buildChildSet = function buildChildSet(childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    var buildBalancedTree = function buildBalancedTree(low, high) {
        var length = high - low;
        var namedNode;
        var key;
        if (length == 0) {
            return null;
        } else if (length == 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new _SortedMap.LLRBNode(key, namedNode.node, _SortedMap.LLRBNode.BLACK, null, null);
        } else {
            var middle = parseInt(length / 2, 10) + low;
            var left = buildBalancedTree(low, middle);
            var right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new _SortedMap.LLRBNode(key, namedNode.node, _SortedMap.LLRBNode.BLACK, left, right);
        }
    };
    var buildFrom12Array = function buildFrom12Array(base12) {
        var node = null;
        var root = null;
        var index = childList.length;
        var buildPennant = function buildPennant(chunkSize, color) {
            var low = index - chunkSize;
            var high = index;
            index -= chunkSize;
            var childTree = buildBalancedTree(low + 1, high);
            var namedNode = childList[low];
            var key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new _SortedMap.LLRBNode(key, namedNode.node, color, null, childTree));
        };
        var attachPennant = function attachPennant(pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            } else {
                root = pennant;
                node = pennant;
            }
        };
        for (var i = 0; i < base12.count; ++i) {
            var isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            var chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) {
                buildPennant(chunkSize, _SortedMap.LLRBNode.BLACK);
            } else {
                // current == 2
                buildPennant(chunkSize, _SortedMap.LLRBNode.BLACK);
                buildPennant(chunkSize, _SortedMap.LLRBNode.RED);
            }
        }
        return root;
    };
    var base12 = new Base12Num(childList.length);
    var root = buildFrom12Array(base12);
    return new _SortedMap.SortedMap(mapSortFn || cmp, root);
};
//# sourceMappingURL=childSet.js.map


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NAME_ONLY_COMPARATOR = NAME_ONLY_COMPARATOR;
exports.NAME_COMPARATOR = NAME_COMPARATOR;

var _util = __webpack_require__(3);

function NAME_ONLY_COMPARATOR(left, right) {
    return (0, _util.nameCompare)(left.name, right.name);
} /**
   * Copyright 2017 Google Inc.
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
function NAME_COMPARATOR(left, right) {
    return (0, _util.nameCompare)(left, right);
}
//# sourceMappingURL=comparators.js.map


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PathIndex = undefined;

var _assert = __webpack_require__(2);

var _util = __webpack_require__(3);

var _Index = __webpack_require__(79);

var _ChildrenNode = __webpack_require__(16);

var _Node = __webpack_require__(19);

var _nodeFromJSON = __webpack_require__(62);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();

/**
 * @param {!Path} indexPath
 * @constructor
 * @extends {Index}
 */
var PathIndex = /** @class */function (_super) {
    __extends(PathIndex, _super);
    function PathIndex(indexPath_) {
        var _this = _super.call(this) || this;
        _this.indexPath_ = indexPath_;
        (0, _assert.assert)(!indexPath_.isEmpty() && indexPath_.getFront() !== '.priority', "Can't create PathIndex with empty path or .priority key");
        return _this;
    }
    /**
     * @param {!Node} snap
     * @return {!Node}
     * @protected
     */
    PathIndex.prototype.extractChild = function (snap) {
        return snap.getChild(this.indexPath_);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.isDefinedOn = function (node) {
        return !node.getChild(this.indexPath_).isEmpty();
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.compare = function (a, b) {
        var aChild = this.extractChild(a.node);
        var bChild = this.extractChild(b.node);
        var indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) {
            return (0, _util.nameCompare)(a.name, b.name);
        } else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.makePost = function (indexValue, name) {
        var valueNode = (0, _nodeFromJSON.nodeFromJSON)(indexValue);
        var node = _ChildrenNode.ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new _Node.NamedNode(name, node);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.maxPost = function () {
        var node = _ChildrenNode.ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, _ChildrenNode.MAX_NODE);
        return new _Node.NamedNode(_util.MAX_NAME, node);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.toString = function () {
        return this.indexPath_.slice().join('/');
    };
    return PathIndex;
}(_Index.Index);
exports.PathIndex = PathIndex;
//# sourceMappingURL=PathIndex.js.map


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VALUE_INDEX = exports.ValueIndex = undefined;

var _Index = __webpack_require__(79);

var _Node = __webpack_require__(19);

var _util = __webpack_require__(3);

var _nodeFromJSON = __webpack_require__(62);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();

/**
 * @constructor
 * @extends {Index}
 * @private
 */
var ValueIndex = /** @class */function (_super) {
    __extends(ValueIndex, _super);
    function ValueIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.compare = function (a, b) {
        var indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) {
            return (0, _util.nameCompare)(a.name, b.name);
        } else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.isDefinedOn = function (node) {
        return true;
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return !oldNode.equals(newNode);
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.minPost = function () {
        return _Node.NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.maxPost = function () {
        return _Node.NamedNode.MAX;
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    ValueIndex.prototype.makePost = function (indexValue, name) {
        var valueNode = (0, _nodeFromJSON.nodeFromJSON)(indexValue);
        return new _Node.NamedNode(name, valueNode);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    ValueIndex.prototype.toString = function () {
        return '.value';
    };
    return ValueIndex;
}(_Index.Index);
exports.ValueIndex = ValueIndex;
var VALUE_INDEX = exports.VALUE_INDEX = new ValueIndex();
//# sourceMappingURL=ValueIndex.js.map


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validatePriorityNode = exports.priorityHashText = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Copyright 2017 Google Inc.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Licensed under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                               * you may not use this file except in compliance with the License.
                                                                                                                                                                                                                                                                               * You may obtain a copy of the License at
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               *   http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Unless required by applicable law or agreed to in writing, software
                                                                                                                                                                                                                                                                               * distributed under the License is distributed on an "AS IS" BASIS,
                                                                                                                                                                                                                                                                               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                                                                                                                                                                                                               * See the License for the specific language governing permissions and
                                                                                                                                                                                                                                                                               * limitations under the License.
                                                                                                                                                                                                                                                                               */


exports.setMaxNode = setMaxNode;

var _assert = __webpack_require__(2);

var _util = __webpack_require__(3);

var _obj = __webpack_require__(7);

var MAX_NODE;
function setMaxNode(val) {
    MAX_NODE = val;
}
/**
 * @param {(!string|!number)} priority
 * @return {!string}
 */
var priorityHashText = exports.priorityHashText = function priorityHashText(priority) {
    if (typeof priority === 'number') return 'number:' + (0, _util.doubleToIEEE754String)(priority);else return 'string:' + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 *
 * @param {!Node} priorityNode
 */
var validatePriorityNode = exports.validatePriorityNode = function validatePriorityNode(priorityNode) {
    if (priorityNode.isLeafNode()) {
        var val = priorityNode.val();
        (0, _assert.assert)(typeof val === 'string' || typeof val === 'number' || (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (0, _obj.contains)(val, '.sv'), 'Priority must be a string or number.');
    } else {
        (0, _assert.assert)(priorityNode === MAX_NODE || priorityNode.isEmpty(), 'priority of unexpected type.');
    }
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    (0, _assert.assert)(priorityNode === MAX_NODE || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};
//# sourceMappingURL=snap.js.map


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StatsListener = undefined;

var _obj = __webpack_require__(7);

/**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ The collection to "listen" to.
 * @constructor
 */
var StatsListener = /** @class */function () {
    function StatsListener(collection_) {
        this.collection_ = collection_;
        this.last_ = null;
    }
    StatsListener.prototype.get = function () {
        var newStats = this.collection_.get();
        var delta = (0, _obj.clone)(newStats);
        if (this.last_) {
            (0, _obj.forEach)(this.last_, function (stat, value) {
                delta[stat] = delta[stat] - value;
            });
        }
        this.last_ = newStats;
        return delta;
    };
    return StatsListener;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.StatsListener = StatsListener;
//# sourceMappingURL=StatsListener.js.map


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CountedSet = undefined;

var _obj = __webpack_require__(7);

/**
 * Implements a set with a count of elements.
 *
 * @template K, V
 */
var CountedSet = /** @class */function () {
    function CountedSet() {
        this.set = {};
    }
    /**
     * @param {!K} item
     * @param {V} val
     */
    CountedSet.prototype.add = function (item, val) {
        this.set[item] = val !== null ? val : true;
    };
    /**
     * @param {!K} key
     * @return {boolean}
     */
    CountedSet.prototype.contains = function (key) {
        return (0, _obj.contains)(this.set, key);
    };
    /**
     * @param {!K} item
     * @return {V}
     */
    CountedSet.prototype.get = function (item) {
        return this.contains(item) ? this.set[item] : undefined;
    };
    /**
     * @param {!K} item
     */
    CountedSet.prototype.remove = function (item) {
        delete this.set[item];
    };
    /**
     * Deletes everything in the set
     */
    CountedSet.prototype.clear = function () {
        this.set = {};
    };
    /**
     * True if there's nothing in the set
     * @return {boolean}
     */
    CountedSet.prototype.isEmpty = function () {
        return (0, _obj.isEmpty)(this.set);
    };
    /**
     * @return {number} The number of items in the set
     */
    CountedSet.prototype.count = function () {
        return (0, _obj.getCount)(this.set);
    };
    /**
     * Run a function on each k,v pair in the set
     * @param {function(K, V)} fn
     */
    CountedSet.prototype.each = function (fn) {
        (0, _obj.forEach)(this.set, function (k, v) {
            return fn(k, v);
        });
    };
    /**
     * Mostly for debugging
     * @return {Array.<K>} The keys present in this CountedSet
     */
    CountedSet.prototype.keys = function () {
        var keys = [];
        (0, _obj.forEach)(this.set, function (k) {
            keys.push(k);
        });
        return keys;
    };
    return CountedSet;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.CountedSet = CountedSet;
//# sourceMappingURL=CountedSet.js.map


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EventEmitter = undefined;

var _assert = __webpack_require__(2);

/**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */
var EventEmitter = /** @class */function () {
    /**
     * @param {!Array.<string>} allowedEvents_
     */
    function EventEmitter(allowedEvents_) {
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        (0, _assert.assert)(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
    }
    /**
     * To be called by derived classes to trigger events.
     * @param {!string} eventType
     * @param {...*} var_args
     */
    EventEmitter.prototype.trigger = function (eventType) {
        var var_args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            var_args[_i - 1] = arguments[_i];
        }
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            var listeners = this.listeners_[eventType].slice();
            for (var i = 0; i < listeners.length; i++) {
                listeners[i].callback.apply(listeners[i].context, var_args);
            }
        }
    };
    EventEmitter.prototype.on = function (eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({ callback: callback, context: context });
        var eventData = this.getInitialEvent(eventType);
        if (eventData) {
            callback.apply(context, eventData);
        }
    };
    EventEmitter.prototype.off = function (eventType, callback, context) {
        this.validateEventType_(eventType);
        var listeners = this.listeners_[eventType] || [];
        for (var i = 0; i < listeners.length; i++) {
            if (listeners[i].callback === callback && (!context || context === listeners[i].context)) {
                listeners.splice(i, 1);
                return;
            }
        }
    };
    EventEmitter.prototype.validateEventType_ = function (eventType) {
        (0, _assert.assert)(this.allowedEvents_.find(function (et) {
            return et === eventType;
        }), 'Unknown event: ' + eventType);
    };
    return EventEmitter;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.EventEmitter = EventEmitter;
//# sourceMappingURL=EventEmitter.js.map


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resolveDeferredValueSnapshot = exports.resolveDeferredValueTree = exports.resolveDeferredValue = exports.generateWithValues = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Copyright 2017 Google Inc.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Licensed under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                               * you may not use this file except in compliance with the License.
                                                                                                                                                                                                                                                                               * You may obtain a copy of the License at
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               *   http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Unless required by applicable law or agreed to in writing, software
                                                                                                                                                                                                                                                                               * distributed under the License is distributed on an "AS IS" BASIS,
                                                                                                                                                                                                                                                                               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                                                                                                                                                                                                               * See the License for the specific language governing permissions and
                                                                                                                                                                                                                                                                               * limitations under the License.
                                                                                                                                                                                                                                                                               */


var _assert = __webpack_require__(2);

var _Path = __webpack_require__(9);

var _SparseSnapshotTree = __webpack_require__(164);

var _LeafNode = __webpack_require__(78);

var _nodeFromJSON = __webpack_require__(62);

var _PriorityIndex = __webpack_require__(15);

/**
 * Generate placeholders for deferred values.
 * @param {?Object} values
 * @return {!Object}
 */
var generateWithValues = exports.generateWithValues = function generateWithValues(values) {
    values = values || {};
    values['timestamp'] = values['timestamp'] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 * @param {(Object|string|number|boolean)} value
 * @param {!Object} serverValues
 * @return {!(string|number|boolean)}
 */
var resolveDeferredValue = exports.resolveDeferredValue = function resolveDeferredValue(value, serverValues) {
    if (!value || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
        return value;
    } else {
        (0, _assert.assert)('.sv' in value, 'Unexpected leaf node or priority contents');
        return serverValues[value['.sv']];
    }
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param {!SparseSnapshotTree} tree
 * @param {!Object} serverValues
 * @return {!SparseSnapshotTree}
 */
var resolveDeferredValueTree = exports.resolveDeferredValueTree = function resolveDeferredValueTree(tree, serverValues) {
    var resolvedTree = new _SparseSnapshotTree.SparseSnapshotTree();
    tree.forEachTree(new _Path.Path(''), function (path, node) {
        resolvedTree.remember(path, resolveDeferredValueSnapshot(node, serverValues));
    });
    return resolvedTree;
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 * @param {!Node} node
 * @param {!Object} serverValues
 * @return {!Node}
 */
var resolveDeferredValueSnapshot = exports.resolveDeferredValueSnapshot = function resolveDeferredValueSnapshot(node, serverValues) {
    var rawPri = node.getPriority().val();
    var priority = resolveDeferredValue(rawPri, serverValues);
    var newNode;
    if (node.isLeafNode()) {
        var leafNode = node;
        var value = resolveDeferredValue(leafNode.getValue(), serverValues);
        if (value !== leafNode.getValue() || priority !== leafNode.getPriority().val()) {
            return new _LeafNode.LeafNode(value, (0, _nodeFromJSON.nodeFromJSON)(priority));
        } else {
            return node;
        }
    } else {
        var childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) {
            newNode = newNode.updatePriority(new _LeafNode.LeafNode(priority));
        }
        childrenNode.forEachChild(_PriorityIndex.PRIORITY_INDEX, function (childName, childNode) {
            var newChildNode = resolveDeferredValueSnapshot(childNode, serverValues);
            if (newChildNode !== childNode) {
                newNode = newNode.updateImmediateChild(childName, newChildNode);
            }
        });
        return newNode;
    }
};
//# sourceMappingURL=ServerValues.js.map


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseURL = exports.parseRepoInfo = undefined;

var _Path = __webpack_require__(9);

var _RepoInfo = __webpack_require__(162);

var _util = __webpack_require__(3);

/**
 * @param {!string} pathString
 * @return {string}
 */
function decodePath(pathString) {
    var pathStringDecoded = '';
    var pieces = pathString.split('/');
    for (var i = 0; i < pieces.length; i++) {
        if (pieces[i].length > 0) {
            var piece = pieces[i];
            try {
                piece = decodeURIComponent(piece.replace(/\+/g, ' '));
            } catch (e) {}
            pathStringDecoded += '/' + piece;
        }
    }
    return pathStringDecoded;
}
/**
 *
 * @param {!string} dataURL
 * @return {{repoInfo: !RepoInfo, path: !Path}}
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var parseRepoInfo = exports.parseRepoInfo = function parseRepoInfo(dataURL) {
    var parsedUrl = parseURL(dataURL),
        namespace = parsedUrl.subdomain;
    if (parsedUrl.domain === 'firebase') {
        (0, _util.fatal)(parsedUrl.host + ' is no longer supported. ' + 'Please use <YOUR FIREBASE>.firebaseio.com instead');
    }
    // Catch common error of uninitialized namespace value.
    if (!namespace || namespace == 'undefined') {
        (0, _util.fatal)('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
    }
    if (!parsedUrl.secure) {
        (0, _util.warnIfPageIsSecure)();
    }
    var webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
    return {
        repoInfo: new _RepoInfo.RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly),
        path: new _Path.Path(parsedUrl.pathString)
    };
};
/**
 *
 * @param {!string} dataURL
 * @return {{host: string, port: number, domain: string, subdomain: string, secure: boolean, scheme: string, pathString: string}}
 */
var parseURL = exports.parseURL = function parseURL(dataURL) {
    // Default to empty strings in the event of a malformed string.
    var host = '',
        domain = '',
        subdomain = '',
        pathString = '';
    // Always default to SSL, unless otherwise specified.
    var secure = true,
        scheme = 'https',
        port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === 'string') {
        // Parse scheme.
        var colonInd = dataURL.indexOf('//');
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host and path.
        var slashInd = dataURL.indexOf('/');
        if (slashInd === -1) {
            slashInd = dataURL.length;
        }
        host = dataURL.substring(0, slashInd);
        pathString = decodePath(dataURL.substring(slashInd));
        var parts = host.split('.');
        if (parts.length === 3) {
            // Normalize namespaces to lowercase to share storage / connection.
            domain = parts[1];
            subdomain = parts[0].toLowerCase();
        } else if (parts.length === 2) {
            domain = parts[0];
        }
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(':');
        if (colonInd >= 0) {
            secure = scheme === 'https' || scheme === 'wss';
            port = parseInt(host.substring(colonInd + 1), 10);
        }
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString
    };
};
//# sourceMappingURL=parser.js.map


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewCache = undefined;

var _ChildrenNode = __webpack_require__(16);

var _CacheNode = __webpack_require__(81);

/**
 * Stores the data we have cached for a view.
 *
 * serverSnap is the cached server data, eventSnap is the cached event data (server data plus any local writes).
 *
 * @constructor
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ViewCache = /** @class */function () {
  /**
   *
   * @param {!CacheNode} eventCache_
   * @param {!CacheNode} serverCache_
   */
  function ViewCache(eventCache_, serverCache_) {
    this.eventCache_ = eventCache_;
    this.serverCache_ = serverCache_;
  }
  /**
   * @param {!Node} eventSnap
   * @param {boolean} complete
   * @param {boolean} filtered
   * @return {!ViewCache}
   */
  ViewCache.prototype.updateEventSnap = function (eventSnap, complete, filtered) {
    return new ViewCache(new _CacheNode.CacheNode(eventSnap, complete, filtered), this.serverCache_);
  };
  /**
   * @param {!Node} serverSnap
   * @param {boolean} complete
   * @param {boolean} filtered
   * @return {!ViewCache}
   */
  ViewCache.prototype.updateServerSnap = function (serverSnap, complete, filtered) {
    return new ViewCache(this.eventCache_, new _CacheNode.CacheNode(serverSnap, complete, filtered));
  };
  /**
   * @return {!CacheNode}
   */
  ViewCache.prototype.getEventCache = function () {
    return this.eventCache_;
  };
  /**
   * @return {?Node}
   */
  ViewCache.prototype.getCompleteEventSnap = function () {
    return this.eventCache_.isFullyInitialized() ? this.eventCache_.getNode() : null;
  };
  /**
   * @return {!CacheNode}
   */
  ViewCache.prototype.getServerCache = function () {
    return this.serverCache_;
  };
  /**
   * @return {?Node}
   */
  ViewCache.prototype.getCompleteServerSnap = function () {
    return this.serverCache_.isFullyInitialized() ? this.serverCache_.getNode() : null;
  };
  /**
   * @const
   * @type {ViewCache}
   */
  ViewCache.Empty = new ViewCache(new _CacheNode.CacheNode(_ChildrenNode.ChildrenNode.EMPTY_NODE,
  /*fullyInitialized=*/false,
  /*filtered=*/false), new _CacheNode.CacheNode(_ChildrenNode.ChildrenNode.EMPTY_NODE,
  /*fullyInitialized=*/false,
  /*filtered=*/false));
  return ViewCache;
}();
exports.ViewCache = ViewCache;
//# sourceMappingURL=ViewCache.js.map


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RangedFilter = undefined;

var _IndexedFilter = __webpack_require__(109);

var _PriorityIndex = __webpack_require__(15);

var _Node = __webpack_require__(19);

var _ChildrenNode = __webpack_require__(16);

/**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 *
 * @constructor
 * @implements {NodeFilter}
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RangedFilter = /** @class */function () {
    /**
     * @param {!QueryParams} params
     */
    function RangedFilter(params) {
        this.indexedFilter_ = new _IndexedFilter.IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = RangedFilter.getStartPost_(params);
        this.endPost_ = RangedFilter.getEndPost_(params);
    }
    /**
     * @return {!NamedNode}
     */
    RangedFilter.prototype.getStartPost = function () {
        return this.startPost_;
    };
    /**
     * @return {!NamedNode}
     */
    RangedFilter.prototype.getEndPost = function () {
        return this.endPost_;
    };
    /**
     * @param {!NamedNode} node
     * @return {boolean}
     */
    RangedFilter.prototype.matches = function (node) {
        return this.index_.compare(this.getStartPost(), node) <= 0 && this.index_.compare(node, this.getEndPost()) <= 0;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new _Node.NamedNode(key, newChild))) {
            newChild = _ChildrenNode.ChildrenNode.EMPTY_NODE;
        }
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) {
            // Make sure we have a children node with the correct index, not a leaf node;
            newSnap = _ChildrenNode.ChildrenNode.EMPTY_NODE;
        }
        var filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority(_ChildrenNode.ChildrenNode.EMPTY_NODE);
        var self = this;
        newSnap.forEachChild(_PriorityIndex.PRIORITY_INDEX, function (key, childNode) {
            if (!self.matches(new _Node.NamedNode(key, childNode))) {
                filtered = filtered.updateImmediateChild(key, _ChildrenNode.ChildrenNode.EMPTY_NODE);
            }
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.filtersNodes = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.getIndexedFilter = function () {
        return this.indexedFilter_;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */
    RangedFilter.getStartPost_ = function (params) {
        if (params.hasStart()) {
            var startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        } else {
            return params.getIndex().minPost();
        }
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */
    RangedFilter.getEndPost_ = function (params) {
        if (params.hasEnd()) {
            var endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        } else {
            return params.getIndex().maxPost();
        }
    };
    return RangedFilter;
}();
exports.RangedFilter = RangedFilter;
//# sourceMappingURL=RangedFilter.js.map


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FirebaseIFrameScriptHolder = exports.BrowserPollConnection = exports.FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = exports.FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM = exports.FIREBASE_LONGPOLL_DATA_PARAM = exports.FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = exports.FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = exports.FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = exports.FIREBASE_LONGPOLL_SERIAL_PARAM = exports.FIREBASE_LONGPOLL_PW_PARAM = exports.FIREBASE_LONGPOLL_ID_PARAM = exports.FIREBASE_LONGPOLL_DATA_CB_NAME = exports.FIREBASE_LONGPOLL_COMMAND_CB_NAME = exports.FIREBASE_LONGPOLL_CLOSE_COMMAND = exports.FIREBASE_LONGPOLL_START_PARAM = undefined;

var _util = __webpack_require__(3);

var _CountedSet = __webpack_require__(174);

var _StatsManager = __webpack_require__(106);

var _PacketReceiver = __webpack_require__(410);

var _Constants = __webpack_require__(82);

var _json = __webpack_require__(23);

var _environment = __webpack_require__(50);

// URL query parameters associated with longpolling
var FIREBASE_LONGPOLL_START_PARAM = exports.FIREBASE_LONGPOLL_START_PARAM = 'start'; /**
                                                                                      * Copyright 2017 Google Inc.
                                                                                      *
                                                                                      * Licensed under the Apache License, Version 2.0 (the "License");
                                                                                      * you may not use this file except in compliance with the License.
                                                                                      * You may obtain a copy of the License at
                                                                                      *
                                                                                      *   http://www.apache.org/licenses/LICENSE-2.0
                                                                                      *
                                                                                      * Unless required by applicable law or agreed to in writing, software
                                                                                      * distributed under the License is distributed on an "AS IS" BASIS,
                                                                                      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                      * See the License for the specific language governing permissions and
                                                                                      * limitations under the License.
                                                                                      */
var FIREBASE_LONGPOLL_CLOSE_COMMAND = exports.FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
var FIREBASE_LONGPOLL_COMMAND_CB_NAME = exports.FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
var FIREBASE_LONGPOLL_DATA_CB_NAME = exports.FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
var FIREBASE_LONGPOLL_ID_PARAM = exports.FIREBASE_LONGPOLL_ID_PARAM = 'id';
var FIREBASE_LONGPOLL_PW_PARAM = exports.FIREBASE_LONGPOLL_PW_PARAM = 'pw';
var FIREBASE_LONGPOLL_SERIAL_PARAM = exports.FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
var FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = exports.FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
var FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = exports.FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
var FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = exports.FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
var FIREBASE_LONGPOLL_DATA_PARAM = exports.FIREBASE_LONGPOLL_DATA_PARAM = 'd';
var FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM = exports.FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM = 'disconn';
var FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = exports.FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
var MAX_URL_DATA_SIZE = 1870;
var SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
var MAX_PAYLOAD_SIZE = MAX_URL_DATA_SIZE - SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 * @const
 * @type {number}
 */
var KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 * @const
 * @type {number}
 */
var LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 *
 * @constructor
 * @implements {Transport}
 */
var BrowserPollConnection = /** @class */function () {
    /**
     * @param {string} connId An identifier for this connection, used for logging
     * @param {RepoInfo} repoInfo The info for the endpoint to send data to.
     * @param {string=} transportSessionId Optional transportSessionid if we are reconnecting for an existing
     *                                         transport session
     * @param {string=}  lastSessionId Optional lastSessionId if the PersistentConnection has already created a
     *                                     connection previously
     */
    function BrowserPollConnection(connId, repoInfo, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = (0, _util.logWrapper)(connId);
        this.stats_ = _StatsManager.StatsManager.getCollection(repoInfo);
        this.urlFn = function (params) {
            return repoInfo.connectionURL(_Constants.LONG_POLLING, params);
        };
    }
    /**
     *
     * @param {function(Object)} onMessage Callback when messages arrive
     * @param {function()} onDisconnect Callback with connection lost.
     */
    BrowserPollConnection.prototype.open = function (onMessage, onDisconnect) {
        var _this = this;
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new _PacketReceiver.PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(function () {
            _this.log_('Timed out trying to connect.');
            // Make sure we clear the host cache
            _this.onClosed_();
            _this.connectTimeoutTimer_ = null;
        }, Math.floor(LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        (0, _util.executeWhenDOMReady)(function () {
            if (_this.isClosed_) return;
            //Set up a callback that gets triggered once a connection is set up.
            _this.scriptTagHolder = new FirebaseIFrameScriptHolder(function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var command = args[0],
                    arg1 = args[1],
                    arg2 = args[2],
                    arg3 = args[3],
                    arg4 = args[4];
                _this.incrementIncomingBytes_(args);
                if (!_this.scriptTagHolder) return; // we closed the connection.
                if (_this.connectTimeoutTimer_) {
                    clearTimeout(_this.connectTimeoutTimer_);
                    _this.connectTimeoutTimer_ = null;
                }
                _this.everConnected_ = true;
                if (command == FIREBASE_LONGPOLL_START_PARAM) {
                    _this.id = arg1;
                    _this.password = arg2;
                } else if (command === FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        _this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        _this.myPacketOrderer.closeAfter(arg1, function () {
                            _this.onClosed_();
                        });
                    } else {
                        _this.onClosed_();
                    }
                } else {
                    throw new Error('Unrecognized command received: ' + command);
                }
            }, function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var pN = args[0],
                    data = args[1];
                _this.incrementIncomingBytes_(args);
                _this.myPacketOrderer.handleResponse(pN, data);
            }, function () {
                _this.onClosed_();
            }, _this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_START_PARAM] = 't';
            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (_this.scriptTagHolder.uniqueCallbackIdentifier) urlParams[FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = _this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[_Constants.VERSION_PARAM] = _Constants.PROTOCOL_VERSION;
            if (_this.transportSessionId) {
                urlParams[_Constants.TRANSPORT_SESSION_PARAM] = _this.transportSessionId;
            }
            if (_this.lastSessionId) {
                urlParams[_Constants.LAST_SESSION_PARAM] = _this.lastSessionId;
            }
            if (!(0, _environment.isNodeSdk)() && typeof location !== 'undefined' && location.href && location.href.indexOf(_Constants.FORGE_DOMAIN) !== -1) {
                urlParams[_Constants.REFERER_PARAM] = _Constants.FORGE_REF;
            }
            var connectURL = _this.urlFn(urlParams);
            _this.log_('Connecting via long-poll to ' + connectURL);
            _this.scriptTagHolder.addTag(connectURL, function () {
                /* do nothing */
            });
        });
    };
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */
    BrowserPollConnection.prototype.start = function () {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    };
    /**
     * Forces long polling to be considered as a potential transport
     */
    BrowserPollConnection.forceAllow = function () {
        BrowserPollConnection.forceAllow_ = true;
    };
    /**
     * Forces longpolling to not be considered as a potential transport
     */
    BrowserPollConnection.forceDisallow = function () {
        BrowserPollConnection.forceDisallow_ = true;
    };
    // Static method, use string literal so it can be accessed in a generic way
    BrowserPollConnection.isAvailable = function () {
        // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
        return BrowserPollConnection.forceAllow_ || !BrowserPollConnection.forceDisallow_ && typeof document !== 'undefined' && document.createElement != null && !(0, _util.isChromeExtensionContentScript)() && !(0, _util.isWindowsStoreApp)() && !(0, _environment.isNodeSdk)();
    };
    /**
     * No-op for polling
     */
    BrowserPollConnection.prototype.markConnectionHealthy = function () {};
    /**
     * Stops polling and cleans up the iframe
     * @private
     */
    BrowserPollConnection.prototype.shutdown_ = function () {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    };
    /**
     * Triggered when this transport is closed
     * @private
     */
    BrowserPollConnection.prototype.onClosed_ = function () {
        if (!this.isClosed_) {
            this.log_('Longpoll is closing itself');
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */
    BrowserPollConnection.prototype.close = function () {
        if (!this.isClosed_) {
            this.log_('Longpoll is being closed.');
            this.shutdown_();
        }
    };
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param {!Object} data The JSON data to transmit.
     */
    BrowserPollConnection.prototype.send = function (data) {
        var dataStr = (0, _json.stringify)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //first, lets get the base64-encoded data
        var base64data = (0, _util.base64Encode)(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = (0, _util.splitStringBySize)(base64data, MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for (var i = 0; i < dataSegs.length; i++) {
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    };
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     * @param {!string} id
     * @param {!string} pw
     */
    BrowserPollConnection.prototype.addDisconnectPingFrame = function (id, pw) {
        if ((0, _environment.isNodeSdk)()) return;
        this.myDisconnFrame = document.createElement('iframe');
        var urlParams = {};
        urlParams[FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
        urlParams[FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = 'none';
        document.body.appendChild(this.myDisconnFrame);
    };
    /**
     * Used to track the bytes received by this client
     * @param {*} args
     * @private
     */
    BrowserPollConnection.prototype.incrementIncomingBytes_ = function (args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        var bytesReceived = (0, _json.stringify)(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter('bytes_received', bytesReceived);
    };
    return BrowserPollConnection;
}();
exports.BrowserPollConnection = BrowserPollConnection;
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 * @constructor
 *********************************************************************************************/

var FirebaseIFrameScriptHolder = /** @class */function () {
    /**
     * @param commandCB - The callback to be called when control commands are recevied from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */
    function FirebaseIFrameScriptHolder(commandCB, onMessageCB, onDisconnect, urlFn) {
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        /**
         * @type {CountedSet.<number, number>}
         */
        this.outstandingRequests = new _CountedSet.CountedSet();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!(0, _environment.isNodeSdk)()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = (0, _util.LUIDGenerator)();
            window[FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            var script = '';
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src && this.myIFrame.src.substr(0, 'javascript:'.length) === 'javascript:') {
                var currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            var iframeContents = '<html><body>' + script + '</body></html>';
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            } catch (e) {
                (0, _util.log)('frame writing exception');
                if (e.stack) {
                    (0, _util.log)(e.stack);
                }
                (0, _util.log)(e);
            }
        } else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     * @private
     * @return {Element}
     */
    FirebaseIFrameScriptHolder.createIFrame_ = function () {
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                var a = iframe.contentWindow.document;
                if (!a) {
                    // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                    (0, _util.log)('No IE domain setting required');
                }
            } catch (e) {
                var domain = document.domain;
                iframe.src = "javascript:void((function(){document.open();document.domain='" + domain + "';document.close();})())";
            }
        } else {
            // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
            // never gets hit.
            throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
        }
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) {
            iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        } else if (iframe.contentWindow) {
            iframe.doc = iframe.contentWindow.document; // Internet Explorer
        } else if (iframe.document) {
            iframe.doc = iframe.document; //others?
        }
        return iframe;
    };
    /**
     * Cancel all outstanding queries and remove the frame.
     */
    FirebaseIFrameScriptHolder.prototype.close = function () {
        var _this = this;
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
            this.myIFrame.doc.body.innerHTML = '';
            setTimeout(function () {
                if (_this.myIFrame !== null) {
                    document.body.removeChild(_this.myIFrame);
                    _this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        if ((0, _environment.isNodeSdk)() && this.myID) {
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM] = 't';
            urlParams[FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            var theURL = this.urlFn(urlParams);
            FirebaseIFrameScriptHolder.nodeRestRequest(theURL);
        }
        // Protect from being called recursively.
        var onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    };
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param {!string} id - The ID of this connection
     * @param {!string} pw - The password for this connection
     */
    FirebaseIFrameScriptHolder.prototype.startLongPoll = function (id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while (this.newRequest_()) {}
    };
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */
    FirebaseIFrameScriptHolder.prototype.newRequest_ = function () {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive && this.sendNewPolls && this.outstandingRequests.count() < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            var theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            var curDataString = '';
            var i = 0;
            while (this.pendingSegs.length > 0) {
                //first, lets see if the next segment will fit.
                var nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + SEG_HEADER_SIZE + curDataString.length <= MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    var theSeg = this.pendingSegs.shift();
                    curDataString = curDataString + '&' + FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM + i + '=' + theSeg.seg + '&' + FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET + i + '=' + theSeg.ts + '&' + FIREBASE_LONGPOLL_DATA_PARAM + i + '=' + theSeg.d;
                    i++;
                } else {
                    break;
                }
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        } else {
            return false;
        }
    };
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */
    FirebaseIFrameScriptHolder.prototype.enqueueSegment = function (segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({ seg: segnum, ts: totalsegs, d: data });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) {
            this.newRequest_();
        }
    };
    /**
     * Add a script tag for a regular long-poll request.
     * @param {!string} url - The URL of the script tag.
     * @param {!number} serial - The serial number of the request.
     * @private
     */
    FirebaseIFrameScriptHolder.prototype.addLongPollTag_ = function (url, serial) {
        var _this = this;
        //remember that we sent this request.
        this.outstandingRequests.add(serial, 1);
        var doNewRequest = function doNewRequest() {
            _this.outstandingRequests.remove(serial);
            _this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        var keepaliveTimeout = setTimeout(doNewRequest, Math.floor(KEEPALIVE_REQUEST_INTERVAL));
        var readyStateCB = function readyStateCB() {
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    };
    /**
     * Add an arbitrary script tag to the iframe.
     * @param {!string} url - The URL for the script tag source.
     * @param {!function()} loadCB - A callback to be triggered once the script has loaded.
     */
    FirebaseIFrameScriptHolder.prototype.addTag = function (url, loadCB) {
        var _this = this;
        if ((0, _environment.isNodeSdk)()) {
            this.doNodeLongPoll(url, loadCB);
        } else {
            setTimeout(function () {
                try {
                    // if we're already closed, don't add this poll
                    if (!_this.sendNewPolls) return;
                    var newScript_1 = _this.myIFrame.doc.createElement('script');
                    newScript_1.type = 'text/javascript';
                    newScript_1.async = true;
                    newScript_1.src = url;
                    newScript_1.onload = newScript_1.onreadystatechange = function () {
                        var rstate = newScript_1.readyState;
                        if (!rstate || rstate === 'loaded' || rstate === 'complete') {
                            newScript_1.onload = newScript_1.onreadystatechange = null;
                            if (newScript_1.parentNode) {
                                newScript_1.parentNode.removeChild(newScript_1);
                            }
                            loadCB();
                        }
                    };
                    newScript_1.onerror = function () {
                        (0, _util.log)('Long-poll script failed to load: ' + url);
                        _this.sendNewPolls = false;
                        _this.close();
                    };
                    _this.myIFrame.doc.body.appendChild(newScript_1);
                } catch (e) {
                    // TODO: we should make this error visible somehow
                }
            }, Math.floor(1));
        }
    };
    return FirebaseIFrameScriptHolder;
}();
exports.FirebaseIFrameScriptHolder = FirebaseIFrameScriptHolder;
//# sourceMappingURL=BrowserPollConnection.js.map


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Connection = undefined;

var _util = __webpack_require__(3);

var _storage = __webpack_require__(80);

var _Constants = __webpack_require__(82);

var _TransportManager = __webpack_require__(409);

// Abort upgrade attempt if it takes longer than 60s.
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
var DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
var BYTES_SENT_HEALTHY_OVERRIDE = 10 * 1024;
var BYTES_RECEIVED_HEALTHY_OVERRIDE = 100 * 1024;
var MESSAGE_TYPE = 't';
var MESSAGE_DATA = 'd';
var CONTROL_SHUTDOWN = 's';
var CONTROL_RESET = 'r';
var CONTROL_ERROR = 'e';
var CONTROL_PONG = 'o';
var SWITCH_ACK = 'a';
var END_TRANSMISSION = 'n';
var PING = 'p';
var SERVER_HELLO = 'h';
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 *
 * @constructor
 */
var Connection = /** @class */function () {
    /**
     * @param {!string} id - an id for this connection
     * @param {!RepoInfo} repoInfo_ - the info for the endpoint to connect to
     * @param {function(Object)} onMessage_ - the callback to be triggered when a server-push message arrives
     * @param {function(number, string)} onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param {function()} onDisconnect_ - the callback to be triggered when a connection was lost
     * @param {function(string)} onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param {string=} lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */
    function Connection(id, repoInfo_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId) {
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* CONNECTING */;
        this.log_ = (0, _util.logWrapper)('c:' + this.id + ':');
        this.transportManager_ = new _TransportManager.TransportManager(repoInfo_);
        this.log_('Connection created');
        this.start_();
    }
    /**
     * Starts a connection attempt
     * @private
     */
    Connection.prototype.start_ = function () {
        var _this = this;
        var conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, undefined, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        var onMessageReceived = this.connReceiver_(this.conn_);
        var onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */
        setTimeout(function () {
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            _this.conn_ && _this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        var healthyTimeout_ms = conn['healthyTimeout'] || 0;
        if (healthyTimeout_ms > 0) {
            this.healthyTimeout_ = (0, _util.setTimeoutNonBlocking)(function () {
                _this.healthyTimeout_ = null;
                if (!_this.isHealthy_) {
                    if (_this.conn_ && _this.conn_.bytesReceived > BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                        _this.log_('Connection exceeded healthy timeout but has received ' + _this.conn_.bytesReceived + ' bytes.  Marking connection healthy.');
                        _this.isHealthy_ = true;
                        _this.conn_.markConnectionHealthy();
                    } else if (_this.conn_ && _this.conn_.bytesSent > BYTES_SENT_HEALTHY_OVERRIDE) {
                        _this.log_('Connection exceeded healthy timeout but has sent ' + _this.conn_.bytesSent + ' bytes.  Leaving connection alive.');
                        // NOTE: We don't want to mark it healthy, since we have no guarantee that the bytes have made it to
                        // the server.
                    } else {
                        _this.log_('Closing unhealthy connection after timeout.');
                        _this.close();
                    }
                }
            }, Math.floor(healthyTimeout_ms));
        }
    };
    /**
     * @return {!string}
     * @private
     */
    Connection.prototype.nextTransportId_ = function () {
        return 'c:' + this.id + ':' + this.connectionCount++;
    };
    Connection.prototype.disconnReceiver_ = function (conn) {
        var _this = this;
        return function (everConnected) {
            if (conn === _this.conn_) {
                _this.onConnectionLost_(everConnected);
            } else if (conn === _this.secondaryConn_) {
                _this.log_('Secondary connection lost.');
                _this.onSecondaryConnectionLost_();
            } else {
                _this.log_('closing an old connection');
            }
        };
    };
    Connection.prototype.connReceiver_ = function (conn) {
        var _this = this;
        return function (message) {
            if (_this.state_ != 2 /* DISCONNECTED */) {
                    if (conn === _this.rx_) {
                        _this.onPrimaryMessageReceived_(message);
                    } else if (conn === _this.secondaryConn_) {
                        _this.onSecondaryMessageReceived_(message);
                    } else {
                        _this.log_('message on old connection');
                    }
                }
        };
    };
    /**
     *
     * @param {Object} dataMsg An arbitrary data message to be sent to the server
     */
    Connection.prototype.sendRequest = function (dataMsg) {
        // wrap in a data message envelope and send it on
        var msg = { t: 'd', d: dataMsg };
        this.sendData_(msg);
    };
    Connection.prototype.tryCleanupConnection = function () {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
            // the server will shutdown the old connection
        }
    };
    Connection.prototype.onSecondaryControl_ = function (controlData) {
        if (MESSAGE_TYPE in controlData) {
            var cmd = controlData[MESSAGE_TYPE];
            if (cmd === SWITCH_ACK) {
                this.upgradeIfSecondaryHealthy_();
            } else if (cmd === CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_('Got a reset on secondary, closing it');
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ || this.rx_ === this.secondaryConn_) {
                    this.close();
                }
            } else if (cmd === CONTROL_PONG) {
                this.log_('got pong on secondary.');
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    };
    Connection.prototype.onSecondaryMessageReceived_ = function (parsedData) {
        var layer = (0, _util.requireKey)('t', parsedData);
        var data = (0, _util.requireKey)('d', parsedData);
        if (layer == 'c') {
            this.onSecondaryControl_(data);
        } else if (layer == 'd') {
            // got a data message, but we're still second connection. Need to buffer it up
            this.pendingDataMessages.push(data);
        } else {
            throw new Error('Unknown protocol layer: ' + layer);
        }
    };
    Connection.prototype.upgradeIfSecondaryHealthy_ = function () {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_('Secondary connection is healthy.');
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        } else {
            // Send a ping to make sure the connection is healthy.
            this.log_('sending ping on secondary.');
            this.secondaryConn_.send({ t: 'c', d: { t: PING, d: {} } });
        }
    };
    Connection.prototype.proceedWithUpgrade_ = function () {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_('sending client ack on secondary');
        this.secondaryConn_.send({ t: 'c', d: { t: SWITCH_ACK, d: {} } });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_('Ending transmission on primary');
        this.conn_.send({ t: 'c', d: { t: END_TRANSMISSION, d: {} } });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    };
    Connection.prototype.onPrimaryMessageReceived_ = function (parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        var layer = (0, _util.requireKey)('t', parsedData);
        var data = (0, _util.requireKey)('d', parsedData);
        if (layer == 'c') {
            this.onControl_(data);
        } else if (layer == 'd') {
            this.onDataMessage_(data);
        }
    };
    Connection.prototype.onDataMessage_ = function (message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    };
    Connection.prototype.onPrimaryResponse_ = function () {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_('Primary connection is healthy.');
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    };
    Connection.prototype.onControl_ = function (controlData) {
        var cmd = (0, _util.requireKey)(MESSAGE_TYPE, controlData);
        if (MESSAGE_DATA in controlData) {
            var payload = controlData[MESSAGE_DATA];
            if (cmd === SERVER_HELLO) {
                this.onHandshake_(payload);
            } else if (cmd === END_TRANSMISSION) {
                this.log_('recvd end transmission on primary');
                this.rx_ = this.secondaryConn_;
                for (var i = 0; i < this.pendingDataMessages.length; ++i) {
                    this.onDataMessage_(this.pendingDataMessages[i]);
                }
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            } else if (cmd === CONTROL_SHUTDOWN) {
                // This was previously the 'onKill' callback passed to the lower-level connection
                // payload in this case is the reason for the shutdown. Generally a human-readable error
                this.onConnectionShutdown_(payload);
            } else if (cmd === CONTROL_RESET) {
                // payload in this case is the host we should contact
                this.onReset_(payload);
            } else if (cmd === CONTROL_ERROR) {
                (0, _util.error)('Server Error: ' + payload);
            } else if (cmd === CONTROL_PONG) {
                this.log_('got pong on primary.');
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            } else {
                (0, _util.error)('Unknown control packet command: ' + cmd);
            }
        }
    };
    /**
     *
     * @param {Object} handshake The handshake data returned from the server
     * @private
     */
    Connection.prototype.onHandshake_ = function (handshake) {
        var timestamp = handshake.ts;
        var version = handshake.v;
        var host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.updateHost(host);
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ == 0 /* CONNECTING */) {
                this.conn_.start();
                this.onConnectionEstablished_(this.conn_, timestamp);
                if (_Constants.PROTOCOL_VERSION !== version) {
                    (0, _util.warn)('Protocol version mismatch detected');
                }
                // TODO: do we want to upgrade? when? maybe a delay?
                this.tryStartUpgrade_();
            }
    };
    Connection.prototype.tryStartUpgrade_ = function () {
        var conn = this.transportManager_.upgradeTransport();
        if (conn) {
            this.startUpgrade_(conn);
        }
    };
    Connection.prototype.startUpgrade_ = function (conn) {
        var _this = this;
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        var onMessage = this.connReceiver_(this.secondaryConn_);
        var onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        (0, _util.setTimeoutNonBlocking)(function () {
            if (_this.secondaryConn_) {
                _this.log_('Timed out trying to upgrade.');
                _this.secondaryConn_.close();
            }
        }, Math.floor(UPGRADE_TIMEOUT));
    };
    Connection.prototype.onReset_ = function (host) {
        this.log_('Reset packet received.  New host: ' + host);
        this.repoInfo_.updateHost(host);
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* CONNECTED */) {
                this.close();
            } else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    };
    Connection.prototype.onConnectionEstablished_ = function (conn, timestamp) {
        var _this = this;
        this.log_('Realtime connection established.');
        this.conn_ = conn;
        this.state_ = 1 /* CONNECTED */;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_('Primary connection is healthy.');
            this.isHealthy_ = true;
        } else {
            (0, _util.setTimeoutNonBlocking)(function () {
                _this.sendPingOnPrimaryIfNecessary_();
            }, Math.floor(DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
        }
    };
    Connection.prototype.sendPingOnPrimaryIfNecessary_ = function () {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* CONNECTED */) {
                this.log_('sending ping on primary.');
                this.sendData_({ t: 'c', d: { t: PING, d: {} } });
            }
    };
    Connection.prototype.onSecondaryConnectionLost_ = function () {
        var conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) {
            // we are relying on this connection already in some capacity. Therefore, a failure is real
            this.close();
        }
    };
    /**
     *
     * @param {boolean} everConnected Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     * @private
     */
    Connection.prototype.onConnectionLost_ = function (everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* CONNECTING */) {
                this.log_('Realtime connection failed.');
                // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
                if (this.repoInfo_.isCacheableHost()) {
                    _storage.PersistentStorage.remove('host:' + this.repoInfo_.host);
                    // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                    this.repoInfo_.internalHost = this.repoInfo_.host;
                }
            } else if (this.state_ === 1 /* CONNECTED */) {
                this.log_('Realtime connection lost.');
            }
        this.close();
    };
    /**
     *
     * @param {string} reason
     * @private
     */
    Connection.prototype.onConnectionShutdown_ = function (reason) {
        this.log_('Connection shutdown command received. Shutting down...');
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    };
    Connection.prototype.sendData_ = function (data) {
        if (this.state_ !== 1 /* CONNECTED */) {
                throw 'Connection is not connected';
            } else {
            this.tx_.send(data);
        }
    };
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */
    Connection.prototype.close = function () {
        if (this.state_ !== 2 /* DISCONNECTED */) {
                this.log_('Closing realtime connection.');
                this.state_ = 2 /* DISCONNECTED */;
                this.closeConnections_();
                if (this.onDisconnect_) {
                    this.onDisconnect_();
                    this.onDisconnect_ = null;
                }
            }
    };
    /**
     *
     * @private
     */
    Connection.prototype.closeConnections_ = function () {
        this.log_('Shutting down all connections');
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    };
    return Connection;
}();
exports.Connection = Connection;
//# sourceMappingURL=Connection.js.map


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WebSocketConnection = undefined;
exports.setWebSocketImpl = setWebSocketImpl;

var _app = __webpack_require__(34);

var _app2 = _interopRequireDefault(_app);

var _assert = __webpack_require__(2);

var _util = __webpack_require__(3);

var _StatsManager = __webpack_require__(106);

var _Constants = __webpack_require__(82);

var _constants = __webpack_require__(86);

var _storage = __webpack_require__(80);

var _json = __webpack_require__(23);

var _environment = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WEBSOCKET_MAX_FRAME_SIZE = 16384; /**
                                       * Copyright 2017 Google Inc.
                                       *
                                       * Licensed under the Apache License, Version 2.0 (the "License");
                                       * you may not use this file except in compliance with the License.
                                       * You may obtain a copy of the License at
                                       *
                                       *   http://www.apache.org/licenses/LICENSE-2.0
                                       *
                                       * Unless required by applicable law or agreed to in writing, software
                                       * distributed under the License is distributed on an "AS IS" BASIS,
                                       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                       * See the License for the specific language governing permissions and
                                       * limitations under the License.
                                       */

var WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
var WebSocketImpl = null;
if (typeof MozWebSocket !== 'undefined') {
    WebSocketImpl = MozWebSocket;
} else if (typeof WebSocket !== 'undefined') {
    WebSocketImpl = WebSocket;
}
function setWebSocketImpl(impl) {
    WebSocketImpl = impl;
}
/**
 * Create a new websocket connection with the given callbacks.
 * @constructor
 * @implements {Transport}
 */
var WebSocketConnection = /** @class */function () {
    /**
     * @param {string} connId identifier for this transport
     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
     */
    function WebSocketConnection(connId, repoInfo, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = (0, _util.logWrapper)(this.connId);
        this.stats_ = _StatsManager.StatsManager.getCollection(repoInfo);
        this.connURL = WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId);
    }
    /**
     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
     * @return {string} connection url
     * @private
     */
    WebSocketConnection.connectionURL_ = function (repoInfo, transportSessionId, lastSessionId) {
        var urlParams = {};
        urlParams[_Constants.VERSION_PARAM] = _Constants.PROTOCOL_VERSION;
        if (!(0, _environment.isNodeSdk)() && typeof location !== 'undefined' && location.href && location.href.indexOf(_Constants.FORGE_DOMAIN) !== -1) {
            urlParams[_Constants.REFERER_PARAM] = _Constants.FORGE_REF;
        }
        if (transportSessionId) {
            urlParams[_Constants.TRANSPORT_SESSION_PARAM] = transportSessionId;
        }
        if (lastSessionId) {
            urlParams[_Constants.LAST_SESSION_PARAM] = lastSessionId;
        }
        return repoInfo.connectionURL(_Constants.WEBSOCKET, urlParams);
    };
    /**
     *
     * @param onMessage Callback when messages arrive
     * @param onDisconnect Callback with connection lost.
     */
    WebSocketConnection.prototype.open = function (onMessage, onDisconnect) {
        var _this = this;
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_('Websocket connecting to ' + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        _storage.PersistentStorage.set('previous_websocket_failure', true);
        try {
            if ((0, _environment.isNodeSdk)()) {
                var device = _constants.CONSTANTS.NODE_ADMIN ? 'AdminNode' : 'Node';
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                var options = {
                    headers: {
                        'User-Agent': "Firebase/" + _Constants.PROTOCOL_VERSION + "/" + _app2.default.SDK_VERSION + "/" + process.platform + "/" + device
                    }
                };
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                var env = __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"/garage48-vrideas"});
                var proxy = this.connURL.indexOf('wss://') == 0 ? env['HTTPS_PROXY'] || env['https_proxy'] : env['HTTP_PROXY'] || env['http_proxy'];
                if (proxy) {
                    options['proxy'] = { origin: proxy };
                }
                this.mySock = new WebSocketImpl(this.connURL, [], options);
            } else {
                this.mySock = new WebSocketImpl(this.connURL);
            }
        } catch (e) {
            this.log_('Error instantiating WebSocket.');
            var error = e.message || e.data;
            if (error) {
                this.log_(error);
            }
            this.onClosed_();
            return;
        }
        this.mySock.onopen = function () {
            _this.log_('Websocket connected.');
            _this.everConnected_ = true;
        };
        this.mySock.onclose = function () {
            _this.log_('Websocket connection was disconnected.');
            _this.mySock = null;
            _this.onClosed_();
        };
        this.mySock.onmessage = function (m) {
            _this.handleIncomingFrame(m);
        };
        this.mySock.onerror = function (e) {
            _this.log_('WebSocket error.  Closing connection.');
            var error = e.message || e.data;
            if (error) {
                _this.log_(error);
            }
            _this.onClosed_();
        };
    };
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */
    WebSocketConnection.prototype.start = function () {};
    WebSocketConnection.forceDisallow = function () {
        WebSocketConnection.forceDisallow_ = true;
    };
    WebSocketConnection.isAvailable = function () {
        var isOldAndroid = false;
        if (typeof navigator !== 'undefined' && navigator.userAgent) {
            var oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            var oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) {
                    isOldAndroid = true;
                }
            }
        }
        return !isOldAndroid && WebSocketImpl !== null && !WebSocketConnection.forceDisallow_;
    };
    /**
     * Returns true if we previously failed to connect with this transport.
     * @return {boolean}
     */
    WebSocketConnection.previouslyFailed = function () {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return _storage.PersistentStorage.isInMemoryStorage || _storage.PersistentStorage.get('previous_websocket_failure') === true;
    };
    WebSocketConnection.prototype.markConnectionHealthy = function () {
        _storage.PersistentStorage.remove('previous_websocket_failure');
    };
    WebSocketConnection.prototype.appendFrame_ = function (data) {
        this.frames.push(data);
        if (this.frames.length == this.totalFrames) {
            var fullMess = this.frames.join('');
            this.frames = null;
            var jsonMess = (0, _json.jsonEval)(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    };
    /**
     * @param {number} frameCount The number of frames we are expecting from the server
     * @private
     */
    WebSocketConnection.prototype.handleNewFrameCount_ = function (frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    };
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @param {!String} data
     * @return {?String} Any remaining data to be process, or null if there is none
     * @private
     */
    WebSocketConnection.prototype.extractFrameCount_ = function (data) {
        (0, _assert.assert)(this.frames === null, 'We already have a frame buffer');
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            var frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    };
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess The frame data
     */
    WebSocketConnection.prototype.handleIncomingFrame = function (mess) {
        if (this.mySock === null) return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        var data = mess['data'];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter('bytes_received', data.length);
        this.resetKeepAlive();
        if (this.frames !== null) {
            // we're buffering
            this.appendFrame_(data);
        } else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            var remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) {
                this.appendFrame_(remainingData);
            }
        }
    };
    /**
     * Send a message to the server
     * @param {Object} data The JSON object to transmit
     */
    WebSocketConnection.prototype.send = function (data) {
        this.resetKeepAlive();
        var dataStr = (0, _json.stringify)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = (0, _util.splitStringBySize)(dataStr, WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) {
            this.sendString_(String(dataSegs.length));
        }
        //Send the actual data in segments.
        for (var i = 0; i < dataSegs.length; i++) {
            this.sendString_(dataSegs[i]);
        }
    };
    WebSocketConnection.prototype.shutdown_ = function () {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    };
    WebSocketConnection.prototype.onClosed_ = function () {
        if (!this.isClosed_) {
            this.log_('WebSocket is closing itself');
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    };
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */
    WebSocketConnection.prototype.close = function () {
        if (!this.isClosed_) {
            this.log_('WebSocket is being closed');
            this.shutdown_();
        }
    };
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */
    WebSocketConnection.prototype.resetKeepAlive = function () {
        var _this = this;
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(function () {
            //If there has been no websocket activity for a while, send a no-op
            if (_this.mySock) {
                _this.sendString_('0');
            }
            _this.resetKeepAlive();
        }, Math.floor(WEBSOCKET_KEEPALIVE_INTERVAL));
    };
    /**
     * Send a string over the websocket.
     *
     * @param {string} str String to send.
     * @private
     */
    WebSocketConnection.prototype.sendString_ = function (str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        } catch (e) {
            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
            setTimeout(this.onClosed_.bind(this), 0);
        }
    };
    /**
     * Number of response before we consider the connection "healthy."
     * @type {number}
     */
    WebSocketConnection.responsesRequiredToBeHealthy = 2;
    /**
     * Time to wait for the connection te become healthy before giving up.
     * @type {number}
     */
    WebSocketConnection.healthyTimeout = 30000;
    return WebSocketConnection;
}();
exports.WebSocketConnection = WebSocketConnection;
//# sourceMappingURL=WebSocketConnection.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)))

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _errors = __webpack_require__(103);

var _errors2 = __webpack_require__(83);

var _errors3 = _interopRequireDefault(_errors2);

var _tokenManager = __webpack_require__(417);

var _tokenManager2 = _interopRequireDefault(_tokenManager);

var _notificationPermission = __webpack_require__(185);

var _notificationPermission2 = _interopRequireDefault(_notificationPermission);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SENDER_ID_OPTION_NAME = 'messagingSenderId';
var ControllerInterface = /** @class */function () {
    /**
     * An interface of the Messaging Service API
     * @param {!firebase.app.App} app
     */
    function ControllerInterface(app) {
        var _this = this;
        this.errorFactory_ = new _errors.ErrorFactory('messaging', 'Messaging', _errors3.default.map);
        if (!app.options[SENDER_ID_OPTION_NAME] || typeof app.options[SENDER_ID_OPTION_NAME] !== 'string') {
            throw this.errorFactory_.create(_errors3.default.codes.BAD_SENDER_ID);
        }
        this.messagingSenderId_ = app.options[SENDER_ID_OPTION_NAME];
        this.tokenManager_ = new _tokenManager2.default();
        this.app = app;
        this.INTERNAL = {};
        this.INTERNAL.delete = function () {
            return _this.delete;
        };
    }
    /**
     * @export
     * @return {Promise<string> | Promise<null>} Returns a promise that
     * resolves to an FCM token.
     */
    ControllerInterface.prototype.getToken = function () {
        var _this = this;
        // Check with permissions
        var currentPermission = this.getNotificationPermission_();
        if (currentPermission !== _notificationPermission2.default.granted) {
            if (currentPermission === _notificationPermission2.default.denied) {
                return Promise.reject(this.errorFactory_.create(_errors3.default.codes.NOTIFICATIONS_BLOCKED));
            }
            // We must wait for permission to be granted
            return Promise.resolve(null);
        }
        return this.getSWRegistration_().then(function (registration) {
            return _this.tokenManager_.getSavedToken(_this.messagingSenderId_, registration).then(function (token) {
                if (token) {
                    return token;
                }
                return _this.tokenManager_.createToken(_this.messagingSenderId_, registration);
            });
        });
    };
    /**
     * This method deletes tokens that the token manager looks after and then
     * unregisters the push subscription if it exists.
     * @export
     * @param {string} token
     * @return {Promise<void>}
     */
    ControllerInterface.prototype.deleteToken = function (token) {
        var _this = this;
        return this.tokenManager_.deleteToken(token).then(function () {
            return _this.getSWRegistration_().then(function (registration) {
                if (registration) {
                    return registration.pushManager.getSubscription();
                }
            }).then(function (subscription) {
                if (subscription) {
                    return subscription.unsubscribe();
                }
            });
        });
    };
    ControllerInterface.prototype.getSWRegistration_ = function () {
        throw this.errorFactory_.create(_errors3.default.codes.SHOULD_BE_INHERITED);
    };
    //
    // The following methods should only be available in the window.
    //
    ControllerInterface.prototype.requestPermission = function () {
        throw this.errorFactory_.create(_errors3.default.codes.AVAILABLE_IN_WINDOW);
    };
    /**
     * @export
     * @param {!ServiceWorkerRegistration} registration
     */
    ControllerInterface.prototype.useServiceWorker = function (registration) {
        throw this.errorFactory_.create(_errors3.default.codes.AVAILABLE_IN_WINDOW);
    };
    /**
     * @export
     * @param {!firebase.Observer|function(*)} nextOrObserver
     * @param {function(!Error)=} optError
     * @param {function()=} optCompleted
     * @return {!function()}
     */
    ControllerInterface.prototype.onMessage = function (nextOrObserver, optError, optCompleted) {
        throw this.errorFactory_.create(_errors3.default.codes.AVAILABLE_IN_WINDOW);
    };
    /**
     * @export
     * @param {!firebase.Observer|function()} nextOrObserver An observer object
     * or a function triggered on token refresh.
     * @param {function(!Error)=} optError Optional A function
     * triggered on token refresh error.
     * @param {function()=} optCompleted Optional function triggered when the
     * observer is removed.
     * @return {!function()} The unsubscribe function for the observer.
     */
    ControllerInterface.prototype.onTokenRefresh = function (nextOrObserver, optError, optCompleted) {
        throw this.errorFactory_.create(_errors3.default.codes.AVAILABLE_IN_WINDOW);
    };
    //
    // The following methods are used by the service worker only.
    //
    /**
     * @export
     * @param {function(Object)} callback
     */
    ControllerInterface.prototype.setBackgroundMessageHandler = function (callback) {
        throw this.errorFactory_.create(_errors3.default.codes.AVAILABLE_IN_SW);
    };
    //
    // The following methods are used by the service themselves and not exposed
    // publicly or not expected to be used by developers.
    //
    /**
     * This method is required to adhere to the Firebase interface.
     * It closes any currently open indexdb database connections.
     */
    ControllerInterface.prototype.delete = function () {
        this.tokenManager_.closeDatabase();
    };
    /**
     * Returns the current Notification Permission state.
     * @private
     * @return {string} The currenct permission state.
     */
    ControllerInterface.prototype.getNotificationPermission_ = function () {
        return Notification.permission;
    };
    /**
     * @protected
     * @returns {TokenManager}
     */
    ControllerInterface.prototype.getTokenManager = function () {
        return this.tokenManager_;
    };
    return ControllerInterface;
}();
exports.default = ControllerInterface;
module.exports = exports['default'];
//# sourceMappingURL=controller-interface.js.map


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


Object.defineProperty(exports, "__esModule", {
    value: true
});
var FCM_APPLICATION_SERVER_KEY = [0x04, 0x33, 0x94, 0xf7, 0xdf, 0xa1, 0xeb, 0xb1, 0xdc, 0x03, 0xa2, 0x5e, 0x15, 0x71, 0xdb, 0x48, 0xd3, 0x2e, 0xed, 0xed, 0xb2, 0x34, 0xdb, 0xb7, 0x47, 0x3a, 0x0c, 0x8f, 0xc4, 0xcc, 0xe1, 0x6f, 0x3c, 0x8c, 0x84, 0xdf, 0xab, 0xb6, 0x66, 0x3e, 0xf2, 0x0c, 0xd4, 0x8b, 0xfe, 0xe3, 0xf9, 0x76, 0x2f, 0x14, 0x1c, 0x63, 0x08, 0x6a, 0x6f, 0x2d, 0xb1, 0x1a, 0x95, 0xb0, 0xce, 0x37, 0xc0, 0x9c, 0x6e];
var SUBSCRIPTION_DETAILS = {
    userVisibleOnly: true,
    applicationServerKey: new Uint8Array(FCM_APPLICATION_SERVER_KEY)
};
exports.default = {
    ENDPOINT: 'https://fcm.googleapis.com',
    APPLICATION_SERVER_KEY: FCM_APPLICATION_SERVER_KEY,
    SUBSCRIPTION_OPTIONS: SUBSCRIPTION_DETAILS
};
module.exports = exports['default'];
//# sourceMappingURL=fcm-details.js.map


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  granted: 'granted',
  default: 'default',
  denied: 'denied'
};
module.exports = exports['default'];
//# sourceMappingURL=notification-permission.js.map


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// These fields are strings to prevent closure from thinking goog.getMsg
// should be used to initialise the values

Object.defineProperty(exports, "__esModule", {
    value: true
});
var PARAMS = {
    TYPE_OF_MSG: 'firebase-messaging-msg-type',
    DATA: 'firebase-messaging-msg-data'
};
// This value isn't using the TYPE_OF_MSG short hand as closure
// expects the variable to be defined via goog.getMsg
var msgType = {
    PUSH_MSG_RECEIVED: 'push-msg-received',
    NOTIFICATION_CLICKED: 'notification-clicked'
};
var createNewMsg = function createNewMsg(msgType, msgData) {
    var message = (_a = {}, _a[PARAMS.TYPE_OF_MSG] = msgType, _a[PARAMS.DATA] = msgData, _a);
    return message;
    var _a;
};
exports.default = {
    PARAMS: PARAMS,
    TYPES_OF_MSG: msgType,
    createNewMsg: createNewMsg
};
module.exports = exports['default'];
//# sourceMappingURL=worker-page-message.js.map


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FbsBlob = undefined;

var _fs = __webpack_require__(424);

var fs = _interopRequireWildcard(_fs);

var _string = __webpack_require__(113);

var string = _interopRequireWildcard(_string);

var _type = __webpack_require__(20);

var type = _interopRequireWildcard(_type);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * @param opt_elideCopy If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @file Provides a Blob-like wrapper for various binary types (including the
 * native Blob type). This makes it possible to upload types like ArrayBuffers,
 * making uploads possible in environments without the native Blob type.
 */
var FbsBlob = /** @class */function () {
    function FbsBlob(data, opt_elideCopy) {
        var size = 0;
        var blobType = '';
        if (type.isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        } else if (data instanceof ArrayBuffer) {
            if (opt_elideCopy) {
                this.data_ = new Uint8Array(data);
            } else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        } else if (data instanceof Uint8Array) {
            if (opt_elideCopy) {
                this.data_ = data;
            } else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    FbsBlob.prototype.size = function () {
        return this.size_;
    };
    FbsBlob.prototype.type = function () {
        return this.type_;
    };
    FbsBlob.prototype.slice = function (startByte, endByte) {
        if (type.isNativeBlob(this.data_)) {
            var realBlob = this.data_;
            var sliced = fs.sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) {
                return null;
            }
            return new FbsBlob(sliced);
        } else {
            var slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new FbsBlob(slice, true);
        }
    };
    FbsBlob.getBlob = function () {
        var var_args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            var_args[_i] = arguments[_i];
        }
        if (type.isNativeBlobDefined()) {
            var blobby = var_args.map(function (val) {
                if (val instanceof FbsBlob) {
                    return val.data_;
                } else {
                    return val;
                }
            });
            return new FbsBlob(fs.getBlob.apply(null, blobby));
        } else {
            var uint8Arrays = var_args.map(function (val) {
                if (type.isString(val)) {
                    return string.dataFromString(_string.StringFormat.RAW, val).data;
                } else {
                    // Blobs don't exist, so this has to be a Uint8Array.
                    return val.data_;
                }
            });
            var finalLength_1 = 0;
            uint8Arrays.forEach(function (array) {
                finalLength_1 += array.byteLength;
            });
            var merged_1 = new Uint8Array(finalLength_1);
            var index_1 = 0;
            uint8Arrays.forEach(function (array) {
                for (var i = 0; i < array.length; i++) {
                    merged_1[index_1++] = array[i];
                }
            });
            return new FbsBlob(merged_1, true);
        }
    };
    FbsBlob.prototype.uploadData = function () {
        return this.data_;
    };
    return FbsBlob;
}();
exports.FbsBlob = FbsBlob;
//# sourceMappingURL=blob.js.map


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parent = parent;
exports.child = child;
exports.lastComponent = lastComponent;
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Contains helper methods for manipulating paths.
 */
/**
 * @return Null if the path is already at the root.
 */
function parent(path) {
    if (path.length == 0) {
        return null;
    }
    var index = path.lastIndexOf('/');
    if (index === -1) {
        return '';
    }
    var newPath = path.slice(0, index);
    return newPath;
}
function child(path, childPath) {
    var canonicalChildPath = childPath.split('/').filter(function (component) {
        return component.length > 0;
    }).join('/');
    if (path.length === 0) {
        return canonicalChildPath;
    } else {
        return path + '/' + canonicalChildPath;
    }
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */
function lastComponent(path) {
    var index = path.lastIndexOf('/', path.length - 2);
    if (index === -1) {
        return path;
    } else {
        return path.slice(index + 1);
    }
}
//# sourceMappingURL=path.js.map


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resumableUploadChunkSize = exports.ResumableUploadStatus = undefined;
exports.handlerCheck = handlerCheck;
exports.metadataHandler = metadataHandler;
exports.sharedErrorHandler = sharedErrorHandler;
exports.objectErrorHandler = objectErrorHandler;
exports.getMetadata = getMetadata;
exports.updateMetadata = updateMetadata;
exports.deleteObject = deleteObject;
exports.determineContentType_ = determineContentType_;
exports.metadataForUpload_ = metadataForUpload_;
exports.multipartUpload = multipartUpload;
exports.checkResumeHeader_ = checkResumeHeader_;
exports.createResumableUpload = createResumableUpload;
exports.getResumableUploadStatus = getResumableUploadStatus;
exports.continueResumableUpload = continueResumableUpload;

var _array = __webpack_require__(111);

var array = _interopRequireWildcard(_array);

var _blob = __webpack_require__(187);

var _error = __webpack_require__(26);

var errorsExports = _interopRequireWildcard(_error);

var _metadata = __webpack_require__(112);

var MetadataUtils = _interopRequireWildcard(_metadata);

var _object = __webpack_require__(49);

var object = _interopRequireWildcard(_object);

var _requestinfo = __webpack_require__(428);

var _type = __webpack_require__(20);

var type = _interopRequireWildcard(_type);

var _url = __webpack_require__(114);

var UrlUtils = _interopRequireWildcard(_url);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Throws the UNKNOWN FirebaseStorageError if cndn is false.
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function handlerCheck(cndn) {
    if (!cndn) {
        throw errorsExports.unknown();
    }
}
function metadataHandler(authWrapper, mappings) {
    function handler(xhr, text) {
        var metadata = MetadataUtils.fromResourceString(authWrapper, text, mappings);
        handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        var newErr;
        if (xhr.getStatus() === 401) {
            newErr = errorsExports.unauthenticated();
        } else {
            if (xhr.getStatus() === 402) {
                newErr = errorsExports.quotaExceeded(location.bucket);
            } else {
                if (xhr.getStatus() === 403) {
                    newErr = errorsExports.unauthorized(location.path);
                } else {
                    newErr = err;
                }
            }
        }
        newErr.setServerResponseProp(err.serverResponseProp());
        return newErr;
    }
    return errorHandler;
}
function objectErrorHandler(location) {
    var shared = sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        var newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) {
            newErr = errorsExports.objectNotFound(location.path);
        }
        newErr.setServerResponseProp(err.serverResponseProp());
        return newErr;
    }
    return errorHandler;
}
function getMetadata(authWrapper, location, mappings) {
    var urlPart = location.fullServerUrl();
    var url = UrlUtils.makeNormalUrl(urlPart);
    var method = 'GET';
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new _requestinfo.RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function updateMetadata(authWrapper, location, metadata, mappings) {
    var urlPart = location.fullServerUrl();
    var url = UrlUtils.makeNormalUrl(urlPart);
    var method = 'PATCH';
    var body = MetadataUtils.toResourceString(metadata, mappings);
    var headers = { 'Content-Type': 'application/json; charset=utf-8' };
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new _requestinfo.RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function deleteObject(authWrapper, location) {
    var urlPart = location.fullServerUrl();
    var url = UrlUtils.makeNormalUrl(urlPart);
    var method = 'DELETE';
    var timeout = authWrapper.maxOperationRetryTime();
    function handler(xhr, text) {}
    var requestInfo = new _requestinfo.RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [200, 204];
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function determineContentType_(metadata, blob) {
    return metadata && metadata['contentType'] || blob && blob.type() || 'application/octet-stream';
}
function metadataForUpload_(location, blob, opt_metadata) {
    var metadata = object.clone(opt_metadata);
    metadata['fullPath'] = location.path;
    metadata['size'] = blob.size();
    if (!metadata['contentType']) {
        metadata['contentType'] = determineContentType_(null, blob);
    }
    return metadata;
}
function multipartUpload(authWrapper, location, mappings, blob, opt_metadata) {
    var urlPart = location.bucketOnlyServerUrl();
    var headers = {
        'X-Goog-Upload-Protocol': 'multipart'
    };
    function genBoundary() {
        var str = '';
        for (var i = 0; i < 2; i++) {
            str = str + Math.random().toString().slice(2);
        }
        return str;
    }
    var boundary = genBoundary();
    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
    var metadata = metadataForUpload_(location, blob, opt_metadata);
    var metadataString = MetadataUtils.toResourceString(metadata, mappings);
    var preBlobPart = '--' + boundary + '\r\n' + 'Content-Type: application/json; charset=utf-8\r\n\r\n' + metadataString + '\r\n--' + boundary + '\r\n' + 'Content-Type: ' + metadata['contentType'] + '\r\n\r\n';
    var postBlobPart = '\r\n--' + boundary + '--';
    var body = _blob.FbsBlob.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) {
        throw errorsExports.cannotSliceBlob();
    }
    var urlParams = { name: metadata['fullPath'] };
    var url = UrlUtils.makeUploadUrl(urlPart);
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new _requestinfo.RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 * @struct
 */
var ResumableUploadStatus = /** @class */function () {
    function ResumableUploadStatus(current, total, finalized, metadata) {
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
    return ResumableUploadStatus;
}();
exports.ResumableUploadStatus = ResumableUploadStatus;
function checkResumeHeader_(xhr, opt_allowed) {
    var status;
    try {
        status = xhr.getResponseHeader('X-Goog-Upload-Status');
    } catch (e) {
        handlerCheck(false);
    }
    var allowed = opt_allowed || ['active'];
    handlerCheck(array.contains(allowed, status));
    return status;
}
function createResumableUpload(authWrapper, location, mappings, blob, opt_metadata) {
    var urlPart = location.bucketOnlyServerUrl();
    var metadata = metadataForUpload_(location, blob, opt_metadata);
    var urlParams = { name: metadata['fullPath'] };
    var url = UrlUtils.makeUploadUrl(urlPart);
    var method = 'POST';
    var headers = {
        'X-Goog-Upload-Protocol': 'resumable',
        'X-Goog-Upload-Command': 'start',
        'X-Goog-Upload-Header-Content-Length': blob.size(),
        'X-Goog-Upload-Header-Content-Type': metadata['contentType'],
        'Content-Type': 'application/json; charset=utf-8'
    };
    var body = MetadataUtils.toResourceString(metadata, mappings);
    var timeout = authWrapper.maxUploadRetryTime();
    function handler(xhr, text) {
        checkResumeHeader_(xhr);
        var url;
        try {
            url = xhr.getResponseHeader('X-Goog-Upload-URL');
        } catch (e) {
            handlerCheck(false);
        }
        handlerCheck(type.isString(url));
        return url;
    }
    var requestInfo = new _requestinfo.RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */
function getResumableUploadStatus(authWrapper, location, url, blob) {
    var headers = { 'X-Goog-Upload-Command': 'query' };
    function handler(xhr, text) {
        var status = checkResumeHeader_(xhr, ['active', 'final']);
        var sizeString;
        try {
            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
        } catch (e) {
            handlerCheck(false);
        }
        var size = parseInt(sizeString, 10);
        handlerCheck(!isNaN(size));
        return new ResumableUploadStatus(size, blob.size(), status === 'final');
    }
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new _requestinfo.RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */
var resumableUploadChunkSize = exports.resumableUploadChunkSize = 256 * 1024;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param opt_status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */
function continueResumableUpload(location, authWrapper, url, blob, chunkSize, mappings, opt_status, opt_progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    var status = new ResumableUploadStatus(0, 0);
    if (opt_status) {
        status.current = opt_status.current;
        status.total = opt_status.total;
    } else {
        status.current = 0;
        status.total = blob.size();
    }
    if (blob.size() !== status.total) {
        throw errorsExports.serverFileWrongSize();
    }
    var bytesLeft = status.total - status.current;
    var bytesToUpload = bytesLeft;
    if (chunkSize > 0) {
        bytesToUpload = Math.min(bytesToUpload, chunkSize);
    }
    var startByte = status.current;
    var endByte = startByte + bytesToUpload;
    var uploadCommand = bytesToUpload === bytesLeft ? 'upload, finalize' : 'upload';
    var headers = {
        'X-Goog-Upload-Command': uploadCommand,
        'X-Goog-Upload-Offset': status.current
    };
    var body = blob.slice(startByte, endByte);
    if (body === null) {
        throw errorsExports.cannotSliceBlob();
    }
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        var uploadStatus = checkResumeHeader_(xhr, ['active', 'final']);
        var newCurrent = status.current + bytesToUpload;
        var size = blob.size();
        var metadata;
        if (uploadStatus === 'final') {
            metadata = metadataHandler(authWrapper, mappings)(xhr, text);
        } else {
            metadata = null;
        }
        return new ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
    }
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new _requestinfo.RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = opt_progressCallback || null;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
//# sourceMappingURL=requests.js.map


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.taskStateFromInternalTaskState = taskStateFromInternalTaskState;
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TaskEvent = exports.TaskEvent = {
    /** Triggered whenever the task changes or progress is updated. */
    STATE_CHANGED: 'state_changed'
};
var InternalTaskState = exports.InternalTaskState = {
    RUNNING: 'running',
    PAUSING: 'pausing',
    PAUSED: 'paused',
    SUCCESS: 'success',
    CANCELING: 'canceling',
    CANCELED: 'canceled',
    ERROR: 'error'
};
var TaskState = exports.TaskState = {
    /** The task is currently transferring data. */
    RUNNING: 'running',
    /** The task was paused by the user. */
    PAUSED: 'paused',
    /** The task completed successfully. */
    SUCCESS: 'success',
    /** The task was canceled. */
    CANCELED: 'canceled',
    /** The task failed with an error. */
    ERROR: 'error'
};
function taskStateFromInternalTaskState(state) {
    switch (state) {
        case InternalTaskState.RUNNING:
        case InternalTaskState.PAUSING:
        case InternalTaskState.CANCELING:
            return TaskState.RUNNING;
        case InternalTaskState.PAUSED:
            return TaskState.PAUSED;
        case InternalTaskState.SUCCESS:
            return TaskState.SUCCESS;
        case InternalTaskState.CANCELED:
            return TaskState.CANCELED;
        case InternalTaskState.ERROR:
            return TaskState.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return TaskState.ERROR;
    }
}
//# sourceMappingURL=taskenums.js.map


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @enum{number}
 */
var ErrorCode = exports.ErrorCode = undefined;
(function (ErrorCode) {
  ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
  ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
  ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})(ErrorCode || (exports.ErrorCode = ErrorCode = {}));
//# sourceMappingURL=xhrio.js.map


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Reference = undefined;

var _args = __webpack_require__(110);

var args = _interopRequireWildcard(_args);

var _blob = __webpack_require__(187);

var _error = __webpack_require__(26);

var errorsExports = _interopRequireWildcard(_error);

var _location = __webpack_require__(85);

var _metadata = __webpack_require__(112);

var metadata = _interopRequireWildcard(_metadata);

var _object = __webpack_require__(49);

var object = _interopRequireWildcard(_object);

var _path = __webpack_require__(188);

var path = _interopRequireWildcard(_path);

var _requests = __webpack_require__(189);

var requests = _interopRequireWildcard(_requests);

var _string = __webpack_require__(113);

var fbsString = _interopRequireWildcard(_string);

var _type = __webpack_require__(20);

var type = _interopRequireWildcard(_type);

var _task = __webpack_require__(433);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @param location An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Defines the Firebase Storage Reference class.
 */
var Reference = /** @class */function () {
    function Reference(authWrapper, location) {
        this.authWrapper = authWrapper;
        if (location instanceof _location.Location) {
            this.location = location;
        } else {
            this.location = _location.Location.makeFromUrl(location);
        }
    }
    /**
     * @return The URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */
    Reference.prototype.toString = function () {
        args.validate('toString', [], arguments);
        return 'gs://' + this.location.bucket + '/' + this.location.path;
    };
    Reference.prototype.newRef = function (authWrapper, location) {
        return new Reference(authWrapper, location);
    };
    Reference.prototype.mappings = function () {
        return metadata.getMappings();
    };
    /**
     * @return A reference to the object obtained by
     *     appending childPath, removing any duplicate, beginning, or trailing
     *     slashes.
     */
    Reference.prototype.child = function (childPath) {
        args.validate('child', [args.stringSpec()], arguments);
        var newPath = path.child(this.location.path, childPath);
        var location = new _location.Location(this.location.bucket, newPath);
        return this.newRef(this.authWrapper, location);
    };
    Object.defineProperty(Reference.prototype, "parent", {
        /**
         * @return A reference to the parent of the
         *     current object, or null if the current object is the root.
         */
        get: function get() {
            var newPath = path.parent(this.location.path);
            if (newPath === null) {
                return null;
            }
            var location = new _location.Location(this.location.bucket, newPath);
            return this.newRef(this.authWrapper, location);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        /**
         * @return An reference to the root of this
         *     object's bucket.
         */
        get: function get() {
            var location = new _location.Location(this.location.bucket, '');
            return this.newRef(this.authWrapper, location);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "bucket", {
        get: function get() {
            return this.location.bucket;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "fullPath", {
        get: function get() {
            return this.location.path;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "name", {
        get: function get() {
            return path.lastComponent(this.location.path);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "storage", {
        get: function get() {
            return this.authWrapper.service();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Uploads a blob to this object's location.
     * @param data The blob to upload.
     * @return An UploadTask that lets you control and
     *     observe the upload.
     */
    Reference.prototype.put = function (data, metadata) {
        if (metadata === void 0) {
            metadata = null;
        }
        args.validate('put', [args.uploadDataSpec(), args.metadataSpec(true)], arguments);
        this.throwIfRoot_('put');
        return new _task.UploadTask(this, this.authWrapper, this.location, this.mappings(), new _blob.FbsBlob(data), metadata);
    };
    /**
     * Uploads a string to this object's location.
     * @param string The string to upload.
     * @param opt_format The format of the string to upload.
     * @return An UploadTask that lets you control and
     *     observe the upload.
     */
    Reference.prototype.putString = function (string, format, opt_metadata) {
        if (format === void 0) {
            format = _string.StringFormat.RAW;
        }
        args.validate('putString', [args.stringSpec(), args.stringSpec(fbsString.formatValidator, true), args.metadataSpec(true)], arguments);
        this.throwIfRoot_('putString');
        var data = fbsString.dataFromString(format, string);
        var metadata = object.clone(opt_metadata);
        if (!type.isDef(metadata['contentType']) && type.isDef(data.contentType)) {
            metadata['contentType'] = data.contentType;
        }
        return new _task.UploadTask(this, this.authWrapper, this.location, this.mappings(), new _blob.FbsBlob(data.data, true), metadata);
    };
    /**
     * Deletes the object at this location.
     * @return A promise that resolves if the deletion succeeds.
     */
    Reference.prototype.delete = function () {
        args.validate('delete', [], arguments);
        this.throwIfRoot_('delete');
        var self = this;
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = requests.deleteObject(self.authWrapper, self.location);
            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     *     A promise that resolves with the metadata for this object. If this
     *     object doesn't exist or metadata cannot be retreived, the promise is
     *     rejected.
     */
    Reference.prototype.getMetadata = function () {
        args.validate('getMetadata', [], arguments);
        this.throwIfRoot_('getMetadata');
        var self = this;
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = requests.getMetadata(self.authWrapper, self.location, self.mappings());
            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     * Updates the metadata for this object.
     * @param metadata The new metadata for the object.
     *     Only values that have been explicitly set will be changed. Explicitly
     *     setting a value to null will remove the metadata.
     * @return A promise that resolves
     *     with the new metadata for this object.
     *     @see firebaseStorage.Reference.prototype.getMetadata
     */
    Reference.prototype.updateMetadata = function (metadata) {
        args.validate('updateMetadata', [args.metadataSpec()], arguments);
        this.throwIfRoot_('updateMetadata');
        var self = this;
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = requests.updateMetadata(self.authWrapper, self.location, metadata, self.mappings());
            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     * @return A promise that resolves with the download
     *     URL for this object.
     */
    Reference.prototype.getDownloadURL = function () {
        args.validate('getDownloadURL', [], arguments);
        this.throwIfRoot_('getDownloadURL');
        return this.getMetadata().then(function (metadata) {
            var url = metadata['downloadURLs'][0];
            if (type.isDef(url)) {
                return url;
            } else {
                throw errorsExports.noDownloadURL();
            }
        });
    };
    Reference.prototype.throwIfRoot_ = function (name) {
        if (this.location.path === '') {
            throw errorsExports.invalidRootOperation(name);
        }
    };
    return Reference;
}();
exports.Reference = Reference;
//# sourceMappingURL=reference.js.map


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deepCopy = deepCopy;
exports.deepExtend = deepExtend;
exports.patchProperty = patchProperty;
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (var prop in source) {
        if (!source.hasOwnProperty(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
// TODO: Really needed (for JSCompiler type checking)?
function patchProperty(obj, prop, value) {
    obj[prop] = value;
}
//# sourceMappingURL=deep_copy.js.map


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var scope;
if (typeof global !== 'undefined') {
    scope = global;
} else if (typeof self !== 'undefined') {
    scope = self;
} else {
    try {
        scope = Function('return this')();
    } catch (e) {
        throw new Error('polyfill failed because global object is unavailable in this environment');
    }
}
var globalScope = exports.globalScope = scope;
//# sourceMappingURL=globalScope.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(449);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(287);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('not a function');
  }
  this._45 = 0;
  this._81 = 0;
  this._65 = null;
  this._54 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._10 = null;
Promise._97 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
};
function handle(self, deferred) {
  while (self._81 === 3) {
    self = self._65;
  }
  if (Promise._10) {
    Promise._10(self);
  }
  if (self._81 === 0) {
    if (self._45 === 0) {
      self._45 = 1;
      self._54 = deferred;
      return;
    }
    if (self._45 === 1) {
      self._45 = 2;
      self._54 = [self._54, deferred];
      return;
    }
    self._54.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._81 === 1) {
        resolve(deferred.promise, self._65);
      } else {
        reject(deferred.promise, self._65);
      }
      return;
    }
    var ret = tryCallOne(cb, self._65);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._81 = 3;
      self._65 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._81 = 1;
  self._65 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._81 = 2;
  self._65 = newValue;
  if (Promise._97) {
    Promise._97(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._45 === 1) {
    handle(self, self._54);
    self._54 = null;
  }
  if (self._45 === 2) {
    for (var i = 0; i < self._54.length; i++) {
      handle(self, self._54[i]);
    }
    self._54 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  })
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(455);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(454)();
}


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(41);

var invariant = __webpack_require__(1);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(52);
var ReactDOMComponentTree = __webpack_require__(10);
var ReactInstrumentation = __webpack_require__(22);

var quoteAttributeValueForBrowser = __webpack_require__(518);
var warning = __webpack_require__(4);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var LinkedValueUtils = __webpack_require__(122);
var ReactDOMComponentTree = __webpack_require__(10);
var ReactUpdates = __webpack_require__(24);

var warning = __webpack_require__(4);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(1);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(478);

var containsNode = __webpack_require__(358);
var focusNode = __webpack_require__(154);
var getActiveElement = __webpack_require__(155);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var DOMLazyTree = __webpack_require__(51);
var DOMProperty = __webpack_require__(52);
var React = __webpack_require__(54);
var ReactBrowserEventEmitter = __webpack_require__(88);
var ReactCurrentOwner = __webpack_require__(29);
var ReactDOMComponentTree = __webpack_require__(10);
var ReactDOMContainerInfo = __webpack_require__(472);
var ReactDOMFeatureFlags = __webpack_require__(474);
var ReactFeatureFlags = __webpack_require__(206);
var ReactInstanceMap = __webpack_require__(65);
var ReactInstrumentation = __webpack_require__(22);
var ReactMarkupChecksum = __webpack_require__(488);
var ReactReconciler = __webpack_require__(53);
var ReactUpdateQueue = __webpack_require__(125);
var ReactUpdates = __webpack_require__(24);

var emptyObject = __webpack_require__(75);
var instantiateReactComponent = __webpack_require__(217);
var invariant = __webpack_require__(1);
var setInnerHTML = __webpack_require__(92);
var shouldUpdateReactComponent = __webpack_require__(131);
var warning = __webpack_require__(4);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var React = __webpack_require__(54);

var invariant = __webpack_require__(1);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(1);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactNodeTypes = __webpack_require__(210);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(14);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(10);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  delete inst._wrapperState.valueTracker;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(8);

var ReactCompositeComponent = __webpack_require__(469);
var ReactEmptyComponent = __webpack_require__(205);
var ReactHostComponent = __webpack_require__(207);

var getNextDebugID = __webpack_require__(537);
var invariant = __webpack_require__(1);
var warning = __webpack_require__(4);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(14);
var escapeTextContentForBrowser = __webpack_require__(91);
var setInnerHTML = __webpack_require__(92);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactCurrentOwner = __webpack_require__(29);
var REACT_ELEMENT_TYPE = __webpack_require__(484);

var getIteratorFn = __webpack_require__(515);
var invariant = __webpack_require__(1);
var KeyEscapeUtils = __webpack_require__(121);
var warning = __webpack_require__(4);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(223);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          if (this.subscription) this.subscription.tryUnsubscribe();
          this.initSubscription();
          if (shouldHandleStateChanges) this.subscription.trySubscribe();
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(224);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(133);



function verifyPlainObject(value, displayName, methodName) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(67),
    _assign = __webpack_require__(8);

var ReactNoopUpdateQueue = __webpack_require__(228);

var canDefineProperty = __webpack_require__(229);
var emptyObject = __webpack_require__(75);
var invariant = __webpack_require__(1);
var lowPriorityWarning = __webpack_require__(538);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(67);

var ReactCurrentOwner = __webpack_require__(29);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(4);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(4);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var randomByte = __webpack_require__(552);

function encode(lookup, number) {
    var loopCounter = 0;
    var done;

    var str = '';

    while (!done) {
        str = str + lookup( ( (number >> (4 * loopCounter)) & 0x0f ) | randomByte() );
        done = number < (Math.pow(16, loopCounter + 1 ) );
        loopCounter++;
    }
    return str;
}

module.exports = encode;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(546);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/quicksandmedium.e1510089.png";

/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aframe__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aframe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_animation_component__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_animation_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aframe_animation_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__database__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(98);














var arrayGP = navigator.getGamepads();
console.log(arrayGP);

__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7_react_redux__["a" /* Provider */],
    { store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */] },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */], null)
), document.getElementById('root'));

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(452).enable();
  window.Promise = __webpack_require__(451);
}

// fetch() polyfill for making API calls.
__webpack_require__(1463);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(8);


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  controls:   __webpack_require__(251),
  loaders:    __webpack_require__(259),
  misc:       __webpack_require__(267),
  physics:    __webpack_require__(95),
  primitives: __webpack_require__(276),

  registerAll: function () {
    this.controls.registerAll();
    this.loaders.registerAll();
    this.misc.registerAll();
    this.physics.registerAll();
    this.primitives.registerAll();
  }
};


/***/ }),
/* 240 */
/***/ (function(module, exports) {

/**
 * @author yamahigashi https://github.com/yamahigashi
 * @author Kyle-Larson https://github.com/Kyle-Larson
 *
 * This loader loads FBX file in *ASCII and version 7 format*.
 *
 * Support
 *  - mesh
 *  - skinning
 *  - normal / uv
 *  - material (Multi-Material too)
 *  - textures (Must be in same directory)
 *
 *  No Support
 *  - morph
 */

( function () {

  module.exports = THREE.FBXLoader = function ( manager ) {

    THREE.Loader.call( this );
    this.manager = ( manager !== undefined ) ? manager : THREE.DefaultLoadingManager;
    this.textureLoader = null;
    this.textureBasePath = null;

  };

  THREE.FBXLoader.prototype = Object.create( THREE.Loader.prototype );

  THREE.FBXLoader.prototype.constructor = THREE.FBXLoader;

  Object.assign( THREE.FBXLoader.prototype, {

    load: function ( url, onLoad, onProgress, onError ) {

      var scope = this;

      var loader = new THREE.XHRLoader( scope.manager );
      // loader.setCrossOrigin( this.crossOrigin );
      loader.load( url, function ( text ) {

        if ( ! scope.isFbxFormatASCII( text ) ) {

          console.warn( 'FBXLoader: !!! FBX Binary format not supported !!!' );

        } else if ( ! scope.isFbxVersionSupported( text ) ) {

          console.warn( 'FBXLoader: !!! FBX Version below 7 not supported !!!' );

        } else {

          scope.textureBasePath = scope.extractUrlBase( url );
          onLoad( scope.parse( text ) );

        }

      }, onProgress, onError );

    },

    setCrossOrigin: function ( value ) {

      this.crossOrigin = value;

    },

    isFbxFormatASCII: function ( body ) {

      var CORRECT = [ 'K', 'a', 'y', 'd', 'a', 'r', 'a', '\\', 'F', 'B', 'X', '\\', 'B', 'i', 'n', 'a', 'r', 'y', '\\', '\\' ];

      var cursor = 0;
      var read = function ( offset ) {

        var result = body[ offset - 1 ];
        body = body.slice( cursor + offset );
        cursor ++;
        return result;

      };

      for ( var i = 0; i < CORRECT.length; ++ i ) {

        var num = read( 1 );
        if ( num == CORRECT[ i ] ) {

          return false;

        }

      }

      return true;

    },

    isFbxVersionSupported: function ( body ) {

      var versionExp = /FBXVersion: (\d+)/;
      var match = body.match( versionExp );
      if ( match ) {

        var version = parseInt( match[ 1 ] );
        console.log( 'FBXLoader: FBX version ' + version );
        return version >= 7000;

      }
      return false;

    },

    parse: function ( text ) {

      var scope = this;

      console.time( 'FBXLoader' );

      console.time( 'FBXLoader: TextParser' );
      var nodes = new FBXParser().parse( text );
      console.timeEnd( 'FBXLoader: TextParser' );

      console.time( 'FBXLoader: ObjectParser' );
      scope.hierarchy = ( new Bones() ).parseHierarchy( nodes );
      scope.weights = ( new Weights() ).parse( nodes, scope.hierarchy );
      scope.animations = ( new Animation() ).parse( nodes, scope.hierarchy );
      scope.textures = ( new Textures() ).parse( nodes, scope.hierarchy );
      scope.materials = ( new Materials() ).parse( nodes, scope.hierarchy );
      scope.geometries = ( new Geometries() ).parse( nodes, scope.hierarchy );
      console.timeEnd( 'FBXLoader: ObjectParser' );

      this.texture_cache = {};
      this.material_cache = {};
      this.geometry_cache = {};

      console.time( 'FBXLoader: MeshParser' );
      var meshes = this.parseMeshes( nodes );
      console.timeEnd( 'FBXLoader: MeshParser' );

      var container = new THREE.Group();

      for ( var i = 0; i < meshes.length; ++ i ) {

        if ( meshes[ i ] === undefined ) {

          continue;

        }

        container.add( meshes[ i ] );

        //wireframe = new THREE.WireframeHelper( geometries[i], 0x00ff00 );
        //container.add( wireframe );

        //vnh = new THREE.VertexNormalsHelper( geometries[i], 0.6 );
        //container.add( vnh );

        //skh = new THREE.SkeletonHelper( geometries[i] );
        //container.add( skh );

        // container.add( new THREE.BoxHelper( geometries[i] ) );

      }

      console.timeEnd( 'FBXLoader' );
      return container;

    },

    getTexture: function ( texNode ) {

      if ( ! ( texNode.id in this.texture_cache ) ) {

        if ( this.textureLoader === null ) {

          this.textureLoader = new THREE.TextureLoader();

        }

        this.texture_cache[ texNode.id ] = this.textureLoader.load( this.textureBasePath + '/' + texNode.fileName );

      }

      return this.texture_cache[ texNode.id ];

    },

    getMaterial: function ( matNode, nodes ) {

      if ( ! ( matNode.id in this.material_cache ) ) {

        // TODO:
        // Cannot find a list of possible ShadingModel values.
        // If someone finds a list, please add additional cases
        // and map to appropriate materials.
        var tmpMat;
        switch ( matNode.type ) {

          case "phong":
            tmpMat = new THREE.MeshPhongMaterial();
            break;
          case "lambert":
            tmpMat = new THREE.MeshLambertMaterial();
            break;
          default:
            console.warn( "No implementation given for material type " + matNode.type + " in FBXLoader.js.  Defaulting to basic material" );
            tmpMat = new THREE.MeshBasicMaterial( { color: 0x3300ff } );
            break;

        }

        var children = nodes.searchConnectionChildren( matNode.id );
        for ( var i = 0; i < children.length; ++ i ) {

          var type = nodes.searchConnectionType( children[ i ], matNode.id );
          switch ( type ) {

            case " \"AmbientColor":
              //TODO: Support AmbientColor textures
              break;

            case " \"DiffuseColor":
              matNode.parameters.map = this.getTexture( this.textures.textures[ children[ i ] ] );
              break;

            default:
              console.warn( 'Unknown texture application of type ' + type + ', skipping texture' );
              break;

          }

        }

        tmpMat.setValues( matNode.parameters );

        this.material_cache[ matNode.id ] = tmpMat;

      }

      return this.material_cache[ matNode.id ];

    },

    getGeometry: function ( geoNode ) {

      if ( ! ( geoNode.id in this.geometry_cache ) ) {

        var tmpGeo = new THREE.BufferGeometry();
        tmpGeo.name = geoNode.name;
        tmpGeo.addAttribute( 'position', new THREE.BufferAttribute( new Float32Array( geoNode.vertices ), 3 ) );

        if ( geoNode.normals !== undefined && geoNode.normals.length > 0 ) {

          tmpGeo.addAttribute( 'normal', new THREE.BufferAttribute( new Float32Array( geoNode.normals ), 3 ) );

        }

        if ( geoNode.uvs !== undefined && geoNode.uvs.length > 0 ) {

          tmpGeo.addAttribute( 'uv', new THREE.BufferAttribute( new Float32Array( geoNode.uvs ), 2 ) );

        }

        if ( geoNode.indices !== undefined && geoNode.indices.length > 0 ) {

          if ( geoNode.indices.length > 65535 ) {

            tmpGeo.setIndex( new THREE.BufferAttribute( new Uint32Array( geoNode.indices ), 1 ) );

          } else {

            tmpGeo.setIndex( new THREE.BufferAttribute( new Uint16Array( geoNode.indices ), 1 ) );

          }

        }

        tmpGeo.verticesNeedUpdate = true;
        tmpGeo.computeBoundingSphere();
        tmpGeo.computeBoundingBox();

        //Material groupings
        if ( geoNode.materialIndices.length > 1 ) {

          tmpGeo.groups = [];

          for ( var i = 0, prevIndex = - 1; i < geoNode.materialIndices.length; ++ i ) {

            if ( geoNode.materialIndices[ i ] !== prevIndex ) {

              tmpGeo.groups.push( { start: i * 3, count: 0, materialIndex: geoNode.materialIndices[ i ] } );
              prevIndex = geoNode.materialIndices[ i ];

            }

            tmpGeo.groups[ tmpGeo.groups.length - 1 ].count += 3;

          }

        }

        this.geometry_cache[ geoNode.id ] = new THREE.Geometry().fromBufferGeometry( tmpGeo );
        this.geometry_cache[ geoNode.id ].bones = geoNode.bones;
        this.geometry_cache[ geoNode.id ].skinIndices = this.weights.skinIndices;
        this.geometry_cache[ geoNode.id ].skinWeights = this.weights.skinWeights;

      }

      return this.geometry_cache[ geoNode.id ];

    },

    parseMeshes: function ( node ) {

      var modelNode = node.Objects.subNodes.Model;
      var meshes = [];

      for ( var ID in modelNode ) {

        if ( modelNode[ ID ].attrType === 'Mesh' ) {

          //Parse Mesh
          meshes.push( this.parseMesh( modelNode[ ID ], node ) );

        }

      }

      return meshes;

    },

    parseMesh: function ( meshNode, FBXNodes ) {

      var geoNodes = FBXNodes.Objects.subNodes.Geometry;
      var matNodes = FBXNodes.Objects.subNodes.Material;

      var children = FBXNodes.searchConnectionChildren( meshNode.id );
      var geometry;
      var materials = [];
      var material;
      var mesh;
      for ( var i = 0; i < children.length; ++ i ) {

        if ( children[ i ] in geoNodes ) {

          geometry = this.getGeometry( this.geometries.geometries[ children[ i ] ] );
          continue;

        }

        if ( children[ i ] in matNodes ) {

          materials.push( this.getMaterial( this.materials.materials[ children[ i ] ], FBXNodes ) );
          continue;

        }

      }

      if ( materials.length > 1 ) {

        material = new THREE.MultiMaterial( materials );
        //material = materials[ 0 ];

      } else {

        material = materials[ 0 ];

      }

      if ( geometry.bones !== undefined && geometry.skinWeights !== undefined ) {

        if ( material instanceof THREE.MultiMaterial ) {

          for ( var i = 0; i < material.materials.length; ++ i ) {

            material.materials[ i ].skinning = true;

          }

        } else {

          material.skinning = true;

        }

        mesh = new THREE.SkinnedMesh( geometry, material );

      } else {

        mesh = new THREE.Mesh( geometry, material );

      }

      if ( this.animations !== undefined ) {

        this.addAnimation( mesh, this.weights.matrices, this.animations );

      }

      return mesh;

    },

    addAnimation: function ( mesh, matrices, animations ) {

      for ( var key in animations.stacks ) {

        var animationData = {
          name: animations.stacks[ key ].name,
          fps: 30,
          length: animations.stacks[ key ].length,
          hierarchy: []
        };

        for ( var i = 0; i < mesh.geometry.bones.length; ++ i ) {

          var name = mesh.geometry.bones[ i ].name;
          name = name.replace( /.*:/, '' );
          animationData.hierarchy.push( { parent: mesh.geometry.bones[ i ].parent, name: name, keys: [] } );

        }

        function hasCurve( animNode, attr ) {

          if ( animNode === undefined ) {

            return false;

          }

          var attrNode;
          switch ( attr ) {

            case 'S':
              if ( ! ( animNode.S ) ) {

                return false;

              }
              attrNode = animNode.S;
              break;

            case 'R':
              if ( ! ( animNode.R ) ) {

                return false;

              }
              attrNode = animNode.R;
              break;

            case 'T':
              if ( ! ( animNode.T ) ) {

                return false;

              }
              attrNode = animNode.T;
              break;

          }

          if ( attrNode.curves.x === undefined ) {

            return false;

          }

          if ( attrNode.curves.y === undefined ) {

            return false;

          }

          if ( attrNode.curves.z === undefined ) {

            return false;

          }

          return true;

        }

        function hasKeyOnFrame( attrNode, frame ) {

          var x = isKeyExistOnFrame( attrNode.curves.x, frame );
          var y = isKeyExistOnFrame( attrNode.curves.y, frame );
          var z = isKeyExistOnFrame( attrNode.curves.z, frame );

          return x && y && z;

        }

        function isKeyExistOnFrame( curve, frame ) {

          var value = curve.values[ frame ];
          return value !== undefined;

        }

        function genKey( animNode, bone ) {

          // key initialize with its bone's bind pose at first
          var key = {};
          key.time = frame / animations.fps; // TODO:
          key.pos = bone.pos;
          key.rot = bone.rotq;
          key.scl = bone.scl;

          if ( animNode === undefined ) {

            return key;

          }

          try {

            if ( hasCurve( animNode, 'T' ) && hasKeyOnFrame( animNode.T, frame ) ) {

              var pos = new THREE.Vector3(
                animNode.T.curves.x.values[ frame ],
                animNode.T.curves.y.values[ frame ],
                animNode.T.curves.z.values[ frame ] );
              key.pos = [ pos.x, pos.y, pos.z ];

            }

            if ( hasCurve( animNode, 'R' ) && hasKeyOnFrame( animNode.R, frame ) ) {

              var rx = degToRad( animNode.R.curves.x.values[ frame ] );
              var ry = degToRad( animNode.R.curves.y.values[ frame ] );
              var rz = degToRad( animNode.R.curves.z.values[ frame ] );
              var eul = new THREE.Vector3( rx, ry, rz );
              var rot = quatFromVec( eul.x, eul.y, eul.z );
              key.rot = [ rot.x, rot.y, rot.z, rot.w ];

            }

            if ( hasCurve( animNode, 'S' ) && hasKeyOnFrame( animNode.S, frame ) ) {

              var scl = new THREE.Vector3(
                animNode.S.curves.x.values[ frame ],
                animNode.S.curves.y.values[ frame ],
                animNode.S.curves.z.values[ frame ] );
              key.scl = [ scl.x, scl.y, scl.z ];

            }

          } catch ( e ) {

            // curve is not full plotted
            console.log( bone );
            console.log( e );

          }

          return key;

        }

        var bones = mesh.geometry.bones;
        for ( var frame = 0; frame < animations.stacks[ key ].frames; frame ++ ) {


          for ( i = 0; i < bones.length; i ++ ) {

            var bone = bones[ i ];
            var animNode = animations.stacks[ key ].layers[ 0 ][ i ];

            for ( var j = 0; j < animationData.hierarchy.length; j ++ ) {

              if ( animationData.hierarchy[ j ].name === bone.name ) {

                animationData.hierarchy[ j ].keys.push( genKey( animNode, bone ) );

              }

            }

          }

        }

        if ( mesh.geometry.animations === undefined ) {

          mesh.geometry.animations = [];

        }

        mesh.geometry.animations.push( THREE.AnimationClip.parseAnimation( animationData, mesh.geometry.bones ) );

      }

    },

    loadFile: function ( url, onLoad, onProgress, onError, responseType ) {

      var loader = new THREE.XHRLoader( this.manager );

      loader.setResponseType( responseType );

      var request = loader.load( url, onLoad, onProgress, onError );

      return request;

    },

    loadFileAsBuffer: function ( url, onLoad, onProgress, onError ) {

      this.loadFile( url, onLoad, onProgress, onError, 'arraybuffer' );

    },

    loadFileAsText: function ( url, onLoad, onProgress, onError ) {

      this.loadFile( url, onLoad, onProgress, onError, 'text' );

    }

  } );

  /* ----------------------------------------------------------------- */

  function FBXNodes() {}

  Object.assign( FBXNodes.prototype, {

    add: function ( key, val ) {

      this[ key ] = val;

    },

    searchConnectionParent: function ( id ) {

      if ( this.__cache_search_connection_parent === undefined ) {

        this.__cache_search_connection_parent = [];

      }

      if ( this.__cache_search_connection_parent[ id ] !== undefined ) {

        return this.__cache_search_connection_parent[ id ];

      } else {

        this.__cache_search_connection_parent[ id ] = [];

      }

      var conns = this.Connections.properties.connections;

      var results = [];
      for ( var i = 0; i < conns.length; ++ i ) {

        if ( conns[ i ][ 0 ] == id ) {

          // 0 means scene root
          var res = conns[ i ][ 1 ] === 0 ? - 1 : conns[ i ][ 1 ];
          results.push( res );

        }

      }

      if ( results.length > 0 ) {

        this.__cache_search_connection_parent[ id ] = this.__cache_search_connection_parent[ id ].concat( results );
        return results;

      } else {

        this.__cache_search_connection_parent[ id ] = [ - 1 ];
        return [ - 1 ];

      }

    },

    searchConnectionChildren: function ( id ) {

      if ( this.__cache_search_connection_children === undefined ) {

        this.__cache_search_connection_children = [];

      }

      if ( this.__cache_search_connection_children[ id ] !== undefined ) {

        return this.__cache_search_connection_children[ id ];

      } else {

        this.__cache_search_connection_children[ id ] = [];

      }

      var conns = this.Connections.properties.connections;

      var res = [];
      for ( var i = 0; i < conns.length; ++ i ) {

        if ( conns[ i ][ 1 ] == id ) {

          // 0 means scene root
          res.push( conns[ i ][ 0 ] === 0 ? - 1 : conns[ i ][ 0 ] );
          // there may more than one kid, then search to the end

        }

      }

      if ( res.length > 0 ) {

        this.__cache_search_connection_children[ id ] = this.__cache_search_connection_children[ id ].concat( res );
        return res;

      } else {

        this.__cache_search_connection_children[ id ] = [ ];
        return [ ];

      }

    },

    searchConnectionType: function ( id, to ) {

      var key = id + ',' + to; // TODO: to hash
      if ( this.__cache_search_connection_type === undefined ) {

        this.__cache_search_connection_type = {};

      }

      if ( this.__cache_search_connection_type[ key ] !== undefined ) {

        return this.__cache_search_connection_type[ key ];

      } else {

        this.__cache_search_connection_type[ key ] = '';

      }

      var conns = this.Connections.properties.connections;

      for ( var i = 0; i < conns.length; ++ i ) {

        if ( conns[ i ][ 0 ] == id && conns[ i ][ 1 ] == to ) {

          // 0 means scene root
          this.__cache_search_connection_type[ key ] = conns[ i ][ 2 ];
          return conns[ i ][ 2 ];

        }

      }

      this.__cache_search_connection_type[ id ] = null;
      return null;

    }

  } );

  function FBXParser() {}

  Object.assign( FBXParser.prototype, {

    getPrevNode: function () {

      return this.nodeStack[ this.currentIndent - 2 ];

    },

    getCurrentNode: function () {

      return this.nodeStack[ this.currentIndent - 1 ];

    },

    getCurrentProp: function () {

      return this.currentProp;

    },

    pushStack: function ( node ) {

      this.nodeStack.push( node );
      this.currentIndent += 1;

    },

    popStack: function () {

      this.nodeStack.pop();
      this.currentIndent -= 1;

    },

    setCurrentProp: function ( val, name ) {

      this.currentProp = val;
      this.currentPropName = name;

    },

    // ----------parse ---------------------------------------------------
    parse: function ( text ) {

      this.currentIndent = 0;
      this.allNodes = new FBXNodes();
      this.nodeStack = [];
      this.currentProp = [];
      this.currentPropName = '';

      var split = text.split( "\n" );
      for ( var line in split ) {

        var l = split[ line ];

        // short cut
        if ( l.match( /^[\s\t]*;/ ) ) {

          continue;

        } // skip comment line
        if ( l.match( /^[\s\t]*$/ ) ) {

          continue;

        } // skip empty line

        // beginning of node
        var beginningOfNodeExp = new RegExp( "^\\t{" + this.currentIndent + "}(\\w+):(.*){", '' );
        var match = l.match( beginningOfNodeExp );
        if ( match ) {

          var nodeName = match[ 1 ].trim().replace( /^"/, '' ).replace( /"$/, "" );
          var nodeAttrs = match[ 2 ].split( ',' ).map( function ( element ) {

            return element.trim().replace( /^"/, '' ).replace( /"$/, '' );

          } );

          this.parseNodeBegin( l, nodeName, nodeAttrs || null );
          continue;

        }

        // node's property
        var propExp = new RegExp( "^\\t{" + ( this.currentIndent ) + "}(\\w+):[\\s\\t\\r\\n](.*)" );
        var match = l.match( propExp );
        if ( match ) {

          var propName = match[ 1 ].replace( /^"/, '' ).replace( /"$/, "" ).trim();
          var propValue = match[ 2 ].replace( /^"/, '' ).replace( /"$/, "" ).trim();

          this.parseNodeProperty( l, propName, propValue );
          continue;

        }

        // end of node
        var endOfNodeExp = new RegExp( "^\\t{" + ( this.currentIndent - 1 ) + "}}" );
        if ( l.match( endOfNodeExp ) ) {

          this.nodeEnd();
          continue;

        }

        // for special case,
        //
        //    Vertices: *8670 {
        //      a: 0.0356229953467846,13.9599733352661,-0.399196773.....(snip)
        // -0.0612030513584614,13.960485458374,-0.409748703241348,-0.10.....
        // 0.12490539252758,13.7450733184814,-0.454119384288788,0.09272.....
        // 0.0836158767342567,13.5432004928589,-0.435397416353226,0.028.....
        //
        // these case the lines must contiue with previous line
        if ( l.match( /^[^\s\t}]/ ) ) {

          this.parseNodePropertyContinued( l );

        }

      }

      return this.allNodes;

    },

    parseNodeBegin: function ( line, nodeName, nodeAttrs ) {

      // var nodeName = match[1];
      var node = { 'name': nodeName, properties: {}, 'subNodes': {} };
      var attrs = this.parseNodeAttr( nodeAttrs );
      var currentNode = this.getCurrentNode();

      // a top node
      if ( this.currentIndent === 0 ) {

        this.allNodes.add( nodeName, node );

      } else {

        // a subnode

        // already exists subnode, then append it
        if ( nodeName in currentNode.subNodes ) {

          var tmp = currentNode.subNodes[ nodeName ];

          // console.log( "duped entry found\nkey: " + nodeName + "\nvalue: " + propValue );
          if ( this.isFlattenNode( currentNode.subNodes[ nodeName ] ) ) {


            if ( attrs.id === '' ) {

              currentNode.subNodes[ nodeName ] = [];
              currentNode.subNodes[ nodeName ].push( tmp );

            } else {

              currentNode.subNodes[ nodeName ] = {};
              currentNode.subNodes[ nodeName ][ tmp.id ] = tmp;

            }

          }

          if ( attrs.id === '' ) {

            currentNode.subNodes[ nodeName ].push( node );

          } else {

            currentNode.subNodes[ nodeName ][ attrs.id ] = node;

          }

        } else if ( typeof attrs.id === 'number' || attrs.id.match( /^\d+$/ ) ) {

          currentNode.subNodes[ nodeName ] = {};
          currentNode.subNodes[ nodeName ][ attrs.id ] = node;

        } else {

          currentNode.subNodes[ nodeName ] = node;

        }

      }

      // for this     ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      // NodeAttribute: 1001463072, "NodeAttribute::", "LimbNode" {
      if ( nodeAttrs ) {

        node.id = attrs.id;
        node.attrName = attrs.name;
        node.attrType = attrs.type;

      }

      this.pushStack( node );

    },

    parseNodeAttr: function ( attrs ) {

      var id = attrs[ 0 ];

      if ( attrs[ 0 ] !== "" ) {

        id = parseInt( attrs[ 0 ] );

        if ( isNaN( id ) ) {

          // PolygonVertexIndex: *16380 {
          id = attrs[ 0 ];

        }

      }

      var name;
      var type;
      if ( attrs.length > 1 ) {

        name = attrs[ 1 ].replace( /^(\w+)::/, '' );
        type = attrs[ 2 ];

      }

      return { id: id, name: name || '', type: type || '' };

    },

    parseNodeProperty: function ( line, propName, propValue ) {

      var currentNode = this.getCurrentNode();
      var parentName = currentNode.name;

      // special case parent node's is like "Properties70"
      // these chilren nodes must treat with careful
      if ( parentName !== undefined ) {

        var propMatch = parentName.match( /Properties(\d)+/ );
        if ( propMatch ) {

          this.parseNodeSpecialProperty( line, propName, propValue );
          return;

        }

      }

      // special case Connections
      if ( propName == 'C' ) {

        var connProps = propValue.split( ',' ).slice( 1 );
        var from = parseInt( connProps[ 0 ] );
        var to = parseInt( connProps[ 1 ] );

        var rest = propValue.split( ',' ).slice( 3 );

        propName = 'connections';
        propValue = [ from, to ];
        propValue = propValue.concat( rest );

        if ( currentNode.properties[ propName ] === undefined ) {

          currentNode.properties[ propName ] = [];

        }

      }

      // special case Connections
      if ( propName == 'Node' ) {

        var id = parseInt( propValue );
        currentNode.properties.id = id;
        currentNode.id = id;

      }

      // already exists in properties, then append this
      if ( propName in currentNode.properties ) {

        // console.log( "duped entry found\nkey: " + propName + "\nvalue: " + propValue );
        if ( Array.isArray( currentNode.properties[ propName ] ) ) {

          currentNode.properties[ propName ].push( propValue );

        } else {

          currentNode.properties[ propName ] += propValue;

        }

      } else {

        // console.log( propName + ":  " + propValue );
        if ( Array.isArray( currentNode.properties[ propName ] ) ) {

          currentNode.properties[ propName ].push( propValue );

        } else {

          currentNode.properties[ propName ] = propValue;

        }

      }

      this.setCurrentProp( currentNode.properties, propName );

    },

    // TODO:
    parseNodePropertyContinued: function ( line ) {

      this.currentProp[ this.currentPropName ] += line;

    },

    parseNodeSpecialProperty: function ( line, propName, propValue ) {

      // split this
      // P: "Lcl Scaling", "Lcl Scaling", "", "A",1,1,1
      // into array like below
      // ["Lcl Scaling", "Lcl Scaling", "", "A", "1,1,1" ]
      var props = propValue.split( '",' ).map( function ( element ) {

        return element.trim().replace( /^\"/, '' ).replace( /\s/, '_' );

      } );

      var innerPropName = props[ 0 ];
      var innerPropType1 = props[ 1 ];
      var innerPropType2 = props[ 2 ];
      var innerPropFlag = props[ 3 ];
      var innerPropValue = props[ 4 ];

      /*
      if ( innerPropValue === undefined ) {
        innerPropValue = props[3];
      }
      */

      // cast value in its type
      switch ( innerPropType1 ) {

        case "int":
          innerPropValue = parseInt( innerPropValue );
          break;

        case "double":
          innerPropValue = parseFloat( innerPropValue );
          break;

        case "ColorRGB":
        case "Vector3D":
          var tmp = innerPropValue.split( ',' );
          innerPropValue = new THREE.Vector3( tmp[ 0 ], tmp[ 1 ], tmp[ 2 ] );
          break;

      }

      // CAUTION: these props must append to parent's parent
      this.getPrevNode().properties[ innerPropName ] = {

        'type': innerPropType1,
        'type2': innerPropType2,
        'flag': innerPropFlag,
        'value': innerPropValue

      };

      this.setCurrentProp( this.getPrevNode().properties, innerPropName );

    },

    nodeEnd: function () {

      this.popStack();

    },

    /* ---------------------------------------------------------------- */
    /*    util                            */
    isFlattenNode: function ( node ) {

      return ( 'subNodes' in node && 'properties' in node ) ? true : false;

    }

  } );


  // generate skinIndices, skinWeights
  //    @skinIndices: per vertex data, this represents the bone indexes affects that vertex
  //    @skinWeights: per vertex data, this represents the Weight Values affects that vertex
  //    @matrices:  per `bones` data
  function Weights() {

    this.skinIndices = [];
    this.skinWeights = [];

    this.matrices = [];

  }


  Weights.prototype.parseCluster = function ( node, id, entry ) {

    var _p = node.searchConnectionParent( id );
    var _indices = parseArrayToInt( entry.subNodes.Indexes.properties.a );
    var _weights = parseArrayToFloat( entry.subNodes.Weights.properties.a );
    var _transform = parseArrayToMatrix( entry.subNodes.Transform.properties.a );
    var _link = parseArrayToMatrix( entry.subNodes.TransformLink.properties.a );

    return {

      'parent': _p,
      'id': parseInt( id ),
      'indices': _indices,
      'weights': _weights,
      'transform': _transform,
      'transformlink': _link,
      'linkMode': entry.properties.Mode

    };

  };

  Weights.prototype.parse = function ( node, bones ) {

    this.skinIndices = [];
    this.skinWeights = [];

    this.matrices = [];

    var deformers = node.Objects.subNodes.Deformer;

    var clusters = {};
    for ( var id in deformers ) {

      if ( deformers[ id ].attrType === 'Cluster' ) {

        if ( ! ( 'Indexes' in deformers[ id ].subNodes ) ) {

          continue;

        }

        //clusters.push( this.parseCluster( node, id, deformers[id] ) );
        var cluster = this.parseCluster( node, id, deformers[ id ] );
        var boneId = node.searchConnectionChildren( cluster.id )[ 0 ];
        clusters[ boneId ] = cluster;

      }

    }


    // this clusters is per Bone data, thus we make this into per vertex data
    var weights = [];
    var hi = bones.hierarchy;
    for ( var b = 0; b < hi.length; ++ b ) {

      var bid = hi[ b ].internalId;
      if ( clusters[ bid ] === undefined ) {

        //console.log( bid );
        this.matrices.push( new THREE.Matrix4() );
        continue;

      }

      var clst = clusters[ bid ];
      // store transform matrix per bones
      this.matrices.push( clst.transform );
      //this.matrices.push( clst.transformlink );
      for ( var v = 0; v < clst.indices.length; ++ v ) {

        if ( weights[ clst.indices[ v ] ] === undefined ) {

          weights[ clst.indices[ v ] ] = {};
          weights[ clst.indices[ v ] ].joint = [];
          weights[ clst.indices[ v ] ].weight = [];

        }

        // indices
        var affect = node.searchConnectionChildren( clst.id );

        if ( affect.length > 1 ) {

          console.warn( "FBXLoader: node " + clst.id + " have many weight kids: " + affect );

        }
        weights[ clst.indices[ v ] ].joint.push( bones.getBoneIdfromInternalId( node, affect[ 0 ] ) );

        // weight value
        weights[ clst.indices[ v ] ].weight.push( clst.weights[ v ] );

      }

    }

    // normalize the skin weights
    // TODO -  this might be a good place to choose greatest 4 weights
    for ( var i = 0; i < weights.length; i ++ ) {

      if ( weights[ i ] === undefined ) {

        this.skinIndices.push( new THREE.Vector4( 0, 0, 0, 0 ) );
        this.skinWeights.push( new THREE.Vector4( 0, 0, 0, 0 ) );
        continue;

      }

      var indicies = new THREE.Vector4(
        weights[ i ].joint[ 0 ] ? weights[ i ].joint[ 0 ] : 0,
        weights[ i ].joint[ 1 ] ? weights[ i ].joint[ 1 ] : 0,
        weights[ i ].joint[ 2 ] ? weights[ i ].joint[ 2 ] : 0,
        weights[ i ].joint[ 3 ] ? weights[ i ].joint[ 3 ] : 0 );

      var weight = new THREE.Vector4(
        weights[ i ].weight[ 0 ] ? weights[ i ].weight[ 0 ] : 0,
        weights[ i ].weight[ 1 ] ? weights[ i ].weight[ 1 ] : 0,
        weights[ i ].weight[ 2 ] ? weights[ i ].weight[ 2 ] : 0,
        weights[ i ].weight[ 3 ] ? weights[ i ].weight[ 3 ] : 0 );

      this.skinIndices.push( indicies );
      this.skinWeights.push( weight );

    }

    //console.log( this );
    return this;

  };

  function Bones() {

    // returns bones hierarchy tree.
    //    [
    //      {
    //        "parent": id,
    //        "name": name,
    //        "pos": pos,
    //        "rotq": quat
    //      },
    //      ...
    //      {},
    //      ...
    //    ]
    //
    /* sample response

       "bones" : [
      {"parent":-1, "name":"Fbx01",     "pos":[-0.002,   98.739,   1.6e-05],   "rotq":[0, 0, 0, 1]},
      {"parent":0,  "name":"Fbx01_Pelvis",   "pos":[0.00015963, 0,    7.33107e-08], "rotq":[0, 0, 0, 1]},
      {"parent":1,  "name":"Fbx01_Spine",   "pos":[6.577e-06,  10.216,   0.0106811],   "rotq":[0, 0, 0, 1]},
      {"parent":2,  "name":"Fbx01_R_Thigh", "pos":[14.6537, -10.216,  -0.00918758], "rotq":[0, 0, 0, 1]},
      {"parent":3,  "name":"Fbx01_R_Calf",   "pos":[-3.70047,  -42.9681,   -7.78158],  "rotq":[0, 0, 0, 1]},
      {"parent":4,  "name":"Fbx01_R_Foot",   "pos":[-2.0696,    -46.0488,  9.42052],    "rotq":[0, 0, 0, 1]},
      {"parent":5,  "name":"Fbx01_R_Toe0",   "pos":[-0.0234785,   -9.46233,  -15.3187],  "rotq":[0, 0, 0, 1]},
      {"parent":2,  "name":"Fbx01_L_Thigh", "pos":[-14.6537,   -10.216,   -0.00918314],  "rotq":[0, 0, 0, 1]},
      {"parent":7,  "name":"Fbx01_L_Calf",   "pos":[3.70037,    -42.968,    -7.78155],   "rotq":[0, 0, 0, 1]},
      {"parent":8,  "name":"Fbx01_L_Foot",   "pos":[2.06954,    -46.0488,  9.42052],    "rotq":[0, 0, 0, 1]},
      {"parent":9,  "name":"Fbx01_L_Toe0",   "pos":[0.0234566,  -9.46235,  -15.3187],  "rotq":[0, 0, 0, 1]},
      {"parent":2,  "name":"Fbx01_Spine1",   "pos":[-2.97523e-05, 11.5892,    -9.81027e-05], "rotq":[0, 0, 0, 1]},
      {"parent":11, "name":"Fbx01_Spine2",   "pos":[-2.91292e-05, 11.4685,    8.27126e-05],  "rotq":[0, 0, 0, 1]},
      {"parent":12, "name":"Fbx01_Spine3",   "pos":[-4.48857e-05, 11.5783,    8.35108e-05],  "rotq":[0, 0, 0, 1]},
      {"parent":13, "name":"Fbx01_Neck",     "pos":[1.22987e-05,  11.5582,    -0.0044775],   "rotq":[0, 0, 0, 1]},
      {"parent":14, "name":"Fbx01_Head",     "pos":[-3.50709e-05, 6.62915,    -0.00523254],  "rotq":[0, 0, 0, 1]},
      {"parent":15, "name":"Fbx01_R_Eye",   "pos":[3.31681,   12.739,    -10.5267],  "rotq":[0, 0, 0, 1]},
      {"parent":15, "name":"Fbx01_L_Eye",   "pos":[-3.32038,   12.7391,   -10.5267],   "rotq":[0, 0, 0, 1]},
      {"parent":15, "name":"Jaw",       "pos":[-0.0017738,   7.43481,   -4.08114],   "rotq":[0, 0, 0, 1]},
      {"parent":14, "name":"Fbx01_R_Clavicle", "pos":[3.10919,    2.46577,    -0.0115284],   "rotq":[0, 0, 0, 1]},
      {"parent":19, "name":"Fbx01_R_UpperArm", "pos":[16.014,    4.57764e-05,  3.10405],    "rotq":[0, 0, 0, 1]},
      {"parent":20, "name":"Fbx01_R_Forearm",  "pos":[22.7068,    -1.66322,  -2.13803],  "rotq":[0, 0, 0, 1]},
      {"parent":21, "name":"Fbx01_R_Hand",   "pos":[25.5881,    -0.80249,  -6.37307],  "rotq":[0, 0, 0, 1]},
      ...
      {"parent":27, "name":"Fbx01_R_Finger32", "pos":[2.15572,    -0.548737,  -0.539604], "rotq":[0, 0, 0, 1]},
      {"parent":22, "name":"Fbx01_R_Finger2",  "pos":[9.79318,    0.132553,  -2.97845],  "rotq":[0, 0, 0, 1]},
      {"parent":29, "name":"Fbx01_R_Finger21", "pos":[2.74037,    0.0483093,  -0.650531], "rotq":[0, 0, 0, 1]},
      {"parent":55, "name":"Fbx01_L_Finger02", "pos":[-1.65308,  -1.43208,   -1.82885],  "rotq":[0, 0, 0, 1]}
      ]
    */
    this.hierarchy = [];

  }

  Bones.prototype.parseHierarchy = function ( node ) {

    var objects = node.Objects;
    var models = objects.subNodes.Model;

    var bones = [];
    for ( var id in models ) {

      if ( models[ id ].attrType === undefined ) {

        continue;

      }
      bones.push( models[ id ] );

    }

    this.hierarchy = [];
    for ( var i = 0; i < bones.length; ++ i ) {

      var bone = bones[ i ];

      var p = node.searchConnectionParent( bone.id )[ 0 ];
      var t = [ 0.0, 0.0, 0.0 ];
      var r = [ 0.0, 0.0, 0.0, 1.0 ];
      var s = [ 1.0, 1.0, 1.0 ];

      if ( 'Lcl_Translation' in bone.properties ) {

        t = parseArrayToFloat( bone.properties.Lcl_Translation.value );

      }

      if ( 'Lcl_Rotation' in bone.properties ) {

        r = parseArrayToRadians( bone.properties.Lcl_Rotation.value );
        var q = new THREE.Quaternion();
        q.setFromEuler( new THREE.Euler( r[ 0 ], r[ 1 ], r[ 2 ], 'ZYX' ) );
        r = [ q.x, q.y, q.z, q.w ];

      }

      if ( 'Lcl_Scaling' in bone.properties ) {

        s = parseArrayToFloat( bone.properties.Lcl_Scaling.value );

      }

      // replace unsafe character
      var name = bone.attrName;
      name = name.replace( /:/, '' );
      name = name.replace( /_/, '' );
      name = name.replace( /-/, '' );
      this.hierarchy.push( { "parent": p, "name": name, "pos": t, "rotq": r, "scl": s, "internalId": bone.id } );

    }

    this.reindexParentId();

    this.restoreBindPose( node );

    return this;

  };

  Bones.prototype.reindexParentId = function () {

    for ( var h = 0; h < this.hierarchy.length; h ++ ) {

      for ( var ii = 0; ii < this.hierarchy.length; ++ ii ) {

        if ( this.hierarchy[ h ].parent == this.hierarchy[ ii ].internalId ) {

          this.hierarchy[ h ].parent = ii;
          break;

        }

      }

    }

  };

  Bones.prototype.restoreBindPose = function ( node ) {

    var bindPoseNode = node.Objects.subNodes.Pose;
    if ( bindPoseNode === undefined ) {

      return;

    }

    for ( var key in bindPoseNode ) {

      if ( bindPoseNode[ key ].attrType === 'BindPose' ) {

        bindPoseNode = bindPoseNode[ key ];
        break;

      }

    }

    var poseNode = bindPoseNode.subNodes.PoseNode;
    var localMatrices = {}; // store local matrices, modified later( initialy world space )
    var worldMatrices = {}; // store world matrices

    for ( var i = 0; i < poseNode.length; ++ i ) {

      var rawMatLcl = parseArrayToMatrix( poseNode[ i ].subNodes.Matrix.properties.a );
      var rawMatWrd = parseArrayToMatrix( poseNode[ i ].subNodes.Matrix.properties.a );

      localMatrices[ poseNode[ i ].id ] = rawMatLcl;
      worldMatrices[ poseNode[ i ].id ] = rawMatWrd;

    }

    for ( var h = 0; h < this.hierarchy.length; ++ h ) {

      var bone = this.hierarchy[ h ];
      var inId = bone.internalId;

      if ( worldMatrices[ inId ] === undefined ) {

        // has no bind pose node, possibly be mesh
        // console.log( bone );
        continue;

      }

      var t = new THREE.Vector3( 0, 0, 0 );
      var r = new THREE.Quaternion();
      var s = new THREE.Vector3( 1, 1, 1 );

      var parentId;
      var parentNodes = node.searchConnectionParent( inId );
      for ( var pn = 0; pn < parentNodes.length; ++ pn ) {

        if ( this.isBoneNode( parentNodes[ pn ] ) ) {

          parentId = parentNodes[ pn ];
          break;

        }

      }

      if ( parentId !== undefined && localMatrices[ parentId ] !== undefined ) {

        // convert world space matrix into local space
        var inv = new THREE.Matrix4();
        inv.getInverse( worldMatrices[ parentId ] );
        inv.multiply( localMatrices[ inId ] );
        localMatrices[ inId ] = inv;

      } else {
        //console.log( bone );
      }

      localMatrices[ inId ].decompose( t, r, s );
      bone.pos = [ t.x, t.y, t.z ];
      bone.rotq = [ r.x, r.y, r.z, r.w ];
      bone.scl = [ s.x, s.y, s.z ];

    }

  };

  Bones.prototype.searchRealId = function ( internalId ) {

    for ( var h = 0; h < this.hierarchy.length; h ++ ) {

      if ( internalId == this.hierarchy[ h ].internalId ) {

        return h;

      }

    }

    // console.warn( 'FBXLoader: notfound internalId in bones: ' + internalId);
    return - 1;

  };

  Bones.prototype.getByInternalId = function ( internalId ) {

    for ( var h = 0; h < this.hierarchy.length; h ++ ) {

      if ( internalId == this.hierarchy[ h ].internalId ) {

        return this.hierarchy[ h ];

      }

    }

    return null;

  };

  Bones.prototype.isBoneNode = function ( id ) {

    for ( var i = 0; i < this.hierarchy.length; ++ i ) {

      if ( id === this.hierarchy[ i ].internalId ) {

        return true;

      }

    }
    return false;

  };

  Bones.prototype.getBoneIdfromInternalId = function ( node, id ) {

    if ( node.__cache_get_boneid_from_internalid === undefined ) {

      node.__cache_get_boneid_from_internalid = [];

    }

    if ( node.__cache_get_boneid_from_internalid[ id ] !== undefined ) {

      return node.__cache_get_boneid_from_internalid[ id ];

    }

    for ( var i = 0; i < this.hierarchy.length; ++ i ) {

      if ( this.hierarchy[ i ].internalId == id ) {

        node.__cache_get_boneid_from_internalid[ id ] = i;
        return i;

      }

    }

    // console.warn( 'FBXLoader: bone internalId(' + id + ') not found in bone hierarchy' );
    return - 1;

  };

  function Geometries() {

    this.geometries = {};

  }

  Object.assign( Geometries.prototype, {

    parse: function ( FBXNodes, hierarchy ) {

      if ( ! ( 'Geometry' in FBXNodes.Objects.subNodes ) ) {

        return this;

      }

      for ( var geo in FBXNodes.Objects.subNodes.Geometry ) {

        if ( FBXNodes.Objects.subNodes.Geometry[ geo ].attrType === 'Mesh' ) {

          this.geometries[ geo ] = ( new Geometry() ).parse( FBXNodes.Objects.subNodes.Geometry[ geo ] );
          this.geometries[ geo ].addBones( hierarchy.hierarchy );

        }

      }

      return this;

    }

  } );


  function Geometry() {

    this.node = null;
    this.name = null;
    this.id = null;

    this.vertices = [];
    this.indices = [];
    this.normals = [];
    this.uvs = [];

    this.bones = [];

  }

  Geometry.prototype.parse = function ( geoNode ) {

    this.node = geoNode;
    this.name = geoNode.attrName;
    this.id = geoNode.id;

    this.vertices = this.getVertices();

    if ( this.vertices === undefined ) {

      console.log( 'FBXLoader: Geometry.parse(): pass' + this.node.id );
      return;

    }

    this.indices = this.getPolygonVertexIndices();
    this.uvs = ( new UV() ).parse( this.node, this );
    this.normals = ( new Normal() ).parse( this.node, this );
    this.materialIndices = ( new MaterialIndex() ).parse( this.node );

    if ( this.getPolygonTopologyMax() > 3 ) {

      var indexInfo = this.convertPolyIndicesToTri(
                this.indices,
                this.materialIndices,
                this.getPolygonTopologyArray() );
      this.indices = indexInfo.res;
      this.materialIndices = indexInfo.materialIndices;
      this.polyIndices = indexInfo.polyIndices;

    }

    return this;

  };


  Geometry.prototype.getVertices = function () {

    if ( this.node.__cache_vertices ) {

      return this.node.__cache_vertices;

    }

    if ( this.node.subNodes.Vertices === undefined ) {

      console.warn( 'this.node: ' + this.node.attrName + "(" + this.node.id + ") does not have Vertices" );
      this.node.__cache_vertices = undefined;
      return null;

    }

    var rawTextVert = this.node.subNodes.Vertices.properties.a;
    var vertices = rawTextVert.split( ',' ).map( function ( element ) {

      return parseFloat( element );

    } );

    this.node.__cache_vertices = vertices;
    return this.node.__cache_vertices;

  };

  Geometry.prototype.getPolygonVertexIndices = function () {

    if ( this.node.__cache_indices && this.node.__cache_poly_topology_max ) {

      return this.node.__cache_indices;

    }

    if ( this.node.subNodes === undefined ) {

      console.error( 'this.node.subNodes undefined' );
      console.log( this.node );
      return;

    }

    if ( this.node.subNodes.PolygonVertexIndex === undefined ) {

      console.warn( 'this.node: ' + this.node.attrName + "(" + this.node.id + ") does not have PolygonVertexIndex " );
      this.node.__cache_indices = undefined;
      return;

    }

    var rawTextIndices = this.node.subNodes.PolygonVertexIndex.properties.a;
    var indices = rawTextIndices.split( ',' );

    var currentTopo = 1;
    var topologyN = null;
    var topologyArr = [];

    // The indices that make up the polygon are in order and a negative index
    // means that it’s the last index of the polygon. That index needs
    // to be made positive and then you have to subtract 1 from it!
    for ( var i = 0; i < indices.length; ++ i ) {

      var tmpI = parseInt( indices[ i ] );
      // found n
      if ( tmpI < 0 ) {

        if ( currentTopo > topologyN ) {

          topologyN = currentTopo;

        }

        indices[ i ] = tmpI ^ - 1;
        topologyArr.push( currentTopo );
        currentTopo = 1;

      } else {

        indices[ i ] = tmpI;
        currentTopo ++;

      }

    }

    if ( topologyN === null ) {

      console.warn( "FBXLoader: topology N not found: " + this.node.attrName );
      console.warn( this.node );
      topologyN = 3;

    }

    this.node.__cache_poly_topology_max = topologyN;
    this.node.__cache_poly_topology_arr = topologyArr;
    this.node.__cache_indices = indices;

    return this.node.__cache_indices;

  };

  Geometry.prototype.getPolygonTopologyMax = function () {

    if ( this.node.__cache_indices && this.node.__cache_poly_topology_max ) {

      return this.node.__cache_poly_topology_max;

    }

    this.getPolygonVertexIndices( this.node );
    return this.node.__cache_poly_topology_max;

  };

  Geometry.prototype.getPolygonTopologyArray = function () {

    if ( this.node.__cache_indices && this.node.__cache_poly_topology_max ) {

      return this.node.__cache_poly_topology_arr;

    }

    this.getPolygonVertexIndices( this.node );
    return this.node.__cache_poly_topology_arr;

  };

  // a - d
  // |   |
  // b - c
  //
  // [( a, b, c, d ) ...........
  // [( a, b, c ), (a, c, d )....

  // Also keep track of original poly index.
  Geometry.prototype.convertPolyIndicesToTri = function ( indices, materialIndices, strides ) {

    var res = [];

    var i = 0;
    var currentPolyNum = 0;
    var currentStride = 0;
    var polyIndices = [];

    while ( i < indices.length ) {

      currentStride = strides[ currentPolyNum ];

      // CAUTIN: NG over 6gon
      for ( var j = 0; j <= ( currentStride - 3 ); j ++ ) {

        res.push( indices[ i ] );
        res.push( indices[ i + ( currentStride - 2 - j ) ] );
        res.push( indices[ i + ( currentStride - 1 - j ) ] );

        polyIndices.push( currentPolyNum );

      }

      currentPolyNum ++;
      i += currentStride;

    }

    var newMaterialIndices = [ materialIndices[ 0 ] ];

    if ( materialIndices.length > 1 ) {

      for ( var i = 0; i < polyIndices.length; ++ i ) {

        newMaterialIndices[ i ] = materialIndices[ polyIndices[ i ] ];

      }

    }

    return {
      res: res,
      materialIndices: newMaterialIndices,
      polyIndices: polyIndices };

  };

  Geometry.prototype.addBones = function ( bones ) {

    this.bones = bones;

  };


  function UV() {

    this.uv = null;
    this.map = null;
    this.ref = null;
    this.node = null;
    this.index = null;

  }

  UV.prototype.getUV = function ( node ) {

    if ( this.node && this.uv && this.map && this.ref ) {

      return this.uv;

    } else {

      return this._parseText( node );

    }

  };

  UV.prototype.getMap = function ( node ) {

    if ( this.node && this.uv && this.map && this.ref ) {

      return this.map;

    } else {

      this._parseText( node );
      return this.map;

    }

  };

  UV.prototype.getRef = function ( node ) {

    if ( this.node && this.uv && this.map && this.ref ) {

      return this.ref;

    } else {

      this._parseText( node );
      return this.ref;

    }

  };

  UV.prototype.getIndex = function ( node ) {

    if ( this.node && this.uv && this.map && this.ref ) {

      return this.index;

    } else {

      this._parseText( node );
      return this.index;

    }

  };

  UV.prototype.getNode = function ( topnode ) {

    if ( this.node !== null ) {

      return this.node;

    }

    this.node = topnode.subNodes.LayerElementUV;
    return this.node;

  };

  UV.prototype._parseText = function ( node ) {

    var uvNode = this.getNode( node )[ 0 ];
    if ( uvNode === undefined ) {

      // console.log( node.attrName + "(" + node.id + ")" + " has no LayerElementUV." );
      return [];

    }

    var count = 0;
    for ( var n in uvNode ) {

      if ( n.match( /^\d+$/ ) ) {

        count ++;

      }

    }

    if ( count > 0 ) {

      console.warn( 'multi uv not supported' );
      uvNode = uvNode[ n ];

    }

    var uvIndex = uvNode.subNodes.UVIndex.properties.a;
    var uvs = uvNode.subNodes.UV.properties.a;
    var uvMap = uvNode.properties.MappingInformationType;
    var uvRef = uvNode.properties.ReferenceInformationType;


    this.uv = parseArrayToFloat( uvs );
    this.index = parseArrayToInt( uvIndex );

    this.map = uvMap; // TODO: normalize notation shaking... FOR BLENDER
    this.ref = uvRef;

    return this.uv;

  };

  UV.prototype.parse = function ( node, geo ) {

    if ( ! ( 'LayerElementUV' in node.subNodes ) ) {

      return;

    }

    this.uvNode = this.getNode( node );

    this.uv = this.getUV( node );
    var mappingType = this.getMap( node );
    var refType = this.getRef( node );
    var indices = this.getIndex( node );

    var strides = geo.getPolygonTopologyArray();

    // it means that there is a normal for every vertex of every polygon of the model.
    // For example, if the models has 8 vertices that make up four quads, then there
    // will be 16 normals (one normal * 4 polygons * 4 vertices of the polygon). Note
    // that generally a game engine needs the vertices to have only one normal defined.
    // So, if you find a vertex has more tha one normal, you can either ignore the normals
    // you find after the first, or calculate the mean from all of them (normal smoothing).
    //if ( mappingType == "ByPolygonVertex" ){
    switch ( mappingType ) {

      case "ByPolygonVertex":

        switch ( refType ) {

          // Direct
          // The this.uv are in order.
          case "Direct":
            this.uv = this.parseUV_ByPolygonVertex_Direct( this.uv, indices, strides, 2 );
            break;

          // IndexToDirect
          // The order of the this.uv is given by the uvsIndex property.
          case "IndexToDirect":
            this.uv = this.parseUV_ByPolygonVertex_IndexToDirect( this.uv, indices );
            break;

        }

        // convert from by polygon(vert) data into by verts data
        this.uv = mapByPolygonVertexToByVertex( this.uv, geo.getPolygonVertexIndices( node ), 2 );
        break;

      case "ByPolygon":

        switch ( refType ) {

          // Direct
          // The this.uv are in order.
          case "Direct":
            this.uv = this.parseUV_ByPolygon_Direct();
            break;

          // IndexToDirect
          // The order of the this.uv is given by the uvsIndex property.
          case "IndexToDirect":
            this.uv = this.parseUV_ByPolygon_IndexToDirect();
            break;

        }
        break;

    }

    return this.uv;

  };

  UV.prototype.parseUV_ByPolygonVertex_Direct = function ( node, indices, strides, itemSize ) {

    return parse_Data_ByPolygonVertex_Direct( node, indices, strides, itemSize );

  };

  UV.prototype.parseUV_ByPolygonVertex_IndexToDirect = function ( node, indices ) {

    return parse_Data_ByPolygonVertex_IndexToDirect( node, indices, 2 );

  };

  UV.prototype.parseUV_ByPolygon_Direct = function ( node ) {

    console.warn( "not implemented" );
    return node;

  };

  UV.prototype.parseUV_ByPolygon_IndexToDirect = function ( node ) {

    console.warn( "not implemented" );
    return node;

  };

  UV.prototype.parseUV_ByVertex_Direct = function ( node ) {

    console.warn( "not implemented" );
    return node;

  };


  function Normal() {

    this.normal = null;
    this.map  = null;
    this.ref  = null;
    this.node = null;
    this.index = null;

  }

  Normal.prototype.getNormal = function ( node ) {

    if ( this.node && this.normal && this.map && this.ref ) {

      return this.normal;

    } else {

      this._parseText( node );
      return this.normal;

    }

  };

  // mappingType: possible variant
  //    ByPolygon
  //    ByPolygonVertex
  //    ByVertex (or also ByVertice, as the Blender exporter writes)
  //    ByEdge
  //    AllSame
  //  var mappingType = node.properties.MappingInformationType;
  Normal.prototype.getMap = function ( node ) {

    if ( this.node && this.normal && this.map && this.ref ) {

      return this.map;

    } else {

      this._parseText( node );
      return this.map;

    }

  };

  // refType: possible variants
  //    Direct
  //    IndexToDirect (or Index for older versions)
  // var refType   = node.properties.ReferenceInformationType;
  Normal.prototype.getRef = function ( node ) {

    if ( this.node && this.normal && this.map && this.ref ) {

      return this.ref;

    } else {

      this._parseText( node );
      return this.ref;

    }

  };

  Normal.prototype.getNode = function ( node ) {

    if ( this.node ) {

      return this.node;

    }

    this.node = node.subNodes.LayerElementNormal;
    return this.node;

  };

  Normal.prototype._parseText = function ( node ) {

    var normalNode = this.getNode( node )[ 0 ];

    if ( normalNode === undefined ) {

      console.warn( 'node: ' + node.attrName + "(" + node.id + ") does not have LayerElementNormal" );
      return;

    }

    var mappingType = normalNode.properties.MappingInformationType;
    var refType = normalNode.properties.ReferenceInformationType;

    var rawTextNormals = normalNode.subNodes.Normals.properties.a;
    this.normal = parseArrayToFloat( rawTextNormals );

    // TODO: normalize notation shaking, vertex / vertice... blender...
    this.map  = mappingType;
    this.ref  = refType;

  };

  Normal.prototype.parse = function ( topnode, geo ) {

    var normals = this.getNormal( topnode );
    //var normalNode = this.getNode( topnode );
    var mappingType = this.getMap( topnode );
    var refType = this.getRef( topnode );

    var indices = geo.getPolygonVertexIndices( topnode );
    var strides = geo.getPolygonTopologyArray( topnode );

    // it means that there is a normal for every vertex of every polygon of the model.
    // For example, if the models has 8 vertices that make up four quads, then there
    // will be 16 normals (one normal * 4 polygons * 4 vertices of the polygon). Note
    // that generally a game engine needs the vertices to have only one normal defined.
    // So, if you find a vertex has more tha one normal, you can either ignore the normals
    // you find after the first, or calculate the mean from all of them (normal smoothing).
    //if ( mappingType == "ByPolygonVertex" ){
    switch ( mappingType ) {

      case "ByPolygonVertex":

        switch ( refType ) {

          // Direct
          // The normals are in order.
          case "Direct":
            normals = this.parseNormal_ByPolygonVertex_Direct( normals, indices, strides, 3 );
            break;

          // IndexToDirect
          // The order of the normals is given by the NormalsIndex property.
          case "IndexToDirect":
            normals = this.parseNormal_ByPolygonVertex_IndexToDirect();
            break;

        }
        break;

      case "ByPolygon":

        switch ( refType ) {

          // Direct
          // The normals are in order.
          case "Direct":
            normals = this.parseNormal_ByPolygon_Direct();
            break;

          // IndexToDirect
          // The order of the normals is given by the NormalsIndex property.
          case "IndexToDirect":
            normals = this.parseNormal_ByPolygon_IndexToDirect();
            break;

        }
        break;

    }

    return normals;

  };

  Normal.prototype.parseNormal_ByPolygonVertex_Direct = function ( node, indices, strides, itemSize ) {

    return parse_Data_ByPolygonVertex_Direct( node, indices, strides, itemSize );

  };

  Normal.prototype.parseNormal_ByPolygonVertex_IndexToDirect = function ( node ) {

    console.warn( "not implemented" );
    return node;

  };

  Normal.prototype.parseNormal_ByPolygon_Direct = function ( node ) {

    console.warn( "not implemented" );
    return node;

  };

  Normal.prototype.parseNormal_ByPolygon_IndexToDirect = function ( node ) {

    console.warn( "not implemented" );
    return node;

  };

  Normal.prototype.parseNormal_ByVertex_Direct = function ( node ) {

    console.warn( "not implemented" );
    return node;

  };

  function MaterialIndex() {

    this.indexBuffer = [];

  }

  Object.assign( MaterialIndex.prototype, {

    parse: function ( node ) {

      if ( ! ( 'LayerElementMaterial' in node.subNodes ) ) {

        return;

      }

      var indexNode = node.subNodes.LayerElementMaterial[ 0 ];
      var mappingType = indexNode.properties.MappingInformationType;
      var refType = indexNode.properties.ReferenceInformationType;
      var indices = parseArrayToInt( indexNode.subNodes.Materials.properties.a );

      // it means that there is a normal for every vertex of every polygon of the model.
      // For example, if the models has 8 vertices that make up four quads, then there
      // will be 16 normals (one normal * 4 polygons * 4 vertices of the polygon). Note
      // that generally a game engine needs the vertices to have only one normal defined.
      // So, if you find a vertex has more tha one normal, you can either ignore the normals
      // you find after the first, or calculate the mean from all of them (normal smoothing).
      //if ( mappingType == "ByPolygonVertex" ){
      switch ( mappingType ) {


        case "ByPolygon":

          switch ( refType ) {

            // Direct
            // The material indices are in order.
            case "IndexToDirect":
              this.indexBuffer = this.parse_ByPolygon_IndexToDirect( indices );
              break;

            default:
              this.indexBuffer = [ 0 ];
              break;

          }
          break;

        default:

          this.indexBuffer = [ 0 ];
          break;

      }

      return this.indexBuffer;

    },

    parse_ByPolygon_IndexToDirect: function ( indices ) {

      return indices;

    },

  } );

  function AnimationCurve() {

    this.version = null;

    this.id = null;
    this.internalId = null;
    this.times = null;
    this.values = null;

    this.attrFlag = null; // tangeant
    this.attrData = null; // slope, weight

  }

  AnimationCurve.prototype.fromNode = function ( curveNode ) {

    this.id = curveNode.id;
    this.internalId = curveNode.id;
    this.times = curveNode.subNodes.KeyTime.properties.a;
    this.values = curveNode.subNodes.KeyValueFloat.properties.a;

    this.attrFlag = curveNode.subNodes.KeyAttrFlags.properties.a;
    this.attrData = curveNode.subNodes.KeyAttrDataFloat.properties.a;

    this.times = parseArrayToFloat( this.times );
    this.values = parseArrayToFloat( this.values );
    this.attrData = parseArrayToFloat( this.attrData );
    this.attrFlag = parseArrayToInt( this.attrFlag );

    this.times = this.times.map( function ( element ) {

      return FBXTimeToSeconds( element );

    } );

    return this;

  };

  AnimationCurve.prototype.getLength = function () {

    return this.times[ this.times.length - 1 ];

  };

  function AnimationNode() {

    this.id = null;
    this.attr = null; // S, R, T
    this.attrX = false;
    this.attrY = false;
    this.attrZ = false;
    this.internalId = null;
    this.containerInternalId = null; // bone, null etc Id
    this.containerBoneId = null; // bone, null etc Id
    this.curveIdx = null; // AnimationCurve's indices
    this.curves = {}; // AnimationCurve refs

  }

  AnimationNode.prototype.fromNode = function ( allNodes, node, bones ) {

    this.id = node.id;
    this.attr = node.attrName;
    this.internalId = node.id;

    if ( this.attr.match( /S|R|T/ ) ) {

      for ( var attrKey in node.properties ) {

        if ( attrKey.match( /X/ ) ) {

          this.attrX = true;

        }
        if ( attrKey.match( /Y/ ) ) {

          this.attrY = true;

        }
        if ( attrKey.match( /Z/ ) ) {

          this.attrZ = true;

        }

      }

    } else {

      // may be deform percent nodes
      return null;

    }

    this.containerIndices = allNodes.searchConnectionParent( this.id );
    this.curveIdx = allNodes.searchConnectionChildren( this.id );

    for ( var i = this.containerIndices.length - 1; i >= 0; -- i ) {

      var boneId = bones.searchRealId( this.containerIndices[ i ] );
      if ( boneId >= 0 ) {

        this.containerBoneId = boneId;
        this.containerId = this.containerIndices[ i ];

      }

      if ( boneId >= 0 ) {

        break;

      }

    }
    // this.containerBoneId = bones.searchRealId( this.containerIndices );

    return this;

  };

  AnimationNode.prototype.setCurve = function ( curve ) {

    this.curves.push( curve );

  };

  function Animation() {

    this.curves = {};
    this.length = 0.0;
    this.fps  = 30.0;
    this.frames = 0.0;

  }

  Animation.prototype.parse = function ( node, bones ) {

    var rawNodes = node.Objects.subNodes.AnimationCurveNode;
    var rawCurves = node.Objects.subNodes.AnimationCurve;
    var rawLayers = node.Objects.subNodes.AnimationLayer;
    var rawStacks = node.Objects.subNodes.AnimationStack;

    // first: expand AnimationCurveNode into curve nodes
    var curveNodes = [];
    for ( var key in rawNodes ) {

      if ( key.match( /\d+/ ) ) {

        var a = ( new AnimationNode() ).fromNode( node, rawNodes[ key ], bones );
        curveNodes.push( a );

      }

    }

    // second: gen dict, mapped by internalId
    var tmp = {};
    for ( var i = 0; i < curveNodes.length; ++ i ) {

      if ( curveNodes[ i ] === null ) {

        continue;

      }

      tmp[ curveNodes[ i ].id ] = curveNodes[ i ];

    }

    // third: insert curves into the dict
    var ac = [];
    for ( key in rawCurves ) {

      if ( key.match( /\d+/ ) ) {

        var c = ( new AnimationCurve() ).fromNode( rawCurves[ key ] );
        ac.push( c );

        var parentId = node.searchConnectionParent( c.id )[ 0 ];
        var axis = node.searchConnectionType( c.id, parentId );

        if ( axis.match( /X/ ) ) {

          axis = 'x';

        } else if ( axis.match( /Y/ ) ) {

          axis = 'y';

        } else if ( axis.match( /Z/ ) ) {

          axis = 'z';

        } else {

          continue;

        }

        tmp[ parentId ].curves[ axis ] = c;

      }

    }

    // forth:
    for ( var t in tmp ) {

      var id = tmp[ t ].containerBoneId;
      if ( this.curves[ id ] === undefined ) {

        this.curves[ id ] = {
          T: null,
          R: null,
          S: null
        };

      }

      this.curves[ id ][ tmp[ t ].attr ] = tmp[ t ];

    }

    //Layers
    this.layers = {};
    for ( var key in rawLayers ) {

      var layer = [];
      var children = node.searchConnectionChildren( key );
      for ( var i = 0; i < children.length; ++ i ) {

        //Skip lockInfluenceWeights
        if ( tmp[ children[ i ] ] ) {

          if ( layer[ tmp[ children[ i ] ].containerBoneId ] === undefined ) {

            layer[ tmp[ children[ i ] ].containerBoneId ] = {
              T: null,
              R: null,
              S: null
            };

          }

          layer[ tmp[ children[ i ] ].containerBoneId ][ tmp[ children[ i ] ].attr ] = tmp[ children[ i ] ];

        }

      }

      this.layers[ key ] = layer;

    }

    //Takes
    this.stacks = {};
    for ( var key in rawStacks ) {

      var layers = [];
      var children = node.searchConnectionChildren( key );
      var max = 0.0;
      var min = Number.MAX_VALUE;
      for ( var i = 0; i < children.length; ++ i ) {

        if ( children[ i ] in this.layers ) {

          layers.push( this.layers[ children[ i ] ] );

          for ( var j = 0; j < this.layers[ children[ i ] ].length; ++ j ) {

            function getMaxMin( layer ) {

              function _getMaxMin( curves ) {

                if ( curves.x ) {

                  max = curves.x.getLength() > max ? curves.x.getLength() : max;
                  min = curves.x.times[ 0 ] < min ? curves.x.times[ 0 ] : min;

                }
                if ( curves.y ) {

                  max = curves.y.getLength() > max ? curves.y.getLength() : max;
                  min = curves.y.times[ 0 ] < min ? curves.y.times[ 0 ] : min;

                }
                if ( curves.z ) {

                  max = curves.z.getLength() > max ? curves.z.getLength() : max;
                  min = curves.z.times[ 0 ] < min ? curves.z.times[ 0 ] : min;

                }

              }

              if ( layer.R ) {

                _getMaxMin( layer.R.curves );

              }
              if ( layer.S ) {

                _getMaxMin( layer.S.curves );

              }
              if ( layer.T ) {

                _getMaxMin( layer.T.curves );

              }

            }

            var layer = this.layers[ children[ i ] ][ j ];
            if ( layer ) {

              getMaxMin( layer );

            }

          }

        }

      }

      //Do we have an animation clip with an actual length?
      if ( max > min ) {

        this.stacks[ key ] = {

          name: rawStacks[ key ].attrName,
          layers: layers,
          length: max - min,
          frames: ( max - min ) * 30,

        };

      }

    }

    return this;

  };


  function Textures() {

    this.textures = {};
    //this.perGeoMap = {};

  }

  Textures.prototype.add = function ( tex ) {

    debugger;

    if ( this.textures === undefined ) {

      this.textures = [];

    }

    this.textures.push( tex );

    for ( var i = 0; i < tex.parentIds.length; ++ i ) {

      if ( this.perGeoMap[ tex.parentIds[ i ] ] === undefined ) {

        this.perGeoMap[ tex.parentIds[ i ] ] = [];

      }

      this.perGeoMap[ tex.parentIds[ i ] ].push( this.textures[ this.textures.length - 1 ] );

    }

  };

  Textures.prototype.parse = function ( node ) {

    var rawNodes = node.Objects.subNodes.Texture;

    for ( var n in rawNodes ) {

      var tex = ( new Texture() ).parse( rawNodes[ n ], node );
      this.textures[ n ] = tex;

    }

    return this;

  };

  Textures.prototype.getById = function ( id ) {

    return this.perGeoMap[ id ];

  };

  function Texture() {

    this.fileName = "";
    this.name = "";
    this.id = null;
    this.parentIds = [];

  }

  Texture.prototype.parse = function ( node, nodes ) {

    this.id = node.id;
    this.name = node.attrName;
    this.fileName = this.parseFileName( node.properties.FileName );

    this.parentIds = this.searchParents( this.id, nodes );

    return this;

  };

  // TODO: support directory
  Texture.prototype.parseFileName = function ( fname ) {

    if ( fname === undefined ) {

      return "";

    }

    // ignore directory structure, flatten path
    var splitted = fname.split( /[\\\/]/ );
    if ( splitted.length > 0 ) {

      return splitted[ splitted.length - 1 ];

    } else {

      return fname;

    }

  };

  Texture.prototype.searchParents = function ( id, nodes ) {

    var p = nodes.searchConnectionParent( id );

    return p;

  };

  function Materials() {

    this.materials = {};
    this.perGeoMap = {};

  }

  Object.assign( Materials.prototype, {

    parse: function ( node ) {

      var rawNodes = node.Objects.subNodes.Material;

      for ( var n in rawNodes ) {

        var mat = ( new Material() ).parse( rawNodes[ n ], node );
        this.materials[ n ] = mat;

      }

      return this;

    }

  } );

  function Material() {

    this.fileName = "";
    this.name = "";
    this.id = null;
    this.parentIds = [];

  }

  Object.assign( Material.prototype, {

    parse: function ( node, nodes ) {

      this.id = node.id;
      this.name = node.attrName;
      this.type = node.properties.ShadingModel;

      this.parameters = this.parseParameters( node.properties );

      this.parentIds = this.searchParents( this.id, nodes );

      return this;

    },

    parseParameters: function ( properties ) {

      var parameters = {};

      //TODO: Missing parameters:
      // - Ambient
      // - MultiLayer
      // - ShininessExponent (Same vals as Shininess)
      // - Specular (Same vals as SpecularColor)
      // - TransparencyFactor (Maybe same as Opacity?).

      if ( properties.Diffuse ) {

        parameters.color = new THREE.Color().fromArray( [ parseFloat( properties.Diffuse.value.x ), parseFloat( properties.Diffuse.value.y ), parseFloat( properties.Diffuse.value.z ) ] );

      }
      if ( properties.Specular ) {

        parameters.specular = new THREE.Color().fromArray( [ parseFloat( properties.Specular.value.x ), parseFloat( properties.Specular.value.y ), parseFloat( properties.Specular.value.z ) ] );

      }
      if ( properties.Shininess ) {

        parameters.shininess = properties.Shininess.value;

      }
      if ( properties.Emissive ) {

        parameters.emissive = new THREE.Color().fromArray( [ parseFloat( properties.Emissive.value.x ), parseFloat( properties.Emissive.value.y ), parseFloat( properties.Emissive.value.z ) ] );

      }
      if ( properties.EmissiveFactor ) {

        parameters.emissiveIntensity = properties.EmissiveFactor.value;

      }
      if ( properties.Reflectivity ) {

        parameters.reflectivity = properties.Reflectivity.value;

      }
      if ( properties.Opacity ) {

        parameters.opacity = properties.Opacity.value;

      }
      if ( parameters.opacity < 1.0 ) {

        parameters.transparent = true;

      }

      //Assigning textures


      return parameters;

    },

    searchParents: function ( id, nodes ) {

      return nodes.searchConnectionParent( id );

    }

  } );


  /* --------------------------------------------------------------------- */
  /* --------------------------------------------------------------------- */
  /* --------------------------------------------------------------------- */
  /* --------------------------------------------------------------------- */

  // LayerElementUV: 0 {
  //  Version: 101
  //  Name: "Texture_Projection"
  //  MappingInformationType: "ByPolygonVertex"
  //  ReferenceInformationType: "IndexToDirect"
  //  UV: *1746 {
  //  UVIndex: *7068 {
  //
  //  The order of the uvs is given by the UVIndex property.
  function parse_Data_ByPolygonVertex_IndexToDirect( node, indices, itemSize ) {

    var res = [];

    for ( var i = 0; i < indices.length; ++ i ) {

      for ( var j = 0; j < itemSize; ++ j ) {

        res.push( node[ ( indices[ i ] * itemSize ) + j ] );

      }

    }

    return res;

  }


  // what want:　normal per vertex, order vertice
  // i have: normal per polygon
  // i have: indice per polygon
  function parse_Data_ByPolygonVertex_Direct( node, indices, strides, itemSize ) {

    // *21204 > 3573
    // Geometry: 690680816, "Geometry::", "Mesh" {
    //  Vertices: *3573 {
    //  PolygonVertexIndex: *7068 {

    var tmp = [];
    var currentIndex = 0;

    // first: sort to per vertex
    for ( var i = 0; i < indices.length; ++ i ) {

      tmp[ indices[ i ] ] = [];

      // TODO: duped entry? blend or something?
      for ( var s = 0; s < itemSize; ++ s ) {

        tmp[ indices[ i ] ][ s ] = node[ currentIndex + s ];

      }

      currentIndex += itemSize;

    }

    // second: expand x,y,z into serial array
    var res = [];
    for ( var jj = 0; jj < tmp.length; ++ jj ) {

      if ( tmp[ jj ] === undefined ) {

        continue;

      }

      for ( var t = 0; t < itemSize; ++ t ) {

        if ( tmp[ jj ][ t ] === undefined ) {

          continue;

        }
        res.push( tmp[ jj ][ t ] );

      }

    }

    return res;

  }

  // convert from by polygon(vert) data into by verts data
  function mapByPolygonVertexToByVertex( data, indices, stride ) {

    var tmp = {};
    var res = [];
    var max = 0;

    for ( var i = 0; i < indices.length; ++ i ) {

      if ( indices[ i ] in tmp ) {

        continue;

      }

      tmp[ indices[ i ] ] = {};

      for ( var j = 0; j < stride; ++ j ) {

        tmp[ indices[ i ] ][ j ] = data[ i * stride + j ];

      }

      max = max < indices[ i ] ? indices[ i ] : max;

    }

    try {

      for ( i = 0; i <= max; i ++ ) {

        for ( var s = 0; s < stride; s ++ ) {

          res.push( tmp[ i ][ s ] );

        }

      }

    } catch ( e ) {
      //console.log( max );
      //console.log( tmp );
      //console.log( i );
      //console.log( e );
    }

    return res;

  }

  // AUTODESK uses broken clock. i guess
  function FBXTimeToSeconds( adskTime ) {

    return adskTime / 46186158000;

  }

  function degToRad( degrees ) {

    return degrees * Math.PI / 180;

  }

  function quatFromVec( x, y, z ) {

    var euler = new THREE.Euler( x, y, z, 'ZYX' );
    var quat = new THREE.Quaternion();
    quat.setFromEuler( euler );

    return quat;

  }

  function parseArrayToInt( string ) {

    return string.split( ',' ).map( function ( element ) {

      return parseInt( element );

    } );

  }

  function parseArrayToFloat( string ) {

    return string.split( ',' ).map( function ( element ) {

      return parseFloat( element );

    } );

  }

  function parseArrayToRadians( string ) {

    return string.split( ',' ).map( function ( element ) {

      return degToRad( parseFloat( element ) );

    } );

  }

  function parseArrayToMatrix( string ) {

    var arr = parseArrayToFloat( string );
    return new THREE.Matrix4().fromArray( arr );

  }

} )();



/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports = Object.assign(function GamepadButton () {}, {
	FACE_1: 0,
	FACE_2: 1,
	FACE_3: 2,
	FACE_4: 3,

	L_SHOULDER_1: 4,
	R_SHOULDER_1: 5,
	L_SHOULDER_2: 6,
	R_SHOULDER_2: 7,

	SELECT: 8,
	START: 9,

	DPAD_UP: 12,
	DPAD_DOWN: 13,
	DPAD_LEFT: 14,
	DPAD_RIGHT: 15,

	VENDOR: 16,
});


/***/ }),
/* 242 */
/***/ (function(module, exports) {

function GamepadButtonEvent (type, index, details) {
  this.type = type;
  this.index = index;
  this.pressed = details.pressed;
  this.value = details.value;
}

module.exports = GamepadButtonEvent;


/***/ }),
/* 243 */
/***/ (function(module, exports) {

/**
 * @author Wei Meng / http://about.me/menway
 *
 * Description: A THREE loader for PLY ASCII files (known as the Polygon File Format or the Stanford Triangle Format).
 *
 *
 * Limitations: ASCII decoding assumes file is UTF-8.
 *
 * Usage:
 *  var loader = new THREE.PLYLoader();
 *  loader.load('./models/ply/ascii/dolphins.ply', function (geometry) {
 *
 *    scene.add( new THREE.Mesh( geometry ) );
 *
 *  } );
 *
 * If the PLY file uses non standard property names, they can be mapped while
 * loading. For example, the following maps the properties
 * “diffuse_(red|green|blue)” in the file to standard color names.
 *
 * loader.setPropertyNameMapping( {
 *  diffuse_red: 'red',
 *  diffuse_green: 'green',
 *  diffuse_blue: 'blue'
 * } );
 *
 */

module.exports = THREE.PLYLoader = function ( manager ) {

  this.manager = ( manager !== undefined ) ? manager : THREE.DefaultLoadingManager;

  this.propertyNameMapping = {};

};

THREE.PLYLoader.prototype = {

  constructor: THREE.PLYLoader,

  load: function ( url, onLoad, onProgress, onError ) {

    var scope = this;

    var loader = new THREE.XHRLoader( this.manager );
    loader.setResponseType( 'arraybuffer' );
    loader.load( url, function ( text ) {

      onLoad( scope.parse( text ) );

    }, onProgress, onError );

  },

  setPropertyNameMapping: function ( mapping ) {

    this.propertyNameMapping = mapping;

  },

  bin2str: function ( buf ) {

    var array_buffer = new Uint8Array( buf );
    var str = '';
    for ( var i = 0; i < buf.byteLength; i ++ ) {

      str += String.fromCharCode( array_buffer[ i ] ); // implicitly assumes little-endian

    }

    return str;

  },

  isASCII: function( data ) {

    var header = this.parseHeader( this.bin2str( data ) );

    return header.format === "ascii";

  },

  parse: function ( data ) {

    if ( data instanceof ArrayBuffer ) {

      return this.isASCII( data )
        ? this.parseASCII( this.bin2str( data ) )
        : this.parseBinary( data );

    } else {

      return this.parseASCII( data );

    }

  },

  parseHeader: function ( data ) {

    var patternHeader = /ply([\s\S]*)end_header\s/;
    var headerText = "";
    var headerLength = 0;
    var result = patternHeader.exec( data );
    if ( result !== null ) {

      headerText = result [ 1 ];
      headerLength = result[ 0 ].length;

    }

    var header = {
      comments: [],
      elements: [],
      headerLength: headerLength
    };

    var lines = headerText.split( '\n' );
    var currentElement = undefined;
    var lineType, lineValues;

    function make_ply_element_property( propertValues, propertyNameMapping ) {

      var property = {
        type: propertValues[ 0 ]
      };

      if ( property.type === 'list' ) {

        property.name = propertValues[ 3 ];
        property.countType = propertValues[ 1 ];
        property.itemType = propertValues[ 2 ];

      } else {

        property.name = propertValues[ 1 ];

      }

      if ( property.name in propertyNameMapping ) {

        property.name = propertyNameMapping[ property.name ];

      }

      return property;

    }

    for ( var i = 0; i < lines.length; i ++ ) {

      var line = lines[ i ];
      line = line.trim();
      if ( line === "" ) {

        continue;

      }
      lineValues = line.split( /\s+/ );
      lineType = lineValues.shift();
      line = lineValues.join( " " );

      switch ( lineType ) {

      case "format":

        header.format = lineValues[ 0 ];
        header.version = lineValues[ 1 ];

        break;

      case "comment":

        header.comments.push( line );

        break;

      case "element":

        if ( ! ( currentElement === undefined ) ) {

          header.elements.push( currentElement );

        }

        currentElement = Object();
        currentElement.name = lineValues[ 0 ];
        currentElement.count = parseInt( lineValues[ 1 ] );
        currentElement.properties = [];

        break;

      case "property":

        currentElement.properties.push( make_ply_element_property( lineValues, this.propertyNameMapping ) );

        break;


      default:

        console.log( "unhandled", lineType, lineValues );

      }

    }

    if ( ! ( currentElement === undefined ) ) {

      header.elements.push( currentElement );

    }

    return header;

  },

  parseASCIINumber: function ( n, type ) {

    switch ( type ) {

    case 'char': case 'uchar': case 'short': case 'ushort': case 'int': case 'uint':
    case 'int8': case 'uint8': case 'int16': case 'uint16': case 'int32': case 'uint32':

      return parseInt( n );

    case 'float': case 'double': case 'float32': case 'float64':

      return parseFloat( n );

    }

  },

  parseASCIIElement: function ( properties, line ) {

    var values = line.split( /\s+/ );

    var element = Object();

    for ( var i = 0; i < properties.length; i ++ ) {

      if ( properties[ i ].type === "list" ) {

        var list = [];
        var n = this.parseASCIINumber( values.shift(), properties[ i ].countType );

        for ( var j = 0; j < n; j ++ ) {

          list.push( this.parseASCIINumber( values.shift(), properties[ i ].itemType ) );

        }

        element[ properties[ i ].name ] = list;

      } else {

        element[ properties[ i ].name ] = this.parseASCIINumber( values.shift(), properties[ i ].type );

      }

    }

    return element;

  },

  parseASCII: function ( data ) {

    // PLY ascii format specification, as per http://en.wikipedia.org/wiki/PLY_(file_format)

    var geometry = new THREE.Geometry();

    var result;

    var header = this.parseHeader( data );

    var patternBody = /end_header\s([\s\S]*)$/;
    var body = "";
    if ( ( result = patternBody.exec( data ) ) !== null ) {

      body = result [ 1 ];

    }

    var lines = body.split( '\n' );
    var currentElement = 0;
    var currentElementCount = 0;
    geometry.useColor = false;

    for ( var i = 0; i < lines.length; i ++ ) {

      var line = lines[ i ];
      line = line.trim();
      if ( line === "" ) {

        continue;

      }

      if ( currentElementCount >= header.elements[ currentElement ].count ) {

        currentElement ++;
        currentElementCount = 0;

      }

      var element = this.parseASCIIElement( header.elements[ currentElement ].properties, line );

      this.handleElement( geometry, header.elements[ currentElement ].name, element );

      currentElementCount ++;

    }

    return this.postProcess( geometry );

  },

  postProcess: function ( geometry ) {

    if ( geometry.useColor ) {

      for ( var i = 0; i < geometry.faces.length; i ++ ) {

        geometry.faces[ i ].vertexColors = [
          geometry.colors[ geometry.faces[ i ].a ],
          geometry.colors[ geometry.faces[ i ].b ],
          geometry.colors[ geometry.faces[ i ].c ]
        ];

      }

      geometry.elementsNeedUpdate = true;

    }

    geometry.computeBoundingSphere();

    return geometry;

  },

  handleElement: function ( geometry, elementName, element ) {

    if ( elementName === "vertex" ) {

      geometry.vertices.push(
        new THREE.Vector3( element.x, element.y, element.z )
      );

      if ( 'red' in element && 'green' in element && 'blue' in element ) {

        geometry.useColor = true;

        var color = new THREE.Color();
        color.setRGB( element.red / 255.0, element.green / 255.0, element.blue / 255.0 );
        geometry.colors.push( color );

      }

    } else if ( elementName === "face" ) {

      // BEGIN: Edits by donmccurdy.
      var vertex_indices = element.vertex_indices || element.vertex_index;
      // END: Edits by donmccurdy.

      if ( vertex_indices.length === 3 ) {

        geometry.faces.push(
          new THREE.Face3( vertex_indices[ 0 ], vertex_indices[ 1 ], vertex_indices[ 2 ] )
        );

      } else if ( vertex_indices.length === 4 ) {

        geometry.faces.push(
          new THREE.Face3( vertex_indices[ 0 ], vertex_indices[ 1 ], vertex_indices[ 3 ] ),
          new THREE.Face3( vertex_indices[ 1 ], vertex_indices[ 2 ], vertex_indices[ 3 ] )
        );

      }

    }

  },

  binaryRead: function ( dataview, at, type, little_endian ) {

    switch ( type ) {

      // corespondences for non-specific length types here match rply:
    case 'int8':    case 'char':   return [ dataview.getInt8( at ), 1 ];

    case 'uint8':   case 'uchar':  return [ dataview.getUint8( at ), 1 ];

    case 'int16':   case 'short':  return [ dataview.getInt16( at, little_endian ), 2 ];

    case 'uint16':  case 'ushort': return [ dataview.getUint16( at, little_endian ), 2 ];

    case 'int32':   case 'int':    return [ dataview.getInt32( at, little_endian ), 4 ];

    case 'uint32':  case 'uint':   return [ dataview.getUint32( at, little_endian ), 4 ];

    case 'float32': case 'float':  return [ dataview.getFloat32( at, little_endian ), 4 ];

    case 'float64': case 'double': return [ dataview.getFloat64( at, little_endian ), 8 ];

    }

  },

  binaryReadElement: function ( dataview, at, properties, little_endian ) {

    var element = Object();
    var result, read = 0;

    for ( var i = 0; i < properties.length; i ++ ) {

      if ( properties[ i ].type === "list" ) {

        var list = [];

        result = this.binaryRead( dataview, at + read, properties[ i ].countType, little_endian );
        var n = result[ 0 ];
        read += result[ 1 ];

        for ( var j = 0; j < n; j ++ ) {

          result = this.binaryRead( dataview, at + read, properties[ i ].itemType, little_endian );
          list.push( result[ 0 ] );
          read += result[ 1 ];

        }

        element[ properties[ i ].name ] = list;

      } else {

        result = this.binaryRead( dataview, at + read, properties[ i ].type, little_endian );
        element[ properties[ i ].name ] = result[ 0 ];
        read += result[ 1 ];

      }

    }

    return [ element, read ];

  },

  parseBinary: function ( data ) {

    var geometry = new THREE.Geometry();

    var header = this.parseHeader( this.bin2str( data ) );
    var little_endian = ( header.format === "binary_little_endian" );
    var body = new DataView( data, header.headerLength );
    var result, loc = 0;

    for ( var currentElement = 0; currentElement < header.elements.length; currentElement ++ ) {

      for ( var currentElementCount = 0; currentElementCount < header.elements[ currentElement ].count; currentElementCount ++ ) {

        result = this.binaryReadElement( body, loc, header.elements[ currentElement ].properties, little_endian );
        loc += result[ 1 ];
        var element = result[ 0 ];

        this.handleElement( geometry, header.elements[ currentElement ].name, element );

      }

    }

    return this.postProcess( geometry );

  }

};


/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports = {
	"size": 5,
	"cellSize": 10,
	"extrudeSettings": {
		"amount": 1,
		"bevelEnabled": true,
		"bevelSegments": 1,
		"steps": 1,
		"bevelSize": 0.5,
		"bevelThickness": 0.5
	},
	"autogenerated": true,
	"cells": [
		{
			"q": -1,
			"r": 0,
			"s": 1,
			"h": 1,
			"walkable": true,
			"userData": {}
		},
		{
			"q": 0,
			"r": -1,
			"s": 1,
			"h": 1,
			"walkable": true,
			"userData": {}
		},
		{
			"q": 0,
			"r": 0,
			"s": 0,
			"h": 1,
			"walkable": true,
			"userData": {}
		},
		{
			"q": 1,
			"r": -1,
			"s": 0,
			"h": 1,
			"walkable": true,
			"userData": {}
		},
		{
			"q": -1,
			"r": 1,
			"s": 0,
			"h": 0,
			"walkable": true,
			"userData": {}
		},
		{
			"q": 0,
			"r": 1,
			"s": -1,
			"h": 0,
			"walkable": true,
			"userData": {}
		},
		{
			"q": 1,
			"r": 0,
			"s": -1,
			"h": 0,
			"walkable": true,
			"userData": {}
		}
	]
};

/***/ }),
/* 245 */
/***/ (function(module, exports) {

/**
 * Source: https://github.com/Adobe-Marketing-Cloud/fetch-script
 */

function getScriptId() {
  return 'script_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
}

function createScript(url, id) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.id = id;
  script.src = url;

  return script;
}

function removeScript(id) {
  const script = document.getElementById(id);
  const parent = script.parentNode;

  try {
    parent && parent.removeChild(script);
  } catch (e) {
    // ignore
  }
}

function appendScript(script) {
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(script, firstScript);
}

function fetchScriptInternal(url, options, Promise) {
  return new Promise(function(resolve, reject) {
    const timeout = options.timeout || 5000;
    const scriptId = getScriptId();
    const script = createScript(url, scriptId);

    const timeoutId = setTimeout(function() {
      reject(new Error('Script request to ' + url + ' timed out'));

      removeScript(scriptId);
    }, timeout);

    const disableTimeout = function(timeoutId) { clearTimeout(timeoutId); };

    script.addEventListener('load', function(e) {
      resolve({ok: true});

      disableTimeout(timeoutId);
      removeScript(scriptId);
    });

    script.addEventListener('error', function(e) {
      reject(new Error('Script request to ' + url + ' failed ' + e));

      disableTimeout(timeoutId);
      removeScript(scriptId);
    });

    appendScript(script);
  });
}

function fetchScript(settings) {
  settings = settings || {};
  return function (url, options) {
    options = options || {};
    return fetchScriptInternal(url, options, settings.Promise || Promise);
  };
}

module.exports = fetchScript;


/***/ }),
/* 246 */
/***/ (function(module, exports) {

var vg=module.exports={VERSION:"0.1.1",PI:Math.PI,TAU:2*Math.PI,DEG_TO_RAD:.0174532925,RAD_TO_DEG:57.2957795,SQRT3:Math.sqrt(3),TILE:"tile",ENT:"entity",STR:"structure",HEX:"hex",SQR:"square",ABS:"abstract"};vg.Board=function(e,t){if(!e)throw new Error("You must pass in a grid system for the board to use.");this.tiles=[],this.tileGroup=null,this.group=new THREE.Object3D,this.grid=null,this.overlay=null,this.finder=new vg.AStarFinder(t),vg.Loader.init(),this.setGrid(e)},vg.Board.prototype={setEntityOnTile:function(e,t){var i=this.grid.cellToPixel(t.cell);e.position.copy(i),e.position.y+=e.heightOffset||0,e.tile&&(e.tile.entity=null),e.tile=t,t.entity=e},addTile:function(e){var t=this.tiles.indexOf(e);-1===t&&(this.tiles.push(e),this.snapTileToGrid(e),e.position.y=0,this.tileGroup.add(e.mesh),this.grid.add(e.cell),e.cell.tile=e)},removeTile:function(e){if(e){var t=this.tiles.indexOf(e);this.grid.remove(e.cell),-1!==t&&this.tiles.splice(t,1),e.dispose()}},removeAllTiles:function(){if(this.tileGroup)for(var e=this.tileGroup.children,t=0;t<e.length;t++)this.tileGroup.remove(e[t])},getTileAtCell:function(e){var t=this.grid.cellToHash(e);return e.tile||("undefined"!=typeof this.grid.cells[t]?this.grid.cells[t].tile:null)},snapToGrid:function(e){var t=this.grid.pixelToCell(e);e.copy(this.grid.cellToPixel(t))},snapTileToGrid:function(e){if(e.cell)e.position.copy(this.grid.cellToPixel(e.cell));else{var t=this.grid.pixelToCell(e.position);e.position.copy(this.grid.cellToPixel(t))}return e},getRandomTile:function(){var e=vg.Tools.randomInt(0,this.tiles.length-1);return this.tiles[e]},findPath:function(e,t,i){return this.finder.findPath(e.cell,t.cell,i,this.grid)},setGrid:function(e){this.group.remove(this.tileGroup),this.grid&&e!==this.grid&&(this.removeAllTiles(),this.tiles.forEach(function(e){this.grid.remove(e.cell),e.dispose()}),this.grid.dispose()),this.grid=e,this.tiles=[],this.tileGroup=new THREE.Object3D,this.group.add(this.tileGroup)},generateOverlay:function(e){var t=new THREE.LineBasicMaterial({color:0,opacity:.3});this.overlay&&this.group.remove(this.overlay),this.overlay=new THREE.Object3D,this.grid.generateOverlay(e,this.overlay,t),this.group.add(this.overlay)},generateTilemap:function(e){this.reset();var t=this.grid.generateTiles(e);this.tiles=t,this.tileGroup=new THREE.Object3D;for(var i=0;i<t.length;i++)this.tileGroup.add(t[i].mesh);this.group.add(this.tileGroup)},reset:function(){this.removeAllTiles(),this.tileGroup&&this.group.remove(this.tileGroup)}},vg.Board.prototype.constructor=vg.Board,vg.Cell=function(e,t,i,s){this.q=e||0,this.r=t||0,this.s=i||0,this.h=s||1,this.tile=null,this.userData={},this.walkable=!0,this._calcCost=0,this._priority=0,this._visited=!1,this._parent=null,this.uniqueID=vg.LinkedList.generateID()},vg.Cell.prototype={set:function(e,t,i){return this.q=e,this.r=t,this.s=i,this},copy:function(e){return this.q=e.q,this.r=e.r,this.s=e.s,this.h=e.h,this.tile=e.tile||null,this.userData=e.userData||{},this.walkable=e.walkable,this},add:function(e){return this.q+=e.q,this.r+=e.r,this.s+=e.s,this},equals:function(e){return this.q===e.q&&this.r===e.r&&this.s===e.s}},vg.Cell.prototype.constructor=vg.Cell,vg.HexGrid=function(e){e=e||{},this.type=vg.HEX,this.size=5,this.cellSize="undefined"==typeof e.cellSize?10:e.cellSize,this.cells={},this.numCells=0,this.extrudeSettings=null,this.autogenerated=!1;var t,i=[];for(t=0;6>t;t++)i.push(this._createVertex(t));for(this.cellShape=new THREE.Shape,this.cellShape.moveTo(i[0].x,i[0].y),t=1;6>t;t++)this.cellShape.lineTo(i[t].x,i[t].y);this.cellShape.lineTo(i[0].x,i[0].y),this.cellShape.autoClose=!0,this.cellGeo=new THREE.Geometry,this.cellGeo.vertices=i,this.cellGeo.verticesNeedUpdate=!0,this.cellShapeGeo=new THREE.ShapeGeometry(this.cellShape),this._cellWidth=2*this.cellSize,this._cellLength=.5*vg.SQRT3*this._cellWidth,this._hashDelimeter=".",this._directions=[new vg.Cell(1,-1,0),new vg.Cell(1,0,-1),new vg.Cell(0,1,-1),new vg.Cell(-1,1,0),new vg.Cell(-1,0,1),new vg.Cell(0,-1,1)],this._diagonals=[new vg.Cell(2,-1,-1),new vg.Cell(1,1,-2),new vg.Cell(-1,2,-1),new vg.Cell(-2,1,1),new vg.Cell(-1,-1,2),new vg.Cell(1,-2,1)],this._list=[],this._vec3=new THREE.Vector3,this._cel=new vg.Cell,this._conversionVec=new THREE.Vector3,this._geoCache=[],this._matCache=[]},vg.HexGrid.TWO_THIRDS=2/3,vg.HexGrid.prototype={cellToPixel:function(e){return this._vec3.x=e.q*this._cellWidth*.75,this._vec3.y=e.h,this._vec3.z=-((e.s-e.r)*this._cellLength*.5),this._vec3},pixelToCell:function(e){var t=e.x*(vg.HexGrid.TWO_THIRDS/this.cellSize),i=(-e.x/3+vg.SQRT3/3*e.z)/this.cellSize;return this._cel.set(t,i,-t-i),this._cubeRound(this._cel)},getCellAt:function(e){var t=e.x*(vg.HexGrid.TWO_THIRDS/this.cellSize),i=(-e.x/3+vg.SQRT3/3*e.z)/this.cellSize;return this._cel.set(t,i,-t-i),this._cubeRound(this._cel),this.cells[this.cellToHash(this._cel)]},getNeighbors:function(e,t,i){var s,n,l=this._directions.length;for(this._list.length=0,s=0;l>s;s++)this._cel.copy(e),this._cel.add(this._directions[s]),n=this.cells[this.cellToHash(this._cel)],!n||i&&!i(e,n)||this._list.push(n);if(t)for(s=0;l>s;s++)this._cel.copy(e),this._cel.add(this._diagonals[s]),n=this.cells[this.cellToHash(this._cel)],!n||i&&!i(e,n)||this._list.push(n);return this._list},getRandomCell:function(){var e,t=0,i=vg.Tools.randomInt(0,this.numCells);for(e in this.cells){if(t===i)return this.cells[e];t++}return this.cells[e]},cellToHash:function(e){return e.q+this._hashDelimeter+e.r+this._hashDelimeter+e.s},distance:function(e,t){var i=Math.max(Math.abs(e.q-t.q),Math.abs(e.r-t.r),Math.abs(e.s-t.s));return i+=t.h-e.h},clearPath:function(){var e,t;for(e in this.cells)t=this.cells[e],t._calcCost=0,t._priority=0,t._parent=null,t._visited=!1},traverse:function(e){var t;for(t in this.cells)e(this.cells[t])},generateTile:function(e,t,i){var s=Math.abs(e.h);1>s&&(s=1);var n=this._geoCache[s];n||(this.extrudeSettings.amount=s,n=new THREE.ExtrudeGeometry(this.cellShape,this.extrudeSettings),this._geoCache[s]=n);var l=new vg.Tile({size:this.cellSize,scale:t,cell:e,geometry:n,material:i});return e.tile=l,l},generateTiles:function(e){e=e||{};var t=[],i={tileScale:.95,cellSize:this.cellSize,material:null,extrudeSettings:{amount:1,bevelEnabled:!0,bevelSegments:1,steps:1,bevelSize:.5,bevelThickness:.5}};i=vg.Tools.merge(i,e),this.cellSize=i.cellSize,this._cellWidth=2*this.cellSize,this._cellLength=.5*vg.SQRT3*this._cellWidth,this.autogenerated=!0,this.extrudeSettings=i.extrudeSettings;var s,n,l;for(s in this.cells)l=this.cells[s],n=this.generateTile(l,i.tileScale,i.material),n.position.copy(this.cellToPixel(l)),n.position.y=0,t.push(n);return t},generateTilePoly:function(e){e||(e=new THREE.MeshBasicMaterial({color:2405631}));var t=new THREE.Mesh(this.cellShapeGeo,e);return this._vec3.set(1,0,0),t.rotateOnAxis(this._vec3,vg.PI/2),t},generate:function(e){e=e||{},this.size="undefined"==typeof e.size?this.size:e.size;var t,i,s,n;for(t=-this.size;t<this.size+1;t++)for(i=-this.size;i<this.size+1;i++)s=-t-i,Math.abs(t)<=this.size&&Math.abs(i)<=this.size&&Math.abs(s)<=this.size&&(n=new vg.Cell(t,i,s),this.add(n))},generateOverlay:function(e,t,i){var s,n,l,r=this.cellShape.createPointsGeometry();for(s=-e;e+1>s;s++)for(n=-e;e+1>n;n++)if(l=-s-n,Math.abs(s)<=e&&Math.abs(n)<=e&&Math.abs(l)<=e){this._cel.set(s,n,l);var h=new THREE.Line(r,i);h.position.copy(this.cellToPixel(this._cel)),h.rotation.x=90*vg.DEG_TO_RAD,t.add(h)}},add:function(e){var t=this.cellToHash(e);if(!this.cells[t])return this.cells[t]=e,this.numCells++,e},remove:function(e){var t=this.cellToHash(e);this.cells[t]&&(delete this.cells[t],this.numCells--)},dispose:function(){this.cells=null,this.numCells=0,this.cellShape=null,this.cellGeo.dispose(),this.cellGeo=null,this.cellShapeGeo.dispose(),this.cellShapeGeo=null,this._list=null,this._vec3=null,this._conversionVec=null,this._geoCache=null,this._matCache=null},load:function(e,t,i){var s=this;vg.Tools.getJSON({url:e,callback:function(e){s.fromJSON(e),t.call(i||null,e)},cache:!1,scope:s})},fromJSON:function(e){var t,i,s=e.cells;for(this.cells={},this.numCells=0,this.size=e.size,this.cellSize=e.cellSize,this._cellWidth=2*this.cellSize,this._cellLength=.5*vg.SQRT3*this._cellWidth,this.extrudeSettings=e.extrudeSettings,this.autogenerated=e.autogenerated,t=0;t<s.length;t++)i=new vg.Cell,i.copy(s[t]),this.add(i)},toJSON:function(){var e,t,i={size:this.size,cellSize:this.cellSize,extrudeSettings:this.extrudeSettings,autogenerated:this.autogenerated},s=[];for(t in this.cells)e=this.cells[t],s.push({q:e.q,r:e.r,s:e.s,h:e.h,walkable:e.walkable,userData:e.userData});return i.cells=s,i},_createVertex:function(e){var t=vg.TAU/6*e;return new THREE.Vector3(this.cellSize*Math.cos(t),this.cellSize*Math.sin(t),0)},_cubeRound:function(e){var t=Math.round(e.q),i=Math.round(e.r),s=Math.round(e.s),n=Math.abs(t-e.q),l=Math.abs(i-e.r),r=Math.abs(s-e.s);return n>l&&n>r?t=-i-s:l>r?i=-t-s:s=-t-i,this._cel.set(t,i,s)}},vg.HexGrid.prototype.constructor=vg.HexGrid,vg.SqrGrid=function(e){e=e||{},this.type=vg.SQR,this.size=5,this.cellSize="undefined"==typeof e.cellSize?10:e.cellSize,this.cells={},this.numCells=0,this.extrudeSettings=null,this.autogenerated=!1;var t=[];t.push(new THREE.Vector3),t.push(new THREE.Vector3(-this.cellSize,this.cellSize)),t.push(new THREE.Vector3(this.cellSize,this.cellSize)),t.push(new THREE.Vector3(this.cellSize,-this.cellSize)),this.cellShape=new THREE.Shape,this.cellShape.moveTo(-this.cellSize,-this.cellSize),this.cellShape.lineTo(-this.cellSize,this.cellSize),this.cellShape.lineTo(this.cellSize,this.cellSize),this.cellShape.lineTo(this.cellSize,-this.cellSize),this.cellShape.lineTo(-this.cellSize,-this.cellSize),this.cellGeo=new THREE.Geometry,this.cellGeo.vertices=t,this.cellGeo.verticesNeedUpdate=!0,this.cellShapeGeo=new THREE.ShapeGeometry(this.cellShape),this._fullCellSize=2*this.cellSize,this._hashDelimeter=".",this._directions=[new vg.Cell(1,0,0),new vg.Cell(0,-1,0),new vg.Cell(-1,0,0),new vg.Cell(0,1,0)],this._diagonals=[new vg.Cell(-1,-1,0),new vg.Cell(-1,1,0),new vg.Cell(1,1,0),new vg.Cell(1,-1,0)],this._list=[],this._vec3=new THREE.Vector3,this._cel=new vg.Cell,this._conversionVec=new THREE.Vector3,this._geoCache=[],this._matCache=[]},vg.SqrGrid.prototype={cellToPixel:function(e){return this._vec3.x=e.q*this._fullCellSize,this._vec3.y=e.h,this._vec3.z=e.r*this._fullCellSize,this._vec3},pixelToCell:function(e){var t=Math.round(e.x/this._fullCellSize),i=Math.round(e.z/this._fullCellSize);return this._cel.set(t,i,0)},getCellAt:function(e){var t=Math.round(e.x/this._fullCellSize),i=Math.round(e.z/this._fullCellSize);return this._cel.set(t,i),this.cells[this.cellToHash(this._cel)]},getNeighbors:function(e,t,i){var s,n,l=this._directions.length;for(this._list.length=0,s=0;l>s;s++)this._cel.copy(e),this._cel.add(this._directions[s]),n=this.cells[this.cellToHash(this._cel)],!n||i&&!i(e,n)||this._list.push(n);if(t)for(s=0;l>s;s++)this._cel.copy(e),this._cel.add(this._diagonals[s]),n=this.cells[this.cellToHash(this._cel)],!n||i&&!i(e,n)||this._list.push(n);return this._list},getRandomCell:function(){var e,t=0,i=vg.Tools.randomInt(0,this.numCells);for(e in this.cells){if(t===i)return this.cells[e];t++}return this.cells[e]},cellToHash:function(e){return e.q+this._hashDelimeter+e.r},distance:function(e,t){var i=Math.max(Math.abs(e.q-t.q),Math.abs(e.r-t.r));return i+=t.h-e.h},clearPath:function(){var e,t;for(e in this.cells)t=this.cells[e],t._calcCost=0,t._priority=0,t._parent=null,t._visited=!1},traverse:function(e){var t;for(t in this.cells)e(this.cells[t])},generateTile:function(e,t,i){var s=Math.abs(e.h);1>s&&(s=1);var n=this._geoCache[s];n||(this.extrudeSettings.amount=s,n=new THREE.ExtrudeGeometry(this.cellShape,this.extrudeSettings),this._geoCache[s]=n);var l=new vg.Tile({size:this.cellSize,scale:t,cell:e,geometry:n,material:i});return e.tile=l,l},generateTiles:function(e){e=e||{};var t=[],i={tileScale:.95,cellSize:this.cellSize,material:null,extrudeSettings:{amount:1,bevelEnabled:!0,bevelSegments:1,steps:1,bevelSize:.5,bevelThickness:.5}};i=vg.Tools.merge(i,e),this.cellSize=i.cellSize,this._fullCellSize=2*this.cellSize,this.autogenerated=!0,this.extrudeSettings=i.extrudeSettings;var s,n,l;for(s in this.cells)l=this.cells[s],n=this.generateTile(l,i.tileScale,i.material),n.position.copy(this.cellToPixel(l)),n.position.y=0,t.push(n);return t},generateTilePoly:function(e){e||(e=new THREE.MeshBasicMaterial({color:2405631}));var t=new THREE.Mesh(this.cellShapeGeo,e);return this._vec3.set(1,0,0),t.rotateOnAxis(this._vec3,vg.PI/2),t},generate:function(e){e=e||{},this.size="undefined"==typeof e.size?this.size:e.size;var t,i,s,n=Math.ceil(this.size/2);for(t=-n;n>t;t++)for(i=-n;n>i;i++)s=new vg.Cell(t,i+1),this.add(s)},generateOverlay:function(e,t,i){var s,n,l=Math.ceil(e/2);for(s=-l;l>s;s++)for(n=-l;l>n;n++){this._cel.set(s,n);var r=new THREE.Line(this.cellGeo,i);r.position.copy(this.cellToPixel(this._cel)),r.rotation.x=90*vg.DEG_TO_RAD,t.add(r)}},add:function(e){var t=this.cellToHash(e);if(!this.cells[t])return this.cells[t]=e,this.numCells++,e},remove:function(e){var t=this.cellToHash(e);this.cells[t]&&(delete this.cells[t],this.numCells--)},dispose:function(){this.cells=null,this.numCells=0,this.cellShape=null,this.cellGeo.dispose(),this.cellGeo=null,this.cellShapeGeo.dispose(),this.cellShapeGeo=null,this._list=null,this._vec3=null,this._conversionVec=null,this._geoCache=null,this._matCache=null},load:function(e,t,i){vg.Tools.getJSON({url:e,callback:function(e){this.fromJSON(e),t.call(i||null,e)},cache:!1,scope:this})},fromJSON:function(e){var t,i,s=e.cells;for(this.cells={},this.numCells=0,this.size=e.size,this.cellSize=e.cellSize,this._fullCellSize=2*this.cellSize,this.extrudeSettings=e.extrudeSettings,this.autogenerated=e.autogenerated,t=0;t<s.length;t++)i=new vg.Cell,i.copy(s[t]),this.add(i)},toJSON:function(){var e,t,i={size:this.size,cellSize:this.cellSize,extrudeSettings:this.extrudeSettings,autogenerated:this.autogenerated},s=[];for(t in this.cells)e=this.cells[t],s.push({q:e.q,r:e.r,s:e.s,h:e.h,walkable:e.walkable,userData:e.userData});return i.cells=s,i}},vg.SqrGrid.prototype.constructor=vg.SqrGrid,vg.Tile=function(e){e=e||{};var t={cell:null,geometry:null,material:null};if(t=vg.Tools.merge(t,e),!t.cell||!t.geometry)throw new Error("Missing vg.Tile configuration");this.cell=t.cell,this.cell.tile&&this.cell.tile!==this&&this.cell.tile.dispose(),this.cell.tile=this,this.uniqueID=vg.Tools.generateID(),this.geometry=t.geometry,this.material=t.material,this.material||(this.material=new THREE.MeshPhongMaterial({color:vg.Tools.randomizeRGB("30, 30, 30",13)})),this.objectType=vg.TILE,this.entity=null,this.userData={},this.selected=!1,this.highlight="0x0084cc",this.mesh=new THREE.Mesh(this.geometry,this.material),this.mesh.userData.structure=this,this.position=this.mesh.position,this.rotation=this.mesh.rotation,this.rotation.x=-90*vg.DEG_TO_RAD,this.mesh.scale.set(t.scale,t.scale,1),this.material.emissive?this._emissive=this.material.emissive.getHex():this._emissive=null},vg.Tile.prototype={select:function(){return this.material.emissive&&this.material.emissive.setHex(this.highlight),this.selected=!0,this},deselect:function(){return null!==this._emissive&&this.material.emissive&&this.material.emissive.setHex(this._emissive),this.selected=!1,this},toggle:function(){return this.selected?this.deselect():this.select(),this},dispose:function(){this.cell&&this.cell.tile&&(this.cell.tile=null),this.cell=null,this.position=null,this.rotation=null,this.mesh.parent&&this.mesh.parent.remove(this.mesh),this.mesh.userData.structure=null,this.mesh=null,this.material=null,this.userData=null,this.entity=null,this.geometry=null,this._emissive=null}},vg.Tile.prototype.constructor=vg.Tile,function(){var e=function(){this.obj=null,this.next=null,this.prev=null,this.free=!0},t=function(){this.first=null,this.last=null,this.length=0,this.objToNodeMap={},this.uniqueID=Date.now()+""+Math.floor(1e3*Math.random()),this.sortArray=[]};t.generateID=function(){return Math.random().toString(36).slice(2)+Date.now()},t.prototype={getNode:function(e){return this.objToNodeMap[e.uniqueID]},addNode:function(i){var s=new e;if(!i.uniqueID)try{i.uniqueID=t.generateID()}catch(n){return console.error("[LinkedList.addNode] obj passed is immutable: cannot attach necessary identifier"),null}return s.obj=i,s.free=!1,this.objToNodeMap[i.uniqueID]=s,s},swapObjects:function(e,t){this.objToNodeMap[e.obj.uniqueID]=null,this.objToNodeMap[t.uniqueID]=e,e.obj=t},add:function(e){var t=this.objToNodeMap[e.uniqueID];if(t){if(t.free===!1)return;t.obj=e,t.free=!1,t.next=null,t.prev=null}else t=this.addNode(e);if(this.first){if(!this.last)throw new Error("[LinkedList.add] No last in the list -- that shouldn't happen here");this.last.next=t,t.prev=this.last,this.last=t,t.next=null}else this.first=t,this.last=t,t.next=null,t.prev=null;this.length++,this.showDebug&&this.dump("after add")},has:function(e){return!!this.objToNodeMap[e.uniqueID]},moveUp:function(e){this.dump("before move up");var t=this.getNode(e);if(!t)throw"Oops, trying to move an object that isn't in the list";if(t.prev){var i=t.prev,s=i.prev;t==this.last&&(this.last=i);var n=t.next;s&&(s.next=t),t.next=i,t.prev=i.prev,i.next=n,i.prev=t,this.first==i&&(this.first=t)}},moveDown:function(e){var t=this.getNode(e);if(!t)throw"Oops, trying to move an object that isn't in the list";if(t.next){var i=t.next;this.moveUp(i.obj),this.last==i&&(this.last=t)}},sort:function(e){var t,i,s=this.sortArray,n=this.first;for(s.length=0;n;)s.push(n.obj),n=n.next;for(this.clear(),s.sort(e),i=s.length,t=0;i>t;t++)this.add(s[t])},remove:function(e){var t=this.getNode(e);return!t||t.free?!1:(t.prev&&(t.prev.next=t.next),t.next&&(t.next.prev=t.prev),t.prev||(this.first=t.next),t.next||(this.last=t.prev),t.free=!0,t.prev=null,t.next=null,this.length--,!0)},shift:function(){var e=this.first;return 0===this.length?null:(e.prev&&(e.prev.next=e.next),e.next&&(e.next.prev=e.prev),this.first=e.next,e.next||(this.last=null),e.free=!0,e.prev=null,e.next=null,this.length--,e.obj)},pop:function(){var e=this.last;return 0===this.length?null:(e.prev&&(e.prev.next=e.next),e.next&&(e.next.prev=e.prev),this.last=e.prev,e.prev||(this.first=null),e.free=!0,e.prev=null,e.next=null,this.length--,e.obj)},concat:function(e){for(var t=e.first;t;)this.add(t.obj),t=t.next},clear:function(){for(var e=this.first;e;)e.free=!0,e=e.next;this.first=null,this.length=0},dispose:function(){for(var e=this.first;e;)e.obj=null,e=e.next;this.first=null,this.objToNodeMap=null},dump:function(e){console.log("===================="+e+"=====================");for(var t=this.first;t;)console.log("{"+t.obj.toString()+"} previous="+(t.prev?t.prev.obj:"NULL")),t=t.next();console.log("==================================="),console.log("Last: {"+(this.last?this.last.obj:"NULL")+"} First: {"+(this.first?this.first.obj:"NULL")+"}")}},t.prototype.constructor=t,vg.LinkedList=t}(),function(){var e=function(e,t,i,s,n){this._listener=t,this.isOnce=i,this.context=s,this.signal=e,this._priority=n||0};e.prototype={active:!0,params:null,execute:function(e){var t,i;return this.active&&this._listener&&(i=this.params?this.params.concat(e):e,t=this._listener.apply(this.context,i),this.isOnce&&this.detach()),t},detach:function(){return this.isBound()?this.signal.remove(this._listener,this.context):null},isBound:function(){return!!this.signal&&!!this._listener},_destroy:function(){delete this.signal,delete this._listener,delete this.context},toString:function(){return"[SignalBinding isOnce:"+this.isOnce+", isBound:"+this.isBound()+", active:"+this.active+"]"}},e.prototype.constructor=e;var t=function(){this._bindings=[],this._prevParams=null;var e=this;this.dispatch=function(){t.prototype.dispatch.apply(e,arguments)}};t.prototype={memorize:!1,_shouldPropagate:!0,active:!0,validateListener:function(e,t){if("function"!=typeof e)throw new Error("Signal: listener is a required param of {fn}() and should be a Function.".replace("{fn}",t))},_registerListener:function(t,i,s,n){var l,r=this._indexOfListener(t,s);if(-1!==r){if(l=this._bindings[r],l.isOnce!==i)throw new Error("You cannot add"+(i?"":"Once")+"() then add"+(i?"Once":"")+"() the same listener without removing the relationship first.")}else l=new e(this,t,i,s,n),this._addBinding(l);return this.memorize&&this._prevParams&&l.execute(this._prevParams),l},_addBinding:function(e){var t=this._bindings.length;do t--;while(this._bindings[t]&&e._priority<=this._bindings[t]._priority);this._bindings.splice(t+1,0,e)},_indexOfListener:function(e,t){for(var i,s=this._bindings.length;s--;)if(i=this._bindings[s],i._listener===e&&i.context===t)return s;return-1},has:function(e,t){return-1!==this._indexOfListener(e,t)},add:function(e,t,i){return this.validateListener(e,"add"),this._registerListener(e,!1,t,i)},addOnce:function(e,t,i){return this.validateListener(e,"addOnce"),this._registerListener(e,!0,t,i)},remove:function(e,t){this.validateListener(e,"remove");var i=this._indexOfListener(e,t);return-1!==i&&(this._bindings[i]._destroy(),this._bindings.splice(i,1)),e},removeAll:function(e){"undefined"==typeof e&&(e=null);for(var t=this._bindings.length;t--;)e?this._bindings[t].context===e&&(this._bindings[t]._destroy(),this._bindings.splice(t,1)):this._bindings[t]._destroy();e||(this._bindings.length=0)},getNumListeners:function(){return this._bindings.length},halt:function(){this._shouldPropagate=!1},dispatch:function(){if(this.active){var e,t=Array.prototype.slice.call(arguments),i=this._bindings.length;if(this.memorize&&(this._prevParams=t),i){e=this._bindings.slice(),this._shouldPropagate=!0;do i--;while(e[i]&&this._shouldPropagate&&e[i].execute(t)!==!1)}}},forget:function(){this._prevParams=null},dispose:function(){this.removeAll(),delete this._bindings,delete this._prevParams},toString:function(){return"[Signal active:"+this.active+" numListeners:"+this.getNumListeners()+"]"}},t.prototype.constructor=t,vg.Signal=t}(),vg.AStarFinder=function(e){e=e||{};var t={allowDiagonal:!1,heuristicFilter:null};t=vg.Tools.merge(t,e),this.allowDiagonal=t.allowDiagonal,this.heuristicFilter=t.heuristicFilter,this.list=new vg.LinkedList},vg.AStarFinder.prototype={findPath:function(e,t,i,s){var n,l,r,h,o,a;for(i=i||this.heuristicFilter,s.clearPath(),this.list.clear(),this.list.add(e);this.list.length>0;){if(this.list.sort(this.compare),n=this.list.shift(),n._visited=!0,n===t)return vg.PathUtil.backtrace(t);for(r=s.getNeighbors(n,this.allowDiagonal,i),o=0,a=r.length;a>o;o++)if(h=r[o],h.walkable&&(l=n._calcCost+s.distance(n,h),!h._visited||l<h._calcCost)){if(h._visited=!0,h._parent=n,h._calcCost=l,h._priority=l+s.distance(t,h),h===t)return vg.PathUtil.backtrace(t);this.list.add(h)}}return null},compare:function(e,t){return e._priority-t._priority}},vg.AStarFinder.prototype.constructor=vg.AStarFinder,vg.PathUtil={backtrace:function(e){for(var t=[e];e._parent;)e=e._parent,t.push(e);return t.reverse()},biBacktrace:function(e,t){var i=this.backtrace(e),s=this.backtrace(t);return i.concat(s.reverse())},pathLength:function(e){var t,i,s,n,l,r=0;for(t=1;t<e.length;++t)i=e[t-1],s=e[t],n=i[0]-s[0],l=i[1]-s[1],r+=Math.sqrt(n*n+l*l);return r},interpolate:function(e,t,i,s){var n,l,r,h,o,a,c=Math.abs,u=[];for(r=c(i-e),h=c(s-t),n=i>e?1:-1,l=s>t?1:-1,o=r-h;e!==i||t!==s;)u.push([e,t]),a=2*o,a>-h&&(o-=h,e+=n),r>a&&(o+=r,t+=l);return u},expandPath:function(e){var t,i,s,n,l,r,h=[],o=e.length;if(2>o)return h;for(l=0;o-1>l;++l)for(t=e[l],i=e[l+1],s=this.interpolate(t[0],t[1],i[0],i[1]),n=s.length,r=0;n-1>r;++r)h.push(s[r]);return h.push(e[o-1]),h},smoothenPath:function(e,t){var i,s,n,l,r,h,o,a,c,u,d,g,p=t.length,v=t[0][0],f=t[0][1],m=t[p-1][0],_=t[p-1][1];for(i=v,s=f,r=[[i,s]],o=2;p>o;++o){for(c=t[o],n=c[0],l=c[1],u=this.interpolate(i,s,n,l),g=!1,a=1;a<u.length;++a)if(d=u[a],!e.isWalkableAt(d[0],d[1])){g=!0;break}g&&(h=t[o-1],r.push(h),i=h[0],s=h[1])}return r.push([m,_]),r},compressPath:function(e){if(e.length<3)return e;var t,i,s,n,l,r,h=[],o=e[0][0],a=e[0][1],c=e[1][0],u=e[1][1],d=c-o,g=u-a;for(l=Math.sqrt(d*d+g*g),d/=l,g/=l,h.push([o,a]),r=2;r<e.length;r++)t=c,i=u,s=d,n=g,c=e[r][0],u=e[r][1],d=c-t,g=u-i,l=Math.sqrt(d*d+g*g),d/=l,g/=l,(d!==s||g!==n)&&h.push([t,i]);return h.push([c,u]),h}},vg.Loader={manager:null,imageLoader:null,crossOrigin:!1,init:function(e){this.crossOrigin=e||!1,this.manager=new THREE.LoadingManager(function(){},function(){},function(){console.warn("Error loading images")}),this.imageLoader=new THREE.ImageLoader(this.manager),this.imageLoader.crossOrigin=e},loadTexture:function(e,t,i,s){var n=new THREE.Texture(null,t);return this.imageLoader.load(e,function(e){n.image=e,n.needsUpdate=!0,i&&i(n)},null,function(e){s&&s(e)}),n.sourceFile=e,n}},vg.MouseCaster=function(e,t,i){this.down=!1,this.rightDown=!1,this.pickedObject=null,this.selectedObject=null,this.allHits=null,this.active=!0,this.shift=!1,this.ctrl=!1,this.wheel=0,this.position=new THREE.Vector3,this.screenPosition=new THREE.Vector2,this.signal=new vg.Signal,this.group=e,this._camera=t,this._raycaster=new THREE.Raycaster,this._preventDefault=!1,i=i||document,i.addEventListener("mousemove",this._onDocumentMouseMove.bind(this),!1),i.addEventListener("mousedown",this._onDocumentMouseDown.bind(this),!1),i.addEventListener("mouseup",this._onDocumentMouseUp.bind(this),!1),i.addEventListener("mousewheel",this._onMouseWheel.bind(this),!1),i.addEventListener("DOMMouseScroll",this._onMouseWheel.bind(this),!1)},vg.MouseCaster.OVER="over",vg.MouseCaster.OUT="out",vg.MouseCaster.DOWN="down",vg.MouseCaster.UP="up",vg.MouseCaster.CLICK="click",vg.MouseCaster.WHEEL="wheel",vg.MouseCaster.prototype={update:function(){if(this.active){this._raycaster.setFromCamera(this.screenPosition,this._camera);var e,t,i=this._raycaster.intersectObject(this.group,!0);i.length>0?(e=i[0],t=e.object.userData.structure,this.pickedObject!=t&&(this.pickedObject&&this.signal.dispatch(vg.MouseCaster.OUT,this.pickedObject),this.pickedObject=t,this.selectedObject=null,this.signal.dispatch(vg.MouseCaster.OVER,this.pickedObject)),this.position.copy(e.point),this.screenPosition.z=e.distance):(this.pickedObject&&this.signal.dispatch(vg.MouseCaster.OUT,this.pickedObject),this.pickedObject=null,this.selectedObject=null),this.allHits=i}},preventDefault:function(){this._preventDefault=!0},_onDocumentMouseDown:function(e){return e=e||window.event,e.preventDefault(),this._preventDefault?(this._preventDefault=!1,!1):(this.pickedObject&&(this.selectedObject=this.pickedObject),this.shift=e.shiftKey,this.ctrl=e.ctrlKey,this.down=1===e.which,this.rightDown=3===e.which,void this.signal.dispatch(vg.MouseCaster.DOWN,this.pickedObject))},_onDocumentMouseUp:function(e){return e.preventDefault(),this._preventDefault?(this._preventDefault=!1,!1):(this.shift=e.shiftKey,this.ctrl=e.ctrlKey,this.signal.dispatch(vg.MouseCaster.UP,this.pickedObject),this.selectedObject&&this.pickedObject&&this.selectedObject.uniqueID===this.pickedObject.uniqueID&&this.signal.dispatch(vg.MouseCaster.CLICK,this.pickedObject),this.down=1===e.which?!1:this.down,void(this.rightDown=3===e.which?!1:this.rightDown))},_onDocumentMouseMove:function(e){e.preventDefault(),this.screenPosition.x=e.clientX/window.innerWidth*2-1,this.screenPosition.y=2*-(e.clientY/window.innerHeight)+1},_onMouseWheel:function(e){if(this.active){e.preventDefault(),e.stopPropagation();var t=0;void 0!==e.wheelDelta?t=e.wheelDelta:void 0!==e.detail&&(t=-e.detail),t>0?this.wheel++:this.wheel--,this.signal.dispatch(vg.MouseCaster.WHEEL,this.wheel)}}},vg.MouseCaster.prototype.constructor=vg.MouseCaster,vg.Scene=function(e,t){var i={element:document.body,alpha:!0,antialias:!0,clearColor:"#fff",sortObjects:!1,fog:null,light:new THREE.DirectionalLight(16777215),lightPosition:null,cameraType:"PerspectiveCamera",cameraPosition:null,orthoZoom:4},s={minDistance:100,maxDistance:1e3,zoomSpeed:2,noZoom:!1};if(i=vg.Tools.merge(i,e),"boolean"!=typeof t&&(s=vg.Tools.merge(s,t)),this.renderer=new THREE.WebGLRenderer({alpha:i.alpha,antialias:i.antialias}),this.renderer.setClearColor(i.clearColor,0),this.renderer.sortObjects=i.sortObjects,this.width=window.innerWidth,this.height=window.innerHeight,this.orthoZoom=i.orthoZoom,this.container=new THREE.Scene,this.container.fog=i.fog,this.container.add(new THREE.AmbientLight(14540253)),i.lightPosition||i.light.position.set(-1,1,-1).normalize(),this.container.add(i.light),"OrthographicCamera"===i.cameraType){var n=window.innerWidth/this.orthoZoom,l=window.innerHeight/this.orthoZoom;this.camera=new THREE.OrthographicCamera(n/-2,n/2,l/2,l/-2,1,5e3)}else this.camera=new THREE.PerspectiveCamera(50,this.width/this.height,1,5e3);this.contolled=!!t,this.contolled&&(this.controls=new THREE.OrbitControls(this.camera,this.renderer.domElement),this.controls.minDistance=s.minDistance,this.controls.maxDistance=s.maxDistance,this.controls.zoomSpeed=s.zoomSpeed,this.controls.noZoom=s.noZoom),i.cameraPosition&&this.camera.position.copy(i.cameraPosition),window.addEventListener("resize",function(){if(this.width=window.innerWidth,this.height=window.innerHeight,"OrthographicCamera"===this.camera.type){var e=this.width/this.orthoZoom,t=this.height/this.orthoZoom;this.camera.left=e/-2,this.camera.right=e/2,this.camera.top=t/2,this.camera.bottom=t/-2}else this.camera.aspect=this.width/this.height;this.camera.updateProjectionMatrix(),this.renderer.setSize(this.width,this.height)}.bind(this),!1),this.attachTo(i.element)},vg.Scene.prototype={attachTo:function(e){e.style.width=this.width+"px",e.style.height=this.height+"px",this.renderer.setPixelRatio(window.devicePixelRatio),this.renderer.setSize(this.width,this.height),e.appendChild(this.renderer.domElement)},add:function(e){this.container.add(e)},remove:function(e){this.container.remove(e)},render:function(){this.contolled&&this.controls.update(),this.renderer.render(this.container,this.camera)},updateOrthoZoom:function(){if(this.orthoZoom<=0)return void(this.orthoZoom=0);var e=this.width/this.orthoZoom,t=this.height/this.orthoZoom;this.camera.left=e/-2,this.camera.right=e/2,this.camera.top=t/2,this.camera.bottom=t/-2,this.camera.updateProjectionMatrix()},focusOn:function(e){this.camera.lookAt(e.position)}},vg.Scene.prototype.constructor=vg.Scene,vg.SelectionManager=function(e){this.mouse=e,this.onSelect=new vg.Signal,this.onDeselect=new vg.Signal,this.selected=null,this.toggleSelection=!1,this.mouse.signal.add(this.onMouse,this)},vg.SelectionManager.prototype={select:function(e,t){e&&(t=t||!0,this.selected!==e&&this.clearSelection(t),e.selected?this.toggleSelection&&(t&&this.onDeselect.dispatch(e),e.deselect()):e.select(),this.selected=e,t&&this.onSelect.dispatch(e))},clearSelection:function(e){e=e||!0,this.selected&&(e&&this.onDeselect.dispatch(this.selected),this.selected.deselect()),this.selected=null},onMouse:function(e,t){switch(e){case vg.MouseCaster.DOWN:t||this.clearSelection();break;case vg.MouseCaster.CLICK:this.select(t)}}},vg.SelectionManager.prototype.constructor=vg.SelectionManager,vg.Tools={clamp:function(e,t,i){return Math.max(t,Math.min(i,e))},sign:function(e){return e&&e/Math.abs(e)},random:function(e,t){return 1===arguments.length?Math.random()*e-.5*e:Math.random()*(t-e)+e},randomInt:function(e,t){return 1===arguments.length?Math.random()*e-.5*e|0:Math.random()*(t-e+1)+e|0},normalize:function(e,t,i){return(e-t)/(i-t)},getShortRotation:function(e){return e%=this.TAU,e>this.PI?e-=this.TAU:e<-this.PI&&(e+=this.TAU),e},generateID:function(){return Math.random().toString(36).slice(2)+Date.now()},isPlainObject:function(e){if("object"!=typeof e||e.nodeType||e===e.window)return!1;try{if(e.constructor&&!Object.prototype.hasOwnProperty.call(e.constructor.prototype,"isPrototypeOf"))return!1}catch(t){return!1}return!0},merge:function(e,t){var i=this,s=Array.isArray(t),n=s&&[]||{};return s?(e=e||[],n=n.concat(e),t.forEach(function(t,s){"undefined"==typeof n[s]?n[s]=t:i.isPlainObject(t)?n[s]=i.merge(e[s],t):-1===e.indexOf(t)&&n.push(t)}),n):(e&&i.isPlainObject(e)&&Object.keys(e).forEach(function(t){n[t]=e[t];
}),Object.keys(t).forEach(function(s){t[s]&&i.isPlainObject(t[s])&&e[s]?n[s]=i.merge(e[s],t[s]):n[s]=t[s]}),n)},now:function(){return window.nwf?window.nwf.system.Performance.elapsedTime:window.performance.now()},empty:function(e){for(;e.lastChild;)e.removeChild(e.lastChild)},radixSort:function(e,t,i,s){if(t=t||0,i=i||e.length,s=s||31,!(t>=i-1||0>s)){for(var n=t,l=i,r=1<<s;l>n;)if(e[n]&r){--l;var h=e[n];e[n]=e[l],e[l]=h}else++n;this.radixSort(e,t,l,s-1),this.radixSort(e,l,i,s-1)}},randomizeRGB:function(e,t){var i,s,n=e.split(","),l="rgb(";for(t=this.randomInt(t),i=0;3>i;i++)s=parseInt(n[i])+t,0>s?s=0:s>255&&(s=255),l+=s+",";return l=l.substring(0,l.length-1),l+=")"},getJSON:function(e){var t=new XMLHttpRequest,i="undefined"==typeof e.cache?!1:e.cache,s=i?e.url:e.url+"?t="+Math.floor(1e4*Math.random())+Date.now();t.onreadystatechange=function(){if(200===this.status){var t=null;try{t=JSON.parse(this.responseText)}catch(i){return}return void e.callback.call(e.scope||null,t)}0!==this.status&&console.warn("[Tools.getJSON] Error: "+this.status+" ("+this.statusText+") :: "+e.url)},t.open("GET",s,!0),t.setRequestHeader("Accept","application/json"),t.setRequestHeader("Content-Type","application/json"),t.send("")}};
//# sourceMappingURL=hex-grid.min.js.map


/***/ }),
/* 247 */
/***/ (function(module, exports) {

/**
 * Polyfill for the additional KeyboardEvent properties defined in the D3E and
 * D4E draft specifications, by @inexorabletash.
 *
 * See: https://github.com/inexorabletash/polyfill
 */
(function(global) {
  var nativeKeyboardEvent = ('KeyboardEvent' in global);
  if (!nativeKeyboardEvent)
    global.KeyboardEvent = function KeyboardEvent() { throw TypeError('Illegal constructor'); };

  global.KeyboardEvent.DOM_KEY_LOCATION_STANDARD = 0x00; // Default or unknown location
  global.KeyboardEvent.DOM_KEY_LOCATION_LEFT          = 0x01; // e.g. Left Alt key
  global.KeyboardEvent.DOM_KEY_LOCATION_RIGHT         = 0x02; // e.g. Right Alt key
  global.KeyboardEvent.DOM_KEY_LOCATION_NUMPAD        = 0x03; // e.g. Numpad 0 or +

  var STANDARD = window.KeyboardEvent.DOM_KEY_LOCATION_STANDARD,
      LEFT = window.KeyboardEvent.DOM_KEY_LOCATION_LEFT,
      RIGHT = window.KeyboardEvent.DOM_KEY_LOCATION_RIGHT,
      NUMPAD = window.KeyboardEvent.DOM_KEY_LOCATION_NUMPAD;

  //--------------------------------------------------------------------
  //
  // Utilities
  //
  //--------------------------------------------------------------------

  function contains(s, ss) { return String(s).indexOf(ss) !== -1; }

  var os = (function() {
    if (contains(navigator.platform, 'Win')) { return 'win'; }
    if (contains(navigator.platform, 'Mac')) { return 'mac'; }
    if (contains(navigator.platform, 'CrOS')) { return 'cros'; }
    if (contains(navigator.platform, 'Linux')) { return 'linux'; }
    if (contains(navigator.userAgent, 'iPad') || contains(navigator.platform, 'iPod') || contains(navigator.platform, 'iPhone')) { return 'ios'; }
    return '';
  } ());

  var browser = (function() {
    if (contains(navigator.userAgent, 'Chrome/')) { return 'chrome'; }
    if (contains(navigator.vendor, 'Apple')) { return 'safari'; }
    if (contains(navigator.userAgent, 'MSIE')) { return 'ie'; }
    if (contains(navigator.userAgent, 'Gecko/')) { return 'moz'; }
    if (contains(navigator.userAgent, 'Opera/')) { return 'opera'; }
    return '';
  } ());

  var browser_os = browser + '-' + os;

  function mergeIf(baseTable, select, table) {
    if (browser_os === select || browser === select || os === select) {
      Object.keys(table).forEach(function(keyCode) {
        baseTable[keyCode] = table[keyCode];
      });
    }
  }

  function remap(o, key) {
    var r = {};
    Object.keys(o).forEach(function(k) {
      var item = o[k];
      if (key in item) {
        r[item[key]] = item;
      }
    });
    return r;
  }

  function invert(o) {
    var r = {};
    Object.keys(o).forEach(function(k) {
      r[o[k]] = k;
    });
    return r;
  }

  //--------------------------------------------------------------------
  //
  // Generic Mappings
  //
  //--------------------------------------------------------------------

  // "keyInfo" is a dictionary:
  //   code: string - name from DOM Level 3 KeyboardEvent code Values
  //     https://dvcs.w3.org/hg/dom3events/raw-file/tip/html/DOM3Events-code.html
  //   location (optional): number - one of the DOM_KEY_LOCATION values
  //   keyCap (optional): string - keyboard label in en-US locale
  // USB code Usage ID from page 0x07 unless otherwise noted (Informative)

  // Map of keyCode to keyInfo
  var keyCodeToInfoTable = {
    // 0x01 - VK_LBUTTON
    // 0x02 - VK_RBUTTON
    0x03: { code: 'Cancel' }, // [USB: 0x9b] char \x0018 ??? (Not in D3E)
    // 0x04 - VK_MBUTTON
    // 0x05 - VK_XBUTTON1
    // 0x06 - VK_XBUTTON2
    0x06: { code: 'Help' }, // [USB: 0x75] ???
    // 0x07 - undefined
    0x08: { code: 'Backspace' }, // [USB: 0x2a] Labelled Delete on Macintosh keyboards.
    0x09: { code: 'Tab' }, // [USB: 0x2b]
    // 0x0A-0x0B - reserved
    0X0C: { code: 'Clear' }, // [USB: 0x9c] NumPad Center (Not in D3E)
    0X0D: { code: 'Enter' }, // [USB: 0x28]
    // 0x0E-0x0F - undefined

    0x10: { code: 'Shift' },
    0x11: { code: 'Control' },
    0x12: { code: 'Alt' },
    0x13: { code: 'Pause' }, // [USB: 0x48]
    0x14: { code: 'CapsLock' }, // [USB: 0x39]
    0x15: { code: 'KanaMode' }, // [USB: 0x88] - "HangulMode" for Korean layout
    0x16: { code: 'HangulMode' }, // [USB: 0x90] 0x15 as well in MSDN VK table ???
    0x17: { code: 'JunjaMode' }, // (Not in D3E)
    0x18: { code: 'FinalMode' }, // (Not in D3E)
    0x19: { code: 'KanjiMode' }, // [USB: 0x91] - "HanjaMode" for Korean layout
    // 0x1A - undefined
    0x1B: { code: 'Escape' }, // [USB: 0x29]
    0x1C: { code: 'Convert' }, // [USB: 0x8a]
    0x1D: { code: 'NonConvert' }, // [USB: 0x8b]
    0x1E: { code: 'Accept' }, // (Not in D3E)
    0x1F: { code: 'ModeChange' }, // (Not in D3E)

    0x20: { code: 'Space' }, // [USB: 0x2c]
    0x21: { code: 'PageUp' }, // [USB: 0x4b]
    0x22: { code: 'PageDown' }, // [USB: 0x4e]
    0x23: { code: 'End' }, // [USB: 0x4d]
    0x24: { code: 'Home' }, // [USB: 0x4a]
    0x25: { code: 'ArrowLeft' }, // [USB: 0x50]
    0x26: { code: 'ArrowUp' }, // [USB: 0x52]
    0x27: { code: 'ArrowRight' }, // [USB: 0x4f]
    0x28: { code: 'ArrowDown' }, // [USB: 0x51]
    0x29: { code: 'Select' }, // (Not in D3E)
    0x2A: { code: 'Print' }, // (Not in D3E)
    0x2B: { code: 'Execute' }, // [USB: 0x74] (Not in D3E)
    0x2C: { code: 'PrintScreen' }, // [USB: 0x46]
    0x2D: { code: 'Insert' }, // [USB: 0x49]
    0x2E: { code: 'Delete' }, // [USB: 0x4c]
    0x2F: { code: 'Help' }, // [USB: 0x75] ???

    0x30: { code: 'Digit0', keyCap: '0' }, // [USB: 0x27] 0)
    0x31: { code: 'Digit1', keyCap: '1' }, // [USB: 0x1e] 1!
    0x32: { code: 'Digit2', keyCap: '2' }, // [USB: 0x1f] 2@
    0x33: { code: 'Digit3', keyCap: '3' }, // [USB: 0x20] 3#
    0x34: { code: 'Digit4', keyCap: '4' }, // [USB: 0x21] 4$
    0x35: { code: 'Digit5', keyCap: '5' }, // [USB: 0x22] 5%
    0x36: { code: 'Digit6', keyCap: '6' }, // [USB: 0x23] 6^
    0x37: { code: 'Digit7', keyCap: '7' }, // [USB: 0x24] 7&
    0x38: { code: 'Digit8', keyCap: '8' }, // [USB: 0x25] 8*
    0x39: { code: 'Digit9', keyCap: '9' }, // [USB: 0x26] 9(
    // 0x3A-0x40 - undefined

    0x41: { code: 'KeyA', keyCap: 'a' }, // [USB: 0x04]
    0x42: { code: 'KeyB', keyCap: 'b' }, // [USB: 0x05]
    0x43: { code: 'KeyC', keyCap: 'c' }, // [USB: 0x06]
    0x44: { code: 'KeyD', keyCap: 'd' }, // [USB: 0x07]
    0x45: { code: 'KeyE', keyCap: 'e' }, // [USB: 0x08]
    0x46: { code: 'KeyF', keyCap: 'f' }, // [USB: 0x09]
    0x47: { code: 'KeyG', keyCap: 'g' }, // [USB: 0x0a]
    0x48: { code: 'KeyH', keyCap: 'h' }, // [USB: 0x0b]
    0x49: { code: 'KeyI', keyCap: 'i' }, // [USB: 0x0c]
    0x4A: { code: 'KeyJ', keyCap: 'j' }, // [USB: 0x0d]
    0x4B: { code: 'KeyK', keyCap: 'k' }, // [USB: 0x0e]
    0x4C: { code: 'KeyL', keyCap: 'l' }, // [USB: 0x0f]
    0x4D: { code: 'KeyM', keyCap: 'm' }, // [USB: 0x10]
    0x4E: { code: 'KeyN', keyCap: 'n' }, // [USB: 0x11]
    0x4F: { code: 'KeyO', keyCap: 'o' }, // [USB: 0x12]

    0x50: { code: 'KeyP', keyCap: 'p' }, // [USB: 0x13]
    0x51: { code: 'KeyQ', keyCap: 'q' }, // [USB: 0x14]
    0x52: { code: 'KeyR', keyCap: 'r' }, // [USB: 0x15]
    0x53: { code: 'KeyS', keyCap: 's' }, // [USB: 0x16]
    0x54: { code: 'KeyT', keyCap: 't' }, // [USB: 0x17]
    0x55: { code: 'KeyU', keyCap: 'u' }, // [USB: 0x18]
    0x56: { code: 'KeyV', keyCap: 'v' }, // [USB: 0x19]
    0x57: { code: 'KeyW', keyCap: 'w' }, // [USB: 0x1a]
    0x58: { code: 'KeyX', keyCap: 'x' }, // [USB: 0x1b]
    0x59: { code: 'KeyY', keyCap: 'y' }, // [USB: 0x1c]
    0x5A: { code: 'KeyZ', keyCap: 'z' }, // [USB: 0x1d]
    0x5B: { code: 'OSLeft', location: LEFT }, // [USB: 0xe3]
    0x5C: { code: 'OSRight', location: RIGHT }, // [USB: 0xe7]
    0x5D: { code: 'ContextMenu' }, // [USB: 0x65] Context Menu
    // 0x5E - reserved
    0x5F: { code: 'Standby' }, // [USB: 0x82] Sleep

    0x60: { code: 'Numpad0', keyCap: '0', location: NUMPAD }, // [USB: 0x62]
    0x61: { code: 'Numpad1', keyCap: '1', location: NUMPAD }, // [USB: 0x59]
    0x62: { code: 'Numpad2', keyCap: '2', location: NUMPAD }, // [USB: 0x5a]
    0x63: { code: 'Numpad3', keyCap: '3', location: NUMPAD }, // [USB: 0x5b]
    0x64: { code: 'Numpad4', keyCap: '4', location: NUMPAD }, // [USB: 0x5c]
    0x65: { code: 'Numpad5', keyCap: '5', location: NUMPAD }, // [USB: 0x5d]
    0x66: { code: 'Numpad6', keyCap: '6', location: NUMPAD }, // [USB: 0x5e]
    0x67: { code: 'Numpad7', keyCap: '7', location: NUMPAD }, // [USB: 0x5f]
    0x68: { code: 'Numpad8', keyCap: '8', location: NUMPAD }, // [USB: 0x60]
    0x69: { code: 'Numpad9', keyCap: '9', location: NUMPAD }, // [USB: 0x61]
    0x6A: { code: 'NumpadMultiply', keyCap: '*', location: NUMPAD }, // [USB: 0x55]
    0x6B: { code: 'NumpadAdd', keyCap: '+', location: NUMPAD }, // [USB: 0x57]
    0x6C: { code: 'NumpadComma', keyCap: ',', location: NUMPAD }, // [USB: 0x85]
    0x6D: { code: 'NumpadSubtract', keyCap: '-', location: NUMPAD }, // [USB: 0x56]
    0x6E: { code: 'NumpadDecimal', keyCap: '.', location: NUMPAD }, // [USB: 0x63]
    0x6F: { code: 'NumpadDivide', keyCap: '/', location: NUMPAD }, // [USB: 0x54]

    0x70: { code: 'F1' }, // [USB: 0x3a]
    0x71: { code: 'F2' }, // [USB: 0x3b]
    0x72: { code: 'F3' }, // [USB: 0x3c]
    0x73: { code: 'F4' }, // [USB: 0x3d]
    0x74: { code: 'F5' }, // [USB: 0x3e]
    0x75: { code: 'F6' }, // [USB: 0x3f]
    0x76: { code: 'F7' }, // [USB: 0x40]
    0x77: { code: 'F8' }, // [USB: 0x41]
    0x78: { code: 'F9' }, // [USB: 0x42]
    0x79: { code: 'F10' }, // [USB: 0x43]
    0x7A: { code: 'F11' }, // [USB: 0x44]
    0x7B: { code: 'F12' }, // [USB: 0x45]
    0x7C: { code: 'F13' }, // [USB: 0x68]
    0x7D: { code: 'F14' }, // [USB: 0x69]
    0x7E: { code: 'F15' }, // [USB: 0x6a]
    0x7F: { code: 'F16' }, // [USB: 0x6b]

    0x80: { code: 'F17' }, // [USB: 0x6c]
    0x81: { code: 'F18' }, // [USB: 0x6d]
    0x82: { code: 'F19' }, // [USB: 0x6e]
    0x83: { code: 'F20' }, // [USB: 0x6f]
    0x84: { code: 'F21' }, // [USB: 0x70]
    0x85: { code: 'F22' }, // [USB: 0x71]
    0x86: { code: 'F23' }, // [USB: 0x72]
    0x87: { code: 'F24' }, // [USB: 0x73]
    // 0x88-0x8F - unassigned

    0x90: { code: 'NumLock', location: NUMPAD }, // [USB: 0x53]
    0x91: { code: 'ScrollLock' }, // [USB: 0x47]
    // 0x92-0x96 - OEM specific
    // 0x97-0x9F - unassigned

    // NOTE: 0xA0-0xA5 usually mapped to 0x10-0x12 in browsers
    0xA0: { code: 'ShiftLeft', location: LEFT }, // [USB: 0xe1]
    0xA1: { code: 'ShiftRight', location: RIGHT }, // [USB: 0xe5]
    0xA2: { code: 'ControlLeft', location: LEFT }, // [USB: 0xe0]
    0xA3: { code: 'ControlRight', location: RIGHT }, // [USB: 0xe4]
    0xA4: { code: 'AltLeft', location: LEFT }, // [USB: 0xe2]
    0xA5: { code: 'AltRight', location: RIGHT }, // [USB: 0xe6]

    0xA6: { code: 'BrowserBack' }, // [USB: 0x0c/0x0224]
    0xA7: { code: 'BrowserForward' }, // [USB: 0x0c/0x0225]
    0xA8: { code: 'BrowserRefresh' }, // [USB: 0x0c/0x0227]
    0xA9: { code: 'BrowserStop' }, // [USB: 0x0c/0x0226]
    0xAA: { code: 'BrowserSearch' }, // [USB: 0x0c/0x0221]
    0xAB: { code: 'BrowserFavorites' }, // [USB: 0x0c/0x0228]
    0xAC: { code: 'BrowserHome' }, // [USB: 0x0c/0x0222]
    0xAD: { code: 'VolumeMute' }, // [USB: 0x7f]
    0xAE: { code: 'VolumeDown' }, // [USB: 0x81]
    0xAF: { code: 'VolumeUp' }, // [USB: 0x80]

    0xB0: { code: 'MediaTrackNext' }, // [USB: 0x0c/0x00b5]
    0xB1: { code: 'MediaTrackPrevious' }, // [USB: 0x0c/0x00b6]
    0xB2: { code: 'MediaStop' }, // [USB: 0x0c/0x00b7]
    0xB3: { code: 'MediaPlayPause' }, // [USB: 0x0c/0x00cd]
    0xB4: { code: 'LaunchMail' }, // [USB: 0x0c/0x018a]
    0xB5: { code: 'MediaSelect' },
    0xB6: { code: 'LaunchApp1' },
    0xB7: { code: 'LaunchApp2' },
    // 0xB8-0xB9 - reserved
    0xBA: { code: 'Semicolon',  keyCap: ';' }, // [USB: 0x33] ;: (US Standard 101)
    0xBB: { code: 'Equal', keyCap: '=' }, // [USB: 0x2e] =+
    0xBC: { code: 'Comma', keyCap: ',' }, // [USB: 0x36] ,<
    0xBD: { code: 'Minus', keyCap: '-' }, // [USB: 0x2d] -_
    0xBE: { code: 'Period', keyCap: '.' }, // [USB: 0x37] .>
    0xBF: { code: 'Slash', keyCap: '/' }, // [USB: 0x38] /? (US Standard 101)

    0xC0: { code: 'Backquote', keyCap: '`' }, // [USB: 0x35] `~ (US Standard 101)
    // 0xC1-0xCF - reserved

    // 0xD0-0xD7 - reserved
    // 0xD8-0xDA - unassigned
    0xDB: { code: 'BracketLeft', keyCap: '[' }, // [USB: 0x2f] [{ (US Standard 101)
    0xDC: { code: 'Backslash',  keyCap: '\\' }, // [USB: 0x31] \| (US Standard 101)
    0xDD: { code: 'BracketRight', keyCap: ']' }, // [USB: 0x30] ]} (US Standard 101)
    0xDE: { code: 'Quote', keyCap: '\'' }, // [USB: 0x34] '" (US Standard 101)
    // 0xDF - miscellaneous/varies

    // 0xE0 - reserved
    // 0xE1 - OEM specific
    0xE2: { code: 'IntlBackslash',  keyCap: '\\' }, // [USB: 0x64] \| (UK Standard 102)
    // 0xE3-0xE4 - OEM specific
    0xE5: { code: 'Process' }, // (Not in D3E)
    // 0xE6 - OEM specific
    // 0xE7 - VK_PACKET
    // 0xE8 - unassigned
    // 0xE9-0xEF - OEM specific

    // 0xF0-0xF5 - OEM specific
    0xF6: { code: 'Attn' }, // [USB: 0x9a] (Not in D3E)
    0xF7: { code: 'CrSel' }, // [USB: 0xa3] (Not in D3E)
    0xF8: { code: 'ExSel' }, // [USB: 0xa4] (Not in D3E)
    0xF9: { code: 'EraseEof' }, // (Not in D3E)
    0xFA: { code: 'Play' }, // (Not in D3E)
    0xFB: { code: 'ZoomToggle' }, // (Not in D3E)
    // 0xFC - VK_NONAME - reserved
    // 0xFD - VK_PA1
    0xFE: { code: 'Clear' } // [USB: 0x9c] (Not in D3E)
  };

  // No legacy keyCode, but listed in D3E:

  // code: usb
  // 'IntlHash': 0x070032,
  // 'IntlRo': 0x070087,
  // 'IntlYen': 0x070089,
  // 'NumpadBackspace': 0x0700bb,
  // 'NumpadClear': 0x0700d8,
  // 'NumpadClearEntry': 0x0700d9,
  // 'NumpadMemoryAdd': 0x0700d3,
  // 'NumpadMemoryClear': 0x0700d2,
  // 'NumpadMemoryRecall': 0x0700d1,
  // 'NumpadMemoryStore': 0x0700d0,
  // 'NumpadMemorySubtract': 0x0700d4,
  // 'NumpadParenLeft': 0x0700b6,
  // 'NumpadParenRight': 0x0700b7,

  //--------------------------------------------------------------------
  //
  // Browser/OS Specific Mappings
  //
  //--------------------------------------------------------------------

  mergeIf(keyCodeToInfoTable,
          'moz', {
            0x3B: { code: 'Semicolon', keyCap: ';' }, // [USB: 0x33] ;: (US Standard 101)
            0x3D: { code: 'Equal', keyCap: '=' }, // [USB: 0x2e] =+
            0x6B: { code: 'Equal', keyCap: '=' }, // [USB: 0x2e] =+
            0x6D: { code: 'Minus', keyCap: '-' }, // [USB: 0x2d] -_
            0xBB: { code: 'NumpadAdd', keyCap: '+', location: NUMPAD }, // [USB: 0x57]
            0xBD: { code: 'NumpadSubtract', keyCap: '-', location: NUMPAD } // [USB: 0x56]
          });

  mergeIf(keyCodeToInfoTable,
          'moz-mac', {
            0x0C: { code: 'NumLock', location: NUMPAD }, // [USB: 0x53]
            0xAD: { code: 'Minus', keyCap: '-' } // [USB: 0x2d] -_
          });

  mergeIf(keyCodeToInfoTable,
          'moz-win', {
            0xAD: { code: 'Minus', keyCap: '-' } // [USB: 0x2d] -_
          });

  mergeIf(keyCodeToInfoTable,
          'chrome-mac', {
            0x5D: { code: 'OSRight', location: RIGHT } // [USB: 0xe7]
          });

  // Windows via Bootcamp (!)
  if (0) {
    mergeIf(keyCodeToInfoTable,
            'chrome-win', {
              0xC0: { code: 'Quote', keyCap: '\'' }, // [USB: 0x34] '" (US Standard 101)
              0xDE: { code: 'Backslash',  keyCap: '\\' }, // [USB: 0x31] \| (US Standard 101)
              0xDF: { code: 'Backquote', keyCap: '`' } // [USB: 0x35] `~ (US Standard 101)
            });

    mergeIf(keyCodeToInfoTable,
            'ie', {
              0xC0: { code: 'Quote', keyCap: '\'' }, // [USB: 0x34] '" (US Standard 101)
              0xDE: { code: 'Backslash',  keyCap: '\\' }, // [USB: 0x31] \| (US Standard 101)
              0xDF: { code: 'Backquote', keyCap: '`' } // [USB: 0x35] `~ (US Standard 101)
            });
  }

  mergeIf(keyCodeToInfoTable,
          'safari', {
            0x03: { code: 'Enter' }, // [USB: 0x28] old Safari
            0x19: { code: 'Tab' } // [USB: 0x2b] old Safari for Shift+Tab
          });

  mergeIf(keyCodeToInfoTable,
          'ios', {
            0x0A: { code: 'Enter', location: STANDARD } // [USB: 0x28]
          });

  mergeIf(keyCodeToInfoTable,
          'safari-mac', {
            0x5B: { code: 'OSLeft', location: LEFT }, // [USB: 0xe3]
            0x5D: { code: 'OSRight', location: RIGHT }, // [USB: 0xe7]
            0xE5: { code: 'KeyQ', keyCap: 'Q' } // [USB: 0x14] On alternate presses, Ctrl+Q sends this
          });

  //--------------------------------------------------------------------
  //
  // Identifier Mappings
  //
  //--------------------------------------------------------------------

  // Cases where newer-ish browsers send keyIdentifier which can be
  // used to disambiguate keys.

  // keyIdentifierTable[keyIdentifier] -> keyInfo

  var keyIdentifierTable = {};
  if ('cros' === os) {
    keyIdentifierTable['U+00A0'] = { code: 'ShiftLeft', location: LEFT };
    keyIdentifierTable['U+00A1'] = { code: 'ShiftRight', location: RIGHT };
    keyIdentifierTable['U+00A2'] = { code: 'ControlLeft', location: LEFT };
    keyIdentifierTable['U+00A3'] = { code: 'ControlRight', location: RIGHT };
    keyIdentifierTable['U+00A4'] = { code: 'AltLeft', location: LEFT };
    keyIdentifierTable['U+00A5'] = { code: 'AltRight', location: RIGHT };
  }
  if ('chrome-mac' === browser_os) {
    keyIdentifierTable['U+0010'] = { code: 'ContextMenu' };
  }
  if ('safari-mac' === browser_os) {
    keyIdentifierTable['U+0010'] = { code: 'ContextMenu' };
  }
  if ('ios' === os) {
    // These only generate keyup events
    keyIdentifierTable['U+0010'] = { code: 'Function' };

    keyIdentifierTable['U+001C'] = { code: 'ArrowLeft' };
    keyIdentifierTable['U+001D'] = { code: 'ArrowRight' };
    keyIdentifierTable['U+001E'] = { code: 'ArrowUp' };
    keyIdentifierTable['U+001F'] = { code: 'ArrowDown' };

    keyIdentifierTable['U+0001'] = { code: 'Home' }; // [USB: 0x4a] Fn + ArrowLeft
    keyIdentifierTable['U+0004'] = { code: 'End' }; // [USB: 0x4d] Fn + ArrowRight
    keyIdentifierTable['U+000B'] = { code: 'PageUp' }; // [USB: 0x4b] Fn + ArrowUp
    keyIdentifierTable['U+000C'] = { code: 'PageDown' }; // [USB: 0x4e] Fn + ArrowDown
  }

  //--------------------------------------------------------------------
  //
  // Location Mappings
  //
  //--------------------------------------------------------------------

  // Cases where newer-ish browsers send location/keyLocation which
  // can be used to disambiguate keys.

  // locationTable[location][keyCode] -> keyInfo
  var locationTable = [];
  locationTable[LEFT] = {
    0x10: { code: 'ShiftLeft', location: LEFT }, // [USB: 0xe1]
    0x11: { code: 'ControlLeft', location: LEFT }, // [USB: 0xe0]
    0x12: { code: 'AltLeft', location: LEFT } // [USB: 0xe2]
  };
  locationTable[RIGHT] = {
    0x10: { code: 'ShiftRight', location: RIGHT }, // [USB: 0xe5]
    0x11: { code: 'ControlRight', location: RIGHT }, // [USB: 0xe4]
    0x12: { code: 'AltRight', location: RIGHT } // [USB: 0xe6]
  };
  locationTable[NUMPAD] = {
    0x0D: { code: 'NumpadEnter', location: NUMPAD } // [USB: 0x58]
  };

  mergeIf(locationTable[NUMPAD], 'moz', {
    0x6D: { code: 'NumpadSubtract', location: NUMPAD }, // [USB: 0x56]
    0x6B: { code: 'NumpadAdd', location: NUMPAD } // [USB: 0x57]
  });
  mergeIf(locationTable[LEFT], 'moz-mac', {
    0xE0: { code: 'OSLeft', location: LEFT } // [USB: 0xe3]
  });
  mergeIf(locationTable[RIGHT], 'moz-mac', {
    0xE0: { code: 'OSRight', location: RIGHT } // [USB: 0xe7]
  });
  mergeIf(locationTable[RIGHT], 'moz-win', {
    0x5B: { code: 'OSRight', location: RIGHT } // [USB: 0xe7]
  });


  mergeIf(locationTable[RIGHT], 'mac', {
    0x5D: { code: 'OSRight', location: RIGHT } // [USB: 0xe7]
  });

  mergeIf(locationTable[NUMPAD], 'chrome-mac', {
    0x0C: { code: 'NumLock', location: NUMPAD } // [USB: 0x53]
  });

  mergeIf(locationTable[NUMPAD], 'safari-mac', {
    0x0C: { code: 'NumLock', location: NUMPAD }, // [USB: 0x53]
    0xBB: { code: 'NumpadAdd', location: NUMPAD }, // [USB: 0x57]
    0xBD: { code: 'NumpadSubtract', location: NUMPAD }, // [USB: 0x56]
    0xBE: { code: 'NumpadDecimal', location: NUMPAD }, // [USB: 0x63]
    0xBF: { code: 'NumpadDivide', location: NUMPAD } // [USB: 0x54]
  });


  //--------------------------------------------------------------------
  //
  // Key Values
  //
  //--------------------------------------------------------------------

  // Mapping from `code` values to `key` values. Values defined at:
  // https://dvcs.w3.org/hg/dom3events/raw-file/tip/html/DOM3Events-key.html
  // Entries are only provided when `key` differs from `code`. If
  // printable, `shiftKey` has the shifted printable character. This
  // assumes US Standard 101 layout

  var codeToKeyTable = {
    // Modifier Keys
    ShiftLeft: { key: 'Shift' },
    ShiftRight: { key: 'Shift' },
    ControlLeft: { key: 'Control' },
    ControlRight: { key: 'Control' },
    AltLeft: { key: 'Alt' },
    AltRight: { key: 'Alt' },
    OSLeft: { key: 'OS' },
    OSRight: { key: 'OS' },

    // Whitespace Keys
    NumpadEnter: { key: 'Enter' },
    Space: { key: ' ' },

    // Printable Keys
    Digit0: { key: '0', shiftKey: ')' },
    Digit1: { key: '1', shiftKey: '!' },
    Digit2: { key: '2', shiftKey: '@' },
    Digit3: { key: '3', shiftKey: '#' },
    Digit4: { key: '4', shiftKey: '$' },
    Digit5: { key: '5', shiftKey: '%' },
    Digit6: { key: '6', shiftKey: '^' },
    Digit7: { key: '7', shiftKey: '&' },
    Digit8: { key: '8', shiftKey: '*' },
    Digit9: { key: '9', shiftKey: '(' },
    KeyA: { key: 'a', shiftKey: 'A' },
    KeyB: { key: 'b', shiftKey: 'B' },
    KeyC: { key: 'c', shiftKey: 'C' },
    KeyD: { key: 'd', shiftKey: 'D' },
    KeyE: { key: 'e', shiftKey: 'E' },
    KeyF: { key: 'f', shiftKey: 'F' },
    KeyG: { key: 'g', shiftKey: 'G' },
    KeyH: { key: 'h', shiftKey: 'H' },
    KeyI: { key: 'i', shiftKey: 'I' },
    KeyJ: { key: 'j', shiftKey: 'J' },
    KeyK: { key: 'k', shiftKey: 'K' },
    KeyL: { key: 'l', shiftKey: 'L' },
    KeyM: { key: 'm', shiftKey: 'M' },
    KeyN: { key: 'n', shiftKey: 'N' },
    KeyO: { key: 'o', shiftKey: 'O' },
    KeyP: { key: 'p', shiftKey: 'P' },
    KeyQ: { key: 'q', shiftKey: 'Q' },
    KeyR: { key: 'r', shiftKey: 'R' },
    KeyS: { key: 's', shiftKey: 'S' },
    KeyT: { key: 't', shiftKey: 'T' },
    KeyU: { key: 'u', shiftKey: 'U' },
    KeyV: { key: 'v', shiftKey: 'V' },
    KeyW: { key: 'w', shiftKey: 'W' },
    KeyX: { key: 'x', shiftKey: 'X' },
    KeyY: { key: 'y', shiftKey: 'Y' },
    KeyZ: { key: 'z', shiftKey: 'Z' },
    Numpad0: { key: '0' },
    Numpad1: { key: '1' },
    Numpad2: { key: '2' },
    Numpad3: { key: '3' },
    Numpad4: { key: '4' },
    Numpad5: { key: '5' },
    Numpad6: { key: '6' },
    Numpad7: { key: '7' },
    Numpad8: { key: '8' },
    Numpad9: { key: '9' },
    NumpadMultiply: { key: '*' },
    NumpadAdd: { key: '+' },
    NumpadComma: { key: ',' },
    NumpadSubtract: { key: '-' },
    NumpadDecimal: { key: '.' },
    NumpadDivide: { key: '/' },
    Semicolon: { key: ';', shiftKey: ':' },
    Equal: { key: '=', shiftKey: '+' },
    Comma: { key: ',', shiftKey: '<' },
    Minus: { key: '-', shiftKey: '_' },
    Period: { key: '.', shiftKey: '>' },
    Slash: { key: '/', shiftKey: '?' },
    Backquote: { key: '`', shiftKey: '~' },
    BracketLeft: { key: '[', shiftKey: '{' },
    Backslash: { key: '\\', shiftKey: '|' },
    BracketRight: { key: ']', shiftKey: '}' },
    Quote: { key: '\'', shiftKey: '"' },
    IntlBackslash: { key: '\\', shiftKey: '|' }
  };

  mergeIf(codeToKeyTable, 'mac', {
    OSLeft: { key: 'Meta' },
    OSRight: { key: 'Meta' }
  });

  // Corrections for 'key' names in older browsers (e.g. FF36-)
  // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent.key#Key_values
  var keyFixTable = {
    Esc: 'Escape',
    Nonconvert: 'NonConvert',
    Left: 'ArrowLeft',
    Up: 'ArrowUp',
    Right: 'ArrowRight',
    Down: 'ArrowDown',
    Del: 'Delete',
    Menu: 'ContextMenu',
    MediaNextTrack: 'MediaTrackNext',
    MediaPreviousTrack: 'MediaTrackPrevious',
    SelectMedia: 'MediaSelect',
    HalfWidth: 'Hankaku',
    FullWidth: 'Zenkaku',
    RomanCharacters: 'Romaji',
    Crsel: 'CrSel',
    Exsel: 'ExSel',
    Zoom: 'ZoomToggle'
  };

  //--------------------------------------------------------------------
  //
  // Exported Functions
  //
  //--------------------------------------------------------------------


  var codeTable = remap(keyCodeToInfoTable, 'code');

  try {
    var nativeLocation = nativeKeyboardEvent && ('location' in new KeyboardEvent(''));
  } catch (_) {}

  function keyInfoForEvent(event) {
    var keyCode = 'keyCode' in event ? event.keyCode : 'which' in event ? event.which : 0;

    var keyInfo = (function(){
      if (nativeLocation || 'keyLocation' in event) {
        var location = nativeLocation ? event.location : event.keyLocation;
        if (location && keyCode in locationTable[location]) {
          return locationTable[location][keyCode];
        }
      }
      if ('keyIdentifier' in event && event.keyIdentifier in keyIdentifierTable) {
        return keyIdentifierTable[event.keyIdentifier];
      }
      if (keyCode in keyCodeToInfoTable) {
        return keyCodeToInfoTable[keyCode];
      }
      return null;
    }());

    // TODO: Track these down and move to general tables
    if (0) {
      // TODO: Map these for newerish browsers?
      // TODO: iOS only?
      // TODO: Override with more common keyIdentifier name?
      switch (event.keyIdentifier) {
      case 'U+0010': keyInfo = { code: 'Function' }; break;
      case 'U+001C': keyInfo = { code: 'ArrowLeft' }; break;
      case 'U+001D': keyInfo = { code: 'ArrowRight' }; break;
      case 'U+001E': keyInfo = { code: 'ArrowUp' }; break;
      case 'U+001F': keyInfo = { code: 'ArrowDown' }; break;
      }
    }

    if (!keyInfo)
      return null;

    var key = (function() {
      var entry = codeToKeyTable[keyInfo.code];
      if (!entry) return keyInfo.code;
      return (event.shiftKey && 'shiftKey' in entry) ? entry.shiftKey : entry.key;
    }());

    return {
      code: keyInfo.code,
      key: key,
      location: keyInfo.location,
      keyCap: keyInfo.keyCap
    };
  }

  function queryKeyCap(code, locale) {
    code = String(code);
    if (!codeTable.hasOwnProperty(code)) return 'Undefined';
    if (locale && String(locale).toLowerCase() !== 'en-us') throw Error('Unsupported locale');
    var keyInfo = codeTable[code];
    return keyInfo.keyCap || keyInfo.code || 'Undefined';
  }

  if ('KeyboardEvent' in global && 'defineProperty' in Object) {
    (function() {
      function define(o, p, v) {
        if (p in o) return;
        Object.defineProperty(o, p, v);
      }

      define(KeyboardEvent.prototype, 'code', { get: function() {
        var keyInfo = keyInfoForEvent(this);
        return keyInfo ? keyInfo.code : '';
      }});

      // Fix for nonstandard `key` values (FF36-)
      if ('key' in KeyboardEvent.prototype) {
        var desc = Object.getOwnPropertyDescriptor(KeyboardEvent.prototype, 'key');
        Object.defineProperty(KeyboardEvent.prototype, 'key', { get: function() {
          var key = desc.get.call(this);
          return keyFixTable.hasOwnProperty(key) ? keyFixTable[key] : key;
        }});
      }

      define(KeyboardEvent.prototype, 'key', { get: function() {
        var keyInfo = keyInfoForEvent(this);
        return (keyInfo && 'key' in keyInfo) ? keyInfo.key : 'Unidentified';
      }});

      define(KeyboardEvent.prototype, 'location', { get: function() {
        var keyInfo = keyInfoForEvent(this);
        return (keyInfo && 'location' in keyInfo) ? keyInfo.location : STANDARD;
      }});

      define(KeyboardEvent.prototype, 'locale', { get: function() {
        return '';
      }});
    }());
  }

  if (!('queryKeyCap' in global.KeyboardEvent))
    global.KeyboardEvent.queryKeyCap = queryKeyCap;

  // Helper for IE8-
  global.identifyKey = function(event) {
    if ('code' in event)
      return;

    var keyInfo = keyInfoForEvent(event);
    event.code = keyInfo ? keyInfo.code : '';
    event.key = (keyInfo && 'key' in keyInfo) ? keyInfo.key : 'Unidentified';
    event.location = ('location' in event) ? event.location :
      ('keyLocation' in event) ? event.keyLocation :
      (keyInfo && 'location' in keyInfo) ? keyInfo.location : STANDARD;
    event.locale = '';
  };

} (window));


/***/ }),
/* 248 */
/***/ (function(module, exports) {

var EPS = 0.1;

module.exports = {
  schema: {
    enabled: {default: true},
    mode: {default: 'teleport', oneOf: ['teleport', 'animate']},
    animateSpeed: {default: 3.0}
  },

  init: function () {
    this.active = true;
    this.checkpoint = null;

    this.offset = new THREE.Vector3();
    this.position = new THREE.Vector3();
    this.targetPosition = new THREE.Vector3();
  },

  play: function () { this.active = true; },
  pause: function () { this.active = false; },

  setCheckpoint: function (checkpoint) {
    if (!this.active) return;

    this.checkpoint = checkpoint;
    if (this.data.mode === 'teleport') {
      this.sync();
      this.el.setAttribute('position', this.targetPosition);
    }
  },

  isVelocityActive: function () {
    return !!(this.active && this.checkpoint);
  },

  getVelocity: function () {
    if (!this.active) return;

    var data = this.data,
        offset = this.offset,
        position = this.position,
        targetPosition = this.targetPosition;

    this.sync();
    if (position.distanceTo(targetPosition) < EPS) {
      this.checkpoint = null;
      return offset.set(0, 0, 0);
    }
    offset.setLength(data.animateSpeed);
    return offset;
  },

  sync: function () {
    var offset = this.offset,
        position = this.position,
        targetPosition = this.targetPosition;

    position.copy(this.el.getAttribute('position'));
    targetPosition.copy(this.checkpoint.object3D.getWorldPosition());
    targetPosition.add(this.checkpoint.components.checkpoint.getOffset());
    offset.copy(targetPosition).sub(position);
  }
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Gamepad controls for A-Frame.
 *
 * Stripped-down version of: https://github.com/donmccurdy/aframe-gamepad-controls
 *
 * For more information about the Gamepad API, see:
 * https://developer.mozilla.org/en-US/docs/Web/API/Gamepad_API/Using_the_Gamepad_API
 */

var GamepadButton = __webpack_require__(241),
    GamepadButtonEvent = __webpack_require__(242);

var JOYSTICK_EPS = 0.2;

module.exports = {

  /*******************************************************************
   * Statics
   */

  GamepadButton: GamepadButton,

  /*******************************************************************
   * Schema
   */

  schema: {
    // Controller 0-3
    controller:        { default: 0, oneOf: [0, 1, 2, 3] },

    // Enable/disable features
    enabled:           { default: true },

    // Debugging
    debug:             { default: false }
  },

  /*******************************************************************
   * Core
   */

  /**
   * Called once when component is attached. Generally for initial setup.
   */
  init: function () {
    var scene = this.el.sceneEl;
    this.prevTime = window.performance.now();

    // Button state
    this.buttons = {};

    scene.addBehavior(this);
  },

  /**
   * Called when component is attached and when component data changes.
   * Generally modifies the entity based on the data.
   */
  update: function () { this.tick(); },

  /**
   * Called on each iteration of main render loop.
   */
  tick: function () {
    this.updateButtonState();
  },

  /**
   * Called when a component is removed (e.g., via removeAttribute).
   * Generally undoes all modifications to the entity.
   */
  remove: function () { },

  /*******************************************************************
   * Universal controls - movement
   */

  isVelocityActive: function () {
    if (!this.data.enabled || !this.isConnected()) return false;

    var dpad = this.getDpad(),
        joystick0 = this.getJoystick(0),
        inputX = dpad.x || joystick0.x,
        inputY = dpad.y || joystick0.y;

    return Math.abs(inputX) > JOYSTICK_EPS || Math.abs(inputY) > JOYSTICK_EPS;
  },

  getVelocityDelta: function () {
    var dpad = this.getDpad(),
        joystick0 = this.getJoystick(0),
        inputX = dpad.x || joystick0.x,
        inputY = dpad.y || joystick0.y,
        dVelocity = new THREE.Vector3();

    if (Math.abs(inputX) > JOYSTICK_EPS) {
      dVelocity.x += inputX;
    }
    if (Math.abs(inputY) > JOYSTICK_EPS) {
      dVelocity.z += inputY;
    }

    return dVelocity;
  },

  /*******************************************************************
   * Universal controls - rotation
   */

  isRotationActive: function () {
    if (!this.data.enabled || !this.isConnected()) return false;

    var joystick1 = this.getJoystick(1);

    return Math.abs(joystick1.x) > JOYSTICK_EPS || Math.abs(joystick1.y) > JOYSTICK_EPS;
  },

  getRotationDelta: function () {
    var lookVector = this.getJoystick(1);
    if (Math.abs(lookVector.x) <= JOYSTICK_EPS) lookVector.x = 0;
    if (Math.abs(lookVector.y) <= JOYSTICK_EPS) lookVector.y = 0;
    return lookVector;
  },

  /*******************************************************************
   * Button events
   */

  updateButtonState: function () {
    var gamepad = this.getGamepad();
    if (this.data.enabled && gamepad) {

      // Fire DOM events for button state changes.
      for (var i = 0; i < gamepad.buttons.length; i++) {
        if (gamepad.buttons[i].pressed && !this.buttons[i]) {
          this.emit(new GamepadButtonEvent('gamepadbuttondown', i, gamepad.buttons[i]));
        } else if (!gamepad.buttons[i].pressed && this.buttons[i]) {
          this.emit(new GamepadButtonEvent('gamepadbuttonup', i, gamepad.buttons[i]));
        }
        this.buttons[i] = gamepad.buttons[i].pressed;
      }

    } else if (Object.keys(this.buttons)) {
      // Reset state if controls are disabled or controller is lost.
      this.buttons = {};
    }
  },

  emit: function (event) {
    // Emit original event.
    this.el.emit(event.type, event);

    // Emit convenience event, identifying button index.
    this.el.emit(
      event.type + ':' + event.index,
      new GamepadButtonEvent(event.type, event.index, event)
    );
  },

  /*******************************************************************
   * Gamepad state
   */

  /**
   * Returns the Gamepad instance attached to the component. If connected,
   * a proxy-controls component may provide access to Gamepad input from a
   * remote device.
   *
   * @return {Gamepad}
   */
  getGamepad: function () {
    var localGamepad = navigator.getGamepads
          && navigator.getGamepads()[this.data.controller],
        proxyControls = this.el.sceneEl.components['proxy-controls'],
        proxyGamepad = proxyControls && proxyControls.isConnected()
          && proxyControls.getGamepad(this.data.controller);
    return proxyGamepad || localGamepad;
  },

  /**
   * Returns the state of the given button.
   * @param  {number} index The button (0-N) for which to find state.
   * @return {GamepadButton}
   */
  getButton: function (index) {
    return this.getGamepad().buttons[index];
  },

  /**
   * Returns state of the given axis. Axes are labelled 0-N, where 0-1 will
   * represent X/Y on the first joystick, and 2-3 X/Y on the second.
   * @param  {number} index The axis (0-N) for which to find state.
   * @return {number} On the interval [-1,1].
   */
  getAxis: function (index) {
    return this.getGamepad().axes[index];
  },

  /**
   * Returns the state of the given joystick (0 or 1) as a THREE.Vector2.
   * @param  {number} id The joystick (0, 1) for which to find state.
   * @return {THREE.Vector2}
   */
  getJoystick: function (index) {
    var gamepad = this.getGamepad();
    switch (index) {
      case 0: return new THREE.Vector2(gamepad.axes[0], gamepad.axes[1]);
      case 1: return new THREE.Vector2(gamepad.axes[2], gamepad.axes[3]);
      default: throw new Error('Unexpected joystick index "%d".', index);
    }
  },

  /**
   * Returns the state of the dpad as a THREE.Vector2.
   * @return {THREE.Vector2}
   */
  getDpad: function () {
    var gamepad = this.getGamepad();
    if (!gamepad.buttons[GamepadButton.DPAD_RIGHT]) {
      return new THREE.Vector2();
    }
    return new THREE.Vector2(
      (gamepad.buttons[GamepadButton.DPAD_RIGHT].pressed ? 1 : 0)
      + (gamepad.buttons[GamepadButton.DPAD_LEFT].pressed ? -1 : 0),
      (gamepad.buttons[GamepadButton.DPAD_UP].pressed ? -1 : 0)
      + (gamepad.buttons[GamepadButton.DPAD_DOWN].pressed ? 1 : 0)
    );
  },

  /**
   * Returns true if the gamepad is currently connected to the system.
   * @return {boolean}
   */
  isConnected: function () {
    var gamepad = this.getGamepad();
    return !!(gamepad && gamepad.connected);
  },

  /**
   * Returns a string containing some information about the controller. Result
   * may vary across browsers, for a given controller.
   * @return {string}
   */
  getID: function () {
    return this.getGamepad().id;
  }
};


/***/ }),
/* 250 */
/***/ (function(module, exports) {

var radToDeg = THREE.Math.radToDeg,
    isMobile = AFRAME.utils.device.isMobile();

module.exports = {
  schema: {
    enabled: {default: true},
    standing: {default: true}
  },

  init: function () {
    this.isPositionCalibrated = false;
    this.dolly = new THREE.Object3D();
    this.hmdEuler = new THREE.Euler();
    this.previousHMDPosition = new THREE.Vector3();
    this.deltaHMDPosition = new THREE.Vector3();
    this.vrControls = new THREE.VRControls(this.dolly);
    this.rotation = new THREE.Vector3();
  },

  update: function () {
    var data = this.data;
    var vrControls = this.vrControls;
    vrControls.standing = data.standing;
    vrControls.update();
  },

  tick: function () {
    this.vrControls.update();
  },

  remove: function () {
    this.vrControls.dispose();
  },

  isRotationActive: function () {
    var hmdEuler = this.hmdEuler;
    if (!this.data.enabled || !(this.el.sceneEl.is('vr-mode') || isMobile)) {
      return false;
    }
    hmdEuler.setFromQuaternion(this.dolly.quaternion, 'YXZ');
    return !isNullVector(hmdEuler);
  },

  getRotation: function () {
    var hmdEuler = this.hmdEuler;
    return this.rotation.set(
      radToDeg(hmdEuler.x),
      radToDeg(hmdEuler.y),
      radToDeg(hmdEuler.z)
    );
  },

  isVelocityActive: function () {
    var deltaHMDPosition = this.deltaHMDPosition;
    var previousHMDPosition = this.previousHMDPosition;
    var currentHMDPosition = this.calculateHMDPosition();
    this.isPositionCalibrated = this.isPositionCalibrated || !isNullVector(previousHMDPosition);
    if (!this.data.enabled || !this.el.sceneEl.is('vr-mode') || isMobile) {
      return false;
    }
    deltaHMDPosition.copy(currentHMDPosition).sub(previousHMDPosition);
    previousHMDPosition.copy(currentHMDPosition);
    return this.isPositionCalibrated && !isNullVector(deltaHMDPosition);
  },

  getPositionDelta: function () {
    return this.deltaHMDPosition;
  },

  calculateHMDPosition: function () {
    var dolly = this.dolly;
    var position = new THREE.Vector3();
    dolly.updateMatrix();
    position.setFromMatrixPosition(dolly.matrix);
    return position;
  }
};

function isNullVector (vector) {
  return vector.x === 0 && vector.y === 0 && vector.z === 0;
}


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var physics = __webpack_require__(95);

module.exports = {
  'checkpoint-controls': __webpack_require__(248),
  'gamepad-controls':    __webpack_require__(249),
  'hmd-controls':        __webpack_require__(250),
  'keyboard-controls':   __webpack_require__(252),
  'mouse-controls':      __webpack_require__(253),
  'touch-controls':      __webpack_require__(254),
  'universal-controls':  __webpack_require__(255),

  registerAll: function (AFRAME) {
    if (this._registered) return;

    AFRAME = AFRAME || window.AFRAME;

    physics.registerAll();
    if (!AFRAME.components['checkpoint-controls'])  AFRAME.registerComponent('checkpoint-controls', this['checkpoint-controls']);
    if (!AFRAME.components['gamepad-controls'])     AFRAME.registerComponent('gamepad-controls',    this['gamepad-controls']);
    if (!AFRAME.components['hmd-controls'])         AFRAME.registerComponent('hmd-controls',        this['hmd-controls']);
    if (!AFRAME.components['keyboard-controls'])    AFRAME.registerComponent('keyboard-controls',   this['keyboard-controls']);
    if (!AFRAME.components['mouse-controls'])       AFRAME.registerComponent('mouse-controls',      this['mouse-controls']);
    if (!AFRAME.components['touch-controls'])       AFRAME.registerComponent('touch-controls',      this['touch-controls']);
    if (!AFRAME.components['universal-controls'])   AFRAME.registerComponent('universal-controls',  this['universal-controls']);

    this._registered = true;
  }
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(247);

var MAX_DELTA = 0.2,
    PROXY_FLAG = '__keyboard-controls-proxy';

var KeyboardEvent = window.KeyboardEvent;

/**
 * Keyboard Controls component.
 *
 * Stripped-down version of: https://github.com/donmccurdy/aframe-keyboard-controls
 *
 * Bind keyboard events to components, or control your entities with the WASD keys.
 *
 * Why use KeyboardEvent.code? "This is set to a string representing the key that was pressed to
 * generate the KeyboardEvent, without taking the current keyboard layout (e.g., QWERTY vs.
 * Dvorak), locale (e.g., English vs. French), or any modifier keys into account. This is useful
 * when you care about which physical key was pressed, rather thanwhich character it corresponds
 * to. For example, if you’re a writing a game, you might want a certain set of keys to move the
 * player in different directions, and that mapping should ideally be independent of keyboard
 * layout. See: https://developers.google.com/web/updates/2016/04/keyboardevent-keys-codes
 *
 * @namespace wasd-controls
 * keys the entity moves and if you release it will stop. Easing simulates friction.
 * to the entity when pressing the keys.
 * @param {bool} [enabled=true] - To completely enable or disable the controls
 */
module.exports = {
  schema: {
    enabled:           { default: true },
    debug:             { default: false }
  },

  init: function () {
    this.dVelocity = new THREE.Vector3();
    this.localKeys = {};
    this.listeners = {
      keydown: this.onKeyDown.bind(this),
      keyup: this.onKeyUp.bind(this),
      blur: this.onBlur.bind(this)
    };
    this.attachEventListeners();
  },

  /*******************************************************************
  * Movement
  */

  isVelocityActive: function () {
    return this.data.enabled && !!Object.keys(this.getKeys()).length;
  },

  getVelocityDelta: function () {
    var data = this.data,
        keys = this.getKeys();

    this.dVelocity.set(0, 0, 0);
    if (data.enabled) {
      if (keys.KeyW || keys.ArrowUp)    { this.dVelocity.z -= 1; }
      if (keys.KeyA || keys.ArrowLeft)  { this.dVelocity.x -= 1; }
      if (keys.KeyS || keys.ArrowDown)  { this.dVelocity.z += 1; }
      if (keys.KeyD || keys.ArrowRight) { this.dVelocity.x += 1; }
    }

    return this.dVelocity.clone();
  },

  /*******************************************************************
  * Events
  */

  play: function () {
    this.attachEventListeners();
  },

  pause: function () {
    this.removeEventListeners();
  },

  remove: function () {
    this.pause();
  },

  attachEventListeners: function () {
    window.addEventListener('keydown', this.listeners.keydown, false);
    window.addEventListener('keyup', this.listeners.keyup, false);
    window.addEventListener('blur', this.listeners.blur, false);
  },

  removeEventListeners: function () {
    window.removeEventListener('keydown', this.listeners.keydown);
    window.removeEventListener('keyup', this.listeners.keyup);
    window.removeEventListener('blur', this.listeners.blur);
  },

  onKeyDown: function (event) {
    if (AFRAME.utils.shouldCaptureKeyEvent(event)) {
      this.localKeys[event.code] = true;
      this.emit(event);
    }
  },

  onKeyUp: function (event) {
    if (AFRAME.utils.shouldCaptureKeyEvent(event)) {
      delete this.localKeys[event.code];
      this.emit(event);
    }
  },

  onBlur: function () {
    for (var code in this.localKeys) {
      if (this.localKeys.hasOwnProperty(code)) {
        delete this.localKeys[code];
      }
    }
  },

  emit: function (event) {
    // TODO - keydown only initially?
    // TODO - where the f is the spacebar

    // Emit original event.
    if (PROXY_FLAG in event) {
      // TODO - Method never triggered.
      this.el.emit(event.type, event);
    }

    // Emit convenience event, identifying key.
    this.el.emit(event.type + ':' + event.code, new KeyboardEvent(event.type, event));
    if (this.data.debug) console.log(event.type + ':' + event.code);
  },

  /*******************************************************************
  * Accessors
  */

  isPressed: function (code) {
    return code in this.getKeys();
  },

  getKeys: function () {
    if (this.isProxied()) {
      return this.el.sceneEl.components['proxy-controls'].getKeyboard();
    }
    return this.localKeys;
  },

  isProxied: function () {
    var proxyControls = this.el.sceneEl.components['proxy-controls'];
    return proxyControls && proxyControls.isConnected();
  }

};


/***/ }),
/* 253 */
/***/ (function(module, exports) {

document.exitPointerLock = document.exitPointerLock || document.mozExitPointerLock;

/**
 * Mouse + Pointerlock controls.
 *
 * Based on: https://github.com/aframevr/aframe/pull/1056
 */
module.exports = {
  schema: {
    enabled: { default: true },
    pointerlockEnabled: { default: true },
    sensitivity: { default: 1 / 25 }
  },

  init: function () {
    this.mouseDown = false;
    this.pointerLocked = false;
    this.lookVector = new THREE.Vector2();
    this.bindMethods();
  },

  update: function (previousData) {
    var data = this.data;
    if (previousData.pointerlockEnabled && !data.pointerlockEnabled && this.pointerLocked) {
      document.exitPointerLock();
    }
  },

  play: function () {
    this.addEventListeners();
  },

  pause: function () {
    this.removeEventListeners();
    this.lookVector.set(0, 0);
  },

  remove: function () {
    this.pause();
  },

  bindMethods: function () {
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onPointerLockChange = this.onPointerLockChange.bind(this);
    this.onPointerLockChange = this.onPointerLockChange.bind(this);
    this.onPointerLockChange = this.onPointerLockChange.bind(this);
  },

  addEventListeners: function () {
    var sceneEl = this.el.sceneEl;
    var canvasEl = sceneEl.canvas;
    var data = this.data;

    if (!canvasEl) {
      sceneEl.addEventListener('render-target-loaded', this.addEventListeners.bind(this));
      return;
    }

    canvasEl.addEventListener('mousedown', this.onMouseDown, false);
    canvasEl.addEventListener('mousemove', this.onMouseMove, false);
    canvasEl.addEventListener('mouseup', this.onMouseUp, false);
    canvasEl.addEventListener('mouseout', this.onMouseUp, false);

    if (data.pointerlockEnabled) {
      document.addEventListener('pointerlockchange', this.onPointerLockChange, false);
      document.addEventListener('mozpointerlockchange', this.onPointerLockChange, false);
      document.addEventListener('pointerlockerror', this.onPointerLockError, false);
    }
  },

  removeEventListeners: function () {
    var canvasEl = this.el.sceneEl && this.el.sceneEl.canvas;
    if (canvasEl) {
      canvasEl.removeEventListener('mousedown', this.onMouseDown, false);
      canvasEl.removeEventListener('mousemove', this.onMouseMove, false);
      canvasEl.removeEventListener('mouseup', this.onMouseUp, false);
      canvasEl.removeEventListener('mouseout', this.onMouseUp, false);
    }
    document.removeEventListener('pointerlockchange', this.onPointerLockChange, false);
    document.removeEventListener('mozpointerlockchange', this.onPointerLockChange, false);
    document.removeEventListener('pointerlockerror', this.onPointerLockError, false);
  },

  isRotationActive: function () {
    return this.data.enabled && (this.mouseDown || this.pointerLocked);
  },

  /**
   * Returns the sum of all mouse movement since last call.
   */
  getRotationDelta: function () {
    var dRotation = this.lookVector.clone().multiplyScalar(this.data.sensitivity);
    this.lookVector.set(0, 0);
    return dRotation;
  },

  onMouseMove: function (event) {
    var previousMouseEvent = this.previousMouseEvent;

    if (!this.data.enabled || !(this.mouseDown || this.pointerLocked)) {
      return;
    }

    var movementX = event.movementX || event.mozMovementX || 0;
    var movementY = event.movementY || event.mozMovementY || 0;

    if (!this.pointerLocked) {
      movementX = event.screenX - previousMouseEvent.screenX;
      movementY = event.screenY - previousMouseEvent.screenY;
    }

    this.lookVector.x += movementX;
    this.lookVector.y += movementY;

    this.previousMouseEvent = event;
  },

  onMouseDown: function (event) {
    var canvasEl = this.el.sceneEl.canvas,
        isEditing = (AFRAME.INSPECTOR || {}).opened;

    this.mouseDown = true;
    this.previousMouseEvent = event;

    if (this.data.pointerlockEnabled && !this.pointerLocked && !isEditing) {
      if (canvasEl.requestPointerLock) {
        canvasEl.requestPointerLock();
      } else if (canvasEl.mozRequestPointerLock) {
        canvasEl.mozRequestPointerLock();
      }
    }
  },

  onMouseUp: function () {
    this.mouseDown = false;
  },

  onPointerLockChange: function () {
    this.pointerLocked = !!(document.pointerLockElement || document.mozPointerLockElement);
  },

  onPointerLockError: function () {
    this.pointerLocked = false;
  }
};


/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports = {
  schema: {
    enabled: { default: true }
  },

  init: function () {
    this.dVelocity = new THREE.Vector3();
    this.bindMethods();
  },

  play: function () {
    this.addEventListeners();
  },

  pause: function () {
    this.removeEventListeners();
    this.dVelocity.set(0, 0, 0);
  },

  remove: function () {
    this.pause();
  },

  addEventListeners: function () {
    var sceneEl = this.el.sceneEl;
    var canvasEl = sceneEl.canvas;

    if (!canvasEl) {
      sceneEl.addEventListener('render-target-loaded', this.addEventListeners.bind(this));
      return;
    }

    canvasEl.addEventListener('touchstart', this.onTouchStart);
    canvasEl.addEventListener('touchend', this.onTouchEnd);
  },

  removeEventListeners: function () {
    var canvasEl = this.el.sceneEl && this.el.sceneEl.canvas;
    if (!canvasEl) { return; }

    canvasEl.removeEventListener('touchstart', this.onTouchStart);
    canvasEl.removeEventListener('touchend', this.onTouchEnd);
  },

  isVelocityActive: function () {
    return this.data.enabled && this.isMoving;
  },

  getVelocityDelta: function () {
    this.dVelocity.z = this.isMoving ? -1 : 0;
    return this.dVelocity.clone();
  },

  bindMethods: function () {
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
  },

  onTouchStart: function (e) {
    this.isMoving = true;
    e.preventDefault();
  },

  onTouchEnd: function (e) {
    this.isMoving = false;
    e.preventDefault();
  }
};


/***/ }),
/* 255 */
/***/ (function(module, exports) {

/**
 * Universal Controls
 *
 * @author Don McCurdy <dm@donmccurdy.com>
 */

var COMPONENT_SUFFIX = '-controls',
    MAX_DELTA = 0.2, // ms
    PI_2 = Math.PI / 2;

module.exports = {

  /*******************************************************************
   * Schema
   */

  dependencies: ['velocity', 'rotation'],

  schema: {
    enabled:              { default: true },
    movementEnabled:      { default: true },
    movementControls:     { default: ['gamepad', 'keyboard', 'touch', 'hmd'] },
    rotationEnabled:      { default: true },
    rotationControls:     { default: ['hmd', 'gamepad', 'mouse'] },
    movementSpeed:        { default: 5 }, // m/s
    movementEasing:       { default: 15 }, // m/s2
    movementEasingY:      { default: 0  }, // m/s2
    movementAcceleration: { default: 80 }, // m/s2
    rotationSensitivity:  { default: 0.05 }, // radians/frame, ish
    fly:                  { default: false },
  },

  /*******************************************************************
   * Lifecycle
   */

  init: function () {
    var rotation = this.el.getAttribute('rotation');

    if (this.el.hasAttribute('look-controls') && this.data.rotationEnabled) {
      console.error('[universal-controls] The `universal-controls` component is a replacement '
        + 'for `look-controls`, and cannot be used in combination with it.');
    }

    // Movement
    this.velocity = new THREE.Vector3();

    // Rotation
    this.pitch = new THREE.Object3D();
    this.pitch.rotation.x = THREE.Math.degToRad(rotation.x);
    this.yaw = new THREE.Object3D();
    this.yaw.position.y = 10;
    this.yaw.rotation.y = THREE.Math.degToRad(rotation.y);
    this.yaw.add(this.pitch);
    this.heading = new THREE.Euler(0, 0, 0, 'YXZ');

    if (this.el.sceneEl.hasLoaded) {
      this.injectControls();
    } else {
      this.el.sceneEl.addEventListener('loaded', this.injectControls.bind(this));
    }
  },

  update: function () {
    if (this.el.sceneEl.hasLoaded) {
      this.injectControls();
    }
  },

  injectControls: function () {
    var i, name,
        data = this.data;

    for (i = 0; i < data.movementControls.length; i++) {
      name = data.movementControls[i] + COMPONENT_SUFFIX;
      if (!this.el.components[name]) {
        this.el.setAttribute(name, '');
      }
    }

    for (i = 0; i < data.rotationControls.length; i++) {
      name = data.rotationControls[i] + COMPONENT_SUFFIX;
      if (!this.el.components[name]) {
        this.el.setAttribute(name, '');
      }
    }
  },

  /*******************************************************************
   * Tick
   */

  tick: function (t, dt) {
    if (!dt) { return; }

    // Update rotation.
    if (this.data.rotationEnabled) this.updateRotation(dt);

    // Update velocity. If FPS is too low, reset.
    if (this.data.movementEnabled && dt / 1000 > MAX_DELTA) {
      this.velocity.set(0, 0, 0);
      this.el.setAttribute('velocity', this.velocity);
    } else {
      this.updateVelocity(dt);
    }
  },

  /*******************************************************************
   * Rotation
   */

  updateRotation: function (dt) {
    var control, dRotation,
        data = this.data;

    for (var i = 0, l = data.rotationControls.length; i < l; i++) {
      control = this.el.components[data.rotationControls[i] + COMPONENT_SUFFIX];
      if (control && control.isRotationActive()) {
        if (control.getRotationDelta) {
          dRotation = control.getRotationDelta(dt);
          dRotation.multiplyScalar(data.rotationSensitivity);
          this.yaw.rotation.y -= dRotation.x;
          this.pitch.rotation.x -= dRotation.y;
          this.pitch.rotation.x = Math.max(-PI_2, Math.min(PI_2, this.pitch.rotation.x));
          this.el.setAttribute('rotation', {
            x: THREE.Math.radToDeg(this.pitch.rotation.x),
            y: THREE.Math.radToDeg(this.yaw.rotation.y),
            z: 0
          });
        } else if (control.getRotation) {
          this.el.setAttribute('rotation', control.getRotation());
        } else {
          throw new Error('Incompatible rotation controls: %s', data.rotationControls[i]);
        }
        break;
      }
    }
  },

  /*******************************************************************
   * Movement
   */

  updateVelocity: function (dt) {
    var control, dVelocity,
        velocity = this.velocity,
        data = this.data;

    if (data.movementEnabled) {
      for (var i = 0, l = data.movementControls.length; i < l; i++) {
        control = this.el.components[data.movementControls[i] + COMPONENT_SUFFIX];
        if (control && control.isVelocityActive()) {
          if (control.getVelocityDelta) {
            dVelocity = control.getVelocityDelta(dt);
          } else if (control.getVelocity) {
            this.el.setAttribute('velocity', control.getVelocity());
            return;
          } else if (control.getPositionDelta) {
            velocity.copy(control.getPositionDelta(dt).multiplyScalar(1000 / dt));
            this.el.setAttribute('velocity', velocity);
            return;
          } else {
            throw new Error('Incompatible movement controls: ', data.movementControls[i]);
          }
          break;
        }
      }
    }

    velocity.copy(this.el.getAttribute('velocity'));
    velocity.x -= velocity.x * data.movementEasing * dt / 1000;
    velocity.y -= velocity.y * data.movementEasingY * dt / 1000;
    velocity.z -= velocity.z * data.movementEasing * dt / 1000;

    if (dVelocity && data.movementEnabled) {
      // Set acceleration
      if (dVelocity.length() > 1) {
        dVelocity.setLength(this.data.movementAcceleration * dt / 1000);
      } else {
        dVelocity.multiplyScalar(this.data.movementAcceleration * dt / 1000);
      }

      // Rotate to heading
      var rotation = this.el.getAttribute('rotation');
      if (rotation) {
        this.heading.set(
          data.fly ? THREE.Math.degToRad(rotation.x) : 0,
          THREE.Math.degToRad(rotation.y),
          0
        );
        dVelocity.applyEuler(this.heading);
      }

      velocity.add(dVelocity);

      // TODO - Several issues here:
      // (1) Interferes w/ gravity.
      // (2) Interferes w/ jumping.
      // (3) Likely to interfere w/ relative position to moving platform.
      // if (velocity.length() > data.movementSpeed) {
      //   velocity.setLength(data.movementSpeed);
      // }
    }

    this.el.setAttribute('velocity', velocity);
  }
};


/***/ }),
/* 256 */
/***/ (function(module, exports) {

var LoopMode = {
  once: THREE.LoopOnce,
  repeat: THREE.LoopRepeat,
  pingpong: THREE.LoopPingPong
};

/**
 * animation-mixer
 *
 * Player for animation clips. Intended to be compatible with any model format that supports
 * skeletal or morph animations through THREE.AnimationMixer.
 * See: https://threejs.org/docs/?q=animation#Reference/Animation/AnimationMixer
 */
module.exports = {
  schema: {
    clip:  {default: '*'},
    duration: {default: 0},
    crossFadeDuration: {default: 0},
    loop: {default: 'repeat', oneOf: Object.keys(LoopMode)},
    repetitions: {default: Infinity, min: 0}
  },

  init: function () {
    /** @type {THREE.Mesh} */
    this.model = null;
    /** @type {THREE.AnimationMixer} */
    this.mixer = null;
    /** @type {Array<THREE.AnimationAction>} */
    this.activeActions = [];

    var model = this.el.getObject3D('mesh');

    if (model) {
      this.load(model);
    } else {
      this.el.addEventListener('model-loaded', function(e) {
        this.load(e.detail.model);
      }.bind(this));
    }
  },

  load: function (model) {
    var el = this.el;
    this.model = model;
    this.mixer = new THREE.AnimationMixer(model);
    this.mixer.addEventListener('loop', function (e) {
      el.emit('animation-loop', {action: e.action, loopDelta: e.loopDelta});
    }.bind(this));
    this.mixer.addEventListener('finished', function (e) {
      el.emit('animation-finished', {action: e.action, direction: e.direction});
    }.bind(this));
    if (this.data.clip) this.update({});
  },

  remove: function () {
    if (this.mixer) this.mixer.stopAllAction();
  },

  update: function (previousData) {
    if (!previousData) return;

    this.stopAction();

    if (this.data.clip) {
      this.playAction();
    }
  },

  stopAction: function () {
    var data = this.data;
    for (var i = 0; i < this.activeActions.length; i++) {
      data.crossFadeDuration
        ? this.activeActions[i].fadeOut(data.crossFadeDuration)
        : this.activeActions[i].stop();
    }
    this.activeActions.length = 0;
  },

  playAction: function () {
    if (!this.mixer) return;

    var model = this.model,
        data = this.data,
        clips = model.animations || (model.geometry || {}).animations || [];

    if (!clips.length) return;

    var re = wildcardToRegExp(data.clip);

    for (var clip, i = 0; (clip = clips[i]); i++) {
      if (clip.name.match(re)) {
        var action = this.mixer.clipAction(clip, model);
        action.enabled = true;
        if (data.duration) action.setDuration(data.duration);
        action
          .setLoop(LoopMode[data.loop], data.repetitions)
          .fadeIn(data.crossFadeDuration)
          .play();
        this.activeActions.push(action);
      }
    }
  },

  tick: function (t, dt) {
    if (this.mixer && !isNaN(dt)) this.mixer.update(dt / 1000);
  }
};

/**
 * Creates a RegExp from the given string, converting asterisks to .* expressions,
 * and escaping all other characters.
 */
function wildcardToRegExp (s) {
  return new RegExp('^' + s.split(/\*+/).map(regExpEscape).join('.*') + '$');
}

/**
 * RegExp-escapes all characters in the given string.
 */
function regExpEscape (s) {
  return s.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
}


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

THREE.FBXLoader = __webpack_require__(240);

/**
 * fbx-model
 *
 * Loader for FBX format. Supports ASCII, but *not* binary, models.
 */
module.exports = {
  schema: {
    src:         { type: 'asset' },
    crossorigin: { default: '' }
  },

  init: function () {
    this.model = null;
  },

  update: function () {
    var loader,
        data = this.data;
    if (!data.src) return;

    this.remove();
    loader = new THREE.FBXLoader();
    if (data.crossorigin) loader.setCrossOrigin(data.crossorigin);
    loader.load(data.src, this.load.bind(this));
  },

  load: function (model) {
    this.model = model;
    this.el.setObject3D('mesh', model);
    this.el.emit('model-loaded', {format: 'fbx', model: model});
  },

  remove: function () {
    if (this.model) this.el.removeObject3D('mesh');
  }
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var fetchScript = __webpack_require__(245)();

var LOADER_SRC = 'https://rawgit.com/mrdoob/three.js/dev/examples/js/loaders/GLTF2Loader.js';

// Monkeypatch while waiting for three.js r86.
if (THREE.PropertyBinding.sanitizeNodeName === undefined) {

  THREE.PropertyBinding.sanitizeNodeName = function (s) { return s; };

}

/**
 * Upcoming (and NOT YET STABLE) loader for glTF 2.0 models.
 * Pulls THREE.GLTF2Loader directly from three.js 'dev' branch.
 */
module.exports = {
  schema: {type: 'model'},

  init: function () {
    this.model = null;
    this.loader = null;
    this.loaderPromise = loadLoader().then(function () {
      this.loader = new THREE.GLTF2Loader();
    }.bind(this));
  },

  update: function () {
    var self = this;
    var el = this.el;
    var src = this.data;

    if (!src) { return; }

    this.remove();

    this.loaderPromise.then(function () {
      this.loader.load(src, function gltfLoaded (gltfModel) {
        self.model = gltfModel.scene;
        self.model.animations = gltfModel.animations;
        el.setObject3D('mesh', self.model);
        el.emit('model-loaded', {format: 'gltf', model: self.model});
      });
    }.bind(this));
  },

  remove: function () {
    if (!this.model) { return; }
    this.el.removeObject3D('mesh');
  }
};

var loadLoader = (function () {
  var promise;
  return function () {
    promise = promise || fetchScript(LOADER_SRC);
    return promise;
  };
}());


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'animation-mixer': __webpack_require__(256),
  'fbx-model': __webpack_require__(257),
  'gltf-model-next': __webpack_require__(258),
  'json-model': __webpack_require__(260),
  'object-model': __webpack_require__(261),
  'ply-model': __webpack_require__(262),
  'three-model': __webpack_require__(263),

  registerAll: function (AFRAME) {
    if (this._registered) return;

    AFRAME = AFRAME || window.AFRAME;

    // THREE.AnimationMixer
    if (!AFRAME.components['animation-mixer']) {
      AFRAME.registerComponent('animation-mixer', this['animation-mixer']);
    }

    // THREE.PlyLoader
    if (!AFRAME.systems['ply-model']) {
      AFRAME.registerSystem('ply-model', this['ply-model'].System);
    }
    if (!AFRAME.components['ply-model']) {
      AFRAME.registerComponent('ply-model', this['ply-model'].Component);
    }

    // THREE.FBXLoader
    if (!AFRAME.components['fbx-model']) {
      AFRAME.registerComponent('fbx-model', this['fbx-model']);
    }

    // THREE.GLTF2Loader (_unstable_)
    if (!AFRAME.components['gltf-model-next']) {
      AFRAME.registerComponent('gltf-model-next', this['gltf-model-next']);
    }

    // THREE.JsonLoader
    if (!AFRAME.components['json-model']) {
      AFRAME.registerComponent('json-model', this['json-model']);
    }

    // THREE.ObjectLoader
    if (!AFRAME.components['object-model']) {
      AFRAME.registerComponent('object-model', this['object-model']);
    }

    // (deprecated) THREE.JsonLoader and THREE.ObjectLoader
    if (!AFRAME.components['three-model']) {
      AFRAME.registerComponent('three-model', this['three-model']);
    }

    this._registered = true;
  }
};


/***/ }),
/* 260 */
/***/ (function(module, exports) {

/**
 * json-model
 *
 * Loader for THREE.js JSON format. Somewhat confusingly, there are two different THREE.js formats,
 * both having the .json extension. This loader supports only THREE.JsonLoader, which typically
 * includes only a single mesh.
 *
 * Check the console for errors, if in doubt. You may need to use `object-model` or
 * `blend-character-model` for some .js and .json files.
 *
 * See: https://clara.io/learn/user-guide/data_exchange/threejs_export
 */
module.exports = {
  schema: {
    src:         { type: 'asset' },
    crossorigin: { default: '' }
  },

  init: function () {
    this.model = null;
  },

  update: function () {
    var loader,
        data = this.data;
    if (!data.src) return;

    this.remove();
    loader = new THREE.JSONLoader();
    if (data.crossorigin) loader.crossOrigin = data.crossorigin;
    loader.load(data.src, function (geometry, materials) {

      // Attempt to automatically detect common material options.
      materials.forEach(function (mat) {
        mat.vertexColors = (geometry.faces[0] || {}).color ? THREE.FaceColors : THREE.NoColors;
        mat.skinning = !!(geometry.bones || []).length;
        mat.morphTargets = !!(geometry.morphTargets || []).length;
        mat.morphNormals = !!(geometry.morphNormals || []).length;
      });

      var model = (geometry.bones || []).length
        ? new THREE.SkinnedMesh(geometry, new THREE.MultiMaterial(materials))
        : new THREE.Mesh(geometry, new THREE.MultiMaterial(materials));

      this.load(model);
    }.bind(this));
  },

  load: function (model) {
    this.model = model;
    this.el.setObject3D('mesh', model);
    this.el.emit('model-loaded', {format: 'json', model: model});
  },

  remove: function () {
    if (this.model) this.el.removeObject3D('mesh');
  }
};


/***/ }),
/* 261 */
/***/ (function(module, exports) {

/**
 * object-model
 *
 * Loader for THREE.js JSON format. Somewhat confusingly, there are two different THREE.js formats,
 * both having the .json extension. This loader supports only THREE.ObjectLoader, which typically
 * includes multiple meshes or an entire scene.
 *
 * Check the console for errors, if in doubt. You may need to use `json-model` or
 * `blend-character-model` for some .js and .json files.
 *
 * See: https://clara.io/learn/user-guide/data_exchange/threejs_export
 */
module.exports = {
  schema: {
    src:         { type: 'asset' },
    crossorigin: { default: '' }
  },

  init: function () {
    this.model = null;
  },

  update: function () {
    var loader,
        data = this.data;
    if (!data.src) return;

    this.remove();
    loader = new THREE.ObjectLoader();
    if (data.crossorigin) loader.setCrossOrigin(data.crossorigin);
    loader.load(data.src, function(object) {

      // Enable skinning, if applicable.
      object.traverse(function(o) {
        if (o instanceof THREE.SkinnedMesh && o.material) {
          o.material.skinning = !!((o.geometry && o.geometry.bones) || []).length;
        }
      });

      this.load(object);
    }.bind(this));
  },

  load: function (model) {
    this.model = model;
    this.el.setObject3D('mesh', model);
    this.el.emit('model-loaded', {format: 'json', model: model});
  },

  remove: function () {
    if (this.model) this.el.removeObject3D('mesh');
  }
};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * ply-model
 *
 * Wraps THREE.PLYLoader.
 */
THREE.PLYLoader = __webpack_require__(243);

/**
 * Loads, caches, resolves geometries.
 *
 * @member cache - Promises that resolve geometries keyed by `src`.
 */
module.exports.System = {
  init: function () {
    this.cache = {};
  },

  /**
   * @returns {Promise}
   */
  getOrLoadGeometry: function (src, skipCache) {
    var cache = this.cache;
    var cacheItem = cache[src];

    if (!skipCache && cacheItem) {
      return cacheItem;
    }

    cache[src] = new Promise(function (resolve) {
      var loader = new THREE.PLYLoader();
      loader.load(src, function (geometry) {
        resolve(geometry);
      });
    });
    return cache[src];
  },
};

module.exports.Component = {
  schema: {
    skipCache: {type: 'boolean', default: false},
    src: {type: 'asset'}
  },

  init: function () {
    this.model = null;
  },

  update: function () {
    var data = this.data;
    var el = this.el;
    var loader;

    if (!data.src) {
      console.warn('[%s] `src` property is required.', this.name);
      return;
    }

    // Get geometry from system, create and set mesh.
    this.system.getOrLoadGeometry(data.src, data.skipCache).then(function (geometry) {
      var model = createModel(geometry);
      el.setObject3D('mesh', model);
      el.emit('model-loaded', {format: 'ply', model: model});
    });
  },

  remove: function () {
    if (this.model) { this.el.removeObject3D('mesh'); }
  }
};

function createModel (geometry) {
  return new THREE.Mesh(geometry, new THREE.MeshPhongMaterial({
    color: 0xFFFFFF,
    shading: THREE.FlatShading,
    vertexColors: THREE.VertexColors,
    shininess: 0
  }));
}


/***/ }),
/* 263 */
/***/ (function(module, exports) {

var DEFAULT_ANIMATION = '__auto__';

/**
 * three-model
 *
 * Loader for THREE.js JSON format. Somewhat confusingly, there are two
 * different THREE.js formats, both having the .json extension. This loader
 * supports both, but requires you to specify the mode as "object" or "json".
 *
 * Typically, you will use "json" for a single mesh, and "object" for a scene
 * or multiple meshes. Check the console for errors, if in doubt.
 *
 * See: https://clara.io/learn/user-guide/data_exchange/threejs_export
 */
module.exports = {
  deprecated: true,

  schema: {
    src:               { type: 'asset' },
    loader:            { default: 'object', oneOf: ['object', 'json'] },
    enableAnimation:   { default: true },
    animation:         { default: DEFAULT_ANIMATION },
    animationDuration: { default: 0 },
    crossorigin:       { default: '' }
  },

  init: function () {
    this.model = null;
    this.mixer = null;
    console.warn('[three-model] Component is deprecated. Use json-model or object-model instead.');
  },

  update: function (previousData) {
    previousData = previousData || {};

    var loader,
        data = this.data;

    if (!data.src) {
      this.remove();
      return;
    }

    // First load.
    if (!Object.keys(previousData).length) {
      this.remove();
      if (data.loader === 'object') {
        loader = new THREE.ObjectLoader();
        if (data.crossorigin) loader.setCrossOrigin(data.crossorigin);
        loader.load(data.src, function(loaded) {
          loaded.traverse( function(object) {
            if (object instanceof THREE.SkinnedMesh)
              loaded = object;
          });
          if(loaded.material)
            loaded.material.skinning = !!((loaded.geometry && loaded.geometry.bones) || []).length;
          this.load(loaded);
        }.bind(this));
      } else if (data.loader === 'json') {
        loader = new THREE.JSONLoader();
        if (data.crossorigin) loader.crossOrigin = data.crossorigin;
        loader.load(data.src, function (geometry, materials) {

          // Attempt to automatically detect common material options.
          materials.forEach(function (mat) {
            mat.vertexColors = (geometry.faces[0] || {}).color ? THREE.FaceColors : THREE.NoColors;
            mat.skinning = !!(geometry.bones || []).length;
            mat.morphTargets = !!(geometry.morphTargets || []).length;
            mat.morphNormals = !!(geometry.morphNormals || []).length;
          });

          var mesh = (geometry.bones || []).length
            ? new THREE.SkinnedMesh(geometry, new THREE.MultiMaterial(materials))
            : new THREE.Mesh(geometry, new THREE.MultiMaterial(materials));

          this.load(mesh);
        }.bind(this));
      } else {
        throw new Error('[three-model] Invalid mode "%s".', data.mode);
      }
      return;
    }

    var activeAction = this.model && this.model.activeAction;

    if (data.animation !== previousData.animation) {
      if (activeAction) activeAction.stop();
      this.playAnimation();
      return;
    }

    if (activeAction && data.enableAnimation !== activeAction.isRunning()) {
      data.enableAnimation ? this.playAnimation() : activeAction.stop();
    }

    if (activeAction && data.animationDuration) {
        activeAction.setDuration(data.animationDuration);
    }
  },

  load: function (model) {
    this.model = model;
    this.mixer = new THREE.AnimationMixer(this.model);
    this.el.setObject3D('mesh', model);
    this.el.emit('model-loaded', {format: 'three', model: model});

    if (this.data.enableAnimation) this.playAnimation();
  },

  playAnimation: function () {
    var clip,
        data = this.data,
        animations = this.model.animations || this.model.geometry.animations || [];

    if (!data.enableAnimation || !data.animation || !animations.length) {
      return;
    }

    clip = data.animation === DEFAULT_ANIMATION
      ? animations[0]
      : THREE.AnimationClip.findByName(animations, data.animation);

    if (!clip) {
      console.error('[three-model] Animation "%s" not found.', data.animation);
      return;
    }

    this.model.activeAction = this.mixer.clipAction(clip, this.model);
    if (data.animationDuration) {
      this.model.activeAction.setDuration(data.animationDuration);
    }
    this.model.activeAction.play();
  },

  remove: function () {
    if (this.mixer) this.mixer.stopAllAction();
    if (this.model) this.el.removeObject3D('mesh');
  },

  tick: function (t, dt) {
    if (this.mixer && !isNaN(dt)) {
      this.mixer.update(dt / 1000);
    }
  }
};


/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports = {
  schema: {
    offset: {default: {x: 0, y: 0, z: 0}, type: 'vec3'}
  },

  init: function () {
    this.active = false;
    this.targetEl = null;
    this.fire = this.fire.bind(this);
    this.offset = new THREE.Vector3();
  },

  update: function () {
    this.offset.copy(this.data.offset);
  },

  play: function () { this.el.addEventListener('click', this.fire); },
  pause: function () { this.el.removeEventListener('click', this.fire); },
  remove: function () { this.pause(); },

  fire: function () {
    var targetEl = this.el.sceneEl.querySelector('[checkpoint-controls]');
    if (!targetEl) {
      throw new Error('No `checkpoint-controls` component found.');
    }
    targetEl.components['checkpoint-controls'].setCheckpoint(this.el);
  },

  getOffset: function () {
    return this.offset.copy(this.data.offset);
  }
};


/***/ }),
/* 265 */
/***/ (function(module, exports) {

/**
 * Specifies an envMap on an entity, without replacing any existing material
 * properties.
 */
module.exports = {
  schema: {
    path: {default: ''},
    extension: {default: 'jpg'},
    format: {default: 'RGBFormat'},
    enableBackground: {default: false}
  },

  init: function () {
    var data = this.data;

    this.texture = new THREE.CubeTextureLoader().load([
      data.path + 'posx.' + data.extension, data.path + 'negx.' + data.extension,
      data.path + 'posy.' + data.extension, data.path + 'negy.' + data.extension,
      data.path + 'posz.' + data.extension, data.path + 'negz.' + data.extension
    ]);
    this.texture.format = THREE[data.format];

    if (data.enableBackground) {
      this.el.sceneEl.object3D.background = this.texture;
    }

    this.applyEnvMap();
    this.el.addEventListener('object3dset', this.applyEnvMap.bind(this));
  },

  applyEnvMap: function () {
    var mesh = this.el.getObject3D('mesh');
    var envMap = this.texture;

    if (!mesh) return;

    mesh.traverse(function (node) {
      if (node.material && 'envMap' in node.material) {
        node.material.envMap = envMap;
        node.material.needsUpdate = true;
      }
    });
  }
};


/***/ }),
/* 266 */
/***/ (function(module, exports) {

/**
 * Based on aframe/examples/showcase/tracked-controls.
 *
 * Handles events coming from the hand-controls.
 * Determines if the entity is grabbed or released.
 * Updates its position to move along the controller.
 */
module.exports = {
  init: function () {
    this.GRABBED_STATE = 'grabbed';

    this.grabbing = false;
    this.hitEl =      /** @type {AFRAME.Element}    */ null;
    this.physics =    /** @type {AFRAME.System}     */ this.el.sceneEl.systems.physics;
    this.constraint = /** @type {CANNON.Constraint} */ null;

    // Bind event handlers
    this.onHit = this.onHit.bind(this);
    this.onGripOpen = this.onGripOpen.bind(this);
    this.onGripClose = this.onGripClose.bind(this);
  },

  play: function () {
    var el = this.el;
    el.addEventListener('hit', this.onHit);
    el.addEventListener('gripdown', this.onGripClose);
    el.addEventListener('gripup', this.onGripOpen);
    el.addEventListener('trackpaddown', this.onGripClose);
    el.addEventListener('trackpadup', this.onGripOpen);
    el.addEventListener('triggerdown', this.onGripClose);
    el.addEventListener('triggerup', this.onGripOpen);
  },

  pause: function () {
    var el = this.el;
    el.removeEventListener('hit', this.onHit);
    el.removeEventListener('gripdown', this.onGripClose);
    el.removeEventListener('gripup', this.onGripOpen);
    el.removeEventListener('trackpaddown', this.onGripClose);
    el.removeEventListener('trackpadup', this.onGripOpen);
    el.removeEventListener('triggerdown', this.onGripClose);
    el.removeEventListener('triggerup', this.onGripOpen);
  },

  onGripClose: function (evt) {
    this.grabbing = true;
  },

  onGripOpen: function (evt) {
    var hitEl = this.hitEl;
    this.grabbing = false;
    if (!hitEl) { return; }
    hitEl.removeState(this.GRABBED_STATE);
    this.hitEl = undefined;
    this.physics.world.removeConstraint(this.constraint);
    this.constraint = null;
  },

  onHit: function (evt) {
    var hitEl = evt.detail.el;
    // If the element is already grabbed (it could be grabbed by another controller).
    // If the hand is not grabbing the element does not stick.
    // If we're already grabbing something you can't grab again.
    if (!hitEl || hitEl.is(this.GRABBED_STATE) || !this.grabbing || this.hitEl) { return; }
    hitEl.addState(this.GRABBED_STATE);
    this.hitEl = hitEl;
    this.constraint = new CANNON.LockConstraint(this.el.body, hitEl.body);
    this.physics.world.addConstraint(this.constraint);
  }
};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var physics = __webpack_require__(95);

module.exports = {
  'checkpoint':      __webpack_require__(264),
  'cube-env-map':    __webpack_require__(265),
  'grab':            __webpack_require__(266),
  'jump-ability':    __webpack_require__(268),
  'kinematic-body':  __webpack_require__(269),
  'sphere-collider': __webpack_require__(270),
  'toggle-velocity': __webpack_require__(271),

  registerAll: function (AFRAME) {
    if (this._registered) return;

    AFRAME = AFRAME || window.AFRAME;

    physics.registerAll();
    if (!AFRAME.components['checkpoint'])      AFRAME.registerComponent('checkpoint',      this['checkpoint']);
    if (!AFRAME.components['cube-env-map'])    AFRAME.registerComponent('cube-env-map',    this['cube-env-map']);
    if (!AFRAME.components['grab'])            AFRAME.registerComponent('grab',            this['grab']);
    if (!AFRAME.components['jump-ability'])    AFRAME.registerComponent('jump-ability',    this['jump-ability']);
    if (!AFRAME.components['kinematic-body'])  AFRAME.registerComponent('kinematic-body',  this['kinematic-body']);
    if (!AFRAME.components['sphere-collider']) AFRAME.registerComponent('sphere-collider', this['sphere-collider']);
    if (!AFRAME.components['toggle-velocity']) AFRAME.registerComponent('toggle-velocity', this['toggle-velocity']);

    this._registered = true;
  }
};


/***/ }),
/* 268 */
/***/ (function(module, exports) {

var ACCEL_G = -9.8, // m/s^2
    EASING = -15; // m/s^2

/**
 * Jump ability.
 */
module.exports = {
  dependencies: ['velocity'],

  /* Schema
  ——————————————————————————————————————————————*/

  schema: {
    on: { default: 'keydown:Space gamepadbuttondown:0' },
    playerHeight: { default: 1.764 },
    maxJumps: { default: 1 },
    distance: { default: 5 },
    soundJump: { default: '' },
    soundLand: { default: '' },
    debug: { default: false }
  },

  init: function () {
    this.velocity = 0;
    this.numJumps = 0;

    var beginJump = this.beginJump.bind(this),
        events = this.data.on.split(' ');
    this.bindings = {};
    for (var i = 0; i <  events.length; i++) {
      this.bindings[events[i]] = beginJump;
      this.el.addEventListener(events[i], beginJump);
    }
    this.bindings.collide = this.onCollide.bind(this);
    this.el.addEventListener('collide', this.bindings.collide);
  },

  remove: function () {
    for (var event in this.bindings) {
      if (this.bindings.hasOwnProperty(event)) {
        this.el.removeEventListener(event, this.bindings[event]);
        delete this.bindings[event];
      }
    }
    this.el.removeEventListener('collide', this.bindings.collide);
    delete this.bindings.collide;
  },

  beginJump: function () {
    if (this.numJumps < this.data.maxJumps) {
      var data = this.data,
          initialVelocity = Math.sqrt(-2 * data.distance * (ACCEL_G + EASING)),
          v = this.el.getAttribute('velocity');
      this.el.setAttribute('velocity', {x: v.x, y: initialVelocity, z: v.z});
      this.numJumps++;
    }
  },

  onCollide: function () {
    this.numJumps = 0;
  }
};


/***/ }),
/* 269 */
/***/ (function(module, exports) {

/**
 * Kinematic body.
 *
 * Managed dynamic body, which moves but is not affected (directly) by the
 * physics engine. This is not a true kinematic body, in the sense that we are
 * letting the physics engine _compute_ collisions against it and selectively
 * applying those collisions to the object. The physics engine does not decide
 * the position/velocity/rotation of the element.
 *
 * Used for the camera object, because full physics simulation would create
 * movement that feels unnatural to the player. Bipedal movement does not
 * translate nicely to rigid body physics.
 *
 * See: http://www.learn-cocos2d.com/2013/08/physics-engine-platformer-terrible-idea/
 * And: http://oxleygamedev.blogspot.com/2011/04/player-physics-part-2.html
 */
var CANNON = window.CANNON;
var EPS = 0.000001;

module.exports = {
  dependencies: ['velocity'],

  /*******************************************************************
   * Schema
   */

  schema: {
    mass:           { default: 5 },
    radius:         { default: 1.3 },
    height:         { default: 1.764 },
    linearDamping:  { default: 0.05 },
    enableSlopes:   { default: true }
  },

  /*******************************************************************
   * Lifecycle
   */

  init: function () {
    this.system = this.el.sceneEl.systems.physics;
    this.system.addBehavior(this, this.system.Phase.SIMULATE);

    var el = this.el,
        data = this.data,
        position = (new CANNON.Vec3()).copy(el.getAttribute('position'));

    this.body = new CANNON.Body({
      material: this.system.material,
      position: position,
      mass: data.mass,
      linearDamping: data.linearDamping,
      fixedRotation: true
    });
    this.body.addShape(
      new CANNON.Sphere(data.radius),
      new CANNON.Vec3(0, data.radius - data.height, 0)
    );

    this.body.el = this.el;
    this.el.body = this.body;
    this.system.addBody(this.body);
  },

  remove: function () {
    this.system.removeBody(this.body);
    this.system.removeBehavior(this, this.system.Phase.SIMULATE);
    delete this.el.body;
  },

  /*******************************************************************
   * Tick
   */

  /**
   * Checks CANNON.World for collisions and attempts to apply them to the
   * element automatically, in a player-friendly way.
   *
   * There's extra logic for horizontal surfaces here. The basic requirements:
   * (1) Only apply gravity when not in contact with _any_ horizontal surface.
   * (2) When moving, project the velocity against exactly one ground surface.
   *     If in contact with two ground surfaces (e.g. ground + ramp), choose
   *     the one that collides with current velocity, if any.
   */
  step: (function () {
    var velocity = new THREE.Vector3(),
        normalizedVelocity = new THREE.Vector3(),
        currentSurfaceNormal = new THREE.Vector3(),
        groundNormal = new THREE.Vector3();

    return function (t, dt) {
      if (!dt) return;

      var body = this.body,
          data = this.data,
          didCollide = false,
          height, groundHeight = -Infinity,
          groundBody;

      dt = Math.min(dt, this.system.data.maxInterval * 1000);

      groundNormal.set(0, 0, 0);
      velocity.copy(this.el.getAttribute('velocity'));
      body.velocity.copy(velocity);
      body.position.copy(this.el.getAttribute('position'));

      for (var i = 0, contact; (contact = this.system.world.contacts[i]); i++) {
        // 1. Find any collisions involving this element. Get the contact
        // normal, and make sure it's oriented _out_ of the other object.
        if (body.id === contact.bi.id) {
          contact.ni.negate(currentSurfaceNormal);
        } else if (body.id === contact.bj.id) {
          currentSurfaceNormal.copy(contact.ni);
        } else {
          continue;
        }

        didCollide = body.velocity.dot(currentSurfaceNormal) < -EPS;
        if (didCollide && currentSurfaceNormal.y <= 0.5) {
          // 2. If current trajectory attempts to move _through_ another
          // object, project the velocity against the collision plane to
          // prevent passing through.
          velocity = velocity.projectOnPlane(currentSurfaceNormal);
        } else if (currentSurfaceNormal.y > 0.5) {
          // 3. If in contact with something roughly horizontal (+/- 45º) then
          // consider that the current ground. Only the highest qualifying
          // ground is retained.
          height = body.id === contact.bi.id
            ? Math.abs(contact.rj.y + contact.bj.position.y)
            : Math.abs(contact.ri.y + contact.bi.position.y);
          if (height > groundHeight) {
            groundHeight = height;
            groundNormal.copy(currentSurfaceNormal);
            groundBody = body.id === contact.bi.id ? contact.bj : contact.bi;
          }
        }
      }

      normalizedVelocity.copy(velocity).normalize();
      if (groundBody && normalizedVelocity.y < 0.5) {
        if (!data.enableSlopes) {
          groundNormal.set(0, 1, 0);
        } else if (groundNormal.y < 1 - EPS) {
          groundNormal.copy(this.raycastToGround(groundBody, groundNormal));
        }

        // 4. Project trajectory onto the top-most ground object, unless
        // trajectory is > 45º.
        velocity = velocity.projectOnPlane(groundNormal);
      } else {
        // 5. If not in contact with anything horizontal, apply world gravity.
        // TODO - Why is the 4x scalar necessary.
        velocity.add(this.system.world.gravity.scale(dt * 4.0 / 1000));
      }

      // 6. If the ground surface has a velocity, apply it directly to current
      // position, not velocity, to preserve relative velocity.
      if (groundBody && groundBody.el && groundBody.el.components.velocity) {
        var groundVelocity = groundBody.el.getAttribute('velocity');
        body.position.copy({
          x: body.position.x + groundVelocity.x * dt / 1000,
          y: body.position.y + groundVelocity.y * dt / 1000,
          z: body.position.z + groundVelocity.z * dt / 1000
        });
        this.el.setAttribute('position', body.position);
      }

      body.velocity.copy(velocity);
      this.el.setAttribute('velocity', velocity);
    };
  }()),

  /**
   * When walking on complex surfaces (trimeshes, borders between two shapes),
   * the collision normals returned for the player sphere can be very
   * inconsistent. To address this, raycast straight down, find the collision
   * normal, and return whichever normal is more vertical.
   * @param  {CANNON.Body} groundBody
   * @param  {CANNON.Vec3} groundNormal
   * @return {CANNON.Vec3}
   */
  raycastToGround: function (groundBody, groundNormal) {
    var ray,
        hitNormal,
        vFrom = this.body.position,
        vTo = this.body.position.clone();

    vTo.y -= this.data.height;
    ray = new CANNON.Ray(vFrom, vTo);
    ray._updateDirection(); // TODO - Report bug.
    ray.intersectBody(groundBody);

    if (!ray.hasHit) return groundNormal;

    // Compare ABS, in case we're projecting against the inside of the face.
    hitNormal = ray.result.hitNormalWorld;
    return Math.abs(hitNormal.y) > Math.abs(groundNormal.y) ? hitNormal : groundNormal;
  }
};


/***/ }),
/* 270 */
/***/ (function(module, exports) {

/**
 * Based on aframe/examples/showcase/tracked-controls.
 *
 * Implement bounding sphere collision detection for entities with a mesh.
 * Sets the specified state on the intersected entities.
 *
 * @property {string} objects - Selector of the entities to test for collision.
 * @property {string} state - State to set on collided entities.
 *
 */
module.exports = {
  schema: {
    objects: {default: ''},
    state: {default: 'collided'},
    radius: {default: 0.05},
    watch: {default: true}
  },

  init: function () {
    /** @type {MutationObserver} */
    this.observer = null;
    /** @type {Array<Element>} Elements to watch for collisions. */
    this.els = [];
    /** @type {Array<Element>} Elements currently in collision state. */
    this.collisions = [];

    this.handleHit = this.handleHit.bind(this);
  },

  remove: function () {
    this.pause();
  },

  play: function () {
    var sceneEl = this.el.sceneEl;

    if (this.data.watch) {
      this.observer = new MutationObserver(this.update.bind(this, null));
      this.observer.observe(sceneEl, {childList: true, subtree: true});
    }
  },

  pause: function () {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  },

  /**
   * Update list of entities to test for collision.
   */
  update: function () {
    var data = this.data;
    var objectEls;

    // Push entities into list of els to intersect.
    if (data.objects) {
      objectEls = this.el.sceneEl.querySelectorAll(data.objects);
    } else {
      // If objects not defined, intersect with everything.
      objectEls = this.el.sceneEl.children;
    }
    // Convert from NodeList to Array
    this.els = Array.prototype.slice.call(objectEls);
  },

  tick: (function () {
    var position = new THREE.Vector3(),
        meshPosition = new THREE.Vector3(),
        meshScale = new THREE.Vector3(),
        colliderScale = new THREE.Vector3(),
        distanceMap = new Map();
    return function () {
      var el = this.el,
          data = this.data,
          mesh = el.getObject3D('mesh'),
          colliderRadius,
          collisions = [];

      if (!mesh) { return; }

      distanceMap.clear();
      position.copy(el.object3D.getWorldPosition());
      el.object3D.getWorldScale(colliderScale);
      colliderRadius = data.radius * scaleFactor(colliderScale);
      // Update collision list.
      this.els.forEach(intersect);

      // Emit events and add collision states, in order of distance.
      collisions
        .sort(function (a, b) {
          return distanceMap.get(a) > distanceMap.get(b) ? 1 : -1;
        })
        .forEach(this.handleHit);

      // Remove collision state from current element.
      if (collisions.length === 0) { el.emit('hit', {el: null}); }

      // Remove collision state from other elements.
      this.collisions.filter(function (el) {
        return !distanceMap.has(el);
      }).forEach(function removeState (el) {
        el.removeState(data.state);
      });

      // Store new collisions
      this.collisions = collisions;

      // Bounding sphere collision detection
      function intersect (el) {
        var radius, mesh, distance, scale;

        if (!el.isEntity) { return; }

        mesh = el.getObject3D('mesh');

        if (!mesh || !mesh.geometry) { return; }

        mesh.getWorldPosition(meshPosition);
        mesh.geometry.computeBoundingSphere();
        radius = mesh.geometry.boundingSphere.radius;
        distance = position.distanceTo(meshPosition);
        scale = scaleFactor(mesh.getWorldScale(meshScale));
        if (distance < radius * scale + colliderRadius) {
          collisions.push(el);
          distanceMap.set(el, distance);
        }
      }
      // use max of scale factors to maintain bounding sphere collision
      function scaleFactor (scaleVec) {
        return Math.max.apply(null, scaleVec.toArray());
      }
    };
  })(),

  handleHit: function (targetEl) {
    targetEl.emit('hit');
    targetEl.addState(this.data.state);
    this.el.emit('hit', {el: targetEl});
  }
};


/***/ }),
/* 271 */
/***/ (function(module, exports) {

/**
 * Toggle velocity.
 *
 * Moves an object back and forth along an axis, within a min/max extent.
 */
module.exports = {
  dependencies: ['velocity'],
  schema: {
    axis: { default: 'x', oneOf: ['x', 'y', 'z'] },
    min: { default: 0 },
    max: { default: 0 },
    speed: { default: 1 }
  },
  init: function () {
    var velocity = {x: 0, y: 0, z: 0};
    velocity[this.data.axis] = this.data.speed;
    this.el.setAttribute('velocity', velocity);

    if (this.el.sceneEl.addBehavior) this.el.sceneEl.addBehavior(this);
  },
  remove: function () {},
  update: function () { this.tick(); },
  tick: function () {
    var data = this.data,
        velocity = this.el.getAttribute('velocity'),
        position = this.el.getAttribute('position');
    if (velocity[data.axis] > 0 && position[data.axis] > data.max) {
      velocity[data.axis] = -data.speed;
      this.el.setAttribute('velocity', velocity);
    } else if (velocity[data.axis] < 0 && position[data.axis] < data.min) {
      velocity[data.axis] = data.speed;
      this.el.setAttribute('velocity', velocity);
    }
  },
};


/***/ }),
/* 272 */
/***/ (function(module, exports) {

/**
 * Flat grid.
 *
 * Defaults to 75x75.
 */
var Primitive = module.exports = {
  defaultComponents: {
    geometry: {
      primitive: 'plane',
      width: 75,
      height: 75
    },
    rotation: {x: -90, y: 0, z: 0},
    material: {
      src: 'url(https://cdn.rawgit.com/donmccurdy/aframe-extras/v1.16.3/assets/grid.png)',
      repeat: '75 75'
    }
  },
  mappings: {
    width: 'geometry.width',
    height: 'geometry.height',
    src: 'material.src'
  }
};

module.exports.registerAll = (function () {
  var registered = false;
  return function (AFRAME) {
    if (registered) return;
    AFRAME = AFRAME || window.AFRAME;
    AFRAME.registerPrimitive('a-grid', Primitive);
    registered = true;
  };
}());


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var vg = __webpack_require__(246);
var defaultHexGrid = __webpack_require__(244);

/**
 * Hex grid.
 */
var Primitive = module.exports.Primitive = {
  defaultComponents: {
    'hexgrid': {}
  },
  mappings: {
    src: 'hexgrid.src'
  }
};

var Component = module.exports.Component = {
  dependencies: ['material'],
  schema: {
    src: {type: 'asset'}
  },
  init: function () {
    var data = this.data;
    if (data.src) {
      fetch(data.src)
        .then(function (response) { response.json(); })
        .then(function (json) { this.addMesh(json); });
    } else {
      this.addMesh(defaultHexGrid);
    }
  },
  addMesh: function (json) {
    var grid = new vg.HexGrid();
    grid.fromJSON(json);
    var board = new vg.Board(grid);
    board.generateTilemap();
    this.el.setObject3D('mesh', board.group);
    this.addMaterial();
  },
  addMaterial: function () {
    var materialComponent = this.el.components.material;
    var material = (materialComponent || {}).material;
    if (!material) return;
    this.el.object3D.traverse(function (node) {
      if (node.isMesh) {
        node.material = material;
      }
    });
  },
  remove: function () {
    this.el.removeObject3D('mesh');
  }
};

module.exports.registerAll = (function () {
  var registered = false;
  return function (AFRAME) {
    if (registered) return;
    AFRAME = AFRAME || window.AFRAME;
    AFRAME.registerComponent('hexgrid', Component);
    AFRAME.registerPrimitive('a-hexgrid', Primitive);
    registered = true;
  };
}());


/***/ }),
/* 274 */
/***/ (function(module, exports) {

/**
 * Flat-shaded ocean primitive.
 *
 * Based on a Codrops tutorial:
 * http://tympanus.net/codrops/2016/04/26/the-aviator-animating-basic-3d-scene-threejs/
 */
var Primitive = module.exports.Primitive = {
  defaultComponents: {
    ocean: {},
    rotation: {x: -90, y: 0, z: 0}
  },
  mappings: {
    width: 'ocean.width',
    depth: 'ocean.depth',
    density: 'ocean.density',
    color: 'ocean.color',
    opacity: 'ocean.opacity'
  }
};

var Component = module.exports.Component = {
  schema: {
    // Dimensions of the ocean area.
    width: {default: 10, min: 0},
    depth: {default: 10, min: 0},

    // Density of waves.
    density: {default: 10},

    // Wave amplitude and variance.
    amplitude: {default: 0.1},
    amplitudeVariance: {default: 0.3},

    // Wave speed and variance.
    speed: {default: 1},
    speedVariance: {default: 2},

    // Material.
    color: {default: '#7AD2F7', type: 'color'},
    opacity: {default: 0.8}
  },

  /**
   * Use play() instead of init(), because component mappings – unavailable as dependencies – are
   * not guaranteed to have parsed when this component is initialized.
   */
  play: function () {
    var el = this.el,
        data = this.data,
        material = el.components.material;

    var geometry = new THREE.PlaneGeometry(data.width, data.depth, data.density, data.density);
    geometry.mergeVertices();
    this.waves = [];
    for (var v, i = 0, l = geometry.vertices.length; i < l; i++) {
      v = geometry.vertices[i];
      this.waves.push({
        z: v.z,
        ang: Math.random() * Math.PI * 2,
        amp: data.amplitude + Math.random() * data.amplitudeVariance,
        speed: (data.speed + Math.random() * data.speedVariance) / 1000 // radians / frame
      });
    }

    if (!material) {
      material = {};
      material.material = new THREE.MeshPhongMaterial({
        color: data.color,
        transparent: data.opacity < 1,
        opacity: data.opacity,
        shading: THREE.FlatShading,
      });
    }

    this.mesh = new THREE.Mesh(geometry, material.material);
    el.setObject3D('mesh', this.mesh);
  },

  remove: function () {
    this.el.removeObject3D('mesh');
  },

  tick: function (t, dt) {
    if (!dt) return;

    var verts = this.mesh.geometry.vertices;
    for (var v, vprops, i = 0; (v = verts[i]); i++){
      vprops = this.waves[i];
      v.z = vprops.z + Math.sin(vprops.ang) * vprops.amp;
      vprops.ang += vprops.speed * dt;
    }
    this.mesh.geometry.verticesNeedUpdate = true;
  }
};

module.exports.registerAll = (function () {
  var registered = false;
  return function (AFRAME) {
    if (registered) return;
    AFRAME = AFRAME || window.AFRAME;
    AFRAME.registerComponent('ocean', Component);
    AFRAME.registerPrimitive('a-ocean', Primitive);
    registered = true;
  };
}());


/***/ }),
/* 275 */
/***/ (function(module, exports) {

/**
 * Tube following a custom path.
 *
 * Usage:
 *
 * ```html
 * <a-tube path="5 0 5, 5 0 -5, -5 0 -5" radius="0.5"></a-tube>
 * ```
 */
var Primitive = module.exports.Primitive = {
  defaultComponents: {
    tube:           {},
  },
  mappings: {
    path:           'tube.path',
    segments:       'tube.segments',
    radius:         'tube.radius',
    radialSegments: 'tube.radialSegments',
    closed:         'tube.closed'
  }
};

var Component = module.exports.Component = {
  schema: {
    path:           {default: []},
    segments:       {default: 64},
    radius:         {default: 1},
    radialSegments: {default: 8},
    closed:         {default: false}
  },

  init: function () {
    var el = this.el,
        data = this.data,
        material = el.components.material;

    if (!data.path.length) {
      console.error('[a-tube] `path` property expected but not found.');
      return;
    }

    var curve = new THREE.CatmullRomCurve3(data.path.map(function (point) {
      point = point.split(' ');
      return new THREE.Vector3(Number(point[0]), Number(point[1]), Number(point[2]));
    }));
    var geometry = new THREE.TubeGeometry(
      curve, data.segments, data.radius, data.radialSegments, data.closed
    );

    if (!material) {
      material = {};
      material.material = new THREE.MeshPhongMaterial();
    }

    this.mesh = new THREE.Mesh(geometry, material.material);
    this.el.setObject3D('mesh', this.mesh);
  },

  remove: function () {
    if (this.mesh) this.el.removeObject3D('mesh');
  }
};

module.exports.registerAll = (function () {
  var registered = false;
  return function (AFRAME) {
    if (registered) return;
    AFRAME = AFRAME || window.AFRAME;
    AFRAME.registerComponent('tube', Component);
    AFRAME.registerPrimitive('a-tube', Primitive);
    registered = true;
  };
}());


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'a-grid':     __webpack_require__(272),
  'a-hexgrid': __webpack_require__(273),
  'a-ocean':    __webpack_require__(274),
  'a-tube':     __webpack_require__(275),

  registerAll: function (AFRAME) {
    if (this._registered) return;
    AFRAME = AFRAME || window.AFRAME;
    this['a-grid'].registerAll(AFRAME);
    this['a-hexgrid'].registerAll(AFRAME);
    this['a-ocean'].registerAll(AFRAME);
    this['a-tube'].registerAll(AFRAME);
    this._registered = true;
  }
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * CANNON.shape2mesh
 *
 * Source: http://schteppe.github.io/cannon.js/build/cannon.demo.js
 * Author: @schteppe
 */
var CANNON = __webpack_require__(43);

CANNON.shape2mesh = function(body){
    var obj = new THREE.Object3D();

    for (var l = 0; l < body.shapes.length; l++) {
        var shape = body.shapes[l];

        var mesh;

        switch(shape.type){

        case CANNON.Shape.types.SPHERE:
            var sphere_geometry = new THREE.SphereGeometry( shape.radius, 8, 8);
            mesh = new THREE.Mesh( sphere_geometry, this.currentMaterial );
            break;

        case CANNON.Shape.types.PARTICLE:
            mesh = new THREE.Mesh( this.particleGeo, this.particleMaterial );
            var s = this.settings;
            mesh.scale.set(s.particleSize,s.particleSize,s.particleSize);
            break;

        case CANNON.Shape.types.PLANE:
            var geometry = new THREE.PlaneGeometry(10, 10, 4, 4);
            mesh = new THREE.Object3D();
            var submesh = new THREE.Object3D();
            var ground = new THREE.Mesh( geometry, this.currentMaterial );
            ground.scale.set(100, 100, 100);
            submesh.add(ground);

            ground.castShadow = true;
            ground.receiveShadow = true;

            mesh.add(submesh);
            break;

        case CANNON.Shape.types.BOX:
            var box_geometry = new THREE.BoxGeometry(  shape.halfExtents.x*2,
                                                        shape.halfExtents.y*2,
                                                        shape.halfExtents.z*2 );
            mesh = new THREE.Mesh( box_geometry, this.currentMaterial );
            break;

        case CANNON.Shape.types.CONVEXPOLYHEDRON:
            var geo = new THREE.Geometry();

            // Add vertices
            for (var i = 0; i < shape.vertices.length; i++) {
                var v = shape.vertices[i];
                geo.vertices.push(new THREE.Vector3(v.x, v.y, v.z));
            }

            for(var i=0; i < shape.faces.length; i++){
                var face = shape.faces[i];

                // add triangles
                var a = face[0];
                for (var j = 1; j < face.length - 1; j++) {
                    var b = face[j];
                    var c = face[j + 1];
                    geo.faces.push(new THREE.Face3(a, b, c));
                }
            }
            geo.computeBoundingSphere();
            geo.computeFaceNormals();
            mesh = new THREE.Mesh( geo, this.currentMaterial );
            break;

        case CANNON.Shape.types.HEIGHTFIELD:
            var geometry = new THREE.Geometry();

            var v0 = new CANNON.Vec3();
            var v1 = new CANNON.Vec3();
            var v2 = new CANNON.Vec3();
            for (var xi = 0; xi < shape.data.length - 1; xi++) {
                for (var yi = 0; yi < shape.data[xi].length - 1; yi++) {
                    for (var k = 0; k < 2; k++) {
                        shape.getConvexTrianglePillar(xi, yi, k===0);
                        v0.copy(shape.pillarConvex.vertices[0]);
                        v1.copy(shape.pillarConvex.vertices[1]);
                        v2.copy(shape.pillarConvex.vertices[2]);
                        v0.vadd(shape.pillarOffset, v0);
                        v1.vadd(shape.pillarOffset, v1);
                        v2.vadd(shape.pillarOffset, v2);
                        geometry.vertices.push(
                            new THREE.Vector3(v0.x, v0.y, v0.z),
                            new THREE.Vector3(v1.x, v1.y, v1.z),
                            new THREE.Vector3(v2.x, v2.y, v2.z)
                        );
                        var i = geometry.vertices.length - 3;
                        geometry.faces.push(new THREE.Face3(i, i+1, i+2));
                    }
                }
            }
            geometry.computeBoundingSphere();
            geometry.computeFaceNormals();
            mesh = new THREE.Mesh(geometry, this.currentMaterial);
            break;

        case CANNON.Shape.types.TRIMESH:
            var geometry = new THREE.Geometry();

            var v0 = new CANNON.Vec3();
            var v1 = new CANNON.Vec3();
            var v2 = new CANNON.Vec3();
            for (var i = 0; i < shape.indices.length / 3; i++) {
                shape.getTriangleVertices(i, v0, v1, v2);
                geometry.vertices.push(
                    new THREE.Vector3(v0.x, v0.y, v0.z),
                    new THREE.Vector3(v1.x, v1.y, v1.z),
                    new THREE.Vector3(v2.x, v2.y, v2.z)
                );
                var j = geometry.vertices.length - 3;
                geometry.faces.push(new THREE.Face3(j, j+1, j+2));
            }
            geometry.computeBoundingSphere();
            geometry.computeFaceNormals();
            mesh = new THREE.Mesh(geometry, this.currentMaterial);
            break;

        default:
            throw "Visual type not recognized: "+shape.type;
        }

        mesh.receiveShadow = true;
        mesh.castShadow = true;
        if(mesh.children){
            for(var i=0; i<mesh.children.length; i++){
                mesh.children[i].castShadow = true;
                mesh.children[i].receiveShadow = true;
                if(mesh.children[i]){
                    for(var j=0; j<mesh.children[i].length; j++){
                        mesh.children[i].children[j].castShadow = true;
                        mesh.children[i].children[j].receiveShadow = true;
                    }
                }
            }
        }

        var o = body.shapeOffsets[l];
        var q = body.shapeOrientations[l];
        mesh.position.set(o.x, o.y, o.z);
        mesh.quaternion.set(q.x, q.y, q.z, q.w);

        obj.add(mesh);
    }

    return obj;
};

module.exports = CANNON.shape2mesh;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var Body = __webpack_require__(135);

/**
 * Dynamic body.
 *
 * Moves according to physics simulation, and may collide with other objects.
 */
module.exports = AFRAME.utils.extend({}, Body, {
  dependencies: ['quaternion', 'velocity'],

  schema: AFRAME.utils.extend({}, Body.schema, {
    mass:           { default: 5 },
    linearDamping:  { default: 0.01 },
    angularDamping: { default: 0.01 }
  }),

  step: function () {
    this.syncFromPhysics();
  }
});


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var Body = __webpack_require__(135);

/**
 * Static body.
 *
 * Solid body with a fixed position. Unaffected by gravity and collisions, but
 * other objects may collide with it.
 */
module.exports = AFRAME.utils.extend({}, Body, {
  step: function () {
    this.syncToPhysics();
  }
});


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var CANNON = __webpack_require__(43);

module.exports = {
  dependencies: ['dynamic-body'],

  multiple: true,

  schema: {
    // Type of constraint.
    type: {default: 'lock', oneOf: ['coneTwist', 'distance', 'hinge', 'lock', 'pointToPoint']},

    // Target (other) body for the constraint.
    target: {type: 'selector'},

    // Maximum force that should be applied to constraint the bodies.
    maxForce: {default: 1e6, min: 0},

    // If true, bodies can collide when they are connected.
    collideConnected: {default: true},

    // Wake up bodies when connected.
    wakeUpBodies: {default: true},

    // The distance to be kept between the bodies. If 0, will be set to current distance.
    distance: {default: 0, min: 0},

    // Offset of the hinge or point-to-point constraint, defined locally in the body.
    pivot: {type: 'vec3'},
    targetPivot: {type: 'vec3'},

    // An axis that each body can rotate around, defined locally to that body.
    axis: {type: 'vec3', default: { x: 0, y: 0, z: 1 }},
    targetAxis: {type: 'vec3', default: { x: 0, y: 0, z: 1}}
  },

  init: function () {
    this.system = this.el.sceneEl.systems.physics;
    this.constraint = /* {CANNON.Constraint} */ null;
  },

  remove: function () {
    if (!this.constraint) return;

    this.system.world.removeConstraint(this.constraint);
    this.constraint = null;
  },

  update: function () {
    var el = this.el,
        data = this.data;

    this.remove();

    if (!el.body || !data.target.body) {
      (el.body ? data.target : el).addEventListener('body-loaded', this.update.bind(this, {}));
      return;
    }

    this.constraint = this.createConstraint();
    this.system.world.addConstraint(this.constraint);
  },

  /**
   * Creates a new constraint, given current component data. The CANNON.js constructors are a bit
   * different for each constraint type.
   * @return {CANNON.Constraint}
   */
  createConstraint: function () {
    var data = this.data,
        pivot = new CANNON.Vec3(data.pivot.x, data.pivot.y, data.pivot.z),
        targetPivot = new CANNON.Vec3(data.targetPivot.x, data.targetPivot.y, data.targetPivot.z),
        axis = new CANNON.Vec3(data.axis.x, data.axis.y, data.axis.z),
        targetAxis= new CANNON.Vec3(data.targetAxis.x, data.targetAxis.y, data.targetAxis.z);

    switch (data.type) {
      case 'lock':
        return new CANNON.LockConstraint(
          this.el.body,
          data.target.body,
          {maxForce: data.maxForce}
        );
      case 'distance':
        return new CANNON.DistanceConstraint(
          this.el.body,
          data.target.body,
          data.distance,
          data.maxForce
        );
      case 'hinge':
        return new CANNON.HingeConstraint(
          this.el.body,
          data.target.body, {
            pivotA: pivot,
            pivotB: targetPivot,
            axisA: axis,
            axisB: targetAxis,
            maxForce: data.maxForce
          });
      case 'coneTwist':
        return new CANNON.ConeTwistConstraint(
          this.el.body,
          data.target.body, {
            pivotA: pivot,
            pivotB: targetPivot,
            axisA: axis,
            axisB: targetAxis,
            maxForce: data.maxForce
          });
      case 'pointToPoint':
        return new CANNON.PointToPointConstraint(
          this.el.body,
          pivot,
          data.target.body,
          targetPivot,
          data.maxForce);
      default:
        throw new Error('[constraint] Unexpected type: ' + data.type);
    }
  }
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'velocity':   __webpack_require__(283),
  'quaternion': __webpack_require__(282),

  registerAll: function (AFRAME) {
    if (this._registered) return;

    AFRAME = AFRAME || window.AFRAME;

    if (!AFRAME.components['velocity'])    AFRAME.registerComponent('velocity',   this.velocity);
    if (!AFRAME.components['quaternion'])  AFRAME.registerComponent('quaternion', this.quaternion);

    this._registered = true;
  }
};


/***/ }),
/* 282 */
/***/ (function(module, exports) {

/**
 * Quaternion.
 *
 * Represents orientation of object in three dimensions. Similar to `rotation`
 * component, but avoids problems of gimbal lock.
 *
 * See: https://en.wikipedia.org/wiki/Quaternions_and_spatial_rotation
 */
module.exports = {
  schema: {type: 'vec4'},

  play: function () {
    var el = this.el,
        q = el.object3D.quaternion;
    if (el.hasAttribute('rotation')) {
      el.components.rotation.update();
      el.setAttribute('quaternion', {x: q.x, y: q.y, z: q.z, w: q.w});
      el.removeAttribute('rotation');
      this.update();
    }
  },

  update: function () {
    var data = this.data;
    this.el.object3D.quaternion.set(data.x, data.y, data.z, data.w);
  }
};


/***/ }),
/* 283 */
/***/ (function(module, exports) {

/**
 * Velocity, in m/s.
 */
module.exports = {
  schema: {type: 'vec3'},

  init: function () {
    this.system = this.el.sceneEl.systems.physics;

    if (this.system) {
      this.system.addBehavior(this, this.system.Phase.RENDER);
    }
  },

  remove: function () {
    if (this.system) {
      this.system.removeBehavior(this, this.system.Phase.RENDER);
    }
  },

  tick: function (t, dt) {
    if (!dt) return;
    if (this.system) return;
    this.step(t, dt);
  },

  step: function (t, dt) {
    if (!dt) return;

    var physics = this.el.sceneEl.systems.physics || {data: {maxInterval: 1 / 60}},

        // TODO - There's definitely a bug with getComputedAttribute and el.data.
        velocity = this.el.getAttribute('velocity') || {x: 0, y: 0, z: 0},
        position = this.el.getAttribute('position') || {x: 0, y: 0, z: 0};

    dt = Math.min(dt, physics.data.maxInterval * 1000);

    this.el.setAttribute('position', {
      x: position.x + velocity.x * dt / 1000,
      y: position.y + velocity.y * dt / 1000,
      z: position.z + velocity.z * dt / 1000
    });
  }
};


/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports = {
  GRAVITY: -9.8,
  MAX_INTERVAL: 4 / 60,
  ITERATIONS: 10,
  CONTACT_MATERIAL: {
    friction:     0.01,
    restitution:  0.3,
    contactEquationStiffness: 1e8,
    contactEquationRelaxation: 3,
    frictionEquationStiffness: 1e8,
    frictionEquationRegularization: 3
  }
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var CANNON = __webpack_require__(43),
    CONSTANTS = __webpack_require__(284),
    C_GRAV = CONSTANTS.GRAVITY,
    C_MAT = CONSTANTS.CONTACT_MATERIAL;

/**
 * Physics system.
 */
module.exports = {
  schema: {
    gravity:                        { default: C_GRAV },
    iterations:                     { default: CONSTANTS.ITERATIONS },
    friction:                       { default: C_MAT.friction },
    restitution:                    { default: C_MAT.restitution },
    contactEquationStiffness:       { default: C_MAT.contactEquationStiffness },
    contactEquationRelaxation:      { default: C_MAT.contactEquationRelaxation },
    frictionEquationStiffness:      { default: C_MAT.frictionEquationStiffness },
    frictionEquationRegularization: { default: C_MAT.frictionEquationRegularization },

    // Never step more than four frames at once. Effectively pauses the scene
    // when out of focus, and prevents weird "jumps" when focus returns.
    maxInterval:                    { default: 4 / 60 },

    // If true, show wireframes around physics bodies.
    debug:                          { default: false },
  },

  /**
   * Update phases, used to separate physics simulation from updates to A-Frame scene.
   * @enum {string}
   */
  Phase: {
    SIMULATE: 'sim',
    RENDER:   'render'
  },

  /**
   * Initializes the physics system.
   */
  init: function () {
    var data = this.data;

    // If true, show wireframes around physics bodies.
    this.debug = data.debug;

    this.children = {};
    this.children[this.Phase.SIMULATE] = [];
    this.children[this.Phase.RENDER] = [];

    this.listeners = {};

    this.world = new CANNON.World();
    this.world.quatNormalizeSkip = 0;
    this.world.quatNormalizeFast = false;
    // this.world.solver.setSpookParams(300,10);
    this.world.solver.iterations = data.iterations;
    this.world.gravity.set(0, data.gravity, 0);
    this.world.broadphase = new CANNON.NaiveBroadphase();

    this.material = new CANNON.Material({name: 'defaultMaterial'});
    this.contactMaterial = new CANNON.ContactMaterial(this.material, this.material, {
        friction: data.friction,
        restitution: data.restitution,
        contactEquationStiffness: data.contactEquationStiffness,
        contactEquationRelaxation: data.contactEquationRelaxation,
        frictionEquationStiffness: data.frictionEquationStiffness,
        frictionEquationRegularization: data.frictionEquationRegularization
    });
    this.world.addContactMaterial(this.contactMaterial);
  },

  /**
   * Updates the physics world on each tick of the A-Frame scene. It would be
   * entirely possible to separate the two – updating physics more or less
   * frequently than the scene – if greater precision or performance were
   * necessary.
   * @param  {number} t
   * @param  {number} dt
   */
  tick: function (t, dt) {
    if (!dt) return;

    this.world.step(Math.min(dt / 1000, this.data.maxInterval));

    var i;
    for (i = 0; i < this.children[this.Phase.SIMULATE].length; i++) {
      this.children[this.Phase.SIMULATE][i].step(t, dt);
    }

    for (i = 0; i < this.children[this.Phase.RENDER].length; i++) {
      this.children[this.Phase.RENDER][i].step(t, dt);
    }
  },

  /**
   * Adds a body to the scene, and binds collision events to the element.
   * @param {CANNON.Body} body
   */
  addBody: function (body) {
    this.listeners[body.id] = function (e) { body.el.emit('collide', e); };
    body.addEventListener('collide', this.listeners[body.id]);
    this.world.addBody(body);
  },

  /**
   * Removes a body, and its listeners, from the scene.
   * @param {CANNON.Body} body
   */
  removeBody: function (body) {
    body.removeEventListener('collide', this.listeners[body.id]);
    delete this.listeners[body.id];
    this.world.removeBody(body);
  },

  /**
   * Adds a component instance to the system, to be invoked on each tick during
   * the given phase.
   * @param {Component} component
   * @param {string} phase
   */
  addBehavior: function (component, phase) {
    this.children[phase].push(component);
  },

  /**
   * Removes a component instance from the system.
   * @param {Component} component
   * @param {string} phase
   */
  removeBehavior: function (component, phase) {
    this.children[phase].splice(this.children[phase].indexOf(component), 1);
  },

  /**
   * Sets an option on the physics system, affecting future simulation steps.
   * @param {string} opt
   * @param {mixed} value
   */
  update: function (previousData) {
    var data = this.data;

    if (data.debug !== previousData.debug) {
      console.warn('[physics] `debug` cannot be changed dynamically.');
    }

    if (data.maxInterval !== previousData.maxInterval); // noop;

    if (data.gravity !== previousData.gravity) this.world.gravity.set(0, data.gravity, 0);

    this.contactMaterial.friction = data.friction;
    this.contactMaterial.restitution = data.restitution;
    this.contactMaterial.contactEquationStiffness = data.contactEquationStiffness;
    this.contactMaterial.contactEquationRelaxation = data.contactEquationRelaxation;
    this.contactMaterial.frictionEquationStiffness = data.frictionEquationStiffness;
    this.contactMaterial.frictionEquationRegularization = data.frictionEquationRegularization;
  }
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * Anime v1.1.3
 * http://anime-js.com
 * JavaScript animation engine
 * Copyright (c) 2016 Julian Garnier
 * http://juliangarnier.com
 * Released under the MIT license
 */

(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    // Browser globals (root is window)
    root.anime = factory();
  }
}(this, function () {

  var version = '1.1.3';

  // Defaults

  var defaultSettings = {
    duration: 1000,
    delay: 0,
    loop: false,
    autoplay: true,
    direction: 'normal',
    easing: 'easeOutElastic',
    elasticity: 400,
    round: false,
    begin: undefined,
    update: undefined,
    complete: undefined
  }

  // Transforms

  var validTransforms = ['translateX', 'translateY', 'translateZ', 'rotate', 'rotateX', 'rotateY', 'rotateZ', 'scale', 'scaleX', 'scaleY', 'scaleZ', 'skewX', 'skewY'];
  var transform, transformStr = 'transform';

  // Utils

  var is = {
    arr: function(a) { return Array.isArray(a) },
    obj: function(a) { return Object.prototype.toString.call(a).indexOf('Object') > -1 },
    svg: function(a) { return a instanceof SVGElement },
    dom: function(a) { return a.nodeType || is.svg(a) },
    num: function(a) { return !isNaN(parseInt(a)) },
    str: function(a) { return typeof a === 'string' },
    fnc: function(a) { return typeof a === 'function' },
    und: function(a) { return typeof a === 'undefined' },
    nul: function(a) { return typeof a === 'null' },
    hex: function(a) { return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a) },
    rgb: function(a) { return /^rgb/.test(a) },
    hsl: function(a) { return /^hsl/.test(a) },
    col: function(a) { return (is.hex(a) || is.rgb(a) || is.hsl(a)) }
  }

  // Easings functions adapted from http://jqueryui.com/

  var easings = (function() {
    var eases = {};
    var names = ['Quad', 'Cubic', 'Quart', 'Quint', 'Expo'];
    var functions = {
      Sine: function(t) { return 1 + Math.sin(Math.PI / 2 * t - Math.PI / 2); },
      Circ: function(t) { return 1 - Math.sqrt( 1 - t * t ); },
      Elastic: function(t, m) {
        if( t === 0 || t === 1 ) return t;
        var p = (1 - Math.min(m, 998) / 1000), st = t / 1, st1 = st - 1, s = p / ( 2 * Math.PI ) * Math.asin( 1 );
        return -( Math.pow( 2, 10 * st1 ) * Math.sin( ( st1 - s ) * ( 2 * Math.PI ) / p ) );
      },
      Back: function(t) { return t * t * ( 3 * t - 2 ); },
      Bounce: function(t) {
        var pow2, bounce = 4;
        while ( t < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
        return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - t, 2 );
      }
    }
    names.forEach(function(name, i) {
      functions[name] = function(t) {
        return Math.pow( t, i + 2 );
      }
    });
    Object.keys(functions).forEach(function(name) {
      var easeIn = functions[name];
      eases['easeIn' + name] = easeIn;
      eases['easeOut' + name] = function(t, m) { return 1 - easeIn(1 - t, m); };
      eases['easeInOut' + name] = function(t, m) { return t < 0.5 ? easeIn(t * 2, m) / 2 : 1 - easeIn(t * -2 + 2, m) / 2; };
      eases['easeOutIn' + name] = function(t, m) { return t < 0.5 ? (1 - easeIn(1 - 2 * t, m)) / 2 : (easeIn(t * 2 - 1, m) + 1) / 2; };
    });
    eases.linear = function(t) { return t; };
    return eases;
  })();

  // Strings

  var numberToString = function(val) {
    return (is.str(val)) ? val : val + '';
  }

  var stringToHyphens = function(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  }

  var selectString = function(str) {
    if (is.col(str)) return false;
    try {
      var nodes = document.querySelectorAll(str);
      return nodes;
    } catch(e) {
      return false;
    }
  }

  // Numbers

  var random = function(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  // Arrays

  var flattenArray = function(arr) {
    return arr.reduce(function(a, b) {
      return a.concat(is.arr(b) ? flattenArray(b) : b);
    }, []);
  }

  var toArray = function(o) {
    if (is.arr(o)) return o;
    if (is.str(o)) o = selectString(o) || o;
    if (o instanceof NodeList || o instanceof HTMLCollection) return [].slice.call(o);
    return [o];
  }

  var arrayContains = function(arr, val) {
    return arr.some(function(a) { return a === val; });
  }

  var groupArrayByProps = function(arr, propsArr) {
    var groups = {};
    arr.forEach(function(o) {
      var group = JSON.stringify(propsArr.map(function(p) { return o[p]; }));
      groups[group] = groups[group] || [];
      groups[group].push(o);
    });
    return Object.keys(groups).map(function(group) {
      return groups[group];
    });
  }

  var removeArrayDuplicates = function(arr) {
    return arr.filter(function(item, pos, self) {
      return self.indexOf(item) === pos;
    });
  }

  // Objects

  var cloneObject = function(o) {
    var newObject = {};
    for (var p in o) newObject[p] = o[p];
    return newObject;
  }

  var mergeObjects = function(o1, o2) {
    for (var p in o2) o1[p] = !is.und(o1[p]) ? o1[p] : o2[p];
    return o1;
  }

  // Colors

  var hexToRgb = function(hex) {
    var rgx = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    var hex = hex.replace(rgx, function(m, r, g, b) { return r + r + g + g + b + b; });
    var rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    var r = parseInt(rgb[1], 16);
    var g = parseInt(rgb[2], 16);
    var b = parseInt(rgb[3], 16);
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }

  var hslToRgb = function(hsl) {
    var hsl = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(hsl);
    var h = parseInt(hsl[1]) / 360;
    var s = parseInt(hsl[2]) / 100;
    var l = parseInt(hsl[3]) / 100;
    var hue2rgb = function(p, q, t) {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1/6) return p + (q - p) * 6 * t;
      if (t < 1/2) return q;
      if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
      return p;
    }
    var r, g, b;
    if (s == 0) {
      r = g = b = l;
    } else {
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = hue2rgb(p, q, h + 1/3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1/3);
    }
    return 'rgb(' + r * 255 + ',' + g * 255 + ',' + b * 255 + ')';
  }

  var colorToRgb = function(val) {
    if (is.rgb(val)) return val;
    if (is.hex(val)) return hexToRgb(val);
    if (is.hsl(val)) return hslToRgb(val);
  }

  // Units

  var getUnit = function(val) {
    return /([\+\-]?[0-9|auto\.]+)(%|px|pt|em|rem|in|cm|mm|ex|pc|vw|vh|deg)?/.exec(val)[2];
  }

  var addDefaultTransformUnit = function(prop, val, intialVal) {
    if (getUnit(val)) return val;
    if (prop.indexOf('translate') > -1) return getUnit(intialVal) ? val + getUnit(intialVal) : val + 'px';
    if (prop.indexOf('rotate') > -1 || prop.indexOf('skew') > -1) return val + 'deg';
    return val;
  }

  // Values

  var getCSSValue = function(el, prop) {
    // First check if prop is a valid CSS property
    if (prop in el.style) {
      // Then return the property value or fallback to '0' when getPropertyValue fails
      return getComputedStyle(el).getPropertyValue(stringToHyphens(prop)) || '0';
    }
  }

  var getTransformValue = function(el, prop) {
    var defaultVal = prop.indexOf('scale') > -1 ? 1 : 0;
    var str = el.style.transform;
    if (!str) return defaultVal;
    var rgx = /(\w+)\((.+?)\)/g;
    var match = [];
    var props = [];
    var values = [];
    while (match = rgx.exec(str)) {
      props.push(match[1]);
      values.push(match[2]);
    }
    var val = values.filter(function(f, i) { return props[i] === prop; });
    return val.length ? val[0] : defaultVal;
  }

  var getAnimationType = function(el, prop) {
    if ( is.dom(el) && arrayContains(validTransforms, prop)) return 'transform';
    if ( is.dom(el) && (el.getAttribute(prop) || (is.svg(el) && el[prop]))) return 'attribute';
    if ( is.dom(el) && (prop !== 'transform' && getCSSValue(el, prop))) return 'css';
    if (!is.nul(el[prop]) && !is.und(el[prop])) return 'object';
  }

  var getInitialTargetValue = function(target, prop) {
    switch (getAnimationType(target, prop)) {
      case 'transform': return getTransformValue(target, prop);
      case 'css': return getCSSValue(target, prop);
      case 'attribute': return target.getAttribute(prop);
    }
    return target[prop] || 0;
  }

  var getValidValue = function(values, val, originalCSS) {
    if (is.col(val)) return colorToRgb(val);
    if (getUnit(val)) return val;
    var unit = getUnit(values.to) ? getUnit(values.to) : getUnit(values.from);
    if (!unit && originalCSS) unit = getUnit(originalCSS);
    return unit ? val + unit : val;
  }

  var decomposeValue = function(val) {
    var rgx = /-?\d*\.?\d+/g;
    return {
      original: val,
      numbers: numberToString(val).match(rgx) ? numberToString(val).match(rgx).map(Number) : [0],
      strings: numberToString(val).split(rgx)
    }
  }

  var recomposeValue = function(numbers, strings, initialStrings) {
    return strings.reduce(function(a, b, i) {
      var b = (b ? b : initialStrings[i - 1]);
      return a + numbers[i - 1] + b;
    });
  }

  // Animatables

  var getAnimatables = function(targets) {
    var targets = targets ? (flattenArray(is.arr(targets) ? targets.map(toArray) : toArray(targets))) : [];
    return targets.map(function(t, i) {
      return { target: t, id: i };
    });
  }

  // Properties

  var getProperties = function(params, settings) {
    var props = [];
    for (var p in params) {
      if (!defaultSettings.hasOwnProperty(p) && p !== 'targets') {
        var prop = is.obj(params[p]) ? cloneObject(params[p]) : {value: params[p]};
        prop.name = p;
        props.push(mergeObjects(prop, settings));
      }
    }
    return props;
  }

  var getPropertiesValues = function(target, prop, value, i) {
    var values = toArray( is.fnc(value) ? value(target, i) : value);
    return {
      from: (values.length > 1) ? values[0] : getInitialTargetValue(target, prop),
      to: (values.length > 1) ? values[1] : values[0]
    }
  }

  // Tweens

  var getTweenValues = function(prop, values, type, target) {
    var valid = {};
    if (type === 'transform') {
      valid.from = prop + '(' + addDefaultTransformUnit(prop, values.from, values.to) + ')';
      valid.to = prop + '(' + addDefaultTransformUnit(prop, values.to) + ')';
    } else {
      var originalCSS = (type === 'css') ? getCSSValue(target, prop) : undefined;
      valid.from = getValidValue(values, values.from, originalCSS);
      valid.to = getValidValue(values, values.to, originalCSS);
    }
    return { from: decomposeValue(valid.from), to: decomposeValue(valid.to) };
  }

  var getTweensProps = function(animatables, props) {
    var tweensProps = [];
    animatables.forEach(function(animatable, i) {
      var target = animatable.target;
      return props.forEach(function(prop) {
        var animType = getAnimationType(target, prop.name);
        if (animType) {
          var values = getPropertiesValues(target, prop.name, prop.value, i);
          var tween = cloneObject(prop);
          tween.animatables = animatable;
          tween.type = animType;
          tween.from = getTweenValues(prop.name, values, tween.type, target).from;
          tween.to = getTweenValues(prop.name, values, tween.type, target).to;
          tween.round = (is.col(values.from) || tween.round) ? 1 : 0;
          tween.delay = (is.fnc(tween.delay) ? tween.delay(target, i, animatables.length) : tween.delay) / animation.speed;
          tween.duration = (is.fnc(tween.duration) ? tween.duration(target, i, animatables.length) : tween.duration) / animation.speed;
          tweensProps.push(tween);
        }
      });
    });
    return tweensProps;
  }

  var getTweens = function(animatables, props) {
    var tweensProps = getTweensProps(animatables, props);
    var splittedProps = groupArrayByProps(tweensProps, ['name', 'from', 'to', 'delay', 'duration']);
    return splittedProps.map(function(tweenProps) {
      var tween = cloneObject(tweenProps[0]);
      tween.animatables = tweenProps.map(function(p) { return p.animatables });
      tween.totalDuration = tween.delay + tween.duration;
      return tween;
    });
  }

  var reverseTweens = function(anim, delays) {
    anim.tweens.forEach(function(tween) {
      var toVal = tween.to;
      var fromVal = tween.from;
      var delayVal = anim.duration - (tween.delay + tween.duration);
      tween.from = toVal;
      tween.to = fromVal;
      if (delays) tween.delay = delayVal;
    });
    anim.reversed = anim.reversed ? false : true;
  }

  var getTweensDuration = function(tweens) {
    return Math.max.apply(Math, tweens.map(function(tween){ return tween.totalDuration; }));
  }

  var getTweensDelay = function(tweens) {
    return Math.min.apply(Math, tweens.map(function(tween){ return tween.delay; }));
  }

  // will-change

  var getWillChange = function(anim) {
    var props = [];
    var els = [];
    anim.tweens.forEach(function(tween) {
      if (tween.type === 'css' || tween.type === 'transform' ) {
        props.push(tween.type === 'css' ? stringToHyphens(tween.name) : 'transform');
        tween.animatables.forEach(function(animatable) { els.push(animatable.target); });
      }
    });
    return {
      properties: removeArrayDuplicates(props).join(', '),
      elements: removeArrayDuplicates(els)
    }
  }

  var setWillChange = function(anim) {
    var willChange = getWillChange(anim);
    willChange.elements.forEach(function(element) {
      element.style.willChange = willChange.properties;
    });
  }

  var removeWillChange = function(anim) {
    var willChange = getWillChange(anim);
    willChange.elements.forEach(function(element) {
      element.style.removeProperty('will-change');
    });
  }

  /* Svg path */

  var getPathProps = function(path) {
    var el = is.str(path) ? selectString(path)[0] : path;
    return {
      path: el,
      value: el.getTotalLength()
    }
  }

  var snapProgressToPath = function(tween, progress) {
    var pathEl = tween.path;
    var pathProgress = tween.value * progress;
    var point = function(offset) {
      var o = offset || 0;
      var p = progress > 1 ? tween.value + o : pathProgress + o;
      return pathEl.getPointAtLength(p);
    }
    var p = point();
    var p0 = point(-1);
    var p1 = point(+1);
    switch (tween.name) {
      case 'translateX': return p.x;
      case 'translateY': return p.y;
      case 'rotate': return Math.atan2(p1.y - p0.y, p1.x - p0.x) * 180 / Math.PI;
    }
  }

  // Progress

  var getTweenProgress = function(tween, time) {
    var elapsed = Math.min(Math.max(time - tween.delay, 0), tween.duration);
    var percent = elapsed / tween.duration;
    var progress = tween.to.numbers.map(function(number, p) {
      var start = tween.from.numbers[p];
      var eased = easings[tween.easing](percent, tween.elasticity);
      var val = tween.path ? snapProgressToPath(tween, eased) : start + eased * (number - start);
      val = tween.round ? Math.round(val * tween.round) / tween.round : val;
      return val;
    });
    return recomposeValue(progress, tween.to.strings, tween.from.strings);
  }

  var setAnimationProgress = function(anim, time) {
    var transforms;
    anim.currentTime = time;
    anim.progress = (time / anim.duration) * 100;
    for (var t = 0; t < anim.tweens.length; t++) {
      var tween = anim.tweens[t];
      tween.currentValue = getTweenProgress(tween, time);
      var progress = tween.currentValue;
      for (var a = 0; a < tween.animatables.length; a++) {
        var animatable = tween.animatables[a];
        var id = animatable.id;
        var target = animatable.target;
        var name = tween.name;
        switch (tween.type) {
          case 'css': target.style[name] = progress; break;
          case 'attribute': target.setAttribute(name, progress); break;
          case 'object': target[name] = progress; break;
          case 'transform':
          if (!transforms) transforms = {};
          if (!transforms[id]) transforms[id] = [];
          transforms[id].push(progress);
          break;
        }
      }
    }
    if (transforms) {
      if (!transform) transform = (getCSSValue(document.body, transformStr) ? '' : '-webkit-') + transformStr;
      for (var t in transforms) {
        anim.animatables[t].target.style[transform] = transforms[t].join(' ');
      }
    }
  }

  // Animation

  var createAnimation = function(params) {
    var anim = {};
    anim.animatables = getAnimatables(params.targets);
    anim.settings = mergeObjects(params, defaultSettings);
    anim.properties = getProperties(params, anim.settings);
    anim.tweens = getTweens(anim.animatables, anim.properties);
    anim.duration = anim.tweens.length ? getTweensDuration(anim.tweens) : params.duration;
    anim.delay = anim.tweens.length ? getTweensDelay(anim.tweens) : params.delay;
    anim.currentTime = 0;
    anim.progress = 0;
    anim.ended = false;
    return anim;
  }

  // Public

  var animations = [];
  var raf = 0;

  var engine = (function() {
    var play = function() { raf = requestAnimationFrame(step); };
    var step = function(t) {
      if (animations.length) {
        for (var i = 0; i < animations.length; i++) animations[i].tick(t);
        play();
      } else {
        cancelAnimationFrame(raf);
        raf = 0;
      }
    }
    return play;
  })();

  var animation = function(params) {

    var anim = createAnimation(params);
    var time = {};

    anim.tick = function(now) {
      anim.ended = false;
      if (!time.start) time.start = now;
      time.current = Math.min(Math.max(time.last + now - time.start, 0), anim.duration);
      setAnimationProgress(anim, time.current);
      var s = anim.settings;
      if (time.current >= anim.delay) {
        if (s.begin) s.begin(anim); s.begin = undefined;
        if (s.update) s.update(anim);
      }
      if (time.current >= anim.duration) {
        if (s.loop) {
          time.start = now;
          if (s.direction === 'alternate') reverseTweens(anim, true);
          if (is.num(s.loop)) s.loop--;
        } else {
          anim.ended = true;
          anim.pause();
          if (s.complete) s.complete(anim);
        }
        time.last = 0;
      }
    }

    anim.seek = function(progress) {
      setAnimationProgress(anim, (progress / 100) * anim.duration);
    }

    anim.pause = function() {
      removeWillChange(anim);
      var i = animations.indexOf(anim);
      if (i > -1) animations.splice(i, 1);
    }

    anim.play = function(params) {
      anim.pause();
      if (params) anim = mergeObjects(createAnimation(mergeObjects(params, anim.settings)), anim);
      time.start = 0;
      time.last = anim.ended ? 0 : anim.currentTime;
      var s = anim.settings;
      if (s.direction === 'reverse') reverseTweens(anim);
      if (s.direction === 'alternate' && !s.loop) s.loop = 1;
      setWillChange(anim);
      animations.push(anim);
      if (!raf) engine();
    }

    anim.restart = function() {
      if (anim.reversed) reverseTweens(anim);
      anim.pause();
      anim.seek(0);
      anim.play();
    }

    if (anim.settings.autoplay) anim.play();

    return anim;

  }

  // Remove one or multiple targets from all active animations.

  var remove = function(elements) {
    var targets = flattenArray(is.arr(elements) ? elements.map(toArray) : toArray(elements));
    for (var i = animations.length-1; i >= 0; i--) {
      var animation = animations[i];
      var tweens = animation.tweens;
      for (var t = tweens.length-1; t >= 0; t--) {
        var animatables = tweens[t].animatables;
        for (var a = animatables.length-1; a >= 0; a--) {
          if (arrayContains(targets, animatables[a].target)) {
            animatables.splice(a, 1);
            if (!animatables.length) tweens.splice(t, 1);
            if (!tweens.length) animation.pause();
          }
        }
      }
    }
  }

  animation.version = version;
  animation.speed = 1;
  animation.list = animations;
  animation.remove = remove;
  animation.easings = easings;
  animation.getValue = getInitialTargetValue;
  animation.path = getPathProps;
  animation.random = random;

  return animation;

}));


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aframe_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_camera__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_popup_display__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_boxes__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_main_sphere__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_inner_sphere__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_keyboard__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_toggle_slider__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_tutorial__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_hud__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_aframe__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_aframe_statsGrabber__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_aframe_animationEvents__ = __webpack_require__(293);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


























var sceneStyles = {
    position: "absolute",

    height: "100%",
    width: "100%"
};

console.log(navigator.userAgent);

var App = function (_Component) {
    _inherits(App, _Component);

    function App() {
        _classCallCheck(this, App);

        return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
    }

    _createClass(App, [{
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: sceneStyles },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Scene"] /*antialias*/,
                        { light: { defaultLightsEnabled: false } /*stats*/, renderer: { sortObjects: true } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_camera__["a" /* default */], null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__containers_boxes__["a" /* default */], null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_inner_sphere__["a" /* default */], null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__containers_main_sphere__["a" /* default */], null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                            { position: {
                                    x: 0,
                                    y: 1.6,
                                    z: 0
                                } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__containers_popup_display__["a" /* default */], null)
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__containers_toggle_slider__["a" /* default */], null)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__containers_hud__["a" /* default */], null)
            );
        }
    }]);

    return App;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getParameterByName; });

var getParameterByName = function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setCameraRotation; });

var setCameraRotation = function setCameraRotation(x, y) {

    return {
        type: "CAMERA_ROTATION_CHANGE",
        x: x,
        y: y
    };
};

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addLetter */
/* unused harmony export clearKeyboard */
/* unused harmony export backspace */
/* unused harmony export sendWord */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microphone_js__ = __webpack_require__(56);







var addLetter = function addLetter(code) {

    var sym = String.fromCharCode(code);

    return {
        type: "KEYBOARD_ADD",
        symbol: sym
    };
};

var clearKeyboard = function clearKeyboard() {

    return {
        type: "KEYBOARD_CLEAR"
    };
};

var backspace = function backspace() {
    return {
        type: "KEYBOARD_BACKSPACE"
    };
};

var sendWord = function sendWord(word, searchType) {

    return function (dispatch) {

        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__microphone_js__["d" /* setFinalResult */])(word));

        return {
            type: "KEYBOARD_SUBMIT",
            result: word,
            searchType: searchType
        };
    };
};

var onKeyPress = function onKeyPress(e) {

    return function (dispatch, getState) {
        var _getState$globalState = getState().globalState,
            worldView = _getState$globalState.worldView,
            searchType = _getState$globalState.searchType;

        var keyboard = getState().keyboard;

        if (worldView !== "WORLD_KEYBOARD" && worldView !== "WORLD_HUD") {

            switch (worldView) {
                case "WORLD_INPUT":
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__microphone_js__["e" /* stopSpeechKeyboard */])());
                    break;
            }
            dispatch(clearKeyboard());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index_js__["e" /* setWorldState */])("WORLD_KEYBOARD"));
        }

        if (e.keyCode === 13) {
            dispatch(sendWord(keyboard.text, searchType));
            return;
        }

        dispatch(addLetter(e.keyCode));
    };
};

var onKeyDown = function onKeyDown(e) {

    return function (dispatch) {
        if (e.keyCode === 8) {
            dispatch(backspace());
        }
    };
};

document.addEventListener("keypress", function (e) {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(onKeyPress(e));
});
document.addEventListener("keydown", function (e) {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(onKeyDown(e));
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return searchFetch; });
/* unused harmony export searchQuery */
/* unused harmony export setResult */
/* unused harmony export searchResult */
/* unused harmony export searchError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__google__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(25);






// Action called to start data fetch from Google Image Search
var searchFetch = function searchFetch(qry) {
    console.log("Searching for event caller");

    return function (dispatch) {

        dispatch(searchQuery(qry));
        fetchFromGoogleAPI(dispatch, qry);
    };
};

var searchQuery = function searchQuery(qry) {

    return function (dispatch, getState) {

        var rotation = document.getElementById("camera").getAttribute("rotation");

        switch (getState().globalState.searchType) {
            case "IMAGE_SEARCH":
                dispatch(fetchFromGoogleAPI(rotation, qry));
                break;

            case "TEXT_SEARCH":
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["f" /* addText */])(qry, rotation.x, rotation.y));
                break;

            default:
                break;
        }

        return {
            type: "SEARCH_FETCH",
            query: qry
        };
    };
};

var setResult = function setResult(res, x, y) {
    return {
        type: "SEARCH_DONE",
        results: res,

        x: x,
        y: y
    };
};

// Action called when request result if returned
var searchResult = function searchResult(res, x, y) {

    return function (dispatch, getState) {

        if (getState().globalState.worldView === "WORLD_VIEW") {
            return;
        }

        dispatch(setResult(res, x, y));
    };
};

var searchError = function searchError() {

    return {
        type: "SEARCH_ERROR"
    };
};

/**
 * 
 * Get's Image Results using Google Image Search API
 * 
 * @param {vec3} rotation 
 * 
 */
var fetchFromGoogleAPI = function fetchFromGoogleAPI(rotation, query) {

    return function (dispatch) {
        fetch("https://www.googleapis.com/customsearch/v1?key=" + __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].search_key + "&cx=" + __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].search_cx + "&searchType=image&q=" + encodeURIComponent(query)).then(function (res) {
            return res.json();
        }).then(function (res) {

            var imgs = res.items.map(function (i) {
                return {
                    src: i.image.thumbnailLink,
                    srcHigh: i.link,
                    width: i.image.thumbnailWidth,
                    height: i.image.thumbnailHeight
                };
            });

            dispatch(searchResult(imgs, rotation.x, rotation.y));
        }).catch(function (err) {
            console.log("Error with normal search", err);
            console.error(err);

            dispatch(fetchFromCustomApi(rotation));
        });
    };
};

/**
 * 
 * Fetch image results from google search API "hack"
 * 
 * @param {vec3} rotation 
 * 
 */
var fetchFromCustomApi = function fetchFromCustomApi(rotation, query) {

    return function (dispatch) {

        __WEBPACK_IMPORTED_MODULE_0__google__["a" /* default */].searchImage(query).then(function (res) {
            // this.props.searchResult(res.splice(0,10), rotation.x, rotation.y)

            dispatch(searchResult(res.splice(0, 10), rotation.x, rotation.y));
        }).catch(function (err) {
            console.log(err);
            // this.props.searchError()

            dispatch(searchError());
        });
    };
};

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aframe__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aframe__);


__WEBPACK_IMPORTED_MODULE_0_aframe___default.a.registerComponent("animation-event", {
    schema: {},

    init: function init() {
        // if (!this.data.enabled) return

        console.log("is it in my head");

        this.el.addEventListener("animationstart", this.onBegin.bind(this));
        this.el.addEventListener("animationend", this.onEnd.bind(this));
    },

    onBegin: function onBegin(e) {
        console.log("onBegin");
    },

    onEnd: function onEnd(e) {
        console.log("onEnd");
    }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aframe__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aframe__);


__WEBPACK_IMPORTED_MODULE_0_aframe___default.a.registerComponent("frame-box", {
    schema: {
        x: {
            type: "number"
        },

        y: {
            type: "number"
        }

    },

    init: function init() {

        this.container = this.el.parentNode.parentNode;

        this.container.setAttribute("rotation", {
            x: this.data.x,
            y: this.data.y
        });

        this.el.addEventListener('clickDown', this.dragStart.bind(this));
        this.el.addEventListener('clickUp', this.dragEnd.bind(this));
    },

    remove: function remove() {

        this.el.removeEventListener('clickDown', this.dragStart.bind(this));
        this.el.removeEventListener('clickUp', this.dragEnd.bind(this));
    },

    dragStart: function dragStart() {

        this.container.setAttribute('fixed', {
            enabled: true,
            fixX: true,
            fixY: true
        });
    },

    dragEnd: function dragEnd() {

        if (!this.container.getAttribute('fixed')) return;
        if (!this.container.getAttribute('fixed').enabled) return;

        this.container.setAttribute('fixed', {
            enabled: false,
            fixX: true,
            fixY: true
        });

        this.el.emit("dragEnd", {
            rotation: this.container.getAttribute('rotation')
        });
    }

});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aframe__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aframe__);


__WEBPACK_IMPORTED_MODULE_0_aframe___default.a.registerComponent('frame-depth', {
    schema: {
        enabled: {
            type: "boolean",
            default: false
        },

        direction: {
            type: "number",
            default: 1
        },

        velocity: {
            type: "number",
            default: 0.006
        },

        z: {
            type: "number",
            default: -10
        },

        y: {
            type: "number",
            default: 0 //1.6
        },

        maxZ: {
            type: "number",
            default: -28
        },

        minZ: {
            type: "number",
            default: -3
        }
    },

    init: function init() {
        this.pEnabled = this.data.enabled; // Variable that checks if previosly moved

        this.el.setAttribute("position", {
            x: 0, y: this.data.y,
            z: this.data.z
        });
    },

    updateSchema: function updateSchema(newData) {},

    tick: function tick(time, deltaTime) {
        if (this.pEnabled === true && this.data.enabled === false) this.depthEnd();
        if (!this.data.enabled) return;

        var z = this.el.getAttribute("position").z;
        var newZ = z + this.data.direction * this.data.velocity * deltaTime;

        if (newZ > this.data.maxZ && newZ < this.data.minZ) this.el.setAttribute("position", {
            x: 0, y: this.data.y,
            z: newZ
        });

        this.pEnabled = this.data.enabled;
    },

    depthEnd: function depthEnd() {
        this.el.emit("depthEnd", {
            z: this.el.getAttribute("position").z
        });

        this.pEnabled = this.data.enabled;
    }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aframe_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aframe__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aframe__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ComponentEnity = function (_Entity) {
    _inherits(ComponentEnity, _Entity);

    function ComponentEnity(props) {
        _classCallCheck(this, ComponentEnity);

        var _this = _possibleConstructorReturn(this, (ComponentEnity.__proto__ || Object.getPrototypeOf(ComponentEnity)).call(this, props));

        console.log(_this.el);
        return _this;
    }

    _createClass(ComponentEnity, [{
        key: "init",
        value: function init() {}
    }, {
        key: "update",
        value: function update() {}
    }, {
        key: "tick",
        value: function tick() {}
    }, {
        key: "remove",
        value: function remove() {}
    }, {
        key: "pause",
        value: function pause() {}
    }, {
        key: "play",
        value: function play() {}
    }]);

    return ComponentEnity;
}(__WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"]);

// aframe.registerComponent("react-component", );

/* unused harmony default export */ var _unused_webpack_default_export = (ComponentEnity);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aframe__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aframe__);


__WEBPACK_IMPORTED_MODULE_0_aframe___default.a.registerComponent('rotateTo', {
    dependencies: ["rotation"],

    schema: {
        velocity: { type: 'number' },
        toY: { type: 'number' }
    },

    init: function init() {},

    tick: function tick(time, deltaTime) {
        // this.attrValue

        this.el.emit("elTick", { time: time, deltaTime: deltaTime });
    }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aframe__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aframe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stats_js__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stats_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stats_js__);




console.log(__WEBPACK_IMPORTED_MODULE_1_stats_js___default.a);

__WEBPACK_IMPORTED_MODULE_0_aframe___default.a.registerComponent("stats-grabber", {

    schema: {
        default: false
    },

    init: function init() {
        // console.log(this.el.components.stats.stats)

        // this.stats = new Stats()
        // this.stats.showPanel(1)
        // document.body.appendChild(this.stats.dom)
    },

    tick: function tick(d, dT) {
        // this.stats.update()

        // console.log(dT)
    }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aframe_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AspectImage = function (_Component) {
    _inherits(AspectImage, _Component);

    function AspectImage() {
        _classCallCheck(this, AspectImage);

        return _possibleConstructorReturn(this, (AspectImage.__proto__ || Object.getPrototypeOf(AspectImage)).apply(this, arguments));
    }

    _createClass(AspectImage, [{
        key: "render",
        value: function render() {

            var ar = this.props.image.height / this.props.image.width;

            this.h = this.props.height;
            this.w = this.h / ar;

            if (this.props.getSize) this.props.getSize(this.w, this.h);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"], {
                primitive: "a-image",

                height: this.h, width: this.w,

                material: {
                    flatShading: true,
                    side: "front"
                },

                src: this.props.image.src
            });
        }
    }]);

    return AspectImage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AspectImage.defaultProps = {
    height: 3
};

/* harmony default export */ __webpack_exports__["a"] = (AspectImage);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aframe_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_aframe_frameButton__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_aframe_controlBox__ = __webpack_require__(96);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// const SmallResult = 

var ImageGrid = function (_Component) {
    _inherits(ImageGrid, _Component);

    function ImageGrid(props) {
        _classCallCheck(this, ImageGrid);

        var _this = _possibleConstructorReturn(this, (ImageGrid.__proto__ || Object.getPrototypeOf(ImageGrid)).call(this, props));

        _this.const = {
            distance: -6,

            upDur: "350",
            downDur: "200",

            minOpacity: "0.7",
            maxOpacity: "1.0",

            maxScale: "1.5 1.5 1.5",
            midScale: "1.2 1.2 1.2",
            minScale: "1 1 1",

            smallWidth: 0.96,
            smallHeight: 0.6,

            largeWidth: 2.4,
            largeHeight: 1.5
        };

        _this.material = {
            shader: "flat",
            transparent: true,
            opacity: 0.7
        };

        _this.geometry = {
            primitive: "plane",

            width: _this.const.smallWidth,
            height: _this.const.smallHeight
        };

        _this.largeGeometry = Object.assign({}, _this.geometry, {

            width: _this.const.largeWidth,
            height: _this.const.largeHeight
        });

        _this.largeMaterial = Object.assign({}, _this.material, {
            opacity: 1.0
        });
        return _this;
    }

    _createClass(ImageGrid, [{
        key: "animationBase",
        value: function animationBase(attr, min, max) {
            var reverse = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a-animation", {
                attribute: attr,

                begin: !reverse ? "mouseenter" : "mouseleave",
                end: !reverse ? "mouseleave" : "mouseenter",

                dur: !reverse ? this.const.upDur : this.const.downDur,

                from: !reverse ? min : max,
                to: !reverse ? max : min
            });
        }
    }, {
        key: "opacityAnimation",
        value: function opacityAnimation() {
            var reverse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return this.animationBase("material.opacity", this.const.minOpacity, this.const.maxOpacity, reverse);
        }
    }, {
        key: "scaleAnimation",
        value: function scaleAnimation() {
            var reverse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return this.animationBase("scale", this.const.minScale, this.const.maxScale, reverse);
        }
    }, {
        key: "bigScaleAnimation",
        value: function bigScaleAnimation() {
            var reverse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return this.animationBase("scale", this.const.minScale, this.const.midScale, reverse);
        }
    }, {
        key: "smallImage",
        value: function smallImage(pos, item) {
            var _this2 = this;

            var geometry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.geometry;
            var material = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.material;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                {
                    geometry: geometry,

                    material: Object.assign({}, this.material, {
                        src: item.src
                    }),

                    position: pos,

                    events: {
                        clickUp: function clickUp() {
                            return _this2.props.click(item);
                        }
                    },

                    "frame-button": { button: true }
                },
                this.opacityAnimation(),
                this.opacityAnimation(true),
                this.scaleAnimation(),
                this.scaleAnimation(true)
            );
        }
    }, {
        key: "bigImage",
        value: function bigImage(item) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                {
                    geometry: this.largeGeometry,

                    material: Object.assign({}, this.largeMaterial, {
                        src: item.src
                    }),

                    position: { x: 0, y: 0, z: 0 },

                    events: {
                        clickUp: function clickUp() {
                            return _this3.props.click(item);
                        }
                    },

                    "frame-button": { button: true }
                },
                this.bigScaleAnimation(),
                this.bigScaleAnimation(true)
            );
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                { position: { x: 0, y: 0, z: 0 }, "control-box": { enableX: false, offsetY: 30, offset: 20, doubleX: false } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                    { position: { x: 0, y: 0, z: this.const.distance } },
                    this.bigImage(this.props.items[0]),
                    this.props.items.slice(1, 4).map(function (item, index) {
                        return _this4.smallImage({ x: -2.16, y: (index - 1) * 0.9 + 0.45, z: 0 }, item);
                    }),
                    this.props.items.slice(4, 7).map(function (item, index) {
                        return _this4.smallImage({ x: -2.16 + (index + 1) * 1.44, y: 1.35, z: 0 }, item);
                    }),
                    this.props.items.slice(7, 9).map(function (item, index) {
                        return _this4.smallImage({ x: 2.16, y: (index - 1) * 0.9 + 0.45, z: 0 }, item);
                    })
                )
            );
        }
    }]);

    return ImageGrid;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ImageGrid.defaultProps = {

    items: [],
    rotation: { x: 0, y: 0, z: 0 }

};

/* harmony default export */ __webpack_exports__["a"] = (ImageGrid);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aframe_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_aframe_frameButton__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_aframe_controlBox__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ActionButton__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_ic_right_4x_png__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_ic_right_4x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_icons_ic_right_4x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_ic_left_4x_png__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_ic_left_4x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_icons_ic_left_4x_png__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var ImageGridEven = function (_Component) {
    _inherits(ImageGridEven, _Component);

    function ImageGridEven(props) {
        _classCallCheck(this, ImageGridEven);

        var _this = _possibleConstructorReturn(this, (ImageGridEven.__proto__ || Object.getPrototypeOf(ImageGridEven)).call(this, props));

        _this.const = {
            distance: -6,

            upDur: "350",
            downDur: "200",

            minOpacity: "0.7",
            maxOpacity: "1.0",

            maxScale: "1.2 1.2 1.2",
            minScale: "1 1 1",

            size: _this.props.grid.row * _this.props.grid.col
        };

        _this.state = {
            page: 0
        };

        _this.material = {
            shader: "flat",
            transparent: true

            // opacity: 0.7 
        };

        _this.geometry = {
            primitive: "plane",

            width: _this.props.icon.width, //this.const.smallWidth,
            height: _this.props.icon.height //this.const.smallWidth,
        };

        _this.page = 0;
        _this.pageStart = _this.page * _this.const.size;
        _this.maxPage = Math.floor(_this.props.items.length / _this.const.size) + 1;

        _this.padded = {
            w: _this.geometry.width + _this.props.grid.padding.x,
            h: _this.geometry.height + _this.props.grid.padding.y
        };

        _this.offset = {
            x: (_this.props.grid.row - 1) * _this.padded.w / 2,
            y: (_this.props.grid.col - 1) * _this.padded.h / 2
        };

        return _this;
    }

    _createClass(ImageGridEven, [{
        key: "animationBase",
        value: function animationBase(attr, min, max) {
            var reverse = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a-animation", {
                attribute: attr,

                begin: !reverse ? "mouseenter" : "mouseleave",
                end: !reverse ? "mouseleave" : "mouseenter",

                dur: !reverse ? this.const.upDur : this.const.downDur,

                from: !reverse ? min : max,
                to: !reverse ? max : min
            });
        }
    }, {
        key: "opacityAnimation",
        value: function opacityAnimation() {
            var reverse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return this.animationBase("material.opacity", this.const.minOpacity, this.const.maxOpacity, reverse);
        }
    }, {
        key: "scaleAnimation",
        value: function scaleAnimation() {
            var reverse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return this.animationBase("scale", this.const.minScale, this.const.maxScale, reverse);
        }
    }, {
        key: "switchPage",
        value: function switchPage() {
            var dir = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            var next = this.state.page + dir;

            if (next >= 0 && next < this.maxPage) {

                this.pageStart = next * this.const.size;
                this.setState({
                    page: next
                });
            }
        }
    }, {
        key: "smallImage",
        value: function smallImage(pos, item) {
            var _this2 = this;

            var geometry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.geometry;
            var material = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.material;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                {
                    geometry: geometry,

                    material: Object.assign({}, this.material, {
                        src: item.src
                    }),

                    position: pos,

                    events: {
                        clickUp: function clickUp() {
                            return _this2.props.click(item);
                        }
                    },

                    "frame-button": { button: true }
                },
                this.scaleAnimation(),
                this.scaleAnimation(true)
            );
        }
    }, {
        key: "generateCols",
        value: function generateCols() {}
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                { position: { x: 0, y: 0, z: 0 }, "control-box": { enableX: false, offsetY: 30, offset: 20, doubleX: false } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                    { position: { x: 0, y: 0, z: this.const.distance } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ActionButton__["a" /* default */], {
                        width: this.props.navigation.buttons.size,
                        height: this.props.navigation.buttons.size,

                        position: {
                            x: (this.props.navigation.buttons.size / 2 + this.props.navigation.buttons.padding.x) * -1,
                            y: this.padded.h * (this.props.grid.col / 2) + this.props.navigation.buttons.size / 2 + this.props.navigation.buttons.padding.y,
                            z: 0
                        },

                        src: __WEBPACK_IMPORTED_MODULE_6__assets_icons_ic_left_4x_png___default.a,

                        events: {
                            click: function click() {
                                return _this3.switchPage(-1);
                            }
                        }
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ActionButton__["a" /* default */], {
                        width: this.props.navigation.buttons.size,
                        height: this.props.navigation.buttons.size,

                        position: {
                            x: this.props.navigation.buttons.size / 2 + this.props.navigation.buttons.padding.x,
                            y: this.padded.h * (this.props.grid.col / 2) + this.props.navigation.buttons.size / 2 + this.props.navigation.buttons.padding.y,
                            z: 0
                        },

                        src: __WEBPACK_IMPORTED_MODULE_5__assets_icons_ic_right_4x_png___default.a,

                        events: {
                            click: function click() {
                                return _this3.switchPage(1);
                            }
                        }
                    }),
                    this.props.items.slice(this.pageStart, this.pageStart + this.const.size).map(function (icon, i) {

                        var pos = {
                            x: i % _this3.props.grid.row * _this3.padded.w - _this3.offset.x,
                            y: (Math.floor(i / _this3.props.grid.row) * _this3.padded.h - _this3.offset.y) * -1,
                            z: 0
                        };

                        return _this3.smallImage(pos, icon);
                    })
                )
            );
        }
    }]);

    return ImageGridEven;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ImageGridEven.defaultProps = {

    items: [],
    rotation: { x: 0, y: 0, z: 0 },

    // Settings for display grid
    grid: {
        row: 4, // Items per row
        col: 3, // Items per column

        padding: {
            x: 0.2, // X Padding of an image 
            y: 0.2 // Y Padding of an image
        }
    },

    // Settings for single icon
    icon: {
        width: 0.96, // Width of an icon
        height: 0.6, // Height of an icon

        maxScale: "1.5 1.5 1.5" // Scale of hovered element
    },

    // Settings for navigation component
    navigation: {

        buttons: {
            size: 0.3, // Size of navigation button

            // Nav buttons padding
            padding: {
                x: 0.1,
                y: 0
            }
        }
    }

};

/* harmony default export */ __webpack_exports__["a"] = (ImageGridEven);

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aframe_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActionButton__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_btn_delete_png__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_btn_delete_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_icons_btn_delete_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_btn_z_index_hover_png__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_btn_z_index_hover_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_icons_btn_z_index_hover_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_btn_magnify_png__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_btn_magnify_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_icons_btn_magnify_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_btn_decrease_png__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_btn_decrease_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_icons_btn_decrease_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FadeAnimation__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_aframe_frameButton__ = __webpack_require__(35);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var ItemActions = function (_Component) {
    _inherits(ItemActions, _Component);

    function ItemActions() {
        _classCallCheck(this, ItemActions);

        return _possibleConstructorReturn(this, (ItemActions.__proto__ || Object.getPrototypeOf(ItemActions)).apply(this, arguments));
    }

    _createClass(ItemActions, [{
        key: "deleteButton",
        value: function deleteButton() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ActionButton__["a" /* default */], {
                src: __WEBPACK_IMPORTED_MODULE_3__assets_icons_btn_delete_png___default.a,

                position: {
                    x: -this.props.width / 2,
                    y: 0,
                    z: 0.2
                },

                button: true,

                events: {
                    clickUp: this.props.deleteClick
                },

                visible: this.props.visible

            });
        }
    }, {
        key: "moveButton",
        value: function moveButton(texture, clickDown, yDir) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ActionButton__["a" /* default */], {
                src: texture,

                position: {
                    x: this.props.width / 2,
                    y: 0.8 * yDir,
                    z: 0.2
                },

                events: {
                    clickDown: clickDown,
                    clickUp: this.props.clickUp

                },

                visible: this.props.visible
            });
        }
    }, {
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                null,
                this.deleteButton(),
                this.moveButton(__WEBPACK_IMPORTED_MODULE_5__assets_icons_btn_magnify_png___default.a, this.props.clickDownBackward, 1),
                this.moveButton(__WEBPACK_IMPORTED_MODULE_6__assets_icons_btn_decrease_png___default.a, this.props.clickDownForward, -1)
            );
        }
    }]);

    return ItemActions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ItemActions.defaultProps = {
    width: 3,
    height: 3,

    visible: true
};

/* harmony default export */ __webpack_exports__["a"] = (ItemActions);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aframe_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_fonts_quicksand_fnt__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_fonts_quicksand_fnt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_fonts_quicksand_fnt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_fonts_quicksand_png__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_fonts_quicksand_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_fonts_quicksand_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FadeAnimation__ = __webpack_require__(68);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var NavButton = function (_Component) {
    _inherits(NavButton, _Component);

    function NavButton(props) {
        _classCallCheck(this, NavButton);

        var _this = _possibleConstructorReturn(this, (NavButton.__proto__ || Object.getPrototypeOf(NavButton)).call(this, props));

        _this.btnMaterial = {
            shader: "flat",
            transparent: true
        };
        return _this;
    }

    _createClass(NavButton, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                {
                    geometry: { primitive: "circle", radius: this.props.radius },

                    position: this.props.position,
                    material: Object.assign({}, this.btnMaterial, { src: this.props.src }),

                    events: {
                        clickUp: function clickUp() {
                            return _this2.props.click();
                        },

                        mouseenter: function mouseenter(e) {
                            console.log(_this2.txt.el);
                            _this2.txt.el.emit("txtenter");
                        },

                        mouseleave: function mouseleave(e) {
                            _this2.txt.el.emit("txtleave");
                        }
                    },

                    "frame-button": { button: true }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                    {
                        ref: function ref(i) {
                            _this2.txt = i;
                        },

                        primitive: "a-text",

                        position: { x: 0, y: 0.6, z: 0 },
                        scale: { x: this.props.size, y: this.props.size, z: 1 },

                        value: this.props.text.toUpperCase(),

                        color: "#F5A623",

                        text: {
                            font: __WEBPACK_IMPORTED_MODULE_2__assets_fonts_quicksand_fnt___default.a,
                            fontImage: __WEBPACK_IMPORTED_MODULE_3__assets_fonts_quicksand_png___default.a,
                            opacity: 0
                        },

                        align: "center"
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_FadeAnimation__["a" /* default */], {
                        attribute: "text.opacity",
                        min: "0",
                        dur: 400,

                        begin: "txtenter",
                        end: "txtleave"
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_FadeAnimation__["a" /* default */], {
                        attribute: "text.opacity",
                        min: "0",
                        dur: 400,

                        begin: "txtenter",
                        end: "txtleave",

                        reverse: true
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_FadeAnimation__["a" /* default */], {
                    attribute: "scale",
                    dur: 400,
                    min: "1 1 1", max: "1.2 1.2 1"
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_FadeAnimation__["a" /* default */], {
                    attribute: "scale",
                    dur: 400,
                    min: "1 1 1", max: "1.2 1.2 1",
                    reverse: true
                })
            );
        }
    }]);

    return NavButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

NavButton.defaultProps = {

    position: { x: 0, y: 0, z: 0.1 },
    radius: 0.4,

    size: 0.8,

    text: "Hello"

};

/* harmony default export */ __webpack_exports__["a"] = (NavButton);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aframe_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_fonts_helveticaNeue_fnt__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_fonts_helveticaNeue_fnt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_fonts_helveticaNeue_fnt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_fonts_helveticaNeue_png__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_fonts_helveticaNeue_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_fonts_helveticaNeue_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_fonts_opensans_fnt__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_fonts_opensans_fnt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_fonts_opensans_fnt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_fonts_opensans_png__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_fonts_opensans_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_fonts_opensans_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_fonts_opensansbold_fnt__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_fonts_opensansbold_fnt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_fonts_opensansbold_fnt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_fonts_opensansbold_png__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_fonts_opensansbold_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_fonts_opensansbold_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_fonts_raleway_fnt__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_fonts_raleway_fnt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_fonts_raleway_fnt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_fonts_raleway_png__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_fonts_raleway_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_fonts_raleway_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_fonts_quicksand_fnt__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_fonts_quicksand_fnt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_fonts_quicksand_fnt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_fonts_quicksand_png__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_fonts_quicksand_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_fonts_quicksand_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_fonts_quicksandmedium_fnt__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_fonts_quicksandmedium_fnt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_fonts_quicksandmedium_fnt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_fonts_quicksandmedium_png__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_fonts_quicksandmedium_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_fonts_quicksandmedium_png__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var TextPlane = function (_Component) {
    _inherits(TextPlane, _Component);

    function TextPlane() {
        _classCallCheck(this, TextPlane);

        return _possibleConstructorReturn(this, (TextPlane.__proto__ || Object.getPrototypeOf(TextPlane)).apply(this, arguments));
    }

    _createClass(TextPlane, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                {
                    primitive: "a-plane",

                    width: this.props.width,
                    height: this.props.height,

                    color: this.props.planeColor,

                    material: {
                        shader: "flat"
                    }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"], {
                    primitive: "a-text",

                    position: { x: 0, y: 0, z: 0.1 },

                    text: {
                        value: this.props.text,

                        // font: Helvetica,
                        // fontImage: HelveticaSheet,

                        // font: OpenSans,
                        // fontImage: OpenSansSheet,

                        // font: OpenSansBold,
                        // fontImage: OpenSansBoldSheet,

                        // font: Raleway,
                        // fontImage: RalewaySheet,

                        font: __WEBPACK_IMPORTED_MODULE_10__assets_fonts_quicksand_fnt___default.a,
                        fontImage: __WEBPACK_IMPORTED_MODULE_11__assets_fonts_quicksand_png___default.a,

                        // font: QuicksandMedium,
                        // fontImage: QuicksandMediumSheet,


                        // font: "roboto",

                        wrapCount: this.props.wrapCount,
                        color: this.props.textColor,

                        height: this.props.width,
                        width: this.props.height,

                        align: "center"
                    }
                })
            );
        }
    }]);

    return TextPlane;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TextPlane.defaultProps = {
    width: 3,
    height: 3,

    // planeColor: "#FAFAFA",
    planeColor: "#FFF",
    textColor: "black",

    wrapCount: 10
};

/* harmony default export */ __webpack_exports__["a"] = (TextPlane);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aframe_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ideaBox_js__ = __webpack_require__(308);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Boxes = function (_Component) {
    _inherits(Boxes, _Component);

    function Boxes() {
        _classCallCheck(this, Boxes);

        return _possibleConstructorReturn(this, (Boxes.__proto__ || Object.getPrototypeOf(Boxes)).apply(this, arguments));
    }

    _createClass(Boxes, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                { position: { x: 0, y: 1.6, z: 0 } },
                this.props.sceneItems.map(function (item, index) {

                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ideaBox_js__["a" /* default */], {

                        item: item,
                        actions: _this2.props,

                        rotation: item.rotation,

                        dKey: index, key: item.id
                    });
                })
            );
        }
    }]);

    return Boxes;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Boxes);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aframe_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_camera__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_aframe__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_aframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_aframe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_aframe_extras__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_aframe_extras___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_aframe_extras__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// import cam from '../helpers/camera-helper'




__WEBPACK_IMPORTED_MODULE_6_aframe_extras___default.a.controls.registerAll();

var Camera = function (_Component) {
    _inherits(Camera, _Component);

    function Camera() {
        _classCallCheck(this, Camera);

        return _possibleConstructorReturn(this, (Camera.__proto__ || Object.getPrototypeOf(Camera)).apply(this, arguments));
    }

    _createClass(Camera, [{
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                {
                    primitive: 'a-camera',
                    id: 'camera',

                    'universal-controls': {
                        movementEnabled: false,
                        rotationControls: ['hdm', 'mouse']
                    },

                    'wasd-controls-enabled': false,

                    fov: this.props.fov,

                    events: {
                        componentchanged: function componentchanged(e) {
                            if (e.detail.name !== 'rotation') return;

                            //cam.setRot(e.detail.newData.x, e.detail.newData.y)

                            /*this.props.setCameraRotation(
                                e.detail.newData.x,
                                e.detail.newData.y
                            )*/
                        }
                    }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                    {
                        primitive: 'a-cursor',
                        id: 'main-cursor',

                        geometry: {
                            primitive: "ring",
                            //radiusOuter: 0.016,
                            //radiusInner: 0.01,

                            radiusOuter: 0.01,
                            radiusInner: 0.001

                            //radiusOuter: 0.026,
                            //radiusInner: 0.02,
                        },

                        material: {
                            transparent: true,
                            color: "#000"
                        },

                        scale: {
                            x: 0.4, y: 0.4, z: 1
                        },

                        cursor: 'fuse: false'
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a-animation', {

                        attribute: 'geometry.radiusInner',

                        from: '0.001',
                        to: '0.02',

                        dur: '200',

                        begin: 'cursorEnter',
                        end: 'cursorLeave'
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a-animation', {

                        attribute: 'geometry.radiusInner',

                        from: '0.02',
                        to: '0.001',

                        dur: '200',

                        begin: 'cursorLeave',
                        end: 'cursorEnter'
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a-animation', {

                        attribute: 'geometry.radiusOuter',

                        from: '0.01',
                        to: '0.026',

                        dur: '200',

                        begin: 'cursorEnter',
                        end: 'cursorLeave'
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a-animation', {

                        attribute: 'geometry.radiusOuter',

                        to: '0.01',
                        from: '0.026',

                        dur: '200',

                        begin: 'cursorLeave',
                        end: 'cursorEnter'
                    })
                )
            );
        }
    }]);

    return Camera;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var userAgent = navigator.userAgent || navigator.vendor;

var mapStateToProps = function mapStateToProps(state) {
    return {
        fov: /android/i.test(userAgent) ? "90" : "60"
    };
};

var matchDispatchToProps = function matchDispatchToProps(dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        setCameraRotation: __WEBPACK_IMPORTED_MODULE_4__actions_camera__["a" /* setCameraRotation */]
    }, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, matchDispatchToProps)(Camera));

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_icons_chrome_png__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_icons_chrome_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_icons_chrome_png__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var wrapperStyle = {
    position: "absolute",

    left: 0,
    right: 0,

    color: 'white',
    fontFamily: "Sans-Serif",
    fontWeight: '100',

    width: '100%',
    height: '100%',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    flexWrap: 'wrap',

    backgroundColor: 'rgba(66,66,66, 0.9)'
};

var inputStyle = {
    fontSize: "24pt",

    width: "100%"
};

var closeStyle = {
    border: 0,
    backgroundColor: "grey",

    color: "white",

    fontSize: "14pt",

    padding: 10,
    width: 40,
    height: 40,

    borderRadius: 20

};

var selectHeading = {
    textAlign: "center"

};

var selectList = {
    listStyle: "none",
    paddingLeft: 0

};

var selectItem = {
    paddingBottom: '0.4em',
    paddingTop: '0.4em',
    borderBottom: "1px solid white"

    // 'margin-right': "1em",
};

var selectButton = {
    outline: "none",
    background: "none",

    fontSize: "14pt",
    color: "white",

    border: "none",

    cursor: "pointer"
};

var selectActiveButton = Object.assign({}, selectButton, {

    color: "#BDBDBD"
});

var editButton = {
    outline: "none",
    backgroundColor: "#424242",

    borderRadius: 5,

    color: "white",

    border: "none",
    cursor: "pointer"
};

var deleteButtonHidden = {
    outline: "none",
    backgroundColor: "#424242",

    borderRadius: 5,

    color: "white",

    border: "none",
    cursor: "pointer",

    display: "none"

};

var addButton = Object.assign({}, editButton, {

    lineHeight: 3,
    width: 40

    // 'padding-bottom': 20,
});

var ListItemHUD = function (_Component) {
    _inherits(ListItemHUD, _Component);

    function ListItemHUD(props) {
        _classCallCheck(this, ListItemHUD);

        var _this = _possibleConstructorReturn(this, (ListItemHUD.__proto__ || Object.getPrototypeOf(ListItemHUD)).call(this, props));

        _this.state = {
            editing: false,
            name: _this.props.space.name,
            spaces: _this.props.spaces
        };
        return _this;
    }

    _createClass(ListItemHUD, [{
        key: "toggleEdit",
        value: function toggleEdit() {
            var newEdit = !this.state.editing;
            this.setState({
                editing: newEdit
            });
        }

        // updateName(e) {
        //     this.setState({
        //         name: e.target.value
        //     })
        // }

    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(newProps) {
            this.state.spaces = newProps.spaces;
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                !this.state.editing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "button",
                    { style: this.props.highligth ? selectActiveButton : selectButton, onClick: this.props.action },
                    this.props.space.name
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { value: this.props.space.name, onChange: function onChange(e) {
                        return _this2.props.nameUpdate(e.target.value);
                    } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "button",
                    { style: editButton, onClick: function onClick() {
                            return _this2.toggleEdit();
                        } },
                    !this.state.editing ? "edit" : "save"
                ),
                this.state.spaces.length > 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "button",
                    { style: editButton, onClick: function onClick() {
                            return _this2.props.deleteSpace();
                        } },
                    "delete"
                ) : null
            );
        }
    }]);

    return ListItemHUD;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var HUD = function (_Component2) {
    _inherits(HUD, _Component2);

    function HUD(props) {
        _classCallCheck(this, HUD);

        var _this3 = _possibleConstructorReturn(this, (HUD.__proto__ || Object.getPrototypeOf(HUD)).call(this, props));

        _this3.state = {
            copied: false

            // document.addEventListener("keypress", this.releaseWindow.bind(this))
        };return _this3;
    }

    _createClass(HUD, [{
        key: "releaseWindow",
        value: function releaseWindow() {
            // console.log("key Press")
            // this.props.disableHUD()
        }
    }, {
        key: "handleFocus",
        value: function handleFocus(e) {
            e.target.select();
            var sucs = document.execCommand("copy");

            console.log(this.setState({
                copied: sucs
            }));
        }
    }, {
        key: "linkShare",
        value: function linkShare() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "button",
                        { style: closeStyle, onClick: function onClick() {
                                return _this4.props.disableHUD();
                            } },
                        "X"
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "h1",
                    null,
                    "Your Space Is Now Shared. ",
                    this.state.copied ? "Copied URL" : ""
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { ref: function ref(i) {
                        _this4.inputF = i;
                    }, type: "text", style: inputStyle, value: this.props.hud.link, onFocus: this.handleFocus.bind(this) })
            );
        }
    }, {
        key: "speechError",
        value: function speechError() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { width: 100, src: __WEBPACK_IMPORTED_MODULE_1__assets_icons_chrome_png___default.a }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "h2",
                    null,
                    "Due To Technical Limitation Our Demo Only Works On Latest Version Of Google Chrome :("
                )
            );
        }
    }, {
        key: "selectScene",
        value: function selectScene() {
            console.log("Selecting Scene");
        }
    }, {
        key: "spaceSelection",
        value: function spaceSelection() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "button",
                        { style: closeStyle, onClick: function onClick() {
                                return _this5.props.disableHUD();
                            } },
                        "X"
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "h1",
                    { style: selectHeading },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "span",
                        null,
                        "Select Space"
                    ),
                    " ",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "button",
                        { style: addButton, onClick: function onClick() {
                                return _this5.props.addSpace("New Space");
                            } },
                        "+"
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "ul",
                    { style: selectList },
                    this.props.spaces.map(function (space, index) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "li",
                            { style: selectItem, key: index },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListItemHUD, {
                                idx: index,
                                space: space,
                                spaces: _this5.props.spaces,
                                highligth: index === _this5.props.curSpace ? true : false,
                                nameUpdate: function nameUpdate(n) {
                                    return _this5.props.updateSpaceName(n, index);
                                },
                                deleteSpace: function deleteSpace() {
                                    return _this5.props.deleteSpace(index);
                                },
                                action: function action() {
                                    return _this5.props.switchSpace(index);
                                }

                            })
                        );
                    })
                )
            );
        }
    }, {
        key: "loading",
        value: function loading() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "h1",
                    null,
                    "Generating Link"
                )
            );
        }
    }, {
        key: "switchRenderer",
        value: function switchRenderer() {
            switch (this.props.hud.state) {
                case "SPEECH_ERROR":
                    return this.speechError();

                case "LINK_SHARE":
                    return this.linkShare();

                case "SPACE_SWITCH":
                    return this.spaceSelection();

                case "CREATING_LINK":
                    return this.loading();
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            if (this.props.hud.state !== "LINK_SHARE") return;

            // this.inputF.focus()

            // this.inputF.select()
            // const sucs = document.execCommand("copy")
            // console.log(sucs)
        }
    }, {
        key: "render",
        value: function render() {

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: Object.assign({}, wrapperStyle, {
                        display: this.props.hud.visible ? "flex" : "none"
                    })
                },
                this.switchRenderer()
            );
        }
    }]);

    return HUD;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (HUD);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aframe_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActionButton__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AspectImage__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TextPlane__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ItemActions__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FadeAnimation__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_aframe_frameBox__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_aframe_frameDepth__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_aframe_frameButton__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_aframe_fixed__ = __webpack_require__(57);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















/**
 * 
 * React Component for tendering Images/Text in space
 * 
 */

var IdeaBox = function (_Component) {
    _inherits(IdeaBox, _Component);

    function IdeaBox(props) {
        _classCallCheck(this, IdeaBox);

        var _this = _possibleConstructorReturn(this, (IdeaBox.__proto__ || Object.getPrototypeOf(IdeaBox)).call(this, props));

        _this.const = {
            size: 0.6
        };

        _this.state = {
            hover: false,

            scale: { x: _this.const.size, y: _this.const.size, z: 1 },

            src: _this.props.item.img ? _this.props.item.img.src : "",

            moving: false,
            direction: 1
        };

        _this.w = 3;
        _this.h = 3;

        // this.hideable;
        return _this;
    }

    /**
     * Loads high resolution version of images
     */


    _createClass(IdeaBox, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.props.item.img) {

                fetch("https://protected-reef-44017.herokuapp.com/?url=" + this.props.item.img.srcHigh).then(function (res) {
                    if (res.status === 200) {
                        res.text().then(function (res) {
                            _this2.setState({
                                src: res
                            });
                        });
                    }
                });
            }
        }

        /**
         *  Updated state for hovering
         */

    }, {
        key: 'itemHover',
        value: function itemHover() {
            this.setState({
                hover: true
            });
        }

        /**
         * Update state for unhovering
         */

    }, {
        key: 'itemUnhover',
        value: function itemUnhover() {
            this.setState({
                hover: false
            });
        }

        /**
         * Fire  delete event
         */

    }, {
        key: 'delClick',
        value: function delClick() {
            this.props.actions.rmvItem(this.props.dKey);
        }

        /**
         * 
         * Saves current rotation to redux state 
         * 
         * @param {vec3} rot - rotation vector
         */

    }, {
        key: 'saveRotation',
        value: function saveRotation(rot) {
            this.props.actions.saveDrag(this.props.dKey, rot);
        }

        /**
         * 
         * Sets Width and Height of the image
         * 
         * @param {Number} w 
         * @param {Number} h 
         */

    }, {
        key: 'getSize',
        value: function getSize(w, h) {
            this.w = w;
            this.h = h;
        }

        /**
         * Renders image with aspect ratio
         */

    }, {
        key: 'renderImage',
        value: function renderImage() {

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AspectImage__["a" /* default */], {
                image: Object.assign({}, this.props.item.img, {
                    src: this.state.src
                }),

                getSize: this.getSize.bind(this)
            });
        }

        /**
         * Renders passes in text
         */

    }, {
        key: 'renderText',
        value: function renderText() {
            this.w = 3;
            this.h = 3;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TextPlane__["a" /* default */], { planeH: 0 /*width={this.w} height={this.h}*/, text: this.props.item.text });
        }

        /**
         * Renders action buttons overlay
         */

    }, {
        key: 'renderActions',
        value: function renderActions() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ItemActions__["a" /* default */], {

                width: this.w,
                visible: this.state.hover,

                deleteClick: this.delClick.bind(this),

                clickDownForward: function clickDownForward() {
                    _this3.setState({
                        moving: true,
                        direction: -1
                    });
                },

                clickDownBackward: function clickDownBackward() {
                    _this3.setState({
                        moving: true,
                        direction: 1
                    });
                },

                clickUp: function clickUp() {
                    _this3.setState({
                        moving: false
                    });
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var primitive = this.props.item.img ? this.renderImage() : this.renderText();

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                    {
                        events: {
                            mouseenter: this.itemHover.bind(this),
                            mouseleave: this.itemUnhover.bind(this),

                            depthEnd: function depthEnd(e) {
                                _this4.props.actions.moveBox(_this4.props.dKey, e.detail.z);
                            }
                        },

                        'frame-depth': {
                            z: this.props.item.depth,
                            enabled: this.state.moving,
                            direction: this.state.direction
                        },

                        scale: this.state.scale
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                        {
                            events: {
                                dragEnd: function dragEnd(e) {
                                    return _this4.saveRotation(e.detail.rotation);
                                }
                            },

                            'frame-box': {
                                x: this.props.item.rotation.x,
                                y: this.props.item.rotation.y
                            },

                            'frame-button': true
                        },
                        primitive
                    ),
                    this.renderActions()
                )
            );
        }
    }]);

    return IdeaBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (IdeaBox);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aframe_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_microphone__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FadeAnimation__ = __webpack_require__(68);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var InnerSpehere = function (_Component) {
    _inherits(InnerSpehere, _Component);

    function InnerSpehere(props) {
        _classCallCheck(this, InnerSpehere);

        var _this = _possibleConstructorReturn(this, (InnerSpehere.__proto__ || Object.getPrototypeOf(InnerSpehere)).call(this, props));

        _this.state = {
            visible: false
        };
        return _this;
    }

    _createClass(InnerSpehere, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                {

                    id: "small-sphere",

                    visible: this.state.visible,

                    geometry: {
                        primitive: "sphere",
                        radius: 10,
                        segmentsHeight: 16, //10,
                        segmentsWidth: 32 //16,

                    },

                    position: {
                        x: 0, y: 0, z: 0
                    },

                    material: {
                        color: "#000",
                        side: "back",
                        shader: "flat",
                        transparent: true,

                        opacity: 0 //0.8, 
                    },

                    scale: { x: 1, y: 1, z: 1 },

                    "frame-button": {
                        button: true,
                        cursorFeedback: false
                    },

                    events: {

                        clickUp: function clickUp() {
                            // this.props.stopSpeech()
                            _this2.props.stopInput();
                        },

                        animationstart: function animationstart(e) {
                            console.log("start", e.target.id);

                            if (e.target.id !== "sphere-fade-in") return;

                            _this2.setState({
                                visible: true
                            });
                        },

                        animationend: function animationend(e) {
                            console.log("end", e.target.id);

                            if (e.target.id !== "sphere-fade-out") return;

                            console.log(_this2.setState({
                                visible: false
                            }));
                        }
                    }

                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FadeAnimation__["a" /* default */], {
                    dur: 700,
                    min: 0, max: 0.6,

                    id: "sphere-fade-in",

                    begin: "sphereopen",
                    end: "sphereclose"
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FadeAnimation__["a" /* default */], {
                    dur: 700,
                    min: 0, max: 0.6,

                    id: "sphere-fade-out",

                    begin: "sphereopen",
                    end: "sphereclose",

                    reverse: true
                })
            );
        }
    }]);

    return InnerSpehere;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
    return {};
};

var matchDispatchToProps = function matchDispatchToProps(dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux__["bindActionCreators"])({
        startSpeech: __WEBPACK_IMPORTED_MODULE_2__actions_microphone__["b" /* startSpeech */],
        stopSpeech: __WEBPACK_IMPORTED_MODULE_2__actions_microphone__["a" /* stopSpeech */],
        abortSpeech: __WEBPACK_IMPORTED_MODULE_2__actions_microphone__["c" /* abortSpeech */],
        stopInput: __WEBPACK_IMPORTED_MODULE_3__actions__["j" /* stopInput */]
    }, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps, matchDispatchToProps)(InnerSpehere));

// export default InnerSpehere

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aframe_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_bg_png__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_bg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_bg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_backgrounds_de7210d05da8121f74aae2397de48b96_jpg__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_backgrounds_de7210d05da8121f74aae2397de48b96_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_backgrounds_de7210d05da8121f74aae2397de48b96_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_backgrounds_panorama_360_nordic_style_family_bedroom_space_01_3d_model_max_jpg__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_backgrounds_panorama_360_nordic_style_family_bedroom_space_01_3d_model_max_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_backgrounds_panorama_360_nordic_style_family_bedroom_space_01_3d_model_max_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_backgrounds_panorama_360_nordic_style_living_room_dining_room_01_3d_model_max_jpg__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_backgrounds_panorama_360_nordic_style_living_room_dining_room_01_3d_model_max_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_backgrounds_panorama_360_nordic_style_living_room_dining_room_01_3d_model_max_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_backgrounds_panorama_360_nordic_style_living_room_dining_room_10_3d_model_max_jpg__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_backgrounds_panorama_360_nordic_style_living_room_dining_room_10_3d_model_max_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_backgrounds_panorama_360_nordic_style_living_room_dining_room_10_3d_model_max_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_backgrounds_Warehouse_with_lights_jpg__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_backgrounds_Warehouse_with_lights_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_backgrounds_Warehouse_with_lights_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_backgrounds_equirectangular_final_jpg__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_backgrounds_equirectangular_final_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_backgrounds_equirectangular_final_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_aframe_frameButton__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aframe_animation_component__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aframe_animation_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_aframe_animation_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_aframe__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_aframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_aframe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_three__ = __webpack_require__(561);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















__WEBPACK_IMPORTED_MODULE_11_aframe___default.a.registerShader("lines-dashed", {
    schema: {
        lineWidth: { default: 1 },
        dashSize: { default: 3 }
    },

    init: function init(data) {
        this.material = new __WEBPACK_IMPORTED_MODULE_12_three__["a" /* LineDashedMaterial */](data);
        this.update(data);
    },

    update: function update(data) {
        this.material.lineWidth = data.lineWidth;
        this.material.dashSize = data.dashSize;
    }
});

var MainSphere = function (_Component) {
    _inherits(MainSphere, _Component);

    function MainSphere(props) {
        _classCallCheck(this, MainSphere);

        var _this = _possibleConstructorReturn(this, (MainSphere.__proto__ || Object.getPrototypeOf(MainSphere)).call(this, props));

        _this.bgs = [__WEBPACK_IMPORTED_MODULE_3__assets_backgrounds_de7210d05da8121f74aae2397de48b96_jpg___default.a, __WEBPACK_IMPORTED_MODULE_4__assets_backgrounds_panorama_360_nordic_style_family_bedroom_space_01_3d_model_max_jpg___default.a, __WEBPACK_IMPORTED_MODULE_5__assets_backgrounds_panorama_360_nordic_style_living_room_dining_room_01_3d_model_max_jpg___default.a, __WEBPACK_IMPORTED_MODULE_6__assets_backgrounds_panorama_360_nordic_style_living_room_dining_room_10_3d_model_max_jpg___default.a, __WEBPACK_IMPORTED_MODULE_7__assets_backgrounds_Warehouse_with_lights_jpg___default.a];

        _this.state = {
            cur: 0,
            visible: false
        };

        document.addEventListener("keypress", _this.keyUp.bind(_this));
        return _this;
    }

    _createClass(MainSphere, [{
        key: "keyUp",
        value: function keyUp(e) {
            console.log(e.charCode);

            var code = e.charCode;
            if (code < 48 || code > 59) return;

            var i = code - 49;
            console.log(i);
            if (i === -1) {
                this.setState({ visible: false });
                return;
            }
            if (i >= this.bgs.length) return;

            this.setState({
                cur: i,
                visible: true
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"], {
                    geometry: {
                        primitive: "sphere",
                        radius: 15,
                        segmentsHeight: 16, //10,
                        segmentsWidth: 32 //16,

                    },

                    position: {
                        x: 0, y: 0, z: 0
                    }

                    // material={{ color: "#FAFAFA", side: "back", shader: "flat", wireframe: true, wireframeLinewidth: 1 }}
                    // material={{ color: "#fff", side: "back", shader: "flat" }}
                    , material: { src: __WEBPACK_IMPORTED_MODULE_8__assets_backgrounds_equirectangular_final_jpg___default.a, side: "back", shader: "flat" }
                    // material={{ shader: "lines-dashed" }}

                    , scale: { x: 2, y: 2, z: 2 },

                    events: {
                        clickUp: function clickUp() {
                            console.log("UNIVERSAL CLICKING ON SPHERE");
                            _this2.props.startSpeech();
                        }
                    },

                    "frame-button": {
                        button: true,
                        cursorFeedback: false
                    }

                })
            );
        }
    }]);

    return MainSphere;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (MainSphere);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aframe_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search_input__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_aframe_fixed__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_aframe_frameButton__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ImageGrid__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ImageGridEven__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_fonts_quicksand_fnt__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_fonts_quicksand_fnt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_fonts_quicksand_fnt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_fonts_quicksand_png__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_fonts_quicksand_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_fonts_quicksand_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_devfest_manifest__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_devfest_grid__ = __webpack_require__(137);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var PopupDisplay = function (_Component) {
    _inherits(PopupDisplay, _Component);

    function PopupDisplay(props) {
        _classCallCheck(this, PopupDisplay);

        return _possibleConstructorReturn(this, (PopupDisplay.__proto__ || Object.getPrototypeOf(PopupDisplay)).call(this, props));
    }

    _createClass(PopupDisplay, [{
        key: 'renderDefault',
        value: function renderDefault() {

            return null;
        }
    }, {
        key: 'renderSearchBox',
        value: function renderSearchBox() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__search_input__["a" /* default */], { text: this.props.mic.text });
        }
    }, {
        key: 'renderKeyInput',
        value: function renderKeyInput() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__search_input__["a" /* default */], { text: this.props.keyboard.text });
        }
    }, {
        key: 'renderSpinner',
        value: function renderSpinner() {
            return null;
        }
    }, {
        key: 'itemClick',
        value: function itemClick(img) {
            var rotation = document.getElementById("camera").getAttribute("rotation");

            this.props.setWorldState("WORLD_VIEW");
            this.props.addBox(img, rotation.x, rotation.y);
        }
    }, {
        key: 'renderSelectGrid',
        value: function renderSelectGrid() {
            var _this2 = this;

            console.log(this.props.search.results);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_ImageGrid__["a" /* default */], {
                items: this.props.search.results,
                rotation: this.props.search.pos,

                click: function click(item) {
                    _this2.itemClick(item);
                }
            });
        }
    }, {
        key: 'renderImageGrid',
        value: function renderImageGrid() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ImageGridEven__["a" /* default */], {
                items: __WEBPACK_IMPORTED_MODULE_9__assets_devfest_manifest__["a" /* default */].icons,

                grid: __WEBPACK_IMPORTED_MODULE_10__assets_devfest_grid__["a" /* default */].grid,
                icon: __WEBPACK_IMPORTED_MODULE_10__assets_devfest_grid__["a" /* default */].icon,
                navigation: __WEBPACK_IMPORTED_MODULE_10__assets_devfest_grid__["a" /* default */].navigation,

                click: function click(item) {
                    _this3.itemClick(item);
                }
            });
        }
    }, {
        key: 'renderError',
        value: function renderError() {

            console.log("RENdering an error message");

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                { id: 'txt-err', position: { x: 0, y: 0, z: 0 }, fixed: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                    { position: { x: 0, y: 0.1, z: -3 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"], {
                        primitive: 'a-text',
                        value: "Result Not Found",

                        color: '#282828',

                        text: {
                            font: __WEBPACK_IMPORTED_MODULE_7__assets_fonts_quicksand_fnt___default.a,
                            fontImage: __WEBPACK_IMPORTED_MODULE_8__assets_fonts_quicksand_png___default.a
                        },

                        align: 'center'
                    })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {

            switch (this.props.globalState.worldView) {
                case "WORLD_VIEW":
                    return this.renderDefault();

                case "WORLD_INPUT":
                    return this.renderSearchBox();

                case "WORLD_KEYBOARD":
                    return this.renderKeyInput();

                case "WORLD_SELECT":
                    return this.renderSelectGrid();

                case "WORLD_ICON":
                    return this.renderImageGrid();

                case "WORLD_ERROR":
                    return this.renderError();

                default:
                    return null;
            }
        }
    }]);

    return PopupDisplay;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PopupDisplay);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aframe_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_mic_png__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_mic_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_icons_mic_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_aframe_fixed__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_fonts_roboto_fnt__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_fonts_roboto_fnt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_fonts_roboto_fnt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_fonts_roboto_png__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_fonts_roboto_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_fonts_roboto_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_fonts_quicksandmedium_fnt__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_fonts_quicksandmedium_fnt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_fonts_quicksandmedium_fnt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_fonts_quicksandmedium_png__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_fonts_quicksandmedium_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_fonts_quicksandmedium_png__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import SearchImage from '../assets/icons/search-img.png'










var SearchInput = function (_Component) {
    _inherits(SearchInput, _Component);

    function SearchInput() {
        _classCallCheck(this, SearchInput);

        return _possibleConstructorReturn(this, (SearchInput.__proto__ || Object.getPrototypeOf(SearchInput)).apply(this, arguments));
    }

    _createClass(SearchInput, [{
        key: "render",
        value: function render() {

            var text = this.props.text.length > 0 ? this.props.text : "Say what you want to visualize";
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                { position: { x: 0, y: 0, z: 0 }, fixed: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                    { position: { x: 0, y: -0.15, z: -5 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"], {
                        primitive: "a-image",

                        material: {
                            transparent: true
                        },

                        src: __WEBPACK_IMPORTED_MODULE_2__assets_icons_mic_png___default.a,

                        width: 50,
                        height: 89,

                        position: {
                            x: 0,
                            y: 0.5,
                            z: 0
                        },

                        scale: "0.005 0.005 1"
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"], {
                        primitive: "a-text",
                        value: text

                        // color="#282828"
                        , color: "#F5F5F5",

                        text: {
                            font: __WEBPACK_IMPORTED_MODULE_4__assets_fonts_roboto_fnt___default.a, //Quicksand,
                            fontImage: __WEBPACK_IMPORTED_MODULE_5__assets_fonts_roboto_png___default.a //QuicksandSheet,
                            // wrapCount: 20,
                        },

                        align: "center"
                    })
                )
            );
        }
    }]);

    return SearchInput;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SearchInput);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aframe_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_switch_img_png__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_switch_img_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_icons_switch_img_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_switch_txt_png__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_switch_txt_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_icons_switch_txt_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_panel_bg_png__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_panel_bg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_icons_panel_bg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_btn_panel_redo_png__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_btn_panel_redo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_icons_btn_panel_redo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_btn_panel_undo_png__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_btn_panel_undo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_icons_btn_panel_undo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_icons_btn_panel_exit_png__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_icons_btn_panel_exit_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_icons_btn_panel_exit_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_icons_btn_copy_png__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_icons_btn_copy_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_icons_btn_copy_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_icons_btn_share_png__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_icons_btn_share_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_icons_btn_share_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_icons_btn_feedback_png__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_icons_btn_feedback_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_icons_btn_feedback_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_NavButton__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_aframe_rotateTo__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_aframe_controlBox__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_aframe_fixed__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_aframe_frameButton__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_url_encoder__ = __webpack_require__(141);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























var uCoder = new __WEBPACK_IMPORTED_MODULE_16__helpers_url_encoder__["a" /* default */]("AIzaSyCb96Oin5QxSdlHOgr9SO5VKUnZge5l5D8");

var SliderMaterial = {
    src: __WEBPACK_IMPORTED_MODULE_2__assets_icons_switch_img_png___default.a,
    transparent: true
};

var ToggleSlider = function (_Component) {
    _inherits(ToggleSlider, _Component);

    // getImage() {
    //     if (this.props.globalState.searchType === "IMAGE_SEARCH") {
    //         SliderMaterial.src = ToggleImage;
    //     } else {
    //         SliderMaterial.src = ToggleText;
    //     }
    // }

    function ToggleSlider(state) {
        _classCallCheck(this, ToggleSlider);

        var _this = _possibleConstructorReturn(this, (ToggleSlider.__proto__ || Object.getPrototypeOf(ToggleSlider)).call(this, state));

        _this.btnMaterial = {
            shader: "flat",
            transparent: true
        };

        _this.state = {
            material: Object.assign({}, _this.btnMaterial, {
                src: __WEBPACK_IMPORTED_MODULE_2__assets_icons_switch_img_png___default.a
            }),

            fixed: true,

            velocity: 0.01,
            curY: 0
        };

        _this.lastCam = 0;
        return _this;
    }

    _createClass(ToggleSlider, [{
        key: 'renderImage',
        value: function renderImage() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"], {
                geometry: { primitive: "plane", width: 2, height: 0.73 },
                material: this.state.material,

                position: { x: 1.0, y: 0, z: 0.1 },

                events: {
                    clickUp: function clickUp() {
                        console.log("Text Search Clicked");

                        if (_this2.props.globalState.searchType === "IMAGE_SEARCH") {

                            _this2.setState({
                                material: {
                                    transparent: true,
                                    src: __WEBPACK_IMPORTED_MODULE_3__assets_icons_switch_txt_png___default.a
                                }
                            });
                            _this2.props.setSearchState("TEXT_SEARCH");
                        } else {

                            _this2.setState({
                                material: {
                                    transparent: true,
                                    src: __WEBPACK_IMPORTED_MODULE_2__assets_icons_switch_img_png___default.a
                                }
                            });
                            _this2.props.setSearchState("IMAGE_SEARCH");
                        }
                    }
                },

                'frame-button': {
                    button: true
                }
            });
        }
    }, {
        key: 'shareItems',
        value: function shareItems() {
            var _this3 = this;

            this.props.generateLinkHUD();

            uCoder.encodeData(this.props.sceneItems).then(function (url) {
                console.log(url);
                _this3.props.setLinkHUD(url);
            });
        }
    }, {
        key: 'addIcon',
        value: function addIcon() {
            console.log("Create stuff");
            this.props.setWorldState("WORLD_ICON");
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                { 'control-box': true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"]
                    // geometry={{primitive: "plane", height: 1.2, width: 5}}

                    // material={{ ...this.btnMaterial, src: PanelBackground, }}

                    ,
                    { rotation: { x: -45, y: 0, z: 0 },
                        position: { x: 0, y: -2.0, z: -4.71 },
                        scale: { x: 0.7, y: 0.7, z: 1 }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_NavButton__["a" /* default */], {

                        src: __WEBPACK_IMPORTED_MODULE_7__assets_icons_btn_panel_exit_png___default.a,

                        text: "switch space",

                        position: { x: -1.6, y: 0, z: 0.1 },
                        click: function click() {
                            return _this4.props.switchSpaceHUD();
                        }

                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_NavButton__["a" /* default */], {

                        src: __WEBPACK_IMPORTED_MODULE_9__assets_icons_btn_share_png___default.a,

                        text: "share",

                        position: { x: -0.6, y: 0, z: 0.1 },
                        click: function click() {
                            return _this4.shareItems();
                        }

                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_NavButton__["a" /* default */], {
                        src: __WEBPACK_IMPORTED_MODULE_10__assets_icons_btn_feedback_png___default.a,

                        text: "add emoji",

                        position: { x: 2.6, y: 0, z: 0.1 },
                        click: function click() {
                            return _this4.addIcon();
                        }

                    }),
                    this.renderImage()
                )
            );
        }
    }]);

    return ToggleSlider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ToggleSlider);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aframe_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aframe_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_mic_png__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_mic_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_icons_mic_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_aframe_fixed__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_fonts_quicksand_fnt__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_fonts_quicksand_fnt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_fonts_quicksand_fnt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_fonts_quicksand_png__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_fonts_quicksand_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_fonts_quicksand_png__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var TutorialClick = function (_Component) {
    _inherits(TutorialClick, _Component);

    function TutorialClick() {
        _classCallCheck(this, TutorialClick);

        return _possibleConstructorReturn(this, (TutorialClick.__proto__ || Object.getPrototypeOf(TutorialClick)).apply(this, arguments));
    }

    _createClass(TutorialClick, [{
        key: "render",
        value: function render() {

            // console.log(this.props)

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                { position: { x: 0, y: 1.6, z: 0 }, visible: this.props.tutorial.active, fixed: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"],
                    { position: { x: 0, y: 0.4, z: -5 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_aframe_react__["Entity"], {
                        primitive: "a-text",
                        value: "Tap The Button To Active Mic",

                        color: "#282828",

                        text: {
                            font: __WEBPACK_IMPORTED_MODULE_4__assets_fonts_quicksand_fnt___default.a,
                            fontImage: __WEBPACK_IMPORTED_MODULE_5__assets_fonts_quicksand_png___default.a
                        },

                        align: "center"
                    })
                )
            );
        }
    }]);

    return TutorialClick;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (TutorialClick);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_boxes__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(25);









// import camera from "../helpers/camera-helper"

var mapStateToProps = function mapStateToProps(state) {
    // console.log(state.sceneItems.spaces[state.sceneItems.curSpaceId])
    return {
        // sceneItems: state.sceneItems.el,
        sceneItems: state.sceneItems.spaces[state.sceneItems.curSpaceId].el
        // camera: state.camera  //camera.rot
    };
};

var matchDispatchToProps = function matchDispatchToProps(dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])({
        setDrag: __WEBPACK_IMPORTED_MODULE_4__actions__["k" /* setDrag */],
        rmvItem: __WEBPACK_IMPORTED_MODULE_4__actions__["l" /* rmvItem */],

        moveBox: __WEBPACK_IMPORTED_MODULE_4__actions__["m" /* moveBox */],

        saveDrag: __WEBPACK_IMPORTED_MODULE_4__actions__["n" /* saveDrag */]
    }, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, matchDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__components_boxes__["a" /* default */]));

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_hud__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_hud__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(25);









var mapStateToProps = function mapStateToProps(state) {
    return {
        hud: state.hud,
        spaces: state.sceneItems.spaces,
        curSpace: state.sceneItems.curSpaceId
    };
};

var matchDispatchToProps = function matchDispatchToProps(dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])({
        enableHUD: __WEBPACK_IMPORTED_MODULE_3__actions_hud__["a" /* enableHUD */],
        disableHUD: __WEBPACK_IMPORTED_MODULE_3__actions_hud__["b" /* disableHUD */],

        addSpace: __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* addSpace */],
        switchSpace: __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* switchSpace */],
        updateSpaceName: __WEBPACK_IMPORTED_MODULE_4__actions__["c" /* updateSpaceName */],
        deleteSpace: __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* deleteSpace */]

    }, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, matchDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components_hud__["a" /* default */]));

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_main_sphere__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_microphone__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(25);











var mapStateToProps = function mapStateToProps(state) {
    return {};
};

var matchDispatchToProps = function matchDispatchToProps(dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])({
        setWorldState: __WEBPACK_IMPORTED_MODULE_4__actions__["e" /* setWorldState */],
        startSpeech: __WEBPACK_IMPORTED_MODULE_3__actions_microphone__["b" /* startSpeech */]
    }, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, matchDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components_main_sphere__["a" /* default */]));

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_popup_display__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_microphone__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(25);












// import camera from '../helpers/camera-helper'

var mapStateToProps = function mapStateToProps(state) {
    return {
        globalState: state.globalState,
        mic: state.microphone,
        search: state.search,
        keyboard: state.keyboard
        // camera: state.camera // camera.rot
    };
};

var matchDispatchToProps = function matchDispatchToProps(dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])({
        startSpeech: __WEBPACK_IMPORTED_MODULE_4__actions_microphone__["b" /* startSpeech */],
        setWorldState: __WEBPACK_IMPORTED_MODULE_5__actions__["e" /* setWorldState */],
        addBox: __WEBPACK_IMPORTED_MODULE_5__actions__["i" /* addBox */]
    }, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, matchDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__components_popup_display__["a" /* default */]));

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toggle_slider__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_hud__ = __webpack_require__(136);












// import camera from "../helpers/camera-helper"


var mapStateToProps = function mapStateToProps(state) {
    return {
        globalState: state.globalState,
        sceneItems: state.sceneItems
        // camera: state.camera, //camera.rot
    };
};

var matchDispatchToProps = function matchDispatchToProps(dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])({
        setSearchState: __WEBPACK_IMPORTED_MODULE_4__actions__["g" /* setSearchState */],
        setWorldState: __WEBPACK_IMPORTED_MODULE_4__actions__["e" /* setWorldState */],
        clearItems: __WEBPACK_IMPORTED_MODULE_4__actions__["h" /* clearItems */],
        setLinkHUD: __WEBPACK_IMPORTED_MODULE_5__actions_hud__["c" /* setLinkHUD */],
        switchSpaceHUD: __WEBPACK_IMPORTED_MODULE_5__actions_hud__["d" /* switchSpaceHUD */],
        generateLinkHUD: __WEBPACK_IMPORTED_MODULE_5__actions_hud__["e" /* generateLinkHUD */]
    }, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, matchDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__components_toggle_slider__["a" /* default */]));

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tutorial_click__ = __webpack_require__(314);








// import camera from "../helpers/camera-helper"


var mapStateToProps = function mapStateToProps(state) {
    return {
        tutorial: state.tutorial
        // camera: state.camera, //camera.rot, 
    };
};

var matchDispatchToProps = function matchDispatchToProps(dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])({}, dispatch);
};

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, matchDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__components_tutorial_click__["a" /* default */]));

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//
// Copyright (c) 2017 by Fedir Bobylev. All Rights Reserved.
//

var GoogleImageSearch = function () {
    function GoogleImageSearch() {
        _classCallCheck(this, GoogleImageSearch);
    }

    _createClass(GoogleImageSearch, null, [{
        key: "searchImage",


        /**
         * Function for image search
         *
         * @param  {string} query   Image search filed query
         * @return {Promise}        Returns a promise, with an array of found image URL's
         */
        value: function searchImage(query) {
            var _this = this;

            query = encodeURIComponent(query);

            return new Promise(function (resolve, reject) {

                // Fetches Items from Google Image Search URL
                fetch("https://crossorigin.me/https://www.google.com.ua/search?source=lnms&sa=X&gbv=1&tbm=isch&q=" + query).then(function (res) {
                    return res.text();
                }).then(function (res) {

                    // Transforms HTML string into DOM object
                    var parser = new DOMParser();
                    parser = parser.parseFromString(res, "text/html");

                    // Gets DOM element with image results
                    var images = parser.getElementById("ires").childNodes[0];

                    if (images.nodeName === "DIV") {

                        resolve(_this.googleGetMobile(images));
                    } else if (images.nodeName === "TABLE") {

                        resolve(_this.googleGetDesktop(images));
                    } else {

                        reject("Unknown System");
                    }
                }).catch(function (err) {
                    return reject(err);
                });
            });
        }

        /**
         * Traverses DOM tree in mobile layout
         *
         * @param  {NodeList} images    Children of "ires" container
         * @return {Array}              Array of found images URL's
         */

    }, {
        key: "googleGetMobile",
        value: function googleGetMobile(images) {

            // Transforms DOM NodeList of images into Array.
            // Needed to use .map method
            images = Array.from(images.childNodes);

            // Maps Image Sources
            return images.map(function (imgDiv) {
                return {
                    src: imgDiv.childNodes[0].src,
                    width: 0, //imgDiv.childNodes[0].width,
                    height: 0
                };
            });
        }

        /**
         * Traverses DOM tree in desktop layout
         *
         * @param  {NodeList} images    Children of "ires" container
         * @return {Array}              Array of found images URLs
         */

    }, {
        key: "googleGetDesktop",
        value: function googleGetDesktop(images) {

            // NodeList of table rows
            images = images.childNodes[0].childNodes;

            // Empty List of image URLs
            var imgSrc = [];

            // Traverses table node for images
            images.forEach(function (tRow) {
                tRow = tRow.childNodes;
                tRow.forEach(function (tCol) {
                    var aLink = tCol.childNodes[0].childNodes[0];
                    imgSrc.push({ src: aLink.src, width: aLink.width, height: aLink.height });
                });
            });

            return imgSrc;
        }
    }]);

    return GoogleImageSearch;
}();

/* harmony default export */ __webpack_exports__["a"] = (GoogleImageSearch);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return saveState; });

var loadState = function loadState() {
    try {
        var storageState = localStorage.getItem('redux');
        if (storageState === null) {
            return undefined;
        }
        return JSON.parse(storageState);
    } catch (err) {
        return undefined;
    }
};

var saveState = function saveState(state) {
    try {
        var storageState = JSON.stringify(state);
        localStorage.setItem('redux', storageState);
    } catch (err) {
        console.log(err);
    }
};

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var defaultState = {
    x: 0, y: 0, // Rotation Vec2

    delta: 0
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];


    switch (action.type) {

        case "CAMERA_ROTATION_CHANGE":
            var delta = Math.abs(action.y - state.y);
            return Object.assign({}, state, {

                x: action.x,
                y: action.y,

                delta: delta <= 0.1 ? state.delta : delta

            });
            break;

        default:
            return state;
    }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultState = {

    worldView: "WORLD_VIEW", // WORLD_VIEW, WORLD_INPUT, WORLD_SELECT (image selection), WORLD_PLACE
    searchType: "IMAGE_SEARCH" // IMAGE_SEARCH, TEXT_INPUT
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];


    switch (action.type) {

        case "SET_WORLD_STATE":
            return Object.assign({}, state, {
                worldView: action.state
            });

        case "SET_SEARCH_STATE":
            return Object.assign({}, state, {
                searchType: action.state
            });

        case "ADD_TEXT":
            return Object.assign({}, state, {
                worldView: "WORLD_VIEW"
            });

        case "SEARCH_DONE":
            return Object.assign({}, state, {
                worldView: "WORLD_SELECT"
            });

        case "SEARCH_ERROR":
            return Object.assign({}, state, {
                worldView: "WORLD_ERROR"
            });

        case "MIC_RESET":
            console.log("MICROPHONE RESET on world state");
            return Object.assign({}, state, {
                worldView: "WORLD_VIEW"
            });

        case "SPEECH_START":
            return Object.assign({}, state, {
                worldView: "WORLD_INPUT"
            });

        case "SEARCH_ERR":
            return Object.assign({}, state, {
                worldView: "WORLD_VIEW"
            });

        case "HUD_SPACE_SELECT":
            return Object.assign({}, state, {
                worldView: "WORLD_HUD"
            });

        case "HUD_SELECT":
            return Object.assign({}, state, {
                worldView: "WORLD_VIEW"
            });

        case "HUD_DISABLE":
            return Object.assign({}, state, {
                worldView: "WORLD_VIEW"
            });

        default:
            return state;
    }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var defaultState = {

    visible: false,
    link: "link",

    state: "SPACE_SWITCH", // SPEECH_ERROR, LINK_SHARE, SPACE_SWITCH, CREATING_LINK

    speechError: false
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];


    switch (action.type) {

        case "HUD_ENABLE":
            return Object.assign({}, defaultState, {
                visible: true
            });

        case "HUD_DISABLE":
            return Object.assign({}, defaultState, {
                visible: false
            });

        case "HUD_SET_LINK":
            return Object.assign({}, defaultState, {
                visible: true,
                state: "LINK_SHARE",
                link: action.link
            });

        case "HUD_SPEECH_ERROR":
            return Object.assign({}, defaultState, {
                // speechError: true,
                state: "SPEECH_ERROR",
                visible: true
            });

        case "HUD_LOADING":
            return Object.assign({}, defaultState, {
                state: "CREATING_LINK",
                visible: true
            });

        case "HUD_SPACE_SELECT":
            return Object.assign({}, defaultState, {
                state: "SPACE_SWITCH",
                visible: true
            });

        case "SWITCH_SPACE":
            return Object.assign({}, defaultState, {
                visible: false
            });

        default:
            return state;
    }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scene_items__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microphone__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__search__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_state__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__camera__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tutorial__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hud__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__keyboard__ = __webpack_require__(327);












var reducers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
    sceneItems: __WEBPACK_IMPORTED_MODULE_1__scene_items__["a" /* default */],
    microphone: __WEBPACK_IMPORTED_MODULE_2__microphone__["a" /* default */],
    search: __WEBPACK_IMPORTED_MODULE_3__search__["a" /* default */],
    globalState: __WEBPACK_IMPORTED_MODULE_4__global_state__["a" /* default */],
    camera: __WEBPACK_IMPORTED_MODULE_5__camera__["a" /* default */],
    tutorial: __WEBPACK_IMPORTED_MODULE_6__tutorial__["a" /* default */],
    hud: __WEBPACK_IMPORTED_MODULE_7__hud__["a" /* default */],
    keyboard: __WEBPACK_IMPORTED_MODULE_8__keyboard__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (reducers);

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var defaultState = {

    text: ""
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];


    switch (action.type) {
        case "KEYBOARD_ADD":
            return Object.assign({}, state, {
                text: state.text + action.symbol
            });

        case "KEYBOARD_BACKSPACE":
            return Object.assign({}, state, {
                text: state.text.slice(0, -1)
            });

        case "KEYBOARD_CLEAR":
            return Object.assign({}, state, {
                text: ""
            });

        default:
            return state;
    }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var defaultState = {

    state: "SPEECH_IDDLE", // Possible States SPEECH_IDDLE, SPEECH_ACTIVE
    text: ""
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];


    switch (action.type) {
        case "SPEECH_START":
            return Object.assign({}, state, {
                state: "SPEECH_START",
                text: ""
            });

        case "SPEECH_ABORT":
            return Object.assign({}, state, {
                state: "SPEECH_ABORT"
            });

        case "SPEECH_STOP":
            return Object.assign({}, state, {
                state: "SPEECH_STOP"
            });

        case "SPEECH_END":
            return Object.assign({}, state, {
                // text: "",
                state: "SPEECH_IDDLE"
            });

        case "SET_INTERIM_SPEECH":
            return Object.assign({}, state, {
                text: action.result
            });

        case "SET_FINAL_SPEECH":
            return Object.assign({}, state, {
                text: action.result,
                state: "SPEECH_IDDLE"
            });

        case "MIC_RESET":
            console.log("Microphone reset on MIC");
            return Object.assign({}, state, {
                text: "",
                state: "SPEECH_IDDLE"
            });

        default:
            return state;
    }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var defaultState = {
    lastId: 0,

    curSpaceId: 0,
    spaces: [{
        name: "Blank Space",
        el: []
    }],

    el: []
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];


    switch (action.type) {
        case "ADD_IMAGE":
            return Object.assign({}, state, {

                spaces: state.spaces.map(function (space, index) {
                    return state.curSpaceId === index ? Object.assign({}, space, {
                        el: [].concat(_toConsumableArray(space.el), [{
                            id: state.lastId++,
                            type: "IMAGE",
                            img: action.image,
                            rotation: { x: action.x, y: action.y, z: 0 },
                            depth: -12,
                            drag: false
                        }])
                    }) : space;
                })

            });

        case "ADD_TEXT":

            return Object.assign({}, state, {
                spaces: state.spaces.map(function (space, index) {
                    return state.curSpaceId === index ? Object.assign({}, space, {
                        el: [].concat(_toConsumableArray(space.el), [{
                            id: state.lastId++,
                            type: "TEXT",
                            text: action.text,
                            rotation: { x: action.x, y: action.y, z: 0 },
                            depth: -12,
                            drag: false
                        }])
                    }) : space;
                })

            });

        case "MOVE_BOX":
            return Object.assign({}, state, {
                spaces: state.spaces.map(function (space, index) {
                    return state.curSpaceId === index ? Object.assign({}, space, {
                        el: space.el.map(function (item, index) {
                            return index === action.index ? Object.assign({}, item, { depth: action.z }) : item;
                        })

                    }) : space;
                })

            });

        case "ADD_SPACE":
            return Object.assign({}, state, {
                spaces: [].concat(_toConsumableArray(state.spaces), [{
                    name: action.name,
                    el: []
                }])
            });

        case "SWITCH_SPACE":
            return Object.assign({}, state, {
                curSpaceId: action.id
            });

        case "UPDATE_SPACE_NAME":
            return Object.assign({}, state, {
                spaces: state.spaces.map(function (space, index) {
                    return action.id === index ? Object.assign({}, space, {
                        name: action.name

                    }) : space;
                })
            });

        case "DELETE_SPACE":
            return Object.assign({}, state, {
                spaces: state.spaces.length > 1 && action.id !== state.spaces.length - 1 ? [].concat(_toConsumableArray(state.spaces.slice(0, action.id)), _toConsumableArray(state.spaces.slice(action.id + 1))) : state.spaces.length > 1 ? [].concat(_toConsumableArray(state.spaces.slice(0, action.id))) : [].concat(_toConsumableArray(state.spaces)),

                curSpaceId: state.spaces.length > 1 && action.id === state.spaces.length - 1 ? 0 : 0

            });

        case "REMOVE_ITEM":
            return Object.assign({}, state, {
                spaces: state.spaces.map(function (space, index) {
                    return state.curSpaceId === index ? Object.assign({}, space, {
                        el: [].concat(_toConsumableArray(space.el.slice(0, action.index)), _toConsumableArray(space.el.slice(action.index + 1)))

                    }) : space;
                })

            });

        case "CLEAR_ALL":
            return Object.assign({}, state, {
                spaces: state.spaces.map(function (space, index) {
                    return state.curSpaceId === index ? Object.assign({}, space, {
                        el: []

                    }) : space;
                })
                // el: []
            });

        case "SAVE_DRAG":
            return Object.assign({}, state, {
                spaces: state.spaces.map(function (space, index) {
                    return state.curSpaceId === index ? Object.assign({}, space, {
                        el: space.el.map(function (item, index) {
                            return index === action.index ? Object.assign({}, item, {
                                rotation: { x: action.x, y: action.y, z: 0 }
                            }) : item;
                        })

                    }) : space;
                })

            });

        case "CAMERA_ROTATION_CHANGE":
            return Object.assign({}, state, {

                spaces: state.spaces.map(function (space, index) {
                    return state.curSpaceId === index ? Object.assign({}, space, {
                        el: space.el.map(function (item, index) {
                            return item.drag ? Object.assign({}, item, {
                                rotation: { x: action.x, y: action.y, z: 0 }
                            }) : item;
                        })

                    }) : space;
                })

            });

        case "URL_LOADED":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var defaultState = {

    state: "SEARCH_DONE", //  SEARCH_FETCHING, SEARCH_DONE
    results: [], // Results
    query: "", // Search query

    pos: { x: 0, y: 0, z: 0 }
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];


    switch (action.type) {

        case "SEARCH_FETCH":
            return Object.assign({}, state, {
                state: "SEARCH_FETCHING",
                query: action.query
            });

        case "SPEECH_END":
            if (action.searchType === "IMAGE_SEARCH") return Object.assign({}, state, {
                state: "SEARCH_FETCHING",
                query: action.result
            });else if (action.searchType === "TEXT_SEARCH") return Object.assign({}, state, {
                state: "SEARCH_INSERT_TEXT",
                query: action.result
            });else return state;

        case "KEYBOARD_SUBMIT":
            if (action.searchType === "IMAGE_SEARCH") return Object.assign({}, state, {
                state: "SEARCH_FETCHING",
                query: action.result
            });else if (action.searchType === "TEXT_SEARCH") return Object.assign({}, state, {
                state: "SEARCH_INSERT_TEXT",
                query: action.result
            });else return state;

        case "SEARCH_ERROR":
            return Object.assign({}, state, {
                state: "SEARCH_DONE"
            });

        case "SEARCH_DONE":
            console.log('[REDUX SEARCH_DONE]:', action.results);

            return Object.assign({}, state, {
                state: "SEARCH_DONE",
                results: action.results,

                pos: { x: action.x, y: action.y, z: 0 }
            });

        default:
            return state;
    }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var defaultState = {

    active: true
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];


    switch (action.type) {

        case "SPEECH_START":
            return { active: false };

        default:
            return state;
    }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.

// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.

function register() {
  if ("production" === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', function () {
      var swUrl = "/garage48-vrideas" + '/service-worker.js';
      navigator.serviceWorker.register(swUrl).then(function (registration) {
        registration.onupdatefound = function () {
          var installingWorker = registration.installing;
          installingWorker.onstatechange = function () {
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // At this point, the old content will have been purged and
                // the fresh content will have been added to the cache.
                // It's the perfect time to display a "New content is
                // available; please refresh." message in your web app.
                console.log('New content is available; please refresh.');
              } else {
                // At this point, everything has been precached.
                // It's the perfect time to display a
                // "Content is cached for offline use." message.
                console.log('Content is cached for offline use.');
              }
            }
          };
        };
      }).catch(function (error) {
        console.error('Error during service worker registration:', error);
      });
    });
  }
}

function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(function (registration) {
      registration.unregister();
    });
  }
}

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports = {
	"name": "cannon",
	"version": "0.6.2",
	"description": "A lightweight 3D physics engine written in JavaScript.",
	"homepage": "https://github.com/schteppe/cannon.js",
	"author": "Stefan Hedman <schteppe@gmail.com> (http://steffe.se)",
	"keywords": [
		"cannon.js",
		"cannon",
		"physics",
		"engine",
		"3d"
	],
	"main": "./src/Cannon.js",
	"engines": {
		"node": "*"
	},
	"repository": {
		"type": "git",
		"url": "https://github.com/schteppe/cannon.js.git"
	},
	"bugs": {
		"url": "https://github.com/schteppe/cannon.js/issues"
	},
	"licenses": [
		{
			"type": "MIT"
		}
	],
	"devDependencies": {
		"jshint": "latest",
		"uglify-js": "latest",
		"nodeunit": "^0.9.0",
		"grunt": "~0.4.0",
		"grunt-contrib-jshint": "~0.1.1",
		"grunt-contrib-nodeunit": "^0.4.1",
		"grunt-contrib-concat": "~0.1.3",
		"grunt-contrib-uglify": "^0.5.1",
		"grunt-browserify": "^2.1.4",
		"grunt-contrib-yuidoc": "^0.5.2",
		"browserify": "*"
	},
	"dependencies": {}
};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = GridBroadphase;

var Broadphase = __webpack_require__(69);
var Vec3 = __webpack_require__(0);
var Shape = __webpack_require__(12);

/**
 * Axis aligned uniform grid broadphase.
 * @class GridBroadphase
 * @constructor
 * @extends Broadphase
 * @todo Needs support for more than just planes and spheres.
 * @param {Vec3} aabbMin
 * @param {Vec3} aabbMax
 * @param {Number} nx Number of boxes along x
 * @param {Number} ny Number of boxes along y
 * @param {Number} nz Number of boxes along z
 */
function GridBroadphase(aabbMin,aabbMax,nx,ny,nz){
    Broadphase.apply(this);
    this.nx = nx || 10;
    this.ny = ny || 10;
    this.nz = nz || 10;
    this.aabbMin = aabbMin || new Vec3(100,100,100);
    this.aabbMax = aabbMax || new Vec3(-100,-100,-100);
	var nbins = this.nx * this.ny * this.nz;
	if (nbins <= 0) {
		throw "GridBroadphase: Each dimension's n must be >0";
	}
    this.bins = [];
	this.binLengths = []; //Rather than continually resizing arrays (thrashing the memory), just record length and allow them to grow
	this.bins.length = nbins;
	this.binLengths.length = nbins;
	for (var i=0;i<nbins;i++) {
		this.bins[i]=[];
		this.binLengths[i]=0;
	}
}
GridBroadphase.prototype = new Broadphase();
GridBroadphase.prototype.constructor = GridBroadphase;

/**
 * Get all the collision pairs in the physics world
 * @method collisionPairs
 * @param {World} world
 * @param {Array} pairs1
 * @param {Array} pairs2
 */
var GridBroadphase_collisionPairs_d = new Vec3();
var GridBroadphase_collisionPairs_binPos = new Vec3();
GridBroadphase.prototype.collisionPairs = function(world,pairs1,pairs2){
    var N = world.numObjects(),
        bodies = world.bodies;

    var max = this.aabbMax,
        min = this.aabbMin,
        nx = this.nx,
        ny = this.ny,
        nz = this.nz;

	var xstep = ny*nz;
	var ystep = nz;
	var zstep = 1;

    var xmax = max.x,
        ymax = max.y,
        zmax = max.z,
        xmin = min.x,
        ymin = min.y,
        zmin = min.z;

    var xmult = nx / (xmax-xmin),
        ymult = ny / (ymax-ymin),
        zmult = nz / (zmax-zmin);

    var binsizeX = (xmax - xmin) / nx,
        binsizeY = (ymax - ymin) / ny,
        binsizeZ = (zmax - zmin) / nz;

	var binRadius = Math.sqrt(binsizeX*binsizeX + binsizeY*binsizeY + binsizeZ*binsizeZ) * 0.5;

    var types = Shape.types;
    var SPHERE =            types.SPHERE,
        PLANE =             types.PLANE,
        BOX =               types.BOX,
        COMPOUND =          types.COMPOUND,
        CONVEXPOLYHEDRON =  types.CONVEXPOLYHEDRON;

    var bins=this.bins,
		binLengths=this.binLengths,
        Nbins=this.bins.length;

    // Reset bins
    for(var i=0; i!==Nbins; i++){
        binLengths[i] = 0;
    }

    var ceil = Math.ceil;
	var min = Math.min;
	var max = Math.max;

	function addBoxToBins(x0,y0,z0,x1,y1,z1,bi) {
		var xoff0 = ((x0 - xmin) * xmult)|0,
			yoff0 = ((y0 - ymin) * ymult)|0,
			zoff0 = ((z0 - zmin) * zmult)|0,
			xoff1 = ceil((x1 - xmin) * xmult),
			yoff1 = ceil((y1 - ymin) * ymult),
			zoff1 = ceil((z1 - zmin) * zmult);

		if (xoff0 < 0) { xoff0 = 0; } else if (xoff0 >= nx) { xoff0 = nx - 1; }
		if (yoff0 < 0) { yoff0 = 0; } else if (yoff0 >= ny) { yoff0 = ny - 1; }
		if (zoff0 < 0) { zoff0 = 0; } else if (zoff0 >= nz) { zoff0 = nz - 1; }
		if (xoff1 < 0) { xoff1 = 0; } else if (xoff1 >= nx) { xoff1 = nx - 1; }
		if (yoff1 < 0) { yoff1 = 0; } else if (yoff1 >= ny) { yoff1 = ny - 1; }
		if (zoff1 < 0) { zoff1 = 0; } else if (zoff1 >= nz) { zoff1 = nz - 1; }

		xoff0 *= xstep;
		yoff0 *= ystep;
		zoff0 *= zstep;
		xoff1 *= xstep;
		yoff1 *= ystep;
		zoff1 *= zstep;

		for (var xoff = xoff0; xoff <= xoff1; xoff += xstep) {
			for (var yoff = yoff0; yoff <= yoff1; yoff += ystep) {
				for (var zoff = zoff0; zoff <= zoff1; zoff += zstep) {
					var idx = xoff+yoff+zoff;
					bins[idx][binLengths[idx]++] = bi;
				}
			}
		}
	}

    // Put all bodies into the bins
    for(var i=0; i!==N; i++){
        var bi = bodies[i];
        var si = bi.shape;

        switch(si.type){
        case SPHERE:
            // Put in bin
            // check if overlap with other bins
            var x = bi.position.x,
                y = bi.position.y,
                z = bi.position.z;
            var r = si.radius;

			addBoxToBins(x-r, y-r, z-r, x+r, y+r, z+r, bi);
            break;

        case PLANE:
            if(si.worldNormalNeedsUpdate){
                si.computeWorldNormal(bi.quaternion);
            }
            var planeNormal = si.worldNormal;

			//Relative position from origin of plane object to the first bin
			//Incremented as we iterate through the bins
			var xreset = xmin + binsizeX*0.5 - bi.position.x,
				yreset = ymin + binsizeY*0.5 - bi.position.y,
				zreset = zmin + binsizeZ*0.5 - bi.position.z;

            var d = GridBroadphase_collisionPairs_d;
			d.set(xreset, yreset, zreset);

			for (var xi = 0, xoff = 0; xi !== nx; xi++, xoff += xstep, d.y = yreset, d.x += binsizeX) {
				for (var yi = 0, yoff = 0; yi !== ny; yi++, yoff += ystep, d.z = zreset, d.y += binsizeY) {
					for (var zi = 0, zoff = 0; zi !== nz; zi++, zoff += zstep, d.z += binsizeZ) {
						if (d.dot(planeNormal) < binRadius) {
							var idx = xoff + yoff + zoff;
							bins[idx][binLengths[idx]++] = bi;
						}
					}
				}
			}
            break;

        default:
			if (bi.aabbNeedsUpdate) {
				bi.computeAABB();
			}

			addBoxToBins(
				bi.aabb.lowerBound.x,
				bi.aabb.lowerBound.y,
				bi.aabb.lowerBound.z,
				bi.aabb.upperBound.x,
				bi.aabb.upperBound.y,
				bi.aabb.upperBound.z,
				bi);
            break;
        }
    }

    // Check each bin
    for(var i=0; i!==Nbins; i++){
		var binLength = binLengths[i];
		//Skip bins with no potential collisions
		if (binLength > 1) {
			var bin = bins[i];

			// Do N^2 broadphase inside
			for(var xi=0; xi!==binLength; xi++){
				var bi = bin[xi];
				for(var yi=0; yi!==xi; yi++){
					var bj = bin[yi];
					if(this.needBroadphaseCollision(bi,bj)){
						this.intersectionTest(bi,bj,pairs1,pairs2);
					}
				}
			}
		}
    }

//	for (var zi = 0, zoff=0; zi < nz; zi++, zoff+= zstep) {
//		console.log("layer "+zi);
//		for (var yi = 0, yoff=0; yi < ny; yi++, yoff += ystep) {
//			var row = '';
//			for (var xi = 0, xoff=0; xi < nx; xi++, xoff += xstep) {
//				var idx = xoff + yoff + zoff;
//				row += ' ' + binLengths[idx];
//			}
//			console.log(row);
//		}
//	}

    this.makePairsUnique(pairs1,pairs2);
};


/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports = ObjectCollisionMatrix;

/**
 * Records what objects are colliding with each other
 * @class ObjectCollisionMatrix
 * @constructor
 */
function ObjectCollisionMatrix() {

    /**
     * The matrix storage
     * @property matrix
     * @type {Object}
     */
	this.matrix = {};
}

/**
 * @method get
 * @param  {Number} i
 * @param  {Number} j
 * @return {Number}
 */
ObjectCollisionMatrix.prototype.get = function(i, j) {
	i = i.id;
	j = j.id;
    if (j > i) {
        var temp = j;
        j = i;
        i = temp;
    }
	return i+'-'+j in this.matrix;
};

/**
 * @method set
 * @param  {Number} i
 * @param  {Number} j
 * @param {Number} value
 */
ObjectCollisionMatrix.prototype.set = function(i, j, value) {
	i = i.id;
	j = j.id;
    if (j > i) {
        var temp = j;
        j = i;
        i = temp;
	}
	if (value) {
		this.matrix[i+'-'+j] = true;
	}
	else {
		delete this.matrix[i+'-'+j];
	}
};

/**
 * Empty the matrix
 * @method reset
 */
ObjectCollisionMatrix.prototype.reset = function() {
	this.matrix = {};
};

/**
 * Set max number of objects
 * @method setNumObjects
 * @param {Number} n
 */
ObjectCollisionMatrix.prototype.setNumObjects = function(n) {
};


/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports = OverlapKeeper;

/**
 * @class OverlapKeeper
 * @constructor
 */
function OverlapKeeper() {
    this.current = [];
    this.previous = [];
}

OverlapKeeper.prototype.getKey = function(i, j) {
    if (j < i) {
        var temp = j;
        j = i;
        i = temp;
    }
    return (i << 16) | j;
};


/**
 * @method set
 * @param {Number} i
 * @param {Number} j
 */
OverlapKeeper.prototype.set = function(i, j) {
    // Insertion sort. This way the diff will have linear complexity.
    var key = this.getKey(i, j);
    var current = this.current;
    var index = 0;
    while(key > current[index]){
        index++;
    }
    if(key === current[index]){
        return; // Pair was already added
    }
    for(var j=current.length-1; j>=index; j--){
        current[j + 1] = current[j];
    }
    current[index] = key;
};

/**
 * @method tick
 */
OverlapKeeper.prototype.tick = function() {
    var tmp = this.current;
    this.current = this.previous;
    this.previous = tmp;
    this.current.length = 0;
};

function unpackAndPush(array, key){
    array.push((key & 0xFFFF0000) >> 16, key & 0x0000FFFF);
}

/**
 * @method getDiff
 * @param  {array} additions
 * @param  {array} removals
 */
OverlapKeeper.prototype.getDiff = function(additions, removals) {
    var a = this.current;
    var b = this.previous;
    var al = a.length;
    var bl = b.length;

    var j=0;
    for (var i = 0; i < al; i++) {
        var found = false;
        var keyA = a[i];
        while(keyA > b[j]){
            j++;
        }
        found = keyA === b[j];

        if(!found){
            unpackAndPush(additions, keyA);
        }
    }
    j = 0;
    for (var i = 0; i < bl; i++) {
        var found = false;
        var keyB = b[i];
        while(keyB > a[j]){
            j++;
        }
        found = a[j] === keyB;

        if(!found){
            unpackAndPush(removals, keyB);
        }
    }
};

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var Shape = __webpack_require__(12);
var Broadphase = __webpack_require__(69);

module.exports = SAPBroadphase;

/**
 * Sweep and prune broadphase along one axis.
 *
 * @class SAPBroadphase
 * @constructor
 * @param {World} [world]
 * @extends Broadphase
 */
function SAPBroadphase(world){
    Broadphase.apply(this);

    /**
     * List of bodies currently in the broadphase.
     * @property axisList
     * @type {Array}
     */
    this.axisList = [];

    /**
     * The world to search in.
     * @property world
     * @type {World}
     */
    this.world = null;

    /**
     * Axis to sort the bodies along. Set to 0 for x axis, and 1 for y axis. For best performance, choose an axis that the bodies are spread out more on.
     * @property axisIndex
     * @type {Number}
     */
    this.axisIndex = 0;

    var axisList = this.axisList;

    this._addBodyHandler = function(e){
        axisList.push(e.body);
    };

    this._removeBodyHandler = function(e){
        var idx = axisList.indexOf(e.body);
        if(idx !== -1){
            axisList.splice(idx,1);
        }
    };

    if(world){
        this.setWorld(world);
    }
}
SAPBroadphase.prototype = new Broadphase();

/**
 * Change the world
 * @method setWorld
 * @param  {World} world
 */
SAPBroadphase.prototype.setWorld = function(world){
    // Clear the old axis array
    this.axisList.length = 0;

    // Add all bodies from the new world
    for(var i=0; i<world.bodies.length; i++){
        this.axisList.push(world.bodies[i]);
    }

    // Remove old handlers, if any
    world.removeEventListener("addBody", this._addBodyHandler);
    world.removeEventListener("removeBody", this._removeBodyHandler);

    // Add handlers to update the list of bodies.
    world.addEventListener("addBody", this._addBodyHandler);
    world.addEventListener("removeBody", this._removeBodyHandler);

    this.world = world;
    this.dirty = true;
};

/**
 * @static
 * @method insertionSortX
 * @param  {Array} a
 * @return {Array}
 */
SAPBroadphase.insertionSortX = function(a) {
    for(var i=1,l=a.length;i<l;i++) {
        var v = a[i];
        for(var j=i - 1;j>=0;j--) {
            if(a[j].aabb.lowerBound.x <= v.aabb.lowerBound.x){
                break;
            }
            a[j+1] = a[j];
        }
        a[j+1] = v;
    }
    return a;
};

/**
 * @static
 * @method insertionSortY
 * @param  {Array} a
 * @return {Array}
 */
SAPBroadphase.insertionSortY = function(a) {
    for(var i=1,l=a.length;i<l;i++) {
        var v = a[i];
        for(var j=i - 1;j>=0;j--) {
            if(a[j].aabb.lowerBound.y <= v.aabb.lowerBound.y){
                break;
            }
            a[j+1] = a[j];
        }
        a[j+1] = v;
    }
    return a;
};

/**
 * @static
 * @method insertionSortZ
 * @param  {Array} a
 * @return {Array}
 */
SAPBroadphase.insertionSortZ = function(a) {
    for(var i=1,l=a.length;i<l;i++) {
        var v = a[i];
        for(var j=i - 1;j>=0;j--) {
            if(a[j].aabb.lowerBound.z <= v.aabb.lowerBound.z){
                break;
            }
            a[j+1] = a[j];
        }
        a[j+1] = v;
    }
    return a;
};

/**
 * Collect all collision pairs
 * @method collisionPairs
 * @param  {World} world
 * @param  {Array} p1
 * @param  {Array} p2
 */
SAPBroadphase.prototype.collisionPairs = function(world,p1,p2){
    var bodies = this.axisList,
        N = bodies.length,
        axisIndex = this.axisIndex,
        i, j;

    if(this.dirty){
        this.sortList();
        this.dirty = false;
    }

    // Look through the list
    for(i=0; i !== N; i++){
        var bi = bodies[i];

        for(j=i+1; j < N; j++){
            var bj = bodies[j];

            if(!this.needBroadphaseCollision(bi,bj)){
                continue;
            }

            if(!SAPBroadphase.checkBounds(bi,bj,axisIndex)){
                break;
            }

            this.intersectionTest(bi,bj,p1,p2);
        }
    }
};

SAPBroadphase.prototype.sortList = function(){
    var axisList = this.axisList;
    var axisIndex = this.axisIndex;
    var N = axisList.length;

    // Update AABBs
    for(var i = 0; i!==N; i++){
        var bi = axisList[i];
        if(bi.aabbNeedsUpdate){
            bi.computeAABB();
        }
    }

    // Sort the list
    if(axisIndex === 0){
        SAPBroadphase.insertionSortX(axisList);
    } else if(axisIndex === 1){
        SAPBroadphase.insertionSortY(axisList);
    } else if(axisIndex === 2){
        SAPBroadphase.insertionSortZ(axisList);
    }
};

/**
 * Check if the bounds of two bodies overlap, along the given SAP axis.
 * @static
 * @method checkBounds
 * @param  {Body} bi
 * @param  {Body} bj
 * @param  {Number} axisIndex
 * @return {Boolean}
 */
SAPBroadphase.checkBounds = function(bi, bj, axisIndex){
    var biPos;
    var bjPos;

    if(axisIndex === 0){
        biPos = bi.position.x;
        bjPos = bj.position.x;
    } else if(axisIndex === 1){
        biPos = bi.position.y;
        bjPos = bj.position.y;
    } else if(axisIndex === 2){
        biPos = bi.position.z;
        bjPos = bj.position.z;
    }

    var ri = bi.boundingRadius,
        rj = bj.boundingRadius,
        boundA1 = biPos - ri,
        boundA2 = biPos + ri,
        boundB1 = bjPos - rj,
        boundB2 = bjPos + rj;

    return boundB1 < boundA2;
};

/**
 * Computes the variance of the body positions and estimates the best
 * axis to use. Will automatically set property .axisIndex.
 * @method autoDetectAxis
 */
SAPBroadphase.prototype.autoDetectAxis = function(){
    var sumX=0,
        sumX2=0,
        sumY=0,
        sumY2=0,
        sumZ=0,
        sumZ2=0,
        bodies = this.axisList,
        N = bodies.length,
        invN=1/N;

    for(var i=0; i!==N; i++){
        var b = bodies[i];

        var centerX = b.position.x;
        sumX += centerX;
        sumX2 += centerX*centerX;

        var centerY = b.position.y;
        sumY += centerY;
        sumY2 += centerY*centerY;

        var centerZ = b.position.z;
        sumZ += centerZ;
        sumZ2 += centerZ*centerZ;
    }

    var varianceX = sumX2 - sumX*sumX*invN,
        varianceY = sumY2 - sumY*sumY*invN,
        varianceZ = sumZ2 - sumZ*sumZ*invN;

    if(varianceX > varianceY){
        if(varianceX > varianceZ){
            this.axisIndex = 0;
        } else{
            this.axisIndex = 2;
        }
    } else if(varianceY > varianceZ){
        this.axisIndex = 1;
    } else{
        this.axisIndex = 2;
    }
};

/**
 * Returns all the bodies within an AABB.
 * @method aabbQuery
 * @param  {World} world
 * @param  {AABB} aabb
 * @param {array} result An array to store resulting bodies in.
 * @return {array}
 */
SAPBroadphase.prototype.aabbQuery = function(world, aabb, result){
    result = result || [];

    if(this.dirty){
        this.sortList();
        this.dirty = false;
    }

    var axisIndex = this.axisIndex, axis = 'x';
    if(axisIndex === 1){ axis = 'y'; }
    if(axisIndex === 2){ axis = 'z'; }

    var axisList = this.axisList;
    var lower = aabb.lowerBound[axis];
    var upper = aabb.upperBound[axis];
    for(var i = 0; i < axisList.length; i++){
        var b = axisList[i];

        if(b.aabbNeedsUpdate){
            b.computeAABB();
        }

        if(b.aabb.overlaps(aabb)){
            result.push(b);
        }
    }

    return result;
};

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = ConeTwistConstraint;

var Constraint = __webpack_require__(44);
var PointToPointConstraint = __webpack_require__(71);
var ConeEquation = __webpack_require__(341);
var RotationalEquation = __webpack_require__(72);
var ContactEquation = __webpack_require__(31);
var Vec3 = __webpack_require__(0);

/**
 * @class ConeTwistConstraint
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {object} [options]
 * @param {Vec3} [options.pivotA]
 * @param {Vec3} [options.pivotB]
 * @param {Vec3} [options.axisA]
 * @param {Vec3} [options.axisB]
 * @param {Number} [options.maxForce=1e6]
 * @extends PointToPointConstraint
 */
function ConeTwistConstraint(bodyA, bodyB, options){
    options = options || {};
    var maxForce = typeof(options.maxForce) !== 'undefined' ? options.maxForce : 1e6;

    // Set pivot point in between
    var pivotA = options.pivotA ? options.pivotA.clone() : new Vec3();
    var pivotB = options.pivotB ? options.pivotB.clone() : new Vec3();
    this.axisA = options.axisA ? options.axisA.clone() : new Vec3();
    this.axisB = options.axisB ? options.axisB.clone() : new Vec3();

    PointToPointConstraint.call(this, bodyA, pivotA, bodyB, pivotB, maxForce);

    this.collideConnected = !!options.collideConnected;

    this.angle = typeof(options.angle) !== 'undefined' ? options.angle : 0;

    /**
     * @property {ConeEquation} coneEquation
     */
    var c = this.coneEquation = new ConeEquation(bodyA,bodyB,options);

    /**
     * @property {RotationalEquation} twistEquation
     */
    var t = this.twistEquation = new RotationalEquation(bodyA,bodyB,options);
    this.twistAngle = typeof(options.twistAngle) !== 'undefined' ? options.twistAngle : 0;

    // Make the cone equation push the bodies toward the cone axis, not outward
    c.maxForce = 0;
    c.minForce = -maxForce;

    // Make the twist equation add torque toward the initial position
    t.maxForce = 0;
    t.minForce = -maxForce;

    this.equations.push(c, t);
}
ConeTwistConstraint.prototype = new PointToPointConstraint();
ConeTwistConstraint.constructor = ConeTwistConstraint;

var ConeTwistConstraint_update_tmpVec1 = new Vec3();
var ConeTwistConstraint_update_tmpVec2 = new Vec3();

ConeTwistConstraint.prototype.update = function(){
    var bodyA = this.bodyA,
        bodyB = this.bodyB,
        cone = this.coneEquation,
        twist = this.twistEquation;

    PointToPointConstraint.prototype.update.call(this);

    // Update the axes to the cone constraint
    bodyA.vectorToWorldFrame(this.axisA, cone.axisA);
    bodyB.vectorToWorldFrame(this.axisB, cone.axisB);

    // Update the world axes in the twist constraint
    this.axisA.tangents(twist.axisA, twist.axisA);
    bodyA.vectorToWorldFrame(twist.axisA, twist.axisA);

    this.axisB.tangents(twist.axisB, twist.axisB);
    bodyB.vectorToWorldFrame(twist.axisB, twist.axisB);

    cone.angle = this.angle;
    twist.maxAngle = this.twistAngle;
};



/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = DistanceConstraint;

var Constraint = __webpack_require__(44);
var ContactEquation = __webpack_require__(31);

/**
 * Constrains two bodies to be at a constant distance from each others center of mass.
 * @class DistanceConstraint
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Number} [distance] The distance to keep. If undefined, it will be set to the current distance between bodyA and bodyB
 * @param {Number} [maxForce=1e6]
 * @extends Constraint
 */
function DistanceConstraint(bodyA,bodyB,distance,maxForce){
    Constraint.call(this,bodyA,bodyB);

    if(typeof(distance)==="undefined") {
        distance = bodyA.position.distanceTo(bodyB.position);
    }

    if(typeof(maxForce)==="undefined") {
        maxForce = 1e6;
    }

    /**
     * @property {number} distance
     */
    this.distance = distance;

    /**
     * @property {ContactEquation} distanceEquation
     */
    var eq = this.distanceEquation = new ContactEquation(bodyA, bodyB);
    this.equations.push(eq);

    // Make it bidirectional
    eq.minForce = -maxForce;
    eq.maxForce =  maxForce;
}
DistanceConstraint.prototype = new Constraint();

DistanceConstraint.prototype.update = function(){
    var bodyA = this.bodyA;
    var bodyB = this.bodyB;
    var eq = this.distanceEquation;
    var halfDist = this.distance * 0.5;
    var normal = eq.ni;

    bodyB.position.vsub(bodyA.position, normal);
    normal.normalize();
    normal.mult(halfDist, eq.ri);
    normal.mult(-halfDist, eq.rj);
};

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = LockConstraint;

var Constraint = __webpack_require__(44);
var PointToPointConstraint = __webpack_require__(71);
var RotationalEquation = __webpack_require__(72);
var RotationalMotorEquation = __webpack_require__(100);
var ContactEquation = __webpack_require__(31);
var Vec3 = __webpack_require__(0);

/**
 * Lock constraint. Will remove all degrees of freedom between the bodies.
 * @class LockConstraint
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {object} [options]
 * @param {Number} [options.maxForce=1e6]
 * @extends PointToPointConstraint
 */
function LockConstraint(bodyA, bodyB, options){
    options = options || {};
    var maxForce = typeof(options.maxForce) !== 'undefined' ? options.maxForce : 1e6;

    // Set pivot point in between
    var pivotA = new Vec3();
    var pivotB = new Vec3();
    var halfWay = new Vec3();
    bodyA.position.vadd(bodyB.position, halfWay);
    halfWay.scale(0.5, halfWay);
    bodyB.pointToLocalFrame(halfWay, pivotB);
    bodyA.pointToLocalFrame(halfWay, pivotA);

    // The point-to-point constraint will keep a point shared between the bodies
    PointToPointConstraint.call(this, bodyA, pivotA, bodyB, pivotB, maxForce);

    // Store initial rotation of the bodies as unit vectors in the local body spaces
    this.xA = bodyA.vectorToLocalFrame(Vec3.UNIT_X);
    this.xB = bodyB.vectorToLocalFrame(Vec3.UNIT_X);
    this.yA = bodyA.vectorToLocalFrame(Vec3.UNIT_Y);
    this.yB = bodyB.vectorToLocalFrame(Vec3.UNIT_Y);
    this.zA = bodyA.vectorToLocalFrame(Vec3.UNIT_Z);
    this.zB = bodyB.vectorToLocalFrame(Vec3.UNIT_Z);

    // ...and the following rotational equations will keep all rotational DOF's in place

    /**
     * @property {RotationalEquation} rotationalEquation1
     */
    var r1 = this.rotationalEquation1 = new RotationalEquation(bodyA,bodyB,options);

    /**
     * @property {RotationalEquation} rotationalEquation2
     */
    var r2 = this.rotationalEquation2 = new RotationalEquation(bodyA,bodyB,options);

    /**
     * @property {RotationalEquation} rotationalEquation3
     */
    var r3 = this.rotationalEquation3 = new RotationalEquation(bodyA,bodyB,options);

    this.equations.push(r1, r2, r3);
}
LockConstraint.prototype = new PointToPointConstraint();
LockConstraint.constructor = LockConstraint;

var LockConstraint_update_tmpVec1 = new Vec3();
var LockConstraint_update_tmpVec2 = new Vec3();

LockConstraint.prototype.update = function(){
    var bodyA = this.bodyA,
        bodyB = this.bodyB,
        motor = this.motorEquation,
        r1 = this.rotationalEquation1,
        r2 = this.rotationalEquation2,
        r3 = this.rotationalEquation3,
        worldAxisA = LockConstraint_update_tmpVec1,
        worldAxisB = LockConstraint_update_tmpVec2;

    PointToPointConstraint.prototype.update.call(this);

    // These vector pairs must be orthogonal
    bodyA.vectorToWorldFrame(this.xA, r1.axisA);
    bodyB.vectorToWorldFrame(this.yB, r1.axisB);

    bodyA.vectorToWorldFrame(this.yA, r2.axisA);
    bodyB.vectorToWorldFrame(this.zB, r2.axisB);

    bodyA.vectorToWorldFrame(this.zA, r3.axisA);
    bodyB.vectorToWorldFrame(this.xB, r3.axisB);
};



/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = ConeEquation;

var Vec3 = __webpack_require__(0);
var Mat3 = __webpack_require__(32);
var Equation = __webpack_require__(45);

/**
 * Cone equation. Works to keep the given body world vectors aligned, or tilted within a given angle from each other.
 * @class ConeEquation
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Vec3} [options.axisA] Local axis in A
 * @param {Vec3} [options.axisB] Local axis in B
 * @param {Vec3} [options.angle] The "cone angle" to keep
 * @param {number} [options.maxForce=1e6]
 * @extends Equation
 */
function ConeEquation(bodyA, bodyB, options){
    options = options || {};
    var maxForce = typeof(options.maxForce) !== 'undefined' ? options.maxForce : 1e6;

    Equation.call(this,bodyA,bodyB,-maxForce, maxForce);

    this.axisA = options.axisA ? options.axisA.clone() : new Vec3(1, 0, 0);
    this.axisB = options.axisB ? options.axisB.clone() : new Vec3(0, 1, 0);

    /**
     * The cone angle to keep
     * @property {number} angle
     */
    this.angle = typeof(options.angle) !== 'undefined' ? options.angle : 0;
}

ConeEquation.prototype = new Equation();
ConeEquation.prototype.constructor = ConeEquation;

var tmpVec1 = new Vec3();
var tmpVec2 = new Vec3();

ConeEquation.prototype.computeB = function(h){
    var a = this.a,
        b = this.b,

        ni = this.axisA,
        nj = this.axisB,

        nixnj = tmpVec1,
        njxni = tmpVec2,

        GA = this.jacobianElementA,
        GB = this.jacobianElementB;

    // Caluclate cross products
    ni.cross(nj, nixnj);
    nj.cross(ni, njxni);

    // The angle between two vector is:
    // cos(theta) = a * b / (length(a) * length(b) = { len(a) = len(b) = 1 } = a * b

    // g = a * b
    // gdot = (b x a) * wi + (a x b) * wj
    // G = [0 bxa 0 axb]
    // W = [vi wi vj wj]
    GA.rotational.copy(njxni);
    GB.rotational.copy(nixnj);

    var g = Math.cos(this.angle) - ni.dot(nj),
        GW = this.computeGW(),
        GiMf = this.computeGiMf();

    var B = - g * a - GW * b - h * GiMf;

    return B;
};



/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = JacobianElement;

var Vec3 = __webpack_require__(0);

/**
 * An element containing 6 entries, 3 spatial and 3 rotational degrees of freedom.
 * @class JacobianElement
 * @constructor
 */
function JacobianElement(){

    /**
     * @property {Vec3} spatial
     */
    this.spatial = new Vec3();

    /**
     * @property {Vec3} rotational
     */
    this.rotational = new Vec3();
}

/**
 * Multiply with other JacobianElement
 * @method multiplyElement
 * @param  {JacobianElement} element
 * @return {Number}
 */
JacobianElement.prototype.multiplyElement = function(element){
    return element.spatial.dot(this.spatial) + element.rotational.dot(this.rotational);
};

/**
 * Multiply with two vectors
 * @method multiplyVectors
 * @param  {Vec3} spatial
 * @param  {Vec3} rotational
 * @return {Number}
 */
JacobianElement.prototype.multiplyVectors = function(spatial,rotational){
    return spatial.dot(this.spatial) + rotational.dot(this.rotational);
};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var Body = __webpack_require__(33);
var Vec3 = __webpack_require__(0);
var Quaternion = __webpack_require__(13);
var RaycastResult = __webpack_require__(58);
var Ray = __webpack_require__(70);
var WheelInfo = __webpack_require__(347);

module.exports = RaycastVehicle;

/**
 * Vehicle helper class that casts rays from the wheel positions towards the ground and applies forces.
 * @class RaycastVehicle
 * @constructor
 * @param {object} [options]
 * @param {Body} [options.chassisBody] The car chassis body.
 * @param {integer} [options.indexRightAxis] Axis to use for right. x=0, y=1, z=2
 * @param {integer} [options.indexLeftAxis]
 * @param {integer} [options.indexUpAxis]
 */
function RaycastVehicle(options){

    /**
     * @property {Body} chassisBody
     */
    this.chassisBody = options.chassisBody;

    /**
     * An array of WheelInfo objects.
     * @property {array} wheelInfos
     */
    this.wheelInfos = [];

    /**
     * Will be set to true if the car is sliding.
     * @property {boolean} sliding
     */
    this.sliding = false;

    /**
     * @property {World} world
     */
    this.world = null;

    /**
     * Index of the right axis, 0=x, 1=y, 2=z
     * @property {integer} indexRightAxis
     * @default 1
     */
    this.indexRightAxis = typeof(options.indexRightAxis) !== 'undefined' ? options.indexRightAxis : 1;

    /**
     * Index of the forward axis, 0=x, 1=y, 2=z
     * @property {integer} indexForwardAxis
     * @default 0
     */
    this.indexForwardAxis = typeof(options.indexForwardAxis) !== 'undefined' ? options.indexForwardAxis : 0;

    /**
     * Index of the up axis, 0=x, 1=y, 2=z
     * @property {integer} indexUpAxis
     * @default 2
     */
    this.indexUpAxis = typeof(options.indexUpAxis) !== 'undefined' ? options.indexUpAxis : 2;
}

var tmpVec1 = new Vec3();
var tmpVec2 = new Vec3();
var tmpVec3 = new Vec3();
var tmpVec4 = new Vec3();
var tmpVec5 = new Vec3();
var tmpVec6 = new Vec3();
var tmpRay = new Ray();

/**
 * Add a wheel. For information about the options, see WheelInfo.
 * @method addWheel
 * @param {object} [options]
 */
RaycastVehicle.prototype.addWheel = function(options){
    options = options || {};

    var info = new WheelInfo(options);
    var index = this.wheelInfos.length;
    this.wheelInfos.push(info);

    return index;
};

/**
 * Set the steering value of a wheel.
 * @method setSteeringValue
 * @param {number} value
 * @param {integer} wheelIndex
 */
RaycastVehicle.prototype.setSteeringValue = function(value, wheelIndex){
    var wheel = this.wheelInfos[wheelIndex];
    wheel.steering = value;
};

var torque = new Vec3();

/**
 * Set the wheel force to apply on one of the wheels each time step
 * @method applyEngineForce
 * @param  {number} value
 * @param  {integer} wheelIndex
 */
RaycastVehicle.prototype.applyEngineForce = function(value, wheelIndex){
    this.wheelInfos[wheelIndex].engineForce = value;
};

/**
 * Set the braking force of a wheel
 * @method setBrake
 * @param {number} brake
 * @param {integer} wheelIndex
 */
RaycastVehicle.prototype.setBrake = function(brake, wheelIndex){
    this.wheelInfos[wheelIndex].brake = brake;
};

/**
 * Add the vehicle including its constraints to the world.
 * @method addToWorld
 * @param {World} world
 */
RaycastVehicle.prototype.addToWorld = function(world){
    var constraints = this.constraints;
    world.addBody(this.chassisBody);
    var that = this;
    this.preStepCallback = function(){
        that.updateVehicle(world.dt);
    };
    world.addEventListener('preStep', this.preStepCallback);
    this.world = world;
};

/**
 * Get one of the wheel axles, world-oriented.
 * @private
 * @method getVehicleAxisWorld
 * @param  {integer} axisIndex
 * @param  {Vec3} result
 */
RaycastVehicle.prototype.getVehicleAxisWorld = function(axisIndex, result){
    result.set(
        axisIndex === 0 ? 1 : 0,
        axisIndex === 1 ? 1 : 0,
        axisIndex === 2 ? 1 : 0
    );
    this.chassisBody.vectorToWorldFrame(result, result);
};

RaycastVehicle.prototype.updateVehicle = function(timeStep){
    var wheelInfos = this.wheelInfos;
    var numWheels = wheelInfos.length;
    var chassisBody = this.chassisBody;

    for (var i = 0; i < numWheels; i++) {
        this.updateWheelTransform(i);
    }

    this.currentVehicleSpeedKmHour = 3.6 * chassisBody.velocity.norm();

    var forwardWorld = new Vec3();
    this.getVehicleAxisWorld(this.indexForwardAxis, forwardWorld);

    if (forwardWorld.dot(chassisBody.velocity) < 0){
        this.currentVehicleSpeedKmHour *= -1;
    }

    // simulate suspension
    for (var i = 0; i < numWheels; i++) {
        this.castRay(wheelInfos[i]);
    }

    this.updateSuspension(timeStep);

    var impulse = new Vec3();
    var relpos = new Vec3();
    for (var i = 0; i < numWheels; i++) {
        //apply suspension force
        var wheel = wheelInfos[i];
        var suspensionForce = wheel.suspensionForce;
        if (suspensionForce > wheel.maxSuspensionForce) {
            suspensionForce = wheel.maxSuspensionForce;
        }
        wheel.raycastResult.hitNormalWorld.scale(suspensionForce * timeStep, impulse);

        wheel.raycastResult.hitPointWorld.vsub(chassisBody.position, relpos);
        chassisBody.applyImpulse(impulse, relpos);
    }

    this.updateFriction(timeStep);

    var hitNormalWorldScaledWithProj = new Vec3();
    var fwd  = new Vec3();
    var vel = new Vec3();
    for (i = 0; i < numWheels; i++) {
        var wheel = wheelInfos[i];
        //var relpos = new Vec3();
        //wheel.chassisConnectionPointWorld.vsub(chassisBody.position, relpos);
        chassisBody.getVelocityAtWorldPoint(wheel.chassisConnectionPointWorld, vel);

        // Hack to get the rotation in the correct direction
        var m = 1;
        switch(this.indexUpAxis){
        case 1:
            m = -1;
            break;
        }

        if (wheel.isInContact) {

            this.getVehicleAxisWorld(this.indexForwardAxis, fwd);
            var proj = fwd.dot(wheel.raycastResult.hitNormalWorld);
            wheel.raycastResult.hitNormalWorld.scale(proj, hitNormalWorldScaledWithProj);

            fwd.vsub(hitNormalWorldScaledWithProj, fwd);

            var proj2 = fwd.dot(vel);
            wheel.deltaRotation = m * proj2 * timeStep / wheel.radius;
        }

        if((wheel.sliding || !wheel.isInContact) && wheel.engineForce !== 0 && wheel.useCustomSlidingRotationalSpeed){
            // Apply custom rotation when accelerating and sliding
            wheel.deltaRotation = (wheel.engineForce > 0 ? 1 : -1) * wheel.customSlidingRotationalSpeed * timeStep;
        }

        // Lock wheels
        if(Math.abs(wheel.brake) > Math.abs(wheel.engineForce)){
            wheel.deltaRotation = 0;
        }

        wheel.rotation += wheel.deltaRotation; // Use the old value
        wheel.deltaRotation *= 0.99; // damping of rotation when not in contact
    }
};

RaycastVehicle.prototype.updateSuspension = function(deltaTime) {
    var chassisBody = this.chassisBody;
    var chassisMass = chassisBody.mass;
    var wheelInfos = this.wheelInfos;
    var numWheels = wheelInfos.length;

    for (var w_it = 0; w_it < numWheels; w_it++){
        var wheel = wheelInfos[w_it];

        if (wheel.isInContact){
            var force;

            // Spring
            var susp_length = wheel.suspensionRestLength;
            var current_length = wheel.suspensionLength;
            var length_diff = (susp_length - current_length);

            force = wheel.suspensionStiffness * length_diff * wheel.clippedInvContactDotSuspension;

            // Damper
            var projected_rel_vel = wheel.suspensionRelativeVelocity;
            var susp_damping;
            if (projected_rel_vel < 0) {
                susp_damping = wheel.dampingCompression;
            } else {
                susp_damping = wheel.dampingRelaxation;
            }
            force -= susp_damping * projected_rel_vel;

            wheel.suspensionForce = force * chassisMass;
            if (wheel.suspensionForce < 0) {
                wheel.suspensionForce = 0;
            }
        } else {
            wheel.suspensionForce = 0;
        }
    }
};

/**
 * Remove the vehicle including its constraints from the world.
 * @method removeFromWorld
 * @param {World} world
 */
RaycastVehicle.prototype.removeFromWorld = function(world){
    var constraints = this.constraints;
    world.remove(this.chassisBody);
    world.removeEventListener('preStep', this.preStepCallback);
    this.world = null;
};

var castRay_rayvector = new Vec3();
var castRay_target = new Vec3();
RaycastVehicle.prototype.castRay = function(wheel) {
    var rayvector = castRay_rayvector;
    var target = castRay_target;

    this.updateWheelTransformWorld(wheel);
    var chassisBody = this.chassisBody;

    var depth = -1;

    var raylen = wheel.suspensionRestLength + wheel.radius;

    wheel.directionWorld.scale(raylen, rayvector);
    var source = wheel.chassisConnectionPointWorld;
    source.vadd(rayvector, target);
    var raycastResult = wheel.raycastResult;

    var param = 0;

    raycastResult.reset();
    // Turn off ray collision with the chassis temporarily
    var oldState = chassisBody.collisionResponse;
    chassisBody.collisionResponse = false;

    // Cast ray against world
    this.world.rayTest(source, target, raycastResult);
    chassisBody.collisionResponse = oldState;

    var object = raycastResult.body;

    wheel.raycastResult.groundObject = 0;

    if (object) {
        depth = raycastResult.distance;
        wheel.raycastResult.hitNormalWorld  = raycastResult.hitNormalWorld;
        wheel.isInContact = true;

        var hitDistance = raycastResult.distance;
        wheel.suspensionLength = hitDistance - wheel.radius;

        // clamp on max suspension travel
        var minSuspensionLength = wheel.suspensionRestLength - wheel.maxSuspensionTravel;
        var maxSuspensionLength = wheel.suspensionRestLength + wheel.maxSuspensionTravel;
        if (wheel.suspensionLength < minSuspensionLength) {
            wheel.suspensionLength = minSuspensionLength;
        }
        if (wheel.suspensionLength > maxSuspensionLength) {
            wheel.suspensionLength = maxSuspensionLength;
            wheel.raycastResult.reset();
        }

        var denominator = wheel.raycastResult.hitNormalWorld.dot(wheel.directionWorld);

        var chassis_velocity_at_contactPoint = new Vec3();
        chassisBody.getVelocityAtWorldPoint(wheel.raycastResult.hitPointWorld, chassis_velocity_at_contactPoint);

        var projVel = wheel.raycastResult.hitNormalWorld.dot( chassis_velocity_at_contactPoint );

        if (denominator >= -0.1) {
            wheel.suspensionRelativeVelocity = 0;
            wheel.clippedInvContactDotSuspension = 1 / 0.1;
        } else {
            var inv = -1 / denominator;
            wheel.suspensionRelativeVelocity = projVel * inv;
            wheel.clippedInvContactDotSuspension = inv;
        }

    } else {

        //put wheel info as in rest position
        wheel.suspensionLength = wheel.suspensionRestLength + 0 * wheel.maxSuspensionTravel;
        wheel.suspensionRelativeVelocity = 0.0;
        wheel.directionWorld.scale(-1, wheel.raycastResult.hitNormalWorld);
        wheel.clippedInvContactDotSuspension = 1.0;
    }

    return depth;
};

RaycastVehicle.prototype.updateWheelTransformWorld = function(wheel){
    wheel.isInContact = false;
    var chassisBody = this.chassisBody;
    chassisBody.pointToWorldFrame(wheel.chassisConnectionPointLocal, wheel.chassisConnectionPointWorld);
    chassisBody.vectorToWorldFrame(wheel.directionLocal, wheel.directionWorld);
    chassisBody.vectorToWorldFrame(wheel.axleLocal, wheel.axleWorld);
};


/**
 * Update one of the wheel transform.
 * Note when rendering wheels: during each step, wheel transforms are updated BEFORE the chassis; ie. their position becomes invalid after the step. Thus when you render wheels, you must update wheel transforms before rendering them. See raycastVehicle demo for an example.
 * @method updateWheelTransform
 * @param {integer} wheelIndex The wheel index to update.
 */
RaycastVehicle.prototype.updateWheelTransform = function(wheelIndex){
    var up = tmpVec4;
    var right = tmpVec5;
    var fwd = tmpVec6;

    var wheel = this.wheelInfos[wheelIndex];
    this.updateWheelTransformWorld(wheel);

    wheel.directionLocal.scale(-1, up);
    right.copy(wheel.axleLocal);
    up.cross(right, fwd);
    fwd.normalize();
    right.normalize();

    // Rotate around steering over the wheelAxle
    var steering = wheel.steering;
    var steeringOrn = new Quaternion();
    steeringOrn.setFromAxisAngle(up, steering);

    var rotatingOrn = new Quaternion();
    rotatingOrn.setFromAxisAngle(right, wheel.rotation);

    // World rotation of the wheel
    var q = wheel.worldTransform.quaternion;
    this.chassisBody.quaternion.mult(steeringOrn, q);
    q.mult(rotatingOrn, q);

    q.normalize();

    // world position of the wheel
    var p = wheel.worldTransform.position;
    p.copy(wheel.directionWorld);
    p.scale(wheel.suspensionLength, p);
    p.vadd(wheel.chassisConnectionPointWorld, p);
};

var directions = [
    new Vec3(1, 0, 0),
    new Vec3(0, 1, 0),
    new Vec3(0, 0, 1)
];

/**
 * Get the world transform of one of the wheels
 * @method getWheelTransformWorld
 * @param  {integer} wheelIndex
 * @return {Transform}
 */
RaycastVehicle.prototype.getWheelTransformWorld = function(wheelIndex) {
    return this.wheelInfos[wheelIndex].worldTransform;
};


var updateFriction_surfNormalWS_scaled_proj = new Vec3();
var updateFriction_axle = [];
var updateFriction_forwardWS = [];
var sideFrictionStiffness2 = 1;
RaycastVehicle.prototype.updateFriction = function(timeStep) {
    var surfNormalWS_scaled_proj = updateFriction_surfNormalWS_scaled_proj;

    //calculate the impulse, so that the wheels don't move sidewards
    var wheelInfos = this.wheelInfos;
    var numWheels = wheelInfos.length;
    var chassisBody = this.chassisBody;
    var forwardWS = updateFriction_forwardWS;
    var axle = updateFriction_axle;

    var numWheelsOnGround = 0;

    for (var i = 0; i < numWheels; i++) {
        var wheel = wheelInfos[i];

        var groundObject = wheel.raycastResult.body;
        if (groundObject){
            numWheelsOnGround++;
        }

        wheel.sideImpulse = 0;
        wheel.forwardImpulse = 0;
        if(!forwardWS[i]){
            forwardWS[i] = new Vec3();
        }
        if(!axle[i]){
            axle[i] = new Vec3();
        }
    }

    for (var i = 0; i < numWheels; i++){
        var wheel = wheelInfos[i];

        var groundObject = wheel.raycastResult.body;

        if (groundObject) {
            var axlei = axle[i];
            var wheelTrans = this.getWheelTransformWorld(i);

            // Get world axle
            wheelTrans.vectorToWorldFrame(directions[this.indexRightAxis], axlei);

            var surfNormalWS = wheel.raycastResult.hitNormalWorld;
            var proj = axlei.dot(surfNormalWS);
            surfNormalWS.scale(proj, surfNormalWS_scaled_proj);
            axlei.vsub(surfNormalWS_scaled_proj, axlei);
            axlei.normalize();

            surfNormalWS.cross(axlei, forwardWS[i]);
            forwardWS[i].normalize();

            wheel.sideImpulse = resolveSingleBilateral(
                chassisBody,
                wheel.raycastResult.hitPointWorld,
                groundObject,
                wheel.raycastResult.hitPointWorld,
                axlei
            );

            wheel.sideImpulse *= sideFrictionStiffness2;
        }
    }

    var sideFactor = 1;
    var fwdFactor = 0.5;

    this.sliding = false;
    for (var i = 0; i < numWheels; i++) {
        var wheel = wheelInfos[i];
        var groundObject = wheel.raycastResult.body;

        var rollingFriction = 0;

        wheel.slipInfo = 1;
        if (groundObject) {
            var defaultRollingFrictionImpulse = 0;
            var maxImpulse = wheel.brake ? wheel.brake : defaultRollingFrictionImpulse;

            // btWheelContactPoint contactPt(chassisBody,groundObject,wheelInfraycastInfo.hitPointWorld,forwardWS[wheel],maxImpulse);
            // rollingFriction = calcRollingFriction(contactPt);
            rollingFriction = calcRollingFriction(chassisBody, groundObject, wheel.raycastResult.hitPointWorld, forwardWS[i], maxImpulse);

            rollingFriction += wheel.engineForce * timeStep;

            // rollingFriction = 0;
            var factor = maxImpulse / rollingFriction;
            wheel.slipInfo *= factor;
        }

        //switch between active rolling (throttle), braking and non-active rolling friction (nthrottle/break)

        wheel.forwardImpulse = 0;
        wheel.skidInfo = 1;

        if (groundObject) {
            wheel.skidInfo = 1;

            var maximp = wheel.suspensionForce * timeStep * wheel.frictionSlip;
            var maximpSide = maximp;

            var maximpSquared = maximp * maximpSide;

            wheel.forwardImpulse = rollingFriction;//wheelInfo.engineForce* timeStep;

            var x = wheel.forwardImpulse * fwdFactor;
            var y = wheel.sideImpulse * sideFactor;

            var impulseSquared = x * x + y * y;

            wheel.sliding = false;
            if (impulseSquared > maximpSquared) {
                this.sliding = true;
                wheel.sliding = true;

                var factor = maximp / Math.sqrt(impulseSquared);

                wheel.skidInfo *= factor;
            }
        }
    }

    if (this.sliding) {
        for (var i = 0; i < numWheels; i++) {
            var wheel = wheelInfos[i];
            if (wheel.sideImpulse !== 0) {
                if (wheel.skidInfo < 1){
                    wheel.forwardImpulse *= wheel.skidInfo;
                    wheel.sideImpulse *= wheel.skidInfo;
                }
            }
        }
    }

    // apply the impulses
    for (var i = 0; i < numWheels; i++) {
        var wheel = wheelInfos[i];

        var rel_pos = new Vec3();
        wheel.raycastResult.hitPointWorld.vsub(chassisBody.position, rel_pos);
        // cannons applyimpulse is using world coord for the position
        //rel_pos.copy(wheel.raycastResult.hitPointWorld);

        if (wheel.forwardImpulse !== 0) {
            var impulse = new Vec3();
            forwardWS[i].scale(wheel.forwardImpulse, impulse);
            chassisBody.applyImpulse(impulse, rel_pos);
        }

        if (wheel.sideImpulse !== 0){
            var groundObject = wheel.raycastResult.body;

            var rel_pos2 = new Vec3();
            wheel.raycastResult.hitPointWorld.vsub(groundObject.position, rel_pos2);
            //rel_pos2.copy(wheel.raycastResult.hitPointWorld);
            var sideImp = new Vec3();
            axle[i].scale(wheel.sideImpulse, sideImp);

            // Scale the relative position in the up direction with rollInfluence.
            // If rollInfluence is 1, the impulse will be applied on the hitPoint (easy to roll over), if it is zero it will be applied in the same plane as the center of mass (not easy to roll over).
            chassisBody.vectorToLocalFrame(rel_pos, rel_pos);
            rel_pos['xyz'[this.indexUpAxis]] *= wheel.rollInfluence;
            chassisBody.vectorToWorldFrame(rel_pos, rel_pos);
            chassisBody.applyImpulse(sideImp, rel_pos);

            //apply friction impulse on the ground
            sideImp.scale(-1, sideImp);
            groundObject.applyImpulse(sideImp, rel_pos2);
        }
    }
};

var calcRollingFriction_vel1 = new Vec3();
var calcRollingFriction_vel2 = new Vec3();
var calcRollingFriction_vel = new Vec3();

function calcRollingFriction(body0, body1, frictionPosWorld, frictionDirectionWorld, maxImpulse) {
    var j1 = 0;
    var contactPosWorld = frictionPosWorld;

    // var rel_pos1 = new Vec3();
    // var rel_pos2 = new Vec3();
    var vel1 = calcRollingFriction_vel1;
    var vel2 = calcRollingFriction_vel2;
    var vel = calcRollingFriction_vel;
    // contactPosWorld.vsub(body0.position, rel_pos1);
    // contactPosWorld.vsub(body1.position, rel_pos2);

    body0.getVelocityAtWorldPoint(contactPosWorld, vel1);
    body1.getVelocityAtWorldPoint(contactPosWorld, vel2);
    vel1.vsub(vel2, vel);

    var vrel = frictionDirectionWorld.dot(vel);

    var denom0 = computeImpulseDenominator(body0, frictionPosWorld, frictionDirectionWorld);
    var denom1 = computeImpulseDenominator(body1, frictionPosWorld, frictionDirectionWorld);
    var relaxation = 1;
    var jacDiagABInv = relaxation / (denom0 + denom1);

    // calculate j that moves us to zero relative velocity
    j1 = -vrel * jacDiagABInv;

    if (maxImpulse < j1) {
        j1 = maxImpulse;
    }
    if (j1 < -maxImpulse) {
        j1 = -maxImpulse;
    }

    return j1;
}

var computeImpulseDenominator_r0 = new Vec3();
var computeImpulseDenominator_c0 = new Vec3();
var computeImpulseDenominator_vec = new Vec3();
var computeImpulseDenominator_m = new Vec3();
function computeImpulseDenominator(body, pos, normal) {
    var r0 = computeImpulseDenominator_r0;
    var c0 = computeImpulseDenominator_c0;
    var vec = computeImpulseDenominator_vec;
    var m = computeImpulseDenominator_m;

    pos.vsub(body.position, r0);
    r0.cross(normal, c0);
    body.invInertiaWorld.vmult(c0, m);
    m.cross(r0, vec);

    return body.invMass + normal.dot(vec);
}


var resolveSingleBilateral_vel1 = new Vec3();
var resolveSingleBilateral_vel2 = new Vec3();
var resolveSingleBilateral_vel = new Vec3();

//bilateral constraint between two dynamic objects
function resolveSingleBilateral(body1, pos1, body2, pos2, normal, impulse){
    var normalLenSqr = normal.norm2();
    if (normalLenSqr > 1.1){
        return 0; // no impulse
    }
    // var rel_pos1 = new Vec3();
    // var rel_pos2 = new Vec3();
    // pos1.vsub(body1.position, rel_pos1);
    // pos2.vsub(body2.position, rel_pos2);

    var vel1 = resolveSingleBilateral_vel1;
    var vel2 = resolveSingleBilateral_vel2;
    var vel = resolveSingleBilateral_vel;
    body1.getVelocityAtWorldPoint(pos1, vel1);
    body2.getVelocityAtWorldPoint(pos2, vel2);

    vel1.vsub(vel2, vel);

    var rel_vel = normal.dot(vel);

    var contactDamping = 0.2;
    var massTerm = 1 / (body1.invMass + body2.invMass);
    var impulse = - contactDamping * rel_vel * massTerm;

    return impulse;
}

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var Body = __webpack_require__(33);
var Sphere = __webpack_require__(148);
var Box = __webpack_require__(73);
var Vec3 = __webpack_require__(0);
var HingeConstraint = __webpack_require__(144);

module.exports = RigidVehicle;

/**
 * Simple vehicle helper class with spherical rigid body wheels.
 * @class RigidVehicle
 * @constructor
 * @param {Body} [options.chassisBody]
 */
function RigidVehicle(options){
    this.wheelBodies = [];

    /**
     * @property coordinateSystem
     * @type {Vec3}
     */
    this.coordinateSystem = typeof(options.coordinateSystem)==='undefined' ? new Vec3(1, 2, 3) : options.coordinateSystem.clone();

    /**
     * @property {Body} chassisBody
     */
    this.chassisBody = options.chassisBody;

    if(!this.chassisBody){
        // No chassis body given. Create it!
        var chassisShape = new Box(new Vec3(5, 2, 0.5));
        this.chassisBody = new Body(1, chassisShape);
    }

    /**
     * @property constraints
     * @type {Array}
     */
    this.constraints = [];

    this.wheelAxes = [];
    this.wheelForces = [];
}

/**
 * Add a wheel
 * @method addWheel
 * @param {object} options
 * @param {boolean} [options.isFrontWheel]
 * @param {Vec3} [options.position] Position of the wheel, locally in the chassis body.
 * @param {Vec3} [options.direction] Slide direction of the wheel along the suspension.
 * @param {Vec3} [options.axis] Axis of rotation of the wheel, locally defined in the chassis.
 * @param {Body} [options.body] The wheel body.
 */
RigidVehicle.prototype.addWheel = function(options){
    options = options || {};
    var wheelBody = options.body;
    if(!wheelBody){
        wheelBody =  new Body(1, new Sphere(1.2));
    }
    this.wheelBodies.push(wheelBody);
    this.wheelForces.push(0);

    // Position constrain wheels
    var zero = new Vec3();
    var position = typeof(options.position) !== 'undefined' ? options.position.clone() : new Vec3();

    // Set position locally to the chassis
    var worldPosition = new Vec3();
    this.chassisBody.pointToWorldFrame(position, worldPosition);
    wheelBody.position.set(worldPosition.x, worldPosition.y, worldPosition.z);

    // Constrain wheel
    var axis = typeof(options.axis) !== 'undefined' ? options.axis.clone() : new Vec3(0, 1, 0);
    this.wheelAxes.push(axis);

    var hingeConstraint = new HingeConstraint(this.chassisBody, wheelBody, {
        pivotA: position,
        axisA: axis,
        pivotB: Vec3.ZERO,
        axisB: axis,
        collideConnected: false
    });
    this.constraints.push(hingeConstraint);

    return this.wheelBodies.length - 1;
};

/**
 * Set the steering value of a wheel.
 * @method setSteeringValue
 * @param {number} value
 * @param {integer} wheelIndex
 * @todo check coordinateSystem
 */
RigidVehicle.prototype.setSteeringValue = function(value, wheelIndex){
    // Set angle of the hinge axis
    var axis = this.wheelAxes[wheelIndex];

    var c = Math.cos(value),
        s = Math.sin(value),
        x = axis.x,
        y = axis.y;
    this.constraints[wheelIndex].axisA.set(
        c*x -s*y,
        s*x +c*y,
        0
    );
};

/**
 * Set the target rotational speed of the hinge constraint.
 * @method setMotorSpeed
 * @param {number} value
 * @param {integer} wheelIndex
 */
RigidVehicle.prototype.setMotorSpeed = function(value, wheelIndex){
    var hingeConstraint = this.constraints[wheelIndex];
    hingeConstraint.enableMotor();
    hingeConstraint.motorTargetVelocity = value;
};

/**
 * Set the target rotational speed of the hinge constraint.
 * @method disableMotor
 * @param {number} value
 * @param {integer} wheelIndex
 */
RigidVehicle.prototype.disableMotor = function(wheelIndex){
    var hingeConstraint = this.constraints[wheelIndex];
    hingeConstraint.disableMotor();
};

var torque = new Vec3();

/**
 * Set the wheel force to apply on one of the wheels each time step
 * @method setWheelForce
 * @param  {number} value
 * @param  {integer} wheelIndex
 */
RigidVehicle.prototype.setWheelForce = function(value, wheelIndex){
    this.wheelForces[wheelIndex] = value;
};

/**
 * Apply a torque on one of the wheels.
 * @method applyWheelForce
 * @param  {number} value
 * @param  {integer} wheelIndex
 */
RigidVehicle.prototype.applyWheelForce = function(value, wheelIndex){
    var axis = this.wheelAxes[wheelIndex];
    var wheelBody = this.wheelBodies[wheelIndex];
    var bodyTorque = wheelBody.torque;

    axis.scale(value, torque);
    wheelBody.vectorToWorldFrame(torque, torque);
    bodyTorque.vadd(torque, bodyTorque);
};

/**
 * Add the vehicle including its constraints to the world.
 * @method addToWorld
 * @param {World} world
 */
RigidVehicle.prototype.addToWorld = function(world){
    var constraints = this.constraints;
    var bodies = this.wheelBodies.concat([this.chassisBody]);

    for (var i = 0; i < bodies.length; i++) {
        world.addBody(bodies[i]);
    }

    for (var i = 0; i < constraints.length; i++) {
        world.addConstraint(constraints[i]);
    }

    world.addEventListener('preStep', this._update.bind(this));
};

RigidVehicle.prototype._update = function(){
    var wheelForces = this.wheelForces;
    for (var i = 0; i < wheelForces.length; i++) {
        this.applyWheelForce(wheelForces[i], i);
    }
};

/**
 * Remove the vehicle including its constraints from the world.
 * @method removeFromWorld
 * @param {World} world
 */
RigidVehicle.prototype.removeFromWorld = function(world){
    var constraints = this.constraints;
    var bodies = this.wheelBodies.concat([this.chassisBody]);

    for (var i = 0; i < bodies.length; i++) {
        world.remove(bodies[i]);
    }

    for (var i = 0; i < constraints.length; i++) {
        world.removeConstraint(constraints[i]);
    }
};

var worldAxis = new Vec3();

/**
 * Get current rotational velocity of a wheel
 * @method getWheelSpeed
 * @param {integer} wheelIndex
 */
RigidVehicle.prototype.getWheelSpeed = function(wheelIndex){
    var axis = this.wheelAxes[wheelIndex];
    var wheelBody = this.wheelBodies[wheelIndex];
    var w = wheelBody.angularVelocity;
    this.chassisBody.vectorToWorldFrame(axis, worldAxis);
    return w.dot(worldAxis);
};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = SPHSystem;

var Shape = __webpack_require__(12);
var Vec3 = __webpack_require__(0);
var Quaternion = __webpack_require__(13);
var Particle = __webpack_require__(146);
var Body = __webpack_require__(33);
var Material = __webpack_require__(59);

/**
 * Smoothed-particle hydrodynamics system
 * @class SPHSystem
 * @constructor
 */
function SPHSystem(){
    this.particles = [];
	
    /**
     * Density of the system (kg/m3).
     * @property {number} density
     */
    this.density = 1;
	
    /**
     * Distance below which two particles are considered to be neighbors.
     * It should be adjusted so there are about 15-20 neighbor particles within this radius.
     * @property {number} smoothingRadius
     */
    this.smoothingRadius = 1;
    this.speedOfSound = 1;
	
    /**
     * Viscosity of the system.
     * @property {number} viscosity
     */
    this.viscosity = 0.01;
    this.eps = 0.000001;

    // Stuff Computed per particle
    this.pressures = [];
    this.densities = [];
    this.neighbors = [];
}

/**
 * Add a particle to the system.
 * @method add
 * @param {Body} particle
 */
SPHSystem.prototype.add = function(particle){
    this.particles.push(particle);
    if(this.neighbors.length < this.particles.length){
        this.neighbors.push([]);
    }
};

/**
 * Remove a particle from the system.
 * @method remove
 * @param {Body} particle
 */
SPHSystem.prototype.remove = function(particle){
    var idx = this.particles.indexOf(particle);
    if(idx !== -1){
        this.particles.splice(idx,1);
        if(this.neighbors.length > this.particles.length){
            this.neighbors.pop();
        }
    }
};

/**
 * Get neighbors within smoothing volume, save in the array neighbors
 * @method getNeighbors
 * @param {Body} particle
 * @param {Array} neighbors
 */
var SPHSystem_getNeighbors_dist = new Vec3();
SPHSystem.prototype.getNeighbors = function(particle,neighbors){
    var N = this.particles.length,
        id = particle.id,
        R2 = this.smoothingRadius * this.smoothingRadius,
        dist = SPHSystem_getNeighbors_dist;
    for(var i=0; i!==N; i++){
        var p = this.particles[i];
        p.position.vsub(particle.position,dist);
        if(id!==p.id && dist.norm2() < R2){
            neighbors.push(p);
        }
    }
};

// Temp vectors for calculation
var SPHSystem_update_dist = new Vec3(),
    SPHSystem_update_a_pressure = new Vec3(),
    SPHSystem_update_a_visc = new Vec3(),
    SPHSystem_update_gradW = new Vec3(),
    SPHSystem_update_r_vec = new Vec3(),
    SPHSystem_update_u = new Vec3(); // Relative velocity
SPHSystem.prototype.update = function(){
    var N = this.particles.length,
        dist = SPHSystem_update_dist,
        cs = this.speedOfSound,
        eps = this.eps;

    for(var i=0; i!==N; i++){
        var p = this.particles[i]; // Current particle
        var neighbors = this.neighbors[i];

        // Get neighbors
        neighbors.length = 0;
        this.getNeighbors(p,neighbors);
        neighbors.push(this.particles[i]); // Add current too
        var numNeighbors = neighbors.length;

        // Accumulate density for the particle
        var sum = 0.0;
        for(var j=0; j!==numNeighbors; j++){

            //printf("Current particle has position %f %f %f\n",objects[id].pos.x(),objects[id].pos.y(),objects[id].pos.z());
            p.position.vsub(neighbors[j].position, dist);
            var len = dist.norm();

            var weight = this.w(len);
            sum += neighbors[j].mass * weight;
        }

        // Save
        this.densities[i] = sum;
        this.pressures[i] = cs * cs * (this.densities[i] - this.density);
    }

    // Add forces

    // Sum to these accelerations
    var a_pressure= SPHSystem_update_a_pressure;
    var a_visc =    SPHSystem_update_a_visc;
    var gradW =     SPHSystem_update_gradW;
    var r_vec =     SPHSystem_update_r_vec;
    var u =         SPHSystem_update_u;

    for(var i=0; i!==N; i++){

        var particle = this.particles[i];

        a_pressure.set(0,0,0);
        a_visc.set(0,0,0);

        // Init vars
        var Pij;
        var nabla;
        var Vij;

        // Sum up for all other neighbors
        var neighbors = this.neighbors[i];
        var numNeighbors = neighbors.length;

        //printf("Neighbors: ");
        for(var j=0; j!==numNeighbors; j++){

            var neighbor = neighbors[j];
            //printf("%d ",nj);

            // Get r once for all..
            particle.position.vsub(neighbor.position,r_vec);
            var r = r_vec.norm();

            // Pressure contribution
            Pij = -neighbor.mass * (this.pressures[i] / (this.densities[i]*this.densities[i] + eps) + this.pressures[j] / (this.densities[j]*this.densities[j] + eps));
            this.gradw(r_vec, gradW);
            // Add to pressure acceleration
            gradW.mult(Pij , gradW);
            a_pressure.vadd(gradW, a_pressure);

            // Viscosity contribution
            neighbor.velocity.vsub(particle.velocity, u);
            u.mult( 1.0 / (0.0001+this.densities[i] * this.densities[j]) * this.viscosity * neighbor.mass , u );
            nabla = this.nablaw(r);
            u.mult(nabla,u);
            // Add to viscosity acceleration
            a_visc.vadd( u, a_visc );
        }

        // Calculate force
        a_visc.mult(particle.mass, a_visc);
        a_pressure.mult(particle.mass, a_pressure);

        // Add force to particles
        particle.force.vadd(a_visc, particle.force);
        particle.force.vadd(a_pressure, particle.force);
    }
};

// Calculate the weight using the W(r) weightfunction
SPHSystem.prototype.w = function(r){
    // 315
    var h = this.smoothingRadius;
    return 315.0/(64.0*Math.PI*Math.pow(h,9)) * Math.pow(h*h-r*r,3);
};

// calculate gradient of the weight function
SPHSystem.prototype.gradw = function(rVec,resultVec){
    var r = rVec.norm(),
        h = this.smoothingRadius;
    rVec.mult(945.0/(32.0*Math.PI*Math.pow(h,9)) * Math.pow((h*h-r*r),2) , resultVec);
};

// Calculate nabla(W)
SPHSystem.prototype.nablaw = function(r){
    var h = this.smoothingRadius;
    var nabla = 945.0/(32.0*Math.PI*Math.pow(h,9)) * (h*h-r*r)*(7*r*r - 3*h*h);
    return nabla;
};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var Vec3 = __webpack_require__(0);

module.exports = Spring;

/**
 * A spring, connecting two bodies.
 *
 * @class Spring
 * @constructor
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Object} [options]
 * @param {number} [options.restLength]   A number > 0. Default: 1
 * @param {number} [options.stiffness]    A number >= 0. Default: 100
 * @param {number} [options.damping]      A number >= 0. Default: 1
 * @param {Vec3}  [options.worldAnchorA] Where to hook the spring to body A, in world coordinates.
 * @param {Vec3}  [options.worldAnchorB]
 * @param {Vec3}  [options.localAnchorA] Where to hook the spring to body A, in local body coordinates.
 * @param {Vec3}  [options.localAnchorB]
 */
function Spring(bodyA,bodyB,options){
    options = options || {};

    /**
     * Rest length of the spring.
     * @property restLength
     * @type {number}
     */
    this.restLength = typeof(options.restLength) === "number" ? options.restLength : 1;

    /**
     * Stiffness of the spring.
     * @property stiffness
     * @type {number}
     */
    this.stiffness = options.stiffness || 100;

    /**
     * Damping of the spring.
     * @property damping
     * @type {number}
     */
    this.damping = options.damping || 1;

    /**
     * First connected body.
     * @property bodyA
     * @type {Body}
     */
    this.bodyA = bodyA;

    /**
     * Second connected body.
     * @property bodyB
     * @type {Body}
     */
    this.bodyB = bodyB;

    /**
     * Anchor for bodyA in local bodyA coordinates.
     * @property localAnchorA
     * @type {Vec3}
     */
    this.localAnchorA = new Vec3();

    /**
     * Anchor for bodyB in local bodyB coordinates.
     * @property localAnchorB
     * @type {Vec3}
     */
    this.localAnchorB = new Vec3();

    if(options.localAnchorA){
        this.localAnchorA.copy(options.localAnchorA);
    }
    if(options.localAnchorB){
        this.localAnchorB.copy(options.localAnchorB);
    }
    if(options.worldAnchorA){
        this.setWorldAnchorA(options.worldAnchorA);
    }
    if(options.worldAnchorB){
        this.setWorldAnchorB(options.worldAnchorB);
    }
}

/**
 * Set the anchor point on body A, using world coordinates.
 * @method setWorldAnchorA
 * @param {Vec3} worldAnchorA
 */
Spring.prototype.setWorldAnchorA = function(worldAnchorA){
    this.bodyA.pointToLocalFrame(worldAnchorA,this.localAnchorA);
};

/**
 * Set the anchor point on body B, using world coordinates.
 * @method setWorldAnchorB
 * @param {Vec3} worldAnchorB
 */
Spring.prototype.setWorldAnchorB = function(worldAnchorB){
    this.bodyB.pointToLocalFrame(worldAnchorB,this.localAnchorB);
};

/**
 * Get the anchor point on body A, in world coordinates.
 * @method getWorldAnchorA
 * @param {Vec3} result The vector to store the result in.
 */
Spring.prototype.getWorldAnchorA = function(result){
    this.bodyA.pointToWorldFrame(this.localAnchorA,result);
};

/**
 * Get the anchor point on body B, in world coordinates.
 * @method getWorldAnchorB
 * @param {Vec3} result The vector to store the result in.
 */
Spring.prototype.getWorldAnchorB = function(result){
    this.bodyB.pointToWorldFrame(this.localAnchorB,result);
};

var applyForce_r =              new Vec3(),
    applyForce_r_unit =         new Vec3(),
    applyForce_u =              new Vec3(),
    applyForce_f =              new Vec3(),
    applyForce_worldAnchorA =   new Vec3(),
    applyForce_worldAnchorB =   new Vec3(),
    applyForce_ri =             new Vec3(),
    applyForce_rj =             new Vec3(),
    applyForce_ri_x_f =         new Vec3(),
    applyForce_rj_x_f =         new Vec3(),
    applyForce_tmp =            new Vec3();

/**
 * Apply the spring force to the connected bodies.
 * @method applyForce
 */
Spring.prototype.applyForce = function(){
    var k = this.stiffness,
        d = this.damping,
        l = this.restLength,
        bodyA = this.bodyA,
        bodyB = this.bodyB,
        r = applyForce_r,
        r_unit = applyForce_r_unit,
        u = applyForce_u,
        f = applyForce_f,
        tmp = applyForce_tmp;

    var worldAnchorA = applyForce_worldAnchorA,
        worldAnchorB = applyForce_worldAnchorB,
        ri = applyForce_ri,
        rj = applyForce_rj,
        ri_x_f = applyForce_ri_x_f,
        rj_x_f = applyForce_rj_x_f;

    // Get world anchors
    this.getWorldAnchorA(worldAnchorA);
    this.getWorldAnchorB(worldAnchorB);

    // Get offset points
    worldAnchorA.vsub(bodyA.position,ri);
    worldAnchorB.vsub(bodyB.position,rj);

    // Compute distance vector between world anchor points
    worldAnchorB.vsub(worldAnchorA,r);
    var rlen = r.norm();
    r_unit.copy(r);
    r_unit.normalize();

    // Compute relative velocity of the anchor points, u
    bodyB.velocity.vsub(bodyA.velocity,u);
    // Add rotational velocity

    bodyB.angularVelocity.cross(rj,tmp);
    u.vadd(tmp,u);
    bodyA.angularVelocity.cross(ri,tmp);
    u.vsub(tmp,u);

    // F = - k * ( x - L ) - D * ( u )
    r_unit.mult(-k*(rlen-l) - d*u.dot(r_unit), f);

    // Add forces to bodies
    bodyA.force.vsub(f,bodyA.force);
    bodyB.force.vadd(f,bodyB.force);

    // Angular force
    ri.cross(f,ri_x_f);
    rj.cross(f,rj_x_f);
    bodyA.torque.vsub(ri_x_f,bodyA.torque);
    bodyB.torque.vadd(rj_x_f,bodyB.torque);
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var Vec3 = __webpack_require__(0);
var Transform = __webpack_require__(46);
var RaycastResult = __webpack_require__(58);
var Utils = __webpack_require__(60);

module.exports = WheelInfo;

/**
 * @class WheelInfo
 * @constructor
 * @param {Object} [options]
 *
 * @param {Vec3} [options.chassisConnectionPointLocal]
 * @param {Vec3} [options.chassisConnectionPointWorld]
 * @param {Vec3} [options.directionLocal]
 * @param {Vec3} [options.directionWorld]
 * @param {Vec3} [options.axleLocal]
 * @param {Vec3} [options.axleWorld]
 * @param {number} [options.suspensionRestLength=1]
 * @param {number} [options.suspensionMaxLength=2]
 * @param {number} [options.radius=1]
 * @param {number} [options.suspensionStiffness=100]
 * @param {number} [options.dampingCompression=10]
 * @param {number} [options.dampingRelaxation=10]
 * @param {number} [options.frictionSlip=10000]
 * @param {number} [options.steering=0]
 * @param {number} [options.rotation=0]
 * @param {number} [options.deltaRotation=0]
 * @param {number} [options.rollInfluence=0.01]
 * @param {number} [options.maxSuspensionForce]
 * @param {boolean} [options.isFrontWheel=true]
 * @param {number} [options.clippedInvContactDotSuspension=1]
 * @param {number} [options.suspensionRelativeVelocity=0]
 * @param {number} [options.suspensionForce=0]
 * @param {number} [options.skidInfo=0]
 * @param {number} [options.suspensionLength=0]
 * @param {number} [options.maxSuspensionTravel=1]
 * @param {boolean} [options.useCustomSlidingRotationalSpeed=false]
 * @param {number} [options.customSlidingRotationalSpeed=-0.1]
 */
function WheelInfo(options){
    options = Utils.defaults(options, {
        chassisConnectionPointLocal: new Vec3(),
        chassisConnectionPointWorld: new Vec3(),
        directionLocal: new Vec3(),
        directionWorld: new Vec3(),
        axleLocal: new Vec3(),
        axleWorld: new Vec3(),
        suspensionRestLength: 1,
        suspensionMaxLength: 2,
        radius: 1,
        suspensionStiffness: 100,
        dampingCompression: 10,
        dampingRelaxation: 10,
        frictionSlip: 10000,
        steering: 0,
        rotation: 0,
        deltaRotation: 0,
        rollInfluence: 0.01,
        maxSuspensionForce: Number.MAX_VALUE,
        isFrontWheel: true,
        clippedInvContactDotSuspension: 1,
        suspensionRelativeVelocity: 0,
        suspensionForce: 0,
        skidInfo: 0,
        suspensionLength: 0,
        maxSuspensionTravel: 1,
        useCustomSlidingRotationalSpeed: false,
        customSlidingRotationalSpeed: -0.1
    });

    /**
     * Max travel distance of the suspension, in meters.
     * @property {number} maxSuspensionTravel
     */
    this.maxSuspensionTravel = options.maxSuspensionTravel;

    /**
     * Speed to apply to the wheel rotation when the wheel is sliding.
     * @property {number} customSlidingRotationalSpeed
     */
    this.customSlidingRotationalSpeed = options.customSlidingRotationalSpeed;

    /**
     * If the customSlidingRotationalSpeed should be used.
     * @property {Boolean} useCustomSlidingRotationalSpeed
     */
    this.useCustomSlidingRotationalSpeed = options.useCustomSlidingRotationalSpeed;

    /**
     * @property {Boolean} sliding
     */
    this.sliding = false;

    /**
     * Connection point, defined locally in the chassis body frame.
     * @property {Vec3} chassisConnectionPointLocal
     */
    this.chassisConnectionPointLocal = options.chassisConnectionPointLocal.clone();

    /**
     * @property {Vec3} chassisConnectionPointWorld
     */
    this.chassisConnectionPointWorld = options.chassisConnectionPointWorld.clone();

    /**
     * @property {Vec3} directionLocal
     */
    this.directionLocal = options.directionLocal.clone();

    /**
     * @property {Vec3} directionWorld
     */
    this.directionWorld = options.directionWorld.clone();

    /**
     * @property {Vec3} axleLocal
     */
    this.axleLocal = options.axleLocal.clone();

    /**
     * @property {Vec3} axleWorld
     */
    this.axleWorld = options.axleWorld.clone();

    /**
     * @property {number} suspensionRestLength
     */
    this.suspensionRestLength = options.suspensionRestLength;

    /**
     * @property {number} suspensionMaxLength
     */
    this.suspensionMaxLength = options.suspensionMaxLength;

    /**
     * @property {number} radius
     */
    this.radius = options.radius;

    /**
     * @property {number} suspensionStiffness
     */
    this.suspensionStiffness = options.suspensionStiffness;

    /**
     * @property {number} dampingCompression
     */
    this.dampingCompression = options.dampingCompression;

    /**
     * @property {number} dampingRelaxation
     */
    this.dampingRelaxation = options.dampingRelaxation;

    /**
     * @property {number} frictionSlip
     */
    this.frictionSlip = options.frictionSlip;

    /**
     * @property {number} steering
     */
    this.steering = 0;

    /**
     * Rotation value, in radians.
     * @property {number} rotation
     */
    this.rotation = 0;

    /**
     * @property {number} deltaRotation
     */
    this.deltaRotation = 0;

    /**
     * @property {number} rollInfluence
     */
    this.rollInfluence = options.rollInfluence;

    /**
     * @property {number} maxSuspensionForce
     */
    this.maxSuspensionForce = options.maxSuspensionForce;

    /**
     * @property {number} engineForce
     */
    this.engineForce = 0;

    /**
     * @property {number} brake
     */
    this.brake = 0;

    /**
     * @property {number} isFrontWheel
     */
    this.isFrontWheel = options.isFrontWheel;

    /**
     * @property {number} clippedInvContactDotSuspension
     */
    this.clippedInvContactDotSuspension = 1;

    /**
     * @property {number} suspensionRelativeVelocity
     */
    this.suspensionRelativeVelocity = 0;

    /**
     * @property {number} suspensionForce
     */
    this.suspensionForce = 0;

    /**
     * @property {number} skidInfo
     */
    this.skidInfo = 0;

    /**
     * @property {number} suspensionLength
     */
    this.suspensionLength = 0;

    /**
     * @property {number} sideImpulse
     */
    this.sideImpulse = 0;

    /**
     * @property {number} forwardImpulse
     */
    this.forwardImpulse = 0;

    /**
     * The result from raycasting
     * @property {RaycastResult} raycastResult
     */
    this.raycastResult = new RaycastResult();

    /**
     * Wheel world transform
     * @property {Transform} worldTransform
     */
    this.worldTransform = new Transform();

    /**
     * @property {boolean} isInContact
     */
    this.isInContact = false;
}

var chassis_velocity_at_contactPoint = new Vec3();
var relpos = new Vec3();
var chassis_velocity_at_contactPoint = new Vec3();
WheelInfo.prototype.updateWheel = function(chassis){
    var raycastResult = this.raycastResult;

    if (this.isInContact){
        var project= raycastResult.hitNormalWorld.dot(raycastResult.directionWorld);
        raycastResult.hitPointWorld.vsub(chassis.position, relpos);
        chassis.getVelocityAtWorldPoint(relpos, chassis_velocity_at_contactPoint);
        var projVel = raycastResult.hitNormalWorld.dot( chassis_velocity_at_contactPoint );
        if (project >= -0.1) {
            this.suspensionRelativeVelocity = 0.0;
            this.clippedInvContactDotSuspension = 1.0 / 0.1;
        } else {
            var inv = -1 / project;
            this.suspensionRelativeVelocity = projVel * inv;
            this.clippedInvContactDotSuspension = inv;
        }

    } else {
        // Not in contact : position wheel in a nice (rest length) position
        raycastResult.suspensionLength = this.suspensionRestLength;
        this.suspensionRelativeVelocity = 0.0;
        raycastResult.directionWorld.scale(-1, raycastResult.hitNormalWorld);
        this.clippedInvContactDotSuspension = 1.0;
    }
};

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Cylinder;

var Shape = __webpack_require__(12);
var Vec3 = __webpack_require__(0);
var Quaternion = __webpack_require__(13);
var ConvexPolyhedron = __webpack_require__(47);

/**
 * @class Cylinder
 * @constructor
 * @extends ConvexPolyhedron
 * @author schteppe / https://github.com/schteppe
 * @param {Number} radiusTop
 * @param {Number} radiusBottom
 * @param {Number} height
 * @param {Number} numSegments The number of segments to build the cylinder out of
 */
function Cylinder( radiusTop, radiusBottom, height , numSegments ) {
    var N = numSegments,
        verts = [],
        axes = [],
        faces = [],
        bottomface = [],
        topface = [],
        cos = Math.cos,
        sin = Math.sin;

    // First bottom point
    verts.push(new Vec3(radiusBottom*cos(0),
                               radiusBottom*sin(0),
                               -height*0.5));
    bottomface.push(0);

    // First top point
    verts.push(new Vec3(radiusTop*cos(0),
                               radiusTop*sin(0),
                               height*0.5));
    topface.push(1);

    for(var i=0; i<N; i++){
        var theta = 2*Math.PI/N * (i+1);
        var thetaN = 2*Math.PI/N * (i+0.5);
        if(i<N-1){
            // Bottom
            verts.push(new Vec3(radiusBottom*cos(theta),
                                       radiusBottom*sin(theta),
                                       -height*0.5));
            bottomface.push(2*i+2);
            // Top
            verts.push(new Vec3(radiusTop*cos(theta),
                                       radiusTop*sin(theta),
                                       height*0.5));
            topface.push(2*i+3);

            // Face
            faces.push([2*i+2, 2*i+3, 2*i+1,2*i]);
        } else {
            faces.push([0,1, 2*i+1, 2*i]); // Connect
        }

        // Axis: we can cut off half of them if we have even number of segments
        if(N % 2 === 1 || i < N / 2){
            axes.push(new Vec3(cos(thetaN), sin(thetaN), 0));
        }
    }
    faces.push(topface);
    axes.push(new Vec3(0,0,1));

    // Reorder bottom face
    var temp = [];
    for(var i=0; i<bottomface.length; i++){
        temp.push(bottomface[bottomface.length - i - 1]);
    }
    faces.push(temp);

    this.type = Shape.types.CONVEXPOLYHEDRON;
    ConvexPolyhedron.call( this, verts, faces, axes );
}

Cylinder.prototype = new ConvexPolyhedron();


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var Shape = __webpack_require__(12);
var ConvexPolyhedron = __webpack_require__(47);
var Vec3 = __webpack_require__(0);
var Utils = __webpack_require__(60);

module.exports = Heightfield;

/**
 * Heightfield shape class. Height data is given as an array. These data points are spread out evenly with a given distance.
 * @class Heightfield
 * @extends Shape
 * @constructor
 * @param {Array} data An array of Y values that will be used to construct the terrain.
 * @param {object} options
 * @param {Number} [options.minValue] Minimum value of the data points in the data array. Will be computed automatically if not given.
 * @param {Number} [options.maxValue] Maximum value.
 * @param {Number} [options.elementSize=0.1] World spacing between the data points in X direction.
 * @todo Should be possible to use along all axes, not just y
 * @todo should be possible to scale along all axes
 *
 * @example
 *     // Generate some height data (y-values).
 *     var data = [];
 *     for(var i = 0; i < 1000; i++){
 *         var y = 0.5 * Math.cos(0.2 * i);
 *         data.push(y);
 *     }
 *
 *     // Create the heightfield shape
 *     var heightfieldShape = new Heightfield(data, {
 *         elementSize: 1 // Distance between the data points in X and Y directions
 *     });
 *     var heightfieldBody = new Body();
 *     heightfieldBody.addShape(heightfieldShape);
 *     world.addBody(heightfieldBody);
 */
function Heightfield(data, options){
    options = Utils.defaults(options, {
        maxValue : null,
        minValue : null,
        elementSize : 1
    });

    /**
     * An array of numbers, or height values, that are spread out along the x axis.
     * @property {array} data
     */
    this.data = data;

    /**
     * Max value of the data
     * @property {number} maxValue
     */
    this.maxValue = options.maxValue;

    /**
     * Max value of the data
     * @property {number} minValue
     */
    this.minValue = options.minValue;

    /**
     * The width of each element
     * @property {number} elementSize
     * @todo elementSizeX and Y
     */
    this.elementSize = options.elementSize;

    if(options.minValue === null){
        this.updateMinValue();
    }
    if(options.maxValue === null){
        this.updateMaxValue();
    }

    this.cacheEnabled = true;

    Shape.call(this);

    this.pillarConvex = new ConvexPolyhedron();
    this.pillarOffset = new Vec3();

    this.type = Shape.types.HEIGHTFIELD;
    this.updateBoundingSphereRadius();

    // "i_j_isUpper" => { convex: ..., offset: ... }
    // for example:
    // _cachedPillars["0_2_1"]
    this._cachedPillars = {};
}
Heightfield.prototype = new Shape();

/**
 * Call whenever you change the data array.
 * @method update
 */
Heightfield.prototype.update = function(){
    this._cachedPillars = {};
};

/**
 * Update the .minValue property
 * @method updateMinValue
 */
Heightfield.prototype.updateMinValue = function(){
    var data = this.data;
    var minValue = data[0][0];
    for(var i=0; i !== data.length; i++){
        for(var j=0; j !== data[i].length; j++){
            var v = data[i][j];
            if(v < minValue){
                minValue = v;
            }
        }
    }
    this.minValue = minValue;
};

/**
 * Update the .maxValue property
 * @method updateMaxValue
 */
Heightfield.prototype.updateMaxValue = function(){
    var data = this.data;
    var maxValue = data[0][0];
    for(var i=0; i !== data.length; i++){
        for(var j=0; j !== data[i].length; j++){
            var v = data[i][j];
            if(v > maxValue){
                maxValue = v;
            }
        }
    }
    this.maxValue = maxValue;
};

/**
 * Set the height value at an index. Don't forget to update maxValue and minValue after you're done.
 * @method setHeightValueAtIndex
 * @param {integer} xi
 * @param {integer} yi
 * @param {number} value
 */
Heightfield.prototype.setHeightValueAtIndex = function(xi, yi, value){
    var data = this.data;
    data[xi][yi] = value;

    // Invalidate cache
    this.clearCachedConvexTrianglePillar(xi, yi, false);
    if(xi > 0){
        this.clearCachedConvexTrianglePillar(xi - 1, yi, true);
        this.clearCachedConvexTrianglePillar(xi - 1, yi, false);
    }
    if(yi > 0){
        this.clearCachedConvexTrianglePillar(xi, yi - 1, true);
        this.clearCachedConvexTrianglePillar(xi, yi - 1, false);
    }
    if(yi > 0 && xi > 0){
        this.clearCachedConvexTrianglePillar(xi - 1, yi - 1, true);
    }
};

/**
 * Get max/min in a rectangle in the matrix data
 * @method getRectMinMax
 * @param  {integer} iMinX
 * @param  {integer} iMinY
 * @param  {integer} iMaxX
 * @param  {integer} iMaxY
 * @param  {array} [result] An array to store the results in.
 * @return {array} The result array, if it was passed in. Minimum will be at position 0 and max at 1.
 */
Heightfield.prototype.getRectMinMax = function (iMinX, iMinY, iMaxX, iMaxY, result) {
    result = result || [];

    // Get max and min of the data
    var data = this.data,
        max = this.minValue; // Set first value
    for(var i = iMinX; i <= iMaxX; i++){
        for(var j = iMinY; j <= iMaxY; j++){
            var height = data[i][j];
            if(height > max){
                max = height;
            }
        }
    }

    result[0] = this.minValue;
    result[1] = max;
};



/**
 * Get the index of a local position on the heightfield. The indexes indicate the rectangles, so if your terrain is made of N x N height data points, you will have rectangle indexes ranging from 0 to N-1.
 * @method getIndexOfPosition
 * @param  {number} x
 * @param  {number} y
 * @param  {array} result Two-element array
 * @param  {boolean} clamp If the position should be clamped to the heightfield edge.
 * @return {boolean}
 */
Heightfield.prototype.getIndexOfPosition = function (x, y, result, clamp) {

    // Get the index of the data points to test against
    var w = this.elementSize;
    var data = this.data;
    var xi = Math.floor(x / w);
    var yi = Math.floor(y / w);

    result[0] = xi;
    result[1] = yi;

    if(clamp){
        // Clamp index to edges
        if(xi < 0){ xi = 0; }
        if(yi < 0){ yi = 0; }
        if(xi >= data.length - 1){ xi = data.length - 1; }
        if(yi >= data[0].length - 1){ yi = data[0].length - 1; }
    }

    // Bail out if we are out of the terrain
    if(xi < 0 || yi < 0 || xi >= data.length-1 || yi >= data[0].length-1){
        return false;
    }

    return true;
};


var getHeightAt_idx = [];
var getHeightAt_weights = new Vec3();
var getHeightAt_a = new Vec3();
var getHeightAt_b = new Vec3();
var getHeightAt_c = new Vec3();

Heightfield.prototype.getTriangleAt = function(x, y, edgeClamp, a, b, c){
    var idx = getHeightAt_idx;
    this.getIndexOfPosition(x, y, idx, edgeClamp);
    var xi = idx[0];
    var yi = idx[1];

    var data = this.data;
    if(edgeClamp){
        xi = Math.min(data.length - 2, Math.max(0, xi));
        yi = Math.min(data[0].length - 2, Math.max(0, yi));
    }

    var elementSize = this.elementSize;
    var lowerDist2 = Math.pow(x / elementSize - xi, 2) + Math.pow(y / elementSize - yi, 2);
    var upperDist2 = Math.pow(x / elementSize - (xi + 1), 2) + Math.pow(y / elementSize - (yi + 1), 2);
    var upper = lowerDist2 > upperDist2;
    this.getTriangle(xi, yi, upper, a, b, c);
    return upper;
};

var getNormalAt_a = new Vec3();
var getNormalAt_b = new Vec3();
var getNormalAt_c = new Vec3();
var getNormalAt_e0 = new Vec3();
var getNormalAt_e1 = new Vec3();
Heightfield.prototype.getNormalAt = function(x, y, edgeClamp, result){
    var a = getNormalAt_a;
    var b = getNormalAt_b;
    var c = getNormalAt_c;
    var e0 = getNormalAt_e0;
    var e1 = getNormalAt_e1;
    this.getTriangleAt(x, y, edgeClamp, a, b, c);
    b.vsub(a, e0);
    c.vsub(a, e1);
    e0.cross(e1, result);
    result.normalize();
};


/**
 * Get an AABB of a square in the heightfield
 * @param  {number} xi
 * @param  {number} yi
 * @param  {AABB} result
 */
Heightfield.prototype.getAabbAtIndex = function(xi, yi, result){
    var data = this.data;
    var elementSize = this.elementSize;

    result.lowerBound.set(
        xi * elementSize,
        yi * elementSize,
        data[xi][yi]
    );
    result.upperBound.set(
        (xi + 1) * elementSize,
        (yi + 1) * elementSize,
        data[xi + 1][yi + 1]
    );
};


/**
 * Get the height in the heightfield at a given position
 * @param  {number} x
 * @param  {number} y
 * @param  {boolean} edgeClamp
 * @return {number}
 */
Heightfield.prototype.getHeightAt = function(x, y, edgeClamp){
    var data = this.data;
    var a = getHeightAt_a;
    var b = getHeightAt_b;
    var c = getHeightAt_c;
    var idx = getHeightAt_idx;

    this.getIndexOfPosition(x, y, idx, edgeClamp);
    var xi = idx[0];
    var yi = idx[1];
    if(edgeClamp){
        xi = Math.min(data.length - 2, Math.max(0, xi));
        yi = Math.min(data[0].length - 2, Math.max(0, yi));
    }
    var upper = this.getTriangleAt(x, y, edgeClamp, a, b, c);
    barycentricWeights(x, y, a.x, a.y, b.x, b.y, c.x, c.y, getHeightAt_weights);

    var w = getHeightAt_weights;

    if(upper){

        // Top triangle verts
        return data[xi + 1][yi + 1] * w.x + data[xi][yi + 1] * w.y + data[xi + 1][yi] * w.z;

    } else {

        // Top triangle verts
        return data[xi][yi] * w.x + data[xi + 1][yi] * w.y + data[xi][yi + 1] * w.z;
    }
};

// from https://en.wikipedia.org/wiki/Barycentric_coordinate_system
function barycentricWeights(x, y, ax, ay, bx, by, cx, cy, result){
    result.x = ((by - cy) * (x - cx) + (cx - bx) * (y - cy)) / ((by - cy) * (ax - cx) + (cx - bx) * (ay - cy));
    result.y = ((cy - ay) * (x - cx) + (ax - cx) * (y - cy)) / ((by - cy) * (ax - cx) + (cx - bx) * (ay - cy));
    result.z = 1 - result.x - result.y;
}

Heightfield.prototype.getCacheConvexTrianglePillarKey = function(xi, yi, getUpperTriangle){
    return xi + '_' + yi + '_' + (getUpperTriangle ? 1 : 0);
};

Heightfield.prototype.getCachedConvexTrianglePillar = function(xi, yi, getUpperTriangle){
    return this._cachedPillars[this.getCacheConvexTrianglePillarKey(xi, yi, getUpperTriangle)];
};

Heightfield.prototype.setCachedConvexTrianglePillar = function(xi, yi, getUpperTriangle, convex, offset){
    this._cachedPillars[this.getCacheConvexTrianglePillarKey(xi, yi, getUpperTriangle)] = {
        convex: convex,
        offset: offset
    };
};

Heightfield.prototype.clearCachedConvexTrianglePillar = function(xi, yi, getUpperTriangle){
    delete this._cachedPillars[this.getCacheConvexTrianglePillarKey(xi, yi, getUpperTriangle)];
};

/**
 * Get a triangle from the heightfield
 * @param  {number} xi
 * @param  {number} yi
 * @param  {boolean} upper
 * @param  {Vec3} a
 * @param  {Vec3} b
 * @param  {Vec3} c
 */
Heightfield.prototype.getTriangle = function(xi, yi, upper, a, b, c){
    var data = this.data;
    var elementSize = this.elementSize;

    if(upper){

        // Top triangle verts
        a.set(
            (xi + 1) * elementSize,
            (yi + 1) * elementSize,
            data[xi + 1][yi + 1]
        );
        b.set(
            xi * elementSize,
            (yi + 1) * elementSize,
            data[xi][yi + 1]
        );
        c.set(
            (xi + 1) * elementSize,
            yi * elementSize,
            data[xi + 1][yi]
        );

    } else {

        // Top triangle verts
        a.set(
            xi * elementSize,
            yi * elementSize,
            data[xi][yi]
        );
        b.set(
            (xi + 1) * elementSize,
            yi * elementSize,
            data[xi + 1][yi]
        );
        c.set(
            xi * elementSize,
            (yi + 1) * elementSize,
            data[xi][yi + 1]
        );
    }
};

/**
 * Get a triangle in the terrain in the form of a triangular convex shape.
 * @method getConvexTrianglePillar
 * @param  {integer} i
 * @param  {integer} j
 * @param  {boolean} getUpperTriangle
 */
Heightfield.prototype.getConvexTrianglePillar = function(xi, yi, getUpperTriangle){
    var result = this.pillarConvex;
    var offsetResult = this.pillarOffset;

    if(this.cacheEnabled){
        var data = this.getCachedConvexTrianglePillar(xi, yi, getUpperTriangle);
        if(data){
            this.pillarConvex = data.convex;
            this.pillarOffset = data.offset;
            return;
        }

        result = new ConvexPolyhedron();
        offsetResult = new Vec3();

        this.pillarConvex = result;
        this.pillarOffset = offsetResult;
    }

    var data = this.data;
    var elementSize = this.elementSize;
    var faces = result.faces;

    // Reuse verts if possible
    result.vertices.length = 6;
    for (var i = 0; i < 6; i++) {
        if(!result.vertices[i]){
            result.vertices[i] = new Vec3();
        }
    }

    // Reuse faces if possible
    faces.length = 5;
    for (var i = 0; i < 5; i++) {
        if(!faces[i]){
            faces[i] = [];
        }
    }

    var verts = result.vertices;

    var h = (Math.min(
        data[xi][yi],
        data[xi+1][yi],
        data[xi][yi+1],
        data[xi+1][yi+1]
    ) - this.minValue ) / 2 + this.minValue;

    if (!getUpperTriangle) {

        // Center of the triangle pillar - all polygons are given relative to this one
        offsetResult.set(
            (xi + 0.25) * elementSize, // sort of center of a triangle
            (yi + 0.25) * elementSize,
            h // vertical center
        );

        // Top triangle verts
        verts[0].set(
            -0.25 * elementSize,
            -0.25 * elementSize,
            data[xi][yi] - h
        );
        verts[1].set(
            0.75 * elementSize,
            -0.25 * elementSize,
            data[xi + 1][yi] - h
        );
        verts[2].set(
            -0.25 * elementSize,
            0.75 * elementSize,
            data[xi][yi + 1] - h
        );

        // bottom triangle verts
        verts[3].set(
            -0.25 * elementSize,
            -0.25 * elementSize,
            -h-1
        );
        verts[4].set(
            0.75 * elementSize,
            -0.25 * elementSize,
            -h-1
        );
        verts[5].set(
            -0.25 * elementSize,
            0.75  * elementSize,
            -h-1
        );

        // top triangle
        faces[0][0] = 0;
        faces[0][1] = 1;
        faces[0][2] = 2;

        // bottom triangle
        faces[1][0] = 5;
        faces[1][1] = 4;
        faces[1][2] = 3;

        // -x facing quad
        faces[2][0] = 0;
        faces[2][1] = 2;
        faces[2][2] = 5;
        faces[2][3] = 3;

        // -y facing quad
        faces[3][0] = 1;
        faces[3][1] = 0;
        faces[3][2] = 3;
        faces[3][3] = 4;

        // +xy facing quad
        faces[4][0] = 4;
        faces[4][1] = 5;
        faces[4][2] = 2;
        faces[4][3] = 1;


    } else {

        // Center of the triangle pillar - all polygons are given relative to this one
        offsetResult.set(
            (xi + 0.75) * elementSize, // sort of center of a triangle
            (yi + 0.75) * elementSize,
            h // vertical center
        );

        // Top triangle verts
        verts[0].set(
            0.25 * elementSize,
            0.25 * elementSize,
            data[xi + 1][yi + 1] - h
        );
        verts[1].set(
            -0.75 * elementSize,
            0.25 * elementSize,
            data[xi][yi + 1] - h
        );
        verts[2].set(
            0.25 * elementSize,
            -0.75 * elementSize,
            data[xi + 1][yi] - h
        );

        // bottom triangle verts
        verts[3].set(
            0.25 * elementSize,
            0.25 * elementSize,
            - h-1
        );
        verts[4].set(
            -0.75 * elementSize,
            0.25 * elementSize,
            - h-1
        );
        verts[5].set(
            0.25 * elementSize,
            -0.75 * elementSize,
            - h-1
        );

        // Top triangle
        faces[0][0] = 0;
        faces[0][1] = 1;
        faces[0][2] = 2;

        // bottom triangle
        faces[1][0] = 5;
        faces[1][1] = 4;
        faces[1][2] = 3;

        // +x facing quad
        faces[2][0] = 2;
        faces[2][1] = 5;
        faces[2][2] = 3;
        faces[2][3] = 0;

        // +y facing quad
        faces[3][0] = 3;
        faces[3][1] = 4;
        faces[3][2] = 1;
        faces[3][3] = 0;

        // -xy facing quad
        faces[4][0] = 1;
        faces[4][1] = 4;
        faces[4][2] = 5;
        faces[4][3] = 2;
    }

    result.computeNormals();
    result.computeEdges();
    result.updateBoundingSphereRadius();

    this.setCachedConvexTrianglePillar(xi, yi, getUpperTriangle, result, offsetResult);
};

Heightfield.prototype.calculateLocalInertia = function(mass, target){
    target = target || new Vec3();
    target.set(0, 0, 0);
    return target;
};

Heightfield.prototype.volume = function(){
    return Number.MAX_VALUE; // The terrain is infinite
};

Heightfield.prototype.calculateWorldAABB = function(pos, quat, min, max){
    // TODO: do it properly
    min.set(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
    max.set(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
};

Heightfield.prototype.updateBoundingSphereRadius = function(){
    // Use the bounding box of the min/max values
    var data = this.data,
        s = this.elementSize;
    this.boundingSphereRadius = new Vec3(data.length * s, data[0].length * s, Math.max(Math.abs(this.maxValue), Math.abs(this.minValue))).norm();
};

/**
 * Sets the height values from an image. Currently only supported in browser.
 * @method setHeightsFromImage
 * @param {Image} image
 * @param {Vec3} scale
 */
Heightfield.prototype.setHeightsFromImage = function(image, scale){
    var canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    var context = canvas.getContext('2d');
    context.drawImage(image, 0, 0);
    var imageData = context.getImageData(0, 0, image.width, image.height);

    var matrix = this.data;
    matrix.length = 0;
    this.elementSize = Math.abs(scale.x) / imageData.width;
    for(var i=0; i<imageData.height; i++){
        var row = [];
        for(var j=0; j<imageData.width; j++){
            var a = imageData.data[(i*imageData.height + j) * 4];
            var b = imageData.data[(i*imageData.height + j) * 4 + 1];
            var c = imageData.data[(i*imageData.height + j) * 4 + 2];
            var height = (a + b + c) / 4 / 255 * scale.z;
            if(scale.x < 0){
                row.push(height);
            } else {
                row.unshift(height);
            }
        }
        if(scale.y < 0){
            matrix.unshift(row);
        } else {
            matrix.push(row);
        }
    }
    this.updateMaxValue();
    this.updateMinValue();
    this.update();
};

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Trimesh;

var Shape = __webpack_require__(12);
var Vec3 = __webpack_require__(0);
var Quaternion = __webpack_require__(13);
var Transform = __webpack_require__(46);
var AABB = __webpack_require__(30);
var Octree = __webpack_require__(352);

/**
 * @class Trimesh
 * @constructor
 * @param {array} vertices
 * @param {array} indices
 * @extends Shape
 * @example
 *     // How to make a mesh with a single triangle
 *     var vertices = [
 *         0, 0, 0, // vertex 0
 *         1, 0, 0, // vertex 1
 *         0, 1, 0  // vertex 2
 *     ];
 *     var indices = [
 *         0, 1, 2  // triangle 0
 *     ];
 *     var trimeshShape = new Trimesh(vertices, indices);
 */
function Trimesh(vertices, indices) {
    Shape.call(this);
    this.type = Shape.types.TRIMESH;

    /**
     * @property vertices
     * @type {Array}
     */
    this.vertices = new Float32Array(vertices);

    /**
     * Array of integers, indicating which vertices each triangle consists of. The length of this array is thus 3 times the number of triangles.
     * @property indices
     * @type {Array}
     */
    this.indices = new Int16Array(indices);

    /**
     * The normals data.
     * @property normals
     * @type {Array}
     */
    this.normals = new Float32Array(indices.length);

    /**
     * The local AABB of the mesh.
     * @property aabb
     * @type {Array}
     */
    this.aabb = new AABB();

    /**
     * References to vertex pairs, making up all unique edges in the trimesh.
     * @property {array} edges
     */
    this.edges = null;

    /**
     * Local scaling of the mesh. Use .setScale() to set it.
     * @property {Vec3} scale
     */
    this.scale = new Vec3(1, 1, 1);

    /**
     * The indexed triangles. Use .updateTree() to update it.
     * @property {Octree} tree
     */
    this.tree = new Octree();

    this.updateEdges();
    this.updateNormals();
    this.updateAABB();
    this.updateBoundingSphereRadius();
    this.updateTree();
}
Trimesh.prototype = new Shape();
Trimesh.prototype.constructor = Trimesh;

var computeNormals_n = new Vec3();

/**
 * @method updateTree
 */
Trimesh.prototype.updateTree = function(){
    var tree = this.tree;

    tree.reset();
    tree.aabb.copy(this.aabb);
    var scale = this.scale; // The local mesh AABB is scaled, but the octree AABB should be unscaled
    tree.aabb.lowerBound.x *= 1 / scale.x;
    tree.aabb.lowerBound.y *= 1 / scale.y;
    tree.aabb.lowerBound.z *= 1 / scale.z;
    tree.aabb.upperBound.x *= 1 / scale.x;
    tree.aabb.upperBound.y *= 1 / scale.y;
    tree.aabb.upperBound.z *= 1 / scale.z;

    // Insert all triangles
    var triangleAABB = new AABB();
    var a = new Vec3();
    var b = new Vec3();
    var c = new Vec3();
    var points = [a, b, c];
    for (var i = 0; i < this.indices.length / 3; i++) {
        //this.getTriangleVertices(i, a, b, c);

        // Get unscaled triangle verts
        var i3 = i * 3;
        this._getUnscaledVertex(this.indices[i3], a);
        this._getUnscaledVertex(this.indices[i3 + 1], b);
        this._getUnscaledVertex(this.indices[i3 + 2], c);

        triangleAABB.setFromPoints(points);
        tree.insert(triangleAABB, i);
    }
    tree.removeEmptyNodes();
};

var unscaledAABB = new AABB();

/**
 * Get triangles in a local AABB from the trimesh.
 * @method getTrianglesInAABB
 * @param  {AABB} aabb
 * @param  {array} result An array of integers, referencing the queried triangles.
 */
Trimesh.prototype.getTrianglesInAABB = function(aabb, result){
    unscaledAABB.copy(aabb);

    // Scale it to local
    var scale = this.scale;
    var isx = scale.x;
    var isy = scale.y;
    var isz = scale.z;
    var l = unscaledAABB.lowerBound;
    var u = unscaledAABB.upperBound;
    l.x /= isx;
    l.y /= isy;
    l.z /= isz;
    u.x /= isx;
    u.y /= isy;
    u.z /= isz;

    return this.tree.aabbQuery(unscaledAABB, result);
};

/**
 * @method setScale
 * @param {Vec3} scale
 */
Trimesh.prototype.setScale = function(scale){
    var wasUniform = this.scale.x === this.scale.y === this.scale.z;
    var isUniform = scale.x === scale.y === scale.z;

    if(!(wasUniform && isUniform)){
        // Non-uniform scaling. Need to update normals.
        this.updateNormals();
    }
    this.scale.copy(scale);
    this.updateAABB();
    this.updateBoundingSphereRadius();
};

/**
 * Compute the normals of the faces. Will save in the .normals array.
 * @method updateNormals
 */
Trimesh.prototype.updateNormals = function(){
    var n = computeNormals_n;

    // Generate normals
    var normals = this.normals;
    for(var i=0; i < this.indices.length / 3; i++){
        var i3 = i * 3;

        var a = this.indices[i3],
            b = this.indices[i3 + 1],
            c = this.indices[i3 + 2];

        this.getVertex(a, va);
        this.getVertex(b, vb);
        this.getVertex(c, vc);

        Trimesh.computeNormal(vb, va, vc, n);

        normals[i3] = n.x;
        normals[i3 + 1] = n.y;
        normals[i3 + 2] = n.z;
    }
};

/**
 * Update the .edges property
 * @method updateEdges
 */
Trimesh.prototype.updateEdges = function(){
    var edges = {};
    var add = function(indexA, indexB){
        var key = a < b ? a + '_' + b : b + '_' + a;
        edges[key] = true;
    };
    for(var i=0; i < this.indices.length / 3; i++){
        var i3 = i * 3;
        var a = this.indices[i3],
            b = this.indices[i3 + 1],
            c = this.indices[i3 + 2];
        add(a,b);
        add(b,c);
        add(c,a);
    }
    var keys = Object.keys(edges);
    this.edges = new Int16Array(keys.length * 2);
    for (var i = 0; i < keys.length; i++) {
        var indices = keys[i].split('_');
        this.edges[2 * i] = parseInt(indices[0], 10);
        this.edges[2 * i + 1] = parseInt(indices[1], 10);
    }
};

/**
 * Get an edge vertex
 * @method getEdgeVertex
 * @param  {number} edgeIndex
 * @param  {number} firstOrSecond 0 or 1, depending on which one of the vertices you need.
 * @param  {Vec3} vertexStore Where to store the result
 */
Trimesh.prototype.getEdgeVertex = function(edgeIndex, firstOrSecond, vertexStore){
    var vertexIndex = this.edges[edgeIndex * 2 + (firstOrSecond ? 1 : 0)];
    this.getVertex(vertexIndex, vertexStore);
};

var getEdgeVector_va = new Vec3();
var getEdgeVector_vb = new Vec3();

/**
 * Get a vector along an edge.
 * @method getEdgeVector
 * @param  {number} edgeIndex
 * @param  {Vec3} vectorStore
 */
Trimesh.prototype.getEdgeVector = function(edgeIndex, vectorStore){
    var va = getEdgeVector_va;
    var vb = getEdgeVector_vb;
    this.getEdgeVertex(edgeIndex, 0, va);
    this.getEdgeVertex(edgeIndex, 1, vb);
    vb.vsub(va, vectorStore);
};

/**
 * Get face normal given 3 vertices
 * @static
 * @method computeNormal
 * @param {Vec3} va
 * @param {Vec3} vb
 * @param {Vec3} vc
 * @param {Vec3} target
 */
var cb = new Vec3();
var ab = new Vec3();
Trimesh.computeNormal = function ( va, vb, vc, target ) {
    vb.vsub(va,ab);
    vc.vsub(vb,cb);
    cb.cross(ab,target);
    if ( !target.isZero() ) {
        target.normalize();
    }
};

var va = new Vec3();
var vb = new Vec3();
var vc = new Vec3();

/**
 * Get vertex i.
 * @method getVertex
 * @param  {number} i
 * @param  {Vec3} out
 * @return {Vec3} The "out" vector object
 */
Trimesh.prototype.getVertex = function(i, out){
    var scale = this.scale;
    this._getUnscaledVertex(i, out);
    out.x *= scale.x;
    out.y *= scale.y;
    out.z *= scale.z;
    return out;
};

/**
 * Get raw vertex i
 * @private
 * @method _getUnscaledVertex
 * @param  {number} i
 * @param  {Vec3} out
 * @return {Vec3} The "out" vector object
 */
Trimesh.prototype._getUnscaledVertex = function(i, out){
    var i3 = i * 3;
    var vertices = this.vertices;
    return out.set(
        vertices[i3],
        vertices[i3 + 1],
        vertices[i3 + 2]
    );
};

/**
 * Get a vertex from the trimesh,transformed by the given position and quaternion.
 * @method getWorldVertex
 * @param  {number} i
 * @param  {Vec3} pos
 * @param  {Quaternion} quat
 * @param  {Vec3} out
 * @return {Vec3} The "out" vector object
 */
Trimesh.prototype.getWorldVertex = function(i, pos, quat, out){
    this.getVertex(i, out);
    Transform.pointToWorldFrame(pos, quat, out, out);
    return out;
};

/**
 * Get the three vertices for triangle i.
 * @method getTriangleVertices
 * @param  {number} i
 * @param  {Vec3} a
 * @param  {Vec3} b
 * @param  {Vec3} c
 */
Trimesh.prototype.getTriangleVertices = function(i, a, b, c){
    var i3 = i * 3;
    this.getVertex(this.indices[i3], a);
    this.getVertex(this.indices[i3 + 1], b);
    this.getVertex(this.indices[i3 + 2], c);
};

/**
 * Compute the normal of triangle i.
 * @method getNormal
 * @param  {Number} i
 * @param  {Vec3} target
 * @return {Vec3} The "target" vector object
 */
Trimesh.prototype.getNormal = function(i, target){
    var i3 = i * 3;
    return target.set(
        this.normals[i3],
        this.normals[i3 + 1],
        this.normals[i3 + 2]
    );
};

var cli_aabb = new AABB();

/**
 * @method calculateLocalInertia
 * @param  {Number} mass
 * @param  {Vec3} target
 * @return {Vec3} The "target" vector object
 */
Trimesh.prototype.calculateLocalInertia = function(mass,target){
    // Approximate with box inertia
    // Exact inertia calculation is overkill, but see http://geometrictools.com/Documentation/PolyhedralMassProperties.pdf for the correct way to do it
    this.computeLocalAABB(cli_aabb);
    var x = cli_aabb.upperBound.x - cli_aabb.lowerBound.x,
        y = cli_aabb.upperBound.y - cli_aabb.lowerBound.y,
        z = cli_aabb.upperBound.z - cli_aabb.lowerBound.z;
    return target.set(
        1.0 / 12.0 * mass * ( 2*y*2*y + 2*z*2*z ),
        1.0 / 12.0 * mass * ( 2*x*2*x + 2*z*2*z ),
        1.0 / 12.0 * mass * ( 2*y*2*y + 2*x*2*x )
    );
};

var computeLocalAABB_worldVert = new Vec3();

/**
 * Compute the local AABB for the trimesh
 * @method computeLocalAABB
 * @param  {AABB} aabb
 */
Trimesh.prototype.computeLocalAABB = function(aabb){
    var l = aabb.lowerBound,
        u = aabb.upperBound,
        n = this.vertices.length,
        vertices = this.vertices,
        v = computeLocalAABB_worldVert;

    this.getVertex(0, v);
    l.copy(v);
    u.copy(v);

    for(var i=0; i !== n; i++){
        this.getVertex(i, v);

        if(v.x < l.x){
            l.x = v.x;
        } else if(v.x > u.x){
            u.x = v.x;
        }

        if(v.y < l.y){
            l.y = v.y;
        } else if(v.y > u.y){
            u.y = v.y;
        }

        if(v.z < l.z){
            l.z = v.z;
        } else if(v.z > u.z){
            u.z = v.z;
        }
    }
};


/**
 * Update the .aabb property
 * @method updateAABB
 */
Trimesh.prototype.updateAABB = function(){
    this.computeLocalAABB(this.aabb);
};

/**
 * Will update the .boundingSphereRadius property
 * @method updateBoundingSphereRadius
 */
Trimesh.prototype.updateBoundingSphereRadius = function(){
    // Assume points are distributed with local (0,0,0) as center
    var max2 = 0;
    var vertices = this.vertices;
    var v = new Vec3();
    for(var i=0, N=vertices.length / 3; i !== N; i++) {
        this.getVertex(i, v);
        var norm2 = v.norm2();
        if(norm2 > max2){
            max2 = norm2;
        }
    }
    this.boundingSphereRadius = Math.sqrt(max2);
};

var tempWorldVertex = new Vec3();
var calculateWorldAABB_frame = new Transform();
var calculateWorldAABB_aabb = new AABB();

/**
 * @method calculateWorldAABB
 * @param {Vec3}        pos
 * @param {Quaternion}  quat
 * @param {Vec3}        min
 * @param {Vec3}        max
 */
Trimesh.prototype.calculateWorldAABB = function(pos,quat,min,max){
    /*
    var n = this.vertices.length / 3,
        verts = this.vertices;
    var minx,miny,minz,maxx,maxy,maxz;

    var v = tempWorldVertex;
    for(var i=0; i<n; i++){
        this.getVertex(i, v);
        quat.vmult(v, v);
        pos.vadd(v, v);
        if (v.x < minx || minx===undefined){
            minx = v.x;
        } else if(v.x > maxx || maxx===undefined){
            maxx = v.x;
        }

        if (v.y < miny || miny===undefined){
            miny = v.y;
        } else if(v.y > maxy || maxy===undefined){
            maxy = v.y;
        }

        if (v.z < minz || minz===undefined){
            minz = v.z;
        } else if(v.z > maxz || maxz===undefined){
            maxz = v.z;
        }
    }
    min.set(minx,miny,minz);
    max.set(maxx,maxy,maxz);
    */

    // Faster approximation using local AABB
    var frame = calculateWorldAABB_frame;
    var result = calculateWorldAABB_aabb;
    frame.position = pos;
    frame.quaternion = quat;
    this.aabb.toWorldFrame(frame, result);
    min.copy(result.lowerBound);
    max.copy(result.upperBound);
};

/**
 * Get approximate volume
 * @method volume
 * @return {Number}
 */
Trimesh.prototype.volume = function(){
    return 4.0 * Math.PI * this.boundingSphereRadius / 3.0;
};

/**
 * Create a Trimesh instance, shaped as a torus.
 * @static
 * @method createTorus
 * @param  {number} [radius=1]
 * @param  {number} [tube=0.5]
 * @param  {number} [radialSegments=8]
 * @param  {number} [tubularSegments=6]
 * @param  {number} [arc=6.283185307179586]
 * @return {Trimesh} A torus
 */
Trimesh.createTorus = function (radius, tube, radialSegments, tubularSegments, arc) {
    radius = radius || 1;
    tube = tube || 0.5;
    radialSegments = radialSegments || 8;
    tubularSegments = tubularSegments || 6;
    arc = arc || Math.PI * 2;

    var vertices = [];
    var indices = [];

    for ( var j = 0; j <= radialSegments; j ++ ) {
        for ( var i = 0; i <= tubularSegments; i ++ ) {
            var u = i / tubularSegments * arc;
            var v = j / radialSegments * Math.PI * 2;

            var x = ( radius + tube * Math.cos( v ) ) * Math.cos( u );
            var y = ( radius + tube * Math.cos( v ) ) * Math.sin( u );
            var z = tube * Math.sin( v );

            vertices.push( x, y, z );
        }
    }

    for ( var j = 1; j <= radialSegments; j ++ ) {
        for ( var i = 1; i <= tubularSegments; i ++ ) {
            var a = ( tubularSegments + 1 ) * j + i - 1;
            var b = ( tubularSegments + 1 ) * ( j - 1 ) + i - 1;
            var c = ( tubularSegments + 1 ) * ( j - 1 ) + i;
            var d = ( tubularSegments + 1 ) * j + i;

            indices.push(a, b, d);
            indices.push(b, c, d);
        }
    }

    return new Trimesh(vertices, indices);
};


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = SplitSolver;

var Vec3 = __webpack_require__(0);
var Quaternion = __webpack_require__(13);
var Solver = __webpack_require__(74);
var Body = __webpack_require__(33);

/**
 * Splits the equations into islands and solves them independently. Can improve performance.
 * @class SplitSolver
 * @constructor
 * @extends Solver
 * @param {Solver} subsolver
 */
function SplitSolver(subsolver){
    Solver.call(this);
    this.iterations = 10;
    this.tolerance = 1e-7;
    this.subsolver = subsolver;
    this.nodes = [];
    this.nodePool = [];

    // Create needed nodes, reuse if possible
    while(this.nodePool.length < 128){
        this.nodePool.push(this.createNode());
    }
}
SplitSolver.prototype = new Solver();

// Returns the number of subsystems
var SplitSolver_solve_nodes = []; // All allocated node objects
var SplitSolver_solve_nodePool = []; // All allocated node objects
var SplitSolver_solve_eqs = [];   // Temp array
var SplitSolver_solve_bds = [];   // Temp array
var SplitSolver_solve_dummyWorld = {bodies:[]}; // Temp object

var STATIC = Body.STATIC;
function getUnvisitedNode(nodes){
    var Nnodes = nodes.length;
    for(var i=0; i!==Nnodes; i++){
        var node = nodes[i];
        if(!node.visited && !(node.body.type & STATIC)){
            return node;
        }
    }
    return false;
}

var queue = [];
function bfs(root,visitFunc,bds,eqs){
    queue.push(root);
    root.visited = true;
    visitFunc(root,bds,eqs);
    while(queue.length) {
        var node = queue.pop();
        // Loop over unvisited child nodes
        var child;
        while((child = getUnvisitedNode(node.children))) {
            child.visited = true;
            visitFunc(child,bds,eqs);
            queue.push(child);
        }
    }
}

function visitFunc(node,bds,eqs){
    bds.push(node.body);
    var Neqs = node.eqs.length;
    for(var i=0; i!==Neqs; i++){
        var eq = node.eqs[i];
        if(eqs.indexOf(eq) === -1){
            eqs.push(eq);
        }
    }
}

SplitSolver.prototype.createNode = function(){
    return { body:null, children:[], eqs:[], visited:false };
};

/**
 * Solve the subsystems
 * @method solve
 * @param  {Number} dt
 * @param  {World} world
 */
SplitSolver.prototype.solve = function(dt,world){
    var nodes=SplitSolver_solve_nodes,
        nodePool=this.nodePool,
        bodies=world.bodies,
        equations=this.equations,
        Neq=equations.length,
        Nbodies=bodies.length,
        subsolver=this.subsolver;

    // Create needed nodes, reuse if possible
    while(nodePool.length < Nbodies){
        nodePool.push(this.createNode());
    }
    nodes.length = Nbodies;
    for (var i = 0; i < Nbodies; i++) {
        nodes[i] = nodePool[i];
    }

    // Reset node values
    for(var i=0; i!==Nbodies; i++){
        var node = nodes[i];
        node.body = bodies[i];
        node.children.length = 0;
        node.eqs.length = 0;
        node.visited = false;
    }
    for(var k=0; k!==Neq; k++){
        var eq=equations[k],
            i=bodies.indexOf(eq.bi),
            j=bodies.indexOf(eq.bj),
            ni=nodes[i],
            nj=nodes[j];
        ni.children.push(nj);
        ni.eqs.push(eq);
        nj.children.push(ni);
        nj.eqs.push(eq);
    }

    var child, n=0, eqs=SplitSolver_solve_eqs;

    subsolver.tolerance = this.tolerance;
    subsolver.iterations = this.iterations;

    var dummyWorld = SplitSolver_solve_dummyWorld;
    while((child = getUnvisitedNode(nodes))){
        eqs.length = 0;
        dummyWorld.bodies.length = 0;
        bfs(child, visitFunc, dummyWorld.bodies, eqs);

        var Neqs = eqs.length;

        eqs = eqs.sort(sortById);

        for(var i=0; i!==Neqs; i++){
            subsolver.addEquation(eqs[i]);
        }

        var iter = subsolver.solve(dt,dummyWorld);
        subsolver.removeAllEquations();
        n++;
    }

    return n;
};

function sortById(a, b){
    return b.id - a.id;
}

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var AABB = __webpack_require__(30);
var Vec3 = __webpack_require__(0);

module.exports = Octree;

/**
 * @class OctreeNode
 * @param {object} [options]
 * @param {Octree} [options.root]
 * @param {AABB} [options.aabb]
 */
function OctreeNode(options){
    options = options || {};

    /**
     * The root node
     * @property {OctreeNode} root
     */
    this.root = options.root || null;

    /**
     * Boundary of this node
     * @property {AABB} aabb
     */
    this.aabb = options.aabb ? options.aabb.clone() : new AABB();

    /**
     * Contained data at the current node level.
     * @property {Array} data
     */
    this.data = [];

    /**
     * Children to this node
     * @property {Array} children
     */
    this.children = [];
}

/**
 * @class Octree
 * @param {AABB} aabb The total AABB of the tree
 * @param {object} [options]
 * @param {number} [options.maxDepth=8]
 * @extends OctreeNode
 */
function Octree(aabb, options){
    options = options || {};
    options.root = null;
    options.aabb = aabb;
    OctreeNode.call(this, options);

    /**
     * Maximum subdivision depth
     * @property {number} maxDepth
     */
    this.maxDepth = typeof(options.maxDepth) !== 'undefined' ? options.maxDepth : 8;
}
Octree.prototype = new OctreeNode();

OctreeNode.prototype.reset = function(aabb, options){
    this.children.length = this.data.length = 0;
};

/**
 * Insert data into this node
 * @method insert
 * @param  {AABB} aabb
 * @param  {object} elementData
 * @return {boolean} True if successful, otherwise false
 */
OctreeNode.prototype.insert = function(aabb, elementData, level){
    var nodeData = this.data;
    level = level || 0;

    // Ignore objects that do not belong in this node
    if (!this.aabb.contains(aabb)){
        return false; // object cannot be added
    }

    var children = this.children;

    if(level < (this.maxDepth || this.root.maxDepth)){
        // Subdivide if there are no children yet
        var subdivided = false;
        if (!children.length){
            this.subdivide();
            subdivided = true;
        }

        // add to whichever node will accept it
        for (var i = 0; i !== 8; i++) {
            if (children[i].insert(aabb, elementData, level + 1)){
                return true;
            }
        }

        if(subdivided){
            // No children accepted! Might as well just remove em since they contain none
            children.length = 0;
        }
    }

    // Too deep, or children didnt want it. add it in current node
    nodeData.push(elementData);

    return true;
};

var halfDiagonal = new Vec3();

/**
 * Create 8 equally sized children nodes and put them in the .children array.
 * @method subdivide
 */
OctreeNode.prototype.subdivide = function() {
    var aabb = this.aabb;
    var l = aabb.lowerBound;
    var u = aabb.upperBound;

    var children = this.children;

    children.push(
        new OctreeNode({ aabb: new AABB({ lowerBound: new Vec3(0,0,0) }) }),
        new OctreeNode({ aabb: new AABB({ lowerBound: new Vec3(1,0,0) }) }),
        new OctreeNode({ aabb: new AABB({ lowerBound: new Vec3(1,1,0) }) }),
        new OctreeNode({ aabb: new AABB({ lowerBound: new Vec3(1,1,1) }) }),
        new OctreeNode({ aabb: new AABB({ lowerBound: new Vec3(0,1,1) }) }),
        new OctreeNode({ aabb: new AABB({ lowerBound: new Vec3(0,0,1) }) }),
        new OctreeNode({ aabb: new AABB({ lowerBound: new Vec3(1,0,1) }) }),
        new OctreeNode({ aabb: new AABB({ lowerBound: new Vec3(0,1,0) }) })
    );

    u.vsub(l, halfDiagonal);
    halfDiagonal.scale(0.5, halfDiagonal);

    var root = this.root || this;

    for (var i = 0; i !== 8; i++) {
        var child = children[i];

        // Set current node as root
        child.root = root;

        // Compute bounds
        var lowerBound = child.aabb.lowerBound;
        lowerBound.x *= halfDiagonal.x;
        lowerBound.y *= halfDiagonal.y;
        lowerBound.z *= halfDiagonal.z;

        lowerBound.vadd(l, lowerBound);

        // Upper bound is always lower bound + halfDiagonal
        lowerBound.vadd(halfDiagonal, child.aabb.upperBound);
    }
};

/**
 * Get all data, potentially within an AABB
 * @method aabbQuery
 * @param  {AABB} aabb
 * @param  {array} result
 * @return {array} The "result" object
 */
OctreeNode.prototype.aabbQuery = function(aabb, result) {

    var nodeData = this.data;

    // abort if the range does not intersect this node
    // if (!this.aabb.overlaps(aabb)){
    //     return result;
    // }

    // Add objects at this level
    // Array.prototype.push.apply(result, nodeData);

    // Add child data
    // @todo unwrap recursion into a queue / loop, that's faster in JS
    var children = this.children;


    // for (var i = 0, N = this.children.length; i !== N; i++) {
    //     children[i].aabbQuery(aabb, result);
    // }

    var queue = [this];
    while (queue.length) {
        var node = queue.pop();
        if (node.aabb.overlaps(aabb)){
            Array.prototype.push.apply(result, node.data);
        }
        Array.prototype.push.apply(queue, node.children);
    }

    return result;
};

var tmpAABB = new AABB();

/**
 * Get all data, potentially intersected by a ray.
 * @method rayQuery
 * @param  {Ray} ray
 * @param  {Transform} treeTransform
 * @param  {array} result
 * @return {array} The "result" object
 */
OctreeNode.prototype.rayQuery = function(ray, treeTransform, result) {

    // Use aabb query for now.
    // @todo implement real ray query which needs less lookups
    ray.getAABB(tmpAABB);
    tmpAABB.toLocalFrame(treeTransform, tmpAABB);
    this.aabbQuery(tmpAABB, result);

    return result;
};

/**
 * @method removeEmptyNodes
 */
OctreeNode.prototype.removeEmptyNodes = function() {
    var queue = [this];
    while (queue.length) {
        var node = queue.pop();
        for (var i = node.children.length - 1; i >= 0; i--) {
            if(!node.children[i].data.length){
                node.children.splice(i, 1);
            }
        }
        Array.prototype.push.apply(queue, node.children);
    }
};


/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports = TupleDictionary;

/**
 * @class TupleDictionary
 * @constructor
 */
function TupleDictionary() {

    /**
     * The data storage
     * @property data
     * @type {Object}
     */
    this.data = { keys:[] };
}

/**
 * @method get
 * @param  {Number} i
 * @param  {Number} j
 * @return {Number}
 */
TupleDictionary.prototype.get = function(i, j) {
    if (i > j) {
        // swap
        var temp = j;
        j = i;
        i = temp;
    }
    return this.data[i+'-'+j];
};

/**
 * @method set
 * @param  {Number} i
 * @param  {Number} j
 * @param {Number} value
 */
TupleDictionary.prototype.set = function(i, j, value) {
    if (i > j) {
        var temp = j;
        j = i;
        i = temp;
    }
    var key = i+'-'+j;

    // Check if key already exists
    if(!this.get(i,j)){
        this.data.keys.push(key);
    }

    this.data[key] = value;
};

/**
 * @method reset
 */
TupleDictionary.prototype.reset = function() {
    var data = this.data,
        keys = data.keys;
    while(keys.length > 0){
        var key = keys.pop();
        delete data[key];
    }
};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

/* global performance */

module.exports = World;

var Shape = __webpack_require__(12);
var Vec3 = __webpack_require__(0);
var Quaternion = __webpack_require__(13);
var GSSolver = __webpack_require__(149);
var ContactEquation = __webpack_require__(31);
var FrictionEquation = __webpack_require__(99);
var Narrowphase = __webpack_require__(152);
var EventTarget = __webpack_require__(101);
var ArrayCollisionMatrix = __webpack_require__(142);
var OverlapKeeper = __webpack_require__(336);
var Material = __webpack_require__(59);
var ContactMaterial = __webpack_require__(145);
var Body = __webpack_require__(33);
var TupleDictionary = __webpack_require__(353);
var RaycastResult = __webpack_require__(58);
var AABB = __webpack_require__(30);
var Ray = __webpack_require__(70);
var NaiveBroadphase = __webpack_require__(143);

/**
 * The physics world
 * @class World
 * @constructor
 * @extends EventTarget
 * @param {object} [options]
 * @param {Vec3} [options.gravity]
 * @param {boolean} [options.allowSleep]
 * @param {Broadphase} [options.broadphase]
 * @param {Solver} [options.solver]
 * @param {boolean} [options.quatNormalizeFast]
 * @param {number} [options.quatNormalizeSkip]
 */
function World(options){
    options = options || {};
    EventTarget.apply(this);

    /**
     * Currently / last used timestep. Is set to -1 if not available. This value is updated before each internal step, which means that it is "fresh" inside event callbacks.
     * @property {Number} dt
     */
    this.dt = -1;

    /**
     * Makes bodies go to sleep when they've been inactive
     * @property allowSleep
     * @type {Boolean}
     * @default false
     */
    this.allowSleep = !!options.allowSleep;

    /**
     * All the current contacts (instances of ContactEquation) in the world.
     * @property contacts
     * @type {Array}
     */
    this.contacts = [];
    this.frictionEquations = [];

    /**
     * How often to normalize quaternions. Set to 0 for every step, 1 for every second etc.. A larger value increases performance. If bodies tend to explode, set to a smaller value (zero to be sure nothing can go wrong).
     * @property quatNormalizeSkip
     * @type {Number}
     * @default 0
     */
    this.quatNormalizeSkip = options.quatNormalizeSkip !== undefined ? options.quatNormalizeSkip : 0;

    /**
     * Set to true to use fast quaternion normalization. It is often enough accurate to use. If bodies tend to explode, set to false.
     * @property quatNormalizeFast
     * @type {Boolean}
     * @see Quaternion.normalizeFast
     * @see Quaternion.normalize
     * @default false
     */
    this.quatNormalizeFast = options.quatNormalizeFast !== undefined ? options.quatNormalizeFast : false;

    /**
     * The wall-clock time since simulation start
     * @property time
     * @type {Number}
     */
    this.time = 0.0;

    /**
     * Number of timesteps taken since start
     * @property stepnumber
     * @type {Number}
     */
    this.stepnumber = 0;

    /// Default and last timestep sizes
    this.default_dt = 1/60;

    this.nextId = 0;
    /**
     * @property gravity
     * @type {Vec3}
     */
    this.gravity = new Vec3();
    if(options.gravity){
        this.gravity.copy(options.gravity);
    }

    /**
     * The broadphase algorithm to use. Default is NaiveBroadphase
     * @property broadphase
     * @type {Broadphase}
     */
    this.broadphase = options.broadphase !== undefined ? options.broadphase : new NaiveBroadphase();

    /**
     * @property bodies
     * @type {Array}
     */
    this.bodies = [];

    /**
     * The solver algorithm to use. Default is GSSolver
     * @property solver
     * @type {Solver}
     */
    this.solver = options.solver !== undefined ? options.solver : new GSSolver();

    /**
     * @property constraints
     * @type {Array}
     */
    this.constraints = [];

    /**
     * @property narrowphase
     * @type {Narrowphase}
     */
    this.narrowphase = new Narrowphase(this);

    /**
     * @property {ArrayCollisionMatrix} collisionMatrix
	 * @type {ArrayCollisionMatrix}
	 */
	this.collisionMatrix = new ArrayCollisionMatrix();

    /**
     * CollisionMatrix from the previous step.
     * @property {ArrayCollisionMatrix} collisionMatrixPrevious
	 * @type {ArrayCollisionMatrix}
	 */
	this.collisionMatrixPrevious = new ArrayCollisionMatrix();

    this.bodyOverlapKeeper = new OverlapKeeper();
    this.shapeOverlapKeeper = new OverlapKeeper();

    /**
     * All added materials
     * @property materials
     * @type {Array}
     */
    this.materials = [];

    /**
     * @property contactmaterials
     * @type {Array}
     */
    this.contactmaterials = [];

    /**
     * Used to look up a ContactMaterial given two instances of Material.
     * @property {TupleDictionary} contactMaterialTable
     */
    this.contactMaterialTable = new TupleDictionary();

    this.defaultMaterial = new Material("default");

    /**
     * This contact material is used if no suitable contactmaterial is found for a contact.
     * @property defaultContactMaterial
     * @type {ContactMaterial}
     */
    this.defaultContactMaterial = new ContactMaterial(this.defaultMaterial, this.defaultMaterial, { friction: 0.3, restitution: 0.0 });

    /**
     * @property doProfiling
     * @type {Boolean}
     */
    this.doProfiling = false;

    /**
     * @property profile
     * @type {Object}
     */
    this.profile = {
        solve:0,
        makeContactConstraints:0,
        broadphase:0,
        integrate:0,
        narrowphase:0,
    };

    /**
     * Time accumulator for interpolation. See http://gafferongames.com/game-physics/fix-your-timestep/
     * @property {Number} accumulator
     */
    this.accumulator = 0;

    /**
     * @property subsystems
     * @type {Array}
     */
    this.subsystems = [];

    /**
     * Dispatched after a body has been added to the world.
     * @event addBody
     * @param {Body} body The body that has been added to the world.
     */
    this.addBodyEvent = {
        type:"addBody",
        body : null
    };

    /**
     * Dispatched after a body has been removed from the world.
     * @event removeBody
     * @param {Body} body The body that has been removed from the world.
     */
    this.removeBodyEvent = {
        type:"removeBody",
        body : null
    };

    this.idToBodyMap = {};

    this.broadphase.setWorld(this);
}
World.prototype = new EventTarget();

// Temp stuff
var tmpAABB1 = new AABB();
var tmpArray1 = [];
var tmpRay = new Ray();

/**
 * Get the contact material between materials m1 and m2
 * @method getContactMaterial
 * @param {Material} m1
 * @param {Material} m2
 * @return {ContactMaterial} The contact material if it was found.
 */
World.prototype.getContactMaterial = function(m1,m2){
    return this.contactMaterialTable.get(m1.id,m2.id); //this.contactmaterials[this.mats2cmat[i+j*this.materials.length]];
};

/**
 * Get number of objects in the world.
 * @method numObjects
 * @return {Number}
 * @deprecated
 */
World.prototype.numObjects = function(){
    return this.bodies.length;
};

/**
 * Store old collision state info
 * @method collisionMatrixTick
 */
World.prototype.collisionMatrixTick = function(){
	var temp = this.collisionMatrixPrevious;
	this.collisionMatrixPrevious = this.collisionMatrix;
	this.collisionMatrix = temp;
	this.collisionMatrix.reset();

    this.bodyOverlapKeeper.tick();
    this.shapeOverlapKeeper.tick();
};

/**
 * Add a rigid body to the simulation.
 * @method add
 * @param {Body} body
 * @todo If the simulation has not yet started, why recrete and copy arrays for each body? Accumulate in dynamic arrays in this case.
 * @todo Adding an array of bodies should be possible. This would save some loops too
 * @deprecated Use .addBody instead
 */
World.prototype.add = World.prototype.addBody = function(body){
    if(this.bodies.indexOf(body) !== -1){
        return;
    }
    body.index = this.bodies.length;
    this.bodies.push(body);
    body.world = this;
    body.initPosition.copy(body.position);
    body.initVelocity.copy(body.velocity);
    body.timeLastSleepy = this.time;
    if(body instanceof Body){
        body.initAngularVelocity.copy(body.angularVelocity);
        body.initQuaternion.copy(body.quaternion);
    }
	this.collisionMatrix.setNumObjects(this.bodies.length);
    this.addBodyEvent.body = body;
    this.idToBodyMap[body.id] = body;
    this.dispatchEvent(this.addBodyEvent);
};

/**
 * Add a constraint to the simulation.
 * @method addConstraint
 * @param {Constraint} c
 */
World.prototype.addConstraint = function(c){
    this.constraints.push(c);
};

/**
 * Removes a constraint
 * @method removeConstraint
 * @param {Constraint} c
 */
World.prototype.removeConstraint = function(c){
    var idx = this.constraints.indexOf(c);
    if(idx!==-1){
        this.constraints.splice(idx,1);
    }
};

/**
 * Raycast test
 * @method rayTest
 * @param {Vec3} from
 * @param {Vec3} to
 * @param {RaycastResult} result
 * @deprecated Use .raycastAll, .raycastClosest or .raycastAny instead.
 */
World.prototype.rayTest = function(from, to, result){
    if(result instanceof RaycastResult){
        // Do raycastclosest
        this.raycastClosest(from, to, {
            skipBackfaces: true
        }, result);
    } else {
        // Do raycastAll
        this.raycastAll(from, to, {
            skipBackfaces: true
        }, result);
    }
};

/**
 * Ray cast against all bodies. The provided callback will be executed for each hit with a RaycastResult as single argument.
 * @method raycastAll
 * @param  {Vec3} from
 * @param  {Vec3} to
 * @param  {Object} options
 * @param  {number} [options.collisionFilterMask=-1]
 * @param  {number} [options.collisionFilterGroup=-1]
 * @param  {boolean} [options.skipBackfaces=false]
 * @param  {boolean} [options.checkCollisionResponse=true]
 * @param  {Function} callback
 * @return {boolean} True if any body was hit.
 */
World.prototype.raycastAll = function(from, to, options, callback){
    options.mode = Ray.ALL;
    options.from = from;
    options.to = to;
    options.callback = callback;
    return tmpRay.intersectWorld(this, options);
};

/**
 * Ray cast, and stop at the first result. Note that the order is random - but the method is fast.
 * @method raycastAny
 * @param  {Vec3} from
 * @param  {Vec3} to
 * @param  {Object} options
 * @param  {number} [options.collisionFilterMask=-1]
 * @param  {number} [options.collisionFilterGroup=-1]
 * @param  {boolean} [options.skipBackfaces=false]
 * @param  {boolean} [options.checkCollisionResponse=true]
 * @param  {RaycastResult} result
 * @return {boolean} True if any body was hit.
 */
World.prototype.raycastAny = function(from, to, options, result){
    options.mode = Ray.ANY;
    options.from = from;
    options.to = to;
    options.result = result;
    return tmpRay.intersectWorld(this, options);
};

/**
 * Ray cast, and return information of the closest hit.
 * @method raycastClosest
 * @param  {Vec3} from
 * @param  {Vec3} to
 * @param  {Object} options
 * @param  {number} [options.collisionFilterMask=-1]
 * @param  {number} [options.collisionFilterGroup=-1]
 * @param  {boolean} [options.skipBackfaces=false]
 * @param  {boolean} [options.checkCollisionResponse=true]
 * @param  {RaycastResult} result
 * @return {boolean} True if any body was hit.
 */
World.prototype.raycastClosest = function(from, to, options, result){
    options.mode = Ray.CLOSEST;
    options.from = from;
    options.to = to;
    options.result = result;
    return tmpRay.intersectWorld(this, options);
};

/**
 * Remove a rigid body from the simulation.
 * @method remove
 * @param {Body} body
 * @deprecated Use .removeBody instead
 */
World.prototype.remove = function(body){
    body.world = null;
    var n = this.bodies.length - 1,
        bodies = this.bodies,
        idx = bodies.indexOf(body);
    if(idx !== -1){
        bodies.splice(idx, 1); // Todo: should use a garbage free method

        // Recompute index
        for(var i=0; i!==bodies.length; i++){
            bodies[i].index = i;
        }

        this.collisionMatrix.setNumObjects(n);
        this.removeBodyEvent.body = body;
        delete this.idToBodyMap[body.id];
        this.dispatchEvent(this.removeBodyEvent);
    }
};

/**
 * Remove a rigid body from the simulation.
 * @method removeBody
 * @param {Body} body
 */
World.prototype.removeBody = World.prototype.remove;

World.prototype.getBodyById = function(id){
    return this.idToBodyMap[id];
};

// TODO Make a faster map
World.prototype.getShapeById = function(id){
    var bodies = this.bodies;
    for(var i=0, bl = bodies.length; i<bl; i++){
        var shapes = bodies[i].shapes;
        for (var j = 0, sl = shapes.length; j < sl; j++) {
            var shape = shapes[j];
            if(shape.id === id){
                return shape;
            }
        }
    }
};

/**
 * Adds a material to the World.
 * @method addMaterial
 * @param {Material} m
 * @todo Necessary?
 */
World.prototype.addMaterial = function(m){
    this.materials.push(m);
};

/**
 * Adds a contact material to the World
 * @method addContactMaterial
 * @param {ContactMaterial} cmat
 */
World.prototype.addContactMaterial = function(cmat) {

    // Add contact material
    this.contactmaterials.push(cmat);

    // Add current contact material to the material table
    this.contactMaterialTable.set(cmat.materials[0].id,cmat.materials[1].id,cmat);
};

// performance.now()
if(typeof performance === 'undefined'){
    performance = {};
}
if(!performance.now){
    var nowOffset = Date.now();
    if (performance.timing && performance.timing.navigationStart){
        nowOffset = performance.timing.navigationStart;
    }
    performance.now = function(){
        return Date.now() - nowOffset;
    };
}

var step_tmp1 = new Vec3();

/**
 * Step the physics world forward in time.
 *
 * There are two modes. The simple mode is fixed timestepping without interpolation. In this case you only use the first argument. The second case uses interpolation. In that you also provide the time since the function was last used, as well as the maximum fixed timesteps to take.
 *
 * @method step
 * @param {Number} dt                       The fixed time step size to use.
 * @param {Number} [timeSinceLastCalled]    The time elapsed since the function was last called.
 * @param {Number} [maxSubSteps=10]         Maximum number of fixed steps to take per function call.
 *
 * @example
 *     // fixed timestepping without interpolation
 *     world.step(1/60);
 *
 * @see http://bulletphysics.org/mediawiki-1.5.8/index.php/Stepping_The_World
 */
World.prototype.step = function(dt, timeSinceLastCalled, maxSubSteps){
    maxSubSteps = maxSubSteps || 10;
    timeSinceLastCalled = timeSinceLastCalled || 0;

    if(timeSinceLastCalled === 0){ // Fixed, simple stepping

        this.internalStep(dt);

        // Increment time
        this.time += dt;

    } else {

        this.accumulator += timeSinceLastCalled;
        var substeps = 0;
        while (this.accumulator >= dt && substeps < maxSubSteps) {
            // Do fixed steps to catch up
            this.internalStep(dt);
            this.accumulator -= dt;
            substeps++;
        }

        var t = (this.accumulator % dt) / dt;
        for(var j=0; j !== this.bodies.length; j++){
            var b = this.bodies[j];
            b.previousPosition.lerp(b.position, t, b.interpolatedPosition);
            b.previousQuaternion.slerp(b.quaternion, t, b.interpolatedQuaternion);
            b.previousQuaternion.normalize();
        }
        this.time += timeSinceLastCalled;
    }
};

var
    /**
     * Dispatched after the world has stepped forward in time.
     * @event postStep
     */
    World_step_postStepEvent = {type:"postStep"}, // Reusable event objects to save memory
    /**
     * Dispatched before the world steps forward in time.
     * @event preStep
     */
    World_step_preStepEvent = {type:"preStep"},
    World_step_collideEvent = {type:Body.COLLIDE_EVENT_NAME, body:null, contact:null },
    World_step_oldContacts = [], // Pools for unused objects
    World_step_frictionEquationPool = [],
    World_step_p1 = [], // Reusable arrays for collision pairs
    World_step_p2 = [],
    World_step_gvec = new Vec3(), // Temporary vectors and quats
    World_step_vi = new Vec3(),
    World_step_vj = new Vec3(),
    World_step_wi = new Vec3(),
    World_step_wj = new Vec3(),
    World_step_t1 = new Vec3(),
    World_step_t2 = new Vec3(),
    World_step_rixn = new Vec3(),
    World_step_rjxn = new Vec3(),
    World_step_step_q = new Quaternion(),
    World_step_step_w = new Quaternion(),
    World_step_step_wq = new Quaternion(),
    invI_tau_dt = new Vec3();
World.prototype.internalStep = function(dt){
    this.dt = dt;

    var world = this,
        that = this,
        contacts = this.contacts,
        p1 = World_step_p1,
        p2 = World_step_p2,
        N = this.numObjects(),
        bodies = this.bodies,
        solver = this.solver,
        gravity = this.gravity,
        doProfiling = this.doProfiling,
        profile = this.profile,
        DYNAMIC = Body.DYNAMIC,
        profilingStart,
        constraints = this.constraints,
        frictionEquationPool = World_step_frictionEquationPool,
        gnorm = gravity.norm(),
        gx = gravity.x,
        gy = gravity.y,
        gz = gravity.z,
        i=0;

    if(doProfiling){
        profilingStart = performance.now();
    }

    // Add gravity to all objects
    for(i=0; i!==N; i++){
        var bi = bodies[i];
        if(bi.type === DYNAMIC){ // Only for dynamic bodies
            var f = bi.force, m = bi.mass;
            f.x += m*gx;
            f.y += m*gy;
            f.z += m*gz;
        }
    }

    // Update subsystems
    for(var i=0, Nsubsystems=this.subsystems.length; i!==Nsubsystems; i++){
        this.subsystems[i].update();
    }

    // Collision detection
    if(doProfiling){ profilingStart = performance.now(); }
    p1.length = 0; // Clean up pair arrays from last step
    p2.length = 0;
    this.broadphase.collisionPairs(this,p1,p2);
    if(doProfiling){ profile.broadphase = performance.now() - profilingStart; }

    // Remove constrained pairs with collideConnected == false
    var Nconstraints = constraints.length;
    for(i=0; i!==Nconstraints; i++){
        var c = constraints[i];
        if(!c.collideConnected){
            for(var j = p1.length-1; j>=0; j-=1){
                if( (c.bodyA === p1[j] && c.bodyB === p2[j]) ||
                    (c.bodyB === p1[j] && c.bodyA === p2[j])){
                    p1.splice(j, 1);
                    p2.splice(j, 1);
                }
            }
        }
    }

    this.collisionMatrixTick();

    // Generate contacts
    if(doProfiling){ profilingStart = performance.now(); }
    var oldcontacts = World_step_oldContacts;
    var NoldContacts = contacts.length;

    for(i=0; i!==NoldContacts; i++){
        oldcontacts.push(contacts[i]);
    }
    contacts.length = 0;

    // Transfer FrictionEquation from current list to the pool for reuse
    var NoldFrictionEquations = this.frictionEquations.length;
    for(i=0; i!==NoldFrictionEquations; i++){
        frictionEquationPool.push(this.frictionEquations[i]);
    }
    this.frictionEquations.length = 0;

    this.narrowphase.getContacts(
        p1,
        p2,
        this,
        contacts,
        oldcontacts, // To be reused
        this.frictionEquations,
        frictionEquationPool
    );

    if(doProfiling){
        profile.narrowphase = performance.now() - profilingStart;
    }

    // Loop over all collisions
    if(doProfiling){
        profilingStart = performance.now();
    }

    // Add all friction eqs
    for (var i = 0; i < this.frictionEquations.length; i++) {
        solver.addEquation(this.frictionEquations[i]);
    }

    var ncontacts = contacts.length;
    for(var k=0; k!==ncontacts; k++){

        // Current contact
        var c = contacts[k];

        // Get current collision indeces
        var bi = c.bi,
            bj = c.bj,
            si = c.si,
            sj = c.sj;

        // Get collision properties
        var cm;
        if(bi.material && bj.material){
            cm = this.getContactMaterial(bi.material,bj.material) || this.defaultContactMaterial;
        } else {
            cm = this.defaultContactMaterial;
        }

        // c.enabled = bi.collisionResponse && bj.collisionResponse && si.collisionResponse && sj.collisionResponse;

        var mu = cm.friction;
        // c.restitution = cm.restitution;

        // If friction or restitution were specified in the material, use them
        if(bi.material && bj.material){
            if(bi.material.friction >= 0 && bj.material.friction >= 0){
                mu = bi.material.friction * bj.material.friction;
            }

            if(bi.material.restitution >= 0 && bj.material.restitution >= 0){
                c.restitution = bi.material.restitution * bj.material.restitution;
            }
        }

		// c.setSpookParams(
  //           cm.contactEquationStiffness,
  //           cm.contactEquationRelaxation,
  //           dt
  //       );

		solver.addEquation(c);

		// // Add friction constraint equation
		// if(mu > 0){

		// 	// Create 2 tangent equations
		// 	var mug = mu * gnorm;
		// 	var reducedMass = (bi.invMass + bj.invMass);
		// 	if(reducedMass > 0){
		// 		reducedMass = 1/reducedMass;
		// 	}
		// 	var pool = frictionEquationPool;
		// 	var c1 = pool.length ? pool.pop() : new FrictionEquation(bi,bj,mug*reducedMass);
		// 	var c2 = pool.length ? pool.pop() : new FrictionEquation(bi,bj,mug*reducedMass);
		// 	this.frictionEquations.push(c1, c2);

		// 	c1.bi = c2.bi = bi;
		// 	c1.bj = c2.bj = bj;
		// 	c1.minForce = c2.minForce = -mug*reducedMass;
		// 	c1.maxForce = c2.maxForce = mug*reducedMass;

		// 	// Copy over the relative vectors
		// 	c1.ri.copy(c.ri);
		// 	c1.rj.copy(c.rj);
		// 	c2.ri.copy(c.ri);
		// 	c2.rj.copy(c.rj);

		// 	// Construct tangents
		// 	c.ni.tangents(c1.t, c2.t);

  //           // Set spook params
  //           c1.setSpookParams(cm.frictionEquationStiffness, cm.frictionEquationRelaxation, dt);
  //           c2.setSpookParams(cm.frictionEquationStiffness, cm.frictionEquationRelaxation, dt);

  //           c1.enabled = c2.enabled = c.enabled;

		// 	// Add equations to solver
		// 	solver.addEquation(c1);
		// 	solver.addEquation(c2);
		// }

        if( bi.allowSleep &&
            bi.type === Body.DYNAMIC &&
            bi.sleepState  === Body.SLEEPING &&
            bj.sleepState  === Body.AWAKE &&
            bj.type !== Body.STATIC
        ){
            var speedSquaredB = bj.velocity.norm2() + bj.angularVelocity.norm2();
            var speedLimitSquaredB = Math.pow(bj.sleepSpeedLimit,2);
            if(speedSquaredB >= speedLimitSquaredB*2){
                bi._wakeUpAfterNarrowphase = true;
            }
        }

        if( bj.allowSleep &&
            bj.type === Body.DYNAMIC &&
            bj.sleepState  === Body.SLEEPING &&
            bi.sleepState  === Body.AWAKE &&
            bi.type !== Body.STATIC
        ){
            var speedSquaredA = bi.velocity.norm2() + bi.angularVelocity.norm2();
            var speedLimitSquaredA = Math.pow(bi.sleepSpeedLimit,2);
            if(speedSquaredA >= speedLimitSquaredA*2){
                bj._wakeUpAfterNarrowphase = true;
            }
        }

        // Now we know that i and j are in contact. Set collision matrix state
		this.collisionMatrix.set(bi, bj, true);

        if (!this.collisionMatrixPrevious.get(bi, bj)) {
            // First contact!
            // We reuse the collideEvent object, otherwise we will end up creating new objects for each new contact, even if there's no event listener attached.
            World_step_collideEvent.body = bj;
            World_step_collideEvent.contact = c;
            bi.dispatchEvent(World_step_collideEvent);

            World_step_collideEvent.body = bi;
            bj.dispatchEvent(World_step_collideEvent);
        }

        this.bodyOverlapKeeper.set(bi.id, bj.id);
        this.shapeOverlapKeeper.set(si.id, sj.id);
    }

    this.emitContactEvents();

    if(doProfiling){
        profile.makeContactConstraints = performance.now() - profilingStart;
        profilingStart = performance.now();
    }

    // Wake up bodies
    for(i=0; i!==N; i++){
        var bi = bodies[i];
        if(bi._wakeUpAfterNarrowphase){
            bi.wakeUp();
            bi._wakeUpAfterNarrowphase = false;
        }
    }

    // Add user-added constraints
    var Nconstraints = constraints.length;
    for(i=0; i!==Nconstraints; i++){
        var c = constraints[i];
        c.update();
        for(var j=0, Neq=c.equations.length; j!==Neq; j++){
            var eq = c.equations[j];
            solver.addEquation(eq);
        }
    }

    // Solve the constrained system
    solver.solve(dt,this);

    if(doProfiling){
        profile.solve = performance.now() - profilingStart;
    }

    // Remove all contacts from solver
    solver.removeAllEquations();

    // Apply damping, see http://code.google.com/p/bullet/issues/detail?id=74 for details
    var pow = Math.pow;
    for(i=0; i!==N; i++){
        var bi = bodies[i];
        if(bi.type & DYNAMIC){ // Only for dynamic bodies
            var ld = pow(1.0 - bi.linearDamping,dt);
            var v = bi.velocity;
            v.mult(ld,v);
            var av = bi.angularVelocity;
            if(av){
                var ad = pow(1.0 - bi.angularDamping,dt);
                av.mult(ad,av);
            }
        }
    }

    this.dispatchEvent(World_step_preStepEvent);

    // Invoke pre-step callbacks
    for(i=0; i!==N; i++){
        var bi = bodies[i];
        if(bi.preStep){
            bi.preStep.call(bi);
        }
    }

    // Leap frog
    // vnew = v + h*f/m
    // xnew = x + h*vnew
    if(doProfiling){
        profilingStart = performance.now();
    }
    var stepnumber = this.stepnumber;
    var quatNormalize = stepnumber % (this.quatNormalizeSkip + 1) === 0;
    var quatNormalizeFast = this.quatNormalizeFast;

    for(i=0; i!==N; i++){
        bodies[i].integrate(dt, quatNormalize, quatNormalizeFast);
    }
    this.clearForces();

    this.broadphase.dirty = true;

    if(doProfiling){
        profile.integrate = performance.now() - profilingStart;
    }

    // Update world time
    this.time += dt;
    this.stepnumber += 1;

    this.dispatchEvent(World_step_postStepEvent);

    // Invoke post-step callbacks
    for(i=0; i!==N; i++){
        var bi = bodies[i];
        var postStep = bi.postStep;
        if(postStep){
            postStep.call(bi);
        }
    }

    // Sleeping update
    if(this.allowSleep){
        for(i=0; i!==N; i++){
            bodies[i].sleepTick(this.time);
        }
    }
};

World.prototype.emitContactEvents = (function(){
    var additions = [];
    var removals = [];
    var beginContactEvent = {
        type: 'beginContact',
        bodyA: null,
        bodyB: null
    };
    var endContactEvent = {
        type: 'endContact',
        bodyA: null,
        bodyB: null
    };
    var beginShapeContactEvent = {
        type: 'beginShapeContact',
        bodyA: null,
        bodyB: null,
        shapeA: null,
        shapeB: null
    };
    var endShapeContactEvent = {
        type: 'endShapeContact',
        bodyA: null,
        bodyB: null,
        shapeA: null,
        shapeB: null
    };
    return function(){
        var hasBeginContact = this.hasAnyEventListener('beginContact');
        var hasEndContact = this.hasAnyEventListener('endContact');

        if(hasBeginContact || hasEndContact){
            this.bodyOverlapKeeper.getDiff(additions, removals);
        }

        if(hasBeginContact){
            for (var i = 0, l = additions.length; i < l; i += 2) {
                beginContactEvent.bodyA = this.getBodyById(additions[i]);
                beginContactEvent.bodyB = this.getBodyById(additions[i+1]);
                this.dispatchEvent(beginContactEvent);
            }
            beginContactEvent.bodyA = beginContactEvent.bodyB = null;
        }

        if(hasEndContact){
            for (var i = 0, l = removals.length; i < l; i += 2) {
                endContactEvent.bodyA = this.getBodyById(removals[i]);
                endContactEvent.bodyB = this.getBodyById(removals[i+1]);
                this.dispatchEvent(endContactEvent);
            }
            endContactEvent.bodyA = endContactEvent.bodyB = null;
        }

        additions.length = removals.length = 0;

        var hasBeginShapeContact = this.hasAnyEventListener('beginShapeContact');
        var hasEndShapeContact = this.hasAnyEventListener('endShapeContact');

        if(hasBeginShapeContact || hasEndShapeContact){
            this.shapeOverlapKeeper.getDiff(additions, removals);
        }

        if(hasBeginShapeContact){
            for (var i = 0, l = additions.length; i < l; i += 2) {
                var shapeA = this.getShapeById(additions[i]);
                var shapeB = this.getShapeById(additions[i+1]);
                beginShapeContactEvent.shapeA = shapeA;
                beginShapeContactEvent.shapeB = shapeB;
                beginShapeContactEvent.bodyA = shapeA.body;
                beginShapeContactEvent.bodyB = shapeB.body;
                this.dispatchEvent(beginShapeContactEvent);
            }
            beginShapeContactEvent.bodyA = beginShapeContactEvent.bodyB = beginShapeContactEvent.shapeA = beginShapeContactEvent.shapeB = null;
        }

        if(hasEndShapeContact){
            for (var i = 0, l = removals.length; i < l; i += 2) {
                var shapeA = this.getShapeById(removals[i]);
                var shapeB = this.getShapeById(removals[i+1]);
                endShapeContactEvent.shapeA = shapeA;
                endShapeContactEvent.shapeB = shapeB;
                endShapeContactEvent.bodyA = shapeA.body;
                endShapeContactEvent.bodyB = shapeB.body;
                this.dispatchEvent(endShapeContactEvent);
            }
            endShapeContactEvent.bodyA = endShapeContactEvent.bodyB = endShapeContactEvent.shapeA = endShapeContactEvent.shapeB = null;
        }

    };
})();

/**
 * Sets all body forces in the world to zero.
 * @method clearForces
 */
World.prototype.clearForces = function(){
    var bodies = this.bodies;
    var N = bodies.length;
    for(var i=0; i !== N; i++){
        var b = bodies[i],
            force = b.force,
            tau = b.torque;

        b.force.set(0,0,0);
        b.torque.set(0,0,0);
    }
};


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var emptyObject = __webpack_require__(75);
var _invariant = __webpack_require__(1);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var camelize = __webpack_require__(356);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var isTextNode = __webpack_require__(366);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var invariant = __webpack_require__(1);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(14);

var createArrayFromMixed = __webpack_require__(359);
var getMarkupWrap = __webpack_require__(361);
var invariant = __webpack_require__(1);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(14);

var invariant = __webpack_require__(1);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(363);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var isNode = __webpack_require__(365);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/README.b5b0df97.md";

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/helveticaNeue.ef86ae5e.fnt";

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans.c9335d75.fnt";

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensansbold.5e4dfd1e.fnt";

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/raleway.d276fd0a.fnt";

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/roboto.9c431a75.fnt";

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createFirebaseNamespace = createFirebaseNamespace;

var _subscribe = __webpack_require__(157);

var _errors = __webpack_require__(103);

var _promise = __webpack_require__(39);

var _deep_copy = __webpack_require__(193);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var contains = function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var DEFAULT_ENTRY_NAME = '[DEFAULT]';
// An array to capture listeners before the true auth functions
// exist
var tokenListeners = [];
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 */
var FirebaseAppImpl = /** @class */function () {
    function FirebaseAppImpl(options, name, firebase_) {
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.services_ = {};
        this.name_ = name;
        this.options_ = (0, _deep_copy.deepCopy)(options);
        this.INTERNAL = {
            getUid: function getUid() {
                return null;
            },
            getToken: function getToken() {
                return _promise.PromiseImpl.resolve(null);
            },
            addAuthTokenListener: function addAuthTokenListener(callback) {
                tokenListeners.push(callback);
                // Make sure callback is called, asynchronously, in the absence of the auth module
                setTimeout(function () {
                    return callback(null);
                }, 0);
            },
            removeAuthTokenListener: function removeAuthTokenListener(callback) {
                tokenListeners = tokenListeners.filter(function (listener) {
                    return listener !== callback;
                });
            }
        };
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function get() {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function get() {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: true,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function () {
        var _this = this;
        return new _promise.PromiseImpl(function (resolve) {
            _this.checkDestroyed_();
            resolve();
        }).then(function () {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            var services = [];
            Object.keys(_this.services_).forEach(function (serviceKey) {
                Object.keys(_this.services_[serviceKey]).forEach(function (instanceKey) {
                    services.push(_this.services_[serviceKey][instanceKey]);
                });
            });
            return _promise.PromiseImpl.all(services.map(function (service) {
                return service.INTERNAL.delete();
            }));
        }).then(function () {
            _this.isDeleted_ = true;
            _this.services_ = {};
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage is the only one that is leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */
    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) {
            instanceIdentifier = DEFAULT_ENTRY_NAME;
        }
        this.checkDestroyed_();
        if (!this.services_[name]) {
            this.services_[name] = {};
        }
        if (!this.services_[name][instanceIdentifier]) {
            /**
             * If a custom instance has been defined (i.e. not '[DEFAULT]')
             * then we will pass that instance on, otherwise we pass `null`
             */
            var instanceSpecifier = instanceIdentifier !== DEFAULT_ENTRY_NAME ? instanceIdentifier : undefined;
            var service = this.firebase_.INTERNAL.factories[name](this, this.extendApp.bind(this), instanceSpecifier);
            this.services_[name][instanceIdentifier] = service;
        }
        return this.services_[name][instanceIdentifier];
    };
    /**
     * Callback function used to extend an App instance at the time
     * of service instance creation.
     */
    FirebaseAppImpl.prototype.extendApp = function (props) {
        var _this = this;
        // Copy the object onto the FirebaseAppImpl prototype
        (0, _deep_copy.deepExtend)(this, props);
        /**
         * If the app has overwritten the addAuthTokenListener stub, forward
         * the active token listeners on to the true fxn.
         *
         * TODO: This function is required due to our current module
         * structure. Once we are able to rely strictly upon a single module
         * implementation, this code should be refactored and Auth should
         * provide these stubs and the upgrade logic
         */
        if (props.INTERNAL && props.INTERNAL.addAuthTokenListener) {
            tokenListeners.forEach(function (listener) {
                _this.INTERNAL.addAuthTokenListener(listener);
            });
            tokenListeners = [];
        }
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
        if (this.isDeleted_) {
            error('app-deleted', { name: this.name_ });
        }
    };
    return FirebaseAppImpl;
}();
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options || FirebaseAppImpl.prototype.delete || console.log('dc');
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
    var apps_ = {};
    var factories = {};
    var appHooks = {};
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        __esModule: true,
        initializeApp: initializeApp,
        app: app,
        apps: null,
        Promise: _promise.PromiseImpl,
        SDK_VERSION: '4.5.0',
        INTERNAL: {
            registerService: registerService,
            createFirebaseNamespace: createFirebaseNamespace,
            extendNamespace: extendNamespace,
            createSubscribe: _subscribe.createSubscribe,
            ErrorFactory: _errors.ErrorFactory,
            removeApp: removeApp,
            factories: factories,
            useAsService: useAsService,
            Promise: _promise.PromiseImpl,
            deepExtend: _deep_copy.deepExtend
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    (0, _deep_copy.patchProperty)(namespace, 'default', namespace);
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */
    function removeApp(name) {
        var app = apps_[name];
        callAppHooks(app, 'delete');
        delete apps_[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */
    function app(name) {
        name = name || DEFAULT_ENTRY_NAME;
        if (!contains(apps_, name)) {
            error('no-app', { name: name });
        }
        return apps_[name];
    }
    (0, _deep_copy.patchProperty)(app, 'App', FirebaseAppImpl);
    /**
     * Create a new App instance (name must be unique).
     */
    function initializeApp(options, name) {
        if (name === undefined) {
            name = DEFAULT_ENTRY_NAME;
        } else {
            if (typeof name !== 'string' || name === '') {
                error('bad-app-name', { name: name + '' });
            }
        }
        if (contains(apps_, name)) {
            error('duplicate-app', { name: name });
        }
        var app = new FirebaseAppImpl(options, name, namespace);
        apps_[name] = app;
        callAppHooks(app, 'create');
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */
    function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps_).map(function (name) {
            return apps_[name];
        });
    }
    /*
     * Register a Firebase Service.
     *
     * firebase.INTERNAL.registerService()
     *
     * TODO: Implement serviceProperties.
     */
    function registerService(name, createService, serviceProperties, appHook, allowMultipleInstances) {
        // Cannot re-register a service that already exists
        if (factories[name]) {
            error('duplicate-service', { name: name });
        }
        // Capture the service factory for later service instantiation
        factories[name] = createService;
        // Capture the appHook, if passed
        if (appHook) {
            appHooks[name] = appHook;
            // Run the **new** app hook on all existing apps
            getApps().forEach(function (app) {
                appHook('create', app);
            });
        }
        // The Service namespace is an accessor function ...
        var serviceNamespace = function serviceNamespace(appArg) {
            if (appArg === void 0) {
                appArg = app();
            }
            if (typeof appArg[name] !== 'function') {
                // Invalid argument.
                // This happens in the following case: firebase.storage('gs:/')
                error('invalid-app-argument', { name: name });
            }
            // Forward service instance lookup to the FirebaseApp.
            return appArg[name]();
        };
        // ... and a container for service-level properties.
        if (serviceProperties !== undefined) {
            (0, _deep_copy.deepExtend)(serviceNamespace, serviceProperties);
        }
        // Monkey-patch the serviceNamespace onto the firebase namespace
        namespace[name] = serviceNamespace;
        // Patch the FirebaseAppImpl prototype
        FirebaseAppImpl.prototype[name] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var serviceFxn = this._getService.bind(this, name);
            return serviceFxn.apply(this, allowMultipleInstances ? args : []);
        };
        return serviceNamespace;
    }
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */
    function extendNamespace(props) {
        (0, _deep_copy.deepExtend)(namespace, props);
    }
    function callAppHooks(app, eventName) {
        Object.keys(factories).forEach(function (serviceName) {
            // Ignore virtual services
            var factoryName = useAsService(app, serviceName);
            if (factoryName === null) {
                return;
            }
            if (appHooks[factoryName]) {
                appHooks[factoryName](eventName, app);
            }
        });
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') {
            return null;
        }
        var useService = name;
        var options = app.options;
        return useService;
    }
    return namespace;
}
function error(code, args) {
    throw appErrors.create(code, args);
}
// TypeScript does not support non-string indexes!
// let errors: {[code: AppError: string} = {
var errors = {
    'no-app': "No Firebase App '{$name}' has been created - " + 'call Firebase App.initializeApp()',
    'bad-app-name': "Illegal App name: '{$name}",
    'duplicate-app': "Firebase App named '{$name}' already exists",
    'app-deleted': "Firebase App named '{$name}' already deleted",
    'duplicate-service': "Firebase service named '{$name}' already registered",
    'sa-not-supported': 'Initializing the Firebase SDK with a service ' + 'account is only allowed in a Node.js environment. On client ' + 'devices, you should instead initialize the SDK with an api key and ' + 'auth domain',
    'invalid-app-argument': 'firebase.{$name}() takes either no argument or a ' + 'Firebase App instance.'
};
var appErrors = new _errors.ErrorFactory('app', 'Firebase', errors);
//# sourceMappingURL=firebase_app.js.map


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */

var firebase = __webpack_require__(34);
(function(){(function(){var h,aa=aa||{},k=this,ba=function(a){return void 0!==a},m=function(a){return"string"==typeof a},ca=function(a){return"boolean"==typeof a},da=function(){},ea=function(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";
if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==b&&"undefined"==typeof a.call)return"object";return b},fa=function(a){return null===a},ha=function(a){return"array"==ea(a)},ia=function(a){var b=ea(a);return"array"==b||"object"==b&&"number"==typeof a.length},p=function(a){return"function"==ea(a)},q=function(a){var b=typeof a;return"object"==b&&null!=a||"function"==
b},ja=function(a,b,c){return a.call.apply(a.bind,arguments)},ka=function(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}},r=function(a,b,c){r=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ja:ka;return r.apply(null,arguments)},la=function(a,b){var c=
Array.prototype.slice.call(arguments,1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}},ma=Date.now||function(){return+new Date},t=function(a,b){function c(){}c.prototype=b.prototype;a.Vc=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.Ng=function(a,c,f){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-2]=arguments[e];return b.prototype[c].apply(a,d)}};var u=function(a){if(Error.captureStackTrace)Error.captureStackTrace(this,u);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))};t(u,Error);u.prototype.name="CustomError";var na=function(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")},oa=String.prototype.trim?function(a){return a.trim()}:function(a){return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")},wa=function(a){if(!pa.test(a))return a;-1!=a.indexOf("&")&&(a=a.replace(qa,"&amp;"));-1!=a.indexOf("<")&&(a=a.replace(ra,"&lt;"));-1!=a.indexOf(">")&&(a=a.replace(sa,"&gt;"));-1!=a.indexOf('"')&&(a=a.replace(ta,"&quot;"));-1!=a.indexOf("'")&&
(a=a.replace(ua,"&#39;"));-1!=a.indexOf("\x00")&&(a=a.replace(va,"&#0;"));return a},qa=/&/g,ra=/</g,sa=/>/g,ta=/"/g,ua=/'/g,va=/\x00/g,pa=/[\x00&<>"']/,v=function(a,b){return-1!=a.indexOf(b)},xa=function(a,b){return a<b?-1:a>b?1:0};var ya=function(a,b){b.unshift(a);u.call(this,na.apply(null,b));b.shift()};t(ya,u);ya.prototype.name="AssertionError";
var za=function(a,b,c,d){var e="Assertion failed";if(c){e+=": "+c;var f=d}else a&&(e+=": "+a,f=b);throw new ya(""+e,f||[]);},w=function(a,b,c){a||za("",null,b,Array.prototype.slice.call(arguments,2));return a},Aa=function(a,b){throw new ya("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));},Ba=function(a,b,c){"number"==typeof a||za("Expected number but got %s: %s.",[ea(a),a],b,Array.prototype.slice.call(arguments,2));return a},Ca=function(a,b,c){m(a)||za("Expected string but got %s: %s.",
[ea(a),a],b,Array.prototype.slice.call(arguments,2))},Da=function(a,b,c){p(a)||za("Expected function but got %s: %s.",[ea(a),a],b,Array.prototype.slice.call(arguments,2))};var Fa=function(){this.Uc="";this.gf=Ea};Fa.prototype.qb=!0;Fa.prototype.ob=function(){return this.Uc};Fa.prototype.toString=function(){return"Const{"+this.Uc+"}"};var Ga=function(a){if(a instanceof Fa&&a.constructor===Fa&&a.gf===Ea)return a.Uc;Aa("expected object of type Const, got '"+a+"'");return"type_error:Const"},Ea={},Ha=function(a){var b=new Fa;b.Uc=a;return b};Ha("");var Ja=function(){this.Mc="";this.hf=Ia};Ja.prototype.qb=!0;Ja.prototype.ob=function(){return this.Mc};Ja.prototype.toString=function(){return"TrustedResourceUrl{"+this.Mc+"}"};
var Ka=function(a){if(a instanceof Ja&&a.constructor===Ja&&a.hf===Ia)return a.Mc;Aa("expected object of type TrustedResourceUrl, got '"+a+"' of type "+ea(a));return"type_error:TrustedResourceUrl"},Ma=function(a,b){a=La(a,b);b=new Ja;b.Mc=a;return b},La=function(a,b){var c=Ga(a);if(!Na.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);return c.replace(Oa,function(a,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+
JSON.stringify(b));a=b[e];return a instanceof Fa?Ga(a):encodeURIComponent(String(a))})},Oa=/%{(\w+)}/g,Na=/^(?:https:)?\/\/[0-9a-z.:[\]-]+\/|^\/[^\/\\]|^about:blank(#|$)/i,Ia={};var Pa=Array.prototype.indexOf?function(a,b,c){w(null!=a.length);return Array.prototype.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if(m(a))return m(b)&&1==b.length?a.indexOf(b,c):-1;for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},x=Array.prototype.forEach?function(a,b,c){w(null!=a.length);Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)},Qa=function(a,b){for(var c=m(a)?
a.split(""):a,d=a.length-1;0<=d;--d)d in c&&b.call(void 0,c[d],d,a)},Ra=Array.prototype.map?function(a,b,c){w(null!=a.length);return Array.prototype.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f=m(a)?a.split(""):a,g=0;g<d;g++)g in f&&(e[g]=b.call(c,f[g],g,a));return e},Sa=Array.prototype.some?function(a,b,c){w(null!=a.length);return Array.prototype.some.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return!0;return!1},
Ua=function(a){a:{var b=Ta;for(var c=a.length,d=m(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:m(a)?a.charAt(b):a[b]},Va=function(a,b){return 0<=Pa(a,b)},Xa=function(a,b){b=Pa(a,b);var c;(c=0<=b)&&Wa(a,b);return c},Wa=function(a,b){w(null!=a.length);return 1==Array.prototype.splice.call(a,b,1).length},Ya=function(a,b){var c=0;Qa(a,function(d,e){b.call(void 0,d,e,a)&&Wa(a,e)&&c++})},Za=function(a){return Array.prototype.concat.apply([],arguments)},
$a=function(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};var ab=function(a){return Ra(a,function(a){a=a.toString(16);return 1<a.length?a:"0"+a}).join("")};var bb;a:{var cb=k.navigator;if(cb){var db=cb.userAgent;if(db){bb=db;break a}}bb=""}var y=function(a){return v(bb,a)};var eb=function(a,b){for(var c in a)b.call(void 0,a[c],c,a)},fb=function(a,b){for(var c in a)if(b.call(void 0,a[c],c,a))return!0;return!1},gb=function(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b},hb=function(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b},ib=function(a){for(var b in a)return!1;return!0},jb=function(a,b){for(var c in a)if(!(c in b)||a[c]!==b[c])return!1;for(c in b)if(!(c in a))return!1;return!0},kb=function(a){var b={},c;for(c in a)b[c]=a[c];return b},lb="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "),
mb=function(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<lb.length;f++)c=lb[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};var nb=function(a){nb[" "](a);return a};nb[" "]=da;var pb=function(a,b){var c=ob;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var qb=y("Opera"),z=y("Trident")||y("MSIE"),rb=y("Edge"),sb=rb||z,tb=y("Gecko")&&!(v(bb.toLowerCase(),"webkit")&&!y("Edge"))&&!(y("Trident")||y("MSIE"))&&!y("Edge"),ub=v(bb.toLowerCase(),"webkit")&&!y("Edge"),vb=function(){var a=k.document;return a?a.documentMode:void 0},wb;
a:{var xb="",yb=function(){var a=bb;if(tb)return/rv\:([^\);]+)(\)|;)/.exec(a);if(rb)return/Edge\/([\d\.]+)/.exec(a);if(z)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(ub)return/WebKit\/(\S+)/.exec(a);if(qb)return/(?:Version)[ \/]?(\S+)/.exec(a)}();yb&&(xb=yb?yb[1]:"");if(z){var Ab=vb();if(null!=Ab&&Ab>parseFloat(xb)){wb=String(Ab);break a}}wb=xb}
var Bb=wb,ob={},A=function(a){return pb(a,function(){for(var b=0,c=oa(String(Bb)).split("."),d=oa(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",l=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];l=/(\d*)(\D*)(.*)/.exec(l)||["","","",""];if(0==g[0].length&&0==l[0].length)break;b=xa(0==g[1].length?0:parseInt(g[1],10),0==l[1].length?0:parseInt(l[1],10))||xa(0==g[2].length,0==l[2].length)||xa(g[2],l[2]);g=g[3];l=l[3]}while(0==b)}return 0<=b})},Cb;var Db=k.document;
Cb=Db&&z?vb()||("CSS1Compat"==Db.compatMode?parseInt(Bb,10):5):void 0;var Eb=null,Fb=null,Hb=function(a){var b="";Gb(a,function(a){b+=String.fromCharCode(a)});return b},Gb=function(a,b){function c(b){for(;d<a.length;){var c=a.charAt(d++),e=Fb[c];if(null!=e)return e;if(!/^[\s\xa0]*$/.test(c))throw Error("Unknown base64 encoding at char: "+c);}return b}Ib();for(var d=0;;){var e=c(-1),f=c(0),g=c(64),l=c(64);if(64===l&&-1===e)break;b(e<<2|f>>4);64!=g&&(b(f<<4&240|g>>2),64!=l&&b(g<<6&192|l))}},Ib=function(){if(!Eb){Eb={};Fb={};for(var a=0;65>a;a++)Eb[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),
Fb[Eb[a]]=a,62<=a&&(Fb["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)]=a)}};var Jb=function(){this.Da=-1};var Mb=function(a,b){this.Da=-1;this.Da=64;this.rc=k.Uint8Array?new Uint8Array(this.Da):Array(this.Da);this.Yc=this.rb=0;this.l=[];this.$f=a;this.Ee=b;this.Bg=k.Int32Array?new Int32Array(64):Array(64);ba(Kb)||(Kb=k.Int32Array?new Int32Array(Lb):Lb);this.reset()},Kb;t(Mb,Jb);for(var Nb=[],Ob=0;63>Ob;Ob++)Nb[Ob]=0;var Pb=Za(128,Nb);Mb.prototype.reset=function(){this.Yc=this.rb=0;this.l=k.Int32Array?new Int32Array(this.Ee):$a(this.Ee)};
var Qb=function(a){var b=a.rc;w(b.length==a.Da);for(var c=a.Bg,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){e=c[b-15]|0;d=c[b-2]|0;var f=(c[b-16]|0)+((e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3)|0,g=(c[b-7]|0)+((d>>>17|d<<15)^(d>>>19|d<<13)^d>>>10)|0;c[b]=f+g|0}d=a.l[0]|0;e=a.l[1]|0;var l=a.l[2]|0,n=a.l[3]|0,F=a.l[4]|0,zb=a.l[5]|0,hc=a.l[6]|0;f=a.l[7]|0;for(b=0;64>b;b++){var vi=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&l^e&l)|0;g=F&zb^~F&hc;f=f+((F>>>
6|F<<26)^(F>>>11|F<<21)^(F>>>25|F<<7))|0;g=g+(Kb[b]|0)|0;g=f+(g+(c[b]|0)|0)|0;f=hc;hc=zb;zb=F;F=n+g|0;n=l;l=e;e=d;d=g+vi|0}a.l[0]=a.l[0]+d|0;a.l[1]=a.l[1]+e|0;a.l[2]=a.l[2]+l|0;a.l[3]=a.l[3]+n|0;a.l[4]=a.l[4]+F|0;a.l[5]=a.l[5]+zb|0;a.l[6]=a.l[6]+hc|0;a.l[7]=a.l[7]+f|0};
Mb.prototype.update=function(a,b){ba(b)||(b=a.length);var c=0,d=this.rb;if(m(a))for(;c<b;)this.rc[d++]=a.charCodeAt(c++),d==this.Da&&(Qb(this),d=0);else if(ia(a))for(;c<b;){var e=a[c++];if(!("number"==typeof e&&0<=e&&255>=e&&e==(e|0)))throw Error("message must be a byte array");this.rc[d++]=e;d==this.Da&&(Qb(this),d=0)}else throw Error("message must be string or array");this.rb=d;this.Yc+=b};
Mb.prototype.digest=function(){var a=[],b=8*this.Yc;56>this.rb?this.update(Pb,56-this.rb):this.update(Pb,this.Da-(this.rb-56));for(var c=63;56<=c;c--)this.rc[c]=b&255,b/=256;Qb(this);for(c=b=0;c<this.$f;c++)for(var d=24;0<=d;d-=8)a[b++]=this.l[c]>>d&255;return a};
var Lb=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];var Sb=function(){Mb.call(this,8,Rb)};t(Sb,Mb);var Rb=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];var Tb=Object.freeze||function(a){return a};var Ub=function(){this.Ma=this.Ma;this.Jc=this.Jc};Ub.prototype.Ma=!1;Ub.prototype.isDisposed=function(){return this.Ma};Ub.prototype.lb=function(){if(this.Jc)for(;this.Jc.length;)this.Jc.shift()()};var Vb=!z||9<=Number(Cb),Wb=z&&!A("9");!ub||A("528");tb&&A("1.9b")||z&&A("8")||qb&&A("9.5")||ub&&A("528");tb&&!A("8")||z&&A("9");var Xb=function(){if(!k.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});k.addEventListener("test",da,b);k.removeEventListener("test",da,b);return a}();var B=function(a,b){this.type=a;this.currentTarget=this.target=b;this.defaultPrevented=this.Wa=!1;this.Se=!0};B.prototype.stopPropagation=function(){this.Wa=!0};B.prototype.preventDefault=function(){this.defaultPrevented=!0;this.Se=!1};var Yb=function(a,b){B.call(this,a?a.type:"");this.relatedTarget=this.currentTarget=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=this.offsetY=this.offsetX=0;this.key="";this.charCode=this.keyCode=0;this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.state=null;this.pointerId=0;this.pointerType="";this.P=null;a&&this.init(a,b)};t(Yb,B);var Zb=Tb({2:"touch",3:"pen",4:"mouse"});
Yb.prototype.init=function(a,b){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.currentTarget=b;if(b=a.relatedTarget){if(tb){a:{try{nb(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.offsetX=ub||void 0!==a.offsetX?a.offsetX:a.layerX,this.offsetY=ub||void 0!==a.offsetY?a.offsetY:a.layerY,this.clientX=void 0!==a.clientX?a.clientX:a.pageX,
this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0);this.button=a.button;this.keyCode=a.keyCode||0;this.key=a.key||"";this.charCode=a.charCode||("keypress"==c?a.keyCode:0);this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=
m(a.pointerType)?a.pointerType:Zb[a.pointerType]||"";this.state=a.state;this.P=a;a.defaultPrevented&&this.preventDefault()};Yb.prototype.stopPropagation=function(){Yb.Vc.stopPropagation.call(this);this.P.stopPropagation?this.P.stopPropagation():this.P.cancelBubble=!0};Yb.prototype.preventDefault=function(){Yb.Vc.preventDefault.call(this);var a=this.P;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,Wb)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};
Yb.prototype.Ef=function(){return this.P};var $b="closure_listenable_"+(1E6*Math.random()|0),ac=0;var bc=function(a,b,c,d,e){this.listener=a;this.Nc=null;this.src=b;this.type=c;this.capture=!!d;this.wc=e;this.key=++ac;this.Bb=this.qc=!1},cc=function(a){a.Bb=!0;a.listener=null;a.Nc=null;a.src=null;a.wc=null};var dc=function(a){this.src=a;this.I={};this.kc=0};dc.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.I[f];a||(a=this.I[f]=[],this.kc++);var g=ec(a,b,d,e);-1<g?(b=a[g],c||(b.qc=!1)):(b=new bc(b,this.src,f,!!d,e),b.qc=c,a.push(b));return b};dc.prototype.remove=function(a,b,c,d){a=a.toString();if(!(a in this.I))return!1;var e=this.I[a];b=ec(e,b,c,d);return-1<b?(cc(e[b]),Wa(e,b),0==e.length&&(delete this.I[a],this.kc--),!0):!1};
var fc=function(a,b){var c=b.type;c in a.I&&Xa(a.I[c],b)&&(cc(b),0==a.I[c].length&&(delete a.I[c],a.kc--))};dc.prototype.td=function(a,b,c,d){a=this.I[a.toString()];var e=-1;a&&(e=ec(a,b,c,d));return-1<e?a[e]:null};dc.prototype.hasListener=function(a,b){var c=ba(a),d=c?a.toString():"",e=ba(b);return fb(this.I,function(a){for(var f=0;f<a.length;++f)if(!(c&&a[f].type!=d||e&&a[f].capture!=b))return!0;return!1})};
var ec=function(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.Bb&&f.listener==b&&f.capture==!!c&&f.wc==d)return e}return-1};var gc="closure_lm_"+(1E6*Math.random()|0),ic={},jc=0,lc=function(a,b,c,d,e){if(d&&d.once)kc(a,b,c,d,e);else if(ha(b))for(var f=0;f<b.length;f++)lc(a,b[f],c,d,e);else c=mc(c),a&&a[$b]?a.listen(b,c,q(d)?!!d.capture:!!d,e):nc(a,b,c,!1,d,e)},nc=function(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=q(e)?!!e.capture:!!e,l=oc(a);l||(a[gc]=l=new dc(a));c=l.add(b,c,d,g,f);if(!c.Nc){d=pc();c.Nc=d;d.src=a;d.listener=c;if(a.addEventListener)Xb||(e=g),void 0===e&&(e=!1),a.addEventListener(b.toString(),
d,e);else if(a.attachEvent)a.attachEvent(qc(b.toString()),d);else throw Error("addEventListener and attachEvent are unavailable.");jc++}},pc=function(){var a=rc,b=Vb?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b},kc=function(a,b,c,d,e){if(ha(b))for(var f=0;f<b.length;f++)kc(a,b[f],c,d,e);else c=mc(c),a&&a[$b]?sc(a,b,c,q(d)?!!d.capture:!!d,e):nc(a,b,c,!0,d,e)},tc=function(a,b,c,d,e){if(ha(b))for(var f=0;f<b.length;f++)tc(a,b[f],c,d,
e);else d=q(d)?!!d.capture:!!d,c=mc(c),a&&a[$b]?a.ga.remove(String(b),c,d,e):a&&(a=oc(a))&&(b=a.td(b,c,d,e))&&uc(b)},uc=function(a){if("number"!=typeof a&&a&&!a.Bb){var b=a.src;if(b&&b[$b])fc(b.ga,a);else{var c=a.type,d=a.Nc;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent&&b.detachEvent(qc(c),d);jc--;(c=oc(b))?(fc(c,a),0==c.kc&&(c.src=null,b[gc]=null)):cc(a)}}},qc=function(a){return a in ic?ic[a]:ic[a]="on"+a},wc=function(a,b,c,d){var e=!0;if(a=oc(a))if(b=a.I[b.toString()])for(b=
b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.Bb&&(f=vc(f,d),e=e&&!1!==f)}return e},vc=function(a,b){var c=a.listener,d=a.wc||a.src;a.qc&&uc(a);return c.call(d,b)},rc=function(a,b){if(a.Bb)return!0;if(!Vb){if(!b)a:{b=["window","event"];for(var c=k,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new Yb(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=
!0}d=[];for(e=b.currentTarget;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;!b.Wa&&0<=e;e--){b.currentTarget=d[e];var f=wc(d[e],a,!0,b);c=c&&f}for(e=0;!b.Wa&&e<d.length;e++)b.currentTarget=d[e],f=wc(d[e],a,!1,b),c=c&&f}return c}return vc(a,new Yb(b,this))},oc=function(a){a=a[gc];return a instanceof dc?a:null},xc="__closure_events_fn_"+(1E9*Math.random()>>>0),mc=function(a){w(a,"Listener can not be null.");if(p(a))return a;w(a.handleEvent,"An object listener must have handleEvent method.");
a[xc]||(a[xc]=function(b){return a.handleEvent(b)});return a[xc]};var yc=/^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;var Ac=function(){this.xa="";this.ff=zc};Ac.prototype.qb=!0;Ac.prototype.ob=function(){return this.xa};Ac.prototype.toString=function(){return"SafeUrl{"+this.xa+"}"};
var Bc=function(a){if(a instanceof Ac&&a.constructor===Ac&&a.ff===zc)return a.xa;Aa("expected object of type SafeUrl, got '"+a+"' of type "+ea(a));return"type_error:SafeUrl"},Cc=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i,Ec=function(a){if(a instanceof Ac)return a;a=a.qb?a.ob():String(a);Cc.test(a)||(a="about:invalid#zClosurez");return Dc(a)},zc={},Dc=function(a){var b=new Ac;b.xa=a;return b};Dc("about:blank");var Hc=function(a){var b=[];Fc(new Gc,a,b);return b.join("")},Gc=function(){this.Oc=void 0},Fc=function(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(ha(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),e=d[f],Fc(a,a.Oc?a.Oc.call(d,String(f),e):e,c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");f="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(e=b[d],"function"!=typeof e&&(c.push(f),
Ic(d,c),c.push(":"),Fc(a,a.Oc?a.Oc.call(b,d,e):e,c),f=","));c.push("}");return}}switch(typeof b){case "string":Ic(b,c);break;case "number":c.push(isFinite(b)&&!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}},Jc={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},Kc=/\uffff/.test("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g,
Ic=function(a,b){b.push('"',a.replace(Kc,function(a){var b=Jc[a];b||(b="\\u"+(a.charCodeAt(0)|65536).toString(16).substr(1),Jc[a]=b);return b}),'"')};var Lc=function(){};Lc.prototype.ie=null;var Mc=function(a){return a.ie||(a.ie=a.Cd())};var Nc,Oc=function(){};t(Oc,Lc);Oc.prototype.sc=function(){var a=Pc(this);return a?new ActiveXObject(a):new XMLHttpRequest};Oc.prototype.Cd=function(){var a={};Pc(this)&&(a[0]=!0,a[1]=!0);return a};
var Pc=function(a){if(!a.De&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.De=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.De};Nc=new Oc;var Qc=function(){};t(Qc,Lc);Qc.prototype.sc=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new Rc;throw Error("Unsupported browser");};Qc.prototype.Cd=function(){return{}};
var Rc=function(){this.oa=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseText="";this.status=-1;this.statusText=this.responseXML=null;this.oa.onload=r(this.If,this);this.oa.onerror=r(this.ye,this);this.oa.onprogress=r(this.Jf,this);this.oa.ontimeout=r(this.Kf,this)};h=Rc.prototype;h.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.oa.open(a,b)};
h.send=function(a){if(a)if("string"==typeof a)this.oa.send(a);else throw Error("Only string data is supported");else this.oa.send()};h.abort=function(){this.oa.abort()};h.setRequestHeader=function(){};h.getResponseHeader=function(a){return"content-type"==a.toLowerCase()?this.oa.contentType:""};h.If=function(){this.status=200;this.responseText=this.oa.responseText;Sc(this,4)};h.ye=function(){this.status=500;this.responseText="";Sc(this,4)};h.Kf=function(){this.ye()};
h.Jf=function(){this.status=200;Sc(this,1)};var Sc=function(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()};Rc.prototype.getAllResponseHeaders=function(){return"content-type: "+this.oa.contentType};var Tc=function(a,b,c){this.Vf=c;this.tf=a;this.kg=b;this.Ic=0;this.xc=null};Tc.prototype.get=function(){if(0<this.Ic){this.Ic--;var a=this.xc;this.xc=a.next;a.next=null}else a=this.tf();return a};Tc.prototype.put=function(a){this.kg(a);this.Ic<this.Vf&&(this.Ic++,a.next=this.xc,this.xc=a)};var Uc=function(a){k.setTimeout(function(){throw a;},0)},Vc,Wc=function(){var a=k.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!y("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow;a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host;
a=r(function(a){if(("*"==d||a.origin==d)&&a.data==c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!y("Trident")&&!y("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(ba(c.next)){c=c.next;var a=c.me;c.me=null;a()}};return function(a){d.next={me:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?
function(a){var b=document.createElement("SCRIPT");b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){k.setTimeout(a,0)}};var Xc=function(){this.cd=this.hb=null},Zc=new Tc(function(){return new Yc},function(a){a.reset()},100);Xc.prototype.add=function(a,b){var c=Zc.get();c.set(a,b);this.cd?this.cd.next=c:(w(!this.hb),this.hb=c);this.cd=c};Xc.prototype.remove=function(){var a=null;this.hb&&(a=this.hb,this.hb=this.hb.next,this.hb||(this.cd=null),a.next=null);return a};var Yc=function(){this.next=this.scope=this.rd=null};Yc.prototype.set=function(a,b){this.rd=a;this.scope=b;this.next=null};
Yc.prototype.reset=function(){this.next=this.scope=this.rd=null};var dd=function(a,b){$c||ad();bd||($c(),bd=!0);cd.add(a,b)},$c,ad=function(){if(-1!=String(k.Promise).indexOf("[native code]")){var a=k.Promise.resolve(void 0);$c=function(){a.then(ed)}}else $c=function(){var a=ed;!p(k.setImmediate)||k.Window&&k.Window.prototype&&!y("Edge")&&k.Window.prototype.setImmediate==k.setImmediate?(Vc||(Vc=Wc()),Vc(a)):k.setImmediate(a)}},bd=!1,cd=new Xc,ed=function(){for(var a;a=cd.remove();){try{a.rd.call(a.scope)}catch(b){Uc(b)}Zc.put(a)}bd=!1};var fd=function(a){return q(a)?a.constructor.displayName||a.constructor.name||Object.prototype.toString.call(a):void 0===a?"undefined":null===a?"null":typeof a},gd=function(a){return(a=a&&a.ownerDocument)&&(a.defaultView||a.parentWindow)||k};var hd=!z||9<=Number(Cb);!tb&&!z||z&&9<=Number(Cb)||tb&&A("1.9.1");z&&A("9");var jd=function(){this.xa="";this.ef=id};jd.prototype.qb=!0;jd.prototype.ob=function(){return this.xa};jd.prototype.toString=function(){return"SafeHtml{"+this.xa+"}"};var kd=function(a){if(a instanceof jd&&a.constructor===jd&&a.ef===id)return a.xa;Aa("expected object of type SafeHtml, got '"+a+"' of type "+ea(a));return"type_error:SafeHtml"},id={};jd.prototype.Qf=function(a){this.xa=a;return this};var ld=function(a,b){var c=gd(a);"undefined"!=typeof c.HTMLScriptElement&&"undefined"!=typeof c.Element&&w(a&&(a instanceof c.HTMLScriptElement||!(a instanceof c.Element)),"Argument is not a HTMLScriptElement (or a non-Element mock); got: %s",fd(a));a.src=Ka(b)};var md=function(a){var b=document;return m(a)?b.getElementById(a):a},od=function(a,b){eb(b,function(b,d){b&&b.qb&&(b=b.ob());"style"==d?a.style.cssText=b:"class"==d?a.className=b:"for"==d?a.htmlFor=b:nd.hasOwnProperty(d)?a.setAttribute(nd[d],b):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,b):a[d]=b})},nd={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",
type:"type",usemap:"useMap",valign:"vAlign",width:"width"},qd=function(a,b,c){var d=arguments,e=document,f=String(d[0]),g=d[1];if(!hd&&g&&(g.name||g.type)){f=["<",f];g.name&&f.push(' name="',wa(g.name),'"');if(g.type){f.push(' type="',wa(g.type),'"');var l={};mb(l,g);delete l.type;g=l}f.push(">");f=f.join("")}f=e.createElement(f);g&&(m(g)?f.className=g:ha(g)?f.className=g.join(" "):od(f,g));2<d.length&&pd(e,f,d);return f},pd=function(a,b,c){function d(c){c&&b.appendChild(m(c)?a.createTextNode(c):
c)}for(var e=2;e<c.length;e++){var f=c[e];!ia(f)||q(f)&&0<f.nodeType?d(f):x(rd(f)?$a(f):f,d)}},rd=function(a){if(a&&"number"==typeof a.length){if(q(a))return"function"==typeof a.item||"string"==typeof a.item;if(p(a))return"function"==typeof a.item}return!1};var sd=function(a){a.prototype.then=a.prototype.then;a.prototype.$goog_Thenable=!0},td=function(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};var C=function(a,b){this.aa=0;this.za=void 0;this.kb=this.ua=this.w=null;this.vc=this.pd=!1;if(a!=da)try{var c=this;a.call(b,function(a){ud(c,2,a)},function(a){if(!(a instanceof vd))try{if(a instanceof Error)throw a;throw Error("Promise rejected.");}catch(e){}ud(c,3,a)})}catch(d){ud(this,3,d)}},wd=function(){this.next=this.context=this.tb=this.Ua=this.child=null;this.Hb=!1};wd.prototype.reset=function(){this.context=this.tb=this.Ua=this.child=null;this.Hb=!1};
var xd=new Tc(function(){return new wd},function(a){a.reset()},100),yd=function(a,b,c){var d=xd.get();d.Ua=a;d.tb=b;d.context=c;return d},D=function(a){if(a instanceof C)return a;var b=new C(da);ud(b,2,a);return b},E=function(a){return new C(function(b,c){c(a)})},Ad=function(a,b,c){zd(a,b,c,null)||dd(la(b,a))},Bd=function(a){return new C(function(b,c){var d=a.length,e=[];if(d)for(var f=function(a,c){d--;e[a]=c;0==d&&b(e)},g=function(a){c(a)},l=0,n;l<a.length;l++)n=a[l],Ad(n,la(f,l),g);else b(e)})},
Cd=function(a){return new C(function(b){var c=a.length,d=[];if(c)for(var e=function(a,e,f){c--;d[a]=e?{Df:!0,value:f}:{Df:!1,reason:f};0==c&&b(d)},f=0,g;f<a.length;f++)g=a[f],Ad(g,la(e,f,!0),la(e,f,!1));else b(d)})};C.prototype.then=function(a,b,c){null!=a&&Da(a,"opt_onFulfilled should be a function.");null!=b&&Da(b,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");return Dd(this,p(a)?a:null,p(b)?b:null,c)};sd(C);
var Fd=function(a,b){b=yd(b,b,void 0);b.Hb=!0;Ed(a,b);return a};C.prototype.g=function(a,b){return Dd(this,null,a,b)};C.prototype.cancel=function(a){0==this.aa&&dd(function(){var b=new vd(a);Gd(this,b)},this)};
var Gd=function(a,b){if(0==a.aa)if(a.w){var c=a.w;if(c.ua){for(var d=0,e=null,f=null,g=c.ua;g&&(g.Hb||(d++,g.child==a&&(e=g),!(e&&1<d)));g=g.next)e||(f=g);e&&(0==c.aa&&1==d?Gd(c,b):(f?(d=f,w(c.ua),w(null!=d),d.next==c.kb&&(c.kb=d),d.next=d.next.next):Hd(c),Id(c,e,3,b)))}a.w=null}else ud(a,3,b)},Ed=function(a,b){a.ua||2!=a.aa&&3!=a.aa||Jd(a);w(null!=b.Ua);a.kb?a.kb.next=b:a.ua=b;a.kb=b},Dd=function(a,b,c,d){var e=yd(null,null,null);e.child=new C(function(a,g){e.Ua=b?function(c){try{var e=b.call(d,
c);a(e)}catch(F){g(F)}}:a;e.tb=c?function(b){try{var e=c.call(d,b);!ba(e)&&b instanceof vd?g(b):a(e)}catch(F){g(F)}}:g});e.child.w=a;Ed(a,e);return e.child};C.prototype.yg=function(a){w(1==this.aa);this.aa=0;ud(this,2,a)};C.prototype.zg=function(a){w(1==this.aa);this.aa=0;ud(this,3,a)};
var ud=function(a,b,c){0==a.aa&&(a===c&&(b=3,c=new TypeError("Promise cannot resolve to itself")),a.aa=1,zd(c,a.yg,a.zg,a)||(a.za=c,a.aa=b,a.w=null,Jd(a),3!=b||c instanceof vd||Kd(a,c)))},zd=function(a,b,c,d){if(a instanceof C)return null!=b&&Da(b,"opt_onFulfilled should be a function."),null!=c&&Da(c,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?"),Ed(a,yd(b||da,c||null,d)),!0;if(td(a))return a.then(b,c,d),!0;if(q(a))try{var e=a.then;if(p(e))return Ld(a,
e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1},Ld=function(a,b,c,d,e){var f=!1,g=function(a){f||(f=!0,c.call(e,a))},l=function(a){f||(f=!0,d.call(e,a))};try{b.call(a,g,l)}catch(n){l(n)}},Jd=function(a){a.pd||(a.pd=!0,dd(a.yf,a))},Hd=function(a){var b=null;a.ua&&(b=a.ua,a.ua=b.next,b.next=null);a.ua||(a.kb=null);null!=b&&w(null!=b.Ua);return b};C.prototype.yf=function(){for(var a;a=Hd(this);)Id(this,a,this.aa,this.za);this.pd=!1};
var Id=function(a,b,c,d){if(3==c&&b.tb&&!b.Hb)for(;a&&a.vc;a=a.w)a.vc=!1;if(b.child)b.child.w=null,Md(b,c,d);else try{b.Hb?b.Ua.call(b.context):Md(b,c,d)}catch(e){Nd.call(null,e)}xd.put(b)},Md=function(a,b,c){2==b?a.Ua.call(a.context,c):a.tb&&a.tb.call(a.context,c)},Kd=function(a,b){a.vc=!0;dd(function(){a.vc&&Nd.call(null,b)})},Nd=Uc,vd=function(a){u.call(this,a)};t(vd,u);vd.prototype.name="cancel";
var Od=function(a,b){this.Rc=[];this.Le=a;this.qe=b||null;this.Pb=this.nb=!1;this.za=void 0;this.ae=this.ge=this.gd=!1;this.Zc=0;this.w=null;this.hd=0};Od.prototype.cancel=function(a){if(this.nb)this.za instanceof Od&&this.za.cancel();else{if(this.w){var b=this.w;delete this.w;a?b.cancel(a):(b.hd--,0>=b.hd&&b.cancel())}this.Le?this.Le.call(this.qe,this):this.ae=!0;this.nb||Pd(this,new Qd)}};Od.prototype.oe=function(a,b){this.gd=!1;Rd(this,a,b)};
var Rd=function(a,b,c){a.nb=!0;a.za=c;a.Pb=!b;Sd(a)},Ud=function(a){if(a.nb){if(!a.ae)throw new Td;a.ae=!1}};Od.prototype.callback=function(a){Ud(this);Vd(a);Rd(this,!0,a)};var Pd=function(a,b){Ud(a);Vd(b);Rd(a,!1,b)},Vd=function(a){w(!(a instanceof Od),"An execution sequence may not be initiated with a blocking Deferred.")},Xd=function(a,b){Wd(a,null,b,void 0)},Wd=function(a,b,c,d){w(!a.ge,"Blocking Deferreds can not be re-used");a.Rc.push([b,c,d]);a.nb&&Sd(a)};
Od.prototype.then=function(a,b,c){var d,e,f=new C(function(a,b){d=a;e=b});Wd(this,d,function(a){a instanceof Qd?f.cancel():e(a)});return f.then(a,b,c)};sd(Od);
var Yd=function(a){return Sa(a.Rc,function(a){return p(a[1])})},Sd=function(a){if(a.Zc&&a.nb&&Yd(a)){var b=a.Zc,c=Zd[b];c&&(k.clearTimeout(c.Qb),delete Zd[b]);a.Zc=0}a.w&&(a.w.hd--,delete a.w);b=a.za;for(var d=c=!1;a.Rc.length&&!a.gd;){var e=a.Rc.shift(),f=e[0],g=e[1];e=e[2];if(f=a.Pb?g:f)try{var l=f.call(e||a.qe,b);ba(l)&&(a.Pb=a.Pb&&(l==b||l instanceof Error),a.za=b=l);if(td(b)||"function"===typeof k.Promise&&b instanceof k.Promise)d=!0,a.gd=!0}catch(n){b=n,a.Pb=!0,Yd(a)||(c=!0)}}a.za=b;d&&(l=r(a.oe,
a,!0),d=r(a.oe,a,!1),b instanceof Od?(Wd(b,l,d),b.ge=!0):b.then(l,d));c&&(b=new $d(b),Zd[b.Qb]=b,a.Zc=b.Qb)},Td=function(){u.call(this)};t(Td,u);Td.prototype.message="Deferred has already fired";Td.prototype.name="AlreadyCalledError";var Qd=function(){u.call(this)};t(Qd,u);Qd.prototype.message="Deferred was canceled";Qd.prototype.name="CanceledError";var $d=function(a){this.Qb=k.setTimeout(r(this.xg,this),0);this.ba=a};
$d.prototype.xg=function(){w(Zd[this.Qb],"Cannot throw an error that is not scheduled.");delete Zd[this.Qb];throw this.ba;};var Zd={};var ee=function(a){var b={},c=b.document||document,d=Ka(a),e=document.createElement("SCRIPT"),f={Te:e,jc:void 0},g=new Od(ae,f),l=null,n=null!=b.timeout?b.timeout:5E3;0<n&&(l=window.setTimeout(function(){be(e,!0);Pd(g,new ce(1,"Timeout reached for loading script "+d))},n),f.jc=l);e.onload=e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(be(e,b.Og||!1,l),g.callback(null))};e.onerror=function(){be(e,!0,l);Pd(g,new ce(0,"Error while loading script "+d))};
f=b.attributes||{};mb(f,{type:"text/javascript",charset:"UTF-8"});od(e,f);ld(e,a);de(c).appendChild(e);return g},de=function(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement},ae=function(){if(this&&this.Te){var a=this.Te;a&&"SCRIPT"==a.tagName&&be(a,!0,this.jc)}},be=function(a,b,c){null!=c&&k.clearTimeout(c);a.onload=da;a.onerror=da;a.onreadystatechange=da;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)},ce=function(a,
b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);u.call(this,c);this.code=a};t(ce,u);var fe=function(a,b,c,d,e){this.reset(a,b,c,d,e)};fe.prototype.se=null;var ge=0;fe.prototype.reset=function(a,b,c,d,e){"number"==typeof e||ge++;d||ma();this.Vb=a;this.Zf=b;delete this.se};fe.prototype.Ue=function(a){this.Vb=a};var he=function(a){this.Je=a;this.ze=this.kd=this.Vb=this.w=null},ie=function(a,b){this.name=a;this.value=b};ie.prototype.toString=function(){return this.name};var je=new ie("SEVERE",1E3),ke=new ie("INFO",800),le=new ie("CONFIG",700),me=new ie("FINE",500);he.prototype.getName=function(){return this.Je};he.prototype.getParent=function(){return this.w};he.prototype.Ue=function(a){this.Vb=a};var ne=function(a){if(a.Vb)return a.Vb;if(a.w)return ne(a.w);Aa("Root logger has no level set.");return null};
he.prototype.log=function(a,b,c){if(a.value>=ne(this).value)for(p(b)&&(b=b()),a=new fe(a,String(b),this.Je),c&&(a.se=c),c="log:"+a.Zf,(b=k.console)&&b.timeStamp&&b.timeStamp(c),(b=k.msWriteProfilerMark)&&b(c),c=this;c;){var d=c,e=a;if(d.ze)for(var f=0;b=d.ze[f];f++)b(e);c=c.getParent()}};he.prototype.info=function(a,b){this.log(ke,a,b)};he.prototype.config=function(a,b){this.log(le,a,b)};
var oe={},pe=null,qe=function(a){pe||(pe=new he(""),oe[""]=pe,pe.Ue(le));var b;if(!(b=oe[a])){b=new he(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=qe(a.substr(0,c));c.kd||(c.kd={});c.kd[d]=b;b.w=c;oe[a]=b}return b};var G=function(){Ub.call(this);this.ga=new dc(this);this.kf=this;this.Kd=null};t(G,Ub);G.prototype[$b]=!0;h=G.prototype;h.addEventListener=function(a,b,c,d){lc(this,a,b,c,d)};h.removeEventListener=function(a,b,c,d){tc(this,a,b,c,d)};
h.dispatchEvent=function(a){re(this);var b=this.Kd;if(b){var c=[];for(var d=1;b;b=b.Kd)c.push(b),w(1E3>++d,"infinite loop")}b=this.kf;d=a.type||a;if(m(a))a=new B(a,b);else if(a instanceof B)a.target=a.target||b;else{var e=a;a=new B(d,b);mb(a,e)}e=!0;if(c)for(var f=c.length-1;!a.Wa&&0<=f;f--){var g=a.currentTarget=c[f];e=se(g,d,!0,a)&&e}a.Wa||(g=a.currentTarget=b,e=se(g,d,!0,a)&&e,a.Wa||(e=se(g,d,!1,a)&&e));if(c)for(f=0;!a.Wa&&f<c.length;f++)g=a.currentTarget=c[f],e=se(g,d,!1,a)&&e;return e};
h.lb=function(){G.Vc.lb.call(this);if(this.ga){var a=this.ga,b=0,c;for(c in a.I){for(var d=a.I[c],e=0;e<d.length;e++)++b,cc(d[e]);delete a.I[c];a.kc--}}this.Kd=null};h.listen=function(a,b,c,d){re(this);return this.ga.add(String(a),b,!1,c,d)};
var sc=function(a,b,c,d,e){a.ga.add(String(b),c,!0,d,e)},se=function(a,b,c,d){b=a.ga.I[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.Bb&&g.capture==c){var l=g.listener,n=g.wc||g.src;g.qc&&fc(a.ga,g);e=!1!==l.call(n,d)&&e}}return e&&0!=d.Se};G.prototype.td=function(a,b,c,d){return this.ga.td(String(a),b,c,d)};G.prototype.hasListener=function(a,b){return this.ga.hasListener(ba(a)?String(a):void 0,b)};var re=function(a){w(a.ga,"Event target is not initialized. Did you call the superclass (goog.events.EventTarget) constructor?")};var te="StopIteration"in k?k.StopIteration:{message:"StopIteration",stack:""},ue=function(){};ue.prototype.next=function(){throw te;};ue.prototype.jf=function(){return this};var H=function(a,b){a&&a.log(me,b,void 0)};var ve=function(a,b){this.ja={};this.B=[];this.gb=this.u=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else a&&this.addAll(a)};h=ve.prototype;h.ha=function(){we(this);for(var a=[],b=0;b<this.B.length;b++)a.push(this.ja[this.B[b]]);return a};h.va=function(){we(this);return this.B.concat()};h.Jb=function(a){return xe(this.ja,a)};h.clear=function(){this.ja={};this.gb=this.u=this.B.length=0};
h.remove=function(a){return xe(this.ja,a)?(delete this.ja[a],this.u--,this.gb++,this.B.length>2*this.u&&we(this),!0):!1};var we=function(a){if(a.u!=a.B.length){for(var b=0,c=0;b<a.B.length;){var d=a.B[b];xe(a.ja,d)&&(a.B[c++]=d);b++}a.B.length=c}if(a.u!=a.B.length){var e={};for(c=b=0;b<a.B.length;)d=a.B[b],xe(e,d)||(a.B[c++]=d,e[d]=1),b++;a.B.length=c}};h=ve.prototype;h.get=function(a,b){return xe(this.ja,a)?this.ja[a]:b};
h.set=function(a,b){xe(this.ja,a)||(this.u++,this.B.push(a),this.gb++);this.ja[a]=b};h.addAll=function(a){if(a instanceof ve){var b=a.va();a=a.ha()}else b=hb(a),a=gb(a);for(var c=0;c<b.length;c++)this.set(b[c],a[c])};h.forEach=function(a,b){for(var c=this.va(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};h.clone=function(){return new ve(this)};
h.jf=function(a){we(this);var b=0,c=this.gb,d=this,e=new ue;e.next=function(){if(c!=d.gb)throw Error("The map has changed since the iterator was created");if(b>=d.B.length)throw te;var e=d.B[b++];return a?e:d.ja[e]};return e};var xe=function(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var ye=function(a){if(a.ha&&"function"==typeof a.ha)return a.ha();if(m(a))return a.split("");if(ia(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}return gb(a)},ze=function(a){if(a.va&&"function"==typeof a.va)return a.va();if(!a.ha||"function"!=typeof a.ha){if(ia(a)||m(a)){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}return hb(a)}},Ae=function(a,b,c){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,c);else if(ia(a)||m(a))x(a,b,c);else for(var d=ze(a),e=ye(a),f=e.length,
g=0;g<f;g++)b.call(c,e[g],d&&d[g],a)};var Be=function(a,b,c){if(p(a))c&&(a=r(a,c));else if(a&&"function"==typeof a.handleEvent)a=r(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:k.setTimeout(a,b||0)},Ce=function(a){var b=null;return(new C(function(c,d){b=Be(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).g(function(a){k.clearTimeout(b);throw a;})};var De=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/,Ee=function(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}};var I=function(a){G.call(this);this.headers=new ve;this.ed=a||null;this.Ca=!1;this.dd=this.b=null;this.Ub=this.Ie=this.Fc="";this.Qa=this.zd=this.Ac=this.od=!1;this.Db=0;this.Wc=null;this.Pc="";this.$c=this.fg=this.df=!1};t(I,G);var Fe=I.prototype,Ge=qe("goog.net.XhrIo");Fe.R=Ge;var He=/^https?$/i,Ie=["POST","PUT"];
I.prototype.send=function(a,b,c,d){if(this.b)throw Error("[goog.net.XhrIo] Object is active with another request="+this.Fc+"; newUri="+a);b=b?b.toUpperCase():"GET";this.Fc=a;this.Ub="";this.Ie=b;this.od=!1;this.Ca=!0;this.b=this.ed?this.ed.sc():Nc.sc();this.dd=this.ed?Mc(this.ed):Mc(Nc);this.b.onreadystatechange=r(this.Pe,this);this.fg&&"onprogress"in this.b&&(this.b.onprogress=r(function(a){this.Oe(a,!0)},this),this.b.upload&&(this.b.upload.onprogress=r(this.Oe,this)));try{H(this.R,Je(this,"Opening Xhr")),
this.zd=!0,this.b.open(b,String(a),!0),this.zd=!1}catch(f){H(this.R,Je(this,"Error opening Xhr: "+f.message));this.ba(5,f);return}a=c||"";var e=this.headers.clone();d&&Ae(d,function(a,b){e.set(b,a)});d=Ua(e.va());c=k.FormData&&a instanceof k.FormData;!Va(Ie,b)||d||c||e.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");e.forEach(function(a,b){this.b.setRequestHeader(b,a)},this);this.Pc&&(this.b.responseType=this.Pc);"withCredentials"in this.b&&this.b.withCredentials!==this.df&&
(this.b.withCredentials=this.df);try{Ke(this),0<this.Db&&(this.$c=Le(this.b),H(this.R,Je(this,"Will abort after "+this.Db+"ms if incomplete, xhr2 "+this.$c)),this.$c?(this.b.timeout=this.Db,this.b.ontimeout=r(this.jc,this)):this.Wc=Be(this.jc,this.Db,this)),H(this.R,Je(this,"Sending request")),this.Ac=!0,this.b.send(a),this.Ac=!1}catch(f){H(this.R,Je(this,"Send error: "+f.message)),this.ba(5,f)}};
var Le=function(a){return z&&A(9)&&"number"==typeof a.timeout&&ba(a.ontimeout)},Ta=function(a){return"content-type"==a.toLowerCase()};I.prototype.jc=function(){"undefined"!=typeof aa&&this.b&&(this.Ub="Timed out after "+this.Db+"ms, aborting",H(this.R,Je(this,this.Ub)),this.dispatchEvent("timeout"),this.abort(8))};I.prototype.ba=function(a,b){this.Ca=!1;this.b&&(this.Qa=!0,this.b.abort(),this.Qa=!1);this.Ub=b;Me(this);Ne(this)};var Me=function(a){a.od||(a.od=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))};
I.prototype.abort=function(){this.b&&this.Ca&&(H(this.R,Je(this,"Aborting")),this.Ca=!1,this.Qa=!0,this.b.abort(),this.Qa=!1,this.dispatchEvent("complete"),this.dispatchEvent("abort"),Ne(this))};I.prototype.lb=function(){this.b&&(this.Ca&&(this.Ca=!1,this.Qa=!0,this.b.abort(),this.Qa=!1),Ne(this,!0));I.Vc.lb.call(this)};I.prototype.Pe=function(){this.isDisposed()||(this.zd||this.Ac||this.Qa?Oe(this):this.bg())};I.prototype.bg=function(){Oe(this)};
var Oe=function(a){if(a.Ca&&"undefined"!=typeof aa)if(a.dd[1]&&4==Pe(a)&&2==Qe(a))H(a.R,Je(a,"Local request error detected and ignored"));else if(a.Ac&&4==Pe(a))Be(a.Pe,0,a);else if(a.dispatchEvent("readystatechange"),4==Pe(a)){H(a.R,Je(a,"Request complete"));a.Ca=!1;try{var b=Qe(a);a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.Fc).match(De)[1]||null;if(!f&&k.self&&k.self.location){var g=
k.self.location.protocol;f=g.substr(0,g.length-1)}e=!He.test(f?f.toLowerCase():"")}d=e}if(d)a.dispatchEvent("complete"),a.dispatchEvent("success");else{try{var l=2<Pe(a)?a.b.statusText:""}catch(n){H(a.R,"Can not get status: "+n.message),l=""}a.Ub=l+" ["+Qe(a)+"]";Me(a)}}finally{Ne(a)}}};I.prototype.Oe=function(a,b){w("progress"===a.type,"goog.net.EventType.PROGRESS is of the same type as raw XHR progress.");this.dispatchEvent(Re(a,"progress"));this.dispatchEvent(Re(a,b?"downloadprogress":"uploadprogress"))};
var Re=function(a,b){return{type:b,lengthComputable:a.lengthComputable,loaded:a.loaded,total:a.total}},Ne=function(a,b){if(a.b){Ke(a);var c=a.b,d=a.dd[0]?da:null;a.b=null;a.dd=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.R)&&a.log(je,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}},Ke=function(a){a.b&&a.$c&&(a.b.ontimeout=null);a.Wc&&(k.clearTimeout(a.Wc),a.Wc=null)},Pe=function(a){return a.b?a.b.readyState:0},Qe=function(a){try{return 2<Pe(a)?
a.b.status:-1}catch(b){return-1}},Se=function(a){try{return a.b?a.b.responseText:""}catch(b){return H(a.R,"Can not get responseText: "+b.message),""}};
I.prototype.getResponse=function(){try{if(!this.b)return null;if("response"in this.b)return this.b.response;switch(this.Pc){case "":case "text":return this.b.responseText;case "arraybuffer":if("mozResponseArrayBuffer"in this.b)return this.b.mozResponseArrayBuffer}var a=this.R;a&&a.log(je,"Response type "+this.Pc+" is not supported on this browser",void 0);return null}catch(b){return H(this.R,"Can not get response: "+b.message),null}};
I.prototype.getResponseHeader=function(a){if(this.b&&4==Pe(this))return a=this.b.getResponseHeader(a),null===a?void 0:a};I.prototype.getAllResponseHeaders=function(){return this.b&&4==Pe(this)?this.b.getAllResponseHeaders():""};var Je=function(a,b){return b+" ["+a.Ie+" "+a.Fc+" "+Qe(a)+"]"};var Te=function(a,b){this.pa=this.eb=this.qa="";this.vb=null;this.Pa=this.Ga="";this.da=this.Uf=!1;if(a instanceof Te){this.da=ba(b)?b:a.da;Ue(this,a.qa);var c=a.eb;J(this);this.eb=c;Ve(this,a.pa);We(this,a.vb);Xe(this,a.Ga);Ye(this,a.ea.clone());a=a.Pa;J(this);this.Pa=a}else a&&(c=String(a).match(De))?(this.da=!!b,Ue(this,c[1]||"",!0),a=c[2]||"",J(this),this.eb=Ze(a),Ve(this,c[3]||"",!0),We(this,c[4]),Xe(this,c[5]||"",!0),Ye(this,c[6]||"",!0),a=c[7]||"",J(this),this.Pa=Ze(a)):(this.da=!!b,this.ea=
new $e(null,0,this.da))};Te.prototype.toString=function(){var a=[],b=this.qa;b&&a.push(af(b,bf,!0),":");var c=this.pa;if(c||"file"==b)a.push("//"),(b=this.eb)&&a.push(af(b,bf,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.vb,null!=c&&a.push(":",String(c));if(c=this.Ga)this.pa&&"/"!=c.charAt(0)&&a.push("/"),a.push(af(c,"/"==c.charAt(0)?cf:df,!0));(c=this.ea.toString())&&a.push("?",c);(c=this.Pa)&&a.push("#",af(c,ef));return a.join("")};
Te.prototype.resolve=function(a){var b=this.clone(),c=!!a.qa;c?Ue(b,a.qa):c=!!a.eb;if(c){var d=a.eb;J(b);b.eb=d}else c=!!a.pa;c?Ve(b,a.pa):c=null!=a.vb;d=a.Ga;if(c)We(b,a.vb);else if(c=!!a.Ga){if("/"!=d.charAt(0))if(this.pa&&!this.Ga)d="/"+d;else{var e=b.Ga.lastIndexOf("/");-1!=e&&(d=b.Ga.substr(0,e+1)+d)}e=d;if(".."==e||"."==e)d="";else if(v(e,"./")||v(e,"/.")){d=0==e.lastIndexOf("/",0);e=e.split("/");for(var f=[],g=0;g<e.length;){var l=e[g++];"."==l?d&&g==e.length&&f.push(""):".."==l?((1<f.length||
1==f.length&&""!=f[0])&&f.pop(),d&&g==e.length&&f.push("")):(f.push(l),d=!0)}d=f.join("/")}else d=e}c?Xe(b,d):c=""!==a.ea.toString();c?Ye(b,a.ea.clone()):c=!!a.Pa;c&&(a=a.Pa,J(b),b.Pa=a);return b};Te.prototype.clone=function(){return new Te(this)};
var Ue=function(a,b,c){J(a);a.qa=c?Ze(b,!0):b;a.qa&&(a.qa=a.qa.replace(/:$/,""))},Ve=function(a,b,c){J(a);a.pa=c?Ze(b,!0):b},We=function(a,b){J(a);if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.vb=b}else a.vb=null},Xe=function(a,b,c){J(a);a.Ga=c?Ze(b,!0):b},Ye=function(a,b,c){J(a);b instanceof $e?(a.ea=b,a.ea.Zd(a.da)):(c||(b=af(b,ff)),a.ea=new $e(b,0,a.da))},K=function(a,b,c){J(a);a.ea.set(b,c)},gf=function(a,b){return a.ea.get(b)};
Te.prototype.removeParameter=function(a){J(this);this.ea.remove(a);return this};var J=function(a){if(a.Uf)throw Error("Tried to modify a read-only Uri");};Te.prototype.Zd=function(a){this.da=a;this.ea&&this.ea.Zd(a);return this};
var hf=function(a){return a instanceof Te?a.clone():new Te(a,void 0)},jf=function(a,b){var c=new Te(null,void 0);Ue(c,"https");a&&Ve(c,a);b&&Xe(c,b);return c},Ze=function(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""},af=function(a,b,c){return m(a)?(a=encodeURI(a).replace(b,kf),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null},kf=function(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)},bf=/[#\/\?@]/g,df=/[\#\?:]/g,cf=/[\#\?]/g,ff=/[\#\?@]/g,
ef=/#/g,$e=function(a,b,c){this.u=this.s=null;this.V=a||null;this.da=!!c},lf=function(a){a.s||(a.s=new ve,a.u=0,a.V&&Ee(a.V,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))},nf=function(a){var b=ze(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new $e(null,0,void 0);a=ye(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];ha(f)?mf(c,e,f):c.add(e,f)}return c};h=$e.prototype;
h.add=function(a,b){lf(this);this.V=null;a=this.ca(a);var c=this.s.get(a);c||this.s.set(a,c=[]);c.push(b);this.u=Ba(this.u)+1;return this};h.remove=function(a){lf(this);a=this.ca(a);return this.s.Jb(a)?(this.V=null,this.u=Ba(this.u)-this.s.get(a).length,this.s.remove(a)):!1};h.clear=function(){this.s=this.V=null;this.u=0};h.Jb=function(a){lf(this);a=this.ca(a);return this.s.Jb(a)};h.forEach=function(a,b){lf(this);this.s.forEach(function(c,d){x(c,function(c){a.call(b,c,d,this)},this)},this)};
h.va=function(){lf(this);for(var a=this.s.ha(),b=this.s.va(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};h.ha=function(a){lf(this);var b=[];if(m(a))this.Jb(a)&&(b=Za(b,this.s.get(this.ca(a))));else{a=this.s.ha();for(var c=0;c<a.length;c++)b=Za(b,a[c])}return b};h.set=function(a,b){lf(this);this.V=null;a=this.ca(a);this.Jb(a)&&(this.u=Ba(this.u)-this.s.get(a).length);this.s.set(a,[b]);this.u=Ba(this.u)+1;return this};
h.get=function(a,b){a=a?this.ha(a):[];return 0<a.length?String(a[0]):b};var mf=function(a,b,c){a.remove(b);0<c.length&&(a.V=null,a.s.set(a.ca(b),$a(c)),a.u=Ba(a.u)+c.length)};h=$e.prototype;h.toString=function(){if(this.V)return this.V;if(!this.s)return"";for(var a=[],b=this.s.va(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.ha(d);for(var f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}}return this.V=a.join("&")};
h.clone=function(){var a=new $e;a.V=this.V;this.s&&(a.s=this.s.clone(),a.u=this.u);return a};h.ca=function(a){a=String(a);this.da&&(a=a.toLowerCase());return a};h.Zd=function(a){a&&!this.da&&(lf(this),this.V=null,this.s.forEach(function(a,c){var b=c.toLowerCase();c!=b&&(this.remove(c),mf(this,b,a))},this));this.da=a};h.extend=function(a){for(var b=0;b<arguments.length;b++)Ae(arguments[b],function(a,b){this.add(b,a)},this)};var of={Jg:{qd:"https://www.googleapis.com/identitytoolkit/v3/relyingparty/",Vd:"https://securetoken.googleapis.com/v1/token",id:"p"},Kg:{qd:"https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",Vd:"https://staging-securetoken.sandbox.googleapis.com/v1/token",id:"s"},Lg:{qd:"https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",Vd:"https://test-securetoken.sandbox.googleapis.com/v1/token",id:"t"}},pf=function(a){for(var b in of)if(of[b].id===a)return a=
of[b],{firebaseEndpoint:a.qd,secureTokenEndpoint:a.Vd};return null},qf;qf=pf("__EID__")?"__EID__":void 0;var rf=function(){var a=L();return z&&!!Cb&&11==Cb||/Edge\/\d+/.test(a)},sf=function(){return k.window&&k.window.location.href||""},tf=function(a,b){b=b||k.window;var c="about:blank";a&&(c=Bc(Ec(a)));b.location.href=c},uf=function(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):ha(a[d])?jb(a[d],b[d])||c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<uf(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c},wf=function(){var a=
L();a="Chrome"!=vf(a)?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!z||!Cb||9<Cb},xf=function(a){a=(a||L()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1},yf=function(a){a=a||k.window;try{a.close()}catch(b){}},zf=function(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-
b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=L().toLowerCase();d&&(b.target=d,v(c,"crios/")&&(b.target="_blank"));"Firefox"==vf(L())&&(a=a||"http://localhost",b.scrollbars=!0);c=a||"";(d=b)||(d={});a=window;b=c instanceof Ac?c:Ec("undefined"!=typeof c.href?c.href:String(c));c=d.target||c.target;e=[];for(g in d)switch(g){case "width":case "height":case "top":case "left":e.push(g+"="+d[g]);break;case "target":case "noreferrer":break;default:e.push(g+
"="+(d[g]?1:0))}var g=e.join(",");(y("iPhone")&&!y("iPod")&&!y("iPad")||y("iPad")||y("iPod"))&&a.navigator&&a.navigator.standalone&&c&&"_self"!=c?(g=a.document.createElement("A"),e=gd(g),"undefined"!=typeof e.HTMLAnchorElement&&"undefined"!=typeof e.Location&&"undefined"!=typeof e.Element&&w(g&&(g instanceof e.HTMLAnchorElement||!(g instanceof e.Location||g instanceof e.Element)),"Argument is not a HTMLAnchorElement (or a non-Element mock); got: %s",fd(g)),b instanceof Ac||b instanceof Ac||(b=b.qb?
b.ob():String(b),w(Cc.test(b))||(b="about:invalid#zClosurez"),b=Dc(b)),g.href=Bc(b),g.setAttribute("target",c),d.noreferrer&&g.setAttribute("rel","noreferrer"),d=document.createEvent("MouseEvent"),d.initMouseEvent("click",!0,!0,a,1),g.dispatchEvent(d),g={}):d.noreferrer?(g=a.open("",c,g),d=Bc(b),g&&(sb&&v(d,";")&&(d="'"+d.replace(/'/g,"%27")+"'"),g.opener=null,a=Ha("b/12014412, meta tag with sanitized URL"),d='<META HTTP-EQUIV="refresh" content="0; url='+wa(d)+'">',Ca(Ga(a),"must provide justification"),
w(!/^[\s\xa0]*$/.test(Ga(a)),"must provide non-empty justification"),g.document.write(kd((new jd).Qf(d))),g.document.close())):g=a.open(Bc(b),c,g);if(g)try{g.focus()}catch(l){}return g},Af=function(a){return new C(function(b){var c=function(){Ce(2E3).then(function(){if(!a||a.closed)b();else return c()})};return c()})},Bf=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,Cf=function(){var a=null;return(new C(function(b){"complete"==k.document.readyState?b():(a=function(){b()},kc(window,"load",a))})).g(function(b){tc(window,
"load",a);throw b;})},Ef=function(){return Df(void 0)?Cf().then(function(){return new C(function(a,b){var c=k.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):E(Error("Cordova must run in an Android or iOS file scheme."))},Df=function(a){a=a||L();return!("file:"!==Ff()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))},Gf=function(){var a=k.window;try{return!(!a||a==a.top)}catch(b){return!1}},
Hf=function(){return firebase.INTERNAL.hasOwnProperty("reactNative")?"ReactNative":firebase.INTERNAL.hasOwnProperty("node")?"Node":"Browser"},If=function(){var a=Hf();return"ReactNative"===a||"Node"===a},vf=function(a){var b=a.toLowerCase();if(v(b,"opera/")||v(b,"opr/")||v(b,"opios/"))return"Opera";if(v(b,"iemobile"))return"IEMobile";if(v(b,"msie")||v(b,"trident/"))return"IE";if(v(b,"edge/"))return"Edge";if(v(b,"firefox/"))return"Firefox";if(v(b,"silk/"))return"Silk";if(v(b,"blackberry"))return"Blackberry";
if(v(b,"webos"))return"Webos";if(!v(b,"safari/")||v(b,"chrome/")||v(b,"crios/")||v(b,"android"))if(!v(b,"chrome/")&&!v(b,"crios/")||v(b,"edge/")){if(v(b,"android"))return"Android";if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&2==a.length)return a[1]}else return"Chrome";else return"Safari";return"Other"},Jf={Eg:"FirebaseCore-web",Gg:"FirebaseUI-web"},Kf=function(a,b){b=b||[];var c=[],d={},e;for(e in Jf)d[Jf[e]]=!0;for(e=0;e<b.length;e++)"undefined"!==typeof d[b[e]]&&(delete d[b[e]],c.push(b[e]));
c.sort();b=c;b.length||(b=["FirebaseCore-web"]);c=Hf();return("Browser"===c?vf(L()):c)+"/JsCore/"+a+"/"+b.join(",")},L=function(){return k.navigator&&k.navigator.userAgent||""},M=function(a,b){a=a.split(".");b=b||k;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b},Mf=function(){try{var a=k.localStorage,b=Lf();if(a)return a.setItem(b,"1"),a.removeItem(b),rf()?!!k.indexedDB:!0}catch(c){}return!1},Of=function(){return(Nf()||"chrome-extension:"===Ff()||
Df())&&!If()&&Mf()},Nf=function(){return"http:"===Ff()||"https:"===Ff()},Ff=function(){return k.location&&k.location.protocol||null},Pf=function(a){a=a||L();return xf(a)||"Firefox"==vf(a)?!1:!0},Qf=function(a){return"undefined"===typeof a?null:Hc(a)},Rf=function(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b},Sf=function(a){if(null!==a)return JSON.parse(a)},Lf=function(a){return a?a:""+Math.floor(1E9*Math.random()).toString()},Tf=function(a){a=a||L();
return"Safari"==vf(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0},Uf=function(){var a=k.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null},Vf=function(){var a=k.navigator;return a&&"boolean"===typeof a.onLine&&(Nf()||"chrome-extension:"===Ff()||"undefined"!==typeof a.connection)?a.onLine:!0},Wf=function(a,b,c,d){if(a>b)throw Error("Short delay should be less than long delay!");this.tg=a;
this.Yf=b;a=c||L();d=d||Hf();this.Tf=xf(a)||"ReactNative"===d};Wf.prototype.get=function(){return this.Tf?this.Yf:this.tg};
var Xf=function(){var a=k.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0},Yf=function(){var a=k.document,b=null;return Xf()||!a?D():(new C(function(c){b=function(){Xf()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).g(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})};var Zf={};var $f;try{var ag={};Object.defineProperty(ag,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(ag,"abcd",{configurable:!0,enumerable:!0,value:2});$f=2==ag.abcd}catch(a){$f=!1}
var N=function(a,b,c){$f?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c},bg=function(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&N(a,c,b[c])},cg=function(a){var b={};bg(b,a);return b},dg=function(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=a[c]);return b},eg=function(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0},fg=function(a){var b=a;if("object"==typeof a&&null!=a){b=
"length"in a?[]:{};for(var c in a)N(b,c,fg(a[c]))}return b};var gg="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),hg=["client_id","response_type","scope","redirect_uri","state"],ig={Fg:{Ec:"locale",Zb:500,Yb:600,providerId:"facebook.com",Td:hg},Hg:{Ec:null,Zb:500,Yb:620,providerId:"github.com",Td:hg},Ig:{Ec:"hl",Zb:515,Yb:680,providerId:"google.com",Td:hg},Mg:{Ec:"lang",Zb:485,Yb:705,providerId:"twitter.com",Td:gg}},jg=function(a){for(var b in ig)if(ig[b].providerId==a)return ig[b];
return null};var O=function(a,b){this.code="auth/"+a;this.message=b||kg[a]||""};t(O,Error);O.prototype.G=function(){return{code:this.code,message:this.message}};O.prototype.toJSON=function(){return this.G()};
var lg=function(a){var b=a&&a.code;return b?new O(b.substring(5),a.message):null},kg={"argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.","captcha-check-failed":"The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
"code-expired":"The SMS code has expired. Please re-send the verification code to try again.","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.","requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
"dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.","email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.","internal-error":"An internal error has occurred.","invalid-app-credential":"The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
"invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"The user's credential is no longer valid. The user must sign in again.","invalid-auth-event":"An internal error has occurred.","invalid-verification-code":"The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.","invalid-continue-uri":"The continue URL provided in the request is invalid.",
"invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.","invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.","invalid-credential":"The supplied auth credential is malformed or has expired.",
"invalid-persistence-type":"The specified persistence type is invalid. It can only be local, session or none.","invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.","invalid-oauth-client-id":"The OAuth client ID provided is either invalid or does not match the specified API key.",
"unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.","invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.","wrong-password":"The password is invalid or the user does not have a password.","invalid-phone-number":"The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
"invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.","invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-verification-id":"The verification ID used to create the phone auth credential is invalid.","missing-android-pkg-name":"An Android Package Name must be provided if the Android App is required to be installed.",
"auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.","missing-app-credential":"The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.","missing-verification-code":"The phone auth credential was created with an empty SMS verification code.","missing-continue-uri":"A continue URL must be provided in the request.","missing-iframe-start":"An internal error has occurred.",
"missing-ios-bundle-id":"An iOS Bundle ID must be provided if an App Store ID is provided.","missing-phone-number":"To send verification codes, provide a phone number for the recipient.","missing-verification-id":"The phone auth credential was created with an empty verification ID.","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
"network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.","no-auth-event":"An internal error has occurred.","no-such-provider":"User was not linked to an account with the given provider.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.","operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.","quota-exceeded":"The SMS quota for this project has been exceeded.","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.",
timeout:"The operation has timed out.","user-token-expired":"The user's credential is no longer valid. The user must sign in again.","too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.","unauthorized-continue-uri":"The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.","unsupported-persistence-type":"The current environment does not support the specified persistence type.","user-cancelled":"User did not grant your application the permissions it requested.",
"user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.","user-mismatch":"The supplied credentials do not correspond to the previously signed in user.","user-signed-out":"","weak-password":"The password must be 6 characters long or more.","web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};var mg=function(a,b,c,d,e){this.ma=a;this.W=b||null;this.Eb=c||null;this.Xd=d||null;this.ba=e||null;if(this.Eb||this.ba){if(this.Eb&&this.ba)throw new O("invalid-auth-event");if(this.Eb&&!this.Xd)throw new O("invalid-auth-event");}else throw new O("invalid-auth-event");};mg.prototype.uc=function(){return this.Xd};mg.prototype.getError=function(){return this.ba};mg.prototype.G=function(){return{type:this.ma,eventId:this.W,urlResponse:this.Eb,sessionId:this.Xd,error:this.ba&&this.ba.G()}};
var ng=function(a){a=a||{};return a.type?new mg(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&lg(a.error)):null};var og=function(a){var b="unauthorized-domain",c=void 0,d=hf(a);a=d.pa;d=d.qa;"chrome-extension"==d?c=na("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=na("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b=
"operation-not-supported-in-this-environment";O.call(this,b,c)};t(og,O);var pg=function(a){this.Wf=a.sub;ma();this.Mb=a.email||null;this.gg=a.provider_id||null;this.mf=!!a.is_anonymous||"anonymous"==this.gg};pg.prototype.getEmail=function(){return this.Mb};pg.prototype.isAnonymous=function(){return this.mf};var qg=function(a,b){return a.then(function(a){if(a.idToken){a:{var c=a.idToken.split(".");if(3==c.length){c=c[1];for(var e=(4-c.length%4)%4,f=0;f<e;f++)c+=".";try{var g=JSON.parse(Hb(c));if(g.sub&&g.iss&&g.aud&&g.exp){var l=new pg(g);break a}}catch(n){}}l=null}if(!l||b!=l.Wf)throw new O("user-mismatch");return a}throw new O("user-mismatch");}).g(function(a){throw a&&a.code&&"auth/user-not-found"==a.code?new O("user-mismatch"):a;})},rg=function(a,b){if(b.idToken||b.accessToken)b.idToken&&N(this,"idToken",
b.idToken),b.accessToken&&N(this,"accessToken",b.accessToken);else if(b.oauthToken&&b.oauthTokenSecret)N(this,"accessToken",b.oauthToken),N(this,"secret",b.oauthTokenSecret);else throw new O("internal-error","failed to construct a credential");N(this,"providerId",a)};rg.prototype.Ob=function(a){return sg(a,tg(this))};rg.prototype.Gc=function(a,b){var c=tg(this);c.idToken=b;return ug(a,c)};rg.prototype.Gd=function(a,b){var c=tg(this);return qg(vg(a,c),b)};
var tg=function(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;return{postBody:nf(b).toString(),requestUri:"http://localhost"}};rg.prototype.G=function(){var a={providerId:this.providerId};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);return a};
var wg=function(a,b){this.jg=b||[];bg(this,{providerId:a,isOAuthProvider:!0});this.pe={};this.Ed=(jg(a)||{}).Ec||null;this.nd=null};wg.prototype.setCustomParameters=function(a){this.pe=kb(a);return this};var P=function(a){wg.call(this,a,hg);this.Ud=[]};t(P,wg);P.prototype.addScope=function(a){Va(this.Ud,a)||this.Ud.push(a);return this};P.prototype.xe=function(){return $a(this.Ud)};
P.prototype.credential=function(a,b){if(!a&&!b)throw new O("argument-error","credential failed: must provide the ID token and/or the access token.");return new rg(this.providerId,{idToken:a||null,accessToken:b||null})};var xg=function(){P.call(this,"facebook.com")};t(xg,P);N(xg,"PROVIDER_ID","facebook.com");
var yg=function(a){if(!a)throw new O("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;q(a)&&(b=a.accessToken);return(new xg).credential(null,b)},zg=function(){P.call(this,"github.com")};t(zg,P);N(zg,"PROVIDER_ID","github.com");var Ag=function(a){if(!a)throw new O("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;q(a)&&(b=a.accessToken);return(new zg).credential(null,b)},Bg=function(){P.call(this,"google.com");this.addScope("profile")};
t(Bg,P);N(Bg,"PROVIDER_ID","google.com");var Cg=function(a,b){var c=a;q(a)&&(c=a.idToken,b=a.accessToken);return(new Bg).credential(c,b)},Dg=function(){wg.call(this,"twitter.com",gg)};t(Dg,wg);N(Dg,"PROVIDER_ID","twitter.com");
var Eg=function(a,b){var c=a;q(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new O("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new rg("twitter.com",c)},Fg=function(a,b){this.Mb=a;this.Ld=b;N(this,"providerId","password")};Fg.prototype.Ob=function(a){return Q(a,Gg,{email:this.Mb,password:this.Ld})};Fg.prototype.Gc=function(a,b){return Q(a,Hg,{idToken:b,email:this.Mb,password:this.Ld})};
Fg.prototype.Gd=function(a,b){return qg(this.Ob(a),b)};Fg.prototype.G=function(){return{email:this.Mb,password:this.Ld}};var Ig=function(){bg(this,{providerId:"password",isOAuthProvider:!1})};bg(Ig,{PROVIDER_ID:"password"});var Jg=function(a){if(!(a.verificationId&&a.ad||a.ic&&a.phoneNumber))throw new O("internal-error");this.S=a;N(this,"providerId","phone")};Jg.prototype.Ob=function(a){return a.verifyPhoneNumber(Kg(this))};Jg.prototype.Gc=function(a,b){var c=Kg(this);c.idToken=b;return Q(a,Lg,c)};
Jg.prototype.Gd=function(a,b){var c=Kg(this);c.operation="REAUTH";a=Q(a,Mg,c);return qg(a,b)};Jg.prototype.G=function(){var a={providerId:"phone"};this.S.verificationId&&(a.verificationId=this.S.verificationId);this.S.ad&&(a.verificationCode=this.S.ad);this.S.ic&&(a.temporaryProof=this.S.ic);this.S.phoneNumber&&(a.phoneNumber=this.S.phoneNumber);return a};
var Kg=function(a){return a.S.ic&&a.S.phoneNumber?{temporaryProof:a.S.ic,phoneNumber:a.S.phoneNumber}:{sessionInfo:a.S.verificationId,code:a.S.ad}},Ng=function(a){try{this.qf=a||firebase.auth()}catch(b){throw new O("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}bg(this,{providerId:"phone",isOAuthProvider:!1})};
Ng.prototype.verifyPhoneNumber=function(a,b){var c=this.qf.f;return D(b.verify()).then(function(d){if(!m(d))throw new O("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":return Q(c,Og,{phoneNumber:a,recaptchaToken:d});default:throw new O("argument-error",'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};
var Pg=function(a,b){if(!a)throw new O("missing-verification-id");if(!b)throw new O("missing-verification-code");return new Jg({verificationId:a,ad:b})};bg(Ng,{PROVIDER_ID:"phone"});
var Qg=function(a){if(a.temporaryProof&&a.phoneNumber)return new Jg({ic:a.temporaryProof,phoneNumber:a.phoneNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret;a=a&&a.oauthIdToken;try{switch(b){case "google.com":return Cg(a,c);case "facebook.com":return yg(c);case "github.com":return Ag(c);case "twitter.com":return Eg(c,d);default:return(new P(b)).credential(a,c)}}catch(e){return null}},Rg=function(a){if(!a.isOAuthProvider)throw new O("invalid-oauth-provider");
};var Sg=function(a,b,c){O.call(this,a,c);a=b||{};a.email&&N(this,"email",a.email);a.phoneNumber&&N(this,"phoneNumber",a.phoneNumber);a.credential&&N(this,"credential",a.credential)};t(Sg,O);Sg.prototype.G=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.phoneNumber&&(a.phoneNumber=this.phoneNumber);var b=this.credential&&this.credential.G();b&&mb(a,b);return a};Sg.prototype.toJSON=function(){return this.G()};
var Tg=function(a){if(a.code){var b=a.code||"";0==b.indexOf("auth/")&&(b=b.substring(5));var c={credential:Qg(a)};if(a.email)c.email=a.email;else if(a.phoneNumber)c.phoneNumber=a.phoneNumber;else return new O(b,a.message||void 0);return new Sg(b,c,a.message)}return null};var Ug=function(a){this.Dg=a};t(Ug,Lc);Ug.prototype.sc=function(){return new this.Dg};Ug.prototype.Cd=function(){return{}};
var R=function(a,b,c){var d="Node"==Hf();d=k.XMLHttpRequest||d&&firebase.INTERNAL.node&&firebase.INTERNAL.node.XMLHttpRequest;if(!d)throw new O("internal-error","The XMLHttpRequest compatibility library was not found.");this.m=a;a=b||{};this.pg=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.qg=a.secureTokenTimeout||Vg;this.Qc=kb(a.secureTokenHeaders||Wg);this.Af=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.Bf=a.firebaseTimeout||
Xg;this.mb=kb(a.firebaseHeaders||Yg);c&&(this.mb["X-Client-Version"]=c,this.Qc["X-Client-Version"]=c);this.sf=new Qc;this.Cg=new Ug(d)},Zg,Vg=new Wf(3E4,6E4),Wg={"Content-Type":"application/x-www-form-urlencoded"},Xg=new Wf(3E4,6E4),Yg={"Content-Type":"application/json"},$g=function(a,b){b?a.mb["X-Firebase-Locale"]=b:delete a.mb["X-Firebase-Locale"]},ah=function(a,b){b?(a.mb["X-Client-Version"]=b,a.Qc["X-Client-Version"]=b):(delete a.mb["X-Client-Version"],delete a.Qc["X-Client-Version"])},ch=function(a,
b,c,d,e,f,g){Vf()?(wf()?a=r(a.sg,a):(Zg||(Zg=new C(function(a,b){bh(a,b)})),a=r(a.rg,a)),a(b,c,d,e,f,g)):c&&c(null)};
R.prototype.sg=function(a,b,c,d,e,f){var g="Node"==Hf(),l=If()?g?new I(this.Cg):new I:new I(this.sf);if(f){l.Db=Math.max(0,f);var n=setTimeout(function(){l.dispatchEvent("timeout")},f)}l.listen("complete",function(){n&&clearTimeout(n);var a=null;try{a=JSON.parse(Se(this))||null}catch(zb){a=null}b&&b(a)});sc(l,"ready",function(){n&&clearTimeout(n);this.Ma||(this.Ma=!0,this.lb())});sc(l,"timeout",function(){n&&clearTimeout(n);this.Ma||(this.Ma=!0,this.lb());b&&b(null)});l.send(a,c,d,e)};
var dh=Ha("https://apis.google.com/js/client.js?onload=%{onload}"),eh="__fcb"+Math.floor(1E6*Math.random()).toString(),bh=function(a,b){if(((window.gapi||{}).client||{}).request)a();else{k[eh]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))};var c=Ma(dh,{onload:eh});Xd(ee(c),function(){b(Error("CORS_UNSUPPORTED"))})}};
R.prototype.rg=function(a,b,c,d,e){var f=this;Zg.then(function(){window.gapi.client.setApiKey(f.m);var g=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(a){window.gapi.auth.setToken(g);b&&b(a)}})}).g(function(a){b&&b({error:{message:a&&a.message||"CORS_UNSUPPORTED"}})})};
var gh=function(a,b){return new C(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?ch(a,a.pg+"?key="+encodeURIComponent(a.m),function(a){a?a.error?d(fh(a)):a.access_token&&a.refresh_token?c(a):d(new O("internal-error")):d(new O("network-request-failed"))},"POST",nf(b).toString(),a.Qc,a.qg.get()):d(new O("internal-error"))})},hh=function(a,b,c,d,e,f){var g=hf(a.Af+b);K(g,"key",a.m);f&&K(g,"cb",ma().toString());var l="GET"==c;if(l)for(var n in d)d.hasOwnProperty(n)&&
K(g,n,d[n]);return new C(function(b,f){ch(a,g.toString(),function(a){a?a.error?f(fh(a,e||{})):b(a):f(new O("network-request-failed"))},c,l?void 0:Hc(Rf(d)),a.mb,a.Bf.get())})},ih=function(a){if(!yc.test(a.email))throw new O("invalid-email");},jh=function(a){"email"in a&&ih(a)},lh=function(a,b){return Q(a,kh,{identifier:b,continueUri:Nf()?sf():"http://localhost"}).then(function(a){return a.allProviders||[]})},nh=function(a){return Q(a,mh,{}).then(function(a){return a.authorizedDomains||[]})},oh=function(a){if(!a.idToken)throw new O("internal-error");
},ph=function(a){if(a.phoneNumber||a.temporaryProof){if(!a.phoneNumber||!a.temporaryProof)throw new O("internal-error");}else{if(!a.sessionInfo)throw new O("missing-verification-id");if(!a.code)throw new O("missing-verification-code");}};R.prototype.signInAnonymously=function(){return Q(this,qh,{})};R.prototype.updateEmail=function(a,b){return Q(this,rh,{idToken:a,email:b})};R.prototype.updatePassword=function(a,b){return Q(this,Hg,{idToken:a,password:b})};var sh={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};
R.prototype.updateProfile=function(a,b){var c={idToken:a},d=[];eb(sh,function(a,f){var e=b[f];null===e?d.push(a):f in b&&(c[f]=e)});d.length&&(c.deleteAttribute=d);return Q(this,rh,c)};R.prototype.sendPasswordResetEmail=function(a,b){a={requestType:"PASSWORD_RESET",email:a};mb(a,b);return Q(this,th,a)};R.prototype.sendEmailVerification=function(a,b){a={requestType:"VERIFY_EMAIL",idToken:a};mb(a,b);return Q(this,uh,a)};R.prototype.verifyPhoneNumber=function(a){return Q(this,vh,a)};
var xh=function(a,b,c){return Q(a,wh,{idToken:b,deleteProvider:c})},yh=function(a){if(!a.requestUri||!a.sessionId&&!a.postBody)throw new O("internal-error");},zh=function(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=Tg(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=Tg(a)):"EMAIL_EXISTS"==a.errorMessage&&(a.code="email-already-in-use",b=Tg(a));if(b)throw b;if(!a.idToken)throw new O("internal-error");},sg=function(a,
b){b.returnIdpCredential=!0;return Q(a,Ah,b)},ug=function(a,b){b.returnIdpCredential=!0;return Q(a,Bh,b)},vg=function(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return Q(a,Ch,b)},Dh=function(a){if(!a.oobCode)throw new O("invalid-action-code");};R.prototype.confirmPasswordReset=function(a,b){return Q(this,Eh,{oobCode:a,newPassword:b})};R.prototype.checkActionCode=function(a){return Q(this,Fh,{oobCode:a})};R.prototype.applyActionCode=function(a){return Q(this,Gh,{oobCode:a})};
var Gh={endpoint:"setAccountInfo",D:Dh,cb:"email"},Fh={endpoint:"resetPassword",D:Dh,$:function(a){if(!a.email||!a.requestType)throw new O("internal-error");}},Hh={endpoint:"signupNewUser",D:function(a){ih(a);if(!a.password)throw new O("weak-password");},$:oh,Aa:!0},kh={endpoint:"createAuthUri"},Ih={endpoint:"deleteAccount",ab:["idToken"]},wh={endpoint:"setAccountInfo",ab:["idToken","deleteProvider"],D:function(a){if(!ha(a.deleteProvider))throw new O("internal-error");}},Jh={endpoint:"getAccountInfo"},
uh={endpoint:"getOobConfirmationCode",ab:["idToken","requestType"],D:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new O("internal-error");},cb:"email"},th={endpoint:"getOobConfirmationCode",ab:["requestType"],D:function(a){if("PASSWORD_RESET"!=a.requestType)throw new O("internal-error");ih(a)},cb:"email"},mh={he:!0,endpoint:"getProjectConfig",Ce:"GET"},Kh={he:!0,endpoint:"getRecaptchaParam",Ce:"GET",$:function(a){if(!a.recaptchaSiteKey)throw new O("internal-error");}},Eh={endpoint:"resetPassword",
D:Dh,cb:"email"},Og={endpoint:"sendVerificationCode",ab:["phoneNumber","recaptchaToken"],cb:"sessionInfo"},rh={endpoint:"setAccountInfo",ab:["idToken"],D:jh,Aa:!0},Hg={endpoint:"setAccountInfo",ab:["idToken"],D:function(a){jh(a);if(!a.password)throw new O("weak-password");},$:oh,Aa:!0},qh={endpoint:"signupNewUser",$:oh,Aa:!0},Ah={endpoint:"verifyAssertion",D:yh,$:zh,Aa:!0},Ch={endpoint:"verifyAssertion",D:yh,$:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new O("user-not-found");
if(!a.idToken)throw new O("internal-error");},Aa:!0},Bh={endpoint:"verifyAssertion",D:function(a){yh(a);if(!a.idToken)throw new O("internal-error");},$:zh,Aa:!0},Lh={endpoint:"verifyCustomToken",D:function(a){if(!a.token)throw new O("invalid-custom-token");},$:oh,Aa:!0},Gg={endpoint:"verifyPassword",D:function(a){ih(a);if(!a.password)throw new O("wrong-password");},$:oh,Aa:!0},vh={endpoint:"verifyPhoneNumber",D:ph,$:oh},Lg={endpoint:"verifyPhoneNumber",D:function(a){if(!a.idToken)throw new O("internal-error");
ph(a)},$:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",Tg(a);oh(a)}},Mg={vf:{USER_NOT_FOUND:"user-not-found"},endpoint:"verifyPhoneNumber",D:ph,$:oh},Q=function(a,b,c){if(!eg(c,b.ab))return E(new O("internal-error"));var d=b.Ce||"POST",e;return D(c).then(b.D).then(function(){b.Aa&&(c.returnSecureToken=!0);return hh(a,b.endpoint,d,c,b.vf,b.he||!1)}).then(function(a){return e=a}).then(b.$).then(function(){if(!b.cb)return e;if(!(b.cb in e))throw new O("internal-error");return e[b.cb]})},
fh=function(a,b){var c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};if(c=d[c]?new O(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",
MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",
INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",
INVALID_PHONE_NUMBER:"invalid-phone-number",INVALID_SESSION_INFO:"invalid-verification-id",INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_PHONE_NUMBER:"missing-phone-number",MISSING_SESSION_INFO:"missing-verification-id",QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired",INVALID_CONTINUE_URI:"invalid-continue-uri",MISSING_ANDROID_PACKAGE_NAME:"missing-android-pkg-name",MISSING_IOS_BUNDLE_ID:"missing-ios-bundle-id",
UNAUTHORIZED_DOMAIN:"unauthorized-continue-uri",INVALID_OAUTH_CLIENT_ID:"invalid-oauth-client-id"};mb(d,b||{});b=(b=c.match(/^[^\s]+\s*:\s*(.*)$/))&&1<b.length?b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new O(d[e],b);!b&&a&&(b=Qf(a));return new O("internal-error",b)};var Nh=function(a){this.Ag=a;this.zc=null;this.Id=Mh(this)},Mh=function(a){return Oh().then(function(){return new C(function(b,c){M("gapi.iframes.getContext")().open({where:document.body,url:a.Ag,messageHandlersFilter:M("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),attributes:{style:{position:"absolute",top:"-100px",width:"1px",height:"1px"}},dontclear:!0},function(d){a.zc=d;a.zc.restyle({setHideOnLeave:!1});var e=setTimeout(function(){c(Error("Network Error"))},Ph.get()),f=function(){clearTimeout(e);
b()};d.ping(f).then(f,function(){c(Error("Network Error"))})})})})};Nh.prototype.sendMessage=function(a){var b=this;return this.Id.then(function(){return new C(function(c){b.zc.send(a.type,a,c,M("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})};
var Qh=function(a,b){a.Id.then(function(){a.zc.register("authEvent",b,M("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})},Rh=Ha("https://apis.google.com/js/api.js?onload=%{onload}"),Sh=new Wf(3E4,6E4),Ph=new Wf(5E3,15E3),Th=null,Oh=function(){return Th?Th:Th=(new C(function(a,b){if(Vf()){var c=function(){Uf();M("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){Uf();b(Error("Network Error"))},timeout:Sh.get()})};if(M("gapi.iframes.Iframe"))a();else if(M("gapi.load"))c();else{var d="__iframefcb"+
Math.floor(1E6*Math.random()).toString();k[d]=function(){M("gapi.load")?c():b(Error("Network Error"))};d=Ma(Rh,{onload:d});D(ee(d)).g(function(){b(Error("Network Error"))})}}else b(Error("Network Error"))})).g(function(a){Th=null;throw a;})};var Uh=function(a,b,c){this.A=a;this.m=b;this.o=c;this.fb=null;this.Ba=jf(this.A,"/__/auth/iframe");K(this.Ba,"apiKey",this.m);K(this.Ba,"appName",this.o);this.O=null;this.M=[]};Uh.prototype.$d=function(a){this.fb=a;return this};Uh.prototype.Yd=function(a){this.O=a;return this};
Uh.prototype.toString=function(){this.fb?K(this.Ba,"v",this.fb):this.Ba.removeParameter("v");this.O?K(this.Ba,"eid",this.O):this.Ba.removeParameter("eid");this.M.length?K(this.Ba,"fw",this.M.join(",")):this.Ba.removeParameter("fw");return this.Ba.toString()};var Vh=function(a,b,c,d,e){this.A=a;this.m=b;this.o=c;this.pf=d;this.fb=this.W=this.Sd=null;this.xb=e;this.O=null};Vh.prototype.$d=function(a){this.fb=a;return this};Vh.prototype.Yd=function(a){this.O=a;return this};
Vh.prototype.toString=function(){var a=jf(this.A,"/__/auth/handler");K(a,"apiKey",this.m);K(a,"appName",this.o);K(a,"authType",this.pf);if(this.xb.isOAuthProvider){var b=this.xb;try{var c=firebase.app(this.o).auth().ia}catch(l){c=null}b.nd=c;K(a,"providerId",this.xb.providerId);b=this.xb;c=Rf(b.pe);for(var d in c)c[d]=c[d].toString();d=b.jg;c=kb(c);for(var e=0;e<d.length;e++){var f=d[e];f in c&&delete c[f]}b.Ed&&b.nd&&!c[b.Ed]&&(c[b.Ed]=b.nd);ib(c)||K(a,"customParameters",Qf(c))}"function"===typeof this.xb.xe&&
(b=this.xb.xe(),b.length&&K(a,"scopes",b.join(",")));this.Sd?K(a,"redirectUrl",this.Sd):a.removeParameter("redirectUrl");this.W?K(a,"eventId",this.W):a.removeParameter("eventId");this.fb?K(a,"v",this.fb):a.removeParameter("v");if(this.nc)for(var g in this.nc)this.nc.hasOwnProperty(g)&&!gf(a,g)&&K(a,g,this.nc[g]);this.O?K(a,"eid",this.O):a.removeParameter("eid");g=Wh(this.o);g.length&&K(a,"fw",g.join(","));return a.toString()};
var Wh=function(a){try{return $a(firebase.app(a).auth().M)}catch(b){return[]}},Xh=function(a,b,c,d,e){this.A=a;this.m=b;this.o=c;this.La=d||null;this.O=e||null;this.f=this.yd=this.ve=null;this.ta=[];this.Bc=this.wa=null},Yh=function(a){var b=sf();return nh(a).then(function(a){a:{var c=hf(b),e=c.qa;c=c.pa;for(var f=0;f<a.length;f++){var g=a[f];var l=c;var n=e;0==g.indexOf("chrome-extension://")?l=hf(g).pa==l&&"chrome-extension"==n:"http"!=n&&"https"!=n?l=!1:Bf.test(g)?l=l==g:(g=g.split(".").join("\\."),
l=(new RegExp("^(.+\\."+g+"|"+g+")$","i")).test(l));if(l){a=!0;break a}}a=!1}if(!a)throw new og(sf());})};h=Xh.prototype;h.Sb=function(){if(this.Bc)return this.Bc;var a=this;return this.Bc=Cf().then(function(){if(!a.yd){var b=a.La,c=a.O,d=Wh(a.o);b=(new Uh(a.A,a.m,a.o)).$d(b).Yd(c);b.M=$a(d||[]);a.yd=b.toString()}a.yc=new Nh(a.yd);Zh(a)})};
h.fc=function(a,b,c){var d=new O("popup-closed-by-user"),e=new O("web-storage-unsupported"),f=this,g=!1;return this.Ra().then(function(){$h(f).then(function(c){c||(a&&yf(a),b(e),g=!0)})}).g(function(){}).then(function(){if(!g)return Af(a)}).then(function(){if(!g)return Ce(c).then(function(){b(d)})})};h.Ve=function(){var a=L();return!Pf(a)&&!Tf(a)};h.Ae=function(){return!1};
h.$b=function(a,b,c,d,e,f,g){if(!a)return E(new O("popup-blocked"));if(g&&!Pf())return this.Ra().g(function(b){yf(a);e(b)}),d(),D();this.wa||(this.wa=Yh(ai(this)));var l=this;return this.wa.then(function(){var b=l.Ra().g(function(b){yf(a);e(b);throw b;});d();return b}).then(function(){Rg(c);if(!g){var d=bi(l.A,l.m,l.o,b,c,null,f,l.La,void 0,l.O);tf(d,a)}}).g(function(a){"auth/network-request-failed"==a.code&&(l.wa=null);throw a;})};
var ai=function(a){a.f||(a.ve=a.La?Kf(a.La,Wh(a.o)):null,a.f=new R(a.m,pf(a.O),a.ve));return a.f};Xh.prototype.ac=function(a,b,c){this.wa||(this.wa=Yh(ai(this)));var d=this;return this.wa.then(function(){Rg(b);var e=bi(d.A,d.m,d.o,a,b,sf(),c,d.La,void 0,d.O);tf(e)}).g(function(a){"auth/network-request-failed"==a.code&&(d.wa=null);throw a;})};Xh.prototype.Ra=function(){var a=this;return this.Sb().then(function(){return a.yc.Id}).g(function(){a.wa=null;throw new O("network-request-failed");})};
Xh.prototype.Ze=function(){return!0};
var bi=function(a,b,c,d,e,f,g,l,n,F){a=new Vh(a,b,c,d,e);a.Sd=f;a.W=g;f=a.$d(l);f.nc=kb(n||null);return f.Yd(F).toString()},Zh=function(a){if(!a.yc)throw Error("IfcHandler must be initialized!");Qh(a.yc,function(b){var c={};if(b&&b.authEvent){var d=!1;b=ng(b.authEvent);for(c=0;c<a.ta.length;c++)d=a.ta[c](b)||d;c={};c.status=d?"ACK":"ERROR";return D(c)}c.status="ERROR";return D(c)})},$h=function(a){var b={type:"webStorageSupport"};return a.Sb().then(function(){return a.yc.sendMessage(b)}).then(function(a){if(a&&a.length&&
"undefined"!==typeof a[0].webStorageSupport)return a[0].webStorageSupport;throw Error();})};Xh.prototype.ib=function(a){this.ta.push(a)};Xh.prototype.dc=function(a){Ya(this.ta,function(b){return b==a})};var ci=function(a,b,c,d,e,f){N(this,"type","recaptcha");this.bd=this.Ib=null;this.Kb=!1;this.ne=b;this.Fa=c||{theme:"light",type:"image"};this.J=[];if(this.Fa.sitekey)throw new O("argument-error","sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");this.Cc="invisible"===this.Fa.size;if(!md(b)||!this.Cc&&md(b).hasChildNodes())throw new O("argument-error","reCAPTCHA container is either not found or already contains inner elements!");this.f=new R(a,
f||null,e||null);this.Gf=d||function(){return null};var g=this;this.Xc=[];var l=this.Fa.callback;this.Fa.callback=function(a){g.Lb(a);if("function"===typeof l)l(a);else if("string"===typeof l){var b=M(l,k);"function"===typeof b&&b(a)}};var n=this.Fa["expired-callback"];this.Fa["expired-callback"]=function(){g.Lb(null);if("function"===typeof n)n();else if("string"===typeof n){var a=M(n,k);"function"===typeof a&&a()}}};ci.prototype.Lb=function(a){for(var b=0;b<this.Xc.length;b++)try{this.Xc[b](a)}catch(c){}};
var di=function(a,b){Ya(a.Xc,function(a){return a==b})};ci.prototype.c=function(a){var b=this;this.J.push(a);Fd(a,function(){Xa(b.J,a)});return a};
ci.prototype.Tb=function(){var a=this;return this.Ib?this.Ib:this.Ib=this.c(D().then(function(){if(Nf())return Cf();throw new O("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");}).then(function(){return ei(fi(),a.Gf())}).then(function(){return Q(a.f,Kh,{})}).then(function(b){a.Fa.sitekey=b.recaptchaSiteKey}).g(function(b){a.Ib=null;throw b;}))};
ci.prototype.render=function(){gi(this);var a=this;return this.c(this.Tb().then(function(){if(null===a.bd){var b=a.ne;if(!a.Cc){var c=md(b);b=qd("DIV");c.appendChild(b)}a.bd=grecaptcha.render(b,a.Fa)}return a.bd}))};ci.prototype.verify=function(){gi(this);var a=this;return this.c(this.render().then(function(b){return new C(function(c){var d=grecaptcha.getResponse(b);if(d)c(d);else{var e=function(b){b&&(di(a,e),c(b))};a.Xc.push(e);a.Cc&&grecaptcha.execute(a.bd)}})}))};
var gi=function(a){if(a.Kb)throw new O("internal-error","RecaptchaVerifier instance has been destroyed.");};ci.prototype.clear=function(){gi(this);this.Kb=!0;fi().ld--;for(var a=0;a<this.J.length;a++)this.J[a].cancel("RecaptchaVerifier instance has been destroyed.");if(!this.Cc){a=md(this.ne);for(var b;b=a.firstChild;)a.removeChild(b)}};
var hi=Ha("https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}"),ii=function(){this.ld=k.grecaptcha?Infinity:0;this.Be=null;this.jd="__rcb"+Math.floor(1E6*Math.random()).toString()},ei=function(a,b){return new C(function(c,d){if(Vf())if(!k.grecaptcha||b!==a.Be&&!a.ld){k[a.jd]=function(){if(k.grecaptcha){a.Be=b;var e=k.grecaptcha.render;k.grecaptcha.render=function(b,c){b=e(b,c);a.ld++;return b};c()}else d(new O("internal-error"));delete k[a.jd]};var e=Ma(hi,{onload:a.jd,
hl:b||""});D(ee(e)).g(function(){d(new O("internal-error","Unable to load external reCAPTCHA dependencies!"))})}else c();else d(new O("network-request-failed"))})},ji=null,fi=function(){ji||(ji=new ii);return ji},ki=function(a,b,c){try{this.i=c||firebase.app()}catch(f){throw new O("argument-error","No firebase.app.App instance is currently initialized.");}if(this.i.options&&this.i.options.apiKey)c=this.i.options.apiKey;else throw new O("invalid-api-key");var d=this,e=null;try{e=$a(this.i.auth().M)}catch(f){}e=
firebase.SDK_VERSION?Kf(firebase.SDK_VERSION,e):null;ci.call(this,c,a,b,function(){try{var a=d.i.auth().ia}catch(g){a=null}return a},e,pf(qf))};t(ki,ci);var li=function(a){this.F=a||firebase.INTERNAL.reactNative&&firebase.INTERNAL.reactNative.AsyncStorage;if(!this.F)throw new O("internal-error","The React Native compatibility library was not found.");};h=li.prototype;h.get=function(a){return D(this.F.getItem(a)).then(function(a){return a&&Sf(a)})};h.set=function(a,b){return D(this.F.setItem(a,Qf(b)))};h.remove=function(a){return D(this.F.removeItem(a))};h.jb=function(){};h.$a=function(){};var mi=function(){this.F={}};h=mi.prototype;h.get=function(a){return D(this.F[a])};h.set=function(a,b){this.F[a]=b;return D()};h.remove=function(a){delete this.F[a];return D()};h.jb=function(){};h.$a=function(){};var oi=function(){if(!ni()){if("Node"==Hf())throw new O("internal-error","The LocalStorage compatibility library was not found.");throw new O("web-storage-unsupported");}this.F=k.localStorage||firebase.INTERNAL.node.localStorage},ni=function(){var a="Node"==Hf();a=k.localStorage||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}};h=oi.prototype;
h.get=function(a){var b=this;return D().then(function(){var c=b.F.getItem(a);return Sf(c)})};h.set=function(a,b){var c=this;return D().then(function(){var d=Qf(b);null===d?c.remove(a):c.F.setItem(a,d)})};h.remove=function(a){var b=this;return D().then(function(){b.F.removeItem(a)})};h.jb=function(a){k.window&&lc(k.window,"storage",a)};h.$a=function(a){k.window&&tc(k.window,"storage",a)};var pi=function(){this.F={}};h=pi.prototype;h.get=function(){return D(null)};h.set=function(){return D()};h.remove=function(){return D()};h.jb=function(){};h.$a=function(){};var ri=function(){if(!qi()){if("Node"==Hf())throw new O("internal-error","The SessionStorage compatibility library was not found.");throw new O("web-storage-unsupported");}this.F=k.sessionStorage||firebase.INTERNAL.node.sessionStorage},qi=function(){var a="Node"==Hf();a=k.sessionStorage||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}};h=ri.prototype;
h.get=function(a){var b=this;return D().then(function(){var c=b.F.getItem(a);return Sf(c)})};h.set=function(a,b){var c=this;return D().then(function(){var d=Qf(b);null===d?c.remove(a):c.F.setItem(a,d)})};h.remove=function(a){var b=this;return D().then(function(){b.F.removeItem(a)})};h.jb=function(){};h.$a=function(){};var si=function(a,b,c,d,e,f){if(!window.indexedDB)throw new O("web-storage-unsupported");this.wf=a;this.Hd=b;this.md=c;this.cf=d;this.gb=e;this.Y={};this.gc=[];this.Wb=0;this.Of=f||k.indexedDB},ti,ui=function(a){return new C(function(b,c){var d=a.Of.open(a.wf,a.gb);d.onerror=function(a){c(Error(a.target.errorCode))};d.onupgradeneeded=function(b){b=b.target.result;try{b.createObjectStore(a.Hd,{keyPath:a.md})}catch(f){c(f)}};d.onsuccess=function(a){b(a.target.result)}})},wi=function(a){a.Fe||(a.Fe=
ui(a));return a.Fe},xi=function(a,b){return b.objectStore(a.Hd)},yi=function(a,b,c){return b.transaction([a.Hd],c?"readwrite":"readonly")},zi=function(a){return new C(function(b,c){a.onsuccess=function(a){a&&a.target?b(a.target.result):b()};a.onerror=function(a){c(Error(a.target.errorCode))}})};h=si.prototype;
h.set=function(a,b){var c=!1,d,e=this;return Fd(wi(this).then(function(b){d=b;b=xi(e,yi(e,d,!0));return zi(b.get(a))}).then(function(f){var g=xi(e,yi(e,d,!0));if(f)return f.value=b,zi(g.put(f));e.Wb++;c=!0;f={};f[e.md]=a;f[e.cf]=b;return zi(g.add(f))}).then(function(){e.Y[a]=b}),function(){c&&e.Wb--})};h.get=function(a){var b=this;return wi(this).then(function(c){return zi(xi(b,yi(b,c,!1)).get(a))}).then(function(a){return a&&a.value})};
h.remove=function(a){var b=!1,c=this;return Fd(wi(this).then(function(d){b=!0;c.Wb++;return zi(xi(c,yi(c,d,!0))["delete"](a))}).then(function(){delete c.Y[a]}),function(){b&&c.Wb--})};
h.wg=function(){var a=this;return wi(this).then(function(b){var c=xi(a,yi(a,b,!1));return c.getAll?zi(c.getAll()):new C(function(a,b){var d=[],e=c.openCursor();e.onsuccess=function(b){(b=b.target.result)?(d.push(b.value),b["continue"]()):a(d)};e.onerror=function(a){b(Error(a.target.errorCode))}})}).then(function(b){var c={},d=[];if(0==a.Wb){for(d=0;d<b.length;d++)c[b[d][a.md]]=b[d][a.cf];d=uf(a.Y,c);a.Y=c}return d})};h.jb=function(a){0==this.gc.length&&this.be();this.gc.push(a)};
h.$a=function(a){Ya(this.gc,function(b){return b==a});0==this.gc.length&&this.Tc()};h.be=function(){var a=this;this.Tc();var b=function(){a.Nd=Ce(800).then(r(a.wg,a)).then(function(b){0<b.length&&x(a.gc,function(a){a(b)})}).then(b).g(function(a){"STOP_EVENT"!=a.message&&b()});return a.Nd};b()};h.Tc=function(){this.Nd&&this.Nd.cancel("STOP_EVENT")};var Di=function(){this.re={Browser:Ai,Node:Bi,ReactNative:Ci}[Hf()]},Ei,Ai={C:oi,de:ri},Bi={C:oi,de:ri},Ci={C:li,de:pi};var Fi=function(a){this.Bd(a)};
Fi.prototype.Bd=function(a){var b=a.url;if("undefined"===typeof b)throw new O("missing-continue-uri");if("string"!==typeof b||"string"===typeof b&&!b.length)throw new O("invalid-continue-uri");this.rf=b;this.fe=this.oc=null;this.Ge=!1;var c=a.android;if(c&&"object"===typeof c){b=c.packageName;var d=c.installApp;c=c.minimumVersion;if("string"===typeof b&&b.length){this.oc=b;if("undefined"!==typeof d&&"boolean"!==typeof d)throw new O("argument-error","installApp property must be a boolean when specified.");this.Ge=
!!d;if("undefined"!==typeof c&&("string"!==typeof c||"string"===typeof c&&!c.length))throw new O("argument-error","minimumVersion property must be a non empty string when specified.");this.fe=c||null}else{if("undefined"!==typeof b)throw new O("argument-error","packageName property must be a non empty string when specified.");if("undefined"!==typeof d||"undefined"!==typeof c)throw new O("missing-android-pkg-name");}}else if("undefined"!==typeof c)throw new O("argument-error","android property must be a non null object when specified.");
this.xd=null;if((b=a.iOS)&&"object"===typeof b)if(b=b.bundleId,"string"===typeof b&&b.length)this.xd=b;else{if("undefined"!==typeof b)throw new O("argument-error","bundleId property must be a non empty string when specified.");}else if("undefined"!==typeof b)throw new O("argument-error","iOS property must be a non null object when specified.");a=a.handleCodeInApp;if("undefined"!==typeof a&&"boolean"!==typeof a)throw new O("argument-error","handleCodeInApp property must be a boolean when specified.");
if((this.le=!!a)&&!this.xd&&!this.oc)throw new O("argument-error","handleCodeInApp property can't be true when no mobile application is provided.");};var Gi=function(a){var b={};b.continueUrl=a.rf;b.canHandleCodeInApp=a.le;if(b.androidPackageName=a.oc)b.androidMinimumVersion=a.fe,b.androidInstallApp=a.Ge;b.iOSBundleId=a.xd;for(var c in b)null===b[c]&&delete b[c];return b};var Hi=function(a,b){this.uf=b;N(this,"verificationId",a)};Hi.prototype.confirm=function(a){a=Pg(this.verificationId,a);return this.uf(a)};var Ii=function(a,b,c,d){return(new Ng(a)).verifyPhoneNumber(b,c).then(function(a){return new Hi(a,d)})};var Ji=function(a){var b={},c=a.email,d=a.newEmail;a=a.requestType;if(!c||!a)throw Error("Invalid provider user info!");b.fromEmail=d||null;b.email=c;N(this,"operation",a);N(this,"data",fg(b))};var Ki=function(a,b,c,d,e,f){this.dg=a;this.lg=b;this.Hf=c;this.Hc=d;this.ee=e;this.mg=!!f;this.ub=null;this.Sa=this.Hc;if(this.ee<this.Hc)throw Error("Proactive refresh lower bound greater than upper bound!");};Ki.prototype.start=function(){this.Sa=this.Hc;Li(this,!0)};
var Mi=function(a,b){if(b)return a.Sa=a.Hc,a.Hf();b=a.Sa;a.Sa*=2;a.Sa>a.ee&&(a.Sa=a.ee);return b},Li=function(a,b){a.stop();a.ub=Ce(Mi(a,b)).then(function(){return a.mg?D():Yf()}).then(function(){return a.dg()}).then(function(){Li(a,!0)}).g(function(b){a.lg(b)&&Li(a,!1)})};Ki.prototype.stop=function(){this.ub&&(this.ub.cancel(),this.ub=null)};var Si=function(a){var b={};b["facebook.com"]=Ni;b["google.com"]=Oi;b["github.com"]=Pi;b["twitter.com"]=Qi;var c=a&&a.providerId;return c?b[c]?new b[c](a):new Ri(a):null},Ri=function(a){var b=Sf(a.rawUserInfo||"{}");a=a.providerId;if(!a)throw Error("Invalid additional user info!");N(this,"profile",fg(b||{}));N(this,"providerId",a)},Ni=function(a){Ri.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider id!");};t(Ni,Ri);
var Pi=function(a){Ri.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider id!");N(this,"username",this.profile&&this.profile.login||null)};t(Pi,Ri);var Oi=function(a){Ri.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider id!");};t(Oi,Ri);var Qi=function(a){Ri.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider id!");N(this,"username",a.screenName||null)};t(Qi,Ri);var Ti={LOCAL:"local",NONE:"none",SESSION:"session"},Ui=function(a){var b=new O("invalid-persistence-type"),c=new O("unsupported-persistence-type");a:{for(d in Ti)if(Ti[d]==a){var d=!0;break a}d=!1}if(!d||"string"!==typeof a)throw b;switch(Hf()){case "ReactNative":if("session"===a)throw c;break;case "Node":if("none"!==a)throw c;break;default:if(!Mf()&&"none"!==a)throw c;}},Vi=function(a,b,c,d){this.Ke=a;this.Wd=b;this.ng=c;this.ec=d;this.X={};Ei||(Ei=new Di);a=Ei;try{if(rf()){ti||(ti=new si("firebaseLocalStorageDb",
"firebaseLocalStorage","fbase_key","value",1));var e=ti}else e=new a.re.C;this.Qe=e}catch(f){this.Qe=new mi,this.ec=!0}try{this.Ye=new a.re.de}catch(f){this.Ye=new mi}this.Nf=new mi;this.ce=r(this.We,this);this.Y={}},Wi,Xi=function(){Wi||(Wi=new Vi("firebase",":",!Tf(L())&&Gf()?!0:!1,Pf()));return Wi},Yi=function(a,b){switch(b){case "session":return a.Ye;case "none":return a.Nf;default:return a.Qe}};h=Vi.prototype;h.ca=function(a,b){return this.Ke+this.Wd+a.name+(b?this.Wd+b:"")};
h.get=function(a,b){return Yi(this,a.C).get(this.ca(a,b))};h.remove=function(a,b){b=this.ca(a,b);"local"!=a.C||this.ec||(this.Y[b]=null);return Yi(this,a.C).remove(b)};h.set=function(a,b,c){var d=this.ca(a,c),e=this,f=Yi(this,a.C);return f.set(d,b).then(function(){return f.get(d)}).then(function(b){"local"!=a.C||e.ec||(e.Y[d]=b)})};h.addListener=function(a,b,c){a=this.ca(a,b);this.ec||(this.Y[a]=k.localStorage.getItem(a));ib(this.X)&&this.be();this.X[a]||(this.X[a]=[]);this.X[a].push(c)};
h.removeListener=function(a,b,c){a=this.ca(a,b);this.X[a]&&(Ya(this.X[a],function(a){return a==c}),0==this.X[a].length&&delete this.X[a]);ib(this.X)&&this.Tc()};h.be=function(){Yi(this,"local").jb(this.ce);this.ec||rf()||Zi(this)};var Zi=function(a){$i(a);a.Fd=setInterval(function(){for(var b in a.X){var c=k.localStorage.getItem(b),d=a.Y[b];c!=d&&(a.Y[b]=c,c=new Yb({type:"storage",key:b,target:window,oldValue:d,newValue:c,Md:!0}),a.We(c))}},1E3)},$i=function(a){a.Fd&&(clearInterval(a.Fd),a.Fd=null)};
Vi.prototype.Tc=function(){Yi(this,"local").$a(this.ce);$i(this)};
Vi.prototype.We=function(a){if(a&&a.Ef){var b=a.P.key;if(0==b.indexOf(this.Ke+this.Wd)&&this.X[b]){"undefined"!==typeof a.P.Md?Yi(this,"local").$a(this.ce):$i(this);if(this.ng){var c=k.localStorage.getItem(b),d=a.P.newValue;if(d!==c)null!==d?k.localStorage.setItem(b,d):k.localStorage.removeItem(b);else if(this.Y[b]===d&&"undefined"===typeof a.P.Md)return}var e=this;c=function(){if("undefined"!==typeof a.P.Md||e.Y[b]!==k.localStorage.getItem(b))e.Y[b]=k.localStorage.getItem(b),e.je(b)};z&&Cb&&10==
Cb&&k.localStorage.getItem(b)!==a.P.newValue&&a.P.newValue!==a.P.oldValue?setTimeout(c,10):c()}}else x(a,r(this.je,this))};Vi.prototype.je=function(a){this.X[a]&&x(this.X[a],function(a){a()})};var aj=function(a,b){this.j=a;this.h=b||Xi()},bj={name:"authEvent",C:"local"},cj=function(a){return a.h.get(bj,a.j).then(function(a){return ng(a)})};aj.prototype.ib=function(a){this.h.addListener(bj,this.j,a)};aj.prototype.dc=function(a){this.h.removeListener(bj,this.j,a)};var dj=function(a){this.h=a||Xi()},ej={name:"sessionId",C:"session"};dj.prototype.uc=function(a){return this.h.get(ej,a)};var fj=function(a,b,c,d,e,f,g){this.A=a;this.m=b;this.o=c;this.La=d||null;this.O=g||null;this.Xe=b+":"+c;this.og=new dj;this.we=new aj(this.Xe);this.Ad=null;this.ta=[];this.Sf=e||500;this.hg=f||2E3;this.Rb=this.Kc=null},gj=function(a){return new O("invalid-cordova-configuration",a)};
fj.prototype.Ra=function(){return this.Tb?this.Tb:this.Tb=Ef().then(function(){if("function"!==typeof M("universalLinks.subscribe",k))throw gj("cordova-universal-links-plugin is not installed");if("undefined"===typeof M("BuildInfo.packageName",k))throw gj("cordova-plugin-buildinfo is not installed");if("function"!==typeof M("cordova.plugins.browsertab.openUrl",k))throw gj("cordova-plugin-browsertab is not installed");if("function"!==typeof M("cordova.InAppBrowser.open",k))throw gj("cordova-plugin-inappbrowser is not installed");
},function(){throw new O("cordova-not-ready");})};var hj=function(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")},ij=function(a){var b=new Sb;b.update(a);return ab(b.digest())};h=fj.prototype;h.fc=function(a,b){b(new O("operation-not-supported-in-this-environment"));return D()};h.$b=function(){return E(new O("operation-not-supported-in-this-environment"))};h.Ze=function(){return!1};h.Ve=function(){return!0};
h.Ae=function(){return!0};
h.ac=function(a,b,c){if(this.Kc)return E(new O("redirect-operation-pending"));var d=this,e=k.document,f=null,g=null,l=null,n=null;return this.Kc=Fd(D().then(function(){Rg(b);return jj(d)}).then(function(){return kj(d,a,b,c)}).then(function(){return(new C(function(a,b){g=function(){var b=M("cordova.plugins.browsertab.close",k);a();"function"===typeof b&&b();d.Rb&&"function"===typeof d.Rb.close&&(d.Rb.close(),d.Rb=null);return!1};d.ib(g);l=function(){f||(f=Ce(d.hg).then(function(){b(new O("redirect-cancelled-by-user"))}))};n=
function(){Xf()&&l()};e.addEventListener("resume",l,!1);L().toLowerCase().match(/android/)||e.addEventListener("visibilitychange",n,!1)})).g(function(a){return lj(d).then(function(){throw a;})})}),function(){l&&e.removeEventListener("resume",l,!1);n&&e.removeEventListener("visibilitychange",n,!1);f&&f.cancel();g&&d.dc(g);d.Kc=null})};
var kj=function(a,b,c,d){var e=hj(),f=new mg(b,d,null,e,new O("no-auth-event")),g=M("BuildInfo.packageName",k);if("string"!==typeof g)throw new O("invalid-cordova-configuration");var l=M("BuildInfo.displayName",k),n={};if(L().toLowerCase().match(/iphone|ipad|ipod/))n.ibi=g;else if(L().toLowerCase().match(/android/))n.apn=g;else return E(new O("operation-not-supported-in-this-environment"));l&&(n.appDisplayName=l);e=ij(e);n.sessionId=e;var F=bi(a.A,a.m,a.o,b,c,null,d,a.La,n,a.O);return a.Ra().then(function(){var b=
a.Xe;return a.og.h.set(bj,f.G(),b)}).then(function(){var b=M("cordova.plugins.browsertab.isAvailable",k);if("function"!==typeof b)throw new O("invalid-cordova-configuration");var c=null;b(function(b){if(b){c=M("cordova.plugins.browsertab.openUrl",k);if("function"!==typeof c)throw new O("invalid-cordova-configuration");c(F)}else{c=M("cordova.InAppBrowser.open",k);if("function"!==typeof c)throw new O("invalid-cordova-configuration");b=c;var d=L();d=!(!d.match(/(iPad|iPhone|iPod).*OS 7_\d/i)&&!d.match(/(iPad|iPhone|iPod).*OS 8_\d/i));
a.Rb=b(F,d?"_blank":"_system","location=yes")}})})};fj.prototype.Lb=function(a){for(var b=0;b<this.ta.length;b++)try{this.ta[b](a)}catch(c){}};
var jj=function(a){a.Ad||(a.Ad=a.Ra().then(function(){return new C(function(b){var c=function(d){b(d);a.dc(c);return!1};a.ib(c);mj(a)})}));return a.Ad},lj=function(a){var b=null;return cj(a.we).then(function(c){b=c;c=a.we;return c.h.remove(bj,c.j)}).then(function(){return b})},mj=function(a){var b=M("universalLinks.subscribe",k);if("function"!==typeof b)throw new O("invalid-cordova-configuration");var c=new mg("unknown",null,null,null,new O("no-auth-event")),d=!1,e=Ce(a.Sf).then(function(){return lj(a).then(function(){d||
a.Lb(c)})}),f=function(b){d=!0;e&&e.cancel();lj(a).then(function(d){var e=c;if(d&&b&&b.url){e=null;var f=b.url;var g=hf(f),l=gf(g,"link"),n=gf(hf(l),"link");g=gf(g,"deep_link_id");f=gf(hf(g),"link")||g||n||l||f;-1!=f.indexOf("/__/auth/callback")&&(e=hf(f),e=Sf(gf(e,"firebaseError")||null),e=(e="object"===typeof e?lg(e):null)?new mg(d.ma,d.W,null,null,e):new mg(d.ma,d.W,f,d.uc()));e=e||c}a.Lb(e)})},g=k.handleOpenURL;k.handleOpenURL=function(a){0==a.toLowerCase().indexOf(M("BuildInfo.packageName",k).toLowerCase()+
"://")&&f({url:a});if("function"===typeof g)try{g(a)}catch(n){console.error(n)}};b(null,f)};fj.prototype.ib=function(a){this.ta.push(a);jj(this).g(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new mg("unknown",null,null,null,new O("no-auth-event")),a(b))})};fj.prototype.dc=function(a){Ya(this.ta,function(b){return b==a})};var nj=function(a){this.j=a;this.h=Xi()},oj={name:"pendingRedirect",C:"session"},pj=function(a){return a.h.set(oj,"pending",a.j)},qj=function(a){return a.h.remove(oj,a.j)},rj=function(a){return a.h.get(oj,a.j).then(function(a){return"pending"==a})};var vj=function(a,b,c){this.A=a;this.m=b;this.o=c;this.hc=[];this.sb=!1;this.fd=r(this.vd,this);this.Xa=new sj(this);this.Od=new tj(this);this.Xb=new nj(this.m+":"+this.o);this.Ia={};this.Ia.unknown=this.Xa;this.Ia.signInViaRedirect=this.Xa;this.Ia.linkViaRedirect=this.Xa;this.Ia.reauthViaRedirect=this.Xa;this.Ia.signInViaPopup=this.Od;this.Ia.linkViaPopup=this.Od;this.Ia.reauthViaPopup=this.Od;this.Z=uj(this.A,this.m,this.o,qf)},uj=function(a,b,c,d){var e=firebase.SDK_VERSION||null;return Df()?new fj(a,
b,c,e,void 0,void 0,d):new Xh(a,b,c,e,d)};vj.prototype.reset=function(){this.sb=!1;this.Z.dc(this.fd);this.Z=uj(this.A,this.m,this.o)};vj.prototype.Sb=function(){var a=this;this.sb||(this.sb=!0,this.Z.ib(this.fd));var b=this.Z;return this.Z.Ra().g(function(c){a.Z==b&&a.reset();throw c;})};var yj=function(a){a.Z.Ve()&&a.Sb().g(function(b){var c=new mg("unknown",null,null,null,new O("operation-not-supported-in-this-environment"));wj(b)&&a.vd(c)});a.Z.Ae()||xj(a.Xa)};
vj.prototype.subscribe=function(a){Va(this.hc,a)||this.hc.push(a);if(!this.sb){var b=this;rj(this.Xb).then(function(a){a?qj(b.Xb).then(function(){b.Sb().g(function(a){var c=new mg("unknown",null,null,null,new O("operation-not-supported-in-this-environment"));wj(a)&&b.vd(c)})}):yj(b)}).g(function(){yj(b)})}};vj.prototype.unsubscribe=function(a){Ya(this.hc,function(b){return b==a})};
vj.prototype.vd=function(a){if(!a)throw new O("invalid-auth-event");for(var b=!1,c=0;c<this.hc.length;c++){var d=this.hc[c];if(d.ke(a.ma,a.W)){(b=this.Ia[a.ma])&&b.Re(a,d);b=!0;break}}xj(this.Xa);return b};var zj=new Wf(2E3,1E4),Aj=new Wf(3E4,6E4);vj.prototype.getRedirectResult=function(){return this.Xa.getRedirectResult()};vj.prototype.$b=function(a,b,c,d,e){var f=this;return this.Z.$b(a,b,c,function(){f.sb||(f.sb=!0,f.Z.ib(f.fd))},function(){f.reset()},d,e)};
var wj=function(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1};vj.prototype.ac=function(a,b,c){var d=this,e;return pj(this.Xb).then(function(){return d.Z.ac(a,b,c).g(function(a){if(wj(a))throw new O("operation-not-supported-in-this-environment");e=a;return qj(d.Xb).then(function(){throw e;})}).then(function(){return d.Z.Ze()?new C(function(){}):qj(d.Xb).then(function(){return d.getRedirectResult()}).then(function(){}).g(function(){})})})};
vj.prototype.fc=function(a,b,c,d){return this.Z.fc(c,function(c){a.bb(b,null,c,d)},zj.get())};var Bj={},Cj=function(a,b,c){var d=b+":"+c;Bj[d]||(Bj[d]=new vj(a,b,c));return Bj[d]},sj=function(a){this.h=a;this.Ab=null;this.cc=[];this.bc=[];this.yb=null;this.Rd=!1};sj.prototype.reset=function(){this.Ab=null;this.yb&&(this.yb.cancel(),this.yb=null)};
sj.prototype.Re=function(a,b){if(!a)return E(new O("invalid-auth-event"));this.reset();this.Rd=!0;var c=a.ma,d=a.W,e=a.getError()&&"auth/web-storage-unsupported"==a.getError().code,f=a.getError()&&"auth/operation-not-supported-in-this-environment"==a.getError().code;"unknown"!=c||e||f?a=a.ba?this.Pd(a,b):b.Nb(c,d)?this.Qd(a,b):E(new O("invalid-auth-event")):(Dj(this,!1,null,null),a=D());return a};var xj=function(a){a.Rd||(a.Rd=!0,Dj(a,!1,null,null))};
sj.prototype.Pd=function(a){Dj(this,!0,null,a.getError());return D()};sj.prototype.Qd=function(a,b){var c=this;b=b.Nb(a.ma,a.W);var d=a.Eb,e=a.uc(),f=!!a.ma.match(/Redirect$/);return b(d,e).then(function(a){Dj(c,f,a,null)}).g(function(a){Dj(c,f,null,a)})};
var Ej=function(a,b){a.Ab=function(){return E(b)};if(a.bc.length)for(var c=0;c<a.bc.length;c++)a.bc[c](b)},Fj=function(a,b){a.Ab=function(){return D(b)};if(a.cc.length)for(var c=0;c<a.cc.length;c++)a.cc[c](b)},Dj=function(a,b,c,d){b?d?Ej(a,d):Fj(a,c):Fj(a,{user:null});a.cc=[];a.bc=[]};sj.prototype.getRedirectResult=function(){var a=this;return new C(function(b,c){a.Ab?a.Ab().then(b,c):(a.cc.push(b),a.bc.push(c),Gj(a))})};
var Gj=function(a){var b=new O("timeout");a.yb&&a.yb.cancel();a.yb=Ce(Aj.get()).then(function(){a.Ab||Dj(a,!0,null,b)})},tj=function(a){this.h=a};tj.prototype.Re=function(a,b){if(!a)return E(new O("invalid-auth-event"));var c=a.ma,d=a.W;return a.ba?this.Pd(a,b):b.Nb(c,d)?this.Qd(a,b):E(new O("invalid-auth-event"))};tj.prototype.Pd=function(a,b){b.bb(a.ma,null,a.getError(),a.W);return D()};
tj.prototype.Qd=function(a,b){var c=a.W,d=a.ma,e=b.Nb(d,c),f=a.Eb;a=a.uc();return e(f,a).then(function(a){b.bb(d,a,null,c)}).g(function(a){b.bb(d,null,a,c)})};var Hj=function(a){this.f=a;this.Ja=this.fa=null;this.Na=0};Hj.prototype.G=function(){return{apiKey:this.f.m,refreshToken:this.fa,accessToken:this.Ja,expirationTime:this.Na}};
var Jj=function(a,b){var c=b.idToken,d=b.refreshToken;b=Ij(b.expiresIn);a.Ja=c;a.Na=b;a.fa=d},Ij=function(a){return ma()+1E3*parseInt(a,10)},Kj=function(a,b){return gh(a.f,b).then(function(b){a.Ja=b.access_token;a.Na=Ij(b.expires_in);a.fa=b.refresh_token;return{accessToken:a.Ja,expirationTime:a.Na,refreshToken:a.fa}}).g(function(b){"auth/user-token-expired"==b.code&&(a.fa=null);throw b;})};
Hj.prototype.getToken=function(a){a=!!a;return this.Ja&&!this.fa?E(new O("user-token-expired")):a||!this.Ja||ma()>this.Na-3E4?this.fa?Kj(this,{grant_type:"refresh_token",refresh_token:this.fa}):D(null):D({accessToken:this.Ja,expirationTime:this.Na,refreshToken:this.fa})};var Lj=function(a,b,c,d,e,f){bg(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,phoneNumber:f||null,providerId:b})},Mj=function(a,b){B.call(this,a);for(var c in b)this[c]=b[c]};t(Mj,B);
var S=function(a,b,c){this.J=[];this.m=a.apiKey;this.o=a.appName;this.A=a.authDomain||null;a=firebase.SDK_VERSION?Kf(firebase.SDK_VERSION):null;this.f=new R(this.m,pf(qf),a);this.ra=new Hj(this.f);Nj(this,b.idToken);Jj(this.ra,b);N(this,"refreshToken",this.ra.fa);Oj(this,c||{});G.call(this);this.Lc=!1;this.A&&Of()&&(this.v=Cj(this.A,this.m,this.o));this.Sc=[];this.sa=null;this.wb=Pj(this);this.Gb=r(this.wd,this);var d=this;this.ia=null;this.Ne=function(a){d.Cb(a.languageCode)};this.Dd=null;this.M=
[];this.Me=function(a){Qj(d,a.Cf)};this.sd=null};t(S,G);S.prototype.Cb=function(a){this.ia=a;$g(this.f,a)};var Rj=function(a,b){a.Dd&&tc(a.Dd,"languageCodeChanged",a.Ne);(a.Dd=b)&&lc(b,"languageCodeChanged",a.Ne)},Qj=function(a,b){a.M=b;ah(a.f,firebase.SDK_VERSION?Kf(firebase.SDK_VERSION,a.M):null)},Sj=function(a,b){a.sd&&tc(a.sd,"frameworkChanged",a.Me);(a.sd=b)&&lc(b,"frameworkChanged",a.Me)};S.prototype.wd=function(){this.wb.ub&&(this.wb.stop(),this.wb.start())};
var Tj=function(a){try{return firebase.app(a.o).auth()}catch(b){throw new O("internal-error","No firebase.auth.Auth instance is available for the Firebase App '"+a.o+"'!");}},Pj=function(a){return new Ki(function(){return a.getIdToken(!0)},function(a){return a&&"auth/network-request-failed"==a.code?!0:!1},function(){var b=a.ra.Na-ma()-3E5;return 0<b?b:0},3E4,96E4,!1)},Uj=function(a){a.Kb||a.wb.ub||(a.wb.start(),tc(a,"tokenChanged",a.Gb),lc(a,"tokenChanged",a.Gb))},Vj=function(a){tc(a,"tokenChanged",
a.Gb);a.wb.stop()},Nj=function(a,b){a.He=b;N(a,"_lat",b)},Wj=function(a,b){Ya(a.Sc,function(a){return a==b})},Xj=function(a){for(var b=[],c=0;c<a.Sc.length;c++)b.push(a.Sc[c](a));return Cd(b).then(function(){return a})},Yj=function(a){a.v&&!a.Lc&&(a.Lc=!0,a.v.subscribe(a))},Oj=function(a,b){bg(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,phoneNumber:b.phoneNumber||null,isAnonymous:b.isAnonymous||!1,providerData:[]})};
N(S.prototype,"providerId","firebase");var Zj=function(){},ak=function(a){return D().then(function(){if(a.Kb)throw new O("app-deleted");})},bk=function(a){return Ra(a.providerData,function(a){return a.providerId})},dk=function(a,b){b&&(ck(a,b.providerId),a.providerData.push(b))},ck=function(a,b){Ya(a.providerData,function(a){return a.providerId==b})},ek=function(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&N(a,b,c)};
S.prototype.copy=function(a){var b=this;b!=a&&(bg(this,{uid:a.uid,displayName:a.displayName,photoURL:a.photoURL,email:a.email,emailVerified:a.emailVerified,phoneNumber:a.phoneNumber,isAnonymous:a.isAnonymous,providerData:[]}),x(a.providerData,function(a){dk(b,a)}),this.ra=a.ra,N(this,"refreshToken",this.ra.fa))};S.prototype.reload=function(){var a=this;return this.c(ak(this).then(function(){return fk(a).then(function(){return Xj(a)}).then(Zj)}))};
var fk=function(a){return a.getIdToken().then(function(b){var c=a.isAnonymous;return gk(a,b).then(function(){c||ek(a,"isAnonymous",!1);return b})})};S.prototype.getIdToken=function(a){var b=this;return this.c(ak(this).then(function(){return b.ra.getToken(a)}).then(function(a){if(!a)throw new O("internal-error");a.accessToken!=b.He&&(Nj(b,a.accessToken),b.Ta());ek(b,"refreshToken",a.refreshToken);return a.accessToken}))};
S.prototype.getToken=function(a){Zf["firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."]||(Zf["firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn("firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."));return this.getIdToken(a)};
var hk=function(a,b){b.idToken&&a.He!=b.idToken&&(Jj(a.ra,b),a.Ta(),Nj(a,b.idToken),ek(a,"refreshToken",a.ra.fa))};S.prototype.Ta=function(){this.dispatchEvent(new Mj("tokenChanged"))};var gk=function(a,b){return Q(a.f,Jh,{idToken:b}).then(r(a.eg,a))};
S.prototype.eg=function(a){a=a.users;if(!a||!a.length)throw new O("internal-error");a=a[0];Oj(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,phoneNumber:a.phoneNumber});for(var b=ik(a),c=0;c<b.length;c++)dk(this,b[c]);ek(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length))};
var ik=function(a){return(a=a.providerUserInfo)&&a.length?Ra(a,function(a){return new Lj(a.rawId,a.providerId,a.email,a.displayName,a.photoUrl,a.phoneNumber)}):[]};S.prototype.reauthenticateAndRetrieveDataWithCredential=function(a){var b=this,c=null;return this.c(a.Gd(this.f,this.uid).then(function(a){hk(b,a);c=jk(b,a,"reauthenticate");b.sa=null;return b.reload()}).then(function(){return c}),!0)};S.prototype.reauthenticateWithCredential=function(a){return this.reauthenticateAndRetrieveDataWithCredential(a).then(function(){})};
var kk=function(a,b){return fk(a).then(function(){if(Va(bk(a),b))return Xj(a).then(function(){throw new O("provider-already-linked");})})};S.prototype.linkAndRetrieveDataWithCredential=function(a){var b=this,c=null;return this.c(kk(this,a.providerId).then(function(){return b.getIdToken()}).then(function(c){return a.Gc(b.f,c)}).then(function(a){c=jk(b,a,"link");return lk(b,a)}).then(function(){return c}))};S.prototype.linkWithCredential=function(a){return this.linkAndRetrieveDataWithCredential(a).then(function(a){return a.user})};
S.prototype.linkWithPhoneNumber=function(a,b){var c=this;return this.c(kk(this,"phone").then(function(){return Ii(Tj(c),a,b,r(c.linkAndRetrieveDataWithCredential,c))}))};S.prototype.reauthenticateWithPhoneNumber=function(a,b){var c=this;return this.c(D().then(function(){return Ii(Tj(c),a,b,r(c.reauthenticateAndRetrieveDataWithCredential,c))}),!0)};var jk=function(a,b,c){var d=Qg(b);b=Si(b);return cg({user:a,credential:d,additionalUserInfo:b,operationType:c})},lk=function(a,b){hk(a,b);return a.reload().then(function(){return a})};
h=S.prototype;h.updateEmail=function(a){var b=this;return this.c(this.getIdToken().then(function(c){return b.f.updateEmail(c,a)}).then(function(a){hk(b,a);return b.reload()}))};h.updatePhoneNumber=function(a){var b=this;return this.c(this.getIdToken().then(function(c){return a.Gc(b.f,c)}).then(function(a){hk(b,a);return b.reload()}))};h.updatePassword=function(a){var b=this;return this.c(this.getIdToken().then(function(c){return b.f.updatePassword(c,a)}).then(function(a){hk(b,a);return b.reload()}))};
h.updateProfile=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return ak(this);var b=this;return this.c(this.getIdToken().then(function(c){return b.f.updateProfile(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(a){hk(b,a);ek(b,"displayName",a.displayName||null);ek(b,"photoURL",a.photoUrl||null);x(b.providerData,function(a){"password"===a.providerId&&(N(a,"displayName",b.displayName),N(a,"photoURL",b.photoURL))});return Xj(b)}).then(Zj))};
h.unlink=function(a){var b=this;return this.c(fk(this).then(function(c){return Va(bk(b),a)?xh(b.f,c,[a]).then(function(a){var c={};x(a.providerUserInfo||[],function(a){c[a.providerId]=!0});x(bk(b),function(a){c[a]||ck(b,a)});c[Ng.PROVIDER_ID]||N(b,"phoneNumber",null);return Xj(b)}):Xj(b).then(function(){throw new O("no-such-provider");})}))};
h["delete"]=function(){var a=this;return this.c(this.getIdToken().then(function(b){return Q(a.f,Ih,{idToken:b})}).then(function(){a.dispatchEvent(new Mj("userDeleted"))})).then(function(){for(var b=0;b<a.J.length;b++)a.J[b].cancel("app-deleted");Rj(a,null);Sj(a,null);a.J=[];a.Kb=!0;Vj(a);N(a,"refreshToken",null);a.v&&a.v.unsubscribe(a)})};
h.ke=function(a,b){return"linkViaPopup"==a&&(this.la||null)==b&&this.ka||"reauthViaPopup"==a&&(this.la||null)==b&&this.ka||"linkViaRedirect"==a&&(this.Ha||null)==b||"reauthViaRedirect"==a&&(this.Ha||null)==b?!0:!1};h.bb=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.la||null)||(c&&this.Va?this.Va(c):b&&!c&&this.ka&&this.ka(b),this.K&&(this.K.cancel(),this.K=null),delete this.ka,delete this.Va)};
h.Nb=function(a,b){return"linkViaPopup"==a&&b==(this.la||null)?r(this.te,this):"reauthViaPopup"==a&&b==(this.la||null)?r(this.ue,this):"linkViaRedirect"==a&&(this.Ha||null)==b?r(this.te,this):"reauthViaRedirect"==a&&(this.Ha||null)==b?r(this.ue,this):null};h.tc=function(){return Lf(this.uid+":::")};h.linkWithPopup=function(a){var b=this;return mk(this,"linkViaPopup",a,function(){return kk(b,a.providerId).then(function(){return Xj(b)})},!1)};
h.reauthenticateWithPopup=function(a){return mk(this,"reauthViaPopup",a,function(){return D()},!0)};
var mk=function(a,b,c,d,e){if(!Of())return E(new O("operation-not-supported-in-this-environment"));if(a.sa&&!e)return E(a.sa);var f=jg(c.providerId),g=a.tc(),l=null;(!Pf()||Gf())&&a.A&&c.isOAuthProvider&&(l=bi(a.A,a.m,a.o,b,c,null,g,firebase.SDK_VERSION||null));var n=zf(l,f&&f.Zb,f&&f.Yb);d=d().then(function(){nk(a);if(!e)return a.getIdToken().then(function(){})}).then(function(){return a.v.$b(n,b,c,g,!!l)}).then(function(){return new C(function(c,d){a.bb(b,null,new O("cancelled-popup-request"),a.la||
null);a.ka=c;a.Va=d;a.la=g;a.K=a.v.fc(a,b,n,g)})}).then(function(a){n&&yf(n);return a?cg(a):null}).g(function(a){n&&yf(n);throw a;});return a.c(d,e)};S.prototype.linkWithRedirect=function(a){var b=this;return ok(this,"linkViaRedirect",a,function(){return kk(b,a.providerId)},!1)};S.prototype.reauthenticateWithRedirect=function(a){return ok(this,"reauthViaRedirect",a,function(){return D()},!0)};
var ok=function(a,b,c,d,e){if(!Of())return E(new O("operation-not-supported-in-this-environment"));if(a.sa&&!e)return E(a.sa);var f=null,g=a.tc();d=d().then(function(){nk(a);if(!e)return a.getIdToken().then(function(){})}).then(function(){a.Ha=g;return Xj(a)}).then(function(b){a.Ya&&(b=a.Ya,b=b.h.set(pk,a.G(),b.j));return b}).then(function(){return a.v.ac(b,c,g)}).g(function(b){f=b;if(a.Ya)return qk(a.Ya);throw f;}).then(function(){if(f)throw f;});return a.c(d,e)},nk=function(a){if(!a.v||!a.Lc){if(a.v&&
!a.Lc)throw new O("internal-error");throw new O("auth-domain-config-required");}};S.prototype.te=function(a,b){var c=this;this.K&&(this.K.cancel(),this.K=null);var d=null,e=this.getIdToken().then(function(d){return ug(c.f,{requestUri:a,sessionId:b,idToken:d})}).then(function(a){d=jk(c,a,"link");return lk(c,a)}).then(function(){return d});return this.c(e)};
S.prototype.ue=function(a,b){var c=this;this.K&&(this.K.cancel(),this.K=null);var d=null,e=D().then(function(){return qg(vg(c.f,{requestUri:a,sessionId:b}),c.uid)}).then(function(a){d=jk(c,a,"reauthenticate");hk(c,a);c.sa=null;return c.reload()}).then(function(){return d});return this.c(e,!0)};
S.prototype.sendEmailVerification=function(a){var b=this,c=null;return this.c(this.getIdToken().then(function(b){c=b;return"undefined"===typeof a||ib(a)?{}:Gi(new Fi(a))}).then(function(a){return b.f.sendEmailVerification(c,a)}).then(function(a){if(b.email!=a)return b.reload()}).then(function(){}))};S.prototype.c=function(a,b){var c=this,d=rk(this,a,b);this.J.push(d);Fd(d,function(){Xa(c.J,d)});return d};
var rk=function(a,b,c){return a.sa&&!c?(b.cancel(),E(a.sa)):b.g(function(b){!b||"auth/user-disabled"!=b.code&&"auth/user-token-expired"!=b.code||(a.sa||a.dispatchEvent(new Mj("userInvalidated")),a.sa=b);throw b;})};S.prototype.toJSON=function(){return this.G()};
S.prototype.G=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,phoneNumber:this.phoneNumber,isAnonymous:this.isAnonymous,providerData:[],apiKey:this.m,appName:this.o,authDomain:this.A,stsTokenManager:this.ra.G(),redirectEventId:this.Ha||null};x(this.providerData,function(b){a.providerData.push(dg(b))});return a};
var sk=function(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken&&a.stsTokenManager.expirationTime)c.idToken=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null,c.expiresIn=(a.stsTokenManager.expirationTime-ma())/1E3;else return null;var d=new S(b,c,a);a.providerData&&x(a.providerData,function(a){a&&dk(d,cg(a))});a.redirectEventId&&(d.Ha=a.redirectEventId);return d},
tk=function(a,b,c,d){var e=new S(a,b);c&&(e.Ya=c);d&&Qj(e,d);return e.reload().then(function(){return e})};var uk=function(a){this.j=a;this.h=Xi()},pk={name:"redirectUser",C:"session"},qk=function(a){return a.h.remove(pk,a.j)},vk=function(a,b){return a.h.get(pk,a.j).then(function(a){a&&b&&(a.authDomain=b);return sk(a||{})})};var xk=function(a,b){this.j=a;this.h=b||Xi();this.N=null;this.Jd=this.Bd();this.h.addListener(wk("local"),this.j,r(this.ug,this))};xk.prototype.ug=function(){var a=this,b=wk("local");yk(this,function(){return D().then(function(){return a.N&&"local"!=a.N.C?a.h.get(b,a.j):null}).then(function(c){if(c)return zk(a,"local").then(function(){a.N=b})})})};var zk=function(a,b){var c=[],d;for(d in Ti)Ti[d]!==b&&c.push(a.h.remove(wk(Ti[d]),a.j));c.push(a.h.remove(Ak,a.j));return Bd(c)};
xk.prototype.Bd=function(){var a=this,b=wk("local"),c=wk("session"),d=wk("none");return this.h.get(c,this.j).then(function(e){return e?c:a.h.get(d,a.j).then(function(c){return c?d:a.h.get(b,a.j).then(function(c){return c?b:a.h.get(Ak,a.j).then(function(a){return a?wk(a):b})})})}).then(function(b){a.N=b;return zk(a,b.C)}).g(function(){a.N||(a.N=b)})};var Ak={name:"persistence",C:"session"},wk=function(a){return{name:"authUser",C:a}};
xk.prototype.setPersistence=function(a){var b=null,c=this;Ui(a);return yk(this,function(){return a!=c.N.C?c.h.get(c.N,c.j).then(function(d){b=d;return zk(c,a)}).then(function(){c.N=wk(a);if(b)return c.h.set(c.N,b,c.j)}):D()})};
var Bk=function(a){return yk(a,function(){return a.h.set(Ak,a.N.C,a.j)})},Ck=function(a,b){return yk(a,function(){return a.h.set(a.N,b.G(),a.j)})},Dk=function(a){return yk(a,function(){return a.h.remove(a.N,a.j)})},Ek=function(a,b){return yk(a,function(){return a.h.get(a.N,a.j).then(function(a){a&&b&&(a.authDomain=b);return sk(a||{})})})},yk=function(a,b){a.Jd=a.Jd.then(b,b);return a.Jd};var T=function(a){this.Ea=!1;N(this,"app",a);if(this.i().options&&this.i().options.apiKey)a=firebase.SDK_VERSION?Kf(firebase.SDK_VERSION):null,this.f=new R(this.i().options&&this.i().options.apiKey,pf(qf),a);else throw new O("invalid-api-key");this.J=[];this.Ka=[];this.Fb=[];this.ag=firebase.INTERNAL.createSubscribe(r(this.Pf,this));this.mc=void 0;this.cg=firebase.INTERNAL.createSubscribe(r(this.Rf,this));Fk(this,null);a=this.i().options.apiKey;var b=this.i().name;this.na=new xk(a+":"+b);a=this.i().options.apiKey;
b=this.i().name;this.zb=new uk(a+":"+b);this.pc=this.c(Gk(this));this.ya=this.c(Hk(this));this.Dc=!1;this.ud=r(this.vg,this);this.bf=r(this.pb,this);this.Gb=r(this.wd,this);this.$e=r(this.Lf,this);this.af=r(this.Mf,this);Ik(this);this.INTERNAL={};this.INTERNAL["delete"]=r(this["delete"],this);this.INTERNAL.logFramework=r(this.Xf,this);this.Oa=0;G.call(this);Jk(this);this.M=[]};t(T,G);var Kk=function(a){B.call(this,"languageCodeChanged");this.languageCode=a};t(Kk,B);
var Lk=function(a){B.call(this,"frameworkChanged");this.Cf=a};t(Lk,B);T.prototype.setPersistence=function(a){a=this.na.setPersistence(a);return this.c(a)};T.prototype.Cb=function(a){this.ia===a||this.Ea||(this.ia=a,$g(this.f,this.ia),this.dispatchEvent(new Kk(this.ia)))};T.prototype.useDeviceLanguage=function(){var a=k.navigator;this.Cb(a?a.languages&&a.languages[0]||a.language||a.userLanguage||null:null)};
T.prototype.Xf=function(a){this.M.push(a);ah(this.f,firebase.SDK_VERSION?Kf(firebase.SDK_VERSION,this.M):null);this.dispatchEvent(new Lk(this.M))};var Jk=function(a){Object.defineProperty(a,"lc",{get:function(){return this.ia},set:function(a){this.Cb(a)},enumerable:!1});a.ia=null};T.prototype.toJSON=function(){return{apiKey:this.i().options.apiKey,authDomain:this.i().options.authDomain,appName:this.i().name,currentUser:U(this)&&U(this).G()}};
var Mk=function(a){return a.xf||E(new O("auth-domain-config-required"))},Ik=function(a){var b=a.i().options.authDomain,c=a.i().options.apiKey;b&&Of()&&(a.xf=a.pc.then(function(){if(!a.Ea){a.v=Cj(b,c,a.i().name);a.v.subscribe(a);U(a)&&Yj(U(a));if(a.Za){Yj(a.Za);var d=a.Za;d.Cb(a.ia);Rj(d,a);d=a.Za;Qj(d,a.M);Sj(d,a);a.Za=null}return a.v}}))};h=T.prototype;h.ke=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.la==b&&!!this.ka;default:return!1}};
h.bb=function(a,b,c,d){"signInViaPopup"==a&&this.la==d&&(c&&this.Va?this.Va(c):b&&!c&&this.ka&&this.ka(b),this.K&&(this.K.cancel(),this.K=null),delete this.ka,delete this.Va)};h.Nb=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.la==b&&this.ka?r(this.zf,this):null};
h.zf=function(a,b){var c=this;a={requestUri:a,sessionId:b};this.K&&(this.K.cancel(),this.K=null);var d=null,e=null,f=sg(c.f,a).then(function(a){d=Qg(a);e=Si(a);return a});a=c.pc.then(function(){return f}).then(function(a){return Nk(c,a)}).then(function(){return cg({user:U(c),credential:d,additionalUserInfo:e,operationType:"signIn"})});return this.c(a)};h.tc=function(){return Lf()};
h.signInWithPopup=function(a){if(!Of())return E(new O("operation-not-supported-in-this-environment"));var b=this,c=jg(a.providerId),d=this.tc(),e=null;(!Pf()||Gf())&&this.i().options.authDomain&&a.isOAuthProvider&&(e=bi(this.i().options.authDomain,this.i().options.apiKey,this.i().name,"signInViaPopup",a,null,d,firebase.SDK_VERSION||null));var f=zf(e,c&&c.Zb,c&&c.Yb);c=Mk(this).then(function(b){return b.$b(f,"signInViaPopup",a,d,!!e)}).then(function(){return new C(function(a,c){b.bb("signInViaPopup",
null,new O("cancelled-popup-request"),b.la);b.ka=a;b.Va=c;b.la=d;b.K=b.v.fc(b,"signInViaPopup",f,d)})}).then(function(a){f&&yf(f);return a?cg(a):null}).g(function(a){f&&yf(f);throw a;});return this.c(c)};h.signInWithRedirect=function(a){if(!Of())return E(new O("operation-not-supported-in-this-environment"));var b=this,c=Mk(this).then(function(){return Bk(b.na)}).then(function(){return b.v.ac("signInViaRedirect",a)});return this.c(c)};
h.getRedirectResult=function(){if(!Of())return E(new O("operation-not-supported-in-this-environment"));var a=this,b=Mk(this).then(function(){return a.v.getRedirectResult()}).then(function(a){return a?cg(a):null});return this.c(b)};
var Nk=function(a,b){var c={};c.apiKey=a.i().options.apiKey;c.authDomain=a.i().options.authDomain;c.appName=a.i().name;return a.pc.then(function(){return tk(c,b,a.zb,$a(a.M))}).then(function(b){if(U(a)&&b.uid==U(a).uid)return U(a).copy(b),a.pb(b);Fk(a,b);Yj(b);return a.pb(b)}).then(function(){a.Ta()})},Fk=function(a,b){U(a)&&(Wj(U(a),a.bf),tc(U(a),"tokenChanged",a.Gb),tc(U(a),"userDeleted",a.$e),tc(U(a),"userInvalidated",a.af),Vj(U(a)));b&&(b.Sc.push(a.bf),lc(b,"tokenChanged",a.Gb),lc(b,"userDeleted",
a.$e),lc(b,"userInvalidated",a.af),0<a.Oa&&Uj(b));N(a,"currentUser",b);b&&(b.Cb(a.ia),Rj(b,a),Qj(b,a.M),Sj(b,a))};T.prototype.signOut=function(){var a=this,b=this.ya.then(function(){if(!U(a))return D();Fk(a,null);return Dk(a.na).then(function(){a.Ta()})});return this.c(b)};
var Ok=function(a){var b=a.i().options.authDomain;b=vk(a.zb,b).then(function(b){if(a.Za=b)b.Ya=a.zb;return qk(a.zb)});return a.c(b)},Gk=function(a){var b=a.i().options.authDomain,c=Ok(a).then(function(){return Ek(a.na,b)}).then(function(b){return b?(b.Ya=a.zb,a.Za&&(a.Za.Ha||null)==(b.Ha||null)?b:b.reload().then(function(){return Ck(a.na,b).then(function(){return b})}).g(function(c){return"auth/network-request-failed"==c.code?b:Dk(a.na)})):null}).then(function(b){Fk(a,b||null)});return a.c(c)},Hk=
function(a){return a.pc.then(function(){return a.getRedirectResult()}).g(function(){}).then(function(){if(!a.Ea)return a.ud()}).g(function(){}).then(function(){if(!a.Ea){a.Dc=!0;var b=a.na;b.h.addListener(wk("local"),b.j,a.ud)}})};h=T.prototype;
h.vg=function(){var a=this,b=this.i().options.authDomain;return Ek(this.na,b).then(function(b){if(!a.Ea){var c;if(c=U(a)&&b){c=U(a).uid;var e=b.uid;c=void 0===c||null===c||""===c||void 0===e||null===e||""===e?!1:c==e}if(c)return U(a).copy(b),U(a).getIdToken();if(U(a)||b)Fk(a,b),b&&(Yj(b),b.Ya=a.zb),a.v&&a.v.subscribe(a),a.Ta()}})};h.pb=function(a){return Ck(this.na,a)};h.wd=function(){this.Ta();this.pb(U(this))};h.Lf=function(){this.signOut()};h.Mf=function(){this.signOut()};
var Pk=function(a,b){var c=null,d=null;return a.c(b.then(function(b){c=Qg(b);d=Si(b);return Nk(a,b)}).then(function(){return cg({user:U(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))};h=T.prototype;h.Pf=function(a){var b=this;this.addAuthTokenListener(function(){a.next(U(b))})};h.Rf=function(a){var b=this;Qk(this,function(){a.next(U(b))})};
h.onIdTokenChanged=function(a,b,c){var d=this;this.Dc&&firebase.Promise.resolve().then(function(){p(a)?a(U(d)):p(a.next)&&a.next(U(d))});return this.ag(a,b,c)};h.onAuthStateChanged=function(a,b,c){var d=this;this.Dc&&firebase.Promise.resolve().then(function(){d.mc=d.getUid();p(a)?a(U(d)):p(a.next)&&a.next(U(d))});return this.cg(a,b,c)};h.Ff=function(a){var b=this,c=this.ya.then(function(){return U(b)?U(b).getIdToken(a).then(function(a){return{accessToken:a}}):null});return this.c(c)};
h.signInWithCustomToken=function(a){var b=this;return this.ya.then(function(){return Pk(b,Q(b.f,Lh,{token:a}))}).then(function(a){a=a.user;ek(a,"isAnonymous",!1);return b.pb(a)}).then(function(){return U(b)})};h.signInWithEmailAndPassword=function(a,b){var c=this;return this.ya.then(function(){return Pk(c,Q(c.f,Gg,{email:a,password:b}))}).then(function(a){return a.user})};h.createUserWithEmailAndPassword=function(a,b){var c=this;return this.ya.then(function(){return Pk(c,Q(c.f,Hh,{email:a,password:b}))}).then(function(a){return a.user})};
h.signInWithCredential=function(a){return this.signInAndRetrieveDataWithCredential(a).then(function(a){return a.user})};h.signInAndRetrieveDataWithCredential=function(a){var b=this;return this.ya.then(function(){return Pk(b,a.Ob(b.f))})};h.signInAnonymously=function(){var a=this;return this.ya.then(function(){var b=U(a);return b&&b.isAnonymous?b:Pk(a,a.f.signInAnonymously()).then(function(b){b=b.user;ek(b,"isAnonymous",!0);return a.pb(b)}).then(function(){return U(a)})})};h.i=function(){return this.app};
var U=function(a){return a.currentUser};T.prototype.getUid=function(){return U(this)&&U(this).uid||null};var Rk=function(a){return U(a)&&U(a)._lat||null};h=T.prototype;h.Ta=function(){if(this.Dc){for(var a=0;a<this.Ka.length;a++)if(this.Ka[a])this.Ka[a](Rk(this));if(this.mc!==this.getUid()&&this.Fb.length)for(this.mc=this.getUid(),a=0;a<this.Fb.length;a++)if(this.Fb[a])this.Fb[a](Rk(this))}};h.lf=function(a){this.addAuthTokenListener(a);this.Oa++;0<this.Oa&&U(this)&&Uj(U(this))};
h.ig=function(a){var b=this;x(this.Ka,function(c){c==a&&b.Oa--});0>this.Oa&&(this.Oa=0);0==this.Oa&&U(this)&&Vj(U(this));this.removeAuthTokenListener(a)};h.addAuthTokenListener=function(a){var b=this;this.Ka.push(a);this.c(this.ya.then(function(){b.Ea||Va(b.Ka,a)&&a(Rk(b))}))};h.removeAuthTokenListener=function(a){Ya(this.Ka,function(b){return b==a})};var Qk=function(a,b){a.Fb.push(b);a.c(a.ya.then(function(){!a.Ea&&Va(a.Fb,b)&&a.mc!==a.getUid()&&(a.mc=a.getUid(),b(Rk(a)))}))};h=T.prototype;
h["delete"]=function(){this.Ea=!0;for(var a=0;a<this.J.length;a++)this.J[a].cancel("app-deleted");this.J=[];this.na&&(a=this.na,a.h.removeListener(wk("local"),a.j,this.ud));this.v&&this.v.unsubscribe(this);return firebase.Promise.resolve()};h.c=function(a){var b=this;this.J.push(a);Fd(a,function(){Xa(b.J,a)});return a};h.fetchProvidersForEmail=function(a){return this.c(lh(this.f,a))};h.verifyPasswordResetCode=function(a){return this.checkActionCode(a).then(function(a){return a.data.email})};
h.confirmPasswordReset=function(a,b){return this.c(this.f.confirmPasswordReset(a,b).then(function(){}))};h.checkActionCode=function(a){return this.c(this.f.checkActionCode(a).then(function(a){return new Ji(a)}))};h.applyActionCode=function(a){return this.c(this.f.applyActionCode(a).then(function(){}))};h.sendPasswordResetEmail=function(a,b){var c=this;return this.c(D().then(function(){return"undefined"===typeof b||ib(b)?{}:Gi(new Fi(b))}).then(function(b){return c.f.sendPasswordResetEmail(a,b)}).then(function(){}))};
h.signInWithPhoneNumber=function(a,b){return this.c(Ii(this,a,b,r(this.signInAndRetrieveDataWithCredential,this)))};var Tk=function(a,b,c,d){a:{c=Array.prototype.slice.call(c);var e=0;for(var f=!1,g=0;g<b.length;g++)if(b[g].optional)f=!0;else{if(f)throw new O("internal-error","Argument validator encountered a required argument after an optional argument.");e++}f=b.length;if(c.length<e||f<c.length)d="Expected "+(e==f?1==e?"1 argument":e+" arguments":e+"-"+f+" arguments")+" but got "+c.length+".";else{for(e=0;e<c.length;e++)if(f=b[e].optional&&void 0===c[e],!b[e].U(c[e])&&!f){b=b[e];if(0>e||e>=Sk.length)throw new O("internal-error",
"Argument validator received an unsupported number of arguments.");c=Sk[e];d=(d?"":c+" argument ")+(b.name?'"'+b.name+'" ':"")+"must be "+b.T+".";break a}d=null}}if(d)throw new O("argument-error",a+" failed: "+d);},Sk="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" "),V=function(a,b){return{name:a||"",T:"a valid string",optional:!!b,U:m}},Uk=function(){return{name:"opt_forceRefresh",T:"a boolean",optional:!0,U:ca}},W=function(a,b){return{name:a||"",T:"a valid object",optional:!!b,
U:q}},Vk=function(a,b){return{name:a||"",T:"a function",optional:!!b,U:p}},Wk=function(a,b){return{name:a||"",T:"null",optional:!!b,U:fa}},Xk=function(){return{name:"",T:"an HTML element",optional:!1,U:function(a){return!!(a&&a instanceof Element)}}},Yk=function(){return{name:"auth",T:"an instance of Firebase Auth",optional:!0,U:function(a){return!!(a&&a instanceof T)}}},Zk=function(){return{name:"app",T:"an instance of Firebase App",optional:!0,U:function(a){return!!(a&&a instanceof firebase.app.App)}}},
$k=function(a){return{name:a?a+"Credential":"credential",T:a?"a valid "+a+" credential":"a valid credential",optional:!1,U:function(b){if(!b)return!1;var c=!a||b.providerId===a;return!(!b.Ob||!c)}}},al=function(){return{name:"authProvider",T:"a valid Auth provider",optional:!1,U:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}},bl=function(){return{name:"applicationVerifier",T:"an implementation of firebase.auth.ApplicationVerifier",optional:!1,U:function(a){return!!(a&&
m(a.type)&&p(a.verify))}}},X=function(a,b,c,d){return{name:c||"",T:a.T+" or "+b.T,optional:!!d,U:function(c){return a.U(c)||b.U(c)}}};var Y=function(a,b){for(var c in b){var d=b[c].name;a[d]=cl(d,a[c],b[c].a)}},Z=function(a,b,c,d){a[b]=cl(b,c,d)},cl=function(a,b,c){if(!c)return b;var d=dl(a);a=function(){var a=Array.prototype.slice.call(arguments);Tk(d,c,a);return b.apply(this,a)};for(var e in b)a[e]=b[e];for(e in b.prototype)a.prototype[e]=b.prototype[e];return a},dl=function(a){a=a.split(".");return a[a.length-1]};Y(T.prototype,{applyActionCode:{name:"applyActionCode",a:[V("code")]},checkActionCode:{name:"checkActionCode",a:[V("code")]},confirmPasswordReset:{name:"confirmPasswordReset",a:[V("code"),V("newPassword")]},createUserWithEmailAndPassword:{name:"createUserWithEmailAndPassword",a:[V("email"),V("password")]},fetchProvidersForEmail:{name:"fetchProvidersForEmail",a:[V("email")]},getRedirectResult:{name:"getRedirectResult",a:[]},onAuthStateChanged:{name:"onAuthStateChanged",a:[X(W(),Vk(),"nextOrObserver"),
Vk("opt_error",!0),Vk("opt_completed",!0)]},onIdTokenChanged:{name:"onIdTokenChanged",a:[X(W(),Vk(),"nextOrObserver"),Vk("opt_error",!0),Vk("opt_completed",!0)]},sendPasswordResetEmail:{name:"sendPasswordResetEmail",a:[V("email"),X(W("opt_actionCodeSettings",!0),Wk(null,!0),"opt_actionCodeSettings",!0)]},setPersistence:{name:"setPersistence",a:[V("persistence")]},signInAndRetrieveDataWithCredential:{name:"signInAndRetrieveDataWithCredential",a:[$k()]},signInAnonymously:{name:"signInAnonymously",a:[]},
signInWithCredential:{name:"signInWithCredential",a:[$k()]},signInWithCustomToken:{name:"signInWithCustomToken",a:[V("token")]},signInWithEmailAndPassword:{name:"signInWithEmailAndPassword",a:[V("email"),V("password")]},signInWithPhoneNumber:{name:"signInWithPhoneNumber",a:[V("phoneNumber"),bl()]},signInWithPopup:{name:"signInWithPopup",a:[al()]},signInWithRedirect:{name:"signInWithRedirect",a:[al()]},signOut:{name:"signOut",a:[]},toJSON:{name:"toJSON",a:[V(null,!0)]},useDeviceLanguage:{name:"useDeviceLanguage",
a:[]},verifyPasswordResetCode:{name:"verifyPasswordResetCode",a:[V("code")]}});(function(a,b){for(var c in b){var d=b[c].name;if(d!==c){var e=b[c].nf;Object.defineProperty(a,d,{get:function(){return this[c]},set:function(a){Tk(d,[e],[a],!0);this[c]=a},enumerable:!0})}}})(T.prototype,{lc:{name:"languageCode",nf:X(V(),Wk(),"languageCode")}});T.Persistence=Ti;T.Persistence.LOCAL="local";T.Persistence.SESSION="session";T.Persistence.NONE="none";
Y(S.prototype,{"delete":{name:"delete",a:[]},getIdToken:{name:"getIdToken",a:[Uk()]},getToken:{name:"getToken",a:[Uk()]},linkAndRetrieveDataWithCredential:{name:"linkAndRetrieveDataWithCredential",a:[$k()]},linkWithCredential:{name:"linkWithCredential",a:[$k()]},linkWithPhoneNumber:{name:"linkWithPhoneNumber",a:[V("phoneNumber"),bl()]},linkWithPopup:{name:"linkWithPopup",a:[al()]},linkWithRedirect:{name:"linkWithRedirect",a:[al()]},reauthenticateAndRetrieveDataWithCredential:{name:"reauthenticateAndRetrieveDataWithCredential",
a:[$k()]},reauthenticateWithCredential:{name:"reauthenticateWithCredential",a:[$k()]},reauthenticateWithPhoneNumber:{name:"reauthenticateWithPhoneNumber",a:[V("phoneNumber"),bl()]},reauthenticateWithPopup:{name:"reauthenticateWithPopup",a:[al()]},reauthenticateWithRedirect:{name:"reauthenticateWithRedirect",a:[al()]},reload:{name:"reload",a:[]},sendEmailVerification:{name:"sendEmailVerification",a:[X(W("opt_actionCodeSettings",!0),Wk(null,!0),"opt_actionCodeSettings",!0)]},toJSON:{name:"toJSON",a:[V(null,
!0)]},unlink:{name:"unlink",a:[V("provider")]},updateEmail:{name:"updateEmail",a:[V("email")]},updatePassword:{name:"updatePassword",a:[V("password")]},updatePhoneNumber:{name:"updatePhoneNumber",a:[$k("phone")]},updateProfile:{name:"updateProfile",a:[W("profile")]}});Y(C.prototype,{g:{name:"catch"},then:{name:"then"}});Y(Hi.prototype,{confirm:{name:"confirm",a:[V("verificationCode")]}});Z(Ig,"credential",function(a,b){return new Fg(a,b)},[V("email"),V("password")]);
Y(xg.prototype,{addScope:{name:"addScope",a:[V("scope")]},setCustomParameters:{name:"setCustomParameters",a:[W("customOAuthParameters")]}});Z(xg,"credential",yg,[X(V(),W(),"token")]);Y(zg.prototype,{addScope:{name:"addScope",a:[V("scope")]},setCustomParameters:{name:"setCustomParameters",a:[W("customOAuthParameters")]}});Z(zg,"credential",Ag,[X(V(),W(),"token")]);Y(Bg.prototype,{addScope:{name:"addScope",a:[V("scope")]},setCustomParameters:{name:"setCustomParameters",a:[W("customOAuthParameters")]}});
Z(Bg,"credential",Cg,[X(V(),X(W(),Wk()),"idToken"),X(V(),Wk(),"accessToken",!0)]);Y(Dg.prototype,{setCustomParameters:{name:"setCustomParameters",a:[W("customOAuthParameters")]}});Z(Dg,"credential",Eg,[X(V(),W(),"token"),V("secret",!0)]);Y(P.prototype,{addScope:{name:"addScope",a:[V("scope")]},credential:{name:"credential",a:[X(V(),Wk(),"idToken",!0),X(V(),Wk(),"accessToken",!0)]},setCustomParameters:{name:"setCustomParameters",a:[W("customOAuthParameters")]}});
Z(Ng,"credential",Pg,[V("verificationId"),V("verificationCode")]);Y(Ng.prototype,{verifyPhoneNumber:{name:"verifyPhoneNumber",a:[V("phoneNumber"),bl()]}});Y(O.prototype,{toJSON:{name:"toJSON",a:[V(null,!0)]}});Y(Sg.prototype,{toJSON:{name:"toJSON",a:[V(null,!0)]}});Y(og.prototype,{toJSON:{name:"toJSON",a:[V(null,!0)]}});Y(ki.prototype,{clear:{name:"clear",a:[]},render:{name:"render",a:[]},verify:{name:"verify",a:[]}});
(function(){if("undefined"!==typeof firebase&&firebase.INTERNAL&&firebase.INTERNAL.registerService){var a={Auth:T,Error:O};Z(a,"EmailAuthProvider",Ig,[]);Z(a,"FacebookAuthProvider",xg,[]);Z(a,"GithubAuthProvider",zg,[]);Z(a,"GoogleAuthProvider",Bg,[]);Z(a,"TwitterAuthProvider",Dg,[]);Z(a,"OAuthProvider",P,[V("providerId")]);Z(a,"PhoneAuthProvider",Ng,[Yk()]);Z(a,"RecaptchaVerifier",ki,[X(V(),Xk(),"recaptchaContainer"),W("recaptchaParameters",!0),Zk()]);firebase.INTERNAL.registerService("auth",function(a,
c){a=new T(a);c({INTERNAL:{getUid:r(a.getUid,a),getToken:r(a.Ff,a),addAuthTokenListener:r(a.lf,a),removeAuthTokenListener:r(a.ig,a)}});return a},a,function(a,c){if("create"===a)try{c.auth()}catch(d){}});firebase.INTERNAL.extendNamespace({User:S})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");})();}).call(this);
}).call(typeof global !== undefined ? global : typeof self !== undefined ? self : typeof window !== undefined ? window : {});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/

---

typedarray.js
Copyright (c) 2010, Linden Research, Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.registerDatabase = registerDatabase;

var _app = __webpack_require__(34);

var _app2 = _interopRequireDefault(_app);

var _Database = __webpack_require__(159);

var _Query = __webpack_require__(160);

var _Reference = __webpack_require__(104);

var _util = __webpack_require__(3);

var _RepoManager = __webpack_require__(105);

var _internal = __webpack_require__(378);

var INTERNAL = _interopRequireWildcard(_internal);

var _test_access = __webpack_require__(380);

var TEST_ACCESS = _interopRequireWildcard(_test_access);

var _environment = __webpack_require__(50);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function registerDatabase(instance) {
    // Register the Database Service with the 'firebase' namespace.
    var namespace = instance.INTERNAL.registerService('database', function (app, unused, url) {
        return _RepoManager.RepoManager.getInstance().databaseFromApp(app, url);
    },
    // firebase.database namespace properties
    {
        Reference: _Reference.Reference,
        Query: _Query.Query,
        Database: _Database.Database,
        enableLogging: _util.enableLogging,
        INTERNAL: INTERNAL,
        ServerValue: _Database.Database.ServerValue,
        TEST_ACCESS: TEST_ACCESS
    }, null, true);
    if ((0, _environment.isNodeSdk)()) {
        module.exports = namespace;
    }
} /**
   * Copyright 2017 Google Inc.
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */

registerDatabase(_app2.default);
//# sourceMappingURL=database.js.map


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TransactionResult = undefined;

var _validation = __webpack_require__(40);

var TransactionResult = /** @class */function () {
    /**
     * A type for the resolve value of Firebase.transaction.
     * @constructor
     * @dict
     * @param {boolean} committed
     * @param {DataSnapshot} snapshot
     */
    function TransactionResult(committed, snapshot) {
        this.committed = committed;
        this.snapshot = snapshot;
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    TransactionResult.prototype.toJSON = function () {
        (0, _validation.validateArgCount)('TransactionResult.toJSON', 0, 1, arguments.length);
        return { committed: this.committed, snapshot: this.snapshot.toJSON() };
    };
    return TransactionResult;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.TransactionResult = TransactionResult;
//# sourceMappingURL=TransactionResult.js.map


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.interceptServerData = exports.dataUpdateCount = exports.statsIncrementCounter = exports.stats = exports.setSecurityDebugCallback = exports.isWebSocketsAvailable = exports.forceWebSockets = exports.forceLongPolling = undefined;

var _WebSocketConnection = __webpack_require__(182);

var _BrowserPollConnection = __webpack_require__(180);

/**
 * INTERNAL methods for internal-use only (tests, etc.).
 *
 * Customers shouldn't use these or else should be aware that they could break at any time.
 *
 * @const
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var forceLongPolling = exports.forceLongPolling = function forceLongPolling() {
    _WebSocketConnection.WebSocketConnection.forceDisallow();
    _BrowserPollConnection.BrowserPollConnection.forceAllow();
};
var forceWebSockets = exports.forceWebSockets = function forceWebSockets() {
    _BrowserPollConnection.BrowserPollConnection.forceDisallow();
};
/* Used by App Manager */
var isWebSocketsAvailable = exports.isWebSocketsAvailable = function isWebSocketsAvailable() {
    return _WebSocketConnection.WebSocketConnection['isAvailable']();
};
var setSecurityDebugCallback = exports.setSecurityDebugCallback = function setSecurityDebugCallback(ref, callback) {
    ref.repo.persistentConnection_.securityDebugCallback_ = callback;
};
var stats = exports.stats = function stats(ref, showDelta) {
    ref.repo.stats(showDelta);
};
var statsIncrementCounter = exports.statsIncrementCounter = function statsIncrementCounter(ref, metric) {
    ref.repo.statsIncrementCounter(metric);
};
var dataUpdateCount = exports.dataUpdateCount = function dataUpdateCount(ref) {
    return ref.repo.dataUpdateCount;
};
var interceptServerData = exports.interceptServerData = function interceptServerData(ref, callback) {
    return ref.repo.interceptServerData_(callback);
};
//# sourceMappingURL=internal.js.map


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OnDisconnect = undefined;

var _validation = __webpack_require__(40);

var _validation2 = __webpack_require__(37);

var _util = __webpack_require__(3);

var _promise = __webpack_require__(39);

/**
 * @constructor
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var OnDisconnect = /** @class */function () {
    /**
     * @param {!Repo} repo_
     * @param {!Path} path_
     */
    function OnDisconnect(repo_, path_) {
        this.repo_ = repo_;
        this.path_ = path_;
    }
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.cancel = function (onComplete) {
        (0, _validation.validateArgCount)('OnDisconnect.cancel', 0, 1, arguments.length);
        (0, _validation.validateCallback)('OnDisconnect.cancel', 1, onComplete, true);
        var deferred = new _promise.Deferred();
        this.repo_.onDisconnectCancel(this.path_, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.remove = function (onComplete) {
        (0, _validation.validateArgCount)('OnDisconnect.remove', 0, 1, arguments.length);
        (0, _validation2.validateWritablePath)('OnDisconnect.remove', this.path_);
        (0, _validation.validateCallback)('OnDisconnect.remove', 1, onComplete, true);
        var deferred = new _promise.Deferred();
        this.repo_.onDisconnectSet(this.path_, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.set = function (value, onComplete) {
        (0, _validation.validateArgCount)('OnDisconnect.set', 1, 2, arguments.length);
        (0, _validation2.validateWritablePath)('OnDisconnect.set', this.path_);
        (0, _validation2.validateFirebaseDataArg)('OnDisconnect.set', 1, value, this.path_, false);
        (0, _validation.validateCallback)('OnDisconnect.set', 2, onComplete, true);
        var deferred = new _promise.Deferred();
        this.repo_.onDisconnectSet(this.path_, value, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {number|string|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.setWithPriority = function (value, priority, onComplete) {
        (0, _validation.validateArgCount)('OnDisconnect.setWithPriority', 2, 3, arguments.length);
        (0, _validation2.validateWritablePath)('OnDisconnect.setWithPriority', this.path_);
        (0, _validation2.validateFirebaseDataArg)('OnDisconnect.setWithPriority', 1, value, this.path_, false);
        (0, _validation2.validatePriority)('OnDisconnect.setWithPriority', 2, priority, false);
        (0, _validation.validateCallback)('OnDisconnect.setWithPriority', 3, onComplete, true);
        var deferred = new _promise.Deferred();
        this.repo_.onDisconnectSetWithPriority(this.path_, value, priority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.update = function (objectToMerge, onComplete) {
        (0, _validation.validateArgCount)('OnDisconnect.update', 1, 2, arguments.length);
        (0, _validation2.validateWritablePath)('OnDisconnect.update', this.path_);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for (var i = 0; i < objectToMerge.length; ++i) {
                newObjectToMerge['' + i] = objectToMerge[i];
            }
            objectToMerge = newObjectToMerge;
            (0, _util.warn)('Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the ' + 'existing data, or an Object with integer keys if you really do want to only update some of the children.');
        }
        (0, _validation2.validateFirebaseMergeDataArg)('OnDisconnect.update', 1, objectToMerge, this.path_, false);
        (0, _validation.validateCallback)('OnDisconnect.update', 2, onComplete, true);
        var deferred = new _promise.Deferred();
        this.repo_.onDisconnectUpdate(this.path_, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    return OnDisconnect;
}();
exports.OnDisconnect = OnDisconnect;
//# sourceMappingURL=onDisconnect.js.map


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.forceRestClient = exports.listens = exports.queryIdentifier = exports.ConnectionTarget = exports.hijackHash = exports.RealTimeConnection = exports.DataConnection = undefined;

var _RepoInfo = __webpack_require__(162);

var _PersistentConnection = __webpack_require__(161);

var _RepoManager = __webpack_require__(105);

var _Connection = __webpack_require__(181);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DataConnection = exports.DataConnection = _PersistentConnection.PersistentConnection;
/**
 * @param {!string} pathString
 * @param {function(*)} onComplete
 */
_PersistentConnection.PersistentConnection.prototype.simpleListen = function (pathString, onComplete) {
    this.sendRequest('q', { p: pathString }, onComplete);
};
/**
 * @param {*} data
 * @param {function(*)} onEcho
 */
_PersistentConnection.PersistentConnection.prototype.echo = function (data, onEcho) {
    this.sendRequest('echo', { d: data }, onEcho);
};
// RealTimeConnection properties that we use in tests.
var RealTimeConnection = exports.RealTimeConnection = _Connection.Connection;
/**
 * @param {function(): string} newHash
 * @return {function()}
 */
var hijackHash = exports.hijackHash = function hijackHash(newHash) {
    var oldPut = _PersistentConnection.PersistentConnection.prototype.put;
    _PersistentConnection.PersistentConnection.prototype.put = function (pathString, data, opt_onComplete, opt_hash) {
        if (opt_hash !== undefined) {
            opt_hash = newHash();
        }
        oldPut.call(this, pathString, data, opt_onComplete, opt_hash);
    };
    return function () {
        _PersistentConnection.PersistentConnection.prototype.put = oldPut;
    };
};
/**
 * @type {function(new:RepoInfo, !string, boolean, !string, boolean): undefined}
 */
var ConnectionTarget = exports.ConnectionTarget = _RepoInfo.RepoInfo;
/**
 * @param {!Query} query
 * @return {!string}
 */
var queryIdentifier = exports.queryIdentifier = function queryIdentifier(query) {
    return query.queryIdentifier();
};
/**
 * @param {!Query} firebaseRef
 * @return {!Object}
 */
var listens = exports.listens = function listens(firebaseRef) {
    return firebaseRef.repo.persistentConnection_.listens_;
};
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 *
 * @param {boolean} forceRestClient
 */
var forceRestClient = exports.forceRestClient = function forceRestClient(_forceRestClient) {
    _RepoManager.RepoManager.getInstance().forceRestClient(_forceRestClient);
};
//# sourceMappingURL=test_access.js.map


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AuthTokenProvider = undefined;

var _util = __webpack_require__(3);

/**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */
var AuthTokenProvider = /** @class */function () {
    /**
     * @param {!FirebaseApp} app_
     */
    function AuthTokenProvider(app_) {
        this.app_ = app_;
    }
    /**
     * @param {boolean} forceRefresh
     * @return {!Promise<FirebaseAuthTokenData>}
     */
    AuthTokenProvider.prototype.getToken = function (forceRefresh) {
        return this.app_['INTERNAL']['getToken'](forceRefresh).then(null,
        // .catch
        function (error) {
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error && error.code === 'auth/token-not-initialized') {
                (0, _util.log)('Got auth/token-not-initialized error.  Treating as null token.');
                return null;
            } else {
                return Promise.reject(error);
            }
        });
    };
    AuthTokenProvider.prototype.addTokenChangeListener = function (listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        this.app_['INTERNAL']['addAuthTokenListener'](listener);
    };
    AuthTokenProvider.prototype.removeTokenChangeListener = function (listener) {
        this.app_['INTERNAL']['removeAuthTokenListener'](listener);
    };
    AuthTokenProvider.prototype.notifyForInvalidToken = function () {
        var errorMessage = 'Provided authentication credentials for the app named "' + this.app_.name + '" are invalid. This usually indicates your app was not ' + 'initialized correctly. ';
        if ('credential' in this.app_.options) {
            errorMessage += 'Make sure the "credential" property provided to initializeApp() ' + 'is authorized to access the specified "databaseURL" and is from the correct ' + 'project.';
        } else if ('serviceAccount' in this.app_.options) {
            errorMessage += 'Make sure the "serviceAccount" property provided to initializeApp() ' + 'is authorized to access the specified "databaseURL" and is from the correct ' + 'project.';
        } else {
            errorMessage += 'Make sure the "apiKey" and "databaseURL" properties provided to ' + 'initializeApp() match the values provided for your app at ' + 'https://console.firebase.google.com/.';
        }
        (0, _util.warn)(errorMessage);
    };
    return AuthTokenProvider;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.AuthTokenProvider = AuthTokenProvider;
//# sourceMappingURL=AuthTokenProvider.js.map


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CompoundWrite = undefined;

var _ImmutableTree = __webpack_require__(107);

var _Path = __webpack_require__(9);

var _obj = __webpack_require__(7);

var _Node = __webpack_require__(19);

var _PriorityIndex = __webpack_require__(15);

var _assert = __webpack_require__(2);

/**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 *
 * @constructor
 * @param {!ImmutableTree.<!Node>} writeTree
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var CompoundWrite = /** @class */function () {
    function CompoundWrite(writeTree_) {
        this.writeTree_ = writeTree_;
    }
    /**
     * @param {!Path} path
     * @param {!Node} node
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.addWrite = function (path, node) {
        if (path.isEmpty()) {
            return new CompoundWrite(new _ImmutableTree.ImmutableTree(node));
        } else {
            var rootmost = this.writeTree_.findRootMostValueAndPath(path);
            if (rootmost != null) {
                var rootMostPath = rootmost.path;
                var value = rootmost.value;
                var relativePath = _Path.Path.relativePath(rootMostPath, path);
                value = value.updateChild(relativePath, node);
                return new CompoundWrite(this.writeTree_.set(rootMostPath, value));
            } else {
                var subtree = new _ImmutableTree.ImmutableTree(node);
                var newWriteTree = this.writeTree_.setTree(path, subtree);
                return new CompoundWrite(newWriteTree);
            }
        }
    };
    /**
     * @param {!Path} path
     * @param {!Object.<string, !Node>} updates
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.addWrites = function (path, updates) {
        var newWrite = this;
        (0, _obj.forEach)(updates, function (childKey, node) {
            newWrite = newWrite.addWrite(path.child(childKey), node);
        });
        return newWrite;
    };
    /**
     * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
     * location, which must be removed by calling this method with that path.
     *
     * @param {!Path} path The path at which a write and all deeper writes should be removed
     * @return {!CompoundWrite} The new CompoundWrite with the removed path
     */
    CompoundWrite.prototype.removeWrite = function (path) {
        if (path.isEmpty()) {
            return CompoundWrite.Empty;
        } else {
            var newWriteTree = this.writeTree_.setTree(path, _ImmutableTree.ImmutableTree.Empty);
            return new CompoundWrite(newWriteTree);
        }
    };
    /**
     * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
     * considered "complete".
     *
     * @param {!Path} path The path to check for
     * @return {boolean} Whether there is a complete write at that path
     */
    CompoundWrite.prototype.hasCompleteWrite = function (path) {
        return this.getCompleteNode(path) != null;
    };
    /**
     * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
     * writes from deeper paths, but will return child nodes from a more shallow path.
     *
     * @param {!Path} path The path to get a complete write
     * @return {?Node} The node if complete at that path, or null otherwise.
     */
    CompoundWrite.prototype.getCompleteNode = function (path) {
        var rootmost = this.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) {
            return this.writeTree_.get(rootmost.path).getChild(_Path.Path.relativePath(rootmost.path, path));
        } else {
            return null;
        }
    };
    /**
     * Returns all children that are guaranteed to be a complete overwrite.
     *
     * @return {!Array.<NamedNode>} A list of all complete children.
     */
    CompoundWrite.prototype.getCompleteChildren = function () {
        var children = [];
        var node = this.writeTree_.value;
        if (node != null) {
            // If it's a leaf node, it has no children; so nothing to do.
            if (!node.isLeafNode()) {
                node.forEachChild(_PriorityIndex.PRIORITY_INDEX, function (childName, childNode) {
                    children.push(new _Node.NamedNode(childName, childNode));
                });
            }
        } else {
            this.writeTree_.children.inorderTraversal(function (childName, childTree) {
                if (childTree.value != null) {
                    children.push(new _Node.NamedNode(childName, childTree.value));
                }
            });
        }
        return children;
    };
    /**
     * @param {!Path} path
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.childCompoundWrite = function (path) {
        if (path.isEmpty()) {
            return this;
        } else {
            var shadowingNode = this.getCompleteNode(path);
            if (shadowingNode != null) {
                return new CompoundWrite(new _ImmutableTree.ImmutableTree(shadowingNode));
            } else {
                return new CompoundWrite(this.writeTree_.subtree(path));
            }
        }
    };
    /**
     * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
     * @return {boolean} Whether this CompoundWrite is empty
     */
    CompoundWrite.prototype.isEmpty = function () {
        return this.writeTree_.isEmpty();
    };
    /**
     * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
     * node
     * @param {!Node} node The node to apply this CompoundWrite to
     * @return {!Node} The node with all writes applied
     */
    CompoundWrite.prototype.apply = function (node) {
        return CompoundWrite.applySubtreeWrite_(_Path.Path.Empty, this.writeTree_, node);
    };
    /**
     * @type {!CompoundWrite}
     */
    CompoundWrite.Empty = new CompoundWrite(new _ImmutableTree.ImmutableTree(null));
    /**
     * @param {!Path} relativePath
     * @param {!ImmutableTree.<!Node>} writeTree
     * @param {!Node} node
     * @return {!Node}
     * @private
     */
    CompoundWrite.applySubtreeWrite_ = function (relativePath, writeTree, node) {
        if (writeTree.value != null) {
            // Since there a write is always a leaf, we're done here
            return node.updateChild(relativePath, writeTree.value);
        } else {
            var priorityWrite_1 = null;
            writeTree.children.inorderTraversal(function (childKey, childTree) {
                if (childKey === '.priority') {
                    // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                    // to apply priorities to empty nodes that are later filled
                    (0, _assert.assert)(childTree.value !== null, 'Priority writes must always be leaf nodes');
                    priorityWrite_1 = childTree.value;
                } else {
                    node = CompoundWrite.applySubtreeWrite_(relativePath.child(childKey), childTree, node);
                }
            });
            // If there was a priority write, we only apply it if the node is not empty
            if (!node.getChild(relativePath).isEmpty() && priorityWrite_1 !== null) {
                node = node.updateChild(relativePath.child('.priority'), priorityWrite_1);
            }
            return node;
        }
    };
    return CompoundWrite;
}();
exports.CompoundWrite = CompoundWrite;
//# sourceMappingURL=CompoundWrite.js.map


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ReadonlyRestClient = undefined;

var _assert = __webpack_require__(2);

var _util = __webpack_require__(3);

var _json = __webpack_require__(23);

var _obj = __webpack_require__(7);

var _util2 = __webpack_require__(440);

var _ServerActions = __webpack_require__(163);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();

/**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */
var ReadonlyRestClient = /** @class */function (_super) {
    __extends(ReadonlyRestClient, _super);
    /**
     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
     * @param {AuthTokenProvider} authTokenProvider_
     * @implements {ServerActions}
     */
    function ReadonlyRestClient(repoInfo_, onDataUpdate_, authTokenProvider_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        /** @private {function(...[*])} */
        _this.log_ = (0, _util.logWrapper)('p:rest:');
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         *
         * @private {!Object.<string, !Object>}
         */
        _this.listens_ = {};
        return _this;
    }
    ReadonlyRestClient.prototype.reportStats = function (stats) {
        throw new Error('Method not implemented.');
    };
    /**
     * @param {!Query} query
     * @param {?number=} tag
     * @return {string}
     * @private
     */
    ReadonlyRestClient.getListenId_ = function (query, tag) {
        if (tag !== undefined) {
            return 'tag$' + tag;
        } else {
            (0, _assert.assert)(query.getQueryParams().isDefault(), "should have a tag if it's not a default query.");
            return query.path.toString();
        }
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.listen = function (query, currentHashFn, tag, onComplete) {
        var _this = this;
        var pathString = query.path.toString();
        this.log_('Listen called for ' + pathString + ' ' + query.queryIdentifier());
        // Mark this listener so we can tell if it's removed.
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        var thisListen = {};
        this.listens_[listenId] = thisListen;
        var queryStringParamaters = query.getQueryParams().toRestQueryStringParameters();
        this.restRequest_(pathString + '.json', queryStringParamaters, function (error, result) {
            var data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) {
                _this.onDataUpdate_(pathString, data, /*isMerge=*/false, tag);
            }
            if ((0, _obj.safeGet)(_this.listens_, listenId) === thisListen) {
                var status_1;
                if (!error) {
                    status_1 = 'ok';
                } else if (error == 401) {
                    status_1 = 'permission_denied';
                } else {
                    status_1 = 'rest_error:' + error;
                }
                onComplete(status_1, null);
            }
        });
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.unlisten = function (query, tag) {
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.refreshAuthToken = function (token) {
        // no-op since we just always call getToken.
    };
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     *
     * @param {!string} pathString
     * @param {!Object.<string, *>} queryStringParameters
     * @param {?function(?number, *=)} callback
     * @private
     */
    ReadonlyRestClient.prototype.restRequest_ = function (pathString, queryStringParameters, callback) {
        var _this = this;
        if (queryStringParameters === void 0) {
            queryStringParameters = {};
        }
        queryStringParameters['format'] = 'export';
        this.authTokenProvider_.getToken( /*forceRefresh=*/false).then(function (authTokenData) {
            var authToken = authTokenData && authTokenData.accessToken;
            if (authToken) {
                queryStringParameters['auth'] = authToken;
            }
            var url = (_this.repoInfo_.secure ? 'https://' : 'http://') + _this.repoInfo_.host + pathString + '?' + (0, _util2.querystring)(queryStringParameters);
            _this.log_('Sending REST request for ' + url);
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (callback && xhr.readyState === 4) {
                    _this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
                    var res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = (0, _json.jsonEval)(xhr.responseText);
                        } catch (e) {
                            (0, _util.warn)('Failed to parse JSON response for ' + url + ': ' + xhr.responseText);
                        }
                        callback(null, res);
                    } else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) {
                            (0, _util.warn)('Got unsuccessful REST response for ' + url + ' Status: ' + xhr.status);
                        }
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open('GET', url, /*asynchronous=*/true);
            xhr.send();
        });
    };
    return ReadonlyRestClient;
}(_ServerActions.ServerActions);
exports.ReadonlyRestClient = ReadonlyRestClient;
//# sourceMappingURL=ReadonlyRestClient.js.map


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TransactionStatus = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Copyright 2017 Google Inc.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Licensed under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                               * you may not use this file except in compliance with the License.
                                                                                                                                                                                                                                                                               * You may obtain a copy of the License at
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               *   http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Unless required by applicable law or agreed to in writing, software
                                                                                                                                                                                                                                                                               * distributed under the License is distributed on an "AS IS" BASIS,
                                                                                                                                                                                                                                                                               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                                                                                                                                                                                                               * See the License for the specific language governing permissions and
                                                                                                                                                                                                                                                                               * limitations under the License.
                                                                                                                                                                                                                                                                               */


var _assert = __webpack_require__(2);

var _Reference = __webpack_require__(104);

var _DataSnapshot = __webpack_require__(158);

var _Path = __webpack_require__(9);

var _Tree = __webpack_require__(397);

var _PriorityIndex = __webpack_require__(15);

var _util = __webpack_require__(3);

var _ServerValues = __webpack_require__(176);

var _validation = __webpack_require__(37);

var _obj = __webpack_require__(7);

var _nodeFromJSON = __webpack_require__(62);

var _ChildrenNode = __webpack_require__(16);

var _Repo = __webpack_require__(77);

// TODO: This is pretty messy.  Ideally, a lot of this would move into FirebaseData, or a transaction-specific
// component used by FirebaseData, but it has ties to user callbacks (transaction update and onComplete) as well
// as the realtime connection (to send transactions to the server).  So that all needs to be decoupled first.
// For now it's part of Repo, but in its own file.
/**
 * @enum {number}
 */
var TransactionStatus = exports.TransactionStatus = undefined;
(function (TransactionStatus) {
    // We've run the transaction and updated transactionResultData_ with the result, but it isn't currently sent to the
    // server. A transaction will go from RUN -> SENT -> RUN if it comes back from the server as rejected due to
    // mismatched hash.
    TransactionStatus[TransactionStatus["RUN"] = 0] = "RUN";
    // We've run the transaction and sent it to the server and it's currently outstanding (hasn't come back as accepted
    // or rejected yet).
    TransactionStatus[TransactionStatus["SENT"] = 1] = "SENT";
    // Temporary state used to mark completed transactions (whether successful or aborted).  The transaction will be
    // removed when we get a chance to prune completed ones.
    TransactionStatus[TransactionStatus["COMPLETED"] = 2] = "COMPLETED";
    // Used when an already-sent transaction needs to be aborted (e.g. due to a conflicting set() call that was made).
    // If it comes back as unsuccessful, we'll abort it.
    TransactionStatus[TransactionStatus["SENT_NEEDS_ABORT"] = 3] = "SENT_NEEDS_ABORT";
    // Temporary state used to mark transactions that need to be aborted.
    TransactionStatus[TransactionStatus["NEEDS_ABORT"] = 4] = "NEEDS_ABORT";
})(TransactionStatus || (exports.TransactionStatus = TransactionStatus = {}));
/**
 * If a transaction does not succeed after 25 retries, we abort it.  Among other things this ensure that if there's
 * ever a bug causing a mismatch between client / server hashes for some data, we won't retry indefinitely.
 * @type {number}
 * @const
 * @private
 */
_Repo.Repo.MAX_TRANSACTION_RETRIES_ = 25;
/**
 * Setup the transaction data structures
 * @private
 */
_Repo.Repo.prototype.transactions_init_ = function () {
    /**
     * Stores queues of outstanding transactions for Firebase locations.
     *
     * @type {!Tree.<Array.<!Transaction>>}
     * @private
     */
    this.transactionQueueTree_ = new _Tree.Tree();
};
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and sends it to the server if possible.
 *
 * @param {!Path} path Path at which to do transaction.
 * @param {function(*):*} transactionUpdate Update callback.
 * @param {?function(?Error, boolean, ?DataSnapshot)} onComplete Completion callback.
 * @param {boolean} applyLocally Whether or not to make intermediate results visible
 */
_Repo.Repo.prototype.startTransaction = function (path, transactionUpdate, onComplete, applyLocally) {
    this.log_('transaction on ' + path);
    // Add a watch to make sure we get server updates.
    var valueCallback = function valueCallback() {};
    var watchRef = new _Reference.Reference(this, path);
    watchRef.on('value', valueCallback);
    var unwatcher = function unwatcher() {
        watchRef.off('value', valueCallback);
    };
    // Initialize transaction.
    var transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out which one goes first.
        order: (0, _util.LUIDGenerator)(),
        // Whether to raise local events for this transaction.
        applyLocally: applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        // Function to call to clean up our .on() listener.
        unwatcher: unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    var currentState = this.getLatestState_(path);
    transaction.currentInputSnapshot = currentState;
    var newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) {
            // We just set the input snapshot, so this cast should be safe
            var snapshot = new _DataSnapshot.DataSnapshot(transaction.currentInputSnapshot, new _Reference.Reference(this, transaction.path), _PriorityIndex.PRIORITY_INDEX);
            transaction.onComplete(null, false, snapshot);
        }
    } else {
        (0, _validation.validateFirebaseData)('transaction failed: Data returned ', newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = TransactionStatus.RUN;
        var queueNode = this.transactionQueueTree_.subTree(path);
        var nodeQueue = queueNode.getValue() || [];
        nodeQueue.push(transaction);
        queueNode.setValue(nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our transaction state, since the user could
        // start new transactions from the event callbacks.
        var priorityForNode = void 0;
        if ((typeof newVal === 'undefined' ? 'undefined' : _typeof(newVal)) === 'object' && newVal !== null && (0, _obj.contains)(newVal, '.priority')) {
            priorityForNode = (0, _obj.safeGet)(newVal, '.priority');
            (0, _assert.assert)((0, _validation.isValidPriority)(priorityForNode), 'Invalid priority returned by transaction. ' + 'Priority must be a valid string, finite number, server value, or null.');
        } else {
            var currentNode = this.serverSyncTree_.calcCompleteEventCache(path) || _ChildrenNode.ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        priorityForNode /** @type {null|number|string} */ = priorityForNode;
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = (0, _nodeFromJSON.nodeFromJSON)(newVal, priorityForNode);
        var newNode = (0, _ServerValues.resolveDeferredValueSnapshot)(newNodeUnresolved, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, transaction.currentWriteId, transaction.applyLocally);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        this.sendReadyTransactions_();
    }
};
/**
 * @param {!Path} path
 * @param {Array.<number>=} excludeSets A specific set to exclude
 * @return {Node}
 * @private
 */
_Repo.Repo.prototype.getLatestState_ = function (path, excludeSets) {
    return this.serverSyncTree_.calcCompleteEventCache(path, excludeSets) || _ChildrenNode.ChildrenNode.EMPTY_NODE;
};
/**
 * Sends any already-run transactions that aren't waiting for outstanding transactions to
 * complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively with a particular
 * transactionQueueTree node to recurse through the tree.
 *
 * @param {Tree.<Array.<Transaction>>=} node  transactionQueueTree node to start at.
 * @private
 */
_Repo.Repo.prototype.sendReadyTransactions_ = function (node) {
    var _this = this;
    if (node === void 0) {
        node = this.transactionQueueTree_;
    }
    // Before recursing, make sure any completed transactions are removed.
    if (!node) {
        this.pruneCompletedTransactionsBelowNode_(node);
    }
    if (node.getValue() !== null) {
        var queue = this.buildTransactionQueue_(node);
        (0, _assert.assert)(queue.length > 0, 'Sending zero length transaction queue');
        var allRun = queue.every(function (transaction) {
            return transaction.status === TransactionStatus.RUN;
        });
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) {
            this.sendTransactionQueue_(node.path(), queue);
        }
    } else if (node.hasChildren()) {
        node.forEachChild(function (childNode) {
            _this.sendReadyTransactions_(childNode);
        });
    }
};
/**
 * Given a list of run transactions, send them to the server and then handle the result (success or failure).
 *
 * @param {!Path} path The location of the queue.
 * @param {!Array.<Transaction>} queue Queue of transactions under the specified location.
 * @private
 */
_Repo.Repo.prototype.sendTransactionQueue_ = function (path, queue) {
    var _this = this;
    // Mark transactions as sent and increment retry count!
    var setsToIgnore = queue.map(function (txn) {
        return txn.currentWriteId;
    });
    var latestState = this.getLatestState_(path, setsToIgnore);
    var snapToSend = latestState;
    var latestHash = latestState.hash();
    for (var i = 0; i < queue.length; i++) {
        var txn = queue[i];
        (0, _assert.assert)(txn.status === TransactionStatus.RUN, 'tryToSendTransactionQueue_: items in queue should all be run.');
        txn.status = TransactionStatus.SENT;
        txn.retryCount++;
        var relativePath = _Path.Path.relativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /**@type {!Node} */, txn.currentOutputSnapshotRaw);
    }
    var dataToSend = snapToSend.val(true);
    var pathToSend = path;
    // Send the put.
    this.server_.put(pathToSend.toString(), dataToSend, function (status) {
        _this.log_('transaction put response', {
            path: pathToSend.toString(),
            status: status
        });
        var events = [];
        if (status === 'ok') {
            // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
            // the callback could trigger more transactions or sets.
            var callbacks = [];
            for (var i = 0; i < queue.length; i++) {
                queue[i].status = TransactionStatus.COMPLETED;
                events = events.concat(_this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId));
                if (queue[i].onComplete) {
                    // We never unset the output snapshot, and given that this transaction is complete, it should be set
                    var node = queue[i].currentOutputSnapshotResolved;
                    var ref = new _Reference.Reference(_this, queue[i].path);
                    var snapshot = new _DataSnapshot.DataSnapshot(node, ref, _PriorityIndex.PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, true, snapshot));
                }
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            _this.pruneCompletedTransactionsBelowNode_(_this.transactionQueueTree_.subTree(path));
            // There may be pending transactions that we can now send.
            _this.sendReadyTransactions_();
            _this.eventQueue_.raiseEventsForChangedPath(path, events);
            // Finally, trigger onComplete callbacks.
            for (var i = 0; i < callbacks.length; i++) {
                (0, _util.exceptionGuard)(callbacks[i]);
            }
        } else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === 'datastale') {
                for (var i = 0; i < queue.length; i++) {
                    if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) queue[i].status = TransactionStatus.NEEDS_ABORT;else queue[i].status = TransactionStatus.RUN;
                }
            } else {
                (0, _util.warn)('transaction at ' + pathToSend.toString() + ' failed: ' + status);
                for (var i = 0; i < queue.length; i++) {
                    queue[i].status = TransactionStatus.NEEDS_ABORT;
                    queue[i].abortReason = status;
                }
            }
            _this.rerunTransactions_(path);
        }
    }, latestHash);
};
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions.  This is the path at which events need to
 * be raised for.
 *
 * @param {!Path} changedPath The path in mergedData that changed.
 * @return {!Path} The rootmost path that was affected by rerunning transactions.
 * @private
 */
_Repo.Repo.prototype.rerunTransactions_ = function (changedPath) {
    var rootMostTransactionNode = this.getAncestorTransactionNode_(changedPath);
    var path = rootMostTransactionNode.path();
    var queue = this.buildTransactionQueue_(rootMostTransactionNode);
    this.rerunTransactionQueue_(queue, path);
    return path;
};
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted transactions and whatnot).
 *
 * @param {Array.<Transaction>} queue The queue of transactions to run.
 * @param {!Path} path The path the queue is for.
 * @private
 */
_Repo.Repo.prototype.rerunTransactionQueue_ = function (queue, path) {
    if (queue.length === 0) {
        return; // Nothing to do!
    }
    // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
    // the callback could trigger more transactions or sets.
    var callbacks = [];
    var events = [];
    // Ignore all of the sets we're going to re-run.
    var txnsToRerun = queue.filter(function (q) {
        return q.status === TransactionStatus.RUN;
    });
    var setsToIgnore = txnsToRerun.map(function (q) {
        return q.currentWriteId;
    });
    for (var i = 0; i < queue.length; i++) {
        var transaction = queue[i];
        var relativePath = _Path.Path.relativePath(path, transaction.path);
        var abortTransaction = false,
            abortReason = void 0;
        (0, _assert.assert)(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
        if (transaction.status === TransactionStatus.NEEDS_ABORT) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
        } else if (transaction.status === TransactionStatus.RUN) {
            if (transaction.retryCount >= _Repo.Repo.MAX_TRANSACTION_RETRIES_) {
                abortTransaction = true;
                abortReason = 'maxretry';
                events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
            } else {
                // This code reruns a transaction
                var currentNode = this.getLatestState_(transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                var newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    (0, _validation.validateFirebaseData)('transaction failed: Data returned ', newData, transaction.path);
                    var newDataNode = (0, _nodeFromJSON.nodeFromJSON)(newData);
                    var hasExplicitPriority = (typeof newData === 'undefined' ? 'undefined' : _typeof(newData)) === 'object' && newData != null && (0, _obj.contains)(newData, '.priority');
                    if (!hasExplicitPriority) {
                        // Keep the old priority if there wasn't a priority explicitly specified.
                        newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    }
                    var oldWriteId = transaction.currentWriteId;
                    var serverValues = this.generateServerValues();
                    var newNodeResolved = (0, _ServerValues.resolveDeferredValueSnapshot)(newDataNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = this.getNextWriteId_();
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat(this.serverSyncTree_.applyUserOverwrite(transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat(this.serverSyncTree_.ackUserWrite(oldWriteId, true));
                } else {
                    abortTransaction = true;
                    abortReason = 'nodata';
                    events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
                }
            }
        }
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = TransactionStatus.COMPLETED;
            // Removing a listener can trigger pruning which can muck with mergedData/visibleData (as it prunes data).
            // So defer the unwatcher until we're done.
            (function (unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === 'nodata') {
                    var ref = new _Reference.Reference(this, queue[i].path);
                    // We set this field immediately, so it's safe to cast to an actual snapshot
                    var lastInput /** @type {!Node} */ = queue[i].currentInputSnapshot;
                    var snapshot = new _DataSnapshot.DataSnapshot(lastInput, ref, _PriorityIndex.PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, false, snapshot));
                } else {
                    callbacks.push(queue[i].onComplete.bind(null, new Error(abortReason), false, null));
                }
            }
        }
    }
    // Clean up completed transactions.
    this.pruneCompletedTransactionsBelowNode_(this.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for (var i = 0; i < callbacks.length; i++) {
        (0, _util.exceptionGuard)(callbacks[i]);
    }
    // Try to send the transaction result to the server.
    this.sendReadyTransactions_();
};
/**
 * Returns the rootmost ancestor node of the specified path that has a pending transaction on it, or just returns
 * the node for the given path if there are no pending transactions on any ancestor.
 *
 * @param {!Path} path The location to start at.
 * @return {!Tree.<Array.<!Transaction>>} The rootmost node with a transaction.
 * @private
 */
_Repo.Repo.prototype.getAncestorTransactionNode_ = function (path) {
    var front;
    // Start at the root and walk deeper into the tree towards path until we find a node with pending transactions.
    var transactionNode = this.transactionQueueTree_;
    while ((front = path.getFront()) !== null && transactionNode.getValue() === null) {
        transactionNode = transactionNode.subTree(front);
        path = path.popFront();
    }
    return transactionNode;
};
/**
 * Builds the queue of all transactions at or below the specified transactionNode.
 *
 * @param {!Tree.<Array.<Transaction>>} transactionNode
 * @return {Array.<Transaction>} The generated queue.
 * @private
 */
_Repo.Repo.prototype.buildTransactionQueue_ = function (transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    var transactionQueue = [];
    this.aggregateTransactionQueuesForNode_(transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort(function (a, b) {
        return a.order - b.order;
    });
    return transactionQueue;
};
/**
 * @param {!Tree.<Array.<Transaction>>} node
 * @param {Array.<Transaction>} queue
 * @private
 */
_Repo.Repo.prototype.aggregateTransactionQueuesForNode_ = function (node, queue) {
    var _this = this;
    var nodeQueue = node.getValue();
    if (nodeQueue !== null) {
        for (var i = 0; i < nodeQueue.length; i++) {
            queue.push(nodeQueue[i]);
        }
    }
    node.forEachChild(function (child) {
        _this.aggregateTransactionQueuesForNode_(child, queue);
    });
};
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 *
 * @param {!Tree.<Array.<!Transaction>>} node
 * @private
 */
_Repo.Repo.prototype.pruneCompletedTransactionsBelowNode_ = function (node) {
    var _this = this;
    var queue = node.getValue();
    if (queue) {
        var to = 0;
        for (var from = 0; from < queue.length; from++) {
            if (queue[from].status !== TransactionStatus.COMPLETED) {
                queue[to] = queue[from];
                to++;
            }
        }
        queue.length = to;
        node.setValue(queue.length > 0 ? queue : null);
    }
    node.forEachChild(function (childNode) {
        _this.pruneCompletedTransactionsBelowNode_(childNode);
    });
};
/**
 * Aborts all transactions on ancestors or descendants of the specified path.  Called when doing a set() or update()
 * since we consider them incompatible with transactions.
 *
 * @param {!Path} path Path for which we want to abort related transactions.
 * @return {!Path}
 * @private
 */
_Repo.Repo.prototype.abortTransactions_ = function (path) {
    var _this = this;
    var affectedPath = this.getAncestorTransactionNode_(path).path();
    var transactionNode = this.transactionQueueTree_.subTree(path);
    transactionNode.forEachAncestor(function (node) {
        _this.abortTransactionsOnNode_(node);
    });
    this.abortTransactionsOnNode_(transactionNode);
    transactionNode.forEachDescendant(function (node) {
        _this.abortTransactionsOnNode_(node);
    });
    return affectedPath;
};
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param {!Tree.<Array.<Transaction>>} node Node to abort transactions for.
 * @private
 */
_Repo.Repo.prototype.abortTransactionsOnNode_ = function (node) {
    var queue = node.getValue();
    if (queue !== null) {
        // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
        // the callback could trigger more transactions or sets.
        var callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for abort, while the unsent ones
        // can be immediately aborted and removed.
        var events = [];
        var lastSent = -1;
        for (var i = 0; i < queue.length; i++) {
            if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) {
                // Already marked.  No action needed.
            } else if (queue[i].status === TransactionStatus.SENT) {
                (0, _assert.assert)(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = TransactionStatus.SENT_NEEDS_ABORT;
                queue[i].abortReason = 'set';
            } else {
                (0, _assert.assert)(queue[i].status === TransactionStatus.RUN, 'Unexpected transaction status in abort');
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat(this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId, true));
                if (queue[i].onComplete) {
                    var snapshot = null;
                    callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, snapshot));
                }
            }
        }
        if (lastSent === -1) {
            // We're not waiting for any sent transactions.  We can clear the queue.
            node.setValue(null);
        } else {
            // Remove the transactions we aborted.
            queue.length = lastSent + 1;
        }
        // Now fire the callbacks.
        this.eventQueue_.raiseEventsForChangedPath(node.path(), events);
        for (var i = 0; i < callbacks.length; i++) {
            (0, _util.exceptionGuard)(callbacks[i]);
        }
    }
};
//# sourceMappingURL=Repo_transaction.js.map


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SnapshotHolder = undefined;

var _ChildrenNode = __webpack_require__(16);

/**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 *
 * @constructor
 */
var SnapshotHolder = /** @class */function () {
    function SnapshotHolder() {
        this.rootNode_ = _ChildrenNode.ChildrenNode.EMPTY_NODE;
    }
    SnapshotHolder.prototype.getNode = function (path) {
        return this.rootNode_.getChild(path);
    };
    SnapshotHolder.prototype.updateSnapshot = function (path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    };
    return SnapshotHolder;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.SnapshotHolder = SnapshotHolder;
//# sourceMappingURL=SnapshotHolder.js.map


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SyncTree = undefined;

var _assert = __webpack_require__(2);

var _util = __webpack_require__(3);

var _AckUserWrite = __webpack_require__(388);

var _ChildrenNode = __webpack_require__(16);

var _obj = __webpack_require__(7);

var _ImmutableTree = __webpack_require__(107);

var _ListenComplete = __webpack_require__(389);

var _Merge = __webpack_require__(390);

var _Operation = __webpack_require__(36);

var _Overwrite = __webpack_require__(166);

var _Path = __webpack_require__(9);

var _SyncPoint = __webpack_require__(165);

var _WriteTree = __webpack_require__(387);

/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 * @constructor
 */
var SyncTree = /** @class */function () {
    /**
     * @param {!ListenProvider} listenProvider_ Used by SyncTree to start / stop listening
     *   to server data.
     */
    function SyncTree(listenProvider_) {
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         * @type {!ImmutableTree.<!SyncPoint>}
         * @private
         */
        this.syncPointTree_ = _ImmutableTree.ImmutableTree.Empty;
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         * @type {!WriteTree}
         * @private
         */
        this.pendingWriteTree_ = new _WriteTree.WriteTree();
        this.tagToQueryMap_ = {};
        this.queryToTagMap_ = {};
    }
    /**
     * Apply the data changes for a user-generated set() or transaction() call.
     *
     * @param {!Path} path
     * @param {!Node} newData
     * @param {number} writeId
     * @param {boolean=} visible
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyUserOverwrite = function (path, newData, writeId, visible) {
        // Record pending write.
        this.pendingWriteTree_.addOverwrite(path, newData, writeId, visible);
        if (!visible) {
            return [];
        } else {
            return this.applyOperationToSyncPoints_(new _Overwrite.Overwrite(_Operation.OperationSource.User, path, newData));
        }
    };
    /**
     * Apply the data from a user-generated update() call
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} writeId
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyUserMerge = function (path, changedChildren, writeId) {
        // Record pending merge.
        this.pendingWriteTree_.addMerge(path, changedChildren, writeId);
        var changeTree = _ImmutableTree.ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new _Merge.Merge(_Operation.OperationSource.User, path, changeTree));
    };
    /**
     * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
     *
     * @param {!number} writeId
     * @param {boolean=} revert True if the given write failed and needs to be reverted
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.ackUserWrite = function (writeId, revert) {
        if (revert === void 0) {
            revert = false;
        }
        var write = this.pendingWriteTree_.getWrite(writeId);
        var needToReevaluate = this.pendingWriteTree_.removeWrite(writeId);
        if (!needToReevaluate) {
            return [];
        } else {
            var affectedTree_1 = _ImmutableTree.ImmutableTree.Empty;
            if (write.snap != null) {
                // overwrite
                affectedTree_1 = affectedTree_1.set(_Path.Path.Empty, true);
            } else {
                (0, _obj.forEach)(write.children, function (pathString, node) {
                    affectedTree_1 = affectedTree_1.set(new _Path.Path(pathString), node);
                });
            }
            return this.applyOperationToSyncPoints_(new _AckUserWrite.AckUserWrite(write.path, affectedTree_1, revert));
        }
    };
    /**
     * Apply new server data for the specified path..
     *
     * @param {!Path} path
     * @param {!Node} newData
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyServerOverwrite = function (path, newData) {
        return this.applyOperationToSyncPoints_(new _Overwrite.Overwrite(_Operation.OperationSource.Server, path, newData));
    };
    /**
     * Apply new server data to be merged in at the specified path.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyServerMerge = function (path, changedChildren) {
        var changeTree = _ImmutableTree.ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new _Merge.Merge(_Operation.OperationSource.Server, path, changeTree));
    };
    /**
     * Apply a listen complete for a query
     *
     * @param {!Path} path
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyListenComplete = function (path) {
        return this.applyOperationToSyncPoints_(new _ListenComplete.ListenComplete(_Operation.OperationSource.Server, path));
    };
    /**
     * Apply new server data for the specified tagged query.
     *
     * @param {!Path} path
     * @param {!Node} snap
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedQueryOverwrite = function (path, snap, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey != null) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path,
                queryId = r.queryId;
            var relativePath = _Path.Path.relativePath(queryPath, path);
            var op = new _Overwrite.Overwrite(_Operation.OperationSource.forServerTaggedQuery(queryId), relativePath, snap);
            return this.applyTaggedOperation_(queryPath, op);
        } else {
            // Query must have been removed already
            return [];
        }
    };
    /**
     * Apply server data to be merged in for the specified tagged query.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedQueryMerge = function (path, changedChildren, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path,
                queryId = r.queryId;
            var relativePath = _Path.Path.relativePath(queryPath, path);
            var changeTree = _ImmutableTree.ImmutableTree.fromObject(changedChildren);
            var op = new _Merge.Merge(_Operation.OperationSource.forServerTaggedQuery(queryId), relativePath, changeTree);
            return this.applyTaggedOperation_(queryPath, op);
        } else {
            // We've already removed the query. No big deal, ignore the update
            return [];
        }
    };
    /**
     * Apply a listen complete for a tagged query
     *
     * @param {!Path} path
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedListenComplete = function (path, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path,
                queryId = r.queryId;
            var relativePath = _Path.Path.relativePath(queryPath, path);
            var op = new _ListenComplete.ListenComplete(_Operation.OperationSource.forServerTaggedQuery(queryId), relativePath);
            return this.applyTaggedOperation_(queryPath, op);
        } else {
            // We've already removed the query. No big deal, ignore the update
            return [];
        }
    };
    /**
     * Add an event callback for the specified query.
     *
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.addEventRegistration = function (query, eventRegistration) {
        var path = query.path;
        var serverCache = null;
        var foundAncestorDefaultView = false;
        // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
        // Consider optimizing this once there's a better understanding of what actual behavior will be.
        this.syncPointTree_.foreachOnPath(path, function (pathToSyncPoint, sp) {
            var relativePath = _Path.Path.relativePath(pathToSyncPoint, path);
            serverCache = serverCache || sp.getCompleteServerCache(relativePath);
            foundAncestorDefaultView = foundAncestorDefaultView || sp.hasCompleteView();
        });
        var syncPoint = this.syncPointTree_.get(path);
        if (!syncPoint) {
            syncPoint = new _SyncPoint.SyncPoint();
            this.syncPointTree_ = this.syncPointTree_.set(path, syncPoint);
        } else {
            foundAncestorDefaultView = foundAncestorDefaultView || syncPoint.hasCompleteView();
            serverCache = serverCache || syncPoint.getCompleteServerCache(_Path.Path.Empty);
        }
        var serverCacheComplete;
        if (serverCache != null) {
            serverCacheComplete = true;
        } else {
            serverCacheComplete = false;
            serverCache = _ChildrenNode.ChildrenNode.EMPTY_NODE;
            var subtree = this.syncPointTree_.subtree(path);
            subtree.foreachChild(function (childName, childSyncPoint) {
                var completeCache = childSyncPoint.getCompleteServerCache(_Path.Path.Empty);
                if (completeCache) {
                    serverCache = serverCache.updateImmediateChild(childName, completeCache);
                }
            });
        }
        var viewAlreadyExists = syncPoint.viewExistsForQuery(query);
        if (!viewAlreadyExists && !query.getQueryParams().loadsAllData()) {
            // We need to track a tag for this query
            var queryKey = SyncTree.makeQueryKey_(query);
            (0, _assert.assert)(!(queryKey in this.queryToTagMap_), 'View does not exist, but we have a tag');
            var tag = SyncTree.getNextQueryTag_();
            this.queryToTagMap_[queryKey] = tag;
            // Coerce to string to avoid sparse arrays.
            this.tagToQueryMap_['_' + tag] = queryKey;
        }
        var writesCache = this.pendingWriteTree_.childWrites(path);
        var events = syncPoint.addEventRegistration(query, eventRegistration, writesCache, serverCache, serverCacheComplete);
        if (!viewAlreadyExists && !foundAncestorDefaultView) {
            var view /** @type !View */ = syncPoint.viewForQuery(query);
            events = events.concat(this.setupListener_(query, view));
        }
        return events;
    };
    /**
     * Remove event callback(s).
     *
     * If query is the default query, we'll check all queries for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
     *
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration If null, all callbacks are removed.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
     */
    SyncTree.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
        var _this = this;
        // Find the syncPoint first. Then deal with whether or not it has matching listeners
        var path = query.path;
        var maybeSyncPoint = this.syncPointTree_.get(path);
        var cancelEvents = [];
        // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
        // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
        // not loadsAllData().
        if (maybeSyncPoint && (query.queryIdentifier() === 'default' || maybeSyncPoint.viewExistsForQuery(query))) {
            /**
             * @type {{removed: !Array.<!Query>, events: !Array.<!Event>}}
             */
            var removedAndEvents = maybeSyncPoint.removeEventRegistration(query, eventRegistration, cancelError);
            if (maybeSyncPoint.isEmpty()) {
                this.syncPointTree_ = this.syncPointTree_.remove(path);
            }
            var removed = removedAndEvents.removed;
            cancelEvents = removedAndEvents.events;
            // We may have just removed one of many listeners and can short-circuit this whole process
            // We may also not have removed a default listener, in which case all of the descendant listeners should already be
            // properly set up.
            //
            // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
            // queryId === 'default'
            var removingDefault = -1 !== removed.findIndex(function (query) {
                return query.getQueryParams().loadsAllData();
            });
            var covered = this.syncPointTree_.findOnPath(path, function (relativePath, parentSyncPoint) {
                return parentSyncPoint.hasCompleteView();
            });
            if (removingDefault && !covered) {
                var subtree = this.syncPointTree_.subtree(path);
                // There are potentially child listeners. Determine what if any listens we need to send before executing the
                // removal
                if (!subtree.isEmpty()) {
                    // We need to fold over our subtree and collect the listeners to send
                    var newViews = this.collectDistinctViewsForSubTree_(subtree);
                    // Ok, we've collected all the listens we need. Set them up.
                    for (var i = 0; i < newViews.length; ++i) {
                        var view = newViews[i],
                            newQuery = view.getQuery();
                        var listener = this.createListenerForView_(view);
                        this.listenProvider_.startListening(SyncTree.queryForListening_(newQuery), this.tagForQuery_(newQuery), listener.hashFn, listener.onComplete);
                    }
                } else {
                    // There's nothing below us, so nothing we need to start listening on
                }
            }
            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
            // Also, note that if we have a cancelError, it's already been removed at the provider level.
            if (!covered && removed.length > 0 && !cancelError) {
                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
                // default. Otherwise, we need to iterate through and cancel each individual query
                if (removingDefault) {
                    // We don't tag default listeners
                    var defaultTag = null;
                    this.listenProvider_.stopListening(SyncTree.queryForListening_(query), defaultTag);
                } else {
                    removed.forEach(function (queryToRemove) {
                        var tagToRemove = _this.queryToTagMap_[SyncTree.makeQueryKey_(queryToRemove)];
                        _this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToRemove), tagToRemove);
                    });
                }
            }
            // Now, clear all of the tags we're tracking for the removed listens
            this.removeTags_(removed);
        } else {
            // No-op, this listener must've been already removed
        }
        return cancelEvents;
    };
    /**
     * Returns a complete cache, if we have one, of the data at a particular path. The location must have a listener above
     * it, but as this is only used by transaction code, that should always be the case anyways.
     *
     * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
     * @param {!Path} path The path to the data we want
     * @param {Array.<number>=} writeIdsToExclude A specific set to be excluded
     * @return {?Node}
     */
    SyncTree.prototype.calcCompleteEventCache = function (path, writeIdsToExclude) {
        var includeHiddenSets = true;
        var writeTree = this.pendingWriteTree_;
        var serverCache = this.syncPointTree_.findOnPath(path, function (pathSoFar, syncPoint) {
            var relativePath = _Path.Path.relativePath(pathSoFar, path);
            var serverCache = syncPoint.getCompleteServerCache(relativePath);
            if (serverCache) {
                return serverCache;
            }
        });
        return writeTree.calcCompleteEventCache(path, serverCache, writeIdsToExclude, includeHiddenSets);
    };
    /**
     * This collapses multiple unfiltered views into a single view, since we only need a single
     * listener for them.
     *
     * @param {!ImmutableTree.<!SyncPoint>} subtree
     * @return {!Array.<!View>}
     * @private
     */
    SyncTree.prototype.collectDistinctViewsForSubTree_ = function (subtree) {
        return subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
            if (maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
                var completeView = maybeChildSyncPoint.getCompleteView();
                return [completeView];
            } else {
                // No complete view here, flatten any deeper listens into an array
                var views_1 = [];
                if (maybeChildSyncPoint) {
                    views_1 = maybeChildSyncPoint.getQueryViews();
                }
                (0, _obj.forEach)(childMap, function (key, childViews) {
                    views_1 = views_1.concat(childViews);
                });
                return views_1;
            }
        });
    };
    /**
     * @param {!Array.<!Query>} queries
     * @private
     */
    SyncTree.prototype.removeTags_ = function (queries) {
        for (var j = 0; j < queries.length; ++j) {
            var removedQuery = queries[j];
            if (!removedQuery.getQueryParams().loadsAllData()) {
                // We should have a tag for this
                var removedQueryKey = SyncTree.makeQueryKey_(removedQuery);
                var removedQueryTag = this.queryToTagMap_[removedQueryKey];
                delete this.queryToTagMap_[removedQueryKey];
                delete this.tagToQueryMap_['_' + removedQueryTag];
            }
        }
    };
    /**
     * Normalizes a query to a query we send the server for listening
     * @param {!Query} query
     * @return {!Query} The normalized query
     * @private
     */
    SyncTree.queryForListening_ = function (query) {
        if (query.getQueryParams().loadsAllData() && !query.getQueryParams().isDefault()) {
            // We treat queries that load all data as default queries
            // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
            // from Query
            return (/** @type {!Query} */query.getRef()
            );
        } else {
            return query;
        }
    };
    /**
     * For a given new listen, manage the de-duplication of outstanding subscriptions.
     *
     * @param {!Query} query
     * @param {!View} view
     * @return {!Array.<!Event>} This method can return events to support synchronous data sources
     * @private
     */
    SyncTree.prototype.setupListener_ = function (query, view) {
        var path = query.path;
        var tag = this.tagForQuery_(query);
        var listener = this.createListenerForView_(view);
        var events = this.listenProvider_.startListening(SyncTree.queryForListening_(query), tag, listener.hashFn, listener.onComplete);
        var subtree = this.syncPointTree_.subtree(path);
        // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
        // may need to shadow other listens as well.
        if (tag) {
            (0, _assert.assert)(!subtree.value.hasCompleteView(), "If we're adding a query, it shouldn't be shadowed");
        } else {
            // Shadow everything at or below this location, this is a default listener.
            var queriesToStop = subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
                if (!relativePath.isEmpty() && maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
                    return [maybeChildSyncPoint.getCompleteView().getQuery()];
                } else {
                    // No default listener here, flatten any deeper queries into an array
                    var queries_1 = [];
                    if (maybeChildSyncPoint) {
                        queries_1 = queries_1.concat(maybeChildSyncPoint.getQueryViews().map(function (view) {
                            return view.getQuery();
                        }));
                    }
                    (0, _obj.forEach)(childMap, function (key, childQueries) {
                        queries_1 = queries_1.concat(childQueries);
                    });
                    return queries_1;
                }
            });
            for (var i = 0; i < queriesToStop.length; ++i) {
                var queryToStop = queriesToStop[i];
                this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToStop), this.tagForQuery_(queryToStop));
            }
        }
        return events;
    };
    /**
     *
     * @param {!View} view
     * @return {{hashFn: function(), onComplete: function(!string, *)}}
     * @private
     */
    SyncTree.prototype.createListenerForView_ = function (view) {
        var _this = this;
        var query = view.getQuery();
        var tag = this.tagForQuery_(query);
        return {
            hashFn: function hashFn() {
                var cache = view.getServerCache() || _ChildrenNode.ChildrenNode.EMPTY_NODE;
                return cache.hash();
            },
            onComplete: function onComplete(status) {
                if (status === 'ok') {
                    if (tag) {
                        return _this.applyTaggedListenComplete(query.path, tag);
                    } else {
                        return _this.applyListenComplete(query.path);
                    }
                } else {
                    // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                    // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                    var error = (0, _util.errorForServerCode)(status, query);
                    return _this.removeEventRegistration(query,
                    /*eventRegistration*/null, error);
                }
            }
        };
    };
    /**
     * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
     * @private
     * @param {!Query} query
     * @return {string}
     */
    SyncTree.makeQueryKey_ = function (query) {
        return query.path.toString() + '$' + query.queryIdentifier();
    };
    /**
     * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
     * @private
     * @param {!string} queryKey
     * @return {{queryId: !string, path: !Path}}
     */
    SyncTree.parseQueryKey_ = function (queryKey) {
        var splitIndex = queryKey.indexOf('$');
        (0, _assert.assert)(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
        return {
            queryId: queryKey.substr(splitIndex + 1),
            path: new _Path.Path(queryKey.substr(0, splitIndex))
        };
    };
    /**
     * Return the query associated with the given tag, if we have one
     * @param {!number} tag
     * @return {?string}
     * @private
     */
    SyncTree.prototype.queryKeyForTag_ = function (tag) {
        return this.tagToQueryMap_['_' + tag];
    };
    /**
     * Return the tag associated with the given query.
     * @param {!Query} query
     * @return {?number}
     * @private
     */
    SyncTree.prototype.tagForQuery_ = function (query) {
        var queryKey = SyncTree.makeQueryKey_(query);
        return (0, _obj.safeGet)(this.queryToTagMap_, queryKey);
    };
    /**
     * Static accessor for query tags.
     * @return {number}
     * @private
     */
    SyncTree.getNextQueryTag_ = function () {
        return SyncTree.nextQueryTag_++;
    };
    /**
     * A helper method to apply tagged operations
     *
     * @param {!Path} queryPath
     * @param {!Operation} operation
     * @return {!Array.<!Event>}
     * @private
     */
    SyncTree.prototype.applyTaggedOperation_ = function (queryPath, operation) {
        var syncPoint = this.syncPointTree_.get(queryPath);
        (0, _assert.assert)(syncPoint, "Missing sync point for query tag that we're tracking");
        var writesCache = this.pendingWriteTree_.childWrites(queryPath);
        return syncPoint.applyOperation(operation, writesCache,
        /*serverCache=*/null);
    };
    /**
     * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
     *
     * NOTES:
     * - Descendant SyncPoints will be visited first (since we raise events depth-first).
        * - We call applyOperation() on each SyncPoint passing three things:
     *   1. A version of the Operation that has been made relative to the SyncPoint location.
     *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
     *   3. A snapshot Node with cached server data, if we have it.
        * - We concatenate all of the events returned by each SyncPoint and return the result.
     *
     * @param {!Operation} operation
     * @return {!Array.<!Event>}
     * @private
     */
    SyncTree.prototype.applyOperationToSyncPoints_ = function (operation) {
        return this.applyOperationHelper_(operation, this.syncPointTree_,
        /*serverCache=*/null, this.pendingWriteTree_.childWrites(_Path.Path.Empty));
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     *
     * @private
     * @param {!Operation} operation
     * @param {ImmutableTree.<!SyncPoint>} syncPointTree
     * @param {?Node} serverCache
     * @param {!WriteTreeRef} writesCache
     * @return {!Array.<!Event>}
     */
    SyncTree.prototype.applyOperationHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
        if (operation.path.isEmpty()) {
            return this.applyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
        } else {
            var syncPoint = syncPointTree.get(_Path.Path.Empty);
            // If we don't have cached server data, see if we can get it from this SyncPoint.
            if (serverCache == null && syncPoint != null) {
                serverCache = syncPoint.getCompleteServerCache(_Path.Path.Empty);
            }
            var events = [];
            var childName = operation.path.getFront();
            var childOperation = operation.operationForChild(childName);
            var childTree = syncPointTree.children.get(childName);
            if (childTree && childOperation) {
                var childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
                var childWritesCache = writesCache.child(childName);
                events = events.concat(this.applyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
            }
            if (syncPoint) {
                events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
            }
            return events;
        }
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     *
     * @private
     * @param {!Operation} operation
     * @param {ImmutableTree.<!SyncPoint>} syncPointTree
     * @param {?Node} serverCache
     * @param {!WriteTreeRef} writesCache
     * @return {!Array.<!Event>}
     */
    SyncTree.prototype.applyOperationDescendantsHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
        var _this = this;
        var syncPoint = syncPointTree.get(_Path.Path.Empty);
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) {
            serverCache = syncPoint.getCompleteServerCache(_Path.Path.Empty);
        }
        var events = [];
        syncPointTree.children.inorderTraversal(function (childName, childTree) {
            var childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
            var childWritesCache = writesCache.child(childName);
            var childOperation = operation.operationForChild(childName);
            if (childOperation) {
                events = events.concat(_this.applyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
            }
        });
        if (syncPoint) {
            events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
        }
        return events;
    };
    /**
     * Static tracker for next query tag.
     * @type {number}
     * @private
     */
    SyncTree.nextQueryTag_ = 1;
    return SyncTree;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.SyncTree = SyncTree;
//# sourceMappingURL=SyncTree.js.map


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WriteTreeRef = exports.WriteTree = undefined;

var _obj = __webpack_require__(7);

var _assert = __webpack_require__(2);

var _Path = __webpack_require__(9);

var _CompoundWrite = __webpack_require__(382);

var _PriorityIndex = __webpack_require__(15);

var _ChildrenNode = __webpack_require__(16);

/**
 * WriteTree tracks all pending user-initiated writes and has methods to calculate the result of merging them
 * with underlying server data (to create "event cache" data).  Pending writes are added with addOverwrite()
 * and addMerge(), and removed with removeWrite().
 *
 * @constructor
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var WriteTree = /** @class */function () {
    function WriteTree() {
        /**
         * A tree tracking the result of applying all visible writes.  This does not include transactions with
         * applyLocally=false or writes that are completely shadowed by other writes.
         *
         * @type {!CompoundWrite}
         * @private
         */
        this.visibleWrites_ = _CompoundWrite.CompoundWrite.Empty;
        /**
         * A list of all pending writes, regardless of visibility and shadowed-ness.  Used to calculate arbitrary
         * sets of the changed data, such as hidden writes (from transactions) or changes with certain writes excluded (also
         * used by transactions).
         *
         * @type {!Array.<!WriteRecord>}
         * @private
         */
        this.allWrites_ = [];
        this.lastWriteId_ = -1;
    }
    /**
     * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
     *
     * @param {!Path} path
     * @return {!WriteTreeRef}
     */
    WriteTree.prototype.childWrites = function (path) {
        return new WriteTreeRef(path, this);
    };
    /**
     * Record a new overwrite from user code.
     *
     * @param {!Path} path
     * @param {!Node} snap
     * @param {!number} writeId
     * @param {boolean=} visible This is set to false by some transactions. It should be excluded from event caches
     */
    WriteTree.prototype.addOverwrite = function (path, snap, writeId, visible) {
        (0, _assert.assert)(writeId > this.lastWriteId_, 'Stacking an older write on top of newer ones');
        if (visible === undefined) {
            visible = true;
        }
        this.allWrites_.push({
            path: path,
            snap: snap,
            writeId: writeId,
            visible: visible
        });
        if (visible) {
            this.visibleWrites_ = this.visibleWrites_.addWrite(path, snap);
        }
        this.lastWriteId_ = writeId;
    };
    /**
     * Record a new merge from user code.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} writeId
     */
    WriteTree.prototype.addMerge = function (path, changedChildren, writeId) {
        (0, _assert.assert)(writeId > this.lastWriteId_, 'Stacking an older merge on top of newer ones');
        this.allWrites_.push({
            path: path,
            children: changedChildren,
            writeId: writeId,
            visible: true
        });
        this.visibleWrites_ = this.visibleWrites_.addWrites(path, changedChildren);
        this.lastWriteId_ = writeId;
    };
    /**
     * @param {!number} writeId
     * @return {?WriteRecord}
     */
    WriteTree.prototype.getWrite = function (writeId) {
        for (var i = 0; i < this.allWrites_.length; i++) {
            var record = this.allWrites_[i];
            if (record.writeId === writeId) {
                return record;
            }
        }
        return null;
    };
    /**
     * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
     * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
     *
     * @param {!number} writeId
     * @return {boolean} true if the write may have been visible (meaning we'll need to reevaluate / raise
     * events as a result).
     */
    WriteTree.prototype.removeWrite = function (writeId) {
        // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
        // out of order.
        //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
        //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
        var _this = this;
        var idx = this.allWrites_.findIndex(function (s) {
            return s.writeId === writeId;
        });
        (0, _assert.assert)(idx >= 0, 'removeWrite called with nonexistent writeId.');
        var writeToRemove = this.allWrites_[idx];
        this.allWrites_.splice(idx, 1);
        var removedWriteWasVisible = writeToRemove.visible;
        var removedWriteOverlapsWithOtherWrites = false;
        var i = this.allWrites_.length - 1;
        while (removedWriteWasVisible && i >= 0) {
            var currentWrite = this.allWrites_[i];
            if (currentWrite.visible) {
                if (i >= idx && this.recordContainsPath_(currentWrite, writeToRemove.path)) {
                    // The removed write was completely shadowed by a subsequent write.
                    removedWriteWasVisible = false;
                } else if (writeToRemove.path.contains(currentWrite.path)) {
                    // Either we're covering some writes or they're covering part of us (depending on which came first).
                    removedWriteOverlapsWithOtherWrites = true;
                }
            }
            i--;
        }
        if (!removedWriteWasVisible) {
            return false;
        } else if (removedWriteOverlapsWithOtherWrites) {
            // There's some shadowing going on. Just rebuild the visible writes from scratch.
            this.resetTree_();
            return true;
        } else {
            // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
            if (writeToRemove.snap) {
                this.visibleWrites_ = this.visibleWrites_.removeWrite(writeToRemove.path);
            } else {
                var children = writeToRemove.children;
                (0, _obj.forEach)(children, function (childName) {
                    _this.visibleWrites_ = _this.visibleWrites_.removeWrite(writeToRemove.path.child(childName));
                });
            }
            return true;
        }
    };
    /**
     * Return a complete snapshot for the given path if there's visible write data at that path, else null.
     * No server data is considered.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTree.prototype.getCompleteWriteData = function (path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
     * writes), attempt to calculate a complete snapshot for the given path
     *
     * @param {!Path} treePath
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude An optional set to be excluded
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */
    WriteTree.prototype.calcCompleteEventCache = function (treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        if (!writeIdsToExclude && !includeHiddenWrites) {
            var shadowingNode = this.visibleWrites_.getCompleteNode(treePath);
            if (shadowingNode != null) {
                return shadowingNode;
            } else {
                var subMerge = this.visibleWrites_.childCompoundWrite(treePath);
                if (subMerge.isEmpty()) {
                    return completeServerCache;
                } else if (completeServerCache == null && !subMerge.hasCompleteWrite(_Path.Path.Empty)) {
                    // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
                    return null;
                } else {
                    var layeredCache = completeServerCache || _ChildrenNode.ChildrenNode.EMPTY_NODE;
                    return subMerge.apply(layeredCache);
                }
            }
        } else {
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            if (!includeHiddenWrites && merge.isEmpty()) {
                return completeServerCache;
            } else {
                // If the server cache is null, and we don't have a complete cache, we need to return null
                if (!includeHiddenWrites && completeServerCache == null && !merge.hasCompleteWrite(_Path.Path.Empty)) {
                    return null;
                } else {
                    var filter = function filter(write) {
                        return (write.visible || includeHiddenWrites) && (!writeIdsToExclude || !~writeIdsToExclude.indexOf(write.writeId)) && (write.path.contains(treePath) || treePath.contains(write.path));
                    };
                    var mergeAtPath = WriteTree.layerTree_(this.allWrites_, filter, treePath);
                    var layeredCache = completeServerCache || _ChildrenNode.ChildrenNode.EMPTY_NODE;
                    return mergeAtPath.apply(layeredCache);
                }
            }
        }
    };
    /**
     * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
     * Used when creating new views, to pre-fill their complete event children snapshot.
     *
     * @param {!Path} treePath
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */
    WriteTree.prototype.calcCompleteEventChildren = function (treePath, completeServerChildren) {
        var completeChildren = _ChildrenNode.ChildrenNode.EMPTY_NODE;
        var topLevelSet = this.visibleWrites_.getCompleteNode(treePath);
        if (topLevelSet) {
            if (!topLevelSet.isLeafNode()) {
                // we're shadowing everything. Return the children.
                topLevelSet.forEachChild(_PriorityIndex.PRIORITY_INDEX, function (childName, childSnap) {
                    completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
                });
            }
            return completeChildren;
        } else if (completeServerChildren) {
            // Layer any children we have on top of this
            // We know we don't have a top-level set, so just enumerate existing children
            var merge_1 = this.visibleWrites_.childCompoundWrite(treePath);
            completeServerChildren.forEachChild(_PriorityIndex.PRIORITY_INDEX, function (childName, childNode) {
                var node = merge_1.childCompoundWrite(new _Path.Path(childName)).apply(childNode);
                completeChildren = completeChildren.updateImmediateChild(childName, node);
            });
            // Add any complete children we have from the set
            merge_1.getCompleteChildren().forEach(function (namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        } else {
            // We don't have anything to layer on top of. Layer on any children we have
            // Note that we can return an empty snap if we have a defined delete
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            merge.getCompleteChildren().forEach(function (namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        }
    };
    /**
     * Given that the underlying server data has updated, determine what, if anything, needs to be
     * applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events
     *
     * Either existingEventSnap or existingServerSnap must exist
     *
     * @param {!Path} treePath
     * @param {!Path} childPath
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */
    WriteTree.prototype.calcEventCacheAfterServerOverwrite = function (treePath, childPath, existingEventSnap, existingServerSnap) {
        (0, _assert.assert)(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
        var path = treePath.child(childPath);
        if (this.visibleWrites_.hasCompleteWrite(path)) {
            // At this point we can probably guarantee that we're in case 2, meaning no events
            // May need to check visibility while doing the findRootMostValueAndPath call
            return null;
        } else {
            // No complete shadowing. We're either partially shadowing or not shadowing at all.
            var childMerge = this.visibleWrites_.childCompoundWrite(path);
            if (childMerge.isEmpty()) {
                // We're not shadowing at all. Case 1
                return existingServerSnap.getChild(childPath);
            } else {
                // This could be more efficient if the serverNode + updates doesn't change the eventSnap
                // However this is tricky to find out, since user updates don't necessary change the server
                // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
                // adds nodes, but doesn't change any existing writes. It is therefore not enough to
                // only check if the updates change the serverNode.
                // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
                return childMerge.apply(existingServerSnap.getChild(childPath));
            }
        }
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!Path} treePath
     * @param {!string} childKey
     * @param {!CacheNode} existingServerSnap
     * @return {?Node}
     */
    WriteTree.prototype.calcCompleteChild = function (treePath, childKey, existingServerSnap) {
        var path = treePath.child(childKey);
        var shadowingNode = this.visibleWrites_.getCompleteNode(path);
        if (shadowingNode != null) {
            return shadowingNode;
        } else {
            if (existingServerSnap.isCompleteForChild(childKey)) {
                var childMerge = this.visibleWrites_.childCompoundWrite(path);
                return childMerge.apply(existingServerSnap.getNode().getImmediateChild(childKey));
            } else {
                return null;
            }
        }
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTree.prototype.shadowingWrite = function (path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window.
     *
     * @param {!Path} treePath
     * @param {?Node} completeServerData
     * @param {!NamedNode} startPost
     * @param {!number} count
     * @param {boolean} reverse
     * @param {!Index} index
     * @return {!Array.<!NamedNode>}
     */
    WriteTree.prototype.calcIndexedSlice = function (treePath, completeServerData, startPost, count, reverse, index) {
        var toIterate;
        var merge = this.visibleWrites_.childCompoundWrite(treePath);
        var shadowingNode = merge.getCompleteNode(_Path.Path.Empty);
        if (shadowingNode != null) {
            toIterate = shadowingNode;
        } else if (completeServerData != null) {
            toIterate = merge.apply(completeServerData);
        } else {
            // no children to iterate on
            return [];
        }
        toIterate = toIterate.withIndex(index);
        if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
            var nodes = [];
            var cmp = index.getCompare();
            var iter = reverse ? toIterate.getReverseIteratorFrom(startPost, index) : toIterate.getIteratorFrom(startPost, index);
            var next = iter.getNext();
            while (next && nodes.length < count) {
                if (cmp(next, startPost) !== 0) {
                    nodes.push(next);
                }
                next = iter.getNext();
            }
            return nodes;
        } else {
            return [];
        }
    };
    /**
     * @param {!WriteRecord} writeRecord
     * @param {!Path} path
     * @return {boolean}
     * @private
     */
    WriteTree.prototype.recordContainsPath_ = function (writeRecord, path) {
        if (writeRecord.snap) {
            return writeRecord.path.contains(path);
        } else {
            // findKey can return undefined, so use !! to coerce to boolean
            return !!(0, _obj.findKey)(writeRecord.children, function (childSnap, childName) {
                return writeRecord.path.child(childName).contains(path);
            });
        }
    };
    /**
     * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
     * @private
     */
    WriteTree.prototype.resetTree_ = function () {
        this.visibleWrites_ = WriteTree.layerTree_(this.allWrites_, WriteTree.DefaultFilter_, _Path.Path.Empty);
        if (this.allWrites_.length > 0) {
            this.lastWriteId_ = this.allWrites_[this.allWrites_.length - 1].writeId;
        } else {
            this.lastWriteId_ = -1;
        }
    };
    /**
     * The default filter used when constructing the tree. Keep everything that's visible.
     *
     * @param {!WriteRecord} write
     * @return {boolean}
     * @private
     */
    WriteTree.DefaultFilter_ = function (write) {
        return write.visible;
    };
    /**
     * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
     * event data at that path.
     *
     * @param {!Array.<!WriteRecord>} writes
     * @param {!function(!WriteRecord):boolean} filter
     * @param {!Path} treeRoot
     * @return {!CompoundWrite}
     * @private
     */
    WriteTree.layerTree_ = function (writes, filter, treeRoot) {
        var compoundWrite = _CompoundWrite.CompoundWrite.Empty;
        for (var i = 0; i < writes.length; ++i) {
            var write = writes[i];
            // Theory, a later set will either:
            // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
            // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
            if (filter(write)) {
                var writePath = write.path;
                var relativePath = void 0;
                if (write.snap) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = _Path.Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrite(relativePath, write.snap);
                    } else if (writePath.contains(treeRoot)) {
                        relativePath = _Path.Path.relativePath(writePath, treeRoot);
                        compoundWrite = compoundWrite.addWrite(_Path.Path.Empty, write.snap.getChild(relativePath));
                    } else {
                        // There is no overlap between root path and write path, ignore write
                    }
                } else if (write.children) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = _Path.Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrites(relativePath, write.children);
                    } else if (writePath.contains(treeRoot)) {
                        relativePath = _Path.Path.relativePath(writePath, treeRoot);
                        if (relativePath.isEmpty()) {
                            compoundWrite = compoundWrite.addWrites(_Path.Path.Empty, write.children);
                        } else {
                            var child = (0, _obj.safeGet)(write.children, relativePath.getFront());
                            if (child) {
                                // There exists a child in this node that matches the root path
                                var deepNode = child.getChild(relativePath.popFront());
                                compoundWrite = compoundWrite.addWrite(_Path.Path.Empty, deepNode);
                            }
                        }
                    } else {
                        // There is no overlap between root path and write path, ignore write
                    }
                } else {
                    throw (0, _assert.assertionError)('WriteRecord should have .snap or .children');
                }
            }
        }
        return compoundWrite;
    };
    return WriteTree;
}();
exports.WriteTree = WriteTree;
/**
 * A WriteTreeRef wraps a WriteTree and a path, for convenient access to a particular subtree.  All of the methods
 * just proxy to the underlying WriteTree.
 *
 * @constructor
 */

var WriteTreeRef = /** @class */function () {
    /**
     * @param {!Path} path
     * @param {!WriteTree} writeTree
     */
    function WriteTreeRef(path, writeTree) {
        this.treePath_ = path;
        this.writeTree_ = writeTree;
    }
    /**
     * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
     * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
     * can lead to a more expensive calculation.
     *
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude Optional writes to exclude.
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcCompleteEventCache = function (completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        return this.writeTree_.calcCompleteEventCache(this.treePath_, completeServerCache, writeIdsToExclude, includeHiddenWrites);
    };
    /**
     * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
     * mix of the given server data and write data.
     *
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */
    WriteTreeRef.prototype.calcCompleteEventChildren = function (completeServerChildren) {
        return this.writeTree_.calcCompleteEventChildren(this.treePath_, completeServerChildren);
    };
    /**
     * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
     * if anything, needs to be applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events should be raised
     *
     * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
     *
     * @param {!Path} path
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcEventCacheAfterServerOverwrite = function (path, existingEventSnap, existingServerSnap) {
        return this.writeTree_.calcEventCacheAfterServerOverwrite(this.treePath_, path, existingEventSnap, existingServerSnap);
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTreeRef.prototype.shadowingWrite = function (path) {
        return this.writeTree_.shadowingWrite(this.treePath_.child(path));
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window
     *
     * @param {?Node} completeServerData
     * @param {!NamedNode} startPost
     * @param {!number} count
     * @param {boolean} reverse
     * @param {!Index} index
     * @return {!Array.<!NamedNode>}
     */
    WriteTreeRef.prototype.calcIndexedSlice = function (completeServerData, startPost, count, reverse, index) {
        return this.writeTree_.calcIndexedSlice(this.treePath_, completeServerData, startPost, count, reverse, index);
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!string} childKey
     * @param {!CacheNode} existingServerCache
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcCompleteChild = function (childKey, existingServerCache) {
        return this.writeTree_.calcCompleteChild(this.treePath_, childKey, existingServerCache);
    };
    /**
     * Return a WriteTreeRef for a child.
     *
     * @param {string} childName
     * @return {!WriteTreeRef}
     */
    WriteTreeRef.prototype.child = function (childName) {
        return new WriteTreeRef(this.treePath_.child(childName), this.writeTree_);
    };
    return WriteTreeRef;
}();
exports.WriteTreeRef = WriteTreeRef;
//# sourceMappingURL=WriteTree.js.map


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AckUserWrite = undefined;

var _assert = __webpack_require__(2);

var _Path = __webpack_require__(9);

var _Operation = __webpack_require__(36);

var AckUserWrite = /** @class */function () {
    /**
     *
     * @param {!Path} path
     * @param {!ImmutableTree<!boolean>} affectedTree A tree containing true for each affected path. Affected paths can't overlap.
     * @param {!boolean} revert
     */
    function AckUserWrite(
    /**@inheritDoc */path,
    /**@inheritDoc */affectedTree,
    /**@inheritDoc */revert) {
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */
        this.type = _Operation.OperationType.ACK_USER_WRITE;
        /** @inheritDoc */
        this.source = _Operation.OperationSource.User;
    }
    /**
     * @inheritDoc
     */
    AckUserWrite.prototype.operationForChild = function (childName) {
        if (!this.path.isEmpty()) {
            (0, _assert.assert)(this.path.getFront() === childName, 'operationForChild called for unrelated child.');
            return new AckUserWrite(this.path.popFront(), this.affectedTree, this.revert);
        } else if (this.affectedTree.value != null) {
            (0, _assert.assert)(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
            // All child locations are affected as well; just return same operation.
            return this;
        } else {
            var childTree = this.affectedTree.subtree(new _Path.Path(childName));
            return new AckUserWrite(_Path.Path.Empty, childTree, this.revert);
        }
    };
    return AckUserWrite;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.AckUserWrite = AckUserWrite;
//# sourceMappingURL=AckUserWrite.js.map


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ListenComplete = undefined;

var _Path = __webpack_require__(9);

var _Operation = __webpack_require__(36);

/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @constructor
 * @implements {Operation}
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ListenComplete = /** @class */function () {
    function ListenComplete(source, path) {
        this.source = source;
        this.path = path;
        /** @inheritDoc */
        this.type = _Operation.OperationType.LISTEN_COMPLETE;
    }
    ListenComplete.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            return new ListenComplete(this.source, _Path.Path.Empty);
        } else {
            return new ListenComplete(this.source, this.path.popFront());
        }
    };
    return ListenComplete;
}();
exports.ListenComplete = ListenComplete;
//# sourceMappingURL=ListenComplete.js.map


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Merge = undefined;

var _Operation = __webpack_require__(36);

var _Overwrite = __webpack_require__(166);

var _Path = __webpack_require__(9);

var _assert = __webpack_require__(2);

/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!ImmutableTree.<!Node>} children
 * @constructor
 * @implements {Operation}
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Merge = /** @class */function () {
    function Merge(
    /**@inheritDoc */source,
    /**@inheritDoc */path,
    /**@inheritDoc */children) {
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */
        this.type = _Operation.OperationType.MERGE;
    }
    /**
     * @inheritDoc
     */
    Merge.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            var childTree = this.children.subtree(new _Path.Path(childName));
            if (childTree.isEmpty()) {
                // This child is unaffected
                return null;
            } else if (childTree.value) {
                // We have a snapshot for the child in question.  This becomes an overwrite of the child.
                return new _Overwrite.Overwrite(this.source, _Path.Path.Empty, childTree.value);
            } else {
                // This is a merge at a deeper level
                return new Merge(this.source, _Path.Path.Empty, childTree);
            }
        } else {
            (0, _assert.assert)(this.path.getFront() === childName, "Can't get a merge for a child not on the path of the operation");
            return new Merge(this.source, this.path.popFront(), this.children);
        }
    };
    /**
     * @inheritDoc
     */
    Merge.prototype.toString = function () {
        return 'Operation(' + this.path + ': ' + this.source.toString() + ' merge: ' + this.children.toString() + ')';
    };
    return Merge;
}();
exports.Merge = Merge;
//# sourceMappingURL=Merge.js.map


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StatsCollection = undefined;

var _deep_copy = __webpack_require__(193);

var _obj = __webpack_require__(7);

/**
 * Tracks a collection of stats.
 *
 * @constructor
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var StatsCollection = /** @class */function () {
    function StatsCollection() {
        this.counters_ = {};
    }
    StatsCollection.prototype.incrementCounter = function (name, amount) {
        if (amount === void 0) {
            amount = 1;
        }
        if (!(0, _obj.contains)(this.counters_, name)) this.counters_[name] = 0;
        this.counters_[name] += amount;
    };
    StatsCollection.prototype.get = function () {
        return (0, _deep_copy.deepCopy)(this.counters_);
    };
    return StatsCollection;
}();
exports.StatsCollection = StatsCollection;
//# sourceMappingURL=StatsCollection.js.map


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StatsReporter = undefined;

var _obj = __webpack_require__(7);

var _util = __webpack_require__(3);

var _StatsListener = __webpack_require__(173);

// Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
var FIRST_STATS_MIN_TIME = 10 * 1000; /**
                                       * Copyright 2017 Google Inc.
                                       *
                                       * Licensed under the Apache License, Version 2.0 (the "License");
                                       * you may not use this file except in compliance with the License.
                                       * You may obtain a copy of the License at
                                       *
                                       *   http://www.apache.org/licenses/LICENSE-2.0
                                       *
                                       * Unless required by applicable law or agreed to in writing, software
                                       * distributed under the License is distributed on an "AS IS" BASIS,
                                       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                       * See the License for the specific language governing permissions and
                                       * limitations under the License.
                                       */

var FIRST_STATS_MAX_TIME = 30 * 1000;
// We'll continue to report stats on average every 5 minutes.
var REPORT_STATS_INTERVAL = 5 * 60 * 1000;
/**
 * @constructor
 */
var StatsReporter = /** @class */function () {
    /**
     * @param collection
     * @param server_
     */
    function StatsReporter(collection, server_) {
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new _StatsListener.StatsListener(collection);
        var timeout = FIRST_STATS_MIN_TIME + (FIRST_STATS_MAX_TIME - FIRST_STATS_MIN_TIME) * Math.random();
        (0, _util.setTimeoutNonBlocking)(this.reportStats_.bind(this), Math.floor(timeout));
    }
    StatsReporter.prototype.includeStat = function (stat) {
        this.statsToReport_[stat] = true;
    };
    StatsReporter.prototype.reportStats_ = function () {
        var _this = this;
        var stats = this.statsListener_.get();
        var reportedStats = {};
        var haveStatsToReport = false;
        (0, _obj.forEach)(stats, function (stat, value) {
            if (value > 0 && (0, _obj.contains)(_this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) {
            this.server_.reportStats(reportedStats);
        }
        // queue our next run.
        (0, _util.setTimeoutNonBlocking)(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * REPORT_STATS_INTERVAL));
    };
    return StatsReporter;
}();
exports.StatsReporter = StatsReporter;
//# sourceMappingURL=StatsReporter.js.map


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DOMStorageWrapper = undefined;

var _json = __webpack_require__(23);

/**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 * @constructor
 */
var DOMStorageWrapper = /** @class */function () {
    /**
     * @param {Storage} domStorage_ The underlying storage object (e.g. localStorage or sessionStorage)
     */
    function DOMStorageWrapper(domStorage_) {
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = 'firebase:';
    }
    /**
     * @param {string} key The key to save the value under
     * @param {?Object} value The value being stored, or null to remove the key.
     */
    DOMStorageWrapper.prototype.set = function (key, value) {
        if (value == null) {
            this.domStorage_.removeItem(this.prefixedName_(key));
        } else {
            this.domStorage_.setItem(this.prefixedName_(key), (0, _json.stringify)(value));
        }
    };
    /**
     * @param {string} key
     * @return {*} The value that was stored under this key, or null
     */
    DOMStorageWrapper.prototype.get = function (key) {
        var storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) {
            return null;
        } else {
            return (0, _json.jsonEval)(storedVal);
        }
    };
    /**
     * @param {string} key
     */
    DOMStorageWrapper.prototype.remove = function (key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    };
    /**
     * @param {string} name
     * @return {string}
     */
    DOMStorageWrapper.prototype.prefixedName_ = function (name) {
        return this.prefix_ + name;
    };
    DOMStorageWrapper.prototype.toString = function () {
        return this.domStorage_.toString();
    };
    return DOMStorageWrapper;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.DOMStorageWrapper = DOMStorageWrapper;
//# sourceMappingURL=DOMStorageWrapper.js.map


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MemoryStorage = undefined;

var _obj = __webpack_require__(7);

/**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 *
 * @constructor
 */
var MemoryStorage = /** @class */function () {
    function MemoryStorage() {
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    MemoryStorage.prototype.set = function (key, value) {
        if (value == null) {
            delete this.cache_[key];
        } else {
            this.cache_[key] = value;
        }
    };
    MemoryStorage.prototype.get = function (key) {
        if ((0, _obj.contains)(this.cache_, key)) {
            return this.cache_[key];
        }
        return null;
    };
    MemoryStorage.prototype.remove = function (key) {
        delete this.cache_[key];
    };
    return MemoryStorage;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.MemoryStorage = MemoryStorage;
//# sourceMappingURL=MemoryStorage.js.map


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.nextPushId = undefined;

var _assert = __webpack_require__(2);

/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */
var nextPushId = exports.nextPushId = function () {
    // Modeled after base64 web-safe chars, but ordered by ASCII.
    var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    var lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    var lastRandChars = [];
    return function (now) {
        var duplicateTime = now === lastPushTime;
        lastPushTime = now;
        var i;
        var timeStampChars = new Array(8);
        for (i = 7; i >= 0; i--) {
            timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        (0, _assert.assert)(now === 0, 'Cannot push at time == 0');
        var id = timeStampChars.join('');
        if (!duplicateTime) {
            for (i = 0; i < 12; i++) {
                lastRandChars[i] = Math.floor(Math.random() * 64);
            }
        } else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
                lastRandChars[i] = 0;
            }
            lastRandChars[i]++;
        }
        for (i = 0; i < 12; i++) {
            id += PUSH_CHARS.charAt(lastRandChars[i]);
        }
        (0, _assert.assert)(id.length === 20, 'nextPushId: Length should be 20.');
        return id;
    };
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
//# sourceMappingURL=NextPushId.js.map


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OnlineMonitor = undefined;

var _assert = __webpack_require__(2);

var _EventEmitter = __webpack_require__(175);

var _environment = __webpack_require__(50);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();

/**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 *
 * @extends {EventEmitter}
 */
var OnlineMonitor = /** @class */function (_super) {
    __extends(OnlineMonitor, _super);
    function OnlineMonitor() {
        var _this = _super.call(this, ['online']) || this;
        _this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined' && !(0, _environment.isMobileCordova)()) {
            window.addEventListener('online', function () {
                if (!_this.online_) {
                    _this.online_ = true;
                    _this.trigger('online', true);
                }
            }, false);
            window.addEventListener('offline', function () {
                if (_this.online_) {
                    _this.online_ = false;
                    _this.trigger('online', false);
                }
            }, false);
        }
        return _this;
    }
    OnlineMonitor.getInstance = function () {
        return new OnlineMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */
    OnlineMonitor.prototype.getInitialEvent = function (eventType) {
        (0, _assert.assert)(eventType === 'online', 'Unknown event type: ' + eventType);
        return [this.online_];
    };
    /**
     * @return {boolean}
     */
    OnlineMonitor.prototype.currentlyOnline = function () {
        return this.online_;
    };
    return OnlineMonitor;
}(_EventEmitter.EventEmitter);
exports.OnlineMonitor = OnlineMonitor;
//# sourceMappingURL=OnlineMonitor.js.map


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Tree = exports.TreeNode = undefined;

var _assert = __webpack_require__(2);

var _Path = __webpack_require__(9);

var _obj = __webpack_require__(7);

/**
 * Node in a Tree.
 */
var TreeNode = /** @class */function () {
    function TreeNode() {
        // TODO: Consider making accessors that create children and value lazily or
        // separate Internal / Leaf 'types'.
        this.children = {};
        this.childCount = 0;
        this.value = null;
    }
    return TreeNode;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.TreeNode = TreeNode;
/**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */

var Tree = /** @class */function () {
    /**
     * @template T
     * @param {string=} name_ Optional name of the node.
     * @param {Tree=} parent_ Optional parent node.
     * @param {TreeNode=} node_ Optional node to wrap.
     */
    function Tree(name_, parent_, node_) {
        if (name_ === void 0) {
            name_ = '';
        }
        if (parent_ === void 0) {
            parent_ = null;
        }
        if (node_ === void 0) {
            node_ = new TreeNode();
        }
        this.name_ = name_;
        this.parent_ = parent_;
        this.node_ = node_;
    }
    /**
     * Returns a sub-Tree for the given path.
     *
     * @param {!(string|Path)} pathObj Path to look up.
     * @return {!Tree.<T>} Tree for path.
     */
    Tree.prototype.subTree = function (pathObj) {
        // TODO: Require pathObj to be Path?
        var path = pathObj instanceof _Path.Path ? pathObj : new _Path.Path(pathObj);
        var child = this,
            next;
        while ((next = path.getFront()) !== null) {
            var childNode = (0, _obj.safeGet)(child.node_.children, next) || new TreeNode();
            child = new Tree(next, child, childNode);
            path = path.popFront();
        }
        return child;
    };
    /**
     * Returns the data associated with this tree node.
     *
     * @return {?T} The data or null if no data exists.
     */
    Tree.prototype.getValue = function () {
        return this.node_.value;
    };
    /**
     * Sets data to this tree node.
     *
     * @param {!T} value Value to set.
     */
    Tree.prototype.setValue = function (value) {
        (0, _assert.assert)(typeof value !== 'undefined', 'Cannot set value to undefined');
        this.node_.value = value;
        this.updateParents_();
    };
    /**
     * Clears the contents of the tree node (its value and all children).
     */
    Tree.prototype.clear = function () {
        this.node_.value = null;
        this.node_.children = {};
        this.node_.childCount = 0;
        this.updateParents_();
    };
    /**
     * @return {boolean} Whether the tree has any children.
     */
    Tree.prototype.hasChildren = function () {
        return this.node_.childCount > 0;
    };
    /**
     * @return {boolean} Whether the tree is empty (no value or children).
     */
    Tree.prototype.isEmpty = function () {
        return this.getValue() === null && !this.hasChildren();
    };
    /**
     * Calls action for each child of this tree node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */
    Tree.prototype.forEachChild = function (action) {
        var _this = this;
        (0, _obj.forEach)(this.node_.children, function (child, childTree) {
            action(new Tree(child, _this, childTree));
        });
    };
    /**
     * Does a depth-first traversal of this node's descendants, calling action for each one.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     * @param {boolean=} includeSelf Whether to call action on this node as well. Defaults to
     *   false.
     * @param {boolean=} childrenFirst Whether to call action on children before calling it on
     *   parent.
     */
    Tree.prototype.forEachDescendant = function (action, includeSelf, childrenFirst) {
        if (includeSelf && !childrenFirst) action(this);
        this.forEachChild(function (child) {
            child.forEachDescendant(action, /*includeSelf=*/true, childrenFirst);
        });
        if (includeSelf && childrenFirst) action(this);
    };
    /**
     * Calls action on each ancestor node.
     *
     * @param {function(!Tree.<T>)} action Action to be called on each parent; return
     *   true to abort.
     * @param {boolean=} includeSelf Whether to call action on this node as well.
     * @return {boolean} true if the action callback returned true.
     */
    Tree.prototype.forEachAncestor = function (action, includeSelf) {
        var node = includeSelf ? this : this.parent();
        while (node !== null) {
            if (action(node)) {
                return true;
            }
            node = node.parent();
        }
        return false;
    };
    /**
     * Does a depth-first traversal of this node's descendants.  When a descendant with a value
     * is found, action is called on it and traversal does not continue inside the node.
     * Action is *not* called on this node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */
    Tree.prototype.forEachImmediateDescendantWithValue = function (action) {
        this.forEachChild(function (child) {
            if (child.getValue() !== null) action(child);else child.forEachImmediateDescendantWithValue(action);
        });
    };
    /**
     * @return {!Path} The path of this tree node, as a Path.
     */
    Tree.prototype.path = function () {
        return new _Path.Path(this.parent_ === null ? this.name_ : this.parent_.path() + '/' + this.name_);
    };
    /**
     * @return {string} The name of the tree node.
     */
    Tree.prototype.name = function () {
        return this.name_;
    };
    /**
     * @return {?Tree} The parent tree node, or null if this is the root of the tree.
     */
    Tree.prototype.parent = function () {
        return this.parent_;
    };
    /**
     * Adds or removes this child from its parent based on whether it's empty or not.
     *
     * @private
     */
    Tree.prototype.updateParents_ = function () {
        if (this.parent_ !== null) this.parent_.updateChild_(this.name_, this);
    };
    /**
     * Adds or removes the passed child to this tree node, depending on whether it's empty.
     *
     * @param {string} childName The name of the child to update.
     * @param {!Tree.<T>} child The child to update.
     * @private
     */
    Tree.prototype.updateChild_ = function (childName, child) {
        var childEmpty = child.isEmpty();
        var childExists = (0, _obj.contains)(this.node_.children, childName);
        if (childEmpty && childExists) {
            delete this.node_.children[childName];
            this.node_.childCount--;
            this.updateParents_();
        } else if (!childEmpty && !childExists) {
            this.node_.children[childName] = child.node_;
            this.node_.childCount++;
            this.updateParents_();
        }
    };
    return Tree;
}();
exports.Tree = Tree;
//# sourceMappingURL=Tree.js.map


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VisibilityMonitor = undefined;

var _EventEmitter = __webpack_require__(175);

var _assert = __webpack_require__(2);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();

/**
 * @extends {EventEmitter}
 */
var VisibilityMonitor = /** @class */function (_super) {
    __extends(VisibilityMonitor, _super);
    function VisibilityMonitor() {
        var _this = _super.call(this, ['visible']) || this;
        var hidden;
        var visibilityChange;
        if (typeof document !== 'undefined' && typeof document.addEventListener !== 'undefined') {
            if (typeof document['hidden'] !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = 'visibilitychange';
                hidden = 'hidden';
            } else if (typeof document['mozHidden'] !== 'undefined') {
                visibilityChange = 'mozvisibilitychange';
                hidden = 'mozHidden';
            } else if (typeof document['msHidden'] !== 'undefined') {
                visibilityChange = 'msvisibilitychange';
                hidden = 'msHidden';
            } else if (typeof document['webkitHidden'] !== 'undefined') {
                visibilityChange = 'webkitvisibilitychange';
                hidden = 'webkitHidden';
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        _this.visible_ = true;
        if (visibilityChange) {
            document.addEventListener(visibilityChange, function () {
                var visible = !document[hidden];
                if (visible !== _this.visible_) {
                    _this.visible_ = visible;
                    _this.trigger('visible', visible);
                }
            }, false);
        }
        return _this;
    }
    VisibilityMonitor.getInstance = function () {
        return new VisibilityMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */
    VisibilityMonitor.prototype.getInitialEvent = function (eventType) {
        (0, _assert.assert)(eventType === 'visible', 'Unknown event type: ' + eventType);
        return [this.visible_];
    };
    return VisibilityMonitor;
}(_EventEmitter.EventEmitter);
exports.VisibilityMonitor = VisibilityMonitor;
//# sourceMappingURL=VisibilityMonitor.js.map


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChildChangeAccumulator = undefined;

var _obj = __webpack_require__(7);

var _Change = __webpack_require__(48);

var _assert = __webpack_require__(2);

/**
 * @constructor
 */
var ChildChangeAccumulator = /** @class */function () {
    function ChildChangeAccumulator() {
        this.changeMap_ = {};
    }
    /**
     * @param {!Change} change
     */
    ChildChangeAccumulator.prototype.trackChildChange = function (change) {
        var type = change.type;
        var childKey /** @type {!string} */ = change.childName;
        (0, _assert.assert)(type == _Change.Change.CHILD_ADDED || type == _Change.Change.CHILD_CHANGED || type == _Change.Change.CHILD_REMOVED, 'Only child changes supported for tracking');
        (0, _assert.assert)(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
        var oldChange = (0, _obj.safeGet)(this.changeMap_, childKey);
        if (oldChange) {
            var oldType = oldChange.type;
            if (type == _Change.Change.CHILD_ADDED && oldType == _Change.Change.CHILD_REMOVED) {
                this.changeMap_[childKey] = _Change.Change.childChangedChange(childKey, change.snapshotNode, oldChange.snapshotNode);
            } else if (type == _Change.Change.CHILD_REMOVED && oldType == _Change.Change.CHILD_ADDED) {
                delete this.changeMap_[childKey];
            } else if (type == _Change.Change.CHILD_REMOVED && oldType == _Change.Change.CHILD_CHANGED) {
                this.changeMap_[childKey] = _Change.Change.childRemovedChange(childKey, oldChange.oldSnap);
            } else if (type == _Change.Change.CHILD_CHANGED && oldType == _Change.Change.CHILD_ADDED) {
                this.changeMap_[childKey] = _Change.Change.childAddedChange(childKey, change.snapshotNode);
            } else if (type == _Change.Change.CHILD_CHANGED && oldType == _Change.Change.CHILD_CHANGED) {
                this.changeMap_[childKey] = _Change.Change.childChangedChange(childKey, change.snapshotNode, oldChange.oldSnap);
            } else {
                throw (0, _assert.assertionError)('Illegal combination of changes: ' + change + ' occurred after ' + oldChange);
            }
        } else {
            this.changeMap_[childKey] = change;
        }
    };
    /**
     * @return {!Array.<!Change>}
     */
    ChildChangeAccumulator.prototype.getChanges = function () {
        return (0, _obj.getValues)(this.changeMap_);
    };
    return ChildChangeAccumulator;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.ChildChangeAccumulator = ChildChangeAccumulator;
//# sourceMappingURL=ChildChangeAccumulator.js.map


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WriteTreeCompleteChildSource = exports.NO_COMPLETE_CHILD_SOURCE = exports.NoCompleteChildSource_ = undefined;

var _CacheNode = __webpack_require__(81);

/**
 * An implementation of CompleteChildSource that never returns any additional children
 *
 * @private
 * @constructor
 * @implements CompleteChildSource
 */
var NoCompleteChildSource_ = /** @class */function () {
    function NoCompleteChildSource_() {}
    /**
     * @inheritDoc
     */
    NoCompleteChildSource_.prototype.getCompleteChild = function (childKey) {
        return null;
    };
    /**
     * @inheritDoc
     */
    NoCompleteChildSource_.prototype.getChildAfterChild = function (index, child, reverse) {
        return null;
    };
    return NoCompleteChildSource_;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.NoCompleteChildSource_ = NoCompleteChildSource_;
/**
 * Singleton instance.
 * @const
 * @type {!CompleteChildSource}
 */

var NO_COMPLETE_CHILD_SOURCE = exports.NO_COMPLETE_CHILD_SOURCE = new NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 *
 *
 * @implements CompleteChildSource
 */
var WriteTreeCompleteChildSource = /** @class */function () {
    /**
     * @param {!WriteTreeRef} writes_
     * @param {!ViewCache} viewCache_
     * @param {?Node} optCompleteServerCache_
     */
    function WriteTreeCompleteChildSource(writes_, viewCache_, optCompleteServerCache_) {
        if (optCompleteServerCache_ === void 0) {
            optCompleteServerCache_ = null;
        }
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    /**
     * @inheritDoc
     */
    WriteTreeCompleteChildSource.prototype.getCompleteChild = function (childKey) {
        var node = this.viewCache_.getEventCache();
        if (node.isCompleteForChild(childKey)) {
            return node.getNode().getImmediateChild(childKey);
        } else {
            var serverNode = this.optCompleteServerCache_ != null ? new _CacheNode.CacheNode(this.optCompleteServerCache_, true, false) : this.viewCache_.getServerCache();
            return this.writes_.calcCompleteChild(childKey, serverNode);
        }
    };
    /**
     * @inheritDoc
     */
    WriteTreeCompleteChildSource.prototype.getChildAfterChild = function (index, child, reverse) {
        var completeServerData = this.optCompleteServerCache_ != null ? this.optCompleteServerCache_ : this.viewCache_.getCompleteServerSnap();
        var nodes = this.writes_.calcIndexedSlice(completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) {
            return null;
        } else {
            return nodes[0];
        }
    };
    return WriteTreeCompleteChildSource;
}();
exports.WriteTreeCompleteChildSource = WriteTreeCompleteChildSource;
//# sourceMappingURL=CompleteChildSource.js.map


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CancelEvent = exports.DataEvent = undefined;

var _json = __webpack_require__(23);

/**
 * Encapsulates the data needed to raise an event
 * @implements {Event}
 */
var DataEvent = /** @class */function () {
    /**
     * @param {!string} eventType One of: value, child_added, child_changed, child_moved, child_removed
     * @param {!EventRegistration} eventRegistration The function to call to with the event data. User provided
     * @param {!DataSnapshot} snapshot The data backing the event
     * @param {?string=} prevName Optional, the name of the previous child for child_* events.
     */
    function DataEvent(eventType, eventRegistration, snapshot, prevName) {
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getPath = function () {
        var ref = this.snapshot.getRef();
        if (this.eventType === 'value') {
            return ref.path;
        } else {
            return ref.getParent().path;
        }
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getEventType = function () {
        return this.eventType;
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getEventRunner = function () {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.toString = function () {
        return this.getPath().toString() + ':' + this.eventType + ':' + (0, _json.stringify)(this.snapshot.exportVal());
    };
    return DataEvent;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.DataEvent = DataEvent;

var CancelEvent = /** @class */function () {
    /**
     * @param {EventRegistration} eventRegistration
     * @param {Error} error
     * @param {!Path} path
     */
    function CancelEvent(eventRegistration, error, path) {
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getPath = function () {
        return this.path;
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getEventType = function () {
        return 'cancel';
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getEventRunner = function () {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.toString = function () {
        return this.path.toString() + ':cancel';
    };
    return CancelEvent;
}();
exports.CancelEvent = CancelEvent;
//# sourceMappingURL=Event.js.map


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EventGenerator = undefined;

var _Node = __webpack_require__(19);

var _Change = __webpack_require__(48);

var _assert = __webpack_require__(2);

/**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 * @constructor
 */
var EventGenerator = /** @class */function () {
    /**
     *
     * @param {!Query} query_
     */
    function EventGenerator(query_) {
        this.query_ = query_;
        /**
         * @private
         * @type {!Index}
         */
        this.index_ = this.query_.getQueryParams().getIndex();
    }
    /**
     * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
     * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
     *
     * Notes:
     *  - child_moved events will be synthesized at this time for any child_changed events that affect
     *    our index.
     *  - prevName will be calculated based on the index ordering.
     *
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {!Array.<!EventRegistration>} eventRegistrations
     * @return {!Array.<!Event>}
     */
    EventGenerator.prototype.generateEventsForChanges = function (changes, eventCache, eventRegistrations) {
        var _this = this;
        var events = [];
        var moves = [];
        changes.forEach(function (change) {
            if (change.type === _Change.Change.CHILD_CHANGED && _this.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) {
                moves.push(_Change.Change.childMovedChange(change.childName, change.snapshotNode));
            }
        });
        this.generateEventsForType_(events, _Change.Change.CHILD_REMOVED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, _Change.Change.CHILD_ADDED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, _Change.Change.CHILD_MOVED, moves, eventRegistrations, eventCache);
        this.generateEventsForType_(events, _Change.Change.CHILD_CHANGED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, _Change.Change.VALUE, changes, eventRegistrations, eventCache);
        return events;
    };
    /**
     * Given changes of a single change type, generate the corresponding events.
     *
     * @param {!Array.<!Event>} events
     * @param {!string} eventType
     * @param {!Array.<!Change>} changes
     * @param {!Array.<!EventRegistration>} registrations
     * @param {!Node} eventCache
     * @private
     */
    EventGenerator.prototype.generateEventsForType_ = function (events, eventType, changes, registrations, eventCache) {
        var _this = this;
        var filteredChanges = changes.filter(function (change) {
            return change.type === eventType;
        });
        filteredChanges.sort(this.compareChanges_.bind(this));
        filteredChanges.forEach(function (change) {
            var materializedChange = _this.materializeSingleChange_(change, eventCache);
            registrations.forEach(function (registration) {
                if (registration.respondsTo(change.type)) {
                    events.push(registration.createEvent(materializedChange, _this.query_));
                }
            });
        });
    };
    /**
     * @param {!Change} change
     * @param {!Node} eventCache
     * @return {!Change}
     * @private
     */
    EventGenerator.prototype.materializeSingleChange_ = function (change, eventCache) {
        if (change.type === 'value' || change.type === 'child_removed') {
            return change;
        } else {
            change.prevName = eventCache.getPredecessorChildName(
            /** @type {!string} */
            change.childName, change.snapshotNode, this.index_);
            return change;
        }
    };
    /**
     * @param {!Change} a
     * @param {!Change} b
     * @return {number}
     * @private
     */
    EventGenerator.prototype.compareChanges_ = function (a, b) {
        if (a.childName == null || b.childName == null) {
            throw (0, _assert.assertionError)('Should only compare child_ events.');
        }
        var aWrapped = new _Node.NamedNode(a.childName, a.snapshotNode);
        var bWrapped = new _Node.NamedNode(b.childName, b.snapshotNode);
        return this.index_.compare(aWrapped, bWrapped);
    };
    return EventGenerator;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.EventGenerator = EventGenerator;
//# sourceMappingURL=EventGenerator.js.map


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EventList = exports.EventQueue = undefined;

var _util = __webpack_require__(3);

/**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 * @constructor
 */
var EventQueue = /** @class */function () {
    function EventQueue() {
        /**
         * @private
         * @type {!Array.<EventList>}
         */
        this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         * @private
         * @type {!number}
         */
        this.recursionDepth_ = 0;
    }
    /**
     * @param {!Array.<Event>} eventDataList The new events to queue.
     */
    EventQueue.prototype.queueEvents = function (eventDataList) {
        // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
        var currList = null;
        for (var i = 0; i < eventDataList.length; i++) {
            var eventData = eventDataList[i];
            var eventPath = eventData.getPath();
            if (currList !== null && !eventPath.equals(currList.getPath())) {
                this.eventLists_.push(currList);
                currList = null;
            }
            if (currList === null) {
                currList = new EventList(eventPath);
            }
            currList.add(eventData);
        }
        if (currList) {
            this.eventLists_.push(currList);
        }
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones)
     * for the specified path.
     *
     * It is assumed that the new events are all for the specified path.
     *
     * @param {!Path} path The path to raise events for.
     * @param {!Array.<Event>} eventDataList The new events to raise.
     */
    EventQueue.prototype.raiseEventsAtPath = function (path, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
            return eventPath.equals(path);
        });
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones) for
     * locations related to the specified change path (i.e. all ancestors and descendants).
     *
     * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
     *
     * @param {!Path} changedPath The path to raise events for.
     * @param {!Array.<!Event>} eventDataList The events to raise
     */
    EventQueue.prototype.raiseEventsForChangedPath = function (changedPath, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
            return eventPath.contains(changedPath) || changedPath.contains(eventPath);
        });
    };
    /**
     * @param {!function(!Path):boolean} predicate
     * @private
     */
    EventQueue.prototype.raiseQueuedEventsMatchingPredicate_ = function (predicate) {
        this.recursionDepth_++;
        var sentAll = true;
        for (var i = 0; i < this.eventLists_.length; i++) {
            var eventList = this.eventLists_[i];
            if (eventList) {
                var eventPath = eventList.getPath();
                if (predicate(eventPath)) {
                    this.eventLists_[i].raise();
                    this.eventLists_[i] = null;
                } else {
                    sentAll = false;
                }
            }
        }
        if (sentAll) {
            this.eventLists_ = [];
        }
        this.recursionDepth_--;
    };
    return EventQueue;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.EventQueue = EventQueue;
/**
 * @param {!Path} path
 * @constructor
 */

var EventList = /** @class */function () {
    function EventList(path_) {
        this.path_ = path_;
        /**
         * @type {!Array.<Event>}
         * @private
         */
        this.events_ = [];
    }
    /**
     * @param {!Event} eventData
     */
    EventList.prototype.add = function (eventData) {
        this.events_.push(eventData);
    };
    /**
     * Iterates through the list and raises each event
     */
    EventList.prototype.raise = function () {
        for (var i = 0; i < this.events_.length; i++) {
            var eventData = this.events_[i];
            if (eventData !== null) {
                this.events_[i] = null;
                var eventFn = eventData.getEventRunner();
                if (_util.logger) {
                    (0, _util.log)('event: ' + eventData.toString());
                }
                (0, _util.exceptionGuard)(eventFn);
            }
        }
    };
    /**
     * @return {!Path}
     */
    EventList.prototype.getPath = function () {
        return this.path_;
    };
    return EventList;
}();
exports.EventList = EventList;
//# sourceMappingURL=EventQueue.js.map


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChildEventRegistration = exports.ValueEventRegistration = undefined;

var _DataSnapshot = __webpack_require__(158);

var _Event = __webpack_require__(401);

var _obj = __webpack_require__(7);

var _assert = __webpack_require__(2);

/**
 * Represents registration for 'value' events.
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ValueEventRegistration = /** @class */function () {
    /**
     * @param {?function(!DataSnapshot)} callback_
     * @param {?function(Error)} cancelCallback_
     * @param {?Object} context_
     */
    function ValueEventRegistration(callback_, cancelCallback_, context_) {
        this.callback_ = callback_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.respondsTo = function (eventType) {
        return eventType === 'value';
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.createEvent = function (change, query) {
        var index = query.getQueryParams().getIndex();
        return new _Event.DataEvent('value', this, new _DataSnapshot.DataSnapshot(change.snapshotNode, query.getRef(), index));
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.getEventRunner = function (eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === 'cancel') {
            (0, _assert.assert)(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
            var cancelCB_1 = this.cancelCallback_;
            return function () {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_1.call(ctx, eventData.error);
            };
        } else {
            var cb_1 = this.callback_;
            return function () {
                cb_1.call(ctx, eventData.snapshot);
            };
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.createCancelEvent = function (error, path) {
        if (this.cancelCallback_) {
            return new _Event.CancelEvent(this, error, path);
        } else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.matches = function (other) {
        if (!(other instanceof ValueEventRegistration)) {
            return false;
        } else if (!other.callback_ || !this.callback_) {
            // If no callback specified, we consider it to match any callback.
            return true;
        } else {
            return other.callback_ === this.callback_ && other.context_ === this.context_;
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.hasAnyCallback = function () {
        return this.callback_ !== null;
    };
    return ValueEventRegistration;
}();
exports.ValueEventRegistration = ValueEventRegistration;
/**
 * Represents the registration of 1 or more child_xxx events.
 *
 * Currently, it is always exactly 1 child_xxx event, but the idea is we might let you
 * register a group of callbacks together in the future.
 *
 * @constructor
 * @implements {EventRegistration}
 */

var ChildEventRegistration = /** @class */function () {
    /**
     * @param {?Object.<string, function(!DataSnapshot, ?string=)>} callbacks_
     * @param {?function(Error)} cancelCallback_
     * @param {Object=} context_
     */
    function ChildEventRegistration(callbacks_, cancelCallback_, context_) {
        this.callbacks_ = callbacks_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.respondsTo = function (eventType) {
        var eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
        eventToCheck = eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
        return (0, _obj.contains)(this.callbacks_, eventToCheck);
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.createCancelEvent = function (error, path) {
        if (this.cancelCallback_) {
            return new _Event.CancelEvent(this, error, path);
        } else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.createEvent = function (change, query) {
        (0, _assert.assert)(change.childName != null, 'Child events should have a childName.');
        var ref = query.getRef().child /** @type {!string} */(change.childName);
        var index = query.getQueryParams().getIndex();
        return new _Event.DataEvent(change.type, this, new _DataSnapshot.DataSnapshot(change.snapshotNode, ref, index), change.prevName);
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.getEventRunner = function (eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === 'cancel') {
            (0, _assert.assert)(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
            var cancelCB_2 = this.cancelCallback_;
            return function () {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_2.call(ctx, eventData.error);
            };
        } else {
            var cb_2 = this.callbacks_[eventData.eventType];
            return function () {
                cb_2.call(ctx, eventData.snapshot, eventData.prevName);
            };
        }
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.matches = function (other) {
        if (other instanceof ChildEventRegistration) {
            if (!this.callbacks_ || !other.callbacks_) {
                return true;
            } else if (this.context_ === other.context_) {
                var otherCount = (0, _obj.getCount)(other.callbacks_);
                var thisCount = (0, _obj.getCount)(this.callbacks_);
                if (otherCount === thisCount) {
                    // If count is 1, do an exact match on eventType, if either is defined but null, it's a match.
                    //  If event types don't match, not a match
                    // If count is not 1, exact match across all
                    if (otherCount === 1) {
                        var otherKey /** @type {!string} */ = (0, _obj.getAnyKey)(other.callbacks_);
                        var thisKey /** @type {!string} */ = (0, _obj.getAnyKey)(this.callbacks_);
                        return thisKey === otherKey && (!other.callbacks_[otherKey] || !this.callbacks_[thisKey] || other.callbacks_[otherKey] === this.callbacks_[thisKey]);
                    } else {
                        // Exact match on each key.
                        return (0, _obj.every)(this.callbacks_, function (eventType, cb) {
                            return other.callbacks_[eventType] === cb;
                        });
                    }
                }
            }
        }
        return false;
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.hasAnyCallback = function () {
        return this.callbacks_ !== null;
    };
    return ChildEventRegistration;
}();
exports.ChildEventRegistration = ChildEventRegistration;
//# sourceMappingURL=EventRegistration.js.map


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.QueryParams = undefined;

var _assert = __webpack_require__(2);

var _util = __webpack_require__(3);

var _KeyIndex = __webpack_require__(61);

var _PriorityIndex = __webpack_require__(15);

var _ValueIndex = __webpack_require__(171);

var _PathIndex = __webpack_require__(170);

var _IndexedFilter = __webpack_require__(109);

var _LimitedFilter = __webpack_require__(408);

var _RangedFilter = __webpack_require__(179);

var _json = __webpack_require__(23);

/**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 * @constructor
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var QueryParams = /** @class */function () {
    function QueryParams() {
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.limit_ = 0;
        this.viewFrom_ = '';
        this.indexStartValue_ = null;
        this.indexStartName_ = '';
        this.indexEndValue_ = null;
        this.indexEndName_ = '';
        this.index_ = _PriorityIndex.PRIORITY_INDEX;
    }
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasStart = function () {
        return this.startSet_;
    };
    /**
     * @return {boolean} True if it would return from left.
     */
    QueryParams.prototype.isViewFromLeft = function () {
        if (this.viewFrom_ === '') {
            // limit(), rather than limitToFirst or limitToLast was called.
            // This means that only one of startSet_ and endSet_ is true. Use them
            // to calculate which side of the view to anchor to. If neither is set,
            // anchor to the end.
            return this.startSet_;
        } else {
            return this.viewFrom_ === QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
        }
    };
    /**
     * Only valid to call if hasStart() returns true
     * @return {*}
     */
    QueryParams.prototype.getIndexStartValue = function () {
        (0, _assert.assert)(this.startSet_, 'Only valid if start has been set');
        return this.indexStartValue_;
    };
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     * @return {!string}
     */
    QueryParams.prototype.getIndexStartName = function () {
        (0, _assert.assert)(this.startSet_, 'Only valid if start has been set');
        if (this.startNameSet_) {
            return this.indexStartName_;
        } else {
            return _util.MIN_NAME;
        }
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasEnd = function () {
        return this.endSet_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * @return {*}
     */
    QueryParams.prototype.getIndexEndValue = function () {
        (0, _assert.assert)(this.endSet_, 'Only valid if end has been set');
        return this.indexEndValue_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     * @return {!string}
     */
    QueryParams.prototype.getIndexEndName = function () {
        (0, _assert.assert)(this.endSet_, 'Only valid if end has been set');
        if (this.endNameSet_) {
            return this.indexEndName_;
        } else {
            return _util.MAX_NAME;
        }
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasLimit = function () {
        return this.limitSet_;
    };
    /**
     * @return {boolean} True if a limit has been set and it has been explicitly anchored
     */
    QueryParams.prototype.hasAnchoredLimit = function () {
        return this.limitSet_ && this.viewFrom_ !== '';
    };
    /**
     * Only valid to call if hasLimit() returns true
     * @return {!number}
     */
    QueryParams.prototype.getLimit = function () {
        (0, _assert.assert)(this.limitSet_, 'Only valid if limit has been set');
        return this.limit_;
    };
    /**
     * @return {!Index}
     */
    QueryParams.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @return {!QueryParams}
     * @private
     */
    QueryParams.prototype.copy_ = function () {
        var copy = new QueryParams();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limit = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = '';
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limitToFirst = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limitToLast = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_RIGHT;
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */
    QueryParams.prototype.startAt = function (indexValue, key) {
        var newParams = this.copy_();
        newParams.startSet_ = true;
        if (!(indexValue !== undefined)) {
            indexValue = null;
        }
        newParams.indexStartValue_ = indexValue;
        if (key != null) {
            newParams.startNameSet_ = true;
            newParams.indexStartName_ = key;
        } else {
            newParams.startNameSet_ = false;
            newParams.indexStartName_ = '';
        }
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */
    QueryParams.prototype.endAt = function (indexValue, key) {
        var newParams = this.copy_();
        newParams.endSet_ = true;
        if (!(indexValue !== undefined)) {
            indexValue = null;
        }
        newParams.indexEndValue_ = indexValue;
        if (key !== undefined) {
            newParams.endNameSet_ = true;
            newParams.indexEndName_ = key;
        } else {
            newParams.endNameSet_ = false;
            newParams.indexEndName_ = '';
        }
        return newParams;
    };
    /**
     * @param {!Index} index
     * @return {!QueryParams}
     */
    QueryParams.prototype.orderBy = function (index) {
        var newParams = this.copy_();
        newParams.index_ = index;
        return newParams;
    };
    /**
     * @return {!Object}
     */
    QueryParams.prototype.getQueryObject = function () {
        var WIRE_PROTOCOL_CONSTANTS = QueryParams.WIRE_PROTOCOL_CONSTANTS_;
        var obj = {};
        if (this.startSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE] = this.indexStartValue_;
            if (this.startNameSet_) {
                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME] = this.indexStartName_;
            }
        }
        if (this.endSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE] = this.indexEndValue_;
            if (this.endNameSet_) {
                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME] = this.indexEndName_;
            }
        }
        if (this.limitSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.LIMIT] = this.limit_;
            var viewFrom = this.viewFrom_;
            if (viewFrom === '') {
                if (this.isViewFromLeft()) {
                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT;
                } else {
                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT;
                }
            }
            obj[WIRE_PROTOCOL_CONSTANTS.VIEW_FROM] = viewFrom;
        }
        // For now, priority index is the default, so we only specify if it's some other index
        if (this.index_ !== _PriorityIndex.PRIORITY_INDEX) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX] = this.index_.toString();
        }
        return obj;
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.loadsAllData = function () {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.isDefault = function () {
        return this.loadsAllData() && this.index_ == _PriorityIndex.PRIORITY_INDEX;
    };
    /**
     * @return {!NodeFilter}
     */
    QueryParams.prototype.getNodeFilter = function () {
        if (this.loadsAllData()) {
            return new _IndexedFilter.IndexedFilter(this.getIndex());
        } else if (this.hasLimit()) {
            return new _LimitedFilter.LimitedFilter(this);
        } else {
            return new _RangedFilter.RangedFilter(this);
        }
    };
    /**
     * Returns a set of REST query string parameters representing this query.
     *
     * @return {!Object.<string,*>} query string parameters
     */
    QueryParams.prototype.toRestQueryStringParameters = function () {
        var REST_CONSTANTS = QueryParams.REST_QUERY_CONSTANTS_;
        var qs = {};
        if (this.isDefault()) {
            return qs;
        }
        var orderBy;
        if (this.index_ === _PriorityIndex.PRIORITY_INDEX) {
            orderBy = REST_CONSTANTS.PRIORITY_INDEX;
        } else if (this.index_ === _ValueIndex.VALUE_INDEX) {
            orderBy = REST_CONSTANTS.VALUE_INDEX;
        } else if (this.index_ === _KeyIndex.KEY_INDEX) {
            orderBy = REST_CONSTANTS.KEY_INDEX;
        } else {
            (0, _assert.assert)(this.index_ instanceof _PathIndex.PathIndex, 'Unrecognized index type!');
            orderBy = this.index_.toString();
        }
        qs[REST_CONSTANTS.ORDER_BY] = (0, _json.stringify)(orderBy);
        if (this.startSet_) {
            qs[REST_CONSTANTS.START_AT] = (0, _json.stringify)(this.indexStartValue_);
            if (this.startNameSet_) {
                qs[REST_CONSTANTS.START_AT] += ',' + (0, _json.stringify)(this.indexStartName_);
            }
        }
        if (this.endSet_) {
            qs[REST_CONSTANTS.END_AT] = (0, _json.stringify)(this.indexEndValue_);
            if (this.endNameSet_) {
                qs[REST_CONSTANTS.END_AT] += ',' + (0, _json.stringify)(this.indexEndName_);
            }
        }
        if (this.limitSet_) {
            if (this.isViewFromLeft()) {
                qs[REST_CONSTANTS.LIMIT_TO_FIRST] = this.limit_;
            } else {
                qs[REST_CONSTANTS.LIMIT_TO_LAST] = this.limit_;
            }
        }
        return qs;
    };
    /**
     * Wire Protocol Constants
     * @const
     * @enum {string}
     * @private
     */
    QueryParams.WIRE_PROTOCOL_CONSTANTS_ = {
        INDEX_START_VALUE: 'sp',
        INDEX_START_NAME: 'sn',
        INDEX_END_VALUE: 'ep',
        INDEX_END_NAME: 'en',
        LIMIT: 'l',
        VIEW_FROM: 'vf',
        VIEW_FROM_LEFT: 'l',
        VIEW_FROM_RIGHT: 'r',
        INDEX: 'i'
    };
    /**
     * REST Query Constants
     * @const
     * @enum {string}
     * @private
     */
    QueryParams.REST_QUERY_CONSTANTS_ = {
        ORDER_BY: 'orderBy',
        PRIORITY_INDEX: '$priority',
        VALUE_INDEX: '$value',
        KEY_INDEX: '$key',
        START_AT: 'startAt',
        END_AT: 'endAt',
        LIMIT_TO_FIRST: 'limitToFirst',
        LIMIT_TO_LAST: 'limitToLast'
    };
    /**
     * Default, empty query parameters
     * @type {!QueryParams}
     * @const
     */
    QueryParams.DEFAULT = new QueryParams();
    return QueryParams;
}();
exports.QueryParams = QueryParams;
//# sourceMappingURL=QueryParams.js.map


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.View = undefined;

var _IndexedFilter = __webpack_require__(109);

var _ViewProcessor = __webpack_require__(407);

var _ChildrenNode = __webpack_require__(16);

var _CacheNode = __webpack_require__(81);

var _ViewCache = __webpack_require__(178);

var _EventGenerator = __webpack_require__(402);

var _assert = __webpack_require__(2);

var _Operation = __webpack_require__(36);

var _Change = __webpack_require__(48);

var _PriorityIndex = __webpack_require__(15);

/**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 * @constructor
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var View = /** @class */function () {
    /**
     *
     * @param {!Query} query_
     * @param {!ViewCache} initialViewCache
     */
    function View(query_, initialViewCache) {
        this.query_ = query_;
        this.eventRegistrations_ = [];
        var params = this.query_.getQueryParams();
        var indexFilter = new _IndexedFilter.IndexedFilter(params.getIndex());
        var filter = params.getNodeFilter();
        /**
         * @type {ViewProcessor}
         * @private
         */
        this.processor_ = new _ViewProcessor.ViewProcessor(filter);
        var initialServerCache = initialViewCache.getServerCache();
        var initialEventCache = initialViewCache.getEventCache();
        // Don't filter server node with other filter than index, wait for tagged listen
        var serverSnap = indexFilter.updateFullNode(_ChildrenNode.ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        var eventSnap = filter.updateFullNode(_ChildrenNode.ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        var newServerCache = new _CacheNode.CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        var newEventCache = new _CacheNode.CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        /**
         * @type {!ViewCache}
         * @private
         */
        this.viewCache_ = new _ViewCache.ViewCache(newEventCache, newServerCache);
        /**
         * @type {!EventGenerator}
         * @private
         */
        this.eventGenerator_ = new _EventGenerator.EventGenerator(this.query_);
    }
    /**
     * @return {!Query}
     */
    View.prototype.getQuery = function () {
        return this.query_;
    };
    /**
     * @return {?Node}
     */
    View.prototype.getServerCache = function () {
        return this.viewCache_.getServerCache().getNode();
    };
    /**
     * @param {!Path} path
     * @return {?Node}
     */
    View.prototype.getCompleteServerCache = function (path) {
        var cache = this.viewCache_.getCompleteServerSnap();
        if (cache) {
            // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
            // we need to see if it contains the child we're interested in.
            if (this.query_.getQueryParams().loadsAllData() || !path.isEmpty() && !cache.getImmediateChild(path.getFront()).isEmpty()) {
                return cache.getChild(path);
            }
        }
        return null;
    };
    /**
     * @return {boolean}
     */
    View.prototype.isEmpty = function () {
        return this.eventRegistrations_.length === 0;
    };
    /**
     * @param {!EventRegistration} eventRegistration
     */
    View.prototype.addEventRegistration = function (eventRegistration) {
        this.eventRegistrations_.push(eventRegistration);
    };
    /**
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
     */
    View.prototype.removeEventRegistration = function (eventRegistration, cancelError) {
        var cancelEvents = [];
        if (cancelError) {
            (0, _assert.assert)(eventRegistration == null, 'A cancel should cancel all event registrations.');
            var path_1 = this.query_.path;
            this.eventRegistrations_.forEach(function (registration) {
                cancelError /** @type {!Error} */ = cancelError;
                var maybeEvent = registration.createCancelEvent(cancelError, path_1);
                if (maybeEvent) {
                    cancelEvents.push(maybeEvent);
                }
            });
        }
        if (eventRegistration) {
            var remaining = [];
            for (var i = 0; i < this.eventRegistrations_.length; ++i) {
                var existing = this.eventRegistrations_[i];
                if (!existing.matches(eventRegistration)) {
                    remaining.push(existing);
                } else if (eventRegistration.hasAnyCallback()) {
                    // We're removing just this one
                    remaining = remaining.concat(this.eventRegistrations_.slice(i + 1));
                    break;
                }
            }
            this.eventRegistrations_ = remaining;
        } else {
            this.eventRegistrations_ = [];
        }
        return cancelEvents;
    };
    /**
     * Applies the given Operation, updates our cache, and returns the appropriate events.
     *
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @return {!Array.<!Event>}
     */
    View.prototype.applyOperation = function (operation, writesCache, completeServerCache) {
        if (operation.type === _Operation.OperationType.MERGE && operation.source.queryId !== null) {
            (0, _assert.assert)(this.viewCache_.getCompleteServerSnap(), 'We should always have a full cache before handling merges');
            (0, _assert.assert)(this.viewCache_.getCompleteEventSnap(), 'Missing event cache, even though we have a server cache');
        }
        var oldViewCache = this.viewCache_;
        var result = this.processor_.applyOperation(oldViewCache, operation, writesCache, completeServerCache);
        this.processor_.assertIndexed(result.viewCache);
        (0, _assert.assert)(result.viewCache.getServerCache().isFullyInitialized() || !oldViewCache.getServerCache().isFullyInitialized(), 'Once a server snap is complete, it should never go back');
        this.viewCache_ = result.viewCache;
        return this.generateEventsForChanges_(result.changes, result.viewCache.getEventCache().getNode(), null);
    };
    /**
     * @param {!EventRegistration} registration
     * @return {!Array.<!Event>}
     */
    View.prototype.getInitialEvents = function (registration) {
        var eventSnap = this.viewCache_.getEventCache();
        var initialChanges = [];
        if (!eventSnap.getNode().isLeafNode()) {
            var eventNode = eventSnap.getNode();
            eventNode.forEachChild(_PriorityIndex.PRIORITY_INDEX, function (key, childNode) {
                initialChanges.push(_Change.Change.childAddedChange(key, childNode));
            });
        }
        if (eventSnap.isFullyInitialized()) {
            initialChanges.push(_Change.Change.valueChange(eventSnap.getNode()));
        }
        return this.generateEventsForChanges_(initialChanges, eventSnap.getNode(), registration);
    };
    /**
     * @private
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {EventRegistration=} eventRegistration
     * @return {!Array.<!Event>}
     */
    View.prototype.generateEventsForChanges_ = function (changes, eventCache, eventRegistration) {
        var registrations = eventRegistration ? [eventRegistration] : this.eventRegistrations_;
        return this.eventGenerator_.generateEventsForChanges(changes, eventCache, registrations);
    };
    return View;
}();
exports.View = View;
//# sourceMappingURL=View.js.map


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ViewProcessor = exports.ProcessorResult = undefined;

var _Operation = __webpack_require__(36);

var _assert = __webpack_require__(2);

var _ChildChangeAccumulator = __webpack_require__(399);

var _Change = __webpack_require__(48);

var _ChildrenNode = __webpack_require__(16);

var _KeyIndex = __webpack_require__(61);

var _ImmutableTree = __webpack_require__(107);

var _Path = __webpack_require__(9);

var _CompleteChildSource = __webpack_require__(400);

/**
 * @constructor
 * @struct
 */
var ProcessorResult = /** @class */function () {
    /**
     * @param {!ViewCache} viewCache
     * @param {!Array.<!Change>} changes
     */
    function ProcessorResult(viewCache, changes) {
        this.viewCache = viewCache;
        this.changes = changes;
    }
    return ProcessorResult;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.ProcessorResult = ProcessorResult;
/**
 * @constructor
 */

var ViewProcessor = /** @class */function () {
    /**
     * @param {!NodeFilter} filter_
     */
    function ViewProcessor(filter_) {
        this.filter_ = filter_;
    }
    /**
     * @param {!ViewCache} viewCache
     */
    ViewProcessor.prototype.assertIndexed = function (viewCache) {
        (0, _assert.assert)(viewCache.getEventCache().getNode().isIndexed(this.filter_.getIndex()), 'Event snap not indexed');
        (0, _assert.assert)(viewCache.getServerCache().getNode().isIndexed(this.filter_.getIndex()), 'Server snap not indexed');
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @return {!ProcessorResult}
     */
    ViewProcessor.prototype.applyOperation = function (oldViewCache, operation, writesCache, completeCache) {
        var accumulator = new _ChildChangeAccumulator.ChildChangeAccumulator();
        var newViewCache, filterServerNode;
        if (operation.type === _Operation.OperationType.OVERWRITE) {
            var overwrite = operation;
            if (overwrite.source.fromUser) {
                newViewCache = this.applyUserOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
            } else {
                (0, _assert.assert)(overwrite.source.fromServer, 'Unknown source.');
                // We filter the node if it's a tagged update or the node has been previously filtered  and the
                // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
                // again
                filterServerNode = overwrite.source.tagged || oldViewCache.getServerCache().isFiltered() && !overwrite.path.isEmpty();
                newViewCache = this.applyServerOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
            }
        } else if (operation.type === _Operation.OperationType.MERGE) {
            var merge = operation;
            if (merge.source.fromUser) {
                newViewCache = this.applyUserMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
            } else {
                (0, _assert.assert)(merge.source.fromServer, 'Unknown source.');
                // We filter the node if it's a tagged update or the node has been previously filtered
                filterServerNode = merge.source.tagged || oldViewCache.getServerCache().isFiltered();
                newViewCache = this.applyServerMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
            }
        } else if (operation.type === _Operation.OperationType.ACK_USER_WRITE) {
            var ackUserWrite = operation;
            if (!ackUserWrite.revert) {
                newViewCache = this.ackUserWrite_(oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
            } else {
                newViewCache = this.revertUserWrite_(oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
            }
        } else if (operation.type === _Operation.OperationType.LISTEN_COMPLETE) {
            newViewCache = this.listenComplete_(oldViewCache, operation.path, writesCache, accumulator);
        } else {
            throw (0, _assert.assertionError)('Unknown operation type: ' + operation.type);
        }
        var changes = accumulator.getChanges();
        ViewProcessor.maybeAddValueEvent_(oldViewCache, newViewCache, changes);
        return new ProcessorResult(newViewCache, changes);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!ViewCache} newViewCache
     * @param {!Array.<!Change>} accumulator
     * @private
     */
    ViewProcessor.maybeAddValueEvent_ = function (oldViewCache, newViewCache, accumulator) {
        var eventSnap = newViewCache.getEventCache();
        if (eventSnap.isFullyInitialized()) {
            var isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
            var oldCompleteSnap = oldViewCache.getCompleteEventSnap();
            if (accumulator.length > 0 || !oldViewCache.getEventCache().isFullyInitialized() || isLeafOrEmpty && !eventSnap.getNode().equals /** @type {!Node} */(oldCompleteSnap) || !eventSnap.getNode().getPriority().equals(oldCompleteSnap.getPriority())) {
                accumulator.push(_Change.Change.valueChange(
                /** @type {!Node} */newViewCache.getCompleteEventSnap()));
            }
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} changePath
     * @param {!WriteTreeRef} writesCache
     * @param {!CompleteChildSource} source
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.generateEventCacheAfterServerEvent_ = function (viewCache, changePath, writesCache, source, accumulator) {
        var oldEventSnap = viewCache.getEventCache();
        if (writesCache.shadowingWrite(changePath) != null) {
            // we have a shadowing write, ignore changes
            return viewCache;
        } else {
            var newEventCache = void 0,
                serverNode = void 0;
            if (changePath.isEmpty()) {
                // TODO: figure out how this plays with "sliding ack windows"
                (0, _assert.assert)(viewCache.getServerCache().isFullyInitialized(), 'If change path is empty, we must have complete server data');
                if (viewCache.getServerCache().isFiltered()) {
                    // We need to special case this, because we need to only apply writes to complete children, or
                    // we might end up raising events for incomplete children. If the server data is filtered deep
                    // writes cannot be guaranteed to be complete
                    var serverCache = viewCache.getCompleteServerSnap();
                    var completeChildren = serverCache instanceof _ChildrenNode.ChildrenNode ? serverCache : _ChildrenNode.ChildrenNode.EMPTY_NODE;
                    var completeEventChildren = writesCache.calcCompleteEventChildren(completeChildren);
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeEventChildren, accumulator);
                } else {
                    var completeNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeNode, accumulator);
                }
            } else {
                var childKey = changePath.getFront();
                if (childKey == '.priority') {
                    (0, _assert.assert)(changePath.getLength() == 1, "Can't have a priority with additional path components");
                    var oldEventNode = oldEventSnap.getNode();
                    serverNode = viewCache.getServerCache().getNode();
                    // we might have overwrites for this priority
                    var updatedPriority = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventNode, serverNode);
                    if (updatedPriority != null) {
                        newEventCache = this.filter_.updatePriority(oldEventNode, updatedPriority);
                    } else {
                        // priority didn't change, keep old node
                        newEventCache = oldEventSnap.getNode();
                    }
                } else {
                    var childChangePath = changePath.popFront();
                    // update child
                    var newEventChild = void 0;
                    if (oldEventSnap.isCompleteForChild(childKey)) {
                        serverNode = viewCache.getServerCache().getNode();
                        var eventChildUpdate = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventSnap.getNode(), serverNode);
                        if (eventChildUpdate != null) {
                            newEventChild = oldEventSnap.getNode().getImmediateChild(childKey).updateChild(childChangePath, eventChildUpdate);
                        } else {
                            // Nothing changed, just keep the old child
                            newEventChild = oldEventSnap.getNode().getImmediateChild(childKey);
                        }
                    } else {
                        newEventChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                    }
                    if (newEventChild != null) {
                        newEventCache = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                    } else {
                        // no complete child available or no change
                        newEventCache = oldEventSnap.getNode();
                    }
                }
            }
            return viewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized() || changePath.isEmpty(), this.filter_.filtersNodes());
        }
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyServerOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
        var oldServerSnap = oldViewCache.getServerCache();
        var newServerCache;
        var serverFilter = filterServerNode ? this.filter_ : this.filter_.getIndexedFilter();
        if (changePath.isEmpty()) {
            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
        } else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
            // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
            var newServerNode = oldServerSnap.getNode().updateChild(changePath, changedSnap);
            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
        } else {
            var childKey = changePath.getFront();
            if (!oldServerSnap.isCompleteForPath(changePath) && changePath.getLength() > 1) {
                // We don't update incomplete nodes with updates intended for other listeners
                return oldViewCache;
            }
            var childChangePath = changePath.popFront();
            var childNode = oldServerSnap.getNode().getImmediateChild(childKey);
            var newChildNode = childNode.updateChild(childChangePath, changedSnap);
            if (childKey == '.priority') {
                newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
            } else {
                newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, _CompleteChildSource.NO_COMPLETE_CHILD_SOURCE, null);
            }
        }
        var newViewCache = oldViewCache.updateServerSnap(newServerCache, oldServerSnap.isFullyInitialized() || changePath.isEmpty(), serverFilter.filtersNodes());
        var source = new _CompleteChildSource.WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
        return this.generateEventCacheAfterServerEvent_(newViewCache, changePath, writesCache, source, accumulator);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyUserOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
        var oldEventSnap = oldViewCache.getEventCache();
        var newViewCache, newEventCache;
        var source = new _CompleteChildSource.WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
        if (changePath.isEmpty()) {
            newEventCache = this.filter_.updateFullNode(oldViewCache.getEventCache().getNode(), changedSnap, accumulator);
            newViewCache = oldViewCache.updateEventSnap(newEventCache, true, this.filter_.filtersNodes());
        } else {
            var childKey = changePath.getFront();
            if (childKey === '.priority') {
                newEventCache = this.filter_.updatePriority(oldViewCache.getEventCache().getNode(), changedSnap);
                newViewCache = oldViewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
            } else {
                var childChangePath = changePath.popFront();
                var oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
                var newChild = void 0;
                if (childChangePath.isEmpty()) {
                    // Child overwrite, we can replace the child
                    newChild = changedSnap;
                } else {
                    var childNode = source.getCompleteChild(childKey);
                    if (childNode != null) {
                        if (childChangePath.getBack() === '.priority' && childNode.getChild(childChangePath.parent()).isEmpty()) {
                            // This is a priority update on an empty node. If this node exists on the server, the
                            // server will send down the priority in the update, so ignore for now
                            newChild = childNode;
                        } else {
                            newChild = childNode.updateChild(childChangePath, changedSnap);
                        }
                    } else {
                        // There is no complete child node available
                        newChild = _ChildrenNode.ChildrenNode.EMPTY_NODE;
                    }
                }
                if (!oldChild.equals(newChild)) {
                    var newEventSnap = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                    newViewCache = oldViewCache.updateEventSnap(newEventSnap, oldEventSnap.isFullyInitialized(), this.filter_.filtersNodes());
                } else {
                    newViewCache = oldViewCache;
                }
            }
        }
        return newViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {string} childKey
     * @return {boolean}
     * @private
     */
    ViewProcessor.cacheHasChild_ = function (viewCache, childKey) {
        return viewCache.getEventCache().isCompleteForChild(childKey);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyUserMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
        var _this = this;
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        changedChildren.foreach(function (relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
            }
        });
        changedChildren.foreach(function (relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (!ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
            }
        });
        return curViewCache;
    };
    /**
     * @param {!Node} node
     * @param {ImmutableTree.<!Node>} merge
     * @return {!Node}
     * @private
     */
    ViewProcessor.prototype.applyMerge_ = function (node, merge) {
        merge.foreach(function (relativePath, childNode) {
            node = node.updateChild(relativePath, childNode);
        });
        return node;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyServerMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
        var _this = this;
        // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
        // wait for the complete data update coming soon.
        if (viewCache.getServerCache().getNode().isEmpty() && !viewCache.getServerCache().isFullyInitialized()) {
            return viewCache;
        }
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        var viewMergeTree;
        if (path.isEmpty()) {
            viewMergeTree = changedChildren;
        } else {
            viewMergeTree = _ImmutableTree.ImmutableTree.Empty.setTree(path, changedChildren);
        }
        var serverNode = viewCache.getServerCache().getNode();
        viewMergeTree.children.inorderTraversal(function (childKey, childTree) {
            if (serverNode.hasChild(childKey)) {
                var serverChild = viewCache.getServerCache().getNode().getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new _Path.Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        viewMergeTree.children.inorderTraversal(function (childKey, childMergeTree) {
            var isUnknownDeepMerge = !viewCache.getServerCache().isCompleteForChild(childKey) && childMergeTree.value == null;
            if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
                var serverChild = viewCache.getServerCache().getNode().getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childMergeTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new _Path.Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        return curViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} ackPath
     * @param {!ImmutableTree<!boolean>} affectedTree
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.ackUserWrite_ = function (viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
        if (writesCache.shadowingWrite(ackPath) != null) {
            return viewCache;
        }
        // Only filter server node if it is currently filtered
        var filterServerNode = viewCache.getServerCache().isFiltered();
        // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
        // now that it won't be shadowed.
        var serverCache = viewCache.getServerCache();
        if (affectedTree.value != null) {
            // This is an overwrite.
            if (ackPath.isEmpty() && serverCache.isFullyInitialized() || serverCache.isCompleteForPath(ackPath)) {
                return this.applyServerOverwrite_(viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
            } else if (ackPath.isEmpty()) {
                // This is a goofy edge case where we are acking data at this location but don't have full data.  We
                // should just re-apply whatever we have in our cache as a merge.
                var changedChildren_1 = _ImmutableTree.ImmutableTree.Empty;
                serverCache.getNode().forEachChild(_KeyIndex.KEY_INDEX, function (name, node) {
                    changedChildren_1 = changedChildren_1.set(new _Path.Path(name), node);
                });
                return this.applyServerMerge_(viewCache, ackPath, changedChildren_1, writesCache, completeCache, filterServerNode, accumulator);
            } else {
                return viewCache;
            }
        } else {
            // This is a merge.
            var changedChildren_2 = _ImmutableTree.ImmutableTree.Empty;
            affectedTree.foreach(function (mergePath, value) {
                var serverCachePath = ackPath.child(mergePath);
                if (serverCache.isCompleteForPath(serverCachePath)) {
                    changedChildren_2 = changedChildren_2.set(mergePath, serverCache.getNode().getChild(serverCachePath));
                }
            });
            return this.applyServerMerge_(viewCache, ackPath, changedChildren_2, writesCache, completeCache, filterServerNode, accumulator);
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.listenComplete_ = function (viewCache, path, writesCache, accumulator) {
        var oldServerNode = viewCache.getServerCache();
        var newViewCache = viewCache.updateServerSnap(oldServerNode.getNode(), oldServerNode.isFullyInitialized() || path.isEmpty(), oldServerNode.isFiltered());
        return this.generateEventCacheAfterServerEvent_(newViewCache, path, writesCache, _CompleteChildSource.NO_COMPLETE_CHILD_SOURCE, accumulator);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.revertUserWrite_ = function (viewCache, path, writesCache, completeServerCache, accumulator) {
        var complete;
        if (writesCache.shadowingWrite(path) != null) {
            return viewCache;
        } else {
            var source = new _CompleteChildSource.WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
            var oldEventCache = viewCache.getEventCache().getNode();
            var newEventCache = void 0;
            if (path.isEmpty() || path.getFront() === '.priority') {
                var newNode = void 0;
                if (viewCache.getServerCache().isFullyInitialized()) {
                    newNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                } else {
                    var serverChildren = viewCache.getServerCache().getNode();
                    (0, _assert.assert)(serverChildren instanceof _ChildrenNode.ChildrenNode, 'serverChildren would be complete if leaf node');
                    newNode = writesCache.calcCompleteEventChildren(serverChildren);
                }
                newNode = newNode;
                newEventCache = this.filter_.updateFullNode(oldEventCache, newNode, accumulator);
            } else {
                var childKey = path.getFront();
                var newChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                if (newChild == null && viewCache.getServerCache().isCompleteForChild(childKey)) {
                    newChild = oldEventCache.getImmediateChild(childKey);
                }
                if (newChild != null) {
                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, newChild, path.popFront(), source, accumulator);
                } else if (viewCache.getEventCache().getNode().hasChild(childKey)) {
                    // No complete child available, delete the existing one, if any
                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, _ChildrenNode.ChildrenNode.EMPTY_NODE, path.popFront(), source, accumulator);
                } else {
                    newEventCache = oldEventCache;
                }
                if (newEventCache.isEmpty() && viewCache.getServerCache().isFullyInitialized()) {
                    // We might have reverted all child writes. Maybe the old event was a leaf node
                    complete = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    if (complete.isLeafNode()) {
                        newEventCache = this.filter_.updateFullNode(newEventCache, complete, accumulator);
                    }
                }
            }
            complete = viewCache.getServerCache().isFullyInitialized() || writesCache.shadowingWrite(_Path.Path.Empty) != null;
            return viewCache.updateEventSnap(newEventCache, complete, this.filter_.filtersNodes());
        }
    };
    return ViewProcessor;
}();
exports.ViewProcessor = ViewProcessor;
//# sourceMappingURL=ViewProcessor.js.map


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LimitedFilter = undefined;

var _RangedFilter = __webpack_require__(179);

var _ChildrenNode = __webpack_require__(16);

var _Node = __webpack_require__(19);

var _assert = __webpack_require__(2);

var _Change = __webpack_require__(48);

/**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 *
 * @constructor
 * @implements {NodeFilter}
 */
var LimitedFilter = /** @class */function () {
    /**
     * @param {!QueryParams} params
     */
    function LimitedFilter(params) {
        this.rangedFilter_ = new _RangedFilter.RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
    }
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new _Node.NamedNode(key, newChild))) {
            newChild = _ChildrenNode.ChildrenNode.EMPTY_NODE;
        }
        if (snap.getImmediateChild(key).equals(newChild)) {
            // No change
            return snap;
        } else if (snap.numChildren() < this.limit_) {
            return this.rangedFilter_.getIndexedFilter().updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        } else {
            return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
        }
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        var filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) {
            // Make sure we have a children node with the correct index, not a leaf node;
            filtered = _ChildrenNode.ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        } else {
            if (this.limit_ * 2 < newSnap.numChildren() && newSnap.isIndexed(this.index_)) {
                // Easier to build up a snapshot, since what we're given has more than twice the elements we want
                filtered = _ChildrenNode.ChildrenNode.EMPTY_NODE.withIndex(this.index_);
                // anchor to the startPost, endPost, or last element as appropriate
                var iterator = void 0;
                if (this.reverse_) {
                    iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
                } else {
                    iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
                }
                var count = 0;
                while (iterator.hasNext() && count < this.limit_) {
                    var next = iterator.getNext();
                    var inRange = void 0;
                    if (this.reverse_) {
                        inRange = this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
                    } else {
                        inRange = this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
                    }
                    if (inRange) {
                        filtered = filtered.updateImmediateChild(next.name, next.node);
                        count++;
                    } else {
                        // if we have reached the end post, we cannot keep adding elemments
                        break;
                    }
                }
            } else {
                // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
                filtered = newSnap.withIndex(this.index_);
                // Don't support priorities on queries
                filtered = filtered.updatePriority(_ChildrenNode.ChildrenNode.EMPTY_NODE);
                var startPost = void 0;
                var endPost = void 0;
                var cmp = void 0;
                var iterator = void 0;
                if (this.reverse_) {
                    iterator = filtered.getReverseIterator(this.index_);
                    startPost = this.rangedFilter_.getEndPost();
                    endPost = this.rangedFilter_.getStartPost();
                    var indexCompare_1 = this.index_.getCompare();
                    cmp = function cmp(a, b) {
                        return indexCompare_1(b, a);
                    };
                } else {
                    iterator = filtered.getIterator(this.index_);
                    startPost = this.rangedFilter_.getStartPost();
                    endPost = this.rangedFilter_.getEndPost();
                    cmp = this.index_.getCompare();
                }
                var count = 0;
                var foundStartPost = false;
                while (iterator.hasNext()) {
                    var next = iterator.getNext();
                    if (!foundStartPost && cmp(startPost, next) <= 0) {
                        // start adding
                        foundStartPost = true;
                    }
                    var inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
                    if (inRange) {
                        count++;
                    } else {
                        filtered = filtered.updateImmediateChild(next.name, _ChildrenNode.ChildrenNode.EMPTY_NODE);
                    }
                }
            }
        }
        return this.rangedFilter_.getIndexedFilter().updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.filtersNodes = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.getIndexedFilter = function () {
        return this.rangedFilter_.getIndexedFilter();
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @param {!Node} snap
     * @param {string} childKey
     * @param {!Node} childSnap
     * @param {!CompleteChildSource} source
     * @param {?ChildChangeAccumulator} changeAccumulator
     * @return {!Node}
     * @private
     */
    LimitedFilter.prototype.fullLimitUpdateChild_ = function (snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        var cmp;
        if (this.reverse_) {
            var indexCmp_1 = this.index_.getCompare();
            cmp = function cmp(a, b) {
                return indexCmp_1(b, a);
            };
        } else {
            cmp = this.index_.getCompare();
        }
        var oldEventCache = snap;
        (0, _assert.assert)(oldEventCache.numChildren() == this.limit_, '');
        var newChildNamedNode = new _Node.NamedNode(childKey, childSnap);
        var windowBoundary = this.reverse_ ? oldEventCache.getFirstChild(this.index_) : oldEventCache.getLastChild(this.index_);
        var inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            var oldChildSnap = oldEventCache.getImmediateChild(childKey);
            var nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while (nextChild != null && (nextChild.name == childKey || oldEventCache.hasChild(nextChild.name))) {
                // There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
                // been applied to the limited filter yet. Ignore this next child which will be updated later in
                // the limited filter...
                nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            }
            var compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            var remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(_Change.Change.childChangedChange(childKey, childSnap, oldChildSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            } else {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(_Change.Change.childRemovedChange(childKey, oldChildSnap));
                }
                var newEventCache = oldEventCache.updateImmediateChild(childKey, _ChildrenNode.ChildrenNode.EMPTY_NODE);
                var nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) {
                        changeAccumulator.trackChildChange(_Change.Change.childAddedChange(nextChild.name, nextChild.node));
                    }
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                } else {
                    return newEventCache;
                }
            }
        } else if (childSnap.isEmpty()) {
            // we're deleting a node, but it was not in the window, so ignore it
            return snap;
        } else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(_Change.Change.childRemovedChange(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange(_Change.Change.childAddedChange(childKey, childSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap).updateImmediateChild(windowBoundary.name, _ChildrenNode.ChildrenNode.EMPTY_NODE);
            } else {
                return snap;
            }
        } else {
            return snap;
        }
    };
    return LimitedFilter;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.LimitedFilter = LimitedFilter;
//# sourceMappingURL=LimitedFilter.js.map


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TransportManager = undefined;

var _BrowserPollConnection = __webpack_require__(180);

var _WebSocketConnection = __webpack_require__(182);

var _util = __webpack_require__(3);

/**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 * @constructor
 */
var TransportManager = /** @class */function () {
    /**
     * @param {!RepoInfo} repoInfo Metadata around the namespace we're connecting to
     */
    function TransportManager(repoInfo) {
        this.initTransports_(repoInfo);
    }
    Object.defineProperty(TransportManager, "ALL_TRANSPORTS", {
        /**
         * @const
         * @type {!Array.<function(new:Transport, string, RepoInfo, string=)>}
         */
        get: function get() {
            return [_BrowserPollConnection.BrowserPollConnection, _WebSocketConnection.WebSocketConnection];
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {!RepoInfo} repoInfo
     * @private
     */
    TransportManager.prototype.initTransports_ = function (repoInfo) {
        var isWebSocketsAvailable = _WebSocketConnection.WebSocketConnection && _WebSocketConnection.WebSocketConnection['isAvailable']();
        var isSkipPollConnection = isWebSocketsAvailable && !_WebSocketConnection.WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable) (0, _util.warn)("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) {
            this.transports_ = [_WebSocketConnection.WebSocketConnection];
        } else {
            var transports_1 = this.transports_ = [];
            (0, _util.each)(TransportManager.ALL_TRANSPORTS, function (i, transport) {
                if (transport && transport['isAvailable']()) {
                    transports_1.push(transport);
                }
            });
        }
    };
    /**
     * @return {function(new:Transport, !string, !RepoInfo, string=, string=)} The constructor for the
     * initial transport to use
     */
    TransportManager.prototype.initialTransport = function () {
        if (this.transports_.length > 0) {
            return this.transports_[0];
        } else {
            throw new Error('No transports available');
        }
    };
    /**
     * @return {?function(new:Transport, function(),function(), string=)} The constructor for the next
     * transport, or null
     */
    TransportManager.prototype.upgradeTransport = function () {
        if (this.transports_.length > 1) {
            return this.transports_[1];
        } else {
            return null;
        }
    };
    return TransportManager;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.TransportManager = TransportManager;
//# sourceMappingURL=TransportManager.js.map


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PacketReceiver = undefined;

var _util = __webpack_require__(3);

/**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 * @constructor
 */
var PacketReceiver = /** @class */function () {
    /**
     * @param onMessage_
     */
    function PacketReceiver(onMessage_) {
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    PacketReceiver.prototype.closeAfter = function (responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    };
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     * @param {number} requestNum
     * @param {Array} data
     */
    PacketReceiver.prototype.handleResponse = function (requestNum, data) {
        var _this = this;
        this.pendingResponses[requestNum] = data;
        var _loop_1 = function _loop_1() {
            var toProcess = this_1.pendingResponses[this_1.currentResponseNum];
            delete this_1.pendingResponses[this_1.currentResponseNum];
            var _loop_2 = function _loop_2(i) {
                if (toProcess[i]) {
                    (0, _util.exceptionGuard)(function () {
                        _this.onMessage_(toProcess[i]);
                    });
                }
            };
            for (var i = 0; i < toProcess.length; ++i) {
                _loop_2(i);
            }
            if (this_1.currentResponseNum === this_1.closeAfterResponse) {
                if (this_1.onClose) {
                    this_1.onClose();
                    this_1.onClose = null;
                }
                return "break";
            }
            this_1.currentResponseNum++;
        };
        var this_1 = this;
        while (this.pendingResponses[this.currentResponseNum]) {
            var state_1 = _loop_1();
            if (state_1 === "break") break;
        }
    };
    return PacketReceiver;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.PacketReceiver = PacketReceiver;
//# sourceMappingURL=PacketReceiver.js.map


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
  value: true
});

var _app = __webpack_require__(34);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(375);

__webpack_require__(376);

__webpack_require__(419);

__webpack_require__(412);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Export the single instance of firebase
exports.default = _app2.default; /**
                                  * Copyright 2017 Google Inc.
                                  *
                                  * Licensed under the Apache License, Version 2.0 (the "License");
                                  * you may not use this file except in compliance with the License.
                                  * You may obtain a copy of the License at
                                  *
                                  *   http://www.apache.org/licenses/LICENSE-2.0
                                  *
                                  * Unless required by applicable law or agreed to in writing, software
                                  * distributed under the License is distributed on an "AS IS" BASIS,
                                  * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                  * See the License for the specific language governing permissions and
                                  * limitations under the License.
                                  */

module.exports = exports['default'];
//# sourceMappingURL=firebase-browser.js.map


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.registerMessaging = registerMessaging;

var _windowController = __webpack_require__(414);

var _windowController2 = _interopRequireDefault(_windowController);

var _swController = __webpack_require__(413);

var _swController2 = _interopRequireDefault(_swController);

var _app = __webpack_require__(34);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function registerMessaging(instance) {
    var messagingName = 'messaging';
    var factoryMethod = function factoryMethod(app) {
        if (self && 'ServiceWorkerGlobalScope' in self) {
            return new _swController2.default(app);
        }
        // Assume we are in the window context.
        return new _windowController2.default(app);
    };
    var namespaceExports = {
        // no-inline
        Messaging: _windowController2.default
    };
    instance.INTERNAL.registerService(messagingName, factoryMethod, namespaceExports);
}
registerMessaging(_app2.default);
//# sourceMappingURL=messaging.js.map


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _controllerInterface = __webpack_require__(183);

var _controllerInterface2 = _interopRequireDefault(_controllerInterface);

var _errors = __webpack_require__(83);

var _errors2 = _interopRequireDefault(_errors);

var _workerPageMessage = __webpack_require__(186);

var _workerPageMessage2 = _interopRequireDefault(_workerPageMessage);

var _fcmDetails = __webpack_require__(184);

var _fcmDetails2 = _interopRequireDefault(_fcmDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();

var FCM_MSG = 'FCM_MSG';
var SWController = /** @class */function (_super) {
    __extends(SWController, _super);
    function SWController(app) {
        var _this = _super.call(this, app) || this;
        self.addEventListener('push', function (e) {
            return _this.onPush_(e);
        }, false);
        self.addEventListener('pushsubscriptionchange', function (e) {
            return _this.onSubChange_(e);
        }, false);
        self.addEventListener('notificationclick', function (e) {
            return _this.onNotificationClick_(e);
        }, false);
        /**
         * @private
         * @type {function(Object)|null}
         */
        _this.bgMessageHandler_ = null;
        return _this;
    }
    /**
    * A handler for push events that shows notifications based on the content of
    * the payload.
    *
    * The payload must be a JSON-encoded Object with a `notification` key. The
    * value of the `notification` property will be used as the NotificationOptions
    * object passed to showNotification. Additionally, the `title` property of the
    * notification object will be used as the title.
    *
    * If there is no notification data in the payload then no notification will be
    * shown.
    * @private
    */
    SWController.prototype.onPush_ = function (event) {
        var _this = this;
        var msgPayload;
        try {
            msgPayload = event.data.json();
        } catch (err) {
            // Not JSON so not an FCM message
            return;
        }
        var handleMsgPromise = this.hasVisibleClients_().then(function (hasVisibleClients) {
            if (hasVisibleClients) {
                // Do not need to show a notification.
                if (msgPayload.notification || _this.bgMessageHandler_) {
                    // Send to page
                    return _this.sendMessageToWindowClients_(msgPayload);
                }
                return;
            }
            var notificationDetails = _this.getNotificationData_(msgPayload);
            if (notificationDetails) {
                var notificationTitle = notificationDetails.title || '';
                return self.registration.showNotification(notificationTitle, notificationDetails);
            } else if (_this.bgMessageHandler_) {
                return _this.bgMessageHandler_(msgPayload);
            }
        });
        event.waitUntil(handleMsgPromise);
    };
    /**
    * @private
    */
    SWController.prototype.onSubChange_ = function (event) {
        var _this = this;
        var promiseChain = this.getToken().then(function (token) {
            if (!token) {
                // We can't resubscribe if we don't have an FCM token for this scope.
                throw _this.errorFactory_.create(_errors2.default.codes.NO_FCM_TOKEN_FOR_RESUBSCRIBE);
            }
            var tokenDetails = null;
            var tokenManager = _this.getTokenManager();
            return tokenManager.getTokenDetailsFromToken(token).then(function (details) {
                tokenDetails = details;
                if (!tokenDetails) {
                    throw _this.errorFactory_.create(_errors2.default.codes.INVALID_SAVED_TOKEN);
                }
                // Attempt to get a new subscription
                return self.registration.pushManager.subscribe(_fcmDetails2.default.SUBSCRIPTION_OPTIONS);
            }).then(function (newSubscription) {
                // Send new subscription to FCM.
                return tokenManager.subscribeToFCM(tokenDetails.fcmSenderId, newSubscription, tokenDetails.fcmPushSet);
            }).catch(function (err) {
                // The best thing we can do is log this to the terminal so
                // developers might notice the error.
                return tokenManager.deleteToken(tokenDetails.fcmToken).then(function () {
                    throw _this.errorFactory_.create(_errors2.default.codes.UNABLE_TO_RESUBSCRIBE, {
                        message: err
                    });
                });
            });
        });
        event.waitUntil(promiseChain);
    };
    /**
    * @private
    */
    SWController.prototype.onNotificationClick_ = function (event) {
        var _this = this;
        if (!(event.notification && event.notification.data && event.notification.data[FCM_MSG])) {
            // Not an FCM notification, do nothing.
            return;
        }
        // Prevent other listeners from receiving the event
        event.stopImmediatePropagation();
        event.notification.close();
        var msgPayload = event.notification.data[FCM_MSG];
        var clickAction = msgPayload['notification']['click_action'];
        if (!clickAction) {
            // Nothing to do.
            return;
        }
        var promiseChain = this.getWindowClient_(clickAction).then(function (windowClient) {
            if (!windowClient) {
                // Unable to find window client so need to open one.
                return self.clients.openWindow(clickAction);
            }
            return windowClient;
        }).then(function (windowClient) {
            if (!windowClient) {
                // Window Client will not be returned if it's for a third party origin.
                return;
            }
            // Delete notification data from payload before sending to the page.
            var notificationData = msgPayload['notification'];
            delete msgPayload['notification'];
            var internalMsg = _workerPageMessage2.default.createNewMsg(_workerPageMessage2.default.TYPES_OF_MSG.NOTIFICATION_CLICKED, msgPayload);
            // Attempt to send a message to the client to handle the data
            // Is affected by: https://github.com/slightlyoff/ServiceWorker/issues/728
            return _this.attemptToMessageClient_(windowClient, internalMsg);
        });
        event.waitUntil(promiseChain);
    };
    /**
     * @private
     * @param {Object} msgPayload
     * @return {NotificationOptions|undefined}
     */
    SWController.prototype.getNotificationData_ = function (msgPayload) {
        if (!msgPayload) {
            return;
        }
        if (_typeof(msgPayload.notification) !== 'object') {
            return;
        }
        var notificationInformation = Object.assign({}, msgPayload.notification);
        // Put the message payload under FCM_MSG name so we can identify the
        // notification as being an FCM notification vs a notification from
        // somewhere else (i.e. normal web push or developer generated
        // notification).
        notificationInformation['data'] = (_a = {}, _a[FCM_MSG] = msgPayload, _a);
        return notificationInformation;
        var _a;
    };
    /**
     * Calling setBackgroundMessageHandler will opt in to some specific
     * behaviours.
     * 1.) If a notification doesn't need to be shown due to a window already
     * being visible, then push messages will be sent to the page.
     * 2.) If a notification needs to be shown, and the message contains no
     * notification data this method will be called
     * and the promise it returns will be passed to event.waitUntil.
     * If you do not set this callback then all push messages will let and the
     * developer can handle them in a their own 'push' event callback
     * @export
     * @param {function(Object)} callback The callback to be called when a push
     * message is received and a notification must be shown. The callback will
     * be given the data from the push message.
     */
    SWController.prototype.setBackgroundMessageHandler = function (callback) {
        if (callback && typeof callback !== 'function') {
            throw this.errorFactory_.create(_errors2.default.codes.BG_HANDLER_FUNCTION_EXPECTED);
        }
        this.bgMessageHandler_ = callback;
    };
    /**
     * @private
     * @param {string} url The URL to look for when focusing a client.
     * @return {Object} Returns an existing window client or a newly opened
     * WindowClient.
     */
    SWController.prototype.getWindowClient_ = function (url) {
        // Use URL to normalize the URL when comparing to windowClients.
        // This at least handles whether to include trailing slashes or not
        var parsedURL = new URL(url).href;
        return self.clients.matchAll({
            type: 'window',
            includeUncontrolled: true
        }).then(function (clientList) {
            var suitableClient = null;
            for (var i = 0; i < clientList.length; i++) {
                var parsedClientUrl = new URL(clientList[i].url).href;
                if (parsedClientUrl === parsedURL) {
                    suitableClient = clientList[i];
                    break;
                }
            }
            if (suitableClient) {
                suitableClient.focus();
                return suitableClient;
            }
        });
    };
    /**
     * This message will attempt to send the message to a window client.
     * @private
     * @param {Object} client The WindowClient to send the message to.
     * @param {Object} message The message to send to the client.
     * @returns {Promise} Returns a promise that resolves after sending the
     * message. This does not guarantee that the message was successfully
     * received.
     */
    SWController.prototype.attemptToMessageClient_ = function (client, message) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!client) {
                return reject(_this.errorFactory_.create(_errors2.default.codes.NO_WINDOW_CLIENT_TO_MSG));
            }
            client.postMessage(message);
            resolve();
        });
    };
    /**
     * @private
     * @returns {Promise<boolean>} If there is currently a visible WindowClient,
     * this method will resolve to true, otherwise false.
     */
    SWController.prototype.hasVisibleClients_ = function () {
        return self.clients.matchAll({
            type: 'window',
            includeUncontrolled: true
        }).then(function (clientList) {
            return clientList.some(function (client) {
                return client.visibilityState === 'visible';
            });
        });
    };
    /**
     * @private
     * @param {Object} msgPayload The data from the push event that should be sent
     * to all available pages.
     * @returns {Promise} Returns a promise that resolves once the message
     * has been sent to all WindowClients.
     */
    SWController.prototype.sendMessageToWindowClients_ = function (msgPayload) {
        var _this = this;
        return self.clients.matchAll({
            type: 'window',
            includeUncontrolled: true
        }).then(function (clientList) {
            var internalMsg = _workerPageMessage2.default.createNewMsg(_workerPageMessage2.default.TYPES_OF_MSG.PUSH_MSG_RECEIVED, msgPayload);
            return Promise.all(clientList.map(function (client) {
                return _this.attemptToMessageClient_(client, internalMsg);
            }));
        });
    };
    /**
     * This will register the default service worker and return the registration.
     * @private
     * @return {Promise<!ServiceWorkerRegistration>} The service worker
     * registration to be used for the push service.
     */
    SWController.prototype.getSWRegistration_ = function () {
        return Promise.resolve(self.registration);
    };
    return SWController;
}(_controllerInterface2.default);
exports.default = SWController;
module.exports = exports['default'];
//# sourceMappingURL=sw-controller.js.map


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _controllerInterface = __webpack_require__(183);

var _controllerInterface2 = _interopRequireDefault(_controllerInterface);

var _errors = __webpack_require__(83);

var _errors2 = _interopRequireDefault(_errors);

var _workerPageMessage = __webpack_require__(186);

var _workerPageMessage2 = _interopRequireDefault(_workerPageMessage);

var _defaultSw = __webpack_require__(416);

var _defaultSw2 = _interopRequireDefault(_defaultSw);

var _notificationPermission = __webpack_require__(185);

var _notificationPermission2 = _interopRequireDefault(_notificationPermission);

var _subscribe = __webpack_require__(157);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();

var WindowController = /** @class */function (_super) {
    __extends(WindowController, _super);
    /**
     * A service that provides a MessagingService instance.
     * @param {!firebase.app.App} app
     */
    function WindowController(app) {
        var _this = _super.call(this, app) || this;
        /**
         * @private
         * @type {ServiceWorkerRegistration}
         */
        _this.registrationToUse_;
        /**
         * @private
         * @type {Promise}
         */
        _this.manifestCheckPromise_;
        /**
         * @private
         * @type {firebase.Observer}
         */
        _this.messageObserver_ = null;
        /**
         * @private {!firebase.Subscribe} The subscribe function to the onMessage
         * observer.
         */
        _this.onMessage_ = (0, _subscribe.createSubscribe)(function (observer) {
            _this.messageObserver_ = observer;
        });
        /**
         * @private
         * @type {firebase.Observer}
         */
        _this.tokenRefreshObserver_ = null;
        _this.onTokenRefresh_ = (0, _subscribe.createSubscribe)(function (observer) {
            _this.tokenRefreshObserver_ = observer;
        });
        _this.setupSWMessageListener_();
        return _this;
    }
    /**
     * This method returns an FCM token if it can be generated.
     * The return promise will reject if the browser doesn't support
     * FCM, if permission is denied for notifications or it's not
     * possible to generate a token.
     * @export
     * @return {Promise<string> | Promise<null>} Returns a promise the
     * resolves to an FCM token or null if permission isn't granted.
     */
    WindowController.prototype.getToken = function () {
        var _this = this;
        // Check that the required API's are available
        if (!this.isSupported_()) {
            return Promise.reject(this.errorFactory_.create(_errors2.default.codes.UNSUPPORTED_BROWSER));
        }
        return this.manifestCheck_().then(function () {
            return _super.prototype.getToken.call(_this);
        });
    };
    /**
     * The method checks that a manifest is defined and has the correct GCM
     * sender ID.
     * @private
     * @return {Promise} Returns a promise that resolves if the manifest matches
     * our required sender ID
     */
    WindowController.prototype.manifestCheck_ = function () {
        var _this = this;
        if (this.manifestCheckPromise_) {
            return this.manifestCheckPromise_;
        }
        var manifestTag = document.querySelector('link[rel="manifest"]');
        if (!manifestTag) {
            this.manifestCheckPromise_ = Promise.resolve();
        } else {
            this.manifestCheckPromise_ = fetch(manifestTag.href).then(function (response) {
                return response.json();
            }).catch(function () {
                // If the download or parsing fails allow check.
                // We only want to error if we KNOW that the gcm_sender_id is incorrect.
                return Promise.resolve();
            }).then(function (manifestContent) {
                if (!manifestContent) {
                    return;
                }
                if (!manifestContent['gcm_sender_id']) {
                    return;
                }
                if (manifestContent['gcm_sender_id'] !== '103953800507') {
                    throw _this.errorFactory_.create(_errors2.default.codes.INCORRECT_GCM_SENDER_ID);
                }
            });
        }
        return this.manifestCheckPromise_;
    };
    /**
     * Request permission if it is not currently granted
     * @export
     * @returns {Promise} Resolves if the permission was granted, otherwise
     * rejects
     */
    WindowController.prototype.requestPermission = function () {
        var _this = this;
        if (Notification.permission === _notificationPermission2.default.granted) {
            return Promise.resolve();
        }
        return new Promise(function (resolve, reject) {
            var managePermissionResult = function managePermissionResult(result) {
                if (result === _notificationPermission2.default.granted) {
                    return resolve();
                } else if (result === _notificationPermission2.default.denied) {
                    return reject(_this.errorFactory_.create(_errors2.default.codes.PERMISSION_BLOCKED));
                } else {
                    return reject(_this.errorFactory_.create(_errors2.default.codes.PERMISSION_DEFAULT));
                }
            };
            // The Notification.requestPermission API was changed to
            // return a promise so now have to handle both in case
            // browsers stop support callbacks for promised version
            var permissionPromise = Notification.requestPermission(function (result) {
                if (permissionPromise) {
                    // Let the promise manage this
                    return;
                }
                managePermissionResult(result);
            });
            if (permissionPromise) {
                // Prefer the promise version as it's the future API.
                permissionPromise.then(managePermissionResult);
            }
        });
    };
    /**
     * This method allows a developer to override the default service worker and
     * instead use a custom service worker.
     * @export
     * @param {!ServiceWorkerRegistration} registration The service worker
     * registration that should be used to receive the push messages.
     */
    WindowController.prototype.useServiceWorker = function (registration) {
        if (!(registration instanceof ServiceWorkerRegistration)) {
            throw this.errorFactory_.create(_errors2.default.codes.SW_REGISTRATION_EXPECTED);
        }
        if (typeof this.registrationToUse_ !== 'undefined') {
            throw this.errorFactory_.create(_errors2.default.codes.USE_SW_BEFORE_GET_TOKEN);
        }
        this.registrationToUse_ = registration;
    };
    /**
     * @export
     * @param {!firebase.Observer|function(*)} nextOrObserver An observer object
     * or a function triggered on message.
     * @param {function(!Error)=} optError Optional A function triggered on
     * message error.
     * @param {function()=} optCompleted Optional function triggered when the
     * observer is removed.
     * @return {!function()} The unsubscribe function for the observer.
     */
    WindowController.prototype.onMessage = function (nextOrObserver, optError, optCompleted) {
        return this.onMessage_(nextOrObserver, optError, optCompleted);
    };
    /**
     * @export
     * @param {!firebase.Observer|function()} nextOrObserver An observer object
     * or a function triggered on token refresh.
     * @param {function(!Error)=} optError Optional A function
     * triggered on token refresh error.
     * @param {function()=} optCompleted Optional function triggered when the
     * observer is removed.
     * @return {!function()} The unsubscribe function for the observer.
     */
    WindowController.prototype.onTokenRefresh = function (nextOrObserver, optError, optCompleted) {
        return this.onTokenRefresh_(nextOrObserver, optError, optCompleted);
    };
    /**
     * Given a registration, wait for the service worker it relates to
     * become activer
     * @private
     * @param  {ServiceWorkerRegistration} registration Registration to wait
     * for service worker to become active
     * @return {Promise<!ServiceWorkerRegistration>} Wait for service worker
     * registration to become active
     */
    WindowController.prototype.waitForRegistrationToActivate_ = function (registration) {
        var _this = this;
        var serviceWorker = registration.installing || registration.waiting || registration.active;
        return new Promise(function (resolve, reject) {
            if (!serviceWorker) {
                // This is a rare scenario but has occured in firefox
                reject(_this.errorFactory_.create(_errors2.default.codes.NO_SW_IN_REG));
                return;
            }
            // Because the Promise function is called on next tick there is a
            // small chance that the worker became active or redundant already.
            if (serviceWorker.state === 'activated') {
                resolve(registration);
                return;
            }
            if (serviceWorker.state === 'redundant') {
                reject(_this.errorFactory_.create(_errors2.default.codes.SW_REG_REDUNDANT));
                return;
            }
            var stateChangeListener = function stateChangeListener() {
                if (serviceWorker.state === 'activated') {
                    resolve(registration);
                } else if (serviceWorker.state === 'redundant') {
                    reject(_this.errorFactory_.create(_errors2.default.codes.SW_REG_REDUNDANT));
                } else {
                    // Return early and wait to next state change
                    return;
                }
                serviceWorker.removeEventListener('statechange', stateChangeListener);
            };
            serviceWorker.addEventListener('statechange', stateChangeListener);
        });
    };
    /**
     * This will regiater the default service worker and return the registration
     * @private
     * @return {Promise<!ServiceWorkerRegistration>} The service worker
     * registration to be used for the push service.
     */
    WindowController.prototype.getSWRegistration_ = function () {
        var _this = this;
        if (this.registrationToUse_) {
            return this.waitForRegistrationToActivate_(this.registrationToUse_);
        }
        // Make the registration null so we know useServiceWorker will not
        // use a new service worker as registrationToUse_ is no longer undefined
        this.registrationToUse_ = null;
        return navigator.serviceWorker.register(_defaultSw2.default.path, {
            scope: _defaultSw2.default.scope
        }).catch(function (err) {
            throw _this.errorFactory_.create(_errors2.default.codes.FAILED_DEFAULT_REGISTRATION, {
                browserErrorMessage: err.message
            });
        }).then(function (registration) {
            return _this.waitForRegistrationToActivate_(registration).then(function () {
                _this.registrationToUse_ = registration;
                // We update after activation due to an issue with Firefox v49 where
                // a race condition occassionally causes the service work to not
                // install
                registration.update();
                return registration;
            });
        });
    };
    /**
     * This method will set up a message listener to handle
     * events from the service worker that should trigger
     * events in the page.
     *
     * @private
     */
    WindowController.prototype.setupSWMessageListener_ = function () {
        var _this = this;
        if (!('serviceWorker' in navigator)) {
            return;
        }
        navigator.serviceWorker.addEventListener('message', function (event) {
            if (!event.data || !event.data[_workerPageMessage2.default.PARAMS.TYPE_OF_MSG]) {
                // Not a message from FCM
                return;
            }
            var workerPageMessage = event.data;
            switch (workerPageMessage[_workerPageMessage2.default.PARAMS.TYPE_OF_MSG]) {
                case _workerPageMessage2.default.TYPES_OF_MSG.PUSH_MSG_RECEIVED:
                case _workerPageMessage2.default.TYPES_OF_MSG.NOTIFICATION_CLICKED:
                    var pushMessage = workerPageMessage[_workerPageMessage2.default.PARAMS.DATA];
                    _this.messageObserver_.next(pushMessage);
                    break;
                default:
                    // Noop.
                    break;
            }
        }, false);
    };
    /**
     * Checks to see if the required API's are valid or not.
     * @private
     * @return {boolean} Returns true if the desired APIs are available.
     */
    WindowController.prototype.isSupported_ = function () {
        return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window && 'fetch' in window && ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') && PushSubscription.prototype.hasOwnProperty('getKey');
    };
    return WindowController;
}(_controllerInterface2.default);
exports.default = WindowController;
module.exports = exports['default'];
//# sourceMappingURL=window-controller.js.map


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (arrayBuffer) {
    var base64String = toBase64(arrayBuffer);
    return base64String.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function toBase64(arrayBuffer) {
    var uint8Version = new Uint8Array(arrayBuffer);
    return window.btoa(String.fromCharCode.apply(null, uint8Version));
}
;
module.exports = exports['default'];
//# sourceMappingURL=array-buffer-to-base64.js.map


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  path: '/firebase-messaging-sw.js',
  scope: '/firebase-cloud-messaging-push-scope'
};
module.exports = exports['default'];
//# sourceMappingURL=default-sw.js.map


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _errors = __webpack_require__(103);

var _errors2 = __webpack_require__(83);

var _errors3 = _interopRequireDefault(_errors2);

var _arrayBufferToBase = __webpack_require__(415);

var _arrayBufferToBase2 = _interopRequireDefault(_arrayBufferToBase);

var _fcmDetails = __webpack_require__(184);

var _fcmDetails2 = _interopRequireDefault(_fcmDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FCM_TOKEN_DETAILS_DB = 'fcm_token_details_db';
var FCM_TOKEN_OBJ_STORE = 'fcm_token_object_Store';
var FCM_TOKEN_DETAILS_DB_VERSION = 1;
var TokenManager = /** @class */function () {
    function TokenManager() {
        this.errorFactory_ = new _errors.ErrorFactory('messaging', 'Messaging', _errors3.default.map);
        this.openDbPromise_ = null;
    }
    /**
     * Get the indexedDB as a promsie.
     * @private
     * @return {Promise<IDBDatabase>} The IndexedDB database
     */
    TokenManager.prototype.openDatabase_ = function () {
        if (this.openDbPromise_) {
            return this.openDbPromise_;
        }
        this.openDbPromise_ = new Promise(function (resolve, reject) {
            var request = indexedDB.open(FCM_TOKEN_DETAILS_DB, FCM_TOKEN_DETAILS_DB_VERSION);
            request.onerror = function (event) {
                reject(event.target.error);
            };
            request.onsuccess = function (event) {
                resolve(event.target.result);
            };
            request.onupgradeneeded = function (event) {
                var db = event.target.result;
                var objectStore = db.createObjectStore(FCM_TOKEN_OBJ_STORE, {
                    keyPath: 'swScope'
                });
                // Make sure the sender ID can be searched
                objectStore.createIndex('fcmSenderId', 'fcmSenderId', {
                    unique: false
                });
                objectStore.createIndex('fcmToken', 'fcmToken', {
                    unique: true
                });
            };
        });
        return this.openDbPromise_;
    };
    /**
     * Close the currently open database.
     * @return {Promise<?>} Returns the result of the promise chain.
     */
    TokenManager.prototype.closeDatabase = function () {
        var _this = this;
        if (this.openDbPromise_) {
            return this.openDbPromise_.then(function (db) {
                db.close();
                _this.openDbPromise_ = null;
            });
        }
        return Promise.resolve();
    };
    /**
     * Given a token, this method will look up the details in indexedDB.
     * @public
     * @param {string} fcmToken
     * @return {Promise<Object>} The details associated with that token.
     */
    TokenManager.prototype.getTokenDetailsFromToken = function (fcmToken) {
        return this.openDatabase_().then(function (db) {
            return new Promise(function (resolve, reject) {
                var transaction = db.transaction([FCM_TOKEN_OBJ_STORE]);
                var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
                var index = objectStore.index('fcmToken');
                var request = index.get(fcmToken);
                request.onerror = function (event) {
                    reject(event.target.error);
                };
                request.onsuccess = function (event) {
                    resolve(event.target.result);
                };
            });
        });
    };
    TokenManager.prototype.getTokenDetailsFromSWScope_ = function (swScope) {
        return this.openDatabase_().then(function (db) {
            return new Promise(function (resolve, reject) {
                var transaction = db.transaction([FCM_TOKEN_OBJ_STORE]);
                var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
                var scopeRequest = objectStore.get(swScope);
                scopeRequest.onerror = function (event) {
                    reject(event.target.error);
                };
                scopeRequest.onsuccess = function (event) {
                    resolve(event.target.result);
                };
            });
        });
    };
    TokenManager.prototype.getAllTokenDetailsForSenderId_ = function (senderId) {
        return this.openDatabase_().then(function (db) {
            return new Promise(function (resolve, reject) {
                var transaction = db.transaction([FCM_TOKEN_OBJ_STORE]);
                var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
                var senderIdTokens = [];
                var cursorRequest = objectStore.openCursor();
                cursorRequest.onerror = function (event) {
                    reject(event.target.error);
                };
                cursorRequest.onsuccess = function (event) {
                    var cursor = event.target.result;
                    if (cursor) {
                        if (cursor.value['fcmSenderId'] === senderId) {
                            senderIdTokens.push(cursor.value);
                        }
                        cursor.continue();
                    } else {
                        resolve(senderIdTokens);
                    }
                };
            });
        });
    };
    /**
     * Given a PushSubscription and messagingSenderId, get an FCM token.
     * @public
     * @param  {string} senderId The 'messagingSenderId' to tie the token to.
     * @param  {PushSubscription} subscription The PushSusbcription to "federate".
     * @param  {string=} pushSet If defined this will swap the subscription for
     * matching FCM token.
     * @return {Promise<!Object>} Returns the FCM token to be used in place
     * of the PushSubscription.
     */
    TokenManager.prototype.subscribeToFCM = function (senderId, subscription, pushSet) {
        var _this = this;
        var p256dh = (0, _arrayBufferToBase2.default)(subscription['getKey']('p256dh'));
        var auth = (0, _arrayBufferToBase2.default)(subscription['getKey']('auth'));
        var fcmSubscribeBody = "authorized_entity=" + senderId + "&" + ("endpoint=" + subscription.endpoint + "&") + ("encryption_key=" + p256dh + "&") + ("encryption_auth=" + auth);
        if (pushSet) {
            fcmSubscribeBody += "&pushSet=" + pushSet;
        }
        var headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        var subscribeOptions = {
            method: 'POST',
            headers: headers,
            body: fcmSubscribeBody
        };
        return fetch(_fcmDetails2.default.ENDPOINT + '/fcm/connect/subscribe', subscribeOptions).then(function (response) {
            return response.json();
        }).then(function (response) {
            var fcmTokenResponse = response;
            if (fcmTokenResponse['error']) {
                var message = fcmTokenResponse['error']['message'];
                throw _this.errorFactory_.create(_errors3.default.codes.TOKEN_SUBSCRIBE_FAILED, {
                    message: message
                });
            }
            if (!fcmTokenResponse['token']) {
                throw _this.errorFactory_.create(_errors3.default.codes.TOKEN_SUBSCRIBE_NO_TOKEN);
            }
            if (!fcmTokenResponse['pushSet']) {
                throw _this.errorFactory_.create(_errors3.default.codes.TOKEN_SUBSCRIBE_NO_PUSH_SET);
            }
            return {
                token: fcmTokenResponse['token'],
                pushSet: fcmTokenResponse['pushSet']
            };
        });
    };
    /**
     * Checks the that fields in the PushSubscription are equivalent to the
     * details stores in the masterTokenDetails.
     * @private
     * @param  {PushSubscription} subscription The push subscription we expect
     * the master token to match.
     * @param  {Object}  masterTokenDetails The saved details we wish to compare
     * with the PushSubscription
     * @return {boolean} true if the subscription and token details are
     * equivalent.
     */
    TokenManager.prototype.isSameSubscription_ = function (subscription, masterTokenDetails) {
        // getKey() isn't defined in the PushSubscription externs file, hence
        // subscription['getKey']('<key name>').
        return subscription.endpoint === masterTokenDetails['endpoint'] && (0, _arrayBufferToBase2.default)(subscription['getKey']('auth')) === masterTokenDetails['auth'] && (0, _arrayBufferToBase2.default)(subscription['getKey']('p256dh')) === masterTokenDetails['p256dh'];
    };
    /**
     * Save the details for the fcm token for re-use at a later date.
     * @private
     * @param  {string} senderId The 'messagingSenderId' used for this project
     * @param  {ServiceWorkerRegistration} swRegistration The service worker
     * used to subscribe the user for web push
     * @param  {PushSubscription} subscription The push subscription passed to
     * FCM for the current token.
     * @param  {string} fcmToken The FCM token currently used on this
     * device.
     * @param  {string} fcmPushSet The FCM push tied to the fcm token.
     * @return {Promise<void>}
     */
    TokenManager.prototype.saveTokenDetails_ = function (senderId, swRegistration, subscription, fcmToken, fcmPushSet) {
        var details = {
            swScope: swRegistration.scope,
            endpoint: subscription.endpoint,
            auth: (0, _arrayBufferToBase2.default)(subscription['getKey']('auth')),
            p256dh: (0, _arrayBufferToBase2.default)(subscription['getKey']('p256dh')),
            fcmToken: fcmToken,
            fcmPushSet: fcmPushSet,
            fcmSenderId: senderId
        };
        return this.openDatabase_().then(function (db) {
            return new Promise(function (resolve, reject) {
                var transaction = db.transaction([FCM_TOKEN_OBJ_STORE], 'readwrite');
                var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
                var request = objectStore.put(details);
                request.onerror = function (event) {
                    reject(event.target.error);
                };
                request.onsuccess = function (event) {
                    resolve();
                };
            });
        });
    };
    /**
     * Returns the saved FCM Token if one is available and still valid,
     * otherwise `null` is returned.
     * @param {string} senderId This should be the sender ID associated with the
     * FCM Token being retrieved.
     * @param {ServiceWorkerRegistration} swRegistration Registration to be used
     * to subscribe the user to push.
     * @return {Promise<string> | Promise} Returns the saved FCM Token if
     * avilable and valid.
     * @export
     */
    TokenManager.prototype.getSavedToken = function (senderId, swRegistration) {
        var _this = this;
        if (!(swRegistration instanceof ServiceWorkerRegistration)) {
            return Promise.reject(this.errorFactory_.create(_errors3.default.codes.SW_REGISTRATION_EXPECTED));
        }
        if (typeof senderId !== 'string' || senderId.length === 0) {
            return Promise.reject(this.errorFactory_.create(_errors3.default.codes.BAD_SENDER_ID));
        }
        return this.getAllTokenDetailsForSenderId_(senderId).then(function (allTokenDetails) {
            if (allTokenDetails.length === 0) {
                return;
            }
            var index = allTokenDetails.findIndex(function (tokenDetails) {
                return swRegistration.scope === tokenDetails['swScope'] && senderId === tokenDetails['fcmSenderId'];
            });
            if (index === -1) {
                return;
            }
            return allTokenDetails[index];
        }).then(function (tokenDetails) {
            if (!tokenDetails) {
                return;
            }
            return swRegistration.pushManager.getSubscription().catch(function (err) {
                throw _this.errorFactory_.create(_errors3.default.codes.GET_SUBSCRIPTION_FAILED);
            }).then(function (subscription) {
                if (subscription && _this.isSameSubscription_(subscription, tokenDetails)) {
                    return tokenDetails['fcmToken'];
                }
            });
        });
    };
    /**
     * Creates a new FCM token.
     */
    TokenManager.prototype.createToken = function (senderId, swRegistration) {
        var _this = this;
        if (typeof senderId !== 'string' || senderId.length === 0) {
            return Promise.reject(this.errorFactory_.create(_errors3.default.codes.BAD_SENDER_ID));
        }
        if (!(swRegistration instanceof ServiceWorkerRegistration)) {
            return Promise.reject(this.errorFactory_.create(_errors3.default.codes.SW_REGISTRATION_EXPECTED));
        }
        // Check for existing subscription first
        var subscription;
        var fcmTokenDetails;
        return swRegistration.pushManager.getSubscription().then(function (subscription) {
            if (subscription) {
                return subscription;
            }
            return swRegistration.pushManager.subscribe(_fcmDetails2.default.SUBSCRIPTION_OPTIONS);
        }).then(function (sub) {
            subscription = sub;
            return _this.subscribeToFCM(senderId, subscription);
        }).then(function (tokenDetails) {
            fcmTokenDetails = tokenDetails;
            return _this.saveTokenDetails_(senderId, swRegistration, subscription, fcmTokenDetails['token'], fcmTokenDetails['pushSet']);
        }).then(function () {
            return fcmTokenDetails['token'];
        });
    };
    /**
     * This method deletes details of the current FCM token.
     * It's returning a promise in case we need to move to an async
     * method for deleting at a later date.
     * @param {string} token Token to be deleted
     * @return {Promise<Object>} Resolves once the FCM token details have been
     * deleted and returns the deleted details.
     */
    TokenManager.prototype.deleteToken = function (token) {
        var _this = this;
        if (typeof token !== 'string' || token.length === 0) {
            return Promise.reject(this.errorFactory_.create(_errors3.default.codes.INVALID_DELETE_TOKEN));
        }
        return this.getTokenDetailsFromToken(token).then(function (details) {
            if (!details) {
                throw _this.errorFactory_.create(_errors3.default.codes.DELETE_TOKEN_NOT_FOUND);
            }
            return _this.openDatabase_().then(function (db) {
                return new Promise(function (resolve, reject) {
                    var transaction = db.transaction([FCM_TOKEN_OBJ_STORE], 'readwrite');
                    var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
                    var request = objectStore.delete(details['swScope']);
                    request.onerror = function (event) {
                        reject(event.target.error);
                    };
                    request.onsuccess = function (event) {
                        if (event.target.result === 0) {
                            reject(_this.errorFactory_.create(_errors3.default.codes.FAILED_TO_DELETE_TOKEN));
                            return;
                        }
                        resolve(details);
                    };
                });
            });
        });
    };
    return TokenManager;
}();
exports.default = TokenManager;
module.exports = exports['default'];
//# sourceMappingURL=token-manager.js.map


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {(function (root) {

  // Store setTimeout reference so promise-polyfill will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var setTimeoutFunc = setTimeout;

  function noop() {}
  
  // Polyfill for Function.prototype.bind
  function bind(fn, thisArg) {
    return function () {
      fn.apply(thisArg, arguments);
    };
  }

  function Promise(fn) {
    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    this._state = 0;
    this._handled = false;
    this._value = undefined;
    this._deferreds = [];

    doResolve(fn, this);
  }

  function handle(self, deferred) {
    while (self._state === 3) {
      self = self._value;
    }
    if (self._state === 0) {
      self._deferreds.push(deferred);
      return;
    }
    self._handled = true;
    Promise._immediateFn(function () {
      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
      if (cb === null) {
        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
        return;
      }
      var ret;
      try {
        ret = cb(self._value);
      } catch (e) {
        reject(deferred.promise, e);
        return;
      }
      resolve(deferred.promise, ret);
    });
  }

  function resolve(self, newValue) {
    try {
      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
        var then = newValue.then;
        if (newValue instanceof Promise) {
          self._state = 3;
          self._value = newValue;
          finale(self);
          return;
        } else if (typeof then === 'function') {
          doResolve(bind(then, newValue), self);
          return;
        }
      }
      self._state = 1;
      self._value = newValue;
      finale(self);
    } catch (e) {
      reject(self, e);
    }
  }

  function reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    finale(self);
  }

  function finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) {
      Promise._immediateFn(function() {
        if (!self._handled) {
          Promise._unhandledRejectionFn(self._value);
        }
      });
    }

    for (var i = 0, len = self._deferreds.length; i < len; i++) {
      handle(self, self._deferreds[i]);
    }
    self._deferreds = null;
  }

  function Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
  }

  /**
   * Take a potentially misbehaving resolver function and make sure
   * onFulfilled and onRejected are only called once.
   *
   * Makes no guarantees about asynchrony.
   */
  function doResolve(fn, self) {
    var done = false;
    try {
      fn(function (value) {
        if (done) return;
        done = true;
        resolve(self, value);
      }, function (reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      });
    } catch (ex) {
      if (done) return;
      done = true;
      reject(self, ex);
    }
  }

  Promise.prototype['catch'] = function (onRejected) {
    return this.then(null, onRejected);
  };

  Promise.prototype.then = function (onFulfilled, onRejected) {
    var prom = new (this.constructor)(noop);

    handle(this, new Handler(onFulfilled, onRejected, prom));
    return prom;
  };

  Promise.all = function (arr) {
    var args = Array.prototype.slice.call(arr);

    return new Promise(function (resolve, reject) {
      if (args.length === 0) return resolve([]);
      var remaining = args.length;

      function res(i, val) {
        try {
          if (val && (typeof val === 'object' || typeof val === 'function')) {
            var then = val.then;
            if (typeof then === 'function') {
              then.call(val, function (val) {
                res(i, val);
              }, reject);
              return;
            }
          }
          args[i] = val;
          if (--remaining === 0) {
            resolve(args);
          }
        } catch (ex) {
          reject(ex);
        }
      }

      for (var i = 0; i < args.length; i++) {
        res(i, args[i]);
      }
    });
  };

  Promise.resolve = function (value) {
    if (value && typeof value === 'object' && value.constructor === Promise) {
      return value;
    }

    return new Promise(function (resolve) {
      resolve(value);
    });
  };

  Promise.reject = function (value) {
    return new Promise(function (resolve, reject) {
      reject(value);
    });
  };

  Promise.race = function (values) {
    return new Promise(function (resolve, reject) {
      for (var i = 0, len = values.length; i < len; i++) {
        values[i].then(resolve, reject);
      }
    });
  };

  // Use polyfill for setImmediate for performance gains
  Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
    function (fn) {
      setTimeoutFunc(fn, 0);
    };

  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) {
      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
    }
  };

  /**
   * Set the immediate function to execute callbacks
   * @param fn {function} Function to execute
   * @deprecated
   */
  Promise._setImmediateFn = function _setImmediateFn(fn) {
    Promise._immediateFn = fn;
  };

  /**
   * Change the function to execute on unhandled rejection
   * @param {function} fn Function to execute on unhandled rejection
   * @deprecated
   */
  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
    Promise._unhandledRejectionFn = fn;
  };
  
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Promise;
  } else if (!root.Promise) {
    root.Promise = Promise;
  }

})(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(234).setImmediate))

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.registerStorage = registerStorage;

var _string = __webpack_require__(113);

var _taskenums = __webpack_require__(190);

var _xhriopool = __webpack_require__(431);

var _reference = __webpack_require__(192);

var _service = __webpack_require__(432);

var _app = __webpack_require__(34);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Type constant for Firebase Storage.
 */
var STORAGE_TYPE = 'storage'; /**
                               * Copyright 2017 Google Inc.
                               *
                               * Licensed under the Apache License, Version 2.0 (the "License");
                               * you may not use this file except in compliance with the License.
                               * You may obtain a copy of the License at
                               *
                               *   http://www.apache.org/licenses/LICENSE-2.0
                               *
                               * Unless required by applicable law or agreed to in writing, software
                               * distributed under the License is distributed on an "AS IS" BASIS,
                               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                               * See the License for the specific language governing permissions and
                               * limitations under the License.
                               */

function factory(app, unused, opt_url) {
    return new _service.Service(app, new _xhriopool.XhrIoPool(), opt_url);
}
function registerStorage(instance) {
    var namespaceExports = {
        // no-inline
        TaskState: _taskenums.TaskState,
        TaskEvent: _taskenums.TaskEvent,
        StringFormat: _string.StringFormat,
        Storage: _service.Service,
        Reference: _reference.Reference
    };
    instance.INTERNAL.registerService(STORAGE_TYPE, factory, namespaceExports, undefined,
    // Allow multiple storage instances per app.
    true);
}
registerStorage(_app2.default);
//# sourceMappingURL=storage.js.map


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.async = async;

var _promise_external = __webpack_require__(38);

var promiseimpl = _interopRequireWildcard(_promise_external);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */
function async(f) {
    return function () {
        var argsToForward = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            argsToForward[_i] = arguments[_i];
        }
        promiseimpl.resolve(true).then(function () {
            f.apply(null, argsToForward);
        });
    };
} /**
   * Copyright 2017 Google Inc.
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
/**
 * @fileoverview Method for invoking a callback asynchronously.
 */
//# sourceMappingURL=async.js.map


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AuthWrapper = undefined;

var _constants = __webpack_require__(84);

var constants = _interopRequireWildcard(_constants);

var _error2 = __webpack_require__(26);

var errorsExports = _interopRequireWildcard(_error2);

var _failrequest = __webpack_require__(423);

var _location = __webpack_require__(85);

var _promise_external = __webpack_require__(38);

var promiseimpl = _interopRequireWildcard(_promise_external);

var _requestmap = __webpack_require__(429);

var _type = __webpack_require__(20);

var type = _interopRequireWildcard(_type);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * @param app If null, getAuthToken always resolves with null.
 * @param service The storage service associated with this auth wrapper.
 *     Untyped to avoid circular type dependencies.
 * @struct
 */
var AuthWrapper = /** @class */function () {
    function AuthWrapper(app, maker, requestMaker, service, pool) {
        this.bucket_ = null;
        this.deleted_ = false;
        this.app_ = app;
        if (this.app_ !== null) {
            var options = this.app_.options;
            if (type.isDef(options)) {
                this.bucket_ = AuthWrapper.extractBucket_(options);
            }
        }
        this.storageRefMaker_ = maker;
        this.requestMaker_ = requestMaker;
        this.pool_ = pool;
        this.service_ = service;
        this.maxOperationRetryTime_ = constants.defaultMaxOperationRetryTime;
        this.maxUploadRetryTime_ = constants.defaultMaxUploadRetryTime;
        this.requestMap_ = new _requestmap.RequestMap();
    }
    AuthWrapper.extractBucket_ = function (config) {
        var bucketString = config[constants.configOption] || null;
        if (bucketString == null) {
            return null;
        }
        var loc = _location.Location.makeFromBucketSpec(bucketString);
        return loc.bucket;
    };
    AuthWrapper.prototype.getAuthToken = function () {
        // TODO(andysoto): remove ifDef checks after firebase-app implements stubs
        // (b/28673818).
        if (this.app_ !== null && type.isDef(this.app_.INTERNAL) && type.isDef(this.app_.INTERNAL.getToken)) {
            return this.app_.INTERNAL.getToken().then(function (response) {
                if (response !== null) {
                    return response.accessToken;
                } else {
                    return null;
                }
            }, function (_error) {
                return null;
            });
        } else {
            return promiseimpl.resolve(null);
        }
    };
    AuthWrapper.prototype.bucket = function () {
        if (this.deleted_) {
            throw errorsExports.appDeleted();
        } else {
            return this.bucket_;
        }
    };
    /**
     * The service associated with this auth wrapper. Untyped to avoid circular
     * type dependencies.
     */
    AuthWrapper.prototype.service = function () {
        return this.service_;
    };
    /**
     * Returns a new firebaseStorage.Reference object referencing this AuthWrapper
     * at the given Location.
     * @param loc The Location.
     * @return Actually a firebaseStorage.Reference, typing not allowed
     *     because of circular dependency problems.
     */
    AuthWrapper.prototype.makeStorageReference = function (loc) {
        return this.storageRefMaker_(this, loc);
    };
    AuthWrapper.prototype.makeRequest = function (requestInfo, authToken) {
        if (!this.deleted_) {
            var request = this.requestMaker_(requestInfo, authToken, this.pool_);
            this.requestMap_.addRequest(request);
            return request;
        } else {
            return new _failrequest.FailRequest(errorsExports.appDeleted());
        }
    };
    /**
     * Stop running requests and prevent more from being created.
     */
    AuthWrapper.prototype.deleteApp = function () {
        this.deleted_ = true;
        this.app_ = null;
        this.requestMap_.clear();
    };
    AuthWrapper.prototype.maxUploadRetryTime = function () {
        return this.maxUploadRetryTime_;
    };
    AuthWrapper.prototype.setMaxUploadRetryTime = function (time) {
        this.maxUploadRetryTime_ = time;
    };
    AuthWrapper.prototype.maxOperationRetryTime = function () {
        return this.maxOperationRetryTime_;
    };
    AuthWrapper.prototype.setMaxOperationRetryTime = function (time) {
        this.maxOperationRetryTime_ = time;
    };
    return AuthWrapper;
}();
exports.AuthWrapper = AuthWrapper;
//# sourceMappingURL=authwrapper.js.map


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.start = start;
exports.stop = stop;
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param f May be invoked
 *     before the function returns.
 * @param callback Get all the arguments passed to the function
 *     passed to f, including the initial boolean.
 */
function start(f, callback, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    var waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    var timeoutId = null;
    var hitTimeout = false;
    var cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    var triggeredCallback = false;
    function triggerCallback() {
        if (!triggeredCallback) {
            triggeredCallback = true;
            callback.apply(null, arguments);
        }
    }
    function callWithDelay(millis) {
        timeoutId = setTimeout(function () {
            timeoutId = null;
            f(handler, canceled());
        }, millis);
    }
    function handler(success) {
        var var_args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            var_args[_i - 1] = arguments[_i];
        }
        if (triggeredCallback) {
            return;
        }
        if (success) {
            triggerCallback.apply(null, arguments);
            return;
        }
        var mustStop = canceled() || hitTimeout;
        if (mustStop) {
            triggerCallback.apply(null, arguments);
            return;
        }
        if (waitSeconds < 64) {
            /* TODO(andysoto): don't back off so quickly if we know we're offline. */
            waitSeconds *= 2;
        }
        var waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        } else {
            waitMillis = (waitSeconds + Math.random()) * 1000;
        }
        callWithDelay(waitMillis);
    }
    var stopped = false;
    function stop(wasTimeout) {
        if (stopped) {
            return;
        }
        stopped = true;
        if (triggeredCallback) {
            return;
        }
        if (timeoutId !== null) {
            if (!wasTimeout) {
                cancelState = 2;
            }
            clearTimeout(timeoutId);
            callWithDelay(0);
        } else {
            if (!wasTimeout) {
                cancelState = 1;
            }
        }
    }
    callWithDelay(0);
    setTimeout(function () {
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */
function stop(id) {
    id(false);
}
//# sourceMappingURL=backoff.js.map


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FailRequest = undefined;

var _promise_external = __webpack_require__(38);

var promiseimpl = _interopRequireWildcard(_promise_external);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * A request whose promise always fails.
 * @struct
 * @template T
 */
var FailRequest = /** @class */function () {
    function FailRequest(error) {
        this.promise_ = promiseimpl.reject(error);
    }
    /** @inheritDoc */
    FailRequest.prototype.getPromise = function () {
        return this.promise_;
    };
    /** @inheritDoc */
    FailRequest.prototype.cancel = function (appDelete) {
        if (appDelete === void 0) {
            appDelete = false;
        }
    };
    return FailRequest;
}();
exports.FailRequest = FailRequest;
//# sourceMappingURL=failrequest.js.map


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBlob = getBlob;
exports.sliceBlob = sliceBlob;

var _type = __webpack_require__(20);

var type = _interopRequireWildcard(_type);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function getBlobBuilder() {
    if (typeof BlobBuilder !== 'undefined') {
        return BlobBuilder;
    } else if (typeof WebKitBlobBuilder !== 'undefined') {
        return WebKitBlobBuilder;
    } else {
        return undefined;
    }
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param var_args The values that will make up the resulting blob.
 * @return The blob.
 */
function getBlob() {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var BlobBuilder = getBlobBuilder();
    if (BlobBuilder !== undefined) {
        var bb = new BlobBuilder();
        for (var i = 0; i < var_args.length; i++) {
            bb.append(var_args[i]);
        }
        return bb.getBlob();
    } else {
        if (type.isNativeBlobDefined()) {
            return new Blob(var_args);
        } else {
            throw Error("This browser doesn't seem to support creating Blobs");
        }
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */
function sliceBlob(blob, start, end) {
    if (blob.webkitSlice) {
        return blob.webkitSlice(start, end);
    } else if (blob.mozSlice) {
        return blob.mozSlice(start, end);
    } else if (blob.slice) {
        return blob.slice(start, end);
    }
    return null;
}
//# sourceMappingURL=fs.js.map


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.jsonObjectOrNull = jsonObjectOrNull;

var _type = __webpack_require__(20);

var type = _interopRequireWildcard(_type);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */
function jsonObjectOrNull(s) {
    var obj;
    try {
        obj = JSON.parse(s);
    } catch (e) {
        return null;
    }
    if (type.isNonArrayObject(obj)) {
        return obj;
    } else {
        return null;
    }
} /**
   * Copyright 2017 Google Inc.
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
//# sourceMappingURL=json.js.map


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Observer = undefined;

var _type = __webpack_require__(20);

var type = _interopRequireWildcard(_type);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * @struct
 */
var Observer = /** @class */function () {
    function Observer(nextOrObserver, opt_error, opt_complete) {
        var asFunctions = type.isFunction(nextOrObserver) || type.isDef(opt_error) || type.isDef(opt_complete);
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = opt_error || null;
            this.complete = opt_complete || null;
        } else {
            var observer = nextOrObserver;
            this.next = observer.next || null;
            this.error = observer.error || null;
            this.complete = observer.complete || null;
        }
    }
    return Observer;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.Observer = Observer;
//# sourceMappingURL=observer.js.map


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RequestEndStatus = undefined;
exports.addAuthHeader_ = addAuthHeader_;
exports.addVersionHeader_ = addVersionHeader_;
exports.makeRequest = makeRequest;

var _array = __webpack_require__(111);

var array = _interopRequireWildcard(_array);

var _backoff = __webpack_require__(422);

var backoff = _interopRequireWildcard(_backoff);

var _error = __webpack_require__(26);

var errorsExports = _interopRequireWildcard(_error);

var _object = __webpack_require__(49);

var object = _interopRequireWildcard(_object);

var _promise_external = __webpack_require__(38);

var promiseimpl = _interopRequireWildcard(_promise_external);

var _type = __webpack_require__(20);

var type = _interopRequireWildcard(_type);

var _url = __webpack_require__(114);

var UrlUtils = _interopRequireWildcard(_url);

var _xhrio = __webpack_require__(191);

var XhrIoExports = _interopRequireWildcard(_xhrio);

var _app = __webpack_require__(34);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * @struct
 * @template T
 */
var NetworkRequest = /** @class */function () {
    function NetworkRequest(url, method, headers, body, successCodes, additionalRetryCodes, callback, errorCallback, timeout, progressCallback, pool) {
        this.pendingXhr_ = null;
        this.backoffId_ = null;
        this.resolve_ = null;
        this.reject_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.url_ = url;
        this.method_ = method;
        this.headers_ = headers;
        this.body_ = body;
        this.successCodes_ = successCodes.slice();
        this.additionalRetryCodes_ = additionalRetryCodes.slice();
        this.callback_ = callback;
        this.errorCallback_ = errorCallback;
        this.progressCallback_ = progressCallback;
        this.timeout_ = timeout;
        this.pool_ = pool;
        var self = this;
        this.promise_ = promiseimpl.make(function (resolve, reject) {
            self.resolve_ = resolve;
            self.reject_ = reject;
            self.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */
    NetworkRequest.prototype.start_ = function () {
        var self = this;
        function doTheRequest(backoffCallback, canceled) {
            if (canceled) {
                backoffCallback(false, new RequestEndStatus(false, null, true));
                return;
            }
            var xhr = self.pool_.createXhrIo();
            self.pendingXhr_ = xhr;
            function progressListener(progressEvent) {
                var loaded = progressEvent.loaded;
                var total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (self.progressCallback_ !== null) {
                    self.progressCallback_(loaded, total);
                }
            }
            if (self.progressCallback_ !== null) {
                xhr.addUploadProgressListener(progressListener);
            }
            xhr.send(self.url_, self.method_, self.body_, self.headers_).then(function (xhr) {
                if (self.progressCallback_ !== null) {
                    xhr.removeUploadProgressListener(progressListener);
                }
                self.pendingXhr_ = null;
                xhr = xhr;
                var hitServer = xhr.getErrorCode() === XhrIoExports.ErrorCode.NO_ERROR;
                var status = xhr.getStatus();
                if (!hitServer || self.isRetryStatusCode_(status)) {
                    var wasCanceled = xhr.getErrorCode() === XhrIoExports.ErrorCode.ABORT;
                    backoffCallback(false, new RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                var successCode = array.contains(self.successCodes_, status);
                backoffCallback(true, new RequestEndStatus(successCode, xhr));
            });
        }
        /**
         * @param requestWentThrough True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */
        function backoffDone(requestWentThrough, status) {
            var resolve = self.resolve_;
            var reject = self.reject_;
            var xhr = status.xhr;
            if (status.wasSuccessCode) {
                try {
                    var result = self.callback_(xhr, xhr.getResponseText());
                    if (type.isJustDef(result)) {
                        resolve(result);
                    } else {
                        resolve();
                    }
                } catch (e) {
                    reject(e);
                }
            } else {
                if (xhr !== null) {
                    var err = errorsExports.unknown();
                    err.setServerResponseProp(xhr.getResponseText());
                    if (self.errorCallback_) {
                        reject(self.errorCallback_(xhr, err));
                    } else {
                        reject(err);
                    }
                } else {
                    if (status.canceled) {
                        var err = self.appDelete_ ? errorsExports.appDeleted() : errorsExports.canceled();
                        reject(err);
                    } else {
                        var err = errorsExports.retryLimitExceeded();
                        reject(err);
                    }
                }
            }
        }
        if (this.canceled_) {
            backoffDone(false, new RequestEndStatus(false, null, true));
        } else {
            this.backoffId_ = backoff.start(doTheRequest, backoffDone, this.timeout_);
        }
    };
    /** @inheritDoc */
    NetworkRequest.prototype.getPromise = function () {
        return this.promise_;
    };
    /** @inheritDoc */
    NetworkRequest.prototype.cancel = function (appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) {
            backoff.stop(this.backoffId_);
        }
        if (this.pendingXhr_ !== null) {
            this.pendingXhr_.abort();
        }
    };
    NetworkRequest.prototype.isRetryStatusCode_ = function (status) {
        // The codes for which to retry came from this page:
        // https://cloud.google.com/storage/docs/exponential-backoff
        var isFiveHundredCode = status >= 500 && status < 600;
        var extraRetryCodes = [
        // Request Timeout: web server didn't receive full request in time.
        408,
        // Too Many Requests: you're getting rate-limited, basically.
        429];
        var isExtraRetryCode = array.contains(extraRetryCodes, status);
        var isRequestSpecificRetryCode = array.contains(this.additionalRetryCodes_, status);
        return isFiveHundredCode || isExtraRetryCode || isRequestSpecificRetryCode;
    };
    return NetworkRequest;
}();
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled Defaults to false.
 * @struct
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Defines methods used to actually send HTTP requests from
 * abstract representations.
 */
var RequestEndStatus = /** @class */function () {
    function RequestEndStatus(wasSuccessCode, xhr, opt_canceled) {
        this.wasSuccessCode = wasSuccessCode;
        this.xhr = xhr;
        this.canceled = !!opt_canceled;
    }
    return RequestEndStatus;
}();
exports.RequestEndStatus = RequestEndStatus;
function addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) {
        headers['Authorization'] = 'Firebase ' + authToken;
    }
}
function addVersionHeader_(headers) {
    var number = typeof _app2.default !== 'undefined' ? _app2.default.SDK_VERSION : 'AppManager';
    headers['X-Firebase-Storage-Version'] = 'webjs/' + number;
}
/**
 * @template T
 */
function makeRequest(requestInfo, authToken, pool) {
    var queryPart = UrlUtils.makeQueryString(requestInfo.urlParams);
    var url = requestInfo.url + queryPart;
    var headers = object.clone(requestInfo.headers);
    addAuthHeader_(headers, authToken);
    addVersionHeader_(headers);
    return new NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, pool);
}
//# sourceMappingURL=request.js.map


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
var RequestInfo = /** @class */function () {
    function RequestInfo(url, method,
    /**
       * Returns the value with which to resolve the request's promise. Only called
       * if the request is successful. Throw from this function to reject the
       * returned Request's promise with the thrown error.
       * Note: The XhrIo passed to this function may be reused after this callback
       * returns. Do not keep a reference to it in any way.
       */
    handler, timeout) {
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */
        this.progressCallback = null;
        this.successCodes = [200];
        this.additionalRetryCodes = [];
    }
    return RequestInfo;
}();
exports.RequestInfo = RequestInfo;
//# sourceMappingURL=requestinfo.js.map


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RequestMap = undefined;

var _object = __webpack_require__(49);

var object = _interopRequireWildcard(_object);

var _constants = __webpack_require__(84);

var constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * @struct
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RequestMap = /** @class */function () {
    function RequestMap() {
        this.map_ = {};
        this.id_ = constants.minSafeInteger;
    }
    /**
     * Registers the given request with this map.
     * The request is unregistered when it completes.
     * @param r The request to register.
     */
    RequestMap.prototype.addRequest = function (r) {
        var id = this.id_;
        this.id_++;
        this.map_[id] = r;
        var self = this;
        function unmap() {
            delete self.map_[id];
        }
        r.getPromise().then(unmap, unmap);
    };
    /**
     * Cancels all registered requests.
     */
    RequestMap.prototype.clear = function () {
        object.forEach(this.map_, function (key, val) {
            if (val) {
                val.cancel(true);
            }
        });
        this.map_ = {};
    };
    return RequestMap;
}();
exports.RequestMap = RequestMap;
//# sourceMappingURL=requestmap.js.map


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NetworkXhrIo = undefined;

var _error = __webpack_require__(26);

var errorsExports = _interopRequireWildcard(_error);

var _object = __webpack_require__(49);

var object = _interopRequireWildcard(_object);

var _promise_external = __webpack_require__(38);

var promiseimpl = _interopRequireWildcard(_promise_external);

var _type = __webpack_require__(20);

var type = _interopRequireWildcard(_type);

var _xhrio = __webpack_require__(191);

var XhrIoExports = _interopRequireWildcard(_xhrio);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * We use this instead of goog.net.XhrIo because goog.net.XhrIo is hyuuuuge and
 * doesn't work in React Native on Android.
 */
var NetworkXhrIo = /** @class */function () {
    function NetworkXhrIo() {
        var _this = this;
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.errorCode_ = XhrIoExports.ErrorCode.NO_ERROR;
        this.sendPromise_ = promiseimpl.make(function (resolve, reject) {
            _this.xhr_.addEventListener('abort', function (event) {
                _this.errorCode_ = XhrIoExports.ErrorCode.ABORT;
                resolve(_this);
            });
            _this.xhr_.addEventListener('error', function (event) {
                _this.errorCode_ = XhrIoExports.ErrorCode.NETWORK_ERROR;
                resolve(_this);
            });
            _this.xhr_.addEventListener('load', function (event) {
                resolve(_this);
            });
        });
    }
    /**
     * @override
     */
    NetworkXhrIo.prototype.send = function (url, method, opt_body, opt_headers) {
        var _this = this;
        if (this.sent_) {
            throw errorsExports.internalError('cannot .send() more than once');
        }
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if (type.isDef(opt_headers)) {
            var headers = opt_headers;
            object.forEach(headers, function (key, val) {
                _this.xhr_.setRequestHeader(key, val.toString());
            });
        }
        if (type.isDef(opt_body)) {
            this.xhr_.send(opt_body);
        } else {
            this.xhr_.send();
        }
        return this.sendPromise_;
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getErrorCode = function () {
        if (!this.sent_) {
            throw errorsExports.internalError('cannot .getErrorCode() before sending');
        }
        return this.errorCode_;
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getStatus = function () {
        if (!this.sent_) {
            throw errorsExports.internalError('cannot .getStatus() before sending');
        }
        try {
            return this.xhr_.status;
        } catch (e) {
            return -1;
        }
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getResponseText = function () {
        if (!this.sent_) {
            throw errorsExports.internalError('cannot .getResponseText() before sending');
        }
        return this.xhr_.responseText;
    };
    /**
     * Aborts the request.
     * @override
     */
    NetworkXhrIo.prototype.abort = function () {
        this.xhr_.abort();
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getResponseHeader = function (header) {
        return this.xhr_.getResponseHeader(header);
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.addUploadProgressListener = function (listener) {
        if (type.isDef(this.xhr_.upload)) {
            this.xhr_.upload.addEventListener('progress', listener);
        }
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.removeUploadProgressListener = function (listener) {
        if (type.isDef(this.xhr_.upload)) {
            this.xhr_.upload.removeEventListener('progress', listener);
        }
    };
    return NetworkXhrIo;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.NetworkXhrIo = NetworkXhrIo;
//# sourceMappingURL=xhrio_network.js.map


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XhrIoPool = undefined;

var _xhrio_network = __webpack_require__(430);

/**
 * Factory-like class for creating XhrIo instances.
 */
var XhrIoPool = /** @class */function () {
  function XhrIoPool() {}
  XhrIoPool.prototype.createXhrIo = function () {
    return new _xhrio_network.NetworkXhrIo();
  };
  return XhrIoPool;
}(); /**
      * Copyright 2017 Google Inc.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
exports.XhrIoPool = XhrIoPool;
//# sourceMappingURL=xhriopool.js.map


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ServiceInternals = exports.Service = undefined;

var _args = __webpack_require__(110);

var args = _interopRequireWildcard(_args);

var _authwrapper = __webpack_require__(421);

var _location = __webpack_require__(85);

var _promise_external = __webpack_require__(38);

var fbsPromiseImpl = _interopRequireWildcard(_promise_external);

var _request = __webpack_require__(427);

var RequestExports = _interopRequireWildcard(_request);

var _reference = __webpack_require__(192);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * A service that provides firebaseStorage.Reference instances.
 * @param opt_url gs:// url to a custom Storage Bucket
 *
 * @struct
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Service = /** @class */function () {
    function Service(app, pool, url) {
        this.bucket_ = null;
        function maker(authWrapper, loc) {
            return new _reference.Reference(authWrapper, loc);
        }
        this.authWrapper_ = new _authwrapper.AuthWrapper(app, maker, RequestExports.makeRequest, this, pool);
        this.app_ = app;
        if (url != null) {
            this.bucket_ = _location.Location.makeFromBucketSpec(url);
        } else {
            var authWrapperBucket = this.authWrapper_.bucket();
            if (authWrapperBucket != null) {
                this.bucket_ = new _location.Location(authWrapperBucket, '');
            }
        }
        this.internals_ = new ServiceInternals(this);
    }
    /**
     * Returns a firebaseStorage.Reference for the given path in the default
     * bucket.
     */
    Service.prototype.ref = function (path) {
        function validator(path) {
            if (/^[A-Za-z]+:\/\//.test(path)) {
                throw 'Expected child path but got a URL, use refFromURL instead.';
            }
        }
        args.validate('ref', [args.stringSpec(validator, true)], arguments);
        if (this.bucket_ == null) {
            throw new Error('No Storage Bucket defined in Firebase Options.');
        }
        var ref = new _reference.Reference(this.authWrapper_, this.bucket_);
        if (path != null) {
            return ref.child(path);
        } else {
            return ref;
        }
    };
    /**
     * Returns a firebaseStorage.Reference object for the given absolute URL,
     * which must be a gs:// or http[s]:// URL.
     */
    Service.prototype.refFromURL = function (url) {
        function validator(p) {
            if (!/^[A-Za-z]+:\/\//.test(p)) {
                throw 'Expected full URL but got a child path, use ref instead.';
            }
            try {
                _location.Location.makeFromUrl(p);
            } catch (e) {
                throw 'Expected valid full URL but got an invalid one.';
            }
        }
        args.validate('refFromURL', [args.stringSpec(validator, false)], arguments);
        return new _reference.Reference(this.authWrapper_, url);
    };
    Object.defineProperty(Service.prototype, "maxUploadRetryTime", {
        get: function get() {
            return this.authWrapper_.maxUploadRetryTime();
        },
        enumerable: true,
        configurable: true
    });
    Service.prototype.setMaxUploadRetryTime = function (time) {
        args.validate('setMaxUploadRetryTime', [args.nonNegativeNumberSpec()], arguments);
        this.authWrapper_.setMaxUploadRetryTime(time);
    };
    Object.defineProperty(Service.prototype, "maxOperationRetryTime", {
        get: function get() {
            return this.authWrapper_.maxOperationRetryTime();
        },
        enumerable: true,
        configurable: true
    });
    Service.prototype.setMaxOperationRetryTime = function (time) {
        args.validate('setMaxOperationRetryTime', [args.nonNegativeNumberSpec()], arguments);
        this.authWrapper_.setMaxOperationRetryTime(time);
    };
    Object.defineProperty(Service.prototype, "app", {
        get: function get() {
            return this.app_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Service.prototype, "INTERNAL", {
        get: function get() {
            return this.internals_;
        },
        enumerable: true,
        configurable: true
    });
    return Service;
}();
exports.Service = Service;
/**
 * @struct
 */

var ServiceInternals = /** @class */function () {
    function ServiceInternals(service) {
        this.service_ = service;
    }
    /**
     * Called when the associated app is deleted.
     * @see {!fbs.AuthWrapper.prototype.deleteApp}
     */
    ServiceInternals.prototype.delete = function () {
        this.service_.authWrapper_.deleteApp();
        return fbsPromiseImpl.resolve(undefined);
    };
    return ServiceInternals;
}();
exports.ServiceInternals = ServiceInternals;
//# sourceMappingURL=service.js.map


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UploadTask = undefined;

var _taskenums = __webpack_require__(190);

var fbsTaskEnums = _interopRequireWildcard(_taskenums);

var _observer = __webpack_require__(426);

var _tasksnapshot = __webpack_require__(434);

var _args = __webpack_require__(110);

var fbsArgs = _interopRequireWildcard(_args);

var _array = __webpack_require__(111);

var fbsArray = _interopRequireWildcard(_array);

var _async = __webpack_require__(420);

var _error = __webpack_require__(26);

var errors = _interopRequireWildcard(_error);

var _promise_external = __webpack_require__(38);

var fbsPromiseimpl = _interopRequireWildcard(_promise_external);

var _requests = __webpack_require__(189);

var fbsRequests = _interopRequireWildcard(_requests);

var _type = __webpack_require__(20);

var typeUtils = _interopRequireWildcard(_type);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Defines types for interacting with blob transfer tasks.
 */
var UploadTask = /** @class */function () {
    /**
     * @param ref The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob The blob to upload.
     */
    function UploadTask(ref, authWrapper, location, mappings, blob, metadata) {
        if (metadata === void 0) {
            metadata = null;
        }
        var _this = this;
        this.transferred_ = 0;
        this.needToFetchStatus_ = false;
        this.needToFetchMetadata_ = false;
        this.observers_ = [];
        this.error_ = null;
        this.uploadUrl_ = null;
        this.request_ = null;
        this.chunkMultiplier_ = 1;
        this.resolve_ = null;
        this.reject_ = null;
        this.ref_ = ref;
        this.authWrapper_ = authWrapper;
        this.location_ = location;
        this.blob_ = blob;
        this.metadata_ = metadata;
        this.mappings_ = mappings;
        this.resumable_ = this.shouldDoResumable_(this.blob_);
        this.state_ = _taskenums.InternalTaskState.RUNNING;
        this.errorHandler_ = function (error) {
            _this.request_ = null;
            _this.chunkMultiplier_ = 1;
            if (error.codeEquals(errors.Code.CANCELED)) {
                _this.needToFetchStatus_ = true;
                _this.completeTransitions_();
            } else {
                _this.error_ = error;
                _this.transition_(_taskenums.InternalTaskState.ERROR);
            }
        };
        this.metadataErrorHandler_ = function (error) {
            _this.request_ = null;
            if (error.codeEquals(errors.Code.CANCELED)) {
                _this.completeTransitions_();
            } else {
                _this.error_ = error;
                _this.transition_(_taskenums.InternalTaskState.ERROR);
            }
        };
        this.promise_ = fbsPromiseimpl.make(function (resolve, reject) {
            _this.resolve_ = resolve;
            _this.reject_ = reject;
            _this.start_();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this.promise_.then(null, function () {});
    }
    UploadTask.prototype.makeProgressCallback_ = function () {
        var _this = this;
        var sizeBefore = this.transferred_;
        return function (loaded, total) {
            _this.updateProgress_(sizeBefore + loaded);
        };
    };
    UploadTask.prototype.shouldDoResumable_ = function (blob) {
        return blob.size() > 256 * 1024;
    };
    UploadTask.prototype.start_ = function () {
        if (this.state_ !== _taskenums.InternalTaskState.RUNNING) {
            // This can happen if someone pauses us in a resume callback, for example.
            return;
        }
        if (this.request_ !== null) {
            return;
        }
        if (this.resumable_) {
            if (this.uploadUrl_ === null) {
                this.createResumable_();
            } else {
                if (this.needToFetchStatus_) {
                    this.fetchStatus_();
                } else {
                    if (this.needToFetchMetadata_) {
                        // Happens if we miss the metadata on upload completion.
                        this.fetchMetadata_();
                    } else {
                        this.continueUpload_();
                    }
                }
            }
        } else {
            this.oneShotUpload_();
        }
    };
    UploadTask.prototype.resolveToken_ = function (callback) {
        var _this = this;
        this.authWrapper_.getAuthToken().then(function (authToken) {
            switch (_this.state_) {
                case _taskenums.InternalTaskState.RUNNING:
                    callback(authToken);
                    break;
                case _taskenums.InternalTaskState.CANCELING:
                    _this.transition_(_taskenums.InternalTaskState.CANCELED);
                    break;
                case _taskenums.InternalTaskState.PAUSING:
                    _this.transition_(_taskenums.InternalTaskState.PAUSED);
                    break;
                default:
            }
        });
    };
    // TODO(andysoto): assert false
    UploadTask.prototype.createResumable_ = function () {
        var _this = this;
        this.resolveToken_(function (authToken) {
            var requestInfo = fbsRequests.createResumableUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
            var createRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = createRequest;
            createRequest.getPromise().then(function (url) {
                _this.request_ = null;
                _this.uploadUrl_ = url;
                _this.needToFetchStatus_ = false;
                _this.completeTransitions_();
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.fetchStatus_ = function () {
        var _this = this;
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        var url = this.uploadUrl_;
        this.resolveToken_(function (authToken) {
            var requestInfo = fbsRequests.getResumableUploadStatus(_this.authWrapper_, _this.location_, url, _this.blob_);
            var statusRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = statusRequest;
            statusRequest.getPromise().then(function (status) {
                status = status;
                _this.request_ = null;
                _this.updateProgress_(status.current);
                _this.needToFetchStatus_ = false;
                if (status.finalized) {
                    _this.needToFetchMetadata_ = true;
                }
                _this.completeTransitions_();
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.continueUpload_ = function () {
        var _this = this;
        var chunkSize = fbsRequests.resumableUploadChunkSize * this.chunkMultiplier_;
        var status = new fbsRequests.ResumableUploadStatus(this.transferred_, this.blob_.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        var url = this.uploadUrl_;
        this.resolveToken_(function (authToken) {
            var requestInfo;
            try {
                requestInfo = fbsRequests.continueResumableUpload(_this.location_, _this.authWrapper_, url, _this.blob_, chunkSize, _this.mappings_, status, _this.makeProgressCallback_());
            } catch (e) {
                _this.error_ = e;
                _this.transition_(_taskenums.InternalTaskState.ERROR);
                return;
            }
            var uploadRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = uploadRequest;
            uploadRequest.getPromise().then(function (newStatus) {
                _this.increaseMultiplier_();
                _this.request_ = null;
                _this.updateProgress_(newStatus.current);
                if (newStatus.finalized) {
                    _this.metadata_ = newStatus.metadata;
                    _this.transition_(_taskenums.InternalTaskState.SUCCESS);
                } else {
                    _this.completeTransitions_();
                }
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.increaseMultiplier_ = function () {
        var currentSize = fbsRequests.resumableUploadChunkSize * this.chunkMultiplier_;
        // Max chunk size is 32M.
        if (currentSize < 32 * 1024 * 1024) {
            this.chunkMultiplier_ *= 2;
        }
    };
    UploadTask.prototype.fetchMetadata_ = function () {
        var _this = this;
        this.resolveToken_(function (authToken) {
            var requestInfo = fbsRequests.getMetadata(_this.authWrapper_, _this.location_, _this.mappings_);
            var metadataRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = metadataRequest;
            metadataRequest.getPromise().then(function (metadata) {
                _this.request_ = null;
                _this.metadata_ = metadata;
                _this.transition_(_taskenums.InternalTaskState.SUCCESS);
            }, _this.metadataErrorHandler_);
        });
    };
    UploadTask.prototype.oneShotUpload_ = function () {
        var _this = this;
        this.resolveToken_(function (authToken) {
            var requestInfo = fbsRequests.multipartUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
            var multipartRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = multipartRequest;
            multipartRequest.getPromise().then(function (metadata) {
                _this.request_ = null;
                _this.metadata_ = metadata;
                _this.updateProgress_(_this.blob_.size());
                _this.transition_(_taskenums.InternalTaskState.SUCCESS);
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.updateProgress_ = function (transferred) {
        var old = this.transferred_;
        this.transferred_ = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this.transferred_ !== old) {
            this.notifyObservers_();
        }
    };
    UploadTask.prototype.transition_ = function (state) {
        if (this.state_ === state) {
            return;
        }
        switch (state) {
            case _taskenums.InternalTaskState.CANCELING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this.state_ = state;
                if (this.request_ !== null) {
                    this.request_.cancel();
                }
                break;
            case _taskenums.InternalTaskState.PAUSING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING);
                this.state_ = state;
                if (this.request_ !== null) {
                    this.request_.cancel();
                }
                break;
            case _taskenums.InternalTaskState.RUNNING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                var wasPaused = this.state_ === _taskenums.InternalTaskState.PAUSED;
                this.state_ = state;
                if (wasPaused) {
                    this.notifyObservers_();
                    this.start_();
                }
                break;
            case _taskenums.InternalTaskState.PAUSED:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this.state_ = state;
                this.notifyObservers_();
                break;
            case _taskenums.InternalTaskState.CANCELED:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.error_ = errors.canceled();
                this.state_ = state;
                this.notifyObservers_();
                break;
            case _taskenums.InternalTaskState.ERROR:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.state_ = state;
                this.notifyObservers_();
                break;
            case _taskenums.InternalTaskState.SUCCESS:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.state_ = state;
                this.notifyObservers_();
                break;
        }
    };
    UploadTask.prototype.completeTransitions_ = function () {
        switch (this.state_) {
            case _taskenums.InternalTaskState.PAUSING:
                this.transition_(_taskenums.InternalTaskState.PAUSED);
                break;
            case _taskenums.InternalTaskState.CANCELING:
                this.transition_(_taskenums.InternalTaskState.CANCELED);
                break;
            case _taskenums.InternalTaskState.RUNNING:
                this.start_();
                break;
            default:
                // TODO(andysoto): assert(false);
                break;
        }
    };
    Object.defineProperty(UploadTask.prototype, "snapshot", {
        get: function get() {
            var externalState = fbsTaskEnums.taskStateFromInternalTaskState(this.state_);
            return new _tasksnapshot.UploadTaskSnapshot(this.transferred_, this.blob_.size(), externalState, this.metadata_, this, this.ref_);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Adds a callback for an event.
     * @param type The type of event to listen for.
     */
    UploadTask.prototype.on = function (type, nextOrObserver, error, completed) {
        if (nextOrObserver === void 0) {
            nextOrObserver = undefined;
        }
        if (error === void 0) {
            error = undefined;
        }
        if (completed === void 0) {
            completed = undefined;
        }
        function typeValidator(_p) {
            if (type !== _taskenums.TaskEvent.STATE_CHANGED) {
                throw "Expected one of the event types: [" + _taskenums.TaskEvent.STATE_CHANGED + "].";
            }
        }
        var nextOrObserverMessage = 'Expected a function or an Object with one of ' + '`next`, `error`, `complete` properties.';
        var nextValidator = fbsArgs.nullFunctionSpec(true).validator;
        var observerValidator = fbsArgs.looseObjectSpec(null, true).validator;
        function nextOrObserverValidator(p) {
            try {
                nextValidator(p);
                return;
            } catch (e) {}
            try {
                observerValidator(p);
                var anyDefined = typeUtils.isJustDef(p['next']) || typeUtils.isJustDef(p['error']) || typeUtils.isJustDef(p['complete']);
                if (!anyDefined) {
                    throw '';
                }
                return;
            } catch (e) {
                throw nextOrObserverMessage;
            }
        }
        var specs = [fbsArgs.stringSpec(typeValidator), fbsArgs.looseObjectSpec(nextOrObserverValidator, true), fbsArgs.nullFunctionSpec(true), fbsArgs.nullFunctionSpec(true)];
        fbsArgs.validate('on', specs, arguments);
        var self = this;
        function makeBinder(specs) {
            function binder(nextOrObserver, error, opt_complete) {
                if (specs !== null) {
                    fbsArgs.validate('on', specs, arguments);
                }
                var observer = new _observer.Observer(nextOrObserver, error, completed);
                self.addObserver_(observer);
                return function () {
                    self.removeObserver_(observer);
                };
            }
            return binder;
        }
        function binderNextOrObserverValidator(p) {
            if (p === null) {
                throw nextOrObserverMessage;
            }
            nextOrObserverValidator(p);
        }
        var binderSpecs = [fbsArgs.looseObjectSpec(binderNextOrObserverValidator), fbsArgs.nullFunctionSpec(true), fbsArgs.nullFunctionSpec(true)];
        var typeOnly = !(typeUtils.isJustDef(nextOrObserver) || typeUtils.isJustDef(error) || typeUtils.isJustDef(completed));
        if (typeOnly) {
            return makeBinder(binderSpecs);
        } else {
            return makeBinder(null)(nextOrObserver, error, completed);
        }
    };
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled The fulfillment callback. Promise chaining works as normal.
     * @param onRejected The rejection callback.
     */
    UploadTask.prototype.then = function (onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this.promise_.then(onFulfilled, onRejected);
    };
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */
    UploadTask.prototype.catch = function (onRejected) {
        return this.then(null, onRejected);
    };
    /**
     * Adds the given observer.
     */
    UploadTask.prototype.addObserver_ = function (observer) {
        this.observers_.push(observer);
        this.notifyObserver_(observer);
    };
    /**
     * Removes the given observer.
     */
    UploadTask.prototype.removeObserver_ = function (observer) {
        fbsArray.remove(this.observers_, observer);
    };
    UploadTask.prototype.notifyObservers_ = function () {
        var _this = this;
        this.finishPromise_();
        var observers = fbsArray.clone(this.observers_);
        observers.forEach(function (observer) {
            _this.notifyObserver_(observer);
        });
    };
    UploadTask.prototype.finishPromise_ = function () {
        if (this.resolve_ !== null) {
            var triggered = true;
            switch (fbsTaskEnums.taskStateFromInternalTaskState(this.state_)) {
                case _taskenums.TaskState.SUCCESS:
                    (0, _async.async)(this.resolve_.bind(null, this.snapshot))();
                    break;
                case _taskenums.TaskState.CANCELED:
                case _taskenums.TaskState.ERROR:
                    var toCall = this.reject_;
                    (0, _async.async)(toCall.bind(null, this.error_))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this.resolve_ = null;
                this.reject_ = null;
            }
        }
    };
    UploadTask.prototype.notifyObserver_ = function (observer) {
        var externalState = fbsTaskEnums.taskStateFromInternalTaskState(this.state_);
        switch (externalState) {
            case _taskenums.TaskState.RUNNING:
            case _taskenums.TaskState.PAUSED:
                if (observer.next !== null) {
                    (0, _async.async)(observer.next.bind(observer, this.snapshot))();
                }
                break;
            case _taskenums.TaskState.SUCCESS:
                if (observer.complete !== null) {
                    (0, _async.async)(observer.complete.bind(observer))();
                }
                break;
            case _taskenums.TaskState.CANCELED:
            case _taskenums.TaskState.ERROR:
                if (observer.error !== null) {
                    (0, _async.async)(observer.error.bind(observer, this.error_))();
                }
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error !== null) {
                    (0, _async.async)(observer.error.bind(observer, this.error_))();
                }
        }
    };
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @return True if the operation took effect, false if ignored.
     */
    UploadTask.prototype.resume = function () {
        fbsArgs.validate('resume', [], arguments);
        var valid = this.state_ === _taskenums.InternalTaskState.PAUSED || this.state_ === _taskenums.InternalTaskState.PAUSING;
        if (valid) {
            this.transition_(_taskenums.InternalTaskState.RUNNING);
        }
        return valid;
    };
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @return True if the operation took effect, false if ignored.
     */
    UploadTask.prototype.pause = function () {
        fbsArgs.validate('pause', [], arguments);
        var valid = this.state_ === _taskenums.InternalTaskState.RUNNING;
        if (valid) {
            this.transition_(_taskenums.InternalTaskState.PAUSING);
        }
        return valid;
    };
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @return True if the operation took effect, false if ignored.
     */
    UploadTask.prototype.cancel = function () {
        fbsArgs.validate('cancel', [], arguments);
        var valid = this.state_ === _taskenums.InternalTaskState.RUNNING || this.state_ === _taskenums.InternalTaskState.PAUSING;
        if (valid) {
            this.transition_(_taskenums.InternalTaskState.CANCELING);
        }
        return valid;
    };
    return UploadTask;
}();
exports.UploadTask = UploadTask;
//# sourceMappingURL=task.js.map


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
var UploadTaskSnapshot = /** @class */function () {
    function UploadTaskSnapshot(bytesTransferred, totalBytes, state, metadata, task, ref) {
        this.bytesTransferred = bytesTransferred;
        this.totalBytes = totalBytes;
        this.state = state;
        this.metadata = metadata;
        this.task = task;
        this.ref = ref;
    }
    Object.defineProperty(UploadTaskSnapshot.prototype, "downloadURL", {
        get: function get() {
            if (this.metadata !== null) {
                var urls = this.metadata['downloadURLs'];
                if (urls != null && urls[0] != null) {
                    return urls[0];
                } else {
                    return null;
                }
            } else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    return UploadTaskSnapshot;
}();
exports.UploadTaskSnapshot = UploadTaskSnapshot;
//# sourceMappingURL=tasksnapshot.js.map


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha1 = undefined;

var _hash = __webpack_require__(437);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();

/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @extends {Hash}
 * @final
 * @struct
 */
var Sha1 = /** @class */function (_super) {
    __extends(Sha1, _super);
    function Sha1() {
        var _this = _super.call(this) || this;
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @type {!Array<number>}
         * @private
         */
        _this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @type {!Array<number>}
         * @private
         */
        _this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @type {!Array<number>}
         * @private
         */
        _this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @type {!Array<number>}
         * @private
         */
        _this.pad_ = [];
        /**
         * @private {number}
         */
        _this.inbuf_ = 0;
        /**
         * @private {number}
         */
        _this.total_ = 0;
        _this.blockSize = 512 / 8;
        _this.pad_[0] = 128;
        for (var i = 1; i < _this.blockSize; ++i) {
            _this.pad_[i] = 0;
        }
        _this.reset();
        return _this;
    }
    Sha1.prototype.reset = function () {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param {!Array<number>|!Uint8Array|string} buf Block to compress.
     * @param {number=} opt_offset Offset of the block in the buffer.
     * @private
     */
    Sha1.prototype.compress_ = function (buf, opt_offset) {
        if (!opt_offset) {
            opt_offset = 0;
        }
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (var i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] = buf.charCodeAt(opt_offset) << 24 | buf.charCodeAt(opt_offset + 1) << 16 | buf.charCodeAt(opt_offset + 2) << 8 | buf.charCodeAt(opt_offset + 3);
                opt_offset += 4;
            }
        } else {
            for (var i = 0; i < 16; i++) {
                W[i] = buf[opt_offset] << 24 | buf[opt_offset + 1] << 16 | buf[opt_offset + 2] << 8 | buf[opt_offset + 3];
                opt_offset += 4;
            }
        }
        // expand to 80 words
        for (var i = 16; i < 80; i++) {
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (var i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else {
                if (i < 60) {
                    f = b & c | d & (b | c);
                    k = 0x8f1bbcdc;
                } else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            var t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    };
    Sha1.prototype.update = function (bytes, opt_length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (opt_length === undefined) {
            opt_length = bytes.length;
        }
        var lengthMinusBlock = opt_length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < opt_length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf == 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < opt_length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            } else {
                while (n < opt_length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += opt_length;
    };
    /** @override */
    Sha1.prototype.digest = function () {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        } else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (var i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for (var i = 0; i < 5; i++) {
            for (var j = 24; j >= 0; j -= 8) {
                digest[n] = this.chain_[i] >> j & 255;
                ++n;
            }
        }
        return digest;
    };
    return Sha1;
}(_hash.Hash);
exports.Sha1 = Sha1;
//# sourceMappingURL=Sha1.js.map


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.base64 = undefined;

var _globalScope = __webpack_require__(194);

var stringToByteArray = function stringToByteArray(str) {
    var output = [],
        p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        while (c > 255) {
            output[p++] = c & 255;
            c >>= 8;
        }
        output[p++] = c;
    }
    return output;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param {Array<number>} bytes Array of numbers representing characters.
 * @return {string} Stringification of the array.
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var byteArrayToString = function byteArrayToString(bytes) {
    var CHUNK_SIZE = 8192;
    // Special-case the simple case for speed's sake.
    if (bytes.length < CHUNK_SIZE) {
        return String.fromCharCode.apply(null, bytes);
    }
    // The remaining logic splits conversion by chunks since
    // Function#apply() has a maximum parameter count.
    // See discussion: http://goo.gl/LrWmZ9
    var str = '';
    for (var i = 0; i < bytes.length; i += CHUNK_SIZE) {
        var chunk = bytes.slice(i, i + CHUNK_SIZE);
        str += String.fromCharCode.apply(null, chunk);
    }
    return str;
};
// Static lookup maps, lazily populated by init_()
var base64 = exports.base64 = {
    /**
     * Maps bytes to characters.
     * @type {Object}
     * @private
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @type {Object}
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     * @type {string}
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     * @type {string}
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     * @type {string}
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     * @type {boolean}
     */
    HAS_NATIVE_SUPPORT: typeof _globalScope.globalScope.atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param {Array<number>|Uint8Array} input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param {boolean=} opt_webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeByteArray: function encodeByteArray(input, opt_webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        var byteToCharMap = opt_webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        var output = [];
        for (var i = 0; i < input.length; i += 3) {
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            var outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param {string} input A string to encode.
     * @param {boolean=} opt_webSafe If true, we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeString: function encodeString(input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray(input), opt_webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param {string} input to decode.
     * @param {boolean=} opt_webSafe True if we should use the
     *     alternative alphabet.
     * @return {string} string representing the decoded value.
     */
    decodeString: function decodeString(input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, opt_webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param {string} input Input to decode.
     * @param {boolean=} opt_webSafe True if we should use the web-safe alphabet.
     * @return {!Array<number>} bytes representing the decoded value.
     */
    decodeStringToByteArray: function decodeStringToByteArray(input, opt_webSafe) {
        this.init_();
        var charToByteMap = opt_webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        var output = [];
        for (var i = 0; i < input.length;) {
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw Error();
            }
            var outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 != 64) {
                var outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 != 64) {
                    var outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_: function init_() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
//# sourceMappingURL=crypt.js.map


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Copyright 2011 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * @fileoverview Abstract cryptographic hash interface.
 *
 * See Sha1 and Md5 for sample implementations.
 *
 */
/**
 * Create a cryptographic hash instance.
 *
 * @constructor
 * @struct
 */
var Hash = /** @class */function () {
  function Hash() {
    /**
     * The block size for the hasher.
     * @type {number}
     */
    this.blockSize = -1;
  }
  return Hash;
}();
exports.Hash = Hash;
//# sourceMappingURL=hash.js.map


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isAdmin = exports.isValidFormat = exports.issuedAtTime = exports.isValidTimestamp = exports.decode = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Copyright 2017 Google Inc.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Licensed under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                               * you may not use this file except in compliance with the License.
                                                                                                                                                                                                                                                                               * You may obtain a copy of the License at
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               *   http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Unless required by applicable law or agreed to in writing, software
                                                                                                                                                                                                                                                                               * distributed under the License is distributed on an "AS IS" BASIS,
                                                                                                                                                                                                                                                                               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                                                                                                                                                                                                               * See the License for the specific language governing permissions and
                                                                                                                                                                                                                                                                               * limitations under the License.
                                                                                                                                                                                                                                                                               */


var _util = __webpack_require__(3);

var _json = __webpack_require__(23);

/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {{header: *, claims: *, data: *, signature: string}}
 */
var decode = exports.decode = function decode(token) {
    var header = {},
        claims = {},
        data = {},
        signature = '';
    try {
        var parts = token.split('.');
        header = (0, _json.jsonEval)((0, _util.base64Decode)(parts[0]) || '');
        claims = (0, _json.jsonEval)((0, _util.base64Decode)(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isValidTimestamp = exports.isValidTimestamp = function isValidTimestamp(token) {
    var claims = decode(token).claims,
        now = Math.floor(new Date().getTime() / 1000),
        validSince,
        validUntil;
    if ((typeof claims === 'undefined' ? 'undefined' : _typeof(claims)) === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        } else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        } else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return now && validSince && validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {?number}
 */
var issuedAtTime = exports.issuedAtTime = function issuedAtTime(token) {
    var claims = decode(token).claims;
    if ((typeof claims === 'undefined' ? 'undefined' : _typeof(claims)) === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time and non-empty
 * signature.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isValidFormat = exports.isValidFormat = function isValidFormat(token) {
    var decoded = decode(token),
        claims = decoded.claims;
    return !!decoded.signature && !!claims && (typeof claims === 'undefined' ? 'undefined' : _typeof(claims)) === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isAdmin = exports.isAdmin = function isAdmin(token) {
    var claims = decode(token).claims;
    return (typeof claims === 'undefined' ? 'undefined' : _typeof(claims)) === 'object' && claims['admin'] === true;
};
//# sourceMappingURL=jwt.js.map


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This is the Array.prototype.findIndex polyfill from MDN
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
 * https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
 */
if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
        value: function value(predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }
            var o = Object(this);
            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;
            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];
            // 5. Let k be 0.
            var k = 0;
            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return k.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return k;
                }
                // e. Increase k by 1.
                k++;
            }
            // 7. Return -1.
            return -1;
        }
    });
}
/**
 * This is the Array.prototype.find polyfill from MDN
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
 * https://tc39.github.io/ecma262/#sec-array.prototype.find
 */
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function value(predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }
            var o = Object(this);
            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;
            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];
            // 5. Let k be 0.
            var k = 0;
            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }
            // 7. Return undefined.
            return undefined;
        }
    });
}
//# sourceMappingURL=shims.js.map


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.querystringDecode = exports.querystring = undefined;

var _obj = __webpack_require__(7);

/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a params
 * object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 *
 * @param {!Object} querystringParams
 * @return {string}
 */
var querystring = exports.querystring = function querystring(querystringParams) {
    var params = [];
    (0, _obj.forEach)(querystringParams, function (key, value) {
        if (Array.isArray(value)) {
            value.forEach(function (arrayVal) {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        } else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    });
    return params.length ? '&' + params.join('&') : '';
};
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object (e.g. {arg: 'val', arg2: 'val2'})
 *
 * @param {string} querystring
 * @return {!Object}
 */
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var querystringDecode = exports.querystringDecode = function querystringDecode(querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function (token) {
        if (token) {
            var key = token.split('=');
            obj[key[0]] = key[1];
        }
    });
    return obj;
};
//# sourceMappingURL=util.js.map


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(447);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(42)))

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(448);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(195);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(444);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(196);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._81 = 1;
  p._65 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._81 === 3) {
            val = val._65;
          }
          if (val._81 === 1) return res(i, val._65);
          if (val._81 === 2) reject(val._65);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(196);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._10 = null;
  Promise._97 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._10 = function (promise) {
    if (
      promise._81 === 2 && // IS REJECTED
      rejections[promise._72]
    ) {
      if (rejections[promise._72].logged) {
        onHandled(promise._72);
      } else {
        clearTimeout(rejections[promise._72].timeout);
      }
      delete rejections[promise._72];
    }
  };
  Promise._97 = function (promise, err) {
    if (promise._45 === 0) { // not yet handled
      promise._72 = id++;
      rejections[promise._72] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._72),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(18);
var invariant = __webpack_require__(1);
var ReactPropTypesSecret = __webpack_require__(199);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(18);
var invariant = __webpack_require__(1);
var warning = __webpack_require__(4);

var ReactPropTypesSecret = __webpack_require__(199);
var checkPropTypes = __webpack_require__(453);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(470);


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(10);

var focusNode = __webpack_require__(154);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(64);
var ExecutionEnvironment = __webpack_require__(14);
var FallbackCompositionState = __webpack_require__(465);
var SyntheticCompositionEvent = __webpack_require__(502);
var SyntheticInputEvent = __webpack_require__(505);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(200);
var ExecutionEnvironment = __webpack_require__(14);
var ReactInstrumentation = __webpack_require__(22);

var camelizeStyleName = __webpack_require__(357);
var dangerousStyleValue = __webpack_require__(511);
var hyphenateStyleName = __webpack_require__(364);
var memoizeStringOnly = __webpack_require__(367);
var warning = __webpack_require__(4);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(63);
var EventPropagators = __webpack_require__(64);
var ExecutionEnvironment = __webpack_require__(14);
var ReactDOMComponentTree = __webpack_require__(10);
var ReactUpdates = __webpack_require__(24);
var SyntheticEvent = __webpack_require__(27);

var inputValueTracking = __webpack_require__(216);
var getEventTarget = __webpack_require__(129);
var isEventSupported = __webpack_require__(130);
var isTextInputElement = __webpack_require__(218);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var DOMLazyTree = __webpack_require__(51);
var ExecutionEnvironment = __webpack_require__(14);

var createNodesFromMarkup = __webpack_require__(360);
var emptyFunction = __webpack_require__(18);
var invariant = __webpack_require__(1);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(64);
var ReactDOMComponentTree = __webpack_require__(10);
var SyntheticMouseEvent = __webpack_require__(89);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var PooledClass = __webpack_require__(41);

var getTextContentAccessor = __webpack_require__(215);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(52);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(53);

var instantiateReactComponent = __webpack_require__(217);
var KeyEscapeUtils = __webpack_require__(121);
var shouldUpdateReactComponent = __webpack_require__(131);
var traverseAllChildren = __webpack_require__(220);
var warning = __webpack_require__(4);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"/garage48-vrideas"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(226);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)))

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(117);
var ReactDOMIDOperations = __webpack_require__(475);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(8);

var React = __webpack_require__(54);
var ReactComponentEnvironment = __webpack_require__(123);
var ReactCurrentOwner = __webpack_require__(29);
var ReactErrorUtils = __webpack_require__(124);
var ReactInstanceMap = __webpack_require__(65);
var ReactInstrumentation = __webpack_require__(22);
var ReactNodeTypes = __webpack_require__(210);
var ReactReconciler = __webpack_require__(53);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(75);
var invariant = __webpack_require__(1);
var shallowEqual = __webpack_require__(102);
var shouldUpdateReactComponent = __webpack_require__(131);
var warning = __webpack_require__(4);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(10);
var ReactDefaultInjection = __webpack_require__(483);
var ReactMount = __webpack_require__(209);
var ReactReconciler = __webpack_require__(53);
var ReactUpdates = __webpack_require__(24);
var ReactVersion = __webpack_require__(496);

var findDOMNode = __webpack_require__(512);
var getHostComponentFromComposite = __webpack_require__(214);
var renderSubtreeIntoContainer = __webpack_require__(519);
var warning = __webpack_require__(4);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(8);

var AutoFocusUtils = __webpack_require__(458);
var CSSPropertyOperations = __webpack_require__(460);
var DOMLazyTree = __webpack_require__(51);
var DOMNamespaces = __webpack_require__(118);
var DOMProperty = __webpack_require__(52);
var DOMPropertyOperations = __webpack_require__(202);
var EventPluginHub = __webpack_require__(63);
var EventPluginRegistry = __webpack_require__(119);
var ReactBrowserEventEmitter = __webpack_require__(88);
var ReactDOMComponentFlags = __webpack_require__(203);
var ReactDOMComponentTree = __webpack_require__(10);
var ReactDOMInput = __webpack_require__(476);
var ReactDOMOption = __webpack_require__(477);
var ReactDOMSelect = __webpack_require__(204);
var ReactDOMTextarea = __webpack_require__(480);
var ReactInstrumentation = __webpack_require__(22);
var ReactMultiChild = __webpack_require__(489);
var ReactServerRenderingTransaction = __webpack_require__(494);

var emptyFunction = __webpack_require__(18);
var escapeTextContentForBrowser = __webpack_require__(91);
var invariant = __webpack_require__(1);
var isEventSupported = __webpack_require__(130);
var shallowEqual = __webpack_require__(102);
var inputValueTracking = __webpack_require__(216);
var validateDOMNesting = __webpack_require__(132);
var warning = __webpack_require__(4);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(132);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var DOMLazyTree = __webpack_require__(51);
var ReactDOMComponentTree = __webpack_require__(10);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(117);
var ReactDOMComponentTree = __webpack_require__(10);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(8);

var DOMPropertyOperations = __webpack_require__(202);
var LinkedValueUtils = __webpack_require__(122);
var ReactDOMComponentTree = __webpack_require__(10);
var ReactUpdates = __webpack_require__(24);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(4);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var React = __webpack_require__(54);
var ReactDOMComponentTree = __webpack_require__(10);
var ReactDOMSelect = __webpack_require__(204);

var warning = __webpack_require__(4);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(14);

var getNodeForCharacterOffset = __webpack_require__(516);
var getTextContentAccessor = __webpack_require__(215);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(8);

var DOMChildrenOperations = __webpack_require__(117);
var DOMLazyTree = __webpack_require__(51);
var ReactDOMComponentTree = __webpack_require__(10);

var escapeTextContentForBrowser = __webpack_require__(91);
var invariant = __webpack_require__(1);
var validateDOMNesting = __webpack_require__(132);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(8);

var LinkedValueUtils = __webpack_require__(122);
var ReactDOMComponentTree = __webpack_require__(10);
var ReactUpdates = __webpack_require__(24);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(4);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(1);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var ReactUpdates = __webpack_require__(24);
var Transaction = __webpack_require__(90);

var emptyFunction = __webpack_require__(18);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(457);
var BeforeInputEventPlugin = __webpack_require__(459);
var ChangeEventPlugin = __webpack_require__(461);
var DefaultEventPluginOrder = __webpack_require__(463);
var EnterLeaveEventPlugin = __webpack_require__(464);
var HTMLDOMPropertyConfig = __webpack_require__(466);
var ReactComponentBrowserEnvironment = __webpack_require__(468);
var ReactDOMComponent = __webpack_require__(471);
var ReactDOMComponentTree = __webpack_require__(10);
var ReactDOMEmptyComponent = __webpack_require__(473);
var ReactDOMTreeTraversal = __webpack_require__(481);
var ReactDOMTextComponent = __webpack_require__(479);
var ReactDefaultBatchingStrategy = __webpack_require__(482);
var ReactEventListener = __webpack_require__(486);
var ReactInjection = __webpack_require__(487);
var ReactReconcileTransaction = __webpack_require__(492);
var SVGDOMPropertyConfig = __webpack_require__(497);
var SelectEventPlugin = __webpack_require__(498);
var SimpleEventPlugin = __webpack_require__(499);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(63);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var EventListener = __webpack_require__(153);
var ExecutionEnvironment = __webpack_require__(14);
var PooledClass = __webpack_require__(41);
var ReactDOMComponentTree = __webpack_require__(10);
var ReactUpdates = __webpack_require__(24);

var getEventTarget = __webpack_require__(129);
var getUnboundedScrollPosition = __webpack_require__(362);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(52);
var EventPluginHub = __webpack_require__(63);
var EventPluginUtils = __webpack_require__(120);
var ReactComponentEnvironment = __webpack_require__(123);
var ReactEmptyComponent = __webpack_require__(205);
var ReactBrowserEventEmitter = __webpack_require__(88);
var ReactHostComponent = __webpack_require__(207);
var ReactUpdates = __webpack_require__(24);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(510);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactComponentEnvironment = __webpack_require__(123);
var ReactInstanceMap = __webpack_require__(65);
var ReactInstrumentation = __webpack_require__(22);

var ReactCurrentOwner = __webpack_require__(29);
var ReactReconciler = __webpack_require__(53);
var ReactChildReconciler = __webpack_require__(467);

var emptyFunction = __webpack_require__(18);
var flattenChildren = __webpack_require__(513);
var invariant = __webpack_require__(1);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(1);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var CallbackQueue = __webpack_require__(201);
var PooledClass = __webpack_require__(41);
var ReactBrowserEventEmitter = __webpack_require__(88);
var ReactInputSelection = __webpack_require__(208);
var ReactInstrumentation = __webpack_require__(22);
var Transaction = __webpack_require__(90);
var ReactUpdateQueue = __webpack_require__(125);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(490);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var PooledClass = __webpack_require__(41);
var Transaction = __webpack_require__(90);
var ReactInstrumentation = __webpack_require__(22);
var ReactServerUpdateQueue = __webpack_require__(495);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(125);

var warning = __webpack_require__(4);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(64);
var ExecutionEnvironment = __webpack_require__(14);
var ReactDOMComponentTree = __webpack_require__(10);
var ReactInputSelection = __webpack_require__(208);
var SyntheticEvent = __webpack_require__(27);

var getActiveElement = __webpack_require__(155);
var isTextInputElement = __webpack_require__(218);
var shallowEqual = __webpack_require__(102);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var EventListener = __webpack_require__(153);
var EventPropagators = __webpack_require__(64);
var ReactDOMComponentTree = __webpack_require__(10);
var SyntheticAnimationEvent = __webpack_require__(500);
var SyntheticClipboardEvent = __webpack_require__(501);
var SyntheticEvent = __webpack_require__(27);
var SyntheticFocusEvent = __webpack_require__(504);
var SyntheticKeyboardEvent = __webpack_require__(506);
var SyntheticMouseEvent = __webpack_require__(89);
var SyntheticDragEvent = __webpack_require__(503);
var SyntheticTouchEvent = __webpack_require__(507);
var SyntheticTransitionEvent = __webpack_require__(508);
var SyntheticUIEvent = __webpack_require__(66);
var SyntheticWheelEvent = __webpack_require__(509);

var emptyFunction = __webpack_require__(18);
var getEventCharCode = __webpack_require__(127);
var invariant = __webpack_require__(1);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(27);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(27);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(27);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(89);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(66);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(27);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(66);

var getEventCharCode = __webpack_require__(127);
var getEventKey = __webpack_require__(514);
var getEventModifierState = __webpack_require__(128);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(66);

var getEventModifierState = __webpack_require__(128);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(27);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(89);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(200);
var warning = __webpack_require__(4);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactCurrentOwner = __webpack_require__(29);
var ReactDOMComponentTree = __webpack_require__(10);
var ReactInstanceMap = __webpack_require__(65);

var getHostComponentFromComposite = __webpack_require__(214);
var invariant = __webpack_require__(1);
var warning = __webpack_require__(4);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(121);
var traverseAllChildren = __webpack_require__(220);
var warning = __webpack_require__(4);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"/garage48-vrideas"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(226);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)))

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(127);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(14);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(91);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactMount = __webpack_require__(209);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(133);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  Provider.displayName = 'Provider';

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(525);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(222);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(222);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(224);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(526);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(133);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(67);

var invariant = __webpack_require__(1);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(530);
var ReactElement = __webpack_require__(55);

var emptyFunction = __webpack_require__(18);
var traverseAllChildren = __webpack_require__(540);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(55);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(55),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(197);

module.exports = factory(isValidElement);

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(225),
    Component = _require.Component;

var _require2 = __webpack_require__(55),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(228);
var factory = __webpack_require__(355);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(67);

var ReactElement = __webpack_require__(55);

var invariant = __webpack_require__(1);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(67);

var ReactCurrentOwner = __webpack_require__(29);
var REACT_ELEMENT_TYPE = __webpack_require__(227);

var getIteratorFn = __webpack_require__(536);
var invariant = __webpack_require__(1);
var KeyEscapeUtils = __webpack_require__(529);
var warning = __webpack_require__(4);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(21).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(230);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(232);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42), __webpack_require__(87)))

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(550);


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var encode = __webpack_require__(233);
var alphabet = __webpack_require__(93);

// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var REDUCE_TIME = 1459707606518;

// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var version = 6;

// Counter is used when shortid is called multiple times in one second.
var counter;

// Remember the last time shortid was called in case counter is needed.
var previousSeconds;

/**
 * Generate unique id
 * Returns string id
 */
function build(clusterWorkerId) {

    var str = '';

    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);

    if (seconds === previousSeconds) {
        counter++;
    } else {
        counter = 0;
        previousSeconds = seconds;
    }

    str = str + encode(alphabet.lookup, version);
    str = str + encode(alphabet.lookup, clusterWorkerId);
    if (counter > 0) {
        str = str + encode(alphabet.lookup, counter);
    }
    str = str + encode(alphabet.lookup, seconds);

    return str;
}

module.exports = build;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__(93);

/**
 * Decode the id to get the version and worker
 * Mainly for debugging and testing.
 * @param id - the shortid-generated id.
 */
function decode(id) {
    var characters = alphabet.shuffled();
    return {
        version: characters.indexOf(id.substr(0, 1)) & 0x0f,
        worker: characters.indexOf(id.substr(1, 1)) & 0x0f
    };
}

module.exports = decode;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__(93);
var encode = __webpack_require__(233);
var decode = __webpack_require__(549);
var build = __webpack_require__(548);
var isValid = __webpack_require__(551);

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var clusterWorkerId = __webpack_require__(554) || 0;

/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */
function seed(seedValue) {
    alphabet.seed(seedValue);
    return module.exports;
}

/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */
function worker(workerId) {
    clusterWorkerId = workerId;
    return module.exports;
}

/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */
function characters(newCharacters) {
    if (newCharacters !== undefined) {
        alphabet.characters(newCharacters);
    }

    return alphabet.shuffled();
}

/**
 * Generate unique id
 * Returns string id
 */
function generate() {
  return build(clusterWorkerId);
}

// Export all other functions as properties of the generate function
module.exports = generate;
module.exports.generate = generate;
module.exports.seed = seed;
module.exports.worker = worker;
module.exports.characters = characters;
module.exports.decode = decode;
module.exports.isValid = isValid;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__(93);

function isShortId(id) {
    if (!id || typeof id !== 'string' || id.length < 6 ) {
        return false;
    }

    var characters = alphabet.characters();
    var len = id.length;
    for(var i = 0; i < len;i++) {
        if (characters.indexOf(id[i]) === -1) {
            return false;
        }
    }
    return true;
}

module.exports = isShortId;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto

function randomByte() {
    if (!crypto || !crypto.getRandomValues) {
        return Math.floor(Math.random() * 256) & 0x30;
    }
    var dest = new Uint8Array(1);
    crypto.getRandomValues(dest);
    return dest[0] & 0x30;
}

module.exports = randomByte;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)

var seed = 1;

/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */
function getNextValue() {
    seed = (seed * 9301 + 49297) % 233280;
    return seed/(233280.0);
}

function setSeed(_seed_) {
    seed = _seed_;
}

module.exports = {
    nextValue: getNextValue,
    seed: setSeed
};


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = 0;


/***/ }),
/* 555 */
/***/ (function(module, exports) {

// stats.js - http://github.com/mrdoob/stats.js
var Stats=function(){var l=Date.now(),m=l,g=0,n=Infinity,o=0,h=0,p=Infinity,q=0,r=0,s=0,f=document.createElement("div");f.id="stats";f.addEventListener("mousedown",function(b){b.preventDefault();t(++s%2)},!1);f.style.cssText="width:80px;opacity:0.9;cursor:pointer";var a=document.createElement("div");a.id="fps";a.style.cssText="padding:0 0 3px 3px;text-align:left;background-color:#002";f.appendChild(a);var i=document.createElement("div");i.id="fpsText";i.style.cssText="color:#0ff;font-family:Helvetica,Arial,sans-serif;font-size:9px;font-weight:bold;line-height:15px";
i.innerHTML="FPS";a.appendChild(i);var c=document.createElement("div");c.id="fpsGraph";c.style.cssText="position:relative;width:74px;height:30px;background-color:#0ff";for(a.appendChild(c);74>c.children.length;){var j=document.createElement("span");j.style.cssText="width:1px;height:30px;float:left;background-color:#113";c.appendChild(j)}var d=document.createElement("div");d.id="ms";d.style.cssText="padding:0 0 3px 3px;text-align:left;background-color:#020;display:none";f.appendChild(d);var k=document.createElement("div");
k.id="msText";k.style.cssText="color:#0f0;font-family:Helvetica,Arial,sans-serif;font-size:9px;font-weight:bold;line-height:15px";k.innerHTML="MS";d.appendChild(k);var e=document.createElement("div");e.id="msGraph";e.style.cssText="position:relative;width:74px;height:30px;background-color:#0f0";for(d.appendChild(e);74>e.children.length;)j=document.createElement("span"),j.style.cssText="width:1px;height:30px;float:left;background-color:#131",e.appendChild(j);var t=function(b){s=b;switch(s){case 0:a.style.display=
"block";d.style.display="none";break;case 1:a.style.display="none",d.style.display="block"}};return{REVISION:12,domElement:f,setMode:t,begin:function(){l=Date.now()},end:function(){var b=Date.now();g=b-l;n=Math.min(n,g);o=Math.max(o,g);k.textContent=g+" MS ("+n+"-"+o+")";var a=Math.min(30,30-30*(g/200));e.appendChild(e.firstChild).style.height=a+"px";r++;b>m+1E3&&(h=Math.round(1E3*r/(b-m)),p=Math.min(p,h),q=Math.max(q,h),i.textContent=h+" FPS ("+p+"-"+q+")",a=Math.min(30,30-30*(h/100)),c.appendChild(c.firstChild).style.height=
a+"px",m=b,r=0);return b},update:function(){l=this.end()}}};"object"===typeof module&&(module.exports=Stats);


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(557);


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(558);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42), __webpack_require__(1462)(module)))

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var CANNON = __webpack_require__(43),
    quickhull = __webpack_require__(560);

var PI_2 = Math.PI / 2;

var Type = {
  BOX: 'Box',
  CYLINDER: 'Cylinder',
  SPHERE: 'Sphere',
  HULL: 'ConvexPolyhedron',
  MESH: 'Trimesh'
};

/**
 * Given a THREE.Object3D instance, creates a corresponding CANNON shape.
 * @param  {THREE.Object3D} object
 * @return {CANNON.Shape}
 */
module.exports = CANNON.mesh2shape = function (object, options) {
  options = options || {};

  var geometry;

  if (options.type === Type.BOX) {
    return createBoundingBoxShape(object);
  } else if (options.type === Type.CYLINDER) {
    return createBoundingCylinderShape(object, options);
  } else if (options.type === Type.SPHERE) {
    return createBoundingSphereShape(object, options);
  } else if (options.type === Type.HULL) {
    return createConvexPolyhedron(object);
  } else if (options.type === Type.MESH) {
    geometry = getGeometry(object);
    return geometry ? createTrimeshShape(geometry) : null;
  } else if (options.type) {
    throw new Error('[CANNON.mesh2shape] Invalid type "%s".', options.type);
  }

  geometry = getGeometry(object);
  if (!geometry) return null;

  var type = geometry.metadata
    ? geometry.metadata.type
    : geometry.type;

  switch (type) {
    case 'BoxGeometry':
    case 'BoxBufferGeometry':
      return createBoxShape(geometry);
    case 'CylinderGeometry':
    case 'CylinderBufferGeometry':
      return createCylinderShape(geometry);
    case 'PlaneGeometry':
    case 'PlaneBufferGeometry':
      return createPlaneShape(geometry);
    case 'SphereGeometry':
    case 'SphereBufferGeometry':
      return createSphereShape(geometry);
    case 'TubeGeometry':
    case 'Geometry':
    case 'BufferGeometry':
      return createBoundingBoxShape(object);
    default:
      console.warn('Unrecognized geometry: "%s". Using bounding box as shape.', geometry.type);
      return createBoxShape(geometry);
  }
};

CANNON.mesh2shape.Type = Type;

/******************************************************************************
 * Shape construction
 */

 /**
  * @param  {THREE.Geometry} geometry
  * @return {CANNON.Shape}
  */
 function createBoxShape (geometry) {
   var vertices = getVertices(geometry);

   if (!vertices.length) return null;

   geometry.computeBoundingBox();
   var box = geometry.boundingBox;
   return new CANNON.Box(new CANNON.Vec3(
     (box.max.x - box.min.x) / 2,
     (box.max.y - box.min.y) / 2,
     (box.max.z - box.min.z) / 2
   ));
 }

/**
 * Bounding box needs to be computed with the entire mesh, not just geometry.
 * @param  {THREE.Object3D} mesh
 * @return {CANNON.Shape}
 */
function createBoundingBoxShape (object) {
  var shape, localPosition, worldPosition,
      box = new THREE.Box3();

  box.setFromObject(object);

  if (!isFinite(box.min.lengthSq())) return null;

  shape = new CANNON.Box(new CANNON.Vec3(
    (box.max.x - box.min.x) / 2,
    (box.max.y - box.min.y) / 2,
    (box.max.z - box.min.z) / 2
  ));

  object.updateMatrixWorld();
  worldPosition = new THREE.Vector3();
  worldPosition.setFromMatrixPosition(object.matrixWorld);
  localPosition = box.translate(worldPosition.negate()).getCenter();
  if (localPosition.lengthSq()) {
    shape.offset = localPosition;
  }

  return shape;
}

/**
 * Computes 3D convex hull as a CANNON.ConvexPolyhedron.
 * @param  {THREE.Object3D} mesh
 * @return {CANNON.Shape}
 */
function createConvexPolyhedron (object) {
  var i, vertices, faces, hull,
      eps = 1e-4,
      geometry = getGeometry(object);

  if (!geometry || !geometry.vertices.length) return null;

  // Perturb.
  for (i = 0; i < geometry.vertices.length; i++) {
    geometry.vertices[i].x += (Math.random() - 0.5) * eps;
    geometry.vertices[i].y += (Math.random() - 0.5) * eps;
    geometry.vertices[i].z += (Math.random() - 0.5) * eps;
  }

  // Compute the 3D convex hull.
  hull = quickhull(geometry);

  // Convert from THREE.Vector3 to CANNON.Vec3.
  vertices = new Array(hull.vertices.length);
  for (i = 0; i < hull.vertices.length; i++) {
    vertices[i] = new CANNON.Vec3(hull.vertices[i].x, hull.vertices[i].y, hull.vertices[i].z);
  }

  // Convert from THREE.Face to Array<number>.
  faces = new Array(hull.faces.length);
  for (i = 0; i < hull.faces.length; i++) {
    faces[i] = [hull.faces[i].a, hull.faces[i].b, hull.faces[i].c];
  }

  return new CANNON.ConvexPolyhedron(vertices, faces);
}

/**
 * @param  {THREE.Geometry} geometry
 * @return {CANNON.Shape}
 */
function createCylinderShape (geometry) {
  var shape,
      params = geometry.metadata
        ? geometry.metadata.parameters
        : geometry.parameters;
  shape = new CANNON.Cylinder(
    params.radiusTop,
    params.radiusBottom,
    params.height,
    params.radialSegments
  );

  // Include metadata for serialization.
  shape._type = CANNON.Shape.types.CYLINDER; // Patch schteppe/cannon.js#329.
  shape.radiusTop = params.radiusTop;
  shape.radiusBottom = params.radiusBottom;
  shape.height = params.height;
  shape.numSegments = params.radialSegments;

  shape.orientation = new CANNON.Quaternion();
  shape.orientation.setFromEuler(THREE.Math.degToRad(-90), 0, 0, 'XYZ').normalize();
  return shape;
}

/**
 * @param  {THREE.Object3D} object
 * @return {CANNON.Shape}
 */
function createBoundingCylinderShape (object, options) {
  var shape, height, radius,
      box = new THREE.Box3(),
      axes = ['x', 'y', 'z'],
      majorAxis = options.cylinderAxis || 'y',
      minorAxes = axes.splice(axes.indexOf(majorAxis), 1) && axes;

  box.setFromObject(object);

  if (!isFinite(box.min.lengthSq())) return null;

  // Compute cylinder dimensions.
  height = box.max[majorAxis] - box.min[majorAxis];
  radius = 0.5 * Math.max(
    box.max[minorAxes[0]] - box.min[minorAxes[0]],
    box.max[minorAxes[1]] - box.min[minorAxes[1]]
  );

  // Create shape.
  shape = new CANNON.Cylinder(radius, radius, height, 12);

  // Include metadata for serialization.
  shape._type = CANNON.Shape.types.CYLINDER; // Patch schteppe/cannon.js#329.
  shape.radiusTop = radius;
  shape.radiusBottom = radius;
  shape.height = height;
  shape.numSegments = 12;

  shape.orientation = new CANNON.Quaternion();
  shape.orientation.setFromEuler(
    majorAxis === 'y' ? PI_2 : 0,
    majorAxis === 'z' ? PI_2 : 0,
    0,
    'XYZ'
  ).normalize();
  return shape;
}

/**
 * @param  {THREE.Geometry} geometry
 * @return {CANNON.Shape}
 */
function createPlaneShape (geometry) {
  geometry.computeBoundingBox();
  var box = geometry.boundingBox;
  return new CANNON.Box(new CANNON.Vec3(
    (box.max.x - box.min.x) / 2 || 0.1,
    (box.max.y - box.min.y) / 2 || 0.1,
    (box.max.z - box.min.z) / 2 || 0.1
  ));
}

/**
 * @param  {THREE.Geometry} geometry
 * @return {CANNON.Shape}
 */
function createSphereShape (geometry) {
  var params = geometry.metadata
    ? geometry.metadata.parameters
    : geometry.parameters;
  return new CANNON.Sphere(params.radius);
}

/**
 * @param  {THREE.Object3D} object
 * @return {CANNON.Shape}
 */
function createBoundingSphereShape (object, options) {
  if (options.sphereRadius) {
    return new CANNON.Sphere(options.sphereRadius);
  }
  var geometry = getGeometry(object);
  if (!geometry) return null;
  geometry.computeBoundingSphere();
  return new CANNON.Sphere(geometry.boundingSphere.radius);
}

/**
 * @param  {THREE.Geometry} geometry
 * @return {CANNON.Shape}
 */
function createTrimeshShape (geometry) {
  var indices,
      vertices = getVertices(geometry);

  if (!vertices.length) return null;

  indices = Object.keys(vertices).map(Number);
  return new CANNON.Trimesh(vertices, indices);
}

/******************************************************************************
 * Utils
 */

/**
 * Returns a single geometry for the given object. If the object is compound,
 * its geometries are automatically merged.
 * @param {THREE.Object3D} object
 * @return {THREE.Geometry}
 */
function getGeometry (object) {
  var matrix, mesh,
      meshes = getMeshes(object),
      tmp = new THREE.Geometry(),
      combined = new THREE.Geometry();

  if (meshes.length === 0) return null;

  // Apply scale  – it can't easily be applied to a CANNON.Shape later.
  if (meshes.length === 1) {
    var position = new THREE.Vector3(),
        quaternion = new THREE.Quaternion(),
        scale = new THREE.Vector3();
    if (meshes[0].geometry instanceof THREE.BufferGeometry) {
      if (meshes[0].geometry.attributes.position) {
        tmp.fromBufferGeometry(meshes[0].geometry);
      }
    } else {
      tmp = meshes[0].geometry.clone();
    }
    tmp.metadata = meshes[0].geometry.metadata;
    meshes[0].updateMatrixWorld();
    meshes[0].matrixWorld.decompose(position, quaternion, scale);
    return tmp.scale(scale.x, scale.y, scale.z);
  }

  // Recursively merge geometry, preserving local transforms.
  while ((mesh = meshes.pop())) {
    mesh.updateMatrixWorld();
    if (mesh.geometry instanceof THREE.BufferGeometry) {
      tmp.fromBufferGeometry(mesh.geometry);
      combined.merge(tmp, mesh.matrixWorld);
    } else {
      combined.merge(mesh.geometry, mesh.matrixWorld);
    }
  }

  matrix = new THREE.Matrix4();
  matrix.scale(object.scale);
  combined.applyMatrix(matrix);
  return combined;
}

/**
 * @param  {THREE.Geometry} geometry
 * @return {Array<number>}
 */
function getVertices (geometry) {
  if (!geometry.attributes) {
    geometry = new THREE.BufferGeometry().fromGeometry(geometry);
  }
  return (geometry.attributes.position || {}).array || [];
}

/**
 * Returns a flat array of THREE.Mesh instances from the given object. If
 * nested transformations are found, they are applied to child meshes
 * as mesh.userData.matrix, so that each mesh has its position/rotation/scale
 * independently of all of its parents except the top-level object.
 * @param  {THREE.Object3D} object
 * @return {Array<THREE.Mesh>}
 */
function getMeshes (object) {
  var meshes = [];
  object.traverse(function (o) {
    if (o.type === 'Mesh') {
      meshes.push(o);
    }
  });
  return meshes;
}


/***/ }),
/* 560 */
/***/ (function(module, exports) {

/**

  QuickHull
  ---------

  The MIT License

  Copyright &copy; 2010-2014 three.js authors

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN

  THE SOFTWARE.


    @author mark lundin / http://mark-lundin.com

    This is a 3D implementation of the Quick Hull algorithm.
    It is a fast way of computing a convex hull with average complexity
    of O(n log(n)).
    It uses depends on three.js and is supposed to create THREE.Geometry.

    It's also very messy

 */

module.exports = (function(){


  var faces     = [],
    faceStack   = [],
    i, NUM_POINTS, extremes,
    max     = 0,
    dcur, current, j, v0, v1, v2, v3,
    N, D;

  var ab, ac, ax,
    suba, subb, normal,
    diff, subaA, subaB, subC;

  function reset(){

    ab    = new THREE.Vector3(),
    ac    = new THREE.Vector3(),
    ax    = new THREE.Vector3(),
    suba  = new THREE.Vector3(),
    subb  = new THREE.Vector3(),
    normal  = new THREE.Vector3(),
    diff  = new THREE.Vector3(),
    subaA = new THREE.Vector3(),
    subaB = new THREE.Vector3(),
    subC  = new THREE.Vector3();

  }

  //temporary vectors

  function process( points ){

    // Iterate through all the faces and remove
    while( faceStack.length > 0  ){
      cull( faceStack.shift(), points );
    }
  }


  var norm = function(){

    var ca = new THREE.Vector3(),
      ba = new THREE.Vector3(),
      N = new THREE.Vector3();

    return function( a, b, c ){

      ca.subVectors( c, a );
      ba.subVectors( b, a );

      N.crossVectors( ca, ba );

      return N.normalize();
    }

  }();


  function getNormal( face, points ){

    if( face.normal !== undefined ) return face.normal;

    var p0 = points[face[0]],
      p1 = points[face[1]],
      p2 = points[face[2]];

    ab.subVectors( p1, p0 );
    ac.subVectors( p2, p0 );
    normal.crossVectors( ac, ab );
    normal.normalize();

    return face.normal = normal.clone();

  }


  function assignPoints( face, pointset, points ){

    // ASSIGNING POINTS TO FACE
    var p0 = points[face[0]],
      dots = [], apex,
      norm = getNormal( face, points );


    // Sory all the points by there distance from the plane
    pointset.sort( function( aItem, bItem ){


      dots[aItem.x/3] = dots[aItem.x/3] !== undefined ? dots[aItem.x/3] : norm.dot( suba.subVectors( aItem, p0 ));
      dots[bItem.x/3] = dots[bItem.x/3] !== undefined ? dots[bItem.x/3] : norm.dot( subb.subVectors( bItem, p0 ));

      return dots[aItem.x/3] - dots[bItem.x/3] ;
    });

    //TODO :: Must be a faster way of finding and index in this array
    var index = pointset.length;

    if( index === 1 ) dots[pointset[0].x/3] = norm.dot( suba.subVectors( pointset[0], p0 ));
    while( index-- > 0 && dots[pointset[index].x/3] > 0 )

    var point;
    if( index + 1 < pointset.length && dots[pointset[index+1].x/3] > 0 ){

      face.visiblePoints  = pointset.splice( index + 1 );
    }
  }




  function cull( face, points ){

    var i = faces.length,
      dot, visibleFace, currentFace,
      visibleFaces = [face];

    var apex = points.indexOf( face.visiblePoints.pop() );

    // Iterate through all other faces...
    while( i-- > 0 ){
      currentFace = faces[i];
      if( currentFace !== face ){
        // ...and check if they're pointing in the same direction
        dot = getNormal( currentFace, points ).dot( diff.subVectors( points[apex], points[currentFace[0]] ));
        if( dot > 0 ){
          visibleFaces.push( currentFace );
        }
      }
    }

    var index, neighbouringIndex, vertex;

    // Determine Perimeter - Creates a bounded horizon

    // 1. Pick an edge A out of all possible edges
    // 2. Check if A is shared by any other face. a->b === b->a
      // 2.1 for each edge in each triangle, isShared = ( f1.a == f2.a && f1.b == f2.b ) || ( f1.a == f2.b && f1.b == f2.a )
    // 3. If not shared, then add to convex horizon set,
        //pick an end point (N) of the current edge A and choose a new edge NA connected to A.
        //Restart from 1.
    // 4. If A is shared, it is not an horizon edge, therefore flag both faces that share this edge as candidates for culling
    // 5. If candidate geometry is a degenrate triangle (ie. the tangent space normal cannot be computed) then remove that triangle from all further processing


    var j = i = visibleFaces.length;
    var isDistinct = false,
      hasOneVisibleFace = i === 1,
      cull = [],
      perimeter = [],
      edgeIndex = 0, compareFace, nextIndex,
      a, b;

    var allPoints = [];
    var originFace = [visibleFaces[0][0], visibleFaces[0][1], visibleFaces[0][1], visibleFaces[0][2], visibleFaces[0][2], visibleFaces[0][0]];


    if( visibleFaces.length === 1 ){
      currentFace = visibleFaces[0];

      perimeter = [currentFace[0], currentFace[1], currentFace[1], currentFace[2], currentFace[2], currentFace[0]];
      // remove visible face from list of faces
      if( faceStack.indexOf( currentFace ) > -1 ){
        faceStack.splice( faceStack.indexOf( currentFace ), 1 );
      }


      if( currentFace.visiblePoints ) allPoints = allPoints.concat( currentFace.visiblePoints );
      faces.splice( faces.indexOf( currentFace ), 1 );

    }else{

      while( i-- > 0  ){  // for each visible face

        currentFace = visibleFaces[i];

        // remove visible face from list of faces
        if( faceStack.indexOf( currentFace ) > -1 ){
          faceStack.splice( faceStack.indexOf( currentFace ), 1 );
        }

        if( currentFace.visiblePoints ) allPoints = allPoints.concat( currentFace.visiblePoints );
        faces.splice( faces.indexOf( currentFace ), 1 );


        var isSharedEdge;
        cEdgeIndex = 0;

        while( cEdgeIndex < 3 ){ // Iterate through it's edges

          isSharedEdge = false;
          j = visibleFaces.length;
          a = currentFace[cEdgeIndex]
          b = currentFace[(cEdgeIndex+1)%3];


          while( j-- > 0 && !isSharedEdge ){ // find another visible faces

            compareFace = visibleFaces[j];
            edgeIndex = 0;

            // isSharedEdge = compareFace == currentFace;
            if( compareFace !== currentFace ){

              while( edgeIndex < 3 && !isSharedEdge ){ //Check all it's indices

                nextIndex = ( edgeIndex + 1 );
                isSharedEdge = ( compareFace[edgeIndex] === a && compareFace[nextIndex%3] === b ) ||
                         ( compareFace[edgeIndex] === b && compareFace[nextIndex%3] === a );

                edgeIndex++;
              }
            }
          }

          if( !isSharedEdge || hasOneVisibleFace ){
            perimeter.push( a );
            perimeter.push( b );
          }

          cEdgeIndex++;
        }
      }
    }

    // create new face for all pairs around edge
    i = 0;
    var l = perimeter.length/2;
    var f;

    while( i < l ){
      f = [ perimeter[i*2+1], apex, perimeter[i*2] ];
      assignPoints( f, allPoints, points );
      faces.push( f )
      if( f.visiblePoints !== undefined  )faceStack.push( f );
      i++;
    }

  }

  var distSqPointSegment = function(){

    var ab = new THREE.Vector3(),
      ac = new THREE.Vector3(),
      bc = new THREE.Vector3();

    return function( a, b, c ){

        ab.subVectors( b, a );
        ac.subVectors( c, a );
        bc.subVectors( c, b );

        var e = ac.dot(ab);
        if (e < 0.0) return ac.dot( ac );
        var f = ab.dot( ab );
        if (e >= f) return bc.dot(  bc );
        return ac.dot( ac ) - e * e / f;

      }

  }();





  return function( geometry ){

    reset();


    points    = geometry.vertices;
    faces     = [],
    faceStack   = [],
    i       = NUM_POINTS = points.length,
    extremes  = points.slice( 0, 6 ),
    max     = 0;



    /*
     *  FIND EXTREMETIES
     */
    while( i-- > 0 ){
      if( points[i].x < extremes[0].x ) extremes[0] = points[i];
      if( points[i].x > extremes[1].x ) extremes[1] = points[i];

      if( points[i].y < extremes[2].y ) extremes[2] = points[i];
      if( points[i].y < extremes[3].y ) extremes[3] = points[i];

      if( points[i].z < extremes[4].z ) extremes[4] = points[i];
      if( points[i].z < extremes[5].z ) extremes[5] = points[i];
    }


    /*
     *  Find the longest line between the extremeties
     */

    j = i = 6;
    while( i-- > 0 ){
      j = i - 1;
      while( j-- > 0 ){
          if( max < (dcur = extremes[i].distanceToSquared( extremes[j] )) ){
        max = dcur;
        v0 = extremes[ i ];
        v1 = extremes[ j ];

          }
        }
      }


      // 3. Find the most distant point to the line segment, this creates a plane
      i = 6;
      max = 0;
    while( i-- > 0 ){
      dcur = distSqPointSegment( v0, v1, extremes[i]);
      if( max < dcur ){
        max = dcur;
            v2 = extremes[ i ];
          }
    }


      // 4. Find the most distant point to the plane.

      N = norm(v0, v1, v2);
      D = N.dot( v0 );


      max = 0;
      i = NUM_POINTS;
      while( i-- > 0 ){
        dcur = Math.abs( points[i].dot( N ) - D );
          if( max < dcur ){
            max = dcur;
            v3 = points[i];
      }
      }



      var v0Index = points.indexOf( v0 ),
      v1Index = points.indexOf( v1 ),
      v2Index = points.indexOf( v2 ),
      v3Index = points.indexOf( v3 );


    //  We now have a tetrahedron as the base geometry.
    //  Now we must subdivide the

      var tetrahedron =[
        [ v2Index, v1Index, v0Index ],
        [ v1Index, v3Index, v0Index ],
        [ v2Index, v3Index, v1Index ],
        [ v0Index, v3Index, v2Index ],
    ];



    subaA.subVectors( v1, v0 ).normalize();
    subaB.subVectors( v2, v0 ).normalize();
    subC.subVectors ( v3, v0 ).normalize();
    var sign  = subC.dot( new THREE.Vector3().crossVectors( subaB, subaA ));


    // Reverse the winding if negative sign
    if( sign < 0 ){
      tetrahedron[0].reverse();
      tetrahedron[1].reverse();
      tetrahedron[2].reverse();
      tetrahedron[3].reverse();
    }


    //One for each face of the pyramid
    var pointsCloned = points.slice();
    pointsCloned.splice( pointsCloned.indexOf( v0 ), 1 );
    pointsCloned.splice( pointsCloned.indexOf( v1 ), 1 );
    pointsCloned.splice( pointsCloned.indexOf( v2 ), 1 );
    pointsCloned.splice( pointsCloned.indexOf( v3 ), 1 );


    var i = tetrahedron.length;
    while( i-- > 0 ){
      assignPoints( tetrahedron[i], pointsCloned, points );
      if( tetrahedron[i].visiblePoints !== undefined ){
        faceStack.push( tetrahedron[i] );
      }
      faces.push( tetrahedron[i] );
    }

    process( points );


    //  Assign to our geometry object

    var ll = faces.length;
    while( ll-- > 0 ){
      geometry.faces[ll] = new THREE.Face3( faces[ll][2], faces[ll][1], faces[ll][0], faces[ll].normal )
    }

    geometry.normalsNeedUpdate = true;

    return geometry;

  }

}())


/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WebGLRenderTargetCube */
/* unused harmony export WebGLRenderTarget */
/* unused harmony export WebGLRenderer */
/* unused harmony export ShaderLib */
/* unused harmony export UniformsLib */
/* unused harmony export UniformsUtils */
/* unused harmony export ShaderChunk */
/* unused harmony export FogExp2 */
/* unused harmony export Fog */
/* unused harmony export Scene */
/* unused harmony export LensFlare */
/* unused harmony export Sprite */
/* unused harmony export LOD */
/* unused harmony export SkinnedMesh */
/* unused harmony export Skeleton */
/* unused harmony export Bone */
/* unused harmony export Mesh */
/* unused harmony export LineSegments */
/* unused harmony export Line */
/* unused harmony export Points */
/* unused harmony export Group */
/* unused harmony export VideoTexture */
/* unused harmony export DataTexture */
/* unused harmony export CompressedTexture */
/* unused harmony export CubeTexture */
/* unused harmony export CanvasTexture */
/* unused harmony export DepthTexture */
/* unused harmony export Texture */
/* unused harmony export CompressedTextureLoader */
/* unused harmony export BinaryTextureLoader */
/* unused harmony export DataTextureLoader */
/* unused harmony export CubeTextureLoader */
/* unused harmony export TextureLoader */
/* unused harmony export ObjectLoader */
/* unused harmony export MaterialLoader */
/* unused harmony export BufferGeometryLoader */
/* unused harmony export DefaultLoadingManager */
/* unused harmony export LoadingManager */
/* unused harmony export JSONLoader */
/* unused harmony export ImageLoader */
/* unused harmony export FontLoader */
/* unused harmony export FileLoader */
/* unused harmony export Loader */
/* unused harmony export Cache */
/* unused harmony export AudioLoader */
/* unused harmony export SpotLightShadow */
/* unused harmony export SpotLight */
/* unused harmony export PointLight */
/* unused harmony export RectAreaLight */
/* unused harmony export HemisphereLight */
/* unused harmony export DirectionalLightShadow */
/* unused harmony export DirectionalLight */
/* unused harmony export AmbientLight */
/* unused harmony export LightShadow */
/* unused harmony export Light */
/* unused harmony export StereoCamera */
/* unused harmony export PerspectiveCamera */
/* unused harmony export OrthographicCamera */
/* unused harmony export CubeCamera */
/* unused harmony export Camera */
/* unused harmony export AudioListener */
/* unused harmony export PositionalAudio */
/* unused harmony export AudioContext */
/* unused harmony export AudioAnalyser */
/* unused harmony export Audio */
/* unused harmony export VectorKeyframeTrack */
/* unused harmony export StringKeyframeTrack */
/* unused harmony export QuaternionKeyframeTrack */
/* unused harmony export NumberKeyframeTrack */
/* unused harmony export ColorKeyframeTrack */
/* unused harmony export BooleanKeyframeTrack */
/* unused harmony export PropertyMixer */
/* unused harmony export PropertyBinding */
/* unused harmony export KeyframeTrack */
/* unused harmony export AnimationUtils */
/* unused harmony export AnimationObjectGroup */
/* unused harmony export AnimationMixer */
/* unused harmony export AnimationClip */
/* unused harmony export Uniform */
/* unused harmony export InstancedBufferGeometry */
/* unused harmony export BufferGeometry */
/* unused harmony export GeometryIdCount */
/* unused harmony export Geometry */
/* unused harmony export InterleavedBufferAttribute */
/* unused harmony export InstancedInterleavedBuffer */
/* unused harmony export InterleavedBuffer */
/* unused harmony export InstancedBufferAttribute */
/* unused harmony export Face3 */
/* unused harmony export Object3D */
/* unused harmony export Raycaster */
/* unused harmony export Layers */
/* unused harmony export EventDispatcher */
/* unused harmony export Clock */
/* unused harmony export QuaternionLinearInterpolant */
/* unused harmony export LinearInterpolant */
/* unused harmony export DiscreteInterpolant */
/* unused harmony export CubicInterpolant */
/* unused harmony export Interpolant */
/* unused harmony export Triangle */
/* unused harmony export Spline */
/* unused harmony export Math */
/* unused harmony export Spherical */
/* unused harmony export Cylindrical */
/* unused harmony export Plane */
/* unused harmony export Frustum */
/* unused harmony export Sphere */
/* unused harmony export Ray */
/* unused harmony export Matrix4 */
/* unused harmony export Matrix3 */
/* unused harmony export Box3 */
/* unused harmony export Box2 */
/* unused harmony export Line3 */
/* unused harmony export Euler */
/* unused harmony export Vector4 */
/* unused harmony export Vector3 */
/* unused harmony export Vector2 */
/* unused harmony export Quaternion */
/* unused harmony export Color */
/* unused harmony export MorphBlendMesh */
/* unused harmony export ImmediateRenderObject */
/* unused harmony export VertexNormalsHelper */
/* unused harmony export SpotLightHelper */
/* unused harmony export SkeletonHelper */
/* unused harmony export PointLightHelper */
/* unused harmony export RectAreaLightHelper */
/* unused harmony export HemisphereLightHelper */
/* unused harmony export GridHelper */
/* unused harmony export PolarGridHelper */
/* unused harmony export FaceNormalsHelper */
/* unused harmony export DirectionalLightHelper */
/* unused harmony export CameraHelper */
/* unused harmony export BoxHelper */
/* unused harmony export ArrowHelper */
/* unused harmony export AxisHelper */
/* unused harmony export CatmullRomCurve3 */
/* unused harmony export SplineCurve3 */
/* unused harmony export CubicBezierCurve3 */
/* unused harmony export QuadraticBezierCurve3 */
/* unused harmony export LineCurve3 */
/* unused harmony export ArcCurve */
/* unused harmony export EllipseCurve */
/* unused harmony export SplineCurve */
/* unused harmony export CubicBezierCurve */
/* unused harmony export QuadraticBezierCurve */
/* unused harmony export LineCurve */
/* unused harmony export Shape */
/* unused harmony export ShapePath */
/* unused harmony export Path */
/* unused harmony export Font */
/* unused harmony export CurvePath */
/* unused harmony export Curve */
/* unused harmony export ShapeUtils */
/* unused harmony export SceneUtils */
/* unused harmony export CurveUtils */
/* unused harmony export WireframeGeometry */
/* unused harmony export ParametricGeometry */
/* unused harmony export ParametricBufferGeometry */
/* unused harmony export TetrahedronGeometry */
/* unused harmony export TetrahedronBufferGeometry */
/* unused harmony export OctahedronGeometry */
/* unused harmony export OctahedronBufferGeometry */
/* unused harmony export IcosahedronGeometry */
/* unused harmony export IcosahedronBufferGeometry */
/* unused harmony export DodecahedronGeometry */
/* unused harmony export DodecahedronBufferGeometry */
/* unused harmony export PolyhedronGeometry */
/* unused harmony export PolyhedronBufferGeometry */
/* unused harmony export TubeGeometry */
/* unused harmony export TubeBufferGeometry */
/* unused harmony export TorusKnotGeometry */
/* unused harmony export TorusKnotBufferGeometry */
/* unused harmony export TorusGeometry */
/* unused harmony export TorusBufferGeometry */
/* unused harmony export TextGeometry */
/* unused harmony export SphereBufferGeometry */
/* unused harmony export SphereGeometry */
/* unused harmony export RingGeometry */
/* unused harmony export RingBufferGeometry */
/* unused harmony export PlaneBufferGeometry */
/* unused harmony export PlaneGeometry */
/* unused harmony export LatheGeometry */
/* unused harmony export LatheBufferGeometry */
/* unused harmony export ShapeGeometry */
/* unused harmony export ShapeBufferGeometry */
/* unused harmony export ExtrudeGeometry */
/* unused harmony export EdgesGeometry */
/* unused harmony export ConeGeometry */
/* unused harmony export ConeBufferGeometry */
/* unused harmony export CylinderGeometry */
/* unused harmony export CylinderBufferGeometry */
/* unused harmony export CircleBufferGeometry */
/* unused harmony export CircleGeometry */
/* unused harmony export BoxBufferGeometry */
/* unused harmony export BoxGeometry */
/* unused harmony export ShadowMaterial */
/* unused harmony export SpriteMaterial */
/* unused harmony export RawShaderMaterial */
/* unused harmony export ShaderMaterial */
/* unused harmony export PointsMaterial */
/* unused harmony export MultiMaterial */
/* unused harmony export MeshPhysicalMaterial */
/* unused harmony export MeshStandardMaterial */
/* unused harmony export MeshPhongMaterial */
/* unused harmony export MeshToonMaterial */
/* unused harmony export MeshNormalMaterial */
/* unused harmony export MeshLambertMaterial */
/* unused harmony export MeshDepthMaterial */
/* unused harmony export MeshBasicMaterial */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LineDashedMaterial; });
/* unused harmony export LineBasicMaterial */
/* unused harmony export Material */
/* unused harmony export Float64BufferAttribute */
/* unused harmony export Float32BufferAttribute */
/* unused harmony export Uint32BufferAttribute */
/* unused harmony export Int32BufferAttribute */
/* unused harmony export Uint16BufferAttribute */
/* unused harmony export Int16BufferAttribute */
/* unused harmony export Uint8ClampedBufferAttribute */
/* unused harmony export Uint8BufferAttribute */
/* unused harmony export Int8BufferAttribute */
/* unused harmony export BufferAttribute */
/* unused harmony export REVISION */
/* unused harmony export MOUSE */
/* unused harmony export CullFaceNone */
/* unused harmony export CullFaceBack */
/* unused harmony export CullFaceFront */
/* unused harmony export CullFaceFrontBack */
/* unused harmony export FrontFaceDirectionCW */
/* unused harmony export FrontFaceDirectionCCW */
/* unused harmony export BasicShadowMap */
/* unused harmony export PCFShadowMap */
/* unused harmony export PCFSoftShadowMap */
/* unused harmony export FrontSide */
/* unused harmony export BackSide */
/* unused harmony export DoubleSide */
/* unused harmony export FlatShading */
/* unused harmony export SmoothShading */
/* unused harmony export NoColors */
/* unused harmony export FaceColors */
/* unused harmony export VertexColors */
/* unused harmony export NoBlending */
/* unused harmony export NormalBlending */
/* unused harmony export AdditiveBlending */
/* unused harmony export SubtractiveBlending */
/* unused harmony export MultiplyBlending */
/* unused harmony export CustomBlending */
/* unused harmony export BlendingMode */
/* unused harmony export AddEquation */
/* unused harmony export SubtractEquation */
/* unused harmony export ReverseSubtractEquation */
/* unused harmony export MinEquation */
/* unused harmony export MaxEquation */
/* unused harmony export ZeroFactor */
/* unused harmony export OneFactor */
/* unused harmony export SrcColorFactor */
/* unused harmony export OneMinusSrcColorFactor */
/* unused harmony export SrcAlphaFactor */
/* unused harmony export OneMinusSrcAlphaFactor */
/* unused harmony export DstAlphaFactor */
/* unused harmony export OneMinusDstAlphaFactor */
/* unused harmony export DstColorFactor */
/* unused harmony export OneMinusDstColorFactor */
/* unused harmony export SrcAlphaSaturateFactor */
/* unused harmony export NeverDepth */
/* unused harmony export AlwaysDepth */
/* unused harmony export LessDepth */
/* unused harmony export LessEqualDepth */
/* unused harmony export EqualDepth */
/* unused harmony export GreaterEqualDepth */
/* unused harmony export GreaterDepth */
/* unused harmony export NotEqualDepth */
/* unused harmony export MultiplyOperation */
/* unused harmony export MixOperation */
/* unused harmony export AddOperation */
/* unused harmony export NoToneMapping */
/* unused harmony export LinearToneMapping */
/* unused harmony export ReinhardToneMapping */
/* unused harmony export Uncharted2ToneMapping */
/* unused harmony export CineonToneMapping */
/* unused harmony export UVMapping */
/* unused harmony export CubeReflectionMapping */
/* unused harmony export CubeRefractionMapping */
/* unused harmony export EquirectangularReflectionMapping */
/* unused harmony export EquirectangularRefractionMapping */
/* unused harmony export SphericalReflectionMapping */
/* unused harmony export CubeUVReflectionMapping */
/* unused harmony export CubeUVRefractionMapping */
/* unused harmony export TextureMapping */
/* unused harmony export RepeatWrapping */
/* unused harmony export ClampToEdgeWrapping */
/* unused harmony export MirroredRepeatWrapping */
/* unused harmony export TextureWrapping */
/* unused harmony export NearestFilter */
/* unused harmony export NearestMipMapNearestFilter */
/* unused harmony export NearestMipMapLinearFilter */
/* unused harmony export LinearFilter */
/* unused harmony export LinearMipMapNearestFilter */
/* unused harmony export LinearMipMapLinearFilter */
/* unused harmony export TextureFilter */
/* unused harmony export UnsignedByteType */
/* unused harmony export ByteType */
/* unused harmony export ShortType */
/* unused harmony export UnsignedShortType */
/* unused harmony export IntType */
/* unused harmony export UnsignedIntType */
/* unused harmony export FloatType */
/* unused harmony export HalfFloatType */
/* unused harmony export UnsignedShort4444Type */
/* unused harmony export UnsignedShort5551Type */
/* unused harmony export UnsignedShort565Type */
/* unused harmony export UnsignedInt248Type */
/* unused harmony export AlphaFormat */
/* unused harmony export RGBFormat */
/* unused harmony export RGBAFormat */
/* unused harmony export LuminanceFormat */
/* unused harmony export LuminanceAlphaFormat */
/* unused harmony export RGBEFormat */
/* unused harmony export DepthFormat */
/* unused harmony export DepthStencilFormat */
/* unused harmony export RGB_S3TC_DXT1_Format */
/* unused harmony export RGBA_S3TC_DXT1_Format */
/* unused harmony export RGBA_S3TC_DXT3_Format */
/* unused harmony export RGBA_S3TC_DXT5_Format */
/* unused harmony export RGB_PVRTC_4BPPV1_Format */
/* unused harmony export RGB_PVRTC_2BPPV1_Format */
/* unused harmony export RGBA_PVRTC_4BPPV1_Format */
/* unused harmony export RGBA_PVRTC_2BPPV1_Format */
/* unused harmony export RGB_ETC1_Format */
/* unused harmony export LoopOnce */
/* unused harmony export LoopRepeat */
/* unused harmony export LoopPingPong */
/* unused harmony export InterpolateDiscrete */
/* unused harmony export InterpolateLinear */
/* unused harmony export InterpolateSmooth */
/* unused harmony export ZeroCurvatureEnding */
/* unused harmony export ZeroSlopeEnding */
/* unused harmony export WrapAroundEnding */
/* unused harmony export TrianglesDrawMode */
/* unused harmony export TriangleStripDrawMode */
/* unused harmony export TriangleFanDrawMode */
/* unused harmony export LinearEncoding */
/* unused harmony export sRGBEncoding */
/* unused harmony export GammaEncoding */
/* unused harmony export RGBEEncoding */
/* unused harmony export LogLuvEncoding */
/* unused harmony export RGBM7Encoding */
/* unused harmony export RGBM16Encoding */
/* unused harmony export RGBDEncoding */
/* unused harmony export BasicDepthPacking */
/* unused harmony export RGBADepthPacking */
/* unused harmony export CubeGeometry */
/* unused harmony export Face4 */
/* unused harmony export LineStrip */
/* unused harmony export LinePieces */
/* unused harmony export MeshFaceMaterial */
/* unused harmony export PointCloud */
/* unused harmony export Particle */
/* unused harmony export ParticleSystem */
/* unused harmony export PointCloudMaterial */
/* unused harmony export ParticleBasicMaterial */
/* unused harmony export ParticleSystemMaterial */
/* unused harmony export Vertex */
/* unused harmony export DynamicBufferAttribute */
/* unused harmony export Int8Attribute */
/* unused harmony export Uint8Attribute */
/* unused harmony export Uint8ClampedAttribute */
/* unused harmony export Int16Attribute */
/* unused harmony export Uint16Attribute */
/* unused harmony export Int32Attribute */
/* unused harmony export Uint32Attribute */
/* unused harmony export Float32Attribute */
/* unused harmony export Float64Attribute */
/* unused harmony export ClosedSplineCurve3 */
/* unused harmony export BoundingBoxHelper */
/* unused harmony export EdgesHelper */
/* unused harmony export WireframeHelper */
/* unused harmony export XHRLoader */
/* unused harmony export GeometryUtils */
/* unused harmony export ImageUtils */
/* unused harmony export Projector */
/* unused harmony export CanvasRenderer */
// Polyfills

if ( Number.EPSILON === undefined ) {

	Number.EPSILON = Math.pow( 2, - 52 );

}

//

if ( Math.sign === undefined ) {

	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign

	Math.sign = function ( x ) {

		return ( x < 0 ) ? - 1 : ( x > 0 ) ? 1 : + x;

	};

}

if ( Function.prototype.name === undefined ) {

	// Missing in IE9-11.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/name

	Object.defineProperty( Function.prototype, 'name', {

		get: function () {

			return this.toString().match( /^\s*function\s*([^\(\s]*)/ )[ 1 ];

		}

	} );

}

if ( Object.assign === undefined ) {

	// Missing in IE.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign

	( function () {

		Object.assign = function ( target ) {

			'use strict';

			if ( target === undefined || target === null ) {

				throw new TypeError( 'Cannot convert undefined or null to object' );

			}

			var output = Object( target );

			for ( var index = 1; index < arguments.length; index ++ ) {

				var source = arguments[ index ];

				if ( source !== undefined && source !== null ) {

					for ( var nextKey in source ) {

						if ( Object.prototype.hasOwnProperty.call( source, nextKey ) ) {

							output[ nextKey ] = source[ nextKey ];

						}

					}

				}

			}

			return output;

		};

	} )();

}

/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */

function EventDispatcher() {}

Object.assign( EventDispatcher.prototype, {

	addEventListener: function ( type, listener ) {

		if ( this._listeners === undefined ) this._listeners = {};

		var listeners = this._listeners;

		if ( listeners[ type ] === undefined ) {

			listeners[ type ] = [];

		}

		if ( listeners[ type ].indexOf( listener ) === - 1 ) {

			listeners[ type ].push( listener );

		}

	},

	hasEventListener: function ( type, listener ) {

		if ( this._listeners === undefined ) return false;

		var listeners = this._listeners;

		return listeners[ type ] !== undefined && listeners[ type ].indexOf( listener ) !== - 1;

	},

	removeEventListener: function ( type, listener ) {

		if ( this._listeners === undefined ) return;

		var listeners = this._listeners;
		var listenerArray = listeners[ type ];

		if ( listenerArray !== undefined ) {

			var index = listenerArray.indexOf( listener );

			if ( index !== - 1 ) {

				listenerArray.splice( index, 1 );

			}

		}

	},

	dispatchEvent: function ( event ) {

		if ( this._listeners === undefined ) return;

		var listeners = this._listeners;
		var listenerArray = listeners[ event.type ];

		if ( listenerArray !== undefined ) {

			event.target = this;

			var array = [], i = 0;
			var length = listenerArray.length;

			for ( i = 0; i < length; i ++ ) {

				array[ i ] = listenerArray[ i ];

			}

			for ( i = 0; i < length; i ++ ) {

				array[ i ].call( this, event );

			}

		}

	}

} );

var REVISION = '83';
var MOUSE = { LEFT: 0, MIDDLE: 1, RIGHT: 2 };
var CullFaceNone = 0;
var CullFaceBack = 1;
var CullFaceFront = 2;
var CullFaceFrontBack = 3;
var FrontFaceDirectionCW = 0;
var FrontFaceDirectionCCW = 1;
var BasicShadowMap = 0;
var PCFShadowMap = 1;
var PCFSoftShadowMap = 2;
var FrontSide = 0;
var BackSide = 1;
var DoubleSide = 2;
var FlatShading = 1;
var SmoothShading = 2;
var NoColors = 0;
var FaceColors = 1;
var VertexColors = 2;
var NoBlending = 0;
var NormalBlending = 1;
var AdditiveBlending = 2;
var SubtractiveBlending = 3;
var MultiplyBlending = 4;
var CustomBlending = 5;
var BlendingMode = {
	NoBlending: NoBlending,
	NormalBlending: NormalBlending,
	AdditiveBlending: AdditiveBlending,
	SubtractiveBlending: SubtractiveBlending,
	MultiplyBlending: MultiplyBlending,
	CustomBlending: CustomBlending
};
var AddEquation = 100;
var SubtractEquation = 101;
var ReverseSubtractEquation = 102;
var MinEquation = 103;
var MaxEquation = 104;
var ZeroFactor = 200;
var OneFactor = 201;
var SrcColorFactor = 202;
var OneMinusSrcColorFactor = 203;
var SrcAlphaFactor = 204;
var OneMinusSrcAlphaFactor = 205;
var DstAlphaFactor = 206;
var OneMinusDstAlphaFactor = 207;
var DstColorFactor = 208;
var OneMinusDstColorFactor = 209;
var SrcAlphaSaturateFactor = 210;
var NeverDepth = 0;
var AlwaysDepth = 1;
var LessDepth = 2;
var LessEqualDepth = 3;
var EqualDepth = 4;
var GreaterEqualDepth = 5;
var GreaterDepth = 6;
var NotEqualDepth = 7;
var MultiplyOperation = 0;
var MixOperation = 1;
var AddOperation = 2;
var NoToneMapping = 0;
var LinearToneMapping = 1;
var ReinhardToneMapping = 2;
var Uncharted2ToneMapping = 3;
var CineonToneMapping = 4;
var UVMapping = 300;
var CubeReflectionMapping = 301;
var CubeRefractionMapping = 302;
var EquirectangularReflectionMapping = 303;
var EquirectangularRefractionMapping = 304;
var SphericalReflectionMapping = 305;
var CubeUVReflectionMapping = 306;
var CubeUVRefractionMapping = 307;
var TextureMapping = {
	UVMapping: UVMapping,
	CubeReflectionMapping: CubeReflectionMapping,
	CubeRefractionMapping: CubeRefractionMapping,
	EquirectangularReflectionMapping: EquirectangularReflectionMapping,
	EquirectangularRefractionMapping: EquirectangularRefractionMapping,
	SphericalReflectionMapping: SphericalReflectionMapping,
	CubeUVReflectionMapping: CubeUVReflectionMapping,
	CubeUVRefractionMapping: CubeUVRefractionMapping
};
var RepeatWrapping = 1000;
var ClampToEdgeWrapping = 1001;
var MirroredRepeatWrapping = 1002;
var TextureWrapping = {
	RepeatWrapping: RepeatWrapping,
	ClampToEdgeWrapping: ClampToEdgeWrapping,
	MirroredRepeatWrapping: MirroredRepeatWrapping
};
var NearestFilter = 1003;
var NearestMipMapNearestFilter = 1004;
var NearestMipMapLinearFilter = 1005;
var LinearFilter = 1006;
var LinearMipMapNearestFilter = 1007;
var LinearMipMapLinearFilter = 1008;
var TextureFilter = {
	NearestFilter: NearestFilter,
	NearestMipMapNearestFilter: NearestMipMapNearestFilter,
	NearestMipMapLinearFilter: NearestMipMapLinearFilter,
	LinearFilter: LinearFilter,
	LinearMipMapNearestFilter: LinearMipMapNearestFilter,
	LinearMipMapLinearFilter: LinearMipMapLinearFilter
};
var UnsignedByteType = 1009;
var ByteType = 1010;
var ShortType = 1011;
var UnsignedShortType = 1012;
var IntType = 1013;
var UnsignedIntType = 1014;
var FloatType = 1015;
var HalfFloatType = 1016;
var UnsignedShort4444Type = 1017;
var UnsignedShort5551Type = 1018;
var UnsignedShort565Type = 1019;
var UnsignedInt248Type = 1020;
var AlphaFormat = 1021;
var RGBFormat = 1022;
var RGBAFormat = 1023;
var LuminanceFormat = 1024;
var LuminanceAlphaFormat = 1025;
var RGBEFormat = RGBAFormat;
var DepthFormat = 1026;
var DepthStencilFormat = 1027;
var RGB_S3TC_DXT1_Format = 2001;
var RGBA_S3TC_DXT1_Format = 2002;
var RGBA_S3TC_DXT3_Format = 2003;
var RGBA_S3TC_DXT5_Format = 2004;
var RGB_PVRTC_4BPPV1_Format = 2100;
var RGB_PVRTC_2BPPV1_Format = 2101;
var RGBA_PVRTC_4BPPV1_Format = 2102;
var RGBA_PVRTC_2BPPV1_Format = 2103;
var RGB_ETC1_Format = 2151;
var LoopOnce = 2200;
var LoopRepeat = 2201;
var LoopPingPong = 2202;
var InterpolateDiscrete = 2300;
var InterpolateLinear = 2301;
var InterpolateSmooth = 2302;
var ZeroCurvatureEnding = 2400;
var ZeroSlopeEnding = 2401;
var WrapAroundEnding = 2402;
var TrianglesDrawMode = 0;
var TriangleStripDrawMode = 1;
var TriangleFanDrawMode = 2;
var LinearEncoding = 3000;
var sRGBEncoding = 3001;
var GammaEncoding = 3007;
var RGBEEncoding = 3002;
var LogLuvEncoding = 3003;
var RGBM7Encoding = 3004;
var RGBM16Encoding = 3005;
var RGBDEncoding = 3006;
var BasicDepthPacking = 3200;
var RGBADepthPacking = 3201;

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 */

var _Math = {

	DEG2RAD: Math.PI / 180,
	RAD2DEG: 180 / Math.PI,

	generateUUID: function () {

		// http://www.broofa.com/Tools/Math.uuid.htm

		var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split( '' );
		var uuid = new Array( 36 );
		var rnd = 0, r;

		return function generateUUID() {

			for ( var i = 0; i < 36; i ++ ) {

				if ( i === 8 || i === 13 || i === 18 || i === 23 ) {

					uuid[ i ] = '-';

				} else if ( i === 14 ) {

					uuid[ i ] = '4';

				} else {

					if ( rnd <= 0x02 ) rnd = 0x2000000 + ( Math.random() * 0x1000000 ) | 0;
					r = rnd & 0xf;
					rnd = rnd >> 4;
					uuid[ i ] = chars[ ( i === 19 ) ? ( r & 0x3 ) | 0x8 : r ];

				}

			}

			return uuid.join( '' );

		};

	}(),

	clamp: function ( value, min, max ) {

		return Math.max( min, Math.min( max, value ) );

	},

	// compute euclidian modulo of m % n
	// https://en.wikipedia.org/wiki/Modulo_operation

	euclideanModulo: function ( n, m ) {

		return ( ( n % m ) + m ) % m;

	},

	// Linear mapping from range <a1, a2> to range <b1, b2>

	mapLinear: function ( x, a1, a2, b1, b2 ) {

		return b1 + ( x - a1 ) * ( b2 - b1 ) / ( a2 - a1 );

	},

	// https://en.wikipedia.org/wiki/Linear_interpolation

	lerp: function ( x, y, t ) {

		return ( 1 - t ) * x + t * y;

	},

	// http://en.wikipedia.org/wiki/Smoothstep

	smoothstep: function ( x, min, max ) {

		if ( x <= min ) return 0;
		if ( x >= max ) return 1;

		x = ( x - min ) / ( max - min );

		return x * x * ( 3 - 2 * x );

	},

	smootherstep: function ( x, min, max ) {

		if ( x <= min ) return 0;
		if ( x >= max ) return 1;

		x = ( x - min ) / ( max - min );

		return x * x * x * ( x * ( x * 6 - 15 ) + 10 );

	},

	// Random integer from <low, high> interval

	randInt: function ( low, high ) {

		return low + Math.floor( Math.random() * ( high - low + 1 ) );

	},

	// Random float from <low, high> interval

	randFloat: function ( low, high ) {

		return low + Math.random() * ( high - low );

	},

	// Random float from <-range/2, range/2> interval

	randFloatSpread: function ( range ) {

		return range * ( 0.5 - Math.random() );

	},

	degToRad: function ( degrees ) {

		return degrees * _Math.DEG2RAD;

	},

	radToDeg: function ( radians ) {

		return radians * _Math.RAD2DEG;

	},

	isPowerOfTwo: function ( value ) {

		return ( value & ( value - 1 ) ) === 0 && value !== 0;

	},

	nearestPowerOfTwo: function ( value ) {

		return Math.pow( 2, Math.round( Math.log( value ) / Math.LN2 ) );

	},

	nextPowerOfTwo: function ( value ) {

		value --;
		value |= value >> 1;
		value |= value >> 2;
		value |= value >> 4;
		value |= value >> 8;
		value |= value >> 16;
		value ++;

		return value;

	}

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author philogb / http://blog.thejit.org/
 * @author egraether / http://egraether.com/
 * @author zz85 / http://www.lab4games.net/zz85/blog
 */

function Vector2( x, y ) {

	this.x = x || 0;
	this.y = y || 0;

}

Vector2.prototype = {

	constructor: Vector2,

	isVector2: true,

	get width() {

		return this.x;

	},

	set width( value ) {

		this.x = value;

	},

	get height() {

		return this.y;

	},

	set height( value ) {

		this.y = value;

	},

	//

	set: function ( x, y ) {

		this.x = x;
		this.y = y;

		return this;

	},

	setScalar: function ( scalar ) {

		this.x = scalar;
		this.y = scalar;

		return this;

	},

	setX: function ( x ) {

		this.x = x;

		return this;

	},

	setY: function ( y ) {

		this.y = y;

		return this;

	},

	setComponent: function ( index, value ) {

		switch ( index ) {

			case 0: this.x = value; break;
			case 1: this.y = value; break;
			default: throw new Error( 'index is out of range: ' + index );

		}

		return this;

	},

	getComponent: function ( index ) {

		switch ( index ) {

			case 0: return this.x;
			case 1: return this.y;
			default: throw new Error( 'index is out of range: ' + index );

		}

	},

	clone: function () {

		return new this.constructor( this.x, this.y );

	},

	copy: function ( v ) {

		this.x = v.x;
		this.y = v.y;

		return this;

	},

	add: function ( v, w ) {

		if ( w !== undefined ) {

			console.warn( 'THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
			return this.addVectors( v, w );

		}

		this.x += v.x;
		this.y += v.y;

		return this;

	},

	addScalar: function ( s ) {

		this.x += s;
		this.y += s;

		return this;

	},

	addVectors: function ( a, b ) {

		this.x = a.x + b.x;
		this.y = a.y + b.y;

		return this;

	},

	addScaledVector: function ( v, s ) {

		this.x += v.x * s;
		this.y += v.y * s;

		return this;

	},

	sub: function ( v, w ) {

		if ( w !== undefined ) {

			console.warn( 'THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
			return this.subVectors( v, w );

		}

		this.x -= v.x;
		this.y -= v.y;

		return this;

	},

	subScalar: function ( s ) {

		this.x -= s;
		this.y -= s;

		return this;

	},

	subVectors: function ( a, b ) {

		this.x = a.x - b.x;
		this.y = a.y - b.y;

		return this;

	},

	multiply: function ( v ) {

		this.x *= v.x;
		this.y *= v.y;

		return this;

	},

	multiplyScalar: function ( scalar ) {

		if ( isFinite( scalar ) ) {

			this.x *= scalar;
			this.y *= scalar;

		} else {

			this.x = 0;
			this.y = 0;

		}

		return this;

	},

	divide: function ( v ) {

		this.x /= v.x;
		this.y /= v.y;

		return this;

	},

	divideScalar: function ( scalar ) {

		return this.multiplyScalar( 1 / scalar );

	},

	min: function ( v ) {

		this.x = Math.min( this.x, v.x );
		this.y = Math.min( this.y, v.y );

		return this;

	},

	max: function ( v ) {

		this.x = Math.max( this.x, v.x );
		this.y = Math.max( this.y, v.y );

		return this;

	},

	clamp: function ( min, max ) {

		// This function assumes min < max, if this assumption isn't true it will not operate correctly

		this.x = Math.max( min.x, Math.min( max.x, this.x ) );
		this.y = Math.max( min.y, Math.min( max.y, this.y ) );

		return this;

	},

	clampScalar: function () {

		var min, max;

		return function clampScalar( minVal, maxVal ) {

			if ( min === undefined ) {

				min = new Vector2();
				max = new Vector2();

			}

			min.set( minVal, minVal );
			max.set( maxVal, maxVal );

			return this.clamp( min, max );

		};

	}(),

	clampLength: function ( min, max ) {

		var length = this.length();

		return this.multiplyScalar( Math.max( min, Math.min( max, length ) ) / length );

	},

	floor: function () {

		this.x = Math.floor( this.x );
		this.y = Math.floor( this.y );

		return this;

	},

	ceil: function () {

		this.x = Math.ceil( this.x );
		this.y = Math.ceil( this.y );

		return this;

	},

	round: function () {

		this.x = Math.round( this.x );
		this.y = Math.round( this.y );

		return this;

	},

	roundToZero: function () {

		this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
		this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );

		return this;

	},

	negate: function () {

		this.x = - this.x;
		this.y = - this.y;

		return this;

	},

	dot: function ( v ) {

		return this.x * v.x + this.y * v.y;

	},

	lengthSq: function () {

		return this.x * this.x + this.y * this.y;

	},

	length: function () {

		return Math.sqrt( this.x * this.x + this.y * this.y );

	},

	lengthManhattan: function() {

		return Math.abs( this.x ) + Math.abs( this.y );

	},

	normalize: function () {

		return this.divideScalar( this.length() );

	},

	angle: function () {

		// computes the angle in radians with respect to the positive x-axis

		var angle = Math.atan2( this.y, this.x );

		if ( angle < 0 ) angle += 2 * Math.PI;

		return angle;

	},

	distanceTo: function ( v ) {

		return Math.sqrt( this.distanceToSquared( v ) );

	},

	distanceToSquared: function ( v ) {

		var dx = this.x - v.x, dy = this.y - v.y;
		return dx * dx + dy * dy;

	},

	distanceToManhattan: function ( v ) {

		return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y );

	},

	setLength: function ( length ) {

		return this.multiplyScalar( length / this.length() );

	},

	lerp: function ( v, alpha ) {

		this.x += ( v.x - this.x ) * alpha;
		this.y += ( v.y - this.y ) * alpha;

		return this;

	},

	lerpVectors: function ( v1, v2, alpha ) {

		return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );

	},

	equals: function ( v ) {

		return ( ( v.x === this.x ) && ( v.y === this.y ) );

	},

	fromArray: function ( array, offset ) {

		if ( offset === undefined ) offset = 0;

		this.x = array[ offset ];
		this.y = array[ offset + 1 ];

		return this;

	},

	toArray: function ( array, offset ) {

		if ( array === undefined ) array = [];
		if ( offset === undefined ) offset = 0;

		array[ offset ] = this.x;
		array[ offset + 1 ] = this.y;

		return array;

	},

	fromAttribute: function ( attribute, index, offset ) {

		if ( offset !== undefined ) {

			console.warn( 'THREE.Vector2: offset has been removed from .fromAttribute().' );

		}

		this.x = attribute.getX( index );
		this.y = attribute.getY( index );

		return this;

	},

	rotateAround: function ( center, angle ) {

		var c = Math.cos( angle ), s = Math.sin( angle );

		var x = this.x - center.x;
		var y = this.y - center.y;

		this.x = x * c - y * s + center.x;
		this.y = x * s + y * c + center.y;

		return this;

	}

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 * @author szimek / https://github.com/szimek/
 */

var textureId = 0;

function Texture( image, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding ) {

	Object.defineProperty( this, 'id', { value: textureId ++ } );

	this.uuid = _Math.generateUUID();

	this.name = '';

	this.image = image !== undefined ? image : Texture.DEFAULT_IMAGE;
	this.mipmaps = [];

	this.mapping = mapping !== undefined ? mapping : Texture.DEFAULT_MAPPING;

	this.wrapS = wrapS !== undefined ? wrapS : ClampToEdgeWrapping;
	this.wrapT = wrapT !== undefined ? wrapT : ClampToEdgeWrapping;

	this.magFilter = magFilter !== undefined ? magFilter : LinearFilter;
	this.minFilter = minFilter !== undefined ? minFilter : LinearMipMapLinearFilter;

	this.anisotropy = anisotropy !== undefined ? anisotropy : 1;

	this.format = format !== undefined ? format : RGBAFormat;
	this.type = type !== undefined ? type : UnsignedByteType;

	this.offset = new Vector2( 0, 0 );
	this.repeat = new Vector2( 1, 1 );

	this.generateMipmaps = true;
	this.premultiplyAlpha = false;
	this.flipY = true;
	this.unpackAlignment = 4;	// valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)


	// Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
	//
	// Also changing the encoding after already used by a Material will not automatically make the Material
	// update.  You need to explicitly call Material.needsUpdate to trigger it to recompile.
	this.encoding = encoding !== undefined ? encoding : LinearEncoding;

	this.version = 0;
	this.onUpdate = null;

}

Texture.DEFAULT_IMAGE = undefined;
Texture.DEFAULT_MAPPING = UVMapping;

Texture.prototype = {

	constructor: Texture,

	isTexture: true,

	set needsUpdate( value ) {

		if ( value === true ) this.version ++;

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( source ) {

		this.image = source.image;
		this.mipmaps = source.mipmaps.slice( 0 );

		this.mapping = source.mapping;

		this.wrapS = source.wrapS;
		this.wrapT = source.wrapT;

		this.magFilter = source.magFilter;
		this.minFilter = source.minFilter;

		this.anisotropy = source.anisotropy;

		this.format = source.format;
		this.type = source.type;

		this.offset.copy( source.offset );
		this.repeat.copy( source.repeat );

		this.generateMipmaps = source.generateMipmaps;
		this.premultiplyAlpha = source.premultiplyAlpha;
		this.flipY = source.flipY;
		this.unpackAlignment = source.unpackAlignment;
		this.encoding = source.encoding;

		return this;

	},

	toJSON: function ( meta ) {

		if ( meta.textures[ this.uuid ] !== undefined ) {

			return meta.textures[ this.uuid ];

		}

		function getDataURL( image ) {

			var canvas;

			if ( image.toDataURL !== undefined ) {

				canvas = image;

			} else {

				canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
				canvas.width = image.width;
				canvas.height = image.height;

				canvas.getContext( '2d' ).drawImage( image, 0, 0, image.width, image.height );

			}

			if ( canvas.width > 2048 || canvas.height > 2048 ) {

				return canvas.toDataURL( 'image/jpeg', 0.6 );

			} else {

				return canvas.toDataURL( 'image/png' );

			}

		}

		var output = {
			metadata: {
				version: 4.4,
				type: 'Texture',
				generator: 'Texture.toJSON'
			},

			uuid: this.uuid,
			name: this.name,

			mapping: this.mapping,

			repeat: [ this.repeat.x, this.repeat.y ],
			offset: [ this.offset.x, this.offset.y ],
			wrap: [ this.wrapS, this.wrapT ],

			minFilter: this.minFilter,
			magFilter: this.magFilter,
			anisotropy: this.anisotropy,

			flipY: this.flipY
		};

		if ( this.image !== undefined ) {

			// TODO: Move to THREE.Image

			var image = this.image;

			if ( image.uuid === undefined ) {

				image.uuid = _Math.generateUUID(); // UGH

			}

			if ( meta.images[ image.uuid ] === undefined ) {

				meta.images[ image.uuid ] = {
					uuid: image.uuid,
					url: getDataURL( image )
				};

			}

			output.image = image.uuid;

		}

		meta.textures[ this.uuid ] = output;

		return output;

	},

	dispose: function () {

		this.dispatchEvent( { type: 'dispose' } );

	},

	transformUv: function ( uv ) {

		if ( this.mapping !== UVMapping ) return;

		uv.multiply( this.repeat );
		uv.add( this.offset );

		if ( uv.x < 0 || uv.x > 1 ) {

			switch ( this.wrapS ) {

				case RepeatWrapping:

					uv.x = uv.x - Math.floor( uv.x );
					break;

				case ClampToEdgeWrapping:

					uv.x = uv.x < 0 ? 0 : 1;
					break;

				case MirroredRepeatWrapping:

					if ( Math.abs( Math.floor( uv.x ) % 2 ) === 1 ) {

						uv.x = Math.ceil( uv.x ) - uv.x;

					} else {

						uv.x = uv.x - Math.floor( uv.x );

					}
					break;

			}

		}

		if ( uv.y < 0 || uv.y > 1 ) {

			switch ( this.wrapT ) {

				case RepeatWrapping:

					uv.y = uv.y - Math.floor( uv.y );
					break;

				case ClampToEdgeWrapping:

					uv.y = uv.y < 0 ? 0 : 1;
					break;

				case MirroredRepeatWrapping:

					if ( Math.abs( Math.floor( uv.y ) % 2 ) === 1 ) {

						uv.y = Math.ceil( uv.y ) - uv.y;

					} else {

						uv.y = uv.y - Math.floor( uv.y );

					}
					break;

			}

		}

		if ( this.flipY ) {

			uv.y = 1 - uv.y;

		}

	}

};

Object.assign( Texture.prototype, EventDispatcher.prototype );

/**
 * @author supereggbert / http://www.paulbrunt.co.uk/
 * @author philogb / http://blog.thejit.org/
 * @author mikael emtinger / http://gomo.se/
 * @author egraether / http://egraether.com/
 * @author WestLangley / http://github.com/WestLangley
 */

function Vector4( x, y, z, w ) {

	this.x = x || 0;
	this.y = y || 0;
	this.z = z || 0;
	this.w = ( w !== undefined ) ? w : 1;

}

Vector4.prototype = {

	constructor: Vector4,

	isVector4: true,

	set: function ( x, y, z, w ) {

		this.x = x;
		this.y = y;
		this.z = z;
		this.w = w;

		return this;

	},

	setScalar: function ( scalar ) {

		this.x = scalar;
		this.y = scalar;
		this.z = scalar;
		this.w = scalar;

		return this;

	},

	setX: function ( x ) {

		this.x = x;

		return this;

	},

	setY: function ( y ) {

		this.y = y;

		return this;

	},

	setZ: function ( z ) {

		this.z = z;

		return this;

	},

	setW: function ( w ) {

		this.w = w;

		return this;

	},

	setComponent: function ( index, value ) {

		switch ( index ) {

			case 0: this.x = value; break;
			case 1: this.y = value; break;
			case 2: this.z = value; break;
			case 3: this.w = value; break;
			default: throw new Error( 'index is out of range: ' + index );

		}

		return this;

	},

	getComponent: function ( index ) {

		switch ( index ) {

			case 0: return this.x;
			case 1: return this.y;
			case 2: return this.z;
			case 3: return this.w;
			default: throw new Error( 'index is out of range: ' + index );

		}

	},

	clone: function () {

		return new this.constructor( this.x, this.y, this.z, this.w );

	},

	copy: function ( v ) {

		this.x = v.x;
		this.y = v.y;
		this.z = v.z;
		this.w = ( v.w !== undefined ) ? v.w : 1;

		return this;

	},

	add: function ( v, w ) {

		if ( w !== undefined ) {

			console.warn( 'THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
			return this.addVectors( v, w );

		}

		this.x += v.x;
		this.y += v.y;
		this.z += v.z;
		this.w += v.w;

		return this;

	},

	addScalar: function ( s ) {

		this.x += s;
		this.y += s;
		this.z += s;
		this.w += s;

		return this;

	},

	addVectors: function ( a, b ) {

		this.x = a.x + b.x;
		this.y = a.y + b.y;
		this.z = a.z + b.z;
		this.w = a.w + b.w;

		return this;

	},

	addScaledVector: function ( v, s ) {

		this.x += v.x * s;
		this.y += v.y * s;
		this.z += v.z * s;
		this.w += v.w * s;

		return this;

	},

	sub: function ( v, w ) {

		if ( w !== undefined ) {

			console.warn( 'THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
			return this.subVectors( v, w );

		}

		this.x -= v.x;
		this.y -= v.y;
		this.z -= v.z;
		this.w -= v.w;

		return this;

	},

	subScalar: function ( s ) {

		this.x -= s;
		this.y -= s;
		this.z -= s;
		this.w -= s;

		return this;

	},

	subVectors: function ( a, b ) {

		this.x = a.x - b.x;
		this.y = a.y - b.y;
		this.z = a.z - b.z;
		this.w = a.w - b.w;

		return this;

	},

	multiplyScalar: function ( scalar ) {

		if ( isFinite( scalar ) ) {

			this.x *= scalar;
			this.y *= scalar;
			this.z *= scalar;
			this.w *= scalar;

		} else {

			this.x = 0;
			this.y = 0;
			this.z = 0;
			this.w = 0;

		}

		return this;

	},

	applyMatrix4: function ( m ) {

		var x = this.x, y = this.y, z = this.z, w = this.w;
		var e = m.elements;

		this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z + e[ 12 ] * w;
		this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z + e[ 13 ] * w;
		this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] * w;
		this.w = e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] * w;

		return this;

	},

	divideScalar: function ( scalar ) {

		return this.multiplyScalar( 1 / scalar );

	},

	setAxisAngleFromQuaternion: function ( q ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm

		// q is assumed to be normalized

		this.w = 2 * Math.acos( q.w );

		var s = Math.sqrt( 1 - q.w * q.w );

		if ( s < 0.0001 ) {

			 this.x = 1;
			 this.y = 0;
			 this.z = 0;

		} else {

			 this.x = q.x / s;
			 this.y = q.y / s;
			 this.z = q.z / s;

		}

		return this;

	},

	setAxisAngleFromRotationMatrix: function ( m ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		var angle, x, y, z,		// variables for result
			epsilon = 0.01,		// margin to allow for rounding errors
			epsilon2 = 0.1,		// margin to distinguish between 0 and 180 degrees

			te = m.elements,

			m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
			m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
			m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];

		if ( ( Math.abs( m12 - m21 ) < epsilon ) &&
		     ( Math.abs( m13 - m31 ) < epsilon ) &&
		     ( Math.abs( m23 - m32 ) < epsilon ) ) {

			// singularity found
			// first check for identity matrix which must have +1 for all terms
			// in leading diagonal and zero in other terms

			if ( ( Math.abs( m12 + m21 ) < epsilon2 ) &&
			     ( Math.abs( m13 + m31 ) < epsilon2 ) &&
			     ( Math.abs( m23 + m32 ) < epsilon2 ) &&
			     ( Math.abs( m11 + m22 + m33 - 3 ) < epsilon2 ) ) {

				// this singularity is identity matrix so angle = 0

				this.set( 1, 0, 0, 0 );

				return this; // zero angle, arbitrary axis

			}

			// otherwise this singularity is angle = 180

			angle = Math.PI;

			var xx = ( m11 + 1 ) / 2;
			var yy = ( m22 + 1 ) / 2;
			var zz = ( m33 + 1 ) / 2;
			var xy = ( m12 + m21 ) / 4;
			var xz = ( m13 + m31 ) / 4;
			var yz = ( m23 + m32 ) / 4;

			if ( ( xx > yy ) && ( xx > zz ) ) {

				// m11 is the largest diagonal term

				if ( xx < epsilon ) {

					x = 0;
					y = 0.707106781;
					z = 0.707106781;

				} else {

					x = Math.sqrt( xx );
					y = xy / x;
					z = xz / x;

				}

			} else if ( yy > zz ) {

				// m22 is the largest diagonal term

				if ( yy < epsilon ) {

					x = 0.707106781;
					y = 0;
					z = 0.707106781;

				} else {

					y = Math.sqrt( yy );
					x = xy / y;
					z = yz / y;

				}

			} else {

				// m33 is the largest diagonal term so base result on this

				if ( zz < epsilon ) {

					x = 0.707106781;
					y = 0.707106781;
					z = 0;

				} else {

					z = Math.sqrt( zz );
					x = xz / z;
					y = yz / z;

				}

			}

			this.set( x, y, z, angle );

			return this; // return 180 deg rotation

		}

		// as we have reached here there are no singularities so we can handle normally

		var s = Math.sqrt( ( m32 - m23 ) * ( m32 - m23 ) +
		                   ( m13 - m31 ) * ( m13 - m31 ) +
		                   ( m21 - m12 ) * ( m21 - m12 ) ); // used to normalize

		if ( Math.abs( s ) < 0.001 ) s = 1;

		// prevent divide by zero, should not happen if matrix is orthogonal and should be
		// caught by singularity test above, but I've left it in just in case

		this.x = ( m32 - m23 ) / s;
		this.y = ( m13 - m31 ) / s;
		this.z = ( m21 - m12 ) / s;
		this.w = Math.acos( ( m11 + m22 + m33 - 1 ) / 2 );

		return this;

	},

	min: function ( v ) {

		this.x = Math.min( this.x, v.x );
		this.y = Math.min( this.y, v.y );
		this.z = Math.min( this.z, v.z );
		this.w = Math.min( this.w, v.w );

		return this;

	},

	max: function ( v ) {

		this.x = Math.max( this.x, v.x );
		this.y = Math.max( this.y, v.y );
		this.z = Math.max( this.z, v.z );
		this.w = Math.max( this.w, v.w );

		return this;

	},

	clamp: function ( min, max ) {

		// This function assumes min < max, if this assumption isn't true it will not operate correctly

		this.x = Math.max( min.x, Math.min( max.x, this.x ) );
		this.y = Math.max( min.y, Math.min( max.y, this.y ) );
		this.z = Math.max( min.z, Math.min( max.z, this.z ) );
		this.w = Math.max( min.w, Math.min( max.w, this.w ) );

		return this;

	},

	clampScalar: function () {

		var min, max;

		return function clampScalar( minVal, maxVal ) {

			if ( min === undefined ) {

				min = new Vector4();
				max = new Vector4();

			}

			min.set( minVal, minVal, minVal, minVal );
			max.set( maxVal, maxVal, maxVal, maxVal );

			return this.clamp( min, max );

		};

	}(),

	floor: function () {

		this.x = Math.floor( this.x );
		this.y = Math.floor( this.y );
		this.z = Math.floor( this.z );
		this.w = Math.floor( this.w );

		return this;

	},

	ceil: function () {

		this.x = Math.ceil( this.x );
		this.y = Math.ceil( this.y );
		this.z = Math.ceil( this.z );
		this.w = Math.ceil( this.w );

		return this;

	},

	round: function () {

		this.x = Math.round( this.x );
		this.y = Math.round( this.y );
		this.z = Math.round( this.z );
		this.w = Math.round( this.w );

		return this;

	},

	roundToZero: function () {

		this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
		this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );
		this.z = ( this.z < 0 ) ? Math.ceil( this.z ) : Math.floor( this.z );
		this.w = ( this.w < 0 ) ? Math.ceil( this.w ) : Math.floor( this.w );

		return this;

	},

	negate: function () {

		this.x = - this.x;
		this.y = - this.y;
		this.z = - this.z;
		this.w = - this.w;

		return this;

	},

	dot: function ( v ) {

		return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;

	},

	lengthSq: function () {

		return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;

	},

	length: function () {

		return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w );

	},

	lengthManhattan: function () {

		return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z ) + Math.abs( this.w );

	},

	normalize: function () {

		return this.divideScalar( this.length() );

	},

	setLength: function ( length ) {

		return this.multiplyScalar( length / this.length() );

	},

	lerp: function ( v, alpha ) {

		this.x += ( v.x - this.x ) * alpha;
		this.y += ( v.y - this.y ) * alpha;
		this.z += ( v.z - this.z ) * alpha;
		this.w += ( v.w - this.w ) * alpha;

		return this;

	},

	lerpVectors: function ( v1, v2, alpha ) {

		return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );

	},

	equals: function ( v ) {

		return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) && ( v.w === this.w ) );

	},

	fromArray: function ( array, offset ) {

		if ( offset === undefined ) offset = 0;

		this.x = array[ offset ];
		this.y = array[ offset + 1 ];
		this.z = array[ offset + 2 ];
		this.w = array[ offset + 3 ];

		return this;

	},

	toArray: function ( array, offset ) {

		if ( array === undefined ) array = [];
		if ( offset === undefined ) offset = 0;

		array[ offset ] = this.x;
		array[ offset + 1 ] = this.y;
		array[ offset + 2 ] = this.z;
		array[ offset + 3 ] = this.w;

		return array;

	},

	fromAttribute: function ( attribute, index, offset ) {

		if ( offset !== undefined ) {

			console.warn( 'THREE.Vector4: offset has been removed from .fromAttribute().' );

		}

		this.x = attribute.getX( index );
		this.y = attribute.getY( index );
		this.z = attribute.getZ( index );
		this.w = attribute.getW( index );

		return this;

	}

};

/**
 * @author szimek / https://github.com/szimek/
 * @author alteredq / http://alteredqualia.com/
 * @author Marius Kintel / https://github.com/kintel
 */

/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/
function WebGLRenderTarget( width, height, options ) {

	this.uuid = _Math.generateUUID();

	this.width = width;
	this.height = height;

	this.scissor = new Vector4( 0, 0, width, height );
	this.scissorTest = false;

	this.viewport = new Vector4( 0, 0, width, height );

	options = options || {};

	if ( options.minFilter === undefined ) options.minFilter = LinearFilter;

	this.texture = new Texture( undefined, undefined, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding );

	this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
	this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : true;
	this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;

}

Object.assign( WebGLRenderTarget.prototype, EventDispatcher.prototype, {

	isWebGLRenderTarget: true,

	setSize: function ( width, height ) {

		if ( this.width !== width || this.height !== height ) {

			this.width = width;
			this.height = height;

			this.dispose();

		}

		this.viewport.set( 0, 0, width, height );
		this.scissor.set( 0, 0, width, height );

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( source ) {

		this.width = source.width;
		this.height = source.height;

		this.viewport.copy( source.viewport );

		this.texture = source.texture.clone();

		this.depthBuffer = source.depthBuffer;
		this.stencilBuffer = source.stencilBuffer;
		this.depthTexture = source.depthTexture;

		return this;

	},

	dispose: function () {

		this.dispatchEvent( { type: 'dispose' } );

	}

} );

/**
 * @author alteredq / http://alteredqualia.com
 */

function WebGLRenderTargetCube( width, height, options ) {

	WebGLRenderTarget.call( this, width, height, options );

	this.activeCubeFace = 0; // PX 0, NX 1, PY 2, NY 3, PZ 4, NZ 5
	this.activeMipMapLevel = 0;

}

WebGLRenderTargetCube.prototype = Object.create( WebGLRenderTarget.prototype );
WebGLRenderTargetCube.prototype.constructor = WebGLRenderTargetCube;

WebGLRenderTargetCube.prototype.isWebGLRenderTargetCube = true;

/**
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 * @author WestLangley / http://github.com/WestLangley
 * @author bhouston / http://clara.io
 */

function Quaternion( x, y, z, w ) {

	this._x = x || 0;
	this._y = y || 0;
	this._z = z || 0;
	this._w = ( w !== undefined ) ? w : 1;

}

Quaternion.prototype = {

	constructor: Quaternion,

	get x () {

		return this._x;

	},

	set x ( value ) {

		this._x = value;
		this.onChangeCallback();

	},

	get y () {

		return this._y;

	},

	set y ( value ) {

		this._y = value;
		this.onChangeCallback();

	},

	get z () {

		return this._z;

	},

	set z ( value ) {

		this._z = value;
		this.onChangeCallback();

	},

	get w () {

		return this._w;

	},

	set w ( value ) {

		this._w = value;
		this.onChangeCallback();

	},

	set: function ( x, y, z, w ) {

		this._x = x;
		this._y = y;
		this._z = z;
		this._w = w;

		this.onChangeCallback();

		return this;

	},

	clone: function () {

		return new this.constructor( this._x, this._y, this._z, this._w );

	},

	copy: function ( quaternion ) {

		this._x = quaternion.x;
		this._y = quaternion.y;
		this._z = quaternion.z;
		this._w = quaternion.w;

		this.onChangeCallback();

		return this;

	},

	setFromEuler: function ( euler, update ) {

		if ( (euler && euler.isEuler) === false ) {

			throw new Error( 'THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.' );

		}

		// http://www.mathworks.com/matlabcentral/fileexchange/
		// 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
		//	content/SpinCalc.m

		var c1 = Math.cos( euler._x / 2 );
		var c2 = Math.cos( euler._y / 2 );
		var c3 = Math.cos( euler._z / 2 );
		var s1 = Math.sin( euler._x / 2 );
		var s2 = Math.sin( euler._y / 2 );
		var s3 = Math.sin( euler._z / 2 );

		var order = euler.order;

		if ( order === 'XYZ' ) {

			this._x = s1 * c2 * c3 + c1 * s2 * s3;
			this._y = c1 * s2 * c3 - s1 * c2 * s3;
			this._z = c1 * c2 * s3 + s1 * s2 * c3;
			this._w = c1 * c2 * c3 - s1 * s2 * s3;

		} else if ( order === 'YXZ' ) {

			this._x = s1 * c2 * c3 + c1 * s2 * s3;
			this._y = c1 * s2 * c3 - s1 * c2 * s3;
			this._z = c1 * c2 * s3 - s1 * s2 * c3;
			this._w = c1 * c2 * c3 + s1 * s2 * s3;

		} else if ( order === 'ZXY' ) {

			this._x = s1 * c2 * c3 - c1 * s2 * s3;
			this._y = c1 * s2 * c3 + s1 * c2 * s3;
			this._z = c1 * c2 * s3 + s1 * s2 * c3;
			this._w = c1 * c2 * c3 - s1 * s2 * s3;

		} else if ( order === 'ZYX' ) {

			this._x = s1 * c2 * c3 - c1 * s2 * s3;
			this._y = c1 * s2 * c3 + s1 * c2 * s3;
			this._z = c1 * c2 * s3 - s1 * s2 * c3;
			this._w = c1 * c2 * c3 + s1 * s2 * s3;

		} else if ( order === 'YZX' ) {

			this._x = s1 * c2 * c3 + c1 * s2 * s3;
			this._y = c1 * s2 * c3 + s1 * c2 * s3;
			this._z = c1 * c2 * s3 - s1 * s2 * c3;
			this._w = c1 * c2 * c3 - s1 * s2 * s3;

		} else if ( order === 'XZY' ) {

			this._x = s1 * c2 * c3 - c1 * s2 * s3;
			this._y = c1 * s2 * c3 - s1 * c2 * s3;
			this._z = c1 * c2 * s3 + s1 * s2 * c3;
			this._w = c1 * c2 * c3 + s1 * s2 * s3;

		}

		if ( update !== false ) this.onChangeCallback();

		return this;

	},

	setFromAxisAngle: function ( axis, angle ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm

		// assumes axis is normalized

		var halfAngle = angle / 2, s = Math.sin( halfAngle );

		this._x = axis.x * s;
		this._y = axis.y * s;
		this._z = axis.z * s;
		this._w = Math.cos( halfAngle );

		this.onChangeCallback();

		return this;

	},

	setFromRotationMatrix: function ( m ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		var te = m.elements,

			m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
			m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
			m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ],

			trace = m11 + m22 + m33,
			s;

		if ( trace > 0 ) {

			s = 0.5 / Math.sqrt( trace + 1.0 );

			this._w = 0.25 / s;
			this._x = ( m32 - m23 ) * s;
			this._y = ( m13 - m31 ) * s;
			this._z = ( m21 - m12 ) * s;

		} else if ( m11 > m22 && m11 > m33 ) {

			s = 2.0 * Math.sqrt( 1.0 + m11 - m22 - m33 );

			this._w = ( m32 - m23 ) / s;
			this._x = 0.25 * s;
			this._y = ( m12 + m21 ) / s;
			this._z = ( m13 + m31 ) / s;

		} else if ( m22 > m33 ) {

			s = 2.0 * Math.sqrt( 1.0 + m22 - m11 - m33 );

			this._w = ( m13 - m31 ) / s;
			this._x = ( m12 + m21 ) / s;
			this._y = 0.25 * s;
			this._z = ( m23 + m32 ) / s;

		} else {

			s = 2.0 * Math.sqrt( 1.0 + m33 - m11 - m22 );

			this._w = ( m21 - m12 ) / s;
			this._x = ( m13 + m31 ) / s;
			this._y = ( m23 + m32 ) / s;
			this._z = 0.25 * s;

		}

		this.onChangeCallback();

		return this;

	},

	setFromUnitVectors: function () {

		// http://lolengine.net/blog/2014/02/24/quaternion-from-two-vectors-final

		// assumes direction vectors vFrom and vTo are normalized

		var v1, r;

		var EPS = 0.000001;

		return function setFromUnitVectors( vFrom, vTo ) {

			if ( v1 === undefined ) v1 = new Vector3();

			r = vFrom.dot( vTo ) + 1;

			if ( r < EPS ) {

				r = 0;

				if ( Math.abs( vFrom.x ) > Math.abs( vFrom.z ) ) {

					v1.set( - vFrom.y, vFrom.x, 0 );

				} else {

					v1.set( 0, - vFrom.z, vFrom.y );

				}

			} else {

				v1.crossVectors( vFrom, vTo );

			}

			this._x = v1.x;
			this._y = v1.y;
			this._z = v1.z;
			this._w = r;

			return this.normalize();

		};

	}(),

	inverse: function () {

		return this.conjugate().normalize();

	},

	conjugate: function () {

		this._x *= - 1;
		this._y *= - 1;
		this._z *= - 1;

		this.onChangeCallback();

		return this;

	},

	dot: function ( v ) {

		return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;

	},

	lengthSq: function () {

		return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;

	},

	length: function () {

		return Math.sqrt( this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w );

	},

	normalize: function () {

		var l = this.length();

		if ( l === 0 ) {

			this._x = 0;
			this._y = 0;
			this._z = 0;
			this._w = 1;

		} else {

			l = 1 / l;

			this._x = this._x * l;
			this._y = this._y * l;
			this._z = this._z * l;
			this._w = this._w * l;

		}

		this.onChangeCallback();

		return this;

	},

	multiply: function ( q, p ) {

		if ( p !== undefined ) {

			console.warn( 'THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.' );
			return this.multiplyQuaternions( q, p );

		}

		return this.multiplyQuaternions( this, q );

	},

	premultiply: function ( q ) {

		return this.multiplyQuaternions( q, this );

	},

	multiplyQuaternions: function ( a, b ) {

		// from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm

		var qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
		var qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;

		this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
		this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
		this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
		this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;

		this.onChangeCallback();

		return this;

	},

	slerp: function ( qb, t ) {

		if ( t === 0 ) return this;
		if ( t === 1 ) return this.copy( qb );

		var x = this._x, y = this._y, z = this._z, w = this._w;

		// http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/

		var cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;

		if ( cosHalfTheta < 0 ) {

			this._w = - qb._w;
			this._x = - qb._x;
			this._y = - qb._y;
			this._z = - qb._z;

			cosHalfTheta = - cosHalfTheta;

		} else {

			this.copy( qb );

		}

		if ( cosHalfTheta >= 1.0 ) {

			this._w = w;
			this._x = x;
			this._y = y;
			this._z = z;

			return this;

		}

		var sinHalfTheta = Math.sqrt( 1.0 - cosHalfTheta * cosHalfTheta );

		if ( Math.abs( sinHalfTheta ) < 0.001 ) {

			this._w = 0.5 * ( w + this._w );
			this._x = 0.5 * ( x + this._x );
			this._y = 0.5 * ( y + this._y );
			this._z = 0.5 * ( z + this._z );

			return this;

		}

		var halfTheta = Math.atan2( sinHalfTheta, cosHalfTheta );
		var ratioA = Math.sin( ( 1 - t ) * halfTheta ) / sinHalfTheta,
		ratioB = Math.sin( t * halfTheta ) / sinHalfTheta;

		this._w = ( w * ratioA + this._w * ratioB );
		this._x = ( x * ratioA + this._x * ratioB );
		this._y = ( y * ratioA + this._y * ratioB );
		this._z = ( z * ratioA + this._z * ratioB );

		this.onChangeCallback();

		return this;

	},

	equals: function ( quaternion ) {

		return ( quaternion._x === this._x ) && ( quaternion._y === this._y ) && ( quaternion._z === this._z ) && ( quaternion._w === this._w );

	},

	fromArray: function ( array, offset ) {

		if ( offset === undefined ) offset = 0;

		this._x = array[ offset ];
		this._y = array[ offset + 1 ];
		this._z = array[ offset + 2 ];
		this._w = array[ offset + 3 ];

		this.onChangeCallback();

		return this;

	},

	toArray: function ( array, offset ) {

		if ( array === undefined ) array = [];
		if ( offset === undefined ) offset = 0;

		array[ offset ] = this._x;
		array[ offset + 1 ] = this._y;
		array[ offset + 2 ] = this._z;
		array[ offset + 3 ] = this._w;

		return array;

	},

	onChange: function ( callback ) {

		this.onChangeCallback = callback;

		return this;

	},

	onChangeCallback: function () {}

};

Object.assign( Quaternion, {

	slerp: function( qa, qb, qm, t ) {

		return qm.copy( qa ).slerp( qb, t );

	},

	slerpFlat: function(
			dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t ) {

		// fuzz-free, array-based Quaternion SLERP operation

		var x0 = src0[ srcOffset0 + 0 ],
			y0 = src0[ srcOffset0 + 1 ],
			z0 = src0[ srcOffset0 + 2 ],
			w0 = src0[ srcOffset0 + 3 ],

			x1 = src1[ srcOffset1 + 0 ],
			y1 = src1[ srcOffset1 + 1 ],
			z1 = src1[ srcOffset1 + 2 ],
			w1 = src1[ srcOffset1 + 3 ];

		if ( w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1 ) {

			var s = 1 - t,

				cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1,

				dir = ( cos >= 0 ? 1 : - 1 ),
				sqrSin = 1 - cos * cos;

			// Skip the Slerp for tiny steps to avoid numeric problems:
			if ( sqrSin > Number.EPSILON ) {

				var sin = Math.sqrt( sqrSin ),
					len = Math.atan2( sin, cos * dir );

				s = Math.sin( s * len ) / sin;
				t = Math.sin( t * len ) / sin;

			}

			var tDir = t * dir;

			x0 = x0 * s + x1 * tDir;
			y0 = y0 * s + y1 * tDir;
			z0 = z0 * s + z1 * tDir;
			w0 = w0 * s + w1 * tDir;

			// Normalize in case we just did a lerp:
			if ( s === 1 - t ) {

				var f = 1 / Math.sqrt( x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0 );

				x0 *= f;
				y0 *= f;
				z0 *= f;
				w0 *= f;

			}

		}

		dst[ dstOffset ] = x0;
		dst[ dstOffset + 1 ] = y0;
		dst[ dstOffset + 2 ] = z0;
		dst[ dstOffset + 3 ] = w0;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author *kile / http://kile.stravaganza.org/
 * @author philogb / http://blog.thejit.org/
 * @author mikael emtinger / http://gomo.se/
 * @author egraether / http://egraether.com/
 * @author WestLangley / http://github.com/WestLangley
 */

function Vector3( x, y, z ) {

	this.x = x || 0;
	this.y = y || 0;
	this.z = z || 0;

}

Vector3.prototype = {

	constructor: Vector3,

	isVector3: true,

	set: function ( x, y, z ) {

		this.x = x;
		this.y = y;
		this.z = z;

		return this;

	},

	setScalar: function ( scalar ) {

		this.x = scalar;
		this.y = scalar;
		this.z = scalar;

		return this;

	},

	setX: function ( x ) {

		this.x = x;

		return this;

	},

	setY: function ( y ) {

		this.y = y;

		return this;

	},

	setZ: function ( z ) {

		this.z = z;

		return this;

	},

	setComponent: function ( index, value ) {

		switch ( index ) {

			case 0: this.x = value; break;
			case 1: this.y = value; break;
			case 2: this.z = value; break;
			default: throw new Error( 'index is out of range: ' + index );

		}

		return this;

	},

	getComponent: function ( index ) {

		switch ( index ) {

			case 0: return this.x;
			case 1: return this.y;
			case 2: return this.z;
			default: throw new Error( 'index is out of range: ' + index );

		}

	},

	clone: function () {

		return new this.constructor( this.x, this.y, this.z );

	},

	copy: function ( v ) {

		this.x = v.x;
		this.y = v.y;
		this.z = v.z;

		return this;

	},

	add: function ( v, w ) {

		if ( w !== undefined ) {

			console.warn( 'THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
			return this.addVectors( v, w );

		}

		this.x += v.x;
		this.y += v.y;
		this.z += v.z;

		return this;

	},

	addScalar: function ( s ) {

		this.x += s;
		this.y += s;
		this.z += s;

		return this;

	},

	addVectors: function ( a, b ) {

		this.x = a.x + b.x;
		this.y = a.y + b.y;
		this.z = a.z + b.z;

		return this;

	},

	addScaledVector: function ( v, s ) {

		this.x += v.x * s;
		this.y += v.y * s;
		this.z += v.z * s;

		return this;

	},

	sub: function ( v, w ) {

		if ( w !== undefined ) {

			console.warn( 'THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
			return this.subVectors( v, w );

		}

		this.x -= v.x;
		this.y -= v.y;
		this.z -= v.z;

		return this;

	},

	subScalar: function ( s ) {

		this.x -= s;
		this.y -= s;
		this.z -= s;

		return this;

	},

	subVectors: function ( a, b ) {

		this.x = a.x - b.x;
		this.y = a.y - b.y;
		this.z = a.z - b.z;

		return this;

	},

	multiply: function ( v, w ) {

		if ( w !== undefined ) {

			console.warn( 'THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.' );
			return this.multiplyVectors( v, w );

		}

		this.x *= v.x;
		this.y *= v.y;
		this.z *= v.z;

		return this;

	},

	multiplyScalar: function ( scalar ) {

		if ( isFinite( scalar ) ) {

			this.x *= scalar;
			this.y *= scalar;
			this.z *= scalar;

		} else {

			this.x = 0;
			this.y = 0;
			this.z = 0;

		}

		return this;

	},

	multiplyVectors: function ( a, b ) {

		this.x = a.x * b.x;
		this.y = a.y * b.y;
		this.z = a.z * b.z;

		return this;

	},

	applyEuler: function () {

		var quaternion;

		return function applyEuler( euler ) {

			if ( (euler && euler.isEuler) === false ) {

				console.error( 'THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.' );

			}

			if ( quaternion === undefined ) quaternion = new Quaternion();

			return this.applyQuaternion( quaternion.setFromEuler( euler ) );

		};

	}(),

	applyAxisAngle: function () {

		var quaternion;

		return function applyAxisAngle( axis, angle ) {

			if ( quaternion === undefined ) quaternion = new Quaternion();

			return this.applyQuaternion( quaternion.setFromAxisAngle( axis, angle ) );

		};

	}(),

	applyMatrix3: function ( m ) {

		var x = this.x, y = this.y, z = this.z;
		var e = m.elements;

		this.x = e[ 0 ] * x + e[ 3 ] * y + e[ 6 ] * z;
		this.y = e[ 1 ] * x + e[ 4 ] * y + e[ 7 ] * z;
		this.z = e[ 2 ] * x + e[ 5 ] * y + e[ 8 ] * z;

		return this;

	},

	applyMatrix4: function ( m ) {

		// input: THREE.Matrix4 affine matrix

		var x = this.x, y = this.y, z = this.z;
		var e = m.elements;

		this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ]  * z + e[ 12 ];
		this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ]  * z + e[ 13 ];
		this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ];

		return this;

	},

	applyProjection: function ( m ) {

		// input: THREE.Matrix4 projection matrix

		var x = this.x, y = this.y, z = this.z;
		var e = m.elements;
		var d = 1 / ( e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] ); // perspective divide

		this.x = ( e[ 0 ] * x + e[ 4 ] * y + e[ 8 ]  * z + e[ 12 ] ) * d;
		this.y = ( e[ 1 ] * x + e[ 5 ] * y + e[ 9 ]  * z + e[ 13 ] ) * d;
		this.z = ( e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] ) * d;

		return this;

	},

	applyQuaternion: function ( q ) {

		var x = this.x, y = this.y, z = this.z;
		var qx = q.x, qy = q.y, qz = q.z, qw = q.w;

		// calculate quat * vector

		var ix =  qw * x + qy * z - qz * y;
		var iy =  qw * y + qz * x - qx * z;
		var iz =  qw * z + qx * y - qy * x;
		var iw = - qx * x - qy * y - qz * z;

		// calculate result * inverse quat

		this.x = ix * qw + iw * - qx + iy * - qz - iz * - qy;
		this.y = iy * qw + iw * - qy + iz * - qx - ix * - qz;
		this.z = iz * qw + iw * - qz + ix * - qy - iy * - qx;

		return this;

	},

	project: function () {

		var matrix;

		return function project( camera ) {

			if ( matrix === undefined ) matrix = new Matrix4();

			matrix.multiplyMatrices( camera.projectionMatrix, matrix.getInverse( camera.matrixWorld ) );
			return this.applyProjection( matrix );

		};

	}(),

	unproject: function () {

		var matrix;

		return function unproject( camera ) {

			if ( matrix === undefined ) matrix = new Matrix4();

			matrix.multiplyMatrices( camera.matrixWorld, matrix.getInverse( camera.projectionMatrix ) );
			return this.applyProjection( matrix );

		};

	}(),

	transformDirection: function ( m ) {

		// input: THREE.Matrix4 affine matrix
		// vector interpreted as a direction

		var x = this.x, y = this.y, z = this.z;
		var e = m.elements;

		this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ]  * z;
		this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ]  * z;
		this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z;

		return this.normalize();

	},

	divide: function ( v ) {

		this.x /= v.x;
		this.y /= v.y;
		this.z /= v.z;

		return this;

	},

	divideScalar: function ( scalar ) {

		return this.multiplyScalar( 1 / scalar );

	},

	min: function ( v ) {

		this.x = Math.min( this.x, v.x );
		this.y = Math.min( this.y, v.y );
		this.z = Math.min( this.z, v.z );

		return this;

	},

	max: function ( v ) {

		this.x = Math.max( this.x, v.x );
		this.y = Math.max( this.y, v.y );
		this.z = Math.max( this.z, v.z );

		return this;

	},

	clamp: function ( min, max ) {

		// This function assumes min < max, if this assumption isn't true it will not operate correctly

		this.x = Math.max( min.x, Math.min( max.x, this.x ) );
		this.y = Math.max( min.y, Math.min( max.y, this.y ) );
		this.z = Math.max( min.z, Math.min( max.z, this.z ) );

		return this;

	},

	clampScalar: function () {

		var min, max;

		return function clampScalar( minVal, maxVal ) {

			if ( min === undefined ) {

				min = new Vector3();
				max = new Vector3();

			}

			min.set( minVal, minVal, minVal );
			max.set( maxVal, maxVal, maxVal );

			return this.clamp( min, max );

		};

	}(),

	clampLength: function ( min, max ) {

		var length = this.length();

		return this.multiplyScalar( Math.max( min, Math.min( max, length ) ) / length );

	},

	floor: function () {

		this.x = Math.floor( this.x );
		this.y = Math.floor( this.y );
		this.z = Math.floor( this.z );

		return this;

	},

	ceil: function () {

		this.x = Math.ceil( this.x );
		this.y = Math.ceil( this.y );
		this.z = Math.ceil( this.z );

		return this;

	},

	round: function () {

		this.x = Math.round( this.x );
		this.y = Math.round( this.y );
		this.z = Math.round( this.z );

		return this;

	},

	roundToZero: function () {

		this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
		this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );
		this.z = ( this.z < 0 ) ? Math.ceil( this.z ) : Math.floor( this.z );

		return this;

	},

	negate: function () {

		this.x = - this.x;
		this.y = - this.y;
		this.z = - this.z;

		return this;

	},

	dot: function ( v ) {

		return this.x * v.x + this.y * v.y + this.z * v.z;

	},

	lengthSq: function () {

		return this.x * this.x + this.y * this.y + this.z * this.z;

	},

	length: function () {

		return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z );

	},

	lengthManhattan: function () {

		return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z );

	},

	normalize: function () {

		return this.divideScalar( this.length() );

	},

	setLength: function ( length ) {

		return this.multiplyScalar( length / this.length() );

	},

	lerp: function ( v, alpha ) {

		this.x += ( v.x - this.x ) * alpha;
		this.y += ( v.y - this.y ) * alpha;
		this.z += ( v.z - this.z ) * alpha;

		return this;

	},

	lerpVectors: function ( v1, v2, alpha ) {

		return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );

	},

	cross: function ( v, w ) {

		if ( w !== undefined ) {

			console.warn( 'THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.' );
			return this.crossVectors( v, w );

		}

		var x = this.x, y = this.y, z = this.z;

		this.x = y * v.z - z * v.y;
		this.y = z * v.x - x * v.z;
		this.z = x * v.y - y * v.x;

		return this;

	},

	crossVectors: function ( a, b ) {

		var ax = a.x, ay = a.y, az = a.z;
		var bx = b.x, by = b.y, bz = b.z;

		this.x = ay * bz - az * by;
		this.y = az * bx - ax * bz;
		this.z = ax * by - ay * bx;

		return this;

	},

	projectOnVector: function ( vector ) {

		var scalar = vector.dot( this ) / vector.lengthSq();

		return this.copy( vector ).multiplyScalar( scalar );

	},

	projectOnPlane: function () {

		var v1;

		return function projectOnPlane( planeNormal ) {

			if ( v1 === undefined ) v1 = new Vector3();

			v1.copy( this ).projectOnVector( planeNormal );

			return this.sub( v1 );

		};

	}(),

	reflect: function () {

		// reflect incident vector off plane orthogonal to normal
		// normal is assumed to have unit length

		var v1;

		return function reflect( normal ) {

			if ( v1 === undefined ) v1 = new Vector3();

			return this.sub( v1.copy( normal ).multiplyScalar( 2 * this.dot( normal ) ) );

		};

	}(),

	angleTo: function ( v ) {

		var theta = this.dot( v ) / ( Math.sqrt( this.lengthSq() * v.lengthSq() ) );

		// clamp, to handle numerical problems

		return Math.acos( _Math.clamp( theta, - 1, 1 ) );

	},

	distanceTo: function ( v ) {

		return Math.sqrt( this.distanceToSquared( v ) );

	},

	distanceToSquared: function ( v ) {

		var dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;

		return dx * dx + dy * dy + dz * dz;

	},

	distanceToManhattan: function ( v ) {

		return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y ) + Math.abs( this.z - v.z );

	},

	setFromSpherical: function( s ) {

		var sinPhiRadius = Math.sin( s.phi ) * s.radius;

		this.x = sinPhiRadius * Math.sin( s.theta );
		this.y = Math.cos( s.phi ) * s.radius;
		this.z = sinPhiRadius * Math.cos( s.theta );

		return this;

	},

	setFromCylindrical: function( c ) {

		this.x = c.radius * Math.sin( c.theta );
		this.y = c.y;
		this.z = c.radius * Math.cos( c.theta );

		return this;

	},

	setFromMatrixPosition: function ( m ) {

		return this.setFromMatrixColumn( m, 3 );

	},

	setFromMatrixScale: function ( m ) {

		var sx = this.setFromMatrixColumn( m, 0 ).length();
		var sy = this.setFromMatrixColumn( m, 1 ).length();
		var sz = this.setFromMatrixColumn( m, 2 ).length();

		this.x = sx;
		this.y = sy;
		this.z = sz;

		return this;

	},

	setFromMatrixColumn: function ( m, index ) {

		if ( typeof m === 'number' ) {

			console.warn( 'THREE.Vector3: setFromMatrixColumn now expects ( matrix, index ).' );
			var temp = m;
			m = index;
			index = temp;

		}

		return this.fromArray( m.elements, index * 4 );

	},

	equals: function ( v ) {

		return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) );

	},

	fromArray: function ( array, offset ) {

		if ( offset === undefined ) offset = 0;

		this.x = array[ offset ];
		this.y = array[ offset + 1 ];
		this.z = array[ offset + 2 ];

		return this;

	},

	toArray: function ( array, offset ) {

		if ( array === undefined ) array = [];
		if ( offset === undefined ) offset = 0;

		array[ offset ] = this.x;
		array[ offset + 1 ] = this.y;
		array[ offset + 2 ] = this.z;

		return array;

	},

	fromAttribute: function ( attribute, index, offset ) {

		if ( offset !== undefined ) {

			console.warn( 'THREE.Vector3: offset has been removed from .fromAttribute().' );

		}

		this.x = attribute.getX( index );
		this.y = attribute.getY( index );
		this.z = attribute.getZ( index );

		return this;

	}

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author supereggbert / http://www.paulbrunt.co.uk/
 * @author philogb / http://blog.thejit.org/
 * @author jordi_ros / http://plattsoft.com
 * @author D1plo1d / http://github.com/D1plo1d
 * @author alteredq / http://alteredqualia.com/
 * @author mikael emtinger / http://gomo.se/
 * @author timknip / http://www.floorplanner.com/
 * @author bhouston / http://clara.io
 * @author WestLangley / http://github.com/WestLangley
 */

function Matrix4() {

	this.elements = new Float32Array( [

		1, 0, 0, 0,
		0, 1, 0, 0,
		0, 0, 1, 0,
		0, 0, 0, 1

	] );

	if ( arguments.length > 0 ) {

		console.error( 'THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.' );

	}

}

Matrix4.prototype = {

	constructor: Matrix4,

	isMatrix4: true,

	set: function ( n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44 ) {

		var te = this.elements;

		te[ 0 ] = n11; te[ 4 ] = n12; te[ 8 ] = n13; te[ 12 ] = n14;
		te[ 1 ] = n21; te[ 5 ] = n22; te[ 9 ] = n23; te[ 13 ] = n24;
		te[ 2 ] = n31; te[ 6 ] = n32; te[ 10 ] = n33; te[ 14 ] = n34;
		te[ 3 ] = n41; te[ 7 ] = n42; te[ 11 ] = n43; te[ 15 ] = n44;

		return this;

	},

	identity: function () {

		this.set(

			1, 0, 0, 0,
			0, 1, 0, 0,
			0, 0, 1, 0,
			0, 0, 0, 1

		);

		return this;

	},

	clone: function () {

		return new Matrix4().fromArray( this.elements );

	},

	copy: function ( m ) {

		this.elements.set( m.elements );

		return this;

	},

	copyPosition: function ( m ) {

		var te = this.elements;
		var me = m.elements;

		te[ 12 ] = me[ 12 ];
		te[ 13 ] = me[ 13 ];
		te[ 14 ] = me[ 14 ];

		return this;

	},

	extractBasis: function ( xAxis, yAxis, zAxis ) {

		xAxis.setFromMatrixColumn( this, 0 );
		yAxis.setFromMatrixColumn( this, 1 );
		zAxis.setFromMatrixColumn( this, 2 );

		return this;

	},

	makeBasis: function ( xAxis, yAxis, zAxis ) {

		this.set(
			xAxis.x, yAxis.x, zAxis.x, 0,
			xAxis.y, yAxis.y, zAxis.y, 0,
			xAxis.z, yAxis.z, zAxis.z, 0,
			0,       0,       0,       1
		);

		return this;

	},

	extractRotation: function () {

		var v1;

		return function extractRotation( m ) {

			if ( v1 === undefined ) v1 = new Vector3();

			var te = this.elements;
			var me = m.elements;

			var scaleX = 1 / v1.setFromMatrixColumn( m, 0 ).length();
			var scaleY = 1 / v1.setFromMatrixColumn( m, 1 ).length();
			var scaleZ = 1 / v1.setFromMatrixColumn( m, 2 ).length();

			te[ 0 ] = me[ 0 ] * scaleX;
			te[ 1 ] = me[ 1 ] * scaleX;
			te[ 2 ] = me[ 2 ] * scaleX;

			te[ 4 ] = me[ 4 ] * scaleY;
			te[ 5 ] = me[ 5 ] * scaleY;
			te[ 6 ] = me[ 6 ] * scaleY;

			te[ 8 ] = me[ 8 ] * scaleZ;
			te[ 9 ] = me[ 9 ] * scaleZ;
			te[ 10 ] = me[ 10 ] * scaleZ;

			return this;

		};

	}(),

	makeRotationFromEuler: function ( euler ) {

		if ( (euler && euler.isEuler) === false ) {

			console.error( 'THREE.Matrix: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.' );

		}

		var te = this.elements;

		var x = euler.x, y = euler.y, z = euler.z;
		var a = Math.cos( x ), b = Math.sin( x );
		var c = Math.cos( y ), d = Math.sin( y );
		var e = Math.cos( z ), f = Math.sin( z );

		if ( euler.order === 'XYZ' ) {

			var ae = a * e, af = a * f, be = b * e, bf = b * f;

			te[ 0 ] = c * e;
			te[ 4 ] = - c * f;
			te[ 8 ] = d;

			te[ 1 ] = af + be * d;
			te[ 5 ] = ae - bf * d;
			te[ 9 ] = - b * c;

			te[ 2 ] = bf - ae * d;
			te[ 6 ] = be + af * d;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'YXZ' ) {

			var ce = c * e, cf = c * f, de = d * e, df = d * f;

			te[ 0 ] = ce + df * b;
			te[ 4 ] = de * b - cf;
			te[ 8 ] = a * d;

			te[ 1 ] = a * f;
			te[ 5 ] = a * e;
			te[ 9 ] = - b;

			te[ 2 ] = cf * b - de;
			te[ 6 ] = df + ce * b;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'ZXY' ) {

			var ce = c * e, cf = c * f, de = d * e, df = d * f;

			te[ 0 ] = ce - df * b;
			te[ 4 ] = - a * f;
			te[ 8 ] = de + cf * b;

			te[ 1 ] = cf + de * b;
			te[ 5 ] = a * e;
			te[ 9 ] = df - ce * b;

			te[ 2 ] = - a * d;
			te[ 6 ] = b;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'ZYX' ) {

			var ae = a * e, af = a * f, be = b * e, bf = b * f;

			te[ 0 ] = c * e;
			te[ 4 ] = be * d - af;
			te[ 8 ] = ae * d + bf;

			te[ 1 ] = c * f;
			te[ 5 ] = bf * d + ae;
			te[ 9 ] = af * d - be;

			te[ 2 ] = - d;
			te[ 6 ] = b * c;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'YZX' ) {

			var ac = a * c, ad = a * d, bc = b * c, bd = b * d;

			te[ 0 ] = c * e;
			te[ 4 ] = bd - ac * f;
			te[ 8 ] = bc * f + ad;

			te[ 1 ] = f;
			te[ 5 ] = a * e;
			te[ 9 ] = - b * e;

			te[ 2 ] = - d * e;
			te[ 6 ] = ad * f + bc;
			te[ 10 ] = ac - bd * f;

		} else if ( euler.order === 'XZY' ) {

			var ac = a * c, ad = a * d, bc = b * c, bd = b * d;

			te[ 0 ] = c * e;
			te[ 4 ] = - f;
			te[ 8 ] = d * e;

			te[ 1 ] = ac * f + bd;
			te[ 5 ] = a * e;
			te[ 9 ] = ad * f - bc;

			te[ 2 ] = bc * f - ad;
			te[ 6 ] = b * e;
			te[ 10 ] = bd * f + ac;

		}

		// last column
		te[ 3 ] = 0;
		te[ 7 ] = 0;
		te[ 11 ] = 0;

		// bottom row
		te[ 12 ] = 0;
		te[ 13 ] = 0;
		te[ 14 ] = 0;
		te[ 15 ] = 1;

		return this;

	},

	makeRotationFromQuaternion: function ( q ) {

		var te = this.elements;

		var x = q.x, y = q.y, z = q.z, w = q.w;
		var x2 = x + x, y2 = y + y, z2 = z + z;
		var xx = x * x2, xy = x * y2, xz = x * z2;
		var yy = y * y2, yz = y * z2, zz = z * z2;
		var wx = w * x2, wy = w * y2, wz = w * z2;

		te[ 0 ] = 1 - ( yy + zz );
		te[ 4 ] = xy - wz;
		te[ 8 ] = xz + wy;

		te[ 1 ] = xy + wz;
		te[ 5 ] = 1 - ( xx + zz );
		te[ 9 ] = yz - wx;

		te[ 2 ] = xz - wy;
		te[ 6 ] = yz + wx;
		te[ 10 ] = 1 - ( xx + yy );

		// last column
		te[ 3 ] = 0;
		te[ 7 ] = 0;
		te[ 11 ] = 0;

		// bottom row
		te[ 12 ] = 0;
		te[ 13 ] = 0;
		te[ 14 ] = 0;
		te[ 15 ] = 1;

		return this;

	},

	lookAt: function () {

		var x, y, z;

		return function lookAt( eye, target, up ) {

			if ( x === undefined ) {

				x = new Vector3();
				y = new Vector3();
				z = new Vector3();

			}

			var te = this.elements;

			z.subVectors( eye, target ).normalize();

			if ( z.lengthSq() === 0 ) {

				z.z = 1;

			}

			x.crossVectors( up, z ).normalize();

			if ( x.lengthSq() === 0 ) {

				z.z += 0.0001;
				x.crossVectors( up, z ).normalize();

			}

			y.crossVectors( z, x );


			te[ 0 ] = x.x; te[ 4 ] = y.x; te[ 8 ] = z.x;
			te[ 1 ] = x.y; te[ 5 ] = y.y; te[ 9 ] = z.y;
			te[ 2 ] = x.z; te[ 6 ] = y.z; te[ 10 ] = z.z;

			return this;

		};

	}(),

	multiply: function ( m, n ) {

		if ( n !== undefined ) {

			console.warn( 'THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.' );
			return this.multiplyMatrices( m, n );

		}

		return this.multiplyMatrices( this, m );

	},

	premultiply: function ( m ) {

		return this.multiplyMatrices( m, this );

	},

	multiplyMatrices: function ( a, b ) {

		var ae = a.elements;
		var be = b.elements;
		var te = this.elements;

		var a11 = ae[ 0 ], a12 = ae[ 4 ], a13 = ae[ 8 ], a14 = ae[ 12 ];
		var a21 = ae[ 1 ], a22 = ae[ 5 ], a23 = ae[ 9 ], a24 = ae[ 13 ];
		var a31 = ae[ 2 ], a32 = ae[ 6 ], a33 = ae[ 10 ], a34 = ae[ 14 ];
		var a41 = ae[ 3 ], a42 = ae[ 7 ], a43 = ae[ 11 ], a44 = ae[ 15 ];

		var b11 = be[ 0 ], b12 = be[ 4 ], b13 = be[ 8 ], b14 = be[ 12 ];
		var b21 = be[ 1 ], b22 = be[ 5 ], b23 = be[ 9 ], b24 = be[ 13 ];
		var b31 = be[ 2 ], b32 = be[ 6 ], b33 = be[ 10 ], b34 = be[ 14 ];
		var b41 = be[ 3 ], b42 = be[ 7 ], b43 = be[ 11 ], b44 = be[ 15 ];

		te[ 0 ] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
		te[ 4 ] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
		te[ 8 ] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
		te[ 12 ] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;

		te[ 1 ] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
		te[ 5 ] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
		te[ 9 ] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
		te[ 13 ] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;

		te[ 2 ] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
		te[ 6 ] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
		te[ 10 ] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
		te[ 14 ] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;

		te[ 3 ] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
		te[ 7 ] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
		te[ 11 ] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
		te[ 15 ] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;

		return this;

	},

	multiplyToArray: function ( a, b, r ) {

		var te = this.elements;

		this.multiplyMatrices( a, b );

		r[ 0 ] = te[ 0 ]; r[ 1 ] = te[ 1 ]; r[ 2 ] = te[ 2 ]; r[ 3 ] = te[ 3 ];
		r[ 4 ] = te[ 4 ]; r[ 5 ] = te[ 5 ]; r[ 6 ] = te[ 6 ]; r[ 7 ] = te[ 7 ];
		r[ 8 ]  = te[ 8 ]; r[ 9 ]  = te[ 9 ]; r[ 10 ] = te[ 10 ]; r[ 11 ] = te[ 11 ];
		r[ 12 ] = te[ 12 ]; r[ 13 ] = te[ 13 ]; r[ 14 ] = te[ 14 ]; r[ 15 ] = te[ 15 ];

		return this;

	},

	multiplyScalar: function ( s ) {

		var te = this.elements;

		te[ 0 ] *= s; te[ 4 ] *= s; te[ 8 ] *= s; te[ 12 ] *= s;
		te[ 1 ] *= s; te[ 5 ] *= s; te[ 9 ] *= s; te[ 13 ] *= s;
		te[ 2 ] *= s; te[ 6 ] *= s; te[ 10 ] *= s; te[ 14 ] *= s;
		te[ 3 ] *= s; te[ 7 ] *= s; te[ 11 ] *= s; te[ 15 ] *= s;

		return this;

	},

	applyToVector3Array: function () {

		var v1;

		return function applyToVector3Array( array, offset, length ) {

			if ( v1 === undefined ) v1 = new Vector3();
			if ( offset === undefined ) offset = 0;
			if ( length === undefined ) length = array.length;

			for ( var i = 0, j = offset; i < length; i += 3, j += 3 ) {

				v1.fromArray( array, j );
				v1.applyMatrix4( this );
				v1.toArray( array, j );

			}

			return array;

		};

	}(),

	applyToBufferAttribute: function () {

		var v1;

		return function applyToBufferAttribute( attribute ) {

			if ( v1 === undefined ) v1 = new Vector3();

			for ( var i = 0, l = attribute.count; i < l; i ++ ) {

				v1.x = attribute.getX( i );
				v1.y = attribute.getY( i );
				v1.z = attribute.getZ( i );

				v1.applyMatrix4( this );

				attribute.setXYZ( i, v1.x, v1.y, v1.z );

			}

			return attribute;

		};

	}(),

	determinant: function () {

		var te = this.elements;

		var n11 = te[ 0 ], n12 = te[ 4 ], n13 = te[ 8 ], n14 = te[ 12 ];
		var n21 = te[ 1 ], n22 = te[ 5 ], n23 = te[ 9 ], n24 = te[ 13 ];
		var n31 = te[ 2 ], n32 = te[ 6 ], n33 = te[ 10 ], n34 = te[ 14 ];
		var n41 = te[ 3 ], n42 = te[ 7 ], n43 = te[ 11 ], n44 = te[ 15 ];

		//TODO: make this more efficient
		//( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )

		return (
			n41 * (
				+ n14 * n23 * n32
				 - n13 * n24 * n32
				 - n14 * n22 * n33
				 + n12 * n24 * n33
				 + n13 * n22 * n34
				 - n12 * n23 * n34
			) +
			n42 * (
				+ n11 * n23 * n34
				 - n11 * n24 * n33
				 + n14 * n21 * n33
				 - n13 * n21 * n34
				 + n13 * n24 * n31
				 - n14 * n23 * n31
			) +
			n43 * (
				+ n11 * n24 * n32
				 - n11 * n22 * n34
				 - n14 * n21 * n32
				 + n12 * n21 * n34
				 + n14 * n22 * n31
				 - n12 * n24 * n31
			) +
			n44 * (
				- n13 * n22 * n31
				 - n11 * n23 * n32
				 + n11 * n22 * n33
				 + n13 * n21 * n32
				 - n12 * n21 * n33
				 + n12 * n23 * n31
			)

		);

	},

	transpose: function () {

		var te = this.elements;
		var tmp;

		tmp = te[ 1 ]; te[ 1 ] = te[ 4 ]; te[ 4 ] = tmp;
		tmp = te[ 2 ]; te[ 2 ] = te[ 8 ]; te[ 8 ] = tmp;
		tmp = te[ 6 ]; te[ 6 ] = te[ 9 ]; te[ 9 ] = tmp;

		tmp = te[ 3 ]; te[ 3 ] = te[ 12 ]; te[ 12 ] = tmp;
		tmp = te[ 7 ]; te[ 7 ] = te[ 13 ]; te[ 13 ] = tmp;
		tmp = te[ 11 ]; te[ 11 ] = te[ 14 ]; te[ 14 ] = tmp;

		return this;

	},

	setPosition: function ( v ) {

		var te = this.elements;

		te[ 12 ] = v.x;
		te[ 13 ] = v.y;
		te[ 14 ] = v.z;

		return this;

	},

	getInverse: function ( m, throwOnDegenerate ) {

		// based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
		var te = this.elements,
			me = m.elements,

			n11 = me[ 0 ], n21 = me[ 1 ], n31 = me[ 2 ], n41 = me[ 3 ],
			n12 = me[ 4 ], n22 = me[ 5 ], n32 = me[ 6 ], n42 = me[ 7 ],
			n13 = me[ 8 ], n23 = me[ 9 ], n33 = me[ 10 ], n43 = me[ 11 ],
			n14 = me[ 12 ], n24 = me[ 13 ], n34 = me[ 14 ], n44 = me[ 15 ],

			t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44,
			t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44,
			t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44,
			t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;

		var det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;

		if ( det === 0 ) {

			var msg = "THREE.Matrix4.getInverse(): can't invert matrix, determinant is 0";

			if ( throwOnDegenerate === true ) {

				throw new Error( msg );

			} else {

				console.warn( msg );

			}

			return this.identity();

		}

		var detInv = 1 / det;

		te[ 0 ] = t11 * detInv;
		te[ 1 ] = ( n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44 ) * detInv;
		te[ 2 ] = ( n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44 ) * detInv;
		te[ 3 ] = ( n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43 ) * detInv;

		te[ 4 ] = t12 * detInv;
		te[ 5 ] = ( n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44 ) * detInv;
		te[ 6 ] = ( n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44 ) * detInv;
		te[ 7 ] = ( n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43 ) * detInv;

		te[ 8 ] = t13 * detInv;
		te[ 9 ] = ( n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44 ) * detInv;
		te[ 10 ] = ( n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44 ) * detInv;
		te[ 11 ] = ( n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43 ) * detInv;

		te[ 12 ] = t14 * detInv;
		te[ 13 ] = ( n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34 ) * detInv;
		te[ 14 ] = ( n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34 ) * detInv;
		te[ 15 ] = ( n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33 ) * detInv;

		return this;

	},

	scale: function ( v ) {

		var te = this.elements;
		var x = v.x, y = v.y, z = v.z;

		te[ 0 ] *= x; te[ 4 ] *= y; te[ 8 ] *= z;
		te[ 1 ] *= x; te[ 5 ] *= y; te[ 9 ] *= z;
		te[ 2 ] *= x; te[ 6 ] *= y; te[ 10 ] *= z;
		te[ 3 ] *= x; te[ 7 ] *= y; te[ 11 ] *= z;

		return this;

	},

	getMaxScaleOnAxis: function () {

		var te = this.elements;

		var scaleXSq = te[ 0 ] * te[ 0 ] + te[ 1 ] * te[ 1 ] + te[ 2 ] * te[ 2 ];
		var scaleYSq = te[ 4 ] * te[ 4 ] + te[ 5 ] * te[ 5 ] + te[ 6 ] * te[ 6 ];
		var scaleZSq = te[ 8 ] * te[ 8 ] + te[ 9 ] * te[ 9 ] + te[ 10 ] * te[ 10 ];

		return Math.sqrt( Math.max( scaleXSq, scaleYSq, scaleZSq ) );

	},

	makeTranslation: function ( x, y, z ) {

		this.set(

			1, 0, 0, x,
			0, 1, 0, y,
			0, 0, 1, z,
			0, 0, 0, 1

		);

		return this;

	},

	makeRotationX: function ( theta ) {

		var c = Math.cos( theta ), s = Math.sin( theta );

		this.set(

			1, 0,  0, 0,
			0, c, - s, 0,
			0, s,  c, 0,
			0, 0,  0, 1

		);

		return this;

	},

	makeRotationY: function ( theta ) {

		var c = Math.cos( theta ), s = Math.sin( theta );

		this.set(

			 c, 0, s, 0,
			 0, 1, 0, 0,
			- s, 0, c, 0,
			 0, 0, 0, 1

		);

		return this;

	},

	makeRotationZ: function ( theta ) {

		var c = Math.cos( theta ), s = Math.sin( theta );

		this.set(

			c, - s, 0, 0,
			s,  c, 0, 0,
			0,  0, 1, 0,
			0,  0, 0, 1

		);

		return this;

	},

	makeRotationAxis: function ( axis, angle ) {

		// Based on http://www.gamedev.net/reference/articles/article1199.asp

		var c = Math.cos( angle );
		var s = Math.sin( angle );
		var t = 1 - c;
		var x = axis.x, y = axis.y, z = axis.z;
		var tx = t * x, ty = t * y;

		this.set(

			tx * x + c, tx * y - s * z, tx * z + s * y, 0,
			tx * y + s * z, ty * y + c, ty * z - s * x, 0,
			tx * z - s * y, ty * z + s * x, t * z * z + c, 0,
			0, 0, 0, 1

		);

		 return this;

	},

	makeScale: function ( x, y, z ) {

		this.set(

			x, 0, 0, 0,
			0, y, 0, 0,
			0, 0, z, 0,
			0, 0, 0, 1

		);

		return this;

	},

	makeShear: function ( x, y, z ) {

		this.set(

			1, y, z, 0,
			x, 1, z, 0,
			x, y, 1, 0,
			0, 0, 0, 1

		);

		return this;

	},

	compose: function ( position, quaternion, scale ) {

		this.makeRotationFromQuaternion( quaternion );
		this.scale( scale );
		this.setPosition( position );

		return this;

	},

	decompose: function () {

		var vector, matrix;

		return function decompose( position, quaternion, scale ) {

			if ( vector === undefined ) {

				vector = new Vector3();
				matrix = new Matrix4();

			}

			var te = this.elements;

			var sx = vector.set( te[ 0 ], te[ 1 ], te[ 2 ] ).length();
			var sy = vector.set( te[ 4 ], te[ 5 ], te[ 6 ] ).length();
			var sz = vector.set( te[ 8 ], te[ 9 ], te[ 10 ] ).length();

			// if determine is negative, we need to invert one scale
			var det = this.determinant();
			if ( det < 0 ) {

				sx = - sx;

			}

			position.x = te[ 12 ];
			position.y = te[ 13 ];
			position.z = te[ 14 ];

			// scale the rotation part

			matrix.elements.set( this.elements ); // at this point matrix is incomplete so we can't use .copy()

			var invSX = 1 / sx;
			var invSY = 1 / sy;
			var invSZ = 1 / sz;

			matrix.elements[ 0 ] *= invSX;
			matrix.elements[ 1 ] *= invSX;
			matrix.elements[ 2 ] *= invSX;

			matrix.elements[ 4 ] *= invSY;
			matrix.elements[ 5 ] *= invSY;
			matrix.elements[ 6 ] *= invSY;

			matrix.elements[ 8 ] *= invSZ;
			matrix.elements[ 9 ] *= invSZ;
			matrix.elements[ 10 ] *= invSZ;

			quaternion.setFromRotationMatrix( matrix );

			scale.x = sx;
			scale.y = sy;
			scale.z = sz;

			return this;

		};

	}(),

	makeFrustum: function ( left, right, bottom, top, near, far ) {

		var te = this.elements;
		var x = 2 * near / ( right - left );
		var y = 2 * near / ( top - bottom );

		var a = ( right + left ) / ( right - left );
		var b = ( top + bottom ) / ( top - bottom );
		var c = - ( far + near ) / ( far - near );
		var d = - 2 * far * near / ( far - near );

		te[ 0 ] = x;	te[ 4 ] = 0;	te[ 8 ] = a;	te[ 12 ] = 0;
		te[ 1 ] = 0;	te[ 5 ] = y;	te[ 9 ] = b;	te[ 13 ] = 0;
		te[ 2 ] = 0;	te[ 6 ] = 0;	te[ 10 ] = c;	te[ 14 ] = d;
		te[ 3 ] = 0;	te[ 7 ] = 0;	te[ 11 ] = - 1;	te[ 15 ] = 0;

		return this;

	},

	makePerspective: function ( fov, aspect, near, far ) {

		var ymax = near * Math.tan( _Math.DEG2RAD * fov * 0.5 );
		var ymin = - ymax;
		var xmin = ymin * aspect;
		var xmax = ymax * aspect;

		return this.makeFrustum( xmin, xmax, ymin, ymax, near, far );

	},

	makeOrthographic: function ( left, right, top, bottom, near, far ) {

		var te = this.elements;
		var w = 1.0 / ( right - left );
		var h = 1.0 / ( top - bottom );
		var p = 1.0 / ( far - near );

		var x = ( right + left ) * w;
		var y = ( top + bottom ) * h;
		var z = ( far + near ) * p;

		te[ 0 ] = 2 * w;	te[ 4 ] = 0;	te[ 8 ] = 0;	te[ 12 ] = - x;
		te[ 1 ] = 0;	te[ 5 ] = 2 * h;	te[ 9 ] = 0;	te[ 13 ] = - y;
		te[ 2 ] = 0;	te[ 6 ] = 0;	te[ 10 ] = - 2 * p;	te[ 14 ] = - z;
		te[ 3 ] = 0;	te[ 7 ] = 0;	te[ 11 ] = 0;	te[ 15 ] = 1;

		return this;

	},

	equals: function ( matrix ) {

		var te = this.elements;
		var me = matrix.elements;

		for ( var i = 0; i < 16; i ++ ) {

			if ( te[ i ] !== me[ i ] ) return false;

		}

		return true;

	},

	fromArray: function ( array, offset ) {

		if ( offset === undefined ) offset = 0;

		for( var i = 0; i < 16; i ++ ) {

			this.elements[ i ] = array[ i + offset ];

		}

		return this;

	},

	toArray: function ( array, offset ) {

		if ( array === undefined ) array = [];
		if ( offset === undefined ) offset = 0;

		var te = this.elements;

		array[ offset ] = te[ 0 ];
		array[ offset + 1 ] = te[ 1 ];
		array[ offset + 2 ] = te[ 2 ];
		array[ offset + 3 ] = te[ 3 ];

		array[ offset + 4 ] = te[ 4 ];
		array[ offset + 5 ] = te[ 5 ];
		array[ offset + 6 ] = te[ 6 ];
		array[ offset + 7 ] = te[ 7 ];

		array[ offset + 8 ]  = te[ 8 ];
		array[ offset + 9 ]  = te[ 9 ];
		array[ offset + 10 ] = te[ 10 ];
		array[ offset + 11 ] = te[ 11 ];

		array[ offset + 12 ] = te[ 12 ];
		array[ offset + 13 ] = te[ 13 ];
		array[ offset + 14 ] = te[ 14 ];
		array[ offset + 15 ] = te[ 15 ];

		return array;

	}

};

/**
 * @author mrdoob / http://mrdoob.com/
 */

function CubeTexture( images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding ) {

	images = images !== undefined ? images : [];
	mapping = mapping !== undefined ? mapping : CubeReflectionMapping;

	Texture.call( this, images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );

	this.flipY = false;

}

CubeTexture.prototype = Object.create( Texture.prototype );
CubeTexture.prototype.constructor = CubeTexture;

CubeTexture.prototype.isCubeTexture = true;

Object.defineProperty( CubeTexture.prototype, 'images', {

	get: function () {

		return this.image;

	},

	set: function ( value ) {

		this.image = value;

	}

} );

/**
 * @author tschw
 *
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program, renderer )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [renderer] )
 *
 * 		uploads a uniform value(s)
 *  	the 'renderer' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (renderer factorizations):
 *
 * .upload( gl, seq, values, renderer )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (renderer factorizations):
 *
 * .setValue( gl, name, value )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .set( gl, obj, prop )
 *
 * 		sets uniform from object and property with same name than uniform
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */

var emptyTexture = new Texture();
var emptyCubeTexture = new CubeTexture();

// --- Base for inner nodes (including the root) ---

function UniformContainer() {

	this.seq = [];
	this.map = {};

}

// --- Utilities ---

// Array Caches (provide typed arrays for temporary by size)

var arrayCacheF32 = [];
var arrayCacheI32 = [];

// Flattening for arrays of vectors and matrices

function flatten( array, nBlocks, blockSize ) {

	var firstElem = array[ 0 ];

	if ( firstElem <= 0 || firstElem > 0 ) return array;
	// unoptimized: ! isNaN( firstElem )
	// see http://jacksondunstan.com/articles/983

	var n = nBlocks * blockSize,
		r = arrayCacheF32[ n ];

	if ( r === undefined ) {

		r = new Float32Array( n );
		arrayCacheF32[ n ] = r;

	}

	if ( nBlocks !== 0 ) {

		firstElem.toArray( r, 0 );

		for ( var i = 1, offset = 0; i !== nBlocks; ++ i ) {

			offset += blockSize;
			array[ i ].toArray( r, offset );

		}

	}

	return r;

}

// Texture unit allocation

function allocTexUnits( renderer, n ) {

	var r = arrayCacheI32[ n ];

	if ( r === undefined ) {

		r = new Int32Array( n );
		arrayCacheI32[ n ] = r;

	}

	for ( var i = 0; i !== n; ++ i )
		r[ i ] = renderer.allocTextureUnit();

	return r;

}

// --- Setters ---

// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.

// Single scalar

function setValue1f( gl, v ) { gl.uniform1f( this.addr, v ); }
function setValue1i( gl, v ) { gl.uniform1i( this.addr, v ); }

// Single float vector (from flat array or THREE.VectorN)

function setValue2fv( gl, v ) {

	if ( v.x === undefined ) gl.uniform2fv( this.addr, v );
	else gl.uniform2f( this.addr, v.x, v.y );

}

function setValue3fv( gl, v ) {

	if ( v.x !== undefined )
		gl.uniform3f( this.addr, v.x, v.y, v.z );
	else if ( v.r !== undefined )
		gl.uniform3f( this.addr, v.r, v.g, v.b );
	else
		gl.uniform3fv( this.addr, v );

}

function setValue4fv( gl, v ) {

	if ( v.x === undefined ) gl.uniform4fv( this.addr, v );
	else gl.uniform4f( this.addr, v.x, v.y, v.z, v.w );

}

// Single matrix (from flat array or MatrixN)

function setValue2fm( gl, v ) {

	gl.uniformMatrix2fv( this.addr, false, v.elements || v );

}

function setValue3fm( gl, v ) {

	gl.uniformMatrix3fv( this.addr, false, v.elements || v );

}

function setValue4fm( gl, v ) {

	gl.uniformMatrix4fv( this.addr, false, v.elements || v );

}

// Single texture (2D / Cube)

function setValueT1( gl, v, renderer ) {

	var unit = renderer.allocTextureUnit();
	gl.uniform1i( this.addr, unit );
	renderer.setTexture2D( v || emptyTexture, unit );

}

function setValueT6( gl, v, renderer ) {

	var unit = renderer.allocTextureUnit();
	gl.uniform1i( this.addr, unit );
	renderer.setTextureCube( v || emptyCubeTexture, unit );

}

// Integer / Boolean vectors or arrays thereof (always flat arrays)

function setValue2iv( gl, v ) { gl.uniform2iv( this.addr, v ); }
function setValue3iv( gl, v ) { gl.uniform3iv( this.addr, v ); }
function setValue4iv( gl, v ) { gl.uniform4iv( this.addr, v ); }

// Helper to pick the right setter for the singular case

function getSingularSetter( type ) {

	switch ( type ) {

		case 0x1406: return setValue1f; // FLOAT
		case 0x8b50: return setValue2fv; // _VEC2
		case 0x8b51: return setValue3fv; // _VEC3
		case 0x8b52: return setValue4fv; // _VEC4

		case 0x8b5a: return setValue2fm; // _MAT2
		case 0x8b5b: return setValue3fm; // _MAT3
		case 0x8b5c: return setValue4fm; // _MAT4

		case 0x8b5e: return setValueT1; // SAMPLER_2D
		case 0x8b60: return setValueT6; // SAMPLER_CUBE

		case 0x1404: case 0x8b56: return setValue1i; // INT, BOOL
		case 0x8b53: case 0x8b57: return setValue2iv; // _VEC2
		case 0x8b54: case 0x8b58: return setValue3iv; // _VEC3
		case 0x8b55: case 0x8b59: return setValue4iv; // _VEC4

	}

}

// Array of scalars

function setValue1fv( gl, v ) { gl.uniform1fv( this.addr, v ); }
function setValue1iv( gl, v ) { gl.uniform1iv( this.addr, v ); }

// Array of vectors (flat or from THREE classes)

function setValueV2a( gl, v ) {

	gl.uniform2fv( this.addr, flatten( v, this.size, 2 ) );

}

function setValueV3a( gl, v ) {

	gl.uniform3fv( this.addr, flatten( v, this.size, 3 ) );

}

function setValueV4a( gl, v ) {

	gl.uniform4fv( this.addr, flatten( v, this.size, 4 ) );

}

// Array of matrices (flat or from THREE clases)

function setValueM2a( gl, v ) {

	gl.uniformMatrix2fv( this.addr, false, flatten( v, this.size, 4 ) );

}

function setValueM3a( gl, v ) {

	gl.uniformMatrix3fv( this.addr, false, flatten( v, this.size, 9 ) );

}

function setValueM4a( gl, v ) {

	gl.uniformMatrix4fv( this.addr, false, flatten( v, this.size, 16 ) );

}

// Array of textures (2D / Cube)

function setValueT1a( gl, v, renderer ) {

	var n = v.length,
		units = allocTexUnits( renderer, n );

	gl.uniform1iv( this.addr, units );

	for ( var i = 0; i !== n; ++ i ) {

		renderer.setTexture2D( v[ i ] || emptyTexture, units[ i ] );

	}

}

function setValueT6a( gl, v, renderer ) {

	var n = v.length,
		units = allocTexUnits( renderer, n );

	gl.uniform1iv( this.addr, units );

	for ( var i = 0; i !== n; ++ i ) {

		renderer.setTextureCube( v[ i ] || emptyCubeTexture, units[ i ] );

	}

}

// Helper to pick the right setter for a pure (bottom-level) array

function getPureArraySetter( type ) {

	switch ( type ) {

		case 0x1406: return setValue1fv; // FLOAT
		case 0x8b50: return setValueV2a; // _VEC2
		case 0x8b51: return setValueV3a; // _VEC3
		case 0x8b52: return setValueV4a; // _VEC4

		case 0x8b5a: return setValueM2a; // _MAT2
		case 0x8b5b: return setValueM3a; // _MAT3
		case 0x8b5c: return setValueM4a; // _MAT4

		case 0x8b5e: return setValueT1a; // SAMPLER_2D
		case 0x8b60: return setValueT6a; // SAMPLER_CUBE

		case 0x1404: case 0x8b56: return setValue1iv; // INT, BOOL
		case 0x8b53: case 0x8b57: return setValue2iv; // _VEC2
		case 0x8b54: case 0x8b58: return setValue3iv; // _VEC3
		case 0x8b55: case 0x8b59: return setValue4iv; // _VEC4

	}

}

// --- Uniform Classes ---

function SingleUniform( id, activeInfo, addr ) {

	this.id = id;
	this.addr = addr;
	this.setValue = getSingularSetter( activeInfo.type );

	// this.path = activeInfo.name; // DEBUG

}

function PureArrayUniform( id, activeInfo, addr ) {

	this.id = id;
	this.addr = addr;
	this.size = activeInfo.size;
	this.setValue = getPureArraySetter( activeInfo.type );

	// this.path = activeInfo.name; // DEBUG

}

function StructuredUniform( id ) {

	this.id = id;

	UniformContainer.call( this ); // mix-in

}

StructuredUniform.prototype.setValue = function( gl, value ) {

	// Note: Don't need an extra 'renderer' parameter, since samplers
	// are not allowed in structured uniforms.

	var seq = this.seq;

	for ( var i = 0, n = seq.length; i !== n; ++ i ) {

		var u = seq[ i ];
		u.setValue( gl, value[ u.id ] );

	}

};

// --- Top-level ---

// Parser - builds up the property tree from the path strings

var RePathPart = /([\w\d_]+)(\])?(\[|\.)?/g;

// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.

function addUniform( container, uniformObject ) {

	container.seq.push( uniformObject );
	container.map[ uniformObject.id ] = uniformObject;

}

function parseUniform( activeInfo, addr, container ) {

	var path = activeInfo.name,
		pathLength = path.length;

	// reset RegExp object, because of the early exit of a previous run
	RePathPart.lastIndex = 0;

	for (; ;) {

		var match = RePathPart.exec( path ),
			matchEnd = RePathPart.lastIndex,

			id = match[ 1 ],
			idIsIndex = match[ 2 ] === ']',
			subscript = match[ 3 ];

		if ( idIsIndex ) id = id | 0; // convert to integer

		if ( subscript === undefined ||
				subscript === '[' && matchEnd + 2 === pathLength ) {
			// bare name or "pure" bottom-level array "[0]" suffix

			addUniform( container, subscript === undefined ?
					new SingleUniform( id, activeInfo, addr ) :
					new PureArrayUniform( id, activeInfo, addr ) );

			break;

		} else {
			// step into inner node / create it in case it doesn't exist

			var map = container.map,
				next = map[ id ];

			if ( next === undefined ) {

				next = new StructuredUniform( id );
				addUniform( container, next );

			}

			container = next;

		}

	}

}

// Root Container

function WebGLUniforms( gl, program, renderer ) {

	UniformContainer.call( this );

	this.renderer = renderer;

	var n = gl.getProgramParameter( program, gl.ACTIVE_UNIFORMS );

	for ( var i = 0; i !== n; ++ i ) {

		var info = gl.getActiveUniform( program, i ),
			path = info.name,
			addr = gl.getUniformLocation( program, path );

		parseUniform( info, addr, this );

	}

}

WebGLUniforms.prototype.setValue = function( gl, name, value ) {

	var u = this.map[ name ];

	if ( u !== undefined ) u.setValue( gl, value, this.renderer );

};

WebGLUniforms.prototype.set = function( gl, object, name ) {

	var u = this.map[ name ];

	if ( u !== undefined ) u.setValue( gl, object[ name ], this.renderer );

};

WebGLUniforms.prototype.setOptional = function( gl, object, name ) {

	var v = object[ name ];

	if ( v !== undefined ) this.setValue( gl, name, v );

};


// Static interface

WebGLUniforms.upload = function( gl, seq, values, renderer ) {

	for ( var i = 0, n = seq.length; i !== n; ++ i ) {

		var u = seq[ i ],
			v = values[ u.id ];

		if ( v.needsUpdate !== false ) {
			// note: always updating when .needsUpdate is undefined

			u.setValue( gl, v.value, renderer );

		}

	}

};

WebGLUniforms.seqWithValue = function( seq, values ) {

	var r = [];

	for ( var i = 0, n = seq.length; i !== n; ++ i ) {

		var u = seq[ i ];
		if ( u.id in values ) r.push( u );

	}

	return r;

};

/**
 * Uniform Utilities
 */

var UniformsUtils = {

	merge: function ( uniforms ) {

		var merged = {};

		for ( var u = 0; u < uniforms.length; u ++ ) {

			var tmp = this.clone( uniforms[ u ] );

			for ( var p in tmp ) {

				merged[ p ] = tmp[ p ];

			}

		}

		return merged;

	},

	clone: function ( uniforms_src ) {

		var uniforms_dst = {};

		for ( var u in uniforms_src ) {

			uniforms_dst[ u ] = {};

			for ( var p in uniforms_src[ u ] ) {

				var parameter_src = uniforms_src[ u ][ p ];

				if ( parameter_src && ( parameter_src.isColor ||
					parameter_src.isMatrix3 || parameter_src.isMatrix4 ||
					parameter_src.isVector2 || parameter_src.isVector3 || parameter_src.isVector4 ||
					parameter_src.isTexture ) ) {

					uniforms_dst[ u ][ p ] = parameter_src.clone();

				} else if ( Array.isArray( parameter_src ) ) {

					uniforms_dst[ u ][ p ] = parameter_src.slice();

				} else {

					uniforms_dst[ u ][ p ] = parameter_src;

				}

			}

		}

		return uniforms_dst;

	}

};

var alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif\n";

var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif\n";

var alphatest_fragment = "#ifdef ALPHATEST\n\tif ( diffuseColor.a < ALPHATEST ) discard;\n#endif\n";

var aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.specularRoughness );\n\t#endif\n#endif\n";

var aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";

var begin_vertex = "\nvec3 transformed = vec3( position );\n";

var beginnormal_vertex = "\nvec3 objectNormal = vec3( normal );\n";

var bsdfs = "float punctualLightIntensityToIrradianceFactor( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\t\tif( decayExponent > 0.0 ) {\n#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\t\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\t\tfloat maxDistanceCutoffFactor = pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\t\treturn distanceFalloff * maxDistanceCutoffFactor;\n#else\n\t\t\treturn pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );\n#endif\n\t\t}\n\t\treturn 1.0;\n}\nvec3 BRDF_Diffuse_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 specularColor, const in float dotLH ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotLH - 6.98316 ) * dotLH );\n\treturn ( 1.0 - specularColor ) * fresnel + specularColor;\n}\nfloat G_GGX_Smith( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gl = dotNL + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\tfloat gv = dotNV + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\treturn 1.0 / ( gl * gv );\n}\nfloat G_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_Specular_GGX( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNL = saturate( dot( geometry.normal, incidentLight.direction ) );\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( G * D );\n}\nvec2 ltcTextureCoords( const in GeometricContext geometry, const in float roughness ) {\n\tconst float LUT_SIZE  = 64.0;\n\tconst float LUT_SCALE = (LUT_SIZE - 1.0)/LUT_SIZE;\n\tconst float LUT_BIAS  = 0.5/LUT_SIZE;\n\tvec3 N = geometry.normal;\n\tvec3 V = geometry.viewDir;\n\tvec3 P = geometry.position;\n\tfloat theta = acos( dot( N, V ) );\n\tvec2 uv = vec2(\n\t\tsqrt( saturate( roughness ) ),\n\t\tsaturate( theta / ( 0.5 * PI ) ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nvoid clipQuadToHorizon( inout vec3 L[5], out int n ) {\n\tint config = 0;\n\tif ( L[0].z > 0.0 ) config += 1;\n\tif ( L[1].z > 0.0 ) config += 2;\n\tif ( L[2].z > 0.0 ) config += 4;\n\tif ( L[3].z > 0.0 ) config += 8;\n\tn = 0;\n\tif ( config == 0 ) {\n\t} else if ( config == 1 ) {\n\t\tn = 3;\n\t\tL[1] = -L[1].z * L[0] + L[0].z * L[1];\n\t\tL[2] = -L[3].z * L[0] + L[0].z * L[3];\n\t} else if ( config == 2 ) {\n\t\tn = 3;\n\t\tL[0] = -L[0].z * L[1] + L[1].z * L[0];\n\t\tL[2] = -L[2].z * L[1] + L[1].z * L[2];\n\t} else if ( config == 3 ) {\n\t\tn = 4;\n\t\tL[2] = -L[2].z * L[1] + L[1].z * L[2];\n\t\tL[3] = -L[3].z * L[0] + L[0].z * L[3];\n\t} else if ( config == 4 ) {\n\t\tn = 3;\n\t\tL[0] = -L[3].z * L[2] + L[2].z * L[3];\n\t\tL[1] = -L[1].z * L[2] + L[2].z * L[1];\n\t} else if ( config == 5 ) {\n\t\tn = 0;\n\t} else if ( config == 6 ) {\n\t\tn = 4;\n\t\tL[0] = -L[0].z * L[1] + L[1].z * L[0];\n\t\tL[3] = -L[3].z * L[2] + L[2].z * L[3];\n\t} else if ( config == 7 ) {\n\t\tn = 5;\n\t\tL[4] = -L[3].z * L[0] + L[0].z * L[3];\n\t\tL[3] = -L[3].z * L[2] + L[2].z * L[3];\n\t} else if ( config == 8 ) {\n\t\tn = 3;\n\t\tL[0] = -L[0].z * L[3] + L[3].z * L[0];\n\t\tL[1] = -L[2].z * L[3] + L[3].z * L[2];\n\t\tL[2] =  L[3];\n\t} else if ( config == 9 ) {\n\t\tn = 4;\n\t\tL[1] = -L[1].z * L[0] + L[0].z * L[1];\n\t\tL[2] = -L[2].z * L[3] + L[3].z * L[2];\n\t} else if ( config == 10 ) {\n\t\tn = 0;\n\t} else if ( config == 11 ) {\n\t\tn = 5;\n\t\tL[4] = L[3];\n\t\tL[3] = -L[2].z * L[3] + L[3].z * L[2];\n\t\tL[2] = -L[2].z * L[1] + L[1].z * L[2];\n\t} else if ( config == 12 ) {\n\t\tn = 4;\n\t\tL[1] = -L[1].z * L[2] + L[2].z * L[1];\n\t\tL[0] = -L[0].z * L[3] + L[3].z * L[0];\n\t} else if ( config == 13 ) {\n\t\tn = 5;\n\t\tL[4] = L[3];\n\t\tL[3] = L[2];\n\t\tL[2] = -L[1].z * L[2] + L[2].z * L[1];\n\t\tL[1] = -L[1].z * L[0] + L[0].z * L[1];\n\t} else if ( config == 14 ) {\n\t\tn = 5;\n\t\tL[4] = -L[0].z * L[3] + L[3].z * L[0];\n\t\tL[0] = -L[0].z * L[1] + L[1].z * L[0];\n\t} else if ( config == 15 ) {\n\t\tn = 4;\n\t}\n\tif ( n == 3 )\n\t\tL[3] = L[0];\n\tif ( n == 4 )\n\t\tL[4] = L[0];\n}\nfloat integrateLtcBrdfOverRectEdge( vec3 v1, vec3 v2 ) {\n\tfloat cosTheta = dot( v1, v2 );\n\tfloat theta = acos( cosTheta );\n\tfloat res = cross( v1, v2 ).z * ( ( theta > 0.001 ) ? theta / sin( theta ) : 1.0 );\n\treturn res;\n}\nvoid initRectPoints( const in vec3 pos, const in vec3 halfWidth, const in vec3 halfHeight, out vec3 rectPoints[4] ) {\n\trectPoints[0] = pos - halfWidth - halfHeight;\n\trectPoints[1] = pos + halfWidth - halfHeight;\n\trectPoints[2] = pos + halfWidth + halfHeight;\n\trectPoints[3] = pos - halfWidth + halfHeight;\n}\nvec3 integrateLtcBrdfOverRect( const in GeometricContext geometry, const in mat3 brdfMat, const in vec3 rectPoints[4] ) {\n\tvec3 N = geometry.normal;\n\tvec3 V = geometry.viewDir;\n\tvec3 P = geometry.position;\n\tvec3 T1, T2;\n\tT1 = normalize(V - N * dot( V, N ));\n\tT2 = - cross( N, T1 );\n\tmat3 brdfWrtSurface = brdfMat * transpose( mat3( T1, T2, N ) );\n\tvec3 clippedRect[5];\n\tclippedRect[0] = brdfWrtSurface * ( rectPoints[0] - P );\n\tclippedRect[1] = brdfWrtSurface * ( rectPoints[1] - P );\n\tclippedRect[2] = brdfWrtSurface * ( rectPoints[2] - P );\n\tclippedRect[3] = brdfWrtSurface * ( rectPoints[3] - P );\n\tint n;\n\tclipQuadToHorizon(clippedRect, n);\n\tif ( n == 0 )\n\t\treturn vec3( 0, 0, 0 );\n\tclippedRect[0] = normalize( clippedRect[0] );\n\tclippedRect[1] = normalize( clippedRect[1] );\n\tclippedRect[2] = normalize( clippedRect[2] );\n\tclippedRect[3] = normalize( clippedRect[3] );\n\tclippedRect[4] = normalize( clippedRect[4] );\n\tfloat sum = 0.0;\n\tsum += integrateLtcBrdfOverRectEdge( clippedRect[0], clippedRect[1] );\n\tsum += integrateLtcBrdfOverRectEdge( clippedRect[1], clippedRect[2] );\n\tsum += integrateLtcBrdfOverRectEdge( clippedRect[2], clippedRect[3] );\n\tif (n >= 4)\n\t\tsum += integrateLtcBrdfOverRectEdge( clippedRect[3], clippedRect[4] );\n\tif (n == 5)\n\t\tsum += integrateLtcBrdfOverRectEdge( clippedRect[4], clippedRect[0] );\n\tsum = max( 0.0, sum );\n\tvec3 Lo_i = vec3( sum, sum, sum );\n\treturn Lo_i;\n}\nvec3 Rect_Area_Light_Specular_Reflectance(\n\t\tconst in GeometricContext geometry,\n\t\tconst in vec3 lightPos, const in vec3 lightHalfWidth, const in vec3 lightHalfHeight,\n\t\tconst in float roughness,\n\t\tconst in sampler2D ltcMat, const in sampler2D ltcMag ) {\n\tvec3 rectPoints[4];\n\tinitRectPoints( lightPos, lightHalfWidth, lightHalfHeight, rectPoints );\n\tvec2 uv = ltcTextureCoords( geometry, roughness );\n\tvec4 brdfLtcApproxParams, t;\n\tbrdfLtcApproxParams = texture2D( ltcMat, uv );\n\tt = texture2D( ltcMat, uv );\n\tfloat brdfLtcScalar = texture2D( ltcMag, uv ).a;\n\tmat3 brdfLtcApproxMat = mat3(\n\t\tvec3(   1,   0, t.y ),\n\t\tvec3(   0, t.z,   0 ),\n\t\tvec3( t.w,   0, t.x )\n\t);\n\tvec3 specularReflectance = integrateLtcBrdfOverRect( geometry, brdfLtcApproxMat, rectPoints );\n\tspecularReflectance *= brdfLtcScalar;\n\treturn specularReflectance;\n}\nvec3 Rect_Area_Light_Diffuse_Reflectance(\n\t\tconst in GeometricContext geometry,\n\t\tconst in vec3 lightPos, const in vec3 lightHalfWidth, const in vec3 lightHalfHeight ) {\n\tvec3 rectPoints[4];\n\tinitRectPoints( lightPos, lightHalfWidth, lightHalfHeight, rectPoints );\n\tmat3 diffuseBrdfMat = mat3(1);\n\tvec3 diffuseReflectance = integrateLtcBrdfOverRect( geometry, diffuseBrdfMat, rectPoints );\n\treturn diffuseReflectance;\n}\nvec3 BRDF_Specular_GGX_Environment( const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 AB = vec2( -1.04, 1.04 ) * a004 + r.zw;\n\treturn specularColor * AB.x + AB.y;\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_Specular_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\nfloat GGXRoughnessToBlinnExponent( const in float ggxRoughness ) {\n\treturn ( 2.0 / pow2( ggxRoughness + 0.0001 ) - 2.0 );\n}\nfloat BlinnExponentToGGXRoughness( const in float blinnExponent ) {\n\treturn sqrt( 2.0 / ( blinnExponent + 2.0 ) );\n}\n";

var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy ) {\n\t\tvec3 vSigmaX = dFdx( surf_pos );\n\t\tvec3 vSigmaY = dFdy( surf_pos );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 );\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif\n";

var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; ++ i ) {\n\t\tvec4 plane = clippingPlanes[ i ];\n\t\tif ( dot( vViewPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t\t\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; ++ i ) {\n\t\t\tvec4 plane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vViewPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\tif ( clipped ) discard;\n\t\n\t#endif\n#endif\n";

var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\t#if ! defined( PHYSICAL ) && ! defined( PHONG )\n\t\tvarying vec3 vViewPosition;\n\t#endif\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif\n";

var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvarying vec3 vViewPosition;\n#endif\n";

var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n";

var color_fragment = "#ifdef USE_COLOR\n\tdiffuseColor.rgb *= vColor;\n#endif";

var color_pars_fragment = "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif\n";

var color_pars_vertex = "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif";

var color_vertex = "#ifdef USE_COLOR\n\tvColor.xyz = color.xyz;\n#endif";

var common = "#define PI 3.14159265359\n#define PI2 6.28318530718\n#define PI_HALF 1.5707963267949\n#define RECIPROCAL_PI 0.31830988618\n#define RECIPROCAL_PI2 0.15915494\n#define LOG2 1.442695\n#define EPSILON 1e-6\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#define whiteCompliment(a) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract(sin(sn) * c);\n}\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\tfloat distance = dot( planeNormal, point - pointOnPlane );\n\treturn - distance * planeNormal + point;\n}\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn sign( dot( point - pointOnPlane, planeNormal ) );\n}\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) ) + pointOnLine;\n}\nmat3 transpose( const in mat3 v ) {\n\tmat3 tmp;\n\ttmp[0] = vec3(v[0].x, v[1].x, v[2].x);\n\ttmp[1] = vec3(v[0].y, v[1].y, v[2].y);\n\ttmp[2] = vec3(v[0].z, v[1].z, v[2].z);\n\treturn tmp;\n}\n";

var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n#define cubeUV_textureSize (1024.0)\nint getFaceFromDirection(vec3 direction) {\n\tvec3 absDirection = abs(direction);\n\tint face = -1;\n\tif( absDirection.x > absDirection.z ) {\n\t\tif(absDirection.x > absDirection.y )\n\t\t\tface = direction.x > 0.0 ? 0 : 3;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\telse {\n\t\tif(absDirection.z > absDirection.y )\n\t\t\tface = direction.z > 0.0 ? 2 : 5;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\treturn face;\n}\n#define cubeUV_maxLods1  (log2(cubeUV_textureSize*0.25) - 1.0)\n#define cubeUV_rangeClamp (exp2((6.0 - 1.0) * 2.0))\nvec2 MipLevelInfo( vec3 vec, float roughnessLevel, float roughness ) {\n\tfloat scale = exp2(cubeUV_maxLods1 - roughnessLevel);\n\tfloat dxRoughness = dFdx(roughness);\n\tfloat dyRoughness = dFdy(roughness);\n\tvec3 dx = dFdx( vec * scale * dxRoughness );\n\tvec3 dy = dFdy( vec * scale * dyRoughness );\n\tfloat d = max( dot( dx, dx ), dot( dy, dy ) );\n\td = clamp(d, 1.0, cubeUV_rangeClamp);\n\tfloat mipLevel = 0.5 * log2(d);\n\treturn vec2(floor(mipLevel), fract(mipLevel));\n}\n#define cubeUV_maxLods2 (log2(cubeUV_textureSize*0.25) - 2.0)\n#define cubeUV_rcpTextureSize (1.0 / cubeUV_textureSize)\nvec2 getCubeUV(vec3 direction, float roughnessLevel, float mipLevel) {\n\tmipLevel = roughnessLevel > cubeUV_maxLods2 - 3.0 ? 0.0 : mipLevel;\n\tfloat a = 16.0 * cubeUV_rcpTextureSize;\n\tvec2 exp2_packed = exp2( vec2( roughnessLevel, mipLevel ) );\n\tvec2 rcp_exp2_packed = vec2( 1.0 ) / exp2_packed;\n\tfloat powScale = exp2_packed.x * exp2_packed.y;\n\tfloat scale = rcp_exp2_packed.x * rcp_exp2_packed.y * 0.25;\n\tfloat mipOffset = 0.75*(1.0 - rcp_exp2_packed.y) * rcp_exp2_packed.x;\n\tbool bRes = mipLevel == 0.0;\n\tscale =  bRes && (scale < a) ? a : scale;\n\tvec3 r;\n\tvec2 offset;\n\tint face = getFaceFromDirection(direction);\n\tfloat rcpPowScale = 1.0 / powScale;\n\tif( face == 0) {\n\t\tr = vec3(direction.x, -direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ?  a : offset.y;\n\t}\n\telse if( face == 1) {\n\t\tr = vec3(direction.y, direction.x, direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ?  a : offset.y;\n\t}\n\telse if( face == 2) {\n\t\tr = vec3(direction.z, direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ?  a : offset.y;\n\t}\n\telse if( face == 3) {\n\t\tr = vec3(direction.x, direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ?  0.0 : offset.y;\n\t}\n\telse if( face == 4) {\n\t\tr = vec3(direction.y, direction.x, -direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ?  0.0 : offset.y;\n\t}\n\telse {\n\t\tr = vec3(direction.z, -direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ?  0.0 : offset.y;\n\t}\n\tr = normalize(r);\n\tfloat texelOffset = 0.5 * cubeUV_rcpTextureSize;\n\tvec2 s = ( r.yz / abs( r.x ) + vec2( 1.0 ) ) * 0.5;\n\tvec2 base = offset + vec2( texelOffset );\n\treturn base + s * ( scale - 2.0 * texelOffset );\n}\n#define cubeUV_maxLods3 (log2(cubeUV_textureSize*0.25) - 3.0)\nvec4 textureCubeUV(vec3 reflectedDirection, float roughness ) {\n\tfloat roughnessVal = roughness* cubeUV_maxLods3;\n\tfloat r1 = floor(roughnessVal);\n\tfloat r2 = r1 + 1.0;\n\tfloat t = fract(roughnessVal);\n\tvec2 mipInfo = MipLevelInfo(reflectedDirection, r1, roughness);\n\tfloat s = mipInfo.y;\n\tfloat level0 = mipInfo.x;\n\tfloat level1 = level0 + 1.0;\n\tlevel1 = level1 > 5.0 ? 5.0 : level1;\n\tlevel0 += min( floor( s + 0.5 ), 5.0 );\n\tvec2 uv_10 = getCubeUV(reflectedDirection, r1, level0);\n\tvec4 color10 = envMapTexelToLinear(texture2D(envMap, uv_10));\n\tvec2 uv_20 = getCubeUV(reflectedDirection, r2, level0);\n\tvec4 color20 = envMapTexelToLinear(texture2D(envMap, uv_20));\n\tvec4 result = mix(color10, color20, t);\n\treturn vec4(result.rgb, 1.0);\n}\n#endif\n";

var defaultnormal_vertex = "#ifdef FLIP_SIDED\n\tobjectNormal = -objectNormal;\n#endif\nvec3 transformedNormal = normalMatrix * objectNormal;\n";

var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif\n";

var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normal * ( texture2D( displacementMap, uv ).x * displacementScale + displacementBias );\n#endif\n";

var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\temissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif\n";

var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif\n";

var encodings_fragment = "  gl_FragColor = linearToOutputTexel( gl_FragColor );\n";

var encodings_pars_fragment = "\nvec4 LinearToLinear( in vec4 value ) {\n  return value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n  return vec4( pow( value.xyz, vec3( gammaFactor ) ), value.w );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n  return vec4( pow( value.xyz, vec3( 1.0 / gammaFactor ) ), value.w );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n  return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.w );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n  return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.w );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n  return vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n  float maxComponent = max( max( value.r, value.g ), value.b );\n  float fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n  return vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n  return vec4( value.xyz * value.w * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n  float maxRGB = max( value.x, max( value.g, value.b ) );\n  float M      = clamp( maxRGB / maxRange, 0.0, 1.0 );\n  M            = ceil( M * 255.0 ) / 255.0;\n  return vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n    return vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n    float maxRGB = max( value.x, max( value.g, value.b ) );\n    float D      = max( maxRange / maxRGB, 1.0 );\n    D            = min( floor( D ) / 255.0, 1.0 );\n    return vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value )  {\n  vec3 Xp_Y_XYZp = value.rgb * cLogLuvM;\n  Xp_Y_XYZp = max(Xp_Y_XYZp, vec3(1e-6, 1e-6, 1e-6));\n  vec4 vResult;\n  vResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n  float Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n  vResult.w = fract(Le);\n  vResult.z = (Le - (floor(vResult.w*255.0))/255.0)/255.0;\n  return vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n  float Le = value.z * 255.0 + value.w;\n  vec3 Xp_Y_XYZp;\n  Xp_Y_XYZp.y = exp2((Le - 127.0) / 2.0);\n  Xp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n  Xp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n  vec3 vRGB = Xp_Y_XYZp.rgb * cLogLuvInverseM;\n  return vec4( max(vRGB, 0.0), 1.0 );\n}\n";

var envmap_fragment = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvec3 cameraToVertex = normalize( vWorldPosition - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, flipNormal * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\tvec2 sampleUV;\n\t\tsampleUV.y = saturate( flipNormal * reflectVec.y * 0.5 + 0.5 );\n\t\tsampleUV.x = atan( flipNormal * reflectVec.z, flipNormal * reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\tvec4 envColor = texture2D( envMap, sampleUV );\n\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\tvec3 reflectView = flipNormal * normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0, 0.0, 1.0 ) );\n\t\tvec4 envColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\tenvColor = envMapTexelToLinear( envColor );\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif\n";

var envmap_pars_fragment = "#if defined( USE_ENVMAP ) || defined( PHYSICAL )\n\tuniform float reflectivity;\n\tuniform float envMapIntensity;\n#endif\n#ifdef USE_ENVMAP\n\t#if ! defined( PHYSICAL ) && ( defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) )\n\t\tvarying vec3 vWorldPosition;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\tuniform float flipEnvMap;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( PHYSICAL )\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif\n";

var envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif\n";

var envmap_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif\n";

var fog_fragment = "#ifdef USE_FOG\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tfloat depth = gl_FragDepthEXT / gl_FragCoord.w;\n\t#else\n\t\tfloat depth = gl_FragCoord.z / gl_FragCoord.w;\n\t#endif\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = whiteCompliment( exp2( - fogDensity * fogDensity * depth * depth * LOG2 ) );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, depth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif\n";

var fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";

var gradientmap_pars_fragment = "#ifdef TOON\n\tuniform sampler2D gradientMap;\n\tvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\t\tfloat dotNL = dot( normal, lightDirection );\n\t\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t\t#ifdef USE_GRADIENTMAP\n\t\t\treturn texture2D( gradientMap, coord ).rgb;\n\t\t#else\n\t\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t\t#endif\n\t}\n#endif\n";

var lightmap_fragment = "#ifdef USE_LIGHTMAP\n\treflectedLight.indirectDiffuse += PI * texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n#endif\n";

var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";

var lights_lambert_vertex = "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\n#if NUM_POINT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointDirectLightIrradiance( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotDirectLightIrradiance( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t}\n#endif\n#if NUM_DIR_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalDirectLightIrradiance( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvLightFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n\t\t#endif\n\t}\n#endif\n";

var lights_pars = "uniform vec3 ambientLightColor;\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treturn irradiance;\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalDirectLightIrradiance( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tdirectLight.color = directionalLight.color;\n\t\tdirectLight.direction = directionalLight.direction;\n\t\tdirectLight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointDirectLightIrradiance( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tdirectLight.color = pointLight.color;\n\t\tdirectLight.color *= punctualLightIntensityToIrradianceFactor( lightDistance, pointLight.distance, pointLight.decay );\n\t\tdirectLight.visible = ( directLight.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotDirectLightIrradiance( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight directLight  ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tfloat angleCos = dot( directLight.direction, spotLight.direction );\n\t\tif ( angleCos > spotLight.coneCos ) {\n\t\t\tfloat spotEffect = smoothstep( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\t\tdirectLight.color = spotLight.color;\n\t\t\tdirectLight.color *= spotEffect * punctualLightIntensityToIrradianceFactor( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tdirectLight.visible = true;\n\t\t} else {\n\t\t\tdirectLight.color = vec3( 0.0 );\n\t\t\tdirectLight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltcMat;\tuniform sampler2D ltcMag;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n\t\tfloat dotNL = dot( geometry.normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tirradiance *= PI;\n\t\t#endif\n\t\treturn irradiance;\n\t}\n#endif\n#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\tvec3 getLightProbeIndirectIrradiance( const in GeometricContext geometry, const in int maxMIPLevel ) {\n\t\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\tvec4 envMapColor = textureCubeUV( queryVec, 1.0 );\n\t\t#else\n\t\t\tvec4 envMapColor = vec4( 0.0 );\n\t\t#endif\n\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t}\n\tfloat getSpecularMIPLevel( const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\tfloat maxMIPLevelScalar = float( maxMIPLevel );\n\t\tfloat desiredMIPLevel = maxMIPLevelScalar - 0.79248 - 0.5 * log2( pow2( blinnShininessExponent ) + 1.0 );\n\t\treturn clamp( desiredMIPLevel, 0.0, maxMIPLevelScalar );\n\t}\n\tvec3 getLightProbeIndirectRadiance( const in GeometricContext geometry, const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( -geometry.viewDir, geometry.normal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( -geometry.viewDir, geometry.normal, refractionRatio );\n\t\t#endif\n\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\tfloat specularMIPLevel = getSpecularMIPLevel( blinnShininessExponent, maxMIPLevel );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\tvec4 envMapColor = textureCubeUV(queryReflectVec, BlinnExponentToGGXRoughness(blinnShininessExponent));\n\t\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\t\tvec2 sampleUV;\n\t\t\tsampleUV.y = saturate( reflectVec.y * 0.5 + 0.5 );\n\t\t\tsampleUV.x = atan( reflectVec.z, reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, sampleUV, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, sampleUV, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\t\tvec3 reflectView = normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0,0.0,1.0 ) );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#endif\n\t\treturn envMapColor.rgb * envMapIntensity;\n\t}\n#endif\n";

var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;\n";

var lights_phong_pars_fragment = "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct BlinnPhongMaterial {\n\tvec3\tdiffuseColor;\n\tvec3\tspecularColor;\n\tfloat\tspecularShininess;\n\tfloat\tspecularStrength;\n};\n#if NUM_RECT_AREA_LIGHTS > 0\n    void RE_Direct_RectArea_BlinnPhong( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n        vec3 matDiffColor = material.diffuseColor;\n        vec3 matSpecColor = material.specularColor;\n        vec3 lightColor   = rectAreaLight.color;\n        float roughness = BlinnExponentToGGXRoughness( material.specularShininess );\n        vec3 spec = Rect_Area_Light_Specular_Reflectance(\n                geometry,\n                rectAreaLight.position, rectAreaLight.halfWidth, rectAreaLight.halfHeight,\n                roughness,\n                ltcMat, ltcMag );\n        vec3 diff = Rect_Area_Light_Diffuse_Reflectance(\n                geometry,\n                rectAreaLight.position, rectAreaLight.halfWidth, rectAreaLight.halfHeight );\n        reflectedLight.directSpecular += lightColor * matSpecColor * spec / PI2;\n        reflectedLight.directDiffuse  += lightColor * matDiffColor * diff / PI2;\n    }\n#endif\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifdef TOON\n\t\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\t#else\n\t\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\t\tvec3 irradiance = dotNL * directLight.color;\n\t#endif\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_Specular_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)\n";

var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nmaterial.specularRoughness = clamp( roughnessFactor, 0.04, 1.0 );\n#ifdef STANDARD\n\tmaterial.specularColor = mix( vec3( DEFAULT_SPECULAR_COEFFICIENT ), diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( MAXIMUM_SPECULAR_COEFFICIENT * pow2( reflectivity ) ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.clearCoat = saturate( clearCoat );\tmaterial.clearCoatRoughness = clamp( clearCoatRoughness, 0.04, 1.0 );\n#endif\n";

var lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3\tdiffuseColor;\n\tfloat\tspecularRoughness;\n\tvec3\tspecularColor;\n\t#ifndef STANDARD\n\t\tfloat clearCoat;\n\t\tfloat clearCoatRoughness;\n\t#endif\n};\n#define MAXIMUM_SPECULAR_COEFFICIENT 0.16\n#define DEFAULT_SPECULAR_COEFFICIENT 0.04\nfloat clearCoatDHRApprox( const in float roughness, const in float dotNL ) {\n\treturn DEFAULT_SPECULAR_COEFFICIENT + ( 1.0 - DEFAULT_SPECULAR_COEFFICIENT ) * ( pow( 1.0 - dotNL, 5.0 ) * pow( 1.0 - roughness, 2.0 ) );\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n    void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n        vec3 matDiffColor = material.diffuseColor;\n        vec3 matSpecColor = material.specularColor;\n        vec3 lightColor   = rectAreaLight.color;\n        float roughness = material.specularRoughness;\n        vec3 spec = Rect_Area_Light_Specular_Reflectance(\n                geometry,\n                rectAreaLight.position, rectAreaLight.halfWidth, rectAreaLight.halfHeight,\n                roughness,\n                ltcMat, ltcMag );\n        vec3 diff = Rect_Area_Light_Diffuse_Reflectance(\n                geometry,\n                rectAreaLight.position, rectAreaLight.halfWidth, rectAreaLight.halfHeight );\n        reflectedLight.directSpecular += lightColor * matSpecColor * spec;\n        reflectedLight.directDiffuse  += lightColor * matDiffColor * diff;\n    }\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\t#ifndef STANDARD\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.directSpecular += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Specular_GGX( directLight, geometry, material.specularColor, material.specularRoughness );\n\treflectedLight.directDiffuse += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\t#ifndef STANDARD\n\t\treflectedLight.directSpecular += irradiance * material.clearCoat * BRDF_Specular_GGX( directLight, geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 clearCoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifndef STANDARD\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\tfloat dotNL = dotNV;\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.indirectSpecular += ( 1.0 - clearCoatDHR ) * radiance * BRDF_Specular_GGX_Environment( geometry, material.specularColor, material.specularRoughness );\n\t#ifndef STANDARD\n\t\treflectedLight.indirectSpecular += clearCoatRadiance * material.clearCoat * BRDF_Specular_GGX_Environment( geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\n#define Material_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.specularRoughness )\n#define Material_ClearCoat_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.clearCoatRoughness )\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}\n";

var lights_template = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = normalize( vViewPosition );\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointDirectLightIrradiance( pointLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( pointLight.shadow, directLight.visible ) ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotDirectLightIrradiance( spotLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( spotLight.shadow, directLight.visible ) ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalDirectLightIrradiance( directionalLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( directionalLight.shadow, directLight.visible ) ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#ifdef USE_LIGHTMAP\n\t\tvec3 lightMapIrradiance = texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tlightMapIrradiance *= PI;\n\t\t#endif\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t}\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t \tirradiance += getLightProbeIndirectIrradiance( geometry, 8 );\n\t#endif\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tvec3 radiance = getLightProbeIndirectRadiance( geometry, Material_BlinnShininessExponent( material ), 8 );\n\t#ifndef STANDARD\n\t\tvec3 clearCoatRadiance = getLightProbeIndirectRadiance( geometry, Material_ClearCoat_BlinnShininessExponent( material ), 8 );\n\t#else\n\t\tvec3 clearCoatRadiance = vec3( 0.0 );\n\t#endif\n\t\t\n\tRE_IndirectSpecular( radiance, clearCoatRadiance, geometry, material, reflectedLight );\n#endif\n";

var logdepthbuf_fragment = "#if defined(USE_LOGDEPTHBUF) && defined(USE_LOGDEPTHBUF_EXT)\n\tgl_FragDepthEXT = log2(vFragDepth) * logDepthBufFC * 0.5;\n#endif";

var logdepthbuf_pars_fragment = "#ifdef USE_LOGDEPTHBUF\n\tuniform float logDepthBufFC;\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n#endif\n";

var logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n\tuniform float logDepthBufFC;\n#endif";

var logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\tgl_Position.z = log2(max( EPSILON, gl_Position.w + 1.0 )) * logDepthBufFC;\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t#else\n\t\tgl_Position.z = (gl_Position.z - 1.0) * gl_Position.w;\n\t#endif\n#endif\n";

var map_fragment = "#ifdef USE_MAP\n\tvec4 texelColor = texture2D( map, vUv );\n\ttexelColor = mapTexelToLinear( texelColor );\n\tdiffuseColor *= texelColor;\n#endif\n";

var map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n";

var map_particle_fragment = "#ifdef USE_MAP\n\tvec4 mapTexel = texture2D( map, vec2( gl_PointCoord.x, 1.0 - gl_PointCoord.y ) * offsetRepeat.zw + offsetRepeat.xy );\n\tdiffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n";

var map_particle_pars_fragment = "#ifdef USE_MAP\n\tuniform vec4 offsetRepeat;\n\tuniform sampler2D map;\n#endif\n";

var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.r;\n#endif\n";

var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";

var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal += ( morphNormal0 - normal ) * morphTargetInfluences[ 0 ];\n\tobjectNormal += ( morphNormal1 - normal ) * morphTargetInfluences[ 1 ];\n\tobjectNormal += ( morphNormal2 - normal ) * morphTargetInfluences[ 2 ];\n\tobjectNormal += ( morphNormal3 - normal ) * morphTargetInfluences[ 3 ];\n#endif\n";

var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_MORPHNORMALS\n\tuniform float morphTargetInfluences[ 8 ];\n\t#else\n\tuniform float morphTargetInfluences[ 4 ];\n\t#endif\n#endif";

var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed += ( morphTarget0 - position ) * morphTargetInfluences[ 0 ];\n\ttransformed += ( morphTarget1 - position ) * morphTargetInfluences[ 1 ];\n\ttransformed += ( morphTarget2 - position ) * morphTargetInfluences[ 2 ];\n\ttransformed += ( morphTarget3 - position ) * morphTargetInfluences[ 3 ];\n\t#ifndef USE_MORPHNORMALS\n\ttransformed += ( morphTarget4 - position ) * morphTargetInfluences[ 4 ];\n\ttransformed += ( morphTarget5 - position ) * morphTargetInfluences[ 5 ];\n\ttransformed += ( morphTarget6 - position ) * morphTargetInfluences[ 6 ];\n\ttransformed += ( morphTarget7 - position ) * morphTargetInfluences[ 7 ];\n\t#endif\n#endif\n";

var normal_flip = "#ifdef DOUBLE_SIDED\n\tfloat flipNormal = ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n#else\n\tfloat flipNormal = 1.0;\n#endif\n";

var normal_fragment = "#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal ) * flipNormal;\n#endif\n#ifdef USE_NORMALMAP\n\tnormal = perturbNormal2Arb( -vViewPosition, normal );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd() );\n#endif\n";

var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 S = normalize( q0 * st1.t - q1 * st0.t );\n\t\tvec3 T = normalize( -q0 * st1.s + q1 * st0.s );\n\t\tvec3 N = normalize( surf_norm );\n\t\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t\tmapN.xy = normalScale * mapN.xy;\n\t\tmat3 tsn = mat3( S, T, N );\n\t\treturn normalize( tsn * mapN );\n\t}\n#endif\n";

var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n  return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n  return 1.0 - 2.0 * rgb.xyz;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256.,  256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n  return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n  return linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n  return (( near + viewZ ) * far ) / (( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n  return ( near * far ) / ( ( far - near ) * invClipZ - far );\n}\n";

var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif\n";

var project_vertex = "#ifdef USE_SKINNING\n\tvec4 mvPosition = modelViewMatrix * skinned;\n#else\n\tvec4 mvPosition = modelViewMatrix * vec4( transformed, 1.0 );\n#endif\ngl_Position = projectionMatrix * mvPosition;\n";

var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.r;\n#endif\n";

var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";

var shadowmap_pars_fragment = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n    #if NUM_RECT_AREA_LIGHTS > 0\n    #endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tfloat texture2DShadowLerp( sampler2D depths, vec2 size, vec2 uv, float compare ) {\n\t\tconst vec2 offset = vec2( 0.0, 1.0 );\n\t\tvec2 texelSize = vec2( 1.0 ) / size;\n\t\tvec2 centroidUV = floor( uv * size + 0.5 ) / size;\n\t\tfloat lb = texture2DCompare( depths, centroidUV + texelSize * offset.xx, compare );\n\t\tfloat lt = texture2DCompare( depths, centroidUV + texelSize * offset.xy, compare );\n\t\tfloat rb = texture2DCompare( depths, centroidUV + texelSize * offset.yx, compare );\n\t\tfloat rt = texture2DCompare( depths, centroidUV + texelSize * offset.yy, compare );\n\t\tvec2 f = fract( uv * size + 0.5 );\n\t\tfloat a = mix( lb, lt, f.y );\n\t\tfloat b = mix( rb, rt, f.y );\n\t\tfloat c = mix( a, b, f.x );\n\t\treturn c;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\treturn (\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn 1.0;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\tfloat dp = ( length( lightToPosition ) - shadowBias ) / 1000.0;\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif\n";

var shadowmap_pars_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n    #if NUM_RECT_AREA_LIGHTS > 0\n    #endif\n#endif\n";

var shadowmap_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n    #if NUM_RECT_AREA_LIGHTS > 0\n    #endif\n#endif\n";

var shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\tDirectionalLight directionalLight;\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tshadow *= bool( directionalLight.shadow ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\tSpotLight spotLight;\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tshadow *= bool( spotLight.shadow ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\tPointLight pointLight;\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tshadow *= bool( pointLight.shadow ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_RECT_AREA_LIGHTS > 0\n\t#endif\n\t#endif\n\treturn shadow;\n}\n";

var skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";

var skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform sampler2D boneTexture;\n\t\tuniform int boneTextureWidth;\n\t\tuniform int boneTextureHeight;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureWidth ) );\n\t\t\tfloat y = floor( j / float( boneTextureWidth ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureWidth );\n\t\t\tfloat dy = 1.0 / float( boneTextureHeight );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif\n";

var skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\tskinned  = bindMatrixInverse * skinned;\n#endif\n";

var skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix  = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n#endif\n";

var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";

var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";

var tonemapping_fragment = "#if defined( TONE_MAPPING )\n  gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif\n";

var tonemapping_pars_fragment = "#define saturate(a) clamp( a, 0.0, 1.0 )\nuniform float toneMappingExposure;\nuniform float toneMappingWhitePoint;\nvec3 LinearToneMapping( vec3 color ) {\n  return toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n  color *= toneMappingExposure;\n  return saturate( color / ( vec3( 1.0 ) + color ) );\n}\n#define Uncharted2Helper( x ) max( ( ( x * ( 0.15 * x + 0.10 * 0.50 ) + 0.20 * 0.02 ) / ( x * ( 0.15 * x + 0.50 ) + 0.20 * 0.30 ) ) - 0.02 / 0.30, vec3( 0.0 ) )\nvec3 Uncharted2ToneMapping( vec3 color ) {\n  color *= toneMappingExposure;\n  return saturate( Uncharted2Helper( color ) / Uncharted2Helper( vec3( toneMappingWhitePoint ) ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n  color *= toneMappingExposure;\n  color = max( vec3( 0.0 ), color - 0.004 );\n  return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\n";

var uv_pars_fragment = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n#endif";

var uv_pars_vertex = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n\tuniform vec4 offsetRepeat;\n#endif\n";

var uv_vertex = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvUv = uv * offsetRepeat.zw + offsetRepeat.xy;\n#endif";

var uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif";

var uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n#endif";

var uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = uv2;\n#endif";

var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( PHONG ) || defined( PHYSICAL ) || defined( LAMBERT ) || defined ( USE_SHADOWMAP )\n\t#ifdef USE_SKINNING\n\t\tvec4 worldPosition = modelMatrix * skinned;\n\t#else\n\t\tvec4 worldPosition = modelMatrix * vec4( transformed, 1.0 );\n\t#endif\n#endif\n";

var cube_frag = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tgl_FragColor = textureCube( tCube, vec3( tFlip * vWorldPosition.x, vWorldPosition.yz ) );\n\tgl_FragColor.a *= opacity;\n}\n";

var cube_vert = "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}\n";

var depth_frag = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( gl_FragCoord.z ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( gl_FragCoord.z );\n\t#endif\n}\n";

var depth_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#include <begin_vertex>\n\t#include <displacementmap_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n}\n";

var distanceRGBA_frag = "uniform vec3 lightPos;\nvarying vec4 vWorldPosition;\n#include <common>\n#include <packing>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tgl_FragColor = packDepthToRGBA( length( vWorldPosition.xyz - lightPos.xyz ) / 1000.0 );\n}\n";

var distanceRGBA_vert = "varying vec4 vWorldPosition;\n#include <common>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <skinbase_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition;\n}\n";

var equirect_frag = "uniform sampler2D tEquirect;\nuniform float tFlip;\nvarying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldPosition );\n\tvec2 sampleUV;\n\tsampleUV.y = saturate( tFlip * direction.y * -0.5 + 0.5 );\n\tsampleUV.x = atan( direction.z, direction.x ) * RECIPROCAL_PI2 + 0.5;\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n}\n";

var equirect_vert = "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}\n";

var linedashed_frag = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";

var linedashed_vert = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\tvLineDistance = scale * lineDistance;\n\tvec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n}\n";

var meshbasic_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\treflectedLight.indirectDiffuse += texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <normal_flip>\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";

var meshbasic_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_ENVMAP\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <envmap_vertex>\n}\n";

var meshlambert_frag = "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <packing>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <bsdfs>\n#include <lights_pars>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\treflectedLight.indirectDiffuse = getAmbientLightIrradiance( ambientLightColor );\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <normal_flip>\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";

var meshlambert_vert = "#define LAMBERT\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars>\n#include <color_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n}\n";

var meshphong_frag = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_flip>\n\t#include <normal_fragment>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_template>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";

var meshphong_vert = "#define PHONG\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <displacementmap_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n}\n";

var meshphysical_frag = "#define PHYSICAL\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifndef STANDARD\n\tuniform float clearCoat;\n\tuniform float clearCoatRoughness;\n#endif\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <packing>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <lights_pars>\n#include <lights_physical_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_flip>\n\t#include <normal_fragment>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_template>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";

var meshphysical_vert = "#define PHYSICAL\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <displacementmap_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n}\n";

var normal_frag = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED  ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\t#include <normal_flip>\n\t#include <normal_fragment>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n\t#include <premultiplied_alpha_fragment>\n\t#include <encodings_fragment>\n}\n";

var normal_vert = "#define NORMAL\n#if defined( FLAT_SHADED  ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <displacementmap_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n#if defined( FLAT_SHADED  ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}\n";

var points_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";

var points_vert = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#ifdef USE_SIZEATTENUATION\n\t\tgl_PointSize = size * ( scale / - mvPosition.z );\n\t#else\n\t\tgl_PointSize = size;\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n}\n";

var shadow_frag = "uniform float opacity;\n#include <common>\n#include <packing>\n#include <bsdfs>\n#include <lights_pars>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( 0.0, 0.0, 0.0, opacity * ( 1.0  - getShadowMask() ) );\n}\n";

var shadow_vert = "#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n}\n";

var ShaderChunk = {
	alphamap_fragment: alphamap_fragment,
	alphamap_pars_fragment: alphamap_pars_fragment,
	alphatest_fragment: alphatest_fragment,
	aomap_fragment: aomap_fragment,
	aomap_pars_fragment: aomap_pars_fragment,
	begin_vertex: begin_vertex,
	beginnormal_vertex: beginnormal_vertex,
	bsdfs: bsdfs,
	bumpmap_pars_fragment: bumpmap_pars_fragment,
	clipping_planes_fragment: clipping_planes_fragment,
	clipping_planes_pars_fragment: clipping_planes_pars_fragment,
	clipping_planes_pars_vertex: clipping_planes_pars_vertex,
	clipping_planes_vertex: clipping_planes_vertex,
	color_fragment: color_fragment,
	color_pars_fragment: color_pars_fragment,
	color_pars_vertex: color_pars_vertex,
	color_vertex: color_vertex,
	common: common,
	cube_uv_reflection_fragment: cube_uv_reflection_fragment,
	defaultnormal_vertex: defaultnormal_vertex,
	displacementmap_pars_vertex: displacementmap_pars_vertex,
	displacementmap_vertex: displacementmap_vertex,
	emissivemap_fragment: emissivemap_fragment,
	emissivemap_pars_fragment: emissivemap_pars_fragment,
	encodings_fragment: encodings_fragment,
	encodings_pars_fragment: encodings_pars_fragment,
	envmap_fragment: envmap_fragment,
	envmap_pars_fragment: envmap_pars_fragment,
	envmap_pars_vertex: envmap_pars_vertex,
	envmap_vertex: envmap_vertex,
	fog_fragment: fog_fragment,
	fog_pars_fragment: fog_pars_fragment,
	gradientmap_pars_fragment: gradientmap_pars_fragment,
	lightmap_fragment: lightmap_fragment,
	lightmap_pars_fragment: lightmap_pars_fragment,
	lights_lambert_vertex: lights_lambert_vertex,
	lights_pars: lights_pars,
	lights_phong_fragment: lights_phong_fragment,
	lights_phong_pars_fragment: lights_phong_pars_fragment,
	lights_physical_fragment: lights_physical_fragment,
	lights_physical_pars_fragment: lights_physical_pars_fragment,
	lights_template: lights_template,
	logdepthbuf_fragment: logdepthbuf_fragment,
	logdepthbuf_pars_fragment: logdepthbuf_pars_fragment,
	logdepthbuf_pars_vertex: logdepthbuf_pars_vertex,
	logdepthbuf_vertex: logdepthbuf_vertex,
	map_fragment: map_fragment,
	map_pars_fragment: map_pars_fragment,
	map_particle_fragment: map_particle_fragment,
	map_particle_pars_fragment: map_particle_pars_fragment,
	metalnessmap_fragment: metalnessmap_fragment,
	metalnessmap_pars_fragment: metalnessmap_pars_fragment,
	morphnormal_vertex: morphnormal_vertex,
	morphtarget_pars_vertex: morphtarget_pars_vertex,
	morphtarget_vertex: morphtarget_vertex,
	normal_flip: normal_flip,
	normal_fragment: normal_fragment,
	normalmap_pars_fragment: normalmap_pars_fragment,
	packing: packing,
	premultiplied_alpha_fragment: premultiplied_alpha_fragment,
	project_vertex: project_vertex,
	roughnessmap_fragment: roughnessmap_fragment,
	roughnessmap_pars_fragment: roughnessmap_pars_fragment,
	shadowmap_pars_fragment: shadowmap_pars_fragment,
	shadowmap_pars_vertex: shadowmap_pars_vertex,
	shadowmap_vertex: shadowmap_vertex,
	shadowmask_pars_fragment: shadowmask_pars_fragment,
	skinbase_vertex: skinbase_vertex,
	skinning_pars_vertex: skinning_pars_vertex,
	skinning_vertex: skinning_vertex,
	skinnormal_vertex: skinnormal_vertex,
	specularmap_fragment: specularmap_fragment,
	specularmap_pars_fragment: specularmap_pars_fragment,
	tonemapping_fragment: tonemapping_fragment,
	tonemapping_pars_fragment: tonemapping_pars_fragment,
	uv_pars_fragment: uv_pars_fragment,
	uv_pars_vertex: uv_pars_vertex,
	uv_vertex: uv_vertex,
	uv2_pars_fragment: uv2_pars_fragment,
	uv2_pars_vertex: uv2_pars_vertex,
	uv2_vertex: uv2_vertex,
	worldpos_vertex: worldpos_vertex,

	cube_frag: cube_frag,
	cube_vert: cube_vert,
	depth_frag: depth_frag,
	depth_vert: depth_vert,
	distanceRGBA_frag: distanceRGBA_frag,
	distanceRGBA_vert: distanceRGBA_vert,
	equirect_frag: equirect_frag,
	equirect_vert: equirect_vert,
	linedashed_frag: linedashed_frag,
	linedashed_vert: linedashed_vert,
	meshbasic_frag: meshbasic_frag,
	meshbasic_vert: meshbasic_vert,
	meshlambert_frag: meshlambert_frag,
	meshlambert_vert: meshlambert_vert,
	meshphong_frag: meshphong_frag,
	meshphong_vert: meshphong_vert,
	meshphysical_frag: meshphysical_frag,
	meshphysical_vert: meshphysical_vert,
	normal_frag: normal_frag,
	normal_vert: normal_vert,
	points_frag: points_frag,
	points_vert: points_vert,
	shadow_frag: shadow_frag,
	shadow_vert: shadow_vert
};

/**
 * @author mrdoob / http://mrdoob.com/
 */

function Color( r, g, b ) {

	if ( g === undefined && b === undefined ) {

		// r is THREE.Color, hex or string
		return this.set( r );

	}

	return this.setRGB( r, g, b );

}

Color.prototype = {

	constructor: Color,

	isColor: true,

	r: 1, g: 1, b: 1,

	set: function ( value ) {

		if ( value && value.isColor ) {

			this.copy( value );

		} else if ( typeof value === 'number' ) {

			this.setHex( value );

		} else if ( typeof value === 'string' ) {

			this.setStyle( value );

		}

		return this;

	},

	setScalar: function ( scalar ) {

		this.r = scalar;
		this.g = scalar;
		this.b = scalar;

		return this;

	},

	setHex: function ( hex ) {

		hex = Math.floor( hex );

		this.r = ( hex >> 16 & 255 ) / 255;
		this.g = ( hex >> 8 & 255 ) / 255;
		this.b = ( hex & 255 ) / 255;

		return this;

	},

	setRGB: function ( r, g, b ) {

		this.r = r;
		this.g = g;
		this.b = b;

		return this;

	},

	setHSL: function () {

		function hue2rgb( p, q, t ) {

			if ( t < 0 ) t += 1;
			if ( t > 1 ) t -= 1;
			if ( t < 1 / 6 ) return p + ( q - p ) * 6 * t;
			if ( t < 1 / 2 ) return q;
			if ( t < 2 / 3 ) return p + ( q - p ) * 6 * ( 2 / 3 - t );
			return p;

		}

		return function setHSL( h, s, l ) {

			// h,s,l ranges are in 0.0 - 1.0
			h = _Math.euclideanModulo( h, 1 );
			s = _Math.clamp( s, 0, 1 );
			l = _Math.clamp( l, 0, 1 );

			if ( s === 0 ) {

				this.r = this.g = this.b = l;

			} else {

				var p = l <= 0.5 ? l * ( 1 + s ) : l + s - ( l * s );
				var q = ( 2 * l ) - p;

				this.r = hue2rgb( q, p, h + 1 / 3 );
				this.g = hue2rgb( q, p, h );
				this.b = hue2rgb( q, p, h - 1 / 3 );

			}

			return this;

		};

	}(),

	setStyle: function ( style ) {

		function handleAlpha( string ) {

			if ( string === undefined ) return;

			if ( parseFloat( string ) < 1 ) {

				console.warn( 'THREE.Color: Alpha component of ' + style + ' will be ignored.' );

			}

		}


		var m;

		if ( m = /^((?:rgb|hsl)a?)\(\s*([^\)]*)\)/.exec( style ) ) {

			// rgb / hsl

			var color;
			var name = m[ 1 ];
			var components = m[ 2 ];

			switch ( name ) {

				case 'rgb':
				case 'rgba':

					if ( color = /^(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {

						// rgb(255,0,0) rgba(255,0,0,0.5)
						this.r = Math.min( 255, parseInt( color[ 1 ], 10 ) ) / 255;
						this.g = Math.min( 255, parseInt( color[ 2 ], 10 ) ) / 255;
						this.b = Math.min( 255, parseInt( color[ 3 ], 10 ) ) / 255;

						handleAlpha( color[ 5 ] );

						return this;

					}

					if ( color = /^(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {

						// rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
						this.r = Math.min( 100, parseInt( color[ 1 ], 10 ) ) / 100;
						this.g = Math.min( 100, parseInt( color[ 2 ], 10 ) ) / 100;
						this.b = Math.min( 100, parseInt( color[ 3 ], 10 ) ) / 100;

						handleAlpha( color[ 5 ] );

						return this;

					}

					break;

				case 'hsl':
				case 'hsla':

					if ( color = /^([0-9]*\.?[0-9]+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {

						// hsl(120,50%,50%) hsla(120,50%,50%,0.5)
						var h = parseFloat( color[ 1 ] ) / 360;
						var s = parseInt( color[ 2 ], 10 ) / 100;
						var l = parseInt( color[ 3 ], 10 ) / 100;

						handleAlpha( color[ 5 ] );

						return this.setHSL( h, s, l );

					}

					break;

			}

		} else if ( m = /^\#([A-Fa-f0-9]+)$/.exec( style ) ) {

			// hex color

			var hex = m[ 1 ];
			var size = hex.length;

			if ( size === 3 ) {

				// #ff0
				this.r = parseInt( hex.charAt( 0 ) + hex.charAt( 0 ), 16 ) / 255;
				this.g = parseInt( hex.charAt( 1 ) + hex.charAt( 1 ), 16 ) / 255;
				this.b = parseInt( hex.charAt( 2 ) + hex.charAt( 2 ), 16 ) / 255;

				return this;

			} else if ( size === 6 ) {

				// #ff0000
				this.r = parseInt( hex.charAt( 0 ) + hex.charAt( 1 ), 16 ) / 255;
				this.g = parseInt( hex.charAt( 2 ) + hex.charAt( 3 ), 16 ) / 255;
				this.b = parseInt( hex.charAt( 4 ) + hex.charAt( 5 ), 16 ) / 255;

				return this;

			}

		}

		if ( style && style.length > 0 ) {

			// color keywords
			var hex = ColorKeywords[ style ];

			if ( hex !== undefined ) {

				// red
				this.setHex( hex );

			} else {

				// unknown color
				console.warn( 'THREE.Color: Unknown color ' + style );

			}

		}

		return this;

	},

	clone: function () {

		return new this.constructor( this.r, this.g, this.b );

	},

	copy: function ( color ) {

		this.r = color.r;
		this.g = color.g;
		this.b = color.b;

		return this;

	},

	copyGammaToLinear: function ( color, gammaFactor ) {

		if ( gammaFactor === undefined ) gammaFactor = 2.0;

		this.r = Math.pow( color.r, gammaFactor );
		this.g = Math.pow( color.g, gammaFactor );
		this.b = Math.pow( color.b, gammaFactor );

		return this;

	},

	copyLinearToGamma: function ( color, gammaFactor ) {

		if ( gammaFactor === undefined ) gammaFactor = 2.0;

		var safeInverse = ( gammaFactor > 0 ) ? ( 1.0 / gammaFactor ) : 1.0;

		this.r = Math.pow( color.r, safeInverse );
		this.g = Math.pow( color.g, safeInverse );
		this.b = Math.pow( color.b, safeInverse );

		return this;

	},

	convertGammaToLinear: function () {

		var r = this.r, g = this.g, b = this.b;

		this.r = r * r;
		this.g = g * g;
		this.b = b * b;

		return this;

	},

	convertLinearToGamma: function () {

		this.r = Math.sqrt( this.r );
		this.g = Math.sqrt( this.g );
		this.b = Math.sqrt( this.b );

		return this;

	},

	getHex: function () {

		return ( this.r * 255 ) << 16 ^ ( this.g * 255 ) << 8 ^ ( this.b * 255 ) << 0;

	},

	getHexString: function () {

		return ( '000000' + this.getHex().toString( 16 ) ).slice( - 6 );

	},

	getHSL: function ( optionalTarget ) {

		// h,s,l ranges are in 0.0 - 1.0

		var hsl = optionalTarget || { h: 0, s: 0, l: 0 };

		var r = this.r, g = this.g, b = this.b;

		var max = Math.max( r, g, b );
		var min = Math.min( r, g, b );

		var hue, saturation;
		var lightness = ( min + max ) / 2.0;

		if ( min === max ) {

			hue = 0;
			saturation = 0;

		} else {

			var delta = max - min;

			saturation = lightness <= 0.5 ? delta / ( max + min ) : delta / ( 2 - max - min );

			switch ( max ) {

				case r: hue = ( g - b ) / delta + ( g < b ? 6 : 0 ); break;
				case g: hue = ( b - r ) / delta + 2; break;
				case b: hue = ( r - g ) / delta + 4; break;

			}

			hue /= 6;

		}

		hsl.h = hue;
		hsl.s = saturation;
		hsl.l = lightness;

		return hsl;

	},

	getStyle: function () {

		return 'rgb(' + ( ( this.r * 255 ) | 0 ) + ',' + ( ( this.g * 255 ) | 0 ) + ',' + ( ( this.b * 255 ) | 0 ) + ')';

	},

	offsetHSL: function ( h, s, l ) {

		var hsl = this.getHSL();

		hsl.h += h; hsl.s += s; hsl.l += l;

		this.setHSL( hsl.h, hsl.s, hsl.l );

		return this;

	},

	add: function ( color ) {

		this.r += color.r;
		this.g += color.g;
		this.b += color.b;

		return this;

	},

	addColors: function ( color1, color2 ) {

		this.r = color1.r + color2.r;
		this.g = color1.g + color2.g;
		this.b = color1.b + color2.b;

		return this;

	},

	addScalar: function ( s ) {

		this.r += s;
		this.g += s;
		this.b += s;

		return this;

	},

	sub: function( color ) {

		this.r = Math.max( 0, this.r - color.r );
		this.g = Math.max( 0, this.g - color.g );
		this.b = Math.max( 0, this.b - color.b );

		return this;

	},

	multiply: function ( color ) {

		this.r *= color.r;
		this.g *= color.g;
		this.b *= color.b;

		return this;

	},

	multiplyScalar: function ( s ) {

		this.r *= s;
		this.g *= s;
		this.b *= s;

		return this;

	},

	lerp: function ( color, alpha ) {

		this.r += ( color.r - this.r ) * alpha;
		this.g += ( color.g - this.g ) * alpha;
		this.b += ( color.b - this.b ) * alpha;

		return this;

	},

	equals: function ( c ) {

		return ( c.r === this.r ) && ( c.g === this.g ) && ( c.b === this.b );

	},

	fromArray: function ( array, offset ) {

		if ( offset === undefined ) offset = 0;

		this.r = array[ offset ];
		this.g = array[ offset + 1 ];
		this.b = array[ offset + 2 ];

		return this;

	},

	toArray: function ( array, offset ) {

		if ( array === undefined ) array = [];
		if ( offset === undefined ) offset = 0;

		array[ offset ] = this.r;
		array[ offset + 1 ] = this.g;
		array[ offset + 2 ] = this.b;

		return array;

	},

	toJSON: function () {

		return this.getHex();

	}

};

var ColorKeywords = { 'aliceblue': 0xF0F8FF, 'antiquewhite': 0xFAEBD7, 'aqua': 0x00FFFF, 'aquamarine': 0x7FFFD4, 'azure': 0xF0FFFF,
'beige': 0xF5F5DC, 'bisque': 0xFFE4C4, 'black': 0x000000, 'blanchedalmond': 0xFFEBCD, 'blue': 0x0000FF, 'blueviolet': 0x8A2BE2,
'brown': 0xA52A2A, 'burlywood': 0xDEB887, 'cadetblue': 0x5F9EA0, 'chartreuse': 0x7FFF00, 'chocolate': 0xD2691E, 'coral': 0xFF7F50,
'cornflowerblue': 0x6495ED, 'cornsilk': 0xFFF8DC, 'crimson': 0xDC143C, 'cyan': 0x00FFFF, 'darkblue': 0x00008B, 'darkcyan': 0x008B8B,
'darkgoldenrod': 0xB8860B, 'darkgray': 0xA9A9A9, 'darkgreen': 0x006400, 'darkgrey': 0xA9A9A9, 'darkkhaki': 0xBDB76B, 'darkmagenta': 0x8B008B,
'darkolivegreen': 0x556B2F, 'darkorange': 0xFF8C00, 'darkorchid': 0x9932CC, 'darkred': 0x8B0000, 'darksalmon': 0xE9967A, 'darkseagreen': 0x8FBC8F,
'darkslateblue': 0x483D8B, 'darkslategray': 0x2F4F4F, 'darkslategrey': 0x2F4F4F, 'darkturquoise': 0x00CED1, 'darkviolet': 0x9400D3,
'deeppink': 0xFF1493, 'deepskyblue': 0x00BFFF, 'dimgray': 0x696969, 'dimgrey': 0x696969, 'dodgerblue': 0x1E90FF, 'firebrick': 0xB22222,
'floralwhite': 0xFFFAF0, 'forestgreen': 0x228B22, 'fuchsia': 0xFF00FF, 'gainsboro': 0xDCDCDC, 'ghostwhite': 0xF8F8FF, 'gold': 0xFFD700,
'goldenrod': 0xDAA520, 'gray': 0x808080, 'green': 0x008000, 'greenyellow': 0xADFF2F, 'grey': 0x808080, 'honeydew': 0xF0FFF0, 'hotpink': 0xFF69B4,
'indianred': 0xCD5C5C, 'indigo': 0x4B0082, 'ivory': 0xFFFFF0, 'khaki': 0xF0E68C, 'lavender': 0xE6E6FA, 'lavenderblush': 0xFFF0F5, 'lawngreen': 0x7CFC00,
'lemonchiffon': 0xFFFACD, 'lightblue': 0xADD8E6, 'lightcoral': 0xF08080, 'lightcyan': 0xE0FFFF, 'lightgoldenrodyellow': 0xFAFAD2, 'lightgray': 0xD3D3D3,
'lightgreen': 0x90EE90, 'lightgrey': 0xD3D3D3, 'lightpink': 0xFFB6C1, 'lightsalmon': 0xFFA07A, 'lightseagreen': 0x20B2AA, 'lightskyblue': 0x87CEFA,
'lightslategray': 0x778899, 'lightslategrey': 0x778899, 'lightsteelblue': 0xB0C4DE, 'lightyellow': 0xFFFFE0, 'lime': 0x00FF00, 'limegreen': 0x32CD32,
'linen': 0xFAF0E6, 'magenta': 0xFF00FF, 'maroon': 0x800000, 'mediumaquamarine': 0x66CDAA, 'mediumblue': 0x0000CD, 'mediumorchid': 0xBA55D3,
'mediumpurple': 0x9370DB, 'mediumseagreen': 0x3CB371, 'mediumslateblue': 0x7B68EE, 'mediumspringgreen': 0x00FA9A, 'mediumturquoise': 0x48D1CC,
'mediumvioletred': 0xC71585, 'midnightblue': 0x191970, 'mintcream': 0xF5FFFA, 'mistyrose': 0xFFE4E1, 'moccasin': 0xFFE4B5, 'navajowhite': 0xFFDEAD,
'navy': 0x000080, 'oldlace': 0xFDF5E6, 'olive': 0x808000, 'olivedrab': 0x6B8E23, 'orange': 0xFFA500, 'orangered': 0xFF4500, 'orchid': 0xDA70D6,
'palegoldenrod': 0xEEE8AA, 'palegreen': 0x98FB98, 'paleturquoise': 0xAFEEEE, 'palevioletred': 0xDB7093, 'papayawhip': 0xFFEFD5, 'peachpuff': 0xFFDAB9,
'peru': 0xCD853F, 'pink': 0xFFC0CB, 'plum': 0xDDA0DD, 'powderblue': 0xB0E0E6, 'purple': 0x800080, 'red': 0xFF0000, 'rosybrown': 0xBC8F8F,
'royalblue': 0x4169E1, 'saddlebrown': 0x8B4513, 'salmon': 0xFA8072, 'sandybrown': 0xF4A460, 'seagreen': 0x2E8B57, 'seashell': 0xFFF5EE,
'sienna': 0xA0522D, 'silver': 0xC0C0C0, 'skyblue': 0x87CEEB, 'slateblue': 0x6A5ACD, 'slategray': 0x708090, 'slategrey': 0x708090, 'snow': 0xFFFAFA,
'springgreen': 0x00FF7F, 'steelblue': 0x4682B4, 'tan': 0xD2B48C, 'teal': 0x008080, 'thistle': 0xD8BFD8, 'tomato': 0xFF6347, 'turquoise': 0x40E0D0,
'violet': 0xEE82EE, 'wheat': 0xF5DEB3, 'white': 0xFFFFFF, 'whitesmoke': 0xF5F5F5, 'yellow': 0xFFFF00, 'yellowgreen': 0x9ACD32 };

/**
 * @author alteredq / http://alteredqualia.com/
 */

function DataTexture( data, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding ) {

	Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );

	this.image = { data: data, width: width, height: height };

	this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
	this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;

	this.generateMipmaps  = false;
	this.flipY = false;
	this.unpackAlignment = 1;

}

DataTexture.prototype = Object.create( Texture.prototype );
DataTexture.prototype.constructor = DataTexture;

DataTexture.prototype.isDataTexture = true;

/**
 * Uniforms library for shared webgl shaders
 */

var UniformsLib = {

	common: {

		diffuse: { value: new Color( 0xeeeeee ) },
		opacity: { value: 1.0 },

		map: { value: null },
		offsetRepeat: { value: new Vector4( 0, 0, 1, 1 ) },

		specularMap: { value: null },
		alphaMap: { value: null },

		envMap: { value: null },
		flipEnvMap: { value: - 1 },
		reflectivity: { value: 1.0 },
		refractionRatio: { value: 0.98 }

	},

	aomap: {

		aoMap: { value: null },
		aoMapIntensity: { value: 1 }

	},

	lightmap: {

		lightMap: { value: null },
		lightMapIntensity: { value: 1 }

	},

	emissivemap: {

		emissiveMap: { value: null }

	},

	bumpmap: {

		bumpMap: { value: null },
		bumpScale: { value: 1 }

	},

	normalmap: {

		normalMap: { value: null },
		normalScale: { value: new Vector2( 1, 1 ) }

	},

	displacementmap: {

		displacementMap: { value: null },
		displacementScale: { value: 1 },
		displacementBias: { value: 0 }

	},

	roughnessmap: {

		roughnessMap: { value: null }

	},

	metalnessmap: {

		metalnessMap: { value: null }

	},

	gradientmap: {

		gradientMap: { value: null }

	},

	fog: {

		fogDensity: { value: 0.00025 },
		fogNear: { value: 1 },
		fogFar: { value: 2000 },
		fogColor: { value: new Color( 0xffffff ) }

	},

	lights: {

		ambientLightColor: { value: [] },

		directionalLights: { value: [], properties: {
			direction: {},
			color: {},

			shadow: {},
			shadowBias: {},
			shadowRadius: {},
			shadowMapSize: {}
		} },

		directionalShadowMap: { value: [] },
		directionalShadowMatrix: { value: [] },

		spotLights: { value: [], properties: {
			color: {},
			position: {},
			direction: {},
			distance: {},
			coneCos: {},
			penumbraCos: {},
			decay: {},

			shadow: {},
			shadowBias: {},
			shadowRadius: {},
			shadowMapSize: {}
		} },

		spotShadowMap: { value: [] },
		spotShadowMatrix: { value: [] },

		pointLights: { value: [], properties: {
			color: {},
			position: {},
			decay: {},
			distance: {},

			shadow: {},
			shadowBias: {},
			shadowRadius: {},
			shadowMapSize: {}
		} },

		pointShadowMap: { value: [] },
		pointShadowMatrix: { value: [] },

		hemisphereLights: { value: [], properties: {
			direction: {},
			skyColor: {},
			groundColor: {}
		} },

        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: { value: [], properties: {
            color: {},
            position: {},
            width: {},
            height: {},
        } }

	},

	points: {

		diffuse: { value: new Color( 0xeeeeee ) },
		opacity: { value: 1.0 },
		size: { value: 1.0 },
		scale: { value: 1.0 },
		map: { value: null },
		offsetRepeat: { value: new Vector4( 0, 0, 1, 1 ) }

	}

};

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 * @author mikael emtinger / http://gomo.se/
 */

var ShaderLib = {

	basic: {

		uniforms: UniformsUtils.merge( [
			UniformsLib.common,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.fog
		] ),

		vertexShader: ShaderChunk.meshbasic_vert,
		fragmentShader: ShaderChunk.meshbasic_frag

	},

	lambert: {

		uniforms: UniformsUtils.merge( [
			UniformsLib.common,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.emissivemap,
			UniformsLib.fog,
			UniformsLib.lights,
			{
				emissive: { value: new Color( 0x000000 ) }
			}
		] ),

		vertexShader: ShaderChunk.meshlambert_vert,
		fragmentShader: ShaderChunk.meshlambert_frag

	},

	phong: {

		uniforms: UniformsUtils.merge( [
			UniformsLib.common,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.emissivemap,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			UniformsLib.gradientmap,
			UniformsLib.fog,
			UniformsLib.lights,
			{
				emissive: { value: new Color( 0x000000 ) },
				specular: { value: new Color( 0x111111 ) },
				shininess: { value: 30 }
			}
		] ),

		vertexShader: ShaderChunk.meshphong_vert,
		fragmentShader: ShaderChunk.meshphong_frag

	},

	standard: {

		uniforms: UniformsUtils.merge( [
			UniformsLib.common,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.emissivemap,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			UniformsLib.roughnessmap,
			UniformsLib.metalnessmap,
			UniformsLib.fog,
			UniformsLib.lights,
			{
				emissive: { value: new Color( 0x000000 ) },
				roughness: { value: 0.5 },
				metalness: { value: 0 },
				envMapIntensity: { value: 1 } // temporary
			}
		] ),

		vertexShader: ShaderChunk.meshphysical_vert,
		fragmentShader: ShaderChunk.meshphysical_frag

	},

	points: {

		uniforms: UniformsUtils.merge( [
			UniformsLib.points,
			UniformsLib.fog
		] ),

		vertexShader: ShaderChunk.points_vert,
		fragmentShader: ShaderChunk.points_frag

	},

	dashed: {

		uniforms: UniformsUtils.merge( [
			UniformsLib.common,
			UniformsLib.fog,
			{
				scale: { value: 1 },
				dashSize: { value: 1 },
				totalSize: { value: 2 }
			}
		] ),

		vertexShader: ShaderChunk.linedashed_vert,
		fragmentShader: ShaderChunk.linedashed_frag

	},

	depth: {

		uniforms: UniformsUtils.merge( [
			UniformsLib.common,
			UniformsLib.displacementmap
		] ),

		vertexShader: ShaderChunk.depth_vert,
		fragmentShader: ShaderChunk.depth_frag

	},

	normal: {

		uniforms: UniformsUtils.merge( [
			UniformsLib.common,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			{
				opacity: { value: 1.0 }
			}
		] ),

		vertexShader: ShaderChunk.normal_vert,
		fragmentShader: ShaderChunk.normal_frag

	},

	/* -------------------------------------------------------------------------
	//	Cube map shader
	 ------------------------------------------------------------------------- */

	cube: {

		uniforms: {
			tCube: { value: null },
			tFlip: { value: - 1 },
			opacity: { value: 1.0 }
		},

		vertexShader: ShaderChunk.cube_vert,
		fragmentShader: ShaderChunk.cube_frag

	},

	/* -------------------------------------------------------------------------
	//	Cube map shader
	 ------------------------------------------------------------------------- */

	equirect: {

		uniforms: {
			tEquirect: { value: null },
			tFlip: { value: - 1 }
		},

		vertexShader: ShaderChunk.equirect_vert,
		fragmentShader: ShaderChunk.equirect_frag

	},

	distanceRGBA: {

		uniforms: {
			lightPos: { value: new Vector3() }
		},

		vertexShader: ShaderChunk.distanceRGBA_vert,
		fragmentShader: ShaderChunk.distanceRGBA_frag

	}

};

ShaderLib.physical = {

	uniforms: UniformsUtils.merge( [
		ShaderLib.standard.uniforms,
		{
			clearCoat: { value: 0 },
			clearCoatRoughness: { value: 0 }
		}
	] ),

	vertexShader: ShaderChunk.meshphysical_vert,
	fragmentShader: ShaderChunk.meshphysical_frag

};

/**
 * @author bhouston / http://clara.io
 */

function Box2( min, max ) {

	this.min = ( min !== undefined ) ? min : new Vector2( + Infinity, + Infinity );
	this.max = ( max !== undefined ) ? max : new Vector2( - Infinity, - Infinity );

}

Box2.prototype = {

	constructor: Box2,

	set: function ( min, max ) {

		this.min.copy( min );
		this.max.copy( max );

		return this;

	},

	setFromPoints: function ( points ) {

		this.makeEmpty();

		for ( var i = 0, il = points.length; i < il; i ++ ) {

			this.expandByPoint( points[ i ] );

		}

		return this;

	},

	setFromCenterAndSize: function () {

		var v1 = new Vector2();

		return function setFromCenterAndSize( center, size ) {

			var halfSize = v1.copy( size ).multiplyScalar( 0.5 );
			this.min.copy( center ).sub( halfSize );
			this.max.copy( center ).add( halfSize );

			return this;

		};

	}(),

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( box ) {

		this.min.copy( box.min );
		this.max.copy( box.max );

		return this;

	},

	makeEmpty: function () {

		this.min.x = this.min.y = + Infinity;
		this.max.x = this.max.y = - Infinity;

		return this;

	},

	isEmpty: function () {

		// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes

		return ( this.max.x < this.min.x ) || ( this.max.y < this.min.y );

	},

	getCenter: function ( optionalTarget ) {

		var result = optionalTarget || new Vector2();
		return this.isEmpty() ? result.set( 0, 0 ) : result.addVectors( this.min, this.max ).multiplyScalar( 0.5 );

	},

	getSize: function ( optionalTarget ) {

		var result = optionalTarget || new Vector2();
		return this.isEmpty() ? result.set( 0, 0 ) : result.subVectors( this.max, this.min );

	},

	expandByPoint: function ( point ) {

		this.min.min( point );
		this.max.max( point );

		return this;

	},

	expandByVector: function ( vector ) {

		this.min.sub( vector );
		this.max.add( vector );

		return this;

	},

	expandByScalar: function ( scalar ) {

		this.min.addScalar( - scalar );
		this.max.addScalar( scalar );

		return this;

	},

	containsPoint: function ( point ) {

		return point.x < this.min.x || point.x > this.max.x ||
			point.y < this.min.y || point.y > this.max.y ? false : true;

	},

	containsBox: function ( box ) {

		return this.min.x <= box.min.x && box.max.x <= this.max.x &&
			this.min.y <= box.min.y && box.max.y <= this.max.y;

	},

	getParameter: function ( point, optionalTarget ) {

		// This can potentially have a divide by zero if the box
		// has a size dimension of 0.

		var result = optionalTarget || new Vector2();

		return result.set(
			( point.x - this.min.x ) / ( this.max.x - this.min.x ),
			( point.y - this.min.y ) / ( this.max.y - this.min.y )
		);

	},

	intersectsBox: function ( box ) {

		// using 6 splitting planes to rule out intersections.
		return box.max.x < this.min.x || box.min.x > this.max.x ||
			box.max.y < this.min.y || box.min.y > this.max.y ? false : true;

	},

	clampPoint: function ( point, optionalTarget ) {

		var result = optionalTarget || new Vector2();
		return result.copy( point ).clamp( this.min, this.max );

	},

	distanceToPoint: function () {

		var v1 = new Vector2();

		return function distanceToPoint( point ) {

			var clampedPoint = v1.copy( point ).clamp( this.min, this.max );
			return clampedPoint.sub( point ).length();

		};

	}(),

	intersect: function ( box ) {

		this.min.max( box.min );
		this.max.min( box.max );

		return this;

	},

	union: function ( box ) {

		this.min.min( box.min );
		this.max.max( box.max );

		return this;

	},

	translate: function ( offset ) {

		this.min.add( offset );
		this.max.add( offset );

		return this;

	},

	equals: function ( box ) {

		return box.min.equals( this.min ) && box.max.equals( this.max );

	}

};

/**
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 */

function LensFlarePlugin( renderer, flares ) {

	var gl = renderer.context;
	var state = renderer.state;

	var vertexBuffer, elementBuffer;
	var shader, program, attributes, uniforms;

	var tempTexture, occlusionTexture;

	function init() {

		var vertices = new Float32Array( [
			- 1, - 1,  0, 0,
			 1, - 1,  1, 0,
			 1,  1,  1, 1,
			- 1,  1,  0, 1
		] );

		var faces = new Uint16Array( [
			0, 1, 2,
			0, 2, 3
		] );

		// buffers

		vertexBuffer     = gl.createBuffer();
		elementBuffer    = gl.createBuffer();

		gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
		gl.bufferData( gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW );

		gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );
		gl.bufferData( gl.ELEMENT_ARRAY_BUFFER, faces, gl.STATIC_DRAW );

		// textures

		tempTexture      = gl.createTexture();
		occlusionTexture = gl.createTexture();

		state.bindTexture( gl.TEXTURE_2D, tempTexture );
		gl.texImage2D( gl.TEXTURE_2D, 0, gl.RGB, 16, 16, 0, gl.RGB, gl.UNSIGNED_BYTE, null );
		gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE );
		gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE );
		gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST );
		gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST );

		state.bindTexture( gl.TEXTURE_2D, occlusionTexture );
		gl.texImage2D( gl.TEXTURE_2D, 0, gl.RGBA, 16, 16, 0, gl.RGBA, gl.UNSIGNED_BYTE, null );
		gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE );
		gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE );
		gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST );
		gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST );

		shader = {

			vertexShader: [

				"uniform lowp int renderType;",

				"uniform vec3 screenPosition;",
				"uniform vec2 scale;",
				"uniform float rotation;",

				"uniform sampler2D occlusionMap;",

				"attribute vec2 position;",
				"attribute vec2 uv;",

				"varying vec2 vUV;",
				"varying float vVisibility;",

				"void main() {",

					"vUV = uv;",

					"vec2 pos = position;",

					"if ( renderType == 2 ) {",

						"vec4 visibility = texture2D( occlusionMap, vec2( 0.1, 0.1 ) );",
						"visibility += texture2D( occlusionMap, vec2( 0.5, 0.1 ) );",
						"visibility += texture2D( occlusionMap, vec2( 0.9, 0.1 ) );",
						"visibility += texture2D( occlusionMap, vec2( 0.9, 0.5 ) );",
						"visibility += texture2D( occlusionMap, vec2( 0.9, 0.9 ) );",
						"visibility += texture2D( occlusionMap, vec2( 0.5, 0.9 ) );",
						"visibility += texture2D( occlusionMap, vec2( 0.1, 0.9 ) );",
						"visibility += texture2D( occlusionMap, vec2( 0.1, 0.5 ) );",
						"visibility += texture2D( occlusionMap, vec2( 0.5, 0.5 ) );",

						"vVisibility =        visibility.r / 9.0;",
						"vVisibility *= 1.0 - visibility.g / 9.0;",
						"vVisibility *=       visibility.b / 9.0;",
						"vVisibility *= 1.0 - visibility.a / 9.0;",

						"pos.x = cos( rotation ) * position.x - sin( rotation ) * position.y;",
						"pos.y = sin( rotation ) * position.x + cos( rotation ) * position.y;",

					"}",

					"gl_Position = vec4( ( pos * scale + screenPosition.xy ).xy, screenPosition.z, 1.0 );",

				"}"

			].join( "\n" ),

			fragmentShader: [

				"uniform lowp int renderType;",

				"uniform sampler2D map;",
				"uniform float opacity;",
				"uniform vec3 color;",

				"varying vec2 vUV;",
				"varying float vVisibility;",

				"void main() {",

					// pink square

					"if ( renderType == 0 ) {",

						"gl_FragColor = vec4( 1.0, 0.0, 1.0, 0.0 );",

					// restore

					"} else if ( renderType == 1 ) {",

						"gl_FragColor = texture2D( map, vUV );",

					// flare

					"} else {",

						"vec4 texture = texture2D( map, vUV );",
						"texture.a *= opacity * vVisibility;",
						"gl_FragColor = texture;",
						"gl_FragColor.rgb *= color;",

					"}",

				"}"

			].join( "\n" )

		};

		program = createProgram( shader );

		attributes = {
			vertex: gl.getAttribLocation ( program, "position" ),
			uv:     gl.getAttribLocation ( program, "uv" )
		};

		uniforms = {
			renderType:     gl.getUniformLocation( program, "renderType" ),
			map:            gl.getUniformLocation( program, "map" ),
			occlusionMap:   gl.getUniformLocation( program, "occlusionMap" ),
			opacity:        gl.getUniformLocation( program, "opacity" ),
			color:          gl.getUniformLocation( program, "color" ),
			scale:          gl.getUniformLocation( program, "scale" ),
			rotation:       gl.getUniformLocation( program, "rotation" ),
			screenPosition: gl.getUniformLocation( program, "screenPosition" )
		};

	}

	/*
	 * Render lens flares
	 * Method: renders 16x16 0xff00ff-colored points scattered over the light source area,
	 *         reads these back and calculates occlusion.
	 */

	this.render = function ( scene, camera, viewport ) {

		if ( flares.length === 0 ) return;

		var tempPosition = new Vector3();

		var invAspect = viewport.w / viewport.z,
			halfViewportWidth = viewport.z * 0.5,
			halfViewportHeight = viewport.w * 0.5;

		var size = 16 / viewport.w,
			scale = new Vector2( size * invAspect, size );

		var screenPosition = new Vector3( 1, 1, 0 ),
			screenPositionPixels = new Vector2( 1, 1 );

		var validArea = new Box2();

		validArea.min.set( viewport.x, viewport.y );
		validArea.max.set( viewport.x + ( viewport.z - 16 ), viewport.y + ( viewport.w - 16 ) );

		if ( program === undefined ) {

			init();

		}

		gl.useProgram( program );

		state.initAttributes();
		state.enableAttribute( attributes.vertex );
		state.enableAttribute( attributes.uv );
		state.disableUnusedAttributes();

		// loop through all lens flares to update their occlusion and positions
		// setup gl and common used attribs/uniforms

		gl.uniform1i( uniforms.occlusionMap, 0 );
		gl.uniform1i( uniforms.map, 1 );

		gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
		gl.vertexAttribPointer( attributes.vertex, 2, gl.FLOAT, false, 2 * 8, 0 );
		gl.vertexAttribPointer( attributes.uv, 2, gl.FLOAT, false, 2 * 8, 8 );

		gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );

		state.disable( gl.CULL_FACE );
		state.setDepthWrite( false );

		for ( var i = 0, l = flares.length; i < l; i ++ ) {

			size = 16 / viewport.w;
			scale.set( size * invAspect, size );

			// calc object screen position

			var flare = flares[ i ];

			tempPosition.set( flare.matrixWorld.elements[ 12 ], flare.matrixWorld.elements[ 13 ], flare.matrixWorld.elements[ 14 ] );

			tempPosition.applyMatrix4( camera.matrixWorldInverse );
			tempPosition.applyProjection( camera.projectionMatrix );

			// setup arrays for gl programs

			screenPosition.copy( tempPosition );

			// horizontal and vertical coordinate of the lower left corner of the pixels to copy

			screenPositionPixels.x = viewport.x + ( screenPosition.x * halfViewportWidth ) + halfViewportWidth - 8;
			screenPositionPixels.y = viewport.y + ( screenPosition.y * halfViewportHeight ) + halfViewportHeight - 8;

			// screen cull

			if ( validArea.containsPoint( screenPositionPixels ) === true ) {

				// save current RGB to temp texture

				state.activeTexture( gl.TEXTURE0 );
				state.bindTexture( gl.TEXTURE_2D, null );
				state.activeTexture( gl.TEXTURE1 );
				state.bindTexture( gl.TEXTURE_2D, tempTexture );
				gl.copyTexImage2D( gl.TEXTURE_2D, 0, gl.RGB, screenPositionPixels.x, screenPositionPixels.y, 16, 16, 0 );


				// render pink quad

				gl.uniform1i( uniforms.renderType, 0 );
				gl.uniform2f( uniforms.scale, scale.x, scale.y );
				gl.uniform3f( uniforms.screenPosition, screenPosition.x, screenPosition.y, screenPosition.z );

				state.disable( gl.BLEND );
				state.enable( gl.DEPTH_TEST );

				gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );


				// copy result to occlusionMap

				state.activeTexture( gl.TEXTURE0 );
				state.bindTexture( gl.TEXTURE_2D, occlusionTexture );
				gl.copyTexImage2D( gl.TEXTURE_2D, 0, gl.RGBA, screenPositionPixels.x, screenPositionPixels.y, 16, 16, 0 );


				// restore graphics

				gl.uniform1i( uniforms.renderType, 1 );
				state.disable( gl.DEPTH_TEST );

				state.activeTexture( gl.TEXTURE1 );
				state.bindTexture( gl.TEXTURE_2D, tempTexture );
				gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );


				// update object positions

				flare.positionScreen.copy( screenPosition );

				if ( flare.customUpdateCallback ) {

					flare.customUpdateCallback( flare );

				} else {

					flare.updateLensFlares();

				}

				// render flares

				gl.uniform1i( uniforms.renderType, 2 );
				state.enable( gl.BLEND );

				for ( var j = 0, jl = flare.lensFlares.length; j < jl; j ++ ) {

					var sprite = flare.lensFlares[ j ];

					if ( sprite.opacity > 0.001 && sprite.scale > 0.001 ) {

						screenPosition.x = sprite.x;
						screenPosition.y = sprite.y;
						screenPosition.z = sprite.z;

						size = sprite.size * sprite.scale / viewport.w;

						scale.x = size * invAspect;
						scale.y = size;

						gl.uniform3f( uniforms.screenPosition, screenPosition.x, screenPosition.y, screenPosition.z );
						gl.uniform2f( uniforms.scale, scale.x, scale.y );
						gl.uniform1f( uniforms.rotation, sprite.rotation );

						gl.uniform1f( uniforms.opacity, sprite.opacity );
						gl.uniform3f( uniforms.color, sprite.color.r, sprite.color.g, sprite.color.b );

						state.setBlending( sprite.blending, sprite.blendEquation, sprite.blendSrc, sprite.blendDst );
						renderer.setTexture2D( sprite.texture, 1 );

						gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );

					}

				}

			}

		}

		// restore gl

		state.enable( gl.CULL_FACE );
		state.enable( gl.DEPTH_TEST );
		state.setDepthWrite( true );

		renderer.resetGLState();

	};

	function createProgram( shader ) {

		var program = gl.createProgram();

		var fragmentShader = gl.createShader( gl.FRAGMENT_SHADER );
		var vertexShader = gl.createShader( gl.VERTEX_SHADER );

		var prefix = "precision " + renderer.getPrecision() + " float;\n";

		gl.shaderSource( fragmentShader, prefix + shader.fragmentShader );
		gl.shaderSource( vertexShader, prefix + shader.vertexShader );

		gl.compileShader( fragmentShader );
		gl.compileShader( vertexShader );

		gl.attachShader( program, fragmentShader );
		gl.attachShader( program, vertexShader );

		gl.linkProgram( program );

		return program;

	}

}

/**
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 */

function SpritePlugin( renderer, sprites ) {

	var gl = renderer.context;
	var state = renderer.state;

	var vertexBuffer, elementBuffer;
	var program, attributes, uniforms;

	var texture;

	// decompose matrixWorld

	var spritePosition = new Vector3();
	var spriteRotation = new Quaternion();
	var spriteScale = new Vector3();

	function init() {

		var vertices = new Float32Array( [
			- 0.5, - 0.5,  0, 0,
			  0.5, - 0.5,  1, 0,
			  0.5,   0.5,  1, 1,
			- 0.5,   0.5,  0, 1
		] );

		var faces = new Uint16Array( [
			0, 1, 2,
			0, 2, 3
		] );

		vertexBuffer  = gl.createBuffer();
		elementBuffer = gl.createBuffer();

		gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
		gl.bufferData( gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW );

		gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );
		gl.bufferData( gl.ELEMENT_ARRAY_BUFFER, faces, gl.STATIC_DRAW );

		program = createProgram();

		attributes = {
			position:			gl.getAttribLocation ( program, 'position' ),
			uv:					gl.getAttribLocation ( program, 'uv' )
		};

		uniforms = {
			uvOffset:			gl.getUniformLocation( program, 'uvOffset' ),
			uvScale:			gl.getUniformLocation( program, 'uvScale' ),

			rotation:			gl.getUniformLocation( program, 'rotation' ),
			scale:				gl.getUniformLocation( program, 'scale' ),

			color:				gl.getUniformLocation( program, 'color' ),
			map:				gl.getUniformLocation( program, 'map' ),
			opacity:			gl.getUniformLocation( program, 'opacity' ),

			modelViewMatrix: 	gl.getUniformLocation( program, 'modelViewMatrix' ),
			projectionMatrix:	gl.getUniformLocation( program, 'projectionMatrix' ),

			fogType:			gl.getUniformLocation( program, 'fogType' ),
			fogDensity:			gl.getUniformLocation( program, 'fogDensity' ),
			fogNear:			gl.getUniformLocation( program, 'fogNear' ),
			fogFar:				gl.getUniformLocation( program, 'fogFar' ),
			fogColor:			gl.getUniformLocation( program, 'fogColor' ),

			alphaTest:			gl.getUniformLocation( program, 'alphaTest' )
		};

		var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
		canvas.width = 8;
		canvas.height = 8;

		var context = canvas.getContext( '2d' );
		context.fillStyle = 'white';
		context.fillRect( 0, 0, 8, 8 );

		texture = new Texture( canvas );
		texture.needsUpdate = true;

	}

	this.render = function ( scene, camera ) {

		if ( sprites.length === 0 ) return;

		// setup gl

		if ( program === undefined ) {

			init();

		}

		gl.useProgram( program );

		state.initAttributes();
		state.enableAttribute( attributes.position );
		state.enableAttribute( attributes.uv );
		state.disableUnusedAttributes();

		state.disable( gl.CULL_FACE );
		state.enable( gl.BLEND );

		gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
		gl.vertexAttribPointer( attributes.position, 2, gl.FLOAT, false, 2 * 8, 0 );
		gl.vertexAttribPointer( attributes.uv, 2, gl.FLOAT, false, 2 * 8, 8 );

		gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );

		gl.uniformMatrix4fv( uniforms.projectionMatrix, false, camera.projectionMatrix.elements );

		state.activeTexture( gl.TEXTURE0 );
		gl.uniform1i( uniforms.map, 0 );

		var oldFogType = 0;
		var sceneFogType = 0;
		var fog = scene.fog;

		if ( fog ) {

			gl.uniform3f( uniforms.fogColor, fog.color.r, fog.color.g, fog.color.b );

			if ( fog.isFog ) {

				gl.uniform1f( uniforms.fogNear, fog.near );
				gl.uniform1f( uniforms.fogFar, fog.far );

				gl.uniform1i( uniforms.fogType, 1 );
				oldFogType = 1;
				sceneFogType = 1;

			} else if ( fog.isFogExp2 ) {

				gl.uniform1f( uniforms.fogDensity, fog.density );

				gl.uniform1i( uniforms.fogType, 2 );
				oldFogType = 2;
				sceneFogType = 2;

			}

		} else {

			gl.uniform1i( uniforms.fogType, 0 );
			oldFogType = 0;
			sceneFogType = 0;

		}


		// update positions and sort

		for ( var i = 0, l = sprites.length; i < l; i ++ ) {

			var sprite = sprites[ i ];

			sprite.modelViewMatrix.multiplyMatrices( camera.matrixWorldInverse, sprite.matrixWorld );
			sprite.z = - sprite.modelViewMatrix.elements[ 14 ];

		}

		sprites.sort( painterSortStable );

		// render all sprites

		var scale = [];

		for ( var i = 0, l = sprites.length; i < l; i ++ ) {

			var sprite = sprites[ i ];
			var material = sprite.material;

			if ( material.visible === false ) continue;

			gl.uniform1f( uniforms.alphaTest, material.alphaTest );
			gl.uniformMatrix4fv( uniforms.modelViewMatrix, false, sprite.modelViewMatrix.elements );

			sprite.matrixWorld.decompose( spritePosition, spriteRotation, spriteScale );

			scale[ 0 ] = spriteScale.x;
			scale[ 1 ] = spriteScale.y;

			var fogType = 0;

			if ( scene.fog && material.fog ) {

				fogType = sceneFogType;

			}

			if ( oldFogType !== fogType ) {

				gl.uniform1i( uniforms.fogType, fogType );
				oldFogType = fogType;

			}

			if ( material.map !== null ) {

				gl.uniform2f( uniforms.uvOffset, material.map.offset.x, material.map.offset.y );
				gl.uniform2f( uniforms.uvScale, material.map.repeat.x, material.map.repeat.y );

			} else {

				gl.uniform2f( uniforms.uvOffset, 0, 0 );
				gl.uniform2f( uniforms.uvScale, 1, 1 );

			}

			gl.uniform1f( uniforms.opacity, material.opacity );
			gl.uniform3f( uniforms.color, material.color.r, material.color.g, material.color.b );

			gl.uniform1f( uniforms.rotation, material.rotation );
			gl.uniform2fv( uniforms.scale, scale );

			state.setBlending( material.blending, material.blendEquation, material.blendSrc, material.blendDst );
			state.setDepthTest( material.depthTest );
			state.setDepthWrite( material.depthWrite );

			if ( material.map ) {

				renderer.setTexture2D( material.map, 0 );

			} else {

				renderer.setTexture2D( texture, 0 );

			}

			gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );

		}

		// restore gl

		state.enable( gl.CULL_FACE );

		renderer.resetGLState();

	};

	function createProgram() {

		var program = gl.createProgram();

		var vertexShader = gl.createShader( gl.VERTEX_SHADER );
		var fragmentShader = gl.createShader( gl.FRAGMENT_SHADER );

		gl.shaderSource( vertexShader, [

			'precision ' + renderer.getPrecision() + ' float;',

			'uniform mat4 modelViewMatrix;',
			'uniform mat4 projectionMatrix;',
			'uniform float rotation;',
			'uniform vec2 scale;',
			'uniform vec2 uvOffset;',
			'uniform vec2 uvScale;',

			'attribute vec2 position;',
			'attribute vec2 uv;',

			'varying vec2 vUV;',

			'void main() {',

				'vUV = uvOffset + uv * uvScale;',

				'vec2 alignedPosition = position * scale;',

				'vec2 rotatedPosition;',
				'rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;',
				'rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;',

				'vec4 finalPosition;',

				'finalPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );',
				'finalPosition.xy += rotatedPosition;',
				'finalPosition = projectionMatrix * finalPosition;',

				'gl_Position = finalPosition;',

			'}'

		].join( '\n' ) );

		gl.shaderSource( fragmentShader, [

			'precision ' + renderer.getPrecision() + ' float;',

			'uniform vec3 color;',
			'uniform sampler2D map;',
			'uniform float opacity;',

			'uniform int fogType;',
			'uniform vec3 fogColor;',
			'uniform float fogDensity;',
			'uniform float fogNear;',
			'uniform float fogFar;',
			'uniform float alphaTest;',

			'varying vec2 vUV;',

			'void main() {',

				'vec4 texture = texture2D( map, vUV );',

				'if ( texture.a < alphaTest ) discard;',

				'gl_FragColor = vec4( color * texture.xyz, texture.a * opacity );',

				'if ( fogType > 0 ) {',

					'float depth = gl_FragCoord.z / gl_FragCoord.w;',
					'float fogFactor = 0.0;',

					'if ( fogType == 1 ) {',

						'fogFactor = smoothstep( fogNear, fogFar, depth );',

					'} else {',

						'const float LOG2 = 1.442695;',
						'fogFactor = exp2( - fogDensity * fogDensity * depth * depth * LOG2 );',
						'fogFactor = 1.0 - clamp( fogFactor, 0.0, 1.0 );',

					'}',

					'gl_FragColor = mix( gl_FragColor, vec4( fogColor, gl_FragColor.w ), fogFactor );',

				'}',

			'}'

		].join( '\n' ) );

		gl.compileShader( vertexShader );
		gl.compileShader( fragmentShader );

		gl.attachShader( program, vertexShader );
		gl.attachShader( program, fragmentShader );

		gl.linkProgram( program );

		return program;

	}

	function painterSortStable( a, b ) {

		if ( a.renderOrder !== b.renderOrder ) {

			return a.renderOrder - b.renderOrder;

		} else if ( a.z !== b.z ) {

			return b.z - a.z;

		} else {

			return b.id - a.id;

		}

	}

}

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 */

var materialId = 0;

function Material() {

	Object.defineProperty( this, 'id', { value: materialId ++ } );

	this.uuid = _Math.generateUUID();

	this.name = '';
	this.type = 'Material';

	this.fog = true;
	this.lights = true;

	this.blending = NormalBlending;
	this.side = FrontSide;
	this.shading = SmoothShading; // THREE.FlatShading, THREE.SmoothShading
	this.vertexColors = NoColors; // THREE.NoColors, THREE.VertexColors, THREE.FaceColors

	this.opacity = 1;
	this.transparent = false;

	this.blendSrc = SrcAlphaFactor;
	this.blendDst = OneMinusSrcAlphaFactor;
	this.blendEquation = AddEquation;
	this.blendSrcAlpha = null;
	this.blendDstAlpha = null;
	this.blendEquationAlpha = null;

	this.depthFunc = LessEqualDepth;
	this.depthTest = true;
	this.depthWrite = true;

	this.clippingPlanes = null;
	this.clipIntersection = false;
	this.clipShadows = false;

	this.colorWrite = true;

	this.precision = null; // override the renderer's default precision for this material

	this.polygonOffset = false;
	this.polygonOffsetFactor = 0;
	this.polygonOffsetUnits = 0;

	this.alphaTest = 0;
	this.premultipliedAlpha = false;

	this.overdraw = 0; // Overdrawn pixels (typically between 0 and 1) for fixing antialiasing gaps in CanvasRenderer

	this.visible = true;

	this._needsUpdate = true;

}

Material.prototype = {

	constructor: Material,

	isMaterial: true,

	get needsUpdate() {

		return this._needsUpdate;

	},

	set needsUpdate( value ) {

		if ( value === true ) this.update();
		this._needsUpdate = value;

	},

	setValues: function ( values ) {

		if ( values === undefined ) return;

		for ( var key in values ) {

			var newValue = values[ key ];

			if ( newValue === undefined ) {

				console.warn( "THREE.Material: '" + key + "' parameter is undefined." );
				continue;

			}

			var currentValue = this[ key ];

			if ( currentValue === undefined ) {

				console.warn( "THREE." + this.type + ": '" + key + "' is not a property of this material." );
				continue;

			}

			if ( currentValue && currentValue.isColor ) {

				currentValue.set( newValue );

			} else if ( (currentValue && currentValue.isVector3) && (newValue && newValue.isVector3) ) {

				currentValue.copy( newValue );

			} else if ( key === 'overdraw' ) {

				// ensure overdraw is backwards-compatible with legacy boolean type
				this[ key ] = Number( newValue );

			} else {

				this[ key ] = newValue;

			}

		}

	},

	toJSON: function ( meta ) {

		var isRoot = meta === undefined;

		if ( isRoot ) {

			meta = {
				textures: {},
				images: {}
			};

		}

		var data = {
			metadata: {
				version: 4.4,
				type: 'Material',
				generator: 'Material.toJSON'
			}
		};

		// standard Material serialization
		data.uuid = this.uuid;
		data.type = this.type;

		if ( this.name !== '' ) data.name = this.name;

		if ( this.color && this.color.isColor ) data.color = this.color.getHex();

		if ( this.roughness !== undefined ) data.roughness = this.roughness;
		if ( this.metalness !== undefined ) data.metalness = this.metalness;

		if ( this.emissive && this.emissive.isColor ) data.emissive = this.emissive.getHex();
		if ( this.specular && this.specular.isColor ) data.specular = this.specular.getHex();
		if ( this.shininess !== undefined ) data.shininess = this.shininess;
		if ( this.clearCoat !== undefined ) data.clearCoat = this.clearCoat;
		if ( this.clearCoatRoughness !== undefined ) data.clearCoatRoughness = this.clearCoatRoughness;

		if ( this.map && this.map.isTexture ) data.map = this.map.toJSON( meta ).uuid;
		if ( this.alphaMap && this.alphaMap.isTexture ) data.alphaMap = this.alphaMap.toJSON( meta ).uuid;
		if ( this.lightMap && this.lightMap.isTexture ) data.lightMap = this.lightMap.toJSON( meta ).uuid;
		if ( this.bumpMap && this.bumpMap.isTexture ) {

			data.bumpMap = this.bumpMap.toJSON( meta ).uuid;
			data.bumpScale = this.bumpScale;

		}
		if ( this.normalMap && this.normalMap.isTexture ) {

			data.normalMap = this.normalMap.toJSON( meta ).uuid;
			data.normalScale = this.normalScale.toArray();

		}
		if ( this.displacementMap && this.displacementMap.isTexture ) {

			data.displacementMap = this.displacementMap.toJSON( meta ).uuid;
			data.displacementScale = this.displacementScale;
			data.displacementBias = this.displacementBias;

		}
		if ( this.roughnessMap && this.roughnessMap.isTexture ) data.roughnessMap = this.roughnessMap.toJSON( meta ).uuid;
		if ( this.metalnessMap && this.metalnessMap.isTexture ) data.metalnessMap = this.metalnessMap.toJSON( meta ).uuid;

		if ( this.emissiveMap && this.emissiveMap.isTexture ) data.emissiveMap = this.emissiveMap.toJSON( meta ).uuid;
		if ( this.specularMap && this.specularMap.isTexture ) data.specularMap = this.specularMap.toJSON( meta ).uuid;

		if ( this.envMap && this.envMap.isTexture ) {

			data.envMap = this.envMap.toJSON( meta ).uuid;
			data.reflectivity = this.reflectivity; // Scale behind envMap

		}

		if ( this.gradientMap && this.gradientMap.isTexture ) {

			data.gradientMap = this.gradientMap.toJSON( meta ).uuid;

		}

		if ( this.size !== undefined ) data.size = this.size;
		if ( this.sizeAttenuation !== undefined ) data.sizeAttenuation = this.sizeAttenuation;

		if ( this.blending !== NormalBlending ) data.blending = this.blending;
		if ( this.shading !== SmoothShading ) data.shading = this.shading;
		if ( this.side !== FrontSide ) data.side = this.side;
		if ( this.vertexColors !== NoColors ) data.vertexColors = this.vertexColors;

		if ( this.opacity < 1 ) data.opacity = this.opacity;
		if ( this.transparent === true ) data.transparent = this.transparent;

		data.depthFunc = this.depthFunc;
		data.depthTest = this.depthTest;
		data.depthWrite = this.depthWrite;

		if ( this.alphaTest > 0 ) data.alphaTest = this.alphaTest;
		if ( this.premultipliedAlpha === true ) data.premultipliedAlpha = this.premultipliedAlpha;
		if ( this.wireframe === true ) data.wireframe = this.wireframe;
		if ( this.wireframeLinewidth > 1 ) data.wireframeLinewidth = this.wireframeLinewidth;
		if ( this.wireframeLinecap !== 'round' ) data.wireframeLinecap = this.wireframeLinecap;
		if ( this.wireframeLinejoin !== 'round' ) data.wireframeLinejoin = this.wireframeLinejoin;

		data.skinning = this.skinning;
		data.morphTargets = this.morphTargets;

		// TODO: Copied from Object3D.toJSON

		function extractFromCache( cache ) {

			var values = [];

			for ( var key in cache ) {

				var data = cache[ key ];
				delete data.metadata;
				values.push( data );

			}

			return values;

		}

		if ( isRoot ) {

			var textures = extractFromCache( meta.textures );
			var images = extractFromCache( meta.images );

			if ( textures.length > 0 ) data.textures = textures;
			if ( images.length > 0 ) data.images = images;

		}

		return data;

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( source ) {

		this.name = source.name;

		this.fog = source.fog;
		this.lights = source.lights;

		this.blending = source.blending;
		this.side = source.side;
		this.shading = source.shading;
		this.vertexColors = source.vertexColors;

		this.opacity = source.opacity;
		this.transparent = source.transparent;

		this.blendSrc = source.blendSrc;
		this.blendDst = source.blendDst;
		this.blendEquation = source.blendEquation;
		this.blendSrcAlpha = source.blendSrcAlpha;
		this.blendDstAlpha = source.blendDstAlpha;
		this.blendEquationAlpha = source.blendEquationAlpha;

		this.depthFunc = source.depthFunc;
		this.depthTest = source.depthTest;
		this.depthWrite = source.depthWrite;

		this.colorWrite = source.colorWrite;

		this.precision = source.precision;

		this.polygonOffset = source.polygonOffset;
		this.polygonOffsetFactor = source.polygonOffsetFactor;
		this.polygonOffsetUnits = source.polygonOffsetUnits;

		this.alphaTest = source.alphaTest;

		this.premultipliedAlpha = source.premultipliedAlpha;

		this.overdraw = source.overdraw;

		this.visible = source.visible;
		this.clipShadows = source.clipShadows;
		this.clipIntersection = source.clipIntersection;

		var srcPlanes = source.clippingPlanes,
			dstPlanes = null;

		if ( srcPlanes !== null ) {

			var n = srcPlanes.length;
			dstPlanes = new Array( n );

			for ( var i = 0; i !== n; ++ i )
				dstPlanes[ i ] = srcPlanes[ i ].clone();

		}

		this.clippingPlanes = dstPlanes;

		return this;

	},

	update: function () {

		this.dispatchEvent( { type: 'update' } );

	},

	dispose: function () {

		this.dispatchEvent( { type: 'dispose' } );

	}

};

Object.assign( Material.prototype, EventDispatcher.prototype );

/**
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  defines: { "label" : "value" },
 *  uniforms: { "parameter1": { value: 1.0 }, "parameter2": { value2: 2 } },
 *
 *  fragmentShader: <string>,
 *  vertexShader: <string>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  lights: <bool>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */

function ShaderMaterial( parameters ) {

	Material.call( this );

	this.type = 'ShaderMaterial';

	this.defines = {};
	this.uniforms = {};

	this.vertexShader = 'void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}';
	this.fragmentShader = 'void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}';

	this.linewidth = 1;

	this.wireframe = false;
	this.wireframeLinewidth = 1;

	this.fog = false; // set to use scene fog
	this.lights = false; // set to use scene lights
	this.clipping = false; // set to use user-defined clipping planes

	this.skinning = false; // set to use skinning attribute streams
	this.morphTargets = false; // set to use morph targets
	this.morphNormals = false; // set to use morph normals

	this.extensions = {
		derivatives: false, // set to use derivatives
		fragDepth: false, // set to use fragment depth values
		drawBuffers: false, // set to use draw buffers
		shaderTextureLOD: false // set to use shader texture LOD
	};

	// When rendered geometry doesn't include these attributes but the material does,
	// use these default values in WebGL. This avoids errors when buffer data is missing.
	this.defaultAttributeValues = {
		'color': [ 1, 1, 1 ],
		'uv': [ 0, 0 ],
		'uv2': [ 0, 0 ]
	};

	this.index0AttributeName = undefined;

	if ( parameters !== undefined ) {

		if ( parameters.attributes !== undefined ) {

			console.error( 'THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.' );

		}

		this.setValues( parameters );

	}

}

ShaderMaterial.prototype = Object.create( Material.prototype );
ShaderMaterial.prototype.constructor = ShaderMaterial;

ShaderMaterial.prototype.isShaderMaterial = true;

ShaderMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.fragmentShader = source.fragmentShader;
	this.vertexShader = source.vertexShader;

	this.uniforms = UniformsUtils.clone( source.uniforms );

	this.defines = source.defines;

	this.wireframe = source.wireframe;
	this.wireframeLinewidth = source.wireframeLinewidth;

	this.lights = source.lights;
	this.clipping = source.clipping;

	this.skinning = source.skinning;

	this.morphTargets = source.morphTargets;
	this.morphNormals = source.morphNormals;

	this.extensions = source.extensions;

	return this;

};

ShaderMaterial.prototype.toJSON = function ( meta ) {

	var data = Material.prototype.toJSON.call( this, meta );

	data.uniforms = this.uniforms;
	data.vertexShader = this.vertexShader;
	data.fragmentShader = this.fragmentShader;

	return data;

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 * @author bhouston / https://clara.io
 * @author WestLangley / http://github.com/WestLangley
 *
 * parameters = {
 *
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>
 * }
 */

function MeshDepthMaterial( parameters ) {

	Material.call( this );

	this.type = 'MeshDepthMaterial';

	this.depthPacking = BasicDepthPacking;

	this.skinning = false;
	this.morphTargets = false;

	this.map = null;

	this.alphaMap = null;

	this.displacementMap = null;
	this.displacementScale = 1;
	this.displacementBias = 0;

	this.wireframe = false;
	this.wireframeLinewidth = 1;

	this.fog = false;
	this.lights = false;

	this.setValues( parameters );

}

MeshDepthMaterial.prototype = Object.create( Material.prototype );
MeshDepthMaterial.prototype.constructor = MeshDepthMaterial;

MeshDepthMaterial.prototype.isMeshDepthMaterial = true;

MeshDepthMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.depthPacking = source.depthPacking;

	this.skinning = source.skinning;
	this.morphTargets = source.morphTargets;

	this.map = source.map;

	this.alphaMap = source.alphaMap;

	this.displacementMap = source.displacementMap;
	this.displacementScale = source.displacementScale;
	this.displacementBias = source.displacementBias;

	this.wireframe = source.wireframe;
	this.wireframeLinewidth = source.wireframeLinewidth;

	return this;

};

/**
 * @author bhouston / http://clara.io
 * @author WestLangley / http://github.com/WestLangley
 */

function Box3( min, max ) {

	this.min = ( min !== undefined ) ? min : new Vector3( + Infinity, + Infinity, + Infinity );
	this.max = ( max !== undefined ) ? max : new Vector3( - Infinity, - Infinity, - Infinity );

}

Box3.prototype = {

	constructor: Box3,

	isBox3: true,

	set: function ( min, max ) {

		this.min.copy( min );
		this.max.copy( max );

		return this;

	},

	setFromArray: function ( array ) {

		var minX = + Infinity;
		var minY = + Infinity;
		var minZ = + Infinity;

		var maxX = - Infinity;
		var maxY = - Infinity;
		var maxZ = - Infinity;

		for ( var i = 0, l = array.length; i < l; i += 3 ) {

			var x = array[ i ];
			var y = array[ i + 1 ];
			var z = array[ i + 2 ];

			if ( x < minX ) minX = x;
			if ( y < minY ) minY = y;
			if ( z < minZ ) minZ = z;

			if ( x > maxX ) maxX = x;
			if ( y > maxY ) maxY = y;
			if ( z > maxZ ) maxZ = z;

		}

		this.min.set( minX, minY, minZ );
		this.max.set( maxX, maxY, maxZ );

	},

	setFromBufferAttribute: function ( attribute ) {

		var minX = + Infinity;
		var minY = + Infinity;
		var minZ = + Infinity;

		var maxX = - Infinity;
		var maxY = - Infinity;
		var maxZ = - Infinity;

		for ( var i = 0, l = attribute.count; i < l; i ++ ) {

			var x = attribute.getX( i );
			var y = attribute.getY( i );
			var z = attribute.getZ( i );

			if ( x < minX ) minX = x;
			if ( y < minY ) minY = y;
			if ( z < minZ ) minZ = z;

			if ( x > maxX ) maxX = x;
			if ( y > maxY ) maxY = y;
			if ( z > maxZ ) maxZ = z;

		}

		this.min.set( minX, minY, minZ );
		this.max.set( maxX, maxY, maxZ );

	},

	setFromPoints: function ( points ) {

		this.makeEmpty();

		for ( var i = 0, il = points.length; i < il; i ++ ) {

			this.expandByPoint( points[ i ] );

		}

		return this;

	},

	setFromCenterAndSize: function () {

		var v1 = new Vector3();

		return function setFromCenterAndSize( center, size ) {

			var halfSize = v1.copy( size ).multiplyScalar( 0.5 );

			this.min.copy( center ).sub( halfSize );
			this.max.copy( center ).add( halfSize );

			return this;

		};

	}(),

	setFromObject: function () {

		// Computes the world-axis-aligned bounding box of an object (including its children),
		// accounting for both the object's, and children's, world transforms

		var v1 = new Vector3();

		return function setFromObject( object ) {

			var scope = this;

			object.updateMatrixWorld( true );

			this.makeEmpty();

			object.traverse( function ( node ) {

				var i, l;

				var geometry = node.geometry;

				if ( geometry !== undefined ) {

					if ( geometry.isGeometry ) {

						var vertices = geometry.vertices;

						for ( i = 0, l = vertices.length; i < l; i ++ ) {

							v1.copy( vertices[ i ] );
							v1.applyMatrix4( node.matrixWorld );

							scope.expandByPoint( v1 );

						}

					} else if ( geometry.isBufferGeometry ) {

						var attribute = geometry.attributes.position;

						if ( attribute !== undefined ) {

							for ( i = 0, l = attribute.count; i < l; i ++ ) {

								v1.fromAttribute( attribute, i ).applyMatrix4( node.matrixWorld );

								scope.expandByPoint( v1 );

							}

						}

					}

				}

			} );

			return this;

		};

	}(),

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( box ) {

		this.min.copy( box.min );
		this.max.copy( box.max );

		return this;

	},

	makeEmpty: function () {

		this.min.x = this.min.y = this.min.z = + Infinity;
		this.max.x = this.max.y = this.max.z = - Infinity;

		return this;

	},

	isEmpty: function () {

		// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes

		return ( this.max.x < this.min.x ) || ( this.max.y < this.min.y ) || ( this.max.z < this.min.z );

	},

	getCenter: function ( optionalTarget ) {

		var result = optionalTarget || new Vector3();
		return this.isEmpty() ? result.set( 0, 0, 0 ) : result.addVectors( this.min, this.max ).multiplyScalar( 0.5 );

	},

	getSize: function ( optionalTarget ) {

		var result = optionalTarget || new Vector3();
		return this.isEmpty() ? result.set( 0, 0, 0 ) : result.subVectors( this.max, this.min );

	},

	expandByPoint: function ( point ) {

		this.min.min( point );
		this.max.max( point );

		return this;

	},

	expandByVector: function ( vector ) {

		this.min.sub( vector );
		this.max.add( vector );

		return this;

	},

	expandByScalar: function ( scalar ) {

		this.min.addScalar( - scalar );
		this.max.addScalar( scalar );

		return this;

	},

	containsPoint: function ( point ) {

		return point.x < this.min.x || point.x > this.max.x ||
			point.y < this.min.y || point.y > this.max.y ||
			point.z < this.min.z || point.z > this.max.z ? false : true;

	},

	containsBox: function ( box ) {

		return this.min.x <= box.min.x && box.max.x <= this.max.x &&
			this.min.y <= box.min.y && box.max.y <= this.max.y &&
			this.min.z <= box.min.z && box.max.z <= this.max.z;

	},

	getParameter: function ( point, optionalTarget ) {

		// This can potentially have a divide by zero if the box
		// has a size dimension of 0.

		var result = optionalTarget || new Vector3();

		return result.set(
			( point.x - this.min.x ) / ( this.max.x - this.min.x ),
			( point.y - this.min.y ) / ( this.max.y - this.min.y ),
			( point.z - this.min.z ) / ( this.max.z - this.min.z )
		);

	},

	intersectsBox: function ( box ) {

		// using 6 splitting planes to rule out intersections.
		return box.max.x < this.min.x || box.min.x > this.max.x ||
			box.max.y < this.min.y || box.min.y > this.max.y ||
			box.max.z < this.min.z || box.min.z > this.max.z ? false : true;

	},

	intersectsSphere: ( function () {

		var closestPoint;

		return function intersectsSphere( sphere ) {

			if ( closestPoint === undefined ) closestPoint = new Vector3();

			// Find the point on the AABB closest to the sphere center.
			this.clampPoint( sphere.center, closestPoint );

			// If that point is inside the sphere, the AABB and sphere intersect.
			return closestPoint.distanceToSquared( sphere.center ) <= ( sphere.radius * sphere.radius );

		};

	} )(),

	intersectsPlane: function ( plane ) {

		// We compute the minimum and maximum dot product values. If those values
		// are on the same side (back or front) of the plane, then there is no intersection.

		var min, max;

		if ( plane.normal.x > 0 ) {

			min = plane.normal.x * this.min.x;
			max = plane.normal.x * this.max.x;

		} else {

			min = plane.normal.x * this.max.x;
			max = plane.normal.x * this.min.x;

		}

		if ( plane.normal.y > 0 ) {

			min += plane.normal.y * this.min.y;
			max += plane.normal.y * this.max.y;

		} else {

			min += plane.normal.y * this.max.y;
			max += plane.normal.y * this.min.y;

		}

		if ( plane.normal.z > 0 ) {

			min += plane.normal.z * this.min.z;
			max += plane.normal.z * this.max.z;

		} else {

			min += plane.normal.z * this.max.z;
			max += plane.normal.z * this.min.z;

		}

		return ( min <= plane.constant && max >= plane.constant );

	},

	clampPoint: function ( point, optionalTarget ) {

		var result = optionalTarget || new Vector3();
		return result.copy( point ).clamp( this.min, this.max );

	},

	distanceToPoint: function () {

		var v1 = new Vector3();

		return function distanceToPoint( point ) {

			var clampedPoint = v1.copy( point ).clamp( this.min, this.max );
			return clampedPoint.sub( point ).length();

		};

	}(),

	getBoundingSphere: function () {

		var v1 = new Vector3();

		return function getBoundingSphere( optionalTarget ) {

			var result = optionalTarget || new Sphere();

			this.getCenter( result.center );

			result.radius = this.getSize( v1 ).length() * 0.5;

			return result;

		};

	}(),

	intersect: function ( box ) {

		this.min.max( box.min );
		this.max.min( box.max );

		// ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
		if( this.isEmpty() ) this.makeEmpty();

		return this;

	},

	union: function ( box ) {

		this.min.min( box.min );
		this.max.max( box.max );

		return this;

	},

	applyMatrix4: function () {

		var points = [
			new Vector3(),
			new Vector3(),
			new Vector3(),
			new Vector3(),
			new Vector3(),
			new Vector3(),
			new Vector3(),
			new Vector3()
		];

		return function applyMatrix4( matrix ) {

			// transform of empty box is an empty box.
			if( this.isEmpty() ) return this;

			// NOTE: I am using a binary pattern to specify all 2^3 combinations below
			points[ 0 ].set( this.min.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 000
			points[ 1 ].set( this.min.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 001
			points[ 2 ].set( this.min.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 010
			points[ 3 ].set( this.min.x, this.max.y, this.max.z ).applyMatrix4( matrix ); // 011
			points[ 4 ].set( this.max.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 100
			points[ 5 ].set( this.max.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 101
			points[ 6 ].set( this.max.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 110
			points[ 7 ].set( this.max.x, this.max.y, this.max.z ).applyMatrix4( matrix );	// 111

			this.setFromPoints( points );

			return this;

		};

	}(),

	translate: function ( offset ) {

		this.min.add( offset );
		this.max.add( offset );

		return this;

	},

	equals: function ( box ) {

		return box.min.equals( this.min ) && box.max.equals( this.max );

	}

};

/**
 * @author bhouston / http://clara.io
 * @author mrdoob / http://mrdoob.com/
 */

function Sphere( center, radius ) {

	this.center = ( center !== undefined ) ? center : new Vector3();
	this.radius = ( radius !== undefined ) ? radius : 0;

}

Sphere.prototype = {

	constructor: Sphere,

	set: function ( center, radius ) {

		this.center.copy( center );
		this.radius = radius;

		return this;

	},

	setFromPoints: function () {

		var box = new Box3();

		return function setFromPoints( points, optionalCenter ) {

			var center = this.center;

			if ( optionalCenter !== undefined ) {

				center.copy( optionalCenter );

			} else {

				box.setFromPoints( points ).getCenter( center );

			}

			var maxRadiusSq = 0;

			for ( var i = 0, il = points.length; i < il; i ++ ) {

				maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( points[ i ] ) );

			}

			this.radius = Math.sqrt( maxRadiusSq );

			return this;

		};

	}(),

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( sphere ) {

		this.center.copy( sphere.center );
		this.radius = sphere.radius;

		return this;

	},

	empty: function () {

		return ( this.radius <= 0 );

	},

	containsPoint: function ( point ) {

		return ( point.distanceToSquared( this.center ) <= ( this.radius * this.radius ) );

	},

	distanceToPoint: function ( point ) {

		return ( point.distanceTo( this.center ) - this.radius );

	},

	intersectsSphere: function ( sphere ) {

		var radiusSum = this.radius + sphere.radius;

		return sphere.center.distanceToSquared( this.center ) <= ( radiusSum * radiusSum );

	},

	intersectsBox: function ( box ) {

		return box.intersectsSphere( this );

	},

	intersectsPlane: function ( plane ) {

		// We use the following equation to compute the signed distance from
		// the center of the sphere to the plane.
		//
		// distance = q * n - d
		//
		// If this distance is greater than the radius of the sphere,
		// then there is no intersection.

		return Math.abs( this.center.dot( plane.normal ) - plane.constant ) <= this.radius;

	},

	clampPoint: function ( point, optionalTarget ) {

		var deltaLengthSq = this.center.distanceToSquared( point );

		var result = optionalTarget || new Vector3();

		result.copy( point );

		if ( deltaLengthSq > ( this.radius * this.radius ) ) {

			result.sub( this.center ).normalize();
			result.multiplyScalar( this.radius ).add( this.center );

		}

		return result;

	},

	getBoundingBox: function ( optionalTarget ) {

		var box = optionalTarget || new Box3();

		box.set( this.center, this.center );
		box.expandByScalar( this.radius );

		return box;

	},

	applyMatrix4: function ( matrix ) {

		this.center.applyMatrix4( matrix );
		this.radius = this.radius * matrix.getMaxScaleOnAxis();

		return this;

	},

	translate: function ( offset ) {

		this.center.add( offset );

		return this;

	},

	equals: function ( sphere ) {

		return sphere.center.equals( this.center ) && ( sphere.radius === this.radius );

	}

};

/**
 * @author alteredq / http://alteredqualia.com/
 * @author WestLangley / http://github.com/WestLangley
 * @author bhouston / http://clara.io
 * @author tschw
 */

function Matrix3() {

	this.elements = new Float32Array( [

		1, 0, 0,
		0, 1, 0,
		0, 0, 1

	] );

	if ( arguments.length > 0 ) {

		console.error( 'THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.' );

	}

}

Matrix3.prototype = {

	constructor: Matrix3,

	isMatrix3: true,

	set: function ( n11, n12, n13, n21, n22, n23, n31, n32, n33 ) {

		var te = this.elements;

		te[ 0 ] = n11; te[ 1 ] = n21; te[ 2 ] = n31;
		te[ 3 ] = n12; te[ 4 ] = n22; te[ 5 ] = n32;
		te[ 6 ] = n13; te[ 7 ] = n23; te[ 8 ] = n33;

		return this;

	},

	identity: function () {

		this.set(

			1, 0, 0,
			0, 1, 0,
			0, 0, 1

		);

		return this;

	},

	clone: function () {

		return new this.constructor().fromArray( this.elements );

	},

	copy: function ( m ) {

		var me = m.elements;

		this.set(

			me[ 0 ], me[ 3 ], me[ 6 ],
			me[ 1 ], me[ 4 ], me[ 7 ],
			me[ 2 ], me[ 5 ], me[ 8 ]

		);

		return this;

	},

	setFromMatrix4: function( m ) {

		var me = m.elements;

		this.set(

			me[ 0 ], me[ 4 ], me[  8 ],
			me[ 1 ], me[ 5 ], me[  9 ],
			me[ 2 ], me[ 6 ], me[ 10 ]

		);

		return this;

	},

	applyToVector3Array: function () {

		var v1;

		return function applyToVector3Array( array, offset, length ) {

			if ( v1 === undefined ) v1 = new Vector3();
			if ( offset === undefined ) offset = 0;
			if ( length === undefined ) length = array.length;

			for ( var i = 0, j = offset; i < length; i += 3, j += 3 ) {

				v1.fromArray( array, j );
				v1.applyMatrix3( this );
				v1.toArray( array, j );

			}

			return array;

		};

	}(),

	applyToBufferAttribute: function () {

		var v1;

		return function applyToBufferAttribute( attribute ) {

			if ( v1 === undefined ) v1 = new Vector3();

			for ( var i = 0, l = attribute.count; i < l; i ++ ) {

				v1.x = attribute.getX( i );
				v1.y = attribute.getY( i );
				v1.z = attribute.getZ( i );

				v1.applyMatrix3( this );

				attribute.setXYZ( i, v1.x, v1.y, v1.z );

			}

			return attribute;

		};

	}(),

	multiplyScalar: function ( s ) {

		var te = this.elements;

		te[ 0 ] *= s; te[ 3 ] *= s; te[ 6 ] *= s;
		te[ 1 ] *= s; te[ 4 ] *= s; te[ 7 ] *= s;
		te[ 2 ] *= s; te[ 5 ] *= s; te[ 8 ] *= s;

		return this;

	},

	determinant: function () {

		var te = this.elements;

		var a = te[ 0 ], b = te[ 1 ], c = te[ 2 ],
			d = te[ 3 ], e = te[ 4 ], f = te[ 5 ],
			g = te[ 6 ], h = te[ 7 ], i = te[ 8 ];

		return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;

	},

	getInverse: function ( matrix, throwOnDegenerate ) {

		if ( matrix && matrix.isMatrix4 ) {

			console.error( "THREE.Matrix3.getInverse no longer takes a Matrix4 argument." );

		}

		var me = matrix.elements,
			te = this.elements,

			n11 = me[ 0 ], n21 = me[ 1 ], n31 = me[ 2 ],
			n12 = me[ 3 ], n22 = me[ 4 ], n32 = me[ 5 ],
			n13 = me[ 6 ], n23 = me[ 7 ], n33 = me[ 8 ],

			t11 = n33 * n22 - n32 * n23,
			t12 = n32 * n13 - n33 * n12,
			t13 = n23 * n12 - n22 * n13,

			det = n11 * t11 + n21 * t12 + n31 * t13;

		if ( det === 0 ) {

			var msg = "THREE.Matrix3.getInverse(): can't invert matrix, determinant is 0";

			if ( throwOnDegenerate === true ) {

				throw new Error( msg );

			} else {

				console.warn( msg );

			}

			return this.identity();
		}

		var detInv = 1 / det;

		te[ 0 ] = t11 * detInv;
		te[ 1 ] = ( n31 * n23 - n33 * n21 ) * detInv;
		te[ 2 ] = ( n32 * n21 - n31 * n22 ) * detInv;

		te[ 3 ] = t12 * detInv;
		te[ 4 ] = ( n33 * n11 - n31 * n13 ) * detInv;
		te[ 5 ] = ( n31 * n12 - n32 * n11 ) * detInv;

		te[ 6 ] = t13 * detInv;
		te[ 7 ] = ( n21 * n13 - n23 * n11 ) * detInv;
		te[ 8 ] = ( n22 * n11 - n21 * n12 ) * detInv;

		return this;

	},

	transpose: function () {

		var tmp, m = this.elements;

		tmp = m[ 1 ]; m[ 1 ] = m[ 3 ]; m[ 3 ] = tmp;
		tmp = m[ 2 ]; m[ 2 ] = m[ 6 ]; m[ 6 ] = tmp;
		tmp = m[ 5 ]; m[ 5 ] = m[ 7 ]; m[ 7 ] = tmp;

		return this;

	},

	getNormalMatrix: function ( matrix4 ) {

		return this.setFromMatrix4( matrix4 ).getInverse( this ).transpose();

	},

	transposeIntoArray: function ( r ) {

		var m = this.elements;

		r[ 0 ] = m[ 0 ];
		r[ 1 ] = m[ 3 ];
		r[ 2 ] = m[ 6 ];
		r[ 3 ] = m[ 1 ];
		r[ 4 ] = m[ 4 ];
		r[ 5 ] = m[ 7 ];
		r[ 6 ] = m[ 2 ];
		r[ 7 ] = m[ 5 ];
		r[ 8 ] = m[ 8 ];

		return this;

	},

	fromArray: function ( array, offset ) {

		if ( offset === undefined ) offset = 0;

		for( var i = 0; i < 9; i ++ ) {

			this.elements[ i ] = array[ i + offset ];

		}

		return this;

	},

	toArray: function ( array, offset ) {

		if ( array === undefined ) array = [];
		if ( offset === undefined ) offset = 0;

		var te = this.elements;

		array[ offset ] = te[ 0 ];
		array[ offset + 1 ] = te[ 1 ];
		array[ offset + 2 ] = te[ 2 ];

		array[ offset + 3 ] = te[ 3 ];
		array[ offset + 4 ] = te[ 4 ];
		array[ offset + 5 ] = te[ 5 ];

		array[ offset + 6 ] = te[ 6 ];
		array[ offset + 7 ] = te[ 7 ];
		array[ offset + 8 ]  = te[ 8 ];

		return array;

	}

};

/**
 * @author bhouston / http://clara.io
 */

function Plane( normal, constant ) {

	this.normal = ( normal !== undefined ) ? normal : new Vector3( 1, 0, 0 );
	this.constant = ( constant !== undefined ) ? constant : 0;

}

Plane.prototype = {

	constructor: Plane,

	set: function ( normal, constant ) {

		this.normal.copy( normal );
		this.constant = constant;

		return this;

	},

	setComponents: function ( x, y, z, w ) {

		this.normal.set( x, y, z );
		this.constant = w;

		return this;

	},

	setFromNormalAndCoplanarPoint: function ( normal, point ) {

		this.normal.copy( normal );
		this.constant = - point.dot( this.normal );	// must be this.normal, not normal, as this.normal is normalized

		return this;

	},

	setFromCoplanarPoints: function () {

		var v1 = new Vector3();
		var v2 = new Vector3();

		return function setFromCoplanarPoints( a, b, c ) {

			var normal = v1.subVectors( c, b ).cross( v2.subVectors( a, b ) ).normalize();

			// Q: should an error be thrown if normal is zero (e.g. degenerate plane)?

			this.setFromNormalAndCoplanarPoint( normal, a );

			return this;

		};

	}(),

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( plane ) {

		this.normal.copy( plane.normal );
		this.constant = plane.constant;

		return this;

	},

	normalize: function () {

		// Note: will lead to a divide by zero if the plane is invalid.

		var inverseNormalLength = 1.0 / this.normal.length();
		this.normal.multiplyScalar( inverseNormalLength );
		this.constant *= inverseNormalLength;

		return this;

	},

	negate: function () {

		this.constant *= - 1;
		this.normal.negate();

		return this;

	},

	distanceToPoint: function ( point ) {

		return this.normal.dot( point ) + this.constant;

	},

	distanceToSphere: function ( sphere ) {

		return this.distanceToPoint( sphere.center ) - sphere.radius;

	},

	projectPoint: function ( point, optionalTarget ) {

		return this.orthoPoint( point, optionalTarget ).sub( point ).negate();

	},

	orthoPoint: function ( point, optionalTarget ) {

		var perpendicularMagnitude = this.distanceToPoint( point );

		var result = optionalTarget || new Vector3();
		return result.copy( this.normal ).multiplyScalar( perpendicularMagnitude );

	},

	intersectLine: function () {

		var v1 = new Vector3();

		return function intersectLine( line, optionalTarget ) {

			var result = optionalTarget || new Vector3();

			var direction = line.delta( v1 );

			var denominator = this.normal.dot( direction );

			if ( denominator === 0 ) {

				// line is coplanar, return origin
				if ( this.distanceToPoint( line.start ) === 0 ) {

					return result.copy( line.start );

				}

				// Unsure if this is the correct method to handle this case.
				return undefined;

			}

			var t = - ( line.start.dot( this.normal ) + this.constant ) / denominator;

			if ( t < 0 || t > 1 ) {

				return undefined;

			}

			return result.copy( direction ).multiplyScalar( t ).add( line.start );

		};

	}(),

	intersectsLine: function ( line ) {

		// Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.

		var startSign = this.distanceToPoint( line.start );
		var endSign = this.distanceToPoint( line.end );

		return ( startSign < 0 && endSign > 0 ) || ( endSign < 0 && startSign > 0 );

	},

	intersectsBox: function ( box ) {

		return box.intersectsPlane( this );

	},

	intersectsSphere: function ( sphere ) {

		return sphere.intersectsPlane( this );

	},

	coplanarPoint: function ( optionalTarget ) {

		var result = optionalTarget || new Vector3();
		return result.copy( this.normal ).multiplyScalar( - this.constant );

	},

	applyMatrix4: function () {

		var v1 = new Vector3();
		var m1 = new Matrix3();

		return function applyMatrix4( matrix, optionalNormalMatrix ) {

			var referencePoint = this.coplanarPoint( v1 ).applyMatrix4( matrix );

			// transform normal based on theory here:
			// http://www.songho.ca/opengl/gl_normaltransform.html
			var normalMatrix = optionalNormalMatrix || m1.getNormalMatrix( matrix );
			var normal = this.normal.applyMatrix3( normalMatrix ).normalize();

			// recalculate constant (like in setFromNormalAndCoplanarPoint)
			this.constant = - referencePoint.dot( normal );

			return this;

		};

	}(),

	translate: function ( offset ) {

		this.constant = this.constant - offset.dot( this.normal );

		return this;

	},

	equals: function ( plane ) {

		return plane.normal.equals( this.normal ) && ( plane.constant === this.constant );

	}

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 * @author bhouston / http://clara.io
 */

function Frustum( p0, p1, p2, p3, p4, p5 ) {

	this.planes = [

		( p0 !== undefined ) ? p0 : new Plane(),
		( p1 !== undefined ) ? p1 : new Plane(),
		( p2 !== undefined ) ? p2 : new Plane(),
		( p3 !== undefined ) ? p3 : new Plane(),
		( p4 !== undefined ) ? p4 : new Plane(),
		( p5 !== undefined ) ? p5 : new Plane()

	];

}

Frustum.prototype = {

	constructor: Frustum,

	set: function ( p0, p1, p2, p3, p4, p5 ) {

		var planes = this.planes;

		planes[ 0 ].copy( p0 );
		planes[ 1 ].copy( p1 );
		planes[ 2 ].copy( p2 );
		planes[ 3 ].copy( p3 );
		planes[ 4 ].copy( p4 );
		planes[ 5 ].copy( p5 );

		return this;

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( frustum ) {

		var planes = this.planes;

		for ( var i = 0; i < 6; i ++ ) {

			planes[ i ].copy( frustum.planes[ i ] );

		}

		return this;

	},

	setFromMatrix: function ( m ) {

		var planes = this.planes;
		var me = m.elements;
		var me0 = me[ 0 ], me1 = me[ 1 ], me2 = me[ 2 ], me3 = me[ 3 ];
		var me4 = me[ 4 ], me5 = me[ 5 ], me6 = me[ 6 ], me7 = me[ 7 ];
		var me8 = me[ 8 ], me9 = me[ 9 ], me10 = me[ 10 ], me11 = me[ 11 ];
		var me12 = me[ 12 ], me13 = me[ 13 ], me14 = me[ 14 ], me15 = me[ 15 ];

		planes[ 0 ].setComponents( me3 - me0, me7 - me4, me11 - me8, me15 - me12 ).normalize();
		planes[ 1 ].setComponents( me3 + me0, me7 + me4, me11 + me8, me15 + me12 ).normalize();
		planes[ 2 ].setComponents( me3 + me1, me7 + me5, me11 + me9, me15 + me13 ).normalize();
		planes[ 3 ].setComponents( me3 - me1, me7 - me5, me11 - me9, me15 - me13 ).normalize();
		planes[ 4 ].setComponents( me3 - me2, me7 - me6, me11 - me10, me15 - me14 ).normalize();
		planes[ 5 ].setComponents( me3 + me2, me7 + me6, me11 + me10, me15 + me14 ).normalize();

		return this;

	},

	intersectsObject: function () {

		var sphere = new Sphere();

		return function intersectsObject( object ) {

			var geometry = object.geometry;

			if ( geometry.boundingSphere === null )
				geometry.computeBoundingSphere();

			sphere.copy( geometry.boundingSphere )
				.applyMatrix4( object.matrixWorld );

			return this.intersectsSphere( sphere );

		};

	}(),

	intersectsSprite: function () {

		var sphere = new Sphere();

		return function intersectsSprite( sprite ) {

			sphere.center.set( 0, 0, 0 );
			sphere.radius = 0.7071067811865476;
			sphere.applyMatrix4( sprite.matrixWorld );

			return this.intersectsSphere( sphere );

		};

	}(),

	intersectsSphere: function ( sphere ) {

		var planes = this.planes;
		var center = sphere.center;
		var negRadius = - sphere.radius;

		for ( var i = 0; i < 6; i ++ ) {

			var distance = planes[ i ].distanceToPoint( center );

			if ( distance < negRadius ) {

				return false;

			}

		}

		return true;

	},

	intersectsBox: function () {

		var p1 = new Vector3(),
			p2 = new Vector3();

		return function intersectsBox( box ) {

			var planes = this.planes;

			for ( var i = 0; i < 6 ; i ++ ) {

				var plane = planes[ i ];

				p1.x = plane.normal.x > 0 ? box.min.x : box.max.x;
				p2.x = plane.normal.x > 0 ? box.max.x : box.min.x;
				p1.y = plane.normal.y > 0 ? box.min.y : box.max.y;
				p2.y = plane.normal.y > 0 ? box.max.y : box.min.y;
				p1.z = plane.normal.z > 0 ? box.min.z : box.max.z;
				p2.z = plane.normal.z > 0 ? box.max.z : box.min.z;

				var d1 = plane.distanceToPoint( p1 );
				var d2 = plane.distanceToPoint( p2 );

				// if both outside plane, no intersection

				if ( d1 < 0 && d2 < 0 ) {

					return false;

				}

			}

			return true;

		};

	}(),


	containsPoint: function ( point ) {

		var planes = this.planes;

		for ( var i = 0; i < 6; i ++ ) {

			if ( planes[ i ].distanceToPoint( point ) < 0 ) {

				return false;

			}

		}

		return true;

	}

};

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLShadowMap( _renderer, _lights, _objects, capabilities ) {

	var _gl = _renderer.context,
	_state = _renderer.state,
	_frustum = new Frustum(),
	_projScreenMatrix = new Matrix4(),

	_lightShadows = _lights.shadows,

	_shadowMapSize = new Vector2(),
	_maxShadowMapSize = new Vector2( capabilities.maxTextureSize, capabilities.maxTextureSize ),

	_lookTarget = new Vector3(),
	_lightPositionWorld = new Vector3(),

	_renderList = [],

	_MorphingFlag = 1,
	_SkinningFlag = 2,

	_NumberOfMaterialVariants = ( _MorphingFlag | _SkinningFlag ) + 1,

	_depthMaterials = new Array( _NumberOfMaterialVariants ),
	_distanceMaterials = new Array( _NumberOfMaterialVariants ),

	_materialCache = {};

	var cubeDirections = [
		new Vector3( 1, 0, 0 ), new Vector3( - 1, 0, 0 ), new Vector3( 0, 0, 1 ),
		new Vector3( 0, 0, - 1 ), new Vector3( 0, 1, 0 ), new Vector3( 0, - 1, 0 )
	];

	var cubeUps = [
		new Vector3( 0, 1, 0 ), new Vector3( 0, 1, 0 ), new Vector3( 0, 1, 0 ),
		new Vector3( 0, 1, 0 ), new Vector3( 0, 0, 1 ),	new Vector3( 0, 0, - 1 )
	];

	var cube2DViewPorts = [
		new Vector4(), new Vector4(), new Vector4(),
		new Vector4(), new Vector4(), new Vector4()
	];

	// init

	var depthMaterialTemplate = new MeshDepthMaterial();
	depthMaterialTemplate.depthPacking = RGBADepthPacking;
	depthMaterialTemplate.clipping = true;

	var distanceShader = ShaderLib[ "distanceRGBA" ];
	var distanceUniforms = UniformsUtils.clone( distanceShader.uniforms );

	for ( var i = 0; i !== _NumberOfMaterialVariants; ++ i ) {

		var useMorphing = ( i & _MorphingFlag ) !== 0;
		var useSkinning = ( i & _SkinningFlag ) !== 0;

		var depthMaterial = depthMaterialTemplate.clone();
		depthMaterial.morphTargets = useMorphing;
		depthMaterial.skinning = useSkinning;

		_depthMaterials[ i ] = depthMaterial;

		var distanceMaterial = new ShaderMaterial( {
			defines: {
				'USE_SHADOWMAP': ''
			},
			uniforms: distanceUniforms,
			vertexShader: distanceShader.vertexShader,
			fragmentShader: distanceShader.fragmentShader,
			morphTargets: useMorphing,
			skinning: useSkinning,
			clipping: true
		} );

		_distanceMaterials[ i ] = distanceMaterial;

	}

	//

	var scope = this;

	this.enabled = false;

	this.autoUpdate = true;
	this.needsUpdate = false;

	this.type = PCFShadowMap;

	this.renderReverseSided = true;
	this.renderSingleSided = true;

	this.render = function ( scene, camera ) {

		if ( scope.enabled === false ) return;
		if ( scope.autoUpdate === false && scope.needsUpdate === false ) return;

		if ( _lightShadows.length === 0 ) return;

		// Set GL state for depth map.
		_state.buffers.color.setClear( 1, 1, 1, 1 );
		_state.disable( _gl.BLEND );
		_state.setDepthTest( true );
		_state.setScissorTest( false );

		// render depth map

		var faceCount, isPointLight;

		for ( var i = 0, il = _lightShadows.length; i < il; i ++ ) {

			var light = _lightShadows[ i ];
			var shadow = light.shadow;

			if ( shadow === undefined ) {

				console.warn( 'THREE.WebGLShadowMap:', light, 'has no shadow.' );
				continue;

			}

			var shadowCamera = shadow.camera;

			_shadowMapSize.copy( shadow.mapSize );
			_shadowMapSize.min( _maxShadowMapSize );

			if ( light && light.isPointLight ) {

				faceCount = 6;
				isPointLight = true;

				var vpWidth = _shadowMapSize.x;
				var vpHeight = _shadowMapSize.y;

				// These viewports map a cube-map onto a 2D texture with the
				// following orientation:
				//
				//  xzXZ
				//   y Y
				//
				// X - Positive x direction
				// x - Negative x direction
				// Y - Positive y direction
				// y - Negative y direction
				// Z - Positive z direction
				// z - Negative z direction

				// positive X
				cube2DViewPorts[ 0 ].set( vpWidth * 2, vpHeight, vpWidth, vpHeight );
				// negative X
				cube2DViewPorts[ 1 ].set( 0, vpHeight, vpWidth, vpHeight );
				// positive Z
				cube2DViewPorts[ 2 ].set( vpWidth * 3, vpHeight, vpWidth, vpHeight );
				// negative Z
				cube2DViewPorts[ 3 ].set( vpWidth, vpHeight, vpWidth, vpHeight );
				// positive Y
				cube2DViewPorts[ 4 ].set( vpWidth * 3, 0, vpWidth, vpHeight );
				// negative Y
				cube2DViewPorts[ 5 ].set( vpWidth, 0, vpWidth, vpHeight );

				_shadowMapSize.x *= 4.0;
				_shadowMapSize.y *= 2.0;

			} else {

				faceCount = 1;
				isPointLight = false;

			}

			if ( shadow.map === null ) {

				var pars = { minFilter: NearestFilter, magFilter: NearestFilter, format: RGBAFormat };

				shadow.map = new WebGLRenderTarget( _shadowMapSize.x, _shadowMapSize.y, pars );

				shadowCamera.updateProjectionMatrix();

			}

			if ( shadow.isSpotLightShadow ) {

				shadow.update( light );

			}

			// TODO (abelnation / sam-g-steel): is this needed?
			if (shadow && shadow.isRectAreaLightShadow ) {

				shadow.update( light );

			}

			var shadowMap = shadow.map;
			var shadowMatrix = shadow.matrix;

			_lightPositionWorld.setFromMatrixPosition( light.matrixWorld );
			shadowCamera.position.copy( _lightPositionWorld );

			_renderer.setRenderTarget( shadowMap );
			_renderer.clear();

			// render shadow map for each cube face (if omni-directional) or
			// run a single pass if not

			for ( var face = 0; face < faceCount; face ++ ) {

				if ( isPointLight ) {

					_lookTarget.copy( shadowCamera.position );
					_lookTarget.add( cubeDirections[ face ] );
					shadowCamera.up.copy( cubeUps[ face ] );
					shadowCamera.lookAt( _lookTarget );

					var vpDimensions = cube2DViewPorts[ face ];
					_state.viewport( vpDimensions );

				} else {

					_lookTarget.setFromMatrixPosition( light.target.matrixWorld );
					shadowCamera.lookAt( _lookTarget );

				}

				shadowCamera.updateMatrixWorld();
				shadowCamera.matrixWorldInverse.getInverse( shadowCamera.matrixWorld );

				// compute shadow matrix

				shadowMatrix.set(
					0.5, 0.0, 0.0, 0.5,
					0.0, 0.5, 0.0, 0.5,
					0.0, 0.0, 0.5, 0.5,
					0.0, 0.0, 0.0, 1.0
				);

				shadowMatrix.multiply( shadowCamera.projectionMatrix );
				shadowMatrix.multiply( shadowCamera.matrixWorldInverse );

				// update camera matrices and frustum

				_projScreenMatrix.multiplyMatrices( shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse );
				_frustum.setFromMatrix( _projScreenMatrix );

				// set object matrices & frustum culling

				_renderList.length = 0;

				projectObject( scene, camera, shadowCamera );

				// render shadow map
				// render regular objects

				for ( var j = 0, jl = _renderList.length; j < jl; j ++ ) {

					var object = _renderList[ j ];
					var geometry = _objects.update( object );
					var material = object.material;

					if ( material && material.isMultiMaterial ) {

						var groups = geometry.groups;
						var materials = material.materials;

						for ( var k = 0, kl = groups.length; k < kl; k ++ ) {

							var group = groups[ k ];
							var groupMaterial = materials[ group.materialIndex ];

							if ( groupMaterial.visible === true ) {

								var depthMaterial = getDepthMaterial( object, groupMaterial, isPointLight, _lightPositionWorld );
								_renderer.renderBufferDirect( shadowCamera, null, geometry, depthMaterial, object, group );

							}

						}

					} else {

						var depthMaterial = getDepthMaterial( object, material, isPointLight, _lightPositionWorld );
						_renderer.renderBufferDirect( shadowCamera, null, geometry, depthMaterial, object, null );

					}

				}

			}

		}

		// Restore GL state.
		var clearColor = _renderer.getClearColor(),
		clearAlpha = _renderer.getClearAlpha();
		_renderer.setClearColor( clearColor, clearAlpha );

		scope.needsUpdate = false;

	};

	function getDepthMaterial( object, material, isPointLight, lightPositionWorld ) {

		var geometry = object.geometry;

		var result = null;

		var materialVariants = _depthMaterials;
		var customMaterial = object.customDepthMaterial;

		if ( isPointLight ) {

			materialVariants = _distanceMaterials;
			customMaterial = object.customDistanceMaterial;

		}

		if ( ! customMaterial ) {

			var useMorphing = false;

			if ( material.morphTargets ) {

				if ( geometry && geometry.isBufferGeometry ) {

					useMorphing = geometry.morphAttributes && geometry.morphAttributes.position && geometry.morphAttributes.position.length > 0;

				} else if ( geometry && geometry.isGeometry ) {

					useMorphing = geometry.morphTargets && geometry.morphTargets.length > 0;

				}

			}

			var useSkinning = object.isSkinnedMesh && material.skinning;

			var variantIndex = 0;

			if ( useMorphing ) variantIndex |= _MorphingFlag;
			if ( useSkinning ) variantIndex |= _SkinningFlag;

			result = materialVariants[ variantIndex ];

		} else {

			result = customMaterial;

		}

		if ( _renderer.localClippingEnabled &&
			 material.clipShadows === true &&
				material.clippingPlanes.length !== 0 ) {

			// in this case we need a unique material instance reflecting the
			// appropriate state

			var keyA = result.uuid, keyB = material.uuid;

			var materialsForVariant = _materialCache[ keyA ];

			if ( materialsForVariant === undefined ) {

				materialsForVariant = {};
				_materialCache[ keyA ] = materialsForVariant;

			}

			var cachedMaterial = materialsForVariant[ keyB ];

			if ( cachedMaterial === undefined ) {

				cachedMaterial = result.clone();
				materialsForVariant[ keyB ] = cachedMaterial;

			}

			result = cachedMaterial;

		}

		result.visible = material.visible;
		result.wireframe = material.wireframe;

		var side = material.side;

		if ( scope.renderSingleSided && side == DoubleSide ) {

			side = FrontSide;

		}

		if ( scope.renderReverseSided ) {

			if ( side === FrontSide ) side = BackSide;
			else if ( side === BackSide ) side = FrontSide;

		}

		result.side = side;

		result.clipShadows = material.clipShadows;
		result.clippingPlanes = material.clippingPlanes;

		result.wireframeLinewidth = material.wireframeLinewidth;
		result.linewidth = material.linewidth;

		if ( isPointLight && result.uniforms.lightPos !== undefined ) {

			result.uniforms.lightPos.value.copy( lightPositionWorld );

		}

		return result;

	}

	function projectObject( object, camera, shadowCamera ) {

		if ( object.visible === false ) return;

		var visible = ( object.layers.mask & camera.layers.mask ) !== 0;

		if ( visible && ( object.isMesh || object.isLine || object.isPoints ) ) {

			if ( object.castShadow && ( object.frustumCulled === false || _frustum.intersectsObject( object ) === true ) ) {

				var material = object.material;

				if ( material.visible === true ) {

					object.modelViewMatrix.multiplyMatrices( shadowCamera.matrixWorldInverse, object.matrixWorld );
					_renderList.push( object );

				}

			}

		}

		var children = object.children;

		for ( var i = 0, l = children.length; i < l; i ++ ) {

			projectObject( children[ i ], camera, shadowCamera );

		}

	}

}

/**
 * @author bhouston / http://clara.io
 */

function Ray( origin, direction ) {

	this.origin = ( origin !== undefined ) ? origin : new Vector3();
	this.direction = ( direction !== undefined ) ? direction : new Vector3();

}

Ray.prototype = {

	constructor: Ray,

	set: function ( origin, direction ) {

		this.origin.copy( origin );
		this.direction.copy( direction );

		return this;

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( ray ) {

		this.origin.copy( ray.origin );
		this.direction.copy( ray.direction );

		return this;

	},

	at: function ( t, optionalTarget ) {

		var result = optionalTarget || new Vector3();

		return result.copy( this.direction ).multiplyScalar( t ).add( this.origin );

	},

	lookAt: function ( v ) {

		this.direction.copy( v ).sub( this.origin ).normalize();

		return this;

	},

	recast: function () {

		var v1 = new Vector3();

		return function recast( t ) {

			this.origin.copy( this.at( t, v1 ) );

			return this;

		};

	}(),

	closestPointToPoint: function ( point, optionalTarget ) {

		var result = optionalTarget || new Vector3();
		result.subVectors( point, this.origin );
		var directionDistance = result.dot( this.direction );

		if ( directionDistance < 0 ) {

			return result.copy( this.origin );

		}

		return result.copy( this.direction ).multiplyScalar( directionDistance ).add( this.origin );

	},

	distanceToPoint: function ( point ) {

		return Math.sqrt( this.distanceSqToPoint( point ) );

	},

	distanceSqToPoint: function () {

		var v1 = new Vector3();

		return function distanceSqToPoint( point ) {

			var directionDistance = v1.subVectors( point, this.origin ).dot( this.direction );

			// point behind the ray

			if ( directionDistance < 0 ) {

				return this.origin.distanceToSquared( point );

			}

			v1.copy( this.direction ).multiplyScalar( directionDistance ).add( this.origin );

			return v1.distanceToSquared( point );

		};

	}(),

	distanceSqToSegment: function () {

		var segCenter = new Vector3();
		var segDir = new Vector3();
		var diff = new Vector3();

		return function distanceSqToSegment( v0, v1, optionalPointOnRay, optionalPointOnSegment ) {

			// from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteDistRaySegment.h
			// It returns the min distance between the ray and the segment
			// defined by v0 and v1
			// It can also set two optional targets :
			// - The closest point on the ray
			// - The closest point on the segment

			segCenter.copy( v0 ).add( v1 ).multiplyScalar( 0.5 );
			segDir.copy( v1 ).sub( v0 ).normalize();
			diff.copy( this.origin ).sub( segCenter );

			var segExtent = v0.distanceTo( v1 ) * 0.5;
			var a01 = - this.direction.dot( segDir );
			var b0 = diff.dot( this.direction );
			var b1 = - diff.dot( segDir );
			var c = diff.lengthSq();
			var det = Math.abs( 1 - a01 * a01 );
			var s0, s1, sqrDist, extDet;

			if ( det > 0 ) {

				// The ray and segment are not parallel.

				s0 = a01 * b1 - b0;
				s1 = a01 * b0 - b1;
				extDet = segExtent * det;

				if ( s0 >= 0 ) {

					if ( s1 >= - extDet ) {

						if ( s1 <= extDet ) {

							// region 0
							// Minimum at interior points of ray and segment.

							var invDet = 1 / det;
							s0 *= invDet;
							s1 *= invDet;
							sqrDist = s0 * ( s0 + a01 * s1 + 2 * b0 ) + s1 * ( a01 * s0 + s1 + 2 * b1 ) + c;

						} else {

							// region 1

							s1 = segExtent;
							s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
							sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

						}

					} else {

						// region 5

						s1 = - segExtent;
						s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
						sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

					}

				} else {

					if ( s1 <= - extDet ) {

						// region 4

						s0 = Math.max( 0, - ( - a01 * segExtent + b0 ) );
						s1 = ( s0 > 0 ) ? - segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
						sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

					} else if ( s1 <= extDet ) {

						// region 3

						s0 = 0;
						s1 = Math.min( Math.max( - segExtent, - b1 ), segExtent );
						sqrDist = s1 * ( s1 + 2 * b1 ) + c;

					} else {

						// region 2

						s0 = Math.max( 0, - ( a01 * segExtent + b0 ) );
						s1 = ( s0 > 0 ) ? segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
						sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

					}

				}

			} else {

				// Ray and segment are parallel.

				s1 = ( a01 > 0 ) ? - segExtent : segExtent;
				s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
				sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

			}

			if ( optionalPointOnRay ) {

				optionalPointOnRay.copy( this.direction ).multiplyScalar( s0 ).add( this.origin );

			}

			if ( optionalPointOnSegment ) {

				optionalPointOnSegment.copy( segDir ).multiplyScalar( s1 ).add( segCenter );

			}

			return sqrDist;

		};

	}(),

	intersectSphere: function () {

		var v1 = new Vector3();

		return function intersectSphere( sphere, optionalTarget ) {

			v1.subVectors( sphere.center, this.origin );
			var tca = v1.dot( this.direction );
			var d2 = v1.dot( v1 ) - tca * tca;
			var radius2 = sphere.radius * sphere.radius;

			if ( d2 > radius2 ) return null;

			var thc = Math.sqrt( radius2 - d2 );

			// t0 = first intersect point - entrance on front of sphere
			var t0 = tca - thc;

			// t1 = second intersect point - exit point on back of sphere
			var t1 = tca + thc;

			// test to see if both t0 and t1 are behind the ray - if so, return null
			if ( t0 < 0 && t1 < 0 ) return null;

			// test to see if t0 is behind the ray:
			// if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
			// in order to always return an intersect point that is in front of the ray.
			if ( t0 < 0 ) return this.at( t1, optionalTarget );

			// else t0 is in front of the ray, so return the first collision point scaled by t0
			return this.at( t0, optionalTarget );

		};

	}(),

	intersectsSphere: function ( sphere ) {

		return this.distanceToPoint( sphere.center ) <= sphere.radius;

	},

	distanceToPlane: function ( plane ) {

		var denominator = plane.normal.dot( this.direction );

		if ( denominator === 0 ) {

			// line is coplanar, return origin
			if ( plane.distanceToPoint( this.origin ) === 0 ) {

				return 0;

			}

			// Null is preferable to undefined since undefined means.... it is undefined

			return null;

		}

		var t = - ( this.origin.dot( plane.normal ) + plane.constant ) / denominator;

		// Return if the ray never intersects the plane

		return t >= 0 ? t :  null;

	},

	intersectPlane: function ( plane, optionalTarget ) {

		var t = this.distanceToPlane( plane );

		if ( t === null ) {

			return null;

		}

		return this.at( t, optionalTarget );

	},



	intersectsPlane: function ( plane ) {

		// check if the ray lies on the plane first

		var distToPoint = plane.distanceToPoint( this.origin );

		if ( distToPoint === 0 ) {

			return true;

		}

		var denominator = plane.normal.dot( this.direction );

		if ( denominator * distToPoint < 0 ) {

			return true;

		}

		// ray origin is behind the plane (and is pointing behind it)

		return false;

	},

	intersectBox: function ( box, optionalTarget ) {

		var tmin, tmax, tymin, tymax, tzmin, tzmax;

		var invdirx = 1 / this.direction.x,
			invdiry = 1 / this.direction.y,
			invdirz = 1 / this.direction.z;

		var origin = this.origin;

		if ( invdirx >= 0 ) {

			tmin = ( box.min.x - origin.x ) * invdirx;
			tmax = ( box.max.x - origin.x ) * invdirx;

		} else {

			tmin = ( box.max.x - origin.x ) * invdirx;
			tmax = ( box.min.x - origin.x ) * invdirx;

		}

		if ( invdiry >= 0 ) {

			tymin = ( box.min.y - origin.y ) * invdiry;
			tymax = ( box.max.y - origin.y ) * invdiry;

		} else {

			tymin = ( box.max.y - origin.y ) * invdiry;
			tymax = ( box.min.y - origin.y ) * invdiry;

		}

		if ( ( tmin > tymax ) || ( tymin > tmax ) ) return null;

		// These lines also handle the case where tmin or tmax is NaN
		// (result of 0 * Infinity). x !== x returns true if x is NaN

		if ( tymin > tmin || tmin !== tmin ) tmin = tymin;

		if ( tymax < tmax || tmax !== tmax ) tmax = tymax;

		if ( invdirz >= 0 ) {

			tzmin = ( box.min.z - origin.z ) * invdirz;
			tzmax = ( box.max.z - origin.z ) * invdirz;

		} else {

			tzmin = ( box.max.z - origin.z ) * invdirz;
			tzmax = ( box.min.z - origin.z ) * invdirz;

		}

		if ( ( tmin > tzmax ) || ( tzmin > tmax ) ) return null;

		if ( tzmin > tmin || tmin !== tmin ) tmin = tzmin;

		if ( tzmax < tmax || tmax !== tmax ) tmax = tzmax;

		//return point closest to the ray (positive side)

		if ( tmax < 0 ) return null;

		return this.at( tmin >= 0 ? tmin : tmax, optionalTarget );

	},

	intersectsBox: ( function () {

		var v = new Vector3();

		return function intersectsBox( box ) {

			return this.intersectBox( box, v ) !== null;

		};

	} )(),

	intersectTriangle: function () {

		// Compute the offset origin, edges, and normal.
		var diff = new Vector3();
		var edge1 = new Vector3();
		var edge2 = new Vector3();
		var normal = new Vector3();

		return function intersectTriangle( a, b, c, backfaceCulling, optionalTarget ) {

			// from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h

			edge1.subVectors( b, a );
			edge2.subVectors( c, a );
			normal.crossVectors( edge1, edge2 );

			// Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
			// E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
			//   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
			//   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
			//   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
			var DdN = this.direction.dot( normal );
			var sign;

			if ( DdN > 0 ) {

				if ( backfaceCulling ) return null;
				sign = 1;

			} else if ( DdN < 0 ) {

				sign = - 1;
				DdN = - DdN;

			} else {

				return null;

			}

			diff.subVectors( this.origin, a );
			var DdQxE2 = sign * this.direction.dot( edge2.crossVectors( diff, edge2 ) );

			// b1 < 0, no intersection
			if ( DdQxE2 < 0 ) {

				return null;

			}

			var DdE1xQ = sign * this.direction.dot( edge1.cross( diff ) );

			// b2 < 0, no intersection
			if ( DdE1xQ < 0 ) {

				return null;

			}

			// b1+b2 > 1, no intersection
			if ( DdQxE2 + DdE1xQ > DdN ) {

				return null;

			}

			// Line intersects triangle, check if ray does.
			var QdN = - sign * diff.dot( normal );

			// t < 0, no intersection
			if ( QdN < 0 ) {

				return null;

			}

			// Ray intersects triangle.
			return this.at( QdN / DdN, optionalTarget );

		};

	}(),

	applyMatrix4: function ( matrix4 ) {

		this.direction.add( this.origin ).applyMatrix4( matrix4 );
		this.origin.applyMatrix4( matrix4 );
		this.direction.sub( this.origin );
		this.direction.normalize();

		return this;

	},

	equals: function ( ray ) {

		return ray.origin.equals( this.origin ) && ray.direction.equals( this.direction );

	}

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author WestLangley / http://github.com/WestLangley
 * @author bhouston / http://clara.io
 */

function Euler( x, y, z, order ) {

	this._x = x || 0;
	this._y = y || 0;
	this._z = z || 0;
	this._order = order || Euler.DefaultOrder;

}

Euler.RotationOrders = [ 'XYZ', 'YZX', 'ZXY', 'XZY', 'YXZ', 'ZYX' ];

Euler.DefaultOrder = 'XYZ';

Euler.prototype = {

	constructor: Euler,

	isEuler: true,

	get x () {

		return this._x;

	},

	set x ( value ) {

		this._x = value;
		this.onChangeCallback();

	},

	get y () {

		return this._y;

	},

	set y ( value ) {

		this._y = value;
		this.onChangeCallback();

	},

	get z () {

		return this._z;

	},

	set z ( value ) {

		this._z = value;
		this.onChangeCallback();

	},

	get order () {

		return this._order;

	},

	set order ( value ) {

		this._order = value;
		this.onChangeCallback();

	},

	set: function ( x, y, z, order ) {

		this._x = x;
		this._y = y;
		this._z = z;
		this._order = order || this._order;

		this.onChangeCallback();

		return this;

	},

	clone: function () {

		return new this.constructor( this._x, this._y, this._z, this._order );

	},

	copy: function ( euler ) {

		this._x = euler._x;
		this._y = euler._y;
		this._z = euler._z;
		this._order = euler._order;

		this.onChangeCallback();

		return this;

	},

	setFromRotationMatrix: function ( m, order, update ) {

		var clamp = _Math.clamp;

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		var te = m.elements;
		var m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ];
		var m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ];
		var m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];

		order = order || this._order;

		if ( order === 'XYZ' ) {

			this._y = Math.asin( clamp( m13, - 1, 1 ) );

			if ( Math.abs( m13 ) < 0.99999 ) {

				this._x = Math.atan2( - m23, m33 );
				this._z = Math.atan2( - m12, m11 );

			} else {

				this._x = Math.atan2( m32, m22 );
				this._z = 0;

			}

		} else if ( order === 'YXZ' ) {

			this._x = Math.asin( - clamp( m23, - 1, 1 ) );

			if ( Math.abs( m23 ) < 0.99999 ) {

				this._y = Math.atan2( m13, m33 );
				this._z = Math.atan2( m21, m22 );

			} else {

				this._y = Math.atan2( - m31, m11 );
				this._z = 0;

			}

		} else if ( order === 'ZXY' ) {

			this._x = Math.asin( clamp( m32, - 1, 1 ) );

			if ( Math.abs( m32 ) < 0.99999 ) {

				this._y = Math.atan2( - m31, m33 );
				this._z = Math.atan2( - m12, m22 );

			} else {

				this._y = 0;
				this._z = Math.atan2( m21, m11 );

			}

		} else if ( order === 'ZYX' ) {

			this._y = Math.asin( - clamp( m31, - 1, 1 ) );

			if ( Math.abs( m31 ) < 0.99999 ) {

				this._x = Math.atan2( m32, m33 );
				this._z = Math.atan2( m21, m11 );

			} else {

				this._x = 0;
				this._z = Math.atan2( - m12, m22 );

			}

		} else if ( order === 'YZX' ) {

			this._z = Math.asin( clamp( m21, - 1, 1 ) );

			if ( Math.abs( m21 ) < 0.99999 ) {

				this._x = Math.atan2( - m23, m22 );
				this._y = Math.atan2( - m31, m11 );

			} else {

				this._x = 0;
				this._y = Math.atan2( m13, m33 );

			}

		} else if ( order === 'XZY' ) {

			this._z = Math.asin( - clamp( m12, - 1, 1 ) );

			if ( Math.abs( m12 ) < 0.99999 ) {

				this._x = Math.atan2( m32, m22 );
				this._y = Math.atan2( m13, m11 );

			} else {

				this._x = Math.atan2( - m23, m33 );
				this._y = 0;

			}

		} else {

			console.warn( 'THREE.Euler: .setFromRotationMatrix() given unsupported order: ' + order );

		}

		this._order = order;

		if ( update !== false ) this.onChangeCallback();

		return this;

	},

	setFromQuaternion: function () {

		var matrix;

		return function setFromQuaternion( q, order, update ) {

			if ( matrix === undefined ) matrix = new Matrix4();

			matrix.makeRotationFromQuaternion( q );

			return this.setFromRotationMatrix( matrix, order, update );

		};

	}(),

	setFromVector3: function ( v, order ) {

		return this.set( v.x, v.y, v.z, order || this._order );

	},

	reorder: function () {

		// WARNING: this discards revolution information -bhouston

		var q = new Quaternion();

		return function reorder( newOrder ) {

			q.setFromEuler( this );

			return this.setFromQuaternion( q, newOrder );

		};

	}(),

	equals: function ( euler ) {

		return ( euler._x === this._x ) && ( euler._y === this._y ) && ( euler._z === this._z ) && ( euler._order === this._order );

	},

	fromArray: function ( array ) {

		this._x = array[ 0 ];
		this._y = array[ 1 ];
		this._z = array[ 2 ];
		if ( array[ 3 ] !== undefined ) this._order = array[ 3 ];

		this.onChangeCallback();

		return this;

	},

	toArray: function ( array, offset ) {

		if ( array === undefined ) array = [];
		if ( offset === undefined ) offset = 0;

		array[ offset ] = this._x;
		array[ offset + 1 ] = this._y;
		array[ offset + 2 ] = this._z;
		array[ offset + 3 ] = this._order;

		return array;

	},

	toVector3: function ( optionalResult ) {

		if ( optionalResult ) {

			return optionalResult.set( this._x, this._y, this._z );

		} else {

			return new Vector3( this._x, this._y, this._z );

		}

	},

	onChange: function ( callback ) {

		this.onChangeCallback = callback;

		return this;

	},

	onChangeCallback: function () {}

};

/**
 * @author mrdoob / http://mrdoob.com/
 */

function Layers() {

	this.mask = 1;

}

Layers.prototype = {

	constructor: Layers,

	set: function ( channel ) {

		this.mask = 1 << channel;

	},

	enable: function ( channel ) {

		this.mask |= 1 << channel;

	},

	toggle: function ( channel ) {

		this.mask ^= 1 << channel;

	},

	disable: function ( channel ) {

		this.mask &= ~ ( 1 << channel );

	},

	test: function ( layers ) {

		return ( this.mask & layers.mask ) !== 0;

	}

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 * @author WestLangley / http://github.com/WestLangley
 * @author elephantatwork / www.elephantatwork.ch
 */

var object3DId = 0;

function Object3D() {

	Object.defineProperty( this, 'id', { value: object3DId ++ } );

	this.uuid = _Math.generateUUID();

	this.name = '';
	this.type = 'Object3D';

	this.parent = null;
	this.children = [];

	this.up = Object3D.DefaultUp.clone();

	var position = new Vector3();
	var rotation = new Euler();
	var quaternion = new Quaternion();
	var scale = new Vector3( 1, 1, 1 );

	function onRotationChange() {

		quaternion.setFromEuler( rotation, false );

	}

	function onQuaternionChange() {

		rotation.setFromQuaternion( quaternion, undefined, false );

	}

	rotation.onChange( onRotationChange );
	quaternion.onChange( onQuaternionChange );

	Object.defineProperties( this, {
		position: {
			enumerable: true,
			value: position
		},
		rotation: {
			enumerable: true,
			value: rotation
		},
		quaternion: {
			enumerable: true,
			value: quaternion
		},
		scale: {
			enumerable: true,
			value: scale
		},
		modelViewMatrix: {
			value: new Matrix4()
		},
		normalMatrix: {
			value: new Matrix3()
		}
	} );

	this.matrix = new Matrix4();
	this.matrixWorld = new Matrix4();

	this.matrixAutoUpdate = Object3D.DefaultMatrixAutoUpdate;
	this.matrixWorldNeedsUpdate = false;

	this.layers = new Layers();
	this.visible = true;

	this.castShadow = false;
	this.receiveShadow = false;

	this.frustumCulled = true;
	this.renderOrder = 0;

	this.userData = {};

	this.onBeforeRender = function () {};
	this.onAfterRender = function () {};

}

Object3D.DefaultUp = new Vector3( 0, 1, 0 );
Object3D.DefaultMatrixAutoUpdate = true;

Object.assign( Object3D.prototype, EventDispatcher.prototype, {

	isObject3D: true,

	applyMatrix: function ( matrix ) {

		this.matrix.multiplyMatrices( matrix, this.matrix );

		this.matrix.decompose( this.position, this.quaternion, this.scale );

	},

	setRotationFromAxisAngle: function ( axis, angle ) {

		// assumes axis is normalized

		this.quaternion.setFromAxisAngle( axis, angle );

	},

	setRotationFromEuler: function ( euler ) {

		this.quaternion.setFromEuler( euler, true );

	},

	setRotationFromMatrix: function ( m ) {

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		this.quaternion.setFromRotationMatrix( m );

	},

	setRotationFromQuaternion: function ( q ) {

		// assumes q is normalized

		this.quaternion.copy( q );

	},

	rotateOnAxis: function () {

		// rotate object on axis in object space
		// axis is assumed to be normalized

		var q1 = new Quaternion();

		return function rotateOnAxis( axis, angle ) {

			q1.setFromAxisAngle( axis, angle );

			this.quaternion.multiply( q1 );

			return this;

		};

	}(),

	rotateX: function () {

		var v1 = new Vector3( 1, 0, 0 );

		return function rotateX( angle ) {

			return this.rotateOnAxis( v1, angle );

		};

	}(),

	rotateY: function () {

		var v1 = new Vector3( 0, 1, 0 );

		return function rotateY( angle ) {

			return this.rotateOnAxis( v1, angle );

		};

	}(),

	rotateZ: function () {

		var v1 = new Vector3( 0, 0, 1 );

		return function rotateZ( angle ) {

			return this.rotateOnAxis( v1, angle );

		};

	}(),

	translateOnAxis: function () {

		// translate object by distance along axis in object space
		// axis is assumed to be normalized

		var v1 = new Vector3();

		return function translateOnAxis( axis, distance ) {

			v1.copy( axis ).applyQuaternion( this.quaternion );

			this.position.add( v1.multiplyScalar( distance ) );

			return this;

		};

	}(),

	translateX: function () {

		var v1 = new Vector3( 1, 0, 0 );

		return function translateX( distance ) {

			return this.translateOnAxis( v1, distance );

		};

	}(),

	translateY: function () {

		var v1 = new Vector3( 0, 1, 0 );

		return function translateY( distance ) {

			return this.translateOnAxis( v1, distance );

		};

	}(),

	translateZ: function () {

		var v1 = new Vector3( 0, 0, 1 );

		return function translateZ( distance ) {

			return this.translateOnAxis( v1, distance );

		};

	}(),

	localToWorld: function ( vector ) {

		return vector.applyMatrix4( this.matrixWorld );

	},

	worldToLocal: function () {

		var m1 = new Matrix4();

		return function worldToLocal( vector ) {

			return vector.applyMatrix4( m1.getInverse( this.matrixWorld ) );

		};

	}(),

	lookAt: function () {

		// This routine does not support objects with rotated and/or translated parent(s)

		var m1 = new Matrix4();

		return function lookAt( vector ) {

			m1.lookAt( vector, this.position, this.up );

			this.quaternion.setFromRotationMatrix( m1 );

		};

	}(),

	add: function ( object ) {

		if ( arguments.length > 1 ) {

			for ( var i = 0; i < arguments.length; i ++ ) {

				this.add( arguments[ i ] );

			}

			return this;

		}

		if ( object === this ) {

			console.error( "THREE.Object3D.add: object can't be added as a child of itself.", object );
			return this;

		}

		if ( ( object && object.isObject3D ) ) {

			if ( object.parent !== null ) {

				object.parent.remove( object );

			}

			object.parent = this;
			object.dispatchEvent( { type: 'added' } );

			this.children.push( object );

		} else {

			console.error( "THREE.Object3D.add: object not an instance of THREE.Object3D.", object );

		}

		return this;

	},

	remove: function ( object ) {

		if ( arguments.length > 1 ) {

			for ( var i = 0; i < arguments.length; i ++ ) {

				this.remove( arguments[ i ] );

			}

		}

		var index = this.children.indexOf( object );

		if ( index !== - 1 ) {

			object.parent = null;

			object.dispatchEvent( { type: 'removed' } );

			this.children.splice( index, 1 );

		}

	},

	getObjectById: function ( id ) {

		return this.getObjectByProperty( 'id', id );

	},

	getObjectByName: function ( name ) {

		return this.getObjectByProperty( 'name', name );

	},

	getObjectByProperty: function ( name, value ) {

		if ( this[ name ] === value ) return this;

		for ( var i = 0, l = this.children.length; i < l; i ++ ) {

			var child = this.children[ i ];
			var object = child.getObjectByProperty( name, value );

			if ( object !== undefined ) {

				return object;

			}

		}

		return undefined;

	},

	getWorldPosition: function ( optionalTarget ) {

		var result = optionalTarget || new Vector3();

		this.updateMatrixWorld( true );

		return result.setFromMatrixPosition( this.matrixWorld );

	},

	getWorldQuaternion: function () {

		var position = new Vector3();
		var scale = new Vector3();

		return function getWorldQuaternion( optionalTarget ) {

			var result = optionalTarget || new Quaternion();

			this.updateMatrixWorld( true );

			this.matrixWorld.decompose( position, result, scale );

			return result;

		};

	}(),

	getWorldRotation: function () {

		var quaternion = new Quaternion();

		return function getWorldRotation( optionalTarget ) {

			var result = optionalTarget || new Euler();

			this.getWorldQuaternion( quaternion );

			return result.setFromQuaternion( quaternion, this.rotation.order, false );

		};

	}(),

	getWorldScale: function () {

		var position = new Vector3();
		var quaternion = new Quaternion();

		return function getWorldScale( optionalTarget ) {

			var result = optionalTarget || new Vector3();

			this.updateMatrixWorld( true );

			this.matrixWorld.decompose( position, quaternion, result );

			return result;

		};

	}(),

	getWorldDirection: function () {

		var quaternion = new Quaternion();

		return function getWorldDirection( optionalTarget ) {

			var result = optionalTarget || new Vector3();

			this.getWorldQuaternion( quaternion );

			return result.set( 0, 0, 1 ).applyQuaternion( quaternion );

		};

	}(),

	raycast: function () {},

	traverse: function ( callback ) {

		callback( this );

		var children = this.children;

		for ( var i = 0, l = children.length; i < l; i ++ ) {

			children[ i ].traverse( callback );

		}

	},

	traverseVisible: function ( callback ) {

		if ( this.visible === false ) return;

		callback( this );

		var children = this.children;

		for ( var i = 0, l = children.length; i < l; i ++ ) {

			children[ i ].traverseVisible( callback );

		}

	},

	traverseAncestors: function ( callback ) {

		var parent = this.parent;

		if ( parent !== null ) {

			callback( parent );

			parent.traverseAncestors( callback );

		}

	},

	updateMatrix: function () {

		this.matrix.compose( this.position, this.quaternion, this.scale );

		this.matrixWorldNeedsUpdate = true;

	},

	updateMatrixWorld: function ( force ) {

		if ( this.matrixAutoUpdate === true ) this.updateMatrix();

		if ( this.matrixWorldNeedsUpdate === true || force === true ) {

			if ( this.parent === null ) {

				this.matrixWorld.copy( this.matrix );

			} else {

				this.matrixWorld.multiplyMatrices( this.parent.matrixWorld, this.matrix );

			}

			this.matrixWorldNeedsUpdate = false;

			force = true;

		}

		// update children

		var children = this.children;

		for ( var i = 0, l = children.length; i < l; i ++ ) {

			children[ i ].updateMatrixWorld( force );

		}

	},

	toJSON: function ( meta ) {

		// meta is '' when called from JSON.stringify
		var isRootObject = ( meta === undefined || meta === '' );

		var output = {};

		// meta is a hash used to collect geometries, materials.
		// not providing it implies that this is the root object
		// being serialized.
		if ( isRootObject ) {

			// initialize meta obj
			meta = {
				geometries: {},
				materials: {},
				textures: {},
				images: {}
			};

			output.metadata = {
				version: 4.4,
				type: 'Object',
				generator: 'Object3D.toJSON'
			};

		}

		// standard Object3D serialization

		var object = {};

		object.uuid = this.uuid;
		object.type = this.type;

		if ( this.name !== '' ) object.name = this.name;
		if ( JSON.stringify( this.userData ) !== '{}' ) object.userData = this.userData;
		if ( this.castShadow === true ) object.castShadow = true;
		if ( this.receiveShadow === true ) object.receiveShadow = true;
		if ( this.visible === false ) object.visible = false;

		object.matrix = this.matrix.toArray();

		//

		if ( this.geometry !== undefined ) {

			if ( meta.geometries[ this.geometry.uuid ] === undefined ) {

				meta.geometries[ this.geometry.uuid ] = this.geometry.toJSON( meta );

			}

			object.geometry = this.geometry.uuid;

		}

		if ( this.material !== undefined ) {

			if ( meta.materials[ this.material.uuid ] === undefined ) {

				meta.materials[ this.material.uuid ] = this.material.toJSON( meta );

			}

			object.material = this.material.uuid;

		}

		//

		if ( this.children.length > 0 ) {

			object.children = [];

			for ( var i = 0; i < this.children.length; i ++ ) {

				object.children.push( this.children[ i ].toJSON( meta ).object );

			}

		}

		if ( isRootObject ) {

			var geometries = extractFromCache( meta.geometries );
			var materials = extractFromCache( meta.materials );
			var textures = extractFromCache( meta.textures );
			var images = extractFromCache( meta.images );

			if ( geometries.length > 0 ) output.geometries = geometries;
			if ( materials.length > 0 ) output.materials = materials;
			if ( textures.length > 0 ) output.textures = textures;
			if ( images.length > 0 ) output.images = images;

		}

		output.object = object;

		return output;

		// extract data from the cache hash
		// remove metadata on each item
		// and return as array
		function extractFromCache( cache ) {

			var values = [];
			for ( var key in cache ) {

				var data = cache[ key ];
				delete data.metadata;
				values.push( data );

			}
			return values;

		}

	},

	clone: function ( recursive ) {

		return new this.constructor().copy( this, recursive );

	},

	copy: function ( source, recursive ) {

		if ( recursive === undefined ) recursive = true;

		this.name = source.name;

		this.up.copy( source.up );

		this.position.copy( source.position );
		this.quaternion.copy( source.quaternion );
		this.scale.copy( source.scale );

		this.matrix.copy( source.matrix );
		this.matrixWorld.copy( source.matrixWorld );

		this.matrixAutoUpdate = source.matrixAutoUpdate;
		this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;

		this.layers.mask = source.layers.mask;
		this.visible = source.visible;

		this.castShadow = source.castShadow;
		this.receiveShadow = source.receiveShadow;

		this.frustumCulled = source.frustumCulled;
		this.renderOrder = source.renderOrder;

		this.userData = JSON.parse( JSON.stringify( source.userData ) );

		if ( recursive === true ) {

			for ( var i = 0; i < source.children.length; i ++ ) {

				var child = source.children[ i ];
				this.add( child.clone() );

			}

		}

		return this;

	}

} );

/**
 * @author bhouston / http://clara.io
 */

function Line3( start, end ) {

	this.start = ( start !== undefined ) ? start : new Vector3();
	this.end = ( end !== undefined ) ? end : new Vector3();

}

Line3.prototype = {

	constructor: Line3,

	set: function ( start, end ) {

		this.start.copy( start );
		this.end.copy( end );

		return this;

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( line ) {

		this.start.copy( line.start );
		this.end.copy( line.end );

		return this;

	},

	getCenter: function ( optionalTarget ) {

		var result = optionalTarget || new Vector3();
		return result.addVectors( this.start, this.end ).multiplyScalar( 0.5 );

	},

	delta: function ( optionalTarget ) {

		var result = optionalTarget || new Vector3();
		return result.subVectors( this.end, this.start );

	},

	distanceSq: function () {

		return this.start.distanceToSquared( this.end );

	},

	distance: function () {

		return this.start.distanceTo( this.end );

	},

	at: function ( t, optionalTarget ) {

		var result = optionalTarget || new Vector3();

		return this.delta( result ).multiplyScalar( t ).add( this.start );

	},

	closestPointToPointParameter: function () {

		var startP = new Vector3();
		var startEnd = new Vector3();

		return function closestPointToPointParameter( point, clampToLine ) {

			startP.subVectors( point, this.start );
			startEnd.subVectors( this.end, this.start );

			var startEnd2 = startEnd.dot( startEnd );
			var startEnd_startP = startEnd.dot( startP );

			var t = startEnd_startP / startEnd2;

			if ( clampToLine ) {

				t = _Math.clamp( t, 0, 1 );

			}

			return t;

		};

	}(),

	closestPointToPoint: function ( point, clampToLine, optionalTarget ) {

		var t = this.closestPointToPointParameter( point, clampToLine );

		var result = optionalTarget || new Vector3();

		return this.delta( result ).multiplyScalar( t ).add( this.start );

	},

	applyMatrix4: function ( matrix ) {

		this.start.applyMatrix4( matrix );
		this.end.applyMatrix4( matrix );

		return this;

	},

	equals: function ( line ) {

		return line.start.equals( this.start ) && line.end.equals( this.end );

	}

};

/**
 * @author bhouston / http://clara.io
 * @author mrdoob / http://mrdoob.com/
 */

function Triangle( a, b, c ) {

	this.a = ( a !== undefined ) ? a : new Vector3();
	this.b = ( b !== undefined ) ? b : new Vector3();
	this.c = ( c !== undefined ) ? c : new Vector3();

}

Triangle.normal = function () {

	var v0 = new Vector3();

	return function normal( a, b, c, optionalTarget ) {

		var result = optionalTarget || new Vector3();

		result.subVectors( c, b );
		v0.subVectors( a, b );
		result.cross( v0 );

		var resultLengthSq = result.lengthSq();
		if ( resultLengthSq > 0 ) {

			return result.multiplyScalar( 1 / Math.sqrt( resultLengthSq ) );

		}

		return result.set( 0, 0, 0 );

	};

}();

// static/instance method to calculate barycentric coordinates
// based on: http://www.blackpawn.com/texts/pointinpoly/default.html
Triangle.barycoordFromPoint = function () {

	var v0 = new Vector3();
	var v1 = new Vector3();
	var v2 = new Vector3();

	return function barycoordFromPoint( point, a, b, c, optionalTarget ) {

		v0.subVectors( c, a );
		v1.subVectors( b, a );
		v2.subVectors( point, a );

		var dot00 = v0.dot( v0 );
		var dot01 = v0.dot( v1 );
		var dot02 = v0.dot( v2 );
		var dot11 = v1.dot( v1 );
		var dot12 = v1.dot( v2 );

		var denom = ( dot00 * dot11 - dot01 * dot01 );

		var result = optionalTarget || new Vector3();

		// collinear or singular triangle
		if ( denom === 0 ) {

			// arbitrary location outside of triangle?
			// not sure if this is the best idea, maybe should be returning undefined
			return result.set( - 2, - 1, - 1 );

		}

		var invDenom = 1 / denom;
		var u = ( dot11 * dot02 - dot01 * dot12 ) * invDenom;
		var v = ( dot00 * dot12 - dot01 * dot02 ) * invDenom;

		// barycentric coordinates must always sum to 1
		return result.set( 1 - u - v, v, u );

	};

}();

Triangle.containsPoint = function () {

	var v1 = new Vector3();

	return function containsPoint( point, a, b, c ) {

		var result = Triangle.barycoordFromPoint( point, a, b, c, v1 );

		return ( result.x >= 0 ) && ( result.y >= 0 ) && ( ( result.x + result.y ) <= 1 );

	};

}();

Triangle.prototype = {

	constructor: Triangle,

	set: function ( a, b, c ) {

		this.a.copy( a );
		this.b.copy( b );
		this.c.copy( c );

		return this;

	},

	setFromPointsAndIndices: function ( points, i0, i1, i2 ) {

		this.a.copy( points[ i0 ] );
		this.b.copy( points[ i1 ] );
		this.c.copy( points[ i2 ] );

		return this;

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( triangle ) {

		this.a.copy( triangle.a );
		this.b.copy( triangle.b );
		this.c.copy( triangle.c );

		return this;

	},

	area: function () {

		var v0 = new Vector3();
		var v1 = new Vector3();

		return function area() {

			v0.subVectors( this.c, this.b );
			v1.subVectors( this.a, this.b );

			return v0.cross( v1 ).length() * 0.5;

		};

	}(),

	midpoint: function ( optionalTarget ) {

		var result = optionalTarget || new Vector3();
		return result.addVectors( this.a, this.b ).add( this.c ).multiplyScalar( 1 / 3 );

	},

	normal: function ( optionalTarget ) {

		return Triangle.normal( this.a, this.b, this.c, optionalTarget );

	},

	plane: function ( optionalTarget ) {

		var result = optionalTarget || new Plane();

		return result.setFromCoplanarPoints( this.a, this.b, this.c );

	},

	barycoordFromPoint: function ( point, optionalTarget ) {

		return Triangle.barycoordFromPoint( point, this.a, this.b, this.c, optionalTarget );

	},

	containsPoint: function ( point ) {

		return Triangle.containsPoint( point, this.a, this.b, this.c );

	},

	closestPointToPoint: function () {

		var plane, edgeList, projectedPoint, closestPoint;

		return function closestPointToPoint( point, optionalTarget ) {

			if ( plane === undefined ) {

				plane = new Plane();
				edgeList = [ new Line3(), new Line3(), new Line3() ];
				projectedPoint = new Vector3();
				closestPoint = new Vector3();

			}

			var result = optionalTarget || new Vector3();
			var minDistance = Infinity;

			// project the point onto the plane of the triangle

			plane.setFromCoplanarPoints( this.a, this.b, this.c );
			plane.projectPoint( point, projectedPoint );

			// check if the projection lies within the triangle

			if( this.containsPoint( projectedPoint ) === true ) {

				// if so, this is the closest point

				result.copy( projectedPoint );

			} else {

				// if not, the point falls outside the triangle. the result is the closest point to the triangle's edges or vertices

				edgeList[ 0 ].set( this.a, this.b );
				edgeList[ 1 ].set( this.b, this.c );
				edgeList[ 2 ].set( this.c, this.a );

				for( var i = 0; i < edgeList.length; i ++ ) {

					edgeList[ i ].closestPointToPoint( projectedPoint, true, closestPoint );

					var distance = projectedPoint.distanceToSquared( closestPoint );

					if( distance < minDistance ) {

						minDistance = distance;

						result.copy( closestPoint );

					}

				}

			}

			return result;

		};

	}(),

	equals: function ( triangle ) {

		return triangle.a.equals( this.a ) && triangle.b.equals( this.b ) && triangle.c.equals( this.c );

	}

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 */

function Face3( a, b, c, normal, color, materialIndex ) {

	this.a = a;
	this.b = b;
	this.c = c;

	this.normal = (normal && normal.isVector3) ? normal : new Vector3();
	this.vertexNormals = Array.isArray( normal ) ? normal : [];

	this.color = (color && color.isColor) ? color : new Color();
	this.vertexColors = Array.isArray( color ) ? color : [];

	this.materialIndex = materialIndex !== undefined ? materialIndex : 0;

}

Face3.prototype = {

	constructor: Face3,

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( source ) {

		this.a = source.a;
		this.b = source.b;
		this.c = source.c;

		this.normal.copy( source.normal );
		this.color.copy( source.color );

		this.materialIndex = source.materialIndex;

		for ( var i = 0, il = source.vertexNormals.length; i < il; i ++ ) {

			this.vertexNormals[ i ] = source.vertexNormals[ i ].clone();

		}

		for ( var i = 0, il = source.vertexColors.length; i < il; i ++ ) {

			this.vertexColors[ i ] = source.vertexColors[ i ].clone();

		}

		return this;

	}

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  shading: THREE.SmoothShading,
 *  depthTest: <bool>,
 *  depthWrite: <bool>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>
 * }
 */

function MeshBasicMaterial( parameters ) {

	Material.call( this );

	this.type = 'MeshBasicMaterial';

	this.color = new Color( 0xffffff ); // emissive

	this.map = null;

	this.lightMap = null;
	this.lightMapIntensity = 1.0;

	this.aoMap = null;
	this.aoMapIntensity = 1.0;

	this.specularMap = null;

	this.alphaMap = null;

	this.envMap = null;
	this.combine = MultiplyOperation;
	this.reflectivity = 1;
	this.refractionRatio = 0.98;

	this.wireframe = false;
	this.wireframeLinewidth = 1;
	this.wireframeLinecap = 'round';
	this.wireframeLinejoin = 'round';

	this.skinning = false;
	this.morphTargets = false;

	this.lights = false;

	this.setValues( parameters );

}

MeshBasicMaterial.prototype = Object.create( Material.prototype );
MeshBasicMaterial.prototype.constructor = MeshBasicMaterial;

MeshBasicMaterial.prototype.isMeshBasicMaterial = true;

MeshBasicMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.color.copy( source.color );

	this.map = source.map;

	this.lightMap = source.lightMap;
	this.lightMapIntensity = source.lightMapIntensity;

	this.aoMap = source.aoMap;
	this.aoMapIntensity = source.aoMapIntensity;

	this.specularMap = source.specularMap;

	this.alphaMap = source.alphaMap;

	this.envMap = source.envMap;
	this.combine = source.combine;
	this.reflectivity = source.reflectivity;
	this.refractionRatio = source.refractionRatio;

	this.wireframe = source.wireframe;
	this.wireframeLinewidth = source.wireframeLinewidth;
	this.wireframeLinecap = source.wireframeLinecap;
	this.wireframeLinejoin = source.wireframeLinejoin;

	this.skinning = source.skinning;
	this.morphTargets = source.morphTargets;

	return this;

};

/**
 * @author mrdoob / http://mrdoob.com/
 */

function BufferAttribute( array, itemSize, normalized ) {

	if ( Array.isArray( array ) ) {

		throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );

	}

	this.uuid = _Math.generateUUID();

	this.array = array;
	this.itemSize = itemSize;
	this.count = array !== undefined ? array.length / itemSize : 0;
	this.normalized = normalized === true;

	this.dynamic = false;
	this.updateRange = { offset: 0, count: - 1 };

	this.onUploadCallback = function () {};

	this.version = 0;

}

BufferAttribute.prototype = {

	constructor: BufferAttribute,

	isBufferAttribute: true,

	set needsUpdate( value ) {

		if ( value === true ) this.version ++;

	},

	setArray: function ( array ) {

		if ( Array.isArray( array ) ) {

			throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );

		}

		this.count = array !== undefined ? array.length / this.itemSize : 0;
		this.array = array;

	},

	setDynamic: function ( value ) {

		this.dynamic = value;

		return this;

	},

	copy: function ( source ) {

		this.array = new source.array.constructor( source.array );
		this.itemSize = source.itemSize;
		this.count = source.count;
		this.normalized = source.normalized;

		this.dynamic = source.dynamic;

		return this;

	},

	copyAt: function ( index1, attribute, index2 ) {

		index1 *= this.itemSize;
		index2 *= attribute.itemSize;

		for ( var i = 0, l = this.itemSize; i < l; i ++ ) {

			this.array[ index1 + i ] = attribute.array[ index2 + i ];

		}

		return this;

	},

	copyArray: function ( array ) {

		this.array.set( array );

		return this;

	},

	copyColorsArray: function ( colors ) {

		var array = this.array, offset = 0;

		for ( var i = 0, l = colors.length; i < l; i ++ ) {

			var color = colors[ i ];

			if ( color === undefined ) {

				console.warn( 'THREE.BufferAttribute.copyColorsArray(): color is undefined', i );
				color = new Color();

			}

			array[ offset ++ ] = color.r;
			array[ offset ++ ] = color.g;
			array[ offset ++ ] = color.b;

		}

		return this;

	},

	copyIndicesArray: function ( indices ) {

		var array = this.array, offset = 0;

		for ( var i = 0, l = indices.length; i < l; i ++ ) {

			var index = indices[ i ];

			array[ offset ++ ] = index.a;
			array[ offset ++ ] = index.b;
			array[ offset ++ ] = index.c;

		}

		return this;

	},

	copyVector2sArray: function ( vectors ) {

		var array = this.array, offset = 0;

		for ( var i = 0, l = vectors.length; i < l; i ++ ) {

			var vector = vectors[ i ];

			if ( vector === undefined ) {

				console.warn( 'THREE.BufferAttribute.copyVector2sArray(): vector is undefined', i );
				vector = new Vector2();

			}

			array[ offset ++ ] = vector.x;
			array[ offset ++ ] = vector.y;

		}

		return this;

	},

	copyVector3sArray: function ( vectors ) {

		var array = this.array, offset = 0;

		for ( var i = 0, l = vectors.length; i < l; i ++ ) {

			var vector = vectors[ i ];

			if ( vector === undefined ) {

				console.warn( 'THREE.BufferAttribute.copyVector3sArray(): vector is undefined', i );
				vector = new Vector3();

			}

			array[ offset ++ ] = vector.x;
			array[ offset ++ ] = vector.y;
			array[ offset ++ ] = vector.z;

		}

		return this;

	},

	copyVector4sArray: function ( vectors ) {

		var array = this.array, offset = 0;

		for ( var i = 0, l = vectors.length; i < l; i ++ ) {

			var vector = vectors[ i ];

			if ( vector === undefined ) {

				console.warn( 'THREE.BufferAttribute.copyVector4sArray(): vector is undefined', i );
				vector = new Vector4();

			}

			array[ offset ++ ] = vector.x;
			array[ offset ++ ] = vector.y;
			array[ offset ++ ] = vector.z;
			array[ offset ++ ] = vector.w;

		}

		return this;

	},

	set: function ( value, offset ) {

		if ( offset === undefined ) offset = 0;

		this.array.set( value, offset );

		return this;

	},

	getX: function ( index ) {

		return this.array[ index * this.itemSize ];

	},

	setX: function ( index, x ) {

		this.array[ index * this.itemSize ] = x;

		return this;

	},

	getY: function ( index ) {

		return this.array[ index * this.itemSize + 1 ];

	},

	setY: function ( index, y ) {

		this.array[ index * this.itemSize + 1 ] = y;

		return this;

	},

	getZ: function ( index ) {

		return this.array[ index * this.itemSize + 2 ];

	},

	setZ: function ( index, z ) {

		this.array[ index * this.itemSize + 2 ] = z;

		return this;

	},

	getW: function ( index ) {

		return this.array[ index * this.itemSize + 3 ];

	},

	setW: function ( index, w ) {

		this.array[ index * this.itemSize + 3 ] = w;

		return this;

	},

	setXY: function ( index, x, y ) {

		index *= this.itemSize;

		this.array[ index + 0 ] = x;
		this.array[ index + 1 ] = y;

		return this;

	},

	setXYZ: function ( index, x, y, z ) {

		index *= this.itemSize;

		this.array[ index + 0 ] = x;
		this.array[ index + 1 ] = y;
		this.array[ index + 2 ] = z;

		return this;

	},

	setXYZW: function ( index, x, y, z, w ) {

		index *= this.itemSize;

		this.array[ index + 0 ] = x;
		this.array[ index + 1 ] = y;
		this.array[ index + 2 ] = z;
		this.array[ index + 3 ] = w;

		return this;

	},

	onUpload: function ( callback ) {

		this.onUploadCallback = callback;

		return this;

	},

	clone: function () {

		return new this.constructor().copy( this );

	}

};

//

function Int8BufferAttribute( array, itemSize ) {

	BufferAttribute.call( this, new Int8Array( array ), itemSize );

}

Int8BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
Int8BufferAttribute.prototype.constructor = Int8BufferAttribute;


function Uint8BufferAttribute( array, itemSize ) {

	BufferAttribute.call( this, new Uint8Array( array ), itemSize );

}

Uint8BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
Uint8BufferAttribute.prototype.constructor = Uint8BufferAttribute;


function Uint8ClampedBufferAttribute( array, itemSize ) {

	BufferAttribute.call( this, new Uint8ClampedArray( array ), itemSize );

}

Uint8ClampedBufferAttribute.prototype = Object.create( BufferAttribute.prototype );
Uint8ClampedBufferAttribute.prototype.constructor = Uint8ClampedBufferAttribute;


function Int16BufferAttribute( array, itemSize ) {

	BufferAttribute.call( this, new Int16Array( array ), itemSize );

}

Int16BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
Int16BufferAttribute.prototype.constructor = Int16BufferAttribute;


function Uint16BufferAttribute( array, itemSize ) {

	BufferAttribute.call( this, new Uint16Array( array ), itemSize );

}

Uint16BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
Uint16BufferAttribute.prototype.constructor = Uint16BufferAttribute;


function Int32BufferAttribute( array, itemSize ) {

	BufferAttribute.call( this, new Int32Array( array ), itemSize );

}

Int32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
Int32BufferAttribute.prototype.constructor = Int32BufferAttribute;


function Uint32BufferAttribute( array, itemSize ) {

	BufferAttribute.call( this, new Uint32Array( array ), itemSize );

}

Uint32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
Uint32BufferAttribute.prototype.constructor = Uint32BufferAttribute;


function Float32BufferAttribute( array, itemSize ) {

	BufferAttribute.call( this, new Float32Array( array ), itemSize );

}

Float32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
Float32BufferAttribute.prototype.constructor = Float32BufferAttribute;


function Float64BufferAttribute( array, itemSize ) {

	BufferAttribute.call( this, new Float64Array( array ), itemSize );

}

Float64BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
Float64BufferAttribute.prototype.constructor = Float64BufferAttribute;

/**
 * @author mrdoob / http://mrdoob.com/
 */

function DirectGeometry() {

	this.indices = [];
	this.vertices = [];
	this.normals = [];
	this.colors = [];
	this.uvs = [];
	this.uvs2 = [];

	this.groups = [];

	this.morphTargets = {};

	this.skinWeights = [];
	this.skinIndices = [];

	// this.lineDistances = [];

	this.boundingBox = null;
	this.boundingSphere = null;

	// update flags

	this.verticesNeedUpdate = false;
	this.normalsNeedUpdate = false;
	this.colorsNeedUpdate = false;
	this.uvsNeedUpdate = false;
	this.groupsNeedUpdate = false;

}

Object.assign( DirectGeometry.prototype, {

	computeGroups: function ( geometry ) {

		var group;
		var groups = [];
		var materialIndex = undefined;

		var faces = geometry.faces;

		for ( var i = 0; i < faces.length; i ++ ) {

			var face = faces[ i ];

			// materials

			if ( face.materialIndex !== materialIndex ) {

				materialIndex = face.materialIndex;

				if ( group !== undefined ) {

					group.count = ( i * 3 ) - group.start;
					groups.push( group );

				}

				group = {
					start: i * 3,
					materialIndex: materialIndex
				};

			}

		}

		if ( group !== undefined ) {

			group.count = ( i * 3 ) - group.start;
			groups.push( group );

		}

		this.groups = groups;

	},

	fromGeometry: function ( geometry ) {

		var faces = geometry.faces;
		var vertices = geometry.vertices;
		var faceVertexUvs = geometry.faceVertexUvs;

		var hasFaceVertexUv = faceVertexUvs[ 0 ] && faceVertexUvs[ 0 ].length > 0;
		var hasFaceVertexUv2 = faceVertexUvs[ 1 ] && faceVertexUvs[ 1 ].length > 0;

		// morphs

		var morphTargets = geometry.morphTargets;
		var morphTargetsLength = morphTargets.length;

		var morphTargetsPosition;

		if ( morphTargetsLength > 0 ) {

			morphTargetsPosition = [];

			for ( var i = 0; i < morphTargetsLength; i ++ ) {

				morphTargetsPosition[ i ] = [];

			}

			this.morphTargets.position = morphTargetsPosition;

		}

		var morphNormals = geometry.morphNormals;
		var morphNormalsLength = morphNormals.length;

		var morphTargetsNormal;

		if ( morphNormalsLength > 0 ) {

			morphTargetsNormal = [];

			for ( var i = 0; i < morphNormalsLength; i ++ ) {

				morphTargetsNormal[ i ] = [];

			}

			this.morphTargets.normal = morphTargetsNormal;

		}

		// skins

		var skinIndices = geometry.skinIndices;
		var skinWeights = geometry.skinWeights;

		var hasSkinIndices = skinIndices.length === vertices.length;
		var hasSkinWeights = skinWeights.length === vertices.length;

		//

		for ( var i = 0; i < faces.length; i ++ ) {

			var face = faces[ i ];

			this.vertices.push( vertices[ face.a ], vertices[ face.b ], vertices[ face.c ] );

			var vertexNormals = face.vertexNormals;

			if ( vertexNormals.length === 3 ) {

				this.normals.push( vertexNormals[ 0 ], vertexNormals[ 1 ], vertexNormals[ 2 ] );

			} else {

				var normal = face.normal;

				this.normals.push( normal, normal, normal );

			}

			var vertexColors = face.vertexColors;

			if ( vertexColors.length === 3 ) {

				this.colors.push( vertexColors[ 0 ], vertexColors[ 1 ], vertexColors[ 2 ] );

			} else {

				var color = face.color;

				this.colors.push( color, color, color );

			}

			if ( hasFaceVertexUv === true ) {

				var vertexUvs = faceVertexUvs[ 0 ][ i ];

				if ( vertexUvs !== undefined ) {

					this.uvs.push( vertexUvs[ 0 ], vertexUvs[ 1 ], vertexUvs[ 2 ] );

				} else {

					console.warn( 'THREE.DirectGeometry.fromGeometry(): Undefined vertexUv ', i );

					this.uvs.push( new Vector2(), new Vector2(), new Vector2() );

				}

			}

			if ( hasFaceVertexUv2 === true ) {

				var vertexUvs = faceVertexUvs[ 1 ][ i ];

				if ( vertexUvs !== undefined ) {

					this.uvs2.push( vertexUvs[ 0 ], vertexUvs[ 1 ], vertexUvs[ 2 ] );

				} else {

					console.warn( 'THREE.DirectGeometry.fromGeometry(): Undefined vertexUv2 ', i );

					this.uvs2.push( new Vector2(), new Vector2(), new Vector2() );

				}

			}

			// morphs

			for ( var j = 0; j < morphTargetsLength; j ++ ) {

				var morphTarget = morphTargets[ j ].vertices;

				morphTargetsPosition[ j ].push( morphTarget[ face.a ], morphTarget[ face.b ], morphTarget[ face.c ] );

			}

			for ( var j = 0; j < morphNormalsLength; j ++ ) {

				var morphNormal = morphNormals[ j ].vertexNormals[ i ];

				morphTargetsNormal[ j ].push( morphNormal.a, morphNormal.b, morphNormal.c );

			}

			// skins

			if ( hasSkinIndices ) {

				this.skinIndices.push( skinIndices[ face.a ], skinIndices[ face.b ], skinIndices[ face.c ] );

			}

			if ( hasSkinWeights ) {

				this.skinWeights.push( skinWeights[ face.a ], skinWeights[ face.b ], skinWeights[ face.c ] );

			}

		}

		this.computeGroups( geometry );

		this.verticesNeedUpdate = geometry.verticesNeedUpdate;
		this.normalsNeedUpdate = geometry.normalsNeedUpdate;
		this.colorsNeedUpdate = geometry.colorsNeedUpdate;
		this.uvsNeedUpdate = geometry.uvsNeedUpdate;
		this.groupsNeedUpdate = geometry.groupsNeedUpdate;

		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author kile / http://kile.stravaganza.org/
 * @author alteredq / http://alteredqualia.com/
 * @author mikael emtinger / http://gomo.se/
 * @author zz85 / http://www.lab4games.net/zz85/blog
 * @author bhouston / http://clara.io
 */

function Geometry() {

	Object.defineProperty( this, 'id', { value: GeometryIdCount() } );

	this.uuid = _Math.generateUUID();

	this.name = '';
	this.type = 'Geometry';

	this.vertices = [];
	this.colors = [];
	this.faces = [];
	this.faceVertexUvs = [ [] ];

	this.morphTargets = [];
	this.morphNormals = [];

	this.skinWeights = [];
	this.skinIndices = [];

	this.lineDistances = [];

	this.boundingBox = null;
	this.boundingSphere = null;

	// update flags

	this.elementsNeedUpdate = false;
	this.verticesNeedUpdate = false;
	this.uvsNeedUpdate = false;
	this.normalsNeedUpdate = false;
	this.colorsNeedUpdate = false;
	this.lineDistancesNeedUpdate = false;
	this.groupsNeedUpdate = false;

}

Object.assign( Geometry.prototype, EventDispatcher.prototype, {

	isGeometry: true,

	applyMatrix: function ( matrix ) {

		var normalMatrix = new Matrix3().getNormalMatrix( matrix );

		for ( var i = 0, il = this.vertices.length; i < il; i ++ ) {

			var vertex = this.vertices[ i ];
			vertex.applyMatrix4( matrix );

		}

		for ( var i = 0, il = this.faces.length; i < il; i ++ ) {

			var face = this.faces[ i ];
			face.normal.applyMatrix3( normalMatrix ).normalize();

			for ( var j = 0, jl = face.vertexNormals.length; j < jl; j ++ ) {

				face.vertexNormals[ j ].applyMatrix3( normalMatrix ).normalize();

			}

		}

		if ( this.boundingBox !== null ) {

			this.computeBoundingBox();

		}

		if ( this.boundingSphere !== null ) {

			this.computeBoundingSphere();

		}

		this.verticesNeedUpdate = true;
		this.normalsNeedUpdate = true;

		return this;

	},

	rotateX: function () {

		// rotate geometry around world x-axis

		var m1;

		return function rotateX( angle ) {

			if ( m1 === undefined ) m1 = new Matrix4();

			m1.makeRotationX( angle );

			this.applyMatrix( m1 );

			return this;

		};

	}(),

	rotateY: function () {

		// rotate geometry around world y-axis

		var m1;

		return function rotateY( angle ) {

			if ( m1 === undefined ) m1 = new Matrix4();

			m1.makeRotationY( angle );

			this.applyMatrix( m1 );

			return this;

		};

	}(),

	rotateZ: function () {

		// rotate geometry around world z-axis

		var m1;

		return function rotateZ( angle ) {

			if ( m1 === undefined ) m1 = new Matrix4();

			m1.makeRotationZ( angle );

			this.applyMatrix( m1 );

			return this;

		};

	}(),

	translate: function () {

		// translate geometry

		var m1;

		return function translate( x, y, z ) {

			if ( m1 === undefined ) m1 = new Matrix4();

			m1.makeTranslation( x, y, z );

			this.applyMatrix( m1 );

			return this;

		};

	}(),

	scale: function () {

		// scale geometry

		var m1;

		return function scale( x, y, z ) {

			if ( m1 === undefined ) m1 = new Matrix4();

			m1.makeScale( x, y, z );

			this.applyMatrix( m1 );

			return this;

		};

	}(),

	lookAt: function () {

		var obj;

		return function lookAt( vector ) {

			if ( obj === undefined ) obj = new Object3D();

			obj.lookAt( vector );

			obj.updateMatrix();

			this.applyMatrix( obj.matrix );

		};

	}(),

	fromBufferGeometry: function ( geometry ) {

		var scope = this;

		var indices = geometry.index !== null ? geometry.index.array : undefined;
		var attributes = geometry.attributes;

		var positions = attributes.position.array;
		var normals = attributes.normal !== undefined ? attributes.normal.array : undefined;
		var colors = attributes.color !== undefined ? attributes.color.array : undefined;
		var uvs = attributes.uv !== undefined ? attributes.uv.array : undefined;
		var uvs2 = attributes.uv2 !== undefined ? attributes.uv2.array : undefined;

		if ( uvs2 !== undefined ) this.faceVertexUvs[ 1 ] = [];

		var tempNormals = [];
		var tempUVs = [];
		var tempUVs2 = [];

		for ( var i = 0, j = 0; i < positions.length; i += 3, j += 2 ) {

			scope.vertices.push( new Vector3( positions[ i ], positions[ i + 1 ], positions[ i + 2 ] ) );

			if ( normals !== undefined ) {

				tempNormals.push( new Vector3( normals[ i ], normals[ i + 1 ], normals[ i + 2 ] ) );

			}

			if ( colors !== undefined ) {

				scope.colors.push( new Color( colors[ i ], colors[ i + 1 ], colors[ i + 2 ] ) );

			}

			if ( uvs !== undefined ) {

				tempUVs.push( new Vector2( uvs[ j ], uvs[ j + 1 ] ) );

			}

			if ( uvs2 !== undefined ) {

				tempUVs2.push( new Vector2( uvs2[ j ], uvs2[ j + 1 ] ) );

			}

		}

		function addFace( a, b, c, materialIndex ) {

			var vertexNormals = normals !== undefined ? [ tempNormals[ a ].clone(), tempNormals[ b ].clone(), tempNormals[ c ].clone() ] : [];
			var vertexColors = colors !== undefined ? [ scope.colors[ a ].clone(), scope.colors[ b ].clone(), scope.colors[ c ].clone() ] : [];

			var face = new Face3( a, b, c, vertexNormals, vertexColors, materialIndex );

			scope.faces.push( face );

			if ( uvs !== undefined ) {

				scope.faceVertexUvs[ 0 ].push( [ tempUVs[ a ].clone(), tempUVs[ b ].clone(), tempUVs[ c ].clone() ] );

			}

			if ( uvs2 !== undefined ) {

				scope.faceVertexUvs[ 1 ].push( [ tempUVs2[ a ].clone(), tempUVs2[ b ].clone(), tempUVs2[ c ].clone() ] );

			}

		}

		if ( indices !== undefined ) {

			var groups = geometry.groups;

			if ( groups.length > 0 ) {

				for ( var i = 0; i < groups.length; i ++ ) {

					var group = groups[ i ];

					var start = group.start;
					var count = group.count;

					for ( var j = start, jl = start + count; j < jl; j += 3 ) {

						addFace( indices[ j ], indices[ j + 1 ], indices[ j + 2 ], group.materialIndex  );

					}

				}

			} else {

				for ( var i = 0; i < indices.length; i += 3 ) {

					addFace( indices[ i ], indices[ i + 1 ], indices[ i + 2 ] );

				}

			}

		} else {

			for ( var i = 0; i < positions.length / 3; i += 3 ) {

				addFace( i, i + 1, i + 2 );

			}

		}

		this.computeFaceNormals();

		if ( geometry.boundingBox !== null ) {

			this.boundingBox = geometry.boundingBox.clone();

		}

		if ( geometry.boundingSphere !== null ) {

			this.boundingSphere = geometry.boundingSphere.clone();

		}

		return this;

	},

	center: function () {

		this.computeBoundingBox();

		var offset = this.boundingBox.getCenter().negate();

		this.translate( offset.x, offset.y, offset.z );

		return offset;

	},

	normalize: function () {

		this.computeBoundingSphere();

		var center = this.boundingSphere.center;
		var radius = this.boundingSphere.radius;

		var s = radius === 0 ? 1 : 1.0 / radius;

		var matrix = new Matrix4();
		matrix.set(
			s, 0, 0, - s * center.x,
			0, s, 0, - s * center.y,
			0, 0, s, - s * center.z,
			0, 0, 0, 1
		);

		this.applyMatrix( matrix );

		return this;

	},

	computeFaceNormals: function () {

		var cb = new Vector3(), ab = new Vector3();

		for ( var f = 0, fl = this.faces.length; f < fl; f ++ ) {

			var face = this.faces[ f ];

			var vA = this.vertices[ face.a ];
			var vB = this.vertices[ face.b ];
			var vC = this.vertices[ face.c ];

			cb.subVectors( vC, vB );
			ab.subVectors( vA, vB );
			cb.cross( ab );

			cb.normalize();

			face.normal.copy( cb );

		}

	},

	computeVertexNormals: function ( areaWeighted ) {

		if ( areaWeighted === undefined ) areaWeighted = true;

		var v, vl, f, fl, face, vertices;

		vertices = new Array( this.vertices.length );

		for ( v = 0, vl = this.vertices.length; v < vl; v ++ ) {

			vertices[ v ] = new Vector3();

		}

		if ( areaWeighted ) {

			// vertex normals weighted by triangle areas
			// http://www.iquilezles.org/www/articles/normals/normals.htm

			var vA, vB, vC;
			var cb = new Vector3(), ab = new Vector3();

			for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

				face = this.faces[ f ];

				vA = this.vertices[ face.a ];
				vB = this.vertices[ face.b ];
				vC = this.vertices[ face.c ];

				cb.subVectors( vC, vB );
				ab.subVectors( vA, vB );
				cb.cross( ab );

				vertices[ face.a ].add( cb );
				vertices[ face.b ].add( cb );
				vertices[ face.c ].add( cb );

			}

		} else {

			this.computeFaceNormals();

			for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

				face = this.faces[ f ];

				vertices[ face.a ].add( face.normal );
				vertices[ face.b ].add( face.normal );
				vertices[ face.c ].add( face.normal );

			}

		}

		for ( v = 0, vl = this.vertices.length; v < vl; v ++ ) {

			vertices[ v ].normalize();

		}

		for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

			face = this.faces[ f ];

			var vertexNormals = face.vertexNormals;

			if ( vertexNormals.length === 3 ) {

				vertexNormals[ 0 ].copy( vertices[ face.a ] );
				vertexNormals[ 1 ].copy( vertices[ face.b ] );
				vertexNormals[ 2 ].copy( vertices[ face.c ] );

			} else {

				vertexNormals[ 0 ] = vertices[ face.a ].clone();
				vertexNormals[ 1 ] = vertices[ face.b ].clone();
				vertexNormals[ 2 ] = vertices[ face.c ].clone();

			}

		}

		if ( this.faces.length > 0 ) {

			this.normalsNeedUpdate = true;

		}

	},

	computeFlatVertexNormals: function () {

		var f, fl, face;

		this.computeFaceNormals();

		for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

			face = this.faces[ f ];

			var vertexNormals = face.vertexNormals;

			if ( vertexNormals.length === 3 ) {

				vertexNormals[ 0 ].copy( face.normal );
				vertexNormals[ 1 ].copy( face.normal );
				vertexNormals[ 2 ].copy( face.normal );

			} else {

				vertexNormals[ 0 ] = face.normal.clone();
				vertexNormals[ 1 ] = face.normal.clone();
				vertexNormals[ 2 ] = face.normal.clone();

			}

		}

		if ( this.faces.length > 0 ) {

			this.normalsNeedUpdate = true;

		}

	},

	computeMorphNormals: function () {

		var i, il, f, fl, face;

		// save original normals
		// - create temp variables on first access
		//   otherwise just copy (for faster repeated calls)

		for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

			face = this.faces[ f ];

			if ( ! face.__originalFaceNormal ) {

				face.__originalFaceNormal = face.normal.clone();

			} else {

				face.__originalFaceNormal.copy( face.normal );

			}

			if ( ! face.__originalVertexNormals ) face.__originalVertexNormals = [];

			for ( i = 0, il = face.vertexNormals.length; i < il; i ++ ) {

				if ( ! face.__originalVertexNormals[ i ] ) {

					face.__originalVertexNormals[ i ] = face.vertexNormals[ i ].clone();

				} else {

					face.__originalVertexNormals[ i ].copy( face.vertexNormals[ i ] );

				}

			}

		}

		// use temp geometry to compute face and vertex normals for each morph

		var tmpGeo = new Geometry();
		tmpGeo.faces = this.faces;

		for ( i = 0, il = this.morphTargets.length; i < il; i ++ ) {

			// create on first access

			if ( ! this.morphNormals[ i ] ) {

				this.morphNormals[ i ] = {};
				this.morphNormals[ i ].faceNormals = [];
				this.morphNormals[ i ].vertexNormals = [];

				var dstNormalsFace = this.morphNormals[ i ].faceNormals;
				var dstNormalsVertex = this.morphNormals[ i ].vertexNormals;

				var faceNormal, vertexNormals;

				for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

					faceNormal = new Vector3();
					vertexNormals = { a: new Vector3(), b: new Vector3(), c: new Vector3() };

					dstNormalsFace.push( faceNormal );
					dstNormalsVertex.push( vertexNormals );

				}

			}

			var morphNormals = this.morphNormals[ i ];

			// set vertices to morph target

			tmpGeo.vertices = this.morphTargets[ i ].vertices;

			// compute morph normals

			tmpGeo.computeFaceNormals();
			tmpGeo.computeVertexNormals();

			// store morph normals

			var faceNormal, vertexNormals;

			for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

				face = this.faces[ f ];

				faceNormal = morphNormals.faceNormals[ f ];
				vertexNormals = morphNormals.vertexNormals[ f ];

				faceNormal.copy( face.normal );

				vertexNormals.a.copy( face.vertexNormals[ 0 ] );
				vertexNormals.b.copy( face.vertexNormals[ 1 ] );
				vertexNormals.c.copy( face.vertexNormals[ 2 ] );

			}

		}

		// restore original normals

		for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

			face = this.faces[ f ];

			face.normal = face.__originalFaceNormal;
			face.vertexNormals = face.__originalVertexNormals;

		}

	},

	computeLineDistances: function () {

		var d = 0;
		var vertices = this.vertices;

		for ( var i = 0, il = vertices.length; i < il; i ++ ) {

			if ( i > 0 ) {

				d += vertices[ i ].distanceTo( vertices[ i - 1 ] );

			}

			this.lineDistances[ i ] = d;

		}

	},

	computeBoundingBox: function () {

		if ( this.boundingBox === null ) {

			this.boundingBox = new Box3();

		}

		this.boundingBox.setFromPoints( this.vertices );

	},

	computeBoundingSphere: function () {

		if ( this.boundingSphere === null ) {

			this.boundingSphere = new Sphere();

		}

		this.boundingSphere.setFromPoints( this.vertices );

	},

	merge: function ( geometry, matrix, materialIndexOffset ) {

		if ( (geometry && geometry.isGeometry) === false ) {

			console.error( 'THREE.Geometry.merge(): geometry not an instance of THREE.Geometry.', geometry );
			return;

		}

		var normalMatrix,
		vertexOffset = this.vertices.length,
		vertices1 = this.vertices,
		vertices2 = geometry.vertices,
		faces1 = this.faces,
		faces2 = geometry.faces,
		uvs1 = this.faceVertexUvs[ 0 ],
		uvs2 = geometry.faceVertexUvs[ 0 ],
		colors1 = this.colors,
		colors2 = geometry.colors;

		if ( materialIndexOffset === undefined ) materialIndexOffset = 0;

		if ( matrix !== undefined ) {

			normalMatrix = new Matrix3().getNormalMatrix( matrix );

		}

		// vertices

		for ( var i = 0, il = vertices2.length; i < il; i ++ ) {

			var vertex = vertices2[ i ];

			var vertexCopy = vertex.clone();

			if ( matrix !== undefined ) vertexCopy.applyMatrix4( matrix );

			vertices1.push( vertexCopy );

		}

		// colors

		for ( var i = 0, il = colors2.length; i < il; i ++ ) {

			colors1.push( colors2[ i ].clone() );

		}

		// faces

		for ( i = 0, il = faces2.length; i < il; i ++ ) {

			var face = faces2[ i ], faceCopy, normal, color,
			faceVertexNormals = face.vertexNormals,
			faceVertexColors = face.vertexColors;

			faceCopy = new Face3( face.a + vertexOffset, face.b + vertexOffset, face.c + vertexOffset );
			faceCopy.normal.copy( face.normal );

			if ( normalMatrix !== undefined ) {

				faceCopy.normal.applyMatrix3( normalMatrix ).normalize();

			}

			for ( var j = 0, jl = faceVertexNormals.length; j < jl; j ++ ) {

				normal = faceVertexNormals[ j ].clone();

				if ( normalMatrix !== undefined ) {

					normal.applyMatrix3( normalMatrix ).normalize();

				}

				faceCopy.vertexNormals.push( normal );

			}

			faceCopy.color.copy( face.color );

			for ( var j = 0, jl = faceVertexColors.length; j < jl; j ++ ) {

				color = faceVertexColors[ j ];
				faceCopy.vertexColors.push( color.clone() );

			}

			faceCopy.materialIndex = face.materialIndex + materialIndexOffset;

			faces1.push( faceCopy );

		}

		// uvs

		for ( i = 0, il = uvs2.length; i < il; i ++ ) {

			var uv = uvs2[ i ], uvCopy = [];

			if ( uv === undefined ) {

				continue;

			}

			for ( var j = 0, jl = uv.length; j < jl; j ++ ) {

				uvCopy.push( uv[ j ].clone() );

			}

			uvs1.push( uvCopy );

		}

	},

	mergeMesh: function ( mesh ) {

		if ( (mesh && mesh.isMesh) === false ) {

			console.error( 'THREE.Geometry.mergeMesh(): mesh not an instance of THREE.Mesh.', mesh );
			return;

		}

		mesh.matrixAutoUpdate && mesh.updateMatrix();

		this.merge( mesh.geometry, mesh.matrix );

	},

	/*
	 * Checks for duplicate vertices with hashmap.
	 * Duplicated vertices are removed
	 * and faces' vertices are updated.
	 */

	mergeVertices: function () {

		var verticesMap = {}; // Hashmap for looking up vertices by position coordinates (and making sure they are unique)
		var unique = [], changes = [];

		var v, key;
		var precisionPoints = 4; // number of decimal points, e.g. 4 for epsilon of 0.0001
		var precision = Math.pow( 10, precisionPoints );
		var i, il, face;
		var indices, j, jl;

		for ( i = 0, il = this.vertices.length; i < il; i ++ ) {

			v = this.vertices[ i ];
			key = Math.round( v.x * precision ) + '_' + Math.round( v.y * precision ) + '_' + Math.round( v.z * precision );

			if ( verticesMap[ key ] === undefined ) {

				verticesMap[ key ] = i;
				unique.push( this.vertices[ i ] );
				changes[ i ] = unique.length - 1;

			} else {

				//console.log('Duplicate vertex found. ', i, ' could be using ', verticesMap[key]);
				changes[ i ] = changes[ verticesMap[ key ] ];

			}

		}


		// if faces are completely degenerate after merging vertices, we
		// have to remove them from the geometry.
		var faceIndicesToRemove = [];

		for ( i = 0, il = this.faces.length; i < il; i ++ ) {

			face = this.faces[ i ];

			face.a = changes[ face.a ];
			face.b = changes[ face.b ];
			face.c = changes[ face.c ];

			indices = [ face.a, face.b, face.c ];

			var dupIndex = - 1;

			// if any duplicate vertices are found in a Face3
			// we have to remove the face as nothing can be saved
			for ( var n = 0; n < 3; n ++ ) {

				if ( indices[ n ] === indices[ ( n + 1 ) % 3 ] ) {

					dupIndex = n;
					faceIndicesToRemove.push( i );
					break;

				}

			}

		}

		for ( i = faceIndicesToRemove.length - 1; i >= 0; i -- ) {

			var idx = faceIndicesToRemove[ i ];

			this.faces.splice( idx, 1 );

			for ( j = 0, jl = this.faceVertexUvs.length; j < jl; j ++ ) {

				this.faceVertexUvs[ j ].splice( idx, 1 );

			}

		}

		// Use unique set of vertices

		var diff = this.vertices.length - unique.length;
		this.vertices = unique;
		return diff;

	},

	sortFacesByMaterialIndex: function () {

		var faces = this.faces;
		var length = faces.length;

		// tag faces

		for ( var i = 0; i < length; i ++ ) {

			faces[ i ]._id = i;

		}

		// sort faces

		function materialIndexSort( a, b ) {

			return a.materialIndex - b.materialIndex;

		}

		faces.sort( materialIndexSort );

		// sort uvs

		var uvs1 = this.faceVertexUvs[ 0 ];
		var uvs2 = this.faceVertexUvs[ 1 ];

		var newUvs1, newUvs2;

		if ( uvs1 && uvs1.length === length ) newUvs1 = [];
		if ( uvs2 && uvs2.length === length ) newUvs2 = [];

		for ( var i = 0; i < length; i ++ ) {

			var id = faces[ i ]._id;

			if ( newUvs1 ) newUvs1.push( uvs1[ id ] );
			if ( newUvs2 ) newUvs2.push( uvs2[ id ] );

		}

		if ( newUvs1 ) this.faceVertexUvs[ 0 ] = newUvs1;
		if ( newUvs2 ) this.faceVertexUvs[ 1 ] = newUvs2;

	},

	toJSON: function () {

		var data = {
			metadata: {
				version: 4.4,
				type: 'Geometry',
				generator: 'Geometry.toJSON'
			}
		};

		// standard Geometry serialization

		data.uuid = this.uuid;
		data.type = this.type;
		if ( this.name !== '' ) data.name = this.name;

		if ( this.parameters !== undefined ) {

			var parameters = this.parameters;

			for ( var key in parameters ) {

				if ( parameters[ key ] !== undefined ) data[ key ] = parameters[ key ];

			}

			return data;

		}

		var vertices = [];

		for ( var i = 0; i < this.vertices.length; i ++ ) {

			var vertex = this.vertices[ i ];
			vertices.push( vertex.x, vertex.y, vertex.z );

		}

		var faces = [];
		var normals = [];
		var normalsHash = {};
		var colors = [];
		var colorsHash = {};
		var uvs = [];
		var uvsHash = {};

		for ( var i = 0; i < this.faces.length; i ++ ) {

			var face = this.faces[ i ];

			var hasMaterial = true;
			var hasFaceUv = false; // deprecated
			var hasFaceVertexUv = this.faceVertexUvs[ 0 ][ i ] !== undefined;
			var hasFaceNormal = face.normal.length() > 0;
			var hasFaceVertexNormal = face.vertexNormals.length > 0;
			var hasFaceColor = face.color.r !== 1 || face.color.g !== 1 || face.color.b !== 1;
			var hasFaceVertexColor = face.vertexColors.length > 0;

			var faceType = 0;

			faceType = setBit( faceType, 0, 0 ); // isQuad
			faceType = setBit( faceType, 1, hasMaterial );
			faceType = setBit( faceType, 2, hasFaceUv );
			faceType = setBit( faceType, 3, hasFaceVertexUv );
			faceType = setBit( faceType, 4, hasFaceNormal );
			faceType = setBit( faceType, 5, hasFaceVertexNormal );
			faceType = setBit( faceType, 6, hasFaceColor );
			faceType = setBit( faceType, 7, hasFaceVertexColor );

			faces.push( faceType );
			faces.push( face.a, face.b, face.c );
			faces.push( face.materialIndex );

			if ( hasFaceVertexUv ) {

				var faceVertexUvs = this.faceVertexUvs[ 0 ][ i ];

				faces.push(
					getUvIndex( faceVertexUvs[ 0 ] ),
					getUvIndex( faceVertexUvs[ 1 ] ),
					getUvIndex( faceVertexUvs[ 2 ] )
				);

			}

			if ( hasFaceNormal ) {

				faces.push( getNormalIndex( face.normal ) );

			}

			if ( hasFaceVertexNormal ) {

				var vertexNormals = face.vertexNormals;

				faces.push(
					getNormalIndex( vertexNormals[ 0 ] ),
					getNormalIndex( vertexNormals[ 1 ] ),
					getNormalIndex( vertexNormals[ 2 ] )
				);

			}

			if ( hasFaceColor ) {

				faces.push( getColorIndex( face.color ) );

			}

			if ( hasFaceVertexColor ) {

				var vertexColors = face.vertexColors;

				faces.push(
					getColorIndex( vertexColors[ 0 ] ),
					getColorIndex( vertexColors[ 1 ] ),
					getColorIndex( vertexColors[ 2 ] )
				);

			}

		}

		function setBit( value, position, enabled ) {

			return enabled ? value | ( 1 << position ) : value & ( ~ ( 1 << position ) );

		}

		function getNormalIndex( normal ) {

			var hash = normal.x.toString() + normal.y.toString() + normal.z.toString();

			if ( normalsHash[ hash ] !== undefined ) {

				return normalsHash[ hash ];

			}

			normalsHash[ hash ] = normals.length / 3;
			normals.push( normal.x, normal.y, normal.z );

			return normalsHash[ hash ];

		}

		function getColorIndex( color ) {

			var hash = color.r.toString() + color.g.toString() + color.b.toString();

			if ( colorsHash[ hash ] !== undefined ) {

				return colorsHash[ hash ];

			}

			colorsHash[ hash ] = colors.length;
			colors.push( color.getHex() );

			return colorsHash[ hash ];

		}

		function getUvIndex( uv ) {

			var hash = uv.x.toString() + uv.y.toString();

			if ( uvsHash[ hash ] !== undefined ) {

				return uvsHash[ hash ];

			}

			uvsHash[ hash ] = uvs.length / 2;
			uvs.push( uv.x, uv.y );

			return uvsHash[ hash ];

		}

		data.data = {};

		data.data.vertices = vertices;
		data.data.normals = normals;
		if ( colors.length > 0 ) data.data.colors = colors;
		if ( uvs.length > 0 ) data.data.uvs = [ uvs ]; // temporal backward compatibility
		data.data.faces = faces;

		return data;

	},

	clone: function () {

		/*
		// Handle primitives

		var parameters = this.parameters;

		if ( parameters !== undefined ) {

			var values = [];

			for ( var key in parameters ) {

				values.push( parameters[ key ] );

			}

			var geometry = Object.create( this.constructor.prototype );
			this.constructor.apply( geometry, values );
			return geometry;

		}

		return new this.constructor().copy( this );
		*/

		return new Geometry().copy( this );

	},

	copy: function ( source ) {

		this.vertices = [];
		this.faces = [];
		this.faceVertexUvs = [ [] ];
		this.colors = [];

		var vertices = source.vertices;

		for ( var i = 0, il = vertices.length; i < il; i ++ ) {

			this.vertices.push( vertices[ i ].clone() );

		}

		var colors = source.colors;

		for ( var i = 0, il = colors.length; i < il; i ++ ) {

			this.colors.push( colors[ i ].clone() );

		}

		var faces = source.faces;

		for ( var i = 0, il = faces.length; i < il; i ++ ) {

			this.faces.push( faces[ i ].clone() );

		}

		for ( var i = 0, il = source.faceVertexUvs.length; i < il; i ++ ) {

			var faceVertexUvs = source.faceVertexUvs[ i ];

			if ( this.faceVertexUvs[ i ] === undefined ) {

				this.faceVertexUvs[ i ] = [];

			}

			for ( var j = 0, jl = faceVertexUvs.length; j < jl; j ++ ) {

				var uvs = faceVertexUvs[ j ], uvsCopy = [];

				for ( var k = 0, kl = uvs.length; k < kl; k ++ ) {

					var uv = uvs[ k ];

					uvsCopy.push( uv.clone() );

				}

				this.faceVertexUvs[ i ].push( uvsCopy );

			}

		}

		return this;

	},

	dispose: function () {

		this.dispatchEvent( { type: 'dispose' } );

	}

} );

var count = 0;
function GeometryIdCount() { return count++; }

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 */

function BufferGeometry() {

	Object.defineProperty( this, 'id', { value: GeometryIdCount() } );

	this.uuid = _Math.generateUUID();

	this.name = '';
	this.type = 'BufferGeometry';

	this.index = null;
	this.attributes = {};

	this.morphAttributes = {};

	this.groups = [];

	this.boundingBox = null;
	this.boundingSphere = null;

	this.drawRange = { start: 0, count: Infinity };

}

Object.assign( BufferGeometry.prototype, EventDispatcher.prototype, {

	isBufferGeometry: true,

	getIndex: function () {

		return this.index;

	},

	setIndex: function ( index ) {

		this.index = index;

	},

	addAttribute: function ( name, attribute ) {

		if ( ( attribute && attribute.isBufferAttribute ) === false && ( attribute && attribute.isInterleavedBufferAttribute ) === false ) {

			console.warn( 'THREE.BufferGeometry: .addAttribute() now expects ( name, attribute ).' );

			this.addAttribute( name, new BufferAttribute( arguments[ 1 ], arguments[ 2 ] ) );

			return;

		}

		if ( name === 'index' ) {

			console.warn( 'THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute.' );
			this.setIndex( attribute );

			return;

		}

		this.attributes[ name ] = attribute;

		return this;

	},

	getAttribute: function ( name ) {

		return this.attributes[ name ];

	},

	removeAttribute: function ( name ) {

		delete this.attributes[ name ];

		return this;

	},

	addGroup: function ( start, count, materialIndex ) {

		this.groups.push( {

			start: start,
			count: count,
			materialIndex: materialIndex !== undefined ? materialIndex : 0

		} );

	},

	clearGroups: function () {

		this.groups = [];

	},

	setDrawRange: function ( start, count ) {

		this.drawRange.start = start;
		this.drawRange.count = count;

	},

	applyMatrix: function ( matrix ) {

		var position = this.attributes.position;

		if ( position !== undefined ) {

			matrix.applyToVector3Array( position.array );
			position.needsUpdate = true;

		}

		var normal = this.attributes.normal;

		if ( normal !== undefined ) {

			var normalMatrix = new Matrix3().getNormalMatrix( matrix );

			normalMatrix.applyToVector3Array( normal.array );
			normal.needsUpdate = true;

		}

		if ( this.boundingBox !== null ) {

			this.computeBoundingBox();

		}

		if ( this.boundingSphere !== null ) {

			this.computeBoundingSphere();

		}

		return this;

	},

	rotateX: function () {

		// rotate geometry around world x-axis

		var m1;

		return function rotateX( angle ) {

			if ( m1 === undefined ) m1 = new Matrix4();

			m1.makeRotationX( angle );

			this.applyMatrix( m1 );

			return this;

		};

	}(),

	rotateY: function () {

		// rotate geometry around world y-axis

		var m1;

		return function rotateY( angle ) {

			if ( m1 === undefined ) m1 = new Matrix4();

			m1.makeRotationY( angle );

			this.applyMatrix( m1 );

			return this;

		};

	}(),

	rotateZ: function () {

		// rotate geometry around world z-axis

		var m1;

		return function rotateZ( angle ) {

			if ( m1 === undefined ) m1 = new Matrix4();

			m1.makeRotationZ( angle );

			this.applyMatrix( m1 );

			return this;

		};

	}(),

	translate: function () {

		// translate geometry

		var m1;

		return function translate( x, y, z ) {

			if ( m1 === undefined ) m1 = new Matrix4();

			m1.makeTranslation( x, y, z );

			this.applyMatrix( m1 );

			return this;

		};

	}(),

	scale: function () {

		// scale geometry

		var m1;

		return function scale( x, y, z ) {

			if ( m1 === undefined ) m1 = new Matrix4();

			m1.makeScale( x, y, z );

			this.applyMatrix( m1 );

			return this;

		};

	}(),

	lookAt: function () {

		var obj;

		return function lookAt( vector ) {

			if ( obj === undefined ) obj = new Object3D();

			obj.lookAt( vector );

			obj.updateMatrix();

			this.applyMatrix( obj.matrix );

		};

	}(),

	center: function () {

		this.computeBoundingBox();

		var offset = this.boundingBox.getCenter().negate();

		this.translate( offset.x, offset.y, offset.z );

		return offset;

	},

	setFromObject: function ( object ) {

		// console.log( 'THREE.BufferGeometry.setFromObject(). Converting', object, this );

		var geometry = object.geometry;

		if ( object.isPoints || object.isLine ) {

			var positions = new Float32BufferAttribute( geometry.vertices.length * 3, 3 );
			var colors = new Float32BufferAttribute( geometry.colors.length * 3, 3 );

			this.addAttribute( 'position', positions.copyVector3sArray( geometry.vertices ) );
			this.addAttribute( 'color', colors.copyColorsArray( geometry.colors ) );

			if ( geometry.lineDistances && geometry.lineDistances.length === geometry.vertices.length ) {

				var lineDistances = new Float32BufferAttribute( geometry.lineDistances.length, 1 );

				this.addAttribute( 'lineDistance', lineDistances.copyArray( geometry.lineDistances ) );

			}

			if ( geometry.boundingSphere !== null ) {

				this.boundingSphere = geometry.boundingSphere.clone();

			}

			if ( geometry.boundingBox !== null ) {

				this.boundingBox = geometry.boundingBox.clone();

			}

		} else if ( object.isMesh ) {

			if ( geometry && geometry.isGeometry ) {

				this.fromGeometry( geometry );

			}

		}

		return this;

	},

	updateFromObject: function ( object ) {

		var geometry = object.geometry;

		if ( object.isMesh ) {

			var direct = geometry.__directGeometry;

			if ( geometry.elementsNeedUpdate === true ) {

				direct = undefined;
				geometry.elementsNeedUpdate = false;

			}

			if ( direct === undefined ) {

				return this.fromGeometry( geometry );

			}

			direct.verticesNeedUpdate = geometry.verticesNeedUpdate;
			direct.normalsNeedUpdate = geometry.normalsNeedUpdate;
			direct.colorsNeedUpdate = geometry.colorsNeedUpdate;
			direct.uvsNeedUpdate = geometry.uvsNeedUpdate;
			direct.groupsNeedUpdate = geometry.groupsNeedUpdate;

			geometry.verticesNeedUpdate = false;
			geometry.normalsNeedUpdate = false;
			geometry.colorsNeedUpdate = false;
			geometry.uvsNeedUpdate = false;
			geometry.groupsNeedUpdate = false;

			geometry = direct;

		}

		var attribute;

		if ( geometry.verticesNeedUpdate === true ) {

			attribute = this.attributes.position;

			if ( attribute !== undefined ) {

				attribute.copyVector3sArray( geometry.vertices );
				attribute.needsUpdate = true;

			}

			geometry.verticesNeedUpdate = false;

		}

		if ( geometry.normalsNeedUpdate === true ) {

			attribute = this.attributes.normal;

			if ( attribute !== undefined ) {

				attribute.copyVector3sArray( geometry.normals );
				attribute.needsUpdate = true;

			}

			geometry.normalsNeedUpdate = false;

		}

		if ( geometry.colorsNeedUpdate === true ) {

			attribute = this.attributes.color;

			if ( attribute !== undefined ) {

				attribute.copyColorsArray( geometry.colors );
				attribute.needsUpdate = true;

			}

			geometry.colorsNeedUpdate = false;

		}

		if ( geometry.uvsNeedUpdate ) {

			attribute = this.attributes.uv;

			if ( attribute !== undefined ) {

				attribute.copyVector2sArray( geometry.uvs );
				attribute.needsUpdate = true;

			}

			geometry.uvsNeedUpdate = false;

		}

		if ( geometry.lineDistancesNeedUpdate ) {

			attribute = this.attributes.lineDistance;

			if ( attribute !== undefined ) {

				attribute.copyArray( geometry.lineDistances );
				attribute.needsUpdate = true;

			}

			geometry.lineDistancesNeedUpdate = false;

		}

		if ( geometry.groupsNeedUpdate ) {

			geometry.computeGroups( object.geometry );
			this.groups = geometry.groups;

			geometry.groupsNeedUpdate = false;

		}

		return this;

	},

	fromGeometry: function ( geometry ) {

		geometry.__directGeometry = new DirectGeometry().fromGeometry( geometry );

		return this.fromDirectGeometry( geometry.__directGeometry );

	},

	fromDirectGeometry: function ( geometry ) {

		var positions = new Float32Array( geometry.vertices.length * 3 );
		this.addAttribute( 'position', new BufferAttribute( positions, 3 ).copyVector3sArray( geometry.vertices ) );

		if ( geometry.normals.length > 0 ) {

			var normals = new Float32Array( geometry.normals.length * 3 );
			this.addAttribute( 'normal', new BufferAttribute( normals, 3 ).copyVector3sArray( geometry.normals ) );

		}

		if ( geometry.colors.length > 0 ) {

			var colors = new Float32Array( geometry.colors.length * 3 );
			this.addAttribute( 'color', new BufferAttribute( colors, 3 ).copyColorsArray( geometry.colors ) );

		}

		if ( geometry.uvs.length > 0 ) {

			var uvs = new Float32Array( geometry.uvs.length * 2 );
			this.addAttribute( 'uv', new BufferAttribute( uvs, 2 ).copyVector2sArray( geometry.uvs ) );

		}

		if ( geometry.uvs2.length > 0 ) {

			var uvs2 = new Float32Array( geometry.uvs2.length * 2 );
			this.addAttribute( 'uv2', new BufferAttribute( uvs2, 2 ).copyVector2sArray( geometry.uvs2 ) );

		}

		if ( geometry.indices.length > 0 ) {

			var TypeArray = geometry.vertices.length > 65535 ? Uint32Array : Uint16Array;
			var indices = new TypeArray( geometry.indices.length * 3 );
			this.setIndex( new BufferAttribute( indices, 1 ).copyIndicesArray( geometry.indices ) );

		}

		// groups

		this.groups = geometry.groups;

		// morphs

		for ( var name in geometry.morphTargets ) {

			var array = [];
			var morphTargets = geometry.morphTargets[ name ];

			for ( var i = 0, l = morphTargets.length; i < l; i ++ ) {

				var morphTarget = morphTargets[ i ];

				var attribute = new Float32BufferAttribute( morphTarget.length * 3, 3 );

				array.push( attribute.copyVector3sArray( morphTarget ) );

			}

			this.morphAttributes[ name ] = array;

		}

		// skinning

		if ( geometry.skinIndices.length > 0 ) {

			var skinIndices = new Float32BufferAttribute( geometry.skinIndices.length * 4, 4 );
			this.addAttribute( 'skinIndex', skinIndices.copyVector4sArray( geometry.skinIndices ) );

		}

		if ( geometry.skinWeights.length > 0 ) {

			var skinWeights = new Float32BufferAttribute( geometry.skinWeights.length * 4, 4 );
			this.addAttribute( 'skinWeight', skinWeights.copyVector4sArray( geometry.skinWeights ) );

		}

		//

		if ( geometry.boundingSphere !== null ) {

			this.boundingSphere = geometry.boundingSphere.clone();

		}

		if ( geometry.boundingBox !== null ) {

			this.boundingBox = geometry.boundingBox.clone();

		}

		return this;

	},

	computeBoundingBox: function () {

		if ( this.boundingBox === null ) {

			this.boundingBox = new Box3();

		}

		var position = this.attributes.position;

		if ( position !== undefined ) {

			this.boundingBox.setFromBufferAttribute( position );

		} else {

			this.boundingBox.makeEmpty();

		}

		if ( isNaN( this.boundingBox.min.x ) || isNaN( this.boundingBox.min.y ) || isNaN( this.boundingBox.min.z ) ) {

			console.error( 'THREE.BufferGeometry.computeBoundingBox: Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this );

		}

	},

	computeBoundingSphere: function () {

		var box = new Box3();
		var vector = new Vector3();

		return function computeBoundingSphere() {

			if ( this.boundingSphere === null ) {

				this.boundingSphere = new Sphere();

			}

			var position = this.attributes.position;

			if ( position ) {

				var center = this.boundingSphere.center;

				box.setFromBufferAttribute( position );
				box.getCenter( center );

				// hoping to find a boundingSphere with a radius smaller than the
				// boundingSphere of the boundingBox: sqrt(3) smaller in the best case

				var maxRadiusSq = 0;

				for ( var i = 0, il = position.count; i < il; i ++ ) {

					vector.x = position.getX( i );
					vector.y = position.getY( i );
					vector.z = position.getZ( i );
					maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( vector ) );

				}

				this.boundingSphere.radius = Math.sqrt( maxRadiusSq );

				if ( isNaN( this.boundingSphere.radius ) ) {

					console.error( 'THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this );

				}

			}

		};

	}(),

	computeFaceNormals: function () {

		// backwards compatibility

	},

	computeVertexNormals: function () {

		var index = this.index;
		var attributes = this.attributes;
		var groups = this.groups;

		if ( attributes.position ) {

			var positions = attributes.position.array;

			if ( attributes.normal === undefined ) {

				this.addAttribute( 'normal', new BufferAttribute( new Float32Array( positions.length ), 3 ) );

			} else {

				// reset existing normals to zero

				var array = attributes.normal.array;

				for ( var i = 0, il = array.length; i < il; i ++ ) {

					array[ i ] = 0;

				}

			}

			var normals = attributes.normal.array;

			var vA, vB, vC;
			var pA = new Vector3(), pB = new Vector3(), pC = new Vector3();
			var cb = new Vector3(), ab = new Vector3();

			// indexed elements

			if ( index ) {

				var indices = index.array;

				if ( groups.length === 0 ) {

					this.addGroup( 0, indices.length );

				}

				for ( var j = 0, jl = groups.length; j < jl; ++ j ) {

					var group = groups[ j ];

					var start = group.start;
					var count = group.count;

					for ( var i = start, il = start + count; i < il; i += 3 ) {

						vA = indices[ i + 0 ] * 3;
						vB = indices[ i + 1 ] * 3;
						vC = indices[ i + 2 ] * 3;

						pA.fromArray( positions, vA );
						pB.fromArray( positions, vB );
						pC.fromArray( positions, vC );

						cb.subVectors( pC, pB );
						ab.subVectors( pA, pB );
						cb.cross( ab );

						normals[ vA ] += cb.x;
						normals[ vA + 1 ] += cb.y;
						normals[ vA + 2 ] += cb.z;

						normals[ vB ] += cb.x;
						normals[ vB + 1 ] += cb.y;
						normals[ vB + 2 ] += cb.z;

						normals[ vC ] += cb.x;
						normals[ vC + 1 ] += cb.y;
						normals[ vC + 2 ] += cb.z;

					}

				}

			} else {

				// non-indexed elements (unconnected triangle soup)

				for ( var i = 0, il = positions.length; i < il; i += 9 ) {

					pA.fromArray( positions, i );
					pB.fromArray( positions, i + 3 );
					pC.fromArray( positions, i + 6 );

					cb.subVectors( pC, pB );
					ab.subVectors( pA, pB );
					cb.cross( ab );

					normals[ i ] = cb.x;
					normals[ i + 1 ] = cb.y;
					normals[ i + 2 ] = cb.z;

					normals[ i + 3 ] = cb.x;
					normals[ i + 4 ] = cb.y;
					normals[ i + 5 ] = cb.z;

					normals[ i + 6 ] = cb.x;
					normals[ i + 7 ] = cb.y;
					normals[ i + 8 ] = cb.z;

				}

			}

			this.normalizeNormals();

			attributes.normal.needsUpdate = true;

		}

	},

	merge: function ( geometry, offset ) {

		if ( ( geometry && geometry.isBufferGeometry ) === false ) {

			console.error( 'THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.', geometry );
			return;

		}

		if ( offset === undefined ) offset = 0;

		var attributes = this.attributes;

		for ( var key in attributes ) {

			if ( geometry.attributes[ key ] === undefined ) continue;

			var attribute1 = attributes[ key ];
			var attributeArray1 = attribute1.array;

			var attribute2 = geometry.attributes[ key ];
			var attributeArray2 = attribute2.array;

			var attributeSize = attribute2.itemSize;

			for ( var i = 0, j = attributeSize * offset; i < attributeArray2.length; i ++, j ++ ) {

				attributeArray1[ j ] = attributeArray2[ i ];

			}

		}

		return this;

	},

	normalizeNormals: function () {

		var normals = this.attributes.normal.array;

		var x, y, z, n;

		for ( var i = 0, il = normals.length; i < il; i += 3 ) {

			x = normals[ i ];
			y = normals[ i + 1 ];
			z = normals[ i + 2 ];

			n = 1.0 / Math.sqrt( x * x + y * y + z * z );

			normals[ i ] *= n;
			normals[ i + 1 ] *= n;
			normals[ i + 2 ] *= n;

		}

	},

	toNonIndexed: function () {

		if ( this.index === null ) {

			console.warn( 'THREE.BufferGeometry.toNonIndexed(): Geometry is already non-indexed.' );
			return this;

		}

		var geometry2 = new BufferGeometry();

		var indices = this.index.array;
		var attributes = this.attributes;

		for ( var name in attributes ) {

			var attribute = attributes[ name ];

			var array = attribute.array;
			var itemSize = attribute.itemSize;

			var array2 = new array.constructor( indices.length * itemSize );

			var index = 0, index2 = 0;

			for ( var i = 0, l = indices.length; i < l; i ++ ) {

				index = indices[ i ] * itemSize;

				for ( var j = 0; j < itemSize; j ++ ) {

					array2[ index2 ++ ] = array[ index ++ ];

				}

			}

			geometry2.addAttribute( name, new BufferAttribute( array2, itemSize ) );

		}

		return geometry2;

	},

	toJSON: function () {

		var data = {
			metadata: {
				version: 4.4,
				type: 'BufferGeometry',
				generator: 'BufferGeometry.toJSON'
			}
		};

		// standard BufferGeometry serialization

		data.uuid = this.uuid;
		data.type = this.type;
		if ( this.name !== '' ) data.name = this.name;

		if ( this.parameters !== undefined ) {

			var parameters = this.parameters;

			for ( var key in parameters ) {

				if ( parameters[ key ] !== undefined ) data[ key ] = parameters[ key ];

			}

			return data;

		}

		data.data = { attributes: {} };

		var index = this.index;

		if ( index !== null ) {

			var array = Array.prototype.slice.call( index.array );

			data.data.index = {
				type: index.array.constructor.name,
				array: array
			};

		}

		var attributes = this.attributes;

		for ( var key in attributes ) {

			var attribute = attributes[ key ];

			var array = Array.prototype.slice.call( attribute.array );

			data.data.attributes[ key ] = {
				itemSize: attribute.itemSize,
				type: attribute.array.constructor.name,
				array: array,
				normalized: attribute.normalized
			};

		}

		var groups = this.groups;

		if ( groups.length > 0 ) {

			data.data.groups = JSON.parse( JSON.stringify( groups ) );

		}

		var boundingSphere = this.boundingSphere;

		if ( boundingSphere !== null ) {

			data.data.boundingSphere = {
				center: boundingSphere.center.toArray(),
				radius: boundingSphere.radius
			};

		}

		return data;

	},

	clone: function () {

		/*
		// Handle primitives

		var parameters = this.parameters;

		if ( parameters !== undefined ) {

			var values = [];

			for ( var key in parameters ) {

				values.push( parameters[ key ] );

			}

			var geometry = Object.create( this.constructor.prototype );
			this.constructor.apply( geometry, values );
			return geometry;

		}

		return new this.constructor().copy( this );
		*/

		return new BufferGeometry().copy( this );

	},

	copy: function ( source ) {

		var index = source.index;

		if ( index !== null ) {

			this.setIndex( index.clone() );

		}

		var attributes = source.attributes;

		for ( var name in attributes ) {

			var attribute = attributes[ name ];
			this.addAttribute( name, attribute.clone() );

		}

		var groups = source.groups;

		for ( var i = 0, l = groups.length; i < l; i ++ ) {

			var group = groups[ i ];
			this.addGroup( group.start, group.count, group.materialIndex );

		}

		return this;

	},

	dispose: function () {

		this.dispatchEvent( { type: 'dispose' } );

	}

} );

BufferGeometry.MaxIndex = 65535;

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 * @author mikael emtinger / http://gomo.se/
 * @author jonobr1 / http://jonobr1.com/
 */

function Mesh( geometry, material ) {

	Object3D.call( this );

	this.type = 'Mesh';

	this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
	this.material = material !== undefined ? material : new MeshBasicMaterial( { color: Math.random() * 0xffffff } );

	this.drawMode = TrianglesDrawMode;

	this.updateMorphTargets();

}

Mesh.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: Mesh,

	isMesh: true,

	setDrawMode: function ( value ) {

		this.drawMode = value;

	},

	copy: function ( source ) {

		Object3D.prototype.copy.call( this, source );

		this.drawMode = source.drawMode;

		return this;

	},

	updateMorphTargets: function () {

		var morphTargets = this.geometry.morphTargets;

		if ( morphTargets !== undefined && morphTargets.length > 0 ) {

			this.morphTargetInfluences = [];
			this.morphTargetDictionary = {};

			for ( var m = 0, ml = morphTargets.length; m < ml; m ++ ) {

				this.morphTargetInfluences.push( 0 );
				this.morphTargetDictionary[ morphTargets[ m ].name ] = m;

			}

		}

	},

	raycast: ( function () {

		var inverseMatrix = new Matrix4();
		var ray = new Ray();
		var sphere = new Sphere();

		var vA = new Vector3();
		var vB = new Vector3();
		var vC = new Vector3();

		var tempA = new Vector3();
		var tempB = new Vector3();
		var tempC = new Vector3();

		var uvA = new Vector2();
		var uvB = new Vector2();
		var uvC = new Vector2();

		var barycoord = new Vector3();

		var intersectionPoint = new Vector3();
		var intersectionPointWorld = new Vector3();

		function uvIntersection( point, p1, p2, p3, uv1, uv2, uv3 ) {

			Triangle.barycoordFromPoint( point, p1, p2, p3, barycoord );

			uv1.multiplyScalar( barycoord.x );
			uv2.multiplyScalar( barycoord.y );
			uv3.multiplyScalar( barycoord.z );

			uv1.add( uv2 ).add( uv3 );

			return uv1.clone();

		}

		function checkIntersection( object, raycaster, ray, pA, pB, pC, point ) {

			var intersect;
			var material = object.material;

			if ( material.side === BackSide ) {

				intersect = ray.intersectTriangle( pC, pB, pA, true, point );

			} else {

				intersect = ray.intersectTriangle( pA, pB, pC, material.side !== DoubleSide, point );

			}

			if ( intersect === null ) return null;

			intersectionPointWorld.copy( point );
			intersectionPointWorld.applyMatrix4( object.matrixWorld );

			var distance = raycaster.ray.origin.distanceTo( intersectionPointWorld );

			if ( distance < raycaster.near || distance > raycaster.far ) return null;

			return {
				distance: distance,
				point: intersectionPointWorld.clone(),
				object: object
			};

		}

		function checkBufferGeometryIntersection( object, raycaster, ray, positions, uvs, a, b, c ) {

			vA.fromArray( positions, a * 3 );
			vB.fromArray( positions, b * 3 );
			vC.fromArray( positions, c * 3 );

			var intersection = checkIntersection( object, raycaster, ray, vA, vB, vC, intersectionPoint );

			if ( intersection ) {

				if ( uvs ) {

					uvA.fromArray( uvs, a * 2 );
					uvB.fromArray( uvs, b * 2 );
					uvC.fromArray( uvs, c * 2 );

					intersection.uv = uvIntersection( intersectionPoint,  vA, vB, vC,  uvA, uvB, uvC );

				}

				intersection.face = new Face3( a, b, c, Triangle.normal( vA, vB, vC ) );
				intersection.faceIndex = a;

			}

			return intersection;

		}

		return function raycast( raycaster, intersects ) {

			var geometry = this.geometry;
			var material = this.material;
			var matrixWorld = this.matrixWorld;

			if ( material === undefined ) return;

			// Checking boundingSphere distance to ray

			if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

			sphere.copy( geometry.boundingSphere );
			sphere.applyMatrix4( matrixWorld );

			if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;

			//

			inverseMatrix.getInverse( matrixWorld );
			ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );

			// Check boundingBox before continuing

			if ( geometry.boundingBox !== null ) {

				if ( ray.intersectsBox( geometry.boundingBox ) === false ) return;

			}

			var uvs, intersection;

			if ( geometry.isBufferGeometry ) {

				var a, b, c;
				var index = geometry.index;
				var attributes = geometry.attributes;
				var positions = attributes.position.array;

				if ( attributes.uv !== undefined ) {

					uvs = attributes.uv.array;

				}

				if ( index !== null ) {

					var indices = index.array;

					for ( var i = 0, l = indices.length; i < l; i += 3 ) {

						a = indices[ i ];
						b = indices[ i + 1 ];
						c = indices[ i + 2 ];

						intersection = checkBufferGeometryIntersection( this, raycaster, ray, positions, uvs, a, b, c );

						if ( intersection ) {

							intersection.faceIndex = Math.floor( i / 3 ); // triangle number in indices buffer semantics
							intersects.push( intersection );

						}

					}

				} else {


					for ( var i = 0, l = positions.length; i < l; i += 9 ) {

						a = i / 3;
						b = a + 1;
						c = a + 2;

						intersection = checkBufferGeometryIntersection( this, raycaster, ray, positions, uvs, a, b, c );

						if ( intersection ) {

							intersection.index = a; // triangle number in positions buffer semantics
							intersects.push( intersection );

						}

					}

				}

			} else if ( geometry.isGeometry ) {

				var fvA, fvB, fvC;
				var isFaceMaterial = (material && material.isMultiMaterial);
				var materials = isFaceMaterial === true ? material.materials : null;

				var vertices = geometry.vertices;
				var faces = geometry.faces;
				var faceVertexUvs = geometry.faceVertexUvs[ 0 ];
				if ( faceVertexUvs.length > 0 ) uvs = faceVertexUvs;

				for ( var f = 0, fl = faces.length; f < fl; f ++ ) {

					var face = faces[ f ];
					var faceMaterial = isFaceMaterial === true ? materials[ face.materialIndex ] : material;

					if ( faceMaterial === undefined ) continue;

					fvA = vertices[ face.a ];
					fvB = vertices[ face.b ];
					fvC = vertices[ face.c ];

					if ( faceMaterial.morphTargets === true ) {

						var morphTargets = geometry.morphTargets;
						var morphInfluences = this.morphTargetInfluences;

						vA.set( 0, 0, 0 );
						vB.set( 0, 0, 0 );
						vC.set( 0, 0, 0 );

						for ( var t = 0, tl = morphTargets.length; t < tl; t ++ ) {

							var influence = morphInfluences[ t ];

							if ( influence === 0 ) continue;

							var targets = morphTargets[ t ].vertices;

							vA.addScaledVector( tempA.subVectors( targets[ face.a ], fvA ), influence );
							vB.addScaledVector( tempB.subVectors( targets[ face.b ], fvB ), influence );
							vC.addScaledVector( tempC.subVectors( targets[ face.c ], fvC ), influence );

						}

						vA.add( fvA );
						vB.add( fvB );
						vC.add( fvC );

						fvA = vA;
						fvB = vB;
						fvC = vC;

					}

					intersection = checkIntersection( this, raycaster, ray, fvA, fvB, fvC, intersectionPoint );

					if ( intersection ) {

						if ( uvs ) {

							var uvs_f = uvs[ f ];
							uvA.copy( uvs_f[ 0 ] );
							uvB.copy( uvs_f[ 1 ] );
							uvC.copy( uvs_f[ 2 ] );

							intersection.uv = uvIntersection( intersectionPoint, fvA, fvB, fvC, uvA, uvB, uvC );

						}

						intersection.face = face;
						intersection.faceIndex = f;
						intersects.push( intersection );

					}

				}

			}

		};

	}() ),

	clone: function () {

		return new this.constructor( this.geometry, this.material ).copy( this );

	}

} );

/**
 * @author Mugen87 / https://github.com/Mugen87
 */

function BoxBufferGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) {

	BufferGeometry.call( this );

	this.type = 'BoxBufferGeometry';

	this.parameters = {
		width: width,
		height: height,
		depth: depth,
		widthSegments: widthSegments,
		heightSegments: heightSegments,
		depthSegments: depthSegments
	};

	var scope = this;

	// segments
	widthSegments = Math.floor( widthSegments ) || 1;
	heightSegments = Math.floor( heightSegments ) || 1;
	depthSegments = Math.floor( depthSegments ) || 1;

	// these are used to calculate buffer length
	var vertexCount = calculateVertexCount( widthSegments, heightSegments, depthSegments );
	var indexCount = calculateIndexCount( widthSegments, heightSegments, depthSegments );

	// buffers
	var indices = new ( indexCount > 65535 ? Uint32Array : Uint16Array )( indexCount );
	var vertices = new Float32Array( vertexCount * 3 );
	var normals = new Float32Array( vertexCount * 3 );
	var uvs = new Float32Array( vertexCount * 2 );

	// offset variables
	var vertexBufferOffset = 0;
	var uvBufferOffset = 0;
	var indexBufferOffset = 0;
	var numberOfVertices = 0;

	// group variables
	var groupStart = 0;

	// build each side of the box geometry
	buildPlane( 'z', 'y', 'x', - 1, - 1, depth, height,   width,  depthSegments, heightSegments, 0 ); // px
	buildPlane( 'z', 'y', 'x',   1, - 1, depth, height, - width,  depthSegments, heightSegments, 1 ); // nx
	buildPlane( 'x', 'z', 'y',   1,   1, width, depth,    height, widthSegments, depthSegments,  2 ); // py
	buildPlane( 'x', 'z', 'y',   1, - 1, width, depth,  - height, widthSegments, depthSegments,  3 ); // ny
	buildPlane( 'x', 'y', 'z',   1, - 1, width, height,   depth,  widthSegments, heightSegments, 4 ); // pz
	buildPlane( 'x', 'y', 'z', - 1, - 1, width, height, - depth,  widthSegments, heightSegments, 5 ); // nz

	// build geometry
	this.setIndex( new BufferAttribute( indices, 1 ) );
	this.addAttribute( 'position', new BufferAttribute( vertices, 3 ) );
	this.addAttribute( 'normal', new BufferAttribute( normals, 3 ) );
	this.addAttribute( 'uv', new BufferAttribute( uvs, 2 ) );

	// helper functions

	function calculateVertexCount( w, h, d ) {

		var vertices = 0;

		// calculate the amount of vertices for each side (plane)
		vertices += (w + 1) * (h + 1) * 2; // xy
		vertices += (w + 1) * (d + 1) * 2; // xz
		vertices += (d + 1) * (h + 1) * 2; // zy

		return vertices;

	}

	function calculateIndexCount( w, h, d ) {

		var index = 0;

		// calculate the amount of squares for each side
		index += w * h * 2; // xy
		index += w * d * 2; // xz
		index += d * h * 2; // zy

		return index * 6; // two triangles per square => six vertices per square

	}

	function buildPlane( u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex ) {

		var segmentWidth	= width / gridX;
		var segmentHeight = height / gridY;

		var widthHalf = width / 2;
		var heightHalf = height / 2;
		var depthHalf = depth / 2;

		var gridX1 = gridX + 1;
		var gridY1 = gridY + 1;

		var vertexCounter = 0;
		var groupCount = 0;

		var vector = new Vector3();

		// generate vertices, normals and uvs

		for ( var iy = 0; iy < gridY1; iy ++ ) {

			var y = iy * segmentHeight - heightHalf;

			for ( var ix = 0; ix < gridX1; ix ++ ) {

				var x = ix * segmentWidth - widthHalf;

				// set values to correct vector component
				vector[ u ] = x * udir;
				vector[ v ] = y * vdir;
				vector[ w ] = depthHalf;

				// now apply vector to vertex buffer
				vertices[ vertexBufferOffset ] = vector.x;
				vertices[ vertexBufferOffset + 1 ] = vector.y;
				vertices[ vertexBufferOffset + 2 ] = vector.z;

				// set values to correct vector component
				vector[ u ] = 0;
				vector[ v ] = 0;
				vector[ w ] = depth > 0 ? 1 : - 1;

				// now apply vector to normal buffer
				normals[ vertexBufferOffset ] = vector.x;
				normals[ vertexBufferOffset + 1 ] = vector.y;
				normals[ vertexBufferOffset + 2 ] = vector.z;

				// uvs
				uvs[ uvBufferOffset ] = ix / gridX;
				uvs[ uvBufferOffset + 1 ] = 1 - ( iy / gridY );

				// update offsets and counters
				vertexBufferOffset += 3;
				uvBufferOffset += 2;
				vertexCounter += 1;

			}

		}

		// 1. you need three indices to draw a single face
		// 2. a single segment consists of two faces
		// 3. so we need to generate six (2*3) indices per segment

		for ( iy = 0; iy < gridY; iy ++ ) {

			for ( ix = 0; ix < gridX; ix ++ ) {

				// indices
				var a = numberOfVertices + ix + gridX1 * iy;
				var b = numberOfVertices + ix + gridX1 * ( iy + 1 );
				var c = numberOfVertices + ( ix + 1 ) + gridX1 * ( iy + 1 );
				var d = numberOfVertices + ( ix + 1 ) + gridX1 * iy;

				// face one
				indices[ indexBufferOffset ] = a;
				indices[ indexBufferOffset + 1 ] = b;
				indices[ indexBufferOffset + 2 ] = d;

				// face two
				indices[ indexBufferOffset + 3 ] = b;
				indices[ indexBufferOffset + 4 ] = c;
				indices[ indexBufferOffset + 5 ] = d;

				// update offsets and counters
				indexBufferOffset += 6;
				groupCount += 6;

			}

		}

		// add a group to the geometry. this will ensure multi material support
		scope.addGroup( groupStart, groupCount, materialIndex );

		// calculate new start value for groups
		groupStart += groupCount;

		// update total number of vertices
		numberOfVertices += vertexCounter;

	}

}

BoxBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
BoxBufferGeometry.prototype.constructor = BoxBufferGeometry;

/**
 * @author mrdoob / http://mrdoob.com/
 * based on http://papervision3d.googlecode.com/svn/trunk/as3/trunk/src/org/papervision3d/objects/primitives/Plane.as
 */

function PlaneBufferGeometry( width, height, widthSegments, heightSegments ) {

	BufferGeometry.call( this );

	this.type = 'PlaneBufferGeometry';

	this.parameters = {
		width: width,
		height: height,
		widthSegments: widthSegments,
		heightSegments: heightSegments
	};

	var width_half = width / 2;
	var height_half = height / 2;

	var gridX = Math.floor( widthSegments ) || 1;
	var gridY = Math.floor( heightSegments ) || 1;

	var gridX1 = gridX + 1;
	var gridY1 = gridY + 1;

	var segment_width = width / gridX;
	var segment_height = height / gridY;

	var vertices = new Float32Array( gridX1 * gridY1 * 3 );
	var normals = new Float32Array( gridX1 * gridY1 * 3 );
	var uvs = new Float32Array( gridX1 * gridY1 * 2 );

	var offset = 0;
	var offset2 = 0;

	for ( var iy = 0; iy < gridY1; iy ++ ) {

		var y = iy * segment_height - height_half;

		for ( var ix = 0; ix < gridX1; ix ++ ) {

			var x = ix * segment_width - width_half;

			vertices[ offset ] = x;
			vertices[ offset + 1 ] = - y;

			normals[ offset + 2 ] = 1;

			uvs[ offset2 ] = ix / gridX;
			uvs[ offset2 + 1 ] = 1 - ( iy / gridY );

			offset += 3;
			offset2 += 2;

		}

	}

	offset = 0;

	var indices = new ( ( vertices.length / 3 ) > 65535 ? Uint32Array : Uint16Array )( gridX * gridY * 6 );

	for ( var iy = 0; iy < gridY; iy ++ ) {

		for ( var ix = 0; ix < gridX; ix ++ ) {

			var a = ix + gridX1 * iy;
			var b = ix + gridX1 * ( iy + 1 );
			var c = ( ix + 1 ) + gridX1 * ( iy + 1 );
			var d = ( ix + 1 ) + gridX1 * iy;

			indices[ offset ] = a;
			indices[ offset + 1 ] = b;
			indices[ offset + 2 ] = d;

			indices[ offset + 3 ] = b;
			indices[ offset + 4 ] = c;
			indices[ offset + 5 ] = d;

			offset += 6;

		}

	}

	this.setIndex( new BufferAttribute( indices, 1 ) );
	this.addAttribute( 'position', new BufferAttribute( vertices, 3 ) );
	this.addAttribute( 'normal', new BufferAttribute( normals, 3 ) );
	this.addAttribute( 'uv', new BufferAttribute( uvs, 2 ) );

}

PlaneBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
PlaneBufferGeometry.prototype.constructor = PlaneBufferGeometry;

/**
 * @author mrdoob / http://mrdoob.com/
 * @author mikael emtinger / http://gomo.se/
 * @author WestLangley / http://github.com/WestLangley
*/

function Camera() {

	Object3D.call( this );

	this.type = 'Camera';

	this.matrixWorldInverse = new Matrix4();
	this.projectionMatrix = new Matrix4();

}

Camera.prototype = Object.create( Object3D.prototype );
Camera.prototype.constructor = Camera;

Camera.prototype.isCamera = true;

Camera.prototype.getWorldDirection = function () {

	var quaternion = new Quaternion();

	return function getWorldDirection( optionalTarget ) {

		var result = optionalTarget || new Vector3();

		this.getWorldQuaternion( quaternion );

		return result.set( 0, 0, - 1 ).applyQuaternion( quaternion );

	};

}();

Camera.prototype.lookAt = function () {

	// This routine does not support cameras with rotated and/or translated parent(s)

	var m1 = new Matrix4();

	return function lookAt( vector ) {

		m1.lookAt( this.position, vector, this.up );

		this.quaternion.setFromRotationMatrix( m1 );

	};

}();

Camera.prototype.clone = function () {

	return new this.constructor().copy( this );

};

Camera.prototype.copy = function ( source ) {

	Object3D.prototype.copy.call( this, source );

	this.matrixWorldInverse.copy( source.matrixWorldInverse );
	this.projectionMatrix.copy( source.projectionMatrix );

	return this;

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author greggman / http://games.greggman.com/
 * @author zz85 / http://www.lab4games.net/zz85/blog
 * @author tschw
 */

function PerspectiveCamera( fov, aspect, near, far ) {

	Camera.call( this );

	this.type = 'PerspectiveCamera';

	this.fov = fov !== undefined ? fov : 50;
	this.zoom = 1;

	this.near = near !== undefined ? near : 0.1;
	this.far = far !== undefined ? far : 2000;
	this.focus = 10;

	this.aspect = aspect !== undefined ? aspect : 1;
	this.view = null;

	this.filmGauge = 35;	// width of the film (default in millimeters)
	this.filmOffset = 0;	// horizontal film offset (same unit as gauge)

	this.updateProjectionMatrix();

}

PerspectiveCamera.prototype = Object.assign( Object.create( Camera.prototype ), {

	constructor: PerspectiveCamera,

	isPerspectiveCamera: true,

	copy: function ( source ) {

		Camera.prototype.copy.call( this, source );

		this.fov = source.fov;
		this.zoom = source.zoom;

		this.near = source.near;
		this.far = source.far;
		this.focus = source.focus;

		this.aspect = source.aspect;
		this.view = source.view === null ? null : Object.assign( {}, source.view );

		this.filmGauge = source.filmGauge;
		this.filmOffset = source.filmOffset;

		return this;

	},

	/**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */
	setFocalLength: function ( focalLength ) {

		// see http://www.bobatkins.com/photography/technical/field_of_view.html
		var vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;

		this.fov = _Math.RAD2DEG * 2 * Math.atan( vExtentSlope );
		this.updateProjectionMatrix();

	},

	/**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */
	getFocalLength: function () {

		var vExtentSlope = Math.tan( _Math.DEG2RAD * 0.5 * this.fov );

		return 0.5 * this.getFilmHeight() / vExtentSlope;

	},

	getEffectiveFOV: function () {

		return _Math.RAD2DEG * 2 * Math.atan(
				Math.tan( _Math.DEG2RAD * 0.5 * this.fov ) / this.zoom );

	},

	getFilmWidth: function () {

		// film not completely covered in portrait format (aspect < 1)
		return this.filmGauge * Math.min( this.aspect, 1 );

	},

	getFilmHeight: function () {

		// film not completely covered in landscape format (aspect > 1)
		return this.filmGauge / Math.max( this.aspect, 1 );

	},

	/**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   var w = 1920;
	 *   var h = 1080;
	 *   var fullWidth = w * 3;
	 *   var fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */
	setViewOffset: function ( fullWidth, fullHeight, x, y, width, height ) {

		this.aspect = fullWidth / fullHeight;

		this.view = {
			fullWidth: fullWidth,
			fullHeight: fullHeight,
			offsetX: x,
			offsetY: y,
			width: width,
			height: height
		};

		this.updateProjectionMatrix();

	},

	clearViewOffset: function() {

		this.view = null;
		this.updateProjectionMatrix();

	},

	updateProjectionMatrix: function () {

		var near = this.near,
			top = near * Math.tan(
					_Math.DEG2RAD * 0.5 * this.fov ) / this.zoom,
			height = 2 * top,
			width = this.aspect * height,
			left = - 0.5 * width,
			view = this.view;

		if ( view !== null ) {

			var fullWidth = view.fullWidth,
				fullHeight = view.fullHeight;

			left += view.offsetX * width / fullWidth;
			top -= view.offsetY * height / fullHeight;
			width *= view.width / fullWidth;
			height *= view.height / fullHeight;

		}

		var skew = this.filmOffset;
		if ( skew !== 0 ) left += near * skew / this.getFilmWidth();

		this.projectionMatrix.makeFrustum(
				left, left + width, top - height, top, near, this.far );

	},

	toJSON: function ( meta ) {

		var data = Object3D.prototype.toJSON.call( this, meta );

		data.object.fov = this.fov;
		data.object.zoom = this.zoom;

		data.object.near = this.near;
		data.object.far = this.far;
		data.object.focus = this.focus;

		data.object.aspect = this.aspect;

		if ( this.view !== null ) data.object.view = Object.assign( {}, this.view );

		data.object.filmGauge = this.filmGauge;
		data.object.filmOffset = this.filmOffset;

		return data;

	}

} );

/**
 * @author alteredq / http://alteredqualia.com/
 * @author arose / http://github.com/arose
 */

function OrthographicCamera( left, right, top, bottom, near, far ) {

	Camera.call( this );

	this.type = 'OrthographicCamera';

	this.zoom = 1;
	this.view = null;

	this.left = left;
	this.right = right;
	this.top = top;
	this.bottom = bottom;

	this.near = ( near !== undefined ) ? near : 0.1;
	this.far = ( far !== undefined ) ? far : 2000;

	this.updateProjectionMatrix();

}

OrthographicCamera.prototype = Object.assign( Object.create( Camera.prototype ), {

	constructor: OrthographicCamera,

	isOrthographicCamera: true,

	copy: function ( source ) {

		Camera.prototype.copy.call( this, source );

		this.left = source.left;
		this.right = source.right;
		this.top = source.top;
		this.bottom = source.bottom;
		this.near = source.near;
		this.far = source.far;

		this.zoom = source.zoom;
		this.view = source.view === null ? null : Object.assign( {}, source.view );

		return this;

	},

	setViewOffset: function( fullWidth, fullHeight, x, y, width, height ) {

		this.view = {
			fullWidth: fullWidth,
			fullHeight: fullHeight,
			offsetX: x,
			offsetY: y,
			width: width,
			height: height
		};

		this.updateProjectionMatrix();

	},

	clearViewOffset: function() {

		this.view = null;
		this.updateProjectionMatrix();

	},

	updateProjectionMatrix: function () {

		var dx = ( this.right - this.left ) / ( 2 * this.zoom );
		var dy = ( this.top - this.bottom ) / ( 2 * this.zoom );
		var cx = ( this.right + this.left ) / 2;
		var cy = ( this.top + this.bottom ) / 2;

		var left = cx - dx;
		var right = cx + dx;
		var top = cy + dy;
		var bottom = cy - dy;

		if ( this.view !== null ) {

			var zoomW = this.zoom / ( this.view.width / this.view.fullWidth );
			var zoomH = this.zoom / ( this.view.height / this.view.fullHeight );
			var scaleW = ( this.right - this.left ) / this.view.width;
			var scaleH = ( this.top - this.bottom ) / this.view.height;

			left += scaleW * ( this.view.offsetX / zoomW );
			right = left + scaleW * ( this.view.width / zoomW );
			top -= scaleH * ( this.view.offsetY / zoomH );
			bottom = top - scaleH * ( this.view.height / zoomH );

		}

		this.projectionMatrix.makeOrthographic( left, right, top, bottom, this.near, this.far );

	},

	toJSON: function ( meta ) {

		var data = Object3D.prototype.toJSON.call( this, meta );

		data.object.zoom = this.zoom;
		data.object.left = this.left;
		data.object.right = this.right;
		data.object.top = this.top;
		data.object.bottom = this.bottom;
		data.object.near = this.near;
		data.object.far = this.far;

		if ( this.view !== null ) data.object.view = Object.assign( {}, this.view );

		return data;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLIndexedBufferRenderer( gl, extensions, infoRender ) {

	var mode;

	function setMode( value ) {

		mode = value;

	}

	var type, size;

	function setIndex( index ) {

		if ( index.array instanceof Uint32Array && extensions.get( 'OES_element_index_uint' ) ) {

			type = gl.UNSIGNED_INT;
			size = 4;

		} else if ( index.array instanceof Uint16Array ) {

			type = gl.UNSIGNED_SHORT;
			size = 2;

		} else {
			
			type = gl.UNSIGNED_BYTE;
			size = 1;
		}

	}

	function render( start, count ) {

		gl.drawElements( mode, count, type, start * size );

		infoRender.calls ++;
		infoRender.vertices += count;

		if ( mode === gl.TRIANGLES ) infoRender.faces += count / 3;

	}

	function renderInstances( geometry, start, count ) {

		var extension = extensions.get( 'ANGLE_instanced_arrays' );

		if ( extension === null ) {

			console.error( 'THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
			return;

		}

		extension.drawElementsInstancedANGLE( mode, count, type, start * size, geometry.maxInstancedCount );

		infoRender.calls ++;
		infoRender.vertices += count * geometry.maxInstancedCount;

		if ( mode === gl.TRIANGLES ) infoRender.faces += geometry.maxInstancedCount * count / 3;

	}

	return {

		setMode: setMode,
		setIndex: setIndex,
		render: render,
		renderInstances: renderInstances

	};

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLBufferRenderer( gl, extensions, infoRender ) {

	var mode;

	function setMode( value ) {

		mode = value;

	}

	function render( start, count ) {

		gl.drawArrays( mode, start, count );

		infoRender.calls ++;
		infoRender.vertices += count;

		if ( mode === gl.TRIANGLES ) infoRender.faces += count / 3;

	}

	function renderInstances( geometry ) {

		var extension = extensions.get( 'ANGLE_instanced_arrays' );

		if ( extension === null ) {

			console.error( 'THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
			return;

		}

		var position = geometry.attributes.position;

		var count = 0;

		if ( position.isInterleavedBufferAttribute ) {

			count = position.data.count;

			extension.drawArraysInstancedANGLE( mode, 0, count, geometry.maxInstancedCount );

		} else {

			count = position.count;

			extension.drawArraysInstancedANGLE( mode, 0, count, geometry.maxInstancedCount );

		}

		infoRender.calls ++;
		infoRender.vertices += count * geometry.maxInstancedCount;

		if ( mode === gl.TRIANGLES ) infoRender.faces += geometry.maxInstancedCount * count / 3;

	}

	return {
		setMode: setMode,
		render: render,
		renderInstances: renderInstances
	};

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLLights() {

	var lights = {};

	return {

		get: function ( light ) {

			if ( lights[ light.id ] !== undefined ) {

				return lights[ light.id ];

			}

			var uniforms;

			switch ( light.type ) {

				case 'DirectionalLight':
					uniforms = {
						direction: new Vector3(),
						color: new Color(),

						shadow: false,
						shadowBias: 0,
						shadowRadius: 1,
						shadowMapSize: new Vector2()
					};
					break;

				case 'SpotLight':
					uniforms = {
						position: new Vector3(),
						direction: new Vector3(),
						color: new Color(),
						distance: 0,
						coneCos: 0,
						penumbraCos: 0,
						decay: 0,

						shadow: false,
						shadowBias: 0,
						shadowRadius: 1,
						shadowMapSize: new Vector2()
					};
					break;

				case 'PointLight':
					uniforms = {
						position: new Vector3(),
						color: new Color(),
						distance: 0,
						decay: 0,

						shadow: false,
						shadowBias: 0,
						shadowRadius: 1,
						shadowMapSize: new Vector2()
					};
					break;

				case 'HemisphereLight':
					uniforms = {
						direction: new Vector3(),
						skyColor: new Color(),
						groundColor: new Color()
					};
					break;

				case 'RectAreaLight':
					uniforms = {
						color: new Color(),
						position: new Vector3(),
						halfWidth: new Vector3(),
						halfHeight: new Vector3()
						// TODO (abelnation): set RectAreaLight shadow uniforms
					};
					break;

			}

			lights[ light.id ] = uniforms;

			return uniforms;

		}

	};

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function addLineNumbers( string ) {

	var lines = string.split( '\n' );

	for ( var i = 0; i < lines.length; i ++ ) {

		lines[ i ] = ( i + 1 ) + ': ' + lines[ i ];

	}

	return lines.join( '\n' );

}

function WebGLShader( gl, type, string ) {

	var shader = gl.createShader( type );

	gl.shaderSource( shader, string );
	gl.compileShader( shader );

	if ( gl.getShaderParameter( shader, gl.COMPILE_STATUS ) === false ) {

		console.error( 'THREE.WebGLShader: Shader couldn\'t compile.' );

	}

	if ( gl.getShaderInfoLog( shader ) !== '' ) {

		console.warn( 'THREE.WebGLShader: gl.getShaderInfoLog()', type === gl.VERTEX_SHADER ? 'vertex' : 'fragment', gl.getShaderInfoLog( shader ), addLineNumbers( string ) );

	}

	// --enable-privileged-webgl-extension
	// console.log( type, gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );

	return shader;

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

var programIdCount = 0;

function getEncodingComponents( encoding ) {

	switch ( encoding ) {

		case LinearEncoding:
			return [ 'Linear','( value )' ];
		case sRGBEncoding:
			return [ 'sRGB','( value )' ];
		case RGBEEncoding:
			return [ 'RGBE','( value )' ];
		case RGBM7Encoding:
			return [ 'RGBM','( value, 7.0 )' ];
		case RGBM16Encoding:
			return [ 'RGBM','( value, 16.0 )' ];
		case RGBDEncoding:
			return [ 'RGBD','( value, 256.0 )' ];
		case GammaEncoding:
			return [ 'Gamma','( value, float( GAMMA_FACTOR ) )' ];
		default:
			throw new Error( 'unsupported encoding: ' + encoding );

	}

}

function getTexelDecodingFunction( functionName, encoding ) {

	var components = getEncodingComponents( encoding );
	return "vec4 " + functionName + "( vec4 value ) { return " + components[ 0 ] + "ToLinear" + components[ 1 ] + "; }";

}

function getTexelEncodingFunction( functionName, encoding ) {

	var components = getEncodingComponents( encoding );
	return "vec4 " + functionName + "( vec4 value ) { return LinearTo" + components[ 0 ] + components[ 1 ] + "; }";

}

function getToneMappingFunction( functionName, toneMapping ) {

	var toneMappingName;

	switch ( toneMapping ) {

		case LinearToneMapping:
			toneMappingName = "Linear";
			break;

		case ReinhardToneMapping:
			toneMappingName = "Reinhard";
			break;

		case Uncharted2ToneMapping:
			toneMappingName = "Uncharted2";
			break;

		case CineonToneMapping:
			toneMappingName = "OptimizedCineon";
			break;

		default:
			throw new Error( 'unsupported toneMapping: ' + toneMapping );

	}

	return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";

}

function generateExtensions( extensions, parameters, rendererExtensions ) {

	extensions = extensions || {};

	var chunks = [
		( extensions.derivatives || parameters.envMapCubeUV || parameters.bumpMap || parameters.normalMap || parameters.flatShading ) ? '#extension GL_OES_standard_derivatives : enable' : '',
		( extensions.fragDepth || parameters.logarithmicDepthBuffer ) && rendererExtensions.get( 'EXT_frag_depth' ) ? '#extension GL_EXT_frag_depth : enable' : '',
		( extensions.drawBuffers ) && rendererExtensions.get( 'WEBGL_draw_buffers' ) ? '#extension GL_EXT_draw_buffers : require' : '',
		( extensions.shaderTextureLOD || parameters.envMap ) && rendererExtensions.get( 'EXT_shader_texture_lod' ) ? '#extension GL_EXT_shader_texture_lod : enable' : ''
	];

	return chunks.filter( filterEmptyLine ).join( '\n' );

}

function generateDefines( defines ) {

	var chunks = [];

	for ( var name in defines ) {

		var value = defines[ name ];

		if ( value === false ) continue;

		chunks.push( '#define ' + name + ' ' + value );

	}

	return chunks.join( '\n' );

}

function fetchAttributeLocations( gl, program, identifiers ) {

	var attributes = {};

	var n = gl.getProgramParameter( program, gl.ACTIVE_ATTRIBUTES );

	for ( var i = 0; i < n; i ++ ) {

		var info = gl.getActiveAttrib( program, i );
		var name = info.name;

		// console.log("THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:", name, i );

		attributes[ name ] = gl.getAttribLocation( program, name );

	}

	return attributes;

}

function filterEmptyLine( string ) {

	return string !== '';

}

function replaceLightNums( string, parameters ) {

	return string
		.replace( /NUM_DIR_LIGHTS/g, parameters.numDirLights )
		.replace( /NUM_SPOT_LIGHTS/g, parameters.numSpotLights )
		.replace( /NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights )
		.replace( /NUM_POINT_LIGHTS/g, parameters.numPointLights )
		.replace( /NUM_HEMI_LIGHTS/g, parameters.numHemiLights );

}

function parseIncludes( string ) {

	var pattern = /#include +<([\w\d.]+)>/g;

	function replace( match, include ) {

		var replace = ShaderChunk[ include ];

		if ( replace === undefined ) {

			throw new Error( 'Can not resolve #include <' + include + '>' );

		}

		return parseIncludes( replace );

	}

	return string.replace( pattern, replace );

}

function unrollLoops( string ) {

	var pattern = /for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;

	function replace( match, start, end, snippet ) {

		var unroll = '';

		for ( var i = parseInt( start ); i < parseInt( end ); i ++ ) {

			unroll += snippet.replace( /\[ i \]/g, '[ ' + i + ' ]' );

		}

		return unroll;

	}

	return string.replace( pattern, replace );

}

function WebGLProgram( renderer, code, material, parameters ) {

	var gl = renderer.context;

	var extensions = material.extensions;
	var defines = material.defines;

	var vertexShader = material.__webglShader.vertexShader;
	var fragmentShader = material.__webglShader.fragmentShader;

	var shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';

	if ( parameters.shadowMapType === PCFShadowMap ) {

		shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';

	} else if ( parameters.shadowMapType === PCFSoftShadowMap ) {

		shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';

	}

	var envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
	var envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
	var envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';

	if ( parameters.envMap ) {

		switch ( material.envMap.mapping ) {

			case CubeReflectionMapping:
			case CubeRefractionMapping:
				envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
				break;

			case CubeUVReflectionMapping:
			case CubeUVRefractionMapping:
				envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
				break;

			case EquirectangularReflectionMapping:
			case EquirectangularRefractionMapping:
				envMapTypeDefine = 'ENVMAP_TYPE_EQUIREC';
				break;

			case SphericalReflectionMapping:
				envMapTypeDefine = 'ENVMAP_TYPE_SPHERE';
				break;

		}

		switch ( material.envMap.mapping ) {

			case CubeRefractionMapping:
			case EquirectangularRefractionMapping:
				envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
				break;

		}

		switch ( material.combine ) {

			case MultiplyOperation:
				envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
				break;

			case MixOperation:
				envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
				break;

			case AddOperation:
				envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
				break;

		}

	}

	var gammaFactorDefine = ( renderer.gammaFactor > 0 ) ? renderer.gammaFactor : 1.0;

	// console.log( 'building new program ' );

	//

	var customExtensions = generateExtensions( extensions, parameters, renderer.extensions );

	var customDefines = generateDefines( defines );

	//

	var program = gl.createProgram();

	var prefixVertex, prefixFragment;

	if ( material.isRawShaderMaterial ) {

		prefixVertex = [

			customDefines,

			'\n'

		].filter( filterEmptyLine ).join( '\n' );

		prefixFragment = [

			customExtensions,
			customDefines,

			'\n'

		].filter( filterEmptyLine ).join( '\n' );

	} else {

		prefixVertex = [

			'precision ' + parameters.precision + ' float;',
			'precision ' + parameters.precision + ' int;',

			'#define SHADER_NAME ' + material.__webglShader.name,

			customDefines,

			parameters.supportsVertexTextures ? '#define VERTEX_TEXTURES' : '',

			'#define GAMMA_FACTOR ' + gammaFactorDefine,

			'#define MAX_BONES ' + parameters.maxBones,

			parameters.map ? '#define USE_MAP' : '',
			parameters.envMap ? '#define USE_ENVMAP' : '',
			parameters.envMap ? '#define ' + envMapModeDefine : '',
			parameters.lightMap ? '#define USE_LIGHTMAP' : '',
			parameters.aoMap ? '#define USE_AOMAP' : '',
			parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
			parameters.bumpMap ? '#define USE_BUMPMAP' : '',
			parameters.normalMap ? '#define USE_NORMALMAP' : '',
			parameters.displacementMap && parameters.supportsVertexTextures ? '#define USE_DISPLACEMENTMAP' : '',
			parameters.specularMap ? '#define USE_SPECULARMAP' : '',
			parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
			parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
			parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
			parameters.vertexColors ? '#define USE_COLOR' : '',

			parameters.flatShading ? '#define FLAT_SHADED' : '',

			parameters.skinning ? '#define USE_SKINNING' : '',
			parameters.useVertexTexture ? '#define BONE_TEXTURE' : '',

			parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
			parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
			parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
			parameters.flipSided ? '#define FLIP_SIDED' : '',

			'#define NUM_CLIPPING_PLANES ' + parameters.numClippingPlanes,

			parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
			parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',

			parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',

			parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
			parameters.logarithmicDepthBuffer && renderer.extensions.get( 'EXT_frag_depth' ) ? '#define USE_LOGDEPTHBUF_EXT' : '',

			'uniform mat4 modelMatrix;',
			'uniform mat4 modelViewMatrix;',
			'uniform mat4 projectionMatrix;',
			'uniform mat4 viewMatrix;',
			'uniform mat3 normalMatrix;',
			'uniform vec3 cameraPosition;',

			'attribute vec3 position;',
			'attribute vec3 normal;',
			'attribute vec2 uv;',

			'#ifdef USE_COLOR',

			'	attribute vec3 color;',

			'#endif',

			'#ifdef USE_MORPHTARGETS',

			'	attribute vec3 morphTarget0;',
			'	attribute vec3 morphTarget1;',
			'	attribute vec3 morphTarget2;',
			'	attribute vec3 morphTarget3;',

			'	#ifdef USE_MORPHNORMALS',

			'		attribute vec3 morphNormal0;',
			'		attribute vec3 morphNormal1;',
			'		attribute vec3 morphNormal2;',
			'		attribute vec3 morphNormal3;',

			'	#else',

			'		attribute vec3 morphTarget4;',
			'		attribute vec3 morphTarget5;',
			'		attribute vec3 morphTarget6;',
			'		attribute vec3 morphTarget7;',

			'	#endif',

			'#endif',

			'#ifdef USE_SKINNING',

			'	attribute vec4 skinIndex;',
			'	attribute vec4 skinWeight;',

			'#endif',

			'\n'

		].filter( filterEmptyLine ).join( '\n' );

		prefixFragment = [

			customExtensions,

			'precision ' + parameters.precision + ' float;',
			'precision ' + parameters.precision + ' int;',

			'#define SHADER_NAME ' + material.__webglShader.name,

			customDefines,

			parameters.alphaTest ? '#define ALPHATEST ' + parameters.alphaTest : '',

			'#define GAMMA_FACTOR ' + gammaFactorDefine,

			( parameters.useFog && parameters.fog ) ? '#define USE_FOG' : '',
			( parameters.useFog && parameters.fogExp ) ? '#define FOG_EXP2' : '',

			parameters.map ? '#define USE_MAP' : '',
			parameters.envMap ? '#define USE_ENVMAP' : '',
			parameters.envMap ? '#define ' + envMapTypeDefine : '',
			parameters.envMap ? '#define ' + envMapModeDefine : '',
			parameters.envMap ? '#define ' + envMapBlendingDefine : '',
			parameters.lightMap ? '#define USE_LIGHTMAP' : '',
			parameters.aoMap ? '#define USE_AOMAP' : '',
			parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
			parameters.bumpMap ? '#define USE_BUMPMAP' : '',
			parameters.normalMap ? '#define USE_NORMALMAP' : '',
			parameters.specularMap ? '#define USE_SPECULARMAP' : '',
			parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
			parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
			parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
			parameters.vertexColors ? '#define USE_COLOR' : '',

			parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',

			parameters.flatShading ? '#define FLAT_SHADED' : '',

			parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
			parameters.flipSided ? '#define FLIP_SIDED' : '',

			'#define NUM_CLIPPING_PLANES ' + parameters.numClippingPlanes,
			'#define UNION_CLIPPING_PLANES ' + (parameters.numClippingPlanes - parameters.numClipIntersection),

			parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
			parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',

			parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : '',

			parameters.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : '',

			parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
			parameters.logarithmicDepthBuffer && renderer.extensions.get( 'EXT_frag_depth' ) ? '#define USE_LOGDEPTHBUF_EXT' : '',

			parameters.envMap && renderer.extensions.get( 'EXT_shader_texture_lod' ) ? '#define TEXTURE_LOD_EXT' : '',

			'uniform mat4 viewMatrix;',
			'uniform vec3 cameraPosition;',

			( parameters.toneMapping !== NoToneMapping ) ? "#define TONE_MAPPING" : '',
			( parameters.toneMapping !== NoToneMapping ) ? ShaderChunk[ 'tonemapping_pars_fragment' ] : '',  // this code is required here because it is used by the toneMapping() function defined below
			( parameters.toneMapping !== NoToneMapping ) ? getToneMappingFunction( "toneMapping", parameters.toneMapping ) : '',

			( parameters.outputEncoding || parameters.mapEncoding || parameters.envMapEncoding || parameters.emissiveMapEncoding ) ? ShaderChunk[ 'encodings_pars_fragment' ] : '', // this code is required here because it is used by the various encoding/decoding function defined below
			parameters.mapEncoding ? getTexelDecodingFunction( 'mapTexelToLinear', parameters.mapEncoding ) : '',
			parameters.envMapEncoding ? getTexelDecodingFunction( 'envMapTexelToLinear', parameters.envMapEncoding ) : '',
			parameters.emissiveMapEncoding ? getTexelDecodingFunction( 'emissiveMapTexelToLinear', parameters.emissiveMapEncoding ) : '',
			parameters.outputEncoding ? getTexelEncodingFunction( "linearToOutputTexel", parameters.outputEncoding ) : '',

			parameters.depthPacking ? "#define DEPTH_PACKING " + material.depthPacking : '',

			'\n'

		].filter( filterEmptyLine ).join( '\n' );

	}

	vertexShader = parseIncludes( vertexShader, parameters );
	vertexShader = replaceLightNums( vertexShader, parameters );

	fragmentShader = parseIncludes( fragmentShader, parameters );
	fragmentShader = replaceLightNums( fragmentShader, parameters );

	if ( ! material.isShaderMaterial ) {

		vertexShader = unrollLoops( vertexShader );
		fragmentShader = unrollLoops( fragmentShader );

	}

	var vertexGlsl = prefixVertex + vertexShader;
	var fragmentGlsl = prefixFragment + fragmentShader;

	// console.log( '*VERTEX*', vertexGlsl );
	// console.log( '*FRAGMENT*', fragmentGlsl );

	var glVertexShader = WebGLShader( gl, gl.VERTEX_SHADER, vertexGlsl );
	var glFragmentShader = WebGLShader( gl, gl.FRAGMENT_SHADER, fragmentGlsl );

	gl.attachShader( program, glVertexShader );
	gl.attachShader( program, glFragmentShader );

	// Force a particular attribute to index 0.

	if ( material.index0AttributeName !== undefined ) {

		gl.bindAttribLocation( program, 0, material.index0AttributeName );

	} else if ( parameters.morphTargets === true ) {

		// programs with morphTargets displace position out of attribute 0
		gl.bindAttribLocation( program, 0, 'position' );

	}

	gl.linkProgram( program );

	var programLog = gl.getProgramInfoLog( program );
	var vertexLog = gl.getShaderInfoLog( glVertexShader );
	var fragmentLog = gl.getShaderInfoLog( glFragmentShader );

	var runnable = true;
	var haveDiagnostics = true;

	// console.log( '**VERTEX**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( glVertexShader ) );
	// console.log( '**FRAGMENT**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( glFragmentShader ) );

	if ( gl.getProgramParameter( program, gl.LINK_STATUS ) === false ) {

		runnable = false;

		console.error( 'THREE.WebGLProgram: shader error: ', gl.getError(), 'gl.VALIDATE_STATUS', gl.getProgramParameter( program, gl.VALIDATE_STATUS ), 'gl.getProgramInfoLog', programLog, vertexLog, fragmentLog );

	} else if ( programLog !== '' ) {

		console.warn( 'THREE.WebGLProgram: gl.getProgramInfoLog()', programLog );

	} else if ( vertexLog === '' || fragmentLog === '' ) {

		haveDiagnostics = false;

	}

	if ( haveDiagnostics ) {

		this.diagnostics = {

			runnable: runnable,
			material: material,

			programLog: programLog,

			vertexShader: {

				log: vertexLog,
				prefix: prefixVertex

			},

			fragmentShader: {

				log: fragmentLog,
				prefix: prefixFragment

			}

		};

	}

	// clean up

	gl.deleteShader( glVertexShader );
	gl.deleteShader( glFragmentShader );

	// set up caching for uniform locations

	var cachedUniforms;

	this.getUniforms = function() {

		if ( cachedUniforms === undefined ) {

			cachedUniforms =
				new WebGLUniforms( gl, program, renderer );

		}

		return cachedUniforms;

	};

	// set up caching for attribute locations

	var cachedAttributes;

	this.getAttributes = function() {

		if ( cachedAttributes === undefined ) {

			cachedAttributes = fetchAttributeLocations( gl, program );

		}

		return cachedAttributes;

	};

	// free resource

	this.destroy = function() {

		gl.deleteProgram( program );
		this.program = undefined;

	};

	// DEPRECATED

	Object.defineProperties( this, {

		uniforms: {
			get: function() {

				console.warn( 'THREE.WebGLProgram: .uniforms is now .getUniforms().' );
				return this.getUniforms();

			}
		},

		attributes: {
			get: function() {

				console.warn( 'THREE.WebGLProgram: .attributes is now .getAttributes().' );
				return this.getAttributes();

			}
		}

	} );


	//

	this.id = programIdCount ++;
	this.code = code;
	this.usedTimes = 1;
	this.program = program;
	this.vertexShader = glVertexShader;
	this.fragmentShader = glFragmentShader;

	return this;

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLPrograms( renderer, capabilities ) {

	var programs = [];

	var shaderIDs = {
		MeshDepthMaterial: 'depth',
		MeshNormalMaterial: 'normal',
		MeshBasicMaterial: 'basic',
		MeshLambertMaterial: 'lambert',
		MeshPhongMaterial: 'phong',
		MeshToonMaterial: 'phong',
		MeshStandardMaterial: 'physical',
		MeshPhysicalMaterial: 'physical',
		LineBasicMaterial: 'basic',
		LineDashedMaterial: 'dashed',
		PointsMaterial: 'points'
	};

	var parameterNames = [
		"precision", "supportsVertexTextures", "map", "mapEncoding", "envMap", "envMapMode", "envMapEncoding",
		"lightMap", "aoMap", "emissiveMap", "emissiveMapEncoding", "bumpMap", "normalMap", "displacementMap", "specularMap",
		"roughnessMap", "metalnessMap", "gradientMap",
		"alphaMap", "combine", "vertexColors", "fog", "useFog", "fogExp",
		"flatShading", "sizeAttenuation", "logarithmicDepthBuffer", "skinning",
		"maxBones", "useVertexTexture", "morphTargets", "morphNormals",
		"maxMorphTargets", "maxMorphNormals", "premultipliedAlpha",
		"numDirLights", "numPointLights", "numSpotLights", "numHemiLights", "numRectAreaLights",
		"shadowMapEnabled", "shadowMapType", "toneMapping", 'physicallyCorrectLights',
		"alphaTest", "doubleSided", "flipSided", "numClippingPlanes", "numClipIntersection", "depthPacking"
	];


	function allocateBones( object ) {

		if ( capabilities.floatVertexTextures && object && object.skeleton && object.skeleton.useVertexTexture ) {

			return 1024;

		} else {

			// default for when object is not specified
			// ( for example when prebuilding shader to be used with multiple objects )
			//
			//  - leave some extra space for other uniforms
			//  - limit here is ANGLE's 254 max uniform vectors
			//    (up to 54 should be safe)

			var nVertexUniforms = capabilities.maxVertexUniforms;
			var nVertexMatrices = Math.floor( ( nVertexUniforms - 20 ) / 4 );

			var maxBones = nVertexMatrices;

			if ( object !== undefined && (object && object.isSkinnedMesh) ) {

				maxBones = Math.min( object.skeleton.bones.length, maxBones );

				if ( maxBones < object.skeleton.bones.length ) {

					console.warn( 'WebGLRenderer: too many bones - ' + object.skeleton.bones.length + ', this GPU supports just ' + maxBones + ' (try OpenGL instead of ANGLE)' );

				}

			}

			return maxBones;

		}

	}

	function getTextureEncodingFromMap( map, gammaOverrideLinear ) {

		var encoding;

		if ( ! map ) {

			encoding = LinearEncoding;

		} else if ( map.isTexture ) {

			encoding = map.encoding;

		} else if ( map.isWebGLRenderTarget ) {

			console.warn( "THREE.WebGLPrograms.getTextureEncodingFromMap: don't use render targets as textures. Use their .texture property instead." );
			encoding = map.texture.encoding;

		}

		// add backwards compatibility for WebGLRenderer.gammaInput/gammaOutput parameter, should probably be removed at some point.
		if ( encoding === LinearEncoding && gammaOverrideLinear ) {

			encoding = GammaEncoding;

		}

		return encoding;

	}

	this.getParameters = function ( material, lights, fog, nClipPlanes, nClipIntersection, object ) {

		var shaderID = shaderIDs[ material.type ];

		// heuristics to create shader parameters according to lights in the scene
		// (not to blow over maxLights budget)

		var maxBones = allocateBones( object );
		var precision = renderer.getPrecision();

		if ( material.precision !== null ) {

			precision = capabilities.getMaxPrecision( material.precision );

			if ( precision !== material.precision ) {

				console.warn( 'THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.' );

			}

		}

		var currentRenderTarget = renderer.getCurrentRenderTarget();

		var parameters = {

			shaderID: shaderID,

			precision: precision,
			supportsVertexTextures: capabilities.vertexTextures,
			outputEncoding: getTextureEncodingFromMap( ( ! currentRenderTarget ) ? null : currentRenderTarget.texture, renderer.gammaOutput ),
			map: !! material.map,
			mapEncoding: getTextureEncodingFromMap( material.map, renderer.gammaInput ),
			envMap: !! material.envMap,
			envMapMode: material.envMap && material.envMap.mapping,
			envMapEncoding: getTextureEncodingFromMap( material.envMap, renderer.gammaInput ),
			envMapCubeUV: ( !! material.envMap ) && ( ( material.envMap.mapping === CubeUVReflectionMapping ) || ( material.envMap.mapping === CubeUVRefractionMapping ) ),
			lightMap: !! material.lightMap,
			aoMap: !! material.aoMap,
			emissiveMap: !! material.emissiveMap,
			emissiveMapEncoding: getTextureEncodingFromMap( material.emissiveMap, renderer.gammaInput ),
			bumpMap: !! material.bumpMap,
			normalMap: !! material.normalMap,
			displacementMap: !! material.displacementMap,
			roughnessMap: !! material.roughnessMap,
			metalnessMap: !! material.metalnessMap,
			specularMap: !! material.specularMap,
			alphaMap: !! material.alphaMap,

			gradientMap: !! material.gradientMap,

			combine: material.combine,

			vertexColors: material.vertexColors,

			fog: !! fog,
			useFog: material.fog,
			fogExp: (fog && fog.isFogExp2),

			flatShading: material.shading === FlatShading,

			sizeAttenuation: material.sizeAttenuation,
			logarithmicDepthBuffer: capabilities.logarithmicDepthBuffer,

			skinning: material.skinning,
			maxBones: maxBones,
			useVertexTexture: capabilities.floatVertexTextures && object && object.skeleton && object.skeleton.useVertexTexture,

			morphTargets: material.morphTargets,
			morphNormals: material.morphNormals,
			maxMorphTargets: renderer.maxMorphTargets,
			maxMorphNormals: renderer.maxMorphNormals,

			numDirLights: lights.directional.length,
			numPointLights: lights.point.length,
			numSpotLights: lights.spot.length,
			numRectAreaLights: lights.rectArea.length,
			numHemiLights: lights.hemi.length,

			numClippingPlanes: nClipPlanes,
			numClipIntersection: nClipIntersection,

			shadowMapEnabled: renderer.shadowMap.enabled && object.receiveShadow && lights.shadows.length > 0,
			shadowMapType: renderer.shadowMap.type,

			toneMapping: renderer.toneMapping,
			physicallyCorrectLights: renderer.physicallyCorrectLights,

			premultipliedAlpha: material.premultipliedAlpha,

			alphaTest: material.alphaTest,
			doubleSided: material.side === DoubleSide,
			flipSided: material.side === BackSide,

			depthPacking: ( material.depthPacking !== undefined ) ? material.depthPacking : false

		};

		return parameters;

	};

	this.getProgramCode = function ( material, parameters ) {

		var array = [];

		if ( parameters.shaderID ) {

			array.push( parameters.shaderID );

		} else {

			array.push( material.fragmentShader );
			array.push( material.vertexShader );

		}

		if ( material.defines !== undefined ) {

			for ( var name in material.defines ) {

				array.push( name );
				array.push( material.defines[ name ] );

			}

		}

		for ( var i = 0; i < parameterNames.length; i ++ ) {

			array.push( parameters[ parameterNames[ i ] ] );

		}

		return array.join();

	};

	this.acquireProgram = function ( material, parameters, code ) {

		var program;

		// Check if code has been already compiled
		for ( var p = 0, pl = programs.length; p < pl; p ++ ) {

			var programInfo = programs[ p ];

			if ( programInfo.code === code ) {

				program = programInfo;
				++ program.usedTimes;

				break;

			}

		}

		if ( program === undefined ) {

			program = new WebGLProgram( renderer, code, material, parameters );
			programs.push( program );

		}

		return program;

	};

	this.releaseProgram = function( program ) {

		if ( -- program.usedTimes === 0 ) {

			// Remove from unordered set
			var i = programs.indexOf( program );
			programs[ i ] = programs[ programs.length - 1 ];
			programs.pop();

			// Free WebGL resources
			program.destroy();

		}

	};

	// Exposed for resource monitoring & error feedback via renderer.info:
	this.programs = programs;

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLGeometries( gl, properties, info ) {

	var geometries = {};

	function onGeometryDispose( event ) {

		var geometry = event.target;
		var buffergeometry = geometries[ geometry.id ];

		if ( buffergeometry.index !== null ) {

			deleteAttribute( buffergeometry.index );

		}

		deleteAttributes( buffergeometry.attributes );

		geometry.removeEventListener( 'dispose', onGeometryDispose );

		delete geometries[ geometry.id ];

		// TODO

		var property = properties.get( geometry );

		if ( property.wireframe ) {

			deleteAttribute( property.wireframe );

		}

		properties.delete( geometry );

		var bufferproperty = properties.get( buffergeometry );

		if ( bufferproperty.wireframe ) {

			deleteAttribute( bufferproperty.wireframe );

		}

		properties.delete( buffergeometry );

		//

		info.memory.geometries --;

	}

	function getAttributeBuffer( attribute ) {

		if ( attribute.isInterleavedBufferAttribute ) {

			return properties.get( attribute.data ).__webglBuffer;

		}

		return properties.get( attribute ).__webglBuffer;

	}

	function deleteAttribute( attribute ) {

		var buffer = getAttributeBuffer( attribute );

		if ( buffer !== undefined ) {

			gl.deleteBuffer( buffer );
			removeAttributeBuffer( attribute );

		}

	}

	function deleteAttributes( attributes ) {

		for ( var name in attributes ) {

			deleteAttribute( attributes[ name ] );

		}

	}

	function removeAttributeBuffer( attribute ) {

		if ( attribute.isInterleavedBufferAttribute ) {

			properties.delete( attribute.data );

		} else {

			properties.delete( attribute );

		}

	}

	return {

		get: function ( object ) {

			var geometry = object.geometry;

			if ( geometries[ geometry.id ] !== undefined ) {

				return geometries[ geometry.id ];

			}

			geometry.addEventListener( 'dispose', onGeometryDispose );

			var buffergeometry;

			if ( geometry.isBufferGeometry ) {

				buffergeometry = geometry;

			} else if ( geometry.isGeometry ) {

				if ( geometry._bufferGeometry === undefined ) {

					geometry._bufferGeometry = new BufferGeometry().setFromObject( object );

				}

				buffergeometry = geometry._bufferGeometry;

			}

			geometries[ geometry.id ] = buffergeometry;

			info.memory.geometries ++;

			return buffergeometry;

		}

	};

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLObjects( gl, properties, info ) {

	var geometries = new WebGLGeometries( gl, properties, info );

	//

	function update( object ) {

		// TODO: Avoid updating twice (when using shadowMap). Maybe add frame counter.

		var geometry = geometries.get( object );

		if ( object.geometry.isGeometry ) {

			geometry.updateFromObject( object );

		}

		var index = geometry.index;
		var attributes = geometry.attributes;

		if ( index !== null ) {

			updateAttribute( index, gl.ELEMENT_ARRAY_BUFFER );

		}

		for ( var name in attributes ) {

			updateAttribute( attributes[ name ], gl.ARRAY_BUFFER );

		}

		// morph targets

		var morphAttributes = geometry.morphAttributes;

		for ( var name in morphAttributes ) {

			var array = morphAttributes[ name ];

			for ( var i = 0, l = array.length; i < l; i ++ ) {

				updateAttribute( array[ i ], gl.ARRAY_BUFFER );

			}

		}

		return geometry;

	}

	function updateAttribute( attribute, bufferType ) {

		var data = ( attribute.isInterleavedBufferAttribute ) ? attribute.data : attribute;

		var attributeProperties = properties.get( data );

		if ( attributeProperties.__webglBuffer === undefined ) {

			createBuffer( attributeProperties, data, bufferType );

		} else if ( attributeProperties.version !== data.version ) {

			updateBuffer( attributeProperties, data, bufferType );

		}

	}

	function createBuffer( attributeProperties, data, bufferType ) {

		attributeProperties.__webglBuffer = gl.createBuffer();
		gl.bindBuffer( bufferType, attributeProperties.__webglBuffer );

		var usage = data.dynamic ? gl.DYNAMIC_DRAW : gl.STATIC_DRAW;

		gl.bufferData( bufferType, data.array, usage );

		var type = gl.FLOAT;
		var array = data.array;

		if ( array instanceof Float32Array ) {

			type = gl.FLOAT;

		} else if ( array instanceof Float64Array ) {

			console.warn( "Unsupported data buffer format: Float64Array" );

		} else if ( array instanceof Uint16Array ) {

			type = gl.UNSIGNED_SHORT;

		} else if ( array instanceof Int16Array ) {

			type = gl.SHORT;

		} else if ( array instanceof Uint32Array ) {

			type = gl.UNSIGNED_INT;

		} else if ( array instanceof Int32Array ) {

			type = gl.INT;

		} else if ( array instanceof Int8Array ) {

			type = gl.BYTE;

		} else if ( array instanceof Uint8Array ) {

			type = gl.UNSIGNED_BYTE;

		}

		attributeProperties.bytesPerElement = array.BYTES_PER_ELEMENT;
		attributeProperties.type = type;
		attributeProperties.version = data.version;

		data.onUploadCallback();

	}

	function updateBuffer( attributeProperties, data, bufferType ) {

		gl.bindBuffer( bufferType, attributeProperties.__webglBuffer );

		if ( data.dynamic === false ) {

			gl.bufferData( bufferType, data.array, gl.STATIC_DRAW );

		} else if ( data.updateRange.count === - 1 ) {

			// Not using update ranges

			gl.bufferSubData( bufferType, 0, data.array );

		} else if ( data.updateRange.count === 0 ) {

			console.error( 'THREE.WebGLObjects.updateBuffer: dynamic THREE.BufferAttribute marked as needsUpdate but updateRange.count is 0, ensure you are using set methods or updating manually.' );

		} else {

			gl.bufferSubData( bufferType, data.updateRange.offset * data.array.BYTES_PER_ELEMENT,
							  data.array.subarray( data.updateRange.offset, data.updateRange.offset + data.updateRange.count ) );

			data.updateRange.count = 0; // reset range

		}

		attributeProperties.version = data.version;

	}

	function getAttributeBuffer( attribute ) {

		if ( attribute.isInterleavedBufferAttribute ) {

			return properties.get( attribute.data ).__webglBuffer;

		}

		return properties.get( attribute ).__webglBuffer;

	}

	function getAttributeProperties( attribute ) {

		if ( attribute.isInterleavedBufferAttribute ) {

			return properties.get( attribute.data );

		}

		return properties.get( attribute );

	}

	function getWireframeAttribute( geometry ) {

		var property = properties.get( geometry );

		if ( property.wireframe !== undefined ) {

			return property.wireframe;

		}

		var indices = [];

		var index = geometry.index;
		var attributes = geometry.attributes;
		var position = attributes.position;

		// console.time( 'wireframe' );

		if ( index !== null ) {

			var edges = {};
			var array = index.array;

			for ( var i = 0, l = array.length; i < l; i += 3 ) {

				var a = array[ i + 0 ];
				var b = array[ i + 1 ];
				var c = array[ i + 2 ];

				indices.push( a, b, b, c, c, a );

			}

		} else {

			var array = attributes.position.array;

			for ( var i = 0, l = ( array.length / 3 ) - 1; i < l; i += 3 ) {

				var a = i + 0;
				var b = i + 1;
				var c = i + 2;

				indices.push( a, b, b, c, c, a );

			}

		}

		// console.timeEnd( 'wireframe' );

		var TypeArray = position.count > 65535 ? Uint32Array : Uint16Array;
		var attribute = new BufferAttribute( new TypeArray( indices ), 1 );

		updateAttribute( attribute, gl.ELEMENT_ARRAY_BUFFER );

		property.wireframe = attribute;

		return attribute;

	}

	return {

		getAttributeBuffer: getAttributeBuffer,
		getAttributeProperties: getAttributeProperties,
		getWireframeAttribute: getWireframeAttribute,

		update: update

	};

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLTextures( _gl, extensions, state, properties, capabilities, paramThreeToGL, info ) {

	var _infoMemory = info.memory;
	var _isWebGL2 = ( typeof WebGL2RenderingContext !== 'undefined' && _gl instanceof WebGL2RenderingContext );

	//

	function clampToMaxSize( image, maxSize ) {

		if ( image.width > maxSize || image.height > maxSize ) {

			// Warning: Scaling through the canvas will only work with images that use
			// premultiplied alpha.

			var scale = maxSize / Math.max( image.width, image.height );

			var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
			canvas.width = Math.floor( image.width * scale );
			canvas.height = Math.floor( image.height * scale );

			var context = canvas.getContext( '2d' );
			context.drawImage( image, 0, 0, image.width, image.height, 0, 0, canvas.width, canvas.height );

			console.warn( 'THREE.WebGLRenderer: image is too big (' + image.width + 'x' + image.height + '). Resized to ' + canvas.width + 'x' + canvas.height, image );

			return canvas;

		}

		return image;

	}

	function isPowerOfTwo( image ) {

		return _Math.isPowerOfTwo( image.width ) && _Math.isPowerOfTwo( image.height );

	}

	function makePowerOfTwo( image ) {

		if ( image instanceof HTMLImageElement || image instanceof HTMLCanvasElement ) {

			var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
			canvas.width = _Math.nearestPowerOfTwo( image.width );
			canvas.height = _Math.nearestPowerOfTwo( image.height );

			var context = canvas.getContext( '2d' );
			context.drawImage( image, 0, 0, canvas.width, canvas.height );

			console.warn( 'THREE.WebGLRenderer: image is not power of two (' + image.width + 'x' + image.height + '). Resized to ' + canvas.width + 'x' + canvas.height, image );

			return canvas;

		}

		return image;

	}

	function textureNeedsPowerOfTwo( texture ) {

		return ( texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping ) ||
			( texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter );

	}

	// Fallback filters for non-power-of-2 textures

	function filterFallback( f ) {

		if ( f === NearestFilter || f === NearestMipMapNearestFilter || f === NearestMipMapLinearFilter ) {

			return _gl.NEAREST;

		}

		return _gl.LINEAR;

	}

	//

	function onTextureDispose( event ) {

		var texture = event.target;

		texture.removeEventListener( 'dispose', onTextureDispose );

		deallocateTexture( texture );

		_infoMemory.textures --;


	}

	function onRenderTargetDispose( event ) {

		var renderTarget = event.target;

		renderTarget.removeEventListener( 'dispose', onRenderTargetDispose );

		deallocateRenderTarget( renderTarget );

		_infoMemory.textures --;

	}

	//

	function deallocateTexture( texture ) {

		var textureProperties = properties.get( texture );

		if ( texture.image && textureProperties.__image__webglTextureCube ) {

			// cube texture

			_gl.deleteTexture( textureProperties.__image__webglTextureCube );

		} else {

			// 2D texture

			if ( textureProperties.__webglInit === undefined ) return;

			_gl.deleteTexture( textureProperties.__webglTexture );

		}

		// remove all webgl properties
		properties.delete( texture );

	}

	function deallocateRenderTarget( renderTarget ) {

		var renderTargetProperties = properties.get( renderTarget );
		var textureProperties = properties.get( renderTarget.texture );

		if ( ! renderTarget ) return;

		if ( textureProperties.__webglTexture !== undefined ) {

			_gl.deleteTexture( textureProperties.__webglTexture );

		}

		if ( renderTarget.depthTexture ) {

			renderTarget.depthTexture.dispose();

		}

		if ( renderTarget.isWebGLRenderTargetCube ) {

			for ( var i = 0; i < 6; i ++ ) {

				_gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer[ i ] );
				if ( renderTargetProperties.__webglDepthbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthbuffer[ i ] );

			}

		} else {

			_gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer );
			if ( renderTargetProperties.__webglDepthbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthbuffer );

		}

		properties.delete( renderTarget.texture );
		properties.delete( renderTarget );

	}

	//



	function setTexture2D( texture, slot ) {

		var textureProperties = properties.get( texture );

		if ( texture.version > 0 && textureProperties.__version !== texture.version ) {

			var image = texture.image;

			if ( image === undefined ) {

				console.warn( 'THREE.WebGLRenderer: Texture marked for update but image is undefined', texture );

			} else if ( image.complete === false ) {

				console.warn( 'THREE.WebGLRenderer: Texture marked for update but image is incomplete', texture );

			} else {

				uploadTexture( textureProperties, texture, slot );
				return;

			}

		}

		state.activeTexture( _gl.TEXTURE0 + slot );
		state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );

	}

	function setTextureCube( texture, slot ) {

		var textureProperties = properties.get( texture );

		if ( texture.image.length === 6 ) {

			if ( texture.version > 0 && textureProperties.__version !== texture.version ) {

				if ( ! textureProperties.__image__webglTextureCube ) {

					texture.addEventListener( 'dispose', onTextureDispose );

					textureProperties.__image__webglTextureCube = _gl.createTexture();

					_infoMemory.textures ++;

				}

				state.activeTexture( _gl.TEXTURE0 + slot );
				state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__image__webglTextureCube );

				_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, texture.flipY );

				var isCompressed = ( texture && texture.isCompressedTexture );
				var isDataTexture = ( texture.image[ 0 ] && texture.image[ 0 ].isDataTexture );

				var cubeImage = [];

				for ( var i = 0; i < 6; i ++ ) {

					if ( ! isCompressed && ! isDataTexture ) {

						cubeImage[ i ] = clampToMaxSize( texture.image[ i ], capabilities.maxCubemapSize );

					} else {

						cubeImage[ i ] = isDataTexture ? texture.image[ i ].image : texture.image[ i ];

					}

				}

				var image = cubeImage[ 0 ],
				isPowerOfTwoImage = isPowerOfTwo( image ),
				glFormat = paramThreeToGL( texture.format ),
				glType = paramThreeToGL( texture.type );

				setTextureParameters( _gl.TEXTURE_CUBE_MAP, texture, isPowerOfTwoImage );

				for ( var i = 0; i < 6; i ++ ) {

					if ( ! isCompressed ) {

						if ( isDataTexture ) {

							state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glFormat, cubeImage[ i ].width, cubeImage[ i ].height, 0, glFormat, glType, cubeImage[ i ].data );

						} else {

							state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glFormat, glFormat, glType, cubeImage[ i ] );

						}

					} else {

						var mipmap, mipmaps = cubeImage[ i ].mipmaps;

						for ( var j = 0, jl = mipmaps.length; j < jl; j ++ ) {

							mipmap = mipmaps[ j ];

							if ( texture.format !== RGBAFormat && texture.format !== RGBFormat ) {

								if ( state.getCompressedTextureFormats().indexOf( glFormat ) > - 1 ) {

									state.compressedTexImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glFormat, mipmap.width, mipmap.height, 0, mipmap.data );

								} else {

									console.warn( "THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()" );

								}

							} else {

								state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

							}

						}

					}

				}

				if ( texture.generateMipmaps && isPowerOfTwoImage ) {

					_gl.generateMipmap( _gl.TEXTURE_CUBE_MAP );

				}

				textureProperties.__version = texture.version;

				if ( texture.onUpdate ) texture.onUpdate( texture );

			} else {

				state.activeTexture( _gl.TEXTURE0 + slot );
				state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__image__webglTextureCube );

			}

		}

	}

	function setTextureCubeDynamic( texture, slot ) {

		state.activeTexture( _gl.TEXTURE0 + slot );
		state.bindTexture( _gl.TEXTURE_CUBE_MAP, properties.get( texture ).__webglTexture );

	}

	function setTextureParameters( textureType, texture, isPowerOfTwoImage ) {

		var extension;

		if ( isPowerOfTwoImage ) {

			_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_S, paramThreeToGL( texture.wrapS ) );
			_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_T, paramThreeToGL( texture.wrapT ) );

			_gl.texParameteri( textureType, _gl.TEXTURE_MAG_FILTER, paramThreeToGL( texture.magFilter ) );
			_gl.texParameteri( textureType, _gl.TEXTURE_MIN_FILTER, paramThreeToGL( texture.minFilter ) );

		} else {

			_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_S, _gl.CLAMP_TO_EDGE );
			_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_T, _gl.CLAMP_TO_EDGE );

			if ( texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping ) {

				console.warn( 'THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.', texture );

			}

			_gl.texParameteri( textureType, _gl.TEXTURE_MAG_FILTER, filterFallback( texture.magFilter ) );
			_gl.texParameteri( textureType, _gl.TEXTURE_MIN_FILTER, filterFallback( texture.minFilter ) );

			if ( texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter ) {

				console.warn( 'THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.', texture );

			}

		}

		extension = extensions.get( 'EXT_texture_filter_anisotropic' );

		if ( extension ) {

			if ( texture.type === FloatType && extensions.get( 'OES_texture_float_linear' ) === null ) return;
			if ( texture.type === HalfFloatType && extensions.get( 'OES_texture_half_float_linear' ) === null ) return;

			if ( texture.anisotropy > 1 || properties.get( texture ).__currentAnisotropy ) {

				_gl.texParameterf( textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min( texture.anisotropy, capabilities.getMaxAnisotropy() ) );
				properties.get( texture ).__currentAnisotropy = texture.anisotropy;

			}

		}

	}

	function uploadTexture( textureProperties, texture, slot ) {

		if ( textureProperties.__webglInit === undefined ) {

			textureProperties.__webglInit = true;

			texture.addEventListener( 'dispose', onTextureDispose );

			textureProperties.__webglTexture = _gl.createTexture();

			_infoMemory.textures ++;

		}

		state.activeTexture( _gl.TEXTURE0 + slot );
		state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );

		_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, texture.flipY );
		_gl.pixelStorei( _gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha );
		_gl.pixelStorei( _gl.UNPACK_ALIGNMENT, texture.unpackAlignment );

		var image = clampToMaxSize( texture.image, capabilities.maxTextureSize );

		if ( textureNeedsPowerOfTwo( texture ) && isPowerOfTwo( image ) === false ) {

			image = makePowerOfTwo( image );

		}

		var isPowerOfTwoImage = isPowerOfTwo( image ),
		glFormat = paramThreeToGL( texture.format ),
		glType = paramThreeToGL( texture.type );

		setTextureParameters( _gl.TEXTURE_2D, texture, isPowerOfTwoImage );

		var mipmap, mipmaps = texture.mipmaps;

		if ( texture.isDepthTexture ) {

			// populate depth texture with dummy data

			var internalFormat = _gl.DEPTH_COMPONENT;

			if ( texture.type === FloatType ) {

				if ( !_isWebGL2 ) throw new Error('Float Depth Texture only supported in WebGL2.0');
				internalFormat = _gl.DEPTH_COMPONENT32F;

			} else if ( _isWebGL2 ) {

				// WebGL 2.0 requires signed internalformat for glTexImage2D
				internalFormat = _gl.DEPTH_COMPONENT16;

			}

			if ( texture.format === DepthFormat && internalFormat === _gl.DEPTH_COMPONENT ) {

				// The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
				// DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
				// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
				if ( texture.type !== UnsignedShortType && texture.type !== UnsignedIntType ) {

				        console.warn( 'THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.' );

					texture.type = UnsignedShortType;
					glType = paramThreeToGL( texture.type );

				}

			}

			// Depth stencil textures need the DEPTH_STENCIL internal format
			// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
			if ( texture.format === DepthStencilFormat ) {

				internalFormat = _gl.DEPTH_STENCIL;

				// The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
				// DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
				// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
				if ( texture.type !== UnsignedInt248Type ) {

				        console.warn( 'THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.' );

					texture.type = UnsignedInt248Type;
					glType = paramThreeToGL( texture.type );

				}

			}

			state.texImage2D( _gl.TEXTURE_2D, 0, internalFormat, image.width, image.height, 0, glFormat, glType, null );

		} else if ( texture.isDataTexture ) {

			// use manually created mipmaps if available
			// if there are no manual mipmaps
			// set 0 level mipmap and then use GL to generate other mipmap levels

			if ( mipmaps.length > 0 && isPowerOfTwoImage ) {

				for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {

					mipmap = mipmaps[ i ];
					state.texImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

				}

				texture.generateMipmaps = false;

			} else {

				state.texImage2D( _gl.TEXTURE_2D, 0, glFormat, image.width, image.height, 0, glFormat, glType, image.data );

			}

		} else if ( texture.isCompressedTexture ) {

			for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {

				mipmap = mipmaps[ i ];

				if ( texture.format !== RGBAFormat && texture.format !== RGBFormat ) {

					if ( state.getCompressedTextureFormats().indexOf( glFormat ) > - 1 ) {

						state.compressedTexImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, mipmap.data );

					} else {

						console.warn( "THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()" );

					}

				} else {

					state.texImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

				}

			}

		} else {

			// regular Texture (image, video, canvas)

			// use manually created mipmaps if available
			// if there are no manual mipmaps
			// set 0 level mipmap and then use GL to generate other mipmap levels

			if ( mipmaps.length > 0 && isPowerOfTwoImage ) {

				for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {

					mipmap = mipmaps[ i ];
					state.texImage2D( _gl.TEXTURE_2D, i, glFormat, glFormat, glType, mipmap );

				}

				texture.generateMipmaps = false;

			} else {

				state.texImage2D( _gl.TEXTURE_2D, 0, glFormat, glFormat, glType, image );

			}

		}

		if ( texture.generateMipmaps && isPowerOfTwoImage ) _gl.generateMipmap( _gl.TEXTURE_2D );

		textureProperties.__version = texture.version;

		if ( texture.onUpdate ) texture.onUpdate( texture );

	}

	// Render targets

	// Setup storage for target texture and bind it to correct framebuffer
	function setupFrameBufferTexture( framebuffer, renderTarget, attachment, textureTarget ) {

		var glFormat = paramThreeToGL( renderTarget.texture.format );
		var glType = paramThreeToGL( renderTarget.texture.type );
		state.texImage2D( textureTarget, 0, glFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null );
		_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );
		_gl.framebufferTexture2D( _gl.FRAMEBUFFER, attachment, textureTarget, properties.get( renderTarget.texture ).__webglTexture, 0 );
		_gl.bindFramebuffer( _gl.FRAMEBUFFER, null );

	}

	// Setup storage for internal depth/stencil buffers and bind to correct framebuffer
	function setupRenderBufferStorage( renderbuffer, renderTarget ) {

		_gl.bindRenderbuffer( _gl.RENDERBUFFER, renderbuffer );

		if ( renderTarget.depthBuffer && ! renderTarget.stencilBuffer ) {

			_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.DEPTH_COMPONENT16, renderTarget.width, renderTarget.height );
			_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer );

		} else if ( renderTarget.depthBuffer && renderTarget.stencilBuffer ) {

			_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.DEPTH_STENCIL, renderTarget.width, renderTarget.height );
			_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer );

		} else {

			// FIXME: We don't support !depth !stencil
			_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.RGBA4, renderTarget.width, renderTarget.height );

		}

		_gl.bindRenderbuffer( _gl.RENDERBUFFER, null );

	}

	// Setup resources for a Depth Texture for a FBO (needs an extension)
	function setupDepthTexture( framebuffer, renderTarget ) {

		var isCube = ( renderTarget && renderTarget.isWebGLRenderTargetCube );
		if ( isCube ) throw new Error('Depth Texture with cube render targets is not supported!');

		_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

		if ( !( renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture ) ) {

			throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');

		}

		// upload an empty depth texture with framebuffer size
		if ( !properties.get( renderTarget.depthTexture ).__webglTexture ||
				renderTarget.depthTexture.image.width !== renderTarget.width ||
				renderTarget.depthTexture.image.height !== renderTarget.height ) {
			renderTarget.depthTexture.image.width = renderTarget.width;
			renderTarget.depthTexture.image.height = renderTarget.height;
			renderTarget.depthTexture.needsUpdate = true;
		}

		setTexture2D( renderTarget.depthTexture, 0 );

		var webglDepthTexture = properties.get( renderTarget.depthTexture ).__webglTexture;

		if ( renderTarget.depthTexture.format === DepthFormat ) {

			_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0 );

		} else if ( renderTarget.depthTexture.format === DepthStencilFormat ) {

			_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0 );

		} else {

			throw new Error('Unknown depthTexture format')

		}

	}

	// Setup GL resources for a non-texture depth buffer
	function setupDepthRenderbuffer( renderTarget ) {

		var renderTargetProperties = properties.get( renderTarget );

		var isCube = ( renderTarget.isWebGLRenderTargetCube === true );

		if ( renderTarget.depthTexture ) {

			if ( isCube ) throw new Error('target.depthTexture not supported in Cube render targets');

			setupDepthTexture( renderTargetProperties.__webglFramebuffer, renderTarget );

		} else {

			if ( isCube ) {

				renderTargetProperties.__webglDepthbuffer = [];

				for ( var i = 0; i < 6; i ++ ) {

					_gl.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[ i ] );
					renderTargetProperties.__webglDepthbuffer[ i ] = _gl.createRenderbuffer();
					setupRenderBufferStorage( renderTargetProperties.__webglDepthbuffer[ i ], renderTarget );

				}

			} else {

				_gl.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer );
				renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
				setupRenderBufferStorage( renderTargetProperties.__webglDepthbuffer, renderTarget );

			}

		}

		_gl.bindFramebuffer( _gl.FRAMEBUFFER, null );

	}

	// Set up GL resources for the render target
	function setupRenderTarget( renderTarget ) {

		var renderTargetProperties = properties.get( renderTarget );
		var textureProperties = properties.get( renderTarget.texture );

		renderTarget.addEventListener( 'dispose', onRenderTargetDispose );

		textureProperties.__webglTexture = _gl.createTexture();

		_infoMemory.textures ++;

		var isCube = ( renderTarget.isWebGLRenderTargetCube === true );
		var isTargetPowerOfTwo = isPowerOfTwo( renderTarget );

		// Setup framebuffer

		if ( isCube ) {

			renderTargetProperties.__webglFramebuffer = [];

			for ( var i = 0; i < 6; i ++ ) {

				renderTargetProperties.__webglFramebuffer[ i ] = _gl.createFramebuffer();

			}

		} else {

			renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();

		}

		// Setup color buffer

		if ( isCube ) {

			state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture );
			setTextureParameters( _gl.TEXTURE_CUBE_MAP, renderTarget.texture, isTargetPowerOfTwo );

			for ( var i = 0; i < 6; i ++ ) {

				setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer[ i ], renderTarget, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i );

			}

			if ( renderTarget.texture.generateMipmaps && isTargetPowerOfTwo ) _gl.generateMipmap( _gl.TEXTURE_CUBE_MAP );
			state.bindTexture( _gl.TEXTURE_CUBE_MAP, null );

		} else {

			state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );
			setTextureParameters( _gl.TEXTURE_2D, renderTarget.texture, isTargetPowerOfTwo );
			setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer, renderTarget, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D );

			if ( renderTarget.texture.generateMipmaps && isTargetPowerOfTwo ) _gl.generateMipmap( _gl.TEXTURE_2D );
			state.bindTexture( _gl.TEXTURE_2D, null );

		}

		// Setup depth and stencil buffers

		if ( renderTarget.depthBuffer ) {

			setupDepthRenderbuffer( renderTarget );

		}

	}

	function updateRenderTargetMipmap( renderTarget ) {

		var texture = renderTarget.texture;

		if ( texture.generateMipmaps && isPowerOfTwo( renderTarget ) &&
				texture.minFilter !== NearestFilter &&
				texture.minFilter !== LinearFilter ) {

			var target = (renderTarget && renderTarget.isWebGLRenderTargetCube) ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
			var webglTexture = properties.get( texture ).__webglTexture;

			state.bindTexture( target, webglTexture );
			_gl.generateMipmap( target );
			state.bindTexture( target, null );

		}

	}

	this.setTexture2D = setTexture2D;
	this.setTextureCube = setTextureCube;
	this.setTextureCubeDynamic = setTextureCubeDynamic;
	this.setupRenderTarget = setupRenderTarget;
	this.updateRenderTargetMipmap = updateRenderTargetMipmap;

}

/**
 * @author fordacious / fordacious.github.io
 */

function WebGLProperties() {

	var properties = {};

	return {

		get: function ( object ) {

			var uuid = object.uuid;
			var map = properties[ uuid ];

			if ( map === undefined ) {

				map = {};
				properties[ uuid ] = map;

			}

			return map;

		},

		delete: function ( object ) {

			delete properties[ object.uuid ];

		},

		clear: function () {

			properties = {};

		}

	};

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLState( gl, extensions, paramThreeToGL ) {

	function ColorBuffer() {

		var locked = false;

		var color = new Vector4();
		var currentColorMask = null;
		var currentColorClear = new Vector4();

		return {

			setMask: function ( colorMask ) {

				if ( currentColorMask !== colorMask && ! locked ) {

					gl.colorMask( colorMask, colorMask, colorMask, colorMask );
					currentColorMask = colorMask;

				}

			},

			setLocked: function ( lock ) {

				locked = lock;

			},

			setClear: function ( r, g, b, a, premultipliedAlpha ) {

				if ( premultipliedAlpha === true ) {

					r *= a; g *= a; b *= a;

				}

				color.set( r, g, b, a );

				if ( currentColorClear.equals( color ) === false ) {

					gl.clearColor( r, g, b, a );
					currentColorClear.copy( color );

				}

			},

			reset: function () {

				locked = false;

				currentColorMask = null;
				currentColorClear.set( 0, 0, 0, 1 );

			}

		};

	}

	function DepthBuffer() {

		var locked = false;

		var currentDepthMask = null;
		var currentDepthFunc = null;
		var currentDepthClear = null;

		return {

			setTest: function ( depthTest ) {

				if ( depthTest ) {

					enable( gl.DEPTH_TEST );

				} else {

					disable( gl.DEPTH_TEST );

				}

			},

			setMask: function ( depthMask ) {

				if ( currentDepthMask !== depthMask && ! locked ) {

					gl.depthMask( depthMask );
					currentDepthMask = depthMask;

				}

			},

			setFunc: function ( depthFunc ) {

				if ( currentDepthFunc !== depthFunc ) {

					if ( depthFunc ) {

						switch ( depthFunc ) {

							case NeverDepth:

								gl.depthFunc( gl.NEVER );
								break;

							case AlwaysDepth:

								gl.depthFunc( gl.ALWAYS );
								break;

							case LessDepth:

								gl.depthFunc( gl.LESS );
								break;

							case LessEqualDepth:

								gl.depthFunc( gl.LEQUAL );
								break;

							case EqualDepth:

								gl.depthFunc( gl.EQUAL );
								break;

							case GreaterEqualDepth:

								gl.depthFunc( gl.GEQUAL );
								break;

							case GreaterDepth:

								gl.depthFunc( gl.GREATER );
								break;

							case NotEqualDepth:

								gl.depthFunc( gl.NOTEQUAL );
								break;

							default:

								gl.depthFunc( gl.LEQUAL );

						}

					} else {

						gl.depthFunc( gl.LEQUAL );

					}

					currentDepthFunc = depthFunc;

				}

			},

			setLocked: function ( lock ) {

				locked = lock;

			},

			setClear: function ( depth ) {

				if ( currentDepthClear !== depth ) {

					gl.clearDepth( depth );
					currentDepthClear = depth;

				}

			},

			reset: function () {

				locked = false;

				currentDepthMask = null;
				currentDepthFunc = null;
				currentDepthClear = null;

			}

		};

	}

	function StencilBuffer() {

		var locked = false;

		var currentStencilMask = null;
		var currentStencilFunc = null;
		var currentStencilRef = null;
		var currentStencilFuncMask = null;
		var currentStencilFail = null;
		var currentStencilZFail = null;
		var currentStencilZPass = null;
		var currentStencilClear = null;

		return {

			setTest: function ( stencilTest ) {

				if ( stencilTest ) {

					enable( gl.STENCIL_TEST );

				} else {

					disable( gl.STENCIL_TEST );

				}

			},

			setMask: function ( stencilMask ) {

				if ( currentStencilMask !== stencilMask && ! locked ) {

					gl.stencilMask( stencilMask );
					currentStencilMask = stencilMask;

				}

			},

			setFunc: function ( stencilFunc, stencilRef, stencilMask ) {

				if ( currentStencilFunc !== stencilFunc ||
				     currentStencilRef 	!== stencilRef 	||
				     currentStencilFuncMask !== stencilMask ) {

					gl.stencilFunc( stencilFunc, stencilRef, stencilMask );

					currentStencilFunc = stencilFunc;
					currentStencilRef = stencilRef;
					currentStencilFuncMask = stencilMask;

				}

			},

			setOp: function ( stencilFail, stencilZFail, stencilZPass ) {

				if ( currentStencilFail	 !== stencilFail 	||
				     currentStencilZFail !== stencilZFail ||
				     currentStencilZPass !== stencilZPass ) {

					gl.stencilOp( stencilFail, stencilZFail, stencilZPass );

					currentStencilFail = stencilFail;
					currentStencilZFail = stencilZFail;
					currentStencilZPass = stencilZPass;

				}

			},

			setLocked: function ( lock ) {

				locked = lock;

			},

			setClear: function ( stencil ) {

				if ( currentStencilClear !== stencil ) {

					gl.clearStencil( stencil );
					currentStencilClear = stencil;

				}

			},

			reset: function () {

				locked = false;

				currentStencilMask = null;
				currentStencilFunc = null;
				currentStencilRef = null;
				currentStencilFuncMask = null;
				currentStencilFail = null;
				currentStencilZFail = null;
				currentStencilZPass = null;
				currentStencilClear = null;

			}

		};

	}

	//

	var colorBuffer = new ColorBuffer();
	var depthBuffer = new DepthBuffer();
	var stencilBuffer = new StencilBuffer();

	var maxVertexAttributes = gl.getParameter( gl.MAX_VERTEX_ATTRIBS );
	var newAttributes = new Uint8Array( maxVertexAttributes );
	var enabledAttributes = new Uint8Array( maxVertexAttributes );
	var attributeDivisors = new Uint8Array( maxVertexAttributes );

	var capabilities = {};

	var compressedTextureFormats = null;

	var currentBlending = null;
	var currentBlendEquation = null;
	var currentBlendSrc = null;
	var currentBlendDst = null;
	var currentBlendEquationAlpha = null;
	var currentBlendSrcAlpha = null;
	var currentBlendDstAlpha = null;
	var currentPremultipledAlpha = false;

	var currentFlipSided = null;
	var currentCullFace = null;

	var currentLineWidth = null;

	var currentPolygonOffsetFactor = null;
	var currentPolygonOffsetUnits = null;

	var currentScissorTest = null;

	var maxTextures = gl.getParameter( gl.MAX_TEXTURE_IMAGE_UNITS );

	var version = parseFloat( /^WebGL\ ([0-9])/.exec( gl.getParameter( gl.VERSION ) )[ 1 ] );
	var lineWidthAvailable = parseFloat( version ) >= 1.0;

	var currentTextureSlot = null;
	var currentBoundTextures = {};

	var currentScissor = new Vector4();
	var currentViewport = new Vector4();

	function createTexture( type, target, count ) {

		var data = new Uint8Array( 4 ); // 4 is required to match default unpack alignment of 4.
		var texture = gl.createTexture();

		gl.bindTexture( type, texture );
		gl.texParameteri( type, gl.TEXTURE_MIN_FILTER, gl.NEAREST );
		gl.texParameteri( type, gl.TEXTURE_MAG_FILTER, gl.NEAREST );

		for ( var i = 0; i < count; i ++ ) {

			gl.texImage2D( target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data );

		}

		return texture;

	}

	var emptyTextures = {};
	emptyTextures[ gl.TEXTURE_2D ] = createTexture( gl.TEXTURE_2D, gl.TEXTURE_2D, 1 );
	emptyTextures[ gl.TEXTURE_CUBE_MAP ] = createTexture( gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6 );

	//

	function init() {

		colorBuffer.setClear( 0, 0, 0, 1 );
		depthBuffer.setClear( 1 );
		stencilBuffer.setClear( 0 );

		enable( gl.DEPTH_TEST );
		setDepthFunc( LessEqualDepth );

		setFlipSided( false );
		setCullFace( CullFaceBack );
		enable( gl.CULL_FACE );

		enable( gl.BLEND );
		setBlending( NormalBlending );

	}

	function initAttributes() {

		for ( var i = 0, l = newAttributes.length; i < l; i ++ ) {

			newAttributes[ i ] = 0;

		}

	}

	function enableAttribute( attribute ) {

		newAttributes[ attribute ] = 1;

		if ( enabledAttributes[ attribute ] === 0 ) {

			gl.enableVertexAttribArray( attribute );
			enabledAttributes[ attribute ] = 1;

		}

		if ( attributeDivisors[ attribute ] !== 0 ) {

			var extension = extensions.get( 'ANGLE_instanced_arrays' );

			extension.vertexAttribDivisorANGLE( attribute, 0 );
			attributeDivisors[ attribute ] = 0;

		}

	}

	function enableAttributeAndDivisor( attribute, meshPerAttribute, extension ) {

		newAttributes[ attribute ] = 1;

		if ( enabledAttributes[ attribute ] === 0 ) {

			gl.enableVertexAttribArray( attribute );
			enabledAttributes[ attribute ] = 1;

		}

		if ( attributeDivisors[ attribute ] !== meshPerAttribute ) {

			extension.vertexAttribDivisorANGLE( attribute, meshPerAttribute );
			attributeDivisors[ attribute ] = meshPerAttribute;

		}

	}

	function disableUnusedAttributes() {

		for ( var i = 0, l = enabledAttributes.length; i !== l; ++ i ) {

			if ( enabledAttributes[ i ] !== newAttributes[ i ] ) {

				gl.disableVertexAttribArray( i );
				enabledAttributes[ i ] = 0;

			}

		}

	}

	function enable( id ) {

		if ( capabilities[ id ] !== true ) {

			gl.enable( id );
			capabilities[ id ] = true;

		}

	}

	function disable( id ) {

		if ( capabilities[ id ] !== false ) {

			gl.disable( id );
			capabilities[ id ] = false;

		}

	}

	function getCompressedTextureFormats() {

		if ( compressedTextureFormats === null ) {

			compressedTextureFormats = [];

			if ( extensions.get( 'WEBGL_compressed_texture_pvrtc' ) ||
			     extensions.get( 'WEBGL_compressed_texture_s3tc' ) ||
			     extensions.get( 'WEBGL_compressed_texture_etc1' ) ) {

				var formats = gl.getParameter( gl.COMPRESSED_TEXTURE_FORMATS );

				for ( var i = 0; i < formats.length; i ++ ) {

					compressedTextureFormats.push( formats[ i ] );

				}

			}

		}

		return compressedTextureFormats;

	}

	function setBlending( blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha ) {

		if ( blending !== NoBlending ) {

			enable( gl.BLEND );

		} else {

			disable( gl.BLEND );

		}

		if ( blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha ) {

			if ( blending === AdditiveBlending ) {

				if ( premultipliedAlpha ) {

					gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
					gl.blendFuncSeparate( gl.ONE, gl.ONE, gl.ONE, gl.ONE );

				} else {

					gl.blendEquation( gl.FUNC_ADD );
					gl.blendFunc( gl.SRC_ALPHA, gl.ONE );

				}

			} else if ( blending === SubtractiveBlending ) {

				if ( premultipliedAlpha ) {

					gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
					gl.blendFuncSeparate( gl.ZERO, gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ONE_MINUS_SRC_ALPHA );

				} else {

					gl.blendEquation( gl.FUNC_ADD );
					gl.blendFunc( gl.ZERO, gl.ONE_MINUS_SRC_COLOR );

				}

			} else if ( blending === MultiplyBlending ) {

				if ( premultipliedAlpha ) {

					gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
					gl.blendFuncSeparate( gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA );

				} else {

					gl.blendEquation( gl.FUNC_ADD );
					gl.blendFunc( gl.ZERO, gl.SRC_COLOR );

				}

			} else {

				if ( premultipliedAlpha ) {

					gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
					gl.blendFuncSeparate( gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA );

				} else {

					gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
					gl.blendFuncSeparate( gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA );

				}

			}

			currentBlending = blending;
			currentPremultipledAlpha = premultipliedAlpha;

		}

		if ( blending === CustomBlending ) {

			blendEquationAlpha = blendEquationAlpha || blendEquation;
			blendSrcAlpha = blendSrcAlpha || blendSrc;
			blendDstAlpha = blendDstAlpha || blendDst;

			if ( blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha ) {

				gl.blendEquationSeparate( paramThreeToGL( blendEquation ), paramThreeToGL( blendEquationAlpha ) );

				currentBlendEquation = blendEquation;
				currentBlendEquationAlpha = blendEquationAlpha;

			}

			if ( blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha ) {

				gl.blendFuncSeparate( paramThreeToGL( blendSrc ), paramThreeToGL( blendDst ), paramThreeToGL( blendSrcAlpha ), paramThreeToGL( blendDstAlpha ) );

				currentBlendSrc = blendSrc;
				currentBlendDst = blendDst;
				currentBlendSrcAlpha = blendSrcAlpha;
				currentBlendDstAlpha = blendDstAlpha;

			}

		} else {

			currentBlendEquation = null;
			currentBlendSrc = null;
			currentBlendDst = null;
			currentBlendEquationAlpha = null;
			currentBlendSrcAlpha = null;
			currentBlendDstAlpha = null;

		}

	}

	// TODO Deprecate

	function setColorWrite( colorWrite ) {

		colorBuffer.setMask( colorWrite );

	}

	function setDepthTest( depthTest ) {

		depthBuffer.setTest( depthTest );

	}

	function setDepthWrite( depthWrite ) {

		depthBuffer.setMask( depthWrite );

	}

	function setDepthFunc( depthFunc ) {

		depthBuffer.setFunc( depthFunc );

	}

	function setStencilTest( stencilTest ) {

		stencilBuffer.setTest( stencilTest );

	}

	function setStencilWrite( stencilWrite ) {

		stencilBuffer.setMask( stencilWrite );

	}

	function setStencilFunc( stencilFunc, stencilRef, stencilMask ) {

		stencilBuffer.setFunc( stencilFunc, stencilRef, stencilMask );

	}

	function setStencilOp( stencilFail, stencilZFail, stencilZPass ) {

		stencilBuffer.setOp( stencilFail, stencilZFail, stencilZPass );

	}

	//

	function setFlipSided( flipSided ) {

		if ( currentFlipSided !== flipSided ) {

			if ( flipSided ) {

				gl.frontFace( gl.CW );

			} else {

				gl.frontFace( gl.CCW );

			}

			currentFlipSided = flipSided;

		}

	}

	function setCullFace( cullFace ) {

		if ( cullFace !== CullFaceNone ) {

			enable( gl.CULL_FACE );

			if ( cullFace !== currentCullFace ) {

				if ( cullFace === CullFaceBack ) {

					gl.cullFace( gl.BACK );

				} else if ( cullFace === CullFaceFront ) {

					gl.cullFace( gl.FRONT );

				} else {

					gl.cullFace( gl.FRONT_AND_BACK );

				}

			}

		} else {

			disable( gl.CULL_FACE );

		}

		currentCullFace = cullFace;

	}

	function setLineWidth( width ) {

		if ( width !== currentLineWidth ) {

			if ( lineWidthAvailable ) gl.lineWidth( width );

			currentLineWidth = width;

		}

	}

	function setPolygonOffset( polygonOffset, factor, units ) {

		if ( polygonOffset ) {

			enable( gl.POLYGON_OFFSET_FILL );

			if ( currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units ) {

				gl.polygonOffset( factor, units );

				currentPolygonOffsetFactor = factor;
				currentPolygonOffsetUnits = units;

			}

		} else {

			disable( gl.POLYGON_OFFSET_FILL );

		}

	}

	function getScissorTest() {

		return currentScissorTest;

	}

	function setScissorTest( scissorTest ) {

		currentScissorTest = scissorTest;

		if ( scissorTest ) {

			enable( gl.SCISSOR_TEST );

		} else {

			disable( gl.SCISSOR_TEST );

		}

	}

	// texture

	function activeTexture( webglSlot ) {

		if ( webglSlot === undefined ) webglSlot = gl.TEXTURE0 + maxTextures - 1;

		if ( currentTextureSlot !== webglSlot ) {

			gl.activeTexture( webglSlot );
			currentTextureSlot = webglSlot;

		}

	}

	function bindTexture( webglType, webglTexture ) {

		if ( currentTextureSlot === null ) {

			activeTexture();

		}

		var boundTexture = currentBoundTextures[ currentTextureSlot ];

		if ( boundTexture === undefined ) {

			boundTexture = { type: undefined, texture: undefined };
			currentBoundTextures[ currentTextureSlot ] = boundTexture;

		}

		if ( boundTexture.type !== webglType || boundTexture.texture !== webglTexture ) {

			gl.bindTexture( webglType, webglTexture || emptyTextures[ webglType ] );

			boundTexture.type = webglType;
			boundTexture.texture = webglTexture;

		}

	}

	function compressedTexImage2D() {

		try {

			gl.compressedTexImage2D.apply( gl, arguments );

		} catch ( error ) {

			console.error( error );

		}

	}

	function texImage2D() {

		try {

			gl.texImage2D.apply( gl, arguments );

		} catch ( error ) {

			console.error( error );

		}

	}

	//

	function scissor( scissor ) {

		if ( currentScissor.equals( scissor ) === false ) {

			gl.scissor( scissor.x, scissor.y, scissor.z, scissor.w );
			currentScissor.copy( scissor );

		}

	}

	function viewport( viewport ) {

		if ( currentViewport.equals( viewport ) === false ) {

			gl.viewport( viewport.x, viewport.y, viewport.z, viewport.w );
			currentViewport.copy( viewport );

		}

	}

	//

	function reset() {

		for ( var i = 0; i < enabledAttributes.length; i ++ ) {

			if ( enabledAttributes[ i ] === 1 ) {

				gl.disableVertexAttribArray( i );
				enabledAttributes[ i ] = 0;

			}

		}

		capabilities = {};

		compressedTextureFormats = null;

		currentTextureSlot = null;
		currentBoundTextures = {};

		currentBlending = null;

		currentFlipSided = null;
		currentCullFace = null;

		colorBuffer.reset();
		depthBuffer.reset();
		stencilBuffer.reset();

	}

	return {

		buffers: {
			color: colorBuffer,
			depth: depthBuffer,
			stencil: stencilBuffer
		},

		init: init,
		initAttributes: initAttributes,
		enableAttribute: enableAttribute,
		enableAttributeAndDivisor: enableAttributeAndDivisor,
		disableUnusedAttributes: disableUnusedAttributes,
		enable: enable,
		disable: disable,
		getCompressedTextureFormats: getCompressedTextureFormats,

		setBlending: setBlending,

		setColorWrite: setColorWrite,
		setDepthTest: setDepthTest,
		setDepthWrite: setDepthWrite,
		setDepthFunc: setDepthFunc,
		setStencilTest: setStencilTest,
		setStencilWrite: setStencilWrite,
		setStencilFunc: setStencilFunc,
		setStencilOp: setStencilOp,

		setFlipSided: setFlipSided,
		setCullFace: setCullFace,

		setLineWidth: setLineWidth,
		setPolygonOffset: setPolygonOffset,

		getScissorTest: getScissorTest,
		setScissorTest: setScissorTest,

		activeTexture: activeTexture,
		bindTexture: bindTexture,
		compressedTexImage2D: compressedTexImage2D,
		texImage2D: texImage2D,

		scissor: scissor,
		viewport: viewport,

		reset: reset

	};

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLCapabilities( gl, extensions, parameters ) {

	var maxAnisotropy;

	function getMaxAnisotropy() {

		if ( maxAnisotropy !== undefined ) return maxAnisotropy;

		var extension = extensions.get( 'EXT_texture_filter_anisotropic' );

		if ( extension !== null ) {

			maxAnisotropy = gl.getParameter( extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT );

		} else {

			maxAnisotropy = 0;

		}

		return maxAnisotropy;

	}

	function getMaxPrecision( precision ) {

		if ( precision === 'highp' ) {

			if ( gl.getShaderPrecisionFormat( gl.VERTEX_SHADER, gl.HIGH_FLOAT ).precision > 0 &&
			     gl.getShaderPrecisionFormat( gl.FRAGMENT_SHADER, gl.HIGH_FLOAT ).precision > 0 ) {

				return 'highp';

			}

			precision = 'mediump';

		}

		if ( precision === 'mediump' ) {

			if ( gl.getShaderPrecisionFormat( gl.VERTEX_SHADER, gl.MEDIUM_FLOAT ).precision > 0 &&
			     gl.getShaderPrecisionFormat( gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT ).precision > 0 ) {

				return 'mediump';

			}

		}

		return 'lowp';

	}

	var precision = parameters.precision !== undefined ? parameters.precision : 'highp';
	var maxPrecision = getMaxPrecision( precision );

	if ( maxPrecision !== precision ) {

		console.warn( 'THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.' );
		precision = maxPrecision;

	}

	var logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true && !! extensions.get( 'EXT_frag_depth' );

	var maxTextures = gl.getParameter( gl.MAX_TEXTURE_IMAGE_UNITS );
	var maxVertexTextures = gl.getParameter( gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS );
	var maxTextureSize = gl.getParameter( gl.MAX_TEXTURE_SIZE );
	var maxCubemapSize = gl.getParameter( gl.MAX_CUBE_MAP_TEXTURE_SIZE );

	var maxAttributes = gl.getParameter( gl.MAX_VERTEX_ATTRIBS );
	var maxVertexUniforms = gl.getParameter( gl.MAX_VERTEX_UNIFORM_VECTORS );
	var maxVaryings = gl.getParameter( gl.MAX_VARYING_VECTORS );
	var maxFragmentUniforms = gl.getParameter( gl.MAX_FRAGMENT_UNIFORM_VECTORS );

	var vertexTextures = maxVertexTextures > 0;
	var floatFragmentTextures = !! extensions.get( 'OES_texture_float' );
	var floatVertexTextures = vertexTextures && floatFragmentTextures;

	return {

		getMaxAnisotropy: getMaxAnisotropy,
		getMaxPrecision: getMaxPrecision,

		precision: precision,
		logarithmicDepthBuffer: logarithmicDepthBuffer,

		maxTextures: maxTextures,
		maxVertexTextures: maxVertexTextures,
		maxTextureSize: maxTextureSize,
		maxCubemapSize: maxCubemapSize,

		maxAttributes: maxAttributes,
		maxVertexUniforms: maxVertexUniforms,
		maxVaryings: maxVaryings,
		maxFragmentUniforms: maxFragmentUniforms,

		vertexTextures: vertexTextures,
		floatFragmentTextures: floatFragmentTextures,
		floatVertexTextures: floatVertexTextures

	};

}

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WebGLExtensions( gl ) {

	var extensions = {};

	return {

		get: function ( name ) {

			if ( extensions[ name ] !== undefined ) {

				return extensions[ name ];

			}

			var extension;

			switch ( name ) {

				case 'WEBGL_depth_texture':
					extension = gl.getExtension( 'WEBGL_depth_texture' ) || gl.getExtension( 'MOZ_WEBGL_depth_texture' ) || gl.getExtension( 'WEBKIT_WEBGL_depth_texture' );
					break;

				case 'EXT_texture_filter_anisotropic':
					extension = gl.getExtension( 'EXT_texture_filter_anisotropic' ) || gl.getExtension( 'MOZ_EXT_texture_filter_anisotropic' ) || gl.getExtension( 'WEBKIT_EXT_texture_filter_anisotropic' );
					break;

				case 'WEBGL_compressed_texture_s3tc':
					extension = gl.getExtension( 'WEBGL_compressed_texture_s3tc' ) || gl.getExtension( 'MOZ_WEBGL_compressed_texture_s3tc' ) || gl.getExtension( 'WEBKIT_WEBGL_compressed_texture_s3tc' );
					break;

				case 'WEBGL_compressed_texture_pvrtc':
					extension = gl.getExtension( 'WEBGL_compressed_texture_pvrtc' ) || gl.getExtension( 'WEBKIT_WEBGL_compressed_texture_pvrtc' );
					break;

				case 'WEBGL_compressed_texture_etc1':
					extension = gl.getExtension( 'WEBGL_compressed_texture_etc1' );
					break;

				default:
					extension = gl.getExtension( name );

			}

			if ( extension === null ) {

				console.warn( 'THREE.WebGLRenderer: ' + name + ' extension not supported.' );

			}

			extensions[ name ] = extension;

			return extension;

		}

	};

}

/**
 * @author tschw
 */

function WebGLClipping() {

	var scope = this,

		globalState = null,
		numGlobalPlanes = 0,
		localClippingEnabled = false,
		renderingShadows = false,

		plane = new Plane(),
		viewNormalMatrix = new Matrix3(),

		uniform = { value: null, needsUpdate: false };

	this.uniform = uniform;
	this.numPlanes = 0;
	this.numIntersection = 0;

	this.init = function( planes, enableLocalClipping, camera ) {

		var enabled =
			planes.length !== 0 ||
			enableLocalClipping ||
			// enable state of previous frame - the clipping code has to
			// run another frame in order to reset the state:
			numGlobalPlanes !== 0 ||
			localClippingEnabled;

		localClippingEnabled = enableLocalClipping;

		globalState = projectPlanes( planes, camera, 0 );
		numGlobalPlanes = planes.length;

		return enabled;

	};

	this.beginShadows = function() {

		renderingShadows = true;
		projectPlanes( null );

	};

	this.endShadows = function() {

		renderingShadows = false;
		resetGlobalState();

	};

	this.setState = function( planes, clipIntersection, clipShadows, camera, cache, fromCache ) {

		if ( ! localClippingEnabled ||
				planes === null || planes.length === 0 ||
				renderingShadows && ! clipShadows ) {
			// there's no local clipping

			if ( renderingShadows ) {
				// there's no global clipping

				projectPlanes( null );

			} else {

				resetGlobalState();
			}

		} else {

			var nGlobal = renderingShadows ? 0 : numGlobalPlanes,
				lGlobal = nGlobal * 4,

				dstArray = cache.clippingState || null;

			uniform.value = dstArray; // ensure unique state

			dstArray = projectPlanes( planes, camera, lGlobal, fromCache );

			for ( var i = 0; i !== lGlobal; ++ i ) {

				dstArray[ i ] = globalState[ i ];

			}

			cache.clippingState = dstArray;
			this.numIntersection = clipIntersection ? this.numPlanes : 0;
			this.numPlanes += nGlobal;

		}


	};

	function resetGlobalState() {

		if ( uniform.value !== globalState ) {

			uniform.value = globalState;
			uniform.needsUpdate = numGlobalPlanes > 0;

		}

		scope.numPlanes = numGlobalPlanes;
		scope.numIntersection = 0;

	}

	function projectPlanes( planes, camera, dstOffset, skipTransform ) {

		var nPlanes = planes !== null ? planes.length : 0,
			dstArray = null;

		if ( nPlanes !== 0 ) {

			dstArray = uniform.value;

			if ( skipTransform !== true || dstArray === null ) {

				var flatSize = dstOffset + nPlanes * 4,
					viewMatrix = camera.matrixWorldInverse;

				viewNormalMatrix.getNormalMatrix( viewMatrix );

				if ( dstArray === null || dstArray.length < flatSize ) {

					dstArray = new Float32Array( flatSize );

				}

				for ( var i = 0, i4 = dstOffset;
									i !== nPlanes; ++ i, i4 += 4 ) {

					plane.copy( planes[ i ] ).
							applyMatrix4( viewMatrix, viewNormalMatrix );

					plane.normal.toArray( dstArray, i4 );
					dstArray[ i4 + 3 ] = plane.constant;

				}

			}

			uniform.value = dstArray;
			uniform.needsUpdate = true;

		}

		scope.numPlanes = nPlanes;
		
		return dstArray;

	}

}

/**
 * @author supereggbert / http://www.paulbrunt.co.uk/
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 * @author szimek / https://github.com/szimek/
 * @author tschw
 */

function WebGLRenderer( parameters ) {

	console.log( 'THREE.WebGLRenderer', REVISION );

	parameters = parameters || {};

	var _canvas = parameters.canvas !== undefined ? parameters.canvas : document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' ),
		_context = parameters.context !== undefined ? parameters.context : null,

		_alpha = parameters.alpha !== undefined ? parameters.alpha : false,
		_depth = parameters.depth !== undefined ? parameters.depth : true,
		_stencil = parameters.stencil !== undefined ? parameters.stencil : true,
		_antialias = parameters.antialias !== undefined ? parameters.antialias : false,
		_premultipliedAlpha = parameters.premultipliedAlpha !== undefined ? parameters.premultipliedAlpha : true,
		_preserveDrawingBuffer = parameters.preserveDrawingBuffer !== undefined ? parameters.preserveDrawingBuffer : false;

	var lights = [];

	var opaqueObjects = [];
	var opaqueObjectsLastIndex = - 1;
	var transparentObjects = [];
	var transparentObjectsLastIndex = - 1;

	var morphInfluences = new Float32Array( 8 );

	var sprites = [];
	var lensFlares = [];

	// public properties

	this.domElement = _canvas;
	this.context = null;

	// clearing

	this.autoClear = true;
	this.autoClearColor = true;
	this.autoClearDepth = true;
	this.autoClearStencil = true;

	// scene graph

	this.sortObjects = true;

	// user-defined clipping

	this.clippingPlanes = [];
	this.localClippingEnabled = false;

	// physically based shading

	this.gammaFactor = 2.0;	// for backwards compatibility
	this.gammaInput = false;
	this.gammaOutput = false;

	// physical lights

	this.physicallyCorrectLights = false;

	// tone mapping

	this.toneMapping = LinearToneMapping;
	this.toneMappingExposure = 1.0;
	this.toneMappingWhitePoint = 1.0;

	// morphs

	this.maxMorphTargets = 8;
	this.maxMorphNormals = 4;

	// internal properties

	var _this = this,

		// internal state cache

		_currentProgram = null,
		_currentRenderTarget = null,
		_currentFramebuffer = null,
		_currentMaterialId = - 1,
		_currentGeometryProgram = '',
		_currentCamera = null,

		_currentScissor = new Vector4(),
		_currentScissorTest = null,

		_currentViewport = new Vector4(),

		//

		_usedTextureUnits = 0,

		//

		_clearColor = new Color( 0x000000 ),
		_clearAlpha = 0,

		_width = _canvas.width,
		_height = _canvas.height,

		_pixelRatio = 1,

		_scissor = new Vector4( 0, 0, _width, _height ),
		_scissorTest = false,

		_viewport = new Vector4( 0, 0, _width, _height ),

		// frustum

		_frustum = new Frustum(),

		// clipping

		_clipping = new WebGLClipping(),
		_clippingEnabled = false,
		_localClippingEnabled = false,

		_sphere = new Sphere(),

		// camera matrices cache

		_projScreenMatrix = new Matrix4(),

		_vector3 = new Vector3(),
		_matrix4 = new Matrix4(),
		_matrix42 = new Matrix4(),

		// light arrays cache

		_lights = {

			hash: '',

		ambient: [ 0, 0, 0 ],
		directional: [],
		directionalShadowMap: [],
		directionalShadowMatrix: [],
		spot: [],
		spotShadowMap: [],
		spotShadowMatrix: [],
		rectArea: [],
		point: [],
		pointShadowMap: [],
		pointShadowMatrix: [],
		hemi: [],

			shadows: []

		},

		// info

		_infoRender = {

			calls: 0,
			vertices: 0,
			faces: 0,
			points: 0

		};

	this.info = {

		render: _infoRender,
		memory: {

			geometries: 0,
			textures: 0

		},
		programs: null

	};


	// initialize

	var _gl;

	try {

		var attributes = {
			alpha: _alpha,
			depth: _depth,
			stencil: _stencil,
			antialias: _antialias,
			premultipliedAlpha: _premultipliedAlpha,
			preserveDrawingBuffer: _preserveDrawingBuffer
		};

		_gl = _context || _canvas.getContext( 'webgl', attributes ) || _canvas.getContext( 'experimental-webgl', attributes );

		if ( _gl === null ) {

			if ( _canvas.getContext( 'webgl' ) !== null ) {

				throw 'Error creating WebGL context with your selected attributes.';

			} else {

				throw 'Error creating WebGL context.';

			}

		}

		// Some experimental-webgl implementations do not have getShaderPrecisionFormat

		if ( _gl.getShaderPrecisionFormat === undefined ) {

			_gl.getShaderPrecisionFormat = function () {

				return { 'rangeMin': 1, 'rangeMax': 1, 'precision': 1 };

			};

		}

		_canvas.addEventListener( 'webglcontextlost', onContextLost, false );

	} catch ( error ) {

		console.error( 'THREE.WebGLRenderer: ' + error );

	}

	var extensions = new WebGLExtensions( _gl );

	extensions.get( 'WEBGL_depth_texture' );
	extensions.get( 'OES_texture_float' );
	extensions.get( 'OES_texture_float_linear' );
	extensions.get( 'OES_texture_half_float' );
	extensions.get( 'OES_texture_half_float_linear' );
	extensions.get( 'OES_standard_derivatives' );
	extensions.get( 'ANGLE_instanced_arrays' );

	if ( extensions.get( 'OES_element_index_uint' ) ) {

		BufferGeometry.MaxIndex = 4294967296;

	}

	var capabilities = new WebGLCapabilities( _gl, extensions, parameters );

	var state = new WebGLState( _gl, extensions, paramThreeToGL );
	var properties = new WebGLProperties();
	var textures = new WebGLTextures( _gl, extensions, state, properties, capabilities, paramThreeToGL, this.info );
	var objects = new WebGLObjects( _gl, properties, this.info );
	var programCache = new WebGLPrograms( this, capabilities );
	var lightCache = new WebGLLights();

	this.info.programs = programCache.programs;

	var bufferRenderer = new WebGLBufferRenderer( _gl, extensions, _infoRender );
	var indexedBufferRenderer = new WebGLIndexedBufferRenderer( _gl, extensions, _infoRender );

	//

	var backgroundCamera = new OrthographicCamera( - 1, 1, 1, - 1, 0, 1 );
	var backgroundCamera2 = new PerspectiveCamera();
	var backgroundPlaneMesh = new Mesh(
		new PlaneBufferGeometry( 2, 2 ),
		new MeshBasicMaterial( { depthTest: false, depthWrite: false, fog: false } )
	);
	var backgroundBoxShader = ShaderLib[ 'cube' ];
	var backgroundBoxMesh = new Mesh(
		new BoxBufferGeometry( 5, 5, 5 ),
		new ShaderMaterial( {
			uniforms: backgroundBoxShader.uniforms,
			vertexShader: backgroundBoxShader.vertexShader,
			fragmentShader: backgroundBoxShader.fragmentShader,
			side: BackSide,
			depthTest: false,
			depthWrite: false,
			fog: false
		} )
	);

	//

	function getTargetPixelRatio() {

		return _currentRenderTarget === null ? _pixelRatio : 1;

	}

	function setDefaultGLState() {

		state.init();

		state.scissor( _currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio ) );
		state.viewport( _currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio ) );

		state.buffers.color.setClear( _clearColor.r, _clearColor.g, _clearColor.b, _clearAlpha, _premultipliedAlpha );

	}

	function resetGLState() {

		_currentProgram = null;
		_currentCamera = null;

		_currentGeometryProgram = '';
		_currentMaterialId = - 1;

		state.reset();

	}

	setDefaultGLState();

	this.context = _gl;
	this.capabilities = capabilities;
	this.extensions = extensions;
	this.properties = properties;
	this.state = state;

	// shadow map

	var shadowMap = new WebGLShadowMap( this, _lights, objects, capabilities );

	this.shadowMap = shadowMap;


	// Plugins

	var spritePlugin = new SpritePlugin( this, sprites );
	var lensFlarePlugin = new LensFlarePlugin( this, lensFlares );

	// API

	this.getContext = function () {

		return _gl;

	};

	this.getContextAttributes = function () {

		return _gl.getContextAttributes();

	};

	this.forceContextLoss = function () {

		extensions.get( 'WEBGL_lose_context' ).loseContext();

	};

	this.getMaxAnisotropy = function () {

		return capabilities.getMaxAnisotropy();

	};

	this.getPrecision = function () {

		return capabilities.precision;

	};

	this.getPixelRatio = function () {

		return _pixelRatio;

	};

	this.setPixelRatio = function ( value ) {

		if ( value === undefined ) return;

		_pixelRatio = value;

		this.setSize( _viewport.z, _viewport.w, false );

	};

	this.getSize = function () {

		return {
			width: _width,
			height: _height
		};

	};

	this.setSize = function ( width, height, updateStyle ) {

		_width = width;
		_height = height;

		_canvas.width = width * _pixelRatio;
		_canvas.height = height * _pixelRatio;

		if ( updateStyle !== false ) {

			_canvas.style.width = width + 'px';
			_canvas.style.height = height + 'px';

		}

		this.setViewport( 0, 0, width, height );

	};

	this.setViewport = function ( x, y, width, height ) {

		state.viewport( _viewport.set( x, y, width, height ) );

	};

	this.setScissor = function ( x, y, width, height ) {

		state.scissor( _scissor.set( x, y, width, height ) );

	};

	this.setScissorTest = function ( boolean ) {

		state.setScissorTest( _scissorTest = boolean );

	};

	// Clearing

	this.getClearColor = function () {

		return _clearColor;

	};

	this.setClearColor = function ( color, alpha ) {

		_clearColor.set( color );

		_clearAlpha = alpha !== undefined ? alpha : 1;

		state.buffers.color.setClear( _clearColor.r, _clearColor.g, _clearColor.b, _clearAlpha, _premultipliedAlpha );

	};

	this.getClearAlpha = function () {

		return _clearAlpha;

	};

	this.setClearAlpha = function ( alpha ) {

		_clearAlpha = alpha;

		state.buffers.color.setClear( _clearColor.r, _clearColor.g, _clearColor.b, _clearAlpha, _premultipliedAlpha );

	};

	this.clear = function ( color, depth, stencil ) {

		var bits = 0;

		if ( color === undefined || color ) bits |= _gl.COLOR_BUFFER_BIT;
		if ( depth === undefined || depth ) bits |= _gl.DEPTH_BUFFER_BIT;
		if ( stencil === undefined || stencil ) bits |= _gl.STENCIL_BUFFER_BIT;

		_gl.clear( bits );

	};

	this.clearColor = function () {

		this.clear( true, false, false );

	};

	this.clearDepth = function () {

		this.clear( false, true, false );

	};

	this.clearStencil = function () {

		this.clear( false, false, true );

	};

	this.clearTarget = function ( renderTarget, color, depth, stencil ) {

		this.setRenderTarget( renderTarget );
		this.clear( color, depth, stencil );

	};

	// Reset

	this.resetGLState = resetGLState;

	this.dispose = function() {

		transparentObjects = [];
		transparentObjectsLastIndex = -1;
		opaqueObjects = [];
		opaqueObjectsLastIndex = -1;

		_canvas.removeEventListener( 'webglcontextlost', onContextLost, false );

	};

	// Events

	function onContextLost( event ) {

		event.preventDefault();

		resetGLState();
		setDefaultGLState();

		properties.clear();

	}

	function onMaterialDispose( event ) {

		var material = event.target;

		material.removeEventListener( 'dispose', onMaterialDispose );

		deallocateMaterial( material );

	}

	// Buffer deallocation

	function deallocateMaterial( material ) {

		releaseMaterialProgramReference( material );

		properties.delete( material );

	}


	function releaseMaterialProgramReference( material ) {

		var programInfo = properties.get( material ).program;

		material.program = undefined;

		if ( programInfo !== undefined ) {

			programCache.releaseProgram( programInfo );

		}

	}

	// Buffer rendering

	this.renderBufferImmediate = function ( object, program, material ) {

		state.initAttributes();

		var buffers = properties.get( object );

		if ( object.hasPositions && ! buffers.position ) buffers.position = _gl.createBuffer();
		if ( object.hasNormals && ! buffers.normal ) buffers.normal = _gl.createBuffer();
		if ( object.hasUvs && ! buffers.uv ) buffers.uv = _gl.createBuffer();
		if ( object.hasColors && ! buffers.color ) buffers.color = _gl.createBuffer();

		var attributes = program.getAttributes();

		if ( object.hasPositions ) {

			_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.position );
			_gl.bufferData( _gl.ARRAY_BUFFER, object.positionArray, _gl.DYNAMIC_DRAW );

			state.enableAttribute( attributes.position );
			_gl.vertexAttribPointer( attributes.position, 3, _gl.FLOAT, false, 0, 0 );

		}

		if ( object.hasNormals ) {

			_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.normal );

			if ( ! material.isMeshPhongMaterial &&
				! material.isMeshStandardMaterial &&
				! material.isMeshNormalMaterial &&
				material.shading === FlatShading ) {

				for ( var i = 0, l = object.count * 3; i < l; i += 9 ) {

					var array = object.normalArray;

					var nx = ( array[ i + 0 ] + array[ i + 3 ] + array[ i + 6 ] ) / 3;
					var ny = ( array[ i + 1 ] + array[ i + 4 ] + array[ i + 7 ] ) / 3;
					var nz = ( array[ i + 2 ] + array[ i + 5 ] + array[ i + 8 ] ) / 3;

					array[ i + 0 ] = nx;
					array[ i + 1 ] = ny;
					array[ i + 2 ] = nz;

					array[ i + 3 ] = nx;
					array[ i + 4 ] = ny;
					array[ i + 5 ] = nz;

					array[ i + 6 ] = nx;
					array[ i + 7 ] = ny;
					array[ i + 8 ] = nz;

				}

			}

			_gl.bufferData( _gl.ARRAY_BUFFER, object.normalArray, _gl.DYNAMIC_DRAW );

			state.enableAttribute( attributes.normal );

			_gl.vertexAttribPointer( attributes.normal, 3, _gl.FLOAT, false, 0, 0 );

		}

		if ( object.hasUvs && material.map ) {

			_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.uv );
			_gl.bufferData( _gl.ARRAY_BUFFER, object.uvArray, _gl.DYNAMIC_DRAW );

			state.enableAttribute( attributes.uv );

			_gl.vertexAttribPointer( attributes.uv, 2, _gl.FLOAT, false, 0, 0 );

		}

		if ( object.hasColors && material.vertexColors !== NoColors ) {

			_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.color );
			_gl.bufferData( _gl.ARRAY_BUFFER, object.colorArray, _gl.DYNAMIC_DRAW );

			state.enableAttribute( attributes.color );

			_gl.vertexAttribPointer( attributes.color, 3, _gl.FLOAT, false, 0, 0 );

		}

		state.disableUnusedAttributes();

		_gl.drawArrays( _gl.TRIANGLES, 0, object.count );

		object.count = 0;

	};

	this.renderBufferDirect = function ( camera, fog, geometry, material, object, group ) {

		setMaterial( material );

		var program = setProgram( camera, fog, material, object );

		var updateBuffers = false;
		var geometryProgram = geometry.id + '_' + program.id + '_' + material.wireframe;

		if ( geometryProgram !== _currentGeometryProgram ) {

			_currentGeometryProgram = geometryProgram;
			updateBuffers = true;

		}

		// morph targets

		var morphTargetInfluences = object.morphTargetInfluences;

		if ( morphTargetInfluences !== undefined ) {

			var activeInfluences = [];

			for ( var i = 0, l = morphTargetInfluences.length; i < l; i ++ ) {

				var influence = morphTargetInfluences[ i ];
				activeInfluences.push( [ influence, i ] );

			}

			activeInfluences.sort( absNumericalSort );

			if ( activeInfluences.length > 8 ) {

				activeInfluences.length = 8;

			}

			var morphAttributes = geometry.morphAttributes;

			for ( var i = 0, l = activeInfluences.length; i < l; i ++ ) {

				var influence = activeInfluences[ i ];
				morphInfluences[ i ] = influence[ 0 ];

				if ( influence[ 0 ] !== 0 ) {

					var index = influence[ 1 ];

					if ( material.morphTargets === true && morphAttributes.position ) geometry.addAttribute( 'morphTarget' + i, morphAttributes.position[ index ] );
					if ( material.morphNormals === true && morphAttributes.normal ) geometry.addAttribute( 'morphNormal' + i, morphAttributes.normal[ index ] );

				} else {

					if ( material.morphTargets === true ) geometry.removeAttribute( 'morphTarget' + i );
					if ( material.morphNormals === true ) geometry.removeAttribute( 'morphNormal' + i );

				}

			}

			for ( var i = activeInfluences.length, il = morphInfluences.length; i < il; i ++ ) {

				morphInfluences[ i ] = 0.0;

			}

			program.getUniforms().setValue(
				_gl, 'morphTargetInfluences', morphInfluences );

			updateBuffers = true;

		}

		//

		var index = geometry.index;
		var position = geometry.attributes.position;
		var rangeFactor = 1;

		if ( material.wireframe === true ) {

			index = objects.getWireframeAttribute( geometry );
			rangeFactor = 2;

		}

		var renderer;

		if ( index !== null ) {

			renderer = indexedBufferRenderer;
			renderer.setIndex( index );

		} else {

			renderer = bufferRenderer;

		}

		if ( updateBuffers ) {

			setupVertexAttributes( material, program, geometry );

			if ( index !== null ) {

				_gl.bindBuffer( _gl.ELEMENT_ARRAY_BUFFER, objects.getAttributeBuffer( index ) );

			}

		}

		//

		var dataCount = 0;

		if ( index !== null ) {

			dataCount = index.count;

		} else if ( position !== undefined ) {

			dataCount = position.count;

		}

		var rangeStart = geometry.drawRange.start * rangeFactor;
		var rangeCount = geometry.drawRange.count * rangeFactor;

		var groupStart = group !== null ? group.start * rangeFactor : 0;
		var groupCount = group !== null ? group.count * rangeFactor : Infinity;

		var drawStart = Math.max( rangeStart, groupStart );
		var drawEnd = Math.min( dataCount, rangeStart + rangeCount, groupStart + groupCount ) - 1;

		var drawCount = Math.max( 0, drawEnd - drawStart + 1 );

		if ( drawCount === 0 ) return;

		//

		if ( object.isMesh ) {

			if ( material.wireframe === true ) {

				state.setLineWidth( material.wireframeLinewidth * getTargetPixelRatio() );
				renderer.setMode( _gl.LINES );

			} else {

				switch ( object.drawMode ) {

					case TrianglesDrawMode:
						renderer.setMode( _gl.TRIANGLES );
						break;

					case TriangleStripDrawMode:
						renderer.setMode( _gl.TRIANGLE_STRIP );
						break;

					case TriangleFanDrawMode:
						renderer.setMode( _gl.TRIANGLE_FAN );
						break;

				}

			}


		} else if ( object.isLine ) {

			var lineWidth = material.linewidth;

			if ( lineWidth === undefined ) lineWidth = 1; // Not using Line*Material

			state.setLineWidth( lineWidth * getTargetPixelRatio() );

			if ( object.isLineSegments ) {

				renderer.setMode( _gl.LINES );

			} else {

				renderer.setMode( _gl.LINE_STRIP );

			}

		} else if ( object.isPoints ) {

			renderer.setMode( _gl.POINTS );

		}

		if ( geometry && geometry.isInstancedBufferGeometry ) {

			if ( geometry.maxInstancedCount > 0 ) {

				renderer.renderInstances( geometry, drawStart, drawCount );

			}

		} else {

			renderer.render( drawStart, drawCount );

		}

	};

	function setupVertexAttributes( material, program, geometry, startIndex ) {

		var extension;

		if ( geometry && geometry.isInstancedBufferGeometry ) {

			extension = extensions.get( 'ANGLE_instanced_arrays' );

			if ( extension === null ) {

				console.error( 'THREE.WebGLRenderer.setupVertexAttributes: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
				return;

			}

		}

		if ( startIndex === undefined ) startIndex = 0;

		state.initAttributes();

		var geometryAttributes = geometry.attributes;

		var programAttributes = program.getAttributes();

		var materialDefaultAttributeValues = material.defaultAttributeValues;

		for ( var name in programAttributes ) {

			var programAttribute = programAttributes[ name ];

			if ( programAttribute >= 0 ) {

				var geometryAttribute = geometryAttributes[ name ];

				if ( geometryAttribute !== undefined ) {

					var normalized = geometryAttribute.normalized;
					var size = geometryAttribute.itemSize;

					var attributeProperties = objects.getAttributeProperties( geometryAttribute );

					var buffer = attributeProperties.__webglBuffer;
					var type = attributeProperties.type;
					var bytesPerElement = attributeProperties.bytesPerElement;

					if ( geometryAttribute.isInterleavedBufferAttribute ) {

						var data = geometryAttribute.data;
						var stride = data.stride;
						var offset = geometryAttribute.offset;

						if ( data && data.isInstancedInterleavedBuffer ) {

							state.enableAttributeAndDivisor( programAttribute, data.meshPerAttribute, extension );

							if ( geometry.maxInstancedCount === undefined ) {

								geometry.maxInstancedCount = data.meshPerAttribute * data.count;

							}

						} else {

							state.enableAttribute( programAttribute );

						}

						_gl.bindBuffer( _gl.ARRAY_BUFFER, buffer );
						_gl.vertexAttribPointer( programAttribute, size, type, normalized, stride * bytesPerElement, ( startIndex * stride + offset ) * bytesPerElement );

					} else {

						if ( geometryAttribute.isInstancedBufferAttribute ) {

							state.enableAttributeAndDivisor( programAttribute, geometryAttribute.meshPerAttribute, extension );

							if ( geometry.maxInstancedCount === undefined ) {

								geometry.maxInstancedCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;

							}

						} else {

							state.enableAttribute( programAttribute );

						}

						_gl.bindBuffer( _gl.ARRAY_BUFFER, buffer );
						_gl.vertexAttribPointer( programAttribute, size, type, normalized, 0, startIndex * size * bytesPerElement );

					}

				} else if ( materialDefaultAttributeValues !== undefined ) {

					var value = materialDefaultAttributeValues[ name ];

					if ( value !== undefined ) {

						switch ( value.length ) {

							case 2:
								_gl.vertexAttrib2fv( programAttribute, value );
								break;

							case 3:
								_gl.vertexAttrib3fv( programAttribute, value );
								break;

							case 4:
								_gl.vertexAttrib4fv( programAttribute, value );
								break;

							default:
								_gl.vertexAttrib1fv( programAttribute, value );

						}

					}

				}

			}

		}

		state.disableUnusedAttributes();

	}

	// Sorting

	function absNumericalSort( a, b ) {

		return Math.abs( b[ 0 ] ) - Math.abs( a[ 0 ] );

	}

	function painterSortStable( a, b ) {

		if ( a.object.renderOrder !== b.object.renderOrder ) {

			return a.object.renderOrder - b.object.renderOrder;

		} else if ( a.material.program && b.material.program && a.material.program !== b.material.program ) {

			return a.material.program.id - b.material.program.id;

		} else if ( a.material.id !== b.material.id ) {

			return a.material.id - b.material.id;

		} else if ( a.z !== b.z ) {

			return a.z - b.z;

		} else {

			return a.id - b.id;

		}

	}

	function reversePainterSortStable( a, b ) {

		if ( a.object.renderOrder !== b.object.renderOrder ) {

			return a.object.renderOrder - b.object.renderOrder;

		} if ( a.z !== b.z ) {

			return b.z - a.z;

		} else {

			return a.id - b.id;

		}

	}

	// Rendering

	this.render = function ( scene, camera, renderTarget, forceClear ) {

		if ( camera !== undefined && camera.isCamera !== true ) {

			console.error( 'THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.' );
			return;

		}

		// reset caching for this frame

		_currentGeometryProgram = '';
		_currentMaterialId = - 1;
		_currentCamera = null;

		// update scene graph

		if ( scene.autoUpdate === true ) scene.updateMatrixWorld();

		// update camera matrices and frustum

		if ( camera.parent === null ) camera.updateMatrixWorld();

		camera.matrixWorldInverse.getInverse( camera.matrixWorld );

		_projScreenMatrix.multiplyMatrices( camera.projectionMatrix, camera.matrixWorldInverse );
		_frustum.setFromMatrix( _projScreenMatrix );

		lights.length = 0;

		opaqueObjectsLastIndex = - 1;
		transparentObjectsLastIndex = - 1;

		sprites.length = 0;
		lensFlares.length = 0;

		_localClippingEnabled = this.localClippingEnabled;
		_clippingEnabled = _clipping.init( this.clippingPlanes, _localClippingEnabled, camera );

		projectObject( scene, camera );

		opaqueObjects.length = opaqueObjectsLastIndex + 1;
		transparentObjects.length = transparentObjectsLastIndex + 1;

		if ( _this.sortObjects === true ) {

			opaqueObjects.sort( painterSortStable );
			transparentObjects.sort( reversePainterSortStable );

		}

		//

		if ( _clippingEnabled ) _clipping.beginShadows();

		setupShadows( lights );

		shadowMap.render( scene, camera );

		setupLights( lights, camera );

		if ( _clippingEnabled ) _clipping.endShadows();

		//

		_infoRender.calls = 0;
		_infoRender.vertices = 0;
		_infoRender.faces = 0;
		_infoRender.points = 0;

		if ( renderTarget === undefined ) {

			renderTarget = null;

		}

		this.setRenderTarget( renderTarget );

		//

		var background = scene.background;

		if ( background === null ) {

			state.buffers.color.setClear( _clearColor.r, _clearColor.g, _clearColor.b, _clearAlpha, _premultipliedAlpha );

		} else if ( background && background.isColor ) {

			state.buffers.color.setClear( background.r, background.g, background.b, 1, _premultipliedAlpha );
			forceClear = true;

		}

		if ( this.autoClear || forceClear ) {

			this.clear( this.autoClearColor, this.autoClearDepth, this.autoClearStencil );

		}

		if ( background && background.isCubeTexture ) {

			backgroundCamera2.projectionMatrix.copy( camera.projectionMatrix );

			backgroundCamera2.matrixWorld.extractRotation( camera.matrixWorld );
			backgroundCamera2.matrixWorldInverse.getInverse( backgroundCamera2.matrixWorld );

			backgroundBoxMesh.material.uniforms[ "tCube" ].value = background;
			backgroundBoxMesh.modelViewMatrix.multiplyMatrices( backgroundCamera2.matrixWorldInverse, backgroundBoxMesh.matrixWorld );

			objects.update( backgroundBoxMesh );

			_this.renderBufferDirect( backgroundCamera2, null, backgroundBoxMesh.geometry, backgroundBoxMesh.material, backgroundBoxMesh, null );

		} else if ( background && background.isTexture ) {

			backgroundPlaneMesh.material.map = background;

			objects.update( backgroundPlaneMesh );

			_this.renderBufferDirect( backgroundCamera, null, backgroundPlaneMesh.geometry, backgroundPlaneMesh.material, backgroundPlaneMesh, null );

		}

		//

		if ( scene.overrideMaterial ) {

			var overrideMaterial = scene.overrideMaterial;

			renderObjects( opaqueObjects, scene, camera, overrideMaterial );
			renderObjects( transparentObjects, scene, camera, overrideMaterial );

		} else {

			// opaque pass (front-to-back order)

			state.setBlending( NoBlending );
			renderObjects( opaqueObjects, scene, camera );

			// transparent pass (back-to-front order)

			renderObjects( transparentObjects, scene, camera );

		}

		// custom render plugins (post pass)

		spritePlugin.render( scene, camera );
		lensFlarePlugin.render( scene, camera, _currentViewport );

		// Generate mipmap if we're using any kind of mipmap filtering

		if ( renderTarget ) {

			textures.updateRenderTargetMipmap( renderTarget );

		}

		// Ensure depth buffer writing is enabled so it can be cleared on next render

		state.setDepthTest( true );
		state.setDepthWrite( true );
		state.setColorWrite( true );

		// _gl.finish();

	};

	function pushRenderItem( object, geometry, material, z, group ) {

		var array, index;

		// allocate the next position in the appropriate array

		if ( material.transparent ) {

			array = transparentObjects;
			index = ++ transparentObjectsLastIndex;

		} else {

			array = opaqueObjects;
			index = ++ opaqueObjectsLastIndex;

		}

		// recycle existing render item or grow the array

		var renderItem = array[ index ];

		if ( renderItem !== undefined ) {

			renderItem.id = object.id;
			renderItem.object = object;
			renderItem.geometry = geometry;
			renderItem.material = material;
			renderItem.z = _vector3.z;
			renderItem.group = group;

		} else {

			renderItem = {
				id: object.id,
				object: object,
				geometry: geometry,
				material: material,
				z: _vector3.z,
				group: group
			};

			// assert( index === array.length );
			array.push( renderItem );

		}

	}

	// TODO Duplicated code (Frustum)

	function isObjectViewable( object ) {

		var geometry = object.geometry;

		if ( geometry.boundingSphere === null )
			geometry.computeBoundingSphere();

		_sphere.copy( geometry.boundingSphere ).
		applyMatrix4( object.matrixWorld );

		return isSphereViewable( _sphere );

	}

	function isSpriteViewable( sprite ) {

		_sphere.center.set( 0, 0, 0 );
		_sphere.radius = 0.7071067811865476;
		_sphere.applyMatrix4( sprite.matrixWorld );

		return isSphereViewable( _sphere );

	}

	function isSphereViewable( sphere ) {

		if ( ! _frustum.intersectsSphere( sphere ) ) return false;

		var numPlanes = _clipping.numPlanes;

		if ( numPlanes === 0 ) return true;

		var planes = _this.clippingPlanes,

			center = sphere.center,
			negRad = - sphere.radius,
			i = 0;

		do {

			// out when deeper than radius in the negative halfspace
			if ( planes[ i ].distanceToPoint( center ) < negRad ) return false;

		} while ( ++ i !== numPlanes );

		return true;

	}

	function projectObject( object, camera ) {

		if ( object.visible === false ) return;

		var visible = ( object.layers.mask & camera.layers.mask ) !== 0;

		if ( visible ) {

			if ( object.isLight ) {

				lights.push( object );

			} else if ( object.isSprite ) {

				if ( object.frustumCulled === false || isSpriteViewable( object ) === true ) {

					sprites.push( object );

				}

			} else if ( object.isLensFlare ) {

				lensFlares.push( object );

			} else if ( object.isImmediateRenderObject ) {

				if ( _this.sortObjects === true ) {

					_vector3.setFromMatrixPosition( object.matrixWorld );
					_vector3.applyProjection( _projScreenMatrix );

				}

				pushRenderItem( object, null, object.material, _vector3.z, null );

			} else if ( object.isMesh || object.isLine || object.isPoints ) {

				if ( object.isSkinnedMesh ) {

					object.skeleton.update();

				}

				if ( object.frustumCulled === false || isObjectViewable( object ) === true ) {

					var material = object.material;

					if ( material.visible === true ) {

						if ( _this.sortObjects === true ) {

							_vector3.setFromMatrixPosition( object.matrixWorld );
							_vector3.applyProjection( _projScreenMatrix );

						}

						var geometry = objects.update( object );

						if ( material.isMultiMaterial ) {

							var groups = geometry.groups;
							var materials = material.materials;

							for ( var i = 0, l = groups.length; i < l; i ++ ) {

								var group = groups[ i ];
								var groupMaterial = materials[ group.materialIndex ];

								if ( groupMaterial.visible === true ) {

									pushRenderItem( object, geometry, groupMaterial, _vector3.z, group );

								}

							}

						} else {

							pushRenderItem( object, geometry, material, _vector3.z, null );

						}

					}

				}

			}

		}

		var children = object.children;

		for ( var i = 0, l = children.length; i < l; i ++ ) {

			projectObject( children[ i ], camera );

		}

	}

	function renderObjects( renderList, scene, camera, overrideMaterial ) {

		for ( var i = 0, l = renderList.length; i < l; i ++ ) {

			var renderItem = renderList[ i ];

			var object = renderItem.object;
			var geometry = renderItem.geometry;
			var material = overrideMaterial === undefined ? renderItem.material : overrideMaterial;
			var group = renderItem.group;

			object.modelViewMatrix.multiplyMatrices( camera.matrixWorldInverse, object.matrixWorld );
			object.normalMatrix.getNormalMatrix( object.modelViewMatrix );

			object.onBeforeRender( _this, scene, camera, geometry, material, group );

			if ( object.isImmediateRenderObject ) {

				setMaterial( material );

				var program = setProgram( camera, scene.fog, material, object );

				_currentGeometryProgram = '';

				object.render( function ( object ) {

					_this.renderBufferImmediate( object, program, material );

				} );

			} else {

				_this.renderBufferDirect( camera, scene.fog, geometry, material, object, group );

			}

			object.onAfterRender( _this, scene, camera, geometry, material, group );


		}

	}

	function initMaterial( material, fog, object ) {

		var materialProperties = properties.get( material );

		var parameters = programCache.getParameters(
			material, _lights, fog, _clipping.numPlanes, _clipping.numIntersection, object );

		var code = programCache.getProgramCode( material, parameters );

		var program = materialProperties.program;
		var programChange = true;

		if ( program === undefined ) {

			// new material
			material.addEventListener( 'dispose', onMaterialDispose );

		} else if ( program.code !== code ) {

			// changed glsl or parameters
			releaseMaterialProgramReference( material );

		} else if ( parameters.shaderID !== undefined ) {

			// same glsl and uniform list
			return;

		} else {

			// only rebuild uniform list
			programChange = false;

		}

		if ( programChange ) {

			if ( parameters.shaderID ) {

				var shader = ShaderLib[ parameters.shaderID ];

				materialProperties.__webglShader = {
					name: material.type,
					uniforms: UniformsUtils.clone( shader.uniforms ),
					vertexShader: shader.vertexShader,
					fragmentShader: shader.fragmentShader
				};

			} else {

				materialProperties.__webglShader = {
					name: material.type,
					uniforms: material.uniforms,
					vertexShader: material.vertexShader,
					fragmentShader: material.fragmentShader
				};

			}

			material.__webglShader = materialProperties.__webglShader;

			program = programCache.acquireProgram( material, parameters, code );

			materialProperties.program = program;
			material.program = program;

		}

		var attributes = program.getAttributes();

		if ( material.morphTargets ) {

			material.numSupportedMorphTargets = 0;

			for ( var i = 0; i < _this.maxMorphTargets; i ++ ) {

				if ( attributes[ 'morphTarget' + i ] >= 0 ) {

					material.numSupportedMorphTargets ++;

				}

			}

		}

		if ( material.morphNormals ) {

			material.numSupportedMorphNormals = 0;

			for ( var i = 0; i < _this.maxMorphNormals; i ++ ) {

				if ( attributes[ 'morphNormal' + i ] >= 0 ) {

					material.numSupportedMorphNormals ++;

				}

			}

		}

		var uniforms = materialProperties.__webglShader.uniforms;

		if ( ! material.isShaderMaterial &&
			! material.isRawShaderMaterial ||
			material.clipping === true ) {

			materialProperties.numClippingPlanes = _clipping.numPlanes;
			materialProperties.numIntersection = _clipping.numIntersection;
			uniforms.clippingPlanes = _clipping.uniform;

		}

		materialProperties.fog = fog;

		// store the light setup it was created for

		materialProperties.lightsHash = _lights.hash;

		if ( material.lights ) {

			// wire up the material to this renderer's lighting state

			uniforms.ambientLightColor.value = _lights.ambient;
			uniforms.directionalLights.value = _lights.directional;
			uniforms.spotLights.value = _lights.spot;
			uniforms.rectAreaLights.value = _lights.rectArea;
			uniforms.pointLights.value = _lights.point;
			uniforms.hemisphereLights.value = _lights.hemi;

			uniforms.directionalShadowMap.value = _lights.directionalShadowMap;
			uniforms.directionalShadowMatrix.value = _lights.directionalShadowMatrix;
			uniforms.spotShadowMap.value = _lights.spotShadowMap;
			uniforms.spotShadowMatrix.value = _lights.spotShadowMatrix;
			uniforms.pointShadowMap.value = _lights.pointShadowMap;
			uniforms.pointShadowMatrix.value = _lights.pointShadowMatrix;
			// TODO (abelnation): add area lights shadow info to uniforms

		}

		var progUniforms = materialProperties.program.getUniforms(),
			uniformsList =
				WebGLUniforms.seqWithValue( progUniforms.seq, uniforms );

		materialProperties.uniformsList = uniformsList;

	}

	function setMaterial( material ) {

		material.side === DoubleSide
			? state.disable( _gl.CULL_FACE )
			: state.enable( _gl.CULL_FACE );

		state.setFlipSided( material.side === BackSide );

		material.transparent === true
			? state.setBlending( material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha )
			: state.setBlending( NoBlending );

		state.setDepthFunc( material.depthFunc );
		state.setDepthTest( material.depthTest );
		state.setDepthWrite( material.depthWrite );
		state.setColorWrite( material.colorWrite );
		state.setPolygonOffset( material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits );

	}

	function setProgram( camera, fog, material, object ) {

		_usedTextureUnits = 0;

		var materialProperties = properties.get( material );

		if ( _clippingEnabled ) {

			if ( _localClippingEnabled || camera !== _currentCamera ) {

				var useCache =
					camera === _currentCamera &&
					material.id === _currentMaterialId;

				// we might want to call this function with some ClippingGroup
				// object instead of the material, once it becomes feasible
				// (#8465, #8379)
				_clipping.setState(
					material.clippingPlanes, material.clipIntersection, material.clipShadows,
					camera, materialProperties, useCache );

			}

		}

		if ( material.needsUpdate === false ) {

			if ( materialProperties.program === undefined ) {

				material.needsUpdate = true;

			} else if ( material.fog && materialProperties.fog !== fog ) {

				material.needsUpdate = true;

			} else if ( material.lights && materialProperties.lightsHash !== _lights.hash ) {

				material.needsUpdate = true;

			} else if ( materialProperties.numClippingPlanes !== undefined &&
				( materialProperties.numClippingPlanes !== _clipping.numPlanes ||
				materialProperties.numIntersection  !== _clipping.numIntersection ) ) {

				material.needsUpdate = true;

			}

		}

		if ( material.needsUpdate ) {

			initMaterial( material, fog, object );
			material.needsUpdate = false;

		}

		var refreshProgram = false;
		var refreshMaterial = false;
		var refreshLights = false;

		var program = materialProperties.program,
			p_uniforms = program.getUniforms(),
			m_uniforms = materialProperties.__webglShader.uniforms;

		if ( program.id !== _currentProgram ) {

			_gl.useProgram( program.program );
			_currentProgram = program.id;

			refreshProgram = true;
			refreshMaterial = true;
			refreshLights = true;

		}

		if ( material.id !== _currentMaterialId ) {

			_currentMaterialId = material.id;

			refreshMaterial = true;

		}

		if ( refreshProgram || camera !== _currentCamera ) {

			p_uniforms.set( _gl, camera, 'projectionMatrix' );

			if ( capabilities.logarithmicDepthBuffer ) {

				p_uniforms.setValue( _gl, 'logDepthBufFC',
					2.0 / ( Math.log( camera.far + 1.0 ) / Math.LN2 ) );

			}


			if ( camera !== _currentCamera ) {

				_currentCamera = camera;

				// lighting uniforms depend on the camera so enforce an update
				// now, in case this material supports lights - or later, when
				// the next material that does gets activated:

				refreshMaterial = true;		// set to true on material change
				refreshLights = true;		// remains set until update done

			}

			// load material specific uniforms
			// (shader material also gets them for the sake of genericity)

			if ( material.isShaderMaterial ||
				material.isMeshPhongMaterial ||
				material.isMeshStandardMaterial ||
				material.envMap ) {

				var uCamPos = p_uniforms.map.cameraPosition;

				if ( uCamPos !== undefined ) {

					uCamPos.setValue( _gl,
						_vector3.setFromMatrixPosition( camera.matrixWorld ) );

				}

			}

			if ( material.isMeshPhongMaterial ||
				material.isMeshLambertMaterial ||
				material.isMeshBasicMaterial ||
				material.isMeshStandardMaterial ||
				material.isShaderMaterial ||
				material.skinning ) {

				p_uniforms.setValue( _gl, 'viewMatrix', camera.matrixWorldInverse );

			}

			p_uniforms.set( _gl, _this, 'toneMappingExposure' );
			p_uniforms.set( _gl, _this, 'toneMappingWhitePoint' );

		}

		// skinning uniforms must be set even if material didn't change
		// auto-setting of texture unit for bone texture must go before other textures
		// not sure why, but otherwise weird things happen

		if ( material.skinning ) {

			p_uniforms.setOptional( _gl, object, 'bindMatrix' );
			p_uniforms.setOptional( _gl, object, 'bindMatrixInverse' );

			var skeleton = object.skeleton;

			if ( skeleton ) {

				if ( capabilities.floatVertexTextures && skeleton.useVertexTexture ) {

					p_uniforms.set( _gl, skeleton, 'boneTexture' );
					p_uniforms.set( _gl, skeleton, 'boneTextureWidth' );
					p_uniforms.set( _gl, skeleton, 'boneTextureHeight' );

				} else {

					p_uniforms.setOptional( _gl, skeleton, 'boneMatrices' );

				}

			}

		}

		if ( refreshMaterial ) {

			if ( material.lights ) {

				// the current material requires lighting info

				// note: all lighting uniforms are always set correctly
				// they simply reference the renderer's state for their
				// values
				//
				// use the current material's .needsUpdate flags to set
				// the GL state when required

				markUniformsLightsNeedsUpdate( m_uniforms, refreshLights );

			}

			// refresh uniforms common to several materials

			if ( fog && material.fog ) {

				refreshUniformsFog( m_uniforms, fog );

			}

			if ( material.isMeshBasicMaterial ||
				material.isMeshLambertMaterial ||
				material.isMeshPhongMaterial ||
				material.isMeshStandardMaterial ||
				material.isMeshNormalMaterial ||
				material.isMeshDepthMaterial ) {

				refreshUniformsCommon( m_uniforms, material );

			}

			// refresh single material specific uniforms

			if ( material.isLineBasicMaterial ) {

				refreshUniformsLine( m_uniforms, material );

			} else if ( material.isLineDashedMaterial ) {

				refreshUniformsLine( m_uniforms, material );
				refreshUniformsDash( m_uniforms, material );

			} else if ( material.isPointsMaterial ) {

				refreshUniformsPoints( m_uniforms, material );

			} else if ( material.isMeshLambertMaterial ) {

				refreshUniformsLambert( m_uniforms, material );

			} else if ( material.isMeshToonMaterial ) {

				refreshUniformsToon( m_uniforms, material );

			} else if ( material.isMeshPhongMaterial ) {

				refreshUniformsPhong( m_uniforms, material );

			} else if ( material.isMeshPhysicalMaterial ) {

				refreshUniformsPhysical( m_uniforms, material );

			} else if ( material.isMeshStandardMaterial ) {

				refreshUniformsStandard( m_uniforms, material );

			} else if ( material.isMeshDepthMaterial ) {

				if ( material.displacementMap ) {

					m_uniforms.displacementMap.value = material.displacementMap;
					m_uniforms.displacementScale.value = material.displacementScale;
					m_uniforms.displacementBias.value = material.displacementBias;

				}

			} else if ( material.isMeshNormalMaterial ) {

				refreshUniformsNormal( m_uniforms, material );

			}

			// RectAreaLight Texture
			// TODO (mrdoob): Find a nicer implementation

			if ( m_uniforms.ltcMat !== undefined ) m_uniforms.ltcMat.value = THREE.UniformsLib.LTC_MAT_TEXTURE;
			if ( m_uniforms.ltcMag !== undefined ) m_uniforms.ltcMag.value = THREE.UniformsLib.LTC_MAG_TEXTURE;

			WebGLUniforms.upload(
				_gl, materialProperties.uniformsList, m_uniforms, _this );

		}


		// common matrices

		p_uniforms.set( _gl, object, 'modelViewMatrix' );
		p_uniforms.set( _gl, object, 'normalMatrix' );
		p_uniforms.setValue( _gl, 'modelMatrix', object.matrixWorld );

		return program;

	}

	// Uniforms (refresh uniforms objects)

	function refreshUniformsCommon( uniforms, material ) {

		uniforms.opacity.value = material.opacity;

		uniforms.diffuse.value = material.color;

		if ( material.emissive ) {

			uniforms.emissive.value.copy( material.emissive ).multiplyScalar( material.emissiveIntensity );

		}

		uniforms.map.value = material.map;
		uniforms.specularMap.value = material.specularMap;
		uniforms.alphaMap.value = material.alphaMap;

		if ( material.lightMap ) {

			uniforms.lightMap.value = material.lightMap;
			uniforms.lightMapIntensity.value = material.lightMapIntensity;

		}

		if ( material.aoMap ) {

			uniforms.aoMap.value = material.aoMap;
			uniforms.aoMapIntensity.value = material.aoMapIntensity;

		}

		// uv repeat and offset setting priorities
		// 1. color map
		// 2. specular map
		// 3. normal map
		// 4. bump map
		// 5. alpha map
		// 6. emissive map

		var uvScaleMap;

		if ( material.map ) {

			uvScaleMap = material.map;

		} else if ( material.specularMap ) {

			uvScaleMap = material.specularMap;

		} else if ( material.displacementMap ) {

			uvScaleMap = material.displacementMap;

		} else if ( material.normalMap ) {

			uvScaleMap = material.normalMap;

		} else if ( material.bumpMap ) {

			uvScaleMap = material.bumpMap;

		} else if ( material.roughnessMap ) {

			uvScaleMap = material.roughnessMap;

		} else if ( material.metalnessMap ) {

			uvScaleMap = material.metalnessMap;

		} else if ( material.alphaMap ) {

			uvScaleMap = material.alphaMap;

		} else if ( material.emissiveMap ) {

			uvScaleMap = material.emissiveMap;

		}

		if ( uvScaleMap !== undefined ) {

			// backwards compatibility
			if ( uvScaleMap.isWebGLRenderTarget ) {

				uvScaleMap = uvScaleMap.texture;

			}

			var offset = uvScaleMap.offset;
			var repeat = uvScaleMap.repeat;

			uniforms.offsetRepeat.value.set( offset.x, offset.y, repeat.x, repeat.y );

		}

		uniforms.envMap.value = material.envMap;

		// don't flip CubeTexture envMaps, flip everything else:
		//  WebGLRenderTargetCube will be flipped for backwards compatibility
		//  WebGLRenderTargetCube.texture will be flipped because it's a Texture and NOT a CubeTexture
		// this check must be handled differently, or removed entirely, if WebGLRenderTargetCube uses a CubeTexture in the future
		uniforms.flipEnvMap.value = ( ! ( material.envMap && material.envMap.isCubeTexture ) ) ? 1 : - 1;

		uniforms.reflectivity.value = material.reflectivity;
		uniforms.refractionRatio.value = material.refractionRatio;

	}

	function refreshUniformsLine( uniforms, material ) {

		uniforms.diffuse.value = material.color;
		uniforms.opacity.value = material.opacity;

	}

	function refreshUniformsDash( uniforms, material ) {

		uniforms.dashSize.value = material.dashSize;
		uniforms.totalSize.value = material.dashSize + material.gapSize;
		uniforms.scale.value = material.scale;

	}

	function refreshUniformsPoints( uniforms, material ) {

		uniforms.diffuse.value = material.color;
		uniforms.opacity.value = material.opacity;
		uniforms.size.value = material.size * _pixelRatio;
		uniforms.scale.value = _height * 0.5;

		uniforms.map.value = material.map;

		if ( material.map !== null ) {

			var offset = material.map.offset;
			var repeat = material.map.repeat;

			uniforms.offsetRepeat.value.set( offset.x, offset.y, repeat.x, repeat.y );

		}

	}

	function refreshUniformsFog( uniforms, fog ) {

		uniforms.fogColor.value = fog.color;

		if ( fog.isFog ) {

			uniforms.fogNear.value = fog.near;
			uniforms.fogFar.value = fog.far;

		} else if ( fog.isFogExp2 ) {

			uniforms.fogDensity.value = fog.density;

		}

	}

	function refreshUniformsLambert( uniforms, material ) {

		if ( material.emissiveMap ) {

			uniforms.emissiveMap.value = material.emissiveMap;

		}

	}

	function refreshUniformsPhong( uniforms, material ) {

		uniforms.specular.value = material.specular;
		uniforms.shininess.value = Math.max( material.shininess, 1e-4 ); // to prevent pow( 0.0, 0.0 )

		if ( material.emissiveMap ) {

			uniforms.emissiveMap.value = material.emissiveMap;

		}

		if ( material.bumpMap ) {

			uniforms.bumpMap.value = material.bumpMap;
			uniforms.bumpScale.value = material.bumpScale;

		}

		if ( material.normalMap ) {

			uniforms.normalMap.value = material.normalMap;
			uniforms.normalScale.value.copy( material.normalScale );

		}

		if ( material.displacementMap ) {

			uniforms.displacementMap.value = material.displacementMap;
			uniforms.displacementScale.value = material.displacementScale;
			uniforms.displacementBias.value = material.displacementBias;

		}

	}

	function refreshUniformsToon( uniforms, material ) {

		refreshUniformsPhong( uniforms, material );

		if ( material.gradientMap ) {

			uniforms.gradientMap.value = material.gradientMap;

		}

	}

	function refreshUniformsStandard( uniforms, material ) {

		uniforms.roughness.value = material.roughness;
		uniforms.metalness.value = material.metalness;

		if ( material.roughnessMap ) {

			uniforms.roughnessMap.value = material.roughnessMap;

		}

		if ( material.metalnessMap ) {

			uniforms.metalnessMap.value = material.metalnessMap;

		}

		if ( material.emissiveMap ) {

			uniforms.emissiveMap.value = material.emissiveMap;

		}

		if ( material.bumpMap ) {

			uniforms.bumpMap.value = material.bumpMap;
			uniforms.bumpScale.value = material.bumpScale;

		}

		if ( material.normalMap ) {

			uniforms.normalMap.value = material.normalMap;
			uniforms.normalScale.value.copy( material.normalScale );

		}

		if ( material.displacementMap ) {

			uniforms.displacementMap.value = material.displacementMap;
			uniforms.displacementScale.value = material.displacementScale;
			uniforms.displacementBias.value = material.displacementBias;

		}

		if ( material.envMap ) {

			//uniforms.envMap.value = material.envMap; // part of uniforms common
			uniforms.envMapIntensity.value = material.envMapIntensity;

		}

	}

	function refreshUniformsPhysical( uniforms, material ) {

		uniforms.clearCoat.value = material.clearCoat;
		uniforms.clearCoatRoughness.value = material.clearCoatRoughness;

		refreshUniformsStandard( uniforms, material );

	}

	function refreshUniformsNormal( uniforms, material ) {

		if ( material.bumpMap ) {

			uniforms.bumpMap.value = material.bumpMap;
			uniforms.bumpScale.value = material.bumpScale;

		}

		if ( material.normalMap ) {

			uniforms.normalMap.value = material.normalMap;
			uniforms.normalScale.value.copy( material.normalScale );

		}

		if ( material.displacementMap ) {

			uniforms.displacementMap.value = material.displacementMap;
			uniforms.displacementScale.value = material.displacementScale;
			uniforms.displacementBias.value = material.displacementBias;

		}

	}

	// If uniforms are marked as clean, they don't need to be loaded to the GPU.

	function markUniformsLightsNeedsUpdate( uniforms, value ) {

		uniforms.ambientLightColor.needsUpdate = value;

		uniforms.directionalLights.needsUpdate = value;
		uniforms.pointLights.needsUpdate = value;
		uniforms.spotLights.needsUpdate = value;
		uniforms.rectAreaLights.needsUpdate = value;
		uniforms.hemisphereLights.needsUpdate = value;

	}

	// Lighting

	function setupShadows( lights ) {

		var lightShadowsLength = 0;

		for ( var i = 0, l = lights.length; i < l; i ++ ) {

			var light = lights[ i ];

			if ( light.castShadow ) {

				_lights.shadows[ lightShadowsLength ++ ] = light;

			}

		}

		_lights.shadows.length = lightShadowsLength;

	}

	function setupLights( lights, camera ) {

		var l, ll, light,
			r = 0, g = 0, b = 0,
			color,
			intensity,
			distance,
			shadowMap,

			viewMatrix = camera.matrixWorldInverse,

		directionalLength = 0,
		pointLength = 0,
		spotLength = 0,
		rectAreaLength = 0,
		hemiLength = 0;

		for ( l = 0, ll = lights.length; l < ll; l ++ ) {

			light = lights[ l ];

			color = light.color;
			intensity = light.intensity;
			distance = light.distance;

			shadowMap = ( light.shadow && light.shadow.map ) ? light.shadow.map.texture : null;

			if ( light.isAmbientLight ) {

				r += color.r * intensity;
				g += color.g * intensity;
				b += color.b * intensity;

			} else if ( light.isDirectionalLight ) {

				var uniforms = lightCache.get( light );

				uniforms.color.copy( light.color ).multiplyScalar( light.intensity );
				uniforms.direction.setFromMatrixPosition( light.matrixWorld );
				_vector3.setFromMatrixPosition( light.target.matrixWorld );
				uniforms.direction.sub( _vector3 );
				uniforms.direction.transformDirection( viewMatrix );

				uniforms.shadow = light.castShadow;

				if ( light.castShadow ) {

					uniforms.shadowBias = light.shadow.bias;
					uniforms.shadowRadius = light.shadow.radius;
					uniforms.shadowMapSize = light.shadow.mapSize;

				}

				_lights.directionalShadowMap[ directionalLength ] = shadowMap;
				_lights.directionalShadowMatrix[ directionalLength ] = light.shadow.matrix;
				_lights.directional[ directionalLength ++ ] = uniforms;

			} else if ( light.isSpotLight ) {

				var uniforms = lightCache.get( light );

				uniforms.position.setFromMatrixPosition( light.matrixWorld );
				uniforms.position.applyMatrix4( viewMatrix );

				uniforms.color.copy( color ).multiplyScalar( intensity );
				uniforms.distance = distance;

				uniforms.direction.setFromMatrixPosition( light.matrixWorld );
				_vector3.setFromMatrixPosition( light.target.matrixWorld );
				uniforms.direction.sub( _vector3 );
				uniforms.direction.transformDirection( viewMatrix );

				uniforms.coneCos = Math.cos( light.angle );
				uniforms.penumbraCos = Math.cos( light.angle * ( 1 - light.penumbra ) );
				uniforms.decay = ( light.distance === 0 ) ? 0.0 : light.decay;

				uniforms.shadow = light.castShadow;

				if ( light.castShadow ) {

					uniforms.shadowBias = light.shadow.bias;
					uniforms.shadowRadius = light.shadow.radius;
					uniforms.shadowMapSize = light.shadow.mapSize;

				}

				_lights.spotShadowMap[ spotLength ] = shadowMap;
				_lights.spotShadowMatrix[ spotLength ] = light.shadow.matrix;
				_lights.spot[ spotLength ++ ] = uniforms;

			} else if ( light.isRectAreaLight ) {

				var uniforms = lightCache.get( light );

				// (a) intensity controls irradiance of entire light
				uniforms.color
					.copy( color )
					.multiplyScalar( intensity / ( light.width * light.height ) );

				// (b) intensity controls the radiance per light area
				// uniforms.color.copy( color ).multiplyScalar( intensity );

				uniforms.position.setFromMatrixPosition( light.matrixWorld );
				uniforms.position.applyMatrix4( viewMatrix );

				// extract local rotation of light to derive width/height half vectors
				_matrix42.identity();
				_matrix4.copy( light.matrixWorld );
				_matrix4.premultiply( viewMatrix );
				_matrix42.extractRotation( _matrix4 );

				uniforms.halfWidth.set( light.width * 0.5,                0.0, 0.0 );
				uniforms.halfHeight.set(              0.0, light.height * 0.5, 0.0 );

				uniforms.halfWidth.applyMatrix4( _matrix42 );
				uniforms.halfHeight.applyMatrix4( _matrix42 );

				// TODO (abelnation): RectAreaLight distance?
				// uniforms.distance = distance;

				_lights.rectArea[ rectAreaLength ++ ] = uniforms;

			} else if ( light.isPointLight ) {

				var uniforms = lightCache.get( light );

				uniforms.position.setFromMatrixPosition( light.matrixWorld );
				uniforms.position.applyMatrix4( viewMatrix );

				uniforms.color.copy( light.color ).multiplyScalar( light.intensity );
				uniforms.distance = light.distance;
				uniforms.decay = ( light.distance === 0 ) ? 0.0 : light.decay;

				uniforms.shadow = light.castShadow;

				if ( light.castShadow ) {

					uniforms.shadowBias = light.shadow.bias;
					uniforms.shadowRadius = light.shadow.radius;
					uniforms.shadowMapSize = light.shadow.mapSize;

				}

				_lights.pointShadowMap[ pointLength ] = shadowMap;

				if ( _lights.pointShadowMatrix[ pointLength ] === undefined ) {

					_lights.pointShadowMatrix[ pointLength ] = new Matrix4();

				}

				// for point lights we set the shadow matrix to be a translation-only matrix
				// equal to inverse of the light's position
				_vector3.setFromMatrixPosition( light.matrixWorld ).negate();
				_lights.pointShadowMatrix[ pointLength ].identity().setPosition( _vector3 );

				_lights.point[ pointLength ++ ] = uniforms;

			} else if ( light.isHemisphereLight ) {

				var uniforms = lightCache.get( light );

				uniforms.direction.setFromMatrixPosition( light.matrixWorld );
				uniforms.direction.transformDirection( viewMatrix );
				uniforms.direction.normalize();

				uniforms.skyColor.copy( light.color ).multiplyScalar( intensity );
				uniforms.groundColor.copy( light.groundColor ).multiplyScalar( intensity );

				_lights.hemi[ hemiLength ++ ] = uniforms;

			}

		}

		_lights.ambient[ 0 ] = r;
		_lights.ambient[ 1 ] = g;
		_lights.ambient[ 2 ] = b;

		_lights.directional.length = directionalLength;
		_lights.spot.length = spotLength;
		_lights.rectArea.length = rectAreaLength;
		_lights.point.length = pointLength;
		_lights.hemi.length = hemiLength;

		// TODO (sam-g-steel) why aren't we using join
		_lights.hash = directionalLength + ',' + pointLength + ',' + spotLength + ',' + rectAreaLength + ',' + hemiLength + ',' + _lights.shadows.length;

	}

	// GL state setting

	this.setFaceCulling = function ( cullFace, frontFaceDirection ) {

		state.setCullFace( cullFace );
		state.setFlipSided( frontFaceDirection === FrontFaceDirectionCW );

	};

	// Textures

	function allocTextureUnit() {

		var textureUnit = _usedTextureUnits;

		if ( textureUnit >= capabilities.maxTextures ) {

			console.warn( 'WebGLRenderer: trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures );

		}

		_usedTextureUnits += 1;

		return textureUnit;

	}

	this.allocTextureUnit = allocTextureUnit;

	// this.setTexture2D = setTexture2D;
	this.setTexture2D = ( function() {

		var warned = false;

		// backwards compatibility: peel texture.texture
		return function setTexture2D( texture, slot ) {

			if ( texture && texture.isWebGLRenderTarget ) {

				if ( ! warned ) {

					console.warn( "THREE.WebGLRenderer.setTexture2D: don't use render targets as textures. Use their .texture property instead." );
					warned = true;

				}

				texture = texture.texture;

			}

			textures.setTexture2D( texture, slot );

		};

	}() );

	this.setTexture = ( function() {

		var warned = false;

		return function setTexture( texture, slot ) {

			if ( ! warned ) {

				console.warn( "THREE.WebGLRenderer: .setTexture is deprecated, use setTexture2D instead." );
				warned = true;

			}

			textures.setTexture2D( texture, slot );

		};

	}() );

	this.setTextureCube = ( function() {

		var warned = false;

		return function setTextureCube( texture, slot ) {

			// backwards compatibility: peel texture.texture
			if ( texture && texture.isWebGLRenderTargetCube ) {

				if ( ! warned ) {

					console.warn( "THREE.WebGLRenderer.setTextureCube: don't use cube render targets as textures. Use their .texture property instead." );
					warned = true;

				}

				texture = texture.texture;

			}

			// currently relying on the fact that WebGLRenderTargetCube.texture is a Texture and NOT a CubeTexture
			// TODO: unify these code paths
			if ( ( texture && texture.isCubeTexture ) ||
				( Array.isArray( texture.image ) && texture.image.length === 6 ) ) {

				// CompressedTexture can have Array in image :/

				// this function alone should take care of cube textures
				textures.setTextureCube( texture, slot );

			} else {

				// assumed: texture property of THREE.WebGLRenderTargetCube

				textures.setTextureCubeDynamic( texture, slot );

			}

		};

	}() );

	this.getCurrentRenderTarget = function() {

		return _currentRenderTarget;

	};

	this.setRenderTarget = function ( renderTarget ) {

		_currentRenderTarget = renderTarget;

		if ( renderTarget && properties.get( renderTarget ).__webglFramebuffer === undefined ) {

			textures.setupRenderTarget( renderTarget );

		}

		var isCube = ( renderTarget && renderTarget.isWebGLRenderTargetCube );
		var framebuffer;

		if ( renderTarget ) {

			var renderTargetProperties = properties.get( renderTarget );

			if ( isCube ) {

				framebuffer = renderTargetProperties.__webglFramebuffer[ renderTarget.activeCubeFace ];

			} else {

				framebuffer = renderTargetProperties.__webglFramebuffer;

			}

			_currentScissor.copy( renderTarget.scissor );
			_currentScissorTest = renderTarget.scissorTest;

			_currentViewport.copy( renderTarget.viewport );

		} else {

			framebuffer = null;

			_currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio );
			_currentScissorTest = _scissorTest;

			_currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio );

		}

		if ( _currentFramebuffer !== framebuffer ) {

			_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );
			_currentFramebuffer = framebuffer;

		}

		state.scissor( _currentScissor );
		state.setScissorTest( _currentScissorTest );

		state.viewport( _currentViewport );

		if ( isCube ) {

			var textureProperties = properties.get( renderTarget.texture );
			_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + renderTarget.activeCubeFace, textureProperties.__webglTexture, renderTarget.activeMipMapLevel );

		}

	};

	this.readRenderTargetPixels = function ( renderTarget, x, y, width, height, buffer ) {

		if ( ( renderTarget && renderTarget.isWebGLRenderTarget ) === false ) {

			console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.' );
			return;

		}

		var framebuffer = properties.get( renderTarget ).__webglFramebuffer;

		if ( framebuffer ) {

			var restore = false;

			if ( framebuffer !== _currentFramebuffer ) {

				_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

				restore = true;

			}

			try {

				var texture = renderTarget.texture;
				var textureFormat = texture.format;
				var textureType = texture.type;

				if ( textureFormat !== RGBAFormat && paramThreeToGL( textureFormat ) !== _gl.getParameter( _gl.IMPLEMENTATION_COLOR_READ_FORMAT ) ) {

					console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.' );
					return;

				}

				if ( textureType !== UnsignedByteType && paramThreeToGL( textureType ) !== _gl.getParameter( _gl.IMPLEMENTATION_COLOR_READ_TYPE ) && // IE11, Edge and Chrome Mac < 52 (#9513)
					! ( textureType === FloatType && ( extensions.get( 'OES_texture_float' ) || extensions.get( 'WEBGL_color_buffer_float' ) ) ) && // Chrome Mac >= 52 and Firefox
					! ( textureType === HalfFloatType && extensions.get( 'EXT_color_buffer_half_float' ) ) ) {

					console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.' );
					return;

				}

				if ( _gl.checkFramebufferStatus( _gl.FRAMEBUFFER ) === _gl.FRAMEBUFFER_COMPLETE ) {

					// the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)

					if ( ( x >= 0 && x <= ( renderTarget.width - width ) ) && ( y >= 0 && y <= ( renderTarget.height - height ) ) ) {

						_gl.readPixels( x, y, width, height, paramThreeToGL( textureFormat ), paramThreeToGL( textureType ), buffer );

					}

				} else {

					console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.' );

				}

			} finally {

				if ( restore ) {

					_gl.bindFramebuffer( _gl.FRAMEBUFFER, _currentFramebuffer );

				}

			}

		}

	};

	// Map three.js constants to WebGL constants

	function paramThreeToGL( p ) {

		var extension;

		if ( p === RepeatWrapping ) return _gl.REPEAT;
		if ( p === ClampToEdgeWrapping ) return _gl.CLAMP_TO_EDGE;
		if ( p === MirroredRepeatWrapping ) return _gl.MIRRORED_REPEAT;

		if ( p === NearestFilter ) return _gl.NEAREST;
		if ( p === NearestMipMapNearestFilter ) return _gl.NEAREST_MIPMAP_NEAREST;
		if ( p === NearestMipMapLinearFilter ) return _gl.NEAREST_MIPMAP_LINEAR;

		if ( p === LinearFilter ) return _gl.LINEAR;
		if ( p === LinearMipMapNearestFilter ) return _gl.LINEAR_MIPMAP_NEAREST;
		if ( p === LinearMipMapLinearFilter ) return _gl.LINEAR_MIPMAP_LINEAR;

		if ( p === UnsignedByteType ) return _gl.UNSIGNED_BYTE;
		if ( p === UnsignedShort4444Type ) return _gl.UNSIGNED_SHORT_4_4_4_4;
		if ( p === UnsignedShort5551Type ) return _gl.UNSIGNED_SHORT_5_5_5_1;
		if ( p === UnsignedShort565Type ) return _gl.UNSIGNED_SHORT_5_6_5;

		if ( p === ByteType ) return _gl.BYTE;
		if ( p === ShortType ) return _gl.SHORT;
		if ( p === UnsignedShortType ) return _gl.UNSIGNED_SHORT;
		if ( p === IntType ) return _gl.INT;
		if ( p === UnsignedIntType ) return _gl.UNSIGNED_INT;
		if ( p === FloatType ) return _gl.FLOAT;

		if ( p === HalfFloatType ) {

			extension = extensions.get( 'OES_texture_half_float' );

			if ( extension !== null ) return extension.HALF_FLOAT_OES;

		}

		if ( p === AlphaFormat ) return _gl.ALPHA;
		if ( p === RGBFormat ) return _gl.RGB;
		if ( p === RGBAFormat ) return _gl.RGBA;
		if ( p === LuminanceFormat ) return _gl.LUMINANCE;
		if ( p === LuminanceAlphaFormat ) return _gl.LUMINANCE_ALPHA;
		if ( p === DepthFormat ) return _gl.DEPTH_COMPONENT;
		if ( p === DepthStencilFormat ) return _gl.DEPTH_STENCIL;

		if ( p === AddEquation ) return _gl.FUNC_ADD;
		if ( p === SubtractEquation ) return _gl.FUNC_SUBTRACT;
		if ( p === ReverseSubtractEquation ) return _gl.FUNC_REVERSE_SUBTRACT;

		if ( p === ZeroFactor ) return _gl.ZERO;
		if ( p === OneFactor ) return _gl.ONE;
		if ( p === SrcColorFactor ) return _gl.SRC_COLOR;
		if ( p === OneMinusSrcColorFactor ) return _gl.ONE_MINUS_SRC_COLOR;
		if ( p === SrcAlphaFactor ) return _gl.SRC_ALPHA;
		if ( p === OneMinusSrcAlphaFactor ) return _gl.ONE_MINUS_SRC_ALPHA;
		if ( p === DstAlphaFactor ) return _gl.DST_ALPHA;
		if ( p === OneMinusDstAlphaFactor ) return _gl.ONE_MINUS_DST_ALPHA;

		if ( p === DstColorFactor ) return _gl.DST_COLOR;
		if ( p === OneMinusDstColorFactor ) return _gl.ONE_MINUS_DST_COLOR;
		if ( p === SrcAlphaSaturateFactor ) return _gl.SRC_ALPHA_SATURATE;

		if ( p === RGB_S3TC_DXT1_Format || p === RGBA_S3TC_DXT1_Format ||
			p === RGBA_S3TC_DXT3_Format || p === RGBA_S3TC_DXT5_Format ) {

			extension = extensions.get( 'WEBGL_compressed_texture_s3tc' );

			if ( extension !== null ) {

				if ( p === RGB_S3TC_DXT1_Format ) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
				if ( p === RGBA_S3TC_DXT1_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
				if ( p === RGBA_S3TC_DXT3_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
				if ( p === RGBA_S3TC_DXT5_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;

			}

		}

		if ( p === RGB_PVRTC_4BPPV1_Format || p === RGB_PVRTC_2BPPV1_Format ||
			p === RGBA_PVRTC_4BPPV1_Format || p === RGBA_PVRTC_2BPPV1_Format ) {

			extension = extensions.get( 'WEBGL_compressed_texture_pvrtc' );

			if ( extension !== null ) {

				if ( p === RGB_PVRTC_4BPPV1_Format ) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
				if ( p === RGB_PVRTC_2BPPV1_Format ) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
				if ( p === RGBA_PVRTC_4BPPV1_Format ) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
				if ( p === RGBA_PVRTC_2BPPV1_Format ) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;

			}

		}

		if ( p === RGB_ETC1_Format ) {

			extension = extensions.get( 'WEBGL_compressed_texture_etc1' );

			if ( extension !== null ) return extension.COMPRESSED_RGB_ETC1_WEBGL;

		}

		if ( p === MinEquation || p === MaxEquation ) {

			extension = extensions.get( 'EXT_blend_minmax' );

			if ( extension !== null ) {

				if ( p === MinEquation ) return extension.MIN_EXT;
				if ( p === MaxEquation ) return extension.MAX_EXT;

			}

		}

		if ( p === UnsignedInt248Type ) {

			extension = extensions.get( 'WEBGL_depth_texture' );

			if ( extension !== null ) return extension.UNSIGNED_INT_24_8_WEBGL;

		}

		return 0;

	}

}

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 */

function FogExp2 ( color, density ) {

	this.name = '';

	this.color = new Color( color );
	this.density = ( density !== undefined ) ? density : 0.00025;

}

FogExp2.prototype.isFogExp2 = true;

FogExp2.prototype.clone = function () {

	return new FogExp2( this.color.getHex(), this.density );

};

FogExp2.prototype.toJSON = function ( meta ) {

	return {
		type: 'FogExp2',
		color: this.color.getHex(),
		density: this.density
	};

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 */

function Fog ( color, near, far ) {

	this.name = '';

	this.color = new Color( color );

	this.near = ( near !== undefined ) ? near : 1;
	this.far = ( far !== undefined ) ? far : 1000;

}

Fog.prototype.isFog = true;

Fog.prototype.clone = function () {

	return new Fog( this.color.getHex(), this.near, this.far );

};

Fog.prototype.toJSON = function ( meta ) {

	return {
		type: 'Fog',
		color: this.color.getHex(),
		near: this.near,
		far: this.far
	};

};

/**
 * @author mrdoob / http://mrdoob.com/
 */

function Scene () {

	Object3D.call( this );

	this.type = 'Scene';

	this.background = null;
	this.fog = null;
	this.overrideMaterial = null;

	this.autoUpdate = true; // checked by the renderer

}

Scene.prototype = Object.create( Object3D.prototype );

Scene.prototype.constructor = Scene;

Scene.prototype.copy = function ( source, recursive ) {

	Object3D.prototype.copy.call( this, source, recursive );

	if ( source.background !== null ) this.background = source.background.clone();
	if ( source.fog !== null ) this.fog = source.fog.clone();
	if ( source.overrideMaterial !== null ) this.overrideMaterial = source.overrideMaterial.clone();

	this.autoUpdate = source.autoUpdate;
	this.matrixAutoUpdate = source.matrixAutoUpdate;

	return this;

};

Scene.prototype.toJSON = function ( meta ) {

	var data = Object3D.prototype.toJSON.call( this, meta );

	if ( this.background !== null ) data.object.background = this.background.toJSON( meta );
	if ( this.fog !== null ) data.object.fog = this.fog.toJSON();

	return data;

};

/**
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 */

function LensFlare( texture, size, distance, blending, color ) {

	Object3D.call( this );

	this.lensFlares = [];

	this.positionScreen = new Vector3();
	this.customUpdateCallback = undefined;

	if ( texture !== undefined ) {

		this.add( texture, size, distance, blending, color );

	}

}

LensFlare.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: LensFlare,

	isLensFlare: true,

	copy: function ( source ) {

		Object3D.prototype.copy.call( this, source );

		this.positionScreen.copy( source.positionScreen );
		this.customUpdateCallback = source.customUpdateCallback;

		for ( var i = 0, l = source.lensFlares.length; i < l; i ++ ) {

			this.lensFlares.push( source.lensFlares[ i ] );

		}

		return this;

	},

	add: function ( texture, size, distance, blending, color, opacity ) {

		if ( size === undefined ) size = - 1;
		if ( distance === undefined ) distance = 0;
		if ( opacity === undefined ) opacity = 1;
		if ( color === undefined ) color = new Color( 0xffffff );
		if ( blending === undefined ) blending = NormalBlending;

		distance = Math.min( distance, Math.max( 0, distance ) );

		this.lensFlares.push( {
			texture: texture,	// THREE.Texture
			size: size, 		// size in pixels (-1 = use texture.width)
			distance: distance, 	// distance (0-1) from light source (0=at light source)
			x: 0, y: 0, z: 0,	// screen position (-1 => 1) z = 0 is in front z = 1 is back
			scale: 1, 		// scale
			rotation: 0, 		// rotation
			opacity: opacity,	// opacity
			color: color,		// color
			blending: blending	// blending
		} );

	},

	/*
	 * Update lens flares update positions on all flares based on the screen position
	 * Set myLensFlare.customUpdateCallback to alter the flares in your project specific way.
	 */

	updateLensFlares: function () {

		var f, fl = this.lensFlares.length;
		var flare;
		var vecX = - this.positionScreen.x * 2;
		var vecY = - this.positionScreen.y * 2;

		for ( f = 0; f < fl; f ++ ) {

			flare = this.lensFlares[ f ];

			flare.x = this.positionScreen.x + vecX * flare.distance;
			flare.y = this.positionScreen.y + vecY * flare.distance;

			flare.wantedRotation = flare.x * Math.PI * 0.25;
			flare.rotation += ( flare.wantedRotation - flare.rotation ) * 0.25;

		}

	}

} );

/**
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *
 *	uvOffset: new THREE.Vector2(),
 *	uvScale: new THREE.Vector2()
 * }
 */

function SpriteMaterial( parameters ) {

	Material.call( this );

	this.type = 'SpriteMaterial';

	this.color = new Color( 0xffffff );
	this.map = null;

	this.rotation = 0;

	this.fog = false;
	this.lights = false;

	this.setValues( parameters );

}

SpriteMaterial.prototype = Object.create( Material.prototype );
SpriteMaterial.prototype.constructor = SpriteMaterial;

SpriteMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.color.copy( source.color );
	this.map = source.map;

	this.rotation = source.rotation;

	return this;

};

/**
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 */

function Sprite( material ) {

	Object3D.call( this );

	this.type = 'Sprite';

	this.material = ( material !== undefined ) ? material : new SpriteMaterial();

}

Sprite.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: Sprite,

	isSprite: true,

	raycast: ( function () {

		var matrixPosition = new Vector3();

		return function raycast( raycaster, intersects ) {

			matrixPosition.setFromMatrixPosition( this.matrixWorld );

			var distanceSq = raycaster.ray.distanceSqToPoint( matrixPosition );
			var guessSizeSq = this.scale.x * this.scale.y / 4;

			if ( distanceSq > guessSizeSq ) {

				return;

			}

			intersects.push( {

				distance: Math.sqrt( distanceSq ),
				point: this.position,
				face: null,
				object: this

			} );

		};

	}() ),

	clone: function () {

		return new this.constructor( this.material ).copy( this );

	}

} );

/**
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 */

function LOD() {

	Object3D.call( this );

	this.type = 'LOD';

	Object.defineProperties( this, {
		levels: {
			enumerable: true,
			value: []
		}
	} );

}


LOD.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: LOD,

	copy: function ( source ) {

		Object3D.prototype.copy.call( this, source, false );

		var levels = source.levels;

		for ( var i = 0, l = levels.length; i < l; i ++ ) {

			var level = levels[ i ];

			this.addLevel( level.object.clone(), level.distance );

		}

		return this;

	},

	addLevel: function ( object, distance ) {

		if ( distance === undefined ) distance = 0;

		distance = Math.abs( distance );

		var levels = this.levels;

		for ( var l = 0; l < levels.length; l ++ ) {

			if ( distance < levels[ l ].distance ) {

				break;

			}

		}

		levels.splice( l, 0, { distance: distance, object: object } );

		this.add( object );

	},

	getObjectForDistance: function ( distance ) {

		var levels = this.levels;

		for ( var i = 1, l = levels.length; i < l; i ++ ) {

			if ( distance < levels[ i ].distance ) {

				break;

			}

		}

		return levels[ i - 1 ].object;

	},

	raycast: ( function () {

		var matrixPosition = new Vector3();

		return function raycast( raycaster, intersects ) {

			matrixPosition.setFromMatrixPosition( this.matrixWorld );

			var distance = raycaster.ray.origin.distanceTo( matrixPosition );

			this.getObjectForDistance( distance ).raycast( raycaster, intersects );

		};

	}() ),

	update: function () {

		var v1 = new Vector3();
		var v2 = new Vector3();

		return function update( camera ) {

			var levels = this.levels;

			if ( levels.length > 1 ) {

				v1.setFromMatrixPosition( camera.matrixWorld );
				v2.setFromMatrixPosition( this.matrixWorld );

				var distance = v1.distanceTo( v2 );

				levels[ 0 ].object.visible = true;

				for ( var i = 1, l = levels.length; i < l; i ++ ) {

					if ( distance >= levels[ i ].distance ) {

						levels[ i - 1 ].object.visible = false;
						levels[ i ].object.visible = true;

					} else {

						break;

					}

				}

				for ( ; i < l; i ++ ) {

					levels[ i ].object.visible = false;

				}

			}

		};

	}(),

	toJSON: function ( meta ) {

		var data = Object3D.prototype.toJSON.call( this, meta );

		data.object.levels = [];

		var levels = this.levels;

		for ( var i = 0, l = levels.length; i < l; i ++ ) {

			var level = levels[ i ];

			data.object.levels.push( {
				object: level.object.uuid,
				distance: level.distance
			} );

		}

		return data;

	}

} );

/**
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 * @author michael guerrero / http://realitymeltdown.com
 * @author ikerr / http://verold.com
 */

function Skeleton( bones, boneInverses, useVertexTexture ) {

	this.useVertexTexture = useVertexTexture !== undefined ? useVertexTexture : true;

	this.identityMatrix = new Matrix4();

	// copy the bone array

	bones = bones || [];

	this.bones = bones.slice( 0 );

	// create a bone texture or an array of floats

	if ( this.useVertexTexture ) {

		// layout (1 matrix = 4 pixels)
		//      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
		//  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
		//       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
		//       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
		//       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)


		var size = Math.sqrt( this.bones.length * 4 ); // 4 pixels needed for 1 matrix
		size = _Math.nextPowerOfTwo( Math.ceil( size ) );
		size = Math.max( size, 4 );

		this.boneTextureWidth = size;
		this.boneTextureHeight = size;

		this.boneMatrices = new Float32Array( this.boneTextureWidth * this.boneTextureHeight * 4 ); // 4 floats per RGBA pixel
		this.boneTexture = new DataTexture( this.boneMatrices, this.boneTextureWidth, this.boneTextureHeight, RGBAFormat, FloatType );

	} else {

		this.boneMatrices = new Float32Array( 16 * this.bones.length );

	}

	// use the supplied bone inverses or calculate the inverses

	if ( boneInverses === undefined ) {

		this.calculateInverses();

	} else {

		if ( this.bones.length === boneInverses.length ) {

			this.boneInverses = boneInverses.slice( 0 );

		} else {

			console.warn( 'THREE.Skeleton bonInverses is the wrong length.' );

			this.boneInverses = [];

			for ( var b = 0, bl = this.bones.length; b < bl; b ++ ) {

				this.boneInverses.push( new Matrix4() );

			}

		}

	}

}

Object.assign( Skeleton.prototype, {

	calculateInverses: function () {

		this.boneInverses = [];

		for ( var b = 0, bl = this.bones.length; b < bl; b ++ ) {

			var inverse = new Matrix4();

			if ( this.bones[ b ] ) {

				inverse.getInverse( this.bones[ b ].matrixWorld );

			}

			this.boneInverses.push( inverse );

		}

	},

	pose: function () {

		var bone;

		// recover the bind-time world matrices

		for ( var b = 0, bl = this.bones.length; b < bl; b ++ ) {

			bone = this.bones[ b ];

			if ( bone ) {

				bone.matrixWorld.getInverse( this.boneInverses[ b ] );

			}

		}

		// compute the local matrices, positions, rotations and scales

		for ( var b = 0, bl = this.bones.length; b < bl; b ++ ) {

			bone = this.bones[ b ];

			if ( bone ) {

				if ( bone.parent && bone.parent.isBone ) {

					bone.matrix.getInverse( bone.parent.matrixWorld );
					bone.matrix.multiply( bone.matrixWorld );

				} else {

					bone.matrix.copy( bone.matrixWorld );

				}

				bone.matrix.decompose( bone.position, bone.quaternion, bone.scale );

			}

		}

	},

	update: ( function () {

		var offsetMatrix = new Matrix4();

		return function update() {

			// flatten bone matrices to array

			for ( var b = 0, bl = this.bones.length; b < bl; b ++ ) {

				// compute the offset between the current and the original transform

				var matrix = this.bones[ b ] ? this.bones[ b ].matrixWorld : this.identityMatrix;

				offsetMatrix.multiplyMatrices( matrix, this.boneInverses[ b ] );
				offsetMatrix.toArray( this.boneMatrices, b * 16 );

			}

			if ( this.useVertexTexture ) {

				this.boneTexture.needsUpdate = true;

			}

		};

	} )(),

	clone: function () {

		return new Skeleton( this.bones, this.boneInverses, this.useVertexTexture );

	}

} );

/**
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 * @author ikerr / http://verold.com
 */

function Bone() {

	Object3D.call( this );

	this.type = 'Bone';

}

Bone.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: Bone,

	isBone: true

} );

/**
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 * @author ikerr / http://verold.com
 */

function SkinnedMesh( geometry, material, useVertexTexture ) {

	Mesh.call( this, geometry, material );

	this.type = 'SkinnedMesh';

	this.bindMode = "attached";
	this.bindMatrix = new Matrix4();
	this.bindMatrixInverse = new Matrix4();

	// init bones

	// TODO: remove bone creation as there is no reason (other than
	// convenience) for THREE.SkinnedMesh to do this.

	var bones = [];

	if ( this.geometry && this.geometry.bones !== undefined ) {

		var bone, gbone;

		for ( var b = 0, bl = this.geometry.bones.length; b < bl; ++ b ) {

			gbone = this.geometry.bones[ b ];

			bone = new Bone();
			bones.push( bone );

			bone.name = gbone.name;
			bone.position.fromArray( gbone.pos );
			bone.quaternion.fromArray( gbone.rotq );
			if ( gbone.scl !== undefined ) bone.scale.fromArray( gbone.scl );

		}

		for ( var b = 0, bl = this.geometry.bones.length; b < bl; ++ b ) {

			gbone = this.geometry.bones[ b ];

			if ( gbone.parent !== - 1 && gbone.parent !== null &&
					bones[ gbone.parent ] !== undefined ) {

				bones[ gbone.parent ].add( bones[ b ] );

			} else {

				this.add( bones[ b ] );

			}

		}

	}

	this.normalizeSkinWeights();

	this.updateMatrixWorld( true );
	this.bind( new Skeleton( bones, undefined, useVertexTexture ), this.matrixWorld );

}


SkinnedMesh.prototype = Object.assign( Object.create( Mesh.prototype ), {

	constructor: SkinnedMesh,

	isSkinnedMesh: true,

	bind: function( skeleton, bindMatrix ) {

		this.skeleton = skeleton;

		if ( bindMatrix === undefined ) {

			this.updateMatrixWorld( true );

			this.skeleton.calculateInverses();

			bindMatrix = this.matrixWorld;

		}

		this.bindMatrix.copy( bindMatrix );
		this.bindMatrixInverse.getInverse( bindMatrix );

	},

	pose: function () {

		this.skeleton.pose();

	},

	normalizeSkinWeights: function () {

		if ( this.geometry && this.geometry.isGeometry ) {

			for ( var i = 0; i < this.geometry.skinWeights.length; i ++ ) {

				var sw = this.geometry.skinWeights[ i ];

				var scale = 1.0 / sw.lengthManhattan();

				if ( scale !== Infinity ) {

					sw.multiplyScalar( scale );

				} else {

					sw.set( 1, 0, 0, 0 ); // do something reasonable

				}

			}

		} else if ( this.geometry && this.geometry.isBufferGeometry ) {

			var vec = new Vector4();

			var skinWeight = this.geometry.attributes.skinWeight;

			for ( var i = 0; i < skinWeight.count; i ++ ) {

				vec.x = skinWeight.getX( i );
				vec.y = skinWeight.getY( i );
				vec.z = skinWeight.getZ( i );
				vec.w = skinWeight.getW( i );

				var scale = 1.0 / vec.lengthManhattan();

				if ( scale !== Infinity ) {

					vec.multiplyScalar( scale );

				} else {

					vec.set( 1, 0, 0, 0 ); // do something reasonable

				}

				skinWeight.setXYZW( i, vec.x, vec.y, vec.z, vec.w );

			}

		}

	},

	updateMatrixWorld: function( force ) {

		Mesh.prototype.updateMatrixWorld.call( this, true );

		if ( this.bindMode === "attached" ) {

			this.bindMatrixInverse.getInverse( this.matrixWorld );

		} else if ( this.bindMode === "detached" ) {

			this.bindMatrixInverse.getInverse( this.bindMatrix );

		} else {

			console.warn( 'THREE.SkinnedMesh unrecognized bindMode: ' + this.bindMode );

		}

	},

	clone: function() {

		return new this.constructor( this.geometry, this.material, this.skeleton.useVertexTexture ).copy( this );

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  linewidth: <float>,
 *  linecap: "round",
 *  linejoin: "round"
 * }
 */

function LineBasicMaterial( parameters ) {

	Material.call( this );

	this.type = 'LineBasicMaterial';

	this.color = new Color( 0xffffff );

	this.linewidth = 1;
	this.linecap = 'round';
	this.linejoin = 'round';

	this.lights = false;

	this.setValues( parameters );

}

LineBasicMaterial.prototype = Object.create( Material.prototype );
LineBasicMaterial.prototype.constructor = LineBasicMaterial;

LineBasicMaterial.prototype.isLineBasicMaterial = true;

LineBasicMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.color.copy( source.color );

	this.linewidth = source.linewidth;
	this.linecap = source.linecap;
	this.linejoin = source.linejoin;

	return this;

};

/**
 * @author mrdoob / http://mrdoob.com/
 */

function Line( geometry, material, mode ) {

	if ( mode === 1 ) {

		console.warn( 'THREE.Line: parameter THREE.LinePieces no longer supported. Created THREE.LineSegments instead.' );
		return new LineSegments( geometry, material );

	}

	Object3D.call( this );

	this.type = 'Line';

	this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
	this.material = material !== undefined ? material : new LineBasicMaterial( { color: Math.random() * 0xffffff } );

}

Line.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: Line,

	isLine: true,

	raycast: ( function () {

		var inverseMatrix = new Matrix4();
		var ray = new Ray();
		var sphere = new Sphere();

		return function raycast( raycaster, intersects ) {

			var precision = raycaster.linePrecision;
			var precisionSq = precision * precision;

			var geometry = this.geometry;
			var matrixWorld = this.matrixWorld;

			// Checking boundingSphere distance to ray

			if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

			sphere.copy( geometry.boundingSphere );
			sphere.applyMatrix4( matrixWorld );

			if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;

			//

			inverseMatrix.getInverse( matrixWorld );
			ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );

			var vStart = new Vector3();
			var vEnd = new Vector3();
			var interSegment = new Vector3();
			var interRay = new Vector3();
			var step = (this && this.isLineSegments) ? 2 : 1;

			if ( geometry.isBufferGeometry ) {

				var index = geometry.index;
				var attributes = geometry.attributes;
				var positions = attributes.position.array;

				if ( index !== null ) {

					var indices = index.array;

					for ( var i = 0, l = indices.length - 1; i < l; i += step ) {

						var a = indices[ i ];
						var b = indices[ i + 1 ];

						vStart.fromArray( positions, a * 3 );
						vEnd.fromArray( positions, b * 3 );

						var distSq = ray.distanceSqToSegment( vStart, vEnd, interRay, interSegment );

						if ( distSq > precisionSq ) continue;

						interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation

						var distance = raycaster.ray.origin.distanceTo( interRay );

						if ( distance < raycaster.near || distance > raycaster.far ) continue;

						intersects.push( {

							distance: distance,
							// What do we want? intersection point on the ray or on the segment??
							// point: raycaster.ray.at( distance ),
							point: interSegment.clone().applyMatrix4( this.matrixWorld ),
							index: i,
							face: null,
							faceIndex: null,
							object: this

						} );

					}

				} else {

					for ( var i = 0, l = positions.length / 3 - 1; i < l; i += step ) {

						vStart.fromArray( positions, 3 * i );
						vEnd.fromArray( positions, 3 * i + 3 );

						var distSq = ray.distanceSqToSegment( vStart, vEnd, interRay, interSegment );

						if ( distSq > precisionSq ) continue;

						interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation

						var distance = raycaster.ray.origin.distanceTo( interRay );

						if ( distance < raycaster.near || distance > raycaster.far ) continue;

						intersects.push( {

							distance: distance,
							// What do we want? intersection point on the ray or on the segment??
							// point: raycaster.ray.at( distance ),
							point: interSegment.clone().applyMatrix4( this.matrixWorld ),
							index: i,
							face: null,
							faceIndex: null,
							object: this

						} );

					}

				}

			} else if ( geometry.isGeometry ) {

				var vertices = geometry.vertices;
				var nbVertices = vertices.length;

				for ( var i = 0; i < nbVertices - 1; i += step ) {

					var distSq = ray.distanceSqToSegment( vertices[ i ], vertices[ i + 1 ], interRay, interSegment );

					if ( distSq > precisionSq ) continue;

					interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation

					var distance = raycaster.ray.origin.distanceTo( interRay );

					if ( distance < raycaster.near || distance > raycaster.far ) continue;

					intersects.push( {

						distance: distance,
						// What do we want? intersection point on the ray or on the segment??
						// point: raycaster.ray.at( distance ),
						point: interSegment.clone().applyMatrix4( this.matrixWorld ),
						index: i,
						face: null,
						faceIndex: null,
						object: this

					} );

				}

			}

		};

	}() ),

	clone: function () {

		return new this.constructor( this.geometry, this.material ).copy( this );

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function LineSegments( geometry, material ) {

	Line.call( this, geometry, material );

	this.type = 'LineSegments';

}

LineSegments.prototype = Object.assign( Object.create( Line.prototype ), {

	constructor: LineSegments,

	isLineSegments: true

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *
 *  size: <float>,
 *  sizeAttenuation: <bool>
 * }
 */

function PointsMaterial( parameters ) {

	Material.call( this );

	this.type = 'PointsMaterial';

	this.color = new Color( 0xffffff );

	this.map = null;

	this.size = 1;
	this.sizeAttenuation = true;

	this.lights = false;

	this.setValues( parameters );

}

PointsMaterial.prototype = Object.create( Material.prototype );
PointsMaterial.prototype.constructor = PointsMaterial;

PointsMaterial.prototype.isPointsMaterial = true;

PointsMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.color.copy( source.color );

	this.map = source.map;

	this.size = source.size;
	this.sizeAttenuation = source.sizeAttenuation;

	return this;

};

/**
 * @author alteredq / http://alteredqualia.com/
 */

function Points( geometry, material ) {

	Object3D.call( this );

	this.type = 'Points';

	this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
	this.material = material !== undefined ? material : new PointsMaterial( { color: Math.random() * 0xffffff } );

}

Points.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: Points,

	isPoints: true,

	raycast: ( function () {

		var inverseMatrix = new Matrix4();
		var ray = new Ray();
		var sphere = new Sphere();

		return function raycast( raycaster, intersects ) {

			var object = this;
			var geometry = this.geometry;
			var matrixWorld = this.matrixWorld;
			var threshold = raycaster.params.Points.threshold;

			// Checking boundingSphere distance to ray

			if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

			sphere.copy( geometry.boundingSphere );
			sphere.applyMatrix4( matrixWorld );

			if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;

			//

			inverseMatrix.getInverse( matrixWorld );
			ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );

			var localThreshold = threshold / ( ( this.scale.x + this.scale.y + this.scale.z ) / 3 );
			var localThresholdSq = localThreshold * localThreshold;
			var position = new Vector3();

			function testPoint( point, index ) {

				var rayPointDistanceSq = ray.distanceSqToPoint( point );

				if ( rayPointDistanceSq < localThresholdSq ) {

					var intersectPoint = ray.closestPointToPoint( point );
					intersectPoint.applyMatrix4( matrixWorld );

					var distance = raycaster.ray.origin.distanceTo( intersectPoint );

					if ( distance < raycaster.near || distance > raycaster.far ) return;

					intersects.push( {

						distance: distance,
						distanceToRay: Math.sqrt( rayPointDistanceSq ),
						point: intersectPoint.clone(),
						index: index,
						face: null,
						object: object

					} );

				}

			}

			if ( geometry.isBufferGeometry ) {

				var index = geometry.index;
				var attributes = geometry.attributes;
				var positions = attributes.position.array;

				if ( index !== null ) {

					var indices = index.array;

					for ( var i = 0, il = indices.length; i < il; i ++ ) {

						var a = indices[ i ];

						position.fromArray( positions, a * 3 );

						testPoint( position, a );

					}

				} else {

					for ( var i = 0, l = positions.length / 3; i < l; i ++ ) {

						position.fromArray( positions, i * 3 );

						testPoint( position, i );

					}

				}

			} else {

				var vertices = geometry.vertices;

				for ( var i = 0, l = vertices.length; i < l; i ++ ) {

					testPoint( vertices[ i ], i );

				}

			}

		};

	}() ),

	clone: function () {

		return new this.constructor( this.geometry, this.material ).copy( this );

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function Group() {

	Object3D.call( this );

	this.type = 'Group';

}

Group.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: Group

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function VideoTexture( video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy ) {

	Texture.call( this, video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );

	this.generateMipmaps = false;

	var scope = this;

	function update() {

		requestAnimationFrame( update );

		if ( video.readyState >= video.HAVE_CURRENT_DATA ) {

			scope.needsUpdate = true;

		}

	}

	update();

}

VideoTexture.prototype = Object.create( Texture.prototype );
VideoTexture.prototype.constructor = VideoTexture;

/**
 * @author alteredq / http://alteredqualia.com/
 */

function CompressedTexture( mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding ) {

	Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );

	this.image = { width: width, height: height };
	this.mipmaps = mipmaps;

	// no flipping for cube textures
	// (also flipping doesn't work for compressed textures )

	this.flipY = false;

	// can't generate mipmaps for compressed textures
	// mips must be embedded in DDS files

	this.generateMipmaps = false;

}

CompressedTexture.prototype = Object.create( Texture.prototype );
CompressedTexture.prototype.constructor = CompressedTexture;

CompressedTexture.prototype.isCompressedTexture = true;

/**
 * @author mrdoob / http://mrdoob.com/
 */

function CanvasTexture( canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy ) {

	Texture.call( this, canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );

	this.needsUpdate = true;

}

CanvasTexture.prototype = Object.create( Texture.prototype );
CanvasTexture.prototype.constructor = CanvasTexture;

/**
 * @author Matt DesLauriers / @mattdesl
 * @author atix / arthursilber.de
 */

function DepthTexture( width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format ) {

	format = format !== undefined ? format : DepthFormat;

	if ( format !== DepthFormat && format !== DepthStencilFormat ) {

		throw new Error( 'DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat' )

	}

	if ( type === undefined && format === DepthFormat ) type = UnsignedShortType;
	if ( type === undefined && format === DepthStencilFormat ) type = UnsignedInt248Type;

	Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );

	this.image = { width: width, height: height };

	this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
	this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;

	this.flipY = false;
	this.generateMipmaps	= false;

}

DepthTexture.prototype = Object.create( Texture.prototype );
DepthTexture.prototype.constructor = DepthTexture;
DepthTexture.prototype.isDepthTexture = true;

/**
 * @author mrdoob / http://mrdoob.com/
 */

function WireframeGeometry( geometry ) {

	BufferGeometry.call( this );

	var edge = [ 0, 0 ], hash = {};

	function sortFunction( a, b ) {

		return a - b;

	}

	var keys = [ 'a', 'b', 'c' ];

	if ( geometry && geometry.isGeometry ) {

		var vertices = geometry.vertices;
		var faces = geometry.faces;
		var numEdges = 0;

		// allocate maximal size
		var edges = new Uint32Array( 6 * faces.length );

		for ( var i = 0, l = faces.length; i < l; i ++ ) {

			var face = faces[ i ];

			for ( var j = 0; j < 3; j ++ ) {

				edge[ 0 ] = face[ keys[ j ] ];
				edge[ 1 ] = face[ keys[ ( j + 1 ) % 3 ] ];
				edge.sort( sortFunction );

				var key = edge.toString();

				if ( hash[ key ] === undefined ) {

					edges[ 2 * numEdges ] = edge[ 0 ];
					edges[ 2 * numEdges + 1 ] = edge[ 1 ];
					hash[ key ] = true;
					numEdges ++;

				}

			}

		}

		var coords = new Float32Array( numEdges * 2 * 3 );

		for ( var i = 0, l = numEdges; i < l; i ++ ) {

			for ( var j = 0; j < 2; j ++ ) {

				var vertex = vertices[ edges [ 2 * i + j ] ];

				var index = 6 * i + 3 * j;
				coords[ index + 0 ] = vertex.x;
				coords[ index + 1 ] = vertex.y;
				coords[ index + 2 ] = vertex.z;

			}

		}

		this.addAttribute( 'position', new BufferAttribute( coords, 3 ) );

	} else if ( geometry && geometry.isBufferGeometry ) {

		if ( geometry.index !== null ) {

			// Indexed BufferGeometry

			var indices = geometry.index.array;
			var vertices = geometry.attributes.position;
			var groups = geometry.groups;
			var numEdges = 0;

			if ( groups.length === 0 ) {

				geometry.addGroup( 0, indices.length );

			}

			// allocate maximal size
			var edges = new Uint32Array( 2 * indices.length );

			for ( var o = 0, ol = groups.length; o < ol; ++ o ) {

				var group = groups[ o ];

				var start = group.start;
				var count = group.count;

				for ( var i = start, il = start + count; i < il; i += 3 ) {

					for ( var j = 0; j < 3; j ++ ) {

						edge[ 0 ] = indices[ i + j ];
						edge[ 1 ] = indices[ i + ( j + 1 ) % 3 ];
						edge.sort( sortFunction );

						var key = edge.toString();

						if ( hash[ key ] === undefined ) {

							edges[ 2 * numEdges ] = edge[ 0 ];
							edges[ 2 * numEdges + 1 ] = edge[ 1 ];
							hash[ key ] = true;
							numEdges ++;

						}

					}

				}

			}

			var coords = new Float32Array( numEdges * 2 * 3 );

			for ( var i = 0, l = numEdges; i < l; i ++ ) {

				for ( var j = 0; j < 2; j ++ ) {

					var index = 6 * i + 3 * j;
					var index2 = edges[ 2 * i + j ];

					coords[ index + 0 ] = vertices.getX( index2 );
					coords[ index + 1 ] = vertices.getY( index2 );
					coords[ index + 2 ] = vertices.getZ( index2 );

				}

			}

			this.addAttribute( 'position', new BufferAttribute( coords, 3 ) );

		} else {

			// non-indexed BufferGeometry

			var vertices = geometry.attributes.position.array;
			var numEdges = vertices.length / 3;
			var numTris = numEdges / 3;

			var coords = new Float32Array( numEdges * 2 * 3 );

			for ( var i = 0, l = numTris; i < l; i ++ ) {

				for ( var j = 0; j < 3; j ++ ) {

					var index = 18 * i + 6 * j;

					var index1 = 9 * i + 3 * j;
					coords[ index + 0 ] = vertices[ index1 ];
					coords[ index + 1 ] = vertices[ index1 + 1 ];
					coords[ index + 2 ] = vertices[ index1 + 2 ];

					var index2 = 9 * i + 3 * ( ( j + 1 ) % 3 );
					coords[ index + 3 ] = vertices[ index2 ];
					coords[ index + 4 ] = vertices[ index2 + 1 ];
					coords[ index + 5 ] = vertices[ index2 + 2 ];

				}

			}

			this.addAttribute( 'position', new BufferAttribute( coords, 3 ) );

		}

	}

}

WireframeGeometry.prototype = Object.create( BufferGeometry.prototype );
WireframeGeometry.prototype.constructor = WireframeGeometry;

/**
 * @author Mugen87 / https://github.com/Mugen87
 *
 * Parametric Surfaces Geometry
 * based on the brilliant article by @prideout http://prideout.net/blog/?p=44
 */

function ParametricBufferGeometry( func, slices, stacks ) {

	BufferGeometry.call( this );

	this.type = 'ParametricBufferGeometry';

	this.parameters = {
		func: func,
		slices: slices,
		stacks: stacks
	};

	// generate vertices and uvs

	var vertices = [];
	var uvs = [];

	var i, j, p;
	var u, v;

	var sliceCount = slices + 1;

	for ( i = 0; i <= stacks; i ++ ) {

		v = i / stacks;

		for ( j = 0; j <= slices; j ++ ) {

			u = j / slices;

			p = func( u, v );
			vertices.push( p.x, p.y, p.z );

			uvs.push( u, v );

		}

	}

	// generate indices

	var indices = [];
	var a, b, c, d;

	for ( i = 0; i < stacks; i ++ ) {

		for ( j = 0; j < slices; j ++ ) {

			a = i * sliceCount + j;
			b = i * sliceCount + j + 1;
			c = ( i + 1 ) * sliceCount + j + 1;
			d = ( i + 1 ) * sliceCount + j;

			// faces one and two

			indices.push( a, b, d );
			indices.push( b, c, d );

		}

	}

	// build geometry

	this.setIndex( new ( indices.length > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute )( indices, 1 ) );
	this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	// generate normals

	this.computeVertexNormals();

}

ParametricBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
ParametricBufferGeometry.prototype.constructor = ParametricBufferGeometry;

/**
 * @author zz85 / https://github.com/zz85
 *
 * Parametric Surfaces Geometry
 * based on the brilliant article by @prideout http://prideout.net/blog/?p=44
 */

function ParametricGeometry( func, slices, stacks ) {

	Geometry.call( this );

	this.type = 'ParametricGeometry';

	this.parameters = {
		func: func,
		slices: slices,
		stacks: stacks
	};

	this.fromBufferGeometry( new ParametricBufferGeometry( func, slices, stacks ) );
	this.mergeVertices();

}

ParametricGeometry.prototype = Object.create( Geometry.prototype );
ParametricGeometry.prototype.constructor = ParametricGeometry;

/**
 * @author Mugen87 / https://github.com/Mugen87
 */

function PolyhedronBufferGeometry( vertices, indices, radius, detail ) {

	BufferGeometry.call( this );

	this.type = 'PolyhedronBufferGeometry';

	this.parameters = {
		vertices: vertices,
		indices: indices,
		radius: radius,
		detail: detail
	};

	radius = radius || 1;
	detail = detail || 0;

	// default buffer data

	var vertexBuffer = [];
	var uvBuffer = [];

	// the subdivision creates the vertex buffer data

	subdivide( detail );

	// all vertices should lie on a conceptual sphere with a given radius

	appplyRadius( radius );

	// finally, create the uv data

	generateUVs();

	// build non-indexed geometry

	this.addAttribute( 'position', new Float32BufferAttribute( vertexBuffer, 3 ) );
	this.addAttribute( 'normal', new Float32BufferAttribute( vertexBuffer.slice(), 3 ) );
	this.addAttribute( 'uv', new Float32BufferAttribute( uvBuffer, 2 ) );
	this.normalizeNormals();

	this.boundingSphere = new Sphere( new Vector3(), radius );

	// helper functions

	function subdivide( detail ) {

		var a = new Vector3();
		var b = new Vector3();
		var c = new Vector3();

		// iterate over all faces and apply a subdivison with the given detail value

		for ( var i = 0; i < indices.length; i += 3 ) {

			// get the vertices of the face

			getVertexByIndex( indices[ i + 0 ], a );
			getVertexByIndex( indices[ i + 1 ], b );
			getVertexByIndex( indices[ i + 2 ], c );

			// perform subdivision

			subdivideFace( a, b, c, detail );

		}

	}

	function subdivideFace( a, b, c, detail ) {

		var cols = Math.pow( 2, detail );

		// we use this multidimensional array as a data structure for creating the subdivision

		var v = [];

		var i, j;

		// construct all of the vertices for this subdivision

		for ( i = 0 ; i <= cols; i ++ ) {

			v[ i ] = [];

			var aj = a.clone().lerp( c, i / cols );
			var bj = b.clone().lerp( c, i / cols );

			var rows = cols - i;

			for ( j = 0; j <= rows; j ++ ) {

				if ( j === 0 && i === cols ) {

					v[ i ][ j ] = aj;

				} else {

					v[ i ][ j ] = aj.clone().lerp( bj, j / rows );

				}

			}

		}

		// construct all of the faces

		for ( i = 0; i < cols ; i ++ ) {

			for ( j = 0; j < 2 * ( cols - i ) - 1; j ++ ) {

				var k = Math.floor( j / 2 );

				if ( j % 2 === 0 ) {

					pushVertex( v[ i ][ k + 1 ] );
					pushVertex( v[ i + 1 ][ k ] );
					pushVertex( v[ i ][ k ] );

				} else {

					pushVertex( v[ i ][ k + 1 ] );
					pushVertex( v[ i + 1 ][ k + 1 ] );
					pushVertex( v[ i + 1 ][ k ] );

				}

			}

		}

	}

	function appplyRadius( radius ) {

		var vertex = new Vector3();

		// iterate over the entire buffer and apply the radius to each vertex

		for ( var i = 0; i < vertexBuffer.length; i += 3 ) {

			vertex.x = vertexBuffer[ i + 0 ];
			vertex.y = vertexBuffer[ i + 1 ];
			vertex.z = vertexBuffer[ i + 2 ];

			vertex.normalize().multiplyScalar( radius );

			vertexBuffer[ i + 0 ] = vertex.x;
			vertexBuffer[ i + 1 ] = vertex.y;
			vertexBuffer[ i + 2 ] = vertex.z;

		}

	}

	function generateUVs() {

		var vertex = new Vector3();

		for ( var i = 0; i < vertexBuffer.length; i += 3 ) {

			vertex.x = vertexBuffer[ i + 0 ];
			vertex.y = vertexBuffer[ i + 1 ];
			vertex.z = vertexBuffer[ i + 2 ];

			var u = azimuth( vertex ) / 2 / Math.PI + 0.5;
			var v = inclination( vertex ) / Math.PI + 0.5;
			uvBuffer.push( u, 1 - v );

		}

		correctUVs();

		correctSeam();

	}

	function correctSeam() {

		// handle case when face straddles the seam, see #3269

		for ( var i = 0; i < uvBuffer.length; i += 6 ) {

			// uv data of a single face

			var x0 = uvBuffer[ i + 0 ];
			var x1 = uvBuffer[ i + 2 ];
			var x2 = uvBuffer[ i + 4 ];

			var max = Math.max( x0, x1, x2 );
			var min = Math.min( x0, x1, x2 );

			// 0.9 is somewhat arbitrary

			if ( max > 0.9 && min < 0.1 ) {

				if ( x0 < 0.2 ) uvBuffer[ i + 0 ] += 1;
				if ( x1 < 0.2 ) uvBuffer[ i + 2 ] += 1;
				if ( x2 < 0.2 ) uvBuffer[ i + 4 ] += 1;

			}

		}

	}

	function pushVertex( vertex ) {

		vertexBuffer.push( vertex.x, vertex.y, vertex.z );

	}

	function getVertexByIndex( index, vertex ) {

		var stride = index * 3;

		vertex.x = vertices[ stride + 0 ];
		vertex.y = vertices[ stride + 1 ];
		vertex.z = vertices[ stride + 2 ];

	}

	function correctUVs() {

		var a = new Vector3();
		var b = new Vector3();
		var c = new Vector3();

		var centroid = new Vector3();

		var uvA = new Vector2();
		var uvB = new Vector2();
		var uvC = new Vector2();

		for ( var i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6 ) {

			a.set( vertexBuffer[ i + 0 ], vertexBuffer[ i + 1 ], vertexBuffer[ i + 2 ] );
			b.set( vertexBuffer[ i + 3 ], vertexBuffer[ i + 4 ], vertexBuffer[ i + 5 ] );
			c.set( vertexBuffer[ i + 6 ], vertexBuffer[ i + 7 ], vertexBuffer[ i + 8 ] );

			uvA.set( uvBuffer[ j + 0 ], uvBuffer[ j + 1 ] );
			uvB.set( uvBuffer[ j + 2 ], uvBuffer[ j + 3 ] );
			uvC.set( uvBuffer[ j + 4 ], uvBuffer[ j + 5 ] );

			centroid.copy( a ).add( b ).add( c ).divideScalar( 3 );

			var azi = azimuth( centroid );

			correctUV( uvA, j + 0, a, azi );
			correctUV( uvB, j + 2, b, azi );
			correctUV( uvC, j + 4, c, azi );

		}

	}

	function correctUV( uv, stride, vector, azimuth  ) {

		if ( ( azimuth < 0 ) && ( uv.x === 1 ) ) {

			uvBuffer[ stride ] =  uv.x - 1;

		}

		if ( ( vector.x === 0 ) && ( vector.z === 0 ) ) {

			uvBuffer[ stride ] = azimuth / 2 / Math.PI + 0.5;

		}

	}

	// Angle around the Y axis, counter-clockwise when looking from above.

	function azimuth( vector ) {

		return Math.atan2( vector.z, - vector.x );

	}


	// Angle above the XZ plane.

	function inclination( vector ) {

		return Math.atan2( - vector.y, Math.sqrt( ( vector.x * vector.x ) + ( vector.z * vector.z ) ) );

	}

}

PolyhedronBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
PolyhedronBufferGeometry.prototype.constructor = PolyhedronBufferGeometry;

/**
 * @author Mugen87 / https://github.com/Mugen87
 */

function TetrahedronBufferGeometry( radius, detail ) {

	var vertices = [
		1,  1,  1,   - 1, - 1,  1,   - 1,  1, - 1,    1, - 1, - 1
	];

	var indices = [
		2,  1,  0,    0,  3,  2,    1,  3,  0,    2,  3,  1
	];

	PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );

	this.type = 'TetrahedronBufferGeometry';

	this.parameters = {
		radius: radius,
		detail: detail
	};

}

TetrahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
TetrahedronBufferGeometry.prototype.constructor = TetrahedronBufferGeometry;

/**
 * @author timothypratley / https://github.com/timothypratley
 */

function TetrahedronGeometry( radius, detail ) {

	Geometry.call( this );

	this.type = 'TetrahedronGeometry';

	this.parameters = {
		radius: radius,
		detail: detail
	};

	this.fromBufferGeometry( new TetrahedronBufferGeometry( radius, detail ) );
	this.mergeVertices();

}

TetrahedronGeometry.prototype = Object.create( Geometry.prototype );
TetrahedronGeometry.prototype.constructor = TetrahedronGeometry;

/**
 * @author Mugen87 / https://github.com/Mugen87
 */

function OctahedronBufferGeometry( radius,detail ) {

	var vertices = [
		1, 0, 0,   - 1, 0, 0,    0, 1, 0,    0, - 1, 0,    0, 0, 1,    0, 0, - 1
	];

	var indices = [
		0, 2, 4,    0, 4, 3,    0, 3, 5,    0, 5, 2,    1, 2, 5,    1, 5, 3,    1, 3, 4,    1, 4, 2
	];

	PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );

	this.type = 'OctahedronBufferGeometry';

	this.parameters = {
		radius: radius,
		detail: detail
	};

}

OctahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
OctahedronBufferGeometry.prototype.constructor = OctahedronBufferGeometry;

/**
 * @author timothypratley / https://github.com/timothypratley
 */

function OctahedronGeometry( radius, detail ) {

	Geometry.call( this );

	this.type = 'OctahedronGeometry';

	this.parameters = {
		radius: radius,
		detail: detail
	};

	this.fromBufferGeometry( new OctahedronBufferGeometry( radius, detail ) );
	this.mergeVertices();

}

OctahedronGeometry.prototype = Object.create( Geometry.prototype );
OctahedronGeometry.prototype.constructor = OctahedronGeometry;

/**
 * @author Mugen87 / https://github.com/Mugen87
 */

function IcosahedronBufferGeometry( radius, detail ) {

	var t = ( 1 + Math.sqrt( 5 ) ) / 2;

	var vertices = [
		- 1,  t,  0,    1,  t,  0,   - 1, - t,  0,    1, - t,  0,
		 0, - 1,  t,    0,  1,  t,    0, - 1, - t,    0,  1, - t,
		 t,  0, - 1,    t,  0,  1,   - t,  0, - 1,   - t,  0,  1
	];

	var indices = [
		 0, 11,  5,    0,  5,  1,    0,  1,  7,    0,  7, 10,    0, 10, 11,
		 1,  5,  9,    5, 11,  4,   11, 10,  2,   10,  7,  6,    7,  1,  8,
		 3,  9,  4,    3,  4,  2,    3,  2,  6,    3,  6,  8,    3,  8,  9,
		 4,  9,  5,    2,  4, 11,    6,  2, 10,    8,  6,  7,    9,  8,  1
	];

	PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );

	this.type = 'IcosahedronBufferGeometry';

	this.parameters = {
		radius: radius,
		detail: detail
	};

}

IcosahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
IcosahedronBufferGeometry.prototype.constructor = IcosahedronBufferGeometry;

/**
 * @author timothypratley / https://github.com/timothypratley
 */

function IcosahedronGeometry( radius, detail ) {

 	Geometry.call( this );

	this.type = 'IcosahedronGeometry';

	this.parameters = {
		radius: radius,
		detail: detail
	};

	this.fromBufferGeometry( new IcosahedronBufferGeometry( radius, detail ) );
	this.mergeVertices();

}

IcosahedronGeometry.prototype = Object.create( Geometry.prototype );
IcosahedronGeometry.prototype.constructor = IcosahedronGeometry;

/**
 * @author Mugen87 / https://github.com/Mugen87
 */

function DodecahedronBufferGeometry( radius, detail ) {

	var t = ( 1 + Math.sqrt( 5 ) ) / 2;
	var r = 1 / t;

	var vertices = [

		// (±1, ±1, ±1)
		- 1, - 1, - 1,    - 1, - 1,  1,
		- 1,  1, - 1,    - 1,  1,  1,
		 1, - 1, - 1,     1, - 1,  1,
		 1,  1, - 1,     1,  1,  1,

		// (0, ±1/φ, ±φ)
		 0, - r, - t,     0, - r,  t,
		 0,  r, - t,     0,  r,  t,

		// (±1/φ, ±φ, 0)
		- r, - t,  0,    - r,  t,  0,
		 r, - t,  0,     r,  t,  0,

		// (±φ, 0, ±1/φ)
		- t,  0, - r,     t,  0, - r,
		- t,  0,  r,     t,  0,  r
	];

	var indices = [
		 3, 11,  7,      3,  7, 15,      3, 15, 13,
		 7, 19, 17,      7, 17,  6,      7,  6, 15,
		17,  4,  8,     17,  8, 10,     17, 10,  6,
		 8,  0, 16,      8, 16,  2,      8,  2, 10,
		 0, 12,  1,      0,  1, 18,      0, 18, 16,
		 6, 10,  2,      6,  2, 13,      6, 13, 15,
		 2, 16, 18,      2, 18,  3,      2,  3, 13,
		18,  1,  9,     18,  9, 11,     18, 11,  3,
		 4, 14, 12,      4, 12,  0,      4,  0,  8,
		11,  9,  5,     11,  5, 19,     11, 19,  7,
		19,  5, 14,     19, 14,  4,     19,  4, 17,
		 1, 12, 14,      1, 14,  5,      1,  5,  9
	];

	PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );

	this.type = 'DodecahedronBufferGeometry';

	this.parameters = {
		radius: radius,
		detail: detail
	};

}

DodecahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
DodecahedronBufferGeometry.prototype.constructor = DodecahedronBufferGeometry;

/**
 * @author Abe Pazos / https://hamoid.com
 */

function DodecahedronGeometry( radius, detail ) {

	Geometry.call( this );

	this.type = 'DodecahedronGeometry';

	this.parameters = {
		radius: radius,
		detail: detail
	};

	this.fromBufferGeometry( new DodecahedronBufferGeometry( radius, detail ) );
	this.mergeVertices();

}

DodecahedronGeometry.prototype = Object.create( Geometry.prototype );
DodecahedronGeometry.prototype.constructor = DodecahedronGeometry;

/**
 * @author clockworkgeek / https://github.com/clockworkgeek
 * @author timothypratley / https://github.com/timothypratley
 * @author WestLangley / http://github.com/WestLangley
*/

function PolyhedronGeometry( vertices, indices, radius, detail ) {

	Geometry.call( this );

	this.type = 'PolyhedronGeometry';

	this.parameters = {
		vertices: vertices,
		indices: indices,
		radius: radius,
		detail: detail
	};

	this.fromBufferGeometry( new PolyhedronBufferGeometry( vertices, indices, radius, detail ) );
	this.mergeVertices();

}

PolyhedronGeometry.prototype = Object.create( Geometry.prototype );
PolyhedronGeometry.prototype.constructor = PolyhedronGeometry;

/**
 * @author Mugen87 / https://github.com/Mugen87
 *
 * Creates a tube which extrudes along a 3d spline.
 *
 */

function TubeBufferGeometry( path, tubularSegments, radius, radialSegments, closed ) {

	BufferGeometry.call( this );

	this.type = 'TubeBufferGeometry';

	this.parameters = {
		path: path,
		tubularSegments: tubularSegments,
		radius: radius,
		radialSegments: radialSegments,
		closed: closed
	};

	tubularSegments = tubularSegments || 64;
	radius = radius || 1;
	radialSegments = radialSegments || 8;
	closed = closed || false;

	var frames = path.computeFrenetFrames( tubularSegments, closed );

	// expose internals

	this.tangents = frames.tangents;
	this.normals = frames.normals;
	this.binormals = frames.binormals;

	// helper variables

	var vertex = new Vector3();
	var normal = new Vector3();
	var uv = new Vector2();

	var i, j;

	// buffer

	var vertices = [];
	var normals = [];
	var uvs = [];
	var indices = [];

	// create buffer data

	generateBufferData();

	// build geometry

	this.setIndex( new ( indices.length > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute )( indices, 1 ) );
	this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
	this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	// functions

	function generateBufferData() {

		for ( i = 0; i < tubularSegments; i ++ ) {

			generateSegment( i );

		}

		// if the geometry is not closed, generate the last row of vertices and normals
		// at the regular position on the given path
		//
		// if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)

		generateSegment( ( closed === false ) ? tubularSegments : 0 );

		// uvs are generated in a separate function.
		// this makes it easy compute correct values for closed geometries

		generateUVs();

		// finally create faces

		generateIndices();

	}

	function generateSegment( i ) {

		// we use getPointAt to sample evenly distributed points from the given path

		var P = path.getPointAt( i / tubularSegments );

		// retrieve corresponding normal and binormal

		var N = frames.normals[ i ];
		var B = frames.binormals[ i ];

		// generate normals and vertices for the current segment

		for ( j = 0; j <= radialSegments; j ++ ) {

			var v = j / radialSegments * Math.PI * 2;

			var sin =   Math.sin( v );
			var cos = - Math.cos( v );

			// normal

			normal.x = ( cos * N.x + sin * B.x );
			normal.y = ( cos * N.y + sin * B.y );
			normal.z = ( cos * N.z + sin * B.z );
			normal.normalize();

			normals.push( normal.x, normal.y, normal.z );

			// vertex

			vertex.x = P.x + radius * normal.x;
			vertex.y = P.y + radius * normal.y;
			vertex.z = P.z + radius * normal.z;

			vertices.push( vertex.x, vertex.y, vertex.z );

		}

	}

	function generateIndices() {

		for ( j = 1; j <= tubularSegments; j ++ ) {

			for ( i = 1; i <= radialSegments; i ++ ) {

				var a = ( radialSegments + 1 ) * ( j - 1 ) + ( i - 1 );
				var b = ( radialSegments + 1 ) * j + ( i - 1 );
				var c = ( radialSegments + 1 ) * j + i;
				var d = ( radialSegments + 1 ) * ( j - 1 ) + i;

				// faces

				indices.push( a, b, d );
				indices.push( b, c, d );

			}

		}

	}

	function generateUVs() {

		for ( i = 0; i <= tubularSegments; i ++ ) {

			for ( j = 0; j <= radialSegments; j ++ ) {

				uv.x = i / tubularSegments;
				uv.y = j / radialSegments;

				uvs.push( uv.x, uv.y );

			}

		}

	}

}

TubeBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
TubeBufferGeometry.prototype.constructor = TubeBufferGeometry;

/**
 * @author oosmoxiecode / https://github.com/oosmoxiecode
 * @author WestLangley / https://github.com/WestLangley
 * @author zz85 / https://github.com/zz85
 * @author miningold / https://github.com/miningold
 * @author jonobr1 / https://github.com/jonobr1
 *
 * Creates a tube which extrudes along a 3d spline.
 */

function TubeGeometry( path, tubularSegments, radius, radialSegments, closed, taper ) {

	Geometry.call( this );

	this.type = 'TubeGeometry';

	this.parameters = {
		path: path,
		tubularSegments: tubularSegments,
		radius: radius,
		radialSegments: radialSegments,
		closed: closed
	};

	if ( taper !== undefined ) console.warn( 'THREE.TubeGeometry: taper has been removed.' );

	var bufferGeometry = new TubeBufferGeometry( path, tubularSegments, radius, radialSegments, closed );

	// expose internals

	this.tangents = bufferGeometry.tangents;
	this.normals = bufferGeometry.normals;
	this.binormals = bufferGeometry.binormals;

	// create geometry

	this.fromBufferGeometry( bufferGeometry );
	this.mergeVertices();

}

TubeGeometry.prototype = Object.create( Geometry.prototype );
TubeGeometry.prototype.constructor = TubeGeometry;

/**
 * @author Mugen87 / https://github.com/Mugen87
 *
 * see: http://www.blackpawn.com/texts/pqtorus/
 */
function TorusKnotBufferGeometry( radius, tube, tubularSegments, radialSegments, p, q ) {

	BufferGeometry.call( this );

	this.type = 'TorusKnotBufferGeometry';

	this.parameters = {
		radius: radius,
		tube: tube,
		tubularSegments: tubularSegments,
		radialSegments: radialSegments,
		p: p,
		q: q
	};

	radius = radius || 100;
	tube = tube || 40;
	tubularSegments = Math.floor( tubularSegments ) || 64;
	radialSegments = Math.floor( radialSegments ) || 8;
	p = p || 2;
	q = q || 3;

	// used to calculate buffer length
	var vertexCount = ( ( radialSegments + 1 ) * ( tubularSegments + 1 ) );
	var indexCount = radialSegments * tubularSegments * 2 * 3;

	// buffers
	var indices = new BufferAttribute( new ( indexCount > 65535 ? Uint32Array : Uint16Array )( indexCount ) , 1 );
	var vertices = new BufferAttribute( new Float32Array( vertexCount * 3 ), 3 );
	var normals = new BufferAttribute( new Float32Array( vertexCount * 3 ), 3 );
	var uvs = new BufferAttribute( new Float32Array( vertexCount * 2 ), 2 );

	// helper variables
	var i, j, index = 0, indexOffset = 0;

	var vertex = new Vector3();
	var normal = new Vector3();
	var uv = new Vector2();

	var P1 = new Vector3();
	var P2 = new Vector3();

	var B = new Vector3();
	var T = new Vector3();
	var N = new Vector3();

	// generate vertices, normals and uvs

	for ( i = 0; i <= tubularSegments; ++ i ) {

		// the radian "u" is used to calculate the position on the torus curve of the current tubular segement

		var u = i / tubularSegments * p * Math.PI * 2;

		// now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
		// these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions

		calculatePositionOnCurve( u, p, q, radius, P1 );
		calculatePositionOnCurve( u + 0.01, p, q, radius, P2 );

		// calculate orthonormal basis

		T.subVectors( P2, P1 );
		N.addVectors( P2, P1 );
		B.crossVectors( T, N );
		N.crossVectors( B, T );

		// normalize B, N. T can be ignored, we don't use it

		B.normalize();
		N.normalize();

		for ( j = 0; j <= radialSegments; ++ j ) {

			// now calculate the vertices. they are nothing more than an extrusion of the torus curve.
			// because we extrude a shape in the xy-plane, there is no need to calculate a z-value.

			var v = j / radialSegments * Math.PI * 2;
			var cx = - tube * Math.cos( v );
			var cy = tube * Math.sin( v );

			// now calculate the final vertex position.
			// first we orient the extrusion with our basis vectos, then we add it to the current position on the curve

			vertex.x = P1.x + ( cx * N.x + cy * B.x );
			vertex.y = P1.y + ( cx * N.y + cy * B.y );
			vertex.z = P1.z + ( cx * N.z + cy * B.z );

			// vertex
			vertices.setXYZ( index, vertex.x, vertex.y, vertex.z );

			// normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
			normal.subVectors( vertex, P1 ).normalize();
			normals.setXYZ( index, normal.x, normal.y, normal.z );

			// uv
			uv.x = i / tubularSegments;
			uv.y = j / radialSegments;
			uvs.setXY( index, uv.x, uv.y );

			// increase index
			index ++;

		}

	}

	// generate indices

	for ( j = 1; j <= tubularSegments; j ++ ) {

		for ( i = 1; i <= radialSegments; i ++ ) {

			// indices
			var a = ( radialSegments + 1 ) * ( j - 1 ) + ( i - 1 );
			var b = ( radialSegments + 1 ) * j + ( i - 1 );
			var c = ( radialSegments + 1 ) * j + i;
			var d = ( radialSegments + 1 ) * ( j - 1 ) + i;

			// face one
			indices.setX( indexOffset, a ); indexOffset++;
			indices.setX( indexOffset, b ); indexOffset++;
			indices.setX( indexOffset, d ); indexOffset++;

			// face two
			indices.setX( indexOffset, b ); indexOffset++;
			indices.setX( indexOffset, c ); indexOffset++;
			indices.setX( indexOffset, d ); indexOffset++;

		}

	}

	// build geometry

	this.setIndex( indices );
	this.addAttribute( 'position', vertices );
	this.addAttribute( 'normal', normals );
	this.addAttribute( 'uv', uvs );

	// this function calculates the current position on the torus curve

	function calculatePositionOnCurve( u, p, q, radius, position ) {

		var cu = Math.cos( u );
		var su = Math.sin( u );
		var quOverP = q / p * u;
		var cs = Math.cos( quOverP );

		position.x = radius * ( 2 + cs ) * 0.5 * cu;
		position.y = radius * ( 2 + cs ) * su * 0.5;
		position.z = radius * Math.sin( quOverP ) * 0.5;

	}

}

TorusKnotBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
TorusKnotBufferGeometry.prototype.constructor = TorusKnotBufferGeometry;

/**
 * @author oosmoxiecode
 */

function TorusKnotGeometry( radius, tube, tubularSegments, radialSegments, p, q, heightScale ) {

	Geometry.call( this );

	this.type = 'TorusKnotGeometry';

	this.parameters = {
		radius: radius,
		tube: tube,
		tubularSegments: tubularSegments,
		radialSegments: radialSegments,
		p: p,
		q: q
	};

	if( heightScale !== undefined ) console.warn( 'THREE.TorusKnotGeometry: heightScale has been deprecated. Use .scale( x, y, z ) instead.' );

	this.fromBufferGeometry( new TorusKnotBufferGeometry( radius, tube, tubularSegments, radialSegments, p, q ) );
	this.mergeVertices();

}

TorusKnotGeometry.prototype = Object.create( Geometry.prototype );
TorusKnotGeometry.prototype.constructor = TorusKnotGeometry;

/**
 * @author Mugen87 / https://github.com/Mugen87
 */

function TorusBufferGeometry( radius, tube, radialSegments, tubularSegments, arc ) {

	BufferGeometry.call( this );

	this.type = 'TorusBufferGeometry';

	this.parameters = {
		radius: radius,
		tube: tube,
		radialSegments: radialSegments,
		tubularSegments: tubularSegments,
		arc: arc
	};

	radius = radius || 100;
	tube = tube || 40;
	radialSegments = Math.floor( radialSegments ) || 8;
	tubularSegments = Math.floor( tubularSegments ) || 6;
	arc = arc || Math.PI * 2;

	// used to calculate buffer length
	var vertexCount = ( ( radialSegments + 1 ) * ( tubularSegments + 1 ) );
	var indexCount = radialSegments * tubularSegments * 2 * 3;

	// buffers
	var indices = new ( indexCount > 65535 ? Uint32Array : Uint16Array )( indexCount );
	var vertices = new Float32Array( vertexCount * 3 );
	var normals = new Float32Array( vertexCount * 3 );
	var uvs = new Float32Array( vertexCount * 2 );

	// offset variables
	var vertexBufferOffset = 0;
	var uvBufferOffset = 0;
	var indexBufferOffset = 0;

	// helper variables
	var center = new Vector3();
	var vertex = new Vector3();
	var normal = new Vector3();

	var j, i;

	// generate vertices, normals and uvs

	for ( j = 0; j <= radialSegments; j ++ ) {

		for ( i = 0; i <= tubularSegments; i ++ ) {

			var u = i / tubularSegments * arc;
			var v = j / radialSegments * Math.PI * 2;

			// vertex
			vertex.x = ( radius + tube * Math.cos( v ) ) * Math.cos( u );
			vertex.y = ( radius + tube * Math.cos( v ) ) * Math.sin( u );
			vertex.z = tube * Math.sin( v );

			vertices[ vertexBufferOffset ] = vertex.x;
			vertices[ vertexBufferOffset + 1 ] = vertex.y;
			vertices[ vertexBufferOffset + 2 ] = vertex.z;

			// this vector is used to calculate the normal
			center.x = radius * Math.cos( u );
			center.y = radius * Math.sin( u );

			// normal
			normal.subVectors( vertex, center ).normalize();

			normals[ vertexBufferOffset ] = normal.x;
			normals[ vertexBufferOffset + 1 ] = normal.y;
			normals[ vertexBufferOffset + 2 ] = normal.z;

			// uv
			uvs[ uvBufferOffset ] = i / tubularSegments;
			uvs[ uvBufferOffset + 1 ] = j / radialSegments;

			// update offsets
			vertexBufferOffset += 3;
			uvBufferOffset += 2;

		}

	}

	// generate indices

	for ( j = 1; j <= radialSegments; j ++ ) {

		for ( i = 1; i <= tubularSegments; i ++ ) {

			// indices
			var a = ( tubularSegments + 1 ) * j + i - 1;
			var b = ( tubularSegments + 1 ) * ( j - 1 ) + i - 1;
			var c = ( tubularSegments + 1 ) * ( j - 1 ) + i;
			var d = ( tubularSegments + 1 ) * j + i;

			// face one
			indices[ indexBufferOffset ] = a;
			indices[ indexBufferOffset + 1 ] = b;
			indices[ indexBufferOffset + 2 ] = d;

			// face two
			indices[ indexBufferOffset + 3 ] = b;
			indices[ indexBufferOffset + 4 ] = c;
			indices[ indexBufferOffset + 5 ] = d;

			// update offset
			indexBufferOffset += 6;

		}

	}

	// build geometry
	this.setIndex( new BufferAttribute( indices, 1 ) );
	this.addAttribute( 'position', new BufferAttribute( vertices, 3 ) );
	this.addAttribute( 'normal', new BufferAttribute( normals, 3 ) );
	this.addAttribute( 'uv', new BufferAttribute( uvs, 2 ) );

}

TorusBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
TorusBufferGeometry.prototype.constructor = TorusBufferGeometry;

/**
 * @author oosmoxiecode
 * @author mrdoob / http://mrdoob.com/
 * based on http://code.google.com/p/away3d/source/browse/trunk/fp10/Away3DLite/src/away3dlite/primitives/Torus.as?r=2888
 */

function TorusGeometry( radius, tube, radialSegments, tubularSegments, arc ) {

	Geometry.call( this );

	this.type = 'TorusGeometry';

	this.parameters = {
		radius: radius,
		tube: tube,
		radialSegments: radialSegments,
		tubularSegments: tubularSegments,
		arc: arc
	};

	this.fromBufferGeometry( new TorusBufferGeometry( radius, tube, radialSegments, tubularSegments, arc ) );

}

TorusGeometry.prototype = Object.create( Geometry.prototype );
TorusGeometry.prototype.constructor = TorusGeometry;

/**
 * @author zz85 / http://www.lab4games.net/zz85/blog
 */

var ShapeUtils = {

	// calculate area of the contour polygon

	area: function ( contour ) {

		var n = contour.length;
		var a = 0.0;

		for ( var p = n - 1, q = 0; q < n; p = q ++ ) {

			a += contour[ p ].x * contour[ q ].y - contour[ q ].x * contour[ p ].y;

		}

		return a * 0.5;

	},

	triangulate: ( function () {

		/**
		 * This code is a quick port of code written in C++ which was submitted to
		 * flipcode.com by John W. Ratcliff  // July 22, 2000
		 * See original code and more information here:
		 * http://www.flipcode.com/archives/Efficient_Polygon_Triangulation.shtml
		 *
		 * ported to actionscript by Zevan Rosser
		 * www.actionsnippet.com
		 *
		 * ported to javascript by Joshua Koo
		 * http://www.lab4games.net/zz85/blog
		 *
		 */

		function snip( contour, u, v, w, n, verts ) {

			var p;
			var ax, ay, bx, by;
			var cx, cy, px, py;

			ax = contour[ verts[ u ] ].x;
			ay = contour[ verts[ u ] ].y;

			bx = contour[ verts[ v ] ].x;
			by = contour[ verts[ v ] ].y;

			cx = contour[ verts[ w ] ].x;
			cy = contour[ verts[ w ] ].y;

			if ( ( bx - ax ) * ( cy - ay ) - ( by - ay ) * ( cx - ax ) <= 0 ) return false;

			var aX, aY, bX, bY, cX, cY;
			var apx, apy, bpx, bpy, cpx, cpy;
			var cCROSSap, bCROSScp, aCROSSbp;

			aX = cx - bx;  aY = cy - by;
			bX = ax - cx;  bY = ay - cy;
			cX = bx - ax;  cY = by - ay;

			for ( p = 0; p < n; p ++ ) {

				px = contour[ verts[ p ] ].x;
				py = contour[ verts[ p ] ].y;

				if ( ( ( px === ax ) && ( py === ay ) ) ||
					 ( ( px === bx ) && ( py === by ) ) ||
					 ( ( px === cx ) && ( py === cy ) ) )	continue;

				apx = px - ax;  apy = py - ay;
				bpx = px - bx;  bpy = py - by;
				cpx = px - cx;  cpy = py - cy;

				// see if p is inside triangle abc

				aCROSSbp = aX * bpy - aY * bpx;
				cCROSSap = cX * apy - cY * apx;
				bCROSScp = bX * cpy - bY * cpx;

				if ( ( aCROSSbp >= - Number.EPSILON ) && ( bCROSScp >= - Number.EPSILON ) && ( cCROSSap >= - Number.EPSILON ) ) return false;

			}

			return true;

		}

		// takes in an contour array and returns

		return function triangulate( contour, indices ) {

			var n = contour.length;

			if ( n < 3 ) return null;

			var result = [],
				verts = [],
				vertIndices = [];

			/* we want a counter-clockwise polygon in verts */

			var u, v, w;

			if ( ShapeUtils.area( contour ) > 0.0 ) {

				for ( v = 0; v < n; v ++ ) verts[ v ] = v;

			} else {

				for ( v = 0; v < n; v ++ ) verts[ v ] = ( n - 1 ) - v;

			}

			var nv = n;

			/*  remove nv - 2 vertices, creating 1 triangle every time */

			var count = 2 * nv;   /* error detection */

			for ( v = nv - 1; nv > 2; ) {

				/* if we loop, it is probably a non-simple polygon */

				if ( ( count -- ) <= 0 ) {

					//** Triangulate: ERROR - probable bad polygon!

					//throw ( "Warning, unable to triangulate polygon!" );
					//return null;
					// Sometimes warning is fine, especially polygons are triangulated in reverse.
					console.warn( 'THREE.ShapeUtils: Unable to triangulate polygon! in triangulate()' );

					if ( indices ) return vertIndices;
					return result;

				}

				/* three consecutive vertices in current polygon, <u,v,w> */

				u = v; 	 	if ( nv <= u ) u = 0;     /* previous */
				v = u + 1;  if ( nv <= v ) v = 0;     /* new v    */
				w = v + 1;  if ( nv <= w ) w = 0;     /* next     */

				if ( snip( contour, u, v, w, nv, verts ) ) {

					var a, b, c, s, t;

					/* true names of the vertices */

					a = verts[ u ];
					b = verts[ v ];
					c = verts[ w ];

					/* output Triangle */

					result.push( [ contour[ a ],
						contour[ b ],
						contour[ c ] ] );


					vertIndices.push( [ verts[ u ], verts[ v ], verts[ w ] ] );

					/* remove v from the remaining polygon */

					for ( s = v, t = v + 1; t < nv; s ++, t ++ ) {

						verts[ s ] = verts[ t ];

					}

					nv --;

					/* reset error detection counter */

					count = 2 * nv;

				}

			}

			if ( indices ) return vertIndices;
			return result;

		}

	} )(),

	triangulateShape: function ( contour, holes ) {

		function removeDupEndPts(points) {

			var l = points.length;

			if ( l > 2 && points[ l - 1 ].equals( points[ 0 ] ) ) {

				points.pop();

			}

		}

		removeDupEndPts( contour );
		holes.forEach( removeDupEndPts );

		function point_in_segment_2D_colin( inSegPt1, inSegPt2, inOtherPt ) {

			// inOtherPt needs to be collinear to the inSegment
			if ( inSegPt1.x !== inSegPt2.x ) {

				if ( inSegPt1.x < inSegPt2.x ) {

					return	( ( inSegPt1.x <= inOtherPt.x ) && ( inOtherPt.x <= inSegPt2.x ) );

				} else {

					return	( ( inSegPt2.x <= inOtherPt.x ) && ( inOtherPt.x <= inSegPt1.x ) );

				}

			} else {

				if ( inSegPt1.y < inSegPt2.y ) {

					return	( ( inSegPt1.y <= inOtherPt.y ) && ( inOtherPt.y <= inSegPt2.y ) );

				} else {

					return	( ( inSegPt2.y <= inOtherPt.y ) && ( inOtherPt.y <= inSegPt1.y ) );

				}

			}

		}

		function intersect_segments_2D( inSeg1Pt1, inSeg1Pt2, inSeg2Pt1, inSeg2Pt2, inExcludeAdjacentSegs ) {

			var seg1dx = inSeg1Pt2.x - inSeg1Pt1.x,   seg1dy = inSeg1Pt2.y - inSeg1Pt1.y;
			var seg2dx = inSeg2Pt2.x - inSeg2Pt1.x,   seg2dy = inSeg2Pt2.y - inSeg2Pt1.y;

			var seg1seg2dx = inSeg1Pt1.x - inSeg2Pt1.x;
			var seg1seg2dy = inSeg1Pt1.y - inSeg2Pt1.y;

			var limit		= seg1dy * seg2dx - seg1dx * seg2dy;
			var perpSeg1	= seg1dy * seg1seg2dx - seg1dx * seg1seg2dy;

			if ( Math.abs( limit ) > Number.EPSILON ) {

				// not parallel

				var perpSeg2;
				if ( limit > 0 ) {

					if ( ( perpSeg1 < 0 ) || ( perpSeg1 > limit ) ) 		return [];
					perpSeg2 = seg2dy * seg1seg2dx - seg2dx * seg1seg2dy;
					if ( ( perpSeg2 < 0 ) || ( perpSeg2 > limit ) ) 		return [];

				} else {

					if ( ( perpSeg1 > 0 ) || ( perpSeg1 < limit ) ) 		return [];
					perpSeg2 = seg2dy * seg1seg2dx - seg2dx * seg1seg2dy;
					if ( ( perpSeg2 > 0 ) || ( perpSeg2 < limit ) ) 		return [];

				}

				// i.e. to reduce rounding errors
				// intersection at endpoint of segment#1?
				if ( perpSeg2 === 0 ) {

					if ( ( inExcludeAdjacentSegs ) &&
						 ( ( perpSeg1 === 0 ) || ( perpSeg1 === limit ) ) )		return [];
					return [ inSeg1Pt1 ];

				}
				if ( perpSeg2 === limit ) {

					if ( ( inExcludeAdjacentSegs ) &&
						 ( ( perpSeg1 === 0 ) || ( perpSeg1 === limit ) ) )		return [];
					return [ inSeg1Pt2 ];

				}
				// intersection at endpoint of segment#2?
				if ( perpSeg1 === 0 )		return [ inSeg2Pt1 ];
				if ( perpSeg1 === limit )	return [ inSeg2Pt2 ];

				// return real intersection point
				var factorSeg1 = perpSeg2 / limit;
				return	[ { x: inSeg1Pt1.x + factorSeg1 * seg1dx,
							y: inSeg1Pt1.y + factorSeg1 * seg1dy } ];

			} else {

				// parallel or collinear
				if ( ( perpSeg1 !== 0 ) ||
					 ( seg2dy * seg1seg2dx !== seg2dx * seg1seg2dy ) ) 			return [];

				// they are collinear or degenerate
				var seg1Pt = ( ( seg1dx === 0 ) && ( seg1dy === 0 ) );	// segment1 is just a point?
				var seg2Pt = ( ( seg2dx === 0 ) && ( seg2dy === 0 ) );	// segment2 is just a point?
				// both segments are points
				if ( seg1Pt && seg2Pt ) {

					if ( ( inSeg1Pt1.x !== inSeg2Pt1.x ) ||
						 ( inSeg1Pt1.y !== inSeg2Pt1.y ) )		return [];	// they are distinct  points
					return [ inSeg1Pt1 ];                 						// they are the same point

				}
				// segment#1  is a single point
				if ( seg1Pt ) {

					if ( ! point_in_segment_2D_colin( inSeg2Pt1, inSeg2Pt2, inSeg1Pt1 ) )		return [];		// but not in segment#2
					return [ inSeg1Pt1 ];

				}
				// segment#2  is a single point
				if ( seg2Pt ) {

					if ( ! point_in_segment_2D_colin( inSeg1Pt1, inSeg1Pt2, inSeg2Pt1 ) )		return [];		// but not in segment#1
					return [ inSeg2Pt1 ];

				}

				// they are collinear segments, which might overlap
				var seg1min, seg1max, seg1minVal, seg1maxVal;
				var seg2min, seg2max, seg2minVal, seg2maxVal;
				if ( seg1dx !== 0 ) {

					// the segments are NOT on a vertical line
					if ( inSeg1Pt1.x < inSeg1Pt2.x ) {

						seg1min = inSeg1Pt1; seg1minVal = inSeg1Pt1.x;
						seg1max = inSeg1Pt2; seg1maxVal = inSeg1Pt2.x;

					} else {

						seg1min = inSeg1Pt2; seg1minVal = inSeg1Pt2.x;
						seg1max = inSeg1Pt1; seg1maxVal = inSeg1Pt1.x;

					}
					if ( inSeg2Pt1.x < inSeg2Pt2.x ) {

						seg2min = inSeg2Pt1; seg2minVal = inSeg2Pt1.x;
						seg2max = inSeg2Pt2; seg2maxVal = inSeg2Pt2.x;

					} else {

						seg2min = inSeg2Pt2; seg2minVal = inSeg2Pt2.x;
						seg2max = inSeg2Pt1; seg2maxVal = inSeg2Pt1.x;

					}

				} else {

					// the segments are on a vertical line
					if ( inSeg1Pt1.y < inSeg1Pt2.y ) {

						seg1min = inSeg1Pt1; seg1minVal = inSeg1Pt1.y;
						seg1max = inSeg1Pt2; seg1maxVal = inSeg1Pt2.y;

					} else {

						seg1min = inSeg1Pt2; seg1minVal = inSeg1Pt2.y;
						seg1max = inSeg1Pt1; seg1maxVal = inSeg1Pt1.y;

					}
					if ( inSeg2Pt1.y < inSeg2Pt2.y ) {

						seg2min = inSeg2Pt1; seg2minVal = inSeg2Pt1.y;
						seg2max = inSeg2Pt2; seg2maxVal = inSeg2Pt2.y;

					} else {

						seg2min = inSeg2Pt2; seg2minVal = inSeg2Pt2.y;
						seg2max = inSeg2Pt1; seg2maxVal = inSeg2Pt1.y;

					}

				}
				if ( seg1minVal <= seg2minVal ) {

					if ( seg1maxVal <  seg2minVal )	return [];
					if ( seg1maxVal === seg2minVal )	{

						if ( inExcludeAdjacentSegs )		return [];
						return [ seg2min ];

					}
					if ( seg1maxVal <= seg2maxVal )	return [ seg2min, seg1max ];
					return	[ seg2min, seg2max ];

				} else {

					if ( seg1minVal >  seg2maxVal )	return [];
					if ( seg1minVal === seg2maxVal )	{

						if ( inExcludeAdjacentSegs )		return [];
						return [ seg1min ];

					}
					if ( seg1maxVal <= seg2maxVal )	return [ seg1min, seg1max ];
					return	[ seg1min, seg2max ];

				}

			}

		}

		function isPointInsideAngle( inVertex, inLegFromPt, inLegToPt, inOtherPt ) {

			// The order of legs is important

			// translation of all points, so that Vertex is at (0,0)
			var legFromPtX	= inLegFromPt.x - inVertex.x,  legFromPtY	= inLegFromPt.y - inVertex.y;
			var legToPtX	= inLegToPt.x	- inVertex.x,  legToPtY		= inLegToPt.y	- inVertex.y;
			var otherPtX	= inOtherPt.x	- inVertex.x,  otherPtY		= inOtherPt.y	- inVertex.y;

			// main angle >0: < 180 deg.; 0: 180 deg.; <0: > 180 deg.
			var from2toAngle	= legFromPtX * legToPtY - legFromPtY * legToPtX;
			var from2otherAngle	= legFromPtX * otherPtY - legFromPtY * otherPtX;

			if ( Math.abs( from2toAngle ) > Number.EPSILON ) {

				// angle != 180 deg.

				var other2toAngle		= otherPtX * legToPtY - otherPtY * legToPtX;
				// console.log( "from2to: " + from2toAngle + ", from2other: " + from2otherAngle + ", other2to: " + other2toAngle );

				if ( from2toAngle > 0 ) {

					// main angle < 180 deg.
					return	( ( from2otherAngle >= 0 ) && ( other2toAngle >= 0 ) );

				} else {

					// main angle > 180 deg.
					return	( ( from2otherAngle >= 0 ) || ( other2toAngle >= 0 ) );

				}

			} else {

				// angle == 180 deg.
				// console.log( "from2to: 180 deg., from2other: " + from2otherAngle  );
				return	( from2otherAngle > 0 );

			}

		}


		function removeHoles( contour, holes ) {

			var shape = contour.concat(); // work on this shape
			var hole;

			function isCutLineInsideAngles( inShapeIdx, inHoleIdx ) {

				// Check if hole point lies within angle around shape point
				var lastShapeIdx = shape.length - 1;

				var prevShapeIdx = inShapeIdx - 1;
				if ( prevShapeIdx < 0 )			prevShapeIdx = lastShapeIdx;

				var nextShapeIdx = inShapeIdx + 1;
				if ( nextShapeIdx > lastShapeIdx )	nextShapeIdx = 0;

				var insideAngle = isPointInsideAngle( shape[ inShapeIdx ], shape[ prevShapeIdx ], shape[ nextShapeIdx ], hole[ inHoleIdx ] );
				if ( ! insideAngle ) {

					// console.log( "Vertex (Shape): " + inShapeIdx + ", Point: " + hole[inHoleIdx].x + "/" + hole[inHoleIdx].y );
					return	false;

				}

				// Check if shape point lies within angle around hole point
				var lastHoleIdx = hole.length - 1;

				var prevHoleIdx = inHoleIdx - 1;
				if ( prevHoleIdx < 0 )			prevHoleIdx = lastHoleIdx;

				var nextHoleIdx = inHoleIdx + 1;
				if ( nextHoleIdx > lastHoleIdx )	nextHoleIdx = 0;

				insideAngle = isPointInsideAngle( hole[ inHoleIdx ], hole[ prevHoleIdx ], hole[ nextHoleIdx ], shape[ inShapeIdx ] );
				if ( ! insideAngle ) {

					// console.log( "Vertex (Hole): " + inHoleIdx + ", Point: " + shape[inShapeIdx].x + "/" + shape[inShapeIdx].y );
					return	false;

				}

				return	true;

			}

			function intersectsShapeEdge( inShapePt, inHolePt ) {

				// checks for intersections with shape edges
				var sIdx, nextIdx, intersection;
				for ( sIdx = 0; sIdx < shape.length; sIdx ++ ) {

					nextIdx = sIdx + 1; nextIdx %= shape.length;
					intersection = intersect_segments_2D( inShapePt, inHolePt, shape[ sIdx ], shape[ nextIdx ], true );
					if ( intersection.length > 0 )		return	true;

				}

				return	false;

			}

			var indepHoles = [];

			function intersectsHoleEdge( inShapePt, inHolePt ) {

				// checks for intersections with hole edges
				var ihIdx, chkHole,
					hIdx, nextIdx, intersection;
				for ( ihIdx = 0; ihIdx < indepHoles.length; ihIdx ++ ) {

					chkHole = holes[ indepHoles[ ihIdx ]];
					for ( hIdx = 0; hIdx < chkHole.length; hIdx ++ ) {

						nextIdx = hIdx + 1; nextIdx %= chkHole.length;
						intersection = intersect_segments_2D( inShapePt, inHolePt, chkHole[ hIdx ], chkHole[ nextIdx ], true );
						if ( intersection.length > 0 )		return	true;

					}

				}
				return	false;

			}

			var holeIndex, shapeIndex,
				shapePt, holePt,
				holeIdx, cutKey, failedCuts = [],
				tmpShape1, tmpShape2,
				tmpHole1, tmpHole2;

			for ( var h = 0, hl = holes.length; h < hl; h ++ ) {

				indepHoles.push( h );

			}

			var minShapeIndex = 0;
			var counter = indepHoles.length * 2;
			while ( indepHoles.length > 0 ) {

				counter --;
				if ( counter < 0 ) {

					console.log( "Infinite Loop! Holes left:" + indepHoles.length + ", Probably Hole outside Shape!" );
					break;

				}

				// search for shape-vertex and hole-vertex,
				// which can be connected without intersections
				for ( shapeIndex = minShapeIndex; shapeIndex < shape.length; shapeIndex ++ ) {

					shapePt = shape[ shapeIndex ];
					holeIndex	= - 1;

					// search for hole which can be reached without intersections
					for ( var h = 0; h < indepHoles.length; h ++ ) {

						holeIdx = indepHoles[ h ];

						// prevent multiple checks
						cutKey = shapePt.x + ":" + shapePt.y + ":" + holeIdx;
						if ( failedCuts[ cutKey ] !== undefined )			continue;

						hole = holes[ holeIdx ];
						for ( var h2 = 0; h2 < hole.length; h2 ++ ) {

							holePt = hole[ h2 ];
							if ( ! isCutLineInsideAngles( shapeIndex, h2 ) )		continue;
							if ( intersectsShapeEdge( shapePt, holePt ) )		continue;
							if ( intersectsHoleEdge( shapePt, holePt ) )		continue;

							holeIndex = h2;
							indepHoles.splice( h, 1 );

							tmpShape1 = shape.slice( 0, shapeIndex + 1 );
							tmpShape2 = shape.slice( shapeIndex );
							tmpHole1 = hole.slice( holeIndex );
							tmpHole2 = hole.slice( 0, holeIndex + 1 );

							shape = tmpShape1.concat( tmpHole1 ).concat( tmpHole2 ).concat( tmpShape2 );

							minShapeIndex = shapeIndex;

							// Debug only, to show the selected cuts
							// glob_CutLines.push( [ shapePt, holePt ] );

							break;

						}
						if ( holeIndex >= 0 )	break;		// hole-vertex found

						failedCuts[ cutKey ] = true;			// remember failure

					}
					if ( holeIndex >= 0 )	break;		// hole-vertex found

				}

			}

			return shape; 			/* shape with no holes */

		}


		var i, il, f, face,
			key, index,
			allPointsMap = {};

		// To maintain reference to old shape, one must match coordinates, or offset the indices from original arrays. It's probably easier to do the first.

		var allpoints = contour.concat();

		for ( var h = 0, hl = holes.length; h < hl; h ++ ) {

			Array.prototype.push.apply( allpoints, holes[ h ] );

		}

		//console.log( "allpoints",allpoints, allpoints.length );

		// prepare all points map

		for ( i = 0, il = allpoints.length; i < il; i ++ ) {

			key = allpoints[ i ].x + ":" + allpoints[ i ].y;

			if ( allPointsMap[ key ] !== undefined ) {

				console.warn( "THREE.ShapeUtils: Duplicate point", key, i );

			}

			allPointsMap[ key ] = i;

		}

		// remove holes by cutting paths to holes and adding them to the shape
		var shapeWithoutHoles = removeHoles( contour, holes );

		var triangles = ShapeUtils.triangulate( shapeWithoutHoles, false ); // True returns indices for points of spooled shape
		//console.log( "triangles",triangles, triangles.length );

		// check all face vertices against all points map

		for ( i = 0, il = triangles.length; i < il; i ++ ) {

			face = triangles[ i ];

			for ( f = 0; f < 3; f ++ ) {

				key = face[ f ].x + ":" + face[ f ].y;

				index = allPointsMap[ key ];

				if ( index !== undefined ) {

					face[ f ] = index;

				}

			}

		}

		return triangles.concat();

	},

	isClockWise: function ( pts ) {

		return ShapeUtils.area( pts ) < 0;

	},

	// Bezier Curves formulas obtained from
	// http://en.wikipedia.org/wiki/B%C3%A9zier_curve

	// Quad Bezier Functions

	b2: ( function () {

		function b2p0( t, p ) {

			var k = 1 - t;
			return k * k * p;

		}

		function b2p1( t, p ) {

			return 2 * ( 1 - t ) * t * p;

		}

		function b2p2( t, p ) {

			return t * t * p;

		}

		return function b2( t, p0, p1, p2 ) {

			return b2p0( t, p0 ) + b2p1( t, p1 ) + b2p2( t, p2 );

		};

	} )(),

	// Cubic Bezier Functions

	b3: ( function () {

		function b3p0( t, p ) {

			var k = 1 - t;
			return k * k * k * p;

		}

		function b3p1( t, p ) {

			var k = 1 - t;
			return 3 * k * k * t * p;

		}

		function b3p2( t, p ) {

			var k = 1 - t;
			return 3 * k * t * t * p;

		}

		function b3p3( t, p ) {

			return t * t * t * p;

		}

		return function b3( t, p0, p1, p2, p3 ) {

			return b3p0( t, p0 ) + b3p1( t, p1 ) + b3p2( t, p2 ) + b3p3( t, p3 );

		};

	} )()

};

/**
 * @author zz85 / http://www.lab4games.net/zz85/blog
 *
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  amount: <int>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline is bevel
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *  frames: <Object> // containing arrays of tangents, normals, binormals
 *
 *  uvGenerator: <Object> // object that provides UV generator functions
 *
 * }
 **/

function ExtrudeGeometry( shapes, options ) {

	if ( typeof( shapes ) === "undefined" ) {

		shapes = [];
		return;

	}

	Geometry.call( this );

	this.type = 'ExtrudeGeometry';

	shapes = Array.isArray( shapes ) ? shapes : [ shapes ];

	this.addShapeList( shapes, options );

	this.computeFaceNormals();

	// can't really use automatic vertex normals
	// as then front and back sides get smoothed too
	// should do separate smoothing just for sides

	//this.computeVertexNormals();

	//console.log( "took", ( Date.now() - startTime ) );

}

ExtrudeGeometry.prototype = Object.create( Geometry.prototype );
ExtrudeGeometry.prototype.constructor = ExtrudeGeometry;

ExtrudeGeometry.prototype.addShapeList = function ( shapes, options ) {

	var sl = shapes.length;

	for ( var s = 0; s < sl; s ++ ) {

		var shape = shapes[ s ];
		this.addShape( shape, options );

	}

};

ExtrudeGeometry.prototype.addShape = function ( shape, options ) {

	var amount = options.amount !== undefined ? options.amount : 100;

	var bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 6; // 10
	var bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 2; // 8
	var bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;

	var bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true; // false

	var curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;

	var steps = options.steps !== undefined ? options.steps : 1;

	var extrudePath = options.extrudePath;
	var extrudePts, extrudeByPath = false;

	// Use default WorldUVGenerator if no UV generators are specified.
	var uvgen = options.UVGenerator !== undefined ? options.UVGenerator : ExtrudeGeometry.WorldUVGenerator;

	var splineTube, binormal, normal, position2;
	if ( extrudePath ) {

		extrudePts = extrudePath.getSpacedPoints( steps );

		extrudeByPath = true;
		bevelEnabled = false; // bevels not supported for path extrusion

		// SETUP TNB variables

		// TODO1 - have a .isClosed in spline?

		splineTube = options.frames !== undefined ? options.frames : extrudePath.computeFrenetFrames( steps, false );

		// console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);

		binormal = new Vector3();
		normal = new Vector3();
		position2 = new Vector3();

	}

	// Safeguards if bevels are not enabled

	if ( ! bevelEnabled ) {

		bevelSegments = 0;
		bevelThickness = 0;
		bevelSize = 0;

	}

	// Variables initialization

	var ahole, h, hl; // looping of holes
	var scope = this;

	var shapesOffset = this.vertices.length;

	var shapePoints = shape.extractPoints( curveSegments );

	var vertices = shapePoints.shape;
	var holes = shapePoints.holes;

	var reverse = ! ShapeUtils.isClockWise( vertices );

	if ( reverse ) {

		vertices = vertices.reverse();

		// Maybe we should also check if holes are in the opposite direction, just to be safe ...

		for ( h = 0, hl = holes.length; h < hl; h ++ ) {

			ahole = holes[ h ];

			if ( ShapeUtils.isClockWise( ahole ) ) {

				holes[ h ] = ahole.reverse();

			}

		}

		reverse = false; // If vertices are in order now, we shouldn't need to worry about them again (hopefully)!

	}


	var faces = ShapeUtils.triangulateShape( vertices, holes );

	/* Vertices */

	var contour = vertices; // vertices has all points but contour has only points of circumference

	for ( h = 0, hl = holes.length; h < hl; h ++ ) {

		ahole = holes[ h ];

		vertices = vertices.concat( ahole );

	}


	function scalePt2( pt, vec, size ) {

		if ( ! vec ) console.error( "THREE.ExtrudeGeometry: vec does not exist" );

		return vec.clone().multiplyScalar( size ).add( pt );

	}

	var b, bs, t, z,
		vert, vlen = vertices.length,
		face, flen = faces.length;


	// Find directions for point movement


	function getBevelVec( inPt, inPrev, inNext ) {

		// computes for inPt the corresponding point inPt' on a new contour
		//   shifted by 1 unit (length of normalized vector) to the left
		// if we walk along contour clockwise, this new contour is outside the old one
		//
		// inPt' is the intersection of the two lines parallel to the two
		//  adjacent edges of inPt at a distance of 1 unit on the left side.

		var v_trans_x, v_trans_y, shrink_by = 1;		// resulting translation vector for inPt

		// good reading for geometry algorithms (here: line-line intersection)
		// http://geomalgorithms.com/a05-_intersect-1.html

		var v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
		var v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;

		var v_prev_lensq = ( v_prev_x * v_prev_x + v_prev_y * v_prev_y );

		// check for collinear edges
		var collinear0 = ( v_prev_x * v_next_y - v_prev_y * v_next_x );

		if ( Math.abs( collinear0 ) > Number.EPSILON ) {

			// not collinear

			// length of vectors for normalizing

			var v_prev_len = Math.sqrt( v_prev_lensq );
			var v_next_len = Math.sqrt( v_next_x * v_next_x + v_next_y * v_next_y );

			// shift adjacent points by unit vectors to the left

			var ptPrevShift_x = ( inPrev.x - v_prev_y / v_prev_len );
			var ptPrevShift_y = ( inPrev.y + v_prev_x / v_prev_len );

			var ptNextShift_x = ( inNext.x - v_next_y / v_next_len );
			var ptNextShift_y = ( inNext.y + v_next_x / v_next_len );

			// scaling factor for v_prev to intersection point

			var sf = (  ( ptNextShift_x - ptPrevShift_x ) * v_next_y -
						( ptNextShift_y - ptPrevShift_y ) * v_next_x    ) /
					  ( v_prev_x * v_next_y - v_prev_y * v_next_x );

			// vector from inPt to intersection point

			v_trans_x = ( ptPrevShift_x + v_prev_x * sf - inPt.x );
			v_trans_y = ( ptPrevShift_y + v_prev_y * sf - inPt.y );

			// Don't normalize!, otherwise sharp corners become ugly
			//  but prevent crazy spikes
			var v_trans_lensq = ( v_trans_x * v_trans_x + v_trans_y * v_trans_y );
			if ( v_trans_lensq <= 2 ) {

				return	new Vector2( v_trans_x, v_trans_y );

			} else {

				shrink_by = Math.sqrt( v_trans_lensq / 2 );

			}

		} else {

			// handle special case of collinear edges

			var direction_eq = false;		// assumes: opposite
			if ( v_prev_x > Number.EPSILON ) {

				if ( v_next_x > Number.EPSILON ) {

					direction_eq = true;

				}

			} else {

				if ( v_prev_x < - Number.EPSILON ) {

					if ( v_next_x < - Number.EPSILON ) {

						direction_eq = true;

					}

				} else {

					if ( Math.sign( v_prev_y ) === Math.sign( v_next_y ) ) {

						direction_eq = true;

					}

				}

			}

			if ( direction_eq ) {

				// console.log("Warning: lines are a straight sequence");
				v_trans_x = - v_prev_y;
				v_trans_y =  v_prev_x;
				shrink_by = Math.sqrt( v_prev_lensq );

			} else {

				// console.log("Warning: lines are a straight spike");
				v_trans_x = v_prev_x;
				v_trans_y = v_prev_y;
				shrink_by = Math.sqrt( v_prev_lensq / 2 );

			}

		}

		return	new Vector2( v_trans_x / shrink_by, v_trans_y / shrink_by );

	}


	var contourMovements = [];

	for ( var i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i ++, j ++, k ++ ) {

		if ( j === il ) j = 0;
		if ( k === il ) k = 0;

		//  (j)---(i)---(k)
		// console.log('i,j,k', i, j , k)

		contourMovements[ i ] = getBevelVec( contour[ i ], contour[ j ], contour[ k ] );

	}

	var holesMovements = [], oneHoleMovements, verticesMovements = contourMovements.concat();

	for ( h = 0, hl = holes.length; h < hl; h ++ ) {

		ahole = holes[ h ];

		oneHoleMovements = [];

		for ( i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i ++, j ++, k ++ ) {

			if ( j === il ) j = 0;
			if ( k === il ) k = 0;

			//  (j)---(i)---(k)
			oneHoleMovements[ i ] = getBevelVec( ahole[ i ], ahole[ j ], ahole[ k ] );

		}

		holesMovements.push( oneHoleMovements );
		verticesMovements = verticesMovements.concat( oneHoleMovements );

	}


	// Loop bevelSegments, 1 for the front, 1 for the back

	for ( b = 0; b < bevelSegments; b ++ ) {

		//for ( b = bevelSegments; b > 0; b -- ) {

		t = b / bevelSegments;
		z = bevelThickness * Math.cos( t * Math.PI / 2 );
		bs = bevelSize * Math.sin( t * Math.PI / 2 );

		// contract shape

		for ( i = 0, il = contour.length; i < il; i ++ ) {

			vert = scalePt2( contour[ i ], contourMovements[ i ], bs );

			v( vert.x, vert.y,  - z );

		}

		// expand holes

		for ( h = 0, hl = holes.length; h < hl; h ++ ) {

			ahole = holes[ h ];
			oneHoleMovements = holesMovements[ h ];

			for ( i = 0, il = ahole.length; i < il; i ++ ) {

				vert = scalePt2( ahole[ i ], oneHoleMovements[ i ], bs );

				v( vert.x, vert.y,  - z );

			}

		}

	}

	bs = bevelSize;

	// Back facing vertices

	for ( i = 0; i < vlen; i ++ ) {

		vert = bevelEnabled ? scalePt2( vertices[ i ], verticesMovements[ i ], bs ) : vertices[ i ];

		if ( ! extrudeByPath ) {

			v( vert.x, vert.y, 0 );

		} else {

			// v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );

			normal.copy( splineTube.normals[ 0 ] ).multiplyScalar( vert.x );
			binormal.copy( splineTube.binormals[ 0 ] ).multiplyScalar( vert.y );

			position2.copy( extrudePts[ 0 ] ).add( normal ).add( binormal );

			v( position2.x, position2.y, position2.z );

		}

	}

	// Add stepped vertices...
	// Including front facing vertices

	var s;

	for ( s = 1; s <= steps; s ++ ) {

		for ( i = 0; i < vlen; i ++ ) {

			vert = bevelEnabled ? scalePt2( vertices[ i ], verticesMovements[ i ], bs ) : vertices[ i ];

			if ( ! extrudeByPath ) {

				v( vert.x, vert.y, amount / steps * s );

			} else {

				// v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );

				normal.copy( splineTube.normals[ s ] ).multiplyScalar( vert.x );
				binormal.copy( splineTube.binormals[ s ] ).multiplyScalar( vert.y );

				position2.copy( extrudePts[ s ] ).add( normal ).add( binormal );

				v( position2.x, position2.y, position2.z );

			}

		}

	}


	// Add bevel segments planes

	//for ( b = 1; b <= bevelSegments; b ++ ) {
	for ( b = bevelSegments - 1; b >= 0; b -- ) {

		t = b / bevelSegments;
		z = bevelThickness * Math.cos ( t * Math.PI / 2 );
		bs = bevelSize * Math.sin( t * Math.PI / 2 );

		// contract shape

		for ( i = 0, il = contour.length; i < il; i ++ ) {

			vert = scalePt2( contour[ i ], contourMovements[ i ], bs );
			v( vert.x, vert.y,  amount + z );

		}

		// expand holes

		for ( h = 0, hl = holes.length; h < hl; h ++ ) {

			ahole = holes[ h ];
			oneHoleMovements = holesMovements[ h ];

			for ( i = 0, il = ahole.length; i < il; i ++ ) {

				vert = scalePt2( ahole[ i ], oneHoleMovements[ i ], bs );

				if ( ! extrudeByPath ) {

					v( vert.x, vert.y,  amount + z );

				} else {

					v( vert.x, vert.y + extrudePts[ steps - 1 ].y, extrudePts[ steps - 1 ].x + z );

				}

			}

		}

	}

	/* Faces */

	// Top and bottom faces

	buildLidFaces();

	// Sides faces

	buildSideFaces();


	/////  Internal functions

	function buildLidFaces() {

		if ( bevelEnabled ) {

			var layer = 0; // steps + 1
			var offset = vlen * layer;

			// Bottom faces

			for ( i = 0; i < flen; i ++ ) {

				face = faces[ i ];
				f3( face[ 2 ] + offset, face[ 1 ] + offset, face[ 0 ] + offset );

			}

			layer = steps + bevelSegments * 2;
			offset = vlen * layer;

			// Top faces

			for ( i = 0; i < flen; i ++ ) {

				face = faces[ i ];
				f3( face[ 0 ] + offset, face[ 1 ] + offset, face[ 2 ] + offset );

			}

		} else {

			// Bottom faces

			for ( i = 0; i < flen; i ++ ) {

				face = faces[ i ];
				f3( face[ 2 ], face[ 1 ], face[ 0 ] );

			}

			// Top faces

			for ( i = 0; i < flen; i ++ ) {

				face = faces[ i ];
				f3( face[ 0 ] + vlen * steps, face[ 1 ] + vlen * steps, face[ 2 ] + vlen * steps );

			}

		}

	}

	// Create faces for the z-sides of the shape

	function buildSideFaces() {

		var layeroffset = 0;
		sidewalls( contour, layeroffset );
		layeroffset += contour.length;

		for ( h = 0, hl = holes.length; h < hl; h ++ ) {

			ahole = holes[ h ];
			sidewalls( ahole, layeroffset );

			//, true
			layeroffset += ahole.length;

		}

	}

	function sidewalls( contour, layeroffset ) {

		var j, k;
		i = contour.length;

		while ( -- i >= 0 ) {

			j = i;
			k = i - 1;
			if ( k < 0 ) k = contour.length - 1;

			//console.log('b', i,j, i-1, k,vertices.length);

			var s = 0, sl = steps  + bevelSegments * 2;

			for ( s = 0; s < sl; s ++ ) {

				var slen1 = vlen * s;
				var slen2 = vlen * ( s + 1 );

				var a = layeroffset + j + slen1,
					b = layeroffset + k + slen1,
					c = layeroffset + k + slen2,
					d = layeroffset + j + slen2;

				f4( a, b, c, d, contour, s, sl, j, k );

			}

		}

	}


	function v( x, y, z ) {

		scope.vertices.push( new Vector3( x, y, z ) );

	}

	function f3( a, b, c ) {

		a += shapesOffset;
		b += shapesOffset;
		c += shapesOffset;

		scope.faces.push( new Face3( a, b, c, null, null, 0 ) );

		var uvs = uvgen.generateTopUV( scope, a, b, c );

		scope.faceVertexUvs[ 0 ].push( uvs );

	}

	function f4( a, b, c, d, wallContour, stepIndex, stepsLength, contourIndex1, contourIndex2 ) {

		a += shapesOffset;
		b += shapesOffset;
		c += shapesOffset;
		d += shapesOffset;

		scope.faces.push( new Face3( a, b, d, null, null, 1 ) );
		scope.faces.push( new Face3( b, c, d, null, null, 1 ) );

		var uvs = uvgen.generateSideWallUV( scope, a, b, c, d );

		scope.faceVertexUvs[ 0 ].push( [ uvs[ 0 ], uvs[ 1 ], uvs[ 3 ] ] );
		scope.faceVertexUvs[ 0 ].push( [ uvs[ 1 ], uvs[ 2 ], uvs[ 3 ] ] );

	}

};

ExtrudeGeometry.WorldUVGenerator = {

	generateTopUV: function ( geometry, indexA, indexB, indexC ) {

		var vertices = geometry.vertices;

		var a = vertices[ indexA ];
		var b = vertices[ indexB ];
		var c = vertices[ indexC ];

		return [
			new Vector2( a.x, a.y ),
			new Vector2( b.x, b.y ),
			new Vector2( c.x, c.y )
		];

	},

	generateSideWallUV: function ( geometry, indexA, indexB, indexC, indexD ) {

		var vertices = geometry.vertices;

		var a = vertices[ indexA ];
		var b = vertices[ indexB ];
		var c = vertices[ indexC ];
		var d = vertices[ indexD ];

		if ( Math.abs( a.y - b.y ) < 0.01 ) {

			return [
				new Vector2( a.x, 1 - a.z ),
				new Vector2( b.x, 1 - b.z ),
				new Vector2( c.x, 1 - c.z ),
				new Vector2( d.x, 1 - d.z )
			];

		} else {

			return [
				new Vector2( a.y, 1 - a.z ),
				new Vector2( b.y, 1 - b.z ),
				new Vector2( c.y, 1 - c.z ),
				new Vector2( d.y, 1 - d.z )
			];

		}

	}
};

/**
 * @author zz85 / http://www.lab4games.net/zz85/blog
 * @author alteredq / http://alteredqualia.com/
 *
 * Text = 3D Text
 *
 * parameters = {
 *  font: <THREE.Font>, // font
 *
 *  size: <float>, // size of the text
 *  height: <float>, // thickness to extrude text
 *  curveSegments: <int>, // number of points on the curves
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into text bevel goes
 *  bevelSize: <float> // how far from text outline is bevel
 * }
 */

function TextGeometry( text, parameters ) {

	parameters = parameters || {};

	var font = parameters.font;

	if ( (font && font.isFont) === false ) {

		console.error( 'THREE.TextGeometry: font parameter is not an instance of THREE.Font.' );
		return new Geometry();

	}

	var shapes = font.generateShapes( text, parameters.size, parameters.curveSegments );

	// translate parameters to ExtrudeGeometry API

	parameters.amount = parameters.height !== undefined ? parameters.height : 50;

	// defaults

	if ( parameters.bevelThickness === undefined ) parameters.bevelThickness = 10;
	if ( parameters.bevelSize === undefined ) parameters.bevelSize = 8;
	if ( parameters.bevelEnabled === undefined ) parameters.bevelEnabled = false;

	ExtrudeGeometry.call( this, shapes, parameters );

	this.type = 'TextGeometry';

}

TextGeometry.prototype = Object.create( ExtrudeGeometry.prototype );
TextGeometry.prototype.constructor = TextGeometry;

/**
 * @author benaadams / https://twitter.com/ben_a_adams
 * based on THREE.SphereGeometry
 */

function SphereBufferGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) {

	BufferGeometry.call( this );

	this.type = 'SphereBufferGeometry';

	this.parameters = {
		radius: radius,
		widthSegments: widthSegments,
		heightSegments: heightSegments,
		phiStart: phiStart,
		phiLength: phiLength,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

	radius = radius || 50;

	widthSegments = Math.max( 3, Math.floor( widthSegments ) || 8 );
	heightSegments = Math.max( 2, Math.floor( heightSegments ) || 6 );

	phiStart = phiStart !== undefined ? phiStart : 0;
	phiLength = phiLength !== undefined ? phiLength : Math.PI * 2;

	thetaStart = thetaStart !== undefined ? thetaStart : 0;
	thetaLength = thetaLength !== undefined ? thetaLength : Math.PI;

	var thetaEnd = thetaStart + thetaLength;

	var vertexCount = ( ( widthSegments + 1 ) * ( heightSegments + 1 ) );

	var positions = new BufferAttribute( new Float32Array( vertexCount * 3 ), 3 );
	var normals = new BufferAttribute( new Float32Array( vertexCount * 3 ), 3 );
	var uvs = new BufferAttribute( new Float32Array( vertexCount * 2 ), 2 );

	var index = 0, vertices = [], normal = new Vector3();

	for ( var y = 0; y <= heightSegments; y ++ ) {

		var verticesRow = [];

		var v = y / heightSegments;

		for ( var x = 0; x <= widthSegments; x ++ ) {

			var u = x / widthSegments;

			var px = - radius * Math.cos( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );
			var py = radius * Math.cos( thetaStart + v * thetaLength );
			var pz = radius * Math.sin( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );

			normal.set( px, py, pz ).normalize();

			positions.setXYZ( index, px, py, pz );
			normals.setXYZ( index, normal.x, normal.y, normal.z );
			uvs.setXY( index, u, 1 - v );

			verticesRow.push( index );

			index ++;

		}

		vertices.push( verticesRow );

	}

	var indices = [];

	for ( var y = 0; y < heightSegments; y ++ ) {

		for ( var x = 0; x < widthSegments; x ++ ) {

			var v1 = vertices[ y ][ x + 1 ];
			var v2 = vertices[ y ][ x ];
			var v3 = vertices[ y + 1 ][ x ];
			var v4 = vertices[ y + 1 ][ x + 1 ];

			if ( y !== 0 || thetaStart > 0 ) indices.push( v1, v2, v4 );
			if ( y !== heightSegments - 1 || thetaEnd < Math.PI ) indices.push( v2, v3, v4 );

		}

	}

	this.setIndex( new ( positions.count > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute )( indices, 1 ) );
	this.addAttribute( 'position', positions );
	this.addAttribute( 'normal', normals );
	this.addAttribute( 'uv', uvs );

	this.boundingSphere = new Sphere( new Vector3(), radius );

}

SphereBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
SphereBufferGeometry.prototype.constructor = SphereBufferGeometry;

/**
 * @author mrdoob / http://mrdoob.com/
 */

function SphereGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) {

	Geometry.call( this );

	this.type = 'SphereGeometry';

	this.parameters = {
		radius: radius,
		widthSegments: widthSegments,
		heightSegments: heightSegments,
		phiStart: phiStart,
		phiLength: phiLength,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

	this.fromBufferGeometry( new SphereBufferGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) );

}

SphereGeometry.prototype = Object.create( Geometry.prototype );
SphereGeometry.prototype.constructor = SphereGeometry;

/**
 * @author Mugen87 / https://github.com/Mugen87
 */

function RingBufferGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) {

	BufferGeometry.call( this );

	this.type = 'RingBufferGeometry';

	this.parameters = {
		innerRadius: innerRadius,
		outerRadius: outerRadius,
		thetaSegments: thetaSegments,
		phiSegments: phiSegments,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

	innerRadius = innerRadius || 20;
	outerRadius = outerRadius || 50;

	thetaStart = thetaStart !== undefined ? thetaStart : 0;
	thetaLength = thetaLength !== undefined ? thetaLength : Math.PI * 2;

	thetaSegments = thetaSegments !== undefined ? Math.max( 3, thetaSegments ) : 8;
	phiSegments = phiSegments !== undefined ? Math.max( 1, phiSegments ) : 1;

	// these are used to calculate buffer length
	var vertexCount = ( thetaSegments + 1 ) * ( phiSegments + 1 );
	var indexCount = thetaSegments * phiSegments * 2 * 3;

	// buffers
	var indices = new BufferAttribute( new ( indexCount > 65535 ? Uint32Array : Uint16Array )( indexCount ) , 1 );
	var vertices = new BufferAttribute( new Float32Array( vertexCount * 3 ), 3 );
	var normals = new BufferAttribute( new Float32Array( vertexCount * 3 ), 3 );
	var uvs = new BufferAttribute( new Float32Array( vertexCount * 2 ), 2 );

	// some helper variables
	var index = 0, indexOffset = 0, segment;
	var radius = innerRadius;
	var radiusStep = ( ( outerRadius - innerRadius ) / phiSegments );
	var vertex = new Vector3();
	var uv = new Vector2();
	var j, i;

	// generate vertices, normals and uvs

	// values are generate from the inside of the ring to the outside

	for ( j = 0; j <= phiSegments; j ++ ) {

		for ( i = 0; i <= thetaSegments; i ++ ) {

			segment = thetaStart + i / thetaSegments * thetaLength;

			// vertex
			vertex.x = radius * Math.cos( segment );
			vertex.y = radius * Math.sin( segment );
			vertices.setXYZ( index, vertex.x, vertex.y, vertex.z );

			// normal
			normals.setXYZ( index, 0, 0, 1 );

			// uv
			uv.x = ( vertex.x / outerRadius + 1 ) / 2;
			uv.y = ( vertex.y / outerRadius + 1 ) / 2;
			uvs.setXY( index, uv.x, uv.y );

			// increase index
			index++;

		}

		// increase the radius for next row of vertices
		radius += radiusStep;

	}

	// generate indices

	for ( j = 0; j < phiSegments; j ++ ) {

		var thetaSegmentLevel = j * ( thetaSegments + 1 );

		for ( i = 0; i < thetaSegments; i ++ ) {

			segment = i + thetaSegmentLevel;

			// indices
			var a = segment;
			var b = segment + thetaSegments + 1;
			var c = segment + thetaSegments + 2;
			var d = segment + 1;

			// face one
			indices.setX( indexOffset, a ); indexOffset++;
			indices.setX( indexOffset, b ); indexOffset++;
			indices.setX( indexOffset, c ); indexOffset++;

			// face two
			indices.setX( indexOffset, a ); indexOffset++;
			indices.setX( indexOffset, c ); indexOffset++;
			indices.setX( indexOffset, d ); indexOffset++;

		}

	}

	// build geometry

	this.setIndex( indices );
	this.addAttribute( 'position', vertices );
	this.addAttribute( 'normal', normals );
	this.addAttribute( 'uv', uvs );

}

RingBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
RingBufferGeometry.prototype.constructor = RingBufferGeometry;

/**
 * @author Kaleb Murphy
 */

function RingGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) {

	Geometry.call( this );

	this.type = 'RingGeometry';

	this.parameters = {
		innerRadius: innerRadius,
		outerRadius: outerRadius,
		thetaSegments: thetaSegments,
		phiSegments: phiSegments,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

	this.fromBufferGeometry( new RingBufferGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) );

}

RingGeometry.prototype = Object.create( Geometry.prototype );
RingGeometry.prototype.constructor = RingGeometry;

/**
 * @author mrdoob / http://mrdoob.com/
 * based on http://papervision3d.googlecode.com/svn/trunk/as3/trunk/src/org/papervision3d/objects/primitives/Plane.as
 */

function PlaneGeometry( width, height, widthSegments, heightSegments ) {

	Geometry.call( this );

	this.type = 'PlaneGeometry';

	this.parameters = {
		width: width,
		height: height,
		widthSegments: widthSegments,
		heightSegments: heightSegments
	};

	this.fromBufferGeometry( new PlaneBufferGeometry( width, height, widthSegments, heightSegments ) );

}

PlaneGeometry.prototype = Object.create( Geometry.prototype );
PlaneGeometry.prototype.constructor = PlaneGeometry;

/**
 * @author Mugen87 / https://github.com/Mugen87
 */

 // points - to create a closed torus, one must use a set of points
 //    like so: [ a, b, c, d, a ], see first is the same as last.
 // segments - the number of circumference segments to create
 // phiStart - the starting radian
 // phiLength - the radian (0 to 2PI) range of the lathed section
 //    2PI is a closed lathe, less than 2PI is a portion.

function LatheBufferGeometry( points, segments, phiStart, phiLength ) {

	BufferGeometry.call( this );

	this.type = 'LatheBufferGeometry';

	this.parameters = {
		points: points,
		segments: segments,
		phiStart: phiStart,
		phiLength: phiLength
	};

	segments = Math.floor( segments ) || 12;
	phiStart = phiStart || 0;
	phiLength = phiLength || Math.PI * 2;

	// clamp phiLength so it's in range of [ 0, 2PI ]
	phiLength = _Math.clamp( phiLength, 0, Math.PI * 2 );

	// these are used to calculate buffer length
	var vertexCount = ( segments + 1 ) * points.length;
	var indexCount = segments * points.length * 2 * 3;

	// buffers
	var indices = new BufferAttribute( new ( indexCount > 65535 ? Uint32Array : Uint16Array )( indexCount ) , 1 );
	var vertices = new BufferAttribute( new Float32Array( vertexCount * 3 ), 3 );
	var uvs = new BufferAttribute( new Float32Array( vertexCount * 2 ), 2 );

	// helper variables
	var index = 0, indexOffset = 0, base;
	var inverseSegments = 1.0 / segments;
	var vertex = new Vector3();
	var uv = new Vector2();
	var i, j;

	// generate vertices and uvs

	for ( i = 0; i <= segments; i ++ ) {

		var phi = phiStart + i * inverseSegments * phiLength;

		var sin = Math.sin( phi );
		var cos = Math.cos( phi );

		for ( j = 0; j <= ( points.length - 1 ); j ++ ) {

			// vertex
			vertex.x = points[ j ].x * sin;
			vertex.y = points[ j ].y;
			vertex.z = points[ j ].x * cos;
			vertices.setXYZ( index, vertex.x, vertex.y, vertex.z );

			// uv
			uv.x = i / segments;
			uv.y = j / ( points.length - 1 );
			uvs.setXY( index, uv.x, uv.y );

			// increase index
			index ++;

		}

	}

	// generate indices

	for ( i = 0; i < segments; i ++ ) {

		for ( j = 0; j < ( points.length - 1 ); j ++ ) {

			base = j + i * points.length;

			// indices
			var a = base;
			var b = base + points.length;
			var c = base + points.length + 1;
			var d = base + 1;

			// face one
			indices.setX( indexOffset, a ); indexOffset++;
			indices.setX( indexOffset, b ); indexOffset++;
			indices.setX( indexOffset, d ); indexOffset++;

			// face two
			indices.setX( indexOffset, b ); indexOffset++;
			indices.setX( indexOffset, c ); indexOffset++;
			indices.setX( indexOffset, d ); indexOffset++;

		}

	}

	// build geometry

	this.setIndex( indices );
	this.addAttribute( 'position', vertices );
	this.addAttribute( 'uv', uvs );

	// generate normals

	this.computeVertexNormals();

	// if the geometry is closed, we need to average the normals along the seam.
	// because the corresponding vertices are identical (but still have different UVs).

	if( phiLength === Math.PI * 2 ) {

		var normals = this.attributes.normal.array;
		var n1 = new Vector3();
		var n2 = new Vector3();
		var n = new Vector3();

		// this is the buffer offset for the last line of vertices
		base = segments * points.length * 3;

		for( i = 0, j = 0; i < points.length; i ++, j += 3 ) {

			// select the normal of the vertex in the first line
			n1.x = normals[ j + 0 ];
			n1.y = normals[ j + 1 ];
			n1.z = normals[ j + 2 ];

			// select the normal of the vertex in the last line
			n2.x = normals[ base + j + 0 ];
			n2.y = normals[ base + j + 1 ];
			n2.z = normals[ base + j + 2 ];

			// average normals
			n.addVectors( n1, n2 ).normalize();

			// assign the new values to both normals
			normals[ j + 0 ] = normals[ base + j + 0 ] = n.x;
			normals[ j + 1 ] = normals[ base + j + 1 ] = n.y;
			normals[ j + 2 ] = normals[ base + j + 2 ] = n.z;

		} // next row

	}

}

LatheBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
LatheBufferGeometry.prototype.constructor = LatheBufferGeometry;

/**
 * @author astrodud / http://astrodud.isgreat.org/
 * @author zz85 / https://github.com/zz85
 * @author bhouston / http://clara.io
 */

// points - to create a closed torus, one must use a set of points
//    like so: [ a, b, c, d, a ], see first is the same as last.
// segments - the number of circumference segments to create
// phiStart - the starting radian
// phiLength - the radian (0 to 2PI) range of the lathed section
//    2PI is a closed lathe, less than 2PI is a portion.

function LatheGeometry( points, segments, phiStart, phiLength ) {

	Geometry.call( this );

	this.type = 'LatheGeometry';

	this.parameters = {
		points: points,
		segments: segments,
		phiStart: phiStart,
		phiLength: phiLength
	};

	this.fromBufferGeometry( new LatheBufferGeometry( points, segments, phiStart, phiLength ) );
	this.mergeVertices();

}

LatheGeometry.prototype = Object.create( Geometry.prototype );
LatheGeometry.prototype.constructor = LatheGeometry;

/**
 * @author Mugen87 / https://github.com/Mugen87
 *
 * Creates a one-sided polygonal geometry from one or more shapes.
 *
 **/

function ShapeBufferGeometry( shapes, curveSegments ) {

	BufferGeometry.call( this );

	this.type = 'ShapeBufferGeometry';

	this.parameters = {
		shapes: shapes,
		curveSegments: curveSegments
	};

	curveSegments = curveSegments || 12;

	var vertices = [];
	var normals = [];
	var uvs = [];
	var indices = [];

	var groupStart = 0;
	var groupCount = 0;

	// allow single and array values for "shapes" parameter

	if ( Array.isArray( shapes ) === false ) {

		addShape( shapes );

	} else {

		for ( var i = 0; i < shapes.length; i++ ) {

			addShape( shapes[ i ] );

			this.addGroup( groupStart, groupCount, i ); // enables MultiMaterial support

			groupStart += groupCount;
			groupCount = 0;

		}

	}

	// build geometry

	this.setIndex( new ( indices.length > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute )( indices, 1 ) );
	this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
	this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );


	// helper functions

	function addShape( shape ) {

		var i, l, shapeHole;

		var indexOffset = vertices.length / 3;
		var points = shape.extractPoints( curveSegments );

		var shapeVertices = points.shape;
		var shapeHoles = points.holes;

		// check direction of vertices

		if ( ShapeUtils.isClockWise( shapeVertices ) === false ) {

			shapeVertices = shapeVertices.reverse();

			// also check if holes are in the opposite direction

			for ( i = 0, l = shapeHoles.length; i < l; i ++ ) {

				shapeHole = shapeHoles[ i ];

				if ( ShapeUtils.isClockWise( shapeHole ) === true ) {

					shapeHoles[ i ] = shapeHole.reverse();

				}

			}

		}

		var faces = ShapeUtils.triangulateShape( shapeVertices, shapeHoles );

		// join vertices of inner and outer paths to a single array

		for ( i = 0, l = shapeHoles.length; i < l; i ++ ) {

			shapeHole = shapeHoles[ i ];
			shapeVertices = shapeVertices.concat( shapeHole );

		}

		// vertices, normals, uvs

		for ( i = 0, l = shapeVertices.length; i < l; i ++ ) {

			var vertex = shapeVertices[ i ];

			vertices.push( vertex.x, vertex.y, 0 );
			normals.push( 0, 0, 1 );
			uvs.push( vertex.x, vertex.y ); // world uvs

		}

		// incides

		for ( i = 0, l = faces.length; i < l; i ++ ) {

			var face = faces[ i ];

			var a = face[ 0 ] + indexOffset;
			var b = face[ 1 ] + indexOffset;
			var c = face[ 2 ] + indexOffset;

			indices.push( a, b, c );
			groupCount += 3;

		}

	}

}

ShapeBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
ShapeBufferGeometry.prototype.constructor = ShapeBufferGeometry;

/**
 * @author jonobr1 / http://jonobr1.com
 *
 * Creates a one-sided polygonal geometry from a path shape.
 *
 **/

function ShapeGeometry( shapes, curveSegments ) {

	Geometry.call( this );

	this.type = 'ShapeGeometry';

	if ( typeof curveSegments === 'object' ) {

		console.warn( 'THREE.ShapeGeometry: Options parameter has been removed.' );

		curveSegments = curveSegments.curveSegments;

	}

	this.parameters = {
		shapes: shapes,
		curveSegments: curveSegments
	};

	this.fromBufferGeometry( new ShapeBufferGeometry( shapes, curveSegments ) );
	this.mergeVertices();

}

ShapeGeometry.prototype = Object.create( Geometry.prototype );
ShapeGeometry.prototype.constructor = ShapeGeometry;

/**
 * @author WestLangley / http://github.com/WestLangley
 */

function EdgesGeometry( geometry, thresholdAngle ) {

	BufferGeometry.call( this );

	thresholdAngle = ( thresholdAngle !== undefined ) ? thresholdAngle : 1;

	var thresholdDot = Math.cos( _Math.DEG2RAD * thresholdAngle );

	var edge = [ 0, 0 ], hash = {};

	function sortFunction( a, b ) {

		return a - b;

	}

	var keys = [ 'a', 'b', 'c' ];

	var geometry2;

	if ( geometry.isBufferGeometry ) {

		geometry2 = new Geometry();
		geometry2.fromBufferGeometry( geometry );

	} else {

		geometry2 = geometry.clone();

	}

	geometry2.mergeVertices();
	geometry2.computeFaceNormals();

	var vertices = geometry2.vertices;
	var faces = geometry2.faces;

	for ( var i = 0, l = faces.length; i < l; i ++ ) {

		var face = faces[ i ];

		for ( var j = 0; j < 3; j ++ ) {

			edge[ 0 ] = face[ keys[ j ] ];
			edge[ 1 ] = face[ keys[ ( j + 1 ) % 3 ] ];
			edge.sort( sortFunction );

			var key = edge.toString();

			if ( hash[ key ] === undefined ) {

				hash[ key ] = { vert1: edge[ 0 ], vert2: edge[ 1 ], face1: i, face2: undefined };

			} else {

				hash[ key ].face2 = i;

			}

		}

	}

	var coords = [];

	for ( var key in hash ) {

		var h = hash[ key ];

		// An edge is only rendered if the angle (in degrees) between the face normals of the adjoining faces exceeds this value. default = 1 degree.

		if ( h.face2 === undefined || faces[ h.face1 ].normal.dot( faces[ h.face2 ].normal ) <= thresholdDot ) {

			var vertex = vertices[ h.vert1 ];
			coords.push( vertex.x );
			coords.push( vertex.y );
			coords.push( vertex.z );

			vertex = vertices[ h.vert2 ];
			coords.push( vertex.x );
			coords.push( vertex.y );
			coords.push( vertex.z );

		}

	}

	this.addAttribute( 'position', new Float32BufferAttribute( coords, 3 ) );

}

EdgesGeometry.prototype = Object.create( BufferGeometry.prototype );
EdgesGeometry.prototype.constructor = EdgesGeometry;

/**
 * @author Mugen87 / https://github.com/Mugen87
 */

function CylinderBufferGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {

	BufferGeometry.call( this );

	this.type = 'CylinderBufferGeometry';

	this.parameters = {
		radiusTop: radiusTop,
		radiusBottom: radiusBottom,
		height: height,
		radialSegments: radialSegments,
		heightSegments: heightSegments,
		openEnded: openEnded,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

	var scope = this;

	radiusTop = radiusTop !== undefined ? radiusTop : 20;
	radiusBottom = radiusBottom !== undefined ? radiusBottom : 20;
	height = height !== undefined ? height : 100;

	radialSegments = Math.floor( radialSegments ) || 8;
	heightSegments = Math.floor( heightSegments ) || 1;

	openEnded = openEnded !== undefined ? openEnded : false;
	thetaStart = thetaStart !== undefined ? thetaStart : 0.0;
	thetaLength = thetaLength !== undefined ? thetaLength : 2.0 * Math.PI;

	// used to calculate buffer length

	var nbCap = 0;

	if ( openEnded === false ) {

		if ( radiusTop > 0 ) nbCap ++;
		if ( radiusBottom > 0 ) nbCap ++;

	}

	var vertexCount = calculateVertexCount();
	var indexCount = calculateIndexCount();

	// buffers

	var indices = new BufferAttribute( new ( indexCount > 65535 ? Uint32Array : Uint16Array )( indexCount ), 1 );
	var vertices = new BufferAttribute( new Float32Array( vertexCount * 3 ), 3 );
	var normals = new BufferAttribute( new Float32Array( vertexCount * 3 ), 3 );
	var uvs = new BufferAttribute( new Float32Array( vertexCount * 2 ), 2 );

	// helper variables

	var index = 0,
	    indexOffset = 0,
	    indexArray = [],
	    halfHeight = height / 2;

	// group variables
	var groupStart = 0;

	// generate geometry

	generateTorso();

	if ( openEnded === false ) {

		if ( radiusTop > 0 ) generateCap( true );
		if ( radiusBottom > 0 ) generateCap( false );

	}

	// build geometry

	this.setIndex( indices );
	this.addAttribute( 'position', vertices );
	this.addAttribute( 'normal', normals );
	this.addAttribute( 'uv', uvs );

	// helper functions

	function calculateVertexCount() {

		var count = ( radialSegments + 1 ) * ( heightSegments + 1 );

		if ( openEnded === false ) {

			count += ( ( radialSegments + 1 ) * nbCap ) + ( radialSegments * nbCap );

		}

		return count;

	}

	function calculateIndexCount() {

		var count = radialSegments * heightSegments * 2 * 3;

		if ( openEnded === false ) {

			count += radialSegments * nbCap * 3;

		}

		return count;

	}

	function generateTorso() {

		var x, y;
		var normal = new Vector3();
		var vertex = new Vector3();

		var groupCount = 0;

		// this will be used to calculate the normal
		var slope = ( radiusBottom - radiusTop ) / height;

		// generate vertices, normals and uvs

		for ( y = 0; y <= heightSegments; y ++ ) {

			var indexRow = [];

			var v = y / heightSegments;

			// calculate the radius of the current row
			var radius = v * ( radiusBottom - radiusTop ) + radiusTop;

			for ( x = 0; x <= radialSegments; x ++ ) {

				var u = x / radialSegments;

				var theta = u * thetaLength + thetaStart;

				var sinTheta = Math.sin( theta );
				var cosTheta = Math.cos( theta );

				// vertex
				vertex.x = radius * sinTheta;
				vertex.y = - v * height + halfHeight;
				vertex.z = radius * cosTheta;
				vertices.setXYZ( index, vertex.x, vertex.y, vertex.z );

				// normal
				normal.set( sinTheta, slope, cosTheta ).normalize();
				normals.setXYZ( index, normal.x, normal.y, normal.z );

				// uv
				uvs.setXY( index, u, 1 - v );

				// save index of vertex in respective row
				indexRow.push( index );

				// increase index
				index ++;

			}

			// now save vertices of the row in our index array
			indexArray.push( indexRow );

		}

		// generate indices

		for ( x = 0; x < radialSegments; x ++ ) {

			for ( y = 0; y < heightSegments; y ++ ) {

				// we use the index array to access the correct indices
				var i1 = indexArray[ y ][ x ];
				var i2 = indexArray[ y + 1 ][ x ];
				var i3 = indexArray[ y + 1 ][ x + 1 ];
				var i4 = indexArray[ y ][ x + 1 ];

				// face one
				indices.setX( indexOffset, i1 ); indexOffset ++;
				indices.setX( indexOffset, i2 ); indexOffset ++;
				indices.setX( indexOffset, i4 ); indexOffset ++;

				// face two
				indices.setX( indexOffset, i2 ); indexOffset ++;
				indices.setX( indexOffset, i3 ); indexOffset ++;
				indices.setX( indexOffset, i4 ); indexOffset ++;

				// update counters
				groupCount += 6;

			}

		}

		// add a group to the geometry. this will ensure multi material support
		scope.addGroup( groupStart, groupCount, 0 );

		// calculate new start value for groups
		groupStart += groupCount;

	}

	function generateCap( top ) {

		var x, centerIndexStart, centerIndexEnd;

		var uv = new Vector2();
		var vertex = new Vector3();

		var groupCount = 0;

		var radius = ( top === true ) ? radiusTop : radiusBottom;
		var sign = ( top === true ) ? 1 : - 1;

		// save the index of the first center vertex
		centerIndexStart = index;

		// first we generate the center vertex data of the cap.
		// because the geometry needs one set of uvs per face,
		// we must generate a center vertex per face/segment

		for ( x = 1; x <= radialSegments; x ++ ) {

			// vertex
			vertices.setXYZ( index, 0, halfHeight * sign, 0 );

			// normal
			normals.setXYZ( index, 0, sign, 0 );

			// uv
			uv.x = 0.5;
			uv.y = 0.5;

			uvs.setXY( index, uv.x, uv.y );

			// increase index
			index ++;

		}

		// save the index of the last center vertex
		centerIndexEnd = index;

		// now we generate the surrounding vertices, normals and uvs

		for ( x = 0; x <= radialSegments; x ++ ) {

			var u = x / radialSegments;
			var theta = u * thetaLength + thetaStart;

			var cosTheta = Math.cos( theta );
			var sinTheta = Math.sin( theta );

			// vertex
			vertex.x = radius * sinTheta;
			vertex.y = halfHeight * sign;
			vertex.z = radius * cosTheta;
			vertices.setXYZ( index, vertex.x, vertex.y, vertex.z );

			// normal
			normals.setXYZ( index, 0, sign, 0 );

			// uv
			uv.x = ( cosTheta * 0.5 ) + 0.5;
			uv.y = ( sinTheta * 0.5 * sign ) + 0.5;
			uvs.setXY( index, uv.x, uv.y );

			// increase index
			index ++;

		}

		// generate indices

		for ( x = 0; x < radialSegments; x ++ ) {

			var c = centerIndexStart + x;
			var i = centerIndexEnd + x;

			if ( top === true ) {

				// face top
				indices.setX( indexOffset, i ); indexOffset ++;
				indices.setX( indexOffset, i + 1 ); indexOffset ++;
				indices.setX( indexOffset, c ); indexOffset ++;

			} else {

				// face bottom
				indices.setX( indexOffset, i + 1 ); indexOffset ++;
				indices.setX( indexOffset, i ); indexOffset ++;
				indices.setX( indexOffset, c ); indexOffset ++;

			}

			// update counters
			groupCount += 3;

		}

		// add a group to the geometry. this will ensure multi material support
		scope.addGroup( groupStart, groupCount, top === true ? 1 : 2 );

		// calculate new start value for groups
		groupStart += groupCount;

	}

}

CylinderBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
CylinderBufferGeometry.prototype.constructor = CylinderBufferGeometry;

/**
 * @author mrdoob / http://mrdoob.com/
 */

function CylinderGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {

	Geometry.call( this );

	this.type = 'CylinderGeometry';

	this.parameters = {
		radiusTop: radiusTop,
		radiusBottom: radiusBottom,
		height: height,
		radialSegments: radialSegments,
		heightSegments: heightSegments,
		openEnded: openEnded,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

	this.fromBufferGeometry( new CylinderBufferGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) );
	this.mergeVertices();

}

CylinderGeometry.prototype = Object.create( Geometry.prototype );
CylinderGeometry.prototype.constructor = CylinderGeometry;

/**
 * @author abelnation / http://github.com/abelnation
 */

function ConeGeometry( radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {

	CylinderGeometry.call( this, 0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength );

	this.type = 'ConeGeometry';

	this.parameters = {
		radius: radius,
		height: height,
		radialSegments: radialSegments,
		heightSegments: heightSegments,
		openEnded: openEnded,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

}

ConeGeometry.prototype = Object.create( CylinderGeometry.prototype );
ConeGeometry.prototype.constructor = ConeGeometry;

/**
 * @author: abelnation / http://github.com/abelnation
 */

function ConeBufferGeometry( radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {

	CylinderBufferGeometry.call( this, 0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength );

	this.type = 'ConeBufferGeometry';

	this.parameters = {
		radius: radius,
		height: height,
		radialSegments: radialSegments,
		heightSegments: heightSegments,
		openEnded: openEnded,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

}

ConeBufferGeometry.prototype = Object.create( CylinderBufferGeometry.prototype );
ConeBufferGeometry.prototype.constructor = ConeBufferGeometry;

/**
 * @author benaadams / https://twitter.com/ben_a_adams
 */

function CircleBufferGeometry( radius, segments, thetaStart, thetaLength ) {

	BufferGeometry.call( this );

	this.type = 'CircleBufferGeometry';

	this.parameters = {
		radius: radius,
		segments: segments,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

	radius = radius || 50;
	segments = segments !== undefined ? Math.max( 3, segments ) : 8;

	thetaStart = thetaStart !== undefined ? thetaStart : 0;
	thetaLength = thetaLength !== undefined ? thetaLength : Math.PI * 2;

	var vertices = segments + 2;

	var positions = new Float32Array( vertices * 3 );
	var normals = new Float32Array( vertices * 3 );
	var uvs = new Float32Array( vertices * 2 );

	// center data is already zero, but need to set a few extras
	normals[ 2 ] = 1.0;
	uvs[ 0 ] = 0.5;
	uvs[ 1 ] = 0.5;

	for ( var s = 0, i = 3, ii = 2 ; s <= segments; s ++, i += 3, ii += 2 ) {

		var segment = thetaStart + s / segments * thetaLength;

		positions[ i ] = radius * Math.cos( segment );
		positions[ i + 1 ] = radius * Math.sin( segment );

		normals[ i + 2 ] = 1; // normal z

		uvs[ ii ] = ( positions[ i ] / radius + 1 ) / 2;
		uvs[ ii + 1 ] = ( positions[ i + 1 ] / radius + 1 ) / 2;

	}

	var indices = [];

	for ( var i = 1; i <= segments; i ++ ) {

		indices.push( i, i + 1, 0 );

	}

	this.setIndex( new BufferAttribute( new Uint16Array( indices ), 1 ) );
	this.addAttribute( 'position', new BufferAttribute( positions, 3 ) );
	this.addAttribute( 'normal', new BufferAttribute( normals, 3 ) );
	this.addAttribute( 'uv', new BufferAttribute( uvs, 2 ) );

	this.boundingSphere = new Sphere( new Vector3(), radius );

}

CircleBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
CircleBufferGeometry.prototype.constructor = CircleBufferGeometry;

/**
 * @author hughes
 */

function CircleGeometry( radius, segments, thetaStart, thetaLength ) {

	Geometry.call( this );

	this.type = 'CircleGeometry';

	this.parameters = {
		radius: radius,
		segments: segments,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

	this.fromBufferGeometry( new CircleBufferGeometry( radius, segments, thetaStart, thetaLength ) );

}

CircleGeometry.prototype = Object.create( Geometry.prototype );
CircleGeometry.prototype.constructor = CircleGeometry;

/**
 * @author mrdoob / http://mrdoob.com/
 * based on http://papervision3d.googlecode.com/svn/trunk/as3/trunk/src/org/papervision3d/objects/primitives/Cube.as
 */

function BoxGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) {

	Geometry.call( this );

	this.type = 'BoxGeometry';

	this.parameters = {
		width: width,
		height: height,
		depth: depth,
		widthSegments: widthSegments,
		heightSegments: heightSegments,
		depthSegments: depthSegments
	};

	this.fromBufferGeometry( new BoxBufferGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) );
	this.mergeVertices();

}

BoxGeometry.prototype = Object.create( Geometry.prototype );
BoxGeometry.prototype.constructor = BoxGeometry;



var Geometries = Object.freeze({
	WireframeGeometry: WireframeGeometry,
	ParametricGeometry: ParametricGeometry,
	ParametricBufferGeometry: ParametricBufferGeometry,
	TetrahedronGeometry: TetrahedronGeometry,
	TetrahedronBufferGeometry: TetrahedronBufferGeometry,
	OctahedronGeometry: OctahedronGeometry,
	OctahedronBufferGeometry: OctahedronBufferGeometry,
	IcosahedronGeometry: IcosahedronGeometry,
	IcosahedronBufferGeometry: IcosahedronBufferGeometry,
	DodecahedronGeometry: DodecahedronGeometry,
	DodecahedronBufferGeometry: DodecahedronBufferGeometry,
	PolyhedronGeometry: PolyhedronGeometry,
	PolyhedronBufferGeometry: PolyhedronBufferGeometry,
	TubeGeometry: TubeGeometry,
	TubeBufferGeometry: TubeBufferGeometry,
	TorusKnotGeometry: TorusKnotGeometry,
	TorusKnotBufferGeometry: TorusKnotBufferGeometry,
	TorusGeometry: TorusGeometry,
	TorusBufferGeometry: TorusBufferGeometry,
	TextGeometry: TextGeometry,
	SphereBufferGeometry: SphereBufferGeometry,
	SphereGeometry: SphereGeometry,
	RingGeometry: RingGeometry,
	RingBufferGeometry: RingBufferGeometry,
	PlaneBufferGeometry: PlaneBufferGeometry,
	PlaneGeometry: PlaneGeometry,
	LatheGeometry: LatheGeometry,
	LatheBufferGeometry: LatheBufferGeometry,
	ShapeGeometry: ShapeGeometry,
	ShapeBufferGeometry: ShapeBufferGeometry,
	ExtrudeGeometry: ExtrudeGeometry,
	EdgesGeometry: EdgesGeometry,
	ConeGeometry: ConeGeometry,
	ConeBufferGeometry: ConeBufferGeometry,
	CylinderGeometry: CylinderGeometry,
	CylinderBufferGeometry: CylinderBufferGeometry,
	CircleBufferGeometry: CircleBufferGeometry,
	CircleGeometry: CircleGeometry,
	BoxBufferGeometry: BoxBufferGeometry,
	BoxGeometry: BoxGeometry
});

/**
 * @author mrdoob / http://mrdoob.com/
 */

function ShadowMaterial() {

	ShaderMaterial.call( this, {
		uniforms: UniformsUtils.merge( [
			UniformsLib.lights,
			{
				opacity: { value: 1.0 }
			}
		] ),
		vertexShader: ShaderChunk[ 'shadow_vert' ],
		fragmentShader: ShaderChunk[ 'shadow_frag' ]
	} );

	this.lights = true;
	this.transparent = true;

	Object.defineProperties( this, {
		opacity: {
			enumerable: true,
			get: function () {
				return this.uniforms.opacity.value;
			},
			set: function ( value ) {
				this.uniforms.opacity.value = value;
			}
		}
	} );

}

ShadowMaterial.prototype = Object.create( ShaderMaterial.prototype );
ShadowMaterial.prototype.constructor = ShadowMaterial;

ShadowMaterial.prototype.isShadowMaterial = true;

/**
 * @author mrdoob / http://mrdoob.com/
 */

function RawShaderMaterial( parameters ) {

	ShaderMaterial.call( this, parameters );

	this.type = 'RawShaderMaterial';

}

RawShaderMaterial.prototype = Object.create( ShaderMaterial.prototype );
RawShaderMaterial.prototype.constructor = RawShaderMaterial;

RawShaderMaterial.prototype.isRawShaderMaterial = true;

/**
 * @author mrdoob / http://mrdoob.com/
 */

function MultiMaterial( materials ) {

	this.uuid = _Math.generateUUID();

	this.type = 'MultiMaterial';

	this.materials = Array.isArray( materials ) ? materials : [];

	this.visible = true;

}

MultiMaterial.prototype = {

	constructor: MultiMaterial,

	isMultiMaterial: true,

	toJSON: function ( meta ) {

		var output = {
			metadata: {
				version: 4.2,
				type: 'material',
				generator: 'MaterialExporter'
			},
			uuid: this.uuid,
			type: this.type,
			materials: []
		};

		var materials = this.materials;

		for ( var i = 0, l = materials.length; i < l; i ++ ) {

			var material = materials[ i ].toJSON( meta );
			delete material.metadata;

			output.materials.push( material );

		}

		output.visible = this.visible;

		return output;

	},

	clone: function () {

		var material = new this.constructor();

		for ( var i = 0; i < this.materials.length; i ++ ) {

			material.materials.push( this.materials[ i ].clone() );

		}

		material.visible = this.visible;

		return material;

	}

};

/**
 * @author WestLangley / http://github.com/WestLangley
 *
 * parameters = {
 *  color: <hex>,
 *  roughness: <float>,
 *  metalness: <float>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  roughnessMap: new THREE.Texture( <Image> ),
 *
 *  metalnessMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  envMapIntensity: <float>
 *
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */

function MeshStandardMaterial( parameters ) {

	Material.call( this );

	this.defines = { 'STANDARD': '' };

	this.type = 'MeshStandardMaterial';

	this.color = new Color( 0xffffff ); // diffuse
	this.roughness = 0.5;
	this.metalness = 0.5;

	this.map = null;

	this.lightMap = null;
	this.lightMapIntensity = 1.0;

	this.aoMap = null;
	this.aoMapIntensity = 1.0;

	this.emissive = new Color( 0x000000 );
	this.emissiveIntensity = 1.0;
	this.emissiveMap = null;

	this.bumpMap = null;
	this.bumpScale = 1;

	this.normalMap = null;
	this.normalScale = new Vector2( 1, 1 );

	this.displacementMap = null;
	this.displacementScale = 1;
	this.displacementBias = 0;

	this.roughnessMap = null;

	this.metalnessMap = null;

	this.alphaMap = null;

	this.envMap = null;
	this.envMapIntensity = 1.0;

	this.refractionRatio = 0.98;

	this.wireframe = false;
	this.wireframeLinewidth = 1;
	this.wireframeLinecap = 'round';
	this.wireframeLinejoin = 'round';

	this.skinning = false;
	this.morphTargets = false;
	this.morphNormals = false;

	this.setValues( parameters );

}

MeshStandardMaterial.prototype = Object.create( Material.prototype );
MeshStandardMaterial.prototype.constructor = MeshStandardMaterial;

MeshStandardMaterial.prototype.isMeshStandardMaterial = true;

MeshStandardMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.defines = { 'STANDARD': '' };

	this.color.copy( source.color );
	this.roughness = source.roughness;
	this.metalness = source.metalness;

	this.map = source.map;

	this.lightMap = source.lightMap;
	this.lightMapIntensity = source.lightMapIntensity;

	this.aoMap = source.aoMap;
	this.aoMapIntensity = source.aoMapIntensity;

	this.emissive.copy( source.emissive );
	this.emissiveMap = source.emissiveMap;
	this.emissiveIntensity = source.emissiveIntensity;

	this.bumpMap = source.bumpMap;
	this.bumpScale = source.bumpScale;

	this.normalMap = source.normalMap;
	this.normalScale.copy( source.normalScale );

	this.displacementMap = source.displacementMap;
	this.displacementScale = source.displacementScale;
	this.displacementBias = source.displacementBias;

	this.roughnessMap = source.roughnessMap;

	this.metalnessMap = source.metalnessMap;

	this.alphaMap = source.alphaMap;

	this.envMap = source.envMap;
	this.envMapIntensity = source.envMapIntensity;

	this.refractionRatio = source.refractionRatio;

	this.wireframe = source.wireframe;
	this.wireframeLinewidth = source.wireframeLinewidth;
	this.wireframeLinecap = source.wireframeLinecap;
	this.wireframeLinejoin = source.wireframeLinejoin;

	this.skinning = source.skinning;
	this.morphTargets = source.morphTargets;
	this.morphNormals = source.morphNormals;

	return this;

};

/**
 * @author WestLangley / http://github.com/WestLangley
 *
 * parameters = {
 *  reflectivity: <float>
 * }
 */

function MeshPhysicalMaterial( parameters ) {

	MeshStandardMaterial.call( this );

	this.defines = { 'PHYSICAL': '' };

	this.type = 'MeshPhysicalMaterial';

	this.reflectivity = 0.5; // maps to F0 = 0.04

	this.clearCoat = 0.0;
	this.clearCoatRoughness = 0.0;

	this.setValues( parameters );

}

MeshPhysicalMaterial.prototype = Object.create( MeshStandardMaterial.prototype );
MeshPhysicalMaterial.prototype.constructor = MeshPhysicalMaterial;

MeshPhysicalMaterial.prototype.isMeshPhysicalMaterial = true;

MeshPhysicalMaterial.prototype.copy = function ( source ) {

	MeshStandardMaterial.prototype.copy.call( this, source );

	this.defines = { 'PHYSICAL': '' };

	this.reflectivity = source.reflectivity;

	this.clearCoat = source.clearCoat;
	this.clearCoatRoughness = source.clearCoatRoughness;

	return this;

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  color: <hex>,
 *  specular: <hex>,
 *  shininess: <float>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */

function MeshPhongMaterial( parameters ) {

	Material.call( this );

	this.type = 'MeshPhongMaterial';

	this.color = new Color( 0xffffff ); // diffuse
	this.specular = new Color( 0x111111 );
	this.shininess = 30;

	this.map = null;

	this.lightMap = null;
	this.lightMapIntensity = 1.0;

	this.aoMap = null;
	this.aoMapIntensity = 1.0;

	this.emissive = new Color( 0x000000 );
	this.emissiveIntensity = 1.0;
	this.emissiveMap = null;

	this.bumpMap = null;
	this.bumpScale = 1;

	this.normalMap = null;
	this.normalScale = new Vector2( 1, 1 );

	this.displacementMap = null;
	this.displacementScale = 1;
	this.displacementBias = 0;

	this.specularMap = null;

	this.alphaMap = null;

	this.envMap = null;
	this.combine = MultiplyOperation;
	this.reflectivity = 1;
	this.refractionRatio = 0.98;

	this.wireframe = false;
	this.wireframeLinewidth = 1;
	this.wireframeLinecap = 'round';
	this.wireframeLinejoin = 'round';

	this.skinning = false;
	this.morphTargets = false;
	this.morphNormals = false;

	this.setValues( parameters );

}

MeshPhongMaterial.prototype = Object.create( Material.prototype );
MeshPhongMaterial.prototype.constructor = MeshPhongMaterial;

MeshPhongMaterial.prototype.isMeshPhongMaterial = true;

MeshPhongMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.color.copy( source.color );
	this.specular.copy( source.specular );
	this.shininess = source.shininess;

	this.map = source.map;

	this.lightMap = source.lightMap;
	this.lightMapIntensity = source.lightMapIntensity;

	this.aoMap = source.aoMap;
	this.aoMapIntensity = source.aoMapIntensity;

	this.emissive.copy( source.emissive );
	this.emissiveMap = source.emissiveMap;
	this.emissiveIntensity = source.emissiveIntensity;

	this.bumpMap = source.bumpMap;
	this.bumpScale = source.bumpScale;

	this.normalMap = source.normalMap;
	this.normalScale.copy( source.normalScale );

	this.displacementMap = source.displacementMap;
	this.displacementScale = source.displacementScale;
	this.displacementBias = source.displacementBias;

	this.specularMap = source.specularMap;

	this.alphaMap = source.alphaMap;

	this.envMap = source.envMap;
	this.combine = source.combine;
	this.reflectivity = source.reflectivity;
	this.refractionRatio = source.refractionRatio;

	this.wireframe = source.wireframe;
	this.wireframeLinewidth = source.wireframeLinewidth;
	this.wireframeLinecap = source.wireframeLinecap;
	this.wireframeLinejoin = source.wireframeLinejoin;

	this.skinning = source.skinning;
	this.morphTargets = source.morphTargets;
	this.morphNormals = source.morphNormals;

	return this;

};

/**
 * @author takahirox / http://github.com/takahirox
 *
 * parameters = {
 *  gradientMap: new THREE.Texture( <Image> )
 * }
 */

function MeshToonMaterial( parameters ) {

	MeshPhongMaterial.call( this );

	this.defines = { 'TOON': '' };

	this.type = 'MeshToonMaterial';

	this.gradientMap = null;

	this.setValues( parameters );

}

MeshToonMaterial.prototype = Object.create( MeshPhongMaterial.prototype );
MeshToonMaterial.prototype.constructor = MeshToonMaterial;

MeshToonMaterial.prototype.isMeshToonMaterial = true;

MeshToonMaterial.prototype.copy = function ( source ) {

	MeshPhongMaterial.prototype.copy.call( this, source );

	this.gradientMap = source.gradientMap;

	return this;

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author WestLangley / http://github.com/WestLangley
 *
 * parameters = {
 *  opacity: <float>,
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */

function MeshNormalMaterial( parameters ) {

	Material.call( this, parameters );

	this.type = 'MeshNormalMaterial';

	this.bumpMap = null;
	this.bumpScale = 1;

	this.normalMap = null;
	this.normalScale = new Vector2( 1, 1 );

	this.displacementMap = null;
	this.displacementScale = 1;
	this.displacementBias = 0;

	this.wireframe = false;
	this.wireframeLinewidth = 1;

	this.fog = false;
	this.lights = false;

	this.skinning = false;
	this.morphTargets = false;
	this.morphNormals = false;

	this.setValues( parameters );

}

MeshNormalMaterial.prototype = Object.create( Material.prototype );
MeshNormalMaterial.prototype.constructor = MeshNormalMaterial;

MeshNormalMaterial.prototype.isMeshNormalMaterial = true;

MeshNormalMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.bumpMap = source.bumpMap;
	this.bumpScale = source.bumpScale;

	this.normalMap = source.normalMap;
	this.normalScale.copy( source.normalScale );

	this.displacementMap = source.displacementMap;
	this.displacementScale = source.displacementScale;
	this.displacementBias = source.displacementBias;

	this.wireframe = source.wireframe;
	this.wireframeLinewidth = source.wireframeLinewidth;

	this.skinning = source.skinning;
	this.morphTargets = source.morphTargets;
	this.morphNormals = source.morphNormals;

	return this;

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */

function MeshLambertMaterial( parameters ) {

	Material.call( this );

	this.type = 'MeshLambertMaterial';

	this.color = new Color( 0xffffff ); // diffuse

	this.map = null;

	this.lightMap = null;
	this.lightMapIntensity = 1.0;

	this.aoMap = null;
	this.aoMapIntensity = 1.0;

	this.emissive = new Color( 0x000000 );
	this.emissiveIntensity = 1.0;
	this.emissiveMap = null;

	this.specularMap = null;

	this.alphaMap = null;

	this.envMap = null;
	this.combine = MultiplyOperation;
	this.reflectivity = 1;
	this.refractionRatio = 0.98;

	this.wireframe = false;
	this.wireframeLinewidth = 1;
	this.wireframeLinecap = 'round';
	this.wireframeLinejoin = 'round';

	this.skinning = false;
	this.morphTargets = false;
	this.morphNormals = false;

	this.setValues( parameters );

}

MeshLambertMaterial.prototype = Object.create( Material.prototype );
MeshLambertMaterial.prototype.constructor = MeshLambertMaterial;

MeshLambertMaterial.prototype.isMeshLambertMaterial = true;

MeshLambertMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.color.copy( source.color );

	this.map = source.map;

	this.lightMap = source.lightMap;
	this.lightMapIntensity = source.lightMapIntensity;

	this.aoMap = source.aoMap;
	this.aoMapIntensity = source.aoMapIntensity;

	this.emissive.copy( source.emissive );
	this.emissiveMap = source.emissiveMap;
	this.emissiveIntensity = source.emissiveIntensity;

	this.specularMap = source.specularMap;

	this.alphaMap = source.alphaMap;

	this.envMap = source.envMap;
	this.combine = source.combine;
	this.reflectivity = source.reflectivity;
	this.refractionRatio = source.refractionRatio;

	this.wireframe = source.wireframe;
	this.wireframeLinewidth = source.wireframeLinewidth;
	this.wireframeLinecap = source.wireframeLinecap;
	this.wireframeLinejoin = source.wireframeLinejoin;

	this.skinning = source.skinning;
	this.morphTargets = source.morphTargets;
	this.morphNormals = source.morphNormals;

	return this;

};

/**
 * @author alteredq / http://alteredqualia.com/
 *
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  linewidth: <float>,
 *
 *  scale: <float>,
 *  dashSize: <float>,
 *  gapSize: <float>
 * }
 */

function LineDashedMaterial( parameters ) {

	Material.call( this );

	this.type = 'LineDashedMaterial';

	this.color = new Color( 0xffffff );

	this.linewidth = 1;

	this.scale = 1;
	this.dashSize = 3;
	this.gapSize = 1;

	this.lights = false;

	this.setValues( parameters );

}

LineDashedMaterial.prototype = Object.create( Material.prototype );
LineDashedMaterial.prototype.constructor = LineDashedMaterial;

LineDashedMaterial.prototype.isLineDashedMaterial = true;

LineDashedMaterial.prototype.copy = function ( source ) {

	Material.prototype.copy.call( this, source );

	this.color.copy( source.color );

	this.linewidth = source.linewidth;

	this.scale = source.scale;
	this.dashSize = source.dashSize;
	this.gapSize = source.gapSize;

	return this;

};



var Materials = Object.freeze({
	ShadowMaterial: ShadowMaterial,
	SpriteMaterial: SpriteMaterial,
	RawShaderMaterial: RawShaderMaterial,
	ShaderMaterial: ShaderMaterial,
	PointsMaterial: PointsMaterial,
	MultiMaterial: MultiMaterial,
	MeshPhysicalMaterial: MeshPhysicalMaterial,
	MeshStandardMaterial: MeshStandardMaterial,
	MeshPhongMaterial: MeshPhongMaterial,
	MeshToonMaterial: MeshToonMaterial,
	MeshNormalMaterial: MeshNormalMaterial,
	MeshLambertMaterial: MeshLambertMaterial,
	MeshDepthMaterial: MeshDepthMaterial,
	MeshBasicMaterial: MeshBasicMaterial,
	LineDashedMaterial: LineDashedMaterial,
	LineBasicMaterial: LineBasicMaterial,
	Material: Material
});

/**
 * @author mrdoob / http://mrdoob.com/
 */

var Cache = {

	enabled: false,

	files: {},

	add: function ( key, file ) {

		if ( this.enabled === false ) return;

		// console.log( 'THREE.Cache', 'Adding key:', key );

		this.files[ key ] = file;

	},

	get: function ( key ) {

		if ( this.enabled === false ) return;

		// console.log( 'THREE.Cache', 'Checking key:', key );

		return this.files[ key ];

	},

	remove: function ( key ) {

		delete this.files[ key ];

	},

	clear: function () {

		this.files = {};

	}

};

/**
 * @author mrdoob / http://mrdoob.com/
 */

function LoadingManager( onLoad, onProgress, onError ) {

	var scope = this;

	var isLoading = false, itemsLoaded = 0, itemsTotal = 0;

	this.onStart = undefined;
	this.onLoad = onLoad;
	this.onProgress = onProgress;
	this.onError = onError;

	this.itemStart = function ( url ) {

		itemsTotal ++;

		if ( isLoading === false ) {

			if ( scope.onStart !== undefined ) {

				scope.onStart( url, itemsLoaded, itemsTotal );

			}

		}

		isLoading = true;

	};

	this.itemEnd = function ( url ) {

		itemsLoaded ++;

		if ( scope.onProgress !== undefined ) {

			scope.onProgress( url, itemsLoaded, itemsTotal );

		}

		if ( itemsLoaded === itemsTotal ) {

			isLoading = false;

			if ( scope.onLoad !== undefined ) {

				scope.onLoad();

			}

		}

	};

	this.itemError = function ( url ) {

		if ( scope.onError !== undefined ) {

			scope.onError( url );

		}

	};

}

var DefaultLoadingManager = new LoadingManager();

/**
 * @author mrdoob / http://mrdoob.com/
 */

function FileLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

}

Object.assign( FileLoader.prototype, {

	load: function ( url, onLoad, onProgress, onError ) {

		if ( url === undefined ) url = '';

		if ( this.path !== undefined ) url = this.path + url;

		var scope = this;

		var cached = Cache.get( url );

		if ( cached !== undefined ) {

			scope.manager.itemStart( url );

			setTimeout( function () {

				if ( onLoad ) onLoad( cached );

				scope.manager.itemEnd( url );

			}, 0 );

			return cached;

		}

		// Check for data: URI
		var dataUriRegex = /^data:(.*?)(;base64)?,(.*)$/;
		var dataUriRegexResult = url.match( dataUriRegex );

		// Safari can not handle Data URIs through XMLHttpRequest so process manually
		if ( dataUriRegexResult ) {

			var mimeType = dataUriRegexResult[ 1 ];
			var isBase64 = !! dataUriRegexResult[ 2 ];
			var data = dataUriRegexResult[ 3 ];

			data = window.decodeURIComponent( data );

			if ( isBase64 ) data = window.atob( data );

			try {

				var response;
				var responseType = ( this.responseType || '' ).toLowerCase();

				switch ( responseType ) {

					case 'arraybuffer':
					case 'blob':

					 	response = new ArrayBuffer( data.length );

						var view = new Uint8Array( response );

						for ( var i = 0; i < data.length; i ++ ) {

							view[ i ] = data.charCodeAt( i );

						}

						if ( responseType === 'blob' ) {

							response = new Blob( [ response ], { type: mimeType } );

						}

						break;

					case 'document':

						var parser = new DOMParser();
						response = parser.parseFromString( data, mimeType );

						break;

					case 'json':

						response = JSON.parse( data );

						break;

					default: // 'text' or other

						response = data;

						break;

				}

				// Wait for next browser tick
				window.setTimeout( function () {

					if ( onLoad ) onLoad( response );

					scope.manager.itemEnd( url );

				}, 0 );

			} catch ( error ) {

				// Wait for next browser tick
				window.setTimeout( function () {

					if ( onError ) onError( error );

					scope.manager.itemError( url );

				}, 0 );

			}

		} else {

			var request = new XMLHttpRequest();
			request.open( 'GET', url, true );

			request.addEventListener( 'load', function ( event ) {

				var response = event.target.response;

				Cache.add( url, response );

				if ( this.status === 200 ) {

					if ( onLoad ) onLoad( response );

					scope.manager.itemEnd( url );

				} else if ( this.status === 0 ) {

					// Some browsers return HTTP Status 0 when using non-http protocol
					// e.g. 'file://' or 'data://'. Handle as success.

					console.warn( 'THREE.FileLoader: HTTP Status 0 received.' );

					if ( onLoad ) onLoad( response );

					scope.manager.itemEnd( url );

				} else {

					if ( onError ) onError( event );

					scope.manager.itemError( url );

				}

			}, false );

			if ( onProgress !== undefined ) {

				request.addEventListener( 'progress', function ( event ) {

					onProgress( event );

				}, false );

			}

			request.addEventListener( 'error', function ( event ) {

				if ( onError ) onError( event );

				scope.manager.itemError( url );

			}, false );

			if ( this.responseType !== undefined ) request.responseType = this.responseType;
			if ( this.withCredentials !== undefined ) request.withCredentials = this.withCredentials;

			if ( request.overrideMimeType ) request.overrideMimeType( this.mimeType !== undefined ? this.mimeType : 'text/plain' );

			request.send( null );

		}

		scope.manager.itemStart( url );

		return request;

	},

	setPath: function ( value ) {

		this.path = value;
		return this;

	},

	setResponseType: function ( value ) {

		this.responseType = value;
		return this;

	},

	setWithCredentials: function ( value ) {

		this.withCredentials = value;
		return this;

	},

	setMimeType: function ( value ) {

		this.mimeType = value;
		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 *
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 */

function CompressedTextureLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

	// override in sub classes
	this._parser = null;

}

Object.assign( CompressedTextureLoader.prototype, {

	load: function ( url, onLoad, onProgress, onError ) {

		var scope = this;

		var images = [];

		var texture = new CompressedTexture();
		texture.image = images;

		var loader = new FileLoader( this.manager );
		loader.setPath( this.path );
		loader.setResponseType( 'arraybuffer' );

		function loadTexture( i ) {

			loader.load( url[ i ], function ( buffer ) {

				var texDatas = scope._parser( buffer, true );

				images[ i ] = {
					width: texDatas.width,
					height: texDatas.height,
					format: texDatas.format,
					mipmaps: texDatas.mipmaps
				};

				loaded += 1;

				if ( loaded === 6 ) {

					if ( texDatas.mipmapCount === 1 )
						texture.minFilter = LinearFilter;

					texture.format = texDatas.format;
					texture.needsUpdate = true;

					if ( onLoad ) onLoad( texture );

				}

			}, onProgress, onError );

		}

		if ( Array.isArray( url ) ) {

			var loaded = 0;

			for ( var i = 0, il = url.length; i < il; ++ i ) {

				loadTexture( i );

			}

		} else {

			// compressed cubemap texture stored in a single DDS file

			loader.load( url, function ( buffer ) {

				var texDatas = scope._parser( buffer, true );

				if ( texDatas.isCubemap ) {

					var faces = texDatas.mipmaps.length / texDatas.mipmapCount;

					for ( var f = 0; f < faces; f ++ ) {

						images[ f ] = { mipmaps : [] };

						for ( var i = 0; i < texDatas.mipmapCount; i ++ ) {

							images[ f ].mipmaps.push( texDatas.mipmaps[ f * texDatas.mipmapCount + i ] );
							images[ f ].format = texDatas.format;
							images[ f ].width = texDatas.width;
							images[ f ].height = texDatas.height;

						}

					}

				} else {

					texture.image.width = texDatas.width;
					texture.image.height = texDatas.height;
					texture.mipmaps = texDatas.mipmaps;

				}

				if ( texDatas.mipmapCount === 1 ) {

					texture.minFilter = LinearFilter;

				}

				texture.format = texDatas.format;
				texture.needsUpdate = true;

				if ( onLoad ) onLoad( texture );

			}, onProgress, onError );

		}

		return texture;

	},

	setPath: function ( value ) {

		this.path = value;
		return this;

	}

} );

/**
 * @author Nikos M. / https://github.com/foo123/
 *
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 */

var DataTextureLoader = BinaryTextureLoader;
function BinaryTextureLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

	// override in sub classes
	this._parser = null;

}

Object.assign( BinaryTextureLoader.prototype, {

	load: function ( url, onLoad, onProgress, onError ) {

		var scope = this;

		var texture = new DataTexture();

		var loader = new FileLoader( this.manager );
		loader.setResponseType( 'arraybuffer' );

		loader.load( url, function ( buffer ) {

			var texData = scope._parser( buffer );

			if ( ! texData ) return;

			if ( undefined !== texData.image ) {

				texture.image = texData.image;

			} else if ( undefined !== texData.data ) {

				texture.image.width = texData.width;
				texture.image.height = texData.height;
				texture.image.data = texData.data;

			}

			texture.wrapS = undefined !== texData.wrapS ? texData.wrapS : ClampToEdgeWrapping;
			texture.wrapT = undefined !== texData.wrapT ? texData.wrapT : ClampToEdgeWrapping;

			texture.magFilter = undefined !== texData.magFilter ? texData.magFilter : LinearFilter;
			texture.minFilter = undefined !== texData.minFilter ? texData.minFilter : LinearMipMapLinearFilter;

			texture.anisotropy = undefined !== texData.anisotropy ? texData.anisotropy : 1;

			if ( undefined !== texData.format ) {

				texture.format = texData.format;

			}
			if ( undefined !== texData.type ) {

				texture.type = texData.type;

			}

			if ( undefined !== texData.mipmaps ) {

				texture.mipmaps = texData.mipmaps;

			}

			if ( 1 === texData.mipmapCount ) {

				texture.minFilter = LinearFilter;

			}

			texture.needsUpdate = true;

			if ( onLoad ) onLoad( texture, texData );

		}, onProgress, onError );


		return texture;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function ImageLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

}

Object.assign( ImageLoader.prototype, {

	load: function ( url, onLoad, onProgress, onError ) {

		var scope = this;

		var image = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'img' );
		image.onload = function () {

			image.onload = null;

			URL.revokeObjectURL( image.src );

			if ( onLoad ) onLoad( image );

			scope.manager.itemEnd( url );

		};
		image.onerror = onError;

		if ( url.indexOf( 'data:' ) === 0 ) {

			image.src = url;

		} else if ( this.crossOrigin !== undefined ) {

			// crossOrigin doesn't work with URL.createObjectURL()?

			image.crossOrigin = this.crossOrigin;
			image.src = url;

		} else {

			var loader = new FileLoader();
			loader.setPath( this.path );
			loader.setResponseType( 'blob' );
			loader.setWithCredentials( this.withCredentials );
			loader.load( url, function ( blob ) {

				image.src = URL.createObjectURL( blob );

			}, onProgress, onError );

		}

		scope.manager.itemStart( url );

		return image;

	},

	setCrossOrigin: function ( value ) {

		this.crossOrigin = value;
		return this;

	},

	setWithCredentials: function ( value ) {

		this.withCredentials = value;
		return this;

	},

	setPath: function ( value ) {

		this.path = value;
		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function CubeTextureLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

}

Object.assign( CubeTextureLoader.prototype, {

	load: function ( urls, onLoad, onProgress, onError ) {

		var texture = new CubeTexture();

		var loader = new ImageLoader( this.manager );
		loader.setCrossOrigin( this.crossOrigin );
		loader.setPath( this.path );

		var loaded = 0;

		function loadTexture( i ) {

			loader.load( urls[ i ], function ( image ) {

				texture.images[ i ] = image;

				loaded ++;

				if ( loaded === 6 ) {

					texture.needsUpdate = true;

					if ( onLoad ) onLoad( texture );

				}

			}, undefined, onError );

		}

		for ( var i = 0; i < urls.length; ++ i ) {

			loadTexture( i );

		}

		return texture;

	},

	setCrossOrigin: function ( value ) {

		this.crossOrigin = value;
		return this;

	},

	setPath: function ( value ) {

		this.path = value;
		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function TextureLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

}

Object.assign( TextureLoader.prototype, {

	load: function ( url, onLoad, onProgress, onError ) {

		var texture = new Texture();

		var loader = new ImageLoader( this.manager );
		loader.setCrossOrigin( this.crossOrigin );
		loader.setWithCredentials( this.withCredentials );
		loader.setPath( this.path );
		loader.load( url, function ( image ) {

			// JPEGs can't have an alpha channel, so memory can be saved by storing them as RGB.
			var isJPEG = url.search( /\.(jpg|jpeg)$/ ) > 0 || url.search( /^data\:image\/jpeg/ ) === 0;

			texture.format = isJPEG ? RGBFormat : RGBAFormat;
			texture.image = image;
			texture.needsUpdate = true;

			if ( onLoad !== undefined ) {

				onLoad( texture );

			}

		}, onProgress, onError );

		return texture;

	},

	setCrossOrigin: function ( value ) {

		this.crossOrigin = value;
		return this;

	},

	setWithCredentials: function ( value ) {

		this.withCredentials = value;
		return this;

	},

	setPath: function ( value ) {

		this.path = value;
		return this;

	}



} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 */

function Light( color, intensity ) {

	Object3D.call( this );

	this.type = 'Light';

	this.color = new Color( color );
	this.intensity = intensity !== undefined ? intensity : 1;

	this.receiveShadow = undefined;

}

Light.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: Light,

	isLight: true,

	copy: function ( source ) {

		Object3D.prototype.copy.call( this, source );

		this.color.copy( source.color );
		this.intensity = source.intensity;

		return this;

	},

	toJSON: function ( meta ) {

		var data = Object3D.prototype.toJSON.call( this, meta );

		data.object.color = this.color.getHex();
		data.object.intensity = this.intensity;

		if ( this.groundColor !== undefined ) data.object.groundColor = this.groundColor.getHex();

		if ( this.distance !== undefined ) data.object.distance = this.distance;
		if ( this.angle !== undefined ) data.object.angle = this.angle;
		if ( this.decay !== undefined ) data.object.decay = this.decay;
		if ( this.penumbra !== undefined ) data.object.penumbra = this.penumbra;

		if ( this.shadow !== undefined ) data.object.shadow = this.shadow.toJSON();

		return data;

	}

} );

/**
 * @author alteredq / http://alteredqualia.com/
 */

function HemisphereLight( skyColor, groundColor, intensity ) {

	Light.call( this, skyColor, intensity );

	this.type = 'HemisphereLight';

	this.castShadow = undefined;

	this.position.copy( Object3D.DefaultUp );
	this.updateMatrix();

	this.groundColor = new Color( groundColor );

}

HemisphereLight.prototype = Object.assign( Object.create( Light.prototype ), {

	constructor: HemisphereLight,

	isHemisphereLight: true,

	copy: function ( source ) {

		Light.prototype.copy.call( this, source );

		this.groundColor.copy( source.groundColor );

		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function LightShadow( camera ) {

	this.camera = camera;

	this.bias = 0;
	this.radius = 1;

	this.mapSize = new Vector2( 512, 512 );

	this.map = null;
	this.matrix = new Matrix4();

}

Object.assign( LightShadow.prototype, {

	copy: function ( source ) {

		this.camera = source.camera.clone();

		this.bias = source.bias;
		this.radius = source.radius;

		this.mapSize.copy( source.mapSize );

		return this;

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	toJSON: function () {

		var object = {};

		if ( this.bias !== 0 ) object.bias = this.bias;
		if ( this.radius !== 1 ) object.radius = this.radius;
		if ( this.mapSize.x !== 512 || this.mapSize.y !== 512 ) object.mapSize = this.mapSize.toArray();

		object.camera = this.camera.toJSON( false ).object;
		delete object.camera.matrix;

		return object;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function SpotLightShadow() {

	LightShadow.call( this, new PerspectiveCamera( 50, 1, 0.5, 500 ) );

}

SpotLightShadow.prototype = Object.assign( Object.create( LightShadow.prototype ), {

	constructor: SpotLightShadow,

	isSpotLightShadow: true,

	update: function ( light ) {

		var fov = _Math.RAD2DEG * 2 * light.angle;
		var aspect = this.mapSize.width / this.mapSize.height;
		var far = light.distance || 500;

		var camera = this.camera;

		if ( fov !== camera.fov || aspect !== camera.aspect || far !== camera.far ) {

			camera.fov = fov;
			camera.aspect = aspect;
			camera.far = far;
			camera.updateProjectionMatrix();

		}

	}

} );

/**
 * @author alteredq / http://alteredqualia.com/
 */

function SpotLight( color, intensity, distance, angle, penumbra, decay ) {

	Light.call( this, color, intensity );

	this.type = 'SpotLight';

	this.position.copy( Object3D.DefaultUp );
	this.updateMatrix();

	this.target = new Object3D();

	Object.defineProperty( this, 'power', {
		get: function () {
			// intensity = power per solid angle.
			// ref: equation (17) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
			return this.intensity * Math.PI;
		},
		set: function ( power ) {
			// intensity = power per solid angle.
			// ref: equation (17) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
			this.intensity = power / Math.PI;
		}
	} );

	this.distance = ( distance !== undefined ) ? distance : 0;
	this.angle = ( angle !== undefined ) ? angle : Math.PI / 3;
	this.penumbra = ( penumbra !== undefined ) ? penumbra : 0;
	this.decay = ( decay !== undefined ) ? decay : 1;	// for physically correct lights, should be 2.

	this.shadow = new SpotLightShadow();

}

SpotLight.prototype = Object.assign( Object.create( Light.prototype ), {

	constructor: SpotLight,

	isSpotLight: true,

	copy: function ( source ) {

		Light.prototype.copy.call( this, source );

		this.distance = source.distance;
		this.angle = source.angle;
		this.penumbra = source.penumbra;
		this.decay = source.decay;

		this.target = source.target.clone();

		this.shadow = source.shadow.clone();

		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */


function PointLight( color, intensity, distance, decay ) {

	Light.call( this, color, intensity );

	this.type = 'PointLight';

	Object.defineProperty( this, 'power', {
		get: function () {
			// intensity = power per solid angle.
			// ref: equation (15) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
			return this.intensity * 4 * Math.PI;

		},
		set: function ( power ) {
			// intensity = power per solid angle.
			// ref: equation (15) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
			this.intensity = power / ( 4 * Math.PI );
		}
	} );

	this.distance = ( distance !== undefined ) ? distance : 0;
	this.decay = ( decay !== undefined ) ? decay : 1;	// for physically correct lights, should be 2.

	this.shadow = new LightShadow( new PerspectiveCamera( 90, 1, 0.5, 500 ) );

}

PointLight.prototype = Object.assign( Object.create( Light.prototype ), {

	constructor: PointLight,

	isPointLight: true,

	copy: function ( source ) {

		Light.prototype.copy.call( this, source );

		this.distance = source.distance;
		this.decay = source.decay;

		this.shadow = source.shadow.clone();

		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function DirectionalLightShadow( light ) {

	LightShadow.call( this, new OrthographicCamera( - 5, 5, 5, - 5, 0.5, 500 ) );

}

DirectionalLightShadow.prototype = Object.assign( Object.create( LightShadow.prototype ), {

	constructor: DirectionalLightShadow

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 */

function DirectionalLight( color, intensity ) {

	Light.call( this, color, intensity );

	this.type = 'DirectionalLight';

	this.position.copy( Object3D.DefaultUp );
	this.updateMatrix();

	this.target = new Object3D();

	this.shadow = new DirectionalLightShadow();

}

DirectionalLight.prototype = Object.assign( Object.create( Light.prototype ), {

	constructor: DirectionalLight,

	isDirectionalLight: true,

	copy: function ( source ) {

		Light.prototype.copy.call( this, source );

		this.target = source.target.clone();

		this.shadow = source.shadow.clone();

		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function AmbientLight( color, intensity ) {

	Light.call( this, color, intensity );

	this.type = 'AmbientLight';

	this.castShadow = undefined;

}

AmbientLight.prototype = Object.assign( Object.create( Light.prototype ), {

	constructor: AmbientLight,

	isAmbientLight: true

} );

/**
 * @author tschw
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 */

var AnimationUtils = {

	// same as Array.prototype.slice, but also works on typed arrays
	arraySlice: function( array, from, to ) {

		if ( AnimationUtils.isTypedArray( array ) ) {

			return new array.constructor( array.subarray( from, to ) );

		}

		return array.slice( from, to );

	},

	// converts an array to a specific type
	convertArray: function( array, type, forceClone ) {

		if ( ! array || // let 'undefined' and 'null' pass
				! forceClone && array.constructor === type ) return array;

		if ( typeof type.BYTES_PER_ELEMENT === 'number' ) {

			return new type( array ); // create typed array

		}

		return Array.prototype.slice.call( array ); // create Array

	},

	isTypedArray: function( object ) {

		return ArrayBuffer.isView( object ) &&
				! ( object instanceof DataView );

	},

	// returns an array by which times and values can be sorted
	getKeyframeOrder: function( times ) {

		function compareTime( i, j ) {

			return times[ i ] - times[ j ];

		}

		var n = times.length;
		var result = new Array( n );
		for ( var i = 0; i !== n; ++ i ) result[ i ] = i;

		result.sort( compareTime );

		return result;

	},

	// uses the array previously returned by 'getKeyframeOrder' to sort data
	sortedArray: function( values, stride, order ) {

		var nValues = values.length;
		var result = new values.constructor( nValues );

		for ( var i = 0, dstOffset = 0; dstOffset !== nValues; ++ i ) {

			var srcOffset = order[ i ] * stride;

			for ( var j = 0; j !== stride; ++ j ) {

				result[ dstOffset ++ ] = values[ srcOffset + j ];

			}

		}

		return result;

	},

	// function for parsing AOS keyframe formats
	flattenJSON: function( jsonKeys, times, values, valuePropertyName ) {

		var i = 1, key = jsonKeys[ 0 ];

		while ( key !== undefined && key[ valuePropertyName ] === undefined ) {

			key = jsonKeys[ i ++ ];

		}

		if ( key === undefined ) return; // no data

		var value = key[ valuePropertyName ];
		if ( value === undefined ) return; // no data

		if ( Array.isArray( value ) ) {

			do {

				value = key[ valuePropertyName ];

				if ( value !== undefined ) {

					times.push( key.time );
					values.push.apply( values, value ); // push all elements

				}

				key = jsonKeys[ i ++ ];

			} while ( key !== undefined );

		} else if ( value.toArray !== undefined ) {
			// ...assume THREE.Math-ish

			do {

				value = key[ valuePropertyName ];

				if ( value !== undefined ) {

					times.push( key.time );
					value.toArray( values, values.length );

				}

				key = jsonKeys[ i ++ ];

			} while ( key !== undefined );

		} else {
			// otherwise push as-is

			do {

				value = key[ valuePropertyName ];

				if ( value !== undefined ) {

					times.push( key.time );
					values.push( value );

				}

				key = jsonKeys[ i ++ ];

			} while ( key !== undefined );

		}

	}

};

/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 * @author tschw
 */

function Interpolant(
		parameterPositions, sampleValues, sampleSize, resultBuffer ) {

	this.parameterPositions = parameterPositions;
	this._cachedIndex = 0;

	this.resultBuffer = resultBuffer !== undefined ?
			resultBuffer : new sampleValues.constructor( sampleSize );
	this.sampleValues = sampleValues;
	this.valueSize = sampleSize;

}

Interpolant.prototype = {

	constructor: Interpolant,

	evaluate: function( t ) {

		var pp = this.parameterPositions,
			i1 = this._cachedIndex,

			t1 = pp[   i1   ],
			t0 = pp[ i1 - 1 ];

		validate_interval: {

			seek: {

				var right;

				linear_scan: {
//- See http://jsperf.com/comparison-to-undefined/3
//- slower code:
//-
//- 				if ( t >= t1 || t1 === undefined ) {
					forward_scan: if ( ! ( t < t1 ) ) {

						for ( var giveUpAt = i1 + 2; ;) {

							if ( t1 === undefined ) {

								if ( t < t0 ) break forward_scan;

								// after end

								i1 = pp.length;
								this._cachedIndex = i1;
								return this.afterEnd_( i1 - 1, t, t0 );

							}

							if ( i1 === giveUpAt ) break; // this loop

							t0 = t1;
							t1 = pp[ ++ i1 ];

							if ( t < t1 ) {

								// we have arrived at the sought interval
								break seek;

							}

						}

						// prepare binary search on the right side of the index
						right = pp.length;
						break linear_scan;

					}

//- slower code:
//-					if ( t < t0 || t0 === undefined ) {
					if ( ! ( t >= t0 ) ) {

						// looping?

						var t1global = pp[ 1 ];

						if ( t < t1global ) {

							i1 = 2; // + 1, using the scan for the details
							t0 = t1global;

						}

						// linear reverse scan

						for ( var giveUpAt = i1 - 2; ;) {

							if ( t0 === undefined ) {

								// before start

								this._cachedIndex = 0;
								return this.beforeStart_( 0, t, t1 );

							}

							if ( i1 === giveUpAt ) break; // this loop

							t1 = t0;
							t0 = pp[ -- i1 - 1 ];

							if ( t >= t0 ) {

								// we have arrived at the sought interval
								break seek;

							}

						}

						// prepare binary search on the left side of the index
						right = i1;
						i1 = 0;
						break linear_scan;

					}

					// the interval is valid

					break validate_interval;

				} // linear scan

				// binary search

				while ( i1 < right ) {

					var mid = ( i1 + right ) >>> 1;

					if ( t < pp[ mid ] ) {

						right = mid;

					} else {

						i1 = mid + 1;

					}

				}

				t1 = pp[   i1   ];
				t0 = pp[ i1 - 1 ];

				// check boundary cases, again

				if ( t0 === undefined ) {

					this._cachedIndex = 0;
					return this.beforeStart_( 0, t, t1 );

				}

				if ( t1 === undefined ) {

					i1 = pp.length;
					this._cachedIndex = i1;
					return this.afterEnd_( i1 - 1, t0, t );

				}

			} // seek

			this._cachedIndex = i1;

			this.intervalChanged_( i1, t0, t1 );

		} // validate_interval

		return this.interpolate_( i1, t0, t, t1 );

	},

	settings: null, // optional, subclass-specific settings structure
	// Note: The indirection allows central control of many interpolants.

	// --- Protected interface

	DefaultSettings_: {},

	getSettings_: function() {

		return this.settings || this.DefaultSettings_;

	},

	copySampleValue_: function( index ) {

		// copies a sample value to the result buffer

		var result = this.resultBuffer,
			values = this.sampleValues,
			stride = this.valueSize,
			offset = index * stride;

		for ( var i = 0; i !== stride; ++ i ) {

			result[ i ] = values[ offset + i ];

		}

		return result;

	},

	// Template methods for derived classes:

	interpolate_: function( i1, t0, t, t1 ) {

		throw new Error( "call to abstract method" );
		// implementations shall return this.resultBuffer

	},

	intervalChanged_: function( i1, t0, t1 ) {

		// empty

	}

};

Object.assign( Interpolant.prototype, {

	beforeStart_: //( 0, t, t0 ), returns this.resultBuffer
		Interpolant.prototype.copySampleValue_,

	afterEnd_: //( N-1, tN-1, t ), returns this.resultBuffer
		Interpolant.prototype.copySampleValue_

} );

/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 *
 * @author tschw
 */

function CubicInterpolant(
		parameterPositions, sampleValues, sampleSize, resultBuffer ) {

	Interpolant.call(
			this, parameterPositions, sampleValues, sampleSize, resultBuffer );

	this._weightPrev = -0;
	this._offsetPrev = -0;
	this._weightNext = -0;
	this._offsetNext = -0;

}

CubicInterpolant.prototype =
		Object.assign( Object.create( Interpolant.prototype ), {

	constructor: CubicInterpolant,

	DefaultSettings_: {

		endingStart: 	ZeroCurvatureEnding,
		endingEnd:		ZeroCurvatureEnding

	},

	intervalChanged_: function( i1, t0, t1 ) {

		var pp = this.parameterPositions,
			iPrev = i1 - 2,
			iNext = i1 + 1,

			tPrev = pp[ iPrev ],
			tNext = pp[ iNext ];

		if ( tPrev === undefined ) {

			switch ( this.getSettings_().endingStart ) {

				case ZeroSlopeEnding:

					// f'(t0) = 0
					iPrev = i1;
					tPrev = 2 * t0 - t1;

					break;

				case WrapAroundEnding:

					// use the other end of the curve
					iPrev = pp.length - 2;
					tPrev = t0 + pp[ iPrev ] - pp[ iPrev + 1 ];

					break;

				default: // ZeroCurvatureEnding

					// f''(t0) = 0 a.k.a. Natural Spline
					iPrev = i1;
					tPrev = t1;

			}

		}

		if ( tNext === undefined ) {

			switch ( this.getSettings_().endingEnd ) {

				case ZeroSlopeEnding:

					// f'(tN) = 0
					iNext = i1;
					tNext = 2 * t1 - t0;

					break;

				case WrapAroundEnding:

					// use the other end of the curve
					iNext = 1;
					tNext = t1 + pp[ 1 ] - pp[ 0 ];

					break;

				default: // ZeroCurvatureEnding

					// f''(tN) = 0, a.k.a. Natural Spline
					iNext = i1 - 1;
					tNext = t0;

			}

		}

		var halfDt = ( t1 - t0 ) * 0.5,
			stride = this.valueSize;

		this._weightPrev = halfDt / ( t0 - tPrev );
		this._weightNext = halfDt / ( tNext - t1 );
		this._offsetPrev = iPrev * stride;
		this._offsetNext = iNext * stride;

	},

	interpolate_: function( i1, t0, t, t1 ) {

		var result = this.resultBuffer,
			values = this.sampleValues,
			stride = this.valueSize,

			o1 = i1 * stride,		o0 = o1 - stride,
			oP = this._offsetPrev, 	oN = this._offsetNext,
			wP = this._weightPrev,	wN = this._weightNext,

			p = ( t - t0 ) / ( t1 - t0 ),
			pp = p * p,
			ppp = pp * p;

		// evaluate polynomials

		var sP =     - wP   * ppp   +         2 * wP    * pp    -          wP   * p;
		var s0 = ( 1 + wP ) * ppp   + (-1.5 - 2 * wP )  * pp    + ( -0.5 + wP ) * p     + 1;
		var s1 = (-1 - wN ) * ppp   + ( 1.5 +   wN   )  * pp    +    0.5        * p;
		var sN =       wN   * ppp   -           wN      * pp;

		// combine data linearly

		for ( var i = 0; i !== stride; ++ i ) {

			result[ i ] =
					sP * values[ oP + i ] +
					s0 * values[ o0 + i ] +
					s1 * values[ o1 + i ] +
					sN * values[ oN + i ];

		}

		return result;

	}

} );

/**
 * @author tschw
 */

function LinearInterpolant(
		parameterPositions, sampleValues, sampleSize, resultBuffer ) {

	Interpolant.call(
			this, parameterPositions, sampleValues, sampleSize, resultBuffer );

}

LinearInterpolant.prototype =
		Object.assign( Object.create( Interpolant.prototype ), {

	constructor: LinearInterpolant,

	interpolate_: function( i1, t0, t, t1 ) {

		var result = this.resultBuffer,
			values = this.sampleValues,
			stride = this.valueSize,

			offset1 = i1 * stride,
			offset0 = offset1 - stride,

			weight1 = ( t - t0 ) / ( t1 - t0 ),
			weight0 = 1 - weight1;

		for ( var i = 0; i !== stride; ++ i ) {

			result[ i ] =
					values[ offset0 + i ] * weight0 +
					values[ offset1 + i ] * weight1;

		}

		return result;

	}

} );

/**
 *
 * Interpolant that evaluates to the sample value at the position preceeding
 * the parameter.
 *
 * @author tschw
 */

function DiscreteInterpolant(
		parameterPositions, sampleValues, sampleSize, resultBuffer ) {

	Interpolant.call(
			this, parameterPositions, sampleValues, sampleSize, resultBuffer );

}

DiscreteInterpolant.prototype =
		Object.assign( Object.create( Interpolant.prototype ), {

	constructor: DiscreteInterpolant,

	interpolate_: function( i1, t0, t, t1 ) {

		return this.copySampleValue_( i1 - 1 );

	}

} );

var KeyframeTrackPrototype;

KeyframeTrackPrototype = {

	TimeBufferType: Float32Array,
	ValueBufferType: Float32Array,

	DefaultInterpolation: InterpolateLinear,

	InterpolantFactoryMethodDiscrete: function ( result ) {

		return new DiscreteInterpolant(
				this.times, this.values, this.getValueSize(), result );

	},

	InterpolantFactoryMethodLinear: function ( result ) {

		return new LinearInterpolant(
				this.times, this.values, this.getValueSize(), result );

	},

	InterpolantFactoryMethodSmooth: function ( result ) {

		return new CubicInterpolant(
				this.times, this.values, this.getValueSize(), result );

	},

	setInterpolation: function ( interpolation ) {

		var factoryMethod;

		switch ( interpolation ) {

			case InterpolateDiscrete:

				factoryMethod = this.InterpolantFactoryMethodDiscrete;

				break;

			case InterpolateLinear:

				factoryMethod = this.InterpolantFactoryMethodLinear;

				break;

			case InterpolateSmooth:

				factoryMethod = this.InterpolantFactoryMethodSmooth;

				break;

		}

		if ( factoryMethod === undefined ) {

			var message = "unsupported interpolation for " +
					this.ValueTypeName + " keyframe track named " + this.name;

			if ( this.createInterpolant === undefined ) {

				// fall back to default, unless the default itself is messed up
				if ( interpolation !== this.DefaultInterpolation ) {

					this.setInterpolation( this.DefaultInterpolation );

				} else {

					throw new Error( message ); // fatal, in this case

				}

			}

			console.warn( message );
			return;

		}

		this.createInterpolant = factoryMethod;

	},

	getInterpolation: function () {

		switch ( this.createInterpolant ) {

			case this.InterpolantFactoryMethodDiscrete:

				return InterpolateDiscrete;

			case this.InterpolantFactoryMethodLinear:

				return InterpolateLinear;

			case this.InterpolantFactoryMethodSmooth:

				return InterpolateSmooth;

		}

	},

	getValueSize: function () {

		return this.values.length / this.times.length;

	},

	// move all keyframes either forwards or backwards in time
	shift: function ( timeOffset ) {

		if ( timeOffset !== 0.0 ) {

			var times = this.times;

			for ( var i = 0, n = times.length; i !== n; ++ i ) {

				times[ i ] += timeOffset;

			}

		}

		return this;

	},

	// scale all keyframe times by a factor (useful for frame <-> seconds conversions)
	scale: function ( timeScale ) {

		if ( timeScale !== 1.0 ) {

			var times = this.times;

			for ( var i = 0, n = times.length; i !== n; ++ i ) {

				times[ i ] *= timeScale;

			}

		}

		return this;

	},

	// removes keyframes before and after animation without changing any values within the range [startTime, endTime].
	// IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
	trim: function ( startTime, endTime ) {

		var times = this.times,
			nKeys = times.length,
			from = 0,
			to = nKeys - 1;

		while ( from !== nKeys && times[ from ] < startTime ) ++ from;
		while ( to !== - 1 && times[ to ] > endTime ) -- to;

		++ to; // inclusive -> exclusive bound

		if ( from !== 0 || to !== nKeys ) {

			// empty tracks are forbidden, so keep at least one keyframe
			if ( from >= to ) to = Math.max( to, 1 ), from = to - 1;

			var stride = this.getValueSize();
			this.times = AnimationUtils.arraySlice( times, from, to );
			this.values = AnimationUtils.
					arraySlice( this.values, from * stride, to * stride );

		}

		return this;

	},

	// ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
	validate: function () {

		var valid = true;

		var valueSize = this.getValueSize();
		if ( valueSize - Math.floor( valueSize ) !== 0 ) {

			console.error( "invalid value size in track", this );
			valid = false;

		}

		var times = this.times,
			values = this.values,

			nKeys = times.length;

		if ( nKeys === 0 ) {

			console.error( "track is empty", this );
			valid = false;

		}

		var prevTime = null;

		for ( var i = 0; i !== nKeys; i ++ ) {

			var currTime = times[ i ];

			if ( typeof currTime === 'number' && isNaN( currTime ) ) {

				console.error( "time is not a valid number", this, i, currTime );
				valid = false;
				break;

			}

			if ( prevTime !== null && prevTime > currTime ) {

				console.error( "out of order keys", this, i, currTime, prevTime );
				valid = false;
				break;

			}

			prevTime = currTime;

		}

		if ( values !== undefined ) {

			if ( AnimationUtils.isTypedArray( values ) ) {

				for ( var i = 0, n = values.length; i !== n; ++ i ) {

					var value = values[ i ];

					if ( isNaN( value ) ) {

						console.error( "value is not a valid number", this, i, value );
						valid = false;
						break;

					}

				}

			}

		}

		return valid;

	},

	// removes equivalent sequential keys as common in morph target sequences
	// (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
	optimize: function () {

		var times = this.times,
			values = this.values,
			stride = this.getValueSize(),

			smoothInterpolation = this.getInterpolation() === InterpolateSmooth,

			writeIndex = 1,
			lastIndex = times.length - 1;

		for ( var i = 1; i < lastIndex; ++ i ) {

			var keep = false;

			var time = times[ i ];
			var timeNext = times[ i + 1 ];

			// remove adjacent keyframes scheduled at the same time

			if ( time !== timeNext && ( i !== 1 || time !== time[ 0 ] ) ) {

				if ( ! smoothInterpolation ) {

					// remove unnecessary keyframes same as their neighbors

					var offset = i * stride,
						offsetP = offset - stride,
						offsetN = offset + stride;

					for ( var j = 0; j !== stride; ++ j ) {

						var value = values[ offset + j ];

						if ( value !== values[ offsetP + j ] ||
								value !== values[ offsetN + j ] ) {

							keep = true;
							break;

						}

					}

				} else keep = true;

			}

			// in-place compaction

			if ( keep ) {

				if ( i !== writeIndex ) {

					times[ writeIndex ] = times[ i ];

					var readOffset = i * stride,
						writeOffset = writeIndex * stride;

					for ( var j = 0; j !== stride; ++ j )

						values[ writeOffset + j ] = values[ readOffset + j ];

				}

				++ writeIndex;

			}

		}

		// flush last keyframe (compaction looks ahead)

		if ( lastIndex > 0 ) {

			times[ writeIndex ] = times[ lastIndex ];

			for ( var readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++ j )

				values[ writeOffset + j ] = values[ readOffset + j ];

			++ writeIndex;

		}

		if ( writeIndex !== times.length ) {

			this.times = AnimationUtils.arraySlice( times, 0, writeIndex );
			this.values = AnimationUtils.arraySlice( values, 0, writeIndex * stride );

		}

		return this;

	}

};

function KeyframeTrackConstructor( name, times, values, interpolation ) {

	if( name === undefined ) throw new Error( "track name is undefined" );

	if( times === undefined || times.length === 0 ) {

		throw new Error( "no keyframes in track named " + name );

	}

	this.name = name;

	this.times = AnimationUtils.convertArray( times, this.TimeBufferType );
	this.values = AnimationUtils.convertArray( values, this.ValueBufferType );

	this.setInterpolation( interpolation || this.DefaultInterpolation );

	this.validate();
	this.optimize();

}

/**
 *
 * A Track of vectored keyframe values.
 *
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 */

function VectorKeyframeTrack( name, times, values, interpolation ) {

	KeyframeTrackConstructor.call( this, name, times, values, interpolation );

}

VectorKeyframeTrack.prototype =
		Object.assign( Object.create( KeyframeTrackPrototype ), {

	constructor: VectorKeyframeTrack,

	ValueTypeName: 'vector'

	// ValueBufferType is inherited

	// DefaultInterpolation is inherited

} );

/**
 * Spherical linear unit quaternion interpolant.
 *
 * @author tschw
 */

function QuaternionLinearInterpolant(
		parameterPositions, sampleValues, sampleSize, resultBuffer ) {

	Interpolant.call(
			this, parameterPositions, sampleValues, sampleSize, resultBuffer );

}

QuaternionLinearInterpolant.prototype =
		Object.assign( Object.create( Interpolant.prototype ), {

	constructor: QuaternionLinearInterpolant,

	interpolate_: function( i1, t0, t, t1 ) {

		var result = this.resultBuffer,
			values = this.sampleValues,
			stride = this.valueSize,

			offset = i1 * stride,

			alpha = ( t - t0 ) / ( t1 - t0 );

		for ( var end = offset + stride; offset !== end; offset += 4 ) {

			Quaternion.slerpFlat( result, 0,
					values, offset - stride, values, offset, alpha );

		}

		return result;

	}

} );

/**
 *
 * A Track of quaternion keyframe values.
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 */

function QuaternionKeyframeTrack( name, times, values, interpolation ) {

	KeyframeTrackConstructor.call( this, name, times, values, interpolation );

}

QuaternionKeyframeTrack.prototype =
		Object.assign( Object.create( KeyframeTrackPrototype ), {

	constructor: QuaternionKeyframeTrack,

	ValueTypeName: 'quaternion',

	// ValueBufferType is inherited

	DefaultInterpolation: InterpolateLinear,

	InterpolantFactoryMethodLinear: function( result ) {

		return new QuaternionLinearInterpolant(
				this.times, this.values, this.getValueSize(), result );

	},

	InterpolantFactoryMethodSmooth: undefined // not yet implemented

} );

/**
 *
 * A Track of numeric keyframe values.
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 */

function NumberKeyframeTrack( name, times, values, interpolation ) {

	KeyframeTrackConstructor.call( this, name, times, values, interpolation );

}

NumberKeyframeTrack.prototype =
		Object.assign( Object.create( KeyframeTrackPrototype ), {

	constructor: NumberKeyframeTrack,

	ValueTypeName: 'number'

	// ValueBufferType is inherited

	// DefaultInterpolation is inherited

} );

/**
 *
 * A Track that interpolates Strings
 *
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 */

function StringKeyframeTrack( name, times, values, interpolation ) {

	KeyframeTrackConstructor.call( this, name, times, values, interpolation );

}

StringKeyframeTrack.prototype =
		Object.assign( Object.create( KeyframeTrackPrototype ), {

	constructor: StringKeyframeTrack,

	ValueTypeName: 'string',
	ValueBufferType: Array,

	DefaultInterpolation: InterpolateDiscrete,

	InterpolantFactoryMethodLinear: undefined,

	InterpolantFactoryMethodSmooth: undefined

} );

/**
 *
 * A Track of Boolean keyframe values.
 *
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 */

function BooleanKeyframeTrack( name, times, values ) {

	KeyframeTrackConstructor.call( this, name, times, values );

}

BooleanKeyframeTrack.prototype =
		Object.assign( Object.create( KeyframeTrackPrototype ), {

	constructor: BooleanKeyframeTrack,

	ValueTypeName: 'bool',
	ValueBufferType: Array,

	DefaultInterpolation: InterpolateDiscrete,

	InterpolantFactoryMethodLinear: undefined,
	InterpolantFactoryMethodSmooth: undefined

	// Note: Actually this track could have a optimized / compressed
	// representation of a single value and a custom interpolant that
	// computes "firstValue ^ isOdd( index )".

} );

/**
 *
 * A Track of keyframe values that represent color.
 *
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 */

function ColorKeyframeTrack( name, times, values, interpolation ) {

	KeyframeTrackConstructor.call( this, name, times, values, interpolation );

}

ColorKeyframeTrack.prototype =
		Object.assign( Object.create( KeyframeTrackPrototype ), {

	constructor: ColorKeyframeTrack,

	ValueTypeName: 'color'

	// ValueBufferType is inherited

	// DefaultInterpolation is inherited


	// Note: Very basic implementation and nothing special yet.
	// However, this is the place for color space parameterization.

} );

/**
 *
 * A timed sequence of keyframes for a specific property.
 *
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 */

function KeyframeTrack( name, times, values, interpolation ) {

	KeyframeTrackConstructor.apply( this, arguments );

}

KeyframeTrack.prototype = KeyframeTrackPrototype;
KeyframeTrackPrototype.constructor = KeyframeTrack;

// Static methods:

Object.assign( KeyframeTrack, {

	// Serialization (in static context, because of constructor invocation
	// and automatic invocation of .toJSON):

	parse: function( json ) {

		if( json.type === undefined ) {

			throw new Error( "track type undefined, can not parse" );

		}

		var trackType = KeyframeTrack._getTrackTypeForValueTypeName( json.type );

		if ( json.times === undefined ) {

			var times = [], values = [];

			AnimationUtils.flattenJSON( json.keys, times, values, 'value' );

			json.times = times;
			json.values = values;

		}

		// derived classes can define a static parse method
		if ( trackType.parse !== undefined ) {

			return trackType.parse( json );

		} else {

			// by default, we asssume a constructor compatible with the base
			return new trackType(
					json.name, json.times, json.values, json.interpolation );

		}

	},

	toJSON: function( track ) {

		var trackType = track.constructor;

		var json;

		// derived classes can define a static toJSON method
		if ( trackType.toJSON !== undefined ) {

			json = trackType.toJSON( track );

		} else {

			// by default, we assume the data can be serialized as-is
			json = {

				'name': track.name,
				'times': AnimationUtils.convertArray( track.times, Array ),
				'values': AnimationUtils.convertArray( track.values, Array )

			};

			var interpolation = track.getInterpolation();

			if ( interpolation !== track.DefaultInterpolation ) {

				json.interpolation = interpolation;

			}

		}

		json.type = track.ValueTypeName; // mandatory

		return json;

	},

	_getTrackTypeForValueTypeName: function( typeName ) {

		switch( typeName.toLowerCase() ) {

			case "scalar":
			case "double":
			case "float":
			case "number":
			case "integer":

				return NumberKeyframeTrack;

			case "vector":
			case "vector2":
			case "vector3":
			case "vector4":

				return VectorKeyframeTrack;

			case "color":

				return ColorKeyframeTrack;

			case "quaternion":

				return QuaternionKeyframeTrack;

			case "bool":
			case "boolean":

				return BooleanKeyframeTrack;

			case "string":

				return StringKeyframeTrack;

		}

		throw new Error( "Unsupported typeName: " + typeName );

	}

} );

/**
 *
 * Reusable set of Tracks that represent an animation.
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 */

function AnimationClip( name, duration, tracks ) {

	this.name = name;
	this.tracks = tracks;
	this.duration = ( duration !== undefined ) ? duration : -1;

	this.uuid = _Math.generateUUID();

	// this means it should figure out its duration by scanning the tracks
	if ( this.duration < 0 ) {

		this.resetDuration();

	}

	this.optimize();

}

AnimationClip.prototype = {

	constructor: AnimationClip,

	resetDuration: function() {

		var tracks = this.tracks,
			duration = 0;

		for ( var i = 0, n = tracks.length; i !== n; ++ i ) {

			var track = this.tracks[ i ];

			duration = Math.max( duration, track.times[ track.times.length - 1 ] );

		}

		this.duration = duration;

	},

	trim: function() {

		for ( var i = 0; i < this.tracks.length; i ++ ) {

			this.tracks[ i ].trim( 0, this.duration );

		}

		return this;

	},

	optimize: function() {

		for ( var i = 0; i < this.tracks.length; i ++ ) {

			this.tracks[ i ].optimize();

		}

		return this;

	}

};

// Static methods:

Object.assign( AnimationClip, {

	parse: function( json ) {

		var tracks = [],
			jsonTracks = json.tracks,
			frameTime = 1.0 / ( json.fps || 1.0 );

		for ( var i = 0, n = jsonTracks.length; i !== n; ++ i ) {

			tracks.push( KeyframeTrack.parse( jsonTracks[ i ] ).scale( frameTime ) );

		}

		return new AnimationClip( json.name, json.duration, tracks );

	},


	toJSON: function( clip ) {

		var tracks = [],
			clipTracks = clip.tracks;

		var json = {

			'name': clip.name,
			'duration': clip.duration,
			'tracks': tracks

		};

		for ( var i = 0, n = clipTracks.length; i !== n; ++ i ) {

			tracks.push( KeyframeTrack.toJSON( clipTracks[ i ] ) );

		}

		return json;

	},


	CreateFromMorphTargetSequence: function( name, morphTargetSequence, fps, noLoop ) {

		var numMorphTargets = morphTargetSequence.length;
		var tracks = [];

		for ( var i = 0; i < numMorphTargets; i ++ ) {

			var times = [];
			var values = [];

			times.push(
					( i + numMorphTargets - 1 ) % numMorphTargets,
					i,
					( i + 1 ) % numMorphTargets );

			values.push( 0, 1, 0 );

			var order = AnimationUtils.getKeyframeOrder( times );
			times = AnimationUtils.sortedArray( times, 1, order );
			values = AnimationUtils.sortedArray( values, 1, order );

			// if there is a key at the first frame, duplicate it as the
			// last frame as well for perfect loop.
			if ( ! noLoop && times[ 0 ] === 0 ) {

				times.push( numMorphTargets );
				values.push( values[ 0 ] );

			}

			tracks.push(
					new NumberKeyframeTrack(
						'.morphTargetInfluences[' + morphTargetSequence[ i ].name + ']',
						times, values
					).scale( 1.0 / fps ) );
		}

		return new AnimationClip( name, -1, tracks );

	},

	findByName: function( objectOrClipArray, name ) {

		var clipArray = objectOrClipArray;

		if ( ! Array.isArray( objectOrClipArray ) ) {

			var o = objectOrClipArray;
			clipArray = o.geometry && o.geometry.animations || o.animations;

		}

		for ( var i = 0; i < clipArray.length; i ++ ) {

			if ( clipArray[ i ].name === name ) {

				return clipArray[ i ];

			}
		}

		return null;

	},

	CreateClipsFromMorphTargetSequences: function( morphTargets, fps, noLoop ) {

		var animationToMorphTargets = {};

		// tested with https://regex101.com/ on trick sequences
		// such flamingo_flyA_003, flamingo_run1_003, crdeath0059
		var pattern = /^([\w-]*?)([\d]+)$/;

		// sort morph target names into animation groups based
		// patterns like Walk_001, Walk_002, Run_001, Run_002
		for ( var i = 0, il = morphTargets.length; i < il; i ++ ) {

			var morphTarget = morphTargets[ i ];
			var parts = morphTarget.name.match( pattern );

			if ( parts && parts.length > 1 ) {

				var name = parts[ 1 ];

				var animationMorphTargets = animationToMorphTargets[ name ];
				if ( ! animationMorphTargets ) {

					animationToMorphTargets[ name ] = animationMorphTargets = [];

				}

				animationMorphTargets.push( morphTarget );

			}

		}

		var clips = [];

		for ( var name in animationToMorphTargets ) {

			clips.push( AnimationClip.CreateFromMorphTargetSequence( name, animationToMorphTargets[ name ], fps, noLoop ) );

		}

		return clips;

	},

	// parse the animation.hierarchy format
	parseAnimation: function( animation, bones ) {

		if ( ! animation ) {

			console.error( "  no animation in JSONLoader data" );
			return null;

		}

		var addNonemptyTrack = function(
				trackType, trackName, animationKeys, propertyName, destTracks ) {

			// only return track if there are actually keys.
			if ( animationKeys.length !== 0 ) {

				var times = [];
				var values = [];

				AnimationUtils.flattenJSON(
						animationKeys, times, values, propertyName );

				// empty keys are filtered out, so check again
				if ( times.length !== 0 ) {

					destTracks.push( new trackType( trackName, times, values ) );

				}

			}

		};

		var tracks = [];

		var clipName = animation.name || 'default';
		// automatic length determination in AnimationClip.
		var duration = animation.length || -1;
		var fps = animation.fps || 30;

		var hierarchyTracks = animation.hierarchy || [];

		for ( var h = 0; h < hierarchyTracks.length; h ++ ) {

			var animationKeys = hierarchyTracks[ h ].keys;

			// skip empty tracks
			if ( ! animationKeys || animationKeys.length === 0 ) continue;

			// process morph targets in a way exactly compatible
			// with AnimationHandler.init( animation )
			if ( animationKeys[0].morphTargets ) {

				// figure out all morph targets used in this track
				var morphTargetNames = {};
				for ( var k = 0; k < animationKeys.length; k ++ ) {

					if ( animationKeys[k].morphTargets ) {

						for ( var m = 0; m < animationKeys[k].morphTargets.length; m ++ ) {

							morphTargetNames[ animationKeys[k].morphTargets[m] ] = -1;
						}

					}

				}

				// create a track for each morph target with all zero
				// morphTargetInfluences except for the keys in which
				// the morphTarget is named.
				for ( var morphTargetName in morphTargetNames ) {

					var times = [];
					var values = [];

					for ( var m = 0; m !== animationKeys[k].morphTargets.length; ++ m ) {

						var animationKey = animationKeys[k];

						times.push( animationKey.time );
						values.push( ( animationKey.morphTarget === morphTargetName ) ? 1 : 0 );

					}

					tracks.push( new NumberKeyframeTrack('.morphTargetInfluence[' + morphTargetName + ']', times, values ) );

				}

				duration = morphTargetNames.length * ( fps || 1.0 );

			} else {
				// ...assume skeletal animation

				var boneName = '.bones[' + bones[ h ].name + ']';

				addNonemptyTrack(
						VectorKeyframeTrack, boneName + '.position',
						animationKeys, 'pos', tracks );

				addNonemptyTrack(
						QuaternionKeyframeTrack, boneName + '.quaternion',
						animationKeys, 'rot', tracks );

				addNonemptyTrack(
						VectorKeyframeTrack, boneName + '.scale',
						animationKeys, 'scl', tracks );

			}

		}

		if ( tracks.length === 0 ) {

			return null;

		}

		var clip = new AnimationClip( clipName, duration, tracks );

		return clip;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function MaterialLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	this.textures = {};

}

Object.assign( MaterialLoader.prototype, {

	load: function ( url, onLoad, onProgress, onError ) {

		var scope = this;

		var loader = new FileLoader( scope.manager );
		loader.load( url, function ( text ) {

			onLoad( scope.parse( JSON.parse( text ) ) );

		}, onProgress, onError );

	},

	setTextures: function ( value ) {

		this.textures = value;

	},

	parse: function ( json ) {

		var textures = this.textures;

		function getTexture( name ) {

			if ( textures[ name ] === undefined ) {

				console.warn( 'THREE.MaterialLoader: Undefined texture', name );

			}

			return textures[ name ];

		}

		var material = new Materials[ json.type ]();

		if ( json.uuid !== undefined ) material.uuid = json.uuid;
		if ( json.name !== undefined ) material.name = json.name;
		if ( json.color !== undefined ) material.color.setHex( json.color );
		if ( json.roughness !== undefined ) material.roughness = json.roughness;
		if ( json.metalness !== undefined ) material.metalness = json.metalness;
		if ( json.emissive !== undefined ) material.emissive.setHex( json.emissive );
		if ( json.specular !== undefined ) material.specular.setHex( json.specular );
		if ( json.shininess !== undefined ) material.shininess = json.shininess;
		if ( json.clearCoat !== undefined ) material.clearCoat = json.clearCoat;
		if ( json.clearCoatRoughness !== undefined ) material.clearCoatRoughness = json.clearCoatRoughness;
		if ( json.uniforms !== undefined ) material.uniforms = json.uniforms;
		if ( json.vertexShader !== undefined ) material.vertexShader = json.vertexShader;
		if ( json.fragmentShader !== undefined ) material.fragmentShader = json.fragmentShader;
		if ( json.vertexColors !== undefined ) material.vertexColors = json.vertexColors;
		if ( json.fog !== undefined ) material.fog = json.fog;
		if ( json.shading !== undefined ) material.shading = json.shading;
		if ( json.blending !== undefined ) material.blending = json.blending;
		if ( json.side !== undefined ) material.side = json.side;
		if ( json.opacity !== undefined ) material.opacity = json.opacity;
		if ( json.transparent !== undefined ) material.transparent = json.transparent;
		if ( json.alphaTest !== undefined ) material.alphaTest = json.alphaTest;
		if ( json.depthTest !== undefined ) material.depthTest = json.depthTest;
		if ( json.depthWrite !== undefined ) material.depthWrite = json.depthWrite;
		if ( json.colorWrite !== undefined ) material.colorWrite = json.colorWrite;
		if ( json.wireframe !== undefined ) material.wireframe = json.wireframe;
		if ( json.wireframeLinewidth !== undefined ) material.wireframeLinewidth = json.wireframeLinewidth;
		if ( json.wireframeLinecap !== undefined ) material.wireframeLinecap = json.wireframeLinecap;
		if ( json.wireframeLinejoin !== undefined ) material.wireframeLinejoin = json.wireframeLinejoin;
		if ( json.skinning !== undefined ) material.skinning = json.skinning;
		if ( json.morphTargets !== undefined ) material.morphTargets = json.morphTargets;

		// for PointsMaterial

		if ( json.size !== undefined ) material.size = json.size;
		if ( json.sizeAttenuation !== undefined ) material.sizeAttenuation = json.sizeAttenuation;

		// maps

		if ( json.map !== undefined ) material.map = getTexture( json.map );

		if ( json.alphaMap !== undefined ) {

			material.alphaMap = getTexture( json.alphaMap );
			material.transparent = true;

		}

		if ( json.bumpMap !== undefined ) material.bumpMap = getTexture( json.bumpMap );
		if ( json.bumpScale !== undefined ) material.bumpScale = json.bumpScale;

		if ( json.normalMap !== undefined ) material.normalMap = getTexture( json.normalMap );
		if ( json.normalScale !== undefined ) {

			var normalScale = json.normalScale;

			if ( Array.isArray( normalScale ) === false ) {

				// Blender exporter used to export a scalar. See #7459

				normalScale = [ normalScale, normalScale ];

			}

			material.normalScale = new Vector2().fromArray( normalScale );

		}

		if ( json.displacementMap !== undefined ) material.displacementMap = getTexture( json.displacementMap );
		if ( json.displacementScale !== undefined ) material.displacementScale = json.displacementScale;
		if ( json.displacementBias !== undefined ) material.displacementBias = json.displacementBias;

		if ( json.roughnessMap !== undefined ) material.roughnessMap = getTexture( json.roughnessMap );
		if ( json.metalnessMap !== undefined ) material.metalnessMap = getTexture( json.metalnessMap );

		if ( json.emissiveMap !== undefined ) material.emissiveMap = getTexture( json.emissiveMap );
		if ( json.emissiveIntensity !== undefined ) material.emissiveIntensity = json.emissiveIntensity;

		if ( json.specularMap !== undefined ) material.specularMap = getTexture( json.specularMap );

		if ( json.envMap !== undefined ) material.envMap = getTexture( json.envMap );

		if ( json.reflectivity !== undefined ) material.reflectivity = json.reflectivity;

		if ( json.lightMap !== undefined ) material.lightMap = getTexture( json.lightMap );
		if ( json.lightMapIntensity !== undefined ) material.lightMapIntensity = json.lightMapIntensity;

		if ( json.aoMap !== undefined ) material.aoMap = getTexture( json.aoMap );
		if ( json.aoMapIntensity !== undefined ) material.aoMapIntensity = json.aoMapIntensity;

		if ( json.gradientMap !== undefined ) material.gradientMap = getTexture( json.gradientMap );

		// MultiMaterial

		if ( json.materials !== undefined ) {

			for ( var i = 0, l = json.materials.length; i < l; i ++ ) {

				material.materials.push( this.parse( json.materials[ i ] ) );

			}

		}

		return material;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function BufferGeometryLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

}

Object.assign( BufferGeometryLoader.prototype, {

	load: function ( url, onLoad, onProgress, onError ) {

		var scope = this;

		var loader = new FileLoader( scope.manager );
		loader.load( url, function ( text ) {

			onLoad( scope.parse( JSON.parse( text ) ) );

		}, onProgress, onError );

	},

	parse: function ( json ) {

		var geometry = new BufferGeometry();

		var index = json.data.index;

		var TYPED_ARRAYS = {
			'Int8Array': Int8Array,
			'Uint8Array': Uint8Array,
			'Uint8ClampedArray': Uint8ClampedArray,
			'Int16Array': Int16Array,
			'Uint16Array': Uint16Array,
			'Int32Array': Int32Array,
			'Uint32Array': Uint32Array,
			'Float32Array': Float32Array,
			'Float64Array': Float64Array
		};

		if ( index !== undefined ) {

			var typedArray = new TYPED_ARRAYS[ index.type ]( index.array );
			geometry.setIndex( new BufferAttribute( typedArray, 1 ) );

		}

		var attributes = json.data.attributes;

		for ( var key in attributes ) {

			var attribute = attributes[ key ];
			var typedArray = new TYPED_ARRAYS[ attribute.type ]( attribute.array );

			geometry.addAttribute( key, new BufferAttribute( typedArray, attribute.itemSize, attribute.normalized ) );

		}

		var groups = json.data.groups || json.data.drawcalls || json.data.offsets;

		if ( groups !== undefined ) {

			for ( var i = 0, n = groups.length; i !== n; ++ i ) {

				var group = groups[ i ];

				geometry.addGroup( group.start, group.count, group.materialIndex );

			}

		}

		var boundingSphere = json.data.boundingSphere;

		if ( boundingSphere !== undefined ) {

			var center = new Vector3();

			if ( boundingSphere.center !== undefined ) {

				center.fromArray( boundingSphere.center );

			}

			geometry.boundingSphere = new Sphere( center, boundingSphere.radius );

		}

		return geometry;

	}

} );

/**
 * @author alteredq / http://alteredqualia.com/
 */

function Loader() {

	this.onLoadStart = function () {};
	this.onLoadProgress = function () {};
	this.onLoadComplete = function () {};

}

Loader.prototype = {

	constructor: Loader,

	crossOrigin: undefined,

	extractUrlBase: function ( url ) {

		var parts = url.split( '/' );

		if ( parts.length === 1 ) return './';

		parts.pop();

		return parts.join( '/' ) + '/';

	},

	initMaterials: function ( materials, texturePath, crossOrigin ) {

		var array = [];

		for ( var i = 0; i < materials.length; ++ i ) {

			array[ i ] = this.createMaterial( materials[ i ], texturePath, crossOrigin );

		}

		return array;

	},

	createMaterial: ( function () {

		var color, textureLoader, materialLoader;

		return function createMaterial( m, texturePath, crossOrigin ) {

			if ( color === undefined ) color = new Color();
			if ( textureLoader === undefined ) textureLoader = new TextureLoader();
			if ( materialLoader === undefined ) materialLoader = new MaterialLoader();

			// convert from old material format

			var textures = {};

			function loadTexture( path, repeat, offset, wrap, anisotropy ) {

				var fullPath = texturePath + path;
				var loader = Loader.Handlers.get( fullPath );

				var texture;

				if ( loader !== null ) {

					texture = loader.load( fullPath );

				} else {

					textureLoader.setCrossOrigin( crossOrigin );
					texture = textureLoader.load( fullPath );

				}

				if ( repeat !== undefined ) {

					texture.repeat.fromArray( repeat );

					if ( repeat[ 0 ] !== 1 ) texture.wrapS = RepeatWrapping;
					if ( repeat[ 1 ] !== 1 ) texture.wrapT = RepeatWrapping;

				}

				if ( offset !== undefined ) {

					texture.offset.fromArray( offset );

				}

				if ( wrap !== undefined ) {

					if ( wrap[ 0 ] === 'repeat' ) texture.wrapS = RepeatWrapping;
					if ( wrap[ 0 ] === 'mirror' ) texture.wrapS = MirroredRepeatWrapping;

					if ( wrap[ 1 ] === 'repeat' ) texture.wrapT = RepeatWrapping;
					if ( wrap[ 1 ] === 'mirror' ) texture.wrapT = MirroredRepeatWrapping;

				}

				if ( anisotropy !== undefined ) {

					texture.anisotropy = anisotropy;

				}

				var uuid = _Math.generateUUID();

				textures[ uuid ] = texture;

				return uuid;

			}

			//

			var json = {
				uuid: _Math.generateUUID(),
				type: 'MeshLambertMaterial'
			};

			for ( var name in m ) {

				var value = m[ name ];

				switch ( name ) {
					case 'DbgColor':
					case 'DbgIndex':
					case 'opticalDensity':
					case 'illumination':
						break;
					case 'DbgName':
						json.name = value;
						break;
					case 'blending':
						json.blending = BlendingMode[ value ];
						break;
					case 'colorAmbient':
					case 'mapAmbient':
						console.warn( 'THREE.Loader.createMaterial:', name, 'is no longer supported.' );
						break;
					case 'colorDiffuse':
						json.color = color.fromArray( value ).getHex();
						break;
					case 'colorSpecular':
						json.specular = color.fromArray( value ).getHex();
						break;
					case 'colorEmissive':
						json.emissive = color.fromArray( value ).getHex();
						break;
					case 'specularCoef':
						json.shininess = value;
						break;
					case 'shading':
						if ( value.toLowerCase() === 'basic' ) json.type = 'MeshBasicMaterial';
						if ( value.toLowerCase() === 'phong' ) json.type = 'MeshPhongMaterial';
						if ( value.toLowerCase() === 'standard' ) json.type = 'MeshStandardMaterial';
						break;
					case 'mapDiffuse':
						json.map = loadTexture( value, m.mapDiffuseRepeat, m.mapDiffuseOffset, m.mapDiffuseWrap, m.mapDiffuseAnisotropy );
						break;
					case 'mapDiffuseRepeat':
					case 'mapDiffuseOffset':
					case 'mapDiffuseWrap':
					case 'mapDiffuseAnisotropy':
						break;
					case 'mapEmissive':
						json.emissiveMap = loadTexture( value, m.mapEmissiveRepeat, m.mapEmissiveOffset, m.mapEmissiveWrap, m.mapEmissiveAnisotropy );
						break;
					case 'mapEmissiveRepeat':
					case 'mapEmissiveOffset':
					case 'mapEmissiveWrap':
					case 'mapEmissiveAnisotropy':
						break;
					case 'mapLight':
						json.lightMap = loadTexture( value, m.mapLightRepeat, m.mapLightOffset, m.mapLightWrap, m.mapLightAnisotropy );
						break;
					case 'mapLightRepeat':
					case 'mapLightOffset':
					case 'mapLightWrap':
					case 'mapLightAnisotropy':
						break;
					case 'mapAO':
						json.aoMap = loadTexture( value, m.mapAORepeat, m.mapAOOffset, m.mapAOWrap, m.mapAOAnisotropy );
						break;
					case 'mapAORepeat':
					case 'mapAOOffset':
					case 'mapAOWrap':
					case 'mapAOAnisotropy':
						break;
					case 'mapBump':
						json.bumpMap = loadTexture( value, m.mapBumpRepeat, m.mapBumpOffset, m.mapBumpWrap, m.mapBumpAnisotropy );
						break;
					case 'mapBumpScale':
						json.bumpScale = value;
						break;
					case 'mapBumpRepeat':
					case 'mapBumpOffset':
					case 'mapBumpWrap':
					case 'mapBumpAnisotropy':
						break;
					case 'mapNormal':
						json.normalMap = loadTexture( value, m.mapNormalRepeat, m.mapNormalOffset, m.mapNormalWrap, m.mapNormalAnisotropy );
						break;
					case 'mapNormalFactor':
						json.normalScale = [ value, value ];
						break;
					case 'mapNormalRepeat':
					case 'mapNormalOffset':
					case 'mapNormalWrap':
					case 'mapNormalAnisotropy':
						break;
					case 'mapSpecular':
						json.specularMap = loadTexture( value, m.mapSpecularRepeat, m.mapSpecularOffset, m.mapSpecularWrap, m.mapSpecularAnisotropy );
						break;
					case 'mapSpecularRepeat':
					case 'mapSpecularOffset':
					case 'mapSpecularWrap':
					case 'mapSpecularAnisotropy':
						break;
					case 'mapMetalness':
						json.metalnessMap = loadTexture( value, m.mapMetalnessRepeat, m.mapMetalnessOffset, m.mapMetalnessWrap, m.mapMetalnessAnisotropy );
						break;
					case 'mapMetalnessRepeat':
					case 'mapMetalnessOffset':
					case 'mapMetalnessWrap':
					case 'mapMetalnessAnisotropy':
						break;
					case 'mapRoughness':
						json.roughnessMap = loadTexture( value, m.mapRoughnessRepeat, m.mapRoughnessOffset, m.mapRoughnessWrap, m.mapRoughnessAnisotropy );
						break;
					case 'mapRoughnessRepeat':
					case 'mapRoughnessOffset':
					case 'mapRoughnessWrap':
					case 'mapRoughnessAnisotropy':
						break;
					case 'mapAlpha':
						json.alphaMap = loadTexture( value, m.mapAlphaRepeat, m.mapAlphaOffset, m.mapAlphaWrap, m.mapAlphaAnisotropy );
						break;
					case 'mapAlphaRepeat':
					case 'mapAlphaOffset':
					case 'mapAlphaWrap':
					case 'mapAlphaAnisotropy':
						break;
					case 'flipSided':
						json.side = BackSide;
						break;
					case 'doubleSided':
						json.side = DoubleSide;
						break;
					case 'transparency':
						console.warn( 'THREE.Loader.createMaterial: transparency has been renamed to opacity' );
						json.opacity = value;
						break;
					case 'depthTest':
					case 'depthWrite':
					case 'colorWrite':
					case 'opacity':
					case 'reflectivity':
					case 'transparent':
					case 'visible':
					case 'wireframe':
						json[ name ] = value;
						break;
					case 'vertexColors':
						if ( value === true ) json.vertexColors = VertexColors;
						if ( value === 'face' ) json.vertexColors = FaceColors;
						break;
					default:
						console.error( 'THREE.Loader.createMaterial: Unsupported', name, value );
						break;
				}

			}

			if ( json.type === 'MeshBasicMaterial' ) delete json.emissive;
			if ( json.type !== 'MeshPhongMaterial' ) delete json.specular;

			if ( json.opacity < 1 ) json.transparent = true;

			materialLoader.setTextures( textures );

			return materialLoader.parse( json );

		};

	} )()

};

Loader.Handlers = {

	handlers: [],

	add: function ( regex, loader ) {

		this.handlers.push( regex, loader );

	},

	get: function ( file ) {

		var handlers = this.handlers;

		for ( var i = 0, l = handlers.length; i < l; i += 2 ) {

			var regex = handlers[ i ];
			var loader  = handlers[ i + 1 ];

			if ( regex.test( file ) ) {

				return loader;

			}

		}

		return null;

	}

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 */

function JSONLoader( manager ) {

	if ( typeof manager === 'boolean' ) {

		console.warn( 'THREE.JSONLoader: showStatus parameter has been removed from constructor.' );
		manager = undefined;

	}

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

	this.withCredentials = false;

}

Object.assign( JSONLoader.prototype, {

	load: function( url, onLoad, onProgress, onError ) {

		var scope = this;

		var texturePath = this.texturePath && ( typeof this.texturePath === "string" ) ? this.texturePath : Loader.prototype.extractUrlBase( url );

		var loader = new FileLoader( this.manager );
		loader.setWithCredentials( this.withCredentials );
		loader.load( url, function ( text ) {

			var json = JSON.parse( text );
			var metadata = json.metadata;

			if ( metadata !== undefined ) {

				var type = metadata.type;

				if ( type !== undefined ) {

					if ( type.toLowerCase() === 'object' ) {

						console.error( 'THREE.JSONLoader: ' + url + ' should be loaded with THREE.ObjectLoader instead.' );
						return;

					}

					if ( type.toLowerCase() === 'scene' ) {

						console.error( 'THREE.JSONLoader: ' + url + ' should be loaded with THREE.SceneLoader instead.' );
						return;

					}

				}

			}

			var object = scope.parse( json, texturePath );
			onLoad( object.geometry, object.materials );

		}, onProgress, onError );

	},

	setTexturePath: function ( value ) {

		this.texturePath = value;

	},

	parse: function ( json, texturePath ) {

		var geometry = new Geometry(),
		scale = ( json.scale !== undefined ) ? 1.0 / json.scale : 1.0;

		parseModel( scale );

		parseSkin();
		parseMorphing( scale );
		parseAnimations();

		geometry.computeFaceNormals();
		geometry.computeBoundingSphere();

		function parseModel( scale ) {

			function isBitSet( value, position ) {

				return value & ( 1 << position );

			}

			var i, j, fi,

			offset, zLength,

		colorIndex, normalIndex, uvIndex, materialIndex,

			type,
			isQuad,
			hasMaterial,
			hasFaceVertexUv,
			hasFaceNormal, hasFaceVertexNormal,
			hasFaceColor, hasFaceVertexColor,

		vertex, face, faceA, faceB, hex, normal,

			uvLayer, uv, u, v,

			faces = json.faces,
			vertices = json.vertices,
			normals = json.normals,
			colors = json.colors,

			nUvLayers = 0;

			if ( json.uvs !== undefined ) {

				// disregard empty arrays

				for ( i = 0; i < json.uvs.length; i ++ ) {

					if ( json.uvs[ i ].length ) nUvLayers ++;

				}

				for ( i = 0; i < nUvLayers; i ++ ) {

					geometry.faceVertexUvs[ i ] = [];

				}

			}

			offset = 0;
			zLength = vertices.length;

			while ( offset < zLength ) {

				vertex = new Vector3();

				vertex.x = vertices[ offset ++ ] * scale;
				vertex.y = vertices[ offset ++ ] * scale;
				vertex.z = vertices[ offset ++ ] * scale;

				geometry.vertices.push( vertex );

			}

			offset = 0;
			zLength = faces.length;

			while ( offset < zLength ) {

				type = faces[ offset ++ ];


				isQuad              = isBitSet( type, 0 );
				hasMaterial         = isBitSet( type, 1 );
				hasFaceVertexUv     = isBitSet( type, 3 );
				hasFaceNormal       = isBitSet( type, 4 );
				hasFaceVertexNormal = isBitSet( type, 5 );
				hasFaceColor	     = isBitSet( type, 6 );
				hasFaceVertexColor  = isBitSet( type, 7 );

				// console.log("type", type, "bits", isQuad, hasMaterial, hasFaceVertexUv, hasFaceNormal, hasFaceVertexNormal, hasFaceColor, hasFaceVertexColor);

				if ( isQuad ) {

					faceA = new Face3();
					faceA.a = faces[ offset ];
					faceA.b = faces[ offset + 1 ];
					faceA.c = faces[ offset + 3 ];

					faceB = new Face3();
					faceB.a = faces[ offset + 1 ];
					faceB.b = faces[ offset + 2 ];
					faceB.c = faces[ offset + 3 ];

					offset += 4;

					if ( hasMaterial ) {

						materialIndex = faces[ offset ++ ];
						faceA.materialIndex = materialIndex;
						faceB.materialIndex = materialIndex;

					}

					// to get face <=> uv index correspondence

					fi = geometry.faces.length;

					if ( hasFaceVertexUv ) {

						for ( i = 0; i < nUvLayers; i ++ ) {

							uvLayer = json.uvs[ i ];

							geometry.faceVertexUvs[ i ][ fi ] = [];
							geometry.faceVertexUvs[ i ][ fi + 1 ] = [];

							for ( j = 0; j < 4; j ++ ) {

								uvIndex = faces[ offset ++ ];

								u = uvLayer[ uvIndex * 2 ];
								v = uvLayer[ uvIndex * 2 + 1 ];

								uv = new Vector2( u, v );

								if ( j !== 2 ) geometry.faceVertexUvs[ i ][ fi ].push( uv );
								if ( j !== 0 ) geometry.faceVertexUvs[ i ][ fi + 1 ].push( uv );

							}

						}

					}

					if ( hasFaceNormal ) {

						normalIndex = faces[ offset ++ ] * 3;

						faceA.normal.set(
							normals[ normalIndex ++ ],
							normals[ normalIndex ++ ],
							normals[ normalIndex ]
						);

						faceB.normal.copy( faceA.normal );

					}

					if ( hasFaceVertexNormal ) {

						for ( i = 0; i < 4; i ++ ) {

							normalIndex = faces[ offset ++ ] * 3;

							normal = new Vector3(
								normals[ normalIndex ++ ],
								normals[ normalIndex ++ ],
								normals[ normalIndex ]
							);


							if ( i !== 2 ) faceA.vertexNormals.push( normal );
							if ( i !== 0 ) faceB.vertexNormals.push( normal );

						}

					}


					if ( hasFaceColor ) {

						colorIndex = faces[ offset ++ ];
						hex = colors[ colorIndex ];

						faceA.color.setHex( hex );
						faceB.color.setHex( hex );

					}


					if ( hasFaceVertexColor ) {

						for ( i = 0; i < 4; i ++ ) {

							colorIndex = faces[ offset ++ ];
							hex = colors[ colorIndex ];

							if ( i !== 2 ) faceA.vertexColors.push( new Color( hex ) );
							if ( i !== 0 ) faceB.vertexColors.push( new Color( hex ) );

						}

					}

					geometry.faces.push( faceA );
					geometry.faces.push( faceB );

				} else {

					face = new Face3();
					face.a = faces[ offset ++ ];
					face.b = faces[ offset ++ ];
					face.c = faces[ offset ++ ];

					if ( hasMaterial ) {

						materialIndex = faces[ offset ++ ];
						face.materialIndex = materialIndex;

					}

					// to get face <=> uv index correspondence

					fi = geometry.faces.length;

					if ( hasFaceVertexUv ) {

						for ( i = 0; i < nUvLayers; i ++ ) {

							uvLayer = json.uvs[ i ];

							geometry.faceVertexUvs[ i ][ fi ] = [];

							for ( j = 0; j < 3; j ++ ) {

								uvIndex = faces[ offset ++ ];

								u = uvLayer[ uvIndex * 2 ];
								v = uvLayer[ uvIndex * 2 + 1 ];

								uv = new Vector2( u, v );

								geometry.faceVertexUvs[ i ][ fi ].push( uv );

							}

						}

					}

					if ( hasFaceNormal ) {

						normalIndex = faces[ offset ++ ] * 3;

						face.normal.set(
							normals[ normalIndex ++ ],
							normals[ normalIndex ++ ],
							normals[ normalIndex ]
						);

					}

					if ( hasFaceVertexNormal ) {

						for ( i = 0; i < 3; i ++ ) {

							normalIndex = faces[ offset ++ ] * 3;

							normal = new Vector3(
								normals[ normalIndex ++ ],
								normals[ normalIndex ++ ],
								normals[ normalIndex ]
							);

							face.vertexNormals.push( normal );

						}

					}


					if ( hasFaceColor ) {

						colorIndex = faces[ offset ++ ];
						face.color.setHex( colors[ colorIndex ] );

					}


					if ( hasFaceVertexColor ) {

						for ( i = 0; i < 3; i ++ ) {

							colorIndex = faces[ offset ++ ];
							face.vertexColors.push( new Color( colors[ colorIndex ] ) );

						}

					}

					geometry.faces.push( face );

				}

			}

		}

		function parseSkin() {

			var influencesPerVertex = ( json.influencesPerVertex !== undefined ) ? json.influencesPerVertex : 2;

			if ( json.skinWeights ) {

				for ( var i = 0, l = json.skinWeights.length; i < l; i += influencesPerVertex ) {

					var x =                               json.skinWeights[ i ];
					var y = ( influencesPerVertex > 1 ) ? json.skinWeights[ i + 1 ] : 0;
					var z = ( influencesPerVertex > 2 ) ? json.skinWeights[ i + 2 ] : 0;
					var w = ( influencesPerVertex > 3 ) ? json.skinWeights[ i + 3 ] : 0;

					geometry.skinWeights.push( new Vector4( x, y, z, w ) );

				}

			}

			if ( json.skinIndices ) {

				for ( var i = 0, l = json.skinIndices.length; i < l; i += influencesPerVertex ) {

					var a =                               json.skinIndices[ i ];
					var b = ( influencesPerVertex > 1 ) ? json.skinIndices[ i + 1 ] : 0;
					var c = ( influencesPerVertex > 2 ) ? json.skinIndices[ i + 2 ] : 0;
					var d = ( influencesPerVertex > 3 ) ? json.skinIndices[ i + 3 ] : 0;

					geometry.skinIndices.push( new Vector4( a, b, c, d ) );

				}

			}

			geometry.bones = json.bones;

			if ( geometry.bones && geometry.bones.length > 0 && ( geometry.skinWeights.length !== geometry.skinIndices.length || geometry.skinIndices.length !== geometry.vertices.length ) ) {

				console.warn( 'When skinning, number of vertices (' + geometry.vertices.length + '), skinIndices (' +
					geometry.skinIndices.length + '), and skinWeights (' + geometry.skinWeights.length + ') should match.' );

			}

		}

		function parseMorphing( scale ) {

			if ( json.morphTargets !== undefined ) {

				for ( var i = 0, l = json.morphTargets.length; i < l; i ++ ) {

					geometry.morphTargets[ i ] = {};
					geometry.morphTargets[ i ].name = json.morphTargets[ i ].name;
					geometry.morphTargets[ i ].vertices = [];

					var dstVertices = geometry.morphTargets[ i ].vertices;
					var srcVertices = json.morphTargets[ i ].vertices;

					for ( var v = 0, vl = srcVertices.length; v < vl; v += 3 ) {

						var vertex = new Vector3();
						vertex.x = srcVertices[ v ] * scale;
						vertex.y = srcVertices[ v + 1 ] * scale;
						vertex.z = srcVertices[ v + 2 ] * scale;

						dstVertices.push( vertex );

					}

				}

			}

			if ( json.morphColors !== undefined && json.morphColors.length > 0 ) {

				console.warn( 'THREE.JSONLoader: "morphColors" no longer supported. Using them as face colors.' );

				var faces = geometry.faces;
				var morphColors = json.morphColors[ 0 ].colors;

				for ( var i = 0, l = faces.length; i < l; i ++ ) {

					faces[ i ].color.fromArray( morphColors, i * 3 );

				}

			}

		}

		function parseAnimations() {

			var outputAnimations = [];

			// parse old style Bone/Hierarchy animations
			var animations = [];

			if ( json.animation !== undefined ) {

				animations.push( json.animation );

			}

			if ( json.animations !== undefined ) {

				if ( json.animations.length ) {

					animations = animations.concat( json.animations );

				} else {

					animations.push( json.animations );

				}

			}

			for ( var i = 0; i < animations.length; i ++ ) {

				var clip = AnimationClip.parseAnimation( animations[ i ], geometry.bones );
				if ( clip ) outputAnimations.push( clip );

			}

			// parse implicit morph animations
			if ( geometry.morphTargets ) {

				// TODO: Figure out what an appropraite FPS is for morph target animations -- defaulting to 10, but really it is completely arbitrary.
				var morphAnimationClips = AnimationClip.CreateClipsFromMorphTargetSequences( geometry.morphTargets, 10 );
				outputAnimations = outputAnimations.concat( morphAnimationClips );

			}

			if ( outputAnimations.length > 0 ) geometry.animations = outputAnimations;

		}

		if ( json.materials === undefined || json.materials.length === 0 ) {

			return { geometry: geometry };

		} else {

			var materials = Loader.prototype.initMaterials( json.materials, texturePath, this.crossOrigin );

			return { geometry: geometry, materials: materials };

		}

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function ObjectLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	this.texturePath = '';

}

Object.assign( ObjectLoader.prototype, {

	load: function ( url, onLoad, onProgress, onError ) {

		if ( this.texturePath === '' ) {

			this.texturePath = url.substring( 0, url.lastIndexOf( '/' ) + 1 );

		}

		var scope = this;

		var loader = new FileLoader( scope.manager );
		loader.load( url, function ( text ) {

			var json = null;

			try {

				json = JSON.parse( text );

			} catch ( error ) {

				console.error( 'THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message );
				return;

			}

			var metadata = json.metadata;

			if ( metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry' ) {

				console.error( 'THREE.ObjectLoader: Can\'t load ' + url + '. Use THREE.JSONLoader instead.' );
				return;

			}

			scope.parse( json, onLoad );

		}, onProgress, onError );

	},

	setTexturePath: function ( value ) {

		this.texturePath = value;

	},

	setCrossOrigin: function ( value ) {

		this.crossOrigin = value;

	},

	parse: function ( json, onLoad ) {

		var geometries = this.parseGeometries( json.geometries );

		var images = this.parseImages( json.images, function () {

			if ( onLoad !== undefined ) onLoad( object );

		} );

		var textures = this.parseTextures( json.textures, images );
		var materials = this.parseMaterials( json.materials, textures );

		var object = this.parseObject( json.object, geometries, materials );

		if ( json.animations ) {

			object.animations = this.parseAnimations( json.animations );

		}

		if ( json.images === undefined || json.images.length === 0 ) {

			if ( onLoad !== undefined ) onLoad( object );

		}

		return object;

	},

	parseGeometries: function ( json ) {

		var geometries = {};

		if ( json !== undefined ) {

			var geometryLoader = new JSONLoader();
			var bufferGeometryLoader = new BufferGeometryLoader();

			for ( var i = 0, l = json.length; i < l; i ++ ) {

				var geometry;
				var data = json[ i ];

				switch ( data.type ) {

					case 'PlaneGeometry':
					case 'PlaneBufferGeometry':

						geometry = new Geometries[ data.type ](
							data.width,
							data.height,
							data.widthSegments,
							data.heightSegments
						);

						break;

					case 'BoxGeometry':
					case 'BoxBufferGeometry':
					case 'CubeGeometry': // backwards compatible

						geometry = new Geometries[ data.type ](
							data.width,
							data.height,
							data.depth,
							data.widthSegments,
							data.heightSegments,
							data.depthSegments
						);

						break;

					case 'CircleGeometry':
					case 'CircleBufferGeometry':

						geometry = new Geometries[ data.type ](
							data.radius,
							data.segments,
							data.thetaStart,
							data.thetaLength
						);

						break;

					case 'CylinderGeometry':
					case 'CylinderBufferGeometry':

						geometry = new Geometries[ data.type ](
							data.radiusTop,
							data.radiusBottom,
							data.height,
							data.radialSegments,
							data.heightSegments,
							data.openEnded,
							data.thetaStart,
							data.thetaLength
						);

						break;

					case 'ConeGeometry':
					case 'ConeBufferGeometry':

						geometry = new Geometries[ data.type ](
							data.radius,
							data.height,
							data.radialSegments,
							data.heightSegments,
							data.openEnded,
							data.thetaStart,
							data.thetaLength
						);

						break;

					case 'SphereGeometry':
					case 'SphereBufferGeometry':

						geometry = new Geometries[ data.type ](
							data.radius,
							data.widthSegments,
							data.heightSegments,
							data.phiStart,
							data.phiLength,
							data.thetaStart,
							data.thetaLength
						);

						break;

					case 'DodecahedronGeometry':
					case 'IcosahedronGeometry':
					case 'OctahedronGeometry':
					case 'TetrahedronGeometry':

						geometry = new Geometries[ data.type ](
							data.radius,
							data.detail
						);

						break;

					case 'RingGeometry':
					case 'RingBufferGeometry':

						geometry = new Geometries[ data.type ](
							data.innerRadius,
							data.outerRadius,
							data.thetaSegments,
							data.phiSegments,
							data.thetaStart,
							data.thetaLength
						);

						break;

					case 'TorusGeometry':
					case 'TorusBufferGeometry':

						geometry = new Geometries[ data.type ](
							data.radius,
							data.tube,
							data.radialSegments,
							data.tubularSegments,
							data.arc
						);

						break;

					case 'TorusKnotGeometry':
					case 'TorusKnotBufferGeometry':

						geometry = new Geometries[ data.type ](
							data.radius,
							data.tube,
							data.tubularSegments,
							data.radialSegments,
							data.p,
							data.q
						);

						break;

					case 'LatheGeometry':
					case 'LatheBufferGeometry':

						geometry = new Geometries[ data.type ](
							data.points,
							data.segments,
							data.phiStart,
							data.phiLength
						);

						break;

					case 'BufferGeometry':

						geometry = bufferGeometryLoader.parse( data );

						break;

					case 'Geometry':

						geometry = geometryLoader.parse( data.data, this.texturePath ).geometry;

						break;

					default:

						console.warn( 'THREE.ObjectLoader: Unsupported geometry type "' + data.type + '"' );

						continue;

				}

				geometry.uuid = data.uuid;

				if ( data.name !== undefined ) geometry.name = data.name;

				geometries[ data.uuid ] = geometry;

			}

		}

		return geometries;

	},

	parseMaterials: function ( json, textures ) {

		var materials = {};

		if ( json !== undefined ) {

			var loader = new MaterialLoader();
			loader.setTextures( textures );

			for ( var i = 0, l = json.length; i < l; i ++ ) {

				var material = loader.parse( json[ i ] );
				materials[ material.uuid ] = material;

			}

		}

		return materials;

	},

	parseAnimations: function ( json ) {

		var animations = [];

		for ( var i = 0; i < json.length; i ++ ) {

			var clip = AnimationClip.parse( json[ i ] );

			animations.push( clip );

		}

		return animations;

	},

	parseImages: function ( json, onLoad ) {

		var scope = this;
		var images = {};

		function loadImage( url ) {

			scope.manager.itemStart( url );

			return loader.load( url, function () {

				scope.manager.itemEnd( url );

			}, undefined, function () {

				scope.manager.itemError( url );

			} );

		}

		if ( json !== undefined && json.length > 0 ) {

			var manager = new LoadingManager( onLoad );

			var loader = new ImageLoader( manager );
			loader.setCrossOrigin( this.crossOrigin );

			for ( var i = 0, l = json.length; i < l; i ++ ) {

				var image = json[ i ];
				var path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test( image.url ) ? image.url : scope.texturePath + image.url;

				images[ image.uuid ] = loadImage( path );

			}

		}

		return images;

	},

	parseTextures: function ( json, images ) {

		function parseConstant( value, type ) {

			if ( typeof( value ) === 'number' ) return value;

			console.warn( 'THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value );

			return type[ value ];

		}

		var textures = {};

		if ( json !== undefined ) {

			for ( var i = 0, l = json.length; i < l; i ++ ) {

				var data = json[ i ];

				if ( data.image === undefined ) {

					console.warn( 'THREE.ObjectLoader: No "image" specified for', data.uuid );

				}

				if ( images[ data.image ] === undefined ) {

					console.warn( 'THREE.ObjectLoader: Undefined image', data.image );

				}

				var texture = new Texture( images[ data.image ] );
				texture.needsUpdate = true;

				texture.uuid = data.uuid;

				if ( data.name !== undefined ) texture.name = data.name;

				if ( data.mapping !== undefined ) texture.mapping = parseConstant( data.mapping, TextureMapping );

				if ( data.offset !== undefined ) texture.offset.fromArray( data.offset );
				if ( data.repeat !== undefined ) texture.repeat.fromArray( data.repeat );
				if ( data.wrap !== undefined ) {

					texture.wrapS = parseConstant( data.wrap[ 0 ], TextureWrapping );
					texture.wrapT = parseConstant( data.wrap[ 1 ], TextureWrapping );

				}

				if ( data.minFilter !== undefined ) texture.minFilter = parseConstant( data.minFilter, TextureFilter );
				if ( data.magFilter !== undefined ) texture.magFilter = parseConstant( data.magFilter, TextureFilter );
				if ( data.anisotropy !== undefined ) texture.anisotropy = data.anisotropy;

				if ( data.flipY !== undefined ) texture.flipY = data.flipY;

				textures[ data.uuid ] = texture;

			}

		}

		return textures;

	},

	parseObject: function () {

		var matrix = new Matrix4();

		return function parseObject( data, geometries, materials ) {

			var object;

			function getGeometry( name ) {

				if ( geometries[ name ] === undefined ) {

					console.warn( 'THREE.ObjectLoader: Undefined geometry', name );

				}

				return geometries[ name ];

			}

			function getMaterial( name ) {

				if ( name === undefined ) return undefined;

				if ( materials[ name ] === undefined ) {

					console.warn( 'THREE.ObjectLoader: Undefined material', name );

				}

				return materials[ name ];

			}

			switch ( data.type ) {

				case 'Scene':

					object = new Scene();

					if ( data.background !== undefined ) {

						if ( Number.isInteger( data.background ) ) {

							object.background = new Color( data.background );

						}

					}

					if ( data.fog !== undefined ) {

						if ( data.fog.type === 'Fog' ) {

							object.fog = new Fog( data.fog.color, data.fog.near, data.fog.far );

						} else if ( data.fog.type === 'FogExp2' ) {

							object.fog = new FogExp2( data.fog.color, data.fog.density );

						}

					}

					break;

				case 'PerspectiveCamera':

					object = new PerspectiveCamera( data.fov, data.aspect, data.near, data.far );

					if ( data.focus !== undefined ) object.focus = data.focus;
					if ( data.zoom !== undefined ) object.zoom = data.zoom;
					if ( data.filmGauge !== undefined ) object.filmGauge = data.filmGauge;
					if ( data.filmOffset !== undefined ) object.filmOffset = data.filmOffset;
					if ( data.view !== undefined ) object.view = Object.assign( {}, data.view );

					break;

				case 'OrthographicCamera':

					object = new OrthographicCamera( data.left, data.right, data.top, data.bottom, data.near, data.far );

					break;

				case 'AmbientLight':

					object = new AmbientLight( data.color, data.intensity );

					break;

				case 'DirectionalLight':

					object = new DirectionalLight( data.color, data.intensity );

					break;

				case 'PointLight':

					object = new PointLight( data.color, data.intensity, data.distance, data.decay );

					break;

				case 'SpotLight':

					object = new SpotLight( data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay );

					break;

				case 'HemisphereLight':

					object = new HemisphereLight( data.color, data.groundColor, data.intensity );

					break;

				case 'Mesh':

					var geometry = getGeometry( data.geometry );
					var material = getMaterial( data.material );

					if ( geometry.bones && geometry.bones.length > 0 ) {

						object = new SkinnedMesh( geometry, material );

					} else {

						object = new Mesh( geometry, material );

					}

					break;

				case 'LOD':

					object = new LOD();

					break;

				case 'Line':

					object = new Line( getGeometry( data.geometry ), getMaterial( data.material ), data.mode );

					break;

				case 'LineSegments':

					object = new LineSegments( getGeometry( data.geometry ), getMaterial( data.material ) );

					break;

				case 'PointCloud':
				case 'Points':

					object = new Points( getGeometry( data.geometry ), getMaterial( data.material ) );

					break;

				case 'Sprite':

					object = new Sprite( getMaterial( data.material ) );

					break;

				case 'Group':

					object = new Group();

					break;

				case 'SkinnedMesh':

					console.warn( 'THREE.ObjectLoader.parseObject() does not support SkinnedMesh type. Instantiates Object3D instead.' );

				default:

					object = new Object3D();

			}

			object.uuid = data.uuid;

			if ( data.name !== undefined ) object.name = data.name;
			if ( data.matrix !== undefined ) {

				matrix.fromArray( data.matrix );
				matrix.decompose( object.position, object.quaternion, object.scale );

			} else {

				if ( data.position !== undefined ) object.position.fromArray( data.position );
				if ( data.rotation !== undefined ) object.rotation.fromArray( data.rotation );
				if ( data.quaternion !== undefined ) object.quaternion.fromArray( data.quaternion );
				if ( data.scale !== undefined ) object.scale.fromArray( data.scale );

			}

			if ( data.castShadow !== undefined ) object.castShadow = data.castShadow;
			if ( data.receiveShadow !== undefined ) object.receiveShadow = data.receiveShadow;

			if ( data.shadow ) {

				if ( data.shadow.bias !== undefined ) object.shadow.bias = data.shadow.bias;
				if ( data.shadow.radius !== undefined ) object.shadow.radius = data.shadow.radius;
				if ( data.shadow.mapSize !== undefined ) object.shadow.mapSize.fromArray( data.shadow.mapSize );
				if ( data.shadow.camera !== undefined ) object.shadow.camera = this.parseObject( data.shadow.camera );

			}

			if ( data.visible !== undefined ) object.visible = data.visible;
			if ( data.userData !== undefined ) object.userData = data.userData;

			if ( data.children !== undefined ) {

				for ( var child in data.children ) {

					object.add( this.parseObject( data.children[ child ], geometries, materials ) );

				}

			}

			if ( data.type === 'LOD' ) {

				var levels = data.levels;

				for ( var l = 0; l < levels.length; l ++ ) {

					var level = levels[ l ];
					var child = object.getObjectByProperty( 'uuid', level.object );

					if ( child !== undefined ) {

						object.addLevel( child, level.distance );

					}

				}

			}

			return object;

		};

	}()

} );

/**
 * @author zz85 / http://www.lab4games.net/zz85/blog
 * Extensible curve object
 *
 * Some common of Curve methods
 * .getPoint(t), getTangent(t)
 * .getPointAt(u), getTangentAt(u)
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following classes subclasses THREE.Curve:
 *
 * -- 2d classes --
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.CubicBezierCurve
 * THREE.SplineCurve
 * THREE.ArcCurve
 * THREE.EllipseCurve
 *
 * -- 3d classes --
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 * THREE.CubicBezierCurve3
 * THREE.SplineCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath
 *
 **/

/**************************************************************
 *	Abstract Curve base class
 **************************************************************/

function Curve() {}

Curve.prototype = {

	constructor: Curve,

	// Virtual base class method to overwrite and implement in subclasses
	//	- t [0 .. 1]

	getPoint: function ( t ) {

		console.warn( "THREE.Curve: Warning, getPoint() not implemented!" );
		return null;

	},

	// Get point at relative position in curve according to arc length
	// - u [0 .. 1]

	getPointAt: function ( u ) {

		var t = this.getUtoTmapping( u );
		return this.getPoint( t );

	},

	// Get sequence of points using getPoint( t )

	getPoints: function ( divisions ) {

		if ( ! divisions ) divisions = 5;

		var points = [];

		for ( var d = 0; d <= divisions; d ++ ) {

			points.push( this.getPoint( d / divisions ) );

		}

		return points;

	},

	// Get sequence of points using getPointAt( u )

	getSpacedPoints: function ( divisions ) {

		if ( ! divisions ) divisions = 5;

		var points = [];

		for ( var d = 0; d <= divisions; d ++ ) {

			points.push( this.getPointAt( d / divisions ) );

		}

		return points;

	},

	// Get total curve arc length

	getLength: function () {

		var lengths = this.getLengths();
		return lengths[ lengths.length - 1 ];

	},

	// Get list of cumulative segment lengths

	getLengths: function ( divisions ) {

		if ( ! divisions ) divisions = ( this.__arcLengthDivisions ) ? ( this.__arcLengthDivisions ) : 200;

		if ( this.cacheArcLengths
			&& ( this.cacheArcLengths.length === divisions + 1 )
			&& ! this.needsUpdate ) {

			//console.log( "cached", this.cacheArcLengths );
			return this.cacheArcLengths;

		}

		this.needsUpdate = false;

		var cache = [];
		var current, last = this.getPoint( 0 );
		var p, sum = 0;

		cache.push( 0 );

		for ( p = 1; p <= divisions; p ++ ) {

			current = this.getPoint ( p / divisions );
			sum += current.distanceTo( last );
			cache.push( sum );
			last = current;

		}

		this.cacheArcLengths = cache;

		return cache; // { sums: cache, sum:sum }; Sum is in the last element.

	},

	updateArcLengths: function() {

		this.needsUpdate = true;
		this.getLengths();

	},

	// Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant

	getUtoTmapping: function ( u, distance ) {

		var arcLengths = this.getLengths();

		var i = 0, il = arcLengths.length;

		var targetArcLength; // The targeted u distance value to get

		if ( distance ) {

			targetArcLength = distance;

		} else {

			targetArcLength = u * arcLengths[ il - 1 ];

		}

		//var time = Date.now();

		// binary search for the index with largest value smaller than target u distance

		var low = 0, high = il - 1, comparison;

		while ( low <= high ) {

			i = Math.floor( low + ( high - low ) / 2 ); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats

			comparison = arcLengths[ i ] - targetArcLength;

			if ( comparison < 0 ) {

				low = i + 1;

			} else if ( comparison > 0 ) {

				high = i - 1;

			} else {

				high = i;
				break;

				// DONE

			}

		}

		i = high;

		//console.log('b' , i, low, high, Date.now()- time);

		if ( arcLengths[ i ] === targetArcLength ) {

			var t = i / ( il - 1 );
			return t;

		}

		// we could get finer grain at lengths, or use simple interpolation between two points

		var lengthBefore = arcLengths[ i ];
		var lengthAfter = arcLengths[ i + 1 ];

		var segmentLength = lengthAfter - lengthBefore;

		// determine where we are between the 'before' and 'after' points

		var segmentFraction = ( targetArcLength - lengthBefore ) / segmentLength;

		// add that fractional amount to t

		var t = ( i + segmentFraction ) / ( il - 1 );

		return t;

	},

	// Returns a unit vector tangent at t
	// In case any sub curve does not implement its tangent derivation,
	// 2 points a small delta apart will be used to find its gradient
	// which seems to give a reasonable approximation

	getTangent: function( t ) {

		var delta = 0.0001;
		var t1 = t - delta;
		var t2 = t + delta;

		// Capping in case of danger

		if ( t1 < 0 ) t1 = 0;
		if ( t2 > 1 ) t2 = 1;

		var pt1 = this.getPoint( t1 );
		var pt2 = this.getPoint( t2 );

		var vec = pt2.clone().sub( pt1 );
		return vec.normalize();

	},

	getTangentAt: function ( u ) {

		var t = this.getUtoTmapping( u );
		return this.getTangent( t );

	},

	computeFrenetFrames: function ( segments, closed ) {

		// see http://www.cs.indiana.edu/pub/techreports/TR425.pdf

		var normal = new Vector3();

		var tangents = [];
		var normals = [];
		var binormals = [];

		var vec = new Vector3();
		var mat = new Matrix4();

		var i, u, theta;

		// compute the tangent vectors for each segment on the curve

		for ( i = 0; i <= segments; i ++ ) {

			u = i / segments;

			tangents[ i ] = this.getTangentAt( u );
			tangents[ i ].normalize();

		}

		// select an initial normal vector perpendicular to the first tangent vector,
		// and in the direction of the minimum tangent xyz component

		normals[ 0 ] = new Vector3();
		binormals[ 0 ] = new Vector3();
		var min = Number.MAX_VALUE;
		var tx = Math.abs( tangents[ 0 ].x );
		var ty = Math.abs( tangents[ 0 ].y );
		var tz = Math.abs( tangents[ 0 ].z );

		if ( tx <= min ) {

			min = tx;
			normal.set( 1, 0, 0 );

		}

		if ( ty <= min ) {

			min = ty;
			normal.set( 0, 1, 0 );

		}

		if ( tz <= min ) {

			normal.set( 0, 0, 1 );

		}

		vec.crossVectors( tangents[ 0 ], normal ).normalize();

		normals[ 0 ].crossVectors( tangents[ 0 ], vec );
		binormals[ 0 ].crossVectors( tangents[ 0 ], normals[ 0 ] );


		// compute the slowly-varying normal and binormal vectors for each segment on the curve

		for ( i = 1; i <= segments; i ++ ) {

			normals[ i ] = normals[ i - 1 ].clone();

			binormals[ i ] = binormals[ i - 1 ].clone();

			vec.crossVectors( tangents[ i - 1 ], tangents[ i ] );

			if ( vec.length() > Number.EPSILON ) {

				vec.normalize();

				theta = Math.acos( _Math.clamp( tangents[ i - 1 ].dot( tangents[ i ] ), - 1, 1 ) ); // clamp for floating pt errors

				normals[ i ].applyMatrix4( mat.makeRotationAxis( vec, theta ) );

			}

			binormals[ i ].crossVectors( tangents[ i ], normals[ i ] );

		}

		// if the curve is closed, postprocess the vectors so the first and last normal vectors are the same

		if ( closed === true ) {

			theta = Math.acos( _Math.clamp( normals[ 0 ].dot( normals[ segments ] ), - 1, 1 ) );
			theta /= segments;

			if ( tangents[ 0 ].dot( vec.crossVectors( normals[ 0 ], normals[ segments ] ) ) > 0 ) {

				theta = - theta;

			}

			for ( i = 1; i <= segments; i ++ ) {

				// twist a little...
				normals[ i ].applyMatrix4( mat.makeRotationAxis( tangents[ i ], theta * i ) );
				binormals[ i ].crossVectors( tangents[ i ], normals[ i ] );

			}

		}

		return {
			tangents: tangents,
			normals: normals,
			binormals: binormals
		};

	}

};

// TODO: Transformation for Curves?

/**************************************************************
 *	3D Curves
 **************************************************************/

// A Factory method for creating new curve subclasses

Curve.create = function ( constructor, getPointFunc ) {

	constructor.prototype = Object.create( Curve.prototype );
	constructor.prototype.constructor = constructor;
	constructor.prototype.getPoint = getPointFunc;

	return constructor;

};

/**************************************************************
 *	Line
 **************************************************************/

function LineCurve( v1, v2 ) {

	this.v1 = v1;
	this.v2 = v2;

}

LineCurve.prototype = Object.create( Curve.prototype );
LineCurve.prototype.constructor = LineCurve;

LineCurve.prototype.isLineCurve = true;

LineCurve.prototype.getPoint = function ( t ) {

	if ( t === 1 ) {

		return this.v2.clone();

	}

	var point = this.v2.clone().sub( this.v1 );
	point.multiplyScalar( t ).add( this.v1 );

	return point;

};

// Line curve is linear, so we can overwrite default getPointAt

LineCurve.prototype.getPointAt = function ( u ) {

	return this.getPoint( u );

};

LineCurve.prototype.getTangent = function( t ) {

	var tangent = this.v2.clone().sub( this.v1 );

	return tangent.normalize();

};

/**
 * @author zz85 / http://www.lab4games.net/zz85/blog
 *
 **/

/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/

function CurvePath() {

	this.curves = [];

	this.autoClose = false; // Automatically closes the path

}

CurvePath.prototype = Object.assign( Object.create( Curve.prototype ), {

	constructor: CurvePath,

	add: function ( curve ) {

		this.curves.push( curve );

	},

	closePath: function () {

		// Add a line curve if start and end of lines are not connected
		var startPoint = this.curves[ 0 ].getPoint( 0 );
		var endPoint = this.curves[ this.curves.length - 1 ].getPoint( 1 );

		if ( ! startPoint.equals( endPoint ) ) {

			this.curves.push( new LineCurve( endPoint, startPoint ) );

		}

	},

	// To get accurate point with reference to
	// entire path distance at time t,
	// following has to be done:

	// 1. Length of each sub path have to be known
	// 2. Locate and identify type of curve
	// 3. Get t for the curve
	// 4. Return curve.getPointAt(t')

	getPoint: function ( t ) {

		var d = t * this.getLength();
		var curveLengths = this.getCurveLengths();
		var i = 0;

		// To think about boundaries points.

		while ( i < curveLengths.length ) {

			if ( curveLengths[ i ] >= d ) {

				var diff = curveLengths[ i ] - d;
				var curve = this.curves[ i ];

				var segmentLength = curve.getLength();
				var u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;

				return curve.getPointAt( u );

			}

			i ++;

		}

		return null;

		// loop where sum != 0, sum > d , sum+1 <d

	},

	// We cannot use the default THREE.Curve getPoint() with getLength() because in
	// THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
	// getPoint() depends on getLength

	getLength: function () {

		var lens = this.getCurveLengths();
		return lens[ lens.length - 1 ];

	},

	// cacheLengths must be recalculated.
	updateArcLengths: function () {

		this.needsUpdate = true;
		this.cacheLengths = null;
		this.getLengths();

	},

	// Compute lengths and cache them
	// We cannot overwrite getLengths() because UtoT mapping uses it.

	getCurveLengths: function () {

		// We use cache values if curves and cache array are same length

		if ( this.cacheLengths && this.cacheLengths.length === this.curves.length ) {

			return this.cacheLengths;

		}

		// Get length of sub-curve
		// Push sums into cached array

		var lengths = [], sums = 0;

		for ( var i = 0, l = this.curves.length; i < l; i ++ ) {

			sums += this.curves[ i ].getLength();
			lengths.push( sums );

		}

		this.cacheLengths = lengths;

		return lengths;

	},

	getSpacedPoints: function ( divisions ) {

		if ( ! divisions ) divisions = 40;

		var points = [];

		for ( var i = 0; i <= divisions; i ++ ) {

			points.push( this.getPoint( i / divisions ) );

		}

		if ( this.autoClose ) {

			points.push( points[ 0 ] );

		}

		return points;

	},

	getPoints: function ( divisions ) {

		divisions = divisions || 12;

		var points = [], last;

		for ( var i = 0, curves = this.curves; i < curves.length; i ++ ) {

			var curve = curves[ i ];
			var resolution = (curve && curve.isEllipseCurve) ? divisions * 2
				: (curve && curve.isLineCurve) ? 1
				: (curve && curve.isSplineCurve) ? divisions * curve.points.length
				: divisions;

			var pts = curve.getPoints( resolution );

			for ( var j = 0; j < pts.length; j++ ) {

				var point = pts[ j ];

				if ( last && last.equals( point ) ) continue; // ensures no consecutive points are duplicates

				points.push( point );
				last = point;

			}

		}

		if ( this.autoClose && points.length > 1 && !points[ points.length - 1 ].equals( points[ 0 ] ) ) {

			points.push( points[ 0 ] );

		}

		return points;

	},

	/**************************************************************
	 *	Create Geometries Helpers
	 **************************************************************/

	/// Generate geometry from path points (for Line or Points objects)

	createPointsGeometry: function ( divisions ) {

		var pts = this.getPoints( divisions );
		return this.createGeometry( pts );

	},

	// Generate geometry from equidistant sampling along the path

	createSpacedPointsGeometry: function ( divisions ) {

		var pts = this.getSpacedPoints( divisions );
		return this.createGeometry( pts );

	},

	createGeometry: function ( points ) {

		var geometry = new Geometry();

		for ( var i = 0, l = points.length; i < l; i ++ ) {

			var point = points[ i ];
			geometry.vertices.push( new Vector3( point.x, point.y, point.z || 0 ) );

		}

		return geometry;

	}

} );

/**************************************************************
 *	Ellipse curve
 **************************************************************/

function EllipseCurve( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {

	this.aX = aX;
	this.aY = aY;

	this.xRadius = xRadius;
	this.yRadius = yRadius;

	this.aStartAngle = aStartAngle;
	this.aEndAngle = aEndAngle;

	this.aClockwise = aClockwise;

	this.aRotation = aRotation || 0;

}

EllipseCurve.prototype = Object.create( Curve.prototype );
EllipseCurve.prototype.constructor = EllipseCurve;

EllipseCurve.prototype.isEllipseCurve = true;

EllipseCurve.prototype.getPoint = function( t ) {

	var twoPi = Math.PI * 2;
	var deltaAngle = this.aEndAngle - this.aStartAngle;
	var samePoints = Math.abs( deltaAngle ) < Number.EPSILON;

	// ensures that deltaAngle is 0 .. 2 PI
	while ( deltaAngle < 0 ) deltaAngle += twoPi;
	while ( deltaAngle > twoPi ) deltaAngle -= twoPi;

	if ( deltaAngle < Number.EPSILON ) {

		if ( samePoints ) {

			deltaAngle = 0;

		} else {

			deltaAngle = twoPi;

		}

	}

	if ( this.aClockwise === true && ! samePoints ) {

		if ( deltaAngle === twoPi ) {

			deltaAngle = - twoPi;

		} else {

			deltaAngle = deltaAngle - twoPi;

		}

	}

	var angle = this.aStartAngle + t * deltaAngle;
	var x = this.aX + this.xRadius * Math.cos( angle );
	var y = this.aY + this.yRadius * Math.sin( angle );

	if ( this.aRotation !== 0 ) {

		var cos = Math.cos( this.aRotation );
		var sin = Math.sin( this.aRotation );

		var tx = x - this.aX;
		var ty = y - this.aY;

		// Rotate the point about the center of the ellipse.
		x = tx * cos - ty * sin + this.aX;
		y = tx * sin + ty * cos + this.aY;

	}

	return new Vector2( x, y );

};

/**
 * @author zz85 / http://www.lab4games.net/zz85/blog
 */

var CurveUtils = {

	tangentQuadraticBezier: function ( t, p0, p1, p2 ) {

		return 2 * ( 1 - t ) * ( p1 - p0 ) + 2 * t * ( p2 - p1 );

	},

	// Puay Bing, thanks for helping with this derivative!

	tangentCubicBezier: function ( t, p0, p1, p2, p3 ) {

		return - 3 * p0 * ( 1 - t ) * ( 1 - t )  +
			3 * p1 * ( 1 - t ) * ( 1 - t ) - 6 * t * p1 * ( 1 - t ) +
			6 * t *  p2 * ( 1 - t ) - 3 * t * t * p2 +
			3 * t * t * p3;

	},

	tangentSpline: function ( t, p0, p1, p2, p3 ) {

		// To check if my formulas are correct

		var h00 = 6 * t * t - 6 * t; 	// derived from 2t^3 − 3t^2 + 1
		var h10 = 3 * t * t - 4 * t + 1; // t^3 − 2t^2 + t
		var h01 = - 6 * t * t + 6 * t; 	// − 2t3 + 3t2
		var h11 = 3 * t * t - 2 * t;	// t3 − t2

		return h00 + h10 + h01 + h11;

	},

	// Catmull-Rom

	interpolate: function( p0, p1, p2, p3, t ) {

		var v0 = ( p2 - p0 ) * 0.5;
		var v1 = ( p3 - p1 ) * 0.5;
		var t2 = t * t;
		var t3 = t * t2;
		return ( 2 * p1 - 2 * p2 + v0 + v1 ) * t3 + ( - 3 * p1 + 3 * p2 - 2 * v0 - v1 ) * t2 + v0 * t + p1;

	}

};

/**************************************************************
 *	Spline curve
 **************************************************************/

function SplineCurve( points /* array of Vector2 */ ) {

	this.points = ( points === undefined ) ? [] : points;

}

SplineCurve.prototype = Object.create( Curve.prototype );
SplineCurve.prototype.constructor = SplineCurve;

SplineCurve.prototype.isSplineCurve = true;

SplineCurve.prototype.getPoint = function ( t ) {

	var points = this.points;
	var point = ( points.length - 1 ) * t;

	var intPoint = Math.floor( point );
	var weight = point - intPoint;

	var point0 = points[ intPoint === 0 ? intPoint : intPoint - 1 ];
	var point1 = points[ intPoint ];
	var point2 = points[ intPoint > points.length - 2 ? points.length - 1 : intPoint + 1 ];
	var point3 = points[ intPoint > points.length - 3 ? points.length - 1 : intPoint + 2 ];

	var interpolate = CurveUtils.interpolate;

	return new Vector2(
		interpolate( point0.x, point1.x, point2.x, point3.x, weight ),
		interpolate( point0.y, point1.y, point2.y, point3.y, weight )
	);

};

/**************************************************************
 *	Cubic Bezier curve
 **************************************************************/

function CubicBezierCurve( v0, v1, v2, v3 ) {

	this.v0 = v0;
	this.v1 = v1;
	this.v2 = v2;
	this.v3 = v3;

}

CubicBezierCurve.prototype = Object.create( Curve.prototype );
CubicBezierCurve.prototype.constructor = CubicBezierCurve;

CubicBezierCurve.prototype.getPoint = function ( t ) {

	var b3 = ShapeUtils.b3;

	return new Vector2(
		b3( t, this.v0.x, this.v1.x, this.v2.x, this.v3.x ),
		b3( t, this.v0.y, this.v1.y, this.v2.y, this.v3.y )
	);

};

CubicBezierCurve.prototype.getTangent = function( t ) {

	var tangentCubicBezier = CurveUtils.tangentCubicBezier;

	return new Vector2(
		tangentCubicBezier( t, this.v0.x, this.v1.x, this.v2.x, this.v3.x ),
		tangentCubicBezier( t, this.v0.y, this.v1.y, this.v2.y, this.v3.y )
	).normalize();

};

/**************************************************************
 *	Quadratic Bezier curve
 **************************************************************/


function QuadraticBezierCurve( v0, v1, v2 ) {

	this.v0 = v0;
	this.v1 = v1;
	this.v2 = v2;

}

QuadraticBezierCurve.prototype = Object.create( Curve.prototype );
QuadraticBezierCurve.prototype.constructor = QuadraticBezierCurve;


QuadraticBezierCurve.prototype.getPoint = function ( t ) {

	var b2 = ShapeUtils.b2;

	return new Vector2(
		b2( t, this.v0.x, this.v1.x, this.v2.x ),
		b2( t, this.v0.y, this.v1.y, this.v2.y )
	);

};


QuadraticBezierCurve.prototype.getTangent = function( t ) {

	var tangentQuadraticBezier = CurveUtils.tangentQuadraticBezier;

	return new Vector2(
		tangentQuadraticBezier( t, this.v0.x, this.v1.x, this.v2.x ),
		tangentQuadraticBezier( t, this.v0.y, this.v1.y, this.v2.y )
	).normalize();

};

var PathPrototype = Object.assign( Object.create( CurvePath.prototype ), {

	fromPoints: function ( vectors ) {

		this.moveTo( vectors[ 0 ].x, vectors[ 0 ].y );

		for ( var i = 1, l = vectors.length; i < l; i ++ ) {

			this.lineTo( vectors[ i ].x, vectors[ i ].y );

		}

	},

	moveTo: function ( x, y ) {

		this.currentPoint.set( x, y ); // TODO consider referencing vectors instead of copying?

	},

	lineTo: function ( x, y ) {

		var curve = new LineCurve( this.currentPoint.clone(), new Vector2( x, y ) );
		this.curves.push( curve );

		this.currentPoint.set( x, y );

	},

	quadraticCurveTo: function ( aCPx, aCPy, aX, aY ) {

		var curve = new QuadraticBezierCurve(
			this.currentPoint.clone(),
			new Vector2( aCPx, aCPy ),
			new Vector2( aX, aY )
		);

		this.curves.push( curve );

		this.currentPoint.set( aX, aY );

	},

	bezierCurveTo: function ( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY ) {

		var curve = new CubicBezierCurve(
			this.currentPoint.clone(),
			new Vector2( aCP1x, aCP1y ),
			new Vector2( aCP2x, aCP2y ),
			new Vector2( aX, aY )
		);

		this.curves.push( curve );

		this.currentPoint.set( aX, aY );

	},

	splineThru: function ( pts /*Array of Vector*/ ) {

		var npts = [ this.currentPoint.clone() ].concat( pts );

		var curve = new SplineCurve( npts );
		this.curves.push( curve );

		this.currentPoint.copy( pts[ pts.length - 1 ] );

	},

	arc: function ( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {

		var x0 = this.currentPoint.x;
		var y0 = this.currentPoint.y;

		this.absarc( aX + x0, aY + y0, aRadius,
			aStartAngle, aEndAngle, aClockwise );

	},

	absarc: function ( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {

		this.absellipse( aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise );

	},

	ellipse: function ( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {

		var x0 = this.currentPoint.x;
		var y0 = this.currentPoint.y;

		this.absellipse( aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation );

	},

	absellipse: function ( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {

		var curve = new EllipseCurve( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation );

		if ( this.curves.length > 0 ) {

			// if a previous curve is present, attempt to join
			var firstPoint = curve.getPoint( 0 );

			if ( ! firstPoint.equals( this.currentPoint ) ) {

				this.lineTo( firstPoint.x, firstPoint.y );

			}

		}

		this.curves.push( curve );

		var lastPoint = curve.getPoint( 1 );
		this.currentPoint.copy( lastPoint );

	}

} );

/**
 * @author zz85 / http://www.lab4games.net/zz85/blog
 * Defines a 2d shape plane using paths.
 **/

// STEP 1 Create a path.
// STEP 2 Turn path into shape.
// STEP 3 ExtrudeGeometry takes in Shape/Shapes
// STEP 3a - Extract points from each shape, turn to vertices
// STEP 3b - Triangulate each shape, add faces.

function Shape() {

	Path.apply( this, arguments );

	this.holes = [];

}

Shape.prototype = Object.assign( Object.create( PathPrototype ), {

	constructor: Shape,

	getPointsHoles: function ( divisions ) {

		var holesPts = [];

		for ( var i = 0, l = this.holes.length; i < l; i ++ ) {

			holesPts[ i ] = this.holes[ i ].getPoints( divisions );

		}

		return holesPts;

	},

	// Get points of shape and holes (keypoints based on segments parameter)

	extractAllPoints: function ( divisions ) {

		return {

			shape: this.getPoints( divisions ),
			holes: this.getPointsHoles( divisions )

		};

	},

	extractPoints: function ( divisions ) {

		return this.extractAllPoints( divisions );

	}

} );

/**
 * @author zz85 / http://www.lab4games.net/zz85/blog
 * Creates free form 2d path using series of points, lines or curves.
 *
 **/

function Path( points ) {

	CurvePath.call( this );
	this.currentPoint = new Vector2();

	if ( points ) {

		this.fromPoints( points );

	}

}

Path.prototype = PathPrototype;
PathPrototype.constructor = Path;


// minimal class for proxing functions to Path. Replaces old "extractSubpaths()"
function ShapePath() {
	this.subPaths = [];
	this.currentPath = null;
}

ShapePath.prototype = {
	moveTo: function ( x, y ) {
		this.currentPath = new Path();
		this.subPaths.push(this.currentPath);
		this.currentPath.moveTo( x, y );
	},
	lineTo: function ( x, y ) {
		this.currentPath.lineTo( x, y );
	},
	quadraticCurveTo: function ( aCPx, aCPy, aX, aY ) {
		this.currentPath.quadraticCurveTo( aCPx, aCPy, aX, aY );
	},
	bezierCurveTo: function ( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY ) {
		this.currentPath.bezierCurveTo( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY );
	},
	splineThru: function ( pts ) {
		this.currentPath.splineThru( pts );
	},

	toShapes: function ( isCCW, noHoles ) {

		function toShapesNoHoles( inSubpaths ) {

			var shapes = [];

			for ( var i = 0, l = inSubpaths.length; i < l; i ++ ) {

				var tmpPath = inSubpaths[ i ];

				var tmpShape = new Shape();
				tmpShape.curves = tmpPath.curves;

				shapes.push( tmpShape );

			}

			return shapes;

		}

		function isPointInsidePolygon( inPt, inPolygon ) {

			var polyLen = inPolygon.length;

			// inPt on polygon contour => immediate success    or
			// toggling of inside/outside at every single! intersection point of an edge
			//  with the horizontal line through inPt, left of inPt
			//  not counting lowerY endpoints of edges and whole edges on that line
			var inside = false;
			for ( var p = polyLen - 1, q = 0; q < polyLen; p = q ++ ) {

				var edgeLowPt  = inPolygon[ p ];
				var edgeHighPt = inPolygon[ q ];

				var edgeDx = edgeHighPt.x - edgeLowPt.x;
				var edgeDy = edgeHighPt.y - edgeLowPt.y;

				if ( Math.abs( edgeDy ) > Number.EPSILON ) {

					// not parallel
					if ( edgeDy < 0 ) {

						edgeLowPt  = inPolygon[ q ]; edgeDx = - edgeDx;
						edgeHighPt = inPolygon[ p ]; edgeDy = - edgeDy;

					}
					if ( ( inPt.y < edgeLowPt.y ) || ( inPt.y > edgeHighPt.y ) ) 		continue;

					if ( inPt.y === edgeLowPt.y ) {

						if ( inPt.x === edgeLowPt.x )		return	true;		// inPt is on contour ?
						// continue;				// no intersection or edgeLowPt => doesn't count !!!

					} else {

						var perpEdge = edgeDy * ( inPt.x - edgeLowPt.x ) - edgeDx * ( inPt.y - edgeLowPt.y );
						if ( perpEdge === 0 )				return	true;		// inPt is on contour ?
						if ( perpEdge < 0 ) 				continue;
						inside = ! inside;		// true intersection left of inPt

					}

				} else {

					// parallel or collinear
					if ( inPt.y !== edgeLowPt.y ) 		continue;			// parallel
					// edge lies on the same horizontal line as inPt
					if ( ( ( edgeHighPt.x <= inPt.x ) && ( inPt.x <= edgeLowPt.x ) ) ||
						 ( ( edgeLowPt.x <= inPt.x ) && ( inPt.x <= edgeHighPt.x ) ) )		return	true;	// inPt: Point on contour !
					// continue;

				}

			}

			return	inside;

		}

		var isClockWise = ShapeUtils.isClockWise;

		var subPaths = this.subPaths;
		if ( subPaths.length === 0 ) return [];

		if ( noHoles === true )	return	toShapesNoHoles( subPaths );


		var solid, tmpPath, tmpShape, shapes = [];

		if ( subPaths.length === 1 ) {

			tmpPath = subPaths[ 0 ];
			tmpShape = new Shape();
			tmpShape.curves = tmpPath.curves;
			shapes.push( tmpShape );
			return shapes;

		}

		var holesFirst = ! isClockWise( subPaths[ 0 ].getPoints() );
		holesFirst = isCCW ? ! holesFirst : holesFirst;

		// console.log("Holes first", holesFirst);

		var betterShapeHoles = [];
		var newShapes = [];
		var newShapeHoles = [];
		var mainIdx = 0;
		var tmpPoints;

		newShapes[ mainIdx ] = undefined;
		newShapeHoles[ mainIdx ] = [];

		for ( var i = 0, l = subPaths.length; i < l; i ++ ) {

			tmpPath = subPaths[ i ];
			tmpPoints = tmpPath.getPoints();
			solid = isClockWise( tmpPoints );
			solid = isCCW ? ! solid : solid;

			if ( solid ) {

				if ( ( ! holesFirst ) && ( newShapes[ mainIdx ] ) )	mainIdx ++;

				newShapes[ mainIdx ] = { s: new Shape(), p: tmpPoints };
				newShapes[ mainIdx ].s.curves = tmpPath.curves;

				if ( holesFirst )	mainIdx ++;
				newShapeHoles[ mainIdx ] = [];

				//console.log('cw', i);

			} else {

				newShapeHoles[ mainIdx ].push( { h: tmpPath, p: tmpPoints[ 0 ] } );

				//console.log('ccw', i);

			}

		}

		// only Holes? -> probably all Shapes with wrong orientation
		if ( ! newShapes[ 0 ] )	return	toShapesNoHoles( subPaths );


		if ( newShapes.length > 1 ) {

			var ambiguous = false;
			var toChange = [];

			for ( var sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx ++ ) {

				betterShapeHoles[ sIdx ] = [];

			}

			for ( var sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx ++ ) {

				var sho = newShapeHoles[ sIdx ];

				for ( var hIdx = 0; hIdx < sho.length; hIdx ++ ) {

					var ho = sho[ hIdx ];
					var hole_unassigned = true;

					for ( var s2Idx = 0; s2Idx < newShapes.length; s2Idx ++ ) {

						if ( isPointInsidePolygon( ho.p, newShapes[ s2Idx ].p ) ) {

							if ( sIdx !== s2Idx )	toChange.push( { froms: sIdx, tos: s2Idx, hole: hIdx } );
							if ( hole_unassigned ) {

								hole_unassigned = false;
								betterShapeHoles[ s2Idx ].push( ho );

							} else {

								ambiguous = true;

							}

						}

					}
					if ( hole_unassigned ) {

						betterShapeHoles[ sIdx ].push( ho );

					}

				}

			}
			// console.log("ambiguous: ", ambiguous);
			if ( toChange.length > 0 ) {

				// console.log("to change: ", toChange);
				if ( ! ambiguous )	newShapeHoles = betterShapeHoles;

			}

		}

		var tmpHoles;

		for ( var i = 0, il = newShapes.length; i < il; i ++ ) {

			tmpShape = newShapes[ i ].s;
			shapes.push( tmpShape );
			tmpHoles = newShapeHoles[ i ];

			for ( var j = 0, jl = tmpHoles.length; j < jl; j ++ ) {

				tmpShape.holes.push( tmpHoles[ j ].h );

			}

		}

		//console.log("shape", shapes);

		return shapes;

	}
};

/**
 * @author zz85 / http://www.lab4games.net/zz85/blog
 * @author mrdoob / http://mrdoob.com/
 */

function Font( data ) {

	this.data = data;

}

Object.assign( Font.prototype, {

	isFont: true,

	generateShapes: function ( text, size, divisions ) {

		function createPaths( text ) {

			var chars = String( text ).split( '' );
			var scale = size / data.resolution;
			var offset = 0;

			var paths = [];

			for ( var i = 0; i < chars.length; i ++ ) {

				var ret = createPath( chars[ i ], scale, offset );
				offset += ret.offset;

				paths.push( ret.path );

			}

			return paths;

		}

		function createPath( c, scale, offset ) {

			var glyph = data.glyphs[ c ] || data.glyphs[ '?' ];

			if ( ! glyph ) return;

			var path = new ShapePath();

			var pts = [], b2 = ShapeUtils.b2, b3 = ShapeUtils.b3;
			var x, y, cpx, cpy, cpx0, cpy0, cpx1, cpy1, cpx2, cpy2, laste;

			if ( glyph.o ) {

				var outline = glyph._cachedOutline || ( glyph._cachedOutline = glyph.o.split( ' ' ) );

				for ( var i = 0, l = outline.length; i < l; ) {

					var action = outline[ i ++ ];

					switch ( action ) {

						case 'm': // moveTo

							x = outline[ i ++ ] * scale + offset;
							y = outline[ i ++ ] * scale;

							path.moveTo( x, y );

							break;

						case 'l': // lineTo

							x = outline[ i ++ ] * scale + offset;
							y = outline[ i ++ ] * scale;

							path.lineTo( x, y );

							break;

						case 'q': // quadraticCurveTo

							cpx  = outline[ i ++ ] * scale + offset;
							cpy  = outline[ i ++ ] * scale;
							cpx1 = outline[ i ++ ] * scale + offset;
							cpy1 = outline[ i ++ ] * scale;

							path.quadraticCurveTo( cpx1, cpy1, cpx, cpy );

							laste = pts[ pts.length - 1 ];

							if ( laste ) {

								cpx0 = laste.x;
								cpy0 = laste.y;

								for ( var i2 = 1; i2 <= divisions; i2 ++ ) {

									var t = i2 / divisions;
									b2( t, cpx0, cpx1, cpx );
									b2( t, cpy0, cpy1, cpy );

								}

							}

							break;

						case 'b': // bezierCurveTo

							cpx  = outline[ i ++ ] * scale + offset;
							cpy  = outline[ i ++ ] * scale;
							cpx1 = outline[ i ++ ] * scale + offset;
							cpy1 = outline[ i ++ ] * scale;
							cpx2 = outline[ i ++ ] * scale + offset;
							cpy2 = outline[ i ++ ] * scale;

							path.bezierCurveTo( cpx1, cpy1, cpx2, cpy2, cpx, cpy );

							laste = pts[ pts.length - 1 ];

							if ( laste ) {

								cpx0 = laste.x;
								cpy0 = laste.y;

								for ( var i2 = 1; i2 <= divisions; i2 ++ ) {

									var t = i2 / divisions;
									b3( t, cpx0, cpx1, cpx2, cpx );
									b3( t, cpy0, cpy1, cpy2, cpy );

								}

							}

							break;

					}

				}

			}

			return { offset: glyph.ha * scale, path: path };

		}

		//

		if ( size === undefined ) size = 100;
		if ( divisions === undefined ) divisions = 4;

		var data = this.data;

		var paths = createPaths( text );
		var shapes = [];

		for ( var p = 0, pl = paths.length; p < pl; p ++ ) {

			Array.prototype.push.apply( shapes, paths[ p ].toShapes() );

		}

		return shapes;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function FontLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

}

Object.assign( FontLoader.prototype, {

	load: function ( url, onLoad, onProgress, onError ) {

		var scope = this;

		var loader = new FileLoader( this.manager );
		loader.load( url, function ( text ) {

			var json;

			try {

				json = JSON.parse( text );

			} catch ( e ) {

				console.warn( 'THREE.FontLoader: typeface.js support is being deprecated. Use typeface.json instead.' );
				json = JSON.parse( text.substring( 65, text.length - 2 ) );

			}

			var font = scope.parse( json );

			if ( onLoad ) onLoad( font );

		}, onProgress, onError );

	},

	parse: function ( json ) {

		return new Font( json );

	}

} );

var context;

var AudioContext = {

	getContext: function () {

		if ( context === undefined ) {

			context = new ( window.AudioContext || window.webkitAudioContext )();

		}

		return context;

	},

	setContext: function ( value ) {

		context = value;

	}

};

/**
 * @author Reece Aaron Lecrivain / http://reecenotes.com/
 */

function AudioLoader( manager ) {

	this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

}

Object.assign( AudioLoader.prototype, {

	load: function ( url, onLoad, onProgress, onError ) {

		var loader = new FileLoader( this.manager );
		loader.setResponseType( 'arraybuffer' );
		loader.load( url, function ( buffer ) {

			var context = AudioContext.getContext();

			context.decodeAudioData( buffer, function ( audioBuffer ) {

				onLoad( audioBuffer );

			} );

		}, onProgress, onError );

	}

} );

/**
 * @author abelnation / http://github.com/abelnation
 */

function RectAreaLight ( color, intensity, width, height ) {

	Light.call( this, color, intensity );

	this.type = 'RectAreaLight';

	this.position.set( 0, 1, 0 );
	this.updateMatrix();

	this.width = ( width !== undefined ) ? width : 10;
	this.height = ( height !== undefined ) ? height : 10;

	// TODO (abelnation): distance/decay

	// TODO (abelnation): update method for RectAreaLight to update transform to lookat target

	// TODO (abelnation): shadows
	// this.shadow = new THREE.RectAreaLightShadow( new THREE.PerspectiveCamera( 90, 1, 0.5, 500 ) );

}

// TODO (abelnation): RectAreaLight update when light shape is changed
RectAreaLight.prototype = Object.assign( Object.create( Light.prototype ), {

	constructor: RectAreaLight,

	isRectAreaLight: true,

	copy: function ( source ) {

		Light.prototype.copy.call( this, source );

		this.width = source.width;
		this.height = source.height;

		// this.shadow = source.shadow.clone();

		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function StereoCamera() {

	this.type = 'StereoCamera';

	this.aspect = 1;

	this.eyeSep = 0.064;

	this.cameraL = new PerspectiveCamera();
	this.cameraL.layers.enable( 1 );
	this.cameraL.matrixAutoUpdate = false;

	this.cameraR = new PerspectiveCamera();
	this.cameraR.layers.enable( 2 );
	this.cameraR.matrixAutoUpdate = false;

}

Object.assign( StereoCamera.prototype, {

	update: ( function () {

		var instance, focus, fov, aspect, near, far, zoom;

		var eyeRight = new Matrix4();
		var eyeLeft = new Matrix4();

		return function update( camera ) {

			var needsUpdate = instance !== this || focus !== camera.focus || fov !== camera.fov ||
												aspect !== camera.aspect * this.aspect || near !== camera.near ||
												far !== camera.far || zoom !== camera.zoom;

			if ( needsUpdate ) {

				instance = this;
				focus = camera.focus;
				fov = camera.fov;
				aspect = camera.aspect * this.aspect;
				near = camera.near;
				far = camera.far;
				zoom = camera.zoom;

				// Off-axis stereoscopic effect based on
				// http://paulbourke.net/stereographics/stereorender/

				var projectionMatrix = camera.projectionMatrix.clone();
				var eyeSep = this.eyeSep / 2;
				var eyeSepOnProjection = eyeSep * near / focus;
				var ymax = ( near * Math.tan( _Math.DEG2RAD * fov * 0.5 ) ) / zoom;
				var xmin, xmax;

				// translate xOffset

				eyeLeft.elements[ 12 ] = - eyeSep;
				eyeRight.elements[ 12 ] = eyeSep;

				// for left eye

				xmin = - ymax * aspect + eyeSepOnProjection;
				xmax = ymax * aspect + eyeSepOnProjection;

				projectionMatrix.elements[ 0 ] = 2 * near / ( xmax - xmin );
				projectionMatrix.elements[ 8 ] = ( xmax + xmin ) / ( xmax - xmin );

				this.cameraL.projectionMatrix.copy( projectionMatrix );

				// for right eye

				xmin = - ymax * aspect - eyeSepOnProjection;
				xmax = ymax * aspect - eyeSepOnProjection;

				projectionMatrix.elements[ 0 ] = 2 * near / ( xmax - xmin );
				projectionMatrix.elements[ 8 ] = ( xmax + xmin ) / ( xmax - xmin );

				this.cameraR.projectionMatrix.copy( projectionMatrix );

			}

			this.cameraL.matrixWorld.copy( camera.matrixWorld ).multiply( eyeLeft );
			this.cameraR.matrixWorld.copy( camera.matrixWorld ).multiply( eyeRight );

		};

	} )()

} );

/**
 * Camera for rendering cube maps
 *	- renders scene into axis-aligned cube
 *
 * @author alteredq / http://alteredqualia.com/
 */

function CubeCamera( near, far, cubeResolution ) {

	Object3D.call( this );

	this.type = 'CubeCamera';

	var fov = 90, aspect = 1;

	var cameraPX = new PerspectiveCamera( fov, aspect, near, far );
	cameraPX.up.set( 0, - 1, 0 );
	cameraPX.lookAt( new Vector3( 1, 0, 0 ) );
	this.add( cameraPX );

	var cameraNX = new PerspectiveCamera( fov, aspect, near, far );
	cameraNX.up.set( 0, - 1, 0 );
	cameraNX.lookAt( new Vector3( - 1, 0, 0 ) );
	this.add( cameraNX );

	var cameraPY = new PerspectiveCamera( fov, aspect, near, far );
	cameraPY.up.set( 0, 0, 1 );
	cameraPY.lookAt( new Vector3( 0, 1, 0 ) );
	this.add( cameraPY );

	var cameraNY = new PerspectiveCamera( fov, aspect, near, far );
	cameraNY.up.set( 0, 0, - 1 );
	cameraNY.lookAt( new Vector3( 0, - 1, 0 ) );
	this.add( cameraNY );

	var cameraPZ = new PerspectiveCamera( fov, aspect, near, far );
	cameraPZ.up.set( 0, - 1, 0 );
	cameraPZ.lookAt( new Vector3( 0, 0, 1 ) );
	this.add( cameraPZ );

	var cameraNZ = new PerspectiveCamera( fov, aspect, near, far );
	cameraNZ.up.set( 0, - 1, 0 );
	cameraNZ.lookAt( new Vector3( 0, 0, - 1 ) );
	this.add( cameraNZ );

	var options = { format: RGBFormat, magFilter: LinearFilter, minFilter: LinearFilter };

	this.renderTarget = new WebGLRenderTargetCube( cubeResolution, cubeResolution, options );

	this.updateCubeMap = function ( renderer, scene ) {

		if ( this.parent === null ) this.updateMatrixWorld();

		var renderTarget = this.renderTarget;
		var generateMipmaps = renderTarget.texture.generateMipmaps;

		renderTarget.texture.generateMipmaps = false;

		renderTarget.activeCubeFace = 0;
		renderer.render( scene, cameraPX, renderTarget );

		renderTarget.activeCubeFace = 1;
		renderer.render( scene, cameraNX, renderTarget );

		renderTarget.activeCubeFace = 2;
		renderer.render( scene, cameraPY, renderTarget );

		renderTarget.activeCubeFace = 3;
		renderer.render( scene, cameraNY, renderTarget );

		renderTarget.activeCubeFace = 4;
		renderer.render( scene, cameraPZ, renderTarget );

		renderTarget.texture.generateMipmaps = generateMipmaps;

		renderTarget.activeCubeFace = 5;
		renderer.render( scene, cameraNZ, renderTarget );

		renderer.setRenderTarget( null );

	};

}

CubeCamera.prototype = Object.create( Object3D.prototype );
CubeCamera.prototype.constructor = CubeCamera;

/**
 * @author mrdoob / http://mrdoob.com/
 */

function AudioListener() {

	Object3D.call( this );

	this.type = 'AudioListener';

	this.context = AudioContext.getContext();

	this.gain = this.context.createGain();
	this.gain.connect( this.context.destination );

	this.filter = null;

}

AudioListener.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: AudioListener,

	getInput: function () {

		return this.gain;

	},

	removeFilter: function ( ) {

		if ( this.filter !== null ) {

			this.gain.disconnect( this.filter );
			this.filter.disconnect( this.context.destination );
			this.gain.connect( this.context.destination );
			this.filter = null;

		}

	},

	getFilter: function () {

		return this.filter;

	},

	setFilter: function ( value ) {

		if ( this.filter !== null ) {

			this.gain.disconnect( this.filter );
			this.filter.disconnect( this.context.destination );

		} else {

			this.gain.disconnect( this.context.destination );

		}

		this.filter = value;
		this.gain.connect( this.filter );
		this.filter.connect( this.context.destination );

	},

	getMasterVolume: function () {

		return this.gain.gain.value;

	},

	setMasterVolume: function ( value ) {

		this.gain.gain.value = value;

	},

	updateMatrixWorld: ( function () {

		var position = new Vector3();
		var quaternion = new Quaternion();
		var scale = new Vector3();

		var orientation = new Vector3();

		return function updateMatrixWorld( force ) {

			Object3D.prototype.updateMatrixWorld.call( this, force );

			var listener = this.context.listener;
			var up = this.up;

			this.matrixWorld.decompose( position, quaternion, scale );

			orientation.set( 0, 0, - 1 ).applyQuaternion( quaternion );

			if ( listener.positionX ) {

				listener.positionX.setValueAtTime( position.x, this.context.currentTime );
				listener.positionY.setValueAtTime( position.y, this.context.currentTime );
				listener.positionZ.setValueAtTime( position.z, this.context.currentTime );
				listener.forwardX.setValueAtTime( orientation.x, this.context.currentTime );
				listener.forwardY.setValueAtTime( orientation.y, this.context.currentTime );
				listener.forwardZ.setValueAtTime( orientation.z, this.context.currentTime );
				listener.upX.setValueAtTime( up.x, this.context.currentTime );
				listener.upY.setValueAtTime( up.y, this.context.currentTime );
				listener.upZ.setValueAtTime( up.z, this.context.currentTime );

			} else {

				listener.setPosition( position.x, position.y, position.z );
				listener.setOrientation( orientation.x, orientation.y, orientation.z, up.x, up.y, up.z );

			}

		};

	} )()

} );

/**
 * @author mrdoob / http://mrdoob.com/
 * @author Reece Aaron Lecrivain / http://reecenotes.com/
 */

function Audio( listener ) {

	Object3D.call( this );

	this.type = 'Audio';

	this.context = listener.context;

	this.gain = this.context.createGain();
	this.gain.connect( listener.getInput() );

	this.autoplay = false;

	this.buffer = null;
	this.loop = false;
	this.startTime = 0;
	this.playbackRate = 1;
	this.isPlaying = false;
	this.hasPlaybackControl = true;
	this.sourceType = 'empty';

	this.filters = [];

}

Audio.prototype = Object.assign( Object.create( Object3D.prototype ), {

	constructor: Audio,

	getOutput: function () {

		return this.gain;

	},

	setNodeSource: function ( audioNode ) {

		this.hasPlaybackControl = false;
		this.sourceType = 'audioNode';
		this.source = audioNode;
		this.connect();

		return this;

	},

	setBuffer: function ( audioBuffer ) {

		this.buffer = audioBuffer;
		this.sourceType = 'buffer';

		if ( this.autoplay ) this.play();

		return this;

	},

	play: function () {

		if ( this.isPlaying === true ) {

			console.warn( 'THREE.Audio: Audio is already playing.' );
			return;

		}

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return;

		}

		var source = this.context.createBufferSource();

		source.buffer = this.buffer;
		source.loop = this.loop;
		source.onended = this.onEnded.bind( this );
		source.playbackRate.setValueAtTime( this.playbackRate, this.startTime );
		source.start( 0, this.startTime );

		this.isPlaying = true;

		this.source = source;

		return this.connect();

	},

	pause: function () {

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return;

		}

		this.source.stop();
		this.startTime = this.context.currentTime;
		this.isPlaying = false;

		return this;

	},

	stop: function () {

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return;

		}

		this.source.stop();
		this.startTime = 0;
		this.isPlaying = false;

		return this;

	},

	connect: function () {

		if ( this.filters.length > 0 ) {

			this.source.connect( this.filters[ 0 ] );

			for ( var i = 1, l = this.filters.length; i < l; i ++ ) {

				this.filters[ i - 1 ].connect( this.filters[ i ] );

			}

			this.filters[ this.filters.length - 1 ].connect( this.getOutput() );

		} else {

			this.source.connect( this.getOutput() );

		}

		return this;

	},

	disconnect: function () {

		if ( this.filters.length > 0 ) {

			this.source.disconnect( this.filters[ 0 ] );

			for ( var i = 1, l = this.filters.length; i < l; i ++ ) {

				this.filters[ i - 1 ].disconnect( this.filters[ i ] );

			}

			this.filters[ this.filters.length - 1 ].disconnect( this.getOutput() );

		} else {

			this.source.disconnect( this.getOutput() );

		}

		return this;

	},

	getFilters: function () {

		return this.filters;

	},

	setFilters: function ( value ) {

		if ( ! value ) value = [];

		if ( this.isPlaying === true ) {

			this.disconnect();
			this.filters = value;
			this.connect();

		} else {

			this.filters = value;

		}

		return this;

	},

	getFilter: function () {

		return this.getFilters()[ 0 ];

	},

	setFilter: function ( filter ) {

		return this.setFilters( filter ? [ filter ] : [] );

	},

	setPlaybackRate: function ( value ) {

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return;

		}

		this.playbackRate = value;

		if ( this.isPlaying === true ) {

			this.source.playbackRate.setValueAtTime( this.playbackRate, this.context.currentTime );

		}

		return this;

	},

	getPlaybackRate: function () {

		return this.playbackRate;

	},

	onEnded: function () {

		this.isPlaying = false;

	},

	getLoop: function () {

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return false;

		}

		return this.loop;

	},

	setLoop: function ( value ) {

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return;

		}

		this.loop = value;

		if ( this.isPlaying === true ) {

			this.source.loop = this.loop;

		}

		return this;

	},

	getVolume: function () {

		return this.gain.gain.value;

	},


	setVolume: function ( value ) {

		this.gain.gain.value = value;

		return this;

	}

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function PositionalAudio( listener ) {

	Audio.call( this, listener );

	this.panner = this.context.createPanner();
	this.panner.connect( this.gain );

}

PositionalAudio.prototype = Object.assign( Object.create( Audio.prototype ), {

	constructor: PositionalAudio,

	getOutput: function () {

		return this.panner;

	},

	getRefDistance: function () {

		return this.panner.refDistance;

	},

	setRefDistance: function ( value ) {

		this.panner.refDistance = value;

	},

	getRolloffFactor: function () {

		return this.panner.rolloffFactor;

	},

	setRolloffFactor: function ( value ) {

		this.panner.rolloffFactor = value;

	},

	getDistanceModel: function () {

		return this.panner.distanceModel;

	},

	setDistanceModel: function ( value ) {

		this.panner.distanceModel = value;

	},

	getMaxDistance: function () {

		return this.panner.maxDistance;

	},

	setMaxDistance: function ( value ) {

		this.panner.maxDistance = value;

	},

	updateMatrixWorld: ( function () {

		var position = new Vector3();

		return function updateMatrixWorld( force ) {

			Object3D.prototype.updateMatrixWorld.call( this, force );

			position.setFromMatrixPosition( this.matrixWorld );

			this.panner.setPosition( position.x, position.y, position.z );

		};

	} )()


} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function AudioAnalyser( audio, fftSize ) {

	this.analyser = audio.context.createAnalyser();
	this.analyser.fftSize = fftSize !== undefined ? fftSize : 2048;

	this.data = new Uint8Array( this.analyser.frequencyBinCount );

	audio.getOutput().connect( this.analyser );

}

Object.assign( AudioAnalyser.prototype, {

	getFrequencyData: function () {

		this.analyser.getByteFrequencyData( this.data );

		return this.data;

	},

	getAverageFrequency: function () {

		var value = 0, data = this.getFrequencyData();

		for ( var i = 0; i < data.length; i ++ ) {

			value += data[ i ];

		}

		return value / data.length;

	}

} );

/**
 *
 * Buffered scene graph property that allows weighted accumulation.
 *
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 */

function PropertyMixer( binding, typeName, valueSize ) {

	this.binding = binding;
	this.valueSize = valueSize;

	var bufferType = Float64Array,
		mixFunction;

	switch ( typeName ) {

		case 'quaternion':
			mixFunction = this._slerp;
			break;

		case 'string':
		case 'bool':
			bufferType = Array;
			mixFunction = this._select;
			break;

		default:
			mixFunction = this._lerp;

	}

	this.buffer = new bufferType( valueSize * 4 );
	// layout: [ incoming | accu0 | accu1 | orig ]
	//
	// interpolators can use .buffer as their .result
	// the data then goes to 'incoming'
	//
	// 'accu0' and 'accu1' are used frame-interleaved for
	// the cumulative result and are compared to detect
	// changes
	//
	// 'orig' stores the original state of the property

	this._mixBufferRegion = mixFunction;

	this.cumulativeWeight = 0;

	this.useCount = 0;
	this.referenceCount = 0;

}

PropertyMixer.prototype = {

	constructor: PropertyMixer,

	// accumulate data in the 'incoming' region into 'accu<i>'
	accumulate: function( accuIndex, weight ) {

		// note: happily accumulating nothing when weight = 0, the caller knows
		// the weight and shouldn't have made the call in the first place

		var buffer = this.buffer,
			stride = this.valueSize,
			offset = accuIndex * stride + stride,

			currentWeight = this.cumulativeWeight;

		if ( currentWeight === 0 ) {

			// accuN := incoming * weight

			for ( var i = 0; i !== stride; ++ i ) {

				buffer[ offset + i ] = buffer[ i ];

			}

			currentWeight = weight;

		} else {

			// accuN := accuN + incoming * weight

			currentWeight += weight;
			var mix = weight / currentWeight;
			this._mixBufferRegion( buffer, offset, 0, mix, stride );

		}

		this.cumulativeWeight = currentWeight;

	},

	// apply the state of 'accu<i>' to the binding when accus differ
	apply: function( accuIndex ) {

		var stride = this.valueSize,
			buffer = this.buffer,
			offset = accuIndex * stride + stride,

			weight = this.cumulativeWeight,

			binding = this.binding;

		this.cumulativeWeight = 0;

		if ( weight < 1 ) {

			// accuN := accuN + original * ( 1 - cumulativeWeight )

			var originalValueOffset = stride * 3;

			this._mixBufferRegion(
					buffer, offset, originalValueOffset, 1 - weight, stride );

		}

		for ( var i = stride, e = stride + stride; i !== e; ++ i ) {

			if ( buffer[ i ] !== buffer[ i + stride ] ) {

				// value has changed -> update scene graph

				binding.setValue( buffer, offset );
				break;

			}

		}

	},

	// remember the state of the bound property and copy it to both accus
	saveOriginalState: function() {

		var binding = this.binding;

		var buffer = this.buffer,
			stride = this.valueSize,

			originalValueOffset = stride * 3;

		binding.getValue( buffer, originalValueOffset );

		// accu[0..1] := orig -- initially detect changes against the original
		for ( var i = stride, e = originalValueOffset; i !== e; ++ i ) {

			buffer[ i ] = buffer[ originalValueOffset + ( i % stride ) ];

		}

		this.cumulativeWeight = 0;

	},

	// apply the state previously taken via 'saveOriginalState' to the binding
	restoreOriginalState: function() {

		var originalValueOffset = this.valueSize * 3;
		this.binding.setValue( this.buffer, originalValueOffset );

	},


	// mix functions

	_select: function( buffer, dstOffset, srcOffset, t, stride ) {

		if ( t >= 0.5 ) {

			for ( var i = 0; i !== stride; ++ i ) {

				buffer[ dstOffset + i ] = buffer[ srcOffset + i ];

			}

		}

	},

	_slerp: function( buffer, dstOffset, srcOffset, t, stride ) {

		Quaternion.slerpFlat( buffer, dstOffset,
				buffer, dstOffset, buffer, srcOffset, t );

	},

	_lerp: function( buffer, dstOffset, srcOffset, t, stride ) {

		var s = 1 - t;

		for ( var i = 0; i !== stride; ++ i ) {

			var j = dstOffset + i;

			buffer[ j ] = buffer[ j ] * s + buffer[ srcOffset + i ] * t;

		}

	}

};

/**
 *
 * A reference to a real property in the scene graph.
 *
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 */

function PropertyBinding( rootNode, path, parsedPath ) {

	this.path = path;
	this.parsedPath = parsedPath ||
			PropertyBinding.parseTrackName( path );

	this.node = PropertyBinding.findNode(
			rootNode, this.parsedPath.nodeName ) || rootNode;

	this.rootNode = rootNode;

}

PropertyBinding.prototype = {

	constructor: PropertyBinding,

	getValue: function getValue_unbound( targetArray, offset ) {

		this.bind();
		this.getValue( targetArray, offset );

		// Note: This class uses a State pattern on a per-method basis:
		// 'bind' sets 'this.getValue' / 'setValue' and shadows the
		// prototype version of these methods with one that represents
		// the bound state. When the property is not found, the methods
		// become no-ops.

	},

	setValue: function getValue_unbound( sourceArray, offset ) {

		this.bind();
		this.setValue( sourceArray, offset );

	},

	// create getter / setter pair for a property in the scene graph
	bind: function() {

		var targetObject = this.node,
			parsedPath = this.parsedPath,

			objectName = parsedPath.objectName,
			propertyName = parsedPath.propertyName,
			propertyIndex = parsedPath.propertyIndex;

		if ( ! targetObject ) {

			targetObject = PropertyBinding.findNode(
					this.rootNode, parsedPath.nodeName ) || this.rootNode;

			this.node = targetObject;

		}

		// set fail state so we can just 'return' on error
		this.getValue = this._getValue_unavailable;
		this.setValue = this._setValue_unavailable;

 		// ensure there is a value node
		if ( ! targetObject ) {

			console.error( "  trying to update node for track: " + this.path + " but it wasn't found." );
			return;

		}

		if ( objectName ) {

			var objectIndex = parsedPath.objectIndex;

			// special cases were we need to reach deeper into the hierarchy to get the face materials....
			switch ( objectName ) {

				case 'materials':

					if ( ! targetObject.material ) {

						console.error( '  can not bind to material as node does not have a material', this );
						return;

					}

					if ( ! targetObject.material.materials ) {

						console.error( '  can not bind to material.materials as node.material does not have a materials array', this );
						return;

					}

					targetObject = targetObject.material.materials;

					break;

				case 'bones':

					if ( ! targetObject.skeleton ) {

						console.error( '  can not bind to bones as node does not have a skeleton', this );
						return;

					}

					// potential future optimization: skip this if propertyIndex is already an integer
					// and convert the integer string to a true integer.

					targetObject = targetObject.skeleton.bones;

					// support resolving morphTarget names into indices.
					for ( var i = 0; i < targetObject.length; i ++ ) {

						if ( targetObject[ i ].name === objectIndex ) {

							objectIndex = i;
							break;

						}

					}

					break;

				default:

					if ( targetObject[ objectName ] === undefined ) {

						console.error( '  can not bind to objectName of node, undefined', this );
						return;

					}

					targetObject = targetObject[ objectName ];

			}


			if ( objectIndex !== undefined ) {

				if ( targetObject[ objectIndex ] === undefined ) {

					console.error( "  trying to bind to objectIndex of objectName, but is undefined:", this, targetObject );
					return;

				}

				targetObject = targetObject[ objectIndex ];

			}

		}

		// resolve property
		var nodeProperty = targetObject[ propertyName ];

		if ( nodeProperty === undefined ) {

			var nodeName = parsedPath.nodeName;

			console.error( "  trying to update property for track: " + nodeName +
					'.' + propertyName + " but it wasn't found.", targetObject );
			return;

		}

		// determine versioning scheme
		var versioning = this.Versioning.None;

		if ( targetObject.needsUpdate !== undefined ) { // material

			versioning = this.Versioning.NeedsUpdate;
			this.targetObject = targetObject;

		} else if ( targetObject.matrixWorldNeedsUpdate !== undefined ) { // node transform

			versioning = this.Versioning.MatrixWorldNeedsUpdate;
			this.targetObject = targetObject;

		}

		// determine how the property gets bound
		var bindingType = this.BindingType.Direct;

		if ( propertyIndex !== undefined ) {
			// access a sub element of the property array (only primitives are supported right now)

			if ( propertyName === "morphTargetInfluences" ) {
				// potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.

				// support resolving morphTarget names into indices.
				if ( ! targetObject.geometry ) {

					console.error( '  can not bind to morphTargetInfluences becasuse node does not have a geometry', this );
					return;

				}

				if ( ! targetObject.geometry.morphTargets ) {

					console.error( '  can not bind to morphTargetInfluences becasuse node does not have a geometry.morphTargets', this );
					return;

				}

				for ( var i = 0; i < this.node.geometry.morphTargets.length; i ++ ) {

					if ( targetObject.geometry.morphTargets[ i ].name === propertyIndex ) {

						propertyIndex = i;
						break;

					}

				}

			}

			bindingType = this.BindingType.ArrayElement;

			this.resolvedProperty = nodeProperty;
			this.propertyIndex = propertyIndex;

		} else if ( nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined ) {
			// must use copy for Object3D.Euler/Quaternion

			bindingType = this.BindingType.HasFromToArray;

			this.resolvedProperty = nodeProperty;

		} else if ( nodeProperty.length !== undefined ) {

			bindingType = this.BindingType.EntireArray;

			this.resolvedProperty = nodeProperty;

		} else {

			this.propertyName = propertyName;

		}

		// select getter / setter
		this.getValue = this.GetterByBindingType[ bindingType ];
		this.setValue = this.SetterByBindingTypeAndVersioning[ bindingType ][ versioning ];

	},

	unbind: function() {

		this.node = null;

		// back to the prototype version of getValue / setValue
		// note: avoiding to mutate the shape of 'this' via 'delete'
		this.getValue = this._getValue_unbound;
		this.setValue = this._setValue_unbound;

	}

};

Object.assign( PropertyBinding.prototype, { // prototype, continued

	// these are used to "bind" a nonexistent property
	_getValue_unavailable: function() {},
	_setValue_unavailable: function() {},

	// initial state of these methods that calls 'bind'
	_getValue_unbound: PropertyBinding.prototype.getValue,
	_setValue_unbound: PropertyBinding.prototype.setValue,

	BindingType: {
		Direct: 0,
		EntireArray: 1,
		ArrayElement: 2,
		HasFromToArray: 3
	},

	Versioning: {
		None: 0,
		NeedsUpdate: 1,
		MatrixWorldNeedsUpdate: 2
	},

	GetterByBindingType: [

		function getValue_direct( buffer, offset ) {

			buffer[ offset ] = this.node[ this.propertyName ];

		},

		function getValue_array( buffer, offset ) {

			var source = this.resolvedProperty;

			for ( var i = 0, n = source.length; i !== n; ++ i ) {

				buffer[ offset ++ ] = source[ i ];

			}

		},

		function getValue_arrayElement( buffer, offset ) {

			buffer[ offset ] = this.resolvedProperty[ this.propertyIndex ];

		},

		function getValue_toArray( buffer, offset ) {

			this.resolvedProperty.toArray( buffer, offset );

		}

	],

	SetterByBindingTypeAndVersioning: [

		[
			// Direct

			function setValue_direct( buffer, offset ) {

				this.node[ this.propertyName ] = buffer[ offset ];

			},

			function setValue_direct_setNeedsUpdate( buffer, offset ) {

				this.node[ this.propertyName ] = buffer[ offset ];
				this.targetObject.needsUpdate = true;

			},

			function setValue_direct_setMatrixWorldNeedsUpdate( buffer, offset ) {

				this.node[ this.propertyName ] = buffer[ offset ];
				this.targetObject.matrixWorldNeedsUpdate = true;

			}

		], [

			// EntireArray

			function setValue_array( buffer, offset ) {

				var dest = this.resolvedProperty;

				for ( var i = 0, n = dest.length; i !== n; ++ i ) {

					dest[ i ] = buffer[ offset ++ ];

				}

			},

			function setValue_array_setNeedsUpdate( buffer, offset ) {

				var dest = this.resolvedProperty;

				for ( var i = 0, n = dest.length; i !== n; ++ i ) {

					dest[ i ] = buffer[ offset ++ ];

				}

				this.targetObject.needsUpdate = true;

			},

			function setValue_array_setMatrixWorldNeedsUpdate( buffer, offset ) {

				var dest = this.resolvedProperty;

				for ( var i = 0, n = dest.length; i !== n; ++ i ) {

					dest[ i ] = buffer[ offset ++ ];

				}

				this.targetObject.matrixWorldNeedsUpdate = true;

			}

		], [

			// ArrayElement

			function setValue_arrayElement( buffer, offset ) {

				this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];

			},

			function setValue_arrayElement_setNeedsUpdate( buffer, offset ) {

				this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
				this.targetObject.needsUpdate = true;

			},

			function setValue_arrayElement_setMatrixWorldNeedsUpdate( buffer, offset ) {

				this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
				this.targetObject.matrixWorldNeedsUpdate = true;

			}

		], [

			// HasToFromArray

			function setValue_fromArray( buffer, offset ) {

				this.resolvedProperty.fromArray( buffer, offset );

			},

			function setValue_fromArray_setNeedsUpdate( buffer, offset ) {

				this.resolvedProperty.fromArray( buffer, offset );
				this.targetObject.needsUpdate = true;

			},

			function setValue_fromArray_setMatrixWorldNeedsUpdate( buffer, offset ) {

				this.resolvedProperty.fromArray( buffer, offset );
				this.targetObject.matrixWorldNeedsUpdate = true;

			}

		]

	]

} );

PropertyBinding.Composite =
		function( targetGroup, path, optionalParsedPath ) {

	var parsedPath = optionalParsedPath ||
			PropertyBinding.parseTrackName( path );

	this._targetGroup = targetGroup;
	this._bindings = targetGroup.subscribe_( path, parsedPath );

};

PropertyBinding.Composite.prototype = {

	constructor: PropertyBinding.Composite,

	getValue: function( array, offset ) {

		this.bind(); // bind all binding

		var firstValidIndex = this._targetGroup.nCachedObjects_,
			binding = this._bindings[ firstValidIndex ];

		// and only call .getValue on the first
		if ( binding !== undefined ) binding.getValue( array, offset );

	},

	setValue: function( array, offset ) {

		var bindings = this._bindings;

		for ( var i = this._targetGroup.nCachedObjects_,
				n = bindings.length; i !== n; ++ i ) {

			bindings[ i ].setValue( array, offset );

		}

	},

	bind: function() {

		var bindings = this._bindings;

		for ( var i = this._targetGroup.nCachedObjects_,
				n = bindings.length; i !== n; ++ i ) {

			bindings[ i ].bind();

		}

	},

	unbind: function() {

		var bindings = this._bindings;

		for ( var i = this._targetGroup.nCachedObjects_,
				n = bindings.length; i !== n; ++ i ) {

			bindings[ i ].unbind();

		}

	}

};

PropertyBinding.create = function( root, path, parsedPath ) {

	if ( ! ( root && root.isAnimationObjectGroup ) ) {

		return new PropertyBinding( root, path, parsedPath );

	} else {

		return new PropertyBinding.Composite( root, path, parsedPath );

	}

};

PropertyBinding.parseTrackName = function( trackName ) {

	// matches strings in the form of:
	//    nodeName.property
	//    nodeName.property[accessor]
	//    nodeName.material.property[accessor]
	//    uuid.property[accessor]
	//    uuid.objectName[objectIndex].propertyName[propertyIndex]
	//    parentName/nodeName.property
	//    parentName/parentName/nodeName.property[index]
	//    .bone[Armature.DEF_cog].position
	//    scene:helium_balloon_model:helium_balloon_model.position
	// created and tested via https://regex101.com/#javascript

	var re = /^((?:[\w-]+[\/:])*)([\w-]+)?(?:\.([\w-]+)(?:\[(.+)\])?)?\.([\w-]+)(?:\[(.+)\])?$/;
	var matches = re.exec( trackName );

	if ( ! matches ) {

		throw new Error( "cannot parse trackName at all: " + trackName );

	}

	var results = {
		// directoryName: matches[ 1 ], // (tschw) currently unused
		nodeName: matches[ 2 ], 	// allowed to be null, specified root node.
		objectName: matches[ 3 ],
		objectIndex: matches[ 4 ],
		propertyName: matches[ 5 ],
		propertyIndex: matches[ 6 ]	// allowed to be null, specifies that the whole property is set.
	};

	if ( results.propertyName === null || results.propertyName.length === 0 ) {

		throw new Error( "can not parse propertyName from trackName: " + trackName );

	}

	return results;

};

PropertyBinding.findNode = function( root, nodeName ) {

	if ( ! nodeName || nodeName === "" || nodeName === "root" || nodeName === "." || nodeName === -1 || nodeName === root.name || nodeName === root.uuid ) {

		return root;

	}

	// search into skeleton bones.
	if ( root.skeleton ) {

		var searchSkeleton = function( skeleton ) {

			for( var i = 0; i < skeleton.bones.length; i ++ ) {

				var bone = skeleton.bones[ i ];

				if ( bone.name === nodeName ) {

					return bone;

				}
			}

			return null;

		};

		var bone = searchSkeleton( root.skeleton );

		if ( bone ) {

			return bone;

		}
	}

	// search into node subtree.
	if ( root.children ) {

		var searchNodeSubtree = function( children ) {

			for( var i = 0; i < children.length; i ++ ) {

				var childNode = children[ i ];

				if ( childNode.name === nodeName || childNode.uuid === nodeName ) {

					return childNode;

				}

				var result = searchNodeSubtree( childNode.children );

				if ( result ) return result;

			}

			return null;

		};

		var subTreeNode = searchNodeSubtree( root.children );

		if ( subTreeNode ) {

			return subTreeNode;

		}

	}

	return null;

};

/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 * 	-	Add objects you would otherwise pass as 'root' to the
 * 		constructor or the .clipAction method of AnimationMixer.
 *
 * 	-	Instead pass this object as 'root'.
 *
 * 	-	You can also add and remove objects later when the mixer
 * 		is running.
 *
 * Note:
 *
 *  	Objects of this class appear as one object to the mixer,
 *  	so cache control of the individual objects must be done
 *  	on the group.
 *
 * Limitation:
 *
 * 	- 	The animated properties must be compatible among the
 * 		all objects in the group.
 *
 *  -	A single property can either be controlled through a
 *  	target group or directly, but not both.
 *
 * @author tschw
 */

function AnimationObjectGroup( var_args ) {

	this.uuid = _Math.generateUUID();

	// cached objects followed by the active ones
	this._objects = Array.prototype.slice.call( arguments );

	this.nCachedObjects_ = 0;			// threshold
	// note: read by PropertyBinding.Composite

	var indices = {};
	this._indicesByUUID = indices;		// for bookkeeping

	for ( var i = 0, n = arguments.length; i !== n; ++ i ) {

		indices[ arguments[ i ].uuid ] = i;

	}

	this._paths = [];					// inside: string
	this._parsedPaths = [];				// inside: { we don't care, here }
	this._bindings = []; 				// inside: Array< PropertyBinding >
	this._bindingsIndicesByPath = {}; 	// inside: indices in these arrays

	var scope = this;

	this.stats = {

		objects: {
			get total() { return scope._objects.length; },
			get inUse() { return this.total - scope.nCachedObjects_;  }
		},

		get bindingsPerObject() { return scope._bindings.length; }

	};

}

AnimationObjectGroup.prototype = {

	constructor: AnimationObjectGroup,

	isAnimationObjectGroup: true,

	add: function( var_args ) {

		var objects = this._objects,
			nObjects = objects.length,
			nCachedObjects = this.nCachedObjects_,
			indicesByUUID = this._indicesByUUID,
			paths = this._paths,
			parsedPaths = this._parsedPaths,
			bindings = this._bindings,
			nBindings = bindings.length;

		for ( var i = 0, n = arguments.length; i !== n; ++ i ) {

			var object = arguments[ i ],
				uuid = object.uuid,
				index = indicesByUUID[ uuid ],
				knownObject = undefined;

			if ( index === undefined ) {

				// unknown object -> add it to the ACTIVE region

				index = nObjects ++;
				indicesByUUID[ uuid ] = index;
				objects.push( object );

				// accounting is done, now do the same for all bindings

				for ( var j = 0, m = nBindings; j !== m; ++ j ) {

					bindings[ j ].push(
							new PropertyBinding(
								object, paths[ j ], parsedPaths[ j ] ) );

				}

			} else if ( index < nCachedObjects ) {

				knownObject = objects[ index ];

				// move existing object to the ACTIVE region

				var firstActiveIndex = -- nCachedObjects,
					lastCachedObject = objects[ firstActiveIndex ];

				indicesByUUID[ lastCachedObject.uuid ] = index;
				objects[ index ] = lastCachedObject;

				indicesByUUID[ uuid ] = firstActiveIndex;
				objects[ firstActiveIndex ] = object;

				// accounting is done, now do the same for all bindings

				for ( var j = 0, m = nBindings; j !== m; ++ j ) {

					var bindingsForPath = bindings[ j ],
						lastCached = bindingsForPath[ firstActiveIndex ],
						binding = bindingsForPath[ index ];

					bindingsForPath[ index ] = lastCached;

					if ( binding === undefined ) {

						// since we do not bother to create new bindings
						// for objects that are cached, the binding may
						// or may not exist

						binding = new PropertyBinding(
								object, paths[ j ], parsedPaths[ j ] );

					}

					bindingsForPath[ firstActiveIndex ] = binding;

				}

			} else if ( objects[ index ] !== knownObject) {

				console.error( "Different objects with the same UUID " +
						"detected. Clean the caches or recreate your " +
						"infrastructure when reloading scenes..." );

			} // else the object is already where we want it to be

		} // for arguments

		this.nCachedObjects_ = nCachedObjects;

	},

	remove: function( var_args ) {

		var objects = this._objects,
			nCachedObjects = this.nCachedObjects_,
			indicesByUUID = this._indicesByUUID,
			bindings = this._bindings,
			nBindings = bindings.length;

		for ( var i = 0, n = arguments.length; i !== n; ++ i ) {

			var object = arguments[ i ],
				uuid = object.uuid,
				index = indicesByUUID[ uuid ];

			if ( index !== undefined && index >= nCachedObjects ) {

				// move existing object into the CACHED region

				var lastCachedIndex = nCachedObjects ++,
					firstActiveObject = objects[ lastCachedIndex ];

				indicesByUUID[ firstActiveObject.uuid ] = index;
				objects[ index ] = firstActiveObject;

				indicesByUUID[ uuid ] = lastCachedIndex;
				objects[ lastCachedIndex ] = object;

				// accounting is done, now do the same for all bindings

				for ( var j = 0, m = nBindings; j !== m; ++ j ) {

					var bindingsForPath = bindings[ j ],
						firstActive = bindingsForPath[ lastCachedIndex ],
						binding = bindingsForPath[ index ];

					bindingsForPath[ index ] = firstActive;
					bindingsForPath[ lastCachedIndex ] = binding;

				}

			}

		} // for arguments

		this.nCachedObjects_ = nCachedObjects;

	},

	// remove & forget
	uncache: function( var_args ) {

		var objects = this._objects,
			nObjects = objects.length,
			nCachedObjects = this.nCachedObjects_,
			indicesByUUID = this._indicesByUUID,
			bindings = this._bindings,
			nBindings = bindings.length;

		for ( var i = 0, n = arguments.length; i !== n; ++ i ) {

			var object = arguments[ i ],
				uuid = object.uuid,
				index = indicesByUUID[ uuid ];

			if ( index !== undefined ) {

				delete indicesByUUID[ uuid ];

				if ( index < nCachedObjects ) {

					// object is cached, shrink the CACHED region

					var firstActiveIndex = -- nCachedObjects,
						lastCachedObject = objects[ firstActiveIndex ],
						lastIndex = -- nObjects,
						lastObject = objects[ lastIndex ];

					// last cached object takes this object's place
					indicesByUUID[ lastCachedObject.uuid ] = index;
					objects[ index ] = lastCachedObject;

					// last object goes to the activated slot and pop
					indicesByUUID[ lastObject.uuid ] = firstActiveIndex;
					objects[ firstActiveIndex ] = lastObject;
					objects.pop();

					// accounting is done, now do the same for all bindings

					for ( var j = 0, m = nBindings; j !== m; ++ j ) {

						var bindingsForPath = bindings[ j ],
							lastCached = bindingsForPath[ firstActiveIndex ],
							last = bindingsForPath[ lastIndex ];

						bindingsForPath[ index ] = lastCached;
						bindingsForPath[ firstActiveIndex ] = last;
						bindingsForPath.pop();

					}

				} else {

					// object is active, just swap with the last and pop

					var lastIndex = -- nObjects,
						lastObject = objects[ lastIndex ];

					indicesByUUID[ lastObject.uuid ] = index;
					objects[ index ] = lastObject;
					objects.pop();

					// accounting is done, now do the same for all bindings

					for ( var j = 0, m = nBindings; j !== m; ++ j ) {

						var bindingsForPath = bindings[ j ];

						bindingsForPath[ index ] = bindingsForPath[ lastIndex ];
						bindingsForPath.pop();

					}

				} // cached or active

			} // if object is known

		} // for arguments

		this.nCachedObjects_ = nCachedObjects;

	},

	// Internal interface used by befriended PropertyBinding.Composite:

	subscribe_: function( path, parsedPath ) {
		// returns an array of bindings for the given path that is changed
		// according to the contained objects in the group

		var indicesByPath = this._bindingsIndicesByPath,
			index = indicesByPath[ path ],
			bindings = this._bindings;

		if ( index !== undefined ) return bindings[ index ];

		var paths = this._paths,
			parsedPaths = this._parsedPaths,
			objects = this._objects,
			nObjects = objects.length,
			nCachedObjects = this.nCachedObjects_,
			bindingsForPath = new Array( nObjects );

		index = bindings.length;

		indicesByPath[ path ] = index;

		paths.push( path );
		parsedPaths.push( parsedPath );
		bindings.push( bindingsForPath );

		for ( var i = nCachedObjects,
				n = objects.length; i !== n; ++ i ) {

			var object = objects[ i ];

			bindingsForPath[ i ] =
					new PropertyBinding( object, path, parsedPath );

		}

		return bindingsForPath;

	},

	unsubscribe_: function( path ) {
		// tells the group to forget about a property path and no longer
		// update the array previously obtained with 'subscribe_'

		var indicesByPath = this._bindingsIndicesByPath,
			index = indicesByPath[ path ];

		if ( index !== undefined ) {

			var paths = this._paths,
				parsedPaths = this._parsedPaths,
				bindings = this._bindings,
				lastBindingsIndex = bindings.length - 1,
				lastBindings = bindings[ lastBindingsIndex ],
				lastBindingsPath = path[ lastBindingsIndex ];

			indicesByPath[ lastBindingsPath ] = index;

			bindings[ index ] = lastBindings;
			bindings.pop();

			parsedPaths[ index ] = parsedPaths[ lastBindingsIndex ];
			parsedPaths.pop();

			paths[ index ] = paths[ lastBindingsIndex ];
			paths.pop();

		}

	}

};

/**
 *
 * Action provided by AnimationMixer for scheduling clip playback on specific
 * objects.
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 *
 */

function AnimationAction( mixer, clip, localRoot ) {

	this._mixer = mixer;
	this._clip = clip;
	this._localRoot = localRoot || null;

	var tracks = clip.tracks,
		nTracks = tracks.length,
		interpolants = new Array( nTracks );

	var interpolantSettings = {
			endingStart: 	ZeroCurvatureEnding,
			endingEnd:		ZeroCurvatureEnding
	};

	for ( var i = 0; i !== nTracks; ++ i ) {

		var interpolant = tracks[ i ].createInterpolant( null );
		interpolants[ i ] = interpolant;
		interpolant.settings = interpolantSettings;

	}

	this._interpolantSettings = interpolantSettings;

	this._interpolants = interpolants;	// bound by the mixer

	// inside: PropertyMixer (managed by the mixer)
	this._propertyBindings = new Array( nTracks );

	this._cacheIndex = null;			// for the memory manager
	this._byClipCacheIndex = null;		// for the memory manager

	this._timeScaleInterpolant = null;
	this._weightInterpolant = null;

	this.loop = LoopRepeat;
	this._loopCount = -1;

	// global mixer time when the action is to be started
	// it's set back to 'null' upon start of the action
	this._startTime = null;

	// scaled local time of the action
	// gets clamped or wrapped to 0..clip.duration according to loop
	this.time = 0;

	this.timeScale = 1;
	this._effectiveTimeScale = 1;

	this.weight = 1;
	this._effectiveWeight = 1;

	this.repetitions = Infinity; 		// no. of repetitions when looping

	this.paused = false;				// false -> zero effective time scale
	this.enabled = true;				// true -> zero effective weight

	this.clampWhenFinished 	= false;	// keep feeding the last frame?

	this.zeroSlopeAtStart 	= true;		// for smooth interpolation w/o separate
	this.zeroSlopeAtEnd		= true;		// clips for start, loop and end

}

AnimationAction.prototype = {

	constructor: AnimationAction,

	// State & Scheduling

	play: function() {

		this._mixer._activateAction( this );

		return this;

	},

	stop: function() {

		this._mixer._deactivateAction( this );

		return this.reset();

	},

	reset: function() {

		this.paused = false;
		this.enabled = true;

		this.time = 0;			// restart clip
		this._loopCount = -1;	// forget previous loops
		this._startTime = null;	// forget scheduling

		return this.stopFading().stopWarping();

	},

	isRunning: function() {

		return this.enabled && ! this.paused && this.timeScale !== 0 &&
				this._startTime === null && this._mixer._isActiveAction( this );

	},

	// return true when play has been called
	isScheduled: function() {

		return this._mixer._isActiveAction( this );

	},

	startAt: function( time ) {

		this._startTime = time;

		return this;

	},

	setLoop: function( mode, repetitions ) {

		this.loop = mode;
		this.repetitions = repetitions;

		return this;

	},

	// Weight

	// set the weight stopping any scheduled fading
	// although .enabled = false yields an effective weight of zero, this
	// method does *not* change .enabled, because it would be confusing
	setEffectiveWeight: function( weight ) {

		this.weight = weight;

		// note: same logic as when updated at runtime
		this._effectiveWeight = this.enabled ? weight : 0;

		return this.stopFading();

	},

	// return the weight considering fading and .enabled
	getEffectiveWeight: function() {

		return this._effectiveWeight;

	},

	fadeIn: function( duration ) {

		return this._scheduleFading( duration, 0, 1 );

	},

	fadeOut: function( duration ) {

		return this._scheduleFading( duration, 1, 0 );

	},

	crossFadeFrom: function( fadeOutAction, duration, warp ) {

		fadeOutAction.fadeOut( duration );
		this.fadeIn( duration );

		if( warp ) {

			var fadeInDuration = this._clip.duration,
				fadeOutDuration = fadeOutAction._clip.duration,

				startEndRatio = fadeOutDuration / fadeInDuration,
				endStartRatio = fadeInDuration / fadeOutDuration;

			fadeOutAction.warp( 1.0, startEndRatio, duration );
			this.warp( endStartRatio, 1.0, duration );

		}

		return this;

	},

	crossFadeTo: function( fadeInAction, duration, warp ) {

		return fadeInAction.crossFadeFrom( this, duration, warp );

	},

	stopFading: function() {

		var weightInterpolant = this._weightInterpolant;

		if ( weightInterpolant !== null ) {

			this._weightInterpolant = null;
			this._mixer._takeBackControlInterpolant( weightInterpolant );

		}

		return this;

	},

	// Time Scale Control

	// set the weight stopping any scheduled warping
	// although .paused = true yields an effective time scale of zero, this
	// method does *not* change .paused, because it would be confusing
	setEffectiveTimeScale: function( timeScale ) {

		this.timeScale = timeScale;
		this._effectiveTimeScale = this.paused ? 0 :timeScale;

		return this.stopWarping();

	},

	// return the time scale considering warping and .paused
	getEffectiveTimeScale: function() {

		return this._effectiveTimeScale;

	},

	setDuration: function( duration ) {

		this.timeScale = this._clip.duration / duration;

		return this.stopWarping();

	},

	syncWith: function( action ) {

		this.time = action.time;
		this.timeScale = action.timeScale;

		return this.stopWarping();

	},

	halt: function( duration ) {

		return this.warp( this._effectiveTimeScale, 0, duration );

	},

	warp: function( startTimeScale, endTimeScale, duration ) {

		var mixer = this._mixer, now = mixer.time,
			interpolant = this._timeScaleInterpolant,

			timeScale = this.timeScale;

		if ( interpolant === null ) {

			interpolant = mixer._lendControlInterpolant();
			this._timeScaleInterpolant = interpolant;

		}

		var times = interpolant.parameterPositions,
			values = interpolant.sampleValues;

		times[ 0 ] = now;
		times[ 1 ] = now + duration;

		values[ 0 ] = startTimeScale / timeScale;
		values[ 1 ] = endTimeScale / timeScale;

		return this;

	},

	stopWarping: function() {

		var timeScaleInterpolant = this._timeScaleInterpolant;

		if ( timeScaleInterpolant !== null ) {

			this._timeScaleInterpolant = null;
			this._mixer._takeBackControlInterpolant( timeScaleInterpolant );

		}

		return this;

	},

	// Object Accessors

	getMixer: function() {

		return this._mixer;

	},

	getClip: function() {

		return this._clip;

	},

	getRoot: function() {

		return this._localRoot || this._mixer._root;

	},

	// Interna

	_update: function( time, deltaTime, timeDirection, accuIndex ) {
		// called by the mixer

		var startTime = this._startTime;

		if ( startTime !== null ) {

			// check for scheduled start of action

			var timeRunning = ( time - startTime ) * timeDirection;
			if ( timeRunning < 0 || timeDirection === 0 ) {

				return; // yet to come / don't decide when delta = 0

			}

			// start

			this._startTime = null; // unschedule
			deltaTime = timeDirection * timeRunning;

		}

		// apply time scale and advance time

		deltaTime *= this._updateTimeScale( time );
		var clipTime = this._updateTime( deltaTime );

		// note: _updateTime may disable the action resulting in
		// an effective weight of 0

		var weight = this._updateWeight( time );

		if ( weight > 0 ) {

			var interpolants = this._interpolants;
			var propertyMixers = this._propertyBindings;

			for ( var j = 0, m = interpolants.length; j !== m; ++ j ) {

				interpolants[ j ].evaluate( clipTime );
				propertyMixers[ j ].accumulate( accuIndex, weight );

			}

		}

	},

	_updateWeight: function( time ) {

		var weight = 0;

		if ( this.enabled ) {

			weight = this.weight;
			var interpolant = this._weightInterpolant;

			if ( interpolant !== null ) {

				var interpolantValue = interpolant.evaluate( time )[ 0 ];

				weight *= interpolantValue;

				if ( time > interpolant.parameterPositions[ 1 ] ) {

					this.stopFading();

					if ( interpolantValue === 0 ) {

						// faded out, disable
						this.enabled = false;

					}

				}

			}

		}

		this._effectiveWeight = weight;
		return weight;

	},

	_updateTimeScale: function( time ) {

		var timeScale = 0;

		if ( ! this.paused ) {

			timeScale = this.timeScale;

			var interpolant = this._timeScaleInterpolant;

			if ( interpolant !== null ) {

				var interpolantValue = interpolant.evaluate( time )[ 0 ];

				timeScale *= interpolantValue;

				if ( time > interpolant.parameterPositions[ 1 ] ) {

					this.stopWarping();

					if ( timeScale === 0 ) {

						// motion has halted, pause
						this.paused = true;

					} else {

						// warp done - apply final time scale
						this.timeScale = timeScale;

					}

				}

			}

		}

		this._effectiveTimeScale = timeScale;
		return timeScale;

	},

	_updateTime: function( deltaTime ) {

		var time = this.time + deltaTime;

		if ( deltaTime === 0 ) return time;

		var duration = this._clip.duration,

			loop = this.loop,
			loopCount = this._loopCount;

		if ( loop === LoopOnce ) {

			if ( loopCount === -1 ) {
				// just started

				this._loopCount = 0;
				this._setEndings( true, true, false );

			}

			handle_stop: {

				if ( time >= duration ) {

					time = duration;

				} else if ( time < 0 ) {

					time = 0;

				} else break handle_stop;

				if ( this.clampWhenFinished ) this.paused = true;
				else this.enabled = false;

				this._mixer.dispatchEvent( {
					type: 'finished', action: this,
					direction: deltaTime < 0 ? -1 : 1
				} );

			}

		} else { // repetitive Repeat or PingPong

			var pingPong = ( loop === LoopPingPong );

			if ( loopCount === -1 ) {
				// just started

				if ( deltaTime >= 0 ) {

					loopCount = 0;

					this._setEndings(
							true, this.repetitions === 0, pingPong );

				} else {

					// when looping in reverse direction, the initial
					// transition through zero counts as a repetition,
					// so leave loopCount at -1

					this._setEndings(
							this.repetitions === 0, true, pingPong );

				}

			}

			if ( time >= duration || time < 0 ) {
				// wrap around

				var loopDelta = Math.floor( time / duration ); // signed
				time -= duration * loopDelta;

				loopCount += Math.abs( loopDelta );

				var pending = this.repetitions - loopCount;

				if ( pending < 0 ) {
					// have to stop (switch state, clamp time, fire event)

					if ( this.clampWhenFinished ) this.paused = true;
					else this.enabled = false;

					time = deltaTime > 0 ? duration : 0;

					this._mixer.dispatchEvent( {
						type: 'finished', action: this,
						direction: deltaTime > 0 ? 1 : -1
					} );

				} else {
					// keep running

					if ( pending === 0 ) {
						// entering the last round

						var atStart = deltaTime < 0;
						this._setEndings( atStart, ! atStart, pingPong );

					} else {

						this._setEndings( false, false, pingPong );

					}

					this._loopCount = loopCount;

					this._mixer.dispatchEvent( {
						type: 'loop', action: this, loopDelta: loopDelta
					} );

				}

			}

			if ( pingPong && ( loopCount & 1 ) === 1 ) {
				// invert time for the "pong round"

				this.time = time;
				return duration - time;

			}

		}

		this.time = time;
		return time;

	},

	_setEndings: function( atStart, atEnd, pingPong ) {

		var settings = this._interpolantSettings;

		if ( pingPong ) {

			settings.endingStart 	= ZeroSlopeEnding;
			settings.endingEnd		= ZeroSlopeEnding;

		} else {

			// assuming for LoopOnce atStart == atEnd == true

			if ( atStart ) {

				settings.endingStart = this.zeroSlopeAtStart ?
						ZeroSlopeEnding : ZeroCurvatureEnding;

			} else {

				settings.endingStart = WrapAroundEnding;

			}

			if ( atEnd ) {

				settings.endingEnd = this.zeroSlopeAtEnd ?
						ZeroSlopeEnding : ZeroCurvatureEnding;

			} else {

				settings.endingEnd 	 = WrapAroundEnding;

			}

		}

	},

	_scheduleFading: function( duration, weightNow, weightThen ) {

		var mixer = this._mixer, now = mixer.time,
			interpolant = this._weightInterpolant;

		if ( interpolant === null ) {

			interpolant = mixer._lendControlInterpolant();
			this._weightInterpolant = interpolant;

		}

		var times = interpolant.parameterPositions,
			values = interpolant.sampleValues;

		times[ 0 ] = now; 				values[ 0 ] = weightNow;
		times[ 1 ] = now + duration;	values[ 1 ] = weightThen;

		return this;

	}

};

/**
 *
 * Player for AnimationClips.
 *
 *
 * @author Ben Houston / http://clara.io/
 * @author David Sarno / http://lighthaus.us/
 * @author tschw
 */

function AnimationMixer( root ) {

	this._root = root;
	this._initMemoryManager();
	this._accuIndex = 0;

	this.time = 0;

	this.timeScale = 1.0;

}

Object.assign( AnimationMixer.prototype, EventDispatcher.prototype, {

	// return an action for a clip optionally using a custom root target
	// object (this method allocates a lot of dynamic memory in case a
	// previously unknown clip/root combination is specified)
	clipAction: function( clip, optionalRoot ) {

		var root = optionalRoot || this._root,
			rootUuid = root.uuid,

			clipObject = typeof clip === 'string' ?
					AnimationClip.findByName( root, clip ) : clip,

			clipUuid = clipObject !== null ? clipObject.uuid : clip,

			actionsForClip = this._actionsByClip[ clipUuid ],
			prototypeAction = null;

		if ( actionsForClip !== undefined ) {

			var existingAction =
					actionsForClip.actionByRoot[ rootUuid ];

			if ( existingAction !== undefined ) {

				return existingAction;

			}

			// we know the clip, so we don't have to parse all
			// the bindings again but can just copy
			prototypeAction = actionsForClip.knownActions[ 0 ];

			// also, take the clip from the prototype action
			if ( clipObject === null )
				clipObject = prototypeAction._clip;

		}

		// clip must be known when specified via string
		if ( clipObject === null ) return null;

		// allocate all resources required to run it
		var newAction = new AnimationAction( this, clipObject, optionalRoot );

		this._bindAction( newAction, prototypeAction );

		// and make the action known to the memory manager
		this._addInactiveAction( newAction, clipUuid, rootUuid );

		return newAction;

	},

	// get an existing action
	existingAction: function( clip, optionalRoot ) {

		var root = optionalRoot || this._root,
			rootUuid = root.uuid,

			clipObject = typeof clip === 'string' ?
					AnimationClip.findByName( root, clip ) : clip,

			clipUuid = clipObject ? clipObject.uuid : clip,

			actionsForClip = this._actionsByClip[ clipUuid ];

		if ( actionsForClip !== undefined ) {

			return actionsForClip.actionByRoot[ rootUuid ] || null;

		}

		return null;

	},

	// deactivates all previously scheduled actions
	stopAllAction: function() {

		var actions = this._actions,
			nActions = this._nActiveActions,
			bindings = this._bindings,
			nBindings = this._nActiveBindings;

		this._nActiveActions = 0;
		this._nActiveBindings = 0;

		for ( var i = 0; i !== nActions; ++ i ) {

			actions[ i ].reset();

		}

		for ( var i = 0; i !== nBindings; ++ i ) {

			bindings[ i ].useCount = 0;

		}

		return this;

	},

	// advance the time and update apply the animation
	update: function( deltaTime ) {

		deltaTime *= this.timeScale;

		var actions = this._actions,
			nActions = this._nActiveActions,

			time = this.time += deltaTime,
			timeDirection = Math.sign( deltaTime ),

			accuIndex = this._accuIndex ^= 1;

		// run active actions

		for ( var i = 0; i !== nActions; ++ i ) {

			var action = actions[ i ];

			if ( action.enabled ) {

				action._update( time, deltaTime, timeDirection, accuIndex );

			}

		}

		// update scene graph

		var bindings = this._bindings,
			nBindings = this._nActiveBindings;

		for ( var i = 0; i !== nBindings; ++ i ) {

			bindings[ i ].apply( accuIndex );

		}

		return this;

	},

	// return this mixer's root target object
	getRoot: function() {

		return this._root;

	},

	// free all resources specific to a particular clip
	uncacheClip: function( clip ) {

		var actions = this._actions,
			clipUuid = clip.uuid,
			actionsByClip = this._actionsByClip,
			actionsForClip = actionsByClip[ clipUuid ];

		if ( actionsForClip !== undefined ) {

			// note: just calling _removeInactiveAction would mess up the
			// iteration state and also require updating the state we can
			// just throw away

			var actionsToRemove = actionsForClip.knownActions;

			for ( var i = 0, n = actionsToRemove.length; i !== n; ++ i ) {

				var action = actionsToRemove[ i ];

				this._deactivateAction( action );

				var cacheIndex = action._cacheIndex,
					lastInactiveAction = actions[ actions.length - 1 ];

				action._cacheIndex = null;
				action._byClipCacheIndex = null;

				lastInactiveAction._cacheIndex = cacheIndex;
				actions[ cacheIndex ] = lastInactiveAction;
				actions.pop();

				this._removeInactiveBindingsForAction( action );

			}

			delete actionsByClip[ clipUuid ];

		}

	},

	// free all resources specific to a particular root target object
	uncacheRoot: function( root ) {

		var rootUuid = root.uuid,
			actionsByClip = this._actionsByClip;

		for ( var clipUuid in actionsByClip ) {

			var actionByRoot = actionsByClip[ clipUuid ].actionByRoot,
				action = actionByRoot[ rootUuid ];

			if ( action !== undefined ) {

				this._deactivateAction( action );
				this._removeInactiveAction( action );

			}

		}

		var bindingsByRoot = this._bindingsByRootAndName,
			bindingByName = bindingsByRoot[ rootUuid ];

		if ( bindingByName !== undefined ) {

			for ( var trackName in bindingByName ) {

				var binding = bindingByName[ trackName ];
				binding.restoreOriginalState();
				this._removeInactiveBinding( binding );

			}

		}

	},

	// remove a targeted clip from the cache
	uncacheAction: function( clip, optionalRoot ) {

		var action = this.existingAction( clip, optionalRoot );

		if ( action !== null ) {

			this._deactivateAction( action );
			this._removeInactiveAction( action );

		}

	}

} );

// Implementation details:

Object.assign( AnimationMixer.prototype, {

	_bindAction: function( action, prototypeAction ) {

		var root = action._localRoot || this._root,
			tracks = action._clip.tracks,
			nTracks = tracks.length,
			bindings = action._propertyBindings,
			interpolants = action._interpolants,
			rootUuid = root.uuid,
			bindingsByRoot = this._bindingsByRootAndName,
			bindingsByName = bindingsByRoot[ rootUuid ];

		if ( bindingsByName === undefined ) {

			bindingsByName = {};
			bindingsByRoot[ rootUuid ] = bindingsByName;

		}

		for ( var i = 0; i !== nTracks; ++ i ) {

			var track = tracks[ i ],
				trackName = track.name,
				binding = bindingsByName[ trackName ];

			if ( binding !== undefined ) {

				bindings[ i ] = binding;

			} else {

				binding = bindings[ i ];

				if ( binding !== undefined ) {

					// existing binding, make sure the cache knows

					if ( binding._cacheIndex === null ) {

						++ binding.referenceCount;
						this._addInactiveBinding( binding, rootUuid, trackName );

					}

					continue;

				}

				var path = prototypeAction && prototypeAction.
						_propertyBindings[ i ].binding.parsedPath;

				binding = new PropertyMixer(
						PropertyBinding.create( root, trackName, path ),
						track.ValueTypeName, track.getValueSize() );

				++ binding.referenceCount;
				this._addInactiveBinding( binding, rootUuid, trackName );

				bindings[ i ] = binding;

			}

			interpolants[ i ].resultBuffer = binding.buffer;

		}

	},

	_activateAction: function( action ) {

		if ( ! this._isActiveAction( action ) ) {

			if ( action._cacheIndex === null ) {

				// this action has been forgotten by the cache, but the user
				// appears to be still using it -> rebind

				var rootUuid = ( action._localRoot || this._root ).uuid,
					clipUuid = action._clip.uuid,
					actionsForClip = this._actionsByClip[ clipUuid ];

				this._bindAction( action,
						actionsForClip && actionsForClip.knownActions[ 0 ] );

				this._addInactiveAction( action, clipUuid, rootUuid );

			}

			var bindings = action._propertyBindings;

			// increment reference counts / sort out state
			for ( var i = 0, n = bindings.length; i !== n; ++ i ) {

				var binding = bindings[ i ];

				if ( binding.useCount ++ === 0 ) {

					this._lendBinding( binding );
					binding.saveOriginalState();

				}

			}

			this._lendAction( action );

		}

	},

	_deactivateAction: function( action ) {

		if ( this._isActiveAction( action ) ) {

			var bindings = action._propertyBindings;

			// decrement reference counts / sort out state
			for ( var i = 0, n = bindings.length; i !== n; ++ i ) {

				var binding = bindings[ i ];

				if ( -- binding.useCount === 0 ) {

					binding.restoreOriginalState();
					this._takeBackBinding( binding );

				}

			}

			this._takeBackAction( action );

		}

	},

	// Memory manager

	_initMemoryManager: function() {

		this._actions = []; // 'nActiveActions' followed by inactive ones
		this._nActiveActions = 0;

		this._actionsByClip = {};
		// inside:
		// {
		// 		knownActions: Array< AnimationAction >	- used as prototypes
		// 		actionByRoot: AnimationAction			- lookup
		// }


		this._bindings = []; // 'nActiveBindings' followed by inactive ones
		this._nActiveBindings = 0;

		this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >


		this._controlInterpolants = []; // same game as above
		this._nActiveControlInterpolants = 0;

		var scope = this;

		this.stats = {

			actions: {
				get total() { return scope._actions.length; },
				get inUse() { return scope._nActiveActions; }
			},
			bindings: {
				get total() { return scope._bindings.length; },
				get inUse() { return scope._nActiveBindings; }
			},
			controlInterpolants: {
				get total() { return scope._controlInterpolants.length; },
				get inUse() { return scope._nActiveControlInterpolants; }
			}

		};

	},

	// Memory management for AnimationAction objects

	_isActiveAction: function( action ) {

		var index = action._cacheIndex;
		return index !== null && index < this._nActiveActions;

	},

	_addInactiveAction: function( action, clipUuid, rootUuid ) {

		var actions = this._actions,
			actionsByClip = this._actionsByClip,
			actionsForClip = actionsByClip[ clipUuid ];

		if ( actionsForClip === undefined ) {

			actionsForClip = {

				knownActions: [ action ],
				actionByRoot: {}

			};

			action._byClipCacheIndex = 0;

			actionsByClip[ clipUuid ] = actionsForClip;

		} else {

			var knownActions = actionsForClip.knownActions;

			action._byClipCacheIndex = knownActions.length;
			knownActions.push( action );

		}

		action._cacheIndex = actions.length;
		actions.push( action );

		actionsForClip.actionByRoot[ rootUuid ] = action;

	},

	_removeInactiveAction: function( action ) {

		var actions = this._actions,
			lastInactiveAction = actions[ actions.length - 1 ],
			cacheIndex = action._cacheIndex;

		lastInactiveAction._cacheIndex = cacheIndex;
		actions[ cacheIndex ] = lastInactiveAction;
		actions.pop();

		action._cacheIndex = null;


		var clipUuid = action._clip.uuid,
			actionsByClip = this._actionsByClip,
			actionsForClip = actionsByClip[ clipUuid ],
			knownActionsForClip = actionsForClip.knownActions,

			lastKnownAction =
				knownActionsForClip[ knownActionsForClip.length - 1 ],

			byClipCacheIndex = action._byClipCacheIndex;

		lastKnownAction._byClipCacheIndex = byClipCacheIndex;
		knownActionsForClip[ byClipCacheIndex ] = lastKnownAction;
		knownActionsForClip.pop();

		action._byClipCacheIndex = null;


		var actionByRoot = actionsForClip.actionByRoot,
			rootUuid = ( actions._localRoot || this._root ).uuid;

		delete actionByRoot[ rootUuid ];

		if ( knownActionsForClip.length === 0 ) {

			delete actionsByClip[ clipUuid ];

		}

		this._removeInactiveBindingsForAction( action );

	},

	_removeInactiveBindingsForAction: function( action ) {

		var bindings = action._propertyBindings;
		for ( var i = 0, n = bindings.length; i !== n; ++ i ) {

			var binding = bindings[ i ];

			if ( -- binding.referenceCount === 0 ) {

				this._removeInactiveBinding( binding );

			}

		}

	},

	_lendAction: function( action ) {

		// [ active actions |  inactive actions  ]
		// [  active actions >| inactive actions ]
		//                 s        a
		//                  <-swap->
		//                 a        s

		var actions = this._actions,
			prevIndex = action._cacheIndex,

			lastActiveIndex = this._nActiveActions ++,

			firstInactiveAction = actions[ lastActiveIndex ];

		action._cacheIndex = lastActiveIndex;
		actions[ lastActiveIndex ] = action;

		firstInactiveAction._cacheIndex = prevIndex;
		actions[ prevIndex ] = firstInactiveAction;

	},

	_takeBackAction: function( action ) {

		// [  active actions  | inactive actions ]
		// [ active actions |< inactive actions  ]
		//        a        s
		//         <-swap->
		//        s        a

		var actions = this._actions,
			prevIndex = action._cacheIndex,

			firstInactiveIndex = -- this._nActiveActions,

			lastActiveAction = actions[ firstInactiveIndex ];

		action._cacheIndex = firstInactiveIndex;
		actions[ firstInactiveIndex ] = action;

		lastActiveAction._cacheIndex = prevIndex;
		actions[ prevIndex ] = lastActiveAction;

	},

	// Memory management for PropertyMixer objects

	_addInactiveBinding: function( binding, rootUuid, trackName ) {

		var bindingsByRoot = this._bindingsByRootAndName,
			bindingByName = bindingsByRoot[ rootUuid ],

			bindings = this._bindings;

		if ( bindingByName === undefined ) {

			bindingByName = {};
			bindingsByRoot[ rootUuid ] = bindingByName;

		}

		bindingByName[ trackName ] = binding;

		binding._cacheIndex = bindings.length;
		bindings.push( binding );

	},

	_removeInactiveBinding: function( binding ) {

		var bindings = this._bindings,
			propBinding = binding.binding,
			rootUuid = propBinding.rootNode.uuid,
			trackName = propBinding.path,
			bindingsByRoot = this._bindingsByRootAndName,
			bindingByName = bindingsByRoot[ rootUuid ],

			lastInactiveBinding = bindings[ bindings.length - 1 ],
			cacheIndex = binding._cacheIndex;

		lastInactiveBinding._cacheIndex = cacheIndex;
		bindings[ cacheIndex ] = lastInactiveBinding;
		bindings.pop();

		delete bindingByName[ trackName ];

		remove_empty_map: {

			for ( var _ in bindingByName ) break remove_empty_map;

			delete bindingsByRoot[ rootUuid ];

		}

	},

	_lendBinding: function( binding ) {

		var bindings = this._bindings,
			prevIndex = binding._cacheIndex,

			lastActiveIndex = this._nActiveBindings ++,

			firstInactiveBinding = bindings[ lastActiveIndex ];

		binding._cacheIndex = lastActiveIndex;
		bindings[ lastActiveIndex ] = binding;

		firstInactiveBinding._cacheIndex = prevIndex;
		bindings[ prevIndex ] = firstInactiveBinding;

	},

	_takeBackBinding: function( binding ) {

		var bindings = this._bindings,
			prevIndex = binding._cacheIndex,

			firstInactiveIndex = -- this._nActiveBindings,

			lastActiveBinding = bindings[ firstInactiveIndex ];

		binding._cacheIndex = firstInactiveIndex;
		bindings[ firstInactiveIndex ] = binding;

		lastActiveBinding._cacheIndex = prevIndex;
		bindings[ prevIndex ] = lastActiveBinding;

	},


	// Memory management of Interpolants for weight and time scale

	_lendControlInterpolant: function() {

		var interpolants = this._controlInterpolants,
			lastActiveIndex = this._nActiveControlInterpolants ++,
			interpolant = interpolants[ lastActiveIndex ];

		if ( interpolant === undefined ) {

			interpolant = new LinearInterpolant(
					new Float32Array( 2 ), new Float32Array( 2 ),
						1, this._controlInterpolantsResultBuffer );

			interpolant.__cacheIndex = lastActiveIndex;
			interpolants[ lastActiveIndex ] = interpolant;

		}

		return interpolant;

	},

	_takeBackControlInterpolant: function( interpolant ) {

		var interpolants = this._controlInterpolants,
			prevIndex = interpolant.__cacheIndex,

			firstInactiveIndex = -- this._nActiveControlInterpolants,

			lastActiveInterpolant = interpolants[ firstInactiveIndex ];

		interpolant.__cacheIndex = firstInactiveIndex;
		interpolants[ firstInactiveIndex ] = interpolant;

		lastActiveInterpolant.__cacheIndex = prevIndex;
		interpolants[ prevIndex ] = lastActiveInterpolant;

	},

	_controlInterpolantsResultBuffer: new Float32Array( 1 )

} );

/**
 * @author mrdoob / http://mrdoob.com/
 */

function Uniform( value ) {

	if ( typeof value === 'string' ) {

		console.warn( 'THREE.Uniform: Type parameter is no longer needed.' );
		value = arguments[ 1 ];

	}

	this.value = value;

}

Uniform.prototype.clone = function () {

	return new Uniform( this.value.clone === undefined ? this.value : this.value.clone() );

};

/**
 * @author benaadams / https://twitter.com/ben_a_adams
 */

function InstancedBufferGeometry() {

	BufferGeometry.call( this );

	this.type = 'InstancedBufferGeometry';
	this.maxInstancedCount = undefined;

}

InstancedBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
InstancedBufferGeometry.prototype.constructor = InstancedBufferGeometry;

InstancedBufferGeometry.prototype.isInstancedBufferGeometry = true;

InstancedBufferGeometry.prototype.addGroup = function ( start, count, materialIndex ) {

	this.groups.push( {

		start: start,
		count: count,
		materialIndex: materialIndex

	} );

};

InstancedBufferGeometry.prototype.copy = function ( source ) {

	var index = source.index;

	if ( index !== null ) {

		this.setIndex( index.clone() );

	}

	var attributes = source.attributes;

	for ( var name in attributes ) {

		var attribute = attributes[ name ];
		this.addAttribute( name, attribute.clone() );

	}

	var groups = source.groups;

	for ( var i = 0, l = groups.length; i < l; i ++ ) {

		var group = groups[ i ];
		this.addGroup( group.start, group.count, group.materialIndex );

	}

	return this;

};

/**
 * @author benaadams / https://twitter.com/ben_a_adams
 */

function InterleavedBufferAttribute( interleavedBuffer, itemSize, offset, normalized ) {

	this.uuid = _Math.generateUUID();

	this.data = interleavedBuffer;
	this.itemSize = itemSize;
	this.offset = offset;

	this.normalized = normalized === true;

}


InterleavedBufferAttribute.prototype = {

	constructor: InterleavedBufferAttribute,

	isInterleavedBufferAttribute: true,

	get count() {

		return this.data.count;

	},

	get array() {

		return this.data.array;

	},

	setX: function ( index, x ) {

		this.data.array[ index * this.data.stride + this.offset ] = x;

		return this;

	},

	setY: function ( index, y ) {

		this.data.array[ index * this.data.stride + this.offset + 1 ] = y;

		return this;

	},

	setZ: function ( index, z ) {

		this.data.array[ index * this.data.stride + this.offset + 2 ] = z;

		return this;

	},

	setW: function ( index, w ) {

		this.data.array[ index * this.data.stride + this.offset + 3 ] = w;

		return this;

	},

	getX: function ( index ) {

		return this.data.array[ index * this.data.stride + this.offset ];

	},

	getY: function ( index ) {

		return this.data.array[ index * this.data.stride + this.offset + 1 ];

	},

	getZ: function ( index ) {

		return this.data.array[ index * this.data.stride + this.offset + 2 ];

	},

	getW: function ( index ) {

		return this.data.array[ index * this.data.stride + this.offset + 3 ];

	},

	setXY: function ( index, x, y ) {

		index = index * this.data.stride + this.offset;

		this.data.array[ index + 0 ] = x;
		this.data.array[ index + 1 ] = y;

		return this;

	},

	setXYZ: function ( index, x, y, z ) {

		index = index * this.data.stride + this.offset;

		this.data.array[ index + 0 ] = x;
		this.data.array[ index + 1 ] = y;
		this.data.array[ index + 2 ] = z;

		return this;

	},

	setXYZW: function ( index, x, y, z, w ) {

		index = index * this.data.stride + this.offset;

		this.data.array[ index + 0 ] = x;
		this.data.array[ index + 1 ] = y;
		this.data.array[ index + 2 ] = z;
		this.data.array[ index + 3 ] = w;

		return this;

	}

};

/**
 * @author benaadams / https://twitter.com/ben_a_adams
 */

function InterleavedBuffer( array, stride ) {

	this.uuid = _Math.generateUUID();

	this.array = array;
	this.stride = stride;
	this.count = array !== undefined ? array.length / stride : 0;

	this.dynamic = false;
	this.updateRange = { offset: 0, count: - 1 };

	this.onUploadCallback = function () {};

	this.version = 0;

}

InterleavedBuffer.prototype = {

	constructor: InterleavedBuffer,

	isInterleavedBuffer: true,

	set needsUpdate( value ) {

		if ( value === true ) this.version ++;

	},

	setArray: function ( array ) {

		if ( Array.isArray( array ) ) {

			throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );

		}

		this.count = array !== undefined ? array.length / this.stride : 0;
		this.array = array;

	},

	setDynamic: function ( value ) {

		this.dynamic = value;

		return this;

	},

	copy: function ( source ) {

		this.array = new source.array.constructor( source.array );
		this.count = source.count;
		this.stride = source.stride;
		this.dynamic = source.dynamic;

		return this;

	},

	copyAt: function ( index1, attribute, index2 ) {

		index1 *= this.stride;
		index2 *= attribute.stride;

		for ( var i = 0, l = this.stride; i < l; i ++ ) {

			this.array[ index1 + i ] = attribute.array[ index2 + i ];

		}

		return this;

	},

	set: function ( value, offset ) {

		if ( offset === undefined ) offset = 0;

		this.array.set( value, offset );

		return this;

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	onUpload: function ( callback ) {

		this.onUploadCallback = callback;

		return this;

	}

};

/**
 * @author benaadams / https://twitter.com/ben_a_adams
 */

function InstancedInterleavedBuffer( array, stride, meshPerAttribute ) {

	InterleavedBuffer.call( this, array, stride );

	this.meshPerAttribute = meshPerAttribute || 1;

}

InstancedInterleavedBuffer.prototype = Object.create( InterleavedBuffer.prototype );
InstancedInterleavedBuffer.prototype.constructor = InstancedInterleavedBuffer;

InstancedInterleavedBuffer.prototype.isInstancedInterleavedBuffer = true;

InstancedInterleavedBuffer.prototype.copy = function ( source ) {

	InterleavedBuffer.prototype.copy.call( this, source );

	this.meshPerAttribute = source.meshPerAttribute;

	return this;

};

/**
 * @author benaadams / https://twitter.com/ben_a_adams
 */

function InstancedBufferAttribute( array, itemSize, meshPerAttribute ) {

	BufferAttribute.call( this, array, itemSize );

	this.meshPerAttribute = meshPerAttribute || 1;

}

InstancedBufferAttribute.prototype = Object.create( BufferAttribute.prototype );
InstancedBufferAttribute.prototype.constructor = InstancedBufferAttribute;

InstancedBufferAttribute.prototype.isInstancedBufferAttribute = true;

InstancedBufferAttribute.prototype.copy = function ( source ) {

	BufferAttribute.prototype.copy.call( this, source );

	this.meshPerAttribute = source.meshPerAttribute;

	return this;

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author bhouston / http://clara.io/
 * @author stephomi / http://stephaneginier.com/
 */

function Raycaster( origin, direction, near, far ) {

	this.ray = new Ray( origin, direction );
	// direction is assumed to be normalized (for accurate distance calculations)

	this.near = near || 0;
	this.far = far || Infinity;

	this.params = {
		Mesh: {},
		Line: {},
		LOD: {},
		Points: { threshold: 1 },
		Sprite: {}
	};

	Object.defineProperties( this.params, {
		PointCloud: {
			get: function () {
				console.warn( 'THREE.Raycaster: params.PointCloud has been renamed to params.Points.' );
				return this.Points;
			}
		}
	} );

}

function ascSort( a, b ) {

	return a.distance - b.distance;

}

function intersectObject( object, raycaster, intersects, recursive ) {

	if ( object.visible === false ) return;

	object.raycast( raycaster, intersects );

	if ( recursive === true ) {

		var children = object.children;

		for ( var i = 0, l = children.length; i < l; i ++ ) {

			intersectObject( children[ i ], raycaster, intersects, true );

		}

	}

}

//

Raycaster.prototype = {

	constructor: Raycaster,

	linePrecision: 1,

	set: function ( origin, direction ) {

		// direction is assumed to be normalized (for accurate distance calculations)

		this.ray.set( origin, direction );

	},

	setFromCamera: function ( coords, camera ) {

		if ( (camera && camera.isPerspectiveCamera) ) {

			this.ray.origin.setFromMatrixPosition( camera.matrixWorld );
			this.ray.direction.set( coords.x, coords.y, 0.5 ).unproject( camera ).sub( this.ray.origin ).normalize();

		} else if ( (camera && camera.isOrthographicCamera) ) {

			this.ray.origin.set( coords.x, coords.y, ( camera.near + camera.far ) / ( camera.near - camera.far ) ).unproject( camera ); // set origin in plane of camera
			this.ray.direction.set( 0, 0, - 1 ).transformDirection( camera.matrixWorld );

		} else {

			console.error( 'THREE.Raycaster: Unsupported camera type.' );

		}

	},

	intersectObject: function ( object, recursive ) {

		var intersects = [];

		intersectObject( object, this, intersects, recursive );

		intersects.sort( ascSort );

		return intersects;

	},

	intersectObjects: function ( objects, recursive ) {

		var intersects = [];

		if ( Array.isArray( objects ) === false ) {

			console.warn( 'THREE.Raycaster.intersectObjects: objects is not an Array.' );
			return intersects;

		}

		for ( var i = 0, l = objects.length; i < l; i ++ ) {

			intersectObject( objects[ i ], this, intersects, recursive );

		}

		intersects.sort( ascSort );

		return intersects;

	}

};

/**
 * @author alteredq / http://alteredqualia.com/
 */

function Clock( autoStart ) {

	this.autoStart = ( autoStart !== undefined ) ? autoStart : true;

	this.startTime = 0;
	this.oldTime = 0;
	this.elapsedTime = 0;

	this.running = false;

}

Clock.prototype = {

	constructor: Clock,

	start: function () {

		this.startTime = ( performance || Date ).now();

		this.oldTime = this.startTime;
		this.elapsedTime = 0;
		this.running = true;

	},

	stop: function () {

		this.getElapsedTime();
		this.running = false;

	},

	getElapsedTime: function () {

		this.getDelta();
		return this.elapsedTime;

	},

	getDelta: function () {

		var diff = 0;

		if ( this.autoStart && ! this.running ) {

			this.start();

		}

		if ( this.running ) {

			var newTime = ( performance || Date ).now();

			diff = ( newTime - this.oldTime ) / 1000;
			this.oldTime = newTime;

			this.elapsedTime += diff;

		}

		return diff;

	}

};

/**
 * Spline from Tween.js, slightly optimized (and trashed)
 * http://sole.github.com/tween.js/examples/05_spline.html
 *
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 */

function Spline( points ) {

	this.points = points;

	var c = [], v3 = { x: 0, y: 0, z: 0 },
	point, intPoint, weight, w2, w3,
	pa, pb, pc, pd;

	this.initFromArray = function ( a ) {

		this.points = [];

		for ( var i = 0; i < a.length; i ++ ) {

			this.points[ i ] = { x: a[ i ][ 0 ], y: a[ i ][ 1 ], z: a[ i ][ 2 ] };

		}

	};

	this.getPoint = function ( k ) {

		point = ( this.points.length - 1 ) * k;
		intPoint = Math.floor( point );
		weight = point - intPoint;

		c[ 0 ] = intPoint === 0 ? intPoint : intPoint - 1;
		c[ 1 ] = intPoint;
		c[ 2 ] = intPoint  > this.points.length - 2 ? this.points.length - 1 : intPoint + 1;
		c[ 3 ] = intPoint  > this.points.length - 3 ? this.points.length - 1 : intPoint + 2;

		pa = this.points[ c[ 0 ] ];
		pb = this.points[ c[ 1 ] ];
		pc = this.points[ c[ 2 ] ];
		pd = this.points[ c[ 3 ] ];

		w2 = weight * weight;
		w3 = weight * w2;

		v3.x = interpolate( pa.x, pb.x, pc.x, pd.x, weight, w2, w3 );
		v3.y = interpolate( pa.y, pb.y, pc.y, pd.y, weight, w2, w3 );
		v3.z = interpolate( pa.z, pb.z, pc.z, pd.z, weight, w2, w3 );

		return v3;

	};

	this.getControlPointsArray = function () {

		var i, p, l = this.points.length,
			coords = [];

		for ( i = 0; i < l; i ++ ) {

			p = this.points[ i ];
			coords[ i ] = [ p.x, p.y, p.z ];

		}

		return coords;

	};

	// approximate length by summing linear segments

	this.getLength = function ( nSubDivisions ) {

		var i, index, nSamples, position,
			point = 0, intPoint = 0, oldIntPoint = 0,
			oldPosition = new Vector3(),
			tmpVec = new Vector3(),
			chunkLengths = [],
			totalLength = 0;

		// first point has 0 length

		chunkLengths[ 0 ] = 0;

		if ( ! nSubDivisions ) nSubDivisions = 100;

		nSamples = this.points.length * nSubDivisions;

		oldPosition.copy( this.points[ 0 ] );

		for ( i = 1; i < nSamples; i ++ ) {

			index = i / nSamples;

			position = this.getPoint( index );
			tmpVec.copy( position );

			totalLength += tmpVec.distanceTo( oldPosition );

			oldPosition.copy( position );

			point = ( this.points.length - 1 ) * index;
			intPoint = Math.floor( point );

			if ( intPoint !== oldIntPoint ) {

				chunkLengths[ intPoint ] = totalLength;
				oldIntPoint = intPoint;

			}

		}

		// last point ends with total length

		chunkLengths[ chunkLengths.length ] = totalLength;

		return { chunks: chunkLengths, total: totalLength };

	};

	this.reparametrizeByArcLength = function ( samplingCoef ) {

		var i, j,
			index, indexCurrent, indexNext,
			realDistance,
			sampling, position,
			newpoints = [],
			tmpVec = new Vector3(),
			sl = this.getLength();

		newpoints.push( tmpVec.copy( this.points[ 0 ] ).clone() );

		for ( i = 1; i < this.points.length; i ++ ) {

			//tmpVec.copy( this.points[ i - 1 ] );
			//linearDistance = tmpVec.distanceTo( this.points[ i ] );

			realDistance = sl.chunks[ i ] - sl.chunks[ i - 1 ];

			sampling = Math.ceil( samplingCoef * realDistance / sl.total );

			indexCurrent = ( i - 1 ) / ( this.points.length - 1 );
			indexNext = i / ( this.points.length - 1 );

			for ( j = 1; j < sampling - 1; j ++ ) {

				index = indexCurrent + j * ( 1 / sampling ) * ( indexNext - indexCurrent );

				position = this.getPoint( index );
				newpoints.push( tmpVec.copy( position ).clone() );

			}

			newpoints.push( tmpVec.copy( this.points[ i ] ).clone() );

		}

		this.points = newpoints;

	};

	// Catmull-Rom

	function interpolate( p0, p1, p2, p3, t, t2, t3 ) {

		var v0 = ( p2 - p0 ) * 0.5,
			v1 = ( p3 - p1 ) * 0.5;

		return ( 2 * ( p1 - p2 ) + v0 + v1 ) * t3 + ( - 3 * ( p1 - p2 ) - 2 * v0 - v1 ) * t2 + v0 * t + p1;

	}

}

/**
 * @author bhouston / http://clara.io
 * @author WestLangley / http://github.com/WestLangley
 *
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The poles (phi) are at the positive and negative y axis.
 * The equator starts at positive z.
 */

function Spherical( radius, phi, theta ) {

	this.radius = ( radius !== undefined ) ? radius : 1.0;
	this.phi = ( phi !== undefined ) ? phi : 0; // up / down towards top and bottom pole
	this.theta = ( theta !== undefined ) ? theta : 0; // around the equator of the sphere

	return this;

}

Spherical.prototype = {

	constructor: Spherical,

	set: function ( radius, phi, theta ) {

		this.radius = radius;
		this.phi = phi;
		this.theta = theta;

		return this;

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( other ) {

		this.radius = other.radius;
		this.phi = other.phi;
		this.theta = other.theta;

		return this;

	},

	// restrict phi to be betwee EPS and PI-EPS
	makeSafe: function() {

		var EPS = 0.000001;
		this.phi = Math.max( EPS, Math.min( Math.PI - EPS, this.phi ) );

		return this;

	},

	setFromVector3: function( vec3 ) {

		this.radius = vec3.length();

		if ( this.radius === 0 ) {

			this.theta = 0;
			this.phi = 0;

		} else {

			this.theta = Math.atan2( vec3.x, vec3.z ); // equator angle around y-up axis
			this.phi = Math.acos( _Math.clamp( vec3.y / this.radius, - 1, 1 ) ); // polar angle

		}

		return this;

	}

};

/**
 * @author Mugen87 / https://github.com/Mugen87
 *
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 *
 */

function Cylindrical( radius, theta, y ) {

	this.radius = ( radius !== undefined ) ? radius : 1.0; // distance from the origin to a point in the x-z plane
	this.theta = ( theta !== undefined ) ? theta : 0; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
	this.y = ( y !== undefined ) ? y : 0; // height above the x-z plane

	return this;

}

Cylindrical.prototype = {

	constructor: Cylindrical,

	set: function ( radius, theta, y ) {

		this.radius = radius;
		this.theta = theta;
		this.y = y;

		return this;

	},

	clone: function () {

		return new this.constructor().copy( this );

	},

	copy: function ( other ) {

		this.radius = other.radius;
		this.theta = other.theta;
		this.y = other.y;

		return this;

	},

	setFromVector3: function( vec3 ) {

		this.radius = Math.sqrt( vec3.x * vec3.x + vec3.z * vec3.z );
		this.theta = Math.atan2( vec3.x, vec3.z );
		this.y = vec3.y;

		return this;

	}

};

/**
 * @author alteredq / http://alteredqualia.com/
 */

function MorphBlendMesh( geometry, material ) {

	Mesh.call( this, geometry, material );

	this.animationsMap = {};
	this.animationsList = [];

	// prepare default animation
	// (all frames played together in 1 second)

	var numFrames = this.geometry.morphTargets.length;

	var name = "__default";

	var startFrame = 0;
	var endFrame = numFrames - 1;

	var fps = numFrames / 1;

	this.createAnimation( name, startFrame, endFrame, fps );
	this.setAnimationWeight( name, 1 );

}

MorphBlendMesh.prototype = Object.create( Mesh.prototype );
MorphBlendMesh.prototype.constructor = MorphBlendMesh;

MorphBlendMesh.prototype.createAnimation = function ( name, start, end, fps ) {

	var animation = {

		start: start,
		end: end,

		length: end - start + 1,

		fps: fps,
		duration: ( end - start ) / fps,

		lastFrame: 0,
		currentFrame: 0,

		active: false,

		time: 0,
		direction: 1,
		weight: 1,

		directionBackwards: false,
		mirroredLoop: false

	};

	this.animationsMap[ name ] = animation;
	this.animationsList.push( animation );

};

MorphBlendMesh.prototype.autoCreateAnimations = function ( fps ) {

	var pattern = /([a-z]+)_?(\d+)/i;

	var firstAnimation, frameRanges = {};

	var geometry = this.geometry;

	for ( var i = 0, il = geometry.morphTargets.length; i < il; i ++ ) {

		var morph = geometry.morphTargets[ i ];
		var chunks = morph.name.match( pattern );

		if ( chunks && chunks.length > 1 ) {

			var name = chunks[ 1 ];

			if ( ! frameRanges[ name ] ) frameRanges[ name ] = { start: Infinity, end: - Infinity };

			var range = frameRanges[ name ];

			if ( i < range.start ) range.start = i;
			if ( i > range.end ) range.end = i;

			if ( ! firstAnimation ) firstAnimation = name;

		}

	}

	for ( var name in frameRanges ) {

		var range = frameRanges[ name ];
		this.createAnimation( name, range.start, range.end, fps );

	}

	this.firstAnimation = firstAnimation;

};

MorphBlendMesh.prototype.setAnimationDirectionForward = function ( name ) {

	var animation = this.animationsMap[ name ];

	if ( animation ) {

		animation.direction = 1;
		animation.directionBackwards = false;

	}

};

MorphBlendMesh.prototype.setAnimationDirectionBackward = function ( name ) {

	var animation = this.animationsMap[ name ];

	if ( animation ) {

		animation.direction = - 1;
		animation.directionBackwards = true;

	}

};

MorphBlendMesh.prototype.setAnimationFPS = function ( name, fps ) {

	var animation = this.animationsMap[ name ];

	if ( animation ) {

		animation.fps = fps;
		animation.duration = ( animation.end - animation.start ) / animation.fps;

	}

};

MorphBlendMesh.prototype.setAnimationDuration = function ( name, duration ) {

	var animation = this.animationsMap[ name ];

	if ( animation ) {

		animation.duration = duration;
		animation.fps = ( animation.end - animation.start ) / animation.duration;

	}

};

MorphBlendMesh.prototype.setAnimationWeight = function ( name, weight ) {

	var animation = this.animationsMap[ name ];

	if ( animation ) {

		animation.weight = weight;

	}

};

MorphBlendMesh.prototype.setAnimationTime = function ( name, time ) {

	var animation = this.animationsMap[ name ];

	if ( animation ) {

		animation.time = time;

	}

};

MorphBlendMesh.prototype.getAnimationTime = function ( name ) {

	var time = 0;

	var animation = this.animationsMap[ name ];

	if ( animation ) {

		time = animation.time;

	}

	return time;

};

MorphBlendMesh.prototype.getAnimationDuration = function ( name ) {

	var duration = - 1;

	var animation = this.animationsMap[ name ];

	if ( animation ) {

		duration = animation.duration;

	}

	return duration;

};

MorphBlendMesh.prototype.playAnimation = function ( name ) {

	var animation = this.animationsMap[ name ];

	if ( animation ) {

		animation.time = 0;
		animation.active = true;

	} else {

		console.warn( "THREE.MorphBlendMesh: animation[" + name + "] undefined in .playAnimation()" );

	}

};

MorphBlendMesh.prototype.stopAnimation = function ( name ) {

	var animation = this.animationsMap[ name ];

	if ( animation ) {

		animation.active = false;

	}

};

MorphBlendMesh.prototype.update = function ( delta ) {

	for ( var i = 0, il = this.animationsList.length; i < il; i ++ ) {

		var animation = this.animationsList[ i ];

		if ( ! animation.active ) continue;

		var frameTime = animation.duration / animation.length;

		animation.time += animation.direction * delta;

		if ( animation.mirroredLoop ) {

			if ( animation.time > animation.duration || animation.time < 0 ) {

				animation.direction *= - 1;

				if ( animation.time > animation.duration ) {

					animation.time = animation.duration;
					animation.directionBackwards = true;

				}

				if ( animation.time < 0 ) {

					animation.time = 0;
					animation.directionBackwards = false;

				}

			}

		} else {

			animation.time = animation.time % animation.duration;

			if ( animation.time < 0 ) animation.time += animation.duration;

		}

		var keyframe = animation.start + _Math.clamp( Math.floor( animation.time / frameTime ), 0, animation.length - 1 );
		var weight = animation.weight;

		if ( keyframe !== animation.currentFrame ) {

			this.morphTargetInfluences[ animation.lastFrame ] = 0;
			this.morphTargetInfluences[ animation.currentFrame ] = 1 * weight;

			this.morphTargetInfluences[ keyframe ] = 0;

			animation.lastFrame = animation.currentFrame;
			animation.currentFrame = keyframe;

		}

		var mix = ( animation.time % frameTime ) / frameTime;

		if ( animation.directionBackwards ) mix = 1 - mix;

		if ( animation.currentFrame !== animation.lastFrame ) {

			this.morphTargetInfluences[ animation.currentFrame ] = mix * weight;
			this.morphTargetInfluences[ animation.lastFrame ] = ( 1 - mix ) * weight;

		} else {

			this.morphTargetInfluences[ animation.currentFrame ] = weight;

		}

	}

};

/**
 * @author alteredq / http://alteredqualia.com/
 */

function ImmediateRenderObject( material ) {

	Object3D.call( this );

	this.material = material;
	this.render = function ( renderCallback ) {};

}

ImmediateRenderObject.prototype = Object.create( Object3D.prototype );
ImmediateRenderObject.prototype.constructor = ImmediateRenderObject;

ImmediateRenderObject.prototype.isImmediateRenderObject = true;

/**
 * @author mrdoob / http://mrdoob.com/
 * @author WestLangley / http://github.com/WestLangley
*/

function VertexNormalsHelper( object, size, hex, linewidth ) {

	this.object = object;

	this.size = ( size !== undefined ) ? size : 1;

	var color = ( hex !== undefined ) ? hex : 0xff0000;

	var width = ( linewidth !== undefined ) ? linewidth : 1;

	//

	var nNormals = 0;

	var objGeometry = this.object.geometry;

	if ( objGeometry && objGeometry.isGeometry ) {

		nNormals = objGeometry.faces.length * 3;

	} else if ( objGeometry && objGeometry.isBufferGeometry ) {

		nNormals = objGeometry.attributes.normal.count;

	}

	//

	var geometry = new BufferGeometry();

	var positions = new Float32BufferAttribute( nNormals * 2 * 3, 3 );

	geometry.addAttribute( 'position', positions );

	LineSegments.call( this, geometry, new LineBasicMaterial( { color: color, linewidth: width } ) );

	//

	this.matrixAutoUpdate = false;

	this.update();

}

VertexNormalsHelper.prototype = Object.create( LineSegments.prototype );
VertexNormalsHelper.prototype.constructor = VertexNormalsHelper;

VertexNormalsHelper.prototype.update = ( function () {

	var v1 = new Vector3();
	var v2 = new Vector3();
	var normalMatrix = new Matrix3();

	return function update() {

		var keys = [ 'a', 'b', 'c' ];

		this.object.updateMatrixWorld( true );

		normalMatrix.getNormalMatrix( this.object.matrixWorld );

		var matrixWorld = this.object.matrixWorld;

		var position = this.geometry.attributes.position;

		//

		var objGeometry = this.object.geometry;

		if ( objGeometry && objGeometry.isGeometry ) {

			var vertices = objGeometry.vertices;

			var faces = objGeometry.faces;

			var idx = 0;

			for ( var i = 0, l = faces.length; i < l; i ++ ) {

				var face = faces[ i ];

				for ( var j = 0, jl = face.vertexNormals.length; j < jl; j ++ ) {

					var vertex = vertices[ face[ keys[ j ] ] ];

					var normal = face.vertexNormals[ j ];

					v1.copy( vertex ).applyMatrix4( matrixWorld );

					v2.copy( normal ).applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );

					position.setXYZ( idx, v1.x, v1.y, v1.z );

					idx = idx + 1;

					position.setXYZ( idx, v2.x, v2.y, v2.z );

					idx = idx + 1;

				}

			}

		} else if ( objGeometry && objGeometry.isBufferGeometry ) {

			var objPos = objGeometry.attributes.position;

			var objNorm = objGeometry.attributes.normal;

			var idx = 0;

			// for simplicity, ignore index and drawcalls, and render every normal

			for ( var j = 0, jl = objPos.count; j < jl; j ++ ) {

				v1.set( objPos.getX( j ), objPos.getY( j ), objPos.getZ( j ) ).applyMatrix4( matrixWorld );

				v2.set( objNorm.getX( j ), objNorm.getY( j ), objNorm.getZ( j ) );

				v2.applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );

				position.setXYZ( idx, v1.x, v1.y, v1.z );

				idx = idx + 1;

				position.setXYZ( idx, v2.x, v2.y, v2.z );

				idx = idx + 1;

			}

		}

		position.needsUpdate = true;

		return this;

	};

}() );

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 * @author WestLangley / http://github.com/WestLangley
*/

function SpotLightHelper( light ) {

	Object3D.call( this );

	this.light = light;
	this.light.updateMatrixWorld();

	this.matrix = light.matrixWorld;
	this.matrixAutoUpdate = false;

	var geometry = new BufferGeometry();

	var positions = [
		0, 0, 0,   0,   0,   1,
		0, 0, 0,   1,   0,   1,
		0, 0, 0, - 1,   0,   1,
		0, 0, 0,   0,   1,   1,
		0, 0, 0,   0, - 1,   1
	];

	for ( var i = 0, j = 1, l = 32; i < l; i ++, j ++ ) {

		var p1 = ( i / l ) * Math.PI * 2;
		var p2 = ( j / l ) * Math.PI * 2;

		positions.push(
			Math.cos( p1 ), Math.sin( p1 ), 1,
			Math.cos( p2 ), Math.sin( p2 ), 1
		);

	}

	geometry.addAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );

	var material = new LineBasicMaterial( { fog: false } );

	this.cone = new LineSegments( geometry, material );
	this.add( this.cone );

	this.update();

}

SpotLightHelper.prototype = Object.create( Object3D.prototype );
SpotLightHelper.prototype.constructor = SpotLightHelper;

SpotLightHelper.prototype.dispose = function () {

	this.cone.geometry.dispose();
	this.cone.material.dispose();

};

SpotLightHelper.prototype.update = function () {

	var vector = new Vector3();
	var vector2 = new Vector3();

	return function update() {

		var coneLength = this.light.distance ? this.light.distance : 1000;
		var coneWidth = coneLength * Math.tan( this.light.angle );

		this.cone.scale.set( coneWidth, coneWidth, coneLength );

		vector.setFromMatrixPosition( this.light.matrixWorld );
		vector2.setFromMatrixPosition( this.light.target.matrixWorld );

		this.cone.lookAt( vector2.sub( vector ) );

		this.cone.material.color.copy( this.light.color ).multiplyScalar( this.light.intensity );

	};

}();

/**
 * @author Sean Griffin / http://twitter.com/sgrif
 * @author Michael Guerrero / http://realitymeltdown.com
 * @author mrdoob / http://mrdoob.com/
 * @author ikerr / http://verold.com
 * @author Mugen87 / https://github.com/Mugen87
 */

function SkeletonHelper( object ) {

	this.bones = this.getBoneList( object );

	var geometry = new BufferGeometry();

	var vertices = [];
	var colors = [];

	var color1 = new Color( 0, 0, 1 );
	var color2 = new Color( 0, 1, 0 );

	for ( var i = 0; i < this.bones.length; i ++ ) {

		var bone = this.bones[ i ];

		if ( bone.parent && bone.parent.isBone ) {

			vertices.push( 0, 0, 0 );
			vertices.push( 0, 0, 0 );
			colors.push( color1.r, color1.g, color1.b );
			colors.push( color2.r, color2.g, color2.b );

		}

	}

	geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

	var material = new LineBasicMaterial( { vertexColors: VertexColors, depthTest: false, depthWrite: false, transparent: true } );

	LineSegments.call( this, geometry, material );

	this.root = object;

	this.matrix = object.matrixWorld;
	this.matrixAutoUpdate = false;

	this.update();

}


SkeletonHelper.prototype = Object.create( LineSegments.prototype );
SkeletonHelper.prototype.constructor = SkeletonHelper;

SkeletonHelper.prototype.getBoneList = function( object ) {

	var boneList = [];

	if ( object && object.isBone ) {

		boneList.push( object );

	}

	for ( var i = 0; i < object.children.length; i ++ ) {

		boneList.push.apply( boneList, this.getBoneList( object.children[ i ] ) );

	}

	return boneList;

};

SkeletonHelper.prototype.update = function () {

	var vector = new Vector3();

	var boneMatrix = new Matrix4();
	var matrixWorldInv = new Matrix4();

	return function update() {

		var geometry = this.geometry;
		var position = geometry.getAttribute( 'position' );

		matrixWorldInv.getInverse( this.root.matrixWorld );

		for ( var i = 0, j = 0; i < this.bones.length; i ++ ) {

			var bone = this.bones[ i ];

			if ( bone.parent && bone.parent.isBone ) {

				boneMatrix.multiplyMatrices( matrixWorldInv, bone.matrixWorld );
				vector.setFromMatrixPosition( boneMatrix );
				position.setXYZ( j, vector.x, vector.y, vector.z );

				boneMatrix.multiplyMatrices( matrixWorldInv, bone.parent.matrixWorld );
				vector.setFromMatrixPosition( boneMatrix );
				position.setXYZ( j + 1, vector.x, vector.y, vector.z );

				j += 2;

			}

		}

		geometry.getAttribute( 'position' ).needsUpdate = true;

	};

}();

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 */

function PointLightHelper( light, sphereSize ) {

	this.light = light;
	this.light.updateMatrixWorld();

	var geometry = new SphereBufferGeometry( sphereSize, 4, 2 );
	var material = new MeshBasicMaterial( { wireframe: true, fog: false } );
	material.color.copy( this.light.color ).multiplyScalar( this.light.intensity );

	Mesh.call( this, geometry, material );

	this.matrix = this.light.matrixWorld;
	this.matrixAutoUpdate = false;

	/*
	var distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	var distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	var d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/

}

PointLightHelper.prototype = Object.create( Mesh.prototype );
PointLightHelper.prototype.constructor = PointLightHelper;

PointLightHelper.prototype.dispose = function () {

	this.geometry.dispose();
	this.material.dispose();

};

PointLightHelper.prototype.update = function () {

	this.material.color.copy( this.light.color ).multiplyScalar( this.light.intensity );

	/*
	var d = this.light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.visible = true;
		this.lightDistance.scale.set( d, d, d );

	}
	*/

};

/**
 * @author abelnation / http://github.com/abelnation
 * @author Mugen87 / http://github.com/Mugen87
 */

function RectAreaLightHelper( light ) {

	Object3D.call( this );

	this.light = light;
	this.light.updateMatrixWorld();

	var materialFront = new MeshBasicMaterial( {
		color: light.color,
		fog: false
	} );

	var materialBack = new MeshBasicMaterial( {
		color: light.color,
		fog: false,
		wireframe: true
	} );

	var geometry = new BufferGeometry();

	geometry.addAttribute( 'position', new BufferAttribute( new Float32Array( 6 * 3 ), 3 ) );

	// shows the "front" of the light, e.g. where light comes from

	this.add( new Mesh( geometry, materialFront ) );

	// shows the "back" of the light, which does not emit light

	this.add( new Mesh( geometry, materialBack ) );

	this.update();

}

RectAreaLightHelper.prototype = Object.create( Object3D.prototype );
RectAreaLightHelper.prototype.constructor = RectAreaLightHelper;

RectAreaLightHelper.prototype.dispose = function () {

	this.children[ 0 ].geometry.dispose();
	this.children[ 0 ].material.dispose();
	this.children[ 1 ].geometry.dispose();
	this.children[ 1 ].material.dispose();

};

RectAreaLightHelper.prototype.update = function () {

	var vector1 = new Vector3();
	var vector2 = new Vector3();

	return function update() {

		var mesh1 = this.children[ 0 ];
		var mesh2 = this.children[ 1 ];

		if ( this.light.target ) {

			vector1.setFromMatrixPosition( this.light.matrixWorld );
			vector2.setFromMatrixPosition( this.light.target.matrixWorld );

			var lookVec = vector2.clone().sub( vector1 );
			mesh1.lookAt( lookVec );
			mesh2.lookAt( lookVec );

		}

		// update materials

		mesh1.material.color.copy( this.light.color ).multiplyScalar( this.light.intensity );
		mesh2.material.color.copy( this.light.color ).multiplyScalar( this.light.intensity );

		// calculate new dimensions of the helper

		var hx = this.light.width * 0.5;
		var hy = this.light.height * 0.5;

		// because the buffer attribute is shared over both geometries, we only have to update once

		var position = mesh1.geometry.getAttribute( 'position' );
		var array = position.array;

		// first face

		array[  0 ] =   hx; array[  1 ] = - hy; array[  2 ] = 0;
		array[  3 ] =   hx; array[  4 ] =   hy; array[  5 ] = 0;
		array[  6 ] = - hx; array[  7 ] =   hy; array[  8 ] = 0;

		// second face

		array[  9 ] = - hx; array[ 10 ] =   hy; array[ 11 ] = 0;
		array[ 12 ] = - hx; array[ 13 ] = - hy; array[ 14 ] = 0;
		array[ 15 ] =   hx; array[ 16 ] = - hy; array[ 17 ] = 0;

		position.needsUpdate = true;

	};

}();

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 * @author Mugen87 / https://github.com/Mugen87
 */

function HemisphereLightHelper( light, size ) {

	Object3D.call( this );

	this.light = light;
	this.light.updateMatrixWorld();

	this.matrix = light.matrixWorld;
	this.matrixAutoUpdate = false;

	var geometry = new OctahedronBufferGeometry( size );
	geometry.rotateY( Math.PI * 0.5 );

	var material = new MeshBasicMaterial( { vertexColors: VertexColors, wireframe: true } );

	var position = geometry.getAttribute( 'position' );
	var colors = new Float32Array( position.count * 3 );

	geometry.addAttribute( 'color', new BufferAttribute( colors, 3 ) );

	this.add( new Mesh( geometry, material ) );

	this.update();

}

HemisphereLightHelper.prototype = Object.create( Object3D.prototype );
HemisphereLightHelper.prototype.constructor = HemisphereLightHelper;

HemisphereLightHelper.prototype.dispose = function () {

	this.children[ 0 ].geometry.dispose();
	this.children[ 0 ].material.dispose();

};

HemisphereLightHelper.prototype.update = function () {

	var vector = new Vector3();

	var color1 = new Color();
	var color2 = new Color();

	return function update() {

		var mesh = this.children[ 0 ];

		var colors = mesh.geometry.getAttribute( 'color' );

		color1.copy( this.light.color ).multiplyScalar( this.light.intensity );
		color2.copy( this.light.groundColor ).multiplyScalar( this.light.intensity );

		for ( var i = 0, l = colors.count; i < l; i ++ ) {

			var color = ( i < ( l / 2 ) ) ? color1 : color2;

			colors.setXYZ( i, color.r, color.g, color.b );

		}

		mesh.lookAt( vector.setFromMatrixPosition( this.light.matrixWorld ).negate() );

		colors.needsUpdate = true;

	};

}();

/**
 * @author mrdoob / http://mrdoob.com/
 */

function GridHelper( size, divisions, color1, color2 ) {

	size = size || 10;
	divisions = divisions || 10;
	color1 = new Color( color1 !== undefined ? color1 : 0x444444 );
	color2 = new Color( color2 !== undefined ? color2 : 0x888888 );

	var center = divisions / 2;
	var step = ( size * 2 ) / divisions;
	var vertices = [], colors = [];

	for ( var i = 0, j = 0, k = - size; i <= divisions; i ++, k += step ) {

		vertices.push( - size, 0, k, size, 0, k );
		vertices.push( k, 0, - size, k, 0, size );

		var color = i === center ? color1 : color2;

		color.toArray( colors, j ); j += 3;
		color.toArray( colors, j ); j += 3;
		color.toArray( colors, j ); j += 3;
		color.toArray( colors, j ); j += 3;

	}

	var geometry = new BufferGeometry();
	geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

	var material = new LineBasicMaterial( { vertexColors: VertexColors } );

	LineSegments.call( this, geometry, material );

}

GridHelper.prototype = Object.create( LineSegments.prototype );
GridHelper.prototype.constructor = GridHelper;

/**
 * @author mrdoob / http://mrdoob.com/
 * @author Mugen87 / http://github.com/Mugen87
 * @author Hectate / http://www.github.com/Hectate
 */

function PolarGridHelper( radius, radials, circles, divisions, color1, color2 ) {

	radius = radius || 10;
	radials = radials || 16;
	circles = circles || 8;
	divisions = divisions || 64;
	color1 = new Color( color1 !== undefined ? color1 : 0x444444 );
	color2 = new Color( color2 !== undefined ? color2 : 0x888888 );

	var vertices = [];
	var colors = [];

	var x, z;
	var v, i, j, r, color;

	// create the radials

	for ( i = 0; i <= radials; i ++ ) {

		v = ( i / radials ) * ( Math.PI * 2 );

		x = Math.sin( v ) * radius;
		z = Math.cos( v ) * radius;

		vertices.push( 0, 0, 0 );
		vertices.push( x, 0, z );

		color = ( i & 1 ) ? color1 : color2;

		colors.push( color.r, color.g, color.b );
		colors.push( color.r, color.g, color.b );

	}

	// create the circles

	for ( i = 0; i <= circles; i ++ ) {

		color = ( i & 1 ) ? color1 : color2;

		r = radius - ( radius / circles * i );

		for ( j = 0; j < divisions; j ++ ) {

			// first vertex

			v = ( j / divisions ) * ( Math.PI * 2 );

			x = Math.sin( v ) * r;
			z = Math.cos( v ) * r;

			vertices.push( x, 0, z );
			colors.push( color.r, color.g, color.b );

			// second vertex

			v = ( ( j + 1 ) / divisions ) * ( Math.PI * 2 );

			x = Math.sin( v ) * r;
			z = Math.cos( v ) * r;

			vertices.push( x, 0, z );
			colors.push( color.r, color.g, color.b );

		}

	}

	var geometry = new BufferGeometry();
	geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

	var material = new LineBasicMaterial( { vertexColors: VertexColors } );

	LineSegments.call( this, geometry, material );

}

PolarGridHelper.prototype = Object.create( LineSegments.prototype );
PolarGridHelper.prototype.constructor = PolarGridHelper;

/**
 * @author mrdoob / http://mrdoob.com/
 * @author WestLangley / http://github.com/WestLangley
*/

function FaceNormalsHelper( object, size, hex, linewidth ) {

	// FaceNormalsHelper only supports THREE.Geometry

	this.object = object;

	this.size = ( size !== undefined ) ? size : 1;

	var color = ( hex !== undefined ) ? hex : 0xffff00;

	var width = ( linewidth !== undefined ) ? linewidth : 1;

	//

	var nNormals = 0;

	var objGeometry = this.object.geometry;

	if ( objGeometry && objGeometry.isGeometry ) {

		nNormals = objGeometry.faces.length;

	} else {

		console.warn( 'THREE.FaceNormalsHelper: only THREE.Geometry is supported. Use THREE.VertexNormalsHelper, instead.' );

	}

	//

	var geometry = new BufferGeometry();

	var positions = new Float32BufferAttribute( nNormals * 2 * 3, 3 );

	geometry.addAttribute( 'position', positions );

	LineSegments.call( this, geometry, new LineBasicMaterial( { color: color, linewidth: width } ) );

	//

	this.matrixAutoUpdate = false;
	this.update();

}

FaceNormalsHelper.prototype = Object.create( LineSegments.prototype );
FaceNormalsHelper.prototype.constructor = FaceNormalsHelper;

FaceNormalsHelper.prototype.update = ( function () {

	var v1 = new Vector3();
	var v2 = new Vector3();
	var normalMatrix = new Matrix3();

	return function update() {

		this.object.updateMatrixWorld( true );

		normalMatrix.getNormalMatrix( this.object.matrixWorld );

		var matrixWorld = this.object.matrixWorld;

		var position = this.geometry.attributes.position;

		//

		var objGeometry = this.object.geometry;

		var vertices = objGeometry.vertices;

		var faces = objGeometry.faces;

		var idx = 0;

		for ( var i = 0, l = faces.length; i < l; i ++ ) {

			var face = faces[ i ];

			var normal = face.normal;

			v1.copy( vertices[ face.a ] )
				.add( vertices[ face.b ] )
				.add( vertices[ face.c ] )
				.divideScalar( 3 )
				.applyMatrix4( matrixWorld );

			v2.copy( normal ).applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );

			position.setXYZ( idx, v1.x, v1.y, v1.z );

			idx = idx + 1;

			position.setXYZ( idx, v2.x, v2.y, v2.z );

			idx = idx + 1;

		}

		position.needsUpdate = true;

		return this;

	};

}() );

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 * @author WestLangley / http://github.com/WestLangley
 */

function DirectionalLightHelper( light, size ) {

	Object3D.call( this );

	this.light = light;
	this.light.updateMatrixWorld();

	this.matrix = light.matrixWorld;
	this.matrixAutoUpdate = false;

	if ( size === undefined ) size = 1;

	var geometry = new BufferGeometry();
	geometry.addAttribute( 'position', new Float32BufferAttribute( [
		- size,   size, 0,
		  size,   size, 0,
		  size, - size, 0,
		- size, - size, 0,
		- size,   size, 0
	], 3 ) );

	var material = new LineBasicMaterial( { fog: false } );

	this.add( new Line( geometry, material ) );

	geometry = new BufferGeometry();
	geometry.addAttribute( 'position', new Float32BufferAttribute( [ 0, 0, 0, 0, 0, 1 ], 3 ) );

	this.add( new Line( geometry, material ));

	this.update();

}

DirectionalLightHelper.prototype = Object.create( Object3D.prototype );
DirectionalLightHelper.prototype.constructor = DirectionalLightHelper;

DirectionalLightHelper.prototype.dispose = function () {

	var lightPlane = this.children[ 0 ];
	var targetLine = this.children[ 1 ];

	lightPlane.geometry.dispose();
	lightPlane.material.dispose();
	targetLine.geometry.dispose();
	targetLine.material.dispose();

};

DirectionalLightHelper.prototype.update = function () {

	var v1 = new Vector3();
	var v2 = new Vector3();
	var v3 = new Vector3();

	return function update() {

		v1.setFromMatrixPosition( this.light.matrixWorld );
		v2.setFromMatrixPosition( this.light.target.matrixWorld );
		v3.subVectors( v2, v1 );

		var lightPlane = this.children[ 0 ];
		var targetLine = this.children[ 1 ];

		lightPlane.lookAt( v3 );
		lightPlane.material.color.copy( this.light.color ).multiplyScalar( this.light.intensity );

		targetLine.lookAt( v3 );
		targetLine.scale.z = v3.length();

	};

}();

/**
 * @author alteredq / http://alteredqualia.com/
 * @author Mugen87 / https://github.com/Mugen87
 *
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		http://evanw.github.com/lightgl.js/tests/shadowmap.html
 */

function CameraHelper( camera ) {

	var geometry = new BufferGeometry();
	var material = new LineBasicMaterial( { color: 0xffffff, vertexColors: FaceColors } );

	var vertices = [];
	var colors = [];

	var pointMap = {};

	// colors

	var colorFrustum = new Color( 0xffaa00 );
	var colorCone = new Color( 0xff0000 );
	var colorUp = new Color( 0x00aaff );
	var colorTarget = new Color( 0xffffff );
	var colorCross = new Color( 0x333333 );

	// near

	addLine( "n1", "n2", colorFrustum );
	addLine( "n2", "n4", colorFrustum );
	addLine( "n4", "n3", colorFrustum );
	addLine( "n3", "n1", colorFrustum );

	// far

	addLine( "f1", "f2", colorFrustum );
	addLine( "f2", "f4", colorFrustum );
	addLine( "f4", "f3", colorFrustum );
	addLine( "f3", "f1", colorFrustum );

	// sides

	addLine( "n1", "f1", colorFrustum );
	addLine( "n2", "f2", colorFrustum );
	addLine( "n3", "f3", colorFrustum );
	addLine( "n4", "f4", colorFrustum );

	// cone

	addLine( "p", "n1", colorCone );
	addLine( "p", "n2", colorCone );
	addLine( "p", "n3", colorCone );
	addLine( "p", "n4", colorCone );

	// up

	addLine( "u1", "u2", colorUp );
	addLine( "u2", "u3", colorUp );
	addLine( "u3", "u1", colorUp );

	// target

	addLine( "c", "t", colorTarget );
	addLine( "p", "c", colorCross );

	// cross

	addLine( "cn1", "cn2", colorCross );
	addLine( "cn3", "cn4", colorCross );

	addLine( "cf1", "cf2", colorCross );
	addLine( "cf3", "cf4", colorCross );

	function addLine( a, b, color ) {

		addPoint( a, color );
		addPoint( b, color );

	}

	function addPoint( id, color ) {

		vertices.push( 0, 0, 0 );
		colors.push( color.r, color.g, color.b );

		if ( pointMap[ id ] === undefined ) {

			pointMap[ id ] = [];

		}

		pointMap[ id ].push( ( vertices.length / 3 ) - 1 );

	}

	geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

	LineSegments.call( this, geometry, material );

	this.camera = camera;
	if ( this.camera.updateProjectionMatrix ) this.camera.updateProjectionMatrix();

	this.matrix = camera.matrixWorld;
	this.matrixAutoUpdate = false;

	this.pointMap = pointMap;

	this.update();

}

CameraHelper.prototype = Object.create( LineSegments.prototype );
CameraHelper.prototype.constructor = CameraHelper;

CameraHelper.prototype.update = function () {

	var geometry, pointMap;

	var vector = new Vector3();
	var camera = new Camera();

	function setPoint( point, x, y, z ) {

		vector.set( x, y, z ).unproject( camera );

		var points = pointMap[ point ];

		if ( points !== undefined ) {

			var position = geometry.getAttribute( 'position' );

			for ( var i = 0, l = points.length; i < l; i ++ ) {

				position.setXYZ( points[ i ], vector.x, vector.y, vector.z );

			}

		}

	}

	return function update() {

		geometry = this.geometry;
		pointMap = this.pointMap;

		var w = 1, h = 1;

		// we need just camera projection matrix
		// world matrix must be identity

		camera.projectionMatrix.copy( this.camera.projectionMatrix );

		// center / target

		setPoint( "c", 0, 0, - 1 );
		setPoint( "t", 0, 0,  1 );

		// near

		setPoint( "n1", - w, - h, - 1 );
		setPoint( "n2",   w, - h, - 1 );
		setPoint( "n3", - w,   h, - 1 );
		setPoint( "n4",   w,   h, - 1 );

		// far

		setPoint( "f1", - w, - h, 1 );
		setPoint( "f2",   w, - h, 1 );
		setPoint( "f3", - w,   h, 1 );
		setPoint( "f4",   w,   h, 1 );

		// up

		setPoint( "u1",   w * 0.7, h * 1.1, - 1 );
		setPoint( "u2", - w * 0.7, h * 1.1, - 1 );
		setPoint( "u3",         0, h * 2,   - 1 );

		// cross

		setPoint( "cf1", - w,   0, 1 );
		setPoint( "cf2",   w,   0, 1 );
		setPoint( "cf3",   0, - h, 1 );
		setPoint( "cf4",   0,   h, 1 );

		setPoint( "cn1", - w,   0, - 1 );
		setPoint( "cn2",   w,   0, - 1 );
		setPoint( "cn3",   0, - h, - 1 );
		setPoint( "cn4",   0,   h, - 1 );

		geometry.getAttribute( 'position' ).needsUpdate = true;

	};

}();

/**
 * @author mrdoob / http://mrdoob.com/
 */

function BoxHelper( object, color ) {

	if ( color === undefined ) color = 0xffff00;

	var indices = new Uint16Array( [ 0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7 ] );
	var positions = new Float32Array( 8 * 3 );

	var geometry = new BufferGeometry();
	geometry.setIndex( new BufferAttribute( indices, 1 ) );
	geometry.addAttribute( 'position', new BufferAttribute( positions, 3 ) );

	LineSegments.call( this, geometry, new LineBasicMaterial( { color: color } ) );

	if ( object !== undefined ) {

		this.update( object );

	}

}

BoxHelper.prototype = Object.create( LineSegments.prototype );
BoxHelper.prototype.constructor = BoxHelper;

BoxHelper.prototype.update = ( function () {

	var box = new Box3();

	return function update( object ) {

		if ( object && object.isBox3 ) {

			box.copy( object );

		} else {

			box.setFromObject( object );

		}

		if ( box.isEmpty() ) return;

		var min = box.min;
		var max = box.max;

		/*
		  5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/

		var position = this.geometry.attributes.position;
		var array = position.array;

		array[  0 ] = max.x; array[  1 ] = max.y; array[  2 ] = max.z;
		array[  3 ] = min.x; array[  4 ] = max.y; array[  5 ] = max.z;
		array[  6 ] = min.x; array[  7 ] = min.y; array[  8 ] = max.z;
		array[  9 ] = max.x; array[ 10 ] = min.y; array[ 11 ] = max.z;
		array[ 12 ] = max.x; array[ 13 ] = max.y; array[ 14 ] = min.z;
		array[ 15 ] = min.x; array[ 16 ] = max.y; array[ 17 ] = min.z;
		array[ 18 ] = min.x; array[ 19 ] = min.y; array[ 20 ] = min.z;
		array[ 21 ] = max.x; array[ 22 ] = min.y; array[ 23 ] = min.z;

		position.needsUpdate = true;

		this.geometry.computeBoundingSphere();

	};

} )();

/**
 * @author WestLangley / http://github.com/WestLangley
 * @author zz85 / http://github.com/zz85
 * @author bhouston / http://clara.io
 *
 * Creates an arrow for visualizing directions
 *
 * Parameters:
 *  dir - Vector3
 *  origin - Vector3
 *  length - Number
 *  color - color in hex value
 *  headLength - Number
 *  headWidth - Number
 */

var lineGeometry = new BufferGeometry();
lineGeometry.addAttribute( 'position', new Float32BufferAttribute( [ 0, 0, 0, 0, 1, 0 ], 3 ) );

var coneGeometry = new CylinderBufferGeometry( 0, 0.5, 1, 5, 1 );
coneGeometry.translate( 0, - 0.5, 0 );

function ArrowHelper( dir, origin, length, color, headLength, headWidth ) {

	// dir is assumed to be normalized

	Object3D.call( this );

	if ( color === undefined ) color = 0xffff00;
	if ( length === undefined ) length = 1;
	if ( headLength === undefined ) headLength = 0.2 * length;
	if ( headWidth === undefined ) headWidth = 0.2 * headLength;

	this.position.copy( origin );

	this.line = new Line( lineGeometry, new LineBasicMaterial( { color: color } ) );
	this.line.matrixAutoUpdate = false;
	this.add( this.line );

	this.cone = new Mesh( coneGeometry, new MeshBasicMaterial( { color: color } ) );
	this.cone.matrixAutoUpdate = false;
	this.add( this.cone );

	this.setDirection( dir );
	this.setLength( length, headLength, headWidth );

}

ArrowHelper.prototype = Object.create( Object3D.prototype );
ArrowHelper.prototype.constructor = ArrowHelper;

ArrowHelper.prototype.setDirection = ( function () {

	var axis = new Vector3();
	var radians;

	return function setDirection( dir ) {

		// dir is assumed to be normalized

		if ( dir.y > 0.99999 ) {

			this.quaternion.set( 0, 0, 0, 1 );

		} else if ( dir.y < - 0.99999 ) {

			this.quaternion.set( 1, 0, 0, 0 );

		} else {

			axis.set( dir.z, 0, - dir.x ).normalize();

			radians = Math.acos( dir.y );

			this.quaternion.setFromAxisAngle( axis, radians );

		}

	};

}() );

ArrowHelper.prototype.setLength = function ( length, headLength, headWidth ) {

	if ( headLength === undefined ) headLength = 0.2 * length;
	if ( headWidth === undefined ) headWidth = 0.2 * headLength;

	this.line.scale.set( 1, Math.max( 0, length - headLength ), 1 );
	this.line.updateMatrix();

	this.cone.scale.set( headWidth, headLength, headWidth );
	this.cone.position.y = length;
	this.cone.updateMatrix();

};

ArrowHelper.prototype.setColor = function ( color ) {

	this.line.material.color.copy( color );
	this.cone.material.color.copy( color );

};

/**
 * @author sroucheray / http://sroucheray.org/
 * @author mrdoob / http://mrdoob.com/
 */

function AxisHelper( size ) {

	size = size || 1;

	var vertices = [
		0, 0, 0,  size, 0, 0,
		0, 0, 0,  0, size, 0,
		0, 0, 0,  0, 0, size
	];

	var colors = [
		1, 0, 0,  1, 0.6, 0,
		0, 1, 0,  0.6, 1, 0,
		0, 0, 1,  0, 0.6, 1
	];

	var geometry = new BufferGeometry();
	geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

	var material = new LineBasicMaterial( { vertexColors: VertexColors } );

	LineSegments.call( this, geometry, material );

}

AxisHelper.prototype = Object.create( LineSegments.prototype );
AxisHelper.prototype.constructor = AxisHelper;

/**
 * @author zz85 https://github.com/zz85
 *
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */

var CatmullRomCurve3 = ( function() {

	var
		tmp = new Vector3(),
		px = new CubicPoly(),
		py = new CubicPoly(),
		pz = new CubicPoly();

	/*
	Based on an optimized c++ solution in
	 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
	 - http://ideone.com/NoEbVM

	This CubicPoly class could be used for reusing some variables and calculations,
	but for three.js curve use, it could be possible inlined and flatten into a single function call
	which can be placed in CurveUtils.
	*/

	function CubicPoly() {}

	/*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */
	CubicPoly.prototype.init = function( x0, x1, t0, t1 ) {

		this.c0 = x0;
		this.c1 = t0;
		this.c2 = - 3 * x0 + 3 * x1 - 2 * t0 - t1;
		this.c3 = 2 * x0 - 2 * x1 + t0 + t1;

	};

	CubicPoly.prototype.initNonuniformCatmullRom = function( x0, x1, x2, x3, dt0, dt1, dt2 ) {

		// compute tangents when parameterized in [t1,t2]
		var t1 = ( x1 - x0 ) / dt0 - ( x2 - x0 ) / ( dt0 + dt1 ) + ( x2 - x1 ) / dt1;
		var t2 = ( x2 - x1 ) / dt1 - ( x3 - x1 ) / ( dt1 + dt2 ) + ( x3 - x2 ) / dt2;

		// rescale tangents for parametrization in [0,1]
		t1 *= dt1;
		t2 *= dt1;

		// initCubicPoly
		this.init( x1, x2, t1, t2 );

	};

	// standard Catmull-Rom spline: interpolate between x1 and x2 with previous/following points x1/x4
	CubicPoly.prototype.initCatmullRom = function( x0, x1, x2, x3, tension ) {

		this.init( x1, x2, tension * ( x2 - x0 ), tension * ( x3 - x1 ) );

	};

	CubicPoly.prototype.calc = function( t ) {

		var t2 = t * t;
		var t3 = t2 * t;
		return this.c0 + this.c1 * t + this.c2 * t2 + this.c3 * t3;

	};

	// Subclass Three.js curve
	return Curve.create(

		function ( p /* array of Vector3 */ ) {

			this.points = p || [];
			this.closed = false;

		},

		function ( t ) {

			var points = this.points,
				point, intPoint, weight, l;

			l = points.length;

			if ( l < 2 ) console.log( 'duh, you need at least 2 points' );

			point = ( l - ( this.closed ? 0 : 1 ) ) * t;
			intPoint = Math.floor( point );
			weight = point - intPoint;

			if ( this.closed ) {

				intPoint += intPoint > 0 ? 0 : ( Math.floor( Math.abs( intPoint ) / points.length ) + 1 ) * points.length;

			} else if ( weight === 0 && intPoint === l - 1 ) {

				intPoint = l - 2;
				weight = 1;

			}

			var p0, p1, p2, p3; // 4 points

			if ( this.closed || intPoint > 0 ) {

				p0 = points[ ( intPoint - 1 ) % l ];

			} else {

				// extrapolate first point
				tmp.subVectors( points[ 0 ], points[ 1 ] ).add( points[ 0 ] );
				p0 = tmp;

			}

			p1 = points[ intPoint % l ];
			p2 = points[ ( intPoint + 1 ) % l ];

			if ( this.closed || intPoint + 2 < l ) {

				p3 = points[ ( intPoint + 2 ) % l ];

			} else {

				// extrapolate last point
				tmp.subVectors( points[ l - 1 ], points[ l - 2 ] ).add( points[ l - 1 ] );
				p3 = tmp;

			}

			if ( this.type === undefined || this.type === 'centripetal' || this.type === 'chordal' ) {

				// init Centripetal / Chordal Catmull-Rom
				var pow = this.type === 'chordal' ? 0.5 : 0.25;
				var dt0 = Math.pow( p0.distanceToSquared( p1 ), pow );
				var dt1 = Math.pow( p1.distanceToSquared( p2 ), pow );
				var dt2 = Math.pow( p2.distanceToSquared( p3 ), pow );

				// safety check for repeated points
				if ( dt1 < 1e-4 ) dt1 = 1.0;
				if ( dt0 < 1e-4 ) dt0 = dt1;
				if ( dt2 < 1e-4 ) dt2 = dt1;

				px.initNonuniformCatmullRom( p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2 );
				py.initNonuniformCatmullRom( p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2 );
				pz.initNonuniformCatmullRom( p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2 );

			} else if ( this.type === 'catmullrom' ) {

				var tension = this.tension !== undefined ? this.tension : 0.5;
				px.initCatmullRom( p0.x, p1.x, p2.x, p3.x, tension );
				py.initCatmullRom( p0.y, p1.y, p2.y, p3.y, tension );
				pz.initCatmullRom( p0.z, p1.z, p2.z, p3.z, tension );

			}

			var v = new Vector3(
				px.calc( weight ),
				py.calc( weight ),
				pz.calc( weight )
			);

			return v;

		}

	);

} )();

/**************************************************************
 *	Spline 3D curve
 **************************************************************/


var SplineCurve3 = Curve.create(

	function ( points /* array of Vector3 */ ) {

		console.warn( 'THREE.SplineCurve3 will be deprecated. Please use THREE.CatmullRomCurve3' );
		this.points = ( points === undefined ) ? [] : points;

	},

	function ( t ) {

		var points = this.points;
		var point = ( points.length - 1 ) * t;

		var intPoint = Math.floor( point );
		var weight = point - intPoint;

		var point0 = points[ intPoint == 0 ? intPoint : intPoint - 1 ];
		var point1 = points[ intPoint ];
		var point2 = points[ intPoint > points.length - 2 ? points.length - 1 : intPoint + 1 ];
		var point3 = points[ intPoint > points.length - 3 ? points.length - 1 : intPoint + 2 ];

		var interpolate = CurveUtils.interpolate;

		return new Vector3(
			interpolate( point0.x, point1.x, point2.x, point3.x, weight ),
			interpolate( point0.y, point1.y, point2.y, point3.y, weight ),
			interpolate( point0.z, point1.z, point2.z, point3.z, weight )
		);

	}

);

/**************************************************************
 *	Cubic Bezier 3D curve
 **************************************************************/

var CubicBezierCurve3 = Curve.create(

	function ( v0, v1, v2, v3 ) {

		this.v0 = v0;
		this.v1 = v1;
		this.v2 = v2;
		this.v3 = v3;

	},

	function ( t ) {

		var b3 = ShapeUtils.b3;

		return new Vector3(
			b3( t, this.v0.x, this.v1.x, this.v2.x, this.v3.x ),
			b3( t, this.v0.y, this.v1.y, this.v2.y, this.v3.y ),
			b3( t, this.v0.z, this.v1.z, this.v2.z, this.v3.z )
		);

	}

);

/**************************************************************
 *	Quadratic Bezier 3D curve
 **************************************************************/

var QuadraticBezierCurve3 = Curve.create(

	function ( v0, v1, v2 ) {

		this.v0 = v0;
		this.v1 = v1;
		this.v2 = v2;

	},

	function ( t ) {

		var b2 = ShapeUtils.b2;

		return new Vector3(
			b2( t, this.v0.x, this.v1.x, this.v2.x ),
			b2( t, this.v0.y, this.v1.y, this.v2.y ),
			b2( t, this.v0.z, this.v1.z, this.v2.z )
		);

	}

);

/**************************************************************
 *	Line3D
 **************************************************************/

var LineCurve3 = Curve.create(

	function ( v1, v2 ) {

		this.v1 = v1;
		this.v2 = v2;

	},

	function ( t ) {

		if ( t === 1 ) {

			return this.v2.clone();

		}

		var vector = new Vector3();

		vector.subVectors( this.v2, this.v1 ); // diff
		vector.multiplyScalar( t );
		vector.add( this.v1 );

		return vector;

	}

);

/**************************************************************
 *	Arc curve
 **************************************************************/

function ArcCurve( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {

	EllipseCurve.call( this, aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise );

}

ArcCurve.prototype = Object.create( EllipseCurve.prototype );
ArcCurve.prototype.constructor = ArcCurve;

/**
 * @author alteredq / http://alteredqualia.com/
 */

var SceneUtils = {

	createMultiMaterialObject: function ( geometry, materials ) {

		var group = new Group();

		for ( var i = 0, l = materials.length; i < l; i ++ ) {

			group.add( new Mesh( geometry, materials[ i ] ) );

		}

		return group;

	},

	detach: function ( child, parent, scene ) {

		child.applyMatrix( parent.matrixWorld );
		parent.remove( child );
		scene.add( child );

	},

	attach: function ( child, scene, parent ) {

		var matrixWorldInverse = new Matrix4();
		matrixWorldInverse.getInverse( parent.matrixWorld );
		child.applyMatrix( matrixWorldInverse );

		scene.remove( child );
		parent.add( child );

	}

};

/**
 * @author mrdoob / http://mrdoob.com/
 */

function Face4( a, b, c, d, normal, color, materialIndex ) {

	console.warn( 'THREE.Face4 has been removed. A THREE.Face3 will be created instead.' );
	return new Face3( a, b, c, normal, color, materialIndex );

}

var LineStrip = 0;

var LinePieces = 1;

function MeshFaceMaterial( materials ) {

	console.warn( 'THREE.MeshFaceMaterial has been renamed to THREE.MultiMaterial.' );
	return new MultiMaterial( materials );

}

function PointCloud( geometry, material ) {

	console.warn( 'THREE.PointCloud has been renamed to THREE.Points.' );
	return new Points( geometry, material );

}

function Particle( material ) {

	console.warn( 'THREE.Particle has been renamed to THREE.Sprite.' );
	return new Sprite( material );

}

function ParticleSystem( geometry, material ) {

	console.warn( 'THREE.ParticleSystem has been renamed to THREE.Points.' );
	return new Points( geometry, material );

}

function PointCloudMaterial( parameters ) {

	console.warn( 'THREE.PointCloudMaterial has been renamed to THREE.PointsMaterial.' );
	return new PointsMaterial( parameters );

}

function ParticleBasicMaterial( parameters ) {

	console.warn( 'THREE.ParticleBasicMaterial has been renamed to THREE.PointsMaterial.' );
	return new PointsMaterial( parameters );

}

function ParticleSystemMaterial( parameters ) {

	console.warn( 'THREE.ParticleSystemMaterial has been renamed to THREE.PointsMaterial.' );
	return new PointsMaterial( parameters );

}

function Vertex( x, y, z ) {

	console.warn( 'THREE.Vertex has been removed. Use THREE.Vector3 instead.' );
	return new Vector3( x, y, z );

}

//

function DynamicBufferAttribute( array, itemSize ) {

	console.warn( 'THREE.DynamicBufferAttribute has been removed. Use new THREE.BufferAttribute().setDynamic( true ) instead.' );
	return new BufferAttribute( array, itemSize ).setDynamic( true );

}

function Int8Attribute( array, itemSize ) {

	console.warn( 'THREE.Int8Attribute has been removed. Use new THREE.Int8BufferAttribute() instead.' );
	return new Int8BufferAttribute( array, itemSize );

}

function Uint8Attribute( array, itemSize ) {

	console.warn( 'THREE.Uint8Attribute has been removed. Use new THREE.Uint8BufferAttribute() instead.' );
	return new Uint8BufferAttribute( array, itemSize );

}

function Uint8ClampedAttribute( array, itemSize ) {

	console.warn( 'THREE.Uint8ClampedAttribute has been removed. Use new THREE.Uint8ClampedBufferAttribute() instead.' );
	return new Uint8ClampedBufferAttribute( array, itemSize );

}

function Int16Attribute( array, itemSize ) {

	console.warn( 'THREE.Int16Attribute has been removed. Use new THREE.Int16BufferAttribute() instead.' );
	return new Int16BufferAttribute( array, itemSize );

}

function Uint16Attribute( array, itemSize ) {

	console.warn( 'THREE.Uint16Attribute has been removed. Use new THREE.Uint16BufferAttribute() instead.' );
	return new Uint16BufferAttribute( array, itemSize );

}

function Int32Attribute( array, itemSize ) {

	console.warn( 'THREE.Int32Attribute has been removed. Use new THREE.Int32BufferAttribute() instead.' );
	return new Int32BufferAttribute( array, itemSize );

}

function Uint32Attribute( array, itemSize ) {

	console.warn( 'THREE.Uint32Attribute has been removed. Use new THREE.Uint32BufferAttribute() instead.' );
	return new Uint32BufferAttribute( array, itemSize );

}

function Float32Attribute( array, itemSize ) {

	console.warn( 'THREE.Float32Attribute has been removed. Use new THREE.Float32BufferAttribute() instead.' );
	return new Float32BufferAttribute( array, itemSize );

}

function Float64Attribute( array, itemSize ) {

	console.warn( 'THREE.Float64Attribute has been removed. Use new THREE.Float64BufferAttribute() instead.' );
	return new Float64BufferAttribute( array, itemSize );

}

//

function ClosedSplineCurve3( points ) {

	console.warn( 'THREE.ClosedSplineCurve3 has been deprecated. Use THREE.CatmullRomCurve3 instead.' );

	CatmullRomCurve3.call( this, points );
	this.type = 'catmullrom';
	this.closed = true;

}

ClosedSplineCurve3.prototype = Object.create( CatmullRomCurve3.prototype );


//
function BoundingBoxHelper( object, color ) {

	console.warn( 'THREE.BoundingBoxHelper has been deprecated. Creating a THREE.BoxHelper instead.' );
	return new BoxHelper( object, color );

}

function EdgesHelper( object, hex ) {

	console.warn( 'THREE.EdgesHelper has been removed. Use THREE.EdgesGeometry instead.' );
	return new LineSegments( new EdgesGeometry( object.geometry ), new LineBasicMaterial( { color: hex !== undefined ? hex : 0xffffff } ) );

}

GridHelper.prototype.setColors = function () {

	console.error( 'THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.' );

};

function WireframeHelper( object, hex ) {

	console.warn( 'THREE.WireframeHelper has been removed. Use THREE.WireframeGeometry instead.' );
	return new LineSegments( new WireframeGeometry( object.geometry ), new LineBasicMaterial( { color: hex !== undefined ? hex : 0xffffff } ) );

}

//

function XHRLoader( manager ) {

	console.warn( 'THREE.XHRLoader has been renamed to THREE.FileLoader.' );
	return new FileLoader( manager );

}

//

Object.assign( Box2.prototype, {

	center: function ( optionalTarget ) {

		console.warn( 'THREE.Box2: .center() has been renamed to .getCenter().' );
		return this.getCenter( optionalTarget );

	},
	empty: function () {

		console.warn( 'THREE.Box2: .empty() has been renamed to .isEmpty().' );
		return this.isEmpty();

	},
	isIntersectionBox: function ( box ) {

		console.warn( 'THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox().' );
		return this.intersectsBox( box );

	},
	size: function ( optionalTarget ) {

		console.warn( 'THREE.Box2: .size() has been renamed to .getSize().' );
		return this.getSize( optionalTarget );

	}
} );

Object.assign( Box3.prototype, {

	center: function ( optionalTarget ) {

		console.warn( 'THREE.Box3: .center() has been renamed to .getCenter().' );
		return this.getCenter( optionalTarget );

	},
	empty: function () {

		console.warn( 'THREE.Box3: .empty() has been renamed to .isEmpty().' );
		return this.isEmpty();

	},
	isIntersectionBox: function ( box ) {

		console.warn( 'THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox().' );
		return this.intersectsBox( box );

	},
	isIntersectionSphere: function ( sphere ) {

		console.warn( 'THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere().' );
		return this.intersectsSphere( sphere );

	},
	size: function ( optionalTarget ) {

		console.warn( 'THREE.Box3: .size() has been renamed to .getSize().' );
		return this.getSize( optionalTarget );

	}
} );

Line3.prototype.center = function ( optionalTarget ) {

	console.warn( 'THREE.Line3: .center() has been renamed to .getCenter().' );
	return this.getCenter( optionalTarget );

};

_Math.random16 = function () {

	console.warn( 'THREE.Math.random16() has been deprecated. Use Math.random() instead.' );
	return Math.random();

};

Object.assign( Matrix3.prototype, {

	flattenToArrayOffset: function ( array, offset ) {

		console.warn( "THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead." );
		return this.toArray( array, offset );

	},
	multiplyVector3: function ( vector ) {

		console.warn( 'THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.' );
		return vector.applyMatrix3( this );

	},
	multiplyVector3Array: function ( a ) {

		console.warn( 'THREE.Matrix3: .multiplyVector3Array() has been renamed. Use matrix.applyToVector3Array( array ) instead.' );
		return this.applyToVector3Array( a );

	},
	applyToBuffer: function( buffer, offset, length ) {

		console.warn( 'THREE.Matrix3: .applyToBuffer() has been removed. Use matrix.applyToBufferAttribute( attribute ) instead.' );
		return this.applyToBufferAttribute( buffer );

	}

} );

Object.assign( Matrix4.prototype, {

	extractPosition: function ( m ) {

		console.warn( 'THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().' );
		return this.copyPosition( m );

	},
	flattenToArrayOffset: function ( array, offset ) {

		console.warn( "THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead." );
		return this.toArray( array, offset );

	},
	getPosition: function () {

		var v1;

		return function getPosition() {

			if ( v1 === undefined ) v1 = new Vector3();
			console.warn( 'THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.' );
			return v1.setFromMatrixColumn( this, 3 );

		};

	}(),
	setRotationFromQuaternion: function ( q ) {

		console.warn( 'THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().' );
		return this.makeRotationFromQuaternion( q );

	},
	multiplyVector3: function ( vector ) {

		console.warn( 'THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) or vector.applyProjection( matrix ) instead.' );
		return vector.applyProjection( this );

	},
	multiplyVector4: function ( vector ) {

		console.warn( 'THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.' );
		return vector.applyMatrix4( this );

	},
	multiplyVector3Array: function ( a ) {

		console.warn( 'THREE.Matrix4: .multiplyVector3Array() has been renamed. Use matrix.applyToVector3Array( array ) instead.' );
		return this.applyToVector3Array( a );

	},
	rotateAxis: function ( v ) {

		console.warn( 'THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.' );
		v.transformDirection( this );

	},
	crossVector: function ( vector ) {

		console.warn( 'THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.' );
		return vector.applyMatrix4( this );

	},
	translate: function () {

		console.error( 'THREE.Matrix4: .translate() has been removed.' );

	},
	rotateX: function () {

		console.error( 'THREE.Matrix4: .rotateX() has been removed.' );

	},
	rotateY: function () {

		console.error( 'THREE.Matrix4: .rotateY() has been removed.' );

	},
	rotateZ: function () {

		console.error( 'THREE.Matrix4: .rotateZ() has been removed.' );

	},
	rotateByAxis: function () {

		console.error( 'THREE.Matrix4: .rotateByAxis() has been removed.' );

	},
	applyToBuffer: function( buffer, offset, length ) {

		console.warn( 'THREE.Matrix4: .applyToBuffer() has been removed. Use matrix.applyToBufferAttribute( attribute ) instead.' );
		return this.applyToBufferAttribute( buffer );

	}

} );

Plane.prototype.isIntersectionLine = function ( line ) {

	console.warn( 'THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine().' );
	return this.intersectsLine( line );

};

Quaternion.prototype.multiplyVector3 = function ( vector ) {

	console.warn( 'THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.' );
	return vector.applyQuaternion( this );

};

Object.assign( Ray.prototype, {

	isIntersectionBox: function ( box ) {

		console.warn( 'THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox().' );
		return this.intersectsBox( box );

	},
	isIntersectionPlane: function ( plane ) {

		console.warn( 'THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane().' );
		return this.intersectsPlane( plane );

	},
	isIntersectionSphere: function ( sphere ) {

		console.warn( 'THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere().' );
		return this.intersectsSphere( sphere );

	}

} );

Object.assign( Shape.prototype, {

	extrude: function ( options ) {

		console.warn( 'THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead.' );
		return new ExtrudeGeometry( this, options );

	},
	makeGeometry: function ( options ) {

		console.warn( 'THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead.' );
		return new ShapeGeometry( this, options );

	}

} );

Object.assign( Vector3.prototype, {

	setEulerFromRotationMatrix: function () {

		console.error( 'THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.' );

	},
	setEulerFromQuaternion: function () {

		console.error( 'THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.' );

	},
	getPositionFromMatrix: function ( m ) {

		console.warn( 'THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().' );
		return this.setFromMatrixPosition( m );

	},
	getScaleFromMatrix: function ( m ) {

		console.warn( 'THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().' );
		return this.setFromMatrixScale( m );

	},
	getColumnFromMatrix: function ( index, matrix ) {

		console.warn( 'THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().' );
		return this.setFromMatrixColumn( matrix, index );

	}

} );

//

Geometry.prototype.computeTangents = function () {

	console.warn( 'THREE.Geometry: .computeTangents() has been removed.' );

};

Object.assign( Object3D.prototype, {

	getChildByName: function ( name ) {

		console.warn( 'THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().' );
		return this.getObjectByName( name );

	},
	renderDepth: function () {

		console.warn( 'THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.' );

	},
	translate: function ( distance, axis ) {

		console.warn( 'THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.' );
		return this.translateOnAxis( axis, distance );

	}

} );

Object.defineProperties( Object3D.prototype, {

	eulerOrder: {
		get: function () {

			console.warn( 'THREE.Object3D: .eulerOrder is now .rotation.order.' );
			return this.rotation.order;

		},
		set: function ( value ) {

			console.warn( 'THREE.Object3D: .eulerOrder is now .rotation.order.' );
			this.rotation.order = value;

		}
	},
	useQuaternion: {
		get: function () {

			console.warn( 'THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.' );

		},
		set: function () {

			console.warn( 'THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.' );

		}
	}

} );

Object.defineProperties( LOD.prototype, {

	objects: {
		get: function () {

			console.warn( 'THREE.LOD: .objects has been renamed to .levels.' );
			return this.levels;

		}
	}

} );

//

PerspectiveCamera.prototype.setLens = function ( focalLength, filmGauge ) {

	console.warn( "THREE.PerspectiveCamera.setLens is deprecated. " +
			"Use .setFocalLength and .filmGauge for a photographic setup." );

	if ( filmGauge !== undefined ) this.filmGauge = filmGauge;
	this.setFocalLength( focalLength );

};

//

Object.defineProperties( Light.prototype, {
	onlyShadow: {
		set: function () {

			console.warn( 'THREE.Light: .onlyShadow has been removed.' );

		}
	},
	shadowCameraFov: {
		set: function ( value ) {

			console.warn( 'THREE.Light: .shadowCameraFov is now .shadow.camera.fov.' );
			this.shadow.camera.fov = value;

		}
	},
	shadowCameraLeft: {
		set: function ( value ) {

			console.warn( 'THREE.Light: .shadowCameraLeft is now .shadow.camera.left.' );
			this.shadow.camera.left = value;

		}
	},
	shadowCameraRight: {
		set: function ( value ) {

			console.warn( 'THREE.Light: .shadowCameraRight is now .shadow.camera.right.' );
			this.shadow.camera.right = value;

		}
	},
	shadowCameraTop: {
		set: function ( value ) {

			console.warn( 'THREE.Light: .shadowCameraTop is now .shadow.camera.top.' );
			this.shadow.camera.top = value;

		}
	},
	shadowCameraBottom: {
		set: function ( value ) {

			console.warn( 'THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom.' );
			this.shadow.camera.bottom = value;

		}
	},
	shadowCameraNear: {
		set: function ( value ) {

			console.warn( 'THREE.Light: .shadowCameraNear is now .shadow.camera.near.' );
			this.shadow.camera.near = value;

		}
	},
	shadowCameraFar: {
		set: function ( value ) {

			console.warn( 'THREE.Light: .shadowCameraFar is now .shadow.camera.far.' );
			this.shadow.camera.far = value;

		}
	},
	shadowCameraVisible: {
		set: function () {

			console.warn( 'THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.' );

		}
	},
	shadowBias: {
		set: function ( value ) {

			console.warn( 'THREE.Light: .shadowBias is now .shadow.bias.' );
			this.shadow.bias = value;

		}
	},
	shadowDarkness: {
		set: function () {

			console.warn( 'THREE.Light: .shadowDarkness has been removed.' );

		}
	},
	shadowMapWidth: {
		set: function ( value ) {

			console.warn( 'THREE.Light: .shadowMapWidth is now .shadow.mapSize.width.' );
			this.shadow.mapSize.width = value;

		}
	},
	shadowMapHeight: {
		set: function ( value ) {

			console.warn( 'THREE.Light: .shadowMapHeight is now .shadow.mapSize.height.' );
			this.shadow.mapSize.height = value;

		}
	}
} );

//

Object.defineProperties( BufferAttribute.prototype, {

	length: {
		get: function () {

			console.warn( 'THREE.BufferAttribute: .length has been deprecated. Use .count instead.' );
			return this.array.length;

		}
	}

} );

Object.assign( BufferGeometry.prototype, {

	addIndex: function ( index ) {

		console.warn( 'THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().' );
		this.setIndex( index );

	},
	addDrawCall: function ( start, count, indexOffset ) {

		if ( indexOffset !== undefined ) {

			console.warn( 'THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.' );

		}
		console.warn( 'THREE.BufferGeometry: .addDrawCall() is now .addGroup().' );
		this.addGroup( start, count );

	},
	clearDrawCalls: function () {

		console.warn( 'THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().' );
		this.clearGroups();

	},
	computeTangents: function () {

		console.warn( 'THREE.BufferGeometry: .computeTangents() has been removed.' );

	},
	computeOffsets: function () {

		console.warn( 'THREE.BufferGeometry: .computeOffsets() has been removed.' );

	}

} );

Object.defineProperties( BufferGeometry.prototype, {

	drawcalls: {
		get: function () {

			console.error( 'THREE.BufferGeometry: .drawcalls has been renamed to .groups.' );
			return this.groups;

		}
	},
	offsets: {
		get: function () {

			console.warn( 'THREE.BufferGeometry: .offsets has been renamed to .groups.' );
			return this.groups;

		}
	}

} );

//

Object.defineProperties( Uniform.prototype, {

	dynamic: {
		set: function () {

			console.warn( 'THREE.Uniform: .dynamic has been removed. Use object.onBeforeRender() instead.' );

		}
	},
	onUpdate: {
		value: function () {

			console.warn( 'THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead.' );
			return this;

		}
	}

} );

//

Object.defineProperties( Material.prototype, {

	wrapAround: {
		get: function () {

			console.warn( 'THREE.' + this.type + ': .wrapAround has been removed.' );

		},
		set: function () {

			console.warn( 'THREE.' + this.type + ': .wrapAround has been removed.' );

		}
	},
	wrapRGB: {
		get: function () {

			console.warn( 'THREE.' + this.type + ': .wrapRGB has been removed.' );
			return new Color();

		}
	}

} );

Object.defineProperties( MeshPhongMaterial.prototype, {

	metal: {
		get: function () {

			console.warn( 'THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead.' );
			return false;

		},
		set: function () {

			console.warn( 'THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead' );

		}
	}

} );

Object.defineProperties( ShaderMaterial.prototype, {

	derivatives: {
		get: function () {

			console.warn( 'THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives.' );
			return this.extensions.derivatives;

		},
		set: function ( value ) {

			console.warn( 'THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives.' );
			this.extensions.derivatives = value;

		}
	}

} );

//

EventDispatcher.prototype = Object.assign( Object.create( {

	// Note: Extra base ensures these properties are not 'assign'ed.

	constructor: EventDispatcher,

	apply: function ( target ) {

		console.warn( "THREE.EventDispatcher: .apply is deprecated, " +
				"just inherit or Object.assign the prototype to mix-in." );

		Object.assign( target, this );

	}

} ), EventDispatcher.prototype );

//

Object.assign( WebGLRenderer.prototype, {

	supportsFloatTextures: function () {

		console.warn( 'THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( \'OES_texture_float\' ).' );
		return this.extensions.get( 'OES_texture_float' );

	},
	supportsHalfFloatTextures: function () {

		console.warn( 'THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( \'OES_texture_half_float\' ).' );
		return this.extensions.get( 'OES_texture_half_float' );

	},
	supportsStandardDerivatives: function () {

		console.warn( 'THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( \'OES_standard_derivatives\' ).' );
		return this.extensions.get( 'OES_standard_derivatives' );

	},
	supportsCompressedTextureS3TC: function () {

		console.warn( 'THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( \'WEBGL_compressed_texture_s3tc\' ).' );
		return this.extensions.get( 'WEBGL_compressed_texture_s3tc' );

	},
	supportsCompressedTexturePVRTC: function () {

		console.warn( 'THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( \'WEBGL_compressed_texture_pvrtc\' ).' );
		return this.extensions.get( 'WEBGL_compressed_texture_pvrtc' );

	},
	supportsBlendMinMax: function () {

		console.warn( 'THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( \'EXT_blend_minmax\' ).' );
		return this.extensions.get( 'EXT_blend_minmax' );

	},
	supportsVertexTextures: function () {

		console.warn( 'THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures.' );
		return this.capabilities.vertexTextures;

	},
	supportsInstancedArrays: function () {

		console.warn( 'THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( \'ANGLE_instanced_arrays\' ).' );
		return this.extensions.get( 'ANGLE_instanced_arrays' );

	},
	enableScissorTest: function ( boolean ) {

		console.warn( 'THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest().' );
		this.setScissorTest( boolean );

	},
	initMaterial: function () {

		console.warn( 'THREE.WebGLRenderer: .initMaterial() has been removed.' );

	},
	addPrePlugin: function () {

		console.warn( 'THREE.WebGLRenderer: .addPrePlugin() has been removed.' );

	},
	addPostPlugin: function () {

		console.warn( 'THREE.WebGLRenderer: .addPostPlugin() has been removed.' );

	},
	updateShadowMap: function () {

		console.warn( 'THREE.WebGLRenderer: .updateShadowMap() has been removed.' );

	}

} );

Object.defineProperties( WebGLRenderer.prototype, {

	shadowMapEnabled: {
		get: function () {

			return this.shadowMap.enabled;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.' );
			this.shadowMap.enabled = value;

		}
	},
	shadowMapType: {
		get: function () {

			return this.shadowMap.type;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.' );
			this.shadowMap.type = value;

		}
	},
	shadowMapCullFace: {
		get: function () {

			return this.shadowMap.cullFace;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderer: .shadowMapCullFace is now .shadowMap.cullFace.' );
			this.shadowMap.cullFace = value;

		}
	}
} );

Object.defineProperties( WebGLShadowMap.prototype, {

	cullFace: {
		get: function () {

			return this.renderReverseSided ? CullFaceFront : CullFaceBack;

		},
		set: function ( cullFace ) {

			var value = ( cullFace !== CullFaceBack );
			console.warn( "WebGLRenderer: .shadowMap.cullFace is deprecated. Set .shadowMap.renderReverseSided to " + value + "." );
			this.renderReverseSided = value;

		}
	}

} );

//

Object.defineProperties( WebGLRenderTarget.prototype, {

	wrapS: {
		get: function () {

			console.warn( 'THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.' );
			return this.texture.wrapS;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.' );
			this.texture.wrapS = value;

		}
	},
	wrapT: {
		get: function () {

			console.warn( 'THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.' );
			return this.texture.wrapT;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.' );
			this.texture.wrapT = value;

		}
	},
	magFilter: {
		get: function () {

			console.warn( 'THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.' );
			return this.texture.magFilter;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.' );
			this.texture.magFilter = value;

		}
	},
	minFilter: {
		get: function () {

			console.warn( 'THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.' );
			return this.texture.minFilter;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.' );
			this.texture.minFilter = value;

		}
	},
	anisotropy: {
		get: function () {

			console.warn( 'THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.' );
			return this.texture.anisotropy;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.' );
			this.texture.anisotropy = value;

		}
	},
	offset: {
		get: function () {

			console.warn( 'THREE.WebGLRenderTarget: .offset is now .texture.offset.' );
			return this.texture.offset;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderTarget: .offset is now .texture.offset.' );
			this.texture.offset = value;

		}
	},
	repeat: {
		get: function () {

			console.warn( 'THREE.WebGLRenderTarget: .repeat is now .texture.repeat.' );
			return this.texture.repeat;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderTarget: .repeat is now .texture.repeat.' );
			this.texture.repeat = value;

		}
	},
	format: {
		get: function () {

			console.warn( 'THREE.WebGLRenderTarget: .format is now .texture.format.' );
			return this.texture.format;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderTarget: .format is now .texture.format.' );
			this.texture.format = value;

		}
	},
	type: {
		get: function () {

			console.warn( 'THREE.WebGLRenderTarget: .type is now .texture.type.' );
			return this.texture.type;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderTarget: .type is now .texture.type.' );
			this.texture.type = value;

		}
	},
	generateMipmaps: {
		get: function () {

			console.warn( 'THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.' );
			return this.texture.generateMipmaps;

		},
		set: function ( value ) {

			console.warn( 'THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.' );
			this.texture.generateMipmaps = value;

		}
	}

} );

//

Audio.prototype.load = function ( file ) {

	console.warn( 'THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.' );
	var scope = this;
	var audioLoader = new AudioLoader();
	audioLoader.load( file, function ( buffer ) {

		scope.setBuffer( buffer );

	} );
	return this;

};

AudioAnalyser.prototype.getData = function () {

	console.warn( 'THREE.AudioAnalyser: .getData() is now .getFrequencyData().' );
	return this.getFrequencyData();

};

//

var GeometryUtils = {

	merge: function ( geometry1, geometry2, materialIndexOffset ) {

		console.warn( 'THREE.GeometryUtils: .merge() has been moved to Geometry. Use geometry.merge( geometry2, matrix, materialIndexOffset ) instead.' );
		var matrix;

		if ( geometry2.isMesh ) {

			geometry2.matrixAutoUpdate && geometry2.updateMatrix();

			matrix = geometry2.matrix;
			geometry2 = geometry2.geometry;

		}

		geometry1.merge( geometry2, matrix, materialIndexOffset );

	},

	center: function ( geometry ) {

		console.warn( 'THREE.GeometryUtils: .center() has been moved to Geometry. Use geometry.center() instead.' );
		return geometry.center();

	}

};

var ImageUtils = {

	crossOrigin: undefined,

	loadTexture: function ( url, mapping, onLoad, onError ) {

		console.warn( 'THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.' );

		var loader = new TextureLoader();
		loader.setCrossOrigin( this.crossOrigin );

		var texture = loader.load( url, onLoad, undefined, onError );

		if ( mapping ) texture.mapping = mapping;

		return texture;

	},

	loadTextureCube: function ( urls, mapping, onLoad, onError ) {

		console.warn( 'THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.' );

		var loader = new CubeTextureLoader();
		loader.setCrossOrigin( this.crossOrigin );

		var texture = loader.load( urls, onLoad, undefined, onError );

		if ( mapping ) texture.mapping = mapping;

		return texture;

	},

	loadCompressedTexture: function () {

		console.error( 'THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.' );

	},

	loadCompressedTextureCube: function () {

		console.error( 'THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.' );

	}

};

//

function Projector() {

	console.error( 'THREE.Projector has been moved to /examples/js/renderers/Projector.js.' );

	this.projectVector = function ( vector, camera ) {

		console.warn( 'THREE.Projector: .projectVector() is now vector.project().' );
		vector.project( camera );

	};

	this.unprojectVector = function ( vector, camera ) {

		console.warn( 'THREE.Projector: .unprojectVector() is now vector.unproject().' );
		vector.unproject( camera );

	};

	this.pickingRay = function () {

		console.error( 'THREE.Projector: .pickingRay() is now raycaster.setFromCamera().' );

	};

}

//

function CanvasRenderer() {

	console.error( 'THREE.CanvasRenderer has been moved to /examples/js/renderers/CanvasRenderer.js' );

	this.domElement = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
	this.clear = function () {};
	this.render = function () {};
	this.setClearColor = function () {};
	this.setSize = function () {};

}




/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Warehouse-with-lights.9bece622.jpg";

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/de7210d05da8121f74aae2397de48b96.de7210d0.jpg";

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/equirectangular-final.c449cf5e.jpg";

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/panorama-360-nordic-style-family-bedroom-space-01-3d-model-max.f673abdd.jpg";

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/panorama-360-nordic-style-living-room-dining-room-01-3d-model-max.1038b2d5.jpg";

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/panorama-360-nordic-style-living-room-dining-room-10-3d-model-max.f1afd765.jpg";

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bg.21a75ade.png";

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAADm5+jm5+jm5+jm5+jm5+jm5+jSgI3ITV/ctLq+GTHNZnbk2t3BJjzhzdHm5+jXmqPQc4Hap6/GQFPVjZjLWWrDM0jfwMZLVloIAAAAB3RSTlMAYL8AIM/vi50ITwAAAZJJREFUeF7t2FtvgzAMBeDCoLZz5/7//+lIR0k3moYGa9okzhMP5AMdCwn58piitG+kLD4ecgmXVW3fTF09g6qrfTvX6glU24zUW6iwWSk2UJkHlRvIZub3IUAcYGKAUPjgcagXt9BhyHxBDGV33hkYIOkhYIDAQy0D5DxEDBBlQCdkpsOQIoJBCzGCyoQkNIhahOg+BRGtfShqocFOPA+q15B/mgSQOH4/hhLAkc9dhteQFI/RKOXPsmGB+kRHeCcaR9uphUd1KgEZz+AUH/9XaaOycSjcCDYKKXHLlB5/M0NDHGpD01Eo3IlxqPGOViloKUnHoKWiZtcn4k/GoKUik4BC25GpLRVJuwtCfzIGyfBCSQhmyEUgo8MoklC/jjdAE/UwoFcCm4RogQwROZBiEz3tg5RIZdgH2Qgw4gBzHJHZCWEAEDtv9Hl/I04ISXPUWnbujxZqs5i5UMh/hk7ohE6o44Lwz0ENFwRcUMsB2RkyTNBoWaBOAA/ktEpALEsWtrUP1yKKczXGv6wLObI+/ARub+qEvTFBpAAAAABJRU5ErkJggg=="

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABUFBMVEUAAADm5+jm5+jm5+jm5+jm5+jm5+jm5+hVN4jdLkRwWJpVrO6UhLKSZsxwt+3/rDPl297tu5/5u2Cnmr7U0dyLeazhf4yej7jd3OJeQo6UxuvfUWOYa8m5sMrCu9CXbs5mIROwpcTeOk5esO7Ht96Ep8Hgc4KLwuz9rkH3s2Lyt4T9sD72tGnswaiqblm51ern4t/sw63qzLrp183m5ON3NCXU4OnofGn8s0rv0aTDi3Oeyuvl0NTd4+jQprbDdoOgBB7u1a/cq6fjrbXkub/ii5bWpqrp4NGpe8HRoK2OY8iDWrt3Ua5oRp1ZOox/V7dsSaJ0W57C2Oq8p9rh3+addtDWz+MiZpnxzZk8icTfNkPlsZa/GTFgrOJdPZHqXT7R2+Pjoquw0era3+OVrKj5lDbfrFbyfTm/rHnmfXertMLc1+XhUVt7sNrptKbYxLt3BUy7AAAAB3RSTlMAYL8AIM/vi50ITwAAAtFJREFUeF7F2OWT4jAYwOGFg32TCuou6+7u7q7n7vb/+6UBmqZtlmvYm/t9KTPtPJM3hQ+kw5rPDx7y+55Y6mAfA0HwWDDgBgU6wXOdARcoCBIFnZBPCOxgvCOUfA5IvM+YJN5xBwRyEHiA5jCeewxoI0zaaB/aGzKgob22oViYFpOE+MHYcPLQfBOabw+6D5vde4WWU3lMyqeWmwtiS5rNhVRSKDfbGtrBZilYCFtagJxqttQCiuSxpXzMCsVCqqXQyoMQ5+BnYa6XKicJIDYX6zUPfVC5lsTQMub7zENfVL5ZAbS2vv6iltra3t5K1TDtIw99qgNdubHLy7Fc19O7ux5XaJ0UAVqkl0JhW9Tpa+zymzuSEIJmb0XQO2j0nkKC0dbArNcd6gOzHtFofJGaG9S14v23lnKDcuAd2iJQ/8BgtNHgQD+BxiSgbYyHo1zDqnopAUXw16itbypIQPAj6uinFPTLCf2Wgkac0IgUZACjlcqo9SoNVUjPG1cDGn8s6H+PxicNTTidCSlo0glNSkFTTmhKCpqmQKURhaY9Q2y2mbozwybzBlWVeGLcgBbr0KIBjSfiStUjBEmE0qtUImuaoc5qGqGk59EyWYT0zailTR2hbMYzBBqBChZps0AgDbxDRQLphd2ms1vQCVSUgErolU7aPzCYg32dhFBJCkI6lyxUtEOyo2lukAZSr/+Qdw6lXn8SIXTEQ0fob7+QVeZUEemYh44RyfqMEFKSmcZcSWR0wkMnyIg9owihOMpqxVKpqGUR7ZSHTinEnokLoQSydWZ1zpCthBCCtA06t0LnNicNYggUHrooM6d8wTsKPARlOEnJXDHoyn5PDNmn0wC+m0sqXwNo3FwtIEhodD5Fo3tpLunKdk8MuXd9U3durtv9c3xbh26hXQi6Dacb5CEmlcvMaQ35QSq/A/LJQb5/dxAlfzT2+Id1rHaOD/8A/wzM5nB/d2AAAAAASUVORK5CYII="

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkT////fO1Dul6L52NzdLkT98vPysbnjVWfqfIr75ej0vsXob37hSFvsiZbwpK33y9DmYnPrHwRjAAAAB3RSTlMAYL8AIM/vi50ITwAAAZpJREFUeF7t2NeSgzAMBVDTVu6F+v9/ukmWsQME96ed3HfOREZyBqFnmpYVpG26R1DX9QMrzNA/of6HFeenf0ADq5ChQw2rkga1daAWsUr5l9AXwoQCcCFLIcnhL6QIcg7AXARRcJkKIAVvEQUQhffgbGiCQ1Q2RI7Qmg1pOGbKhDY4Zc6ExA5ws0M0D8J8h8wMe2QO5JpI2be3ZEHG9o/tJ50BuSYyjNnaxnTIPazeUJEBaVeZmxWeDklb2aHHVTK02EePbDLEbWWnQhOh8fQTltCYoFATqdOR0TQIX24zHbgCUKCJzOXwSRJEbWWXO0WnQJOr7PoaZQK0fDha4R8T5B8PsdnY5ubx0AjejNGQ8EMmFsIc/MGRkIJAVCS0hqA1DpogmCkKmsPQHAXpMKRjIGmBlZwirCQjIHHfeNhCSwTEPaNg7mtD9+MhfB22BSHiGylXG0mAvBceiS9N+P/HgxCjvosQ703GcRjCr1Hjin2MfElaRg2tJERhdpeRkPH74XfMF6q2ZKm29qm1iKq2Gqu5rHukxvrwF1Ts0r64XjMIAAAAAElFTkSuQmCC"

/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkT////fO1D52NzmYnPhSFvysbnob3798vPqfIr3y9DjVWful6L75ejsiZbwpK30vsU4MT1ZAAAAB3RSTlMAYL8AIM/vi50ITwAAATRJREFUeF7t2MtugzAQhlGumfH1AiR5/zdtvAhO21DVnr+bim/J4gghrIHpcv1AgoZ+fNSN4zSTsHnK0HQhcZfpAc0EaB67niD13YCBho5A/SvohBbzuUbIbPw1fVX1kOG3rdWQ5vdpVQkxH0pV0MKHpSrI8HERBWkUxLYJcibnHZdiE7Q+6VAuiSBaUZBCQYS/Iy+D4g4pEaS2p+NIAvndCbYN2lKOSxFzaIMnCOQsYSBOUQiVNi+ESg4FsUNBHFvfo9wrFJTk9PutSFcJRErvkBZBZHlPSaDXQW5kUGI8hHpGiwi6F4gEkHLF0W0jOxdvgUs30FnjBQQlwkDB/hqyP0JR+DFanArozlUD6Riy4YBZFVVBZN13JTn/x39HJ3RCsCULbO2DWkTBVmPIZd0jxPrwAywklb4UhZr3AAAAAElFTkSuQmCC"

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAC+GTG+GTG+GTG+GTG+GTG+GTHGNkvfjJjvxszafovCJz7////nqbK+GTH78fLjmqXKRFjz1NjWb37rt7/34uXOU2XSYXFk5pifAAAAB3RSTlMAYL8AIM/vi50ITwAAAZpJREFUeF7t2EduwzAQBVCqediLmu9/08iLwGTo0UjRIAgM/zXxKBaxiUea1l9I23RbRNf1g7+YoX9A/c1fzq3foMEzZOhE41nSiJYHaoVnyv+BPpBZpZyVmqVeL0CgR5tFafMrCJz9meDgNGQyJqfkSWgNFskIZ6DJ4gkJgTAHlyYCKh3ym2goWSoBjkBmKauf5ZY5FJI6AsWcGe/f/n3MJU1DkDvFrJEZFAwJucyZ8EGQFASlg0rBYFD9/bOvMj8lTUDZkEENQTYMFYSVdAVR9yDsQvoJpVdQQntQYDUupVA33e1Cqi6H1aR2IXxU6rYfhJDFfv0LiC5GV8UP8fcRPzR5an85OCHjaygSE5L9F5mqvxtdHfTRZSTut8zC0YUtmNoxAW26wH/KuPtBkmnxt0BuR/genwKyENMbpC5bnQVIyMtcUs8tW+VO9DRkRvoQsRgUKruCSuI5aNmJ4ehXO/RhlHZoyKcFY8J68sAeXzvOcFwhrAOOS82ogeGaJVfzflfRD8T2yML27MP1EMX2NMb5WLeF4/nwC5/pEN+EP5/OAAAAAElFTkSuQmCC"

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAAiZpkiZpkiZpkiZpkiZpkiZpkiZpnx9fmRs8wwcJ////+sxtlLg6yDqcbI2ebW4uxZjLPj7PI+eaaevNK6z99nlrl1n7+QpaS7AAAAB3RSTlMAYL8AIM/vi50ITwAAAP1JREFUeF7t2Elug0AUhGFG1xua0UPuf9NgRVZbkb2AV4vE6v8A36JRg6jqXt0gUFO3W1Xbdj2C9d0d6k4Id+o2qAehvq1qUKqrBpSaCqQK9KICnZP/SiYd9kNn8Veto+2Ekr9pve2D/H2JBXliQZ5YkH+xILEDkP40ybOkB6AHbeq5NQABg+eGCIQxQxqCkM/pGoPyxZlikH4uNJMOeyA9fpsztASgZ0dwFFqWi3hOaa8REjSCA13BgWbjQMnAgGQECJCoIQ5NlxtyoUuL/w0VqED25yAIC9KHk0JQ/oiJBSFAV3dJ9tE/fgWijSy02Yc1RNGmMeZYt8WYD78Ba2ybzMRJCooAAAAASUVORK5CYII="

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAC+GTG+GTG+GTG+GTG+GTG+GTH////78fLnqbLfjJjCJz7Wb37vxsy+GTHKRFjz1Nj34uXGNkvSYXHjmqXafovOU2Xrt7+CkYMPAAAAB3RSTlMAYL8AIM/vi50ITwAAAhVJREFUeF7t2Nmu4yAMBuB0O2ZfsvX933TaEcQixtZIZS6O1P+uAn3BJolSpncu1/BBrpfbK9Ptdn+ED/O4v6H7T/g4P/cX9AgD8rhNlzAkl+k6BrpOYVD+D/SFvpB1qzb759Ci4B0/k4EMTdTTWQFyxzx7coBGORaaFdT4FsrQi+YgDZjYQAC8RCGr6BwZgqULuaYD/wTlLuTJxXgIZ1FoJvVTyJtX1ozQ2oG2WlSRbAcyOLXIHSgXp7bK8VDYBCjWkmacw0JBgPTRvlSkWYA8D2Fr6ro3AVJss5fiPHH7Eg/t/PY/scVHbZGDbMJrnSALR2W4J2sXsvuWi6MigTasDDcwI9SNWgKBUnPzZOyAAPkYCBShuZ3XAmkZ2iyB1lpZ6yoRAlCmhbAWx/wGLt420IKVkRXKEKQG0lgZ7ZkMgUEIbyJHHpithfT+N84klGaEXIWSr6lQYp61sKgKrQh54DMzEL6S8gHNIGRlIMThgIwEZRZKuOgCZZASOQjO0A5iNAM5UpqWIdWHoiKQAjkLhfZd47gvkGv3h/bgWSAuW4Ge2NUmOGAFCO/sGXvBfXU5DsJCJpwO+gxZrE2Asi2QAewpU5sXIBXDaUUqkDiEEuOkGCpkc91YEquOHu38m7ZCIebyyqSJ6mhe9GQxejl/1S7GxNCNdTj0e/6LfKEvNOyQZdixz6iDqGFHYyMP614ZcXz4B+oN8V0ZbssvAAAAAElFTkSuQmCC"

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkT////52Nz3y9DwpK3qfIrhSFvmYnPfO1Dysbnul6L75ej98vPsiZbob370vsXjVWeWCIlOAAAAB3RSTlMAYL8AIM/vi50ITwAAAZpJREFUeF7t2NeOgzAQQFFadsa9Uf7/T5cUyyZewJH9gFa5jyE6xFRlmnttBwV1bb/W9P1wg8Juwx0afqC4n2GFblChW9+0UKW26epAXQOV+i/QF1rMTPCepYyLGOCMGpkJCWZxExmV38Fzi86BhMY0x58QedHmHBpdooQfsXjYnkFqxr04ABj0nUCK4G42C0qdtA8gijUg/7XypS0Y5zSXa+Psz+KYDdG368bHHxsY5EISQ0RBnJBSQDZEg0MhLRsSwbGqBGIBklAC2WhhBVC8sqkImtDnoAgKX9Fl0Iy+sQyi6JOXg+By0HKRY6TRN17kgpS1bhFV66YFUukxAmOtB5sIkFMlEOjkJZL2+etIxIAwBAnPhkBjyBnlGfn6nGVDymEcNVxORlv0yRiiUUZsIZjwMOahNL6FgB1CdB9yYguBPoL0PoSjh3Kk6QAy7xCYo5XBlA+BtH87RIUTmyYDFDIuZZyBR3zv8AUojs9bhnIFryayv5cG0tRkZvpIG6m+f/y+0HnVhizVxj61BlHVRmM1h3VrNcaHv0RfmQ89XmibAAAAAElFTkSuQmCC"

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMNHj8dUl8tsptKdxOE7iMOFtdrn8Pj////z+Pu20una6fTO4fBgns7C2uypy+WRvN14rdYYBkN2AAAAB3RSTlMAYL8AIM/vi50ITwAAAcZJREFUeF7tmNmOIyEMRWtJ2uxbLfn/Px2wQwWmaiYtBXW/cN9scY/luHAkhqRxkh9oGueoYZ5vd/mh7rcEun3Jj/V1i6C7bKD7PIyyicZhagOaBtlIHfReHdRBHdRBjAvB2RECV+KxyFoxp3jhgDNIaYPSghwrhVbAy+csJR2Vexhj+V+gxZtDLsZbDoqzCjGkPSVSrbUGLdYUktKZUoo4VW6LmRCDUIHAV0YpKPCB2rVL6jXnnmcfVyAyChaRKgTFMFxZskcbnUamT22yFelwBoGlBrI25FAACODUmAdKImk/gxQZD1kqiKKWHHnziBiO9wSiES1HZiFrlkaTRWsWYuEECjSqLF436tBEk8rasd8ziBL1qSMUyMVpvGr9AMi2aO39j21xkr6Gs+vxu/+Nf63HDzjD9x+kK8B0ex4XH6T49xWB6FPaOIahSy6GHH1cEZbYWMiyCxBog/JoM1xQGPIF5eWlDXmRIIikl8s1wr+xRpwsQWa9Wmwe6sVGnJq00UU5gyQI/fQ5wGHlco4VqzbbuKz7sLk1yitRbnbgQuwUVjnB4Xf+1zqogzqogzqo2SNLs2efVg9RzZ7GWj7WRbV4PvwDVyjm3EaP6e4AAAAASUVORK5CYII="

/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8fO4fBsptKdxOHz+Ptgns5Ul8va6fTC2uz///94rdaRvN220umpy+WFtdrn8PiV8aucAAAAB3RSTlMAYL8AIM/vi50ITwAAAXBJREFUeF7t2NmKwzAMBdCsvfKWden//+mkUQiVKG0ZG+ZhfN8umIOw8xBUPFJWiEhV1nuKum5aRKZtHlBzQ3RuzQ61SJC2LkokSVlUaaCqQKJkKEMpkqEMhcVcGQJgh6u6iQ6A5BHdGSI/PsWjG0V3AGDEkU51YmgeRazqY08gdaRTnSEnoeBGlRVWQfYLyHAX6STUQ/dnaHFHNtHvDDiGzHmEIDsEZMGRfWCBIYcz0P0zFFJB+MOJ+LJnenVHi75c0ScJnenpxatZ+/a7cgriWNHZ1B+k6v5LaMFvIE8K6idoaNVdQL15ZOkkPOz9gu7myKz7++dfWNoYivmO1lOKhjCcUjREPUshFkLn+SFDLIQwnpJ8bkO6f4KwMXCX0LiqPn+EsDCgIKM7Q9NR6IK2526OieDlRORfTQSjLq4/puXQXryF9fJONtUZgrUBZ2Tn0v3Hv5EMZShDGUq2ZEm29km1iEq2Gku5rNuTYn34A6wvuJFso3XhAAAAAElFTkSuQmCC"

/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAACSZsySZsySZsySZsySZsySZsyZcM/k2fL////49fygedK7n9+SZszx7Pndz+/Js+atjNnCqeLWxuymg9bPvOnr4vW0ltyPRC0fAAAAB3RSTlMAYL8AIM/vi50ITwAAAVpJREFUeF7t2NuOgkAMgGGOtp3zcPL933R1tbiQFWGm2biJ/503X4jApLS4VlY2o6qsLxV13bQ2s7a5Qs3JZndqLlBrBWrrorQilUUlA1WFFer/Qx8Iut4H/QAgLtJ7oajommGmp3XOd/o1BIpuxRs00a9N5hXU0b2efz7JmW3IM4TfENLzELYg3A+RGvIhlvIhloQgcnAUcuEWuqXkj0JoOR3UTykmQByM9AiTIM7Qo5gKrZ94nwytbydkQZrmzqnQ+pLGPMgQh3mQprk8yCriIA9C4uKbQOHtIP92/5ETgjTNgdAroqReWsyCBprrpA62QeionaQOf5MIrYcvBanQMCpaXNAxSOE9RYtQaIhQWgiKVgYyfzD69fsh1HYDMsvx2CSPx+D4dmwO7P7lwG6Hb0mdGQ5uZSgcDez6OjqHYODz4feBjia2ZBFb+0gtosRWY5LLuksS68MvTiLueLZWWjEAAAAASUVORK5CYII="

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMOFtdqdxOFUl8tsptKpy+X////a6fTz+Pt4rdbC2uzO4fCRvN220ulgns7n8PhHj8eJTumeAAAACHRSTlMAYL//ACDP71kzCuAAAAIFSURBVHgB7MxBAcAwCAPAQAL173irBvLogxNwuCI5kKEfpGoOdd2oDsdOCWoatBC0CCQtEjTZaKONNnoq+toxg2VLQRiILtiI2Cgg8v9/Og/oinFealaupuyNegknsU2qbrH4xSmt3od+CaJVfpwK3q+85e4B2gBExdkBHO6A0sEfuRXATpJLAPIEoWsTkMdYylDKBSpbh+JkWnQJiOk0CL9B4Iuha5fqNEjXaoH83Dxd2jBU74dLgxANUPZDC4PKCLgIHw/DgSQgsUmBGExl8WXViZlAQNomG+RlbwHVvah8SwEpm2zQIW4nUIvyWoEkow1qdJs3dGZ6nTUoi00adOWus3+tSDOOO5rWwWtQyLTpAVJ2nHR7XJfEYNapQW2nTRbI043Itl7LxFZWpkFs2GiCFpmFOoPG0yX0B2gSsBmg2NiHCGPV07K60dgniHMaFegMQzLmKBPAz1UyrfoLNG2C+fnZiJmjxVeUxtQgrtogWZRJYdKJ1SDJaoN+jdIpWAvk0j9AGRRnhiomqF0axM7OqXJ2ZDTUqFQLRCcE9PAhSFPp4ndng1yxQNA1NB2IdIN2KfDOlMQRlTYxxxSbZblBC62nWgb26uqlODO6xc5p0g/7bGsBuTVUp1VDc7bCI7KFsP63fyI+0Af6QB/otUOW14593jqIeu1o7M3Duh+9cXz4B0mjbRDhwU8hAAAAAElFTkSuQmCC"

/***/ }),
/* 581 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMP///+dxOGFtdrO4fBHj8dgns5sptK20unn8PiRvN1Ul8va6fTC2uzz+Pupy+V4rdaw/696AAAAB3RSTlMAYL8AIM/vi50ITwAAAgZJREFUeF7t2Nlu7CAMBuBZ64U1+/u/6ZnoJG4AU7UablrlvyTSF2Mgirisud7gjdyu91cu9/vjCW/m+Vihxwe8nY/HC3pCgzzvlys0yfVyawPdLtAofxo6oRPqO+psAfRE1KeAo9EMaIyhxSqQmxBx4szx6ygeRi1FPGTgAhpwzeRSKP4fFaebMEvkDNpfkVTbb6N+K8egktFqEIZkZglkB1RjVAhZg8RRwyo0uQpksJZRhXCwKtQJMM0r7HiUuekQBg2ysl6zvKjfiuwqELICUfFQtsNga9DkSihKP5JYJtaWX9qUQ8v+Dgt6dAhDDs17g+BnEHIGDRvkvguRtCmFNieCxHW0ZXEK5EnadIT6ZMcUx26wJSQbOByhXaQdoqynCiQ7j2uQdl4UCJy06QeQUyDoZOZ1KGSQ1yAYNykIZItmD9+oCGzcpXz5J5AwrTH1Hq1xReGmsiHHryHocohkndNEmbIOwZhBUmOfOLIIFUjaVH5GTALJjKsQuCmFGJXJBTmCdQg4haQkHPvsS4vIGiQJKeRREth7340yEEGFsj0n/Iy1+CokbUr4seIwVCAJp5DVpRmqkCRk/FyvRyCTnKW0TVFkP2SMcZBBfVwdD5lk8p+m5Ti/4LV/SE+LhSKuGLWegjFmJv+7f49P6IROqNklS7Nrn1YXUc2uxlpe1r3S4vrwH4BLmtow18NFAAAAAElFTkSuQmCC"

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNgns6dxOHO4fC20umFtdpHj8eRvN1sptL////z+PtUl8vn8Ph4rdbC2uza6fSpy+XXWFdNAAAAB3RSTlMAYL8AIM/vi50ITwAAAetJREFUeF7t2Nmu4jAMBuCyHWffur3/mw7VUBvbIDEiN6PT/zJBX2tMEpRhy+kMX+R8utwzXC7XG3yZ23WDrj/wdX6ud+gGHXK7DCfoktNw7gOdB+iU3wEd0AEZO7ulOOdDE0Cz1vKxmHBEQNGOheLCsxPKlulZXraRoCFItfAshqC/cyM5cSlbapRQdEUn7U5+2IY5WzJBNKHjBZTJkZB2tKQhdGRprrxLeAV5nJ6AQQmB0WaAmH3FRzYNkROAQRH7tca9ufiOs4C0Q5AVE/yxhkPaIaiyHsnGeA4F6RA0iQ6IllcGaYeg9QFZ4HHYGYKYI6G9hsYYKmIliPVLQXvnQaQ9IEcQcyRksM8yFZ+QtaOhLL4i/SUpKEEnaO4FFd8J0tLAmiND7dTt99+1PweSJEQVGAElrJkgSErSS2QV0PJiiTwv/iQhw/YwDK7lz7eR8dXPI+6j/vONLbCy5XHQGERTequlVyrzXl1eCBeQlgjKBeNDzjm58n7z1xJBsP7bcQSNThnDoLcH2wovITAoOQ7F+cMjW0sIva+uBhBQA5I0RI3icU1ulgvb0mVplGkmpXosAysZDf943ey2QywxW++cW20GkTjZSY0Fm//Pv8cHdEAH1O2Spdu1T6+LqG5XYz0v6+7pcX34B4oGuxPLovzxAAAAAElFTkSuQmCC"

/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTqfIr0vsX98vP////52Nzysbnob37fO1DsiZb75ej3y9DwpK3jVWfmYnPul6LhSFvQ+V3VAAAACHRSTlMAYL//ACDP71kzCuAAAAI4SURBVHgBrMGBAcBQBESx4x7237i/M5DoF+mFDB5BtZe6QNR4bQrRPtAofCKUPpHyka8dc1mTFYSB8BYJF7mF93/TI9Oh2jB8s3J3rNVY2D+mCKMfL+gF/e+gF2QOS5ecD2o4nh8/HSYuA5mGcql3UEgEpfa929NXlm8otgTlDpAnpUkKVvupzgmy8m0UEJOWl2phQOYzklf7A6q0A4GjFMbIubrnB3Rs5/3iU84OVYw8LC3qP6AoVyPLVixRUY/v+7jqM8Z83STMa74Y/OePAWqoR6QKMzCwEqxHRACd01F5MoyZzDFBbQ8i1+92l3junvRaFJCPexBZX1VlePzVExAlxtwIG6y5ESRbNancWAJBqQSA8KPJ6t+InI7Bybol1e4cJyhaUmKAsuLArKRkw9xr1f3qbKlCgyScq5PsbosMmbQ8U5KlVvJYycga1QR0Kfgby8Y/SxuK5rix8gBB9USJJn+AGmQXeiuYvAtIhOK9xFHvg1U1u2p3MhqEDZnbJu2y2xo86QKCZs12/teAuljrzHtQWHami+hr91dLnANkEjl5F3Q3J+gWe1mN0HVdLOWzq1DbBZob3TN7SwiZ0Z6hteDRYti8rjAf4tqx/Ey/lNE1q9x+gPcgWxGKkkSWtzZK01tnQ0L0ZjvxCNtquy1LArFuKODxpo2c9IsZ6sVioPSv7WFTMuojojf+EZ4Gqufwz7rageG/X2wv6AW9oCf02CHLY8c+Tx1EPXY09uRh3aUnjg//AXEobpAsUCNYAAAAAElFTkSuQmCC"

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMOdxOH///9Ul8upy+VsptKFtdrz+Ptgns7n8PhHj8fa6fTC2uzO4fC20umRvN14rdawzA2XAAAAB3RSTlMAYL8AIM/vi50ITwAAAZVJREFUeF7t2MluwyAQgGFvycyw4y3v/6a1OyIY1MRVQFUP/k8ZhXzyAdsRzV7bQUFd2281fT/coLDbsEPDHYq7Dxt0gwrd+qaFKrVNVwfqGqjUn0IXdEEXJJTKAa/UGaAQVQpJIhpF4mhDZOw+PBw9c5P2cQltySOkaG86OoJ/x5+SDAbI0J44QMhLAhJtsvxl2uwZ4kn9ClIMZY2+EkSyAJr3KCQ+h2DPI3FLAcStPLliCAyP5dDMo/o/kOPRl0IPngwUQsrwNH0O4ZYciSNV6RaZoQ5kRB3IWPg9hK+hycMJZCEmGRI55Ja4KiyJkGYIIeYYOlzbdx4OyfyZDYIhE5et7MwRevEW0XCEYGRpCY41DK3vIC6FNHGT4NGESzyBrM0gcBQoRPkcEN5C1hE5m0KKfmiE95Djq04g0D84/g0U9+waoFTKnXMIMwjsmDjSJ0+gOVPiprEBiuknZRYBz5Zwe+VJ3jIRigmNOCEqSLJaefgpJRd9/Ye8oAu6oEpVO2SpduxT6yCq2tFYzcO6rRrHh1+qtZm4F1W5+gAAAABJRU5ErkJggg=="

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAUVBMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz1lxv3rEn1nir6zpX848L83LP71aT2pTr6yIb////96tH4umf3s1j++PD+8eH5wXZCCVdcAAAAC3RSTlMAYL//EABA31DvgOiRhN4AAAJrSURBVHgB7ZjbluIgEEWjiFG5mVBckv//0Gk7PeaQAnutMW/jfuo2uimKw0LpHhyO4g2Oh5OUspPy3Is36c8P0UXswEV2p6vYgeupu4lduHW92IW+EzvxEf03IqW1VjWRsc7dtahhBucGfDR6RwthiKYUpUwPouCMm0faUcFdg0jl5cVs+BwmWtDLv3di2FU042slsXg0TlRheIo8/ZCZKNAPbp0mY2QiSttOr71Yp8mY/4oSvr3A45st/SYS61BKIPgAqmtNDQeOAtHY0IFWsnMuY/sWEQwWBDJg8/KqWYYb7XfBQUGy13hglNTzs5MQI0wFUu5TsUUii1f5qscVGV5tWhh7xWGdHq1tkS2jxEMEovBKZFjh25x62BOqLRKOR2kqpptw9a1piiKLki4XwFBBsJqLynYHFiIDBQJ5SEzEPwdmt62ZzxFEEDjbmGugGlZtRCJgbyHsmQe9II+lCErQ2FvIugpUJZYilTFKc3X3+XpRI4qg3VnBGgWBKD8RZ0IRtjsWf29IlrsiiqAKV1THGWfHSwIR9AX7VUXFQIApRGrdANjHFho6n1CE6eat5uA550uRrnaxjW2J+MZU4hW+KZr5sf5vFRkq0Q0D23xxIxL3TTwAZTORm011bcatKLFDnZ0pYTbsK1fm3yGnVqsjO7EBy0W+1WpLLzBcZFqtdtTGCxDxdk+tUnn8a6KE4wCm7VEgAjJOHIivPVzkW6lO+fdTpCDgQIiaA20Y2LmGzM45Dx7AxOGZoHyfzZs/aoz+4vPDD/mIjntdshz2uvaR/U4XUfK809WYlJfrPpd1Up5u/XvXh/KLPwmIq11J3xiHAAAAAElFTkSuQmCC"

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMP///9Hj8edxOHa6fQ7iMPz+Pu20ulgns6Ftdrn8PjC2ux4rdZUl8uRvN2py+XO4fBsptJY3aOgAAAAB3RSTlMAYL8AIM/vi50ITwAAAZpJREFUeF7t2NeSgzAMBVDTVu6F+v9/ukmWsQME96ed3HfOREZyBqFnmpYVpG26R1DX9QMrzNA/of6HFeenf0ADq5ChQw2rkga1daAWsUr5l9AXwoQCcCFLIcnhL6QIcg7AXARRcJkKIAVvEQUQhffgbGiCQ1Q2RI7Qmg1pOGbKhDY4Zc6ExA5ws0M0D8J8h8wMe2QO5JpI2be3ZEHG9o/tJ50BuSYyjNnaxnTIPazeUJEBaVeZmxWeDklb2aHHVTK02EePbDLEbWWnQhOh8fQTltCYoFATqdOR0TQIX24zHbgCUKCJzOXwSRJEbWWXO0WnQJOr7PoaZQK0fDha4R8T5B8PsdnY5ubx0AjejNGQ8EMmFsIc/MGRkIJAVCS0hqA1DpogmCkKmsPQHAXpMKRjIGmBlZwirCQjIHHfeNhCSwTEPaNg7mtD9+MhfB22BSHiGylXG0mAvBceiS9N+P/HgxCjvosQ703GcRjCr1Hjin2MfElaRg2tJERhdpeRkPH74XfMF6q2ZKm29qm1iKq2Gqu5rHukxvrwF1Ts0r64XjMIAAAAAElFTkSuQmCC"

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMP///9Hj8fa6fRsptJUl8u20ul4rdbz+PuFtdrO4fBgns6dxOHn8PiRvN2py+XC2uzMotXGAAAAB3RSTlMAYL8AIM/vi50ITwAAATRJREFUeF7t2NlugzAQhlHWzIx3liTv/6YNqorVykg18+cm4rvk4sgCbMQ0W21Hirq2f9X0/TCSsnHYoOFG6m7DCxoJ0Ng3LUFqmw4DdQ2B+ijogmb7u5OQXflv5i71kOViSzVkuJyRSoi5VipDMx82VUGWj0soyKAgdqcgb7eC51w6BS0/dMyXVBAtKEhQEOFXFHRQ2iFRQbIfK540UNid6M5B67TFuYTZtDEQBPKOMBBPSQnl1qCEch4FsUdBnM6+R1uc4yia3R/WLN01EInZIaOCyPGeqCDKS7I6aHoDhLpHswp6ZogUkHjWPH5vv0uPyLlHPVRuBkETYaDo/g25+lOkDFGlcww9ufqDVIZcPGAWoSqInC88LB/e/Hd0QRcEG7LAxj6oQRRsNIYc1r1CjA+/ACwklb7aor+1AAAAAElFTkSuQmCC"

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTqblzhQ0zwjmf9zn/ymWv/2YPfOUj0pG/seWD5uXfoY1j3rnPjTlDuhGT7xHvmWVQ7eJ3dAAAACHRSTlMAYL//ACDP71kzCuAAAAD6SURBVHgB7ZdBj4MgEEaRUQvCNxbXtv//ny6NGxIOHnDmYDa8E4nJ4zAvmDGdzv9lsCTADmPGjOM0k5B5+oqmB4l5TFk0kwLzaAZSYTCWTnCOGrDm5INfQlh8g+lMRBGIpCFyITgVkWf2clHhqohZSeSckmhdr7ZUixjgiy3VoifwvNhSLUpAam6pFm0/mYRM+p629pZMuRyF4CRT2xP+SLts/BwPT2RpR+4QOXFH6yFaxR0BeL0ASDva8P4Qfd7YJB1l4sKU4SVWb1K7yJeDdGqFG4kkj1z/r91m/F3URV1kSQWrt0KoLTV6a5ba4pdRWkXl3E7URV30C5/PPnfCCL8fAAAAAElFTkSuQmCC"

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMP///9Hj8edxOHa6fRsptJ4rdbO4fDz+PuFtdrC2uzn8Pi20umpy+VUl8uRvN1gns6WWOOUAAAAB3RSTlMAYL8AIM/vi50ITwAAAV5JREFUeF7t2AmKgzAUgGHXviW7W+9/07EUUsuoJObBwOB/gA81JpBXvaobKKip27WqbbseCuu7F9Q9oLhHt0I9CNS3VQ0i1VUjAzUVCPU/oRvSbBW+UpYNXYWeo8OvrL8CPS3+btDZEON+Pg8ihUfpHOjp8LCwC+U7OKRDpPAklw6FCJS9msFtw2T0Gofsj03D/n9DXiGiS19+3jgjwbZZa4JkyG2ckk3rMWahBAoYm4sgjE1QAmmMzUUQR0dBERQixGWQjZAugzBGUtARcEMuQiS2/FI/5AJCW8TC327amBM6RmCUOtg0xlQRBIPQ4Q8ePwXaAvM4oDXJEKiN5HykjH3jPhnSuM0FNtpwcNGmVAgYT1uSIbCnEKdDpAqeKF2aMyCg8dCZMq8Qxu07I2RCQLxDDf7KFYIW9c0Ef/lSM3u276ZF3xe/3W5IbMgiNvaRGkSJjcYkh3VrEuPDHzNSlCTWVSABAAAAAElFTkSuQmCC"

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAMFBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzPdLkT/zE3/zE3/zE3/zE3/zE3/zE3/zE3ForIZAAAAEHRSTlMAYL//ACDP7///v2AAzyDvDH7t8gAAAHpJREFUSMdjYiACMI0qoqoiIWO8QNHFhcklTBG/MUKKDEyMsoQsuyTAxHiAkKI/AkxnCbv7LJMAYUWMxCkaTQVUVBRKBBgNp1FFQ1mRIBFgNJyoqYh6hb0IYUWOTIwJhNSwCTD9+0JIkf0DJob7hGrOd8TUwaOpgKqKANEYJ0HguWYxAAAAAElFTkSuQmCC"

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAA7iMM7iMM7iMM7iMM7iMP///9Hj8c7iMPO4fBsptKdxOHn8PiFtdrC2uzz+Pt4rdba6fS20umRvN2py+Vgns5Ul8vj7ABlAAAABnRSTlMAIM+/YO8aA/umAAABLklEQVR4Xu3Y24rCQAzH4bGtSebck77/oy4qNN1FF8b86YX4uxU+SmzLNO7W0IuhfnCPTp0Y60535yzmzjepE0Cdc4NAGlyPgXonoD4H+kIc9r0NXQv9KZV4aYe40rPSem2EZnrVzE1QopfV3ALRf80oiDyDICooiNZmaAn3xlgq7QutUFB89KQlAySykJYtkGSFkgnaX1MwQaJzmm1Q0HHbIJk26WKDdErZBl02aLVB+pM3QhMI0hugoiD6NEiHnWB/P+qGLKhHJKIe2gB6jRCboGk3IgsUaSuDXv5V3od4JS2+DfGSSEvcCM3xUZnoV+Mhh4jjjzWFMdCKOYymURqg+IqpkaUF4ukp4zM3f4ssnvZVX+LIB3wdfaEvBFuywNY+qEUUbDWGW9bB1oc/QvCbuuT1rjsAAAAASUVORK5CYII="

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAUVBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkT/zE3/xEf/uD3/sDb/rDP/yErvbl/3jUn8ojrqWW5mdX/3oVn8vlHyhGLtZ2qZqrX0orLrYGz7tlMsubDZAAAACHRSTlMAYL//ACDP71kzCuAAAADKSURBVHgB7dc5coAwDIVh74glrDbE3P+gMSYJ1JYywxD9pYpv3MET743jpNKIlDQpYYx1GpmzB2Qrja6yCXKaIGeE1CRJoWggJTRRDP1vCIj6S6hu2i7XNjUG+uhuoV7UD+OpjEOPgqZbxdA8AyyXs5yXQgh8WA9lDR6KoW0D0LnP3Hlh6PnQdOtlULyciILCBQUU5OPvg3whNOdgj9/O/nMphMCHmJjgoQBCRAzxt58hiuh+2MkmBNmooZtZZMMvRTRF8T0OYoihL2HoZC7Y5d+GAAAAAElFTkSuQmCC"

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNsptL////z+PudxOHC2uxHj8e20umRvN1gns7O4fDn8PhUl8upy+Xa6fSFtdpriMdtAAAAB3RSTlMAYL8AIM/vi50ITwAAAN1JREFUeF7t2EmuwyAURFHAdoreffa/1O9MrC8FZIFrYEXcBZzZQ6jEJ6lwIyW7I9F1/YCbDf0H6l+43as/oAGEhk5IUJJCgZISIPVrUIOC/qoGCpv5zrpyyJtkYyk0mXS2FHIm01QIzTlIsyCQoI0EeVRDi/vXhHpoxnUNuqpBdj7z41oDpbJvEmRsIEFmZEHucdBEgiIokHWoh3Z9tj7iRBrUXsizTYN3/Y/7aEUWNBdCWw7yhZDOQe9CCDHt7CiF4JaEE0MWItSgBrFGFtrswxqiaNMYc6w7YsyHf8/slrzxBmhZAAAAAElFTkSuQmCC"

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAALVBMVEUAAAAiZpkiZpkiZpnu7u7dLkTdLkTdLkTdLkQiZpkiZpndLkTdLkQiZpndLkT8PXBnAAAAD3RSTlMAYL////+/YAAgz88g7+8ykxn6AAAAaElEQVR4AWOgPxgFQsYw4IIEQmEgvaODoWOWMX5FoXs6GDovE1IUd4Khy5iQotAdDMKEFYUzKBNWFMZgTFhR6KBVNKpoVNGoolFFo4qIKuyJqjaIqoCIqsqIqxQ7OoipXgkCqioaVQQA6T+4O1FrCqUAAAAASUVORK5CYII="

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNsptJUl8tHj8f////O4fBgns7z+Pu20umdxOHn8Ph4rdapy+WRvN3C2uza6fR8HTjuAAAAB3RSTlMAYL8AIM/vi50ITwAAAM1JREFUeF7t2GkKwjAUhdGMfZk7OOx/qbYICrWCSa4g8r4FHPIrJFdsSUUdKanXhNbGUmfWbJAZqLvBrJAlQFYLSZCkUBhICQL1fxBDbp9vgcIYX0u5GgrXeFQJtdAUj5tqofkNlGqh+G3oBIKKx0Bzpmbo7J6tTDvkaFcDxBBD4/QoN0P7UgBBMaGg6FGQ+zVoJhDkIFC58MXGEEMMNTxGfSc0Pu7ETsiXO7T0QpTTdp4F8anxLvPHj6FPgo0ssNkHNUTBpjHkWLeGmA9v30+Xt4CKd7IAAAAASUVORK5CYII="

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAk1BMVEUAAADdLkTd4+fhXm/u7u7u7u7u7u7dLkTdLkTgVGbdLkTePVHdLkTu7u7ePlLu7u7ke4jh5undLkQvb57mjpnt4uPV3ePqvsSiu87u7u7I1d7eOk/opq5vmbm7zNns1tnhXm9ViK4iZpmVs8nkgo6uxNPjdoR7or7nmqQ8d6TpsrnfRlngUmRikbTiannrys6IqsQdYqZMAAAAEXRSTlMAYL+/ACDPIO/vAM/PYL+/76WwZIwAAAH2SURBVHja7ZfZcoJAEEVbozESl7DKiMriihjl/78uLK0tziJU+ZCyuE9Oj3XEO6N9G1q1el+NpyzXPIzulZeMO+Xr6FGmy7rjXibo9fqf7Kpt3BCU6nn1s5+DBl+WzW5KzQag0GGFZsOBBtq3YXgLIunLuqB4xQr5gWGMNOgYuYIZoVZhHZC5ZoXsTbHZgQ98284nlBs/Be11VujglZsTYMekfOlZRNJTUwkK52jOCfc2NmRLC6nJkVDOrxwUb9GcM+4EPmNQVHbXyuXOKgnITNEcC+tJ4S/gMwZXq+gqiEFLNGfhoSOHcg38hgoUrmQfDKJHlYBQYitAbJ4KZAsPB2THKQXRdbHvrwtILpi3EIMugeQCg+DKlzqJQGiO4CcFTCoOpNQ7g4wXqQW1oBakVPt/VAMUZcL++dBDRaBZggvLfkh4GSh2xT2UB/H9ihIeYJ7keqj0q9nUkirtyLlh+MjFg7gmSQ1SuK0A8W0bW7b8gRUgPuU5ILdQBeKPBeSHqgpafNiCjH0tnP3KIKGKfnzKA0ofM1YdbZRhlEt5MKlGR30foZ7F42rKm0CnktDWNNPUCeyU8jqgjSgzrmLC1Bwh8MhHGmiDIZrjhASpOdSg7J98zNLKwU9PI1SzMYsGv0zjLnPJnKaD3xRH0ReoBbWgfwf6A7vjWoIuXZxnAAAAAElFTkSuQmCC"

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMNHj8c7iMP////z+PvO4fC20ulUl8upy+V4rdZsptLa6fSdxOGFtdrn8PjC2uxgns6RvN1KMlThAAAAB3RSTlMAYL8AIM/vi50ITwAAAatJREFUeF7t2FeugzAQQFFSZ8a9ANn/Tl9QPhw0Ri746yl3ASdxlfC0dbniia6X27vpdrs/8GSP+wbdn3i65/0NPXBAj9t0wSFdpusY6DrhoP4h9INcWDxtCaleay+kjaBdQtkOSCvKNMdWKAjK59cWCCQdF+sh8ESN0tThkNCVkKdCpg4ytM9LKfaQrILcbhRm/ejOiHqID0xBdkeEGigeL4+WLZM9cydl582xWAGtyVkw0+pc3c5WaZ6h6xrhIzPYBfGR6S6Ir5nHU1A4GNnqvoMylK4P+81I2qegHnLJAX7J+RKUzgemXsSLBYhy0EK8pQeSxPPVQ4PdUvJ6JlsL4nUtv+WS7NuQEMOnasgWjkj1qml+aPP3eai/RhSm+NZ0Jciwv5T/GShBmi9MKrIp4hDfAHwe1rQLYhlyxCTuCChC+5Ml0zxB4L9wDPEDscTNAqsEpQTUQBiplMUqCFXBUZiD2iWPWahZ8tAAoTl0FGALhG7OMuLV/AkBQXBH6Z5PCIh+p8xBd3/UgA3yk4mHyu8L8gcNe2QZ9uwz6iFq2NPYyMe6dyOeD/8AvAuqMX+h73QAAAAASUVORK5CYII="

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAJ1BMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8edxOHz+Pv////a6fSPHyASAAAACHRSTlMAYL//ACDP71kzCuAAAACeSURBVHgB7ZbBDcFhDEc7AxOICXgH/4NjmUBMwAS2YQIxAT1aTJxommgdOPXdXvKOX/r9RGTERyaqolsS9iqrAwmLjaxJ2cmYlJlMSZkLBV5RR8PRzkBQFy3N7A5BXXQysysEddHFzG4Q9S0a7AlE/TbCR3T0hyjS0a+ifnQd1Q9reqLrxx7/bTgVCnREbdCUplFpZJXmWmn4qeYT8gFmWx1wb/cQcQAAAABJRU5ErkJggg=="

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAALVBMVEUAAABckTtckTtckTvu7u7dLkTdLkTdLkTdLkRckTtckTvdLkTdLkRckTvdLkQr1T3fAAAAD3RSTlMAYL////+/YAAgz88g7+8ykxn6AAAAaElEQVR4AWOgPxgFQsYw4IIEQmEgvaODoWOWMX5FoXs6GDovE1IUd4Khy5iQotAdDMKEFYUzKBNWFMZgTFhR6KBVNKpoVNGoolFFo4qIKuyJqjaIqoCIqsqIqxQ7OoipXgkCqioaVQQA6T+4O1FrCqUAAAAASUVORK5CYII="

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAP1BMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNUl8uRvN3z+PuFtdrC2uz///+py+XO4fBHj8dgns7n8Ph4rdadxOFw3Vb8AAAAB3RSTlMAYL8AIM/vi50ITwAAAJdJREFUeF7t2DkSAyEQQ9FmmwZmX+5/VkPZpE5aiV36B3i5JD3n1ZB3oSUhxKTGUuxQnNTcFBuUFFAK4hSSE4+BvCio/4QI5bIsJduhua6tOluhvH7KRmgb0GaE9gHtvwoRIkSIECFChAgRIlQGVIzQUd9OPYyQnld3rhOwju7nuTn8vkYIdrLAbh/UEQW7xpBnXQtxH74A/VKXu0dbwSgAAAAASUVORK5CYII="

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAADu7u7u7u7u7u7u7u7u7u7u7u7u7u7t4uPnmqTianneOk/dLkTjdoTpsrnkgo7s1tkFgF/yAAAACHRSTlMAYL//ACDP71kzCuAAAADNSURBVHgB7ddNDgIhDIZh/qfQwnj/04o7jYNJh29BDM8B3hiVQs32vzbr/ARnQ2dCiMlPSvEVioefdsQeSh4gBWM9hDXOQzjjQXZonRDlwtJxyTQRoipvKt0NNZYP3O6FTvlyqkLjTi/pQ00uNW2IWC4xKUNVBqouRDJEqlCWoawKFRkqqhDLEKtC8gMs9FjuE+G/bPzPj/9D4o8I/tDixsh4sOFHLX74468j/AWJv7L3+2jtEO7BDlshYEsNbs2CLX4dZhUF2aEdWir0BGyxTm5iaypEAAAAAElFTkSuQmCC"

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMOpy+XO4fCFtdpHj8f////a6fRUl8tgns7z+Pt4rdZsptKRvN220unn8PidxOEu33L8AAAAB3RSTlMAYL8AIM/vi50ITwAAANNJREFUeF7t2MkOwjAMRdGkU+ah4/9/Kk0LBUGElNhigXz3OWvnsRRvBKCGt3usbbteAOu7BHWDADd0O9QLhPqWcYESZw0O1DCB1D9DBI1SSQ2HjLIpZ6CQtGcLFIr2nodBk300/QoiiCCCCCKIIIIImp6PZgAU1nRX+RNyFxRKIRPtkRqN8Iu9EqXQbLOpYmjLQzMWZIohnXW2ijt7zTjOVEAhfjgxVF3+wb05ztf+RfQrtWrIp8ZrqY62QB+/bxGENrKgzT5YQxTaNIY51u1hzIc3U5SaUdPCyaUAAAAASUVORK5CYII="

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAolBMVEX///8AAADu7u7u7u7u7u7u7u7u7u7u7u7GDDApLzPi4uLV1tfJyssANHhOU1ZZeqTLKEjVYXdjIFQ1Oz9zd3mkpqi9vr8eS4ewsrRCR0rip7OktMns4OLf4ueYmpyIGUc+KGKzwNFohazYb4N/g4WMj5Hktr9aX2IlLWu6DzUyKmZXI1mmMFVKJV2hFD6tETkMMnQZL2+VFkJDRHl8G0tvHlAs6WCxAAAAB3RSTlMAAL8gz2DvqHqfkAAAAipJREFUeF7tl8eS6yAQRfHIHpJydo4TXs7//2sPPB4Z1GCsMqsp340Wog5wabob9DF1110jockDvkEPE8kQoGCMb9Q4kKDgEd+sx0CAxtiDxiM00QGH8DpAeNBJE6T7vKIFv4bDC7rSHUcap6X0BTM3h+EXSluNpIHCgsaMxaWLU8pRtAhtIFaIn3Ku+jKnlusOxWBmBrFYIkoqdt9esDxshZO0FLjYDJKICldyTNhbdm/74dvQmrGVCfQkENLtGHNl1UBy/xzH0mvh0xMEVaeNT4GPQvBEpic7Kx0Ef6taLDqKfUoEFlxSZcF4lqVEKM1mWDEhZsAEpFrYuf2u55R0Sp/P8c9Y3T8WBA5VOdU90bRXIgUECgJhNu04GekpuxC6yB74ewK0B5fJfEWObnf+EIM6n45eg8g2JoevJlBqTTjIlq7mxKiZlgIhCCoxgzIM5AA1GuB7/nmT/5B7GwyK1mfMp0101BdBGgpaRpsz5zU66Rshi8Gg6O87KI86rQeDsJj/3xtn/fMM2pDhZgvSr3z9O3+NVA03O4mMAsfvDkgzCASk+4o0Js4f5xWB9XNrAm1hTXankR3k7BxpBNRPi9+JObG5U+0OcMyp1p38t4rjzdaR/PVyxHvlaJ4cWU0y75UjDsqR5l6FMSyQyyUokPKjnw2y/oayTwmbCH59E8FBE+GhrfHQaHlr/fw3o97aY28Nu7cnhK9Hjbdnlr+Hn7+n6IfUXXf9B2OghqgBivtNAAAAAElFTkSuQmCC"

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8eRvN220un////z+PtUl8udxOF4rdba6fRgns7n8Pipy+XC2uzO4fBsptKFtdqrUO3uAAAAB3RSTlMAYL8AIM/vi50ITwAAAURJREFUeF7t2MluhDAQRVHGLo/Mw///aUAoLZyXhfNsZdHiLlkcGSGhchVnZSUJVWV9VNR100pibXNCzUuSezUH1EqG2rooJUtlUeWBqkIy9UHQA/XzOvcIKL0YreIhtdqzQUnYONkjN0ZDs70yPxx3PXY+ElL2O4XOWRcJbW9ou/PT219TIDXYRAgdqykInUF4aLk5buQhAw4BocNB6NBQBw4H7eAwEDgsBA4LbeBwkHbgcBCeh4fQ4SF0eGhH4P9PhFKmr+ZToOC/qBKgHiQS2hRIJCQgsZB4BxIHyRhICVAomQRIRgsSB8kOEgOhREMo8ZAYkAgIpZ2EUPIJkAzwciSkbtLEQShN3HiMg+3yt4F9lisctbc4SEzgwOXC7RIJided9vJbfdf16rn4hT1QtiVLtrVPrkVUttVYzmXdUY714RdfzqHyqZRR7QAAAABJRU5ErkJggg=="

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMOFtdqdxOH///9Hj8dgns7n8PjO4fCpy+V4rdaRvN1Ul8vC2uy20una6fTz+PuTVMC9AAAAB3RSTlMAYL8AIM/vi50ITwAAAKlJREFUeF7t2EcOwkAUg+GpeVPSKfc/KhMEQhGwiJ7ZIP8H+Pa22bJOFDnrW8b7EEVZDBsUOlHXhQZFARS9sQLJGoeBnBFQ/wYRquk85l4P9UPZmtRQc+4lJTSXRxcllMszQvsIESJEiBAhQoTGV6dlVUC7rj0GalIFQSWhoHwQSiiofoPWg5Asn53p+BaZh3dmWH64jggRgp0ssNsHdUTBrjHkWddC3Ic3OL2T/X1XdBEAAAAASUVORK5CYII="

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8eFtdqpy+XO4fCdxOHz+Pv////n8Ph4rdZUl8tgns620una6fRsptLC2uyRvN2UcJfmAAAACHRSTlMAYL//ACDP71kzCuAAAAIkSURBVHgB7MxRFcBADAIwKJTz73g7De3X3iIguFgaKPoFu6Oh9I36aOy04WhBDGoFUVpR0JKvRH/0tGMGa5KCMBDmSDQIIur7v+n27H69pqAQDx6H21jpGswfIuBlmlV4/EeaxD8zkrD8jJhaKcW/UpAnRrJ8hzyUuNG6XGPtS3lotJnobSz1jYqJDigFI5Wh0WLHbpUdpJFRhujJShNIeWCUIDpaKYKUBkYK0ZbbiooOjA4MPy/lROUYGBUMn7v/ogyMlmr4r+Br5d4o1+GCFBAbN+LhGylris0xaKy4Q61obcShxeoNciMcxIhAO6vinhqhECMCbS8Y///PvYPNdaB5NcVtylp9B5vrQLs8TyjrfGU93Ripqehgk3pcEGeODY0Og2SzxW3KauPYHIemptMn88piZl1ujOzK8GwWHvLYNcrQY8uVl2gmsXNsjkODzOcM+eWrzVFoAeanCnMIFJuj0GZYp6XACp4pNkehbbxzVI9L16hqEcK7nFJsjkJLvLv6CknuGKX6C1tov98pNkfbI++XSjNAjI66v2be7gPD5hi0GRo12AP/0jEafDrIU26U23eXFj6kLlOj1NLwNfw+Nseg7WwrUNjUB0ZkCwI/emoUSd4gH/HeSNiONYJ7jU2okY+YIiSQyLY0+s6ijWRXL4EcGuSfT+5/IFVlbY44qs0xZhXVa46/J8hfo9cuWV679nntIuq9q7HXLus+443rwz9DcH/5DQfatAAAAABJRU5ErkJggg=="

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8f///+dxOGRvN3C2uxgns6Ftdrz+Pvn8PhUl8va6fR4rdZsptKpy+XO4fC20ul8XuoFAAAAB3RSTlMAYL8AIM/vi50ITwAAAUlJREFUeF7t2Mlug1AMhWHGHvuODBne/00bkgZQEiSQz6rKv0X6dOWVcTFVVjBUlfWtoq6bFsbaZoKaH5j7aW5QC0JtXZSgVBYVKFUFSP0X6Av1LpzHDUD8Nbh+H+R16tLjQzHrlN8DnfRRJ3hLsj467YCC/hXwVpq/7YCyPvN4zT2hvAPSpbgJ6TGoExKkgQWpZ0EaWVAnJEgDC1LPgjSyoE5IkAYWpN4G5UWKJsgNqzGZIFneFEwQTjrnTRDcIkUThMtqTCZoPSYT9DImA4T1mEwQwmpMJki6WQomCFHnOhMEv0g2CIEFSUeCEFkQEgvClQXJQIIQMwlCYkG4siAZSBBiPgTlTQjj7OQj63HCW+cnFA4s7AM+NBxY2JHy3Yn4kNzflBP2QJDk3IiNeu+SfH/8XvpCrCML7ezDOkTRTmPMY90txvnwF1HImFmFKoCYAAAAAElFTkSuQmCC"

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNUl8uFtdq20unO4fDz+Pv///+py+VHj8fa6fTC2uyRvN3n8Ph4rdZgns5sptKdxOHhp7EqAAAACHRSTlMAYL//ACDP71kzCuAAAAGhSURBVHgBrMwJAQAgCAPAsQf7N1YzwAU4fEUNsPzATmuo86McjZ28qLWgjdKKArWCtx0z2nUQBgHoEl5sC8Naxf//07ss2S4LVlrTp2Xn2ZxYQKTcYBA/0feJphAT0gNM98CXRWGmD3K4JFqQDGXtFm0zHZK4TxSQKuDWI1rohOCLtMc3+aJA5+DWJpqQPsCUCn1QuEmUSJECwwMOiRTZEZmDFYE3ol9LGkTq+ZlBwaq0ki8Khx5jElc06+TU05A90URvdjDs9GayokotIoOBsVqVt2ruIxxwr53NiFCH0yL0Ao2oFiI4pBIkIxJTKdWjy6lo1SE6ItKL9VS02+T7D3y1aHywx6ef2wuSrUhT9Ktb1tZPBPJ5kGLzRxta28jiiHhQY9NnI9NqN939PZG0Nf/VFUFSpgkUk/IU8EVC/2CoTDrSIIJMirLI076U7l82cCEH5CYRbOiIpHXQCkMGLRPY/tFPsRWqgNI3HnOmQzJ3D+ySyJDk0hVCIpICo1y/HW1LTE/iLr+LX52faNiSZdjaZ9giatxqbNiy7sGI9eEfwl9sGboMQvcAAAAASUVORK5CYII="

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMP///9sptJHj8fn8Pi20ul4rdbz+PudxOFUl8vC2uyFtdqpy+XO4fDa6fRgns4c/8m5AAAAB3RSTlMAYL8AIM/vi50ITwAAAQVJREFUeF7t2FuKAyEQhWH7lqry2vf9L3U6gVESJjCxzlPwX8CHLyIec6/rSVHfDVdmGMaJlE3jHRpvpO42XtBEgKbBdASpMz0G6g2B+iqoQVaeq4Tsxq85Hyqghf8qJvshdPKbXPgMSvy2hILYoyBeUVCcQRDvNZA8kuAjl+YKKNvzUaBNA5F1GXIqiIRzVgVROZLooAUFJRTkUdABgmbOnSpoz04kDeQ5t9RDdnVcCqDb7wgEBRDkCQMdVgkVBwJtmHdtFwJAzp9E1VD6TeYnQHPXvgdqUIOiEgr5vdBB5VEVLWQfUlwBnxpJabXt49eg/wUbWWCzD2qIgk1jyLHuCjEf/gBROpOU6pX6hgAAAABJRU5ErkJggg=="

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNUl8uFtdq20unO4fDz+Pv///+py+VHj8fa6fTC2uyRvN3n8Ph4rdZgns5sptKdxOHhp7EqAAAACHRSTlMAYL//ACDP71kzCuAAAAHCSURBVHgBrMGBAcBQBESx4x7237i/M5DoF+mFDB5BtZe6QNR4bQrRPtAofCKUPpHyka8ds9txFYbB4AU3CYmbPxLe/01P1V3JopklTYV0pN3OJY0G/NlFwh/R7xMZuzovd7y72fC2yEY5kOxbouylo2zTohoFcWFOZL0I4+uMKMsJlkWzHjaxyAoA1Y1E5ikf71yRAyW8JHKHLn3NYbCHqwlFJ4WVptdbEaW9INLzEg8lhKi/uLHIggdMbSiKJ82pmBKLjJ7dl45dfzUg4ln00OPgYSpVxL1fF2Dl2kDkKU6l6QOzCCJaEAwJRI0mhUtvp6KNI6KQtlPRzs3HA39UNA77Ngj78vaHnwZy27PRyR8P5FLw0Wv5TqXyjUCU+pBUn0Lm0kFk4TWiF2PhpoEoCBzdpaeySElwFkRlGYkavPybdGQW8aRINE//eQgQRHB7b9mk+aFIU1JKfkywiZTQQBSKjHCBRB3Vy4gIGQFWhvgKIjD5aROLllomTCoCQhonTiKgOeko2YlCIlatvv+EWMcioubVPUh7C08tTTMionkOe56wikgyn0/R/ya6bMly2drnqkXUZauxK5d1d65YH/4DfGdyOb2XCYkAAAAASUVORK5CYII="

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAKlBMVEUAAADu7u7u7u7dLkTu7u7u7u7dLkTdLkTdLkTdLkTu7u7u7u7dLkQ7iMNkA1kjAAAAC3RSTlMAv88gIGC/YM/v7221RzMAAABoSURBVHja7dCJCcAwDEPR3Jfb/ddtYrqBRSlGf4CHUGDMbTWKoVhfpiQxlopCS8wtlQRQQkFSUVBEQUKI0N+gGxIhQoQIEfoCuiARIuQSaiiog6ARdtPuzHygPMx7tqP1Zvq5B8b89gBhjaojiaQoZAAAAABJRU5ErkJggg=="

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMOFtdq20un///9gns7n8PhHj8fa6fSdxOHz+PtsptLO4fCpy+VUl8uRvN3C2ux4rdaoItmmAAAAB3RSTlMAYL8AIM/vi50ITwAAAUdJREFUeF7t2LmOwzAMRVGvofbFW/7/T8dBgAwnsgv5sRr4lipOIUcSwuZV2xFQ1/Z7Td8PI4GNwwsaHgT3GHZoJIHGvmlJpLbpZKCuIaH+FXRDPv/NX4O8NkXTbOuhyRzmVCVkzVlhqYKiOS1ZCOLSIgSZSQoySgqarkDxnXZcWi5AH1ulX0ghEP9tRQgizTYJgrIUtEhBVgpSKFReLTMEKfPpCUALuzIdXYCmd86wVqFDG0gGCh6FuINDkUgASvNCOORiZkA1FPh1hkCWXYwZgSjztxGBSHEJgUhzCYGIbbjzCOQdPyAARDZxCYDoabgEQLQySSMQaS4hkA9G6Mn2bMMTApFlUj2UmK5qIf65t4Kve2kpHN4cW7l6DvGPlNTX6lasFlBRjlGVp8GuB6v3P8gbEhuyiI19pAZRYqMxyWHdnsT48Af0uZ00h8blnAAAAABJRU5ErkJggg=="

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMP///9sptI7iMNgns7O4fCFtdrC2uydxOFHj8fa6fTz+Pvn8Pi20ul4rdapy+WRvN1Ul8tjPAuHAAAAB3RSTlMAYL8AIM/vi50ITwAAAWxJREFUeF7t2Glug0AMgFG21PbsG3D/m5ZUrQgNU8WDf1X5DvAEjDQW7u71A11o6MetbhynG13sNt2h6YMu9zFt0I0Euo1dTyL13SADDR0J9Q+hN6QWG2Ar6dms7ZAJ8FgwbRAm+F3CBsjBWYUNZTgteibkoBLyIAQhKAhBpepEYkEW9nJBRBfaTm1novq213mzQiEWpOqHxINwh+gS5OQhWJhQ/fRnL/ONAGIuzRDBsWiNb4MsPBUW3wAhnJVXNkQznFO+DjHvNeRB9WcCw4UI07mk+OPI6DMoeTZEtC7hWVraRrY3OR6h1D77y9FSbGjPz7BnmNCxZYfcJYiSFKSloCAErdAEYdbaqcrMxNchA1+l+cfyFvZ8Haq/RsoO0WV4yNLL0AJ/VVhzrZ4mIUhxB6TIDal5Th3y4ZyJhT1FXGQOto5qGXu04s6wrxFlnNVfWYfvH796b0hsySK29pFaRImtxiSXdVsS68NPv3Syrwi3G0IAAAAASUVORK5CYII="

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAQlBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMORvN1gns6dxOHn8Pjz+PvO4fD///+20umFtdpUl8tsptJHj8d4rdba6fR2gybFAAAAB3RSTlMAYL8AIM/vi50ITwAAALxJREFUeF7t2EkOwyAMhlHGmDnz/a9aUJRlLFqsLlp/B3gLJCT4RUsqGEhJXRNaGwuDWdMgM8Fwk6mQBYKsFhJIkkLRQEoAUb8EMeS3h/xbkD/LY6fvh/ZUkNLeDbmC5rqhjEP5+9CMQ3M3tOHQ1g3BgjkL9EOwunAVbyCGK7d+dkUycsL/CDHEEEMMMcQQQwy5G3KD0P12T/sgBD42J3qC39ERwsEfPzSGyEYWstmHaogim8Yox7oaxXz4AstLnndbATekAAAAAElFTkSuQmCC"

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAOVBMVEUAAAA7iMM7iMM7iMPdLkTdLkTdLkTdLkQ7iMM7iMPdLkTdLkQ7iMPdLkS73fXu7u7u7u7t3uDu7u7r5B3uAAAAE3RSTlMAYL///79gACDPzyDv7///YL8AGxeMcwAAAJlJREFUeAHt1zEWhCAMhOFoRqOwLrj3P+ziBZgmhS8vX0P3N0wTSSmuZdUpTG27DWJ2nEqAKPUJHR9lwFx1hE6lQBWTRVW/g07exnVZfUK3qE+o+YZmkQfABQ6979dyR7mjsCEO4CKHmpPIITiJHMod5Y5i7uhuLm7pzUWXX4GDYmL1wkDxM8tqATh++A37Boqfog5eF8pQhv4LVI88awnBxQAAAABJRU5ErkJggg=="

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMP///+dxOFUl8vn8PhHj8epy+W20unz+PvO4fBgns7C2uyFtdpsptLa6fR4rdaRvN2UiNFXAAAAB3RSTlMAYL8AIM/vi50ITwAAASNJREFUeF7t2MluhDAMgGHWsZ2Vfd7/TTsZtQGJehKKT1X+q6UPcrSrUN3AjZq6fVW1bdfDzfouQN0DbvfoXlAPAvVtVYNIddXIQE0FQv0TqECKpolUBJhpGiJ8RxDipnMa2vC7LQD8NAnpH0gHgJ2uSQhjAcifFqhAxwpUoAIVyJwdkw8pjC1naLnyNHnoeYboAqQjNACkhzw0YWz88DKbhGZkv2o0xrYkZHDPsT/rIQmBYyQz4B5lQAoP6fiE2eOeNxkQWDymHS0LOY/HCHIgs2KiAbIgGP1nxxsGuij5ERiIkXgnH4Jx5ZzBwBUIjP2V8XR9F1Hu7DgFPMSnrD4qmtTft6PxaYd3duaVskEWSOzIInb2kTpEiZ3GJI91ryTOh198BZOrvLGVqwAAAABJRU5ErkJggg=="

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8eFtdq20umRvN3n8Ph4rdadxOH////C2uypy+Vgns5sptLz+Pva6fRUl8vO4fCJNfQ2AAAAB3RSTlMAYL8AIM/vi50ITwAAAaFJREFUeF7t2NeuwjAQBNBUxjW18P9/egOC2GQRi8vTFfMGFkfeiRUJF7eUFRJSlfWeoq6bFolpmxvUXJCcS7NDLTKkrYsSWVIWVR6oKpAp/wX6QUKqQYv3gNCDkuI7aFr6PcsEMGsMJHbnLgkwawzU9Y+MFBrdGg9dn9BCoeUJXUOg3p4d24dA4wENZ0j1IaPN/ZFTpcKtzDwEmAOSr5A8HINvIH1A6yu0HpBmIDLB5jsbmZlATKfkKSgwEKnbvO/OfoLYn1jC81DnD0EH7j5CXK30EfAQMNCjJL0Dz0O0j5UeIhsAwZzn2EjVDETqHskXIZC/AbLFAIi+lWbyJuIg+pDU6yGSgZB7qy4CEO4TQqHR34MkVfMQrfvqN7YFQ/6PHboiACJ1d50bMwJyBRvjio+AoHoShRhootAUBWE9OyviIHmGJANxdZOqGYitWyEKonXP0RCM7xjEQ9qHdAIkfEhEQbRuhRRoJlVHQjCkagZi69aJkHhsyYhECNNdMhNSIcB2nf398fuYH5TtkiXbtU+ui6hsV2M5L+v25Lg+/ANIeKcjwyOq6QAAAABJRU5ErkJggg=="

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNUl8udxOHO4fC20umRvN1Hj8fC2uyFtdr////z+Ptgns5sptKpy+V4rdbn8Pja6fQ4ua/TAAAACHRSTlMAYL//ACDP71kzCuAAAAJDSURBVHgBrMGBAcBQBESx4x7237i/M5DoF+mFDB5BtZe6QNR4bQrRPtAofCKUPpHyja8ds2liFIQB6IEL8o2i/v9/urvtNOUBuXnZmeakgC/xGaZTzH8O+oHs5nyI0wobUgp2Go7Bu82uQLn8i7obRq6v4WwY+2u45Bl0lHdUqQnD5WA9lcMdyH+eCHjCfYYdhsNnOBGkPmGLhFX4KqjAUJGApaKDmsz1ulORSL1qGfUAMXdm5qlSLgaINpqROHvQaSQazBFkroXt1oP8wnU1BFGHAVziWrxxWoACbdOpNh4GEGcz2RLb7PpYgMxs+ybontUZgLRujWWIqK0kaEMetjXfeX5ZgI7RahpBabR5LEFxzFw/zSIXY6VxBsFtY4Xes7kb7QPEBY6358kMjrcEcWexrWNkc0PBCmRhW+5Sp93CtV2AWEPu2zrw2mTUtwSJ1NabsF11rneXVFDo1kd8mlt8dRmCCto72/xSrXtpmCRIon7XeLlECv+9rEYHuW/iyuWX3Iprp4Cwb1tXAr/D0bBjFdAh2Rp2Ra/MCVIHdSLvcV9OE8VoIEiaeiWNM7cG4kadeiWPM00DQYWEnTYi5KmgqNd/zykIYlxz/WwN7lgd5JXfxOnX0uughdOqF5sV0Dqv14vdZxCjql/mVGpVQGi8iKlVo+qgrK9OuqIFKF6KB/i74hqE5VXNmsXQbhQQSPc76TlPne9yb3IIAips22GWcWzbNmF+/yB/oMcOWR479nnsIOq5o7HHDuv+xhPHh38AMoSKvh0Xux4AAAAASUVORK5CYII="

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMNHj8c7iMOFtdq20umRvN3O4fBgns7////z+Pt4rdbn8PhUl8vC2uydxOFsptLa6fSpy+Wegqb2AAAAB3RSTlMAYL8AIM/vi50ITwAAAcVJREFUeF7tmEeygzAQREXyKAeCff+bfuMkgbASWv1y79wuXqEeJQatalp8Qm3T3YW6rh/wSQ39Cuov+LQu/R004AoaOtTgKmpQWwfUIlxJ/wf0AwGhExt9f2ScEkgHCSPvUmTvE7X6RqSCwMin9NbXL9tAIojIl9S44au3TxJBs3yLuzb/2HM2SDLrMpkN0tLqE6xwTJ1atasFXQNeHDQqS7o9rZt11JgMwkRaLauxOAbJWSLUghTYyq+iOAcETiQTxpMTEGSBsHBiIsQJSOSufuY87EAZzgW5w3GHmQ8C43MMFICw8EGibIdke85cutXyLYfjUhAol6OgGIQXF7ScOUV4fGAWlBo3KwcJr/glIH9KGigD+YtkKgMx6Yllg2xAqTGhtIBsTNmg6Xg/mgKg+Pa/JMSE4jvtbXsYiRwQ7I9D9zdkgOj+DUT0PEKxgJhvkVSQOKrSFIkJhQOy8wZMOCYUDEgux5scTQEt33b7ObhbolDFrl+vTTQBxP2LkH9t4jkgv8w6C0QDidKcoYlP5QMzQ6SUX6tH0IeLUzxISid+Quh51viL1v/g9+G31Q9UrclSre1TqxFVrTVWs1l3V4324R/jnLgg8wu3XgAAAABJRU5ErkJggg=="

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMNgns47iMPO4fCFtdpHj8f////C2uydxOGRvN1Ul8vz+PtsptLa6fSpy+W20unn8PibKcnWAAAAB3RSTlMAYL8AIM/vi50ITwAAATtJREFUeF7t2MmOgzAMBuCw1c7G3r7/ow4waFwzHGLFh6rKf2sjPmTHB2Szp6oxI3XVbDFN03aYma7dofaB2Xm0G9ShQrrGVKiSytQ6UG1QKd8DFcg9bQ93APT26ZIhv4Q9639nPQ4WnwjZ8Jvh6gzngU2DxnBmGi8HUzgDSdAcwv2b7d/BLIRCzwsjSFYarwHY34JmH1kIWshJajY1lRfXkzONiRC6wNvBGxdc+mRHgl5+d/yLnIiJED1HA74yORnilczXnwKI99Z71n0JxG87RjYPIohmgGcCMYTDHTSgHKIZ4Dcvh6jF1HY5RDPAb14O0Riy0ZRDfAb4zcsheIcgA8J3CD8EKlCBClQg/xGlRXJiFgQEQRZEH28O8yCEo7oIKIbkKVCB1JYsamsfrUWU2mpMc1m3RWN9+AMvrK1QxMKhKAAAAABJRU5ErkJggg=="

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8f///9gns5Ul8vO4fBsptLn8PidxOHa6fTz+PvC2uy20ul4rdaFtdqRvN2py+VhQI3UAAAAB3RSTlMAYL8AIM/vi50ITwAAATpJREFUeF7t2Flqw0AQhGGt7tm0y879bxr5SUXA6g7V5CGoDvBh5h+MmOq9uhFiTd0eq9q264Vc372h7iH0Ht0B9eKwvq1qcVldNT5QU4nT/hF0Q3n4tPAbKGzx87Zgh0q82his0B6v92WFJgWavaBohZ6KU6xQmJUzYvLjsgbhhh8DemL+RvICJ8RA56ktmYDwQuxCQAMWI6Awnpc6MNB6FktCQHDRX0JAUH4VAsLygYCw/CAKRJQHyF5eCAjKL4mAsPxTFIguj5BefgwqxJZHSC8/iQ6R5RHSy2cCwvK7EBCU34SBsDwBYfkkBATlX0JAUL4IA61QTPmK/Jsvtjkqm4xQ1LbYoCGqS06/KGYbVDRnNFZLi3JEyQhJ3q6oAg5C/G7ohtweWdyefbweotyexjwf6455PB9+A7kpl2aXdIixAAAAAElFTkSuQmCC"

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNUl8vn8Pj////z+PtsptLO4fCdxOG20umFtdpgns6RvN1Hj8fC2uypy+Xa6fSZV+70AAAAB3RSTlMAYL8AIM/vi50ITwAAANFJREFUeF7t2EluhEAMhtEa+Wtm6E7uf9SABFE25ULCWbW/AzwvkLDK6kgbPMhou6esdR4P8+6A3ITHTW6HPBjyVmmwpJUBS0aBKYEEYkgggUJMvfK7YG/JqVecwy/UEtUCoCaivN6DUhhAqV7QmkloA7ZE9qK/2jWiods5ogwhzCMIN6EmkEACCSTQP/9qX3EElb/QXDvFcx2ttVe+Nh/UgdKF0QaNuAV9YQSVE8I3Na0BKJlgapEnxEdDAgnEd2TRYElzHaLYTmOcx7o9jvPhDxKnl0w75mbKAAAAAElFTkSuQmCC"

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMP///87iMOdxOFUl8tsptLz+PtHj8dgns7O4fDC2uy20umFtdrn8PiRvN3a6fR4rdapy+U8tgFNAAAAB3RSTlMAYL8AIM/vi50ITwAAASRJREFUeF7t2Ll2g0AMhWFWX2lWNtvv/6ZBxVDY8UlAOjkp5u/5GijQbaS2I0Vd2+81fT+MpGwcBBpupO427NBIBo1905JJbdPZQF1DRv0DqEKe2b0Djtmfgx4AwpsUAwB/CmJ894jHHv8RVKEKpVxa8XP39BHKOFX+CAUraMKppo9Q5FIWYOaXZgEyl2L9IK9AFVqsIDaFFgMoF14LrQI5PeTECXQeSt+9tHwOihMCv+qTQJv+/8hBSnpoFmclNZQgbXroLk6IamiGxKSDinMnJRQzpJCUkA+QsJAKchOKo4H8jMO5DLnHcy3MmugqFDOO8Ix0GdpwlL3mqOHCzMIoIBcAhGmJ6jPLbUuqF2SFfpPZyGI2+1gNUWbTmOVYt2cxH34BljWiWlU31WUAAAAASUVORK5CYII="

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAz0kAz////+8eH6yIb1lxv++PD848L2pTr3rEn4umf71aT1nir96tH6zpX5wXb3s1j83LPrG2UJAAAAB3RSTlMAYL8AIM/vi50ITwAAAbRJREFUeF7t2NmuwiAQBuBuHva1i+//pochsYMmB+SAiRf9r5CYzynFdMoAGSfSkGmcQ4Z5Xm6kMbcFoOWHNOdnCdCNdMhtHkbSJeMw9YGmgXTK/6EL0sZ3gQ5K6dEDYgHiHSBO+1QkZHAUaYfuwZGiHbI0ZDOFiCKkJX0nqgSJlb6XDFTlsByEjuKQuJ0g7pxSwXAw0DkI6+GRVY8rMCCeW8wU75qOztoMeRkd0wzx6Ih2CAQlSDtErNoJaYIw3wVZWhNp/4QkrQr7PLTXQfbDi31BF2QgsC9dHK0BeplyAdphoHMQpxU5MpCqgXgGcjXQnoEEr4j4fDOKZfnXjlTYOBdj+V6CcMU1ABu2WyulLOmetncgcy6kwr2Htxv7yxJ0B8g/RhwnXfJclz4HYUHu/O07Xo9MO0NVhFaA/Nm1ryRGAH+kNe8FiIPjkuISf0u7Zymy0EGT74gE4rG69GnjcpCWT1UDZJLqziIYSD4DMVzHF0g8UGR5BoKCmMCPCBGWQkQV/rQ2OBrdDfo3XJctbTbllu9qzRPs9Te+015Qt0OWbsc+vQ6iuh2N9TysC+lxfPgLTaOa2J5MgOgAAAAASUVORK5CYII="

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAABckTtckTtckTtckTtckTtckTtmmEfW5M71+PP///+FrWyjwZHC1rZckTuPs3iuyJ2ZuoVwn1Tr8efM3cLg6tp7pmC4z6n008phAAAAB3RSTlMAYL8AIM/vi50ITwAAAZ9JREFUeF7t2NluozAUgGHI0rN4XYC8/5tObHUsQgwp2FKVKv8VQui7sTHidLH+pCs69ed73fl8uerKrpcIXb50dV+XO3TVDbqeu143qe9ObaBTpxt1EPpAIHwTyBOz/A8oRHMUssyM345I10/5qQUEDplvtRAYRRyrgiaJ0aiCQNiBOEfuADQ6i4FnkTIHVm1ZSEolFJTzEaiBUFkBM8BJvw4ZTAVmJoyZBAWTiZxiJr8KIS/C0obMj4oWEG9Cbgm5BI1PTPJ5/6rB0oEx+vshUtaJnP3e4nYX5Hktgl2QHtYgp/dBYKnEoNC7oNQkbGpAHGzMCdjximz3KxBINA0go5iZ0iFtn5LTD6HcpB1xKYSXEDjMDmogLmc3ITC3kXODSK9IOSxBpV0crI+0ZGYy4jH1Cpo5uLUVxM+gMFZDkmmQXts6KPcGEOGi8RBU6l2hN1v+DySs8BqGGST53s0+Nr6CPOdUYo6ekKLwZScuJ7egKTsB8r1QdG7bnyODlBgFM14U8n/in/YDNRuyNBv7tBpENRuNtRzW3WsxPvwHLFMKWpUSN4sAAAAASUVORK5CYII="

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkThSFvfO1D52Nz////siZb75ej3y9Dul6LmYnP98vPwpK3ob370vsXysbnjVWfqfIoUMOX+AAAACHRSTlMAYL//ACDP71kzCuAAAAIQSURBVHgBrMwJAQAgCAPAsQf7N1YzwAU4fEUNsPzATmuo86McjZ28qLWgjdKKAnciQktuO3az2zgIBVB4cTfAAQP+we//ptPeuRIaO3HIjNXFtGdRKZL9yUAsGv4B+oGcvwcKEM94Irk3IWCSYxko3xxylXPVSeBR4TlUeFQRHvcFkMT8u4A254+iyJI1tJqt5QI6PNl6nGptG141V+F8z4JFHIR8ABLUP6RWIQEByAOQOXMFnanNd4cILOZfQd0JAqw6xNC6swNlBwjuGrI7qhNg0g/gROwxMlD0L3W5hqI6TRQyNvoZ/WiQbKAP/BxyK+YY9CnVJanj+7umMDU/g1w1p0Mixa/2ReiQ7GjLEygCpHZ8+2cgHt7+lgDiE6jZCA6Q3zYnB0j8DNWfIGvJu1jh0deu6IJarrihXaQ5OeeKf2cXKa9yY1DkZW4ImnhZHII2XlaGIJ9fFb/zvzXb9EZxbF8b6Asgn3ij9d3JBih/v2qlPYJKexPyAbYzFGDyw5A5cIIKQPDDkDnTCZKqkhuFmjrJn6GmUi1j0NJ3pSNkEnkA8jPmnKEuTe0VVBJ9Ro9QHzfM/hKa0dbPq1zsu2qHxE9o1V1AC30KHECaEh2ycr/qEkrFLu/Vw7JOAPsFJFMf/EJvl0N7qPP1ZJui0hpUqWv5+U37n0K3HbLcduxz10HUbUdjdx7WfXTH8eEv2+Vp6kPrxbkAAAAASUVORK5CYII="

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAACSZsySZsySZsySZsySZsySZsySZszJs+atjNnCqeL////k2fKgedKmg9bWxuy7n9+ZcM/r4vXPvOn49fzx7Pm0ltzdz+9yvtH3AAAAB3RSTlMAYL8AIM/vi50ITwAAAXVJREFUeF7t2NuKgzAQgGEP7c7kfFDb93/TTQrdNIFNR5xCL/yvBOMHSkCdITdOcKBpnFPDPF+ucLDrJUOXHzjczyVBV2DoOg8jsDQOEw80DcDUd0EnJO+L5YCEUkp/AjohI7HJJWjDNmn6kFfkfA8Kq6JnOpBQO/IdSGYAxbOYANkcPfIZwg6EyYnF3RIkIKcfRyVNgHSBVMoyQLcMAQPkClugckpSobCW1S0UcJHQgfwr5MpmaSGLKPo7G7Wzr0/IQQMV13ahks03tpoKqvcFDfLZKc9TVzvZKCpk7irnqnuJNyEAghB+y1B4Dxm3FqdAdRHeQMY/L1qgJFXbrQ9hfC7c6pVLzaweupD9W4gB6oJAdDq3oBQAJGiT4eibNiZlsRyvbGG+8CNCEKJAUhFaCJCmQJoAOQp0J0AB63QGsCkQoDbMELyNHzqhE9JqRzr8Cwm1K/F5KMQ9TgznH+SzE+IasrCNfbgGUWyjMc5hXYpjfPgLEFGdAv1ZQgcAAAAASUVORK5CYII="

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTob37ul6LjVWfhSFv75ej////ysbnfO1D52NzqfIr98vPsiZbmYnP0vsX3y9DwpK2HTQt2AAAACHRSTlMAYL//ACDP71kzCuAAAAFtSURBVHgB7dhLD5wgEMBxdNSVx/Be+v2/aZE2JN2IzFYOTerv4An/HNAYhx2mGW6YpyVjy7JucNO2HqH1Bbe91hzaYIBtYRMMMbEZhpgZDPKE/q3QzrkYEJIKM307ZCwW/G5I42/uXohj5stF3Ak5PIhAKLF+xwHofol1Oxoy2y0xQqceno9/E+J4sAZqKXNfh4z+o1NL+suQtB+dWrLym9DuT7Y3bzz4QAzVO1A3HvMkaaHdN18Kh4XnhJBMWCgBJ4TCQrlOSGr85S3jqbogxdPQR8YHUHjKwu5rqhUSdYmEiA2ingWia4Q0FmoHAIkNBgCiwiJdhTw3cAjpVIAieMx0IyR9zXQZ7lHJRghMNEAn/usvrXH8gjPUkPB4yQtiKGFHIoawy5BCETPr4qlgMYv0UISG+ISe0BPKfkADp4ckdglSCBR2eKCFAnYEYgj2hBeSe/4gPz2hYUOWYWOfYYOocaOxYcO6bMT48CfVMWS5oJw5qQAAAABJRU5ErkJggg=="

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTfO1DmYnPsiZbob3798vP////hSFv3y9Dul6LqfIrwpK30vsXjVWf75ej52Nzysbn5QGA+AAAACHRSTlMAYL//ACDP71kzCuAAAAHaSURBVHgBrMwJAQAgCAPAsQf7N1YzwAU4fEUNsPzATmuo86McjZ28qLWgjdKKArWC0JLbjh20yK4CARRe1Eajx9LWmP//T+9k4Ep8YOIQF4/LnJ0gn2kDTXf9QisgY023moPM5qTPerBt5cCHCSh40H5jBGK3shPQBuDdeyhxxucV1DYC2byFpOycVSOJ+7y7hcQoZyrKQzqAWgdnknnoeIJkA7yUrGc7sOtXbVX1uxweIUm1ureX3frHoBTTEigBtch3ofKYmgGk0I7fmCgNoNgOeglJ8pz5ImKydnmgal82I0iM0h/V0sEtD6D2kdxrSIoHyC+h9uK3BZCYQz/ylauMq9sT1HLcF2ch5T4/CwHs8W87cLTVAfATyI4uu66C9OdQUU0XKGo209AWkzRIAWlQAeIslIA4gOxPoAzoAsgAfBZACaAsgCqwy3vIAsQF0AEQ3kMBIEsPlQZt09ABYHuobw4KALtcoA//Lc1AB0C6QsHTV80EVNoDNUhMiteSyASkAOkKDar3kGsPNIRijtbajXtoB0h3kJv7zgZQuYMireMGUqDcQrZ7eUNIUgzX+/Rtcyts8VDV6OZ/Q5othv/pf9pfaNmQZdnYZ9kgat1obNmw7qsV48M/BHBv4Nh5IxYAAAAASUVORK5CYII="

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAz0kAz////1lxv1nir848L5wXb++PD2pTr4umf6yIb3rEn71aT96tH3s1j83LP+8eEP5naZAAAAB3RSTlMAYL8AIM/vi50ITwAAAVRJREFUeF7t2GlqxDAMgNGsI3nfkrn/UWvjQgcaD3alH1PId4AHwklwNJXmBQgt85qb1nXbgdi+FWh7ALnHlqEdGNrXaQaW5mnhgZYJmKJDNyS0liyQQjSCAZKYswyQy47hGO3MUGSABOYOBkjXyYYhoXAg45uQxrGakOeCpBlyVBMCEV4r7BnadZ5aHVSSX9o6pwc6pLLzFHRI14eaDNniJO0vcmIAEgnbGdcPnfguI3qhiO87OiH3PUG4yDWeiqnhtD9oqgE1HfREyCMLJCKWEhWSCUvOZ+ipLjM90GHqcYHHdh1QHctYgJMEOSyl7IAiQUdxTgEFop1aQqMBGCAIAjigGj8Uw2VpEGr33yHCu0Y4tU+FbsipqIME6ZAGCXwt/B2yr84TCKOlH8fYfuj4fVMIPqpSHLofgQ32Y/9pb4htycK29uFaRLGtxjiXdTmO9eEXaKmZtBhIFiYAAAAASUVORK5CYII="

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAz0kAz4umf848L++PD////5wXb71aT2pTr6yIb3rEn96tH+8eH83LP3s1j1nir1lxv6zpXDe7tBAAAACHRSTlMAYL//ACDP71kzCuAAAAEeSURBVHgB7dhdasMwEIVR22M7Hl391omy/512QqEEElUKGgpNfRbwvYxedIebcaIO0ziLYZ6XlTqtyy20nKjbaZHQSgrWeRhJxThMpGIaSMkROkKPNjYoYdsecviRaw15VPjGkEWFbQwFCBuf2iDCKyEq4P8QOkJcYF4NFf39UCxIL4Y+tK7G7xni9w0lALvGO0LFr4eiVuisFQoQpHA1BpA0QgaAUwh5CKsQshBeIZQAGOoPeQinEHIQ5/7QBcJQf2iHCP2hM24u3aFsIK70yMevukdLKCcIk+nBBsHMCU2hK0onY9yLtZCB2OmJHXcS1UI7gJTpCc/45nI1lB3vmQp83EIINubj4/c2IbWRRW320Rqi1KYxzbFOaMyHn9JsW4UhjzXsAAAAAElFTkSuQmCC"

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAz3rEn6yIb////848L0kAz++PD71aT6zpX+8eH4umf3s1j83LP96tH1nir2pTr5wXb4SO8kAAAAB3RSTlMAYL8AIM/vi50ITwAAAOxJREFUeF7t2EmKw0AMhtEqD5FUo4ek73/UVhYN9iYSWA0O6DvA2xhB+Q/v4pAvNMSRC+M4zfli8/SGpke+3GNiaM4GzWOI2aQYBhtoCNmoW0EOrYXKagFtRJQsoPR/kEOA6VRhqKRzCDJUSVWVoIWUrQJUtVAToMRAWeDQzsAOx5bCUFJAKH21ZgXh/SCHEh7rDHU8lZSQ3NdCFT7fGlQZ8hNxqErQpoRob5+Otu3EbQKEpAwF6Kl0ylOA8to1TgfFa+QF0tHCy19sfznk0A9DaAFlQLjXH6RDZiOL2exjNUSZTWOWYx1nMR/+Ardh1h1GAw+AAAAAAElFTkSuQmCC"

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkT3y9DmYnPul6LjVWf98vPysbnfO1DdLkT////hSFv0vsXqfIrob3775ejsiZbwpK352NxS6H3FAAAAB3RSTlMAYL8AIM/vi50ITwAAAXxJREFUeF7t2OuOgjAQgFGuzvTOnfd/021dLWRpkZFm3TV+v0iqJ9EiyGSuvNAnKvLSlpVlVeuT1ZWDqos+3aWyUK0TVJdZrpOUZ0UaqMh0ov4E9IH4YEQXBTrWHYWYMQZizmgXRxoUX2QnIAYtPwahhHuDhQTck+hWnX0I6k28ngLNO9BMgRwwwLbBSVRILafKssHDE9Dd4Rb1Jx2cgNC/9sWQaFq4Nq+++L61xxRoMqJjZhsoREWBXEFI26iQYt9JB9yO+TNQcNfeAWqECTWTod6EQyrEw45QVEhzvDVaQOKt5t/vGsd7/qP5FAHqzE4tAWJ7EBAg3IMmAqQbjKcJ0G6vg1DCz6aGBsV3TnA6JEwoSYb49vbvaPAXq+kghP727+s9pBWipkCxvXL9OvSB5DFoxHXtCupBMkTsxENImWAQOO/HXUhDyPFvWuPNPsRD0rT8u/XFn47il0m1rI0TXGPNGzyKfqBkQ5ZkY59Ug6hko7GUwzpbivHhF1UpEoqfvWRjAAAAAElFTkSuQmCC"

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAz0kAz////3rEn++PD6yIb848L71aT2pTr+8eH83LP1nir1lxv3s1j4umf6zpX96tH5wXbPaOloAAAAB3RSTlMAYL8AIM/vi50ITwAAAYVJREFUeF7t2NtqwzAMgOEcK/nsnNr3f9PFoZ1Y6WSZmBVG/yv1oh8qBYe4SbUdnKhr+72m74cRTjYOCRoucLrLsEMjVGjsmxaq1DZdHahroFJvhz7QatRj3DQaoMBY58WQQ8SHhDSnFCJqMRQQMcw0W4JsEbTg3kYrHCvRJyOGICbJ0w72x64gh2ZN31aEgqH18hD9OEUrOUj55EQQQWu0RwkK9iikmabrMbqVhyKK2zjIY0ETA5kSaMlAYQYu+ldNBrIgyP49pFbzstUXQV7jr4WpAArIFOXQjGxySCVgUS8yBOGNgbzegTsEL7tDN0Q9MdBuzCCBYPbZY0QAUe+HpjLI0wH2VCiDALmuBdDGQYsUoqObTmwqKmAgpgQ5yEcQ91w6CdFz9jykaKFyaHH2O42I2j7nlATaUNCahyaUpPOQQlFKBOkZmLwcssBWE/pA11oQOsMUpZCoKQtBkDgW8pAXSNZzEFEq0/RPXkU/ULVLlmrXPrUuoqpdjdW8rNurcX34BRm2l0TYV5ofAAAAAElFTkSuQmCC"

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkRwyRsNAAAAEXRSTlMAIGCPv98AUJ/vQK/PgBAwcKJA2FIAAAL1SURBVHhetZjrcoQgDIVB7ioi7/+ynWaBo42gdWbPr85YPpPjJgTEQHJS2uQio9UkbV/CduS8yUzGu/+BpAq5o6DkY9C85KGW+RFIegBWH+ei6FegvLwHxZpU8G6zJ23Ot4fxBiTra3XHVadrsHIEcoGF3k09uD4olmiSHSqVqGIP5AkTdnurPRDJX4M8ch8LXnoGahy/2Ufayr9zUDw/SCbrMdPDpyPIEQf2mGrmNsUL7bK+2p1BMpwDjRWbekU3lZiCPIHWM2emUv9NrVt2oWa3FhACWMkTxEelSWv0H5nyeFthkygLESOeVxA3XRMICyvIN6PBWWwDWaZYA96bJaI6osFBnrcgq6sJohqaGKeBIpNuoETRf0Cyhdc+d0gWoI7mQ0FIAqnyZ8s5m2QfgygMRaAAh+bc8trmrYI0kwGIjAm/ICoOh4A+NSYD5Xdrtq3rBSUZqtOBwiypx0cgyshbYc2xOLY9Ice9C1IfEOw2VkhkdtBaa42A8x+56hFyk2K6KoLY6Cb3lFoW1AyEQgGfi38B8kr6HL4S+mgRLM+hRBl5TGjJMEkLaoXMIFgwFIwwgi/y5bc6EncCINbU34PAIdCm81ir7IDAIZDLd4odEIJ4CNqvQGhqIRaPlL7S2rYDv12AgA6JQENr9Y3ZiTj2HcgcV016kdYuz0H4QV6ViC5mx0tR14ikdCgRFC0D5VvpQ9GijbwAmUMbQWNjoPUWpI6NDa0WoMdmo9Wi+XdBe85qAELzd8iNg7AP90DYjoi4jEHgcpCmjLBld1ObiDR1QNiyEXzPbIWtnoEwRGCs6YEwdDIQxho2aDEQuotnIAxabPTjIAynmoEw+rFhlIPwiR0DYWFnPAYIpCitWuhcugKE8ZcN7AwETRlaiIOBnR0hRqCYoen8NfmhJg5ADhwFo7MbHLM8vZMpxc+2EhPbkXsHvym6pwe/7xxF3x+Ov3dcf3+B8P5KY8FM89VLlvG1T+LXPt+/iHp/Nfb9yzroX9eHP0rrwAQo3O+dAAAAAElFTkSuQmCC"

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz2pTr848L3rEn6yIb1nir++PD1lxv71aT4umf6zpX+8eH3s1j96tH5wXb83LP///+wSrO7AAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAHWSURBVHhe7djLsqMgEIBhWkRASeM193Pe/zEn0aSQQVGQ3cy/y+arotIqQDxBRnOGn1hOMyjWI8VKXDB0YoKHQUAlriQp7IbKCr1V5S4IBG4mYBtSEnck1QYEJ9zZCXwQl7g7ydchhUGpNUhgYMKBjBMtkSjHSC6kMCr1N8QxMm5DIGMhCRY0zaGug9LTZM4hNenn36DO83Ei84XVYVA9XxyZT9A9DLqbGZigEr/pZrNx+eMPjd/KD1RhQO0bQrtqggCPQggjRI9DdITkcUi+IY7HIeQvSLhAd2ntmi1IvCDmONdfp5v2Q6wg4DjN4hT7IQSSocn3xHV+KCMUTeaJ66+tqR6H2Q9Rki9C17k87IBywhah1qJ3QIxgGgj/aeg/lG4g8zRQTmgaiJIsDZQRWIQeHZqeOyAgBXOhpbQXYksv/+eS02+//Dna4fBYgC7bn6NCOlJb95Zy+2nQC8m0n2w4DkHabU1RHoVKs/U7BAlrMxoPSbC2x/7uP+eLNkNmQcresPv7zNXjNs3V3DmFHCEad6duFhZyqBmsSe87NPGwY5Y+mwew1mhSEQe/rhkbnH8++VE0XhKJj+vpLxDirzTSX7LEX/ukv4hKfzWW/rLOLej68A8jZR6TNI5MywAAAABJRU5ErkJggg=="

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAABVrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO6tVgxQAAAAEnRSTlMAQFCAACBwr9//z59gEL/vMI/L85aRAAAC70lEQVR4Ab2Y25bjKAxFS0YYxEXY//+zs9a4yCg+ckg/9OzHTnpbN4RTP/8DtIULIl7zwx5xT1kspbb+x6IYsngk61qLSOWRUeNShBofVHmiCBpkhLVoH/IN5fgs6un2aD3DRkQtVL190j6JjiyGsh9soTOL4XwWHcOWITJC1db8SdSG0XT2idU1GZGN5wSN4SgyaSiynkz8mSCTA0X9VUjtbIkU/mUz/6m9ntlBpG7iW7WNSnu8t+W8i3bHEwMOZ6VbTPQuigM8PYiLXlHNJ+u7SOGfKcsTO7OpBVkRQe1O+UDqzK8kkhWlm73XxZHtZgiiEemtBUUWFGbuw2Z6ia5ExkysypL6X/rFiK58Nzu4KzbmKBfdtv/URLNfsmKGX6bT39lZviK8cgsgWiQGIW1m+EDUh98m1XukjSOK/IDsmrM77TWJcuGKsjt+sIuvbuVn0eYPn2si1mdRdfvsPyhweRYNr82WYj8RX2SG0Xw98hu7XQK/MTuiMNskk8wTmHul5/an3zWgMlG+YSI65xyg6FewPYuiqVF+PiJzQqbIVBLbBssWRTNFe7ZxPoZ5lC9SDuLl5h/F9EnU3g6nIQnQPokOO9qEicHk+6LMnL3hjsnf3iiaJ+R+r+WTiBqEA5MPc3SY3BZUdkX1VT/9duH6ov3VUZI15nbsWziMaGY0/NsfSXbhVWcfNfMKt3gHMFuq4YZUWNAeI94q4uxs+sKUjzlfA0VzEgsvTaWboYHUeLftiEUeOeEqzP5Ne8UdhrgUwndlMiITUu6XuDqq3Bg95/1tpNxq0PcillGJ/Xf3m4iwmn0LqllEte6HfzuNA3/TBugvAr8TG6OIFY6SD2XzRU/UC3YHiQmWiRGBSXRjj6M6K9SK0CT5PO7B7MVd/yjirmLJKdBli7TXLJZBjCLo3Rp1bxELFVkzGq5aZB+y4OzsiYAefBX+3QZEQFPxKbuNBkVIbAni0j0ygiLgaCGpqqhqCu1gn7UI+cuifwB+VIWgscmx6QAAAABJRU5ErkJggg=="

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAwFBMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t2IyfmIyfmIyfmIyfmIyfmIyfmco6d6gIS/xco1Oz9ufIaFkpvW3OGMmaGcp6+UoKjZ4eZudHmzur9jaW3g5+za4ujX3+XT3OLR2+HK0dZMUlbe5uvU3ePM1t3V3uTd5erP2N/N197Z4efQ2eDc5OkpLzOIyflmdX+rtr2Rl5xXXWKorrNzla3h6O15pMT/zE3K0tjQ4u+62vJTcopASVBETlRicXp1g41oeofYZAqPAAAADXRSTlMAYL8AIM/vv2AAzyDvkJpDGAAAAdZJREFUeNrt0WmXwTAUgOFQW+2mGBSdIfbWGszu//+rSWxRbcI9KePDvF8cJzlPc+5FrETcUSie0GlI11NJR7FkikGptKNcOkWhpBNASR0lnEBKoHgwUBxJDhdj2uJKCUkdgIRkDkRCEgckIbEDk5DQAUpI5EAlJHS8Ehwa+/QPiaEV7bGh5WbsarMEQuL5gYf9+NCKdgvI5n2Ihg2F7LtDvPtCvMeDPm1PX9Bhs75tn0AQuxocRLsJtKLtINYNIe9WeEqQfRtoNie0+cx7/jNZE9rb+1XQlOybnp9PyCEOCZ7Ob7My2Rz7yWXz7KCwJhDoifhkFLlzCSqUthfXa+Jbmb9UDhWfibwSkUC8MgHFoHxlXq1WMzWXUyPyzHqjaVnNRt08QhWD7Hp5pehhK4aUabXxsXZrB2UIr1IzyBWZHeyqYzKIgOv28Fm9LoXgTh976nfhkMkcr2SCIQv7Zl2EBtb23uDwFwu6ALWGeN9wt+WeEDp+tNdpeZ3+yRg6W1QMjfhHGufQEF8dGrhGZrrngwEQdtUWbAgM4fophBWgoTrEa472i1SDWHyRihD+SygcjBNGoWCgENKiQThRDWmRmLoTi1BIi0SV3xPRKEQLhZXmHGLGL05Bb1VzavvhAAAAAElFTkSuQmCC"

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA0lBMVEUAAABmdX90TqqSZsySZsxmdX9mdX90TqqSZsxmdX+SZsySZsxmdX9mdX90TqqSZsx0TqqSZsx0TqpmdX90TqqSZsySZsx0Tqp0TqqSZsx0Tqp0TqpmdX9mdX+SZsxmdX90TqpmdX90TqqSZsySZsxmdX9mdX+Da7JmdX+JX8J0TqpvW5ySZsyQZcp/V7d2UKyFXL2MYsZ6U7B0Tqp9VrWDWruJX8F8VLNmdX+LYMSOY8h4Ua6BWblvXZqNaMJyU6VocIRzZptsc4l+aauHXb+CbK8OCPFgAAAALHRSTlMAn9/fIO+P758Q7xAgz59QUGC/QGBAgECAvxAgcIAw3zAwj8+Pv2Dvr9/P75iSqEMAAAJHSURBVHhezdjnctNAGIVhFctBYCEHhZqQQi+76s0ldO7/lggr+WDLq/Lt/uFcwDPvN2zwjAzFBcGNoT33wqvv5pgLPeedU+/2Uscx6719cJWdeX0wUxnCXbrXtcCVt5MWOqd5gWEsPBynKjlzV5hvBeQY2ls0STf6UnNcoA9d0SDfZsz2JU5Qi7lTHSbm913mTQ2yG8ju+1u5mOicsnaXcsdxCUFib6QOPYh9lDqmQQ3iUXY3a9l1yEF51mzZcahBZdbOojsIwmFi5yQHQTgMO1NwEPQrw7LPdMd43TrraA/6Snces3ZVtr9vVMd43jpxdrDvP+AQgnAYFjL25f3pTCGo6jpitk8NijsO5tOCkqjHYTYtKD1ysBklqOh3GCUoGXAYJSgdcNaEoGLAiSPr1fXEoKTf4bnQreWwcykcnvY6JR7FsHRPQNs+h4cZZg05M+Gs+pzVJtvbi7EgvpE5CMVGg7ZyJ0kPHWssaCV3iqyz5UgQ38icddVhrOVYUChz4qjDnI3+k5USh+eTGQTx6Ngpo+kMgvIjh4cEBkElHPkb/ARmMAiHhfI3+OgpgJGgvOMkKZkxHtzHDz2cgsBgT/B7GOINEhkEVXDwBikMguJ9h+dEBkHiMDglch5eC4AQVMFhPARzLgBKUAwHbxAMJSiJ4GxVGASlOydJVRgEFTunUGIQlPx18AZPwJCDUuE0b/Dk2QsA1KBCODwHozbzp3DKCIzyN5jbkPEQjM6Hit+rDRi9bzC3YJSH7yW6m8PRl5y58V/sD1mdQkW1WC0YAAAAAElFTkSuQmCC"

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAZlBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMiZpkiZpkiZpkiZpkiZpkiZpkpLzMmR2AxODwzOj4+Rkrx9fn///8iZplZjLOsxtnj7PJ1n78wcJ9Lg6w/SEw0U2mRs8w9SlEvWXc+eab/zE0JFe9NAAAADXRSTlMAYL8AIM/vv2AAzyDvkJpDGAAAAWBJREFUeNrt09lugzAQhWGzJSyhSbHZQjbe/yU7RkVH1SDVqWHERf8rRMQnxhOULT0aj45pRqksK3LjWV5YqDgZ704FQblZoTxTqbG9mkq33Xy7qoxTd63v35epms75Wmnd9OZdSFPziavpfchpZwfdBurmBpkJauhGt+xwiY8GqCKoXnAg4TEeoF4DYg4kTTlAHXcgAWLLYKO1PXcgYbRlCIc9rZ87kH5rXj/VdnVdw3GXANk/5FR1NbZhIcPCkIDsJ0JM8zJ+EHKFkDw0UvuGno/hR4/nH6GBBYitc2DJQ8gdGqktoBJ9vHXYHELiEJKF0P4hDC0NjdQ+oXPJugB0hz7LhVwh5A+hTaCREoB4F08IbQghOQivvn8Iv0lCyB26lHOeUPkuhGShkfqHpLYmAY2UPIQHdg8hAShcZ/2hCtaBAhUla0BJpKL44A8dYoKiOPGFkjgiiApCHygMrPEFI0iUGQahGx4AAAAASUVORK5CYII="

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABUFBMVEUAAAA+ch0+ch1ckTs+ch0+ch0+ch1ckTv/zE1ckTv/zE3/zE1ckTv/zE1ckTtckTv/zE3/zE2kgxNJdBxKeSertHOZsmmZp0LwtDZsfR1ukEOur0Tbu0RWfSPb0pnMzZDMukdKeCC3qju3vH2PrGGPo0FRhTC4skVViTRAdB9WizXzxkpigyZEeCNajzmGlC9JfiifnzVNgixThzJHfCZPgy5CdiH0kAz+yEn6ri31lBD+xUX1mBT8vT34pyT1lhf/zE35qij7tjX3pjf3rEH/6LZckTv2mxj3oyD6sjH9wUH8uTn7x3b+3aH5t1b6vGH+46v1465wnEr3nxz8zYE+ch1mlkO4woCuvXng2J/YkBX92JZWgTB7nD71yEzpjg2ZgRVVdhvrkA+Fp1qfrWrz4axvkTWDljpmkTjCx4jCtkbW0pfWvUlmlTzgwUp7oVKsDCdQAAAAEnRSTlMAYL8AIM/vv79gYADPzyDv7yBckn8ZAAADG0lEQVR42q2VV3ubMBSGSZ20iZ2kcZvuNN276W4PAgwYm2U8Y5Pdvff/v6sijnnymIBEyXulC+sFfd9BlvYpz5oFmC1XKFKlUl0wC7JQ3RdVl8zCLFWpCN+nGAsVqWweCWVJIOd6XSBxyeRiAVgmlzSRTFQT8QA8E1GJnFPkgxLgEii4DBTwc4oIgNKKNgMlkrYUAJJfBK7MogYKi1t2Ib8oAMBoNKBoGBZAkFNUA4gerwJDZS9JqeUUqYDbfGD4qAbB1hTQsXZgKKoHDE9VgIHP0cHNFAFFl6NoGC4guNBQQ8kUsV8ohKqGKDAajW630TAgYkjL09lKzxRhNJoVVdRsd2yk025G24mC8WeHrY9P4oHRQ0vs6hkw1CBC57QmK4A0+3aCfhMQRebVTzCakX0oIwyLcOdI1phn105hl5k0mT+QFnoyTVbqQMo+IUGNNeGiJ8Pksi01ixBfnhARwOKHngcjO5MReHrcHpkQqQrENG0OTYhR1MmMgthk9HmivhF7WsmwWy5E9GwuPYgYyoe1JnvA6PBFHWD4afWTOCGRlJQgfY5qCkBbRNQG0FqZX7+LJ+PQwdlOEam+B4YthAFaPeVoQZ3NWENM1GDle5Y8IbKwMZ5osLXuOOtbAypCXP+gqA4x3SzP5obD2NjsQoyeWzT46MR8/QBj/LxH2153DvBlJ5rteitv2Nt4rDHfdrR67T/q/+4k+MEdSL4HTdxPhO9BU96P9qeTwi/xawRzTuH3H+7FxvegSfyqHfx1Mnj95tDL/+2792G49+mzkAdNh/0dnTodMpbP2DFnHQ7nEn+Q5y+EMRfHL7XlcLk00drK5fAAe6vMc8UR4CqK0HMNFcjyaqKwrOpi0fUwwY1E0BnVSWkeZrrpCHILRehJcNsR5U4kWglTuCtskjDnFO7dFxahp5AJRQ8ehhmsPRIWUU+mSVT0OOTwREz0NOTyTEgUCvC8uCiurrgIqyssQl4UFyEvuaJjgiZOTCekKUHRq+yY5qTSTHgEMc2XpNL08eIxnVykotL0TNGY5hdLVESZEkt8LSXnuRLlH4SOWdhj/5A6AAAAAElFTkSuQmCC"

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAolBMVEUAAAAiZpkiZpkiZpkiZpkiZpkiZpn/zE3/zE3/zE3/zE3/zE3/zE0iZpkrc6k5hsA7iMMnbKEob6Qvd641gLklap4ye7MqcaY4hL4webH0kAz6sjH1lBD1mBT+xUX3oyD+yEn6ri32mxj4pyT8uTn8vT39wUH3nxz/zE31lhf7tjX3pjf/6Lb5qij3rEH8zYH+46v7x3b+3aH5t1b6vGH92JaZzEbMAAAADXRSTlMAYL8AIM/vv2AAzyDvkJpDGAAAAolJREFUeF6slEluwzAQBH2Ll7yguVP76jX//1oYckAETiRKkOrEg1nCdA99+OH4UW/g43hyHE6ny7neyPnyI7p81pv5vDjRud6B8+lwrHfheFiQ8zAsSPyQ9rRAmzZNibSRNaEAVRPS6JUiBp7TEQ465hxspcgAvAyX4QjSkgNmvQhW+6jh8HFri/WiHKBoBByCwgLylaICCJ+X8Eg/raNYKZKgawweRmosbI0jo9rh4VLBoySHh76Twc6K4Mh0jAawIOggSOOYFflfcONUFQJN1z2fXdcgULnyvAbZrIiiEW2oaLw/euJxH8N1QzPK+bAzBKxC8yJLdL0aVAKBLNGa5iDGW/+H2wiC61T9hqK59v9ypbBMco+08J6vfoIvbxI6vZAteWZN7eRCamZMXvgmLHlmTNZfKVpjmH4TGQREpRSu/SxXqCy2Z95EkiMy9glGRLh8zyiPpuaWEt2a6Cn/hl1aBF59khcClf6vNa3geaRFD3jYVP0mJrQkJZ5P71HBgfsS0R0Q5ezrtzRZcjahZzZbMoWmX0QDMUyMlg8Cjm6ZqIODq1a/iVpqbIWIsOy3aEDkuUz0RCTbS8R2Ga0ayu1hi6HYoX5rdlpITp7tT4S3pNj8aDGQY/vfiNK/RN/tk7EOwyAMBQ2GbGAnISH5/x+tO1SRSqFYZGvfdssJARdu2m+JIlFUcF1EzDRfOH/iXhHT8qKFuOBO0crPpbiFsMUkUPLaJQo7f9levey2aX/n/ufPx6U5csGaf5TPxLJ05oL/iQyJyob0DPXGdM1BozFVc9BoTNUctBrTNAetxjTNga03pmnOgqk1pmvOAPpwwzwCumncMzkRoRs+k3coIpmxIxprUPYAJvhJ1HjsgmQAAAAASUVORK5CYII="

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAz0kAyJajxIU1n/zE2TbjfpjBEpLzOCWSI1PUE3P0RGUVcpLzMpLzMpLzMpLzMpLzMpLzOXyPtrAAAAGHRSTlMAYL//ACDP7/////////////+/YADPIO/Z3xfxAAAA/klEQVR42u3S2Q6CMBCF4YGySLUuUPD939RDjJkYKHHokpL43/e7OFOaK0rlUVlUiKqqbpRnTT1Ddau8a2tAjQpQU1GhglRQGQYqSbk7dej0o0SbjkCiLUci0YYjksjtyCRyOkKJXI5Uom2HpV1Qt9IfckMa5Qk5v8Z5H3TpFgnGDg+hCJBGMSDDXV1jyyCUHOLSQlx+0M0suovHRg+zkgjSKByEokAavaG5iNDyKpwHhCJCXFpIo+NAGqWFuPwhLi2kkQy6m0+ekMkf4o4DaZQe4gfZQ1xSiPtD31AfBuppCAMNZMcQ0GjJTk9/6DkBstPoC42TBYSG3gfqB4teItWtfC6TdZoAAAAASUVORK5CYII="

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAllBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzP/zE3/zE3/zE3/zE3/zE3/zE0pLzOCWSI1PUE3P0RGUVf0kAz3oyD1lBD+yEn6ri36sjH2mxj1mBT1lhf+xUX/6Lb9wUH4pyT3rEH8vT3+3aH5qij7tjX3nxz8uTn3pjf5t1b/zE37x3b6vGH+46v8zYFIU1n92JaNi3z037CYiFSB1PSgAAAADXRSTlMAYL8AIM/vv2AAzyDvkJpDGAAAAsZJREFUeF6s1Ndy2zAUBFC9WbL8tOhgr6q2k///uUjENZKhUOSJ90kzAg7JvSA392xfjv+Rl+3uls1ut3/NAH2foV73d2j/lnEGYMhIb/sbFL4fIYsviAHsCyikCN/TbrMNF6DAJ4IAgJyJQ4XXbzeRniXAK7cZABxacUBGGt8coxC0WKoGgKVuoRGFjjFoAqgaAwCGygKmb0It4C5fYEnhbhJovwkVoG3KQYpoiOcgjprG7iBeMAexgjuIrlNDJyEAqIWvBtCg0A9DDIAktKzg8kaNBNh5Phzm2ZI33oa3MKiTEFVjBjei5tSVlO7UuO2SU/3psmu4aAZ7JsVbZ4vRAHBiGhIclOZSPuTSgMJFbvySqrmWwVwt6ITlIGEW56OM5GORjMhCx4GcpDRED6RQUk7tMglNTkLSy5Z2kFKJFSThYkbGcC2TuYLVfnpyBRUcPk2ZSQMfXqw7mrxkLwR8vt/yGYAu1jvVY9mVJuj814lJZ3JGEZqaYA7qvBOVOueo2PglNUROTKKW+BQ/Ry0HTt5JSCfAVMm3X6MjJyl1dLYjUKEYLDkZycL0kUebegMAMzkZaQYAzgaxggY3MYLeA3mAKFr9C/XwOTwHHeBT/xSkfuTRxr4KlB2C7osikOnb1Pifg6yW2QMZh4JH7Hf0FUlCvx7bS7y066VpKP4ZSUGB/+Iftgy0bi/xqf1Tfd20IBACARhWR/c2ZfYBUVmHDh3a///3YhIJdsxapxb2vQrPYRAcmyB8tQipMxv2SAifz1G8BjF0SStWHWIVoHwHxFDea3pWAxRDFbp/Cx1CAVoiyyfgPRQL0AoLfYBOgRoMugVak7MZQH0DlBb2GkQ4QdVh5y+EAGL5jEkh/DtETQuRPh+IzqaHqMmgmdwjwwY9BvLZNUqLIMxpBe4XkAMFtpNDnQUFYB2yxkHOAkEA2kggo8l4AKgzeWRPQYLOAAAAAElFTkSuQmCC"

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABdFBMVEUAAADtHCSIyfmIyfntHCTtHCSIyfntHCSIyfntHCTtHCTtHCSIyfntHCSIyfmIyfntHCSIyfmIyfmIyfnuKyGhnsSVs97UR1nNUme7c4/8vT31lBCFoED1yEzwSBvaPEz0iQ6uiKnwTxr6ri36sjH5qii4skX3oyD+xUWOvuyok7Y+ZqY3ZqOMnuXybBTgMj/xZRXWvUnycxKur0SPo0FckTv2mxjrxUt7nD7gwUqjq0PtIyNKhFg/fGo4dnYxcYItbodDfmQmaZNRiU3xVhhaZrN2Zr/nJzGNmOOMpOibqdGOi93vOR5mlTzHXXQ7eXApa43CtkZGgV7tHCTMukf9wUFYjkGZp0JMZqzzgg/3nxzBaIH4pyRTZq8wZp8pZpxhZraRbM+Qf9f1mBTxXReLquuJw/b0kAzzehGLsO6JvfOQedT+yEmKtvGOkeCRctJ9ZsL/zE20fZwiZplwmD1VjEeEZsZvZrz8uTmSZsyLZsk0c3xRc1AnAAAAE3RSTlMAEIDfv2AQAFDv30BAUO9ggL8AA9lregAAA+9JREFUeF6l1gV74zAMBuAMO7zdNSkzjpmZmZn5mBn//GW1Esn2Myfd9APeR/okp9XMqiwt0x9Szb5UKBhIlFeUeDwezeOpevIAxBcKdu5aVVN7B9UVjayEArtC1ZtQWZHKKXaCVV2iNRSj+EGR66n2zD3TghNJVaO5XlFKbmZ0LT7X1dOTfGWW5pIJLQrI2lzH8Sso95DQjZHuAKA4yMcxxtxrAIqE/EGaShyU4qGvJBzjuZnrwyB/gDBdEjBwksmGw++/mKWGWhbvZSKN2fAXLDW0gdk85zvJ7SPhCPkTthOn2dzmmgBwB63YYxk9hGn8DYBbKGW3kybtnGEzMqR2Rkk7ufci0J3v7Yt+7zdLc4h5LXlfN4Pbh0P9WJraSeOiuGUPjwCCkNKxbyeSJUosXxjGGdqQ4hkgUw0fIqCGUpZjv88MSTeKgAypnUgYAxaZH2PjE5NT38ySoBV0xLFiIzwy/W/mG5QM+RcFp9G+nb11osxuboFwD5QQnDO7nT5UDnYK08iQvLAe0eleR2YcJlJALXg/vJNXMgDJAaUFJ4ansyMwrUfzCwt/zOKgALwv0RmyI56kSNu5SUBx0FcIOgn7kpxpolzM/wQCIRyMBj0Aex+0nAPSTiv2IkNBLqBIk9DP7IyCoZCPOQYMFkZHSLmNY2SokxssIzoWc3nFAdc3S8tv3pqAJrzVOAQEQVt737SnohG/a/8AXSDU3Ikbw4B6RWee9PLxrhEJCrGG4HcwC+9CmOvyl818WkaDQs1s9QY3WGxdcD7b3bSjgBBJqIvbWB+/9zY7ntWXugzRlRnc09iDO7Scv1Y7LxAQoRauoSZusEmYy+rnHbYjQwHaUI41NILvi+azioAM+bmVsTc2CAFB0Na+lnQVdAo3RBOK4mDkfnDpEoRRx2lC3dzmW1X9AIS/QK/pVyiKG8OgV3UlBJMZ9IaGWUPjrKEr2JeuhmCyuYJzC4+VNtQG9/NSDeFkuPsY1xB8f17oDlAIJiNR52lDrRiQEoJrTNPn+p2u7DMOpobYZB0wGYl6ijbUrjtBPgaxyfbJ65ilCX3SHaEQ+VGMsMmGyGfxAk7aGQqS5TfSZ7ZFHse17gx1QkT4id0uOD/YZOyoPzpDzSyiYzhrvMZpeoxvnSGW9SjLmkb0rwCdw+NwhlKQNbkiFtEM2Vm7CyhEPiEn8AUhEbHJPriA6NIy5H2M4TXizlRQAD77uLRe8mCPCtCNGyhB/jqEyc/ZBLmiJTdQjQRF4WONWS87O8+0pwUoCb8f+PSnCPTGGWrQSqrxydLtw9JcnmOZV/PWO0PODdWZkLe25rHQkyqvCZlVUf4YqKy00jT+A9wQ4vqaVJE/AAAAAElFTkSuQmCC"

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAY1BMVEUAAAAASncASncASncASncASncASncASnf+UBEQSnHuUBfv9PdfTFH///9vTUq/TytATF4wS2SfTjePTT5Ad5l/TUQgS2qfu8xgjqreTx7OTyTf6O4QVYCApbswbJEgYYivTjHKv1VmAAAAB3RSTlMAYL8AIM/vi50ITwAAAiJJREFUeF7t2NeO4yAYBWDc8lPcU8u093/KZcA+Gg+OAOOr3T1XURQ+cwBbitl3spwSkmeFDiuKsqLEVOU3VB4oOYdSQxXtkKpgmQE+r6p53mZAqTDgvWneJyljZp0/VNNc3ygWanQmKGdmPtp5wkFiIDLQVcu3eAfVACkNnUKHuQH01gDyFvFDtwjI3QxUw2L7q61DWGxs/2JQRLD9ek630+nk1IiA7IE0UR8u1ErOZesAKAkIt0ijrp9utZab1H7Ik7uF7uSJDxJ8Sip0nqFzGnSRMyQvSVDHkW4jhC1D2hhIKbeYW06pGAjFkM4D+XfM3bkoqOdO+i2QMAtkDjY+SBEPiYcBBqPgw0NEQ+N0r84Q1UYaY6HjNAzQTB/joNoWoZ8Q2bJ1OARHLCEB6RWEBxkcnGRAOOmQluOY82iFM9BviIalhHHrEBwHciRATjU43DgORAOH5FRbv8FoFQJ89u3ayMMgPr6GsMFBEO/Ea2i4G+Phg+zl7sMrqJbTpH3QtACyXoXEiEezD8LDfBQu1NtasqcQiHpp6/W/oTNWMAwi0S3PAcN08G0IhGtjUgyrg9McCtHAsVIGaiV+HAehtmw1VOtWmyHkXrPZ3ArNfSx0FLQVInEE9HUh2g4RXb4M1PVEaRBR33GmmUTIUoz2gYjxnfJvQ/8h8iT0T83fDOX7QDnL9oEyVlR7QBVejaVBhxIv67ZDeFmnk+WbIbw+/ANmHJ8ML/lS1wAAAABJRU5ErkJggg=="

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAnFBMVEUAAABVrO5VrO5VrO5VrO4iZplVrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO4iZpkiZpkiZpkiZpkiZpkiZpkiZpkiZplVrO4iZpkiZpk4hL0iZpkiZpk8icQiZplVrO4iZpksdKpVrO4iZpkveK48icQlap5SqOlLn94ob6RIm9k1gLksc6lFltNCks4/jclPo+M4hb4yfLRRC5L+AAAAI3RSTlMAQIBwIABgn9+/MBDP71CPr9+/z++fUBAAMGDfgEBAIK9wUBMxUTMAAAIWSURBVHhe7dfrcqIwFMBxSCEQuWitVnR1a/eEu9f2/d9tdRCwcIgJ+mFn1v8D/ObkJB9A+3d6pus6edF1I7iVFnRmUMuGKkYGvSCHutDMJoYqZBAP0CxDBXIIdOYReYh6IMo15CCDwY08XwbyPbgdvQ0NQSp6C7JAMiqEHAbS+SJoDfJ5BgaJz5Xkp9KmxDohgirpV8aLwugnRjsgHWVCfl12SGrIxiHHQ5yIN4ujmqIIhC46+b4mXsen3k7UroTWGOQjzrZCJtP3mVk0X0x/lUNhkN2G6nmWhVL1mxWQ3oaIYD+TudnKtxEI3/QRd2rKYsPG0fCBqntfmXJpZ769obR0pqYCRKHVpoQ+VCDWhuKLMzIVIKPt5PzSQgV6Edz9hwrkCh6jqQA50H35ryqQj0BZH2iIQLzP0VwE2vZZNiCFPa5fBxA87LE8RDFoz8tW0hDBoCNXHklbA4i2zT9lIQbis/G5JGSjUBJX0ERO0gDvwFFJHYItr1vcAx1jXjcSvHDHJ0QPgk4I0mtpspx1OMWHtOt0Q5AXUkWhU1lQtBZAkGb8R6NF0/rDoEwEQbLhjd6mn6vVmZit3pfjMAEEQstD3lm2A8AhnNrEKLPdAyCQsF0UNrDwcARAIImSfB9FURh+RdEuBSQNevQfQU/oCbmPcVyNPgaiWvCQkexACwbe/Y43OEHB4O6Z3MHlp4ayuxh6Nv4Cvvr2ww71h78AAAAASUVORK5CYII="

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABIFBMVEUAAABmIhNmIhNmIhNmIhNmIhNmIhNmIhNmIhNmIhPBaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU+dHCZ3IBlsIRWIPSp8IBuSHiKYHSS7ZUt3Lx6NHiCwXERsJhd9NCK2YEiePzOeMC2eKyulUzyURjGZSjWCOCbwmzr/zE3Rekjgi0HFbU3YgkX7qDXslzzkjz/BaU/okz7znzjUfka+GTFmIhPJcUz3pDf/rDPNdkrBZE2/KDfAS0TchkP/ykvAWkm+HjPJdU+uGytxIRfjfkH/tDrkoU7gm07fcz+/NzzGLzXaZz3vn0a/PD7AQUCoGyqjHCj3rD2qTTz/sDb/sjj/tjvgmUy5Gi+CHxyfTjmHHx6zGi2OQS3/xEe+IzXk53jmAAAAE3RSTlMAYL/fgBAAQO9Q37+AYBDvAFBArxa3oAAAA59JREFUeF6k1Fdy2zAQBmA+Sy60T4HOXlXde0vvuf8tAhAkghaHlP8HaXaw8xFaCAxE9ufJGzLbOwjDMAjD41nyxhweCejIByCMc+IHcoxpZVPHYXBw6DKkbngY9lBr1oik1tIsDPZ8+2lkMvvJJGqGJUvaD3wDqoZ2Zkoka1TWJjQPEl+o9WDXqdvEjAm5UqRBQBoAI8SrcVDSgl7KlYPlCai5uZA/VFKMDLSoYl6NhxTFhIT7KuMo0raMRMgoKKm66cqTi7nTDggG6jRyL1TRGAAQYaSfUzpMv3do3eiJXYgCtcrS6q+EpIN9jPAtCGXmuqRaocapsLsm0DhBJhS7Hd1dS4cKJGTYcgZ4agty/7SMd8myzvtTl5X8jJEaaNS1qxmZDshl17ruKro2fy8yDweDmuoQUE/VGjETgDs2fwLjZgFiXBNz/FlrAS4UqRtqJdW34wAuBNQ7w5EMZ+SOmGcCp+9658Pn0xEQUq8qK9cQXkroF4TX/4eSCmNKXOcKQrj5KJxPkOfqdeiVQJEN39PlBorsCj1BK0+7QduTC9O5KLa7QItlUdzozk1RLBc7QLcFz939g1Qe7u9E/Tgdeiy8WU2FVoU/J9tJkHLc/F5MgVYvz/+UlhOg9+dl2QHPZx7pdjT0rSzLcw58+cq/9Jx9/yGlcdDPP9XVO5eyMBAGYLyh1gSCCHEvultvkTRbQrWVdEH8/79jM+MXBhDlfCc0+zbeTh6TN+NRmQTGYQZsOzqE90kagSJwODr4SImVyQ6lcShBh2kpK7usCVeQEqUxKNlbJ1UQ6ORcqLQFhRrqi55DWeOU6FTgABgThOpORc+gTIBTa+wVAtNU4DZsR6jmgfn4kDyELrgEO6jQ4fjdDXlVnexfHkCvwMRa4nEw+W1DzdnSriSyIej7DY6vJYahU0vsyraFE9HN5R7K3nEKbynpeup/EJODUpT0oKOgocEN2ZeFXSKHpX3WgU5YM02wbRr7pbapPYr4ICj5tCsxgUL2Ss8hAe22EzsHHk4hdSJ1quhgrXuq6XfSjzgidBGWZsE5qEOF4f1lIUH3Obx8eVGPp91BFGUnqbS7iJM3oFC1uo2X4DD1IMNQLIfuqOAFAaMQFUtzTfk/iGkLpW4Q/RUxJyhsnFw5QbyBKjdIaaraAaLLz0MHiCQdg+MCYTgHwAWi/H1oMY0z95bTQDNvtZnCWfiev50CWhvIXzvXtNn6BjKZzZ2OtVwZ4xe/Yg1w5nVrhgAAAABJRU5ErkJggg=="

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAjVBMVEUAAACIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyflckTtckTtckTtckTtckTuIyflckTtckTuIyflckTtckTtglkxckTtckTtckTthl1ByrZqFxeuIyflckTuDwuGFxu1yrZptpoJ9u8pnn2tknF+Av9VflUd4tLJqo3Zvqo5imFN6uL51saa9wpxGAAAAHnRSTlMAIGCPv98AUJ/vQK+vQACfIIDvgM/PUK+P32CPv9+zqAeyAAADJUlEQVR4Xr3YaW/iMBAGYJuQC7YFWrr3js/cgf//85YGY0GGsUEr7fupqtRH9sw4Sc0C4YtkmYJLukwWPKPDMiJ5kQJKWuTPQTwpgUiZ8Ieh1foWUNZaBT7y28srDkO/4cWMMeIz9dCcnWMrxGYbh3azTclRXDIOVnX1xL69RyC+h9uoWtzPxzYE5ajGvaDy9pWGdjBPcwGMlO2ceqegAlC0q44FACvm2SCIcNwft/qsipDEKMdFWmvdT70ISQzXB8cetCG69z6HcgzYU7SuKhHM11uIl0DMYSxv2xtoj9v1aD4cRBRIYmDsAAxZJuY2htJ5oB2s1ELUCk4hN8eozqvWOcMEVMK6ScfZXKAVZuTgnNYCnKFpmZOO8uKgNWp877fVOFlUAIqahC9niNPlERcHGhXq5HaCEvrRYeAmB2pJ3ycItUzpS4EkzHIkpvIE+cOBqfYAKBV1UBhx6tWxHyRiyDptTlAKRJQedNfMfOII/nhlnHKa0b06vAWq805lAay56htbUMsRPlWnAJQ99mLeTllfoJ8sucdIQ/S5l2ftMH9b/WJLzCgjqNTuAdAarfVRAVzeLb8ZrnXXCjr2ut49ADRn6Q9DjhGhVDevJX+gKmDYCcdeDWXnR0sjqBORjG5JfvAn+ICgWsTSAQyT01w9liWCRDT1uem1BJ/OwJOQr0yHzjOG4tHKATEonqqqujmUhqGRoFypfVK2DEDjwZ3LqANLltDtN8q94FB8y3yS+WNk8F0+KvIzssXVXjB+5yu2Np0MHZoBUDjL0pktVXTYJXLSjGUFhCNxhQClOEF5BOoQdMRQfoKyMgz1D+yszD6hJAyhkewBJZkg/iRkMcQnKFs/tbUKO+vsDK3CxY4vaOWgyASMsQUV2QXiwcbZG6jBLeMeynYIoD5lDKDsrv853oegJjhD+8xD0c0Z72hiYx7K8oeO26juHI4rKFomQ7Z+hy8QinjjhjudRxCScLlryvFQXGo/HYUdBMXqdBhHrXB9KCjLS3g4ZR66reH7R509j1z77B5aVLmL3x/xIu4U/ImLKDrr1X+9Gvv3yzqcp64P/wLtFwu3y/ZJ/wAAAABJRU5ErkJggg=="

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAclBMVEUAAACIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyflckTtckTuIyflckTtckTuIyflckTtckTtooG6IyflckTtyrZqAv9VtpoJflUeFxu1qo3Z9u8pnn2tknF+DwuF6uL54tLJvqo5imFN1sabrBxDQAAAAFXRSTlMAIGCPv98AUJ/vQK8gn4DvgM/PUO8xKJnKAAAC1klEQVR4Xr2Y647iMAxGGwrTFmaYYWeda++F93/FhQ77qaGN02qlPb+QkA7EdW3HCYPYpfsDPTns0514C5OEvshyOAAd8mybSKQFBShSsVp0PBGgbqhr1TmacDquEr1/GA2NvsondalaqHIRF319Sjk8NZWRHjBRcY6I3n/JO1ci0jdjpU9DEy6CE31/ypESkgmDo26Y/KksLPqSYcqHQknZEziHRB+MR9GD/m7UBPKZKOq50kiFjzNTwnpATfhHsl80JWx8wHXMSDdmla1oHieIvqWsB8uYBqXwvVQEMl8kfks1/uJKKogK4YkuNHJbK7IapstUdCY8lZXYdhImiESxTdT0/aAmh4MoJ9p0tI488r+iI+RmnUiTz/EpOkFkNz0zcPoRCQIxQzk0UlpkJBCjKCVQ8p6BAqSjqCDQxt6TAMVDlNEExT+sINldlHvumgkQhcnvIr8P6qDHOkZ0eEsEAT4nb8Qhkh290NWLNaAhll2S0hztR8rWDXpaiDTZ0xL9S/uoJfHskwMt0vhHUjHRIaFljF/2+5iIQiLXeCKqtoqAKyEC20Sgs2iN/yYiN2aBcd3NrRFxDIGiuFlEVflzvmesXW8MI+JRKETaoMvOQUJyQbcaEbtzrUul5wm5pyjayqF9KcNm9oqkFEffJTVfv1OUEZ5+3qjalzIiKAr6C3M4gVIbgKmbbhprFH+e1so5xvnFPyMGdiawBg0qQ4PkibWoAi07QmxwSzFEMDBts9EYIjDW8FSLIUKnO2HQiqLYefTojX48hum8uTeMxqjqUD4WYj4eA75p+k3h7A/sPGiaYJgP7DjcpiRo51eIkWyjqA9cahCmlaI+cM1alwPQ2Iq5+MVNGm9Gy11F4yaFazt7OY7H6SrRK0PXdZAVseJm+AUCEBe+ANyiKw1wLpg20vNLFh+xGHPneXKxdREFOmQPFlEbV2MQlS1WY/97WQc2rQ//AK55cVyd9o+7AAAAAElFTkSuQmCC"

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAhFBMVEUAAACIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyflckTtckTuIyflckTtckTuIyflckTtckTtckTtckTtckTtckTtckTtckTtzr6CIyfl4tLJckTuAv9V9u8pflUdyrZqFxu2DwuFnn2ttpoJknF9vqo51saZqo3Z6uL5imFP4PR6cAAAAG3RSTlMAIGCPv98AUJ/vQK8gn4DvgM/PUECvj99gv++Sn9noAAADI0lEQVR4Xr3Y23aiMBSAYagK2lJbx47tzM75wMn3f78RQxbLSTaEXvS/71eTsEJINlP+tNnuYGy33TzlBV5WIJX7HQTt9uU6KN8cAOmwyZOh5xeY7eU5Cape6S3RzFH7fBl6f6OuAWgt5/EBHheg6hf1SaXtXbQDoDgnhKuJOuVz0PmNRmq4vTpcND3z0qHEoXeakjCdlBwAjhj0SlfUDnMeQOsd2sGjlH3TEQycFEDvq5yagev4P3ROnhlVU9op8JWPUPWWBsEtbghMHfIH6FeaYyHs5KE1E8QUYYF09FD6wKhxyz41DS5bu/IGgvYe+lj3IIY9j9DvNVAPYS8OqtKVrmsVRMrv0CXZaTSBaJs79JbqWCCURaHDAJ1XTLOlHKKVRZa+9g2AESoO7W/QZyokAGQH8XZFVlHRJUocNLWIlGdf1PSJkFQdpQj0lF2oYYlQ21upEWiT/aEChAeuRANYxLkqwNtmn5Qy7WfJLW4dhxjMtMvu68qcQ5xOog6B2Qbo6objHeAOqPk13BxxaBSIuDk+P07lBym6HlIg0QMoNund+PyBdstQK1gs8z9c8Wlp3YM1TReHNMjXgO/qIbCOXAcZ8Glzg/QAse9ADUwRMQ5IpkKfk/Mwpdofz7RsE5xd9gd54Fa2zS7zjk70N9kX9U9SNLdLW2rVPPSUVXdHIY7bpYn/V3i522oNYBnaMWjpUMs6jc71uPl3CONWv9ZaClpzTYXkDN38z7O/SNVue2CdAqjRVSnHF6QBvF7Kfvp5t4xpeOwFWVwctJDmGpSU4zdAE3tlV8uQamu/ZyvOgRtqdHiIKH4vQNqO21JjjN+NbRsea4qPWUjZxxOAwg9axesMxEVwVkePfkX1F3UIDarxw2hxxJ1IFjkeD53QgSEScmAv8gMiSQTCPiGKEoGaGCQBkI8afJpqDAo/s3z7mKMdIIkIztrIhx8iEf+HrKZTOnQchEv2xtTtuJ/4msDxED5PhhoOLhas2RG/QCgP8Jhmwbx3sxcIvvwEaEqKwVELVxq+42GG4rJfvmTx5XtYbJ//xEVU+tXYz1/W+VZdH/4DXuTZiOh95bgAAAAASUVORK5CYII="

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMMq0ylJAAAAEnRSTlMAIGCPv9//AFCf70CvgBDPMHDw4INlAAACE0lEQVR4AaTS63KtIAwFYC7iIiio7/+yHdmLE5wpW3vMnzJ18+VCzJewzk9hZoTJO4txGAwiCo0+gsS/QdaneRDJ28fQss5fY10eQVYuBYg7/zi5lCj2Hsr9jeAKcB6A4kLv5xvIbn3iXIAGASX33zb7DYqpz7oADeLwLp/jGGLKz/KkHQrxuFcpTCx4BMkn03Goo1AvHcenNPkdEva+q6PQVdo5S7lCvSMFtXCH3yG42jyKqKSQzkf4yxUjCCvziM6ph+K/f4ezsTKGytlcAHDUK/EK2dQKPZhwBLHkow0j2Qu0NQeB+UaQ/oTSRogDehFZIZteOGzOsMQ3IQ1a5pexVIibsXPoTDAeNlvgkHdu3QnZVh6P8Q7i1lma9XhCnse2ROUeKm2VmNtXKLE4NjnhHsLEOzymE4pdO4FrcQtlXVveN5AqapnLE2jRcdSOBKZWId1nPIHQpZRaneFDacHPIB0Cn9C49lC0pztIRyzdEzrjuVvta34G5ZaTW+wNaf7nLxDzsxGjzXKCzyB9F47W8PL/Qzz/dGOHOgCDQBBEDaI5x///LAlZgb32CVI8CFpud8YeJNbfD7rqq7Efkj0R9mjZGGGDTY1aOfzPOKovcbR3j5cBmT3FIpuVCFVrWNFS1Y+VUVWPZWH3CBGomQ2oyX08CrMU+CkUVXCscF0JBKU0lGTx2seLKK/GvKzLaunDBakSiKnQtAbyAAAAAElFTkSuQmCC"

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAUVBMVEUAAABmdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9jcXxcandbaHZjcn1ebHlgbnpfbXllc35hb3tldH5caXdkc33w7yfdAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAACF0lEQVR4Aa2Y4ZLiIBCEIYQWSOKKGvey7/+g5+W4zajXDqnl+2vVV8yMhAbzBtu53qPge9fZA8ccCCF6vOBj2CeyLoGQnK0WDSPeMg5VIhuhEq0umhIqSJMiskdUcrTvRCGhmhS4aALl45Tz6QMPTEwUwT155ckUpejFc77kO5czJKe8cgI1mWfPNRdmCHIB1GSe+jPnb64VIkzPolDqyoIzK00SHkW2zP2SBRfabEGyD6KjKGGDj19wlKIJ/xXd8I7PnD+3NplSGFsR51e+sxVnyuR/IEL8JxpQIM1WSgOGIhpRIONXGf+KLATXzTOjGruKHCSz/GPX4lZRQoFtWp30RxTQgHAXRTQg3kUeKrd5yXmZb6D4g7FQ+VryyvIFijWdvp4lFxa+ps44aMw1fy1nemgsm2gBozceGlkAhjdoI4JBm9Jg5AdBbzY/f438ROnjp+cvEfE/JDl/tdKULZILRVRPYxEpzWMfpNmebRECHX9vHP9xD850fLl76IzlDdyDNQfPR1qPFx9/XaR8/EOL0oI8IHmz1WMzlSNbH7/IuvzItlAgWVdgZayh6GFnlEGLo8evQUY/ih4IowyjFD3rJivj8Q9WNL0G9noRC+y0ONJsfoU4hPrx80uN3iaedSd28SORnGXdSK6i5JJAN22kl2MiIkR6XSelEab2DwjtnzTaP7JUP/s0fYhq/zTW/rGOsOv58DdLBJ2Qg3uwGQAAAABJRU5ErkJggg=="

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAArlBMVEUAAABmdX9mdX9mdX/M1t1mdX/M1t1mdX/M1t3M1t3M1t3M1t1mdX/M1t1mdX/M1t3M1t1mdX9mdX/M1t1mdX/M1t3M1t1mdX9mdX/M1t1mdX/M1t1baHZfbXm4xc1caXeAjZdebHllc35cand5h5HG0di7x89jcn2frLRgbnq/ytGZpq7G0NfCztVjcXyzvsZkc31hb3u5xMtse4VldH5zgYuGk5zL1dyTn6imsrp1cXZMAAAAGnRSTlMAIGCPv9/fv49gIABQn59Q7+9Ar69AgIDPzyJm0o4AAAKjSURBVHjavZiHcuowEEXlUEJs05IAiSTbdNLra/n/H3tGEazMclE0zHA+4Ix315KuJA4QndXOG9Iwfm3WWxdxghEJIO1Yh2X8oJRqtrthoqjWl7t83qk1vVb8Y9HltdzL+EkZrgY/EkUdiZh/qG/asV806kvM58bUG3pE0Q1QkMlyGx8SpexzsKnXxaIRFrzMtJ69rPv0pDYMkahzwKMNa9MftaXtiphnNdElk5V0mWnDTJbccROJyHOvLZkr0hbTpod9JrHTn0xvuQciOVbEcFeU2rq0w2pPaYYvRXSrosjOfeKKJnuabfitiF5cEd1QCQ58/JZHRdxaETWIi6aSQ5/0nOfP1CZBhYEvYtgu/c1LqDhBkw8RzR2Ram9El9LCmo35sKUZBlZE+xgbP+Sfcrj6FkWSoB+bfm3YbiI2opp0ydiPDWsjWkZEexBftJhHV9Rbi1IZDC04WiiCZh+IcmmXoob0Ms0KrYtsKl1eXVEzEZHf81ZoQ/FW/bldYnHm/x7jMaYp6ra6EDWJYXtdBrvdEudeUUGiAorqwt9r7QDH1hTyKBGBRbg0LHrX+j2g2SRaLPN8udiKfumS4PHL0pMbFkDk+yFJtMwNS1Cab4mQKLdsReEcL8KlNWQIsNlNWiKhjCvjr4sayGYAvGjPUDYDwG0kkhJmMw7e2NhW6zmu8VabdIAoePNPQWnBx1HSB80GxyY8IJOaZ/ws66IjO5I+eNblIYJiDQeHHR5rKGhxUPzilQ0o+gFgIJxXZs/CKANm3S+WtG08DhHttnpYCewBIhjYQXGw2fAKYUgDxg8vNaBNIOviaxa+iNIxRVkXX/yQyR6cfNHiqyiZsIjAl2NiBEsj+HX9+AeEEzxphD+yHP/sc8qHKP/T2Kkf64ig58P/PeXdqd0SfKYAAAAASUVORK5CYII="

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAmVBMVEUAAABmdX9mdX/M1t1mdX9mdX/M1t3M1t1mdX/M1t3M1t3M1t1mdX9mdX/M1t3M1t3M1t1mdX/M1t3M1t1mdX9mdX/M1t1mdX/M1t1mdX9mdX/M1t1baHa4xc1caXe+ytJcanfAy9Nlc35fbXljcXzG0di7x89jcn1ebHlgbnrH0tnBzNRkc33CztVhb3vK1NtldH7L1dzG0NfA89GmAAAAGnRSTlMAIGCPv9/fv49gIABQn59Q7+9Ar69AgIDPzyJm0o4AAAJzSURBVHjavZiJVqswEEBDKW1lKbTVqiGh++r23vv/j3sR007inDgB1PsB9zBLhmTYFwS9UT/iilIxGIY3ceKGJQ7STDk05YXBOG8mCkYTblAaFGHsLbq75TalzWzqJQoyzrHIZhzTovsJxyJEMSdEwSPnhEjzEH8lSiecEAFF7hbdc4vtUojl9iLCzF2i7JNH1GxBhHKOReABlqJmaYnOC6lYnJGJOT1/hMYUraTmCUwggvxQoid5ZQV5skQpR+DQztJAR5fboqCuO5XshSla6C6ILZHuQ6L80uLSmVoECXoV4pVjKJFOE4PAhKKJ6K00g2NQ+aYi6MuL6I5zIjRXsjVTLbrlBM7ya2YfooBTWI0NrQ3EtWhEi3Brr0qTsBZNCI3z0ALFuyjltIgkV6LsO0RjJYo4Yr2phKg2a3/RIGEB9jxXoqZ6BhFFzHr4e5RHm9beohuGi78RVzbeopD1kagCUeUtGrIIj1gDb9GA8U4iAEREaLQIhmqrZL9I+aJFMObblF8qtAh+PERDUiJIL3FEqNBA1PbQotA6iSKUbIRfQ/ZR+VuJhujQkqLdXsr9Dh/aXkPRTtbs0BgJGor2smaPBlsSNRL9lRo0apOsmwiGf/odoeXOH+ThKBTHg1+yC/TLRnP75FX+0HWJONkjqaSIHdeagzA40KIZXLRsjqboSIumcPWzERakaGxcRruIiti6HrtFa0I0Rxf2dl/0gJ4QLZKNnxBJ2rb8OXpmocaG1iYT5H74nax/Lfx2UOWppyg+tFKBPdTjGEAi5CGe64A7tPmPLRC6rzS6L1m6r31+cxFFr8Z+e1kHXNeH/zzWh/8BD1Pb/n8AvGYAAAAASUVORK5CYII="

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAt1BMVEUAAABmdX9mdX9mdX/M1t1mdX/M1t3M1t3M1t3M1t3M1t3M1t1mdX9mdX9mdX/M1t3M1t3M1t1mdX9mdX/M1t1mdX9mdX9mdX/M1t3M1t1mdX9mdX/M1t1mdX+4xc1baHa5xs7Ay9OsuMDH0tm+ytK/ytGZpq5se4XK1Nu7x8+Gk5xjcXxcanfBzNSTn6jL1dzI09rG0dhhb3uAjZfCztWzvsZldH6msrqfrLTG0Nd5h5FzgYuMmaKn44jAAAAAHHRSTlMAIFCAr7/fv49gIAAwj9+fUO+fr0AQcO+Az89gKIOLSwAAAqxJREFUeNq9mNly4jAQRWVW4wSMGRJgRpJtIOwh++z//11jGw0t0Wkauyo5r6465W5tVxJn8Gr1L031907mtNp+J7iiEdSH625PZWwyDdAK++VEXr2wqOVUnhL5wcUib6AObH7J92gMLxLdDJRhLynCgBfdjpThh6SJxozIayrOY5gE50S1EecBoj4tulXK7s/TWuv1E60aU6IBeF5yjy44YwpPRNizzMd9rQvW0mY21xnzGTIJywPk8/BBG2xPqg33pyYB/QE2khDd6yMp9MkR1ZRb2LulzbSFqa7viryRAhayADd7bovmZhYEjuirAv6YFYaHXwNQ8sQW1XPBcxw/q4yfEkGKoE0CCoszoEO8aCXt4oQZeRDtZck/kuF/0bVSVml3WEA22zA0ooGy+C0R9PAbGgeRBxa61TCxYWoDQSHqgoWqDE/tVNr4hWjEVEYuWiDKRTVls5eV6GeigSOaVhOFmajniJzZuEoTrZN0xYtaV8Ids6W0eEx0QfLImwLxzRG92P+TaEPC/1NHdMlep/YuxuGLpiNaSCABUcKK2qJHDdqDtuC7LZTDGyViQSKmNEa03cXxbguiEs1+1fr1KNrGBVsjKjX8OuMo2h1EOxARE5IRfY8NIEJLhCsNi6qBS6su6jnNnlb1tETTGf5FVVEbLVoGKsf5aBthoHJcB29sNDjsAAHeamlQ/AJaePOvJgrxcVSttD5xQKKjkGl2RBzZKL9yw+8TIQLlV46AiDUowDA0IGg5teFIxTCE6GexJ0IeTeiGUYjrJUVR4MZjaDeRXynGdGAv9UeTM1cI1GymMPpSc9Hw40sNatMG5VeSMXvxg/xqHTuIkL2KokWrMwgPczkGSFF40XUdoEobf8wDQvUnjQ95ZKn+7POZD1H809hnP9YBpZ4P/wGubf56/Cs3FQAAAABJRU5ErkJggg=="

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAUVBMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t24xc3Ay9O5xs6+ytK7x8/H0tnBzNTK1NvCztXG0djI09rL1dyA141DAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAIZSURBVHherZjrkqQgDEaJaAO2Jtq3mdn3f9DtdZmJU6kQpTh/rTpFguIXXAHofD9gZuh9Bxcdpz0IcUDBEMM5EfiECsnDYdF4xSLX8ZAIIppEsEVTwgOkyRDBjBqfd6L7J34zQ0kUku6hDTaloIsm1LnTxh2ZSRMVu0wZ3BH3IuF53OjN7WGL2MQi9jwps1ilsYlF3J+FfniqzZZ9YlHIddGOh779TPgtgrzvN9pxwwMk+CWauaU78AhzFnGDpOiFJT6IPrhNjgs7uaI/9IaLc7zztSKM36IRM6LZdmkbYxZdMaNsv8n1vwhwx5M9Cx4GNpHHPYt8sW38JkrIKB+tRfonCtiA8BZFbEB8iwZswHBxgE0A16HNa1mJ1uWFOp3zaPK10sb6hSre9fZ6Vsqs+pp6Z/d6OfKyDw5NVhatqHJARDsMER8IlkjPA46PqLOlcR4wRFazOQ8YpdnbT5ksqn8hbZH9icjSBqxANntwPVYgt793Xnl4Eu86bbnn6BxoDTwHiKOWMqeP2kusE8nDP7QoLYgfZF2zk/hlV26/5xBhYPzOgWONQTmDXzloGRgZfOToV8AOYVGEUQUjFiYQ8VjBCKqTCOwKRgafxQhRt6IEYqipEwUxZtU1e1IGPxnJy9sftVFUDgnFDB7N4ZhFpQwe7XGdSytk8KnmAkGSQs2VhmSGRpcsra992l9Etb8aa39Zx5y6PvwLJc78T5/NAh0AAAAASUVORK5CYII="

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAt1BMVEUAAADM1t3M1t3M1t1mdX/M1t3M1t1mdX9mdX/M1t1mdX9mdX9mdX9mdX9mdX9mdX9mdX/M1t3M1t3M1t3M1t1mdX/M1t1mdX9mdX/M1t1mdX9mdX9mdX/M1t24xc1baHa5xs7Ay9O/ytHH0tm+ytKsuMCZpq5se4XK1NuGk5y7x89jcXxcandhb3uAjZeTn6jI09rG0NfCztXG0djBzNSmsrqfrLRzgYuzvsaMmaJldH55h5HL1dxwo2C3AAAAHHRSTlMAIGCPv9+/r4BQIABQn9+PMO9Ar58QgO9wz89g1NKcDwAAArFJREFUeF61mIl22jAQRWWWFGwMIaWQtpJs9jXr0v3/v6uxsJAnL4MizuF+wD2eN5I1kjhCVKtfNFXB5LdsfGp14oRHJAztgXFYJmv5Srd3GSaK6n31lvlSGlcr/rDo6rN6j4e13JPGHxJFA8VxJ63qi1807CueF2saXXtE0VcQoMnQiI+J2pAxbxp1eNGQFzxttN48uZwKrjnR4IhHGwrTrTOlVRF4pjP9ymxKRBtt2BSrYAkmKyKeZ10yrop0iVmZEkxGRPMZ6wPPjEitJeTkRLWyLl1h+m5ptDjZoaKo7PusKpph2MqwkI5RTER2HWoCtn/Pw0/p+GZFLiAQrRTDj8Jwk2U3hallRa4w/CLkkNKf7BVXnHCd50XIXUUkUyu6shoIm2ViSzPEpcj+x7D9PH9lhXQviqzFLWxc2hh3ldiI6qrKGBY2W5ujZ0R9RcBN669tVIjaygPbN7JRhO19KHNJ4xZJ0y9YjXOt8/GKrEki6iYi8nvuc23I76umJe2bqPm/x3iMqfpNt0T0XdS9ojEuLUy7Jy68otyJcuVYEFFD+LPWFdi2dYU6VfRLEoQKL40XPWr9GBC2E213WbbbHkT/bPX+9lPRNjNsQeRfkFS0yww7KM2/RagoK7GiAM4ggtKap4rmJOyu3SLhLEj7G6LOzGYecNPWuNnMA/xGImXBAQbhf2zwq/Uc1/yvNhkwouCff5spLfg4SvqesPHYxAMSjmxsP8y6/JEdKQ8w6+IQAWMNgsMOVpbioIXg+IWVXcLox6AJ0LO0MoyGiFZkZCfDaDIMEb2NukUG9gARO7BDcZ6w2SuEoR3QfvZS44kJZt01BIQXP4c9pmDW9Vz8wGQPTti07FUUTCAi+C/HmBOewHBdP+cDQviTxlkfWcKffc7/EBX+NHb+xzok6PnwP/G7BWW451jcAAAAAElFTkSuQmCC"

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAmVBMVEUAAADM1t3M1t3M1t1mdX/M1t1mdX/M1t1mdX9mdX9mdX9mdX/M1t1mdX/M1t1mdX9mdX/M1t1mdX9mdX/M1t3M1t1mdX/M1t1mdX/M1t3M1t1mdX9baHa4xc1caXe+ytJcanfAy9Nlc35fbXljcXzG0di7x89jcn1ebHlgbnrH0tnBzNRhb3tkc33CztXL1dxldH7K1NvG0NezsfW3AAAAGnRSTlMAIGCPv9/fv49gIABQn59Q7+9Ar69AgIDPzyJm0o4AAAJzSURBVHhevZiJcuMgDEBxHKeJj8RJWjfL4dxnjz3+/+PW68URWEOFW0/fB7xBEiAQ+4BgED5EvEJUjIbjSZy4YYmDdBrxBtEwymbdREE45wbCIB/H3qKnR24jbJYLL1Ew5W1EmyymRc9zTotEXhCi4AfnhEizij8SpXNOiIB85hY9c+4SHTZSbg62qnCJptwpOsialikzRchzW6uK9c0SbWTNRjhNrO15UZqtKZIa4TSxVn626s4LKYI8gSjVcSmDmzs0YGaLAl33tSlau5MN5LElavahsnCU32alRZAgLPoNIox4lfIV0sR0YNSKML9kBQTHoPKfFYmsET1pC042HVrNQovgHnOVn2D5XxSABza2tbUFRVyLQm6yxRubFo1r0b1k7kNLkf8TpZxEkMwq0bQPUVaJIn/Rbl9KWe53WDRKWMC9RW+lrCnfsClmA2/RrpSaEq9pwkJv0V7e2eMNwB68RSWISiQasshbJA1wthnvRyRoER0aiN6Veu+ebOi/jeinquhefmgJhIjakNCkiNDoIyI1HZMN9CnCoUWfEqFkj/yOCAKVf4gP7fGk1OlIifChHbQ9qubYUTRBF9tJ1Zw6imJ01SpNN9EILn9KRF/+aR+hzaBBksk+X2TF5exskEnoVf4ruq9Ry6Ybkn0ZXV2PiOSRFp2lAYpuCQ8tSnQxRZe2aAFPP0okLVDt4THaTbRDL214Hn9hRQV6sH9OtMJfiO7Jxl+IJO1efvypIdMEGxtt7cL58QOgTVl99kp8/JAJGqf70GbE5xiJHGT0dx2HhhFF7wOE/kca/Q9Z/Mc+3zmIokdj3z2sA5rx4R+f8eFfrKvbI3uQ42QAAAAASUVORK5CYII="

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAArlBMVEUAAADM1t3M1t1mdX9mdX9mdX/M1t3M1t3M1t1mdX9mdX9mdX9mdX9mdX/M1t3M1t1mdX/M1t1mdX9mdX/M1t3M1t1mdX/M1t1mdX/M1t1mdX/M1t1baHZfbXm4xc1caXdebHmAjZemsrpcandlc355h5HG0di7x8+5xMtldH6/ytFgbnpjcXzCztVjcn2zvsafrLRkc31se4XG0Ndhb3tzgYuZpq6Tn6iGk5zL1dzxW4F5AAAAGnRSTlMAIGCPv9/fv49gIABQn59Q7+9Ar69AgIDPzyJm0o4AAAKiSURBVHhevZjpcuowDEYdwpomEKCl1HYS1qX7fpf3f7FLgkE2qhDJzOX8ZeYMkmzns8UJvFq71XydyoJG3e8EVzSC+qHXbSqlHnIN0IjCciKv3Vc5bx/ymNgPzhbdXKuCz6IqzHBwlsjrqh2bpaSIAl502997PiRNPGJE3p3iPIZxcErU63MeIA5p0a3a85n352mu9fyJVo0oUVcd+JN7dMEJU3Qkwp43uWWuC+aO4GWSyycvyCR+8jzkDbrXBtuTaMPjsUlAf4CpJESP+kACfXJENQXMZAEu7UVbmOpCV+T1FfAtC3CzJ7ZoYlZB4IjuFPBLGtD4NQAlj40IGvScps/whwBGZNokoLB0C3SIFy2kXZwwkwfR8lwRrMu96EYpKG2DBXSzDQMjulYWv7GAHr9huBN5YKFbDQsbljYQFKI2WKjK8NJOpI1fiPoKLSIE3rQOcS7qKZuprES4FXUdkaxGtBU1bc+rI1gkmdZZsuBFjSvhzMxd1u+ZLsjeeVMgaorq9SLThoz/Tx3RJnud2KcYhy9apCgDUcaK6qJJDe1eW/DdFqqSCINETGmMaLVO0/UKRCWa/aX110G0Sgu2Jll6/HrLQbTeidYgIhYkI/qbGkCEtghTGhZVBJdWGdFEza5EQ7Sc8U+riupo0zJQOc5HxwgDleM6+GCjwWEHCPBRS4PiF9BAh39FUYQ/R9VKC4kPJMqvTLNj4pON8is3fp8IESi/cgRErEEBhmEIQQvYkJGKZgDRz2JJhDyayA6jwKysKA6ceAx8E/mVYkQG9nKljU9cIc5uNr5COBtlVmb8IXPNQvmVYMRe/CC/Wp8dRMRdRfGmzZ2Eh7kcA6QoOuu6DlCljf7PA0L1J40LPLKUefa55EMU/zR26cc6oNTz4T+PMN2qcIvbmAAAAABJRU5ErkJggg=="

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAZlBMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3CztXF0NfI09q4xc3Dz9a5xs7K1Nu9ydHAy9PL1dzH0tm7x8/G0di8yNDBzNS+ytIjMhpLAAAAEXRSTlMAQBAAgK9Qn2DvMM8gv3CP338PSWYAAAH3SURBVHjardYJsqsgEIXhoIiIEjmaOXfc/ybvi0XSPsGK2vwL+IqpLXeMRJZTu3x7skgEKZRpIAHoVFBlEkGoU0GQqSA0qSCbCoJIBdlUEAQX2nuo4EISvoYJtfBJJmThc0yoxjPDg/BKsiBDkGVBGhQLakEJDlSD2jOgDKNaBqQwyjKgEqMcA3IYtx0ySAS1qaAqEaTxf82O8wk5nc8/zBUJADgc/9VzIP+IugfUsaAGrxV9sCCLof7z3LFGRGBasQ1yASQ3QRJBagtkENZsgWoEuXwD1CKs3ABpRFLrIVMhUkYQyynztVBWI5YiaIVz6a7X29fkztZBph5Gfuj7TpBcCZmKnLFUZesg/XAux1cdLYigxe+wI+hMC1oBGX9d1yPl96bzFZAEQujiP2nLIeHw7DaCMGQWQ40F9UXOr/8xWgiJEkPh3g7+p38RpC0m3b+90wOAy5ZApq0Qdu8+H/sa1lOZ/B2UqdLhbeREIaHb55D3XXfAbDofQ0Iq8UzK0rrpyfbvHA9lBeY60cMLovOhrZWgYld9QiRHDp2RrlZDRZaHkB/JsG52a3sCCKKpjD++H0yzJo9BNFGhdPq9fQSnrAPEQz5hsaBKZvkcRFSBNzliYhDVSIf5CjWnEEQZaRHJlYoW8waixL4djYotpGpmAYIS9Qd2OY1RgjfFmwAAAABJRU5ErkJggg=="

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAjVBMVEUAAABmdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9baHZYY2pQWl9PWF1VX2ZTXWNbZ25jcXtlc31ebHlicHlfbXlZZWxcanddanJjcn1gbndgbnpjcXxhb3tYZHBSXGFVYGpSXGNldH5ZZXFRW2JXYm1QWV9UXmZlc35icHtHQJ/kAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAKLSURBVHherZjnkqswDEZtmu0AMp3UsuX28v6Pd7PcrIYgRAvnpzNziO1EfJIYQDqu58Md33MdGfCIgEFpHwi+VvNE0jXAYFw5WbQJYZBwM0kkNYyi5bgoMjABE42IZAwcL0drjy+oiuWQSBneYxvQBEbxogjgvLU3tmciOtqGIyAQcSINcLV39tDB3oEWuitCz94iV07EmETbc7YtzszWGJNonQ9s26Lt0GEjUVek8ByQwetH1KNIGir6A1Mw8kEUAxXBNOK2KIIFoldrXwGPSeDGmMNm+fb5MCNRpKGBXP80EehP0QY/vFpkD1O3BrC5i0JA9uSHPYXwv0gCQv60E5GNyIWncRuRgacxHyIFhCpJsyxNKnadoG4iTTy7NGtId2PriL6JfPLcxtOYqpF1xA+EJPYkQ5KxdUQKh4jSDEnH1hFH0MvPWlTMOhG5whsUwVSRJ/x1tuYLWOewAUULrx8RWBBm/SBpHhBYomb9RWgeoCIeNg+Qrc3F3iGHvaZo+dZ8WAA9bF94sAB6/Z5wYRVc4cAqOELCKkgstc/h9xX//FDBINUh7yv+qqewFacaGOpT0VPYFL4gW1d5yD4oyguR1ZeyaD489L0gA7cTNusC606elOXpcuNUlkmO9aioe1/Zsht/6zwb5Ovf/hARhCSQl0OeLyQ8hRi0uiLY5ezX+U7j0wajX0+yby6H8ONnTzDUD2GUJvtLkj5afv1+I1H1MYwGEZPsL2X+njW85+UbE54jGth5BvqCmLQQ80RMCxGopSJF2yyegb4g6mn8+FDO9wWaaUWZNoHtCzTTHDMiti/QbLvObI3pC6IlAwSKUUtGGpRYrjRkWX3ss/4gav3R2PrDOmTW+PAfnA8JN58NLQQAAAAASUVORK5CYII="

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAolBMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t2mtb+ZqrWZqrWZqrWZqrWZqrWZqrWZqrXF0NjM1t24xc2ZqrWcrbizwMmmtb+/y9O2w8yjsr3J09vG0djBzNS7x8/Ay9PH0tm+ytLCztWvvcehsbu8yNHL1dyltL6puMGwvsefsLqsu8S5xs7K1Nt8mthUAAAAGnRSTlMAIL+AYABA359Q748Qz3CvMEAQ359gQDDv72MB/18AAAItSURBVHhetdiHmpwgEMDxxQainqaWAd3erqW//6vFbHF00YSZS/4P8Psoeycw80wEQRiJeLpZ7FkCbVKlXAiL4JTOBA/CFFxS4mVQLgEpBoQl0KVDBoQpwArxAijXgOmUD8Uh9AtZEA4JUzwIh4QSG8rBlRAib9y9Mfe4TjwohTbTBpdSJhTrG0gLJqRwaucKJhTBbSEPEg6kBQuKpSMpHhSAU8KCQhdSLOgO3AQHSsAt+1eQZkNNbW3doJQyoZU9tcLl5kGNvdSNSTIgBVBfoRr3jfO3trZdHRQRobyEcSijQXcaAEanFlCgRMI5d7FBziizuobbj3lDeYEO/iAZUABuLAj+M7TZGbPbUKBy3DGnNgRI6DFod4Z2BCiuCtd5NpcQ8inS05CkndjU5NQC4kFrcrEzGhRObn/EO4y6CRKUOQDvX+2rxXoKUhTo9Rtrv80fmubH4qlpWwDzc/TWDlsyP5Dvbpz5mvfJfj9k6iXzEPHhY59Zfd/2nTL2hqpPy4f5vLb28fHzl6+mbc86aFUafncwvQ6Mo19yduDYh47kwyieiM0g6vE4VzAOEQ/siYQJ6CflCoHDcSHCpSYPNSrOYntfs8SAcbff8+KXluC2R2frcxWtohIHM7hUba/OHp0xqErSMAs6BJcYZ3dap+PhL9f1FI1xyPsBQRSAuVOjPGngVrnRHlmEmgQ8nn1IVJl4P0SJTLsA82ksVdJBuI91IsqCTpNB9sfnw18OO/Vta1F3OwAAAABJRU5ErkJggg=="

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAqFBMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t2mtb+ZqrWZqrWZqrWmtb+ZqrWZqrWZqrWZqrWZqrXF0NjM1t24xc2zwMmcrbiZqrW2w8y/y9Omtb+jsr3BzNTG0di7x8/Ay9PH0tm+ytLCztWhsbuvvcfK1NvL1dywvsepuMGltL6su8TJ09ufsLq8yNG5xs45xAXSAAAAHHRSTlMAIGCAvwBQn99Aj+8wEM+vcEAA3xAAn2BA7zDvMr76zQAAAjhJREFUeF6t2ImSnCAQgOFBRVR03EyyORt17mN3cx/v/2axrBlbB0nRbf4H+EpALWDxj0QQRpGQfi2ko1gl0JbKWZDINHQFcg6UK7im5AxI9AwkxQwo1NCXSjYkloApyYZiDZgu2FAIw0LJhdTI0QUXUsB+IIRsBwoWhPPzZMwTLhkdiq/OF9MGbTEPEvoO0pIHLQHGQ1M8KIT7Ag6EA8MEC1KWk0gOlIJVxIJKGwo5kAC7Bw6UgV3KgfR/gmIEqrpp6ooL4drvmq4dE0r652muVSwI16y+QTWAokNBDzV9rG8tm4agLIhQNDm0Nv1AgxKYmuyuJKVAAPby95UFB8IXElsWNMhdxITsKNDhaMzxMB86mK5pqSRAR9N1nHK0IEDmGtgtc8IL6YZ0QPpEnENTBe2jdU42caMVOJc/5PzYMP5mNHFKGevnb/dz8+rRv8VjDNimavu9+VNVL9tfTfP6zcq7xWqlEVo3496SoGwwmu2d9I4CCRi0rsfSewK0KofS/sduCH34SIBSwE6m7eu378/PTVNvty/rTzlr63c2g84drXPOZvQyhC7QpVPG9tiMuvEBbcNuQ5/xj0I5QtgQ9CUp8VBjQ/hQlGOWPdmYDgvCwc9a/jEl/I+ie3ROYFfG3ofj083Zjw5efboMcr/j+rmbp8sZ7s+UmI6yME5zzwsEB4Ra7HulMTU0bCkIlyzudEi59nGnhNdFVFp6MMSrMTudCfplnVWiPF5IOxFkUa8lURYI6e4vYmoRfyCWQh8AAAAASUVORK5CYII="

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAh1BMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t24xc2su8Scrbimtb+jsr3J09uzwMnG0diZqrXCztbH0tmvvce+ytK5xs7Ay9O7x8+/y9PCztXBzNSwvsefsLrEz9ehsbupuMGywMmfr7qbrLeltL7K1NvL1dwOlzs6AAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAKISURBVHhexZjZlqMgEIbBDYhauJs9vcy6vP/zTdpJgyksQ9ueM98lF98JhSnqh83AgzCK4UYchQFPaFhCIGQMDrEUHxPxUAGBCrm3aJPCLOnGS8QlPETyx6JMgQcqeyDiOVB0Z63PnVHlfE4kFO3RA9akBC3KAHYHfeWwA8xZD5zBklEiCfCsb5wAoW/ACIlE1nPShmdKRJjY2LPTI3bE1ggTG9UHDmPRgSz2mAyLhKmDgTh+hLgXceWKfoMPit+JcnBF4Ec+FmWwQPSk9ZMtEzMbI4pN8ue9joobkYQBdPy+IpDvog2882w9J/DdGsDmJkrBcEIfth/pPxEHA/rTesMHUQifJhxECj6NehMJcOiKsu/LoqPXMeIqkoDZlv1AuSXXMfIqigHRDZ7B1JHriDhhHDBFbyjIdQxnAWBKKyrJdUzAQsD0I8h1TMiidUQRi9fZWsxgnWIDEvkePyGyDcH/g8QXArMtyv8vgq8oUkRDX5p2awvQN1Cx/5cIby2GReBixyyCReDjj1gIqxCyAFYhYBxWgaNWu5R4qvlX+w5m6fbVVPMXE42tPjZA0BzricYm7AVpj3Lfv1G3F0fWXNq6f2M/dUEmIfq4mtr0napo2+PlyrFti8r0o7qZvLI5/tybqp/l65fpISJJnYG8nfN8c3JBagYtLIJtRf6c724u2NjRzw0tw+E4/CgmcoG8G0bdyf5SlPeWn79ecC5Aw2iSEZP9pa1e+4HXqn0hckGGBvZ56FyQowjxURERIRKxVCTcmEUzkwuyieBH5w06F0giihIxgcwFkgjHhIjMBZKM68TWiFyQLXlAcFFi2ZMGJuerPrKs/+yz/CFq/aex9R/raD70fPgX9JYOuDBcBpwAAAAASUVORK5CYII="

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAYFBMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz3oyD+yEn1mBT1lBD/zE34pyT8uTn6ri38vT39wUH7tjX6sjH3nxz5qij2mxj+xUWNDs3/AAAAD3RSTlMAMK8AEO+AYL/PQN+fUCABae7rAAACxklEQVR4Xr2Y13KkMBBFR6xATLwK5GD//19uFTAttAKDLK/P2zxwplUdFC7HsCRhfw65/DmCp0DKvyviNoYMADISMB4iEkDObUA2JJ4DIkCUArgyCohCYlcAaYAIUxRsCYhCYvOP8yKGGTEFRCEJzNxOi2709RTQElKG74twB3FHuEjgS8SBiF3vj+c6UzCyb1QxoZpeGqwz+Hzcc7YpugIAEsFnkSmr4h+q0swiLpJJmW+KUiwkOWBqVWygagPkCWVgU/SAZSSNpxpheWyKnqTRbfEFrSbRcztrWJCq+BIlsbCT/mXpZXFIiYlkS0Tl0xUn6KigtkSc4jkZE/dFtDZZnETSyhwRu91EluXQ6qxIaeRZJm43ZkUixZu2OE2DN6mYRS8QYxHACOI1iRh5jAoRKUMiNi8tx0Jt06sByNYVtBKAtuVRYyFfssavFJBbcHD6vwIVrBvSlc8iGuqlU26k9lbSuf+XMpt+5v6/7creinq80W6MbF1HAoChb0AMVjSAILmxfXKxG7MMF0nazEnE7+g9kdMxckPU484dEc9SoNn4pnMa3rM3QJpxEk0awGaoxcJHseLD7yMFvFWXtwYoLJWZPU6lq9lk1sUFvFUXRh3rfNQPg/RGXCeHoXfk1LfskoBE4diKSyJFsCKWxoloaVPOIkVpxt30h0Lp9woyCCpIv0XCoBbxmzYMatr9MXKwyMYbI3uDDaZs9yxtaeAPNn/UUnvqsfLSqKpRUyv7o9Yf/q3BhJZ13SzUtdSYMK0//P3tyJp8yONvR7sbpBqww6A2N8j9LbvbDMp0e1v2/iFC9Rou0Oth1HqHiP1jTVWuXLqs9o81xwetz6aeaD6PD1rxR7/4w+iPH4/jD+xRV4jGv0LEX2r+7zUr/6mLH8vDr6KRl+Po6/qvPyDEP2nEP7LEP/vEP0TFP429fvuxzufc8+FfTvr7FGqIBboAAAAASUVORK5CYII="

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAaVBMVEUAAAD/zE3/zE3/zE3/2YP/2YP/2YP/2YP/zE3/2YP/2YP/2YP/2YP/zE3/zE3/2YP/zE3/2YP/zE3/zE3/2YP/2YP/2YP/zE3/zE3/zE3/zE3/2YP/zE3/2YP/zE3/zE3/zE3/2YP/2YNd0paiAAAAI3RSTlMAj/8AIIBgAHAw7//fEO+vgM8gn7+PEL9AUN9QYECvzzCfcDznMxMAAAKnSURBVHgBzdjZkqowEIBhaJZAmn1LFFzf/yHPJDqpFsVGORfzXTt/dRlp43g8H8APWF5AhVEUi5kEfiTBTBxFoaA8QaQSEbNUUHlhQkUeUGmGiDJdDJWITy+owKoeOhKNcjEk0apnAxlFQ0I1WnIxVONNJJwW7trAifCmWwz1eCMHcdeA40YaJN70i6EQ5yO14Kj5QBjOQ8sjNUDodwPREH2XYmEpcNxIMdIjWQoNNX2Vhgc7emT1sByipXA2kLE3nZB25iFq6NAY3UDE9BMa0ehoh4ao/vfc9jBjHpSIvM9MSBwyG6rgydGGsoNgQk4chWKCF9ogpPuBCxk+vHTM+X1E6RMsKKb1oWZS8Mbe1zkbOk++KoBXKH/Sr0O5TtoTfOZ0rHTzENLHPXyr8HMX2sEmrQsdYRPlQv7/mqgpYIOicaHgvKVzpsc/wdd25Pi3lKb5B3La0qEhpsR0TGhLKXn90CZffIBIiGi/6JAQU2I6JPRl6fh+Q55gpX3+PnSGlSZuZ7crBwq40A5W8V+GhjEquwwR60sqYBWdXmpEzLoyGof7F+ShQ3Q6oWCN4OGPDiZ0QWoUPqxQBCNSF+H1SMX27sA7mZsb1XtIyNHdPznmpiSRoKGOXNM4Zk+HHQ25bDYKqwAGueKOGd5JL0arjsXdZ5sortGKPRFGZX9Nxa8zrEF+5KTXvozC54uWhlWO7COSwCqKDVWwDhtSsE7+eeik1ItbnOZC8EjtAqupis8WWw5UqwPjYD7yebIHomJCmmaawIpRhsKYSKrlQzRjSbMmDJpSXIhmyC+9Qdzt1LpQ4zJOeVtUjraphF3+SvlNQMmnfxZoX5GOCzEOaEjB8ATnila4OdSjddgc6tCK/k5I/qWJaOj6d45/kLcvdzbESjPEchCMf+BGanM8ec5vAAAAAElFTkSuQmCC"

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABBVBMVEUAAAAiZpkiZpkiZpkiZpkiZpkiZpkiZpn0kAz/2YP/rDNXcXYvaZAwbZiRoI7IvInAhi/9pyz/t0f3lxZkc23NiCb8pSlxdmT+qS71kg7+qjE8a4eDmI+Le1M+dJZZg5R1kZHnjRX/zm/7oiT/1n7jy4bx0oSsrovaix74mxu6tYr+1HzWw4f2lROygzj1lBGYfkr5nB3/wFalgEH/rzj/vVH1lRP6niD/w1tLfJX2niL/yGVnipKep41+eFv7vlb8uk/8wl7fmTGai2D9y233mRj6oCLxqDn/sj1Jbn/4qzl1gHP/0XT/xWD5sED+wlv6tUj1mRv3oir8oyfOjCv8x2XVv4ACUXIJAAAAB3RSTlMAYL8AIM/vi50ITwAAAqVJREFUeF7F2PWS5CAQwOHRbSA27u667n7uLu//KBcyxx4bdhqmJlX3e4CvmjT5hxgvnoAtSsSTfrFkMpWGLUunOJTaga3bSflQGiIonYzFIZLisUQ0UCIGEfV/IctqNo8ymZ/TfpYx9ubD5lDd8gEStHeQZaKNINtqZrpElO+zfz03hwr7RSI1LUlMdmmZQfXyLnlUvsKkStUjMIDscpGEmBKT65OurYcKuyTUXp+FHHILGsi+nZBwZzXFmQAO2c2uwiyz7HFZ3y4gkNNwX6hM9TULVakSkgEEciml75VxKizc0uctDFpQv8+hr8OUDggfCINo0J28rKzq/OC+hUEtuurZqXCmNdWpVYOBMKhN//ZyJVX77IleEb8yCnXog3QpL1092ARQyKUPzS+DY6nV9sRACDSjUvfHAjjOHV71fPyEQ2fc6do45FG5wdVhLndy3hsIusevIuHtAw5RvJ740qSOQw7u8KOVAicDONTGnQFjLB9AZQ3k4tC5GKgLGmiIQ2/FQPsaqIE7V/wuBr3DoQuKlxMDFQGFLka481GsjNyikDvS7V4MROoI1B5STYOHgYqwFmrNqLZPjE1XUHkd5LjUoByrkFX2Guh6SE3iv33QLjwJtTxKDaGqtDMVGlLDjvtE2pkCtahpuby0MxWChSn0hcgnUyHHHZlB81P5P1Mhc+pr4ExgDWROzb9x6AiBeB2D7d1xqIBAxhQfyUYg0Y3BSBkwgKChk76TphEEYw30i1hmkDPSjQRmELga6LcpdEE1mUIQPttw5rpjzxOOZwx5VM67BpHTbnfchoNAyEdqABYOtSWnA1tADu6YQ7DAHXNojDvmUAd3cEi9kmPYGoIR4uCQerYb2Kw1jyyOs6GTiOzZJ6qHqMiexqJ8rPOL4vnwD0mYvIdd7LQjAAAAAElFTkSuQmCC"

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA21BMVEUAAADBaU/BaU/BaU9mIRNmIRNmIRPBaU9mIRNmIRPBaU/BaU9mIROyWz7BaU9mIRPBaU++ZktmIRNmIRNmIRPBaU9mIRNmIRNmIRNmIRNmIRPBaU/BaU/BaU/BaU/BaU/BaU/BaU9xKhuURTG2YEi7ZUuCOCalUzx/Mx+MPSV9MyKqV0DAaE3BaU9mIROrUzWxWTy4YEW7Y0i6Yka1XkGuVjiyWz69ZUq3X0OpUjO0XD+vWDqsVTeDNiG6Y0qIPCqfTjl8Mh+lTzGZSjVuJxeOQS2YRiu+ZkxsJhf58gfQAAAAInRSTlMAEHDPACCfQL+A348wz2Dvr3BQr2AA30CPEM8g7zCAn1C/ilQerAAABENJREFUeF6kltlu4zAMRaU4gIEGDVJ0nYnjNO9avGRP93X+/4vGsslSMj1pmuGTQFuHvJc0YPFdyLNTa0/P5OU3IfY/Hk9Lu6nCltPxf4Dimco2EJmaxUeCxlO9cu1A2JWejo8AyVTrfBNErnUqfwqKT7Teblqx1fok/hFIDrTWSwTc3eFpWaUH8nDQJAIOSAKJQIomh4KGCXKsU2eVsk6XRVIyPAzkZOl1M6jM3W2oWTPCtXbyDgDJqePkDUc5XKl16RCqIeWONJLfgWTkOCtbc2qedQlbEzDtjJIcxDlqAaWXjTI4QKML1UUSjINGz6GR0mVKaG0OhnOSYBxwJHMK3UHX4U5OUwau+SQOGtUcVTuhYHS7BrSDgeFDF6N/gdy8sGiBJ6cQNGXuUEC7LqbdoGHDKeCrAosKytr6tN1QdtgFmiQNyH1Yd0qTRaFJWtUvNMlkwkEyQg1YkCwik1AcKo4kAw00OE0WLPECFliCieS3HrRBsdbkwGdzXuCkcScWzfETXXQRt0CR987cs0UhSHmGzb1qUQjqaVRDXRdoKg2hQP2kU/d8kEw6GlqjW+TMuqOlRHqglDdEXodu85ZSAsmEntPdHXpNbu98qlXUEoDS8DEEtU+y3YGVTL9AJ56fW3axE7z1JnGCoCEk8uDVgqSQ1CIokwNpCKCR92bWYW6n+ZlXZ9SAxn6Rgt/rJhe+0nEN6gWyuRKmlRvaq0EzfBK2YKkidWz9Bqlu5ECy1SsGDY1luBOyAt16nmShkEUIWoRiM8+z2wo08KTk3Yvcveq5J3VQgSK6uFGhBdsQtA1NVBsCRxWIKWPT5/Pn2i5FzJSx6fP5c22xgO9jhcpoTTiIBk7aVvCViJT0Z12z3pfLyMdUzGi069b2cVBrR9e0IjMAfQbvcD+4b3QLQAn6hvL5GvFFIiNxQonAYaNavkZ8kShBCyAIXQYgvLM3WZIQQWJVeyB5G5S3R6vQJATlZD/zde8EFl/1BLeI7yPfSG6SeGS/C3z3eJb9WjwK8wrX1DEgBZlXI87NU9AyfXqWgyx9XIEFT+ZcXBjzHv4ucFv5CMJfi3djLkT/ypjnF9yPw0G0Wi/Pxlz1Rf/aGPP2wZ7jNDBgurzix1sFuK5A/RtTxf3Dnh3ek364d7dv+g7067c7/3k6BvS30npZbRgGojDcxZGIQCCIQhJpKbvOpe2QFAot3WiT4Pd/ouJLBzMurvKvxQdaHKTcdk4MPQTlqCvl5YXMP3E5UZdTGCDYQaJU1WIhCxt5rgaGnEUPsdTXHMqgQ0PEDkOAivRb2+RaPKri+a1z0/LxqDCFEDxNSsfTfdyMWMT9dEw0yQcwNGZIlM63Kr9wubqdE4kMMINgIz1YtBDQmHGPMM6AExCULne0goAEVc5ISFL7fy/o9swISLTxS4zfACiDgLDW27+QrV4HoBBibGf8iq/pVt7sGJn3A2+LIKGmvpPjAAAAAElFTkSuQmCC"

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAB3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slWDzbF6AAAAEnRSTlMAQGCAv59wABDf/++vUM8wII/buf9gAAABX0lEQVR42u3VzY6EIBBG0eb3K0EU3v9lZxwNsU3RbSnJbLwrVyciFL7WlDbGLjnjFa70Amk3hLfimC5AKQamaRZDeQxsWgoBnpeSGIJmoUEKNSUth+A4aLwA0cRunRJDmANbISkEw0vDLIVgeSnOUihHscRDSEEs8RB0Q5pIBrWlIoWwvwmsDzUlhZDtbj0qVlQMAcrFhdF/z81XmrVxdsmYpDhojbBl2LHLZTjsRkkValRHsNogx05A/gypw5XSGu9g6DOE6bi2qXVmv0D1DGDNNJyvUA5b25wM/O3OQvza/OYyFZyBSlgz9eMfG+gU5N8Od2IXdgpSe4j7K1ucg+bdtpXAlE9CqBBZzjGQQo0/FsQQ75AcajhdIEu4AdUhiR64ATnk9Q71hDuQA5cccugDOfSBJuoDxYw+UEIfqKAPFKkTpNEJwgM90AM90AM90P9BcXXibSh7+5vPAuheP6qxnBLPYZjXAAAAAElFTkSuQmCC"

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAyVBMVEUAAABmIRNckTtmIRNckTtckTtckTtckTtmIRNmIRNmIRNmIRM+ch1Zjjg+ch0+ch1DdyJmIRNckTtckTs+ch0+ch1mIRNBdSBDdyJZjjhNgixckTtckTs+ch1NgixckTtckTtckTtckTthVCVckTtckTs+ch1ckTtMgCtBdSBNgixNgiw+ch0+ch0+ch0+ch1AdB9NgixViTRckTs+ch1GeiVYjTdThzJJfihWizVHfCZCdiFLgCpajzlRhTBPgy5kPR1EeCNmIRPJtVwlAAAAMHRSTlMAEI8Az5+AUDDvv69gAL8AYN8gQN+fcJ8AnwAQryAgAHAw76+/369grwC/3xAw73ALyrXIAAADEklEQVR42sWXbXeaMBSAKQ30zbkWbbsttlNr67baluQGBAFf+v9/1CgDQkKUiNvZ88FzvMl5zr3JzblqNIJNABN/b8Jo2oARpCB8sMiCDOtQkQ059mGiEyg5OUQ0GnPReNRehBFUQLi1aAICk7YiCySsdiLu4aYWIjwABQO8t8iEAt/zfCgw9xYVCYUBSwnCIqW9RZeEUrqKo9SyWKQfUbxKA+TyyxaMbQtdluNRAOqxnO7nLRjbFjr9zBKHeYVx5up39hY5Y6iRwNjZ94wwAiUI7ycacY9sGumK+KtXMx7pixzu4Q3JTY62yAZOQlzGXJIAx9YW9cqM5oHLMtxgXmbU0z8j55nQOYk9JuARMqfk2dnjsK9FgSi81m/IDqvgrgBWbjXS0Ra9sZJolWRHvop47E1bZJEoy8UjIZSExHMzNfn6SYGhiFlZDgmoyKKW3mFbIKByWjoiEyRoFNGaqVnkgIi/YCkLH0ScRhGGKvOA5WSdzcHNpfVQkcs8iFiFKJgXeaGeVmffeh8wJdnS7c86Ri0y6zIJ15Uj3ZlGQz4xiUWSLOTYU7PojolE9E8LSOG7RtG9K2RDIYcKWbn33yQM6TtG5TDcBMtEaPBlsCmHZm2aGKopRFNCUBLSFNVcMhqmh/Y0MTQ8hDSYZBFWenyPMc9XmvAW0RDqJDHLiBOoM9QW+bFbXnjsa4swEi1LeRwtRReSS+Om4aRov2W8YQo28bJo0ckQ7+ijl1cWeawRL2KvL7ueSOrRRTYZGh5CGkyyaNZnCiLKH79If6YW4R9MQZzwdpL5hVWHjZGigsAvmyFQ1IxwXeQg8F2pKOILfUWkAl0fkMNFlfcaVm5emPt8/ld3hOXL5SL8CBk+JR9QLqnL8i15to9YEFnQGksQwQH8G5EJMmhi2g/r9XvJev1gmxMEMqZ4a9PBuBBY9rTnZMGLd4GL4w+c3tS2CuF4MFW9fvm3yrkoOj8WcbT/91+JoqvjHRi7Ft8l2oqOZNHRX8vov4vk628tOj2res5O24m4iXv0RTJHN+d5M94c7d75Gz4YyulUWfryAAAAAElFTkSuQmCC"

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAbFBMVEUAAABckTtckTtckTtckTtmIRNmIRNmIRNmIRNckTtckTtmIRNmIRNmIRNmIRNmIRNmIRNdiDhckTtckTtckTtckTtckTtckTtckTtckTtckTtckTtmIRNckTtWizVfdTFHfCZAdB8+ch1ajzlL0He5AAAAHHRSTlMAIGCfzwAQgO+PUK8w33C/QM9AAICvv98QMO9wgooNrQAAAeBJREFUeNrF12tvgjAUgGF6mQrqVChQi8fb/v9/3GIWTgulh5Zlvt8M+KRAU2gWjHEh4ZUUnFWhsmoyzSU4Sa4TIKYMjDI5i4Q0MgNK6RioQGZMFbMhXUOwWs+Dzi0Qtec5EIcZcRrKYVY5BQmYmQhA6CRIGeFQkh/qIKpuCiogssIPMRMLGeaFJEQnfZCChNQYYpAUG0ENuF3vz5/uV+9vrBlCJbh9PZ6vHv7fWDmAmlSoQQgHFHFpWOlAtX0q0YCtbYg5gydzz2UW1C2BOguSkH5pIBFisCjWQ3wZxHsoXwblPdQsg5oeMv7biIWPmx7yP1iMOk5A7ggiIfwjBVMQRl8qDQVGSEF0/wL9/YQUyyDRQx1xU4mH0PUQIx4zMS2YtbAFJh45UaW91AZOJGd4Z0HaAEZCbkZbUKXS32uqsiHdQmKt9r776ah3f6XSVkg1/tASKSukqBBCKX6FFP6vWhW7Qqqp7+yyjVkh27KyIWLjiCMgtpIIIRUIGUbu1zRvKKbhOrxfQ0u0U0grUAlBiJUqP91s4nbKVYkIDWHHi9PxI1AWOrh2ofX7oa0LbZOhgwsdkqG9C+2TocugVGg1hFZvGBEBvf3x7za2s9kRECWhEw1hq8/D72T8XIXP/AbXws/NhHxFagAAAABJRU5ErkJggg=="

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA8FBMVEUAAABckTtckTtckTtckTtckTtckTvBaU9ckTtckTs+ch1ckTtckTtckTvZnoI+ch0+ch3ZnoI+ch0+ch0+ch1ckTvBaU8+ch1ckTvZnoI+ch1ckTvBaU/ZnoJckTvZnoI+ch0+ch0+ch1HfCZDdyLRjHE+ch0+ch3TkXVuk0XNhGnBaU/BaU/Xmn7UknfZnoLZnoLZnoLBaU9ckTvZnoJajzk+ch1WizVEeCNGeiVJfijMgGXEcFVAdB91h0BpjD5Pgy7VlHhRhTDSjXKZlFu0fljHdlzDbFKucUvPh2zJel/Ym39NgixYjTeIgETTkXUfCcz7AAAAMnRSTlMAEO+AQGCvv3DfgJ/PMO/f778QUEC/QCBQgJ8gEDCPcL9gMM9gv3DPQN+AgI+/j69AEBQuuRQAAAKZSURBVHhe3ZXXctswEEUJsBarU5ZVbLn3SlLdvff8/99EFAYhlgBJD/SgJOf1Qmew3DuQ8rdTa5X6EeV1Z1OUbzrr5X5EqVXL0swslJJThXHVgXmqqtVP0mJUVUEs9nh9nrJDU6csiD2haLcvYq8RZY09YbgrFFU9b/qjxvbWaPz5OR6N6KVq0x3Q64xItrUdnfS8qpJC2zLs4A+DWyLb2CCS20Gc2YbVTrMgK5JAvsZ0ivEXF9oWEmlUHIgYDCPNcCAMscqpVqiGozc1DXtpKV6BU7lBOr2rK+iBuIjxLAVZ3N9nxksIeDLo9YJsExW5wZy4xKMFc6PNRDYJ7DVdm6Kv1fMFdXqW/jbyFMic8RpRrqmO4tqQPRWmIjWKrHiFBRzkggvxeSsKVCLCWuzRiScHrMcmDRORBfx68EN0MEM0EdIRM1fwY5jpkM49I8K5rq+F07WVdAQVv/l+9f3X75uMQvOoScvB49OLP+Pl6fEgmappHoRBWVRNaYYMTUVTQcUwyr0Qdkk/oYg00MV5V0IYvHu8CLyl3JX4Chk05kQUZMAyUeBrYjHBKSs6ZQKLvh8ibM6jmJeTt18z3iaXpsKZbKGIzAUC02cwQUSmEy4fbDRXhHCaqA0WKhTxZRGuTRDsTJ5ps58nO4IJ0j62kQiKIUMxERppH1vlexEC+N6Jq40MA+WK+PP58CJ57ljPnbyn47PN9jvSomUfsPwfifYf2GY/7EuLzkPAubSoC0VdaVETipqLFx3CZh9Ki45gs4+kRcc+4FhaZEKRuXjRCWz2ibSoEgIqixcVoagoLQoTSIveYbPfpUU+bLYvL0og/yeSoLPoGykfsNkf0qKzEHAmLVoFjSyuKnOYoEeei26FaCrdC+Uf4zd2/oF3rUPLPgAAAABJRU5ErkJggg=="

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAS1BMVEUAAAB3slV3slV3slV3slV3slV3slU+ch0+ch1JfyhJfyh3slV3slV3slV3slV3slV3slV3slV3slVbkjl3slV3slV3slU+ch1bkjkROVrJAAAAFnRSTlMAUJ/fAECPgACfAGC/IM/vEDCvAIBwO6UFVQAAAbBJREFUeF7t2NFywiAQQNEESNRCgFhd/P8vLVOntLLs0qxaX3pfTc4MDO6Iw181Kg05rUbDNxiuSUNJT3JohptmKaSgSsmgGeouKe32RMOeagJUym2H9IOgEaC1tMMb0UB9UHaa2G/rIOdsd7N1G9JXZvFfsl9YaJfSpS1dnQClsHBQyrWhz9f8T9rLIJOzt7YVL83dQo7dbAAawuedOUcMFPEx5SB8GC9CCD/OL00OldjNJpcmh/BLhb0fSrkXQJKl4fnCQxgf8HyRQni+CCE8X6QQni9CCM8XMUSfXh66PtOFUq4HpdzTIfnS8KDvbPZKbHbKbYLsg6CoESRaWjxC7xyV7XvPNQdtbtLAQfjHVGP0l54FHQVLa2bJA7lWOJ83JGS3QGGlIb8FsoaGQP0aCqPhIHALC5Tt96vhoX4pF07VXcQLoWgqyG533KG64Azo3tE7gsGp80Rds4ibUMvp3NcsGqxCyNjqRQR3Ie7SIILKnJRDpVWFe6HSOHsxVBfH09FT3y4OIiJO1guhhy4N9xToH3Jtx22GYlNykYbIrK8Zb4X/sS1n5cL3pF4M0wdPKR0t0hpxjAAAAABJRU5ErkJggg=="

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAulBMVEUAAAB3slX0q7r0q7p3slX0q7r0q7rqWW70q7rqWW70q7p3slV3slX0q7p3slXqWW70q7p3slX0q7rqWW53slX0q7r0q7r0q7rqWW53slV3slV3slV3slV3slV3slV3slV3slV3slXqWW70q7rzo7LqWW7qWW70q7rqWW70q7rqWW70q7r0q7rqWW7ufY/tboHrY3jzprXwjJ7ynKzxkaLsaHzwh5nyl6fzobHrXnPueIvvgpR3slXtc4bEV19gAAAALHRSTlMAIL8AMO8w74AAEN/P358Qz69QUECfIK+/cGCP77+AUBAAIGCfz69wMI/fQAzoZGQAAALWSURBVHhenNbrbpwwEIZhhAULllBQInvzY3tK2mxSvoE9H5L2/m+r7a5SM9j1QJ8LeGU+GUQiergnun8oJUkpeJ7Rb7NnOSR3RpUSuSOUpFCeFUrdfKe/vt2UZWXUvyQqTNeolHqinqfyFiimhgyA/I6YOwOgmRa6BYCvM2JmGYBqUkhXAHAirsMfxZRQgYs9MQdc2PEhi6uWmC0u5uNDBldH1lnhCs3YkMW7M/W84grp2JDBu5/Us0HsSEnsQNhQzxqxIyWRA/ELsIfTjAlZ9KxcqIWTSiG+EL8AO/RYOaQz9OzYRI6RQ0v0rdlETqbFUA1m7yZiHqVQDq51EzG1FHoBt3MTcVYIVeDWbiJuGQ/lGOrcREwdDy0x1LqJOB0NzYHwSCcMNdFQBQRHWsFTREPw7d23iDFCKDzSAZ5UCIVH2v5/iH+TMPXRavhWRB18j8I98r0SvcFnoyGdwXMIXUcY4V0r4Dm66yi8tNJKdA5dRylkMwx1XeASiSGVe6XW27rWgZBc2uyEjgtxtgZz3IIxeuL/UVi2nPLrl6cIw9wqKcQ1wVTaRP5qFz8WHz5++vxlKDcZmOrFP82vzupotWEYBsPozMwoxDMYAiWO7Oi/3yPo/Z9rtMs6Ncqi0O/W6CB8o1BzEsnAG9DlXpmCtS7XzxW5Xj6MEudBblG4Q2iyVirDdnuBLfRB1ip+ICb5jXI4B9UmjzJWCFFUbXQh7oMaSPyAUEU31EOIO4mKGH8QZjGUgXYZoQgNIctzaTSQYlQjniEU2VSChZZBNlVsIU6yrW+g0MQ6BtqTUtTQRNaBgo4kmR4QN7EONHQsFf6BRtp1NORIKdxnZN/RkCeZVaxjIXARm+9YCMinGFrgQZjOOBE+hEqekxhnIMR07GTAh/wvpwoH0i30n9MCfMhfiibAgUxjs05m+JBtLKKjOQAvQQAvvfcb0vsUofIh/669DnWRDrdvRylYTpZv/5gAAAAASUVORK5CYII="

/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABR1BMVEUAAAD0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7rwipz0q7rueoz0q7rqWW7zoLDqWW7qWW7zo7Lzo7LtcITzorL0q7r////zprXqWW7ynKztboHrXnP++vv1sL7vgpTrY3jzobHueIvwjJ7yl6f3wMvwh5n/zE3tc4b97/L62uH85en2tsDxkaL1tsP+9fb50Nj/z1j//PTsaHz/35D/7Lz61d32u8fxjZv3xdD/5qbufY/4y9T+ylT1rLf/2Xr4y9L74OXyl6TrY3f3wcn1rbP1sbv/+en/9d7ueIn/0mP+yFv86u3zoq386u79yW32sabtboD0prT/8tP83cH/4pv6vn3zoq79z4P+1Yf80qf74OT6v4//6bH7zKL1r6ztc4X8xGj7wHbxkqHvg5Lyl6X4t5H+25102ahJAAAAG3RSTlMAEEBwYADPIN+vn1CAv49QMFDv7++vAJ8A34+/iElqAAAELElEQVR4XtWXV4/rNhBGRRXKahvH6RlK7t1bey+33/Tee2///zkEKZkSh3Lu7iIBcp4MwT4YcfhxTOs/gtiO63FcxybeSixvBS4FAOpxxAf3liKfgsDnH0FA/duISAMkgecFIGmQW4hCKAgCKAhvLvLBiH9jkQNGnBuLAjAS3FjUACONG4ughv+/yP93KhqNO52r9O6idjfjDNM7i4aZYPwsIhLFcezYSpSUCsokXQBIlMB2+E8iUhGRNcihjq9nFqZZjkqt71DIWSNKRCiUSFwta6PcMyyy5iZQgpKlKNFzEHnec6pRMJaiCQA0PS/S05MUIhcQyfMviFUZCVF6nnGuRNT8BBCuEJnz2ckE60I0Y99tPxXVhU6rJskWLkgtC0eIThljPfkTMOJyEXpn1CiALS7agnoatuwaCQGhtg6nx0WneVaG3fW25gnJMiK4pisp+qoPALuMM1NZ6bbRChWiNSRK1zPOB2wTAK4Zp9yCIZRZkyJiEzsGA+35m+9zwRnAJvdsqBfmjKBMzBXEitA6TyHngnE2fvrzr8uTtzZF9wrRFHQiS6tm3uXhnAAU3Xr7wULw0cdwtsE+KVqAiK2w6skEOyDo904WS75ljG1L0QAQoVXNWTeP50VfmH5clDjhpvsyK5ikKmpnOYztPdo/e+NeWXRwyHr76XQ6AqMoNiaDCS4XFS63+lBHbNlgOFTfkaJ3q6L3oB7b8iiU2JGih1K00IBaKI9Is1VJ61GWddqwe7H5IRbtnwGkg05nrKet1eSiwoSZ6SLG2KMjuT90j0x/AGbuVT0HXPTYkLZApd82qfpbx1XRMRc9QSEJ7Dz9ar4opuPO+qc99llV9DkXaWmjjo8nrR/FidyeE1H+Y8a+KHu+BJjtd5b5T5I48leO7OjFbLkJvlaeb8r746WXdSz0JCySm51vzOD7gzwfP7BrYRpknM4rr+pY2gNCxXcFPwPA9eHJ8YNffj05ZKwnAzKazNsAlKy+QhAqlkgyhuXpeMq0QYJMFvZA2lWd2WBMnNt7cgDUmyzdo4bFBDiMcy2GLWevX2+yjNePdDKYi7H/2/nv23u7IN9R1qYIa0R4dqciWE/a8thl7OH9wTwFhWMW+Si840zQkTNF5mxYSn7LvCG1vKEx9ofUHoEiMIlsQFSDNcy1bVDYSoQKwjMlSzWtIsQiAohii7/WqK0ICBJFYGBdLMrra2XtEZSJkCgGE9PBYAeazaKJ+D9NXCvCUK+YNDtXY7WP6kQO1OGqrYpxkMiHGhrqYmrAx+1P6guqLylR7ccJwQXhknBGLC2zYaz5bOO+b8WhqLYu/bQp24e7gh83ae7BIs8mevsSdIFTzSL26htkWHMIEooytlJEWtiDTS3yjyKfYg82UR+LEC7NG+Mh8pZS9xlv2b4bx5FnJIpjV1WDRXfnbw3Jk6hxQK92AAAAAElFTkSuQmCC"

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAADhklEQVR4Ae3aPYvUXhTH8RSKygrGRcUtdjbsE7oPbCxsJdipIGPjoqgEFMVGBgvr2P0rpxELCyMii/oHg4gPiJiXkJeQl5CXcP3NMqeYgzNOJnvn3Lte4QNbjBi/3nvmJtEz4dfrA60QclB9OYTgSZO+AIpTgWIqCPdtoF9z5wKI+rw/wed8KEENUYIP3hBRX2BDIAoTQgWKySEGHyhQF9RfdMEDChpD3nzFyQZSI1SQfJhZDseIQ0JI+FbkbAhEkQpQo/w8Hars2JnRYeopwLMlUAfUOL6f3FTvjiztRaCOTYEiUHV88s82DRTt60C0mt4eCv6JQO1JAtFsej+zPEmgtk2BUlBN/H90pW6g1JZzkE/noKY+H1+rE6gCXz6Q/tXDI4muIsnZU/8bTmAW6b/FIPpnkpZbjr2cOyUonXYOL44bqQTfpECZ7jh0BHhzcGHcSJlsIDZ3puXL7PpU55EVW4vDvdvUtpr+m1INvp3YqHUTKxmIrx4jV5FIoOEPxoycRaFEoASUoDqBEolAOShi+DbLJQIVwoHqPLItJAIpiwIpF8gFsi9QblEgkSGdWhQolQgUi8Wp/4wolgjkW3QO8psEsnWbjftsKJW8WY2k4vw4tTWVF4qybzH0v+1IxZ8o3rm1GH1dCI0b0C9nWmp7ez4Crwn6YWIXHs9HiKQnRINn07g2hWsLwWuCfmhKPbq2Ysz55+6l3TgVeKYEyiiS8OqhOD2pSYEiUD33ry8pzKSpzh6aObfbFGdXJB2Iy+nirj4I1Kutjal9c/0XtNTlewNxMvBMCxRARRdJW+7j8pa2OM9nB7YUqSAwLRCJ6UJ5qJ21zYkPhPw/VD2bGwjDtcEzMRDpgOJo6z25sqpenF+nOTXyrUVv3tB8ebraUg8vzvOtxMXgCQZqHonDGWrAzRtB7wxD2Oc1xBEIRGKaSZpVtK1sCkQCyDXGyWkg2xQo6vPZair3MEzJtpRPf67xgViIDDoQAIUqGq4YChNABzIWzvhA4ZDZU0ACIfvLjQpWQNqPEkAIyZDfU0EoF6h5JC6HLiR9ikn6unyOaYgjMqR9+pfWrADfpiHNpVrCsDt2WwORNlQCZx8rAhGfvnEaytiWsj4QF014Jir5qtmXgfjhsfahUCCQtHjI1st4GNlA8hTjSXOBXCAXyAVygVwgF8gFcoFcIBfIBXKBXKCEPbD3TPAbsasJqWYbtMIAAAAASUVORK5CYII="

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABa1BMVEUAAAB3slV3slV3slV3slV3slV3slV3slV3slV3slXTrZ93slX0q7p3slX0q7r0q7r0q7p3slX0q7p3slV3slX0q7p3slX0q7r2sqR3slX0q7r0q7r0q7r0q7r/zE3/zE3/zE3/zE30q7r0q7r/zE3/zE3/zE30q7r0q7r/zE3/zE36vnz0q7rVraF3slW2r4iWsG5/slvdrKfsq7TFrpTNrZrkrK2HsWKesHW9ro6OsWimr3v0q7rqWW7ueIvzprXvgpT/zE2+GTHtboHzobHrXnPwjJ7saHzrY3jynKzwh5nyl6f8xGjxkaL1rbPufY/xorHSUGTZYnbiTWPUOVD5uYrBHTX+yFvnVWrtc4bFK0L3s5/+ylT6vITfcz/BIjrqkKDtman9xmHgdIf7wUvSUTrfb4LJKUD2sab1r6z3tZjfSV/7wHbMLUTcRVvPMUjXPVPaQVfGJTzEITnaZz34t5HCJDP6vn3niUPwy/jLAAAALXRSTlMAQICvv1AQACCf72Bg378gAI/fzzAw749QcM9wQIC/AN9g75/vII8QrzDPcFAe8ILbAAAD7UlEQVR4XrzW127bMBSA4TyAIAUCDBeO1aRyU6ppH+FQe3hm7tG99x6PX0lkKIvksZOb/neGgQ/ksUhr5X/WdxzPdJyHZHVBK6tLsgYuXGUaN4TubETR7c31MtKFVrZxA2hzK6raKp2ODXImuS50/27EurfecUHN7VwHIv1bG9FVD5iDSThEjB7Ar0h0uQ3aemQxZNQLeBQ1TUFfdxFEPKg7iuY6QiQLh0gPWNsn89JbdEkqJBzexTx0oh+Ti0IDrshTii5qIBiHo5bUR6A1mG8qQ2lGKQ3nIUcPWdDq3WUD1VsraNUMmjw9NIB274Xz+BkA5LRuCE2mFrJA7g93/sZ79YJY6TJoTYG2n1fMy1dxHO9CSnmTZZAJqvRxOv35Oy7bh5zyoMnuek5fgVzQthdXncMOdwqQsg0JkoU8HFfj2H1SS08TDo1BybQWQEE9Wz8A2K+hvSFzsgDU3D4O8Z1kI4Dzem/IgngGClEqpBdx1QGfEFIH+9WokFK2pEP+AcklDFIe7ERIBbyuoDfsfKB1BWS0oFEmpIQeV9IppcMA8MgVRNyWlCZUdFhBH6rVBZDmPvsmO8tb0Bp6aCeCOhVDSgqhM7epJyDLBamRzzf4iQ1JyYe5BCSmJBKXx+e4TAMNpfuyhFCJ1h2zIcllKsSyPAT6UkJfVegMgYgHCPSNTVtugkA9UGOH9UAL7YAechQlyAvK+h7/qE9bWDSTnoEesmQm9TPN7x3MQj9JklA5LgR7IMOMKgWA5oojot5saj4OefpDGwwFkM2SRsLPv4FfI82lGEzGOVcD/ELikN2ac+MknF6yOUd/1U6EI+4gzUMonX0dFGTNnS1BiXZjFgJBKDsgpp9ir7gCUv+PipFm/DuKY5cOCsEoDGeSzBrKzoBoXiLwcvXxtk0Ad9BHXmuwAvXycJEXrSX50rQxiB9avDSTZ2T+K5VeeiKEoSgAW8GeQWRBICToThezogOUGR5qYuIjuvL//xvlMekD7ozEs73ly+G2jLHL37hTgAsA2N6f29IgfaqbzISRYIKgtkR1enn9/tDknQn5PeT3Fa+f1iU3HBc95PVkUa5ypOEkmwHaiPVSZf3YACEcpb0FHE5Ate6EmCAejHBjfFrWtNTqjoMjhPhoN9VkyX0jxI5yDoXmRFxB8LVBl+f5eLAgKsnOchSEUCylk390FARvWSrnTlbbjoJoqWjt9TzqYw8wIVoSdSUpRqSYQ7SUbG8ebvvVZG1nMAHDMoRUAfazjZPZwOOgIDB13F6DLUUMoCFwx3aixZHrAych4CowHEfrz7xktMMYICEVX1FJCjOcMRuhISAO3aF/ykGFhv6fH5rih5dpsusVAAAAAElFTkSuQmCC"

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAilBMVEUAAAA+ch0+ch3/rDM+ch0+ch0+ch0+ch0+ch0+ch0+ch0+ch0+ch0+ch0+ch0+ch0+ch3/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDPDmixKdh56hCTzqDI+ch3/rDNzJwB8LwP2pDDCch3TgiOfURCoWROwYRbXUgt2AAAAIHRSTlMAgN+vMACPz+8gn3BQQBBgv99gABDvn1C/j0CAIM8wcCTwf+8AAAKBSURBVHhe5NdLjoQgEIDhTjyBoqDy6FUBPvr+15ue6enEShUCLjqTzL9z8yWKBXo7SbfQOPEbumC6iWQTfKd/GGfh2WCuQAZeWSeEhlfyCiTh3WThnamHDHDJekgCmymGzF2reXYG+GQ/z/NdqyzUQVm2P4cMlCbPoXsxNJxDGoo7h1SxY8+huRgaPwQ5wMVlC/5Z2JaIoaZm+ePuD+2xePmNRM4aPCqsR6ntCMQz8PCkBxCKQhMQJydB6yikAbd6thVLQ0+gFjsx8FCIWOoIBLjdJ9oxpAnUICf6ZBFBjkAOQUsaWvjX8sYP/paGNvysKSTsAQppKBwgJTBEb86fhG6Mg8RUC/UJyNZCioc01EJDz0EO6h92w0H2wvKDopCueyHzQ5sfkU8PbX4byQ3tcGVjk4JA/Jad37QxRCleelCGQpSixxFhUpDoiw/IKXP2Fx/Z49/7Gvm3n37ClkIqA/VyADuOjQS+dhrHcQCriv9FWh7qEIChr1LqZrd1EAjDcE2ZeAAzuEl7Nkeq8vP1/m+x6ij2NBGjxsq7wgsefWwcGnXa9wd1kRaIXoiALvX24CBpAVCIAXCe3EnH0/niDpqyXldohoZ512qtcjfpcgZwOt4Pklpr261XFRqwZqQQ6T/z9QTt/HH9H4pdtwaFKnrlRO/7/5+HBdePQ8roVRUiRp/SVy7Qz1n6DJgUoox+Y7yF4oh++QolOHH8DUWGU1LInwSMYpCMcActUGI4DQYNcOK0QlTgxLJAwnAqZJD/uGIH/2EG+dJsB88xyKStmWMQTQGbCxMZtCZlIxWK0A1kxWFmPBTPQzTFIL8FoE6boAAtPA01aO1piAoDXOivvgHB1C3z7GJBIwAAAABJRU5ErkJggg=="

/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA+VBMVEUAAAB3slV3slXh6O13slXh6O13slV3slXh6O3M1t3M1t13slV3slV3slV3slV3slXM1t13slV3slV3slV3slXM1t3M1t13slXh6O3M1t3M1t3M1t3h6O3M1t3M1t3h6O3M1t3h6O3M1t3N197h6O3h6O3e5evM1t3h6O3h6O3M1t3h6O3N197h6O3M1t3M1t3h6O3h6O3M1t3h6O3Z4efst27woTb0kAztnTPjr2fj3dHg5+zP0tDX3+Xd5erQ2eDRzcN3slXe5uvR2+Hc5OnU3ePa4ujN197T3OLa5eSCt2bh4d5+tV+fxo7V3uTi49/P2N/a3Nm8z8QVU22TAAAAMnRSTlMAcL+PIABQn7+PIAAQz69AEIDf7zCf32BA789g7wBwgK/PUABgr8+/n3BAEO8ggDDfUOmkfvEAAAL1SURBVHhelNbZjqJAFIBhE1IJjTfclAFx7dFBZVD7FJu7vffsy/s/zDgS2zrUMsV/ycWXAzlANZRNbdu2YnLtlobhjdNV1FBcj4bs3NgrFXfegn/5i5rQhF1ajiIyo3DJd2pBMePqtIGL1oIsxgd8vlsDijpqCIIa0IhpoHYNaKiDYGEMeUwL3RhDEz306YOkhnDFDdqJFvq1tz0i1CC4GfUBINFAh025pTrI7bWgLFFCz5sS71ixElpwG5wooB3nTyIFVDpYwtArnnQYSaEAQCG9O3uG60uhAUikdZrlp4rVEeDwwCrZUigEUUrz91ZvGyZkBsHvLOfKfjKziXpVZ1vkuV6ypJBbhVZ5pbQKxVKIUOwcc6E1dsaqhRQH0o/kIUi1kVCIUIacJcGQaiVzSQgaKSHi/w/iV7ITqSH0zZdBAPD4+LbbJU9PmzFRQiNmAF1zlZ/aIYIy0SkQ1FNBHkOlIrRCUEsFTTC0FqEjoG7lUMwqpeJAuIEc6lehrwV2ii1UcqSQXYUO20LvwNwIesbvW7p/FaCBCfSj/ASszlNl6Zqx/aEKUSk0RU4C1y72pioFCJLu4wtwodvl8l05FF0XCT8PdMPKPeKLrfK1fUAOyG85XOiONdFoKT4LxvdyHtanJYMhnGcjB0PlbYeBa3LQcn0txD46pic2qofuiKQGkTTTQktiDJGWDprWgOYaqBPVgBwNNCGGkHhW+vOZh2JjCP+9ffrl/tv3JRrICMI/3VbP7d6fanpjdGw0h4hDw5DOuqfOULMZWzaz+8gRIH1/2yeDHYZBEAxPQsphKGk14Xl8/5damk4z20Tokt32HziA+UThP0CWHvaRr0CaYn0LKMgIkkDQqjHpDMR1VCZpIKF8KvKsI6pnAe4R4VKg6dMwX0i5hzGN88/W6pRaUyMfh+zxk49jgxhsDrABcvZE3s1eh9tb6Fr9FimxcxLvkVNPxHLLa3qgNm0W0e3A6G3TooSlfHqtLEHwt+7/g9Z9c0y9AJ/knPgutIyOAAAAAElFTkSuQmCC"

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 683 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAnFBMVEUAAAB3slV3slX/zE13slV3slV3slV3slV3slV3slX/zE3/zE3/zE13slX/zE13slV3slV3slV3slV3slX/zE3/zE3/zE3/zE3/zE13slV3slWKtlT/zE3/zE3/zE3/zE3/zE3JwlD/zE2ZuVN3slX/zE2ItVT3yk6AtFXMwlDmx0/dxk+Rt1TEwVGZuVOzvVLuyU6qvFKiulO7v1HaurtbAAAAJHRSTlMAEGCfv3AAgO8wYO8Az3BQj5+vIM8QrzCP30BwIFCAQN/vv0Dp2gKEAAADCUlEQVR4XsXW23riIBAAYEFCiBqjwbRL1q27LunxsKf3f7ctMDDRzzaBXHQu7cdfmBmGzD4jmsX8eFw3q4sxW42Om2VnYnm9okJQfhYzPjKudx3E8qvWWqRC35adjwc9AVp0p45OO1rfebwHJwW6Xl5wEqAGnTvrbHgadETn2ThbngatMUF/jFPzNGiPzotxSpIIXQXnyTiC8DRof5bogidCXwL0CoVPhL575x8ULBaCG74/SVBJoiEi3MU8+ATdmkQXPBqi+hT6ZTaU8XiohIQA9ISdeJgfrw6jJ6Q0C6W5rw669R20d/dlMRbKTGa5CaxY1ZsDy2YkVLqMQGP/hoOB47dEciHoxzki7mQmFtCKQp7Mk/lq1Srz88dQ9eYoP4xcpvM3Z9eFOJKN1sPQpje9brpbYOcdxmNpnaGjlb1b1fwwK1qYSxAP99ap5UAfuRRBmFSw0AhYRS2qoYYs+oenMDx2Z4NSM8IvQyRjWxrWsv6Gtv2D3b1qyP5lqFDh3+SQa49qCZXHBwCzfA4Rk2Do59q3I25oceYU/CIEu/BbZrZMNirI+27AQUiY3ZRumcLZzFy6Gpy3MN8+ggSRwq4znHMk9NAB6wXORQhHa2YXIrSFpl70HEEGBxv0tAo3jQho8RvXz5ifQajSLhgOXOKf7Sd0hiGu+lDtX6BD+KLJ2laOgmgPkuFpbVzhIVgxAuIKoQzH0q77C8pAH2HkCJV4VdYvuh9sBESEhfBkNn6ioeDnIYhTARDFkxGogcoIbnQI4i1ANS7YWkZkOGViIBHubmWZnODfVQRkPIFpE+RkEkdAeXjuGVzdRIj58Ubx2xonRQTkq0wEjg6cFGOhkhf+APXFvhkDEUOEIrdwsDgIk2mf7RxaUZEJEHOfRDlULAlSZq2wmZECmiAFcptxua7h0ygd2trStfDSJUI5vADMkopPgFzk9nxVOlR5yG0rHWoBqqH0yRABCEZlOsQ1RjsJYsFhfBJUB6iaBuXeUXwaVHkomwhJD8mJEBdQfz4VosIGnQhhfAL0Hx4aAv9+FefPAAAAAElFTkSuQmCC"

/***/ }),
/* 684 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABZVBMVEUAAAB3slV3slV3slWm04igYlN3slWgYlOgYlOm04im04h3slV3slVckTt3slV3slWgYlOgYlNckTugYlOm04im04im04igYlOm04igYlOm04h3slWm04h3slWgYlN3slVckTtckTugYlN3slVckTugYlNckTtckTt3slV3slV3slWm04hckTtckTum04igYlOgYlOgYlOm04im04hckTum04hckTt7q1Wjm26daFOm04iaZlGKv2mfzoGQbU2abVNglj96rFWSfVSBuWCkqXSCnVRckTtckTubZlFckTudaFOgYlOFl1R3slVqokim04igYlNckTt6tFhjmUKGvGWj0YVwqk+RxXKXyXiUx3VvqE19tlugz4Jhl0B1sFOJvmiPw2+ihWRekz2AuF+YcVOMwGtrpEpon0adZ1N0rlKgkWedzX6Ta09wiURmnUV6rVWjonFtpkt/o1Vrk0Wdxntgjj2ay3thyzmFAAAATXRSTlMAn79AnxBg78/vMO/fgCAQ32BggCC/gEDfMGBQQM+/cCCfIDDvnzC/j4CvUN+PEFCvcM9wQI/Pr0Dfr6+fcM9wcM/vj4DvUHDPr8+PMExMencAAAOKSURBVHhezZaFcuNIEIZHtiWZ2XEcJ7HjOInDtEzHfCOww7TMvAfPf4KReiSPKMpW3fcAX3W3un8N+ppk7wnFq/BsZI4wTgjxRTuyfIoxnknG9EzIsnyIdZa9BcX2sk7bZwT1jCY6wwYc21ISZrDFjOBdkM6ej0nIYZq8xwgyhugYm3TGy+Gwmx9YnmnZZEhM827RilMy3Ds+y7A7M3lIRAmXZxnT7B3JGg2WqEFER5jQRjTzGDg93JcNrrOXiDBklpSAYv6VLVZZIqKB3jC9KklrMg/PZJtJ5CeC3jpjBQ0f7csUUz5fn+5thZoQaAIKgmFDb3kQcaABsmzRnfHebA//E34OGmiMya4t2neLKqLyRg7rQVmigXvLEc+CoiiPXZrMKvJk0hYd0ovEz2oe8dbEJO1JbSBvpkwLZMlA97TSmifd0oyrKeLKpOog8C/p1L6Rlqh7eCuypncnVrMoiGlYAOvrVxSNWf4yWQuhtEw8C5dLbRhSCS2AJypTGXtIXDRPUoPOwnrD2qQ/I3nuG7uX44quoh7hm+lIfe1YF8qV4H87kZGPPt4mnsVqoVC41g0Swa3nqQbrqb+fGZ7uel81WVvvBm7OU3JZlIk3+rpb0DTAXDdAtE9M+ZLT82BNddKv+orANHB43qnjzHmJNsj+DR1pb3r+UUOb4E7fDiHtzT189ddIZeHVXcqRrhx4vujii4MDSRo5jP1uQCweWklWU3S+yWNAE754OXri31yDTo4EuXelhuZz2M3rE0kvruvzurKWIIFahmcWISRgJgfSt34BSwae6Im6p8yT1weLmVJgVB/j79KKTsv+KdLA/nuRtea09z0ZEGKZ4CJ9VNcN1ycyIJuB27NSQoHUp380PGIPAcm8o5w2CgNfNkTbTr+wkiOWQRKFYwEac1JKaqDQbEJjseBF+GI/ry9pzP2yGFUCjZU1TRXy7EY1sqepGGyixRsqzdq1iKI0mXS1r7ooRPJsKwbNdVYoRp/0r7/5h2IwNcXg/WgkSdLJgc6JJH2wsmwxYkG/Q5ZBNErnqroUsaBmErO4+HwetiSzoLJnKuaK4TwVxaCiKTtMUTvSDim8VyoKIT09TQIvoU5UD/CHdR0m7Zwz6+dRWMw8E21xkaM0UE7YzrYQUBIGCQ2uU7zEmVVQXLZMUS+2qEy2MTYwohhANNbQFbXWjC9qaSaxgq6CZhP9P/gP0aYQ4zn5hpQAAAAASUVORK5CYII="

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAB3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slWDzbF6AAAAEnRSTlMAEI/f/69gACDvzzC/n4BAUHCJnX3HAAACSklEQVR4AbXY7XKkIBCG0SAv3TSIyv3f7O5ijeMIdBitPX+SqqSe0gmf+bkwkwXgiLvIAbCT4U8//MELdiFyUwzYiVdDMw7EDYTDrIUIJ4krCSekhCzUUsKZ7YcI0EoJn6gXMoKLhU8WXIhph0xAZeXDikowrdBqUbN8aP54rULbjKal/WKHmc4hs1h0iHl/fm12Ma8QCfoW9YEKoT20QSNcCDRbCQWoaB9hqlBC0AX+K0A3EkJkjhgJCXQT8wSdlFCCzjJb6FIJGYEuRujElBCv0OUM3foa2QTVPENF77lGeIDOkzYKbpL4Ofv9jFtmX61HJPiapeYKme2XmWy629GMYXN3Oyp8DhgQste37L3lBApxR0UNFTE7iwbrcuSKFqIU0BASjYcMJf3VEpnfQ2b0wzZqaHMY5rZuiOydcV2FNouv2a0KmbuT1jD/j2VkE9wm2ztEGKUvtREPRda3o5q+HSU8loa27IBfydAhIgMC6EZCYQUkQDd00FoBTCMHLYJGzAogjxz9OEOx8ArALVDk18j2kyhDxJcv/d+Y/Hn2U+ifjsvDL2gKVK9H0rtCAIBj25uw45eaGQD82KWm8FKfQ/9x+7cTLsRzO1T9+dzp+iCmBM+yfhWtl9Ftf7rrcmy/vhx7FF65HGvX9Xx90Pnz5QNrodj8B0J6p2N4L/r6+ShJGWatNxZ/DF1JyvmozzTGDd8JscMuPQ1twC7fDVUDjB6GMtTSeMhYvKz3QvWYtzdD9Zh/GPJyK6S83DQeUkvBPA4xCTBxxx+kUG7szPtrIgAAAABJRU5ErkJggg=="

/***/ }),
/* 686 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkRwyRsNAAAAEXRSTlMAzwCAEO/fQGAgr1BwvzCfjzsSZNMAAAHiSURBVHhe7djLrqswDAXQ4AdOIA/8/z97q3J6rapKQhoGZ3D2EIklIstbEe5ClgX6cdANquIdELEq0w0Q6iM4DxHrI0zTEOozOAsRnxDTJIT6E5yE1he0fgWJD6fj9X/8CQQvAxCqbrt9kH3SvqniGKS6Ropq0Ujx4Y5BURuJA5C0IBmAQgsKAxC0IBiBUt1JQ9BWh7YhCOsQDkF7HdqHoFyH8hAEdQj6kBSyra851gJUcgVC5Wzz700/s2IVUvYvtDc0z9qCVH0HilZUbUgPW9v6yh7ah7T0oaKfUEipxPzWQokAqAYRAKW3Y+ZYUgrufJuLJ6uzJdf3HyAvVnHkC5+ms+pZrKA5hhoUIluNL/bYQdIbksBBvgPK4ACOeed4jp941mF6QrDPQvtrRbY5Z4MTmj0ck61InIEiGAQzEPxA4nFbZ6B1Qy/gWG8Ju3IPVBzgHQ6CO2thLkv+mRryDMNo4w/b984W3jpb1i9nLx/lj/zdqT4goDLqFKpcIiSNMEkatxHPVxn27WsNXSzeg7r3I7niCEAXwisQ9iGvl+KbkDnjkhs9l0ktKNpCpwOjiISzhgGCiEQ80mJSA1JVTkcUMvsFWUjikVhVG1CwsVYgi4Tm1PqQ5ddDf9AfNP/X7x8i3bIkQ5YKIgAAAABJRU5ErkJggg=="

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAt1BMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLYm3/BaU/ZnoLZnoLZnoLZnoLZnoLBaU/BaU/ZnoLRjHHZnoLZnoLZnoLZnoLVlXrDbVPJe2DXmn7TkXXWl3zKfWLGc1nJel/XmX3XmX3NhGnTkHTNhGnTknbSj3PPiW7BaU/MgmfKfGHTknbBaU/Jel/Qim/Ym3/TkXXKfWLWl3zPh2zMgGXGc1nSjXLEcFXZnoLVlHjNhGnHdlzDbFLBaU/9GsM9AAAALHRSTlMAEJ8AvzBQABBgr++AcJ+Az78gQI/fv7+/v7+AAAAAAK8A72AA31C/79/PAFzPdeoAAAQ4SURBVHja7ZVZd6NGEIUbgbAFaEYjpMnmJYsnk2SAZi+W/v+/K70XGGxLPnnIw9wHn2O5/an6Vt1qcq1uPzD24fbbQuTblfrKuL7+ByAm9R30HfT/AG0VyN+6z0Tcy+XsAgAFAgiD3TtBThQCIIgrjJx3gPYSgyCF8q8FOQHADGS0WQV9ZOzjqsXOAV4AgeesgBjX6xwEIekKUABLEGpzMSiCV0HgXwg6whug0LkM5L0Fgs1FoBjeBMHxEtDmAtBpAjruPZBHvD3noxww6vqBTTUmaWZcsqDjxnybvPMEtQclipSJ8kI3ToN2KkgYR0y2mqECMXONpbabSA4AgpQsCYTSkb2oRNzvzEHIQRCStsBVsddUC5JD1NklCLauKTZn7E1SzEHeEoRhjAB606SeUpqZ9heUplWtbwewJ3gxBE0uF0Cj2tOszlFRtoyrhIiogoqqnc4HluQVI/+kz9YGEudiLCIiI9mzuVoqB1+AEsSsgExPE4/sAbKaLdQDwJ6DPrGhWImIQKOyhH0mAXJmygECDvqhBBSCKMxV/kjOIDht1dBCmU1pmTCuCs4c9BNcBIJfiPBnoM+6lvXc4gaER+ugktI5KyIFG9OV9mcVG7Obm5vTAoSqK7RvR/K6WJ8j2uZ3d3fRHJMmbKbKuB6TGhtApyDRzPv7+90U0y3b0nYg5RKAl0AgPIoBVa7uEUk6WBCthqFegHBBvpzdNlP76CBrHvDzPkMQ1xm0+tl/D1yjjqzMJdks9lZLp/kPQKmZbzMV2VQWQEWaREQ6xUHpeQgmOztTZ8Zc+T3Y+Cf8FzG6ZAtytIe+nzwSHYDKml17uel2pYBg1YyskM9RmIp8Gxfa3BoIsWtNKuydy0X8u7H3BWhTm5EcZM1FosMfulInU9Ag6XQZti55eHggDzt731YUr73PADa4/jO5DpSsjahfHx8fyaNj260PSPdL8egpHTgaOVArtxCjzCTyIDa40Neu5RIxD0nCatDSbrdNhqCjAkUqjuKb7PmUZZFrdAY2ZuiIXX3Gp7OrQLGMOpvPR/K7Y0FRN/O2NSSzhTca5E7HvzfR/+M31JepI1n7/OX3Dcir+J0G/ffCxgP1ZwaoZL7aM26RAZ3KTh3AksIjYjBwOEco0RUDiszsDomx23dnckILsjmqOLTph7HyLMjXsztm4qd+refybUhxSZhPIguK9YFGjlu35JiqTdRUVQ2OowbtlEMVSCANY3dFG7Q6hWo6KvHUo8ZmoP8ZfZ6TzBCVZgToc1DAI2E4Z7R5laSXY4clIcjhHP1IHubuLH2yYUltSQiKulHO+vm0dV+XH4K1ONf7D0G3fyX04EX+0X1bjjcAIEn1B9t/jfwzkvQIBAi6SpFFpeqdDRF0pXZmFXatIGH6r9f2pMrKKkEKEPQe1j4QsCIfS4gR9D45cRR5n//O/3l6evoX6WkNfYp9ZwUAAAAASUVORK5CYII="

/***/ }),
/* 688 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA5FBMVEUAAACm04im04h3slWPw2+m04h3slWDumKm04im04im04im04igz4JVrO6Zynmm04iPw29VrO6WyHeMwWyj0YV3slVVrO5VrO5VrO6WyHem04hVrO5VrO6HvWaZynqWyHd3slWm04im04im04h3slVVrO6m04iMwWyYyXhVrO6NwW2m04ii0IRVrO5VrO53slVVrO53slVVrO6m04h3slVVrO5VrO53slVVrO6m04h9tluUx3Wj0YWGvGWay3uXyXiPw2+DumKgz4Km04iRxXKAuF+Jvmh6tFidzX6MwGtVrO53slWVVZEjAAAAOnRSTlMAMN+PAK/PQBCf72CAIHAgn78wAO8gQHCAAFCf3++vYBC/j8+/EECPz1DPgM8w758A748AMM9gAK9wew+BWQAABA1JREFUeNrFl+ty2jAQhR3atDaU0vSSUpJegNq9UNImlDRgYyzL4IDe/30qCbm70jodhkmn50dm7Im+aI/Orhzvv2p8vr364cj7cYButtvt+D5AUwk6vQ/QViq8B9Cp5JxXD8qvQ0FnEnRj+XUYKLyQa6+rp3Pl12Ggrlx6EVZU5ddhpbXVhs6IX95BZ3/Rrp6uKr+8Q5zedi3s6x3o1feP33/+2leaM4U61WNbg35eCiEu9yS1p1tTGFRmsN5HIfYmdS80Z2wn4fUOJCmU1IlmI6moM0Eaa4zhkCR4l4TUCxq8UvO45VegE82ZtoEzRsZ7D4RNahkKKIgQqEuSEFZN+wiTeoBB6muUbM+zNkmCdMiAPgDpccDvUOBPiLqKcwJjBJHKW36Xmj2Xc2aSAKD9SHxgYUI5PvQAAdDepD4q73oXhWs8If9OSpZZxhjLsmXOh4pkbNd1faGjtp6UFCsBKteffZyo83HdzH6yIqRkIxyxrz6ArsK64d/hiUtalpix2ixzFYOJlSgK6nOXVCDKPMu50WxCpO8RA4o4d0hrhIk50hFCgGNjAwq4Q1qAxRoDargZ/7IFkN/kQLLFkppgkuFyYkrrcSNC2tgQWlyok3lqQAN+BymuTTgZdt3q1PqckIBD1QJ/NAeuoybuCYhPRhngNzTuNPwD4iCTH9ItebGYq1csky9HeIbfKA4FpcBBpHyN41m89KHjZBbrQMlc1JBiVS5GPXsodQIDgIIyISgJb4dlacrztGNaI7R7jTo9/0NKEafMEoiAI0/96LtOxygFDNKJUh7VggJutDIrcJ7Q3pCGtaBZdThmD3XdsnKablYH6vCd4t2fTkjGKYc3fQKSGnKt3WwtoFsoB3RMQFAb0wdW13erW07UqwH5CLQk8YT5RovDIDi3Od6QeYEOH646xkqxio8dENjtjo6lYeDy4oXZotz5iIImowqEXV0LWxl03UL/XouC/MbOowVHIqEkjrUIaBLtQJanQmsNTtEzbBHQZKBLSSgoSRZ/CfmAgGQqM7HiBLSA6xvOD2kYuSB/mIoNBcX0g6JcW/kMjjQIdNQsYwoya26ZXV6R4+tgECkQkN6mFkgXBOPcMX2+LlLT32n2yXuB9fybBWJCYNegPCxWyoN9/8Z7Y8k3cwBWMvemKl3SIn7ZMx4h+QFuERt0K5RSWciGMRlW9W1ZSDOGYDbWzDaJuT1c+zEPIGx5A5rNBmU1oGaLBBLKG6B7l7nfBbnF6XdQsqmiynNmZ71QHuH89JympWo1qy1xZx4UUNXIJ2OEyh9pq5hdSl6KNcEQENlVX61ccqzU1NqYAYaAqDqDYbzhluIyka2lkrMfCFjvAyvtw3dPgbIvCGiR/rc7ioBxGAj070G/AY35fMKd/+1mAAAAAElFTkSuQmCC"

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAz1BMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrXdLkSZqrX0q7qZqrWZqrWZqrWZqrXdLkT0q7ryobD0q7rdLkTdLkT0q7rdLkTdLkT0q7rdLkTdLkTyoK/fNkzdLkTdLkT0q7rthpfkVGfthpfxna30q7ryoK+ZqrX0q7rdLkTyobDdLkSZqrXdLkTxna30q7r0q7r0q7r0q7rdLkTfNkyZqrX0q7rdLkTzo7PgPlPrfI7mXXDnZXjkVWneNkvhRVrjTWLwlKTqdIbujJ3thJXxm6uQ/EJAAAAANHRSTlMAPJzO7/sAh9v+cObAV/bO2wDOAJxX/vbAPObmAHDv7wDb2wD+AK8AwO/7H4fO9jyc5lf+OVcMGQAAAohJREFUeF6k111vmzAUgGFfot4Qigt1l3rZ1mkdypqu0znmOx/b//9NY5nlYA6HFPFIUSIuXhxjW4mYoGSoM7QyHUoV80TM2AYZElmwnRdSYYKMJFTvDj1qnKQf3xVSDySQFwbAFLlLPajroWckWgNnpkXn+UroLUUiN2CZHJ30bSokE6QKcAq8SCQfuoV/TlWOfQYcg30hF1pd7tzgBfSgJ6Ah23FMfS3UVAeA1TdHuE8r8JTTX63+f3VFQ7cwUE9NdgnWjy+WsO+vMGQa/vHX4Lz6I7p7AqJgF2RjwHm680IvMCLntkgFPS/90D2MqZBxgL77S2gHo07IAI/ZudBPGMd0GvB9+NoR3esGloXgxo7oIzBypgQD36MoElG0Aw4/2QO784g+zQ5VMPB5sxGbTQKMg79FO4eqsQvSY36t12K9xd9M6Djcou5YqIfbchuLOMCSCbX+FrXKsStBF8oQ/0yuR3p/OsYsFsqOlH34dEYaOmuohMTOEaiSfUYVUlKE7vDyFfyqOSAVCo1nR/6uQCClRWaTdX/GTy3ODGUCndKuJ1PsEeeGUGBfu9/vc7SWhCh+sueH6OOfG2IX5OwQv0UooZHHblpKC4k89hihpIhTZHEHG5XGIlYJLpaoLhSrFBdKlf2hJTUuoOXUX4i/xdRBDsMgDAVRSJxGEQnH8Iat73+2XqCD+Wql/iWLJ2ZjD5i/Pq/A+03QLUJGkInQQdChQSNwQ4JOhk4J2hnaJagz1BWoxmRVgLYZtAlQm0FtHRox3QAIysS2AmVCG0M1ktVFyDPIF6GeQR0gKNPaCpQJbQhZDtkSFAv7GTT+8aPvoZY7bQl6rsy5HoBAEhy6R27MmH+8R2/VyhtmsTe6zwAAAABJRU5ErkJggg=="

/***/ }),
/* 690 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAn1BMVEUAAADdLkTdLkTdLkTdLkR3slXdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkR3slXdLkTdLkTdLkTdLkR3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slXQP0aZhk93slXKRkd3slV3slXdLkTKR0eXiVDXNkWEolOqcE3ET0iRkVHQP0a3YEqKmVKwaEu9V0mdgU+keE53slV9qlRyQUbGAAAAJHRSTlMAPOaHAFf7H/bvztvA/q9wnFev5u/AAIfb/vvOPB/A73Dm9pwpZEoSAAACXUlEQVR4XpzPQQqDMBCF4W6yDdjEZzI6bRqP8Lz/2UoGpFQsNP6rWX28uR1awoRL3XDIiZxSSy8ErYzuqMySeiGTOH4xiUzoh+AyWT+vTJkUvQLBk8z7e4UkCy5BkCatdmomWQG4ubIlsfwPrbRN+zqO0GBK8K5rkdLyAKJBamvmpfc1VFrii7Qjxn1hL5R4moRVe6Dh/tr4o+35GN7t19uOmzAQgOEaLDuObXF4hgESoAm77Ps/Wx0OkxSzJtrxTaX+N777NAyJhPlOv/i2VFsAqOotUF/bHlztdRBndgRJI2Cuuf411KUBrHKHykKQNBaWVgbrYFPCvoVSZH5fRq9+K1mzD0mNo3czcOseY30t6B28lNyB5Amf6oHU99aRzYcThmZ4HDX4icKD0Glu4+WzhbX2a7y4o6/HG+xkC4Q2Tt/d12UgXIHrY4SAhFACfijN2+lgX5KvUAmBqut0DNW+dHqBmIVQwzxZC/uZJ6QhWIPHfmyFGNBSK6SBWDZDEqjpGcqBnJyghA6VEwT01APKIELSQWUMKHPQOQZkHKRiQImDTjEg5SCIkY0FwT8I/Yesg1SsH2QSA9IOMjGg0kFpDKhwkIyyawfF+PvrCSrpUDpBjOwIPkH0ZzMLlBMdKxeIC+pAK5QTB0KINlLOn1BGcJT3MUp5MISkoHxkIeQqKAtC6Odv7syfEEXS/AUiSCX3oJ9INuc+hDe/9xNF4E7LTu+vWYZv2ebNcbLD6zpTx4wtQ/d+LDugRCl5GMLY+futJykCIQhLtfARoXMc5hjCWGoStXBCJSZlPNAffIZMbNM/bJcAAAAASUVORK5CYII="

/***/ }),
/* 691 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAh1BMVEV0Tqp3slV0Tqp0Tqp0Tqp0Tqp0Tqp0Tqp0Tqp0Tqp3slV0Tqp0Tqp0Tqp0Tqp0Tqp3slV0Tqp0Tqp3slV3slUAAAB3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV0VKV0Tqp2gIB1Z5V1eoV3rFp1dIp1bY92mWp3slV2n2V1YZpXrpYZAAAAIXRSTlMAAP7225wfV+bv74dw+zyvnMDO/h8AwHA82+b79s6vV4dVjQLRAAABnklEQVR42q2X23KCQAyG111YYDkIQj22tUa07db3f75KO9NUB8WQfBdefpP8CZtRPZ1pnr13Ex6q+yn9mVJANO9Ec6mK1gKiRSdyAqJGSjTpRHUjIHKdaeOcq9clsyLELXlTQ+pyrGhb+0teRoqcv2Y1StSg4OsEPxirRrBA0R6AYXq9EDFMc++PJzh0ogP8EdBFb96/A0B79P4ESDUmox2c2bUt/Celipb+E/rQBdW02UMf9MBXH9AHPfCyhRuERFMOgHACj+EWOiKJpiBkKuCOKWWGhITM3pAZszcksdS58YNKYYDY8uJG9IOZhzCIyZglIUnILAnJq4JZEmKqzHJLQtksumNKgIK5nVcGNPKUuN70LS00ENER7RGgvzFGyhQBnf7uKiCjrVRzcX9zGshkUpNLSGtJL8nSYwqUVEyWfgn6SYn3kn5CA8bcWCatpEyEI04QcWpSUiYlZVJSJjXAlLlHSMjabPoXHKlhCsPsDJkxC0LSgfam6lFscP99JJAZkPorFvarkkKRyYLrrHSAMRNdVZLDLyauLq7QN3hUNrBLjg+kAAAAAElFTkSuQmCC"

/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABLFBMVEV3slWSZsx0TqpVN4h0Tqqqjdh0TqpVN4hVN4h0Tqp0Tqp0Tqp0TqpVN4h0TqpVN4hVN4iqjdh3slV3slWqjdiSZsxVN4h3slWJX8KSZsySZsx3slWqjdiqjdh3slV3slWSZsxVN4h3slWqjdhYOYuSZsx3slWSZsySZsyqjdh0TqoAAAB3slWSZsyGiZWIg593slWqjdh3slWeetJ3slV7VLN0Tqp/V7dfPpNyTah2UKyMar6gfNOHXb+FXL2ZecqJX8FXOIpwTKZ9VrWactBmRJuBWbmDWruOY8hjQZdZOoylh9SbddGLYMRVN4iIZrtoRp13Ua53Uq1oRZ14Ua6QZcqSZsyqjdh3slV5rVyhftSUaM2Qa8WIg5+dd9GjgdSnidWpi9eFYriSccReoaR0AAAANXRSTlMAAAAA7wAQEO+Pr3BQcJ+vUO8Q7xCfj4Df7xBgj1AwUI+fz3Cvr79QcJ8gAI8gz4CfryAg35y++eUAAALdSURBVHjardf9UxJBHMdxkOtUQPQQpUNR1BDsWdPFLlEUI6K6ymIPozTr//8futtu2Lu9/SzezL1ndPzp5c53HxhST8qjUTmVRCO3g2SghJa060KHSUBrI7e1JKTlpJZUTmpJRbakYlJLKiexpENP2khA2vSg7ZSs0s6+4bgZ+zulB6pS7PeuJz2VMHtOoL3SVOhg2ZM2RadqOKGMqgpisVO5LIxp3Ym0roJYL0f8DHAHShgqbrOBB6SqI60KIb8Nb0zXz+smdTPrzVeGHDJKCOLS9S/K++GA9jDk9+In5Y0dWGkKVKPBbjC0AyHu8G4xtK+EGjTcHYYMFVQxBQgpv//+uSJuWjanzwRLzbBWqBBgPpNABT0CVei9oLMrEkrLi1DzXtAbEmlegOoR6A44SPIhPmq8/WdEWj4EcSB8IO9OLsfsnF+efLiSQ5quhsYe85EGaltyqQAgfmlvxzTUsCuXdDU0vqGRTqVQDgwbhKUs3n5cVzZufCBxQ9nEwRVR15ZAj8GlVWfBFbHEZwTXwxCr4Q3gtMv+n9XtY6gDh+1XG7bIpKFi3HD7/fIW4VFF+ECy5glPDX3HV0R01JDy0uZJHAg/I7pGeNOHbfU6Q/Znp2eFH7YCEepgqGO1aaCHlfT/Uu6PTsR6GPokrNZscCgXgSwao9oEypJI7bgSg7QoZA3jSA0fIpK6cSCzgiFyGkdaAVB8qQIgVleYU/8dhppo2Kzw0TsatDBUn2w/oI5afbaY1sXAtvsYMv0DCXtvB6KK/CsCO78v9MyD0gXkfLNjrSitg3G/Po8JpfNy6DjITB02a17mvLXDTd1+JkGHd6E+kH55TZjPsS02mHJF/PTQ3hUe2dGO1JeWU7msNvl6MDsXhQZ91TOCWrKjfVE9bLBVifRV8dTGklZr+PFXtCTMaW4pk2mY+OMIN7sVdLZmM26VldB+BT4g1dTC4hxbzOICYxjVnHypZwzrHyDs2tBl5ekCAAAAAElFTkSuQmCC"

/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABFFBMVEUAAABckTuCumGPw2+HvWZ/uF5+t1ym04im04h/uF6m04im04iWyHd3slWm04h3slWm04h3slV+t1x3slWm04h8tVqAuV+m04h7tVp9tluWyHem04iHvWam04h7tVl3slVckTuWyHem04h8tlufzoCm04ifzoBckTum04im04h3slV8tltckTuPw293slVckTum04h3slWm04hckTtckTt3slVckTt3slVckTtckTtckTtckTt7tVlckTt3slV3slWPw293slV3slWXyXigz4KJvmh9tltckTt3slWm04iay3uRxXJqokiMwGuAuF+dzX56tFhmnUVhl0BtpkuPw29vqE2Ux3WDumJekz2j0YV1sFOGvGUe4TLrAAAAQ3RSTlMAEM/fMABwr4C/QCBgQHCAvxAAIN+fUI+vgO8QADDPvyAAYI8AUM+/AM9wADAAYACf3+9gzwCvMI9A34C/cFDvIJ/PdM0f8wAAA7JJREFUeNrllm130kAQhVPfQFChFsUasYpWaa1Ksb4rtJKEJEgSFYmR//8/TIDN3Z1ZaDmHb94vZOdkn8zcmd3W+J+0dTL4dPR6bRks8nUwGLzbBOhzCnq+qYwGmwB9zECPNgDaykBvsqebh5W9uSqVm9tvV8vgoZPM7Z3DPVfV8Vl3ez3Qhyylv65O97rrgI4y0HdXr+Pd7QuDKj9T0B93mXoVs6WRQQPvv7m/NaCh5yX+cDrPqnuBjLq99M0fg8EvAhp7c03ibPXl9CWVoS5fucs08hbyM1SvuzojcLiCUKCGUbp88kKVIS/A0SnqC5IVpMszc6nZd/nmiT+KpJUgJXa6umQuAe30OCjbNNaQvCx4/aokA48PXa6ZL2GQr/s5aZJVpzV714ViR01hlPsUKqRrt3MZ4uFUKsz2kkUSU7FLOBUkcnW9Kw+EDPFwBo6TNWaxU+wLo/wjuWzYBI923LgfyPWM8YyWqzZ5aejG44WMxe+d9Aw4SCiVg9oy5dVGCUKRe5kcEfN+GhbnE2amshhphJR8N2iqc9ScRVVb4sVpBSmW2KKdz57OZcx/CrkrKMZHoTCF+J0EfkPOyJzR6fTGMFetzpLhdRlUwj5XdgAZKlNgy6GaDCoCFHtQzL8/nDXOk9WQQFU9KESXAKflerckUI10CbvY90NWW0ECeUtAfm4/ZFN27RwQYoESSqL59QIB1BCnGY4gJbrNG9MkSzmohIbAbKRE4ImDvLUgn4AQjNRYH/OuBSUA8XZTv30PasJs+eIgoAnajeLUSJGCbAICPiKxqRLZB6gjakeLkJImOFQiJYCqMElUD0WYLqkFQy2oLjLGBQmNtb2cYlUGqIkqlKFBoiSkoFsANTD9eAPd5gXL6Kp8Z9f4gYRCbpIjgeoyqI0tbsJIASxBkphHGbSPLahCnoCAnhKATIBSdWC33DZ4RyK4gQ9aCqiOobE9plEOwmyjMgVUxtAEHGSxczsRoI4J0EwFUgU1d0rQ4q12i4BKOEYakMWa6WCsAcJ5SxVjtiUFtAcjJERAZXw85KAhtc6CQwCpjbN1doeojfxx5CCzlvs95lscMqg4ZgBRv8e66bZVOgoDCCrmzjqsjokG3mhpQTi7VqS5lQDCTC8FmQf5v0EW3Tb1GYeBOCmx+xTU9zmHg0CqehdSp9RaCcI4rVa13GIgpv3OuekU+S6AILOwmtNGOgTEVKquhwGIo9paSq0OzGoQZDYLxKyDOlq1EsTVaBYL1ZmKxZK58tV/wTmdng2sRYgAAAAASUVORK5CYII="

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA/1BMVEUAAADdLkTdLkTdLkRckTtckTuuvXn/6Lb/6LZckTv/6Lb/6Lb/6LZckTvdLkTdLkTdLkTdLkTdLkTdLkTdLkRckTvdLkRckTvdLkTdLkRckTtckTtckTvdLkTdLkTdLkTwmIVckTv/6LZ9olR9olRckTtckTtckTtckTtckTtckTv1467W0pfmXWHjUVnr3admlkO0JTccBgmKHSvBKDwOAwQAAAB8GibMzZA3DBHPK0D/6LZckTvCx4h7oVLyoovqdG/ui33dLkSjt3GuvXn70ahvFyKPrGHhRVL93K/3upr5xaHwl4SFp1rg2J+YIC+ZsmnfOku4woDsf3ZwnEp+EYRRAAAAK3RSTlMAYM9wEACfQAAw34AggK9QAO+PIL9gEFCfMM9wv0DfgN+Pr1AA7yCv359A5dwQzQAAAtdJREFUeNrtlWtT2kAUhmmbtFq11dqopWktrVER5SKCxV0CrhdECgLt//8tPScbfGFnEmfhK88MfGBmnzmXd5fMkiVLXsLLfnXcRcnQJyulfPtuZTEyKyurkiiJ92vrC4o2yNMRQnRHHz5uzk1mc5M7a5KopZTa+rQ9t8iRRIFERRXx+dXOfKJd8oTcmZqwtfdlHhGP6EZ3Bl6/2bEW+fGI/qpZ9r5ZinjWpyQ6Uybf97dtRJIQxAgGQIGwFikAEIjFRBaByHCMytOiynkVDgTCWnRRq1/CYATCprXLeu1CGdUhEBai6nmFvlGdGQjr9aM6MxCWgUR1LwcCV+Q3rkg6CETapbWAA5H8jIBaI02CQKQ9bEylXr9KdSAQSU9tTL1ewbhT+bG2/vz45yaPPwLQqBkBSGLUFeLnrwMic3Cg/47I1FbAjCSmVmlMpf2ajpVkkDt8/oO8pV/uUJJxSTA1Vt/PFCRu6PhRJPL43vK4r1USmNq9bhYFFcp03ItEThCX1H1I8mBq1QbG/yCIWzp87JKI2JiU9Kis6EUTIjwt0iV1RNScBX8E0dcFaRFNSV84bA4bSqQtiKYkdrWI8bm5Eo8J+TY2ZHLGngFP2nchOuTmwgJM2NAUT7UqPF3eWEjHgsNYhOaGAt3NbAg5v0JfREc3BhGRhylx4lecc8xZDCWRd2dFThamXlKeqrUnRRR78PCAIIKpU9BFjVIu6rVgCn1JZB2IZk3hQDBdqExNVzCDEB4tMk3lsdCqFu3PpNgiDTMuP3sggsmXTL8kNHetdnFK0m7dCc2gL5kj7YEI5GTEkFUxvceIHn4pDWXEhhsDEdgNYtVAJDCINcEJTkEEnLzUhGOUhWLGodTkHNcUmZz4cuK6aZ5Cctoc/pMxPsqBKEWldX0iLgSadBFU+UAmEORXXZAkAo6nXabFw2xeEoFVL+cfy5hjP+ehFgCRDUvRUrQUzcl/zMtF3CJe030AAAAASUVORK5CYII="

/***/ }),
/* 695 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAC90lEQVR4Ae3csWsUQRTH8fsDErOJCIIgI4jaOQqKIMIVYmMzrSBkRUibK7QQmzWdNtktrCzS2m1nYzGVrYOdVoe2Kbaxf/44tghH7t3mZl7cmx3hsyh4gXzZmb2bm92R9J/n1UMFORRQgz1FDUVrDApGfSD5w3OwQB4sFGBiCjSGKVBALoZAGRwBBdaAWvdAGpxQHL3uc5CGJro4rV7G2ase0M/yEv0tN+Y5qKEAAxmMJK38wnbOmYrHWc7BBJRIoL1rF3NogMDCIRjIYLRI+96FQnpT3aXf5Q4fhFeDCR2oAVrAwQTUXJwxUEhH1Q06Lre6x+BNIRcNxMTKQp49+9U9+l5e9grCsKCDDbGOgoX5Wl4NGoRReE/S+MU15HAEUy7Q7us7K88xGErMGSPKgQp2FWuDTcABzXv5WNGLZzdnsYAOqtsnzUJ8rq7Tt/KKR5DgGhgHv8y3k/QhNxTf3d+hX2836fj9Bv14dWH2d7y2r3KPQGyoDPJFQ3D/FkD77wgisYF4H59s2zbGQjiTehuolUsFMkB/Djbpw6NtWnQ24f+sg3HoQBoaICDMOacG+rK7tS6BGlAhAzmg1mwYzcf59DTrXwieCxXoEOgkTMQnh5XcmSOv8A2kgU6DSMyEvFa0TyALFDm7aqAcaCDyVQJNgQZietZABmhgzFkCWaCBqbsGUkADpboEmgAN1KRLIAc0UG5ZoAxo4LJ09eIZLlABNHBFurzz6jRB8xwXiGDw/AKlQEn6iJECpSGWAqVAPZbeKPJc+qjBq9OHVV6Rljt4Ji2YeSyYpSVX/0X7tGivIH3tw0tfHC6Tvnrmpc0Ly6TtL7y0gaorDRQ5HWQTZ6QKgW3A0XAyG8l5w9xI3hoDLRHvrQjyl/74b2aJIZLc7VARRBK4oY5nlkzcEdyS6U+D6/mlXIs8miKCN5Net4VL0GCBhMk/WAAHSbnwUon8oylwOA9G6IySf7gJDudJwSTgZC7/eBwc/pcMDBRgwXWMYc/zAUv/AGTpia3f5MzjAAAAAElFTkSuQmCC"

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAADcElEQVR4Ae3cQWvUTBzH8byEvIS8hNylkuLzIKK2U21vUvISFi8evMxF8BaqHhSEiMWLioHah0erJSi1ohRy0psEvCrO0eP46/IvDNtNhuwka3YyhU9O6cJ++c9ski71jn9u7Gz4xCPEOT5wkKSEFBi4QBRIVhAUK3KB9EqI3RLTK02W37WtMz5EE7w+Gx9og2aQUgSpkUNQEyKAESSQgwCpUdK5HBiE4FU4ef2MdBtIRcFCiiU0e1Q8ZUJSkC3KJxQgVXMPBOpkcU2oVJkaAXLOivkF0oeSFYrNe0v5vOOQ6K8Hmlh6xbRI158zuXl3qdGbu/UoGtt+dk6+yP6ZKtleHp8zuj/1tTPwehNICZU0jXTz4dlxiKO98/LHh4tSHl2eydf9C/LVzr/yzpNlgYABeF2a+Rdpg66ORBOCN6MJYiyDGHzw2tboZOVSoFCjbP2/Lt/ka/Lb4erYz4+X2g+hJyCBYN6BaFqqr48QZ+5BNNK2QunCBOq0VOG7G/L355W+RRLAOwtEn1iCImgdvWd9iqMqIDQIZBiHPH17pY9xVCPzQLSsmsahjbrXgUgKvmmgAuQs+h6IFE0iTcbhIM0D2RNJjeODMA9kVyT99FgaiOT6QOr0DCwQSfSB6L5qiIEI0wXKTOPw3YUOJMCvCyRNPXh9dWEDkWxqILpqlqYe71GgxRZNC8QMwtTd0VvxqWb+8U6+HLCFD0SiTgLR4w4b5K0HohtVm4StBjp4t2ZboFQNFJkG+vVpxbZAorVA9KDMRqyVC0X8FcPWQKkaqBji1bNGqQZK3d4zVTDz3fzLfdp77BafBAqaxLn937p6YWgzrj5RLN3GfEquBkrd0jqlUAPFA7yl0FIDhZpA4vvhajnMQEQTKMY5fOiByrovauKcaOiB8oovj/vgUSThAhESgacEytweRCChMGog5gIBFMrSmowkhrvENHEoEB9qoBBGdXEokA9iOIGaG8oUlSaBfCgHcbNqgFkeKDEKRDLrH5hVckstMA5EQqsf2rcktm3/qQ/kIkWtByIjW5ZXdSA3Sbw6kIskwO88EGEgFvoLVDh0LYTCBarnQ7pAkcwCGWBQukD6aeIgXKB6AaQ9DFX2IZDKh1GPNvK4b4FUAcXKO5iKHDgwiAgDrmDg9SqQRqi8iQRyjQy4GqLj/7zg/AGqhf473Ij03AAAAABJRU5ErkJggg=="

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABYlBMVEX/6Lb/zE2m04gAAAD/6Lb/zE3/6Lb/6Lb/6Lb/6Lb/6Lb/6Lb/6Lb/6Lb/6Lb/6Lb/zE3/6Lb/zE3/zE3/zE3/zE3/6Lb/zE3/zE3/zE3/6Lam04j/zE3/zE3/zE3/zE3/6Lb/zE3/zE2m04hrnEv/1Gv/4qHGcU//z1f/24Xgm07/2Hrgm07T0Gv4zVL/4qH/1XCm04j/zVG70Xr/0mWm04j/1Gv/4Zz/4JiZx3uDs2Sm04im04g+ch2m04j/6Lb/2YP/zE3BaU8+ch3/02j/zVD/zlT/4qP/2ob/46L/5q//0WH/zlf/13n/1nb/57P/13z/3I3/1XL/4aD/z1v/35b/4Z3/3Ij/24n/4Zz/3ZD/4Jn/13T/5rD/46b/0F7/5an/1G//2Hv/1W7/2ID/5Kn/5az/2oL/0mX/3pNyo1PpzlzUiE630n35zFH0zVT/02um04j/02fFb0//0Fr/3o9ckloRAAAAP3RSTlMAAAAA7xBAEIBgMN/Pn78g74+fMIDPUI9gQHBAv1CvIK/fcIDfcJ/Pr+8g378gz+9gUO/PzyDfQHCAMK9wgBC4G5GQAAADhUlEQVR4Xq2Xh3ajOhRFQwYwGOzguCex06b3Xl67kntN7z3Te3//PxCMIgTCrOD9AXudc4V85bFLI+LiopiqTMXGohPXAECMR/eIYCFGzpQEm0REjwwOE9FECSKaiibSiCgZyTMB50QSqZQoPpIRvV2F3EhGtIlAGcWIlhERRRtRM6JozhF9QCjKtx0Dh5YpSo6g2RtkilIjaLZliZToZwZ7CK1GECnU4aO9i4tioiM6MkX7oIYQyBZxXiDYN0XrIA+R5BI6DNBTcb9AsGOK3sBE4DwTIrjQVGdhpIjnLTJZhkANeNHsWx4HwiayDk3nD1MBX+wvj/SF5ZYp2oQ57p7RgUeKLgZNZHIECn9feWnvtsFClintjj0imTMe1iMm1Csz2OTAdGkiE2gVgLf3GIs94QK2eAnABlrnzVpmj3xABlu8gxPiWUcWh7y1lqA1VFAJn9HpdOgjQ3vcRatTGppZW7RNIu0jiyYkh/z0KcwjY8EWHUCb/KKZ7ADvxuYGcdh7Khm2qAu7tmgVWWyBxglkN9NjrCeLBwyqbbWsEbWWeYEUzotnEjvsAuGw2fSePXWxRe95FjHhAGj4K01VcjGPp4Apfr48AYpk+GeWNIndNN4BRejXaDpbr60gk5W1rqPqdmiTHMpTMN6/Rg79Brb53eZk4tfq9RHFGqlHm/TY0FrzNeRiCfu1G7rYMk4cQpc6PbpcYKTZGWc6hFNMsQ0Q6oVceLiGgjz4ugYEnT/lcm8l2DMpqCFeyCWjy9ZC7xmPIIhAkP3j5OunrOb1sccjpIaIivONPuvpN7weIRc4bSmPjz21atjHI8iMiImDa544PV+P8Iyq5o1TX2Knw8TBBWGAzBWls3jD8xE23BqjJPiImCuB698ZzRLTCmfTAuE58WiuWjO41+ekIZQl4ZyrRJSgaxm47qq11q1jlgWB5h4R5ajTMjDuOY6VpdoG9jKfdnnuU7efzmPS2DgD+5OXXB7phl+za5VKBQeSLQpuz2Pw+cN+szJEZGQEN8WnHepBSJB+EVGYVunMLWrjavQmvF2pfOanmXVpMsZ2h7tEpCxPUy4ILu7cxf8HLsiCjyqbL5FO0xYPFh99c3t0n6U2W8qUZxzymRJ1GZ5crlY//jD58hW/ouOQ91hIXlRNLNEnfC4S51SiCctftujvf6anx7mMjYfg32r18uJ/RMARRWP0oj/k9w8mqoN+/AAAAABJRU5ErkJggg=="

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABCFBMVEUAAABckTtckTtckTtckTtckTtckTtckTtckTtckTtckTtckTtckTtckTtckTv/rDP/zE3/zE3/zE3/zE1ckTv/zE3/zE3/zE3/zE3/zE3/zE3/rDP/zE3/rDP/rDP/zE3/yEr/sjj/rDP/vED/zE3/rDP/szn/yUr/szn/rDP/xEf/xkj/yUv/xkj/rDP/tzz/xEf/yUv/uz//rDP/rDP/uT7/zE3/ykv/zE3/x0n/zE1ckTv/rDP/rjX/vED/uD3/yEr/sjj/xEf/ykv/sDb/wkX/tDr/wEP/xkj/uj7/vkL/tjv1yEx7nD5mlTyjnTjrw0l7mj3WrTyFmDlwlDrgwUq4rkLMpDag6JbYAAAAOnRSTlMAv+9AEN+fMM+AUGBwIK8Q75+AII+/EDBgQK+/33Cfj4/vQEBQ74+f34C/769Qr79Av8/fIL9w789g579aUgAAA0tJREFUeF61ldd64jAQRmXABmNCCyG9b++9SHIttGR7e/83WUkWLhvxZQTfnovoKif/FE/QahottCFN6SEbeuqtBn8ssrGIcNMWIWRrUxGxRCDSRpvBFCNUEz8ZTrfWaq4tIhZhmKzxJuGVrodBlrSbLFht7VZZuchosacjW1dHcBpiTh1SxswaRWpQUdsyuaDWdeoVkcM3ixUIbbhjFhkqogZLqLcKbYMoaGUtM/RWUaEyeR793ewQNTWkC1scFQZqdAzDsIErJa+HglHTzJJpLNOWKlNXBu3Awjg2j98lK3FAGousRiOPaMJq4LvUIrcCHVm93rZlU5VYSIu2pXDpL3ezbtujFSZ5J+EXYPOvxALMDNht2zYAIhiNTg1QGki0olGf9rd1NLYqz88v368x5+hgb4zW/k5+/KE0xTkDQDBHofn8O6Q04YbAn2HB6fjW629YdtcwKp35inHkL7jApzSMsgp3obfNsUzpucZLYpdSGuGMPQSmOWKub4UHT5kn5JJZJE1g6sYvHAe5aebTaVZiyN59HdMQY4/6UVGd6DllBLg/hnu2mSChcvY5HvNM2HsAFw2yxiS4QuC7mfoS6un1WV8mlHpcML8qVbgQwtdQ0R0ZIJazT2JcZk6PgaL7OEdVoufe7cFEO5U/T7PZL9Kiwuk9mAjjNChaPBeVxSzYovDvAkUJnaRYOXvJDkyU3mxMsiwx0oiEJ1TOvlSh5ybipYnHSx2ARJFPqXC4kynOmS2bf8XePkTUZwHS5ewnuEJ+Ui51xh8y0aLiib0k697sGPTtS1iFrph9ucKpCOufAES7pQCi5wsm/CeZe4gAPEjVsy+YJSDRQ6/6W8zjitlP41z1CHRHHnNB+XwkQu1Rdx5o7fZQzD4pBRBR3NLVfIJAHOF8vRUnJWbaIUy0LxpDZaKiwmytfNcPniIYO/xC+yJHucJoeTVpD/6PJJ7O5Ozd6EaJzxCU02UGKte7IGXuC7Bo3JcdZnXMxXovShU+R3Du5Bc6DLISXT9XvUAanClmLzlDWgzKoiu+VnJwLxHSNQWlSCGVs381RrrsnYsLLQmyEk96SJ83h9TFFc6P0XpcvC1r+sMeWpvtdwfvQ4/V9WHwEf1H/gI3mLWKj4ZMjQAAAABJRU5ErkJggg=="

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAtFBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkRmIRPdLkTdLkTdLkTdLkR3slVmIRN3slV3slV3slV3slXdLkRmIRN3slV3slVmIRNmIRNmIRNmIRN3slVmIRN3slXdLkRmIRNmIRN3slV3slV3slV3slVtXy93slW1KjSzZUtmIRNmIRN3slVoLhndLkRmIRN3slVtIhawKTKKmVLXNkWdgU/ET0iqcE2keE5wcziRkVGEolN5iO++AAAALnRSTlMA758QMECA38/vj79QIJ9g7xDfgHCAIM8Qn78gUDBgr6/Pj3C/MHCvYL9A30Cv2rCx+QAAAclJREFUeNrtl9l2gjAQhieJJICouO/afW9Au7fv/14l9vQgJ0FDRm96+l3m4oP5Z0IIWNIKghYcgFaSJAHgmQcHEp0mGS1A01eePqCZqsImgGesApqCoj1rDtMNnevzS6jGKPgtbNCM0206i3bl1o+UJtXozMCek0w0BljEqYmmfWVJxrzdTM2cgS13mee+PTRrOg/VhujR7Im7sI8GK0T0YY5nZ89qvC7kBp9GSjfJRFfdi1h7mwGUw7iQBZbcU1N0w5fy+fXt/fPpx/L1cstgB5xInSRD6hBeXpQvpa1I4ddKPEQaWSXJShohtSoeuV6t1tLexHzpgK9HHkonQm0ApSMNKEJdRRSKEFcRgQKRdCYyRY2Pu+4uqpsiwockEfxhEfvPaC+HHkj8FjmOiLuLeEHUcxf1CiLPXeQVRAy5Q3KEq0cc6xTp4bLOqbmKtNNfoCLCh0Q1UYQ5HvEfAAI6FFEZvrYIDAhEz7CfEg4mGGLDIuOmYKaB+H9EvRKFMhqk0jAyKIUjW5YjEDPkegh4sJMQWViOb+fxYR+MIDpmcW/T72lok+6xv9vqd1lL2FbvROhlhCJfCRnY41GyeTb18hV/U5VaMfINrZozdeAgPicAAAAASUVORK5CYII="

/***/ }),
/* 700 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAC6UlEQVR4Ae3bv4rVQBTH8TzCgIqVEBsRbUYLQfBPOhEtAiIWwnILUQSLuzY2IsOWFgYsbAcsbBd8gTxCHmEeYR5h/HEJy3LIZe+eJOMkZxa+EBRy4cPMZEKYIuW/9zevbJDv26Aidv1Fkm1QOJdPHujJ5xslqgbSqJgq/JZGPlkgglIjizwKF9Qig/RIoA4FUjJTjI4YjwKjDm0YOGYAx6Ai1RG0QWFEDlUH4pQDU6tFRYJA45FIzQFAdmDdKVMFokh2AqQOqT04CnnW1IoPFB9pz2NdLQGIIpmpkAjQKQGyqEgNKOaadEqmVyDppQFRJI3cSKRtD1QRHIeKJQJRJIWaEUAelQN7H7sGILqhtMxNZTuw/mwv+s0vf1+rvmLOpriJRga1yH368yIc/XocXn2/H55/u30Q0tG9a54AVQSiRhZ1KOzJoRYZpP83kEIGORQuCmjh4+9nO7i3Px+GNz8ehJcnd896d+tqOA90fPJ009//FAVmDhmkYgMZ5FGYKjJ6yP+PziMTA0iTIZ46EK1Dei4gTUbNpH24c/0MB9czAe3yl0WKjDPc8ddHOxi0u8a/xUdiAikyrdZSh9QUQA0KK60ZC1SisPLKMUBWAJAdA+QFAHkuUI2CkGoOUCMIqOEAtYKAWg6QFwTkOUBBUhkoA2WguVOLAMojKANloAyUN4r5VYPWzgCUgYwgIMMB2goC2nKAKkFAFQdI5dcMAjSQE4DjZvyqkb9qbEUt0AwgLQBIs4H6nKj1hwFkpa4/FEjiB8SaC0Tz0t7gKZDEaWb5QDKmWT0aiOREPb0YQGZFQGYOICXl5ZQF1GclLc4coHIFQOXkQCQrafRwgMqFbhw9UhGAFvtEM7GPQ7ml7XtiA1ULAqqiAZGaNU8tNhCpSxinS+HMqkJ+eU+t+Id6fVo48Q/1po9EcGIBRTjTGvVManwgkrrk082hBlWk5pJ7rYasOekBkSpk90y7DllUHXyf4ZHp6X3m6B80nkW16QyR0gAAAABJRU5ErkJggg=="

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAbFBMVEUAAACm04im04im04im04im04im04im04im04im04im04im04hmIROm04im04im04hmIROm04hmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNxPydmIROm04hmIROasnJqLBqCb0ZyQinMV4GRAAAAHnRSTlMA7xCAvyBgn89Qj6+/MEBwj98gQDDfEM/vYHCfv4AwASKJAAABeElEQVR4Xr3XaVLDMAwF4Ofd2btTNrnA/e8IKX8o2E2UaPgO8EaS501aXJ3adDxAwCal1EJAm75ITZT2WO9xDNpgvd0YdISAhzFJ4t1ex6Bnqd3SCeu1Uufep9FO6tyt2EhPUldKewCdN8ZUHRbanceg86Ha0jfVeL28J+mNflDBLa5uutCNRVEvvycaqQFcgd7Tx4X+sA4snkpUBY5IZR4MdI+RCqJGCwWRqh3mUTQlDh1msDSDsqafWtLQXLGucEdFDCp0KCIeW4xqiMkUO8IVNXI0SSU1xGZZ78a/kyI+h4ya+AIyHPEpne8bX4UMT3y11LktcgKxRUjtBql3Q5YSuhGsVFAt9PwwxOWR1ROXEwqKyHNCmwFLyi/RNoMSKzQQGqGBYIhhq4V+AvQoc8x2lEX+d3ZlbVUHQGK3ChMCoxsCIwVMM0I5gBXKgY68ZvCT+P+WdENF1oFjUJSlPJh0yNXdaPDpYUs3Go+l3BDsdUdrTY//8AnBeg/d5SmvQwAAAABJRU5ErkJggg=="

/***/ }),
/* 702 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA/FBMVEUAAAB3slV3slVckTt3slX/iGxckTt3slX/iGz/iGz/iGz/iGz/iGxckTtckTtckTt3slV3slX/iGz/iGyzjFVckTt3slX/iGz/iGxckTt3slV3slV3slX/iGz/iGz/iGx3slX/iGx3slVckTuujVR3slV3slVckTv/iGyhpVxckTtckTtckTtckTvyZl3fNEfhOUnwYVv7fWfjP0z5d2XmRU79gmrujWm7nWHMmGPoSlH3cmJ3slX/iGzWimBckTvdLkTEmmKujVT3i2uAr1briWaipVxwkEGPjkrsVVa4jFeRqlnqUFPmkGiIrViZjk1yrFDuW1jVlWXgimMWltCCAAAALnRSTlMAn+8QYM8wgCDfv3CP778gMN9An+9gv6+AryBQEGAQUHAwr0BAQM9w78/fj4DPcAFipQAAApRJREFUeNrdlltb2kAQhlcwEggHIRWDSjTaQ3oSQaEHMxwEsVR7oP3//6VZ8thRdja7Cz696HuZi/fZmfl2M0zgRa6+YONom63O/nH0gGruYDXNZjVaIpNjSOVteRDzvvFqK/00XCPw8r7AbGOAvNnJyjR79Ygmk5i2SoNHlHZoz1GGkqCpcu9ByhVRc4A9pkx7jJUHIqWTZc92NUqlzk4GJEvl7WciBZsNWlR+PPRISVVQUP3eUIt+3ny5+trv968B4Lrfv/pxE3veZYXJq1STb7DM72fPUaBUoYfCDfRV6KFVPql6PSE9t9wzHw5nIBIeEqImjEffRc90DDHDmDsg8AgP59d0qawRLBhKTS7l4YxHt6j5OIaE2cI0U5uCEJAPo+kktkw/jfFbe2E6BQLnociCFPBMrQ4QBOjxQM0dN50DQf5vCvwQ1PTOuamdOjoPdLho8eJ6VJxslhCCFnNpBoqJ5xA0OeMmqt9h0iUXNLnkojkQNLEyLbq8S0CwuwgjaHMqTSWvzQF9+OA+A0FNu0WY75YsSgVAtNp9KWlSCAa0JHOzYhGY0JU1CUX66e6uKcIA0CIfTLj8ByL2n4rCWJR/ClEBr4iJiH4ji+Yi+mVzniKQNj5sa10RC59aTWa0yMHHX5MuvUv4uIkY/JHm1EZiWFuPfiFtluCaTb8jXZFso6G1yF9/gmv+0tKblm3SoraYIcQzyPUFURhiaVd2JtwyRPeedIjVtijs2bprZEeyHJtMbijMzPLZKiaMNe1BkzqOc4UHTQbsose046o+I0EedHFYKn4RtAhrTEVN51AFn2nghKDAY3r4XuqprIDp07Sk3fGYGUExT4bHZsjqLqvGVsRuulhkvsnWo+Z4hYJC8wfO2ZxBkvQ1SAAAAABJRU5ErkJggg=="

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAq1BMVEUAAABckTt3slVckTt3slW+GTF3slW+GTFckTt3slVckTt3slW+GTFckTt3slW+GTFckTtglj93slVckTt3slW+GTFckTt3slVckTt3slVckTt3slVckTt3slW+GTFckTt3slW+GTFckTt3slVckTtup0x3slWwODi+GTFckTtekz1flT5mnUVon0ZqokhvqE1wqk9yrFB1sFN3slWElU6SeUibZkOxNji+GTFyVv68AAAAKXRSTlMAEBAgICAwMEBAUFBQYGBgcHBwgICAj4+fn6+vv7+/z8/P39/v7+/v74Z2YlYAAAHzSURBVHja7ZbbcoJADIZXrIgVxApaT+CxVGprW7eHff8nK2GcCkYXY7BX/W50zPgN828SVuTwpfRFGciEBnypWJ7nOVaVIwqEsIbxjuXQqVwiWoCp6cQ5xg5dNALRQ3zI0qM+lg+idYyZ39JEjcTzGh+lRxIZiWgTH6dPTRtEfFMg5XtchsnPhI3xzhe1smljHNKxyZcyTCCKnvmmdEjuo03MzilIRIOmfFtzz85P538kt5unU6bJWculAxkJI5Ia1bxy7rEJ0YSP7d0EW5b98+bXBIO5WyiBqLaHyELbtka64zrwi9XujYGhZwkC0e7/DQmYAkM4f/93yS0MlmgggCmYRgJDaSTgJgKTzxdBD6TJX0ZHJmSkMiIEjjoyG5icGnyRsbg88Eaufcw08AHrIpENvMUXQfhg4ovEQAImXySCC5sAtbMxRSbS1GITVwRTh010EWAiE02ETVwRmIj9VO8+qpSwW8emj69wX9XhzlSGmZtLfPr5jarHqYXqgLBWXMXYK4VY2UVVjKuO4hZUEbY6ga2vonxW6gSrWkE1T6hOEuqrmoBQEPpqTjRTGmb6aq6fFYNsj3c5oi6KmgyOW7H4F/29iH/85Tckf0TKH1r9GrH11assNv6q5S//K72O+C9I/iubfonA1YJrzf7iQqr+ACRi3W5MXVihAAAAAElFTkSuQmCC"

/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAz1BMVEUAAAC+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTF3slV3slWrQjt3slWbZkOAn1F3slV3slV3slV3slV3slV3slWAn1F3slV3slV3slV3slV3slV3slV3slV7qFOjUj+1LDafXEG+GTHMPlPSUGTBIjrINEvca370q7rjfY/WWW3gdIftmam6IzPPR1znh5jZYnbqkKDFK0LxorGNgkqxNjiSeUh3slWbZkOsPzqWb0WJjEyoSTyAn1Fjj2otAAAAJXRSTlMAQHCAUABgr9+/j8+fIO8wEIAA758gABBQzyDv34Bgr79AcDCPBe/6hgAAAytJREFUeF6Uz0sOwyAMRVG2AIpafjF2YB0v6Wf/a2olRqhNcc/sDXwlGwXZ7Jt3Pxk3QQVdJrKFWR3yjdGFhZxkDDIpQzENd+NC83+8JmIDzqSyRV2otoAJpnmoMjQ4zkIJOuk6CYmIX77Xnsdj32/3br18MuOsGSeOV+d115s2DIUBuBQMpfkg0jTtbpo0td3JB04CSSC0G+v2/3/TIFt2cl5ZtsV7VV/00XF8jt0SJw4jhbkTq88MYH7vaZowsUFfEXh/Z+lEIvHCAl0P7fR74uzp9e1plJ5ZgaIQ+vT96e3lJzs/aMivt7/2N4IELEno44c9nbmcF+Kcz2deooRQEhDRaUCupZE9KN1Jh96vyul5T34JDVBI17zCHlxZIKQWdFPiBKEHui1zgJaESbMcgTSfLooBigEK0NlqXYJT6YqdWut0kJYCitDJ9SUA7XTN9WittwO0Ysi0s8YAad1OChpXDwIKEeouzkE6hZ5UdPhfEQlobYJqwooq/vmSxgARJrtAR4D6nk+t5ILtEHV1g3hTMFrs2twN+Qc/dkS3JzRCXX0k/xgaktuwL8RQNE4oMUFHfZFy0Tpbh7NSxj7qxz7jbnLsdSah+8lvthLqXGdmHtpaQA27Mk3X0JAlQzAjXVsxlPcMYd+nY0ESmpExHUwcn4nuxoIkpFZmadsWhKFqhLgghqKYvNNdoYwLYogPzhE+gwMXBJBa+0u1bgsuCKHEvrltW+eSi5UZUhvZKRl+YLx750YIn4BW6zaXa63lCEcIcUK4/XOAOhhXhDgB4TsxprxClbiIbFDywOPRipct1XgTJDZIbeLJ7tqSOM1hl8HcmyH/P2+yYfLXCGHm7m4ctvhohbDDLVfI3A65O7z0hMx3E3Tm0Q9SjzZop3VLdgi7yZzy39O38ICwB4qd5skvuoLfIYBcJ1fy5HOUF7QhwskvpBP4QWqOFeFDOfeEVEAwsJWEIh8Ip5eyXtxNPGkAuU8uT0lm5oa83qeVskGY0P4PH0I3SPFG+UIoYT3eEH4n7CA3hJnFsKswUjdBKgmJEyxhVwDZM1uN1dwDAJA70X24XodQDeQPlLBD586jSCUAAAAASUVORK5CYII="

/***/ }),
/* 705 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABIFBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoJmIRPZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoL/zE35xFb5xFb/zE1mIRP/zE3/zE1mIRP/zE3/zE3/zE1mIRPZnoL/zE1mIRP/zE33wllmIRNmIROzdF3ZnoLZnoL/zE1mIRP21qn/6Lb947PstWjjsY/ZoT+zdzD9yVBwLBd5Nhrst0bGjDf1wUnep4nxzKPbo4V0MSF8OCjDh22DQC/637Cub1iMTCLnupbjqnX2wVrSlnugYEvirELepHvgrIzboX+DQR6fYSnPlzttKRr6xlT4w1fuuGTnr26KSDbLjnTqvpmpbCzzvl6RUD21d1+nZ1G8f2bltZLsw5yYWET42qzgp3juyJ/qsmt18jToAAAAJXRSTlMAQHCAv2AwAK8gj9/vzxCfj2AAUO8gAK+fv9+PAO+/r49gQDBQ49qzgQAAAyxJREFUeF7t2GeXmkAUgGEpFhQx2exues/MUOy9t+29903y//9F5BodEa6Nbzl5P845PF6GAxwM+Ol/gijJMhkny1Iw9AEt4L0ckoBwFxGVxSElGiMziknKQlBQJnOLCHOhIDbMo64/EJ4szIRC6DS6YRhmhUxSCg5FAajoRnN3eh7DLumwVRGBQnF+kFlyQmXbaZKpZM0LEtTJg8pOqHKp62UY0zGzGnJDQTLqwbAjSHxmpxRwOlCyrOuPqMJn5hKHBIKW5NvlMTNIHFJUjCmZhtEhEDJzXJuAZAB2K95n0SQzS3BIhEvx7PXbJofQhBGkqaPfNl2QYXAeKzaCpPEhhsdEJnewgn+hGOyf7fxyb3ayQuYmD6EQqBXTaHbIcnWezQeQFICiBKqUllPg6hiPAIkAyWS1Lo0xlABoBYM/WnYBklGIP5Pw1ZLJHxIA4ff3nNXSZYegEPZMwldxiN/f+CoO4fc3vsqL88vvrwRAon8oCNAX387ey7W1wNoreuYXsj5ubAY2P9PMjj/nJ6VvBtBbSk/2fDkZSt8NoBd0IO34cwDavNqmNPN7VccaMKn0hg0xlj04pCcrbfnZMT08yDIWDgfCYWaXvdo+Pv25nNI9zYDCOATl0vnMtdVdaON3utZ1Jn+VY8PWAVpn49qFIqW017Msq2vnAPZgybJOez1KabHQZuM+AfSaQ/Z2bdMFytunxHsP0FfmbB/GmhUMM9k3gL4fORzY+TyuFNM5NlVVG979W8xdO4WdE3PXCgIkkxrzKFdwM6k28+icRAFSycUR8yqbdm5WYZ95Vevz11G9yhBqvFnFQo5hDlFHEOk3GNIBUMV0lnl30596+LeOUCqVQpnqrfst0r+rsiWrtZDX0f3NElb1qU5GxQCKk4nqd+cLYLWb1gWZKAJQgkx3f7v11GjUPIBGY2vrtk6mEwESCBagw+BgNAUgODe/L1qABL+QAtCgqD9H5J8QCZ8nBpBfSXJ+r/1QV2NiwvQXpLbKRqmS5vFxrEixJacRNfS7PxpfVIlLodl/aWiCFJmjyREJ+UvDnSIIkiQlZEdRSRIFQQMAgfz070N/AB+BrXMgB/H+AAAAAElFTkSuQmCC"

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA4VBMVEX/zE2+GTHfcz/0kAwAAAC+GTH/zE2+GTG+GTH/zE2+GTG+GTH/zE2+GTG+GTG+GTG+GTH0kAz/zE2+GTH/zE2+GTH/zE30kAz/zE3/zE30kAy+GTH/zE3/zE3/zE30kAzLPTe+GTG+GTG+GTH9wED0kAz/zE30kAz0kAz2tEn/zE30kAz0kAzfcz/0kAz0kAz0kAz/zE3/zE3PSTj0kAz7wUv6ri35qii+GTH0kAz+yEn/zE3niUPKOzb3tkrORjj1lBD8vT33nxz2mxjCJDP+xUX3oyD8uTn7tjX1mBT4pyT1FS7xAAAANXRSTlMAAAAAACAwv49gYN/fn0AQ79+fryCAEBDvQJ9Qz7+Pj1BwzzCfUHAgz++AgGC/MEC/UK/v725UR5QAAAKdSURBVHhenNJLasMwEIBhg3sBrQzeaBPhQIKsQNBbfufV+x8oWjS2ppLatP8BPmaYKT4yUXKoGVNBjNUHQstMRRnXHPFeZdvjY/MORDBSv4Yw+Rmi+Kze7IxpFmqZ+lOsBRBk/kNBCCvYMAk+jtqs6XHkfBoUDH+DKnCmWdwuJpO+iRkcsQJQvSnX+zqG7aWvtzH2uU1Wh1D1UqZNMZ2TX7nORN2vLymGBhEu1C1ybUlI5iKGCCqRd2ZtwpwMciaVfngHAYh6iQPHSpBNStw7FECeancA6iHUJ6FdSxOffQLQs/SyW00YCKLwTGHVxPyRmGDRSrUgVOhFWwqFxnrT93+mXg3rZja7s7vfpZDv4uRMDn5PsIoWYKUIFe3BTk+dkYrOYEdRZ6SiAWbodGd42LzrLcyR687w18+7/gizNPQQLyTvegHzrKgz/DGuPjtEioLlR8u7PoCDJYlYtCz+Eg0ADXISMVghdk4RNlLRGt2iksL2iXqP6IU64xMpjwhPto8YD7tDnyi3fVZ513deUf36M8eVRe0SYcsNfA5WAtGCV5EPlBKIcD+/aNT1twcG8J8ydq6MDCQM3kXbgozSt2gHkFH5Fm0DQtbu/diDlKMh+uJRS6mdou0AYkrXorUgp+Jh67bT4IfGPU7O44RWAK3ouK/Tg82DRGpyInrTmjpIhJ15tCNbIanomRZtumlVoAgL+4KsMVR0sYuOwaKNXVQHi/DDJioxXPRu27QqTMTjHinqGFFPBdCF7KNEiiqpT0RFiXBJR0JH22GcKDd3ZLztIkXYmDtSQCwrc0cuEIsyd2QD0SzvRU8QT34vyiCBhkQ0+Elx3/Tgp8U9JkZNcV8p6iRyOpEM0qg/fynqRDJ698m09Pc1mYPo1f8DjOcRds3TipwAAAAASUVORK5CYII="

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAn1BMVEUAAADBaU//2YPBaU/BaU//2YPBaU/BaU/BaU/BaU//2YPBaU//2YPBaU//2YPBaU/BaU//2YP/2YPBaU/BaU//2YP/2YPBaU//2YP/2YP/2YPBaU//2YPWjmD/2YP/2YPkqW3BaU/WjmD/2YPBaU9sJhf/2YOfTjmwXES7ZUuURTHor3DcmmZmIROIPCpxKhvYk2N9MyK2YEiZSjV3Lx4m2EBPAAAAJHRSTlMAMIBwIAAQv4/Pn0Bg3zCAr7+PYADv3+9wQBCfz2CvIN9QAFA5cW3SAAACgElEQVR4XqXXCbKiMBCAYQETFAziCOIyb++gvnWZuf/ZZh4WdsUm3ZT8B/gq0CFURueyMFzfqasbqVPbRf3Tr6HQ9nd9KhkIreu2zTBocYbCYVB9bjEAysIQoeRqqJkXNrsWauaFrbYKC+Z5HE+WRZ9G69qpzM7M0sCpKuoDLepuKTWAxVqGGoBIegdOJhChVZcUTOEioyUoqal0UwEpl6CMQi/QVSpAxYx1sFiCis1tXZdJ1u6nV/A0FqC27Un6BF87GUIJ10OrtAih9AJMkQShdA9cRveFUuCb94SCCoSCXpCegpTRfaAJyE21DKXQJxOIkOGF73dr980b1zy0FJi3/9mGNJFmIH5Bz/YNIYBqN/ZCAcMcv96a7B7pOPVAc79zsA3z0TBYrjuh3OvsG8Y+swNEKOadvwdheyLEOu9H4dBEaMI5z+ApotBDp3NonD34qihUVEA7WtehPVAoAtoXPpeniQP55vanec/AFXdA2oDbt/2Z+7E/1BZcSD/fqT0AW94FFTp3FkQHT5s7EJbG7oI+QCggUNt41+4DSyZPMwWBMB2ZFrIgtHQgSjVnyt5aeUEMhAOUS0UI/3H8tuYg3J5SU81AWCA5VVBwEDYXoJtHp9GjL+HhXsqM3I48RayDdwQR0pXfecXbhgypndf5JDcgFhqz62mkTVjW9WomQCr2vZ/LEgFKO537mhbykMopU6V458RWAkT30jQoii7pjodUcCFNdFF0ShsBUjoGzLTnBpXI1GhR1TJ4HhLpFiGmh0kc53P3Y184TnnHQGyZO7NMXQutUUnCJ6WuhkKENkoNgJ4QUoMgVeK8hkEznBcPyVLZzmsgpLazMHxC+B8EDNBVDs0rvwAAAABJRU5ErkJggg=="

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAdVBMVEUAAADBaU/BaU/BaU/BaU//2YPBaU//2YPBaU//2YPBaU/BaU//2YPBaU/BaU/BaU/BaU/BaU//2YP/2YP/2YPBaU//2YP/2YP/2YP/2YPBaU//2YP/2YP/2YPgoWnqtHLBaU//2YPwvXb3y33RhVzcmmbkqGyIqSq7AAAAIHRSTlMAEJ/vQDDPEGDvj9/PIK8wgL+/gHBQn69Aj3DfYCAg71J6HNYAAAF3SURBVHjardfpbsIwEEZRbwnGIRt79wm0ff9HLFXbjJBoPOGb+58jOx4cxYwVm832xcAt1sN3D7CzGn7ag9B2+OuIQesRAjc3jK0B5XJeDB2w8+K20HlxywV2XgwV4HnhEhOg9KQl7QclqRi0pGc16Xi4/HJfrK6lrrQqk7n0pCOdiaisFaQTXfItJDFE9IhJDFFjIYkhqgIinU+fNObqu6TXt493us538ymbPN2q74KdBzn6t9I9tkaeo8n6FGtQ4qq0AyXOi46yIUl9yEK2JFHOakk+ZKWKZHU5qfVCyeWkHWlJSUuylZYUSVrMLEkM+cyUl2KpmYY6EhemZ4m0luTlksVuAS5KBgCfpVoOlWaySi5NQ04LilqQnQ3hA6B1A3ijtLcee1lyKQcFIbQzuXrsT8u14DXCJfnO8LdJZSS14G3EReGC8McUjDSXH0Zcmvk1lkCHix5zuLYEnw/X8aLAL6fa+SsmmruzsfG/SgoGzIYQbiBfrQf69/Xwo2gAAAAASUVORK5CYII="

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAhFBMVEUAAADBaU/BaU/BaU/BaU/BaU8pLzPBaU/BaU/BaU/BaU/BaU/BaU/BaU8pLzMpLzMpLzMpLzPBaU8pLzMpLzMpLzMpLzMpLzPik4bBaU/gkIPWg3HUgW7aiXjDbFLejn/LdmDSfms8NjfYhnWSV0bPe2fFblbHcVnci3zJdF0pLzPNeWQH8RsfAAAAGHRSTlMAEFCAv88AMI9g798gr4DvYM8AMI8QUL+yDqL7AAACSklEQVR4XtXY6W7jIBSA0WCbBoidNtMNvGdf+v7vNypNb0wIuzTSfH9bHcmKr1lm/1UoywssruEiz9AfczPTH+YECy1M5oEQBUWzqD+EciYssRz5QXQhHC2oB1QWwqOidEGUCa8YtUNEeEcsEKpEQBUyQQiLoDDSIHAiJB2qRHDVI4iIiIgOUREVvYdKFgex8g4qRGSFClERHZ1CaBEPLdAEykVC+QRiKRC7QVQkRQHCaRD+heYisfkVIqkQkdDdk627bW8HvvYH7dkkhCbM8cQ531qd9vs/RlVCEsoEtOffdVaIywaFyiSUg7PmstYKDVxWT6FcQgVAnXT2JgKeXqZMroQwQA3n/HQUro5NzXkzhbCEBNQ33Vr41H+Nqg2QrWNv4MKgsYZfOwk61Py7Yd0nQnv+W9MnQtBJew+G9uCAdpuLsc1u+mZ2ow3aXaxdJf5TCxDWZnpjhzYwvTJ4IQttpi+OxE/jVo4vjEiuzLQvJDu0Q3eEoc2UmfaG9M8IUmY6CkLwqYWZjoIwfPyVmQ6HiL4cxUFzWCDTIKws2UGQumpRZRMRAqmrFlO2NUGQumrlpo3W2LggZdVaoMdbv/PAuQ8EqxY1bEZr7gXBqlWYtsfcA5qsWqw0bdhbzuuAEcnMR4jzufeHiP1Q4w1V1mOWG7Ifs0ByQ+DYj6JuyHwUhYg/ROzH9Yz5QSxzXyD4QEXpdaXhghxXGhBaPtuY5yXyv/Z5WZmY1cvTw2ZPhl7fHlirt1cA3BD0/rH8BG31ufx4B8AOufsX0F9ND/F097j/kwAAAABJRU5ErkJggg=="

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAflBMVEUAAADu7u4pLzPu7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u4pLzMpLzMpLzMpLzPu7u7u7u7M1t3O2N7Z3+Pj5+nV3OHs7e3S2+Df5OdCR0opLzPm6Orb4eTd4ubo6uvX3uLQ2d/q6+ywsrTh5eizhVGKAAAAFnRSTlMAQACf3zC/jxDP72CAUCBwr7/fIEAAqEo8NAAAAlRJREFUeF7V2Otu4yAQgFFcjE1ITN12O/iW+619/xfcFq9pAg4DtlRpv7+tjmTBZJyQ3yxJ3vEI8veEpvBVStksKMnAlLHpUA535XwaxBdgtWBTIJaCk0jiISZgrCUCYQ4uEcQJlgjiBEsEOa9gicQ7IFggRAFJ8CBoBWiLEKiAgHIckgJCKlBoAUEJjkA5BJb5oQKCe/ZBXIRDQnqgEiIqH0MFRFU8griIg1L+AKIQ2WocSiA2IUehFKKjY9AzTIi5EBdToMyFVtB3bM+dH/jcXMGU2JAE3WmtlDp7ncP3fzTOyJG7o9+o71ovpHSXgWL3kNTOUekOXujSS5V1cOT206PVzsbH6KfXDbA00M+R1V/M+gRYp7pSqrY+dcntHerq9gghdZ+NvVIIfqlPHQTsS4JNWVPp00Z3E0HG/lr1p33skDnRkGc6NmqofkjlA1RACKTWzj24HPSwpANEHeBju3vY9uP2ZraNfrYeSh1n5+2fpMwc5D3EnJne+qGtmV4dQNpDS2emd0jQ15z1gQKA1FBuzzQODV0Pl/YEAEsNZfZM45BdriFhz3Q8lGnImel4CAxkZnomZPp/Ib215kNma82F3K1lLuRtTY1BztbKNETvmP1FKQxythY1Q/tTpXDI2lrDrHFrI+OQs7W4ht5L6x2hwqCx91vibKP9vouFkmGLlPNGpDTriIs5kOAGemdiOiTY7WsNS6dCKbt/Y+N0GkS583osaTxE5fh3kWUpwiFRLrnnG6QsVnn28upjXl+yfFXIqF+03v7c9PbkizyF9zvQX950v7A0bhMRAAAAAElFTkSuQmCC"

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABIFBMVEUAAADu7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7dLkTdLkTu7u6gBB7dLkTu7u7u7u6gBB6qCyTHeYagBB7HHzagBB6gBB6lFCygBB7dLkTdLkSgBB6oCSPdLkTHeYbKITju7u6gBB6qCyTdLkTu7u7u7u7dLkTdLkTdLkTdLkTdLkTHeYbdLkTdLkTdLkTdLkTHHzbu7u7VKT+gBB7dLkTu7u69XGzQ2d/o6uvm6OrX3uLs7e3M1t2vDyi0P1Lb4eTq6+zh5ejWpa2/GTHS2+Dp3+GlEyvbtLrZK0LV3OHf5Ofj5+m3FCzk0dTfwsfHeYaoCSPO2N7d4ubZ3+OqITjSJj2rDCXRlqDGHjakByC4TV/CHDPOJDvCanmvMEVTDRMnAAAAM3RSTlMAQHCfv+/PgGAgAK/fjzAQUJ8AgIAAYCDv75+PzwC/AM+vAL+AAI9QcCBA359gEM/vrzBDhk1uAAADcElEQVR42u3TW0PaMBQH8Ir3oKJu6gbK5uamyASnJykUKCDIRUXxiijO7/8tRkJpCMfSUh+3/wMP5eTXk5NU+593ZSIwOTXNrMxMzc7N/3CO5vB8PrDNcBZ+Ho0HzUkFWYGQZ2hugY3K9GzIE7SMGEwF3KHQNvOSmSMXaHmaeUxgJDTLvGcy5AxNsnEyE0KQdPxLGnJ8SprbfC5yN4Wio/QGtMxE0gZTc5br5txx4ggKiXPPFtCidKoLnTn2OTcMiXtY5Itu0aJM6oI59Tk9r0ITjOeWvzzLRgT3OaVCU/2Gz5lzsqe5VBr1+euLiCZ+P/RL++2kT1P4rM67XWQQf/nxG4/Gf9Yf2VBSOd66HI298xRD0df70MYn9Geul4Ly0OCP8AhrnzcsaEVHfxYsSZ0Rf2IwlPuVHrQBaGd8ljm8EXw7RP7AhoAW4co+1YycS7GQOkszJRn7kivVJVgU0CbYvfNXFkfentMsQ9UV2BQQgDIZg7kEVwOokCHH4h5ZjaHUGA3JagwZ8ua4R1ZL6BpKvWPirWblZG/TjopafQXXW1va1lYDdOvunGXk2otu4YlyZIYh36JU6/B9dVVbXf0KUGMo4kLeMTt3OZ4b25a5BPi9tqatrUVNuK8w/KnzZLKDn8fb31oezB1CNEIiLwCvSMpmxLpzV0gHeNkV0B4tI8neTIZZObkRzh12oExjAtqntAFQxXM66S68GGzSMIYPsvIM0KBxIiBCad0EAF1tCt8AnFIVwKzTsAVFqegJqk1Oec/lM/B+KD2woAjtpgOCuvTMXOl8RYevTVjQPuV5aAGPXvLEPOZ5ceuBr0wSCyKHVKT9JKiqm1Up6VVe+NSmIns2FKa91MvX0Eu+WXNAas08iFyX69aymA3tUjttE/p5fW6WahU5k9pjM38PVsy2vSRILEjsTea40wKXtDrHVGZ3AIpQJfV2o+WINNp1pThOBqAYxXnplE3zSQpPplnuvOC6vUGIBKnfHCYUaN83tEMk9J6W4okhKOYTOiBDENnx5UQJghJxP5OOYYgs+dsYhsje2E6YIEgkPKaTTDhAJOnPwVAi6cuRkJSCvhwJyUQ8OkHVwRDZPfT8hWFo3O0ll4gbJLIfHcnE5TVEEKKCnhgM4SQOuIWUCN4UhnBfO+HooW1EIwf8E/UD4fyb0F9HrkXFn43VzQAAAABJRU5ErkJggg=="

/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABblBMVEUAAADx8vLx8vLx8vLx8vLx8vLx8vLx8vLx8vLx8vLx8vLx8vLx8vKTlZiTlZiTlZiTlZiTlZiTlZiTlZju7u6TlZjx8vLx8vKTlZjx8vLx8vKTlZiTlZjv8PCTlZju7u7u7u7u7u7u7u7u7u7u7u7u7u6TlZju7u6TlZju7u7u7u6TlZju7u6TlZju7u7xxYv0kAzv7+/Q2d/d4ubV3OHzqEX0lhrztWLx8vLv4tL0nCnyzZzx7OTo6uvX3uLys2Hyx43y2rnyrVPzu3HS2+Dwy5n3pzH+0HT/2YPzojfznCju6ODv6eHztGLh5ejxuW/zojbv3MTl5ufx5tX1lRP8x2XOz9CrrK/w0af1mRuTlZja29zw17bxv33m6Orv6eDIycvzqUaZm57f4eH6tUjzr1TzwX/y06rU1dby4Me8vr/r7OyfoaOwsrTw8PC2uLrs7e3b4eSlpqnM1t3f5Ofj5+nCxMXO2N7q6+zu7u4gTRvCAAAAL3RSTlMAEGCPv9+AQACv758g77+PgEAgAFCvcDCfUM9g33AQ359AAL+PEM+vcO8gUGAwgJIzd/4AAAONSURBVHja7dTrO1RBHMDxEULsam1ySSiRQsba9ozdw+4q2SgJ2ZrtYt0WS1kn5fz3zeVnjDNna/XGm/2+Gh6/zzMzZx6oWrVq19bg6KOBPpfVN/DswcMKQ8ZvRh+7ek/6n/4XNNrnGgF1FejpgOvbd0LIrbq62psNLY1lQvoPd564ZZogIu413e34FzRqAl4JsOYuE6rMAUm3OspBD2Bi+qu/9C2/s1vY16zuG77QoLyf45Lj/NTnT53fpTOxGse8/O4FVt/lA/W7vLOI4ziTOhR1WJJ+jmUxS1l1LV7ovhybZFPRYx2a5nRULKewKp6w4a7uXoJqmibUQbSDwe9mIqdylcQXxVJE1lQDEHe6iQsdH7vlm8J68TRcupCQdL67FTWLL/VCk5BwCJxMNf0ywr6V0Ry+XN4GSUC1bOmdiDis6Kn/2V7NZ1jzr9jytZRqOdTAV+q9QI6s5JWEk4G4ZBFRA4PqJATvBSqB5H3rC2x2PgPNc7Yg31MjahAL/b3AN+dOxPvWMSujEt8OtoSaAYL3ctFZKRKd9rz1RROCLTWjesJ745r5vPU5bBwN3kA9IqK3iybh89YXPJfNy0sBoPysfqjJCL8V860nsefzm5CFZ9Welhxx7WbvsF/WJSiF8fJ77R/H7yWDWZzFvqUAWiG8VcxKTomJr9EZYPTmYpi19iHD+rCmQasCWEHr52cTFOzKZBawiDlCMk62jrJyYcewaHl8ylA+JmMYykCfMBSziSiLaE6u9tUfLyTHP59rnz9+eY4hHVIO/NPNUdSTJbIESOUzjxZLwHC2B3XSDaLvqXzGZav9kA3aiUJ0c4vI7B3s3zaf3sbedmwY3NqkIRQOcgkqxH0hdS968QK5cIJhFA5RIUGJeGVQPEE0h4YYFG5l0h5RFax/H80qENUec1rDHOodopQeFInKTlh/ufeYlbCJqnjAhod6OQTSYY7o7aesvInkrdQ+0csdgsMhkOjRCvFkp9OpXSiVTtvE08oRBYdDQmqnvB9b5Apt/aC8duYAxBsOUN7JerEypbh+QnmBYQBQGGoLUtmRaZnKEZUF28IKUo30UOjkYK9YFtk7OKFQzwiMAqS6N0RVh9lfG7lcURNyuY1f2UOqGroXhgDSG+sM0IoKdI7BiAlBI6ZlKvxMBmQ2NtweKIu0D8NeDMi/ttDt1mAwoAnBYOvtkPpKJnTFqlAVqkLXC/0BV0ywv1a0tz8AAAAASUVORK5CYII="

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAVFBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoL/6Lbep4nqvpn947P637DgrIzbo4XxzKPz0ab21qnuyJ/42qwvkWPHAAAAD3RSTlMAEFCAv98Ar2BAz59wIO/CFHeCAAABOUlEQVR4Xu3XC26DMAyA4QSCm9KC8+DRx/3vOWWtgGnMDjSqOin/AT65pokU8e/LyaJUFUZUqbKQsEzAXHHATR2KVUhXuLlK/4KONe6qPv6EyifQu0tnprqL61mqXEInDA1uRmbMDYx0khOkMOS8Wc07RlIP6DmPvZo/u1pmpgd0Dk7vDZFnVnUOUNNyDi+1EsT3oofOMHUD8+OEDOJo2G5IJkXYkDURWXpLIpyvG4fwIx1EWPU9BrrT6xaBM1Eh2QbIpoLwPVCyZSf7/Kn+kDrZEUl3aEGmukZAY5BoiHZQL65aGoq6agFeheDDoAxlKEMZylCG6CfEBmikoHEDZImRvI2EFP0+8n3kew00huy4SvnRIp2eIKjxhWqYoabd77TNAoJm90x1AzMU0moPozTABCXovVCGvgD5Xv3iploqlAAAAABJRU5ErkJggg=="

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABVlBMVEUAAADdLkTdLkTdLkS+GTG+GTHdLkTdLkTdLkTdLkTdLkTdLkS+GTHdLkS+GTG+GTHdLkS+GTG+GTHYK0HdLkS+GTG+GTG+GTG+GTG+GTG+GTHYK0G+GTG+GTG+GTHXKkDeNEH7t0DpXyjufUnxhBP7uEzfOEXhQDr4qDD9wkzjTEbhQkX5rkv6szzsc0jnWSzwfhfrayHueBr3pUvykUrmVkbRJj3GHjbZK0LEHTXAGjK+GTH0kAz7tjXdLkT/zE3BIC/KOzb2mxj4pyT8vT3ZVR/3oyD+xUXFKCzjaxjgYxr6ri3tgRHVKT/qZSXzihDCJDP6sjHjRzb8uTnILyr1mBT3nxzniUPjfkHkTTPnchXqehPSRiPWXDzMNyj1lBDbLUPuhRXvn0bcZC/5qij7wUvdYCDdMz/rlETxiQ7ngTDPPiX+yEnpgSb1oyv9wUH2rkHzlBsssQSCAAAAIHRSTlMAEFCAr7/vAECPzyDfn3AwYO/PAL8An4BQQBDPj2Ag7whOQKYAAAN9SURBVHhe5NLXlpswEAZgX9h3Pt4DSYxNwHmQEcW9b++9pPe8f4s0IGaExa5znf9m53DEh/Xv1P7L+B2v3nAgj9Ooex3/TWVqFc+7gQuWuEH3X6Ce14TKNL3ellCvDS+k3dsC8gPYIoH/EtQtLrV/liRn+5UX7D4PeXRUOlKCynjPQbydBGMC6UKIRaqbqoTIIahvQNKREpBkh9rGVx8RujEg5dxFRXdtO9Qyv3qO0Dl3ZgqKWHctG7Sjv4pJ4Qah3ynr5VZBCSZ/tmOBXAO6hn6CWbBergk6yZ65m1AIeeYIXem2BxmMW/VRTb8QOpWTssMNqFjEbwIzy9seZhBuVaSmkX6MULMMhVDkC0LjvO0DIVgzMkuclkLMQSUsQfXSsogVfEVoZIeOVI0qdRPygXIsMMd/6GVWsTjNfA2Bb0AhsDwM38s3rgRve1RUPND+GDChAQVsp/sfJDChWjnE61rhaQgMqMF2+rM6N5XjAbXNoSmNapcaBuTQKkJRzZC1HeG8JHOSnwbHgICgmYaoDfqnM1NDsAldIvSEzndqY8AgGiN0ViXIZwv0gy5EbfO3J+zGl1ZojNBPvXDUNm0PjVOE5tar3ZptUNsmJFh1Yys0Q+iIIGrbAg2s0Ls4vl+vd/doY0qvnGiTTuztHh5+iuO3rzC17M/rGHPB943aJpP/5ou/zdRfT/IwFMdxWRNaSky46AuYjA0R1KnPwxjDY6LGGxOMJnLrS+D9/1dZ2aHdIVmbXfi9IeHic/FrO9il+K6T8ue0hEJjAWPt+p2CMmZADMreVl8I4dr4/PHfMxIKNDTUq25/GVwbh8HhIw0JAxIaCkd43Yy1EdLDxwkJdUA3PsdZcO36YU4uQMcNiMO+6QyfJK5tPtXtw2wKRyAJVdFEn7ix9usBdBlBlbIgBVhyFW9W9toIja5DOA71wGi8Tq219fNP12MwYhbEwC78GN7cptXam/juX/Q/AYyGAvBMWJBoC+r4QtyCeGuQBLp5VvyUzYFO1SBFMou80OWLhlCPdJZF1ZKUWA1iFJQXB+XNoIDapzCidhI1SBBQZkJZA4i+SIUVAfEaxFuDpA+kCEi1BfV8xmYExNyPn4YCnwspCEi4PxEa6vg8Wk5A3OMzQkMKnFMkNHCHBiTEpasjOQ31u25Ot29BKEkXR+4dhLBB48UV7oOQX38d+gbHQod9DMQd4AAAAABJRU5ErkJggg=="

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABL1BMVEUAAADBaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/0kAz0kAz8pDr0kAz8pDr0kAz8pDr0kAz0kAz8pDr0kAz8pDr0kAz0kAz0kAzSdjn0kAz0kAz0kAzIbkb8pDr8pDrKcETOcz78pDr0kAz8pDr8pDr8pDrigiT0kAzBaU/0kAyKSzi+Z078pDqNTTm6ZUzhgSXHbkfQeEq3Y0uRTzumWkTXf0ftlT/qkkHEa0vXejLnhh36ny/MdEvOcz6sXkb4oDvfh0XIcEz1nT3LcEL6niz3mB3Te0ifVkHFbU7UeDbuixTefymbVD/xjhD8ozf2lRizYkn7ojTbfS7khCGUUTzqiRn4miOpXEX2lBX1kxL1kQ+YUz73lhqwYEhrnwXSAAAAL3RSTlMAQDDv32AQr7+An3BQIM+PQIC/UK8wYJ8g73BAYBCvYO/fj++AMGBA378gUBDfz8cLPD8AAAKBSURBVHhezZjndptAEEYRIIqQbFl23GI7vZfZBdR7ce8ttZf3f4bYHKTIBnZmpT+5D3APH7OzM6D8P6ScjGWlppXYFgTYU0hUx4QhWm5SSzajwxjpCZ9lVoOQKYLlHB1uMTNJJBOiqLIWw9EhhoysxtYgFsmKOQkaMOVOng5JZGVSmTCGz4+KMEKfPNUR534VhszSD44FN3H9K1NRuvbZaK2qV6ZfksmMDARETZtSydQZiKXKec2VSJbWIIFNzr/BFRrJk4Fk6rxGbQ/DAhHnvEq7iFQdhLif6wBg4B4NAAaDssBUpNxE6XKnywJOSydtiEIs/r0SG+fTAOLBptAau013D+JAPEsshjP5q2iOxfKlDCFFNxQ5Qk+eJXAxjFf3q5TOf8sw0x/uu3jnzzOGmmp8E++PDSYytcOWPcdvayakGz6Sjxb/DhPTCXsfLf48IroIus/l77HOn2MIJbjmeiAZiAijTD3WGB9py1UeFZ1CgGYoSNVQ9mjLDC7q0ObQBioq0da9NVTUpe2x6/dREXHkL1FEDkG0TBDphkLgISaibvrrD8SiM6Rk5NN9Qt/SVoWito0Jniw+LhS8Eb3e14PvUU9JHOz14sKKF8Pl/sHPm6JHomB3FzwB++/GX7WgYi8LHkLvx2jeCjyvVjyUy9+h56kglkciiPfmmZLMc5roA2Mv8ooIj8jqMrIsUkXYdpbapXl2UVGFJuqjIjjcwjVbh4CLYKeJeZo7QBEBVFoiTatCWYUVCDhutGITbrUaxxCgYFgwpN/Ybo6lbDa3G32Jj2BVAwoq6TsIRcvSflYAgpVTaORsUT4zJf2PKopmpg1FllzWNi3tXx7LTqtkwV9E/9IZNE0sKgAAAABJRU5ErkJggg=="

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAC7UlEQVR42u3bT4vTQBjH8byEvIS8hLyEeQm+hLyEvIRg/+mpNy+CgwfXVQtFKivFwoiigusyru5uuwc3By+CyBz0ImjHnyyFWk2fbDqNk9l54EsvPYQPM5m0pYEfP/XPj4cfY8RWigPX5/TW1RBxJBBH4RIKQxwppAtSiCPmKpBAein5dbD/G0YgfcGEc6tqBUd/2hnQEHSpS0BqgaPui/IIdNwVoATpz7ujCghkmRNIwMkqI9AxF47wfItAedNxEqS3XNJkIFkDkGwqToR0TUV+e60vaSJQ0enlj/z/AMQ90PqGHugf/Xyyr+cvRnp+cFvq05ZAHGUoQdHlBNqb6vnruxoAZZIosRWIGYV59KEYhi5HzEYkZWQrjQ+1PurTEHSZbUDcCM70enkEOu7M0zS21QLHdKlNSP2qQHN5szoCXWwLUIhkhSN8MwA6YdvPOqr21UPHbEPKS96YDUPQN2ybttuQBHo+rgtI2fwQKYqA8NHBHAJdbPuXaikaIoFypOaHN1SNQCxo2uCiPZAH2gxIbAvkOzqbdvSr466eHPf04P01vXNejgTqowSFNgMNtwEDlAVImRTKUGgjUGoSByuGgCGhrtgGFJnCwaohAErXtw1J1I5Dx20CYpvgzE461RDoksbfrL/N2tUB6BSKbAEKUX5RIBzfBkHs32oxUrWvHrrINiRZBujgpFsXUGrbqRaiPgX0+KhXF5Cw9Sk7Qrxg25kDoFNN+MzGULboy6zNawNCQdMGF8080Hqg2AMR44FooLwmINlUIG4CYPSyp5+OO3oy6eh7b4mn6YYBJZvi7D3r/vEnHLnb+guJ+I7I7W325kF7gVOElFtOQK8iI0DFSIn9CjSSMLHFVnt3p6XwGroAFCJVFWksipGQdAUp9kg0UoSkR6KhsgqrSaEMCMllQQpRWmJFSZQu/2joJhINxlYreGt5pMs+HskjeSSP5JEcQwr8kEgs8HOO5IFKIPktRiMxlKHU36T9mJ1f7RnM1r+UTKoAAAAASUVORK5CYII="

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAzFBMVEUAAADM1t3M1t3ZnoLZnoLZnoLM1t3ZnoLZnoJmdX/ZnoJmdX9mdX9mdX/ZnoLZnoJmdX9mdX/ZnoLZnoLM1t1mdX9mdX9mdX/M1t3M1t3M1t3M1t3ZnoJmdX/ZnoLM1t3ZnoJmdX9mdX9mdX9mdX9mdX/ZnoLM1t3TtqnVrZvZnoLYoonM1t3ZnoK8lIHM1t1mdX+gioHSm4JteH/N09d8fYB0en+RhICDf4CnjIHXqZPTurDWrJnTt6rUs6TXpY3DloG1kYHRwbvLmYJ+PBz0AAAALXRSTlMAMO8Qz2BgQDCf78/vQL+AIBBwnyBQgGBAgN+/33CPn1Awv4/fr6+vcK8g3xBokCuEAAABwklEQVR42uXU13aCQBSF4aEYEFBQsXfTywD29Pr+7xQWy3gSxxk4DhdZyf8A38XmMORvZ56Va1oeUI9SqmvjUkkWip3ZdB7F2cW+jGbR2TKCDtcKdAqMlFaYR3uzGx4OqkS8nCYKKkX86ihJANko6EQgoaAi33FQUJMPFVGQx4c8ks9ITYLrOGKbr6dBUB5UTQxUZ5jbN/pVz9UOvu1VQL9njTJL9g9nOaM7DXAjgcNUO2CkVeywufjf7ZXuzcgGTbbOmu6vnA1qbKEPysnAvUlLBkDu7WygOy5kkTil3W5le0oCys0kSjeM6yjC43ZgIk6GooZJqlAaJ5JD+V0kTrrkNSan/QrfuV8kCEjieiIHI5UFDkpy+Q5OMrkOVtLTHJB8ITRKc6Aham5w2MSQZjEOCoJMi3FwEEh6NuecpKUNBA6kkPSualaqc0SyZVTdSykHUtR8HJ9xFg+PTwu0Q7rhbs/JbFhHCZk2HxLnkBYLvWwkxsFC7zTpWkNBSsiVdJzUzUvyVYSEPsijgqQE9ywngSMngSMngSMngSMndRJGjR1J6abdCdWhT4icBP1HieQlGXlIAMlLOskj061q5Df2CdU2P1CfrMD3AAAAAElFTkSuQmCC"

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABPlBMVEUAAAD/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/g5v/rDP/g5v/g5v/rDP0kAz/rDP/rDP/rDP/g5v/rDP/g5v/g5v0kAz/g5v/g5v/g5vqWW7/g5v/g5v0kAz/g5v/g5v0kAz0kAz/rDP0kAzqWW7qWW7/g5vqWW7+qS/qWW7/hpP4dYzwZHr0kAzqWW70kAz0kAz/g5v0kAz0kAz/mWP8pCj7oyb4mRn9qC34mRnqWW78fJT1kg/8pCjqWW71kg//rDP0kAz+qS73lxb7oiT2lRP+qjH6niD1lBH3mRj9pyz1kg78oyf/g5vqWW74mxv5nB3uYXb8pSn/knTtXnT3c4ryaX//qTr/iI72cYf/nVr/hpX/mGf/i4jrXHH+gJj1boX6eZDvZHnza4L/p0D6oCL/lW78fpX/ok34do3dmGnXAAAAQHRSTlMAQL9gn++AIDBAEL+AjyDP33CvryBw7xAwYDDv3xCfUIBgUEDvQM9wj8/P7+/fEM9wj59Qz99gMM+/n7+/cFDvXYgP5QAAAvFJREFUeF6l1+WWozAYgGGkQCnUpyM7tjPr7m5fsPq4rLve/w0sJadbSEKSsu//PicJ5ONUmbZs2/aC8r8tuatjnOO4rm0XdRbWxmROy12xl+aFnHFOq86Gu7ksv6CxoIstd1Pm/OyxTPerZfGKZHoN0KhafOmZDPQTJpVUHnTmmtg5BBy0LZ50/YuUgzM50s2n+29+cZwPkK7OO/ZLOztHJ8d52FvIZOj50IWdpCM2dQpE1dxTOo+h/U9MCKhKbOcldo4+j9n95kj0vr4eC14isXQlXsw33lN7dwp0TRr6ePJH/B7RqRTEOOF4gHRsu+O21rDEgowKCRGDrdVJzyD7ztXD99+BVZuENtNLWaEHow45bZPSynRmb+ABJis9WKfGf6flOK0OZuSlg7PKvF2OmNDi+tzS8xELQvMvqbYY0FAXFVjSbRQwILSlzN0NWvIRusUHVLOkTarqsxG9hdBB1olQXC1fKZcMmNVoTm/CIhp6xM7iXuQxlgZEhompuwiFmQUNY6er5TgmMGok4/7e5HcpJ0SJzGQqbWCnx1ANxXkZpx8BqCynDsCRJpA/hfoI9YK871wb8nuYQLMn5/cDLLa550NnPMKQD0T0aavA7XENJXmkREF14PcEQ3siSAdBBxjqkVCZgBogysfSgP81UUHYCEM/+FAJxA0TqM+HGiBul3VIwbmMUwaQ3luaiXZRFtJloAhD0cwZhOREMkGmMHNLwEv2qmTSpCA/DUUJg14VgbopyOslj3CkFYc8DPl+dxQBVItDWVwvAu0xLptVBPLpN7tBDUeZhvRdq9LTUdwAnzV3iGyD7F0LM05dIaqAOA9NCohnRlaXPOqQOGqqpuQQGQgWpFhyTsD/FIlHpOczHMNiQRaPwcsZBuTtYFbNZUKU5HtZx1TYVQxgF+32YmXPE/3Rkv8i8e6G/Csg+IMs/+Q4f9kLS4apCNMNCaaiSGRpgk01MSORmk9pzbIyT1ZTMyijZKpKsSz1X8J1/AVBrymvnAZZMwAAAABJRU5ErkJggg=="

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAZlBMVEUAAADh6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3g4erey+DXl8nbtNbe0uPYnszUebvcvNnXkMXardPVgb/Tcrjdw9zZps/f2ebWiMJtxH71AAAAEXRSTlMAYN/PQAAQn++Aj1Awr3C/IKXAr6oAAANGSURBVHhe1djZsqIwEAZg2QIICJ2wLy7v/5IDHU2MHVmsmYv5b05Zp/yqu5MAcvr3cVwAzw9UWAgQhSz4klPwJTFgzq9vJhF+9thBKIVnXCyKZfDM+RjEXFA5s6UcFecQlMFbXONTlB6ALrASl+2GUlhNvgvynTiLYCP52UlXoCTLI9gfL78wKxTC4XjMAiXwQzILlMEvYRTKf4L8vwUVeyEx574CBRSKP43rrZ+eeZTV/UeobtrJzKPj1Ik2INFPlrQDoXIL5CiG3xAYb12NH0VVPqlR7IB81dU4K22DiLKrUVK3LYjFEch09iagauWouCn5BlSEkVqr2Wk4WMJLLVHqhAzolFN7hS+pqCQpCcWwO9cWJXp9YjPkwIHUKN2oNEMuHJKwO0Gk9BSsAbwrcS/0+oR0uJ8IFK9BfGgnleZF4dp1n9DlFHgE0BvTSPXkF320tJaszNVMI6VhUWs67MBdc8ZBCHXWBoTuloVzFuhsczj21b5mce/fVqune4ktUGGDbrjz7lpuFqjXvX3eTE7kIqvLb/nS4tDLjko1GkG20kVCDoUabOR1UBHiajScQIWEfAotky5n5/G2Wo3qjUBMQiFxZPGynbZ6O/utHXIkFGnB/E69OLWh26EQIce+Zr38M5i6Orj8HYoQyinUS6FXLRgzupLlh2SGCtiG9IbW9Ro5z1D4BWokVKJi7KMR/2skYpbLiD4Eg158rne2sF1HHAXRA3KX3UxjJUQ1TqqgHmdNL2zRt9vFgCWRK5KQpZGKrDOqX0etUYg6H6PsjM6IeUCDnZTq/oruVc98BCDLr+7WtDecM6967KXiajORgkJ5aG0Ub5+SGS6dB2EQQspxTek6YR71uyMeE6Y2mNUnNj3mRlECyzEbc4vNB3a8FGHGcphTthN1IN/xMMr7iQadgxBuR5LRGBq4uyCoe/I4Ch/Z+1tENK1myo7DDigHe+puWNIJsCX4H37UXI4r9lVj3g9QQqBFyg7Xg46GNOX7cbhrVl4WJ36x9QKh2BhXlO5+pXFehahDIfvgI8Nxgl0QfTvi+sYyhMEuiO4qfKeVqKI8dgTSGz1KJFzkaisfhBhKGdM1RtLdgmjS+JIatBMnyiX5A5KGL1qXzD8SAAAAAElFTkSuQmCC"

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABWVBMVEX/6Lb/zE3/rDP/sTf/vkL/4Jr/2HsAAAD/2YP/3I3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/6Lb/zE3/rDP/6Lb/rDP/zE3/sTf/rDP/6Lb/6Lb/tzz/zE3/zE3/rDP/6Lb/zE3/6Lb/2YP/vkL/zE3/6Lb/2YP/2YP/46X/3pX/2YP/6Lb/6Lb/6Lb/6Lb/zE3/24v/4Jr/4qL/2YP/2YP/3I3/2YP/6Lb/6Lb/6Lb0kAz2mxj80oz/xkj3oyD/tDr7tjX3nxz8zYH6vGH7x3b6ri31lBD6sjH5qij8vT3/sDb+46v/uj7+0HT4sUz/xEf+yEn9yWP1lhf/rDP/z1v6ulv/rjX3pjf2oSz92Jb/vkL3oy38vUb/zE3/uD3/2YP/6Lb/4Z3/35b/5az/2ob/57P/3ZD/4aD/3pP/5Kn/4qP/46b/5rD/4Jn/3I3/24n/1nb/5q//2HtxDMJOAAAAOnRSTlMAAAAAAAAAAAAA778QgCAwz8+vUEAQYGCvMCC/j3CP75+fQHDfv+8gMN+/j68QYFDPr89gMJ8QgFBwnbWlggAAAv9JREFUeF6slclym0AQhufiLEdVcZEulFylOBGgclakp+melV1y8v5LjGKPOggNDPg7zhRfNd1/A3s/QBLt2FuQLBDfxBThM/FqtmeF/1ikwTzRAS3hYY4oRcJ+hmhNPOLrnQN2+2ofLYhGHmH7wQG7dZFQC9YCAB4nDY96ilYDSuLGf3a7SzHZEVqOsnXuJo5Lni1nj542uhTrgucKXmlsnBI/0XegGIkWz5f7fCKagjb+58deWO/pcoPyxXRqJNFoAVuPHAVh+0zJOS8lUjIFPqJliL2U5yK/jO/2xqEBkOHS8xtE0a8ayBHDkauyxy51o4DmcuMV6u6K0HwH3hVJagHFX+SxV4+KLFdAEbXdEzaKb5wLY5NNNBb+MCJHSSwVdFGcaLCEe4eIpLHomPIKKRxGiJJzqmtzmZOotFXYu2R0quuMP1MWGjtw1doXQ54ALa49yTBlbtZjNKA04sDL2b13rRu0vT+4RVbgWDfgOLxvt4oxcCHDiaJKAOFUoBV59EhXQgGFaxwliqmk4Ab+J78sSuQW3SsjeIsxtpL+39KKudnCLXKqGQwke/gEfaimRsqaDfKjx5SXGim//7y7gl2d/HoCiupa8G9ndLPTIBCFYZhTXSkCwYgmgmli9+6Bdvr/iw6KoqKDRo3e/x3YidHacIbO6bv8Fk8yZxbDZwGVjOokbq8vf4zPt6/31/Ueh1c3UaoJiXQ0frrrx4t/QBz3B4P7hzAMx6NU6EJLqtsJ0TrdJUOAZLPJtBetiKg3nczkToTwSJC/2fG1IGhucpqgB8Epr2P4+S6SgY1n2TxRWDyZZ0cNJAMbDzMZSwreXhFtXiRM7icNbchKspqOd7AMdG1xpmIYNwHwY+P/xsu8quQlFy4QoEDIeFGyPy1nZcHl6lEgW6gzKRDsKR0XSJCrhDwaFCghSwnRjuSAEqIdKVBDtCNZVMhTvYwKWTh0QIbAQSGbDgWY0wI6ZGL/5m0BwQV+ajoEXsUxt4PA3l9zXBN0IJzyfy3Ht6G2byPZ9nYivtjbAAAAAElFTkSuQmCC"

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABTVBMVEUAAABVrO5VrO5VrO5VrO5VrO5VrO5VrO75gJf5gJf5gJf50tw7iMNVrO5Po+NVrO75gJdVrO75hZz50tw+jMdVrO5VrO75gJc7iMP50txVrO47iMP5gJc7iMP5iZ/50tz5h51OouL50tw7iMNVrO75qbo/jsr5gJf5gJf5xNH50tz5gJf5hpz5gJf50tz5qbr50tz5hpz5laj5jqP5gJf50tz5gJf5gJf5gJf5jKH5u8j50tz50txLn94+jchPo+NAj8s9isZFltNqsew7iMNCkc6IuOhDk9BSqOlNoeFKnNtTqutGmNZImtn5gJf5laj50tz5n7H5zdh+turQyeH5hZtVrO6nv+X5qbr5s8L5j6T5pLXay9/5iqBfru35w8/lzd75uMbybYOdveb5yNOxweTqWW7GxuLv0N28xON0s+v5vsuTuuf5rr75mq0NN5UAAAAAPXRSTlMAQBCA77+fMO8QQECAz4CPMFDv75/fIM8gn2DfgL+PcL/fEFCvIGAgv7/fcM9QgIBg30BgYDDfr59w3yCvIcSLxwAAAqlJREFUeNrN1Pd30lAUwPEbIaxaC9RutLVaR7XD2TpKpCZaWnh5IfBC956O//9HQ5s0IdyEDI7Hz+98z7335QD/TjazsJDJzEAk0++WGuRGfjkDYaULKWL3/E3EjOUhBDeXJ4iRdNBxlggun4UgMiniJvUW/CsQRPBDpZcJ6ujs7Ojm9Wb8dUYI7kxnrDcH3c2YHTxkmHoGXWStM6OrmRqFdJcO8iNc6qPXfT4ga7iaSnvdGQ/hXmcBN4Lcw1MKLy2TwPLYdi9JCK+QByNbf5pNZQt/9nYNWVZkuUF0BXCY/lSj12q/G+iHaFH26Y3az6ZMnJ/mGL1V2/YKySe0zQto00ftNt1XU6jT+7bFZilSQmzTDmNgM08dtgmmcUg7DU7bBhqkTgrSUWoUs4gM5FVSTihuDB3IcrhLLLtNI4OYBdMixe035S29ISubZgX3GQxfaDR9YKARTVofYzTzRmiyV6H5/yfU6xvBRa+e/5hGcgEmptEoNCvE1EsaVl1lVki39+s8xKkOTq8Ys4UMqlYPNIvWqiAhI3Z+QLvauTxWmQ4NWfbUY62+gxfqp9p3YxAshLtSVVUzqLpvDAemARbJANxKROkkwCY3FDYzlIN294QwGWF1FJwmihUhYKVSFB9Ah7uiTqqW1/w01spVSWx5DB1GRUNJWq2WhTWXglCurkol0TABiPuiQ1HSVarXKpKuKDo9BQRXLorBSI8AxbMVKUDmh8DGAcW1brD+1d8w6/oRh8AFz1o2yhXjmriSVBU2WEsOXHD211nXX0eyj3d9+RW9YeLB1RMWxDC4Go4H6MTAQ8x/px889fvtxJPgKel3uXHoYtzvv2JXCf//itFL/XegJyUe6aBiIe6DS/Ie43AQRDIRx6/MQWBcjG+LxflYDkLjTMPg7S+JwxyOR4MvJQAAAABJRU5ErkJggg=="

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAEeElEQVR42u2a62sUVxTA8yfsnzB/wn4sFGWI+ECRbBqKDxQHFUEQ3H6opZDCUNHUgAwxPmKQTlUiNWk7EmjUlHZI1RCT0LUJKrHF9RHUVux8qY9q8XiO5KyG3c3uzezM2bu7F34fAsnOPb85j3uXNEmtfweGDcRCHMSfI4vAez97iI2YTfWy5qRkEFAkQFzErFUxKc6QCuAjRq2ISSAuAhUmQCzt5XA5RYilsyCfA2lIypdjIxATAWLoVloBAjHiNrKnNIYugrJCgtI6yDEQEMLX5UAIQgRVLadzzQfm+L797q3uXmAeuv2RSnk+fHEe8GjIRJLVIsRAHCSDQDG6Wk0Y3L0Tpg92hRby1BuG/0YvwP8z50lGKTzEQhISYlwEVDm2bhWLUhbzcvwCvJ6lwJUJEDsuOTYCYenbtgGe9A2WV0a/XGQxYckiyajEJBaTNaVK787xUwvJoayhwCqNFYWcXJ+JS9Kr3xXkSEpSzhx1SXnl9uLXtxMpasxKyEmHEqDQk1jOs6FY5HDzToQtrQCBOJjsOECCeITHhSs3sdSPADSx4pTDGELZo87U2Q4JQe5iBFkIxI3XvkVCUCA3udSREKQ+0fjcI8G9kWMSgmxVQSDF9PcifcjRRtCV3s8kBPlly/n4u3+MhqAFVvOhTLreBF2fuVy+oFTfAy/d3g325o110YPGr4/B9oE/QaXEfASITd/chF1ffg2f7/wEOlqX1cQU+/vuz+BPTcCRSzNgnXtMcRJZFUEOAoXY0juZE7Z3XUskgl7c/iESIe7oDfj0/CwUic1REZRCoBzWn7kPWw+PAJXknt3t8MW2HZRpEidp7iVAMvrHp8D+6Q5nSDlYFLuKpACBEJA4ljdPIFNI0NUfe4plAQXPkACCyqSwCHWSqoJcBOoE9bsYGa0jQXybV5Zkf/TtXzUtp+3s4wyX16LWh19dck1nAlb03ICW0/drQgq99NUn/gCKC+ML9x8h9AEIMEs6R2FZ9zV6AAnTRsjak3fpJbMUJldaYSU5CBSDHrr86HROmmRZ0vNJxqreGWju+g2WHhwrtu8ASVRKUALJIqACiaNN0pujDbNABq805WbAvL9b496mz8tJICizFfeXUrNQumGbGBBvih6gHZRNlOkre256CqGrTTUEGBRGWUEP5dquGmg/1CvphVLWtfW/u3MhXFqRSPKKlAJL4x5A4ijbopLH5cUlTM8tVbYBj/QoBSWQTIiJwr2EoeAKQb0m73c5ExaJyXEISBJD+TLakLSAnIak+QR5ZSUhqUpv/tm8hiwsKl1FcrzCo1xeUhLJCpdUWkyAQsnZAnJ8RPFmLp9Nfky9JtWk66IpEtGkyyqMbz1EVSijMtGLkS89BwkUm68rMLbls0rg/qTXKiWo3uVYAveo2mvYPLEaYupVFJ1wEa9xBiogJuKbfibclJO/jwUx3sOSushJsRgBHB1OySCMrcHJWBS/2rMoIywopcsJ2Yv5y7I0Yug4zVKIMxdEUCEZLmIjZi2fqBkSaBfAZCRH+Bt0+NgPF1yg2wAAAABJRU5ErkJggg=="

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABdFBMVEUAAACKSziKSziKSziKSziKSziKSziKSziKSziKSziKSziKSziKSziKSziKSziKSziKSzj0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz/rDP/rDOhXjf/rDP/rDOZVTKZVTKtYin/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDPtpbKeXVClXC2RTzWXVDO4aSXTehrnhxL0kAzafxe/biKyZSjtjA+rYSrggxS4dXGlY1nGgYHnn6r0q7q/e3mKSziKU0SJmrGJqsmKW1Cyb2ngmaKRUUCJkqWIyfmJipnMdh3ak5qnYzfMh4mraWGAXVp2b3xwfJN9Y2a9dTbFfDZmjrVpiKqHUUPajjXilDSRUTj/rDP4pjNVrO6vaTZsgp5zdYjTiDXwoDSIwe2ZVzfpmjSgXTdYpuPTjZGJgoy2bzbMgjWJor2JcnR5aXFcoNeDV0+Ka2iXV0hilMH9U35ZAAAAMnRSTlMAQCAAgJ+/z++vYDBwj99QEN+/r4CPz3BAACBQn+8wAO9AcHAA74Cfv99gj+9QIK8Qz0WwIxQAAAO2SURBVHja7dbtQxJJHMBx2RY0TS3t4ayLCSpAAzXJHsjSSPidomaBIUglDnjnpVlalw//fDOzzsMysyDny/y+W1g+zsM+2HHeeeedNZ/PutCyDs9vLJ/tD3SCqCtw0e7uaROyLl3sAnMB23dayOrtg6Z1+ftPAXUHwFD69WzmNcj6bKs51G0eTDpDS4Oa3/KG+r3mlBWQmn3ZDFmuSf01Nz+X4wcL1Flc0har3wT1u/fpzTLprRhSfuU9GOrVIRtoxSI/ZX6ZBoZWS2V50Hm5AfID7UO9vrsKrB8e0H8/6/W6QepQnWKddgCsQzKmOR3apaeUQJMcqBtYBwwSs8vlQI+dwka9lM5ms0dEklAPP6tETjqGph2T2ZeYM5EhTZCttAWk7Hu5DMb0M9IZcXH1MMiZWPslHShJb2QKyQGZe3TSpH65zy7m8wtAsxhkeRmPnzx9lpI9n3oEHtkMuiSOj9JHIHrxPKX1bGrS/JBiUC9nVtiUnSYZo/dy2igxKMAZWvbEmUl5Nd0cyk5kWK+A9YT/7MrAwODVq9cGBq7zT2aaQsmM08oSsKZSpMEbfwwp3bz15206ORMURB0I3RFXVz4tNp0wN4f0bqRS70xQiEIFer0vOozcs9tDxq7N8H0rl1aBVwgTKFhw7sBkw4V4954h333gDr13BRQhUKgA5vp6G95glvqG+ane34UohdbAu86AfZI/4HoUl1yPpUqMQOEKuPtYPy5Ciw7o8233Ez9cp1Ck2vBIJqd8aAV9rKtLtIEZVAORnHyLjl0nVfAwhfAmKBWdv9Wiv9VH8kYNYwa55lZ2Jt+qf5R30jo+gXDBPX05oOTi7ILy8j3MmcwtLKB/N0BJGc4suW/EIyr3mbyfNGq7iiWEd5ikx+5jfvB2mfTZLX3ZYgxb7BHsLX11XjhO35Zph6C0h53Y9gcxrbZfIa1tG/4vEqv0nUI5dTw1Dj0gEIpjpS0+NLlIeXF0ODf/A2QbO5iXoFAUq9W+qNArvkjm7eLFEYWCuIm0kskvgbk9LIoyCMVUR14M5tQFEo06UAjLnC1s04kiB0Jj7UsFxYmPcmg8jt3V9tTfVNZ3GF/dXyvI61AWRhxCCdxYbX9zmxiblWrjF9Uq/0hMTELk8v7fPRxXIRQ9myMhNHI2R0IoEW8HkOujQWg01i4TTyAVkoXj7Q1nHOmQ03jk9FQsiJAGqdTw6UbDGQlpJaKthjU2IiclIVOhSMxzv6Nc0SFzwZHIWEydZywWCYcEokNt9htCvwB2YhwwipSfaQAAAABJRU5ErkJggg=="

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoKKSzjZnoLPlHm7f2bFiXCtb1jUmX2oalTAhGuUVUGjZU+ZW0aPUD2ydV22emKeYEvKjnTyHVu+AAAADnRSTlMAEFCAv88AMI9g798gr0hldpkAAAJsSURBVHhe1Zjr7pswDEf/AbJCW+yE+619/8ecBqxmwYmhlSrtfEU6ApOf4+Tnv0JFcaJxRSdxpH75+fE9uKQad+j0clKUafSgs+MiFV8xwDVWx0TZDQVu2QHRPcEDJHdJFAW+6lkY+r4oLErRS/UAgJK0aUCkcvRTwx9qMuXKJ1IaA8BCQyatXBF5ZFGLWxMryjFIBwtPJPKdiOps+6FBDtPuRZjuRdGsqXoAGJHHdi20zsPIFd2XVEzgiCSud0eU4MzoVEEm+VeU4YIZaKkcJNuK1CunZrJ4jpvaiGL8gHgj4pNalQNAZ8R6kyhDlh7+MIim7CXiszHBjFx8/Vd0QZYHrKDEZRWlgqhAgXQV6XBKwaKAXkQKeQpYkSOjZlEU7okAE/JQp4hmUYw+el+N3E4Rz6IEfVTzOw0VuridIplFGv00LVtrt1PoWYRnYTrFSVHVjNYgOp3ivGgagPZIghHZupuqwE67MAZE9DtheHp/9soQFNH6a4XkARRh0TOYUQuHRXUwWh0QhhPRghxgpeFz96Jj4k8RoS/jE2Fete6Z58kmtIXUfWz9AGgfEzpQaKOtaCjwJNRGFPWMdqzwHdS21VaNLfA9NDX/z0hpO/qMC22QH6GFLdvbM3sn1xkzRIgU+7Rd3xpr6v3qj91BS4bCW3KDVqhKxlrDtZPWM/r5Nrdy36TLJbmUV248dhm5GJupfJTGNx4zEwC1qD4UV+4I4dLIk1Z66FBTgvRG+bFjFr+RSccsMrmiTvDIR9E6PNTmSj4cU676Qq6zfFw3hUEP1+gLFwhnrjS+eckiX/t8/SKKePtqTOYbot8ZIvchp3ukIQAAAABJRU5ErkJggg=="

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA9lBMVEUAAADBaU+KSzjdLkTBaU/dLkTM1t3BaU/M1t3BaU/dLkS+GTGKSzigV0HM1t3BaU/dLkTM1t3M1t3dLkTdLkSKSzjM1t22Y0q+GTHdLkTBaU/BaU/IqqTM1t3M1t3BaU++GTHdLkTdLkTBaU/CS1/BaU/JubfZK0G+GTG+GTHdLkTM1t3Jp7KKSzjAGjLBaU/CHDPCSFzbLUPKvsjTJz7DYHK3Y0u/JTzLytLFeIfAMUefVkGNTTnHj53PJTzMIjnRJj2bVD/VKT/OJDvEHTXIIDfZK0Kjf3bKITjFkoSRTzvGHjbDfWqmgXesXkbXKkDBPFHJs71kMCKSAAAAKXRSTlMAMDDv7xDPzxBgMDDv778gQIBgz69gn+/vgJ+/n+8gEBBw34/vQO/vz3NTepoAAAI6SURBVHjardT7VtpAEIBxAqKUKkJttfZ+b2chQAEvBfGutff2/V+mSf75jkx2N2H9HuB35sxOUslt88lgsPL2ZSW0aGWQthbdjZMMFQU7SIEOUphDO9W7cfaP1pGCnDhGCnKSNsrvqbqT48zKb7y6frSvHd6uuBPHSDhlpWgjjpFwkArveYaEg1TivZBwkAo7SDj088PzVqeYg/RbO9+6aasNv4OUpR0kv4OkHSS3Q2eZc6Ycr7Spvy+uAAfplQV6qhwkHOp9qucPlON8R1JO9/PlVq70XjszLlM7PTk1uVKkHS4Th4H6I5MvrWkHSTk9uTEmX4qUg/SrqwaSc2OT7i04SF+7eqChMU4JBwmHgeTYuCXtsGeai4yMU3I6NE1X7ZQeuR0Gmhiv5HcOD9JVeyWbQ19ELkDse/I54wORa1NQwtHtiVwhOCWnMxZW7ZVwiFuUviGPZHd6InJiiks4C/0VVl1EemZx5onzw5BPemBxDqcJdGqsPVxwXiiBW2TVRO3bUEcJ3CLfa4GRWhZoT5L+GFe3oe1851/qXBpnzl1zi6zaCdGq7RalPyoFNZBoKqza1lbFL80l7dwNvYZAUv/FpKHbecNpK4lbTDt2OrWmYpC4xbRReQeJW5Qbn+OVxpI1Ke8gcYsyXNJB6knWxZIO0jvJul7OQWrdf5w6V8s41GltNyqZNFnaoVTqhzlIJ2EO0scwh5q1UAcp3EEKd5DCHSScMAknSMIJqr5by5jdeiW4Zrttm+Y//EHZj7273qoAAAAASUVORK5CYII="

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAwFBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkS+GTHGHja+GTG+GTG+GTHdLkTLIjm+GTHGHjbZK0K+GTG+GTG+GTHRJj3TJz7IIDfdLkT1+Prpk5/uucH06+/vxs3ohpTiVGbfO0/x0tjjYXK+GTHroKrgR1vy3+PmeojsrLblbX3AGjLbLUPEHTXOJDvXKkDZK0LKITjRJj3PJTzCHDPMIjnVKT/TJz7GHjYkNy36AAAAIHRSTlMAQK/v358gAGCPvzCAcBDPQACAAK9Q3xBAgN+/n4DvYGRaJbIAAAOCSURBVHhepdfXerNGEIBh0TtyiZP8sZPM0ot6cS25/7uKB9ZaDQjJwHdmH7zP7krDoglNkhUAVdON3k3IXybwrJGQAt/ZoyAHRO4YyAOR4o+AZDjKGwGpx5A8HNLhOHs4ZBJIGQ5ZQBoM+VMKSUMg3dRUyjy9/3ndp8n1te7hgDWY57K8ue3T5NaEdq+bkkOOZ9mY5UkXtqYrLWb7X4n9ditpCogU7e4c5LWcp11Z9bsKzVSzG5JbzqZidh9wqqnTBdlA29bred5CR+4PV1SfzwsCRUyEbBUXKGn+T85of3CyGSNQETHGwgy355+CdHpAByfNGYGWrGqRdjwYJobc2tg7OhFDiDpYhJJ1CvIV4Tyis+OOgCqXSNIJyHDElD0j9AiQ5azqAMVMFGUAqn8CMnxL4RBOxjMAzFhdQTeG8YW6HdMvea5twwcu6Algzniz9oLiYFlkeDe0IdEfV1dXf8NXKw5FgAk4XGbAMzshcZOIM2LJ8c5WcxBNL0EAtSQOlh9ZXgBJPw9Jh3ngm/k+ohk0Ms9DLny3jvjmKmgJzbQzEL1sswApJGLukOzzkE3mPVl8SQHEM1jPYmQXYTLnkHIJoqVJGMV5WG+Tfni9ICwLF8HqWGLBEGi+YnEQV7sU5VlPaJ7kjEXzgK3x7Jko/Am0DgpsHYT1IpYQsAWyqVjU6uKn5n5BjLQCCFCrJ0eMjnweugPImg6EjOVApBTAOw/5OBHE4f9IAZtHDMOdOi2INsVhpw6Ij5zvOwBQL02/CQAL+oVJEcqhLubPBOsS5Cvi6imgKmEYh+bc1zsgOv94plEAvJw8v2O2yABeyr/uH37dST6BWktKozzJ4LAGAiVIbt/KsnxDV9EkAtFvAGQgCsR5Yeny+2Z/5bQlIJpGZzaiEPaBzmYLPJlAXa+3ARMQeYV6FbBLICLRBWFJ4xVqR34BIXReChmvoK+Gmyd6EwiISnLrsk6587gpsU84ziIQyVMAS4MQJy0OA/ImVr4AySYQTdeg3csbcSjUTVkqUZR/OLP5hEYuhdo5rl1jqu1Kxn3t7B6hmUOgiz0gs9lDK83oB92U5dt+22Js1+gJ/btvbkqRXZzZvpBEFdV0kBgA6RSS6S3SJwp5w6EpgZzhkE0gYzjkkrEYATl0LCg0eG/SGEhXBGSMgI5/AVnjIMN3FWQU1xgHYY4k8Ru2DY3vf5mDfg/QKrEEAAAAAElFTkSuQmCC"

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABhlBMVEUAAACTlZiTlZiTlZiTlZiTlZjx8vKTlZiTlZiTlZjx8vJmIROTlZiTlZjgqkHx8vKzdzBmIRP/zE3x8vKTlZjx8vLx8vKTlZjgqkFmIRPx8vJmIROSUiSzdzBmIRNmIRNmIROTlZjx8vLx8vLx8vJmIROTlZj/zE3x8vKTlZj/zE3x8vL34afx8vL/zE3/zE3x8vJmIRPx8vKTlZjRkXjfv7XEclnUiE7BaU/koU7zuU3l0MnFb0/HemPOhEy6ZUzIjUTKg26fVkHFjEONTTm2e0CKSziRUzn4xEzo2NPTnEW9g0Hl5uesXkaZWzvirEjOz9Cnaz3apEarrK+zYkmRTzvptEmTlZja29y+Z06mWkSvcz/IycvNi3iwYEiZm57f4eG3Y0upXEWiWEKYUz7WpZbU1dbTnIy8vr/r7OzZrqGfoaOwsrS2uLqlpqnCxMXr4d7/zE3x8vJmIRPst0a8gTT1wUmfYSmDQR6MTCL62ov+zlfZoT/16cnGjDf53ZVwLBf802z89KxVAAAANHRSTlMAIGCfvwAQcM/vIAAQ3wCfACCf71CvADCf72DP3yC/cBCvj0Dfn0AAv48Qz69w7yBQYDCAckXB8gAAA21JREFUeF7szt1ugkAQhuE9xqQUSRpx0eVAUwNW0TubGf797Z1Xu6RJyewWjstz+E3yZsT/Mxp5h/WSWsv1wZtYCOMlUpI6pIqGh1RAjEANDEWSDGQ0JLSQZCQXrxzBjXFIFmH8zhDcOCOr2QtDMNv+TFbnfc+Ppn+Fpj1Du4yssl2vULoFKMmiBNimb13i93B0fWwAioqMqgKgQd89WkLzBB9OoEvmDpzwIZkbQukKny7wLb8T457r6wWfVikTcjao3UAr8oo6qrwA7YbaxumGPnxsfcKP7FrW1KrLa/bFKN3stA0EARxfCZIb4lDRBwAUUUW94TBgTHC8TCiBfJAQJwETvrmaeYO+eae2prtrmnb/V1s/zeyu+fJT/v7y3YHqW8Lk+x9e7edCbdUNVG+KE7QO/KCDViBSs5CU6wAc+kGHAK6kKg4c+UFHUJEY2hYnZOf4w7NjlkKRtn9DOyRFDJ34QicMRSTtMLRnL9Y+9YVO2/Zye1+VGShmqJP4QkmHodiMpDZJAk6f+UJnGjiSNtWuA2H33M857yJwPwTaVeRC6LlbguhMRBVII174OBeIugq5h40seTkoh20g5/o1S73/OT12tFy/QJfkPMgr5PqDfzGDPnJXzoOkSzU0UAgi4eh6FXM9QnEgNNBQjcldDiY3BdXvTT8r016/YG4m4C5GY5XOqtJ8gWXd22TwR5sOktsuli3mVWeWqo0x2VILuPZC48r0og1cy3ZovKHW0jtbyjMouu/81dKdeyjKctu5S9dUI10+kF0QQdnj0/OLpemX56dHKIsCsntYpg1VWxfJUBmY5pOiOZgyYYyzXlO1RiqSKX+NYUXxa06fnLTBUO0bS29ULQ/esyqSvQeimN6Wv9qje1WFgSCK4ze6IVnQLpA6jZBarPIKFkKKs0UKK9m9+fDi+39cDhMGIciqlYX/B/gxwwHqlNAmB+ADgYXWHH7nDg2NRcEDyDeEZql3tzdyvTgCiYTh+CpzHCCOQJQqsPH8CnMewSo6hKTMgk2n8JwSThOYzQgIJCUG0kArpgyQTJIqpBVbzE3+8hALFz9hblukTCFtlUPr22vn3J0XnOuubQ8tX6mikFauLZ7KrksBFpBW0Iop/CkCsTKrHmK2ynhLFNKS3b425s6zxtT7na4Uh+J9PvSFvtA/9zWP1X30HYoAAAAASUVORK5CYII="

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABtlBMVEUAAAD0kAz0kAz0kAz/zE30kAz0kAz/zE3/zE3/zE30kAz0kAz/zE30kAz0kAz0kAzcjCz/rDP/rDP0kAyQUCP0kAz9wED9wkL/rDPmlS7/rDP/zE3/rDP+xUX/zE3/zE2ZTx7/zE2HPxr/zE3/rDP2mRX+x0f5nR70kAz6ri3/rDP0kAxmIRP/rDP/zE3/6La+GTH3nxz5qihwKhX9wUH8vT3+xUX3pjf1lBD+yEn6ri3GM0L8uTn2mxj4pyT7tjXsmy/6sjGWTB380oz4sUz6vGH+3aH1wUn1lhfqehP1mBSMRBvjaxj3rEGzdzDxiQ7zkDPZiSvFKCzcXBztgRHst0bnmoT7x3bvhzPZoT/6wmz/zn3/v1z7ozPBIC/KNTGtWRDGKzHWUDLirELYUijZVR+/Zg/zwZ3WTSHgYxr3zqWpbCz/1Y22Xw+zZyP0uHv/5K68gTTWZ2PfYzLrsWPPPiXMNyiKPRH1myH5t1bfgXT+46v8zYHFLTeDQR5wLBfGeCf7266WViXrfjL3oyCfVR/3mjP/w2T92Jb716b/4ab/ynVvKBPriQzaWTL1qk7/u1S8byUnLk87AAAAK3RSTlMAgBC/7+9QEJ8wQN/fn48wz58gcK/PUGCAYO+PcIBwv2CA31DP36/PryAw9vH6kgAAA1tJREFUeF7N1mVz4zoUgGHFwTalbbvlLvOR5DCXmRmWmfEiMzP846saMk6vjmKlM3f2/ZDxp2eOZMsx+f8KhAHCgaM7rWDVemQInN4WqGlw1HZGB5saV6KnWzjnpQJAoSQuWk5HG3NOhPihQicaGeckl3RSe6imEJcWamrAObp0qnuOo811n/LJ9J+h97mi+/RMvw/mSkearnJlqzTdcaWeMzSepnRHDe1Qmh4fUjvH2CSllNeJUjrJjqmcPsaoP4gy1oc7ncyGrqqd7B0LYp34whzoyzmVUxyBRxaEL25AQEu2pHQAHi0JaACFmGiDHvTVOxgzUYCD3meiThXEvqY29VzyVGZSNgN75nUB4RPZUpo61rerVzOukcuWvncUmN8zTfOGAjpnS+NLtNod+G/5WVP0KzuHQheZ08akC/3+x2FmZcq0YxcxJwDrzG38H2esl7XDXJs13dYhIHeMMDy4yTxtvPphKf2Ruy/56Zkp09MvDyBsIAPB1m0h1XbdRPp0C5CR4gBrt+6uH4LeIM6zL9YA4jKnGUTLicS9H73OT4jzuLwMomb5ykRPE4LyTPWbifRaMPK1BcGRRHf/3Hegv02sT0AUlEBhsFvYTFjdvvfed/s32Y0XNTtcfuxCn80LKCyBwG3t4a1EbVXnm0SiXEWn5d8WBoCH2qyBqlPsCnXXhWZAZMhumreFJx7rXXeg8uaThZUqJL9t7XC47eWHH3xoQe4Uf20DQN6FVkDUjuwR1rWD3Z0GK3ezse8vUPZxPu+is87KMCgOPrM36WfLiSMPpL/yn09NzcwD9kAGQC/0iEQagSJEUiMQkRXUd4JSqEsf6pJC7fpQO5F2Xtc5T+TFskkdJpmNIdBZznOpgj+lkMpxfpYghbioklqspyymKlwUIlgXuF2ukkoikxWSqUqO211AoV7uqZgdK5WSViPWb6k0li1yT70oZIS4RiGDoMV0oBjB69GBeoiiFv9OC1E17B8aVkLRol+nGCXKYnpbjXd5zJ8zdpnUqS2Zq8/kkgFSLyMMoxk1kxmVfD3K/wRGJlArMzHieekra3VOpzhaNavMicPnnOU24qug3jsfz6gjBQ3itzaV00Y0ao5jzPFmolfkkoy5FCH6GZFA8LhnlGAgYmgj+v0LamMSMUERzwcAAAAASUVORK5CYII="

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAmVBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzNmdX8pLzOut71vfYfR19v1+Pq/x8zs8PKTnqU4QUZXZGycpq1icXp4hY7j6OtebHZIUln9v2X/rDOKlp5PW2O2v8Q8RUv9ulhTX2fIz9T53K9LVl6lrrX27+GBjpb+sT/a3+MxOD3p/F1EAAAAEXRSTlMAMHCfvwBQ7xCA30CPIM+vYHlKhRkAAALtSURBVHhenZiHdqswDEDDaMwoebXZZK/u/f8f96iJcI0Vq3A/4B5JloXMDMdxPV9c8D3XuSGZ3ZjMPSYGMG8+VhSEkUCJwmCMKGTiKiz8syiOhJUo/pMouBUktwEtShZC0eyXOy7ZLfeNUCwSSuQwZTmvucb6rFzMwUWmp1m2gk2d/vB2ynjHsrGbZkPP91OrWeVFz7asueTp22ICUQKehzapelvoVOVGJvgApuSaKIA6v3KePRcIqUzxFSoeXBHBuZ85//gqUL6k6QxdgIti5cnAY1BpphgVRX1eHPJCyPmv7CJMFF7q3HpOhYWVNF0qHpqigHXn/tOEpU303DVn1wUsGIogoCfeUtlE20s/oSHNoEKNjLuwUfGOBqqki+ZCsuQtG6soh9siJPOByIOAqFoX91wLyRuIGLQQKaq5BJqJ6SJHSNa0aMuBtZA4msiFzEhRCh7IzdVEXYn2XLKyiTZKtDeLNPP7MyP6seQAnJuviYSkm89ZRZQa2AkJIuKSe7IbAYtIb8eXw7Hl8IJlRoty0Lw/Hi88voPoTRN920Sr3vN57PkE0+nvEW1BJOMBHkeL6r4+R42XUaLdryM76KIDiIjjh4ZUpT4OABHRkHBFxojgiuCXlhYZlxYfIykpMsYIPthqutjGYMNHbUUevzFq8eGfkg1pDH/8c5RVtitiBBRd/0DW+KVVA5v4QKpPdomOETVFiE+2WiLwnUaViFgi1Fpz3ZRzANYaYtHKctRTbcCjFi1q9Usxz4fyqBcAtYx+GEGVmcqrh7n0enwqtdUYwoH1GIhiemHP6vu8DSzP0xosamFX/EuoJwTCskFfcBMeNTiLeNQzi37B0Q8/moUz5SnqY6q7CY9jR2DMJzzXPUzEkvE/EAI0ZE+KECy/NEKBkRgiGjT12wmiGO0BU0TzDzNNEQUMFU3ARUVTMPvbnyZKhskxBxXR3Bm3bYrIvCnhzVgR3uAu3P5JxDAH2R3Mo8kqL2o9fiIF/wHJ+SyrrRpQiQAAAABJRU5ErkJggg=="

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrVI+sstAAAAEXRSTlMAEL//ADDvgGDP348gn1CvQNBu8dwAAAEOSURBVHgB7dPNbsMgEMTxwAy7xh+k7/+0kdIUxy1EIPZSif9ppJV+Mgff3nMe8I4kSysXPABRXrrxLQ8AvrJyC76LdQjPyisX8JMOQW7NkAxBG85GoB1G0GEE7TCCNitIjKAEI2izglYjaIcRlKwgtYK8FRStIPx3aC+vAuQ+Q4lM5xr4ophSvK5+qFontKLS2gkdqHR0QgsqLZ2/CAXFhL3QhmLKzr+fTlBIXH56K0T99EEM7RAj/hSZk3bISeFhuXs7xBBxKQaeLR0QnQpyou5ya4NyyPFXdyvoywqit4J2MYKYrCAGK4gTmtCEJjShCU1oDBK8ktZrBVK80tZrBWLEs8jmawWiCiBKtl8fvbxLIOSglSkAAAAASUVORK5CYII="

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABblBMVEUAAABmdX8pLzMpLzMpLzNmdX8pLzMpLzMpLzNmdX8pLzMpLzNmdX8pLzNmdX/h6O0pLzNmdX93slV3slWEuWh3slV3slWJu24pLzN3slUpLzN3slUpLzMpLzMpLzMpLzN3slXh6O13slVmdX93slV5h5C61LZmdX93slV3slXh6O13slW+x87h6O3h6O3h6O13slWJu27h6O3h6O3A17661Lbh6O3h6O3h6O3h6O3h6O13slXh6O27xMtmdX/Z4ebU4dqrtr3S2t91g42cp69ufIaFkpukr7aUoKjCy9J9i5RebHazvcRPW2PK0tg4QUYpLzNXZGxLVl4tMzhbaHFTX2dETlRicXoxOD08RUtASVA0PEFIUlnh6O2m04iSwHufxo53slXa5eSRxXJ6tFi51LSj0YWMwGuszaGdzX6gz4KDumJ+tV+AuF+ay3uPw2+XyXiEuWh9tluUx3XH28ez0KuLvHLN3tGJvmiMmaHY+0lhAAAAPXRSTlMAQFCAr7/PABDfMCCf748AvwDPrwC/gACPUHAgQN+fYBDP7xDfzwDPj0C/n9/fn0AAv48Qz69w7yBQYDCA9pOgZQAAA3BJREFUeF7s1clSo0AYwHHeoAsCTaW4oMEMJGo0jnHBV/manez7or692CwVNMxAM4c5+D9RHH4FH3Q39z/0k9HEuCFJkuBECdFFA+OmcVMUd+KeamBJcwrSJGyoZSATC85fE7D5Z0jBmlMyDSuFkNF1KtU1TkKKlAP86XC5WIQkK1wslsOpn6Mk5TuEj5DNcDUhBU1Ww80Rhb9AqpApcy9DCjFvnkmCegyZ5ynzNialGr+l0rkZQzlnGZLShcucxB2913RCKjWZpm+XQHrseKRyXizpMaRQxh8ThsY+lRQK6anDLukUohPaEsa2dEoUonMmzNGJZ9CKHVrlIFKjfwZtUmhd/4nWosiJol0fupVlTpZ/1x/2fbvNtdsdq+7nt14Q4hDq7+r+kLsnCg1gVG+JjOCRQj0Au86iteEKUQgBuBb7NmK5cJ1AHQCwWTc2GwCeE6gPUXu2rXYPUXcJ1IPPXg/VN//DK0SdoQRCD0ALZtWOo1kAtEEKtS4hzh2tyx+Q65ELcRctnuc5nm/9eoeswCp3ZFvBR+10s5s2EEZheEgITiCO3B1Chiy66FX4EEzM748/E8AQYpFWipRFlgEpd197bPHJRm7NVH3XM4/mLOZ4xcKP7xK6A9oB97A//PxLh/1DwH0BdxFUAtAJUv16e83FDq9v0STORlgphK4AdIPTPvfvu90HCx+73fv+MzjpEWFX30QJUVagWtuRQEncSqinDPUhuxU3+Kcn2Q5kNwJxXUVogCSBpL6SM8QJ5NgKTrt7CmGkNIyh8VF6PNuZsDMWU0YnZzozh6GpcMHNlB24gjyGnJmq45FouuAcS82B2xQtmoNDp6BjpZw5tYRJTwtw+GoX/WHc4olMoRksFZ03G2UdQxOaSRkJveEfGXuArENmCGn1UFoiTVmFGSxDp65F0HWFiFY+UjkDtji7M0I6f0VElWsJxdLaQ7ZefzJsH41hZ9BFNm8dOxJKJNqMcWbjDcWOhKRUpqjnBc5o8UxR5ciRkKyhS2o79VEof7qVjN6QAENazaC4DVv5yobijJqWgmQXTUrarpa5mL9cbSmpeREKDHH3FTq2dl/mnscefM+bv7hrPlG5TwyGuGpLp0LprSojKYgXspWvyE15EFdtlHMxvdzgt+RDXM28rBsGe6QbRv3SrDGQhRT6r9BvJP6JRmtciQYAAAAASUVORK5CYII="

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABtlBMVEUAAAA7iMNVrO6ImabM1t07iMNVrO7M1t07iMNVrO7M1t07iMNPo+NVrO6ImabM1t1VrO7M1t07iMM/jspVrO6ImabM1t07iMNVrO6ImabM1t07iMNPo+NVrO6Imaa7x8/M1t07iMNVrO6Imaa/0d/M1t1VrO7M1t1VrO47iMNVrO6ImabM1t07iMNVrO6ImaY7iMNBjcdVrO6BnLDM1t1VrO6ImabM1t07iMNAjMZJlM1OmNFTnNRVrO5YoNdYq+pYru9bquVbsO9cr+1dpNtfsfBip9xiqd5is/FlpthlreNltfFmreFopdNot/JrufNvu/RwtehyvPRzt+p1uex1vvV4wPZ6uel6ve97wvZ+xPeCvOiCxfiDxfaFmquFx/iImaaIyfmLyvmMveKPn6yRweaSzfiXprGYxOSYz/ib0fierLee0vei0/ems7yo1veqtsCr1/atucKuzOGu2Pax2fa1v8e73fW8xs3EzNPF097I0NbL0tjM1t3O197P2d/S2d7S2+HW3uPZ4Obc4+jf5erh5uni6Ozm6+7p7O7p7fDs8PLv8vTw8vTy9ff5+vv8/P3///9g9jWuAAAAOHRSTlMAEBAQECAgIDAwMEBAQEBAUFBgYGBgYHBwcHCAgICAgICPj4+Pj5+fr7+/v7/Pz8/f39/f3+/v74V89McAAAMvSURBVFjDrZj7W9JQGMeXmkalYBlqNiPLC1BkJmrljCyT0pRUKEqTQ2UXb1nqWoWXNKSLJv9xZxvMwXbO9p78/nj28Hne894PHGdTR081eL09Onm9F2qPcVDVtveYqr3hCIhzpW+w14zTOzx8DUI60YcQmnp879aNA8bN3sEJfIomTgNAJx+ivJ5OKJrSDtA5AKh8CBE1xkN8JIRjppTp6IjgAoGwwpHYMz0kHh0dkM8rIaAOIa+wqgHtAAbyCWSB8ognczpAIBcZ1AYClZBBNbBaayOCymGgGhLHBy3/DgLIBQXVHJJBpFRywEElQRNOHccgh5HUwjHJUexwnmNUEShYwsgxBI4/HIOYTao0Bo3NJJNECrJwyg+h9BW1mIEC/5fY/dF4fIS1RHSx75+Wh0iUMbcDB6CoOo7CTBmgd3VcBUWY3M0bQZOKn9qAIH1WRxB6L4orSdVPsLs5CoIeQyLWvOon2N2a9BwctTwoAr1bQb3iqK1g0DsMGgXerfBm2NnJ+XmZM90PnCN1xaDcdqSkdxNz4UdUylA4BK234skf1awB7jWGljYQzlljummVVtVf9Pu7Ejp1+f2N9VW07cgw3ErrryaIuv7oNg2kb7hnuhJUvXhAAenmf1ViVlp9RaLMfk6vJu7YAjW+yWKlpQUjZHVjV/62cJ8M0o2A8x+yOe2mv0nSxwUsSZLSP/PH2a8vbe21nrX9LFX7a69tgdypzd8U1N7OZkoFjSEUC1FAzhTW950/f42m7GW21+WvTwRhaDRy0GIpIEVb25lMZk/Wr0zmx9a69mE8hB8iybm5JIpTQMdTlhofwcYsiuJibg4RHhHWoLvytZZEcYkO6rQECbJFM8vLMwjRVonLVpxPSsQmlU5EW5E9VqC3yk9C8rAeo4GcVqDnuUYUixujX9Bru618bbONcK2WLiKroEM6bd3Mqvgt4/bF9s0sTLoUJHMM04hiUmeZg0gKGCZ2BTlw1XjRIjzYm0wmfzWJ06wON+OzNthi/qB1m3NatYHr4n3aWhLw8eS/INxUDkROg5+6z3JMKivK8NYKjlUVzVpv6mxmx6iN1+3BcgIp/wCx7033q1shHQAAAABJRU5ErkJggg=="

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABNVBMVEUAAACImabM1t3M1t3M1t3M1t3M1t3M1t2ImaaImabM1t3M1t2ImabM1t3M1t3M1t2ImabM1t2ImaaImaaZqLTM1t2ImaaImaaImaaImaaImaaImaaImaaImaaImabM1t3M1t2cIDiZM0mWRVqRYXONfY2KkJ6fDSeaKUCXPFGOdISUT2KQanyTWGvM1t3Z4Ob///+ImabZWGry9ff19/nm6+7S2+HOJDvi6Ozv8vS3FCykByCgBB6rDCWzESqzv8iVpLDPt8DRoq3c4+jdLkTs8PLf5erNzNPSl6TYY3TI0trbQ1fVKT/p7fDVgpHXbX3GHjbKITi/GTH5+vuRoa3BzNSuu8W/y9Px9PWisLvP2d+mtL6drLequMKLhpWMnanW3uO3w8yksbvV2+D8/P20v8idFy8U7MBYAAAAIXRSTlMAMECAv9+fcBAAj69gIO9QIACAQIAwUN+/j69w75/PYBDk08SqAAACg0lEQVR4XrTQV07DQBCA4cTegAyixUBCEznBrHtJ772H3vv9j4AnIlKc4HF44H/cWX3STOR/OxBEkTEG/mKMrYnrQmrvtyJLL8IGA7rY5vlWGJQSt2GlmEBCO36GplLBkAB/iQVDIkBFd6xQwqq7eh2AgrjiZZg8GLmr9AwFs2BXmisizbXfdpSfjJrJXxYIXjHdiTKLX8mBULx4+aH4MvRZCwPl5lElIFV9e58o4Rm9zwuVhtQiWI77QSG1ugWgekUDoUMct8HL4mZtaRtD7zkcpl0jJAVCMkIFmIvPWrh8gYaiCN3CCt17TiIYkhB6XgUqelCSgBIovSJQKvcHmlb1pWmDfrmEThv/HRHQ8XS3RrNVJWo1GwWETggoPt2tUw2p84CQTECyinXDoO4TQhIBSacIZdIjihmlM+gkSegMoa9sNpvLj4e27RdsezjO577bp2PdhkEgAMP1BpIHxIChBUtp7DhO0uH2PotHv/8j9CQqXdtLjlJ39L9a+gR3GD8e2IgY5AB7fS90BMwwiN1tKEEjOr2WoYDQaZKdM2BtATKAzTJ0QScqDvFxL+UDWV2CTETpKjjTkg8kQPS6T+tjaKDdy5DuURofznsGWlkBagAbJCc2EkS1JHGHVi9D9KPcJu5cAYOkJYhLy/kHs17IESAuwbB+Zd6AHAnijwAbj4eszDfIBV0HaReBB7HVtZA2njve6DLEc913pqPjyBCv7YsMQXJNyExoGMAhuQwJxEZoh3Zoh3Zoh0yGzEbIJPgsmQ0QMWXqqcxQQf0BUhZ40dZCyka4W+eqIEcMy6vfQwak0n9BoeJqFrZdjTIv/f1Zp6b6HSlnn31Hm/fetqSwPgDRDfFYzge/+AAAAABJRU5ErkJggg=="

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABd1BMVEUAAACImaaImaaImaaImaaImaaImaaImaaImabM1t2ImaaImaZmIRNmIRPM1t3M1t3M1t3M1t2ImabM1t3M1t3M1t3M1t1mIRPM1t1mIROImaaImaZmIRPM1t3M1t1mIRNmIROqmprM1t1mIRNmIROFV1CquMKdrLfM1t1mIRNmIRNmIROTo6+3w8zM1t2ImaaImabM1t3Z4Obm6+7y9ff///+VpLDEztaisLuuyJ1ckTuMnalsLCDi6OzW5M78/P3c4+izv8jI0trGy9DW3uOdrLfp7fBmIROFrWzv8vS3w8yGq3iZqLTr8eff5eqATka+zcmmtL54omSbuJa/y9PS2+GsnZ6ZfHiTcGuzqat5QznK2cbGz9XR3tCZuoXn6+5/p25zOCzMysyUtIyGWlKwxbWzvsdxnln19/m3yb9jlUXe596XkYBdijmNr4LY3uJlKBZ1dEpdgzZhWSefh4W7x8+/v8SIimCquMLP2d+5tLfF0tPs8PL0PIMzAAAAMHRSTlMAEJ9g7yDPMIC/v1Agv4DPMGDfEHDv30CvUK+Pn49AYO+/UBAwn2DPn4/fr2DPIHBSnHdrAAACgElEQVR4Xu3WZXMbMRCA4TtTDLEbx0lDTcpM0pGZOcxlZmbuj++tFVcj9aJYvfvo9wc8s9od31iRbyYeP6p40Gjb7pQH0BGAprwYCBr1aKDzHg104aR7KA7QjHtnCpyLijcDHRt401cWkolEJBI5jLkix2Gg0wsHE6kTielDeP/WbOemLU5G5ifG9lXG5sEQdQMG+tlXJ6eTKQdmgj5EONB1hj7Hz5Wiw4gHelDn8CQLJTDU0BsHDbTbB3ZW9SKGuIcBUDFNs9wtOmFbz3K53MdP7cdg/ND0btm0a8GmWEi9bEO6uZfRKmo7mPYLGOjbQ71lgEEyME6fUTjpbBWvmkxlwzD0Xrey2VKptGLy6emNSwqfGso3b98zB+/5u6dWIEYATkIIZTTdGMD4XdRwBqHAiOKU6rOl5RrGjYredeZWSq/0Su8YtWXG4QLJSuO9GppW0aE72Wz2bqfTgXXfx73SFnFEUn4bc63naI8wtJ0njlhCVV7apNATcBZtJxRUhPlB2uCgFy/7zhI4VWQ7KgUEUrPGSq/fEOctOBnWEUuwclq98P7D0ubS1jqcq8k4omIBfuXX6FeoZjGOuJEAu/J6Ab5Cf8+FZsGRkDboQP2v0CI4PgCkJFg5GWiXOFUk49AfHrJ6i/rcXiNOhjqyUv4LvKxQx+Rc1JGWYOVfiWNJO/RjAGXouRAKK/8VkaxFjNPfe46fAvISjTryhV06NL97h0rUcS+B4zoCSQBDSLIhNISG0BAKEijolvGhvXxB14xbChiuOVWRTw2jfwuE5ZkAcmw8JuXEGIYtqsqcXJTPK2hO8n+R+6dBwash5137RuTvHwvPRsfp5aPRsF+g/AHHfDoXUSClKwAAAABJRU5ErkJggg=="

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAn1BMVEX/zE3/rDPh6O3/rjUAAAD/zE3/zE3h6O3h6O3/rDP/zE3/zE3/rDP/zE3/rDP/rDP/rDPh6O3h6O3/rDPh6O3h6O3/rDPh6O3h6O3/rDP/rDPh6O3/tDr0kAz1lBD7tjX/vED/wEP/zE3/rDPh6O37tErn3crj5OHwypDl4db/rjXs0qf/sDbp2b/0w3n5t1b/yEr/wkX/uD32v23/sjjNd/hjAAAAHHRSTlMAAAAAAGDvj0BAIL9gzyC/z5+v7yDPEO+/cIBgjlf8BgAAAYFJREFUeNrt11tvgjAYgOGyTQFFRZnupKi0gOJhzPH/f9vKaknZ2kKhF27hTYwfEJ5WrhA8kKwZqtnUuuMFyJeJFDLF0BQpNRNBJlLM5EMWUs7iQlN1aMaFUIM66C9C8NrEMUgAf5pBNHesCYLeuAUUQya3BXSAbE5jKA5L0OQKPSNOe5nzDstdobcf295j5jOMmRsPdIri/CiEfMiYs04ESWFUnAlhxF4zvrNfvV/Q4xP3559PCHc65/Mu38qO3kZaeGUol+bM6qQjFGbQnBJEYla/HDHzkSawKLnQKUvw0T3N5kCwKAtIaVacSYOMvQaKZFCSBrTtEuKW23ze5FvZBNUQs7qsaohZvR0U0G4OWvv+WjQrQf5q5YtmJWiFE80d1EEd1EE3C9m6IEcTtPC0QPaLB1tCkHa70EQX5GiCXEMP5I31QC52WkL0b1ZjCMj6x5DSi5YspVc/WcOgdkMp1KsP9YC0UV1nBOQN+vWc/gBUSaNa+yGOvN6w8jmLn88XaZr9bxEh36QAAAAASUVORK5CYII="

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA81BMVEUAAADM1t3h6O3/rDP/rDP/rDP/zE3M1t3/rDPM1t3/rDPM1t3h6O30kAz/zE3/rDP/zE3M1t3h6O3/rDPM1t3/rDPM1t3h6O3/zE3M1t3/zE30kAz/rDP/zE3M1t3P09LU3ePWzr3ZzLPa4ujd5erfxp3h6O3j5OHl4dbl5dnn3crpvn3p2b/q1bPsvHPs0qfuzpzwypDyt17yxoT0kAz0w3n1tFP2v2321X/4u2L5sUj5t1b7tEr9sD/9skD9zlf/rDP/rjX/sDb/sjj/tDr/tjv/uD3/uj7/vED/vkL/wEP/wkX/xEf/xkj/yEr/ykv/zE21vB7YAAAAHnRSTlMAEBAQIDAwQEBQUGBgYHCAgJ+fn6+/z8/P39/v7+/h8vhLAAACCUlEQVR42u3WiU7CQBCA4XqjeKOoFFAR8EKrWNSq6BQVoaDu+z+Nmy1lata6k13jkfgnTbeEfmkDk9b6geZse0460sl2XRsdNzrC0tmiomza4rk8dGRopUhoaQih476/tXSRVBoh2RFlaVAWIdkRFYkhhI4JhI42JH5+dLSh6C9oo6MLhdno6EEj0mhoQ5gJtGHpQlvlqqK1WQq0UyW0nDCzm3zbroTXUyUVv6YphI6v6nUAIZVp0NqH41+BsHqlVKoSs+JNb4j7OgSfK/dt4DV1IN758WEdALrP3R5jbQMIRG0W1n9sgQHkd1gsTajf6fRfmQ40+h5iIh2oCbx8ZjwJuiM6exCWn4hDge8Hg9UtETqFSBqPQT6AH61oTg2GZWIQ8KLVEX57l28HTvww6gSwfALk4dcbN54H4AyYi4bYO/zDG4iXAEEjchwI85xarXba5Isjvo9OTqUyCggu98UVnOEEhvkw7EGcvKCAGLtunHk4gQMmCELjJQiemTg5pYTkCbx/emGs9wCtjpgDKoQTmJQlUkI4gWYQ9psgnD95RYdw/uSVEqKu/qF/6G9A8hCQoTEJksaSBs1IkBQNWv0aaIY75pD0gCyYQ3kBLZpDGUs0n9OF8LUmOQqEL1qmEL76mUAW9i0Q4XFES/WApEOK/jCUUznrRGiy8LlTmLSo0vpnTk7h6PYGUDFupG62Na0AAAAASUVORK5CYII="

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAhFBMVEUAAADM1t3M1t3M1t3M1t3/rDPM1t3/rDP/rDNVrO7/rDPM1t3M1t3M1t1VrO7/rDNVrO7M1t1VrO5VrO7/rDP/rDNVrO5VrO7/rDNer+1VrO7M1t3/rDP/rDNVrO7/rDNVrO6crbhVrO7/rDOZqrXM1t25xs6RweZrtOvF0970rD91rMtFD8atAAAAIXRSTlMA7zBgQCDP3++fn48QIGBAML/v37+AcCBQz79QMBBQYEANizFgAAABd0lEQVR4Xq3SB3LCMBSEYQncS+idFEk2pNz/fpkwcRxmB+ux4j/AN0/2qsAmRerSIg5l4qW7lL2GOcfMdQXdFPeOK0KgletL7wGm+cLu1x3zvE3dv5S8F3vp69N1cRe9WQsS8402czskTcRQbvtQWkqZKNrZASmLBUQ5a38629tSdvQyo6Tter8lpavY7+j2r49b0laJHL8ku0cgiRyJJHFEksCRSX5HKAmdkzGnYUnoNE1jhm8SOgCBJHaa0/AK1pyD0p50UOIclBacg1Iuc/x7mooc/56eRI53T3PCwT2dd/mGcqBIcQ5CnIORDsY5uCfNObinWZjTQyXhoIs/rWadRF2XkI4eXTvjEAcPCneqBzkq+oUM6SAU6Kgapi9zMN1ClKNKzsEqzTnYgXSwMeH4JcM5KBnOQQn3hI70dYQDEuugxDso8Q5KvIOSAYeUDO3gnsBhXwcOIYFDSeiQEji0BA7bQXdOUqugqlJfmLEKr46i6h7gG00Kd2xaTVxbAAAAAElFTkSuQmCC"

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAyVBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkSgBB7dLkTdLkTdLkTdLkTdLkTqWW6gBB7qWW7qWW6gBB6gBB6rDCXdLkTqWW7ZK0KgBB7qWW6gBB7PJTygBB6gBB6gBB6gBB7dLkSgBB6gBB6gBB6gBB7dLkSgBB7OJDvVKT+vDyi/GTHqWW6oCSPlSV63FCzZK0LCHDOkByDkRFnfNkzKITjGHjbOOVDlVGnpVmvFL0arDCWuFC3ULkW7Fi/SJj3eMUezESrU/1qMAAAAJ3RSTlMAQAAwECCvz59Qj++AYN9wMJ/vAIAAAI+fABCA34+vYFDvv0DPcL/YHzRBAAACtklEQVR4Xu3Y2XbaMBCAYVlYtolkyNqkadqktEXe2LMv3d7/oWoTkD0azChc9Zz2v+CCmI+RIvsCts4r42+sU37G568xXiUCvSyMur4j0j0N9bJA1JCQui7o0ooXSW2SwkCRBkkltil+3NOgyEBS20WilVHoamkgiEAKMzgIYQrve98wIAEgnOzvnx2Olh2e7R8deWZviIlQ16NGHyIDUBB2QNe7Qjcjq5sdoYkNTXaEHm3ocUdohPr110H6X4b+Q9nboey2yB9s5yFJxvmPeeoKZfPfi6Ts3obuk1V5kZJQVoyTVS829JLULabpNug2Txo9QecpgY3nsxYorYZpla7zxG5RzDZAGb7w+ftk9VB6nNxoPU9Q41sE3S2QU2irnzmmpjMITRGTZxbT8nXPswaEnXGqNzYrNkjvy1j1ogubudOtZVMkvStj1UtqDQsY3McDSzopY9UL+LcfpJoo5OfHFxuhPaN8ujz3NJnHOb86+Lx29gx0cjn8nFwM967OSzWioYgv+3I8/Jokw28nKwgmtEOCoxi3Ui6QoiFfukDSJyGlnVIk1HODehQUa8diBNEDDQYuIzF6IKVcRmL0Dnmeyy4xeoc4d9klRg404HzgMBIjB+pz3ncYiZFnqMN5x+EsMWogycskPRKj7rKoggL6jmPUXRZvOfAKQHgg/OgR9EOAEQOFfFlIjWQgoTd3+gqd6s0JBEUtUOcV6rRAEYTaL5R8lWz9IggNWr+RmHgAoW4NSLCv3TXUbQKhxFcweHNI5Qu0MrQ24StD9ZqQqhmzCrAy/G5NqQYkDVMl4Nx4bQL8liABZJiqAKwMrS0oFUNBKJYVY/Ks02idSQ/8wiFjA+FCeEjgUQs5qhWKrTMCzlpMQXg/YszDfaMhZdaAVqzeBPnS7JC1S9KnIFgsZUy8S0A79wdAtBEI1YZdvAAAAABJRU5ErkJggg=="

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAATlBMVEUAAAD92IjaL0faL0f92Ij92Ij92IjaL0f92IjaL0faL0faL0faL0faL0faL0f92IjaL0faL0f8q0DaL0faL0faL0faL0f92Ij8q0DaL0f+U9yTAAAAF3RSTlMAIIBQAGC/MO+vEEDfj5/PYL8AIM/vAPt2JLkAAAEnSURBVHja7dTBroMgEEBRwAGttaKP0un8/48WrWmEoC8i3TTcjYHFyQRF9q2MENXj3yohTLDF/OVArtHsM2Yk17AH1TRnhz1nsDRX70AjLV3aLaa90NK4DVX0yV7jztXSp2oT6mjVbRrK9HaBezONc6NV3RYkyOteP2q7mtEt7+Ql4lBrKUh4O1ZQkG2jUE+H62OQoYRMBBIpkPgmZLrjTmd8SCqMRkEYTUlwMQCuEROhJc0niDd4FsKGO0jjeQg1MIk5IJRM5YEUwzwQ/jCU7bCzvf5cH2S2K5Lz0rry/EbmntFC6Bntb469Hz8MnTlsgNVhF6hABSpQgQpUoAIlQSodUh4k0yHpQaBTIQ0+xJs0qOEBBFynQJpDALmkOgopCeBD6eWHXqIune4Tt5IDAAAAAElFTkSuQmCC"

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA0lBMVEUAAABckTvxjybxjyY/cSNckTs/cSNckTvxjybxjyZckTtckTtckTtckTtckTvxjybxjyZShjM/cSPxjyZckTvxjybxjybxjyY/cSM/cSPxjybxjybxjybxjybxjyY/cSM/cSNNcyNckTtckTs/cSPxjyY/cSNckTvoiCWrWB5kIRZ+NhnXeiPFbSF2LxhtKBeiUR3fgSSZShyHPRrOdCK8ZiCzXx+QQxtckTs/cSNajzrxjyZDdSZMfy5GeSlVdSOCfCRBcyVPgzFYjThEdyhXizcImSK+AAAAKHRSTlMAEM8AYCAQAI+AYJ/P769wv+/vUIBAMBBAz2Cv7yCfgADPMFC/349wUr1xCQAAAwtJREFUeF6UztkOgjAQheE2qZBQaqLBIG7gEn2FmYLr8v6vZIq9IEpH57s7N3+O+CEqsFVEFU1UNIWeeu+BjPuJmLZHr5SJTsExw4Pkh3a+04ygS0tuaIzO9QYfzJYZQudxh28ZKzR1nZOFPpoTUu4PBCSMUInYWAjZ/BHKJ6014hOCUjqUz+aL2jvjEQgZEVqu6o4LWiCYcOhVehnsOArDAHRFLpvTIFUlEgVulRIDoUDoHPz//7WzLDOeGGe2Le8a82wiEwdd4WNUpYr4pb5TZ/g4F5MUFRU+Q1YnRCU+SVWIohM+TWZI9Mp7EfleZK74CnonuiBhUUJeLkjEN8gBtB0m6VoAR6IsFhnaoB4+8MmirIcPejKVkUhT4AB/cZjArcsDJbqSKCrIAUUSUR6WqCQRK2jlhiI32CXKSGSqOHBlRIERYJ+o+BKVQiBMKDCBkOj3lyiTAkFogQ6kRNWnqBYDYcYdM4iJik30JgdCQEYAOZHeRBcKlCMpj5wo30QV9VAMMsjBeumfqMDDovMqKhN7AB4ZPvFq+LaKNMol+Q4ZnZcLwt+rKEdidPPGtOBGF0Kwm2qZ5g03IpGTKEX/WcRkkcNFP3rgixZ/ICGSN+2Q6E6e4ZDIDtQ1h0RU0mAPiagJ73hQtFCXHxNhu4qW46JATfSwyIt5Z/o+IxafFAH4u0WOde89cuzdAzBRHp83E38qPU2SH20LK/6WcsUpWybS0jCaXbCYpGcDSa+it3id8LNzfQihCx/0zk1sCvTshDyzNk4zRk3qkZ3ZandqtDOITNEYdcimiMriNm4Don0HBvX3feAHXbaJNIm6AVq7KSVm57aFocPdpC3wu2mk0SRDHj771RUJm9z45Ki6qk+Rlu9mAuJI0ezGxljSmjEKrAy7QzICiMy7z1qzWy3Humn2caNPLiBBBZFInfBlTvEvxAVf5KJikcnwJTJDIjId8JBImRyfJjfiP61+9a+Pi1T9VFF5obiIODf4IM1ZESQiTNlU+B+qpjSKIBGnPukmF18zzxt9qpXAH+UBYCmjRcJcAAAAAElFTkSuQmCC"

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABiVBMVEUAAABckTtckTtckTtckTtckTtckTtckTtmIRNckTtckTtckTv/rDNckTtckTtckTtmIRNmIRP/rDP/rDP/rDNmIRM+ch1mIRNmIRM+ch3/rDM+ch3/rDM+ch3/rDM+ch0+ch1Ogy3Jozb/rDNHeyb/rDP/rDP/rDM+ch1ajzlEeCN3ljpDeCLdLkRKfik+ch1GeiU+ch0+ch1ViTRckTthXSjdLkRgYSo+ch0+ch1mIRNmIRNckTs+ch1NgixJfihGeiVLgCr/rDNRhTBYjTdWizXdLkRViTT/zE1CdiFAdB9ajzmm04hThzJEeCNHfCZPgy6dy37nwUedYEBwXSl6jizVNEPJNz+Po0HWvUlmlTyZx3tzplOFmDnNOkPrxUvWpTXFQUJfkD6OUDFklkRigyZjRCBhWSeunzeEcj5mIRPTMkJgkkDDP0Bmkzv1qjRuoE17nD5kPR2ZmzjCojZ7ljpwlDpvok+XWjqLoD2PmTnMpDa/Oz3bu0SjnTjMukdSfyjgwUp5ZjNlwwxgAAAAPHRSTlMAnxBAv8/vMEBwr4Bg3yCPML+AMI8QEM9gYO+Ar0C/j6/Pj3DfUBCfIM+fYK9Qz+/vn8+AYO/f33AwcJ9x28E9AAADYElEQVR4Xq3WZXPjOhiAUVOdNGmK2267zBeZ4ZXMFIQyLzNdZvzlV7XsJIo3a0fO8y0znhPJkjwSMrQ4I0ykJfPMjYlAF0xzcRLOjGmaZ5byzur64jniEOnUTC7LHOxcDujUIJRr7d5gnJxLRrsq5OtKDL2Tzyk8jCG1kMeR1B9i6McpKYczBTfNFw8Pf7tpmodQ4odKAN//9RxIh7//BCDyOiIw8UqSAonEXONxdN2OpWkOaI4yjRYiaQ0KlTmgs7qBNZ0g1Ua7Sixdw0ZzjQO6hMICXAOo4QCFXeSAVi5jjC0Hopw2+XmZd/H3dn3/7z3oN83nwK5P2gVG4nHAD9vj30rUiaF/jBr0mxsLAtq/PulPhAIL+vGM6Nuu73fvIVLVWN9y3a31sffku7qh6U2E7hEm7A837Nnb4zkXUb+qhRG640bdOTsWNOBoNQBbexJDTz4Yx5E+jBS9HS2Y2+vaeJ9Yx8K44VGEhUAcx0m0FTtbAIqUERpynKZuw3oMrQORsjlyCBx06vXOAUANnywcrt2izq3QljNBhdCph/2sVaM9YPxCN2TYbMYhlVToUGgf9QsMywOSWpKFjH2JUD0KvaK17NuahQyNT/oKkfZ7U2t6AI2Ald7MBJ1HpNsUuq1bEGYx1PksjvSWFkpkTJ2XNvRyjGbsGFNStm1texhjz4FEnofvnvzBQbpUqMDo+vsrVSqokMxoQ1y8vzpQkdKPGZvXREjvTbMelXLg5ARjawihza7vH+8MQfA6aBbY6FVk0w/7lZkaqK8/ZpVHR6579IggthUf2C6FuoHWqMUvG5SUW+57bth/OkHi/ChECp6S5d+/+37q+f+cQtuUSEJxH62k3GXcKEqwU0ODfZxyu0pC1fYOhTZjI8Od6xO0PTy1lg2wc0zGQxy2T0c7ooM2KLQRMx5EefowNPKuJIkALbRBxrRNncCwYSDHCAYdbeRdSQGS1aLrrmttBxI57VaTvriWBTBCmgOOppOOBDypKec1e0lIUoeBilL67MH976LuP/iipCSemRKSzYoRpSpKeVoOz+TjwU4LpIJcLisK0CqiNOrwyzKDP2YaerQgZK6YgJi4oSI39PWkoNVJQfMstCxwtzDofCPwt3y67ywsC3lajaiFVSF388XifDrwPy2485Lxw8cwAAAAAElFTkSuQmCC"

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABOFBMVEUAAADdLkTm5+jx8vLR09TdLkTm5+jx8vLXnoTdLkTm5+jdLkTm5+jXnoTdLkTx8vLaZmTdLkTm5+jx8vLR09TdLkTm5+jdLkTm5+jdLkTm5+jXnoTdLkTm5+jdLkTm5+jR09TXnoTdLkTm5+jx8vLXnoTdLkTm5+jx8vLUvLLdLkTm5+jx8vLXnoTdLkTm5+jx8vJmIROfYEy3dV69g2/DkoHHinHR09TTxsDUqrDUtafUuazUvLHWpY7Xl4DXnoTYdoPYiXjYkHzYo4rZdGzZgnTZnoLZp5HarJfbSlrbUVjbp4/brJXbsJ3cQ1DcsJzctaPdLkTdtaLduarfw7bfx7zgw7Xgx7vgzMPhzMLh0Mni1c/ja3rj2dXk2dXk3tvk3tzleIXl4uLm5+jswcft7u7v2tzx8vKanrnKAAAAMXRSTlMAEBAQICAgIDAwMEBAUFBQYGBgYHBwcICAj4+fn5+vr7+/v7+/z8/Pz9/f39/v7+/v84YeRwAAAv1JREFUWMO1mGlf2kAQxgOtioC1QFFAKBUtUFDwKlivtMWq9YLVoiiglHh8/2/QJJtsMnFDNmv6vOHHzjN/ktljQgTBVr5QfDaXqyBDpVwyMim40lgkXUJ0lZLMrMmkHURTPsJA8cXzyFmlkBNmtoLYlPZ5glHuz75UoRJyo4odKYlcik7y5RHygsTDkevk84aD0EcrKIc49Q5y4rwcVII3VuEGoVlvLkieOXO9868AIfMGfg0HVOlVIKSvyumlZw499QgoqXGeOdWz3NsSL+iJXNKYCnrmFgHFvQKlvQLlvQIhr4qNQt5Mv36WTD/yYB57L0+AuiaRSbob/Q9Q2itQDoM+4cgmG2gTu79RQB9waIsNtIXd3ymgtzi0ywbaxe7fFFDgixLZJta11dU1a7ppbBu7f51bQYFlcade3zGSVmVZQeYxzb13bgF9HpU0auwHBE2JvCDxGIDm+EH7YGUv84P2AEjkB4mgR74MO0w/BRSig9gFTkgPQBWBXmxm/QTrcY4ftA969hQ/6Bg0SLxFGmdH7ICjswbYItr/koBSpb4kDVoWf21dVc0y3BpIUl/+XH4Pe79MmhcbkqIOzFjXBAYbHdUqivMB8qBnetLyq1Gp23ACNfrYqWZF/j4onekhZiLhsNQ3k2obX2Vt1CgcFTRR1JtccYKACpphQGre6gzx0LBDinc00GwFhbNitMsVQgpWNYv051D55Us9BeMvFcxhW/9eDcopRXPjLZJLihpp3fbtULJoeNvuGt+ickIMtnBSp6zkQlk5YRGCFnXQArTeXJweEJ1e3MDoAuW5SgfNAOf1gUXXIDwjCG/sQP6y2XnfhJzmvTla9o8ACUFAku6umicYctK8ugOhclAYcWtkdTtrXLXbFdtY3Y7CbrvpZ18BWc1usyBlhdlAYc1O3yLW1W2vKLFTNy3WeKY6mlLNjJv9MbXiizHaCwm/83wxasQ1VV29FEvYgxLuXq+l7DgpwaX84UQiGs4YhExYkV/gVDClnr+FTJDJ/g9wHfetY/HKmwAAAABJRU5ErkJggg=="

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAzFBMVEUAAAAiZpkiZpkiZpkiZpkiZpkiZplVrO7/2YM1gLkwbJTxxlKRmXMiZpm/yKtqsuGfwL9gr+d1tNrKy6T/zE3Vzp51jH2qw7mVuLKKus301oqVvcbq05D0yleAt9O1xbL29vPf0ZfIs2A+c5D57M0+dJZZg5T1+PpgruR1stDfxmtZgIaspmpLeYvjv1eDk3irsYSUpJNnipKen25Dh7TIvImep42qvJ7Ww4fWuVuRoI6DmI/935m6tYq/wImAtMbZvWH+3ZJqsNrnxFycUeUCAAAAB3RSTlMAYL8AIM/vi50ITwAAA6JJREFUeF6t2OeyqkAMAGDbObv0bu/t9N7bre//TtcQA0yOGeVqfikMnyEJ6w4ViGrN2SNq1foqKvV648jZM44aADWOnb3juLGCMJ99c6pXqgLQtKzmGjAMdmxDVCtSna04tkx0lELJhGNSxSuODMX22llLdixDjgThVSY6KJlol4PoMnBIQrokRCk9gtHpgPSIckmIUnoBIkkAemEJCZCQ0uBUqVDrUKnTgZCQDGFN4FJMydXahYSQxSgF4bXK06vwFKrbIJhZm0GQEkAtgFoAQUIMsmnWCYLCvl0xSLUHg3bQBagbwGfFoKs3aACDIGyCQj8krKfT6CFAp7JucKgJDiSFUKB13+2kUB+hfqp03NXXACBMB6J4a4XDNtYo0RCR7w31OoaeH6VkAiKlQ/XIocIZgHwthg9Q4Xc5RElhkz0ZCmEwWDoEsaTOz7A0PKhYZ+dZOhziSbXVSIJGqp2lI0OU1EB1JKijBoV0ZMhY5Q2QIuD3fHxyMp7/Jkil0PmZwSHmQCXTGY7Q+VwxEONPdKJ03qEfBoO4gxGOupgPOChhTt1RNvOGDBmkZD2bn2Qxz/pGliFA6HigZDHOoTEgmeWhxCFyPH+CAAUIFGhQTHwvkzgUkiJCzAo5RBIlJN0aT4ndGrs5LJFQbIo+3pjcftY01v68bVL75QHgA0mKPJB8JKPNj0jExlGCQIJHRFxH+viInJIjQ1e/0oc2lNc1eGj/NpkjLiO+vNLiMjK9YJCwsE0kaKLaKMWXs0yRl9pAixGoPz9QsmzT2bb49yQG/yp/TpG6plKJf0cuAonvEuD6CUIunHea13GhVPIfZFfrrtsLVL52d5QKei4cTyHHtK2sVPJf9nDSwvnNx4C+tyZDgFYxu0TJaoqbiGIQBArfjVxMUdqyrcGNTIJOQt+LkIOlsuSNVr7NorK7CrdaDIJS0a1JcRMDRCPup1B88x+7Wkj6VqkhQkOlbmFwSkLUx5lB1VbKmOG2qiwEDbmEVaUPTh/WH2j3tCx0AQnB1BoRQJGRHSsJ5b9+B9BdnmU5qFCPe4DuC3UrBT3kHVoAtMg7+VAGMq3CzABUmC3L3BXiFzxp/cR+YDeI38Kz1s/slneDeFE/tP5gTdgN4m1ear1kY7EjxAdPa+GcAIm/+voqZCtAYh2+voT6CZDYmfd3oaNboG+zslx+m7ENUE1+vUKxWLCp3wDVKlXhhY8Q0vnqoV5EHezV2CFf1q3iEK8P/wEeMSW8Z5b+kgAAAABJRU5ErkJggg=="

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAw1BMVEUAAAAiZpkiZpkiZpkiZpkiZpkiZpkiZpnxxlKRmXP/zE0wbJTIs2D1+PrWuVtXi7HA1OKen25LeYtZgIaMr8qspmp1jH3jv1c+c5C6rGXo7/RnhoFxnb1klLf29e8vb5+ZuNBKgat+psODk3g8eKX+z1j56Ln91G2mwdb64qTb5u6zytzr8/n+0mPN3ehptvD38Nr47c/73Y653Pb913hVrO7q59S1wruPn4nO2t3e1a3Q0r328+RzlZ346sTDxqxljqIg/rT3AAAAB3RSTlMAYL8AIM/vi50ITwAAA/pJREFUeF6t2Nd24yoUBmDbsUNV7669pGdmTu/v/1RHCNAG28hr2flvEjviE2wR0KIn0h8gZ35WQc4M+g91eg8PwxFCt0CQ0VBAw0d0L4QehzU0QvdDaPTQ6wOwmKXp6jYI9XtQ5/XYq/O8ugka9Fpn6akEt0CohQJP5/k+6MVrM70LGgOU3gV5XwU9fxW0BCjohqZpGnRA27ZIv6MuaPEurlm6ITRT0ucu7oJSedXWDaHtsWbmTzvqsw4ohDo6IJkNrRN9AYS4kBI39KuEVlchhmsIMxeU7D67iw2Z0DqVC/Ip/f5H5+OHZELKzyAo4QSATogVYnDlCQTj5qgbgiS0jn8CQWfLaxCECImcQ4n83g1Nw/C4MCVfSLEF6a8L5oaOXp2xKZVYNQEIKu2C9CK7vDTBAYJKO6FUQr/kZqcrfXeAqrbSES3iC9BaQt8oJux0ggMElY596JkFbSX0nVJFwQTnBlSosuWYOiA0Fc6eNsFRqaRISJsWInKsLJOXxZcgtF2nqzKjKllpTPBYQ7LScdE4vOyakGWGLSoWqq8hAZQb2oRcm9mMaIoneoIbUMTlsBLkgJwUNyGdihnA9CVcbh0L26bQVF7ic2ijCNhRvClAdnJNFZzSjx+vnvf640MyfgwMvC8EALkoeqgZkdeDcDKmjTiZkN88lSNAZ0lkYd/mnsr8jeJJ3T4nEee0yU8aCgFyUXuvzZ5iCnFADsqnc4Dm9DQ7/dfUAZXQf8+IhWDOI6L2uPHChliSEMI5DOACVHBOyCQpzReB9xWyoBgEyMnQcJYzZGYRBIKxoOqcKexiy1RgQUwoA0D1n1X24xcBywmxivOM5EksXbUSHpQ0P4ADlgW5MsFySu5rar6X/aky7LDcEGkYTKgMliXM0cSy2DWIyXa8WVkbQ62gGUKmFV2BYl9fJppMxKcNIq0EVtUF6Y0C53IvwYjIJnkj+Qy1Fo47oUhOoljNiQwlgpP1l5JKzLqKzbgqD0JqZPJHome/2Y8OKC5go5AjU7OeQPFAckBQngnM9ky9U/iyv41E82tQBiuzMTJUCp1JKdN7QBAELoj5MM1gZCKFFOFmuz+blSg9g1brdBZjKA+M7OQ3OdDdpyfzbkOLF+H/dYDywMjavhVQSPrN01laUNj+i/slsiAsSWa/zv7tQRYGNNP8PxmzHyHOlelbjyo1oBlAxvfIlejt6enfxSUoNaCX69B/c3jztaH1pR6NHYy+11FBUwNaGdAKNnFXxmpLlVmMz84t5CHLEnY6R0KAoEtGhwbq2CcVtwgdDrScwWfZp7H+pt8eRAWBk9G3ep4a8jYNw3Ct24zgaOyuPA7hsO7WwGFdnf7gVgKOD/8H6SH5ncRZ01sAAAAASUVORK5CYII="

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAYFBMVEUAAAD8q0C7GjS7GjS7GjS7GjS7GjT8q0C7GjS7GjT8q0D8q0C7GjT8q0D8q0C7GjS7GjT8q0C7GjS7GjT8q0D8q0D8q0D8q0C7GjS7GjS7GjTXWDn8q0C7GjT8q0D4oj8/+CbcAAAAHXRSTlMA75/PEGDvECCvUJ9A32Aw30CAUK/PML+/cI/fgLyDePwAAAFgSURBVHja3dXrcoIwEAXgkwsQAUFFQW03vv9blhE7dEolibs/2n4PcGZ3k2ywxnba0J3RncWrnM7pi1w7vMJqWtAWyeqcfpDXSJTRExkjh5HU0YoO0VxOK3KHWBtatUGkmgLqpIL4JTkKcryjn2UpnfF7MxRkEIMi/M0g939bw5mCzohxpaBr0uPnP/8dBewQ50ABBwjtEYdImlZpxLLry98i2oE/ofBOMkjR5k8ba6X/fubJaSTbBLZ+NGtowVgwk+YcVtIyhzVxDYbLnHMBS/t286PbWwsm5e8Ufk1QM7XWgCsLP7Gkn2AnVBC/pPPic+XebQ2e9nNGLdjevfcVBJRj0BYCCj/aQ8BRqrfGj3oI2I5Bp0KqpEoiafCjbQm2Qk1L6cjO6qckgbKKo38YCvDsK/UoqgdXWU2j6sG2P/n5TgnMqoKA0/SGhe7UAAGl2FoZJFemggQlFdQo1eC7D6jFkxIby/5IAAAAAElFTkSuQmCC"

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAzFBMVEUAAACZqrWZqrXu7u7u7u7u7u6ZqrXu7u7u7u7u7u7u7u7u7u7u7u6ZqrXu7u7u7u7u7u6ZqrWZqrWhsLqZqrWZqrWZqrXu7u6ZqrWZqrXu7u7u7u6ZqrXu7u6ZqrWZqrWZqrWZqrW1wcju7u6+GTHr4eKZqrXBJj3iub/cnqfNXGzHQVTWhJDENEno09blxsvKTmDp6uq5xMrTdoTfq7PO1dnJ0NXQaXi0v8eerrnT2dyuu8PEzNKpt8C+yM7ZkZvj5ueks7ze4ePZ3eBPWZKNAAAAI3RSTlMAQK+fEABQv4DvjzBgz3DfrzBwr++/j1AQAM9AgCDfn2AgYE9D6ZAAAAL1SURBVHja5ZhZV+IwGEABZRcUhlVRcFLaorgvs+///z9NFuJNofbh82nO3AfPqZ7eJLdJVUr/JeXKfDKF2nA2LaA0fZVBHI+46sVxvJCJ9J0drvr6ciYTnelbWVtFX5Vlonf61lq40FjQqN09aj7FNhKJvqh6a7xfzae0+y0jUZqfLhKJvirDMbJ8ERLPLxuJRH+UBRkgQgL3NhLlFSDbEp006l4CQaRzmwgCGaJ2o64AwkgLnyhXZkVtLLATaU6iHJpdLWJFkIlEogIa1ZKC3EgzEhXQRPRapKFP9F0VsZ8VLR8uo+hyvQwj+USf1YbVRRQlF2mR6DGJLEkaRCpvEt1txrqNHB9USGZpafTCTRDJJfqmHHrKOaZ6RnSF6CqMFCb6EUGaeWqHLCzyMKVPWkEiOxhcIDqplvaUZx2K1sry0UYi0XUUkCDSG/KgUPRsItlEZAQSadFpoei3iUQiOyMgkTm0L5FWUcCjIlK4i5IIbklkRC+Rlklm+UQy3OVMe8V2NCIirTITIhKJ9Gg8tkveJPZ9RCT1EI5FJBJpbhLvWSpPy4pMJE9q9787R0RyiTiPRnW1VjC2IhMJlikWItlEcJNeZ0+sExEJ4JlE25DIioi0DZHuVREtJyLSNkR6UkWMnYhIuzSPuu2OFr0ft44L3o5e1H1Von84iTV9/XLbR7adyItO8yWOmhFVppZ8WYvftPUdCYyMaDCFHdkponZTOQ73DpwEOrGhhwgZE7IiazrSS907cG5wiVwkQFbXQzeqiHIhEZEkf9V6Zk40eLNoqC1nRJKLjGdGJLGorB3zMpEEIhItpkQSiEh0br/2hCISDfy83iJydVwpoYhE/c2ze4vIxfGppCISEUkkIhGRJCISaSZEEonYPx0iSUTs6BGRBKLgjNVMJJmIRESSiiouEZGkooFLRCShqEciIklEfRIRSSAiEZEkIj4yIFJNJOr5f9aINJKI+FSFSB2ZyCci0lAkmsyHo8xSh52eSATwT4n+AsA2Fw+dzTCzAAAAAElFTkSuQmCC"

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAqFBMVEUAAABckTt3slVckTttpkt3slV3slV3slXZnoJckTvZnoLZnoJckTt3slVckTtckTtckTvZnoJckTt3slV3slV3slVckTt3slXZnoJ3slVckTttpktwqk9yrFBjmUKAtVtqokj35bCZwG3V15j/6LZekz1on0Zkm0PE0IzM1JLm3qSqxnl0rlJ1sFNflT6iw3ORvGeIuWFvqE1rpEpmnUXu4aphl0Czyn9Zbtb/AAAAGHRSTlMAIJ/vAHBgj88QgAAAEK+/MO9AIADvgM8vtg9yAAACUElEQVR4XrzV127bQBSEYYGA7BvmiqGNf9mLumvq+79ZElkRJQ436xwJnltBH7gHGMzsw5JEKaRR8jmQWeD3OYfML4MijokugW6Atmu+dy1wY4eSFDb9PjtIEzMUwc/+kGeIrFACr81fqKkgMUK3sO6P2cGtEbqH7QB1cK/Ap/dAQD+kAYxPg5f+JJdArRk6axZggbRZQDM42xDkbxawGaB1CPI3i7MjvYYgf7MAuuGDQpC/WQDV9nChKgj5m8Ve2p9pXRGE/M2CN6ptKwhD/mYhCUC+ZtkgbZYdaq8FcQVIm2WFtFm1m8hdHMen26uQNstNJo5H2yuQNMsDyfYKNGqW52myvQppszSyvVOQNksj2+uBgtHtNUK6vQLduYnUjKLbK5CbDBLZXhuk22t8mm6v8djAdSDZXisk22uFZHvDkKe0tWxvGHKTke21QrK91qfp9ipkyIdDRZ5nAPnXPM8fTVCRLcuF+5OTc/0o6yz/HyhbLdwxBVC6k5TLd0EP4//lY8gtgKz4N5SV7gusxtDiDCrhwbmnZeGDHrMn59wK6jEkNfn2drNsEvrVHB3rIAgDARguOQfoGWid7NEYF3ERBvX9n81GrrE9E5dj8E9IF/guXBPz7lZD6eVYQ/cw5x0u4y5n+Oz6z8Ao5peQnDR0+zWzHg4ot3xBZ7HrudwZuBI6QLmVuYSeIUxi1yORlBhyUH9KZTHWlzaFhaTEUAPiWuhX1weJoGFoIGU9Q6Tub6GjOkQ06dkM8lrHM2S1kGUIW53TYobQKv7OW2Rom17kA9wp5HX1qAAAAABJRU5ErkJggg=="

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABtlBMVEUAAADdLkTdLkQpLzMpLzMpLzMpLzPdLkTdLkQpLzPdLkQpLzPdLkQpLzOqjdiqjdiqjdgpLzOqjdgpLzOqjdg7PEvdLkSqjdgpLzPdLkQpLzPHztKqjdiFjJCqjdiqjdjdLkTffozdPFHdPFHCtOGulNqulNrdLkTh6O2qjdjdLkTdLkSqjdgyNj+qjdgpLzOqjdgpLzOqjdgpLzNmbXEpLzPh6O0pLzPh6O20ntzT1eWsL0XBdobRr7nVvcbJk5+Ia7erm8zGwtza3unNy+C4rtSWfr90TqqrDCV+WrO/GTGPbsHVKT+kByCjhdJ3Uq3GHjaWdcfpbX/0q7q7ouHLt+q3FCyIZrvZK0KnidXOJDudfc3CHDOSccSoCSN7VrC7Fi+Mar6vDyiCXrYpLzOqjdhqXoZJR1yzur8xNT1ZUnHdLkRXXWKagcOFjJB6gISco6eih86Se7nfdINudHngusN6apqCcKQ5O0hhWHu/xcpBQVK0S19jaW1MUlaorrOgBB7K0datk9k1Oz9RTGfeUWTZzNNARkrgxc3h6O3d2uCKdq/dOk9yZJDW3OHX1+m/r+DT0ehDueHUAAAAOXRSTlMAUN8AEO9gr4DPnyBA398QAIDvj2DfMI9Av3Dfv2CvMADfzwDfzwBwAHAQ74DfUFCfn0C/v6+vMDBjNXLtAAAD30lEQVR4XuzWZ2vcMBzHcYGlAxMujXstNVcK6UzTppjETa8v6C+P2yN7de/9jmvLkjxOA1ryLL9n4r58kOAODl3SgjZAO3D+YagWBMAW/C+ESQERbAJauywjuy0t5AGfp2eCNsiRQAO5onC1zjbUtq2GykB7H2isZYFW1M7OzSb0bOfaGhtaq8xyo63rlI6iKnN6SCm9tQRV7h0onBuUbR7LKqJsWzUIewQqIx5uQquU70daXGfOz6tViDM1qgFRudF7ADieyXMJYRcUc3ETkjuMv1G6DPUIKEd6OkiuhLhjl3oVYHYM0ayEesX3SLzL/DrsziUTpQCQHghn7mIGdcCwjoA6EHPnIOVBzOl+XiHHB+N8xrCqP8uZo0rQH2VOxCrkhGYoZA6vTuNmcBSnRYVWTIr82dkr1LUl3RyyV4jd2fo2e4WILSE5BNYKgXUMsu4KuoK+aCcgc3UJ0Ml4bzgcTt7IYHqencfTnwKyVBI6h2InvBDnVwKyV0h8kiTjizJ5tzdNsvslArJXiJG6x08EZK4kNNElFwIyVxL6pCkSEJBrq0IGQSKCs9fZzr7yZCgh7IVheFtdPc8+6mIGte/UE1688NsMEnuprh6z5VAHO3cVV/587z72qpDzQFH9eviIDRHXd5yNwWKp2P8+2Fhf910inU36e6n685Zulv/YnjwdDD7s14KPi7+91k1r2zAYwPGll5YQluFDwWCS3kLmEUJufd+72qau7bzHzkuXoJO+Qg+6bqf2G0/RI+2RhuwtMPY/CvSLHgtiM8bCtydGdY/S0xeLOXumlHr1X9AR23V+came39X1E5dLRyb0ju56/+HjJ1A+f/lKfvv0O5DQDTe6kdCBCcGn3y0xurU//SpMdmdCd7BWQadDZX0T6sNaR0FVgO4jdKJ7gKoIdQF6iNGJHwDqKihkUIJQwqAQIY9CKUIphTyAasIYDIcDIakzRQnT1bTTo7pUnSkWzmg8HgmpJyC4s6FoN91EUNEE5sJ7wzuD6aaCiqe7ucYiuDcB+QgxNuNcnQ/yNRQAAmeYEyIUhAIJhczcyjmy5kPyqLlVQXo0T0IMsyBIQ9QBYU4IR7MhHO1vIcyCsP8DwUD7QDCmAxqK9oPGoiIo4zyzTogQ/j7NCcmdEG5ccL4wYYRgG7QkZOkcDVtxvvoztCZkXX5rj/hfVDLaNyLql0ELLluU39qSyJYF0CxLNly1SbKZG5rn6Zaotmk+d0HcqggiVi6I2VDRaDZkjXZYBh1qqFEGNSR0HBZD4bGGml4x5DUlBJILQgclG9KOfmW3fBfkt+xXdjtwQUEbX9n/op+EiE6tEvTrdgAAAABJRU5ErkJggg=="

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABCFBMVEUAAADdLkT0q7rdLkT0kAz0q7r0q7pVrO7dLkS73fXdLkT0kAz0kAxVrO7dLkT0q7rdLkRVrO5VrO5VrO673fXdLkTdLkTdLkRVrO5VrO70q7r0kAy73fW73fX0q7q73fVVrO673fVVrO7dLkTdLkRVrO5VrO7zo7PysbngPlPhSFv98vP0q7rjTWLwlKTrfI7nZXjeNkvqdIbpbX/dLkTmXXDjVWfujJ3hRVrxm6v0kAxVrO7////0+v4AAAC/4PlqtvBvuPC73fVAQEDv7+9isu+o1PTylBlbr+6Vy/J1vPFmdX9se4WOyPK12vXM1t1ote+i0fOIxfKmsrqu1/R7vvGCwfHf398XI8P1AAAAJ3RSTlMA788QIJ8QEM8Qn5/v7zAwvzDPv8+vgHBwgK8wrzBAQK+fn2Df32CQDJ0CAAACZ0lEQVR42u2W+1bTQBCHU1MJmrS2VHoRFRXQ0hUQXVGTTRvuF8X75f3fxM2wuDRDunMm5/CX3wN8Z+a3O7PraephFMdRWPcqshTFQLRUzVMHD5iq1RTG/wgriSIrirxrCAYLiabRGbRni+IrXOfJNYa1QcAXgcfyLGC29jwp0Ojzwn6SIDoB5/gbCWYhIFzI9nQJJ0d7JExN4XEcH8OItIsVnHymeJ56hi8aOGvwZJNUqXSSgWmX4Ll/pyjqJ5qzVAHpGZjO6R4r6uT1pAf74/H+gTZlpOYeak9RlGgmSnu0Sdc0gZK+k/LBolSNgT+6JJM3xYNFyoiUJgFOZ+XjlYtMa1b0y5FzaWsm7Lw14LBc9Mib5senj8BF2AYIGyAFBIDHiLJUGdLMJVouFaELSRTh1tCIUFvDYWN2HWGTRb95x485Yl1IzKFj1MiiU8bQdhwFkddIP8F84yy2oIGPjLVq8fL/ylv++Dn6uUcCibjcqMjvzktNrdVtVhL5ucaw2vX5IvBY7vpM0YosUOvxRIsS0fI5oprEzPsEUXO6hO3NlySQqFmsYPsFxXO7KPLBMxoKpcRwBKYNgufWXFHUk5odoQCxA6bXdI8VtfJ6xOWTLUak5h7M4bClZmg/EUOZ84aUDxYJ+z8SJm+KB4uu/o8ksDUrH69cZFqzoreknHFr9n8kJLBeLrpX8om4CNsAYQOugPC3RsLxK4MYuUSPS0XoQhJFuDU0ItTWcNiYDUfYZNEr3vFjNlkXErPuGDWyaIsxtC1HQeQ10pOYd5zF5tdIR4ZN7uX/nrf88XP0gfUc8fkvulHRXxFfqrgcxy0cAAAAAElFTkSuQmCC"

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAilBMVEWZqrV3slU+ch0AAACZqrWZqrWZqrWZqrWZqrV3slV3slWZqrV3slWZqrWZqrWZqrV3slV3slWZqrU+ch13slWZqrV3slWZqrV3slWZqrWZqrU+ch13slWZqrV3slV3slV3slX5+vr///+5xcx3lXxEdify9PbZ3+OZqrXM1dp3slU+ch1CdiFimkApkT4eAAAAIXRSTlMAAAAAQO9gML9g78/PEJ+AML8g7yBQgI9Q33Bg36+fcK/bP+AgAAABtklEQVR42u3V65KCIBiAYdoNFdSE7HxOOxDW/d/eljU1DULwxez2Y98LeAb4QNG3VdM8n34ZQ19W5VWVe4Gqc58DsQGXF0jyAWtpQ60XkUSeq6FzCQFCPS7rjlV1lHW8B4FGVF47HY8neY2O3CEiGyOu0EhqGrlBPaqDaM8J4lIbd4GINEQcoMQEJfYQk8aYNTQwQwNriJshbg3JF/1DHiFqdqg1tDJDK2uImCHy+2+txajeocwAqVKiXQ9z/WbPmpgZAfyO2HLB6cOgfLFkDr8jtc/59wdY1F0gcQsHyD0sVEhgACRubatqK+69AW22280DSmGQWvvvoXJXFLvyfags6sq3od0V2sGhUNQVt+BQ2xc08bW1oa/DjprHn8KGpgYYmicoa3ZiZyhuhiJXp9t81GLoafhi4uikWLmOsGsUCOWBgK5ROtZAMWz26tY6sMuoHnYfcIc8vLSO0DV3nJi2wJODUz+O6IDO57AuivXhCeraP9XHvPZF3R60oACLe8Ut0IKwMEEZgkDq1mLQxNTDxiFyqKu/1H3kWL8TCzUcIEBpO5s/a+MQwQvbWRZF4zMTvVrOD88CCtAjFY3KAAAAAElFTkSuQmCC"

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA21BMVEUAAAAiZpkiZpkiZpkiZpkiZpkiZplDg393slV3slVyrVkiZpnh6O13slVcmmona5VHh3stcJFNjHc3eYhsqV5in2b/zE3V4Oh1jH1Xlm/Is2BnpGI6dqTdxk8ydIxZgIbxxlI9foQwbJRCg4CCp8O90N3WuVtSh66Zt86spmpGfqnJ2OORmXPMwlCZuVOItVSAtFVSkXNej7M+c5CDk3hLeYsubp7mx0/EwVGxyNj3yk66rGWRt1RQiXuqvFK+vFWzvVKen25nhoGiulNAe4jBaU/jv1fuyU67v1HR6BI5AAAACnRSTlMAYL8AIM/vz2C/ZjBiUgAAA7FJREFUeF6lmOWO5DoQhZtmdtcOYzPzMC3DRXj/J7pdKdvlzjigzPnTUkv5VHUKbLkFanf4G9Rpd09qdbu9C/5GXfQA1Lvkb9Zl7wTCeN4aU7fVbgDY7a+sk672R0Vqtwp9XvYPw+Hz8jVm/MVS+jKWjreKONfzBDR/4SvGVpz0mFqa0kcBKAC9bBOh+Q/btpnGsXJ6LAP9MU+kbuwz0DjNg9JxMaifaBwQpUb+kE8IKud8uj/nHC2DdgWgl3khh+9NoL0ZtCTO14zzwElXJtCVGTQkznfgDLgmyygj6JkM+gkcR+d8rA96Is5n4IzchqBvijMBDgNOk9SeckZPAdDE7N8V6FYrfIPy/yM5/1HBdO1MoCOBxIRTZpOc0XVHxGU4mDNp0B0YrRlUd2hX9jnoNwjI46S6a2QEhhBoQp04Owy/zTivudh8+NCHeUXQneygJ5yXfvmqJZAHznIQVWyh7YF5bnMf5fLfEb4lM/NUY/+LiREHQ3IDqKxBBHIxM1BftCLzz/bJgfMwgr/LQYsTJ5LLCJ0OTpxtojR0H2y7GvSgba/r5E5gDwnp0wg5FamNtKla/oIvQthLpJv7jOP4vByEFgmBFbFqBKqizaCOpaCpnvxKLI9tblHascurQCuMgQIa6Il9vbWF+5WgAL2mgHysPB0A6HIlyJHtSAH1c5wprwOKsUyghfB9W5tDIJ9HtJtjtGtJ+5b2WxUozqqPHF/00IzqRZwqkB0SaCCauk8cWCc1QZGaNJeJFr/Gfjb583GdWla6NoFAMS1cVx7bE6PPGyvTphTkyBNopm40Xhj6OmdtCa1LQL46WpdYeKFYi0rt67QE5NFa2iZ/2iQ2NVwiSkAjGpXnz7auuA6IIYgyA/1FjAj/rk5txQRoRZm5EVIiz6VAq8zmoQA59MEArfFUU8TUQ1LpuggEkYU0uiwQLR1CaNRDpI0ZBDxGDa5NBmApLU1rIyhQx30sRjcPen0PMYDwc096Qu5izsx8ETWCZJVdRquDLmF1QSM+lQk4SDSoKjUXEKrIISWmq47ZaCYc24Foxciwy7QeMvUSgWK8EgVUsfweMmqjgyCIkGXO+PDjVKdFWueOo6yZ0WnmVxtNSnOgQVa60Hg4U+lNyh3ZeAeJcayag1DBQlxCm6a2kCAMC9TM7FCAnKLS879LpUCuAOGqbAzqcG6TwqagDjz7xNpx0RTUhocoR4EWTUEX2dNYIDkRbwbCp7Fu750EeQ1B+Fh30vsPCPIbgfD58H/15FG/g8jrDAAAAABJRU5ErkJggg=="

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA7VBMVEUAAAC+GTHBaU++HjPBaU++GTG+GTG+GTHBaU++GTFmIRO+GTG+GTFmIRPBaU9mIRPBaU+7ZEvBaU/BaU++GTFmIRO2YEjBaU++GTHBaU/BaU9mIRPBaU9mIRNmIRPBaU+7ZEu7ZEt/NSNmIRO1X0fBaU9mIRNmIRNmIRPBaU9tJxjBaU9mIRNmIRNmIRPBaU+URTGzESqiBR+gBB6fTjmZSjW+GTHjmqX///+6Fi+8GDCmCCKpCySkByCvDyitDSa4FS3BaU+7ZUt9MyKwXERxKhu2YEiOQS2IPCpmIRNsJhd3Lx6qV0CCOCalUzzWTzO8AAAAMHRSTlMAEJ/vIACA3zBgz1BAj8+vr98QcL8wAL/vgFBwQBCA3+8Ar1Dvj0Bgv2DP7wDv3wAcu5rvAAADKElEQVR42u3YaXeaQBQG4JFC1MYYg0aC1Zo2ZrHSjEFj9uWKC6jx//+cjsjMFQPWkY/t+8FzgLnPubNwjkqW0ZUWhNJSVBoR3axDOHwc8T8zyGCan51MHj6lVUEInc2SHj0uwyG9DtGprkF5iExLD6BzgL47GTruDMKphx0TwhmNnaHn9gGUJaQCDIaeH6cPoZgbJtYfL2smA9a6DynQn3pBftXDTW9o6CevmYygsIB0gA9+77qWiV/vcENFesWrHACVQUWYeTzHlqXAagx0KuvLV/vNy+aMJdQAh9/4blmWCqHgsVQ+tXrG66aQZxCMxMSsRfLhgpiZLXYcJzcAnVRhzC+/+dB5qKDAnfDi5f17F7xyDBVigtiyGmNSe+neFvmyl9JYroPKIZik0OfOIXP2T3pb5mSfQQe8dlQgxnxlZrmeRHKaJuY2N0irzS8urFRaBkprWo3XtoGAi0uU7Uklq2n8KH0AwVNkWSU5qKRp/AA4YagnGYSGDJoIKLU75DHIW4dubPsmphKfx0M4NbvTsaMJfL4V1GHZBOHzxa4hNMVzJA95CNXFrp3JQ8e81mkRQ0Df5aFLARlEESf7ShrCl/ajQMy2xyMPfRXvmkkqcwFdyEI1UdqtEHUgrg5koUtROssQ2hJX17LQIe4+JRS3zZOFxHGcGgwyxztDotA1GVSdJ4e6VQbR0+TQqFwm5XJhmhQa+l8iaPM2KTQu+pA+SArNVB+ihWEyaJKnS6jZTga5xQDSG8mggRpAVHGSQGzPOFTtJoFuKwKi+UkC6OjHIsT/bLZ3h1yTYke0sTs00Fch090VchS6CumNXaGZyiFsKRK6u/dzFwVhQwjpjRjoPkgMNFMRwpZw4EM89IgQNoQQa4lDT2zg82Mc9PDMHr8EEDaEEDXbAfTaWQ2HQjffAog3FIL0o0nQu/03yH4MoJEaAdFmN+j+3d4M2e/BwLFJoyBqiPV8e4mHnl7F+p3q0VCmh9mw/ZgKjYaoLKSthKxe/FMQvrQJIcx/aJmSnJOOhbJy0F4sJPfj+CQVC2k5GWhfi4e07f9ASOe0CAiz5V8apay2lj+YDBKI7GWizQAAAABJRU5ErkJggg=="

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA+VBMVEU5QUYpLzP8q0AAAAA3P0QpLzMpLzMpLzMpLzMpLzP92Ij92Ig5QUYpLzMpLzP8q0ApLzMpLzP8q0D92Ig5QUY5QUb8q0ApLzM5QUb92IgpLzP8q0A5QUYpLzM5QUYpLzM5QUY5QUY5QUY5QUY5QUY5QUY5QUY5QUY5QUb8q0A3P0T8q0D8rkX9x200O0CumWj8sUlRT0MwNzstNDgzOj/92IjwzYMyOT4sMjc1PUH91YSBaEM2Ojg4QEVERD45QUYqMDQvNjrwpED8q0Czg0JeVUVFSEYpLzOCaUQ3P0R2YkQ2PkLXl0E2NzRRTkWnfUN4XjiYcz/inD7AJlO5AAAALHRSTlMAAAAAABAw78+fMO+/YN/fcI/vnxDPYK9QIIBwnyDfQI8wQHCvYO8ggECAn96TnCoAAAKxSURBVHherJVJboQwEACRkiNHW+KArPEwNiR5RJt91mz/f0wUK4KZFjZuk7pxKYGr3SRP/8S6qCyqqiiTzVRgqTZq2AH+OLAtHilgQsh4j9Jwh1axnhwQeZSGccAAZ3TPXsMCek/1FOCgIFfHxMyB5OCBS1p1DH0OdrDKLqR6CgGkqwclNQShJbl6zBywHAjkjFadPgeZBiI6I1Q/1WYcTX1yzEFw9YsZLeYSNgdSON7HeqwJvdPy4lTgoB4nanCgQqqbWWRW54B5qo93AAYvzhScvIeJILXnDE765oY+zYX0is5N+4kO24Vd5cLhObZt+31D+ZcRvs3x0f7yhQbSu1PKpWyd9XTzFXHDS/cgDVfrOZLXiULZracJ8ijPZesb6+lhHSE91/9sPdc+9iewm7JbzwDRv6VMz9m7gbIgMZJP2YkrG8PyDmX3VvfwEpz99fmR5PHxLTD7T2f1tpowEARg2FnISTGeQLFSfIEkHlejbVJDLgbp+79PN64yLE0mZv+73HwwM4HN0gDMemA0UtAXA9CT4DksVKrw3OacUTVsh7DI2LEKrAregDD9ZcZK8VHIQMtZBW1yxFvS5CQ3fNYM9QeyguRph4j7emeP2AotB1JD8pQr6VCzqOyAb0Az+YLkRj/3NVenvEZoQNAJHx1N50gKezVJkMy1VGTG1Y0+WSgqy6iCvlGX3l/OPTWdD2BHi6MoptFQ/wd0dcoH4Jb9aoNUkVwuSYFmnhqMPb9OnZ/Pc4GBoH/VznWHLQ2BhWAbK+oaby0cEyqfDT12LnLaIOF6HfbDQcINm5zQhS6QcPx6x3egE6QK6pwAoDMkxv+dMdhAtChajx0knAVSuHDACqLxaCx7SLi+ZnwX7CBqgqoJQBdopJ2RMFqH4Rq6QXMNzYVFPeNrNS3L6UrY9Ac1acVMmLyNeAAAAABJRU5ErkJggg=="

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABfVBMVEUAAACIyfmIyfmIyfmIyfmIyfmIyfnx8vKIyfndLkSTlZj/rDPq7/KNv+6v2PaPzPnd6vOVzvi93va9aIjCXn3IVXGi0/ethaq22/aoj7Xk7fPLt+rD4PWzfJ/c0e7K4/Xr7OyQpbaZm57YOE/y7ubSQVuMttXZze3Q5fTX6PTeOk/+sD91cX+ZxfXrtbznkJvswcfl4PCc0fj22KrfNkP05c7VxuzNS2ap1vf8uVff4eHw5uewsrSSmJ6YrNfqqbH4z5ORn6qJxvOrrK+6vO7IycuKv+f7wm/fs6X0hTjtzdHOV3GTtuKrPk2byPb1rlWlwfK0wfDYtLzqg3fHuOvosYPhU2XBs5fv7vLSwuzo4/De1e7QvuvEu5b5y4fs6/GdoszU1da2uLqmwNPl5udYWVvz6drOz9CjmcDwp2K6g6aLudt+f4GlpqfLzMzn6OnubTyLvOHCxMXjRkGOrMKhwvOww/G4cpOvucDNu+uPqbySnKTgR1qOr8niX3DZgT9JAAAAB3RSTlMAYL8AIM/vi50ITwAAAt1JREFUeF7t2FWP4zAUgNHiXDsIZaZhZmZaZmZmZt7fvrY1jjpTJ8okeVlpvsc+HF27qZw6QovGUIBi0TgpEo8nkihgyQSFEl0ocF0JAiVRCCXjkagL8ITkUYpGYuFAsQgKB0KHhI4gNZfOZNIFNShUaWFWKxcAKhtaCtulVN+QbsD4+OjYXy75hlAWWEtrv5mU8w2Vgbc2SPdJ9QsZYLd0lY7kF4K2lshMGZ+QCe2tYYx9Qjrsi4z0PNDSeGMYfwsK8V3qCQWCUYwLQaA88C7h6WtOkFrpwRjPFVwg+7l8Kr/HnxygVcKw0iKoSAGD/1JgXZZPTJ+xobPnL2xf7gNSf3a1hXkFATTAVsah7iFZll+8HB4eHhn58nW7xPoBrNFBsqwMg+YEkEUARefQMZl0vHSgCWCdPHUaITVFJQFkKlCcREhjzhR1zpUOVgUWGDoF5oRQ+2AwM0Shix3QLOxVo0DGHbKdKyVnCOYJ0HKHuLNQcoOKCBWIk3aGNJhizlB3tRPqAzsNpcRfP09fl5kzA9dvdEA3wc6gW9RSnSHEHeiUbkFbKM2OCHdooRtY+1Z3ewLay1YwXnWD7sjyXeqw7lX3ppqtcsaG7uMWcoDMfH8RvJZFPWkxpJcZ4B2qVMRQDQ4JqSkhNOnd4M92zvmk5T14+Cir1ZQ2wLC0/R9Yrift40WA+rPllcYrhr9+8/YdVQbyJn/TsOt3O0XqzcYH4RubYCMVN+ij9Bm5Q8gCnuUMKZK0susE8cwa8AYmHY7smiRJG5vOEKfyfKuKuhhSvjepJITEluV0HNXpTO4Qb2uRjuT4HEmkn54gSaKSADIZ9ItKvd6gZl0IoTxxlN0VAv3xBkk7AFkBRBdXRpsNzxNJywDzwf+LbEjSFoAyrweFeilEKweEUENqAqsWEEK9GzvA0vxDvLxCISs4hMxyEUD7X//THkGhXbKEdu0T1kVUaFdjYV7WkcK4PvwH9rUgJpCXK4cAAAAASUVORK5CYII="

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA1VBMVEUAAACIyfmIyfmIyfmIyfmIyfmIyfmPy/X/6LaIyfn45rqt0+S11eC819yXzfGm0ei5kbRcc4d/uOLh4MfL2tPp4sPw5L74/P/S3M+ez+z/9Nva3sv//vpFSU1BQELE2diEwO7fV2v////kYHfE5PzrYnP/+/HYboh7r9ftn5budHxgfJJlhZ5tlrRKUVlOWmR2p8tTYnBXa3vS6PT48t+sxMmIf271oZJNS0liZmeWTVjQvplMQkVlYFi4qYtWQ0jp9f6YZXidxuiOwvD+37LqWW7R08uqEwgeAAAAB3RSTlMAYL8AIM/vi50ITwAAAy1JREFUeF6tmOeS6yAMRp22gLvTe9vee++3vf8jXUhgFWu0xp719ycziXIio8kB21GpVMUPUq3UZJxard4QP0yjrkD1LfHjbNUlqCFKSKPmVEQpqTjVckBVJwvAvHbL5au4rbbHskjfg5g/4igjnxUGsZluZTheyoyHurEZKwYKNObP3lJnj2tUUAAUdrjOcPmVIdfphHlBnm6nG4Q9APXCoKub8vKBfI3xJfPvRtRHGuXnAfVhKTAIFq9vA+301jMy67ANnO11xaCznmNvJwP0+2Op86HBMYBisoYG7cCMzO/tG84+XUODNmdk4PHq6rZjsoYG4RlB7DXlg6gZQWw1GMQO0YxQ8BwP2Tcgnx/BjIigOR5x/xuQ9M/9LsyICsxx9176iQYxLhOInJmpakaCPAUK84JCBfJIUFuZQ+A0k8l0OkmaAkeJoE2CWtS/+kBiVCYHlCVaJMgllqgpOZqEewqUbEgQl4kQKJl+JUGgSNXnBk0ANMkBgjEM0pz5dCN2ELgRe69Jgeh6h/Ce5dLoeofwnmWx6XqH8J5l/HS9Y1HasQEdW/RmAc2ho7kFlO29E8U4PVWkk2xPOtT+BTmThDPzAiHqHWL/gqxaOYVXHarewd7ziYaIlnxwKSF/FxnJrI1ZK2QjF8kfMkOyPdfT0tM7TzuEzwQBgpbc0HAuTEOmpQvDGbjQEAbBD3VMwaVpyLR0qTmsA63TILGq6G80lKQUdwGW5R2RBQpdIF0pUDNllCvguGGeE9s1k99Efk00l10XOrENzBdNDPhXwRPbza25FBW41Nubgie28d3mvGHx78YFT2yLB8l5DFODeJSgh0XBE9uTauiZd/tBFEWDKAr6Xf6s3nsqdmJbvEjOK0d5laCXhf3EJuJ0Q28Y9JZuKUYgyjLvShsjfL82UjZ5BxMRIHSq/lxbg3n/4H6t7bG1Vz7h5E2DsNDw/oUFZweB0PD+BYKzg0BoeNsBwdlBWGgYBIKzg0BoeP9CgrODQGh4/wLB2UEgNLx/IcHZQXNoCN+vQUsEqEqAoCEiTRJUJR77nKADQ67PK9SDqLkonEZpj8bKfFgnU8bjw/87nXVV5H5zyQAAAABJRU5ErkJggg=="

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA2FBMVEUAAACIyfmIyfmIyfmIyfmIyfmIyfndLkSIyfn/zE2gBB5mdX/Sy46oj7XYOE/NS2aTtuKjmcC4cpPjTEaPye7ZK0LfOEWNv+69aIj9wkyeytnIVXHSQVuthaqzfJ/OJDvCHDPGq2DVKT+dosyYrNfmVkZoeoeCueLpy237uEy/GTFxj6X5rkt3n7y1yrnCXn2rDCXykUr4zFi3FCzhy3ivDyjoX0fEy6O9u4zSJj2mys7wzGPqaUfLy5jufUmzESqzoWaroHH3pUukByD0m0qoCSOMi3Psc0gGZqucAAAAB3RSTlMAYL8AIM/vi50ITwAAAc9JREFUeF7t2MeO4zAMgGHbSYaU3J3e+/Tetvf2/m+0FCYxtIN1PKB5WGDzX518kGTCBzkm18MKeW6Ncmq1egMr1qgbqH6AlTuoE9RAgRo1x0WRXMeTgTwHhfqnoEAICpQMdK9koEBVhi58/4Kc6pBPkSMDkSKytS8i0NHh4WsR6Mz3PwtALXNGP6tDreOAC9nTQ45Sc9+fK9MNC/Ip41DzjQNsaHCr8shps7f2pwPXLIim58hy3gPcaRZE03P2zNHsM9oy/UfjsKBXgQX1mwCh5kADe3rUeROiFDnQ5W0+PcbpQLRCDvRW2d2AcThQ653t/AKIyeFAlwTYryvuIg+yFnTSBOiRw4IGKu97B+AUkQl9yJ2PAO1Pmg0db49nDfDmWvOhjfO1A9D7pgugbrnTyrcVhaiLoChLXgSdNwGGCRZDQM/DXcvqhqMT1TfLGSPuhqirIiuZRACdtflJguWQKc7S5LkyHsKmxRJxNzQFq2iYTdLlU5PeCHLmTmMZpH/MFrC7kfkSlkPUKhsVM1cp6jLIUpOw9zcsHicEvBx6qvtwOpvGW6M9naVmLBhQwR/+R2gP7aE9tIc8GchzXBnIlbqIErsak7ysoySuD38DYYS6i76R5bQAAAAASUVORK5CYII="

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABaFBMVEVmIRM7iMOZqrXM1t2ZqrU7iMNVrO47iMM7iMM7iMOZqrVmIRNVrO47iMM7iMM7iMM7iMOZqrU7iMOZqrWZqrU7iMNmIRM7iMNmIRNVrO47iMM9i8Y7iMNmIRM7iMN6WFRVrO5Lnt1mIRM7iMNPpOQAAABVrO5VrO5VrO5VrO5ElNFmIRNmIRNVrO6SmJ9Aj8xVrO5mIRNmIRNmIRNmIRNmIRNmIRNmIRNVrO5Eir5mIROUc29VrO6LY1wAAABVrO5VrO5VrO7M1t0iZpklap4sc6lNoeFsfIaJmaRmdX9Cks5FltMob6RsMieMiI1Dk9BPo+MyfLR5VFA1gLk+jcgveK5GmNY7iMNAj8tTqutKl9BIm9mZqrU/jclQod9Ln949isZQpeaPkJdImtmWoas8icQ1bJVSqOlVrO7M1t0AAABmIROATkYVKzyMZV+ZoaZ9jppcr+2CvOglS2hFjMGfxuNAgbMFCw8FqeSUAAAAQ3RSTlMAAAAAv4AAEO+f7xCfQK/fYCAwz2BwMI+AEL/fUGDPUDDv3yCPAK9AgCC/n89g7+/P7yC/j3BQQO+fr6/fr0C/UI/v2BFgNQAAA7NJREFUeNqtl/tfEkEQwEkloPNBZHhYlGEPCyrhBIzoJT4yLe05kZqYGQuXvbN/v9thYe/27hj8yPen/QD3/czMzuwtgWu+aMW8bhgZE0kZxpxe1ALHJZ4vZU0PUunkMWSFNEr8yPTm0vSUyRH56II5w5CqbDpH5yQ0hl6Iq9/lCnrGFJCqEv6q4B9w0miruif44Ou3+0QJcqKE2UKgCwuNxsIgRS5tInNdRA2LQZpiqpUeJaLRSsJEiWha6eknFElTkRTRZLBp+yDSspgcKaIpYDvRIhrs8mQfREUuKp1QJOut9UGUx9z6IMphbrSIJoX71gcRjlzOW/SLMfboyePTPaF7Fen2TOJ0o/GXtSjP9CIqus+lqVnG7j38/uMna1OeokVYbcPhmbce/d1sHjHJ/G3ahFOieti/5iFzQMeEgys9iTKz+CMCkpQTlAjHTb65ZhjnqB3Qx8Nm8/AjX+1DeDR6qguG43RLzAvRF4ZYnmZLWq0BQPgiIcp3Nl4EYkWBNJEPfLkGnAlfke443IaZRIpwuQtIqDfRrHQoqbE9QLpGJDuSKYhiI72IDEWkIkVjvYkSpGi0X6Jgv1KL+YrSxxKFiYY0HNtf31ljks0tJrc/0qvoOrNYqlTWn9WF5nWlsoSrZS4a6VV01Xpiq4K8PHi2c7CES4zpHW6+Pym7aPous1isKGwyi/eW6Lz69PjQtsXQ+MDAgGkXRaDKp+qtQ7OIFavyUiuDdvbctuDcWYcoBLArKtOJan2n3pnZoOI5s93hzGX7rTQKsMEEWzsHb60ybTLBhjsgKx7JHfsFcBQA6syTujugcf7805XV1ZWnfPXKJgoDwL63aN8d0BD3rCLc9MImAosL3qIagHrM8jBWWqIVvpZndoi3bmjYy7OLc+8WrQoUER7uN71EbzAxQiRfRzH88bBXQGEcezK1gJ2b86qn+gbwlUYVW70gzbi2THjI7TcCTspKD4Xl0Ps25Cevu98Np+jWtKpwj8jn516X/4tX7J4rSgN5Di161BvbBMCe9Oz5v6flMVI0Pf4hRQCgVu3sWA1PWALdRBQP531VePh5RptK6MkoHmGSHtqUdf0fjUKb2jJjyzVoE+3miZtIXnpCYfAGZ82XvInEpSgIvgSJa59zQMagzVgkOjISjdg+8Pdopqn2NQginWGPRUDgL0qKEqmicNBRj1CwVThi851/aSatBy65Rmv6kvXxpL/IdHdRbNJzHkITMBmjRMnAicHUUtrJRdpc1szEA33mP31525zmPTFJAAAAAElFTkSuQmCC"

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAC9ElEQVR4Ae3a0YncMBDGcZXgElyCS3BSgQkEEvKiCoLJawiogtuQI5A3NRC4ElSCS3AHcQmT78EOx8BmuNFq1joU+INfTM4/vDPa49zZ/r3//YdY7p7tF6eqATWgBtSAGlADakAN6FqPP39N6IIWRKwVPaEZdcj9r/3iPGmBdhi/A9ALiqhXA+E/3lBA/VnfoP0BEyJlG/JaIHpWRMNZgD58/DSh8PVb2LQ4rKgGYiU0WQMxHI/o6PP8hUogaYGOVuRRZwbEcAoh+TwgFptTRYEAMTGYEkgb6m8JpJ5TCqCEyAAp3hRIMadmtCAS4kABkRFSXxKIzym310kwLMfDw5MR0qwB6lFUQLm9pLzvOPOMiIyQUs7JtkMBbS98UMoECoiskNRALI9WI6ALIiWSPRBrROmGH7GEOFBClIlkD8Tq+X2KIb2gTgZSIdkDKU7E/grUwrbe1RlkgWQOpIgDzYiMkNZrKN3e3YHejG97NKOAJvx8AyIjpKcDRT7Z2gBxHI+IlR4uPzYjJC8PTRMgAYc1Te/o4fsjFUbakGNr9xxAQBjQhuiOSOEAInMgeeZwHGukBTl7IBmnQwuHsETaf307HEBZJ1tW9vaTcUyQEnJHuSfbnO3HcaKMYYLkkTs6LhQn26ztx3GCjGCCFJHjQKr0209e56ZIHIelxemUw53jjIgKtABhRAFFlJ4VkEc9nuWCEpqROw8QO+sUyiOXm/ZGzfbj63xFVLB0TyD19pPPOpUDsV68/XDPEyKDZnug/KIRzoK62oC8EU7KwmG9NpyI3F41QAParGZObUC9EY5HriYgq3W+oQG56oAMcBaGUxVQtFrjNQLNBpuK4dQD1BfGuSBnWU0fLY9c7UBboU01IVc70Gi4xhsQ31QNSP7C2YDkL5xtSM/IvWagxWCNVwsUDTZVtUDR5gunfSVxVuGtCcidvVI4EfG/LzwakaulYjivpYYj1HCEGo5Qw7kR0CDjtDfIyzhtBnkZp22x4d91A2r9BV71eKLJecY9AAAAAElFTkSuQmCC"

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAaVBMVEUAAABYWVtYWVtYWVtYWVtYWVtYWVtYWVtYWVtYWVtYWVtYWVtYWVtYWVtYWVtYWVtYWVuIio1YWVtfYWNcXV+EhollZmh7fYCAgoV5e328vsC3ubtucHKTlZiWmJudn6KPkZSgoqVbXF7KMee9AAAAEXRSTlMAIBAAcK/vn1CP30DPMGC/gFN9KCgAAAHqSURBVHhe7dXbcoIwEAZgCUgAKTbh6Nn2/R+ybjP4k0yDWZzpheN/JRd+s7shy+ol804k4pCs4pmIZJ3qW9J1Ip6AhNSTSLEUylJtJc2WQfkINM1I5VwITr1Tp1vUrobEgzJimt3pnp2mZFxIpOSo0ySKOkwFE5JwbEmOgBAhkKA20Ne0O0F9y4J+FjJ7BCU05xE4n0eJJp7Em0LfU2zmoTUK+jrs94cvlLTOtZV8FqJRK+Psf2MkBQBvl5yDqGpTxMFAB/M0KseW3PaImgC5s27MfEihTKH6fpyqJmnjhaJZqL7iIK8kFQtbU9OzVERn4cO+4F9H+yxpTjLk+C/0lwuOX7f2WbbUW9gLidQEuQ0TvuSKNNYRAOJcWu2F2GuE1xoWm3YXm2/Y7FXLOn5InqBhvJCMzxHivyJalx+uUm21L/5LSw+fFhOVHsOzRgDZRUWpDo+MLcgqqmQ4eexCKKoKZ7D8AaGobTCTkeBCKMoFhj9iJDCAUNSzEMKDDPn/kP95BnpDb6jrh6HvPBDjheyG33QLIVza3kD9Y2h+jXzjTvEglONA7DWCVeu0xoew/K1hcyCUAwjHz4FQDm/5bx0I5TA/R5UNIcwPZBl7IOYnO428EKSAmkpyfBBSPZj4FvMBtCyvAL2hH7HW8aJMjUEkAAAAAElFTkSuQmCC"

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAQlBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMP////a6fTn8Pg7iMOpy+VUl8tHj8d4rda20ulsptKFtdrO4fDz+Ptgns6dxOGguc2TAAAAB3RSTlMAYL8AIM/vi50ITwAAAV1JREFUeF7tmEluwzAMRT3ma/SU9v5XrYOiJVpTtkBykyBv6cXDFyXREJsHbRcUdG2/0/T9MAYl4/AQDbeg5jbsojEYMPZNG0xom85G1DXBiGcT5WwgmmaPHT9PKtHi8Ytf5KKIP0SpaMY/Zpko4kCUiBYwLMxuXok8GPyPJEWHHRfTlWgCy/SdJRaW2xQrzdY7OxBw+VTkweLJQ6ZTEQpw2xlPRLksSjiQyqKEAvz5Ei3N4YATFRsMku3PYBAcSF4kuiJgEFxavtiCNsJ/FzQ2/kAKWm3lFQHcB9P8z3GBEwGfgUj3Ck/mRRSK9fCF5kUUylWuixdRqBUVrEURhdpQwVYUUShUURRRKCsRXkb0Fr1F+itif2mpjahEFEcnojhKEcXRiiiOrtVSHFXzJ3S/I6L+B3lPVaKQLjK5VP2mXTcU2Vb7V/bri8yGLGZjH6tBlNlozHJYt2MxPvwCw/iyk9mr1okAAAAASUVORK5CYII="

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAgVBMVEUAAABmdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO4pLzMpLzMpLzMxOD1TX2cpLzNTX2cxOD0GMJxbAAAAK3RSTlMAMHCfv/8AUO8QgN9AjyDPYK8QACBQgL/v/89AcK/fn48wYFDf////AAAA1cLGbwAAAlRJREFUeAHt1W+3akwYx3FSQqhtiJF/ya7u8/5f4HFHfrNzDZP94Dzp+yhrdX0wM2vRptJXxnrTtzZWujmRZsraGtbmJcvYvgvZzm5DtnPsdyDH2kizHGXIxdOQ7VwlyPZextZtL7Rnz0P+Xlzcw7BT+kFc/L0/B+n4N7YIG4l76NMQHMM3iXxDJmm0s3dNSe4ekhTyn45nTuQ9JV8G2c+bHczJDs/HtiWQp+ZA8mjIVXUguSTUH7qVqdCqP6wU5GwefZlKfW0eOWPItrqtsOcR6u+AnPkFopbJGUE7vPRcxACg7fQDBWxU/0jbF8joXpkwwugYJzwdS90qGS+QhROGgtP/RtcY8nBvQProgAVZXnBEQP0B1n9Aq15HKQxA1LutBghLtDYRn4fWwyIBWuNQqEPOcHdA2HwF6JSVcYUDQEDuLNQa6XDtLobOCa5pyFaDYq4ImXKoIiCbfjU5FFd1yAiI/YQuzfej642A0rI+sy4Kul272eZy1y7fQ7f/hPB3EkpZ2w2zF63BxfWP0BRU5FnA2q6YbbRvobuQDMqPp4D1ibNvQwz9A+gDfaAP9IGiKo7zY/pbqMaH8VdQyZEcavC7oaGai4UMibPi5+jSzodZGbdVEaDi5ZOLxFntfml6s3XCnPji8x/FTEiY1e5CGUdyiE5jqOIklHCxch6KOA0dudh5HiokEEs5qtksdOYyKBjeOYEjhyIS6gqrOOFFXgdMAcpISDlAJ8JJlkDYZlQugo5jKFwAYZtRxpZBQbzIAYSOCZjixJZDLKjzh1WUEXuvv46Cei8kO0F6AAAAAElFTkSuQmCC"

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAclBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoJkkj/dNUj9yVAtapiLllYiZplckTvCl4XakHrcWFtne5DdLkTxu2HJnHn/zE3CnHXaiXbepHvgp3i3lIbKip9uAAAAEXRSTlMAMGCAn78AQI9Q7xDfcM+vIKr5RHsAAAKHSURBVHja7ZjJcuMgEEBBCLQgybT33c72/78Y7BA1nkZgalJTc8g74vKr3kBI7Jf/BF6IUjpKUXAVgakJqloCQdZVnqgpW5igLZtnRVp0EKUTOiJCTQtJWqFToh41cVUfFfEBQuyOq81mddyBz8CnRT0E+bCaG6sPeKCfEOkZBNlZjzPt4IGZDon0AGGOm5EjPDJoKuKu55f1fLudry8wskLRikwC/1NkXLderObG/AW+2XjQ7hkU+XldrMeZLkkRZoci6ZbX25F1NDVE+qIaHHMUzePFRmoUVePi1iPRfqT6FukuIiIDSem0EwmASGpki1DEl0i7zpNiR9gfFqfT4rB3M6CtCAMi7Z/m1WpuLF7HkBgGRAZykr31ONPehWRFBSBki4Q5nEYOcKewohlks0DRwp0DimnI5+ThljRrfkbUsBp+IjWomYR8aLFBshZyoe23tAzyoAPpyBfRLUJF+fwz0dD9hKgVRlX5IqpRliJfJIP3FQmZSFaCR/2lSWX2dl5er8vzGyAlKzyrUZZ0QO9Wc2P5jmsFG/80VHiFjMdjPc6EMRnmntZdoUZ0vPnn68gZHMP9KdILwZWHgChLFC3B0VsRwXhNlJYWHrl6jJkREVYa0+VlSlSqgKgPXMfMLJ6aISL/udsojyJW7FIFRJiGoYGG298aKvJnuqGlCw9krwKiAUWS1C68RaQKiArwcE1LjHuriYjMdE+LRz1cERE9hiSf/AkrGRLRC4UszL0HJB5MPySSmSd4i50lEaWg9UnVKI3UiohIbnnvkFSkn05OmsTLcSWf0lTxl2NUpTVURDF1F6lNzXM+afB6CI5UTYIhIoKuRClbPL5LUWmFEFEWv6K/4RNwOgnMrdHCngAAAABJRU5ErkJggg=="

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAArlBMVEUAAAB0TqopLzNlSJJ0TqopLzN0TqopLzMpLzMpLzMpLzMpLzMpLzMpLzN0TqphRox0TqopLzMpLzMpLzMpLzN0TqopLzMpLzMpLzMuMTpAOVhmSJRdRIVPP288N1FvTKNhRoxKPWdicXpIUllXZGwpLzNASVBLVl5mdX9ETlRTX2c4QUZbaHE0PEE8RUtPW2N0TqotMzgxOD1ebHZTQHZFO2AyM0I3NUlrSptYQn3ewncaAAAAGXRSTlMAQICfv98AMGCP7xCvcM+AcABAz7+fnyBQO7E2FwAAAitJREFUeNrV1Nt2ojAUgGGalhpB2xL2QLVCOQWPtfRk8f1fbDQXZO1yKMkMF/5X3PgtE9jbaI4xQjwAMHmVCQAeIYw5jRnOj0Z0DBbvzIIxHXVCNp0go1ObULsFYh5XzGMNkD3hGk3sGgRcK6hB/FSeJK/5G+/Ry3qTJPn5qRFKVud2y/17l7FPs5Uo6YCqstd0v0Xe23a7Tje7lawdyoWES7JTH6uG2o4m2i8/Vr3K0i0Xtb+193yZdRvL/KXjrQG+0W26zDJ80l22Sdfy3vpAmDyn8B2NuVbjGkT0IDIcRPUgWoOYHsSGg0Z60AhBIj3IuQQIdBy4AEhzaj0M6Q8bGRKa6kBTDOkPG7sIyNGakMuAXHXHxZD+sMGwkKc/sxgi+qOGofvP7/8DPRRFefw69EVm88+nh9sqQz5eFaJyEYSzX4wwOJbFqasWSPYcHYM4/AkewjAOFlEh6gchU1TIWiBZodztpUB3qs5dC3SjCt0MDV2rQn+aIV8Zuvbrs+ZPXR6oQgF3pz6CqFizoSoUi3VLK4ianItKRejARSYVkC1X7FzNOcqVazuGb3FZoOI8zXiV5Rt45c+fezsR2jFgcNwsLvv9nS+OExDuO4i6kXIR1xeyPBrG5sExKmtCFAVx8x4GfNn1wqqG36PLdnzg/xz46IPUzaRoRHRzKR5a4mopBA+tyKeeqXQij6I1grIZ8eB3AzzCbEeGIMQ9EgIAFkdZAEDIoyBq/QV1BJZ3tH62NwAAAABJRU5ErkJggg=="

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABSlBMVEUAAADM1t1VrO7M1t1VrO7M1t3M1t3M1t3M1t3M1t3M1t3M1t1VrO7M1t3M1t2+GTFVrO7BGzNVrO5VrO5VrO5VrO7M1t3M1t2+GTHdLkTdLkTBGzNVrO7dLkTdLkTdLkRVrO5VrO4mKClVrO5VrO5VrO7dLkTb4+jw9Pbt8vXe5ero7fHy9vj1+Prr8POzu8HU3OLZ4ebLytLFeIfu3OHKvsjW2dvJs73AGjLPX3DCVGdAQ0VNTk7P2N++GTHOJDvCHDO+vcTR2uHEHTXdLkTTJz6PEyXW3+SRFyngOU/qWW51LTfoVGnoUWbjQVZmJzDpVmvfM0k7FhzmTGHj6e3nTmQsERXiPlTkRFnNTmDeMUfh5+ywQ1PlSV6EMj5YISnhO1HfNky+SFlJHCLkRlwdCw7m6+8mKClma29VrO7M1t0FCw8AAABAgbMTBTt5AAAAJ3RSTlMAMK+/j3BAEADvn4Ag32AAEACfYDDvz1CA30C/cIAAvwC/AECA31DKSWYwAAADcklEQVR4XtzRuwqAMAxA0VAcHUq1m0Nj6rf1of7/ageluFgwwcE7hwNJ4LtGhdhNpN1z4FrZdIbGU8+A0i1rNA+qGSlICUHvV9svYkE/EOPYa5Hq/xnQVgKJ/gzFKAOFnMPcDloDB7v0spwqEIQBWOqUGUcqLEneQEBawVviZYxhMy/AbvYu/vL916fGZqZiYgKWdc4qveKn4atuGDEtMBWD1uq1PTBEqTC8H4pQ6QqI7oUCibqqSsjgPkhIqFprA0hxDyRi4FhqXY6AWLRALU6RQGukqlXq/ewgNTAZzBhtUu9np84VjIHKR066GQqsMyID1DVg8sJKwe3QkwRQ5LkCJhNAna8gn26FQpwdysAQMkqthLAz5NeCSiixHpFNSSPFQWdIhDg7KZG2HpEVNDUSQtENih7R7EU1rMAeai89Rh2ghxjeSZQFMqKs2ZTygrt/HlqgZhpglFMzCI5ERzSjUV6CK46+h0TfMTBERIZDQpT4uzwdL9gXVyERSseosXUmHCprVixNrDRWjpKh+Ar1PQOdWCdRnLIPYyjuFPBU/zM0BC7W8p8VrML/Al7a1/ASCj1TpHQu52QcMydxTAsvhReQ9BA19Snn3/UhP0ICX6CuGfgn0OA/Qr+QdM6sKzRzjrx+sucLdhZLztMV59WU89L159dP9iBm5+V1zdB6w9B2x3m35bxx/dcXduLBJfQ8nwGz+f7tsF4QLdaHw2YJvG9Pp92KaLU7nbbvwHJzcP23Pb/x/Lc0utlREIbCMMwdTGaJxmE31+AKTTwY/QRFjSKNgz/ojvtfT9N20faMNWTezWlKeNK0H6ZIj2GqmlGmF5ma885qbvZVGc30YvhpivRIJuM0HU+IKJum6TTTc2FDC7NvvpP+I/kyRXokxFoCKxtaATmxfIh4BYew5tJbaA1gY0MbAOW2N7QtAexsaAfZ/g00YNABsqMNHSFD5UODMHSCDJ2TgsptL2ipnNqFaiUVIgSN+AXJzi50hurHhUYBSBRQNS7UQHcKQ9zBxYUuMFWvoYQ9GPTrs/dXXS0oeQ3dSug6L5j2IgRx6e5Dd3bbDCJikrlrftsHcgtBdIWs9aEWslz0gegB4OlDT8hu1AsSOeqOVQMPCkIxkyo0HGpQCt+JHeibWHnLoRYn8vu2ISmxM1XdH7EDxdJxoP/3C+5h37inhUtzAAAAAElFTkSuQmCC"

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAYFBMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t2crbjM1t2ZqrWsu8SzwMnJ09u5xs6/y9PG0djCztamtb+8yNGjsr2vvcepuMK2w8yfsLonQk6wAAAAD3RSTlMAQJ/Pv48gABCvgGAw73CGY3xdAAACH0lEQVR4XpXX27LaMAyFYSUBDGnAdg4c9t5t3/8tC2nqaf6KSF033H2DtGRmEHequklptz8EPRJ8OZ7SktaADKdJJbUBWY4hidexJHE6piQ+x5bE59iS+BxbErczTh/jhiRe5xZzjsNIiZA915Bfif0NEiC7r6+8ZKEoibevj5zjj58z9f0KyYK+rWp6IkOaflOPK6RtqFpBU85xTH+ozwmSHxpjzsPy+cqjSCbUplWG+SuNn3lJmc6CunP69yvNTj8OMfeluw3oeKmq9pyQPuf4cmbijnuSzd7P7d/gbTkk9d3JptOtR+yLQwkQnNRi6fdX70lLCwj3XPEMHk/ppkoHUZz30LWMxuxFdThaybO0qEI7UR0se/V0v5Ia0R3WX3K/JgOCY4FMI6bDEfXUojtTjJOy9PfpRHdyaYdnoOcURHf+E2qOQd452RgNThDT4bJ1J4jpsH7dCfLGYXcE6QTRHXSHEeEskO6wOy6dThDNockzgLNAJ5dDiE6QzudwNDpBap/DZdMJ0vgc1k8niNsheFkcQtFwOCIjuwIZDpdOaM+fMttJlQYdMADfmhuar8J4a8xFhUK94QBC74CKZHRHh9BKii5Hh4rE7myH0Ho6v0OIkt8hRMnvEKIU/Q4hdud3CLE7v0OI3fkdQpT8DiFKdLwQJTpuiBIdP0SJjh+iRMcPUaLjhyjR8UOU6Pgh/i8+wTEh5rDfpdTUXfDmF7qr6aeqUda5AAAAAElFTkSuQmCC"

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAArlBMVEUAAADM1t3M1t3M1t0pLzPM1t3M1t0/cSM/cSM/cSPM1t0/cSPM1t0pLzPM1t3M1t3M1t0pLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzPM1t0pLzM/cSPM1t0pLzMpLzMpLzPBy9I2PECxusFES0+9x85qcnertbs/cSPM1t0pLzPCzNI9REhmbnOPl50zOT5ITlNcY2h7g4hSWV6tt71weH2Zoqi4wciFjZOjrLNbiLqPAAAAKHRSTlMAEN9Qj5+PYM8gr+9wzyAwYN9wMFCfrxBAYO8gv8+/gO/vz2Bgr++fVO9z1gAAAYdJREFUeNrt1FlTwkAQBOA1EiEiMaioCOJ95CDh8Pz/f8zKYugVd2vGDG+mX2frK6s7omQJI9/z1BaQuEwoQEZ3GlklqosMB/1klsbr+HURnTmgv5Z0fHR6nSBTSCEfOTzYf4SxKUVs5KJ8PnVKPh/Rmbskj+rkoUSQdOaSQqJYbOyS8qokYh2u5LuRSopZkverWNsytAQI69BSsfGg/xSFGwhPeikMZDAcqe/c3+ANWwKCnFuWIaVea40gjI0/zPPl3u6OsmXCkHI3glwlHMmNoCTG19JrAXEnsUmZgZycKVYm9mX4CEqySrdsBCVBItYhS9J5FSAoSW8sQFBSWSyB0CXx1uGXlMVmFgnCuJlQ7vwBo28mtHT/LNE3E/r88T3iIXkDZPm0l3jIugEq3s23b3jIuwFaxGbwz8+7AcpS17z0DZBwekDC6QEJpwcknB6QcHpAwukBPW8hDdRADdRADfRfobHcGWuoLYfaSqcjdTpqlaArc7qBqqSO6O8JFNIe1+5Z9/MFfele07vi8a8AAAAASUVORK5CYII="

/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA81BMVEUAAADLt+rLt+rLt+rLt+rLt+rLt+rLt+rLt+rLt+rLt+rLt+rLt+rLt+rLt+qyyqnLt+qm04im04im04im04im04im04im04im04im04im04im04im04im04im04jLt+qm04im04hjk0ahqajLt+q2sMmvrr54m2e9stTHsui2md+kf9WSZsy9o+O5nuGWa86getSnhNedddLJueSZcNDAqOS/wMvErea5xbmvj9uyyqem04h8rl1hlUChz4OKumtckTuYx3pvok6BsmKdy354qliGtmZzplOUw3VlmUVqnUmNooi7vMfCvtK9wsVqllGPvnD3VUm/AAAAInRSTlMAUJ+/76+AIAAwz49wQN9gEIBQMACvvyCPcECfEO/fYGDP3aDwQgAAA3NJREFUeF6s1FlugzAQgOFcAYNJgILCOcYrW5au9z9NmVFMWrWyJ1L+p3nAn8xidphoSlhrS5mJfbGVi0yWgPWNKBLt1ut72CLuUNV1dSDiXp+noLwFVm2egHpg1sWhI7A7RiHJh2QUavlQG4XggZ4GvbAgY9VwGv1PwI+nQVnzGLRoRw1TYKbBUXp55NZmF9IeKE8yNfMhRUaQgrOlGFCHzhmBizWeNnZF6Epb8cZecDgnP+1didCIyw1OlpbdaIuiQXLEqYxCzW25noBa1nEljXZuAYxGIpsolAFJ4b1vox9p8c8xi0I1sKuj0J4P7aNQ0T3pf1RILiQTUMWFqgSUc6E8AYWHpObpP8DMivGICGqAGpwezR/nS7sBqCYJCYBwOLT9TU0nOiiUSEJFG04CUmq6M3iEP1/f3rGP707rtblJIAoDsISFHipGMmrGSyK2XS9cAlsEI0ZHm9pOpzP+/78ju0s4sFI5k/fjZubJecPkLK7lQS+e5Tq2jOOeyINHAPAGR5K5//7zrsm1/LOeX/B+7Mf+kyb+zB4cO4GGDs9t/8vM+XtOCgsUBGdtlR8m9IETY2vo3Q7L9fORk2MpCNatdD2ELujQTEOLHd4BvXyiQ3MNrdajEqeHawjwn3uLzu0REOBWurrXzP5qdwzU37h3N/v9TXOTdFAUJ2mTZIPARp/EkQnBy50RhLI8bSOiVhaHkzwzodXZQ9BliimUFBUp5tKAYOSl9DM6uRBqLiEhcThBiSE0Iv2RvSRTxrKPIivOKzWIbBmXUpLtbIRGpC/ttxcRltxyvsVCUdFO6SA0In3VUNk9mlpkEshE3T3QUkPuAILV8G761gCVEBV/KPi5pSHM6yU6y6ecnJMOwn6LZdNwvVw01w+jOgwQGotDhZwJyKdC/gTkUSFvAgJG/YmmoBkNmk1ClglUdZLUlQlZCNG6ZWWqUmZGM4Qo3aIk7ZJE/WYIUbpVRdpL0etnESCYd06eDpJ30hwokM9xYfSDy4X7JChgGkp0oTrbbLJao4l2WECCwFVOrLbilrfZqm0ZK8gFDdFGKpFBqsSBJEQaKf13vVUixYEoUMAm3rGoEFj/gywgQIT95gABIpRjAQGiLDgPECIlHHdCIEAECR06BCEzGRbCMRB4p0Pn1AMDIsdlyDAXDYTICR1lMScEM38BmoqlXEScLvoAAAAASUVORK5CYII="

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzNndX8xOD1baHFjcXpMVl7xjyaaZSxQW2PMfShCOzEtMzg2NTI1PEHEy0O4AAAAEXRSTlMAgO9gABDPrzAgn99wv0BQjwtcR20AAAJJSURBVHhe1dfdjpswEEBhbIyDQwwcIP+7ff/HLHUpSzKkhMUX7bkcKZ80k4CU5H9MaZ2axRKzUGYBvRUKThxoBxBhtRzAOrMZ2gNFZrZDBZCaCBBA9k9BBXCIAe0B7SJADsBHgIwCSCNAxgJFDCgHyCNAZgeoGFAK+BhQCRRboKpAVFTroYrZqtVQwWzFaogXvQnlyvNWXuV/gVLLimz6AnKelXk3B1Wa1elKQilAe+qavu7U8rL75Xbuu13uAOkzVAGcmrETL7qcxy4A1SPkNHx0zaTuAxmft/Ok2ydo9wD5wVmSgvMo+SmUTveS28m9ptulE8hC24haceez6A72C8rDoUUneWjRBchHSAGdhDp5IdENUCPkgWYmnjrPBPgRAj6WIT5fQPyB3FbIDVDJttUoB+jAtmNzGKCabV8/9QB52PKDBD9AGrY8IqB/QxkhOnGh5YeWEFmASkLffI2EygAdCH3zxRY6BEgxtPpVO6YC5JG112PTHK/t7EzmA1Qg+nFsQscfszNRESBEbXCC1M7ORL+gEtG1GbvOzkRlD6WIjl/QcXYmSntIIWomzc5Eqod8DMj3kI2xmu0hFo9trZiJTJKz+PXXtZiJ8qSCpR+kc2ImqhIFC49IbUz9NJOpZMdCNgv//hfaJVYA1j47z5KVrk2knZmasdoMPcwyuYeAlOlztQWwtTMhOVMLkK7Mm1X6CdJMsrl5u9wySSf7x/Os6OFQ+8TpyXlWphhCu8TkWp5n7aF0bhJj3F6D3rv1zvSziYlSROgnFtPnr4f2fQUAAAAASUVORK5CYII="

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABNVBMVEUAAADM1t3M1t3M1t0AAADM1t2Ij5PM1t3M1t3M1t3M1t3M1t3M1t3M1t0AAACIj5PBaU/M1t0AAAAAAAAAAAAAAAAAAADM1t1ZMCQAAADBaU/M1t3BaU+OVEPBaU/BaU/BaU8AAAAAAACUnKEAAAAAAAAAAAAAAADM1t37nDU7iMPyfTn/rDO6zNqWudNxpc1fnMrBaU96qs5Nksaow9exx9hEjcVPfbN4ZpOgUHS/P1zdLkSqSmxFgrtWl8jwdTomKCm/yc/oVT/okz7mTkBkcqM0d6u1RWSEr9CWVXxZd6vTNEyAhooLGiXNdkoaPFUHERgWM0kpXobSa0gSKz1CWGh5QjEaGxxQWV+ZoaZZXmHwmzr3pDemrrQNDQ7slzyMk5jYgkXhPkL7qDXXVEbTREhIJx4OVxIMAAAAJ3RSTlMAIGCPv98AUJ/vQK+AzxAwAL+A70BgzxDPMGAAv++f3zCvcK/fIJ/y5sSAAAADMElEQVR4XqXYZ3ubOhQHcGFsA7aTOuncI20qwHvv7J3uvfe93/8j1LXRQIcD4un/beLfczSRRPAYGXMt5wbJrZkZ42ZMCPIHy+aGSM620kGG6bhIHNPQhgpFNzbFghZk2G5ibCMZKjmuRpxSAmSsuJpZMeIgy3G141g4VFKAWr3R9IM0G/WaQpUwyA4r7Y6vpNMOWzaAoNNt+pFpdjGJRDk9wUCqFy2RiP458WNzAvtJQJZgalt+QrakoqwwZDiid/p+YvqipxwjBIl5WPe1UhczU4ZKiDMYjsaTRcaj4QCRSgISDevKzOF0Esr0UJa6SuOIPPK9vsQcT0COJarPe9xmUMFlEeM1O51E5nQmxs5lKQRQEc6f2XiCZDyD86m4hAzeMO6cnU/QnJ9xiTfOWEAmg5q8HtmBEq+pySBzATlsxEC70NapI+f8hSxQkNzPexWvOo9X2ZN7HJRkzSE29jU+7oI58Ko83oGQ+CyoiRlAcgHUZpCYP9vVULbFfGJQO4Byc4hV1wEFVapKKqCkjhg3orZsCuuBNU3VtmUYxFfrgPdPNSK8nwbK2jU51AigIYO8KMhj0DCAGgG0xiA++CM27hz49FmS2CwYKRMgxyE/yFjp6V9PW6192N9jP4gbBEBqy/Zb8+zDtmlDrIRvrbCUHmL5EZZ+BtBM2QGuohAipa8IkVJDHpR0OxsOP5Tw4Y+dkFDCJ2TsEoESvkRiFy2UfqOLNn4bgdJ/2DaSsLFB6X/K8vzFS2ljS7PVvmKSsN6wvk63+b8FEn33YQHZ6T5HNEKiH9nnKMUHkkZKO7uuk/KTTTHJTHmIoJh0IZ/Pk3xe+1hDMSlLFtE+aFFUWl9Kukc/ikoXl5DuYZTi0qWlpHk8prh0mSyjd2CnqgQqInpXiCeodIWwWC5PbwuDnlFEyq4SHp1r1hEF0rVsNrt+ncjRufi9htKNchBSZtG4ih5RIN2CUFnjcvw+JN1GoHLydX13R4bW77Tu3hOQlOQHhC9fJeg+QZP8pPEdLHokiY8sj0FFSAw7SeKt2yDxSXqIevAw2Ds2SVISnsZWH7EVr5H4x7rNjfUNpJ5/fj78Az6mI28mSsMNAAAAAElFTkSuQmCC"

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAgVBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzM9REiPl52+xdGSZszCzNLM1t3Iz9yZdM62rNerl9O+utmkidHh6O3awcrJWmzHTWDNdIO+GTHUmqfQgY/Wp7LYtL7CM0ndztbLZ3jAJj3f2+HFQFTRzcPlqlrvmSb0kAzbvI/P0tDEx8UGiUfdAAAACHRSTlMAYL//ACDP71kzCuAAAAFuSURBVHgB7ZfbTsJQEEXbTluoduQmICLihZv+/wd6mlhWE32YE+aBkO7HNdlrQBMyJ7nd9OmTZnJBsjQPSfK8KOXClEUjKgZycQZFEJXikDJPUnFJmmTikiwRp7iKhtXdfSd1NQwwlieB1/rQHajWYRLLg6hS1RF8pKqVSCwPolpVxwzGGlaIxPIg0iaTlk+0iUgcR6TTWYNnU6Vg54gIBTv3Fj3+E5FY7i2aL5a/eaJg54gWq3OeKZg5ojWDFwp2zt9ovmmyXK1e+QpWjqjNtvmkFKz8r+itXUDByBGxgIKdI2IBBTtHxAIKcbwrWrKAgpkj2oQFawZmjogF7x8MojgiFlCwc0QsoBDFEW1ZQCGC84k+WUDBzrv/NTgFA/f9hXT78b91Ua0hu/3hGHLY75Rjwc7PZ83peM6J88XO20Pr69gJB5Wdt6ffd3fAiRfDr/Cq9TrY3Z4QXo8at2eW58MvxOkp6pNe1IuuSvQDEp/AZ3JSLPsAAAAASUVORK5CYII="

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzNjaW2Rl5y/xcrh6O1ARkrW3OGFjJBMUlbK0daco6ezur9XXWKorrNudHl6gIQ1Oz+e1E8QAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAACKElEQVR4AZyV6xqiIBBAQWNSuoiApaH7/o+5rTlq6zAa529fR+YuGGSWnxRMqFOeyXMccY5QlAo2qLL4TSRzDRF0Lg+LLldguV4OiWQJu5RyX3TTcAB92xHJOxzkLjlRoeEwuoiLbvATt5iohB8paRF60kwiyUOYRFJ+iDyhqIBEim+R1JCIll+iOyRzR1FKgog0iaTAiOAEX/nK1HakNhXEKFF0ARpnvF3hjQOayyS6AkmDmhnfAMn1I5JA4WpLUDugkKMoB4LH/Jxn2zRmtvoHEOSjSHOe7gUjLnAm/U9UUHGhp4WZHk2OHBRB1h4jCbCiwTyRHSDOiqiXnXCw5mk/ELVTZyGjgeG3q677/NUwwUmRwQZj159+2DcDvHnZCQMbMkEU3y8ijLP7EnmiAcRpO192BGs2zFkfLLKdu5NQRGTIc87Y2E3BxmNTIl57TI0bGoeRxTuAENkV1X/NjvwsCkRzpYhaWNGniwJMOXoAVi1N5Obc9DgjCSKsTVha0DAirvwGvdhIFVd+tTNqKNoZNsWNiFke6P/gL7ER4Ya2Ri8+rmGGllkjuNdeIfS7my1jF1sAZHdrS37V9sRloVcts/xx/JGX55c/f46Wu9Za9hwxBxLxXWu6p0X+tmLHJgAAQAgD99/6S6tHhHMJkzwHWS47K5fNIEJhjQYthn4ORhkeO2B3CsGkRmgWED+gokqOla6rgKCSBoosOvv4EOXTmI912ZQPD79+pr6LJJo4AAAAAElFTkSuQmCC"

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABPlBMVEUAAADqWW7qWW7qWW7qWW7qWW7qWW6gBB7qWW6gBB7dLkTdLkSgBB7qWW7qWW7qWW6gBB6gBB7dLkTdLkTdLkTdLkTdLkTqWW6gBB7qWW7dLkTdLkTdLkSgBB7qWW7dLkTqWW7dLkSgBB6gBB6gBB7qWW7dLkSgBB6gBB7lU2npVmv////qWW7dLkTh6O2gBB7jVWfd2uCwPVLBdobueImkEivhSFv98vPqfIr4y9Lul6L3y9C4WmzoUWbeMUf75eisL0XsiZbJk5/+9fbFhJK0S1/ysbmoITjob37Vvcb86u3ZzNPrY3fpVmvmYnPnTmTfM0m8aHn61tuzGTLyl6TwpK3mTGHkRFnlVGnhO1GpDyjOOVCuFC3cSV/hTmTfO1DkRlziPlTjQVbgOU+8JDzlSV752NzAKUGlCSPfNkyQ0/puAAAAK3RSTlMAECDvz4CfMGAQ7xDv3zC/YEBAr8+fMEDPj3BQ369QgHBgj4C/r78gn+/vcWwbBwAAAr5JREFUeF6tlIdWGzEQRWUbgw0xnQBpJKRH0hb3Su+9pvee//+BeIc9Ys1IHlv2/YB7ju6+WUaSzAgxMMt6JTYmgGSPntGMCBmL9eJJJYQiM2rvmRctpGzzDIgbDMas8iQEYiBukUfoSDzo1jMoDCQt8mDoHdB5bHaQEgQp6zw2O4hr8tjsYBbnsdrBQyyw2UGMyEPsgMhzcFE5O6tcHBA7IPPk9ziwlyd2QOTJr/OQ9XxnO5gXWipcUREaniKR0MMjCB03i8f7JWKf7Z52jBp9fGsTu7GERO7fT6Lrz/9rSWKR634Q3Q1SfJdSK3J/im44/CFNIheHMtM4kWaRKZQ+j1EEJl0oQx6zCPjTSZ53kha552Soxj9JiYD3RKjXQR6vxvklISJCvZGBp8SbeIQIhcJ5ajxg1SCq+46fQ6F0eTzeTrTtBKyZQ0EeoAwe09NOHaBuDAV5gFXw1Ayxcw6wj0Lh9cDTSp5BtOlcsYIWhdYjtzhf9kw7KoSirHZRx5BHUfTaDDKnRHhRXyXCLCrsBh5fs6jDb1JxtMx5mTiRwkbTk3VbOA9EJxEPD/hiFhkJRPKaZRAd9Sza4X0SVTlQ7JOoZo59vyuRSjSFRBMdioolHv36dxlivEWQ9R1no6ARSa9a9ZTnDtMwdCsi8p0muy0izPAk05J+ojxZB8i1iorVctQzPcJMLEZEQCEUqb/ZpVTMsDaMh89bCUWbEdFOy20MP2JtGZpzgX31NhCh27h3mxGkrwZVd4DTa5HHAQ88z0YYzWMwrYFoOxSpqy+BZ4F1xASEyvmOX3dviqpBHrVCiudzmmUXA8/vZutplYcm/QKLZLnEt5qemWgemnEswkdBAweDRXAUJPhgkAiOwoLFiIg+CvJgQEQfBX0wIKKPgj6YUDRF5aEPBkQLrGcmXgrxapL1gXgyGacF/wHGpwsgv/EglwAAAABJRU5ErkJggg=="

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA7VBMVEUAAAA6REk6REnM1t3M1t06REk6REk6REk6REk6REnM1t06REnM1t3M1t3M1t3M1t2+GTHM1t3M1t06REnM1t06REnM1t3M1t2+GTE6REm+GTG+GTE6REm+GTHM1t06REk6REm+GTG+GTHM1t06REnM1t2osriosriDjZM6REnM1t02QEQAAAAWGhshJikvNzssMzcHCQkzPEAEBAUPERISFRckKy5faW4ZHiAdIiULDQ5DTVKxu8HDzdS+GTGNKTq2HDNLP0Zxe4F0MT9MVlxVX2WeqK9bOUO6xMuVn6aDjZOosrgoLzJ6hIqlITZN/jnyAAAAKXRSTlMA759Q7xBAMN+/YIBAMM8QQJ+/UK9ggN+fr2DvIK8gz4/fEI9wcL9A34eI5IcAAAK9SURBVHherZfXeqMwFAblggHjkrik960S1d1p23t7/8fZzwpY7PEPkVeZq+Qi8wkNKEdMi2ZHiE6TmdIdCMmuqWhXasxNNbGmZiQaKNHASCQUdUORApQ0FOGS+iKTku28yKRkNy8yKpkXGZWs0/xUrktPiXpGoj0l2jMStZSoDUtqc/wm5RiX1OYgEx3gktocZaIjXFKbnUy0g0tuv9ttXLKEk4bEJh9WDZcswPZcvub8ok++dFASceI5nFCp3omMLioJsKoc8vWP6o9KUp5XeBEf36lutCTFcnkJ7x8WdXkFS+axK7yct9J0ymBJxZB4AL9luWb5md0HAmyqn608ZwKURM+F+S4/ibQ+6m85XI87uSuqGe12iARJvCn6dC+E2GdXl0qjSsIN8sMgCEYR3qbWqbKokvDB/JtAcg0friMIaUmPb3AdpIypaEElqiQDxdIF4SUBZMlhJkhmo5tZIkVBseiDQNRyyeaBZL4SjYpFt1C0z5iVesb5bVlmIvAKfIGmVtZe/W24qjZRP4M3ALDLLlLRNBNN5frkr0sO+FzwbC4QrYiTxOcQAVnHj0AozB0WcYnalon/mOhnuYjH0jSJuamI+1EYRr7OqYRFiO1XVH8qUe+pRM+Ys7XoGxK9YC4QjKNZOC/cdoFooWNtLl+EUYw9CxyNNTglDh4YYdEP5OmgAzIMUuZQ9BLvNWNklKGnGsWp4RMSPNukVOR1iUNNYA4RzTJRhEQnrIO2SJ3+iiQoOQeq+YmWTrYuMS0fPL+A5/ZV/iJCJ1ubE5LZdBqOOeA1GfvJ8O9xTRZNNWRJ6LDl6nkqFr0Z0/HPOtfy2ORKk1LfdmQbkks/HCPtR9dU6YObiKRFx+xSHJsp9sn//RSddocWy9EkYxbBLozn9Nl2DB1Yy7PY1jSqtN9hFmt7l+c6aSj3oq+7mL/Evh+H7w3NygAAAABJRU5ErkJggg=="

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAyVBMVEUAAAAAAAAAAAAAAADPK0AAAAAAAAAAAAAvCg8AAAAAAAAAAAAAAAAAAAAAAAAAAAApCQ0vCg/dLkTdLkQAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkQAAADdLkTPK0CYIC9hFB4AAAAcBglTERp8GiYpCQ0OAwTdLkT3y9D////qfIrul6LfO1DysbnhSFv52NzjVWf98vPob37wpK375ehvFyLmYnP0vsXsiZa0JTc3DBGKHSvBKDymIzMGX/QVAAAAI3RSTlMAQJ/vABCPz9+AIL9gcDCvAADvEN8An0BwYI/PIK8wv99QgDmnJNsAAAKRSURBVHherNZZjoMwDIDhniERpIXOFPXZWViXLrPd/1DDQ5Shlt2kaP4DfIrNg9n9ayoX8CSRqyzaLstkAdEKGYdkCQmVMgoVkFQRgxQkpiJQngrlEUikQiICQXIvQa3TnTHd7d7SUHWWKdBVm5DuKQhAFMcoNJmHHAkt5eopVHcG1TAQwOnwBPIOljDkq/aSgSZD5FgoLAtDvaEaWg4Ky8JQY8gaDgrLQlBt6Ib6EdLNiKjqINeQNUzjI7TYs0WUOMs/qOEgh6ElXeNXvQdIc9CNgEyHJXGMQhpDnkedNkJmxJKKQQ0NzRjKPeSSl+3r8WweGjmoZyAHKA/BQDszYIhZd+UhbjbLQZoZDeqBflAqtPcQs6WehSZ0YmSAwFKDsZDFR28HvGSBh9CVOa4huM5rpuuBhfBHe8N3zXaBseRdYx6kAhRqrVsaW+bS0kOXr59s8pPBYRs04KmrbAs0TDWgzhug+xVwICQHff9cLp++y9fHGmJ/CjH0Wy39LDUIA3Ec3wQDSsG/VK3TGe0gC6Q+AQdqef+HcnvJsI3QuJz8Hnv4sM38ys/qgGfVTT8LbT2oby3+3mGYhp7XHDpWNc5UTUIvY6j8tnghW15RvvO+dhAds8fL2XvKhzYOOjYYFlAOYGM8BR0B4RAe2p5Brw7Cv0GUbUs2RilE7buSjVEKUfXgxiiEXJ0b40IIGzfGhRB2bowLIRw2YygKdSJyDIOuH0aBDoU0QYpBOYxToZAiKGMnGmDFYU4MlOa/8EwS4iSGnJTRKZxLATfFBqg7/mZ+SkdzSqQVnMq8N5N1y762EjsZczATMkYjqxAhauc9Yi5wUqewMUoyeeEdJG23mt6Q/B/ewLJMnpBSxCn8i34AzjSHuOBda00AAAAASUVORK5CYII="

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAABdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrex1onOTAAAAEnRSTlMAMEBwgJ+/r1AAII//72DP3xCajOHiAAABHElEQVR4Ae3VUW7EIAyEYUMdB4PZJPe/bNWo7Qvq1N7y0JX4D/BJkwRC/6WU33iTvSjpU9VcuInYdxyEcmbepdtQ90EpP3iTw0D02wAWMRyECu9yugAIXXuEAFCzSZC9HLSgBYkwl1yfhg7Z+JGTfhWFuuzMOeuQFxJpHwN0KAQlBUUgXdCCFrSgBb08lJrYnbT0B6gcNhaHqpjNgFI3BP2wO+AYod2Dc3VD0L3bBW0GodTNB1UD0OAAqCFo2A2gE0KbuSFDULVJUJsFnbMgAwUe9gmh6n/9DUChD7ICKHJENiW0231o+6WEdnuvkZ5UCe1Wl3Q7Smi376qVqjcEdnsu/6PoHaHdnt+RfkZgdygCu2MQ2B2DwO4gNKl3FMLLkFZzdAMAAAAASUVORK5CYII="

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAABdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexvu18nAAAAEXRSTlMAQHCfv48Az/8wYK/vUN+AEC34KxYAAAEpSURBVHgB7dTRboMwDEbhsCaeQzLS93/aVdU0Jrrj1kuqiQpfIvTd8B8C3vR2ikkeviC/3MV41+v9Hcpz+jL6oLQafZAe0HOg6+L8ECzOhiIT28UZUEwzKuviAFqNLPbpI5AF/D90QNEPweIA4qZocQBxU/AmQNCUG4Km+iDdP3RA0QlxU24ImvJB8GSX0FyqXq6WPuhjga04oZPqECjpGGjSQVAZBeneIVxcqLdORchYXGi3UCPIWlw4V91cPQOU1IIkb6RK/51JbUjyoj9uyQJQuQeJtG9qafyZ9T4kkluKMbUs0gnxPQGCxfkhWJwf4sUhBE3x4hCCpnhxAHFTsDiAuClYHEDUFB9AZRSkrwtBU34ImvJD0JQfoqb8EDXlh7ApP0RN8X0CgWaHtdZzCxIAAAAASUVORK5CYII="

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAnFBMVEUAAAD8q0D8q0D8q0D8q0D8q0D8q0Dqq1a5qpCaqrSaqrSaqrSaqrT8q0D8q0Cgqq2aqrT8q0CaqrSaqrTM1t3M1t3M1t3P09PtuHHS0cn8q0D8q0DUz8P8q0D9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j8q0D9y1j9y1j8q0D9xlT9yVf9wlH8s0b9u0z9wVH9xVT8q0D8q0D8q0CiqW/4AAAANHRSTlMAIEAAYN//////r0AAMM//v+8w71Df/+///58QYL9AgK/P/wCf74AgMI+//9//////r3BQc+NUMwAAAkZJREFUeAHtmEt32jAQRi0PngaIXUQLJVZNCOURmuYB/P//VttBVP1kUEe7npO7556Z8dWG5IP/AZXWKLIkFEcv45pPN/3+YHjbkNzGkBfcej73G0bDWFGuueWmf2I0jhNl/E7/zJexVPR1Mp1+m4GoZpAIPdOWGaxWIxRN3kV3bI8dK5qe4JZyPILV4kSZIRqO4Ngxq6XUMBzU84g//3fn2CW5JCSimt3V87QebSJFtiBLj+JEbkENFXWL5veLh+WJh8X9/AfinrlBdYnmq/USWK/A9XdBvCFftF0sO1lsL4sy8kWP3jSW9ePF1VJftEWPa3JmOheECVnRanmF1R9RaQvChKxofU20bh1NQZMZY0IgWl6l8UBBkJBABAVBQoLVoCCbkOzYIIKEBJ8fVoOEBEHCsSEh4RPZOQVhQvhofz6h5emXfbQpO2BCIKKcn19e36zk7fXl+fwLo9kBE0IRabbgt6nYRYVEFQN2oA27bEgsyqklxTHFq+l2JJOxSxoU9dhnR0R7dikpKMq4g705sIs2QREOlBXcUOD9gyIcqGdK9qgoKOp1NHRgRIVF+66GjpohoaBIdUad63BCIDp0DWTg0mlYhJtpfBrBhKxId3wdpQUJWRH7IuMnJBfxJj0WvjssUhxEkXwiBBOSizAh+VfzSP9VVDEiTMiKdowIE7KiIyOyhKwIj4QJCURldEIgUpEJgch96khBMpEpLniMRHTZtDckFZGpGNFHkpA4f3a4ZAdDUpHlWBYnSbXJKQyKQnyIfgNXsbOgWYTWpQAAAABJRU5ErkJggg=="

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAe1BMVEUAAADxjybxjybxjybxjybxjybxjybxjybxjyarWB5kIRZkIRbxjyZkIRbxjybxjybxjybxjybxjybxjybxjyZ3MBjafSPafSPxjyboiCVkIRZ+NhnTybvXeiPau5jM1t3vkzHFbSGzXx+rWB6QQxttKBe8ZiDjqmuZShzywDgaAAAAGHRSTlMAIDAAn78Qz4AgEM+PAEBgr3Df71DvYAAqu0CbAAACCklEQVR42q3V23KbMBCAYcRKQkkIslHaLviUY9v3f8KSsaYyjNarNf5vuPtm0Q6iWpmq4VwFq9KIxhKQzJlqLAEJnShV65wkVeucJFVrnJRhIM5J1bdCDu8EmbmjYd1EybkZejjMnJuhx6evw8yJkNwZxyhFJ0FSJ0rRSZDciZIGBuKd8emhNQ5YiHceny+qnvm6Kc7hIb+JH/jW0g4PdT3+L7xQDg95nKUJh4BIB4cfyZFA3dLZJUcENbQjgjztyKAN6cggSzpCqKUcIeQpRwZZRzs8pLbanGuQdHjIN5jpdX/Et+jsfv6iq+LTGsw7p9MRf5+doQeidLHVAbNNTpQmB3HLQXWP+f6covTtTPnrkA2IjPQ2xJvEtWbTUVCDyEqzXvKQQxRKTRZSgdj7pbTHWVlIk3tP0v4VLws5yAZq70laOKhzkMdcx3gy+boctEGx1EIOCiiVNOQgi8uG94/DFSk4yEIdLvscx68oLffeG+0tlELjmKTLvTsFRORESbp0AITQsIvSPCWDaAkYSCElfcggQEp6x1mWg0xW+hz/Djir4yCHVEKovhcEzb0gXwYBC0Ff4jQsVDhSWwCBQb66BFKBdQzwUNHLdWUQONkJ0RDo6yuzJRA/U1BQDoEPpFODBAJliIVZKINSvs+MswUQQZFqFkxrQQSlamcw1sefmBRKqe47C5L+AbKHANsWEYakAAAAAElFTkSuQmCC"

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAIVBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzPh6O16gISRl5z6FN7hAAAACHRSTlMAcO//gABg3+gx/ogAAABkSURBVHgBY2BUNiYAjFwZko0JAkOGYsKKzBmMiQDDXlEHEEA4WBkdZCgaVTSqaFTRqKJRRZNBIpaYDCRFEGYHFsYgVzSqaFTRChCrC0pjMrqIbYYoE9NcEyasyIwhrJhgE1IUAAYtY/A1Ac4SAAAAAElFTkSuQmCC"

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAbFBMVEUAAAD8q0D8q0D8q0D8q0D8q0D8q0D8q0D8q0D8q0D8q0DM1t3M1t3M1t3M1t3M1t3M1t38q0D8q0D8q0D8q0DM1t38q0DM1t38q0DM1t3M1t3M1t3iwpTM1t3M1t38q0DM1t3qu3v5rkrkwY8MH1U2AAAAH3RSTlMAYIAAv5/vMI8QQDBAEABg789wIK8g33BQz4BQ74+vaA5vQAAAAjlJREFUeNrF1+tygjAQBWBBTCACykXU3kLb93/HAmU40iW7hXSm54eKM34TzHHB3X8msDbc/8xuvz6RtfbwNxAkTwiSFxRaSJ4QJE8IkicEyROC5AtB8t1+SB6QskTaBGkgkLZAsSXSJihRdkna+SwI0gbI2KXEqyGt7GJ+AR3TLJ8CZzV0attz5nJUNCYA5HS6pEtOURoyRgSnvVCnrlaN2uPgnKgTr7yKnL6dKgzLpHeQOlkFXc69Ewzf6+AgRUIgLll6zKsZAIlAUn9Cu5xQhNAfFrIVgfj+lC4oJhDfn8e5oboSmmI8aBhI6o/S/URqcG4CdJ36E6A/kILxwBCI6U8zOZCMCEHq+qMtMpduHCT3B1LNQtivO+nP/CcyvaK7JvdHaTocawrJ/dEL49q4oZTpD5GivRt6Qn/wMYekKgIt9qdQ1rJSyY6Ry4nrzz5YNY/c/ekdREtQzfYHMeKK2P4glQRVfH9QRwnSanatoFLY9E7CQHA4KejeMDgvQIwDiVw8GAgOkQKLRAIEh0pMfwARh/anYfoDyLUew/SHgYjTyP2hEBykcPUnShgIDlIt9cegPwQiDnbZMX9YKHt+ef+YS8VNm3omi1CaXs9tl0/LppKg13bIKKnYBRkJurdTPvq5EW1d0Rugd6Vx10L6I0EZlvSih70qZoIq0R8OepSe8yHJwSKR7vvTPYgQJPx7MQc1nlAgCYAgXfOHGBPeTCILgCCl+fbsxudO8oZG6e3+mntDyP9DXySi+7iu/7eMAAAAAElFTkSuQmCC"

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAllBMVEUAAADxjybxjybxjybxjyYpLzPxjybxjybxjybxjyZkIRbxjyYpLzPxjybxjybxjyZkIRYpLzMpLzMpLzPxjyZbRzApLzMpLzMpLzPxjybxjyYpLzPxjybjiCcpLzPxjyYpLzM2NTLMfSimayvliSdPQTH2sF394q/+57h0Uy5kIRZCOzGzcSq/dymNXy3YgyiaZSxoTS+zsq4uAAAAH3RSTlMAgAAgMACfvxDPgEAw72CPAI+f73BAEL/P31Bgr98gZhOJWQAAAlhJREFUeF6l1wtyozAMgGEwATt1CWlK00DbFeT56Gv3/pfbxGFU1hqzlvkP8E2k8YhJFNzd+Xw3/ymah3a+NJ8nE3ErEqEZKAOQaiR0HS2DS1MVDnX7uTgoRcFjoQMgx0EZYJMxo6GDUFh9JxPhUGw5wZDsOddBg192/OOY1QdDT2t0RkH3j+0a9zNitJemaYyU4Q2IQp3m8amQsRkLoSCnuU+vjYEejPOSmkaMtugcqygdblJIAMhlmYhb6LAgLQGT+sIsn43zkPKgAv6pUMuVcRYpC1ISrN7QYUHEWb8b5znlQRlxWuOsljyodjssSOWW83Fz3t+UIA0dtpnlbBpTu4aCB726HADNgazJvnoOSA4UQ79Tc+sDTAkDSiqgzqZzy7Blb20HZBC03XXOF9I5B6ps5wQYMKASuojjBSmtusHsRf8BFhTDVKHTl3ZbRDyWrXQFkJe6ltYjshwoBiEtwdHJcmAyBBXgnRRuSE3BP+2AmI7zjHAdKRwQcfaHw37AUS6I7PlwPB6dUoYAhRIgkEvKazEAZRa0PxJpOptVkL/OlBiCAAYkPGRJjIoD0vA/aSZ8imJwSuiwICod8N0wICIhVIdB9FlqX6juHZ7dhoqlL4Tv8Tc5zaZceUKiAtNnY6LSVHlCsXG+W/wM2mlPKMHPl2lnMVWsPCGRmUVj7N+DkMrNok10ScofEuUnMmRFUjCgX23T1a7JpjnQChe9pZeeAy0a5xsSDAilDXUUDzJSu2Y6FDLSalnm1GFBmMqsP1WCC2FJXEFXliDAg9Cq40saAS40vr8ESRFTSB32DwAAAABJRU5ErkJggg=="

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAaVBMVEUAAAATFRYTFRYTFRYTFRYTFRYTFRYTFRYTFRYTFRaaqrQTFRYTFRYTFRYTFRYTFRYTFRYTFRYTFRaaqrQbHiA1Oj4sMTSJl6CSoapGTVF4hY1ncnlXYGVfaW9OVlskKCo9REeBjpZwe4PQD9ejAAAAEnRSTlMAUL8wAJ/vIN/PAIBAr2AQcI92KalMAAACQ0lEQVR4Xq3YW2+jMBBA4WJsA8stHG65t93//yNX2tGIVdVowdPzlpdPwcGMyduRMudy/6I3v78AxMIGqQPODGVImRUqkaoX0LizG9rn+F27oQ+0pwk6o7GYoCsA030C/g/9el0NQO4D0Phv2gu1AMH72go5gELuyswCVcgdVAK1BUKAHKCzQo1cmX2NCl/wI5D3LQC99ef3GQClt0A1kEcAgmn334AJAG6mvfaJNp1N0DghcRlt30gh1tGy+2WddanTt8jmxMICbQ4nb4D6zQneAPUVWtVboIBG4w1Qx1ZngPrI1mCAAhKnCC4dKrarcsAO6EWXbU7fgXn+eCRt2vO2U6/vSNwToIc4y1lPI/rxKPShJxl1VDq6+0vkVy8iW8BwdIuAjI3Al4oUKPiCr4UUqPMnNOcEiilQ4YOAEZyi+TEoAnjv5JnmIOq4zY5B7QbR+xoofA9AfQw6yaUNsiqZfBOXABWy2Jl4hQA1QLcT0gLg5KDWeh/BvTgkve0Z1Vc5HV/WGRjHBZgOT9on8C57lukCfAp6GDovwLKOvyfgCTwWgPUgpFN/uo3nx3xfkXimzH6Zs+WQNU2GVCVOWoekhf4opHUlW6Xp5N+1aCefCGl5I4sUTJBWQvkjUDAe2JvB1X8fZSfbK0RAR0dues0aABABaFNP/qswsuUXmFPP2Xe06zjOBmj+F3r/IWjlFbTv3pGiDJIh9d+aDomurwHyVMhX4lQhythPhvLIVtWnQCpVaK04CZAkz6MYGgFeQvb+AEqt+Dx3dDu+AAAAAElFTkSuQmCC"

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABDlBMVEUAAABVrO7/2YNVrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO7/2YNksORRp+dVrO4iZpkiZpkiZpn/2YMiZpn/2YMiZpn/2YNVrO4iZpkiZpkiZpkiZpkiZplVrO4iZpn/2YP/2YMma59ksORVrO7GyqciZpkiZpn/2YNVrO4la5//2YNRp+giZpkiZpn/2YMiZpn/2YP/2YPq05Dq05D/2YP/2YP/2YPw1Y1VrO4iZpn/2YMob6Rgr+c4hb5SqOnVzp41gLklap5qsuFFltOAt9P01oqqw7nKy6QveK61xbJCks7f0ZdLn96/yKvq05CVvcY/jcksc6l1tNqKus2fwL9Po+NIm9kyfLSi2PNEAAAAOnRSTlMAQAAgEHDvjzDPgFDfEADPYO9wQN/fYI/vvyCAzzBQn6+fv9+vAO8QAFCv73DfYJ+vv4+AgABAMCCvKkzEzwAAAwhJREFUeF6l1tdW20AQx2Hv2hKWXCKMMSgkERAICSG9z8q9m97J+79IwGW9ZciuzO/KV98Rf3uOSAmR3WSlSWaXl+KfHBdcJ4mzBOA6GpT14KEEkg8PeVkZyrkw7sPeW8v2nsE4NxChAGa9L9k5K69hVsAhwYEWW/1o8Thr7C8I0hRKu8DrMmamSsuMdWFedgqFIFRl9y2vPX98nI1VxlgVhMIJREDsiE16UXqJMa8+sXFHIEbG0BJIVdms5c3Syp4wzMrGJptWBaloDIUydMfkvkxjYncylB9DoFRnxuqghP1p0Lg0OZcNxdkpFlPFYiavSCft/zvtE5npvClQmqKUEkAke+em/45OIBqpUheXsG/+6jj+TGdQxrV/prb0hdUO43i9wCEagCZVcacq7dM7i+P4gM4hmtekxghzRg3xcYbxfWUqQgT0LrSh2hfyyPFDFQmiHiI1WrLTaogjN+NxZSpDAWDdtvjo7datOPIgnlZRIOoCXrc+qlZH9S4oI09bL6hQBIakkXlbVIVyBkAemVfRoIwl02nGYgUNop6VM4ilylSH9nEAHZm3jUC+eeTTWO3rItB5P9b6hkA548hI33/MSvFPxDAyUv88h/xbQwwj653WgCSCaocYc9wDSAZd9xGmPwAwQ+aRmx1ICA2wxzm7hmm2Y/eOY6TDGszyEci3HLl5BWCGzCPfAJgh88jDGkgtIVBkMXIPlEIECuX3MNIAwAoyjdwBPQ+BXD7yGXqfgIZAs5GHhp+OCUoLrwj0PvGIBhE+Mnqf9lDw2MhDPjKWr0E+Hxm9T3toxzQyXqhB2/h9mvI0CL9PcypUwO/TXFqBfuL3aY4o0AF+n+Z8BdrC79NcpEDb+H2a8xRIvU/7ZOiXep/2EQmq8J9O4hwJ2uL3mbh9CSrz+0xcXoR+3zuDGixWVoAO9Pu0zxGgPzeweN4cStfgKaU5lHWf4rhkvlHG8RZlPCejvI6CKJ8UyUdBWnyL8DLEj0LXhnDDyCeTR+GQHiGO74dhqD1hPgxD33cI2dX7B9ko+GuRvqiKAAAAAElFTkSuQmCC"

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAtFBMVEUAAAB3slV3slWm04h3slV3slWm04h3slWm04h3slV3slV3slV3slV3slX///93slV3slX///////+m04iSwXem04im04im04im04iSwXem04im04h3slWm04im04im04im04h3slX////H5LWx2Ze72aq3257j8drT6cSIvGrm8d/u9+m83qaAt2Cqz5XY7MvC4a35/Pis1o+z1J/0+vDd7NX3+vSRwHWiyorE3bXV58rN5rzQJeLVAAAAIHRSTlMAIGCPv98AUJ/vQK+Az58AnwCAUAAg78+An0Cvj99gv5VHzggAAAIbSURBVHhe3Zhpb+IwEIadUgppKWXLhl7Qvkm4r973//9fmxfYJIyU2FmNVtp9vhCJ6NHYju2ZMSV4B/3Derijftg/8M6KMUV/NDp0COqdRjWR1/fDAvy+5yw6PglLOTl2Enmd0ErHs4tafuiA37KIvNPQkVOvTNTwQ2f8RrGoFVaiVSS6City9TPDZI/t6LOa5zNq/0gx6VM7iqL5yl2zmkcRTVJ0HhGanD3kXIq6w4kwOXkmw+7RFrP9CXpA/EjTl5voi5rHGOgFe6ILJIw3pg8Xz8fGM0bCRV50CYIHit4cBrd6o+gBBJeZiAMjuKdpZBeN6LkH4eBSURM7nl7SkKwBvTxhR/O36BopMUNa20RrvhUj5XonukEGQ5rbRHMGhIybrShAjilDmpV7ZnxnihzBRlRDjiFFz+WiZ4qGyFHbiHrIs0hEr+Wi18SzQJ4eRV0AcmzlIjEy0k1ETeyxpOi9zPNO0RJ7NBPRAPtQtLYuPvYZHJkAgoXt4x7JKSKBuYVgwtm2zfUEgltTg2DqIppCUDN3EHxzu5WJuNG+IbgzAwiWtvWXi0YwMNAR4Z8Rzf5WRGNI/uPJVvsg1baI2qZVO0bUDjato1bt8Fe7jrQuSLUrWy2J0Epr1BItrdRPLxmV6XH8Z+mxWsKuX0IQnaKGKJRZqoUf0SlFiU5xTBTKdYUGgkJLQ6HJotL20W9E6bfG9Jt1kkrtw19w6UouOMmMvgAAAABJRU5ErkJggg=="

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAaVBMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAwjHyD0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAzKeRDKeRAjHyB+UBcjHyBKNBzniQ0jHyDagg9kQhqmZhQwJh/NexCzbRKMWBY9LR6ZXxVXOxvAdBGIiXiLAAAAGHRSTlMAIGCPv9///wBQn+9Ar4DPnwCf/wD//4A1gRrMAAAB70lEQVR4AZTU4XajIBCGYSaEzwKJdu1qrVrb9P4vshM2i7FTR/P+ylHOAwrGKNHBHh1QcIA72gM9rWfWbvjgkLpBKRf8YxDZCEBCXLS0GzqdAUgodz7tgigAOgQE2obKiG0IsdyAqAL2QEBFGuQj9kKIfh0qAQUSlWvQMx6D8Pxnzsw/6+LlMeilqP/mTP5V8/im3Q+1DV+vJfRacCwpkHC415+Q796kJCDhvHV++bIpAv2Qbu2D0rRDD0RaQBW4MUnve6D35IzgqnuovL/dbkPt/ZTlDFHMG8pN29DEl/JhiZShkGf6uC1JQmJBH3lY+A+dkOsLrtchOep0g86Yuy6p2YKa64Iwd/4HkXj6Toc68SYpQVYM+tShTzGZTVAUy77o0EU8frxCHnJndUieEXiGAhZ9FdyoQWPBfWFRYMhBblKvQb3cRrgnQ4Dc20mDJnlCADKH377riwZdfvuPOBiLH03bkPweYc0RgDglgwYN4qRxR+MAyG3TILlpnDP47saObQAAYRgIdrD/xnxPFekKhAdIA3HsN4OWG7SRfh703quxD8lWhC0tsxFmbMxqnfmzc8QOpDvZLESwWOOCFot+LoyyeOwCu6oQCZWapGoWK34JVdGEynFSdd0BBIc0HGSB2MeBKITGAKy7NcKHB8oOnBniQZDKAAAAAElFTkSuQmCC"

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAIVBMVEUAAABVN4hVN4hVN4hVN4hnTZXh6O0pLzMpLzMpLzMpLzPMVlipAAAAC3RSTlMAUN//AP///99QAAky7VEAAABiSURBVHgBY2BUNhJxIQAYhI2NDQkqUjY2Nk2DgnIoQOVXzGIwBgL8isoriVFUQYyi8iGuaFQRuiQ6n1hFo4pGFY1mqVFFFRRVQJhVmQsBMNgUjSoaVYRorhlRp+HnSEQTEgD9fZv1MibH9AAAAABJRU5ErkJggg=="

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAEFElEQVR42u2ZTWjUQBTHe/AoEvHQm6xgpd0KptQqlVZiUQsKNlYQRcUVD1WrElRkrV/BXqwKe1AQPDQKtSKiC4WCChI8+AE9LAo9iGDEm3iIVxF5vgfZskxnk0mW7m4mGfgdljLbmR8v7z+TbUlHk4x/cwcyiIHYCHBwEBNRkijHREAQF9GTIkZBSghEQEuCoAICEXFkl6OJiPg1ewZ+PM0v8HPGgD/vjpT/npNZkOUn5u/HQ/B9egy+TN7gQqKoocssyK0ihyqEkcPn9+sTILMg4EGb/vroOgkIhB452XuQST2GoEfm29RVRkIw0icZs+FUEEeQXYMgOwmCcjUI8mJefkmlCHJKNDcpgjKIG0KOS3NobrIkiVeSnig5bE/ya9xz+ZMw2zdQfLhstdaSjgVh8OHscXjS2gkoppISoiZdkDa7dTvJqIabaEm4eQuBAEqIkkQ5GgIiTK9qt9LqCeDTzQsO9awkCbLDCKJeVb6CIFoqiMPn2xdJUJkCIm9vetG52Z6/dwXe7NVhasVaIUGvBnexZycHkTPl5u9edsobpcqY2dgfJIhEVrua5GQ7/1jMJqmSRKqIDpVS3/5JjsG5Ygj3occr19k+1xVTuvdD1Ie8a4Yw3neZElUSXw7xbE0XI0AI3e87Y9e4vUgGlvejxwoR5BBWgHgHUeIgRvHpFznvPOREEOQIVKcZh0fK9ZPjCTIiVlGG+X9FNv6bVYzmUzUu+8aQNhpRUI5TrW5TCqKm6MW34/ciHlEDrx3iWD5V2/jDY0DUEsL3JqqGCIJKMvxyagtELglSEAhLnAUVES3k7b4ooyCTqRYj6m9al9p2FiJEvfwjO3JfQSwE9g+cglutPcIplgQ5KuIgUMme/HMYHRqDibZBeLC8vVJK+bORBDkmAjwGJt76IruYDGIjkApaLEdHXARSQVUaMZEKqtKIU0F8OS4CqSC+oGJIOQ6iyiyI7TsQAgtRaC5JCECTJbFAABfRy/MEBRF2rEUJppaNMHc3RpCsogSSy2LnsIJkE8WmFwSg+ggqIiCrKBJkBKUVM4UVpCIuAjVgd+87rXds6NY8lGYSZEd8vFhJdhQ5/flpWL9lB6CUStTYxDuTWkGitLCiunYfZeVA3OJdoNyji+rs6WMF2XGKd7HFRhdFQlgKcYp3w2d6zaK08Zc8QblYxvtSiOo7P8kTpMYy3pdAVLF35M4iQRLFe+0DhZiMoFJdJXiHLhOxPSzvsyYS7w0QZNVLjOIJgap090LHtmHIDo1C9uA1brw3QJBRz8pxWClBwrLD58pyivQ9DRCk1fsRU5FCGFnZw+MupVed1qc3ukGzi7EQ11fSJs2s45oUxOU16GaWZdZ5LSavQTezLL0BayiwJ+hmlpVpSUc6Ejf+A44fh4zOF0/cAAAAAElFTkSuQmCC"

/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 803 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAApVBMVEUAAAD/uT7BaU//rDP/rDP/yEr/zE3BaU//rDPBaU//rDPBaU/BaU/BaU//zE3BaU//zE3/rDPBaU//rDP/zE3BaU//rDP/rDP/rDP/zE3/zE3/zE3/rDP/rDP/zE3/rDP/rDP/zE3/rDP/zE3/zE3/zE3/rDP/zE3/zE3/wEP/wkXBaU//rDP/zE3/uj7/ykv/xEf/tjv/yEr/vED/sDb/rjX/xkgD4qG6AAAAKXRSTlMAv0Dvv4DvgK8gYBBQ3xAwYJ/P35+PcDCPcN+vUM8wIEBQgL/PIBCAj0vDQ8gAAAJNSURBVHja1dbbeppAFIbhv4VaSquBYoPGDQQTNXG5197/pbXOhKwZU8IayEnfI0/8npnFMA94Y7pQ+rNKo0XUQ63+WqITocZwLXRfE+pIQ3d4Yx57VNqvxfZUSkLVST1iR3noSCy+rCchw04e2pGhAAoy/ZaHDmTKkJBp7YBMA9DHhPzXUJHjL5cQgCwP6EUZugWcQ4p/FULT0NgO+Y1DOSnJS2jSNhQgabm1sDyRASk5v7NCHSgxKWMUZVGZyUMzKBNSUt6jspSHlvrqIO31lwclkociPWt+WF751l08ykOPuCj4HvHLaSl3Ljck/7vg5sBxSEsoHj/0sXW2790u/5R4MJn9tnWcTlFoPiqyjmRfFupDGZjb8a2LZCoLTa3jODCrMbQHSecBGt9mvM8EWiQ/jcitsaT2tHsdwah7UG5Jm1vrG0Nb1IcW0GLejDHtgJckXNDcs+/XAWkhL0m2oIC0AvZOqch5SbULysY+8VB42qaj6POBZeAhWc6H9zqHMzEervVlI/pM2pPN0wviMyn8vNldd1IY0oQsp21VZ3siS5LCFk7ItKkKbcg0CVFn9O/OCK56nYoj5GxacQ25iypuD3fD684QDfWv7+nGvtj7ai7fb18P4ie0ENL5SXeezj5aKIjotHl+3pyICC0EZJijuQkZcjQ2J1OBxsZk8tFYTKzVkDyyhM13ZgtaPnyWoZGMrhXNR23zHMf9+efqXd0fws6qlqzUrQ91IbES+A9DN92VUPdGNui2A185+PZRoe+SUOuBf5V3fsHyB33RDaEJV054AAAAAElFTkSuQmCC"

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAb1BMVEUAAABmIRNmIRNmIRNmIRNmIRNmIRNmIRPh6O3h6O2znZtmIRNmIRNmIRPh6O1mIRNmIRNmIRNmIRNmIRNmIROznZvh6O1mIROznZvKw8TZ3N+UbGXh6O2khYB1Oi6FU0puLSF9RjzCtrerkY7Sz9KdY+1DAAAAF3RSTlMAEECAn7/P37+fgAAgYM+PMHBQr+8AAAIi4owAAAKQSURBVHjavdjbkqIwFIVhkUDUBBVEN4fYovb7P+OIwV5DGrJDTdX8N175VQ5AKFb/u2i92272xpiKiGQi4nWkRq0Un86EJOrqF2MlW3o4LoF0npIN0k8yjwKh4kQIEiGheSjKJaE5qdQcFJeEfGPyQxlGw0hl5IF0QoiT8nkoJsRLEhAzHE46TkNFSbRMOkxCOaFAKZ2CBNFyKQLEOIy0BsQ4jBQDYhxGEoAYh5ESQCH79XW9EdHTNK0ryRFUcE7T/6syxjTkSn9DumSgq3n1bfrIkUZQQkyt+fQkV1KAYmKrDObiSOfz6mzTFJCd1/fE3l0uq4stoeUjggQoC3RsN1cCJH3C/fG4W2fYtSs50v4D+Ve6Maa5W6fqveaLHGkzQFHphXoBq9NePw6k7QDl5K2GM123G7Zfht6fk+F5VATu153miix0Yh1bMydJ9YY07ww9aDphoTzEqWoPlFkoDXGoq+enpntodmb3xtTdj+MrVW8oo+keL6DmHbxECA9k4HjSFpKzUwt0TuoNRYQcCY63wkJr7vqpO78jlYV2ncexErfUFtrWrvR1beH0eZ0yGqANxu6eg6/ffsUbLxSrAdobSO45WNnHLLdCFvq1nreA6wdlgH5J1QInUYAguedgQBpQBWn5iGIFiFzpaT61IRMD5ErOOeip1CPIlRqcgwE3GSDpSm3zfv+5XTknVyMoIUcKTagxJMgj8Q6gmBiJd/A8YiXewRMS0iIHkEoZidkvQAdaKJWFmoSOtExKtJqGlFwkxa4AKCePxA8HUFSGSjJTygMpQUFSiVnNQLr0SvjCw0FKC252p0IxrfCFZ1ZKc+0jANmOh3RCkiKDwkAoWscikYO032x3+CIXCv17fwBeVJYgAhvPgwAAAABJRU5ErkJggg=="

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA9lBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMPM1t3M1t2Fs9Y7iMPF2ObM1t11p807iMPh6O3M1t07iMM7iMM7iMPM1t3M1t3H2efh6O3M1t07iMPM1t2OuNjM1t3h6O07iMPM1t2av9vM1t3M1t3M1t3h6O11p82OuNjM1t3H2efh6O3M1t3M1t2IstGvxtjM1t3h6O07iMPX4uq40ONamsuOuNijxN2EstVFjsZloM7M3OiWudPC1uVQlMiow9dEjcVNksZ5rNO6zNqEr9DD0duxx9ityuBfnMpWl8iNtNKYvttooMtxpc1vptCfvtV6qs7kkKtFAAAAMXRSTlMAQGCAv+/fj3AwAN+Pn79AABCPEAAgzyDPAM+vUFAAgACvv99gMO8QUECPzyCfcO+fj1XNXAAAAypJREFUeF7F2Od22jAYgGE7NsOiNKGEjGbQkdKZthoe7J29ev83UyzZ50NgYYn+6HsBz5H0ST4crP+QveO4boHGFd1S2duXsva18hyX8rrtB9/vEeL70cdXniFkV8U6gtAnUuz11/M06zynmlPkyrDdIxm9+fxOZL3bWKOa7Cgiit7+ACif8Ym678c861hZygScUcacnKk5YtKdiOREG5sgu0h5bUZyIXcDVBLM0Cf5UWqroMYBLCc3Rul7BXSanM4N0cmnlDYyoXIyLEa0oXIWlAy9TTQLF9ABQODA0PWa0kU1gGRnQLQbxtCXPWtPSjiBgdOLnXETWWi5xGFEv4cYejqRobK5Q4IYuv4gQafgmO3sFleWoUYBzlm7dgz1MV6GxLswc1hn4UywBIl3GhGjQr4gCbK5MyXbLagCUDF2hoyYn9BoAcHUHBrnmzkDMTKA+MTgoZrdoVkMNVOoyifPtjjpOY67SKAGjXswc/zYucO8T8iCBQ3NnF6HPw7utJCAGltcIRbAxvAJh7ZbUCA2JroQUI3GhQDofhfHswSqC8jhEDN26AtOd8YhcamfzZ0/OOlMQLbpUbMud25Tp4IEVIWdGcyLTq5SqJlA/HV0tZ1Bhzvj69Rp1QXkmd3qiIpGGBbEIbN3z6aJ08ewoARyOaS5rQAcWFACcSfQfe6iJ3AqKIH0P7GDABxoN4V2NN8HC2mWc4JSyNG7jjdD2YHRp5CrM7RBVxjw5YDHYQD1+MxhXtA3BFABIA1mLDlH9SWIApTHiHcBtQ6RLuRLDL2bgQKTz4eiLpV6upKcC6QF9dodKnePpS6RBsSigK40uc50ACqu3exe9Ewh2JbagXsEP0P8MKDrjV+wwgGoRHmddhiGU0CkHq+UDkBlmtdkhNUOQF4OM57j1X6iLAgVKaQ+ZKh1hrKh0iZmhlc7OkQKyNNj4L2rIOQqziaDqeyiDZCdwdz28XqtJgeUED8l5SuHLg9RDlQ7oHIvRgxAyFuRRmYMQKgm7+5RVirNOgBqSGRLs5vM+yPe/fzXb5hUHiTySut33HW8fXXq/9i8cskVWsF1nR1A9KF/7y+edx1iB0aKqgAAAABJRU5ErkJggg=="

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA7VBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoJVrO7ZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoIiZpkiZpkiZpkiZpkiZpkiZpnZnoIiZpkiZpkiZpkiZpkiZpkiZplQdJOOpsAiZpnKoI7KoI6OpsAiZplMn99QdJPZnoIiZplVrO7BaU9+go6oo6tdq+fGc1m4op1mquGPpr+fpLHOm4M5bZbHdlxyf4/Rn4m3lIbAoZarkIjJoJCwoqR+qMyUiYtuqdqXpbhQdJPQim+gjYktapjYm3+JhozDbFLNhGnCl4XWl3wveK7VlHiHp8ZEcZX21zXXAAAAJ3RSTlMAEEBQgHAgAGCf378wr++PzzCPv++vYADfIEBQEHCAAJ+PAN8ArwD+kn1OAAACVUlEQVR42u3VWZeaMBTA8SFES0gEHR3R6TKd6bQX3Lfp7Fvb6d5+/49TA1EghiA9np4+8H/Cl583uRzd+6cZyMS4gqqepj0vJ8MiNogo00F6pQbJnL+DGHFAChWHmGvDZqQYxCzigDq0BcTQMhMTCppsQw8ZYoT8iBZiNmydpYEMB7bPqWZDFIpEMyET8iLy4dSQLWYmmIonijF2Ka1HE7jMS28uA7IgDHs806U1xTdq71tAhh0OwTwpDVRTQpZwCkCghMKLML1CEFNBsKzi5UR1lyQgm7/2BSFXubUK94tBVAVtFYZ0O4NYHtTYb/rLWgft01RIgip6qMEVUSdFMQkiWqjd8pM1uwlJghwddOhLtZ7HEJUklg296PgbxcdzNWeToLa/7rH/8equ/5iULPlsRia0Hqj/DaLmdwu/ISADpHAW1BDM7wtI1O+ciuqyZGVAL4UzB9GHs94I4OLVu6gKyGGkhF6HzqfVsZ7Oej0OiUVn/NM4pLoBRe/iZxCNel++fk8dAYMy11BBC1hDo5/S7yoBdTZSQO9BKj6bCZnhTegKFHlhNmRHjQS0z6G52NYmZIEuB8VQm0PrbZ0PLmEVEgNpI2uoy6HVth6GwSAFIciLQ1EH/GjhtsaTIBimX2FSADoUl30+DZY9QNR4Njs+OTGcApDX5Ovn4/CuYdnNLX98c3RkQRGo2/IXfBzePQAMIjIYIP5vPJ0Ek9uxDoprtH5MgqjhbDpcPYJTh+v76MONDop7G0iJ4S5/BaJZNhTsqBIqoRIqoRIqof8Berajdgb9AafZm/m/46KAAAAAAElFTkSuQmCC"

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAMFBMVEUAAABmdX9mdX9mdX9mdX+foJT/6LZVrO5mdX+pm2n/zE3/zE3BaU+8vsC8vsC8vsC2hV0fAAAAEHRSTlMAj/8An////4D//wD/gP8AHgs1EQAAANVJREFUeAHt0MENgjAchfE3AxvQaKJnnUA38OAG/Ffw7giOwQqu4AxuICvUlgM1fFL1YkLSlwAJ+fIjVLNYVW/G0/jF1rn9x2jn3AIRIVIiREqAlgdQAnRsQAmQGSgBMgMlQqREiJQIkRIhUiJESoRIiRApESIlQqREiJQIkRIhUiJESoRIiRApESIlQqT6qAI0UPUQEUpUiiJ0CrPRo3mJzmt7H9lllf6unYraa5z6+6wjrkQ2fZi3sMyJlyguRTzMEt27zB7ee4Wry+6X6KvP5ff/6AkaB2VcYHSZ/AAAAABJRU5ErkJggg=="

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAApVBMVEUAAAB3slWm04h3slV3slWm04h3slWm04j/zE1ckTt3slV3slWm04j/zE1mdX93slX/zE1mdX93slVmdX93slV3slWm04hxhYF3slX/zE13slVckTt3slWm04h3slWEu2Om04j/zE1VrO5ckTtmdX9sjG9tkG1vlGp3slV+mIKGvGWUx3WfoJSj0YWm04ipm2mpp5epsbezr5vBaU//zE3/6Lb///+GX5mnAAAAInRSTlMAEBAgMDBAQEBQUGBgcICAgI+Pn5+vr7+/v8/f39/v7+/vN9hgAwAAAbFJREFUWMPt1WtXgjAYwPEhWl4yvKCpgGmsWmXYZfj9P1qIQ2FsbLHnhXb6v+HAPL8DGxOELrYhxkMIZ4yTxkAOgMQcY+noGEoHZ7MxlZgTx4bS0dGU7OXSVjh60oKQhcrRkRyS5KgctWQv91Dp4UqOUnJJmns4a61WLYmjkGzCSm+pEURR0JA41ZKbQektTaOkqcypkixyzELoOkq7kzkMEknOCUoWLkidF5UjkvwT5KMbXacsdUmubqDjiHfwJA/daznCGbdIoXctRyT1itCbniOQJkXoVdMpSdyTkUddh5d6tR1Ocus7RcnPO09S56NqBw/zGz9N6sTVO5h/rYnUiaUjGwY5BegZ463Qib8w/hSPbDG+TaAZt/qUZj94YGXnu13xejZCafb1gIHIP/SnIL4M4mPQEgqaQUEjKKgHBVlQEP8RqQ9dQUHcdBtAxb8kE8jK3dPoBH2zNLdIWtNNP0q+20RmUFKb0vb+aAz1Ke2DQANKB+cFzSmdXyokfyFhoTWlaxCI0sOF+lDHC8XtWKE6r5M40tFfQGHYQR4M5KEQBgrhILBHA5tssOU/u34A5c2OaTSmz8cAAAAASUVORK5CYII="

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAIVBMVEUAAADR09TR09TR09S8vsC8vsC8vsBVrO68vsDR09Q7iMOPeX0cAAAAB3RSTlMAUN8AUN8AOFP9RwAAAI1JREFUeF7t0bEJwzAQheGXGVJlBNXODMYjaIDscAtY8Nq40wqZMkJEYHwHVyrF/YU40NdIh9Et1UvHffmFMTyq6q1Q0uhQqBoZSC7ZKJBuPpLW+TyjQM/MXjVir6zY6CHuyD4qoI8IUlqk9bpxF4j+Z3ICirXE7mJ3E5H0Pi3p/TnKPirYfLTjlT1U1i+h/d+Beg9DwAAAAABJRU5ErkJggg=="

/***/ }),
/* 811 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAS1BMVEUAAABmdX9mdX9mdX9mdX/R09TR09TdLkRmdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX+8vsBVrO47iMO8vsC8vsC8vsBSRe09AAAAGXRSTlMAYN8A//8A/1CfMI/vIHDPEL+v////31AArsUW6gAAANBJREFUeAHt1M2ugyAQQOEBR6si/rbg+z/ppYnESGxnGtm0d84KFnwLwgB0SmtVkEFBpDSGaAo4DIcCmuFRQDM8CmiGRwHN8CigGR4FbIaggM+kFAGVzKokqJL+BXQ7SaD8ly3vSKDYERCobrhQU7/+/FvTIXIhxM60Z5A1GkN86Jk29gjZfsDQx1Bo6G2ERjXhXskM9yY1BkjNGLoEhWYFSxIXWpJ+HbpvRSju362TcwIJJLMmsyaQzNpXQI+tDJBALg/kwOeBPKzeXYecX/8Awzq+GZnUyuMAAAAASUVORK5CYII="

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAZlBMVEUAAADZnoLZnoK+GTHZnoLZnoLZnoL/6La+GTG+GTG+GTHBaU/ep4nZnoLtu5/ZnoLZnoLZnoK+GTGnqay7K0Cwc36ooKTAMEXKjZfQx8rR09S6NEjCPFDZnoLep4ntu5//6LbBaU8xMndlAAAAEnRSTlMAYL8AIM/vAFDfEAAAAAAQ31B3lzILAAABJklEQVR42u3T7W6DIBSAYRStOt0KRVFoT7vd/02uYSq2DBqF7MP6/jycPCFE0aOiGK7F0euDkPs4SaEvTXygZAdju8QDSmFSuhyK4KZoMRTfQvFiCO76fehy15sj5DrcoGeFKIFvI3TeB0nBGp0FETtE5kB7cDTrRhdHsx57LRAl4BWhX49NwTuqoLM/dK4qVO0hQOpG7wHKMpRlK4Y+AlSWqCxXDB0ChDHC+Ckg1qcn7tkGbZCGtn/tf0N1wxnjTT1daTshpehaPdF7NujImYof9cZJSJU4HSx7JlRz1sfr8T7KUVJr2TOhho01w6yTY51lz4S4XuDDTGhIWPZMiE0aZnKSZS889PLnILxBPwqZWSEzDRX+UKGg3B/KFYTzwg8qrg7+BGfPkOtl+/aZAAAAAElFTkSuQmCC"

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAMFBMVEUAAADR09TR09TR09SAgoWAgoWAgoWNj5GAgoXR09SNj5HdLkSAgoXm5+hVrO47iMMisfmGAAAACXRSTlMAUN8AUN8AABAgWm2rAAAAsUlEQVR42u3T0Q7CIAxA0bbAtFvV//9b3Ys1HQSIGBPW87asuSGEQhESHxCGEggFyFnYHdLzbC96pu4Q50PsoR+FNsND/o7mCKm/hmKSqhQXCxYjSpNYDa3SZL0YYL6v0uh4InMnt0b2ziCK6g6pCGlMKIGMCQmwsQ/dK/YZNmYPmaFqyM6cL1R3spDvmu+a75rvmu+a79rcu/b2yNC//MFDjSEaEyLAMSGEgPR9iDA8AZMFzo6KnJZxAAAAAElFTkSuQmCC"

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAe1BMVEUAAABYWVu8vsCnqaxYWVtYWVunqaxYWVtYWVtYWVtYWVtYWVtYWVtYWVtYWVu8vsBYWVvR09SAgoW8vsBYWVtYWVtYWVunqayAgoVRUlQ3NTYmIyQjHyBOTlDm5+i8vsDx8vJYWVvCxMXJy8zR09SVlphnaGp2eHmrra4N7LjMAAAAF3RSTlMAQN8AIK+A788Qn3Awv49QgAAAAFDfADw0ZwIAAAFfSURBVHja7ZNrb4IwGEZfLl4qKrDhGLTOoXj5/79wDdTXLQ8RtGTZlPOlJWlOckgeasdZrZy3VqjtgT8qNCPfVhRNiopJZCVypgUzde4WiVmtOBzqcybuEwWmar/b7U1fcIdovigqjttSsz3WX4v5jSKxNFWn0nAyfUtxiyjhqpLhvqSzyL9UMT/6/E4iEXEVcO6LRLvIWWEV9uFoCAeBVdiHoyEcBFZhH46GcBBYhX04GoJBQNWVvplAUYBVXfoCFvEgoKpTH4+GeBBQ1bVvKc6iBKs69/FoaJz2wpjSnnhgUX8/2/PKHohjiuNB9FuiYWv/c2sV74ZCc7kjTe9eKqg+HlhUGgrN5Y40vYsrqD6eUpTlUimZZ7aitVQVcm0nyqQyyMxKlCsmtxJJxUgrkfrGIBpEg+jPiNJGPhpIG/E05GkeVRS6G+TzChvEDV8p1KeNyBCS24/IpY2diPkCdSw2w73NZbIAAAAASUVORK5CYII="

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAS1BMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMO73fWx1u+Vv96LuNgsbZ8iZpmCsNOex+RIhLBlmsE1daWozupSi7Zbk7xvosc/fKp4qc08/RrjAAAACHRSTlMAYL//ACDP71kzCuAAAAHySURBVHgB7MxBEQAxCAPAQIDWv+KjGsjnZlgBi8ecA27REJHFocoX5eHYyY6KAhUwShicEg6KbLTRRn+LrsjXjrkkOQjDQHQb/43BwP1POhmp0yNKWyqbQStst55+KUj5v4BCjOEOUMql5KrPrRdjedFAvZSRoObKgdYsTqsstnI14Su8Qd8hd6CpLpMqa/tvChAgZxx4UEYZoPqMohW8dl1tDpQuVYTZez/Er79N4p56jtoOXRwWxK7kYWIghc7lAtAikQrMgngwRRs8iH1jErXAmgEx7ySupwexiZwUx5osCCVnFR8exJwFVkEdGJsFrRjsREQHwmpDF5M0S3YsCI1MEOwOxOJ3iQT9io5Z0NDKkLIDMVZNGnHICcdGUEJlqK15EIYWdbpNh9JVTBDck0E6EIYWxHmcStjgRlAoV8seBA1ahQbs7ChAlQhYciAuWoFN+G0EoXxr04POj9NgMBUcf6C1OAsOtHzKmJSwXIC01NFhErE6UNdtviY6B9AIGjpMWKWMIPpE7Tr1XWsEqJl3JoUOxF37xp2olyD+0vm+Zu8saLDt9vFkaRP5wWLG2C4HC38y4dBtfDBGIOjVIguT49jwhAM8N4bCNj6F3/5kP6DnX+0DekDfAd12yXLbtc9tF1H3XY3ddln3tjuuD38AI06CEej8Ju8AAAAASUVORK5CYII="

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAADBaU/BaU/BaU/BaU/BaU/BaU/BaU//6Lb/6LZVrO7/zE07iMP/zE3/6Lb/zE3/6LYmcsyMAAAAEXRSTlMAYL//ACDP7/8A////399QUCMekiQAAACwSURBVHgB7dXPCsMwCMdxk181Tdd/7/+0y2FsEEa1TMqgfk/m8jkIErq0lHFQTkOLBjUWKAlbIC5QK2yABIZEhxJMJRXKMJVVCMaug0ZjVJUCcoaOrntsTa+O5gaxAB4QF/hAAh8owQnKXhD+DnoojcbuAM2tb/O5ZQcU0Kce0roB5LLsgAKKf02Hpnf9y77sgAKKW7PfWl8PzV0BnYQWH2ilzQfaqW7L79C6V6pOPQGcmao4jB0kygAAAABJRU5ErkJggg=="

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAbFBMVEUAAADqWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW6+GTG+GTG+GTG+GTHqWW7qWW6+GTG+GTG+GTH/1N7/1N7qWW7UOVBVrO7JKUDlUWb0q7rdLkQ7iMP0q7r/1N70q7r/1N4V34RBAAAAJHRSTlMAEEAAMJ//72BQ38+AYL//AI8gIM/v/wC//////////9/fUFAJtk/GAAABK0lEQVR4Ae3Vb2/CIBCAcfBacOvaU1pFp9v88/2/44g9L0SMRcaLJfK8OmP6S8BeFJyczYCqZhKeTcCYrJVSeg6ut3c31jINko269AEwH6fGk9oOH9S1C5dYXFoqqjKKqoHqB5xo6BnS/HitKH11VjjZqr9C6k4EDRjRMA21GFXLRwuio3VxUEdQHUJ02RgZQSaETBLEvz+3hLF1ZMKO0RvJNTIRskb7jjaQCtnKk3QF6ZA1DZ/LQBpEyc3obCQkQrzdW+Xaot/a9Uk9mh3kb/duv99hIhRsdyo0YB6oxUxQlwvCfwd9TbSO6FWgb9e9+dnLLlCB/BiK6GWg8h6Fc4HK/1pm6IcLP8VedoEKVHYtdtfCbqHb75+ECnTIAx3FKQ90FvZ0+Dt0PNtf1kHJ4weHF04AAAAASUVORK5CYII="

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAflBMVEUAAADR09TR09S8vsCgBB68vsC8vsDdLkTdLkRmdX/R09TdLkRBQEJmdX9BQEJmdX9BQELR09S8vsBVrO47iMOgBB70q7r////mYnPqfIrfO1D98vPhSFv0vsXob3775ej3y9Dul6JBQEL52NzysbndLkTjVWdmdX/siZbwpK2yOC90AAAAEXRSTlMAUN8AAFDf31AQEAAA399QUNERe9oAAAGYSURBVHja7ZVZc4JADICpUKGHR1vbwC73pf7/P1iyh93OIBBWXxy+F4Mz+5FkEtZRBH4ziB+8DePIn6AZJZgk8sdF/iRRc6FlzT/iMFYRRRRVAMBrw3UGgDNVxBKQ8FZ7UkAioqgGTaZFGSAJQaTfnheZygE5gSCniRL5boamWtbKOwldhI3G5hTyqIqiWaJMtEpnFPMuCOmilEOq6oFIG2O6CNHHOcPRFJnRRebkFBjlmNBsUYuFVRiFIqG5IlZdBhujeLYov0xjBAb8RBTVokF6OUxikqgA0ZceEWcEkaymYqrrSS4QTUtCSmkhCBGeTtJGMqvZHAxaCxGYhBaiSKVkdFzNU0oQDaC//re/ju5/QSK3urKRsuO9B/H/KM5f+Iii3eY4lbKP7V6KdsfplP3shWhjL9qi6OVoKUJQ9PpB4PMKruu47oOLvhQYDz0dFHhYx4toEaFo2bVxUUPg+wqe53jeXUQ/HWCAz4uI3uz7i8zFPPTQs7QGxtIuokU0QTT6YVvZi9ZC9GQvekZRZ1rZidadx/0FgNaqMG96VQQAAAAASUVORK5CYII="

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAbFBMVEUAAAD/zE3/zE3/zE2AgoX/6Lb/6LaAgoWAgoWAgoVtbnFtbnFtbnH/zE07iMNVrO4iZpnm5+inqazIwbCysa3a293p2LSgBB7k1LPW2NltbnGAgoXi4+SkV2XDdoOvsbS/wMPOxbD04LX/6Lafv8BwAAAADXRSTlMAUN8AEBAAUN8A31AApqqCRQAAAVNJREFUeNrtldtygyAQhtGk1WqTlIPnHJv3f8fyz0CYDBpBbKcXfDeujn4D6+5CHmT5MEuefUxBdJANTmSzotxNlM+JtoMjc6K3uyPvExAd/Jao5eLUNCfB2yBRLRhjjUReRL1cdGNMi8BtqYizZxHj/iKznmsHUXfVa/IX1UxyqSiFiNLqgvt6gUjAc6RaRI8wCX9RyyQVNSJa4UnrLeLID32IAPLEvUXYWfcs6rA3bxGTUCVSnPEsWKSr6XsNUeCKzmFbM8kGJtkBvx+Y3x9QkMAUZECLANMiAU0LTNMGjBFofMZIWfTAHmzAHmz9GEX5SUoV26MW2KO2H6ckhYqs4a/A8HcQFURH9nEEi30c9ROQneLuyG6CKPpr0V6Clw6KV/Feob8DURRFsddir0VR7LX/3mtfCpdkR1EUjRekETkXZLqOKCXJOqKEbJI0XJQmmx/XPp8UEaxF0AAAAABJRU5ErkJggg=="

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAC8vsC8vsC8vsC8vsD/6Lb/6LbdLkTdLkTdLkTdLkRVrO70q7r///9YWVtYWVv/zE07iMP/6Lb/zE3/6Lb/zE3/zE0pxW30AAAAF3RSTlMAUN//AP8AUN//AP////8A///f31BQAGRT1AwAAACxSURBVHja7dXLCsIwFIThXNQkxluv7/+ohqIo1ToneKBQ5t9kU75Fm6HGWOdhzu5QxnpRFkJOBjkIeWEQ2gs7gFaCQkxfi+FYBYW0WJigDHpCcRmKVVD6UTV0Kp1L7ych1ZeNP7/ahVxjIq8upWtpOh/pQhlESAah/54KVLJakNOCvPhC3kBbhzIIPUOIELfGrRHi1rg1QluFmlmfUDOLUBXU6kCd6XWgwYx9+z/UDeMdYH/DOWWokyUAAAAASUVORK5CYII="

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAATlBMVEUAAACgBB6gBB6+GTHm5+jm5+i+GTHm5+i+GTHR09TR09S+GTHR09S+GTHm5+i+GTHm5+jm5+jR09Tm5+inqazBaU+gBB7R09Tm5+i+GTHwAVz1AAAAFHRSTlMA31BAQL9wgIBQ37+An8/PEJ+fr0sIehgAAADxSURBVHja7ZbLCsMgEEVr8zbvptXk/3+0YDUDGRe9RBdpPcvD5UACA94ONFJr2eCOdbShAR1HaoMEHUdbABcmFP/THvQTYcc/TTao84dA56fTukMdJ9ssGeCuESrdoIQcp1otFeCihmY3mD1uIbeQ81O4QQE5TrtZWshxRjcYIcfZdgAXNbTu+Nzk1HRwjJwGOeCuECq3nRJwnJoGNeAihnoa9JjjN+soABcxNNBggBy/EAJy/GYJwMUI3YU6hbjbjjrNpyTOh4QJqQCY0CsAvx5SAfif0NOi1HcuhVLIkG4t3VoKXezWgj1rgj20Aj793k7MJ2U4JONQAAAAAElFTkSuQmCC"

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAV1BMVEUAAADdLkS+GTG+GTEpLzPdLkTbLUMpLzO+GTHdLkS+GTG+GTHdLkS+GTHdLkTdLkS+GTHdLkS+GTHdLkTdLkS+GTG+GTHdLkS+GTHdLkTdLkS+GTEpLzNN28dSAAAAGnRSTlMAn59A30DfUN/vEO9gYBBQcL+/gN9QgK+vcM/yqZsAAAEZSURBVHhe7dhZisMwEEXRUjzFY+apyvtfZ4MJopVGxtYl/RFyFvCQVEZ+SF5U+bhIXsmsalxsPikfF8tlzrgCCvoG7W2VvURsbKXNXA5P6i1BL38UmqSQF0OtSepBQjdNdItsjG5ua8m2dGJeH1kQWVJmSOaDnCLOB9WK1PK0U2jndwa5YGZ8bo1hTTB8/AFcDbsGZ41P+6DYYQoqFSunIOV0CjLOPj1IOf30IOMsuNfwzXY07BgpWImF66TYKWwitJEMig0yOSt0jtTZ5HJ7MegiT60hbaSqg9pe0OF7JfwXeZ0CnfxS4gXxOppJ4G6J7hJqWkvSNvIioxvzOjoxz4GqDpOcRDx0lcd/v0R8g/jT2Hsf6/jz4Q9/AbDMCPAiJAAAAABJRU5ErkJggg=="

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAUVBMVEUAAADZnoJmdX/ZnoJmdX9mdX9mdX/ZnoLZnoJmdX/ZnoLZnoJmdX9mdX9mdX9mdX9mdX/ZnoJmdX/ZnoLZnoJtbnFmdX+psLRzgYrR09SZqrWP36nvAAAAFHRSTlMAn8/vIHCPEDBgUIBAEO+fML9Q3+UX54MAAAErSURBVHja7dRdj4IwEIVhQVE+1Ip0B/D//9ANXnjsTmvTnhgulvdSkyfMtLAL9XhEflV9HfK2JiSBNuiVCUGGdSCxDiTCYaabAy3/bdD3oHFMhs7ybH5vnESmhULy7PwBqgCBWQIFqIrfxD+MouL3sgQExqUAlanfjmmE6BTZtWI8DxfbdhVgFBXbtvEyQcpEdq0YTcW2rZnPVIA5lJJYefA596skd71r5yhZHemxMB47FsYjx9LjoTkpfOQ2aD3okv6uXXzOLeddu2mnkawa/XHMzFDr0YvS62EW1QhZg/WQGeI6uldyg9aCfjL6V1BnM+tc57TPhfYnBypsdsW7U1uieod6BurhtJaqfUEDBw04erJOHT13BQpLV+DoyWocPVePoydrcfRcwy+nXyZEkwH2/QAAAABJRU5ErkJggg=="

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAAAiZpkiZpmnqazR09QiZpkiZpkiZpkiZpkiZpkiZpkiZpnR09QiZpkiZpmnqaynqax6nbdYWVvGzNAtbZ2Eo7pOgaj////x8vLBwsNrbG6TlZinqazR09QiZplVuS+EAAAAEXRSTlMAEM8AgO9gvyBwr0AAgADfUFAEwO4AAAFASURBVHja7dPbcoJAFERRIIJXgo6XBCLn/z/TYTiVZtAonZGHGPYLgtWrigKiqaHFSRK//yLsovaQi+S0gh2gVCRlEewAZWLLSAQ7QHOxzTkEO0ALcS1YBzuFluJashB2CiUi9L15O4Vi0WLOwU6hTLSMg7BTaCXaioOwUygVLeUg7FpoLd+tCcbbOSgXjfze/F2kryf9Avg7B0knwvF2Djp3eiPydxEuBEKz2msnA9v5u1lU9xoK9XdPg553a5vNuZMQXT21F4eMjYWwGxOqiUaEkAftD4f9vXOsHkBHkWP/nIKMrTme5KoT/icgudFDyNhYCLtxIfRxoxqNCSEOQiNDxnYPMrb/DqHPprIypirdzxrxUGlcZTBUtVAVDBltgiZogjzo64f+FFSEQ4WDtuHQtoGsVIRBhXUcFN5rQxeRvKWEmfLPxwAAAABJRU5ErkJggg=="

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAqFBMVEUAAABmdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX+xZXXqWW7qWW7qWW7qWW7qWW6Ab3zqWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW6WiY/Wo6Xep6duc37qWW7GnZ+ejJKwZXVueILmqqp+f4fOoKK+mZ2OhoxmdX+mkJV2fISGgoquk5dIUlkpLzMFB1P2AAAAI3RSTlMAIIBQAGDPcBDvj7/fnzCvQN9QAK8Qz+9A74AgMHC/34+fYAtQ6IsAAAHvSURBVHja7dLZdpswEIBhEJKQkFgajBvstKmTOGRxl2nc+P3frIORewiHrYhL/sP1x8yAs7S0tLRkmUsI8VzanUPHxaCM+8IWooJIwGTgTocEI0opEmg4F7oToUhCo9ibuJqnm5QkYhASIQepWO04hmlQbAASujoENfkSOgr7IR+q8IX4RBy6i3shAiatwWfQWzg00f3D/un5FYbz+24kAfYH7OH7MCTdDsiM9ONwlmC4uAeiHH4ezv2C4aI2iBHiJZR6cF9Bv2G4sA2KAZOhq98q6BlGJFpXc5kqLXOk4xiIta0Gl/6Uzh7GFLdNJHCgc28jT4TJJmQo/W+kp1cYVdQGCQ6m4xFG5huo4fx/gYFsHVAGsnWANyGXw7Q+QoJJmAFyQ8O8n07vFpAvwXTCpkMhwByQcexX88EyAwlp6UgDWQ8UG4jbQp+u0jLH1nksilU2B/RSFMU6s4c+o4MSQtrK4eI6L6VN6kTayqE0W5fS1knThMSKT3JCQbGbcqYvCF1KMIKpkaxOaNUGoa8ItSUSP+D9DKOXtgWGUHdJF6aDiNYahMxoSsmaoQLm0g9lBrLuGp3bOaBvCK1mgDLz+a3bmR/SsmxVOrvUDtpe7fLSybM6dJcXE8tv0jo02blFZwYo32QpZrnaeneHTNlfIlrZA4hOfukAAAAASUVORK5CYII="

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAqFBMVEUAAADM1t3qWW7M1t3qWW7M1t3qWW7M1t3qWW7M1t3kcoTqWW7M1t3qWW7M1t3qWW7M1t3qWW7M1t3qWW7M1t3qWW7M1t3qWW7M1t3qWW7M1t3qWW7M1t3qWW7M1t3SvcfqWW7M1t3NzNPOwcrP09vR0dnUztbWy9TZWGrZn6zZydLbxtDdLkTdkJ/gwczlu8fmaXzouMXqWW7qtsPts8HvsL7yrrz0q7qzFKqtAAAAIXRSTlMAEBAgIDAwQEBQUFBgYHBwgICPj5+fr6+/v8/P39/v7+9VvM7kAAABmklEQVR42u3Uf1eCMBTG8StoRCmhYS60xWOalZZFFu//nbUhPzrHZLjxV4fPC/ie3e2eUavVarVa/17P932vR6bcGVLMISMBCr5hpzQibR6E5eoRe9rTdTiw+EyS5GufmlHJdlJ23QMtdklqBcnd990RQ4F56lgIbJO9L0gBke2FKNV8UWCZ5NYQwqxygNmK0LoIfaASd6tDb0XoEwr9pkKoOBM/KcTtir1+KUJbKN3QMS4W33lohQrKzWd4KydTC+iYHs82crdAHZ1jHQZgvUu+t1lHcwV81KH8aOwQJ2N0yOHQQAf60PLn9cyfNpunuVkogCA6omQUGkHapB4MQn38CkE/5EAyH83mEPQu+/6SSgz6XuOJRRkPBt7jeJqXOPQ9x8I0/8v0hReRLA1NJws7ZE1lqUtCJ4SmQP5qZ/JMV5SWPJ0UDxxKDUXoljK26weM1R+J+S7lurFATWgqZDUVOhedO2rAtQhNyJyVPb+xcbaQhqyJ7IzJTPdyHMlOZJHSIIqVojNSq9G5kx3zUDSUc5mONh0P8swP884B00eNFEoAAAAASUVORK5CYII="

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAgVBMVEUAAADBaU/M1t3BaU/M1t3BaU/M1t3BaU/M1t3BaU/BaU/M1t3BaU/M1t3BaU/M1t3BaU/M1t3BaU/M1t3BaU/M1t3BaU/M1t3BaU/M1t3BaU/M1t3BaU/M1t0pLzN1TEHBaU/CcFjCd2HDfWrFkoTHoJbHpp/IrajKwsLLz9TM1t0f8CgUAAAAHnRSTlMAEBAgIDAwQEBQYGBwcICAj4+fn6+vv7/Pz9/f7+8J3AbmAAABeUlEQVR42u3W23KCMACE4U3TFEmtUqSomOq21R58/wcsik60gE0Il3y3mfldwBnAYDAYDFo9TF/m+4PVfDYd3aGr5f7a8ukenbzua547zXqYrWqlOTobPc4uS3SVRfhDpm+7n3Pnk+5ygUvKsLT9Pna+6GNxVTKsvG93uw/6yWBphohsKGMIO0kyjMDJmGGMRmXBg816vWFHVUnxaF3qvEmglISHOEapYPClMQcQsw8A0p5Cgj2FdF+hrK8Qg+XHkOorFPUVEgyWHEMwDDWpQilD6SokGSqqQkgYSJ5CmDAMziGI6GxBf7kNWYr+klqo42XqxhAK+lLNoYi+UAt1e+vmbSHpfa9hSIO61PvdqI3RqBOGPiSskL9AAStoUgr0MymG26QcjQqeCThMag/lLeftkyZolF58hbhN0v+cSzhOitAotlfmOAnNlB3sNmmBFvaLz21Sgha5fRROk+LbvyPhQB+mo41yGWTXpzdPCwEn0ty6l8oYhQu/I5ZEI/BW4jsAAAAASUVORK5CYII="

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAk1BMVEUpLzMAAACZqrUpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzOZqrWZqrWZqrUpLzOZqrWZqrWZqrWZqrUpLzMpLzOZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWSoq1vfIT///+Lm6V9i5WUl5k+RktFTlQpLzNMVVxaZWwwNztodHxTXWRhbXSZqrVDkTdNAAAAIXRSTlMAAADvvxBAgGBQIN+vn8+fgEAwvxBgUI9w36+PcDDvzyDLrIuTAAAB70lEQVR4XuzQSw4CMQiA4Y4XoIRH0s7LI3D/041GjJquhnbhYv4t4QshTYP6e+iCLog1V6Ka8Xai1AwQ7F2ROMSzfQcchHi33yAI0XNXH2couCQhaDWju5vifwpBsi0f1W/Ck1BbfkG5G6JBENgQCMl6IUbUubgSevbRarnsNggDUXQk29gY8IIN2bZpHrdNH///dW0pysiubA+Bs73oMB6uLLwbNPD8FfOEEn1DKS7MyeUr4RNltIk0JizBNR3ohgohMgVkRFdU6Ymx9+AWez4ggPdkFBbiZb9cwEhGsmBuT3fNG4SYxeMVGFxOv5bT+yvEKEczA2bOx+MZDzKb/BIcf8CDKENE/Q4iHIgaYPvRoHmgjRBhH2jcS9TsJTLYjJpFpLAV/Sca9hL5vUQ0YSN2EZHdS0SmmWmnDo/Q3kVMq7GeBiximvVTEYsirMIqupyIfMAadEa0+jvavGhd3V1J5CFnLIlIQwwVRQ5SdFlkFIRMLNq2blcRtRDiKyIj7nVFRH30bAKLhqrowN+lJGpZVO2k/R920b+RAhRn+YebbF+XaZ1SjqhegFJ24KBagL50PXgOqgVwhZdokhB4nSkjv0TAFJ0shv/4xEtqC9eMJRkqrXW6bU8y+vwWRh5IdrZQuEI7Q1KCGnPRqOLsGwRzlCnTihh2AAAAAElFTkSuQmCC"

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAApVBMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t0pLzNze4ApLzMpLzMpLzM0Oj5xeX8pLzMpLzMpLzPM1t0pLzPM1t0pLzMpLzMpLzMpLzNSWV4pLzMpLzMpLzM5QER7g4jM1t0pLzNSWV6Zoqi4wchcY2hmbnOtt71weH09REhITlMzOT6Pl517g4iFjZPCzNLM1t2jrLPf7x8+AAAAJnRSTlMAn7+AUBAA3++PIM+vYBCvAIDv74+PIEBAMDBgn7/fgK9wUJ+AcPZFcm8AAAKDSURBVHja7dbbcqJAEIBhBRkQAqvsxhMhp920CMFotH3/R1t0NjYwJ6JXW+V/ZQXqq2FG2vRu3br139a3LMseOOyyevTRxWPe0L8W8gPk9f3rIObcIc8Lr4NY9GOPvGj03XojahzDZsuhn7/8y1d0D8eWGeIqByiC0LkMmkCzAvEu9C+AptDqE6uC4YypiqbTuWyPoN2hgjgWLgRlkjzEAJDOReixDS2xVmDZT8mUNx6n55vjuQCl/HE+SXrHegeQFk/a0HGlWAXnyga0BnlpC5qAAH3UnS2omjahMQiPBroFUc8NaA6UDMpAXVSDokcDVGqgODlDc6mzQWoJupJ/0EsMsnKkQFscHaF5CvK2Joh6qaAxKPrA7lDaG6WgaPNuhqheone6Q88gb7nC70GpVCmJoePXQ/dAbcoDqipN0GttJO5RXaY5sRNE82yL2tYm6JW+Ndp2Jmj0QINV7JBDVX7QLen3CaI3LdNtcVGZKugPh6qiKW8W9r2GU8C5Unlwpc2hVqGrGPcH7goVOOOQ0Nt5VXl7phQyBxcxQEwQtfiSxHG53UA9/k8HS+I4IaglidAKq1ZFYznHv7n02y+0kEHI2+/yzWkx+Y6/CRZBYrYSErN1EHMlm61ooIVCyfE3y9YA6wwRHS3E3NbsKOXTIMOA6SEbG1KpGAZrHBogX3hp5aMXQwPEAtRFkG+ChjqGHs1lJmigY2iz+0bI0TF0/AMjxFzskmOGrC6OxQgy7bbLxPpf0FsHyEbeUHMNfYKMx+ZrrlmsAzSje1UDC0MjRDfPmCw85TkmiG62dEdqs+7QTHcSfjfIoyOTP7fNDBAtP3A0F12nI9THO0d9FJ63YLX+Au1+0dY9O4FkAAAAAElFTkSuQmCC"

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAolBMVEUAAAD/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDPUkzMpLzP/rDMpLzMpLzMpLzMpLzMpLzP/rDMpLzOvfTMpLzMpLzP/rDMpLzPKjTNmUzP/rDMpLzM3NzMpLzP/rDN/YTNGQDP/rDOpejOHZjM2NzOUbjP/rDOvfTPKjTMpLzNEPzNRRjPknDN5XjO8hTNsVjPypDPXlTNfTjOhdTOGks99AAAAJXRSTlMAEL/vMACf30Bwr+/fgEAA748gYJ+AEGDPcEBwj7/vryDv71CfMhh3uAAAAoZJREFUeF7swAENAAAAwiD7p7bHB6sCgLdOR9tJA0Ech5NNNrsgi1rURk0VjTT/slQLpO//ak7HKWclWRasv5teDHxMMqe5QlHqfysLBxUA8z+gApQloJxMX3lqptz89XllwSAHBeUUgxtPAf2bt1cXQguFsBU5t0BH3LurCyBr8Hd3JPTA2j/1/sOZUF7huJ8EbIEdQ/vZ9VlQWWMYAR2AW95s42cf5/bTfD7/7Jqbmy8d/c7s6/URVBZAx18L672/4z8EyRvjLWVy7ymzCM9PDuCpAbQGsCViJW+MtwRPmN4A0+UByguMQr9Y5rN14S4yeWCacrlANYDBo7HQQ6B1uItMhKbqkiGHSB3JAu2DXWQiNFeQlC0Rh/ag1gQh3EUmQnMm11mFWP0GAvUIdpEJQ3tIlc6++dtVBOoA8EtdIdxFJkJLy8zLgsPud5ArPIS7yERoio/eEBRZaNcBAu3CXWQiNKUUAJN992vEkx8OdhkcA6oFlf1IQb1/RLDL4BhoLENLJLr3u2CXEHoEN/kDaZeA/Fbe2HEboa1AesqAcgtrreYQtI8+uiwE/QzldVG1WhpAjz1OZw7QMBNA23UCmp6AFA7tVkjkEtDZtScghwta8sfNyyGtGwBqFFrg/BS/CTSjkI0AhXK2PoIqrUFNzoVq5dqlpsrB0VpQ5SikISH93K2uABT6ckg3CCvzAkAVgYw4anRaIYhPDBuB1AFKSYYXMjoBOT3eBBIUo4sY5BKQtkagBrxQCrI6Vi4Q72aj0CIJaYGs471jkBVIJ6FS3BdD+iSU17HrS7krwJlTkHUFBIoxBpKKQxaH4OKnl5o4pFKQRZCLQwiyyf+0NgrlSWgy/onft41VZzqCsgQAAAAASUVORK5CYII="

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAZlBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE1/bj1GRDapjUP1lBD/zE33lxb+qS6UfkApLzP/rDP9wUE2OTWHdD6vkUP3oyDKpUf0kAwwdKrLAAAAFHRSTlMAEL/vMACf30AgcK+PUIBgz+/vn9rL03wAAAHgSURBVHhe7MABDQAAAMIg+6e2xwerAoC3Sve9bYNAAIfN4cPgF8y2XlM3azN//y85x0KIUB85b/39FSTriQ5OAekW/60GswwRdd8BadqyiOj6Yf+tYZzUeUjRPfCgKW+Y1TloBmLSo5NDU0ex621db9fiZJwMUgMl52XdermWJ+MEUBsodVtfL5fX9fb1BLPd6/0IsA/QDfMD1Oq3ZXmL0Lpe3t8v61qcuLpINbtDy1Yd4u8PpggpTQliR6veH6gdCkQUR+M/rv9JUBvkKcU//7OxR2wcyeMhco0RAILVGJsfy+8PivEjPr0/aJZl+aSy/DPh/W3Qx5MxZDU/lz8JMJPDe8VVyqBfCQoOY9KdfoAcxQymxDudQ+iTkwrinc4hBNrqMQvkO51DKpBxWEApAdRF6GujeKf3BhbyJVO/bC+H6s8/sdBEp3IsZFkATG9DCeEZqAPjrcN7bYnzkEoAHjU/QoaHsIDq6+EFUMDjTA5NqIn0MRTS+AKpxVnr+RiCND5XT8X4dcgjm+2i00Woeps9VooQ1CAfISuAxu+C+ho0RQgFkK1B9gTUCqAggbACqZAehEv5+PwdD1mvn++jphhwkKUUeX4ZUyMHQQb1jENZnoOSwq+Rz6HpP6D+6Ju/MT7B/O01KCwAAAAASUVORK5CYII="

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAnFBMVEUAAACZqrWZqrXM1t3I0tqZqrWZqrXM1t3M1t3M1t2ZqrWuqraZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrVhbXQpLzPM1t2jsr2puMKzwMnCztafsLqcrbjJ09u2w8ysu8SZqrX0q7qwqraqqrbuq7rSq7ifqrXdq7nHq7i7qrfjq7nBqrekqrbpq7nMq7i1qrfYq7iVjqYwAAAAF3RSTlMAnyAAv+9gr49AgM8QcFDfMM+vQACPvx/G+BYAAAKISURBVHjardZbV5wwFIZhwzSxpoEMh4nSk22/AHPUUf//fyuGXcqIMib4Xs3F8Cyyw8rKxYsYWFSEdFGcZgAuPgLK0LYKg/JikMRzLASSQCpUQcVwyQAoQRuXROXYrTcAcn9IwaW7RyNs7aEGuPKfEcNwOS1kDxtgFTBs3O/qfsRmZ63dAoj8t1/X7aM1SewZsnti/SCBxlp7B7ce+Wjbmg24P1TwtW1bu83KK2s7NveHZG1J0irauN9HQPpDih8sTUYWsK4axh8q2N66ydyDF2ZLa0sDoGjTWNtte0LQExAAFdnauiowuSMzCMrvLb0HJ6gJgwq97aQNxKN1wQRBYm9p42Q1C1K8oW+JddDR+zuiWDfuAwxo2EkYlNS0Igl6tdDDnx9PoDsTCrEHB1QE1XEoJKoTCMtQKMLhoUJXtb/jRSiUcwzjUgVBKsPL0kRIY9CnDYvzc1DO8c6yOJqABHzKkrcgAc+0eBVK4J9ZjqGIIyQ5ggy6rm9uruGRUadQDuqmDT6l6gQywRBJBC2BkKWRNIBWmNPqP2TqGjPKe+ho7RHh6R6ybZiR+CjIzIeoiKAnd1+YUUzQl6apMaeMoBgz0wQpjZkRVCz5B0HFMsWsosFRO4sqL68Wi8XFwhWJldGhUFl+JmiY9oecNIJEEFReETTjlb466HIMxfDrW+kaQwp+fR9DlIFXP3po3tp+lm9Cue/KaNjj4NHtr7Lf/lGpB/TbMfRBzpj2n3/Oq5CE6x3e7Sc3n6vFJFQIjXOJwSViXNwfWEmG6bJJKB+cxZHGVOYsRP9RKSZjZyG62mlMxpeTkMJz7j+YLCWHoHG6Xz2beBu6bk9B4v9NM2HjKRmTSfHyevwXNv4WoFktb/4AAAAASUVORK5CYII="

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAjVBMVEUAAADBaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU8pLzMpLzMpLzMpLzMpLzNZQTylXkqIU0V/UEM8NjcpLzPBaU+4ZU2lUzyOQS19MyJmIRNsJheCOCaURTGfTjmwXER1TEF3Lx6qV0CZSjWIPCq2YEi7ZUtxKhuonujOAAAAFnRSTlMAIO8QAJ+AMGDfv49Qr0Bwz4DvnyBAC6y+FgAAAl1JREFUeNrtl9l2mzAQQNGKkLAgSZsuTBOSOomTLv//ecUKdCTb1RLct9wXn8OYizQzkqB6553/A6GU8WIqfoQAkKtEjNJ6+iEAkBySogCNNoqcEokpNgkMTKiEiMKMbo9EbB+U8382eSKnqg9Eyl0mLTjSU0NUKBLuojDgaHkSq0wDji4QvV6kc8zwLKyex4QiAgE9z6QDV2UUtRCSI8HcChRJCLE5EryTLaK6gZAux4F9oyosZ0iTLXItLCqc5wGKp8H09hUmunhIQcGrZZJIeboXkYCZp2F4QpEuE11cDsNw/Qn2DBNvGBJzosHxGUXlQ7Iu2c7zxZ8aokrKv5/ZVzgNZQUNeTVPDCmdnHCPrD5MQ/oGN7fjeHc/jt+3D4/gITKXv+EV/3h5Dbs7j12JiQncRhTMovHh+WU73gci6C0PqVtptNZGTgEi6dIoS0M+vuxlP37CMX1nX2ml1D0gtPeqW+F2/TxOqu0vKIVa3PwV/avaQSGG+ccREeC4+V0o2pDDA7IW8BaaE0c2MRTKsSjyUBsoRaIoRBYOS6PogLpfJ0JYv06EELpOhHQrRUgD2YioSK0sP0LPJRKQSxsX2ZVLBKHnEmUvOp4QqXOJCORBfVF2T/ba4Yd0UiT824XsrPUPswJRF3tRrnHPToqwk6LdIZMijqJYd6i0qEdRpDssipLZjnYHSYskdkokSRxFqWzr2BLSGSK2FDjWHSJDxCkW+J+d1OWIdPRtGxx1jsiAg8Uew1Mi7JVNrKibpAjToGLRLiXCbNNolOSJRPQrwmDxUyJCwcSilHDkD6AU8HSqov2LAAAAAElFTkSuQmCC"

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAn1BMVEUAAABckTtckTtckTtckTtckTtckTtckTtckTtckTtckTtckTtckTtckTtckTtckTtckTs+ch0+ch1KfilEeCM+ch0+ch0+ch0sNTQvOzRSfzr////1+PPg6trC1rauyJ17pmCFrWzW5M5km0N0rlJ3slVekz1Pgy4+ch1GeiVViTRRhTBAdB9ajzlckTtZizs8VDZMcjlPeTlDYDcpLzPHt21fAAAAGHRSTlMAIL+PAHCvYJ/vMN9AzxBQgO+f7+8QvyBrz6fLAAAB2ElEQVR42u3V626bMACGYQ4m2MY2rDu1Jek5G+22L1vG/V/bjJ10NA52CP3JIyRLlniFwRbRbDabzWaz9xQnKemJyLkyYPEuoRwAnRiymC1ND6Uwpekhjk4aCsUkqEAn94TEggGQmSJeFAYfCokEO6wMfDejUEdDiqKHEg8BKzUhXuhmQqtMGCkDNr//ANu/tuRZnsKO6EISjk3btpdtC0N6StiRXQhHXLXaFYIl7OUDoetL/UjXCJawVwyEsNluN0CoJPBKmFAQE8NnxKI2FJYq4ogZXjESLVBrS32t6nqFISzlhx2JHh6VuKnrm9u6vr1bLu/gUSyqUmg6osyG66siQu/r+h6rFSZZRITQhwdMJnWICAm/x6f1+unRHfvsoeVVwjDo29pwRje0J0SZMrjWhjO6oT6VTFlan5Jw+SM25IhZ+D2FQlaG0HsKhyw5fWkWP3NDuqpzjshREiNlAyHOMA63IVeJUYrhf3+OMfLhECnZmAfyhAgvcCrhDRH1/eSF+UOkeX5BGCtJMNQ0zwhSJBzSfiCEnBb6+evwlsYYFfrQvF1cb7Z5GRO6aDofsdef/TQm9PmLvuPiaw6LeWadkG9r0oNDxOysE/JQFQMSRd6KKf7P/gOnIkUMOs7ZfAAAAABJRU5ErkJggg=="

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAtFBMVEUAAABVrO5MoOBVrO5VrO5VrO5VrO5VrO5VrO5VrO5MoOBVrO5VrO5VrO5VrO5VrO5VrO5Tqeo7iMNVrO5VrO47iMM7iMNTqeo7iMM7iMNPo+M7iMM7iMM7iMM7iMM7iMM7iMM7iMNPo+M7iMM7iMM7iMM7iMNKnNtSqOlVrO5Ln95TqutFltNPo+NCkc49isZAj8tQpeZNoeE7iMMpLzMuRVc6grpImtlDk9BGmNY5fbE+jcgj/1ceAAAAJ3RSTlMAjwAgcIBA388Q75+/MGCvUL+P7wAwrwDfgEAQ759gzyC/AEAAUHBRicAZAAACYklEQVR4XuzUW27DIBCF4awBycijwQHEmA2cXHrZ/75KStQCjlubPLb/s/XpCEtz+MP9pw7yZC5SEIl4FiKkRot+iBVgaMI90wF5Ts5gUeU7oGk8hmhQpzogZ7Ds2AFJxDLugUSjTUsXxBZNcx8k3GzykqC+qt9mhn5I3FQ6q1CIpLxXNLt1iqPOs0geQ4Mq39IeWdbDLf0IcmpEk6H1UfmDJRQ0HjWGFSjgM9dAzmMtxT9BoYJYIbdj1JyhWEJhRG7PKMoQFZDCr9lB2nwLsceWqHEYOZ+h4tztHEUNNBhszcTqwtVQcnakuTgmFcQWuzKz5CbUkMa9y/l0Ol82UN4lxlnU0PzlJidJ2JKlCUXTDfqGT5+9YX90g16u19f3AkIv9NFe/fUkD4NhHN4ck9V2A9MnMZEz/2S7WVdAfV8kfP/vJVB5YmmEup3yO+nZlbtLlmLffMtX6wO9MoTW+B87Pv77FVzz996Z2R5KcZQWfaG7m11JiWOrntJ2QrsSGg+V6txBOQZKza2DBIZJRpODSA6TuskREhocur9KFtURohwDNnV69sIPZNFfspDEi6jUvaUG2Q+IKnjSMtqpcf/gStwhPam1kY4BHp9cyffpS1hHOZ+AJOKruRS8um3UHi0CiCS82s0FZlEDmFIIUQq/lT07p4G7WAhRpeHXmd/WHBgU5ENcpnBSU4ezlps3HCpEAHEjjdPabm2stUu7y6znHYDACSESKSKTbDDkl6U6gtEVBVCQqIqLcwSdhbhsdM6SJdFFiBPTVCEM4zwjioW4cpqnSvFDo2TFSgAN7wpdoS+70Lrh+7WdVgAAAABJRU5ErkJggg=="

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABMlBMVEUAAAD/rDP/rDP/rDP/rDP/rDP/rDP/rDOqjdj/rDP/rDP/rDObdND/rDP/rDP/rDP/rDOqjdiSZsz0qEmSZsySZsySZsybdNCSZsySZsySZsyqjdiqjdiqjdiqjdiqjdilhdaqjdiqjdiSZsySZsyqjdj/rDP/rDOqjdiSZsyqjdiSZsySZsyqjdiqjdiqjdiqjdi7k7eSZsySZsySZsySZsyigNT/uD3/vkL/yEr/zE3/rjX/ykugfNP/xkj/rDP/tDr/tjv/sDb/wkX/sjj/wEP/uj70qEi/la/vplLKpaT6yFa6mb7PqZvqvHCvkc/Foa3ftIHvwGe1lcf/vED/xEfVrZPkomevj87Fl6T0xF7KmZrasIrqtGnvsFrqpFzPm5C1kcOSZsyqjdikg9WhftQcVgYEAAAAN3RSTlMAYL8QAJ+PIM+AcDCv70BQ3xBg77+PIACA73DvQHCfv+/fMACfUM+vABCAz9+vYI8gUDBQQK/vLSTmUgAAA2dJREFUeF7s0kEKwjAQheFeoZKEpqUojAtri0qaeKCn3v8KTocsXc3spP/m7T4Skuaf29s7AG4iojPgSVUjE8DNROyxZIA6bPXkZJMeKgLMFGW9HvKQaJZxemjKBVwK60ZFPVRvl5lceE1QAhB4e2AxQVRPkgFnhWKFihVyFeosUHv7vE/H++PC0KqH2uvwkoaxt/zscWNqz5+v/y213prTBKIAjideUqJF4/ShD1od09EwdqL2CQKUJUjIpZe0EZLeL7Pf/zsUopw9e2EzTf+vJr9hz7KunVazZpK8g1qz1W4o2mk0ekOKe/NKVLpNk3CZzY4C6hmU7+lzXH3/gCiadiVoSIVGFqplkopqbR6aU6klMO0p0dTioLEMzeFxiL4mhqjcbOs0yUNN6xIkD6k+JQ9X00MqJ07SLC+1Y/XqdoYV0BGnOCcudJJ6SNotoZ6hhPYwk7l8PqLMJ/Bmz8WNW1hWlzGe48oFMRsTQDllCLtWN8GJA1eVz6QOQHkLDE3Qxsc+m41jh2F4mgaCVMNQA0OHHYWThYBHq3sX5tTB0Ig5fasmOX5IcHYhreAVqIBGbVJWzieAXcJSiZsV0AwmlEoO5BSrhbWpodcwi3LKskO8YtHRFtpXD3u3hM62EDcf/LQJ7BtAPeYYR8IDrYiqCK3tgEEDNGsTxrApBsBLVg4sszh9pcqgOYLQXxYF4CTFXPxyMJkSmlHW1ondTSnhn/AMQaEEjRB0DtPkRh2627SQgaALtr9F5VBWAgSfcRDFXVwSYpcOzAHOLpwSxYyWVOjqrStAkcvNzDtB228CNKBi70CC2ePj4gVgci/knMqSABH8QGHuKI/IjMq9F6BgA/lZmhXLwoe2q4XoB377E1csglnroevNmBJCYLxcNrvb9BD9yJ/ZkHcS/O2vh+gn7o0kNmJ8m6i+/F+ooesb2CfhpjyLiPI6GlB162JMvkcYla6yzLE9wtrLAemIqN9LR//LhoOOtdKpDOCrH0MTqpP8uNJpN3ioMa6U1jfV0jNwAJrQ6m7hphW6+zyeLa1NO9a2Y420zl8oxxOZ8y+0aHjIQz2D6qjbr34aYebyG7suBhiyDvtU2/rq+4+f4T326+73H4o7XiLIWhr00fUnCLJ6i/+Qcgi1HPYfK5UQNFmMxv/OGPO/D+rx9qfCIA0AAAAASUVORK5CYII="

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAdVBMVEUAAAB3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slXdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkS+VkndLkTdLkTKRkfdLkTdLkR3slXdLkQpLzNQcUTKR0eRkVHQP0Z9qlS6i9pAAAAAH3RSTlMAQHCAv9+fYCAAUI/PMO8QrzBAIAC/EM9wn4Dvr1BgQZ3IhAAAAoRJREFUeF7t2Nl62yAQBWCxaEALg+KsTdqOki7v/4hVHIcaMyyNetGLnktb/j80DMiia4mQSuueQjQYO1ykGyoZp5m4zNL+AeQAKR+wjZAHqmTyLZAPVXl5fn7hJRQN0BIuf95Cmcg6RE0QQTsUbo0P8NDV4frmLZoaIznoal3X28MRmqg1joHu7tct9w+Hw8OnZqhna/T4tJ7yvVlSbLGv70/Qj5+tEHoOGg7rKd8SqQelJp1Ksjii9ekznCEzSPe+ki+tnoG+PL0Sj1u577aps0bBopQaxRDFYCy5BPq6brndjEpcLMkEetyG83DTEBlBS5eW6OqmLX1UpARqT9z5O6Dxb0Hi34L+Q1aoLW4nNMJ7z8odkJ2QQsYPQxYCgou0H66RCqOBcUex3fzOaLtn1gxSocbtkAq22dVHEJxpV0PK4My7OnukELEHshgcnQBObHFtkM41s5XhKy1tFTIUgkyfh4AtQx4pBM4cRUlUEVJETA95TUy0L0D9GWSDMxOb2WehkbgSBSeRshAQpZM/UTZTDkJKay2oEMFDgpsVXYI0D0nmfcBRMY6FgBk1lCFgIc1AfRnqWYhSyFIltg4xV6ASQiFzWR2SRJerxkSQbIRUBA3HRJCqQiqFdOisGpT+CjgonX+TQnFBHNUgcun+0GEsgYL4E+B6FEGpuNkwNGTlLVpSOUunKpBrWn4kO1ddDk3LxnbpXshv9+WR66EbTOUd8xSPJUhs0KBrpa6XWw+vkMPKZljdNtEeofzN9T49veFv7AhlJXTnTn7o5veRhsHis7D41ER3fshidfk5n2+CxV8c+4iIQrADGwsYMdyJlpUaj8oMxg/ZeAPzEemjv/S/ALUulO10+UsLAAAAAElFTkSuQmCC"

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA+VBMVEXBaU/ZnoIpLzMAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLBaU/ZnoLZnoLBaU/ZnoIpLzPZnoLZnoLZnoIpLzMpLzMpLzPEcFbIeV7ZnoIpLzMpLzPBaU/ZnoLBaU/LfmPGdFnBaU/BaU8pLzMpLzPBaU/BaU/BaU/Eb1UpLzMpLzPBaU/BaU8pLzPBaU/BaU8pLzMpLzN9T0PBaU/BaU8pLzNXQDvWl3zZnoLKfWLMgGXYm3/EcFXQim/Gc1nTkXXSjXLHdlzDbFIpLzPBaU91TEG4ZU1iRT6IU0WbW0iSV0Y8NjczMzWlXkpPPjpsSD9GOjhZQTyuYkzh4dV8AAAAN3RSTlMAAAAA74C/EGAwIICf37+vEECPz8+AQO+fUDDvYHAgn1Awz6+/cBCvjyDfj1BgQN+fj4/vn1Cf+jzVzwAAAzBJREFUeNrtl21bmzAUhoNrqzW1Mi3d1lI2sIVVKtRBN9zc3Ex83/v//zELSUqgQBcu+mW7vD/oB+2d85xzCAqebIhH0b8iGqhbCWCrBv3FisiwdBCzOB2PtUEF0Xy1IhN3TdDvIcrRVNqEBqvRXIzfoiXDgbSop66IZvj+5opw85OqTiRFPW4S0QK85PfVV/ma5uxXRbOJR3D9HaFjVUq0iBtxIkQhzvILIU1KpA4RYZ6IApzl+gEN5UrSEDVxkYFXuZXtt9pjJibycqJrsk1bUgyOqWlBRRDnIP1W5UzqESIcU5GVF/2g2eSY05KISMd5viHUk3CI0Z2CtKc7SWfry5rGRDQGpvAEM5Bs1B2i2y/DFFGRgxkh9GwAZon1ig41i6dDpxvjzkDClG6ABngxBqCkVuqGmERNhu5mZuJzlaoNUcyUi1zAwYL7B9SzPQ9C6HYDnCPs9/samT2/LgA7x+AeIzu7O7yGO8ShqwLsCYS6DTg6rsAt1/T6+csf4iq8WWiadjIoeos4lUQ+KMXFldBLRbCayCkVedVEXVBKsCkR3JTIDqqJNlRSCNbg1x9/9afEKDS0R839VqvVOK/XovZhxHlfK9lOIxKiGo/aiyjhwyUuxgrh67N07llBrrieVrPZId8/Fp8+iRu7H0UXn9Z1qEU8TYVh4TyOB2KeRoR3OLnmc2xHhG3mMcW2zXTHJx/owuVHOukWTrIOcZLCcJdF2MWFR+drbpBRRNhlIp+LQAEtkcy3QQHNWDQSyfKdFNEuMMUDpaK9dLLATP+Y7PsB+dKIEpEDSkV8bH7Os30YZXhGB1Eq4l3SWa70ZJlH8FwkL9vrpmL7cTl6wSGHzQ41fv4iZpGnvRRZubnvRpR9hfDq5dnlX95o7Ilte/k96ySpXZzCLRF12Kle/qg96mkpCuSKoBtCaIISdhvEQ56RgMwju2kRZaQYzOIKRYlp1FYUfqwz8VLLzJOFmGAZQBIyNYbl6KyyndhzENdKMIE09P+tzHIfRA3i8XCMDSqY/MKrXRdXoiw2DAr+1IDifVhBpYcWSZYZn8nSgvp0qQnUx7b4Ptc3TaAOHvnP+ANBL+Df1W5aAgAAAABJRU5ErkJggg=="

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABklBMVEUAAAApLzNmdX+ZqrXh6O1mdX/h6O0pLzNmdX+ZqrXh6O1mdX+ZqrXh6O0pLzNmdX/h6O0pLzNmdX+ZqrXh6O0pLzNmdX/h6O0pLzNmdX+ZqrXh6O3h6O1UYGhmdX+ZqrWwusHh6O2ZqrXh6O0pLzNmdX+ZqrXh6O0pLzNASlBmdX9+hInh6O0pLzNmdX+ZqrXh6O0pLzNmdX+ZqrXh6O0pLzMtMzg0PEFARkpETlRFTlRIUllPWF1XXWJXZGxbYmZebHZicXpjaW1mdX9udHlufIZ1g42FjJCFkpuLm6WMmaGRl5ySoq2UoKiZqrWcp6+errmfrK+isrykr7amrqintsCrtr2rusOssKKzs5uzur+zvcS5tZW5xc69ydG/t47Cy9LCzdXGuYjK0dbK0tjL1dzMu4HP2d/SvXvS2t/U3OPW3OHY4ObZv3TZ4ebd5OrfwW7h0J3h6O3j5uPl5dnmxGfn48/p4cXq37vsxmHs3rHu3Kfw2p3yyFry2JP014n21X/403X5ylT50Wv9zlf/zE0O5G8bAAAANXRSTlMAEBAQECAgMDAwMEBAQFBQUGBgYGBwcHCAgICAj5+fn5+fr6+/v7+/z8/Pz8/f39/f7+/v7wsFmuIAAALASURBVHja7dXpXxJBGMDxJyXSas2URFvKinLL0KzcDrvdPCqd8gghTexwpcOOUTS04tD9v5uVGWb3I8wM9aYXfN/Pj2cfdgDq6urq6v4XAc0VgL+mhSNGDHvFjEhYXtSIVl3XIwYR1Q1cTSyiwX7BkM4/VtmAHgSfkKAhcdaTCggycoNhYAz8b6Js77iqzVyhkFvHMrGAOLSWd/ZsK5REoY0dh8qtSVcOroHKnV2nbEdaagUiIuiolgbdhwsKOkweS+hAhKUd+cYHwLWI/bac/dZVtoTmPmOP76u2bacz/lBB5YtDCL18s4JdH5dfT6OSqZSvtanwbKiahSIP5bBYoEIo9S3rFDPpBTJVlpewmEZDE0OmOTSBCH64aE95Sj+wUIiEeshx0iElRKw6XDGRcJif8jfpHDlu7nlCBnK8Mrybl4dOlkPugtkwC8lU1kmj8kgFeeio99Fsei6JqCIPSV8kvmweQkxGeSJ3SQwPzSIqW0OoHXEpes5GlEP9Vgg1Im7WoZIsTG3LQq5uxJVv2FtEJMq3ZEN+/d3vjUs6zK+0vVru7GKxw7Cnx7duTv3SAvhH8l8S9Z8RA6huJJ6pgMXCQDVeRx5JfukV/0eCwDQjn5QvVZB1osC1I79EmrXyW1hGA0HpxTLe2CSwXBR8mq8gbnrxK1Y1SDfEtfeUZplbXME1aIUqNFyTEFR1GdfgDFTXOfwJK/owfkQQOmTeeoWVxEf6QaTPNIffYan5UcvqAJETJvFg/gsWeP98xLKsaw0gcuCqW3poPY0v4UqW4pOk4uoCsU43dNtyjY5PzszEjZJnY2OP7921KDqQdKQbjyymF0rOm8RNHuoAmRaTuGMxXXx5hKcvd9w30kE2aZ8bum9RTaCghZy5RA+c5q/YRdPsO2WVtIGytoorbehnHXXHyJkL+56gqdey+v134w9cGrjCfxVKaQAAAABJRU5ErkJggg=="

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAADSElEQVR4Ae3aP2sUQRjH8XkJ+xK2tXIhWApTaSXsK5ApU56tNgM26c53sKWNuKUKwuCfQjC4GpKIYNyIMSooAwHrxx8ygWMgtw9r1md3sgcfOIznI19mZidwan7Nr3G8aPtGDguw4FZYMFCAmprz+Ec0OCCGFizkFyVQBdSDhzLlQPw4L68TvbjmoQ0rzQOBSzlQ2RnmqSZ6eIXowUashQpKUGPX60MIUK+N8/hqiNGpBZNiIIr9frNJvrlNx6/v0fGzLTp5dDNEYNHJBEKMDIjgpLlF7c59avZ2aXv/gGI7716Rf7JJ+JwDAwUoyEDDAhwUSa0grBTa330eQrAsQU1ReMNWgAPqoUo9kAX6RybFQBl/1bAUKQUqoAU6Ry1kKQQqwAPxpXdoS8QZw1Yz4IHAQw2GGyjr2lZ37m7Rpcsbf+F930BOMJBfs/11V6DOAxlhVk3xqea5/y/+o3yYQFIHtmFE0nGgHCgyxBaLWVCCSqiBIm0cqAIS4CEHJcwARUy8eqRUoEYgXkn16Q+WQMI0KKYMNJRgAxd4oBjnkQ46/vunP2gkojAObA0GLNTgznmeBhWhVfEfimKsgqFv9blAoEmozjio3RwIggW08epaf3ueFWf/cjpzoOJHZwU0C5fXECiW7306orcfDtMPwf1lNfb5+y8COvz2kz4e/aD37VfaPfhyuuzai7C1OIFiDahVYVv6BLdXr0AVqFi45VJiegUqQaW/iniBarBAQRuHkV9FgoFCJN21euRXkWCgEMnFceRXkfQh3V8qq6geJFBgEghkBgsUtBPfXtnZgeZVZEENGijwCayeQQNZoIkpQf2vQNmEt9bwgYIKaCKURCA9B+rWzoHWW86B1ivmQNO/EzmBQGJPswaWUEI9lUAGiMlE39RogSJuhYUF6P5z5QPlQBxCcy0zkPzjXmQuP5D8OSQ01zADyZ9DQnM1M5D8fUhobs4LJH8fckJz1VgCOYlAHXObMQWyHYGWAnPdmAKVHYEWAnMtP5D8hVELzDX8QPIHdSYwt+AFkj+oG6G5ihdI/qBeCsx1/EDyB3UpMNeOMVAGFPFCc7VAIJYm3l4Ccz2osQZaxN9HFphrZQPxv0dkBOYC/0rxB8077mkXvcO6AAAAAElFTkSuQmCC"

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA9lBMVEUAAADh6O3h6O3/rDPh6O3/tTr/tzzh6O3h6O3h6O3h6O3h6O39zlnh6O3h6O3/zE3/zE3/rDPh6O3/zE3/zE3h6O3/rDPh6O3/rDPh6O3h6O3/rDPh6O3/zE3/zE3/rDP/zE3/zE3/rDP/rDP/rDP/rDP/zE3/vED/zE3/zE3/zE3/zE3/rDPy2JP70GHj5uPl5dnu3Kf21X/403X50Wvp4cXq37uzur+FjJCco6cpLzM1Oz/K0dZjaW3/zE3/rDP9zlf014nh6O3w2p3/sDb/uD3/rjX/tDr/yEr/wkX/vED/ykv7tEr5y2bs3rH/wEPwypDn488GAng8AAAALXRSTlMAMHC/39+/gEAgAGDP769gECCf74DPMBCfj1AQv78w388A78+PcECAIJ9Qr2C2jih6AAACe0lEQVR42u3Va3+aMBTAYUS2QBjOojSTsXb3dRdrLWq1XaMc2t1n5/f/MgOZBAlkEXnZ/0tePJ7E8wPlvvu2O3zTPJ7P51++Pnj47u3JC7kU7smnVzFy+/0bTep8fNyuAB00I+bmjm7VeX+yK3T4MmG4um1JiDm3P2lRz492gJ5Gzh0tqXMkDz1hTtFMbVnoYD7/QQV1ZaHX8xsqqtOWhJq/flNhHyShP0DFdaUg4sGKZlsE4TIMFpT1TAZqaADQp2mnS1g3yDx7RHBpCk5qWBB3Njz3KaUjfwhpyxTyIcrxeqpOeIg5pZ1voADSnJ5eBBGRA+MNFEI2DRl5iDggbANNIJdtbEM2gNREA8hnqVnIBXEBTRpBQS2SQsSSHGgIRTlkAyGxs0xX8gwEkoINiLuYTi8Kx/Ep+/NLshOoB1Gzy6gZpA0mYTgZh8EpTVsMoCx3DVkQdRVDV7CpT7kWKyjNIhHkQtzlus+QtOKd0QoEoQiyM1B6sFF+nHAAorQI0iBuGjtTSKVwQVn+kmP4W1IgaXZ9PYNsq2XY9/0gHI5BIjuCakmrCwJSF6TXBZmKVw+EFLUuiFg1QdisBbIVXI+EIggbrVqgOGL2PKsOiIXqgqpug5uH9IpQIw8ZFSGch3C1O/d4qNoqqBxUcT0NHiJVnBbmIWxXgPQiSK8yEIP2GckyiqGd31AuZtA+hzMxg/ZZARsziMsF+XQRhJ0dvrFCCElDqhhqyDoWEUNYk4QQ/g+kZqdHqOcl9RAydZMbiEGirXQE51Yxg0pC3PQs7jcYJBrJwPk8+FeDgwRLaZdfoIllIGyy68xFNOZIQNjVALxG4Zo5AJqOs/0FFy90NkB/YYsAAAAASUVORK5CYII="

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA0lBMVEUAAAC/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVLXnoTXnoTXnoS/aVLXnoTXnoTXnoTXnoTPjHNsKh7XnoTXnoTJfmbXnoTXnoTPjHPRknjBbVW/aVLXnoTWm4EpLzPOinHEc1vFdl/TlHtkIRZrKR3BbFXQln26f2nLhGs0NjjQjXTIfWW2iXWAZ1xfUkzCcFjKgGiLbWHUl36eYE3BkHqWWEbRkXjBh2+ISDg/PT2BQDKhe2vHemJqWVHNh24oDcJQAAAAInRSTlMAEHC/z59gADCPQO8g36+Ar0AAUI+fIO9g33AQ799gMM/v/TqQ3QAAA4NJREFUeF612Fd7ozgUgOFIAg5IgJJlZrOzM9uOXNLr1LK1/P+/tEYyHAGi+PGz31UuwhsfRbLBJ/9PjAu0RXHCYLw0s78nMglNJ+DFFXrFOYSTAtuKZAixEntlQUdjJ8H6UISDosB8MfYq0i4UD52nlTHm9Owbv8QCIskB8sTNoJgPVUPnvXG98Jxc1VfydtXtGJEHMYU3Hy6NMavNRfuCzL6XBNnBUmhjdhBNkMbtJ7PvX3Tdm6Z2utxd5hfZ4RqIqe3KtG360GkDcUQsLJAo5faHHVY3kMZL4/U3Qa4GEojILWTXKrHXWtxBTD0Zv09jUH25bCH3M7PL5qAEH3fA87uPjbTtQd/uodqH/WjYjFnWszmowJUxXx7W67fG9WFkNIKA6VqqAIAjorCQRNwBH9fr9R/GdT+y2MX+WmhfibscIwvFFnq73hWGzvxtJPxDp5tFqqEc32960AVtyM7WlriLgyvbQ9BA2p4p89fOeeecVeeIbCS0CZKYQsTEh94Y1z/rh+dmMjq0jxfICUqxTlQAVVGbzIO+M/0usZvQWifSSQn6afCgH/rOrzcYTHDWkyLwoO/7ziao0NtvKhqnZB70+rwGbu9uW+gep8oYgIwLxCKWAB50WjOfr6/NQgiVBMqDdi/m6/XV9W+zEMWD0FXd77ed95C54hD06urqzzvjt8XZdAA6M71WuKBkCMGL5f99SuVDCE670AUuSQSg1y995xGXJYcQgCdd3iyERAiCH8/JWZoMQfDTz6uaecLllQPIxX/Z4mGxMAQsGwCF0FomWRGGeB8iSvuXlElONzyhoiFEVZkY3kKqqdkImq3CkZIDITEGxYdBEseKDoMiHO0giON46QFQriYguQyilVYj4+llEA2m1VEQfdLneCTECjtYXh0LlRaoIDsS4s0jkpiGUoImFiiaOLWc9r44mV0gAJjZRxoRy3Eooz86BuW01/jJ9FktYAqyDN35TwyGyTxEzyJTD64wC9HTUTCmrCPGIJqb0fNaKI4+VIQh0TioYQyKOlA5CsmCnmmDYQfiYSiuBN3jhCGJLuWgHKcqUpiFMKXNOZZgsACK5z4BigpgAkoHH4I6yJSWGYf8866lkxgvo8Cd+xwUI6UYAKRa9BwsYQGUo5eEXOAwvgQC7kPhtc770NxwCljIKWEZRN+TJWEoXQpBHtdUKYMbUlUQhI7vP8UssXF1UndxAAAAAElFTkSuQmCC"

/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAADd0lEQVR4Ae3asYvUQBTH8fwJ8ydsa6OB66ym0NqzESyEKSysjhQ2Z2PEs1KMnQjCgrZyKRWbgKKFoOGaQ8W72RWEs9ABO6vnr9hifWRv85jL7U4mwqcQGeG+lzeZ3SSR/jk4e0FDCcSUoCHpE+kCA7SEiTXQCKglHWOgsSBQCQkoyKCCEgyovgZyQAIpWCDGQtqHQClkMxpIqAZawIIKNZCCCqhjWZiBBHvN4bUtsvefAAD+TgfnL0n3qeACuaVhbmzTdO8zTY9+NZrsviLEWhaoCjUQHWfybHdhGG7y+i0dXr4eTyB7+2G7OAzGr1d7kGscq4tXafrtuzzQDK68+f/PhXwXy4E4XAXyMM2RXOjnINV0hpm8++gdaCaHZA2MIIPkOAv/AVEMVOCA/5B078EjOnNug4Bu5TvSSHrFcRRYICjkgZimQAjznw97+5JAFtQKA+VAc0biQPRiQ4GBUhAohFFT4IDmjEWBEGUTHBDBshHburkti8N+c6esAGIcqFaBZlcNEfBAHShXsDHTAqZtIPIPtLYbdgW0QL2ugapTipPJR371I8Yv766k4ICWyPw36W44UJ3ftZYrfW/zoY3aCGrhL0p2UESc0ekEYucRfxockFDqf5Lu1thz3BQ/6whl6xiIs2CkGzEU4IA8FGsfiIUqYBM0pKDnZDAG29Ve2CaOZl939J2VBjJA+H45lkAkDVQC4UnFEKh5vBq/ch0CIUoKjj/RiIRqE6hmT1FjCjRqDMQ3Zv7YZxgxdvVwQ6CZpjizW/0QCCEUUBP7+PlwUITmx8/x3Mmq5YGaX5+r7Z2iiCBQwQNJUc8Z30BVBGcgr0BZBBu0V6BRDPtPc6BhzNKTCqQjGC8WaLiKsoWBhqtI8HaHUAHUAzkkXQRSYPu29/BAvlKggGl5IDkT/rlHHkhqHOindnmgCCLVoGSBIojE43gE8mbCjyMPJKXBhrQh+weSU2swchY2IVmnQJxewWc3BzkbKY9AwYSShwkhEJdC8WO6f5JRxnyUggzEX1r/+/IK/Xm/Q0df39Qtry7780tFvz89JayDuxkkXfFY7I2/1Z9D0obHOjGvxUIKNENzrMe64APlQC1kHuuCDaSABIzXuggCkce6fo4Yx9b1OhCnoAY6xthjXfCBDNACFozPur4GcpB1sC7YEauAwEEOymdd1/4BcstUNJHl80AAAAAASUVORK5CYII="

/***/ }),
/* 845 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA3lBMVEUAAADdLkTdLkTh6O3h6O3dLkTdLkTh6O3h6O3h6O3h6O3h6O3h6O3h6O3dLkTdLkTh6O3dLkTh6O3dLkTdLkTh6O3h6O3h6O3dLkTdLkTdLkTdLkTgrrjh6O3W3OFXXWIpLzPK0dbj5OHs0qf2v23/rDPl4dbyxoT9sD/wypDp2b/7tEr5t1b9pyzst273lxb6niD8pSni49/woTb0kAz2lRPm0rXymyjrvH3zlhrj3dHox5nuoEjff47h0djfl6PeaHngxc3fi5neXW7fdIPeRVngoq7eUWTdLkTdOk+S40UjAAAAHHRSTlMAEJ8Av2DP74BAEGCfzwBAIL9w74Aw34+PMHDfG1RRbAAAAlxJREFUeNrt2GlT4kAQgGHUURIy0SQawaMVoxEvgsb1wPsCh///hzbHJLEyQHc2Vftl9/1ITz0wqaKqoYG2sCjE4sIqVgM9YYsouz60LJKWa0MrKbRSGxKy/9Ds1lNnvTZkp5BdG9pIoY3a0FoKrdWDWgY3J7EzMbnRWppXY85M5xD1FUNfEMX1P4IsBkm7MbQLScyqDjlNkI2EGIGs6VSFOOSNhRhDHsch1ZF9fwOgUgNz1Dgd0mBuGhVyAcklQiYGmTTIADSDBG3i0CYFcoGQS4DaFKhNgEwKZOJQC0i1UEinQfrfgzQapP3r0N5+t7u/B2pyQoai09F5UJMTMtRNOoAo7/DIjzo69ACKSTUIAI57J77spHdcTCgQLy7gnUpGUqdecTWOQix/pGfnfqnzs/xhMwIk6/lT6oGMDHkX/tQuPDKkOIpEg5R7zbgdEfLnVAnqz3b6laBgcHnVn4JcXQ4CGqRDUnj9K+5m8KOb5KXrEJJ0FMolJemQIVkwzQkAiJADebd3ZebuFvIcBNKgKLwf/mSG9yEUaTRI9hAMcyZ4ACBD6tIXPj7FzNNjWBpwBGJQ7llEPUM5VhkaxdAIh7Bd5EUkvUApE4Gg3GsKvSqDqtBbCr1VhCwoN0mhiTKwShCy1LwL2Tuy2GDQOIPG1SAHSn1k0AeyazeQXeQzgz6RfaQmhF+tqUClAThzIUueY9osSGMStFRI/UXTdOV3hdsZZHP5zXDT9zLQ9Zgz1m7Ft2SMGUudDOqsGoyx+D6tNmMcWY/VtjJoq+5fGp3sA6EQ1vaOEDvb6LHf2uZ/Blqlwm4AAAAASUVORK5CYII="

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAArlBMVEUAAADZnoLZnoLZnoKDQC9mIRNmIRNmIRNmIRPZnoLZnoLZnoK1d19mIRNmIRPZnoKDQC9mIRNmIRPZnoLLjnRmIRPZnoJmIRPZnoKgYEvZnoKBZ1spLzNmIRPZnoLZnoJmIRNmIRNmIRNmIRNmIRPDh23ZnoJmIROKSDaub1jZnoJ0MSHZnoLZnoKzdF2nZ1HYm3/HdlzBaU/TkXXJel+RUD3MgGXWl3zQim/EcFVqMpseAAAAL3RSTlMAUICvv/+/IABg3///7zAQ/98Qz/+vn1BA/yD//2Awv4+AcEDP/wCf//+P/3Dv70y5n/UAAAJtSURBVHgB7dRhV9owFMZxaHfB+sgirZRahYhophU2rc7p9/9iCyln6SElN+jL+XvP/5zbe0nvy//kSz+KvxENhkfBekcdkmPghLTR98+ERAztlDbG6SdCGbQzakw+HBI5Nk5oa/rBUJHBOKet8WGhstjoRzpzcXl50XyixswfmA5taC7Rcqm1QwN/aECzJnRFdAY3RJb/mBbbG+kREdq2o5F17Q0tiW5syEUWcwEjosUmNGZDI39oQjRKdWjGhsgfWhDRYrO1K7plQkP//s2xmfXHTGiufJakDU0oYUKZUB7XpE1NSDAh5MrjB2kLHdJyOO5s5w6+0pBaoQKOexu6B5CVao+JDWkVHKe0dQoj7xeGUG2pGcyGxDEc5w+kPZyjSybzVaHS2ZgaSx0y5mscbv3zgRqjVIf4kscvMq5aL6SIEchdyk3ahOwr6/P4VNdPj9CeX2rt5Rkbv4kG6e6bPa8kDBlHzqi6o0sAXuutV2i3k2X7zXZF2FEbf/BW//MGTTV6ag/RHQLebeg9JKTiPaPVLUGhfvfHPjwk0I0dzSHRaedjZ3woQgdn/ZIPFejgHGTEh5Tnuq0kILTG3uu25gEhiX3X3aICQvGeEFpkSCgKGK0KCSUBHzsJCRXglSEhBdaxCgpl4ORhoRycJCy0AqcMCxVhn4gPKTCq0JCEXz80VMFPhIb68IpVaEjAa+WE+JOs5BqGXJXu8vlQhIbsWkGmwkNzX2jlhPjnturaZXlIKIcRdcybKSfEH0DR8c9J+JA7m3CPYi0OC1XuFCqzT1F4qGz24z4vJRNy5M4USqyBXPEh51eJ2pE4bfUXkl+Eu9l4KowAAAAASUVORK5CYII="

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAUVBMVEUAAAD0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7rno7KofYf0q7pPRkwpLzPOlKHBjJjbnKmbdX+CZW7dPTafAAAAFHRSTlMA799AAP+PnxBwgL+vUDDPIP//YOThAIsAAAGDSURBVHgB7dfrjqQgEIZhgfo4q/TYzh7u/0JnRbNJu4xdiMn+8bmAN6FiwOput9vt9n8IqahSRyUA9CUhCcBQZpXzIUhkMkTf24pQQC4NziyFvdElbsjgjaB4IY+3wvA+lIwAg38TSgZMwR6FnADbOHwbsgE1pP0mpATqjLYYcqhmCiEbsXh8fDzA1+9DdhLInvP8fFSPaQkppZyPAqvP+Y8f4PNbyI548XMJfYJPbiGNnV/z/Bs1pjU0olVcQ2h3WUhdFfJXheJVIYzDRSGInhHiGa4KyS7gGl2PZmHw0Xfk2kPbNdILtNFbiGxEE7eGFk6gwbCGsmHEaeLlzrYGZ5mXUMPM+12IUsAZovBAepygd6HTM0+F0JkPwVA5RCmiSiqHFkqc/YnYm8Am7FGIJLgcHYY0mAIdhxT7YIxdZBVdPDinYu0iWcrbyOR9DAvtvcNfE28XWeijYxtih6Q9CBnihxT9K+06xyG9zaAEma/YjhwVbW89L5QEZE9lGsIUZvcF8p9JswsNS6cAAAAASUVORK5CYII="

/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABAlBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLDbFLHdlzBaU/h6O3Qim/NhGnh4+bWl3zVlHjezMXEcFXYm39mIRPKfWLbsZ2ub1gpLzPPh2zMgGXg3+DbrJbao4nTkXXdvrHf0czSjXLdw7jJel99MyKwXEQ/PT2DQC/Dh23Gc1mie2lxKhuIPCrOl31sJhfcuqrFeWPLkYDTsKjd2Nl3Lx7HgW3f1tK7ZUvg2tnVuLLZyMaLVkqFU0qUbGWrkY7CtrfNmYptKRqURTHLjnTctaPap4+RUD2ZSjW8f2aYWESqV0C2clq2YEjgxvTjAAAAEHRSTlMAYL+AUBAA36+fQO9wzyCPDQEyxQAAA8VJREFUeF6t2OeOo0gYheFxkbHHfUjO7phzmJxzzmHv/1bWfBRHAuzFpvf9WTSPvoJqCfnW/1hLKcO07IZZpqFUy7Zv2baDNLfVwLJaLtIcgZDn+SXAN1wFnXKNymUPeRpisxmZ6bVRqu2ZNmspoAoxlU1lGQ7m5hiWMD6ZMsRca8a0sbD2jLJcYB40GBQ20FnIVP/geH0cDQkF0XhniNWb9MbRrF4ODaO062RlJpAbCd0+iLLGK1HbwmTQbYGUQFI4wNKtR4SgMmhAaB1YXSJkYEWHEiGDEJ0GEiEf1+JcT7Bik+zGY/gCdRGmTtDgJA3lzR2gK5CNXgpto0HbKTSBnUEqmTkhmiSbgdLQ2jCKggEaNQiiEGsaaiGIemhYL9pBS0NdhOMJGjYZJ+hqyHa2EzQuGTh2DnlD3CSPkIkbZRKyUejOxdbWxR2wumt2aSI6WxKl2msmIbcAXWTQBVjNNTeHLBTa0oHVXbM0ZN4UMjXk4WZbg6chBxjFu3tNHvbebjwCnAzqAvtxHL9o8vpfzG7cB7oCmcBGLAvs/n1Uq16TAeINwBTIAKAXGDBMemEYFQrDXjIEgx4AgCGQq6FDsIP1IFpQsH4AdqghVyCl93rEYTjJ/EKOdaSfrRKoDWA0g/raSYKopiDRUH8GjQC0BeKM37JtRUuUbe8bnwihjVjbwHgZaCzQiO+IEFKovw8giZYqAbDfTyHkkMWTFZ8AOF0OOgVwkjovCHUBWdQjBctBQT7QCSGbR0tWc+Dll7OzLy8JVFZkIB5jQoDw/e+E7k1n3aNSWcH37A6UoZH4R4QepNADKpWV9DDyTRPi3uKHOTSVqFRWHsbSRgXCrkD9ZaG+OLuoQoex9Chz/ilA1ZVHsXRYhni84sfLTfQ45hEm5EDSr/PJctCT/LhIjkCqMNJTDT1LnWdUyitPCwMpDRWe0vMMOr87nd49p1JaeV54QvzOznuVQq+jJXqdOq+QZwjUIbTX53tbHN9Zf49QRyAfTE7Zm3rojZxdMF8gGwxv373/8PFTnfPp44f3796Cwc4gF+yz/D+d/7dzLv91n8FcftWyTUq1ziZYZ85nzddLLdU4l18rnzXlz5GrH+lUPxc5P9NpflzN/xjttlHo1+/L6dmfecyfs+nl718o1O4SsjuodLX597TMnP7dJFJ4QoS4uWKT450wyIwg3DmeLPrKJiRSo+gQstfQqDWbUJ7vYOUc3y5BUmtFymmRIVT+zag+/pZEqJRvqFqsrQzuaR7ELL9jeEpVduoo5Rkd3yJQAzXqX3sUW6wTwresAAAAAElFTkSuQmCC"

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAdVBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWRoayZqrWZqrVmdX+To66Mnahzgo1peIKAkJpsfIaWp7KGlqGPoKt5iZN8jJcpLzOSoq1FTlSJmaRwf4mDk512hpCLm6XbtCLoAAAAEnRSTlMAEECAYDAAII+/z69w35/vYFA02V17AAACg0lEQVR42u3X2ZajIBSF4QiIpUZpN06Za+p+/0fsxJjSYwAhl736u83KnwO6Im7++ydEjDHOuWAslgE2ciYRbynmsnybBIcSnsGk4ElIiOWwKyPfUFTCSf1iV+uhWGHF8XMspjmvEmOIdOzOe0yKsjKGMqyrT8tLED2FBHz8bkApmtqQgRw+WywVjIRi+OlqPOHzEIef0wnPylkohZ9DB1dpI+Gp1g0Mto9QDF+6h0k8hir4+mphko0hDl9tByNxD5X+IQ2j4h5KA0J7GFWBoU43MMqHkMLD+8fl8vEOm73WNcyGEH5cO9cSbD61hkVFQ5fBH1icdQcLbgo5tqiFRRqytIPWPSwUCbk3e7/T+ggbEnLrtd7BKvYOHbXWB1gJd4gubAe70jO0/3IPhIyE3J0WLl6h463T1XBhHqHvTpOFGW1XQ4edvjnDrXSHjuedHpywIpWbAkvNoO/bTo++serpj63e6aVdg3XRMtTrpX4PD4yGMjSLafoaXir6OBJkpLZv4IuTUBZPm00aPqEtuRvwqnzD5lmZ4gUZgJSEKsnxAjGEJCZMVgiXMwAZCcUyQjgxfImc2JxHZccj5B7KSegNocpHiJMQQ6j4ERIkJBGokGNoPkMiZfCd9CalVIDazGdg3ptEz6JCKXENZeSoW4WubHQNleRUkYSubAoJOqdCiGoKzWdIg3c7mkLkq9txpVSapzcZntFXUfxQseTWtymGJ+k8RHapiF4P0RLj1jegZD0kWYE7lVSmI8Kd4eqT0EBkQ0fICEtKjnIsCRIaJYyx29UsrW+JwvATJEQlCoSKpG2kyhmScQHysJs+ici0SkgSMhD5OFWRC0mwMsNduo3kzF+tfCPaP2DtEQAAAABJRU5ErkJggg=="

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAwFBMVEUAAACSZsySZsySZsySZsySZsySZsySZsySZsySZsySZsySZsySZsySZsySZsySZsySZsx0TqpVN4h2UKxVN4hVN4h0TqqQZcp0Tqp0Tqp0TqpVN4h0TqpVN4h0TqqDWrt0Tqp0Tqp0TqpVN4hVN4h0TqpVN4hVN4h0Tqp2UK2SZsx0TqqQZcpVN4h2UKyHXb+DWrtxVZx6U7BdPZEpLzN8VLM2NkaBWbl/V7dyTahlQ5lqR59bO46OY8iFXL1uSqTjJ/K8AAAAKnRSTlMAMHCPv99gAFCf7xCAQCCvzwAAADAQIACPgL+f798wABBAUO+/z4+A388Z8CgwAAAChUlEQVR4Xt3WeZOaMBjA4SCEQBIOW9eq69o96h4J4O2ex/f/Vo2ug7Ak7puOnen095fvaB5QYAw6kNNyPSx2Yc/1HWIOEUNBSEUjGgZ2EONYGMKcgSHGqTgQ5QwGRVh8EY4gEBeA+NdQKECFWsjswCXUdOCSGfKFRb4ZYtQGoswIhcKq0ATFwrLYAIW2UGiAqC1E9VAkrIu0ELeHuBby7CFPC1F7iGoh8Qf9e1B81DP6/6Hj35CJPZQc7Vn7u08/s4eYFiKprZMSPcRtIW6AHFvIMUAE2zmYmCDXDnKNkGMHOVrI/rqlwE3EbL1crmeNGbKJUGV7Z7ltZppF9qMWqo/TElp/QGvTLKY/a6H6WJSntNxlmrPiey1UGTonXTmBQhPZPel824fKV9d5ni/kA/SrPciFWnDdhG5y1ZNcQX/slXzKVTcN6NcGepcF9PIX8n0D/WpAp8p5kVIKYFLKFwWdNqDOVZ4/20HPeX7V2UOldLZQzhwKzZW0OFNOCZWNHhW0gkIrBT2O2mWo3T6/2A6XQ6m6h0L3UjW83CIX5woaDRQ97vXHctsECk3ktnG/t1k5GKFbWesVCr3KWreoPs8FuHld+gS9waG3T1C/OhUZHMqKqtNH7ao0FRZNq87m8nd7g49peJfZQNnd8EMZ9LttBVU61t9RoANSPyYk9lOdFOghh2qYiOyKNBR1dFCgcVqkUksjBRUo5l7SigLPdMDDp+wFUSvxeEyQetcQLp1SwsIQdZBncjxGGjHzpxFkEwXZjBkgzyGGHM8AUQ2DfXIgH2scilwAA6BcxNI6kwQEUJDUnZQhQnjp48RnBBjzk/06vruz44Bz7keMWMYiXy0MYqL6DZTDaTm6ZHEEAAAAAElFTkSuQmCC"

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAw1BMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t2ZqrWZqrXM1t2ZqrWZqrXM1t3M1t3M1t2ZqrWZqrWZqrWZqrWZqrXI0tqZqrWsu8SZqrWzwMmmtb/M1t1mdX+ZqrWcrbjJ09upuMKzvsaAjZemtb/G0dhzgYuZpq6jsr2/y9PCzta5xMufsLqTn6i5xs68yNGvvce/ytF5h5Gsu8TG0Ndse4WzwMmfrLSMmaKmsrqGk5ysuMC2w8y72wlBAAAAIHRSTlMAIEBggJ+/AHDf7zCvIECPj7/PUBBgcICvz78wgN9gQMimjtkAAAMWSURBVHhendjplto4FIXReAZDQsBOZ+4+khnnoeY57/9UwVq0a8nnukTx/WcjX8miVn2w8/wgjOI48pP39iE55rWiuI2q4FwoSGHnnwd1UK9bAh8/BWEvDoPToS6oz/3vWi9hSrMToRzcUh/6Y83MDflN0Kxys3OhYemMUNU+F9qX0AqvBadAHqjRwdnSNrqghJyZPrS36CPg+37nHdBNfUHAv/98/dY3T4s08hug2L0gTHUZjvWaIF7QFAK0rNxBLkERrFa1LTNp64QCsQSF/OUj2K21fUKBnhP6U/uI6VLT4/oM+dahLg7OPWptef6xANFZHMLuonQK2AUEefxy8J7xMmOCElTNimrSNOohanUIGljXRzGUTrq+Qb2IoMD6xAW/erSRppSgJK52vvpmXhCXEZTH1aDNjvFJL2bgIhsyBT9WI122RtOWcW0BSn7q6nWSztAQUp4AJcYZgdrK/tUGQNAELfmL783gyHm6U2MgkqDv4kRnhXjUN3dK7YCBBPV1sYY86Slq3c6VUtcAJOib5FzIZ3GnygD4AvRLcIaFuPVjZdoAgQCF4EbypOfKNAZCAcpA7bU46YUyqQegK0B+w45d0qTvjtACiAXII2gpv3uP6hVqC1DSpgtfvFQ26v8mACSoRzsvPRgmTsh+tnUhP9hYWZBnQ3wAhlt5x3BtQ74EJfGrs9TyLfSkToHy2HamoOZuyBSmZj7GkW6zhWqAqLzVXV0W2hoQn0WGpH5r69alt75q54D62nQD6kpZLU6CpuCe3wd9pdtbXpAauyF2eELmYkP+BvSFHD5DJljvGvdJj0QHNWfigv7bQ2xcg3awLzYOp0EvALpuyL1pt7Avf24AOdt5BoDsTSiC3IROEbw3oQwU3UVqXv2BxBD/DPAvvr2gyAEFkHupTQgZQY5x00tyfQsAaeKCOinkHpRpYhyEBJ08b1wtJpPHMUzwCOJ6cBcmDHERXA1ygs6S0k7ihPi/Sly7cgiiOgM0FucJQWcsKm1VBkFyeastMGGeEOTOj2wrDiqGIFdeFnbjsij0S4X6Cxx8wsZXux0nAAAAAElFTkSuQmCC"

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA2FBMVEUAAACSZsySZsySZsySZsySZsySZsySZsySZsyqjdh0Tqp0TqqqjdiSZsx0Tqqnh9acd9GSZsyqjdiSZsySZsyqjdiqjdh0TqqSZsyqjdh0TqqqjdiSZsx0TqqSZsx0TqqgfdN0TqqSZsygfdOIXsGFW710Tqp9VbSIXsGkg9V6U7F6U7Gqjdh0TqqLYMR0TqqSZsx0TqqQZcqHXb96U7B8VLN2UKyMYsZ/V7eOY8iDWruLYMR4Ua6FXL19VrWJX8GqjdiBWbn///+kg9XJs+ajgdShftSUaM1tLeQIAAAAMHRSTlMAYO+AAHBAn79w759AIABwcM+/j1Dvn78QYN+Ar48wEL8g358wj8/fv+8A3wCAz2D3aKRLAAADQUlEQVR42q3Xa1vTMBTA8a2EtgqdjlWpOFBQ8a7nZL2t7boBXr7/N7InIQtle1gS+b/qm/6eXNqlG+hevVitXn9zbaAvV9STx4Je/Ad0+PJIjONISIfO0CHd/pKun3++ubl550fMpQF7vaKe7Y9hXTiJHaBX5Pz+C/28wLeF2JOj1R/YUujbQV1vQfbr+vpXj4rsoMQD2XVXf4JDK2gfNiFVYAONoTc1N4kgeLDAGErg4SaPBUH8OFPj4EV2i72dSTEvQqvt316JiCX4lg/kdgevIDSDWAzbm6fk5BzAN4PYcBvDq1w4Bb11hhCLvY3RECMdKjKEWCJ/2JRXtChL5yCaGEEKS8TgQgDIJZNXcNuFOaQbeiCdcg7rYgeI7dO2N5VgVIELxDwoCujnOUF7fWRedpOMXaCo5yxzxAYCF4hNNVNnSIHnBH1Yj0YyWAKc2UNvjpHTWBZljrIreibtoWPEBfAGVWkNXWNr6JzuhZlimhnIIusRnSDifCmZdgmqof0aHZxgBVWWVTXcaWoNUe9hI88B2n4kxE7QpI9cYV5MnKCzuwxvad09J4hx7dQNEgSxNUQ7N9Mvv/r1njpAp9hKZikZbAp6Ju0hxJxOpAxvyzipgT10ibiEVDG5mqdvv0anJyWgrKnWCz9OLCEqgYwGUy71oTmDwAFiAcxmBazjOWIFgQPkQ6+U1hxgmqgR+3t7fmICsfHGJ04l/l7Evu/vh+oPggE01AzPyEk5bBbshtiFPpLUpwlPiZN0Jt1wNxT3zhJyYCEnKC9aEE12QowWYtagKCUHKg111VKKdkJnABxlJYcexMnP1JB2QWwP5vpIomiWM6Bq7JoDdbEbYmPa97YGVa4nlCIdgCIDKPLgbgV2AdVb7khAJjunKvXNYm6p8Yj6H888V0tEYZeGrKRWfMFvQFOCbKRKvW8ivoaGhhD7yPWWNRzur9GYmUKY1+sNL0BV3S68d2YKnauP7qLNlkTo7V8Ix3xEXfmnC+jHW3pvwoiZQ0876GA0Gk7hXvPF1y+iwRejviN+H1FJvKg5yMIfVyni8Ug0GNlGg8MTcfnmEhF/ukIHBJ2OpHSMlyNXiHbw6flI5wRRP2k6G/0D+46/vcKcjXAAAAAASUVORK5CYII="

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzPqKuokAAAAEnRSTlMAIIBwEADf/8+f748wr79AYFDG9q5mAAACRUlEQVR4AbXXYe+jIAzH8T9I/WFFwPf/Zg+Xs9kZoN3d7vtwSz7B1hn3819yfgn0l/3QWysQwzcgwCopUERr+wIUXtJCf+T8YodEYgAcnh/tZkhKaB37CiAXuioXbYckDwmVrhjA+TkUGBIKtTYA/t9OhJVaFUD+GNoEkYsrt6hBbkUMfQfHfZtaIA/ckjjSJ9CCFqeug/SAKnMdQSHiygcPSSpE4Q2qaI2gW2L0oQIgvjk8hCgcGNWgBcAhDlBn6194DB0AvOIIRO5At98jSpojEO3oFYk8ANYdgVb02suyAth1RyDMSopjhqJXHCsEcXQo25xQt8wAOO+1DxWLUw68tXUhqiqUnqfuQ1RWzGKPR/kJSfU+edwxat1PR0Tp9D50ICmV1nhi8VS29mxBL1709YdCEoVl7TqJVMgxeKvlJS4H+uXrW98qYQh5WJJl4DgH0IJPi6UL0c54i/cUobUP1n/6vKIVs0+2i41OXz9VGOKkQuLYpZ+xUyurUphA4lgGlWeQOAktzoxJXqCxQ/lykjIwJ9DQKWgtlzcrCzRy6AAQiQLmFYEGzgs49ad57kL8csRcLfd4GUFV3iexW6CtB1W+HcoATguE0IEeh3MmqE4heQct0Mo2KEAtmCA6oFXVGSVqndDaxpBs7WqFUpxCu/y2C7SmUBWomUplBtGGHORPsxVScoxp3gpRYjukSV+CKGQ7pOS/BZHLGHQKZKwMKCeQndoGzxGBzIWaHw6nEaRbW4SUE00gvVL81emIFMjal6Ffl8B54W6L9PQAAAAASUVORK5CYII="

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABBVBMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3/zE3/zE0pLzP/zE3qvEr/zE3/zE3/zE3M1t3/zE22wMbM1t3/zE3/zE3/zE0pLzPqvEr/zE0pLzMpLzMpLzP/zE0pLzMpLzMpLzMpLzP/zE0pLzMpLzMpLzMpLzOvkUPCzNJOTUH/zE2su8RITlPKpUe/y9Omtb/CztaUfkBfVjqjsr1RTDjywkt7g4g2OTXXr0hSWV6FjZPM1t24wchweH09REiZoqiPl51sYDvG0divvcecrbi5xs5cY2i8yNGpuMKZqrWzwMmfsLrJ09tmbnO2w8yjrLMpLzMzOT5nba9XAAAALHRSTlMAQDAAr78Qz4Bw7yBgEECAvwAgcK/fYO+Pz+8wUJ8AYAAQn0C/MM+PIHCv77/wAM0AAAMdSURBVHhe3NJBasUwDEXRvwMvIc9IMkn+eu7f/1I6SCC01sCCQqFn5Inu4OFXyiyUU5gp81LiBLwr0R04V0MGwEhKfQBgpRCuiVMKBZemHxqXWAzJ84Pg4msbPVPgaX/05ZD6M8Y8XVceyrV5b3+GK4QUDjC43U8PVUPSweSQ6qF4M3lHPSQn4fXQTmovhzZSWznUSLV/EDp+ayMjZeWQSP3hh9QGH775wLYW+mKkXJYbhYEoimOMwXhL2YtZTFU2WYRgEnCeDymPwpIxmID4/09Jo0xbmJFSPiuoe+tA96KdEeC67mQyIQj92Aqx/aAEgRAqXdMZ97Dkg+/ZATHy+WnOAtvzDyLfNtWyDWOcAJyxTWZq2f6PaG4q5LsCYARgBbDLTc05iEyerNwXEkYoBZFkX2Ymk+XMNEHFd8U/YLSvLxgN33e80ohmjuVqLci+rkhzedmQqt4Xv7lcKxhMVKMFlxJeRdFViCvDpB7MGFh9CV/hZ9U+wvg6iq7jEPem8hXvy35E2Q0vE1Yo2CqFQHrWEbAGkyRdHdWSkt9UKOIYKQuMhJ7bSHIrTZIcXcrHpejYc7dJyQEa3z9Ekof7mJID6ebu2ASiAERKklekR9N2HjS1TT+r8p6MwbKXcrSkG5YMeBRPz9GB5yfxOGx0q03kaEvLJwboi/iPF2pq+9Z4qU9eW6GhfdW3l3BGnKkmaGJhIG409akDIo2JbsUvbKnGAyLAnfWDBjVm1dFfzVx1IR0Pb+vi7V2cwPvbAi+v56hTKzkbAeNzcSJ//nb9s8HNVlycKvpuvg5SGARiMIzOBWa0KoKKabVTtWQheAhv0PtfpXQTaFpNIl30W7p4DMLA/JM0IXBdZrFlRXFCtLOq9sRy/EOpg0pgOWB5HeRFCHqN04MMBQ0UFBCkspOCAGmPFFQQxIdQVC9IIfWCTPadRD8hhj1nMEyICbcdnAwQbSz90nLSpuGdzQ92/MbggQd7U80fVQ1s5WAzP3Jn9GCCqKx/u/EZgBkiKi/qF1IXOTFWiGJbxvyzqf+DIq0rO8RH6f0nUIfYmaHjPQHLZct5GB7UnAAAAABJRU5ErkJggg=="

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAnFBMVEUAAAApLzPdLkQpLzMpLzMpLzMpLzMpLzMpLzMpLzPdLkQpLzMpLzMpLzMpLzPdLkRKLzbdLkTdLkQpLzMpLzMpLzPdLkR9LzvdLkTdLkTdLkTdLkTdLkRKLzahLj7dLkQpLzPdLkTdLkTdLkQpLzPdLkSlLj80LzRWLzdALzW7LkFLLzaDLzzSLkNtLznHLkKwLkB4LzqOLj2aLj6j6UrLAAAAJHRSTlMAnwCA72AgzzAQcL9A36+vAI8QAI9Q7+9AgL/fz6/vIHCfUDAfARmOAAADJUlEQVR4XsXXa3eiMBAGYIxBRFBb21rFdnubcPPa7v//b2tyQgadEIQ9Z/f9UmpPn5MhM0G8f5MBwOBBRV254rn+OIRzhnjVG+IS4njVGwIVvOoPYf4K8q8hvxc0CoAkGHWHxhws4eOuUKgdIoUdoQE0ZNANGkFjRp2g92bovRMUNUNRJwgc+S+Q74L8m6EwAmeisB2iPV3gD2d/e41Olu/SUghxkMBBCFGmuzxDyQbFQRBfOsX3SeiUEiqFzum7uJTiKIoNxPH0C6cAkKeiFgmJWtIcAKYhnqLcQHCOLnsGsFWLoRDmtAWY6QLgHANFpvNjgB8hCFSIq/wAxGaWIgPJ36YKCooSBVoapiwCBU2rNXhm1mO5oO1eOKFdBpDtpLTfxlXnjnD7I72kV3Rs0H4LKlslvd7dhVNVGUKxhB8fFlhXWgAU6RW0Ax21pnLBZroUbEj1iX+PDqikl1BWQZly7we1I9OrHdG5MKkG4xICFYSxoRRkijshBDpu6IQtjrPm44IoREurlvREh9b/LRylkZut8iu2Tf9SiJabLcz26yyZiWeuVsiQ7acNqbOyQGtBg1BD1hYo6QMlFmjTB3qxQKIPJBDyObaMzPEgB/xwpNA+B8j3pG4V7nvKQajUTZeVBMqlmNsh4FfQEZv3eA2ByvESygx0WdoBTA52SFgh7mNn689NMkdp2K5Nuwa1NN1sHKCeEB1pO5S0lUa3yt7Zc3qz26G5fWjp9rtLsw/tqq0h6WllP0aYe0TspxWzQUn3oU1s0NNzd+h5TM/sJ8jaIFp2xscI4ctQ6oboRqTkuUaetOTwJ61Bn7T4yjBIXI8j2qzJQKqzOvSunIeV6wFJx2fFlOQjpAoLzmtMXI9sqEXvfRiod0EDDatvo2/L26HlG2NsLNWhgbj6miUzub20CZN5lEtCCN9V57fe7A+mEvI65HNevfIsXm7b/peFHgj1vxrCoORuSHTIrGGIREcEHQJRiUIY5VCI5t4N3SPQArHPTTO0+WS3Q2yxXhpIbrBhlusFc0KUmlSrknC1mglhKETzNZlvdOd9nJH55AuBNqh//gDt8w5Nbk333QAAAABJRU5ErkJggg=="

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABC1BMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMNVrO5VrO5VrO5VrO5VrO5VrO5VrO47iMNVrO5VrO4/jck/jclVrO5TqutVrO5VrO5JnNpVrO5VrO5VrO5VrO5Hj8YGDBEAAAAAAAAAAAAAAAA5c59Sp+hHmddMoOA/jclIm9k8icRGmNZTqutImtlFltMiZplKnNtQod8veK4+jchCks5Dk9Asc6kyfLRPo+Mob6Q/jck4hb4lap47iMNAj8tCkc4wYYZLn94VKzxKl9BQpeYrVnc1gLk9isYQIC1FjME6dqQLFh4lS2gbNkoAAABVrO5SqOlNoeHfgY6vAAAAMHRSTlMAIIBgMADvr3BQv98Qn89AEGCv30CPz48w73AAv+8AcK+fIIBQYN+PYEBQv+/vYN8K6fVSAAAC70lEQVR42u3Xa1PaQBSAYXLjkoSQIApUChXt/eaNiBYL6hqDVi20rP7/X9ItJ5HdyR402H7jnfELMz6zZ7NrMLNs2f9LUVVV040UZQxZWpZMy+WVZ0E6OGAVngGZhM/SFoU0ADiqsBhkkkSmsgCkEEnZfHpII9JydlqoSORZekrIIeQ8CHb393tBII5XSgO5XnhFZ93d757PKC0JFHIWcfIJyCvTZHthD5MKFnzu2ALkrVCkvYMj+A1hn+wciVM5qAIMVj+Y7hMn6Q530B4gdxUTRMqxuRspgdw1HOAotvFVmUO0CKrV6dM6uCEliVM0MoiDttezko5jABTNNRpPJuPRo9T9i/V12yF8egQ1wJlM46XtnW2J9LLWzBFxMIBadNoYoDF9qOP7fkglvSJCCkAubFB3EkUf2mHQIZUVigsCaINi0Deftf2opAPUphQbjR4z6DuVdnUze2QAbVIWstkdn9VHHl4M5SMIbhjy+AcMOqEQNp0CUI3O6xS2W95uNBlArblQyKAz9JAfwWQAPXLp403Ch9MjqDEfOoQDgMSWZBn/AuoRkouhrfozoA4hagwZ7cbi0DkHsZ/XXRw6g3srr09EyHhzQZHufBbFChhk8tDbyfCSSoJre4wwcEmyPPSOXbEfVNY1g06x1cK11Tno/YR1+xOZrIOc6+hVXuWgD8yRLupkzg3pEciaQd7HIUjDLhUb4JN1SFwphrbYx93Rr1smjS8TW+33cQcqxlCLQpcXv4ejxGm8RvaHS4mgNn6skQV9Yo7kj7+xikHh4OyEJiu7juR1BC/aFNVbzaadFSAToHRSo91k6aKkAZSYDq/uNSFNgLI6g6DK2lOYTbcZp2UFSckgXyDnM8npigBBlQ2Kd/eZMUKKI/vqB7leuS49gGEAt1NMRVYEVVrlFQHp7wdkWvKfLaXI7ZG0WsXb/Jv35Su3o7aRpPImIVbVNmIIT3O4u4DGQXh6NbLMFBCSXcqrqlpKCeEtoSUk7w8A10RbQdyoRgAAAABJRU5ErkJggg=="

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABCFBMVEUAAAD/rDP/rDP/zE3/rDP/zE3/rDP/zE3/rDP/zE3/rDP/zE3/rDP/zE3/rDP/zE3/zE3/zE30kAz/zE3/zE3/rDP/rDP0kAz/zE30kAz/rDP/rDP0kAz/rDP/ykv/rDP/zE39w0T9w0T/zE31lhP1lhP0kAz4pyT/rDP/uT30kAz0kAz/rDP0kAz7uDf7uDf/zE3/zE3/x0n/tDr/uT3/zE31lBD/rDP+yEn3nxz9wUH0kAz6ri3+xUX2mxj4pyT1mBT8uTn8vT3/xEf7tjX6sjH5qigpLzNfVjr/vkL/wkX/uD33oyDywkv/xkjkuEr/wEP/yEr/sDb9uzz/ykv/sjj/uj7/rjUhKmbSAAAANXRSTlMAIGCAv98AUJ9A7zAQr3DPj59wEABAz58gEI+AADDP3+9wAGCfACCAUJ+vQK/fYAC/cN+A72ryvXsAAANCSURBVHhepdhnl5pAGAVgbCDFVQO7MTFmSUwx3ZTB2svWklr+/z+J3CMzzgwGGe9HzplnX+7MQVgtTTLZev60s86pLkXT902rCANRh46LFlWKrYauBjlZNkvnbQaAAuTULcZYLQAq0BGYTU4auiJ0jIKp4+hqkPOwsx0LjgLUwDgsDV0NOvp7/W1BwnxfXF7/6NR1Jch5dUW4/Lz34NF/ou24bj4mfIaDweD+i7SQWxGY0XiAvHS9HdHiLtplwZkFYMZzUrBTQKYvOEswwQrok6ex0eRLTRLrjEdwVsH9PTva4ZyBGfXCzveC7HhnCWceAH32XI4mXKiJ/fQDOJGJ4bo5vtMyIaZQtivuV3fMnCGYcX9NGlsOjkpOgKpEyBnrZwVn0g1N3+WWSBMZotMPnZ7U1XL6Ouq0QhCPg1xfhMJNCrogmTOfrsU33B5XeagkOjO6uDuFw0Z7ByfaG4ODTBI3UI91NWSVD3rvP6zTJkjB46CC6MzDFXMcxNC5IRgSzChc7EWHN8dBOSJmQgeaRF112bEy2Z+uAdrZdBdr6EAriNQhVTpQyQPEH6Hbi/Pzi1u64QFtaErtM4IQNxqouQ3VNvraWUv0fiaAptFAq80tItHp9T1Awpk+R75Gy2f0DGF5DwMJqW5DJuEgWgzwFS09FPsiZGxDbSLd2ozbsyGgAK0JAaCxgcSyh7TXHo4T+g+Cpei0KYSB5Nyg4c0cgxHZldwWZAqGMAfK2hmDQhhIzhSQ2Iwck0FNCWFzsGaSIdtPgJBEqIajeDhUiUXkZhLLjjWSm5G3v02UIh9I93BpU7Z9MGQAMtQBn3uM+MpOwYjAA6Gcxz1q7YKi47viw99Q27ePnvxzpFJ42Yv7gWymdnwbC6WfbDtt500PkV8i7HLKHdtEfq1xqymcqkcT86JlFBSc2Fc/t7J/Pwkvo7VSMoOvkcTXY89Moiruvh81taq/m2mbaT6z3OanZCYZQj5/ufolKOVcDUA6yMsUO7//XC7uYNwtKk0oaSHkON9hyTt6QrQ9/w1hZVUhJLtF5RvKEKgTRhUzqhCCriilCiGZosVaz6pCiJNlY1nFVkYRQjJHsDZYSxVCnFY9bwE6laF/oVTTM4xAauUAAAAASUVORK5CYII="

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAArlBMVEUAAADBaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/ZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLUk3jZnoLZnoLZnoLZnoLZnoKURTFmIRPZnoLEcFXQim/Ym3/DbFJ1TEHKfWLHdlzGc1nJel/NhGnTkXXVlHjPh2zMgGUpLzPWl3y7ZUt9MyLBaU/SjXK2YEifhuLRAAAAInRSTlMAIHCvz59gEACA3+9Av1Awj0Cf73AAIL+AYDDfn1DPEK+P+RgrdwAAAjpJREFUeNrtlGFzmkAQhkERIhhthFWEIhpOTUqCbW2y6f//Y70yFw+EW862M5nO8HzwAwyP+97untHT0/NhmIOhhSXWyHZu9DAaT2wLawzt2mtzMBZyWmS72MAbn7+c3CLHnXaJZqIahcr5hAKbFo1RiWfX/salRM4tUli2h1oix0JN6GgzDxsQOZUix0WK+yy7lwNhKtqvkSvjiGpGJjWQQ9QW2dRkD5CjG23kKEWmOOjH0+kRu7FmKtH7AJ04f9O1KSpFL69Z9vqCkpZ4d3OfscAAABdRFY17uImKt1iy34RcNKG7xfl5WZ+Mt/JLT1nRqFPUXt/Q4R4miLiI2g35abM+dCdnTwxchAQyTK0+wc5ngjkYU3LJ6KPfs3cCMJCEHobDWXQHhod/zAOrij5/eUAleZUnQhSBwX/3z1jlKc+LYn88sha+Ho/fiuJ7XvJcq4j9E1bXig45z3tgEtn+JL5GlCMnZ5LqQIKGqkAsGAdLfoin6zCorgjMGY0QSJGIswCA6tJCoi+S0ZYRlFSuEUi1o8nDDuCMvNhgw64kjuCSUrS60rNMoV0EPmvnbYe4e2sODahEW4UHSy5MAahFi3bRTtxfF9tAiBSjhILa+QApWmiLWEqKYKsdLaFFqa972CEtgkS3/UtKJMLRiJrjLhGsO7YiEtdNpyilTJsUIC0XfU2LaJMvWrWKyYGUJsUVt02BQookSW0K5E14tQjSsK6KQ0JDiTjJdi0kmyACXQyg6UW96P8U/QJorhuNVrpUJwAAAABJRU5ErkJggg=="

/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAwFBMVEUAAAB3slV3slV3slV3slV3slV3slU+ch0+ch0+ch0+ch0+ch13slU+ch0+ch13slV3slU+ch13slV3slU+ch0+ch0+ch13slU+ch0+ch13slU+ch13slV3slV3slU+ch1RhzBzrVFzrVFViTRajzlYjTdEeCNWizUpLzNThzJ3slVLgCpAdB9RhTBGeiVckTtPgy4+ch1lnkRQhi9JfihzrlJXjjZMgitHfCZQcURelj1CdiFNgixwqk5bkjlTijL1U4vpAAAAI3RSTlMAUJ/fr0AAMHCv3wBgEIAQv+/P71Cfz4+PQCBggDBwv2DPALydmukAAAJySURBVHhe7MAxAQAAAMIg+6e2xg5YAgDA26nXrkShKI7DakBmGHilzOYS2NQJOf7VJhqovv+3GtYecG85lvR+fi9cywU8bOCs0+6cqCLLdoxOu2c9UL2z7un5B7Xo1yWFcveV/gUhXO+i/yHk+USwJJgBjAaSkpA3VLKRt3PGkpHU+ABUOS/39y+K6lTjTBiIl1qvYqYmfROyFHVftDdSfwpuqYuW4KZ1qWUrCVFtw0k1lZoSQxYx8tFUUDlZHuooBbDQ1AJFdwsd5rEhtZSZX0CFg5yuDmkgHulXIRI/bQJd0nupoIcKegDA5uVx6IodvQL0LoaiDLiSkH8ImgKPuuwRKUMpqyEwldDsxJSugTiqoAQrhlZAyAdwvbcg5wbVowcrixEyFAroAehJqOjmW+D7/IxrOdAC0CJ5iwwYC4ibl9AG2IoZMgllyDW/PZwdhGaKeoL44DpHIqFEQCGAPkOiTvVk0AJKJZTKvwDGByGboN9AYozArjwGXDIkoxf+DOTNoBz4zpAxUvYVaMCQMRK+AsG3/u3NLWcv24RqL7sOKaVObBNyLILEtXH988dSBZ5oBzMhb6RQFIqFjYidCMBCriMoqmNATpugOC9P3/KGUm3b2/IWecyQmhuQ425QliVJBsidIKJr75IkQdmmhEYm5PxAvWxJVLSMUe/q3HYDv5AY4iZo3ERuI2bdARo16JLBkFG/u8XRtn9+3nKt24PdqNf12/uz5CTx/P62flVK3TgUr2yjQO2aO7XmfCw4CvnNIP8opJpB6j9EuXXI/QpkMTSrQzN2rKOQzed+dhfbgIzaQ2JGgWdCXjAiZtgW+l8h6mIDzZCs2wAAAABJRU5ErkJggg=="

/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABF1BMVEUAAAD/zE3/zE3h6O3h6O3/zE3h6O3H0dnh6O3h6O3h6O3h6O3/zE3h6O3h6O3h6O3/zE2ZqrXh6O2ZqrWZqrX/zE3Wvnf/zE3h6O3h6O3h6O2ZqrXh6O3h6O3/zE3/zE2ZqrX/zE2rusP/zE3/zE3/zE3/zE2ZqrWZqrX/zE3/zE3h6O2ssKLY4Oa/t46wvcfSvXvP2d+9ydGisrz5ylTG0difrK+ntsDd5Oq3tp+zs5vCzdXazqPl5dnMu4GrusP403Xq37v50Wvn48/014n70GHw2p3jzpPu3Kfj5uPs3rH21X/9zlfp4cX/zE2ZqrX1lBD+xUX4pyT0kAxmIRP3oyCMTCL1wUn9wUH7tjXmxGf8vT3st0YbdvhxAAAAK3RSTlMAEGCAMADfr1CPzyDvn0C/j59wYABA799gABAQ769wUI/PgL+AnyDfQK8wl9ktIQAAAvlJREFUeF680EtuwjAQgOHYErssjGhwSytChAlNDjN2Hrx7/3M0NdAUD3ZskPovIksjfZpJ5IxQIcpRVykEJSNXkXPKoasgpIAu/gQktMTPX/E4lLIMfstY+hiUixiMYpEHQ4TB3RgJg9IYLMVpAERW4GhFfCGSgbOM+EE5cpCU2yC8T/BOGNLOoDQMMfCKDUEJeJYMQNwX4m6IgnfUCXF/iLsgCgFRB1SEQIUdIhdgt23b7c4A8IQYEL6sczrJMPCEWiF2gVrdlwaqWjWNqis8AWaFljeQdvaq0am9OQFYWiF8QKUdLVX4aCuEf2nd/Fb3k2EIpXpIASoAav6EofxZ6N9OKzF06KEDhkoLlADutDkzmxPgkrvQYjyHwObjycu16Pr4lHIaCk3l2oBe397XUh5DoaOUkxto9jFbSCkhOPmz0nendLOcNgxFATgzYpzKDHgm7cJXIzbddHGB0pak9IeWlp8Ahnjf93+QSlpcS75OIvlsNN58c84dKwUmN2BS4q1xpunQ1Fa6e0OQxJmB5unQ3FbKBUEF4se6XqRDCzPkPRYEacRPdOvEa9efUROEJl/qZTq0NNAMMYDuH5565KH+ig2kLLT61gf6Xv9oQ/izDzS3y8JpuO4D/fqNDMJNH+g+gLSD/jjg73aXAq2Mowkq0GVvgEPaxkc0KQiS6HI0dewbU+l4OlfmOVtIElSiy+mAsWffWMBYJ/uWBCkMQ5WO66bd+dA4lzV6UQRBTkZQqbL1HOVG7JthvpNDA5Wdlfa2uKOcg9dgGKX0IKW7Km3pc3d2b9U1TCsPghGrRP19/8KH4Qh8aMgrVchz4MP0MIBAtCvZA/Hs28NQQAiprFVpi125todlqgXBGKNShcNwDG0IZBS0DodJ4BAUmJwCuiCVpzq5YhBJqQ6HSEp3OARqEu9MyCHIj4h1RMBwCAZZDJMNgEEsQr/GaAEQAYGSL1JaKoiBHCWeHZgJj+EQz0B2WJlkt+EQz7AUBf1ZeSHKIQHRUHr+AxfusGMNS6O3AAAAAElFTkSuQmCC"

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA2FBMVEX/zE3/rDP/tDr/xEcAAAD/zE3/zE3/zE3/zE3/zE3/zE3/rDP/zE3/zE3/zE3/zE3/rDP/zE3/rDP/zE3/rDP/zE3/rDP/zE3/rDP/rDP/zE30kAz/rDP0kAz0kAz0kAz0kAz0kAz0kAz0kAz/tDr0kAz0kAz/rDP1mBT/xEf/yEr/rDP/sTf/rDP0kAz/uD3/sDb/rDP/xkj/vkL/xEf0kAz/tDr/ykv/zE2MTCL4pyT1wUn/sjj/yEr/wkX/tjv/rjX/wEP9wUHst0b/vED/uj5mIRP7tjWtOfezAAAAL3RSTlMAAAAAAJ8gYBDvj2C/UECAgN8QcL/P769w3zBgn+8QMM+vv1BAQHAwgIDvUN+P3++EAF4AAAJHSURBVHja7ddbV9pAEAfwRbu5ERIiKmqr9n5v4yghYw0QWqTf/xt1TyIY3OyyO+WcvvT3Ni//MzvAzsKe7cj/oH8d5CaI4cBjzBuEiInLiDysxTHWyEHhETaEIfsL4nRCfS46z+WrnrjrMSqH4wbu7CCGHtXzsYXfY5YCVAiYFY5KnN4PvaceahnPyfFRy3dIA6KPycGtHEJD9JY8NOCx7Vw04Fqe7O52uby9Q9mQbde8y0SOSKKM++L9S2xYVn6hLGZa786zTA7CFr523M8zARVHs2jpMquCpGFb/05eS0E6mpWSmQVdY23AVM6roJ+ol47xQaSc0fdM+I1aU1isxxSpP7ZXWfYDtYp1kHy6s0byxZuP+gFBMwjD6DElSBBd42vkvgpqSAI3iqJ46MvfLkd/Mpih2tD4ZgOAMarFxpc/CLog03U0AWFqfuEF2o5SVIqMFwAIZY4q5ku7AGGBCkPjZw3eVy1NbHaCxxXfbKHIrbaU0xY1BvW8ueYxGuITI6iMc8vV4rZOSbgayQ3ZLfC8gNrs2uq1w+WkEh4U84n5GndQMilg7Wq2mI5GI9EcJ7xy8jE8dcNpD8GbEjaUn/ZX2L5KD1vkaTPq8O3eGttTCrBNPp/VWV+/feg0sI4aRw3u7eYBP6D8xZEdnTEN47sgcXfy/22adjstWGerMp1/xoofBr0S4AsxCAD6UkUMOpUqu6A+rJxIlVUQPOpuVvQg2KyoRxNERQ4SDg6h9kKq7IK6UDntShUl6PhEqihHO+4fyJXsD7434RYNvFxBAAAAAElFTkSuQmCC"

/***/ }),
/* 862 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAhFBMVEUAAAD/rDP/rDP/rDP/zE3/sjj/rDP/zE3/zE3/zE3/zE3/zE3/rDP/rDP/zE3/rDP/rDP/zE3/zE3/zE3/rDP/zE3/zE3/zE3/zE3/zE3/rDP/zE30kAz1lBD+xUX4pyRmIRP1wUn7tjX9wUH3oyCMTCL8vT3/vED/sjjst0b/xEf/yEoZpBN6AAAAGnRSTlMAEGCAMADfr1CPzyDvn0C/AIAA33BgEL+f7wiS4KwAAAJQSURBVHhevNfbiuQgEIDhuRASOyDYRZlIJd095z28//ttI86YTsWUOrD/reHDEgz49H9yaK0631PWojsf9XS4CnSvc66je/ADyAYJgge2Her1ib476b4NGqynTd4O1ZDTtJt2dVDvKZPvKyA30UGTK4XciQ47uTJoYA6TBglK+xH3JEPBESUZ0lSUliBDhRkBglIIjiGk4vAQgnIIjiCkivAA6mqgLg+5CDy/327vzxuAr7gNxCe7O3dpY/AVzEI6QrfQ7wBcrss8L9cLXyGdhcYHKDivyxxaXrcrRGMW4gNcghOkCx9ahNKRXufvrmlFhlhLghZK1UPzKg4NGcjUQiYD2drRbAbqOPSSoBcOdRmIdvp4m0NvH7TTPmSoOrML6XpI70JQD8EepKghtQNNLdDEIedbIO8YhNQUMgjaINhCPTVmNtDYCo2PkKHmzAM0tkPjGkL6QbiCgGJWBtinkCBM25Rn5J/iF+QgOl4lUx5I+QjBF9SvaShzYD1IHyG73qItg+z6SGyEMDlxTjFw6wuKAYoXHwy/vfJdNRB+ARE6q2kKK8W3ZUxf4zSp3BPCS46XnhClf4K+9JmF0gEJUAolR4ZkCevetAr2GVC1r2xnPWe8dWcZ4tRmVxAZEeL9+vzzl0L/OiODFQRiGApuE8ypS3PoaX5A0f//P7GhuF4CZm5DYOCR1/P+uGUc6RVQXyjgGYdnABZi1ZCymR+dbPTPEF/EXS5aD/Fr5WkRKk0L2iA43U+C0QpfExYmSyxMqqE+t85eDbVB13Zx7dm0N6LPuLcyirxCAAAAAElFTkSuQmCC"

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAzFBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkT/rDPdLkT/rDPdLkTdLkTdLkTdLkT/rDPiP0L/rDP/rDP/rDP/rDPdLkT/rDP/rDP/rDP/rDOgBB7/rDPdLkTOJDvdLkT/rDOvDyjOJDupCiOgBB6gBB6gBB7dLkSvDyj/rDPdLkT3jTfoVT/dLkSgBB7/rDOrDCXOJDvZK0KvDyhALzWzESq3FCy7Fi8pLzPKITjSJj2/GTGkByDVKT/CHDOlLj/GHjaoCSPjRkHqXT7yfTn9pDQjOGKtAAAAKnRSTlMAQK/Pn2AQACCA3zCPv1DvYJ/fIO8Qj0Bwv6+AgAC/QADfjzAAcADvUIC7SpVwAAACfklEQVR42u2W2XbTMBBA7UR2ncQuTmqTUNNSoNSGkZx970KT//8ncOREsdFa3jjct3m5RzMajcb6z7+B3QCAJnLcGxOsmzouHEHe34qYyjUXMRJgtDvmIkbHD5gqQJlrKGJ4CM6JkPcmkcs0kmKpRVkEHKLMVOSDgMRMhEAIMhH5ICHRF2UgJdMVuRFIiVxNEQIFSE/kQcHTZLGYPAEfT0uEDp7FAYEJqUTs2U+oaCKsklrkQMGiRHhxahHSETU0RE1JagxPIQq7PQBxsRmJTHTVTQkhALLrZ+UWiuL3pGAPeiQiUT8lRqLI44tCcgQ0CfiiVF+0Aso3hegnyJmNocTmia5uSckrSFni9alMNvfWwh4V7UBKTkXc7Do27aP+tfraVvhcBIHNLH4bwLFoEIfXitzmVMRo+45t20kjot119tb63+WZ4SmIaWiPWozxWNbv2sMf/0YtUn9H20K0BCGO9gdZiGYgxNb4sploMwIR+ktEXpjWwkvTXmtgfjjSVlQi9aLFOrsgFyTnilY/zqnGWFxvRGc2BzcLoMYQHxjzzuRVRYqWmlPTy5BzoJpI3uWjHFOmq/oUr4qUHTXa4JL8eQuV4SQTeZx3kuMTL9P1cjgcrmhiVZG6yUdjXOcRcZdR5Sx43FQ9m493FOtOTAYcRrNz1YdPDyXWgwQfuKrnKXV9/vL1/oR1LwOBBCTd/NWzgF26WqSeBdDs3KhF6lnQdjg/rRKvrvqxG1z8gXWhwX73+o46osDP9oRcvlFECGnxI3NRrxoZi1rkyKAaGYpiwgirkbGIUY2MU2PE1ci02JcpoXRrkamoXJ97IScyF6WDemQuim9J2oprEYdf1alYo+4aUqIAAAAASUVORK5CYII="

/***/ }),
/* 864 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAzFBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzP/rDP/rDP/rDP/rDMpLzP/rDP/rDMpLzP/rDMpLzP/rDMpLzMpLzP/rDMpLzMpLzMpLzP/rDP/rDP/rDP/rDNUSDP/rDP/rDP/rDMpLzP1+PrCxsj/rDOpra9cYWV2en7o6+5DSEyPlJeUbjPc3+HKjTPXlTOCh4q8hTN5XjM2NzPypDNpbnFEPzOhdTNfTjM2PD9PVVi1ubyHZjPknDPP0tXHoGXtxYr60pecoKNRRjNnqSgCAAAAInRSTlMAUK8AML9wn9+/gFAAj59AYDDvcM+A3xBAICBg7xDvr4/PQa/tbwAAAyZJREFUeF6l12l3ojAUBmBEduvGqIjajr2s7nbf1/n//2layeGGQhbq+40jPudCkpugiNJQ4StqoymIwv9Z04FE146BDKBi/B4yoRCzNoROukokJYXrxEEQ3ADc3u2iLCPbaZ1URjlhpQ0AwVdCgOuokE63DtSDHLqPfsbuS0Oa+w19Hh7tX1TOH1loAIfcrJaAj0anIwcNgc5lldSSgTQo5ur5YvcTcmQgHTjR5edRD7jpSUNWBqwWKQ2ki1UGWTIQFvTwPa036TJTlunm6zJ+YJakMAt6DbJswjgON+TilVmSwiooDioTY0kiKJvT+4CR/TfkanwInceAmUeUeJA3wBdUDr6mgceB0EkDTlKUGBA21w0P2mC7ZEIGYEGiksBgQxpgQeKSQGNBHlkaSSBIkkGWx4DakCUWQTFkaVdDYyBZiKAFkIwrIQvwyeSeDawqKO+uKzG0ApJhGfJcIAnFUAgkrleCsN0HEoFSSUqpoKUMtCyVpJQKSmSgpFSSgkOG77rG2warCDXgtxA0CpCJ0KcM9ImQSUMeYEIZKASMR0G9Y6AeBZnHQCYFucdALkIaHAOBlkMGQP1Rwxg5pALUn0cYNYcsGtrLQHsasnIIlTprDUMg7LFqvdWv0h1XoaajlYkL2X40tqgpqVAtpDGu1yHHDQINESKHzHo9u9nUaSi/9An0KIYSAvmkBIQIq0vva+TvwzI0wMUr3mlxsQ4QyrZq18d2It77sX34LgC0CWTkRzm/zmnEz4+KBoE8XdVwD5A7H2HX11TdIxCVofyJbcg9+vkge4YEnwNh0w2FPc1s8iHfBZlzNrg+F8JuuRd0IkP8CWEC91sEH4wHTVqOMz1DieWcTR2nNWF/ivajQy6JxHQus/v6TKgbZbm4wn5S7h5XF+S2LhM6nRHpen17GLuQZsLDeN2ur4kz43xl/43y7J7vASB5CkieEgC4f97hHX850Dwq5GW7Xa/f3j8+3t/Wd9vtS1TInAOdR1Wx7agq52xoUqGM5l+D05+PKqQJf9QwM5uaLJOWY88Q4Y/aZESKtjvOtHt6Usppd+p07HNSa6Gi/0b44QTMHGIhAAAAAElFTkSuQmCC"

/***/ }),
/* 865 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAkFBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWTo66JmaSAkJqDk52Wp7JsfIZmdX9peIKPoKuGlqF8jJeMnah5iZN2hpBzgo1wf4mSoq19i5WEk50wNzspLzNvfIRhbXQ3PkOLm6V2hIxaZWxMVVxFTlRTXWRkGPEvAAAAEnRSTlMAIGCPv9//ABDPcK+AMO+fUEAI4HmtAAACc0lEQVR4Ae3X23aiMBiG4YTNhyAbUcFQW7tRo6J17v/uhjbQ8E+0knYOfQ6zygsJy9Cwu7u7n+OO6/lo+J7r8OA7LLhq5IQgQmd0O8SjsQ+om8fJRyZOYUjjj1QSe93fjiNOQjwD4ccTHxf5k9gHkXEdivErcRfK8EuZCrn4NfcjlEObzubzeYGbiubPZlNoeRMK0SrnC9GoHnDTQyUai3mJVhiwBK1lJT7NMMBMfKqWaCXM7TpCecQgj0LpSi7zyC3EosQg5UKQCXgMSjf+hIGeujtDYXRiKwz2TCfH6OgUg02F8kxClfUDAav2zZGQfiD7R7oQeoGVFxIKe6ElrCx70whZpkMVLFX6iTLm6NAKllY65LBR+jXdJSwtvxY2HTG1rRWiUcJSKRqF2tpYMErbV/kKa6/tWqejJhREarp0id7W6zcQ5qi+KtJ7dlmJAtpmK+V2oy7e7fe7NzraKURV6j1blZ7ID/8gGwc01lvZ2K7JqNJdlOnvWgyA7MHyUw0cZeuoR/t7PIC4/6XlYygkBNRb2drWerRvzP/59vMIPSfZOAHv8su7HtUibv4TkaBvfz7vgY3s2XSjPapDQzlMJ9nzB6Z8YOggew4/D20ksRkW4jAcJXEEZa6RAsNeEnsYgkuh0D4UXgxl9qHsYmhiH5rQUMe3DfnB5ZBj+9YcGrq+3LUkanOpr4SSFNRZ9pxBpYkZurbe9EdrrjQJEXkKYqf3ox2INP/+LMI9EPVJ7a+nGoTHbx5qHB83+c6g05ET4luhM/iYlUQervCixPK8lkeh8ShRbn/wo8ulF8YqpE3cdo6eO9GjFiF799A99D/8BZ3Or9j+wLu0AAAAAElFTkSuQmCC"

/***/ }),
/* 866 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABMlBMVEUAAABmdX+ZqrXM1t0pLzNmdX+ZqrXM1t1mdX+ZqrXM1t1mdX+ZqrXM1t1mdX+ZqrXM1t1mdX9vfoiZqrXEz9bM1t1AR0tmdX+ZqrXM1t1mdX+ZqrXM1t0pLzNmdX+ZqrXM1t0pLzNmdX+ZqrWerrmot8G4xM3H0tnM1t2ZqrWntsDM1t1mdX+ZqrXM1t1mdX+ZqrXEz9bM1t2ZqrWvvcbF0NfM1t0pLzNfZ2xmdX+LnKeZqrXF0NjM1t0pLzMzOT5mdX9peIJsfIZwf4l5iJJ5iZN7g4h8jJeAjZeAkJqDk52Gk5yGlqGJmaSMnaiTo66Wp7KZpq6ZqrWcrbifsLqmtb+puMKsuMCsu8Stt72vvcezvsazwMm4wci5xMu5xs6/y9PCztbG0NfG0djJ09vM1t1pr2RGAAAAPnRSTlMAEBAQICAgIDAwMEBAQFBQUGBgYGBgcHBwcICAgI+Pj4+fn5+fn5+fn6+vr7+/v8/Pz8/f39/f7+/v7+/v74qpcxAAAAL+SURBVHjapdf7X9JQHMbxp5FDCcJaJMpMi24ETJKiiKR1sdQu1jfNLpSWnf//X2i5OQbPbuD7Z16f1zmHc842hJlZaHRt2240lmZxBrM37KG1qVPn3IyvO4OpXOzaY65hGks2aWAKzrRYY3a6DutewmQW7AjdCcfUtaOsYSJ2tBSTW+73r9MSTTOkvuNqoWSa5t37b6NLMwijV3siUiuehl4rz4/I1ALAij1x1TTgUb//7Kfy/Tn49HbLkWZb5sVXBc4vP/6myC/aAWBtGSoCKCl2kGKRihLQgsNS5BOFLlCoIkFwZDZShC5SqEkh5Ki0RaElCtUoRKXEEE+tByqlDukSUIUns54YItXAgHT4zIlDWssPGQjIWgkhLnljaucxKrvqTvDo8FVoiD0cfNm/aYAZ4tqm0GWAzStHJqYjOxR6YoBZTqcOpvfE84FCIhWMW1SOAmL/z/HOSxFZgW+4+SwwXYY2x0I74jhUSnWsujmfgSPTUY4cWFmGdkc7zz+K4/Ox8tQLyJ10TAzxceb/7b2c+Kp81obyJsZ6EvQmMJ534jlWI9YzCCOjdjdfuOu8vSunvqsgK7yjS7I9FWAiXF5S+EudKUNHyldHlAlD1llDPkRpTxgqIEJtwtAiIhiS7FilWG1NkqmADqJUJcm+CsoiwpzE4SNSmmRIvNadUkm57iKK1ks8avUSkKFFIkWJdc+9G1GnRSJlidHT/MeQax6YapkqOLXhhlYRY0WitOBb9W5IxDFoxfmNI6tcGcSZa4V25hBg0blNO6iWTk99viXZlcO90eGUMaZDl1uonFK/B/unlZoB4u7uDSRRJ45v5/N5Dcx/p84hgZW440z6QSiTzgAPKdVqF+hUEjPVauPp4WBwdAdxOupo8MDQQfh9tVdBjFuf5b9mTEpvi6eJSFXa86wlvhUQ+hRpa2meS3qKy7QCwq9ulRQ3YBvhJKiZ5gI8Q6gpNP+El8lamos0zb1tIFSeR820Fn0asipfnkwrN+kmIvla2x1OWQPwD0nJ/k8R12zyAAAAAElFTkSuQmCC"

/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAV1BMVEUAAADBaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU8pLzO4ZU0zMzWuYkxZQTx1TEFiRT6lXkqbW0hPPjo8NjdM/28HAAAAEXRSTlMAEIC/UAAg7zBgj9+fz0CvcEvntPIAAAJPSURBVHhe7dbZcuMgEAXQ0JhNLFLbyez//51TaaWMkGiBSJ6m5j5Q5QcfWbfBxcs/kf8RIG/qel7ULtog4icg6ybpcc04ZIPBbeQYJCZc8/h9//P2DsEYJPEj3+/3+493KA5BDrfQN7YjkZI+hXLFb6/3158M5CIiop80D2HO49cDq1DKT5tEB8SNH3ATb4ehgGVcHZJHxxclR9xnqkLWEMBuyBmPCadnTSy1JwasZWIhijmWAFiPO4OedeW53JBLOoP8fmjasJDRJ9Cha4l8Ig/ZfZOAZwEWcrnIAuaSOCjsuo4NKBYQ3zVgK1CF8ptwE+MnV0JQjkNiO6EC5UpM3orN6Aokij8R4bsgn46Qe0I3arozcIDC9l9EY3fCHoqbDsWMV6UMFXPFK3EFlHA4Rn8RhHILAX4i6Qsg6anvDLlRiL4oMmQHIVCGBpfH78cgRzs5FEdkKJaOtyxP/0g+jtMWEnFwCxUQSfNI19SuJygnxavQjS7FQRO0jZ2uTU/Xb/4UkaAfUyxEWQrASynN84Mvum5A+uQKI0wbYvaUVUVuV6Bp3wNzGfQtKO2upuzLpQYkiJDrejaLUEBcScBAKk8utqCZIM/chekJq9aCgCBJKzOL0ILyjNPKMS++dEGJoKUOCXw26FuQIijVIUczmGntgsDWoUC+obUPWtf69F1xfHgo8pClcpbmEclXyEWZGkQEzLT2QYlWqFakPa1tyNH2r0GkB3W41bISCMX+IiOoKF2B+KbcoWzvrVKGGuqFFrqPVeMkqH5IwZxUV/4CSW7BKoL3F0QAAAAASUVORK5CYII="

/***/ }),
/* 868 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAV1BMVEUAAADBaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU8pLzOuYkxPPjqSV0ZZQTybW0hsSD8zMzW4ZU2IU0V1TEH8vjOsAAAAEXRSTlMAML+vAFDf72DPECCAn0CPcM3NXWQAAAJfSURBVHhe7dbL1psgEAfwDwSGm+iY9N73f85WRzlaQES76ul/4cIkP4YwiB//XP6HcUTsmNhHKkQlxZ/5ECdhgHNgL0lcopsggxRlRYxCimuANG7x6T3eAKkIgU3vscuQxhjsVyckt8pQ2IbqcJdAkMEYOIEGPo6ACHJ2LO4Ds2T7va0LkNPqMJjGY4zv4WB3KeT6xXh9fn+i5aaZVQIJtI39nqbphYiczRBgLfIIRQen3/my9VrAaoYjZOPQX6fp2/et14Y6pI7QiDE/fr5i+xushx0gnq3Z4YWMNcgIqrMWc4AkpqGZ1eP2kHBhzug7iFBweCljfotYE6HhGmTykGAbpAGvheUhsUFXHezzkMXmuCwU2qEhC+l2CGwO8tieLgf1eCMhA/E7kPpbEI4p1N2CwCbQiLfiE8jhzZIIerJsFE3Qo5JUP18IetSSwzJ2IOjJwumlZ/oUsqa1rzUiQgoJC20Q/UCmkJBNkKWl9hG6u1HWh8+Qg2QjZDkql4OEaoIoWWh8CNX7W3U+qDJU/bt1WEIHRihC9bklo+Sh6tx46cM6JExympY2Nkug8nf92SYK51AgAhIoOUflOSQIGmjQs471FYgTEaFiSV0F8gvBCpCACKkKRLWIEqRmgrRwDlmCFEHZTzlV3Z9DRFAXs/yDxtMwcA4RQedc4tBtue6kCrTUTddCuVaEKxWNJxBb34x18qJVWja65gcZ1unrB1BHSxCojx5AQACv7bX47a4A0Wuao2dVFdKKuzKk1jVjVYjCshBHYDT5QdShOEGVQJbOAYPGXoY0ghSlhL3+C1lGwpwe9eTsAAAAAElFTkSuQmCC"

/***/ }),
/* 869 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAVFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMMpLzMqNTw5fbEuRVcyXHs4d6gxVnIwUGkrOkU3cp9RhgnIAAAAEXRSTlMAMHCPv98AEGCv71CfQM+AIOxvFEIAAAIPSURBVHherdbZduMgDIDhgEFiNVbS2d//Pac9M42C8SJD//t8AWQn3LpTejKW3rMK3rtBT+h8oGe+F4qe6vogZ2lV6oHyTOtm7IAKNVkEAaR0MuH51d5Qm4JTKKZApxU4gbBYEmThBHKWRLljCD3JsnAIKUvC9CGkAklDhoacGQ4glDtUjqCZ5OkDqNCFgtqFFrqUxT3I0LX8DpTpam4bMpehgFtQputNW1CijpYWQuoptZBj4Me3+/3xXXhKDeSfztvj/tFP+eBu2zv7df/XmwTyDDU7+/0f+kOScAWlXiiuoNC5NZpqSBH1HTaZGpqImvHLChWkqL9XqNBA6gmpmUbKHxAvZxxK9DVQoa+BkIGxw84MjI1/GVT4gczC2fus7ekrknOOJW2K9vUt11tQeUKcisXz9dP4kjEzuXNXiQwdpeqLXmwhkEHAkN/8E/VSyFTjAdfsTArpehOZ6ixIIQyHkBNDUKqtxWZBYgjm12NNzezlEBq+M0JoRsaQdHdLMzSLAmjxk0MA/jE2AIB2+zZ6O5tWyp+UM4r/tHhiDJ09QCYD51aOBOIBmc8PYLWe4EAGsUQhxYx5qgZmFcgh8LSXR7gCLTuMjQArqGdJoSBchUrLWM2MHIprZVIMXIHyi2EmtzDQCQVkoAvSfAUagxK/DGOQZacX4iMKGYYhQ0TzAsOQIwoaYByKRiOI+gsKGuRd9mrSNAAAAABJRU5ErkJggg=="

/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAyVBMVEUAAABmdX9mdX9mdX9zgo1mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX+ZqrVmdX9mdX9mdX+ZqrWoqraZqrWZqrWZqrVmdX+ZqrWZqrWZqrV3h5Fzgo2ZqrWZqrWZqrWZqrWZqrWZqrWZqrVmdX9peIJzgo1wf4mDk52Wp7KfqrXuq7rpq7nHq7iZqrW7qrfdq7m1qrekqrb0q7rjq7knKyuqqrbSq7jMq7jYq7hueoGwqrY1OzzBqrdncnkuMzSMnaiTo66SoqzvzB8DAAAAJHRSTlMAUI+/ABBw35/PryCAQEAAMGCAvwAgr+/fUM/vQBBwj+9gv580Y2JvAAADgElEQVR4XryWyZLbIBCG9QRzmEIu5IpElXxj0+Z9tiTv/1AZI3WXDKgDh+S7Uf79Ad0CqfgXVKK1jlZUbJONVAGBuuF2BW9qT0CnUFRBAOHeqsgUioSNIBhCp1BUtzZKiwunUyiCRJgBCZ0C0QECg+n7/mbOFhHRfZ3N7TtoBkzNoso6pFHTgu7QhBWvUNNpyCkjMVWwms+z6GnFcYSuzGVyKcd4XOf0GVIFa+Zp1PSEgv01zNHArvxct6QKxt3vk49a1sSZg6PH5zynCrd3qaeAI1RpXaFjmNPSpQrXDDNF6LAl2LIuljMuVbSPBalYQONTgs+QjuWUfKQKnChkqfdDZC1UcmvpTnSJB4wvMvHcBUU9IQIIUU+J1HWwEYaryhL1nd2k65NF+s2SvOmYqA2KbexfMUGx20J47VeDTWBQXvuFOyLSO6wk4aGT7ogw/rS3wSYyPO2ML9eIBP/VJnNdn5AGLrYBT3IyUuMeLK/xqu2gbKngX/CqZUxAH5TMEUkFPRZPryN5cWXL4PsPbubWf0HKMU80SnxBhq/sfATxEZEBr4jPGhriswaocj2N96GF5IrY/xV9fp1OX5/+OE20X4XuJ8c9HCP7TdFulXqfRe/hGNltippV6rTwOxgjzaaozBOVgQjhoSgYI5xti15zRK+EqMwRlYSIHdJFB0aJXtLb/0KK2C71gdwxWlSmHpGSEDlE+r1Ii2qe4uE1KcJ602ClaRETSRujRXib0OxZmujHz18WGT9ufX/7GC3yp/Wy62kYhMIwth62FpCdzYXpXNyS7itqY6JRb5Zs//9PWXpoOdXeNPrckBPguXiB5HA5P1z/RsRigjpNi5bt7kw9R+xTzrttnE9TjRPbImhQmLviJ1vq8WJHSBqOy1ExEeZFLxf+Z3guL0UvOQYRjop+9mX5xijLfdHPCCvRFdNkjk0uD0f6VsUm+HhYstUuY6qJcI1EG8hbo1R27m/BKYpO/tznt0q2+3MwuimcoEEra01wuoTyW/mb+c7/gY/0MFTSrDTWKk2FqJSuTguDRoNtuFtQG0xt8yK+C9BBRTurIhOAWO9MyJOAZayma2/ynvW0806hWe9N3iEsISkzQxVTbWZVE/4525CGYSh32b2QGNKzAwhngx1RHdjYDmRch8pFED3DTcBENqtyh+Ei8Ps6GQFK8gwEJEIU/ZF/Fn0DH9rXIzFyNQIAAAAASUVORK5CYII="

/***/ }),
/* 871 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAECklEQVR4Ae3ZwYrkVBTG8TxCHiE7F7OJm1m5iE9grV1l667mDUpwIQgGXAi6CbhsbAJilzNKc8dhqEXP0Jm2ocaaaSc6tK27gKAgCMfv0n2wOOTeupF0VSq5Az9oKk0450+lkp4K9D/6fR5CBgQVpBCMTAg51FDBBAI+OAUS8hHFiaEGEkL+hQKoQQnhCOOwRAbqJNLT5U8hpJBDCXRLSsghhRCCNqxxRKAZkHskY5gECqAdKSDpIA6LeLkUqG0kEUYB9YSyhOJ9OY5NwEtGQA4qiEWcDKinsoY4UyAHigOxCsjR7Ko6ifjzpedKCDFzDArI0VQGyoBc/PnrMS1Xy/5GEZ49f1FhZtcwLJKBnC6zf367z3H2ip5Zz97m8hKBwOEtuG9xRCTXQBNToATI5PWrp3sbh2EHl7t1YApkfGj84/Lh3sdh2MUWKNkUKGp6Rli9PB9MIOxiilNAYAvEUsO7Z8jvogpCt0Dw1+v/LrWLi7PBBcJO63FqfgB2CvTZwVEM9ers+raOEw6S3u3vyzkdzo/qm50DSb6ghVADaYuTx4MNtFo+pi/n13tCCaFLIAXEHixOBxsIu/GerNgUKAVa9+j0/z8YfvBRRm/evUtv3Lmj6Z/1a705H3aTgbTEFqgCAiZO6u7jTz/nRSR9bOfnYw2BKlOgFKirQG8lbxsXwrGdn08GEtKmQGWXgeQS0qMnP2z/fO6BlAwUAY09kBCtB5ptOdDuzuceaAqB+fLygdR6IAIfSOBAiQ9klIjPH3+bF6Y6UA7Exv6gKGQ6kHIPNJA/NdwDKR2ocgg0LO6BSh2IfCAzH8gHup1AFWQwsZ28PHtOy8UJXXx3TL989TVdHRz0gp5Fz6Rnw4ybAqVQQG0LVEEOU/l/s00nPX/yjF7d/5YH6j09K2Y2RQoY9k1gBgpqDmQlw/x89M3ehJEwe1OowAT7R06BTs9f0Mvjh3sbRtK7YCdrIGY8wHAi/nwZFOykI2mBjfUgThRfHh4OLg672S2GwMR4AEKogQauhrBtoBBKoJEoIWwTKAMamcw1UAI0UolLIAXUxo+ffEjfv/eOpn/e/mLdzaE2BUpa3y6/yHkopl/bepwO50hsgQqgNsr378nB9GtbD9ThHIUpUATU1uLeu3Iw/drWA3U8R9QUKAVqSQ7Fth6o4znSpkC5D8TQoiFQ6QMxtGgIRD4QA3Mg/yFtD+Rv8yxsDOQfFB3eQSP+U8M9kGe7zXul+UHRMz4oToA8QAsZiFVAI1dBYAo084HQQAYSSv/hbA8UQz3CODXExkBCOsJAadsvDicj+uJw4vzFoRCBGnAcBZH7V89m6cAeASpxSTkEcjOBYo/DFOJy6jaQkMAMFJQ9vWUrmMnvujoM5P0LPiukNHzppfsAAAAASUVORK5CYII="

/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 873 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA5FBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrX0q7qwqrbM1t2fqrXpq7nMq7juq7q7qrfSq7jHq7isu8Tdq7mqqrbYq7hodHyfsLrG0di1qrfBqre8yNHqtsO/y9PZ4Oajsr3bxtBFTlRaZWymtb+5xs7CztacrbiLm6XWy9SkqrYwNzvjq7nZydLyrrzP09vew86zwMkpLzPc4+js8PL////v8vTW3uPy9ffP2d+2w8zJ09tvfITS2+F2hIxhbXTm6+6puMKvvceIC0r+AAAAEXRSTlMAv99gAJ9AcK8QMO9QzyCPgLEX2ygAAAPQSURBVHhendVVg6s6FIbhTQiaFuYLUJVx3e6uR+X//58zgXYlmQaZee/KxUNWgPSRymM+f3A+89SPRwoIABY+jAkZEBAUAUCc3J9JYgCICEqhEqP7OiMBVUoQF6gL7rWoJECd4BqK0TROhzvpGE2xAfkAaLzhYzX5BpSB8oc5PqjMgDgDFQ1xIlCMm1AOXdDvBNDlFhQCWBY03cC5iiWA0IK4ANZySdIgZynXgOA2FKvrclFBJdIuJxVQVQup7hwTRHcppJRvG4kl7U7CGuetlLKg1ROUAJBaytuhXDsSQELQNg9Y1xLqwjYnRF3trAGP34Ui4EyqFlB5bZAH1UKqzoBoD8qAjaw7o0/aUQrVmazbANkexMfApJEKBQUdr2LROBNgzPehaLdgOakACDckAFTbGy6AyAFlwKlsmgLAyOWMAGAqm06BzIZottlWek2zOSZ7vXVmNBlBNNuhpEW7ZxOgDZCHQOSEMmAuaUnO55YaC5Jzmowgmq3aQVP3wRQZOyQrmoyg/dlmdBZbxQBm9mQacs926twkAZxak7khHuvZFnQY23fCQk8W8zbIN2ZzfbihPZnfCiVCz7YBDu5CB0ChJxNJK8QDPdvSDS31ZAFvh0LaA+ussc4s2sOwA+JMP5UaSvyAAQAL/KSG9FNlvAuK9G5u4GWBACWCzMNGP4uoE0rMb5sUsszzIemEeEA3ncPRnJYb8G4o3J7rkwLOisn2HyLsgfi4vuthhZaqw3q1Y94H+ahmcomOpnJWwe+FOMN0js7mUzDeD/kYkD8A4gK9CT4ACjCgoB/yMaT+zU4xsLQbShiaXv599BJ29lWWdEIxmv76fNsfoBxX4y4oxLY3CnoDynU17IAYtn2uo+GcV1k75MOGABTT9UzK2XpaEESu3woxgp4o5wmwkNTimK5uY22QD93R48dHWJ1Io/L8aX1V57dAHqyun5elBZXlby9g5rmhDFar8rYL7Vyo38+vYZY5oWjfKV9p6FWpOrHWFDmhGEbHv5d1Nzvnpmy6hFHshBiMnpXb3r1XzPt35a4VdMwJwehFSX34eHHx8UNJncOoF/q3bO9e0CcCrr78c9uXKzeUDYW+fqO+EvSA0f78ZjQYEo7NNiHHZov+9+hZK7TqfY8i+4VsgS773+zE8Yl81853xyeSOCGe25Ja04+fO+fnj/2PNuduKGF3j5Hbfl3V/SpV9jHCkhaIpwJWq5PS7PwpzETafvinDHbXny6bXT85/+8YVizt/IPMYeTlI7prOso9GOVJz39/ljNlCO8g5HuFB149Pcszfqf/AXU5/8gVDzq3AAAAAElFTkSuQmCC"

/***/ }),
/* 874 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 875 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABHVBMVEUAAAB3slU+ch0+ch0+ch0+ch0+ch0+ch0+ch0+ch0+ch0+ch0+ch0+ch0+ch0+ch0+ch13slV3slU+ch13slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slVgmD9gmD8+ch13slVwqk5zrlJpokdCdiH///9MgitbkjlFeiRXjjZimkBspkspLzNJfihelj1Qhi9lnkRTijLE3bWIvGpkkU0qMzJfiUpyqlOAt2Du9eqRwHW72aqfuY4zPzdBWD6ZxYA1VSdGYEA9bh59pWTn7eO1zac0USg8ZSZdkj7m8d/d7NWz1J/M4r/b5dXD07gtPC8uNzWiyor3+vRhkERijEeNvHHP3MdulVZKeyttolE4SDkNA3nBAAAAI3RSTlMAEABg7zCvz3CPIL9AgJ9Q3zDPEI9A31Dvn78gAK9wYIDvUDBOe78AAAOBSURBVHhendZnc+o4GIZhI+w4YDqBBcIJu/vI3XSSnF639t7L//8Ze4Q0YxsLy8r9IQyTmWtey7KRUa0hUWWQKtVhWumXCxuXD4MaAGzBWDZYzYdAdbD4EHUT4ps+1DTBMofc5NkPgBzwGoRYzOQ1taEWRLispw7sVqvdcBynVRlyUFqnKmQhWxBF8W0UJUjHrAp1UmW/c6nIOywFZlWFTPCSnUfzrSIGkYpQlzORTyWtAthVoYZg5HlbNNqXrWEFqAdsOSPvFgBMSwk1EawYoJDaSqi7PF1i/xDHsZ+7OqCugvqDHHJYbsHLSGsAw3KodpVV3DizDeMMH8MmpdBonGG8JbL52X8FTgqpxtkFECWRWKO0uCcuTT3OHryvv/FoMRdwuoZyHHFjgM++erL57xmVtAVMQzEOi8/zyZPN+z6VQTHQMRTjsCIAyc+bY7/IoANgGYpxWCtg621EMmiNHjFU47Bcn9K33HlLZaFxCn0woWd6zKHHcqh9hEbT2ezqej6fj2b0fE/fbDZvntLzE9UecfVmwZiynv1LzwTTMsiAlveOqgNs40OFcxfeVYFgjPltWReEl/fHv2EY3qscD3AMsVEQeXnn1/C358eBQvVIPswmg1ywdnnoRRi+4h/ht2qoRYwJA1lRiohLekHpfch6roB2NiFssd0giaKTie4Y8JK+O0KqGxczqDamsr5jwPf0Vcg/y9uzSyP9iQw6Aj8w6MefXn/ul0Nb2OwRuS5sSbE2X3wZ//4HjrmqbdQy5E/8n3+9/vsfpMVljs8h1vUsg6x3twnS1BPtgN6QQ+wNIJB9gJO2UewrfrXtZuZ9dH310SmSRPFhTZUlnZOfo3rujBf7Hq2UaxaONRfiWpYrl1Zv55BTaGi+Rw6ZQSaziRraFyciHzMk4/TntZux+h3SLkBkmoNGc9ainFoBaBag3It3MRfdlF3gXn5iqw1yjqg/KLsymHwi+flh0J9nqo3LtrUlPx/1r2az6WKer3/+yb8YkhRSN5U7PlsfLejMSLc9ogkRqePC1IYGZ45YXV1Idt+8AOjoQmcGgqO72PKB9CHZYWMJAHVNaCw9X+OiRfSgES0W8U2tB81kh2KbEF1oUXS8BF1tqDaRrrQ+NJX/vDZ0oYV8C+mukfS8EoGlB9UG8mcD6CkgtbMCy6xrQY+KzjpgikWIDjSVO+iSfP8DpJG5ffLGF8kAAAAASUVORK5CYII="

/***/ }),
/* 876 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA0lBMVEUAAABVrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO50Tqp0Tqp0Tqp0Tqp0Tqp0Tqp0Tqp0Tqp0Tqp0Tqp0Tqp0TqpVrO50Tqp0Tqp0Tqp0Tqp0TqqIZruqjdiqjdifgM+fgM9vTKM8N1EpLzOCXraqjdidfc2qjdhrSpuqjdiqjdiFYriqjdh3Uq2nidWqjdiqjdiSccSqjdiqjdiWdcd7VrCggc+PbsGqjdijhdKqjdh8WLGqjdijhdKZecp+WrOqjdiqjdhIU21oAAAARnRSTlMAEGCvz//vv48gAIAw30BwABCv/zDfgGC/z1Dvj1CfIP8QAO8A/////7//j///UP/P//9wIP+vQP/////v/2DPn4D//9+A2tRPvwAAAopJREFUeAHc0t2SoyAQhuEYR3RQCeSLiIM/93+XW4Rsmoysgdqp2qp9jzzxqbbb039fcS4/KlY3n5x/NjWrPspzwbM6cVfLKh/ruudjmw811bO+p+cmFyqqP/TPIF7HnTobKlq2Z1ibcTdxOUlf1/Sh0jcdT09dgZN81pKTd/nbAIJIynY08A0qkq5106OSlBiwg2Tvnf4QGgEYLaRLjQaIQHXS2R8jTMZ4JQK1SSsaEWl4gb489MWPm7DPEETbLt6d22KXJshVOqfkVPLHiVfo7KAzf9u8W5H0UPgD9Ok/ITV+hzrGOp7SYhFkJEG5qZWcSQVQftvF+LFWKUNomc1z3MnMF5GCwXUNIKUtdk3z7Y2j4LIEiQHx7HpoCdzbfkMjDprGt5B4QAuOG+IUvXnxkLKg8iiNe9pDKxIy0V2ZENqQ1qwiR/OZO6SR2CBiX0bQBCpvqM2G0AYqbyg1IYQWZHWloVa8QBp5Wa3CeQi6Ijc7C6lGC2p1kMHfpx1kfwrCD7T8aqYOlxIEoiiOv0Gf+xZ7SoG1g0KQ6SJR6vu/Ugh2BzemvMKH/g/wm7PMcKeC7iaCAgNgCujxqakHzeZhOJ/pnSjG5aLGaSQ9ZBceFLY9qwcxGYT0g2gmedqSK5wa+7HTjC8CjcmS+RRQQb6ibdxPG5Bcn6H7kU6MLjlsN/RGGQSoT6202bI3CMrjL6WOp8pcoIebmGDHtgoC4d0tN8pHFRm7avSgD5LZp4vS65S92/K7lelDOc/trAuiX5dEzmak5wiEmhdZW7hGbNtHXc4VVob4jkCm5C3VgAchob6ywk8IlX6OwRCE9UHH5MAwBHMseWWHo88I1JUs4j+xuK58xYf0/XvoC/oJlTGbl7Y1AAAAAElFTkSuQmCC"

/***/ }),
/* 877 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABTVBMVEUAAADM1t3M1t3BaU/M1t3DgG3BaU/M1t3LzdHM1t3M1t1mIRPLzdHBaU/M1t3CcVnM1t3BaU/M1t3M1t3M1t3M1t3BaU/BaU/DgG3BaU/M1t3BaU/BaU/BaU/M1t1mIRPBaU/BaU+URTFmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRPBaU/BaU+nVD6URTHBaU9mIRPGmY2MmaJmdX/LlYLKh3GZpq7Rt6xse4XBaU9mIRO7ZUvZnoJ8OCjLjnSfTjnWl3zTkXXKfWLHoJbNhGnQim9sJhfSlnvJel+OQS3VlHgpLzPDh23Ju7rEcFWub1inZ1HLz9SwXES4ZU3SjXK2YEjM1t3Cd2HHdly8f2aKSDaqV0CURTHDbFJPPjp3Lx5xKhuCOCbHpp+ZSjV0MSGgYEuuYkyRUD19MyLCcFjJtLHLyMuDQC/DfWptKRrJ9BAFAAAAMXRSTlMAQM9gEAAQcL/vr2AA74DfUHCPvyAwQI/fIABQr5/f3wC/AI8AcEAQ77+vgDDfIM9QEhf51gAAA1lJREFUeF7E08dv2zAUx/EABnQJfNBFhuEEodKV1mnV64+Sd/bee3Xv/v/H0pQl6uWFoppLvkeB+ACPj5oqFCCqeYL06sVrOW7hzfRzmleLEAjTlDAFAOrtIjW9IPPm3heZdh0ohRTlG0eSnuWOr5gSyENa2JxAC/JBqRkizbNAApPqi9p5Ke+np1usY5KwQVFRajbeMmju3fy8cSIrFAJXKz0ttUIgXmFSL2xpp7dyBYRWqK0gdRhZB7/vQx+g60mpoLYV8jUkjzNomJxfUOi7do6lhnwrFACXClrPoI0kSc47HFpX0CUQWKGmhm7jDErGrXYYFN9qqGmFxBi6i2EgLX1mdxTfjSFhhyJAHiBrJ0nbM9CnbA0SiBhE9w/TBOrmjtkD2T6H2kDMoUTKTvdbYTLoY+1ySMWhv12l6VWZSqGWBdpLNLSOYq0SKHgY6ihnV80XEyj4b6i7NcbUfHg0ZPoiO1tJdUjYoC15sZpQCM1HQKud3TEHkiiHDm82N28OoevnkOb6UJkTDkg5SoJukJAGUJkTDmhT99UKmROVIDghPAm0RKGlp4Ci6lBUCoVk/WsUWiPrD0uhBnmQZxQ6Iw+yUQr5SLNCJp9Bjt/fBFLAIFJ1SJRDEYE2is4GcSIH1CDQgD3svIYDahFouQgtE6jlgASBlth7zBMuaAaF1th7zJpxQjXykKzPqOaEPBSzbt9zQnS2vnH6dDI3VLPsf0Anc0OiztbGllYXVaBZtja2tFkHxGfbMdAOm8wFeey22V17Loj/uMsP/SCRcEH8koYZNGRX5IZ8mK4z6BomvyIUADj9uL2/PToFjlLnKP12sj36AQQVIQGMTnT7o2y2IU5/pt9+/YGoCv2rjA5SHYSBOA6r+NA8ik+igTKL3KHaqgUX7wIu3OQOvf8FmlTClHYSMr/lH/xIzN9mfNvj/3izy+6n/fxDlFFj7YhhHAf32dVBtw0XU5+IMmqUFphG2+TEeV1n875IIMqosbLQ4qDFYLhUyVBuofGVwXDJk6EyDpXJEIjY1QSkQx3+Wh8uvwyo8Y+N4dIwIGUiKQYEOuxo4EAyDEkW1IehPgQxjySBB5WadnTJhEAJyhEKuBCo4tspFKRDWPVxPV0BsCCslZ04ENHJFmI9AeBPpl36ypIbAAAAAElFTkSuQmCC"

/***/ }),
/* 878 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAq1BMVEUAAAC/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVLLhGvXnoTXnoTXnoTXnoTXnoTXnoS/aVLWm4HXnoTKgGjQjXS6f2l6OCtyMSQpLzPOinHHemLCcFhkIRZrKR3BbFVVS0ezd2LNh27Qln2BQDLBh2+sb1vMl3/JjnaPUD+WdGbIfWXRkXhKRELLhGvTlHvEc1vBkHotRukEAAAAGHRSTlMAQICvvwBQn+8Q348gMHDPYEC/YM8AMICvUZ3QAAAC0UlEQVR4Xr3Y127jMBAFUBXS6iWdKu5O733//8vWIRiS0pUZaeXsBfxCBAfkxDMD2PovsR2XMBHiOjY1xKK7MvF81orvToZCgROyzvhOMARy4DJA9YHskBkT2gbIdiLCEzkeABBP/bWtQ7bLRsS1BRQTNjIk/oISn42On1ArCNkeEgZWyvaS1Mr2A2UW21N+F7qo6qLcpqiri11nCCGzLLUsOQVnPaBVUTZSrLrOECIt57qEXHedtRxipeD0CEqpFTffVfZO83WxRYle56I/VOgVJ19Nq0HLckCWGpRsIRqpC5WDoq4U8XkUyHarhkGVbDTKISXVw6D62wkERFMBFcOgQkCpnNmZgDTg4XKxuHxoAHimXiaexhB6W2zz1nDwbC2kWEA5Qs8LnmfdwTMmkgvIQ4hfiF8JzxDyBJQxKPZCRHPwrJCjn0OqRKwG6I9y8Kxm3wk4ZEuoGnajSkI2h1JsETOELZJyKIKm7VfsJWv1GsExYv734xghHMpwsJm/kDjYMg7BqP2xRXDUAsQlY8BBCNcRBtcRQrggMbggEcKVjdm9sgMJQV66nRcw8Eb9FtxqGLTe/bT1TshnmFcFzGb8I/PKMD6HiLlAmw3/GMtERNNCPkzQBziiaXNwPksTVH4ClHMoAOjdDL0DFHOIko5SY7EN5SZyHbVS/hB4mYBoOA7y5crOx0GphGg2BsqogpIxUKJBNP13yKE6RD3otNmmIzPoNo9KCCX+hZx3QXP+hQSHQyCJFrnqgq5EiygHIZq2mvYWnVvZtKo+CNEkbIyRm/O2c37TGCOhTQEScXy93Hdt6K5RaiegAMnEnj5q75vOvT5qvZhShHQq8tXwn2qvO5+q4e8rRkGY3JXT9lFW/PZRzlk3D/r+7BNMokys7unTfLOZP03Fqs68SUNBCHNwWLZyeKAQhAw5OtaZ46MTQ6wTY07PxLUOz04BAGgv+QuYErrcIbl1cwAAAABJRU5ErkJggg=="

/***/ }),
/* 879 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABC1BMVEUAAACImaaImaYnKyuImaYnKysnKysnKyvM1t2NnaqImabdLkTM1t3M1t0nKyuImabdLkTdLkTdLkTM1t3M1t2ImabM1t3M1t2ImaYnKyuImaaImabdLkQnKysnKyvdLkTdLkQnKyvdLkQnKyvM1t0nKyvM1t3M1t3M1t0nKysnKysnKysnKysnKyvEztaZqLS3w8yMnamCkp5wfodYYmlRW2FeaXB2hI9FTVE5QEItMjONkqDCT2PdLkSdfo7SO1CocYHNQlbISV2/y9OisLuRoa2Imaa7x8/M1t0nKyvCy9IxNjZGS0xbYGO3wceYoaWjq7E8QEGOlppvdnmEi496gYRla26ttrxQVliT6icUAAAALnRSTlMAUJ/PABBQj7/v359AEIDvAGCvgHAwzyC/cCBA758AMEC/IO9Q3wDvnzAgYECvnP6MqwAAAxlJREFUeF6s1suqgzAQgOGApK6Om0KhCwNiPb1o32OSeO/1/Z/k0EKbOOo0KedfzuJDmKhhdJvdCp6tdptfMjYc8EWYpPJRFhc/yy1YbZc/RZzJR2kSLrgYxISJ50dpdXkxhrpIq2POJyEepTajW5io1TaVRnwMrQeMLBVMpko5oNYI4okkHEKSCbehfUo5tJTuDYQdXQNRrackZhxTA2SNHElPiAfIOcGHTkgK+BMKkdOpT5DqkBQ+oINENfCxXqIOgokYOXdw6I6gWDCO8dYFaiWKs5x4II9HyllMrN7jCMQM7b4Dx9DiAobksyt0lsMwpFwhRUMVOFeRUOMONSQEHlFQ5QNVBNT7QD0B1T5QPQ+V4FU5C538oNMs1PhBzSykDHDWUmr0vuCZmoO60UZ6AGrWYWh8ijpDE7PKhjIDXcanVgE1uxgnY4mBWl+oNVBiQ2oMAVAzZUPmSqTBFwL9ho4sekN3Hwj/AiILuvpDVwtaoKU5rh+vrWAF+ob4HEjoLUig7Tu+Inj/gongBd3Au9vLCexLBHyRdYkQ+X9AubkffQuZ+5FIJlb9V3q9tSgIhHEcTpmFjmRHw6Ktvagg6WCamVrtptP2/b/QrqM570yiA/4ugx7+vnRh9yDEmYXBIwOaTyNIf1u02eKctps3SCdQMmmdOrs9BYyDSToYVNrvUmidDCIQee2f69PUAYz1TLMwLZUWevTdDwKlVZPnAnuOT9ARbEqerpr5f20VQ/A+JoRMeKcYWmVCfeI8MMiGkI1BdwL1MyGVQAGGnahzwrCAQCqEaORIIQMZzstxDAYK4Yl4qBlBmM0+x87ZxmwR1OQhOAnzEtnk8A5mBvFQawkg+FuyDPwOLVssBFOHBBLpd6gueAjWq4k5tR41KASTxSAZcVUQ10AMGhdCaCTijFAxpLV5wHV5p60JQEjiIc/jIQmJQEhiNrme73sus0dCYhDSwJ0uV/+/6wXcR0P5EGws1yOlfvv2k35u8SfyACFBCOaDlNwqSm4T6kxKQQ0KNUpBnxT6KgUpnZfTUcpByqwbMd2ZUtAf5Jqp1Ao6TewAAAAASUVORK5CYII="

/***/ }),
/* 880 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAjVBMVEUAAAD0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7r0q7rqWW7tboHrXnPrY3jueIvynKzyl6fzprXwjJ7vgpTufY9CP0QpLzPsaHzxkaLtc4ZmIRO1hJCoPUGHLyqYNjXiVmhuJRnwh5l/LCTRT113KB7zobHaUmMZzgK7AAAAEXRSTlMAcL+AUBAAIK9gn0DP79+PMAcP08EAAALPSURBVHhe3djZlqIwEIDhEKDYFKiw427vy8z7P96EMDndplQi9s3MfxnhI4AalP3XOZy7ng8z8z2XcweAQYCqMJph+VGIqkBCDurixAASN+T6RR665OUYdY6EFvgVj8jBdGTaEcevFsB8PImPhw3iJZ5tGQeKSTie5LOEHNWHIMQrhQH4ZIOEuRJoRVXvvx0UJ/o23X1diVYSLhv2WgtZterwxrpVJWTrwWZcQjuhKjVly5RCtZMEZ6mEhK7c2zv7UugkkbKBFrqis4e6QuiGvQao1U6NN1VrqNUQcWwlAhHHXqLQrrsd6nYUKoljJZUEanBWjQmtcGYrDXEFFTi7QkGcZWp6zVxG750xTwL6xOaenCQ8Bili1d0DdRViCgwixF/3OGr3SEIQ4t2FMEB+eq+T+iO0vBdajlCEdxcpiN8P8XHJ1j1sttvNwwRAtqVL9sNWZSHRbR0JhRrajNBmmqHbhhJC3fZvFg7dFlj+M1DOnAvTbfpVUYiTimLVNxcug8OycxewrUtxobJuz92YjHF6S5tCXK1oyO1XS7ZZX4qJyh7NUkacVljUEolClQ1UTUO9sKqfhA520GESKu2gchLSwMvj09PjiwboiDX0fJQ9a4SM2EOvA/SqETJCocUF6KhSAh2h0IKFPwOFzD3/fvxtQOZIZUAu+QlxsJvRgfyEAGNVe7OD3oyVDRjExkIuxt4H510jZMR4XIglZJ7bboQ+Po/Hz4+RoCM788zIAmn5qe3pAglkStXt3yKJgiC8+ZutJU81EqKPI/WUU9OHEQVBviTP89fadadODhqCCIlk7WAEXxB4ZE7W8/FAQ6p8gSetLzlrPGmRwykEfmbcu+IcUxj3K/PBgGQ5NyiyDhwMhgcABFJUbFz0/booR6Ms1nvjIsc5AIHoPyI0+i+JCRmWl/HrCM88pVCIFiSuy7lxJxecu24SEINAlv0r0B8iOT7p2C5ZJQAAAABJRU5ErkJggg=="

/***/ }),
/* 881 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAqFBMVEUAAAB3slWXxnvG5bPG5bPG5bN3slV3slXG5bPG5bPG5bPG5bPG5bPG5bPG5bPG5bN3slXG5bN3slV3slV3slV3slV3slV3slV3slV3slXG5bN3slV3slV3slV9tlyVxXio0pDG5bPB4q2ayH6836d3slX////E3bWfzISZxYApLzNckTvM4r+t1Zby8vJfY2ZqokjV58qLv22BuGHk5eaIvGqGvGey2JymUBJvAAAAH3RSTlMAUJ/fAECPMCBgrxDvz4Bwz59gEACfQK8g77/fgHDPlMzq0wAAAkZJREFUeF7s1MlugzAUhWGzgW0UY0N0obvDkHHo9P5vVjulDtbFSMUs8+2Qjn6ZEBD/8pIogkEqyWdN7oQbaIJDmgUCOx5K4UlZILjzQwo+KJaY34nRefpbY9z6wJnczl+m45CG0TaDIx4072iAL/UoRACOjdPCIh4igC/pGUoA9M1IDyvJrUwbWT7sppaJCykA9q7Pl/3+crZ3D0uV24IwoGJbKmBqqVzIrm3edEypMRDGl+RCGEL7hw8z/EQYXwZCcyeaXpYuFHNr/on4TxjGly5E/KGG8SV5jx9t4xwxgy+VCyX+H7bFHL5MvFeEvbQBfEneSxtBs8/IMin7sC2jcj8kd1hkJ/2Q3GChjfRCBRYrxqEKEapnSCOK/gtJQhSSQ6hCpOo3VCJa+QgpRFM2JLECaUI1VlCbEGEFlIsMq8hEjZDr4XBl1yG1KBByMNh1SCFondBGYJ1bg0CMV+j93nWn78Gp6+5fc6E3TPnpho55G4SBMAxb8YfkyzmgWz2U2KQSS5YMyf//ZxUt0ing0pLb8u5+9J3v/fmRKz3OfV37cIc1Ml5L3qhcxzV2cHR/QgZFtrHh+R05Lv2M3GpLtpfdZqcv7CC5TJ95yS91md6WLHBosr3cwAFHu3PEBIVodWL4hkBWiPADQWyOYIaMkkAhNkjCCgEQ2x6FQPEVJhKWEELa76QAhTTy+xhPQBUCtzso3zJWkEb/PDDpmjoEhO70l3LqArABqUXy641eSJUFVI2brk0pqhBTaruGoS0ga+8PfQHkvkDhAquyfwAAAABJRU5ErkJggg=="

/***/ }),
/* 882 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABPlBMVEUAAAD/6LbBaU/qvpTBaU//6LbBaU/BaU/BaU/BaU/BaU//zE3/6Lb/zE3/zE3/6Lb/6LbBaU/ZmnfBaU/BaU//zE3/6LbBaU//6LbBaU//6Lb/4JjNgmT/6Lb/6Lb/zE3/6Lb/6LbBaU/BaU//6Lb/zE3/6Lb/6Lb/zE3/6Lb/zE3/zE3/zE3/35X+37L1oZLta3f7zanrYnPxhoXz0KPwyJz32KnouI/gqYPRiWnBaU/FcVXUkW/6xKTNgWLyj4nzmI7JeVzYmXbksIn74LDudHzcoXz/zE3/6Lb/02f+xU/tZ2r3oVn1k17ub2j4qFfrYGzxfWTqWW77tlPyhGL/4Zzzi2Dvdmb2mlv6r1UnKyv8vlH/2oL/0Fr/46Khhj41NS3/1W7/3Ij/5amukED/3o9CPy//zlT/2HvywksfMb3pAAAALXRSTlMAUI+/ABBw35/vz9+fAI9A32DPMIC/r1BgrwDfUDDvz8+AIBC/EI9wUCDvn3A847QFAAAEGklEQVR4XrSW2W7bMBBF9a5YzosAo0GQGIgCIfV/XGpfvWff8/8/0EicmqTHdswCPS8GiIvjmRFFyvkfhJ6PHt8LB3vZk3IGRDBxoeFOAqY4kFKikAIKl1V1MEUiDxx4ynAwpUQBdR2n2fybrIhpCqo9PVXIVKqlSCQTy6re0K5lRvNQat2qVLWkFIl+99VUtcEsprqNvuKZmapkSopCAGiSeou8L4pmSal1vp1KGko5g8DtPGXNKDvTzQV6Lm72pTqTG3yLJgBiSpgssMViV6qMAUy+RS6AOQ/QvBU0ac4cgDtwQgAp1+QNdtLkPJsCCB0PQMI8GfaSsXACwHN8oGFtL3GAJRtoA/gOgBl/EIfgD28GoBPNucfONCdRyTyWppJErOGfYGPdJVrgKBY/iSocSbUt8oHc2O9HYb5VOeA7HtDqm/RoUiVqAc8J9aUEFiT634fOwNWqLGBBoc3DlcdIxgqyKimTx0igSkphRaoKCuiopSpjWBFv5hHKw9+j5ipYUlFjnnYdzWhTW7GQHt+4IIuybmBJU5eFfkHK7uIW1rQx4LGPiAjWRPpHBBGcTWHN9Cxg30cn4l9E4uQX4dDvtdBFD4+r1eMDCL6uROLaFA2FLnpd9byC4OtKJIaG6NQQvUvROwi2rotOddFIGKIV8QWCryuRGGmiy050by+670SXSnQuepgIJnxd9JxvRGMpurMV3UnReCO6kqInW9GTFF1tRELybCt6FpK/oiGJXmwf/wuJhiQaCSKy25CRIEYkGgtiaveKTAUxViLiDQYf0eftlLj9jD5g8PanVfrpSRwI4zhetIKQJlLXuDJBEhyj6QFUsAMtf1ylsj+vTbihB33/72GHzrOPA2HQZPdz6WXmm2dmCncInVdqvL4sOx/Y8NFZvvCCDhwh8rZYwQ6Lxfty8QZih87wj874+d26N7e5dnvThRM/v4DTXS8nvTs48Z99Cpd+zvpwOeVQCWvuYwWSW0BUfI81JQ6JerF/MEySlI2SGOjlrAfEyShlSTIcFMW6+AwdqcGY17DR5tG2LBkP1NFnKGykWylMcjaBSrdqhL7m+X5YSbebAnjIyS8AU8fCik55P63M1Jr98WmWQXs2nWdo2ezp0TqW1a388KoUqR3H2ZiLMwXSLWZ66IKoGe8fZ/FxjUpVz3xOLvyDfZpnNFewTfr9CWxq/nfl/oG4ODGjeDpZLW4rpMwww5eyIaXMTp2qeTIMpa/tmc48w7dkc1Pa87VVw/ONsrmzZoBvCprmlcoUMCE6V0PPFl218KXWVSSEbNDp7FBxYYcULwU7W62gJIzD4qHskKQOa8OpTRUuSXsi/XY16Vsix2UFkbDI1b61o8mwTB0WtevYUG9ThslyKDnkdn4dXIJcBtfnYgdP/Cd/ANB+z5fJQYHYAAAAAElFTkSuQmCC"

/***/ }),
/* 883 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABOFBMVEUAAADM1t1mdX9mdX9mdX9mdX/M1t3M1t3DzdTM1t3M1t2AjZfM1t1mdX9mdX9mdX/M1t3M1t3M1t3M1t15h5DM1t1mdX/M1t3M1t1mdX/M1t1mdX9mdX9mdX9mdX9mdX9mdX9mdX+5xMzM1t2/ytGAjZdWY2pHUFWMmaJDS1BaYmdzen5QVlhbYGOYoaXCy9KOlppGS0zRoq3NzNPSl6TdLkTaTmHOwcrVgpHcOU7bQ1fZWGrQrLemsrqUlZ/VPVHTR1uam6R1bHjHO0+TWmm/QFNmdX/M1t3ep6fmqqqOhoxse4XOoKKsuMCmkJWzvsZzgYuGgoonKyu5xMu2lprGnZ+uk5d5h5F2fIS+mZ2frLSejJKGk5wvNDZueILG0NdOWWBKVVqWiY+Tn6grMDDWo6VicHqZpq7jqOuEAAAAJHRSTlMAnyAAQGCA76/PML9wEFDfj99QAK8gv2AQr6+fgO8wz49wr7+L7WFUAAADhUlEQVR4XqTW6W6jMBSG4aiBnyFqoyGlGNLM3Ms5LNm77/vM/d/B8LE4dkoV7Lw/LfQkx2BEr4zCo75VRyHVCz0ADhEoG4bIUSCXyJwCg1wFElQWCRNHRFQmFCiguknclYknVBcokE+yaTdnSjJfgSLaFm4BRwTydyeBcLZOSEoKRGqTQal4IXitKPRKZgC+DYoBZMmDMrQ7pNaGrrKlD0kGKJaQA+A6TWfrShKSaaM8UTHrWZpeA3Ik5AG6SosW1LkFrr8C5ElIAErLLrs6l2kZIKFB69RIgoPW36B3O+hdgwLstd1o2O1QQj72WjpGEnbb16AvODMyaAbo6xsEJ7k1gW4TSK1QRkZlP0F3ZNjdLnQOSA5mNBygc+05Uo6H0THRnqMp7kHybA49J7jPU+30ZwuyaJFpp79P9ulvyPAQJ1Sg+BAobiDkRrZM5PYlhAJbKOhr0ICsG2iQuwu8fW42n2/71pAcrXWy103Z6541FGhQRHpPFfS0Zw1FKuTQTlDQ3z1ryFEgcQgkFMj/Cdq3hnwFIntI/4g4DIol5NbAPyNIXu5qr1rEK5Pbv2JltwEdn/gNtDR5IJe83e2T41FvdCb/CPNj9yPyyA00/PWHzwpozPO8gV5y6lj+0kD5nJnHBXTKHxd5DfF9V+ieayi/+GDm0wIa/V5xJXHRTTfnhosqh1dcTAZoTHNIFbTsBv1vxV5akweiOA5XKlqtVOOpzBAXXTRabb1e0vvVy5xFKYJduAm4EPT7f4OaSZwmnZx5Qd7fNvDk8N8EMpeQdL4EIpMQFx7upKWHsebacZ6DsWqfOwc9gcglBBfCQS19eQ+TcsQSbQig6naFSW2F2NSvZPWNSH4brmoNZCF0gsk5m+ZC1VwikYM8gDhSXS8i3SCVDf+CWlGoRUIshODyf0EVCmpHoTYJWXuIUVAnCnWQjIWQhVRt40EqK4RSJNRVK7W6SJcKIcggWa/vM/0eGsrAHgKWxYPLMviFIH+wlM1DFAKeO8zJcYhDwMnJB0PDzBzikGHykXt7Z5hZg4jJh/eu6z4MqJk1iJp89OjKnp6JmXVIn9x5eX1zVe8f85U2MwkBL5csRPUVGE/2zmQcfF3DrFKZAwGpKgXbl9bCbzrzmdlU+K1RZhcqIKMhlX9YQ/ypEZwCMhrSDzuPO6fqFAKiSxeFqpg+NnZkfnxWlVZR/jky9gOxe08AEtDM/gAAAABJRU5ErkJggg=="

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA21BMVEUAAADBaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU8nKyvWl3zZnoLHdlzQim/Ym3/hop/dmpPJel/SjXK4iHLbbWfdLkTUin2AZVeHUkI6MzDYkojDkHfGcVrEcFXNhGnDbVXfnpnIdWDKeWbKfWLDbFLPgXGtgWwyMjDmqqpfT0aLbFzOl31+Tj8xLy1IQTtqVkx1XVE9OTbPh2zWjoLbdGvkpqTakHrcSlTaVVjFYk7YOUbMU0vWPUe3ZU2hemeWc2H5cjzUAAAAEXRSTlMAUJ/fAECAr7/P749gIDAQcJHtnvMAAAMKSURBVHhetdjnmqMgFIDhsSZBjUFNb9N7773P7t7/Fe3AACd4SDE+8/1k9A2iwXmyIrNsh37n2JYr8/xKlYpqFd9zZYZj3RVxjkNVjscVm9BcxPbwsToUUK3ADTmMc0J07CRko88GYO6fbAGp+Rx3z77rHtPZ4WMDCXmM2do7Ez3Odx7lsXtbTPIE5DDnWTobdIE2pPTMJOcHshiq5jNmQJE5MdfikM2uGZwFG0vpWKz3Cr+yrn5dRa6uy66NQ8yHwUWDD2dqDursFoF2OwBFOrRPC7U/bUZjWrCxgrTF7tDCdeRia7f/oDh0ALcfHkgmF66rHkj4imwVVtRpzuSXdre4ok7zYBspVYA2tuWyta223HwAipaHIvdXZuQsDzmTkEVLZLm/cNdIGYgAVKelqivILwf5Cqph4Oo6Sa6vjGOomoRi7KwlvDXjGCoWkIWh9YS3bhxDWQLyMZSI/swYg3wBVctCVQGR6ZBxDEV+oIiWhWjEIas8ZHHILw/54r1W7var91qVznwge612u9XTxlBVDhEA0NdheyfNeOnOthwzRDhEp9bsZxP1m3RqM6HDNMuVHhaEgMFUQQgYTBWAmsCYqKYZQq+io342p/5RznE4VMlNpw3A4GRVdTIAqZ2bVIVDDX11lPLvPMl1/ldR+ko1OFQ3OxeJoQuzVGeQtvc3s0WhrKnt/hwKAUoBujzFzuklQClAoYBiom5YNtEASaeDbCLlkFhAbogg3uaN7txsZkYodCUEO0mmtzrprGZ6sIcAFBFYI63NW8nciumgNSIRQPCObEkBqLv7JLm/kwzUUvs1QLBMvWzherBAAIGULuqk4ADEswg8kbOD55FYLobcqMakBwwMh9h5YE4tchHEaxDTej+NRk+mlSYNQWDIjW08p+HouyGejx27GIKigGgb5MvriPf6om2RJIiAAEgvrNBei1tp622kepNjPVoJGYAgXGwFYmt5/5DOxzvl1QIrBgBDOM/m1OcXY74+uWJ7CMAQzjb/j18cwj+CLQfhn+WWgvAPhXP6D94uUuD5vFN6AAAAAElFTkSuQmCC"

/***/ }),
/* 885 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABQVBMVEUAAADM1t3P2N/M1t3M1t3M1t3u7u7u7u7u7u7u7u4nKysnKyvM1t3u7u7M1t3u7u4nKyvh4eHu7u4nKysnKyvu7u7u7u7u7u7u7u4nKyvu7u7u7u7u7u7u7u7u7u4nKytdYGB4e3vv7+/t7u7y8vLX19fJysr09PSusLBrbW2hoqL9/f01ODhQU1OGiIjz8/P4+PjwpK3ysbndLkT75ejmYnP5+vvs8PLneojm6OrM1t3OwcraTmHSl6TZWGru7u4nKyszNzdlaGhmdX8/R0uwsbF3hI3JyclWY2pAQ0OIk5vV1tZZXFy8vb2XmZni4uJicHqqsrfk5eXm5uejpaXV19nM0NJydHR+gIDd3+BDS1B2eXmLjY1ebHWDhob5+fn+/v4vNDZaZ298hYtCRkaTlZWZoqkrMDCiqrBMUFD///9m8Z2KAAAAIHRSTlMAUJ/fAECAr7/PAECf749g3+8gII9QMBBwn58Aj0DfUFo4S/gAAAP1SURBVHhenJXnbuMwDID1y82AUbeXtEjSJo9CemXPzr3Hjfd/gItkRhLd+C7W98cAIXwQSZEWG3qtANcErV5tw6m3VwGiuueddjaws4TIPvUANUFdWdo+5PDbysXPclEDGY3afhe20t3v5M/aohZyogMo5CBCTotE+j7JMF4zTDBM4Z+koT5LdyJRXWpe32LifQH/YfEeE2+v0lQnUSA9y5j4gh34iomlNAWZqCel+j4r2Ilf+k64pidFqtLJ7h5iFRMJ1VuozIY8rzLZDSk3UcM1FBxDCcZkwjU5Uf8cSnDeN6IfXHQJpbgsutEKSrLSIlbsPpSmr4ttt/8KSnPF2k8PcgwOjOlB2iNyCw7c0ohYQ3sPTtzT0Jo1MgEnJrRG9GKLwJEIW2zVzsCRGVu1tUNw5rCTIdTnBJw5YaIucC6iESJOL8CwmE8RMYwopunaoiYw0hESowEQAxPL1bNpidrMc42GcEJtDtFww0RtS+Rzj801KKb5oME3oiPu4Uzo3RWbjrTIA8Mcc8y3RlMweFpUtXpDtbhbxvHyTqcR8RhiuABNdSM6BsMDKhLzq5nK8IjFJA9gOFYi3ny60GMmepRSGWYxxSj/AAQr0QwzYuIniXhMMQCNR6IKy2xX0Rw0FRL5xSKTGo/xIvmZyJ78qYOINoBgtb5xEzWVyAPH1Hi1BZvYFL+1//f29uMsN7fCbhos8NuDfHp+eXl+YjFJCMDbJvKjz0bk4/Psj+Ls84NiRQtAdMCCj/nfyuqgJ3UgCsOwQA2SdGzSBCG2GMACV4siFFABHVyxMOQmrO7iJriAhfP/f4D2JPTz9GAK766bJ5PpzJn60iCzrKeHAgLE/xvVWJlUq0bi/NdZ0N9PyUjqU2dCevEmGEFhiDBISHXGCKr+tgABSDxFzWuT0XVT864IKnIn+ADQam+T2i1IHwGHigRVmdNJlD8381Q3OA4dBlUJutjv3AJAt/ulixhisz8wh0ImYNOfIAdQCCjoSqcbAAoBObtXRCU/zCDTElK3ZZDBTdu9Ip4jIGp1x507frz4ggjCJDG87U9na3iYIYBchT0SF4LdPblHygWEN3ItL8T9Zj7f3BPDWifzGhC2qWcOrocNAgQpPNQJ4QCiyio5kRnhPKqyJyHPpRP+IIF+XzoPdKJdT0BUVWG/0SCKBvt2WlU9ChCqXMo19aPv+nI9lxVPQsj1lQ5CMMNRRI2GYMJAK98FAYjnFHVvTdb48SlKenock7Lu6aLjIUCyStkv6efJd9PZzplN4+9nXfLLFQASktXyk7iX15h5faGPfA1AJoTsSSrbQqIT6/fOuXNuHQmh0wKYwql1PIRyNlkFO2dl9AWPUbIxvZl/1AAAAABJRU5ErkJggg=="

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAATlBMVEUAAADmqqrmqqrmqqrmqqrmqqrmqqrmqqrmqqrmqqrmqqrmqqrmqqrmqqreoaGWVExuKhxmIRPOkI5+Oy+2d3F2Mia+f3ueXVWGQznWmZdxvBphAAAADnRSTlMAMHCv3/8AEIDvUJ+Pz1Vj518AAAElSURBVHja7ZftbsMgDEUTgguktA397vu/6CTW3cZVhTtidZrE+Wfd6AiFYJyu0Wg07vRmsFTEDqZfPdPx0nlIBJl3BZHzgd4mMBUTjVwjq8bXojX9mvhC5DZUwcZBJHlkExdlT5WJi9ZUTZyLRlrA+BC5QGC7m1KadltilPLgIPIE9lPKTHtilHL/I3KBPVcwsZwvqeMLOiRwICDl5i56nNNjmnEkIOT2W9QTOKUZJwJS3meRQX1OjDMCKTdZNKC+JMYFgZQPWWRRXxPjikDKbRYRSE8gEPNPiW6C6PaBFf25SG371T5ItSOidmh128jKLG1sXq3VajV/tetI+YLMRKomag0RmmON/qBV/Z6i+jCqPx5DZRYP7KD6F6KOJmqiJvrvoi9gEnf/zCCuEwAAAABJRU5ErkJggg=="

/***/ }),
/* 887 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAABmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIROuRplmAAAAEXRSTlMAgL8QAJ+PUN/PYK9AMCDvcH4OmEcAAAGlSURBVHhe1dbRboMwDIbRJmmAQCH4/V92TYvcqKB9ONOm1XeWyEF2cvFf/nk5ER+uW4Uo0l3P1qVuernXsEkhlW5sgpKUmp7NJA+2BQryrFtp5q1ZGqDbBsXSRFXboVya/DNIx1mkHaoP16gdqsepx7RDcQ9FEzRm8Uu1pPAacy4je8kjQ9uhHPQRpoIP+jhD1l0BtOoQ4XG8L9D4IIMO7E5A7nU/weuRTiQWZxErtB5/sZ6E8NP6N7xshnjZus71Oyjy9b9f8OJS6ZLben0cDOmT00l01uq5MlRXSFJVCnqAob3DEkNe3iq1QU525VqgJe+hvDRAnRxU1wDlIyjboVkOazZD6zG0miF3DLlPh3hHu+zkWm6Ns9NlF49kmNy9puHZJcxOeyhE710ftO2d9zFQdlKIirMTQ5id7BBnJ4Y4OzGE2ckEcXZiyJCdADJkJ4BOZieEODsZIM5ODFmyEy+bIV62ITsBdDI7IWTJTgxxdmIIs5Md4uzEEGcnhjA72SHOTgxxdmKIs5MF4lzAECeVj4V4R399a5ydDBBnJ4a4fgP6AvRYi9KKt3qWAAAAAElFTkSuQmCC"

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAOVBMVEUAAADh6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3K0dZudHk1Oz8pLzO/xcr6gEi3AAAADnRSTlMAIHC/7/8An4AQz49A3zuL04YAAAEmSURBVHgB7da9bgMhEEbRwSx3sdfeH7//wyaaYmQlgi8FRQpufTRaGbDGZv+w2WyWbnkp3y35lmjWUEaAtXy0Ooq0ikG1/KjymVSGd3+UXz3uRFpZCDVJKAuhJgllALk0ykRKGVBLs0oklEEqnRKeVgZrj6x4WhmpFP1JWhlbn2x4UhlLnyx4UtmziJ4AWllVpAJoZVmRDKCVvRR5AWhlRQag1Z8HzUH7cV7XeeytQVqZH+z7vLzz3Th+rfxC7i7c7I0LKZU/keOKjsYTkcof7XlFZ+PRSuV/I9dHjb8RqYytTzY8qYzU/+iEJ5XB2vsZVzytDFLvYBOeVgbU9lWrREIZQG5d/kyk1NglYthaM27RGrf6DVtGvQHr8YDmINEcpJqD5qAvrc5ib6U9R14AAAAASUVORK5CYII="

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAZlBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLPh2zDbFLJel/Qim/Ym3/EcFXVlHjGc1nTkXXWl3zNhGnHdlzBaU/MgGXKfWLSjXJVmEx8AAAAEXRSTlMAQHCPv++AYDAAz59QIN8Qr8i3PyEAAALYSURBVHherdjXkusgDAbgeIMLrsG9prz/S56hhQ1YgjOb/9LjfEYCgycXJNHPlRDGExOSpBnFcgGuZ9ec2YmL8j+h6lorwLWqcKgqGBZD4VBzZSbb2u4i7boZKgmBsvqNtMf9d7q+1VheeaEoVszKFSfHoFoVeaBMMWN/BzK9JJWiUKXGM3caOPpdpF/eVD8KqcQg8uFM7cx+ZX1MalDicpzBUPrbmQZmRzeuE1IOQ2rCRBVPUYBLTUZKICiSzi4cBmR8cmkRagVAhbyTF3YwOELaOVQAkKys5UPfGBLRKH5H3JxCDROZxPOAmDE/7MV0sVo0y8cBMV3sOHRzIDP5rWylf0gvXtsplAio91T2eVMGQGoRrT5o0BMbwZBqEZ6Vr3wOJTiEK/ouEPrhzvwFKNKDXrZ15xnmP0Im0z6GQ8bk0GhviKczuGmoPIViUb2dAZi1BZx+St7Q8tz3/bFIaUbWET2FEv3O6nK2Xqgu9FQruz6HSr1HmGpaLr0caFJXi3Oo0W/243Pv6c9adB+dbcQkV+X3BnqJHUPG1RsAuvL5Xz5fWvlwd0AvsR0BUCTv2wxjmm8yTvqVLSGIxszJ4UD9Xdk1BaFCAVhp7V13KIWh0nFmDjkNmjhdUxiiDvSwDrmxey/2CINuZ9t8a7VMXrhRDEot6Gm1qH0f53GDQpX9cn6uc8YLWwRcUhSitfO90I0WNKvCcMg0aX3yX1mLaOi6QReGQ4li5gXY12R+/F+1ujky3XrqEOqFGlmWYqC9v/JD1KyW48WAFDQAIvqQ2BmYJhAyhwQ+IBxK/FAWBunSZsjJKQa5R8kIQQkIuQtp7o+BQYnCITw0DKp8Th4IUR90/RZUfgmKaSiU41ARDBEcioKhG+rUNBhKUCgNh1LMITQcyjAo80HgJwm+5+NQgU99OBThTjhEb3hd4VCTnzCkol7IlewxxUVEfbn4/qojt8QoKPSl/AMdpyVVUhmquQAAAABJRU5ErkJggg=="

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAtFBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoIpLzMpLzPEcVbXmX0pLzOTcmIpLzPBaU8pLzMpLzPSjnOHal0pLzMpLzMpLzMpLzMpLzPZnoLBaU/Ym3/DbFIpLzN2YFbEcFXOl33TkXXGc1lVS0eBZ1uie2nVlHjHdlzPh2zDkHhKRELNhGk/PT00NjiXdGTWl3zJel/KfWLQim/xQERzAAAAInRSTlMAML/PQABg7xDfgJ8gr3CPUJ/f35/v72DfAECf7xCvIHAw2sZi4gAAAjJJREFUeF692OlymzAUhmFAChKbIWlTN2mdpB9el+xr2/u/rzJ2iGwhCUnu5P1rzTM6nmE4Q9BbGAGEHvUV9B2IsSk+FAoZttHDIJ7gPcYPglJ8lB0C5RCBHgBlECHyh3LsRb2hDHsVvhBn2C/3hAaQKj0hAinmB4XoVHlBJToVXlCCbtwDCqEo9oBKKMo8IAJFzB3KoYw6QzGUlc5QAWXEGWJQxx2hEJoqR2gATaUjVEATcYQS6OJOUA5t1AmqoC11glJoK5ygCNoSJ4hBH3eAchiiDhCFodQBSmEoc4AyGIocoAiGmAMEY/YQhzFqDVEYq6yhCsZSayj9JCiyhqJPgog1RGDOGsJ/gOiP73WNnur6y1dqhGiCeV3P+6H6DxKqhXgB3DaH7iygGkDB1VBOANzbQksAJFdBOUPTkwsElnchTmANrVoIhHegAvbQ3QeEQoYqbPtre6M3ac0JpKVhbPkfzeX3ZSBvjL/toCd59Q7kdWhZ15N+aDJGW7EHAbtXgrnl7oUAHTSe1Ms+aAULCLeTHuh+NdZCEUQYw5T8e7QHhQyesVBAG4kAD7N10/UNeru5XjfNHgASdh7a+Of0vedXGHt9bk9+i5VLxPCkpdYLaFusW+ZkeCYKznY7Pz7dSo9aafG4VU6PzxtAhkSj4cVGmkHTbMNcDEetICC5y6tmxBdoemlGuroUgIBU/TqeQtNUjGSARKMSqlgqRjJDIhopGO71bSQfFEQgUVkdGfoHvaB2QqoRp/8AAAAASUVORK5CYII="

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAolBMVEUAAADnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDtg5TpZHnzrbj4y9L51tv////wmKb2wcn86u3seYv74OTvjp31t8Dqb4L+9fbia3zyoq/18fDZyMTfVmrGrKezkImMWU5mIRN+LCSeOjzXU2SWNjavQUd2KB/HTFluJRm/SFPPT1+nPkKGLyrnWnClmtjeAAAAEXRSTlMAEIDvz1AAYDDfr0BwnyC/j5DdnpEAAAH6SURBVHja7ddbU6NAEIbhGZgAgQBGhBAP6+piNAclCt///2tLGd0FmgF6c7E3vNfJU1QN1dOIqamp/500TABqZlXZCoBpSEubsHQ5c5xyPcfFqbnDh2wTHZk2F7KhyeZBC2hbcCAfPfkaiOdQSQ9JFwO5cgwkFQZTchhyTIzIdIYgmzgaye6FpI/R+T2Qo8BIOTrIADOjE/IUulp+ha6UR6AgRKvLZXQVJ7Xiq2h5iVZh0IACv4Ws0nXS2TpdtTA/+AM5TeY6ukl6u4muKSVaR357t05GtL67bVDSErU3+ccqvU9Gd5+uftbedKE+T+YhSuOk1eMv0mPSKk6jh88TVQJZXPvj02azea566em5qvrZUw2OgQravpzdNoNQyHbnOrsMSswA7A/nMIc9gJmwXBCKzcC1xPdEzF7f+Mrba/Y9MUVtJuaHI0c5HvLavBTN6fpOLK3y3py7gszpj2I7eNrFB5nfomviZ3lRHjVPUhZ5hnqmZ50gKp3a58WuLP8SZbkr8r32PhGsWwhap4KIxHdOEJF4DoWsQIGZCrqvI6mYjrQIRCSuU0FE4jsUsmTIcAjUyGesEATiS/6Y1W+BwRbjllFvjt7m3titVhomtJmGZCzswYWpYS4C5reItF2QXJs+DYWoNTNCha9UaMzqCoU4TdAETdC/9ht357Y7PRnzbAAAAABJRU5ErkJggg=="

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAflBMVEUAAABmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRPqWW7aUmPJS1eoPUGgOjuHLyp3KB5/LCTiVmiwQUaYNjVmIRNmIRPkRFndLkRmIRNmIRNmIRPqWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW68PHdeAAAAKnRSTlMA77+AQBAA/8+fcN8w//////////////9Qj///ryBgAN+vcDCAEO9Qj8+nKZeBAAABc0lEQVR4AezMz3LCMAzEYUu21sH8sQkFEgK8/2M2BR3UDmRIYHrK77z7ubn/aW6OiH0QvJEEz0Qu3qoWKUxBQlpUd0GhW0v2KaxeE1YheV6as1PQVjH7vvAg38f86ONS/EjJyWcgcfDRtN7ksq13cbCvelvyZh1NHg5CFtL2OR9KOda/OpZyyHmvEwuR9BAaC72ehRr8QGjfhVrcIfAgdOq60yDEgEJSDUFd3xBUiUIqTYTUUQhyngqdBQpp7TSoBf5AaGg8RA0spF14LMQXGMh0pTEQXYEnEGQMJHgO4bvderexIIZhKLqdUP5IHvff4CZKBhhQdPgA3wJOwIgnEF794dWFLnShH4NMh4xCTYcahboOdQoNHRoUgqmQgUNdhWYBeWhQeAFhatBEBXkoUHgJYSnQQg3hqaEHCoRdQRsa5Jtfv+0MIlJGnYT4TnwfDmHFNxMLZxB8flAxHSdQUt3ejCVzAmWjt8Ss9QESgfQudKF/D+9JNzoQUukAAAAASUVORK5CYII="

/***/ }),
/* 893 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoI7WtDNAAAAEXRSTlMAEJ/vAN/PgFBwML+vQI8gYB7QbScAAAFgSURBVHhe7dXRboUgDIDhlVZFoWLf/2WXs+ianQGWwdXif+8XUqt8lAMnIuiATH1QKZjkqxk6ISdnSyeEF4SdkHz3j6EHeqAHeqAH8suybv3QhvIqQB+k9xhuvyBwKBLZBm1yNcMbdJ5VdhME+mB8g/ASVyJgTnWIJpW8Qj9COF5o4Cq0KzQVIAmneNSgJNqhUL5UgSgqNN9BjhJzCfKipRtociKCSx4iVGhVqJbLQ06haIOEs5BXaDJCMQuRaEZI8lAcBa3tUMpC26gTEY6C4ihoHQXxKEifZu6DwgXNcx/kROuC1lEQj4JSo4MliBqhUIRCG7QUoaUN8kVoaxxREdILt/3n37FJXIEAG9+ZQn8fN1chME8pUhUib3Qw3UC023eoDtFscXa6h8AgOapBdsmRCSIIho+1BNnXCZnsEHFxUA7IAmlHdjUDExkhzcc3ZdoTUQOkgd8DnkhcNir2CdBQubPQuQ4VAAAAAElFTkSuQmCC"

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoI7WtDNAAAAEXRSTlMAIGCfv+/Pr4BAAHDfUBAwj88Mvw0AAAFaSURBVHhe7dbbigMhDIDhehzNeGje/2WX2VJsxWhcvVrmv5YPRDE+6IRU2uCVPZyHQQ9oJ86AXxnl/wAJhY1snISSQyKdZ6AckO7kQxK7qcSEFA6yiYBIh5YY0ImMjjHkkZUbQckgLz+AFDILfcgjO9eFNB8yqQNlnOjsQGoGCh3I4EyZhDxO5UjIzUGahDTORUJhEhIUhJP5XdC5C3quQdaWY1uCfLlua9DHurwLOndBahcUdkEomlCah+Qu6Ni1NdOGDiYUihSbUGRCukBq4fH/+h6YNgTPC9BhAGUsRWr2R5dBDSCwBToIiDEnqy+doKGy0BLQ57m5HgTxd6UTFCQLFCqoLnsv2pOunlypB9UXwsgKSmVzngVBtIioBFQQZFNuUoH65QusIcj65Ug+BDX0ppxzMsEaVPq/0A3d0A3d0A2Zt2MWIfWG1CKU7MsxaRGCpC5HCyD7AdzB/7CDVCjeAAAAAElFTkSuQmCC"

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoI7WtDNAAAAEnRSTlMAMBAA7//fjyCvYFCfgHBAz78y8sBcAAABPklEQVR4Ae3UXQ4UIRREYaBu0dD873+zzmg0Gm24Y2PiQ58FfEm9lHl6+tdZB3UGl1kh/RHuQ8KvxfMmlPg9yekOVPhzsdo90CuJtf0NVPmneq4tfAZZXjeK1UMYnOWr00JOOE2K00EInfN80kFwkYsOHQQkz3nd6SDg7DrJYFmo0a8lg49qnb81dkEs3yCXhTdrb8h53q6/ocwNnS+IO/K7IKZdUIQRbsmZzC0l4zp3dBi4IrzfMJhkhdpkBjmhvhmUuQmSXRD/Oyjughr1+RmEg+riFEIVKitzCG5Ql11AJ3V5zCEn1HUsoEZlYRM0sIACdbUVhEFNGUuoUZG4NYRTN2wNIWTPeQUqaHmUGUrIrhwt1Ba7tkCSoIcgvCoGfALVC2Y0YAWtJck/GD2EcPRfkFESAD2k74EeaFNfAP+QSWAiUSbuAAAAAElFTkSuQmCC"

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoI7WtDNAAAAEnRSTlMAEDAAII/f/+9gr1CfcIBAz79Y+IGdAAABPklEQVR4Ae3T0YrYIBSE4aOTOCfGaHz/ly0sLG3ZVoeNlF7ke4D/Zhh7/VuvEDFg0Gx7Ij0+DR2ZH/xR6CzOT+d3Q/HK/FX9Tqhd2Uk+CW3tKjf/5NJDsXb+XRRD4Uoc6ZBCoTqHPEihM3Hs3qCEdk7kACEUbo6lE0Omde4DEzbvpHxtgBbq/OJu0H2GKteEGh/yEj5CNx9LwYCDCxQDElcwnFwUyotCgUu4nVyi2M4V7mCdz3kNMKcqRQwYdR4WhVhWhXxViP9dKI9Cibo2CmXKdgxYpcgvjFikpgcMGRI1xyy0U+NhEtooapMQ+qpQo2abhVCo6JiGglPQ5iE0aX0hhMqxVDZIIRQOFUwZpFKUQ9g5cukhnC5MpoSwZeFnSghoXdheCQGtOL/wA3rop7P232J3DZBCK7yhN7TID2kNWRIGLwJNAAAAAElFTkSuQmCC"

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAb1BMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLWl3zNhGnGdFnNhGnVlHjTkXXKfWLBaU/DbFLHdlzWl3zSjXLQim/MgGXJel/Gc1nEcFXZnoLYm3/Ph2yU19ySAAAAFHRSTlMAIEBwgAAwn79Qr89gEN+P74CA7z/5yOoAAAJcSURBVHhe7MAxAQAAAEAw/VOL4TEym+3X3Y6bMBQE4GIMOMEktA3E5D+G93/GEuX41KNi7aG53bkFPu0OHqRkKtcqK+L8KNalVLoy/h1T/hekNnpbe4xdBTXKarNjACUZlCm9Ny0CmLb5Aio3ryoE0UlIWapClh1AVEUOVQiDUJNTFeujYsiysj42gqz/IPu/kPKfpG0YEhU8TocOgP4w0Z8UoNJLcnRuiJ3OOfeWdgHSCaA7TBF0cs71EdTP0OltfgGNg3MHEVQSlAOAd4qgDUHqU0gTlDHQT2fPObs5IqgiqAjOxblh9ByEji6qDCETIBPVcE1BhzTkA1QRdMN7hxnqRFBDkCboulCvCFIEbaJrQwqaZuiegCxBZdzKCNAVH0xAmiB+bY+Ff0YCmQDVBN3hUTlUB8hEjx4BusH5HBKQD5COLj4YuvCtXGAKygiyi6vo5ZAiSOEZXA9pggp444nVPmG1CO0D1C6OZGH+CcgEyMBI1kNtgPYwEmgMoEsC8gHKYSSi1SKkCFI4kvXQhqDMw0hgtSJIE1S0MBJ8NHoR9xS0DVAFI5GsFiETIAUjgdUilPrQBajY4khwtQw9SYGzi1BTRwULxjYO8CZqhorG8EgmAXTHz3LO0By7m4FucMM5OlVXhOjS+eSgv7ohiFLmWv/89XNr5rxU37/N8Xaa86rvcXrl4V558gRa+rCl06hX9G+3kKFjp5T+qFlyHuAIods/zHPy4Mig0vcYqo4dKZT5RNiRdtQKHBFUCRwR1OySjgziZDUKfJ4BEsVWBmMqSwJDn+cb+ob+ACmrfjXar3ytAAAAAElFTkSuQmCC"

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAaVBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoJ3slXZnoLZnoJ3slXZnoJ3slV3slXZnoJ3slV3slV3slXZnoJ3slXZnoJ3slV3slV3slV3slV3slXZnoLZnoJ3slV3slV3slXZnoJ3slU0X0/xAAAAIXRSTlMAMIC/zwBg3yDvEJ/PUABwQBBgn68g79+Ar78wj3BAUI/jHcIwAAADkElEQVR4Xq2XW5eiMBCEB0K4BIOKgDfUCf//R65poUnb6Zmz7tYLL/qdrq4ymC/U9XTZTM3H+pqf7XHy+ldQfwHMP4Ou1fQ7yNTOZVZL+no+rhNos73vPeDul8WQJnNe+Q+gvgLM/WXyUMVNdu6lUgbBfg4zZhJMWjcrF0HtytlWkwAqhwCUF25IDQMdvS+P2S/jnGFZRMotSvQIz8y8gWDTd8/ZAOXYAoTqhpxOLybTN9AJBkLOiWCYscGYxaR6A/lVb58g8FVdCYAbs7pzAmjzcraFCjxdJYr1LmXGvMY3kAfsG+hStfcuWMiJixhzQ8l65AXGrmvvhgCUIWinV5M3HQP1sOcnx+B3IsZGvaanWCFxoKPPK2egHXIKE6an0wFqSUF+Q234i3LLJ0wRNWZ1jbUMQHfYeOis0LNG5KTR9FIC8qU8N6GzjhnL4ukpAoJSEmcpM5aQ9DoXBUEp0VkQWkeMsfSYtWVFuaO7tswYT4+BwBnddVhjMb0AhDJBKtTYTY/MGGbCQTlxTmospRcHKbLrkhlj6VkdBZUOZQjWiulxELVSEGOdmJ7OlapLBsrCHSZBwiS9sJY1nl0hKHGoNKTaX9MrKah2KBts2tVCegaHvhGQnx8dWI0WUHJ6KYKwRIEHoxgo13U0PUtAhSOq2UxyepgaHQjnpSSaXhKmR0AxIwl1K6YXgnax1eqUuhXSI6DOcSmSpJxeCCpdTDs6EjPGTkjMno+EADE9CupcVAkWh6WHxihoiINGNir77REQd4CDlxG/NvBOQBg+V2TWYcf+2cgg/sIQ0nsHpR+BOv1/QIPhoNsnIKtB01N4O/pkR53+G1Cps1+M9QRk5Phl0y89npwLghqh2YoVg70bv+FGhKBOKIqUZ4GJ+StRu4JycUWyMXQ27VeQEYJJOINejC7w7xNBzBt5JzNlyGnhjoYgoQBKGggPob6CzEJQo2KfVz8b22/mgfwDQNGRVBk3pijnu2l6BPEtcbFDqPccuHxCKREkvHrEQ6itpuUmdPClBBAzJ6ue+3OZgHNtZmcPBGErJeF7tX98HyfQBqp4fnIqTI2RJM606hucQJdOAOIkmbOCLq8ibudVEVBjf9x4bTSCzi9M731BlyioKZWcu11OxMuh3QPlcZhALTY7kC3EcYjQJB4jTDlHDXWptQA64o+WKxmzkNLlOA0DVSdwiSAms7ulIJtoQX5ZD/TxB6drvG+e4D3kAAAAAElFTkSuQmCC"

/***/ }),
/* 899 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAgVBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLBaU/ZnoLZnoLZnoLZnoLZnoLZnoLBaU/ZnoLBaU/BaU/ZnoLBaU/BaU/ZnoLBaU/BaU/ZnoLBaU/VlHnBaU/ZnoLBaU/SjXLDbFLKfWLQim/NhGnYm3/Ph2zEcFXVlHjGc1nWl3zJel/TkXUAn5eeAAAAHHRSTlMAQAAQj89gz4Cf3zDvUJ+vgEAg72C/r49wIK+/iLwyhAAAAj5JREFUeF6l2N1y2yAQBeCwSMRCqIpVK1VbsJ3/tu//gE2xawYdsND63HrmG58F7QV3KyMEpXNHKyIr+5lK3gzV1qe+Cdrdu2d7zuYG6Itz7td/SPOhnfuMvaRlQ/cxVLEh9y/7C2Rug46hW3dTtUOAGi70CN2Y0AN0Y0JbDx1eQjcm9N35PIVukgfRVw/9Dt0UE/rpfEK3ngl9m3ezkgftHHTjQVsH3XgQnaFX6FYOKd34j8TnI0ATQAvM6fo9nqCw3WwN0BLjpQfsNpRC0jNnaeuwWxkkN8aG2B8OuukSaKiMjXM8Q8+4uvOQaC4ASG+wurOQqm0qLx8n6R3OLQm1oRNIb/P1NgAEfyaZ98NsdXc5qLHXs59122QgZZfyGp/bmIFSvXTc9hjtEp2BkBk7ImkiKboAhVAvvN/OpQC1BdVMczncbnad/lwgsThsPUkKmWIJoOzx9x1R/l487eH8kxeyngaC1JGUhQKiKJ346PJQqNVkJLEEwaBVRuoLoTreDZjBlEFwWyEVAyru1jGgySYi1kPCsiEcNUZeg1rCyMwKJoRG6F2wg/VVaFMy6Pyq3cCvMGhMFUGwi5SEQWeiEtAQ7VhvwaAhbQIibW3Ckqq32RgCCD8lb0UKpklCwq5OBxB0K4qhNDSthZoMJM1KaAAI7mRRRgKIN6UWIN7BVQQQq5yWAMG6KIlpCSCWNBFALGmkRYiUKSgmCyAaxiVHlz77iOtUL8sfotpKZ8cjVr76tVM1zjQzNmqgdP4C9DgHD4zBYbgAAAAASUVORK5CYII="

/***/ }),
/* 900 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAe1BMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLJel/Xmn7Xmn7MgmfMgmfTkXXTkXXTkXXZnoLHdlzNhGnJel/KfWLDbFLGc1nQim/Wl3zBaU/Ym3/Ph2zSjXLMgGXEcFXVlHgcLANfAAAAGHRSTlMAcM/fQABgML+PIBCAr+9QnwC/AO8AvwDs7IpxAAACZElEQVR4Xq3Y2ZaiMBCAYdAgiIjMXpWwLmq//xMOwcERYiUx8N9w9x0LrEi395K/Q9meBQ55wbMDToXroB1OResg/F+4FXTcCorWQDG+tAZir9BpBZS8QmwFdN4KSjeCLrgRlM2g0B1Kcf3jVyfbuUHqZJkzdMJZB2fIl8AW27+bOWngCoU46+wMZXPId4bSORS7Qhecd05kTHb6CMpQ3z4aUnUV2uPHpVHmhwpEAs2Nc54L0QN8odr+GNtBdTtvUIUQV4BuotJEgQiH7M55Ucu1NENd2Zq6IqI/g8jBeoBeiJzz+ztIyOmMUD44xavcAFyFkPd/ggCHmAni42enAoC+QWsIUJ/LJ3KHigGqOjN0MkHXdqi8XQFoRHlq5GxTFeeFEAIAmgUUmaGuaokeGyhquYKJGcIub43VFwUih6t0EA9tt79q5JQAIIQoOOcLKP/2yJMXCsqJL0ADcgPHFSy+/3jkyQsFlRbf7aPNwdYOoSF/K4jZQHeLbQsUiNg2rnd2CkRuWw5DJHS2grB6sxf9bN8SO+ir1P6M8B6ZHYRQGjbtZAlhpd+2n7+mPHmhHTEOAdNe1I+94NPE5e8/U568kE5X0sctDDWJ8ttPP/+yQbqDAtGTFagp/AC6GRbEfrSOdiJbqBt3hIYyWwhvUioaCvIJSP+OVHJZLsZgfBlkCyhFp22rMVhAkQZq6fj+g/fsXAPl5yXk05AExL8pQVYLWSHvVpcsoVgPIdVlCQWRGxQrENNCQB78ChQcNTeb3DemQrQE7VhDHCEqFDDiPhUElF7I/2jFfvYO6+9vRosOp2DeX8pocQoTqqvBAAAAAElFTkSuQmCC"

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAe1BMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLTkXXRjHHMgmfMgmfZnoLRjHHTkXXJel/ZnoLBaU/HdlzVlHjQim/Gc1nWl3zJel/DbFLKfWLTkXXNhGnSjXLYm3/EcFXMgGXPh2xFmymUAAAAGHRSTlMAEGCvz3AAgO+PUN8wn79AvwDvACC/AAD0i0SWAAACWklEQVR4Xq2X2dabMAwGgRAggUCXtJXZl2zv/4S1EnLc+EeWcZkL58pzjKwPBe+NH+xCWGK6CXEHjXDvR59482+cwDKDQFrQSYJFUQgEF6FEGocFUQwUHWr6Byxx/CLygQQ9IyyTfhEFZhFQZLro5Cg66qLcLLpfUTA+eUxIV0q6KtZFQDMImi5fIWp7WlSmK0SVQVSDby26Kk9TIsOEPEZJC1BoIqZEA1DsbUVXswdOvEglrb8CSWgrmrCLwMAa0QAGsjWP1gJNwIvU7TeLRapkXuo25kWqSKIf0YkbZcwGmTLVXL++v/FwAZpGGPnx842HC5DUwszlbFejilbcMC81FLqIf7BSMsesUhtiTqRGyCB30s29sxJ1eBAwklqJblhOMGMlEhJgKLYS7W1EvZqOJCerYi8lTaUFh1L37fcLDxcgGAWaKozoc+v9mbNPuj8vPFyAohQsZWZRo2vHi+qAF7U3QtDI2sxpaSHmRc1HRHHrBXdq5KyofhoeuNdEwojU5XOcOVE5J42jsBGNViL3E80dOtqJBn06ymTIYKjung+cWd3aNEdjeZpM6tVGi3A6cuCJLDr7Imh67NCL7Wuk7vVkDNNU/9uhyd5uHLWP1wwiBkka+5+zP4XVhPkhOEfEP3+KNJfsYqRA1DF00VETMHsiUhQl5MfKStFBGzHOoowY6Azsp2jiLgq0IjmLfPggcBXprXRyFemtFDqL9Jg4i/RWytxFhTYZnEVRspVot5Uo3kpUbHRr0XkrUQSKfCtRvJUo+y9RyDwZL9Jzm2RuImXKAUldPNFfUVZhfXpHfQ4AAAAASUVORK5CYII="

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA3lBMVEUAAAD/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDPZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoL/rDPZnoLBaU/BaU/BaU/BaU/Xmn7/rDPBaU/BaU/BaU/Qim//rDPZnoLTkHTTkXXEcFXHdlzYm3/KfWL/rDP/rDPBaU/BaU/RjHHGc1nZnoLSjnPVlHjDbFLSjXLBaU/Ph2zWl3zBaU/BaU/Jel/MgGXNhGnZnoLBaU/BaU/BaU/EcFbZnoLBaU/VlHnEb1XEb1XBaU9+wSb1AAAASnRSTlMAYO8A/zCvvxCPUM8gcIAwAGDv/68QQM+fnyBwgGDP3zDv//9AUO///////yBwUL+//4+f////j///n0D////fEM/f77+vr48AAFrIYoQAAAMWSURBVHgBrdT/VtowHAVwrKAgCIEICpQBKY5SFIYTkB8ic3OT93+hkQrZ/Vajid39a3fn8Dlp02vCJAeOc3D4QRKHBnGSSecQkzo6Tn0GSm6DPQ1yLOgY/iMOlJE9Ex86kTWbNoNyp/kCUyFQytk2J2V2a8US5/ys/BaUzsp2Ynb9FR7mvPwGdKFekAFU5SgR6ED++9jkg6zV3cYXvkupEIWa8gWlDaBWWwjhcSJFoY7BRC6/dj1f9DiVXj7kcjFfLKeaTTK7zsVuhxTK822CvuiDVGQsHG3uXLZLBrnKNOVhHYTwtjiReJGFOYcmk77OSgUhPJCSgohUoW7qKLlP5NEGw+HwG9/HEyOQbhqu+121vDyOs2eOJANQQ2zT51SCJkZcpcpY50XJXqcjt1YTYW7fkbpE2r6fZubq9fXXRZgxSN0xtglp1XK6Q2dLISrdjjUNZ6iSYGFqodLzxbhrLyHEpkLcyefxYR98NsJ2Oxp7GgkgNpcO5wH+Vtdw0K+gHOeflQCqLRbqy6VTC5biHlpPrKhEIVeQD05KZq1IobqQmZn99o5KBGqHEH7IK9LuRS/Ay1vioBESYegktE1Wj6MEkIE04TT4xhU030t0XD60Gdfmoayg9Q+hm5pJbhQUV8opiK3nQixnnHs+GZeP49KnihOZL3WTMEgOIBbwz0s3Cmq1CrpxjQyghx20eBTip24SM26QQggthEyXSnY5DaGhdPTjMry3hH5qFvkVQu34UimEXLELjssbj2QzjYTiDQQgvdSzg6T0pKQJSJ4thH+SYBLWt/YfpDMY7VRJK3soDxBrKKlvDVUQiiGVGEBSaivJemoEYi0l2U2tgpC9hJdPISrNrA5EoehcTA8EUAyplEMohlRkGshyLlWGkL2EDkL2Ejp6iNXN5pJnGgiH9/EH9VBhGggzECqr4O3jlJkeQqmtpPFrKvidY8wMYq1H8S9LbwbKpP/nOZLEsz7rJ4Hxe6swPV+0B5toEpv3soBDQabrjRGEaQyjSnta22xMIUytDtbjHB/KDMK0FnXXdQeL9UabvysLuvAjigcZAAAAAElFTkSuQmCC"

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoI7WtDNAAAAEnRSTlMAQJ8QAFD/vzDfIIBgcO/Pr48o+2rgAAACjklEQVR4Ae2Wy27rMAwFLYmmXo5l///P3iDUSXnaOgG6u0BmIyOmhxTJAl0+fPjw4UGIMclbUoxBmEWIVVWzvCWr6nohKlVrk653grwh6J0urWotJEKSKJu+Kwmxukl0sSzSJtWOlzS9U+34IbJLRbnZ8ZKod252dBaVIGlX1T09Dm3vCkLkniSUpygN1YgE/W1JHBhVRzKRDSFwojme3tsso/c5TC7dvvWi/MvVVzjt6/WXZmYvmqPyw7DPDxuziK3F8VRq428g8vYNlWEl+rOM7GI3ugVE/r5Vih0QZXqySood6OsUlZnwxIUzbpSfygqRVYK2nrPkIrJsqkOSmX1UxYVU7iguWX0uu0mSobotri+dwgJERaRAFChVd/1aaFQ2HNQ/RavICpFVMsdJA1z8qLY5VFTW8T0egktbZfMDXB7vhhRf7Dqssq52ymEiO8fqG1HkERwWyd/bB/oUDZFKPyiPxo6FBjq+QkeTMOxRZP4UpI2vNIOWZcFE7feIimJKp05CwNOZUkRF0TJjVxahnoEsaSjoXcFIVgHAlB4i8VNEA5xHc1Zn8m3E3oiJ5l4dPlHWC7Iv/cAmm8hyDJfWBTNYNjCs/imSfh3LYBGZLhA1ZVLRF5SkTHuKJCqgbWJogxxRIKKS0MJrMBbQnIhfdczsam6d03pR+LsokIg+jXLqC06JpGVRoHc39ey7em6UNbBIpF6PP8br8Vf5LtquF7K164Xcfoj8cuydW8ZN6btfuZ+iq23eE/4af6GwiC/H7I/YQia6GImuTfuM3fZrD4s4muvhmjgHi0DLSvh/3lNUIjdhERMOBXtsQrS4Kziu//MHae1nzmenSBDs3YpKWfR3PqKP6CP6f0X/AJz4VssyfPjRAAAAAElFTkSuQmCC"

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAn1BMVEUAAAD0kAz/rDP0kAz/zE30kAz/zE30kAz/rDP0kAxckTv8vj7/zE1ckTv/zE3/rDP/rDN3mz7/zE30kAz0kAz/zE3/zE3/zE3/zE2LokD/zE3/zE3/zE36ri30kAz/zE3/zE3/rDP0kAz+xUb/zE3gwUr2mxhckTv6ri31lBD7tjVwmD3MukeZp0L4pyTrxUv+yElmlTz/rDP0kAz/zE1DLYVaAAAAJXRSTlMAQGDfnzAwn89w38/fUBAgv2CAEM/vv0BgcI8gz79gcFDvv4+vhG+QBgAAAc9JREFUeNrtldlywjAMRQ2Efd93ylIwO6TR/39bjWVQ1OIZgjM85bzpKnOv4sggEhIS3iKXs6gR8QA8ixqJPij6FjUKFVBM/qoTVCMwAM0Aq2yWq5EG0lR0kQ+CPFMjDUThqUCRYmqUgSi8Eyg6XLVDh4HRFD4LNDOumqc5ua+coMPAaArPoFGGq/Q0GYxVx6vdEgJFUQ9ETAPDFICNVLyJt5lqnhLG9y3zBLZUr9aFENcd+uyuYbVbU6kYK771lqIROi3xHVbA2KLRlqsrfOOlvjXGSAA6tSmaj2RRNW0Pa7P4mjJFM7YWVVMGoGszAmRP0Tzcoir2gIz42pwpmoXb1ODMF6sP5ETR4fDnKvmAWURqbig6HP5c3ZA9XS0DT7bKKJJaEUgPHOnRL7EbnkBa4EgrbqM5ODKnfxk3+h81upx8Kf3TxdVo7UuNv37BaHiQ8nAEwzFcXXxp8C+8H66G6FOVmqPpsOokH5x4n1VVbVTC4oCtA6t8MvJ5n1UlbSQN2PpfvdKPzSi2V4v3sEXT9fM3hcF1IcUd1ytCRo7Eb/TjSPxGDTefhriTdjNKiwcFF5+CIOqL930WdRF2Krw9D/oQ6cZb55wWCQkJH+UXyDkB5vN51FQAAAAASUVORK5CYII="

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAolBMVEUAAAD/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YOZbceSZsz/2YP/89j///+ZbcfJoKjxy4z/24v/7MH/6rn/3pP40oj/2YOSZsy0irXWrp7dtZq7kbH/4JrPp6Prw5H/8dGtg7rkvJX415fJs+b/5b//tk3/rDP//ffWxuymg9bdz+/49fygdMOmfL7kwaVWrCmAAAAAE3RSTlMAIGCfzwAQgO9wvzBAUN+PAACvmrFoWAAAAeBJREFUeNrt1mtvmzAYhmEwzDiEw9Yap0nzmGwNa9qEHtP//9cGKA3BHGym9hvXBwSKdEuYvJatyWQy+U42cVxUXIfYP4ZY/T9R4qLBJfQ/QtRjaGEeHRuaMXRis1Eh20cvd24eChgGsNA0RKBBzEIEWsQkNGfQm+tDNIIBRrUhD0YcXciGIVsTimHI0YQYTNHBUAhjZDAUw5gzGPJhzB0MMZgbDKHD3dPT3ZeErjm/Hh1KxAK1m+XqFuAF4Ha1vEFtLZKfDVbzUUqZbvBpWSSWVeh0++n3Hynlrwar+Sgr6TZDacULf8+XFUrZNk2k1IdOknux2T3whofdRtxXEV0o8GTTI+d8f8jzw764eZRNXtC52JRcAZCKZ77PK3v+LBUArghVQmFZUUIvr7xwyCsHXnh9UUJlK7wIkQhoh954KT/hpTd5IQMqETmFwghnIjENJQJnUViGHFxab99NXu19u1a2AiuGKhPH4cU+igyq2EKX9U6kx67Pf0zFbo0uFvotPnjDxwL9rBi92iPSLy4XW6Ud2jan/vw1/TaiisLWH9JoY1MzpGNExmy19Yi0hnYkdWhrgefDmK9uI4pgFvvaRjwLzA6jNCBe7PvqOdv3Y48EVHMYNTeFptAUmkIX/gHwEAZZGgZs+AAAAABJRU5ErkJggg=="

/***/ }),
/* 906 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAZlBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMsNz80TmIvP0o8ZoVHhbRNlctVrO5Ffag3Vm0xRlZKjb9SpOJCdZw/bpE6XnlQnNdgKBD0AAAAEnRSTlMAMCAAn//vgI/fYM9ArxBQv3C8OYTvAAACmklEQVR4Ae2X23arIBRFubjAC42Y2Fhzae3//+SpupFY8VgZecx8TFbmcC8cQNiL5/OCC/lHBJcz2ON3CQCl/6LRCkAiwiKuMJBue1IMKB4UZSDE5lggspAoh2NzOA1HHhAVMaJiKeKIEYEvRAkmzJbIYCJZiNT4eW6MkJsIY/IEPWouoqqVkTswytftRW/0WuyB96a3uegAAKXcSQkABxL5yazcjfWzMT9Zvl+U+9mYf+d3a6gR8SCqyLwPmqR6EBU0WdRshRcJaj9+NhJV5I2gcLMxN6mOE2nXLnPPZ+JExrXCqDElI1G0Towme4vT+B8zmqyKFVUAMIpK2uni4ABQDqIktiJfUjKIVHRFfifrRTy+Il8S/xHpqSJhKq0T25NoXRm+6ONXQEwl6R9RMTwa11Zhga2EJERlsUBZzYdqrGTD4mcZ1qBvwgH/2wMr8RRKluIppMziKViGGccTUWOF2iWOmMF84v3cfDzQtBf84tLOE+f3eiG63nzAJ68ArPnB9hFv8dyuTpSNnvtHiLPbOjWAczByH00ZLb8PzWjc1mkA3MKZMy2/FMV66Dadm//PFEIyKfV66BOw0yn/uS7SshdVANpw6ET7whA6hTMthhAb5/8KF+m3Tg4gvCBfY49snP+0NlkmiWxtttO0Z8sCOAYzNZD6yz7qYOgIFCRKV9a/pcmm2dqV1U9JVALowg9UyIki/Egd3RmZOwi+Qw0h96IcoZa+x62fREmo7uZIEYcCjk2o6oREtH9394VnfrhUWJjuHVyPbLqdom69qhkSxfIuhK7xmrbGdBtms/981+6r51Iv/tf5FOrLEOqueEwxymRYkM08WylGmYPOfgX0QXq2U8ynzHRGKqvNQrKRYvIZvEQv0ZP4B9TtgAfZMs2RAAAAAElFTkSuQmCC"

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA7VBMVEUAAACIyfmIyfmIyfmIyfmIyfmIyflMoNNMoNNMoNNMoNNMoNNMoNNUpdirDCVbqt2BxPTYOE+oj7W7Fi/CHDOthaqTtuKzfJ+jmcDCXn3IVXG4cpOIyflMoNM3g7bdLkRjr+HCQ19CksXUNU2Exvd9wfK3FCygBB46h7qdosy9aIiNv+7SQVuZoMnZK0KRf6d5fKacKUdVmcqzESp1vO1msuSYrNeoCSPGHjbVKT9ElciwUnEqcaSCdZ1eksEnbaBut+inWXoveKtHmcw0f7JXqNpni7hQo9UtdahyuuvNS2Y/jsElap1JnM8iZpnzWq5dAAAADXRSTlMAYL8AIM/vv2AAzyDvkJpDGAAAApVJREFUeF6s0lduwzAQRVH9qXkJM6Rqce+99579LyeSk4GtUFJcdD8J4oAgnhSlyOzr7ZisqGGSquoaIp4v7zGXMyJqegTpBYy6BvPXmXlwxaiCHkIaUiM2eUWZsBFSmiopGMtiqye0yYpZGEuRZBRbWwHbHA6Hv0B4tGGBtUYxWcKcegZqNPKBWrbdygUacz7OA5rysOnn0MyOIHv2MWTyW+a/0CLbWfLfltnOQgIj+4Oo7G8yQAJnm+7s7Dtk79KdrRNC4OzTF8QfSl/T3oEIAjdFapk8lpki7V34gcBNho6nOHQ6JkMuEATHRAeKcaiYdo+gZMkAgNKjUwIAI8khiCTRgXLl7lTKQJLoECRKBtyq1sipVQFIEhyCSBIcqHsEeXUgSXAIIkl0oOm3b2+qtf0mkCQ4BFEd2lOXnJ7n+/3BcDjo+77XI6lL++l89043uwkCYRiFB0F3/jD+gPo130bTOBB3NfEKmvb+L6igRo0Dc5BF3y3kmclJRpoh2Y8v3x/nOJ183jZR96hwOXG8lzZIdtVh09ndKVI93qTJUdPiLs2m1bV34kHP1PNnW9eZ1868LmW9/zyoZdcncl4sztcnIo1j6KAvO/SE3Cvk+kGFeit6QUsfWvaCSh8qAeLUnNtAasrN0Eobt3obypqhLABBashNUK4ty9+E1m3QGiBIzbkNpO6c20BqyE2Q1cDsG9AmBG0A8lJjboa2YWjbGUrDUAoQpIbcJpAaciN0UtypE5QxlP0vZBmynaCCoQIgLxIkIkhc2HECkCeRw5A4cBDiZ2IFIJDAqSGQyGFILDg+xBI7YgYgdXQGJhKW2JHIxEOW2BnGJk5GJLEzSiooTuhOfJ8krqBqUah4XqqWeahzVBt/4pKGI5z6EMMAAAAASUVORK5CYII="

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAjVBMVEUAAAA7iMM7iMM7iMM7iMM7iMNVrO5VrO47iMM7iMNVrO47iMNVrO5VrO5VrO47iMM7iMNVrO47iMNVrO5VrO5VrO47iMNVrO5Aj8w7iMNVrO5VrO5VrO47iMM7iMNVrO47iMNLn94+jchFltNQpeY9isZSqOlTqutKnNtCkc5ImtlNoeFGmNZPo+NAj8v80it/AAAAH3RSTlMAMGCAv8+AAABwr+/vEFCf388g30C/UHDvr49gMBBA68t/MQAAAc9JREFUeNrt1UtTgzAYheGUcNFSSkGoWoTzcWm9+/9/nknsjFTCIsl00bHvitUz5AxM2DXTFh73AyICwkhbCBBR4HNvcXMS+31c3D7GdAxYJTonWSlIFT/eLqbQNt3QqHcgSzROBrzTqE26HUM5l8q4VwB3xV+nuAPwSqdteH6E8pSmfUJUrsfMuoTok6aluYTuH0jTfoBstQwLVbhcQTbsSdPDfcR26GlG0qR3qMeOAS3pe8GkF9LXAgI60Exdi5PajmY6KAgdzbXv2wGqoe33NFeHH6gnx3oJZXIkx1ogY6UcybEDULJQjeSSmihklRzJfaKKFQBa54lQsAjAwXkiRCzK5EiuE5UC2smRXCfaCWgtR3KdaC2gBMCzC/QMIBGQGunL3vkCkEUSCgG82UNvAEIFPQEY7KEBwJOC3D6ATp3sB6oAfNhCHwCqI5RkDmcb5AspSFRXy9IXmSK+qFxW9eimVW1NoWZ696u4KcSv0BWaQqkplM5A5r/IFbKGYlMonoHIuEuBcnMo10KNOdScF/LMIU8LcXOInxfyzSFfCwXmUKCDarJIBzU2UKOBuA3ELwLybCBPA9WxuRPXZ/vXVHkamChBmt+MIZf+B/QN/DXgamc8QpwAAAAASUVORK5CYII="

/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAQlBMVEUAAAA7iMMiZpk7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMMye7MiZpklap7CBIzMAAAAEnRSTlMAAABAcK/fEIC/7yBgjzCfz1D/552aAAAB80lEQVR4Xt3Xy3LsIAwEUOfysnnYQJL//9WbzRSVaanFOlpS1GFgaFE+pJo/9fVT81etsQ+hDmnwD0NfRv0T6pAG/zAkHfCq/cN2FuQ2IW9BfhMKFhQ2oWhBcQ9K04Jm2oKcDbkt6LShcwu6bOjagrIN5R2oTBuaZQOqO1DdgNqL+Px+D+v35wtqBIKzXtRi4LQJ9FIWtZhVNnTPCRQwc94m5OdWeRN69qDHhDoCXRqzoDSxWptYyYCcAI0hQA4gjD72egE6DSigE5RRDkWEvHgnIkAYfbx798QqFBrK0hGhgRA/60e5pieFLqX1VIQuCk2spN1TBt3odDU5N4EqQqd6eJVADSGnRqcRqOsPTwaoE0hIAskOQCz6lRyfUyFPglCMdnvw6EcW56BCkf0zjTeAg7fZQfOcEOJT+TIInTyYF20AB53p+X96KVDGXPJEZxkq4kS6UAFIjv5jveZVhJo8j63UAJLPOlnP+SVCcp/gXUaCnJYPtnknQF6dRdbyAvSov5vs/hGgrnQJ2mc6Qonkg2w/AeTItSWX3wF0krZFWt8JUCD5ICkJAGXStUjvy+9QIfmgKSlv0CAxoikZb5DrpI2SdtwdRCTVkLE5sm+eHGpS3v7RIjZHuU3GNozPLN8hH5CS7o3PrLXJqkF1behX/Qf9uL0aTbyozAAAAABJRU5ErkJggg=="

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAbFBMVEUAAABVrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO673fVVrO47iMNVrO5Tqus9isZPo+NSqOlKnNtFltNGmNZImtk+jchCkc5Dk9BQpeZLn95Aj8tNoeG73fUUYeMYAAAAEnRSTlMAAO+fgFAQz48g3zC/cK9gAEBPFKiHAAACfklEQVR4Xt3YW8+jIBAG4AoWtNi6nfHQ8+Hb//8fN0XyhqSgsO7VvjdWTJ/I4ETiJhxm5iIQjH9lEx7+byHBn8hyq3xEbUtpL4hkSLIL66qelLrSGJTJ0Ja9SFUUSrKXbXqNdr4kjBG+s8sodsV+mob9VBmQ4ZmYDKjQcUcXOdA+Du2zoDoO1VlQcYg5hyIPamNQmwkpEXaEyoQKGYZkkQttw9A2G/LbxG+PfKgKQVUeFG8TkwEhOtwe+dDvQH5Fs4lf+leQCkHqL6Z2CEHotMwn+8KfDIM9nLvcJxvO6cz2cGKcsUyH0PwD/VjherXQSBZsUyE4XX9jm/udbR70hLQMweE7XSbg5sAX3TpIKZARdkJE4wQQ8ZSeHtOLLgGCMxC5GY0QL0QnSItQbZ3uRvRiduQAsn9aqV6GlHaFJVcZfoH8jL4tqdU8BOeHiK4OuuInDxiGFIManlaeqO8cdAHEfCOip5WaeUjiv3Rhl/un7JgmTuQcJFFUrBQg3BK9IMWgkqecUQoPQuWxCmUMahk3ZCvk8nZLhTMsYvsFwUGFTowQuUcbC/dgSAHI+HN5cAziq++ab8gIQA96dx7UE/Xs5Ywi2WYBBAfpBiAotp/nyN/SBo0RDKBotAI056BFFqXNosNj3488KwGSvCrSQnBWSRaqeHUqC4n1kFAfaL8e2k81atY6jSu2Emsn5qDiuA46okWKdo3T+r0m1zxEgCCtcABBynYAQVrlAIKU7wBCqvwWC0NFK3IY0cbftGaX7uzM3LtfJU+vUgv7o2PSTe2OCVu/crFSokzbjCpQEUYl77NVq2OMbsHMQoipApauDIAkCN/CGmi6wZeyYP4AYoLcp8thiwAAAAAASUVORK5CYII="

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA0lBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMMiZpk5hsA7iMMiZpkvd64rc6kob6Q1gLna6fR4rdZHj8eZqrUzfbYtdas2grswebHE5Pxiqd7n8Pi20umfr7r///9Ul8vO4fDZ3+PM1dqdxOElap6/ytHz+Ptgns4kaJy5xcw5hsCFtdrw+P6X0Pqt2vva7v3h8v7s7/F+wfJFkMpTnNRwteh1uez5+vqmtb44hL4nbKF+rM+yzuOIyflJUvFOAAAAE3RSTlMAYN8AQL8grxCAcO9QjzCfz5/vjvv+dQAAArVJREFUeF7t1lezmzwQx+HgSIDAGJ+sKO7l9N57TfK+3/8rJfZBZlcSkInvMv5f+mc/DDN74S+2Oa3eXrGjYbEj9Umv5Xy17Iv5EeMA+2dKuvx0LpVztg/A2R9ArgeL9RX0/rFwPt4V1F9mz22AfAHFjpX0uDsc7j4q51h14ddBQQirHSjpcDg8VM5B2cOgEnJbgDbYVtLpqXK2B4DWciugNpCd7xk7B7J2BRQB3bXuXANdVAFxUMs/pR3q7Kioxisg0KFBDzu9gQ6BHeqU0KgA1V2qS1RRrWOFghJKlNgvoT6KaoEVijFk3OWxJUJshbollBp3eWCNXRvkQ7kM3yW5RBrBt0CMQvQuzysis0AC9RPtLn9CRRQWyENdAt5/OyjR6FmgsAoap1AJhSbkojxB0PcfmgNygiTXgNqo5iU0utAdkDmC2gYUWaGxJI4JRQbEUZ1K9VoWB+QUQdyAAC2RxWvZHJAJZnWoY0JjSR071NGgAMdMLl/L7oDMMBRoUKxBowvlNECxBnUpNJbKaYK6FPLpV+X/NZOSuD6B2N9DjEACp6sm6ApDgkAeTnkTlGPII1CoQXs106AQQy7gjZqgEeC5CHJISZqghEAOgqJ1oAhBnJRUytlNFXMz00+VIwjIssUd3d7N7h8Id/NwP7u7XdxRBmQlxEyoeibEVlBAw0kTdEKhYAXFNEgp509VzNP8d6ZQvIJaBgTw/DJ/fSPc09vr/OW5yHgtBfnUmRjfNJ4zocEvIEahvBnKaWAFJNaFRAFxCk2boSkNvIBCCiXNUEJD+Am5sC4E7hJyNChrhjItOEsoWh+KlhA3oa06aMuE+BIyn5i6dZCbmq++hISIOQ8RlHoEN37kpQgKOY+FIH+PGQtExPm3FJx6yIH0G+eRCBijf4/N1UN4/y60gTbQBtpAvwBVKWhKc1Ug4gAAAABJRU5ErkJggg=="

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAxlBMVEUAAAB0Tqp0Tqp0Tqp0Tqp0Tqp0Tqp0TqpVN4h0Tqp0Tqp0Tqp0Tqp0TqpVN4hbO450Tqp0TqpfP5NoRZ1qRp9bPI9VN4hrR6BVN4h0TqprR6BXOYpqRp9bPI9VN4hfPpJ0TqpVN4hoRZxfP5NVN4hbPI9VN4hqRp9VN4hVN4hVN4hyTKdVN4hVN4hVN4hVN4hVN4hqRp9wS6ZmRJtlQ5loRZ1yTahqR59dPZFfPpNbO45VN4h0TqpsSKJuSqRjQZdZOoxhQJXrkqlpAAAAMnRSTlMAUBAAYK9AnyDvv9/Pj78AIDAwAL8AQAAQgJ/vYFCvz3CPUABQ74Dv33CfzwDvYM8wAPjWRQMAAAKJSURBVHja7ZbbcpswEEAxBmFhm0KbkpC2jtNQGlNCXN8aoyXB//9TVVwTDRKSKH3pg8+Mx8Owc9hdxEpGO/FVJuEqzloxsjZyMpOJZiTvLgoJIWm7J6W3wq6i0QORhYeE8jDqKPIIJc8kRVM8rYjFppmElD1FJ7qnkY+ZlEd6+76LKBcbJLYp7yDyWGHy4jy9aMQSUqU00opyvgXtTcy1ovS5Irdq0S0hZaoVXcALidWimBzg4ieHwV37AM9kqRYtSQkQDJsY3LULAMU7DQUAuGoRAsr2g4YtUJBS5AJlZw6V+PCKqxIFcCRSixw4gniRGIKVKSH4g6MQYeiQkgsnTKkIQY0v91hQY0lFEdS4Uo+JocaRilx4YyAT2SxmIhVhFoRNaWEMqQgo6uJ8DMAwu4hg3tagSSMEdRIBkixFRtBNhAPeM4cm6rfGmHANH3AeLBVNQWUKMDSxpaIAeNOXj298ZR7Nyma1MZ4/zZI8DPNk9m0HHGPFR4tAMBXkSCF4YKAabBbw7I6mSvQ46pltNTuxWp8yqjYraBAJM5vDjCZ1D+x5MAwXiUdJFmHmz+1xfWvqD0WRCHpl2EqAKGxVqEV6zqKz6Cz6X0TXN2kSLzMNYZykN9eXDYzLJvNfFaF4XprQGXRidPpfJEnqeYRSff8sHI85LCifiIZ9+eP9HYdxxxNgNmDbKNYrcHQ9YhvhanuoREl12K7YhqYRsS11V643+ydKQX/7zbrcsY1RI2ImORgpX393U6BcR91N1l+u7EDp0YsYFrQx7fGtRSDi9vpobeDBZi+ROZYcZDQifcPt3vMo4grrP9jG3ImotwhxCfUftS6XkF6kT8nsJRJTcv5xF7HYGlLzG+4Px2Zdn12MAAAAAElFTkSuQmCC"

/***/ }),
/* 913 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAulBMVEUAAACqjdiqjdiSZsyqjdiqjdiqjdiqjdiqjdiqjdiqjdiqjdiqjdiSZsySZsyac9CqjdiSZsySZsySZsyac9CeetKeetKniNedeNKqjdiniNeqjdimh9amh9adeNKgfdOqjdiSZsyqjdiqjdiSZsyniNeUaM2hftSHXb+Xbc6pi9emhtaactCjgdSgfNObddGdd9FgQJVkQ5ldPZGkg9VZOoyVa857VLODWrt0T6qOY8hsSaJwTKZVN4h879dfAAAAI3RSTlMAEM8AMN9Q74CvYI8gYO8AcJ8QzzAAgADPAIC/AM8A70Bwnyj7HGgAAAJqSURBVHhe7dVZb6MwEMBxIA52IKXpfbjd0o4h99Xz2N3v/7XWDGlJYsSM8lBpq/4fiGTJv4fBJt6u/eQHg6e/NT0NAv+iNq92VbRhMli6znIwgbbgQ6EEmJn339vOn3czA5AhF1Jgy4wxrw/rzMOrXcrApliQ3wHs2dhekELmxdieAev4NCQCKFsYbPB2f7+8fxsYbAFlgaCgSMKqqalpCqtk2AzFUFUHQVXcAHUDWGviOhNYK+g6UPXW15sZLC8f2AzWk2Et5MewWYbOcFwI4yFCGWwW+y4kAqiqDsB8hLOC0Rxf/naB2IYUuC1M3gcoIYB+bhbgpjYgEUBN0+EYKgjGwynUFIgPaC9J+tAQQg31k2Sv1fJafmKMedwderTbk08oz3aFsvwDat3iWx7tBo3wXNwi1DoopPlu0LxwDloldHiEp5YJuaf/6BAh2zHegEcO5A7a5Mf7Nm+/6BQXMgbkDtqcnhR5J9h5OXAacgd9/gvzyh8xdwZOQ+UesXnXLlHHgeuIgiL9Oejh5VmZd7bquhh4DjK2nysKsp/AWAJuuL5a5V2tEnjUowsbDRVFeLWE+2FTN3j5bIKCit142W9U4x9kSkFpteHbQT9QSEEhE1IUpP5bKKagmAlpCtJfDQUUFDAhoCD4YkjQkGBBKQ2lLKhHQz0WpGhIsSBNQ5oFtWmozYKAhoADpRwoZUCKAykG1OFAHQYkOZCkoRA4EIQkdMeD7ijIlzxI+gSkgAeBaoZ8yYWk3wT5GrgQ6EYo7cV6+67lxuRbSFvHvdSB3LpppJTWWiLUz/M+AtIuKRWl3Qpwod37/tA/AzFCHVQrCFgAAAAASUVORK5CYII="

/***/ }),
/* 914 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABAlBMVEUAAADqWW7qWW7qWW7qWW7qWW7R09TqWW7boKrigpDqWW7R09TboKrR09TigpDqWW7qWW7qWW7R09TR09TqWW7qWW7qWW7qWW7R09ToY3figpDR09STlZjqWW7qWW7R09TR09TR09STlZibnaDVv8PR09STlZjR09STlZjR09TMzs/R09TR09STlZjR09TdLkTqWW7R09TfNkzeMUeTlZjcnqfkeIjoYXTapa7WvMHlcIHoVGnpVmvkRlznTmTelqHhO1HXtbvmTGHTy87lSV7hh5TnaHvfM0nfjpvjQVbUxMfiPlSjpae+wMHgOU+XmZzoUWbFx8nJy822uLrkRFmusLKm+TC8AAAAL3RSTlMAMK/fgJ/fEADvz4C/r49gQHDPMCDvUI9gvwCP7wC/70AAMIBgv99wjxDPIJ+vUMBXldcAAALKSURBVHhepNLJbqNAEIDhnLggLubSUiLFyQzjYexQ1ew73rMvs73/q0wH1KZp2jgZ/ivSp6pqzoa7vvG/fVlo2sK+OtHZ4NfrC99//UlZE3sUdOP7/l9ap4+CfNZzA1mjoAsG/W4gYxT0nUFPDUT+G5rOdOvHL8qzLEMn5meh+cyiyi6N2fzjEJnQoSzyMUjX6Kk0chpyDswquAvDCHlhGFbx6kA5w5BtNEhSpRzIGJJj6wUPDWXYA5BZj7MJmMLbrhnwVqBQGm/qu0+PQuTynakibCuhBrwSxaKqpsgRiFBWIDKYecsaWHoZdqmAS33IYUySYicXts2C4KJUmnBJgky2Vxx1nUeAZpIM4F6WophJ0x5kTyi9w25rOAziApQot2MXn8vQOaU7yck8AP5cBYCXqyRLgsy+gy9Qb8Z3gyWqJNKFLBrITgEgnPiWSWuVpNkiNKUrVCwGBfL+gHI5jKkuQovNXoaWwMpbF1j3fSh60ATI7j0YliBdxYXmZHIhdVqIJCjngnSULbAesV9stJARKge6FeXcOzLSnrZQgsoLFdJvrr4Sxg6HzJ3s5NB/pIwPKbfXOfT1X7N1zBIxEIRheC6ZEA1iJpA1KHwDllZOZyFnYSOHIBb3/3+LwT1Q2BPh9ivuhS3zZJawS+LozvYR5UjPUXZ1sSbrui6g7eHl5UgvUXZ5tybruj060WfB7/+Y6OnhsLUURbuP1yjb5e9fZAAE2ERtmqGxGvIMaTXUZsijugylesi+oahvAgRGgBZAMBIgBwRKgBIg8CDUQzAwIIMgGE2QmQIpxCiQQ0YK1EI0KEEWDrQR50DGgiYZOJBKcOpYkJ8dNLCgOEPIOU7Lgpx1+hsx1hFBIl0jWEg3JGbGSCPnRysGQABotdNnCGPd7poeBwi9ptMZAzKUu1lOuHRTM83ICX5lptr5WvvP8+7e6WQ9fvoC4aCDgHlRJecAAAAASUVORK5CYII="

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA1VBMVEX/2YOSZsz/rDMAAACSZsySZsySZsySZsySZsz/rDOSZsySZsySZsz/2YOSZsySZsySZsySZsySZsz/2YP/rDP/2YP/2YOSZsz/2YP/rDP/2YP/2YP/2YOSZsz/rDP/rDP/2YP/2YP/2YP/rDP/2YP/rDP/2YP/2YP/rDP/rDP/rDP/rDP/2YOgdMP40ojJoKjPp6Prw5HkvJWSZsytg7qZbce7kbHCmKy0irX/rDP/2YP/t0f/xWD/sj3/0XT/wFb/03n/tEL/1n7/rzj/y2r/vVH/zm/70EkcAAAALXRSTlMAAAAAv0CAIK9A799ggDCfUM9w3+8gUBC/cM/vn48gjxBgr2Awr3BA388QMI/cF30NAAACLklEQVR4XqzSSY6DMBCF4ah65QUrIAoQQeb5Aq9sIPP9j9Q2SFGnA0mB8h3gV9l6g58v+RBaeLOYrXjmLQa9TTyf//C9Sc9Mwv8kfVJrnxv4666dFdeKUl+Aiy4Lrq26dcZcMTkecsOVcffONceT/Nq1dGCnxIuSnYO0M2TrrOFsI7Uj2qloC0ef2RrKOmHiOidYWUoPaQbr5EpJKAqN2LoBWKb0JF0CuLE1Ej/MAIjoRQTASB/nhngEAkUNVAAc3TA/d6ZsaQR7arQPoNmain7oDsypxRy4S34prA/KqFVWnxQKtlhgQ29sUAhWGVeTVvSGqgYetzd+W6tzXIdhGIqiNiBKgiPIQ+MqS4gzMBO8/4V9fkWwnbhQ8Xhr4gBSQQbP/JilExc6zdKD2Yd6qapzsWfpLc6Vi10FerPUx18oNmniLNClDF0EOieyid+Q+zh8E+hVhl4C3TjVuC/I8Ardy9B9hdhsIeLctPx18bcnztEGajk3SwVkN9duoB6B+g3ECMQrNGLQuECEQbRAHQZ1C2QxyOpDBoOMPsQYxOpQRKGYIUIhytCwQlNaD4V2c0OG7Ao9p+lZQvZzNkMtg7UZMihkMnRAoUOGGO4DORxyCSIcogR1ONQlyOKQTdARh44JMjhkdCFWSBUiDYg0oUEDGgSyGpAVyGtAXiCjARmBGg2oEYhVqiunA7mKdCBSg/Selo8RfJCqOmhAQXWxjR51/PgPSQGifBBCIKX+AGrX8pHx1HpNAAAAAElFTkSuQmCC"

/***/ }),
/* 916 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAt1BMVEUAAACm04im04im04im04im04im04im04jBaU+/cFPBaU+m04jBaU+4jGLBaU/BaU/BaU/BaU+m04jBaU/BaU+su3u1lmem04jBaU/BaU/BaU+m04jBaU/BaU+4jGK6hV6m04jBaU/BaU+m04h3slV9tlum04i0nmyj0YWAuF+MwGuJvmidzX6Pw2+ay3uDumLBaU+XyXigz4KRxXK/cFOGvGV6tFirv325imGypW+tuXqozISUx3WSWKbtAAAAJHRSTlMAUI/P758wAJ/vjxAgj+/PQL+AgBDP32Aw3wC/cK8w70BQYK+mNODXAAAB0UlEQVR42u3Wb1faMBiH4f7R4QyrWJhgq7OMx9+KRawi3Zx8/8+1pFlJsp1jSzJf7Jxerzl30jxpD16v1+v1er3/0vzT51d0dHT8YdDwBrr5yccXHCRgf4eGp1H5/B0HCtkfodF5yalO95IRGvIM9w0ocIDVPYBYC43L2vMrsC0O6FQrceSsCU3OSukCwI6K7p1bCNPfoVkkMyfDAEBOtEMn+ZLuIAQyNLkshfNhkqTgtkRrdPFAtIKQylB9zNFVwoXgHomqJ7S7I7rV5ubN684sEVCriJZoI9ajDaQ6dC1CsvNlvxTdo0VeEVEOiYmQ6IwTYXaD2hNxbQ9XEKnxZk1oJDqj6AekLRE9tEyeSJuJr4UmY3GvpXX7lgpjrXj/aKNTcQde1GDbTkltqLlI3lm59xNQp7TFG3LzB6kIXamQevV3YrRvqWiZmx8Ab9Bs6XIOZb1pOewN7yjyFRnz84muvyYM1pgI7WWwlhkhH9Z8IxTDWmyEAlgLjFAKa6kRCmEtNEJwoIcYHDAtlMFBpoV8OPC1UAwHsRYK4CDQQikcpFoohINQC8GJCjE4YZ66Rk6yfx1yf7R3mNoUDqbv8mFjC1hasDqk+AurjG/8YXf1C0dMoJN610QfAAAAAElFTkSuQmCC"

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAnFBMVEUAAABmdX8pLzNgbndmdX8pLzMpLzNmdX9mdX9mdX9mdX8pLzNmdX9mdX9mdX8pLzNmdX9mdX9mdX9mdX9mdX8pLzNmdX8pLzMpLzMpLzMpLzMpLzNmdX8pLzMpLzNgbnc9RkxFT1YpLzMpLzNmdX9XZGwxOD1icXopLzNebHZIUlk4QUZPW2M0PEFbaHFETlQ8RUstMzhLVl5ASVAOBx0xAAAAJHRSTlMAAAAAgIBAvxCfz7/vQN/PIGBQcDBgryAQr3CPjzDvn4/P358SNdvLAAABbklEQVR42u3TWY+CMBiFYeiAUAbcd2efo3woisv//29TW4yZBCoJvZhJ+iTcvrQnqWNZlmVZlmX9YwNv4DbmuLU4gKDfPuThKh62DSUojdqF+jGk9SXjbUJhBCndEF3enxpwxDeO0eW/tki6ZWdPRKeUNzxRoGblg8SVhhzKekNCDkRhk1Af1dKCrgpAlh6HRtWZy+nWUaXHoSmqZDJzyiHlqqQPdVHpuvMug7SlTS5K+lCIamc6rqHkJJyjUB9K6rbO7klhD3QTbWgEvewox5JZ3teEPH3mokY/QIlG47pQAI2UpL3qlIKpV5oGQRwMm4Qg71Wk0OEqFEMnJ9od8ACXIWilRYbHPBEKYUAcuk4CEwamQp7BkAcTuKlQ8OdCkalQ7DrjGAa8iCfysW3vc86cCZmwYI5PJryZCpEuNGGvPWpKs1GPCU3P22MOq/urz65mqy9qYCVCv806NzNWmneWvr94vvn275YdZc7YD7ltEPZyZXtyAAAAAElFTkSuQmCC"

/***/ }),
/* 918 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAflBMVEUAAABVrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5ElNE7iMOJstHM1t3M1t3M1t1SqOksc6k8icQlap41gLlIm9kveK5Ln95Cks5Po+M9isY7iMM/jckiZplVrO5EjcXM1t04hb4yfLQob6RZtRFPAAAAFnRSTlMAYO+fIAAwEM+/QK/fgHBQj+/PvxAAtub08gAAAS9JREFUeNrt0V1vgjAUgOEWGMUCOsVVQD6UHif+/z+4HAKELRVIONlV36vSJk/aA7PZbDabzWaz2Wz/GHcc1/tYHXt3wAFDahvkO+gg5W+CRABjO7kBCnukfVVI8VWQJ6X4s+v2TqO1fuEi4suQwGmEfGL5wcTRT4BlCqF4GEW8l9h+eJZq0bko6IvkPBSBMZVm6GSD0ygAV8xAvtlBZnqfp85SNfc+tjdDlcZyNf2sulGJN1BohhT+r+t4P3QK6HJco8V2YK4tKugrC42sgrEgjA9S+r8gWOqa684pwZQT8pVQrSdTNxYdVkFwQSeFufgqqNE6r2E+uQaqmxqWigRCFHEqKKCCwKOCJBUUs/J2J+j2yY53ko500OlB4TxO7JsoOiihcRJ2TkicM/si6gc2qe+cWlunoQAAAABJRU5ErkJggg=="

/***/ }),
/* 919 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAnFBMVEWSZswpLzNGPl0pLzOSZswpLzOSZswpLzOSZsySZsySZsySZsySZswpLzMpLzOSZsySZswpLzOSZsySZsySZswpLzOSZswpLzOSZswpLzMpLzMpLzMpLzMAAAApLzMpLzOSZswpLzNGPl2SZsxkTok2NkZ4WKZxVZxeS4BrUZNDPVl+XK9XR3YwMj2LY8I9OVBKQGMpLzNQRGyFX7n8CWeaAAAAI3RSTlMAAACAEO9gv0Dvv1AwQDAgzxCfj4Bgr5/fzyBw3wBQr3CPr27QZlkAAAHtSURBVHja7dTZVsIwEIDhhi50wbZgWxFQ0BEUWTT4/u/mMYhDOrQJCRde8D/Ad5J0ps7DhbpCV+ifQlnoOZcoAIiyyzgAt/ZOAj/l1k4vApH1K+WwL7B0CvitsrwYiOzvFiNU2DghYEPLA2GB3Qthkfkr3aJiN91DkOsZOhnUyu2+mf3lvC2REiMoXRMoMnqmku8W5JlMZsDlnG/qVmwAdblovpSkgSEkqIW5hJDoc2szBPyozcJife/5cS/mt7vjUjtjacybpco7Z7J5i5RnZ0h+mxQl539/7E36F3j6O0J6PZaGuod6pNDmS968UAu64bQPkIsDzwjCZ8KqIgnDWa8F6vND92WajidctEJC+091cFz2U38/6u9wuoEaKtlve2nZIAVKiP0l9ngODSUKyEdo5OOPgBb12qEuw1wxTNsmKdCG+tKRaLM2aMqOGkuvRIuzZshl5EhLaK4KtSDmklki5cFpaMzokVbQWlR4J6AbJpKmcg2qBpkKGokJAHVxWINSJtfFP5wOhRCr9Yi/b2VVRiFsorgbHXZcNaknxd3oKuOG0Ofe6UIFgeS/yfxsaEqhEmdS82q4IXS63/ScoVOD6HTvdM60fe44nU4jlHL9SocxuiE43dq5rdDItzsRlk70GN9lB4hZdjnoGyT1cTP4qINAAAAAAElFTkSuQmCC"

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAACpUlEQVR4AezBgQAAAACAoP2pF6kCAAAAAAAAAAAAALjdelmNGorjOH4eIVs3EnEnCrGiYKsSQUUZpIPQhaXQIHVRGDQoioiDQQRBkCCILgTzCHmDZmq9U4lUvK3yCHmEv79TZhaOnds5v7Q0Wvh00RkI+fZc/hX+rOw57EEBsoUMEgjBBcWgf+0mCciYCojB/ZcCFSAGEnDqHsgFsZCDU+dATRBLUZ0Dxf8DDZcTAvlWgX69euBDCiXICAVkXREE4IOqAiGOmNxovTAOpCAkBaQQQRNcyzg+KZAyCjQ0Dj9aCN6EgSJCnMwkUG9byQ4oIYEAnBGBUkKg2CQQYfXQpBAMCFQSAoVGgb4+vSX5o5Z8frgs69FVeX974S/67/pzTX//27M7Va+sCNxuHA+EwDcKtLo8K6be3bwsn9pXdOCqosWvD54MSYEci0Acb8K5zWAbT27QIn1ozDLilKAIgbg+3l2UL4+vy8+X940DrU35jEAZJ1D1sSaK8+N5mxFHi6sPRLLWuqS3oT7sRwbaaF+jBFpfmO9N/SlEEI459ZMCWZxZ+mb8/uLeloHwYpRACD3sH5FDBB4/EJEeJ/q34Nvps5RAE077ETj8QMQtqOcuvao6+45Zx1k9MGM6iwXsQAX4XTEUIMYWG5TVg1VoM2aEzEAxqD4BZCCT6jTOsA5om0AlM1AT1AA+pCDjyk6cogTKW0vmgYAZyAc1ggvJWIEOHWfeYKaK7QzUHyqGcuAWm78gK/uP2gayfi9+oMk4EEE57CzKpqbNAu09srsD9QmG3nxLF6XTPKfPprG3H8LWIZDFgY5RoDN3fnOVdU77f0BMwjtxAykyFyKLearWgfo1IYFymwMVqrecLeWgemoUK9UP9CwfVoIHagd4EEICOTlOCd5v6VWaaaAlvEAAAAAASUVORK5CYII="

/***/ }),
/* 921 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAllBMVEXBaU9mIRPBaU/BaU/BaU9/NSPBaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU9mIRPBaU/BaU9mIRNmIRNmIRNmIRNmIRMAAABmIRNmIRNmIRNmIRNmIRN/NSNmIRNmIRNmIRPBaU9mIROOQS1sJhelUzyZSjVxKhufTjm7ZUt9MyKIPCqwXETZnoK2YEiqV0B3Lx5pxy6kAAAAInRSTlMAAECAvwAg3++vYDCPEFCf789wv2AQgEAAn1DfcDCvr48gp0cuWQAAAa9JREFUeF7F1ud2gkAQgNFtsixVUTAa0wC7ae//ciExBwR1nUnm6Pffe2YHKeyuTggpjXqryuuUChLBwIkkUG6+r4GajBfCoB/BAuUuFRQzIigiglwGTF2ADBXkUUEOFDJ2SDNo0g7FVJBHBflgKLFDDJywQooKiqkgCYccKyQYvOtA7BaQSwUpCzSggtRNIEMFyWtAmgrKbwJFNshHQMIGCSpIUkGGCtJUUO5QQQkVpOCQR/Q1wgI7JMGQzq25Ify9Zi/w4Sezp0P4S8TeAOL4FgDzKREOckgS8FSD5QEuGVbCD4R5Vmo45Pr2kyGk6NKNT7CncIOTgnPQQ5njGpxZ1KjYfSApc3JTWVG1Xb6iKB04R9Cw2LcqF7gTJk4XqpuXuLmMF3agptUSdxHjZl1FJ+zutXTqibqt1sixxP7yn2hevqMo5VfSfXGyHW7xEWOz4kxbzLIkY+M2MJ41I36u/w71OeejfrP3BfxoaQsa8qp00shbEKWP/kkT/tP0e6jm5tlccDaPPdbrtaCM70ufClQjxnkLmlZIPRSirAuNeV36/J+J+GEvE+BU/Yx/AS9PheDPaS25AAAAAElFTkSuQmCC"

/***/ }),
/* 922 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAABmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIROuRplmAAAAEXRSTlMAgL+vMABAj+8QYN9QcM8gn1r1vj4AAAK0SURBVHherZfRrsIgEERl6bRsoQX+/2dv3FAJQhbb3HkQNXhg2B0aXzdlyC4Y6YWftJZfbzlnx49Bu8vZBwDIbx3yzXYftGZRuN5ZyGhug2wWOS4gEof5vA3KRQe4jCQjYMg8AdHnsI3sSD5tz0DYpPzxDdrl1d0A+Qq6FIhMKcINkCkgC4B3Q2SNtNXy5vgbIHZZtCOmXOQNA6d8+TsIi5BSGYucAScK9yLCG5EpnCpiQQSftw6k6sxf8svV9/sYBEM29onLnU4ufW+GIEmAZwHENQ43VAtZcvj6jjkxuNQIYHpPFiQ4jxSkyzxaUJTilGgagGUTJQVhCPJvx7R8gQ4hVNDVNbG2ZacARKCCgk2xzEX8ZL1oV0CpjcgiqT5KCpN8qmZMuZU69RGR5Q525WySZNzUiwgA5bG4AclyFgvR1oc1L4q1vDag4+Mg7htRMqVnRR6/g8TUAuz08b4CJVuhrjUFISYbsDZp2hDKKFpnoN25DcPNb1gt2TIRPAO5a9E0nFPlJ6Crd7fciRpQmpTfCXYcpQVVgxntU8QIiN0IdDTehlPoAoknK7iZt20EMhUEMOC1IBVFxX0N7VhoZMdH1IZ2rOmtnb5ANAeNmzv8E8jjC5QfgsyPIMKk/vFHkIWetoQfQabhHEqq26rp8WenONdBbtKOaw8y8yMKeile2hURVGM5DkA8dZY6zoYBCOekZrFfhluQctewWvqAIWjpOSeqYJRCNCB4/QyMYqwFbXpbG8VYC4p60FZlty0IVu9r166hgFatLq23kzUQvBoBPhuOBtr15yPTxWfooH5LrkkTduty9kJXQXq+q+YgUG/uGWiZJHMOUtr7GYidktw5SD3vhyCk/wKx/x9r+P4HbJ+B+qTsj0D99ezxCNQf+PoE1LtzAc9BooXeBTOMx6Dn+gOHaMMgXUWumwAAAABJRU5ErkJggg=="

/***/ }),
/* 923 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzPqKuokAAAAEnRSTlMAUIC/z//vn0AAr2DfMBCPIHDXtvFYAAABXklEQVR4Ae3XYWsDIQzG8ap51Bkbr9//yw5uZYzSaLK79cXo/63wg9rD6OVFhZgIezmVWD/0LpO10PBQLtUPccezOvugStBKVwcUMSmzFZKGecUGCWFVMUEJ69gADRjK2xKqMJWWEMFWXUAMY20BJViTKSQwx1MowFycQhHm0ht6HTSmEMPcbQbJgLmy6ZAQHOWrChW46hokcMYKFOCsKFCEs/TX0O0sqMLZ0P7+Dl9Vg9j7yxTIud0ks8PfvOG8zceRwNi2mrQNpmg5shmmWIG830CWNcQwFC0XLfKdRDp0xbKqQN5REq3X42I6zxTIvk0kCuS8aTdxvUWGZcAaIHUSBP8zC0+7L74hqbEkPC1WsUJhEKbRCLKChBtMNZYJVAsctaBA3OGs3+QBWjNKOT5AlfDLev0JRRxofEOScCiSO5RwMPqCIg4XdyjjcHmHcEL/HeKMg2XeoXM6DfoErGSGD3VFgdoAAAAASUVORK5CYII="

/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAmVBMVEVmdX8pLzMAAABmdX8pLzMpLzNmdX9mdX8pLzNmdX8pLzNmdX8pLzNmdX9mdX8pLzNmdX9mdX9mdX9mdX8pLzMpLzMpLzNmdX9mdX8pLzMpLzNmdX8pLzMpLzMpLzMpLzNmdX86Q0lmdX8pLzNXZGwtMzhETlRLVl5baHFASVBTX2debHY0PEE4QUZPW2MxOD1icXo8RUtIUllu7yfZAAAAInRSTlMAAAC/v+8Q7xCfnzAwQI9gUN8gYCBA33CAgM/Pj1Bwr6/f+rxe/QAAAcRJREFUeNrd1sdygzAQgGEcEL0YDNg4kKJ1r0ne/+Ey45OD0O7K45TJf/ThG7ESwtbDnTKBomlqX0qnkXVzxSyXV3nBbZabSiW7MHeSXA7kTUydidQUmDraUqPnkkhjgzl7GJS7bGgm0aYGC0LL+ZMmKphQgDP8cdsUNPuHEL3/8VPrXGqf4hE57ESjlE0NV4nXDQEF7hDjt6B03OPS44BU1TDQ8mQ6pQw0bVHIVh1tKxOoAqQdH/IFBp3f9NDLV6gBtLUemigLwjpztz8Dor2GSXrHKKSgHfM74lDQxzBU3AmyrTtBkTm0xifEH/ZiaMtUJyZXtFXPtlcoTimA7NCXvAh5MKw145KtOdBRecXU4AbI+lZozoHeGVDDgU69wzh2Vcifs7a/X5CoUkUxi8HL1lapZxxasb+0GXVB6soj5FDiW0+8Kh0GbSQmuewprSRawD0DB4nn9S8lMews95LIYknLjeRA9MAXkqzg/EU60Y7NulBGrKz+D38LqhpnrkJt5xtBXShAV1ixoawGNKdiQaUDZKFPQ50ARnVMQR3wEjEOlQK4ko9CIbALUQj4CQwqwSB0Rb8ClRjk8B0HW5FRPwB9AjnWmDNKHutcAAAAAElFTkSuQmCC"

/***/ }),
/* 925 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAvVBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoJmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRPNhGnBaU/Jel/Qim/Wl3zYm3/EcFXTkXXVlHjMgGXGc1nSjXLHdlxmIRODQC/Slnuub1jZnoJ8OCigYEuKSDZ0MSFtKRq1d1+YWESnZ1G8f2aRUD3Dh23LjnSJuxoaAAAAIXRSTlMAMECAUBAAr9/Pn3DvjyC/YDC/AO/PUJ/fEHAgr0CPYIBWTR4uAAAChElEQVR42t3U23KiQBCAYTHSKpIgWVxFJStijJvDgK2ixpj3f6wgSrXoAMNYtRf7X3kov5qeGaz8s0zHGUX9dhz7V16VnO/M0bDHzut0+2ZpyOlajFev65SA7D4thWP1bUFoZLH8rJEI5PRYcT2nCLKfmFhPdi5kdphoHTsHMi0mXs/kQeSIZw34EDni03GhATmiDblQh5Wvz4Ho3GW2iSCTSdW9gh6ZXIMLyGGSPV1AQ1nISkMDJp2Tgv7IQ6MUNJSHHlNQTx6yUhDjtA7P3yxY0nYesvOKoFXgs6TwM5gnL3eI+LkWhvwd4jwhN4gYxL9dLwM8tF8IQYvtNx6ar3x/uQkwbv/lr+YBngoWGRAZy12AAgVhLhSicPt1HjRH8ZY5UIhlCi8vJP2JbFC85FS7HMhHLL+k/hmkGMd5dyWhLYv6NhQAqECUouNGZkG4P9wXRF05QU3EILaxbOvjOTePUA2jVox9YelWpylqMaTFqwz9IH1HlkhlfR6cnhkthnS8jkWh+Od6DKE0RP3vkH471KDjp8SPn9LoQt5WLXlEbqxJD2127jjOxczooQXFQMzCxqeyEET6G4mryUE1OEaQKjeamoakt7wJ11BLBmpxoAcZ6IEgql7eqQMPqqa32Js840XPEy+97VUuBAYmTcdxL547mc1mf2dRE9d7ubwIBvAhJXV7uKUhJQOCexot26HR7iELUhu0Ha9vPOXtlTauoXIgGo6avrveBxkfnvs+RYoGI4hqo3Bt4EAS97sF+RDciTl3wIEkpmtDMQRVvYjRqyACgVrPd+oq5ENUtZHNNKoAhRDVbvKZZhtACKIUrXG1GE0BKAGR1dKMBDG0FimFkHw/Pm/Vg9bTmH0AAAAASUVORK5CYII="

/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAw1BMVEUAAABmIRNmIRPZnoJmIRNmIRNmIRPZnoJmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRNmIRPZnoLZnoJmIRPZnoJmIRPZnoLZnoLZnoLZnoLZnoLZnoLZnoJ2MyN2MyNyLh7ZnoLZnoLPlHlzLx9mIRPZnoK8f2bDh22RUD3SlnvLjnSDQC90MSHZl37bZmPdLkTagnPakHrdPEzbbWeYWESgYEuub1htKRqKSDZ8OCjBaU/cUVfNhGmnZ1HcQ1DcSlS1d18y/nzGAAAAJHRSTlMAIBAAMIC/769QYM9A359wjzC/ACDvrxBAUHCfj3AAn4Bgv4+dttiuAAADHUlEQVR4XtXYWXeiMBiAYQkgCu4WqbXttDNf2Fz3pfv//1VDJCUkkko8czPvRS64eM75Qg7mWPm/0lCfC2l9aRXJc8OsupBUq38r9RokuVXTUIBsB7KcBmEa+Sd2SajeBC6z3zeBq1kvAaEaiLVaIFZDlyDDgVI5xs+Q4ULJXIOH1B0mySHkgEIOkkI1UKomg9qgWLsYQq4q5KJCqAPKdYogDa5IK4A610CdAki+Q3s55J5DNkgLQ7lkM+jiGdrHgRyqiRACaTuMN3JJhOpSZ4OTjlKoLkCmzHnHpEi6TaYAVYuZcYBpu0kxVBUgt0jZJAzrKyyyXAHihMO77+PiYt/f8B4PacAKY3wh/wgsjYMa7NT4uERbBjWKoX2AS7WTQsxRkOSQj0u3KYK6v9kpLh3d8d9dPamik24snA4WqUB+CmHrJoMGGO8JtM2/lS0WE5+HxNljPPiGvIQfEyjKIMJiMfF5QKBxInoUuqVbF2I1CI/ptt5SaEjf5pcqtEu/VnhIobsEiMksqlAEAHEC3eVGw0cYK0P4CEecG62bnq+tOrRNT16XQrqVAAHZIoXXTzcpSFYrO0cjAkx8rJw/Iesog7on/RpoRyejkD6QA28vp97k2kBnkGdJoRea1LG8HKR3rWshq6vnId0bWdeMZo08nYPouVTtNlUE6I869PD4XeUxqw6BqhOAcX4/Qu7Zh3Y6vfjZbqIzqAUw4Z3ZfP4xWyxTYLmYfcznMx6aAJgipAEAP9t0Tlt9fq7mNGEyAFcToBaBQh4SE6EQklo8hOBUxI8mJIwWsUs7g9qEET8dy/XriiGr1/Wy6Pe/zUEOpMVYaLpYrGez9WIxxUIxpDl5SAPaAZfuADQtB9n5K6zqdcTOQS1QvdYE+wxqUUi4ih6jMk50hCwnBwEoSNRhMQgBL6k5oGVQA3gp/tmJeQcaMsh9GPzkDH6BHBL/ZBhaMsYa6nrbLQOZJ9t7KqSsJ09P0qocxL+1qpGufZr33BOZ3rOn0+wmIdqnVcufo6pNVxKz7nt0Rqt3TxQWSqhmP10pdHUaoqsEUu6fQn8BDaJfbLrvJW0AAAAASUVORK5CYII="

/***/ }),
/* 927 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAq1BMVEUAAABBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJ6Y1pnWFKXdWbZnoKEaV6qgW5LRkbQmH5xXVa9jHZUTEqzh3Kge2qNb2LGknpeUk5UTErZnoLFkXmIbGDZnoLZnoKgYEtmIRPZnoLZnoLZnoLZnoLNhGnBaU/ZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoKdXAqKAAAAOXRSTlMAQHCfv+//z4BQEABgryAwj9//////////////////////gDDv7wDP//9Qn+/f//+/j3BgEECvIICKu64RAAACbUlEQVR4AZzMyQEDIQgF0FHxGxni0n+zueTmBr4C3rPjfKCIv0SfzO/S8y6wfDFKvtiiGrASnD4qhB2quogbThoroppw1usxyhEqcogEWm0bCfTCJqoRBn4ZcYdJXkUNNrHMIwcrmkcEM5lFDnZ9FgVckDFi3EhjlHGlDFHDFf+rpg6W24ShKAx3dXfdQI4N2EJQtUocywkmxMn7P1mNQsfRiXCEd/1m7AWLf5B0RRiiM8tySfXzS0gu7oBV8lBeCa1wti7kQyGEzIcyeGUl3qbwubtiaWhbYqLGncrxUarLOl8WUrjYaN0Am1ZEKgDlWudFaigDmVa5xT9K1Vrr9ptQUSKm3uYIqW9CGVLlFKKBbJBKUSi8/BXS5dO3jUO//CEjnYqHzG85K7H0lf4Y6/2wk3u0Ii0uHna7B4zoGb3S+j4MPQK1yAoXuzMQepb7NTwGoT2ATNSy0MaPyz4IObCEENZVCbgghCUh8n+E0o6f0Gbf7EDHf7M9DeTNHvmK3IiuiDUOcU/P3hPinKGQNR2inieI6oyl0Fm3PNRZj0LH5Us7RkM9FuujIYPFDIdmxltLQIM4Gw/xeJdCQPYzoRd8platkHal8NnLTGhwmDR1VUhUUdUNJm7gEK9Ny1UavDIOmZm9YXRmFBp1aaGSxvpr6BWe9vsqEf4ENLxXCgVOuJBRJpOMB+Bkr4XeXDCOWTP+6/GHJgtG0r1RiPTp14xDpEOSzsZCNJUJ3BAJEeMSOsbGQ+kl7nAovcQdDqWXqEMhMnSY1fE+U4j0DlGut4xDZDgi4jjYlBCl3g8IHN45Mx8ipj9NscOpN/aKv5ltkO92QY9NAAAAAElFTkSuQmCC"

/***/ }),
/* 928 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAolBMVEUAAADBaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/ZnoLZnoLZnoLGdFnZnoLZnoLZnoLZnoLBaU/ZnoK+GTHKU1TDbFLTkXXYm3/MgGXEcFXBKjvSfW7KfWLNhGnHdlxmIRPPh2zQim/Wl3zSjXLVlHjMXFrXln3RdGnPbGTGQ0rAITagYEvGc1nUhXPrtu9BAAAAGXRSTlMAIBAAUIC/32CvMJ/vz0CPcJ+vMJ8AEGDPdQG/1gAAAl1JREFUeF692Nli2jAQQFEQeJMFCUlIMvLKvmZv///XShqaCSOPkNym95GHw1ggGdz5r3VF72ydni3RD8IIfheFQV+0g0ScACmJhTckU2gslV6QDIEtlM6QSMFaKtygvoIzqT4L8ePwQ9khMQCnBsIOSQWOKclD6PhLHcbxljp+60PXiYFC8CxshgLwLmiCJLRINkCDNtDAhGJoVUwhodpBShAogJYFBIraQhFCzArNF4XzKiGUmI7WlROVfIVEk6MdKfEFik3nT5sf568NocR0sG09OXNtCKlmB63NnB9MISSpw1SW5bo2RfkJxcSxt11PzEXqmAfIWp9vd0IFn1CITFFqp2rAwgao2GvHNk2Qh4OtUTKhtfZoyUOF9mnLQ7XG3larNwLQ15YstNPY6hAS5DWySt0jNIRjpR9U4kTfBW39oIqFKk/o+y9t4/fxb1hoob1asNDSD1pSCA9I5m2ZYS2btjQh/j1KC1T7QLUFmvhc2sQCgcfBtgcbNHeH5laoqFydqrBCsPD6NlIoZEZ6yLL88QN4zLPsgQzEQ3Sk7NA0n/2czfJpdogMxEP0UMpI5OA3oYujQTdcfurkZJuZUADMzf9pisz06fTYxyLz14i5455fXt+V15dnusvoLRvPEecb977gIAGMxDkc1IsMycOBAKEEqLTjnJ3hwCVCl2BUV01MVYPZEKGuCambK9O5ulFgJhDqDYiS9g/89eiUGV2Px2N5EZl//hCKiXLs9m50/4Hcj+5ux8eGqWJ++R8K6cMme3FyOhBC4l2KUqrwiTiN8HELQn/Rv4V+AUJhihd5OHfnAAAAAElFTkSuQmCC"

/***/ }),
/* 929 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 930 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABaFBMVEXXnoRmRQBCicHnWnC/aVK2iXVbQQrXnoQ0NjjffHrnWnDXnoTXnoTXnoTXnoTXnoTXnoTXnoQpLzPXnoTnWnDnWnBCicFCicHXnoRmIRMpLzPXnoTaL0fnWnApLzPnWnBmIRNCicHnWnBmIRMtMDCRNDLaL0fnWnApLzNmIRMpLzNmIRNmIRMpLzNmIRMpLzNmIRNmIRMpLzNmIRMpLzMpLzNmIRMpLzNmIRNmIRNmIRMAAAApLzMpLzMpLzPXnoTOinFCicHEm4xmRQBxkK7mXnHFdl/nWnDaL0fXU2TBbFW/aVJbQQrHemI0MymOMzBLir0tMDDib3bZloJmIRMpLzPXnoTBaU+mZ1PMl390MSFtKRpqWVFVS0dfUkxKREI0Njitb1rLgGbCh2+CQC/Qln3TlHvCbFKQUD3Nh27TlHptSwjFc1mfYEy2iXWWdGasgnC7f2iAZ1x7OCh1YFY/PT3Jjna0d2HmpPeSAAAAQHRSTlMAAAAAAAAAgAAgEO+f33BAv1Awj++fEN/Pz78QQN+fr99QUJ8A7wBgIAAAQO9AUK+vIO+PUN+/j2BwEADPYBAgt8JvfwAAA3RJREFUeNrtmOtXEkEYhzeoLO+XSoIyjCzvF9RSshCzNsU0dXdAvOD9nt3r3292+A2zO/NieY6nTz5fHHjkcd7ZBc/BeqnTn4g7nHiiv4uiuW3U5Yy2NXcHsLqD9HgVEO8xMp1Rt0y0s0Jo7LmjMxyo9A24AZIjVGjovkOQ8HVeuAYjZmio1yEZpjsg2WmEsB+THjmXSxHVQ2NOJeIIDbgkfVpInfN3vYS7wKVp00KOZHeLOm8VKm4GQ6PBUMqRbLFDYjYVWvvmBqkQKjC2p5cCoTNW1EL0aF8ZJ79aMbTO2MrG30Orv5lgL1+gQ8UVT3/ZOD9U+LTHyvzaOtxd9Yeirru5tgK78vnH+k8cthliBCr0yqW823ahkGCCDDVXCJ2cCI9VIPSa8tHui4QA5TvJkIYRIrB0LjW0A5njYLnjD0VMHyFDedjtXG4by7w/1GL6FjJUYAYFfyht+jQZwpYANoQQtqTAhgx6xVvNO6WDnODAOyHxHukth2KRoI/EzNCgI0vHpznO6bHsOIPIoCQ9OjrjePvntbk4412+Ugs9l0J9sh3tM87+UcEBqS4/aenTFk3CWZixPbJAPJhZUP8i21szHtKLB63tIYmFn6kOW/BWhQQdKdnJCD6qkKBdhcBDhCY/zGazs+8mEXoYBq0ISY9Qqx6qtsEyEyzbAJ17GTBV8lMZUDG0xARLlULTJT9thoBdLi3z/XgdhECmXJri+0GHCtUxxmwN/lSdBTyf0YAPUM/oEKuXngzBK2I1/LkaPSSejCmvh+D9VIm4HhLbqFJeD8H7SDMx7nuNB3X40IHXQyF4RS3jNJmhJsapld4MwZdpYJxGyww9bfRMA7wZCpW8JcFDIlRKwBMh/AkgN/jY1ngWDouh4IlQCEOXkEd2Vw89CofTDKTpEC6DoHwR79g61eEwv/DwRIgjfL2612KYzJiNa3g6xD00kphMnw2nVGvRIY4cCENiMnO2tDoiOiTvShw7JjNnEx5beqNxTYCLjhsBkxmzxRigQ4JG4XGvYTKD2/8QahC+CpcWkxmzeR6/Y4aA8ACTUddNQYaAJReYzKD6QiGQFVznYKWhXv6/Qur6YKVxFboKXYUuI9Q84XKKZzc4Z0VvPRH4Hq3k5+ducubmdW+pZdIVbN7i4KuUJJTfLz7hLMKTIRdo6/P95Yf+AAKkERNi/hFWAAAAAElFTkSuQmCC"

/***/ }),
/* 931 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABUFBMVEXXnoRndX9mRQD9y1hCicFbaHEtMzjXnoTXnoTXnoQtMDDXnoTXnoTXnoTXnoTXnoTXnoTXnoTXnoTXnoQpLzMpLzNkIRYpLzMpLzP9y1hbQQpkIRYpLzNCicEpLzP9y1hkIRZkIRYAAABCicFkIRYpLzNkIRYpLzMpLzP9y1gpLzNCicFkIRZkIRYpLzNkIRZkIRZkIRYpLzNkIRYpLzNkIRZkIRYpLzPOinHEm4zNh279y1hxkK7BbFXxvWbFc1lmRQAtMDBbQQotMzhndX9baHHcpH81PEFLir37yFvLgGY0MylCicHCbFLTlHrHemLFdl+/aVLTlHvBaU/XnoQpLzNkIRbMl396OCtKRELQln1tSwhfUkxqWVFVS0eBQDI0NjiPUD+ISDhrKR26f2mWdGasgnA/PT1yMSSWWEasb1uAZ1yeYE11YFbBh2+2iXWwfyDjAAAAOHRSTlMAAAAAAAAAECCAAJ/vj99wz79AUDDvv7/P3wAgIN+fUACfAFDf30AAQBCPEK9Qr48QMFDvYGDPEJrmHU4AAAMVSURBVHja7ZhbU9NAFICjrTYVyrUFKhSshYqKCHgDykVAQKGg0E2Achfv1///5snmbE6ze9JOR3lx+GaY2e3XfOwm2ZdadzXSgyMOMDKYvsdQzA+7wHB+8o6GFZ4O9DoBvQN6pr/HDejpjw6NjjshMlPhzqMnboixIh964BhMhTquwWMuRB0iM1CzL1wPX6LQqMPRS6Eel6NohMYdllHVmXRZxoyQwzOoQnmXJyp0cBYOjajQsBviYr9B6Pi7E0aF3DA/zhuEfosDNjQR7uyLX/VDJ0LsHTUOva8KcVovdLAngE9H7NYo80EA1X0+BIfs7Bg6kr2PP08+czf7y+nXb1XhUz2/gCNnhJ46gqH28XPefUYhRR8bSqtQkQ09Z87aC08cHgqARrVHhPMT3Onnvlh7aDlvcQiGev7yQx0oKwAOO5rwRArtRqWygcNUE56whYHd2PNL0kg15YlEB8itimTLuwOJxj66tL1YARa3me/xni+l+HXzvi727K4AdmftJj1RyJU9dhA5yRXiAUPZkofycpIdiiksNSiUJa8pJCkEnZLkDYUkQ0Yoh6Hpt/M7O/PvpjGUU6EshpTHUFYPPSwjM0Iyo+bYuV9C1ny/puaRoTkhmYsKLfh+wQwh5aA0A+uBjgohpaC0BuvBDhdqE0KUNeCjNgvxfEmDPNEu+JBoJ8+E0BOJVvisVQ/JDxPk9VDgiaSM6yG5jCR5PaQ8YQu5XT0UbxOAHXg9FENPtAig2wx1C6BFeTOEPqBLAJ2WGYp3eqYLvRmK+T4I4ZQJ+Qn0TAj/BYIL5EJxuSn0TCiGm/bBW8aGbIHYfAgfgwQfIhcCkiDRmyFA+nZ61xJRIdDo+RBdTkkuhHepxeJDgNoQbZIP2XSL+JB6K2tv+0uN64D0uKRXGtck+NDpRWBDCYHwIUmn9Piu/U2oS/oknV92a573/tgQQo2okIYZIqzayT8L0eV8iC6/Cl2FrkL/Uyjd5wCby7eB5U0H6Av9zub79dUbwOq67i0aZhzJ0i1gyR9nAkl+5Sawgp4NOYg2rusvIfQH4EiJynqtJVkAAAAASUVORK5CYII="

/***/ }),
/* 932 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABI1BMVEUAAACSaMrXnoSSaMqSaMraL0fnWnDXnoTXnoTffHopLzOQNDTnWnDXnoTnWnBkIRaSaMrXnoTnWnDXnoTXnoTnWnCqjtbXnoTXnoTaL0dkIRbXnoRkIRZkIRbnWnDXnoTXnoS2iXXnWnDnWnBkIRZkIRYpLzNkIRZkIRaSaMpkIRZkIRaSaMopLzNkIRYpLzNkIRY0NjhkIRZkIRbXnoSWa8bOinHHemLBbFXFdl/ZloLOl43ib3aoebTaL0eqjtaNMzLXU2XnWnC/aVIpLzNKREK2iXWSaMo0NjjmXnFkIRalZ1TXnoRyMSTBaU/Qln2sb1trKR2PUD/TlHrFc1nBh2/Nh27TlHvCbFJtSwiBQDLLgGazd2K6f2meYE16OCvJjnaOiNxSAAAANXRSTlMAUJ/fAEBgv48gz+8QIACPEM+vcFDfAO/fABAQ33DvgEAAn1BAvwBQYJ+vn+/vIDDPAADvAPI2JQcAAAMxSURBVHhezJTJasMwEEB99MWEXBPl5uIQQyh2vmIkecm+dPv/r2gmkiVV4zCXFvpOYp55QnNwQihKAXdEWVSjPPFJ9FkuwCFyFJynoeULxExQMD4OrV9hhLJiPAmtaxhlwvk4ZO+j5LwPQ0t4huB9GPJ7/ISIgvVhyIlrR/bJex+aOdGpLXkb72lIK9XGJc6PPu1d3ZE9hLCehvo39aCVGjyMpyH90SrHV7e92osZT0NqBJwz/o9Dlwtqf/Ih6n8/9P93dLCyuWOPB5wznoaktbemudmjxDnjaUgrgjYhQ0Z9tnEk5gDmyggJLoSksU83JFRjqMctnJsHZ9xAj9PahebTn346p6EVDKXdHjv73dCBVRWWvMcODS3AlGT4LsOiCkpp9C4S8n+u4wkrp6MGy6wKyQb/3V7ZtjQORFE4SceVVTvIttVqwVYXBLEiu8S3tro1raZK/v/v2Zk75+aWuZpvfhB6oDDTQx/yzE3Sdq5AlMv3+XPhs0Bo8zyXv8C0VfpwT5tWajgJFse7BeVNQJTdY+aUlBsBUVIBIT2Abu/uF4v7h1uAehZpAcQ9QK0YtFcgk4oy4T04+yUyDf2U95+CZgE0+wz0GPpHDUKKmuSuaQKOgGxZk9w1TWuOBvWdTxHFKfRzxPdlFOll/J3qY1DVkV6DuBfQ4NBxDmMQfTmQPgbVvYCGBI9BdBlD6WMQ9wJqV6T7FGWrj5cO+n9RDtALKPOgrgZ1PSDjXoO4Z9DI77dzDTra9s0IvQYdhL4G8VaDAoJ7DQo9g1jgdxHlh7UkhT4to6TGBGmA+MjOYtAva2kM6C9i0IUxGAOB6iGeFHH2rPWDRz+OQWNjDPUdB8K9NoCZcnM19TBTbvi5AwEJM+VmM4yYzLSbgVACSZhpNxxSG2bazYQjTnDsMNNuGFsGM+1mwtAT3AgwU26DCmEz7WboNiPQiM10fjJIzJTbiEBDGi2baTff+4+YKTfj+yRHYKbnhsBMualXLZvpuYXATLsJSILTcMEqSlNPapxvBdqANqAN6Hpn6fLyeury+uLXO9fna2nuE1leLSmrPy6rsL5C1dRr0BKJ1o39F4D+A2ebuy2z/wOKAAAAAElFTkSuQmCC"

/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABR1BMVEUAAAAqZ5fCi24qZ5fCi27Ci24qZ5fCi27Ci27Ci27Ci27Ci27Ci27Ci24qZ5cqZ5fCi24qZ5cqZ5cqZ5cqZ5cqZ5cqZ5cqZ5cqZ5cqZ5cqZ5d/Y1R2XVFPRkLPppHiz8bi3txcYWXFknfl1s71+Prc3+Ho6+7v6umUaDdsSQeldUyJXylmRQCgcUW3gmB9VxyrelODWyKMYTGAVyOIXiz39fH///+2gWCEWii+iGmdbkSZaz+peFKRZDYqZ5dCicH9y1jCi258nqA8c54vRlcpLzOJaVg8Ozo1dqk0VnE4eq+UmXg8gbcycqSvh3NGQD5Bh74saZrav2xfgIdshoOupnBiUkk2eKw2XHrmw2WvgGeSblxZTEU3bZOrroY7frS3sn8+g7k/hbx2eYMrNTy4hWowcKKhn3Q3YoMuQE5Ag7gta5w/fq/9ehr7AAAAG3RSTlMAEEBwj7/PAFCvgN/vIGAwnwCPIN+Av0Dvr1C+YrTKAAADYUlEQVR4XtzU126DMBSA4SCkXBI1BWp4GJs9s/fu3n3/6xKFEw+cpag3/S8R+mQbfGp/n3KnNs063lc3m+qdcnOomvyx3QRCqN60z4dsCx/Nss+BFEPHJ9MNpQKJDGKA3HHeh6Ox44xHw3fHyRkKASWHVJbBa0cIsyH1IHRrAnEcgsxbOWQjLJTzTo6FkC2DNCyJdda4mkYh6pyCAJBLtcPOW5K1WKiVJW8SiYcavNFvZ49k24A6A7LtMWv3eanBQTqrJC0CPVDogUCt5JuBdBYyKNO+J0wehTzCdN+mksFACBYzfSJ8c3DmhO9pCltEANGTnvaImEcXJNYDSttDcNuJpM3O2RBJJWTtIQSQLK/Y3dwjsmBvewgDdGG47P9D4mH/+P5slgZB8BIKvRQP09nM9784CFU+v/+RBp/hWX0G6YdfQlblhwwvDAYAc0WugRB7aa+BDG6MADSJ4nOIOJoApPODDaDIdU9T8fYtgBrCqC2hhVu0XB1jVku3aFFCWmX4P3fcMOy6u16jiXRd8SR6dXd1w9DtPINDod/e6qCnQRgK4LghkDIKCXfGpgOnmzBRmYjooQe8esfv/z1soZOyt1fSi/8L5G35hVLYQsY4FLGx7mcZx6MRx8ufjo1FHGIsJLIrebQFIFc2n1yb8OwpFPQAX5lB3z3EgglkD1BkAkUDZE8gOkCdCdQNEJ1AAxAbMOPXL0BfZtAXAo2t1tc3bXtzvV7ppzPQJklT7nApTZMNMsUgqkDcSdu+Wy7hUxmF2y9L/yBxpp3C7Q/OILkInnYKH0hiT5e2Fbd1y51ENwWviChUb/ZfyUY3hS+tyKPKRt8J5U5uND6lHgGQiBnGgX+H7pVTA4gCaLdnsv0OOBSFHAA9ZPng5NkDgBwU8gB0yLLHvCjyxyw7AMhDIYuB8kyWM5CFQsSHUvEkmKcCOj7BoZAZFGogywSyAITtmz6HoJB6Sc8vSM/qBeEQWUio7IHjq9Kxh0rpLIgeCuTGVW+XobdKblkwAxGXqZKa6jCXzEHEPkkldMqTYxMUgg9T/X7uvNfwEYIQlFjVqExTMeBgEPgnqD+aT4F8Nh81+L0HEMz1GZrvEhSCBQvMWQQEgZAs5xLjWEAAEKTCswX6IWAAhFmeQweEOp5QjCHzfgF83YWuMQJQkwAAAABJRU5ErkJggg=="

/***/ }),
/* 934 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABVlBMVEXXnoSAZ1wpLzMAAADXnoTXnoT/2YPXnoTXnoTXnoTXnoTXnoTqyHvXnoTXnoTXnoQpLzOGal7XnoQpLzPXnoQpLzOplWP/2YMpLzPXnoSdeWmAZ1wpLzPXnoQpLzORcmQpLzP/2YP/2YP/2YPXnoQpLzMpLzMpLzMpLzP/2YMpLzMpLzOFeFX/2YP/2YMpLzP/2YP/2YMpLzP/2YP/2YNGRj5KST/qyHuUhFt/c1M4OzlIRz5qWVHOinHCbFLTlHqhe2vNh27BbFU0Nji/aVKWdGY/PT3Ml3/Fdl/BkHrHemK2iXXFc1mLbWHTlHtKREJVS0f/2YPXnoQpLzPpuIRfWkfXuXRsZEz60oPBaU/aooTKr2+vmWWHeVb91YP1yoPww4PmtITyzn5tSwh5b1HLgGbfqYQ2Ojj4zoOUhFtRT0LkxHlERD3ksITrvIShj2DcpYThrYQDJAShAAAAPHRSTlMAAAAA7zAAz0AQIIAAv4/fv+9QEGBgUM/fnzAgj6+An0DfECBwn89wr49Q79+/YDBQnyDvQO/Pn5+f39/bJgpRAAADUElEQVR4XtSQyW7CMBBAo1bqqYdIKMABVbQoFJpu0HX5irGTsO9b9+X/txor2IMdNBd66DvN6EXPdpzdLaFD+XzlZAfj+e4xWiuB6635ou8WtHZWos4FvhYZV+xlFAqWe0bvPhekhIp8iT7ClTsKSe8qX5D+IjWEjcdTQ9xb/7yuQ/jq8nHZh9OX7tu73CooVJa+vJO9Fz6eSh9o7Rh3zT9yhTof3/EJ+4O0UOaGmzSqe4hby7/e7Suc1VDKjSOzM4aaypRy0DM72Dur764AoDONoq9YDotFowOCKvZxL4p6HTkseKOrPA7lYAPXtMehc9jEIe1x6EyJZzC4JD0OKTEYgUGN8jh0pMSIDa27094ONRlrmyXKpz7thwnCPmBIb4f6H0zSDpugIbwdan62meJ7NBwkBxPeDrEUQED4Pw5NJtKrCQSE307on/yjeSJbgmScg4DwdihM7KzVmiVjCALCq5DitxRz6W0aCKPoYNnyS3YgCZJTSNlUICULJNZ9JyEU+ohmVvz/P4LnavBnvql8F5xlz9GdjJLIVSobUZkRzAut7lrqX6fMe3n9G1z3XV5SP7F08+i7xxvVMa/LVt2L+Amqu2dfPd9V3IOYTeecs3YfsNY/wDfJAPFm6JzToWdDvR7qQnj1836/v/9xFcKOeT20cOBoB44OMK+Hzhw4SHhwoDKA+IEideBFwu8OpAX3whLKx5c2cOkjLC6pH1hBNaXrOd16eXtyPWUDsWJePvie2hinSJIaivnwZcEOrhqHSYHrMZ9jCKHv4tCX0MxjCJtp9nqYwTKfYggtyigMHfFw46U4DIb5sCNLOvzbMW+ALOU6nIWOer20+7fbSUe8Xno4jbvTAzrqFdl6fWHt03Do7sl68or6mBqHynEgnXOvqWHeve35krUzG1hSr1kP32Uwz8OZFfWKBqLWL9EW1CvyEOq/VNQrov0SXU49HWoRzqlXZPp/ngJdQ72msEAulsp7wn38KBm6XC5GvKKWm8g70lJPhhafjpjlPqYZHbHxT9UDnjPcT32wO+d5+fBmxLQ3Es4QXvjuGzr8fiRMe5MEvn7GGb8Kg/LjVn4FIl4NbR3Y9SFYnPfpFop4NeQCifC+O4cing8B4vXQ//MHxCF8HnS7HaMAAAAASUVORK5CYII="

/***/ }),
/* 935 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABEVBMVEUAAADm5+jm5+jm5+jm5+jm5+jm5+jm5+jm5+jm5+iAST7m5+jm5+jm5+jm5+jm5+jm5+jm5+ju7+/29vb8/Pzs7e709fVmIRPXnoSfYEzWzs2OX1bZyMSzkInm5+i2nZjQln2CQC+GU0jJjnaXWERtKRq0d2GQUD10MSFuLSDCh297OCjEOkbMZGC+GTH///+Wa2O8npiukIumhH6tb1p4Oy+WZl2DSz/GtrPPurV+Rjve29vMhGrBaU/ShXT9/v7DMkF2Oi6MWU7RfW/JU1XLXFvAITbVln/i1c/bsJ3ZnoLYnoPYnoSBST67f2iJSDbOwsDr7Oz18fCfdGzh3t7BKjueeHDc1NPm4uLTxsS+qaVtvRU3AAAAEnRSTlMAEEAAMIC/j9/v75/Pr1AgcGDOYmr7AAADfElEQVR42s3XZ3+iMBwH8IMW7bantkFE3FWrFqvde+89br3/F3IeDT9DEgn10wf3e9TQ+PWfQcBvQ6Pp/6KNIbggzTfp1XEj5viJxfWxMT3OXDDGo0GaMeEM8tTtZaemsr3uE3NxwtAESGQm0X83n20QpJHN7+Jfk6CGQPqgGqsDBVbHGlSlh0EGwxBpGMoYCmnT6NRFNUJVXXSa1uSQNoPJKZGQlDBVM5oUmnVo3u5JaO7fHJpZGYRx/Tx0XdtezeVeT7i85nKrtu26h78wOhGac2h+uxECaY6HEv72eT6MAr08+xsqASg4Qdb6xqqtYuzVjXUL0xSAdIfmY702T3K5bdt+4cqw7e1c7mTT67Lj0OgBKObvHxI5Pf8mBsQUZDWiQw0LJQFCQR3yiXRQEqCEXxD5VPySEoAMRUGKkuYBzdBbjJuhteVi+Czt0luOQhhZnnNM03x4DJPy/tgoNE/bWc7xUq5Uh0JZjM2DsKsbQQdZqtWHSP7uphA9XrdEBymvZTLFYpEHt+ix+wElxF1dfTDlKSzVWKjrT5IH6cLi15clBqyKuAF0DzJwv9I0C2ZoljHCkv8c8KA4bRGaR1OVQtPfSfSjcQ+KBaE66gmpiVu2GAdhvZTJyCAnCLGdM2hw7XIQcgANtlERH4Qqaze/CioqoUo0qKaEMtGgjAiN80NTT7Y4tEQf0oNQ01RHnGxdhEg0iKgh7sbf2/eyF7z6EAI5BLPNZp+G39lqqBkFakaASFk9tDKJAlVMZSqRoKoaqiog4SA5aB21TS/tVusAl9dIKHRMhKPtfWVl5ah9eto+6v/xjgOyLoUM5h2L3wErgTBrz0OGHCL+U+SMdc5wziqgHwTBc+T8As45Tn4V1GM61Eyay3arb1202pfMSYTsiBBuNkhi4CAlFsJvQ4soJDgiFAOEtxHksSAyBe51qSeHsiSQ+hLvLFXlb1qApG9s2bx1dc0y11dWnvsui4UmHeR4sBz09+vN7d2Hcnd7Q3/nliRT5Ez2IWeQP8TLcQ/fdMMEi9Ldoa8QTw5CIUilUqcLRYRg5Tv9nnAAMUmm0q6XmyFxvaRTSfoBQONsc8FTVBC1FoKQzrQW0SsMQhaHQSk3GoSkWOi7rB41hJoAGZgfNzqELEig9ChQWoSS7iiQmwQUw0yPBKUEKD0alBYgd8QAcv43SPsi6C/FglYbl6lxgAAAAABJRU5ErkJggg=="

/***/ }),
/* 936 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAyVBMVEUAAAD/2YPZnoL60oPZnoLZnoLZnoLZnoLZnoLZnoL/2YPZnoLZnoLZnoLZnoLZnoL60oPZnoLZnoLZnoLhqoL/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YOKk6M7iMPNhGnBaU/Wl3zKfWLJel/Gc1nMgGXPh2zTkXXVlHjYm3/HdlzQim/DbFL/2YPZnoL60oPsvIP91YPgqYLxw4P4zoPepYLbooLlsILntILquILuv4PjrYL2yoPs9v/7AAAAI3RSTlMAIBAAYI+/369wMO+fQM9QgDCAAO/vAM9Qn9+/cECvYBCPgOWoSWMAAAJuSURBVHhevNLLbsMgEIbReMuuC5oY7EDyCv/ge67v/1BVkSW7KsYzXfTbIh3NoDn8a4X/3O2QeyzcxRrM2XOl/gSpy2ys0mUthdwR6YyTQLXBdubEhfwZ+WzBgpTBXvrEgJQGI7cLKfAqdyClwazKQt6AnctBJfjpYhuqIcluQxai3BZUQ5b2G9AZwqo05CHNpCEHcSoJlRB3TULHBeh7sLJJaOUQPcAqB0WHqAuIDRFoBZDH3Jti0zMSr7hluAUx1I40N/bAMFGUOuqeQbbag1a9vsEGQBPlW9O/AxMK9LtbG6FVYR+6U6Lp0f2E7jnIzAOxChnILj+UbxlJJ6ErAIzELGxf9gnAQCQZqUxCHy3QfFVTbzsNwzAYgKfs0EZpNlLzBjvBskI3DIyDkOD9H4pq6ixY3FqexAX/paV+SuX8QdQc6Wp4ymBICa65L5+oOtJ1gDYDoEzx/fUZKfPFYk4AO3tsyjRNodmxFEhZNCGBnR1eDoizBCq4j+RZkUDuMsglEF4G4b+B5PWLkMOLkvHr16fgL6Q+M64i+nAVgeD0juNKC2GidSYBOAjAMsBydcyScSxAB+QZaNWGgXwnBDoIuqFc82t5DzRCRUY9kNFAhoX0RSmgD/L9wHqd7oyHYPLj/tysz5jbZkaXEfoh/2vtm7itququarKNm+PohHsBgpwgPve0ewEybXcj78S2rUaE6GGq6pSpK3qGZAjGtKNdrPcnY1/HHe1sDBLEF4UvhwwZ4bGcGgkiqehzCgMiRCm7nRJAAYHPeCbzoIPAlC5lXGlAgDjKnp0qs8QIUJJg8xbLchsIECE5fw99Awea5u1EJj8sAAAAAElFTkSuQmCC"

/***/ }),
/* 937 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABfVBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoIjHyDdLkRQSUjdLkTdLkRBQELZnoLZnoLZnoLdLkTZnoLZnoJBQEIjHyBBQELZnoJBQEJBQELdLkTTL0TRL0TdLkTdLkTdLkTdLkTdLkTdLkTZnoLdLkTdLkRBQELdLkTdLkRPXUdSZEhceUxqllDZnoJ6Y1qXdWZLRkbGknrQmH5eUk5xXVazh3KNb2KEaV5nWFKgYEtmIRPNhGnBaU+3hnB+X1FRPznOlnw6LywjHyAuJyagdmNzV0tcRz+JZlesfmrCjnZnT0UtJCNyRDitYEnDbFLKfWLPh2zTkXXVlHiVbl1UNi+3ZEyNXk3Wl3zMgGXHdlzdLkR3slVBQEJLP0J9qlTTL0RePULKMESPN0OqwWaqcE3dz3jm0nrXNkWKmVKdgU/KR0eEolOXiVCFOENmjk9lS0X/2YPAMUSRkVGAtFhwpFPQP0bET0i9V0lyOkOjNUO3YEqIt1uzw2l+Ii4eAAAAK3RSTlMAEAAwr+9AgM+/ADCf7xCvUI9wz2Df72AQnwAwv+/PUJ/fgEBwIGCPYACvIvmISQAAA19JREFUeF6k1dmOgjAUgGHuCXBhQsiII4JRx2c6LZvrvi+zPvs0DZwwhRYd/1uaL4e2SbV7cpyX2rTaFU2Lsqzms5BjU579HBT4ryHlha4fvCnSFN90zwCA456y9kcAMDz9H1DgAm8VEVa0Ap4bPAiZQyg4BQmG5iNQ2yg4gmS074f6kDVfEGwxh6z+vZAHedxBCfI8CSR1luRPS4WkqZwvIvQlSEqoi841EqHoilK3DtIBO5FSJ8D0GqiBzjup6B2hhhrqAbaugtaA9VSQaQgDKUYyTAGSDLSphjbCSBKoA1gB+D4XpDlCHTmkA3bLlZ/ZgTUb59ANMF0K+YBNCO/MGU5lY00A86WQW9qi6QGbljbJlUIt8TaeD4VKd7LlSF6RQZIiFMmgNTppMpBAFg1HMR6a5NdIxsSjkFoSiLLCUYpQebMRShnDkkK8j8+YQXljPH6E4s8Phiggm+Yl292FVHbZbRNcZldDv93UW0/iQBTAceaUwdbwgARD+gF4UvZQykVBS0HrBbygXW+Y8P0/xsKx6Aye1s7u2/4fSlKSX87MtBXlpdbBYbP5S6nZPDxYapUFbCrAJstBbC2NaiE61jZkSVzltfMzbQ9XSWsLspHycw/V8pGydaiCmzpe92el63VwU0WDXFTyvV7GEts9z0clV4MkbuX3j44HA81rDwbHR31C1KQG4T/0/0P8Zg9PqCF7T2+fP/6kk6SMe/zxV/4eqrCviPnSbPalNU9azGfEOO4zQhlaDhEc5JpBbiq0YwbtpEIlM6iUCgEDnAbUKQMBA6XvdpDE7HUGVDWBqhlQw2RpDRbi3xQchePxeDRaXcIR6tmQBdVUZRKena87S37CiQrVMiEhFSY63ypSKCkYiHsmL76Yy8sv6oJ7GglKGSlMkKvr6QxxNr2+SqiQGYggfqQbUm7v7ucPj/HvOH58mN/f3ZJ0wwzEQbCPiE/kPL8EWi/PJD3Rh/pnqIQ4W+9P9Bp865X2aYZYygHB3sfCpvi2mKvKfPGGU1oc7kEeCJzoc1PjxXtAvS/iz0OIHMgHifVAE2SbrP8TOSGo045y0TnUd79X2GUTNqZmC2AqAJ8opjlFcliIryo5RlYBDCFoMEMVG2AIUZarM64FYA5RoubaSNluTQAYQ+b9ARvSoCaFcFs8AAAAAElFTkSuQmCC"

/***/ }),
/* 938 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABNVBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLm5+jZnoLgxbjZnoLR09TZnoLZnoLZnoLZnoLm5+jR09Tm5+jm5+jZnoLW2Nnm5+jR09TZnoLm5+jm5+jm5+je4OHc3d7ZnoLm5+jm5+jT1dbg4uPR09TY2tvfwLLm5+jR09TR09Tm5+jR09TR09TR09Tm5+jb3N3R09TR09Tk2dXNhGnBaU+gYEtmIRPKfWLHdlzPh2zcsJzWl3zSjXLJel/TkXXj1c/DbFLVlHjMgGXj5ebS1NXW2Nnh4uPc3d7Z29zd3t/m5+ja3N3l5ufe4OHV19jf4eLU1tfi4+TZnoLl4uLgw7XR09TbrJXY2drk3tvgx7vao4jVz8zhzMLeuajWtabdtaLbp4/TycXi0Mjfvq/YpYzZqZPYqJHVuau4ZWSWAAAAMXRSTlMAzxDvMJ+/EGDvr2CAUHAgnxBgz9+/35+PMCC/gCBAcI+fr88w7+9Q31C/jyCAr+8w96jgVQAAAwtJREFUeNrt1Fl70kAUgOFAoMUu0M2u2tYNtVq1+4pI9kkCyekKUov7//8JAjNhBpghCdx40e+uobzPySxID43S6tzMGkIVU70iqVvPJp/GVcY35hFCPlFImu0q8xvjcZiZPEKOVWYRQ0e4/ExkajvfPYxnVhBbfjsSszKPUEWjiu0zhqIbtqapL16GO2/zyPUCRTV1arg25T++DnPmGKbsOgRxXBM/pU2GOJQx/WAUsupxpE/BV1RDIbP0Kp5mGpbezF8RO7NvAoa8U+WGNcqmpSPaovgYvMOMhRnH8JhB7ArBaZsi5z07jWIyo1gK4qSILsxS8zs2ZnRNrOiWreGPlwQr1LwISg+j2l2KU7G71n6WC016eCn9DqO5rKJYWrQj8NzpXhtTZxmXbiDtAxdabO+UGjAKO4ytdguq1TpJaJELtc6Nx2HokKxkoFZ8SLnhMbfV33/+ficb6CuWF+ymLoBWLTK+prPKNbT79e0r2UD6G2MIJiJH2KXMj3tguq5fIJzukaEUMWQ7gXJRbUBPtZ+3CEemV0VQ2e8wlzXgdUcoB6+nADJQEGWElKuKoMd+Z20aMKhL1M4vX21xobXgre4hpMYOfj2ND21i53MNwquidk94TuoRalWHSN2hVq9SHChxQpwY0kmi35mGGnbiSADTfVAa4BbtQKf9g4N9wAmeVVv/nu6DZIA6Yrb9oBngBM9qF1UAuQ8CgPs6xIHgsnWheRA0okE0EQT/FSQPBy1wtp8Wuv20NOdADtU054oM4yR4l1aO78gpiSeNxXXGsMMJ+tvda7cL/UniODPtkTjzDICycaDsACgX59Vy0oASo+08LRMdygyEknJUR05KA5uKCk0JCToSXebzM+h0dk6WnA4UPhLd+OLhceFLoXB8WGz/GT4QbYFC/dGfofDW6av1Rl9tXYrQMpBOS0VWKZZOgbQs0aLduELpCCtHpYLololLJkLOdFIaUaLOaBJ1YkgTImcCO9HLyjxGzkqxy01wxslJw5RKdzPplDRsyUw6QZY4nUlKD43UPzYkP9tBKAf2AAAAAElFTkSuQmCC"

/***/ }),
/* 939 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAzFBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLR09TR09TR09TR09TR09TVuavR09TR09TR09TR09TZnoLR09TZnoLZnoLSy8jZnoLR09TR09TR09TZnoLZnoLZnoLZnoLR09TVvLDYqJHDbFKub1jSzMptKRpmIRPDh210MSHNhGnBaU/ZoYfS0M/EcFXJel/KfWLVuavWsqHTkXXHdlzVlHjSlnvXq5fYm3+DQC/Uv7WKSDa1d1/Wl3zUwrrQim/TycWgYEvPh2xstZUSAAAAIHRSTlMAECAAQIC/3++fIECAADCAv++fEK9gUHDfj3CvUGDPMDeoHoQAAAKoSURBVHhevdjpcqowGIBhAwiheqiolVpbm+C+73Zfz/3f02HIkSEk+TTY6fsTZp7JZjql8KshwzxawQSzirZD4rBdtPJClosJF3YtbeiidGkTSfZl6eKPrILkmVeu+P1Houix71fK3nHIq/qU0nBGlM1CSqlf9UCoVKFR8w0B28xpVKWkhGotGjsdcqROLNFWTQ55vujAku/xEOzAkgjVmEM35KQ2lEk1AWoxJyQnFjKplYVKzPkiJ/fFpFIGqjKoczrUYVA1A/nAxMDJ+TzksR2b6UAztnMeB13F0JpotY6hKw4qQwOCh1QWoRei2YsC6uhCHTnUJ9r1pVCoD4UCdAvNDJ7bbfZAzrld5U6D+s08dSBZN/TjANGkRFC++aA3PISs63UeaH1todSfI9SEJwC/aaIEsslZ2QeoSM6syCCEz4UwiqFADjz03rLAW+9BLgUxVJcy34Ph8Jl3nofDwbeUqscQVjBRPBQ9UFA4hkRnxJjhgIcOT0eipIBemTMeZfwxk171oHGPCPXGetBokDAipZ4aJmeH+e3PXx04kFoFP/YT+dkf7fnXCH+xOXkMJ3WxMcoyjDyQYXBXLUs+pMk0biIfkPRfiKYUmv5PCjWlUEMfakghE+tODZtyqEk0ayog7X0zpJD+wbRNFWTpQRYHKYe0Xy63PLBdLvf8gERIHNJTN9qrxWSfuH8X0YPukzggEeIuue2U1d1NonYRG7dNXWZKiL+bFlNJi9QdBELmXQK9r7pZprt6T6A7E4ZMN7VMn8s0s/xMLZBrHoNQm9+pyWoXtZrwO9hGIMQvE3xJgxDr/qiE700IgiXYYRC0TixgfUDIRK7acZHWZ5+GI2echu73I1TEIoOLKMeHKBRklqodoLyfxoyg7jDEqQcGB8AQ3K9A/wD7ENf0laum7QAAAABJRU5ErkJggg=="

/***/ }),
/* 940 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABHVBMVEXZnoKqjdi1k4OHhIWzkMfZnoLZnoJtbnGAgoUAAAC1k4PZnoLZnoLZnoLZnoKAgoXZnoLZnoKqjdhtbnHZnoLZnoLZnoKqjdiAgoVtbnGAgoWzkMfZnoKAgoXZnoK8lLfZnoLZnoKHhIWAgoWAgoVtbnGAgoWAgoVtbnGAgoWAgoVtbnGAgoVtbnFtbnGAgoWAgoWAgoVtbnGAgoXagnPdLkTZl37akHrcWFvcSlTbbWfbZmPBaU+qjdigYEvdNUjNhGlmIRPClq3aiXbZnoLDl4OAgoWhjYTImYNtbnGnjoSGhIWRh4RxcnXTnIJub3J7fYC4lIN8foF0dnnOm4KykoOtkISWiYS9lYOLhoWci4R3eHt/gYRvcXR1d3q88CEyAAAANHRSTlMAAAAAAO8QAAAA72C/MM9gQIAQYJ/fIIC/39+fUFBwz4+vvxCAUEAwQHAgIO/vj8+fj5+vVjbECgAAAshJREFUeNqd1G07KkEYwPHbQ+scJTqKJI8RJYQishL3TikiIufx+3+MM7tyrpk9s/fu7O9V17z4NzP3FHz1sX28dMctHW9PkWCKtMsrn5Z2w4fm7yTzGiGiQ5Xo0N6+O7S/Fyp08Pgod37fHWiHVo7SzPbr6c+D3Xj4+cRspfRW/osKqBZ3yiUmeH55eWaC0lExUCifZr5Oir6hXJkFcpSjQ/kMCyizQ4VmmYZZKUR0tEpAdLRKIHW0rahCxRLTVioqQocshPT/oQILpeAO5UoslFLOFdpiIW25QtSGuuSWpBA9+laLfExS6ITa0KDNCCdiKMcIfcQOI4ihFeatg9y93/MG35m9oq3XIuYmhNLMw7CNI/3v5OsG6ucx7LRR8N5Stw6FEJP9eLUsVBtYVsfd8wq1BujDug8Q6loYwJtvqNvGQPrqUIbu0KWMavwWBtZRjb8svGLxBt5QIK6Kr70shAqjg/XQwf5Bh3rVYh8KQigvfFXgELaYI++EpP+1HuocDdujfzYxtMm4FmoaMm5zwgYTH6YZ945q9BOYHrfB+Afsui4Er5rNK+SotZ49IASBYb+KIYqaHHLkGn8BHVdoIN4sHZLvf4Agsmf5rh/q2wMCUYRvydIPWXxDERAl+TbDhN4QkyBaNs0b1A/hjWkuT9pg0vHN5FB3/JzJjdlgzCGFaFSIWzTNNQxhzTQXxZBjDrXNgYqB2gxQiqPC9aXjGhXioLaKCpcjqLAKagu6oQXwENc7Why8RFFLFDxF0NvZGcoi4C2Bknq1Wqugo1Ljn1GSAEIKBadVR+P8vFF1SHtKASUrh1xOUZAFUlI+mqSOgiTQjDgKKrXGZ6VRq0ijN8DHjGtyt5WLev2icuua2AyAZklGd+gS3aFLKSSlhA7N2EDChgHBZSOex8qCFiMRUWYSBugyojF0iUWJDN1aj0VGW4mtk5W/4T6gPhiJ3F8AAAAASUVORK5CYII="

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAjVBMVEUAAADZnoJmIhTZnoLZnoJmIhTZnoJmIhTZnoLZnoLZnoLZnoLZnoKMSzlmIhRmIhTZnoLZnoJmIhS6fGRmIhRmIhRmIhRmIhRmIhRmIhTZnoLZnoLZnoK8f2dmIhSgYEuucFl0MiKKSTbSlnttKhuDQTDLj3SYWESRUT18OSnDh23///+1d2CnaFK8npgeIqjFAAAAHHRSTlMAQCAAEHDP358w779Qj0AAr2AQr58wv1DvzyCA+sGh/AAAAkpJREFUeF7VmNty2yAQQKWUqFh2U9lt06Ra0NX3JP//ecWqZg0SrInhpedJQjNnlqt2Sf4/nhQP32+TUB83j69y4OvPXyGixxd55fnhXtHmWRq8/L5PtBl71Wy3x1H1Lf3iJnF9eBo0hxMouroZTAKKNfukKP2hNEelGdkP0XUAwBefEKVLgGp76OBKLRXvg3SZeooYBwvtJcTRypmPaJWDjZ1U7EZTvrot4uDgMnkCvfyGiGWgIzTR1hBBxkwR5dn1stnNRWhyi/6Yw1NJKatZ15CczUUYj12Eg92BTsYcookH3rUZhy2+aCZNRM3X6boI4SAVNUzgNtEKED0K2Z6UspWKBmas5iKWwwwhdXrcepYBT+iFWOuiGizwqSgFK6KRI80JrKQT0RLsdPW/garBwdIULeBuUkPE4W64LmIQANNEawhgrYkKCKDQRBDEVZRCECmKSgiiHEWszCGIvGQXEcsgmIwpkcNT9VL2FdFimhLXEhozhyPRYpA4AqrkSDVvcYjASo+nmbXFXySReUtMUfyuxR/saNMfbUFG2yIxN234wRb7qA0//KP9juL+IMkc4q2qqjchxEmI4RFsLDySiF4a9GQSQYTUyQl0WjPCCdFZ4RBxr9TvtihnXsnowRQd6GQU4c5k9ON8/sC8X4d7JOxYOCJ7mJJRJYRJixrsGFFCUAO+N+Mhixo6JjEE1QoyHrrwo6ELP//ty32LY5p85Vuu03Dmf4FA4HOBgCycUXHU0CKErQuYQl6yUKRlkeF0FyV97RNGfNFft0WTTMfeslgAAAAASUVORK5CYII="

/***/ }),
/* 942 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABWVBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoL/2YP/2YPZnoLZnoL/2YPZnoL/wVjZnoLZnoLZnoLZnoLZnoL/6Lb/6Lb/2YP/2YP/2YP/2YP/2YPz0abz0abZnoL/2YP/6Lb/6Lb/6Lb/2YP/2YP/2YP/2YP/2YP/0nb/6Lb/6Lb/1Xz/2YP/2YPZnoLbo4XxzKPep4nqvpn637DgrIz42qzsw5z21qmMUzyzhWXZto1mIROgYEvNhGnBaU/Jel/SjXLDbFLKfWLPh2zTkXXVlHjWl3zMgGXHdlz/rDP/6Lb/1n7/2YP/zm//t0f/yGX/w1tckTv/03n/wFb/y2r/5rD/xWD/4Z3/3ZD/vVH/ynWutV//tEL/57P/rzj/ukz/w2T/46b/tEP/0XT/2ob/3Jr/xWn/5Kn/4aD/3pP/3I3/sj3/s0D/4ab/35//z3v/w2D947PltZL/5K6StcaVAAAALXRSTlMAQICvzwAQYK9gIJ/vMO+PcFDfv2AAQN8QUJ/PAO8A359QzzC/j3BgEECvIIDY7YdzAAADg0lEQVR4XpTVx3LbMBCAYR6pGY1PpgrtRO6JYz7IAmBVr+69J+9fAoowoOWCtvxfJX4SFhDkfFojcPeEas8NGj+rcypfaf36I0hurfVN6MTfAEjKTgKw4Z/YoQpGZCDjAgeyTBCqEgqEEHEVFEswWAvaX873VDozUWomodPl5Pe/hmp1kbcA+4xgsSTrta+gQ7HsEmRhGQpBdlmgh59DvigagEyQQDZQqk8g4qgRRRSK1JCwRKEj/cSjHhEZ0qNmj6qghnY4yHoU6uFD0bBDrTqeKqcQx3tQb1khl+4zjp4K1wa1FUJmPU3TKZ62qW2Bmnh3zKxTmZk23s0mhWrkR2WD4vL5qhGoKUyZmqmB0C5klq/koAnhTUMQ3jY6JQedabwADOFFm/wSpAg80mmKmuJtUGGojaCugtJSCuoiqI2gwCjm3RQyn2EKEHRAoMS+tIRABwhqkis1sQ87IVdwE0GC89J57NmhHr3xVqHNBGAcIii0QyGCwjFAsunJHC/v+B/kRTH/DsTjCPL6xxrqzKFoMY75ehCPxwsoYp0P6DdjE9DNugMN6WsEQ4PuDHQTxlYg9nwGJg3RQsCdPTMDeR2WU5OLVShbA7qY5IxZmrfLiq5vnjQk7HGtPN1cs6JdDXk77KOX17cIXczWv+3o7fVFP7LjGcjbYqb5+XB0JSq7Gg3P58y0tZ3nbBf9+PvOUP3bu+H96GFVeBjdD+9u+/87qdMdBWEoDMOjeDCRNCD93Us4iBvijjJi5m70/rdZNHFO85VY3p8NeZJDF/nd7W7otw96xJxNvjo0yZgtiDn3piY5M4CYs+nsfWU2zZgB9Gw+XbyjLJZzZgaQ4VfZfVncWpBiec/4VSqgiK3yVVmuCzHprFiX5Spnq0hAY7bb/ATX7MYCokFXaEASUqYbZJQFkdJdIK3Ihoi0P6SJABQLaLvZbIWC1mIIJexdAiHlDykIkfF1DGEo8oUiBzREwG7/1w5BQwcUotn2z9BkoQOiyA+KyAUpv9GUEyLNHmlyQz0fqNcCUSCHOhxfwPEgBwyoDRoZa7+q07n+rOvzqbL2zowAhC/cHoSuGYZIy/2S7cSfBhA+lZem+q9UzQWcRQChR7durg/l2tTggRUQlnDYwRCWsIMhLGEHQbBQux0dEoZwicGMSYi8IApj5MQhtUKY6qdSSfuCwRBOJcETS4NEUUvfamC2YCpf6J0AAAAASUVORK5CYII="

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA3lBMVEUAAAD3zYP/2YP/2YP/2YP/2YP/2YPZnoL/2YP/2YPZnoKnqaynqazZnoKnqaz/2YP/2YP/2YP/2YOnqaz/2YP/2YOnqaynqaz/2YP/2YPZnoLZnoKnqaziyZGnqaziyZH/2YPZnoLZnoLntIL4zoPepYLuv4P60oPjrYLquILlsILgqYL2yoOKk6M7iMPNhGnBaU/bZmPdLkTbX1/Zl37dPEzagnPaiXb/2YPae2/bdGvcUVfdNUjxw4PsvIP91YPZnoLbooKnqazx8vKsrrCtrKm+wMLMzs/o6emwsrVQTGJfAAAAI3RSTlMAnwCP71BAEN8wABAAMO/Pv4Bg368gQI9wn6+fUDCfABBgz36l1XwAAAK3SURBVHhepJHNCsQgDIS9t/Qi6MXO7rNM7M++/wttWAxeCkb2u42Qj4wJHoB1SFjHgMQ/oryhNE8zFWx5XpSoqAtkrSTUQiXNipZI4xQ5acRlUpT520ThLXKTlrNfZMUukYuKKJ+e04xoj2QVxUTsOe6vB8LTY8Fhg71azweKp1q7jlWxz+65XXMoopOR6E0n39rrrjdVIAjAsKV7LJg0CqFJqTfbckRQa1uodm2rwP//U8f6cRiYWdwh6XtJ4pNddAeUVq2eVc8RyjDhYAg7fKmHHL6EITlUrIZSA40UsxENuYqdS0GO6pBDQMMu0BBDnuqU14Sk6AYJ2YBc1TG3AdldIRtA9B3a7nLDuwQhHztFURpRPoQk5RSGlASQh51z4d+LewOQjxzQJJq27w1AgnKgFW71CxMV5CCHLo7jJMKi8x/ykNPWJJnim9TDAyQpLjerUe4ZghMtjwujIgCNCCifF4aFFAQd45JKwlBSMFroobzgNNFDEQCel8tnAFDXFlpoBqDlPmCAa/gu3Z2g/hmKeVAMVvRL0IQHlVqoZEK/v7WQ9/WHWmhXsNppoQUPWkCoPiAJ4OX10AsBtRzaGEOvp7ATt0ARB4paoClna9MWSDEG21y1QVtzaNsK5aWpU+Y0xP5N7hQBjTRLekvT7P0IvGdp+oYWhCF6Sem+Vbb+WK+zVboPLYiG8FBKG8HBT0LXwIEHLqs7GThmNOQqzcN/s6qY1QaOfZiN30bwifv8+v5Rvr8+0SlDj2wwR8we3PNcB0nFkICDIMtGEsNRLnoZBdJM58yQo+4r6F6hopJiykjh+hV0hyFx9YCdhytBQLKCrGFDCf7s+dtxnRnfDgYD59pGf/4A5CHl0M3j+OmIPI0fbwan+oHQvPnD4+Z70rqc58MFQUj+SHaAFG3SCw57DI6f+AdnjIRTGOJmIAAAAABJRU5ErkJggg=="

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA/FBMVEUAAAAAAAAAAADdLkQAAAAAAAAAAAAAAAD/rDMAAAAAAAAAAADdLkTdLkQAAAD/rDMAAAD/rDPdLkT/rDPdLkTdLkQAAAAAAAB3UBgAAAD/rDP/rDMnGgj/rDMAAADdLkTdLkRvFyLdLkT/rDP/rDP/rDP/rDPdLkT/rDPdlSyFHCkAAADdLkS0JTf/rDMOAwQcBgmKHSs3DBF8GiaYIC/PK0BFDhWmIzPBKDwpCQ3voTDPjCmAVhpTERr7nDVvFyIQCwNhFB7ubTyfbCDjRkF7RhzqXT5wSxYgFga/GTGgBB75lDbfNkMwIAryfTnhPkJlJBzwdTpAKw3mTkDK2XiPAAAAK3RSTlMAgI8An99AYIAgv++fQFBgEN+PIL/vMM/vr+8QzzBwUM9AEI8AQL8wn+9QymoucwAAA71JREFUeF6ll2lz2zYQhkFZpCIwZljXkaraUVI7dY8FL52Hz9x3ev3//1KJILAACNLG6PlAz3o0j5cLvAJMVB6l6flLSRfAD4gk8AG62mcfvVQgapFueSIKD3Z4wmOUP6ZbWkUXoghBmNADoRD9fq8o/ZUXEVT0dp6eqCLuOUnvF/3Ai44QhX1C+qGoOmJCraKLFKdEQUAJUQre0M84BZvonLd0sit8kPR6IPFxQul5o+hJKeLLCojvA7LzPEux9Zoo6FB6mnKeoQhRRBdcdEqp1ycGvPtLLvqDegE0EHijn7jnEhdVgXf/IeVccUG+uC2Wy+VqtX0Ut4ucq75tuOgDDq0muttUpn8B1tMVM1hN1wB3VdubO6uoCyVvKtHm74RZSRbiI2+gpGuI+lz0UbT05Suz8138qY9cpE8bw3SVoqnNk15hFO0vdylMN//VNX99EZ5LfDGDwJdrIvjH9LxOBZtvXOQHpqcDgnepxPB8TSXvAFOsEg9BkM3f3y96P89AMIzRMwhBUjAmTcxAehgrQBIObJ4J2/L2pk1083ZXTOqm2AdkxqdRrvJr67C/830xA8SPq3VHcvZgckC61Z5Gpg8XTbkD9/cYFFYPF61AYVxmA1kzB9bAEUkZAHLrIroFpFw3ivXSRbREDzW3NXOivrm9EEfkPqTQq0X2Wv8uBFgk9RpZ1GIbWWadlLHMErO2TDuS2Q8xH+afW9hrLSVhbH4XLS2TbKhx2fDlMCOJmyjBhBihZW4iZoZ2PxGGdj8RhpbuJ8KMhPuJ8JIKe4gQraOcOW1Is6MulswhIrqoqx9GzC20zDiQ0MQcqR1sY7qPiI5jIol8zFo7Ztb8iCDxCNPv/qU9kg31h3iBMPj0ecsn/mw8Iod9vEM0nUafFZrPo3Bg3CEmbqKJfosYgSRze7UMJCNCAlBIHBcNCcjI/TKCs1ZbApWFi2gCKroI5g/3zKFNVLi/mV20djz5ETyMtJS8gqvy3w3+BLV6hflQ6JKYgspEHMbpFvHUq5ll1DTeRSSooLKlok1UyIZoUNEnKhFOaZ7x19BF/HfZHC/HEbEQh0pyEz5KXVSyTjCveA9R8fScFDkOGX/mhZ4Or+7BYymvduVskYFGdj2r9mKGx1CNAUjWcn8vp9eTvHRMrqdLuafX6r3YJADNZAc9mPoaQ9ku9f580ex58YtH5RiGtlXrdSjteFHZ7NlRk+fo7GDLIPJ2n+7F5F4Oj22a498OGiAHjRw+NixPHx+ioFVkcvb86PhpJTk+en7Qxv/hy+dGcmy23QAAAABJRU5ErkJggg=="

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABYlBMVEUAAADaL0faL0faL0faL0faL0faL0erL0KWLz8pLzP92IjpoKzuxs3z6++WLz/nWnDolKHhYXQpLzPaL0f1+PrnWnDaL0faL0fnWnDdSF3aL0faL0cpLzPaL0cpLzP92IjnWnDaL0cpLzPaL0c1LzTaL0fy3+T92Ij92IjnWnDshGjshGjnWnDaL0cpLzOjL0FrLzs/Lzb1+Po0LzRKLzfPL0ZgLzmuL0KCLz3hYXTyo3T2uHz92Ijnbl/cPFLhT1NcYWV2en7y3+Q2PD+5L0ONLz7o6+7eRE/nWnBVLzh2LzzrrbffVWnuxs2Ch4rtucKYL0D0rnjz6+/jWVfmh5VPVVjpeWPolKHEL0XP0tXdSF3ePFSPlJecoKP7zYTibn/poKzwmXDcOkv5w4BDSEzCxsi1ubzlVWvriZnvusTYxsvw0tipra/keoriSmFpbnHc3+Gjh47dOlGQSFWTYWvcNEz7ZEWpAAAALXRSTlMAYL8AIM/v788AAAAAAAAAAAC/QABgMK9AAN+AQBAQML+fcFDvjwCv7zBgAK+mXzp/AAADsklEQVR4Xs3XV5PrNBiAYSdKAkvnLHBglxxYwtI/uaf3urX3cnqjd/4/ltb5xpJlW5PhgndGN/bME0lWJrERlsuDZvkcUWUQVqEI+kGxkAQVSgIwrlLq1dTIBbv3SiEBEudz4VKWiUD83qtvxTKCkQMhi/Lci7jje5Rn55QzkvbZprd5PshZNCyvhEANUUt2Dug80IEsOu9AdMbo2NkQbihvLGyQjZCpBYGJkB3dpk10tkAPgi2UNgGrCxczIfnD6/Fpur4+5LsomYqN04OuGo3G/AHhufQ9dP7qakE7uw5r/2+UPF84EgPHGZ5kQw1n3gAlK3oST6fs5nkmNERoehrZFNyg0aXDu/pIzggGYL84mHM5mkOTGpovwpuPXpczggHYIyfSizi054TtviFnBAOwXSfajby0Pt46elPOCIYMYX1xs59NHew9OSMYgG2L0PRmRG1+tk2PjgYRZ/iFnBEMwE4cqSGEddHQ2qMdR+4hPk+h83fkjGCI5wibDkb959shtB+ss7+Hi2u8K2cEA9QHiZ3I0Y8hdLvzp6E0zP6uDaVjNADelfMzZd0PV5YNPZRO0bNG+B0cRE7SUTcbgm0Rojsh1I9AJ6ABdX8Kofvc6c+Xtseh3/izBx0Ipd859Mf1y430Pv3wbZYRDJCkfQ7x7R18v5Hd+wjJnRzdzun55Q8bOn2dBEH3fMifzvlLLei7JAh/A/7Z0AuhpP78v0H/3dJgwc2eTGToeqHHP6HUu5CkXxc4kPw/iFtjgF9j+Uxa5CviUpZXr7o0zKvWOQym5VKhj5ekjGBAGFVXPTiwEUiFVpIgd7Nu1viu1cwtOxvKKyHXMkFobGVBqwrIrbOtnp01W+2gVvNsxublpUPLcchiTIchWKsD4FupUFmGXLaoHjJI9QCsNGipKELuGADO2orOAKpp0CoeSHQet5U9nv//v6eEPhBeQtBRSzUOLcUhVolDJr7JdNqJdfji7iRAa8Czw3erXjulHnvp+SwBqgBvbNsTBh62sWZnBjDrNNvYIYw/v3NPAeHasGNknh7jtacoHZeSX9fJehTCj289AexJCye5ngIVohDOhzso4ZwKKRDJKyBcl7Ti11QZ4YVKfGmHooPP4MtEiLcCWO8Bcx70UBCuf/VJOpSDiBTMqYmOdP2bb5UZeKEIWhWJOgMvLOtBy5kQuavj3CXZULmU7ZTKGhCpZEMVogOR1SxnlehBZC3dWSO6EFlfcD4IYZWVJGalQnQgrJxTnsxirkxS+xf9sBNcnBaDngAAAABJRU5ErkJggg=="

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAb1BMVEUAAADh6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O0pLzNARkrK0daco6dMUlY1Oz+aqrRXXWLW3OF6gIRMVVuMm6Szur9jaW2orrNudHmRl5yFjJC/xco8B/HTAAAAEXRSTlMAMHCv3wAQgO9Qn4/PQL9gIMy2s6UAAAKcSURBVHhe1dfZdqQgEIBhF0Tcui3cel2Smfd/xkmIKIhVSpKb+S9z8R3EYNHBf1YYxQxULI7ChCpI0HjKwIqlnIBwRoCTQCgCygSsJjI/KAe0wgPiJRCVHIFoh5ZoSDmktA/KYbNiD5TBjrJtiIs9kOCbUAq7SkmIXhC9pABfEF20ATEc6M7yo3MHKkZDIcq0vRzrWyWFJBShziCnhtZ8towBsGwJxRjUS6P+E4qtf7ssQLbo1UjZvEDXSatu3iT9BV1AkyNVk3S2ofMnrhwOYwjUSFWjIQXc7qfT/aakCao2IDlmQreT6mZB2Teg+xd0t6DiG492GrMggUDUZmvI3OwUMAh7/fajdSMUAgph9eZm9/AFRcIfagf9+vURgYjBXGlBYQH7Dq3bwYDCgwHQnxG3YoYK+ElRgAxF36rgdxxIgh3O5bLpxAqihmt7VaeleXuR0FFBxHDtBqlrOtwRiYK4QB1p1v8lxmVAzbJW2g0dNi0VVAPWm1zWoVeKgBqug3R6rF9yFCTwJ3MbLo6TJwoiXtlDrvQGduKoJ22OQhe5Vmsvp040JIDaI7frrLAjT3RBaAAsspf3XIN6mOPJDEWgE5Ged+agdjOgowHNawiTJQTNBnQwoIN9K9zx3sConiExnTuVsKXrBlTM0OJPB7A7O87ThIQLZevX/suTPm5HB6qwu98VW5CqdKARrsDpYT7e+QJ2lYaYfdvlsNLjiX8lcw3py+TGb6zH+58/76tfyHqE9PVWl4NnhYYWZb6Q4OsQB98iF1LFvhBDoCP4lrmQivlCMQL5LwmBksNvQdxTEhikqqoqLR2ApdVHEbOgnIC0xmwn5ys/EEWtIarUnYWqsJycMNEQWV2UoCrT2n65sWLy6dD+uF+G/gEhWwJhtN8WyAAAAABJRU5ErkJggg=="

/***/ }),
/* 947 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABR1BMVEUAAADh6O3h6O3h6O3BaU/ZnoLh6O3h6O3ZnoLh6O3h6O3ZnoLh6O3ZnoLBaU/h6O3h6O3BaU/h6O2MyveMyvfh6O3BaU/BaU/BaU+MyvfBaU/h6O3h6O3bsp+MyvfZnoKMyvfh6O2MyveMyveMyvfh6O2MyvfBaU+MyveMyvfBaU+MyveMyvfBaU/BaU/BaU+MyveMyvfBaU/BaU+Myve5d2fBaU/MgGXEcFXGc1nVlHjKfWLQim/SjXKKk6M7iMPWl3zHdlzh6O3ctaN6OCpkIRZzMSTPh2zNhGnJel/g3+Dao4nDh25rKR3DbFLYm3/f0czSlnuBQDHZnoLdvrG8f2eQUD/TkXXcuqrf1tLbsZ3dw7jap4+MyvetjY63e2+Zss2PxO2drMOnmqOWuNjBaU+gpriqk5m6dWSwh4SjoK6TvuK0gXlQNDorAAAAN3RSTlMAMGCAvwAgr+/fz59QQHCPEBBAYIAAUI/PIN+fcO8wv3DvAJ9AvxCA388AUO8gQJ+/jzDvr3Bg0y8mBQAAA5ZJREFUeF6U09mOgyAUgOG+goFo6YUx0nRfrKV9mwO4dZ33vx5TzJmaCnS+xDvzKxwY2cWEZhmgLKMkTq1G6SBGxAYGbARh/wgRAQ6CfBkiC/BYkC9C8RJQxul62llTngFaxr5Qgq8mAzsbJ/iZxB3i3Z4eWGrBDt0UuCtETUfMUodZNwpqDzHTIakHMSVmDXH8Zyd80Royq5++BYLdef5y3gWrP1Ozk9YQ9ENhNG7ejKOwHwJXCJe2nU+aD5P59hXintAGNzvYNxb7dokEPEvjYIjTsbE6ngQY3DV+o3jcbJ3bo4AOcx1IVF/VZ0Vda0DUe0WQvlT3n5Zqn3t10fCO+y6th+fSolDV8IVahau+0aonb8cln+DxlO3wclcoMEdZluBQSnPQA0cowiHLsoABRSnxYET2UN6ftay0BqR1JdUvZXWs2yAMhAG4A0iRIiJlCVWXjJEqJUOHBAwJdApZzsMNPAHv/wqtqSph/jvL/ieQ0Kf/MMbeA18qlE1JyTToAsBzeFFAugCkFbLMPN6qYCWEzuDU/BfTKL3OIlTiZPwf+xRrlSIEP7KKl2kF6gMgcTLDfgbC2QTounZaXse+1tBVgEp0MHeClwRQpjt6qUyAvKOHRtYyeEeUAHmOYT3tcrwwVBsOxVAkVFsEUNIhdB5d95Cu2QQh7NP9Bq9dWoBg+annCIib1aohNHIUZCv1OzrNzsBxEN9n6CRAB+dUNhbibwcdBGgPGwMhqLRHaN4j5Dm4/F7IvWsJ2k1Tw/FxC7cTob2bLCGtmwwgl5L6FKinUj2yNynQJl/mzbvbpkDbAFSkQEUAyo/xzjEXofRKBUA/jc/BisIwFIXhtIVKQ6ChcFZxFlnkRY4zs2gV1Kq06vs/x9QqGjWx823v5b9cnRWkzDQGauEHvn+e/PqzrxwXlXGurAAIJAVHUgMl68YLLVd+Z7X0Rk1tE0DPODKA0AVvJCqS69az2T46240/WZM2h+ONgch4N5cc7Frf/vA7fnXYt74dByblnRIF7yRHXTup44WVvJsJvuumO+8CIe+7sB3/G+K6iWeaNUOEY0i9iHUWNUOcSBnWH0OZY8+wuUDBiL57ebDpYhlaLVAxrj8dz+3ofDz1jFMQQMpPbILBnB8ZQABIJzqTJYNrCEnBCKdxoywjbIoxNMqCa4XCgzYMMjm8EHQq+WKm8Cw3b+fsmPFDgzw1jlfWlUojQJXePWm8pT9OqB21n0fRcwAAAABJRU5ErkJggg=="

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAZlBMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t0pLzMzOT5ITlOjrLNweH2Pl53CzNJSWV57g4i4wcitt72FjZM9REiZoqhmbnNcY2jkjSZeAAAAEXRSTlMAEFCAv88AMI9g798gr3BAn40GuAIAAAKnSURBVHhepdjtdqMgFIbRoAEVtekB/DZJ5/5vclYZSdB3JIY8f5u1S6yHsjgFYkl65rTEz2nCxH4nsVOWc4J4nr0JFU5BqzgOsVRSIJmyY1BR0ovK4gBUnelA5+oVlEg6lEzCUE6HywMQq+mNarYHMU5vxRlCzomQEKrp7er/QTlFlCOUUFTJFqpkHCSrDXSmyM5rqKDoCh9iZTxUMg9K6YNSD5KfQPIJFfRRxQPin0HcQdkCTPfx2vTHgL65jvdpkbIFysnWKpvpwAKlM8rWki1fIL44Lj2GnVFb5SnxfxCzzqS8bs0+09yU12QlZqHEQne1qt1zWrXq7kb35N7GUa0zPWHUG7VudO/kyc3rVW26zejMN7Xp6ib35J51o7ZpkGattjUW4hYiW69QmtbOhI7qyeZBZFAy/eb5QIYQ6hQ2+NCgsA4h6rXCxqczKkz3CNlPYrNzZrXzexCim8KG0Be7EUDuDcCa8M98iHuvPzbggnCMuIVqemQUNu89IUOPagt9hV+VFtaKw/hloSw8BAaWigOUWUiUYekXCjvlskOm5DUZHCccRDORV7pAFfn1w+sV/enJr7IQHrHGV9AIx60FutC62V/Uzy/04zHDTOsuDwgPNc2D0tN6KxoaPNg8oYqguTV2PRPZJrsm084EVR4kcoouFz4Uf0Aq2QoSl1joInwo/svlYgsxHuNwBpDI5PuOzARCIok7riMkiriTMULiewN0Wl8dcNW62zjfAqAdSf+ORDcRTd3vyGhwAELJQX4aHYRQwv/iHTgAoYT7yTCDE4REutkErDVsxj49dBNx6O+OEHaRYUZexDFIVDzk8ErsQVgenPcABCXyyJ0IQhirA9cYIQhLYPstE4EhhK1vtmQKwEsIL8nwQgyhcEUtiWRdiBf9BdZEGvROMS2JAAAAAElFTkSuQmCC"

/***/ }),
/* 949 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIAQMAAABvIyEEAAAABlBMVEUAAABVOYbFT/47AAAAAXRSTlMAQObYZgAAAEJJREFUeF61xoEJwDAUQkE3cKFC99/GAQJWMkCF8PMEOdSebEwCbeernNzFLR0KxpzoLasojIKudFngwitcFTV5/313TQsi1JsBHwAAAABJRU5ErkJggg=="

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAVFBMVEUAAACqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaafsdwVJ9VOYaVecJaPotqTpplSZVgRJClidGKbriFabM4xMfSAAAAEXRSTlMAML//rwAgYI/f71CfEEDPgPWClcMAAAIeSURBVHgB1dhhb6ssGMZx9PJGQKpW1m1n+/7f84RIntArzBXlxXN+70zrv6KpEJTqemDopECPprdIbG9GLQXdgHi+6hwAuEnI5GODWD8JmfbzOzVgN0pGG4cfOKMlM2I3KCTwN0nmAYeGWZKbR4IUipZOIu3xK68l6hZQKDE3kdXhBW4VuRlk1PL8+YIXLc+/uKgeTfTKoAmjRjQxqg5NdEosGrCixKMBL0pmNDCLErEtRhZDIy4bY6jBJVnZQzMumlNIBlwySOsrGnDRsIc0LtMSQwaZ+xbC9oZDb/E7d2SMxJDLO48Qvb8dZN5D9MhLLoYmZLaQUIoy0YbMxH/akHCKMxH/aS2FKEWZDL1GNGhonOIMDS3R9Kq9PwKl7ukDyuQ3Oxr55V8+ofwDOcPTUXkIhSGTXlkwThUfArMKjFMc4gzP/Zz6KA/tI2ZqQvgs3+xP1IZCkq7gHpI/tSE+8XKIj/HvhGybkFX98eP/5OPqFdvXfuIXH9ev2L4fITy+fzpmo9JoQv8fV2wTGph4gjzJ8ZR9lmm2iGi6rKGFFq1Mctv9t6WfB6HJkiZF5iWFRDskNH2zDQVO/xeSFQWhAAWrpFC0nA8tkoe0Ozs0p59CMp292ZM8h2Q99/hX4ZB4nOCFQidLXjjEpboOh2RFlVU4RHs4r3GTcCijX9/S0HIUqtlkOQ5Vbfsch2o2osqh+q2x41DlZh2HqrcP2V90G3B9kXDkJgAAAABJRU5ErkJggg=="

/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAbFBMVEUAAAC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsBYWFpBQEJ3d3ltbnGtrrCBgoW3ubu0trhJSEpQUFKVlpmLjI9nZ2lyc3adn6Fvb3GGh4lgYGLvkwCbAAAAEXRSTlMAMGCPv98AUJ/vIBDPQK9wgNHG4bsAAAHoSURBVHhe7djZbuMwDAXQWpZkLXUTek26L///jzOYGJQSRpSt9KWD3ocAxAWOwAAGLN8xqUQtFSxRshaVTucuVTTGAok1zTbIBYVaLg8hA2yQ4iFfQza1z0ONhRWxTQ6qYWVqFvISVkf6NOTvYUPuPYGKHJQoRJysdB0ysDnmGtRAQRoKeVsCWU8gA0Uxl1ALhWkvIFkKyXOoOm+Px3jiu/YMMqGYhq7/m26YEGA7E0M+nDf0mCEItDti4SNIoNP1UTrcgutEBD1QJ0i57iGC7ALhXmQ7prMBqhZn6kkmyHcVQjtyKDmW63YImQXqKNRBvjMIyQXqrwTynURInZwjA3GdQghugyCC8qv9cOiJOk9cl4ReKfTKdUnonULvXJeE4OPS+QCuS0MwkKeJ6TgIps+vxxPy+PU5YcF3ASrJz4DkbY78fmh/G7RHSHDA89s4vj1zkEDIMc7L+C8vDOQQ0irFHOZxyXxIOUoHqE5B84iZU1CNELPbGIXZDCFtyiGjY8hxq80zt5o7g/Qu/WfPh9PvdWf3/W+1KJU5FNL7soeDQrrdejtqkxc/odYzSrBX0XbDGz8L6bWQ3gJdLKqKITL979AvZINjuSkLmQAZbspCDo+1jpuykK4WyVb8xEP4pc4ax04kfwBCBB0yJf7XogAAAABJRU5ErkJggg=="

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABEVBMVEVkIRaSaMrXnoS/aVIAAABkIRZkIRaSaMpkIRZkIRZkIRZkIRZkIRZkIRbXnoSSaMpkIRZkIRbXnoSSaMpkIRbXnoTXnoS/aVJkIRaSaMq/aVKSaMq/aVJkIRbXnoRkIRa/aVLXnoS/aVLXnoTXnoS/aVLXnoS9ip6/Kz6HVp17RXDTm4i9IjnShXXGTFLCO0iISDh0UKifcr3QfXCSaMrUjnp4QGXVln+BTYfAM0OJW6ibb8FwM0O7GjRkIRbXnoSPUD9rKR3Qln2/aVI0NjhyMSTBh2+lZ1SBQDIpLzPJjnZ6OCuAOCmeYE2sb1uzd2K6f2nEc1uWdGbAe2TRkXjUl360YEuWWEbLhGvFdl/IfWVHveV9AAAAJ3RSTlMAAAAAABDf769wgO+PUFAgn2CfzzCA3yDPv4BgUL8wQL/v70BgQL9kjKzhAAACQ0lEQVR42u3WW3PSQBTAcQISAwELSou2aq03qum98YqeEzaEcGl68+73/yBmkMnJMsnuJmGmL/2/7czOb85u8rClO0l1aoYO83Sj1inlrFrXgUuvV7MBNcOE5MwMVLUFosymotM0QVJLyWmAvIdVVae41ARQk2T3bIJiDTHUAuWawoGAbyCATNE11YAvAEF1AWQA14zlHckELgfPc44EfBeIjgDSVSEPw2YCqaMInWMYE0g1NWiG81j66QwlaDDFRf4g8yUB5Y0wajpOkRSgXwzjXY5zQWN/isuNnEFmCFO6cLyCEMUuA2fsFYeom4Guh8NrpGidFRpOJkNiaJ0ZmoQRQ+sEqPuqW4kqVSp5oO7jzWfPXdfd5KAsRzv76XJ1X7xcf72BuF4ql7Nc9plL/fn7+/uPaB9BCgF8w5R2skEDTGnj6Sqgnfv3yuVsEKQo5SIQKTw0Qq4rN+wKuUYAiQoP+XLIhy92LI2rpGkw7wilHSlBwGQOAzXIl0GBIuQxyUAewHsh9GQhBdKB4K0QagBwf8DuV65P0beXQW3gD7e/F3f29qODyaAqvSD+S+8OyTn8gLHnyUchpBnLEp4ezM+3e3CKcQfeiKF28iuCGnmgBGk6UAFbZlgAoAi1IZbnM47xPYj6LIKikag4BPFsGbS9KkhrrAbaemRzxSGbSwitPbCpAtDaXXs1UDQPZZFjKUNbCVt6BPWUIbpnqm9FA/WVITupE2vhnNi5IKrfs0Km17eLQdRNQsfHdkq04xa6hVKgfyO6WEd4s1JpAAAAAElFTkSuQmCC"

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAsVBMVEUAAAAAAABYWVtYWVtYWVtYWVtYWVtYWVtYWVsWFhc3ODlYWVsAAABYWVtYWVsAAABYWVsAAABYWVsAAABYWVsAAAAAAABYWVsAAABYWVu1loajin2HeHB9cmxhX1/msJTaoITZnoLRqZKZhHlrZWSskIHdnIHEblTBaU/ar5ftu590a2hmIROQfnXktZvIo45uKxy6gWsAAABYWVtNTlARERGUdWM7LygWFhc3ODkGBgbJMQayAAAAGnRSTlMAII/PEDDfQO8AAADPr4BAYBCfML+P33DvUDKbMMAAAAHySURBVHhe7NC9DsMgDIVRM7ZFilBklOewIX/v/2BdyNJAlevZ3+Tp6Mr0U+AoD4oc6F+J5XGcxs6cBSjPI2daBGqZBnuaA0jdTSkLXO79icUQ350gpgIwCJwUbVC8QWLMIYcccsghh4h2m7O/WnQdhw063i26Dq0Wp+qnRdeh5cSds3QgLfCmWrQHqa4bwmzrt1w66k0QBgI4vkABk4uEGBIztLgJ6pgimPv+3229qblmbVPvef83+vDLtRxiAPq2upj4y3/2H6HJgubLZWbCeza9BN3m+cYEnwmgaHGokUGNF0oNtJFBG+OkDrQ00FYGaQMtHag0UOsBdh+fpo+dB2oNVDpQgaa9C5FDkuvs0VQ4EBDUSaCOIGDIfqRecrWensgDVWiahFtUeSBFkJb9M1QeCFYkTaKBVuCDMoK0aKDMC0FN0sECjqcvq9PRcg7k1OBAPFI7MESOLbEztDyQC0FC0vkV6ExOAiFI5SSN8auN5OQqCEGBLPljBwsIQ1CyFHNKCEG8TKivYeaqkVcoDEGKVB9czKlHKoUYpO4SjoOPGUa8OyoC8e2w7Rxq6Frke0UhWOOjbWNZQ7PFR2t4DYIsx2e93vyme3yWZxCDuHKBgRYlgAACRZSPUSCCiKrSv0xaESOA2Erqx2CLOnknJdgPbrnAEemd3GEAAAAASUVORK5CYII="

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABF1BMVEXdLkTcWFvZl37ZnoJmIRMAAADZnoJmIRNmIRPZnoLdLkTdLkRmIRPcTlZmIRPdLkTdLkTdLkTZnoJmIRPdLkTdLkTcU1lmIRPZnoLdLkTdLkTZnoLcTVVmIRNmIRPZnoLaiHbdLkTdLkRmIRNmIRPdLkTZnoJmIRPZnoLdLkTdLkTZnoLZnoLdLkTZnoJmIROiKCzZnoLZnoJmIROzdF1mIRPZnoJmIRPZnoLbZmNmIRPdLkTZnoK8f2bagnODQC+gYEvdPEx8OCjaiXbbX1/bdGttKRqRUD21d1/bbWfcSlTHLDvFT06/KzjZl36ub1jDh23SlnunZ1HLjnTdNUjcWFttIhbakHqEJB+KSDbcUVeaJyiYWET6nfzmAAAAOXRSTlMAAAAAAADvMBBA32Dv388ggJ8QQL9Qv4CAr3BwryBgYJ/vEL+fzyDfMI9Az48wv3CAr1CPv1Dfr5/4zet6AAAC40lEQVR4XpzSyWrDMBCAYYNcx4HgQ3KwIdihtRuFLmlD2zSM5Oxb933v+z9HkaKoMpg40n/Q8WOYkbWTm+tjABzZru9Hrr1Nlp1XyQNeggGgcmEMuRVQ842hBNQ81xjKDoRLxhBkq4SGUE1BBuyJDaHon1nSMZNqRpCLmTFMKW/IoMQI8rhDqQJhXUjefk7XPQDLAPKB9UszE0GoCck/9CyhselE4lxUlIIhFMKqBeU9zsF4ItEXc5bCibeCGg5t94JyE/E8EDFoINRoK8ihIs6dgehFngywrQepze75O6E0TdPzoFxFBVkINfKkyZS9o76Uu0fNIgihZjnotWk2MqN0Sq5UvFEEibLciHxfEzJSIacIUovWH/uVsNhIg0XQOdSGfPEdP4jorY9j2+4wqK4DxcB7mhKZZVl15nSQ/kTvt0SFWvxsVS3oZAXdqFC1y6AW0oJC4H2qkFiQHoQS4N0RWdGCDqzcXMyhHyJzNi7oeJfs7+VL7HCXpwq0aUF/3dZBS/NAEMfh0UjBDS+b1VSaVNBdiGB0C743+Yee7MVDThbB7/9BnLKE5pJhQnvyuS78YLM7SYIBUNME/oy1GOBhsRgPR1gWkQZUgi1p2ijU0kh0HoDlxPX6dcPTyCrShXIa2LpJ7bs0M90OrAnKkE87iVwZvHfJV1rWhVhTlSXGdqnznR6QqIDkmyuLzeo/5wuSlRD8exvevW0kmYXABxLod2YiqVmPSQXN4DCpphlaTKMZgsG0lvSeIWgCaeUQNaQUPWRuRkdW6/cl84rzqiDQn1w0UGlP3lZZGLCouM+SyhKFZ8Bp77N87NaeuDFDSuW5Qh4wuXQfHemkD6g0sUuaI+LoZ7u99xigolkMBp+H36LQCKMhqjF45NAqG5VoluCRuDWHNlkWHJKSJsiT4u01h14y5oSHLcl9moenjmUHuQGM2JH1XddfKpG0uO/7/YUSSYtgdA5/OOTlsdDLvc9J6Reum6OsQAEjMwAAAABJRU5ErkJggg=="

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAk1BMVEUAAADqWW7qWW7qWW7qWW7qWW7/zE3/zE3qWW7qWW7qWW7qWW7qWW7/zE3qWW7qWW7/rDP/rDP/rDPqWW7qWW7qWW7/zE3/sDb/rDPqWW70q7rrXnPzprXueIvynKzxkaLsaHztc4bwh5ntboHoVGngOU/yl6fvgpTzobHwjJ7dLkTrY3jlSV7eMUfiPlTkRFnufY+loD/jAAAAFnRSTlMAMICvv3AA348g758QUM9gUN8AUADfpIytYgAAAURJREFUeNrt0ntPgzAUh2HKmLgCypy7/Fquu3rX7//pXDZMwQbSAzMxS9//Tpo8adrjdMXckeeO2aNJTvsR83BufjsZAjGOMhNCJHkqEUzokHJSUZUcJHd7QuEcUqiSEl7YC3KBVNTLJWc9oJADB9EoUxIBcqFBIik4I0McQClaJAI0wzEpfvckOaNBAXAs16QMfEKC+AnaCK017kICxHBur0sbBARoXEGvif5MwMwcClCVCq0Uc3PIw0/PGpQD98YQ0CEBIwLUIUmgF4Qv0Qx9IRRZ3dnTIVWqqKQgQVrFen/aorXEEGgL1SDoZfe2vQx07H338TkcqrKQhSxkIQtZyEL/BYr8hVF+dNPMaY7RwrioE/LNIb8TWhCy0LVB8XJl3DJ+qOfUh3hFKm6FpjRo2gqtiF0/NPyx/+77lTQl3Ke5kN/+FLfWc63E5gAAAABJRU5ErkJggg=="

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAZlBMVEUAAACImabdLkTZnoLdLkTdLkTZnoLdLkTdLkTdLkTZnoLdLkTdLkTdLkTZnoKImabdLkSImaaImabdLkSImaaImabdLkSImaaImabZl37dNUjZnoLakHrcWFvaiXaImabdLkSocYHN/rH+AAAAGXRSTlMAn1C/7xDfcCCAYN/Pv0DPQBCvn0BgYO/fISVGLwAAAYpJREFUeNrt09tygkAQhOFsBPEc1BiVAYH3f8lgPMDm3yrIOBemyrmTar+KdOdNe+uP0jsrp9Q7NhAcJeRKG2hXGkEbK2hvBR2sIGcFfdJxyvrpKKEndzZWzvoxxzmb3+WaFbjDfrN72Lney3k5/9eZLGoTZxpVVf2wM2mY89VqJ07TNNnOq9vVOue9Efzb6pzKxokjOqpLfjuJsqqFz0SptnLfWcZ/6mj+Hn7V8y9k+jq6p6ZdJkamt6Po9hOWLbREZkhHSQhipr+jxeXzqurcCpkhHU1+Hoy70BiZnlfdvsqZdCGZIYNjR9Pz55EPjZDhhV+t+JAgo4NOgyB2BCgXZPj/EO5IJGsfZCLMYOvhjkSK9kEhwgy2Hu5IJM/uf1Auwgy2Hu5IRE7Z1TmJCDPcOju6QJIXWcMUuVygIyBunR2Jf2GIW2dHhJjh1tkRIWY4UXZECJkwxI4IMcOtsyNCzHDr/NqQJ9y6EuLWlRC3roeOzwRx60qIW1dC3LoS4tb1ELeuh9ozhr4B9SUEgq+CeewAAAAASUVORK5CYII="

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAtFBMVEUAAADXnoSSaMrXnoRkIRZkIRZkIRZkIRbXnoSSaMpkIRaSaMqSaMrXnoRkIRbXnoRkIRZkIRZkIRbXnoSSaMpkIRZkIRbXnoTXnoSSaMqSaMpkIRbXnoSSaMrTm4i9ip6bb8Gfcr10UKhkIRbXnoTQln2eYE1yMSTBh2+6f2mzd2KWWEaPUD+lZ1SBQDJ6OCtrKR3JjnaISDjShXXEQ027GjRKREK9IjnEc1u/aVIpLzOsb1t/9kXLAAAAHXRSTlMAQAAwcK/fAIAQgL/vUDDvEI+/j2BAYL8AIM/vEHY7kZIAAAJrSURBVHja7dbbUuJAEIBhXIVkRQUUUVgH0O6cSTh43N33f6/NYkzPOD0zSZXe8d+lKnzVTTEknU8dYdXtexcn3R7s63VPLjzPw6qjW7XOp2tfhoanPVDqnQ6xyndAN1gFfL+w6sYBoQMC/MgOnTeHzm3Q8aA5NDjWIM7BiHciZCSCyKG2abZWkXWWbhENUodzqDSqR0mRIomB7siRiqEqRqbBHQP5yAZVyOYTxA0UJzYoiZmRCPIlZwNQZGmAZTlU5VgWpFkBsJEknyAaiJz3Mgx2ULcLV9U3TxKNRBPpDqSIK1DTJW01cpTf3tokuaCwduAvlgUmKbRCCTGwxn3BCgxUYoFC6b76NOSkK4UWKKPDGUunrmChzAIV9U0ByiUcVTihIt/qZ261aQPRYWBKV5EqtYaoIAlXReSGEhekHuXk+6GwHRR+P1S0g4rvh6AdBCx0hXilQC9/yl7wI7om6P9nCJJqC3lSHfmiwWoHiHvKv/0ue0OluBGUOyB6/g7t0A6d7RpBELicAFyr0W7WwoZQJI/0+PRc9vQoDxS5oMv60Ue9Pu97ZQa6NEIjqIptUAxVIyM0AVrOtBotBhMjNKQ3iAC51NeToRHyurzEO13PDE2AfYug4gjqJjpE9YAKA22cEKieZ4MmIBXlgcLkEUhNjBCNROl/HTSQHbpuCl3zEDVqBo08OzTuCyUZEkr98Q+ljnwxnQnhgqjZ1ARNz0QbSJxNDdBMaM3JmQutGQ+Nhd6CoIXQG7NQX+gt5/VAS6HXZyHBdT+vnHvBxUE/BdtyMS+ZxVK0gdrHrvbl0MODMER3HKADpED/AO+tMUBCljwvAAAAAElFTkSuQmCC"

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABSlBMVEVkIRaSaMpndX+aqrRkIRZndX9kIRZkIRaaqrR8XlxndX9kIRZndX9ndX9kIRZndX+SaMpndX9ndX9ndX9ndX9kIRZkIRaaqrRkIRZndX9kIRZndX9kIRZndX9ndX9ndX9kIRaaqrRkIRaBkJpndX9kIRZkIRZ0gowAAACOjZKBkJqSoqx/jZd9jJZ8XlxkIRZzgYu9ip6bb8HTm4hqKi2JW6h1PFqfcr10UKiHVp2SaMqPZL9kIRbQln3XnoRyMSRndX+aqrQ0Njh6OCueYE2PUD+lZ1TBh28pLzNrKR2sb1vGTFKQoKp0gozShXWXoarCO0iBkJrJjnbQfXDEc1u6f2m9IjmWdGaTmaCBQDKHlqCzd2K/Kz5uOzRrMiq7GjR4VFHAM0NyQz7Vln99jJbUjnq/aVJqeIKWWEZ6iZOGd3mKmaOISDiXp7E3zt4uAAAAMXRSTlMAAAAAEJ/v3xAAQJ+P3zDPvxBgUICAr89w72AwUCBwv0BgzwCvII8AAN+fz88Aj7/PjogkPQAAA21JREFUeNqt2Odf2kAYwPEYQ4KMWEAQUQti1W4L1GrpZTHde2v3Xv//214u40nCedaE37t78/3cShjcQ0guFiREkgpFmQuZkCcIJOWFuwHFgojoiQEql9b1dI6nxyFW4gwHZXVSlgExSrrOtG43HQpCVWd5ZQcqMyC2BBOamIApUSG2RKAUFtI8nza5kBBadFaW4nnTK4eFkHl2Og4ffU7H8W6ZbKocy/qgDQYkChaU4PmEF5qN6aTxjAfqIEZ5LkOB7k/pdjGA2gp7ShQopkMAddVN9pSCUHycCFMpciNmXehKVbsMSApudvwFcR7g3fHNSFNxbYYke45/Z2kp/pQ49zGZNeflQpsmpDCkoudCfnkWf/LdeX4zaXNiDtRWScrNqyt4HpHt+ORPMh93y3M2tHGo2vVuOjsJHtodY/Iv2R9yBcg94i1I66tuhxeIHrxGtg3j0tyXWcfRExb0Q1G9ndAp98V2aRjGgXUJM3hdzkPM9ZxlQf0uZYHOq/a3YUMpPovHRCSQSu2qqwWgCkeKY+MAQxB2AKKlnHS6F8AVLWdSxxmPwcHrAoidff6WY+i4udFxmykn+LtCSCCOYS5tfj6TmsLnFnMYgM5arTMVgjFAJeKQRinZUGt9vaVCMAZo2XGY0DoOGP8Y2T0yhgR9MI25KEtzOsfOKBtib7bTJ+ywIXbI7fnY2FhECD6WokBQISIElYYFifL/QcffcMd+p4+8SeGhHvIVfml/hgQpaEhQhwIJHCVFtbp+7+ujMyGNAlVpUke12j31Oqe7MKFBCN+CQQg5n45f98HZ/wxnT4OQWBqENEW1O9oi67veOlJhYVQIlxSCEGpjiZ7SRnTITKoEIJCoDh0iLQo+CL5FBOpriA0hacYLkTrKwHTgvILQHoyWZYCstJ7iY3oauhH65R0nFwCyo7w6qNDeOxgBFQJ6i4IlKyGgc3A8VUtc080LNX29foVuq8qEoJWXbEdcYEPQG7Y0w3mgBjiN5kAr7J8qXqgGUK05GGOfljkfVG+4E6pToHtFEdGTBAJBqw3bWW3SGhGSdEjmLAiq1xqYqdWbdGhkpCJRnBIHECuAcEKB8l9FCAhXpP+/cDu0tgYQSRYDNzEMRFqo+m5iCMhJACnPhYGgJNzECBBIkhAJAknmokAglbgoEEhJn/MPDDuoGia+JesAAAAASUVORK5CYII="

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAZlBMVEUAAADM1t3M1t2ZqrXM1t2ZqrXM1t3M1t3M1t3M1t3////dLkSAwfJVrO6ZqrVqtvCq1vf75ei/4Pn0+v7mYnP98vPfO1DV6vtgse/hSFvysbn3y9DqfIqVy/Tul6LK5frq9f3f7/wu+34nAAAACXRSTlMA31Dfn1CPQCDVwTRPAAABLElEQVR4Xu3XaW6DMBgG4Zgl1GYn+9r2/pcsUqVYsV4KnSLUH5kDPLI/YySvRooSY/tMEq3+UmbsI5NxZ22fWlMnsUHJHOvha8qsiMzJKMj83omsLMKT1vPmO+N7swPNBr39uxUtN2x+/PyDXP6KpHH1Y3E60alGmybF41A8CaomtAAEtrbQsPnx69yjyzYP6gEAeYpCkuKQpyB0+xQUgcqyOIRUe0WQphCkKQRpCkCaYlBf3c0ACYpBnoLQrRQUgdyHogjk3KY5htSx2QBoiALQAAUgTTHIUxzyVFdzKKirIXTfCYpA+V5RBMo1RaC+axtS7wWANHUoAKQpAAmKQZ7C0D5/bnuB0O6uKPRjUxSCNAWgb+okKHb7zyF1OgNIUwDyFIBeryMAvV5HXyK1XZniDA0yAAAAAElFTkSuQmCC"

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAtFBMVEUAAACZqrWZqrWZqrXdLkTdLkTdLkTM1t2ZqrXM1t2ZqrWZqrXdLkTdLkSZqrXdLkTdLkSZqrXh6O3h6O3dLkTdLkSZqrXdLkTdLkSZqrVmdX+/y9PdLkRmdX9mdX+ZqrVtfYfdLkS7bH3dLkSZqrWjs72ZqrXfdoXfhJJmdX9mdX9mdX/dLkSZqrVmdX/h6O3M1t3fl6Osu8SPoKumk6DG0djh3OJpeILeUWSjsr3J09vZNktfxgDrAAAALHRSTlMAEM9gIBDP758wMO+/74CPcEAQz4BAv2CvcGBAML9QUHDfYFAgcI/PzxCAj0SYX/wAAAHaSURBVHhe7ddZb+IwFIbhk2AggRBCy1JK970zdoDOuvz//zVNCfoUnbGNONZcIN7LKHlk5eKTTAfY1eWn1xDOeVmWnwM55WUgp7wK5Jz/f+foHB01uSDqJdN5JHLamdb69q5vjIlvJE5HV/35at778kPqQBI6kG5kDqQ4kjmQ5jIH0lTmQEpEDqR+T+RAupM56FbooAuqKwqRoye1o7RWAgdfn2l9JnGy2pngdHs5nXYNfbzUkTvjjTu2OyfPuzhqsIEGyuqcrndwKMMvsznL7z/9jgKubM4SktWhGaCZzYFkd2gMaGxxIHEHTQDdN4jrJBnBgWRxqD3YOoPG89y89wgHUtNBxRYqCFFkPvq2tEhw0HDjDBv8yHgkOEgNs2yoqJlxSXD85U4Jjr/ELnGnKPaS4DiW0S+tX+Dstozp2z+l0xMIOy1j2l1BsjpYRoez4hJ3sIx2h0vc4cvIHSYxx7mMrbwFpyExx7WMUWyMiReVwyXmOJZxbqp+/V4hSI8AvMs4NS5pBMC3jE+GS900qaEEgG8ZH/pM6qZECYN8y0g9SHC20jUA5zJyqXKwTzkA5zJyCQ5RNIrInUuCg/aSFgBkUkyhpFYoKadAUovCSDEF6OGpukMfSn8By2EHpyQTtTgAAAAASUVORK5CYII="

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAWlBMVEUAAAD9y1i7GjS7GjT9y1j9y1j9y1i7GjT9y1j9y1i7GjT9y1i7GjS7GjS7GjS7GjT9y1j9y1j2uVTIPTv9y1i7GjS/JTbUXEL1tVTxqlH5wFbHOzvkiUvgfkgjqw5nAAAAFHRSTlMAn58QIBDvYM9QIGDvj1DPgI+fn3VdyXQAAAFBSURBVHjardQLTsMwEIThsZ1Hk7RJgTVv7n9NJIS0gLyl08x/gE+7trT4Wb+kg311SEuPW+uS/Sp1exmnetBNgzUaJpDdWdAZVMnCEjmPRJrMJFI3mEZKZhKpM9NIyTRSb6aRFhNJyUTSwUSSmUgylWQqyVSSqSQju9/3/d5TRrtEOrUG0sI6kdSTTiwlzomljnRiKXFOLPUD58TSZFf04UYsne3f3l24JCXS4SV3BJI7hEQ4hOSOQHJnh+SOQHp5rALJnYudWhLheGtT4p16LC2JduLz5M7VzU2JdeIr7s7VlUh65pw6oi29vlWujHYPlWxDUGYlqCSoJKgkqCSoJIikDSIpQySNEEkFGikDGmmGRsqARDoWaKQVkEgnQCJlUJ12zuOtx+Y7r6ArubFWwS3N+Q8z49bKmLfvu5HHAnifZe7snjU6VdsAAAAASUVORK5CYII="

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAADnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnD6X8l+AAAAEnRSTlMAEFCAYEAAz/+/cCCf7zDfj6/Ysm40AAAB3klEQVR4Ae3XbbajIAyA4Qv5IBEQ3P9mx96ZehpLLc2Zn30W8FosUfmZ8fUVIuyQeOyHpwRMcqdL9oZyqWIkDJ4QVHlSy/ppKCcZU/wotFR5qUF+H8pEnKk3uZYgvg6ty9ZkXovDUIAmn+qD0FLFYTmHwiYu9RQKSZzIhPwdARPaxPL+IhC3xA8hEn8nPIRCFZ9a7IbcXJFtWU+zFmcvr012VbUD5efpD22us7IRIqhCfgh1T4eK/IVHaHV0VpXDeg8lmZAy84tdB/9CMPusOASVR9semlyY0tV0629orTLQzBWJhx0TGs58RQ60QFfdAIhPjnWZpcHEfrGKnMEeGs2YBr7Qx4/aKGd14Ssoz2gPgZyUzFe6DPBzSIlPJt4Oegvh+G8ei1VGFjY3u/bMl0hlLN9C95u3Ie8I4Sbm8afWWOLfEFPXgoGZcZNDK7jyIS+bvIb23R+bnFTtsOta5UplE0LxAhPK4lWDCYF4If+fkLINofjUfApx8y/MhqJ4FH4KcXF0Eg9CIX3eCSbkLZmO49PPdEzIWSqXh5oukyryZYhjlRma+U2IQ5G3Gk6dIEnfZCDMHkVpk5cSfnQ4ztCGlZ6Z50LmOW1iqaCtvAlZRAi7SCsbEyGHb+gb+gPVL4FS1+Hy8AAAAABJRU5ErkJggg=="

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAzFBMVEUAAADM1t3M1t3M1t2zwMmdrbiZqrXb4+mdrbi9ydGZqrXh6O3h6O2zwMnh6O3h6O3h6O3h6O3b4+nnWnDmbIDjs77nY3isu8TmdYfjvMblhpe5vMatlqSjoKziX3TUboHPc4bAgpPAlKO7rLfOztbgZ3vKeIq2jJvdZHmepbHXcYTTt8LlYnfPx8/bkKDWqLTgeYvdiZnicYTRv8nkan7amKeZqrW0wcrh6O3koa/J09vM1t3kqrajsr3jxc7i1t3lj5/izdbh3+Wmtb9AJ/17AAAAE3RSTlMAYL8AIM/vzwBgv79gAM8AIO8AOTCAGgAAAfFJREFUeNrt0ttSwjAQgOHlfBIBC0U8oGhVlIOoEFqqVfD938l16rCGbZPOpBeOw3+XZOebpi3s2/d/O6i5BtUOGhg0Gs1D17DD5jfUbLnGtZoIldwUKh1BxU2lClSXaTjLKgixTMERAgRJJg5CJJk4CJFk4gh4I8nEeYMVSSbOCnySTBwf/BhpE3ie97qmjcDDgkjnc+UjFCm9f1hh7U7Iena4tr0Nc7poIBQldWxr2zE+1bpNazvgTghxqWP9zl4HtrTRYU4IMalnybXRkWXuIMSkjW1pOuYOQkx6tbT1yCGISW09dEIOQbvSqaXPJoegXenMShA5BMlScggdDpGUGCKHIFk6T+D0ySGISX09dEEOQUy61EMDcghi0pUeuva1EOZo73bjJ4K6tzrorpsE6mq/21AILgF3hBhoHkhESMAc7H6och4ExiTgDg6NFM548jOkgrYj03jokcZiIGlgFuc8SYMc2j12nqOdmTTKIX7ojKOcZ0ce5hA/epkrHD4OkQd0O+bEScC3SZrx9xwrQbyDTXe+u0IChYON5ttrveBSIQFz5JxF+DsvfEwlgdrBJk/j8QLfskaCLHf0cSkLGXJMpAzkCnpHLxXKUM4XQ8dEKubrUK/nC+gYSYV8HSEskzVxspkcBrkU2kN76M9BX/dotZfGttoAAAAAAElFTkSuQmCC"

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAflBMVEUAAABdreyMyveaqrRdreyMyveaqrRdreyMyveaqrRdreyMyveaqrSaqrRdreyMyveaqrRdreyMyveaqrRdreyMyveaqrRdreyMyveaqrRdreyMyveaqrSaqrRdreyMyveaqrSaqrRdreyMyveaqrRdreyMyveWqriZrLiaqrRRZ3OzAAAAJXRSTlMAEBAQICAgMDAwQEBAUGBgYHBwgI+Pj5+fn6+vr7/Pz8/f7+/v8rUR7QAAAb5JREFUWMPFl9tWgzAQRdOi6S0oLZoShZZCiOb/f9AHZRVskpnRcXleSXdnzlwIQoRUuZmGmY4CrYNLgYY9lrNzadCwxXHuewjU3WE4y7ODQMNpgQBVDgZhDD84DAg2fOdwIMjwW6NjoLThAaNjIMDwY/A3QXqVzm2PBR0gt7cdBtTv4PqvTjDovMa09uIFAr0ukVP7lAY94/fIQxcH9Y+CoFUXA/VrQdLiFAadl4KqYwhUkTFCmjd/o3cjqZyN9UHZDTGeCMd7S4vJ+KgMCWTjIEsC+YT+B8SVWp4C5XiO9klphtqTOgDkIEnzvFqdK6VUrltqdvnUVz2ZB6mnFQAdnw5Znc2fZTVh5K5nbXH7tLj+TZ3mKGBfTLaLSoIaaO9cSQ0uoCJ2pECFZBAO1JhmGuO2WfxMZuHpVah+03Bu5Xgk2SRyPFWCNWvTPdKCdbvgJmnM7QIu2Bw5jiBIIdsfdPG3IHJE8q9T4zObrfxsDck2ImxDi1ojErFG+BYb26plW/58ryO2FyTfK5vtEsF3reG7aPFd/fguo3zXYyFkHePU1C821YQwjRJ0KfMtQWt+gvlklc3XHr80ZZryARDqIUfFaL+UAAAAAElFTkSuQmCC"

/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA3lBMVEUAAACMyvdCicGMyve93fS93fSMyveMyvddrey93fRdrexdrexdreyMyvddreyMyvdCicFdrexdreyMyve93fRCicG93fRwufC93fRdrexCicFSn9u93fRCicG93fRdrey93fRdrey93fRdrexCicG93fRCicFdrey93fRgr+2GxvZaqedHkMlKlM5ToNxEi8RMl9GJyPZYpuSMyvdQm9d9wfRjse1ptO9WpOFFjsZRndlOmdRVot9vuPB1vPJstu96v/NCicGe0faPy/eDxfVyuvFmsu5bq+mu1/V3vfIJC0YYAAAAJ3RSTlMAMDDPzxBggGDvgBDvn5/v70DPEEBgIJ9gMICfMBDf36+vgCDPn5/tG2gXAAACBElEQVR4Xu2V124UQRQF216zyxoPYJNz5vbGHJzJ6f9/CGFZM6Ou23Mk3kCuD7jSUVWrwz/PFe9ixc+FwweruBmyPIw1PnuHPlqN6yHD026s8cU7NLMae4+Cy7XnMVkmttmLG8HjZcQysc1eBYfXMWKZ2Ga2G8DdGLFMbjPbDwn3u5HL9Dbbe5Mc2oneMr3NDlAilolt6BIlchm3oUuUiGX+NnSJErnM34YuUSKW+dvQJUrkMm4DuygRy/xtYJ8lcpm/DV3uRHeZ3IYuWwvSs0Z+fCJvwx3n0pk1MnbuPAth6xYOfbVGhrhze/uPti1uW1sDAw7bDhe0ceiXNXCCO/fCJZ30UN8aOErvPA4lBZvLcpreeR8qEMHKsowgvgYj6OUjovgKRvDNMhxTfHLJS0lHhDuI4Lu5zCGedPjEyZTiSYEnTiYQ79GSL3cM8QARrEREEM8I8i93APGEEZwbWEI8YQT93HuleBHBxhIOlXhG4Kc09cXLCGa95L1OfPE6gjNEpMUzAr7cIcTLS25KA4jXtL1P4CQrXkfQR0QQryjwCZy64jWt9OWOhHgRQa+MSIgXEVSfwLEQLyKoUhoK8SKC8hOYC/EigurlToV4QVF+AhMhXtG6fLljKV5HcJHSSIvXEazNBhBPdATnZkstXtPumx1BPNF0NocQ/3c8eBL+T674Dcwq3ZfMdnBzAAAAAElFTkSuQmCC"

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABhlBMVEUAAADyq7rZnoLZnoLyq7ryq7q/aVLyq7rZnoLyq7rZnoLZnoLZnoLZnoLZnoLZnoLyq7q/aVK/aVIpLzMpLzMpLzMpLzO/aVLZnoK/aVK/aVIpLzM9O0Hyq7opLzMpLzO/aVLyq7opLzMpLzO/aVLZnoK/aVLyq7ryq7ryq7ryq7ryq7q/aVIpLzPyq7ryq7pKREK4iXNrWVGObXfPinDfkpPAjJiXdGSzaluadX9bTlWHU0bRjXNrSEGie2lPPjtFOjl6OCrSlntkIRbDkHimZ1OBQDGtb1prKR10TEOQUD+XZFSfYEzIinHWl3wyMzV9UERhRT+2ZVCsYk7Dh26/aVIpLzPyq7rlm6Dvp7TZnoLJdWbFcV/VhoDSgnmzhJDTkXbKgGfCcFjso63lo7LOl32tgm52YFY/PT3Ec1vUlHnJfWTCbVnMlKFCP0Ton6c2NztPRkzZiobOh23MhGrHemHBbFXPfnOMbV/ZnKmBZ1tgUkw0NjinfYfXm39oVl3Memx0XmZy4aS3AAAAMHRSTlMAYK/vn0AAIN+/MM8Qj1CAEEBggBBAYIAAUI/Pn8+PUCDf3yDfcBDvAIBQj88AMK9aqY82AAADEUlEQVR42u3W+1MSURTA8UUUUUnxbdmLCqGXj6KsxApuPiLDHu6uHrXCwgDLHiCZItZ/3nVhPXtXbgfI6Zf6zjhzZlY+c+/dXVSR5BgJ6LoeaGwKGjU3+nReiyMoSwlWaviMbtbiDQa9V3UzXxMBiU5AxwLDXs5iDhISHcxnONiVqiH8YMUC3iohh050uUpohIJ8VUIBnaq5Okgna/oL0FBnV79RV+dQNVBPb1+3UV9vz3Ujhf+cPHVNtbREQqcHNUuDZ88dQOf7L6lii5TzXbN3ofuioh5plYL2tApVgFYoaJ+AxL3RO6OhH7+HfpKQuCR6QTS0TJwQBWFf5c5rjYDEPkk39rk2aEX2eH/RSEhseYm4YwSEvaIdGkKJdkQom9vKH5G+LUmd7Z3dQkWoCABvEmv2c3prZd5ZHqAkAKy/Tx2B0lAqsyGu68MiOh838UOjUGrsRkGEsmBWzIrLWjW3d1OztA1mye2UBVoDayGBWrml825vWp0UWBtPHUIZEMsJG7xzd++eJjQGYjuFEhQCe8UtFZvQbI2DveQuh9CxFsZFTcod7H5BQUeyqAe0w0sqICtXhh5amcI6SJJDECptT3DGoA4IMnkbNModOURJFicJBCSXEBIdGopEhClkQOjYrsuhKGPitGHe/sIjOIixKABOUmiKTYtTca0Mle/7NJsCnKTQzCybsU3hx4azY/4Gm53BSQJFGGMxceI9MV74w4OO8UsRnCRQZE6YjJ7aXow5fhEnC0QV5+/IfByoaCj8TNOeh48BSrzQtInEMUBpdXL+ZbpOKMJiUfOIVCM3PrMxFqkBYjHxa8kPeP9pCFswX5VivgR5nFCOsQWoGcLvSVcHARFbK+ZNyOOsY2sIbakm5Gr/kzPKqgi5TtR/RhkVIV5bvWeUyYuQp62OM4pFTQchLtX6QOL5WCE8p0pQkfiTjZBRuxMq5lTyOaSQwf9sECrl6UAKmQ6Poqr5RByE4glkEELK7wYht98zMMAhXjoRjpeRcCItEghhrf4Gdxlp8LcO8MoQnYvqP/RPQ78Agg8OFLWNJ9QAAAAASUVORK5CYII="

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAE8klEQVR4Ae3a3WscVRjH8fkT9soLQdiKoLVKY5La2GoaU6khTXANiZiqZJVo2lTpUNMqLTFbsZj0JatSNxdLsxZRelFYUBBU4ppSi290q8V6OZdezp9wfH5wggObZzL77Jk5A87FF4bJbsh8OC+bmXWmt93jUnXKoxSTp1/jUl2UE6V/DrlFqk75lArkUzVqgHKY8vo1XvC9uob+3U47bd/Z00W5VJ3yKMXk6de4DgAEAaxE5RiYLqpJqQg1qFzgQnBcjvhebwtkoOSoUjgInwYS5wehAjh6xETO1+/LhcLyFUNgfAmMHIiHKgRxBHkSnECFAE6Bh7EBpLs7Nq1xrORTGDU1OUiMQJ8+3mcHJtDygXF+1NgG+mFo3DpQc+KwSi2Q98KsdSD0dO/eVAKlAgdN7hnMgDKg+ICyNWhX9+50At0cOZTtYmFd3vOUdaDPhic3vcjhZwbtA809tM060PSTBza9yGvvu2p28nmbQPanGTe9eukT/t+rHyDRSHJO9e0wBnR256PWgNx9w5teIEbOBtDvKwttIzm3K/OqXNiX/lEkXJy/WToBnCBSW9PN2XjjFzPj6uj2+zoGmn/kwdSsPRMHn9UwrZ1/61VMv+hA6Jflk+rMQHfHSF/2708M59roK1uPHqb1j04BMSJQoO8WjnQMdeu5qSSmFvvBsDTzMgfTEnY5DsoJFf7wGNYnydTDth/7p+vR3f3hC3ObYcThvZh6PBDT1++8poB1/LEH2lmPgGRt1+qkK6eP4neFA3Fh58M0XC2OAg3TEXDm7jQKcKbGRjBV5ChMGsh8ciTZyDF/DQkCoYs93SamW5EwvFQCVebewOKFcBwBiP2M5AmfWBT0I526BKiydF7tmq0gHBsHCq7sOBYBIf1wsNEGTpPKB555uRIgwDw8s4JwbByo5Q+SAgWewLoRHjKWNnu+LgACTLD0AyE9MmrM8/p8yPN2zwKQaIrJgVqhyhG+8cFOM8tTjF+k5UDy9BcTfPuLNJ9VII1UsrjNWwCSjyKM6gyIQSpkQFsjlbMptjVSM1agG2+/pBpHxoLhnPSX4j5S0kC53yrveaK/l7/+2IBwfzsMKBcDEq6jHBuQ6RaH+mwAFdK/BumbaRpCPsXkSH7qgXCX0SJQOdVAGD249WoRKG96FDkJj54G5cSMVDIK9P29vSpqP/bsl2ztwcqUkwBSM/KOFV50oLX7n1B/nj0hnlq6ohkE+VS7c+m0Wn9zwizQ9b1D6q/KAovDfENEsMUbRerikO5Wz6ifTk5FA7o5Qgc7+ltQcA4/uz3vtsLIcOrmIeRI6I+P31U/z7+urrsvtsDgHH7mdPLvBD+tLE0vfro1k9rFMGr43YrPSxSG3938uIAAg/+xmFEjHz0WRlMZUKaBBCjM6ElJaQIayIAsfDBMHdAnh3+V1qCKlGOywaX1ItWglKSLlz63BMTXpPIGYPJUk1KddqN6IVVAyAdShzg+pUw0s/yVGaA71UVTQKgpBeJHjryrK/xz+lqlGg1o7dyqSSBUFK45ynQTF75Vty4vtlwzzh08t6acKKOnemzdNFBDACRYkOULNs7hZw4AwnBqx9fM4ugEQEqQaMHG8cZ5B6MDUygIhWOc0yMn3UDmF2wc/wcUI4A9IPmCjXCcAXELNooVaK5wFSUOpL89ZgLq/wGUAWVAGVAGlAFlQBnQv7IvNg+/6MxRAAAAAElFTkSuQmCC"

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAt1BMVEUAAADdLkT0q7rqWW68vsDdLkTxm6vqWW7qWW7qWW7qWW7qWW7dLkTqWW70q7rdLkTdLkTqWW7dLkTdLkS8vsDdLkTdLkTdLkTdLkTdLkTqWW68vsDdLkTPbXrqWW7qWW7qWW7qWW7qWW7rfI7IgIZ4MihmIRPnZXjrorB1IxmwKTKiKCzWLUHgPlPujJ3jTWLxm6vpbX/qWW7dLkS8vsD0q7q+tbjPbXrmXXDeNkvwlKThRVrzo7PFnpcMAAAAI3RSTlMAgAAQEEAAMJ/vYFDfz4CPIAAQzwAw72Cfv4+AAADfQL8ggKWbvP0AAAJeSURBVHja7ZUNU+IwEEBTex7UEzX1BBSPWpF6fmtCFJT//7uu7MRsaBK2UMdxbnwzzMBkedN9fJTRDCaTwW8SRk78mJR8BRHyIaLBxDAgRNRaSB1RnGVc08pibvCIQvOsfMRtIUSyw0t+DcunbVR5V/POs9LTEcA55zsC6MTcorqWbx5EJ0LTyoWmvUrkmwdRYl62hSZZJfLNg0h4WCUSHj5WlAgHejUEV2sLGzq2bx5EuXDIl0TPz0si/zzj5vNHTrjNi5Qvf2y884zjN7LE/T6mh7LkMD1F3Hkt4nmyVM5e7Kgrge6RZXLntYi3rJOkxZGeNPQsU2UeRTzvmOvMOdKXFn3LVJlHEY/PBHAWV/PI2evrTFZD2fMoAs7hF+3meZsrNX9zQ+G8Fhmy4TBz80wVMHVD4TyKPOxLYKQ0IwnsnwZgoQOdRxl0qPVFOo+6GBfF+EJBqE1EkZSXauEpgIVJXUoZkSIXBYwLYKyArSAsfKQW/C00X0ak/mfR1bWU11eNRfObW1lyezNvJhrdSc3dqIHo/kFaPNxvKHqcvhvefdPHn0FY6CCNZmYns+EsStf9rfV29Vuf5tD8SWt3e2uJto/NMkpjFj3eri066GNeBNP3D2qJ0qiLcWwwVdeTihFxECIVI+IgRCpGxEGIVKxGnFqpGB2nXipGxqFT2aIoFIdOFdmiNByHTpXaonAcOlVltUAcOhWuBqT+q8F7fwjnj015wXt/QxHe+xuK8Ja9rgiruCI8o0VuFRQ5Z4QIq7giPKNFuIwrwrNPFakVIvUt+hatFu1tJtrb0vwDdf6LQM7AoKgAAAAASUVORK5CYII="

/***/ }),
/* 970 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAaVBMVEUAAAD9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1jnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnCd3ReAAAAAI3RSTlMAEHC/798wAI/Pn1D/QK9ggCAQYJ/P/++/gDAAIN+PQHCvULiDHKwAAAJLSURBVHgBrNLBroNACIVhGJAzKtNp3/9lb6HEtWPutzBhwR8l0j/jJroZVnXdjxOJ4sHdw4ZF47d2Vgi2+fNQeHGGppeJVeI/O4Oqo2/DA3xKlci0Xu6pkQGhLDYk6+I6cQOL66sxAu+RIL06c/OguKHuenyuEvXvGJPFtBAqb45ddSVYXrl5uf1pZbcYBxPS4UnmB3dZr1MYAlUnyMCaph7qz65Onfyv9zrOcRMGoji86m4r9Z82jM0z9oths/c/ZIFNRghNKvBs+zvAp/E4WIqE2GMpDblwV8lDwlIfg3Cue9WZXh77eVvGuUZsq4GbQsW2eOXcOsNbt0I/HqqM2Fcn3puU0UZ5SK8rtO5sdkqFUeZahlEtD+nbDF3u32tJMIucizBLi/RzOdB8/cvmf80OnhXVsaVuES6fUKfzmJI6tnT5hH6vB+vRWE/O39r37v7LzmhMb+OFS5LQXJINlOEob6AKR1UhFrgqCr3D1btCN7i6KTTA1aBQhauqEJx9/UT+HX31rWW4ygpNcDUpJHAlCrGHo/5fPCMFjq4biL3zZAoFNBcU8j3aSRTyrTtTIddISRTyjZS5h1hbX5A9NKGhyYAYcbpIC5KKk1UxIU7tB1Oo6eYybejs4z3wOSQ9DteLAWkl4WCp0IZUanMU0sLxx8OGtNDkGBBDi2NBDAl/LQUeg1jS8T3bkEoVT6uFxyHKgCcNwkOQNsJsJE9C/EjGej54HqLcsOsmbIG2Q+k4bRBlhDYKGyDtGrf/qZsgpcaURmUckPafoD9mI5xEvmSaMgAAAABJRU5ErkJggg=="

/***/ }),
/* 971 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAADnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnD6X8l+AAAAEXRSTlMAMEAAIHC/79+vYM8Qj4CfUB/Wk8oAAAIYSURBVHhe5ZZRj6UgDEaBDyliRfv//+wmDtnRrVIv87SZ83qTgz2Q5rpfhQ/Bo8P97w5n4pRIDvI8RSjiNGc5oDTFR1FZ5EIKuBCSXFjKrShkUaTTDD6JIgcl4lVuqWhUuWXlq4gXuYf40HCSBxY+izzJA9PzOQ3y3yLOj+fhYJMOmf+Kns/7ihmky9JEqPLEBuiDNPVLFEX6pSexiIcoiVGaxCIBDl7M0jYeDttIaR3TgezSNgQXRkprgqsjpTXVzSOlNbNLI6U1yS0jpTWL635QJHmLo54I/q2JnhrNUBvPaJT6zxE8vxRVeWBmfPACqtvF2sYoYrO7aG5jYLeTRwfqmHa8vDyC6ycoLy9vg1MFhi6vwIGVYODyGA5oZ5mXN3dOAxywWyE9rE2wHyJky8SGKOMQmQ9utSKVJmL62QcRmshY8Dv6fzSkNJFRacbB2i3URNh/UFr2kwhpfLCEsyjS6GAULyJMo4NNuIqQxge7ipiGBmMlQhgZLECLUD8frOJOhE0PBvO/qhbpfRoPjzc2lRLpIXAwmx4tgif9RcXYd0rUTLpRMjxKpE1BR9IeLdKmjIPV8CiRNlX96LVHi/QrINVb3VdHBE793olhihpbr/cGvBah0FNvKvhEBL/c9148PhOB17veK8MSaUL+t3cOwIAIvF57V8aYCIjpu3eJwLAICKn1tnCwCBvFIZGGeVCk+S9FfwD2KNp3qtMElgAAAABJRU5ErkJggg=="

/***/ }),
/* 972 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAADnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnD6X8l+AAAAEnRSTlMAQAAgEIDf/49gv++fcDCvz1ATjLsUAAAB10lEQVR4AcXX4W7jIBCF0XBnzGDAhLz/y260cqSQegq3q2q/n1Z0AuNppN7+UyHgPQmKsxuWky3as5gEf9uzPSs1kNBR7NUGoEV7lZWBqr1Vsdtbsa1DyYbuNtR1FQr2fWkVyjZJ1iCxWcca9JhCeQ3aplAnIb9/gvirhSl0X4N0Cm1rEPoMaj5EDSliEZLZzVYh1G+dosuQTA7kQ8yUohKQdh8KICA010mgIOyO00FCSNeOfoEkPMNnGp6puwNFMEKhlvMbkrwNpsbzxSS5lErDAIVsb1U9meHpXb5KXTBAycZKAIDj8+n+OfGsGKCLu+/e0xCHhR6gahc9ktmlpK+Px4AROuyqYpe110DLBoyQFHPyty/cD8UnVI1qx3U3LRzUPWg3MnGgykK7A2UW2hwostDdgYwtO1BnofrbM0os9PjtPRLSiXAgRHrWDpToETmQ0DdzIGT65TtQIJyiPgRk+kAOFOgDORAS/VvkQFq4P3wHWr5ckSmERO+iA6HPnYQVSCM7IAdCmwy86xxakaJiDZq8utIwhxbO1BsYyJW6goPQ+pWTFSwEzcT+OJDzz0t54GcQQhyuJfgpBN3sVTkADhqTc1JJwUNjoVpJAjCQk8KJhdj+AIR5WfOn3F0wAAAAAElFTkSuQmCC"

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAn1BMVEUAAADnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnD9y1j9y1jsdGr9y1j9y1jsdGr9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1jtemn9y1j9y1j9y1jnWnD9y1j8xFrqaG3oYW/1oWHufWn5tl3tdmryk2T6vVvzmmP2qGDrb2z4r17xi2bvhGfG/SC5AAAAJHRSTlMAMEAAIHC/769gz1DfEI+An88Az3AQAK9Qn98gv2CAQN/vjzDHO8DQAAAClUlEQVR4XuXY2XLiOhCAYdkykjcF4klmcmBOMkvLC2u293+2MRJOoygW1YSbqfmvqFLVV3Z7QcD+qaI4jnigj9cZPy6ZCAkmmU4SBHA9HdYFrntQloOTKFymEOCUZx9CcQleIkYmFuBVxh6kruDDrgZnbF25kDJn1Wx1917KFa5j7jpCkR1hp7Ve+pLjeMkIIWXH0+q+R/Alx/Eq1RuUW/tV72s9KU0hWD5AU7A9G+gFyE0tlICt0aYV0EsMJAzztKv1QXppqZDYQxEAtC8rfdzjkihFPTTrnVq/r6NBsx6SAGvtR4MkZ7EZs9cWaMXMXPvlSrt1DRGastSKzWarh55fW6CWMgFDS8vUDZyRYDmq9ph2cE45A2xjoCc4KyYRavAJISeZAGyFzyw1YSEcd92eC00Bg2aNDq0pK+AiFSy5DJQwLi/hSPMaCUR5jWSXgLIeUpeAVA/x9PNOyvdQ8XmoMBAvaYC/Syi5gajj9ncJ2QFSkmL4uwTJDxCfUBB/lzAZINKU/F1CyREqCIi3SyiOIC5I0EZrfCsLfgwlpHlvtW0HADJBiDrv9fHX8YQjRDu5Zaff2u6+fD3Ehg8nbybcRTld39xW+1g1FIcJ3EV5fbtzoGp6yqn1WP85UDU7NePxXEjlQagZd+YWQqkMSsvV2JktLIRFEoLhLgr7/v8tXjVHCrfuao3N7xcGMBBRgnajhx6MgRBVqvGqOxBZ6rTtLgDhXRDoh3V+VmGoUiLsCDU30K8gdPoen3F+b6DfHuSXjQ5KZpzzhXnuKx/yi0YGlUd833UP3YQgTF2Ffp3f9aO+DUNYXAb+L1g8oINQ6KDcwxmP8VCJQEYknJMhLBb4LwkN8qkZwAwZOoQpnA0N8vsroT+RNxP7tP2KaAAAAABJRU5ErkJggg=="

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAk1BMVEUAAADyq7ryq7ryq7ryq7ryq7ryq7ryq7ryq7ryq7ryq7ryq7ryq7ryq7ryq7ryq7ryq7rnWnDsfZDvl6jxprXxobHXQlq+HjjkVmzfTmXcSmHoX3XreIy7GjTyq7rpaX7BIjzwnKzoZHntg5XROlLqboPtiJrONk7iUmnGKkPvkqPujZ7ZRl3MMkvJLkfUPlbqc4fvV6MjAAAAEXRSTlMAMEAAIHC/769gz1DfEI+An1KbGu8AAAMmSURBVHhe5djXtuIgGAXgNEGjHCU99nZ6ff+nG48xm66Md7NmX4LrW+GnhBj8VwmjKIyvxN4fKA3JgND1OXQ4SABI/cO+n6DfhEbpWgkZq8yYqP3pyApFEwgIiQQTgRGZRAbEHtbWPPSOq5+pEEvXjqTMox9QSAFYJDjW0FBADOWxS3CsmTBA5u/KPC8hDYfWdiTtoamK7LINP2eTlQou2neqNO2gRGHyRy7lMb/WjiRniEhMkXEtWeeY7YUEkV8olJ0NN7Ip3O1IeIJmTgcSHKc0O0FUQHDUPKI8miQgGgcRGNTBO5mQomAKp1SAl+p4ylwA8+Mp1YsilYCmwRDQUmLmr6su9bH5VZpjfWl4lWy+BDQMCCotOc8rkW3LebuVGp4lCfUmAbbHu3A+V3Lqtq2Vhk8BvWObBJaRHVdq6ouDHC1jCzD7mON2dTMtVgbmX9TIPjDEMTjUyISalUcaE5rq0NwHmuvQNBj30B6lvh2Ue99D4yBBse+BUOxEbNrDPdABm1YcI28XqPKBqgv0Jh0jI22LtD5Qq22R0Qli+mlU33Zq/URiJyju9//T3y/Ip37vx7/QWDuPPm5DH9p5ND5D8UTbtttbzlbbspP4DKHcOebNc85ylLqDGMWa9HqkrbYaKd79A1TJa7vNtQoNAKFKmcfE4ajNUCFAmLhi0UHNlcFtm85ZFJgyAcVE2ydt7XLqVtsdJJahhGIJ3Ji5Spt6migQ6l1sIF11NgUqDUgd3G4B6Yqz2GFgOsQoygTJ6aBAlFku7HhTOqXKeC+aF3b5KnngmDvrfPGDfHkEJDIzXrrNl3C+GuP1OovtEEsNiVd1x9QVN5yU2SFc3HHI4UJTHxs4T6YDCAmpVHFQ399gUGd8OgjIIeULbskiNxxALqm0XYlL0wHklNbWyzscE3JL+V5m9rnmuCHjI7DIzG8GzJcbgkTWSPnTMT+laCNw3BDWuMhuyflyBwXr2QuKR1SiikJi6Cj2gZDQ8fWZhrEfhLAHx9e5N4REE8f/Bf4QHsrvcQC5kxDBkASAPyQSEfEvyZ0QqNOimoG5B0IYanMvhPyT0B/MgGVoyUxw6QAAAABJRU5ErkJggg=="

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABOFBMVEXnWnAqZ5ddrexCicHnWnDnWnDnWnCLkcPnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnAAAAAqZ5cqZ5cqZ5ddrewqZ5fnWnDnWnDnWnBdrewqZ5cqZ5cqZ5ddrexCicFdrexdrexdrewqZ5ddrexdrewqZ5ddrewqZ5dCicEqZ5dCicHnWnAqZ5cqZ5ddrexdrezFb49FjcUqZ5eLkcNdrexagrVdrexPhbs8gbddrexdrexMltAqZ5fnWnAqZ5ddrezlUmjePFTfP1bhRVzaL0fmV23eX3iihK5CicHbMkpuo91mqOTcNEzkT2bFb49hgLLgQlndOlGgX38zdKdNZZCzeZ80dKfSYHpaqefWZICaSWrlVWvdXXXhR17IY393ndW0UG2ZibbiSmEwcKJKk8zbW3KYRGXjTWPcsPnIAAAAPXRSTlMAAAAAEM/vAECfr7+AcCBgAGCA30Cf31AwEBDPIIDP37+f769gv1AwEK9gj3CPj89Az0CPMHDvz4BwIDBQJKFxVgAAAtxJREFUeF6t1oV+ozAAx/GwEQbFrr6u203ldttOXRJqczt31/d/g4MQSCVJU9jvAb6FP6EfwJVLKhO0sRQEi2tTA4GpiWusBqS1nFDjZhD3ICe0GiRt5IIWgrSFPFAluByosdgPbZZ2tCSgTVQ4EOs2xng3G7TR7/zGYSsiyDNdx6mbOuCk31ocdvAWF6pbBqJB1xtUPAeigxGn+bRSqTSGxvZraCCrj/KsEN8/GXbevifocqMPmk0ZlpM4DpEPeA5piUE+4gXJVjqM3WOOQ7uXQBbiZ8wCMJsMJ3aCxxRykChD1xMHiZ2gEkN1JA7CFBU7wRMCsd+UJ3DY2BZSS+gEFQJ5SDGhcyM+kJYqJHKW6ck2VCGxQ6A6Uk10XxRylCGuc3cmDszYqs5LjnNyboMkO4fz7QNikJHd+bGPkJFCmZ3jcxSVQjCbc/wGkSDbSNl5/QeNxjbazuWg7RTycznITSEzl4NMkJbLQYBVGAVanXb3bE/FKQAgG+m0F9X+OdZBPmDpo1CPdvp9jIN0IL23572kv9SR3ZnsuZ1120dUoo7kmbFqiFerQ6SPEqfGDOmZbJGr+iSGfDAUlEkdoQOZMO50d0PoaE9lIVpBAO31wv6pPDKaZwikdgh1+Y7hAU6uAPoSQi/4kAu42YK5Q6jNdWzAT/RJ0ukdtfgfTkCQiSaqDoQ5kzgOkGSpOxaQpUNVB4oGujOvRekwnzPXxLhIpPvvVJyawAFFjHE5cq4fXnwe7xizQFAVh21GzuHhxdex+wgdUI6gauhEPYRZ9iHNY9Ij4ly9psMMDp2I9Ct2pqenrYznp4rjXhEnyhU5LpBVxokUOSTT4DGGKXXmcVq5qNH0wqhTIPNIJ2KtrJco5Q5dlMFuSzoRK5G8guBy5BOx1rUk004Ym66jMBFrR2P5MGKgTwH1ifDKFtmbZVqWCZQqMWW9tKllLoGau8+0XEV/RuVqcU7LG9Auqf8QovTZTOEvMwAAAABJRU5ErkJggg=="

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAABdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrex1onOTAAAAEXRSTlMAMEAAIHC/769gz1DfEI+An1KbGu8AAAGcSURBVHhe5djRrqsgEIZR4MdBkVHn/V/2JG06iUHYhzI3O/u7ayZZaQE11f2pfAgenZ7n7vYpLpTkVVqXiKq4rJ856byGtiy3aMetneRW3h6hUKSKArRAUlVCBfEhjx0fpzXnO8RZGmX+j7lCPom0JXUeS14hcBHpSeo8VlihLN3WVbrlD3TKZOcbijJdfEE0DxHg4MUgD4fLArrgkCygBBfEpOBOG+h0qw20OrKByGUbKDsxyiUbJ5mtkRlkd452G2h30QaKVhet5W1ks4A2OLAFxHDAOu+sgAP2eWh/QSizTsEb2uaX+g1xmnOSPvuXOWhRCGVyhRTaJ7dMIdDUc18hIKZvnRQVwtR6L1Bo6scRbtDXhylxBSF8AwXUEM5x58QTNH6vvPAMcR5zMjcgcBl0WhD8wNYljwak0rij0LikTg2pNOgoNC6p04fAeWC/ehCY+g4xGlDV9fN57kPallpM2jACwTcWKnsMQO3/7wdjAGq+USgBGIfqL3UwBiEtkmgUgXFIC1S9JRmFlLpELmUmIIAZMIGAXwn9Ay+S8SMtfllMAAAAAElFTkSuQmCC"

/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAB4sVl4sVl4sVl4sVl4sVl4sVl4sVl4sVl4sVl4sVl4sVl4sVl4sVl4sVl4sVl4sVl4sVkltZ7HAAAAEXRSTlMAMEAAIHC/769gz1DfEI+An1KbGu8AAAGaSURBVHhe5djRjoMgEIZR4McBkanO+7/sJt3tZA1KQ5mbzX63JCftgBp1/yofgken63WH38WFkjxLeYloikt+rZOut9Ba5BRtOLWRnCrrJRSqNFGAFkiaamggfshlj5dzt85niIvcVPj9ukLwSaQjqXNV8gqBq0hPUueyygoV6ZazdCsvaJfJ9m8oynTxCdE8RICDF4M8HA4L6IBDsoASXBCTgtttoN1lGyg7soHIFRuoODHKJRsnmc3IDLI7R5sNtLloA0Wri9byNrJaQCsc2AJiOCDPOxlwwDYPbU8IddapeELz415/IE6zh+gHwjIHLQqhTk5IoW1uyxSaev4TfkPx43mnqBCm5r1Aoak/RzhBHx+mxA2E8AkU0ELYx50dV9D4vfLANcRlzCl8A4HroHMHwQ9sXfJooHFJnRZSadRRaFBSp4HGJXX6ELgM7FcPAlPfIcYbSDven+c+pK23g0orRiD4m0EVjzEI/Oi8nY9AQKid7wUDUPujHoxBSIskGkVgHNICNV9JRiGlDpFDmQkIYAZMIOBPQl8vkvEjP9NtAQAAAABJRU5ErkJggg=="

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAD9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1gjfEMpAAAAEXRSTlMAMEAAIHC/769gz1DfEI+An1KbGu8AAAGcSURBVHhe5djRyqQwDAXgtKemWpvRvv/LLswQRMyI0+Zm+c+dBD40RonSn0qIMeAmdp1OR2ni3N7J85SuRppmrbPWDWgp7RRez8zK53pZTCjWdglHHHW+1mu8QPJqZl7qfKvLGZLSvqTIk7pCIStgSerYyeGApCpgS+rYqaIQSrvNPN/Xi0JbG8z2gVIbTnpDPA4xQAjNIQGE3QPaQcgeUAbF5pJImw+00ewDzcQ+EFPxgQo1p1D2cbJbj9wgvzlafaCVkg+UvB5az9fI4gEtIIgHJCBgHndmgACHAVjfEOqoU/GBlvFWfyDJo0OkS8Q0Bk0KDXap4oDWsVt2QOB+h3FAQOrud04HNNTvCWcIPHRhCnUPUxZjYe+Brgt73yq5wYJ+X7l22JCU35wiNgRI7XAsCCE/d3KACanU6YDQI6ljQyp1OSD0SOrY0PMpKIInEITvHRbcQk9nfAceQ1i+Niov+AVCKLZTAp5Ct9/vL8FvkP1HoUagA4K8jNPpgYDEB8MJ6IaOPyIcgV5Iqb21XZkRCBABXCDgv4T+AS+S8SPTs9FuAAAAAElFTkSuQmCC"

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAACqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtb2aGAuAAAAEXRSTlMAMEAAIHC/769gz1DfEI+An1KbGu8AAAGbSURBVHhe5djRjoMgEIZR4MdBkany/i+7SZuJa0QJnbnZ7Hc7yUkLqFH3r/IheDzUnjv8Lk6U6rs0TxGX4jTLnGTegJZcT9GKUyud53lpQqHUSxRwzOk6L+EC8as2e4lzN+czxLnelLk/PyCfBGhJ4rRL/oC4CNCWxGlXWCDk+tg8P8+zQFtVtn2gWNXFN0R6iAAHXw3ycNgtoB0OyQJKcKGaFNxmA21utoFmRzYQuWwDZVeNcsnGSWZrZAbZnaPVBlpdtIGi1UVreRtZLKAFDmwBMRww650ZcMCqh9Y3hKJ1Cj7Qol/qD8RJe4g+EDDpoEkg5SoVCKTcuPWAVM9/wm8opm+dFA9Itd4TzhBI9ccE+vowJb5ACN9AAVcI27izoQWN3yt3tCHOY07mGwhchp02BD+wdcmjCYk07gjUkfqOQKOSOB1IpK7Th8B5YL+eIDA9O8ToQdLeOc99SFrSHZMWjEDwue1kjwHo/v39xRiD2l8USgD6UP9HvRijkBTpYCgCw9D1iwgFQAUBYa91F0YDAcyAEpL+JPQDL5LxI3O0ZkoAAAAASUVORK5CYII="

/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA2FBMVEXnWnD92Ij9y1jnWnD92IjnWnDnWnDnWnDnWnDnWnAAAADnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnD92Ij92Ij9y1j9y1j92Ij92Ij9y1j2roD92Ij92Ij92Ij92Ij92Ij9y1j9y1j9y1j9y1j9y1j9y1jnWnD92Ij914X91Xz91n/9zFv9zmTqaG390Gr9zV7yk2T5tl34r176vVv8xFrrb2zufWn4uYLtdmr2qGDzmmPxi2b1oWH91oL5t2Dyl3b91Hn90W3903b90nPtenbxkHjoYW8C1o8TAAAAJnRSTlMAAAAQn8+/70AwACCPn4Dfr3BgUECP70DvvxBgzyBQgBCvUJ/fcJPIlSQAAAJQSURBVHherdjncqMwFIZhyRgBi1tckmy2Nwn37vRsLfd/RxvXTxiQDyvev2fmGVkCjwb2oqBSoMD3A2YI8+zCM+GpTV7jLEybN/ZzgXmipqtiiVacaYn43G2mMn5dJRK+Nj8wqO4nGKeiUqvsnay5c+S4KiPXOT1HgQcgKcFJywvgONieVAlOWnWsyVXGGg3z3N07NWVZbeuEyrpwAwl7SKydQBXQ+uSqRUDVZ8g7BfwlQB5j5/LeyIzm8pEg+UxKOVtlO9dLKeekJ0Cue8j6VXdS0qDGFpLzUZpzu5BUSOwgubxOOvdSkiGXyX2PR6ezmskckAIkF7e684ABBfKY1Jrqh47Ie4Rmf26i526+LaUVNOlHu/qTnFCN6U43OtSd5INaOtSPtPqAvv4+3SsNGkexxgdoGBHSoF4c6uWCXmvQ8SwX1CkKelsQdMkLgjq8oM1+w4s5/pecmx5IOtQGZHpFhoQFccNLS4fagOL71MX+UKAOT0DDp+3o+yAHdPn+GBr8whaN6VCbHyAsB/UmROgdj0ODn1G87g8SVOZx6EM3StRbnPyH9HB/3DDnH0sAkJqegnwWgz5dldIhtZoZoRrToc8XpVIWpNaLujNcr9DFl6uSCVKj6Yhw6UepEDI4tpAXMDsIjh0Exw6CYwfBsYZwXvaQgGMFVQHYQF6TFQK5AaNC5bIBqjiMCpU5P0iE7wXJ4ECq0JeD4EDioQAjQkYKDqRn0hf4SkILDqSN6VeVqvqMHBxIO9RxWI7gQOI5YvsBHEj/BcGBlA+yq3joH/wbQCP72s3fAAAAAElFTkSuQmCC"

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAkFBMVEUAAADnWnDyq7rnWnDnWnDnWnDnWnDnWnDyq7rnWnDnWnDnWnDyq7ryq7ryq7rnWnDyq7rnWnDyq7ryq7ryq7rnWnDyq7ryq7rnWnDqcYXyq7ryq7rnWnDyq7ryq7rnWnDyq7rnWnDqcITpZnvnWnDyq7rtg5XoX3XxprXvl6jujZ7qboPxobHvkqPsfZDpaX6EheanAAAAJHRSTlMAQAAgEIDfj2C/759wMK/PQHAgUICvv+8wcI/fYM8QAJ9Qr99nISEiAAACxklEQVR42sXW25KiMBCAYXIgnERQEVlQWnfDzOz5/d9uGSZdGsyQhJv9L6mpb9INBQb/KULgMUY4qAJwjoVCjomIwdQ5kWNpRjyhXSqxEAAaIbGE+0CZfCiDs3xINO5QJLWOUqvgrhCRy0WuUCItMTeISVs7B6gsyy9WKPkc2h+qbX0apl6sUGGG8s1WEQhZCwxK2yFwh/xHiy/Dc9+t0FGH+uo0mHqzQqEGxcg89dcGNQ9Qrg91qasqLssyp2OhxRFwh6q7UbeHnGox22SAUL/Fg7QlNZQtOilHqP8Yq6v21ByzHEhB+bTlbUnN2bYk+DuE57nu6VK8+BwioKDRqXNqqVl4GSmoHU4bau/8iVOAgsqhy6lLkdnhCHWXXt0ZMgbzOBnj+AF4KmWgoPjDIVmq/kPE7kqTCXVjImaU0gYQmtZMEu1rwxWjXT2yZ6lggFBeGaZPpwl386tnAH3jCQcs2PTG5/8MYL5KhPZA36EcnVk3POVc4vjngsAjhBPMS6WxBgCmhaYhgA6xVDqHTx857jjMoUx6dQZjecBTP6gwQ4fgLD1jRugaaJOtnq0/BYkvFJqgtg6EL3Q0OOVQBdK3RCPwTZ0HhS+UmZyOrt6R/n2OaRD5Qjed6a/vnzFK1z5H+s+FcoSYpyM0phvea+kIUbF21/2mU195OkHRqhX18XZQXfoPiPlPlm+Ugs4E0cQH+hpXNRLoIEQ8nNe3QW/bU4S8jvSiKfipR4isPVC9pxrkfuN+PDJdTDGEXF+3P80MQs7Dvf66D3VAQIMch/uNd3yjdmOAaGF3/kwTXWNUzBAXNudb3VZlbyAQUjWWhRccFgsAW5YEB1cIyIKTNmCHHM5UoGOBbFLBwRVCqTA5CQdfCHhi/GHvA2HhfM03WAcBEdpYDNZCwMP7cXYAayCMJWo7HNZCGMlkGuFU6yAMD7MSWt8/ZK1MVqZTMaMAAAAASUVORK5CYII="

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAACqjtaqjtaqjtaqjtaqjtaqjtaqjtazm9vLvObZ0O3i3vHw8fj1+Pre1++9qd/Br+HGtuTs6/bn5PPUyurQw+ivldhgg9yCAAAACHRSTlMAYL//ACDP71kzCuAAAAF1SURBVHgBrMGBAcBQBESx4x7237i/M5DoF+mFDB5BtZe6QNR4bQrRPtAofCKUPpHyka8dO9ZtGIaBADrcQlOUaTm2//9TW7RD2uiEhISKLrn1gIfYDAOEb+h/IVm0WLWyLvJYrF+FLvIC5KXeU/x5wSEp9XeKPCk4tFl9jDUAaKTwMdQqSxsXA8grT2uVxzkkVnlsWAiFSg2nMMhrIk6gNQOtPSQ1FemgloNaB2kO0g4qOah00J6Dbh1Uk5n1ifbp72j+1JYctHSQ5yDvIFjGsT9a2vyyNQJlns3AoCMOHRSSOCQUgkYdBYfEYo7JAMIZg06MoGuPOPvFoMSeOMYQjsToKYRb+Dd2AIklJsYgbK9BG55BaIFlJVDsC64gUEJScCgqKTgUlRQcikqKCIQ2nlcMghtjzBGFIDeyF4I4BBxkT1MQfP/J7I4shOu8O+eFPASIfjMqQAwilJnK+8/xhMw7skw7+0w7RM07jU071n1mxvnwA05oj78aqY+EAAAAAElFTkSuQmCC"

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAV1BMVEUAAABVrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO47iMNVrO47iMO73fW73fW73fVNlMpVrO5Tqus9isY7iMODuN+jzey73fVKnNtDk9BNoeFLk8lFltNSqOlK8creAAAAEHRSTlMAIL8AMO8Qn1BgYAAQzwBwNjA0IAAAAaFJREFUeF692NmWwiAMBuCUaheXMUB35/2fc9KboUqKmQmn/63H76C0kASOS2EQTVF+CpQfcjoj5XxSQMGRSCBwRBIIHJEEAkckgcARSZB25BKkHbkEaUcuQdqRS5B25BKInSDJoYqchFSJoRqTqcWQSUPmeKhJQ40YKi8p5yLZtao2pomkyGmMqasIip6fy54UPoyfJ4idrWTHyXmKm0a7dWIJYidI9uk3edrgxBJETpBm51/i5uBEEkROkFr/lvZ6vZLDSsA6QVq6fqD03RIcVoIdB+f1a203/KZbnXbGHQl2HOtoAbf7sMn99tV6Z3ck4B1c9+tBzov0WPcOeQl4x3pKN7yl8xTLS8A6OJKzDFEWgkZkJWAdnMKC3pc0IStBWTAOOoL6GOoJcshIBUEGmXjKwMRTkIkhCP8KfXPSfyDkku2nZfuzc21/3gdS/4rkf2n1x0j+g01/1OoP//zXkf6C1F/ZmYsIfVmjL7SOLv2Or2r1BfvRLYS+qdG3WfrGT9+K6ptjfbt+/ABBP9LQD1n0Yx/9IOr40RhFPKzLlB+SdL+o4YK9LgAAAABJRU5ErkJggg=="

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAilBMVEUAAAD/2YOZqrX/2YPM1t3/2YP/2YP/2YPM1t3M1t3M1t2ZqrX/2YP/2YPM1t3M1t3M1t3/2YP/2YOfsLqZqrX/2YP/2YP/2YP/2YP/2YP/2YP/2YP5zV/yz3GZqrWfsLqmtb+zwMm5xs6/y9P52Y7y2Jrm2LDf17vZ18fM1t3/2YP/1G//zE3/zVAdae47AAAAHHRSTlMAIFCAv49wMAAQz9+fQO9gr+9gAAAA31DPEK+/ul3eugAAAdRJREFUeF681D2OxCAQhNFByHZiApCaAXODtn3/6+1PMiMB3dWj1X5ZJS+sx//knr79tqwbyT1oWl0Lv5UX9xHkdu5qwQ75yKP2aoNc4UkxWKAQeV7CocRiCwolVkoYtEXWeiJQzawWHQAdDNR0KDBUUqGCQVmDAoMlBTpQqMlQZTgnQgmHkgjtOLSLUMGhIkJsCIbO+z6FjUP3dV1v0vk974+hl3ReH0Pn9ZJeA4Z6qXMQKI6ksZNFqPFIGjncRMjzSBo57EVo406aOLyJEOVOmjiZZGjloXSaj63GTvqBOidWBSIvQ/j5U0agQjoUEGgDIFp0yBMC1axBjSCINgWKDoRokaGVUKhGCSoEQ5QkKBggynOokQXycyiZIDeFIpkgyjPoMEL7DPJGyM+gYISefwWFHvpql25aEIZhOA6XskO6YjJwF2F2b75N/P6fTzaGGpYKycWLv2MPD5T8T+fL9TYhgZwDMQY1x5lYQx10SEtt1w/jKtggeBE87dcIBWMc+q7d53LiKwpEWqpzOfEVBcIEETJCB/EY8L6gekewIazn//2O/juK6h35JObVUO3jlonMkSC5cmKV8C0H+UL16VRBBfEI2RDtEAQqZqagADrI3hPjGht0MO1H8wAAAABJRU5ErkJggg=="

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAC+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTGMpxiPAAAAEXRSTlMAEDAAYN/vgEBwjyCvUJ+/zzcN5MYAAAKASURBVHhevdcNcuYgCAbgYhR/Y+T+l93pNsNYROuuM+UATyX2Bb+P3ykw1259XIuyDuEEYoaI/DEUHH0WwikU6avScWvulfIpZF+oTIC8C/GRwuTvpAVkeuh+IQeK44nITqFK36Rn+r2h0mcZHYJGhH3ngd6ywjGN/hYaDTKOiKj1fSR663tSItJbDUYo4HhJgC+E3ZnCQ1xFgQq95bXmKMHIUNIiAk3rI7GENYZYHSPzW8uoXXehWaGZRcRozUGbOA/MI2JJxGsuYVSzJvuoV19pdEpehxZQTfztRFdBTb8WryoT2lhxKe+MkYcmczFbX57irdmbRxyvm4X/ndmNe9st6zxD46huK0BeBAJD43/lEpAB9gp0/QOUC/HdHEDdWCJ/AEE/TzAPUNiEDPaOhwGqbwp+cCx1VfnWxktL+07NSkTA8ZRclSGuFtT0N9rpDFCMJQkZznhYQpWPI/eaXFdl6QSxjASUH+7bwdaBipZ+8GI9zAt4yypQxG2Hp2i4Bsg62ncuzxcroSbXlSx1GscR8kR9jDehMEKAfBxzHUCcHGcZ2ICsAl3uHQVcGx+7apDdZ/j8qEEXMxuViXsT0LQghMX72+1Bd2pfHZQI+uoj+zMEHsUo1cKGIKApw4W3Hv81dAtmnOEZubk5BIXUqiK3s5e/fLavJXByBEoofgea66SoTdumQ7VDnP88N1i2KCjNUWVILqMhwEkd5Q9v/RF6iMurazWNn6llpTWDcl3JLxfkK+KB1cu/wmwBNbEE6iwiUd4O96HFy9p5RKpIg7xuB7vP42LW29XvQrJkvBAOIY6XP4R4Z7kjiI+EHo6hy/FP7UPofl+dBxDXr0B/AD4Wepeho9t7AAAAAElFTkSuQmCC"

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAaVBMVEUAAADxjybxjybxjybxjybxjybxjybxjyb1ojb8xFL9y1gpLzMpLzMpLzPM1t3bupQpLzMpLzMpLzPM1t3M1t3qnEjRzcbvkzE4PkJmbnMpLzMpLzMpLzPM1t0pLzMpLzM4PkIpLzMpLzPHvNBRAAAAI3RSTlMAYL//ACDP7////zCPADDv7/+f7/////+v/yBgvwDfQACAz9VextQAAAGaSURBVHja7dddb4IwFIBhPgSFUuVU3VypMPj/P3JUyI6z1YZzQpYse6/w5olQWtqIU5ykY0m8GYs25LI8ncszDpRt0++2GQPK07tyOhSnY7uiLIudvYrJUGKd8paVEjKUjhUTVNhrFlTOrQHxb+33HraopG1/YA6/qEFZ53g6015IdACUdU5v75Qpgo7tMjqjdKZMWnRsH6dbh9AyohtlYM6oRsupyUHpuL9i0fUxXbXwUFvp2UEJHT/UGfBmuslBCR0PJJAJdvn8UXT/o4clKXlfhJd6AKBLCHU1LK3yQQ0srhYOxHUQ6lgOQqJmOQgNLAehnuUgJHgOQmYxhA5CpBHrvJBZDhkfpIGQ9kAVBao8UEuBWhfSQEo7UEODGgdSNEg5kKFBxoGA2B+GxP8zCrbCC8mcIutMWv4ywl/Y1llq+Ys//3O07gdSGt4fQkjQlhD+tqaXGGejNUiMs/Wr9QtIdrQR42yPG/kMQongUI8QtXNftEPNoGUYsvWE98cLyVcHPyNkGMKeH0WlLQxhzw7HYcjNPa6H+wJu/hZ9j5UFfAAAAABJRU5ErkJggg=="

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAABCicFCicFCicFCicFCicFCicFCicFCicFCicFCicFCicFCicFCicFCicFCicFCicGkTtJjAAAAEHRSTlMAj9+AEDDP70BQn78gr3Bgep25UQAAAPJJREFUeF7tlsEOwiAQRCkg0FYr//+1xsQ4VcISdppolHf08JKZddqan2Yw21whTl2eLNBjspIodoiyyMEiPtp6VNmJPD+OxuCenkB5EoKdGI9HUGcYphFsBBvBRrDWYcBFHSy/oQxWitQXW149C3UxvCmipy82ow5qY+d492wIViFuRibsb5+ywNZeg/UP0ar7PkJB1GcNCroaWhTwD2qLbKOg4Pc/CCS5oHgywNdNNlW2joKAcqIrCqJErhitauulWrl1ToStl3NwxNYJsHUKbJ0DBXFg6xzYOgm2zoCtf0tB2DqJsHX2MfJxUbn1v2FwA+ZcQulWO5CTAAAAAElFTkSuQmCC"

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAllBMVEUAAAC7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjT8q0C7GjTcYzr18+7shz34oj/kdTz8sEz1+Profjy/IzXLPjf34MD7uWPwkD735cz0mT/7tVf6w3rTUDnDLDb6vm/HNTb50p35yIb5zZH27uP26tfPRzj41qnXWTngbDv427Qr603YAAAAEXRSTlMAYEAA33Cfz4C/EI8w769QIMRRXaMAAANMSURBVHherdbZuqI4FAVgg0GPKJY7jM6zZ67qfv+X6wAJKx5jYlOuO25+V7b7C/T+R1jQv59e//Hw8DkQE4PnQFwMnwIxIcRTIC6hoBM0uCkkwk6Qni0KiUE3SEkoJIbdIFPiok5HCBITTYJuECSuoLATBIkJlUEnCBLX0LATpCVdqLg37eBlNHRCWmoKnXJM+wqpmkYKGo7GbGKFkD2dMW0gVeKJPlo0FDLQAP2jnRPRN6YNpHFqCFKrAaJCQVuiRE17Ek5jYeQXhg0JmoKUtCKiTHotgjDsEaSbkJIyCeXCljH2yCVRI62oytniDLBHTokaKauhb4GskkU9BCykRTqtllcQSacsiZIWkXD+Wi8QIIv0mtN+kdQa6by9S08juh6XDiC7JFNpNbLeUJn+JsolonNSCwToroTs0s3bfEdmEjiAXNLheJDQPE3nc6LNx1pxhV4gQD7p33m6+5xX2Unsq6ydBRxAfglJG2e7xAIB8ktwNrWzh2NCfulLQ29S0QvUfwAKJATpssPRfmtHjCIvNMNF87qlQ8UgXweiol77OHBDs0HLnItqoauk6mQy79Ws607ixQFFL7Fmlkm7kxdV50Iq+UngeDYobBnxx1htfboPDenj8YkVYrxlTvsKQKH0/UtCa83geOEtFGDGq6wGUGhdUrmezz9bBsebRtfQbCraJJmRnC7pUe9lSZQhjcQnBhQNxJ0sczqWREo6Wm/bUEH4qyxJyMjHG25bM9OohhgYWyEzB9y2SHO83i8uAW8hJBPWhL3AnjEK/YgEwuA2vb49vNlKus0rlsd3jeATTa/lYkHmpT99DEKhk1q9byGKFiqE4DbIX2ixlCakrXyIHoJQSNdRT5h28BCEQrrOtbTCTeSEUEjVgZTrV+PID5mFdJ0RrnD1Tou9kFlI1YnDfnQl7SU580IolKg6M/N2OG+bzy3mg1BI6DpNtLSUkmw69kEohDpNxlrKMG03xI061h8oMun5IXZbBxK+4QMvxFHnZwLjBgx9EEOd20wgDXwQRx2nxD0Qs9WxfopHboijjkcKnBBTdVzStIFenBB31zGXfOSCGOp4pdgFDVHHmbCSZg7IW8ecJbuBuoTFYvx3EFZz9JcQpGvoP0qFwSOEJ4UeAAAAAElFTkSuQmCC"

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAABdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrex1onOTAAAAEnRSTlMAUI+//wAgn+8QgN9AcGDPrzCKDVEYAAACBklEQVR4Aa3YAZKrIAzGcZAvJCgLcv/LvmG23acTRaD9HeDfgkEdzSC7OFRwi6UjQwM8Cw6E/VTIOihLGA2FdcMVsUOhyLj10x0KKaOF+0J+ETxYO0J2Rwf7EAo/G7pIaIUKoxvfh1LGCE9mZoM1vgrFHcOEzNQGa1aFMqYsammBMcMZUhJmGNLK9qUQBTcZ0ta5kCXFykSoYCHF5/GQBXKgz+Ygm9eGSPxsDriGGNX60RykGnKosF8sb0enUEOCX1shZR25jeBNEilR0KHUUDyVp+ZgpxqyOMieFMYD8UTmtA13cyBoSkRk9A8OzwHTb0gdddc3B+qRLTgbnAOmdwgXHudATYyhiCvcd4p3T38hi0vZP776gSP9MbeLF0tasJxRIXMKdGCIW+NxrURSDDncstTPkLRHvz+EBjcQimiJ9CbpIWTR95eAHJuhFU2FXs7jp5kdTesxBKzhNuTQt7bz2dIM2uQUqnKcCkGFAPZfCkHW8J0QsKUvhQBXvhSCpMnLr51KZukfyObNwZTuI6K5Y4gyGjK1QojHUEKDbYf4GCLX2up2aDuFivTcanHpFKLUXlh/6K6UaDRESZoPyP4QFf1u4+nEPW72S9pwkNXpXnBhUaGq/P/GVEjxuFB06K0UusFPR6RXED1mUyE9uJZmQqokn3ys29V49IW0smwAsLG6Jv8AaQZeTqfuWPAAAAAASUVORK5CYII="

/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAABdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexdrex1onOTAAAAEXRSTlMAIJ8AUEDfEL+AYO+PMM9wr5DVodoAAAFySURBVHhexdgNbsMgDIbhQoLNT0j23f+yU7VOjdrE2JB17wEeRSAiw+2DOT8puk3NPOZLoAAQXwFFAOkCKOOeG4aYcC8OQwk/5UHIlQdUeAzy+G0ZggKe1REo4tk6AGXs27ohJuwr3Asl7AN8J+QKXgp9kMdr1AUFvJd6oIj3irNDGUd9mSEmHDZboYTjiG2QKzgp2SCP05wFCjgvWqAIoayHMqQKayEmiC1aKKFR1UFc0GjVQR7NNg1U0a6wAopQ5NvQDFWhBTFBFbWgBGWbDHGBsiJDG9RlESKoWyWowpAToA2GsgB9wZAXIIKhVYBg6hxyV0HhnyD391/EMHXVrhUBWmEoCpCHoSRAGYZmAWLTEgmQ5dR6EQpQV0Voivo9k6EAZVWALKu0TC2ICxQRC5BhvUvVjDVZ898XIIOULxpGZ/14XAmnrdUy+fOCkxIbr1k14iDveu60vmAfaHHdLxEp0gOJqY4+jU3MhqcxuU9C34YHqPPV2+2QAAAAAElFTkSuQmCC"

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAC93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fTq5ZqXAAAAEXRSTlMAIGCfz49QAECv7zC/gHDfEBl2d1oAAAGvSURBVHherdgJboQwDEBRsgdjA77/ZauOOvK0FJzE+Qd4EsJZlEXN+RD5VUy53LaU5+rKn0FyQ9CG/DegAWjn/4quFwr8f7ApkOqI1AMlvg9cO1T5qdgOHfwYtUI7PwdnI3SwErVBmbWgDUqslpsg1KHUBHFLSJsRkmI2QhK6SRBDNkKSnwVxvodiFwROGcjm8Baq3FcWSBltpViWBIiJaK+fZVq5r20pFXlC9P1p/rBDuMh5aus9R26PE6C3tVohqe7rYYZE8xQQwQBdS7MgbP/9gSOuRL7WWq5Bx0Bm+CW/CvRTzxIpJwFbiz+r30cjlIsy2UMbm/NBhtG61bpMMonmzf+snlY8zMeRVCvaDkgJ2o/swIiJfK1jB2WQS8Qu+num5RRQITjlNrJFNkQClUIGCD6h4nBcygJ9V4epJJCNwjckbQFGJIE+yuEwQlKdBZ1GSJoGHbOg0OfEW8gZBtJypc330BkHF+1VWru+TKBr+Wg+iQS6oVJ8AaDtawIpReXfN0MOlA8TSGkD5bFFoAFJHIH0XFQepATSIlCeyBqhy7UOyJVOSMoJH54RvwB8gwFxZ84uiwAAAABJRU5ErkJggg=="

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAq1BMVEUAAAC/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVL1+PopLzPhwrvy7/A2PD+HU0aObXfAjJjyq7o2NzuaW0rc3+HJhHLu5uXSgnnGe2c8NjdbTlXo1NDNjXzZnKnP0tVhRT9cYWXlo7JrSEEyMzWjXkzAg4fCcl3so63ilprCbVncjo3lm6Dvp7R2en7GenHPfnNO043GAAAAEXRSTlMAgEAAn+8wUHCPEN/PIL9grxWWhgIAAAJ0SURBVHherdjXkuIwEIZR21gOktMvYpicc57dff8nW8BmuizJoEH+LruoUwhwG/D25SMY2OQNdhcCLHKByAFY7AwlqEu5G8QZmlgauUAJKIg05odCGZSyhB8EQY9FB0ABTFLeE4Tw91AMU+x3UOAXDObsIV5W2BG3hWIGyuEZldgdC0tuAwXYH/P5fiiDTSLYB0WwrNwDJThI0iEftrG8JwjFTiiGfbkO6UvxdTSWcjx6BaXNUg3Sz3YylpvGJ+Ros2wXlIcAcL5yGukcdaaZGSIGuJI/XQH6zAzpy/56LdzeD4f3t1JeNzOa/MzyDihE02jlHE+GqybHctTMaCLlaOfRUmw7XUF/hpv+yNNmRhPZzIQC6YtVrprU0ETK7Ywm21nFTZBoQ8OmLUQTgiAiHSpxAAQWaVCFXx6tkbgKgbJ7sZsKBcpB2bz9VEkQrWr7DyQlzJD1JUKVHa+R5UVLVW1IgLJaI1QbSkFZLTYqaEE5Ds5vQ6IXiKdAH1Ak0AsUMbhD7g6SBuIM/UAVXCs3UAClo6FVR6CCNVRAaWoHTUEJPvByaF3YOBfKG+f50DqyPRnFBh6dzHi4y9n8ZrHpZj67VA9GlR5M3dXKcvawaPUwW9bOHZRCM4THtVMzKrV2HqEmOiBMn5bzhbH58mkKvS4Izy+Ljl6eYQNRZ28m5u0MsIWIeleZd2JUqMCuPv59fn3XxvfX598PdOb56KXMi9BLKV20bkW0RpwStNjcimnVOlX0s/zBeD+3Ixa53iDJoVt2iI6KJBoEIUNnBW9/rQkqA+IH9BdHAVMi1n9C5EklUCeK0I+jgVIe+H5RZKRkKT3mP+OIEflY8aWgAAAAAElFTkSuQmCC"

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAY1BMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLPinDBbFXXm3+/aVLOh23CcFjJfWTMhGrWl3zEc1vHemHKgGfUlHnTkXbGdl7w+jQqAAAAEnRSTlMAEGCfz/+vQAAgv++Aj3BQ3zDip1P0AAACIElEQVR4Aa3YC3ajIBTG8QL55KliTNLm0Un3v8pR0xl8XRXMfwE/7wH0HPlYiHFxQFsm1WofikoKhARLhXSGQSYR4hajXBKUY5pOgARmElEQ7cCyWKjAfGUkJEGUx0HMg8jEQTneA2m8CRJvgjToXAwkQOW5ioB0HENDAkRCRUEaZGUUlIPMx0DMgi4GcqCzLALyC07MGnEMMiYwgqkI6IBBhWJceMBmnGAIqMIwqUJRkNgJkXuvEiGON0EHDPOJkMYokwjluyHqVGdpUIVxLg3KN0GVlKUrpJSMhPwaJF3mEbLGVXOQxhLEeIaZvNMTqFiApACZYCMoIyFpsJQthxAISBuslfchSUDcYj3Rg9z8kwQ25QJkMM2QziT5H7JzUIGt+X9QhZmsxeb4L1RiZ/4Xcthb9YIy7M29IIO9mReE+I51fUTIp0Kn+nyu0auDNKK7nOcgGT/QZwN9vQG6nptu+6FbHQbqQyUiu08Gsh3kENdX61zRL+sgkeDcMYh3kEFEp0fr1Le5l9bSp/f7hmHHz875M/sZAVF9brpfn2G3Li0zdYzaAHXY49r00yptnyPHsxXo2ErTvk8YZCv1gjSoTpf7hPl5YphvHXqisCyPOij3yeLDMEVCE+x5vDZdnieMs4VSARJITWjVh5jYwwSoSXNhLKKyuV748ZPFYZsiyvWbiCKzWMw4ufX+qCpyM6dZkxcy4dZPchcqZaUW+wv68I5FmAgRagAAAABJRU5ErkJggg=="

/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAjVBMVEUAAAD8q0D8q0D8q0D8q0D8q0D8q0D8q0D8q0D8q0D8q0D8q0D8q0D8q0D8q0D8q0D8q0D904D92Ij92Ij92Ij92Ij92Ij92Ij92Ij92Ij90Xz92Ij92Ij92Ij92Ij92Ij92Ij92Ij92Ij8uVf8q0D8rkX9x238s0790Hv8tlL91YT8sUn9xGn90n/92IhsDACjAAAAI3RSTlMAMAAgYJ+/349QgBCvz+9wQI/PEAAwn+/fUGCAv3Agr0CPYHjbmdcAAAK/SURBVHja1dfbcpswEAZgGx9im8RukZCglgUobpqmrd7/8Roj6gWWRVIuMtP/0pN80b86eLL4f5LzuCzQJ9oIZV0K1Rj9Qch0CKRo8nioLOxUirOOglhl22Ti3Eb1WKHDoTyz1kpR9umyuWOVDoRy+c6cGfqJvJEdJVgIxDJrFfFHTbcseQmAKmvPnAjsgtI+qLTW8LkYV1CWHqgg1oP3tJmFjFXcm9ItKmMzUCY194cpdz5zEtKoGJHGDSqnoItkPCyGkhxUCR6aUoKEoaLkwclBwpANALCEIaZ4TEq3dwxDNYwoYuLZBASbH3MKmmgIR7VSOYZ0NMTcwPUI4tEQr92rQkDxY7qMoDoeYkVbjg0hE6nAaRJDCF3Z3fX6lCbzcTunAZrI8vqejQdy865mod0NOiahS6Khh+st+6AlCRJyzaAbnQKWBBBqFtDt0kJnB9HN/N10CxUA4WaB3bJWygFCzQK7neE5WVDNIvatAAg1C+zGbBsNEGoW2M1BBiDcDLr5p938g9aHXnbXXraHXk4r4pYoB0EXX46raajooGtwDmNI2jYOSj8OMduH+DYYWo6gcgilj4Ej+jJuJvrQLetjgPOYovMoxxBfPnmdU4LSWATxdDPPPCyxY+wIctnP1Xv+yvg44KgBxFdkve8vt7e5HjCssfeIAUQf8R+vtk0hSj36T4e6tOsp5+ebhUh1CyjEM3Kagn5ZTxRH0PTJfPVABkHErftNEtS3yJoY9jxUYoi6c3/mnIoDBM3iu2UMQ3sk+LvJnGOof912gxvzRq4n5xMQ/OpxnyT9V+qFmg/jAE0027qX53SXnycZ9z8Vhjbo5YFX6puQqJXhEICg2VPv5Ul38EWZX4S6r6W6aM4pqJvy8EHtZr5OuuR1XbvB0NDOTXmUdHv7GHQqiwRy2G5WCc56u4G2HsibT4T+Ar16wIBK0kG4AAAAAElFTkSuQmCC"

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAP1BMVEUAAAC93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fQqZ5c8dqOPuNdzUpAxAAAAEXRSTlMAMGCAvwAgcK/vEM9An9+PUAkGcdcAAAFrSURBVHja1dfLcoMwDEDR2PgpsFMB//+tTZkGzZgkBkmL9u68OROHwVi3f5Sxg3O459xgjX/fzb8qxJTxRTnFcB6COOKHxginoKlgtzJ1ocnhqdz0EQoFT1fCeyhmvFCObyBweDEHryCT8XLZHCGbkVG2LWSRmSWIHK5EkEFBhiDIEijDDjkU5Z5QRGFxg2hjgs1tUEFx5QcCVAge0KABDQ+oakD1AaFKRguKWlA6Qusyz8vaXTfVA7TOW2t33XSAlnlr6a270Pxbd90UpJD+1vT/bPnjVyn9uVfEaB0jageb2lGrdfirfY50P5DyT7byJUJ+rVG/aMkkq34ZlV+P9S/sVETRCEEFRKWhBinRmJWQkgx+gJRoFLXYxB2O28d/Z47r4XDKXIqg0h6fTCi0LyMXKnyHoPYHVePZUEIqgWdDEzH5y3s2BHVnBvAC6P5kSvCeC9HGagQO0QzH9W54AkEw1hRJYUOy9KFvudz+LfQNfzMAAAAASUVORK5CYII="

/***/ }),
/* 996 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAC93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fTq5ZqXAAAAEXRSTlMAMHCfv6+AQADvYM/fUBAgj+GjGIIAAAFvSURBVHhe5dfNcoQgEIXR8Kf2gOB9/5dNZWLqjjWMIzTZJN/SxakSpZWPf5mxzt8L07y87WOpNzvBY+HWBd0inkpTM2Q8qqW1DZrwMpevQzngpFiuQjniNDHvIDqNUh0KeFvM2Qa5m8HmF9CEC6Xj8tcgg/ZkrUAePW1P0A3olY5QRGfrEZrRm+QD5NCde4BWJ+gv/0Bzgiq7QxuUhW/IQZvcoQ36vqAZg6A0CFoxCHJgqsVOYKrHD6Z6ITNGlPUQNy2YbowkMNVgc2CqUbsOcZRbhJ8j5ablB1I7Rvyypx1sQkg5aglx+Cshfo6SEmLDINEtNvO6x88smrNVqKC5UoWW0Hln+n9Ic4TY1jNACPX+/cXc+ucfY91pPYvETL/mEDpfp61+lQ6hs3NfMPvVAAZvLh1Fi/UCAOJtOblagYoTQFxZuiJkhGcxDVQEe1JUEGc/nAoSQqKCwDASGn9r4xd7/OMf/0L+8hZhfwr6BDi9/No0FVivAAAAAElFTkSuQmCC"

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAZlBMVEUAAADqWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW7qWW786u3tboDyl6TrY3f////3wcnvg5Lzoq31rLf61tv+9fb74OT4y9LueInxjZv2tsAPznQHAAAAEXRSTlMAMI8A74AQ32Cvv3AgQJ9Qzy4jojUAAAP0SURBVHhevZhrg6ogEIYzFQvDGsD7rf3/f/IITQ240lofzvtlSexx9p2BCQ//SdExRh2j+K0Ob2ejBNLHKIUk+h7EMgA4mdEJADL2NegMi5LIRrbo/CnoyPk5v8SxAKuMsQysRBxf8oLz404QWHGRAY44IFLgaB/oAqDvJQRU3jXAZRdIAFRVVc9bmLlepgDELlAOqlokt0DSzCjI34MuV2G9hsaAfrZAPwbUgHVbXC8B0NH4ydMM2sftRtYrGthHtJCl3GTiGABx77lg1bb+Xy9WHgABdH3XNiX0C6cHq/4RWYOfcaps9HIrQBDUV0bDQBYtn2aAebmCweK85b0HofTLk7Esx5dn2jL2gshra/s0WYuRvAs0EUhZUEfkzoIUgaZtEBNpBqpZ1HaTREvcEPunaXJaMrJIQZYKtgKdzusVFQKtV+H55IBEBgF5oICy6AW6QkiSQBJCupJH5xCochTinB2PWPI9KGGe2Qi4d51u1F8g1eiuuyOIzHYX7FwZDVM7h0BzOw2WO9PCdUGXBPwKHGqtkIuaQel68OsTksuqjjjliSQnFzR5U4DiTh1FheN1U+1S47hdRBYkbuvddIdW+/BNLKDIw5TtuAc0tv5KiYxHnDD3utqtGvOPqTtQwkCN1UcaFVDqDk41guo/4fQzODV5wD6E0nIvRmp46kh1xB2zd6GkYzaPA9uInv7CTHp7G4kSKH/cdKruTViyU8SwX0wiBN2gHCvZgKumDiR9dZusxhJuD9AJu0ft19gcWhmkssZucrKg7Lm+hs5F9ZspdzHd8KRnBnS1Af5CtdWm2l8Ya8p1AYmM6oeCV8M2aFBojldPmbBm5wmh+jf/mH8DYZL8WUcsNSjpbKD3Kijt5EIaTMqcTsuSR7A1GjCEQQPaWD+MSJjfsjFWRTeRpKQxPUyhE34XwRKYyEnSMM/DVjFNmHoCUUD008E3RW/5ffdCOrgBSQpotT3/bIUk3ZAOGJB2fjf6TShwDemDtiEhSNhCqseGXByRNmKOyhEZI+WkGWtdAiSCPGIFkFppmmyDRgMKDW9Mu5UtkArmtWyWc0Dh41w31hcUoHh+2T5CkBQmjKSx8kmhI0QKrojjksBVGjyLuCJ/ypJ88kB8F2hUT844Pklq/BxEmrBwSB4oaHZCPFrA9YqQvDU7B+CpiGMXU2JhTl5niGORcoA8eBRldFyngqYSJ5ARCxxFScRpnP1jaBwQaheIOonW2EE+Bd0A1dB+5K2X2y4QlkEhbAfG8tbYUUWBad/5kqU4MRtZKQ2nKAxJPno8OxXhlyzh11Cz4cSxIc3eq6j9IOwtlmNJ2C8+AhEJOYaEnO9A8dcv677XP/TaFd8P0EyEAAAAAElFTkSuQmCC"

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAC7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjQK/11gAAAAEnRSTlMAEHC/7//PAJ9QYCCvgI8wQN++REF3AAAC/0lEQVR4Ad2VWZPiMAyE5UNxfDv//88uYyakV+OJKF62ar83CGmpdUH/EcY6zw82a8IDCp9hdn7h4+dC0TOSFKFsi3tQcxA0FvQ7oeH4pJiA7CxxU2g8sPUBhs6OAd8X+Rwt1eNMiTBNLlc6nhk5rpwSP6mz6BtPGjUGDvixYH+l6s8CTwZPNmKkSJ3NvRyetsuVz+RbF4Sup91/ywz4YP/OIJy4byHHwAjoe8f02OF7PH4IGVtqrfwkTCq8+cDgw3E9E0JPL5hv5ok34qc4QukXIYtedqwJCl2l9eHCoxDGyTgJUihiRDS+PYU2nnSokF0KNXSGRdvpRzkPnpgwgW8gYg4TjEuyFR1H8wl4ZSwRptsJVOvKGYZZNN+cUQimPmKE8MJeYQYuAE5rewp5cI7lwuXigZpPsE0kGp5l8jg6WANpm67hKPCkhQmOzlLIMd7sBo8T/hSHNa6exit/EgstYopBH5A7XJgxhbC+C6EdvzCM05o3qAOJ1Zd96XAKriZtXx+TxxdJrP6AD3DjkrjB3jnPjDEIVx+OERqDaTAHC44eJoSrDxta8b/NZxwcZJqcEK4+/vuVZHdmiCHMyaYQLiJ4Q1JAxuVuzwGEZMOrkPExCGJzD/ZkAkDnOEaYHGTr4S0IVn+R05HCmxCuwElux/xuR1cKlHB9EIUxYq3VOfcVs/RA8rQq5GHr7jYW+E4R5kpRaDP6mkJzAsudjhl1d6xB92nEei7n50KjFl0DrS0wsW2sIYuti+jM9gdkvC/indtrTWOMc0VOTHqrJpurNQ4TABTKVk3lcNUKASGkqnhX09C3v7u7NEqdWehQ9wwgrsUc3obK0kypqhcBLTKxPSjoQkeL4Q36SLXN/8jSF9aKzfoxqeKY+C6KXZLSnWHXx6S82l+miqJxM2mnkMKokIcm9LkIWluj77AsdpDgDmtg+1dTohty85h0sf2C7u/PUcI1vhMqvy6xOCaa0CqPlsDGh0JOu0i6tbnDuohabKfssCoE2/e5EPKPhP4A335+mwlHJdwAAAAASUVORK5CYII="

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAb1BMVEUAAAD92Ij92Ij92Ij92Ij92Ij92Ij92Ij92Ij92Ij92Ij92Ij92Ij92Ii/aVK/aVL92Ij92Ij92Ij92IhndX+NjoF6gYCfmoLYv4bOuYWDiIGpoIP00oeyp4TqzIdwe4DFs4XhxYaWlIK7rYS/aVKr7tLqAAAAE3RSTlMAcO+PAGDPUK9AMN8QgIAAIJ+/qqUfdAAAAmpJREFUeF7Fl+mO6jAMRkOXQLe5Baf7Bsy8/zNeuAUlTe2YSFea8wsJ6Uj5vGAEwSEACKMHsYQH8hg9CAGCQ4QjIpQDPDkl6QlenJJk/Rx7iTIgyXxEOTj4b6JfeVpUAEnhJcrJtLPcSxSlAaAEKdNHuIn38KKvH5SvPwSC+uKH4PdE/k+jKJG0gzLyDjuSgCD9RSGghL6iIxAc/UQ6ICYmTiSBRDIiJiA2JuEIyCsmwQY0VkrVNzYmwQbUqAc1G5NgA1L/uHExCSQgTNRyMQksIFpExySYDuqaVdQPnRUTIzqDybVWmmUaQXN2iw5W4bcsHWgOLlG68fRqh2lKHaLLtoFWqmlq3s4FNBdaFIPBvGpewcwvLRjEpCgDg0k9+YY3bW13eEaJYjCp7NEYp2qYwSQmRNleVIGLDBWVIexF6vbpQhHkITOsZXKazjtRLsFmVivNDDS5FtE7elIv7t0HbxOOA23Qs9EQWZ23ohJwOmNm+6u7bsL5ozFOi1bVmKrciCSQjOYmqUY0JC0CJ+06ZngzFKYoB4ZxeofVg8XJErG8w7JzulhP47n1Chu+AAmbM+mFZCJzq/w8FSoCyTTk3FRXRNTDjsI9Is869bfdEN+JpqSHVm/slbnXVbMIDVFKiNTSdE9XO6zlrwFBGqICWSIYLWC499GAeK7AiQChrS1N3QIvQunuC7OQOJGm/X6VbwYSyYjwQ4spv/QQkQ3JTNtiHaP0iGDTRp/H9NDiHUkf7PQaYVOaZ+5dpiiX4M+5xM6aAnzJcvw+SsCThL4hWfgb0t8Uuw72JPs4n4T5LxJfgAcucR5t+Qs54RzMUOHh7gAAAABJRU5ErkJggg=="

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAWlBMVEUAAABndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX+aqrRndX+aqrRndX+aqrSaqrSaqrRndX9ndX+aqrSaqrSaqrSaqrSaqrRndX+aqrRndX9ndX9ndX+aqrRBYtgaAAAAHHRSTlMAj98wAIDvEL9Av1AAn1CfQCCvr4AQ799gIM9w5SShJgAAAoFJREFUeF7N1912ojAUBWAJkhAyWMPYGuDw/q85ZWXJbv41zkX3nSz72Z2cIJ68NESsPVfk5L7s6DtcvA/1tEf+bmi4/AnzEVw5Oa8Uoz2jEoCu2zAHzpaDRMfpyIR6f7ft9uk5OUhxctI/pmD+2rb7xXFykCE//CHdtu8MM5wcJCkI5um+S7afdTIQs8Co9FmrkVvJHOu9x/azThJSbhkxWQjrbTPM1klDjT8/hhMt4oz1RrJQvzv8/CNCSgH3VgmFub8C0ZqGrk9CK5Wkv89BmluplyloLkH+YLNVRKGPACofkVGWnKcPLTMFp3wbAeU7ZShB9TpwyhBiFuc2AqcM+ZHjIQk4L0CIflAjnBoIO8hrv46Q1paTtRAyAhJrpxNA263ChUTrQd0BCUZEKuoYIloA2StMRf6jfZQkNjDaX/+EaE8j4LR8dxjePkUgO3JONf9YSLtrHZ4HUM5rPzoQIxvWGCnl2jsDqSlarsVlQIpiMc5HT9Fiytt+w5NO+DehDuisJ49hKmwRFtMuZKmGEZhVpD8exdbEZLfGWp0/noKhHGTqX3+GlCgXKVaGkAblnGKvQiiHYkvq9OOIYYkQhXK2GLU5SCz2ZEQyHeUWnJ8AgmSwZW4Et+VQLAMh6XISN884tMXiPOH3hDQgyhCcVu4xcLiSe3QWCp2GUjE5KOxFyfR5CI4NT0JTHoJj004syrCpzUFwwkh/6/MQnPeh+X9Bw5sQcvkBmNS2cVWG7p+A+FtzdHsTQuZyNSbT0Md8/MqrXGzMz/WO9a6CMIe3L6x3DYR5tv1ulRCcR7+5CoJz9BuqIDjod6mA4CDX4fN56KX8PkjjJ0oVhBgibmLQP0a9A8JdUma9AAAAAElFTkSuQmCC"

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAABndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX+Q1MiBAAAAEXRSTlMAQM+fIABg7zAQv3CAr1CP30YxgMcAAAGqSURBVHja7dhbc8IgEIbhEhbIcjDs//+znakTvzpYYEM73vS91sdDxCV8DDObiFhygz7cIC9fhX0R4iD34iKU5IzWoCxn5h/6U4h9CfJosze+BJGVJmvUEB/ysmh00F7lpworIC+d6j4N3aRboEmIgvSLk1AUVG0yxvgcnySagszLa8Q5yCMzBRU5S80vQgXJ2dFchCD3eALCJwvtw+n+VXk3AWGdWvcic5RMTgdl1+ktUF2EsM7yGrTLo7QEuQ1SIQXUX/uZL0FYI8julyHe5KnN8xUIEgr24m6EY/sHm1gBoRQaKljqQKqxJpbmIbQXacvcgVTvqu7Xtn65NpRXQcjHRtJBiGxoJD2EWYQC6SFQ3yWrhxBtgugChCwg30LXJLsGcTihuAa547cgo4EoJRpCZQx5TI/OR8t9CK8ZUv/Lvg0hi11w7/LzEIpYUKlxNEukCKqeHTKbag/p5amSvp7DJm+CihtBmPzrG3auQ8i4Cagds9f/s/noMcEopoiJupssQC1lFbd9gHo3tKgeytmP9m8zLdH/AcIboPceROFo7N2HdWjy+PATvyiXxy3YZskAAAAASUVORK5CYII="

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAYFBMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t1ndX+zvsb1+PrZ4OS8x86rucGaqrTe5emltL3q7vHCzNPI0dexvsbk6e2gr7i2wsrT2+Dv8/bN1tv4jm5nAAAADXRSTlMAYL//34AQACDP71BAlkOE4AAAATRJREFUeAHt121vgyAQwHGVbqh7AEVUPHHf/1uOC5XMDPdiXJbN8XvTXKx/K6ZNKbLsusqKJbg9PHLOC87rhiVqnzBUtyzdsws1jMCNFyUjURYVI1EVjMiVQy9EcuhrOZRDr0T+ww+b+KafCMmuV6ofUkODVt6YFprUbk4KdSowImaZjHJgtdtpKHSMxM81CWRXNy/izhoVwHwempUDUojevVpcsN6fg+sVpkAvJ6FBOeCObn6xx3CjHd6UUZ/YaGjTvuOLWnYqACH3TG9HfIc/CNHQ7K/hQ4EZ4DCJu9GchvCEVRxD2n58kjpk0BuAPQvBJtAG+4PBeYQQjYiELF7Bw4XV62HqpIj6A9/+BFcPkf1hJ9tCEG1qGqJtVlvTbPyamruQk7YVrUrOfShdDuXQbwu9A71klpjjqqKnAAAAAElFTkSuQmCC"

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAATlBMVEUAAAD92Ij92Ij92IiaqrT92Ij92Ij92Ij00ofYv4bhxYZwe4BndX+WlIKfmoK7rYTqzIeNjoHOuYXFs4WpoIOyp4R6gYCDiIGaqrSaqrR+TeD/AAAAGnRSTlMAcO///wBg3/////////////////////9AAP5QBD8AAAD3SURBVHgB7ddBbsMgEIVhnKkTMA8Ddps0979o7EiIWHK8eKWLVvNvkJDyicGLCHOcpmndSfb72En2O3W96UR4qHY2lzbQxUgbSBT6s5B1smmwJOQR5KUR3nIQgFi3IoDEQSPgU9lJHgjsHXkgl50MePaOZKrDRQAz//lDGS7VwzFQ/X1eRQ6qE8Wy8FA5Sh2Mh55GBjD8CErOBTwLziUe+sSmkYYyNmUaSvFr6Qpc1zUmCqrl+slYyM6vJ5otDQX+jg6hQEMyuKUbcFvXQX79shUKraAJmP7Hf79CCrV7QpxbPWr6Vs+s/m3fO93fZu5tUug4hRR6AOvxj/SCkO02AAAAAElFTkSuQmCC"

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAATlBMVEUAAACn0oun0oun0ouaqrSn0oun0oun0oujzIpzhoFndX+LqYaHpIWbwYl3jIKPr4d/mIRre4BvgYGDnoSTtYd7koOXu4ifxoqaqrSaqrQjkBh4AAAAGnRSTlMAcO///wBg3/////////////////////9AAP5QBD8AAAEGSURBVHgB7dddbqswEEBhkmmS8cEYTPhp9r/RiqnKE7mVGD/cSj4L+DRIIxs3tVrt312uctzHQXLc9XJrLiJOyLo3jzLQo5EykFToz0MaCFoCaoFYAoqFoC4BqVcnZIw1qAfqMntBHdAIjM8YA0A8D03AbIMsGdrzUAQWsbRt1QdNsuf7tDwVgCQAhN4PqUnkYfVAVsxYaXVConHE6l2Q1Se2Jh9kLbbiBSDRDJyHtJOfnsB6FlozSeW75JloAXK7UToAszgm2kopsdWdhvZzzb9H+zYyd+7DfwCG9T+6jspdkBoY1/pbU6ETULEnxL3Uo+ZW6pl1e9vnQa+3NS9/Ffq9ClXoC6u6jh30Ofg4AAAAAElFTkSuQmCC"

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAATlBMVEUAAADG5LXG5LXG5LWaqrTG5LXG5LXG5LXA3bKuyKi61q6iuqF5iolndX9zg4aXrZq0z6ttfIKLn5OowaSRppeFmJB/kY2cs52aqrSaqrRcGmRrAAAAGnRSTlMAcO///wBg3/////////////////////9AAP5QBD8AAADwSURBVHgB7ddRi6swEEBhba5tJuZUo3W6/f9/dGFF2ILduziB7sOct7x8aAyRabyf87z2FPb7t1PY79R2TRuCDVo7N5c60KUJdaDgkEO/hBxyyKEoIskO9RmA6xBN0JjZytEApQJMs8itwGKAMuRxJTPTcaiHkraFGF7tCr35899UFdA1OQ7xlJqeqEDWtdl0IBUkbL0fWvhW6f/AZt9VMxT9ahlNe5SgxCr3UYahCjRDGbdFSsehoFBkZSZIx6GYAR1kWMAEhajPZ8lwZ8tSAPQe3/k7qjZCnGsNNV2tMat72cdOj5c1D3sOOeTQ//sEA/SPwJeGS0MAAAAASUVORK5CYII="

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAATlBMVEUAAADLuOnLuOnLuOmaqrTLuOnLuOnLuOmyp8/FtOK/sNyNjqdndX+GiqC4q9Wmn8GTkq16gpOAhppteYaZl7R0fYyfm7uso8iaqrSaqrR5mz4hAAAAGnRSTlMAcO///wBg3/////////////////////9AAP5QBD8AAADpSURBVHgB7ddPb4MwDEDxUI8S4K1Awp/2+3/RbT14CNFNcnLYpLxT5MNPkW92pVLp56qLnPd2kpx3qWpXiSRA2tU18p3/rLVBjdNn1/Ps/WaBRKEBbTRD6kwhAvR2qI3A/LUfPwGzGRqAQU1ia4VmWPbb8glQ0NmSAK2Azm79Klao0x1pNkgCLFkgDwzJ0MSuLQFiX0iAQq4fPYswi5YAhT8HRVhzQB7ockAT9JIB6iF2GaAB2CQd2jg0G6HAMSM0cmg0QOf9X6hABSpQgZo8UOOuuY6aOteZVb/sftLjZe6RXoF+r0AF+gBm4I7YF7mYZQAAAABJRU5ErkJggg=="

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAV1BMVEUAAAB4sVl4sVl4sVl4sVl4sVl4sVl4sVl4sVl4sVl4sVl4sVl4sVn1+PqIum2Pvnev0J/e69zt9PDW5tKXw4GAtWPO4sinzJW+2bS31aqfx4vl7+bG3b5oDel0AAAADHRSTlMAYK/PABC/MO/fQICoA3n1AAACHElEQVR4Xq3Y63KqQBCFUeIlMUn33Afw8v7PeRByskvSVA8M+7cs/aRQiua5twNV7Ph2GtacTud3qtzx4wmdj1S9y8cAvdMO+zw3X7TLvpvDPtBnc5mA7K6G5Nmry7rU/Dh3Zr6JTsfMvhhKPCwYwbH8nCmB8PJWgPwIFadRZBbjrqPzKIfMCIUshoVcDtFVjPP4oDokHyPrOoSKtWGA5DiEOVoJ5TviIHOktRAllBDCzHqIesSVhwES4hDmaQtEN8RNYWy3QdROcb9hV9oI5TDFIWwThLjE49J2iCJjvQbYlrm1c8im5zo44ZaeM8tOGF9mX6Gel+aWHVxVgHhxcdmZ9gqFRahVnBlk2/gzPwI+/qy1ioO02dLs1CtOsApU7uhQuaNDujOHusDywk1zSk9/VJytUBScorR7enGM4Gw6aw4OVUEeTg2EMkdVEMpMFYQyT3UQyiohlFVCKKuDUFYJoUyB8LZh9u/VCWUaRN3gdPOrPfRGKgOkLeNiji3KVkGowVC2EnqwMLce6lia0aHUMkdncKctzZMG5f8hfrJyECGnQW46DpZnpUyE0p/D7lCpi/KfASBUicN9rukDfmNFCFXycJPc4VZPhiyqpHWkr8HVtLgHlUItYxx6L1wPZdDL22ci42BxyFsgnyYfVrBUBl2QxsERNlgR50iHDviyH7nmIcvX749poop97/Ygaq9HY3s+rBu2x+PDf+qb/qp+stS2AAAAAElFTkSuQmCC"

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAaVBMVEUAAABCicFCicFCicHh6O1CicFCicFCicFCicHM1t3M1t3M1t27zNptocrM1t2aqrSaqrRYkb55nrlTj79FjsZToNxbq+ldreyEpsCSqrthrel0rNcqZ5eaqrSaqrRndX9ndX9ndX9ndX/2El/9AAAAI3RSTlMAYL///wAgz+9Q3////wD/AP///////////////99Q/wDfUC7jzbgAAAEOSURBVHja7dHbDoJADEXRgSrITbyjKCr+/0dKrDqEiqfG8KCZ/QTTZhHAvMrz6daoE5/63vhFRh4FIVEfxIWBBgomhCCaBAooJAxRiCGPAMR5EPJ1kA8hghDnIAf9KiRzkIN+EIri5FaaYSVLeTeOpo/M4yJKnmXQsbuRgGI7TBGU2t1YQEkrBLV3B4C+fLVBPjb3/e+35U2kLG+atTLtmz+H5jpnDqGFDlpAKF+u1pvibZv1apljaCsZSW0xtCsLReUOQvtC1R5CpQ4qIVQog9BBmYMcNDhUfQZVvdDxM+goICtVeqhix0KdTvfOPfXNTffAQQ76T6jmvVoIYg6gCy9ehADmRm7WzfOkg+ZXQgcoGRAjL4QAAAAASUVORK5CYII="

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t1dreyaqrSaqrTh6O3h6O3h6O3h6O3h6O3h6O31+Prg940cAAAAEXRSTlMAYL//ACDP7///ACCf7/8AMNJWhQgAAACoSURBVHgB7dcxFoMgEIThgQVMhF3M/S8b6KUJU5n9Grv/PUGLwRSibIghDUgpF9lU8gzlQ7YdeYSKEJSEIBQBUSgihIQfev3oD0Me8pCHPOQhD3nIQx4i4IaiUETahGCNGtrMYg6/gTNFl943ziWcSw8OyY20hLT0gFBtalu01d7RL7VtenVUNQKtaEbRoDZ9hp2nKYwTMl6I9mq0w6ZdP+2D7J3zi3wBZ7CTF87er0cAAAAASUVORK5CYII="

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAATlBMVEUAAACaThyaThyaThyaThyaThyaThyaThyaThyaThyaThyaThyqeVjGxcXM1t2NQxp6MhZmIROQRhptJxSXSxtzLBWHPRlwKRWUSBtpJBQBRbadAAAADHRSTlMAYL//ACDP7xCAQDB7/KQkAAABCElEQVR4Ae3XD4qDMBCF8UneJKlWq6P1T+9/0WWXstASXWOGhUJ+B/ggiQiPthiLCGt4A3GU89jgXUrIBWwKLiHkscMfDxnsModDFrvs4RD+cDR00Q2FquY3dRWSQvzTuXLENSSHKo6qkkM1R9XJIY67aIX4w0LGIoM1z5DzyOTdd8gFZAuOiT0UeCYDFYYsVFiCkhIqoQ8KNe3tV9ucDzW3F83pUPsaak+Hbm/+NZR/tE7nsjvqdZ6/JxmgYBCS8Y5s91FoknFApmGUiWYR6Ttk6HoRmQmLKFhAWB+S7bGCgHWRTMv6/LLnSTJMc/lnl1AJlVAJ7VEbNWozS2v4qU1RrXGsONe/ABOtVreNlzWXAAAAAElFTkSuQmCC"

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAt1BMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzP/2YM2Ojj/6Lb/rDOUhFuvmWX/2ob/3ZD/4qPXuXT/1n5fWke8pGr/57MpLzP/5Kn/5axRT0JsZEzyzn7/3I3/24n/35b/4Z3/5rD/3pP/tEJ5b1H/rzj/ukz/zm//t0fKr2/1+Pr/0oX/w1v/0XT/03n/vVH29Ov/46bc3+FpbnH/yGX29vL87cv/4J7846j/4JlERD3/y2r/4qf/sj3/3ZSp5Ta7AAAAB3RSTlMAYL8AIM/vi50ITwAAArBJREFUeF6t2IeyqjAQgGE86kmhd3vvnl5uf//nujGDgyYbFkf+B/gGlogh1qnWQ3pHD622yGq3O930zrqdE9R5TO/usSOgbtpA3bbVqgAiOw5IURDbUYXUskxzpouYaMULapq4BTORQww5PVgCoWh7BlxvPFKpbVQTok6hzPwpY8wDrorWgfoDqQz9hMlmRG/QxyFHMl7Gzk3gUSEQlY979MoYApGAKhDgjBN2UUYQCYB+ncbj+hJAITKgAFRej5uz66bEVEANkO7IiFmCIUc44XyvQa5ZciCoLx3ONckj5vo6RE+DfuaiPQDhA7cub+yDc0D6SSpyVCgSztOSQ9KEVBUp0FZAK84hya+EttdQTzhrzkEpI3UuySontOGAhEPOJUSFc+TcIJHq6AW0kI8elHBocQHFAlpykzQsgB8vO0Nv7wUknN+cG6R8WDi7it4lFMk7A6Vk4pKilyroTUK2gP5ySMoFc25XmVWMKORQc+kEQV0okKtRbxkKwKZpSu16kPy9Ah2E0yuWfl2IhOv14bDaXI0qJMROi+yaUFkpzuWyLaI3Q6V4vHorB7UguMagZm5Ndvuw4W59/IGRuXFBxmam/Im4NSCb4Ll5DSjCmUnCPvHXSIoww5yJvrAXGz6kkMm+PtFX7YJUx87t+XXPysufItAfk3RU/o5SpxrKGCxtlD9I9Ll9M1haC6inbyLMTRgorZRNBH5J/xgkLZ+UbQ0+JY9B0oeckL71QyBNeoa3fmkfWZGqNA/1zSh+c0yTpOMYNuzoiizLXfOGPaVmKQMdqkL4wL+vHd+Vg0Y+s9AVmYyRzywp4SvydVQ4yKcospAyT8pO3Y9jGEr8IfpxXEYdeEVO/Zn2uY4fIKiNPRc7QADrmY80BAPV2CFLY8c+TR1ENXY01uRhnaiJ48P/TZJZUvVvTAMAAAAASUVORK5CYII="

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAS1BMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzN6gIRVrO7h6O2Rl5zW3OE8ZoU6XnlQnNfK0dZSpOI1Oz8sNz9udHmco6cK+TT/AAAACnRSTlMA358QUGDvQL+AzL8+UAAAAMFJREFUeF7t2MkKwzAMRVHJdqaXufP/f2mzqXEghigRtFDdnTYHtBKIlnzDOBYXlBRKHM/56FQ4lYsQQ0cqNoCh39VrJdUbUL+zeypBACG2np0WBKcFwWlBCFoQa0EwyKA0gwzaUR6Sn6MhA8n7Q2i6dYJuUw6aO2FzBrpIoUsG6sQ9fg7KrNaL+wJkkEEGGWSQQQZdpc51BXEcWin0TJyaGsTaUcKMLZIK8iUUYiIKUKiipYpxsjJ83mM1TsSNJ6I3wvHkRvtkchAAAAAASUVORK5CYII="

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAkFBMVEUAAACImaaImaaImaaImaaImaaImaaImaaImaaImaaImaaImaaImaaImaaImaaImab1+PrM1t3a4OWjsbvM1NuZqLS7x8+/ydCMnam/y9PT2uDm6++zv8idrLe4w8vh5uqqt8CquMKmtL6Pn6vI0tqVpLCisLu3w8zf5eqsuMKxvcbu8vWRoa2cq7bn7PCWpbEE1VLOAAAAD3RSTlMAIGCPv98AUJ/vQK+AzzD5yyLRAAACv0lEQVR4Xs3Y55LjIAwHcHAtcQ5wTe/br7z/291BHLJaLIt82Jn7P8BvRiBjEJsID8IoFkPiKAx4goclSNLMGDBxlj4G8TAXSPKQe0PFTExmVnhBPLNA3a/21RiVcRoqh6LO7ytpMl5gSUB8fmXqRhsQgpnzKSjNr0wl7/mFSHmKQ+W1qEZ+Ti2wlBiUGefwIUEOAk0GIeg08kt64SUx6Jz3koKg5EIl4shKTKX8CqXa+fkqH4VECiGu932xVGsX+j0N5RxApg+XSo1JYjrzG2QXaKPUqHQmpPIK2cK2So1LtfApjt12fnFRiERBIrtBxVAYIu0ElWKA9DnWKoVJPQnNrhDXaKdQqRFkuIFCIcSTUqhU0VBooBysEJB8oVxDqd4yDaCSoJMmzOz9s0IkXyj7B+n/4IvCpY/qDw3FCeMaVAqTqoPwCmeBaSJM2gnPBExv/lEheRO+CVkElgjmpIEoKIogoqCIxeYgGk2nnSAxCQgoZprbdKPU1joeErNm256OQLzouhKbyBdyxM4W5lMco04am+I/gNzSOrXsNsdT2z4GuYt9UTZApCG4/du7A0QDxX5SAM9jSJmGpJs/+DF8Iic1nhfziYTCN28KydF8tIGvs5NrBGrNMcL9mEMlJSZpgOujlk413CvX2BLF5vCnoxFUeh4O/9QD2k9Ji+F3lOQ0VElc0u2Y2182kUbi0pP9ZXMa6iUqdfdLRDLz6CFUau/XmqQgoVpi0ubzRSvJaAiRLnrLMnAZnY5EpC28jCYlCbmSLayEF3a6I11p6VzYyeIqOSItF+4TIkmpjnTzunAeNfQy9a6zP488s8ge2CFOhjxFvRtJNshTFEg09HEADvJcpxupORunJAYIFFTV+ADBhs+pjmxqO9Ighyx4R67ez2DIQo593DT7VV8jY5/vHkTRo7HvHtbheWh8+BdrnhJj1yH5ZwAAAABJRU5ErkJggg=="

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAk1BMVEUAAAD/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/2YP/rDP/6Lb/2YP/5Kn/3ZD/tEL/2ob/zm//t0f/4qP/1n7/4Z3/y2r/rzj/4Jn/5az/3pP/ukz/w1v/xWD/vVH/46b/57P/0oX/0YL/14b/35b/0XT/yGX/3I3/5rD/24n/03lq5vFeAAAAEHRSTlMAIGCPv98AUJ/vQK+AzxAwkHLS4wAAArdJREFUeF692Mm62yAMBeDgcYjTCjxnnu/c9v2frjYh4TpYFt7cs8zi/yyQHdAMD3Nczxcqvuc6LBjJDPk9jHxhxI/CaRBzY4Ekdpk1lMzFaOaJFcSiB5CvLrtsiIoYDaWqqPL9wmWGC0wJiC3UszT8HqS+BRuDwvjGZFznC5HiEIdSyZQN/55cYEkxKJLO/sp72Qs0kQlpp+FPWQk7adZzyh1HIELSUIo4PBNjSZ+hsHP+vfKpkAj7EOv2fVnAiwn9GYdi1oNkHxYAQ5IYz0JDaoHOAINSSUiphmRha4BhKRdWxc3Uzi83gEgUJKI7lKjCEGkrqCQKmrdOBYBJKxKa3yDWoTWgUiPIMAm5rfMBgEoZDbkSitUKGZI9FHdQ2G0ZwIgk6IQt1O39JyCSLRS1kN9CB8Cla/aXhvwW6kAATMr2wipMQhVg0lZYxpHQEZC8Cdu4EjogzqkDPCdJHI+CPAkVw059e2YZh4B8CZ3rQWqtHVqSkExVnY49cSOf+BHPFhLPYq0LU8WREJ5EQ8k49Gs6NP2JzNJqKOrz8VRV0yBzsTdwjyESUH/719rpiST03JA1DKZQDUnEc36rV+QEwzmoV8Q2b4DkqF5ay2z5CwJVcgUsoX3GOSapD5tvwWTXlsGkg/rURhaQVDDpU338QwtoNyYt1d9RENNQxnHpfP+DDFwaajgufTz+shkNrTgq1foQEcwtegiVKn2sCRISyjkmnb8ftIKIhhBps7ztvT6MEuGItO4fRoOUhAxJF5YaB3aiI02pMA7sZHEZH5CKpXmFCEKqI828Lo1LDb1MK9PZlUPXLKoHtogTIVdR60biDX4V1RINXffawa/rdCM1pXRSYoBAQVmODhB02ILqyCbXIw1qyIJ35OW9RIYsyNjHTLO7rHJj7PMzgyh6NPbTwzqdaePD/2pnMW3Ia3iVAAAAAElFTkSuQmCC"

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAbFBMVEUAAAAiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkob6Q4hb5Im9lVrO5Im9lIm9klap48icRVrO5VrO5VrO5Ln95VrO5VrO4/jclVrO41gLksc6lSqOkyfLQveK4NO8yJAAAAH3RSTlMAYL//cCAAz4AQ748wUED/////gAD//88gAP/vYP+/DsWGfAAAAP9JREFUeAHt18FSgzAQx2FgTSNoRf5SQmgMUt//Hc3QY9uwwI6OM/nd95vZ2272f0vlBd1UPKkDv+wQUpru91yuglRFj9LlGkgT7ZcClFMszYcKivbChmihnAmVtFD1KgRRdZRZLVQc3wSgiJ/LQCGthCCqlBBEegNUvze4qflo57K2JV6nDvczvQ1l1jKdAY8693wo5gBmBTQglmNDn4jmudCIhZjQ1yQDXSYIQN+XBlgHjfEJLlQPgARUT5CBBshAI4SgRgpCghKUoAQlKEF/C3VEnQjksTs/Qw67czNkDXZm7BXqz+AXOdiDZMAt8kLMOY+NeWftFRIqQb8I/QBE/Q8OlqeIGAAAAABJRU5ErkJggg=="

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAACAklEQVR4Ae3aIUs8QRjH8XkJvoRBEAyChyAYBBdBEAxesU8yWDywGAxbDAY5MAgieEGLIFosFrdYLE4w/YsX/t19CePDcc+xyN4zKOuN4/wGvqBB8D7MrM8OKqy/s7CwsLCwprfPDFVQrqEKqkNpSsVW9RtNWcr9YDk1FSOQpkrKTSAbDRIDjd85QOJnjguQjQWooFygujEAucAZAMmVVAtAfqQ2gPwVQ6gMQGHwDYD8WUoDSK6kNIDkLID8GQDJFQDyB6Akgeb3b93qyYvbvPzvtm7em6ikepSmFKdihNnovTWCItSJEmj56Kl5DBkpHiA6TpPE4bQCjlhP4ViJ9X810GL+EAyHU8CJEGjp8LH6SwJodvdqMN8QjDD4BalQX/0gK8fPAT5EBED81ySxuirkHBJBuReIjlSKMFxbBJrbu04VhstEoLXT19SBtAiUMAynlHTvkjhOXwLiUT/lCgbC3FPfXT0QZh8uF4HWz/+lDtSRgPh9K+UyEUj4QQDRWzuACAdA3wWa2bnADCQA+aZoAC0c3KcO1BWAMEVTeT0QLsk4IwBhiqYyCYj/vSTltACEKZpSnMI9dP1FGafoWqM6QeN4De+BODUcihwaZT4DGaCMsgzD8RcWOINa44A0VVI4WjVAnE50J/V55/iAOJPIg9tWd40EhOIEAhCAAAQg9AEUwnTg5SjoBwAAAABJRU5ErkJggg=="

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAclBMVEUAAADh6O3M1t3h6O3M1t3h6O3M1t3h6O3M1t3h6O3M1t3h6O3h6O3M1t3h6O3M1t3h6O3M1t3h6O3M1t3h6O3M1t3h6O2ZqrWzwMnM1t3N197P2N/R2+HT3OLU3ePX3+XZ4efc5Ond5ere5uvg5+zh6O2UBbIWAAAAF3RSTlMAECAgMDBAQGBwgICfr6+/v8/P39/v7663E0kAAADnSURBVHja7dhbDoIwEIXhgiL1Ri3KZURRkO5/iwaJPtAa6bQmxsy/gC8yOb6U9XEBFgnOzIUSLJOh0cnAuswkSUAkdYcDKv1OAgcJDQJkBP0CVBaTKj9CxcR8Q+6fRjuiHdGOaEe0I9oR7Yh2RJADVDfKoiR+A1WtsmwXmKCqU9algQFqFaJEh2qFKtagBgclGqSQfQ06/S909gVdkE46foi4KuyOhPYHQbVmKz8zihn3cuucsdDLiTbjZ58OCc1G7z41+gf17V/O8Ya8UPCAFq4XyiM2xN2cQ8SezbcApxq3xXQ5fNcdj0/fMnflN2QAAAAASUVORK5CYII="

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAATlBMVEUAAADh6O3M1t3h6O3h6O3M1t3M1t3M1t3M1t3M1t3M1t2ZqrXh6O3h6O3M1t2ZqrWzwMnG0dijsr2mtb+9ydGcrbjP2d/L1dy5xs65xc55loHdAAAADXRSTlMAYL/fUAAgz2DvEAAA8SobGQAAAP1JREFUeNrt0t0OgjAMhmEcsA2VDv/1/m9UQckXYoFtTTyx78k44Um6tUDe0ELhVVtW+7mK8cM6olWobTdrkG0oAoI0CzmKgyDxkKdICBIPmVgIEg9RJASJh7aRECQhBEk6GiQpBEkMQZJDkOQQJB7qwlcdC0HiocDEQJCEECTpaJCyLvvKSTnQuWWqEqFTL90YqEyE7qHvwUyXeNl0DDPthor3sf78dLiIoVE6xkP8aLin0zokqB4q3scfQF2IrluEQkI/geSj6R7pHuke6R7pHuke6R4ppNAUMvmOmUA+H/KA+lyu4+opZJs8p7GAPpLLcZytAY15k8oYj7+fn0YEsL7Tg4AAAAAASUVORK5CYII="

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAllBMVEUAAADdLkTdLkTdLkTh6O3dLkTh6O3dLkTh6O3h6O3dLkTh6O3h6O3dLkTh6O2zvcRufIZmdX91g43K0tjS2t99i5Skr7bCy9KMmaG7xMucp6+UoKiFkpvZ4eartr31+PrdLkTfO0/jYXLvxs3pk5/iVGbohpT06+/meojx0tjsrLb0q7rgR1vy3+PuucHpbX/eNkvroKqbi+PaAAAADnRSTlMAUN+AAEDvML9gAM8g75vGi2cAAAIMSURBVHhe5JTbqsJADEWnLUUQ/IadZC69q+f/f+5MJyBCdbCt+KDrIcwmYTGZQo0pSlKqY6KiHI9ny+Joiluz1mZNGZ7OFqZ8j6g0sexcTbkTnQ5z73DKCDKz5r5b1XWV8+RmDe1jKRLniUJgTa1j4tBuEHGDhgLwpx7gTD3QrhcJAHKAnYMeLOB+SHQZhsuyrhddh8iyflC0f7X9j92kZLeJuB1V5AH0RBQAhA2rnQE7pctYAJPtEAPHkOjG1x5bRdC7cAel8bNVcS+L/ISI5Ri5RzqPaUFFVnw1L+JJYREZN/6PlnyH6L/dutuNEASiAOwF2Wg0/CgOiuD7P2aX0ElZtkl1hqY3Pffz5cRBVDbK30L/kNLmM/OCgF1NGQ0XIFcMzAhtpsr+MwTlAFYydeAm5LAlAXLfQOoNUhe2Bu8Q1I6/vv4X6Mi7KuaIUDApgQ/lU3RwIVSBDcUM+RMAlCVD9TEKjg1hPBUCU+VoBZm9FaQjCVp0mvVOOo+SIkHSApzx5fXdSFCZLUMzG8JKbMgxofaNPOMZOQCLTtQZCgRIJdFHLJQDBCh30Cr1QccsBAhndQganVUSoTqOAh0IcK+RuNbOGm9A+utLFn3VJ8obEJRLtoeuruzrkHQA5cgO4Rl/2l//Y+vbOH03tIGGTowtnFF0Ynrwncf0hMTE7jROIkFCDD2H6YdkfACOvanCMH62CAAAAABJRU5ErkJggg=="

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAnFBMVEUAAACZqrWZqrUpLzMpLzMpLzMpLzMpLzMpLzPh6O27xMt1g41mdX9ufIazvcScp6+FkpvZ4ebS2t/Cy9Kkr7bK0tiMmaF9i5Srtr2UoKjK0dZjaW31+PrdLkQpLzPjYXLfO0/ohpSZqrXvxs3HLkL0q7rx0tjgR1vpk5/lbX306+/iVGbmeojy3+NhLzjpbX/uucG7bH3roKreNksQyM4UAAAACXRSTlMAgABgvwAgz+/+pvxsAAACMklEQVR4XuzU2WqEQBCGUScanYf4qzf3bZbk/d8tVjsjiqHBAm9CvotGKfqArRjtuzh3+Qj0+zzab3BTIYjnfwr6h+JELTGkAm3nSfzpi3hJM6VkEJelbyi9KjHEXdMXlCk55MtmKGbgVtA7hijQZl7cWIo9lLBDJIE4lhIPMVnIoYL3LxCtejr33AGB+RYSFIJM0xJZS76+6cnYQQQ9gN4CszSiIwsMEigHdAM0xAEgvjkJupflfb1Koe9yar2eCckf7fzDrthppZBuiUZA9/DfjqmAh+TRDDBWAGrKAVR5B0AzxH0dOGwDX05Ud1i2vyAcgGhgZ+xpknJmOusPylcdemtGa01zNV+GOuU38lOOme1GCMNQtFJXk2XiLDCANP//mR0l4jKhI9E4L5V6nvzCYUlslFuJqIN/KRqUzhhLhYuucPw7EZvtCuOzJ+gD7lR0vM7igWqaRTGLnFDkjyIjfDWyphLx0aNSw/JDhFcdaEcmsqX23aKYSxPupC7RqHdUZLlo0o9MSSzSNcZ3isAkFW0tDJMVioa7QlnORWYUioi3ZU+6IBQB7ITQLYp/TITJJOt+f0Xfc8/Htg9tMWNHCkQmF7Mn4hnjTiAKaAyHre0lItY/uFCLqNz++uRfNHGTaNzWmUsFVMM8wsR3+KmAsXVCUogR48KOxaXmdDazFzrBhxCYnrFA9HYvVhKz5sMxjuvrQiKWFcd1BAhyPvdIQwoiDYQschCyZBD7tILY5xsY4GgIchUP2AAAAABJRU5ErkJggg=="

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAPFBMVEUAAADM1t3M1t3M1t3M1t2RweZVrO6Zpq5mdX8pLzMpLzMpLzMpLzMpLzMpLzMpLzOzwMmZqrW4wchcY2j00eVnAAAAEHRSTlMAUN//AP////9gv/8AIM/vJR7RlAAAAQlJREFUeAHt1t1uwyAMhmES1h/8AWng/u91rMoUZ6YTzpB6MJ6zcvBKIeDUHEyzbTZPH5zhPyarMr0MzVZlfhmySr+GLlfhcip0regaut0PbqdD9x+6hd7/aNII9d/scY5GaJwjR3jSbjaeyPnCeB8iNtrPETYxfIXCAh7SwLcllFDE30OI3jjUQ491fVimtoadM4Rdsru1sJxcS9iRAZN1oQzGgMupPZQyZKhiLVrW/luow2Z3eP3dDmS3K9Lt0vYbI3ywKcjBVjjSh+So3ZwN+WKERmiERmiEmkPJqqRqiABkq5IBkAg59ieiScoonAj5iBOil6GwQG0JIlSECKUYPAsxjqBAzjOfb5F+fzWCvcoAAAAASUVORK5CYII="

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAY1BMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t3h6O1SgTekvJ/D0NE+ch2uw6y6ysXN2dOXsZVQfzXX4eCQrYVii01qkVmFpH1xl15HeCl7nmvX3+VzmGWgt6FnkFFIeSqpva24y7kitXYGAAAAB3RSTlMAYL8AIM/vi50ITwAAAf1JREFUeF6t2OluwjAQBOCSBmznPrjv93/KlsTeNWyK3QzzAwlYfRkiYUf+GrNI1Mwki+8hX4+XdKmALFMHpSsFZZVaaKnALEdooeAsBiiZD+T5CCUD9ACOekZKUxSmPD4kgmY5xZAShswIGRTqCxsBKUrMu3zvoByDts4xWCMulGEQF9IQVHEhDDpxIQiqCpc7BHGhi4YgrxAGbZyz1gL6T+5cCIMuztlpCOJCNQRxocOvAtxsLlQphUDGOScFQZlz9hUGUaGtgqCGCuUY1HIhCNpyIQjK91woBhr20PYsIC7UqijI7qENQ6+FmjcQpzO0Hv+xJxqaFZCcl1J9pc+joM7OC+kgCklIFpJSTfz9PaTGVMVTGvqOV3xFeQPRPEkWqrhQBMTznGyENlRIR0HrYkpS6saFIiA7LyXvAjsdA/H8uvElr1AdBZ29BdmXGip00FFQS/N2EROpo6CG59W0dNIxUE6Feq0mpX0Vhvw/x7XTY7IXqNcyEuquYp4kvkAY4kLGm89EoSBUy8WDJS4Uhk7OaeXeyit++GZzofMzRJ1aFQVdnLMWw1Y6R0H8tHKTw2VL21MQ4kKB7TIAlVSogiD/8QmCMi4EQOLxCYDE4xMK9fq/mf5ppkMhdxigUeg4HE/Mco4EJQpO8rFjn08dRH3saOyzh3VD8OPDHwCgpiVWYdJbAAAAAElFTkSuQmCC"

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAY1BMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t3eRVndLkTh6O3OwcrNzNPfi5ngrrjh3OLh0djcOU7bQ1fgoq7X3+XVgpHeXW7ZWGrSl6TRoq3gusPdOk/XbX3QrLffdIPeaHnYY3QPX32LAAAAB3RSTlMAYL8AIM/vi50ITwAAAgBJREFUeF6t2OmOozAQBOAhS8YX902umfd/yhVOOmW8SPSmqR+RkOXPJRQw8tczyUl9mFPyx+dr+UnPSpBzSlD6rUT5Tl/QWQlzfkKJEifx0EkOnTy0AF2hjdGF/SDdIr2hwvh8JK0g/YR0KYXMK/lRUJ0trB+mcK4AaZJ6IdQaipNBVhN0E0IFKskgOxA0bkJZxoUuhnL/FyoaY5qZB4WVYqg1PjMPqgxlXkPkmIYH2RtBDaD1X6PnQajU2iBwzLW0UTYhmxOky5WD5DyovGJC5KDSHoRKmAAHlTiQUlmDCWrJZKLUjnGzVxMrcqLceJB6V3qQE6fiQbOhuJUzjQQ9eJB6TxhDp1V3VOJBmBA6NljhhwGhUuTYcIULD3Ibjh/7JWjgQeoWOdNrzKESD3KRQ2NYYdiBKHl0fygVKllkG8KzCwd5EKR3IVSCg1RX+Cyo1HC2V9A7Tz+loPvsg7Gs9gyG1A5kC03bz3qsJ6hhQtaWGVhAqNRzoe0rVKozGaQaVJJBEyqJoPCTTAi12AdEUPhJJoTw/eM2IX6GYB8QQahUySBU+hFCqHQR3OxF+iVoFEIOlWRQsA8IoaCSDEIlLYRcTVIrg/CG00IoQyURFFYSQqgUQf+d/CiI3nBaDNGhwwrqPpL8MUhH0HGHLIkcSo46iDrsaOzYwzof+fHhX1tpqPi+mqDFAAAAAElFTkSuQmCC"

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAS1BMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3h6O3M1t3X3+XRoq26s9iSZsypwKpqmk9ckTvgrrjbQ1fdLkRtnFHeRVmcdtC3zbWZdM7Iv+OhTLYlAAAAB3RSTlMAYL8AIM/vi50ITwAAAPtJREFUeF7t2LmuxCAMhtGQScaQdV/e/0lHOFxMcxUpP02Wr0CiOUJIbpzsqVSfLFUfLrFHlmugPPuDsq+G+mYOyjVYvkNKwymGUhxKGbKAodMZK3mIgC4Aae7UTaAXKteKW0sMKitfCUGrQCsEVUGXgo4LIeLuD+Gf/VCoblquqTGobn01BDUCNRDUBt0D8oUQMGt3gvDPfqGiH7i+wKBi8BUQ1AvUQ9AQdCnoeERCCJi1C0P4Zz8OeqF3+kdxRqJJnIloFmc+hBaBFqJOoI5oE2j7BzKB5N40Ltbt3Jumzt4296Y5cAxDUZcsCodUrEVUtNVY3GUdh68Pf8CRt71hLab3AAAAAElFTkSuQmCC"

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAPFBMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t2Zoqg9REgpLzPM1t3M1t3BaU/BaU/BaU/BaU/gtKf////M1dqZqrXLueYJAAAAEHRSTlMAIJ/v/wAw////UN9Q3/8A1l+fIwAAAO5JREFUeAHt2N2KhDAMhmE1345/bcfo/d/rwrjFDhXNpLK7Qt4jQXgwbY6szqobAqipv06qTt4/CK/oUQbVhLbr+64F1UVQg7Z/1aIpggjdCnWgIgjofwI+h4YRsQTaGgcZNCBpGy1tEEEjkrbDThtFEN6K1//eEeR8WIOgsObdM1bFBxfCJ1DMZZDXQT6Dgg4Kt4EmZoYgZp4OIZZDfDtInkH/CZqXnWYFtOz2l9A1owmzPTptVl5/3u9C5aPZHtke2R7ZHtke3RyarzrsZbfrIf1otkeT3JkOIE03gLzO8RnkdJDLoKdTfFPyk+UbZzUUIqVb/+8AAAAASUVORK5CYII="

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAolBMVEXdLkSZqrW+GTEAAADaLELdLkTdLkSZqrXdLkTdLkSZqrXdLkTdLkSZqrWZqrXdLkSZqrXdLkTdLkS+GTGZqrWZqrXdLkS+GTHdLkS+GTG+GTG+GTG+GTGZqrXdLkSZqrW+GTGZqrXdLkSeoKzFHjWZqrXaLEKZqrWZqrXdLkS+GTGZqrW+GTHdLkTKITjVKT/QRVnZK0LXKkDRJj3AGjKdoq4JhMK7AAAAK3RSTlMAAAAAAJ8Qz8+AcL/vnxAw798gMCCPYFBw3++fz2CvMBCAUM/fQK+/UEBwQ7HxkgAAAgpJREFUeNqt1tmS4iAUgGFgJsR0FhM1Mba7vQt0T8/y/q82pdM1pwIUEI7/hRfG+goOKUrybVS8zxvV7DpOcGWF+lfRYxieKyhBQAkwKKkDBCc16jbSFASc1KsbSZnCSgDhJYDw0vxR3URa3svPW0hnKeW7wktreekDKx028trvnzhpvpLSJ/VhY5ZeqeDE2uxtMOYAqbMo3e7ypElmMGa/tDOY6eT/w+w65jCpMZxCQc8rAHyS5vCLA/2SoVJjXstxUq6dllKRUq/fgpFSwfWdRUoZGZarOCknBhQufcAPEu69TkEye//8OvkTMTqpAAl6zLKsnxJbxRjpfs4gwgb1aoS0ZAYE5eHSmbkgPgmV1kyDIqUN06E4aXUwoCgJDgygKGnJTChGOrMwqHr44ZTWLBBKxR+XtGGBUCmES1odfBA4Tun5uy1ifLMVwiNlJKQnIbzSLMDZ18IvJX6nSoXwS40fegHFJXmdFgyn9OZxXoXRw2T8tGHQUFpxmxQ4aKiklFqknRsqbY5V6pzO1nC2lFqlidNZ6AOqnyi1SsXUCaX6mPcU4nmwc9Scl4oO6gv4w+BqrzktNTpleZ70MwL5N1a/0tGR6+dRH08kNNxYWdFYKBVQvaU0FroTULqg0VBVg3OkNB5qUVMGaIFbDkAlLAcFfS2ovqO4SAvvDg5KLwycOQJKW2AQ/QWtX4Tez/zYtgAAAABJRU5ErkJggg=="

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAdVBMVEUAAADdLkSZqrWZqrWZqrXdLkTdLkTdLkTdLkTdLkTdLkTdLkSZqrWZqrUpLzMpLzMpLzMpLzMpLzMpLzOZqrWZqrWZqrWZqrWZqrXMTWCZqrWZqrUpLzPdLkSZqrXMTWCSoq2mk6C7bH1vfITQRVlFTlR9i5WChz1ZAAAAHHRSTlMAv0CAv1Bg7yDPMIDfn89Q32Cf788QYFCPgDBwURzjqQAAAU1JREFUeF7tldlugzAQRb0RwhbIvtnOnv//xJZG1bilkDD3oajqefHbkXzneiy6STPpPpBZKviMEheQjJiasXTfkGOOJ4pdgzhiXMv9SO/rRa6FqGc+cZso7peTdK1IRkB4TEmXKHndk7pOXu941i3KGFGDcbsnDEn0L8LHjxcSfyL4o8XXSPQLiw1Ytdjyx78j/IPEv2we22uouW4Fl50/nQ8Py+F88jvBxn9B/CVRHnpyQGRCkRmCqAhFBSDSoUgPQaRCkRqCaBmKlgIALDaxwIpNGKyPxIZEG0iksRoRaxKtIZECa0SA0ydymj6GoeljaBoaxupTtAJFioYG0hga+GwXsKigzY+xf4j2sEhR1iCUNYihXmNo6jUeEh7RdDaxR++PdjKbApqysu9cvL/UZ1WyRXNbc/P+ZmvmoMje75ZE7KsRVQmGXfM87DfKfowsa+8r1QAAAABJRU5ErkJggg=="

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWnk4lxAAAAEnRSTlMAMI+//++vYADPIJ9QgEDfEHB5D6jfAAAB10lEQVR4Ae3XQbejIAwF4KCgVxTB//9nZ5A395gdOVnOu6u2wU8aDtKKKb8Jyxr/Jm077BG+2o/IJFJLXIMJymtUOX/0rgYDdCUSSipxVhLeuF9x7vd9L5UScqI0A12DKQ0jhRLCrCS87ZHB7CaJ0Po6DTBLGrrpeCT5mVAAfJIg8wKXJHj6oAyvJNh6hwCvJG+LCtySoI/Y4ZYEvX7BLQkOfjWXNHq0wilx+YNbEmTuEJckwKklZKNEKKevlGuswSIRGuMoFY6zSQIldcgsEVJSTnaJkJKCXSLklwj5JYFfIuSXCPklQm5J4JcI+SVCdun+SFlBRmnDkDhYYJbGAwwfaSFkk+4BfaRMyCQR4o+0k5BJer4Qtv6uEbJIVR1godd3QgapjCuVuxCak1hJDczyTlBglEr8TIifHIRmpAu4Du4QvYiEZiRGn8sXIau0KQeFPZqS6j8mPdA5CU1JrbyTqqWB0cs/KwHhvjMrTO4jLkITEqNTuEV8Ukvj6STwSdwwAp8Ueq2iQy6p1dFqDdmldvTCCg3ZpfA6qWnILhV9rlmk9JBqe418ohgg/Y/+Llvs0We/TdJZM0wQW6uTdsACMW9bmLo3WCHmWtaBbE8AQ8iR/wH6A/M/iJuADapmAAAAAElFTkSuQmCC"

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAYFBMVEUAAAD/zE3/zE3UrUj/zE3/zE0+Pzb/zE3/zE3/zE3/zE1pXjv/zE2/nUUpLzN/bj3/zE3/zE0pLzPywkvKpUdRTDg2OTXkuErXr0ivkUNEQzZ5aj2hh0KHdD68m0WUfkCBiG+HAAAAEXRSTlMAn2CfEL+fgN9wQJ/vn5+fz5Pu7qsAAAF6SURBVHhetdjbbsMgEARQ4uA4dpy2C77n9v9/WZmKTvwQacOQefeRVjsgZPOZ2KIUkbKypNMc5S9tTTmF/Gc6ZHIG95XJcZBIxw37TM4ku0yOQOIcSCmOf3bEn1IdeWyc/q3dNYLIdeO81QJ7BBM+jo70bs05YbBtpuDM6t2Vr6AxOPrdycvMy3JHCwgI+c4EXVS7+1E4qhZUCkfVAtsqHFULapUjCmmncRgJDlqQKHVw0IIUqds6LlnyPZybW5M8XTdGNDiX5N0hQ3CEl2bnbnQLtjlnkmbN7lSOyyLNXAvg8C2Aw7cADiPBoVswwuFa0MEhW9DDubs1p0TJd100l9XpPX/uluBkuQuCk0Ea4ytqT0nINHAnGA5/F+AxfSAlPMprSoIjrWUkOCKVISQ4IqUhpOiEGEKCAyjxLoAjhpD89eGjUwLgmlmYPNLRmjxSA4CQMBghwWEkOJwEh5PgcBIcToLDSXAoCQ6Tuo3nojFcbBX+6BXWfCS/j0GVtkH+A9IAAAAASUVORK5CYII="

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAKlBMVEX/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE0d8jQTAAAADnRSTlMw7/9wAK+fQM8QgL9gIDTMwooAAAD2SURBVHgBjc2xSUVRAIPh4wbiBvcImcARDqiFIM4guMDFAZzBwgGE1zvCa13AcWw0pAn/Tf3xZ1xsN4s2nqYYzTmfjyAxgpSRGEHKSIwgZSRGkDISI0gZCZBTjATIKUYC5BQjAXKKkQA5xUiAnGIkQE4xEiCnGImRU4DEyClAYuQUIFX08tZTRvtHTxm93/eU0VqZqqimEvVUoppKVFOJaipRTSWqqUQ1laimEtVUoppKVFNGe00F+qypQJf/6NbGKaPt9Hf3GkhGZU4hEiCnGAmQU4wEyClG6ihTR5DW+JqcGmdG1+OO0TYerliN9TO5tNY3ocdfkdERr8v5kXkAAAAASUVORK5CYII="

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAjVBMVEUAAADh6O3M1t3M1t3M1t3M1t10Tqp0TqrM1t3h6O3M1t3h6O3h6O3M1t2ZqrWzwMl0TqprZo9mdX+LiLGWp7LG0dimtb+5xs6jsr2ro8rP2d+5xc7L1dx5Wqumm8eJgrCRm7CcrbjBxddpeIKZpq69ydF5h5HG0Ndse4W5xMtyU6WGlqF5iZNwf4l2hpAkXYCGAAAADHRSTlMAYGAgv8/fUO9QEN+speDfAAABRUlEQVR4Xu3Y127DMAyG0ciR7aQhJdvZnXuP93+8Nijgi4Qav8G7+nuAA5AyLECTvwrLkdxvtJhPkk1L5iREZJLOjHOgtFRyDpSWCs6C0pIFoKjEABSTzjCIjAKUkFCIjBZERgsiowWR0YLIRCDvTvJBiEwYckJhiIwWREZjtF7Cl30uSzj0REJzENocpEsBWoDQ1h26EKYDl807Fwg8fl7fKUG83gGQOFrfdpMBDe+/Qd5l56OQA9KH9EfTX/b4HS2vmpOqGj/+ZSNWixDuNBUwWu+IYcveNwAEOzh03yhB1zEIWfZNNuTi3WpBq1ZpNPfQKh3/Y9fqQPwclCoMenkNSTUG8VvXte/SbwS+1z66owZfR59a0OorA/JZ0rcAKd4iIzRCdrhj5WcfvEJ8iMIrxacxvNlUeqzDK4+c/vkQyx7t5we+/eALxAMAdQAAAABJRU5ErkJggg=="

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAADTElEQVR4Ae3cz0sUcRjH8fkDClc81Wnt0CE6SEFBYAllP5BAOnToUEPUQnTIQ5IU0UZRVBQRXaJDlyCKQqNag4IJyaAQRiSkPcRqYAYqA9KhDvH0POEX9fE7s4+th/nOPsF78VDr+mrma/uB9Gr99fP2qjzWhfViFQwcKpp73T7m2aKH/83HAgwyUgXrXAmgFgOT0R7UAuRjkfsIcqTl4kBcs3fXwMSTQzD2ohtGBx8vamj0a9qi10WvNwmpczlAnUk4hBKODNMndq7PH0sQ3VtvP5OEQLmE24o+gWsoPPrLjUPyJUBdcTh0iToMw68k29fYKwEK44C+j7yC8R8zzjQ2OQ3l8UkIv1RsSLYzKZIAQRaAONRwecx6cPOvcQlIofuCjwUYUElAM899F4EMku1KsgIZmBasYmAkQNTU2/POXkl0u0mADE6EgR1IHjzdnMp+vTkK0yOP+FVUFYhwcgYny0Cm3/0HYWJ81CCJgIoWmArmY21ZA6L+9O0gJDFQyHBCLId5FP8DQaEB7uxqhOutjVA60gBT15wDMleSGAhYbQaHAz08kIPCxmYodOyj6GOCWgw0tD89DbQDvNwWh0Rn0soC/cPp6pn/vfRxcxOUz61OJ5Dp3c7Yg3vFbrGpW01QOH6SYxIaB3IKqeZDunxjHZQub4dTZ3qW4vjH4H5HLr23GMtyu9XwbV5Q6fQGehJ3gAbaBUCCfyhKCq5spSdwCYiSAsnfavDoVjM49QTE36yGHObi2RPw7NJu+HZzrR2nXoDkc4cCKVCNe5Ae0gqU8G1egcR7kAIl70EKVPse5D5Qve1BciDdg4RAugeZdA9KTvegqukepHuQ7kE6dyiQ7kG6BymQ7kG6B+kepHuQ7kG6B6Uu3YN0D9I9SPcg3YMyAxToHpQM5OvcEQ8Uxv+XTAWKsLwVqKB7UGhw5oB0D2J5C6MH3YMSgAR7kALpHjRfYAPSPWg+fymQ7kGmkEDsQLoHRVie40hvsSAze9D7PYtwZvsPmyuH48gPaXxjWszMHvS6lQMVMS+p+tmDPuzlt1eIedWih+zvQZ86APq2LMSJsLwYiMrqHkRXDsMJRTgMyMT3IH54Fwevbkr66XdpOpD5mRNgvhTG9BccFSVs41rgpQAAAABJRU5ErkJggg=="

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAolBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzPM1t3M1t3M1t3M1t3M1t3M1t1SWV5SWV4pLzNmdX9mbnPM1t2tt73h6O1TX2c4QUaco6d7g4ijrLNMUlbCzNLK0dZXZGzZ4edbaHFPW2OFjJBXXWIzOT7g5+yzur81Oz/P2N9SWV5ASVA9REjQ2eBudHlicXoxOD3yHBinAAAAFnRSTlMAIHCv3+9gAL9QMJ8QzwC/YM/vIIAALauQcwAAAUVJREFUeF7t2MduhDAQgGFY1gaSmGRTTNveUnt5/1eLmbEMSIm0NnNIIv8HJF8+WSMNBwdt4SgaS7tYxGNdEOt4Ip0apz3oCBi3jjsQZwi4SwhxDdwVi6WqPLRlgVKqoVQ7i3VpW/UKc0LohKFTlQ6tQeIAjdApSqeqBooAEgg91Hbd755AaubEAJIOEFJvMHGp6kLvtb0Ed2oh3Y39nXZ9yKnbeXOlgRC22tQ1CSQfN0SQXP0MlVCug8N35+kMpbkzZOBrnPhQyEgEUD6jgqZUUP7HIAMcAHrIQ79mRTzk/0ce8pDfNQ8lVBAnWhER00AspIGEckigDAqy7N9Bp1TQmYGGrcgko4HOL1oocYO2ynmeoIMQd4NeFHR5ZQrUR7hAe4k71n1jC5k99PEpccdaqJGELbRXjkDHQBBPbKCtmk/C415fGCbDU68saFAAAAAASUVORK5CYII="

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAqFBMVEUAAADBaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/M1t3M1t3M1t3M1t3M1t3M1t3EhHPEhHPh6O3BaU/ctaPFkoTM1t3KwsLg3+DZnoLVuLLd2NnHoJbJu7rZ4efLz9TSjXLHdlzHgW3TkXXVlHjg5+zJiXfCcFjNmYrRqZ7DcVnZyMbQim/EhHPKfWLCd2HP2N/Q2eDYm3/EcFVd055eAAAAFnRSTlMAIHCv3+9gAL9QMJ8QzwC/YM/vIIAALauQcwAAAVBJREFUeF7t02dvwyAQgGEnDthuitt0gFf27t79//+sGFBIpLrK4ZMqRbwSXx+dDghsnW7YE7BISCNTEJloLJzqJQfQmWXA9fcgSkSL+juIGuA+n0xlxbFNcy0lBkqMM5kX0Mp3tScNnRPtlIVDcyVRBXW1kxdOlTUUKohp6JnD2s4+lFTviShIWAhIfaqNC9k+9MDhkprJQqZH+EyzQ8ipu1E9UgvIthpzjgKJpzESJFbN0PC4FkstjVwh24veeEvISgjQcIkFLbCg4elCHsoq/mtVBoMy3lgGgqpmqAJB/I/+B/IQ/vXjP0j8LwLIQx7ykIdEjAVRJIhFOBDp4EBMOihQqgrS9OSgCyzoEgkapDjQ1bWFYjdoLZ3XgXIMRN2gNwnd3O4K5GEu0EY6LLIF8nQIHPr6FvqPWaiWGBTaSIcpx0IqGkOgtdxPTKODfgADUO4+goj0zQAAAABJRU5ErkJggg=="

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAt1BMVEWgBB7M1t2+GTHCSFwAAACgBB6gBB6gBB6gBB6gBB6gBB6gBB6gBB6+GTGgBB7M1t2gBB7M1t2+GTHM1t3M1t3M1t3CSFygBB6gBB6+GTG+GTG+GTGgBB6xU2bh6O3Er7ndLkTM1t2+GTHXKkDGHjbVKT/dztbJydHBoq3UmqfFQFTTJz62bX7Z4efg5+zKITijESrAJj24WmzCSFzCHDPRr7nHTWDbLUPRJj2mHjbQ2eDP2N/BdoZmRKgWAAAAHHRSTlMAAAAAAGDvIL/PUN+vIJ/PcCDPYL/vgBAw779g673+xwAAATNJREFUeF7t0NdqxDAQhlF5E8mW18luNrXIdXtP7+//XBlGYMWGgCUmN0EfzO1h+NlhXThM+soukXDWjkfKqX7cYK6Ace2YmbhQikLiSneXbhZQ2bVFqqWY6WKl28xL2/J33Ek7l0I7eenQHCWO0FA7aelUrqAEIamh58yu3fYTpRQggZBygZD6wMUV9BN6yOwl/KkNqS/7n7YtyFR17mUJ0M4JareaZRkJVN3PiKBq9TtUdGs90dLSFTK96cWdobZEABUTKmhNBRV/D3nIQx7ykIc85CEPeSiigjgRJBkNJEIaSIJDAgUYC4J/B51RQadE0CCggc5PDBS5QVNwHgfg1BB3g/YAXRzUMTjpAo3BGfVMDC4U9tDrU1VdHzUhkKQtNAZnhI6BMB7ZQFPY5+a21+gbKWFC04Pwc7YAAAAASUVORK5CYII="

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAzFBMVEUAAAAiZpnM1t3h6O0iZpnM1t3h6O3M1t3h6O2ZqrXM1t3h6O0iZpnM1t3h6O3M1t3h6O3M1t3h6O3M1t3h6O3M1t3h6O0iZpnM1t3h6O0iZpnM1t3h6O2ZqrXM1t3h6O0iZpnM1t3h6O0iZpkkVXkoNkApLzNHe6JMVVyKorKLm6WZqrWcrbierrmjsr2mtb+ntsCpuMKrusOsu8SwvcezwMm0wcq2w8y5xs69ydG/y9PCzdXG0djJ09vM1t3P2d/Y4Obd5Org5+zh6O3dPs4bAAAAI3RSTlMAEBAQICAgQEBQUFBgYGBwcICAn5+vr7+/v8/Pz9/f3+/v7ycPn4oAAAF2SURBVFjD7dfZcoIwFIDhuLS40MWlRdOqtFFA05aKe8UUm/d/pybgAsMQbPHGmfx3geSbXJ4AIJNdQNf3bcrqNUvBWml0Cat1d/UXpXDrK0GPBQDyD+RQ6yZ/IlNtvtJwzwA8kXAvjUoKUSpV620aq14jsVq1iqLEhXIHY8ejCfW6JCHXxrhTDjkY4ylN7IckN2ZHjxK7D/b+B7nsaGfHFCFbYCpIABF+FhZ9R0dZIaRzCaLsEIIAqOgcEFKBdh5IA+g8EJKQhCQkIQlJSEKXDXnrqeM4c3cPLSe2bY8XbirkRZVPvOt9zaHF2379EbXcGHQcRreug8PNKZlEPoyXm8gwGoWC8Xj7vYoqvNUs9smefW1243EMytABGor3jUbi/0Mf4qOfKd5oWeL/pj/68WEUmYI7jSzDsAR3GnKHDaN8PBbVN/z64l0wGNjF0sAwBimOHoz+KXdKL3hCsFQtC6OpJ7wmc4fbwlzGV7LqU1AFMtkl9QvOnPUXAyUCBAAAAABJRU5ErkJggg=="

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAq1BMVEUAAAA+ch0+ch0+ch0+ch0+ch0+ch0+ch0+ch0+ch0+ch3M1t3M1t1ckTtckTs+ch3M1t14omTM1t0+ch1ckTvM1t1ckTtckTtckTs+ch1zmGWxw7nh6O13slXM1t11oVxvqE1yrFDZ4efQ3devx6qpva1jmUKFpH3D0NFwqk99p2iQrYVmnUV7nmt4omRHeCng5+xklka4y7l1sFPP2N9flT7Q2eBQfzVtpktKRGmaAAAAGHRSTlMAYO8gv8/fUK+fcM8gzyAQYIDvMO+/v2DTzJP+AAABJklEQVR4Xu3Q127EIBCF4QHD2tnNphdw295Se3n/JwuGi4ktRTLs5Cbif4BPRwewZJgNtF88Y9CNCR3UIG0x50IHdwAY41pTSEy7HvPNylT3bZU7KQVXql2bbe1b8Wl/cs4xd05RB7S1ErPQ0Dl5HVTRQJmFpINeSr+e5m9Wan7iFtIIeVIf9nFt+gndl/6S3dSF9K3/pnkHwlTvbpbNpD0gbLIoSxJIPS+IIDX5Har6NV07aRkKYV/u8T0hlAigak0FTamg6u+hCEUoQhGKUIQiFKEICSqIEUESaCCe0EAyARoI4L9Cl1TQCRE0Ahro7BAhEQbtjPMwQgeAhUF3BjqFVjIEmhlnDO0S7g+9vit1cQRdSfpCM+OM0cGY8IF25p+r67bwDZyU/4/7hhC6AAAAAElFTkSuQmCC"

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAq1BMVEUAAAAiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpk7iMPM1t3M1t07iMMiZpnM1t1fnMrM1t0iZpk7iMPM1t07iMM7iMM7iMMiZplikLOswdDh6O1VrO7M1t1amstNoeFQpebZ4efM3OijxN2iusxCkc53nrvBz9lPo+M3dKKCp8NLn95ql7lfnMotbZ1FltNFjsaxyNhTquvP2N8+jchloM7Q2eDg5+xqDrhWAAAAGHRSTlMAYO8gv8/fUK+fcM8gzyAQYIDvMO+/v2DTzJP+AAABJklEQVR4Xu3Q127EIBCF4QHD2tnNphdw295Se3n/JwuGi4ktRTLs5Cbif4BPRwewZJgNtF88Y9CNCR3UIG0x50IHdwAY41pTSEy7HvPNylT3bZU7KQVXql2bbe1bcWN/cs4xd05RB7S1ErPQ0Dl5HVTRQJmFpINeSr++5m9Wan7iFtIIeVKf9nFt+gndl/6S3dSF9K3/pnkHwlTvPpbNpD0gbLIoSxJIPS+IIDX5Har6NV07aRkKYXfu8T0hlAigak0FTamg6u+hCEUoQhGKUIQiFKEICSqIEUESaCCe0EAyARoI4L9Cl1TQCRE0Bhro7BAhEQbtjPMwRgeAhUFPBjqFVjIEmhlnBO0S7g+9vit1cQRdSfpCM+OM0MGY8IF25p+r67bwDRY5/5710nXWAAAAAElFTkSuQmCC"

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAolBMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAzM1t3M1t3M1t3M1t3M1t3M1t3qokDqokD0kAz/rDPlqlrM1t3Uybbh6O3Z4ef8oyf3lxbgs3XWxanox5nP0tDwoTbj3dH9pyz8pSng5+zvpkT7oiTm0rXylBnzlhrQ2eDP2N/qokD4mxvvmSbtsWDrvH3+qjH1lBE16U/4AAAAFnRSTlMAIHCv3+9gAL9QMJ8QzwC/YM/vIIAALauQcwAAAS5JREFUeF7t0NlOwzAQhlGnqR0HcKAsk637yr7z/q/GaGrh5gKpdoYb5E+a26PRL1zJIB2CXzJVmU1kNqUhqGHegU40BHd6ACkJ0FMiSFngoZrNsfrY5hVQuYVy68yWtW/NG+20h84kUE0d0JIkRdAAqKoOqgEsJcgAdd/6tRs/k1QhJAmCEIioJ1ocsEPovfWX6CcH2T78fxp3oaBuFwjt+kLUat22LBA8rpkgWP0Olcc1mQK1CIVcd/vFe0JOYoDKKRc04YLKv4ciFKEIRShCEYpQhCKkuSDFBJmMB5IJD2TQYYEKShTFv4POuaALJmhU8ECXVw7SYdAWnZcRORZSYdArQtc3Pwk8EwJt0DGZS+Al0h/6/AKQSRdCyfhCG3QMOQ6ilPaBtriPVlmnb+6AuaSdXJf1AAAAAElFTkSuQmCC"

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAADJklEQVR42u3bz2sTQRQHcP8AkfwDwuJFBQ9REUUQvCjemksRhUrBUrw1EMGDgktVzEGsVq0JNhaNCibRxd8NTVxFiSmG1BAoBpUgCnoo5mIPijjuE1bEnczsmh1lHm/gS24z8GFmduftZAk1auG1FcPpmJO2E/Z71h26y/qy71h/4ROWmH+DMwgYf2aDWYQO0SUoTpSHsyZxHTojIAfD5gHtuNDCCmQGwTF4OKtGrnA7H8m3WDp3T/dEgwDFeUCbjj304OwpfMCAAxkLAmTxgLZNND1AB/N1LEB2EKA2B4j7WE/mn2ABYkGAGCfc/Qc6nrwxzUrVBqvNv9E56oDs500YgIB4QNnbZegcS4zQge48msUEFAkbyN17aIl1AUKDA1HymL9Ze4sGSMmLYurpeyxAtpKjxtCtBSxAY8oOq6OljxiAolTuEMekgpkkVHKVhIr2siUWRvt8aqnppOOE9ZKvFw32PbeWscJ6XWL6wbF6hYF8y66EAbWLn5nDQpg5WuJARDiRMJbV4vgyd1npGFMEFA9j9nyZXM4d3M4f1aEkGxMB2aHsPVdXe3Ba+SFdataWCKgTAhB3eRVyGf2L+iHgQHjLCwYmIAkQ1LV1KfxH/jkQfDKabb6CwQmIB2SVn+lccVS/Sc/XywiAFD7mF0oJXYCs//ai2K5kdACK0VFDHJMOq5JQuUMSKpj1ssT6NyajTuacMFEGt55jxwdsNj5cwxIXRorT8YNzcm8VOkUVOZB85kDcmYMuMpyYH5x92zMYcSDSvcfyA3R45wNP52cPVFj62n1dL3XCQRp+DRFOxA/Ors0nuPqpyz8H0D1xJcvrTKKKAQcyJQIy/QDt78t5gCaSj7EA2SIg2w/Qkd0zHqDz6ZlfgxQrdZ2vxXSUPN5TmSLgoLgFKwJiPsLdoN3ZU2m8JKAuQO4lcwLqAgT1ZgISAKG5hd8Nx/CDM7DlNA8I059cIIaKGQRAtMQIiICYqhdFNECqjhpYgDqqDqtYgGxV5Q4sQFPKCmbT5QYGoLiykuul0ResOvdadyCDivbimPTZRxL6cOgTiD49d1ti1KiF2n4AVDnhPrcm4/oAAAAASUVORK5CYII="

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAP1BMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTy3+P1+PrlbX20S1XuAAAAEXRSTlMAMO8Az4AgQBBg35+Pv3CvUIVwrSsAAAHXSURBVHhe7djbboMwEARQs75ecBIn/f9vLaVkRLKE2/qtnUdLPuxEYEVW2+mIOr0ZpTdjajUtIFuH2MOQ8+HV6eqYt3LBu3UoUk3hrdgY8+pQpcggVoOtLK/az1Aet1BgxVAOA/0kf4J6/nBTEcPH7JehODkYCTvgY6ApcQnybAuKoRzjPYccwcFI5hUyGAghx6DCWqDY2nKZQ3wTBRRj5QIt4IAc8WcbDhkMxMopFHsfydaFWAyElDnk2Y58qYu5ZIb7GZSqIAmQjlWUCCjJoPSEfBXGT9BVCl1/IVfFcSN0kUOXETJyyAwQmgm7KR1bQHGAcgsoa4W38ev+OJz7F95JFZ7O41SeUlB+gu7noPsEeWUn6HEyE2RVbgNlVdpARZk2kFG1DVT/NvQPpTZQavaJtPv6fRvIK00tDjbC4S88avMA+RaHvx8gnao4Sf9AUQ7FEZKPlPQvdJNCtwnSReYU/YQcSRxygHQU/tKAJH9Jsp5DwZx1TAAESeIA0h2dcajTgAQSHEBod6oXIEjlmFPCyk3Egdi1uxGf9jLJ6zVIh36f04fN+yNXtpnidl1E+es6c/W7b7RcT58U6t2xq7FbTlxJ+Xbmjs1FW/CSmmIjm4VD8nwDy0QU+JzGC18AAAAASUVORK5CYII="

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAUVBMVEUAAAD/2YP/2YP/6Lb/6Lb/2YP/6Lb/6Lb/2YP/2YP/6Lb/2YPjnz3/2YP/6LbBaU/JeVzswJb/5Kn/35b/5azgoWnuumr/24n/57P41pjjnz29U6ABAAAADXRSTlMAYL+/YAAgz88g7+8AtdvyYgAAAQRJREFUeNrtmNkKwyAQRbMvbVyydfv/D622NqO2UIcRAsHz5NMB9SrcyXyqkiummQVT5LUiqx2alhuWa7iq631Rc+IbN4Tp3HuillssLJzOFVVcMUoh5KhXM8KUO6JSe8QLbZoQosIRcYV8i6ReMwRfImHYVxR/a9EOm3r9IKIGEkTUJwIi4qMF0eVO+kZA9EAyGLLB4uAihqTW+IedREmkWEUQ61+RCCS2iL61lKOUo5SjlKOUo5SjQ+fo0/WJhw1dnySCrk8VtTyOyOr6NJHd9UkiuxCTRcIQVbT/1giDFU2xiQijHk2+ibDDJ7/vgwg3DvP7PoiwAzq/7//8RpgC1/eBJ41K9fmm+XU1AAAAAElFTkSuQmCC"

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABR1BMVEUAAADM1t3M1t3qWW7M1t3M1t3M1t3qWW7qWW7M1t3man3qWW7qWW7qWW7qWW7lboGisbyisbyZqrWZqrWqucKqucKMmaJmdX+msrrlboHM1t3ZnoJmdX9se4UpLzOZqrWmsrq5xMv/zE2MmaKzvsaZpq7qWW7f0qesu8Rwf4mzwMl2YFatgm6flmynjIGAjZfxu2Haza7kcIO5xs55h5G8yNHOz9LCztb1zmjP1dTG0NfUs6Shqa+frLS9o5icrbjVn4W/t46tpqV2hpCvvcbVr7rYoojOzMxzgYvTt6rNoIx5iZOGlqGxpqKbkHNpeIKMnahbXF3Xp7O/y9O1kYF8fYCTo66tt73J09vSm4LOztZ0en9mbnOuj4GKgoAzOT5rWVHDloGDf4CsuMBOTlCRhIA3PkMtMzhASVBbaHGjsr2Gk5y/ytHf01IUAAAAGnRSTlMAYL8AIM/v34AA75/PUGBgAGAAYABgAAAAAE2qJf4AAAI8SURBVHhe7dhFc+NAEIbhkQyJF7PZbGBGYA7CMjMzMzP///NadjqS/Mnpma495q3yzfWUuzWeg1Q/z9eO+V4tn+p9yhXt3rUd3e7YeGkzVSqVqwLncbffziwk+j09hCSCPC3o9eFUIsh3Z46dQEmV3J0j8QWQRNBCDJIEelIoIcTPtYDSuAD6HRdIYwLoZaHkCs2fPAWSBJpvNoulXVloKea61GyOkHZnISunWNpTAohxiqW9c73UHIzGOCB5Gxeb9Z5HSPsm+qkJJwel/ZOD1KSLg5KX3tkODkoHpig1xS+b9oxSMheMxjootabT1DRBnINSK5hJUzPMaORgqwFAVntGByChA5DQQUju8Mvm97wFJHB4iHeY0RwchAR7puqzaWq20Dlk4YQNXaNGXSPHzUHWOXpa89AZMySh09IaIFj2WWPyEjrnNEL4+M+bnIRO2NZW0EWTldBZbCQKP9plYzISOleu6mIIV52R0OkQw0LXTSqBE9a1LXTDGJTIudnQ1tAtg9Jqegopftm3DUjk3In7LW0J5U5jXiLnLn3HCrpnhrs/YB48jCmr0R4tr+SYp88GzuLzhOBHo15EUbRsqFdrb+hPml8zD72Neq0MlHfvAziF1tCHBPpozKe1z8Fm4RftDEVJX7/RRHAKrc/R9+jHz19BrnVYj83jD4YKWzSWGArX/3TqfwlwHm0xmaXTbqPAQ/K2IWob8uWOn4M8OeTloFpF6lRqeahclTnVsuRlHVYhh6Ck//D68B+E/ykMAWpcYwAAAABJRU5ErkJggg=="

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzPqKuokAAAAEXRSTlMAIDAAEHDP359A769ggI9Qv0r3aFsAAAGvSURBVHherdfRruMwCATQ2pDExm4T/v9n9z50pa5G0Hj2zkvfjgIVkDw+Uqrwebx/ddv9J0fr/wdt5n8zlIek+UeOSkHguFsloc0dJAYq5igxUHMnJITUnZEQmk5JCA2nJIQOjyRdgzzMICFMX4F6ArUVqCaQkaVhym9BfQXafwsaCaQr0DN2DlmBagy9liCxECrUPsI8ZQ06A+eSNSiqbegy9HKMTeKKFGDGJO8ajgYHwSqZJCQXLCIKwi4ZCWGXTg7Csz1YCHZAYSHZYT5IqEOXKAgHxZSFdId+cxCsyo2E8BVwshAclMpB2CYLtoD2XlJIqn2vrrwO/4m1nkByxgcAR2AoQHHD/dJPRi94Owwg3JZ24t+BEkIo+VXgeVFCSHeHtDdljhJAqeTXVJHpGKsA5ZL72IYHEkIoYVACiJYAIqVDQ0i0rUgjhkSWpJ5Asi1ALYPktPtdSiGp91ueQ6LjLlQBIhtVAIrK40uDy5llvwNJ/97zLYBgUVvumN6EpLQvDwRQTF2x0wSgLL0lTg7hbbTwGwGhPGczuAsxlKc+x3sGjzEVztEy1//l/wAmDJ84qyt3wwAAAABJRU5ErkJggg=="

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAZlBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzNaaFuyzqPG5bOt1ZafzIS326Gjz4rB4q2BuGF3slWayH6836eo0pCVxXiGvGeQwnKy2JyLv218tVs8RUtebHZmdX9hLzjHLkLdLkQ0LzSElNPdAAAACHRSTlMAYL//ACDP71kzCuAAAAGLSURBVHgB7My7FcAwCENR8bVh/4ETrRC6HG4hdQ9r/ZeoDaj4C+6RNpTBUBwbO+HwNBpKh/Bv9Wd1WRAoOz3CkoK56pFiA5we2tCGHvbJJldCEAiD+5a/AoWW+x/0jfrNxIXe4Lkpk65U0A630BJCiD+kD/I1yJ/XZBY/WARpz6EC1C8awHINVoBsG9BNkPYYYrjnL5zgrkFg8Wi2F/cmSHsMRfpYfkjsW1RoMGo2m2VPJkh7CxVW4QhNmvlxrDF3ylHobIK0t61lxg0LaYXLrsQDfZog7SnU8jkS4hm6ThTPUG5nQZD2FCozdFah0cOkaWmjUmyjDjZB2mNonTB+qEDSB+8w3WKB3gRpL//I2w1Zyz2e5idiFO72/+3/a7/scRAMoSAoeIz36/0v+RkwWIh5zRQmMu0mkwAFu0cEisAvGygRUwTUmikC+AuRqH2gci8zj8zwt0hsi1SZ58CXSG2LVlnkIJbIvlBkj3zBi5Cjdeay+60xz9+4UcPNLGz4PWGmKMDPiY7oiC4CC6ar1PnhEgAAAABJRU5ErkJggg=="

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAclBMVEUAAABmdX9mdX9mdX9mdX9mdX9mdX8pLzMpLzMpLzMpLzMpLzMpLzPM1t3M1t3M1t3M1t3M1t3M1t3G5bOGk5y/ytFse4WzvsaAkJpzgYtXZGxASVApLzNbaHExOD1icXpmdX+EmI+6162zwMnM1t2ZqrWWnYmKAAAAE3RSTlMAYL8AIM/vYL8AIM/vv2AAzyDvLmapMAAAAbZJREFUeNrtlNGOgjAQRQdBARUEFXUBV8Xh/39xW+I6tlamaRp92D0v7W1yTzKlCmPkGY6Q5asHYPWSskCGorQRlWtkWZcWogItKHhRjlbkrChDKzJWhIJrP8oVBVainsGr6J2j8bxfdNVH0XC+bG+iz4+m85dFweQsmAThDZEtoR6EYTT9PZpG8ogyD/UgjGZ0MotCyixKD8Kp4g4pc6g9CNSTYMiXbqPRXcZNAUy0m5P5sjEwbpqA6bQzibqzZFshVlux0ZNRtDEyNHFg6FJyEFU4UMk9JQcR3pB7Sp8Q8aP5v2z/n9/hQZpFzE+EE/H8ixR2e8T97mkVHHoDh5ci0RPNp1XQG3kpwoEvfXUV6au30bxdtr/Pz49mT2/EYTRGZHnZ/Gj278iMwzsy43U0/5fN403kbTSvl23G4R05PUh9ZS67Vh117fZXW0OjiprG7c+/gfb46Dm2lDnUHrTfJ8qn75Yyi9ID0TzevcJD2Qbqgaw2tYx1I/eUbaAeJK1CIrILCcTqQSyyCzGki8e8SClzqD1I50vKy3lKmUXpgWgu7l7hoWwD9UBW40TGJJZ7yjZQ7wdMkksQ4MiwbwAAAABJRU5ErkJggg=="

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABRFBMVEUAAAD/rDPM1t3/rDNmdX//rDNmdX//rDP/rDNmdX//rDP/rDNmdX//rDNmdX9mdX/M1t1mdX//rDP/rDNmdX//rDNmdX/M1t3M1t3M1t1mdX/M1t3M1t3/rDP/rDPM1t1mdX/M1t3M1t3/rDNmdX+ZqrXM1t2ZqrXM1t3/rDNmdX+ZqrVmdX/M1t3M1t2ntL2ZqrWqtr6IlZ6ZqrWAkJqZqrXDzdSqtr6Zpq6DkZqZqrWZqrXM1t2ZqrV3hY9vfojM1t1mdX+ZqrWZpq6/ytGfrLSsuMCmsrqMmaJse4WMnaiAjZecrbi5xMvG0NdpeIJ5iZP/rDO8yNGzvsZ5h5HCztajsr2Dk52su8STo66Wp7KAkJqGlqFzgo2JmaRzgYuGk5zJ09uTn6imtb+fsLqzwMm5xs52hpBwf4mpuMLG0dhsfIa5w++MAAAAQHRSTlMAEIC/QJ/vz0AggDCA77+fIBBgIM9Q30CfMGCPcK9wvzDvEN9wMM8QYI+PYFDfr6/vMDBQgICv79/fr99QQGBgR+Bl7gAAAylJREFUeF7F11db2zAUgGHFcZw9CSGBhFCgFFro3vPI2Yu5R+ce//++sWMryJaOcXLR7we8j3QkOUD+R/GYUS4+rTO7Z5UMRaaCgnvjgtNQob2rVQITQ4FKODjMllamn5W9tByZtpmQpzSfTg1Lry4RvEgSldQCtdPSqhOIDQe0kbNmHAgbUFI8p7eUqzDPL8I+rsgVaUV0dg80ShFqcXyJZsbShttZfk7dFTbHE04yKTlrSuacDJRP6VFRqSiTFmOhsH3y7M2EnE4GqDhtVXTy5poqoiUVgcpKZblvwOi8AoZqQIvOBckhqqncUwmzLRlmkIcUBglLuKW4fZI8tAVwiEnpLJlTikpmtDtzSfbd4q5SCQDaFCtfBKMF9kVJGqQBcZ+mMgA0UKgBo16zWx4RQXcBoI45HbDaIkbGXYxZe+Te2xoAPqQe2LHPboiQnGvYYNS4PhQzz908tbAb2kagFtsagyrmRTDfHWsOzNreDpTZCzaHHA8QAVT3dp5ZzyUQYW9MAEEbdZoHrR5NEawSYEtqcRu/jUpg9QVzrOavA213PB2qLSFQ1ZaacoeVR6AFsPuEOp5jWgfx5pjDp0qhDLAOvB1aINLWgPVF7rASUqgM43qeDtWiMmgZxm1/NJ0adtvTRFYRxg3MgeMPOYqNmx84c6ZYErSMESEOuqQbTqld60kQ/OAU4CU0/C75k+Rvt3TDj4S/OK5mB2Hwj0CRlwa4hEA3j3ipfjjZkG7e7zuk7TYCqXJH1799Br5Wxzd065U+7NgpDQ79Qi91s+MjcFTzN6NHulXfJdWFT0WTbOy+zqR9cNb8eO33/0S/0ndw1XJSWhZZEOvrZzfV/MQ5kgnd0fn6P8BdvcGG9eIhcmR8X49A1KBZq9UOni4TSbqg0z8grjpHZL3Rhf3eFzB3GYOPiK9/us/NvVrOEKzHXV3e8T1FUaoLirJeIl4l6PtLCXN+8jdBrt0qpXRn98O5Uzk7+en8Gw0vSkf92r340O0OvbNu9/Li/Y7oJwzvNvqV91E2L3XyWeJLSsv/5fOZmhIwKZVMUDTBbzCfiJKJU98lRm2q5L/0D2KFqb3bek8RAAAAAElFTkSuQmCC"

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAADG0lEQVR42u2bQWsTQRSA8xP2qgcJogcPSvQgFAUX6lkKHvSYUw/SwkLRi5WuFQPFllQCDRHLIpS2iBiIiuihW0F6qLGLSpVSS3/C/oTne4cJsSYzu5nurpl9D77TnuZj5s17M7MFDg4ODo50o/3zwELsxuprd/zuDOEgVt6llBAXCRBYbX0ElNJNgFh5kzKGeEiIgODD5y8kpBfN3Erpxl2ok4x+2CZKKSJV5BABGf72N5IgwzNJTBnxEYhKzVsnCSqsYZ8trlhCcZl6+CSKoPKw7kJeXCGK5Dz8yZrqFbGMdPFevY0qKMyVGEGl9jyqIKL0P+cYD4HjZuL+4ziCnEwEHFy4biF2Fw7iEns3x6taEtTbexy8pAZKVBG/ixABFcH7TUhK0JuNrbiCfNngS/EGqs/u7NPE5BDYmMYVBP1mBUmBNNkfvaUnQKNAVGAdFRQgkDbf6yvJClL3X+q+jJZUFnJ+j9yAr+0fqQuaml2AiemKUpCQU0QgC35NPkhcDtE98PnldWi8fAdLay2VJFcIqiJgwPJSCrpXWSQ5HSpLLyIJOsxK0M6n7VQFzTVWhBwxi6SCxJYOGeWfBGRIm1QSIuQIKB/1b1qpwMtK0N7tO6kIEkWiMzNHQv7BXXzWv1ik/GN4ghaCaKb0FPSotiwV5GckiKrnVAVNz9d7CaJdjQXhYGkpsSAWxIIyyUG8iw26i3EdpKiDuJJWVNLci621uJvX6eb5PEhxHsQnihGPXIUkn8+k/8LmWw05Ft+LSSjEjY0TF10EiM2Tl2Dr1OUO7dMjsHPmChDB2auwe+5ah/3zo2DQzapa0ID4Ee/mw2G9mydBTQ1BtvGvO2gWDCjnMBfvg2igAwqq5uKFmc7yMv2NIsmxBhWUi1euNAs08o/B76T1Bflmv7TXr4F8w//V0Bdk9t8++kWib/b/YvpFom/yH4f6RSIJMjr0i8QwD3IsDUGQB0E2AhrYLEiOw4LkNFmQnNB0QUUxWN7qJYUi56BklllQyEmQpHJcOYgo4XMjaSxC20HfXYWcXIhyj+AgpQIHBwcHx7HEHzfEqQGNodjFAAAAAElFTkSuQmCC"

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAq1BMVEUAAABVrO47iMM7iMNVrO5VrO5VrO4iZplVrO47iMNVrO47iMM7iMNVrO5VrO5VrO4iZpkiZpk7iMMiZplVrO4iZplVrO5VrO4iZplVrO47iMNVrO5VrO4iZpkiZpkxe7MiZpkiZpk7iMMiZplTqetCks8la59VrO4iZpk7iMNKnNtCkc5SqOklap4yfLQ8icQsc6k1gLlFltNPo+MveK5QpeYob6RNoeE/jclJ715hAAAAJ3RSTlMAIJ/vcGCfcL9AEI/fgI8wEK9Q31Dvr9+AzxBA7yDPn7+fYFDfcO8oulo0AAABg0lEQVR4Xu2X2VLCMBhGuwASWgoUUVkUxeVP2NyX938yawb9pBknSRuHm5w7bs40hzb5E/wPHo+n05wPOR8e1bNMu+P1lksG/aqSsHkyI6JHvuOqkuU4OyXJB//BenW9Rpu+WW8gGvWt0rZmBOieA35mnDYbE8ADWT1S2JBpAQqZV+rs0qo87IsuzNKqPPMS50ZpdSvD2tS0GrZl0cAorcqmLBpp0moTqZF63TYZ86SKruV6kFaL+lrj5c7IHLRWa3fJmhdVdBmEZM+bKhoGDbIHAhC0XYnoYCIvOvzf7+yFdPaJOPtonW0jzjY2l1stNv9W/c0fx9E71TqOgBCr5U31AxKIAhbWO7IhQv4qQwREOfJXH2vSQpTsTwNUadCKClE8+a2exKvlq/3ol4uCqKwWtzbDKNYmFvAsREGK/MbjMRNfRLvVTSL5kyG/+cCeSFOc5IzlSSwE6iO/9gqBKADJwDTTXWrwTCD5424zv9Nes1gKTcqCOuSRdKVRHjjA4/F8AlR6dvqCJI3gAAAAAElFTkSuQmCC"

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAWlBMVEUAAADdLkTdLkTZnoLZnoLdLkTZnoLdLkTdLkTZnoLdLkTBaU/BaU/BaU/BaU/dLkTBaU/BaU/dLkTSlnuRUD21d1+YWETBaU/ZnoJmIRNtKRqKSDanZ1HdLkTnEj0EAAAAE3RSTlMAcN8An4Dvr1Agn+8Av2AAzyDv8Ebb4gAAATBJREFUeNrt0cFygzAMRdEXh5CQAIUaUtXA//9maTYuE8uyAot2yt3Kc0YjQ+xgpskc3qQgPbhOj64qiHdkCaKTKEFyUiUITrIEwUmWEHUUEmKORkLEUUngHZ0E1lFK4BytBMZRS2ActQTGUUtgHEmSodOU1EmEprTeReicBp2jkLTdz9kO7dAO/ULILB3zMnRZQhcR4iXjGeMdARL7v1CR5fTUZyR6Ks+KIwrP6CFPFcgolOMdR6Ey5BRq4KGBQuWgYCMPjRSMgSwPWRVEHed0pIOsY05tlRD1YagnLUT3kHMnARIl7+gh6t2ScT0JEJftFv9lSYR4ahzcY5lh9IwAie3QDv0l6GOjtoOqbZwK9TZQjbLZwmlKlO1tvXNrZ6hsm9X7tOUMzdXVqjvX38YXDMKgPska+mcAAAAASUVORK5CYII="

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAaVBMVEUAAAB3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slV3slXZnoLZnoLZnoLZnoJmIRPZnoJtKRqKSDanZ1HSlnuRUD21d1+YWETBaU/BaU/BaU/BaU/BaU/BaU/BaU8o4J7DAAAAI3RSTlMAcO//30AAgDAQr7+fUGAgn+///wD//////////79gAM8g7w3brksAAAE8SURBVHgB7NFRUoMwAAbhSNog1gr8GgjU+59TfXEGuyEkT3Yme4DvZc1uT4397XR2exm3U2s3PZdCXbOFXkqhs/1ThSpUoX8IXeyh2hTU2WNdUpB7PQZdASqR3hxAIOU6DLHEDkMssZOGWGKHIZbYYYilTIchlthhiCV2GGIJnAIIJHYYYintMMQSOwyxlHYYYokdhlgCpwhybWPt6eqyIahzUAnkHhXqh1F3ve+ku8ah/zA9MCkIqN4Monzc8aIGM4qa4tAkajTC5jg0C4tAIQ6FLEhLzFmUBwXPjg+ZkFaGVuVCupFzUxoCCZwSSKvfMn5VGaSwbH4FlULf1Dz5H8RPMzBJiHskqEIV+vxqZT4IAIBBGIBhpG/+RQ4PNAJS0ovQeTDsRBy58VijvPvzspHi6+Noo0VcGlDrAz849ksTuXkIAAAAAElFTkSuQmCC"

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABoVBMVEUAAADZnoLZnoLZnoLBaU/ZnoLBaU/ZnoJmIRNmIRPZnoLZnoJmIRNmIRPZnoLZnoLZnoLBaU/ZnoJmIRPBaU9mIRPBaU/BaU9mIRPBaU9mIRPZnoLBaU9mIRPBaU/ZnoLBaU/BaU9mIRPZnoLBaU/h6O3M1t3h6O3h6O3M1t3M1t3Q2uDM1t3WqZTh6O3h6O3ZnoLM1t3BaU/ao4lmIRNmIRPRlnvXmn/ZnoLBaU/M1t1mIROZqrXh6O3Q2eDVlHjDbFLN197Ym3/g5+zRwbvEcFXbrJbZ4efTkXXV3uTezMXh4+bd5erUs6TT3OLN09fYoojbsZ3Lz9Tdw7htKRrOzMyDQC/FkoTMgGXXqZN8OCijsr3O196RUD2crbjdvrGYWETLjnTY4ObGc1nSvrXf1tLPh2zKfWLao4nDfWqmlpXCcFiwhXzg3+Ceoqi6dWLLyMvHdlzDh23Jel/f0cyjmpzXpY2zwMmfsLrJ09upuMLg2tnCztbTt6rWrJm8yNHc5OneyL7HiHLBgnDcuqrap4+/bVXSlnuub1jQim90MSF7J/5JAAAAOHRSTlMAECCAEN/vzxDvvzAwYGDvn59Az89AQDCvYI9wUIBwj9+vv1CAYM8Qz58g72DvMJ+vML/vIJ/v71CByqsAAAKeSURBVHherdSFWuNAFAXgqQpQCoUCiy4s6+4zkSrusu7u7u7+1NvSTJpym7kzCecB/i9zvnND0IQilMbSxG8CTXQtIZ9Oc4RaaQr4cVpT1E6k2bszROvS6rWeGF2XNk/P23eYgsSC6s5Wc3YZSqktqs5+s5xVAKnuYPsOcy037wBIaQcHd8+Z1TycAJDCDvZoWmHStHKZA+o72KlVMs2lGf48xR3s2qZVky1Z0vsJLztI713UrBR4UbM/1HfQR+mrkxrPNV7UV8UdBNpoOUtjtrRgP09pB0F+XB9tKWs/b1l+B+kU5fnEi3LsYFV2B33UkSVelGMHL+R2METrUysqWxLM/ACAQAPztlT4ItjB+saDFOTsItzBDAqRqwCqFAV38LPemQIdnftNYcawHeTyANJPPKMw85pwB3/zDEK6/ocKi4I7OMNYQ0i/SAVFgR0UnzI3SBcUBXaQG2fukGtR8H9QrscFsiSkKL6DacbcIJ4rgqL4DkoLGg7pp5CiJs25rCYD6f+Qoi4UNAySKur1Gw2H8KLevjMMeQgWxX/mH84bMhBW1I3PlwwL+iWEsKK+GQaHviOQqKjic8Yh7IuEReWusxq0gnQkKGoqzxzQaUkIFnWLsRq0wh0EgkUVbzMH9OQuwyFYVAUaZw7o3n3mBdIrEHNADxjzD700Hj1mGwExPh/fEEOhHm/QMIAy3qB+ApL0Ag2SBmlJqELRLtIw8RE1qDNM3NKrArUTQZIJWSi6iQjT0iEHbe4mSOI9MtChMMEzgEOjRCqZhBiK9hPJHOkQQZ3dRDrxo+5Qe5ioJOkGDeIAPBgIwaPAEx8BED8K1fQ6IPwokIPhEHoU2MFwCDsK/GA4NBwm/jJQhUaJ72SOUXq8i2xAgqFQEAf+AwvqnsSdzdUoAAAAAElFTkSuQmCC"

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAjVBMVEUAAAC9ydGZqrXh6O3h6O3h6O3h6O3b4+nb4+nM1t3M1t3h6O3h6O3M1t2drbidrbizwMmZqrWzwMmjsr3Cy9LJ09vM1t2mtb99i5TZ4easu8SzvcScrbifsLqrusPP2d+ntsC5xc69ydG2w8y8yNGpuMK5xs7h6O20wcqZqrWrtr1mdX9ufIbK0tiMmaG12OvJAAAAE3RSTlMAYL8AIM/vzwBgv79gAM8AIO8AOTCAGgAAAZ9JREFUeNrt0V1vgkAQheFRUQsqIpa1VVq/2uIW2///8zqmIedi5FwAF03De0d284SZlb6+/9t8VrRoNh9pMhoF46Jl4+AGBZOidZNAoWnRQdMHGRSdNJDhpQvnMhTvmfRZVl2/mOO9eCqV6Js6ClGJQ3BuEJVKPhocL2tINdBjYbLOWjJIHOJOJg4Sh7jjxEEiEHc2mVMIEl3203Ots1VDISqVaEcdhYhEITiAILHRiAMIElk2cQBBIhBxAEEyEHUAEQkQcwBZib8aHANZyUJX6ihEpauBjAOISTszGhwKQTJRBxCXuAOIS9wBZKUc0n3nxSECbb2HZBz2R9aBZB22I+tgOjsXeTXjbLFxs+fqCoHg4O2Mg0sMwpVKet3/MvtXHBkJkHEg+cPxdDoesOMaSe44+EY4qpGk1oEEh1wW4kCqjogkxNHOecXkb84xSZijZedNrsr7R+YclYQ4JiZJM8dKYpyGkhinoSRRGwdSJCGcNlIoixhOcyleyjJZwWkqrZJU0jSJ4TST4iRVSAujNk4ULjRZdFAP9dCfg34AbfT2ddwnF+QAAAAASUVORK5CYII="

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA6lBMVEUAAAC9ydHh6O2rusPh6O2ZqrWZqrW9ydHh6O3h6O3h6O3c5Onh6O1VrO5VrO6ZqrXP2d+ZqrWZqrWZqrXM1t2ZqrW9ydKZqrXM1t3M1t3M1t3M1t29ydLM1t3M1t3M1t3M1t3M1t3a4ufM1t3h6O3h6O3M1t2/y9PCzdWZqrWZqrWcrbjM1t3G0dierrnY4OacrbizwMmrusPU3OPd5OrP2d+ntsCpuMK9ydG0wcq/y9O5xc7CzdXJ09vh6O3M1t2mtb/Czta8yNG2w8ysu8Sjsr2vvcfL1dyisrxVrO6ZqrW5xs6wvcefsLqcf3b4AAAALXRSTlMAIJ/f758gABAwAO9wgAAQv6+/QJ8A33AwIHDfAL+PABBQn6/fIEC/7+8w7+9qqYhuAAACWElEQVR42u2UW1faUBBGTy0WLyVUC5WLEBB7URtIkIJiwxAuVgf8/3+nIXPw5AwLk7D60Ifst6yc7JVvvklESkpKyn/N14vLUXwye++yWZHd5GBvlJDM4ZE42uAwM0rM8YHY0cP5KHLPIXKGkT8e7cIn8axhGCft2+Sa3sMpF31GTG6y2njKo+1jYlOni4gnoqjzHhOaene44oyJSjBNZvrzhAEfmKgCsAhMVrxUS9K8fDkX5xo1kCaMY7pr4wrbgbopzDANgPimX30MGFgATSZqQmxT716mGoKPaYpcaKuNAsQ1/aZU6Ljg0/JF4a02qiAZ2ujzsE1z2yXN2IKAChOV4BUvMN1v+SBkqglIyixaBaJMtDoqFVE1TX3YNYg2dbRURJ1ErHxu4qujpSKaJGLlc9OyF1odnoowmagOjBmu6K9NvSVPRdS4qAoa1hyJfifQ+KmIBehUmKgMGpMgmFR1u31UDEGjFIhysnq9fHBnlMKbYxi6smU2Vf7rQq5ELVB4LzRU3zhGgrp6JJ8LigIXgcKh5zy6sKUm6GpAX7xWvh5NlS9fYuCCZOI4ztSTNyndoxI1SKTK16dsq250LJuqU+WTiJfvyilYsI0hDdxT5ZNIL1+25MAbLMjkyvKZiMqfqr/eG8xkdVQ+E7W0KUdA52ZUPhPV1r9FewqRuLRmq5PfNkVyyh7EwKPqJtAyueg7248IJjTwH40N0VlwYwgxoVqurotrRFGSv0EcsylHVXcjPVIkub6aQhLc+X6+yEREufAT4lMtlM0wwtydVJSKUlEq+peiv63H/jUW8VT5AAAAAElFTkSuQmCC"

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAolBMVEUAAABVrO5VrO7h6O2ZqrVVrO5VrO5VrO69ydHM1t3M1t3b4+nh6O3h6O3h6O3b4+nM1t1VrO5VrO7h6O3h6O2drbidrbizwMmzwMmZqrVVrO7M1t2byu5esO5ntO611e2mtb/Y5O2su8ScrbifsLqrusPP2d+ntsC5xc69ydG2w8y8yNGpuMK5xs7h6O2Kw+6t0u20wcqZqrWjsr3J09tVrO7NANlFAAAAG3RSTlMAUN8Av4AQn2BgvwAgz+/PAGC/v2AAzwAg7wDgTs67AAABwElEQVR42u3U2W6CUBSF4Y3aVqlTHXCgg8U6dhTh/V+tpzF1ha7kLEJv/e92NvkCB4J5C2r5uVow92W+ZZAXCipDtSJUqwzlf7pAF+gCzQd5qa4UdJ2XayDv6KYcFDBUSboTZwRJORKCpB2GRsOPQp9+56t49XBUd1m93u64iSTtoE77B2p3aQHJ66Bu20E9zEKCQ/VurYlJSXC4pjUOWtLOoWFpqiXtpKmDtKSdE6Ql7ThIS9px2VFIJZ2jZUIq6WQWK6mcE1uspPuHPH988jqLLHYQSdRzYWIncYaDtCSdE6Qk7QASknAACUk4gIQkHEBCUg4gISkHkJCUA0hI2gGkJe0AYkk7DLGkHYa0pB1ALAmHIZaWRYmdl7gUlKQpJHLEHZEDiR19RnDwdPxc+q3BSXDifM6J/I7g4N2xg4sYYucsrdYnZr3CiiRA5EBKN9vdbrvBGbMEiNeYEa8wA+IlS7xKCKIVSbTifzYv0H75yyxf3eiRzOe4sv1i6ZS398wNPsk8DuWTTDpaAqQdLRk5FSULyakkhdYip5LUsn6kHS1FYxtPZ8rR0mw6sclkGglHStF04iBXK/yPE7b6rm8vfvc6pk0gLgAAAABJRU5ErkJggg=="

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAgVBMVEUAAACZqrWZqrWZqrWZqrWLm6VvfIRTXWRFTlRhbXSEk52ZqrWZqrWZqrWZqrUpLzM+RkuZqrWZqrV9i5UwNzuZqrV2hIyZqrWZqrWSoq2ZqrVodHxMVVyug5LVPlLdLkTdLkTdLkTdLkTBaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/XqwCMAAAAK3RSTlMAYJ/f/////////7+AMAD//88Q//8g/+9Q/4///////99QAP8AgECf7zBw7mZBCQAAASpJREFUeAHt1M1yglAMhmHQD1RQIxRF23JQCvhz/xdYNj0VJAFmGKcdz7PK6l1kJrGMQezJFBXHnc0XHiT+crVusPRkT6E5M9q4EAV2eyj0UfMW0dyByN+2hFYBGrwNRTuI4v1DKJzigRMRuZDZzVCAFh4R7SDb10NLtFoQRQ5E8fY+FMZodYiI5pD596F3MD6o15p0KAbjUIU2kAW/oT1Yn1XJg2ylQxOw3Cq0gGypQwFYHvVYtw5BQBV0GD0U/rnQ+tVDiUpZx1OWZVaW9QklqejUO6Tk0LF3KO3w/JAaK5SMFUKiRggxTOiJITX4RBjJ8KPlSmroGzE/m/PVkIusnGVCJmRCJmRC/ydU1DtFd4hTni8/lcu5zLtDgmt5K4pbec1lckj2QqFvK5iD8V41oWYAAAAASUVORK5CYII="

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAgVBMVEUAAADdLkTdLkTdLkTdLkSZqrWZqrWZqrWZqrWLm6VvfIRTXWRFTlRhbXSEk52ZqrWZqrWZqrUpLzM+RkuZqrWZqrWZqrV9i5UwNzuZqrV2hIyZqrWZqrXVPlKug5KSoq2ZqrVodHxMVVzBaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/0nkHRAAAAK3RSTlMAUN//AGCf3/////////+AMAD//88Qv///IP/vUP///4////8AgECf7zBwIJnrPAAAATRJREFUeAHt1MtygkAUhGFA0QYBzREIimAugJf3f8DMwhDOOAypqZQVq+Zf9epbtvPEud6sz3Pncs78l7kzlmsMeRzyjKGZlB7yF0uIgnAVxQlYMrTevLCcwfaX6AtWtA11EJD6aijLwXotKAp0EJDvFNAmhVSypWKvhVAe7qBsibuCgijUQoAvQykUJUS0V0MVbh04tIaymKgIlFCNW+VuCGUllB0LokgBVTX68iH0hpHeiShkEO7yB1CJkY4C2k5A6Q90wGgfQkr0EDY9tMBooYDiCWjdQylGSwQUTUB5D0ETiSYg/DmU/TNI9CjIQhaq+FebQzX/anMIdcW+2gxiGUEWspCFNH1KNZqcRtPzQBaykIUsZKGWO60x1HSn87dyPnWNOSS6dNe2vXYXMc0h3oOgL5RMcrPT7QU5AAAAAElFTkSuQmCC"

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA21BMVEXBaU+ZqrXdLkQAAADBaU/dLkTBaU/dLkSZqrWZqrWZqrWZqrWZqrXBaU/BaU8pLzOZqrUpLzPBaU/BaU+ZqrXh6O0pLzOZqrUpLzMpLzMpLzPa4ugpLzPM1t3M1t0pLzPh6O2errmntsDh6O3BaU+ZqrUpLzO/y9PG0diug5Lh6O3VPlKjsr3J09uerrnM1t2rusPdLkRodHySoq2crbjCztZFTlTU3OO5xc6isrzY4OawvceEk53d5OowNzs+Rkt2hIzL1dxTXWSntsCmtb9MVVw3PkPCzdWpuMK4O0NVAAAAJHRSTlMAAAAAgFBA3yBgv4DPMJ+/UFDvcO8gYDCAMCCvzyCf7++v759zct6wAAABtUlEQVR42u3U127CMBSA4UAz2Ht0b5sREvbo3uP9n6jlJMZ1CMcuIFWV8t/ZR/ok++JoO1vqTyDD6i+yjLiYFlfO6AsZa0OWCFlrQ/1AEmhvN08pnUzeBrdELAil67EfaTGh2iHlvQ+GGERIJrkC2s9TsftHDPoulQiDiid0qechCpFKYRmq0bAehqshKBmEipSiUhCyiV9hAVUv2ljNcKjFoErCh6qnbbybEMgGxyvlQwdtSXeuAJGlkh7UljaTQBkPmkqhawSC6gC5culFAqUBInJpJoFSAI3k0hMCQQCNcUkd6kqlqasG4RI4ahAqgTNSg1AJnLEahErgdNUgRPIdRQiRPEcd4lKY81vI6RCQBId0HHWIO1ziqxEkdQicTgNex51RowMSQLbn2DgEjsP+iTlj/x6glr+rEYg5/o83584HOGxCQLJhVyMQd0AiV72e6zlsRrAYxB0mQeAwSQ3iDtR8nY8+m3DgkhxiDs9pNMSz2tOYg+QoQWfg4ClBiXNwNodiR8dbgSAqKYJWdxlIW7cIiqAIiqAI+j+QLjq6tnZmrsSUUs7UNiprlnW9bGa1f9YXjjfk3jZZmIAAAAAASUVORK5CYII="

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAeFBMVEUAAADdLkTdLkTBaU/BaU8pLzOZqrUpLzOZqrXBaU+ZqrUpLzMpLzMpLzOZqrUpLzOZqrWZqrUpLzPBaU8pLzMpLzPBaU+ZqrWZqrXBaU/BaU8pLzOZqrXVPlKug5KEk52Lm6U+RkvdLkRFTlQwNzt2hIxhbXRvfIT/U2OfAAAAGnRSTlMAUN+AQL+/YGAwz1CAIFAQIIAw78/vn+8wcEACtUoAAADzSURBVHja7dQJDoIwEIXhIov7grhPC7Ko97+hiYlBkZkBS4zR+Q/wJX3QKqldy4kPt/JzoqmCcEcw/RU8lF402WiAMFMfKuVHmgoWdc54DS8VJ1razmqOBbVdNN3L8caAdGKkWWWfNQYVzE7b5518QMs1XYAMZDfTioJSBhqVzhLIEkYq//EJDZ0ZKESmtpgbmDRT59D86yD171BsMrSe0xyKMzKnMWRoqNcYypg+D5muoNgeKj+/PYQk0Ach0/qKIMWtLy0qmfszIk8tB3EdKikkgQQSSCCBfghynx1XvZ23ie5KtPGUVUNv77p7b6ikDroCKVM7gPsKkZsAAAAASUVORK5CYII="

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAllBMVEUAAADdLkTdLkRmdX/dLkTdLkTdLkTdLkTM1t3dLkRmdX+gBB7GHjaMmaI0LzSOLj25xMuaLj5ALzXG0NfCHDOoCSOkByApLzN5h5Hh6O1ufIaUoKjCy9Krtr3S2t+Tn6h9i5TZ4eazvsafrLS/ytGsuMCZpq7OwcqAjZfh3OLXbX1zgYvff47WeIfNzNOMgozfdINse4XUN2+CAAAACHRSTlMAYL8AIM/vADTqLoQAAAE+SURBVHja7djJboNAEIRhwOBMD97XLM6+78n7v1yQM1LFYRhNp5LIlvhvXD6JEpcm2SzNJLIs3dso+fqQF6KoyJugvCuqunkDVIiywg+loi71QpkeyryQ/KB/gGaLMqp5Lwz1yuhmQWgeDy2CUKlox6Cly3yvb609Oli3dKkhOBwEh4PgcBAcDoLDQXC00ACQ3wE0CEJDQH4H0DAIyXgCCE4dmowlACHnnMJBgqKhdzgcZHkIr3bMQa79Slr9BjStpMMTCnKNqr3PzinIdYHBOchcYnAOMn0MTkAYnIfMFQYnIAxOQhichTA4C2FwGsIXzkPm2g1OQ+bGDa6Dbj3S3efg9yrowQNNH9eDP6kgeX6pSyNr7eubKKBgLbRNEH9m8Ycff4r+9XHMn+uI+YEQyNbqNJZ0ArVQC7XQ9kEfuH+/B33cYEEAAAAASUVORK5CYII="

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEX/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDPDEeIfAAAAEHRSTlOfjwDvMN/PECBwYL9AUK+AqPfYnAAAAcFJREFUeF7V19uOgzAMBNDEhlwIAf7/a1dqFVHseE1qodXOc3UameJJnTvEeBhIc7oZglB2cAiaRAmnIQgkaSaOCsE095wQYRSCGExOg7pSAPgGgojG8zSITBwTfAtB/oQW+B6CcjoFLNB6QtUEwdycGWyQb5AzQlUZtQqxIa0nkBZf8M1j8Uu6BSUKxcx/8DnqEFzXWRJWnkt3oRcd/SHGRx1qTsXjl2DVoOa4Q4lTIWE9KeuKQMTRJRkKkTm47esr+4ZEEqF3bVycchlrLRdJhjKZc1mBZP2kvAQVAKgngxk6yXhKVYDWy+4OQq1N5wwxMqjFK3VEKsdLUCKOKiUBclrt08pxfSiqNcIqJ3ahrNYIq5zchQJZbTysckIPSvxA+pFSB1r0XhOagkB+5MaH9D1x/LjbHWijY3D8S/Y70H4en0HCM1Oe24NQ/GPoH8zI+PjtP8gnXxH9pe18dnlmjdgXm33VKss/Dy5/ex3ZChJJQT5X2fcuEahfIti1Ro0MgWcXLT0x7wuBpKuf3paeQNJllAO0oR0I0mgcGCUO8YnbIahohVqiN0Mtydkh8lfUDLU/xwZID1s+aIXaPtx/AM+bgpTLhTcjAAAAAElFTkSuQmCC"

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAgVBMVEUAAADM1t3M1t2ZqrXM1t3M1t3M1t2ZqrWZqrWZqrXM1t2ZqrWZqrWZqrWZqrWZqrXM1t3M1t2ZqrWZqrXM1t3M1t3M1t2ZqrXM1t2ZqrWYxORkseymtb9VrO5cr+2zwMmcrbi2w8yfsLq5xs6fxuPJ09ujsr3F096/y9Osu8SpuMKqvFdYAAAAGHRSTlMAYL8AIM/vv2AQAN9AUO+Ar0CfIBCA36+uxGsfAAABKElEQVR4Xu3S2U7DMBCGUScThzYtLTtjZ1/K9v4PiCIsQhIbMnYQQvV3a+lIY/2sLwiRWBgkk1iSRBwt4tEUimK0Ko4mEEfL+BgK0LpgBIX2UDiCFFA3YnFVrSQNVAtSrRGqaFBjgk6C2K9D+DPgoYbmVEaopUG1EcKaMMmmRT1E7zwhmeazCol9pZhVGiGZa+t6iDTIQg+lZmh4udhsAeADes4NfX+aUO32iyBzg3ypIHSFDtuVIHFcC9opyOGzVQsgoekPoNVPM+Qhhx2leqcg76jTQ5IMoSzmTNoh8TR65wiVgpR5R4LYqhD9tP+1I78jvyO/I7+jGO3LvkJXDtDb4BzYtQPUDtANg9BBevqEbhnccXvolClnAwwA7h/sqZfXrBKPe4B3d9rkM0/yKQgAAAAASUVORK5CYII="

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAJFBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzNVrO7804WWAAAAC3RSTlMAEIDf/79gAFDvQCzAXzYAAAB7SURBVHgB7cqhDYRAEAXQvSo2p+8qICQkSBiogFABVIAYQgMEicMjrgiaO7OYv1+zZp5+7vb6COi9Bk6DTSIlpkWIFdLE0g5pYKmC1LFUQxIqdboiDyRLlixZsmTJEpE65ew0kL4stZDeLBWQZpZ+kPSMz6GYdMSTeQ3+7+gsbB746T0AAAAASUVORK5CYII="

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAABVUlEQVR4Ae3cv03EQBBGcZfgEi4lIqCBLcEJuUugBHdACdMAPbiU7YAtYfgkfEI6BCsC3+ygd9KTLnLwk+zbf+cp8vPw+DSrTVXlwe1qVbOarh1fQlpUUz5YVZVooKJ88JZIoJoAqKk5AmdVnqQtAmhPBFQjgDxT/xsIIIAAen57HymAAALohAACCCCAAAIIIF3gol6OLmr6a6mBOjir8ptMzQB9AjXlPyAB1LmwKYA6GUD9DKB+BlA/A6ifAdTP8gN9DQKr8hOy1EDHtMFPzjIDNeV3yLIC+R1bAPq9ClAngADiFuMhzc88A0WmGkxWxwZiuYMFM5ZcWbRn24eNQ7aeObzwyumO78dfyhHHX04IIIAAAggggAACCCCAAOJPvRmBAAIIoJoIaI8A2hIBrRFAs2oJcGrkG6iWBEAlDOioDPo8ampR0xUoulXtg9xS2+1rAj8AKO/siLFFEpEAAAAASUVORK5CYII="

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAUVBMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz++PD0kAz71aT3s1j6zpX1lxv3rEn1nir////4umf96tH83LP848L+8eH2pTr6yIb5wXacI+eDAAAACnRSTlMAYL8QAEDfUO+AOe1yPAAAAd9JREFUeF7t2NtuwjAMBuBCQwE75555/wcdiShmg8ZBjZAm8d8Z2NeEjKR1FbLb44bsd7UQohLi0ODGNIcAHbFAjqKqTyWgU12dsUjOVVMGaqqlsL1fD0jHSQvUeiZtHjR5NjYLkjzUZ0Hg+WRB/rPQF8JE/hn0hZTsfIy61XoIVSfVW1A7+ntGhage6zYbMn+2TSl/173Jg0znmXSGhWi7k8ohunZYgKENtbq9mQPZeM3pXkKowS71FMdrM6AwhtFQPV0lmKg2QR54aHra8luA9rFW/pqJheYwMUwmTG5OQDSzSxq6hLmxEKQOM1oOYCDCuV3hs5BLO44g5stWaUhlfdk6/gKSkVdIJyC6HJiUYyAMOgXR+s8paI6rz0MyDokZkExDtCZ6HdJxXRmIPqlSS+Y1MhCNHdxrxwHNnINQ0Xb6ehtWmAehJumVozEXwo6kZ6fDfMiQlHqVh9CMUXKPjovOSA4L0WEBlhwLdLzkQjQP2nUvdDSuQIw0mFgM5HDQ2pELClFBdOSG+6OQvl8elTZAlG7CIpA2G2/Y7RiK0Ra4858B5u/TUSKQBfU8JLMgy0Pusw0ERCchwfQWOWhfqsmyK9X2EU2hRpQ4FGqNCXE8lWnWCVGfm23tQ3HNDzPIA3cLViGEAAAAAElFTkSuQmCC"

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAUVBMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz3rEn++PD0kAz83LP71aT1nir6yIb1lxv2pTr96tH4umf////848L+8eH3s1j5wXb6zpVGo6ntAAAACnRSTlMAYL8QAEDfUO+AOe1yPAAAAa9JREFUeF7t2NuOwiAQBuBqserMcOpZ3/9Bd9lOKsQgDRITs/3vJoEvkgFsqFwOR3ojx0MthKiEODX0ZpqTg85UIGdR1ZcS0KWurlQk16opAzUVcUAO8aDSKYkh6odE+m1QOyQDmyCVhuQmCId0NkHD56AdSg1kaIcy8n2Qno0x4AEaOHapgdO+hGD078Xw2pucZLu1vr2A7sManBcIw5vy9iinOKSebtjgBLnFmEcpYxAP6oy5TzyRoW50mYkh/CuVjUHaW5FZf7t/ZzM0JrqmeM5D6vMg9MdYV8ksCJw4U9BAhm68jRjqXNlGIG6sXaHZldrrGgJDHBmDDIsc4DX57Q7b3+ZCJoQw1v6e1+IfDevto7sN9xFQBGq54d4ux7z2T0/tV3mQ8Y+0ZCAHsugkY4lI/zkjZUC8dVzGsVvaonOh8NsNW8qGaMbV6RaH0Nt6vP9lGiJruoXp15nhRDsNCCmILYBgpG4pCNh//gcZZv8+2qEv/fLfIdwEyTSkNkGQhvTHHhA4WuELRgKloGOpR5ZDqWcf0RR6iBKnQk9jQpwvZR7rhKivzXvPh+I3P/MeIcInfpsXAAAAAElFTkSuQmCC"

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAdVBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkQAAACKHStFDhXPK0C0JTccBgkpCQ3///+mIzP52NwOAwQ3DBGYIC9AQECvr6/dLkSfn58gICBvFyLv7+9hFB7fO1BgYGAwMDDpyMwgwViXAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAK7SURBVHhevdjpdpswEAVgydgBbDzsi/clad//EdsxMrdW0IiEk96/5nzHGpA0khKiF8FydTJZLYOFfnNHuX4Io8FAVlH4NUgH8cmRONCTofXmJGazngTpCECRXncm17QAFWk/lMQGydOso5d0WZobKU48kN4apsloNNneUFstQaGpcVqSM2Vqqh66oaRnmorEVE1PJS6or3J+J2/ufa2izxCcomTgcKzHczv/YqksbElZTtqx81EL+WCpSyEBQn32xLnUYg7E6aXEhkLz8VQMnWXoaAr1kMJXSMcnSHSr5RDhP8X6BeLvEFLtyeVfaWsgFKjIjeSFyKQrUCY1DCwvq6c0FaIyHwanhjd/J3pKLT/syACh4NETWrPTEA3SezsVooaltYE2DFX0Ik2FKoY2PaTZSYlepQkQ3px+QAFDJVlSNREqGQoeUNxPDUvKKy+EKsUMhUxmJEgylPUTRT3efc4ApHdIfoh4BNFfaPUsNdJCEiGUe/WmNEaGhyHJEMam1YKhzoIgTYA6FhaKX37x+eEWFfdBxFM3UEtTIvthvDsBQpGWimt9HYEIkg+6crUVP7wbgyD5oB0bAgRpLgRpLgRpLgTpW9AFEKTvQAdAljQHgiRD+CBdECTxg8QUcUKQpCmCSeuGIAmTFsuIAEESlhEsbAIEybmwYakVIUiOpRaLvwxBah2LP7YjCXL2BdiOzAbZyJDUF+zNBokt2wdBcmzZaCJkCFI10kSgrREgYTdHW4NGywHJEhottH4+yO4L0PrZzSggIS0kNKNWe9wBmiKhPbYb9hRL7TTJbtjN4CDVcn6biu9HjhA8UVDwowydK5ZMwvFjVooiuXMhSMm8g98gRb6j6OV8czDHg3wUnX84nn9cn3+BMOlKY++60mhwpfGTlyzytU8lXvvMv4iafzX2vy/rkC9dH/4B2jNNnzqaTIsAAAAASUVORK5CYII="

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAIVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMP///87iMM14EnYAAAACXRSTlMA3xC/YFDvgECdxfTWAAAAd0lEQVR4Xu3WsQ2EMBAF0UnIyTg5InIF1wENUMNJ14QjXAYhAglpqwS5gP2Zo530v3wXWMztOwPVRB8YTLaSNfpRNLpJGh2YznqhQPubgwK12UGB2uCgQG1wUKA2CBSo89kIlLQ5KRpdZI1GBo02qMr80S/kNPMARhWJsuvCVqgAAAAASUVORK5CYII="

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAe1BMVEUAAABmdX9mdX9mdX8pLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzM2PD/Cxsj1+Po2PEDKy8z///9DSEw9REhmbnOPl52tt73M1t1ESU1SWV6ZoqijrLMzOT6FjZN7g4hITlPCzNK4wcgrOkUzYYQ4d6g7iMMqNTxVqcWZAAAADnRSTlMAj/8AEIDf/79gAFDvQKYzFtkAAAHBSURBVHja7ZfdkoIgGIapVBS131VjUdNK7f6vcPkZlwwbaGA62O05YtB5+r5XBQIfPrhksZywWL0IGAfLB/6GyPMDaEEYeQghgFCcQEuClIlS6ICYigIXosQDERSsN9s7NmszwW5/OOx3dOCDEAqER5rMRNRDTSwmME5tH/iSd2d5ccScY5FnE9GB801HT0VwhJR4QkkUEZSip62RCitURGlNiubDrk94llM9DVuK5qnHaBoCOaQZZ6hJohO1Z8wo2slkgRnn1lxUc8+FwAfIhZtqE5Hsq6xnrpSiO0MRz7mAsxQ8cTMR4fXAJ/CaiJGoYvmM1V+7fqD03XXsjuVUmYjI3U/euuGXTrmuEZUyoFs/3NHfZEylXpRhSis9qqnFlEwrytnzFUPZ17Q79nbkGpEovBE5Dwoi8YY1rxUdRZSyILUkworWijBFjHpV1Mt7XhANM5iLMlci+HaR67DtH7/DF9L9J+L+o3W/jKgLl8XCZr3U2i/+9tuR/QZpv2W7P0S851ijO2gZi3RHP3OR/jBqLtIfjyUggE4Ige9GFAEvceEJEECxC1FKRSi1jimJERVRotCqLV/8FXXBR/TfRT9RTNmLg2Tv4wAAAABJRU5ErkJggg=="

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAe1BMVEUAAABmdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX8pLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzNASVBebHZicXpPW2M0PEFLVl44QUZTX2dbaHExOD0qmtruAAAAH3RSTlMAII/P/69AAGAQnzDvUECv/wBgMJ+P71DfgM+/cCAQq5g7lgAAATJJREFUeAHt1dtu6jAQhWECkwNgzKyUhqRQ6GEH+v5P2JCLKFLtIcP2DZL/B/jkuVmexWL+kvmCvKVZfitLieazXCpJSa7I8+WKbonQ2tC9ksKQB1I5ZIjuQwtSJEAbCgSloSATCqJA0PJhyG55CMDDUMmj0PUg9MKBoN3/Qq/M1W4PVDzO6iHuq0v+Axk15KgBsKIJmTvQG4A1TSjbGBHqbytIbBg2ETqgK0tJyqyS0dSypyN0eSEuQ0G8fVdCAnW0Fr5O1sqQoueCIhSh8we5+/z61kD/SOgsQ+Pxb0ms9UD9d2QBHrqQ2MUDoW8MUde1ZUftlbpUkMMZrv7RQOxJ9aIIRchRhGo9dHBCjR4qndCp0kI1nBD2Wsh6INhaA1V7+CCgPEyF6uYEAdL1/FCEfgGIpOn9dMuhAQAAAABJRU5ErkJggg=="

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAY1BMVEUAAABBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJCR01GW21Kb41LdphPirhQkcNUpeNVrO5HYnhMfaNRmM5Tn9lJaYNOhK5ETlhDQ0ZdaHBmdX9GR0q8dJLLAAAADnRSTlMAEEAwAM//n2C/31DvgOLlgygAAAGASURBVHgB7dfbjoIwEMdhW3TkfCp4wFX3/Z9yDa75J0txmM5y5++yyXwxJpRhs27GRtuZImu85xvfodkR7f3OnmhnFkOWaJS8DpFdDEUEaepQxEMYgMQcA2Ik1gHESIwDiJE4BxAjsQ4gXuIdQIzEOIAYCU4IBAlOEAQJTiAECQ4DxQkFlsQGkE1JUWpfUEbKsidkci2UmxEqSF0xQqkeSkeIJpVV3bTOdf2fOufapq5KmuSDDsdTz3Q+HlhoOL8lYA3voUu/uEvpgwQOpHmo7kXVc1DZyaCunIGGXtgwAzkp5PxQ2YsrvVAlhyov1Mihxgu1cqj1Qk4OOS/UyaHOC/UBfaAw6Gv9X/SB9I/Iag+t/hrRX2z6q3bVy1//OtK/IPWv7LWXCP1aEyRd1l39rrf7/XZduoyenssopgA9Th5nwvUYU4DuY98kCVMTiIIgekEJfqQsTCUjFONvk4WpeIS2qf6b5glZLWR/oW2Wa5g8w8exKdJQJi3wcazvP6Eft0TmZeNqE2gAAAAASUVORK5CYII="

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAe1BMVEUAAABBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEKZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWEk51TXWQ3PkMpLzN9i5WLm6VFTlSSoq12hIwwNzs4QUZTX2dmdX9LVl5PW2MxOD1MVVxaZWwtMzhXZGzWp8qOAAAAFXRSTlMAEK+/gAD/nzBAzxCA3/8AUO9AYL+jKJj3AAABzUlEQVR4AaTMyw1EMQgEML5D8voveLlxQtpoXIBlp+aRf5NcGYCio+ZokXwUaE5H52oBMDYq4NNwUzIqtJsPZH9wqGieyhfCPUO4Zwj9TMQ/E/HPr7V62XUUhgEwnD3gcE0dUihpTy/v/4RjjjqYThnJ4HwrpEq/FMdQDqk6xOg6zOg6zOg6zOg7HMryAhSKPLPWGmvLCpSqcg7VkEBNoQISKKxpIInGtJBEa2C3zp2QnJyHld2hPuAi9Buhc0AM5/88sWHElXH4DgUkYfuJDfiP4SuEv/rNp0U/IrlMkUwXJGO/Hdp8YgHJNb7dkIQjR/NIbnFxRdIdGLabzxVX5tM5DonN+zPFlWnepwMhJPEDkiShn1QhJPJhy0Ly6xcMW7DZ8uuXbHbHi82r7Y+8tOFjta/8s2zYwpdWQPYZEZB82NJ/auX8349/B0w0bAHp9QuINltgz2anP5q/I7l7UA77gW9uMyTmcPHQhDyueEVons/zFePrOc9JEUJCHSohUQwbCf+D9Mevn0NIFJu9cTTpZsuHLT+a4Prlm/3AhVNtNjhe7H0h4UtbQBKFySGJ3GQVJFBlxpaQQGmNtbV6TEVtKUSaFhTaxhJjE/kDrMce4dZDwNoAAAAASUVORK5CYII="

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAe1BMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzNweH3M1t1ZXmEAAAASFRYPEhNSWV6Mk5gmLDCtt72/yc8NDQ5ehqKIyflITlNNUFN7g4gNDxBASU9gbndmdX+jrLNzeHwTFhjCzNJAQ0U9REgzOT5cY2gVGBpaMUkfAAAAC3RSTlMAYL//EABA31DvgOiRhN4AAAFESURBVHja7ZfbjoMgEEBRRNS29H6v0Ntu+/9fWGaTUZftElMmTZpw3hDmZEAZgUUikQ8kSXkAaZIJIZgQueSByBxEBSegECwrKURlxipOQsUkjUgyTkQUvV80GFpGChlzDxOFjCBq0BVN4clMtXg8c9Uyg7hpR7Sw7eXKEa03f1g7otXSBi5a0RbEO+WINk/gFtVhB5HbRrSHhBRyqLXxiYyuDwqBlPaN6GhbJ+w6a2P8ImP0GUefbOixEV1s64r5gMcvAhPmdLWhl0Y0tOBS16aPyNS43BD7S4S56n4ijeP/FZl+IvNM9BUq+qaaGtlik71+sg+SbIuQbdrXygj3lBF+8xU2F7ew3V4ttWOn1Mb/2oeL7iqIeyNSgfyIJI0oZRXN1BKi47GkOrDnNFeIshBWZAm71MgqEyCiIIqiKIreJnoA7N+IBrqF47IAAAAASUVORK5CYII="

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMNHj8c7iMPa6fT///+Ftdrn8PhsptKdxOG20ulgns7z+PvO4fCRvN1Ul8vC2uypy+XAJA47AAAAB3RSTlMAYL8AIM/vi50ITwAAAYFJREFUeF7tmMluwzAMRL2G1OY1yf9/au0WwkCHoq6GQHLIXG08UCOKlNicajsl1LX9oabvh1FJjcMJGm5K6zYcoFENNPZNqyZqm84G1DVqpA8oy4kRyK+LEcivwQZ0aLIC+VmMQN6JEQiWsyBYDtAvPz5CEb6Ex+oLTX+AoHUCZyopsPwKCJ7eHQDF50sgeLoU4RSfr4J8FFWJngf5pLoBULE0bM0OQIXZWJnAoMvbD6Xw40tQnUEN6XJCQuLOgFTvhSM1R0Tid0BPrLL20KYzIDiU6svItquGzNmIwraIqkNATKmF1Y4r/rA6kO0o5t0WrkGmHNCsHGiG1QwISRSVAiGJnlzvRxLdqd4Pqx3X+1EZQ23vR0BIolR9aCUWVs8VZQSFDVZLTWFDqUVW7/8utT4LDuHQVfR+aM+pSbQjVMZINUiU/MC1bPy5sSB3Ry4QSyMuWuzVj7+Mvv567OS9nhDTez2z1uX1T9HPu99syGI29rEaRJmNxiyHdYcsxodf3D+rr6bAnoUAAAAASUVORK5CYII="

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMNHj8f///87iMPa6fRgns5sptKdxOG20unz+PuFtdpUl8vC2uzO4fCRvN2py+Xn8Ph4rdYOhPk0AAAAB3RSTlMAYL8AIM/vi50ITwAAAZxJREFUeF7V2EluwzAMQFGPIanZU3v/m9ZZKPJCE0oCRf8BXiBbYgwN78aJGE3jfDfM87ISs3V5Q8uL2L2WG1pJoHUeRhJpHCYZaBpIqL+CFAhB6LUQhD4IQYhWCkIHQhAqEILQayEIfeiFtuAU1rJdkNmxmYMmZA7sSUEdggs787oGgUIRSPsI8JYG0eE87Pa6+l//9QT205hfbkiDKQuMI3JgTGnOoTXJAdYY2ZPTNdjOPQ9tGNNdo9YhQhYK0bGN4Z92SshCLkLQ8Xekv/DOZSEV9w+1+/b4TmWhuLKzyaT3W4UME9qkIPrX0FmFVBwQrdJhUsUN+dy5ZQc+U7J4RNLO9ViGbIRCFoLHgAgey5DG2FYYI/bxk2UoDfb8GEmBw3dNB00dAoUVSCfnoCqkPZYhsJgyVSh4zENgzLnjo4tqkMXeFFUgcN2OhwzE+BJJEOdLhA9d0eEt7TARYD3s/cMwXr9yYaNU/4Zs1z4ifIhACUEEjgmlrBREwQtBpL0QRKAYECM5SOySRezaR+oiSuxqTPKy7k7i+vAHwZizmLtAiKsAAAAASUVORK5CYII="

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMP///9Hj8dsptK20uk7iMPO4fDn8Pja6fTz+Ptgns7C2uyFtdqRvN2dxOF4rdZUl8upy+VmIM9pAAAAB3RSTlMAYL8AIM/vi50ITwAAAdFJREFUeF7tmMmu2zAMRZ3pXWr0nPz/n9YJjBIKKNl4JNBNz9o5oCnzKmD35nINCq6X20Z3u90fQcnj/hbdf4Kan/smegQDHrfuEky4dFcb0bULRvwrUSYjEfrBSIR+MhIBi5UInoxEyGQk4pYrRdzyY9Fz8hktllMiN+IQT4ciF3GGTG0RvXCSfmiJKMNENPRgFK9G7FE1u3wvxfEXfR5n5375QTowCylGJHIjB83QOvaQKkZG9pwKtnmURU/sYDgVtR4gUTTxybbDnydgEkUeO3TiOhoSNrwoyvgQp3DM2uNNFkXYSFO9HOl8K6LExShETx5DZUVcjlIUjEWrT9hIfq2L5mORS/hLcrKGhylXRS8UvGQPYcfXRB5feFG0YEcaEa4nx41WTQN28Gzl0VI+7EL9wqrESEj8S07nVPfAyaIVH+ZShLX0DOyJITRjJMZ35sj9pgWMq4hS8QS+342cm8fy26iIIIvAB1GQg42oJxMRZ7dCxBfWb5q9ljNIoSHyssjv48VE175pV1m0fv0tGAuNPCKSKHFwANlPPKd1kZNELrSRY4SneuIYaaEMNkYZtYwy/BnldSSLjvgvMluymK19rBZRZqsxy2XdhsX68A8I3s6cwrKC5wAAAABJRU5ErkJggg=="

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8eFtdq20una6fT///9Ul8tgns7C2uxsptLz+PudxOHO4fCpy+WRvN14rdbn8PhkPWDoAAAACHRSTlMAYL//ACDP71kzCuAAAAGRSURBVHgB7ZjbboMwDIYBA3USA+G0vf+brjBQmMevUSUXlcZ338+4seRDtpAXFEGRl0+ysqxqiqSuFlH1oGge1VNUUwLqMsspCXlWUBKKjBLxb0VsrJMVZ03zsqht6ZtOftD510Tc90wrgyhG/4KInYjbTFY0E18RhR/bIFU4viIK6Qx7mqLp20siIxuGVtoTE18Qtb0ObARnh0Xc/w7sF+ZODkx/idjhwDxIwEPR6WtblXYIMyIRqL+BCHywRyLwtxpk6oBIPTSsmVZ2Gihi5VE1o7M3QKQeDNYM64fQooBs0DndHiBWNMtGrMi/nYhTiegW3aJbtOLfTjTHilxoOHEiKxt8GkDjoMigNgvbFRA1stNSADdQKKIOtDTc0oHICzKhIQOIaAwmlR0ae4DIH2PylUEMiGiSA93sF/BoiERgoPhAwyoWoen6fHxGIlwzn6wG+gsisDuoFQOINDyJxuqlR4kQfhTFrNcwLFIqvfjpxVCLMM1xFeV7XY8k3ZEl2dkn2SEq3Wks2bHuSYrz4RcDfGl1j0fOcgAAAABJRU5ErkJggg=="

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8dUl8uFtdq20unO4fD////z+Pupy+Xn8Phgns5sptKdxOHa6fTC2uyRvN14rdaEYaYqAAAACHRSTlMAYL//ACDP71kzCuAAAAHiSURBVHgBrMwJAQAgCAPAsQf7N1YzwAU4fEUNsPzATmuo86McjZ28qLWgjdKKAnciQktuN3aw4zgIw3F4JC4F/KeDIen7v+muao0W1RBbQ077OzefkGgI4IEecReKKROkQjnF30Hx+Y2Pvp/RA9UwxIRpxDZE+Z9JWEbVhPAjNVzWDKhDpNph1OslBLwlLjArbEHICa7SGoqYVI7G79pR5pKGGKrMYYgzxtgNZfXviyNV6gI6rZn5nNG+gBrGclg0DKo5oDPo9MjrFCJzQEoiCzKkrGduhDpMSf30mEGAW6r4KVqQIWU9cV/LN4QoKUD9uGuIIU8frSXmR5DMIUUFPeRpZy/17n6F31UgPXehAxLtQg1SmUKR+Yw+iCFBQdTxjnch4P+AOu1CMTHH6QpZILXdjRZBOnahJ6SyCyVIeAVP6kXX61G2n06tHUQyNxdrdlwaiQgfRQ01/xI7dLkbqYZkQOHQC7Ep9RnE3q/jEI3Q5Ft7GpIBVf8mYvldk5p7W2NAofs3WtK5gGpxb/0k1pDE9mbUhKTk3R7r3YiWPCUZXlhD7iNEtiD3oSYD/RJyH7MyyIC8B79sQt6jaL3/cGwf14v7uG6nAAPa67ZLltuufe66iLrtauzOy7q/3XF9+AdQE3khb+qfVAAAAABJRU5ErkJggg=="

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAD/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDPXYsykAAAAEXRSTlMAUN8AEGCAcCAw70Cfz7+vj5hBbCwAAAGHSURBVHhe7ZjrbsMgDEZzMQkJt37v/7LbCqgizhwka61W9fzntNjYmAxvyYdxAqZxvmKYLxhxZ1SLpiyatCJC4dUivrWXBZvMstrWxNNv18WQLNp2ADAH+WGRAYB9k0S0446bBRzu7CSIDDK+7sH4kNXBm7pjj4wRRAsyMf90QkPKfzQiswiitS750UQw4o+q6ldBZFGTTTeccqNafbBS1kwJEQX8QqASJCOXiPMxjeUUcErexxS96ykREjws74KIAkQCdYqaOKfVfbOmJuJ9IocHC1U7LXjgukQRldDU0xZQiT0ix2PBY+c6RIl7uCldiywq28zYULGXIgNek7yqYS5FHgUS7wLPRMeGGlgUTiMYjk14OLZ4sCZx2mhwvBaG46XTJFg4rY81jQgFsv0iFM5Fs0Kk3dpfBFuffv2B1JfI04pW30b0jU3favXNX38dPfGC1F/Z+iFCP9boB61njH76YVQ/HusHdvkJwRCeENpHzb9/084oqEXv86blKD5pyLxe9BF9AZqDenX08twAAAAAAElFTkSuQmCC"

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAAD/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDOwiOlpAAAAEXRSTlMAUN//AGCvv59AII/PMIDvEDeQewIAAAGiSURBVHgB7dhhb4MgGARg8UAFEfz/v3a1M7mU3ipJ3w/N0vu46dOp43zpcBk3AqPzVxn8RRzucW9DI+4Z34Zw5gt9KBSmeYm9UFzmKWhowZHQBwUcWRQUACFpiAcLaIKQCEkHk4BmCIlLRDqYBbSAkli00sEioAgtnTUiHURC+gB30Sv8QEJSGi96hQ4hLaXz49d83tX1/COTdgg10nacUyoY1HLom3IIUeKlkSHFS6NDSEjBpwyRnHiEgtqnHfxWIVM3H9RrhRCTNk9HSX5LvX2UTkdKVK6hjBfJ/VABk0u8pWQwpRdKlUz0ZyKpmjqhlYt750931kPphGpbEm3R1C6Iyzvv/iF7Zjn0QOtz2bSVtSrIjWB7OD579Zj5K9+eNzg85Ca9uKWFr4L2vIHur00oPkORUHvegCZ+74PQxA4yuzSzm232+G3+IS+WyJ815UwXrUGNrPbFZlu1BuVv/zqyf0Hav7KthgiLsUYMWmv/oNU9+mU9+tkPo/bjseHAbraFMNvUmG2zzDZ+ZltRu83x95uI/wNxiXzCl3W6RnR+AL/IT9iHt/KaAAAAAElFTkSuQmCC"

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAdVBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkQAAAApCQ0OAwSKHSu0JTf////PK0AcBglvFyKmIzOYIC9FDhVhFB43DBHdLkTf398QEBD52NzfO1Cfn59gYGCPj49wcHDv7+9QUFBQVHZcAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAKeSURBVHhexdhpk5swDAZgO4QFskTmzL1Xr///E7s2Lm/RxDIbd6b6mplnIoGFLCWE3mTb/OYj32Yb/RQOFfqhKGcDkZfF1yCdVbdAVJleDe2eb2I871ZBugTQtYerj0PbgSp1HKorjwztuaFFNOd28FJVRyC998zxTHfjfPLUXktQ4WvcjhSMsfVVL8JQ7f+NITHMcaLqEDRVebhQNC5TrcoFxJwulNW3l/4zvvv8Oi4p5rTNfeb1o5/Cs00LCRDqc6JATA4gokmqOVT4l8dEHEB0cVKxhHR1gxR0AOE/VXoB7b0DiTmAuLT3EArUDZCYE4CaDmVSc2LDaCAxJwDROMzJqfnJX4ggBR1AKHj5B9pZ50jEJDhhiNxp2XnI9TFDTIIjQcZ1ugnS1mmJmAQnBOHJaQdlFhqJS3BEaLRQ5qAKR4NJcBjEq1RZqLDk3A9/vPRv7056fwMgQefpoCj37IfZsQlwSYbIZlB+QjlKTfSzlyRAvNz5k9J/Z/ZqGVmi+7lptbFQA4hLcaixwkbZh9/Neh+QJIjs0c3UFiUCJEh0v0hbZWt94BCXZOhgq61sAlcOcUmGrtYQIEipEKRUCFIqBCkVgpQKQUqFIMkQfyElSXwh+RERJemI8EMrS8KhRRsBJEhCG0FjAyRIwcbGW21UCrZa3vxjkgk0f3yOMHKK0mBCnyP3gTxKA58sndwHEp/sxyR8sjFEPCRhiMBY85iEsQaD1kMSBi2MfuukARJGPzaMrpIMJAyjbDxu1kgECeMxG9hbWiERJD6w++RWSgTphCsEv9Rc4hJBclHcv2bFs6OlVAsXP1mihVQ+cBX9JV5F0y/H//66nr5AkFcap9BK4xhbaaQvWeJrHyOufdIXUemrsf+wrPPxpfXhbxzCTTpRSPB/AAAAAElFTkSuQmCC"

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAALVBMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t2ImaaImaaImaaImaaImaaImabM1t2JMdPHAAAAD3RSTlMAYN//jwAQn3Df/+8QYFD0Qq7OAAAAmElEQVR4Ae3WMQ3CAABE0aIFCYeV4xgAE+eiEiqhEqqOhEBYSPkDMPXPT8Afft9ur4MfDX7fsZI+oQigAhQBVIAigApQBFABigAqQBFABSgCqABFAHUNnab5ntbQOAO0AHSev4W8oQ1t6P9oIWgk6DIB9KwEhSCXoBDkEhSCXIJCkEtQCHIJCkEuQSHIJSgEuQRdwa69ougGQaQ+ebn9c+kAAAAASUVORK5CYII="

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAABf0lEQVR4Ae3cwU2EQBSHcUqYEiyBEihhS6AEyvDG2RM3r5RAAybcvJktgRLGd9hE+ced+IJvk5GP5Ltpgr+ILswbmv9/cHC8vX/01tXK0mg1kfm/6bElaxIU6dxAigOQ4gDkwAFIcABy4QCkOAApDkBuHIAUByDFAciNA5DiAKQ4ALlxAFIcgBTn0UDPL6/Jaq3mSL/9wsG6WtlbME6+g3OxNitbq5UigQb9oSsAWuQ8NquNAtoqBlKk9NdAqQhQwSUmrVY6LZAgtXeQxmNAUk1ADqQOoC+k3srSAtAeaS7/FgGUfrjUZoD2SKOVpSeAbt0wstQDtEda5fwmgMqX2QqQfsLWcwRoB9QBBBBAAJ3mjzT/5vmgyK0GQNys8riDB2Y8cuWhPcs+tS0cduWFQ5ae5/LSM8MLU/jwgtRXNv7Sfjvf5ej4S2jxA1SM4DHECRBjwAySsxWBzSxsh2JDHVsy2dQLENvCebEAr6aoDonX4wDkRwJIuvCKrojigegTlda+xo+nhD8AAAAASUVORK5CYII="

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAATlBMVEUAAACImaaImaaImaaImaaImaaImaaImabM1t3M1t3M1t2ImaaImaaImaaImabM1t3M1t2ImaaImaaImaaImaaImabM1t3M1t2ImabM1t0KtbCKAAAAGHRSTlMAYN+PABCfUN9gAO+AMK8Qn0C/z3Agj1Dif9e9AAACDUlEQVR4Xu3Y7W6sIBAGYEXBc+SjVbR17/9G61jeddumQ2BMmiadP5JNfDIMiw42vzD+/7vt8TJmohn5eHq+vYcUgiOA4AghOFIIjhSCw0CDUm3/EE3/bewOA9lt29oMBIeFNoqWheDwkIMEiHW4YreQADEOA0GynoHI4SBnw3H7ISnNQLvDQP6eiCEpAMo4X6HpnNJM0gAo6wBCmLukLSYHKOsAOqVI9w9kOkBZ54S07z8WJ1By+oAWtT3GjYMGS4nQ/SjOipSa5TTy0HwvjkImJg0aWwbhfk+jDim1O0RAydRQZkfAmlKKpdDoLTLRNg38IRZCkCZKCbOkci2FELbqjJRo83f0Qzk0BqREQMDcKiBtPwB7WJLLobHDeikC0tZdKiD8c46Fd6nsXQU0xh0wO7CkK9V/LoUwt7gDEwHpGmugIVWZ5qiwS2qgCcuF6x+ULbYGdMXyqyv+kAOBV20Rc8WmDQSKHyMApQ827BAtfdSmmscrHv60iJ30dYSZ+UJo+vyCTANV+soOn17ZyMyVNhHmaxOBzJq+LWhrvNrmh7YGCZniRguBRgsJCVs/lMrUNqPhbGsjjdbK9rg9nY5IV9uwL3fnIGP1EULPWzwcb0FKDjXYLq3wmAWnEx780Jca+VEUjvhwDIeFIHGQQ31YCBJX7HWFAYiXfu4jCy/JIUhyaHwt+DQmiOuhN/j9LYksZZh4AAAAAElFTkSuQmCC"

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAOVBMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t3h6O3h6O3h6O3h6O3h6O3h6O3h6O14sVl4sVm31ar1+Pp4Ir04AAAAEXRSTlMAYL//ACDP72C//wAgz+//AOAD21kAAAC9SURBVHgB7djBDsIgDIBhoINBhSm8/8NqjIc5KVkn4mH9blz+CyGkVS3awIrRU4OaSNbBhrNHQnaGD7M9EHJQ4fghDVWaHTL1kGGHgDA+5APuEPxlQ70fY8KdUmyF4oK7LbERSsiQ6JBHFk+GArIEMoRMvw9dmW4ran04WSiXp/x1qLycKiShXKoyO1QIEhofGn/98tYk1PE72pKQhORfk9D466+Tt/bXCbL/cNx/XOcvEPqtNAYsWR6Orn3uE4ELRBvCv38AAAAASUVORK5CYII="

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAY1BMVEUAAAApLzMpLzMpLzOaqrQpLzOaqrQpLzMpLzMpLzMpLzOaqrQpLzMpLzOaqrQpLzMpLzMpLzMpLzOaqrQpLzOaqrSaqrRFTlNteYBqdX2aqrSaqrSaqrQ5QUUpLzOaqrRwfIQy58t7AAAAHnRSTlMAMO/P7xAwYIBAvxCfIM9Q34+vQHAgv4Dv34+fUHCtGyZgAAABRElEQVR4Xu3V227DIAyAYeOEAGnSND3sPLP3f8ptatxdTMIM+2rq/wCfQGCA311OF7DolHM/WECv2Uh6yUbSbv9fpLt0lwZJmqfxGETmrc/7XVEK9N0kQQ85l6VHuhZEqCx90NYoQENfkthhqFl6pltHUEiBfkpQLRUddNAisaOV2NFK7GgldrQSO1qJHb3Ejl5iRy29E5lIH1QOfZUkOPwOyNITySWQC1TRKjsLA9q9HaogFJ1EVXVWkLw1T3UFUVpNJYwoSosozSl5cEjKOeFkKYKRdAArCawksJLASEIwkiYwkhb4m9RpV8T5iGqJc+mcznWD2/iWOyupg6bceAVwlAZXpuJXC/iOIZxBlceGkxP+iFkprVZL8ii8uNWFhltZ/tuPWijSlhaaGUpaiW9ltNrbpIWWDRq1kLt9lNpoyxT6BGoVn8fRW1rwAAAAAElFTkSuQmCC"

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAeFBMVEUAAABndX+aqrRndX+aqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrRndX9ndX+aqrSaqrRndX+aqrRndX9ndX9ndX9ndX+aqrRndX9ndX9ndX9ndX9ndX9ndX+aqrS93fS20+i00OSsxNSesLy72vClusihtMCnvcx6iZNfuV6aAAAAHHRSTlMAEEDPYO+/n4DfryBgj1CPvxBw369AMCCA7zBQqcpavAAAAX5JREFUeF7t19luwjAQBdDJukATlhboYjsr9P//sCKS5VCwx5ArVaq4z+iI8Uy80FXCPC3kmCLNQ3owYZbIiyTZI1aYyhtJ76WWC2nJYnmPUyXSmqTyd1bSmZWvk0kmGcgxkn9dx7ZRY5r2eGd11YQ51WqS+jSRKrbvpl9do36l6UzvuCkw8zP06ir9YOaJmWdTlroZU557xlPtDMqSQUOp1x/qehvUd1oKfUaoUdY0PsOUXC6Qe5kSj8pqF1TzteV6npUzesZztmetG2rZvhXTpeaXu7BCunjFRP/uD6AnBGg/aCBhnwjso0VtI7CNDbXV7lGbP+w4Qh2QqCN7A7pEyBhwrfGVMumX+GstXt+D+dK3OCdySStPh5G467FxGIm5sG9i7TAS/4SItWOT+EfNnsbE2mEk9pm11QAjsfkQIEkIkCRQUoSSdgIlvfw36SmVhJIOKKkkkLQmlEQoiUDSmkBSSSDpQBipJIJIUUAz8vmqnTfG4RJso5HZnYEf4gsQNHiy/TUAAAAASUVORK5CYII="

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAflBMVEWaqrRndX8AAACaqrRndX9ndX9ndX9ndX+aqrSaqrSaqrRndX+aqrRndX9ndX+aqrSaqrSaqrRndX+aqrSaqrRndX9ndX9ndX9ndX+aqrRndX+aqrRndX+aqrSaqrS93fS00OS72vC20+iesLysxNSnvcyhtMClushndX96iZMMAcanAAAAHnRSTlMAAAAQQM9g77+fgK/fjyBQYI+/QK8QMN9wIIDvUDB726x4AAABnElEQVR42u3XW1eCQBiFYSe1gDBQNDVqhpOH/v8fbMUCt0VzYrvqpvfKq2cxzDeAkzvXsiiIZVscRNlkZFmYyy/lYTaGCSCgwJfar6Wm9d7HSXKpLU/cnaU0tnR1QmkpZB1I3us6NoVqK5qj5+oSiQ6Vuqo6SJRY9x37VRfqW0WNvbNNAebnVKpB5QnzZJlnLEv9GJZnnvHgcj1K0+WaAqcLqksdVNa4JIcRKpS2wmWY8sENMtym3GFllQmq7GuL+nlWxvoZj6x71pihxrpv8eBWG293rIVkl7Iku/6hv4b47ecHkj8iNz60/GPkNx5sb/Sjln/4868j/gVpbnqrV3Yq2Y8IONxnzeZle169wjEX6p35+bP3Wzju0tLqQBrzeQwHUjr1/2CHAykd8RcCDqS0O8Fef2rgoJ3o8/ibBQc9CMcm+AnnOg8IDgVZnLkPBGfYzBkyO/fCGSIdQKQDiHQAkQ4g1gG0oBxAT5wDaME5gFacA4h0ALEOlkY6uNmkg+1nHQwk6+CIkA4O7WPPbJ8FAwkxa6n5biPG9wF2HDoVvL2iYwAAAABJRU5ErkJggg=="

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAmVBMVEUAAADM1t3M1t39y1j9y1j9y1j9y1iaqrQpLzOaqrTM1t3M1t39y1j9y1jkw28pLzPM1t3M1t3M1t0pLzMpLzMpLzOaqrSaqrTM1t3M1t0pLzPM1t3M1t3FuIzkw2/ewXWgrK6mrqnxx2S5tJfSvYCaqrTqxWmzsp3Mu4b9y1g3PkNwfITYv3tibXStsKO/tpIpLzP3yV7M1t1h/TP9AAAAHXRSTlMAUI/PACDvgDBAnxBgvwAgz+8wv99gAL+AQAAgAEPp1ZQAAAG/SURBVHja7dZtW4IwFAZgQLESreFLQRiWpdOiRP7/j8v0mod8YC9Orvrg8xHGfZ3tDJhTFddjxS7McyeaceBK4oVFKaGXnAZFgiEqOgEasKIiLDGFBmFRmXCghsAxlhBKyEEpMYBYIQnTh6LyY1G8TVSmIyWEE2OxuBgzmJwS8gqRbkD3g24h4mlC4cH5PeIghXqQC6sKPXClEMwsPh4Sw9ykEMOC4JYWhF3GfWEExTgmNoGCs0MTTGA0NdngC3SBLtA/g3r9lWb6vXZNnHbbb60M0vLrIL+zMkrHr4GgHmVN1VBP+lD6MufL9OhieZ2uh/k+jmydN0/zXY6wfgka5QKSONPnnYIYOeNcDc1eBQEYFCSD3qgcwG5FxrkKWvC5LA9XN/c/GamgpUwhTBREEPRcL+8AQc+18pEDBD3XL4gg7DmGZ2macSgIIFXPs/3dDAoCCHoODklUEECKnnMawrEggkySQUEnQilBn38P4dSaX+zFl1n7G9yQlBmve0UWklekkZeWslnbfkbsP2xYlOWnFnaC5cff/ncEO8HwB2n/y1YfItb6hwjbY83dUECPFgct26Nf04fRbc5xPP4G5la89BdCRpQAAAAASUVORK5CYII="

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAk1BMVEUAAADBaU/BaU//rDP/rDP/rDP/rDPBaU//rDPBaU+8vsDBaU//rDO8vsDBaU+8vsDBaU+8vsC8vsDBaU+8vsC8vsC8vsC/i3y8vsC8vsC8vsC8vsC8t7e8vsC8vsDBaU/BaU/BaU/Vt4vusVb/rDPFbU3gi0G8vsDBaU/Bbla/joDAeWS9rqu9s7K/lIi+o528ubl4QgdDAAAAInRSTlMAUI/PvwAggO8wQCBgn88AQK+/7xCPMO9wgM8gz+9gv98A1MfuNAAAAb9JREFUeNrt19tygjAQgGHBQypRAoVShdYWpU1Qe3j/pyvjYDeQLbDITGda/ztuvkmWg3FEy7JdderJttJKo7R7nAVKK2C8HwQMUD0g7iokl1OheQDL8DwGV3OAiM7cuCZAHMbDyoHBoDgB0ubjpac8bU4/QslmGctT8XKTCCGYQiCI4ZDjy0q+Axurbg02h0DOrTS6VxAMW8cNKLyTSLmC4PZrBXUojDHnQ7VmVaHoUWLt2yG7AoW4Iw/tkAsQ7MtIdUiHKnP2V07Ryu8BORJah6IsXMtPIgTPTxwJreiBBjnghKJSSIP8ugORoESei0Q9l3L7N99zFkY25YFcnqHQhCzKKxKXji+QAoWFv7SybCVEj73ZJuRgEMeWhH/YEoCwWDPEUnNFAs9tvvfdIZ43bYwAiaMpwTecAkmQDIcGyeMBnU/h0KCi9xw91tAh+bbPK4zNUzpUpkPo0W+7yzq027ZAs3HWsWZodpMNA42zYaBFNhA0GQrKrlANeh4Ksi6EwBkISq9QK6TY9RX5zxC7Ptl/4vZPst/9yWYXHSJetL8fFx1rXvH10A9aYxdO+yZUtOg08cliOmUBnGb1vgAEL6tb6hvQ5wAAAABJRU5ErkJggg=="

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAADBaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU/BaU9j1/k9AAAAEXRSTlMAMGCAr7+PcEAAn+/fEM8gUMymrDYAAAGOSURBVHhe7dbLjtwwDERR62WJetjN///ZJDB6Cpke0XJqm7v3QS0owNuDnA8x/W7PRT7aZLFSmyKN/t8g3/V7LYzHkDsUoeYfQkFnxfEAGlHndbcMjUOtmgNEOJBuoap39bEC5dnXfoirl5QWoLP97BzXCn9J+R5Kk0HnX4fRxh1UJk76Wny54Q6KEyjIO31PMqFTJ1VAV96G8gzqb+elV9GGks7K3691mJCqLZ24+mJBTo36HqqiYEEvXa9aUND1Egf9h4qut1vQqesFC5K2DhUTiuuQmJBfdqINjbYKvWxI6qLTxYbc6iIPiHK6AGIcLYAoZxdAjHMIIMoZgEgHEOdYUF91AgZsxBtLTmwofAKtfjJe5DHUnAwfFR071syhOPvhdK/wp1wGAAOqE8duI5w5NHIehrMM4Q7XHUC0A4h3APEOoM45gEgHUOccQJFyLsjFFCrpyEbeDyDWAZQ4BxDpADo4B1AmHSziHECcA6hwDqCTcwBJ4xxAgXMAjU46eLQHHAoSyUn1CEOYfgHkau/HL/duCwAAAABJRU5ErkJggg=="

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAATlBMVEUAAAC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsDVt4vusVb/rDPVt4v/rDP/rDP/rDP/rDP/rDP/rDMrbRWsAAAAGnRSTlMAIGCfz/8AQK+/EI8w73CA////ACDPAO9gv4GW3WAAAAEXSURBVHgB7dbPbsMgDMfx/ME2cdO0Zcmavv+LbpoglVdIzMSkaeJz4/I9/C64+XVV1Xa9gS+m71rc02AaWRAs/ShEA7wYKDvEJ4g6cV6IDSQYzgmNZ0g6j/oQxzuhxNoQG9hlWBkSO9uJPk1WLK4LETxdGD2+wBOpQgMERuw6GggGTYjiW8jtSBGyshMv2eNQC8GIL0YI2sNQt+2MEdvi3WGoB48xgsHrD0NGrJBc0ByGwJswagJPHSKMIm2oLRVC8DCOS4Wwhv516HpzCrfr2zeNfM6LU1rmd6ERr/nu1O7zTmhxGZZ0aHVZ1mTo4bI8kiGXqYZqqIZqqIZq6C+H8j/I8l92+SOi1FkTFDi0glW1+CPss/kAzBTwuhY4tK0AAAAASUVORK5CYII="

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAUVBMVEUAAAC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsD/rDP/rDP/rDPusVbVt4vVt4v/rDP/rDP/rDP/rDM02nvwAAAAG3RSTlMAIGCfz/8AQK+/jxAw3+9wgGC/////ACDPAO9PqJxiAAABEklEQVR4Ae3Wz27DIAyAcUJwDCVr/rAuad//QVdNqxEdJGbNoQd/t1x+qi1VWG3W6NbAT6bVTbeV6sqhhSSL/4LQwZ8c1kMnyHbydZA3UMj4Gqj/gGLnng95crKSZ0M0V8V0am/PdsB7g002zoMQYqOncUeIIQtycYZkr32c2HEgLO7CRwkZkC04iWT3IQ+P4lxUD4+aXUjTnrtMtHG9P1qj7Rnu0WDZ39sy/yKjoy3kN2h4ULkBfnsVwreD/FFQJ9BOAgkk0DQHRp+Xr6dU+rmsgdm6XJNU8rXcArvbsgGtoaK1DE2hqqkIzXXQXIRCZQIJJJBAAgn0zlD9A3n8k338EXHQWUO9fmhRvNNvnq5PfQNSyQ9UwXxDgQAAAABJRU5ErkJggg=="

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAD/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDPXYsykAAAAEXRSTlMAIJ/vADAQQK+/j89ggHDfUBBqpeYAAAFOSURBVHhe5dTBbuwgDEbhgi8mDCTpef+XvZtqVNpJbGDRSv22oLP65TdLiAISwz/Dm/GeBAAkrYWC8EHCUijyFJdCwpOshJRPVkKJT8J0KG90tjwVyoVvSh4O6YOXHjoW0sqFqiOhJFyS5A+pcEPUG9LKrarO0APDwxfKmLIrVDAVTyjjkB2hDYfNDgVcghlquDQzFHGJZqjiUs0QTr8vpEYo4ZSMUMYp/91Qw6kZoR2n3QhFnKIRKjgVI4TbfSjhlm5DB27HbWjDbbsLKQP0JtQY0G5CJwPO61BjSLsK6cmQUy9CO4P216HEsPQqpCfDTn0RKkwo30M7U/avocSk/CVUmVT70DvT3rtQZFrsQsI06UIs+OWhk2lnF2pMa/0gD2GKHN0gV/zxED1+PlTolOlQo9OmQ/3drAs7CsKThJUdhcqHGhZ31ApAada//9RNzJGU2zHEAAAAAElFTkSuQmCC"

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAkFBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkT///8AAACKHSu0JTcpCQ0QEBC/v78wMDDv7+/PK0Df39+vr68gICBFDhXdLkRhFB5vFyKmIzOYIC8cBgnPz89wcHAOAwSfn59AQEA3DBGAgIDfO1D52NxgYGBQUFCPj49JKS25mJyNUwTXAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAL/SURBVHhetdjnstowEAVgCcO1TVm5V3q9NXn/t0tkFGwdbCEmw/nLzDdoVbwSM4SPnPFkqTIZOyP+Nhw29IPrSQMy8dznIO74y4H4DreGprOlMbOpFcS9FgiD9UVlHYQt5fHH0NxXSB7UR6HlWAe5kvz5A4gvFLOpRW/qraIW3AS5qsbBTgxmF6iqu8PQXP2bqAvEhyQ5xF0q2lyp+RB0rXK+Et2kGRFRlopuVtdaeRoETqiPKi6oSRHr4wtRYuAEMFNfpPIFMxiAxPT6bAXknVTeBeQqzRFy1eKJ4A/tSWX/jdKqkVwd4v4SJckU1EmBVDM6n2uQXIcoxQlByrhHWiioLVCYK6mdd8w+1SsetmVit4Hlu6grVY2DyWAV5LfBsdvMr4ToSPGeerPvKbj3D5pKZyNEV/pBYWAZbKQ0VdBMQpHoSr9oMJUGRRKaXSEunUCIrvTxOQidemaON5AjoZ2wlTI4VSTkNJCvtoatdL6vki8hV5K1sJaw3PV1o7Bm7nMh7KVS6JEj8P5CE1Vqaynp2XKTN8ZxZDK/P1BCCMfG2UhCR4CST5BM0FEKIyYnPxQIEUgmSMit67AxlkiGyCBlfWflmMlarxEio4TQWlabyQFcwInJKMUAXaTRC53JKJ2toQMZpYM1VJJROllDGRmlzBb6JjJLZ0uopAfSyQDhnJml6h7qWZAJPZSS+wXZbhGYe7N0uN8iuGlTIhspxU2Lx0ickZVUxHCM4MGWENlJJRxscNSeiWyls3bU4uFfkrVUaoc/fo6I7CX8HDUfyA1ANpIq97b5QOInm56QKu2TDU1EYS8VWhOBbU1qLRWp1tZAo2WM1olBowWt39OSav2wGX1eUs0otsfH56S2PcaGPQAAlsOdhA27GhxKuBwKgdK2vULgpWaF0AkP6lZScfuvWTi6Cs9plOb/dfFrJc/6KiqqU0FUnCphfRXFyzHGfDk2X9cxeF1/6QMCPmlsh540NvCk8aJHFvOzT2R89nn9Q5T909jrH+swTz0f/gGPfE5Sdt6TNgAAAABJRU5ErkJggg=="

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAIVBMVEUAAABVrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO4RDnu2AAAACnRSTlMAn4AQjyAw76+/XJpknQAAAJ9JREFUeNrt1EsKgDAQwNB+bKu9/4EVEbKWFASZHOAtk17XylVPujzvcvXOI2kHSTpI1kGyDpJ1kKyDZB0k6yBZB8k6SNZBsg6SdZCsgyQdas6hIh0g6QBJB8g51Bc5OZxwwgknnHB+5mzOoVVOlQ4N51CRDm0rHCLpkHRIOiQdkg5Jh6RD0iHpkHRIOiQdkg7hyJY4/GlPvjLmPGr6qBME3FNqh0q8UwAAAABJRU5ErkJggg=="

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAACImaaImaaImaaImaaImaaImaaImaaImaaImaaImaaImaaImaaImaaImaaImaaImaaImaanONBsAAAAEXRSTlMAMFCAQCAAn+/fj2DPrxC/cLfYs0MAAAI7SURBVHhepdjhsqsgDATgYGBBsGjf/2XvnTmnbLWYHmV/KvONmQmBVm7ETarqA3YRXMwU0/Mncw73oTI/3xPDPcgtz0NSuQMpASZehyKBjiRjDiUZcyjJfYcphC456aEa5/cHAZDLTtLKlmJxctVZWg/WhVKAXHQiGKwNypABB7VVN0MGHKCwNhlxgPZJXoYcvlYZcqB/hLY8OQBhionOHYipG3p5vKDpG+SL6ubrGZ9ekBPzK1rHLVs1K0uQc0bTbqfqpxPaingObb8Ms7gjxM02nUF1JXCc9J1NO+MEcvPpBGPW3XPpOq0sQ4p0FhCyHcb3aneEvjjMXD8dBaFTZ1HV5V3KHGn748h01gAACPHJhP5eFsthD3ryE+uiA4jhlN6L0ncgtsN424FYTvRg8q+zdB2I5eyKq6YDsZznCgYPy4EYzv94MGo5kFOnNTJjOBDTORRnOJC+k3uXhtVwIF0Hal1j6ByhenSA3WTjxYpOF1oODhuZOXcI6acDZMvpQ8Eapd8dQmvXoWQ7hNzRsSXFGcTlGw4p5iF5hNridYdwxjJzwWnEcxijk5BfDZTiBCOiretwkuBVdXKwIw92UCeu4I+RthN9/8yds68AfInuDmSfBTY0DTmQ1kZ5yIFsLyjVEQfiOHVGHAhmLh9wIFDr0kDnO1STfY2hY0NAMS9WdOwIf1AwhmNCdRlyCMGlUYcH5JBDCKFXXfK4DKHmDydW3IAAv/+o1QMXIVKtD+bsgDsQrcJ/Bq/lH1JtwKmoNymRAAAAAElFTkSuQmCC"

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAe1BMVEUAAAAiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpk/fKpvoseVv9673fVbk7yex+Q1daVSi7ax1u+Mprheb3sjKS4AAACYtMcJGiZGU1w6RU0RM00cU3wXHB+vz+YGEx0VQGAXRmkeWYYCBgoilYbEAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAACAUlEQVR4AezSXW6DMBDE8V0Mg20+AobA/W9aNU2lJpk1OH3pQ38H+Eser2Ro5eoGd03tKm1t0hp8aPCiCb4spC7CEJ2eDnU9svruVEgDDgU9Dg0RJ8ThIKQjTho1F/IRp0VvhwYUGaxQQKFAQrxTUBLeKS9JyT7E8BzyeJN/DGnEm6I+hEa8bbyH+EDlM0n5w/jjpPTnifAd6vBL3T3Uw3SZ5nQzTxeY+q+QwrKs6Yd1gUVvIQfuOqcn8xWcu4UiqG1PL/YNVPwMeVBLohZQvhXj77dk2IwLkLah++zJsNOdmlYUzJxMMxiVqmCgzEyVOBBrylhBOKnZPacsduO1sK2nlDWxtaVwanNuGkoH/kN/MfTRipnlZgzCQPgakC8GsrDc/4R96UPbf7BUyT7AKET2bMnHSRJILWT2gbJaSHkihw90yBNRR8vp4ZzIo1U0YsUDqqZoRBJbw/ndiaaITVLtxf3scJ6bS1GtJv+Xun0YryZ/KUcdisYpMLQcaYE0qI94VwXbCaSU7Lng/vjj6YY1t5ItBWkAlPPX/hSAIcXIsTUdgCN/f1bKBwBd2xrPaI3Fx6yhjZZv/abxZ2x61s8xo/3lx7zdN6OuPb6aAYC1y7HHMYY9LEJEhZqomBUV/KKiaFQ4jorrUQVCVKURVLJE1T7hRVR8NRZf1on5V334BXIBsvSp07OCAAAAAElFTkSuQmCC"

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAABndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX+Q1MiBAAAAEXRSTlMAEI8AUN8gr3DvMM+AQGC/n0UeYTcAAAJCSURBVHhe7dfJkpswEAZgtO4L/f4vmxEt/yWMD0mkquTg/+KBQp/a022Mj08RkkiqP8uhntGGfrIMWUe0A/KBdkAxEW2ARCbaARVDfxmjJ0g4WogGVAOtxAzINloMQ5loB1QM7YCEpB05YqA9EJxViHZBZhcUIe3u2r+fo58IuQXq0WETpITbAq0XZQAtFqUBoajFW+3z/lZ+P+LD95oPy98iKGodQlGbIGXTKoTkQHINQoTaBKn/BvpCX+gLfSHt4xtgi88l4kAAKfYHwhN/cGVioiGic2ZqGtedth8RhWGK1K+8PYxWhSScAIx0oZMODpE9aI5GsSwnOIGmOIYaHKII6L7wHLJ9OiwAaoO+oFSK5hMv6LUwM8RXG19K7VvoAWHHJNQB2kxQ7UhfYriBl3Nym0SJChCcCWoT5Hq1sWvxdUhJIYDgTJCFOP6uV43ytYrKE8pwBmRylgH7K+U7JJTsrX610KgHFOAwhJgyDVEagB7/MfeE4ACCpLnZHfCjd6dSGf37AHn1gHBa8gSNnojPEFInKLTWEktlFJLQ9sov7QmZAAldw+PVycunOH6r4Qm1CGmGVMSQ3WN5zusTeu2pP0KC3uKZNuIJqYrbwQSdDNV3KKnIrzxl1bkICBIGMud2AZLvRDJzGo+pZNLlfAYeTuyfh3TQPdbexrgyLhLdAgiff/MGZeV56YjgBW8SKmLp+Ss7+NH8eCm4D3TxJCREDD0kOqJrI85ffZEhyNsvCsOsPXnPdl2mDTW0UVLwvwCuF7qZibpELgAAAABJRU5ErkJggg=="

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAABndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX+Q1MiBAAAAEnRSTlMAEI//AFDfIK9w7zDPgEBgv582TWZnAAACAUlEQVR4Ae3W3W6rMBCF0TPsjSFj/MP7v+xRiRk5hZq0WOpNv6uoJItpTDD/zpIBGPi9/vHY6ADgNjTNQA/ooegB+QXoAEkAekDR4Ye5sYJkxo1Gg5LiTq5AU8bNnlAAekDRoQckA9AD8oo+kKIThF6Q6wV5k35/1XpfRyRl6ASRo3aCKHMn6O5QzqCbQ40G2VB3b7WH+1t8PznZ1x56fxexofpANtR9iNNyF7KCYrgHWcJOEP+gP+h3oJQVe5pHkj4D2bPOO2Dx26t5f3vOc4g0KOG1SObNFFbp9kmSk+IlF6RAC15byXLCyonYkrNnOx2fED417xDCC2TTHltPoWQQ4hVk0hHSQIOg8iaEZFBgFfbyGWQHpjionbINITSgj2S1N7YhxDZEFkmvIJULiA5b4wWEfAUlbK0FWuOzClI7RROScsLPyz8aNBYptiHm8+dslR2K0f7ShNZzCNEghjJ1GwpfQJ4GccZW+AmUWUHiysv3/zWXnwWpIfp9CRrQYtDxOjKIjyJdLr9rQ/Y1XV6Q8xUkrgnZ8XQF0Tchm1guIaYGZA+cK+23VjpCXI/QEj962BGddshSf4BkAd691Va5A0Sv+MbN3zpCTG1oON0g9QjZ18SzDdJFbtCI10L5mGOVLF9t2Uuyh4i45qpEUlbF7Fkng+oq/JCGvDeHNHHvP9zAVIgIDxiRAAAAAElFTkSuQmCC"

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAABndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX+Q1MiBAAAAEnRSTlMAEI//AFDfIK9w7zDPgEBgv582TWZnAAACd0lEQVR4Ae3X3ZKjIBAFYLBbfkXg/V92yx1zyg4oE03V3uy52mpmv3RaQaN60RPRxN1sK5o7UdxmNkREfWhbMfOvIOuIriEiZ8eQDzSGKPgBFBeiAbRniReQTkRDCEn6DFoNfRSzdiHt6OM43UI50I2E/AbZQjdT7BFK9CAJUDvkG0NXrCd6nEmzioG+kBDVQweSoi9Fme84RsWvSCZ+76p97z5iftjUpA97bQ53mTBjr90+RHCQALrbFNoBdLMptAPoTlNoR0Lt+bZ2I0+0FkJ8GD9F8GDrQ2hqAKGdAYSmziG0M4DYLtfQYnkAISmcv9aExDyGEM0fLih+mH8P/YfWNX5u2FVA1pdAW0zNfIiuIVTN3KlhH4QMyFY6JCRGylZYpLT8rR3WaVXy9GhfWuN+GIoB7CfW4TxIP1A9O//wn8gfoISShODIzAKi2EDpHfLUTYgCMnoEWXqlzpZjLpiTgMiNoIL5vj9MsoDIX0Px5aB1jrtkJETxEtonHSwjPKMlARl9BQVUEXxdJyFyF9DrD62A8t7mG0T+HPK4QiKYyg4ZFM6gvTgx977b/IKSw5hOoIKiSN3LgLTBmC6hlWXSO4TbxD+FsJPiR1/NtRBjTI+GzcwY063Lf4AwJtODYu+GxB5hAXEmBLVAW/x4i4jlKiFclqDHm1ZAemkgzqVMlhXb82MksICwBEg+IOvpwZZaiPM5ZPEhLq/r6tG94Q7E9R1KhlxkhQ9pE7uQXiQ0/UxY4d9NMrcQxoTaPuKqoPYdQJ1r6g/r5ez3msEjGyzCEzY61h1+r6Vw9RJhfvUSsVPZGdqy1JkP0amUallmq+22LkQh8x8qmFQbkpCgTAAAAABJRU5ErkJggg=="

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAABndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX+Q1MiBAAAAEnRSTlMAj/8QAN9QryDvcM8wgEBgv58pZZvTAAACRElEQVR4Ae2XwbLbIAxFjSQwChjj///ZZsTFVbJ6r2HXnEVmgpWDuDF4vP2SQBRYgGeT30FPYlohMva8SET6WCEySl0hMg5+FaVI/0hsXpToA3b+K4r0CXreIvqQnleIjGORCKFvtILAi0SkdZGIdJWIVoniIlGsq/61pffRgnZWiDSt2Ws7LzlGNK052HZectRqej/8uf0cf6IteIrgwbZAhHY+EqGdFaKS5XNRID1EFoiERdaI5Cv6ir6ir+j/EtXWWhYwB6q80l6KuPnybKJjPLTLOWuC2kB0L1L5whiKElG8rTvRtQmXt5eBU2mic9oHvb3xdSIqsx96stkQ6OYhz2jgIodWiChgzSZqZMR5Ad9LH41qtnUYvcdRyxBRcqKANeVHv1hEyv0szQVdst5v1g0TmgjTQGQjAjB5sZCRXh0B7TYEKUNExYkwm4E0mrjFB2tShxsRPiByaWwB6qNaXZzTuG/05JLJaK8TSFOUadIbyoK89jd6AKbo9hmixQTR/LsxLaIHxy1qLyKyz6OOmCCSfNHk/KFIh2g0ESB6wmlugJmHX1p9lZd7aQcKAkR+E3AxnQ+7I17AYyqIrJ4gAuZtwa0DnctOT7Jf7TlFUvUWcXUh5jr3wF2Uh6+4MWWIbDKIEpFeiautVuHTU4RPnWuKZkoifCgCgwg54s4G2HNKHmWcE47CXsTFiVwFFgS0IqzXKi/CDzb3u5LHhfJ2iGHXg25h7e5uTwj70e+TFpy7RbrbCDhHeFdDG9GMuKZ6/gGdFEvK/Mhn7wAAAABJRU5ErkJggg=="

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAABndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX9ndX+Q1MiBAAAAEXRSTlMAIAAw798Qj0CAUL9gr89wn31rcgsAAAHzSURBVHhe7djdlqsgDIBRgfAnFcj7v+xZnjKDkcgI9rLf5ZTuNq5RscuNhLzRIv9KAWr1AcgAImrzHLK4Zx9DDt+5p5AukDbPII8/2UeQwNr6BApYAzMPvfDYNg0ZQNI6C21IAzMHOTy3TUFGY9M6A3lsAzEOKeQK41BEtjQKJeQDMQYJwIvCGLThZWkEWvE6EPcho7FTvA9Z7OZvQ9gPPgXhp0azHejugKMn7Rf6Qrp19BS0ztxFeElTRleHg4abh76Q8+fELyBSAETEmNcjIHzN/UAJm0C9GRWwpl/HZ4FjWfyHANsyux0J4urumXbo8racL79p4D550QxkiUMkHsIkl7WdLZrjXBAieYWFwCzSuL334uz2pJSCHsmXLpKtkN9NZYuUFrlHXjwcIHCnP6CoENmLRx4S7TNRmSc3a8vgPJTquyS1oYF8D4p1Dnkazg1BZW5u/+7PUO5ADglL9K1CZOQetHIb5kAhVY5C7kGOQoFCwXtvA5bcNEQLcnY0GhgeUp2DzUFayQai7ykRvYWskRTq/0PaMi+FIKT3qu4pYpkHXFPXkvonrWqeTrIcgepl5FfKlR6A2gtbrBfnMUgm9lILZhDqXPyHIf52dBdKvef1qMjaFw+tzG8WYsMalFHIWgoVKYRNVYTfRNS1WUjaPz1fjdGWZoVcAAAAAElFTkSuQmCC"

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAnFBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkQAAAB7fH31+PrPK0AfHx+KHSvW2dvm6eq4urwPEBA9Pj+Zm5xTERpvFyJrbW1FDhUcBgmKjI3HyssOAwQuLy9cXV7srLZNTk60JTeYIC8pCQ2mIzOoq6xhFB43DBHdLkSvbneBQEjNjZfdnaZiISmQT1i+lI8JAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAANySURBVHhetdhnc9swDAZgKY5jO7FBag7vvTK6/v9/a0mhQIhKjNU7v19zec4ERQhi4En40Hvsv2P6j72H8Kk9QdsfBkMyOP3hoBsU9kYEiIx64c3Q88u7Ny/PN0HhkIFjMnvDzJIjU8Pwa2g8QiRKFhtwslkkEUqj8RdQOEHmtIDGLC5ITUIfNMAaJ0tozTLBqg/aoXHNXM7gzRl/1bgNqqscvcKXeY3qmjuQcI5LuCHLo5QC4Vw2cFM2iZACUZ/3KdyYWhpLaIBOB2lmpYELhbjv3X/TKHSgia3Pf0kThLhAx80UpW9KqXksgXK11iZptUNoc+QyBbSwaAnxd5T25h92DnNINSdT+BREtLiAdv4VINf7z9KWmeKq3azrP77SM2CgZ1sggK3WjqTYWWuZrJZsXZ8Rsn3sDFBqV8oJujLAUmGgs+10NRQaJwGEWGJop5tS8c6FFuoZyJ6w1JUISnVjYltvA/UsNLIVMikzR/pAZ8vAepVnBK3A5GQ2zkD2cGA/jJUJSnRaFBfYKfzaQov6oAR27yP4HC0kKnVp3YJ+E9hEtgsET30sNUcLKUcnhTorgqjc/acgpJUx5EgM5XITgdcWBg8G2riQkCoBKXQyPHFGeAjM5h/BhYQ050fQqdkVYXN0e8EjlYghIcXufpcaswMu0mNgaj0TEObHX6nSmOsWYpVx7blV9gOzgLdmKJ+i9DPTDTkA5s0YXgio0zVIFXSAPJKCLhBLewnlcRfIJ2XbLpBf6gBJaZ3nXK206AaV1OlsXQolCo4QPpAe6Cr705zbNj+QeEQ8UKE1S6L1HviI4KH1QKWWEjckxYcW24gHUlpK3JBybiPY2PyQlA4EcWPDVuuHpKQY4lYrm7+EeB0sramtUPOn15Gv2LI//eKTy68jfEGe2iHISPqQp6XEMWIkXtnNUKUpe1dK+ZXNQ0Q7tNVtknKHCBxrWiGoWqS0cMcaHLTaoSJtlkoatMToJ6ErYLZZk7Sj0U8Oo3IcmgNJaYM05WFUjscIKWoSlGLVJInx2GTi7NyKOiknrrJ/pIsc2HFxLMVzdShA5qCu+Z+oXTFFiRYmP2pmcGNYGjR/ZiVdpXHbh19y64ffxTrDO3yK3uHjuPvn+l0vEOSVxqXtSuNEVxr3vWTxX/ucPdc+d7+I6n41dv/LOk6n68Pf9LWYpmqSCBIAAAAASUVORK5CYII="

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAACaqrSaqrSaqrSaqrSaqrSaqrSaqrS2wsrT2+Dk6e31+Pre5enN1tvv8/agr7jq7vG8x86rucGxvsbI0dfZ4OSltL3CzNORlgqTAAAAB3RSTlMAYL8AIM/vi50ITwAAActJREFUeF7t2NmOozAQBVCydXlfgfz/n04yLxBfV2wUS1FLfZ/hgG0KcE3PnM70Qc6nyyPT5XK90Ye5XZ/Q9Yc+zs/1Ad1oQG6X6URDcprOY6DzRIPyFegPyrusNUBIpf/H2MxDwul9Fl8yc9C7hMhAWRdZXpkUdBGVqpDSZV6OixrjRA3SkDs4kNgFzZsjdD0uHYO800yCB8i8gRbNxgKUHAtl/SZrCVFaEMKbNTHnGHaQ5ErEAJRxJWVxSy0IzrKVWZu7oW3yQm0dQy8kqo+oxQrgITjFb1BCnofKIjS0S4DqbkG6kGEJXBMqF1/soRlGzENl3ec9lDcot6DyysRAsQuyCMHcdUFmPKRGQYaDzK+HwldXrf1Arh9AnikR0QUJptbE0VpLUFNQ/YffR7Z+XOiCsEbgkyCbEIxhrU5R7IRSdWwSeR6C17zzRKAr6oUs/g56hV+jNrTqLdKXjvM9EP4eOSuidQf/RrCsMM4fgMjy0ExHIB84R9EhiJJrDQwhCevKSy4RD0UoCFYKOwchUvW9iDelIz29hbxidkf5hVpye+Mn5nlOVMl6l0/MGRnXr25F/6BhTZZhbZ9RjahhrbGRzbpHRrQP/wFX+q2w/3bPCgAAAABJRU5ErkJggg=="

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMOFtdq20umRvN1Hj8fO4fDn8PhUl8vz+PudxOGpy+V4rdZgns7///9sptLa6fTC2uxdwASOAAAAB3RSTlMAYL8AIM/vi50ITwAAAoFJREFUeF7d2Ndy7CAMBuCtofZiv/+bHm9RPCCEsydc5b/KjJnPYAux8emR84X9Ipfzdcvper3d2S9zvz2g2xf7db5uG3RnE3K/ns5sSs6nyxzocsIAF0KqHlAgvasIUjpvMRb7Ln/HeHUIhfyMbh2bq5iEIGJ8aaCS6zg7hiRA4gDKYgwZgNwRlNUISvs43kLw6KJGi8eQeBBmfUArBTFljiH3IAKHqfchFg6h+BSSgrUR0PoaRkEwwrxHLhSU8msYDb1mEqAILIaM9150C+2EiyhBWfpBHbnIBtACU4a/aEhzEoK1h2pudEEuiYQCrAzWJkZQdomCDKwH1uYQ5PQWA8sjoAhD98GxX0d2fUmpD4mMIhBU7W3fhVTuRBFQGEC8B3ECWgeQ7kG6D6VMQtBj9XfcU7I1tJRHpINd0oH801nbqpI7hOIYhuA98LbOlwEku1D7loCmIcHoGa2o7TqArGucwPpQdO3uUaZaazR5zxIsufsVPtNLsYwMgsb5W1CSXqze4yf2jv0RpLzJkLVQP49EPIKiIza/zXUMH0IhN7F0YWtFQ6Jhxnt2UQiiW1vsQiARkILnI6JlRern0BoSZYtfQfJ9SDQHn5VcNZBn1SniVA9SDi6i7FBzUzlo/pyNoKZZLRiCmxg2hNrbqg60oHY1ghS0fwzBlTHU3FeSUPoppEEmIDYLsh9CE54RBcGVz95anFVHaVJlm+6mfe81+8FeC13IN/9k8lXHPqSgkdijflRKCc/JR9yP+N6PAtEhY0bRww6pCIjJjyBjGYLIri0/PUUgxVSOoM81eXRk8+U/T9oLa2O53yKLYh/kMu2zz6wPUdM+jc38WLdlxufDf9os2iL9iratAAAAAElFTkSuQmCC"

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMOdxOGRvN1gns7C2uz///9Hj8dsptJUl8vO4fC20umFtdqpy+Xz+Pva6fQ7iMPn8Ph4rdbNXZ5uAAAAB3RSTlMAYL8AIM/vi50ITwAAAkVJREFUeF7t2Ml2qzAMBmDIUHmcB97/TW8Apz4c4di9eNFF/1WS0u/ESlUpTGvmW7yQ23x/ZbrfH894Mc/HCj2+4uV8PV7QMw7I8z7N3YAktC7NU3edGeec1Cs+9ToLXyOqUjcEGyR/J/QHKcK0NvYFWACFIGu01o42IeH4nkTXR14cIZf4Hq0+QyLwd/zm2QId4+lHKDslUIO4Fx8g4P0QN3VIZYCB8zXIG2BZUlXIldOLcA6F9UB0r5+rQqHUN1IMlXdBdrQGic1JWWUYKnVJm1SD5OFacgbZDBnUMBgC/Ay3CAyG/vdoxWUfobhBPkMaQeWDEn6DGh8/lJMhiC9IRVC5mKyOP4e8/D41J80WSTrUey3olE0xqGlh0L8RFj9BQn8TIW3FPU5aVhzRmCIkV9mJ5d3spStcdLmKpGOKSAAgaq29PAwNKun6ogUAeWEcoQyCKJFDIFjLPQASuV0uQaUR4TdBf5B0Wmt20gh0/YGxnZBMPCctB0bp9+uuB4KsoDlBPS9pQ1C7VmSnE5LVaw3/EZTrE2Dbgrw62Z2M74AWXnYFRYC2dycM4V0Gj4U8ylQb8tUvU4fdyTShzdEFqCwYtgGhHmqsPC3IXYPK0ULzaNBZbBVxDntDaELmZKzj3126/yCNiFFYpm2BCN6dMITXEa/1Ji6oZ5MOF5sWfta00WYCb3esG8JSELFEFIl1TVplMuNBxENI2h0XHf6+dos4wgIAkRFnAQCrvpelkts0xyGZR92IGnZrbOTNuldG3D78B3i+cHdC3stqAAAAAElFTkSuQmCC"

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMOdxOE7iMNsptJ4rdZgns620ulHj8f////z+PvO4fBUl8va6fTn8Pipy+XC2uyRvN2FtdoQobsdAAAAB3RSTlMAYL8AIM/vi50ITwAAAj1JREFUeF7d2NmS6iAQBmCNOt3sS7b3f9MzymlLaUIWcjX/lVWJnxSQ7sjlmWuHDemut99cbrf7AxvzuD+h+w825+f+Cz3whDxulyuekuulOwfqLjmgxCtLgAStQRouZZCJNsXJEgPOpgxmBRospU8A+xW6rOqQt+9wp7cf6U0V0hXI26/oKhTcIiRoKCSZGoRGCFGGxhcQAxqdIJlBPGUojVUhokkf4QhEfKTZaoWmE6DXJIenE9IN4iCkvHXzxx5xuA/ikek6NEK0Zs60QtHStLdBOjkeG6E5Oc40QvTAKWyDlEvOjG0Q1QbANogqpMZGKNKCNUKa2oJ4Rh2GwGaBY1CwLOoQJDgk1qCx1NfU3hHRtpM5P7nMmZBDvJUE3BeCeP4kpCbwMKlFQIAHuQ7JaFO8qpXIkUP8Nspc6SEW6pBmW5f3yZS+Cs1EsJv5o1uF+uwdSPKmtg16KW5GDLFcU8Fug9x7GJKgQi3R6xC8K7IqQi9CwzqEM0yf0z6XalJYhHgMuFI/9amHrEF8c0+lvRjWIF5UdWkvatwMQfHvCE2b2ANRNN+LHjdA/O1/YL7YAaGRMP7HRMZ7XIE4FrOyoy3LUIGEMN9rV2y0FLEEhd7aSFKCyJ1KECxB48dSqW9I7hqRpyJEqLVH5oi+7CaDQdu8xhtBSaYwyCBWaSv1f9vy+8zxeBAy7suJ5iiUajXFGzwAUeZ3J6H5KT+MQw51pd4Pi72fFjC/3J127HPWQdRpR2NnHtb95ozjw38xC73sE5+0PwAAAABJRU5ErkJggg=="

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMPz+PtUl8vO4fCFtdpsptLC2uy20umdxOFHj8fa6fT///9gns7n8PiRvN2py+V4rdb3Xh/hAAAAB3RSTlMAYL8AIM/vi50ITwAAAmpJREFUeF7tmNmy4jAMRMN25X3Lwv//6UA64xujmAfQ20y/pChXjjoutUx5eOp0pi90Pl0eGi6X642+1O36BF1/6Gv9XB+gGwnodhlOJKLTcJYBnQc8yxsdAdSiqdUnIBQ2VghUCmwJgGBLAIRVedAHEgYpKRBZIwQi0ouSAEECIImI9EH/Qc6v7Olb0MILdCPyLqqhyICWIgNyRQgUWo76GFRaBSmQFgLN9DHI7DmRPgeNU8VMjr4AUYorSnkLgMBg+7dB4xzNEt0RINnF/65ob5Y+yOUCqcg4d5ysJgHk0ZQMxOZETp3s51R/+g7Ilr1MC5qapkab2w5IlUaOXouYqDA/YGhqIsLMz5QCj9MCjyMqMEMchDHDQWYj5ycI/jK9AWE5KQYKqJHgaMLjEATbMIxPu+9B84pGeyRsWD8iBi1kc2HOYRLyzBBAnWNCjdQo1gUd614yEG8kZTunmhphTr8BaVM5eSQmF3IxMREzBBALE99o4ruldB90ZzuUPPLQKiAmXZCGn+wrKeWjvdDrauqDsD8h0UaatqC4Y0N6yUV5x0F6e5tg5CFVjmprFBmxWgIDzX+7GqTuQYi0asXWh6bf3H67eA7q+PClSr8B0aiaacgMrdH1bsbUYSDku/m4cGTI4JHqSACo6SLw3QQMJ2XYfoLyVt1UUJtuZQwwmyyft5uxER+6tCDQof7kruNjTcmS92EadrYbhRnP+GIotFUnnrVk9lmb8R5Ae9O6bTV3eK7VczZo1G1jbn+3JPnXP1ztJYu28aG6eo+xyexsfE3MGGO8U9VZ7NpH6iJK7GpM8rLuIYnrwz/kT80qS4hSwgAAAABJRU5ErkJggg=="

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNgns6RvN220un///9sptJHj8eFtdrO4fBUl8udxOF4rdapy+XC2uzz+Pvn8Pja6fT91/35AAAACHRSTlMAYL//ACDP71kzCuAAAAG/SURBVHgB7MxLAQAgCAWw9wHs31jNAEcWYPgoN4jxICLLTZU/yuO2ky8qD6gAPYKQRwgestFGHRvddsxn53EQBuIHX/gPTgJ5/zfdhmk+ZVJWWnU5rFaZG1P7V3ANqmysmQJy3ns3AWT8IfP3oNBB4QH9y6CYXM7ZRpGiGi6gZX35KwHhbWoGoKX6rpo6YDlBtnloN3IqnZ7P5g5y/kc9ausgUjUcC7MwaPU3ZQJRkiPTEohzGMSmiGVvIVCGuau2T1B16jwURGL1XZvqftSBamQuu3R3UDNHBNKdiAIeep5qIRAqtGHRbqBwOXw9P17GfZSvD0Zi0C7QjphC5h1U8W1QYZAKpNgem3fQmcqrQIdIWMG0X4AsgRJM/eJoK7VsYHNc7ICFZVATqF2LXX8D0svZYmWQt8Dzz6/C4oZ0UaTsH52dUCFqyE6KNudFRlek5jy6ay03D5W+Y4ot31zadXBpLYFE/wS0x8EzEi4gJtXtXQ0DInH48UIcgyS8M3Ip9f0auh6oFXylWKglIRBkrKoegBhCgRP6MqnqIqRyeNb8v//YHtADekAPaNqQZdrYZ9YgatpobOaw7qUZ48NftV5gdSBpABgAAAAASUVORK5CYII="

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAilBMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz2mxj9wUH+xUX6ri31lBD5qij/zE3+yEn3oyD8vT37tjX1mBT3nxz8uTn6sjH/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE0SVGDiAAAALnRSTlMAIL9AAJ//jxDvUN/PgK8wcGD////////////////////PEK8Aj1DvIL9g34AwOFoTpAAAAtZJREFUeAGsl+mSgjgYRZuIlwQScKMNttrbvP8zziA0dQkkBGrOLy3LA99KeIskEbs0yFsayR6Z/F9EO0Dl20VEASDbIJLunzIAEHKtSGoxia1Fy5UijX3qADbFijLATJP0olwjqjAjEugwK0QlgL1PhCRalACAnqatR0SLDmhxs4qBKlZUouWYjsgxsF8WcX0Kd9gGVKxorjwViN06EQcnNQgTEmXJRIQDe4gyIMqLufroo2w1RmGE8IsStScRo4WGS+EXCY5bYAmv6DiqRLZZJIuRKN8sMs4oFgijfCLFFwnHFqza0Z3EfKNIu22/Q5j9vKiiLo4THVKmqnpRRleJCc0d2jzrRRotSsYnOx1hdCeSk5GWCkG0uwdlKxriUFXsiJTuHsxfIoMe1YVeaSxg3GeXaUV8fW2McTWnpaIdAPESaQQ5X+r3YNEKQL9ECHO1tqldkdtzMaKT/Y/zyRuaiBWhaU3NzTMhB/yJEizwYV/QPVHvVmoQSSxw70TNg2+JPbGh1bbjA2SSrUYaYIPIPkEIY0qFbaIPeJlvSKf/Pu0fD3jQw4gw9ydGXAbRFR7EMLTEl705DTnwCQ+mXyPMzdraqf7AGR5yXmwdj8ZJ6skS8CB51VJmKdvvZxbxD5xrXv4dT9tSezzcSU/6nPWiyjtXT/I4oisloBoekHxDLc31HcDtbh1qLu5g1fTInlbo0tgpX9xdd/Qc6RBBqyfEZbQ30aH4WMOR+eDePlHGjHPQ4vFcMl0pY4V0jn5DzcJc6vrrwtvg6BxGaTyJ5YyJyfEYgF0JAJVMDuzbRPnMK8QWUTb3UlOuFj3KdE4k9VqRliwi0/c6z7f0va/9/K7x/P78Q7zxl38bmYMrhIEQgIK1wPtAIKT/9vTkSTZMAQO2fwwOER67JpxzxJWbJy/eIqj7rbkLFhHacWqilV30VTI1UsA+gsfkz2IPTNFMvVN+R7Yrsw/PrePw2NAY5gAAAABJRU5ErkJggg=="

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE1mdX9mdX9mdX9mdX9mdX97jJeImaaImaaImaZmdX9mdX91hZBmdX9zg46ImaaImaaImaaSE+eVAAAAGHRSTlMAYO8A/xCAj/8QAJ//nwD/IHD/7/+PIHC1C2CUAAABnElEQVR4Aa3U4Y6CMBDE8bZXKFIrep76/m96htzkSJPlvyHONyH5ZbprCX1iSvHrQEL/IOWchg9BefwENGZXJYYGrsQQVmJo3RVUQkgjjlDJCUmCSgTFLEmVDkKSVOkg1EsafZmmcpp9CbMi6T91eqe6IVNaHUl+qJfkTOd28SRsf6xS6pxlcUkhpjQO24mn3vFJIeWcRWlfnSOJIVFK7yxnnniIKYuyHcfuwjyMoqLtrBKuX1QyHZAEiUqms6YQJCpFw1GuHkjZcaYbQOgolSF2GPI7/qOVfcc/bHC+m/czct91fnR3GSrgrFK5T+WEwwbnLek7TusHRy8qQXMzHZIEKc1wSNpAksDR62JDkvYdSXeE5rrvSAJIkulIKgBJshxJNGxJpqM044r0KX/31GAkMXS53mq9XdsCEkIKSgz5JYZYYsgvMeSXGPJLDLFEkF8iyC8R5JcI8ksE+SWA/NIDIL/0BMgtvQByS40hlhhiiY/GEg+bJVr/cQn/kCzJYYglvLQsyQEIJTkAoSSHIMhDe2cI8ny19npelF9Fb9p9rP5JDgAAAABJRU5ErkJggg=="

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAACImaaImaaImaaImaaImaaImaaImaaImaaImaaImaaImaaImaaImaaImaaImaaImaaImaanONBsAAAAEnRSTlMAEIDf/7+fcCAAQI/vUGAwr8/vXXROAAABcUlEQVR4AaXX8YojIRDE4ThWd0bH6Nz7v+xycLtFr3A41u+/EPgIQqR8hdKRAfP3WR73Cp8c/7KqQRk/2alAF1j7CFBygPXnEIuSAEVpCFCQsgBF6RCgILWkQKVR6hJkhG4RYstQ8nz9Dxqr0AHApzNidRXKmKSOHQj4LaUmQHA6f7AFGSU6O5AjSL0hllahN/8OZkaG/iJ0IrYrvYppEqEKSSJUTJMInU2SCJUOSSKkSoRUiVAZWZR4Qx5NkgiV1O89iRAb9W/JH0uEYhsSIVEiJEqERImQKBESJEKCRGhDMsvgHif0XCJZCWkS7CSkSe1DSJPQCekSIUkahDQpExKlg5AmtURIkzohTboXoXkhtKuW9Lnx3S50p/hL16E83SRBWoeCcxfmAhQfX74PXSXk24ddyyRdy5CDTV/WUZahd4DmlqETrCpQfJ8qUAVzBSoWJAEKe9wFKG5fnyFNIrQvCVDc41WAwh4fEsQ9Hu+AL97ql+y+w/r7AAAAAElFTkSuQmCC"

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAD0kAxmdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX/0kAxmdX9mdX/0kAz0kAz0kAxmdX/0kAxmdX9mdX9mdX9mdX/0kAybf1SVD0joAAAAFXRSTlMAnxDPn++/j0Agj4BgvyCAcECvUN/PivQNAAAA5UlEQVR4Xu3V3XLCMAyE0Y0dyfkzNLRK3/9Ny5Un0ELHyl6Bvwc4s7oS3rZhvqiYqM6fAe7GXmxXXLyM3fcBR4vYrzyTbuZ8zcM1OAp7RxZ4C3HnxJHkBJIDjiOkPTaTHAskJ5IcU5JjSnJMSY4pyTFjOd9dnZFM0p/OtnXHthTnKlGcKik9duokeehUSk+cIjlPiyrFqZBCf8voCKDbHBL6+ydIkRJYEkiSgCQlcKQeIEjFOSYlsQQQpFKT/q9JTWpSk5o00aQTSzqDJGWQpAySNIEkreBIHQ42kRzgdM55WvHi/QA6YV/CcfzmHAAAAABJRU5ErkJggg=="

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAgVBMVEUAAACImaaImaaImaZmdX/h6O3M1t3h6O3M1t1mdX/h6O2Imabh6O2Imabh6O2ImabM1t21wsvM1t1te4XFz9a7xs2quMJod4FmdX+Imaamsrqzv8hzg457jJeotLx9jprh6O3M1t25xMuMnalse4W/y9OisLvZ4eeqtr93hpG7x88aBDP8AAAAF3RSTlMAEM+f75/PEBBgj4/P7+/fn++/79+/IMVSgv8AAAG+SURBVHhetdbHbsMwEIRhyZTjWI5bGqnillre/wGzgEEMFuRhxUl48e0DFiPgd5V97ebcLir6Le7O8uZ/4kDiHEisw0u3N59nRoJzuXASHC21hKOkDeFoqcS5vypKaovv0tKccCBxDiTWgcQ5eLvpTp1z9vV0Z/aROkM3qyc7XZdIx66DZHcSqR8FOvhmOQESJ5H6cBLIh9DYnZUgUYLjxTmFELz9OiGiBCeMAo0CjTOztE4kceJl8gvJdhqkrxBwWdzO0junpf0YcBm2U72zSLva4zJsB8couapqcBm2g2OTnLDLxh/iZdgOjkESB9+619s9G3vnohOlk97u9d3au1W3XlUVJHWZOKW909uJU9g7vZ04hb3T233/ML3Ddm8vRO+wnThE77AdHKp3tYfD9e4BDte7x//sHdpC9W5AW6jeDWgL1bsBbaF6N6AtVO+Oqi1E75K2lPWuz7cFz9i7PtOWEukp15YCyWXbMl1y+bZMlpxqS8F26B3aUrqd7l3+f0HBWxLbqcdth8dth5ffjpD0ZYSktsOXRm53fVsByO0AsdvhNHI7NRuxHeNgO9LBdqSD7eCQkttunXb49wsQB7KnpVMNJAAAAABJRU5ErkJggg=="

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAclBMVEUAAADM1t0pLzPM1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t0pLzMpLzPM1t3M1t3M1t0pLzPM1t3M1t0pLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzNqcncpLzPM1t1ITlNmbnPCzNI9REitt71WZuVSAAAAH3RSTlMAn5/vgDBAEM9gUL9g7yCPcECv34BwUCAwz48Qr7/vVF+3wgAAATBJREFUeF7t1EluwzAQRNGmSJEaosmyMw5kpvtfMYE2tYmhdqoXXuQf4AEqNSjW3T/kPJx45yZvVQYOJM6BRDqQWIeXbmFQ0t2QbaQTAE6qspF0zEbSkq2kRzOpug7pXzpaScOTlbQIKQGykYY2hGggfX6VnxwtvX2UwklwOAkOJ8FhJTi89L4BpLQ8v7wCYCRpARASHEaCw0tTOV8r+hwASgoAOMmXnTolVPbytRKykhqFNGqg2u9LTVJJq5WUegDkiU9mUrc/1KyT6gYAd+LpQJ4TCvQ5YSjlEfBDOQDkUEG0BfpNwVDsr8NQ3OAoOXJwNJMXjqLnZkJjo5iJH2oCQA4VAXBDrekiaezJj0PxLFWLEdXLxdXOk3uj9hcryN+K4bAq3hOtFuew1UW5wr4BgYjO8MhZPS0AAAAASUVORK5CYII="

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAn1BMVEUAAAC/aVK/aVK/aVK/aVK/aVK/aVK/aVKaqrS/aVK/aVK/aVK/aVK/aVK/aVKaqrSaqrSaqrSaqrS/aVK/aVKaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSfoqi2eWumlpWcpq66cV6tioO/aVJndX+aqrSNmaLG0Nd0goyHlqBqeIJxf4nM1t2Nnad9jJaUo61tfIaBkJp475xoAAAAIHRSTlMAUN8AQI8gcK8wEO+fYM/fnyAAgL8Qz1CAYEC/7zBwj8Cy0BoAAAIYSURBVHja7dVte5owFIBhJXYy0AERRCJi27UhfVu7l///27acC3OQQEhpPq0+nzB63YagyezSJUflkfhXlNOzYLQvRvuaUZqLppaEo3r5EKS+OaIYjmodKYWSypcf8g8NlAkVMjiqV2bAxOr1ASAx3M+X+rynZxiPKaWVwPwR6E+t9+OXfKegsWg3Av2uHx5fVY8PIL2AFIn3QHUtHZSaOQktfxJUPwvMarHfau3WoKfufMAxQgMJVVQA8mFom1EMIa0xqATHAXSk1pB5sdk5FE1+/PQcyqf9IHUINzDLv8ggNJDpTwvdc2/1hahmZCDDNgJdc9nGBjJ3w6E0+CB0y5u+BRYQq+Jtv/P9jp9aWUBU1qvdc2xuCQGmBLXSmGcJ4SG3U3O74e3W9tBOHXtMrTTmjULJCYKJFPKqwpXGFiaobB3OCZ7De3nJO61MkA8nIZRt1RZ/ALILhSaowj1QXu4TnFDMu301QBk8JypLGJMMkDKmQUuE9OBUPtB2BThbqkErE5SVsDKaI5gOpSaI5EJKuxOT+WrP51pGiBwFUHHBGMvjUjQ31gcFABkkLT/rhRZmiOSlwPAx6tASIENZ3GbihA5AVwCZqcqHaZX7Cph+KNUgq3QodAXxwBW0cAUtXUFXrqDUFRS6gvh/AqWuFnutQ+tJEPG6jkemQYuRjc2+edhmwjmZCpFg46nb2gQEIAddoM8O/QW/i3JdtLfW8AAAAABJRU5ErkJggg=="

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAt1BMVEUAAAD9y1hndX/9y1jxjybxjybxjyZndX/xjybxjybxjybxjybxjyb9y1j9y1jxjyZndX/xjybxjybxjybxjyb9y1j9y1jxjyb9y1hndX/9y1j5t0dndX/9y1j9y1hndX/9y1hndX9ndX/9y1j9y1j9y1jylSv7wlFndX/2qTv8xlP7v077wVB+eXB2eHX9y1jxjybxjyb9y1hndX/7wE+9hUf5tUXykyn2pjmsglObf154eHTGh0IcN0AzAAAAMXRSTlMAYGCfEN/Pn1Dvn3BggEBA3zCAj6/PML8QECDvr9+PUFCPQO+/cJ9wgN+vn2C/j68g3Uqs5AAAAfJJREFUeNrd1dl2wiAQBmBiCEate/fa2n3fBrT7+z9X1SNnSoeOBLnqf02+wMCAiEnnUOvDTKydjl5kfWlLJ5K0TiTpVNJWKqmjU0lZKknepJGkgrc1peOni4UDjtSJqk0+d1wpj6vxAcAv6Txyr15+S0dRDkrqiq8R76CkpMjOmF3jHJQWjhD77XZ7P8ZBScnonnCTJ3FQincw25EOhRI5+T91DmQa5wWUTOMAqEQOwDDc2ZgwDkAZ7MDrhHGgIUMd8Em3CmwGQc79K/ikXEhVaUqZnqDknsN+g5vSXr1nRqfOflmJnOeWhQqP0zPz1Ow7qDWVsC92rNQnUH3OoNTWVEJHlBZqEahnHCnTRHL6tFhCmwQyxpVyIjn93vyzSKOVUu6esWUIdGpWSHfO8C6FbGq81BQMFC6hQ6Bq0qVgoHAJ68wWm5eIw2w/Kx0RhzmQrLS7KzBMi/ASDW3aeIm/Rq6NOQmV+g1mZWaWepjEX7VmlfQ8VItvN1v85X/CS7IJGP7ur3NSt0EUfCCDpTE2BAaf7HDpE7xRQlSV/I4UoRIPUYdKNStxSysFmwczy6NwpC8v1GSdEj6MMVP7t3FvNh/ikDbzXzPT9+nPQXJQgD8s5Bs0qAyVBVROUXociAqVijiIFh0ikxhKv7T4Yqff/m9ly4ozdiLFiAAAAABJRU5ErkJggg=="

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABGlBMVEUAAACaqrQpLzOaqrSaqrTaL0eaqrSaqrSdBSKaqrTaL0faL0cpLzOaqrQpLzPaL0faL0cpLzMpLzOaqrQpLzMpLzOdBSKdBSKdBSKdBSLaL0faL0cpLzOaqrSaqrSaqrTaL0edBSKdBSK7GjQpLzPaL0eaqrSaqrQpLzOaqrS7GjTJIzwpLzOdBSLaL0cpLzMpLzOdBSLLJT5rLzs4LzUpLzPEIDq7GjS8GjXaL0enkZ7EIDnaL0cpLzOdBSKaqrTSKkJMVVvWLEWhCCS7GjTDHznEL0XLJT7HIjueoq2Mm6Q/Lza8GjWCLz2/HTbYLkbOJ0DWN05rLzuYL0DPL0a0FTCsECu9GzVVLziqi5muL0I0LzS6bX7UK0OWmU5OAAAAPHRSTlMA798gn99gEBBAgL/v30BgnyCfv1AQIJ/vv0AgvzBQgBBAgN+A749wYK9gj89QMHCPMICAvzCfEGBQ79/KNAVUAAACc0lEQVR4Xs3UZ3eiUBAG4KGIwdhj1BRNMX17bxQ1Pdt7//9/Y3FZHBm4OGP8sO+new6chxeYe+G/zfKdxnycouvqB3OAdtxR1svzKDQXqu6OU69dw6mhg9TMhTDFB5uzOY/ceH6e7RZmotYJ9NpxnFxF7pRpoU+Oo6DEhcIsroqcBnFehoXk1E0CfXQmU11jQ7QQIkLqLi1Ew56FA93FfENATi3vFMfQj4SCsyChaCE5VasrC+Es8KkPTmaYEpQfnmVDBeBmdTHLGT5+AuxUcmro4qR3BHOghidBXlT40mZhV1EoSJ/+PDnVHzmn0jNhrZqATkfQb9zIIooWupCdCTgLtNCQbmQ59Q4LEUo4C28C5+tb4UamVFToPOVMeMpkDFO7/PXecW70wkI0w+OVLY7T0fwgl9+fd+Coh4UwrzzPY1BG4ITRDICUKe0fe6O0mlMg0x/HTB34z96/bGdDGkJauHeq8UJelFvZkD8RHPiUQisghgBuj6f03IuyBaJXowP/BQvJPjbmWS5W6J7o99OBx0It1kCGTgcSud+OoCZviwSMaUBKFrbbjEIN3U1Eb1CqFTjthUzHTQ2VoNmaMtR6OqRDIs3MQuAqArLIIfmridIt+f7VIAQGV/F1qStwwiH8Kw2Sa75UCqGScs2MhQcH5HGNh4rFLaSGRJXs2P0ITTzBZkFLEWQRCN95SVRIy1Mor2ElQaENoBBsCCoZWCgJYSUD2Kf0HiQh2Isgk13INwhEL3MLmUAhel0d+hEoRD9hRvC3HEI6BIf4U1mFbBVksyrt45yoIJyzfc52tdWQzdi6FrmHQPRp1vRCVhZkKSr9AWVSrbdopdv6AAAAAElFTkSuQmCC"

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAACMyveMyveMyveMyveMyveMyveMyveMyve/aVKMyveMyve/aVKMyveMyve/aVKMyveMyveMyve/aVKMyvddrexgr+1vuPBjse1ptO+GxvZmsu56v/N9wfSDxfWkNoxWAAAAE3RSTlMAQICvz7+fcDAAYO/fECBQUN8ACD4gxQAAAbhJREFUeNrt1ttygyAQgOEIaihIrWbxmOT9H7Od1onCyiJkOu1F/rvcfAkLGE+vnitjPIelojyLlujU+pJcgVNTZrGQZouCLElBmMECpsKQVECWZ4cgzSEYOwCJBg5UaAQRy6JqBA1JsLoNxgy3XUkJBBGO+S4kYUiA3fADDZ7VaR+k3fmYJd/EfVABcRCwfYgB0EvDZXvQu7MwPGxcvgeVgELbj5IYeoeUFIZKSEqu0OEfdB3NV+PVPkwuxELMNJulecIbt0JNyOnMo24rlRYUXtlsNs3u2lboHJqPsdrOSVgQB7rRhkZYO1tQaETGyRnSCkE6VGyh7AkI/gLCw06E8PYnQvhApkH4isRBU98Z0/UTfWnD0L1bvv+OHiN+SFNr6Sagyq2TrcCtN496EuIWVIDbdrgkxCyIkWeZhDILEsmQch61KnVp3IHK1GFLBxKJ26/QH2RBHEgihqAP/xUhUhpBbQEJsRZDWYKjNILSXiNkuwfpJtbhnndIEek02obWZNyAhP+FvUwZEIawRDsEVFeXw1X127bT9kN9iar2QlUcVHmhS2Qv6AX9Zyj9ivzapV174jHyCVIQXgup+Zk1AAAAAElFTkSuQmCC"

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAD8q0D8q0D8q0D8q0D8q0D8q0D8sEz7tVf35cz7uWP26tf18+71+Pr8q0D6vm/50p327uP41qn5zZH5yIb6w3r427T34MDTJ8uvAAAAB3RSTlMAYL8AIM/vi50ITwAAApRJREFUeF61mOmSgyAQhDEXN97J+7/pJoWkGaeELdztX0kVfmqP04OKj7pLOKFLd31LXK+3ezip++0Duj3KALkMwyLLpMftDapcz+r8W26tXNNVdBWO31QhdaLss3QJ5GTZcRGKmvxXz1BUGaR8pv4ESOegsR3UR4J+RdLQDBojwKhouVONoDlypu8v3QaSDnW31YdJVEs/Z2452QBSqBWo029AsifSW6niv9Qqa08lGcho3yRtKMg43yhnCGj0zRpzkPEnZDJQfwbUc5DVUduNOk2V/E0aOcjQttRYkQvNS5ZJbrZXeb5q3jT5qrBEzgtm49gXp0JoXoJN5ed3Mxy0A5p3+YCesCOCiEuWdD2TQfNu9RklAeEES/oxlyJhYskiWPz0NKEX/aHqJa1KJR9gKgHBGpeXXlm/ySpSFYv0JSDWbzpyIhXHoCpwmoNWD6lUJMgGBreBg+jJJjxx0EIswP1zkMGgBxjSewumw8x+0nP7nTA3cToGIktkAQTrJhb+zKSpCJqRaAcglE0VQNgzaQZiwa0LZj93deSggcYnLz985HYLFltoNfZA8nnzBIjVfls4H7RIalbkNUA0kEgcsaZViZqaFyAWkQhIEiNk1YxJABBN8lJkI0Rw205RkMTRB0OE5T2NNkFLP5TGGt0lIWwJCA7D0fEw+ul4DnxkL3zXB+ESdmGh/nETcR6k2jG4NRSqQWwTIW0rx0oCCnJoQtmBzH4m9gio2tZf1F9FaLNWQVxzll1Lar8GEF7XsmZtAeEFMmvWFhCMWbE5awIhBdCsTSCkAJxuBUk6RdpBYaabs3YQRqQNFdClDDIOr3clXUQXylJxrqlQVsc/RHFU39cw4Y5PY6f0uP3lx7q3/uLz4Q/vrxCimWP0zQAAAABJRU5ErkJggg=="

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAIVBMVEUAAABmdX9mdX9mdX9mdX9mdX9mdX/Gy4RTt7T//4dH3tRuRd2GAAAABnRSTlMAML+vAO9oBwRvAAABBklEQVR4Xu3WwUkDURhG0diDtmAJsw+kATc2MPi0AsEGXNiA2IGkSocQOLy5HUi+xSwel7P953DZ3eN6f8qOy/X1cPk+jPE0BV5FyxgvoY7PY6yi09iGAo0xRe8o0Nsu+kaBvnbRDwp03kcoUCIUKBEKlAgFSoQCJUKBEqFAiVCgRChQIhQoEQqUCAVKhAIlQoESoUCJUKBEKFAiFCgRCpTIzv8xukW36EOk+Z2iZbyKRJ9jnU8ZCuSUXW8ECrRdEtFMBdqiUIG2KFSgLQoVaItCBRKhQKJQIFEokCgUSBQKJAoFEoUCiUKBRKFAolAgUSiQKBRIFAokCgUShQKJSoFE5r9x3h9CwiyJteQmmwAAAABJRU5ErkJggg=="

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE0bZtZtAAAAEXRSTlMAnwDPEIBwQDDvr7/fUCBgjxmK6NYAAAHqSURBVHhexdjbjoQgDADQlouCIMj//+xGElztLrZKMsNzPWmLJQEQLETFL+BDsBQUQbwjkUDgiCTgHZkErCOUgHOkEjCOWALGEUvAOGIJGEcsAeOIJWAcsQSMI5aAcVhpHBov7aPN5iX88A+JKB8RxD6EJPTWIenB1bmV8C4WiEOkvkNpIA6Vug6VgPlEzANXRIO4goFpK4H6scBsNIE6sa8g3YEel2aIhC+bTSUUbj+FqITCH5JCVMKbESmWhdREnAYRaeYg55tDICJ5I+sR3h1syy4FwYhoxNuj1sRdmg7HlT/1rjXrRD6E0CIuX7oG5UK3INUGrVdmDlBKpciOeHdKsDXu1KDtwiQsBfbIcPFDlXKNOI2DrqnnKmtzzqb2FbBGRZsOyPhSqbCQqdIYYmn5tmSmKhcN6xG2tRK3wqzQ+mmPjCdQ8RyRU62HWXGPyov/pb2Bui/Dy+4jEscdb3ZoHoeyUiBprqD5FTJ6tLA2a84PQU41aKxN+Tz9ecyp0KCU6XmU3zoUUqt/6VBIufiU8e7/o9aEZ45O3TPbPnHs3eHvtJSJM3OFmEQ995a/QpiNdzCJrhBpu83KYxLfRUzu9kpP5tmlJk3/WNq6Nw8IZl7OyjKbrz6yUAm//BBFJfzyYx2VBI76AfiapNY2HslyAAAAAElFTkSuQmCC"

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAIVBMVEUAAAAjHyAjHyAjHyAjHyAjHyAjHyAjHyBgXl/Ozs/m5+hNqsnHAAAACHRSTlMAYL//ACDP71kzCuAAAAB9SURBVEjH7daxEUBAFIThrYEKjAq4gAIeFRgVUIESZEq4CtxVKb6Z422K98dfvgugcI9VIpDZKa2CYdNQN2F0agtKHTWoddTCEb0d9T5mCnuCjpjtTJDPo5CgeJMhQ4YMGfobomaDGiBqyr665tShoa4RdbKou0YdPxH9Ql7MWRv7Jo4FogAAAABJRU5ErkJggg=="

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAIVBMVEUAAADm5+jm5+jm5+jm5+jm5+jm5+jm5+ipqao7ODkjHyBclVLDAAAAB3RSTlMAYL8AIM/vi50ITwAAAH5JREFUeF7t1rERQEAQheFXg0QsUsBSgVEBPYgJrA7MKOEqcFel+GbO7Qqxf/zl7wEoOFtFBOpZaCQ0k4TWDi2LDShlNKOW0QJW9Ha0uZDI7xE6QrIzQi6NfITCTf9BhgwZMmRIng15gPRT9u01Vx0a1TVSnSzVXdMdPyL5Ql6HHJByqjTnRAAAAABJRU5ErkJggg=="

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAALVBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkSTnX7AAAAAD3RSTlMAECAAUIC/z/8wj2Dv368kIFc2AAABIElEQVR42u3YwY7DIAxF0TqD8QuQ/P/nVmLSToaqCeFZXfVsK91die3bJ8n0c+528JsEjYaNRQ0yEpqT4YWl+WIoG96w3B8SLThQVPpCecGJJXeEpogOcToLhYIuJRyHErqlg5CsuGCVdyExXGLShHadoVIbWnHZ2oSqhAHpNRQwJLShqWBImZpQxKD4P5QxLO9DsmDYIruQgqC7UAGh/IUyKPkZMlDsEZpBmrdQAiltIQPJfkMCmtRQAC3UkIKmNRRBizVkoFkNwcE39A0ZaOb7F1HQ1PcZEdDE66n1fvz5z5HzB5L/ZDsPEfxY4z9o8aOf/zDKj8f8wO6/QvBLjf+axS9+/Crqvxzz6zp/QPjQSYM/svBnH/4Q5X8a4/iH7iwvhCX+0zFZAAAAAElFTkSuQmCC"

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAALVBMVEUAAABVrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO6IGJelAAAAD3RSTlMAECAAUIC/z/8wj2Dv368kIFc2AAABIElEQVR42u3YwY7DIAxF0TqD8QuQ/P/nVmLSToaqCeFZXfVsK91die3bJ8n0c+528JsEjYaNRQ0yEpqT4YWl+WIoG96w3B8SLThQVPpCecGJJXeEpogOcToLhYIuJRyHErqlg5CsuGCVdyExXGLShHadoVIbWnHZ2oSqhAHpNRQwJLShqWBImZpQxKD4P5QxLO9DsmDYIruQgqC7UAGh/IUyKPkZMlDsEZpBmrdQAiltIQPJfkMCmtRQAC3UkIKmNRRBizVkoFkNwcE39A0ZaOb7F1HQ1PcZEdDE66n1fvz5z5HzB5L/ZDsPEfxY4z9o8aOf/zDKj8f8wO6/QvBLjf+axS9+/Crqvxzz6zp/QPjQSYM/svBnH/4Q5X8a4/iH7iwvhCX+0zFZAAAAAElFTkSuQmCC"

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAFVBMVEUAAAD/rDP/rDP/rDP/rDP/rDP/rDNLc9G3AAAABnRSTlMAgM8QAJ+N+GT2AAAA8klEQVR4Xp3WwUnFUBCG0a+Ghw08FAsQG9CMLaQAF+m/BPc5BMOd9XACl8z801o9np9zquZUP8fx+m/Tfhy/ZyohqYSkEpJKSCohqYSkEpJKSCohqYSkEpJKSCohqYSkEpJKSCohqYSkEpJKSCohqYSkEpJKSCohqYSkEpJKSCohqTYgqOkLgHrpG4B6u9V073PzDsAbNB83nmA2KR8TCmgaKKBpoICmgQKaBuri95VyEKQcKSmHE+pizKVcGFKuHimXmNT1Otx2ocUV7bJfjA0DaDHKDMXleDWo1yPf42H9DPGgWT+NPLLWz7Xt8RybKOsPCmpBtMQaQ0kAAAAASUVORK5CYII="

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAFVBMVEUAAABVrO5VrO5VrO5VrO5VrO5VrO67MPsPAAAABnRSTlMAgM8QAJ+N+GT2AAAA+UlEQVR4XqXWy01DMRAF0FtDRAMRiALQawA8tEABWbj/Eli8XY7EjcisrWPJnzuT/9XlesxdZe7qe+/Xuuhn79uBBCQVIakISUVIKkJSEZKKkFSEpCIkFSGpCElFSCpCUhGSipBUhKQiJBUhqQhJRUgqQlIRkoqQVISkIiQVIakISUVIKkJSWUBQk89d6yVffdHbQ4se227eATiDzEc/gsyS8jBPql2LlBd8UvWpSPnopHy+UECnBOWXkvJzQgGdkpSBIWX0SBliUH/E4erB2iO6h31vG70B9VbWm+IT7bU36t7y+/AABdQGmj4a9SHr+XFtXa4zSr1+AQpqQbR11bYhAAAAAElFTkSuQmCC"

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAG1BMVEUAAAD/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDO3qpHeAAAACHRSTlMAQAAQv5/PrypZZKMAAAC/SURBVHhe7dQxjsJADAXQzxVS0RLgAhR7AKrUc4Vttt8TUIB8bMpI85AiTYnyy5H1CtvjmD17cpjmPukfzstzu+inqiH10F8VVISkIiQVIakISUVIKkJSEZKKkFSEpCIkFSGpCElFSCpCUhFaKaSlyLOXrmWqddKxTD1Gii5l6t5JdqDqdbMF5PdzM4Uci5ADBlolKCCXTsj1FfIjCK2S1P/Y55RqYwdDqo0dMak2dlihgAaP/XyaNovM9xft0ht3UtWUdLMYXwAAAABJRU5ErkJggg=="

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAG1BMVEUAAABVrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO62E5ZzAAAACXRSTlMAQAAQv/+fz6/p+UjWAAAAv0lEQVR4Ae3UsW2EQBQE0LkWkFzAwekKuMS5JQpw8HFOCxYVuHFnDvYhkDY1E49eAPsn5sqV3IaxTcYm07ycl96r1rPStFVBRUgqQlIRkoqQVISkIiQVIakISUVIKkJSEZKKkFSEpCIkFSGpv9JcZGlLzyqzNqW3KvPZU3pUmY+mNG1Fvl5+AvJ98DGB/C1C/mAgn8o+5KMT8vkCeQhAxyf103+cnnn/YDg9/SPmHPYPqxPdP/bjfdgpmf9Wukq/Cd578evKOzUAAAAASUVORK5CYII="

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAADnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDkYbFIAAAAEHRSTlMAEO8gv6+AQDDfUHDPj2CfAHcyNwAAAMpJREFUeF7t1FsOwjAMRFE7adr0yex/tUgVyBAhVHu+QDk7uNLY8ju6rutyFUO4AYMKbwSAIrSM0yKsAaeUhbPiYSDDEp5WMswwIzhgsEmYJrzaJarg3SQxCxqzcmGm8GGID3xCIzhwndEIDnzHZysZZioXZjZ1fzMTHnhFIzrwDd8k5cJMIcPM4fhmJjzwFY3gwHPCBSMZZioR5hq4Jly0e75ZfOALrkvKhZniCAsOfIJPyo5vFhn4AbfF8T0Cl5LdaXOW/9V1XXcHjLVDWNeEyWYAAAAASUVORK5CYII="

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAADnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDkYbFIAAAAEHRSTlMA7yAQv6/fgEBQcDCPz2CfGQTH8wAAAMNJREFUeF7t1dGRgzAQBNHRrhAYMKf8o70EmLPbX1flfRlMVa+k/6eUUmJMaITurBNbdeea2EN3Ek/rurdNpoWMZSKXnGwTWOQ9yLCUAcdtMuC4U3/b53ueqRf6fMuhV6Kx2/B2mLTXWdJewKS9FSbtPVnS3sGTFh93ihg+aSEbTNo7zbBdUA6QNB/XQtyP+X6wbChp8oCP1GcWkDQZd+pjl0ma6yZpLJpJGttN0lw3SWNhkuZWnzS/uZ4ykDj0jUop5Rev60NZI0iJ+gAAAABJRU5ErkJggg=="

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAACaqrSaqrSaqrSaqrSaqrSaqrSaqrSltL2rucHT2+D1+Pre5emgr7jI0dfZ4OS2wsrv8/bCzNO8x87k6e3N1tuxvsbq7vFE2wohAAAACHRSTlMAYL//ACDP71kzCuAAAAEoSURBVHgBrMwJAQAgCAPAsQf7N1YzwAU4fEUNsPzATmuo86McjZ28qLWgjdKKAnciQktuO/aSG0EIA2F4a1IY2v2A+980o1GiTCY8bGAV9X+Ab12qG/qvELk10AfgeQEU8CjOQ4Rn2zTk8UxoEtrxlZ+DSPDdPgV5/OQmoAMvneMQC167hqGI36VBaMNbmYcgFrwXh6CIv20DUEIhITPEGaW8GbpQbjdCCbWcCeKMWidboIB6lwFyaJX00IlWwloooF1UQg69Dh3k0UtIA+3o5xUQCRSFPuShyvWgHbpObkMsUHa1oQh1qQVt0Cdch1hgKNahCFNHDUqwJVSGOMOYL0MHzG1FKMBcKEKUYSzTvfxv6IZuaNXJsuz2WXVELbvGVp51j1bch59v2GItUTo6rgAAAABJRU5ErkJggg=="

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAACaqrSaqrSaqrSaqrSaqrSaqrSaqrSltL3q7vH1+PrI0de8x862wsqgr7je5emxvsbv8/bZ4OTN1tvCzNPk6e2rucHT2+AyI9sfAAAACHRSTlMAYL//ACDP71kzCuAAAAEqSURBVHgB7dhRboMwEIRhwwCxY7LGhND737TwDtOM2Ic+MAf4JEs/TbVhX9Piwtqm2xa6rh9wcUO/Q/0Dl/foN2iAw4YuNHBZE1q4rA1w2r+FbuiGYnqKS/EQyk95+RAadeh1CJn8tIJDCJPo1HgCYdagEWeQVcWZSUcv5WFGIOVxEwgkPO4NCmH50vkYh4DyHbTiLyhW5dsgEBYpaQKhSEkTKEpJEwhZSJpC+AhJU2gVkqYQMk1agJDOk4YETSRpCcL7xFkgQpZI0gqEiSQtQfghPz8SZJUnTSH+BzwZg8hmkrQEWSVJKxBGkrQEoZCkJShWkrQCYSFJSxAKSVqCIklagpBJ0hK0f3PFPCDE9f7P//Ju6IbcjixuZx+3Q5TfacztWLfN43z4C16LXeocE7ZXAAAAAElFTkSuQmCC"

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAeFBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWisry0wcrG0djP2d/h6O3CzdXY4OarusOntsC9ydGkr7ZmdX/U3OPd5OrZ4eaMmaGUoKjK0tiFkpvCy9K7xMt1g43S2t9ufIazvcRZG49dAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAACT0lEQVR4AazT0XayMAzA8dZKhCpTicJEkblNv/d/w2/MrjGuTdk5/C+Qq9+xTVBCembmGbiyuZnpRTy1iJQX3qCyIv8bpI2FSNbo0dByBWKr5ShIF5Cs0GmotDAiWyYg/QIje9ESlFsYnc3jUAm89WZboavabtbAK2NQwZXdHp/a77hVMCjs1BUGq+qIpIJOwxlONUFJhe7nFR87tO0BH3vl98ShHHzNEVntV8g6NuDLOaRp7vUJUxCeatoCzSDaww1iHKI2tJmPUMmcNMSkkiA6WI0JiKr54RSbfHOSoO7cnju6p4Z2wEFL+OmIEtS3bBGO8NPSQSvaHwl6G1760D6t7pD2B0MRugwv74iUP5z+hgy4KhH6GH7P/GsBl/mGLE1Mgj6H32t4cnaAcukPEXRo/VVTFX0oys9+jRJ0vX09bx0+tfYboBaZe9+JUD88/+FzO7iXLZSf2V6C3ofHBX+193NTM+FkBNHoI2ebKUNfqwDRLka+XaPm7m2bgm5XDLSFe3OVCcMniEYfWYBMgQsT0GeHwcA1GvrAaaALTgS9YaTmb1CPE/yjQ9ueuwmgRJND/1uxmxuEYSgIwh3EBUD/dXIc+QCfkHYKyCV++4cHKXqQOBHRieBoRUcLGRHJCIRNJGyQWpDUQvxF4g87EtkRDBJkkLBskWUjRIhCBGINKNYgaIE7aCH6/eB9in4Oo+EwyngciscI7PjOgwrxBVSIq9ScF//XuUuNa1a4Zm2L36CKDsrxoK6vBoTVpDEaWdazz36I2k9j+7Eu/poPP57KBl0HeoZPAAAAAElFTkSuQmCC"

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAflBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWisry0wcrG0djP2d/h6O3CzdXY4OarusOntsC9ydGkr7ZmdX/U3OPd5OrCy9J1g41ufIbK0tjS2t+FkpuMmaHZ4eacp6+rtr19i5SUoKi7xMv2K1ozAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAACSklEQVR4AazVi3KrIBCAYRBdFbUqa5KGXNqk9nLe/wVPJhJXGhGc6f8A37CwJmwhHok4AVMSi4in7ljqKMtHg0rybB3EhQRHUvBgqChhsbIIgngO3nLuhyoJAcnKA/EXCOyFL0GZhOBk5oYqsKubVqFJtU0NdpULym2l2+CvNp1t5VPI4WwVzqa2DonNOjuFztRuVmJ0P9QrTttrvcdpr8/3RFA2Oc4BrfQttDpMDpXZEJd0O0f0QXikm5LcgmgPG0Q3RDW0mVOocjkEuaWKIBpsix6I2trDMevld8dw6LijHTBQAY8O6IWoAzwqDFTS/qyBaJ/KAeLjYBgEUeNw/A4JMKm1kAKTuEPS8WJeiF5O3iD6ONR6SNGHwsa3rzEMOp312zua6nEDWJrAUBcEXa761geaOhhKUsbBtAmA+k+tLWgDJs4imswLfb3dGRqNZouYoK/VA52+9dBn//ztChbDUOuBLh+GuV5wUgtDMUs8jz9A/d4w59P8AiQMTLgIPS7nC38HpjDI9NPjX0DXd8Q/gM7/ln8BQu9oT1OtPxH9Qf7Qk/shd3SYIOh/K3ZzgzAMBUG4g7gA6L9OjiMf0AfSTgG5xG//gD6EByl6kDgR0YngaEVHCxkRyQiETSRskFqQ1EL8ReIPOwrZEQwyYJC27LBlK0QEQoRiTSDWKGiFghai3xfep+jnMBoOo4jHgXiMwO7vPD9XiHCFuErNefF/navUuGYFatay+O2r6KAc7+v6bkDYTRq7kWU4++yGqOE0Nhrr4q/58AO/WgbBPY1hhAAAAABJRU5ErkJggg=="

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAV1BMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWisry0wcrG0djP2d/h6O3CzdXY4OarusOntsC9ydGkr7ZmdX/U3OPd5Oqr3DOHAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAACB0lEQVR4AbzTgbZzMAzA8VYJiqFBZ7z/c97vTifLd3SxnZ37f4Df0STUi3Ri0gxCWWoSncdTeaSi3A0qK4v3IG0sRLJGn4aqGl5WV6cgXYJYqWWosXAi2wiQvsDJLvoVVFg4nS3iUAO8tusdhlzftcBrYlDJlWHE/xoHbpXHEHMmh4e5KSKpQ8c7jOb8oaSO5nPF5+bbbcbnrnxOHCpgzy/Iuv0LWYuHvYJD2tJ0VpQgXGlSVjOI7rBDjENUR5f5DDXMkSEmNQTRwyYUIGrij1Ns8349D62ebiBAFTxaUISoBR5VAarpfmTo6J7qDdIQ8ihDLA8hfYcMhNy7kIOQuUOWNiZA0c3ZX6iIfpAMOfpR1L77Ft+HsN0vQOUZbA2fQANsZbnSEBo/gUYIaZVILwuQ8LZEGfpbZSj+7xqVwlb/GdTDVqoyYfkC5B7TVhBCAYoFoT+Fjpq/BNE3+m9BcB6af1qxexMEgjCKoplg4hSg/ddpIlw2WA7CuwUsiPO9v8VPM/sP9SAFHmQnInAiHS3A0UJGQjICYQsJG6Q2ILUQ/5D4w45CdgSDDBikLDts2QgRgRCBWBOINQhagaB1H/3M5zx+PB1Gw2FU8TgQjxHY/Z0XKsQNqBCXUnPe/L/OtdS4ZoVr1rb4DarooBwP6vpqQFhNGqORZT377Ieo/TS2H+vir/nwCwaaBOMlTCGwAAAAAElFTkSuQmCC"

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAgVBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWisry0wcrG0djP2d/h6O3CzdXY4OarusOntsC9ydGkr7ZmdX/U3OPd5OrS2t/Z4eZufIZ1g427xMuFkpvK0tjCy9KUoKizvcSrtr2MmaF9i5Scp6+St9JTAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAACRUlEQVR4AbzSC5KjIBSFYQjxBIhPrkprnNf+NznpgF25VSGi0zX/Ar6qw0W8SZ7UuUCsOKuTvKQTl0TaBINVGL0PksoikVUyG7qWeFt5zYKkwWZGbkOVRUa22oBkjcxq+Q7SFtlZnYYq8Jq2cxRzXduAV6Ugw5V+IB4NPbcMg147o6OXuTEhiZeO5wynPJc4xN/ng56b5nmi5z74O3FI4yt/I9Z8j1g3j680h6TF2rjQFkTLiDUrGVRjrSVKQKwWa/UzVDFnE+JSFSE2bKRciEY+TrDL+yUfWjxiZoWuWLtRPkQ3rF0jVPL/kwWx/1QGSCLmaR9EHjH5gBRibi/kEFMPyPKLZULscvYT0oi5/ZBDTN8hg1BD+yFqEDJ3qECoPwL1CBUXIREbjkADYlKc+LJ8iG87CYVQewxqEVLijFB3DOoQOosCIXcMcggVAjE6BhFi/xv68Q3Qz0/o10SJ/A7o0e8//zxtmkN/WzGjHASBIIYegQMoC1lWQe5/QD8oCZiSF0nfAZqgO5126nRbSLQqqVe5LSTew6Y0zJdC9CBF2b9vbFcPEkdE9Iukau9HhId2p30ktRY3tN5GPPP+U03GRg7GxpR1U1qMsZ2slumrhH6s1pg/0UZ92sn8zTpiil9HuCAFLkhY2QJWNocIQSGCY43gWMNBS3DQ8tGPeXbH6MdhVEAY5XgsKB5zYBcU2LlCCKgQvtR0+N89OlNquGYJrlnh4perorlynKvruQNC7qSRO7IEzz65Q1TwNJY71om/zodfJZIG+gDaQwMAAAAASUVORK5CYII="

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAgVBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWisry0wcrG0djP2d/h6O3CzdXY4OarusOntsC9ydGkr7ZmdX/U3OPd5OrZ4ebCy9KFkpuUoKizvcTS2t9ufIZ1g427xMuMmaHK0th9i5Srtr2cp68PUIGhAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAACRUlEQVR4AdTS7ZKjIBCFYRA9AfymVWaiu/d/mZsMOJWuChH9t+8FPFWHRnxIFqqsEKtKVchbOnFLpE0wWJXR5yCpLBJZJbOhusHHmjoLkgaHGXkMtRYZ2fYAkh0y6+QnSFtkZ3UaasHrh9FRzI1DD16bggxXppl4NE/cMhx66yyO3uaWhCTeOp4znPJc4hB/ny967ft+/6bXvvg7cUjjN78S6/6IWKvHb5pD0mJv2egIom3BnpUM6rA3ECUg1oC97hVquXMIMamNEBu2UC5ECx8n2OX9lg9tHjGzQzX2VsqHaMVeHaGG/Z88iP2nJkASMU/nIPKIyR9IIebOQg4x9QNZdrFciF3OPiGNmDsPOcT0AzII9XQeoh4h84AqhKYr0IRQdRMSsfkKNCMmRcGX5UN8WyEUQsM1aEBIiRKh8Ro0IlSKCiF3DXIIVQIxugYRYv8j9OcJ/aVU/l8rZnjCIBjE0A3qAGJt1Wp1/wHb/CiEg8+HNG+AoHDfJblrQmPi1x5SegaEpvkrNA//C8mz5dogBAMphkVKEwwkPRHxktAKTwQfrRhbI2CPFteI2CT0Pl8jtNhsBPbTxcarVgx1BOqqxeX/Y9cnHe3lD3Zk1BEodgQGadzLkysGCZYNI+CWDSHCmCS0tEMExBrjkFI71nDQ8hGY20GLop+xretm0a/z6Mdh1KEwCvFYcDzmwE46N64QFaoQtdR0Pen0nZcarFkO1KxA8UtW0Xw5ztf13AEhd9LIHVmCZ5/cISp4Gosc65xL58MPa8QHEedZwGEAAAAASUVORK5CYII="

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAV1BMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWisry0wcrG0djP2d/h6O3CzdXY4OarusOntsC9ydGkr7ZmdX/U3OPd5Oqr3DOHAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAAB0ElEQVR4AZzSDc6rIBCFYRA9Av4zKm11/+u8vR9oOkmt6LuAJxkO4kcyU3mBWJGrTJbHifIgbYLBKoy+BkllcZBVMhmqavysrpIgaXCakedQY5GQbU4g2SKxVv6CtEVyVh9DDXhdPziKuaHvwGuOIMOVcSLiTSO3zHeIObOjr7n5QBJfHc8ZTnkucYi/z4M+e75eT/rswd+JQxp7fiHW6x2xFo89zSFpsTWvdAbROmPLSga12Oppj0O8HlvtJ9Rw5wziUhMhdthMqRDN/DjBlvdrOrR6xMwGVdhaKB2iBVtVhGr2f9Ig9p/qAEnEPF2DyCMm/yCFmLsKOcTUH2TZYqkQW87+hzRi7jrkENOl2Lfv6DpEHULmDRUIjXegEaGiFBKx6Q40ISZFxi9Lh/htmVAI9fegHiElcoSGe9CAUC4KhNw9yCFUCMToHkSI/evGjm0ABGIoho6QkuL235MBXESgV10GiCi4H/tfuOjxX3TtIvdDsieiHq2LERZsLGpd+LNzxA6kO9kMIgDWaND6iX4T9AMwuuNxFaJ4vAB7Zgf2KkRnV4hKzZxtz5lKza5ZnWqWFz+qok6Ona67AsFVGq5kgbWPK6JUNQbKusyn+vAFA9AE5DFvwK4AAAAASUVORK5CYII="

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAgVBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWisry0wcrG0djP2d/h6O3CzdXY4OarusOntsC9ydGkr7ZmdX/U3OPZ4ebd5OrCy9KFkpuzvcSUoKhufIbS2t91g42MmaG7xMt9i5TK0tirtr2cp68U9EFtAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAACQ0lEQVR4AdTTaXKDMAyGYYvlA8xusSSh3P+abYNNUSYEw7++B3hmJNnqQxSEUQxbHIUBJfupZKc0WwxRnKXnIAo1dtIheUN5gY8VuRdEGQ7L6BgqNTzS5QFEFTyr6BOUanin032ohKxuWsM20zY1ZOUelEml6/mlvpNWJqG3zmD4bWbYkdRbZ5SMpEYpSUju58bb7o/Hnbfd5J4klGJtnHjb1+MnFk0j1lIJkYZrmPkI4nmAS5OAKrgafs1CsgauaguVwjmEpFRaSAw2sC/EgxxOicuPsz80j7BlDsrhmtgf4gmu3EKFfD8+kHxPxQLROhifg3gdjp5QCJs5CxnYwiek5cU8IXE5/QulsJnzkPn7KGq9fc3nIa7XF6CSGEvdFajDUpwogq2/AvWwkQrkZP6QnC1Q7vjNNajBUqgiLLXXoBZLkXK7Ntcg47atYONrEMP2H6HvVsxgB2EYhqF/QD9gZYNuhbH//0CIerByeROac8vFUpXGsT0HUDUALSagR+A8rz+tth9OWy8Dxb3WxUYg/pBr4Gx1NPwheUV6AL3Uw4rQ0o7RL+phaZlG3gG0qwcaQWL78OgzsQHVjtFXAhLVEvkfPPpM/nCOxujV4zmCAzmWbFbPBzKfbB49nGwSEVsAaclYRJCsCZxDLcoaFFotjZ6FFkq/vXf80/ci6QdiFArEKMtjFctjFuznODewEFBsIbKpKdMZzlSSqSGbBQU2y2D8LFbUb479dt0XIPgiDV/IYox9fEGUMRozhXWqv+LDL62MBwJmqLv7AAAAAElFTkSuQmCC"

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAgVBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWisry0wcrG0djP2d/h6O3CzdXY4OarusOntsC9ydGkr7ZmdX/U3OPZ4ebd5OrS2t9ufIa7xMt1g43K0tiFkpuUoKjCy9Krtr2zvcSMmaGcp699i5QaLWImAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAACRUlEQVR4AZzSCRKjIBCFYRB9Iu60ShLH+19zZgJadipG9D/AV9WL+JFMVJohlKUqkflxIj9IF95gZYW+BkllcJBRMhoqK/ysKqMgWeC0Qp5DtUFEpj6BZIPIGvkL0gbRGX0M1eC1XW8pZPuuBa8+ggquDCN9NA7cKr5DzJksfc1OB5L46jjOcMpxiUN8Pw/a93y9nrTvwffEIY0tN9O+P69/EWt22NIckgZr00JnEC0T1oxkUIO1jj4LEK/DWrOHauacQlyqA8QGmygWookPJ9jl3RIPLQ6hYoVKrM0UD9GMtTJAFfufKIj/U+UhiZCjaxA5hOQbUgjZq5BFSL0hwy4WC7HLmf+QRshehyxCOhfb7Vu6DlG7fYDIM/iGO9AAX5YLidB4BxoRkiLhk8VDfLZEKPi6e1AHnxIpfP09qIcvFRl89h5k4csEQnQP+tuLGewgCMRA9BP2sCcqgoAg+P8fqGEzhzU1L6bIu9uklZ3ONOv3JxbqDirU9PamjRa6DWYHFBonKzSh1tq7FaY5Rwotve30j1yAQl8+yHlQVxoPfZDuE+k0nLXLgp6I82jbzQrPOQt8tI6MjBrOkn1cGXGEbbWdrR4OCtuH1KrQVA+HpbYWf7U2wHAc8XfXETTlrSNakIIWJK9swSubTYRAE0G2RqCtIaMlyGj51o+5ptr6sRkVaEbBHguwx2DYBRh2jhCCI4QTatIF/6/khBqOWYJjVjz4xaPo/8JxPK7HDwjxk8ahR5b42efMQxSfxs4/1omfzocvCBUG/W1VQvgAAAAASUVORK5CYII="

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAWlBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWisry0wcrG0djP2d/h6O3CzdXY4OarusOntsC9ydGkr7ZmdX/U3OPZ4ebd5OqGDsZAAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAACBklEQVR4AZzTC9KrIAyGYRCJilKVeGnrcf/bPJ1f6icdrdJ3Ac9MSBBfkolKNfl0qhKZHSeyg/JiNZAu8jhIKkMHGSUvQ2VFX6vKS5As6LRCnkPW0IWMPYHkjS52k9+g3NDlTH4MWQqrm9axz7VNTWH2CCpCpev5o74LrWIfCpzB8W5uOJDErjOGTEiNexIgS+jO2x7P54O33QnZTyintXHibf+erzhoGmktDyFp8Dozn0E846WMDCDcYcOfAWLU4DK3kA2cUyiULCAMNvAJhIZwOBFsfpyvQ/OIG/BQSe8mPoXQRO9KD1W4nxgI91QtkFwH4ziI1+HkH6TI52IhRz71BxlsLA7C5swLwudw8ZDDRxHr7muOh7heL0Bkmpa6X6COlnQmJPn6X6CefFIkmCwewmyJUPit8RD+rhIpLbW/QS0tpUJj+fEQDkAL8nEUhMj3vxl7t2EgiGEg2oE39q//Nh0OLjCeBSjwFCDgcCuK5P6gbkbEfNDr8Q+D/Gn38aA564PwIEkPshUBWpGWFmBpISMiGYGwiYQNUguSWoi/SPxxjkTnCAcSdCBxskUnGyZCZCJga0C2hkYrYLS+Wz/zPlk/m9GwGYU9DthjGHbPuf0aIcIR4hpqzpP/61xDDWNWIGatBL/9KLofjudxfb1A2K809kuWee2zX0TtV2P7ZV2M6sMPuNwE/qH6eZkAAAAASUVORK5CYII="

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAflBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrXh6O2ZqrXP2d+isrxmdX/Z4eantsDU3OPd5Oq0wcrG0djCzdXY4OarusOkr7Z1g43Cy9LS2t+Fkpu9ydFufIaMmaGcp6+rtr3K0tiUoKh9i5S7xMuRi/vgAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAJMSURBVHhetZgJkuIwDEVtQkgMQc7KvvTeM/e/4FC0ica/CVbKxTvAq7ItyZLUA/QkmabWkU6TiZ4No2YDZHnvYNI8GyfSibEDmESLRfOFfchiLhLp3AbJdVhUGCvAFAGRXlohS/1IlBkrxmTDogIE1XpTkqPcrCtQFUOi3LdsdwTstr4rB9E9z76ku5R7MIEIPK2nAVWLJhbh/bx6gkNdHzzVq2UKFGWsaTvP09QXyKNr2ZT5Im34dlYUEtGKb8poT8RxuCbkKkLWHJn/iwrPExChqWARH2xPUhHt/cMp7+XblVy0ajkGnGhub3QkF1Fnb8ydaMHxIxNhPC1+RLo/GI0TUX84fRUl1lGOFZXWkVxFhl9MKsKXMxcRJ0c5XlRyoqj+7StyfL3Vx5NMRFUfAWqWOtGWHO/1hZezSLR1onSmtHXsWHTloxGIdtah1YRPxke78vYZFPHZJir5na3NR/3Dn1NAxLmbqKkTbYih84tTvZ8Doo0TTVV6//FPR6c6uMIWCIBUWQchn7erAhFgHcMiar5rx2gR8vUSKWL+HuNETHOIvCPm/I0fpFyENBQnYgQiCEg5GJCQInIwRSBp5WDSQhmRg2UECpscLGxYauVgqeXiH3OyHL4jOfgdwQcpBj9I/LLF4JeNTYQcbCKwrZGDbQ02WnKw0cLWT8yqgtYPmlEJ2IwG22NG0h5jwz7WsxSMEIxohMChpgq+XVfBUCMZsxAcs543+MWPovHDcfy4/rQFQvxKI37JEr/2ecYiKn419vxlHTJqffgP8J0FtlJAnZ4AAAAASUVORK5CYII="

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAaVBMVEUAAACaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrTh6O3P2d+ntr+susKaqrRndX9vfIa1wcnG0djCzdSjsrvU3OLd5OnY4Oa+ydGzvcSkr7bZ4ebqxdI/AAAAEXRSTlMAEECAj7+fUCAA3++vYHAwz2989BwAAAKuSURBVHhevdhptqMgEAVgcAbjMwVq5rxh/4vs1x7DTWgLIT/6LuA7hQWcQhGKzPKiXFLldaMCEYpLXenRS7vrZCKUVe24nl2XAHV6DKTNZRxUg2GpCKgpx4jobAv6aMe4FDIEyXKMju55qPcafjmeDC0xp+PF+1IdB/Xti3K+k5f7+dWCBMh3BuOAr8Phy1lmYCSx6lhDyGGaDoQYuyqJNeeTnjP9hp7z+a8ESGp8nCuFIbpaSL0Hoe/DjbYgug3onXyBPpxzJOIh5IhT/Aw1LRwG4qUaEBY2UCxEAxbnoNq1Hd8H+4eBbtYdOwe5jl3J2z8/PERXt7hmgTrsHw+avgMQ9lM1QyjI0ku+p7kkHiLrSpqh7AGbV+hnKYmHzAPKZ6hCx9ZKAsR3Ts9Qi4LWSgpBBgdFuN5fiNZLCkB0cTtAuJWdidZLCkFntzbhenYnpqQQdHd9ExIrY0oCFFhbLTKcVqakAISzm4t8gU7ElBSGTgtUigLN50oCxG+AvSgXiChUErEZl3AQSkqG+JLSIb4kHrIPSAPiSzq8X5F35SZCfP4nVGFDpgcbUntHJDk4IjUObXpwaAvR4BpJD66RTqgWF1tycLH1Qu1w1aYGV22rhOqwtvdXVv1Ccnx/AxiMNkK5tQ3p0OBW9hfqUNK7BVUz5PpmUyGLiXSGcow1KcFYUy5jjWwxaCUEg1a2QCjJ3uIdjH4lhlE9pncOo3YDKMOYHX9aMWUBUgWkVGevniGpmScEwjwhxh6Q9ziym727XrznESDsb2Y/cc+sSgFakazhGWM9BxAkZGAoPEXhAIKU9DiGAwhS+LnOOIDQu/h0ioeU3MUy+37jJ0sdV1S+/dtHFttM2SgeQppqg8mif401ueaUturTftb1hV5TagBbENLUebl/GLosul7x+QOrMU9aPuGiPQAAAABJRU5ErkJggg=="

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAY1BMVEUAAACaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrTh6O2susLP2d+ntr+aqrTd5Omjsru1wclvfIbG0djU3OLY4ObCzdRndX++ydGzvcSC+UkeAAAAEXRSTlMAEECAj7+fUCAA3++vYHAwz2989BwAAAJ+SURBVHhe3dhbktsgEAVQEBISYEZGT78n+19lHAd3Yd+xGukjH7kLOEVXA6IlliILVVYxWtWNWYgwn1JrO77F7bxcCRXajT9n51dA3o4LcUrmQTUwSGVATTVmxBYc9OXGvJRyCZLVmB3bfobat4bPh1MfYvrTYX6VnP8Ete5FuV7CWy7XV8sDhE7XE/DrePxFVt+hRBA6w52hHG+3Y6CEfgApQuh8hzS3e0Kab5ASSFpi5nNYhsI5WVT7BlXkdFPgoDB1BDn5An2RcyAAoDQHknYp1LjEYSCQaoKSwrqQC4UuLS5CNbV9yocm2gYlQdSxc8iHwpmKayLk0/3DQ7ifdIRsdIawDgpUXPOAiifcr4X6J6QekIaOMRB2zj4ghwtCiFlSawT1fg4shJlpBwiq7LoFulJtgnp22QJdqG9CYmU8hLXVosDTykN4dpVQETptg04RqkSJzech3AB7UUUobIPCGPMfQsMTsgwEH8hNpdEneyOE+ZeQxg3JBzekZY4IhT8iNR5aPnhoS9HgNcIHrxEvjMOLDcNebK0wO7xqMdxV64wwnq+Nr0zfIUnfx+3NH+s7RLV166GOKvsDeW5J/IL0A6K+DWuhgXr2F1LwrIEsP2uqOEJIBw8tyOJDq4iQUfj04zMNyYIiZOy4vnNd8vIjqIBnNpsDOSodIUqQsp29SSFp0xGCzdTBMCJwOBrY3p1nGI8Iivub2U84ZmlDUCrh4IfpB3AIQmnskKJRFB2CSOKHY3AIAokf18lBCHvHxxuEKHKXy+xb5idLnbcoxf/2kSXPVI1BCNNohimyf401yn5SnG7X/axrS/uTUoMAEKapVbV/GrYqfWs+5zc4gE9RjzsQtgAAAABJRU5ErkJggg=="

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAaVBMVEUAAACaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSsusKjsrvh6O2ntr+aqrTP2d+1wcnd5OnY4ObU3OJndX9vfIbCzdTG0djZ4eazvcSkr7a+ydEXiY7KAAAAEXRSTlMAEECAj7+fUCAA3++vYHAwz2989BwAAAKUSURBVHhe1dhplqsgFARgEAWV2AbnjD3sf5EvL7Er0Wu48LNrAd8pDjhchC8yUWk2RyuTF56I4l2MLvtV7K6SkVCibb+dXRUBVWXviVUyDDKEoVQAlGd9QMqEgz5sH5ZU+iCJOnzK+j1Urza8Ga9DO2e4js1SstU7qLYL5XJoVzlcllZFIOo4VFlmcFQCRJ0ODM3QbUpiy/lpvfnZkADJEkxzbJkcX0rVKyiD46aWzeQAWbmAPuCMbVBGSLtXKLfECZcMoJeFuTY47rk4QAbbPnmAr/P56wWacAxSQNgx3359nk+n82LvsLh8hqqg8/N9ArQ+T/oBoVDXMoVO30u7Q6U7lPzCA1vocwkNv5C6Qxo7FliI7lx5h2x0IVqpLgT2vokohDQ4AQIru0QUQi5Ym8CeHfhCNAfsm5BYWUQhujYjEjytXCHvs6uEmqFrVCHkOkOZSLH5EYXoAdiLbIYiCyH9HAbiCvEQXyge8hbCG0CULHS6BYWYRizU/kVI40AykP9AlvwjAoh5RAweWg7yPrSpyJnXCAM1M1QJvLIPLOR7sdWi2OFVGw/hVWsLge9s44O4lekbJPF9jIfwOTI3CGtz8ZDDyv5DFSrFQiik7xD2rYuFOuzZA1L4rYmD8FuTFQ9IYnQ4hkD0RyuZoWelbgqHpg6FniMEpiIXDjkUyp9QgpZjKDTCUa8jRLotAfI4+wLQchRxEw9Njgwjgg5H3ZGDjg0ZjwDhfOM8EWhzzNIFoJVEB7/Vj/rQUQcQJDqKYnTAKEodQJAih2M4gCAFjutwKIS9C0/lu9KQu1BmXzOXLCaslOKvfWTKM1kedBGVa4ZJgq/GclW+U6yu4y7r6rTcUgwAHkJyo7I9rouytEKXjfwDbEpj85MQ7ZsAAAAASUVORK5CYII="

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAeFBMVEUAAACaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrTh6O2susKjsrvP2d+ntr/U3OLd5OlvfIZndX+aqrTCzdTY4Oa1wcmzvcTG0di+ydGstr3Z4ea7xMucp6/K0th+i5SGkpsmqRSAAAAAEXRSTlMAEECAj7+fUCAA3++vYHAwz2989BwAAAKqSURBVHhe1djZlqQgDAZgcEGFsi1wt9be3/8Np8fRWFbQwOmr+R/gO2HVwPbCgzCKp4gwSbOdsGwriZDDU9Qh555QINRgzyH3gHI57ESF3A1KEIMpByiNB4fIgIJe1OCWiO9BPB6cI4ttqJBroLzcKj2lul3KtaTyLahQK+V01k85n9ZWjiDsmEpbU5kNiVmdGhgLVVslZnPuejd3LC0Ql8CUjSbSPBRVPEExOKbVZFoDkOIr6AWci3bKBaTDI5Qq5LhLCUAPAzPaOWYZHEAJLHvrDrUw4xFAsGKN9kgDg0snKCf2D7mfxAgtBdXaMzWUNELBDFe+UDVD4QgJasXolZMjpLwKeu26Ky6pyBisfenCvH33fd8tbAk7gMHITg7Oe9evoROMjcGanelyPvox1wU6w7ox7jyyz6+R+frUGo8tYYHraX3tx3y8Wc9uyMIJutGz/JPu/Ym/TVDMIlh8epb777etPXlk8QS5zPKrxhmmIIiY5d9AV5jlX0IdzPLeDcAkCcEs0xXRkNb/ISTwhqQhvCElPiI0ZD8iCT60NIQPbcRSfI3QEL5GcgZX9tkDwhdbwbIDumpJCF+1KmPwnS3dITwy8QNx+D76Q9Xya8MyGJvxhwyM7C+Uo5IwRBQkRgjWrfaFalizf1A4w3c/6D478dRCcDVLDQXZf7SCCVpKqlt3qK2XgmZo+fcz7pCBgtIFCtBvNgldwAkfW4gISxiyO8cMoHUrYloaag1qRhhujuqGgpoStUcAwf6G/YQga5slMoBsUl2tP5AdavzAQRBIqBW9rn4/zYAdgLBEN8fgAIQkul0HB0N47ejke08a/ODKHAvikSVxKyqkn314RDNx6vQQlQqCCZyfxtJQbilKFH6PdUUkbUoCAA1B0iSMj7Mh4ygvsu38AaK9bRf57Zd6AAAAAElFTkSuQmCC"

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAY1BMVEUAAACaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrTh6O2susKjsrvCzdTP2d+ntr/U3OLd5OmaqrS1wcmzvcTG0di+ydHY4OZvfIZndX+qvvZKAAAAEXRSTlMAEECAj7+fUCAA3++vYHAwz2989BwAAAJ6SURBVHhevdiJspwgEAVQcAHF8THg7mzv/78yLxO8owZlqUruB5zqrgathpyFJmmWm7CUF+VJSHkUzsS0S3WpaSCUsGqy51IHQLWYTlKl1A/iYI4pD6jIJ4+IxAV9VZNfMnoG0XzyjpDHkNwNvJnvnTLp7nOzlar6CJLVRmmfapdnu7XWEjlwdKes6fSBRKxOD8ZC9VaJ2JyHOs3DIgGiAkwzKEeGVVFyB+Vw9KicGTWgim6gLziz8soM6bKGimrlhEoc0KoxrbyjP80B4hj76A+NOAYZIExsUAEZ0FxhoNpxfpzniRlILI2pwKC54g0lC9yFQt0CpW+IuSbmnpx4Q5WzIHdJsiSYfaMi0uAEEHTWxkAteiOY2TMGemJuhK47i++Nk8R+W0PvbkpSA93joLuBcpKthx9/AK4kN5CKzGTyP6Hb6/uvvG4REJyNtP8CEOGEvq1QREVW5xYJWfx/BjEcyBgIB1I4rggg9xXhuLQxEC5tRgoDNXFQY6Ca4JP9jIHwYZOkvBiojYFa41QlwX+2iYDQGfuBKP6P4RB+R/wHQm86HNLo7DdUo6RQCAWxN4S59aFQj5n9gdIFfoRBj8XJzQpBsToMIdAwLUkM9CmpH/2hsV8VZKASW5H2hzQKKj5QgipnX2iGk65XiMwuATpxriWg7SqiRzc06gmRgPbLUT+4oKHZr0eAcL5xniyQbc1iJSCb1HfbH+TLtvjBAQTJvoreXq+bdRWFAwhS4HIMBxAkv3UdjgXC7PxTnz1p0Isvc5WORxbuV1TqfvahmZvJC6+HqII5mMT7aaxIxZFSMRn2WCczYVM4ADeEFDzNr4sh8qyW5XF+AbyQakAjhQHPAAAAAElFTkSuQmCC"

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAeFBMVEUAAACaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrSaqrTh6O2susKjsrvP2d+ntr/U3OLd5OmaqrRvfIZndX/CzdTY4Oa1wcmzvcTG0distr3Z4ea+ydGGkpu7xMucp69+i5TK0tiNutW6AAAAEXRSTlMAEECAj7+fUCAA3++vYHAwz2989BwAAAKvSURBVHhevdjncqswEAVgiW4wwRId99T3f8ObgHKIvViFZO7565lvtFqEWTFduOcHoUrkx8lGE/bwlzhKu7tk25w7Ql6UdcvZ5g5QnnaaZD63g2LCUMoCSsLOIqlngp6yzi4B10E87KyTFo+h4q7h5fFcCZXqfCxvpSx/BBXZjbI/iLsc9rdWTiDqyEosppJUAkSdGgxNVS9KbMl5Fto8U2mGeAqmbIQhTT1LxR0UwpGtMKaVgDJ+Az3BOQqrHCFtf0JJRhx7KQb0ozAprCPn4gDFaHtrD7XY8QAQOtYIhzQoLlFQrn9+zM9TNEFYUC0cg+KSEfK+4coVqr4hf4Qi0jHnzqUjlJEFuS+p2DD0vhQrUuIJYKhsvwbaozaGnh3WQAf0jXFS2araYuZpTqvD2fWZr6DzOuisoJAFpPmrHoAdCxUkVqZT+Z/Qqe8vfwL1wzC8XE1vAJYaoeEr/evvSxumvF3/CBreP34LIRcdFCmo0kKv/Shhz8kDmeqPCCBxfcGePzgiMQ6tFhLigj1fOrQBSxRUmiDx8Y49p6+RnOGVfTBB4vo2jDktvNgKttkqaK+Fpkx73tNXbbZh+J8tLaBpz3taWfQJcfw/6iDk0vcn+ncUf0KoTZogGonKvqAcS3KFsKBohNC32hWq0bMJ8vFZ4wbhsyZUIwTH6NDYQPRDy1PQvKS6tYdaFBbOIwSmImkPSSwomSGPfGYboSMc/+cIESxLgDTObhIYGUVka4ZaSYYRRoejujFBTUnGI0A4u3ieCLQ4ZkVkXoNEBr8e5x2DH3UAQaKj6OnmvMuOOoAgOQ7HcABBshzX4VAIvbNPrrvS4FtbZlcYLlliu0X55msfHpiZMLG6iEoiA+NZX40lfvpIyaLC7bKuCNIlJQZghpAk9sMdrovCIC8A0PwDQ9xicGEWg2UAAAAASUVORK5CYII="

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAflBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWisry0wcrG0djP2d/h6O3CzdXY4OarusOntsC9ydHU3OPd5Oqkr7ZmdX/Z4ebCy9KFkpuzvcRufIbS2t+MmaF9i5SUoKirtr2cp691g43K0tiS6otOAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAACMElEQVR4AZzSDXKEIAyGYRD5RPwnKqv3P2inCzqlI4I+B3iHkLAbvBClhCdLUfAqjlURqnaNgKzVsxAXGhFa8OxQ0+JW22SFeI2kmqdDnUYG3SVCvEemnt+FlEY2reKhDqFhnAx5ZhoHhLpYqA4r80L/LHPYqq9DQWc1dMmskRK77FhDUcZeltjV/3zo1if8pzCkcLIbJWwWJxWGuMZh3SlpX3HQPAj1OIyUZcSh/xvq4p10qfOhYLCVsq3hcCzYvN0p227h1UeowWGjBzYcGh9qk/eTuKfWhTg8Sw9ZePwbEvAMPWTgiW9IpzaW3pz+Dan0g9JPUhU7dz/QC8N5AayScGZ6YYYjK8bhLfTCAo+zInOyxGwFE3BGemWEI1gJZ6JXJjglkznLTx+AZPB+ejFj1QyBIAh3aS2uEtczauKv7/+CYXEIAWE/EoZM4Vl91d3szLY/6k36T9AUMTlAc0REd4EWA6hF6t0FWmcTKCYC8YWMWxtcSH4iAu3wRPjRhtTrR8s2EtJHbSNgbAJ95ucojQ2sVqB5va9AYbVg/gK1I7+vwvxxHAnUzjy2YhzhgBSo57EUAxJHtkBtybMXIxtDhEBbnmcRIjDWCNRe+VPEGgpa36C8AmsRtCD6CZS69v36Ef2GR/SDMCoQh1GKxwJxPKbALhAEdq4QAnGFeJSaYSTQODxLDdcsDUiuWe7i56uivnLsq+u+BYJvpeFbshjXPr5FlHE15lvWSb9aH34BMJIHYeHTi9wAAAAASUVORK5CYII="

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAWlBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWisry0wcrG0djP2d/h6O3CzdXY4OarusOntsC9ydHU3OPd5Oqkr7ZmdX/Z4ebnlZOZAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAAB9ElEQVR4AdTTD3KrIBDAYVZ0RdT4Z1WiSe9/zdcXiXRnVJDpdNrvAL8BdhEnIJFphlaWygTyYyI/oIqt4WSFuhYCqfGAlhAcKis8VZVBISjQqwB/qNYYQNeeENww0A3OQkpjMK2OQzVyTdv1ZPVd2yBXH4UKXhlG4mgceKvYD7HO1NOufjooid2O4RmeMrslsfc+dzp15+/EQwo3ZiaP2eBG8RC4uU8LeS3upTSwkNvDloK0bjO/hmreuVaqXchdbKJgE7+cYJM3CwVbjNsBGyrxbaYLZnwrbajy7I93n6o1BGgZusigBa+QRKuni3q05CukfRPzT07/Dyl2oMgjqVxss28oQrNtgMgzXA0UYcBVlgtAa6QII1ogEnaz6LslQvp/a8jflSLFVUdROlylIosePluATKBFkdD6ydDj+Xx8R+jj+elXheivhtxCRoXcQrovEhdyX+RfLXZsw0AMxTB0BNeX/QdNyeIQPASCPQA761Pq0wKkT6sYCYQYKdgAQrAhagEqahH+AhX+OEcCdY5wIAPhQOJkB9LJhkQEkkRAawJBayhagSxaVr8foM9J/SyjgSyj1ONA0GMIeyAIOypEIFSId6k5j0DPeZca16wOJGvWXvz2Knq1HO91fR8Q9knj/siyzz77ELVPY/fHut5f8+EX0b4Dn1zG//UAAAAASUVORK5CYII="

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAflBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWisry0wcrG0djP2d/h6O3CzdXY4OarusOntsC9ydHU3OPd5Oqkr7ZmdX/Cy9LZ4eaFkpuzvcRufIbS2t+MmaF9i5Srtr2UoKicp691g43K0tgyPhAlAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAACKklEQVR4AbzSa3KFIAyGYRD5RLwTlaPt/tfZ6RGd0oqgP/os4B1Cwi7wTOQSjsxFxoswVgSoUuIPWap7IS40ArTgyaGqxqW6SgrxElElj4cajQS6iYR4i0QtvwopjWRahUMNfF0/GHLM0HfwNaFQ6VfGiX6ZRr9Vnoe8zmzolJkDJXbasYaCjD0tsbP/edGll/9PfkjhYBeKWCwOyg9xjd28UtQ6Y6e5F2qx6ylJj137M9TEO+FS40LeYDMlm/3hmLd5u1Ky1cIp91CF3UI3LNhVLlRH7id6T/UW4nAs3WTh8HdIwDF0k4Ej3iEd21h8c/o7pOIPij9JFezYfUcPdMcFsEJiM9IDIzayYBzORA9McDjL4pOlzJYxgU1Pj/TYCJZjM9AjAzY5k5HlJx6AZHDoITj/Gfr4/GrF7NEQhIEgegSKrZAEBFTg/hfUpZnYPPVz0vOakPkrgwNUy+uMBtBkAl1LnvgbNM4m0FC+BfEPuZQGxD8kP5G1AfET4UdbSwPiR8sycmtBLCMobPdkPAQiYSOpPa9+HgUCqUXx3xIxBIAk/mRH59XvQSDZERnklIRKIBkkWXZNwBQEkmVTiNgTsCBIIYJiTX6/BYEUazBozXn1AmHQwuh3rOsRALp0b9GPw6hAGEYhHgMI4jEEdoEosEOFYBBUiLbUdP0nUN+1pYZqFhsk1ixT8TNUUUM5NtR114DgmjRMI4t79vEPUf5pzD/W6fw0Hz4BIYEHWFfa4joAAAAASUVORK5CYII="

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAflBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWisry0wcrG0djP2d/h6O3CzdXY4OarusOntsC9ydHU3OPd5OrZ4ebS2t+UoKhmdX+kr7ZufIa7xMt1g43K0tiFkpurtr3Cy9KMmaGcp699i5S55nSAAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAACNUlEQVR4AZzTDY6gIAyGYRD9BPynKqP3P+hmRzTTRBR5DvDG0ioeyEKVFYKqVIWs40Qdoc3RYCqjv4WksoiwSiaHmhaP2iYpJA1eGfke6iwS2O4lJHsk6uVTSFskszoe6sAN4+QocNM4gOtiIcMr80IcLTNvGRa676yObrk1UhK3He8oyvnbkrh7nx969MPfiYc0Ln6jF5vHRfOQtDitO73aV5ysZKEep5GSjDj1f0Pdxw4rdSHEBlsp2cqHE2zzfqdku0dgzlCD00YfbDg1IdTG7yftntojJBF4+sgjkL8hhcDRRw6B+g3Z9I3FNmf/h3TmB7FP0rW4dj9QhuG6AFFXOMyUYcahqoVEsFCGBYEURfZkbLZCqMjf+vHfVaLEYaIsEw6lqLKXzw6gEggoE4J/rZg7doUwDESXQKGKyMgO/+x/g6/AVNc4egd5AbfQsUYz4wGphoDSZJYDQLmYmelb0O9sFgBaVqtP3oB0MosAbeViFB/o6UPudTiWFaDmh2yvSLqHcyQRgNorwqUVPSvmbxd5AmFpKSPLPZxN5BkEGaGwHRfnVOmAIGyQ2gpak0gXBKml+C/F5l2kC4L4t8+RivRBPEeeA0kQDyRPtg+Ekw0T4QTBRMDWOEGwNTBaXhCMFqyfH/QzwPrRjBLkM6O0xwS57DENO0EOw84IQZAjQjDUDON/oHFAqPHErGyWOzErKPhFRtH4cBwf1+MKhLhKI65k8dc+8UVUfDUWX9bhfVUffgBcBQkc/+SiogAAAABJRU5ErkJggg=="

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAWlBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWisry0wcrG0djP2d/h6O3CzdXY4OarusOntsC9ydHU3OPd5Oqkr7ZmdX/Z4ebnlZOZAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAAB9ElEQVR4AbzSjY6dIBCGYTjoJ+I/o7K62/u/zaYLmtLAAUm6zwW8YZhhb/CXqGo4dSVevIljTYRsbcNTt/JZiAuFCCV4dqjr8VbfZYV4i6SWp0ODQgY1JEJ8RKaRvwtJhWxKxkMDfNO8aHL0Mk/wDbFQ61fWjf6xrX6rDYe8zq4pSO+REgt2jKYobYIlFvqfD3rrw/8nPyRxMwclHAY36Ye4wmU/KenccVHcC424zJRlxmX8OzSkO/HS4ELeYDtl2/3hmLd5c1K208Bpr1CHy0EPHLh0LtQn7ydxT70NcTiGHjJw+HdIwNH0kIYjvkMqtbH05tSfkEw/KP0k2bB79xMVmO4LYE0Na6UCK6y6YRzORgU2OJy9iifzZnsxAWumIjMswSpYCxVZYFWsLl6+dwA1g0OF4Py/0OdXwOfz0K+voJ8MpUcrCIX9dOh3K3ZwwkAMxUC0BJ+d9N9njrOEwCOgLWBOa/2R8EMC1A+JJyJQTwSPlqAerWIEoGJEwRYIwaaoDYSoRfgDVPjjHAHUOcKBBKgDiZMdSCcbEhFIEgGtCUStsWgFsmj9Vj+BXif1k4wGgoxKjwNBjyXsgSTsrhCBXCG+S825At3zLDWuWd2Vt2vWvvjtquiuHO/q+m5A2E0au5FlOPvshqjhNDYa6/r+mg8/4qgGJoqnLFwAAAAASUVORK5CYII="

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAgVBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWisry0wcrG0djP2d/h6O3CzdXY4OarusOntsC9ydHU3OPd5OrK0thufIZmdX91g43Cy9KMmaGFkpvS2t+cp6/Z4eartr19i5Skr7azvcSUoKi7xMsbB6JqAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAACQElEQVR4AaTTC3adIBCAYRAdETU+xkc0McbEJG33v8C2inLJFcH2W8B/nGEkJ6jH/ACkwGceDc1IaMCjvaEEEb8WokyAgWDUORQncCqJnUI0AquI2kOpAAcitYToAzh6oGchLsCZ4OZQCrosL0qUyiLPQJeaQpFeqWr8pq70VnQbMnSaEg+VjaFEDjvtfUal2sMSOdrPI556vN+TCnHYtR1adC3suB6iQm2nR6tebUpQLaTuMEcnubrM21Bq75hLqQqpwRp01ujDEe3l2x6d9a26ARmKYdPhBR1sYhlKLPdjvadkDdF9MLxoH44uIQZSiReVILElJOwvZns58TfE7R9k/yQekv3tM5SenoeXEd1k+wWQMIBVhdLr8Mf0hi4qWAUhoSDVKrR4n9GuBokST02mRls8f1yYzSPs/m+d34fV5+j87zLiw6rAG2+TTL3aVlXAyifB8eOPLzL1NTsdQEBAwu8+tlX9wDMgmUM4/xxW03g9pHuatvn+MaT8kqv67xDOX797sVschIEoisKuAVWBKkFh2P8OMYQTBPloeOks4Kh59+/2H6h3nwJdjgb1IQXCh+xEBMKJdLQC4WiTEYEgIwmbQBC2pFYgSG3iDxDEH3YEUHYkgwQog4RlA5RlK0QAVIhArAGoWOOgFchB62v0A+i6Lq93dhgN5DDqeBxI8RiBPZACOypEIFeIj1KzbgJt6/J+p99r1iODdM0aLH5zVXSuHO+v6/MDwsCkMT+yzM8+80OUp7Gjx7rervnwCSDfCJ+osn/AAAAAAElFTkSuQmCC"

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAgVBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWisry0wcrG0djP2d/h6O3CzdXY4OarusOntsC9ydHU3OPd5OrK0tiMmaFufIZmdX/Z4eacp691g43S2t+7xMuFkpvCy9Krtr2UoKh9i5Skr7azvcQhzceaAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAACRklEQVR4AdTT8XbaIBTHcRBzJWhq5KrUqtja6ta9/wOOFSrBhgs76z/7PMD3BPiFEfhETBsImqmY8Fkem2XI9taImlb+XYgLBRlK8OrQfAGkxbwqxFsoank51CmooLpCiD9ApQdOhaSCakrmQx2klv1KY6BX/RJSXS7UppX1Bu9s1mmrHYYyna3GUXqbKbHRjtGYpc1oiY3dzyOSHiHq7kMSbswOC3YGbmQa4irezhMWPcWbUjwJxR32WKWPyxyGOrpDl7oYigfbYrVtejiWvLwZ3M/+cNiT92TiBkJoDp92GB2tPZ7It4NP8xBajO3nZJ3nuj0tfIhDYHDoxTpnpBgI+EdIQKBx6NU6b0jREIiPkMq82Jt1LlUvp/6EZPpB0dk6L3WfJF2oBW+J956tc0XKErzWhRrw1njvdLSlCazBa2aMQ7DBL67W+YGEDQScTbInc35aZ19ztgkT1N96KU6gB0+wKXgrHHOwzivmrcCbsibz+FUTiANoGAQ47t0675gHARWKEzj/ewh/0ROoC8Vf7vQNoct3hdA6+D+G4iDLIXKQv1uxYxuAYSCGgSN87WyQ/RdM6erwCEAPwM56SvoiBuGL4NMahE+LGCHIMYJgA8jBhqgFyFHr8AfI4e9zRBDOEQ8kQTiQOtkG6WRDIgyCREBrDKLWQLQEgmhZ/TbQM1f9LKMGWUahxwBBjyHsAEHYXSEAUoVgqZmzgc6g1KBm3av9umZVxa+qolU5rup6NSBUk0Y0slSzTzdE9dNYP9b5/ZoPPyQyCWBumf9RAAAAAElFTkSuQmCC"

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAV1BMVEWZqrWZqrWZqrUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrXh6O2isrzP2d+ZqrXG0di0wcrCzdXY4OantsDU3OPd5OqrusNmdX+9ydGkr7bdV3x/AAAADnRSTlMAIJ8A74/fgFBAv69gz4Kdj0YAAAG/SURBVHhe3ZhZcsMgDIZrih1iOwK8O8n9z9lOi5FtErbRU/4DfKMNIenr+72KtqwrbVTVZVt8ZUgwy0BVTKRRipLrN+JlvF3XRnvVXOOsYTooFmHVhesI8UvInJuO1M1rlOA6Wlx43DoBZN8pMFJdL0+ot+6xI2UY4aRxOLJYBGdV8FJqdUg+zoQYFzXtSf74PMCrhy9OAjHTDAHNO6NOuSs4RmeBoBaMFD/WE9ZhD1HqsTIPAfJxnvf700e6vHJsBVf3X4GrFZ1zMz8t8aBlcmrgqjfNEA+CWW/a+lOD9ZMCwnpqTISsY5AGAuvcf5TKDaRSQWoDlX8gjhlLA2Hm+OFxqGQQmiR2uZeQDgK5q4DKgIYc0GBA1S5nYw5oxLy16Fk6CH1rbfL7PFBvC6A2oC4P1BlQbWOt8kDKRlsbQR4ItNEHgiYyiz4fRFaQZE+E7NGStRGyxkbVasmaP9l3RPVBkn3ZZEME1VhDOmjlj35y4zDKYTQ8HiMoPB67A3sYhJxbzAqBoPAK4S41cg6BZqmtRMyahSuEZ80iWvyoVlGq5ZhqXac6IFCdNIiOLNRnH/pDFP1pjP5Yh0o6H/4APdH7xkY77QoAAAAASUVORK5CYII="

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAvVBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzOIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfny8vJscHNTcoqCv+18tuBBVmWHiozX2Nk2PEA1QkyvsbPk5eahpKZHX3FRVllNaX1kj6////+IyfmPzPnp9f6e0/r4/P9fY2Z5fYDS6/2t2vuX0Pq13fu84fzE5PwpLzNwo8hqdn+m1/vL5/wvOT9qmbtZfJbw+P6Ul5nh8v7Ky8za7v362jbvAAAAE3RSTlMAYL/fgBAAQO9Q37+AYBDvAFBArxa3oAAAAWFJREFUeNrt02tTgkAUgOH1hoq3VUsrzawOu4A3XCs0s///s0RjgEA7KPulmX0/McPwnLM7AznUqBkZ0utNSimhtKMbGWu1D1DbkFCHkmZLBqRTUjek1CC6HKhGDEkpSEEKUpCCFBSPcfDjLAtkWgC4hEMLCyJ9mtdCS/idZV4FsW9ItLgCmnM4kXMx9G7ByaYXQg6ci7MLIDaF83EzNWRy+CtrlhKaWYDkpIKWgDdlKMS+IE18jkDRnwu/qPOQA+n7iEHIT4EfLwmt3mzb3gLebmKLQ+76JLQRxyYY070RQbe9BNS/E367cK593/U/3nq7/jw/DESk4SoGrd3gnR2dO3gEgNHEX3YE8BQ44VIh1BuLSLtgLl64FAnWCXruxuZivfSOUH8ssuZuPGjjCgkNX4mQlIIUpKD/BhXkOHlSlAPlSKkiwyloRKvKgMoepJUzX1OlqnmQVy6f6VjFkmfsARIFPb/33NcgAAAAAElFTkSuQmCC"

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAYFBMVEUAAACIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfm9aIjdLkS4cpONv+6thaqzfJ/IVXHYOE/CXn2Iyfmdosyoj7WYrNejmcDSQVv////NS2aTtuL4/P/h8v6PzPmm1/urvXXgAAAACnRSTlMAYL/fgBAAQO9QwdmeJgAAAdhJREFUeF7t2NluqzAUBVBnKEk8T0wZ2v//y4uzpRtDG1ywH6Iq+y0SWtjHGOJDQjZbl5Hd/qOqKlJVh53LzPEUoJMrkENFPo4loF1F9kmAMsaT0oYkCyTYkCS0Ja4M5NKQ+8NQP+QNzcazIf6VIBkgWQBSAVIFIB4gXgDSAdIFoFs/5FYAugboWgDq78mHPgF9ZkNfgL5eB5LsHpkNKUAqG+KAeDakAenXgQwgkwX1k6yB3tAbcp5F8e4vQSqGVAbEY4hnQDqGdAbERlkPNWOoWQ3JAWjx97hNfUlIqkQCkEgViSROIdYBcjagK6F6EGpADj9WQmcMAhDmtgq6YGaAMLfLKoiGNXtAYd3ocghz6eLTUTdbbjK7YWUMydmNS+YqZEQMCYMqLYQs7v+AMEa7FPIYUAxhSH4ZJDo8fzGEh7ITiyCLrTWGsPnsEkjirdFIqg27x2gqG7xX5O+hNjiawohiqA5S+1uoMWw2pklAkbNc+t5k8ZHTWVXjKFor20WSnzrbadtHqP8X2/oyXrVLbc2zj9xm0ogSlCG2/bml0VqGUBE7u0lrrDljRko8740IhTme40IdRs06wcHUqSZLDYqLUbNuyGYbGGUCY8A8h0DhWvVoH/4DpLpwSt4JvmoAAAAASUVORK5CYII="

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAmVBMVEUAAACIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfkVdWkVdWkVdWkVdWkVdWkVdWkVdWkVdWkVdWk8xLQgin06v68/ybkllYccenIqn5Eyio2BxPAtpJYagHMdhXg1tKUnmoyIyfl6v+cyr6BHmqhkr8xAlZ8vqptrtNUrhYQjgHs3uaoij4JPn7EYem5dqsM5j5ZWpLpyud73jVZlAAAAEnRSTlMAYL/fgBAAQO9Q34AQ71BAYL9/Ra5aAAAECUlEQVR4XqWY6ZKbSgxGmUxCkrtf9ca+b949ef+Hu26sQd0WVbh8z7/Bw0H6UDcUgeXtS30jAoCuZkxwY6pXGABgX9fvX7+FYRiE4ff3euYEN3om6vEwo1t++PHTin7WSGpLipqaIP+Jey7Wk6D0exh8++GfsltrAIb1QqFB0XsYfEULlsRjSvDKPr8iv9C34N3vgucx26Pap5k9+3QRfQlqBEviMcGM70l37JIBD9aPaQLg938H1C+JWEnQsVChZ/lj0o6IlwQ9O3LyB4gOkYiXRDHR1QdvgDBpJuIlUUwJUB7UK1VNIlYSxZT2XYJ/R0nXpzhAZGYiXhL06eUKD1wvaYMeaLhovaQoghWiPfCkUcRL2gCT5iJe0jZ9zUWvlJTUz4g+YJOPZ0QDrHI+g8PARZCcJrbxzZxNq7UWxgqM0Fq3hmQXVzKdEgjAQrJ+8cRC37FOfUfEFLcjscwiki3zJpVGhBUJjSiJoqhZJCQi2Q492aIZc+vNx0WVoWmHEiS47IFxPqCmPcLCsUXT4QyM/SW4FXgFn0LcT8BsyW/uFxAF+FwnnKOmi5inlLCCLJkp6hpnjlLq8KwwUwbdBXWmnlKcIxwI6rB0ApVxiSGLMpbOjSipJyTY1wuzKdZaSLDkmdAeIsvv+ps8nj01EdBCTuezhT4Uc4eZXiGbeyoOWszO1BUl3mY84t0tlF5FFTgfI443iaBxnjI5eozW41FK4zQnjJTHUWuDJltS54k653lRKfTYHry1IfBAhiZR4b5Eosh5W7jnU9wbwOwtmK7zY3Hw3y0C6nQ+DywtjbTUiKQBb2H5V180kIijEb7HcVH0rIjTkAi3u6kfABHZkpCRJJIGkCLD5AGGfnJF++ihBpUZeSPTrkhn9pjJ1EN9UTKc+ikAhnYwJDLaARgbohg3jlJC/L9EJfnLV0QE82+IBrv2EeWHhHgRKUBoI0FRlF7We1BnZ9/kHSeeyE7IaWAiDhdFnqhS3ntVti3KAAFPFGMStOCJg7k/II3ypwKBX66oXMJjsVbkr9ZuAUy+yCtJ6k0ke1NCkV/StggWOl/kl3TY8hxIlLginJeFcUs0kmjvioR/I+C4JTJA+K1ZctTQo4NBDxRiYqJybZJUG8uZuFXuFBEfTKSrhxct0VY5OORVK/iLVueIMFyROzHFxwJWKG4/gEfiiGK6qy/giI50W19gIlE+SwTFtA1PO8A90UDlTcjzXB1RrLPPtTqeXwoJRVDRolfytZACvnuU5iXRbyu7h4pzeJodfmT5nYmwrCfDSlL87PPHn97zTNm1dYztYmifcUXLh6jwL0BGbySL+KDFKDcLWj6NheHfGJN8XCR5prQyGyL6WHfjn3/BYvgQmXJL9fn58D/JOOQPGEqW5gAAAABJRU5ErkJggg=="

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAUVBMVEUAAACIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyflMgkZDdytsqKc+ch16udCDxOtemH12s8JRiFRxrrRVjWJjnotak3B/vt5oo5lHfTmnvM5HAAAAC3RSTlMAYL//34AQAEDvUBClaMQAAAGXSURBVHgBzdhBdqMwDIBhGqWlrZ0/WDFQuP9BZ3h+TmgnXRhpMf8BvoXMM6Bu6+Ukhs6vb33fd33/fhZjH58b9CkOvffd24cHdO67V2kqxIs866VrHBBwlSedOmmGwiBPOgCRPKAAoA7QDSBmO5S4N6oFmtg1GCDlURQXKM5fBkgnSreLZdiR2mI7Ne6JDdIxshWTCdIR6mRMEMDNA5oBPCDJK9EM1f4zSCG5QCPgAgGoFxSyqgNUWo3QQM0IaXWCF7Q4QXEwQheKk8UIzWwVxgJltmaxQddAKdugKzW1QasTNOAEKffEBCUn6IIHNOjEo3gYSnxrPArNfE8PQpl9U2WaoWFlVxY5An3lFNiXpBlSncaVn2kLpCO/Ji0QvxZTC3ThSfWV2ABppHabVNNjNm3Q9OMPYyiQtEILEPI/E1sboVqixFKgeD0IRUpzQcNVGqEUy8MLTDrf0uFPv3rb1GOyQYgAYoJkKVAiGiEtUMkCBWB2gGYgiAMEoBbovIMMzum+9kmQDNCL3yLKbTXmt6z7m8f68A+T61w/90ZbnAAAAABJRU5ErkJggg=="

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAolBMVEUAAABmdX9mdX9mdX9mdX9mdX/M1t3M1t1mdX9mdX/M1t3M1t1mdX9mdX9mdX9mdX9mdX/M1t2LmKHM1t1mdX/M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t1mdX+cqbGPnKV3hY9mdX9mdX/M1t1mdX+zvsaZpq6AjZemsrrM1t3G0NesuMCfrLSGk5xzgYuMmaJ5h5GTn6i/ytG5xMtse4UcpSEkAAAAJXRSTlMAEEBwj78AMIDPUCDv32CvnxCvnwDPYL+vQIDvcN9Q7+9gMCCPpYOmqwAAAtZJREFUeF7F11lzmzAUhuGATYwTO07apNTO0jbNp419+/9/rQxOsYwkOM102vcSzzwXHHl0uHB1t396iyKlFUVvT/u7S0cX1qerw4Ny9HBYkaGrSE0WXZGga5Mxqet5aPWoCD2uZqFnRep5DrpSxPYz0IEKfZmBvp6AOOGZwJDIeBKfoMMM9Pv81LyEpZLX79DnGejISAFnQvZQNA3dqS4mMFnJhrG5IO9T53DMxjvp1rvXu7jXWwulChAqlMLaDd2AqwqkKiVw44SCDgKxDtq5IA8dNJ56nrKuNB85pSoAzwH5AFNKZtBK1XsptDLZz8R3QCHAjke6EsNLHSpwTFTHA86B0AHd9tB7TFaiRXqCGFpRSTbAKXDrgIIe0pLgOpQpPQYEDmgD1EqvQaZDfAxtHBAAdR7ECeJIxhDskG9C5RnEDMinQgI6pM5zQgsTKjQos0ALKxSaENcgUZpQaIV2M5AwoZ0VCkxIzkCBFdqaEJuBtlYI01DFTQg2yLNBuTZ+G+RZIN8GiRnIp0KFhlKhhQ3iimXoypiqbdDCAoU2KOmZnopTCxQSoSbHUNsQocCE4hZabWxCAQ0qcFb2YQij4r8FqY9CsoRWKT8Kmf1/qEmzHH15lo7OEaNDMsdZuYwpUAicXZBJjrLgkr0neVEiTzTIdbJfAO3KjqsiUUZJUcVn0IsF8jY9pFX3e8SxfoOodTQFsPEc15EOsQxGQvudAwgJa42ENalBxloz5O++DRAcDdD3nW/ukEMHOrSf3PxPUCJaGLUiIUJ7Re7y30A/yE6t7/3myw7IEAumoFc0VEji5wS0REKFOJYT0AacChXYuCEfyKiQAHwntATAaA4DsHRCa3QVNWH2BbrWTgjHRDo5uyYVOOaCPJwSFWds5DUs4VWP0CB6E9+0f1TghLw16GHtmdDQzRbEtsafdtRrGGC2IHztABMyMD8Mg8ACdg/D0O8Qs1/D1HY9Ntq/BQAAAABJRU5ErkJggg=="

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAilBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE28kStwTQVmRQDGmTB5Vgr1xEjisz/Zqjrsu0ODXg6WbxiziSfPojWMZxOfeB2pgCLs6N/Z0b+zooCWf1CDaDB5XCD18+/////i3M+8ro+MdECfi2BwURDGuZ/Pxa94DnysAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAACRUlEQVR4AezTzZqDIAyFYSJyJFFsbXv/1zodxvlpedBoWM63PIt3A3EbUef7gLXQ+46Gem6oFDmgKHA8BpEXVBJPamicsNk0qiBi7Ma0DyWBIkk7EM1QNtMWFAXqJNahhEOlGsQ4GJfQ6hgkZ3EALqGEU6V3KOJk8RUiwcmEXqAZp5v/QgmG0i9EAkNCPxDDFH9DI4yNKzTB2PQFEcxRhjyKLtdluV70u8+Q4L3bkrtpd8gnFFF0X3J37Q7EJ8QoWtYeyh3gJxRaQGFwhDqk23PkujZQ53wbyLu+DdS7gBbPj+AAWD9kLkPmE8mQISP0D320Yq47CsJAFI5r1l1/yRAo0Iu0sID18v6vt9INGk/pgkm/vyQTJ7bTb07OdstkrNgBcCCzcjxwFRdFqEYheDUeTJnBgXy9IooelPLID8xRsJEDP8qSHii4Ilu4TeuBS/vx0hm9AYyRjVeo1qZpKchPY3TtFdrAqKU7bdffGfTJGOto7R/GnPQwfutaLPTphj8OinO/wNkbJnt8jhRNvylM1/r/2jc+kIIcF90H0RdyCHwgv7bQm6Op+1nqhmbG5NaXiJQm7NVrsLtamkhRIlBrSnpizW2Yigw3Y+lJCVrji1ZOq8hRtHz1S2kJbGwfkFFFiyiQUdDj1ZUU6nFI2Dn9Cw8LO5q2SChIInzLDi81WUUBqgxcbWnNYpJmkAz3hxWLX64SaErlvvKtW0UZl5OBSM787/uoy3GEdT1WgBAr0ogUssSLfeIHUfGjsfhhHfJWfPgLQvO66B/Z+d0AAAAASUVORK5CYII="

/***/ }),
/* 1167 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE1mRQD1xEhwTQXsu0PGmTCDXg71+Prj4tt5VgqMZxPisz+feB2WbxiTfU6ziSepgCJp6wDKAAAADnRSTlMAEFCAv88AMI9g798gr0hldpkAAAHrSURBVHhe5ZjbjqMwDEAbgksSqMO115n9/89che0AwaET4mqk1Zwn14IjNeBg5/BfITKZAz6BXGbiuM3huEGhAAmgip0iDbgB6HiRkAZfYKSIE+kSv6HUEaIqxwjy6jtRZjAKk70WKYxGvRCJE+7gJLZEAnAXIIiIeuJNVHTC3ZxCIoUJKCrKMIlsLaoMJmGqlSjHRHJfpDEZvRSJEpMpxUIkkYFciAwyMLNIIws9iQBZwJeoQCbFU6SQiXqKAAn1Z29t/1kHcwT4JxJIuF3syOUWzBHEKMqop7FPmls4R0v3EHgb64uduNThnI90Ilqvf5zh0bYPZ7oHc7RyD3St29HjotHUBnM+MIpwxd2tQ+2i2q3LPZzzCYrclR2OdM4ZysWKmq8ldjHJxYq6pun8mObCIga/RQQ4011tJNcOZ2BVIm1vd9C3qxKRk6exu2gmk/S3kd7upPe3EYFzPdiP8zAMLhgmgr/OH3auGhTeVnt1HnLrptaZrjgC/ubvLjnHi84u8jf/YhYNUaI58j9HR+CJYP5k8/6aXjQRnMU2XlvDePySNFppL2QpSOuXViKaNKNpRZuT9jhtGzHV2xt2/gjx/qGGP2bxB7+3jqL84fgHxnXOAQL/SIN/yMI/9vmxgygK42iMwdtEfwHnRvHrlX0v/gAAAABJRU5ErkJggg=="

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABFFBMVEUAAAD/zE3/zE3/zE3/zE3/zE1drez/zE3/zE3/zE3/zE3/zE3/zE3/zE3XxHXXxHVdrez/zE1drezpyGJdrexdrexdrexdrexdrexdrexdrez/zE31xEjGmTBwTQWfeB2ziSdmRQB5VgrZqjr////i3M/Z0b+zooCMdEDisz+DXg6Wbxjsu0NxsdjPojWku6aMZxP1yle8kSupgCJ7s86aubBnr+K8ro/XxHVep915XBjhxmteoM9lUh6DaDCWf1Ds6N/Mwn/FoD/CwInPxa9kWSyuvZ3GuZ9hgIWu1vbryGH18++GwvFieXZ5XCCazPNfmsCQx/KIlHtghpRnsu1ic2dgjaK4vpNlTA+JjmyAgmt2fWojQFliAAAAGnRSTlMAEFCAv88AMI9g798gr0AAgAAg7xBwz4/v3+WB4v8AAANpSURBVHhe1dgHb+I6AMBxsoBQ2nI9Dt6zs8Peq3vP2/ve/v7f4wW7jhM7TlJ0qnR/qWpl6E+xsSOUwi+VJCuqBh/TVEWWXogriF4olTXIpZVLT4R0ovCWnh+SlApMqaJI+SB9C2a0peeAqirMkVrNguQKzFVFTofKMHflFEjahk9oWxJBkgaflCaxEHU2kHhoGz657SSoDDeozEMy3CiZhaoVSDPMoWWZSYBpWUPTgLRKlYFUyoxsyw2ykiD8ij2ikhqHdHo1ToCkQDiHXpUehaTwnPoecZKnRiTPJ9CWFIEU4iweFduHgvr2o7UgkhKByErbmEEXLsxwMGWT9aaQHnOGhBFTw5ikh5CGHbzMJsyRiSQHQxqBStjx0bT6MFd9ND0fSyUEkcNhWMTJL1lGeFAK4cyW/LyyZ7fEc8OQhJwRXb7s6EeD97iEIJkMoyvNn2GFe0BGkBJufgfifNtzXY/ZlPy4Ex4kBUEqgSyD7hJ+R/HjhkUgFUF4rU1y4+h7bpjXpw4/Tv9HQxAzc+wQyUgbpyVAMzfWTDSeBd18vI9LJtk1se7/uEmHrg/A8Yltoq3vm+hDwtD6Lzp+cgwOrtOgBxD0F6SZ3gBDA8/k3ieG9sG6McxsDNbtsxB1cKdZzjUAVKIQ64BpFrQPGAlDGpk3aZw9M9ItdrTIEbkFtHfpzikAjKTSQ3sEIv3jTEYiZTRxvgEcXVAlvI28O4hC392gwWzpLHzUCP1aOMvZwA36MwodzANIDm9sKxDtzE3tGERbBZBEbrVTEO/vNOccxHuAGrn5HwGmfy/Ezqf/ANMRufnvjFnobavV7hx2uz3URQ/X7R522q3WWxYa7+zu7haCnxpg+9xK6StgqxWLxUKxuAe4PqRBHzjotzqCajz0oyN2OoDvFYIagM+9vEpmri5dwNdAEEiCXLf3+j2rvH/dc90kCKyhugBaW927NkHad90e3Ub5oZREUPFnQKLF/pIGnYkWu8lDb9KgNzxUE23I8/RDy7WHIP6SphNL7FiTqeCIcKu0mtNvHlxDA85X7AoRqN5gnCB/lsTMfBgUlxp1AsVnN2W+49Msuw9x82l8XhQq7jUbSG++hJF8Z+ZhxJs5Poz0svk7fv9ekUBMGz1A2PyRxnM+ZMl+7PPsD6JoGz8ay+45oP8B9FT68N/djYwAAAAASUVORK5CYII="

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAilBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE2pgCJmRQDsu0OfeB31xEjGmTCDXg7isz/Zqjp5VgqWbxiziSfPojWMZxO8kSvs6N/Z0b+zooCWf1CDaDB5XCD18+/////i3M+8ro+MdECfi2BwURDGuZ/Pxa9wTQVrjtwGAAAAD3RSTlMAEFCAv8//ADCPYO/fIK8hQ7nBAAACaElEQVR4AeTU627DIAzF8RrwWYAkpbf3f9VJjJXUE54rPk37fz3VT73Fpz8VOR8YLQ7e0ce402hYIgMyjsubUGIM4mSHyGcoZU82KK2A3poM0BZgKGy/QS7DVHY6FGEuKhDtgL2dRhAx3opJQCZHkSS04+12Ccnv+VzKGb3xEn9C7vXVQhouTkJb7uOl1C5oaUveBBTQu5baFS11Ca9QQu9WWje01CUdIVrRu5fWHS11WekAefn+5SfQFn+A8nF4lNYDLX3JHUo4Vp4BsCzpCfEcxN/QgjkIS4PiLBQbxLMQf0GEWQhUIWf6kdXFVcib/nbq4isULA+CvoQKseXR1BeukH4sbIuA7IdNh+ynVofsx1+H7P1DiDEdf7Zi9jkKwlAQT0x2s/qPA0VaSoXCIuIH97/eUgyJ7FhkN/0dYEI1897Me2GRVH6+R8iILTIzrXAGV5nOI59GlOtMATCCTLthDzgOZq+PciSSjqPemwMc5JMNDTb8ARpsT7+2+J/QBw3/UagobVXDy3dly2IutOV1hIG6OQ205dnabqTuHlh7LtvTQFPPhb54QSoMXE5vuGBAPb+MVnaM6Zv8NPWvf233IkTkGLmWfp3yipF8FiIo1ig8qIrXMkWFB2oWazhoJZjobg096tZhIuGg5djREnR09t5OIu3dOhVekTtPGE2xipTCKMXjBCtIOB5zYI/hhwy7WaoQ8Xqd7XKp0VhEU6nx1qy8h5c+99csVhIZPGSCdJarqDQAY6S3ivrLcRr3mNHHKVW1lXVdaqMwooyWXNfDHxDCnzTCH1mCnX0CHKKYMKex9QQW+gEqvLzO7u7P1gAAAABJRU5ErkJggg=="

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAilBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3ZqjqfeB15VgpmRQD1xEiWbxjisz+MZxPGmTCDXg7su0OziSfPojWpgCK8kSvs6N/Z0b+zooCWf1CDaDB5XCD18+/////i3M+8ro+MdECfi2BwURDGuZ/Pxa9wTQX63lTUAAAAD3RSTlMAEFCAv8//ADCPYO/fIK8hQ7nBAAACWklEQVR4AdTMYVLEIAwG0E0g3zZJy/2P68yKiq10gfzyHeA9/hXilAWV5MT07Hs8OzYVXIhuk5EJOsTGI0qOG55oLLIdb+w2EB0ZA/LxLmLHEOf7SDFMbyIqmFCoF5FgilAbrT91ukYF08pfkWKBXiPGEj5Hh2OJH6coY1H+HRmWWRvRjmU7NVFCQGoiR4D/RIYQ+44EIfIVbQjaaqQI0hoJguQzIoTRK2KE8StKOPtoxmyW3ISBIOwLVXEuklogQNggCMb4h/d/vaXkxAgPg52ESuU77GEOXVjaHk2PkApQUvB1+j+5o37VMX4Sa7ZOnLsjZ50oPFEJXw+JvNC8phUClObrIQtCBjMMX18XSvFCytdXhfy1pP5eROovab3OCmUqnX2gytg6FdqA/1Qo+nudaMEiCXUSRYucWmRmWp0BULEtck4jL2ysABgdmpa0EYknmTnYo/Dk/u/RHkyGJzJsI6Sx4TcgjS04bf1nQhFp/l6orFzdgOVH7apyLrSnzxFGmvY00lVn53pP0z9w7lx1p5G2mQt9ow+kwsjl9IYLELo2WniyJaZv4mibl1v7vjBEFPBcK16nusJThEMEHWsUHtTlskxZ44GiY40ftGiH7G8t+VG3PuyQdNAKTynDRO/u3S+R7u56TGTTCTHDaIKPSAK/MuNxig9IufE4tK7EW2RoVz5CyM919uuhxmIVy4YaErOKASxDwccsqqRjMMSa6KxHUWGwgBFsFOXDcSIHzBhkwofj9bgurFHwKGMFietbLRC2X2lsv2TZfu2z/SLKs8VqjOFfCH0ByBm6fDeZrjYAAAAASUVORK5CYII="

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA1VBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE1drexdrexdrez/zE3/zE1drez/zE1drez/zE1drez/zE3/zE3/zE1drexssN5drexdrexdrexdrexdrexdrezZqjqfeB15VgpmRQD1xEiWbxjisz+MZxPGmTCDXg7su0OziSfPojWpgCK8kSvs6N/Z0b+zooCWf1CDaDB5XCD18+/////i3M+8ro+MdECfi2BwURDGuZ/Pxa9wTQX/zE1dreyku6Z7s87ryGHhxmtxsdiaubD1ylfXxHWGtcSuvZ1rGsIuAAAAHHRSTlMAEFCAv88AMO8AMI8QYL/vcN8gr5+vQCCA34/P0e25+gAAAvpJREFUeNrV2GtT2kAUgGFzBYkhgrb2kmQDAYJCoIh4O0G0tv3/P6m6DTm7SZZdRqczvh/8sMw8s5fZOMnBh0rTDdOCPMs0dM1mazSbjcOig0NBLacwMMtpFc5RM8uaRzLIRaVsuTnUzl5q74Q0w4MdecbrEo8z2vEOyO2ApI77ujBa80gEdU1QyPyU5Z0KIN0DlR6zokYt5IBavxFq10DaiaLzK2P6XIE0C9QnhLURQkd5QvyUeOgEVPvJQ6c85Cg7m6zUGQvpoNyfMvSFgbqeOvRUhr4ykKnuPGaVGgXkgnrrKvRtC2kdUO+hCn3fQgbsUVbTFvLeCXLhnSDrnaAWyJNvNl6Otx+/tR+0qUJnFNIA3jiltWbbB7at7ws9l3bp4VmnkAHl/CAkJAx80TiVGAcMCpnAF/VIXi8Sja+ZdQGASSGLd/ohKQr7ovHN+oHOZr2h/8cpVJpPSJjCSDjOVQPFhCsWjcugASk1EI1LIHosA5+e0YAekmhcAg3DATfBcCgal0DqfQTIertj1VyRvg/yIn8EbGbl0kZDQkjYS8YjkTEaJ72QEBJHgBmVx0hAiobxeXLh00b070VyHg9JUQCYTiENMLJHgGkUYnY72hPCvaaQw0OTaTqbE2E/Zul0wkNODrX4pc0Xly8tp1dpuqLNV/9K06vp8vW3xZyHWhTi1kYfOteXkq7pI4ldWQ65zKnhnEQt5qVTcwvI9iBvTGg3U7EzvSG0MeR5NkIGuzbabFLPTGaExqzMYCCtU31Crm4XlUXdrqpPyI6GELtLQ4Kt0rvlFlnepSuCDbkdQghvbp8o1cf7ykNdDxcnDxfmdXmIvbqB3AmY64pQnoOSuuPYCBXhS02y20lg24ldBzGvWeN7MXM/xruhsVCtFPVETi8qOQhh7KuoH9cxsQ+4LnQQwh3H+sF9aVFBHzDcZ4SY+Nd1P4lDQgvjxAcmT7drIUzxA0LXFkGY0icNDKFKCh9ZJBAm+ewjhzDZhyg5hAk+jckhef8D+guOQxvNcnbw6wAAAABJRU5ErkJggg=="

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAilBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3GmTBwTQVmRQCDXg6MZxOpgCLisz+feB3PojV5VgqziSf1xEi8kSvZqjrsu0OWbxjs6N/Z0b+zooCWf1CDaDB5XCD18+/////i3M+8ro+MdECfi2BwURDGuZ/Pxa8qI6EWAAAAD3RSTlMAEFCAv8//ADCPYO/fIK8hQ7nBAAACvElEQVR4AdTMQbqDIAwGQAPJryTA/Y/7Nv1aqkUhrN4cYLZ/hUJkwYtwDLT3bXvHkQQXko7JSAUdouMRRcMNizQWacaDrANRYQzg8hQFwxAL91HCsHQTUcWESr2IBFOE2sj5tNM5qphWf0UJDukaBbiEc1QMLlZOEcOJvyOFm7YRZbhlaqKIBbGJDAvsEymW6DsSLJG/Vsy3yU0QiMPJdGTSvoEVQUBMNGku5/35/l+vLSnnmoXgtD4v7oU6z0ngh7tE0SFe4QKglg1X7CmKN7IGEDxeOAQRCoeAvwjd5iytNl9PoaAEUYVFEWMdtTgbLQtRdRftGRoaQnSPnm55n7PIPogWcXWeNzI+WiuGUHW8Lhvu3UN0d6nVKOk/xa8rU2tyl8orzPAvD8z0ieTuEquoT/2g4pmoCiK2hEsoiUBytoSKuAE6M3RGwXAqSmqM7rwiS9pbbYiKipSMz3TEgWxddElFRXhetGcFvEZzSkXirunZCvq7SqRF+G2L+Dor4gKnq0wnxHJoFftvqkRElGdlnO8TEcGhdTUAmKNt+5yjb+3RAIB0JLR4G9HwRS0b2/lAH/52NuywEU22kT3J/TrYzD5utRH3b6IKbf5IdBrG8wWy/DyPwwmJ0OZ/WA7tcn35zW14HccpcJnujOPrcPtz73pZig70Axny+PZS4C0kG4+MfLI1xHfKc708zNqPRBHRQuB9yHuGdwi0tIjAazLuNedTWnM6QwCN7Fuy0OIQmT7IAK8fE0R4qtDCv1INM9P4eYuS2+c4wUydLv1QchWsQqG8ZspjDivgufIYR1dDEY3jmm8h9HrP9+dNjYWnWNTUFNqsVkAW0ZbaLGxyR8hwdNizohX1EhJIX25FSdOmtIAFQquVzTFp172VBgJGWk/b9e0PELY/0tj+kGXTY5/NDqIi2xyNrWR70S++YcIIvJmDpAAAAABJRU5ErkJggg=="

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAwFBMVEUAAAD/zE1drexdrexdrexdrexdrez/zE3/zE3/zE1drexdrexdrez/zE3/zE2Tt7f/zE1drez/zE1drexdrexdrez/zE3/zE1drez/zE3/zE1drexdrez/zE1pr+BdrezwyVv1xEiziSeDXg5mRQDisz95VgpwTQWpgCKWbxjsu0OfeB3GmTDZqjq8kSuMZxPPojWuvZ3XxHX/zE2GtcRdreyQt7pnr+LhxmvCwImaubB7s87ryGH1yleku6a4vpM/IpLyAAAAIXRSTlMAIEBggI+/zwAwcJ8Qr+8wgO9g3wAgv99QUI+vzxDPMK8NU9KhAAADAklEQVR4XrTUaY6CMBiAYSnQECBVEXGBUa/QnU29/61GMpTSagRN5v1DSMiTtF/p4l/bAtfzISy4VQGh77lgm75oYb2fwwjyyWAUnt9AsZuvx4AUmJS0ryRYyDG2zt34JQRyPq65D4auvDd8XA6eIGAsCNZasa3a/BKYkK8NDyxXiL4JrZbA05o/hiK1bi9O0wTRiXZJEMSe2s9IQ6Ea74NxMjqjzHlQ6niEA7TpoX2aHhCdFToEwb6HNgqK+QAd6eyOA8SfoOJCP+hSaMhaGpf4Ope5YqmcjbHZKoZJO4W0BDOuC+3x6xi7YVwRVUn6KoxvjHGzyDyQX+dbv8jpO+YEUhNyEBGfM4IgJ/hr0T+zbhCVkPMRKapuxJkJJfqiqNk0wmp9ySRj6GdnjbfqptPYQNNNsyLtbyt20+MoDIMBePfkcChCHBiBlEMghDbhS+L//7dVMmytjJMwTOY9VZb6hCLZuPgdzBFi1ZGRCiFW5kAlQvWRlfoNQR4E/6HiyExxQl0u1J0Q5ELwCfEjO9xBbQAQ/SDl0ItkDdM6qKLOqKSLGlM1TOWghjqTPDONiRqmcRCQ36XkO0rEaxhwEPGfVnhp/bKSidT8BCHtHCs6SUdq15Cx90FYSEz2+EjtGrLfnj/N2Zqx2jV0Hn4eP0Vq19A8TbP/mdbCUGZ+H4J8B7BF8tJg0+alwjGSl/YXBxsdtYNaroBFDZ4DweGvpDQ6xQgjpQoO/8I/zvZSL6JMb/vOv+gi/IBcpaXMGGK0sYxcPQdij2wjXYZVf1HWQbqY2COblVRyUWZdnDYuq1EOoU6ZWGueMpFnYq3hH2SUxBgcIWTRCi42egs7GxnXNV1G/eyKMmoP9KsP/S0PSr185kWZg6zH4dYVe78pa6jtuYtwu/rQT7ekjlGIPe47DxaCONx1gBMIpfsOQijd+nUP5yDkpbt1nxMQu/F3PQ2xb79AIBBJ/fGdVxoUouFXL1k4i0A0NcQYwKtJQZiiC1jQFUQgEA1vq+atQVO1nAAEys8/YAElJtEIVroAAAAASUVORK5CYII="

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAY1BMVEUAAACqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaqjtaKbrhaPotVOYZlSZVqTpp6Xqmafsd1WaSPc71gRJCAZK6lidGFabOVecKfg8xwVJ/ixVf9AAAAEXRSTlMAML//rwDvUGCfEM+AjyDfQIPWR1wAAAKGSURBVHgBrNHRYoMgDIXhxEMwEKi+/9N2E23T7mqG7zr8USDiBUgst3E6zhNn/Mir3LSO80wJg8otiiERLqXKv9WCC+HF+HtsbYvhZEtbv1exwYWc7ia5G/6wzm5Ph0MGJ7czpQbHMz0zLcMxWvAp6cPNeG7bQws+LdQxRSfFFEqMKZhkwwSbkBRMUIRkxwS7kMz4t01+Q4owPUKyxT9ohPb4DY2QNIQ0uUJSYk//DknCbUlcqAbue6su1BDQXCgjIL9DihB9hQwhdoUYQXyGOoL6GTIE2QhVhNUjtOLybMV8VxwGgSAOoaFHc6ToauKfaPr+T3ngSWWsduWu83FLf9F1R5cVkkjpTezv/7aLTSsiKZ6RawKVapSUJY3tUaxxlCVLTSbQhKAs549XyuGfFABNCbTA1opkqDkBfxcl2wmE34xi05SlIFm7oiy9iYjrLSCkGfwoLtcUBgsqW3iSRNnSOMjXCcWD8MMg9R6khkGNk4ET/QPoZKLDICaKoOX/oAUs0ki2YqJoke/+8Xsmiqa9dgtSHv0o6Nq72Cwl2X4UdetetdYROduPopZPX/4fe44+9kDik61c5P4ZnYInu91EOCKDZmpce67dREBNRiKS/uhivCSiiNXYbrTC74O0tzCnSVUZeo0WZslkS4WzooRsN1NnqIDmCUlZzoSYaHsM5WE06FcErdC0bfRGG7RrK4LQunixoqSo7Yqg2iinbnP0WZsDQEmXV4eiXh17mVugW+0U+0DMw9beuCEISKDDeu3SUvRmoUaBA6BEgt1xuhQOgCDjjCDPAIJxEK8ycAIQaJ1GONM6N0GgrzuHuSd/saCZH7LMYyB+7DMOYgdR4yB+NIb6ATLMdHeSVhDsAAAAAElFTkSuQmCC"

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE2feB1wTQVmRQDGmTCDXg7su0PPojWpgCJ5VgqMZxO8kSvisz/Zqjr1xEiziSeWbxi+lY5FAAAADnRSTlMAEFCAv88AMI9g798gr0hldpkAAAJYSURBVHhe1ZjbcuMgDECLMRvjJOLi6yXp/3/mzhJCjQyBlGln9rzGc4JAAsHHfwWpaM3AwmpakT9xPmI/nBoGB1hzelPEGURgPF9EaAsvaCnJE/EzJDjzDNGlhgzqS0pUtZBFW70WNZBN80JErvAGVxITEQZvwQgSJTxJExbt4hrGTiml09F5IjzPvZDKILNmHIsqq7kJI8kUQYVFl9YGJZ1nGiBNe0Eim8/CBiWGHvKofRF/hDU/NMsN8uF7ETkbT2c8Y1Cz2j+ZRxTxmexE9CsuuUEQqRxSeHHTncjM9N3M8AphlIfYBd9+ibj7VEbnePRNchcgdyL2HLxcIUpv4lm1SVcv79lTdALDME0actATMp2sqIE3uT3idNE1VsQAMUypvNZeCbGHiBw8ypA2OS8xogoP/Fn80fy2yTI6UWVE9PCJ5Q6ITfyLWWzPVXRQI6qRqFOWDo30U1k+8VhrI2LRHPaLbVIOnP/MiCAq6vfjMR5nQmNKiGDHrDzm74q0QuigKD3ZZrm0Wa9Nm8ULitLL3/l1qKcuIcpOSEiIUImUiHDR5osYFMNsiRRT26IthtptpJjKbmzFELfVlsHc5l9I4x1HmO6YSQMqDHQcHWNz56VYtg0M27YIGem9GDqyEUIFEBCAoyYC0YdEPRxpcVuDGY+eEQJQ3Gg58C6Nd+pYoxWdpVV6mkivwlEzGjalPXWwPcbcBGrSku1xtHT7ZZZKyXnp8xr27xZKk7jU5HL9uWtW+cWv/Cpafjn+0et6+QNC+ZNG+SNL+bPPLz5EYQqexlL8hugvbLrvRoVCuKwAAAAASUVORK5CYII="

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAh1BMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3PojWMZxOfeB3/iIX/eJLGmTDsu0NwSAlwTQW8kStmRQCziSf/nXTZqjp5Vgrisz95SxL1xEipgCL/wlazX0nGZVuDTxvZgFzZa27/x1HZi1TibneDXg6Wbxjk8ROaAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAJhSURBVHhe3ZjZsuIgEEDBmBuI2tl317tv//99QzIyXSGQKDEvc160sOtoQOimyQh05axduOKunRV9MkNMH3jMhQEu8+4TUYeDAe7Qm0X+BkbZ+DeJKINJGJ0WbTncAN9OiOgObmRHx0Qeh5vhnlm0hbvYmkQM7oSpIvTYm4jisTYRnB8rtqrIA0u8vohysITTnmgH1uxQhBM0Y5oIPti8hyO48tYwKfJhJv5VtIGZbP6KKMyGdiIHFIJLWAnCSzA+jjidiCuaQ/WPQzA2jnAhUjdHVPWIxsYRT4iY3oMm8zjChEjmwecmTpKXThCmGUCWhp2pBkE9HH9Jkrh5lpnzicg1a5KWXGjyd7iyL4SoAEH3Zi/H37uwpKWR60ZW0PIZJ1KUfyfx59V0LFBUHAFk7HcuRTJ2RRz0CF7z/BU/BUiLIsXXqwfj0OSQtXyuHg1oMceuidvOczLgGXSYY12CXzL9k8ZiO1E8FMWgwRgrRYkG0GCK/Y9FD53shy3/w/6QD9siyqbFjajFHOvgMSJ5O32gR2/6OL0pHlgpB5vgVFVRBiOco6o6qXNA+0etIP5qD8P6bNTUhQj4ErHKUTtM/GUlKKIjaMiiVlOVoMAwHQ0zyU+ZKZbyR2YQFQ8TpDYnHaJy39mO+zISCdLk4TJlq1yqES4wwDEWEWlh0hQpDKHmsiYL9Z4wM5Y1WGiZiglD8YD4E6Vf8NvX/Oo1wKaL0XNQh91iHcJLcJ4oRueXxwsU7POuEMtcauyvWYtc/OxNbNHLsf11fX4DYfmWhn2Txb7ts3wjyr41tnyzDrmrffgHw6IYThSCsTEAAAAASUVORK5CYII="

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAArlBMVEUAAAD/zE3/zE3/zE3/zE3/zE3nWnD/zE3/zE3/zE3/zE3/zE3/zE3/zE3nWnDnWnD/zE31nlvnWnDnWnDnWnDnWnDnWnDpZG3nWnDnWnD/zE3nWnBmRQBwTQXGmTCziSeMZxPZqjqfeB3PojXsu0N5Vgr1xEipgCLisz+8kSu3UkbfWWluRgeDXg52SA7whWOWbxivUT+OTCOnUDiTYRy/U03HVVSGShzXV2LPVlsjA8rjAAAAGnRSTlMAIGCPv98AUJ/vQK+Az+9QAO8QcL/Pn69gr4PI/9YAAAKKSURBVHhe7dhZc5swFIZhCYxBNm7dNEnTI7F7y56uy///YwVC+CKojBGd6U3fO2bwY51hHdiRuOPOPGryZq7D1+bY2pAftAbyAn8cxF1BhoTLT4YWSzracnESxAMaLODDUCjohEQ4APEVndiKH4N8QScnfDMU0qhCExTQyIIuBMdeYtYOJB0KyaqwC/lkma9DXNhCgmvQiqxbvYZCmlAICIPZD8dw5K0LXqAFTWzRQMup0PIZ4jQ5XkPudMitITEdEhXkWwJZHkUxLhRmd+w3yVaVRTgD2NojvWKfqrJ0X5iUXVztoUHemvEOs1Vt28IwkmrCaMSZozm50soNI9Wl8Q68w1yjAwkjYbXJRj8B2IxQ0vzThmjT/CiBE2OkPKNOM+YRqvaM2n2yehNQ1B8JeYx0KDrAPUQdCCP106AYpxi2CVsYyQBZ9E+h/5D3dxwPl8i0Zsy1Afonr8scS0i/fMhh3M4plA5x3GrH9aTfrDzrm78qKwAFJeTbLujhEZBv+YDMVNmNbCVh+cjebasFSVlLeGRzq8HUdwmJ273W7Cvns5SttMSLVv+cNXddOQ+3EtKi++qHm/wRKa+cu19StlLQexkFpK4NzOZeVX2T6B3vvx5j6SrNqN8uUXU38nVv52VsXrfSFm94EB7ySGEu9OYMkD5crJrSpMhqbZNd51v13I+fstN7QHNf/+9Umbr7JHud11BTSFrx/Z+ZL7cAEKCygPQOL7OgrzdgzBAkWPE+fV5ZlD4l2Y4e5QAEaaDHYxAKLaWLBkK+sJFw+BFfjZZwQuqF4nQJCwKEeDBSupwD0hv8EPVBdwD1Gvo0dvWmvWDruQD1G/hYd3V5LuXFx6uzOSBjoz4f/gZ73t2B6qk8bAAAAABJRU5ErkJggg=="

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAWlBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE2MZxPGmTCfeB15VgpmRQBwTQXisz+8kSuDXg71xEjZqjrsu0OWbxjPojWpgCJ4qBYYAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAIkSURBVHjarZjbjqMwDECTUiCh4Ny4dmb+/zd3yg4yJDVQ5POGFR0psUhsix3kLbvn8Ed+z26yoBEFQalySMhV+ZlIZhoIdCZPi6oH7PKoTomkgkOUPBbVGk6g6wORbOAkjdwTlRpOo0taVMNH1JRIwYeoWISe6yYReS6bBJ7PJepYVMJFyq1IariIlhtRAwnTLyOsGF8RSGhQlBzQszdtmGntErNLxPTPd8ck0o1ZE5B2ibYBMTbdnIgz36EmFaGqA0QtogqQPix4Y4bt1owxPiz0gFR/ogeGXJgZ+g4Iun4IMw5jj/8iGXvMBLtMJjbJWZRF++qBglyYzSIN6wNtOzhBNy/FxL1EJWxE6Nk3bURQFmKde9tilgiItepXlAMDeSEksCDFDVi4iQxYyMQdWLiL6KwHbze58cNeHMlFZPYheGen+U+w7vW1G0dikQ0RloofiMCEDYaMH4lGH1b4kYpTIqTzq/UdGSdFyPi1rP8ayTghipjcnKSJjhMiDkQOLORsvwjbT8t2jbBdbHxXbaGAAYXPUcLgvyHi2w9U3YYPJIKPXOv6aVrKrt69IkTZhk92igtvcETysYhIeb4TPYmcYVnzhp/U80M0cGmhRV9xeJ2lVFj6kSUHQhcqiihGCRPp0ZIqj5HRoceNVBdBFuxpyY3FdUrD1kJwNTVcbRZX48fVinI1x1ztOtcAgWukwTRk4R778A+i+Edj/MM65KPx4T8+6wK4JBlhXAAAAABJRU5ErkJggg=="

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAt1BMVEUAAADnWnD/zE3nWnD/zE3/zE3/zE3/zE3nWnDnWnDnWnDnWnD/zE3/zE3nWnD/zE3nWnD/zE3/zE3nWnDnWnD/zE3/zE3/zE3nWnDnWnDnWnDnWnDtdGj1xEjisz9wTQVmRQB5VgqWbxiziSfZqjqMZxOfeB2DXg6pgCLGmTDsu0O8kSvpYW77t1TnWnD+xU/td2f/zE32oVrqaGzyjGHzk1/5sFbvfmXsb2nwhWP1mlz8vlH4qFjYnHYSAAAAHXRSTlMAYJ+/YI+/3wBw7xCvgDDPz0Ag3yAA71Cfr0CAz+P6m3MAAALmSURBVHherJPpjoIwFEaLBS00IQZFRXyEriyu8/7PNRREyzK9JuP38+bk8N2Wotl4B4zxwfOD5Uo/s1oG/nNM5oJmZmEkurC7tnJnz3EUfiSimXjnInuNvFjjjH4gwsKO6kVqMMawKBfD1J2nHo3zP0TUnGOWx4RGIxFrl5NsNI4oifPMHD21RPRVA5/EOO2B3yfjE36Vo70oXgtHVHdCjqzjVmS2caU0otKJRLQVYeGOEQEINiJP/F8kvEaUQZD8QJQ1IvGNRoKg43dER0sE3xosgv8jWLSFkLp7akC2iGwA5GxEZwDaEERyN8J0G+amcoKgF3LrRDfojSBCQmgzeLeQGFGioMuHnq1K0hSlaSAdUNGLCsfHZNCKdpozRyGwEuN6Z0T7BuJXRyGg0pU3wL4RLQwl1Tykrcx/TEkDLBrRqsNqx5U5Lq7ugFWKkp7j01KVHqSa1uE9kCD/Df6UM4s5liutE/RRYJOF3Yo9xqIHs9sU2kqAlkOWV+X7Vifhvams+G87drOiMAyFYTgEtRtLMfAlK/tn4u/MQBDx/u9sYMqIPR+xKbibebdHHpLTRcDxZKUK/vXtfn1ySLrebzwrVHxTfxv6h4r3OIVaRW5LwOR4pZbE1E3bdv3O10zUftd3bdvwaKkWBHXtb10Iu0chPA0IWihDB28zotsZBbltnwN5uWsoaInnQFGkoeAk1Ew7jYTc8ECO209De+HY4cmmJc1e0fBk03c7TDkhiswPhDUdaeaB1higTRQdXzvHKNoMEKBnXe7A3/4XMlZA2xfSYSscax4QyiilkHKCdGKJBwRUUXbM3E+s8AwZS5I/MBM8OdaMILjInYJgTpFzGEHDmqjzpW8GpOkv58jFEhKCjolq7+vUTIMhljh2CCIp32EI5TynRAqCs/mMdUhDMFWuUxkISFRmHcqWwAQEk7FzbcAQt1m/ZtYbIAsCzDJ5Qbs0QBrinC5YKbQDRRBl5N+HBum+AXv3MOxUCiY/AAAAAElFTkSuQmCC"

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAq1BMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE0pLzMpLzNfVjpfVjo2OTUpLzOHdD6UfkCvkUPKpUcpLzMpLzMpLzNRTDgpLzOUfkB/bj1/bj3kuEpEQzZsYDvXr0jywkuhh0K8m0V5aj2DXg55VgrZqjpmRQCfeB3su0P1xEhwTQWziSe8kSvisz+pgCLGmTCMZxPPojWWbxjDVTyWAAAAIXRSTlMAIGCPv9//AFCf70CvgM8gYL//////////cADf/++fnwCswMQuAAACf0lEQVR4AazV3XLaMBBA4ZVtHWwlkEYCQylp+TPk/Z+wROPJ1DBaDNV3vXNWliZEFKYoK0vPVmVhJmkySagbyw3b1I+FTOlIcKUZHXp5RfX6MipkGu5qzP3Q1DGCm94JmRkjzYwWqh2juTodmvKQaSrU8KBmGBrf0UoyvqOXZMz9KKbXoZon1cOQcTzJmUFoxtNmfUi/oPHXJOM/TPu4GHr78e59mA947xftcsXAatkuvPfDyeD9+8+39VrW61/ztM2lFy38Rhn7iKF5BjH0kSv0O/xvJvzZbmW7dbuNOrY/HPbqwObovl6thk4rnQBO2qIO6kuoAc7KOiJl1RJoLiELdOmxBVGbntgBdiJGXxj3qWcOABgpAPhMzh0B9cwegEJK1MsM9JIP1wJQSgXAMTV2APQzrwCoxBIF5Yr0SyKyoi8MHT2CfmTRF37yrdWPLOplhh3fuqAeWdSFJ/6xTL3ZMMRG/bDErn13G+r89amXXDmHm797bkNwbP2+b/hDe+64dW4Pvq/t/eIMw1AOYsnCSkUWlZRkUUpBFoUYsjAysWRg449/Bk38dzT0txUzxo0YhoFgp+ZeYmooy7JPuv+/LIiSJgQtIwDnAduQxexuktMDWTbrbd82YpxGQEtasCuIMZupNeYBMlCP/TbmqEA2x59B9m4NoOqZHIpWgGZv9mNstp4pk60Vk9I2JmoL3K/6vZKfBKItz7QzNxXwc9JrBnnSf7HgcvT/VkbfFR/q25HRhR6Xjksvjh6vhX0IFmQ8CLtv2uPDHz7jxrKfS80+ji4A0q+x+6UmvmZFF7+4KhpXjuPqetyAEDdpxI0sgbNP3BAVNo0FjHWWf82HXyeF45SNwW2sAAAAAElFTkSuQmCC"

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE15VgpmRQDisz+ziSdwTQXGmTDZqjqWbxi8kSv1xEiMZxOfeB3PojWDXg7su0OpgCKj20Z0AAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAIcSURBVHherZjrlqsgDEaDSJVeAt7tZc77P+ZZ4zATM20qMuyf37J7CUgJgTeoQpcGA6bUhTrIwEGgqg0+Yepqn0hpiwJWq2jR8YRvOR2jRKrGTWq1LTpbjMCeN0TqgpFc1DtRZTEaW8miM+7iLIlq3EnNRMyTbgLuSTcBzU8S59+iChOpuEhZTMQqJrpgMhcSsQlKnSbgA0sfHNDKJ1N/i474R45BdEJO016d73p8Qd95d20b5Jy+RIqFc+v8Qocv6PyCa2cWq0WkmSY8KooCHVPpRWQpGJwPyEP7xg0U209RRZ42SMZpQJFhGoOqXW8UWK39Lbz0B27wESbgtvoC4GC4Z5wxgnnkJnMARR5xZsTZIpOCInimxdNgNM1imkJQgKaFJU+8qQuBhnIlIk+caSUqwfyMeTU/w739ZOBmnvPfGHhe2+nh2Wcp5Rz4rbl5RifloogWlSPloojv7us/EvF8h8gte4REQr41tC5sRRfeQcxlEefuF+6xOaBoct67e3QOBrNgoMQslKAxCxoKzEIBCrOg4GAwA2b5889ATcdRHL17CHUbHZBRGtobDEtHdpSGn4pPR7baofFuxhcoXtbINO2ikc6H02ah1QxD396u/odeLLTk0u/hn3g0wtpTMRohcmMvFaO5yuNcBXvWK0T+S036NSvjxS//VTTdVOe8rudvIKS3NDI1WXK3ffI3ovK3xvI364hd7cP/ZYH97lTflhMAAAAASUVORK5CYII="

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE1mRQBwTQXPojX1xEh5VgqziSeDXg7GmTDsu0PWrsn0AAAADnRSTlMAEFCAv88AMI9g798gr0hldpkAAAF8SURBVHhe1djZbsMgEIbRsEwN2B6cte//ppWok6Z/ioOHuel3O9KRsmADh3+Vsc4Tr5F31nzUO9QGQyDGmMKwE4rElSi2Q8Yl3ig50wbFkd80xgZo8tyQn95BNnFTyW5DgZsLG5CZeUezqUGGeFdkAAJnt4TQzLub/4ICCwqvkGVRFqEpyaA0AeRZmP8NRRYXnyEzyqHRPEGOO3JPUOqB0g8Uuav4gKgPojs0cGfDCoVeKKwQIXA853w+IlCf0DdkXpxcAmlrYgpkwTktubScuHViC+QAuuS1C7dOXIE8QNc7dOXWiS8QAZQfceuECsRV6LN58gZqnOhD4i8bIfHPj5D4D4mQfIkgJFy0CBF3R7BExHlYtOIcPEbEWXiwiTPwqJVGag9/7dcRfja+LXmj5QYOVV/Z6KAEUIRNhBRKsK0RfzSnttHS2vqpbkb1t8fyDbv6EUL/UCM/Zukf/ORHUcXDsf5xXX6BoHeloX/Jon/to38RhQmuxuTpQ1+zBudZlfjsLAAAAABJRU5ErkJggg=="

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3GmTBwTQVmRQAkoz4AAAAAD3RSTlMAEFCAv8//ADCPYO/fIK8hQ7nBAAABRUlEQVR4Ad3Y0XKDIBCF4SywJwJqzPu/bGeobUlSDHL2pv1unflnvEB3ufwp4nxQ7DR4J9e2S+vBFBUvNE4nQ0nRoKk/JD7jQPbSF0oz3phTR2gJ6BCWdyGX0SW741BEt3gQkhUnrNIKieIUlTrU6Jwt1aEVp62/hSIGxNeQwxD3HFoyhuTlKRQwKDyGEoalOiQzhs1ShTwIvgplEPJPKIGSvkMKin6FJpCmPRRBintIQdLPkIAmJeRAcyXkQfMlFEALJaSgaQmhctvuD7bbwZPKS2i7P9mOn9iH7F+N9N9DCpraHhEPmrf9jAhoYvWpNfv42/6O6ndrHND2cS20+ctud4qt+cu+ZiaU67GGeTVvP2jxo5/9MMqPx/YDO79C2C81/JrFL372qyi/HNuv6/YXCPyVhv0lC3/tw19EtRBXYwSz0Ae2UIYk7U1aDgAAAABJRU5ErkJggg=="

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAAD9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1jXqkL0w1POoT2fdyFvTQZmRQCCXhGogCd5VguyiCzEmTeMZxa7kDLquk3hskiVbxx3V4WQAAAAD3RSTlMAEFCAv8//ADCPYO/fIK8hQ7nBAAACH0lEQVR4AeWY0XajIBCGi8K/UZugghuxSd//MfcUsZmMkRrCTc9+lxn7qVOBmXn7VYiilAoBJctC/NnmbStwqBRWqOrwpKhW2EDV+0WibBChKcU+Uf2OH3ivd4iOEjuQx59ERYNdNEVcVGE3VUQkTniCk9gSCYWnUIKKkjzMxEQnPM3pkahCAtVaVCCJgouODZJojkwkkYi8F9VIpqYiwdap1i02aLVmK1gQUYkbXW/sF0PfgdH9HXzI3IVKImqwoM/2hhnJg7WjIaGzxkKziGiGRnuPcQg4w0IjzVIQKQT65e+nbxMC355peeYeAbWIDgh8zFd2/k26fi3qnX/Xbr7PBwKHIKroxcbRrNBXoxlzht6kCiJFRRq70FSkZpEAuavDLti1wosKvEzhRSVepvQieffA/DuKRwLSixRuGMsw8UhAeRFiInuJRwIrkTOWEYnERJTJf+aRyF5RO1k7tfEIFyXxP4kUXkbxJZKKzLtos20jAi8j2FabiuKbfyoVP45WXFw/mfmg690FWxzYAclxk71jcniIYkc24zrYFcN1o7AhRQTH2Yc4rGh4WcM9e01lpNBCZzfpECm0eJZaY78wn2M3126t7sbP8GPLMhQrRkdflmkwtC/mRlBktDw21o6Pd+vRWhMrj9nSHcj/mXE9DyAU+VuI/E1NepuVv/FLb0XzN8f52/X8A4T0kUb+IUv2sU+GQRQnfTSWQH7RPylQmhoJW2uwAAAAAElFTkSuQmCC"

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAolBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE1drexdrexdrez/zE1drez/zE1drexdrez/zE1drez/zE3/zE1drexssN5drexdrexdrexdrexdrez/zE1drexmRQB5Vgr1xEjGmTCku6bryGF7s87ZqjqfeB2DXg7su0OpgCKMZxOWbxjisz/1yleziSe8kSvhxmvXxHWuvZ2aubBxsdiGtcTA5QnrAAAAHHRSTlMAMO8AEFCAv88AEDCPv2Bw79+fryBAryCA34/PONr/RwAAAj5JREFUeNrV2NmSoyAUgOHERmU6xk46mf0ImsUsvc/y/q821imHYwCVhlzMfFcpLv4SLSrA5F82WyxmH7pYnKQcWjxNYnbTb6J+3S6KYnGrKtOMg4Fn0/HQvGjM20zOoQfPR0J3BbprKiyJYECUMFuIJtbAyeVLGLHM+0P3RetTCg7SdU9oViiv4CKK7aE5hX6Dm8wW+lh0vIGbFTND+ED0SI4400P4QOTNpzRRn4z8BFery9DnQrMFV9lF6Ise+gHO4m7oqx76Bc6iNYVmheEVnKUU+maGNuAuV6HvZmgH7pbsb6iwgHdIrhWKAkMkv1aIB75sMg37/CTDEC41v8VGc8MQ23g+EGEYip922ht6gneKMZSAKqnOvpZCyHoPXTSqSzCUAsDmYl7lg2g9lKAYoyTFEIfGdrPDp9lsAR6lUOQjINso4RgCTSlFhyz7R4k1dBYXzvbR8VAlNJV9dDSEH6ba41eq8DPZR0dDB1lBRyUP9lFLyM//EOIQjKslEihtF20QWrQxBIsxxCAYw1D42+btbiSDQFkbmkKgKYaG53aspWjI+jj6B9nIoUd5EsqpHPvLbkQ9nYPoOJQjm4hGAlbYGS0lnRBbgsVJaE7DG62+t3QUhuPg1g+lYKiFOD+/7Fsvz2ch6sHNKFpHoJMVaCo5tD1uxb7LVQtpC8XnCKGsgPgcahTGgXgcs8yS78GPMJqd51FUe+P+h2MSRxB0XCdr7wsEg++Vhsn/ksXkfe1j8r+IMnlcjfm7fugPntuxQuel+5EAAAAASUVORK5CYII="

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAV1BMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE1wTQVmRQB5VgrGmTCfeB31xEiziSfZqjrisz+Wbxi8kSuMZxODXg7su0Px8pW3AAAADnRSTlMAEFCAv88AMI9g798gr0hldpkAAAH6SURBVHja1ZjtdoIwDEBXSkZBDC2f6vb+z7mtshOIRMDoztn9Z9R7NC1tkrd/hUlsCjgCqU3Mu8yb9EbmAG8Al+0U5YACkG8XGVvgHQprtonyA65wyDeIyhQ3kJZroqTATRTJfZHDzbg7InPEHRyNJDKAuwDDReR5yMRFR9zNcUnk8AHcrSjBh0i4qOT7p66qGtdjRclEfD8P3vsKGdV3cOB7fC7KuaeSRBU35VOROSx4/BkZZ79gOpiJyLJcRE+DNzTRxPJkJ6JZptuTZx5m8qd2lm8S5Uh8dhV5JFPVffIsRRHgSH8++SsdCnT+yunc4wj8ijLKzEjoUaQP/gplKxtFjhZ3/OEt3qHt6JMYcaMIZqJAGlkVZiK4igwterh0A25i6C6BNoKJogTVJFFkUY2NohTVpFEEqAaiCJ/A/xB9hBon1OFjMbYuCt6Hpu7jY1U3P68WY+ui2jPq5dh6ji5+xkWIrYva4CeEdjHGWN6QQ5h8Z5BjBLBHhJ3adDrzGCcVH9q+iQvVCzGOfe4xYlCNoaNWBdDhr8PRdaQjowtSBUyubBX5tIhQUMzKGgVWLrRYLcDveqnQkrJEHjIJGWLF6EOiVCiP9/61onxFwa5vIfRNzWvbLH3jp29F9c3x69t1/QBBP9LQD1n0Y5/XD6I46tGYzF+IvgBgRer7ci9QeAAAAABJRU5ErkJggg=="

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3PojV5VgpmRQD1xEhwTQWziSeDXg7su0PZqjrGmTCfeB2MZxPisz+WbxipgCK8kSs19xQcAAAAD3RSTlMAEFCAv8//ADCPYO/fIK8hQ7nBAAABsklEQVR4AdTUy3LDIAyF4QjQqQFfQi59/0ftDFXT2K5jGWXTb3uYfxEHTv8KOR8YgoN39LHttDV0kbHCsTsYSowNnPQh8hkvZE+6UOqxo0+K0BCgEIa9kMtQye51KEItvgjRiANG2goR4xCmZaitI6V1aMRh41+hiAZxHXJo4pahIaNJHhahgEZhHkpolp5D1KNZT08hDwP/FMowyL+hBJP0CDFM+CfUwaiTUIRRlBBjYTqXcp4g9hf+DtHqdKkmQLtQDTnMXa6lul6gXVwNeczdirhBu/gaCpi7F3GHdgk1xJgrD9AuXEPbxz/Vy05Iv7w/ZPyxJWT//BKy/yElZL0ii5Dh0kqIYcZyRcyCXFozL8+ImZOHzYzkqYURv/vx/2rFDFIgCIEY+IXtKLS2rv9/5hycgyyYVUjuMyCIqcrfOoKXPOMgdcTPhlI/tiTaviBJZXu33yRS2TuI8Fi+jzd1AxEEa77z7anDG7+NHLQQZtYLzkCLoF+3lHEENRxGh2WcwijDY0S7wGMFsKsUQiU1Ms1SiZ9cRfVyrNd13YCgmzSEI4tu9hEOUTP305gish89eAeLoZFQmOwAAAAASUVORK5CYII="

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAAD9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1jEmTdvTQZmRQDXqkJ5VguMZxb0w1OVbxzquk2yiCzhski7kDKfdyGCXhGogCfOoT3CdSx6AAAADnRSTlMAEFCAv88AMI9g798gr0hldpkAAAK5SURBVHhe1djbcqMwDAbgGvAGaCIfOZO+/2PuDOAIoXWAIdOZ/e/aNF+xbCWCr/8qIkkzCUtklibiTzxfsRduuQQWmd9OQkVQuFUch0RawpuUqTgGFd+wk+/iAHTP4ECy+x6UlHAoZfIeyuFw8jeQeMCJPEQMEhJORQoGoXNe4tADTufBIF5npbUC2PtdzqGEOp0xRm8hbYzpqJRsoXtJHR2DNJXK+wbKuGP6LdQbLmUUKoijJmcAlmGSaJ2KNSTWfVrVhjhMMnUFmG+xglJkmlYzh0m6bVBKV1CotO1rM6eFSFozp+5tqDdCRahMiLMQjXWzhNUqXpCcoJej2wrepGrxLydIBugGa8hxhlNuDcFtgfLXpjvfdnAoXetdWBrkCyThYuQMCbgcMUEJOdGjf6qd5XXq6UdywpMJwtOIuzH8xJSfweGehaQTlDGIbB7fLg5lEyTJ0jCadz99HZcmJ4j+T6uePlAjKVY3BsI/laXXixCJJz3ALtcjsAMZzEtSBtMchJp/FVSfhpQ3e5DxahdSzvCd4TtqnIpClHFDb1n/drYdHKM41Pmg9NSgWh8s31FIbvZlsLATO2z2VJIW0TPTwIE0M6VJi6QI4dXuxo4LhE2b4IjQw4n0OFIkH/tg++RHLZ2M+DTEf+bJ6dcR8AnJWHSsCdMRyw2/IHmqqVd0E5xmahFXRVYWvrJ5liFgrBZ3NFNq4CnoEMFnqvVUMpglPXPKzVjDC+TG+Z3BHd0/y5TyQQsP5vyWuS52KbRuZh4PIhu0aJU0LmIBFhAXrEmF6DDKoBqXhEusGZTFx2NlcKOxyMPqUBgVHY9D66LUhW2nx6CjDiSRWwjeDI3Gg8kbJT9xU2OxVVgep26z4s0qxYdv/K7fin7+5vj67fr1Bwgff6Rx/SHL9cc+v/4gCnP50Vg8vwH9BdJz8tK7m41nAAAAAElFTkSuQmCC"

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE1mRQB5Vgr1xEjPojWDXg7su0OWbxjGmTBwTQWziSefeB3ZqjqpgCKMZxO8kSvisz/agDAoAAAADnRSTlMAEFCAv88AMI9g798gr0hldpkAAAHMSURBVHja1ZjbTsMwDEBxEtMkbd3dufP/nwmUMo85Da0tkDiPnnS0XJzavvlXgPMBaQKDd3A7z83cD01EEmBsVooS0gyYlovAZ6qQPSwTpZZ+oE0LRF2gBYTuJ5HLtIjs6qJIi4kVEfS0gh7mRIC0CgQhYo/CJEQ9raYviSIpiFLkSIW7FnWZVOTuShRISfguSqQmXYqgJTUtXIg8GfAXokwGMosSmUhnEZIJ/BI1JNhthmGzq0eZZhJF6RlGdtUoEyeRWNn2bhi529aiDH6KgK65Hybuq1EGRpFM1/0wsa9GGTeKvIgPZ6pRxo+iUBEdalEmjCK0/yMcRWQXEYsMm80i6/GzyHghWWRMERbZkpZFCn5XhGQGOUVsBE5aG56fERuOHzYbUH5qZeptnp9OB5oFi4//bA7vTzRD5M9Rne3jyyjbvFKRZs0H8nD8yNeiCVd+sh/eTUcqkFYWEdvy40hZlDVKkReFlm5pLYjST7fZSRSjuuMPojzWXcjciYJdJ3KFFkKztFhsatZvdq9qs+TxI2gaP3khETStqBT1oGmO5dKipl2Xm52dZoAgjz90ipGGvJBtUgxZ5OOfPfzp2Mc+iJKYRmN1/kL0Blyl6aH+xeAyAAAAAElFTkSuQmCC"

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAtFBMVEUAAAD/zE3/zE3/zE3/zE3/zE3nWnD/zE3/zE3/zE3/zE3/zE3/zE3/zE3tdGjnWnD/zE3nWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnD/zE2MZxN5VgpmRQDGmTD1xEjZqjq8kSuDXg7isz9wTQWziSf+xU/nWnCWbxj2oVqfeB3su0Ptd2fpYW7PojXsb2n1mlz8vlHyjGHzk1/5sFb4qFjwhWOpgCL7t1Tz2eRXAAAAHXRSTlMAEFCAv88AMI9g798gr88QAM+vIHCAUO+fYI+/QNUzu7MAAALFSURBVHhe1dhpj9owEAZgnMQmB5S22y3bwzkPzmPvXv//fxUmCRObOHaEtFXfr5EeecYeCzz6n0Is26G8DnVsi7zvyUjxYeyCIYa644GQh4pseeYQsX3eE98mZpAXcE0CzwCaONwgzkQHWT43im/1Qy43jtsDkWkNlMswihdJvzQlKohQUNJlFEMWvD+USBA6wCxAQchQQgjqyqKGgdI0mUoQ9nlZI5s8G9ZxhKyTs6tKWu65aSwZmvhnZ5Ny8/gTCXLA6e1Mmh1zITki5B2dHJxSwST1Zi7CXCzca0PkNKcLtQNfMWF71QFpQTavIXDUEFIlSnYL8qvFQ3/UpYVhiKcsx34j5HHzlHlRSTuxSwBRPihZKEq0gcYy8HCsIHrooXKxunENubITQ/qkErYYBwUgubK0OTFpn9SGaAURgcHBjZdKRt5jApAlQUUDFeajC5AtQfE5MpDtTruwuxw4GyBHCYlDlW5A77ofHICo2YrKCD9E0ihRgLgRlJ4clKQ1IaRtdhgLCRWQdvuTWEqigHQHErYrgf3KEtg8BaQbkSISlpBEhQbSDS1GB2H+HUSvdyiOyLA8vxwOh6eVNCL2YOdlDbnfikNrDXea/BSuETK0rvU596v2xabtdhFH4e9kj4Vhtn+eXrfPFC9/DQQp6vF6XMt5N2OMjRgbc03SLC/wGlpf5sMMIEa5PvsN/MZASMjHCvK0TPNzboOQmBuAmG8CpfExKuhTBdlXQ7cVRIIBpT32QMwb0OxfXdDnGmKO+fZvO5z5rIEmvvGBXHUuqIGYZQh11nbHEGKuaWn8R5eDEJsaNpvzg9ifL0yECDXafnlJdzOGEEq6AyndJPOvN6CIECNTPYRXyfzb7XcgEMK4BqVBVitX93dd22yIb+kfEDTbr3tAwHiB5kDywDN+ZOm7/H2bvPGzz/UPUXIGP42Z502gvxXIA78koArcAAAAAElFTkSuQmCC"

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAWlBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE31xEiDXg5mRQBwTQXsu0PGmTB5VgqWbxjisz+feB2ziSepgCKMZxPZqjq8kSvo7JPTAAAADnRSTlMAEFCAv88AMI9g798gr0hldpkAAAHnSURBVHhe1Zhtk5wgDIAvQBRQ4/vu3rX9/3+zI6V39iIrhl5n+nzayew8DKghyct/BShtkCJotIIqzUuVoLZIDLT1RZFDSoAuXwTa0xO8hjyRa+iExmWIWkMZmPZMpDxl4dVzkaVs7BMRdHSBDlIiQLoEAhOJPNHERR1dpjsSWRJguUiRCPVZ1HoS4dtPIkNCzJ8iR2LcXgQNiWlgJ9JUgN6JPBXgP0SOinDvIqQi8LeopkLqKLJUiI0ipELwlwioGAgiRZz+dRjH4bU/jHFUEGli3NcxsN4PYwwdRIZ7pjEy3ZOxPSaIkO1rHd9Z+1RsDwYR879thts83zbTIxnbcyiag2cLBNOciJ2LHts5hB31U1yexbJE2z8XCiybMxHLEMXF4/ITi+WKlmla9r9TMS4S8LUipGKQfSJCDPtohWiWRoSov5rYzk97GNdvb8t8mmoreyoKDAslsLnXUf/9x7BLjoz6ygU532Jy5ODFK/sRUxLDXSwi+m13z4uISpeINCu0ZFtrgJV+ssN2rBiVPX7DymPRC8nL40rJROqghZBszSaamquH3YnaLP74ESSNH38hESStKBd1IGmO+daspF3nh+2VZIDAH79pBSMNnmobJxiy8OTvNfzTsU/5IIojGI0J+DLRTwWK62viQ1a1AAAAAElFTkSuQmCC"

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAhFBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE15VgpmRQDisz9wTQXGmTD1xEjZqjq8kSv/nXT/eJKziSeWbxj/iIV5SxKMZxPsu0ODXg7/wlbGZVufeB2pgCL/x1FwSAmfWDfibnfZcWmDTxv1mmviqEfS+fEoAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAK4SURBVHhexZjpluIgEEbBGEM0FmRf3Xuf93+/0XTFKbpBg+k5fX959POeFEUSgN2Az7y5D4g/92Z8YYctLAQCHRRfBG4i7oVgIfT4aNFyBTdZLUeJuIC7CH5fFIUwgjC6I+JrGMma3xIFIYwmDOyiCJyIbCIBjggq0jwTTIx6ppiYNj7uRF9FATxIoIt4CA8Sck20hodZU1EEE4hQRAqbUhzDzk9BDKIlTGSJohXoxPVGqiQFA2mi5KaOQWf1KeJAyWqpehIwkKgeWWdA4b3I0zQYtYqQRFN5vYi0LJcKsZc2IHPSuLOI3hw1ZpoiByt50WCspjcKI70/4kVv4Q5bHIAjmQFs4eueJoMRZI1u8heMU4+l6ZbRoibOZhgoek8Mo4l7U4GBGfNIY9HjYkow4LE5EcXgRExEc+Zfa76Oz7bYnLXJpiDtM31P/+MzGNiXbXWm/TipKyfSwox+//GZLfcwcBWV1SevnSLIGJBYKkL3ivHyi+ipHTzPSiOJSY8Iz4OpfUKR7qk6pbqXw9vl1zw9SqUk9Fw+HdP8kn07vFxSlW5iWNfAe3egV5zKHfTsZErH4NC9VwPlP9G++sYejNizjFwQpQQD9iyK2u+iFozYs/2ErAyACXvWZ/OfEc2Z9zMij83GiHZKbk7p9oZoxrh9AKmoZ5das5wt/DHtz/Kil8nYnPX7h//ICbltzqbkjzEr8HVU3r4g+lhvjNkAX5DDTUtuRBOZOmPKhvjKRhP12EWmrEcWEaVel700U5bTZc2+1B6ftsGODdnV2IUWbT8YWI5c+tEJaUKQxegUUcjJ8nhKaZHjgp0ONmXtuIWg7dcLc97U4IS0bmqQ6DFRZNz4uZcmjFtR98EWls2xa/uFdbvuNiEjtwME+vCnhMF/PdKYfsgy/dhn+kHU9KOxXzisQ5yOD/8CaNwccIxmU5MAAAAASUVORK5CYII="

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAolBMVEUAAAD/zE3/zE3/zE3/zE3/zE3nWnD/zE3/zE3/zE3/zE3/zE3/zE3/zE3ufGbnWnD/zE3nWnDnWnDnWnDnWnDnWnDnWnDnWnD/zE1mRQB5VgrPojX1xEiziSeDXg5wTQXGmTDZqjrisz+GShznWnCnUDipgCLpYW6feB2MZxP2oVq8kSuWbxjHVVTvfmW/U03fWWmOTCOWTSrPVlvsu0NuRgfKEcxAAAAAGHRSTlMAEFCAv88AMI9g798gr5+/ABDPgO9gn98F53sAAAACRUlEQVR4XrXYaXPbIBCAYYNEBLKV1DkXHb6v3D3//1/rVLW1LpfWYvp+3ZlnxnHAwCgQ40kq4JhIE86++Bv5BpkUYCVkdiGkUDEtRYdYkkOgPGE0SI2hp7EiQJMUCKWTPojnQCrnYUgCORmAWAEXVDAfxARclGBuCB265IQKuLjCBUkYkLQhDoPiJjTJh0H5xIBSGFj6L6RgcOocYuPh0JidQQlElJxBeQyUI6QgKtVBIg4SJyiDyLIjJGMheYSECVSl1mWFQN9E/IWY5eg2lHonrIW44dRz3TavgTrhLZQYUKOPNUCdJC2UGtDsBM2AOklbSBiQ7gLqRLQQeKGf5EkPFJj8Xyjyj41Q5NePUOQ/JEKxSwShqEWLkIDoBC6RuFJctHEluI3ExXFji4vhVhuVsDd/PTu8LvuB5WI30/bmn5nLsnxumuWytoHVsmp2z6W5cDP7B7LUWCuepY1Z5wjHT/ahM9a/tKt1Bx06SDkOEVUHbTZf3z+322/rU9+32/cfm83JwQWXO481JULu7E+WOA9aCyq0wIOW++g3o0G4RyrPYXQ1J0ErXK++4/GCAi3weOw/sO/6IfzqeegKceiD0JHhS81rGGo6p+i7ZlVzPzSv/NcsW6rffNBbbTnhq6gPCl5FMUmHJOG6ToByTn1A2LudPT4gEJ80PtzQBz5pEB9ZXtzQC+mRBVPC/dn21GcfLLt2Qdf0hyjsxnZurryN/KPprencTkMQUUKHDmF398jc3yFAhbDpw+PTH+Xp8WF6Few32lPBV6+ctUIAAAAASUVORK5CYII="

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAyVBMVEUAAADnWnD/zE3nWnDnWnDnWnDnWnD/zE3/zE3nWnDnWnDnWnD/zE3/zE3ufGb/zE3/zE3/zE3/zE3/zE3/zE3/zE3nWnD/zE2GShxuRgfnWnDfWWnHVVS/U02nUDiOTCOWTSrPVltwTQXpYW7vfmX2oVr/zE329e/1+PpmRQDGmTApLzPZqjp5Vgr1xEj+z1j73Y746sQ2PD+DXg6ziSfisz+feB2MZxP64qT38NqPlJf91G2pgCKWbxj+0mNPVVjPojXo6+68kSuBSrsvAAAAGHRSTlMAEFCAv88AMI9g798gr5+/ABDPgO9gn98F53sAAAAC2klEQVR42qWYa1ejMBBAW9QtaisbHup23brrYyAUsE9q1WrX//+j1sXAtCFhUnu/5nBPHsxkMq0GmOU5Lghcx7PYdz0t3UDHdqGGa3d2FAVokV2BuYh5PjTge8xMFFwAwUVgIOo6YIDTpUSWD0b4VrPIBmPsBhHrwQ70mE7EXNgJl0kiwkOaZFEPdqanEtnwBey6yIIvYcmirg8kD6NxGH0QjkcPIPC7ksgBkscwqggfQeBsiwKgeF1GWyxfxUCwKWJknD6HkUT4LCKYbYg8cj7oQZOYk7chInd6GSlYiv1GUUDuc6RE7HhQiVzq3EO1KPz8C9xS1AGCUVTyNBkOJ09RyQgKOkJEBsdYfPf3bVjwVorGGCgtg5VBWM5nKCjnFIos8ClisE2Sp5yneQIVkWBSiiaRAD5hHyI5XLMVF6wyWTSskERWIfJgg3nKK9K5qcgrRA4gmfAIU2a4NKcQuYAs+BYLs80GtxABEnOJWBy/oH78AllUHFecFGcXF4dH/JA60TSNYYM4nRIhIov2C1paRKcRWmSe2GgRnWoJkXnyR6QfcsfrCHGlENnxgkQcDNr98DCN7IeFiW0/GKbavXDryZ9P8/cESJL4Zcqhwq5fRyKhLWazJMmgxjxZz14WIvlBRad+QWKCFMYNuDSGK1Nc2TkvufzBVVzykhxKAkURseYl/f7Pq1+DwfVlye/B4OpPv89L1iDwlWVNiiI19ZV5ykIrNhXFILhg6tJvaiaa4g5pitH5jZFojvGqK49jE1GM5bG+YH+hRTmGa9MTIqdE6LGbHzXvzaIZPmqoZ9b6Ri+6WWueWUpTttKJVpnkoZ6iOhH1FBXY5iKbeq6biXzLtIFwq/bcYgPBsKVxpxbdYUvDsMlyrxbdE00WmcBVr+2WbvvIdM5UojPzRhRyWPccftPS0g+1j2TPUZsU0Sb0mIuQgxPUnBzIo7QIaR+fn/63nJ4f43SU/APuFWhUZfAxAQAAAABJRU5ErkJggg=="

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAolBMVEUAAAD/zE3/zE3/zE3/zE3/zE3nWnD/zE3/zE3/zE3/zE3/zE3/zE3/zE3ueWbnWnD/zE3nWnDnWnDnWnDnWnDnWnDnWnD/zE3GmTCMZxNwTQVmRQDsu0N5Vgq8kSvZqjqziSfisz+feB2DXg7PojWpgCKGShznWnCnUDjHVVSWbxjpYW7vfmX2oVr+xU/1xEjPVluOTCNuRgeeTjG3UkZ2SA4hu5hlAAAAF3RSTlMAEFCAv88AMI9g798gr6/PABDvIIBwv9SquvkAAAK/SURBVHherdjZYqIwGIBRA0QBdTraJRu7a/dZ3//VxraEAH8SIsx30wvqEdBgkpkl5PkBJnU48D303dzMdGARYgLC4eJKKJIKtCJ3CPkxsRT7yA2KlmSgZeQArQLiULAagryYOBV7digkzoUWCK3JFa2RCUKYXBVGAIKOuwShNbm6tQ4KyYhCCHlkVF4fWsXjoHjVgwIysqALRWR0URtCy/HQErUgn0zIb0HxFCiWkLpDlAuxYwda2oGSHthOCE5rKWogXENc1PFqb1L2VSrqeA1hCS1IA6nS4h0q74VU2hBZ1FBI1KW14lnfybrHqYTCGsLt98zpgUlqV7aZcicJdqB5+3zxF4RIP9Z+U3i6jPRDn5AHIKFqJCpUiWbozjTfxkR3Q7kN8i8QGK+UiSFIMApG7gXCHSYV8JOBn6hIOxT+hLRMWmU5+IKXeVGlWqoLlUwqmTJAZSYtVuohWjNVTgbKq5qiWoh/MQlxKPmiuBFiJXEs3xkhysHospZxTgE0pf8P4ekOlkNkaoEctFPz5WNkap58sE0NyUftxLB6+MsEK/bJMJDsC8YVFNbQov+QZVVBc62X57R4YuIzBS3UD6QsFe1SdumpKIoD+4h3DzYObv1ky6oGOQptfxuoaqBIM4nYN9Dp9OPxfP55PB5/fbz+8vf3+c/j6dRAe+nE2mlNqiB98Mp87USLukIUTrS6d2k3AIETigyT0dINKqUTGKfHmQuUwekxnLBXw1BFZJ5tCVENQcoJ7Yuagx1SznpomUW5GeLUvMyCUsJMEEuAY1+KmiDrUlQVukPh0HLdDYo91w2EZ73zLDcQnLc0XvTQi9zScN5kedVDr9ZNFliE37TX9vyGo2s3or7poG/DG1GwG+jczI3NzIc2276z3bhAsNveOd3czp0g2OZuq5jt3WbuDEHq/uHT2j7cS8bQP3SBwaPUo0IpAAAAAElFTkSuQmCC"

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE31xEi8kSuMZxNmRQBwTQXsu0PPojWziSd5VgrZqjrGmTDisz+DXg6WbxifeB2pgCJtO0xuAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAAB7klEQVR4AazMAUKDMAxA0YaunyYQ7n9cJ07dnIVCeAd4aYMM+VZ4KLc8yNiWxoaqhTdF67FIstFgWbqjaWbTPHVFouxS2Y/c6GC+E8lCp0W2omp0s9qOnEO8FSkH6f+RQmBKkQf0PXJO8b9R5aT6GolxkslLtHDa8hw5Af4biRFg8hMpIfodTQRNj2gmaP6KhDBZo0xYXiMjzD6jCnH1HinE6T0qEFfGJFxC0sAlhpS5RE4frVjRksIgDPRBew8+BBYKtD34/8906nWsMQy5u8m+2dTNREzY7NWG6HqRvzU5DwTvSL4e9xB6odtFPJoDfhDcZ4aEA7mIrwmiBSc8y7xuOLFoRAXv2OiNJ7DQOiaiDM50hkRkSOReVX2nVDeEM+RzSyk1L4pjRCxtbuX4SDRJlBqeqUZE606zTBoo7VRxQJSARtMvED0wcyL2h5zPyjVU/urt/y1CvEXMmtZsjJgNNqtRazn8za4jkwtSv7Kj8+E5L+Pw8DURQRUvVBqcmSJr+CwLqyJrvu4Kj8p0H0s/yvhApv7ZK2K0QaApYrQrjyM6iD15rAj2ig6qIth7xQUgVFfKMaiLq/uTTmHaUrPlWVzCeZPNYb9mWS9+dquowXJssK4bGAgGloaRyWJm+9gbUfbWmL1ZJ/An+/ABoF2RA1TfWP8AAAAASUVORK5CYII="

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE1mRQCDXg7su0O8kStwTQWfeB2ziSf1xEh5VgrZqjqMZxPGmTDisz/PojWWbxipgCKHiyT3AAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAIkSURBVHherZh7s6MgDEdBpUprfwGffd37/T/mtm5nsY2xdTbnPyNzRgQliVnBZnnh8MQVeWZ3Mka6UVYODFeV20Q29xDwuf1atD9glcP+K5Gt8JHKfhbVHl/g6w8ie8SXHO2aqPT4Gl/KohqbqCVRhY1UTMQ8201G8Gw2Gfn9XNr2Ilwn6ndRCUZL1L5fR2YqX0WWr3tDXESBibx9EfF9GFsi6jCjpxSZcZyL+AsaAt2JmBOWTXUS8YldJ0//FmzpToiLkzNLKx87ehCAJRP1ke+BSbR/GXzrA02EAYKJfprT/Ob+KTqknUKJnwGcGNKAtKsOf0U2LfBs1A3L9GlQ2hx2EuVcNDYDJIZ+ZKJ8EnnMp9aeu+aKda79OcynBv8QlVCgvIsqKFDdRQ4KuJ2xUMGaTFibM9F5kGKczKTF5x9okGKc3BRY4kITFyHGKYyTH4goCDGOM1iEnkgxzgdRFGIchSdSF+m8bBjoLD8MdDYkDHQ+ERgHFZwpoEJhcqiQmwwqZGo/Nq1frdrPX/M42nn8Nz4d2RKxOU/HbxMhkI5sC5Gho390A0Tsa1qzmA4l2isEDjzR4h7ZxBMtYQcMI70xDsLaz5NRzi8xfpFgyahUX0VaIIJTryfs6GiBDowjLyF4KdI1pxMmTqeme0SEia0VNWFk+ehtDExUCmXWVmqtwk+rFNUqjrXKda0GglZLQ6nJotX20W9E6bfG9Jt1nE3twz/sWPyvFBXt0AAAAABJRU5ErkJggg=="

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAAD9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1j9y1jEmTdvTQZmRQCCXhGMZxaogCfhskifdyHOoT15VguyiCz0w1O7kDLXqkLquk2VbxzEgqNWAAAAD3RSTlMAEFCAv8//ADCPYO/fIK8hQ7nBAAACDklEQVR4AdTMYVIDIQwG0AbIV5IA9z+uM7qruJUtkF++A7zHv0IhJsaBUwz0HHs8B7IwXrDkxUgZA6zzEUXDDYs0F2nBG0UnopowIdV3UTBMsXAfCabJTUQNCxqNImIsYeqj7ecydVHDsvZXJNggr1HAlnCNqmGL1UuUsCn9jhTbtI+oYFuhLopwiF1kcLCfSOGi3xHDhc8owykfkcBJjojhxF8RwY0+o4DTRytmt9sgDENhtImL3cx2Qv5o6Ps/5iSE6KEkGK0+l4Z+gIvNsYlFnJ8oXP8s0OSdCBOW7oBvI8smjqlHSTHvZ+E7OWC9sryUy3ymzCXDKYyVO2CuiQXEj3fOA4/jo40r6HjNSpOXTS7goeBkk5+oHu8XQUiLcNHT7UZkKKDXI9DO2UN8H1QaCYX0lNsgdw1yt0HAodY/+g/QokZvgtQogsbPQSOUSDPZTo9CiXz3//6iR6Fov7ovJM96FNpIo7ElWZX0KDa2VqtNWSQnJQq5tmr+Zp8jqw+k8SfbwETotmah6FlEhH2kpWdrVKNFXg7ypBitVpag14NcaGRIMaMkTZFiRtEeI0cjgT1uG/YkXaVLww6FAoXOz5LqvAZqKk8+F/+PMtSU1UjU93zUyMd29KuNWSyCHgJdhAhrYxaQnAtdc5QdcIxGUaPh2Gpct1og2K407Jcs9msf+0UUymY1dl/GoD8HyZZgPwgCsAAAAABJRU5ErkJggg=="

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAADaL0faL0faL0faL0faL0faL0faL0faL0faL0faL0faL0faL0faL0faL0eYL0A0LzQpLzNKLzdVLzh2Lzy5L0NrLzujL0E/LzaCLz3PL0aNLz6uL0LEL0VgLzkMtou+AAAAD3RSTlMAEFCAv8//ADCPYO/fIK8hQ7nBAAACDklEQVR4AdTMYVIDIQwG0AbIV5IA9z+uM7qruJUtkF++A7zHv0IhJsaBUwz0HHs8B7IwXrDkxUgZA6zzEUXDDYs0F2nBG0UnopowIdV3UTBMsXAfCabJTUQNCxqNImIsYeqj7ecydVHDsvZXJNggr1HAlnCNqmGL1UuUsCn9jhTbtI+oYFuhLopwiF1kcLCfSOGi3xHDhc8owykfkcBJjojhxF8RwY0+o4DTRytmt9sgDENhtImL3cx2Qv5o6Ps/5iSE6KEkGK0+l4Z+gIvNsYlFnJ8oXP8s0OSdCBOW7oBvI8smjqlHSTHvZ+E7OWC9sryUy3ymzCXDKYyVO2CuiQXEj3fOA4/jo40r6HjNSpOXTS7goeBkk5+oHu8XQUiLcNHT7UZkKKDXI9DO2UN8H1QaCYX0lNsgdw1yt0HAodY/+g/QokZvgtQogsbPQSOUSDPZTo9CiXz3//6iR6Fov7ovJM96FNpIo7ElWZX0KDa2VqtNWSQnJQq5tmr+Zp8jqw+k8SfbwETotmah6FlEhH2kpWdrVKNFXg7ypBitVpag14NcaGRIMaMkTZFiRtEeI0cjgT1uG/YkXaVLww6FAoXOz5LqvAZqKk8+F/+PMtSU1UjU93zUyMd29KuNWSyCHgJdhAhrYxaQnAtdc5QdcIxGUaPh2Gpct1og2K407Jcs9msf+0UUymY1dl/GoD8HyZZgPwgCsAAAAABJRU5ErkJggg=="

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA21BMVEUAAABdrez/zE3/zE1drexdreyuvZ1drexdrexdrexdreyXuLOuvZ3/zE1dreyPt7tdrexdrexdrez/zE3/zE3/zE3/zE3/zE3BwIr/zE1drez/zE3/zE3/zE1drez/zE2aubBxsdjErVxvVBRfk7FieXZkXztlTA9ep910l52SlnHryGGku6bMwn//zE1drexmRQBwTQWziSd5Vgr1xEi8kSvsu0PZqjrisz+feB31yleWbxi4vpPGmTCMZxNnr+LPojWGtcSDXg7hxmuuvZ3XxHWQt7rCwIl7s84d3RgDAAAAIHRSTlMAEFCAv88AMI9g798gr9/PIABAABCPIGDPz5/vML9w3wLsm3IAAAMLSURBVHhetNXZrqQgEAbgE7juq8E2RMl5gwLcel3ONsv7P9EkTFnxgNplyPy3P/kUugtfVqKENBow2kihfiznZamoCw1JdFFvhEpSEqvkQ0pWsJJKKh5UvsKTvJYMaG+AEbN/BokKWKnEOlQAO8UKpHawITu1BCkNm6JVCpGzXUqhHWzOLoKScz4299b5WwzcvGvvzTE68QgSVHZN60J8DHkX0jYdFSKG9hUxuHwOooaoah9BBotDOzLzWxvTHrAw36ESnQaRS3+A2Rz6C1INFuUUUjinJ3zxAVYy4OZPOMFqAsmpc+ngSbrLVJITqCKHTmY9N08SVAjRCfXBOQIrxyD1oSgJ0qHz5LAlHwo9QjUQhA5LIghqhIpx3/7GM+L1BULJ1L+1zrVvCDAa/Q9SieNCUOI0KkAicjocBN8BtxEBkhHUOBoCbiMDZCLoY4Q+gNuYAOkIchTgNjpAy8sHdvMEYjT/B8o9bIJyf36Ccv+QBGWPCEF5Q0uQhuxoHJHsGBza7Ei8RrIj5i82+Hw8PheA8x/7Oy3U/FV7flj7OM9D79ban3Gh6fJPF9v3WefL2vQhdPnX352rDbkGYOjv3jl/74ewZxvyK4Jq+kDGGxuf250c5dThuyab09EnG/O3+7LbSRgKgjBVqgX/eqqAYsBWwb+iqxemxpAQA6a8/xMRZDPZ06EX3PLdkUmms4ecdjYVJd18TcHndylK5hn1bIkAcwH3Gx/wkEGa2iWAao2eNBh9+IwF2PM+9IuW8ieGR8/n6dlIC/igaKH6IRAYcSCO1KMyikAcCYE40mB7PU7F4+Wr0FJaFK++lJl6zIU9lwr5O8jEp6TCrnT0BvAAPDTuUGfrUqNPpQEwNKU9q1mz5kLgdTIjaUprFpxOhJiozxtLS1r8QCjEUo0mwpweGRr2hzCCm8MkztBwhj022vGwg1qjaKe/P3S1RrEQOV010GKj+kgXaBjXHAiwURBW0gcO9H2pfUxG5MQ+cGIfNuLpoorUakNqIioZgTj6TxVGMUnBsLmWzvuJI1bHQBgneC7orgAAAABJRU5ErkJggg=="

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3GmTBwTQVmRQCDXg55Vgrsu0OfeB2ziSf1xEjisz/PojWWbxjZqjq8kSuMZxOpgCK6nJ3LAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAKzSURBVHherdjpkqowEAVgIjKAYmdhX9//Me8MN05ygBCmzPmnWJ82VtNJopOwW3xPSCe5xzf25U7kupBmq4FJsvRvEItzciSP2WXo8aTTPB+XIJaRNxnzQ0VOF5IXHoi96GJe7AxKc7qcPHVDBQBcCH72mgoXlBFESCm2ryuQMoBcziT3kFTkkiKXU4lvqLahRpp3QEKoQKdV8jtYiTqQii2UotOtToN4J34khXqKEMuhrFpKuCEgycamcgbQy3y4b5Rco1pySHKYxt+LLw3ZN4gLaTJoB1Ip8wHB7dsU2YVZjujpOI0wkilOQxltoHJqyZW2KRGi7A09iExpYq6njs7TNbMypRE9NPSkD/P8DzH6OGyF4s+heIXyz6H8B0opQNJvKAsBZd9QEgJKviJGQcKiWxjoFsVhoDi6w5yQUs0L97RIxxfdIib3KIE5oSPq3qX0dQndr5NEBJBJ2bTuzt9DBBC3JSmmrTPhdY4Qph35Mr8p1W0Ggs68cPOoRQjT8gG+FH7uwNFAaE/pAn6l9xvAeKBqmvGG4h8xT9UliBtlCxmLeyFeSnBMaSDJkm+h5Jgp62nczYBubOrymErsFunmtzKhgdr0tubObpGYtv9LPZInY60pbjXtbdMgdXVq4DJDWI8RBtDc0cWMCiBmPWq5gO7yZrIWp0mwh3+wcRRsQPpHdrXM2F/ukc3OGNN4deuGmG9Z00Df9S7nCQutfdpBYrgDemyXfvs1+yUpg8Woy/FLOYPl8S6DPEq3hwpcsG+zyMOULSCwYD8srrcANVtVDrvCTjc1rdBGowdY2y96yI4IpYfbLLxBYqlAH+e1OOc2SyfbFCbM8EeKn278UCqlXCwGx38JzvnmWJUdOdKVChz/dt2fItQBQqgjjUCHLCGPfcIfRIU/Ggt/WIf50/HhP95gBHftZz69AAAAAElFTkSuQmCC"

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA7VBMVEUAAADh6O3h6O3/zE3h6O3/zE3h6O3/zE3h6O3h6O3h6O3h6O3/zE3h6O3h6O3/zE3/zE3/zE3/zE3h6O3/zE3/zE3/zE3/zE3/zE370GHs3rHj5uPh6O3913j50Wv38Nri6e7m7PDu8vXl6+/z9vjn48/014np4cVwTQX/zE3GmTD1+Pr1xEjZqjqziSefeB28kSuMZxP29e9mRQCDXg6Wbxjs7ep5Vgrsu0PPojWpgCK2qo3isz+BZy+Kcj/a1sv+0mOun33735l4Wx/91G3Ry7yTfU5vUBD73Y747c/46sT82oPIwKzitUmlk22cHYX3AAAAGXRSTlMAIGCPv98AUJ/vQK+AzxAAIK+fMO9Az2C/1s7nlwAAA6JJREFUeF7clsmO6jAQRS1FUTZIbaLQ8AmeMoeZnufx/z/nYTvpEo4rgMTqnU2wrjgyRaVsMgCdBrOQt4SzYEqvcAgWRHHIe4RxdJ6IBglHSAJ6smgy5oOMJyeJaMyPEtPjolHCTyAZHRHRa34i13RIFCX8ZJIIF434WYwwUczPJO6LwCNYXTfzYoUJVsW8qWsmXBNx98NqS7n2adZlGzN3TwTqAyJL2dvVqtWAiI9cUcRbBJiYs6k1REx0QXQoogkHVJo1ViU4wIV1NEWqOJDQA1GvD1Or2oFnZzVprzNB5G+gXIuWqgvUUq9ztJ0I/DCfCb650asMUvfHkYFOnGtT21Ar7ZmjfWlFE+5HMb0l2B5T3M+kFaFzTPxtSdn/EGFsRZSj6AIXOihMD6JQIwp8EVS41IFu6Q0uCowo8WbQOzqwPYWSaFHkjeDNY/DEia7I8BQSjAl44sR7UcgvQHhFKL8IlEwvI5qS4DKigMzc4maqC1cbXWJINqsuUZlb/BkJuxAG7TxL03Rthxs7SJpsvY+yeZcAIXH7xoENJ4AjEo6JCTxBRFAX0CwLBYkqlpBAvUDUY5fl5Z6N6B9HYqOTPNtBAKIL8L+LQo7zXlXvzmeMkMzw8L6SsuoC/fkeF82GXtoPKeWiNG9KUy72iw9cFAyMkS+557tu+darL3yM4IPtp9Ki3070q1fVDyai2KhV+VZqbjrRjVluc+WvNTb8U3ZrPFUuUrMWeWVMtyzFhn/kP6vvjOgTgk8juvOf3JH/gMzr+kEaHiF4lIYH3yUpgSPb8TwtrOgZgmcrWjyByTmyqecO8mI9FQd4ZU0vnnsJ9V5rWF2/SgklgiJZXntjduy/aLH6bSGhRG6R5OLNFU38Vz/BTAtBiaBIlq0zr2PnMvqvFPPZTRiG4fDCGMRssElM21L/gPJfFTceYeK093+gCRWbOPhS9bv0UOdT6jiS3VQxwFVqFuI5N4azmBYaK81o3h4vGVfAy9XJpqhM0ml1j9X2WBv2xLhRrwFgvZEU5UnatO9qieXUfBUjRIWS7e5iRZfdFiVVMUK8jxkP1MmKUo0HeFxMRzM47K1oD4fRjaf2EV7hccg9B3jEkIvmBJdjLjrCheZ3USD4IBfBBxRUFNFHhKgi6iciEc3QTwQr6p5sxXxa9+NXyCS7e0Eq0Tl+mhAULq8IA04gBVOQUlxhqvsRj5J0T9OQrTFXJBJAbbkPhgAwHIyc34fyzq658g/pyMt2UDuBqQAAAABJRU5ErkJggg=="

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAqFBMVEUAAAD/zE3/zE3/zE3/zE3/zE1drez/zE3/zE3/zE3/zE3/zE3/zE3/zE1drexdrexdrexdrexdrexdrexdrexdrexdrex6s89drez/zE3/zE1mRQCDXg5wTQVdrezsu0O8kSt5VgqfeB2ziSf1xEjZqjqGtcThxmtnr+Lisz/PojWMZxOaubC4vpOWbxjryGGpgCL1ylfGmTBxsdh7s86uvZ3XxHWku6bqE1BOAAAAGnRSTlMAEFCAv88AMI9g798gr0C/nyCA3zCPz68QAA9FxM8AAAKqSURBVHhe1ZjZlpswDEDHgBMgSdu0TTqVzU722bv9/591xnUQtmMg5sxD7yNy7kHyEuGb/wvi+QEFCQ18j3y3cmONTEMKBjScXimKKFig0XAR8WPoIPbJMFE0gx5m0QDRPIABBPM+kRfDIGKvWxTCYMIOEVnAFSyITUQoXAUlugg9DiZTtICrWaDIWueXJHkB6HsWmiIPVBLGErjwLAMFTxfNY1DI2WUR46AQzzVRAArZ229K0KiY+TRQRREo1Jy9koEOv2CK2iKi7tOD8FRgcEjeAlyp04y0RL6SVsmYLIbFxKq2ym+J4mbgseJMwGvoMLGHfHMeEKMokquEIQ/oUck4DpKrKmpEVE4ujjiCnSpBkwjQs2gKqqjIa+iirgpFBFMpCqFJLTmV+QH6OVQn3qQGoRRR0DgWjBWYXW+E/hMRw8MEaOqNECHy9BLIYiU1DI14QuQbO0pSwdCIL0SBsaEkHIZGAiHSa80aYGiECpF9eDY40iPqiry/yL3YKBo5/SgauSBRNHaLoMh10yKtBbnb73fgCsUt8rxP0/0zOBLgpt2mr2zBEb85Ru5TwT244QkREYkJXJMj56P2LpXcOdZaHv67tMFh5vDwn25RpNc7y0/izyXPwM5Uij6kLX5Di7pkDWVtz0yKPrZFW61lQJKDRRRJEb4QvhJ6ek3YRHxCiTJxdcE0ihoQo61ZphqPUvTEDJ4AMRqtz7roFwgyFGiHvqX1+6KLfoCgZCbYP5rN6NfUYNc01WW+2YBgs8lL2Xpb2uOVKfojRNw8wI4FB7A17GtT9BP6MT8h0gs4fNSME1EyXoSe8aIFekYUG+vcNf1On+tLU/TodIFgvtI3xyuNW61K61vHSxZpQs/kFadrHyW71UTidhG1XIn81qvlpIX71Vg/7y/6C8ez+niJa9/bAAAAAElFTkSuQmCC"

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAV1BMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE1mRQB5Vgr1xEhwTQWfeB3su0PZqjrPojW8kSuDXg6ziSfisz+pgCKMZxOBfjWOAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAG7SURBVHherdjZcqMwEIbRboSMxPKLzUuW93/OSTweT4JACHefy3TVVy47NlJTAhemtHiwpSn4tI22BpWziFhXHQux8djgDWeH6gZJTZ0VYoddjvdDrUcG3+6EuEOmjlOhyiObr7ZDLQ5pt0IOB7n1kAMEJZJ0ABeHWrykXYYqvKj6HWKPF3n+Ferwsu5nqIVA+z/EHgKenyEHEfcvVEOofoQaCDV/QwwxvocMxMw95CHmv0MVFFRfIQcF7itkEbn0IfQXIH9iT8QrnXB3OTJhKrA0jOFuHPInKMhg6S08vOVPYKjE0i083PInKMliKTzlT2AJidCcPQEI0lekH9J5s0HQ+fhB0PmHBEHwFYlC8i8tQBYqLJVQUZKBCkMFVBTEUMF0slBgNX/8K6TM188xhPHzOiOl2nlADlN4mgZs8juP7Pcx/DC+7zyyOdXJK3HyWDP0YaEfsKpJH7Q+QuQDq+rk0W8OK2ascOnD6BRWTIh5Th+PxxDG6Xo+4+58vk7ff0Gs3Tmw3+JTx6W/IdIpXyHklxrta5b84qd/FRWUnPJ1Xb5A0F9pyJcs8rWP/iJKfzWmv6yLHVof/gEkFPpTyCKEUgAAAABJRU5ErkJggg=="

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3isz+ziSeMZxN5VgpmRQBwTQXGmTD1xEjZqjqWbxi8kSufeB3su0PPojWDXg6pgCJFK+HxAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAACK0lEQVR4Aa3Y8ZKqIBTHcVD5pZRpHlZTa9//Me9ectlEJJw5n39pvpPsVgdEhMzyQmGhijyTp31ib6GsFDZUVR4LyVxjh85lcuh8QdTlnBSSFT6q5OdQrZFA1x9C8opEVxkLlRrJdLkfqnFIvReqcFAVCoU76SUR76SXRHB/mvbWkfmC58tQd2ub0D65UAmnbzuyDDyGrK7t4ZTrkNR/GUMUCVnmL6XlKnTFYuhoEX60X92AxfU9VGPR0st9HBA0jHd6adfbJFYPNi1vfEbEvDz85B7OhapV597jg/6+KlW/obPruJ2JcbvlSucldIE12k6DJI0tjbAur5DEi0nuuJLBi7Sh/C3UIFnzFsptSLvnTtsfbF+v/4dKMCh/QhUYVD8hhY1HR9Q9gPQVdRIy8GqyHkdWpMjg6w1Zpk9fQSZy+FpatOkryEUB35MWz/QVFELBR076CpRAJDQnrwACPO+IM8Sz2RDg+fNDgOcfEgIsHxEb4vjQAkKBhRIFWBQiB4tcZGCRCQkWUpwUGCjOL/8SMfN4M0TmNs6IKd0PZFg/kTP12KXdT3ZsUrDic0FuQzLeSSlJN9aE9B15uh5BFzdoBX3TxjeCzqvRzzdTwIyAyhtGPRMFTNjS0huPt9O5mcZhgDUM42SIDLZqb2D3PbvH9mvtiY1r8AhxnJbBQ81xZfSYla7mOvhxHkX5D8f8x3W+CwS+Kw2+SxbGax++iyjGqzGuyzrn0PXhP2ETnvYpQH79AAAAAElFTkSuQmCC"

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA0lBMVEUAAAD/zE3/zE3M2c//zE3C3Oj/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE293fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fS93fTS2MDm0ozi05bPojV5Vgr1xEhwTQXJ2tXzz2yziSfW17WDXg7su0P3zmLq0YG8kSuMZxOfeB3isz+pgCLZqjq93fRrTw/e1aGSkXpxWB/O2cq41OWBdUyXm4mtwcacpJmnt7dmRQDv0Hf7zVeHflx8az2yytbF29//zE2N6t+bAAAAHXRSTlMAIGCPv98AUJ/vQK+Az9+PYCAA359Q74+vQIDPvxi2v4gAAAMMSURBVHhelNBncsMgEIZhHSEbUVR8igXUi1vuf6VMCMhgCYHfv2Ke0X7ZSfDFLzma8gv/gu9wWegDJTnuygn9DALOMBDjkAyVBZ5WlEkQEIxGIA5VDBNiVQSCGhOr4QyiDJNjNAxV+FFVCCL4YcSFIk6ylEWcZCk73GdU92YR0zswiaW5q3G3kwtR3OpUs+jEOyQWXaM63KI+BOzF6OcByCReFAMPqq0zN5Y5Ps3WzFaqDeQPpAzSDzMeNg+9oZQ/U+YddjM//sCTHub4m3OcgYjn9B1G6npPIhYqrWOXiTcJVyoNVKBu0M6ISY1aGlBX/ENgXGGddEkYFjTEHchznq2U65aU7dOTHIhriG13O/u0cr3+7LquskXcv2d/EMVdv63UzW6jMBQF4Ou0PUBCoD8z6iZACP0JbUqbUaXs3CyS93+laQE7pPZFFuIsOdYnro1JUo1YsDRRVPeikHHrD5lSeCs7GH8Bur07Z9JvYJlLmS9thG7Sc+rulm4M5riUdSySbgzqhq47zmc91KpooGLVNcxm/9mBruleMw+PzfIn2ebpRNibxwcN3dNCOc9qj9cKWmuBa/bPClqQ2utML5c6WuCbTO02tU5qW15qgm/SFiDtDHsjLZGaazB0zE5Qwm+pS5Mo6LDnD9ml2R9a6Iv/7NyarwZK+Ivg2iQ19MJfTdfm5Ru62h1HyO6KFq9jQK8LujiOkguajANNSIwDCUI0hhOB4I8B+SB4vUC5eSukLN42ZS/kgYCA71eV1KlWvBMABMRs/17ITop3FoprSPQ5bpKoIcyYuXL5Kzkz3QwNNLXXH9LIhx2atpD9CyilJaX97BUkbAdX2aDK4gRCQwgtfSFlUW2226bYbjfVzxMLFOIEYW72a/MHtszXpjOHgtRwwxKIMwjeUMjDOYRwmBPiNwR/2K03IfjDHBOCP9TR0MB9CsFB8AJ3JvDAQxBzV2cu0AcBodNLBWosHoJw2HNfwITMTGf9zGwKOEGAiNkBg1gAPGTG8yNTiXwPTAh8xCS+1Fp0GU8E+PwHx2D1MGYzpeEAAAAASUVORK5CYII="

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAgVBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE2feB3PojWMZxNmRQD/zE3ZqjrGmTCziSfisz95VgqpgCK8kSuWbxj1xEhwTQWDXg7su0OMdECzooD///+8ro/s6N/18+9wURB5XCCDaDCfi2DPxa/Z0b8XzDyHAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAALtSURBVHhe7ZjXcqswEECRMQZsrEov7qn//4EXAVEirYRNksnTPS+eMcOZFbtaFW8GtPLXAZ8I1v4Kbdx4rgdhFHBAEIXLRMiPuYPYRw+Ltjs+y277kAhF/C4Rui9KYv4AcXJHhPa6IG3bVP1q7NGcKDTCaVrGWimQv40RVOgWJdwAs08Rw9wgcYnAVyasJ5OijPUQ8M2ByO7JZRzFMKKmkLHlMyZv3qPCIMxugqLE7in5RGk3JaYoND0Vk9RcUTNJZZpCXYSMvAvKJF3DFU3HJFQYVYA0kV6HRGpgwjEboESvzK+iRK9mNlLB4Y60KSwnDw5s8tCcA3I6meDgvDHzQFSk3EpaABGPPkRbMFEx4U4IBhN4O4l2/IfsRhGaE+RtJwU1buZMaBD53I1oWSEFjHUH7sYfRO6WeMAfxdQx1mbuoGIpCt1flUmIqqAWC5cp7EWRWSplJUSa0amcCtUqJS0ts57O7E1RLwpA9WpMmc6YhikKNh7IWa15qDZlFRjkzVtxS6NWdI3enlyzkK88S/KJeoc2XHFQMRWCA3xvzSFNNbxUGzMhpepfwNoLXDV04EsIPP5L/Irov0j0/FDUkJKq2ixJ802RqJlBPROZsyBJwSwUxFmQa3tdU+aA2it+rU1asNgeT++388Dt/XRUy6wFX7UR2EieL6NEcbs8q2YE2whyeJ4uZwuXJ4cJja0Weo7Xs5Xri9UUjM0fNu3Xs5NXW4uM4HKUA4/VlOuiEC6Qsnxexjy9nU7HL5xOb2MO5egKzRPDJTuV3/na5/qJWXnuK+Iqn6VwyUZmQPcxQ0JgW0PYwxCu2MGNFn5chOFGaxOBkS0aW2TZjLIFmJtRSfITUQI27N8T7eERYrkIHiE2oZm1luIsE0LkU6cTQmQZpq2ZtdB+zGro0Ocr4Wz0jahK+rlRSdwHvwNfQDRzFF3qgaLlpsh9XF9EMnuB8DBxuORKw80e/cEly5Jrnz+4iFpwNfZXl3WQRdeH/wBjlEFpmxcWgQAAAABJRU5ErkJggg=="

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAtFBMVEUAAAD/zE3/zE3/zE3/zE3/zE1drez/zE3/zE3/zE3/zE3/zE3/zE3/zE1drez/zE1drexdrezvyV1drexdrexdrezvyV1drexdrexdrexdrexdrexdrez/zE15VgpmRQBdrez1xEjZqjq8kSufeB3isz9wTQXGmTCQt7qpgCKMZxOziSfXxHX1yleWbxjsu0OaubB7s86DXg7CwImGtcSuvZ3hxmvPojVxsdhnr+K4vpPryGFBk18CAAAAHXRSTlMAIGCPv98AUJ/vQK+Az58AzxAAj0C/n9/vUK9wgAGbZMIAAALDSURBVHhezdjZcpswFIBhyRgBNo6TNmmStkdix+uSPW3f/70aE6weKSAL4ov+F5mJZvwNsmRgRAzRgTN0oc4dOgM6bY9MW/L82sC5vtcNok4ALQUOtYZGYzA2HllB1Iej+fQ4FAZgURAegegELJtQE+QFYF3gtUMhdCpsg3zomI8h1ekvEez0ljAUQq9CHfKgZ54K0aAvFFAFmkDvJhgK4ROFEkIT6z85Ile+f/4BGsEnG9XQWAPy5YKLomwCykLwxTLXoPE7RAEXL7moKpqgQlTxZQw4WkGOwhRCGKG6QqGcCkJLlvAD0z61QzwBWbCHPJAta2STJtBakm5qaol/KAStfVZf9BaOtK2/gAztADJ1VWcTg0XxRpXcKaGKU5RgWVkoEiWD2kkrJwfr8kpKa2hAHLmw0rGW0CZxyBBB0rGUEDQkrpxzUYJ9+mdcAifq/4fueYmBkt8bxk0QF4JnZbJHkjLb/2cYN0F5IZSK3DBugiDn2OG5YdwMQTwXsnlsHseQCx/apotCiGKRbs3jOJcM4SQNiXMayCGD00ADQk8DUXmr/VyuvPlb9vAaRY+zp5UO+fJxZNv6KaqaPawx5MkHpH3Pd9F7u2fpBPoj22pzrg9S9LhSHtmGdYszIctiLNXN/lQQ1V9rjLeCIpfSq5R+PQDA2PCiZb51rKJ/7dYwMr/6xVxocTm7GZLuvn15i+z/NL+MzsWH5viSZOcXjDHC9oVN6yUakmt3p0gSYpOPUNYEZVD3O8J9lVDD5PbbJ0uTBKqSJM32I3JbRkqXB4h5oHfPX3T7BT2EVOhKQiyEbj1qlyQh5neDdip0RlhP6UmFrgnrKa0iNQyx8FQQ63KAYIRYhyONcx3Ssj5kOVOcG8L0bI99bhXou4RQlgdR1y0bEmd1NHap/URasjisu71BdyQM6R09Prz4cVXt6p9vwF++XRSSBZvb2wAAAABJRU5ErkJggg=="

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAeFBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE1wTQVmRQC8kSt5VgqMZxPGmTDZqjqDXg71xEjisz+WbxiziSfsu0OfeB3PojWpgCK/xMGThGGsqZh5YCnM1t2Me1NsTg6GckWmoIriRcLWAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAL3SURBVHhetZjpkqowEEYTkUEUOzu7zrq8/xveEsbpJCSAxZ3zT5BT1en6oBMyA90l+xR+SPfJjj7FIbEb2SGFCekhe0xEkxwi5AldLTqeYJbTcZWIHmCRA10WFTmsIC8WRPQMKznTOVGWw2ryLC4qwEYzpud+QxETeavMOGf+785dc1sU9Qg+FfESYiYS83S353qwaDlemZpIeH2gKm+PuZWUAVPhizJwqAdP611kN1Pp2jNXRHOnrJ5zXBDfxFtblVNHdMY/X9qSj54KIibeCPN78/wrwgXSjCMNepCuxD8wbS8TsQuzPOwCYVqGJrs4gp23RFJUEKNqpSuCw110BMDSmOpFDfPUrSqxNIDjj+gEGzmNIgqboYMoAbu0Ul31Qmm1vrqlQTKIcjuWI6y/QIRLL7Frd/KbKLPzjci2inYMRRgUMvYeS0OYAA/h3tf2W4A8pW7qjb6qu6qs/SCPqKs2bn7SJxLqWaUbOwVufhqNDoSSHUBQxUd+TfcLqHHYkSSQTKEwT9NGKNHBhITswUOjxRMhSoPHnqSeRvJJZ7CjiPRUKYloZC/MJLu1aXsZUdmiWt0tc/mvxd2l6pAI+9IbWMD02NOAiI2aDpbAzwOLilQNKzFlVKQZE/AAgjGntE38hSiF/0KKEdnGHkO7jYTsYAbTNmrIGFNNa2CGHaFxS8+4A+vjLoqvWg+jeAAVUaX48nepxgi8vbw+vw88v768jRGqIMABP0cO9RDwj0GCPH98cs5lKEUZfiAn89QXalD1dQvY1JTjJ3vi+X4P8v0ZMiXBIaKSfAHprxMNjjUNX6TxxxoctBDDV2DA5oijn4VcI5JO771hdETzVWh/0ib+/kGtEykUFcGBveMr6YIDOxYnbEHZtBczPtEZ014VQ5HAwgKbGqyMNSKUz+5ylW5tWWSbNVia2Um7E8PEhQsU3PiVOIfOuVpZhjZ+aFomvhXdYDrEt+sPUfz5AcL2I43thyzbj322H0T9/dHY9sO6OA8dH/4D9OwLOaRAtxoAAAAASUVORK5CYII="

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAYFBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE1mRQBwTQXGmTDsu0OMZxODXg71+Prj4tt5Vgr1xEifeB2TfU7Zqjrisz+ziSfPojWpgCJnaMekAAAADnRSTlMAEFCAv88AMI9g798gr0hldpkAAAHnSURBVHhe7ZjprpswEEavt4IN+cya9d72/d+yAtIahjrxglRV6vkXECcC85mZ+fi3YFxIhSdKCs6+efnwnilKhR2qLCJFWsGD0uEiJgxeYAQLE+kKb6h0gKiWCEDW70TcIAjDX4tKBFO+ELETIjgxn4gpRKEYFTlPkomKTojm9CdRiQTKvYgjCU5FtUESpiYiiUTkVqSRjF6LWIVkKrYSCWQgViKDDIwTaRDaxtrbFTu63tq+A0H/FtFsfLcTPSjXy3T8Qv9B/RIVIDR2pgXhy858gVA8RTQcrV0YQLgsogsI5VNEU//DPgHBd1wtIgZC/07UgcBmEY8WgcJnkUDQrblFaEARs0gi9GHfFtENFDmLFEKXv5tPNB0oahYBCHwh8dlY23xijxMRkyciuD4eV3hF0fx90X+RgqPtbSB9C4ciEekGG8HQkYiIVQKicFkR221ksJEM222ErUN/P4/jOAnGBd+v830da7bZavvJQy/1a+8u12q7+U8XnMNF50m53fwLJxrDRaMTFe4DmSVS7pOdd2uaFBGpD9uQsiZ5+QUptFJfyIqR0i81IpoUo6mhlbvyOG0bMfXxBXt+C3F8U5PfZuU3fse3ovnNcX67fvQAIX+kcfyQ5fixz/GDKErcaCyP40U/AR8z8KjV+ee/AAAAAElFTkSuQmCC"

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAt1BMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE1drez/zE3/zE3/zE3/zE23vpRdrexdrexdrexdrexdrexdrexdrexdrexdrexdrexmRQDGmTD/zE1wTQWDXg7isz+WbxiziSfsu0P1xEi8kSufeB1dreypgCKMZxN5VgrnWnCGShzPojW/U02uvZ3ZqjqWTSrfWWnXxHVeoM9jZkpieXZfk7FghpRic2dkWSxfmsDMwn9lUh6RhlW0AAAAGnRSTlMAIGCPv98AUJ/vQK+Az0CPABCAj7/PUJ/f7/4w0m8AAALISURBVHhe3ddZW+IwFIDhhFK6UFBRRE+SLuy4O/v2/3/XUOiY5NiTUuRqvgsvPDyvbUNtwxzxjtf1ZZXf9Tq8R8eoQRCWBsoPg3YQ9yJJFHn8YGjYl876w4MgHsrGQt4MJZE8oChpgPhAHtiAu6AgkgcXBTSUyFYlFBTKloUY0s7xEkNOewlDiTyqBEOBPLLAhnh0LBRxCxrIoxtUEHWBhFLC9Tt8mRhxYhkAKAwpAMiIk2P1K58pClLvpfAfNKx3YI6hOdRLwwrqY+dh5yzkuxY76QFD/T3EsVMAcpAEBZb4DvJsZrrWDiWtpzbk7SB7yQqlHVpS9kFFJRSYjNhAmRKSTCgo2wj7RmHG2s8qBtJMOspSqKiZ8Q1gPR/9KX3YZIUCdOB+j+k1q5zFVDY2XVSSXjfWsaH8WR7Uc25DHeaZtyQ+GvdRmbewx7poPnsuVuuyQiDVOesy31LEGozS+cw90/kMfUVQSrhnOgvSjpZcMzf058vXb9vEKn0PbfKinH3/8dMNCaVWv5b7ynVZKSXMWbYFq/FnPdOQ1VJDKGr+/0P+aSCfdU8DdZnXBBUbgE3RBHms44ZmKexKZ26owzgFaUdLNMRZz3dBK3hr5YL86p8/BWVglDmgED2OMJSbUO6AAvSARNAUrKYkFKFHNobmNjRHEH5kcxLKAe4f73Y93gPkJMTRaw2GFLzcvfUCioL6+EULQwCvGnoFoKChfvWjoDsjgGk9FKKX0WYIzdHLaFnykVNL0At7DZTaFzuthQbEFsKEhL38og6KOLGpMSG5AKOFrIMCYpuFPihytVdULmQdlBAbv7ZPkZDYiraFQmJz3BYKye16OyjpUVB89vtpeWBPn87icyNW/riIR5dX4+URja8uR/HFHrqe3Cw/2M3k+pyNlydpfDLoVKd2yottFMfxaDSaXG27pYDbcjrZfuw6tpb/L2yBFHMKAOToAAAAAElFTkSuQmCC"

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAWlBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE1mRQDsu0NwTQXisz/Zqjp5VgqMZxOfeB31xEiziSfGmTCpgCLPojWWbxiDXg7zaVm2AAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAHhSURBVHhe7ZjZjuMgEEUpYxpw8MXO2tv8/29OEjKatK/wAup+6vNYlo6FcRVUqRmk0a3BA9PqRl7yqNwD6wwI4+w2kWiPDF7LalG3wyy7bpVIHBZxsiwKHivwYUEkPVbSy5zIeqzG27woYBMhJ3LYiCMRebabVI0HcCwKKCJMRRaF2K8i8SjEyxdRj2L6Z1FABSGJaGFli0sihyrcP1GHSrqHaIdKdkkkqEbuIg3ibYzxfAExnGI8DSD0XcRb9hFvnCh+Od7iR36Dv4ksiDHeecOE1xR/BWGvIscLi4k/mHBM8SMIdxUZir7HB5iQiwPmRQmI05JoACGqKRCBaZTGwtJ4E0YwWrVY/7HPKX4G0yqD9ds/3B+MAxijQOR/SOyvpnEPBkgiMmVSBJfDgcIkKuXnRb8ig3n2n/HK5x7zGE4RrmVczZiWk5bzN/GOObRqMMMhPnHADI0SEFRbqcIyQqWWkvc/H8hiqPhT/UlwHeLib5dXtrw2mw7IHHECcvh0ZJeJ+MiWepHQtaZMtKOLVuHH7ujqV7b9ji6jZT+kF7oel6VIoAt7WdL21EKUlREv1NSUFTZLbVZZqQ3f1/jVt6L1zXF9u/69A4T6kUb9kKV+7FM/iPrR0Vj9sI7ZND78C+qo+oVw6v+GAAAAAElFTkSuQmCC"

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE31xEjGmTCfeB15VgpmRQCziSfisz/su0OWbxi8kStwTQWpgCLPojXZqjqDXg6MZxP4Hq1nAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAACOklEQVR4AeWY0ZK7KgyHQeVXpLVU07qrXX3/x/yPHjNdFxFR785368w3ECAmESvIJM0UJlSWJvLiR1w86FzBQeU6TiRTAw8mlZtF1xtWuV03iWSOILkMiwqDDZgiIJJ3bOQu10TaYDNG+0UFoih8ohyR5Msi9thHWRHREws8iagqH9Y1ib+eV0kTWIAmytdfk5jHp/4iWhcxX/U8TizSGPhuiPFujWm+MaDnImkAWF5O1b5/LBaxP++24kVZAEbORHcAtpvv3w/HsRtM99+i4uPpWbOu6j+mgkXTxjp/ZPzR6sCbE3zyLQ08sJkHDbQAchZdAVj2xJosgOskurGIPTEmALj9J5K85xaRtBxTOYpSHCYdRQaHMYNIw+XREJUWDnVP1Ndw0RexlIXeNNDjL3Z8HJVdykziouDQ0PJleHqfs7oIuXysfG1nVDRSwUWKZOlUJ3zZCC6JSOHQh0Q1HFKR7RDBJRNq+9b4EBq4KIGIYJc0UmIBAWw//nr80NRhUeBC4tUQNS9sFuHteSKwP76/gkA8/zuRwikokeEUMpHiFFKR4BQSIbGOfQ63+WmxjuRU64NLlG7dpDj5e+nIlwqc5K/D//dwXaBDP0heUGBJJvjLpl8Ef9lyo6iGF8llzcEV3bjQOiq6fkq/Q8HO58Xo7uM3cl4e776Qxbxg3/1E7m4LsevRGuk2NbvQbpu1i8Lb+MWR+1vReM/5zfH57Xr8AOH8kcb5Q5bzxz7HB1Hnj8ZOHNYxUePDf6jsmwTRxWmSAAAAAElFTkSuQmCC"

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABGlBMVEUAAAD/zE3/zE3M2c//zE3C3Oj/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE293fRdrexdrey93fS93fS93fS93fRdrey93fS93fS93fRdrey93fS93fS93fRdrey93fS93fTS2MDm0ozi05bPojV5Vgr1xEhwTQXJ2tXzz2yziSfW17WDXg7su0P3zmLq0YHhxmtnr+L1ylddreyGtcS4vpOaubC8kSuMZxOfeB3isz/XxHWpgCKHqKfryGFlUh6uvZ1ieXbZqjpxsdheoM+ku6Z7s8693fSSkXpmRQBrTw/e1aGyytZ2Yi6twcaHflzO2cqXm4nv0HeBdUycpJlxWB/7zVfF29+41OWirqh8az3/zE2nt7dDcsIMAAAAInRSTlMAIGCPv98AUJ/vQK+Az9+PYCAA359Q74+vQIDPz48gEAC/njPAqAAAA3ZJREFUeF6c0nmOgyAUwGGP0EQgaoRMb/NY3bouc/9rTKw6pA9x6e9PxC/CM1lIHPgxhbH0yA/iJ14Se0BJCkEpofsgwRlEYlxshvIMFsvyTZAgsBoR61DBYEOsWIFECRsrxRJEGWyO0ThUwK6KGERgZwRD3vleSpDztZTE7ues9RnW1woMUUBppfTcmkUS/YQEnnur5iHlEMTEB1Qix/bv1BiSama19FB4QXfXv2IB5+akwkP4YNXbkRBU6V5yduZwSTh5WyuFLgNJSn5QZIJyj1QP6dTg3GFBUqf212/IRyib/hLlO00Ozjq/afqrsgESfrhT+gHxpPbSqIs3xDF0aYdj3Rpjuv+MaW7jTOUFQfwNMfBH08+6rXqkMd31FXTtTDOMTz6dPxqwHqIQ9NdKvTSnDQNxAJdIsrZ5hqYdDkzSYPNwHpAATkLIqy1t2tHkkskBDnz/z1HH9qqSJTFyyf+64je7K2Q/4IgGC/xYUh4KUV79qouK2equlK8AOT6QmSAGen3G+j0FECuBTB0ck6M8EzssiSIJFYU6IvuC85IMNQhTKByIhlpZvgjQPjnkzMlpevyMZTmTGbVyesKhQ9JB5xx3PERoyAVTZXmOUIfgrrv8OOPhgrnSxW2TzAl0x0ecMFeCDCDcKdyRLBGcqzAkToeQb16pTcVHaLU0X7JNZbnKoDfz386u8pZCvvkh2Fb8BLowP03bykUM7b2uPyCve6Rz+RHQZYfs5IDxZDL+D2mHlGRnOomiybQ4VCJUhq6iOFfFIUqgLjrXUZLrok4dCLjyYEkKD+fGkCNAN1GWGwRGs9uQsfB2NtoIOTEEHnfGEU96c4M545kPzI4H71BD2HQa3PddyISEd0aokUAUnftIyD06NhJNIKjIDWFLgz7LpW+YrgIpVJYbwpYemJIHPVTOIHDxysQ8Mk1G+rtHiHqx8xTl8k0DzTWORzkE1Rj6nod+sHA+WyzS04vFbB4yFmqgKnAIoLZe/8xDv3rqZ22oOjUQIeqNIyVWnxOPShA4zyr0bAM5IEPQVqHfFk4V8lCkic2r3xZCZ3sIne0h3M/Wy/Yc0EKtgtdfo6CHmir0ZGY8HEuFoFWgIZeCGfrazm1oamIqZQA9hJKN4zUogBFSp2s5bl1V6i5e1WYImq2kq3ar+SkOLTV2uVbfbZQomPMXOjQx1KavDM4AAAAASUVORK5CYII="

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABQVBMVEUAAAD8q0D8q0D/zE38q0D1+Pr8q0D/zE38q0D8q0D8q0D8q0D8q0C93fT/zE31+Pr/zE31+Pr64qT/zE38q0D1+Pr/zE3/zE38q0D/zE293fT/zE293fT1+Pq93fT/zE293fS93fS93fT/zE293fS93fS93fT8q0C93fS93fS93fT56Ln1xEjGmTCWbxhwTQVmRQD73Y746sS8kSvnzqf6vm/5yIb35cyfeB3m07L8q0D18+782oP6w3r7uWP50p3913j5zZH26tf27uP41qn427T7tVe93fT1+Pr/zE329e/y9vrr8/nE4PXg7vj91G3B3/Tu9fnL5PbZ6/fi05b38Nr55a7S5/b7zVfJ2tXS2MDF29/+z1j735ne1aHz7tn47c/m0ozzz2z28+Td7Pf+0mPW17X64qTn8fn6023v0HepH9qBAAAAK3RSTlMAIGCPv98AUJ/vQK+Az++/n4BAIBAAYK9wQJ8AQK8A3yCP779Q368wgGC/Lr6M0QAAA/9JREFUeF6ck2mOozAQRusCfQGEIoMgglzENjvZl973mfsfYBQaj/3ZTQJ5P6vQs11fQRdgabCIeU+8CFI2G4aGGpEXc4fYi6aJWBDyAcKAjRb5c36RuT9KxDx+FY9dFyUhH0GYXBGxOz6SO3ZJFIV8NGE0LEr4JJIhkccn4oEIPLebCD23mwjmM53EFkX8RiIUMcy92a2+VztX0JUb3AIGItzDVS7OtEvULNuunK9wMw0RDqgphAIutROKonHHRPgw9Ii81PUyF2jCx5GTfCEMKl2vzHoBO6BEPsxHAI2qN1iHOfm9aM41pUB2ekJIyTXzHxEz5ZVA3lXjXSAVN2CdKDATExZPf3ue7I6ZXNCJQowYeZY9z1jH1QjPogheNl5U4Y9CmH07XtTiBtAsNgvCZqtEW6dliuIZQWYnR/SgRA9O6wS5Uco1j38cUa1EtdPaP3JNSjr8w6uUtudN/ufN7kn5etALQAvl+dxLV/SlRV+uSO4/lWhBatZreWaDnuxei+4z7G266lpNm3rPC2aDF8IrYZ4vvYDAI2vrUGBjxQAm0u9y9i77QNFHBpuqWGvR8dePs1pa1Nmvhxx/RMtCCPGv0XJrbRsIovDGVhTLFakSV7kgih/y0AdfJMeVnKziS3NxXVMoGNqnFgTF9P//g45XrGZWixift5V0vmWZmbPaDvb1jwv1ZDgax0kSj0dDtU1R32Q/OMC/776KnX410dVRr+7L5RQopeKpMk7u1ba6mhO97U58TtM0mx0WmkT0kBA92O8nB98sA8SjkEpZDqSnBk4j6QlM+bwkCFlqkev2Q02TmtTpzBbNF1KDNAnoA4MzjOugeGiABmDRHATJJZBWFDRKLI0oZwWGL5VdeBXpGWpFQWMbNKYgqN9zZfaEU4FS2IH2cmyDYtrn8HlamR3RkZVm5pSiHwUAkr0z9HaEj4s5BBkLokE3R68vuhL1AjPNgjAnXoi1K07I6hXOxoIwnV6J9YNwoWyklwoWhOG0QKfnCtcxz3YsyDyZAyCfrN+gJxkQduMbMfoAapF1BjciA8IAz4ixBSBatjXMGwPCOVvTogHIlUT5pjgOVGxy6nMPIE/S5t4eB9rStpaeAjlmJx0HMrvIQRBmyZ4B6b5eEts7BaL1T1X9edCKTD7IbwCxMcKD1gBigk2D1haoJYkAxEStBlFXS4G6FogJfxvUbQAx11ET6MYCMRekDbrBqhEQe2XbIJ8DmT8RHKhjgi4DNJi/Najg0gR1cEQwbMPw9pqabF3fRhEGLc6aNDr7NAT12udNlPN2LwKdbtJ6jJxIIyLfh6XOgr5N6QdnUamPRkDKTzpqcfovwkq9q/ZdRevfta96UaWLzdJs7f8vCMXS0aCe6AAAAABJRU5ErkJggg=="

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAb1BMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE2ziSd5VgrGmTD1xEj1+PpmRQBwTQXisz/ZqjqWbxi8kSufeB3su0Pj4tuMZxOun32DXg7PojW/tZy2qo14Wx9vUBAN+9N/AAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAKASURBVHhetZjZsiIhDEChu7kNiund3bvO/3/jKJMxrQHE4npetNA6xZYQEBFkUVYKEFWVhXwLI0I/1FoBQ+n6OZEsDQQwpUwWLZYQZblIEkkND9HyscgaSMDYByK5gkRWMiaqDSRj6rDIwlPYkEjDk+g7Efesm1M7Th3c0U1je2rWXpPgnr5pR8cEd0yjo216MjGRvWrw714RMl1V9l5Uo2fTjoh/aP9pN2iqb0US171ByXa3AS+b3RZVDTiMvBHhPtxjxw8Q4YCD3+POnIvs3LPt4QH9dm6yJJKGPDQzDDZb+9ngBK38znnWkMTamXa4B1C0wMVFT6qJNsgCRUsSoSfJRKLlP5G8jjttfoD/XzpRCdmUTmQgG3MR1b4u07dYK1GfRdoXms7U4XQGWwl9FikucibnQVGglVBvQvLVGJ0JP6KthBQFBEzoibYShSghYuoCrZxSVBA2daFWTiXU74iUgKyhEQIyJ5tEuctPoswNSaLMECFRXtCSKIPXiBT8CgpDJJtKlBCl7z7GMx8dxClFATE2LSs//BQ8sfFgQaKdkphq/XyON3xCEIXJ30/vwuL9OAzHdxcYPYTQeBwxqDr5GhxfWH0EqGMHZH/xfA/I98UU6pIJH9lY5vwMV36wjAkf2RL8nLBDsy6dwI+clTX+dHIk0RHTh4clFVo+xjPDjPEMeFlQ6RcQ/bkXHfxrT8WoX8QBBhWjF2yOyLKCnU02YwLOil0h+PIzTr6BsUsN35CMHTBqfs3iIcLgIWK9Fz8etIQ/aHXwKsrTCMHTiI5ejtMTm45e19NTrY09IKQnf1PHnzRSj6OVfOkjS/6zT/5DVP7T2Osf6zhPPR/+BVHrDCcrF11DAAAAAElFTkSuQmCC"

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAolBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/eJL/nXT/iIVmRQD/wlb1+Pp5VgqWbxi8kSv91G356Ln28+SziSf47c/29e9vUBBwTQX1xEjZqjr5yNP/x1Hisz/42OD28PSfeB38oLP+0mOMZxPsu0PGmTD913j9kKb9mKzs7er+iJ+BZy/82oP26O2un32w/bwAAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAALbSURBVHhetZjZmqMgEEYlxlYTu3DNvq+97/P+rzYJ1AgBQog9Obd/fUdRLAHPAmn57QCQoO23yN15vHNBGAWgEUThdSLix3CG2CfOok4XrHQ7TiISwUUiclmUxOBAnFwQkXtw5J7YRGEMzsTheVECV5GcE0VwJZEi0j2b8VOVz19A4WWeV0/jjdHk6Z7FuMoZc1CY54xqvBAmTZTUGiw3izCpVYkqCjFYVjliHto/qiUG4amI4Hsfo6TXX4KRZb+HqjEPYnIiwnm4xxt/BgvPOPg9zkxZlMie3gIusOjJpkSISIwefDJ2xNPaS4PzxJvvM88GnNgwUx/nAIo6+HLR42oSE6SDoq4QocfJJERdLiL1uN2eD+j1hIl8pWAwHJUHRsNXcE18JopB5nFS1kwe3RKIj6IQZL6npcT025oIwoMoOvGUCt+2RBAdRIE8rqkqmj7aEyS48whITEqNiS0REK8FglcU/Jnl+ewPmgb2BGl5PgiGLP/4yhlfXDS0J4jvtUEw4lfNEX7lkT1B2l4AgpIxy5FZybAnSOCBJsprUGRJBLcQNR8aipo/bLOoSLNVyTC/fj1ZZWmhidYppfSNiz5Oph1rGQNT8k4pTRXROqNHttd8Ilt6JFujSPbQz537R7v7pLKJT8iUIg/ubeSBe3B0AftEClrzsHNrbDvm4RTsE/HZDQk+ty6tdsvHJW7JZ20kozLvqx/e4geg8Mqb/8/qjcpkrI0QAKAGwMT5WsJa7e9FAWv+vxbx5h/+D1HIf5CZnmVgxlwb4y871cMUzJhrfVxEFHpYgBlzLcFlDaTONwSm2m690FqLkYsP0YyptiOWfpg6eECvjU4Wo6nDuBClNiany+MiZVfC9mlBrU3UBbtlw4AYl4b36hZCQ/Fo2xx1C8EJm4pCbZvVbGiJZePnir7xa26KbrM5br5dv9kBQvMjjdsfsrgf+9z+IKr50djtD+sEVx0f/gW2mCFZwA6oAwAAAABJRU5ErkJggg=="

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAulBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE0qZ5cqZ5cqZ5f/zE3/zE3/zE2koW2/rmMqZ5f/zE3evFgqZ5cqZ5cqZ5ekoW0qZ5cqZ5cqZ5cqZ5cqZ5cqZ5e/rmOkoW3/zE0qZ5d5VgpmRQCfeB3yxlJ6jXvGmTDXuVtth4A3bZJfgIWvpmnKs2CVmnKioG3Zqjr1xEjisz9wTQWHk3e8rGRFdI6MZxNSeonkv1aWbxjsu0ODXg5UXD8BAAAAIXRSTlMAIGCPv98AUJ/vUADvgECvcACAz89AII/fzzBwv2DfnwBo8FuNAAACu0lEQVR4Xq2Y6ZKjIBCAJUaFnVV3Jjszex545L6vud//tVYw6SAKzLJ8v0xX5RO6aYtqTwPq+f2Angj6fg+FarxQQYS5AxjOszMfP1y18a66QD6hEqvsws07RUlK2ywE0ac/bbxWBGHayWJVMWKeFcXInKOYUA1PlWdeBUhsEKGBSgGJmj3zwOdbgTs5RxER6zSan1jTmklWUf8YZQ1um6JYUaeHk5ltbApKkZuGSMryEUSnFR3YxoYgUq0IPMBkuVyueXY5S+Y8UtqxtXvIEXgkhg8su/CYjYS3ML5wz1fxQMa0i9FlEdOs4rBiDEFX9803QRSBQE7TCB6BebMe34UWQaRzY7OqYkN4NzCD48D4IfZa6xzCnyfnxc0ungUcB2a9A5EqQWveV2oOXHuMLy3SvbGJlBOZJfdMKUEg6u73aQYsFQmsU4jPooR2stCvaHp5RXISpVSL8jWQwrQWIRvP86wW1fzkVfNtRPOswT0TEauNSVSiiFqwljy/KhG2EQ2nDc/T72vvOqAOCEIPUScgr+dG1PN8NyLf67sR9b3AjSjwqCPaord8LAbG+VtnzCzKiyIvxxsW2IxL9qszZhaNC4lxZ8wsoo9Nz6MiZhZtc9GTbxUxs4juBFO+U8bMIrp9OXtetqqYjOJAbnhpyo0pBgTOWsRZ0zr7jLj7sIWuPrUh1gtey31R7MtXvQhXokjr2e0Lzn6nFUWVKCS69XAPN+nWREIm0h2AsgBKXfGNl4h9Aex1NTNeawoBtSeVLlrWokS6+tluDYuXUftkw2WUEf9P+eF6zBjYH8hBKIoQsW0RgkDEiaglkTyJiO08cXukgW08uGs2gi09IAKwrQdElnmK1ZOIiLxfQyK7kYbMAFkPWQD9kAVA5pwbxj5Akuo1afLuGRuMxtoQH9kP64AAR+qpn5p/Gh/+BaBjQTVr3IgnAAAAAElFTkSuQmCC"

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAWlBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE1mRQB5VgqziSdwTQXGmTD1xEi8kSufeB3ZqjqWbxjisz+MZxPsu0ODXg7PojXW98z2AAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAJJSURBVHherZjrkuogDIChFAHF0LvXff/XPB42o8YSbNl+f3QynW+4BojIICtVa0B0rSq54xE7BmM1zNDWrBNJ5YDBKblYtD9AlsN+kUha+IqV30XewQKc/yKSR1jIUeZExsFinOFFHlbhOZGFlVgiSnku7bUJXQ8f9F1oru0laRJzz9A2IdLBB12INO1ATFTkn5r4OSNCuqfKf4oMek5NQNJdQ0JzwpihIonz3qLkPJ4gyWk8o6qFiJNEhOtwwobfIMMNOz/hynwX+XfPeYAvDOd3k3+JpEMPjgwPHa3prXPiNfNj9FxgEZdoGnENoGiPk8t5eBMukD2KDi8R9eRNL9HhVySf/Sbjk4d+L6NIwZ9RUeTgz7j/IsM0Gf9xUYp5iGxqa0ZTH4eTiVLsQ6QTomjqAxXRKEXvhAQKCkKPP2yUIkUFjAk9bJRSCQUZU5+JUpSogTf1uSilFnobkRawTddAQPlg86Ly6UdR+YKkovItQkUlm5YVlbO9SMMmaFHDJtRCQZahv4cH9x7yKFFBjlNDrh88FUlszCJHso2SMdVy/ATCD7DomPw5ho6KugE4bDyOOKbwwQQcJndADmEG1ySXPbLHuWjMHtncvF3noisjkuRak8xLlA6SHMhFa0ZIAEn25Oq3SHSDBJZcRstb5CS5HpeLPLmwlw/2cfaEKJh++oSImNIFaWbPrLIt4hMPv5JNa5mn6No0YpnH8drEZtnn+rpU63MFhOXJ35k1JQ3+ODrKTYss25d9ygtR25fGti/W8awqH/4Drnn+hLl3HG4AAAAASUVORK5CYII="

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3PojV5VgpmRQD1xEhwTQWziSeDXg7su0NcVpZWAAAAD3RSTlMAEFCAv8//ADCPYO/fIK8hQ7nBAAABaElEQVR4AdTM21LEIBCE4R1g2gA5sQff/1GtQlxDIskAV3633fXf/hVS2jASNlrRR9mtNAyWccB2qAw5RgE7eYi0xwmvSRZyIy6MThCaDATMdBVSHiJenYcsxOxJiGZUmKkUIkYVpn2orZNKx9CMavNfIYsG9hhSaKL2ocmjiZ92IYNGJg85NHPbEI1oNtImpNFBb0IeHfxvyKGLe4cYXfgnNKDTkEIWnWwKMXaWNYR1QXK98HeIDu8QLYB0oRhSyN0fIXrcIV1UDGnkniF5QrroGDLIvULygnQxMcTIhTdIF46h8v1TvFyE5MtXK3ZsxTAMw0D0OYm0/8hpULn9dwOgsEUSQC+EH3tC/vsn5A9yQjoiLyEY2gmdy5yNCPPb0DLfrRHms8XGPFu1Fzn18vdzFB9IP9m9iWBb0xsttn69GXV77Ia9jxAeavqY5cGvj6Iejvu47gWCVxp9ydLXPn0RNaAaAzKhP2NuheyCGxumAAAAAElFTkSuQmCC"

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAn1BMVEUAAAD/zE3/zE3/zE3/zE3/zE364qT/zE3/zE3/zE3/zE3/zE3/zE3/zE329Or29Or64qT/zE31+Pr913j64qT1+Pr913j1+Pr1+Pr/zE382oP+0mOziSefeB1wTQX28+T1xEj73Y756LnZqjr64qT46sT913hmRQDGmTD29e+Wbxj+z1jsu0Pisz/735mMZxPPojX47c95Vgq8kSv55a5B/fvIAAAAGHRSTlMAIGCPv98AUJ/vQK+Az68AQACfACDvgABuo7KoAAACf0lEQVR4Xr2YiZKiMBCGOyIkKIzjXJtwep9zHu//bAtuszYCEsjsflVaJehH8icQ03AFNrCGtkLsoTVg02ag6QQX6KDYgncTMctVDbgW0xaNxuoq45GWiAnVimDtIs9VGrhei4j5ShOfXRNxV2nj8maRpzrhNYmE6oioitBjYALqMTEByacP3qWIq57wsoi5fUUuK4l81RsfRTQgk5iAdMyoc4Ajb4IoRCNlyAhFY1PR+I+IKWPYSWRVBcsofku222RHBbv8yFscLasi6yS6GLLZ7rAtSKgo8yCH3awscnMRV5TnGL/fIEKS+FlReCYSJQ2x1HSNUlKJTGTXfDU5RMsXVcPLMjokNZexp8AqKSTxu7rKe5xUEmQwuBB9fs1UK7OvzwvRAKxSCkmk9JhFSSlBC4bqRxgCZm2KDfvV0VxzXO1BSrkIzTThYi8lyJz1hgqCVF4lDahms5A5gCc/5mePbOVsCj5QAPPi8ukcw0rbRSlqyI8h+1RIMXepASZMugOnbq4lsgj1RJgwCRiK4OXfwzoiTJgMOU5IbGhXzpPQJrfIEaPTBIcHGdKbFnPXABMmWPQxgrm3gwlTBsAqE17HU7mpGD5qCdrziGLjw99YJHA5MhZxXCBNRS4u2aYiXLLZKghNRGGwYifR9CafXt+vm+6izet3PoVvJpMJZK9biaTrrHFaorwZ61Qit47jgJNxJ424+5UB+dvDo4nn8cEpWuQ8YUO1oWE83efA/QmfRKcDGR6/YQsRBjqWIGzYQkx533nEK9usfiKvZuPXRyTqt6KdF0jRsDnuumSLlu267p8I798WEMxLGuZFFvOyj3kh6r+WxsyLdVU6lQ9/A0kp1SH59UKsAAAAAElFTkSuQmCC"

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAz1BMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE1fVjpEQzY2OTWvkUPKpUeUfkDXr0gpLzPkuEp5aj1sYDuhh0LywkuHdD6tsKFRTDhndX+8m0Xo6+6pra9pbnH1+Pp2en6coKPP0tWgrK7fwW3c3+E2PD+zs5rQsV2Ni3OaqrTZtlrCxshDSExPVViqm2mPlJfNu4Gglmy1ubzAt43yyFp6gHlxenyCh4pcYWWEhXb2x1DswVOA44qWAAAAEXRSTlMAEECAn7/PAHCvII/vUN9gMGxp8PoAAAOKSURBVHhe7ddXt+IqFAfwFEl0TFRSi73X0/uZPvd+/890CQvcIMKZB+/LrPm/SchPslm4o6WN7bgN5OFjPNRwHdvXxfLtZgsh13U+icNOGwgpXtsRgU+O6yLUatZQE7MEyA1terXdwYYEbfqdduiigPtNAqGTb+y28IdB3ZMVIwJ5+ALxCIQvkr/QX+gCCegRuUDQnw25l4Dc/xcq8iguk/QckCZlHOXFWSiUlVEelzTJOSgpaeJ8JEMhgRyZIVMNEFyVKecEymLO6B+NJ870UM6QwTDD2mTDAaNyGYJi99miK/xBKlaAvlRsJDsDKKMhowGX4IiAo62Mtlog+VaPOUPqFPi3U1BpyKCeFcLGahyjlDAotFwBUh2zJECu1Tg+87E+1TAibBINKwDkcfWehoWUDRmXx4xH5nEIstBk/+UgrjcuhcSFdhxy+LKfIAtP7u/viQUVlJIUunFQCDDBFgXBIuuJ+yk9IVnarz9hrB+HWwkkD0xj6bCm8RTTqOOigjkk4+ao0wEyW2YFoMn+5u3w9aR0PLd3M5a7B86cbM/Xw9vNflJD93VAIxZA32fHfAeIKGDQ2wnESFGD/DsTgiHKTbxGOu0fCTJOtQL1a4Qq/QLnTqiQuvgAzpqkcegBoAcOgSGdtTY25oU7L9iYthVic95nNO/YnK5lc2CaDIYFVnP7bTb7dovVVGk/mXLIhi5Ce2MyyLPfaSNZPqAdKRb+i3SVH5Ap0SodURFjWvIU/MkIZAdMmtfI9WK5YlyU5/OMr2+UZfM8jxixWi5KsYcENoGg1aY1sF6vF8vNU6nN02a5IJNoM4VGSyBYEh5TiGa33TyryPNmu2MT6jWPYEE1JHf/3RryuHzd/GTZvC4fxUtkYyphQRTyO4K0rYXl5mqtydVmWUNboZt2bA71MEhPi/VVXe7V53PMZ3rpar14Erqp43PIdwUJqvpjJyu7H9dQrhRDpQHyWyCNS8j1assK87hdgSK9tSBfhGwPpLQ0R37b8GwOqdI80QrQZ2HnAVKkYmp0IjiNnZ4vQKo06hucHIvPBRBILWx8PPWtGNUOQBBXebuBwHu6uO8ayHc6AlVFitOvgAkcXw/5dhuLVJ8/oPoHpGH7CiTFkdvKfBzVWHTyM+zx5agQpNvBH6TTBUCEVAqZGA8YHQTpNYLzStCAGhshSAgWKCEACmRIr9tGTAtQo9kzzf0PjJ6JIxqJ/JwAAAAASUVORK5CYII="

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAz1BMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE0pLzPKpUc2OTWUfkCpra92en7ywkt5aj3kuErfwW2aqrRndX9RTDhsYDvXr0ivkUNEQza8m0Xo6+6tsKFpbnFfVjr1+PrP0tWcoKPc3+GgrK5DSEyHdD42PD+qm2mglmyzs5rQsV16gHmNi3PAt43ZtlpPVVjCxsiPlJdxenyhh0LNu4G1ubyCh4qEhXZcYWXyyFrswVP2x1AfjjicAAAAEXRSTlMAEECAn7/PAHCvII/vUN9gMGxp8PoAAAMhSURBVHhe7dfXcqMwGIBRgRDYAYxFde/d6b1vff9nWoFRfi0RKDvLxc5OvksZDpJskQkqTdOxQUz6lkkMrGtWWcjSGk1CMNaPxGHdNqk009ZF4EjHmJBmI4UaNM8h2NWyT+0Wrcixs2dqLiYO9xsMIoUnek2qjHiFGRMGmbSGTAbRWvqEPqEacrIjUkPk/4ZwHRD+JyG3DshlkC4BOmPfH3eU45BeAjGHSapxNRT4WYFyHCD5ZncPUFc1DmH5EZkdoJlqHCLy0+/nKcchC7UroJ5qHGojt54ZuQjXA2Fk0Do2mxqI0Dq+fkoQWR7f9v/uB9m/PV4SRJeDwQCsjx8RUBiwpCgDwfqjQyveigoDyqQK5ZDCUigAlVtqBaDl8eVL/3th63hXN8O8mzvOFL6e7/2Xy+NlCg3SQGMWQE/Dt54AYgoYgzQG5aSoQT+GQhSS3MT3SK79lEHyS5EjeQzs0ldwbvjCpJN3+FkraBy6A+iOQ2AIEWTTys65c04rs5FLq7s4OBe0Og9pHBiF4+eJRLq6Hg6vryRAb9oNRxzSkEXEt1Y4joIOVRdE45C/4/j/Il4OTUI/b8S0XhnRY8bI5/EleAzSnFyap8jZIl7l3DqK5gGfXycI5lG0zolVvMic59xxNAbBn9ppCmw2m0WcnPilnSTxgl302ysOWwyCKdHTDMra7pL798h9stvmF6Rz7sCEUsjC4tt9u4Ee4sfkW17yGD+IH/l+2IMJHSCrJUi7VIiT/aakfRKn0M4PJ9xpaRxqU5BOFpt9ut2rVxnzmn203yxO/DeH6haHLCxIsKtftr8r2y9nsF1TCgsDyGqCdOpDZ6tdvjEPu5Wg+CE4xBIhzQRp6iuD/aGmBlBRmocKZwaOwxyAitJkVOms4TS22hZAEqnTrXAiKq4LIJCa9APLmwXgkNQBCMIU6pzKmDDqgIM5wiFIb1Got37ndHvAOLpVDlmaTUWqG4qLEmdDDc2SQZBOqNj8dJ1i68Jr2ITpAFTMa1FFLQ8AGQQUqWJMxiggqG04csUx+KIUEOSCBYoLgBqC2p5Ncs0hRqNtVfQLwutu6T8O+1kAAAAASUVORK5CYII="

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABGlBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3nWnD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE37t1T/zE3nWnDnWnDnWnDnWnDnWnDzk1/zk1/sb2n/zE2zs5rNu4HyyFrQsV2Ni3NndX/ZtlpxenzswVP2x1CEhXaqm2mglmxRTDg2OTVsYDuhh0LXr0h6gHnkuEqvkUN5aj1EQzYpLzOUfkDKpUfywku8m0U2PD/o6+6pra9pbnFfVjr1+Pp2en5DSEyHdD7P0tWcoKNPVVjCxsiPlJdcYWXc3+G1ubyCh4rpYW77t1TnWnDsb2n/zE32oVr+xU/8vlHyjGHwhWPqaGzzk1/vfmX4qFjtd2eaqrT5sFatsKHfwW2grK7At420ijwoAAAAG3RSTlMAEECAn7/PAHCvII/vUN9gAABgr++fQABAADDhrIJoAAAEKUlEQVR4XqyV2XKjMBBFBbK8xPZk3/xHrZUd20n+/zcGkKXBgrQexvf1njq0iq5q8muSlC7YUvks2YKmyeNvIY/JesMYpenduEi3ThFkuU3H3F1KKWObdS9aO2bH6D4Z2u0fhWS3Hb6Z7CnbuWLdiVjwxfuNiobdBxOzTjR9w6koRZdah4WuRZeyOE1f3IlC2tTCRfJxwaUvahOapiJjcRsYDaVhVEiDirzHB/xM3Hm8CRdV4jrSFTIoqllRU0M/b54ZEEG0BbUIAibLeznUjRfx1tetCFNbUe2LKdpyK+IgkIAV4QzvRZ0Hjek9BmeAP5AHKfAM23eKQPKTPIlbiMQTeb6N6JmI24hEXJT1ouwGIjXk/0XSimRU9BIBcivKI9gLeY0QjRU1EeyVvOEAqEsA597ICl+kwokKfI1WZPUB0S2KbhJ8vJN3qhGiVD4lgmk6nKMcIZSPxv4ss1ekwAaKj1QMV+TQMxU+ED5S1ZcHsrdrAnNIq67SzjFgF21PqIWyOYpfi/jctzLbUbJwWFPOzIzfKlE2rloQ5jFTwfRh2OOgMr5hhJ2/f74cqGVwS5F7LrUrvn6+z4yo8/F4/Ofi+YWFTM0kg4sl538Lr6PmNIEoDMOg4rQjgeHWJEbTNhFjUBcwIKASU5ObnfYiTTMm/f9/o7vN7nw7FJf3KjPA49njmFEoDDhQQ/4J6+fL86/f+L5RmYlden4RG1YfNcDCaq76kIC0VrMCSG/pFUCH99Ozt/PK6mSDi6HoYiSZyttz/nZ2+n7g0CsPGrMAXTJCdAmIKTBeeQwSpKqhL0Mliv57CDuq175WIM2thl3zMtjSNzgX2FDN8LZhUQRNQiNAIwnBULKMHtV2JZ0rqq1nnFB91x/ONdXnGqYExv7kZlojDW6Hw9tBDRDM5v5YQiZ+1CwIy5+EUUybi8KJT1gL5beIK6CpT0RjpgXHiIAZYyKTR3AZZNpCWnLkLklXgsvCcBnJ+eIoWoZhJohVmhDejXBsk0Fem4pmHMjzPEmLNTnaukgTdhN3JlTU9hiEkeiGQx9ty+L+f+S+KLfiBj5zjIE4hJHonJBtjnbpQ/FdVDykO/USIX6AgTjEchSp5EJa7PMj7YuUQyXxp9JxTAn1KaR1ku/5ulePdczjv0v7PFkT5ohanoS8tiJhq09bDqDt0x3WNaM4GCDvM6QNQXerUixmV64UhfhwLE+FzC6kGWkM+6FdE1BVWvoNzgKOzRxAVWk61joZPo1O3wNUI8VzjRNS9VyAIGHjmuMtIjgWdwChNkXxpnbLYUwr7zsgpZZDUZCRavMAjN2SBiBk9qhKzX2CFmwa1MGxAKm1LKq23GQcyyr/hrsYB1A116ENOS6AOgiUpWO6nNFDqN+x6xW7g0NpIXQCC8oJgGYI9d2eJTTb6nzqe5r+AvwaAFkuZ9SMAAAAAElFTkSuQmCC"

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAn1BMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE2vkUP/zE0pLzN5aj3KpUc2OTWUfkBfVjpRTDjkuEpEQzbXr0itsKGgrK7fwW2aqrRndX/QsV1sYDvywku8m0WNi3PAt43Ztlpxenyqm2mglmx6gHmhh0LyyFrNu4Gzs5qEhXaHdD7swVP2x1AqSQhUAAAAEXRSTlMAEECAn7/PAHCvII/vUN9gMGxp8PoAAALMSURBVHhe7dfZkqMgFIBhEJGkxRhwyb72vs/2/s82hHiaxCMmVnszVfNfddHyCURTFeKNBizkkf4q4iELqPBFBB0MOWcsuBEnBbElcFEcnAI3AWOcDwcHaAATJGcJtf+NR7olGdt70oRxCf7AQLx2x3SoL8bT2oq5gSLdQ5GBdC/9+9B/SJVZOZ3cXwbuJ1NzqfJCZWYr86JNKXK4zjkSXhGAoKmXKqaGQBCvILc1Ry2bmKVj7NYwBBUqB22CnV9g5AqWjCGXqm47m58z81m1WLsUBDH/QZTF2WDpPz4GEOr9OEs5Rx3td43DEN6HOnemc+2FEu0ph4/YPRq59pQYKNC4u9ssu71TdUgdxzUu8EDGMZJWZQlbs3/D+NVQkdmKtnEMsabTseVt4/iwOYYWR2jRNo4fSI3LqrzjOEHGLdDcO44ak6SfFSWE9QMxEuo+DluHhOs+Pn7NCV+tHzffeyA3j+sVJ3q13W7rFn4V8LhTDLDSxIJ1C72cnvGTqaQ2cGV4EsF4dwUgZHVTAFqtf3xuPmpHB+0fdlUPT8DUPp6PzeeP9eoAbQ9ZDSwHPe++enaQVcCw0w1Ukeca9Ht3knahSXBGPu0PgryXEtl4G9jcT+c8wMYaFy/xu2Y1gJ4c9AQQGGdxEuvWXsB50a3FJNHtvR6dV91eSqi+0P5tt3vb6wtRInhfv0XSPqDUQFR+35HUQIJ1AtRihiEmDhCVXZim735JLSRYB8Y0aVqQhcSoA5Mt0FfwiAI0vqwsJ4axLXW9QAAkmB8oCjXJp9lXqnFjAIlhEzLLUDO8Hi5OIRpdAS1ulUZFFCAkdX0UAfqWNBoLB3WV8L4AAmnY1eHgAASxbg4DBEEiGF3PyED4IUHja52QimYICvg1TATLwZArvbi/UWoBBGGKt64GGAzhxqFsVmQIm0KQrwRbMkywgCHcOI15pUkeDsaipb9gOGUmAyAReAAAAABJRU5ErkJggg=="

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAn1BMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE2tsKFEQzY2OTWvkUPywkuhh0L/zE0pLzNsYDuUfkDKpUd5aj3kuEpfVjqtsKHfwW3Xr0hRTDhndX+HdD6aqrTAt42zs5rNu4HyyFrQsV2Ni3OgrK7Ztlpxenyqm2mglmx6gHnswVP2x1CEhXbaAn5CAAAAEnRSTlMAEECAn7/PAHCvII/vUN9gMACPBp1/AAACxklEQVR4Xu3X2XabMBAGYCQhxg4CXHbva/a97fs/W+kcJKMIBCTuTU/+u0zEp2UA2053CGUu9woVj7uMEuiIA0AmU84Zo1fNOvWRMOP5tAlcUcY4n07+QhM5RnAWEPyvHxaWCB/nJAHjQvqTCuIfZoymRW949GHFvIKw8tV4FVRcJN/QN3SBCHxELhD+f0PsEhD7t9B+sYnLJG0D0qSMN4t9KxToSraIS0zSBiUlJl5kOhRUENUZHGqFMIlO0Q/QMpZM99Zk4mU3tKiRea4GmVnm85pa6BBTzqpe9Lroybo+gJXWNa4786wYkGyuS7yClNN9Mt2npSQHZrWTo7MvBmePUq6gQDZWOuOkREGsAaEzQtIgV+1Znc8631Rsssll+4y6eY0D3GjIqVQ5Zf11BW2fbnbN9cZlI/HeXsfsbp62zo9ie319jZbshZZkb62jUgEVhODZquaNVyk+Ict09fcvdFrrzUsdKPTCIdZuyTQ+oNNS1xYgIc0aEk1RkGGNUhS0fbq9293rR6eAh8djncdn5ejtud/d3cquVUFNWmfo5ajycoZQkQZeXkE1qWkqP4+NNOrGRbJrXdovDbINdUC0TiM39/vsPMqN6YbxrOmahJ7P0LOEdENBfmHNq3RercPwxWbP2xHzVvRBpOjJw/vx+P5Q9ELAL/VbJBoAHMp4c0rX3VBUQUQMgTCHtMMRxIFhX5CyZX5Qb0YzDBzAJQ3Ket71iSUIQoOWpD6M560LQgggHAhlZRXTCYmEZl+DKEgI2Fe2xuAMwfTzh82hCRHvs+33iIQ0afQNKQjoEErjoXAGOoTS+K15BEwIyHTsYXMCBoRh49rPADogoOHwG1JQ6IaA+EMhl4ANAqB8yNY8CmCDMFHYd9hhBGCFFMVt7feQsUMqM1e035DCpQA2yEyAlvbyF26AwBgIM4t8XmuCu5MZdOcPArizuM5zivIAAAAASUVORK5CYII="

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA4VBMVEUAAAD/zE3/zE3/zE3/zE1ndX//zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE0pLzMpLzOghkH/zE3/zE1GRDYpLzP/zE0pLzMpLzMpLzMpLzNmXDpmXDqpjUOpjUNndX9ndX8pLzNndX9ndX9ndX9ndX9ndX+ehUGehUEpLzP/zE0pLzM2OTXKpUeUfkC8m0XywktfVjrkuEpndX9RTDihh0JsYDuHdD55aj2grK7fwW2aqrREQzbXr0jyyFrZtlqNi3OvkUOtsKHAt42zs5rNu4Fxenyglmyqm2nQsV16gHmPwzZNAAAAKnRSTlMAML/fEABggI9Qz+9Ar3Agn48gAO9gn++P30DfAJ8Av0AA74+f31CvAM+mQqR5AAACx0lEQVR4XqXY13LbOhCAYfYuy7FiJ04UO70sWNWba0lyzvs/UGwRAkCB4kLif+HR4OIbcF3GS21HugGm1duOncpp9ccOPOdipzjkwUsmcopDHpTpyCkGOUBzkVME8mFT0HCKQ3oILMOEmiwlyDIBK1KCOoDmqkBHgBcoQDqoZJygUABKhX4zZHVANacJsgJQ70yCEEf1TpqCMyKEFJM0y6vSq+4nIY194o4M0Yo70cpfn9ZBHuzujlFxKlAJOZahCBpLJpzi0pScSpAJSINZTKnRAGh5/Ka7BbmAl6creqkroKXkuApZIfDwYcUZuxLpViAXVMuqd0rJ2wpkKkN06CsKDci5CPnKTrIZOIffCVBHGZqVzoxPjRwLECi3Yk9Gy8k5h3x1iNDEoXHI2x8aMGhMugwK2twoEW4EbSDgUAQthg3wvr9O6/ePAPb/9vM+XKzTLi7cJuB+/rCQfyAT4LnsT63RCC2XS2rxX5EJCHXUIFg8zEUrf5YmuQgZDAo5gFtyJoMQBrUQCLH2hu7nj0+L64p1T4Gb2yHt8qNta7bdDC1fKjVqbaDfQ9ZnHILrxdPjXNB4QyEJUtVwCNfYlG65cylBaloJ3XCoHHYIB/Z343yx15ABh/andL7aJeTCwf33/3D47btNIR9a5fIVoh0UceisFdTjUKtn6whQz2wBOSLkKAJ5Mk6nRdk0vUsAIKyuEAGOXI0nMdluNP3xk6atv0aIks0oIver+j+k16AMpkzBISvYycyqQFwUaZpmyXMApiWtEHqIMnGRZldQya/ZRWrHNGajKcbM4Hm1S40jMXlRIqtpBnUFlgTVS6PyKgOoL7R2LX5+uAXFM75ayY6+exXVTZDCHA4dttQGOrb3h0qOYaFvIk4MwHOV3tZE2KQMXfVFlNNEmc4+79iiDsJgEO/kKJCU8CxiAA7xLMcTJm94fq+hf7PI0gomp5g4AAAAAElFTkSuQmCC"

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA81BMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE1drez/zE3/zE3/zE3/zE3/zE3/zE1drexdrez/zE1drextsNxdrez/zE0pLzNEQzZdrew2OTXKpUfXr0hndX+aqrSUfkCtsKFsYDtfVjqhh0LkuErryGGgrK7ywkvhxmt5aj2ku6Z7s86Ni3OvkUPZtlqaubBnr+LCwInfwW31ylezs5rNu4FxsdhRTDiHdD7At42qm2nQsV1xenyglmx6gHmGtcTyyFowP0o9XnhKfqdTlcmCrspsrN6VrbiDgl9GdptXndX2x1DswVOSqruEhXaTt7dQJkBRAAAAF3RSTlMAEECAn7/PAHCvII/vUN9gMM+PIBCfANPZUPUAAANTSURBVHhe7ddnc6M6FMdhmsCJwXaS3UgU917Se7b3vf1+/09zQSP+5hgD8Yzvu/298ijjhwMSM45WmG6YFrM5spllGrpTlObotQPGTNM4yS4bdRA0u25kgRPDNBk7qCVQjatcZnq6/Gu9wUty6/KaumcyN/VrMcQ2rtg84JWx5sbELIZsvofsGOJ76Rf0C9pDrnxF9hD7f6F2b+iL8HwbcB4Kf9hrvwSa9XwhC7dBoZD5vVkeMikTClEKqUJKmRtQ5KdM8a2l+VEx1FPIYBTxwqLRQFE9CnlwFmroMa9orB7AApAXQwZ1Bsm9zwbyAw3r8gOVDAnBwZMZSJLT6Pp5CIlCI+m0pRMJWcRpdL0tpVEKYddC6WA4DI7IOqRwvWtsDSmH+2qDIWxfb0sIBxInZH1yhIrT6Dr9jqO1OIlA48p11NK8Eqh6HXmauR/I1CxC7PCwaZbGCLHD9tOYxvrT55uyg1e9fvM87TON97vdLrWqXxGqxECfaxIkVvVLqyJf1cDCul2tbnllmwNoefwyCJY7KYCo9TOIm79cAdSf3t3ffFpbPxLoowLennVUZxdw6PZ8urm/m/YTqJsEbZ44GOldB71bQ4kCo5sUQ4qE9m8gu5TOX51MHMHACHhG0P4OVJME+pNARYZMc+llvitHbdw/HXSmHPIokLv5rl2l0JWELjroIoVg0HetTpzrAF1L6U3qvOGl1TWPQB9TBifgfUf2npfX1PSsMwkyTdRR+tDpfHjLK9Lpz5plFlru+L9IMwM9ZKGHHaBmDOkunHlAmr/YcfUYckxAlzBwusejYShEOByNyyDTSSCMhEOEozReCLQYlwyUQBgJd4Z+E6ReyUASchrYM9rvgjacbXUaegq1sGe0P8RGj1slw0khx8RppH3elEJI5MYAOQd4z0hfRPVMzMlCuq02n/ZV5Bpymq2nEKRVHvo2GEVtHteOeoNQyJ5yO68gSMGWeLb2k7Si7Ia1HECQSiB07gvh0/sChCogUI9wGJzdofy+56GjvLMqYVzDKYCO89Cy2LF0pwg6zEOTIsbGOASiI1UP1GgC2Aq9OqJOwc8kGwyFiFTpuBZuqhiid/facvOKB6AAQofHcqqj48PT09NWs86U5jKr1nJK+g/aZs4QJxGcugAAAABJRU5ErkJggg=="

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABMlBMVEUAAAD8q0D8q0D8q0D8q0D8q0D/zE38q0D8q0D8q0D8q0D/zE38q0D/zE382X78q0D8q0D82Hv1+Pr/zE31+Pr/zE31+Pr/zE31+Pr/zE31+Pr/zE31+Pr/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE37zX78q0D18+76w3r7uWPZ3dmzs5rNu4HyyFr50p2xvsavkUNfVjopLzP5zZH26tfl5NfkuEpRTDg2OTX27uP41qn427T7tVf/zE31+Pr+z1j28+T47c/64qT91G338NpndX/46sT73Y782oP29e/6vm+aqrStsKH913jv8/bQsV2Ni3P55a7Ztlr735n56Ll6gHnAt43+0mPfwW3T2+CltL2qm2nCyciglmygrK5xenz5yIb2x1D7yXPswVOEhXb35cyDDPLfAAAAJXRSTlMAEECAn7/PAHCvII/vUN9gMO+/n4BAIBAAYK9w3+8gAN+/rzCAcwpqzwAAA/JJREFUeF7slMeO2zAQhnnyxdDJEISFod3Qy9cYqjf3ur2lvf8rRGGWnuEE5hpITkG+4z/ixzaUOEkUqpEcwJGBHKkwujqFuIrGEymVCi9pHA6tgjEYhlRwGSol5WT8UzS2A2KpgshUh5/AQzw0c0aBkrHNxr1IshkvJvAh8oKtWPYiTP6AQS+Cv8K/I/ovSvJUa102PG/KPk7z5FxR2+lfZImjz97jrgVOjE8EafSRmuY15g0wJIqoB2l8uV9UaEqKhVRTig9FpWYDcAJK+btIsY255LaQOzHfnEIRXxA/7poVSr+o0IzMVjJeKbgooEF+vigHQtCLQhpkXhGvICEXUQc/I865In5rfhE77ERzWltqNYcftvSKktMl3pDg21pN3yyD/UaugdIx0QJLC1bqgHItAqDUnivO+GIpgfA+tWK1rt5ZbwvvYxMjoCTO3nbwWh15hZ2zswQoIyGB4ny8h68VAWDvTOIghZy/3NwBgh9vAD67ItiQSZC7m5e5FDCfzWbWRVo4NRf2DT1rc3WpbXhi6QVzEEbouG53m31egGGLoi0Yiny/2d2CgQ4VsCi11sv7B3RRHq3nETNqebhfaq3LBQjbZ8snK3d5rgzPmNC1PC1t54ov0+n07btpDFwoZXWoqsMKA7oj03Y/aqu/56SBIA7gkSSmYipVsJPUMinD9AK0pRBb6A84RX2wqX1wdKRPTl74//8F92Dndu+G0ZtRv8/JJ7m73b1VBcSxJ9apctXptHW/Cx2Pmgh5byMgJPo51piy/gQpBas37wsNoQT64OT08WzulLPH05MBvIIOg8QQpHO1dFMbjQvIeGQaagPOwXkrNBRr6ULKy80jtEuTaYGZTmiHNp+7lPJCO7EXaqiUUi7xgwhNrgqdqwlC+MtLeLzUUOgFQmeFpU+ZFizTOY/qu5XQCTyfoB50mOGMCiMjA4Ku6xHkezVBubYu4rEJja3L/VpQal6dQTfW2gor1uV+w6AnXhSDQLW0cIU+UQ1B4siLQnNtrpC5shAgn0G30MZuEAyNWwb5ADUYVMEsdoNgiyoGNQDixzaDYewGwWif8UMDKBIsuVy4QQuZC5ZIQbHgxX3nBt3xshbxGgrNSnKDzCoKCaJZsnSBoK6HDHqmIOP8Szh/F+gBOx/j/z9o5g7NbMioSOEOCZbGGqr9PVT7t9COBTkMNhvaoc1mkMOotSF/G/TCZfi/3AYFJrSfHmnIvo4wR+m+CQXUIjRskyRJO/NtFyTmaZplGQ1a6jVOl/IwUek229uv7HbzdaZyKEt7jNQ5VMlXCWYXLAoquxnmQFYc2sNRy7q/lVC66fMOau1O8003o7Tk0CztX7I8UjwuAg8DAAAAAElFTkSuQmCC"

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABg1BMVEUAAACSaMpkIRa/aVJkIRZ7RXCSaMqSaMqSaMpkIRZkIRbXnoTKgWl7RXDXnoRkIRaSaMrXnoSSaMpkIRZkIRZkIRZkIRbXnoTXnoSSaMpkIRZkIRa/aVLXnoSSaMrXnoS/aVLXnoS/aVKSaMpkIRbXnoTXnoRkIRa/aVJkIRaSaMq/aVLXnoTXnoS/aVK/aVLXnoTXnoSHVp1wM0OjdrnGkZasfLDOl43Ec1uWa8a1g6fTm4ibb8G9ip7JXFy7GjSHX72EXaigLmCsN2x4U6x0UKiIUqaXXrd8VrGLYsJ4QGWPZL9qKi2EUpJtO2hyN05rMUaDXLmQZ8iIXrZoKCpnJSF7RXB9WLNzTZ9sOV9lJB+FXrt2UqpyPWWOZcZ/WbWMZMR6Va6BW7eJYb/XnoRkIRa/aVLQln2PUD+BQDJrKR2SaMpyMSQpLzPJjnZ6OCs0NjjFdl/Bh2/RkXjWm4GeYE26f2nNh26MX7Ssb1uzd2J1PFqlZ1SWdGbKgGjBbFWWWEZR1cnLAAAAMnRSTlMAMHCv3wAQgO+fUI/PYADvIHC/r49AEJ8g3wBg71DPv4/fYAAwr8+AMM9gAGBAvyDvEH02kTMAAAOaSURBVHhenNHZbuowEIBhK8oNQSKKglxAVLRhOyeFLu80dsK6L12XR6+H0ArXZBL633jm5lPssIxalm+LfbZvtWrpsRoR79pCy+7ysyBu+a44natRNMQLgsp1ckKOKzIq5ILKIrv/nIJMh5ZoyNEAQsqAuCtyVqahgsidQ0Fc6A0JyOUEZAm9jSDqEpCvO7OI/qR0yNWhGJ7IT0qHhN4zQExAdl5oDKoZIbV0qAfQKyXp0BNCESFZCZEIrHQPcF85Ac1gX5R+Oz9xKigkEHgmNJzCodch/UgeJFBDnW0DGi/hp+kgRUqgtgIaCioi+Bv6jOC47YCA8EpFBXmgqhxDg9cp/G4ZD1OgCqg8BfVx6B1BkNJzPD4F9RDqK+gBh4tsCIu2m3gw1qELhB4UdLdWw7UB0R1B12pd392wQK4S8o/Q/kIrGbC63OF4aUJv8/kbntpuQJe47mSdSfmOY9GE5pPJHE9tN6Airu9SKmiBY8eEJio8td2AOrguFHQrPwD7KwTYh7xlV1ICVg2bzfOvFlYBk/KKBQdoNKqG5z52WB2NDlDA/n1DqseXc37/y+NX6XXT0zYQBGA4CNpwACkyhUODfPHFSm7OB98EWm/rYNPWbqlpvbWhxL3slf8vNlY2E5jZjUnfW3J4NBnNYSPEHHIbXYBkXq8u1POkAlB3AVJUHUgxJKTqD5Yxg74QBggaHpiYgyEwNERTh/9kh5gxQ5gCCBgaWqchcXR8MnnRyfGRoKF1Cbn7jwBhCjMYetx3JdR1twDCFGYwtOV2JTSrKchOzybno9H55OxUkDWdWQ1HtWaT0sXlh9Hoo4ax1xyAoCbB+IyxT5+FYRyAoG2PYIKxhvG23yzUWPywV16FdZnwqtzTv2p3yshDDJkXqccICbXLUg6lGP9C6McpyzaGoA0pRdfA0F1H6lGDIRhJ9sXIhF/LaW0NBCPJvsWJ1vn+A15ZBmhXMjc/Qy2TpOz2128J7S79v2ZiRMaZ7PbPDf2nBupYwlAesGl8uj+r46jwZbdsBOBxWDHbn93SQa3NGuP4cKObLQ1knCdmVfGibdNQx8Dc3VdMkD/XOyRkLRuHoyO1SEjLjO/VklEU9FbDJH9hyf8DjX28ZDPk6MaBgVaHHnw2L81XhpK0Eoq8qCQerwg98PmS79BVmyBynPj5j0yT10IZf3nJcfUNz14F5QFxyUnBAK8HZZy6ZLUqntWE8oBeLKwqyDH0BDiwLijX8OTzAAAAAElFTkSuQmCC"

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABI1BMVEUAAAC/aVK/aVKSaMqSaMqSaMqSaMqSaMqSaMqSaMqSaMq/aVK/aVKSaMqSaMqSaMpkIRa/aVJkIRZsKh54MSOSaMpkIRbKgWmSaMrXnoTHjHTXnoS/aVK/aVLXnoTXnoS/aVKSaMpkIRbKgWmSaMqSaMrXnoRkIRaSaMrQln2PUD9yMSRkIRbJjnaWWEaBQDJwM0O/aVLXnoTBh2+sb1trKR1tLjh6OCt+SXu6f2mJW6ilZ1TTm4i9ip6ISDg0NjiEUpKbb8GHVp3Ec1spLzNnJSHShXW9IjmPZL/Wm4Gfcr10UKjFdl+WdGbKgGieYE2BTYd4QGXBbFWzd2LGTFLCO0jQfXBqKi17RXC/Kz5yN07RkXjUjnrAM0PNh267GjTVln8u6ZTTAAAAKHRSTlMAMGCPv+8AMHCv3wCvIBBAcI/f34/PAABgAN9AvyCPEO+AMM9Qn3CvAHO5ygAAA5ZJREFUeF6ll+dy2zgURqFGKXIkOUWJN+skkk1twKLeu3vv6X3f/ylCMCSAS+gOTfr7Y2LmmzPA4ZUMESWJ5JPNdruSXHOztf7uqe3m6bv1rRcvkpV2e/NJMrEWDOGLxOM2yOu3//735pVhmIxiGsZ42mg+ew47jxMqKFERhbuLq1/fTzteGMh/Pv3+6+riTjQrCQW0fdpRI0BITrdfeiH+A1b1j4ah/vFC/IfVtXHDst1YjXFsUL236NtS+otePTpo3BjaKzJsjKOA6mbfRtM36yEggbFDwlAYaIPySFZQlGhvaH9DvL95ztkT9WsUtMfreQiSNvRFmDVQVV+ULZHghmhLqOj0MFBL9PMyqERXKXrf6ZjhkmhJAqXpCkVWx8kwVBJNC1CBrlLUYyBjGCqJFjgoRVcoGvIPbYgkmvJBxcwKRX0+dNN+iKSMD9qgqiKrK416E5UkJoBw1UBRw4Af4SYiSegmXLVQ1JyqXxdds49LogUXVKVQUQfJe9NCJNGqC8oHFHXwGONrs2mpkvIMlKVAEQChCUiiWY3Ak7XuD2rBsxGtDBUJ0OVyeSkAcB2UVNZIkUJFArQ8OFgKDFwHJdEi0YEiGXTgRGDg2g5K0kkKKIoAgpJSJA0URTgalJQmUFEU2VASURTdd46gJAhqRQO1UNC3aKBvKOgmGugGBZ1EA50AEHj9A1boQsB+28k+5HRZbwBff01ejlhhGg6ast5IBtVITl5OWGERrmjBehMZlCMlKuczaxhhHIO1PlM5JaKB9S04G5Zr1roFII1owPYOq1j+lr7+Bvnpb8hirR3g2gGlAPmQda490NGxzDk+kjd0CJSkHJBO4XDLE/Djo+B8/J+/e2Wsqe6AilQdbov7/vTBPd/XD5+4aUsda1p0QFpZHW57iLw5cT05gV/ZDAQlDQAJ5QygIhcEJY2kW4Sarv/PdgQVuSA4SRNxp1U2ZYhr7gSA+G0EDrcfawpQxtTbjjLWaQ+UU4abRwZxijLWOQ+UBaCdMJAy1jTrgbS8Otw4SB3rvOaDahSLDEJLNQ7SHwbSOaj4MJB083+EdWaCM8M6jyRQDivNBWiOdXISqICVdvmWZrtYpyCBtDLWOvNIszOsUdZkUJVi2Z07qNl8Fy1UAShLYyer/KaNF/ibFny7nZ/jALWRCoD0uCA9ANIy8UAZLQiqxQPVFJAeD6QrIC0TB5TRVFAtDqi2AqTHAekc9Ae7OzxCEKVomgAAAABJRU5ErkJggg=="

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA6lBMVEUAAABCicFCicFCicFCicFCicFCicFCicFCicFCicFCicEpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzNCicEpLzMpLzNCicFCicFdrexdrexdrexdrexdrexCicEpLzNdrexCicFdrexdrexdrewpLzNdrewpLzNCicG7mo+WlZ9xkK7OnYiNlKNVjLnEc1u/aVJejbbFiXXTlHtZg6y3a1lShbOQdXzEm4x6kapnjrKflpuDkqaymZPXnoQpLzNdrezMl39qWVE0NjiWdGZKREKsgnDBkHqAZ1w/PT2LbWFVS0e2iXWhe2t1YFZ86KAsAAAAJ3RSTlMAYO8AMM+AcK8Q3zBwr98AEIBQj8/vIJ8wcK/PAECf778Q34AgYI+oNgqdAAADDUlEQVR4XqSV226DMAyGc0/LSUSi2zTUdvAWTjj1uO39X2cIvLnzFtdSv7sI6yO/HYK5pa6q+kXN72pzW1B570utp5yKK0H0rBU9C6K9n9gLAqHWsLdow5We7d4IjxnyK83c/Y0QThFsM83PLC1+2rIWCvCxbJ+mRYUivyvZUJFotY7dTLxeRck3FQUrdx5FtZ/Z/D1maTZLiDhLFxFVbfxMbdCJ8Yi8Kdw/WFQhUyzMM0+NlshbY10Im5OHtjCLaIMYKrNO4jVBqCkoopbN2yncHQqMR2NC0RIPRRGmUpjw4JCIjhV5ZIolGh5lEhFv1qloEoZh68IpyWVR5rTYVBJhMBWZJGqcHpsKIuv0uCwsypmgF0UxEwnJTk4kYqLg7MdW3tIqKGKFHQyiaK0VfQB0YpOUojNMjJJJKRpgoh0fFo0w03YPivojIJfg7DTjP7/DD8erJJIP5GcLtxz+V937RK6XI3Deu145fvpoIcBHd5YPJM8GYdrDqbv+6FZ3LjZQEPhoiUwvcrF8+ZNo6PsBEL7GZEzEwgHSO9cDwtfSVYtEloopJl8Llz+ZNCLhd0ToouWJUiQ3W/5lf7VWNzsOglAYhilK1W6b6MrE3Ycirf219uf+b2ucMSdVQWgmfVau3sBJPIRRLAC8PgBAxFEYvDH6yDOOgfR3JAY8y2ehvABB6Q+VICjyUSiJMVL5QxVG4oRC4QYTytdRmNiEQyjkIB/ercYUD39DicCM9hxJacyIpA+tYajHgd2+t1s4EFkHLOEwSVdIwsQTFsFCK/fFTBErYNMsllQDm4Jx+Ev+DjjDAi1tHamxgGFRbRxK1cA/QtDlJKVKDVfIqToch8rxUMGJCTidzvs/5xOcBIvgdrn2qfP1AreIpfiKlAUZviALWJByYxW1NzjcWmMp8bQPjX//rq9QypEZdCBYDxtSWPeHvD86THSPu7RuE0GrllPoSZVJjRozz/eCpOW/otDLpm2a9mVDodX7OdrSiKyUsnZoSNvxu5bRiLyMIWXTlzamEVmUJQUsQ4qDwQ+w0lMl0oew3gAAAABJRU5ErkJggg=="

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAn1BMVEUAAAC/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVLLhGvXnoTXnoTXnoTXnoTXnoTXnoS/aVLBbFXUl37RkXjFdl/TlHvEc1vCcFjNh27Wm4HXnoTOinHHemLKgGjQjXTLhGvIfWV6OCu6f2mBQDJrKR1kIRZyMSTJjnbBh2+PUD+sb1uzd2LQln20U+T3AAAAGHRSTlMAQICvvwBQn+8Q348gMHDPYEC/YM8AMICvUZ3QAAAD8ElEQVR4XrWWh47rOAxF3Sax05w3r125l7Spr/7/t23EEW1Z0mYTzOwBAjhCckxSFG3vEn4QRlBEYeDfXcDjC4vZPIZBHM5uFSXBAk7iILlFFHAwbtW1In+Biyz8CyI/WEbEMpjjP5mPv/Z1kR/iHYS+Eq0ivJNoJUXrGO8mXt95yQIfwCLxNvgQNl6KDyH18EH8vyKxP7TdmfawF661K0Wi7zR64Vq7RrRruwntzrVmi8y2bjqLxrWGKZG3MT1X0ph9tJrm1V3NNLuVd6fnJoZaZM2OKlrvMxLkp7evuybjOgk9M3loHYnl+u32bZcVetS52juMrOUYWUKy39eAKElTUJZNfkYaqpyiqQ553lBCBalKuXakhSXNoyRVxWkAkXXtHkDdyyTpuqacG3mVy6W+lqqsywREThkipcEmTSqpUqDKa6lRGdYyMekv+Qsv41io+AukCY/aDZBraR9b0rQqiAIote+SRowV3SMaZnYqRbynNf1rjCDnf/ASt3bdEUekLEoAqGQyPg3j7Qu+MIJifQGslGgr01E/PVj3BgRdm0GV2SDaKtHcaukhHMos2xtBVZ0GgLkSpeCEGQqBnTXFoQelizIAizdRAkmri8rSuD8Xx4A3OiGRD1C1TbhjoBfH4gQAPok2znPPYfTAQd8xE0FDhERLWLnpMVQopgsTDhjPWgRnbhxADxg7Zk+liEQpCN43a+cqHlO8YxoZiJREgB6SvXM9ULHJUWqCRc6QWCjwr6YSLhGOLs9BQJyAqnSJKrcIubMDRNn1/Ii09sMtEqXVARQLxYVdZjc1k0xFEJOYsh2GrcsqnngDR8AREXNSQbU057mVeSqKU88LhwoXRYAoiqJSl5Pyt7zXxRkAliiGk3rXUyYPD/SRZE0BJzEfEYsmH8rx8kIfJssdsogPrQVrbBEXmdEO7RYWRXdBlMNiyxPS5OgUMbBYkchRJG7MabGZyi4RiezcRHeRk5UZP2kXwC2vW721+Sza4qb3vxJTNiyymjvrLoMp/iBaY0p3m2g5iIL3idJBlGJKTtv+4uDB2ZErJVo5+/HVJXp1npGtu4/Us+uPS/TH2ZBzJQrdnf1ke56s3SdiJYLFSYr+Ppue57/c2AZrEs1A2OX+aYp+cqlNAhLNYVPTQPo99fymgVvDJiWRcdKieDxuj1p2z4/jW0McgxkfR2sr323IZep+DBV/+jGc/HCbmFN1dhYFjqOczJapek9+/HVuqNdfb+G0u3Q+S+7sus7PotRcYj7ddwb3n6REYvbw4s5bObqU+fxF13z5/HUkNgviba1zo/Ptuwrr/vu3rzpmE2+80IzxOgJMiTxrtlyHD4N/AG0+/ps0mUmdAAAAAElFTkSuQmCC"

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAArlBMVEUAAAC/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVLLhGvXnoTXnoTXnoTXnoTXnoTXnoS/aVLRkXjXnoTBbFXNh27LhGvWm4HCcFjEc1vIfWUpLzPTlHvKgGjHemLOinHFdl/QjXR6OCu6f2mBQDJrKR1kIRZyMSRKREKWdGbJjnbQln3Bh2+sb1vMl39VS0ezd2LUl36PUD/BkHoYiBu9AAAAF3RSTlMAQICvvwBQn+8QIN/PYI9wQL9gzwAwgKU5BEUAAANFSURBVHhe7ZjZcqM4GIUxZrUx7vR2JHbv2dPrMu//YoNkYsFvgaArV1PzVfkip8xn+RfopGwNMbPnDhqcuT1zB7DcPjw/ACGYe8Oi0A4A+AsVh/YSWgI7VIKFrxIhCiNIgpXbIMUwqVYBJFHYiBygYixNgPMUZksMsmzeBiQpYxXgnEUr4MBrficIHCe2fRjx7dhxAiS/ec0BWEnREkcuYZgI45IjlkLkySCv8FdUuVyAV4t8lLW1xN/RXOy7Vhgg4zxDsq2TBBNIasU2OV8dhNYaYDxPzvPeYwL786STnDNgbUWA+LPgggwTyLigEEsAIgs4ipWkMj1hAicpSsXKjoAFVGI2W5my6Zu/FbOqpCjjvCz5GUiS3SkXQX7aJUBfxiXy2kyKDlwhNe2AH5K+rB1IEeuK9jnvkO91WVfENKKMX5Gm11mmEfEWSmuAdUT5W4n4dNH/Igbk40Q5wIZFfCRjRT9+bjY/fzQxzcyiFEUjet7UPHMFzQqkA6Lda6G8bCQvykKzI3YDohI7tSCyJJLtcOwX5cCJSzYNSkOzE5D3ig5A3hX9ozwky9sHWU6OkSP2fOyK+B7HzjESoOINJ+AwXnQQc7hIl5aNZh9F2ZX6weqzUpSqJAVsK4yAImVsmyUQZTd2+0WpIskYY2kBRKHleqQ9x9yQtJXlPxE22qRjH5EUbWwlIiYTKQwiVT0EWkdGkSpDCi1IKoqhIPVMUZVNiWuRAy2V3lNBi9Mr2vMe9tNERf9XKyaJmBLc3srXBdYnigwDenwUL8OYoloEDdsh0RYa9KKSD4l4OVqUDYsyg4iMmg5bwbSiUJNyA7gmtGZvI5r9l0Xe24g8y+7b/ttHDbd9228rEb0hn3SiJ3JDGkSyJ3/pRL9kMxpE9KG9v/bctx5aKop7z9mvD9Tz8LX3tI0tB70H2zcq+qZGTXGoyGkftd+7nu/to9YxiNaLOFCH/13r2z3cqcoP/MXaILLFrzDzSx19uUz8/suljuar0HVtKopo0wlCL46a6r77U99QT3/umqqOfC90BWSTIuuqDi68u+GEm3dSIqGbpBEp3n9oaz68/9jCJArcDp8+N8u6+fzpY4fAIII7EphE4ThPCMK/NNXdQXC9mskAAAAASUVORK5CYII="

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAeFBMVEUAAAC/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVK/aVLBbFXNh27XnoTWm4HOinHQjXTCcFjKgGjRkXjLhGvEc1vUl37Fdl/IfWUpLzPTlHvHemJKREKWdGbMl39VS0fBkHr5xP9LAAAAEXRSTlMAQICvvwBQn+8Q348gMHDPYDyIRLIAAANQSURBVHhetZjrkqMgEEbV6ETN9QO835LMZd//DdcwttsEw4w1s+cflHVoGuiu0nPhB5sQE+Em8CMHXvSMl22MB+LNy1pREqRYJA6SNaIgBuFWuUV+Ciep7xD5wS7U7IItvmT772ufi/wNfsDGn0T7ED8k3N9Fhxg/Jj5EXpLiF0gT74hf4eid8CucPPwS/1ckqiJTI1lRCdecWwSRK0Yulue+Ft0yZZDdluZsUQgTqSzk0hxMQu/o8nDcpqO3B+emvo25u70X8b2J7PuiTPCd3R8tG+dqBTkTHUZRtAMh1CoEiJ2uR8mJxtU6UUWeky5szFSsExXkSajU0hXI1okyOvqIRBQRE7x/XC4f74pjz1FEJEpgi14vI6+KY8+VdIkm0dkWvV00b0q55jBxnkRbEhmL0/KOORJtJ9EJVrIvE8xjz2UkSj9FCYjCEv1hImuuAJFokQ+iWhdRBcLXoiMIsU4kQBwj860hX5PsHA9vLbTLiPv47TISatHJLmzuC2kXtpMWgSO/+0QkOCRaX7QlXCJqR06oHblF1Azd5AIOkdWyNbVsGlnT6GnLTkhk0d5N3TAP5eTKWhCOiLiHElr2vdCuobOuj0sk67wEUI+e4a656jDyYVZVQJnXckkUM0+pRhodUQOUQFlPW2oEIBpVTNGW4MTsifCbnQM3CbSqLoEqY6q2HD12ww4fHy0apWkoT1mlg+K3p56/eHy0ZyYa1Cc9AJ0eIyhVCPRKM4BzpgpJ0Geqo10+BNW1Ba3E2WsRT1I7ia6gOFhQnBaMkLUjgpVjlpxKL8EBwdtRlGKmpmz3Rhx1aYpq8/BJdLaOTUKw5Ng0IHjv50Wyn1fsWHIsWrM8zqIDZjrqfdI4MZMOjAMTsZYk6Z6U7MRc9TGImIj1/3LeW/PkxMyXto24iJsKCgk1PzFOwT1cxE20fFZCXNUyLfMwEXE0s3QVELW7g1B+SEQcUi0SHZlIatKJpR8J3sKvjDabTCXQd4rDq3aQOH5p7ENuynpANMue7d71b4RS3lKapQBK3ueuLbuFDlFCBXwo6jty0KO+kXpYDOzBO0VnfJP0C1EIkxjP8J2iPUzOz2PdOEWB1dJnEjzgPLXUseoGJjuH6MXameMc4sQQ/QXFYE7IWp9RLgAAAABJRU5ErkJggg=="

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA8FBMVEUAAACSaMqSaMqSaMqSaMpkIRZkIRZkIRZkIRaSaMqSaMqSaMrXnoSSaMqSaMqSaMqSaMqSaMpkIRZkIRZkIRbXnoRkIRaSaMpkIRZkIRZkIRZkIRbXnoRkIRZkIRZkIRa9ip6fcr10UKhkIRbXnoRyMSTQln1rKR2lZ1S6f2meYE2PUD/Bh296OCs0NjiBQDIpLzO1g6eWWEbJjnbShXXBaU/QfXDGTFKsb1vCO0iWdGbEc1u/Kz6zd2K9Ijm/aVKSaMq7GjTVln9wM0OISDjTm4jGkZbAM0OEUpKbb8GMX7SHVp17RXDUjnqjdrmoebSAfvYsAAAAIHRSTlMAUN8AMHCv3wAQgO9Qn8+Pv2BAv2AAzyDvj4Aw3xBQn0FnzE4AAAJQSURBVHja7dbXltowEIDhTaFkIQQSslRv2B25YEzfXp3iJKS+/9tEx/YytkAagX2Z/0IcXfAdjXyjg6eqfXZ+znh87VffJ+oViiUIKxULvbKkg/i3GhFP61oyuiGClbqGEuqnob5RKLZhe21OyaGIwBVUtY8zQtgHfch2hgtbLh0ZupDHlyFQEg25jBrwSAuKA1UdfWgIyo5lkJhlAtgKqG1oQgsAcEFRl4JwsLFFHEkJ4WAwYlfEkWhoAbx7xkYKqKSG8IuZjDdWSD0Kiv9+Fc6okAok5AJvHN+WfLoiCQHPXrI4x5ZfEg2ZHm6XU4m0AflCAAsrffnT/SBnycS8kb0HxLZ2PzIzQpg1dEdTUxtaMTI96E/O0M1kcsMw3O8KTWazCTK414f+srAZDxnc60PznKHso83zuux5Xp//63+IhAKW7PaRd5t2PD2IkZATQQYFkX3RgyzKsUBrtB8OBbl60E/TIg5kakLg6h3oHQmBx8LuPqb6ht8+rENA3wHi4c4eks7DWXowaBLQLwAYR9Lva3SuPzHheWKQEErs4jKc7+7ygolOsUxD+IoQ8kxY16ShKNcSGctNPWoo6DPEmY6VYhwTEjU1ICwJSV5ZWaG3OUGdMgEJJSE/Vb3xAjuIf3eBsForG4RVWiJUl0IBOoG/UU2E3kihAUIDf7OGADWk0CpYH2jlb1YXoJYv7SSInRN/WwhF1eTSahBwZrDyCQhnI6MhXiUv6NDfpdNTCcSr5QW9rGSDsEZWCKWsEE73PBuEvTqsZISwZ69r+0D/AArb5UmdTX4DAAAAAElFTkSuQmCC"

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAApVBMVEUAAADtu5/tu5/tu5/tu5/tu5/tu5/tu5/tu5/tu5/tu5/tu5/tu5/tu5/tu5/tu5/tu5//rDP/rDPdpYv/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDPbo4nXnoTirZLotJj/rDPdpYvtu5/lsJXbo4nXnoTaoofsuZ3ptprYoIbhq5Dep4zmspfotJjqt5zfqY7jrpPirZL/rDNQSlPbAAAAJXRSTlMAYO8AMK+/UM8QgI9w359AIEAQAGDv3zDPv6+fgI9wUAAAAAAAUF27nAAAAv9JREFUeF6E00sShCAMBFCvIEUI6CibnKHvf7Qp2EQGnO5dUvHxKdx4okg0mm3q6FHq0BBAfieUQ5YBGeYA4FmHLnNIAOTwBypd5tAHAI536Gr1RSBf8X6DKnzHBAqpSbqGVOB3SCDTBklYQSG3qhqHeu4mlRV0+gVRyOdnKPoKHPITzA8y9TNzyKOPr/sv4tBuBBqzpxQXvncJ9G23bJcTB8EozEfEoIYwszewHwMYk6yrhvu/tTXQtKdEqdb6r88fnDnH5w04g9G15Dch0yLhCLXW0qwAixkRO+cVL0pbFdcUdWVFEYrsoqhYCCW5HeEibaWzxEtRKrEoJhHkKuaxdeWRaqhwBRMJ5AxF9Q0iBkWCubxTZK+J6odEtGJKPiKSipWUEz0Gq0dEq3HRhI6LeEQkQp2sni3SXyXiH4vqp4vYTFQLQaOAikWdE1EUiVSk2ViZrg2mM6JVVqRCNopCef1ZkWRjpl6VTH5StLEWthY/FreIKmWDfBJVoShHkQxJdVZCRc1F5dqmcL60IeKBcroSbMq6nEQIikRYN1EUawsQAXmRtnjlFjHQ94mOgzc/1HQsERb3wY0fjjeK3LYx3on4TTWJopcJ502zdTeIjmbn2rfCEv4SJ1q3M8ePRF3vLSInkcZW+7fv8qKudxYp+SulRRya5qJ2B554uBwOCRm2bUbk9xi+f1HYJJHx70WYt016hnVypQHHvsWJBPNhbxM4kGb7AScSDdH2X9KtUFQloTPQ1ATzpk26CkUq3VuDEwlfw29vE5YoWqYpnOj6LNJvIjPfWW5vprMTmhN85MP8x0doEh/wCEi4mi8jeEJ5pchkEOHmEaZTkYaR6VESeObEU/AZxUUT5ZOI07wnb6L46je7X4TmF9EiKR63PwMkLk3vW0wpvwrFma3vm18BEpfmzMnFSjeYEF6jMUMXx7l9cyYVIXkR8DyR7z8r6v3vAImLtW7f3y/q9266swhcWp3zJ2PMyQ+HPxkOw0vNhTOfixCeAWpfLPoWfYv+A1Y/HxipJIiiAAAAAElFTkSuQmCC"

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAArlBMVEUAAABkIRZkIRZkIRZkIRaSaMqSaMpkIRaSaMpkIRZkIRZkIRaSaMqSaMqSaMpkIRZkIRZkIRZkIRaSaMpkIRZkIRZkIRaSaMrTm4i9ip6bb8Gfcr10UKhkIRbQln3XnoTBh2+BQDKPUD80NjilZ1S9Ijm7GjSeYE1yMSR6OCuISDjEc1u6f2nUjnrJjnZrKR3ShXUpLzO/Kz6sb1uzd2KWdGbGTFLVln+/aVKWWEYhrB+zAAAAF3RSTlMAMHCv3wAQgO+fUI/Pv2BAYL8AIM/vECOZjkMAAAIMSURBVHhe7NfJbsIwEIBhSCIhkgMhIr6NnX1hXbq//4uVuijtmHo85NAT/82XTx4SicnE0dTzA9AFvjdN7E0SIjELABXMxF2Q8PwU/i5FFA2JOVClIRMKU3A0Z0ERuFsJGsIOLbmgEHitHJBIgVlEQ3NgF1KQANyBgFJBQB7gWiCaEZCPnV7yr4ShFEOFemJfCUOAe1aqIKCAC3XqUk9IUyb09AVJQvJ4UK900j6dz4IOe3Wtsj27gAN1mRra5xaJAX1I9bttPgrKq70yy4rD3ZCy9Fx0oyEzuW2LvGNDjB7Qdy9l+aIBdB4BladTqQV0HgGdLmkBnf8RGj/a+B/78UJmbidjQZUbqkAnaGiNgc37pQ2G1iwIpAuS4BqNOVvLhDpJO7JzQcur1PIutLRCEcDNG7B7rZumft3hZ6+LrFAMN8Md60ZXH28Gg5ixQ/by6mhlkPB6IqxQ4pvSuRk6vxmOn9ih2NwizLIOhmICSgL4qZUmI1u01FBQjHa/ClGyQv/9MQHhK5l7gLll0dCCCy3Y32s0FCU09Nn+HKtQCMNQGHa5F4ekS4eTpAXf/y11uFRLj0Lhjv5bIHwkSdF1hdCl6dO1XIcswBPUJ/kOyitmIKz5BhIM2ekYhoRDCWN+Qo6xRCElULSTLAikFAKr/CQrYDHoC1r4QZkHZqD56Gt/h2rFU23jhVovtAN1w9607gW2lwAAAABJRU5ErkJggg=="

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAn1BMVEUAAABkIRZkIRZkIRZkIRaSaMqSaMpkIRaSaMpkIRZkIRZkIRaSaMqSaMqSaMpkIRZkIRZkIRZkIRaSaMpkIRZkIRZkIRaSaMrTm4i9ip6bb8Gfcr10UKhkIRalZ1TXnoTQln1yMSSeYE16OCuBQDI0NjjBh2+PUD/Ec1uISDi6f2msb1uzd2LJXFy7GjRrKR2WdGbJjnYpLzO/aVKWWEYgMvhvAAAAF3RSTlMAMHCv3wAQgO+fUI/Pv2BAYL8AIM/vECOZjkMAAAH9SURBVHhe7NdLj4IwEMBxBRIjHERie5s+ePp+7X7/z7ZgzMZp6HQk2XjZ/62XX6ZCzDALNI/iBB4lcTQv/M0KIrlIAJUs5FuQjGIB4wlE0ZBcApVImVAqINCSBWUQbiNpCDu0FIJS4LUJQFIAs4yGlsAupSAJuAsBCUlAEeBKIFoQUIydyvBHwpDAUKcP7JEwBLij1h0BJVzI6r6KkOZM6DBAhpAiHlTpR8Z/u5gFXW76mfI9u4QD2Vb/dqs9EgP6Nvq1fT0JqtVNu7Xd5W1Iezp2djLkZvZlV1s2xOgz0LVprgOAzlOg5n5vBgCdp0D3vgFA5w9A9NX++Mf+/Hv0D7UY2H71bbHTsiAVhhQ8kjS008F2LAhMyDHM/2wVgkomZAMjGRuC1k+p5A209kIZwMgbcDqfT/jZP8u8UA5jlzv3jV0McsYOWZlRCK8n0gsVMZbw1VwnLvxQ7m4Rbq2F33ICKpLXnda4jCnRUkNBObxkFaKMsvBSTkB4JHcPcLcsGlpxoRX7e42GsoKGftqdYxUKYRiMwi6KQ9qlw0mr4Pu/5b2DWEtSUHH0bIHw8cdA0xmiKcSxaTgfSeAqBJJ6UJq5AzGnDiSYtDqKSXwoYssVytiiCwVs5ZikBVtwIbyWXdIFLw+acCv5T2kuPINs16HxdWhd6Vc/Pqj2QT9EnN1ijVF0xAAAAABJRU5ErkJggg=="

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA21BMVEUAAADBaU8qZ5cqZ5cqZ5cqZ5fXnoQ1apb9y1jXnoT9y1jBaU/BaU+skIkqZ5f9y1gqZ5cqZ5cqZ5f9y1j9y1gqZ5fBaU/BaU/BaU/BaU8qZ5fXnoQqZ5fXnoTXnoQqZ5f9y1jXnoTXnoTBaU/XnoTXnoTTlXvTlXv9y1jXnoTXnoTXnoTXnoT9y1j9y1jXnoTBaU/XnoRKcZPMm4VAbpU1apa3lIihjYprfJCWiYuBg47Bl4ZgeJEqZ5fXnoTBaU/9y1jUl33HdlzIemDNh23JfWPMhGrPinDSkXc5MPPnAAAAMnRSTlMAUN8AEGBQAN8QYN8AQIBQn++/v4BAQICPvyAAMO8gz5+PYBCA3wBg778wn3BAAEAgz9N0BSsAAALCSURBVHjapdfpUuJAFIbhhM2QOAqoqCNR3MZ9A1kUzgkoIvd/RZPNHJx8adPM+yeppHgqXd1pwFBmOp7nmOvr8VGVobppemHm13FlyIkA5+u4KnTq/dOq0MWUefoeGe/BeeUgOyP7VoXD3kOHwyorQeccNg2gKYedrwJVOS6AOC4PZFv2/XIPCHo48IMfMZIzazKxbB3IDj6RhuyJn1AKSBg/WyB5oO/UGYLOhImyUtBm+1IoNSTMZXvzOySWUBgSRhSBUlbbP71C0JUPtUXBkFi+kwkFkigYkhSQ/spmBLE2ZDoYytwnjcy9EUOyT0LInlhb2/bdfZLjvWHobXmfvLO3t6x4cRvLyzrhTr1syBMiyhLIniznX2iqoKYPTZazE8gC0BxDcwBZEYQyVZCpMWu7KmhXD1pgaKEH7amgPQ1oXwXt60GMIdaDHBXkaECeCvK0oM8s6FMHevRmnAXxzHvMDTU/OBvij2Zu6IIBJF38ARng2rWrhtzrfFvtocsYEukwD1R94gxIeqrmgCIHQyL9DN2wApJufoKOWQlJx2rohPNCfKKCKpwf4gqGShsF6nR1oG6HChulYpwRH8t1omdxAASkZ6J6+RtUahBRr896EPd7RNQoCdSqk584CMIS+dVbX1CZwlgfYgorR1CN/heimg8lDnX1oS4lkpE4NGDYIoAWDBtQIhmUNGTYLIBmDBtS0hLUA2OT/2uobg9C9MKgqRc2ZdALQQiv7HkEzfHKxhC9ciq3Gu+bLqd6JQjhxX17EHeLlzWG5PUHv/SvUi+/AqIhGhge3JAUkEjgC+zaxQ6G6AU4cQ8unnmBsCSOPJM4CMKjGyWO9GuEx4UhGgdzN+itpSv1BsF8jQlBoE5/NCYqgojGo36HIJRVAUEFQqmhGoJqK0A7CNrRhxpFWEMXqpcw9LuuBx21ihm1jgj2F6OkeIDGIEV6AAAAAElFTkSuQmCC"

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABGlBMVEUAAABVrO6XGTj/rDNVrO7/rDP/rDOWrKb/rDP/rDP/rDP/rDP/rDNVrO7/rDP/rDP/rDOgBB5VrO5VrO5VrO5VrO5VrO5VrO7/rDNVrO5VrO5VrO6gBB6gBB5VrO6gBB7/rDOgBB6gBB7/rDOgBB6gBB6gBB6gBB6XGTj/rDOOrLB/T3qgBB6gBB7/rDNVrO6gBB6gBB5VrO5VrO7/uD3/xEf/zE3KXDP/sDb/xkj5wEr/ykvhjj64NiqyKif/rjV2Y5NVrO6gBB4QIC2bDytaouFAgbNjjceNLlIgQVkFCw8VKzwlS2iSJEUAAABKl9A1bJVQod97WIY6dqRel9SEQ2x/Tnn/rDNxbaBogrpseK2qrJGXGTiJOV8grl0UAAAANHRSTlMAEAAgUICvz2Cf3zCPcO+/QBDPv4AgMO9QYI+fQHDfjxBQv3DPIJ8AgAC/jzDfzwBg769AjnA6bQAAA4ZJREFUeNqt1WlX2kAUBmBS0FYsIhiwCAoCEqlLECGKWzuRxQ2Rzajo//8bDRMyN2RmMlh8v8g5Hh/mLjP6viaS6lPnSywgl6MIobmgWCK5hXDmgeIbUSzMB8VC+CiQ6H9BgTJyp/x5SILDOCJ/FpLkdcRKQAAJGEgMoHkYtKV+AkpAb7pdF5ScHYqvoUme7h/N3D85ocSskLSBJulcP05y3QEoNiN0vEWcu0eSuw6s40yQlEQk+DzkTLBFAAmPg9N86Deb/Qf7WHaf4rNAMqLTvbWgezJ8ISStIWaeLAnhhMTQMXcFbx1QTAiFEDfdOwKVVYCE06LzQKAAE4rkdTNZM7tR5JW+3ewtlQXtmI6Vegt5pmmPP8SC9o/EDkB4IdclBrRNHP0NCdKfXBFZpaGSTtJDotxed6wD0VAanDZipfHacJQG18wFFXQIq0GDoa6/IlfWJQLB2CHPDKdXN3/RoP97AARjJxNrUEyrrZsZUm+1BBCM3aPTPesLBsiVhAoQGTtk4O5Om/MFa+o0VAKDVcBLnTfKuBOCsbN3sTHkjnJDnYIKLqdOdxkKozsNUCq1mXbO7AM58lbn7+gxKDD+SIkc7AVBnuGcA25hANnWgasVDVIW8HRhAEFSWfNPoD119iShMBoC6uCGTF2HtDl3g4Yge8jK0DnIFr2KQki22nPD3yy49GKo9e50ntkNEkN4eyA3lBNShVDm129oM+9RSaoCKJM7NIwRtJlzxaKqN+RfMsYZgcPexNbuN1Z89oeFsVKpaiecNwXWNKuw4rN+ZMImc1rTtDMw6EZbc/CEDsfOuaZpF1POe4N+cz2hn4aZmungyuiNhsfJG1rG/dHGufR4K+1HhQ+Fx1AVQ1e8gQ16dV0E+fHcNRzOwN5gKXiQ3aE/ALmc1t8PfBgxFGRBJ6PRd1mW99q6O3ketGy4Sru6PLk40wwjVzRzQDkRHmTuNGk2pGoY/jGUcjlHOwobwjMj44dUjGARJzvt7CtcyJik5nRquDL6SNsKD7JbhK8IyfmpVZm7SyWFD/0wiFQj5zGdpeIkJXDSige0YEAqVdznivlxxW9DEeIUFC9o0WAmVyQpwAJ5QWEWA4VBbfmINxTkO1AbLBAfYjAruC5InrlAYmjJ6jMkDQvEhzIu5TCXKbqzCQvEh1YdSHAx5y8ykoIFEkAr4fBCbpUchYIKihhSvij/APunQ6Y7NvwsAAAAAElFTkSuQmCC"

/***/ }),
/* 1243 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA3lBMVEUAAAD/zE3At43/zE1wenyZqrX/zE2ZqrX/zE3/zE2ZqrVmdX+ZqrX/zE2ZqrX/zE3/zE3/zE3/zE16ipX/zE2ZqrXAt42ZqrWZqrXHuYaZqrWZqrVmdX+ZqrX/zE3/zE3/zE3/zE2ZqrX/zE2ZqrVmdX+zs5vZv3TiwGSAkJqzoWbav2OdqohsmaZgla07iMOFopfCt3LzyFTOu2uproFUkbSRpo/nxFy2s3lHjLx4nZ6Mi3PGq2DZtlrPsV2WkG9wenz/zE2ZqrWfrK9mdX9peIKWp7KmrqjyyFrsxmENDLO2AAAAJnRSTlMAIAAQAGCAv1CvEBAAYO8w34+/UHBAz98wr1CAryBAn88Ar+9wADIhnxIAAALDSURBVHja7djvX5pAHMBxkQVqMIXcbJboReVSCEXTaD/al2it//8f2t3phsf9SF60J3v1eQbqm7uD44G1t97aNhhYOx0eXuyEP1NWs6zBwYlppjuZ5snB0WmGOz0SfTYQQi0zFfTzMaM9pqJMhtB1hKsO2b6vEwihalNrA4BNIVkpznoxvYMh5xUgB3BuNah/3rI8II2qQWnaO3aBVhVKH573gZ4e1NAZkX6pIL1huD4I8l1c0zAMz9MQ+pDiLuVQo8kLYvWSSGMxpBsd2LtnAj0JIZtjlI3JZvrMQ5oLuHLSVZZNipDtA2kahNdRFM7msC1eLGKplOEKkEN/tLyJ/nQdA2kV4WZriUSgMQMNAXebRDuFG4eWTMXQJMuu0o/1er1W30Sc+C5iW+Nz0bZkrbh1B+RVSzPI4lxHhZYA83ymIO6JSMdbqEHGk0TF7gCC/CgQQ58IZG4gzccONx66SCtmpnxDDZl0chRq0kXlSwBC1mXzHQ0h1HqPoTMCeWSBIlEsFC0YpmnriHZMJAK5ABDuA80ECpV6FGoDwCJSQHkxRVzDQ2yt83MMkUdoJnTCIkS3jYNE1RAiWyzZDwrogCSQYmYBgfhFkkA2MI9dYSbsrlmpIAPI14XFxUss1VBhAszumrO7WAW5zIi46yfMzJQjkq1REgP7YITxi9BUfM9IccIcqyDmuvx+mN7Q4eUvW1cCNQAEmz/J3z7xbRDMIW8ogTSgrZez8G+r2xikdSUQ6kC5NBnklHM6SAa1y0FdKYTcMo6vyyGvDGQgKVRqlUZIBemjvSfWlkOlJBupICpVdChEcyrMi4GQ54K6oY6UUF7DVTGaGOAgmtYVW6Muxygh2pfJ12+d3HC/T+5/vHu5Gncmw13slB8rq3Fn/i+o30v3rteX/oFg9dNS9aVQrxzUk0JpyV4bqj61f7/Y1mvc/t8PVTLzpgegyQAAAABJRU5ErkJggg=="

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABC1BMVEUAAABBQELdLkQjHyBYWVsjHyBtbnFBQEIjHyBYWVsjHyBBQEJtbnGAgoWgBB7BaU/dLkRYWVvdLkTdLkQjHyBYWVttbnHdLkQjHyBYWVvdLkQjHyBBQEIjHyBYWVvdLkQjHyAmIyQqJic3NTY9LR5BQEJEQ0VLS0xOTlBVPkJVVVdVrO5YWVtcXV9dVFdhTlNhYWRjZGZnaGpsYFFtbnFucHJvPkhxSRl9f4GAgoWIio2KY5CMWBaMjpCOGS2Tbj2TlZiVYiGXDyaXbGCZXxWcYzagBB6rFhyweC+3Ij2+GTHAORfAdBHBaU/GHjbKShXNgiDPUxTdLkTfbRHniQ3qWW7qjRHvhw30kAwIGnutAAAAIHRSTlMAEBAgIDBAUGBggICAgICAgJ+fr7+/v7/Pz8/f3+/v74tuhPgAAAJUSURBVFjD7ZdpVxoxFIanKuCCu1LXMUJZigHqRt1ARE3tgtq06vz/X9LcGYcszG6O0nN8P3DuTXKfk/tCMoNhvOu/1lRR0lRSzoeiojcHGa8ImiG+mokFIgF6G1DE1g4Uefn4w0fSopzMySUGZWVQNjEoLYPSiUFGuEU26HRH0ukgKBdqEYC+7ygaBGVDLYoISodaZLcWDjJCLYoKyoVZFBXETbrs9Wbd0VkhjgjiJvWY3FExjgLKbAgHFoq94gigjHTyk4NSG3pAqc2iHtAK0gMaRzFAQYd2PQ4o4BpJIU2gSV2gJV2g9VigB0UCCA0baHToQMPnkb6vf0kXaFIXSNuh1XaNxLvYAl9rVnSBnMv/y3FiTUuPo+MXSHpAagEZmc9aWjOMRcqEfFUoY6ZywTsXnv0LNAiUr+BnVfJeeR8z8pH2QWeWol9f81XcV5VVqnkfNLJGOcga1OPNPq+sIFTBWMqRyqG4Wspbnrq/7hLSbUJloQCfTZ67IM6hsNULb5L19PsbIVBZBp+bzr8iO3dBi1QEsaa5BcyAT1d/LT/dkS6segYtcA4l7TrGpRLG9TZxYmbA9vm9H4kQDhL2w0CkzbbBNtSGfUMMIIz3b57CQHNUBpEGTNUdBxqwCCEY6f78E9zalgqyvWk4IBbBppdlc5fV3HZoTeTc2u2YJm/NhDUT8tc9oebSy/o8N3hejO3JVfEHuDqYixoz3QlzTIyVSWdIzUEdVyc1Z6J2Ise2Wrtu3W7LK+90OKjTOmTltcOWGjs62oOyvSO/XAC9TNpA/wAB1yQvtz2GQgAAAABJRU5ErkJggg=="

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAmVBMVEUAAADm5+hYWVtmdX/m5+hYWVtYWVtmdX9YWVtmdX9YWVtmdX9mdX+8vsC8vsC8vsDm5+jm5+jm5+jm5+jm5+hmdX9mdX9mdX9mdX9mdX9ckTuIyfmDwuFqo3Y+ch1jnotyrZpflUdYWVtVVlkpLzMvNDhJTE+TlZiIio1cXV+MjpBucHLm5+hufIbW2dvGy868vsC2vMFmdX97hA0JAAAAGnRSTlMAgABwABCfzyBA72AwUN8AYL8gz+8QAO+fIK9o22sAAAGdSURBVHja7dTZcoIwFIDhWFMXKJZF6wKoTStuwe39H66YqJE5csSYiw7jfyOZnHxOLoAQUuNY+zRrz/FqlBJKOVp6yEr5ne5Dm4NoUwbCrrZNJZRu718Nq364VP/CI8hebyCIZlP8DHq60PAEXMChHtTui+P28Vlesd/WgWx59iOvakDiZLOXv2dfF7LVuq4L2fIuYIlAuIQ4AMIl4CAQLgEHgXBJOaUhp7MrXcf5vI5cL5zdQzmFUOcxqFMI7R4MQK7Hn8hzaRah1A/4kwX+EfK7/Om6fgYF3EABJS43kks8M5BHuKHMQSNDVRkKj0WxWIxzgdnbE3EkCBLKYl0oDsMcFMmxSXhqIsem4aXp7YlIQTI5ps7JMfGITXyH/w0avaAXhEHwFdGHQOUg+ErC4ASE9D4jEIp0oUhBZj5s5j61akgHUlUZGhuqyhA3VJUhKntnP7+nGHvDuzlLzg8Wm8m9GbMQBMwCqMESuZmwBmKAWQC1LJbMsv9ImNUqArBZMj+3WDLRcjEvCpslane1XmZb6xUCwFkA6WYe+gPhNGvo0MP/iQAAAABJRU5ErkJggg=="

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAER0lEQVR42u2YS08TURSA5yfwDySauDKGhW50w4rEhUmXGiJWjUhcEDTGRyAICaISAxo0UQmWaHwhUMqzpUA19QEqVkQREKmAQVc2cePyeM+kJ9ah3JmhPRQ69yTfXULO1/OYezUVKlSoUKFChQoVKlSoUKFChQoVKrIlHj5uy4/jFlTF8QpCCcQEsBL4RzYyOXEBZfHkKWmwQ7YIyhW4SITsl896Qfv2F6KMvHhleElGJsiYAIFLUCUICSICIA4UudkSftTaDm0dPp2unj4gevsHoD8QXIYmjrUApeQJGkiGjPqrjWmR0NnVC929/Xqi/oFBGBx+ahtNHJygGDdJsUJ5RaUtGa1tXujo7MIq0EUEh0KYWNrgFhMVgFVOnzlnKuRJe6deGT19AQgEhzEJVjjE5JOYVOVQu3h9PRIhvKRTTI7AKwC71NReNrYNVgm2DLMAc9JZNTEbUmhb0UCmSjEO040vKL6qwS7HSo5Ds+cubhtsnwxKkJNqS3lsiqFNta6q5Vn4BbwaeQ3v3n+A8YmPMDk1DbNf53Q0cdiF5ETsijl85Cg0NXtw2GZMxOibMV3C9MwszEXnYenHTymaOOywajm1l+pEK/nXTEboWZhk6JWw+H0JE7YNu5zSspPQ7vWtiRRsk4+fPlNlpAU2OUeLS6D5Tgt7lbwdi2C7UIWkxJf5JQhGojrX/JM6mjgsEb9UghlFBw9B3ZV6TjHYOihl1SLGvyyCb3RWF1D2IALFLW9h96VwUjRxmGJ1W6GYPv8A14DF9sFKsV0VJANFFNS/wMQtY0WO20xM5flq6PR1c80V29WCQmq7JqDw9mtMMiXM5ORJZgxWDKcY3D6WW+ZBeAbbxZggmyAayjGjlJoLF1mH7/OXIyTGrHVQimR+8AsKnTh5ioRgpXBvJJwxpmJww5S3jUuS4heEV4kGBgmyrWQ2fLFaaKasKcnkuI0JLE0NAPzs+4/f3/ww/X6QtWpIjOv6CKMEOUY5ecYkFiZJTlJSGsLzC4uyTURiMkqinBxBVADE2OiwTA7KW833DA5h2UaSDN7MCvIak/k1F1gm5c9ivy7meThkVww+I0jbqWloij7k1g0kx5UsqbmJIIKzBqsJpbBcC3Bly79hMi8oynCrps3EWDX8oJyqFIXQa5zVWzV9zzAMYR5BMZPkCXqAokco2RaSbSeGIcyHZkiAA5wx2EqJFaMEoRTJBdJRgozvLsYrgaME0ZMktgw9QlHrZCUaJiiBVrBj0fBQyAU1OF2CmSDE43QRUkHI5uJbZYKYABT/QDGJ5Ao8TpciE5QoqkEQVYJQiIQ9Fffy47IiSpAcnFVVThzSVskVgBK0MiElaGVcjv8OkpAjiHL88+17j8GWTbnrGk0cMtgG887S28zJ8QtiG8y7qgOwdduOrBAUcmprEVrjjZuQjLPX7oODW0suqP56ExTUDTupteSCFCuiBJnxF3NK1pKi7QGwAAAAAElFTkSuQmCC"

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAACBklEQVR4Ae3Zv6oTURDHcR9hH2HxCdLb7BNIGrESUllZpLAVthCxEIIGJVYprIRgKi202KBGVCR/iCg2LoKFhbiPMM4UB4uTwwbxpzvub+Bb3iX3w5m93JMzHA6Hw+FwOBwOh8Pp9+wP7zNtpM21WpN/nX2oLpRppdZo0qW6grPVpIsRp8tA526+mGjyp3u83rsHMpxCE0SL1c41kOFkWo3AuXjvlf8Vs9UCnh7fQBcWPwpNEF198s31S9pwMq1GAT1998k90ASFc/3ZV9Sfef+rdenRd3m++YgH8rpa09UXCI7lfrXs9LzZf8ADeVwt68HLzzAcy+1q6cmB41j+ry+cAeXaXJP/JTAMgcIqSRyBxsffMQQq4gt1AoU7nGX8EAIZzlBrNCFQfGrmmoQI9AtnoG01IVCMU4SVIlCMM4pgCNSKQ6D091QEMpxca9IwBKoSIARqXy0CLTVJRyAhEIH6CXTt4Vv7TMj8Ai1WOzhOAKq8Ab3eHOT87fVfAxrhgZCrhQeytngg5GrhgQb4fzWQq4UHOnXVHKwWDsgatpwkB6uFBUpdtYYcrBYeKFTigZCrhQeycvy3GsDVwgNFUI3D1cIDhc5evl9q0qfslz61XJN0BKoIlG6YfgiBMq0mULpSEwLxxfxbQFXvgaZ3Z3Ks8Y1Z6ocIdOvOTAZXiBMDsSgCtfQTyUUjaP4zn0oAAAAASUVORK5CYII="

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABU1BMVEUAAACnqaycnqCnqaynqaycnqCnqaxYWVunqaynqaynqaynqaynqaynqaxYWVt4eXsiZpl9lKanqayfpasiZpmGmKenqaynqaynqaynqawzbpunqaxcg6F4eXtUf6Dv0aTKwbP9sD6yqZ3XrnP6rDvDqobZq2jpq1F2d3lYWVtnaGqdn6KipKddXmCJi45sbW+TlZhiY2WAgYRxcnSEholbXF5sbnB+f4JnaGuAgoV7fYBxc3V5en1iY2aMjpF2eHt7fH6OkJOPkJMiZpmnqaxcg6Hm5+hDd56rrbDS1NV5u+3W2NnDxMaGmKfi4+Te3+EzbpvO0NKLwuyfpatesO5Uf6DU4OnHyMp1kKW3ubuOnKivsbTL3OmztbenzeuUxutns+2w0eo7c53a293C2Oq7vL8qapp9lKaeyuu/wMPr3Mbzyo75u2Dp4NH/rDNVrO7o493aUVpQAAAAH3RSTlMAQHCPvwAQryCfMN/vYAAAAAAAABAAgM9QcACvAFAA85nGKQAAA+dJREFUeF6U1Wdv4kAQgGEjLIs4iZRrkbic7s/M7Lo3Oum9X/n/9TITiEYntvB+QIwsHpa1xQbGesN+GKIoDPvD3mdTwcYL0fBICOmJGI6GkTc02GHgpOyKRn9UF13JIu4MvKCoz6soPwxZU6ZE9SM3FO+SU9baUF2StBu7oHiPlpNpSxktai+2QxE5eKOt3SBJkRXim9VpRx3fPhvUI2epnS1J6lkgXlCjZbe3q1dZw0syQwNy7giYPeb5n1U0r9/n+eOM5juSBkZon6CMPyjaNGcE7RshfqK1D6QJ2jFCIW21F8TbHRohfGvuB83xLSuUMTQxQxOGMidUMHQ1MUGTK4YKJ6Tfm402Q6OZfs8PYuri8n/o8oIZNzQmSHR6PsrXUD46PyVAQOMvokAOFUH2JFR9EwVyeEBMt4AePokCOajtIPVDFMih3e6ntd9FgRzgeBvoGA5EgRi+gkJs/JwGUVmgFrHwgwrE1ggdACxw7gfNcQFmqIUEl37QEhMwb/YUoMLax6mxApj+FAVyqAAS7HygDhMA85PNV898oDP+TuMpQuu99rlvBV4DVBYIFcDC54BcACi0QTiF+7H7yB7fwxRtEEsqbexOkyp20HocoaL9du20QutxdIhUleCTlv36q2VPmFRIHRqhGNetpeeX19/c68vz2vlXebnttg3DYNiuNzeo0w3YxdLCKJKeo/rYNrHj1O4JQpC7PkEfYMWQ97+c+4OJIscVvf+SIj5KNEXKG6eDVhA00EkfRCHWh84ZGJ41h3Kj97fFcNXQcPH2rjwODSC3r0jL0WkTdDpaKk7fNYAo3aSz84ttzMX52fbqb/Or1pOaLq+uV9D11aW+4jHP4yPZUUcGEOR34/jsy9/1unA8lwOhKnkddPk72uM5e993ZO2a9sccZ7z/Y0fWjuVECIY0FuLkZ1NW0+B6td9N8DUmuKkjdUi2I8PaM4q/4sRRHSeUDgeypQRJJGkbJk0EOFLaZhCqKLwVn0riUKeEcYKF25Aqibu0d2Kt+0lKsDCd3G/Md+ylRTEGUY2YTkWrYI8CKkpzh0TkLJ+1cWZ5hp0yHRIHSxE4L4p5FumUKJsXRY6tpsbm30M2kOmHAiqzimBRlZUF9IB8w7Wng/SxNkEyTcLHmGCwtYOO8XU+dyAZ1aAIpXHcBur16R51AdF97PdaQN82mRaPZs4jnFL9cJberFG6VcGoQuHrrdvSJlqMWE8c6AluMU03HeRTptWGuC1Rvn0FUgd7RqSSB5VwfKbDEUiNjoAuJC+62AENFAVyVKZlR6l8Owpkw/Ai/hckXmCwAaKDrdvZ9LUb53VKLW59uH+RjvL63Z+d4gAAAABJRU5ErkJggg=="

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAtFBMVEUAAAAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAvLC1SUVOAgoVSUVNSUVN4eXyAgoU4NTYtKiuAgoUjHyBSUVMpJSaXmJvGLECAgoVXV1mQkJHGyMlnaGpYWVt6fH9pVFjR09SzO0tdJCtdXV9paWxAPkB0dnhGREZvb3JMSkxVrO45NjdXg6UvKy1kY2Srra5jY2U6ODlsbnAwLi//2YPdLkSnqayXUQEXAAAAGHRSTlMAIGCPv98AUJ/vQK+Az+8gnwBAryCPjwBzhSJJAAACgklEQVR4XrXYZ5ObMBCAYQmQQTa+ntyCe7vea8r//1/xXog17Aohxsr7keEeswwcAuFIRnGioEolcSR7zYleQ2mmgKWytBskYw0N6Vh6Q/0BOBv0vSCZQWuZbIdyDR7pvAWSQ/BsKF1QpME7nTZDOXQqb4Iy6FhGIe50l4Tb8ZeE5fw8zeYbR/PZk5FyCqXGed209mqktA5JTRxvScsaNDRzbbwy0w0riJ6gGQJvi+W/Pidffe42LN4QmtHTJMhgMEdnaZpULU0ozYEMJ+gVhAMs3NAC96HXAEJ9IBACfDQTgaBfQQMb9Pxo7dkGDf5CEmzQY0M2COQXFO8PxV+Q3h/SCKWwPwTpFspCQNkWUiEg1RMSQkAgRRQGikQcBopFQqBf29og3IdAiVBhICUgDARWyHXTdoPc+UNrt7P2hi7c0IUnhJLjmNbo+ELu/jOkwkBKJGGgRMQW6GdVDSDb2U0bhYEiIcNAUvRUCEjhP/8QJzvjj6OxnzOuQyl/QF76QZc1R7NHNkoexzRGhz2yJdB+twQ0SZc1VSO3M6LOgC20qh7c0AOF+mbpRyXHMY2Yk/HFqOnHctuqBBOUK9wGLC3J8phDRR0vEHphUF5fsJPeJ9vKOlTitncj8AU7H+4DnSuqX6H0wQbjLzWma4TYFC8IXdObg79mmW7MX3D/hpwg14vfrZmBT3zrePEj0h0692DpHqU77iDEpXJldjeZn1iVxnG+rhd0ADp04Xxdx1K9O6DCDhW7Q9Jp2yeNabUvy4w9tX3SIOUHk2pXe9MJdpC3f/Y5PKIXI78ojw6PaeKYd3JK7g5yn5yeGIBAtLNvusnR38/ObYnzhvb4WMfq9PnwD9scMZ7sXmZAAAAAAElFTkSuQmCC"

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABAlBMVEUAAABBQEJVrO5BQEJVrO5BQEJVrO70kAxBQEJVrO70kAxBQEJVrO70kAxBQEJVrO5BQEJVrO70kAxVrO7R09T0kAxVrO5BQEJVrO5BQEJVrO70kAxBQEJBQEJVrO5BQEJVrO70kAxBQEJVrO70kAw7hLs7iMM8e6s9cps9dqM+YHo+ZIM+aYs/W3JASVJATlpAUmJBQEJBRUpCR01ETlhGW21JaYNKSUtKb41LdphMfaNOhK5PirhQkcNRmM5TUlRUpeNVrO5cXF1lZWdubnB3d3mAgIKJiouSk5STlZibnJ2kpaarlHWtrrC2t7m3k2S/wcLIysvR09TXgYzdLkT0kAyqJPkMAAAAJXRSTlMAEBAgIDAwMEBAQFBQUGBgcHBwgICAj5+fr6+vv8/P39/f7+/vjwgIsQAAAdlJREFUeNrt1YdSwkAQgGF7F7Eh9oLEXlbF2PEgFIkgLPr+ryJ7gTlzQcYl5zjj8D/AN7t35Ojr1avXXzcYXVqDr2WwQ98ykXXQy3cBjW1CsCofikCbisiGJts7bKh/B/TSuSryIH0xp1AuV1DGh9YUo83Bg4bE/SXIcqgqO9CxNtC8EI/ePIqpEcOFtoQQNJJdU04G+NC4aJQCgIIaKAtdQHHhTWQrpwjU2b7VoYAzkGg4z/6BbHJOLIsFzdBAD74vq0TORZIJrRB047uyHEFHFg8aEtQVQEk76j0mNNvarKYgoCwmtEHQtW+zKjnnTGhEyDvzbVaWd8aEYgTd+jcryLNmQlvNo86gyiHogAfJzR605zBDUJIHxZpHDRVUkXNh8aDW55FGVUVeGg+aooHutX8wl6BDHhSnga4AwEXt0o55UKJ5QjbyLo3Sn7Q7/a3GLB+KiacUUG4AOmJBm+BlYwA65UDDQOmbYR6ok+TPoWhroCqi/jtiPf7L4FVCf3kutOPN46JejgnRp+GUahjMdVgQhuo3oPq7rB4aIoUyDP39agto6LDxn0LT2x9hk85oOENBi6agCSMQZQxaNQXNmYJGjUDUriloNTz0Ins1AlFv4SFDGYM+AboUuZyiC/DBAAAAAElFTkSuQmCC"

/***/ }),
/* 1251 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABelBMVEUAAABYWVtckTunqazR09RYWVunqazR09RYWVtckTtYWVunqazR09RYWVtckTttbnF4eXvR09RYWVtadUtckTunqazR09RYWVunqazR09RBQEJYWVunqaxYWVtYWVunqazR09RYWVtckTunqaxYWVtckTunqaxYWVunqazR09RYWVtckTttbnGnqaxYWVtckTunqazR09QpLzM+REdBQEJLT1JVrO5YWVtYXVlYqedZZ1NbXF5bgEVbg0Ncjj1ckTtdXmBdpNpgotRhj0RiY2ViY2ZjjkljlUVljU5naGpnaGtqi1dsbnBtbnFuimBvl1dwiWVwkqxxcnRxcnVxc3VynVhziGl1h252d3l2d3p3hnN7fH57fYB7h5J8hHx+f4J+g4B+oGuAgYSAgoWBpmuDiXyIh4WJi46NjYqPkZSQjYWRk5aTlZiUlpmYmp2dn6KdoKKetpGipKenqayztba0w664wbe7x7fCy8HHycrKz8rR09Tfw4T/2YO5ucemAAAAMnRSTlMAEBAQECAgIDAwQEBAUFBQUFBgYGBgYHBwcICAgI+fn5+vr6+/v7/Pz8/f39/f7+/v75wqJIgAAANoSURBVHja3ddpQxJBGAfw8U4RtZQ8wvAkRUHxaL0XDTNTLDxSU7LYklQUA0tr9bs3zwy7sMzO7oD1ov4vhJ2Z/fk8O6Mo+pfSMTHR8UegCZz/D2ocjugZbryHEzGkBKmmK6hyEuyqEXceEoZLPRZ16lWb1Is5lUE7KFgpBLXD2svxMdOMX8JsuxA0CM4YNyANCkEqjlbPZETPpFYTzKNcnD5Jj89ZAP3Uvn0kL9qYEXJKhjhLhnxGyFfQ2hinNRaSCsJAbPjQfpJk/95QMhsT6LlF/hLEtlY6pKd4SHz7l/jOkviBxInyoaj4jwiOsshzFhUKGZPEQRAGik2bO9OxIiEltmhaT0wpEsKJLjHPOaooxUKclASdHhsBGCkBOr69u7s1UHSEQN+EoGsC4bvwfTlGGwHoZkUIWrlR1fPjO5LTPCg7cq7+2pGFIHnnRr06pbcpDKRcYYeBzpLJMxaSV76rJ7zWTq6xw0ARHBbC+fzjq/nD/vJJlkWhHhny5t0HpTAfd9dkkh4hqEXO5sWrjbfvtexurL2UtbQIQWhItskQEoMa7KAGQQj1Wzv9CF1kjAGIvjNA5SNWzkg5QqELIQjVjlg4tfDZEUoLQah5gecsNNMPodW0ENQ3NW/uzE/1kXmQBKAmSZJm5lhmbgZPNOEFVQFJ2hOA/HsSN3t+WNEK72whdybDk+Bud7Y5Ka5DW5HIFgtVjOKBkLkTwlOjFXhRWQBfJTJ5YSEPvk6YO/Rej/5ZnbCCquE6TMpmEw/D12pY1w0FXlhAXlJQhhNShBdBcz4icSEHvkqH+VAYzo8DVtZJIKV5kB8agB1hk5vxI0gnSKtpc6gNCoItW1dMsq7V0EabYyXD1sfx9OyRGXQ0C8dHOwLogXa0WMitFfRaMc1rrSQ3gjxhpPytj8PkoTl0CHNx/QigZ0SKM1AvKQjGLRInJfUi2hxJogBy0IIyNqEVOBCkVZMM0AApyB4iJQ0gkj6Tv7NdsOrA0DLnLB3AqwtBqgIMRLY+BVfLikWWYUVKPwLoEQPB1tNfRNtW0La+425E0l0AVesFhRTLhPSS6BEoCxghD1OQbUke9t+I7NanmAfNfeCp3BFAT/MhLy0oIxhakpdCZb4c5KIFiUO0JBeV6nKQH4Y3JfHWpE149VdQqVODfgMTMk5YZw2wjAAAAABJRU5ErkJggg=="

/***/ }),
/* 1252 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABRFBMVEUAAACnqaynqaynqaxckTunqaxtbnHR09SnqaynqaynqaynqaynqazR09SnqazR09SnqaxBQEKnqaynqaxYWVvR09R4eXttbnFckTtckTtckTvR09RckTtckTtfYGJYWVtiY2Z+f4KTlZinqaxxcnR2d3mAgYSOkJOipKddXmBbXF52eHtiY2VsbnBxc3WEholsbW+dn6J7fH55en2PkJOJi46HiYuMjpGAgoXR09RckTtjlUVwkqx7h5JtbnFYWVtZZ1Ncij9dpNrKz8pbgEWIh4VLT1KztbZ1h25aeUmXsohYqeelupvfw4RuimBrmU6NjYpabk//2YNgotSUlpmQjYWdoKK7x7ePkZTHyco+REdBQEIpLzNjjkm0w65wiWVnjFKIqnSbsJGBiYF+g4CetpF+oGt3hnNekEBljU5siltVrO7q6djDAAAAIHRSTlMAEN/vn1BQYL+AIK9AIM+/j4AwcCDvUN9wQL/PMO+/v01z+IQAAAKoSURBVHhe7NBHj/IwEIBhHxCcUIRED+z+Ddtp9N5729rL/7+viUkESszY2pVYffre4xwezQyCS2y3CfQbbVn/HhTN2H6Z6A8c+yR1KaaRM2kxSSauEyA9LuWkCFhKRtKJRDrsxDiw2OxC2yy4BP9J485OGJc0ECJu3j4N26/h7UTc5KC1t4B9lDe7CER2otPUoWCXhb7O9Feh/9BU7EyVIFMMmUoQroicClaDrG6407UUIWyF7lSxsCLEMgMfn5oYq0Li1KF5/QTgE3Wo3p9M+keUP+HQCwgtDxBzmIT9vAmHlhSEDFea1Sdu8yPoMJntHQOGqHHLoOacQzgA4abrSECUdqqErESnrQjpUCoBFZk07FXXo/Bnj9a9IWUVQShC9xkPj0842HPr1aBuERDKUa/3j89B683vbnB/Q/1yCCxPJcojuIIMVEASZWEni6SKAAzwaVBSd1Cyfc5pJ6WhK6dUFjHlknMt66Qd1rgWxtTGDist53xXUm67CcNAEC1ESJQgFMEPQIYQEwzEXPO2//9X9aiSEdS3nteRRns28Y6KRqI0xSirqAR2EmEHlDk9E1i2EmTLfJIhNgZgJIIBME7LVbD0FPBB6Z5BleqZw9KKCALYqGUwzxBTOl6kVVru+3d8ywNeHsyoje9YzxIWsxeRbjN42XQ23BtYlpGihfv0xyHA0f0Ci4RYLW6g4EhSR+VmIJpFpyHIibkGmQWKpgzPXCai8GOcGUz9PStmiptGAu5bMVh5xQpGjeQVScOgmIXEaiFPRHkKqQNyE5CePeshwZpFPbxnYEQx3IUcUkUHIXdY/ty40m2aA6VHcvsufWIXIdd00VXIxcm9P3oY9yDjuIdt8HkGqtemkclr39XHNUMr/y2SFmT+LqY0o+6GLG4di7Rycj8UVKG3e+6Q5wAAAABJRU5ErkJggg=="

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAn1BMVEUAAADm5+hYWVtmdX/m5+hYWVtYWVtmdX9YWVtmdX9YWVvm5+hmdX+8vsC8vsC8vsBmdX/m5+jm5+jm5+jm5+hmdX9mdX9mdX9mdX9mdX/dLkRVrO5mnNmzVXmZbZnVNk++GTFimtadR2ygBB5YWVtVVlkpLzMvNDhJTE+TlZiIio1cXV+MjpBucHLm5+hufIZmdX+8vsC2vMHGy87W2dtd+9qcAAAAGnRSTlMAgABwABCfzyBA72AwUN8AYL8gz+8QAO+fIK9o22sAAAGfSURBVHja7dPZcoIwFIDhWFMXKFRAqzZoxaYVt+D2/s9WTNQRjxw05qLD+N9oyMmnuYAQUhFYmyRtI/AqlBJKBVqySktEQcXQbiXb3QJhV9smCkq2xVfDqq5OVT/wCLLX6UmiXpcfvY4u1D8AJ7CvBzW78nhr/11dsdvUgVrq7FtW1YDkyXone8+uFpT9B1VdqKXuApYIhEuIAyBcAg4C4RJwEAiXgFMMOe765lzn/TxyvnDWd+XkQu59kJsLre8MQLYnHsizaRqh1A/EgwX+HvLb4uHafgoFwkABJbYwkk08M5BHhKHMQZ+GKjPE9oUDfWEQSoIw1UDbYSwDherxkB0antbgSXYdXkBMPWYMrtGJL/afINkTekIYBF8RXQh0KwRfSRicgNAoLXtkBLo2cQlFulB0AY11oXEGilJHB5JSpCBkDIRNlBn6NlSZIWGoMkNU9cp/fg9x/oJ3dZYcv1h8ovYm3EIQMAugGo/VZsxriAFmAdSweDxJfyPmViMPwGbJ9NhszmXz2TQvbFZCqsVynm4tFwgAZwGkm3noD0qffbg1RyohAAAAAElFTkSuQmCC"

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAtFBMVEUAAAC8vsAAAAAAAAAAAACAgoUAAAC8vsCAgoXM1t2AgoUAAADM1t3M1t28vsDM1t3M1t2AgoXM1t3M1t3M1t28vsDM1t2AgoUpLzPM1t3M1t3M1t3M1t3M1t1Xg6UpLzOZqrVYWVuGlZ4MDAwwNTn0kAy1t7mmqKpVrO6PkZSlpqg/bpGipKY2PEAvNDhJTE9ydXh2d3iAgoWTlZf/rDMAAAAjJCSEhomTlZgvMDC8vsDM1t396hG6AAAAHnRSTlMAAM8gYAC/7+8AMO8Qz5+/QJ+f768gMCC/IIBg34+36Ea4AAABi0lEQVR42u2TyXaCQBBFy4FBxTEOmSUog3NQMQH+/79Coa2BUJxDmoWLvquG987tpgAQCAQCgaAMnnrPg247LEj7bdxAoBGjvQxew//S7THReBDyMdRQpA1DbtoaNMYPYQl0gXl4gcdpxHb3wQtMz+zKEm1LESHcIsdxVkz07hTkPSlymMgpjBAJUcTxeKcivl8kLeLkPkWrUkTTC99cmCYTbcoSfZYj2qCHU2Sa+zMH2woiLPuwp6G7TLSIEoa1IA1kl4nWQYI15aC6TGQHKWxCQnfhtofrexG+S5+J6jLRAq+WJ+/CaYnXxJzILooszGbelRmmVqaH7oK6P6AU97hywjtZXwHdVaEfT8/Fe3ND1405rlxi3nS3DxMVT+tjpsdg6lPPRnXVCUhNJVqh2jiHBq6DiCxRkN1VmhJI0qijxKF+gYm+KFG6q3RGlQpUYtIh5JDbTR8XaPK7cnKAMtDkd+vJV1qHJAW6Ve8XVUhRoFtr3bJWDWjoLkur1z3+ZAW7dRkjmZxPfvcHGJQpWRpdtZkAAAAASUVORK5CYII="

/***/ }),
/* 1255 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAaVBMVEUAAAApLzOZqrUpLzPM1t3M1t3M1t3M1t3M1t3M1t1mdX/M1t3M1t2Iyflse4X/zE1xj6VwenyMmaL/rDOZqrX////dLkTswVO/ytGflmxmdX+Ev+rivFa5xMvM1t1SWV4pLzPCzNK4wchEm50CAAAADXRSTlMA34BQ31DPYL8ggBDvCEs61wAAATtJREFUeNrt1G1vgjAUhuFHedWpCDKBokfc//+Raxok2FMze1wyFrm+cnJTChQPRSExYQRvETn5l0JyCuGLHsAzkpTuXC/dyOVKd9IEbquYLKYzKpElXjk7G7J1li+ybFylmH4MERODSYjhj8YlsKXE8M3mUthICJaPyYXwi6G62Ckvu6J2hc4m45k681CtO4JSDVuhRArcLEttCZgF7dvt09q9WdJQKA3AdLZeTAm3QtlTWusXapVWaiy09fQvQoA0BLxDSL7Z83ckfGuin5aHXj9GhoMtlx1sOYZCr1EiDWxVrgTyCrbslAs6p4yHsqrJPTNNlTlCInNoDk09dNQ+Rw6ashy08cxRm0N/GToIvU9orcTWGFMveIPQ65tt60bAeMxNL7ToBgv0RHNBNwjQk80Fi/4+w3WPuW+glkZ+HzXLOAAAAABJRU5ErkJggg=="

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAq1BMVEUAAABtbnEAAABckTttbnF3slXm5+htbnF3slXm5+htbnFtbnEAAABtbnFtbnFtbnFtbnFckTttbnF3slXm5+htbnEAAABtbnEAAABtbnFtbnEAAABckTttbnF3slXm5+gAAAAGCQQRGwsXJA8wNTk6WyVRfzRVrO5ckTtflT5mnUVon0ZtbnFvqE1wqk91sFN3slWGlZ6ZqrWeyuunqazm5+jqWW70q7r/6LYgby1hAAAAIHRSTlMAECAgICAgMDAwQFBgYHCAj5+fn5+vv7/Pz9/v7+/v7+7bhFAAAAGrSURBVHja7ZLrcoIwEEYXL1StFq2IolQQxIqiFayX93+yugKiGZZxEmbqtJ5fSfabk2UJPHnyK1Teeh9+jMJvUYb+NcBHq+8z8GmGPosiptGVhgScNPTE0m9JwI3Uji0f7QoI8KLHGkUCEVrFaOA98vQqIITUi9p5BUFPNB6du53vHP6jSFbNnRCmKqOnjhpBzDqAjB5xkwzqrhBUMIsRmbAriAcUfaZs8WDLt0NRCh7w7J6ip4gRFfQgOXl80VZINC+Ew+EvizYFUZzoeIxXq4WHTXqLVU6cyu73iWiNlRhvTRqIbCpazm9YUg4qm4gWc4YFISGyKErvcB3rhOPSPeVlUbTG3cy2YuwZ7ok5kVkUeVibWBcmWPUyPXQWxpsVSm3rChtPsl4BnR1D9zw9F8+mQRgGU1y5xLzpbBeqY+zWwVp4BqsO9W1UdlwFqBmnFaqDqBjgGvvNEs2zs0YNTpQ7xrkYxiSiL0rEZo1OGRLYItDkZ9l2gSY/q90OUAOa/Gzz9pc2geH+7MC6YgAs92dLo7Q2KgHBPdnS4HIH4bk729SwpJHzyc/+AKToRm2XdEelAAAAAElFTkSuQmCC"

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAOVBMVEUAAAC+GTG+GTG+GTG+GTG+GTG+GTG+GTHdLkRtbnFtbnG+GTG+GTG8vsCAgoW8vsD0kAy8vsBtbnHe7jLCAAAAE3RSTlMAYL//ACDP7///AIAQ//8A/4CfAteF4QAAAM5JREFUeAHt1tGKgzAQheEkx0SNu7X6/g/bICI7yxHsWDoi+W/m7oOJRnS7+YBS8M2xXMOLCWspnoFii602noAS/pT0kAfQrQHwaihIKKghSAgV0h+2/vGbvZD8iphe2pL2M0LqS/loLu/3cWgAaXh/tR/QlFAn0kH55pDMDFr7LT2WtlkaZW7c7+ZQLl0QItlDzyWyWoWWrgnJLCF52Nus0PUhmgKamDMpIIM/NhuoQhWq0Nz/a1ZAzCmSCupJhpDc6/h2jjgqydG1eN+BXlufvbtuqx/2AAAAAElFTkSuQmCC"

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAt1BMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t1VrO5VrO5VrO5VrO5VrO5VrO5VrO4pLzMpLzMpLzMpLzMpLzMpLzO90d+zwMmJvueZqrXF095cr+1mdX92hpCGlqGTo65zgo3Y4Obh6O3Z4eeco6dXXWIpLzPR2+HK0dZMUlbe5us1Oz/T3OJMVVyLm6XN195ksezM1t2uzOGfxuN6uelVrO68IVxAAAAAHXRSTlMAcN/PYAAQv48wn1DvIECAQABQgJ+/7wC/YM8g76OR1AwAAAHhSURBVHja7ZdbV9pQEEYPJOEoJmDtDdBqWhUvEMUL7Vfl//+uZjCTZLA6y4yrL81+AQ577XNy5gVcS0tLyxOdLt5EEEZrXCToebwZ33se6gVoQEAlZ+kwW5uhAA3ZlqE+mtIXoR0cpo04RFwPJTHShgD1kIchNKhCHaD5oyEsQ70YFoZlqA8TnkMD2OhyyMNIEdoB8LCqgRx6VdYqdt0Hogvglym0tw6FAH6vTKGPjg/0aAt9csWBvq1soc8U8gCOjKEveWgA4PsPS4jIQ32evTGUgGdvDHV49sYQz94c2ubZW0NDnr015Hn21hDeiTb0L0PH78R/Ezo5naY509MTaamODJ3lBjM9E5ruOJScXwjOIdCcKnR5scElBIrj5F6zeZYzn8n9FEeErmj1epEVLK7p8xUY3XEea27Iuc1Kbsm6AaM63oUg7ii+yGosaOUOjOaELgr4Fmf03f0yTZf39G4m7lJxgshFSVycek5OuoasuXi21504yUNREgB0Rtpi+SQt6T2toeQ1J0iKH+yhZyktYOknKl5yfLjxf21T+voXXnaclPjYUlIdGRrJixyJguKI0FiOdiwKqkMhZpLVmIiA5sjQ/kHlHOzLgOo4YU3KvWRHdzjEjEekjJ7dj+78AVdL2Una5UcPAAAAAElFTkSuQmCC"

/***/ }),
/* 1259 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAArlBMVEUAAADM1t3M1t0pLzNVrO7M1t3M1t3dLkTM1t3M1t3M1t3M1t0pLzPM1t3M1t1VrO7M1t3M1t3M1t3M1t3M1t3M1t0pLzNVrO7dLkQpLzMpLzNVrO4pLzPM1t1zt+qnyeJksezT3OLZ4efe5uvh6O3R2+HY4Oaco6dXXWIpLzPK0dZMUlY1Oz9MVVyLm6WZqrWRwebN197F095cr+2CvOi2zuB3jcTdLkRVrO7VNk8tRq2jAAAAHXRSTlMAEL+/EAAgEIDvz2AAMN+/j59AUHCvIAC/YM8g79N+H+MAAAH7SURBVHja7ZddW9pAEEaHpaEkKRSh2kp9WyEg4Af0O+n//2PdiUuWieLUNY96wbkKy3nOJrO5ADpw4MDL8fZTbvn7pyh5/+bjf0D3LdqOxXZcKTiUlxQVn5sKvfyjNTHsVjfGo0jSqIQiQa+PR2Nad0O9GAEkXCK9ozOohVp94FtRgb3kFrHQk6EB8ONnUOhIhIYAfhVBoViEDPC7CAthNzQC8CU0NOSQn/TXIjSU+tAAwLkaygU+161CPfDRB4dMFTJ89OGh/jb0wR19aAgu1Ird0YcOG8Pb0LE7+vDQqAwN4Y4+PNQl9wrh/GmhIxsaxdDQQ4b4uRoIxRT10QiUohnouKlQ3FQIry6UN8Qh9JwhvO4XcjLNZpZsOoFAdWRozoYjm8OjOjJ0MRNcwKM4MjSd1ZjCozsk91osV5blQu6nOCI059XLq5Xj6pI/+xnoDhmUZOxcryqu2crg0B1DKZgJx91ebj9emcChOilFyXaKC/7uZr3ZrG/4aiFmqThJRFEndne9ZGdTwtZSPNvDTtyxoaiTADMLb7G+ldZ8zWvwPOAkHfdjNDVbaePYSt/h2eeYtPZfpC69u4f9DgnJ37aQVEeG2nKQbVFQHBE6lUd7KgqqQzvWeLXDWAQ0R4ZOzrxzdiIDqkPCGld71Tq6Q7UZtFlp35mP7vwD/LIgXDh0tJYAAAAASUVORK5CYII="

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAApVBMVEUAAADdLkTdLkTM1t07iMPM1t3dLkTdLkTdLkTdLkQAAAAAAADdLkQ7iMPdLkTdLkTdLkT/rDPdLkQAAADdLkQAAAAAAACzVXlmnNlVrO5vlM7ERmSqXYRepOPMPlmIfa67Tm+ZbZl3jcT1+PqKHSs3DBEAAADBKDwpCQ0OAwQrMDR3hpGImab/rDPdLkQ7iMPM1t2dmnvcOU7Pt8DNzNPZWGrWeIcdLo0OAAAAF3RSTlMAgACAgABAr98Qv89gACDvUIC/YM8g7+hEEEkAAAF/SURBVHja7ZbbcoIwFEXT2IsixTailbb2KogCR3v9/09rTobBwHhsT7HtTCfrATLszZIkPkQ4HA6Hg0tnzaIjjgjWTH5e9O2pnRdF8bQyHJ5WYAfT3XekEhWaVcmfivY9teMTaNB9f+Uvdk/BFp5fuNvfC2Erb1yRAgLm1HzQXEwiBIf6dnkFX0f5UiOk7ALAdRTZomjKMUEYoAg/6GZqi5AJcBgEWoQbfxvZIgOwCKXo4X3aVgS+ONPXu6i1SIkDfb1vLwKh9OVhHyLc/Mk+RObVfyoicKK66LElTvSLIvfPZotmcaKJZ0BBN23RPE1K0jmQ0E2hynSRVCxIE91UwgdDmlikQEA3fSFDM2t8uszyPFviiFgnuhlKIYOBHsSY5gbMYyAgmuYQIYMQAOVZbshwDCTN5uZYo/EVPspLdouaTeughTRjQfJJ0/7gRsxrevUl9KyI1xzWN3VoRcxmP7Ho2wmzORpv0vHICtjNUb/6lXrKbw49DD1yfXY3PwC+NRp7FIhNoAAAAABJRU5ErkJggg=="

/***/ }),
/* 1261 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAApVBMVEUAAADh6O1VrO7h6O3h6O3dLkTh6O3h6O1VrO7h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQ4e2t0u2+2e1vt+54u+5esO4AAAAgJShASU9ZZm9mdX/H3e0aHSA5QkcTFhjh6O0GBwikzu1GSUrFy89ntO7Y5O2Kw+6Sxu5VrO7dLkSZbZnEXS+xAAAAHHRSTlMAgIAAEIDfQAAwYFDvIK+/z4+fcO8QUN+/YM8go4ws5gAAAdVJREFUeF7sz8EJACAQxMBDEK6gXfsvTRHf+hH0kSkgkHgJAABU201TyY3IAw9a/ghdWeuk1D1vwyAURuFGQUYm4I90bdN6ynBUKbbv//9tpQOK2ogLDWdjefSyXHPoyNTZ4+9ejvn6DiVXDTn0TipU7+BDGUrO5VPuAaTHcgWGGsgCfIlkILmtgC1DvQc2yUOyA2MRMlPak4XkDehL0Ay8iw5twLkAnYDrokFpklEh42H9kBK0Aa8qNAC7qFCaNGmQBS5SAe1AyEOmg/VWAy3pb4+QPYyefzU+QsYNPNFfKMyeJxvdHTIzLU0hQumCNeVDhKLjaW36gYKnPRehM+0xRui7NLpJYhCEATCaQ9DKzw6BQXDk/reraRkS3aS03zLzJigoz1pDTGcxrJ4nC4AHQxlNL2ZSkrgv2tKljZgsAGCokG6FjkRBi+i0kHGcAz9RFnxRRhSL75WILncmC4BnZxHV7kc7utiZLMaeFdcXzyo4WbsTBSzsHgOCo9XaDj76Rmjg351R1XfoMn25KMxYlM6Qtw9rfCYLC7DcWO0xJgvl8NH+X2QdnD2XP39NG7inr1epYU5Q5vq4ZlZQ1rPstKCcIqXctOBunGjdT4IyGpE2s+IF8c9oogf+dcoAAAAASUVORK5CYII="

/***/ }),
/* 1262 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABCFBMVEUAAADM1t3M1t1mdX9mdX/M1t1VrO4pLzPM1t3M1t1mdX/M1t3M1t3dLkTM1t3M1t3M1t3M1t3M1t3M1t1VrO5VrO6qtr5SWV7M1t0pLzMzOT7dLkQ8RUtTX2dVrO4pLzNmdX9mdX+2zuC90d+fxuORweZ6uelzt+pmdX9rtOuzvsbJ09uryd9se4WzwMmZqrWsu8TG0dimsrqsuMCnyeLM1t1SWV5cY2h7g4iPl52jrLOdp66DkZqKlp+tt72uzOEpLzOCvOi4wcgtMzhXZGwxOD1cr+0zOT5ksew8RUtPW2NTX2eJvuc4QUZebHZbaHFicXpIUllASVCYxOTF097dLkRVrO71+Pq//RQ5AAAAInRSTlMAEL+/EAAgEI/vAM8wv59gr1BAcBC/7wCAAAAQAAAA399Q7hwUVwAAAopJREFUeNrt1GtTGjEYhuFFbbsI9djac0UtELWy2vKIx6IgFIugHNz+/3/ShOxkWN5ANi70Q6f3hwzsJNfsGx2c//0LfXj5GOp3kB/q9avPIzmjD7hjhrhkhB6NkOz5tKC/N9q0LjvhJhGhpJt4Fs4Jf02kELFUYiLEncjSJMiFRe54KI2g7S/ZXH7XJ+3mc9niNoLSY6E5iMrXdX9i9esyRHPjoPSAafgRagyo9BhoCcCdH7E7AEt6KJEEen7kekAyoYWWgX49OlQHsKyFVoCyb1EZWNFCIJMZZ4MOWqVXbb7uVQ3kAsjbQHkArgZKAfCtApDSQAB27KAdABRaA1C0g4oA1gi0DiBrB2UBrCtoYZ4N2gCQs4NyADbk6fkFJ3DYHoCGHdQAsMcCyWFB4MmfHP6bw+uVtfWyvFxe/liBx4KGof2vfVjUL4N3wGRytAMxWMHzDo8QuaNDzysA+CZHk5f9XbyPx+NUdIYHIcnLXuSlIfJ4ijIzCkJa/R+9hajgEcrA8NFEroLm1AYDpd+VUpB2U1SGRyDy2iQyPoUoBU2EoRCl9kFTjB46Lp0EnZ4NOr/wvMsz1Q/16dLzLs7lx9OToNLxG54jlquYveM5YpkuVKpAVSnpT9B9FCohlFbS7SNQBaEqeobuIxBG0jN034yg+KPFv+wZ/fljNGuoesMidlOdCHEnsjQRYhbV1KkX8SB16Od7niOW23ij3X7kOWL5Fe+ym594jlhY6ypGLbbIc8TC2oq3r9oegth97alO7Z4NQ+yhU33S63QeWBjiVLNbs3yZbpPxwpCs3ex0W5tmYrPV7TTbTEYh9dgcE1Eow4bKmBB6QkFbbKgtE6I/4cjnGaWbHf2JP80UtnDKdzRVAAAAAElFTkSuQmCC"

/***/ }),
/* 1263 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAq1BMVEUAAADM1t3/zE0pLzPM1t3/zE3M1t3/zE3/zE30kAz/zE0pLzPM1t3/zE3/zE3M1t30kAz/zE3M1t3/zE30kAz/zE0pLzPM1t3/zE0pLzPM1t3/zE3/zE0pLzPM1t30kAz/zE0pLzM2OTVRTDhVrO5cY2hfVjpgruRqsNqAtMaKtryVuLKfuqivkUO1vpO4wci/wInKwn/M1t3VxHXkuErqyGH0kAz0ylf/zE2rYz2uAAAAIXRSTlMAEBAgICAwMEBQUGBgYHCAgICPn6+vv7+/z8/P3+/v7+9JFPLAAAABsUlEQVRYw+2WbVuCMBSGCUMto7IXxUADmZqRUfjS/v8vawcQtgvG1sZ19YX7EwcebuBsAwyjo6Ojo6Oj45/pvyTJtK/vuVwkhMWFtughSbnRFk0z0Z2GwnYxn2dLVmM5uBHflvMMfCzAH0jdj9CDsScjStvzE21QCezJNzfRESqJhxtDbk9rGBFRHaVuyYKTvhHii1AEpbBLjyR03DSKkMyzmdDpLWoW7Uk5Fs1EaBASiD5J6QhEHsm8i0QfpHSbPUMYeSQSbaEWt/pLKHoTDpsJiUgoSuth9exbFyvhjU2mLR5Whl68NtahNF1jPTx6Imthl8OtRzYxzdeTNqno6tSS6L4t0VNbIg/rUyytNkRDesduHRDWO/4p9Ynig5FxCIOc8FCv4SXI6qA6dFgGBctaEzfBrrIwoAjrRNwEM2I7OLqKkyRewVZNn7gJx6Bj0MVV9jMEuXVVxE3YjAguEmexGLarIl7CZScjHEpy+KKahG+xrzRVkZv+u1HDr/ZoTvX7P2FbOTEUEikjdnBHKomMGT3dZmqJlN68TM17aok8V1xx1lNNnLsA/Qwmo78mfgFr5aJC4pMJxAAAAABJRU5ErkJggg=="

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA9lBMVEUAAAD/6Lb/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zlb/zE3/zE30kAz/zE3/6Lb/zE3/6Lb/6Lb/zE3/zE3/zE3Xr0iHdD42OTUpLzP/6LYpLzMpLzPKwn/VxHWVuLJgruRqsNqfuqi1vpP/zE30ylfqyGH/ykv/vED/rDP/yEr/uj7/xEf/sDb/uD3/wEP/rjX/wkX/tDr/tjv/sjj/vkL0kAz3s1j+8eH/////+en/3IXPsV15gHlmdX/fxmv/z1jXr0i/wImHdD6qvJ42OTXywkuKtrwpLzN5aj2AtMZEQzahh0LkuEp1stBVrO7/6LbM1t2ZqrWqhxwVAAAAHHRSTlMAIJ/vADBAgK+/vxAAj+/PMJ9gUHAAAAAAAN9Q1J/AVAAAAndJREFUeNrt1GtX2jAAxvEg47JmBVG3OaSCPIoFYeouUBCdE6HgpW7f/8ssDZycSNMuEV7sbPu/yDmE5gcJnJD//U2lSoWnSIVS6kNMJGZ+kzMKatMMSnHnx1JcShlBpSc1xCoZQQUB/VwkoII2lM3lXz+pIZ6Vz2Xpq+XI0mtqp6FR2qbJEC1CsyJNhJijLSVBNgyy46EMFl19H01mj0Gkx9lkVLnCokwsZCHM2a8GiVX3HYRZcVCGM7VAoxqnMjHQBoCDQLMDABtqiKaBeqBdHUhTJbQFHFb1oSqALSWUB5zAIAfIKyHwnRntDSpoWxy1wXFvKyAbwMwEmgGwFVARQGAUgKICAnBkBh0BiEJZABUzqAIgG4F2AIzMoBGAHQFRC7w0gIkZNOHLeBYlzBHVzKAaILIIpOZXDrtzWHVHWX3EmszmlxWknkHOIQw6dJ5BFqQaDbwwi1BJOnbdY2jWPG41JYcS+a52WSfQqtF23bZ8d3MoJ0Ftvd11XNbiUVtAlvxuBxp95J+JeUUBie97yiUtRz6FCIQzl0t6TgvxEFpu2PlZ0kGdfJo/BDUkjkmzzw0VZC6dMycZwhcdpwX8FkKzc5qsnHaaiIGM+/egr2HdnsfrD8C6GF4qG16ANeh7vF6XL33DIuHAHU80YM5lbBfM8UTdCNTzRH1gGA8Ngb4n6kUgTwq4TAjfPKm1QWvd2voPe10/P8WK0bX/s6+xUtdvWSQcbrBSN+9YJBxux1ih8e17FgkHf4oVmvq7LBIOvj8d44WNp74M+Xf3D3hBD/d3vgw9a1cjX+qPhsrybFnDUazg0J48vafhKFaQ+XxZ6BqOcsUv2cX2n2ONw48AAAAASUVORK5CYII="

/***/ }),
/* 1265 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAk1BMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkQpLzMpLzMpLzMpLzMpLzMpLzPOe5HbOU+90urIm7PGpr7SZXvVWnDdLkTMhp3QcIbBvNSaLj5WLzcpLzPHLkJLLzY0LzRcY2i4wcjM1t273fXKkKjXT2XZRFrEscm/x9944Zf6AAAAF3RSTlMAIJ/vr1AA32CAQDDPEHC/j78AYM8g71oLwSoAAAGxSURBVHja7ZVpj4IwEECrXKKy6npfIwpe1GP//69bh5rKiDga+bDJ9n2RxNfXdjBRGAwGg8FgMPxtKlULCJbtuA8Q7lMqVXiAV3s35EMBXv2dUKMJxdjBy6GaGk64lAg+4ufycLzOynktFKjpnM4S0SHkZzjSh2JDFXWt4VjSkGI8OalJsaGGheJoKiUN3Tikp/KZkBrPcSmLQ3I8I9cTDzuAzMcyFyJM0us1ikNqzKGUTAhL+u2Jos5Q8iEZAvJFQ7Qzka+EFpBSfRAKSIc/kS6RUN1vAe3Q0PJ84bC4MJsjoGljiESQUdrBRVNcFOKaETwnUKHAt+AzHKF/f5/hY6gNn9O6hBwoKeRBCVjCDaAUSgy5/ya0iuIL0QoIjJEPrTfxlc2aeKwhKl7W2saaLfFYQ9hZDXfTbIDAGILcHr/d7ZNkv8MnMgXGsEgoQitJQS8CDWvYJISb7JW2x2fQsEZdWHdacoVorNFyRa2MUDNwhet4n17N8+//jjp0lJ3vHMWGyGpd+nK7pMEYgni9OEOPNhiDhvqDmzXo0wRjiDuvp3cjHd4QuSl0UOrk5sMZv3gJNVZoZFgLAAAAAElFTkSuQmCC"

/***/ }),
/* 1266 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABC1BMVEUAAAA7iMM7iMM7iMM7iMM5fbE7iMM7iMM7iMM7iMM7iMM7iMM7iMMpLzM7iMMyXHsqNTwpLzM7iMMpLzM7iMMye7MkaJwqcaYwebE4hL4iZpknbKE5hsArc6ktdas2grszfbYvd65UkbS2s3nzyFT/zE1Mhqdgla1bjqVPiqxFltNTqutKnNtDk9A+jchVrO5QpeZPo+NLn95ImtlCkc5Aj8s9isZGmNY5fbFNoeFIm9kyXHsqNTw6gropLzMuRVcwUGksQE44d6gvS2A1bJYob6Q3cp8rOkU7iMOTwuW73fV7s9xzrdmbyOmr0u+z2PJbndBjo9NTmMxLk8mDuN+LveKjzexrqNZDjcYw7jlNAAAAFXRSTlMAMEBggACvvxCP78+fUHAAAAAA31AvmGeUAAADAElEQVR4XuzUOW7DMBQGYZEyxEWGi8CHGi5avCb3P0kMCYiAiFLIOp7yFV/xir/6X717J6SsD7+qpRQfG1Xrkzw0ip1Uc5D6T0gbS0bW6H1It2TW6l0o24F2DzIUZLYhwRzXz+C6p1/17Fy4XJlDbEIKgPEx+N2GxwiA2oLExPQ+o36ixAZ0BO4+sztwTEPaQvTZRbA6CdXwNeRDA1AnoQZGX9AITRICYgkUgRR0Xl6d/+5zAjJAVwJ1gElALeCLAtoEBNzKoBuwhiRwKYMugFxBJyCUQQE4/UBaMWUBVwY5wDKldKVY6sugniVVscQ8OZ0Lr+KYLIZXrpvH6rv2smtOE4jCsJ1pm36M6YfjZhXBiBoTSNIArU2CLvmul7nM//8l3T3Isvq6UDrtc8GF591n9hyQHcy1G6Lnl1UDXp7Ngm6ty9gB7zUR9fgBY92iNT1s1lc4fPBnlgF3aAHTw6ZXoxZJXNgW0nOLNCtelCR6Ta31C7yaXQ08HaXW3mtR3t2QO0X5sMpzWGzeGQ3LE45E5Za9dcize9bbYV45AhBJBqNc5do8bq4ZUfsggglYTS5MEUX+eDKVTMZH1B/f5eHU1VGR9HeJZlSkwDHLbyxCheMyOUORL6u6flIlOjGTPojGU4Nxlx5+RP2+mQTRxCxPVhYwCaLpBjYJJv+Z6P+1BiO0UjNsH26qBUzaH8iZVQLJyr9IxX4giaIgDE/PzlcNOD87DcMAROE34iKKkyT5rviBgjkVfiZJHF3k+dAiagyKgr8yQWuSeRBHzSxRHMw3h31pDiFRE4iurkvia4OraD1FchCXbyQtdUlhqk7figPh9JOkpS6L5XatX8F2drn4LGmpi8jwrLCBp0Imvkha6iLEDZ5egOXEuxGmSNze6Up5VgL6VNTc3QpTpLh/WG0x5O6jtrFHlw+3Ew/3QoBIkqVPMHYby6c0EwSKiF/Zvvzu37N+tH/Yk9/9+9lCaFCk/fVQEEUd09Opk+AKLWqbonatBVeQiEwdba/37F7xG3hjhtBLlIBEAAAAAElFTkSuQmCC"

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAllBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMMpLzMpLzM7iMM7iMMpLzMpLzMpLzMpLzMpLzOLveIpLzNDjcYyXHs6grprqNYsQE4wUGk1bJY3cp89isZPo+NVrO4+jcg0Z40uRVc5fbEqNTxcY2i4wcjM1t17s9xTmMy73fWbyOmjzew7iMNoXEDfAAAAF3RSTlMAgN+vIAAQz+8wcL9gQIAAn4+/YM8g73S0dPsAAAG1SURBVHja7ZbbWoJAFEY5KKFgmqfIslLzbNb//i8XTMh2M7JHg7tYV4yzvqUz+A1YNTU1NTU1/wTbgYzbaGZYzSK8OxjxWxQSO+aSRyGpY8Y2hVwoDsczDtknNHYMoTYUj0cGgKfcGC0x1ILi5WgOtcVQgITPox5CfuxKoRCKr2tCgRDyHFqYMQQhZEPxfV3IKwx5PkDbagx1CkM2bgrZ91HMvdXN4/lgS5P/kIATKXKhjh3gViYUkiJmnlmo08OfmVKoFaAEr1ko9FGGySkUohxvaaiBkrynoV5VIZwxmy9uYj5T918PaR1jCTEXQoub+agqhJiKl1Z+s5EeIyhNerBVFGo4FYVcVBQCY7mKYlZLaOiOEFpPo5TpGgzJ0UPrTZSxYSXZcVTIZ0cmMQVDcnoq1KO1J3Pb3X6/2yZXSxCy01EhejVbJc5ekVgrnCE5D+mT1js9hqKY3a+0S67BKXJc9siOY0rapwgh7jih/jaSl7oXKHYsJtHPZpLo6KE+38g+zYiOHhrwWzugGcmhEDGMzhh2CdnRQ6MxOeOR1pAdi1nD7Lt4R3YoRAz6idLX9sfs/ACDYcchHUE+bgAAAABJRU5ErkJggg=="

/***/ }),
/* 1268 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAh1BMVEUAAADM1t3/zE0pLzPM1t3dLkT/zE0pLzPM1t3dLkT/zE3/zE3/zE0pLzPM1t3dLkQpLzPM1t3dLkT/zE3/zE0pLzPM1t3dLkT/zE0pLzMzOT40LzRLLzZVrO5WLzdcY2hgruRqsNqVuLKaLj64wci/wInHLkLM1t3dLkTfxmvqyGH8zVb/zE36ZdmXAAAAGXRSTlMAEBAgICAwYGBggJ+vv7+/z8/Pz9/v7+/vAFGAWQAAAWBJREFUWMPtlttWgzAQRce2lKJy1bZiuVSLjVX+//tkhFIISYCBF5c5T7DYbA4DLAKgo6Ojo0PKxmG9cTa9mpXPBsVf9Xh2bGB2apPPBsdXzoeNiGpOzhiRoxCxUZF77qii9cNz3sw3TbR4zPmQROuXfB7RUz6P6B5P/Ho/xpgJogXe2KXUTBJhoUscTxb9FnqbQYSFPuLpIq4QXcQVIov4QmQRX4gq6hSiijqFqKJOIaool0aLtOgviz5nyv8RnZKwSHJSnSJmWqJzFFaJzjKNjAG3wRzCOgeJSca4YN12orCRSCySMRZAUN87HkszxrIUt4RzkjFB8X809tUOzjAtX1OkEpFIwuwN/PUbVSe8RFZCGW6LRGImMKr1muVeoeuXoxC98oxrcethXiRaM/MikECt2lQG7PYgbSoDZvvRmlQGwGu+bB6dgeX2xmyXdKag6ut5kxicAU4ztE0YzfwAQ6XaoaXkTiUAAAAASUVORK5CYII="

/***/ }),
/* 1269 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAk1BMVEUAAAB3slV3slV3slV3slV3slV3slV3slX/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE2ZqrWZqrWZqrWZqrWZqrWZqrUpLzMpLzMpLzMpLzMpLzMpLzMpLzOLm6U+Rkv/zE0wNzt3slXqyGGVuLJcY2i4wcjM1t1gruRVrO7fxmtqsNq/wImZqrVvfIRFTlSujL0EAAAAHnRSTlMAYL8AIM/vEDCf3+8gABCvz4C/YADPIO8Av2DPIO/jhOMPAAABhklEQVR42u2R7VaCQBRFB0TTMEsFDD/QkVKyQt7/6ZrrujrQdRya6VfN/sHHOWttDsAcDofDYY7n5zfxvY6AdTQE3VxLN9CLgl7egl6gFeEe7SadyMtb4mlEfluRrxHlrbktujMR9Qf3/Ew4GD4ABqLRI28Q9k+mH4v6If9GODQSPXHCwEQ05oKX17cDcJ5kIBrBi72DBuCIgWgMHnBYiXDQh60IB30erEU4yF6Eg6xFOMhehIPsRTjIXoSD7EU4yF7ECU7kRH9BVP4S/0F0rDJBdSwJpKOZFK03GbJZlxLSqTM2OeXb7MK2ZqKdKpuwKZzQj8+QEtqpsimLYvG+cL/bF8V+B1dHaaHd9SyOWJTMygry4gQ0VSkh3dVslghRlMSgFX5gD9d1Ee1oFieREAngpkCIiHQ0exYwOJACUXVKUX0qFdGOZihKmx8vlRraXc9QNG/+zrnU0E6RCRGwyGospIV2qgxFy5XMV0spoZ0yY9gsLv6mh3Y0QxEyTyFOG9+HdursC+h24rcXXvcxAAAAAElFTkSuQmCC"

/***/ }),
/* 1270 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAACXUlEQVR4Ae3azWrUUBjG8XMJuYS5hNm7mZUrF+PClS5mo4JQsRu3dtfloKJWHY1DkQEpCKMoYu2HtFSlEj9xOTsVRXMJrw/D8EJik9MQz5iTPIV/KISEnN+ck0xgTBP+1je2umiCpGgGm7rXzUcg0IRA2QVIagn09dv3LgrRBMn/ymBTpVqoj+LkhRKohzaTF0egAC2llhCBTqz9DtASipEU6eyjX/Ls84/EAO6++an78X9qgLrfUvbx84RpoRBJyRJI6X2pARY9twXI7YyR8ulM8h7IspTK5ymQ4vQSMARSmA6KkGgE0uXUR6IRSHG6upwIlJo16cc2gRSnjSbOAPx9zOsTShzk/xdFt0vK/1eNEEnTIo4l4pQEupBxIIGG61dapy4fiZE0OYPNgZ27dSzMOZBAnD35QAFxcoBm9x+pSwuD43JpdGba8tqiYHzag+2B7Hx4kZnB5sB8GPjp60f/GvTz/fF0YPtfXrl9iuECHlbo09dPu8DgnQP15glxcXhSZwJmQTkE90CKFDnAmM6IlafLMt4bOYZwD9RGcdmZ4QuGHaj8UtP7Be4VzXmbVyT3ID4CKVIHxbMlYwFpHJDWQpt8m7fXQRGB7LVRH0UEKtDsx5MREt9z/QvTiED5tVFcYyAimavXVsR14XBV3kbv5P3HT76lQM67feee7O69JlBeN24OZGNrm0C2xo+fEOgw96WXO7sEsrV6fzRddriJE8jDCGTLLJxfFJaZeyACEYhARRNLtTpfpYAIRCACHeaLpSlYpc9n/v0FEIhABCIQgQhEIAIRiEAEItAfFxJs1ojOjXoAAAAASUVORK5CYII="

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAt1BMVEUAAADR09TR09TR09TR09TR09TR09TR09TR09TR09TR09TR09TR09TR09TR09TR09TR09TR09Svx6SOunV3slXGz8SIuG3O0sp9tF2QvHPi28n/6Lb047714bOMko1mdX/U1NKzr5vs2q9VrO6qytL/rDNckTthg11djz95omFkfG6luptynVjCy8FjlUXJy8xYWVtVVlkpLzNgYWMvNDiFh4hJTE/CxMWTlZiIio1cXV+MjpBucHL6KQk1AAAAEnRSTlMAgN//UABArxDPMO+PIJ+/cGALcX6eAAABv0lEQVR4AazSDW4CMQwFYTYTEucHaO9/2SqoSH0t25UNc4BPSvxOgbYEKZ+109lbSdyr9hq08ajZC5BVECkIWQORglAXRyQX1Ae/qwLFHZgCxR3IXsieO4yLD7LGTk2guAPTA6mjURQy23eu/Newn1Af3HrIgbogOe7HU+eTo/KC5DOvIYdhD2jCntQHx9VvKINKTgfKSVYrkrz5qHSHqk7V/A4sqKC17ncWZAmNsZnXWdDG38bMpcyBB7oQTqHbm6DMm6D01S797SQMBFEYfwetfyscUYRSUEdbFim8/3M5cZtOMTtxpJOYGL6rORf7IwS8IDnPzrMBddDFJS8H6Oo684FuMh/oNh9aC915Qbmh0Ri9xqMUdG+BxInS0RAwkTEBHo79aoC6BHrslXPTeE77F6AuHZJbLkBbfwadIP+f3+EP6QDlP3aCngwB6uL+PzQzBKiL+xU0L7oxV6CFASpxUJmElgaoOJDKIgFxq9mgBHp+8YFYWvlA3HLhA8Ve6e29jSix1QRqq6iO72qqUtsMrSnEh4HWqW2GNhWFmj8/ULVJbRX6+N62oa+abXorCdS12/PTZr/Ttg655AZ9AuNfll2dGfE8AAAAAElFTkSuQmCC"

/***/ }),
/* 1273 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAeFBMVEUAAAD0kAynqaz0kAxYWVv/2YM7iMNYWVtYWVv/2YP0kAz0kAz0kAynqaz0kAynqaz/2YP/2YP0kAynqayAgoX0kAynqaz0kAxsYFHDfyU9cptASVL/2YNYWVv0kAw7iMOnqaxBQEJOTU+BgoShoqVUVFalp6qAgoWhvKnSAAAAGHRSTlMAIJ/vADAAUN8AYL8AIM/vv4AwAABQMIDkmT+YAAABVklEQVR42u3UwXKDIBCAYcQ0WkXT1iYFLUTUxPd/w46ZwWqKK0y3h2b8j+vwDR5YslZGD7W1A82KSaSAOxnGRp3cocw4dilzhmgNRidQD3aFoWs/tgLVK/0BhPdrGqyFoVaPrUBNBzld4wzpSwc4F+0O6abtFpi20VOod84I9q+PDL07Z6DCGimce1yIGogCkJsDSsTdgSXi6xjJH4piaS2OdtPIbqVILhZ5QfEyFHtBEugHlKTK2tkjst8HuVIYUBAqHChXOFCikKAUC5JcqFuCyzEuvqGy0mNVeV6aESmluDlyljBQqWeVtpmB+HCIzyFuoErPqmwzA8nhkLzLQPou22yDNuj/QGhPxOfRgpDvGoEhj+A14ha82NBWrTek7G3QBPpEirxgQa9Y0BMW9JwrlAhLsCCWYkFBiASxIxbEEiyIHUMkiAUpCjSU5CjQ0NvHb671BWnfQJ4UDUPZAAAAAElFTkSuQmCC"

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAADCElEQVR4Ae3YTWsUMRzH8byEfQnBV7AvYV7CXATFS04qgnXb0lq11LEPVKV0FZHa6jJSlKIU5iXk7GnOnvYdOGdP8VdJIMTNdGafnJn8C59LBrLlSzaTLPP9PVxZ5RoLme9BAkobQwox9IDNy8W3ywhi6AFroomDOoxPDkOIKkaIIQUJQydICkqTkEDU9kCuDAbQt8Mkuwf85PRTOkrP1deL7yaCLYcxqAkKyGAA/SYGEqCmUEC6k+ylCKSM3f1D9eFsZAeoawwpRI0IpCP1IIYUxlUjbT3Z1mH+9XH0eepIWtyAQN5gHARkUIByrTxa0zEmO3x1NGsg0dhALr3nDECaQGvrm6WBYNZA7obOmxfIHyxa39gaLimQTbQikIEIY1+co+O3cw+kRW0KFHsCFedfLmaOgWPD373MzHtw+Fq9PznLgC3CIia9ihRBZsJAChzMwXEI+RRx7OAuAWzenIHl0pusgKsD5bWB9MrxKfRbtreEu9jy3bp9R927/0A9295Rx2/emdO0siFCqdW1Dc91qCOBHOYym4CsEgjHDBPIJc11qFOBbAjUQ4TcF+f5i/0616EMBPDOBAL/GxI2Hz8tdIC63J9z2hvIijS2N2cYgH0dSmHaYKLVgaxQHPrAPOzrUFYzUpsDTU+/1YaQU6ByZT/nJBRocjCuMQpUwzI+RC1StwNRIApEgdTPPQESVMdIEMDKlD3kkIPquBx43UAcClCBKIDXCZSDCkxeNZAAFShRJZAMOJCsEkgFrjRQjwJdE+jm5S9Vh/sBZrzF8zAbcwcoEAWiQAsN9PLHb1WH+w+Z8RbPw2zMGWhWIApEgSjQjbunNvtZW+ehQBSIAlEgCkSB6qBAFIgCUSBNTxwyZmPOwP8ORIEoEAWiQDLgOLJKoCTgQEmVQP2AA/W9gRx5gHFyYFUDiQADicqBNBnk5lwjEIcigDgF8NqBtDiAQDGwqQJpIrR9p1YgLe7Y162wVs7sgTTekY1bAgc270CGaOk5KbdXzSIDGX1IGr6qJCT2CXnOgcgfkJnfGdssbhsAAAAASUVORK5CYII="

/***/ }),
/* 1275 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAACqUlEQVR42u3bwWrUQADG8TxC3sCAd9lHyMEHyEVQvMxNEazbLa1VS421ZVVKVxGpVpfIYlmUQh4hZ095AolPYM6exi+QwOhsstmsSXeWb+B/aUtofySTTDprzRr3NzadLItjJo6PZF6CAuQh2/qPY/r1wkUesk0DkhXFaITcmggeClCERipI/nWZFyEfuWYD6YWoj3rqMfyDI+f0w6dgHEzk+fRbgaAWowTJGaUoRH3UW0UggWSDUhTs+88DAMmig8OhfH821iHql6AAuauEZCMPBSipi7T7aC+H0fs4/twUqMhb5cvOQQKFKJ2Fs/FgoIDoDV8eLwskTJrIe6iPogJosLVTCYSWA9IndMckMHdre3fUHpD5Z1Vx90rKcI5P3rQBlOWaBOSVAKWTL9OlMbLHhmwuK457NHwl352ehaadRS4KCxgUIEd5cByhuAFO1eUrrHUb2SSLBMoeKOcBFWdOWWl+l7WtdRw3b92Wd+7ek0/29uXJ67fF07RUA0Jlm4NtbTm0VkBqymLWR1EdIDxm5EBakbYcMh5IvxxtIMRlOE+fHS6yHAqRQI7JQPXvkGjn4eO0wdpRe51jJpCOlKiTM+r/sxwKUFMwYSaQDuWgXs3lULgIkhFAbS2H0AjFBGr+Oscn0Jx/UhDIgNt54whEIAIRSB0/rl0XKEJyxYqQuEwYB8VIrngxci4DJ0XSkNJOkYozx7DiTnBuXPwSSNbt6hVHTft+x8cRrQOJyc/IVKDsd+/iDJLmAOm1jWMTqHpytl98/y0XSPvDtJ/p+DhW24NABCIQgQhEIAIRiEAEIhCBCEQgAhGIQAQi0N9vFaXBEYhABCIQgQhEIAIRiEAEIpCpQJHBQFEXQMJgIMFNnOXF3AY8ZxswN5JXbCTnRxHKPorA0f74Ax3C5a3Ew4d9AAAAAElFTkSuQmCC"

/***/ }),
/* 1276 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAABi0lEQVR42u3YIU5DQRDG8RUcYC2G1KK6DRfYI9SQQGqqcDQPgaY3qEYVRyBNKkhRpK9XaMDXAYoeYXnrXgUhJJ3ZmeGb5H+BXzL7dp8rOWfng9iU2h13T3ZyhQdAAAKQaSD/tHhO7e4fZju5/z7r17fUCkAAAhCAALTvef/4rJuSsGoAKQJKEgOQRqCX5apkANIGlHGCUKBckAAUBQNFHMh/DEAAApAtoMvRleQABCAAkYZDGl8xAAFINBA3WP7xXrJfQQAkCCjjeOFAOV8SKCoAipKBqH+QAQhAxoHGCoDGLBi3j4vE0cX1DUsUQBtDQBsKoLkhoDkFUGUIqNo70PKwF5oSdXcHRxwFRzFWgFweIqDaAFBNCVQZAKoo70LBwCEdqC+MW8VAW44b9VQx0JQDaKgYaMgB5BUDeQIS1mcHy/NC85qxrJfmNWNZL81rRrpe3EB9RUB9GgX+SyPx5ZAfaKIAaFISqKMAqEMnwH9YyzucT2dfCf0cgAAEIAABCEAAAhCAEIAARNA3so37fZWjECIAAAAASUVORK5CYII="

/***/ }),
/* 1277 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAACtUlEQVR42u3Wv2vUYBjA8fwBDllcyw1uRQg4KpJZsJ7DieUUIoiig8Spi9ggWMTBVs+fWPuKoB1ae1CxFFGiglBQiGhBnW5xEJEGQXBweHyeI/DGNl7yQsld8zwPfLly3NH2w5O8sWRkZGRkZGRkZGRkZCo8T642PGwSC7E25mM1i/sggo1FGGQUYy53oACDHnW4A4U5QCBA60BeXPfg7Z2z8P7uGLy5dTrmDqQwoJZbTXjWOgpfZi6kC7kD1bAYo43RMDplcZ/XN0/Wn147/D+gwOI+iFBfnT4Hn+6NywalZ2yxYWP+RPtINPXYA2ph9gx8UOMxwoSYwhyuOAEWY5BRjDmctybCIKcOZgtO7yZ5ASU4Jt2eO+5xwfFNcabnTnRPsuj+ecXh0ooLoDiYwuhEI5x0HczjvD1tK5mL7ab/UelnoozC5DXG3CpsT6cAkL/u4dHRELq1R4cA5nd1+/Gw2d2sKjzvQH76uScDKiCIn7MHExwdbdFWxqkVvPfkbgFiKCwLyOFwrNeNcHRb+zlpdMJ1h3ZuB2rP6HBmw+4QbY+H2YY4lTj6PQwKFmMKcwcS59fUtgCDQenPgx1ZMPR+Gb8/2AAkOP+2AUhw8oECwUldYnnz6tQBH4Oy+tbam4lD75f4d4SWydAXGOFQyhTIxmImOJS+tAyQXCY4lGumo5F8BjiUY66jkVTFcfTRXjbS6qUR+P1yP8C7pJV9AEu7BwmHiiyc0pE+XxkhlKwIyRin/yeY+T3JHEdvksbpf76ZQj5SDVM5OHmVjWB+gjXm12Czu7G8WASHos8PdFY/cb6vHOMCZI5DXV56zgaI/lkTHMKk77EBosvFFIcPkLfw1RRHgArgyCVWAEdu0ikczkAaKb1J9HNylAtQjwRIgARIEiABEiABEiABEiABkgRIgDazv2FxKehLcpTJAAAAAElFTkSuQmCC"

/***/ }),
/* 1278 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAEtklEQVR4AezBgQAAAAACoP2lX2GAKrwAAAAAAAAAOu7LP7SNMozj/UOogrIOhjDYZoZxuMx2lWqWtaaeTdfYZkuGYhWZtlAVBx2NSGb3QxdkPxBZQ1GZ2mLmTGWLncVVsay6zFirlrlOsegEiWWgImMZYzKGyOP7hTxHeC9vLjeOLPjHZ3u53t17+fB9nnvu1IZuQVwwKyCbyQpSBYgyuf21HA5BVSXAi7CAKhSWGcuJ3AiJZRV0abAjWmli5qYilPzsHYp+PE2PjF7Qj19KB8i99l6ANQsck1LosFXQr3Wtjt872+ififUVI0SGz3t3XwutXN0AsDa7byYvfeGcvBqrglhSVEB/bfbTlZFAWeW8MXEMEpT0JH6hLzaHCISaG3VBWH//ckjnt6EggfNHg3RxPFhsz9mcNK1UQSwpLiAw37KOzj//IGRdVzng/e0vsCCWw/BxJd9GWJ5SWqpYqgwHfnJp8bmV90OSTsazjv7s8tPFfe109cNAWeVs7XmNDt6wjDEISjpr6aM1a+gTn5cmO9tMhX23M6Tvf+q4n8JvemnTYJNMTFAF8I8B8SDxD26+g1KL76YfVnhZlIkw++U8eeBHGlqwSpfzVvVtBkE4LnN4qYvGvY0FhX3VF2I5LENFjAUpJekb3nQ7Td66mmaWe1iSQRh6l3gbltzoZ9K7KH78MEWOnVEK2l/3EPa3JEgmsdCJhNHnm9ohiH4eCGJ/To4ZGgtRSQobNqx20PhCF00vc5Ncivn9y4qwyzOPysLk0mKsCZIYddXTlZMb6O9v1puJYeIQYSZJE2RVm6IU1eliYdZKEsLOjQTpzLNuOuGrpdGlTlsE4X7yXii1HcPNKkFZFmEmqUaQKuUhxhbcid5Fp51NkKMEc9eFF9vp8lAH/Zs2T9nVkx30x9sP0JE9GnV1NlKrz01+Z13JcqZC9cp7F+tHajGKkpPSZJswThmkYbRQSlOImx9oRkL01E24XQBiaC7iKXYPlJwtgliSY+TG5VKarAnjkjy7qoUFKZs/koZ5DP1MFmcn1nuQCSIR2pdL7sl8uuguNO5rksVvSDT9Eys0Sj6xm6banmJBpiXKiWN51/ipBOksZFagCRyKOcg64mG7BRnMS+klDfixloXteGwvPX5oHm8v2u3rReMniOfSVCdNWa4QyOmDRCWQjKT27rkPglLy7+OFbaL4IUsRhjkHwyDEAEhSSMQ9uJ9hxLAuzoSd/V4IitoqSCFqY/43nSwMyXhvUT3mHBbDIEksRCl0V3Ab4AmbxXHi0Nssy8O5/Vub7BdkIqoml6oxATGTwT56ZvisQQ44sNhjkPLK2i7q7T9qSaY8p0EgkgyB+eBlgb/hvC3bPBCklU2QzLSvu/vV7cms6rOi7/XTmMyRADw8ehGXX0Hw9wJCkEy+Dv9DLn+yKBm+xQE510+QeFhNkCn6YZo4R4eeHqDBSAJrxXnqXoX09ez/WnkNkqgStLe1lgVVyZRDTkxAdsJpQ6850vAwPbfloOk16FuFGv9LAZajEISL/+8gcUgQSg1gjVLk0aIYLOi/duiYBgAAAEBQ/9bmcOOgAAgSJEiQIEGCBCFIkCBBggQJEoQgQYIECRK0Fp09lKeu6OrQAAAAAElFTkSuQmCC"

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAATlBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzNGYEBkkU13slV5aj3KpUf/zE1tLzmwLkDdLkQzPzdomU9EQzbXr0hALzW7LkFyqlPywkvSLkN7bBYpAAAACHRSTlMAYL//ACDP71kzCuAAAADiSURBVHgB7dZRkkQwFIVhHDQhhEZ373+jk0mlUm5qal6cp3a/BfwPiJxC/UcppcoKF1Rl7RV13bS4qG1+Q80Dlz0aH2pB0NZFCYqyqEBRFSC5R6jrjdd3EIbReuMAYZqdN09/hJbVROuC5LnZaHsi2Q8XHXseWl4meS2p87bJO5X2j0s+exZazcmKaLMnG6LDnRwy1BmhQzBYYUAwOWESod4IPYLRCiOC2QmzCJkMAptB4DI3CBEeNun1sz5I2hGhHlr+b+SCG4RoFyTtymaNCNqsYQ4tjzP9SDSkIQ1p6OtCP5OHToVK/7hIAAAAAElFTkSuQmCC"

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAV1BMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzNtLzmwLkDdLkRALzW7LkHSLkM0LzR5aj3KpUf/zE1EQzbXr0jywks2OTVGYEBkkU13slUzPzdomU9yqlMuNzVw+PELAAAACHRSTlMAYL//ACDP71kzCuAAAAEaSURBVHgB7dhRjoMgEMbx6lSrSFeRVpHu/c+5PhjjGLfQ+ZINyfo7wD8RHB7mcizL6Rd5dj10uR4oSnqjLGJDxY3euhWRoZICyrhQRkFZVCinoDwqRExVq1ldEfNxqNFqoRsk1NzV6t4AIa02tDxUKaYSh7RianFI7UhDX8mF8E/DDxu4fuCHBEYkgaHFn5GQM5R2qO3MrGvBUG/NwvZIqH+Y1aMHQtZsWHmoNUwrDlnDdOKQ2ZGGnmmE8E/DDxu/fvyHxEcEH1r8GfmXT+0ZGkY3GwcwNHm38BMSml5u9ZqAkHcbXh4aHDOIQ94xozjkdqSh7wRCwKcBhw1fP/5DJjAiyNDizwi+ZMHXPvgiCl+N/cmyjvt8ffgDp4RsK3SXCD4AAAAASUVORK5CYII="

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAAApLzMpLzMpLzN5aj3/zE3/zE1NSTdNSTcpLzMpLzMpLzMpLzN7az3/zE2ZqrWZqrV27YStAAAAEXRSTlMAYL////+/YAAgzwDvz2D/AJllXAEAAAC8SURBVHgB7czNagQxDAThsjXajN2Tn/d/2jiwbA65LLgJCaiOLfFR/ddaj6+O/O6I1XPr7eVccZ5jxo6z1jkkNK5dJ+IaQnPbWU3RDM6q0S1OdDxOHJicxOQkJicxOYnJSUxOYnISk5OYnMTkJCYnMTkHJicwOYHJCUxOYHICkxOYnKB7nE6zONHQdDhTaFz7zjWENF53nTkktHq77Ti9aYXuvT/6eKKf3zxOfxoqqKCCCiqooIIM/TJU0Ce0W7yCpP/xXQAAAABJRU5ErkJggg=="

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAeFBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrXdLkTdLkTdLkSZqrXdLkTdLkSZqrXdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkSZqrXdLkTqWW7nTmTfNkzkRFneMUfoVGnoUWbfM0nkRlziPlTgOU/jQVbmTGGra+nCAAAAGXRSTlMAv4BAMO9wz98QUN+fIHBgn2BAj7/PMIDvivkXcgAAAUlJREFUeF7s1MuOgzAUg+HZAmpEKZDIgV7m+v5vOMqy8kEaW7OsH+Bb5FfO27/vtde6tOCPW1J37PQFwkp/5GSIy7GTIC9Fzoq2673yjqU1gGYAt0etEjSzcwKArYoQTgSdAexVhs5hsqsO5fCJfnSIH2kBsOnQQlDjqw4hinbTIc42AfhyoCn4H58OlKL6DpSF+hVC/6HVd6Ahqu9A4Bvy7kEr1/egiaJ96xBnu7T6HnSh+psHzVT/4UED1/cgUH0XWqm+CU1UX4a4/0j1BWik+jLE/QuAuwsVqm9CeI626xBn66m+BPV0sE0oP9X/8KGR6pvQTPU1iPt3VF+D0P22R+9GAIMwAEPFz1Bw59r7L5olVKRAA7xGAIwSGkAYUADXgC6wDWgDpQTTgSbpQEl3oE5zoMZxoENJ/RBajrMIBwpI4dtJjF6vD5KeXiuUFGbDAAAAAElFTkSuQmCC"

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAABT0lEQVR4Ae3cMUrDUBjA8R6hR8gJRDxBhw6OTgpOAaHgIMTBycEO3sDJySO4uvUWbpIj9AjxK2R6BD98DqL5Cf+lJcsPfOl7+cii5m9z99BF+2gY24+fLf5bNRe1I8pU8R2gfgrn5vZ+eL7Y9B9H623URk20+Ot9+4IpnKfL6+H95HSI78t20WrWQI9X3QEiq4/aWQK9rc9ToAJqGy1nAxSf1bQfoRpAeS9RAyjvNVoByttFLaAf3/kAlQv6ElACVSzogJI73zGgonQrAyhf0AHlUF20BFS7lQE0vZUBlNcByjsD9HU7QID8i1mk3eZ/Nz8UbTVsVh13ODBz5OrQ3mMfDw49eja8YPzFAFX1VsAIniFOQ5zFGPAByhhwiVNkkBwQIECAKgMECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAfKKrrEekJe85c3pNYGfHEaEw5YhgKMAAAAASUVORK5CYII="

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAVFBMVEUAAAC8vsC8vsC8vsC8vsC8vsC8vsC8vsC8vsD0kAyvDyjqWW6+Izq8vsC+GTHZVR/xiQ69V2f/2YPUOVCgBB78x2X1lRO8n6XqehO8qa7BIC/1mRsmUYgGAAAACXRSTlMAYL8AIM/vUN+UNNCLAAABKElEQVR4Xu3Y226DMAyA4UChwTlx7HHv/56LLG2pJdPFAg2pyn9XX3yC0AsrilbVPrO6OpHU64+m9YLaZg1qzl7UuVmBWi+s5aEKgcfowp+58YFSxUJ4zjdkMqgbnjgL4fOgkyXhM61CY8hufAu5CJjlN4MAP3NvoRBbXgoYPzsEMgxkRNAPMFs7czMxZGPc7BOhAhWoQGZZDIHSTARhs00xs3zIMpA9DqKvMXOzDCiv/4b6AWDoN0PPO2D3rVAP18s0Xa7Qb4QGiE6UYNgIAUzYF+wEAez8ascfdqCf//g/JO14KH+rDR+/1ZattkAFKjuk7nxKtEOmOn1SOiny1S+lVbcP1ClPcvk7pPMkAgkvWUjk1cTXPqmOHLbsIoqkyeeXXY3Rz/8Nf1Pkv5YRNEoAAAAASUVORK5CYII="

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkRtd6VRAAAAEHRSTlMAIGCPv98AUJ/vQK+AzxAwkHLS4wAAAdxJREFUeF612Ouu4yAMBGDsBAcT0vr9n3albqVjL4Uye5T5WamfDOGeJiHe9mzv5H1jknGSDHKUbF1yOTCINrVBdKNlqJ42zVmXICr2NYW+Q01tIdq+QHTZYi6aQYfacvQYQ82gtBFUDEzx0NzZG9dXuO1zKY0d/XcYH0XHUhr1T2b5EM59P0XoiIyyDMIapSNCpF3JozxKgJQCdA0av1DU5aFmhkjPILUfiNQwia6uccl9eUTSUPwbqhHAW1ff0Gm4JOyg8y9EZrgU+4Ne0OZnxbr0cI3bXpD7gQWQ2BUgkvzkyCKIlP1ESb4GFkhiX3hyropgkrq2JPIsIsXiKbFvKCb57uXkPr4IKrkBkH6W4l1gyf05ZbccQFJcfnLyHx+WXAc7qAos1QEESDPoKYA0rwiWngMIkICKZtIcYoEldpAfkJgUB2SYIrDk/hwmLSbFSRuWEVCKywgBC9hkBaS41GJSXGo9y5jETu62I0SK21HcIAHJF6Tdlv0ApG7LJvTU0If6Yw3/j3R+OGjpE5esfjr6KcFS+XwYvVBJaXA8RlvXhgd2ZUS6ZleIc308Kd1wqfnVNeuGi9+vrqL3Xo7x6/q9Dwj4k8btjyz4s8/9D1H409j9j3Ux0PPhHyMI15Y2HHRLAAAAAElFTkSuQmCC"

/***/ }),
/* 1286 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAWlBMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3M1t3ZnoLZnoLZnoLh6O1mdX9mdX9mdX9mdX/ZnoJmdX/ZnoJmdX8cfJFdAAAAHnRSTlMAIHCvz/+/j1AAn99gEEDvMIBg3////99gAHBw7++14P6XAAABY0lEQVR4Ae3V23KEIAyAYVGRDQLBdnuwh/d/zZaEjtppZ2ri9KL1v+dbois0Z/8n03a9fW9wF+AaEGS8XRqDGGrttiHKIG8/10cJFHgglyKACR3vSQBFLCtb+CjTQ5/2Q1NZl9dykTDuhkb6/XWZtrgT4lURNrnyvPdCiR/tJlPwRvCIPFABMdRxBVC7QGgtAjUUSDDayG+rDASUF0C0PNW9VRI6AURjoEvJFdFLR+PZlgxQ/NYU32wA6lI2uR+CCZnBsJrWCyCIwQ9D18b1sBeGNMWRXp8ainSMJDWUyelAC024HLWKTG+ro4MyLpeIBkrk4ARUo9xPb0AJxbF+tVrIs6OGMv999JCny0wPGT5F9BCfs2qIT2mnh/gmS0dAfBX9Sahe13ooIAY9tO146Ob2+lV333a/7uFx5ponXieBuOcKvWih1wpdFRB3Qid0Qj+B9B/t0cfIfNTBNus7od+G3gBwAPrpoPCkzwAAAABJRU5ErkJggg=="

/***/ }),
/* 1287 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAilBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkQAAAD///+KHSu0JTcpCQ3f39/PK0AQEBDv7+8OAwQgICAcBglwcHBgYGDdLkRFDhVvFyKYIC+mIzMwMDC/v79AQECfn5+vr69hFB6AgIDPz883DBGPj4/52NzfO1BQUFAOqFXRAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAMESURBVHhevdjXbuswDAZgO6OO04T0ntm747z/651KIkxErTUu2v82wIeIGqYUGBJOprP5hjKfTSfhy3iCsR+ixWBw5ovIDwqn8WYk8TR0hpavG2Nel05QuGAgTXZvlF2SMrUI7dAqJqRItjU8pd4mBUnxygKFa2IOW/gx2z1R69AERVTjpIXRtAlVPRqHVvRvMjAmOyhqNQapKhc3sOZWqJp/h9hJW3BIm+pSoDlJbQKa9xy/8ujKOmGJIa7PHkzpK6TkR1DSSociWjyZyUFOdYSblKJnKIw3VqmpEPO+BGjuiHgC9Z/i8AmidWiU3hHzUpn/EPFM0pogLlBamKUTYg+UC+IFoE65TMEwsKLNzFKFeAQ45vlR/qUTALTFMLhgmPkbgFl6SOiOeAdoEFHgN7UGCFoK5wBgka6I16bJETsJVVKXu2VJkDzHMrBIPPsNDU0kE9CrgkLhJABW6aqcXhX7XTg0c6GEpgJqwUHqH4jXMwCc5fTLtAKaSiimrWGTOGWuRjZUKRZQJMgteEjnCsUEUrZqowRy7gsAd+muCjVEjGDxBc2p1K7ShR0u9/wlCGlkdomdx5EMHlsYTARUg6vUIeKlfKJrIUwCMfkpgFXio+Sq46lYAMGMSuQm8VGiFWkWiFrvwFWquM6cnah2IAbwBq6S3PR63oRBkKtU4ckMuUrNubRBzqMzQ56SP8SSO9Tl+FM+PqX0+UEThip5PwZ1BBgkgiidBtGChAqt0jNUaQuStkiJaJcIomhbhDYtQWYp+wbxph2OEXSQikyH+BgZDjZ0kzSID7bhqK0cJb3YdNTy4d+hm/ShTz8d/vw56nMn6VNJea99jugDeQCO527Z0weSP9n+En+y9SbCX+Imgtsaf4nbGr3R8pe40eLWz1fi1k9vRj0lbkb19rj2k7g91hv2BPwkvWGnwflLe75C6Jeam4dEiX6+ZiW+0spw8fORFr9wFf2Fy7H/df1XHxD0J4392JPGwfak4f/I4v/skxmeff7iIcr+NPbXj3Ucr+fD/7cmQpg9nky3AAAAAElFTkSuQmCC"

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrX////5+vqfr7rs7/G/ytHGz9Xy9PbZ3+O5xczS2t+zv8jM1dqmtb4mhnxzAAAACnRSTlMAYL8QAEDfUO+AOe1yPAAAATdJREFUeF7t2MuqgzAQgOGoMepMrl563v9NDymlhI4VOhnQhf+qq48kklBG5ZoWKmqbTmuttO4NVGb6DA0g0KBVN0pAY6cmEGlSRgYyCoQ6A3IPi2gfrhZyHp95Vwl5fOXroIDvQhXk8Z2vgrBIDPq73IrEDvvcz0+X5AWvyPmXNiT8yEYG5GbcKfwO7TqYCMRxcgRiOBxoRj5ElzFzIffhgAw0A4hsbQYeRLsh2pIQ01IPLfhsqYYSud1MCF+xoRUxhQJ6vYzrzxDmYrm1iLkvkD2GbHnY9giKB1vLlZ8fc/tbS+Ho8d874vKw/bZ5cj4caAPYJKCMOikIrgTd0A3dEIkJWeokFhQpFDgQ/WNuY/mer8Uv0gUnEUbGaaXGPo3QIMpIjcZ6mWHdOOgMaV03PjRTHh/+A+Yq0BHOxX3fAAAAAElFTkSuQmCC"

/***/ }),
/* 1289 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAh1BMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkQAAAD////PK0AOAwSKHSu0JTcQEBBFDhXdLkSmIzMcBgkpCQ03DBHv7+9vFyJhFB5gYGBTERrf39+YIC/ysblAQEDPz8+AgICfn58wMDBwcHCPj4+/v79jISkgICBeeKUZAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAL9SURBVHhevdhrr+IgEAZgsNa2WqFX73fPfff//75dOOibMlBqTJxPJiZPYAboAOsJPorG8cJEPI5GfOIP5vsjSe8GIk6TxyAeZQtPZBEfDE1ni96YTQdBPAVQV7uNiV1Vg0p5GMozgxRVW4pOlG1VGCnLAxCfG2bZCme0S0PNeR+UmOFUK+GNVWUGlfih3IxmbQHN+1bK7XtjqLUZVe6DUs0Ue2E7b1LH200S+0JLKYXg1HRW2tES5lfbErOcZUmcg7zHARWsLIlZ+VkcXQPCkBC/Um5DiULckkRIgRA7LSVdiGcLSD3QX2GPKeMdaK7zAyk4IkhzAyFBdXmENAgqa6SJ3SdWrISA1JdsxKq4T47dK6/WIaTe8iP2eg3coKlOkBBEoguShM7r1EAzBa0FlegWIbFW0OwX4sqpjEMlumlp5biGIgWthFs6nKQV269uvhUUaShDhmyp+QDgS/lZFU5BiSJb4ZScjjx1oPZ3ozBd+0IDVLoA8C/LQq8ANomR6qESTXc8YRwzGywJOjfORgoqIdzScoEUgEoljJgqfg2nkZJIAUiorRuxMVIEKCA51uSYqVzvBOIjLAHCURkzNfoNnHDGKbRRBqCA9BwE6VHo89qEpTD0qQ6e966EjD8A/UgV1w4kIQ2HFGMPSUJ6FoLUB2FB+qZGJPeC7GyR5r+0PXSrJ6m0dW0Ra9PS6kkqfbk2rXWM0ClKWzodhPMYoQcbkg7o7frH2RfgYMNR64XM6FwSjloc/v1TU5W4QKKHv+tzhOoB0iQk+jm6fSDPggaBINltREY/2VhDFKISPtloIsgaohCR0ETQtgaJphCR0NaQRgul90DyCAmNFm39wpCAhNaPNKOYmh+ChGbUbo+tNeSBIKE9RsOOyiE8EKQlGnZcISAFIUhmYvRSsxsAWVLivmZVwyBIue/iV5XDoHKpnTR0FfVD4asoLsdhCJfj4df1b+V84xe9rj//gPDck8YZTxoveGTxPfus6bPPKx+iwk9jr36sQzz0fPgP/BkuMnDruQgAAAAASUVORK5CYII="

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAATlBMVEUAAABVrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO7///9VrO6Vy/Rgse/V6vu/4Pn0+v612/jq9f2AwfKf0PWq1vdqtvB1vPGKxvPf7/zn2ibSAAAACnRSTlMAYL8QAEDfUO+AOe1yPAAAAQdJREFUeF7t2N2KwyAQhmGTTEzyjfn9abv3f6OLUNyygYmLQxsW3zM9eEBzYsb4ipITKouKiAxRbTkxW3uoYYUaMlWrAbWV6SKBGRgFqTM2EgIAAbJGAvoBz4beQ6/r35IIDQh5Aq/rP0EQUoNu7zua/mXLn//SUIbu+zBBbIyB3ILzzqG7ZxQgB6hADjrQCiVoUYJ2KEGLEvRAdLMIjQhN28piIvT14/TMCRBCjpWgVQvi/wvdLnK0Gc/mBEjoA9AYDiPsRkB9uF5h9z2Q/Fj4IJShDB27IpShDGVIfhUvJ5CN/QFxolMexz7bhGOYNhYrlAZRVms0VusM69qGPESUNj60XUVE3zgo2fTja3DPAAAAAElFTkSuQmCC"

/***/ }),
/* 1291 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAjVBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkQAAAD///8OAwSKHSu0JTfPK0AcBglFDhVvFyLdLkSmIzMpCQ2Pj49TERphFB43DBFwcHCfn5+YIC8QEBDf399gYGDv7+/ysblQUFC/v7+zcXlAQEDPz8+DQUnSkZkgICCAgIAqib6jAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAALHSURBVHhetdjHluIwEAVQCWOMwZScTQydJob//7wZiWqM9UYUXvA23WzuseoolKTuRE+iadxx4mk00bNw1CyQZB53kHiejIN0lHaBpJF+GFosu7tZLh6C9LwHyqI9cNqi7Km5lqEsZaQqmpwGyZuiYinNBEivmFk39N80a6ZW+h6UcI2LmoKpC656EoYy/prNANgacxpQG/6qLARdqlztaRjzLzTMvnLSHKHeKWvi/DEu7s/n/8SpS19SnrPOifNiMP2X5YUnKa8+3U6EOBcp86HEIixJQ+O0TkqGkE47kALF9r4p1QNo5eoDEkIorRjqC1TmO0+SoLzsy6SuA6tqIk+SIKqr6+DUdQbtiUCSINpf5gBDC1cgIpBkiFxdFwwtLbQhlH4fv5pQeP1tLLS8QNo6BZEvvWzN3dzMAe2gyEI1gfTLPALVFooclHKFQPp4BKKznZUWSizZUECSoeayUJRb9RXReIk4lZsBahZzqUdLtwslnikNI7P58iFKW7odm1YTC+U+dDKf0rfvJCS3wkRFdrmSnx/mKu1Iil26kZpCiXhZyNJtkabK1rpFaIzU2morO4ADQmOkgzVCkCCNhcxPQRIhXvhb2J8kKBhBkiBZkqGTHRDMcZAEiA9qGvwWJIZ4Qt6FDI4OJyQsEQf5v0HCJcKLVoBAwkXL24gAgYTbCG9sIhSWeGPjrVaGUPK2Wt78RQglb/Pn40iEUBoeR3xAnm8gDIHktREpHNlhCCU4srmJECCUoIngtkaAUIK2hhstAUIJGy1u/UQIJW79oBkVIJS4GYX2WIBA4vYYGvZCgEBaQ8NuB8fSKzqvFJJ4YHipaYneEHqjO1KC1ywe3fF9yLwficJSFrr4FTk9lHwNFz+8igqBq6h4Ocbg5Vi+rmPwuv6MB4TxTxpneNJ4wiOL+OyzwWef5z9EjX8ae/5jHWbU8+FfNbcsEM6g+okAAAAASUVORK5CYII="

/***/ }),
/* 1292 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABGlBMVEUAAAApLzPdLkTqWW4pLzPdLkTkRFkpLzPdLkTqWW4pLzPdLkTqWW4pLzNmdX/dLkTqWW4pLzN6aXXdLkTqWW4pLzPdLkThOlDqWW4pLzPdLkTqWW4pLzNlLzndLkTqWW4pLzPdLkTnUGbqWW4pLzNKLzbdLkTqWW4pLzPdLkTqWW4pLzNkPEXdLkTqWW4pLzM3MjdDLzVmdX+qLj/dLkTqWW4pLzNpPUeJLjzdLkTnUGbqWW4pLzM0LzQ1MjdALzVWLzdhLzhlPEVmdX9xP0l1bHh9QU2DLzySPEqWR1SaLj6uTFywLkC3RFW4RFbHLkLKOUzSLkPdLkTdVGjeMUfeVmrfM0nfNkzgOU/kRFnlSV7mTGHpVmvqWW7Qk75LAAAAPHRSTlMAEBAQICAgMDAwQEBAUFBQUGBgYGBwcHBwgICAj4+Pj5+fn5+vr6+vv7+/z8/Pz9/f39/f39/v7+/v7+/AhFTgAAADHUlEQVR42u2VW1vaQBCGJ2AqxkOxAm2sVaiUghS1Fmipq1jxUNHWNpXaU/7/3ygzmzC7IeZZ8Zb3hn02Xz5mJrOzMGXKlClTpsyWq0XXmYEHUxWSB9u1hUp1GSZlTejMwqS8OD/qCsaBibFrnnfVP3+7gz5tK1YzYxZoyRtSA3CW3dh6W64QLphQQ6fMHf2RL9NnMMsOjdYj2eRd161WRUAejKhgbtG+0DDssQKGBBpCow5mzI8bLVd3BJO/j5ENOuve9VXfLaJh2/T0ZNAoBTrN4V4FGOOICjF7K3A/Vrw7aHKYxr0dzyoYweWIhRveuNZ304Bk0rnNbZ/Y2pjDzDpNei2sSWrkVNC1oJPb95l/N0N9KdPB1ypq+R/jVuclake0nqVBYcFX+I0vzQcJlnggNOTR+eXrtLKgsBUJ6PZ1GqMI28kOVg38/etH2FSCyg4ujg/FkMPjbyj+42+nKQBqQrmyIfsRf29+jLQXAzRCbYBVFCFd1N7Kp6XwizdormSDtPuCORmoTovKtOmj9As9lYPJ62QyFNnc/jDvn7g8EszhJRutCaYr//IMnTYgRUVpUmSP6Jt/xuX1gVA4i/jsus6QdyjsCum0AKlRk1ee486ZjPgDad26IN5In0U58xwe11QDjHgLANuJeIo+l0IcfFdOirMrkEWqM9WnaCnH9RXlPvBbOT4vnYWW7w/wY31ST4pVHF1/tCqq90dJ7r3PcVNTY+a2T0hb42mlvG9RXpY6P2xIU8Th5qrs9EC7m7bppIwmcV1q83TDawFh7jzhZQ80cRFqC/IqRlhbpstFCyj8mzIgS3u93ulXvC5Z26AjjCvWYqldPSDExRKST494guuRNkPlxxHDWopWC4jjxcWeNDr1ximpuWlGylMnrHYvwIsh0chWHs5MarRKt4RhahEtF5CJK/YSrpO0/EmZ8c+/Rz6JWm5IhptMJ1EbOSKRto8gtRCr5UPH8J5OkjYyRqKjIUqylgebxKnzsNJI1vKorWvjcw0iGGjpKRPvY6aV1xHTHsvLVMsXJFdTw1xr5ctt+oNyftzGQPsf62udfc/sEUcAAAAASUVORK5CYII="

/***/ }),
/* 1293 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAyVBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkSKHSsAAAD///+AgIAgICAQEBBwcHDv7+/Pz89AQEBQUFC0JTcOAwQwMDBvFyLdLkSvr6+/v78pCQ1TERpgYGCfn5/PK0DqfIrysblFDhXjVWf98vPfO1D75ehhFB6Pj49HGyGmIzPf398cBgn0vsU3DBHmYnOYIC/52NzwpK3ul6Kne4HCgYlzMTljISnob37ioamzcXnSkZmjYWmaLToGB0XfAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAQASURBVHhevZhnd+owDIZjKE2gkL3Yu3vPu9f//1EX24pixQ7jtKfvt4J46leR5NjWFrFG86g1BrWOmg12XC+r7gvbEQyqlmMfBmLN9rhG7SbbG9Q5GW/VSWcvEHNKQN8dPYFGbr9EOWw3qFuYWrlnA49ocOauCoPdHSDWA8zdmWfU2R2gemwbyIbluA9erR5cWJRdD+rCambeVs1gVd06kCNzc+3t1LXMlUNBlNMnrmr99askq8K5G3h7aeBWSFYlP+O5t6ckqVsF2cA5gDQSJJuCmNJbpz4q0ADhsLKmNiOgnsiPTqpgogDhSOoBqExQfzBHkgk0jCecPVUy3i/TZKGx1aaaKQmshXEQBNNpwY7VKlihOQsrSNTh3JDxxCcKSWXKGgBQRySIc4wkykk9IpHXDoDEHJt5daTF9F4BxRQ0E5NOgpjod+CY3WViLRyYhKa6ZALU5KAHbxtpyUH3kbHrOKgpQG3IEOqHRkqwPHW98KrkINEcdB7+wSqgGhpnpmwUS3T9igZkp2ZS6pnEa8nZgFoi1VSTGlJcNwZaxxYDZ0SpbyYlYZ03ZjU4aEA5oe8LEmR8KlzF0GiaBpzQsJq8XSlH/uZ7QQrBVMpJuYHEW7dpHSkpiuJJgonFevoNHTaU5iAmmcSRkqQji+d6JDFLX9E0QtIpWAr8ipYRjsqWxSOfOCevdHmSK6SFWDD0HInZ6IkzEHTja7opSdLFxBBDQchJgyxbEBJ2C8YkQbZRkAKJgnKJyfCZybBcJeWVTskgRgVFiZI7zkhl5pPI+1uQeAztlCJGAS0FxxMqygY+S4rK/CZipmqnQEwJulU7MpZlAwW48NVuSb0wUToFYm4R9JWDMuW7FMci9/MLSZlHOgVivnKGKMgvaBydAVLoZl64w09zdUlfeEGKFlnj+ENnaiUPSRUM4Sl4GLPmLSKa9lx3Bt5A+lRZKt7OedPKMXKBoAidIchMKkEXcowwDnqkoJCCKEkDPXICk6N2zUFoOsCgehLGyBS1YPhf6nsNJDLBHUmZmTTmEoa/Lb2lhIF5n+B+4BtJqXRmFxvkT+GNKiPdEPuUhDHPsEHCln1Fl4SVh9t05BMSxlyVWzbjoDWWBm1I8rdGWspUj5nyWvMKY4SOCPWThJAg5pVzTtQXrWccbGRoKcp9QpIxz/iihYeHNxi1dIyicNSS+fTGOQ59Gb28Mgx2jUQr8+qSvIzC+eH8wrDVUOUJIV2c4ymCvLCvtc1PU0SenUhQz3CE+Ee2Y024rSMJjOmHmpG3p+YIss3HLPdQUrfu4Ofue/CTJyDnY4+i7z8cf+xx/f0XCO+70njBK43PuWQxX/vM9Gufz7yI2n019umXdaiDrg//A0c2Za/1aEkqAAAAAElFTkSuQmCC"

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1296 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAADv0lEQVR42u3YT0gUURzA8Tl0jjnVrTbo0go5YRaSyhBBkFF2kcKEhf6YSLFQmCxWi56kYiGCbm6FWBI4JBgZ1BQYFQoDRYcI2ugWHV7XiPj1+8k+GZ/jzJsVCt9vH3wvFkvv05vfm9X6V+vP/PEMlsd8DCKqYEXMtrit6sZBM4F1coGxsQCDGnI5AJUwqLGK6TiuDsSPmfPwbXJwqe/Tefj1ukf+ec5koHIczO+33fB1ogCfxoYjIyga6CYDiVVw6IRInNh+PjsHJgNBVLTpz/euEUBi9MiZPoOKNGMoemS+jF9REJKzTF/KhutAEUD+GoB8DkC5NQDJa954pKAGnICDjQTKYCIFjsAybIAkkuZJCtjhqDMpZnB7Vn0tQbnvrw/AVMNeuLthi0xgJcy2uK/5wT73weYGCaMWWNwXIpQxiKnIGSeDQUICs+unJ748VyChCeRxxHEw0I0jUB6DFLncgEphAOVFsT6HcMO+3Dy9B4VxPt4eWgHkNbWJhVsFmyUQvUWHgfDlcQXQw62NgEAlljfY82Ody4DmTveoQBQBUS4XIJDRiQkDzR48FAk0d7mPgHxWQOMbt68Y0I+27YoEenG2RzlFDIBm2g8sw6Fv9iqM7EnHYQnksxnSBBIGetndtSrQlLOPcGQZ44Gmd7dpP17UxKZsGKhkOlAZT0/i9a72bvSSBKoYDfTh5uWScnrofUgXSOYY+2tWFefNhVMEkJSEkeVNxHEwoXy1oK8btQB5puNQdNVLgLRAvkk4RQVGuda1EgoQmAQEaguF/iAFToA5nIDK2d47GUxgsH/0VVKuhQtRwqdImPqIlehnCENIQLWPzCYB5atAOUxUy1mGLsJxMZC1DD1OAipbjBYB+WGg5oHJJKCAE04Og3BO/n4SEHDBsbGKCqQ7qDkAFVWYVIPa5BW+1mX1Qb0cqKyipBzUArNZXOuU5qBWC0wF8jBIqCgh2D1qGjgVzMbNe5pIOW5AixvGjTsYaOawAQr/XTodmkACs7kBSaSyJlLAEUgiBbpDmyuQjQndoc0OiNHQTg9U49D2mAHpD+3Wi2Ow52QBdjQ2FbEMAyD9od3Se4Ng1EqYzQ3IxoRyciSImsAcVkByaEskd+QpNDS3xuKwA5JI7vCMv9M9EovDFogWIgRxOKyBqjcVRORyvOZVnMwqOLl1i0P/s9muwSB74iosdrQfsh1nZPQzP8VnlY3AoX805mGgmav5uWJd49DLmRygKQssjWXAyZE4NWWnAMqt13njRwSauRqfX/kfOH8BlEN3qqnlovYAAAAASUVORK5CYII="

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAjVBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkQAAAAQEBD////PK0AgICDv7++/v79TERopCQ2YIC9vFyIwMDDPz89FDhWKHSufn59AQECAgIDf399gYGAOAwRQUFDdLkQ3DBHysbnBKDyPj49wcHCmIzO0JTdjISmvr6/SkZld57MiAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAMaSURBVHhetdhpk+IgEAbgYHRiNNOQ0/ue89j9/z9vl4A4+NJGy7K/WvWYbkjTIboQohf3By82Bv24J574iLgfkqExvBgMk9sgEacvTKSxuBoajX3g/d23xqOrIDF0wtd00ZCNZjH9ctRQdEOZTSpfLghiscxtglkHJJ7ts9TERG2f61lcgpLUMK90IV4NlSY8lJmkauqI2iSYcZCp8mRPnbGfmJojdHJquipqIwHknClhSEkYTe5LkVef0BPN5krNZ5yUnUOJYVAqSvU/ygKlfSslPiTSF0ZaqTZWXHap8KDntj4hqTRQSSGp3Zm/oczkVKMklQ1+7TIDucQmRCB1QTRxyUXHlc/3BBKkFi748AiNbDogQbGZ5EYWGuvWQ4QSLj+GbgZjAwmNvhInzSqlqhnfC3QCooXi0wOhtK5MavPDpUeKWyh1iaC0Uy4qyVcp1VCil4woKGnHRbkOS3n7okTt2i8pLL0pL3ZBaNnugOhJn4MLuk7ahKCFPjmfonbNiLolfjtpQUQ9b806pQ9m3XpRHG6LxertXDJ7vEBId4046usSIaOUOpeolT7DRepHutZNgEGJaK53ZrgtDSKs9cbl8uNJRJ9MbtoIQEemOKs4UQG5XYKkZWDtyObGQ++QmmV8iWxushNyIUP7SUMFQJAaF+vKrZ192g3dBuF+qgG4FpKbUimQGMhtSIzdVisgMRvSviIYsjIISMwrwr209MupViDhS8u1EemY7Y7kFiRoI35jQ6jcSF0uyA4bm221EO6FM4mCBK3Wa/4AubENKg7NH46jIESwM+E4ggMyDMnSk+CAhCObg+hTMdK3XnwYIniI5p4EQwSMNSy0Vii5sQYHLR6iPyC5QQtGv4tQUYJkRz8cRhHyezBIZhiF8bgDIttX/jrJjMcwsDdd0MFA5Y+VpjCwm+TyBqBwbznUVjKJwUeNV3AVGhkKC9FJSoKfWXnj/3mlAah3KclJWeDDz5dkFZw/P5Tazkxb1DF8xKfo/R/H93+uP+4CAa80vm+80rj/kuXx1z54EYUxHj3gauyRl3UYN10f/gOulmHMoemIXwAAAABJRU5ErkJggg=="

/***/ }),
/* 1298 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAD/zE3/zE3/zE3/zE3/zE2PcysQDQVwWSIAAAD/zE3vv0jPpj+vjDVgTR0wJg4gGgqfgDCAZidAMxPfs0NQQBi/mTokdv/GAAAABnRSTlMAUICfAN9bz07pAAACMklEQVR4XsXY247iMAwGYLdMc+wJmNn3f9SduFYV5pdlS0jUFxQV8Sm2E0JDZgzj7TYOX1aQ8fkwFY5peA8ayxnjO9CtdHEzINuZZ4dEphNizjGYElnOmjlWSyLb8UlkOk6JLMcrke2EUoItkencG3k3JXI4LolsxyeR6TglshyvRIbjlshw3BJ5HZQAcju1goSQ7Sx7zvuiSuR2MocqkTev/YB2LTtyOiVLaBUnw0FIkUhxpEuYWlEk0hzpEhS7KBKhg1/keDbnqc5MQgdT6XcTTSJwsLino0sMjeAgxI4ujQ0awMHUxNGl4ReawOmLnerhGNL0RTygAE6ZZUh5Sz8MqFLgIRFXKPKN3rnH/Bpbf0nsyAAiV4lay2aWO6auMIhwQOH45KUlc2scQg3essR+JrOebxSoTw3TWuuSftXUdzHl/MDUCIuduozimWyWqCxgsbH99RAkqaWfDecNbD9MSIG27/ja6UdLa8+SFU5IXCL8nXSOIEoqz4ausv7BGZVFK27sbnAxuJT6okVJ+phaKj/szNzm4xUd9YdNajsnaZO0VcaFjkAgibmX+YS5OlIpdARCSTIrZWsNbBD3S3qHjr4d/ePMJKMqtV4k4wqOvkGusvF891CVORbA0bZsjniXefj4c92NLduzSWK/ANIlw0EIJdP5xF8/lHTnI3+PUVKdTz5CoITORx+zUALngkfR9x+OUQLnogMElMS59pAFj32uPYjCo7GLDuswnMeH/wGySZXRp7zobgAAAABJRU5ErkJggg=="

/***/ }),
/* 1299 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAQlBMVEUAAABVrO5VrO5VrO5VrO5VrO5VrO5gse/f7/z///9VrO5qtvD0+v7V6vuKxvN1vPGf0PW12/jK5fqVy/Sq1vfq9f1SDYXUAAAAB3RSTlMAYL8AIM/vi50ITwAAATBJREFUeF7t2MluxCAMgGGyjReWZLb3f9VCGxU6VCXFvlTNf0Iz0ifFJBeb1DCyoHGYYmaa5oWFLXOC5guLu8wRWlihZTIDqzSYUQcaDSv1NyGwGhA8HJF7gBQCpPcQhBDSHsqgO312F0GYIRRBVCSBrBYEWhCrQT47Xvf65S+kZxlk3YfjrAwKT9p7BgFkb1R0s73Q5uhLbuuCVqQqXH8NwZW+7QptqB5yWWvopj3kVHvopjnkOrcdggCpGdoDkM/XTXv1D74NQTGLV6iY3REo384rVNwmHH20K3AN5ffLHxl2lPyayBpKrel/aEIpAE7VUMdHqw2d0AlhCKgCBeagAkURtCD+j9AJndAJ2XzqhXxyfHHqhSBKHorTD6ktWdTWPlqLKLXVmOayLqaxPnwDNiXGgh3sk2QAAAAASUVORK5CYII="

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAADqWW7qWW7qWW7qWW7qWW7qWW7rY3f////tboDqWW761tv+9fb74OTxjZvyl6T86u34y9Lzoq3ueIn2tsD1rLf3wcknBNezAAAAB3RSTlMAYL8AIM/vi50ITwAAAWhJREFUeF7tmNluAjEMRT0bdrZZWPr/n1qmQeVKtGmC/UAlzivSgeNEETLtdL1X0HfDFRqGcfJKpnEXjQev5jBeRZM3YBqo8yZ01NuIevJG/E8ROwsRX6JIvLBWxEm+SKwUJbmRdKJFvllUonQXJZVIAI3IWYlYgJdI8+HuCbbHr7+QwetELmZPdDrRvMqNdVaI3CbA5p4VHaMgEo9PiU5JHkinZhGf5UfOXC/CISPloVN5yEh56FQcMoJDrxJxgg4B8JFzFaIA37wIMMMvDX+LGGexCfCBs6sQwemwIBFPk2vTzpwfEWTO96syzXMQCfkG5xJo2zntn3PV8TNjJbYVoJrnEdvaRViGbe0iFmloo2JZQxsVyxraqFTW0kalspY2KpW1tFGhrKmNKsqQpVWEZcjWKmL5BW4RIQ8v2WuL3qK36C1as2dVi+YsmhUi+F+6Zk8JsyWL2drHahFlthqzXNZdsVgffgKRusQ43O9tyAAAAABJRU5ErkJggg=="

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAABmdX9mdX9mdX9mdX9mdX9mdX9wfof////19vdmdX/i5eeDj5fs7u+WoKezur/Z3d95ho/P1Nefqa+psbeMmJ/Gy89zfh8PAAAAB3RSTlMAYL8AIM/vi50ITwAAAcJJREFUeF7tmOtuwjAMRtNysXNPW+D9H3UUlYbwEbNBtGkS51eFoxO7dokUNdP15g36bnNGbTbbnXmT3XYWbffmbfbbs2hnGrDbqM40oVN9G1GvTCP+h4gGEED8uYiiZtaRQABxWUSWL1gwQVwWWV6w4IC4JJp4ZQKJGFewIWxZi4sivgEsEK+LhlYiaiUyzUQpexJYIP4b7T9m0dGIKSVxICPfEF//RE5ccBKKg3FV4JFNTkMMRBMDE3qgchAdGYA3Tr66iyrWAJ7gTWfcQ9HIDxmh9xntUISFYXHYDEso8lzBoydjQRS5SoSmwoBkEWmuoil7kFiIICFc67jClEWYEKbk6ivcjejAIgczSKW7LPIs4k1iAbuKiJ8wsEj4tohY5HBfGlToi9IsFDhannGrKCwpQs7X1CkxJ4f9HPwyHovIBM/sg+E7rr/P0KORDDRFh6cIigpG4Qv5iYgY0a+Ipmrnn4ugMuAkiWwIFkSVYdOSKKzzAJUhQRDl7aEy5CSLDIhI/Nt7LkKgEX8t+og+oo9oKJ5K8hkoitLsScUTsJ51kuhyDlLxBOSzrqTZJUuza59WF1HNrsZaXtadaXF9+AXBj76wl8PmrgAAAABJRU5ErkJggg=="

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAz1lxv848L++PD////0kAz1nir4umf6yIb6zpX71aT2pTr96tH3s1j3rEn5wXb+8eH83LPgo9JsAAAAB3RSTlMAYL8AIM/vi50ITwAAAdRJREFUeF7VmNmOgzAMRUOX8ZaFtf3/Px2QUCMIqVuIBs15rXRI5BvXspmoLnKAS3UdMdfr7S4Hud8m0e1HDvNzG0V3KcD9aiopQmUuUoSLkUL8mciGlkfaYA+JIPCLAPtF0HKEW1BEikc16aInr3juE/Wc0O8SISfgHpHlDewOkeMN3A6R5w18XqTVXkmALkLeBL8VAWcoJrJnXU1g04RwwhNRHu2ZbSRtbCe22sjAM8OR5m8D8QsKdqcIal5Rwx5RR5xAnSJSj6MfyuiF/yxMRvEoJkXUEL/h0aii+dG3rNAyIygi5Ag9VkchjuB7EXCEmrVocWVQRbE8vGJRBPjwagiSigRQudq68DTIyPpqMjLQfF61/J2vvQOZCLwgyAQ4X/vutMbmX6rWQ+Hx+P+LmqFGXBSnR/QOvhS5OU4QPUA8UdsvRE0bo5NOcAE+FTlahHnm8T5QRplC7daQS1YTQUBcdv1OZrpFyJ+IbiVSWnUtM3X6U14UEg+FvIibrAgXx09fuPWUDN2qqJZsMHRR0IczS9rVYnjnSGfoMt8ym/+M1EgWF2OZF4lFHkErb+imjJMHJdm2760oNH3/DxpbsSVLsbVPqUVUsdVYyWXdSIn14S9lf9r3dxLyXQAAAABJRU5ErkJggg=="

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAACL0lEQVR4Ae3aW4oTQRTG8VpCLyVLyBJqCVlClpAd5EGEQZB+U0MMEUQGmcEEIl6iZnQcxQt68IL6liUcT0EewiHdeaiu7tM9X+BfL+mX/Oi6EMpZ/9y4ecISSV5ydRcG6/FeR5AARAAqB5IAdBToz99/XiKJK4okLzldGEyngXY/hBPluwBECYGo1UAnt24nQFG1Hej8yTJ1br8wWE5PsbQ4AAIQgLBIqwAEIAABCEAAAhCAAAQgAAEIQAACEIA6APTu/ZWXSOLQy1dv+M69KYD2cPhQk+mMALR7cwoCkEbRmQTaXTshiVPXFiCNw3UVFuRWTTH95qROdqsyIG8JKOBkNcFoJP0mkeQlZwFoJLHRRhaA2HQGrr+w4QxcoLI/xZq9gnd3cn8k8TVoK+WSKysMOr4GzaXsMAqABsdhSoCev1h3GSeXXBSQ9V0scs3JAFTcWHJVAM2t4lxefYgB8lUBDawCLZarGKB+DJBGIms43+lHDE7IVQnUtwZ0+viscSCNNLaCs369iYCpFkgj5U3jbN5exuPEA9lE0jiWgDTSsG6c1dNnkSDpgTRST7pIDfPl6zd++Og0AqIhIHVOogTbeNw5xwCQhvLSvIrT8dn5Ih7AEJCGyiQf/gX4+Okz//z1uxAjfBeeCc8GlOnsQSIMA0CqnsRmMwA0BFB5FwAqLpO4OAANAFReDqDytgAqri9xcQAaAyhqewcQA6gbQNQUELUEyDcF1DOORDE4of/7JaCX3HCTEAAAAABJRU5ErkJggg=="

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAAiZpkiZpkiZpkiZpkiZpkiZpkiZplZjLO6z9/I2easxtlLg6wwcJ+Rs8x1n79nlrmevNI+eaaDqcbW4uz////x9fnj7PKYRBN0AAAACHRSTlMAYL//ACDP71kzCuAAAAI/SURBVHgBrMGBAcBQBESx4x7237i/M5DoF+mFDB5BtZe6QNR4bQrRPtAofCKUPpHyka8dc1mSFQSC6JaHiKDg///pvSPWMTdE9MKluWpo6lCVBdMTfKAP9IY+0AdyPsRFJtMafNZVmw+lyrju/mit9RBzEtDW/iYfUvpb1OITt14Lkg1daKJYAV1xzRMXxwoHeIzXe6QYUrhAbQjQOcaFwhS0dAiQyGiMrbalDZ1SGSA4KneBKCVrnJLDs7zCEQHKWgoJtrbfE3dwgnnVE4q/Rz3doDrG4W4taw+bYJT5ytm5aK1nztGJ2ywmB7wuLORoXHJyID2eMBDXVhuwh5+d7F3jxM6oXlf26GkGWkieQkaEkM/nwJX5pRW3ywiTjlOOa0N1BiL7x/hysvfGWcgc1AkIPxeqXAox9h2fwhRE0tl87zZTLduuV2UOSrg4wqJZvNuH8AuIaxGMuNkFDOb1+oDKFESvmvmZcDZt9O8Hj2jNEq3V5HZHy6I+B3FYMs7gVuDGcp2XKYjjc9Ar+tfxhTsb56DLW3SQJNpwkpQmoF2iiiZJjvpHOE1BrGFD9tdbESxncqox+AXQc8e1K66hyHbMXPc5hyugKihIFGxT1h8UhCIglmAsDaBY9kMoCEgKwcksxcrPOUJFQRTin6BO6kIiT4RH1MYvOVNUJtoGH53aNdp9OsZG6mYaSWWp79iTnSNUtx2MxTiZEtW8luDX1dXvn9Hf9IE+0GuPLK89+7z2EPXe09hrj3X/9cbz4T+J/Y7mGGFT3wAAAABJRU5ErkJggg=="

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAflBMVEUAAACZqrVmdX9mdX9VrO5mdX9VrO5VrO5mdX9mdX9mdX9VrO5mdX9VrO5mdX9mdX+ZqrVmdX9mdX+ZqrWZqrVwgIqZqrWZqrWMnaiVprGAkJpmdX9mdX9VrO5mdX+ZqrWAkJqWp7KPoKtpeIJzgo1sfIaGlqF2hpBwf4mMnaj0JMPkAAAAHXRSTlMAn2C/gEBgQBCv748gnzCA71DPML/vIIBA32CPcAEer08AAAGKSURBVHhe7dbZbqswFIXhzWwIIUDSdDjHJh2H93/BZiBdijat4oUvu6589UnRH8vID1tvhqG9ldnbtsNhUV0612fCLxpOe3OHxTy0GZTEQoGkaAgkbdtQ0jqU1Nw8hpFK9xFGci6Q5EJJfSipc6Gk+E/6dXlaBJGW1lpO0o5NqXbasTnVTjtLvp12eAkO3047fDs4fDvt8O3g8O20w7eD49uuMtOOf7ts0iHaZVMO066ZcJh2CeFMSpF2yHaRcth2D6OTw+Ha7boTlMLh2u2q+ggVcLh2724sV6S5b7tqDyV37dF5woXzb2eyuBFZ3++dz2dcOO92+Dx8eXXHreB4tMM6N66C49MOK89S7OHAxEw1QiXnYCs3zlAOVp+hjHOw3p27LRhH/7ZSKEf/AxKhHCz7hlJrF7QDqB9h1hEzQgnpYIB4R0O8A2iuYwBRjs5POhpiHQ0t4FycczjXQXAEZ7x3HhCci3OhnGvvmgjOeO+uh7iFh+pQkASD/p2gbjZkSrzZM9f8j2uRLzaJ1t8g1Ne9AAAAAElFTkSuQmCC"

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAC1ElEQVR4Ae3cz2rUUBTH8fsIeYR5hD5C3sAguBBcZONCKBgQxJ2hG6WbiLjwHw21ICJKRKkbLVFa1OJAlKIoInmEPMLxZwlhOHCH0463dk5O4QNdNNzw5dzc0NJx2r6m339HkEIFHRDTQQUpRODm6b9RIxuiyHSQjSVQCXRMpTeQxRmUWgMlQMC1kEPM5NB6rok1BqqAmEz4vCKm0hiImBycUAHEqA+0Ak4oVhvo3tPtFBogpoEUnISKQCxM5AnDNRCNMVANJFSPMRAdxZgC5UAi8pNNVSBaiAWyQLbFwrNAFsgCWSALZIEskMD7S2cm4JacIJA8SAoVEFPDypgC8TAxtEBzdGMJxOMUQBLaA/EwEZTSONP8Iv3cWCvBLZnjBpLH+XDlPP14cP1vIIJCYyAeJ5PG2V09S9/uXOvjDGLtgTppoObGKo9DUJ/mIPg16wpUQECSQPzEIom97NxsFC4+pXEi6ICCB/qyfnleoHL0gfoHs0+naouxSK3k5PLHGSTKHtLyKfp49YIkUKEiEMYsB+I2Nx7R1v2Hgye3C3q+vnboxa2btLN1l/Y3i1k8UK0lEAXUQD2jhHxGBjHjTtDJBFrmyPItppEg8qt3+/R6d0r154NDPPJQsv+BAS4iXDx49maPHm/Xg62XOzSCsPnsqHVAi9AYeTZQDbQoVZFZoAJoUZoi8y2WApkef5OGCZDxBOq1QAYdPIEKoKmpfYESoKkpWCDbZkzOAtk2Y+J5gew0QwMeiKtHHKeT/Ok5thPMF8imKJ8fyKYoFgXqlSMM5I4SKIJuRHFqeaBxvl1n8wPZVpuIAnk0yuM04BYJFCmPlPkDWaQOIn8gi5SDkwWSR6q0TY88kFyi4D0pCf35QRHkSxoqAxcyEA+Vvv30lfYPfp32MK1vcrj/8Y//LqB/vn6IG2yBPNoQUQKsHzRQAuSRBI0TYP2QN9kC9drwccKs/wfsyrplNR8t7wAAAABJRU5ErkJggg=="

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAdVBMVEUAAACZqrXM1t3M1t2ZqrXM1t2ZqrXM1t2ZqrXM1t2ZqrXM1t2ZqrXM1t2ZqrXM1t3M1t2ZqrXM1t2ZqrXM1t2ZqrXM1t2ZqrXM1t2ZqrXM1t2ZqrXM1t2ZqrWjsr2mtb+su8SzwMm2w8y8yNG/y9PJ09vM1t0f7HP/AAAAHXRSTlMAEBAgMDBAQFBQYGBwcICAj5+fr6+/v8/P39/v7+yjKeEAAAFXSURBVHja7dhRb4IwEMDxo24DZFDHQIT15nDuvv9HXCGEU8wSvWviw/y9NvmnR/sAgITJKkeeqzIDCrmjmctBrKQzpa6jL6U06Gzs2Y4GMUhU5OUwycmrQII8C7MNeeLQM8xiYWjdoNesYSYKRQ1OmkgVqnFWq0J4QhGydMaKQ7QQMBR+NJ1H6BF6hP5v6OkdMUQo+sA7hOSj3f/UChw0dV2/FUXx+uLJQnjhsiwLXV9ejibB5f5wPE7lo3fo+/5rv99/olDhQ44WRGUf2tKSpDy+Ty4JysNoGenBYBUqBB1pdfzSrbPlzwudDQSazUKg2WKAMOe2gsmWVBx/46gPLcyWLATaUgysJAU4YZz+Eamvdw5nSuUtYjuS2cGC2Wkm05ecgTAlC4xLlXJDLHV0mxT+YKzTPWlmsu8fuk6XXvejQLjOWhy1wnWW4CiRrrOkRWyTm9Z/ASERPG7p9mNeAAAAAElFTkSuQmCC"

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAAiZpkiZpkiZpkiZpkiZpkiZpn1+PoiZpmmwdZklLdXi7Ho7/Qvb5/b5u6ZuNBxnb08eKWMr8rN3ehKgauzytx+psPA1OIjXXgBAAAAB3RSTlMAYL8AIM/vi50ITwAAAb9JREFUeF7t2FuO6yAMgOEkbcc299za/e/0dAZVNHGC6YDO0/wL+AS8GLn7rh+woqG/POsul+sNK7tdv6HrF1b3dX1CN2zQ7dL12KS+O3vn8TNo6I4QPT0MzJ9Je8iq6QGx30NW+TkalZB3APVQOhOHJjht2kPj9qm3EGTaQTMYCjZhwfwSivo8LS/pXgU9ex1sfEHLCrkeHEqWinSEDGTzGQjMB9CSgSJRdrUZC6Hy/iA46b9C5h1yx44rgIx6h+gYogLI4nvqGFISxHPCzYohfQRpGeJ57njkkBEhpMxLJ0gZEULPz8MhtGE1AoTaJcbpzDjSfhYmmqIfy5GSRvYY1sKpzyGWxkYQNoKsPQas/QhSDsApzigHm0iAFPzEpADMyUMuQmbZOos5dqZT6H3apsKJQyBCAOv4YsYVzhyQrhapu160vieGORlIgVhychD6cicPIZU6EoS+zJEhVKbIkSG0JDoyFBt3FDFHgFI20ByRmYJF7nCoqI1TByWnDkpOHZScSog5dRBBG4igDUTQBiJoAxG0gQjaQASNIKiGyj/sg0AU/rOH0rWPcpxxycG+1SKq2Wqs5bLuWYv14T/OPJ8YJvpByAAAAABJRU5ErkJggg=="

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAAiZpkiZpkiZpkiZpkiZpkiZpnb5u4iZpmMr8ovb59klLf1+Ppxnb3o7/RKgavA1OJ+psM8eKWZuNCmwdbN3ehXi7GzytwNHAHLAAAAB3RSTlMAYL8AIM/vi50ITwAAAX9JREFUeF7t2Elyw0AIBVCNhh402879bxo7lYUprB/RYpGF/wFeqRFIXVTP1A2fSFO3j1Rt2/V8Mn33hLoLn86le0A9O6Rvq5pdUleND9RUB4F4y3sZpydwFFryfmYLFLygO4Cuh6GBMspyFBoyzuQEETsdLQDImg+Ee3u2QosDBIckWCEe30PJDF3fOiMDyHK2ACDLI1EsgCJp6F7UkJOq91DY2etNFjqVj0h4eajrembW4jL/KLdt/XxGiqBEOVNCwDJnlUFBScwxmg7pKOi39anEmZYXKP+mxBlnAFmcDCCTAyCTAyCTAyCTcxzaoLMLoZvR+KUcAAFnCsoBEHA4KOcolOTPIkjHAJGsbxCOBZIOB+FYIOlwEI4FIuFwkI692IP625og/QHWjqGzY2TgGCDWDob2Q0k6GKIMkoSDoYQgEg6GOBGQhIMhXCfjzZ/+Otq0A20CAnVKjO/ZUUK6Tvr1b++6aP239yO3JYvb2sdrEeW2GvNc1j3isT78Bn9QvF3Pl8XDAAAAAElFTkSuQmCC"

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAKlBMVEUAAAAiZpkiZpkiZpkiZpkiZpkiZpkiZplklLfb5u71+Povb5/N3eiMr8otXGazAAAACHRSTlMAYL//ACDP71kzCuAAAADWSURBVHgB7dbRCcJADIfxzKATiBNoHiz09XQCcQKdwBH6VpzgJuj9wT2cwWmUEmoL5hJBfbrvIU8/VCIcIaIZZ1uEQOHARqdA27OFNnvasdmR5jZa0dJGa+JxVURfanjcFLWQugyKkJKOagxl0Y2fXXKIgf4XVwaST3Qg/iWSTTNjEvOweZJNv0foRihqKL1QDQ3hQ8QFFVRQQd6nx/eI2c+h3f/RHdmuPYKRH7m+Tv4kdQqKQNKnoBbo9CmoiqnR5zc37jpoXKeR68hynWu+wy8E+4R8ANkv76d1xTDhAAAAAElFTkSuQmCC"

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAP1BMVEUAAAAiZpkiZpkiZpkiZpkiZpkiZpnb5u5klLf1+Povb58iZplKgauzytxXi7HN3eiZuNCmwdbo7/Rxnb08eKX8XYknAAAAB3RSTlMAYL8AIM/vi50ITwAAAUVJREFUeF7t2NuSgyAMgGHw0CTgsd33f9aFjnTtoBMhmb3yv+j0xm8GY6tiYrbxghrbhkzbdr0X1ncR6h5e3KMLUO8V6ltjz4BppNA4XZOsaU6clbaWS1BjTpyFPq2XpBNool371bmhDBrj2ZlGOgiKoOBsXl4hNKUVSqFBDuVLS99GF6Hykz1sTjRfkXj54MzC8cN7XoFeTiDuwk5HDs/n8P78KYP8wlzYDMT8aBlInj6EQNUB/kFIovADgQyCBDkS9gXN6CvCeQ/5tNCKMIMOAYTv6eQ5HsqneSjxUD5NqITyaQqgNE2cJdB+miiG0jK1IF8OIWwsHbSRgDyERBwUQxaCaxBwkKNrEP0b5G/ohm7ohm5I689f/3akf4OsSx/SfxidaySXPR7L0n2FaHReahpjdV6zrNZGlNrWmOZmXUhj+/AXI/zN1latt20AAAAASUVORK5CYII="

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAFVBMVEUAAAC+GTG+GTG+GTG+GTG+GTG+GTGgxwOeAAAAB3RSTlMAIJ/v/wAwF8MKgAAAAGVJREFUeAFjGCggZOKsGAoHKDwGGCPMxMXFORWVh6FI2AUIDFF5GIpUQMJOqDwMRSYgYWdUHoYiFzBA5Q1+RaOKRhWNKhpVNKqIcGFPuNogXAGRV5WF4q0UcYOBVzRam4+mJ7wAAI2P/7b50WKtAAAAAElFTkSuQmCC"

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAC+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTGMpxiPAAAAEXRSTlMAIJ/vAHCv379gMBDPgECPUPbVTMYAAAFsSURBVHhe7dfBjsMgDEXRgqEECKT+/5+dkbJo3pQYHLoZtXdLdCSaGpTbB2QsMZM1rpXx98B7i43NZ25uL9H+HKUXJceVsdXnM8gQ7zEZh3ni16jkNmSfz1hg0srtQm1C9ITo6ETi00oL4kMHp7CUHYY8y9lBKHIvPwQZ4m5pBFq43zoAVR4p9qFlCApdKDEWtvpbtMTYoweVk39fLgjdZQh3hqOcAkhZhJBmnKtMsDcFZB2EL3RTQBUd3PeigByGw0MdCA8WaW8ihEfdBISH7wQkXwdu00Du/ILKNA7tZeNaWVZAQhGccBnaGLpfhOrKmL8EPRb+m1FDcKrBqCkgczCwqoISMjD7GsicOmRUkBVuIxVEwuWvgmRnHvLuLVBI7h0QFWCuQqFkNw8F+wDiIhQNANch5/4NJN+rwqruE0JY1X3UCKv6zyxclSD5XsVVAVL1sdD8jz3/+uf/kPMj8rah/azz6Hsefc+jHwI/qDjKHZtwAAAAAElFTkSuQmCC"

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACjBUbJAAAAEHRSTlMAEEAgz++fv48wYK/fgFBwNEt7pgAAAdBJREFUeF7tldGOxCAIRUerWLVa//9rN9sMINqW5914nyY3eCxewnz+kpaWlpaMtebG3gbbunYjDwYx8GuEbcDY8Gvvho32IPe913/JUXASVhEptyelCxTQOERbHu0drfaocp0QYNJOrkfreAdVNqADObaxZRgBsqK06W75na1iKAyX2qcntAQ6xYejarmEPUK5FKkHiZ7w+TMoyHtlFjI3M46JDoqt14Y9CFcFzUfO24CiBsLQWOF2ZKoKmufecL+sooM4NE/DzZ/pODYdhD0BDTfTT4xNBXETOdFw81hHPKGCOLRiuoQSTlVGUwNxaAnb2TkAoEirDsrkFX4POp4wNh3kKPZIw13JsxibDuoWiMfhBhpOg7GpoNhNNODtBxJ5uyogDg2635ai4iNRAxV6Te4jYPhdFlUBycLQeoG4SAM5tni9MpvyzwpIPmac9gDl7xQQHvXzFgpy5SqgKvcZzLsSjfgG4tAAuawoz9R3UJahmPn/BLDiHeSG+4IIv88/v4Pa4JzTvq8iNhVEKcrwOX8ZG8wgfhA5APm5hMfUT83CvDDnkl4wJhn9RTZkmIBkWeLMR8iWXLbeMCfspyhKJRTbG1sBSMj5T1paWlr6Ae6uV7TD9Rh/AAAAAElFTkSuQmCC"

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMPn8PidxOF4rdZgns5Hj8fa6fT////z+Pu20unC2uxsptLO4fCRvN1Ul8upy+XW0JVpAAAAB3RSTlMAYL8AIM/vi50ITwAAAL5JREFUeF7t2FkOgzAMRdGMODNz97/UQkvoAp4/UOW7gPMTWXKszrQhIKPtkbLWeQLz7oTcQHCDOyBPDHmrNLGkleGBjCKmOCCBljmEecGh2D69UCi1qwRCoUMBg/Z2t0NQ/kEZgmi8IcKgqTsTCJX6dcYCQlTW01kzw4jkbct/Ov0pxgRD/dlqgaHr+etjpj92KD4PEkgggQQSSCCB8M0f30bw/Qjf2OQrKhDbkYXt7MN1iGI7jXEe6444zodvzq6XJjX+ajUAAAAASUVORK5CYII="

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAOVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8fa6fT///9gns7z+PuFtdqdxOG20umRvN14rdbn8PgI0In9AAAACHRSTlMAYL//ACDP71kzCuAAAAEUSURBVHgB7djBsoMgDIXhKGrxCKK+/8Nes7wpFsTIin/ZxTfjGCkT4rrePKjvhjMahnEyD5tGhsaPedxnPKHJKDQN1BmVOup1oJ6MUg1qUFkNsrOJNNs0JB2YSJBSCloc4hDckoKkE4dYyoe8wzUE53MhD1xDnM+DVqQgrDlQQBpCSEI2IAdCsL8hOyMP+hookk5uUiIxPtnJgSLplEokx/CW5GOQR0H+G1pR1CqhgMLCP8jed8RoMsQ9gd54NG5DUdtbr5/b7w/k/uonwtKBGx2L1jFS4WDjco/aWoc/t6Whre4fJI/mL8jt9S8RPJpX0LHUu2hJySZ/rH+rbVCDGqS2ZFFb+2gtotRWY5rLujON9eEf8QNcVx1wVF8AAAAASUVORK5CYII="

/***/ }),
/* 1317 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAOVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMO20un///+RvN2Ftdp4rdZgns7z+PtHj8fn8Pja6fSdxOHKSsTAAAAACHRSTlMAYL//ACDP71kzCuAAAAEOSURBVHgB7djRboMwDIVhg4HGpCQ17/+wTScuNq/bkbDV3PA9wH91JILpZRjZYRymhqZpXthpmV+h+cZut7mFFg6wTDRwiIFGDjESYykxRow7IikitEqz+kNZvmRv6C6Huy+0FTmUDYdwB5ZAqD7km0c9G6oqP2g9GVIx9FwoyS8JhEAHlEBolbdWGDKy/CHjkB20ASZOcIhW2VAIdECJ4KAPaOKEB32wE8chFUhRyBCDjd6hK3SFrtAVukIqkH72c8S1yL9K/dAn2/+IAM8jI3d5aDW7vLX3eYz6n8dgmFr7/kLYiZfa5zfL/+MHhpk7/xzbie+9DgiOk0bYkSXs7BN1iAo7jUUe65qI8+ETtFNY9Ra2FQwAAAAASUVORK5CYII="

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAJ1BMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMP///+20ulgns7z+PuFtdqx66FmAAAACHRSTlMAYL//ACDP71kzCuAAAADkSURBVHja7dixEcMwDENRyZDk0OH+88au0AWXA9PpD/B6oD31A0ZHH3dtjLlgtuYDzRN257yhhYLWaB0l9XagpKOhqA1taEO/Qq/vhQnR8SE6PhTwITo+FPAhOj4U8CE6PhQogq4q6H25ECUXouRClFyIkgtRciFKLkTJhSi5ECUDEpKC4nprCRoKQEgCoiMkBdERkoLoCElBdJSkoQC0pKHH0VJqKAAtJSQUgJYSGgK0lBCQlOhoSEsJA6JER0BKSjgQpYQDUUo4EKXcE2JD/4TKTpay26fqiCq7xirPuruK+/AD9Q1RNhzOHhsAAAAASUVORK5CYII="

/***/ }),
/* 1319 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAJ1BMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMO20un///9gns7z+PuFtdqpbALuAAAACHRSTlMAYL//ACDP71kzCuAAAADmSURBVHgB7dYxTUZBFEThqwEUEBTAFNy8bLmggKAAFKDiSiCUlCj4cbDBFDV7/sdOSfGm/nLqiYgL/bmr3qM/abGXHvevK3T3GA9a7jku1+gmrtfoNmTsQP8e1dvvnUXpIJWD0kEqB6WDVA5KB6kclA7aHPRpoO20jxgiYoiIISKGiBjaRwwRMUTEEBFDRAh9FRBC7x9JhJBUQAhJSYSQVEAISUmkOSQV0ZhCUhK1OSQVkMYUkpKozSGJSGMKnUWNISINhogaQ0QaDBE1hoj0jRDQ/g4k79BY18g6WdZds45f7+sL+QOVKMyW3Co69gAAAABJRU5ErkJggg=="

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAJ1BMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMOFtdrz+Ptgns7///+20un7Dtm1AAAACHRSTlMAYL//ACDP71kzCuAAAADjSURBVHja7dg5DsMwFANR7Y4t3f+8kaspiYAfSKM5wOvJ9JZLNSq57VJrfVSz0V+oX9Xu6hsaNaDRUq4h5VRioJJqUAc6ENHnfhwIZ04hCQhHSALCEZKAcIQkIBwkA8IRkoBwkH6CcLS0NLQdLa2pIBxCwtHQPbW0HQ09WlpTQELCEZCUcAQkJRwBSQlHQFLajoa0RBpCciEkF0JyISQXQnIhJBdCciEkF0JyISQTQoqClgnheBCOB+F4EI4H4XgQjgfheBCOAUmHzoQ40IH+BYWdLGG3T9QRFXaNRZ51u4j78Av3u1tgiT27jgAAAABJRU5ErkJggg=="

/***/ }),
/* 1321 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAJ1BMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNgns7z+PuFtdr///+20ul1/l9mAAAACHRSTlMAYL//ACDP71kzCuAAAADhSURBVHja7di5EcQwEANB/nrI/OM9yRpPMLBV53ACaB9Ib7lUo5LbU2qtj2o2+gv1o9od/YFGDWi0lGtIOZUYqKQa1IY2RKLzui0IZ87bgnCQBCQcJAEJB0lAwkESkHKQFKQdJA0t4SAJaC7hIAkICYeQNDSXdualIaQv59QQknAUhCQcBSEJR0FI2tHQKwlHQiQcA8IxIBwLwvEgHA/C8SAcD8LxIBwPwvEhHB/CMaHlQkguhORCSC6E5EJILoTkQkguhORCSHtCbGhD/4TCTpaw2yfqiAq7xiLPuqeI+/AH7vZbLrsAZVUAAAAASUVORK5CYII="

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMOdxOFHj8eRvN1gns7////z+Pt4rda20una6fSFtdrn8PhsptLC2uxUl8upy+XO4fBHaJ+PAAAAB3RSTlMAYL8AIM/vi50ITwAAATxJREFUeF7tmFluwzAMBb2GWr0lbe9/0zoo7PdRoGgyRIECmQOM7SdRotncaTsDdG2/0/T9MBpkHO6i4WKYy7CLRnNg7JvWXGibzlzoGnPin4renhWV72y3lKlIshCZSNQQmUjUCYrEDEViiVQkExTJ9GyJXK/rvBVR3kmJTB9FTKjWUtUuiERkeTlNAYksLnolJLJc9UpIZOmsYCiyc+0yFE2HKEGRHTvzRkWzQmKi9QiJiq4vEQgbLj/fkH9fInGBRaujx+UYWWspPx1s6ZeiUHb4URu/1hge/nowvI4UBLwg1zPQ0/zYla2YYROhmGFbo5hxo6WYhVA+VKRmFH6a2mMY9pakeWD5+S+ENiT9O8qVihQ5FSlyKBIBixQ5FSlyKlLkHiLxErkNWdzGPl6DKLfRmOewbsdjfPgJ9X2fnFZusQ0AAAAASUVORK5CYII="

/***/ }),
/* 1323 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNUl8tgns6RvN3C2uzn8Pj///9Hj8edxOHz+Pt4rdapy+Xa6fS20umFtdpsptLO4fCtrKqhAAAACHRSTlMAYL//ACDP71kzCuAAAAFCSURBVHgB5ZjdbqwwDAb538KSBArsef83LSu1c7lqGV+0OvMAI/IRG+PqSd20gqbuTqqu64dWMvRPUX9rNbf+FPE8hqGr6jaEuiJnR1O1QfxN0ZsXjdN9TgA/FOWCxIhyWRII0YrGid4TGFHekhfhCRBtSYvIB+b9eIzXLuSaIP1br5dIXtAsk6m1gmcbTdHmBU9W1T9xrtG1Eep0cv1o5H3JxsbJVim6f91D2WqJaLei9MkRJXpIUf51In80H7Z//f5C+hLxRbvloDZCk/qGqLxqbCkth221XI4imz+itGf/OeJR7QeS+C5+sik8HvWwQwSUmLGGyO2gReRu9CNyMYxeEDEei6OhmmYRNvALIV4/wKsLKUTELEXELEXELEXE7ETE7ETEbEXEbEXwn4nClixha5+wRVTcaixsWXcSsT78AF8HYkcGnqYgAAAAAElFTkSuQmCC"

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8eRvN3C2uy20ulsptKpy+XO4fD///+Ftdra6fR4rdZgns7n8Pjz+PudxOFUl8vNLrywAAAACHRSTlMAYL//ACDP71kzCuAAAAGOSURBVHgBrMwJAQAgCAPAsQf7N1YzwAU4fEUNsPzATmuo86McjZ28qLWgjdKKAnciQktuO2awIyEIBNHDXkSQVkH4/z9dpzhMJSYLW8tpM3V6l34xacpx+Ieij2hxqw9v3oIqinZnb3y8+NREyV7J4ACOmujE8AUufxHx8AZeNZHHsAdHcNFEPHyAnSa67L0pQ4Ik4uHauEqiZMjSto9oB5KHHfBQRLx9ZkHER2elBQ6Lgo9IW1p+sE9jotO6SUOiaN34WaI4JFpnPVG6rJOrjm2tFuRoiwJncCyIW4bPEXef2Gkv/0wiQ4ImouGlcZVEyZDE9ZVEPLwDD01U2tKI4+9EaYtIbkfmwT6MifrH0c4hkVeaxiK9svoTrUOielkvYWxr1ZVXIlWW+E7tb01880M01n1NxN3fub6a6Nn9JIjoo4HqK4me3c+CiD4aqPuaiIc9eBNEne0LIkd8aqK1bZxEVRPh/Rbp88R/SSJ0d6ef3vPzx++HfETTLlmmXftMu4iadzU27bLuzozrw29q02pO0Wl9PQAAAABJRU5ErkJggg=="

/***/ }),
/* 1325 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAnFBMVEUAAABBQEJBQEJTUlRBQEJBQELR09RBQELR09TR09TR09TR09TR09RBQELR09TR09TR09TR09STlZjR09STlZiTlZjx8vJiY2TR09Tp6uvr7OxYWVu4ubnV19hBQEJlZWeTlZjv8PCtrrDb3d3h4+NTUlTX2dqbnJ3d39/Iysu/wcKkpaaJiotrbG6IiYqbnaDLzMylpqfe39/Jy82ggp93AAAAFnRSTlMAYL8AIM/vAFAAj58g769Av4Df31AAws3p5QAAAe9JREFUeF7tmNdy6jAQhm2wOT6UtMNZyd30Ttr7v1sMId4Jq8LijIeLfFcMF9/oV1mt5ehwW9kZLfePAUf9t+dnCnyPK/IGmZKBxxT5mQafJ3IzLS5L1NKLWixRZuDGRb+ifDteyyPr8Ta/VpQvVvIbq0V+hSgfSwXjnCmabaSGzaytwWlTAgxFWAV/1Tj0r6400r1U1JMWenYRevgmx5RrPg0hESKBcDon6cyiQCLLCEpEHAsoiZYSCWyifqfSpCEciUvgSJhWok7fIrqrPJMRnItgNKlMd2bRPcYCoCIAjHdvFD1U4wG1CKoxPRhEOKB0pBONUt2QHNUWCkEngpBuJirq4AQREZmmDhHRZJFJFJFsRPR48szBJIKvPf6oEeGaTc2iKa6bRvQPp5qK6HS/F0/D/4iDP+UJMItAniiKYvhToiemaPeiEj2XJoZIxAf2b4poPFHyaRKvdaPB2/4gwnz2ycblP+NlF2O+C5YfNyTh9ZQvIRvSekTU+QQ5IvZDq8wnyKG1lxFVPpGQMmIrbARa2FilFqGlllP8EVr8WdcRQq8jzgWJ0AuSdWUj9MpmNhEIaSLYbc0B0tY00GhxTL2mmlGkbnuM1GzYEcYnRO2PmuY/syg3JfoV8R9Zmn/24T9E8Z/GGn+sQ7jPhx8L0FY0wwdDjAAAAABJRU5ErkJggg=="

/***/ }),
/* 1326 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAY1BMVEUAAAA7iMP/6Lb/6LY7iMM7iMP/6Lb/6Lb/6Lb/6Lb/6Lb/6Lb/6Lb/6Lb/6Lb/6Lb/5K7/2ZX/6Lb/u1T/sDv/w2T/ynX/v1z/tEP/rDM7iMP/3Z3/t0z/1Y3/zn3/xmz/0oXYDnwTAAAAEHRSTlMAUN8AAN/Pv6+AcEAQIO8w31OJ1wAAAclJREFUeF7t2MeOwzAMBFCXdYpbJLf08v9fuVCMxXgFRxyuN7fMzZcHSARBytGvxNmJThZ/TRNNP+KTKvFLKNNB2UvopMy7If3R3nbZyPLyIw2Z1EuUekk4ZyVCaw5a/xe0EaEtB21FKOegXIQKDipEqOSgUoDY+iepDG3URQOkv+2cgCoGqggoXSkbBJD+bDkFlbUD+uNseufUpQyhSy5zzgX9QUDlykEGEhyDGyKgdFdPJd+pdxwEyb+nvoHDQZBkBxApwdFAkNofp4WjgVC7bnS6sV5lqoQgPUboAUcHQTo45wCHh5DK1W5w0ODqVQHgITSLdZD1GkMLFVOoWAg1DmoWQltAi45W1YCEy5bKD0gsv+gAgqRvEUCQ9E3rQfqmhQMIkg4q4BgHGVGKhHOh1wQpkpxz56Du7Ev8OHIxdnCMy2C9gU0PyMbuj172FgskPbINmCllFCM7x3R8NWvzlF5r4PgSvdZUY81fZmAXrRxDaDYdziYvo9djIFdyGU0wqefTc+txOc6yQA7cwl6MfRqKEZ4QuGsbhixuW3hm3cLQDV0iPPzuYeiOsglQG4Za6imacNBKhMa5EUwnP9c//48+/4/+Vv5vqhr2BTmHY3IAAAAASUVORK5CYII="

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMP///9Hj8fa6fQ7iMPz+PuFtdq20ulgns6py+V4rdZUl8u7A2IQAAAAB3RSTlMAYL8AIM/vi50ITwAAAP1JREFUeF7t2DmOwzAUg2HJG7U7uf9lR+lZ0QQEDPzKv/iAIIksv/CbuJUHs8V9Ttj34ywP5zx+0HGVx3MdEzqLYc49xGKZGDYPtIVimn8BvVAiQFKgTKScBAhTIk2AkAdrAoQ6WBOgKbEmQKiNNQECGmsKhMaaAqGzpkDorCkQemJNgJATawI0JdYECHmwJkCogzUBmhJrAoTaWBMgoLEmQHyaC0J3QegqxCU/tP6j3a6vf90Psn5Yc/1p1x0j+cua66hdd/h31hY+IG/WXJeIddea+mHNdfVbdxnNX9bWXdiJk4RXCGle6IVsSxbb2se1iLKtxpzLujmO9eEfuIW9s/E+MYIAAAAASUVORK5CYII="

/***/ }),
/* 1328 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8fa6fT///9gns7z+PuFtdq20umpy+V4rdZUl8vvHHCWAAAACHRSTlMAYL//ACDP71kzCuAAAAEZSURBVHgB7ZjBboNADEQXFggMYdv+/8+WlOM7jCWsPVTM8UnzpCiYOC6fDGO9kXGYzpRpmpd6M8v8Ec2vejuv+RQtNSHLVIaakqGMOaKx1KQ8ov8qWg2LitYtwkrAowizon2TPPOi/S2JLCRCR5450fHXkWVOdOgKWUiEjgxzoiaWmuIidkQWF61NKJF50boJJTKIjEdkQdG+CSUyL9rfQomMIusRWUR0oCOwiOgQA2ZE8CBxUVOOqClH1NRf1OGjXfmST9+vP+eBvPLNcSDrMrQJrxHkZ0MJrO+rNuvlj4ecrPMPJMaFrP8SkbPWYFzI+q9+OcsoxsWz9IXdmNaUvxA+j+gRpR1Z0s4+WYeotNNY5rHuTMb58Bf4uFyHKY9mZQAAAABJRU5ErkJggg=="

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMO20un///+py+WFtdp4rdZgns7z+PtUl8tHj8fa6fS/016HAAAACHRSTlMAYL//ACDP71kzCuAAAADfSURBVHgB7dhLCsMwDITh8TN23rn/Zat0UyiCTGstSur/AN/KEWRw5nxoyLsoIcaUQ2M5nVAaQnNDEigHg3KECyY5eBvIIxj1Y1CHSrGBSq2EBMKRxnZoqs+mVkgcTgLnSHMLtKwvaF14SHNYCbQj0vYdtB/1rWPnIMXhJfDO2fE5VKpaYSDF4SUQDiXh4kErTQSkOKwEwqEkqA9a6epjAeFQEgiHkkA9aOJjAeFQEkhHkfrN7je732yt8dY3e771zd5ufbP3/pvVoT+AzEYWs9nHaogym8YsxzrJYj58ACJVWblrQWr9AAAAAElFTkSuQmCC"

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAOVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMPa6fTz+PuFtdq20ulHj8dgns5Ul8upy+V4rdb///9sptJUsHCKAAAAB3RSTlMAYL8AIM/vi50ITwAAAO5JREFUeF7t2MkKwzAMBFCvkZds7f9/bJOToFDFg3UoxvMB7zYDkrljHXXEWX/FeB8idSaGGwoLdWcJFxRJIdEbSyqxxulAzpBS/hma0ITSqzlJhNZmKa0CxBLoMMTZc4uTt+eKbBlyGMIldmSIzieotFakAA5DsFSQihy/nYpVpAIOQ4BU8dImoRgQtCbAYUiW2IEgrp1QDATisrCDQyyxA0BC7Qoh0Ps7VXDmZovJ+6CbfQ662ceom02DbvY+6Gaf1ANRwTdblgoBkFC7gwBIKEslDYhqHfTMmpDak0Xt7aP1iFJ7jWk+665ovA8/Xlu2SpC9TU8AAAAASUVORK5CYII="

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABLFBMVEUAAADkR0H/rDP/rDP/rDP/rDP/rDP/zE3/rDP/rDPgOUL/rDP0gjn/rDPdLkTdLkT/rDP/zE3/zE3/rDP/zE3/zE3dLkT/rDPdLkT/zE3/zE3dLkT/zE3dLkTdLkTdLkT/rDP/zE2LfFfdLkSRR1HnvE9YWVu8nlPdLkSoP03dLkT/zE3/zE3/zE3/zE3UMUaoP01YWVvdLkT/zE3dLkT/zE2bRFDdLkT/zE3dLkRYWVvdLkTjoqvfNkP9pDTmTkD0hTj/rDPyfTnoVT/ubTz3jTdLSkzii5bdLkT/zE3fXG2XhFZYWVtBQELkxMmoqKpgVlrfUWPm5+jhf4zufUngc4LMM0fykUqCdljl295xUVfENkjgaHfilqDl0NTeOk7jrbXkub/eRVmKSVKkP5LfAAAAPHRSTlMAUN8AIGCAz79ArxAw7xBAMABgn9+/gI+vjyDvcHDPYFAQz9/fcM+fIJ8An1CvgN8AYL8wn0Agj+9QEDD/2VGyAAADlElEQVR42q3XCVPaQBQH8NSj2ispCCkEgVJ60BV7ABZoUJsesKCChtI2rYLQ7/8dGgmbt0dgE6f/GUdZl9+83bdZBkWacqLbTZRjsiiyCeXuPOXQkBF/4yZu8BMSHpSAEXY+B8W3uoskD2JMyDg7epAk41txCjLcYch+QQYV9un5SYNA1UaXSaK6Gqom2PmNqgeBA/8gUbWf371oJiIJeoMLFRJLHDVfK2I6Fd1cIiUKLpQOdvIpHJBivRQopWOKEeSoegYvS0ULkgxlN8DJAhNIlURpV0kKjpnDsuiClFQER8chkjN5iYV+vVdTOFQyzY/PlkMnp+dvMZtJb9S5Se+Cp56fnvAQOL//YDqXV2Mbcj2cYTp/QWKhFy/Pf9C1dHwFrB4rvaIg/7GPxz7Q9XQcOyhTeomv38X9S0BJ+06M2ueLPrx30G4PKKpDSSYiUloxfCcLE4Y2lfbZWZt+3YetKqpEMpTY3sIxwWnZdM7cMAMOLC+FPGnPfWiNxtyJ5QRHhERJm0sNw4Vi8bmTFx0REqUiupHi3g1puD9qBvZHDtnjCZmedSUDLn94wnp2GMi+9p8V5EVZ/C6SYziWQCQjIuUZyN+hjh0ScsjicgyUIgU5Mkg8mCYFqVCQDBJLqgMEK3OkEGTonwCAatjLyI4A9fEiJYCKcBalEGRG901htsiJAMHa6j6kkcvDjgDBoaz4UBa2KAo0Jofbh3RofhTIxosIUGsJBGkPmN3moQr2MpVB3F3Zg7MdBmpLIS0cNGjTS1sJ1QCKEIBUWdcgkq79d6gJ12yUTMnV5kMmudaiQVfkw82HEKmxHwm6xF50AkH/r261RRqBYLdnUZwWgRBAJhmb3uIUpQCCK/Iyes9wnobqUFLUgrBKQyUy2otcUA0BBH0L3ThnBp+PDKSR8Um4szTCcGEDxJR04URpPTZ5qIRBiuDUEA8hXZTkTkYVIZTjJbmDmygAMjOYZDJd0a8ROHVEQZA8hgyXFTWdwaQcYiBIlvkq4gQxPUw5KgdBapimhn1uUS2awRkTBULwzEFmo9bUK6w/7fSEL5ECxO+TPLAugLjcOQzl3FeRBLp7dCxnDj+trXNR+IE1y/osK+rLkWVtSqBNy83R11XU8TfLzZoE2rbmeagXlzApbcebci8MtOP+1axlxFZlSwhtACRbmrXhvTCztUqGGBW9uejUzoqlQZ5Y1qOn6yvzYNt1HnOD/wC0yftPssgGLwAAAABJRU5ErkJggg=="

/***/ }),
/* 1332 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAY1BMVEUAAAA7iMM7iMP/6LY7iMP/6Lb/6Lb/6Lb/6Lb/6Lb/6Lb/6Lb/6Lb/6Lb/6Lb/6Lb/6Lb/5K7/w2T/2ZX/sDv/v1z/tEP/xmw7iMP/t0z/zn3/u1T/0oX/ynX/1Y3/rDP/4aZpdJg0AAAAEHRSTlMAUN8AAN/Pv6+AcEAQIO8w31OJ1wAAAeRJREFUeF7t2MuO2zAMBdDEqp1Ylj30M++0//+VpVBMcUduSWqM7HJ32RxEoihC3n3JvjibU+x/YHb4Y3/OCkgJVORBxX+hc2ZeDeUv7UWbjdlafgxxfsqZiOOS7FySkqGbDN3YqVToYIMOJugkQyeGjipUM3SVoStDtQp5hkYZGhnyKtQw1MtQz1CjQoE4i+QsxAkCBPUfJGhgp3Q6dGToKUFPKJoEeYb6STnX3gC1xBnklVFrgFwl/qWphwaRIU/SmbzCyhQodFEahIV1QYawS6i//Mu59AT9oUGhQmntVM4IuY8OpdTpPkwQSvNXZwZHh1CiId1ndHQIJcVBSJb+1u4CjhnC2k1woKkKToBk6f4HuqNjh1BaorOAkw+5NtbuEaEHO13rsiFsljFCY9IYuVCDULMRogj92gjVnxBtW1rbAYSbnV9+gLTyiw5AIOW3CEIo5TctQlrTqg5C+ddIEx2EBEm/ahFSpZ3oIISSfRxJkH0c1SRB9gEZOhGyj2xPGkTeBFU6VFmglpLc4qMhSWuAvAXyBuhogY4GqLRApQ4FSnOKz5g0QYWaFfSIYy1No0J+Bd3jwE7jVaheQWMca2lqy8MvDXQIli0fmuc1dFChkkypVIiMkaH396P396Pvlf83jdr32Ip5adgAAAAASUVORK5CYII="

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8edxOHz+PuFtdra6fTn8Ph4rdbO4fC20ulgns5sptL///+py+VUl8uRvN3C2uxS/TC3AAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAALgSURBVHhetZjrkqowEIQTEAEXJxfuqPv+j3nO6rpMD4OXoux/ZqraJF/oXMwD2STdZfSrbJcmdr8us1bIi4wWyor8PSOblrSiMrUvGx2+6KG+Di8Z2YKeqrDPjaqSXlBZPTGyR3pRR/vIKCnpZZX5ulFFb6laMyroTRXcCHw2OBnw2eBkYH7eVyWNclZ08dT5SKr+l07RsUKORpZxj2H6UdPSQm1zLQX2L6UFoyPzme6SndJLx9kIJug8zToTE5YGOU1GDqxnRj2BoCQHZyT5mhkFAgVWqnkW3I0OxDRxjbwyQolXDr9GPMcGMDoR0wlKA0+6m5EFwGDU8FIDJVgc9mqUEpOfQGfODOSJKb0aQQZ9o9Flrlyw8g3Z9GOUEwE0UId/gdjgQzEiPSYhdy84WREpYPYZITRUFBR0bJTtjSWEJtTLZa1jI2sSQmhCQS5rHRslJiUVWiNGMGBBYqPU7HRoF7G4T6Igse1MpkMba8T893PUsWWGdGjOs1BiUeSdjo3MCrTZ8wLLeqCgYzM6tG7G9M0hBKJOx2YQGkPS88XNgrHXsRkdmmdJ37IhR9br+oER/zKc1gsH8whGOrSREQ9EDevEqGMzOjSY+WGA+dVD0mQatAD98x76EDRsmdlp0Dr4Tuua+1OnYduZVIPWY3KozYgthRgRERH1lPMatsRYDVqrp6sDJIDN8qht5Q5bq3k/KtgyCH/oMzQgpbkBwj9fQgs4VjmSsMSWwwZZL3azoMZ3t8BW4patbx2PWnHLtgANxh7VLc4vsFk41rRLGk7C17F94UHLK+erWsDXu36Ao5+6Yi8IX+dfiMOoV45Xg7rXN2BUWnE8jtphtlHcqYf5r+SB3TU4RUigVY6ljcMD+31wQ8Mw44UiiMabz3AdmHapab2PZ0K56H10hDpH72/s809cs7Zf/LZfRT95Od5+XefKtz0gbH/S2P7Isv3Z5zMPUdufxj7/WId66/nwH9tMOKJvnu1hAAAAAElFTkSuQmCC"

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIAgMAAAAog1vUAAAADFBMVEUAAAAjHyAjHyAjHyDrNp3xAAAABHRSTlMAgP8AwYKAaAAAAClJREFUeAFjGBJgFLCtAoP5/0GAAUz+ggitHwlCo0Lf0BMAAgw+oVEhALCaOYN6lvCGAAAAAElFTkSuQmCC"

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIAgMAAAAog1vUAAAADFBMVEUAAADm5+jm5+jm5+iePCILAAAABHRSTlMAgP8AwYKAaAAAAClJREFUeAFjGBJgFLCtAoP5/0GAAUz+ggitHwlCo0Lf0BMAAgw+oVEhALCaOYN6lvCGAAAAAElFTkSuQmCC"

/***/ }),
/* 1336 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAALVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8fz+PudxOH////n8PiFtdqRvN3U+kIUAAAACHRSTlMAYL//ACDP71kzCuAAAAC6SURBVHgB7dZBFYEBEAfxfwYSeBKwBwWWBJ4EJBBBi++giAw6eVPA7J05/wJMklV9bdOdvpR06xzvhg7nnEq7Zu1ol62jfdxU/QZ6TNCCMvRCKUI5QjlCOUI5QjlCOUI5QjlCOUI5QjlCOUI5QjlCOUI5QjlCOUIZQk3Q2xFGEcYQxhDGEMYQxhDGEMYQxhDGEMYQxhDGEMYQxhDGEMYQxhBGEEbRsxRJf1SjoRmt0WiyRrs2G79uX8gPN2YYXf7sGHoAAAAASUVORK5CYII="

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAALVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8edxOHz+Pv///+Ftdrn8PiRvN2gisSZAAAAB3RSTlMAYL8AIM/vi50ITwAAALtJREFUeF7t1iEZQgEMAOFlwKBRBBgk4CMBdEA/xBtZqEIGipACcX43D6f/ABcRm2rbZUaeS7pmHG6G1lMcS7vE1tESe0f3qEE/jB49wjx7hHn1CCMIIwgjCNMgjCCMIIwgTIMwgjCCMIIwDcIIwgjCCMI0CCMIIwhjCCPobQhlCGUIZQhlCGUIZQhlCGUIZQhlCGUIZQhlCGUIZQhlCGUIZQhlCCWIPoroj2g0NKM1Gk3WaNdm45fpC/kFMH4xdZ2F2rEAAAAASUVORK5CYII="

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAFVBMVEUAAADm5+jm5+jm5+jm5+jm5+jm5+g8dULQAAAAB3RSTlMAIJ/v/wAwF8MKgAAAAFpJREFUeAFjGP5AyMQFB3BWDAUCBiAOQ6jBVJUKVSTsggcYQhWp4FPkBFVkgk+RM1SRC14wqmhU0aiiUUWjikYVjSqCAhKqV8IVNeEqn5TGQyjhZggBMKQVAQCZTZr57r3B/QAAAABJRU5ErkJggg=="

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAFVBMVEUAAAAjHyAjHyAjHyAjHyAjHyAjHyC67rMZAAAAB3RSTlMAIJ/v/wAwF8MKgAAAAFpJREFUeAFjGP5AyMQFB3BWDAUCBiAOQ6jBVJUKVSTsggcYQhWp4FPkBFVkgk+RM1SRC14wqmhU0aiiUUWjikYVjSqCAhKqV8IVNeEqn5TGQyjhZggBMKQVAQCZTZr57r3B/QAAAABJRU5ErkJggg=="

/***/ }),
/* 1340 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAD1BMVEUAAADm5+jm5+jm5+jm5+hpSK+5AAAABXRSTlMAUN//AByXhmwAAABHSURBVHgBY4CDUTAKGJWNMYCRiAsEMEBpYWMswBBNkTI2RUZoioyxAuorGlU0qmhU0aiiUUWEi2hyCntH/NUGPjAyFI0qAgCU2ueifIMEWgAAAABJRU5ErkJggg=="

/***/ }),
/* 1341 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAD1BMVEUAAAAjHyAjHyAjHyAjHyCMLXc/AAAABXRSTlMAUN//AByXhmwAAABHSURBVHgBY4CDUTAKGJWNMYCRiAsEMEBpYWMswBBNkTI2RUZoioyxAuorGlU0qmhU0aiiUUWEi2hyCntH/NUGPjAyFI0qAgCU2ueifIMEWgAAAABJRU5ErkJggg=="

/***/ }),
/* 1342 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAAD/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDOwiOlpAAAAEXRSTlMAcO//AGDfECCAjzCfz0CvvzzURlsAAAGlSURBVHgB7ZjRbsMgDEVdLjRAE5L//9pNyVaxcWNclUqb1PPYwKEJGGyky8UB7uJ7iO8QsBOeFl0P0fVpEb6Y/pzIv0Ujpz+mlKJ9QcaUU2Sim+MdjhDhA7hbK4qOD61HjouNKAG6iXmA1Ihm6CbuIaKEO7HniSAi7aGPYV6ws8whem1QIX83+4Oy4gdraUTB1yL+AcuGhq2cToycTOmUQcnTyVIRvsimBScsE1u8h6iNkqMhx93q+NCDdnJQcJMp+sl70beziDI6ZJuooEsxiTZ02SyiAgPFIFphYO2LIkzErijAROiKZpiYW1H4PnCOQRaYWPbGVV+54M5+VMCI/6TuK64KokdFdV/59TA+IkKF8IePi4a92rCPPW76By3I8SEyPmjt28j4jW38Vjt+8x98HPUPSE946ZHdTyLMIj2t4SKWz+uJFq8RhObzaurHawTh+byWjPIaQXg+T9NjtUYQLZ/nZDCTaPk8h9cIwhvYCwhVFKwlTdZFoVf4Bf0f8WkNyo8uUhFfaLw4Dk3UCYmP7pUGiZJ/ezfyvht5/WUdDxHOB8NbTbjouKiWAAAAAElFTkSuQmCC"

/***/ }),
/* 1343 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAclBMVEUAAACImaa0w8y0w8yImaa0w8yImaaImaaImaa0w8yImaa0w8yImaaImaaImaa0w8yImaaImaa0w8y0w8y0w8y0w8y0w8y0w8yTpLCZqbShsbumtsC0w8yLnKiImaaxwMqvvseQoa2errmks76WprKsu8Uuv5umAAAAGHRSTlMAUJ/fAECPvyCv73AQMIC/YM8gUO8AjxD5Vh+nAAABl0lEQVR42u3V21KDMBCAYUjCoVQQhIK2m4WU9v1fUawOI5BwWDJeOP0e4B8myS7O07+UMw4dzvLTHOc0z+PQ4x49VMJASQ0xGGG0UAkTJSXkgYZHCHHQ4NtDOWjla0P9u3kFLbYu5HFYwFeFSli2JsRghbflUAlrHAroFIdjZQp5sBGr9CEOWxW5LpQDQakJMSCVpiEOJPkkBDRFZSkEbDFUtzeJHXlra5hRLYSuEnvyCmbH2cNuFA6oBkwOc9d/lzgi72BQzDzIRuKEbMBgZkQUaigwMA/tFbVMJ25cI7VELVmvCsVJgA/vH2jQ1meFHXWujYedZrhMyf7jLvrrDwPcqtU9SDfC7S7TEUmRQtbjoXWR5jxaI2GENGq02AKkGq7aFMmGyz9DssHvKEa6wQ8yQbJM/OIESBY9an74HcL9fFshzF4mIXrJQSt8WyEMbYV8J0ArMidBO5zYVkhktkKprZAI7By2EGFk5fqFEK6VByk6qY0REV/caP/Qiocw2L1GxI8027nYRC9OKJ/Vr1qx3zP016FPKxLC0iXm9PUAAAAASUVORK5CYII="

/***/ }),
/* 1344 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAt1BMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkS+GTHdLkS+GTHdLkTdLkS+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTH0vsXob3798vPdLkS+GTHqfIrCHDPfO1Dul6LAGjLZK0LmYnP3y9DbLUPXKkDsiZbGHjbRJj3wpK3IIDf75ejysbnPJTzOJDvEHTX52NzhSFv////jVWfVKT/T6JDjAAAAH3RSTlMAIEBwgJ+/zwAwEGCv71Dfj3AAEO+fML9g34AgQI/PRJobvgAAApxJREFUeF7s1clugzAUhlE/AIrk4IEA8eJe5iHznL7/c7XUAasJckhEdzmrX3fxSSyQyX/5+AhC6nMpFd5RUnKfhsG0B7k7CMolPiU5FZaQ6zkMB2OO5/aGJg6+zJk8hLwZvmXm/QmFCt+mQhPy8cEmB8g3tpvhtyHe04FfG9vN4DrE8VGuQ7n1ZvAmRLEH3NhvBp0Sl40RYi6hOEYIKVHjhBTBcULYE4pXFVhVq3hAKNvDAPvsWSiuYZA6toeOFQxUHe9CzNYZXmKEo5Hl8II8Q4OTgGHnC1pFefmxTQGiU7NOEUC6bVZZQKvGDgvIVHSlA3QuN9G1XddFu6Bz6Dqi+fuF1J0lGGvdKRPY6bWDpNRrDcZSd6S4vSJirhCxBgOSIkqLc7POxWLRrjQqEtC6j1Nz8fcV+W6vblZzhYE4Dqfq60dKsHdg8+clgQQE0YWO939fRcI0c3o2pWbXPqsk4I/BLFJDCiHw8gjhkMdS3TPFC21EZSL+ry794tU7vgGaRMvo/0IP0SH2jp2XO96JidLja2hA5ol5ECN5jGz4EmqRHZYSe2LhzoLz8/hA1v4beoXk5mjJxtkBCNtOtG9BHkN6lSE94sdGLUINsuPpY9x8QHLOS4zLfCIJfovRPw9kTQ69mJyJlJCdAYSVt+tVni1vY06ZFw6Jq3eWsgWBhICFMuvAHhyqwDCThImECZaEGQxVCsmrDyREeBI8IgknGNoUqpDJT9cTLoqBHM5VZhMeSfFA7Fj2NM4Tl7DZa2e3gMszlfflgNReoQoFVL3ige5pezWgiEG9oYg31aGITqGQb4T+Qi2KaFWNImqlDQowWvUNCmh61esOt3X6ekUGg5vMkF6RYcQt48CviG5uDGUa3XPorl8f+gt9ABNELRL8wuqNAAAAAElFTkSuQmCC"

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAAiZpkiZpkiZpkiZpkiZpkiZpkiZplvosex1u+73fUsbZ+ex+RgdYSYtMcMDg8AAAACBgoRM00GEx0gYI9eb3uvz+Z4vWcjAAAACHRSTlMAYL//ACDP71kzCuAAAAErSURBVHgB7dhbioNQEAZh9ajRzu1oLvtf6piBwFDzUmA/Wgv4Hhv6bz61XdlR1/ZbTd8PY9nZOHyg4VR2dxo2aCwJjX3TlpTapsuBuqYkdUAHdEB/m+aIeTrvhc6X+O1iIOFETAYSTswCMk6EgIQjIOvMAjJOXAVknNtdQMqpAlLOIiDj1FVAxnk8BeQcASlHQMoRkHIEZB1AuHreAYSr95W0A2iKgGQdQHNA0g6gCEjeAQTJO4BmSN4BdA1I2gFUb5C8A+hOyTqAln+SdQCtlZJ1AJUHJO8AekLyDiBK3iFEyTuEKHmHECXvAILkHUCQvAMIkncAQfIOIEivd8T7VYUDCNI35wCC5B1AkLwDCNK61Lqsx7+WCaWNLGmzT9YQlTaNZY51Wxnz4Q8O72IJEJgX6gAAAABJRU5ErkJggg=="

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABSlBMVEVmdX90TqqSZsxdrewAAABmdX9mdX9drexdrexdrexmdX9drex0TqpmdX90TqpdrexmdX9mdX9mdX+SZsxmdX9drex0TqpmdX9drexmdX9mdX9drex0TqpmdX+SZsxmdX90Tqp0TqpdreySZsx0Tqp0TqpmdX90TqpdreySZsxdreySZsyMYcVdreySZsxdrex0Tqp0Tqp0TqqAWLiIXsF0TqpdreySZsySZsx0TqpdrexrcsNgouVgn+NyWLGSZsx0Tqpdrex2UKxmdX+QZcpgqeqLYMR/V7eFXL1xkuBzVK58VLNwYLZjldx4Ua6MYsaJX8F6U7BmidNep+hrcsODWrt9VrVuZruIc9KLb9CBWblxWrKHXb+AZsNpfstkj9dqm+SPas5ul+Jtc8WBfNZ9csyGaspng8+Kbc5goeRkpOh2V7JzW7Rsgc/Z7YpMAAAAP3RSTlMAAAAAAO+fvyAQQJ8g37+AvzAQICAwQM9AYHDfz1Bwr2Cf75+AMI9wUO9wYO/PgI+vEI+fv++v37/fYICP359mnvqJAAADQUlEQVR4XrSTZ2/aQBiAbahkkBFESUFIIIQdENnQ7NH27sze2bt7r///tTftt3AQIqXPJ17p0SN8753x7IkQoUQ6PBN2cqJgsCHiZmbqJIk1PWQTkpglZBFyOC2UJpTIw50lqrnRKSGLhSytMD9Xrc7NG4IM8+zJoUPCWdIJtENLopMQXnpSKJoRQgb8aX+LVc5z1om6wlufFEoQSZkLaoswZDBs5a3oQxGXKJJKsAl5mSpsba81mpjSbKxtbx35mhvRhmzis8sEtcU3NYTuseQeoY+BZ2tDLgngq41tvmLDe9FRpQ9Ac7UhKaiFpCr4XAyfGxjwBXoPh4pxjDs/xPDzFwxdQa9oAqz0+Ke9xpQ/avoGQx2gneHNF34nTTJjh92nGe9r3Z97sNQPvFOMD1IqlJHvFK6/RzvDdhB+B0M9X6v/ZnNBdFbUOzXCSVU6p/oxqpOADix9Up3rYz47rCOuuyXeWsRm0+kdlVsIEcAVhnxvs0z7BqEWn+P0oMrynbIQp8LVLpoWOkY+Xa5XzAhR71SGHG56NYQmfxq+DUI1T3ydpcyyCJWE2WJOG24Rgk9QQGv0ciVZqCjEAVduNOuXIMBg5ErsslBWvUzOdd3f4ggNpBDv8I4AaCgvNE85N+262OIo9wjgiS+DoQN1loALrOECGrdjobzUhlC71IUuoTGkAui4hjqhAYJ0daEuGjnu0yCUMGLSaiLIiS50giBNetpnxL+RRklaLQTBWrgAr1JPltaTYaOidvvYUIMJnbd9QqyVKH1rWSnVHhuqSSFrcgwozR6Czn8KeU8VchBko6DrFDYQxNGFHHMvMBYXQqEY1yBOzDQXFgNrL+TAEN/aTt40V0GGIlMwQ4Gp1VAov0OFuAyl6E8u5ZapsJ/jGZkqxUUlXuKGTOX2qbic4wYVUjJkTuVv+3WMwjAMQ2H4LfZgMERBYBwQ2XIR3/9OBWtQm3axnG7+t7d8oFGth/kehxa0oAUtyH7KSUh/yknIaH4Kgg9K5qQpqBpUnVDp0GnQ2Z2C0eLttqQ7YjRRKJBOCroFw+WmRaEksWkZ49X2owpH5dsp8MTh7gSGK8qfTiY4269359rhj49Nle1g/LsXm684b2wqh1MAAAAASUVORK5CYII="

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1348 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoI7WtDNAAAAEnRSTlMAMHCAUACf/88gv0DvjxBg36/SIIO/AAABsElEQVR4AeXVTW7sIBBF4dhUcfkz4P1v9kkdIkfu+7AJljLIGdUg+qTGBfn4Wy2rER3tQ9+yAOD8NLTiVZiGHD7zsxBacRZKDVpnodAg8xS0zUJbg8IsZJ6G0iwU0XoMypOQRytOQvo4VGYhvtq/CdkGhVnIPA3VQai/2lKBKsf0U0jwSo7pEuKrXduvPKYBSA8oo3VMP4FEOVQSkMoNyB0bidb3qZAbxKHQhxJ9+Bi047OdQ2hdQrxfhKTirSpaRiEBTTQMQhW0qmUMWgCexjHIPAU5PPPTPPDMYRfQqqi06eYV2fGV4Wsh9y5tBoWihPL11BbpPSN8G13RvJ/+7xYkaX/LIf7xnVeLVigxlvCaJEYJ6EEBp9KiDrwulHDOZZ9Aqz0I721qQAuDEHxOYJnbZ9SyuoEVe9AOUl5AStqDVpAKfaNsF/IgWbV4b+lCdGmcrvSbjd9+jb2j5pDWe9CuV5DcglKm0NUGGINTotdQrrhs0xuQLgkXWaXQsGSVQ6PSprchXRz+VxIdgDRv4O1eOxArBsKEqNqFOHXaqGQJQyBSLrYdVg2GKxzq93ehfzt8cJC3jaRUAAAAAElFTkSuQmCC"

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAeFBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3Zqjr1xEjsu0O8kSuWbxhwTQXGmTCMZxODXg55Vgr/iIX/eJJwSAmfeB2ziSf/nXTPojX/wlb/x1Hisz9mRQDGlDTGZVvGb1OpgCKy7r8NAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAKPSURBVHjatZjZloMgDEBB66htDe67XWf5/z8ci+NEFNQWex9jzlXQIITMQA1zZ8Ef1s406IcaorpgOxZMsBz7ORE1XVDgmnS1aH+AWQ77VSLqwCIOXRYdXViBe1wQUQ9W4tE5ke3CalxbLTrCUxxVIgeexBmJ0KNhIoJHw0Rwfl7iOBbZ8CK2KKIuvIhLBZEHL+OhCCdIY5oIDkxvcFzkgBZOL9rDBJ9xAhgQMI4PE/Z/ogMIBGEU3/+Ikz6aYCwKAxA4dCIqBFl6HxL38VgIpwyGUC4yAQlQIxehKgDE5CIXA+f/9Cx9IA6Nh7L/W5wHL64VDYsj6VLyhsEMrMm7vGRYKGT47mP+LAwWYRkOm+O0IksUNbCKRhRZH4QCksQ4J1LUuZQYsAkGMWETTLKDTdgRC6T4LGxa2K0P3FjTEjIfpFhEakmyO1YbVhonS6QumYjlQpFMCiRns6LLqShbitPnHUGRwGefe5mIrqeyp+puG7VTUqc4tLRuA1H3sFXZcxqJrkUpiKIAFASRICqLK4q4B/mqqu8rKLl+V9VXKZhQhOPCJ5agyEXRpZxwASnqXGLhTZYfSZ1r8RIpygkFyFDn7njRlhJAhjrXJMY2IoPQbUSUL7X6Iosv/vqTzRd/e4vXb/MfpP4H6Xa/bPlnn+VnGHHOM3muyUUUixYLkS9BcR0yBhzGwvoRkefSfluDV7Gg67uEGmS5h+FG6zSe6EAmCkCWuxe2fpfx8vkz9fwAZ5TrLGxG/XzsyX35ZnRpe3yLRU98m90eczyVadnjrTlC+DV6ah/UA1s+1ARh+vh80jAAOfY7jln6Bz/9o+hbD8f6x3X9BoJ+S+P9TRb9to9+I0q/Nfb+Zh3yVPvwF4vZN+v6b6uDAAAAAElFTkSuQmCC"

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTfO1D52NzmYnPjVWf3y9D75ejdLkTul6L////ysbn98vPsiZbob37hSFvqfIrwpK30vsUI7FnXAAAAB3RSTlMAYL8AIM/vi50ITwAAAexJREFUeNrtmO2ygiAURS0zRL78qt7/Ta9eo2VpNXPgZ/sfkyw4e8OZiWLW4egSdDyUk4qyPFUuUdVpBp3OLlnn0wSqXAZVZXFwWXQojnlAx8Jl0g+UH6R8HSbV1/ELaLh1YZJt9S6n70KU/wRq6vDQTW05bVjJqLegpgsr2WaXg9p3IPXPQbV6KTu8aNgFsSDVOcQ6yO6DxrDRk+M+uqy1vzObXVB/L2jgQ7uzocs80CS3Bd3CrE5hO1tinesyMktwuyCz/vCycalmnUn+K8gzmqVwkJ+/gfiNLV1eKhvZ3z6IVOKw49DhYB2d/2R28wxqyQ2uB7SJH9XMpDbFKusUDZVtQY1dX7CRqWA5VYZbCwhUxGyK8VgUFxo/NzZkOEkMBB2So0LcXgTq17bEviEB6Qgibi0BkThQJQK5CKI5OgmI/ElfAqKvcF+MBMRsmF4Aoh5Llb0IhMP4LgGRf/NIfxSBOM7sTQqyi8WkLwGRVRv7rBGDrst80peAuP9dNOsiBHFVufsiEG07AsWgWBItTgTiitF0haAYezwGQhBtiM4vBQ1hpUECIn/USEDEhlwKyMKxSSADyCSBroB8EqgH1CeBNCCdBFKAlASEALkkELGZ37/sZGV7ZMn27JPrISrb01jOx7pJOZ4P/wApMAqxYXcOBgAAAABJRU5ErkJggg=="

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAz1lxv5wXb++PD6zpX1nir3rEn+8eH2pTr////6yIb848L96tH83LP3s1j0kAz4umf71aT6ts7kAAAAB3RSTlMAYL8AIM/vi50ITwAAAZVJREFUeF7tmMmugzAMRRmfM4eZ///TBxJKIbfQpnjJ3eIcxSOKs1V5Md5QkZeLsrKs6vGm6moFVX/jbf1VC6geGVSXWT6yKM8KHlCRjUxiBT2gB0Sil35Rp/RngFbdait7QRGIGumD5g8oPfsg2dAeRJ0/qLniNEfbjnag1kdq6QxDaLsDeVCHJLz7JkIQkpCDosg1ORtjhAXSW44Vi7GSO9eC462OYimHmDPIKBt6PUdnBemCeXtATSHM0gU2EVY2ktaSa4xxxpimlx44WNlIQiEHQUiy5xzrUpqW+jNOT4ndb966J03CGIFOgN5JAQUOkNJA6nVQmEXiBVYpoCGENowmHcI/JIC27MvpUNlb+O33ILGvPKxTcQ3CC02x8QRXuga5LT5ovcXpstcwZRpBGhJ3CWqhYODTdyAIKaQhCfS2q8wDSgg2T/rZCpKtRbialm2McA023lHLP/z5f0f8P0j0DqV+eUIMNsbY4ccnhDigrLjxFnFqi1Wr3PPMOtUDYluysK19uBZRbKsxzmXdIo714T8T7Yrz4P4iSgAAAABJRU5ErkJggg=="

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAQlBMVEUAAABckTtckTtckTtckTtckTtckTtmmEfW5M7///9ckTuFrWxwn1TC1rbg6trM3cKuyJ2ZuoW4z6mPs3jr8eejwZFPSllgAAAAB3RSTlMAYL8AIM/vi50ITwAAANJJREFUeF7t2LsOwyAMQFGesQ3k3f7/r5aoytSgFNlSh/qODGcABrA5si4xctbXjPchJmYxHFAYErshVCgmgaI3NolkjZOBnElC/Q0EIAIBEj3GZ77VSn6ODyKEBoR0NuG8LEv+qC7OONEZXkOFuruGQApK2Otge7M7am92razblxhua7m7kJD3ejgtoR7nnqHjZr+B1soPIIUUUkghhRRSSCGFuE8//mNU/nks/2Cn7kAY4n+zuB8/aHz8GCnUk9iQRWzsIzWIEhuNSQ7rahLjwxffEMYdt8cZDQAAAABJRU5ErkJggg=="

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMOdxOH///94rdY7iMPO4fCpy+VsptJUl8uFtdpHj8fC2uxgns7z+Pvn8Pja6fS20umRvN2G/uG0AAAAB3RSTlMAYL8AIM/vi50ITwAAAh1JREFUeF7tmNuOqzAMRXsdO/c7/P+fnkZIhOAS2oB0HmbWWytlFSPX28olc73xA9yu9xeX+/3x5Ad5PrLo8cMP8/N4iZ78BJ73y5WfwvVyO0d0u/CT6BX9iSyDQbyQAMCU7hWZhCuSA/W1yER8TwL/hcg6bBCl/lBkE+4g2Iao7YkBCVHti0hdQXOuGLhYqYTeEbFJEB2AC5NpmBtCLmRhbIumwpLlGZhMls/4hcvZhshjJmZPMbGNFkt2WzTWJy1mgNewSExEJLMnriod+BpYmahIZJEgnwk+TqahU0TbTbVKC6X0kEWSb5vchshgBup3b/g7bGyJNC6P+oCZjWGkWqXxYTJBrs6E6ukJyjm12dk6TKYgRMAJ35ciBldAb4oMWDH0p4gJWJBHUkTPDyXUwTjSRgohR/3LIluPuWyjD4qUmPtCHxFJLATTK6LN2isCXGH6RB7Xf+igiYiOBoorr8ZCe2bTYUWGXvDVlNAbIlfysaIcHetIMg1RFVckGHgdnrJRGjG1o6o9s6PvFNE9C953Y+Ik8/Y2tsjetqOtN6nxkx0yGU53MKjyEf1nW22UvojsXHP5udQeI2PAhYvZOl+Cg3mjZHszW+CS6ICpEp4Ftz9GVERCKN81NjYCE9igsUNStIzYoLHVUjykDU00X6eIAkdswvTGkVYMAKR4MQCz/zsg/0SnXbKcdu1z1kXUaVdjZ17WvTjj+vAfhV3JQ/FL3HYAAAAASUVORK5CYII="

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTjVWfwpK33y9D////75ej0vsXsiZbhSFvqfIrysbnmYnPul6L52Nzob3798vPfO1A4/QN3AAAACHRSTlMAYL//ACDP71kzCuAAAAHxSURBVHgBrMGBAcBQBESx4x7237i/M5DoF+mFDB5BtZe6QNR4bQrRPtAofCKUPpHyka8ds9ttGISh8G2CIebHgfd/01VJ5WTGGnPLxTT13BW1nww+tgvTQB/Qsjo45MOGr4Oih7sSvgbKHqTKK6ACipIdlEBVsoI4HqnNBsr8Q9ryQ/ta4VRtJhDBKYddjMUCyto+4tNRFlBSOBwTGkD+3JdYxRO0G0BwKOr8YgZluez+HIgmgZr9sKuSfTbSMgaJwwhiNZw1MjRki+GIpIa4aj9Bpf41UKkgtYswxaIKQoJeYVxqErRU0NT6b8QfQVhHXaxVPSABItAVmENwKusg2VfTnvOe4JLkrHrzF2HT02oLMQjZQYdIHUcyH9TERngnG8hv6KDQWX9h0P2TlxwJqr1jE4MuJ9ZlNPsVx+63w44MHYBQKeoMV7V5OYYGoKyAAgfHCTNvjZ0d9I3ZDhu5LToJMKXfcWwcr9mQXOlF63HGEqlXuLyz5gBcMxZtEbOMPzpbG6FuKPLRo6WxVewGCvvL0mrr0v+XYVsYmj/hd2tSvvUT+vU4qkXaFcCn5EUrHw9IkVKhqqV/rEb6bLGA9EQk86VGT8T6zn0tMsrlNy9+GItzZcN/cRX9gKY9skx79pn1EDXtaWzmY91DM54PvwDIJGf2CrL2dAAAAABJRU5ErkJggg=="

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAz0kAz1lxv848L////++PD71aT3rEn4umf96tH5wXb1nir2pTr3s1j+8eH83LP6yIb6zpWvJj3iAAAAB3RSTlMAYL8AIM/vi50ITwAAAbVJREFUeF7t2ElywyAQBVCNbmY06/43jSYCMXYZdbNJJX/1N34lEJIRxZ6yAkKqst5S1HXTAjFts0PNA8h5NBvUQoa0dVFClpRFlQeqCsiUe9A/xLgQUvV71YqLiXcs7OkQF3ukgWFrZ9dhT4bEFXWUuI/J0IdIljy0D1HJk429pPj2+ymxnWcn100yxKQbxcuuEiF/Sfx15+lQd0LsTU+H9AnF/fdD4KCo/wmImdlkgHq1l5EMddI9vySIzeKKokFWfKenQGGWXNCUCxI9FZLjWUYiJAeYjrIgIe/AfLSZBnVbX47GSZCFTJAmQ+HiUQSo9zMEwAl3TYeL0KEYaHEj86gmQDzcIAAV6mW0HiPITSSP+uJX0Xz65gPENomzqF8Pqt8FSIbYHvsJHsD49xoC8rfcORPDQvYApLiiAQutIkwHaGgIHQV4CGTo4CHNvbMAGjI2fPcDEhpWKYIYQEHx54BFQot4jsFB3AvWPWU0iGvXFQoyJ6N0sChHDASLFNZ90K5ucAjo5cfTSoP8+42/gKp70vxmuqu7xz7MnjuS55S3D6LYylXstNmOxnIe1m3JcXz4BW+4nyeUxl5+AAAAAElFTkSuQmCC"

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAABckTtckTtckTtckTtckTtckTvW5M5ckTvg6tquyJ1wn1T////r8ef1+PNmmEfM3cKPs3iFrWx7pmCZuoXC1rajwZG4z6nhbtkAAAAAB3RSTlMAYL8AIM/vi50ITwAAAZFJREFUeF7tmNtyhCAMQL1uwt37/v+fVqfgtAuycU1fOp5HwxwSRHBSbJQVXqAq65WirpsWL9I2m6h54GUezSpqkYG2LkpkoSwqZKEqkInLolukpieAEACydxdEE+gfdP2HosnoF8zwgWgUOkHnzoomq5PY8Zxo8gK6qXjnMbNc6UxkoohGHZgH9AzzblJUkQvTC6/xKhEeU0XPkI57mSAktdBEKngwwpuso4hCQoAJfHWSJLLRkkbZGoqoD5Mmkd/RkSDylTnETEqSIAK90aEnHQaCKFtZqM2SRQMeMHzH/1oUDxzZMuISLXjARBaJ/Ovv9Iagb0iV3ZAzQdTHQ+PvvyeI0Pj3lknIIkW0ZM5BOHOMOHs4eiEcbPFwPRxdCpJ6i4j0xaN8qub0dSR+leBEyJQswmU3JTwS6SLsdlPkAXwrcqAjhNs9EeAORKATQDaWFukkuZg6I3KZGF9p9MUGl4vdf/504sXOQ9/ZJOg7m47iErGVxrDY/2Jn3yK2Jgtb24erEcXWGuNs1q1wtA+/ADmttCKl8vZaAAAAAElFTkSuQmCC"

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMNHj8fO4fA7iMP////z+Pu20ulsptJgns6RvN2Ftdrn8Ph4rdba6fSpy+WdxOHC2uxUl8u4ap1gAAAAB3RSTlMAYL8AIM/vi50ITwAAAS5JREFUeF7tmNtqxCAQQHPduai5b/v/f9qIHWhwy1odKAHP03k6ZJIIMo2n7aiAru1Pmr4fRipkHHxoeFAxj+EMjaTA2DctqdA2HanQNaTE30I1BMhs7KdXZ5FXnOHiySFkj1loOi24u3hqiL+xQSLfkkNvMJA82hts8svOfyQJCZaFfUYWVvElOQRGpnjpNjkkj4SvHdNDcwjBL54eciEU+/1DJKHIbxaqoRqqoRqqoUkr5P4hhL6DF88LATIjxP7z9rdPBddjZM8RombJD1n2rDLmB+SGFvawhRDidcoMAQfMsblgz4yQzHYFISsEJiqZLSdEjmOOnBA5oxQieJrS0QTYDsx+2TFln18o/CGF4iMilBzamH26wwJBbcmitvbRWkSprcY0l3UnGuvDL/LwudBOSb9EAAAAAElFTkSuQmCC"

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAJ1BMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTfO1D3y9D////hSFv52Nxs8yivAAAACHRSTlMAYL//ACDP71kzCuAAAAEgSURBVHja7djNEoIwDATgQgET9f2fVzjtYbVrkxw8uMfO5GMK/RnSrixrT2RdtjNt2/ajJ3PsF7Tfejq3/YSOXpBja0svydLWGmhtvSh/6Icg8/unuM1AcDg+A91HeVRBganlIfMwpORnGoKTh+BoSDt5CM4zB8GxGMROj0HsxCB2YhA7MYidGMROHGJHQ9r5GjITjoJw+rhJR0OOgoGjIaMSciYgFJEzOTWUsaMhKhw4AiKJHcQHNy1JAwfrhCGWBg7CEEtwYhAkdjTEEpwgBAlOPVQ/tfqXXf/56xek3iKc5KZFcseIhrgQA66h9w4N2QzkcAifgYwcSN5nIDji0pRTgzOfRs/+/9P+PlTWZClr+1Q1ospaY5XNujMV7cMXkGpXAHuYdjsAAAAASUVORK5CYII="

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAz0kAz////6yIb2pTr1lxv848L3rEn++PD1nir4umf96tH+8eH71aT6zpX3s1j83LP5wXaAzMQJAAAAB3RSTlMAYL8AIM/vi50ITwAAAb5JREFUeF7l2NmOqzAMgGGg7djZN5b3f9NDSTSUqY80rnM3/1WvPhFHoiHDs3ECQdN42xtut/sDhD3uT+j+BeK+7jv0gA49bsMIXRqHqQ80DdCpvwm5RTn9EWQsoi+hKgWPsjJ8yOIzH3dyxu+8Y0PYiiHha/FTyHu85vhLo/OGP+wrgK3C3v7yokQDYW1S4ELGYyvpQ25SYULnI3l9kb3hQluDFmipCkcu5Kpjz8USa2NA5udi84cQnMVKByYEb1BoQxNDkA9IyaG1jl8OqWrLoTZ/LYZMhaIYgnRARQ6VA0pyaKu4HNIVcmKo4ZscsnXacmg+oCyHYtWNEDqnLYbAtxcAhM1W1G6BC53TXkPBl4rhQ4r8K/eaDS1I5jUXCkiXuBB4pItcyH4DeXZ7c5MTF1I/t8qkKv0fsuSbfnk73zgauh6SrAF62tn8HqKDt/1eJdB5xA3NSR9AraRiVBZbGxdySJYNF4o05IAJGU86EZiQyxSTHXAg51TCVv1Ff+3QEH2EXwH0tlqP1irH+/CzxBa1eNDF0dAFsoYA+EtLCwGwh21n/ae/+7tdsnS79ul1EdXtaqznZd1ej+vDf9fNljZ0Xy4qAAAAAElFTkSuQmCC"

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAPFBMVEUAAABckTtckTtckTtckTtckTtckTtckTtmmEdwn1TW5M7///97pmD1+POPs3iZuoW4z6nC1rbg6tqjwZGNG45gAAAACHRSTlMAYL//ACDP71kzCuAAAAEZSURBVHgB7Zhhi4MwEESjq3aTNaba//9fq3AVBjJSzv1wB5lvD3YfpBYGNhzpermRvhv2hGEYJ7mZaTxE40Nu5zHuokkcMg2hE5d0ofcR9UGc0kR/RKQuopjMkn7PTDRn25O+Zgncc+TDC+VTxDwwWIzzlahkHHwa5ytRMRxcCVPR6YFB3Thfil4Gg3HjfClaDQbnTJiIiMeWTJmLwINCy0uFuUjT6RHcmytMRPA9XgKLWyRcEYGnCCxuSrkmiuARO7MKYSJKn/cXXHwKYSLS83fExSKEuQg88oOLMOZPAw8g5VQTaTJLkSBhJf8jbQX5z0WtaVvTtqZtTdua1r9pY2vaJvp1/I4sbmcft0OU32nM7Vi3x+N8+Aa2Y2oj1LYHuAAAAABJRU5ErkJggg=="

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAQlBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8fO4fD///9Ul8vz+Ptgns7a6fSdxOF4rdaFtdqRvN1sptK20unC2uyALngTAAAACHRSTlMAYL//ACDP71kzCuAAAAFpSURBVHgB7ZjRsqsgDEXRqA0R1Nb2/3/1omd4Omyw0z19OXc9MwsSEULcQdfLB/TdkHDDME7yIdN4iMabfMxtTKJJCEyD64RC53qh0Dsh8YdEqnINrYrUm/lZmszHOK2IvCVClAYxWMJXRHYSGuFpsJOmyBapstgPrdASq1RYLdEITfNkUSAxL3sGomwqzFZa9aKCRfmDJDYB3O0kxNbOftTznTP9kJYoL32XIjsK3aGhTynyRNM4mE2VAlpYEBRtdnKvpHq7JJKAYsuRBQGi9uj2HE5gbBHu6u2iSGGS7vg7OLzpVvS/LnJV9LIDj3bG67JorYtWKAKpkF+A5EHRXhftXxOpt7fwCkTIg01AZG8zs0Tc0PjJ5m9I/i/S/mn5xwj/YOMftfzDn3cd0S5I1pVNKyJYZQ2r0GKVfqxiNL5THusXCnZlPSGU9qghPLMIDz8S/0VteE0WWtuH1ojitcZozboEo334D3mLWlSbs+TaAAAAAElFTkSuQmCC"

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAQAAAD/5HvMAAABu0lEQVR4Ae2ZUXHDMAyGfwiGUAiBYAiGIAiBEAaBIAiFYAiBYAiBoPWhl+tDU22ukr/b7f/etrvel9aWFBtBGW98TBIUdkORPkNngd1Z+EoDVtgDKwYQUzadR6UCUgS2g4CQCfaCCSdHYQ5K0HFQgo6DEnQclKDjoAQdByXoOChBx0GP16EqCSwAiWuhFkQJHTACCBhOEhoskPbuCFdhwdTgESOACZ3JsIPIfatnPUxo7VlJV9iBXAm1x6EwNrtfAAi7K2C3XWAncQno7KFo//dD/I70VCHtL4ekEimwk5H++kyp2UYgoL/HknsrNKFizxShOWBgDaX2C/0LXSlC+vm7zB9cWcNsogilX9XLMr9xcLd+hZvhVKEBfiC04SygyS7OX8JOHcdvfqQ8eWqF+WDED5PRnPF8BKBPn3t0XhUaMroyou3IKNLOO8p6/4/uSDWMeCsFM+r24QsUstVWeblUEwSKZROtmFHgJv5AtIGUiXDB2d1kMuG+3jsip+nwlfKm4yll7lImLG/pOAxtEByQ5Mj4UilCIt8omIKGtooJBRm5V6ceOCcm8sVUwCUV4fyVK/QHfjLSov4CKA/w38VGg7AAAAAASUVORK5CYII="

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAQAAAD/5HvMAAABjElEQVR4Ae2ZUY31IBCFPwlIqIRKQEIlIKEScICEK6ESkFAJlYCE+V/2YbPplt5JYdg/95y3JiRfmBmYofxfcgQ2DuTLBxsBZwUTKciJC7E/1EJBLlxY6KgVoe7VBMceaUHuu33gHOUtoNI6vSPypqPB/tjtUUAUDjTTpgLaaKZDBXTQTKL0B+gDZJ/U9mVvfzCOf3WMf7mO334M2aCZt7ATK/lbmAqZlXQLJ52unVBrJiMNnJk1yZuQhk6493B2pLF3nD1OHamOY4+UkI5O9cqSzq5UXO4OlLnQhBh4ql8Kfb1aBUwRtGICVPhVYuS/D/QBsk/q8cve/mAc/+qwu1zHbz/sG7TxW1g9Uql/6Tl37KwnRbyrcB4YFBOOF/LDr9trNaN0ZRx2pyFz9bVPPzZMl098ob62jRyH6tXV4HkvYiCPXNjTWXP1N/lshmOP5G+exgVvm8oG6R0Uv18OAg3kKjB1KPcEhMezEB/qIzORBY/X4mSkkbNmv7JlJ20xxU6DAQ0XslGTenz9AyPpWltA3RqsAAAAAElFTkSuQmCC"

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkRwyRsNAAAAEXRSTlMAMICvvwAQ33DvzyCfUGBAjy7W7cMAAAF6SURBVHhe7dTRjtwgEETRBVM9bmDs5f9/NpGilIy80DKdh1W097Wkoxkb8/Ef9FOIW/rdFgO+bLh/4JLEV2OvKGDW3kO7ti7dwcydECS1W5uAyXbfk9whye2Lstg7ITpjyd4JpTZo+7Nvoz31UGzDdgDY5zsh0TGkBSizXS5QbJMqUGd7vEDaZpUynZUQ3m1arfP9TSg2V5FQ8kGJ0MsHvQg1Z98YUp+j//6tVR9UCR0+6CBUfFAhhOxxMghh90A7Ied/KxcI27qz4Qqd69BJCK4zmdBDp/MHEUJ1nOoOKrriaLlBiIvXNSGW1w71HQrPodBBbF/5OHpo7TAljCDRJ47KEEJYfECE2PHkXpxBqA+PdA8tPPAEC5Lc7FqWAfTw1anAhhBMSQMMiJLlWBAl27EhSrZjQzjVcCyIBTUcG6JkODZEyXZsiJLt2BBK7p1csAZBOikLViFIbawKFiD2+df5BDwQ78wDHoiHXE/4IZScC5wQ+1bQD/QL8lrS+j7qPCwAAAAASUVORK5CYII="

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAABXklEQVR4AezVwQnCQBCG0ZSQEqzAGnKwkJSSjlJCSkgFkhIsQVfMgIIMAQ95uBn4YM7/5TXKXc+XU+m29vwboXiE5tJ9bT4G+myIcd4ajoFedV/GibraB2pLSzLQUmprHmhMxonGWgfqN4wT9bUNFKRvGmhP+gXS0/amHyA9CaAfID0JoB8gPQmgnyI9kujnSNfo50jX6KdIF+lnSFfpJ0iX6SdIl+kHSLfpt0kH6LdJB+i3SQfot0kH6LdJB+i3SQfot0kH6LdJB+i3SQfot0kH6LdJB+i3SQfot0kH6LdJB+hXSAfo/32g6Y8Gmh7t3IEJAFEIw9D9t3YKMeBbofDPs7Y5EIhAnpiPtDG/M+b9KFo1LKtBu4PdwTBjuTLtnX0CAjkcOj0LL4i/pAQSoBLBE+IUAxYkzwmkiqDMog6lUKeSqdT7rxauFg4sAE0BbgKPA7AE0QXyRqAkJnAA/73xGudv8tQAAAAASUVORK5CYII="

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkRwyRsNAAAAEnRSTlMAEAC//8+PQO8gn1Bgr4BwMN+O4u1mAAACHElEQVR4Ae2WyW7jMBAF0+HjKonL///swD0NmcrQeYoPOU0dAtTBBUoU2flYIPI5sbIFH7Mo4gAnzHhIPAA4ZjwUoAgxGoqAIsRoyEFx1EgoQkmZGgkVKBs3EoLiuJHQBmWnRkK2v4kbCdm+HMx4KOFBZcZDUCK1/6GN2O1dK8x46ICSifHQDsUR4yFbPxoxHqpQUifGb8gBxQux23d2oXZziqAR4wPSn6+CGQnlBMUTY6HzTkUjRkPnPgsxFjpfRSXGQx3KIMZC9+ckD2UogRgP2Z3hmPFQg8KMhyIUYr8Z6lCI/eaKdijMeCjYISfGQwMPDmKrkITFTdK4BbmG+siL45+55dHnUE9t8V07ZuqpW0g7YzVJIjNlaElDMi5nuScojpgRMMRCAYjzcxmd2bn+8DeUMYXEwajEphCyhsIccjAKszkUNOSnkMDwQuwS8hqCJq+hIsyup+kRknko2PIrt5NxCWGfXrbrn9yu94Q9mo3Od5D0DHl7g2917Me2/cohb3QOKME+SJA1kfUA2Y6IaYo/68QEBeF5aFefCEEKjCHPawRGqnIzUxOM8xqxkpFK55leEq4dC1nJ8C1/V8nNw7COhZTsMTPK3pdL2cvAjM//jKOKr7ijtvigP/60ejh8pa7mWi74ISW/GJCx/CgTv5m0OQzcYoTMRvZWaGuUjfzDbvR2vIyNo9l+spAhsVXnEk6Sc7XFlx/+H1zWQLyYGlQJAAAAAElFTkSuQmCC"

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAmVBMVEUAAAB3slU+ch13slV3slV3slV3slV3slV3slV3slV3slU+ch0+ch13slU+ch13slV3slV3slVbkjl3slV3slU+ch0+ch0+ch0+ch0+ch13slVVjDM+ch0+ch0+ch0+ch0+ch0+ch13slU+ch1bkjlJfihzrlJFeiRpokdTijJMgitwqk5Qhi9lnkRCdiFXjjZelj1spktimkCikAdrAAAAInRSTlMAYN8An+8QgCC/UBDvjyBAz3AgrzC/MFCAAN9Qz3CvQI9gX8S9igAAAqtJREFUeF7V1tuSmzAMBmDANgYS4mwhCaTdQ+09b8/v/3DdRGRMZHnk7PSm/32+EbIiO/uvku8tSi6iyUQ00gZR5QcgbYnoy6FP9w8P3/mSeGjj3vObK4mHdu6QV6YkHlos3THPgSQvg+7AIUqy1SXQLTBcSTz0BRSmJB66BoQpiYdW0GmuJB66AYIpiYe2HomXVMlaI4g6Mq6kSga7IIudmc+TjURz0OLuXPoTgfqEgTwr6jPtqKQ1MvgRGEZJQjIJEqvTEBSLsSKhhocgu+II7caRLEkJBkJNv3l3yJIkD/lsh+vFASrXIdTwUJ/L/T73XKkV82UE1F9106/Kk5Mr7swAwgguvbRkmghkdI1qbyeoYqfRQyV1vGsxpaagjoSuLBVxSiPDLuUkpEnIAENbJQkZdktgq4tsyIrqQy1wTLtHXxaeWqPoJuH0R0uVUUi0ZJNIS2tYaV8Lt9yOU7IRYtgm4Ww3xyWDoTXTJJzF4CDDOcRMErmrIMvVHCpVZJLorDbO52YOSUvmKvpV89x6yFg6Hdnkwp2n8NA+Ain6DYYznCAdEmuFrkCYNE1CyxVAlQpLqaoOD7CcznHlgmwA6uguN3VtkAMDMYRSc1gjJr7TsAPQogig/TtUEp02McfCNGLnxeYiIzoto46lnnSv94+2FVkdOI8/YDx24ynScqlFFrb6p4Ms0x2rRdZj59mdku5YI7Jg8z94KNmpD8ePju2X72KyY80BEibsNCTZqaedPe/3izuDWpsSM0GlQp32UJJTE1f200cgA9D8nXDvENQmFeShHpw36PSFzTYAza/Hby6AeKkWMwiG6c2FEC/16O6HI8MQL0l892v4d6AFyksVhoTp7OO8ScV2TJA0/2CnFxsZDPESD/ESDyVLPJQufRzCVzYD/Yv8BXC1dCbDflIkAAAAAElFTkSuQmCC"

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMPO4fBHj8dUl8vz+PtsptKdxOE7iMP///+Ftdpgns7a6fSRvN220unC2uzn8Ph4rdapy+VugFuGAAAAB3RSTlMAYL8AIM/vi50ITwAAAfRJREFUeNrFmNmOwjAMRcvq7OkG/P+fTok6XMApRHEkzlukcohd26nS3dntvYD97rDQHQ7HkxdyOt5Fx7MXcz4uopNvwOnQ7XwTdt2+jWjf+Ub8UqQnE4KZtFTUm5AwvUykTVgxWiSawoNJJDIQGZEoPFEuUqqJSFEIl5sVh6aG9fkpqqpkwwNo1BWvHx6QgqwoSO5BkOUtwj3ZIAtE8AyUc6liEf17lFdxMsxUKlLwJOztzVUugicRQ53IE/MUh8abAym1UGCnTPS9XXvDPKUikPfUiSwxT4UIKngkx9HIPGWi3lFIkOuRKHgKRXF4yUlE98FTINLEOksnk3nxKPVFdDWBYa4pukEpa6NzMxFmQF6EZphHuzDO6zIi44A+iK4h4dQjAhcSVwwXkBdhsA8Yximix6C3pSI0PZ+WxLd02RRFeLgprpGDeVOUftB7Rp/+wC9cQiCa17yNGRGedz6De/oH5MpmRHhcbY5e9955mwVJiPudeU03VlhzEeJmjC87uCTR7aPI5kX2WaRRo1mRKhKhCLRYdEM5ykIjlKMs2ShH2etHOQoLEuUobBGUo6BpWTnWjBFejvWDLS1RjrWjdoXgrRv+/Nup6jji1B2QQHZkA8FHBNuO4LPmFxcIcppdsjS79ml1EdXsaqzlZd1Ci+vDPyfHB7OX7CqKAAAAAElFTkSuQmCC"

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAAiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpkiZpncuPEJAAAAEXRSTlMAUJ/fAECPv2BwMM8QryDvgM1XMkIAAAHcSURBVHhexdfNloMgDAVgICJ/Dpr3f9k5cyp1vKgBN9xtm69FIE2VEG2ImZmMnp6jpqdY4m/IvodmPmV+CxmGmHfQzFXmN5Dli9gXEO2A89Z6t0PUD+nd8R/W75LuhszXOUmmEcKVuUN2sLZW6Lsw+Er9EO6SHQPJSxvwsIXtH3AghSsy4NIKbWRkY6tb7dDmj6eA5Z8jIQWaRkOa+DKk+yDNt9FdEN1D1AXxQwZAwtIGPGxh+8ed7PFQCG0QViAUmWMThBUIJebUAWGFOrXVuR3CCnUeEWwrhBUFWugD0SJDWHGCfnjPTyuEFQqvlpYhrDigvB7QmmUIK76Q439xMoQVBQp8SpAhrPhAkSFRgK4q/qCEUBKgywoFo11u3f4Mo6GCF7ZWKMAHK+j31Arh2xUOQ74N8jgyKVw0tUGEj1RVhyy0QKE6vKrqC2uUobhWXUfV5z4tErSk+japiwNrJMjAFUBo2kACCJ3tfohIRVruoaU4aUKofoic4h0UE8OmAAR/QNZwDYW1yPZ5iPBcQr6GPHGJnxC6lZi2/B/KgRicJ2iyKx8hUyBDfGS1LdNITiwkxcaxZnt2tvb5KLp7xsWuQcveUM52T2x5JlRozu9Gv+yNK4gz/qRgfgH8mZkt50G+IAAAAABJRU5ErkJggg=="

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE2tizyRdjcjHyBoVS7xwUoxKiNaSivIoUI/NSZ2YDFMPyifgDnWrEVayba6AAAAEXRSTlMAQI8AYBDvIJ+vv1DfcIAwz+fXnhYAAAHQSURBVHhezdbZboMwEIXhMQXbUJf2sGTr8v6P2SRAUJrOjA2o6rkFffqluTH94UyWmSd1pP6RA0C+HiosANhiNZThumwt5DDOrYT8BPl1kAMik0gNikwiPUhP0qES81AuhwzuZhZD1T1UqZAepCeRHBSfRGJQQhLJQXqSDj2PQHvquo9mlJ4XQGFw3rvr3gcopEP54By7ccdByllICWonqFWSSAx6hJAnQoGDQhr0Ag7CSwpUWB6yRQJUg4dQx0OFZSAhiZggBuKTiAliID6JmCAJQh0HOatB1kVBHhoEHwM56BBcBORjIK9DDjEQnAr5OMhr0CviILwqUBULVTJkEAvBiFAVD1USZBAPwQhQlQJVPGSQAsGwUEiD3jgoRxqEnIFCKhTuIDEInxP0CTmJ5CDs9oOz30FOIjkI+LpK+y9ATJqhIuD37Zq2bXbMx1A8QDUWrf4JFXYZZKckYoKSk0gNak5dd2rUJJKD5jeklkRKUNONa4SkGfLgdpigD3DzM+TArrsN7NwN8lGQnERyEPrJ6SEnERv08GCXk2gKUs7WQJq7QiXEHfvDoT9CXHmBDDaYOUPlFlB5hrDJ/iWUbeFkl/PXYS0T6sv5N9mG0Dc1zNJ+8ZSoCAAAAABJRU5ErkJggg=="

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAz0kAwc2muaAAAAEHRSTlMAj4AAEK/PMO+fQCBgv3DfD9M5fgAAAXlJREFUeF6t1WtuwzAMA+DGUv2IlYb3P+2w9UeA0sAmZjzABwKE5Uc+G1CM8rBk/AkA9yGv+I7fhVr/ccbdRvvbwbwJBUCFFGgDqJAA+QAVUiCvoEIK1C5nWA7i2d/p8wYUuFJMhwqudNehASqkQH6ACinQrKBCCtQ6qJACRQcVUqAAqJACDXzkZQrkz0/nNAXyis+EArUOLiRAOzsIAQpwTstDGziINOQDuUIXxHNxIgu1tXNYEmody+xJKJBNWUIF+aygAR2io5rNRtCsihO0WusC04NWC8lpNH9ASJ30RDbFOdwIUpxh9i9QsRVUhNlzP+3+y1x/ho71XM2SUKwdtyx0Ludy+e/nV8pQulBYHgpm+m4CdK5mF6BYzSVAXOjppkCvxStVIO80lwYVOqoa5J3m0qBCR1WDvNNR1aBCc6UhLlRMhwrNrkGz01waNOioatCkVypCg46qBk06qiI0aC4NmnRURWjQ7BrkNJfaiI6qChVgs3S+ALx9hX3GzfeGAAAAAElFTkSuQmCC"

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAALVBMVEUAAADm5+jm5+jm5+jm5+jm5+jm5+jm5+jm5+jm5+jm5+jm5+jm5+jm5+jm5+grtndMAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAABJElEQVR42u3YUZaDIAyFYQJyJVHc/3Kn0+mUtuegaO7bzLeA/0mBJOyQmKaMhzylKHNfmDuKPhtN1nIuJMnQYUmGQ8uKXesyFBLFIZXjUDUMsHoQkg2DNtkLRcMwK/1QxSm1F1KcpB+h1nGUgqPTSq+hikvqZ6jgovIeEsNFJm+hDZdtr6EKh9pCYnAweYYULvobWuC0PEIrnNafkMBN7qEEt3QPGdzsO1RAUG4hBYHeQhkEeQ4CCgkRFDEkUKQwgWIKGRQ5gOQ/9KdDtA+S9ovQflreMSKgENZRSzv8adcR64LkXtkCN2E9a2gPLdbTj/YYZT2PWQ922gjBGmpoYxZ/8POUlDsc88f1pjgWCI6VBmfJwl778BdR/NUYf1nXnFoffgEORH1qQbrePAAAAABJRU5ErkJggg=="

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAALVBMVEUAAAAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyC/gmIZAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAABJElEQVR42u3YUZaDIAyFYQJyJVHc/3Kn0+mUtuegaO7bzLeA/0mBJOyQmKaMhzylKHNfmDuKPhtN1nIuJMnQYUmGQ8uKXesyFBLFIZXjUDUMsHoQkg2DNtkLRcMwK/1QxSm1F1KcpB+h1nGUgqPTSq+hikvqZ6jgovIeEsNFJm+hDZdtr6EKh9pCYnAweYYULvobWuC0PEIrnNafkMBN7qEEt3QPGdzsO1RAUG4hBYHeQhkEeQ4CCgkRFDEkUKQwgWIKGRQ5gOQ/9KdDtA+S9ovQflreMSKgENZRSzv8adcR64LkXtkCN2E9a2gPLdbTj/YYZT2PWQ922gjBGmpoYxZ/8POUlDsc88f1pjgWCI6VBmfJwl778BdR/NUYf1nXnFoffgEORH1qQbrePAAAAABJRU5ErkJggg=="

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABKVBMVEUAAAApLzMpLzMpLzMpLzMpLzP1+PopLzMpLzP1+Pr1+PopLzP1+PpSWFwpLzP1+Pr1+PopLzP1+PopLzOIjZApLzP1+Ppma29ma2/1+Pr1+PopLzPx9ff1+Pr1+Pr1+PrJzc/1+PopLzPM1t02PD/o6+7U3OLy9vjP0tW1ubyPlJdPVVhcYWV2en7Cxsjc3+GCh4rr8PPR2uHt8vXZ4ebw9Pbe5erm6++Pl50zOT7W3+RITlNpbnHh5+xSWV6pra9DSEycoKPj6e1mbnPo7fG4wcg9REhweH17g4hcY2jb4+iZoqjP2N9UW1+jrLOosbaXnqOFjZPCzNLW3eHK0NRARkpNU1e6wcatt71XXWHKztGcpKqwtbi6v8OcoqbU2t/j5+pwdnppcHVEyhkeAAAAIXRSTlMAIGCPv98AUJ8gj+/vjwBAr6+fgO/PUJ8AgM9Ar9+/YN8PNHb0AAAEaklEQVR4XpWYZ3erOBCGIY4x2N4Ue5O7ublOdkbg2ntJ77m9be3l//+IRUZGII+C83zyMZxHmldiDsh4AnMjtZlGQXoztWFu6TF0FzI2dyik7czzRM43OdTwbdaxKAziv+1XP6OWU4Cd7bVETqHXf41afrwGgIKTLDrInzE2Qz2s3wPIHySInJejMmNseo86HhljwxHAS+cp0X5+8o5xhpVqrX7awCjNVr39Aws4q0B+Xy86qAwZ590EBFx3Mjt/uGp3YMFozsJbDnQiP2XGKY8gCleDRNzE5j0o0CIbZ9PFtAEokeQsKJ+9GRUokY2IM8bXJEkElTfcc3P+vvviuyXG8kcROX7KQIoUBnP2ATlF9RHJIOc9T5kWqUw+4oJMXGTmkNOFtUVQCUQ5MybaC/QXzxDBZWDai4qKGNABgrePH0jRKQYUhUgWhi6h8VqI+AAEdZTFCZEt3E1YoRoU0KjCCm0U2EvRIQrq2lHRvQKVDi45FKJdFNTUW5soaXqg4KJgNxCZiHTWNRejuOo4chhzIUohUll7XVTpenTdmFqIcij4dVKJpNzAVS6jmY/+CkU5LspEm1/5WrSQK6SQ63E77rNfMCTji+xQ9JZxymcD8E5RR7MDo8kwaCSytdu+KI2Ce7bko4t63E9syWMoSm8Zcs3+GIveN0UaGUFA+eulXDdjAyPbenBWljPWcs579pCvTC0UbRjh4rfFWlyXTxJEr8vjnrqVUsam8LQgpJsguiAek01DZO121KdRjwerg6YN6nl18SlOIYK3vFeIXI9qWfrKJBdSRFxMrkzSiIoadKdJrkwmasilV0bRV6bwXyDiYZ2PdI0xuTIY3PGS2ob3E97fTdROvX5lcM3enn8CMGDMX4dAwV2/smHw3mGUevzJAYUWanBBhXeUHpSMI2A+A4D1NkALFAbMB+DIyIq5xfFQQ201IsbmAFnjWPxUaGoroyM6NpxgchVFdKWrjI4IHMMqAW+Mt4roNyT5fURHVLIMqwD8RW4MMSr9eySYsTIdUcEX7cPEF/UhxphNZ4RnykekItr3RVa+wnxic+4xagGgzHgIRER5i4uyUP6MJ39GC+OX31VAZbT4PzrkYPr5CwPILkQO/I0+zbacbziywi3zkTF16i7izRzAWYisnRqiUMnb3wDFmMmFqbaC4L7CjhWItruIoUoU0JeF0THVmrJBbQuRZWNIqwNztghQQMb0z9UlhjQL1lJk5lDy752cPR3T3UNsa+ScUGQVMcqDyJNmPMU4ReWFPWoagJ6qslP3qE8ImZ8WT2meOZP6qEk2eQ3pUD5qBEWMUQWaFhWQEAlsjOLSprrisbekSGfqEJ4LyiNFtKnhgUrVJTxSJClSJv2CFfWnNZnYLnjNYnw5ia975qljHzO2M29iopv4PjQTzo+K0UnFRLHpFJMPokyZ+YluRra51onW4a5Mm9pEu4drH42ZqRxiK/AoH3C5lPnMw7oXJVjh+6TDOhrnOHsU2kpH2WPH0vM/pGdlcqBdoj0AAAAASUVORK5CYII="

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABDlBMVEUAAADh6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O3h6O2zvsTY4OXY4OWzvsSzvsTh6O2zvsTdLkTeXW7goq7h3OLgxc3fi5ngusPfdIPdOk/eRVnh0djeaHngrri8xszaN0zIdoTfl6Pff462tbzb4+je5ereUWTTUmTBy9HDiJTFf4zK09nQ2N62wcfLbXzH0NbNZHTY4OW+mqTYQFTAkZzdw8vUgY7Y1du4rLS/yc7N1tvW3uPT2+DZhpO5w8nTXm/bZnbUmKPbQ1fUo67Oh5Tdq7a+pq/QW2zVSVzMs7u7o6zLkJy+vcTccYHWg5HQcoHb193Dn6nSrLbIgo/GoqzeztWBk7vtAAAAE3RSTlMAIGCPv98AUJ/vQK+Az58AnwCAgYqj+QAAA+NJREFUeF69mNdy47gShkkFi7Rk76x/AIxBOTlnTw4bcw7nvP+LLEFCA4gmBGm2Zr4rXbC+agjdjQasDdiNZqsNQbvVbNh7eqw9DR1HOFTaTmc3kd10ocFt2luL9rvYSHd/K5HtwIhjm0U9F2bg9gwi+wBbcmBvEnVcbI3b0Yt62ImeTvQEO/LkM4klfx6SawAeY4FBMGGMhQFwTQ4/f4/1/tchIWS48CmlDBsJaEH6CyHSJEVHhDP8ziyKqOD+Z0KOqqLO/IRwjnNRjM306YrTk3lnfddsF7i4JOSK5kQwkEXeF6XJg2uviYo8vP3+B+5hMPOGvDimnAgHqqgHP2YspZzRUxhZ5MGTMy5KgZ4U2S5iue5zGDknOdceN2XF4oTIAZjcicvFVgG9W6BfRARnJdoHMKCc5Vck5wKDJRtAz0X5FTAJM+TsC1G33Iko8oF3PJn8hNIEeoY8IEi6pch+tPovaQ5q8adLmvPj1U9QsAtREwrz3HPDPVPUktIVLJOiZiFyK2EXntRHHRlVmGCFy0WdtZSNnt1TTgBtRBIPKzq5yJHrXyqfaPDDyXNCZqdfc1GIFU4ukuegRwWjb2DafEzWwm7vWfbj/nAzOzel9ZDnSwaJbTUgmaaMxd/OCHmJDbzMRSeo0LCaNXVkFj0KuWm1UOFVLrrEBnihvUKFltVGhdckB0G/r8sAkvMaFdoWakW82lLUkl0VLS2NM6jUi+5SXbX5snElvl7kJUn8dnx1T3XVFiRUEulF6mdLvyYe4ZERmUX9Gk/ZkO/PXpBb3wszbFqa0LAIdfCGHM/krmlF8Afh2/H4YYZ6BnzFxCyS268/GgGNqK0X7ZSQH1oifhR5ASStDyra2VmZaQO1aBuQTFg/wIlR9DCiJbHaRuz1CSoJfxVdQstvNd0ftmi1Socc3YzHz1Lah4apSHzWVzztteYPRhUGulTijJ9jDadyHIWJQSSq7bS6+E71gMxi8UfqlhaXHjKEilt3ZN+Nx7+HXgZoq+0PkjOHQlMzRMyhJaQ0+ZOLzhGEjLGyIdvKWDNI6ARirMEGgoFfjDV/iZ1JAXSVQQv8uI7kCAXDWTumK5RBa88RouQpD2ib0U96poCjDKMiP0ZnxeqN/F3m5CSKAsC11fFYbCw9fjAGJPZudPoGBb3KwC5MNGF9z+AJymS6vEXOweMrxLiS1VpCHjpvWxdQrhAlxaXm7liIQrPoH8JRLzWCI8L5X5zoBz+1cJP/DwnnSHfxA4IoymAgiDIshtWLnzRdYxeqV1HJf70cS3a9rn/cB4TdnzQ+6iPL7s8+n/Ihyvw09qkf6yQ7PR/+C8ZicekGzUlkAAAAAElFTkSuQmCC"

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAArlBMVEXx8vL/rDPdLkQjHyBBQEIAAAD/rDPx8vLx8vL/rDPx8vLx8vL/rDP/rDPx8vLx8vLx8vL/rDPx8vL/rDPx8vLdLkTx8vL/rDP/rDP/rDPx8vIjHyD/rDPx8vL/rDPx8vJBQEJBQEL/rDPv3uH/rDPdLkT/rDP5yoX6w3P/rDPdLkTz59XiX3DnkJvzwX/y7ub5y4f0kAzdLkT7wm//rDP4z5OZmZrx8vJBQEIjHyA9uFPKAAAALHRSTlMAAAAAAACfEM8QQJ+PgN/vIM9gr4+/r+9AIFCA3zBQv99QYJ9wEL9w7zAgz+VGmoAAAAI5SURBVHja7dZtU9pAEMDxC23JMxASAygI+NBqq1Zo9OL3/2JdHi7beBt2kzdOZ/y/YCAMv2EvdwPqW3PrVVlrtf7anGp+a11arTtBKxtadYJKok/oE/oQ6OKtsYsvZIq+/Haij4G6jUY30EQD1bpzTXbeGgrhU69l+ap34fOwNbSbrIQMVEKdZtM0pNtD9Gh61B4yPW02T/hKdYc2EAX5zr8pp6EBCeFix0URi6CQHA1vfwH5Eqh5QyJ0yUMQc0QSgCIRFFBQUEERQIkDj7EFTe/rUmY7maq6LKB+Ab2HkvpXvT3bEp3d9o75xS4CmsKliYOBQ0o9U3J0IguCZghtG/ppoOjg9GuL7cOOMPeTgXqm9AAlNzOEYJem0zlcjeWj9Yuq2EC4bt8rx71+oJyHa1ftAwfzLWhSOZ7W2336XZ6LTpocIRzNlE73zmKoaQgaLsAx6zy7SXA0aDapqPmV77jgIGRJrnFMCNUmnkS/NAFhd8axoOgwVlpZL6egZ+PYUDVxZEb8fQJCx4LwHf9qzkKUg3cNz+uPP8xoL0XxHCi+XEM0hOW8M9IsJPt5G1uQ+WmsNWah0IJKyIJCFvJkkMdCWjaabg9hXaHHnfPYBLksJEz9f5AnczzphsTo2x+KjwhWQh2OyEgGjRRbLhktV3yBFhQoQUveWSpJgfAL8WWckylZrsdsRldJpeEpZ4gO2wIl8k+EPNdj5pJLGbPO8oIlsX8C1aUgrzM5MB0bjUPvuDTh+PQ5/QslQeTPYHJO+QAAAABJRU5ErkJggg=="

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAeFBMVEUAAAD/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP6rT3jtWzLvJy5wsK0w8zauID2r0bCv6/xsFDusVXusVW0w8y0w8y0w8y0w8y0w8z6rj3etna0w8y0w8y0w8y0w8y0w8y0w8y0w8y0w8xmHceEAAAAKHRSTlMAcO//AGDfEDBQj88ggP///////////48AzwCA7xDv/5+/MFBgIHCP7/GR5wAAAfdJREFUeAHU082KxEAIReHEa5n6y/u/7kAYYaq5MUI2Pd+ySZ1eqFtoF0B2zdg0UHApr0OGi70O4dfxdSH9B6HjNlQNsJYLNQOs8lAVtjFs/L5dUmnIAFIqwY8wFjoAWiInUuBYSAHXNNQQhwzONBB8uN3/UesDl9GbOjg0GtKC9R5mF/whfX6EChk/GcYp+CAnH6/b2HrUAWJMunAeIgtbBZRUcgIk5LzDS+zOeGgKbslUhocGAiMfOhE6s6EpCMlMhjoe9GRI8EByoYZHLRXqeNTvQsVwscJnTzZgeeOhHQ67KhJUlzceEjhINrS88dDyyZEL/bRaB7sRgkAcxk3Pje78V3YLYrcolPd/wxrbNKuDKU7nd/PyJQwKbp9qQ213ISzo0rWFUPXSroRfdOVLqxx2b7Bhej7smu2/EXboxra/4oXsCQzd34qa7eP2EzEosK6ocVsvz3NG0VAVelpbSyjyY03o9f1hsDCPtsOBj4BVGKbj0Ozxgwz+ZuNBKOKskEqhGef5mYdGD4nIQp+QmfchCxmfdiFIBa0QolbIaoUwCYfNDN+hlNeGh1hYQxn/t4RGC5WQtMNCGTqhBKVQ1gpZqAgNdAxaoUkpZJ1SKDqdYQfnxNvPjtoERnj4Z4UBLeQfLb8gWUl+ZWcIsZ+IlC3OYb81X1H87AfbkevdAAAAAElFTkSuQmCC"

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAz1lxv0kAz5wXb++PD3rEn96tH71aT4umf////83LP848L+8eH1nir6yIb6zpX3s1j2pTrI9RI9AAAAB3RSTlMAYL8AIM/vi50ITwAAAadJREFUeF7t2NluwyAQBVCvGdbFW/L/f1pao+oqkyCToKYPvo/GOggLxmKa77SdeCNd28c0fT+M4s2Mwzc0XMTbuQwRGkWFjH3Tiippm64O1DWiUl6ETogm7yfKjByFohOlzMhRyP9kyYwUQZmRv4ZO6IROiOgptMiwQyrIJQdheeKQDh4TdA4ik8oTg2jz95k0h9CJIQbd4giPJQ6hw6Gb8g+jJIPAgaUxh8Xc7iBwDCWIO/MObDNQGwGEjkpzNMxR7vd1B5RyCKEDEDqGcAEOlju7X8gpdBLEnQTxDTFvifToIEQzOgnK7Ql0EJrA4QdBqpyDEKHDIUE2tycQAgcgiJ5AgA3Bl4YOQvnTjBCWAw5hSAaVFLl8pEJq7ujPQlcOXQuhfZ9vHNqPyHwYCvg+nyEchiR+JP6J5GFogRqagkdyOQyJ6eHUEvyDkPN7XPYhh3jM3cmECmdECaR9irJOxzirfIougsTqn2QtvR3Zx44VpRBK6JRD+CvCf1s5JGhFyquVXr5BkrNmV4x19F/utCdUrclSre1TqxFVrTVWs1kXU6N9+AWBHL6bJciaSAAAAABJRU5ErkJggg=="

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAC+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTHSYXH34uX///+2a91vAAAAD3RSTlMAIGCPv9//AFCf70CvgM/BTNtMAAABNElEQVR4AazMAXqDIAwG0ATkl0Sxev/Lriu6rfOjIuEd4NEH7PwQsAuDdzyW0VgQJeAkSLwXsVcUqOfqaJrx0TxVRSy4JHwdJUUFTRcRL6i08KfIKappLEcJt6RSJLhJTtHxGCayPICco4Qm6X8U0Si+R6xopPwWLWi2/I0SDNJvxAoD5Z9IYCJHNMFo2qMZRnOOGGb8ijzM/CtSmOl3FNFBfEaCDuQZBXQQRmJ0weSwe6zbbesDO0f+eLYmx+RpQLa2RSuygQKyrRGyQOgT4asdOzQCAAhhIGjTf8XIaGbWAQW8ekLubj/0D6kPyVaELS2LERZsKmpZ+LNzpA4kO9msRKhao4sWq36ujLJ67Aq7QwgGNQ6zHPg5FGVwDHC9EyAQjNLwkgVqHyeioBpDsq6z0ocDpSyjporx2Q4AAAAASUVORK5CYII="

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAilBMVEUAAADdLkTdLkTdLkT/2YO8vsDdLkT7xHvdLkTdLkTdLkTdLkTdLkT/2YO8vsDPbXrdLkTdLkTdLkTdLkS8vsDqblzymWvPoGB5OCFmIRPseWD1znx1IxmwKTKiKCzWLUHhQ0z3rnPmWVT7xHvfOUjuhGT5uXfjTlD9zn//2YO8vsDPbXq+tbjdLkQtfbxxAAAAFXRSTlMAgAAQABDPADDvYJ+PgAAA30C/IICRR6lXAAABqUlEQVR42u2V23KCMBBAk8a2gtp6AQTrXVQW3f//vSpGFoeJC8ZpndbzuuEMe2YggsdLU++DRbAnXtMDjyAi7iLy0hyPEXFrEb8k4lezj/0U/U/Rfn8f0Q5x98kiuAPqDQ+8qRcGwcybDmY4TTuRizmujaiFBVo3i055MN5sYmRDCTbPNgFItmwoweXxIcOnUDVFbcwIQBNgRru2SOeBHB2qvkjngWEYReEQdKj6Iok4gqMnyjiaYIQoWVEZyAhPohAyGkaEeQRHviLNw4jgL4vGE8TJ2FqUTGd4YDZN7ETBHDXzwEK0WGKB5eJG0co/G84+f/VuRJgGSsbnnWjDWKq635rb1Y+uk6z5Wmu7bi1Rr58vA5p80X6vsmjQorwEpW8NKomUdChOEUrlSFUWMXEIJpVg4hBMKsHEIZhUokKcSqkEH6daKsHG4VMVRdIUh08liyJljsOnUkWROQ6f6nI1Uxw+lbyMrQxvQ3e/gdKPDQzQ3W8lorvfUkRXdl0RVSmLaMaLylVIVJoxIqpSFtGMF9EyZRHNflQEV0TwFD1F10Wd20SdhuYbs2SRuYWy8tAAAAAASUVORK5CYII="

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABXFBMVEUAAABckTtckTtckTtckTtckTtckTsiZpkiZpkiZpkiZpkiZpkiZplckTvC1raxx9iWudOEr9BooMtfnMpNksY7iMOZuoWNtNLr8efD0dtEjcV6qs6ow9dcr+2fxuPJ09vy9Pa+0uGcrbivvce/y9O/ytHa6fRHj8eZqrXZ3+NUl8vM1drz+PudxOGTqLazv8js7/Gpy+VBisJkl72CorlsptKsusPS2t+20ul4rdbGz9Xf5Oj5+vqmtb7m6u2Rp6ZzmmmCoYd7nnhrl1qOpZ5nllJ+n4B3nHCGoo+VqK1klEqKpJdVrO4sc6lIm9k1gLkiZpklap4yfLRSqOk/jclPo+Mob6RCks5Ln944hb4veK5FltPm6+7Z4ObM1t1Lg6yRs8w8icTI2eZZjLPp7fCevNLS2+Hs8PI+eabj7PKDqca6z991n7/W4uz19/n8/P3c4+jP2d/////x9flVeOW+AAAADXRSTlMAYL8AIM/vv2AAzyDvkJpDGAAAA3pJREFUeF7M1NeO4yAUgGHfxUnm0Q7dtaT36eX9peVYKJgwuyb2SLP/jW0p+gQHlAiLJ3xEk3iqi6bT+YyPbDZHaP7AR/cw19CM/0CzaRR/B8i8AF2Ry1ApjiY+w1K4lrLAiUceI2pwqkWQ5EGigJsKMQjKActlxnkmzccQqEKmINxECpSqARDFAQsLC6Uhej9EvAVI0BHOq4QCmkkVBG1wY66Nm9sQVEyUBED4+9KFSg0ocGL9kPJHW4Ef64VAx28yAGV4IxhFSGXDobK7VcgHQxv3QCAbCKVdOcUFBkOipCjQUiCUdKFEQ3X/qSmOMQUm5d3RCpfYAzGlmJmDU/8AEPKT8ENQikBCOCfJKIihwzrvwGqcXs3uhPLulauhU0ECIbsz+f28VGbONggCnbBfTtScbTDkskAl55I6V2oQVNg/uTwYsjOwELPzSkMhOwN/YgLRIKhvo/8fhNMbD9npjYew34LOu/Vhu/3UIYTP7faw3p3vglaPT1+fJgNd+3p6XIVBq8OlBV5PzfviuFwuEdKP4+K9Ob222OWw6oWeX1pkv1iaDHRtsW+xl+d/Qjtk3va4Dg+yHfdvSO3+Dq2RaT6sYSG3jwaptQP9aY1eepIHojgOUwruxop0LBbReqEOYMWiXFXAggWFryDLd/km9vtfPCeNnWkyk0Lwt+lqnvxzSniHeJlkjXFUOi6blFKE4GOWj0tHRrIKr3VIeAJ0gs53jFhlGvcLJZWtGPtG6UQKVQDCG59aZoLY1bNNbb2ubc6qdmKZ1ileHaCKFIogYEo25eGL81rtHH3Ks0tARZAaMkwqdrFJuqBipqGGHIAubZrq6vomZm6ur2gq+xIcRwrVAXJv0xATSkO3LkB1KcQaKDW3g5roNJgcYi2Q7jxx1D137sU53h04LaaCWPsBKZ+v6jw+xczTY4ev8ZF5aDMVhNWRily/SxV1fTdCpg6MGsJ6fSfC3IE37AoXa3aH3gAQyOn3GMuE0Bo9v0SKXp5HqGRBvNd2qz8ei8R43G+1XzmSAWWWDU12dyZSaLo7NJVC5G1X543IIRLs5gREBZHZfHtmPiMqCJtuSc3xPGoIew8zf98kfEcgDeU5wa3F8kOFfCwXXOHlcxqR9zkLwtVKJFarMJh9EnlaTi+SP6io5/TCwf7OQQEgvbD3pmJBBwjS8vsweQ2NH3+r5YoeKQ66AAAAAElFTkSuQmCC"

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA21BMVEUAAAB3slXdLkR3slXdLkR3slXdLkRckTt3slXdLkRckTt3slXdLkR3slXdLkR3slXdLkRmnUV3slXdLkR3slXdLkR3slXdLkRckTt3slXdLkRup0x3slXdLkR3slXdLkR3slXdLkRckTtup0x3slXdLkQpLzMuNzUzQTU4SDlBWD5GYEBLaEJQcURckTtekz1flT5hl0BjmUJkkU1km0NmnUVon0ZqokhrpEpsVjNtolFvqE1wqk9yrFB0rlJ1sFN3slXKjTPdLkTfNkPjRkHmTkDubTzyfTn/rDMI1QkmAAAAJnRSTlMAEBAgIDAwQEBAUFBQYGBwcICAgI+Pn5+vr6+/v7/Pz9/f7+/v77Bqht4AAAHcSURBVHja7dXbVoJAFIDh8VSaeYgIk5CoULOzFmmpuLOT7/9ESVvc6owhDnfxX7oW3xpmZiMTl6vUarVymslWHGOn5aSUkxtTelHC0seL1Sv720I+QdbRjiREnR2m5SHaekmI0nOSEFVLykFUJSpIjwiq70QC1StJFgGkF6M4/tMthk7yXlMfcpNGfcvNPjX5lPsaETT5eqchlYGmpXE85SHGYiiGYiiGYujfQdmSUjUsWMg0NCWfCeOkPAjEjQYnB7ubKaoJa6Bh7+n+zuv8eC+IKZgAIIT6zsOdX9vpXqipvxgLQAi53bny8Nwf4Y/aOiqPDA8NnPlSesNFX00ImEQVQAgNOvO1uLCSleWcjAVCyPWZTh9Eqau7Y4MQ6s4Yx4U1VRNLDoAIGrY5hs9ckDIghHrIdGiDxRLdQVsI4Vnd9yAozYcMEEHotF0ILk8bxEPoOLBJNm6TBUs93l55UMPr8ur2cRNJ4xb0et2cPo/QrOb1a7DkTYsJ1A0+ixB1EwgpjKV4B6FQkrX8Zg0BhG3wbooAenl7ewkJFZjBvxoWcpMQIim8QxB3/BQdfzCkAnAXsuUjLbqQAZVYHiIpgxMincFYNEvKsmmqvFNgvykROFhKs7dXbPyj/AEwMyLVRTwH7QAAAABJRU5ErkJggg=="

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAACU0lEQVR4Ae3awa3UMBDGcRfAISVsCZFoICXkwn1LSAnuYOnAR4S0kktICRGC+96AE75wH75IPJRFTkYbe5g8dlb6u4CfnDiTrDva78PHq0f0O4+cZvNytGiZARmQAYkC/Xz/JiCn1bwcqRwQg2RAaRvJgEZEDJIBLboY0D1QRPRX56cDouvbBk0ZII9IC+koOC1KiHigu1p9IHmc7gVnB1CSRtLGOSNaNGaAOkQbTajRB5LHYYEYJCeRFk5AVBFI7BlJFSeTzwA1PI7cyaaMwwMhx8PInWzqOAJAqeZNWw8nX1cBaG5UBBLA4YGmHUheH4jHGRBVABoR7agTABJ8zuFrKgPdSu9HkuMD7chVBip+PSKBc0KpMlBEVFB3JKBpJ07aAPIMgNilVhvngmhnYzGQwKlWE6dHdGCghE6iQMzbwKQOxBe0gCKiwqI4EHp0F+kc6fn8BlBfESj+a6CbPBD/Tkhq4i/F8YheIVAQB+JvzMpAfCdpoICoYh0HpLGLSsYJeuVACTVSQEEDSKCBB9LfPZpANwmgcFgggUlff/foA4WaQEEfSKSGAVLfPdpA5xpAl5UJPCCPetSt1COPAhpXgNwa0NzG552APOpRt1KPPApofGQ+e/SpOaIBtcgV1qIBRQ5o8fk5oqHS19MWDSgiYoCOk/2RnM+ADOh/BPr67btH9CfLzc3LS1SQARkQc4kZUKZPn780KCF6otyyeeEaDIhvNKDtTigZ0Ha9AfFdDIgvGBBfeBqgd9cftJ5lQAZkQAZkQAIZkAEZkAEZkAFZvwB5RcWGyW2yLAAAAABJRU5ErkJggg=="

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA9lBMVEUAAAA+ch0+ch0+ch0+ch0+ch0+ch0AVX8AVX8AVX8AVX8AVX8AVX8+ch3nwUfnpTBuiSlsYDtugSPDsD7DmixWfSNWeSCrpTirkylKeCDzxkrzqDJKdh6GlC+GiCWfnzWfjyj/zE3v9PcpLzP///8AVX8QYIdAgJ+fv89gla/KpUff6u+hh0KPmGMwdZe8m0VggmyUfkCHdD4gao9fVjpEQzaAqr/kuErvxVAQXHz/rjXvpzgQWnr/sDYgYHb/uD1gdmPfvVOAkWb/yErfoT1Ac3P/vED/tDpAa2yvp13/vkL/wkWvkUuPhlT/rDOAgVkgZHn/ykvFywyBAAAADXRSTlMAYL8AIM/vv2AAzyDvkJpDGAAAAlhJREFUeNrtlNluGkEQRRsGbBY7Cdn35FIz7DYGg8m+x9md5P9/JkUJq6XKdNOdGSkvPk8IaY6m+x4waxq7WQF2G03GNJvtVlaQVnstau9lhdlrs6iVlUCraRry4XjQTcfDbEO3mwVxkqYnm48NI/d82E3TQS+LFaXM+Y0beR/2jNljiRIJIhrwF8NYiz2aFXVZ1A9+TGNFvTRIlDIBomGoSI+hjzbuhRzNL5LL5vn1Q1Gcz8+Mh/1+Xx0jTiRBCt3DSJEc0orkJ8KawbE6WpSoIBciuc7/J7KPxcvLF0X+GxUQpUy8SF6/dJE92sVPpKAo/yrfAadn+fzMn8DkjvsLzEuH6ZWKwic6wGiErw7RDyXyHO3pE0yn+P0sX/T8hfNomiNgNgNeO17pTfBqb4H5HHjvEH0IFX0EsFgA+OQwfQ4UfQGwXAL45hB9DxPJ9kTeAoJEBwBWRCvAX4BfJNsDI6IR4CkgQHQEZkI0AWIKMPuaS2BmRDPAXcDlfc1foitY0yHqAJ4Crm4VXcOaBdEC8BRwfZvoBgRiAF8BN7eIbimRs4DbftGduwBkfdnfU8C9+17RAwhTYqaAr4CHXpFsL+vL/hEFGL29MCdmDkQUYHK2l/Vl/4gCjN5eWBKzBCIKMHp7gQQgogCjthdWJKyA8AKM2t5mJCGFF2DU9sKEhAkQXoBR29uMJKTwAozaXuiQ0AGCCtAiADYjG5Jw5mCLiDb8o+iRW3Tq8DxWoiKUL6qW46maSjmiiknqZXjqiUlqO8U9OzUWJbV64fepJSxiKtVC91xJmD+Tz/ncyYnSWwAAAABJRU5ErkJggg=="

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAolBMVEUAAACTlZinqaz/rDOTlZjm5+iTlZj/rDOTlZj/rDOTlZi+GTGTlZjm5+j/rDOTlZj/rDOTlZinqayoqqz/rDOTlZj/rDOTlZj/rDOTlZjipk+TlZjm5+j/rDOTlZjm5+j/rDOTlZi+GTH/rDOTlZi+GTHm5+j/rDNYWVtqa22TlZinqaypV2W6u7y+GTHJoWbUu5bW2NnfYzLm5+js2Lv/rDP2I7QVAAAAKHRSTlMAEBAQICAwMEBAUFBgYGBwcICAgICPj5+fr6+/v7/Pz8/f39/v7+/vbZJIIAAAAg5JREFUeNrt1m1Tm0AUhuEnBSliXoom0pS8FEVJUGMr8v//WvfMGbOs2TGnuzhOO94zJn665rCwS7BvtGgELUZ4u5N1I2x98qZz24i77UrjqhqjE80jbo19QdW2FXSjRvWw3Rxt+9Co9DpNWxNakLMRRdKiO1A7ha5RbWXQtlEZAwWvoI0whoyBvCEeyBPSAx2D7g7SkDGQP6QH8oRaVdAXhH8Jkt/+p93uqRdop+oDOiPozBdihyRv6IqhK2+IFOoTemeofum+B4jrFfJ4HZmX5vmC1Ivt+crWW8TrR8TNbt+Nx88aE3L8ofX7AlxUq3DY6FnCPP+q6yIFFSsnh6VW1GOtKmIAqfpn7gVRM2CuvlJ36EfG0mpQqs8Yln6KoDHCvKZK+oOtpQg6BZAQQmWeEMIVQ7EvhAGvVARblyIoAKiU1ymEpakIwv5h5HvnB9Gt5zI/aEXGkD9x0KnEWUKVkZDxXOXAHUpeVidm0BXiQUKoZiSFjhBfWMKLXlhHkkBThLz5uSEN5whNjBXmI8AJyo1jyHooVQLoG0pjj6W2RVqK9qw+8vXB/fGQvrSJ7Q3wXQB9RW5ssIwW22XX8tNcgOOnPHGDou4Gy/ihcoKQk1RMIiCZ66e82/i4cw0gLGud6zmyhCoqu04EZ4hfkVxhcRAchy7BRTOyyvkQZud3f9U5YO+L3ODeHcJ/Cf0Bo/2H09XUEv0AAAAASUVORK5CYII="

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA81BMVEWZqrXM1t2rusPQr7rdLkQAAADdLkSqucLdLkTM1t2ZqrXdLkTM1t3M1t3dLkTM1t2ZqrXdLkScrbjM1t2ZqrWZqrXdLkSZqrXM1t2ZqrWZqrXdLkSrusPdLkSZqrWZqrXdLkTM1t3dLkSZqrXM1t3M1t3dLkSZqrXM1t3Qr7rdLkTM1t3dLkSZqrXM1t3M1t3dLkTM1t2ZqrWZqrXdLkSpjZvG0djJ09u8yNG5xs7CztacrbizwMm2w8ymtb/M1t3dLkSZqrW7bH3VgpHcOU6/y9OpuMLVPlLNzNOjsr2mk6Cdoq7ZNkvbQ1fQrLeqi5nPt8AJVB92AAAANnRSTlMAAAAAAACA7xC/MJ9AYFCAgCDvEBDP748gIEBA39+/r7+Pj3Bw33Bgz89gMDCfr5+v7+/fz88svmTDAAADRklEQVR4XqyVy27kIBBFWSQICYnEmhFKhCIhS/HCIoozQ9bYnXfm+f9fM9NAEaiyuze5q25063ApHmann6Qa5Ljdi7uTI1ozsmJwdgZ5dQijfDFaR0F8rjWJLYyYGiPHIDm3utpYn7tCRtmC+IylV0lOEyOvQS4XS2VUn71eUI7w2dgro2Q2ugqU+mxFcud4PQX1OUQ25rIPUJcHQGPydy0FfPNYjPbDx0qHNNQVksQgCZxC1jFgAVlSNkU06pKIZRNB2wKKAQ1dBG9BnC7YRF8Laqf3EAkH8m3IFdDa7HxzCHQ0kZpTJBxoVocSaeow5diiy2jofJruGjoAEAkCoc2nu8ahBjkgEnjIfAKdI0evRHRUeFEG6JVx+K6NqCEQiQyARnzXoLUjajUkgISo3WP9n8GViJLp2A5zpRFqUKYut3FqHjYBD5/lXOqas/v+lbEv1w81SUvOLTylAkDV00f1831Zzhk7C+Hv46pBO/z4O7/BWb5dXtyFDZJ39HMk+jXOXje3IayTetF8jkBGlomG+PPPEvUWkn7H/RhKdGnIBxIkFP+vwaWm7Zakp5D1kFrSDXuXgjQIRGRefiTOcwC9/jLYRUFU9/9qLb/WBmEojnq3h2GxKKvFKsMittgxttEWav9tIQ8d7Pt/oRlCEhVyjbfsvAoHDr8rhEsOTPP6aMWzfyql58oMK7DigZ1ceC618fhAE6W7RnRih+uXrNsuiCIoxfQnLnQyDBehcbf6ogJ9oIviJ3ZTt7Sd3SGCNTtL0Zm9PKB46NeQMfYr/5IjjzwyM/HX1z+cf9f1he9isqhgmsbGE6pnYTxHLkiJIl97mjBBTvME7TBJRhKt22GSPcWz0p7tM1eUpOkVQaZFu/iO6QuARJsS+vTrGUC816aUPH0ADSYup05fgKAVl1Gml2GCeE86gWk3rBtXUaYvQJMQTiDshvXjovHTB9AiG30CH8oTQodIiZYjp99Aj/m4E9go0Rv0mCjR3HV6E2aJqxynN2H9OPcTCDth1rjIZXoThsSlw9ObMCxuOTy9CUPjJqgobIfhcZGLyAeE3EU0VU8z/CEnqByuaAUopcslhTIMJ3c5pE8Vhse9e4MUUxikSrx/4w9DWY5sNKmaKAAAAABJRU5ErkJggg=="

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAJ1BMVEUAAAB3slV3slV3slV3slV3slV3slV3slW72ar3+vT///+At2Dm8d9uVASEAAAAB3RSTlMAYL8AIM/vi50ITwAAAQdJREFUeNrt2EkKwzAQRFF5lKf7nzd2svgBQQW6mqxU6+4H0sLCVZ4MYzUyDtOdMk3zUs0s8wPNa7Wzzje01IQsUxlqSoYy5kBjqUnpUIc69J1tP459O13ovI53LgPCebIBWc6xA4UcAmQ4BoRjHg2nvWzLuU4g0wEyHSDTATIdINMBMh0g2wHyHSDfAeKrF3CAmGZMOBLaGPzlaGhvRoWjoGZYOxpiXDv6aO2CdvRlsyIcDdVmSTgKateEo6BWEo6CWkk4AkIKOEBIMQcIKeAASQlHQ0LCiUBIOBEICScCIeFEICScEISEE4KQPk9K/xfp0H+htJIlrfbJKqLSqrHMsu5ORn34Am2+l0WN6H2UAAAAAElFTkSuQmCC"

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA51BMVEUAAADM1t1VrO7M1t1VrO5VrO5VrO7M1t1VrO5VrO7M1t1VrO5VrO5VrO5mdX9VrO5VrO5mdX9mdX9VrO7M1t3M1t1VrO7M1t1mdX9mdX+kyOPM1t1kfY/M1t1VrO5XpuLM1t1VrO5VrO5mdX/M1t2kyOOkyONXpuKkyOPM1t3M1t1kfY+zvsaqtr5mdX9mdX+RweZVrO7M1t1mdX+msrpksexcr+1se4W2zuCMmaLF096zvsZig5vG0NeJvueTn6hrtOuYxOSfxuN6uem/ytFekbeCvOi5xMunyeJgiqljf5SGk5yAjZdB/p2tAAAAMXRSTlMAEFCPv8+AAHAgn+8wQCAAYO9Ar++/j3AAYL8gcFAQj8+f3zCAjwAA72AwAL+/EJ+/DEXXEQAAAu1JREFUeF7N1ul2mzAQgFFsAwKDIyfES5LG8ZJma5tU4D373u39n6cyFAYZRgLnT78HuGekI+PR/o8qh7VW3/dbx4RoZOMqnb4fd7w5dFD3U7U2hjq7vpAKGu1sdfOCcYpBe0GwPcKcWRDMFi+R0wcIcUDKzBOsmr3DHckckLLnuh7/WUnhTDWAUIdLW9j9jLm0WEGHAKEObyfrgDRbQRWAJE4wQhweP1141xHU8Bz2L0cP845eV92EffoCdXyxcQh1IqjJiqSv+u6vdR0erRJCNivcm59bnYSQ9VFn9yCCqps5UIdEENGLOQ8+drAY6rULOUvMiSGe3TY+6MCD7FUHw40cgCDb8hBnonAAkg82naMOQNlc0yjq4BAcUu10iByCQzpS5/NJOu1EVqM9ZOxHvvOm03QaVeSeIQ4rCdUxB4HKOcsHVhKqYU5J6BxzUKi8w5NCamc+YQhU0pmyktAF5gCU3lW0LtLFrsphwq6ilXJ+cAcSNgytjHPGhH6BhEGVXKfeEKEb2FUQqNJHPmNODhTsIBDm1AghgzxohECIc054zRxoD72jxHlZd0hPhMBZQc3o4ENdH5hmo+HGP/jbRfAiOjwvDf0Eh0M28g//PgsWGUfcXF7B4ZDFxOawHN7Ga8sFibMFiDsodBc593zqa3AgIw2BkznadBk6C+6M8xzSZtDRaSrtVNhpHhPnPtchLoPMtc/IAJxJ7CQX3a8QMQeHKFzTk8IRH7e+DlHXgIEUDqmiUJgZ31Do/MYd0pND1NU5tBTnqZG8PAyKs5xnwZk/2DQvSwVRe9+/T5zlHWONXMhWQrQ1TpzHKcMgaiihb/E7fJrAO8kGLxiBLrfD38XykTMyqKGCroLtr639Z5Y0oPk5cmgruLrsdm0HIB2BPDl0Gf2tWGqoKYMgPYGGCGQXg1yWRJEMGQSZSsiSQpChgnpO6HgqyJVCMHRVBcHoaAN4ZhIo/vo6FM81XaqAQGpSVWqI2pZl0zL9BU4rWN8V1KwpAAAAAElFTkSuQmCC"

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAclBMVEUAAADh6O3h6O3h6O3h6O3h6O3h6O3h6O3b4+nb4+m9ydGZqrW0wcqZqrWjsr3J09vM1t2mtb+su8ScrbifsLqrusPP2d+ntsC5xc69ydG2w8y8yNGpuMK5xs7M1t3M1t3M1t2drbidrbizwMmZqrWzwMkgqTOCAAAAJnRSTlMAYL//ACDP788AYL////////////////////////+/YADPACDvAFtj2+YAAAFuSURBVHgB7dFPb4JAGITxUUSturIu9W9bEJHv/xW7DW3nMgfyLoem4bmRSX4BXkxN/d9m8yyh+WwRw2KRL7PElvkXlK+y5FZ5hNbZCK1fsMlGaYPtbgxnt4VzdomOc3ApEp0IpUh0IpQi0XHYp0h09ihSJDoFfIpEx8ObJTqHwkfIKtEJ3vcQJbsTIbNEhxAlm0OIkskhRMngEDJIdAhZJDqELBIdBVEyOIQGSsIREKXhjoa0pB0BaWm4oyEtaUdDlEpK2nn1g6DgHCXl6DdSDiXlaAnaKXtJfpeWIJ2g/vjuWwhSgnTE7XgvLUE7v9Lx1DOnIycpQTuU3PlyvV7OjpOWoBw+M05agnCUpKcgIE5a0lMgpAZ2K3+Y8s17LRHSTl9xO5RRef8ofJ+UCGlHpyUIxyRBOCYJwjFJqFIcShXqFIdSjXtjdyg1Dzzap9Wh9Gw7dF3b2BxKTdtFKFZXKU5V32O4j9QETdCfgj4BOrXyVdDmKr8AAAAASUVORK5CYII="

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoI7WtDNAAAAEXRSTlMAIJ/vADAQQK9gUI+Az7/fcNe6xpcAAAIBSURBVHherdjrsuogDAVgIRAupe3J+7/sPqJ7Y6bqisX1z9H5JhQIlQuK8yRC3gWQC/g+kvRQ/Bx6rMGR3EMOQO9r8PIX/yGka6ABkaoWQroGloeoahGka9CQrhZCugYFqWonIF3tBKTZr0IpX8mcZqHyi5Y5KA01TUF5QBlAdva7EE6qC2HIFvZWiNsqr9L3e7NBkeRtKAYADQdIzgRtAuMtUBQcskBNDLFA65cgJ18aWgGG+WFnYFinnxVgXZDuCFXI9C1SdfMPR8hroIUn4SxeHUfPGhsBiFP1JCL8eEAyH1ptlCfZt1ZDcGoa8uOR7duh+S/yIrRwqCQjZbxEFJEyjiPXoXd9qOi+4Dn08KKeQds7BJZh0kWm/1nu+H77tMt2hZK8TTPs6A7B36Ww2yAPf1Qs+/CCm2NiQlAzQR4WLf9MEOGx9ZW9CEp0CGI4az0lEKoZrqOehoafO8QQ8qiFtg7hRruh4ccbVGYhCjeIaRLydwiutx0skfoLOUESHlmHQOUoy4B4n4HcgEKacLL6L7Kch5KCwjpRkIL4pERuQOB1FG2zAc1IaxjQkNYTA9PQ6eeUwgE6tQpKeAWFSqecIxQ42x1wyZJ2E0MR3x8VA5U5IKhTYP72ar7Rip5eM+Wzq7G6PBsi+XTijs3Vtq0DWXPTioZwYrqGOwCg+fwA+dT5GQh8eC0AAAAASUVORK5CYII="

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoI7WtDNAAAAEnRSTlMAcO//AGDfEDBAgJ+/UI/PryCagjIiAAABV0lEQVR4Ae3S7WqDQBCF4Tiebtwv497/zRaacKDo6aoTaErz/hLFZ2dhLt0GG0cb0OuCTsP41cdZiHOEOxROQpzjOj46CXEOQpzyEMTfAT5xSjfEKQ9A2ICIvwyEfwBxo9wQN8oNcaOcEBfhZSC8IT/EjXVD3FgvxI11Qly0l4Hwhn4PEj0NmrwQC36I/WEoxphy8EOPpmxnIWYlVQDX2QMRyxMw3TwQWxqQPRCzAUguiGVg9kKUshOidA0uiA2Iz4GsIbsgtqD5IDZhOQIFCWXUcVWQUJGQAbZ6WSSURlnduFuSUNRQ2jglSggmobI+xaChLCFbQ1lAnbutv0UNAWU/VCCgzkj1pgfagLCMO1vwM9Rsn2OtA6Hugyp6EOY9zow+hNx3MjSkJeX0IcxH76UgVNOMVeyH0BblLA0CEsWyxZQIaEhR2b4rliWjIFqphDsSStpU2Ce7FEmiygHoTwAAAABJRU5ErkJggg=="

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAADZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoLZnoI7WtDNAAAAEnRSTlMAMEAgAJ//j3CAUM/vv98QYK8gSMiYAAACFElEQVR4AdXW3W6tIBCG4SUMnzL8ev83u5PViVGZLU7Sk75HNlk8LUOl/fzVFuc8PfahNwUAWI3QskWmaxGYSh/1m6frPjK+ZQu04VuhUwskC5RkjR93ZoMgncdU8FOyQFUWRQU3DbtgGBJDYgsUMZzQCqlZIIbkh/knskDLsI8GKZogGpZ1SM4AadMOkMgGhfu06yHboA2Svw0tGiEHiW/wYoC0Q9qPrRqhYyb75QrBboWOY6vXnW5mKEJql68WM8SQ3P3nM0DDeTdIwQ4RTuNlSJ24ApXnkD7tFZIXkg1QOE07HWiVBwO0QXLkIa0NkgFykCqO+Az1DOQ+hxrGGkE6Lqg+hajiXqID0v/u6lDBvfUMQZpD3t1rFmiSHeKKocrUrRBDjakYoQq1St0GLdADORsUfwtK+J2teeiZh92hVplYnl6+IjskRP3Xgt+9tA0q5LgcV23nN9cI41zq1HZIsrAjs3xWh/TDT54CpNKd6+X7xM5xwRNUcCsvlKD3CGXcS81nqNUnCGMrRagVIwTfMrTi6xlJgVZouSdoh1JboJTpCdqg1KliLDxCHuqSgLFFgSa3SKJNPzPz208OQ24CUX0H7TSD+BWU2xSiHUMx4hbTHGoV09Z3/4xmTAqkQmYpkA5ZpZVeQ7Qk/K/MZICordDbPZkgIlcwVhyRBRJqx6UchDFAUutBhlVLFMUE6f056B99NmGj/VZ0dQAAAABJRU5ErkJggg=="

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAsVBMVEUAAADM1t3ZnoLZnoLqWW6ZqrXZnoLZnoLqWW7ZnoKisbzqWW7/zE0pLzMpLzPZnoLZnoLZnoLZnoLV1MXqWW67x9DqWW7qWW7qWW7ZnoLqWW4pLzPZnoLqWW4pLzMpLzMpLzPZnoLZnoLZnoIpLzPZnoLM1t0pLzPnr26ZqrX/zE2jsr3J09vqWW65xs40Njicrbj8zVbfiJhKREJrWVGXdGQ/PT3CztbW1MJ2YFbDkHgTB0CaAAAAJXRSTlMAYBDPYGBgIBDvYIBggHCAcL/fYHBg758gn1DPUM8g32CPMEAQ21qyJAAAAWFJREFUeF7t0OduwkAQhdGxcaX3HiBl1gVI7+//YBEh0iQxrDw7+9PfAxxdXfjddNhoeBFIiyb7Q+O51LnY/+SJHZJEDvXoWHKUciw56s235NxnviUny0aWnFvlWHLUrs6DJuecLe+n6Xknyzibhhpnu2P81NA5Sg0YkM55f2iWhTy9k+dlpWisd8pLc63DkTyNw5Q0Dk9yNA5T0jg8ydc4TEnj8KSRxmH+pHF4Ul3jcH8iR7iJHKHkkCOUBuQIpWZeSSWqpEqqpHRpR0oxdiUSOYgdkEjkYB8kEjmIgUgiB3sgkchBDEUSOdgFgZQiVQMTiRwqNJHIobpgIJFD9cBEIodyTSRyqAAMJHKoGXCl0w7GwJZSPNkVW1rGJ6EOsHM7/f/K58fTGkwKen+cl7skSTZgVHjZpz0HJ1mAaWG3doSek+9WYJ4bzGLE1yPUBlnXl+sj1AJxmwUtErZqt1o3XwH4OeaeMR0uAAAAAElFTkSuQmCC"

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAgVBMVEUAAABBQEKnqaynqaynqaynqaynqaynqaynqaynqayAgoVtbnFtbnGnqaynqaxtbnFtbnFtbnFtbnF2d3pBQEJBQEJBQEJBQEJBQEJVVVdtbnFtbnGnqaxtbnGnqaynqaxBQEJtbnGAgoWnqaxFREahoqV0dnhSUVRUVFZ8foFNTE+l9JuZAAAAIHRSTlMAYIBAYBC/788wYBCAn99gcCDvYECvMBDvn5/PIFCvUCMATE4AAAFySURBVHjardOJcoJAEIThYblEwfuORtTc7/+A2YSqtGEqRHr2f4CvitlGbptNy3IyEmuj/fmr+dHqPJybXqNATl1HgRxINgeS3YHEO5DMDiS7A4l3eGkPxyTN4NikKRybVMKxSSUcmzTpduqP4b2vP+923i/3Ssd/nMvdUtTtWCU4voVJgvPyFFGSduqak7TDSdrhJO1wknY4STucpB1O0g4pKYeWlENLymGloXJoCY5VgmOV4BilRcvRLbk/WLeSUJKEktahpI2EkbaCTNJOwkhvz84kwbleH1ODBMc3LgwSHF+e0BKcpoqS4KDBgZHgoDymJDjIUZJ2sIM+knb67mC58sx2pxxmB+uNiFMGdtCv7C8p7gmlYxuEil+3cXHscoygV8mNU3zTOQdJ1Zpi8wJZfygdtO4Sk5AccgX5hOikPo2ExOHYvoR4f+wSz594CZBll17Cd3K7hERDkrSlTMiqlkRDqb+zy7IfqRBrDXiST0Wd6BfU7ZVIAAAAAElFTkSuQmCC"

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAFVBMVEUAAABBQEJBQEJBQEJBQEJBQEJBQEI8Fh6gAAAABnRSTlMAIJ/vADDOI35WAAAA70lEQVR4Xu3RQUpDQRQF0VqDcQMiZB7FPxfKFSRuIA29/yUo+WTQ3Ef3OJAaPi5n8njEnr1s7U2c9rP13i447dz/O7GEer+yhnpjAd1iBeWohhquoStrqJ9YQ+3CGvoS15CsIcXbn6eQ7H+eQnLYyRkkx92cQbLt6AySuzqB5M5OINmCCkiOQQUkh0EuIYlLQhJ2QhJ4QhJ6QhJ8QjL4NSTDvYbEgSohcaBKSByo3woSB+qzgsSB6hUkDlQJiUEFJAYVkBhUQGJQAYlBBSQGFZAYVEDiQJWQOFAlJA5UQCF5TihH3+/949UMowcZPaU/cXZ+4uBvhekAAAAASUVORK5CYII="

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAIVBMVEUAAABBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJ9LkK/AAAAC3RSTlMAIJ/v/wBAMFBgr+RfDrsAAAE+SURBVHgB1dbBacNAEIXhV0NCCgikAYNBd2ka8OFXrAJSQeJL6nAJKTQXDYv51YDnODw+LQO7ozx1vZyXd1x0P8B6rlpuqD67H+C1qmpC9V1VddpDH1Widqhq3kNVTRmqBQhcqpoyVNWhQQnqEDUoQ0sffFCG5h6BqYbGCK4lqqExTO6iGqqJDm0PlCCCKEEEUYIIogQRRAkiiBJEECWIIEoQQZQggihBBFGCCKIEEUQJIogSRBAliCBKEEGUIIIoQQRfEYfwXfPnDJmKIVMxZCqGTMWQqRgyFUGLqQia7qIi6LaJiiAQFUEgKoZMxZCpGDIVQ6ZiyFQMmYogUX7sRZ28NkzNXkCiegGtgh6oERI0KK9XU73v/gw1NQ7+Y2hQPYLtEILr+HkAfquOf0P2fgBYvzisy5sfDBfPHfoHnX3tGPHf60EAAAAASUVORK5CYII="

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAADKElEQVR4Ae3cwancMBCHcZegElSCS3AJaiCgElSCK4hL0D0huIQtQbdc1UBADQQm/8MelgFl7R29sWxs+N1C4H1Yssb4veG+7uu+uri+/fpjYAILg5Yf339byEAQYdC06R894xSgJ6cYKAK9cD0GCkAvkmKgwgLFHgMlIMYqxJmAmHJ0IB5nBAJuVgi0AAE39hRoqQTKCoFyJdDSRaDnMipAFe6Ln15UkbQD8SeWhwfQBhlmsI0DBRaFsxqB+N0SgQQSuEaB0ptAQTtQBmrECuMYoDce2oGooUkYyANtYDQDxUZxChhhoHVjIK8W6BnJwSrYfwKY5qfnulU1EHuSBUgb7pYFxoZPLwe0UVEPxL2JZBWG03fc0YFCJc5D9fRctxwdyFQC+S+IMwLtlNUDcZWN2ygMp1uNRwdyLE4UhBCcnqvmQwOxc1IGqzKcbpf0A+kLQAL26oFWYSB/5UAGSGi9YiADHh5ADUSYrhBogshnroYyzGDPFMjCAhlIUQIPpqdAfAkloA5EcD0EchCBOpVhgVEz0AgLFKATSRDAfEUgAwES0AWsfAlK4xSgC4otAk1A1yUPZC8cJ7fagxykCy4vywKJWZghnzTKo3aYPNkYoT+OaJyi146ilL0DreYcFg5cgiv4s0zzo9ISzBDAnvl9kGu8BEt9xuo8kMKZKl39nXQWBlq6DvT35zRCBoIIwx7PH5AExt4DRaAXbmegSbj3DL0HyizQ8sFdVKTTd2stlxcxeW8gwRPN9x4oAHFgdwbyHwYyvQdaK4H8zkDmw0Fz6D0QVawfLLO0M1DoLhCLMwFVlA8ChSM/WuCkG/MChUXhEgQwGwONR35dxu2NYiBAAvrACm5DpHzU6ZnbG6cANRDfBIpHfeHKCfYamTeBnP7pWR7IyqNsP0QKvgc6dA9ykBosL9vgVO17C8TvphnyxigP8GAanqqNciD5mCEYN7hOfyWTk+9NqR5BdKqeTxOIvergFkGgfn8tXPCyjHPCQKPK6VkhkK8EMjAIdPynKeT7UIJBSPDHTU74ylXwNMtas5f+S/uTa/mfWcjs7rkD/c8d6A50+we7xf0NIPLGCgAAAABJRU5ErkJggg=="

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAJFBMVEUAAACqjdiqjdiqjdiqjdiqjdiqjdiqjdiqjdiqjdiqjdiqjdjnpe8dAAAADHRSTlMAUN//ABBgr7+fQO+OtZczAAABLklEQVR4AczMv0kAMRxH8TjD3QaZ4PJAsBQ0/lnDjGDhAIIDaGVt45YiB3mXXCCFjb/yy+f3Qn8XMa033YV+WGCboghphm4B/oK8f4Pyy+cIfb+VA3qHckYZrkQZuDyjJ6BUdAdQepQBniu6xxSAIV4resAUgCE+KnrEFIAhvnbkUI4o+/iLXET+iZx25FtFbiK/RI4ATUjkCtCERM4ATUhkCsCQqEkBNCGRKYAaEpnyDIlMeWWETBkSjVOlQ6aGIZEpQ6LryOTSGhamt4XI9FLgp9o6pgEgCoEgKoyKBCn414CBLV7Lr0nuAuwM8KiIPkc/bi3IzawdGosNmFbFlo7W14JAkbJwUswNGIQegxjh0MBKiCbYkzZIQKQykiLp1UXtyv9d5OeaHX4dTsgDONx5KRQ+uLsAAAAASUVORK5CYII="

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAABBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQELd6pctAAAAEXRSTlMAUAC/IECAj+8Q3zBgz3Cvn/yARZIAAAG3SURBVHhe5Zhbc4QgDEaLkZBwUb///2c7ZZnWrjeczcN2et45oySQhI//jXPDNR/DNURGIsBGNAKjicgD3kTEAJuIAhBMRASQiUgAuSkKrLvR342/cjgUMWLaC9pe2FIEH4o07gQoA0DeCWXU46glAKSbJRu9EoB0FjUGIO45aM9hc1LdJ6K2LOhKVACgrDQamvpUpFLXpXXQfoctVbPoVR45fCHTetvWGzJJFbvrhAyozNrEWC/UGZXQk9kFleiraG7e6vERldJ1RJLgAWvLopZJynggqUs0TGgIFXxTSNCYeg/tjFPm7tOvESdE7RYNHif4O1WEcQjfqiIqOED0lmggHEA3q0jBAeWeKOOQ3C8a3YwTZpcuRcnxTOigEGe/J1I/MUXcRCiwH39EmQSvQK6JFoGBqP2Z44XktV9b4z0Hir2brZd5lDzH++HfR4tBQla8wRGpJKNDO7DRNZKsLrZodNWS0eUfjMpRNiqQSWxKtopRE1GM2prFqNHKRq1f2nx42WxKTzOqYtQeF6OGfTEaIZzVUMMGY5bZ4Gc/itoPx/bjugf8ez1pDMC7PftYPEQ1/qToE4FBbsmMul2NAAAAAElFTkSuQmCC"

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAACIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmIyfmyUbufAAAAEnRSTlMAj/+fABBwQCDvgDBQ389gr7++fdgrAAACIUlEQVR4Ac2Y646zOgxFh5WGOIFwef+XPVJRLcDT8JVaOrN/grWAHePY+blWB+FxqZ/rEIC/AIp9sqDUx09BkiGcQQGyfAgqAOEICgDlQ1BCSQDKIX3qUVASwP5CG9QgAVjOBUjEkgAsR6QFCtAbEoDh9BDegwaAI3evcMrSoQ0aLclyxjboUYHOOm597oDa9ojJXLGcxwSEBmgGkDPJcgRg/g002AAlHTj2gWkHkkqd7Svbv99aMGeyKCgATElNvALpoqQJoBxBEESXtQXSNJEAR5BUnsolAvRXoB4glsxTU9yZ/bpYK7BcgRag6sOPyx8DqnwFyqhCNHmUVl5KbVDipTX9mpBzZdPSBi1s2lLGguKon1fH96Cx6meN0YJSWdlrld9BcgoraQeSfskYddGCYodRXnrZQHKgTF2f2SL6M0jvzN10YMkTVFBrwhz3z53SHpSm/bvGOahZlCdo1De0TizyAsli3VNPxs2jbl3LcN4gK5tKBIiFTTWdAoeyrl1zX1NDANS2O21NDJwU4s3+aFjZaR2+aLTGapL9fwU5fZqX2Vo0/2n5NSGTQ0K6/SIeP+3dMtLbMuJY2BxKbaP4p/fFP5ni77od+W+QcnfLFgV5NhFx+qatqaKg8l2jFY6g9WbrtwdJJt9tRitVfNrjwaFhdxsh3IYatzHLbfDzH0X9h2P/cd3/AOH6SMP/kMX/2MfrIOrvn7EZddBdR/0HfMhQI5o1LLIAAAAASUVORK5CYII="

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAJFBMVEUAAAD/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDOgo/zKAAAAC3RSTlMAUN8AECCfj+9gMIQ27Z0AAAFZSURBVHhe3ZYxasMwGEbVM3jMETwZOQ1tjxEo3UMnjRkzd8rYI/QEdcExfJcrwqIPG4V8Q4dSLcIfj+dEsv5fYT3u2qGJqxHWwUb6vAm10nAL6iXpV6D4Z6DtvgrlHCiNdeg0Am2lQw26l/ZA0liDElDWZhUQovI6HoEQHYB4BkKUIQIgREAkQIiAcgSECIgMCBHQHAIhAiLNECIgVECIgFDNECIgVAVCBIRqPlKIgCKq+XAiAkKlY9cOzQ4RECp95fkJERCqAiGqQLvp/fk8vT7oWIEYj2dp+liFoWv1M4YmvuT5LS7TsIEpf74shEhDFqGK5zxNcZkGLUacp36ZWpD1OuuHW0vgLOZ6W8S2OBvsfir+R+d/vv5BQNRfPVKICoTKOOZOwfBKj1XEvHJoFVazRPvF3m8b6VoDukS7lflNMaZLvb2m0WrUVsv/F5B/XfMvfl3lCvkNMMhtO1oAo1MAAAAASUVORK5CYII="

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAIVBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkSEPECwAAAAC3RSTlMAEIDv/wDPIDBAn2fwrtEAAAEoSURBVHjazdjBDoMgEEVRgUFr//+Dm7Ymt7sbzFt0dgqeRAw4M9t/RuujavS5Gr/Pbe/rvT6xtzWH5y6oV61LOFX9gkaJJE6NL3RUrUg4BJBI4hSvJpI4g8VelHBYbG4jLTr7vCCR1GkXZJI7QCKJAySSOEAiiQOkkjhAMskdIJdkApBLMrzJVB0EEsmGgERyB0gkcYBMEgdIJXGAVBIHyCRxgEwSB8gkd4BcwnHIJRyHkNRxCMkdIJdw0lD+1fKLnf/87iDltkhu0+aOkeDBlj9q84e/OyLFf5DuuBRIIlJpTS7RCqZ++WTUHZHSCbs7LoWLGndcihV+sVI0XBw/UuX6mWogzAq1NOYz0GTJtn1me1bV6O1mI6r9btrzMW/FcbBpA/GX0AtSQ1ntHSrXVgAAAABJRU5ErkJggg=="

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAAB3slV3slV3slV3slV3slV3slV3slWAt2C72ar3+vT////m8d+IvGqRwHWZxYDM4r90yX4+AAAACHRSTlMAYL//ACDP71kzCuAAAAEuSURBVHgB7djNroIwEAVgoIDQ8e/9n/biXRq/RONZepZ2/BJLLNMZHhmn9kWmcT4yzPOyti+zLg9oObWvc1oOaG2BrPMwtkjGYcpA09BC+RD6Qdveq/rekOc6Qtu5/nPeJDzXAdqrXklyqnZAvSDBqf4aulRBglNlCBIcQK1TgtO52ZDg1M7HD0kFDRAkLwNSqRcBodhLgFDuBUD+gj8GZMmOIEl2AEGyIwiSHUGQ7BiyZMeQJTqEINERBMkOIEh2AEGyk4LyPy2/2fnHD8dS/i8CB1L0GMkfbPmjNn/427GUf0HmX9nRJiLV1sQarVjrl2pGr6n2+JZq2FuFrhDtHrjUZK9ZbbtXVd+3Ny9+7rOP3K7trVwuv+v6x8kNWWJjn9ggKjcaiw3rjiTGh3+iW2fve7LJoQAAAABJRU5ErkJggg=="

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAC+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTG+GTGMpxiPAAAAEXRSTlMAIHCv37+fYAAQz++AMECPUJ7EKEoAAAFISURBVHhe7dXbbsMgDMfhQgiHGEj9/i+7SbvJf10M9ipVavO7jj7lZHz70JxfAv+0xuSy1C2fVdLG2OaLAfLEj1EtSqht/Hehq6BEfFpVQJWl4jTkWS5OQolH+SnIEQ9rM9DK47YJqPNMaQytU1AYQo2xsPfvUiTG7iOonvx9pSK0DCB8MmrHew0glQHEx3CuCsGzKaAofdBdAXXpi64KSBweGkAEl0rPNoAiDLkRwpElp4WwRvAPQbsGyi4SM0X36BQaQ1gBBd6fAE2XwAlmaGdoMUJ9Y8yboPvKv3NqCE41GDUF5A4G1lVQAwZvSIAUG46cCorCNlJBJCx/FaRwTJDPT4FCy8+AqAJghUIt+f9QiLATrVByANihnN8IkreudWijDpK2rh3CrWuHcOsqIGMXhC/79Z8ff8jXjwgO7YeeR9d5dJ1HX83uwY8TEl5lAAAAAElFTkSuQmCC"

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAACTlZiTlZiTlZiTlZiTlZiTlZiTlZiTlZiTlZiTlZiTlZiTlZiTlZiTlZiTlZiTlZiTlZirIP9RAAAAEXRSTlMAIHCv37+fYAAQz++AMECPUJ7EKEoAAAFJSURBVHhe7dXBjoQgDIDhgcECFtC+/8vuJHsgdVZK7Zx2/K+aL1EoPL4055+BflsgujTqkc7KcSXe6vMFyCO9hyUrobrS34WmgiLSaUUBFRoF05CncTAJRZLyU5BDEqsz0EJy6wTUaKYoQ8sUFESoEi9s7VUEJN4uQeVk9+XDg6cA8S/Dmno1MCkLEHuZz1VG9m0KCEYLuimgNlrRRQENhwcFCNmro28TIOgQmKA+suhMUKrI9hBr00DJARIhuHcnowzxMlPY/5MhuciccBnaBlOrgNpKPH8J2hc65tQQP9X6qKkg141DTQVVzrDZ10Du1EGngmBwG6kgHFz+KkhwzJBPH4FCTZ+AsHTAAIWSkx0KsL8AMxRdB0xQSv8Ekm/dq0MLBojfugaI37o2iN+6MiR3Q9afbV9++4a0j4h9aL/0PLrPo/s8+gHN7sGPnFXQpgAAAABJRU5ErkJggg=="

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAFVBMVEUAAACTlZiTlZiTlZiTlZiTlZiTlZgCFCI5AAAAB3RSTlMAIJ/v/wAwF8MKgAAAAFpJREFUeAFjGGAgZOKsGIoGGND4YSYuLs6pBBQJuwCBIQFFKiBFTgQUmYAUORNQ5AIGQ1HRqKJRRaOKRhWNKkIU9pRXG4gKiPKqLJRApYgAg03RaG0+mp6wAwCaVBiKwg1ZCAAAAABJRU5ErkJggg=="

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAFVBMVEUAAAC+GTG+GTG+GTG+GTG+GTG+GTGgxwOeAAAAB3RSTlMAIJ/v/wAwF8MKgAAAAFpJREFUeAFjGGAgZOKsGIoGGND4YSYuLs6pBBQJuwCBIQFFKiBFTgQUmYAUORNQ5AIGQ1HRqKJRRaOKRhWNKkIU9pRXG4gKiPKqLJRApYgAg03RaG0+mp6wAwCaVBiKwg1ZCAAAAABJRU5ErkJggg=="

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAD///+7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjS7GjSOZULgAAAAEXRSTlMAABDvv88wQCDfn2BQcI+Ar0LRaggAAAFpSURBVHhe3djdauwwDATgObIc2/mf93/ZQwPBpIlTvNJF6XcrGHYlJ0HGPye/MOhuSGlA1VGv8qKBh7Av+am+n3Wt9Zsp8kJnXMzKizjhSSq80YRaV96UhO9k5aP1zGnVBRcS2RDl53o1BDZFecshQx0hpPBFFIl8UQSnyFf7zlfxzNlotOGQaZbxRWmmx8ToYAAw0sEIINBBABJdJGx0sWGnix1KF4pIFxF0gkAXwa1HbkF+52imixmZLrLXQ+v5GpnoYAIgdCAAsNNsx5fZY/iHQqOCAyaHVh8k0CTgtNBkwcHcpYJqNo6sUtt3v8qBHwoZF4ux05Wa/5jpMAXBTeIHEh5s7Lbh0chOI55JZJcoaJBizWmvEu+rgz2p5rST7Dk1yZ5Tk+w5gETDvC5E+UobOb1nfESHKbAhTOgyRD6KAzrJ2tjO+6XSui+w/qhV8KmsPFEzLJLWWxKjNJJjggcR/OwPX9b9B7d14HfTT5E0AAAAAElFTkSuQmCC"

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAGFBMVEUAAABBQEJBQEJBQEJBQEJBQEJBQEJBQEIfX4aOAAAAB3RSTlMAIJ/vADAQTXMoVgAAAIhJREFUeF7t1jEKwCAMBVDP0J6gU+dOuYD1BD2JGf71ixmF5jsIRcjfhAeKEvxphWyiR+6SuvUtgD4E7QBwEXQ2VAmShtRHBZYJKC+GAgXaBJ/Rw5ANraMeQzvcXIZOH1VD4iNtqIBkFPHtRg/Or2DwMvmzxCAECsS/fF4eeA2ZUWgyqUZd/kMvcDAD2t3U6h8AAAAASUVORK5CYII="

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAAf0lEQVR42u3Xyw2AIBRFQUuhBEtQG6XEVwKy0MSFC4xukJnkFuCJH5wmAAAAAAAAAAA6tC5bqst1UVd+ujiuMT2NM/88zF2o+cmdM1Kca6TUEigPGOdcbgkUAweKlkBl5An0QSCPmJf0u5e0z7yD4ouDol8NAAAAAAAAAAD6sQOwfyMAEM0vYQAAAABJRU5ErkJggg=="

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAIVBMVEUAAABBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJ9LkK/AAAAC3RSTlMAYL//ACDP7xCfMN+6hX4AAACfSURBVHgBYxhZQMjYWNEFDTCg8cOMgSAVvyLXYpAi8xC8ityMwSAFryJhiCJDvIqUIYqM8CoyhgI6K6LU4YggoDQwEdFCfgQjAL6kggAeLS6YijDBCFQUWWyME5hPhSjyAqrBo2oJWFG4MV5QClY0Gb8iS7CiYvyKzMGKjAkAYhURto5YhxMOAiIDk3C0kJ8KRhWN1i0kKBqtW0ZWbgEAYbhSl9GUaYQAAAAASUVORK5CYII="

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAQlBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8fa6fT////n8Phgns7z+Pt4rdaFtdq20unO4fBUl8udxOHC2uxsptKRHn1pAAAACHRSTlMAYL//ACDP71kzCuAAAADZSURBVHgB7dgNaoQwFEXh/JvcSSZx1P1vdXQFLXigoXgW8IGo8fnMlXX+Rs6GMxNCTP5mKV5QXPztlnhCyQOlYKxHssYxkDMe6l9CD5QpqGQI0qtCkNobgqROQRoUpDVDkMoHgtQqBEmdgrRRkEaGIJUMQXpVCFJ7/w7Sz3UK0qAgrRmCVD4QpFYhSOoUpI2CNKaA+Etrnb/9MzyQe57rpe3QwXbMddRSh/+Y6wPZ+lxDBDXW7NCgNeYaRtvxJwM78AsB9EAPhC1ZsLUPtojiVmPYsu6MWB9+Aaj2VreWk7uuAAAAAElFTkSuQmCC"

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAABBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQELd6pctAAAAEnRSTlMAMGCAv8//31AQAECvIHDvn48PVPqvAAACAElEQVR4Ae3X2a6jMAwGYLIQk42E93/ZUXsov2iNnUGjczHqfx19ODZhmaZvvjHW+Tn8hLxbYrpIzM7Tvq64nI5MKdW1tPAev9ZPpa4+nNP68oKiDxeZ7amuaOfAhVx8QpyD6x1l1d6ulz2oKcgp+YcJYmZA1/H1gyHfneve+2M7Bluj4mx+ZHFertGexlDzI3uzaXubd96IV7yNic+ULpK70PsRCImufcxGh1jpVFSJ6SZU57cZm3uQaR89yncgeziEyuzfQza8ssXkBqRJcdrzdOemSjy0HA2u+wBnTZrEPneMvONYDUORXk5KyPbabByGPByub/MotPIOanJjUG0XDvpkdAgbm7lW7LPzI1DeW8pcFdVmDUJBq3ijeh0y0mRwnaxCnVnI7LyrUEPpUklNgxb5QGHFokCOvR5T8yZAKLxIUMHmBaixZ4A5QU2BuJnxc/slqA5A5h9W9PvQIkHLEETy+HHPkgJ57ahhycgRCfHaicxz+9ahtZiHBKWg7Y3ExwjSlbnZoQcb7hKKvBOb8qhFCJdkUvSHP9otSD3oryP+zc87ZfSVzX98mln6HpmEr6yAD3T812CkKpTWcKTYZ1nGlnDEjn+xbUEIHB1KVnMUCMnEM2TSEIRExzku3viFqFs7K22rd/+ObKdjT51vjgYBy89gSyqk5L+EvtAfOUWllJMyLToAAAAASUVORK5CYII="

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAABVrO5VrO5VrO5VrO5VrO5VrO5VrO5gse+Vy/S/4PnV6vv////q9f1qtvD0+v7K5fp1vPGf0PXf7/yq1veAwfK12/iKxvPpuxbiAAAACHRSTlMAYL//ACDP71kzCuAAAAI0SURBVHgB7MxBEQAxCAPAQCD177g9DeRzM6yAxXJZkRzIqAdVLQ6pv6gPx06/SDRQIWgRSFokaLLRX6PbftnszA3CUDSSN0D4DX/v/6ZlSK+CrlCni6ibr2c3sTk2jCcalDannTijvXznXuPs5DRa3SId7ErUAtIVMx7neCUBOtqVoKfIMq58SlQTLBFM/TRTnGUgYoK+kEy4S1PkEZkRbroOesn2r8ml14FuQ2ymSFISAb4Eu3CWUcH7kV9OuxAKvhSsP4RRDtmxC5j0iIhT3+coOQsypatsgUvfRAk7o3R4QEh7EXmaKuiJPUW1renYeEIXjGl+YhmjJz1sTAc1jwxIG2JtDTlul0RlJiOe7Icqk7p8wDfbWAQ8daznJMlkTpGmM/AkAsYOLnmIdxdoKOI5ihgSgYAGgA9YHrmB2WLYi7oddBHuUQZUHz32rahQDZx3/b2KBudz3mUritjHQrhPTaMzOsBzKzqXEvSsLItA+TeiRtnuETkKta0IkUzZ62EL4LosumhWMBFpzjxPhsL0smhm8yEZTETgOZJCZQ9q1iYeI3MbORToIA7eiEv0VklQru8N7+xAb0VoKXQk5+XXH6fJo2RAaC9SM26zHgtqC1Prn9/voFURr0+L0B9etUR/9k3sX7UgZf53MMF2FnISEhFlyT+TLKRzqVCUsIhRV75zYxWixnB3c7GGRaDWmmRLGqGf9mf0tUvNa9esty5+r11F37wcD965rr/Ef9GPFv0C+BFh6bQepMMAAAAASUVORK5CYII="

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMNHj8f////z+Ptgns47iMPn8PiFtdrO4fDa6fS20umdxOF4rdZsptKRvN3C2uxUl8upy+Xe7iW3AAAAB3RSTlMAYL8AIM/vi50ITwAAASVJREFUeNrt2Mlug1AMQFHG2H4zY///TwtFL6QUKcL2IlK5OzZHYoGwXayVlRVUlfVSUddNa4W1zQo1Dyvu0SxQaxVq66K0KpVFpQNVhVXqhhQh6JWgSEYFSogECtCISxHEUI8/JSlkCLc6GQQOc14ERXxGRgAlfImADY34qwhMqMdDiQcZwmMdBwKHf/MMKOJJZC5DCU8jYH9rmcjPN3RDN/RPINCCBi2o14ISbpEUItwKQsjnNxtlEFCGjAyashNtTjhEeAkEu+OsABocPvNsaPYB94JlQJMLIbjDf5oBdaeTw3XInzrXIUMXnQy9H67CbBlQPDI0stasryPTAXNf8xPtyuRBsvjNQ7fWm3s5/khI7ciidvbROkSpncY0j3VLGufDbwZo18TOukIEAAAAAElFTkSuQmCC"

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8fa6fT///9Ul8u20ulgns5sptKpy+WdxOGRvN3n8Pjz+Pt4rdaFtdrO4fDC2uyKIYJsAAAAB3RSTlMAYL8AIM/vi50ITwAAASZJREFUeF7t2EmSgzAMhWHGPMkD49D3v2lDF7gCeNOSF6kK/wG+hd+CRNlWXkBRkZdrWVlWNZTV1QZVL6h7VStUI0F1meVIUp4VSFKRIVHfB9lmy+sg2y/maOm8GGrNOZ6FELG5NDQiCH4011qSQJjMLbYSCP1dGr0EgotIJIGI7xKTAAL9cU37/u6tAApR90Y1CgiwHCBWQSAXpFkARV9+0UGw4Z2sDkJ3QL0SomO6HyUEt0ODFprNnhZqPg6CDHqgB3qgB3Im2kj/hcBRxwu+/UMEmgWrxX4HdrLVpqvjpKv1Z4dJCsFdBhND4NNgAigy3QwBFJmugwoK0zmooDAdkx6CC4MpIXAYTAnR9DF/jh8o2ZEl2dkn1SEq2Wks5bFuLcX58BeZ6pWk5/pHtgAAAABJRU5ErkJggg=="

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAQlBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMP///9Hj8c7iMOFtdq20unz+Ptgns7a6fSdxOHn8PjO4fBUl8t4rdbC2uxsptJzdiQpAAAAB3RSTlMAYL8AIM/vi50ITwAAAORJREFUeF7t2Fmqg0AUBuGe9O/ZIcn+txp96ddcsEC4WAv4IJhuj8ecWZcu5Kw/Mt6HKV1sCicU5nS5ORzQlIAmb2xCssYxkDMJ6j9DDxQhKHYGaqsQ6FWFQFlCoCIEipsQaO9CoFaFQFlCoEUIFIsQKHYhUFuFQK8qBMr63V+gIgSKmxBo70KgVoVAWUKgRQgUixgoARD100a5SvDjv/8POYpv6e5Dy18jo0+V6Kv2/st/VACIfEGO88IPEfePNeO8gKMfP4zy4zE/sPOfEEAP9EDUkgVb+1CLKGw1Ri7rjoj14Re3l688MahJ2wAAAABJRU5ErkJggg=="

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAP1BMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8e20umdxOH///+Ftdpgns5Ul8vz+Pva6fTO4fB4rdbn8PhsptJydb/uAAAACHRSTlMAYL//ACDP71kzCuAAAAD2SURBVHgB7dhxcoMgEEZxFDWLHwhq73/Wmkynk9IEF3f/yvAO8DvAM/e63grqu+HIDMM4WWHTeIfGmxV3Gw9osgpNg+msSp3pdaDeWKUa9KkQkRLknA40A7MG5HHk5VDAoyCFlohHcZFBlPBTIhG04rdVAjk85a5DHn/yV6ENWds1KERkxXAFoh3/2qkeooQXJaqGHF7maqEZb5rrII+3+RoooFDgQ0tEobhwIUoologJrThp5UEOpzkO5MHIn0MbWH2dQSGCVQxliHYw26kEUQK7VIKykGXzGtSgBjXo8yFhDWqQ2mRR2z5qI0pvjanNuiONffgNZhlZ8GVVgcMAAAAASUVORK5CYII="

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAQlBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8fa6fSFtdq20ulgns7z+Pv////n8PhUl8udxOHO4fB4rdZsptLC2uxuEF/SAAAAB3RSTlMAYL8AIM/vi50ITwAAAPBJREFUeF7t2DcOxDAQA0BJDlRwvPD/r57dGrBIwNud+IBpuGzWnfEBDxJ8d8R1XT/gYYb+hPoRjzP2BzTAIEPnPEziXbCBgoNRGnSXBi2X/DHUoAY1qEExLXJSDUJcVWeNVQjTrDnzxFp7a9CHt5YVJyutFe4Urf4Xc74gkHgEKYoQtmp186ZPZCLFyxAyKUyGsN85OwgkHkEBgcTqEhSI73eNMnTdLy+MQ3iTpcoQMilehlB4YRy67vcLBeJHkKIO1fY7b3gGYSLFyxAyKUyGzv3usIBQCiwgngY1yOzJYvb2sXpEmb3GLJ91Ryzehz+XgaUTnSybMgAAAABJRU5ErkJggg=="

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAGFBMVEUAAAAjHyAjHyAjHyAjHyAjHyAjHyAjHyCo06W8AAAAB3RSTlMAYL8AIM/vi50ITwAAAFlJREFUeF7t1qEZgDAUA+HMgKlGMUDKBHxMADugQfStzwYkDpPT/wAHYKrPZhLcS3QS/VJobFhLdqBpdGPR6EEZ/YSCgoKCgoKCgqyhsdbImixr17zxI/VCvmJHrBVlhqdbAAAAAElFTkSuQmCC"

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAGFBMVEUAAADm5+jm5+jm5+jm5+jm5+jm5+jm5+iCaedZAAAAB3RSTlMAYL8AIM/vi50ITwAAAFlJREFUeF7t1qEZgDAUA+HMgKlGMUDKBHxMADugQfStzwYkDpPT/wAHYKrPZhLcS3QS/VJobFhLdqBpdGPR6EEZ/YSCgoKCgoKCgqyhsdbImixr17zxI/VCvmJHrBVlhqdbAAAAAElFTkSuQmCC"

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAD/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDPXYsykAAAAEXRSTlMAEACP71CfQN8wgM8gcL9gr/CpoksAAAGQSURBVHhe7ZZZcoQwDEQlbINXwPe/bJJJSMIwuJvlc/oAr+q51Jbklryj2uFIB2NqNbeAbK32DpCrn3E3gPovUI9BjBnjJoQZ5SaEGeUmjBl2w6Ch/mS4CDILyFwE+QXkr4FC/U0AIGhGugk0I90EmbFugsxYN0FmrJtAM+yGQXENiqdBaQ1KZ0G5PiWfBJVnUGmDdKwXM+oDFOrlhG+1/iqnXypSrnHKX0WCP4/x4X9F9LRer08VmewZjJ22FQnpOCeFlxUxRzlmryLukJ51+xXJI88Zc7NrkeVEVNqB0rMDbr/OVEsRiGpMYbdI8KATLKjTFkg7HuRaIIdA7Iz3B0DtN2JB8PMFj8231wAQMANuAhYjcKMnm3cTsPJpNyHMvCfcBJvNqjN2E2RmywNu0YEjwCyFlzsmE6Bp5aCv+1cI0LzdE9sdkzBI9/bE+pDKEDS1bs+47yZ7Zn5ofsIJgRazWTeQ9dmSAWhahmeb9dkyAZBZhmc/+dHFiEE2atdOtBik0WkHo64oAJ3OG4TzAUg6g2SIyLOLAAAAAElFTkSuQmCC"

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkRwyRsNAAAAEnRSTlMAIGCPv9//AFCf70CvgM9wMBANZ/LfAAABiUlEQVR4AdzSwXLEIAiAYdAIisaY93/ZTrfbGVwTV6a9tN89/wQBJtD5LdBT2LxDvgd8I6ZAg5CiLYRe6IZ4XA7lQlMlL4Uw0VsJ34d2oQWyvwlhpUUVZ6EotEzcfWgnk/0ulMgoDSF7ZyiBqTMpwfx9qj9ybi3nw9fJO6lQpFFxJyunKzSKfQhler2TqxfsQsN/b8iXcBum16F9emw9J5fPBFeD1cYTrV4NBxebrydPnS+l9B3KY8dWys9QGTu2UvkKIWnSeEET0vAR8qQ5XuJI849QF9940UaKfIYiaciLkLTIwKnf5KrX74DD+EP2XwoM2O/RoJCC4Ewr0/ovwZNyssFJige9xsomVZ8NBJ1lEz1MAFIONjlI6UKZTfIfCrX/O9qP1v9rB/nRih3UAACDUAy9kuDfLwcUNHnzsE9b9kXYp2UzooZNTS0bf3aO5IF0J5tBBMMaB1oM/RyMMjxmwA4UAkhN0KwtmuXET6gokGOg6yAgjE8aPrL47ENDlEhjPtb9S/nwAD5Dhnoqc5dzAAAAAElFTkSuQmCC"

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMOdxOFHj8f////O4fA7iMPC2uxgns5Ul8uRvN1sptLa6fS20ul4rdbz+PuFtdrn8Pipy+X3fYQ0AAAAB3RSTlMAYL8AIM/vi50ITwAAAYNJREFUeF7tmMluxCAMQMk2toHs2///aTNVVaM6EWPCoa3mHX14wmCIY/OkKN0NyqI6MFVVN+4mTf0U1Q93m0d9iBqXgaYyhctCYco8otK4TPxD0VvU9X6jg8333Q1R5ynAt6kioB9AkggtCSzqRTjSCSOqRROdMmlFM10w60S40AULqkRAzGbtFj86E1vQsrqDNQigQrRyKl9V2LKpV4j46EEmO74u6sI8ZLZdVCQz2zm4fwfXqEgW48DBQRRlXMSnHUa5Hl4W8b6en0BMJJOwYdhywhqRrGJQiyAmgl8i6tNEcjOGG6I5Ivpzm93nEg3h5Wd2dUG2sSvSRkSRe74pLq2458hB5Dch4WGbzz6ZU8JTOwm76qnlLKg7iWFMxHhOQ6br0z6Qq4woRMFRE6BzCOxZkpsIGkdSNhFySZLN6UQDXTAoRJycBPRd7aRoIYVImqRHL+I2jZu3NJFDCFQL4J2/oxnsJzC/f/yueYuyDVmyjX1yDaKyjcZyDusOcowPPwAh3NgmmZ5lagAAAABJRU5ErkJggg=="

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAMFBMVEUAAABBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQELdgQv7AAAAEHRSTlMAgP+vQACPEJ/PML9g3yDvkjW0+QAAARpJREFUeNrtlNEOgjAMRe8KuomI//+3xqEr5myJvpreJyDdob1rq1AoFAqFQqKSmU3zaah5sm8ikqzqPAjKFVNReRBytirZrtLnXKzp0icV26Vku1IvqnIaqRfRjuvtgi2jrMs8l1H9i70dVMNe6WKNWp+Pa32k49dWjNo7wvLtxWmkW8avagYO2l4fWH75MDX1Etp2kLvhKTn8nlt+dz/kCblzOpyaeK+rv6/skunA1vHYxvJdNHI7osWPPEY0fy6myUJYLO0QjIO1tN+5nrN4lbxsNgRbRrSA7ccWpYliu3MgODQcK2EAOaIc44WDLq4ELg0uFq4ecUlxjXHVcRmKmXOxcvmydv206hlD0O8KUIACFKAABeh/QQ9QmT9BPFHO5AAAAABJRU5ErkJggg=="

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAD/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE0bZtZtAAAAEnRSTlMAYK//zwAwIL/vEI+An0BQ33BNeij4AAABxElEQVR4Ae2V0c6DIAxGh1ARxKnv/7L/LhZzgKL509udu6XspMIHff348sNN/kNwouCC/zDNMuAlF3HxX0K3fA7+i3sUzclfJJpY000QYS1Mes3dinLwFSHLBWpKu41o9Q1FLkpTCjei2XfE6xC6UhmLll60yZetr80j0dsrxKYhsCgivSG0tGm1XRdFrxLHtUMXrbqo8MgaTlWUvErKInlYU0Q7uzj5o25oO1hTRBvW1n89a21OSksQobzff0yhtxO9sVjZXvyxbqkV8cympzAwVK4Vhba2jeMZmyxRlFHLWK1fmKlpCaK9v0Kb3lB7K5daVPq4xptHhY/cuxItyuoyfoEc26xESXv5wvhNPNgnRNjrVeRxFAxDSRGXj4cTQ3mon5aUkaiNy5UJ0E6tKENaG+CRCVCSHeQRJWYRIinJ+1TkGSWUazOOsvwDRi9B9H8YSmcRMZSTSXRyuy0ihrJYRAzlYRIxlG+LqBlhBtHMOWURMZTOJNoZJYuI8zlSZEnASZFlu4NJxAExU2S5cCtFlnQfJpFM/DaLyPGaUGR4TBJFppubTaLdJgKY0jYRprRNhCltE2FKv8RKznhqbfxEP9EfAj5VO28qYVIAAAAASUVORK5CYII="

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNUl8v///+dxOFHj8eFtdrn8PhsptK20unC2uzz+PvO4fB4rdZgns6RvN2py+VaVwIyAAAAB3RSTlMAYL8AIM/vi50ITwAAAKlJREFUeF7t2EkKwzAQRFGNbkmeMt//qJHBoMSLLNQFAVP/AG/dXWbLOlHkrK8Z70MUZTFsUBhE3RAqFAVQ9MYKJGscBnJGQJ0NIjQuraSApmv+6Db2Qvf83aUXmvOh1AnlY8u/oRkFFRQkKwqSR6mtOqi1nAMiRIgQIUKECBFKKKjdkqMSeu7OS5SQlOboIElTmRIfvx8Rgo0ssNkHNUTBpjHkWFdDzIdvufyTDccW2pUAAAAASUVORK5CYII="

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMP///+Ftdq20una6fRHj8edxOHz+PvO4fCpy+WRvN1Ul8tgns5sptLC2uzn8Ph4rdac16IzAAAAB3RSTlMAYL8AIM/vi50ITwAAAWZJREFUeF7t2MluhDAMgGHWsbOH/f3ftMwFt7KgtZNTNf+dTyYERUrzru2goK7tz5q+H0YobBze0PCC4l7DCY1QobFvWqhS23R1oK6BSv1D6AN5Yx2euW2aCyAfIlJ20UJTxJ9lHWSR5bwC2hAlUvM4Dy9LoQlvWmWQj3dQkkEBqT39UGcRRI+6FQAMUThJoJXG8fBuIclKoMDWNtMiSaDtGohmVEGJb5tCaCmcyNKbsQ2aNV8tXJC7IPMrxEdynuQrL4Lg2FLK9Mx+OVvRKZJVPy1vZf+sDvKRDaSDEjkWCqBMTvQFkEHqAD20xNLjiC+0Az3kHVsgHbQhtYAeskgZ0EMTUgH0kEHKgh5akUqggfgGcl4PzZF9eCnEN9ACeighlddvCSGLd8UggQ58KAig/QmKf4c8PjbXgnylV9sFa2SeICOA4HC38xwggGR9oA9U7ZKl2rVPrYuoaldjNS/rzmpcH34BKo2U4gmFNgEAAAAASUVORK5CYII="

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTfO1DqfIrul6LmYnPwpK3////ob373y9DhSFv98vPjVWf75ejsiZb52Nzysbn0vsXzxuQQAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAALaSURBVHhetdjXkuowDAZgm5BNTJFLagHe/zEPdojGxCX2meG/2l2Yb4gWyYVEQk/FuYRPynNxon/hkNALVV2Ck7Ku8iBaMAiEFTQZulwhmuslCaI1HKamx9CNQULY7QCid0jMncagikFyWBWGbpCVWwiqITO1H0KHC6myJeI60LRt2+VKxFOf/g3JzDohVEEQEs/eTbM9fPUNURaEHq0/zQox+gXdIQSJNpRhle42dIMg9ApCAsuEEGVeCNVe7dKN1lsYRaiGOKRgH2lBUG/QZRMGZaLL+9Q/JEJw+UDbHFPtLqNIg64rRK1X95mSIKAGKjZIuZBMgwoDMbBrhJEa6tIgpqEK/BEa4kcQNgoJTqHZtEEiVL+hEgHnrSNPhco/Qv3OpCu0QCoElJy8Dtc9/4B06EQKL/Q0X6IMqCBnn7OsD7ZBz70zPPbQmfhq3WnndTRGFhsqia/Qoy4QTxpsGBJw2gbLFZ9rCPkduzDTIqWplJRSq7N8R3CIQ+ighC2hPn3dgy8k4Giu5wj1uRCWdjEFn/4XagyiR63qNDcuFgTJEO+NI9aCCLtQ4zFU7ssjwEDb79xAb2eOQqXVIr0pssJGMtKMs6CPQmdSfC3y82S6YoWAP/sJe6aJQgU52R324LhAOv+EJQqd7ME2KAAHwg87RSHqjFofNOjiQQwqcfhHoQUbxoa4mr6GfxWFcEHpHOhhTYAKF8gYJMyTOZA1axgu2TGImxXOhtCUX0s2jUDYgEMUoritiUBdi24IuuJGKwBhB87chQSOW7gcbP3QaRW4kMS/1wmbUWEcCR7otY0GRg+3x/y1H97qMyBgWLY1HW6HG/ZuRMeGMGsh74dHiM6zoMJoOSPHB4seahbNzAq+0s3ovAb3UINlwrVVmG/0KMGJEvKdRXEsUPDgx5dGrO3N8w5+KGWn/u3hOP+4/vsLhPwrjd9fsuRf+/z+Iir/auz3l3WYrOvDf3FZEkYR4lCHAAAAAElFTkSuQmCC"

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAXVBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTfO1DmYnP3y9D0vsX98vP////dLkTjVWful6LwpK375ejsiZbhSFvqfIr52Nzysbnob35Id/HDAAAADnRSTlMAIGCPv98AUJ/vQK+Az32XzooAAAOOSURBVHhevZjpjusgDIWhaSfpMuxkT9//Me+Ni2sWtUyl0Zx/VpOvtjkQgL0RPzTHkws6HZsD/3ot9uqHtgNGqlPXfgbizdm90LnhPwZdru6trpcfgXjnqup4HXSDomo63yog/u1+qG/+DtRSOlWd29egm/tIt1egzn2oLga95Mx97x1IyLlOYi84frP/BQBvrFWyQiLQLaYMowX1ewRIq+Z3fSJQixA5aWNRkMcQgl5EZS8YtCmIgw3varSRNHCcUCEeJXKMtSu6gCcg8KGIKeNAtcg1oAYHmvbAozMRRA2SluRdoiWUq8SzayJtEwuFgaAwBT1xmYS2oG0PjMXSqDgWO0gscs8EQIXuxoYffBhQVIegi0tVgqjpK7WIdAmgaw2E6tW2d2YHjslK9wBxVwWJqZ8pwPEjcQA1VRDk8CQt5ag2ADrXQehykMbKSOcd1JJZ1ENgApDPQWVlOFFYNOttoSEFlZWRA9jX6Q1oK0FuJTeSTl+MUzQUoHsJmnfo4nJxdnC5xsy4BMJ5ZkQBOrCGAvpLfBY9SCBhoOJCDTvmoAn7jNQtgOjX2W3WpP0+Muo1NRPkcWVRCMK6tZOFlU6srCxoFSEBHYGWB1IimYSgbOhU6EQPfQ+gkJAKK5J+DzIAAntPj0m2EGhBYg+tegdaHukoCTYCrAygMGTq2YApAZUmGtXeSb0T4Xn0UZKHyv3NyoT6/SEwjL7D4wjy0axZ8tpY6eqQhlfKD/AmglRkVJHXxoqENLxG3AVBU/Lumo0bGpL8Lwk0Y/6AeHaaLB4b8ph5aHUEmsDAAbRzDHXFp548xpNWWnLNM/0BQXlTTLJGNLSMoEsI5MFLEUi5SFvSpEO0sClMFkEbVEYgI8qBQXFaatElBFJY2VJsLKR0YrWjj5Za+vCDSwgE748CJhZoScpai8W/xWDBzw8NvxShwuwLVHxI2voHUuhoG4jK43P9kz2vtgSFSURqapsI2BSVIJmDeGVbI4bQ5gy0x8aRrpWN1n0EjFnyngyZOS/R1q8EzQowYJZgcdSYDmIXb0ZLUOiyFgG9zsFvd5W66szj7XEJAoyZcILmoulyyzbsZUZ0ANEFhyr7zo4QBchr9WyLz1PSaWHloYZAqeYtQhkdTbu2OGZVt8cy6N0xK/VAb0KP6+pqR9EPOL9+OP794/rnFwh/cKXxySXLb137/OVFVP1q7K8v60gfXR/+AyhxUgGf6m8EAAAAAElFTkSuQmCC"

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMP////z+PuFtdq20uk7iMPn8PhUl8tHj8dgns6dxOHO4fB4rdba6fTC2uypy+VsptKRvN3U54CQAAAAB3RSTlMAYL8AIM/vi50ITwAAAYpJREFUeF7t2MmOgzAMgGHWsbNvLO//pkPnYBSWqjE5jfofK/GJREoq3LxqO/Wgru23mr4fRvWwcXhBw4963M+wQaOq0Ng3rapS23R1oK5Rlfp/0BeyQibY0tNqHkBGIuxNjgt5hDzPgmyAU5IB2QQXyXKInLy1FPJwHdoyyMJdvgxaYQ9Dgj1dBs3EpGVzrQTKFUH04HT8AZYSiPZaW9o0HmRO60gciF5JKEozIRVDCPH8igAP76OJdv8R5MiByIei1EAFxYUiZkfNcSEDB4cJ5beAdooNTfnRt2xIQpZ2XGiFPHRMyKaTxIOU9TqXUjlELUIiUJ4P5Xck8iAqkBTLoMXlkCBoLoCsRICUUY6g8DlkE93YexxIXixi4UB48Sc2cyB6JtHiDHI2O2TS8aiIz6EZKFyNUsYj7NnPIQdvkiVHZLp30JRABm8hUXb64/3CyiAl3jiFhxbhnOdc/lYemcD9OzIZNS1PPmqiD3/Nwn4//O77QtWGLNXGPrUGUdVGYzWHdVs1xoe/+THUZ6fl/nQAAAAASUVORK5CYII="

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMP///+Ftdo7iMPz+PvO4fBsptK20ulHj8edxOFUl8va6fTn8Pipy+XC2uyRvN14rdaIAWDiAAAAB3RSTlMAYL8AIM/vi50ITwAAAShJREFUeF7t2EuOg0AMRdHiF9v1h6R7/0ttIiEnDDqUeB5F3AUcWciDwu5Z1wtQ3w1rbhjGScCm8QmNN4G7jSs0iUHT4DoxqXO9DdQ7MepLoQuKD09EgVEo0dacIaiQNmcAqvTWHYAe75DPp6FIu+JpKOyhchZiMoIWI+iHbKDsN8BjkO5iCBikuxhBKG1OEAyKOhAIBR0IgHYDYZDu4iwYxLTFGKS7uAgGFR0Ig+prIAxKOhAGVdKBMEgnYAzSXfSCQbMOgEFMn0q1GVroY742QoUOSo3QfAT5RogOs5ooNEJ8BP0eQI1f23P7QuZY9ulChBIz8Bht32wcuqC7FaQPLgahij6PNdalBiGpXArn68fvny7I7MhidvaxOkSZncYsj3VrFufDP86sseDEnrcWAAAAAElFTkSuQmCC"

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMP///+dxOE7iMNHj8fO4fBsptLn8Pi20unC2uxUl8uRvN3z+Ptgns6Ftdp4rdba6fSpy+W7cXTUAAAAB3RSTlMAYL8AIM/vi50ITwAAAWdJREFUeF7t2GeOwkAMgNFUbE8tKdz/pguLskTgIDnjXyu+AzxFozS7udd2VFHX9reavh9Gqmwc7tBwoeouww0aSaGxb1pSqW06HahrSKl/B32h5F6bzkDGwnt+kUMB2CYpZIAvSqEF+KwUQi3IAl+QQivwOSkEfDOdhTzuyomkkDs43PMQVkK4QVkLcpVQ3KBUCdkNWjBaa0OeTkIFXlvnUxAw2SSHEnCVSQw5OJCk0Ax83gghhIOuSlcEkGSQWR9AWIhoCjsIZRCZUMCH9H72XgAx5adk5BB/p7s6yMLWUgchbKEWNNdBUeuMvBKU4K8kgAyuEB3/j1OIhz48H9Fwb5UogBAelUyPpvKEZgG0wpbPiSgh7DICCD4USHxFfEkC4bGDJIGMP3IsiSCaCu+sRghRspwTzYkRYvavTMknZ5El7hmfTcV05ND+ds3pO/h96AupLVnU1j5aiyi11Zjmsu6WxvrwB3MzsmJWRGqsAAAAAElFTkSuQmCC"

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMP///87iMNHj8edxOG20ul4rdbO4fCpy+VsptJUl8vn8PiRvN1gns7z+Pva6fSFtdrC2uxwnJ46AAAAB3RSTlMAYL8AIM/vi50ITwAAAXRJREFUeF7t2IlqwzAMgOGclXweufr+b7p2ZVVhFkSVYTD6P8DX2JUhcXevH1DR0I+3unGcZlQ2T3douqC6y3SDZmzQPHY9NqnvhjbQ0GGj/i/0gdIO4LIesnBvW7WQg0fFaCByAA4VZOGZ1UAHQJMnSkDtis3OGzmaf83sQCXFHDlmg6SQZxwGOrVBDhVQYBwpdJATUAEZWthuNJCjAcqogFZ4ttgYnPXmPSjAr67pDShBrWjEUIBquxFCKwAnySAHrCSCDPBZCXQA32YE0BUolxCTA8oKIGI2/6ATHZhyHkoELT/2Qvh6GrK1Xy+EvwHZmh5ZiB/rVFtv+EvIE+RlEL8dkR0kHloqY2xokA4e4s++qxzjfBrCQlIkRz7ZGIEq0ftYgFoEUG51+jHy0IISyBTOCSiCcN24hQkh9HVnRR4SPNOeUQ6hcSQoX4/TK7XFrHirNd6G76z/fPjxfaBmlyzNrn1aXUQ1uxpreVl3q8X14ReNb6JSeYgBrAAAAABJRU5ErkJggg=="

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNgns5sptJUl8t4rdbn8Pj////O4fBHj8e20umdxOHC2uyFtdrz+PuRvN3a6fSpy+V5oD3UAAAACHRSTlMAYL//ACDP71kzCuAAAAErSURBVHgB7dhBjoMwDEbhgKGFQAIB2t7/pgObLEaq9Ub2asR/gE9vg1AcrjWtGNY23bnQdf1DjHv0F9Q/xbxnf0KgBzR1oRGXNaH1gdogTvtP0A0N45fFP0HTnL4uRw4NSdu8YGhN6gqGsg5lL2jG0KZDG4YmHdoxJEVzDuGQxFf5tXeFiukTWY4atJigVQ/CUEx6EIRAEINAEIQ2PQhDox7EoawEAQgEcQgEcWgHQQiaK/QRAIGgFAkEglaxQC8QRKDlAEEEKjCoQjyIQzyIQzGBIAKtOKhCPIhDNIhDAwhCUAZBBBppUIVAEIFAUBYL9E51I4NAkAUqNIhDWUzQUKHBBskKfh0Ikk+6lhczJHEvZboffjcE5ndk8Tr7+B2i/E5jbse6cx7nwx94PFmH14i8ogAAAABJRU5ErkJggg=="

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMORvN3C2uza6fT///9sptJHj8e20umdxOHz+Ptgns6FtdpUl8vO4fDn8Pipy+V4rda/bOdTAAAAB3RSTlMAYL8AIM/vi50ITwAAAYFJREFUeNrtmOtqwzAMRnOtYst3p837v+nSQRGr7RI5ZoOR81OQQ6x8EVjdk36AEwz9uNON4zTDSebpKZpucJrbtItmaMA8dj00oe8GaMLQQSMu0T8UxUVI3JFiiSdEakUkhKoU6Qe+8dA1Ii0xQWqeiDypiS0ymEVwRQoLKKZIYIGVJ9JIGGsNEpElopM5Dzve4YvAElnqybvZ1onur4o8J6Lemj8WqfLRNl6Oys3WPJEpfX7DTHZ0hUBGpggCZrH8eWQwg6mZkEv2ffgiLzHhrgAa9ShwRQELLDyRx4S6ZN9pHtkIEK2jPmmGKPyYa2+TbWGIJD2VuuVxkaYXyp02HhYpSnIu6eqwaMlF2VLxsMi2FwkqigqRyjRbO4rkYZHP/BGWav54jlwSyIBUYgTSIGEjgDdIGIZI4QcUQwQrFlmBI4oOCzjfaLCFXx+1ZHKY4ALwRRDXpM+x9gohTl4hCL3Z9Ru76evid4mKNFuyNFv7tFpENVuNtVzW7bRYH34BDaGgIxbjiG4AAAAASUVORK5CYII="

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMOdxOE7iMP////O4fCRvN1gns5sptKFtdpHj8fz+Pva6fRUl8vn8Ph4rda20unC2uypy+VWJ47NAAAAB3RSTlMAYL8AIM/vi50ITwAAAW9JREFUeF7t2NlqxDAMBdCsleTdWWb+/0+boRRDM7kdL1Aocx8DOSiK7RB1j/QDV2ToxyPdOE4zV2aeHtD0wdX5mA5o5gaZx67nJum7oQ00dNwo/xB6Q4u+RTmyKjIVkFWSItEVQv4mPxJNCWSCnOMAhBwsYQg7Ilse5KNcJCxZEMll9hxoERADIFSQctY6BUpC0Joc/UW7BIXXIZMc+rZ1kuzLULppfVYlXUCoRfcE3dPFlyH17Clsav9fQhuAintU0GyH35q+gOAOoXOVYmtWti5a2azRXrtlQD7IdVwGxNu1E3wOxHuLgw2ftQuG8FcNF4QhZh1AQTkQe1pBQScIxjgi2ggUBCD0sSSugHxyVp8BoYVguQKKYJflQLuABwMQcMRyOUSSQlwOOUlRXA4ZAQ0CEDreguFySINGAwh22nEN5ICTBXE8OxjC2yw4roXYk1L78v7x+y1vqNmQpdnYp9UgqtlorOWw7kiL8eEnl/qnvGqhUMAAAAAASUVORK5CYII="

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACjBUbJAAAAEXRSTlMAIGCPv9//UJ/vQK/PgBAwcLh7S/gAAAJUSURBVHgB7Vhb06sgDES5Jdz0///aM0dto8RQdHj89qnTlrBZICxRDUyzNtYdsEbPk3oBD9YxWPDqESaNTgDqfl4huiZi6GMDNCRBDgcyJPoeOljlT1IIvqgLiofvj/kXnc+0RlDVmw/ZJimPjLqYOvpGWgebRTWxHKzE9PapcFU/seJOXI7Dcm9rCXIcKKoLBaRImf/QBtzr5LevuTwhm7SnbLIvN1P7Kme847NAdeTMzDjhVdPE4myrzGFDHSkxlokxv8WJVEmVTBMSR/qPhCAPBCb0gk5EVIT1IknYdGRxJFh1gjlz3OrYwvKSgJcpTxwnokeRG4h8X+4qafpIm5Ngtd8qZGRiEw29fcRKoWLv902Z/2eMtPxEH7/ze2EDVWd4CqE+1DQeav3wFEd1AI8/2mrATHFMdxmwh1j+fsnEGsdzm3YCRREojlZdKPsJ1NUBDl2EWOnQylQS0ZqlJ7XSbFrnW4my6kTe1K73quHlogFSgwUiicqoQErAXyB8Kfa45Zc35PpsQ8pHxDw7IsMOLSsj+LKMsMIGLwsblVqeW3pSannxt++KP7+OZkeI5WqxLXfyNB7razg5As6lMv1kkGgHY31lk0oEjNkHnyN+vyj8yhZMRHZNrNxEcFtDdGVkZmtEo1VSLyMyWmT9uiNN3Po1zCg4CZqb0aY99oKPBMEey4a95JtQdpYNu/yEKGslVZSeEAQv3NLTnM0OvVLtJaGdH/XMGvXwG/kUHf84Hv9cH9dA6GlpRLmlMb7JIrZ9Ft72Gd+IGt8aG9usG9A+/AdWuTLZQcIDLgAAAABJRU5ErkJggg=="

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACjBUbJAAAAEHRSTlMAIGCPv99Qn+9Ar8+AEDBwSAZjAAAAAmVJREFUeF69mOuOhCAMhVFuRS76/k+7WSVz4hQoa8yeP7PR9aM9SimogZZVG3tUWaPXRT2Q8/Zgst79jbJoOjoiPR9X2I6htjAXjQcg+hSqko9A+YmoElUIeZfVTdn5z80khRMrxnRcdaai4jAoRwhdSp3cIK0aTVFDlRpVN71rKNqVqJ2uwLsc5D7npe9zfFZTyr5HSrgxJ9/2yZ2cHYAc7sqdod1XzlTjQeRMRpdGTHT3NH7lZY6m7MpJkUUZEX1pUfhLzRE2ITFabuCeqKj+gx5Gj0HMlP1mSTitVHMg/CfMDBV01rEigaDqONzcaqIIbw5k2Ju7stX4k4PSJawEeE4hDH2CCINw0Ie9EssNxtBncrghCG7wQoTnfSVKIOXbJimqFtv6K4ICA2EAW81yM6ClA3KX/+svKM+ASgeUL/81JrAAWjkIpUMrA4sEEEqL5nXJnF4nEYSAOh+LVZh0HRDvCCwYeJ0SyFy6zZD9AailqN4BxfwOCJznIMzXeZDcPz4H2YTxGiDpg4ztcsY/SGmKFAIpDNoJI07a0Fwb+aSVy8g6JKGMyIXND0gobDOlNoJkc9siO1X8s2UThBX/ueWoUI+E5ytx64FgAyehcJK8ZH/aFwiGYsmWmwg4ykm4schtjUKXByXW1siNFj47AohYozVs/QBir461fmIzSqq5Ho0fxHvF696aCRvWHncb9tisHBuu8oadbyEwFn3VsrzhKttCIJl7lCGllc+rsuPqjuX7/W3W843fm1vR9zfHz7frbx4gPD/S2LADfP2QZf7Yp/Bjn/88iJKPxv71sO758eEPw9J3sUgM/jwAAAAASUVORK5CYII="

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABa1BMVEUAAADR09SnqazR09SAgoXR09TR09Snqaynqay8vsC8vsCnqay8vsCAgoWnqayAgoWAgoXR09SnqaxBQEKAgoW8vsDR09SbnJ1BQELJy81KSUukpabR09S8vsC9v8GAgoXR09TR09S8vsDKzM68vsDR09SnqaynqazR09TR09SnqaynqayAgoWoqq28vsBlZWetrrDBw8W9lZzR09S8tLfHycp3d3lBQEKJiou2t7nMzs/Nz9BgYGK/wcPJgo2kpaa8n6W+OEzQx8rKzM6+IzqSk5S+QlXNsLW/wcK9ipO8qa6dn6G9YXC9gIrIdoO9bHnEU2TCPFDO0NJTUlTPvMBJSEp/f4HAMEXMpatcXF2lpqhKSUvDxcabnJ2+GTFubnC9V2fJy83AwsTDSFrIysvExshQUFKGh4m/JTvGaniOj5G9TV69v8HFx8mAgILLmaHKjZfBRlnAO07LrrO9doG+LkPFX27Ioai/l5/b4yfoAAAAK3RSTlMAIEBwgJ+/3wAgYI+/ADCP32AQABAAAAAQAAAAEI8AQN9A3wAQj4DPMIBQL1HzygAAA2ZJREFUeF6slVdLJEEURlvEBsUXWTavi+OuoC+3c5qcgznnnPPm8PO3bnVRQ7vVegc8L/U1wz11Z5qP0ZT0ZfqnBnR9HAAcAYvjuj4w1Z/pe6VCE0EyODQ6LIcZqjw8OjT48gFa4mlyYkwxrMxjE5OpG2V01XB61jNq0UhigJRHVKIPiQFi7kHUmp8vrtJFSFe0ifBcruwji9VYVP3KtC2yaJYPn7A8Xd+PWaqiqHgZf+ISRWKY5SYGzjy/QFBxaaKbWGRZNgt1G37i4QI+CQ5pIrBt/GkADplhAYAvNsf99Y7Nr3lKlLsrAKfJRagrA/CVZgF/LxsAfvGzcJdLFWUt4EhRfDfwL9WUT00hBCurFh0BJESeh6Is4w+K+EZ/rYLYiHP0VqLJ9BkktdwJf2sochibKOLvYOlLaxH1IFC1n4uOT+MqqET2vuQG4PRYKUIAzpYdJ10Ec1Jk42XLZymiW3wNCRH2o8VERXxrWJ3F2NMUFcndfpRo3VhzHoqwK1dMtMTOTjzcwpbYmJHaJ4nWjc5/ojJeX1z9zY5LYAjPFbW0KFJ0Ddu/weJGlS5a/sa7Bm5deCqAWN+xJT8cokhWhDEd7zTrAmJj7mAid20By8Upzy10pkFQwfJyqF2DchkUuLZ0ErsGBWvX8zBkBZg9b9cSK1O79tg/R64GQO2aID0TukYTEbpGEhG6RhPRu0bIhIo8o6htNkLfMM6DBOeG4YcNs00Tmdd+PniCvH9tPi6K7lcCIiv3UarINIKeMEy1aC9xoXEQhhczMzOmgMWLMDwwEivvvZZoMr0RirX8eil6rCJRaT2/JkwvJJpMXLTV2KZVZLuxpRQhQeC3e6lI208R7US9ViTaeSfRurHUe0VK7yVaNz5TRf61V8aqCgNBFB2CsAtLNCz26XywdxWCpIlYvT+wtlGSTv+/dUniuJoiMEYrTzPdaYbLsUYiMlb3UH8ThbhrVV02oWsvFEVT1tUhEkElTyJrABaNE4kAYx+iPPMB7to43DUfyPI0QGm6XPgW7to43DXfMmtFiUKHpGvo+JtrMuhZS7qGOysCiyRdA0NgJF0DQ56RdM0zkUjStUgERjIRMB8QibY2FAm3NviaeGsMi+Rbi78m3xpDmGZr+ObWfltT04gUuWlEjrRT74uU0zfcPb3GLsGnhgAAAABJRU5ErkJggg=="

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/helveticaNeue.fad33fc5.png";

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans.28c32de9.png";

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensansbold.6d887e1a.png";

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/raleway.45c729f4.png";

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/roboto.a6811118.png";

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/btn_copy.72ea0d1b.png";

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/btn_delete.d9e1c3ab.png";

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABGdBTUEAALGPC/xhBQAAJDFJREFUeAHtnXmQ3VeV379vf92v91Zr3xfLsi3LRnjBpgwYhgEPHjMYY2AKKJbMVKhK1WSqMn9MpaYqqQkhk4VJqpJUpWyWSREW48qAGZuAwQs2YHkVyLIsS1ZLakkttVq9v33J53vfe+22bFlS68mWba503v0t93eX7zn33HPPvb9fR3SBhlqt1knVNp5Eyzn39bnEqaZOoiHOn59LkUjEaS64ELlQagTgXdTlBuhG6H3QFqhV9auR13boAegX0MMwZJL47R0AvRv6EvQQVIZer+CyXKbL7n5bcYEGR6CboO9BOeiNDq6D6+I6tarHXXg8pXEx6NPQDuhCDa6b6xi78BCcZ43cGOiL0AvQmyW4rq7zm5sRNOA66BnozRpc9+vmKXtv3GNUegF0J1SF3uzBbXBbFpwPRFs+6FDRW6jo16G+81HhNzDPUcr+IubrD1tZh2irMgP4BPRfyO8fobca+Iap321zG91WX2hFaEkPoEKrqcz3oKtbUak3QR7bqOPt9IbBc63rOTMA8K+iEvdC50VHnmsDz+Pzx8n7Jpjw+LmUcU4qCPA/SOGe2r/dwDfmbvMvGhj4fF5h3gyg4E9R4o+hjnmV/NZ4yG3/cQOLebVoXiqoUeC3KXFez8+rphf2Q3b2/Snq6DtnW82zBrDR5Sz5LbMEzrbSF2j6EvX6CEz46dnU76wYAPgecK3z385q57XwnebmjWczMJ8xAwB/NZl7xPfg8/twagRsHV0FEwZPneSlO2c0CAO+1Y3t/AsGfOqkJr3UnNfhqFw+XSHGyO7tM1LRZ9QDyOxrZPoXpyv5fNwPIFcrilRpOFTOTahSynNclGpV1aJxRWNJxdKdiibaFInS7miM+A13ZP49veBfng6T0zIAAOzbsXvhdQsB9HJB5ZkTKo/tU3nigKondik6uUux3JBimlBURUXMAMVVjbSpHBtQJbNatZ6LlejboHjvOsU6FitqxsTPSBjPR/s+ChNe03f0mgwACHcnL26/Lr6daqWi6sxxlY7tUvHINkUO/0KZ/OOK9VSltoqUxNpLoDXjSHd0TtVL3KuQpggVuJeNKDe9ULme65VY8T6llr1D0e5V9JIOReY8dj4QPylPO/AuhgkeF141vGZ1YMCdPPWFV32yhRcr1ZoqE4dUHPylyvvuU/vx+5QcyErtANqZBPwMxwul9AqYMAADOI+kIKpfM/iopAqbHvJHpdxBGHBCmp4m5t5kTDPZVaqsuk2JNR9UfOnlSrR5U8XrFr4OA754qtJOyQDA90LEI9Ap05wq07O5XpweV/HFh1TZ/V11nbhHkQUFQEfKu3qk7vVSz1bA3yClNiH9K5F8b56wSkHSQ9U8B/LAyHPlMXrBPg6fY6PKb6WJZ6VxzidhznRMuYnlKq/9rOKbblNy8SbFYmdkg5D3OQVX8N0w4Vevlsurggv4bt2T0JZXe6gV1zBiENgXVHr6TiX3fUPpBfTSTqrTu1gaYLrRcy3nOFcT6yiuHaJK6HxG33rxzsDBLWgcKkIa94oIDKmNUwDac+Ix6cSvpWPPwAwYNBHTePVdil32Z0pe8sdKZczQ8x68JWYrTKBLvjycigFfJNkdL0/aurMy+rqw++cqPvFf1Vtk4tjDJLK/V1p8jbQQ/17nu8AbleNQ9QTToLuqJkAOsaW3ibzv+9jtcwxF4sSQmVE6KI09KA3fD8GIsbwKx/uUX/9lpa76ZzB/JWnPe/gSDLjz5FJewYCG9O8iIf2/9SE3PaXig19RahCp70Vn9wLS8uulFZ8A+MsBDGm3yWndHoKBtGQbcIPvuMkMDkOYw4DQS3g+MMPXCWaGzVKrqLFHpX3flw7v5JjxgSWM8lX/Wl2X33S+B+g91MQDcrNh9aqF3zk/MODTnH57zqWWHc5MTaj0s79Rx9A3FO9DLy8A7DU3S8s+ykC7FMwALkg8IFudBLAN/pzjWemfWy1LvcFuUGCe28l5kyHmWZQB3b1jCtW073vS/odQT9JMabMqV/2NOrd+/HwzwQ67/0MlZsPLegDg+/x30KWzKVp0MJPNqvSTv1bngTsU658BfCyRDbejdlA5CUs9g6j1etDjTcAbUh8Y4GsBxUY8t+pmAICH5w26wW8wIDChce77UedJj8gx5gzeDSPuk45XNVPcpPJ1/15dV95yPpmAVaDNMMEVDsH9e274MCctBz9XYAb7wFeVGfy6Yn2A3wP4awB/wQ1gWgSrHMUaUCiM/4Bdcy9oULhm4JrUSMuVemgwwNIdJN7MaEi/e3zzmu9XuY7Zq3gatXcL98ihjOk7ukszv/o3mkx3q/uS9zbybXlkbI3xvc2cT2bA55o3WhnnHvum2nb9LyW6UTvdNHw1aqd/K43P0ngAsjkYdLwBbjDB52aCqQl86AlN8B07GMEmNUBvqiLHBjycuxeQLjCG4zLzhAjm7JIPMEjnFKkw6RvdrulH/1a5ZZeprdtz0PMSjPEsA5qtsGOrmxvDEAi1LuRG9qt618fUHnlakT6KW/sH0tL3o3aQ8lgD/Lir0QS6ecz9JlNC3LzudD42ORh8B4NPfu7dQeINvI8NvMnpTA2mlDmumJDB/CTq6EeMCU+pNpbQxBVfU+b6P1MiAYNaH5g1ajFqaMJZz+0Bt3HeUvCLBcy9J/9B3aXtivTS2IVbcGpcCQ7UAbfDrIqpAGbQzU1wiZs9wIwJQ1Pj3iwzmgxwM8i7CXqYHzSlnuthbDADHDgPKshMaBzbhRED6EXXMVk7rkjhgCKPf02lJZuV2HhD/bHW/hpjY32Hs53LgM/4QquCcSjs+aUi2+8AfADowcrpv6Iu6BUkzoBXGqAGaeY4OGp8DQqqB5DnAh6Y0gS+GRtkB+IAvs8BNTCkcRxUkO83gee4ORa4h5g/SQyBhahFZuZdU3s1+vgdii7cgKm8xJm3OhjrlxiA+vF0EGO8dSE7flQzT31Xi+MHmMi2IfmbaCQ+HPtsDFYFFWPgA+jEBjzmczPA4DaOZ8cAp2lc5249jWOD7OC4SQA9F3RfN3OaUh/AdxLSBTVkJlBuZhH1vEiRE0+qbe9dKu69WemtCKuLbW243pijhiabPeAG8jciLQlua3nwN0rvYcLjsawT6W/jIFg7Bsf6vQHmXMCNX3NADnED9GoTATPHgfPwvB8ghMg/JvJ38pCUc4NudWdV42NXrskMXwsMIPaYYGurcxmMeF6ZmSkdfeJbSq6+lpnyCjJsaTDWN0A/bjLgxlZmX5weVfH5n2igHUsjxeTHDDBgZUzQWSkGoaZut+QbZIPmGWs8inBWMJBqSibRz74GhnVkGzUNz/oY4GYDxwaf5OVyEY1TZaz3QGqgySAwwKec+9iglxvgB0ZxL46XNTPAaDittqGfKX/waaX6ltMxnXFLgzFvPQPoWioOs3CyG6siQ6VZEAk2t13GtlAs8R50T+4BbqAZACPG9o9r95NHNDKc1ZpNfVq/dblSXR2AdRoAeB7Htkb2jGj7AwdUYp1g46ULtHLzEiXSCEKQeJfRYEBT+pvgmxn8V3sPgtOurvYZHf7dj9S+/t1KdvadpvCzvv0+PxEHMBASTpjWhAprpvmhZzRQO4KpSQczA8BWZWz+uogTNxhgJgT14nPQIzq6+4Tu+YedeuI3I8ozP+vtj+tDt47qhtsuVlsvTCjBxJdJPQ/5HAby8pMOPH1IP/zGTj392ImgaRYt3qebb1+raz/MKpl7U1BFTQbwaJMps2MBecUZkFOUFc8qtu9nqk7RltYzYIuxtwraCLkVLQmV7JgKex9BDbBoHk/iWaBLV3AzWMKrViUGmuNmL/Cx1QmrXNPHs7r/B8/rsV+OaOFAVJ0rYjp6tKx7v/+iuvoSuvrm9QwRVBn1FAKP1XnBAWPGiQPjuu/bz2nHkye0dnUMTRbV4eGSfvidverrT+nia5Yqagm36gkDMMcBeMfcMHli6J6abFMtGVdm8rBmDu1UYtHFrB9Q/9YF136jO70Z0JJg9VMaG1LkwCPByKkl6PbWwehjlXErV4i9mB5imGLGsParGvoaFbXvmaN65vERrVwe00XrElqxJKpLLk4oyYTt0f83pBODo6RFlfmZ8KyPIZ6vFLJ6/teH9MKOOvirl8e1YllUl25KqFQo6dH7h1gowwIjbfA7Nevi+jTJ1wKh6xCeCtSeKGt610M8ZndJy8PGZg9oSc5mQP7YXnWWj7BIHlc8LIYjTQbLKsYmpSXfghRiH1sQospPl/XMb44CdlWrViRZ+kWbo5M722NaszKhoeFpvfjbY+pbxg4I9xhLazOQ99SxrH73+DF1YPEuW8xOiYbN39MR0+oVcR14cUKHd49qw5X9uJ8s6e4FkPW+O1QgX4foHTWUQpXdFrVoVtUDv2I3xrjibail1oYWMwB3cnHsMG4HFtejqdCIGmNCpAxgATQYYFVk0H3NLggzA1UxPZzT8KGsujuiCHhFeYQwyhhSy5WUYiE+gUo7sn9axXxBbXZjNNWQAalGNX54WqNHc+H5Ug4LiozDOJ8tqT2JemJ0PXxgSmsv7lDc44gpqB8zAQL3wBCrJphQY00iyAtVjuWOYUFPhTEl5OkyWxMCA1a0Ji9yQdWURvbWx1WAjiOFNfz7kaKBNvg0jiiQmVCCEgyemJmTx/PKZctKRaqKsAh/6fUrtWBNt/Y8NqT9Tw6L17g1RppKlt7U6cEU0BzIogZgU2MFfGplxv2q4j1d2vohBt22mPZtO6T9qLYqaY4P+/mi4pb8ItRkQACfvHzdxwhNzWsTiFAFxGOFEypOjqh96cX1AvltUUBRtnCfZwVVUz6B841MowEZjqz7LeZurMEHsNALmoxwT2DQKwF+IV9R50Ba19+yRqve0Qtvqlq+crUeYV4wdPdBtpoADPqcLvZyBqCCKsX68/0rM7ru1rVafWm7opS5atUqPUJZB+9hMJ0CVHpECFZDVjtN0F1pqhjODT7EK4YwIKYke5CK4wgBvSPS2oHY2w/Chy+Izj3UmOyUZsbo0Ug1SNeCVUFjvG/HVIRQL0G/IK1CVagZcy+bq2rtpdj9G9qVGmXz1bFxZeJ5XfP+AXUMtKnAfU9iZy2WYLmwa46eVi1VlWM83rC1HzWTVnx0XNHhMXUwaF9zXb9SbG8pUlaNdPVyXbbrArlOrpvraPXjHgC5sDAWIFKlqaOcc7+1IZihnge0JFRt7RRn6iDZvkcCrTrqytPINYJ7QSCuMRhHWDjv7khry9ZF2rK5R9FpkDQoKRKhWnq6k3rn+xcpN1lSLEWnBZu6nqvn4zWX7kUZXf7eJbpsK88zTihfz1ujefWm47rinQuYF6JO3OM8wLgjNKWfwyD9rpOr6esw1+O4FwnNhEqeWX3gvhO3LLSWAVEkJFor07OpNG1wA9zNgxy5YSH4BgdurAfkoIcrWtyT1idvWapUHHAmQIeBMwzUHvWmK7rxA2w9BIykzUhLcRgNGxlhu69e165lG7qV8poyjPLAHAZXeMFmUv3Re3AvFHBNzGBOFnjOwuyynUUIlOM6oQ79z3o0CDxlVhiNU6FVjaStiwIDWpad92DGsf2reTMAavSC0MrAEYqydDUDpmawiEgXYWkybdFG3wfwrRxNtpSwWOLY6vEmwwJSzsSIESgrBhNiHuTd42ziGuDmMfo+6Q29MCCQpd/3mj0gAM81lwcDLPN15tQFqQwzO3BlnAd/UFgPsH+4HzrnEGHSFWdNtTYZrXdfGuiBa5YBPnSjm13ZgPqag5lhcmjOEwKQpLG0W+0YGIPlnxA7fTio52tQfe4o9CwOfM3WllWaGRDOG9edxsFRnB8LjHsAg39d/XCLazVzxu0i70Zp4bEW/EzZCmodA+gBie6FqgzXpT/0gIC/9RBVdwPNgGbDLXG+b4BDb+DY4GPzz5Il2ZM4pw1IOSYYtBCakBCHay6DTMMATYLARJfpY8iMDExwmkYmIQuXwbl7EUxwPa2CTFZB8c4BqhkqQQYtC1PO0QxoSfDe/OSCVdSaWSSNDNJDezxDDqCEmGMDYDIAZkggA0c1Avm4Sb7mNMTNmXSTmT63rndaAx3ik/Nons+NG/k5X9djtg6us4GvheqGORkMqMYyinexWBPGHfJpXZjtAS3JMoL7IdW7XDOAYVM6NARpZj4LE7ChDRztrQcOwjHX+B8GZN/wtZAOYA1wIK6ZAb7ptJbkEHziBxpxyI9TMyXk07gdVB7X3Lv8cDNdiPkJ5TUfqASB8UTbaqgCg+LtvYq2ec+Cy2lpCD1gqFVZRvBUxroWo27jTCar9TUQGoGVThGNBroNQc0YEIhuXWRWOjWNdRPu+SbXHfxI6Amcz8Zzj3kgXHe65nWuBUAdOxNiD+xEU5NFFTwOeD3a44/LDzN0jvlPJjzDQ64zFBbSzIDeleyYZD2g9T1giBqEFzBc+jmHGg2LLlinaO9aLD8YQCuqdGm+90LeAc06tqHhtNggYG4en6zo7gdH9ewua0NanoQJXgUL0k+aADKxgZ1lxNxjmtFM04yd1nnYb0TYs3dSd90/ouFxJNwveQQGkMYuEaPQMD+tLoNmpAeU3Abc5+1rr1GsjUWa1ofnW8oA2wjJgXXq3vzBMHgVmV16J7RfwKjasgi+IFrmQdbmpYGAGZnFnTpaSeo//mBYd//TYZxu7JowCp502aPqwS/oe54JAIMEfHqJGtedxmh6zcDPEo4NTenH9x3S3333iA7kY+pazFsy7hGmIAgkoj6um60f/3OdS1CRWXJJGWU2vleRZEt37IS68fO8a/l886wVcYSFjLa112r8V99i49uUEixqxBMYckhWxFYGjWQ3QB1UIveM7o64Pv6Hy/Q/Jgq657Fx7Tta0BWbprXpkm4tW4vubYMJlljriYaKqKuX+qW6xuKe8/eAykx3GCY+/9yEntoxoR17s+roT+v2m1aop4cmT7I6Z8lvWDtB2QO8pb/M8+65RbZTFmcqSq95hxIDF9Xr6+q2NswygFrXteA554/0JZdv4VWgy1Q88EvlcCfHUTNRGmyLOrQ7mHr0hKYawMG2bkmHPvOxtfr+PXu0+1BOh8eK2rZzUpeuG9PaNRktWMgabXdKmQwqxe+Ihd101NZWDKoiO1PW5GRBoyMs7OC23vEC7mncGBPMogeWtOlWVtM2rcafP0bvCsxE6hmQsdcAHrm36jH4ZFdgzlDI44Aj+/7LP8RLOcyiWx+M+fNxpHEKzvsNDnZNtSbUckfZDDGs5NpFKo5O4mbGJU2jI0lLMZymF1hqI4EbvFDHenFtalqXkz7xyUv005+/qKHBMR0fz+nhp2EEUtyejqkzE1dfT0LdxOkU/layy+FWmJwuaRT3xSTe0hwOtjyz4hpmDEXook1d+sAfbNDmlWnlRg7jtMvhYmoLGghHFUyoj1MGn4+JAjxr2jyfXr5APb3tirXX86rXPFS/VT/bjX1dUUoPkGvLGFBhH36NnWa9/Unl+nqUPXhIWVs5eCSTqfqgGKPhEQBg86IqrNeWLHFDR3TJqtXquf1SbXuC5cVnj2hqPB8kdaYY1QS+/MFhBMcDbCNYbXiIiMHgBLPZGCtq7iTtXSmt27RY116zQkt7YvTGI8qWJ5Ve0qPC+IwivEnpmrB0FKS+FMAvMVmuKbNuGePSAMIzyuDbT+9labX1wZjX1Q6N+AjH97SqjBrrqlPP/pOmt/1n9Q4ALCpmevAQvvicMgCTYqEkwQBYZZpZ6IoptWqdpgaHNbZjREtWL1RmTZ9yibQOHS3qyScOauTIuLKTubBE6RqDVaBmA8IElWtRBvV2vKr9i3r0jqtWsKbcrgzu6MrxKQ3vGlGVLZKL33mJSuPHpQP0Ul72s84vocbyM0V8fxEkf7EySxZrnDJjSz6mnqv+XNGOugqqshYd9b6h1oSb6QGz+4IeJk+Ucn2qcrb5F8cP6fj9/y6g0nPNl9S+cqs6L7s5TN9ntv2duvsmkKSUJvYc0AQ6OFNBl7OqZYuDd0YBLsVcAGagQgrTWWV4o7EtkdW6/nYtv2mdxrI1HTzImu4hGEFPKuO3rwZnDWrNko+p2Z5JavGyHq1Y0aVeukCaxaHoNK+/4CIv4t7OT+aZTNXHjmhbe/BG29Ix5VBhVZY/M2tXsAtuQCdeHFFqw+fV9Y7Phxe9i2MHNb7tm8rvf0zdV39O3VfcdrYQnZzeWBvz+uZcODFJL3iU8xt88WxDaeR5xQ7fq2R3hybu/bWmVn5Evdd8QW2rrkUX/5WOP/iX6vdAunm9TuzapwmkyxO1tnacdvjtkUHF/BK25w2oorDTgTXZCH79NDsTlsC8RRvbVdvYyXgbxTnKcI608kTQ82ZlHAsoysJAtIC7mcG4vhLndqJisvQCrJoE6i/CkqWn6VU8rDlW0XIs0kQzbereuJpZfK9yQ8fYSHwjr6t9Ev1Q04lt31Ju+zeUKB5Rgrd8Jp/8bisY8KgxN87NMcDH/xuaFwNSbOWeWXOriod+gu6lfUf/r47f/YA6t3xGHZd/QuP9H9bR5+7S4suWwAQkOr1fk/tHQ7fv7PU3HhJq60kplgGUqVJY942l7ctAufuFPVzJ2FHBevHenLTt96A9zQICUjy79TCwhfPgS4ABqLkSY4ft/HbGmlgb200wjfPMiEuYmcmFnQH8ZGevZvYe1tHBmJZ86rPh0whjj/43jIOdasPiKmEeVdha3/f+f1Uv89x+jXUIs6MZPcDOjmFo3jOO7N4HNPPk/1SqvC9IdWEqxzR+s9ouu10Hf/EdtdWe0aLNKwGyqulDR5Qfm1DX+hXKrFyhyviQDj/6grL7K1q6Ns1GNH9wA6DDnAHV4eMg77NV5rzBgPpQxrkBB/xAvoeJyaVj+wqs0ZS09L3LUTMXsbrFGLXzOZYnI+pctQJfT5cm9g7p4BOjqM6Pqn9JStnB+5Vpj4fZcL7Yw3vit6n32j+nCtTl3AILEy+9oDG3NZ6IfI+bnzjb/KtIaJmXG6JYPpFkh2ae/YFKL9zF9g+6bRz/SzWlmUI33XuHFl3cq/SAt0yzKpIo0f37+IYD7wjnj2li124dYUtiezqlgeVJtmdGUCtUEaq/1+bjhvQ3a97kgZnRAN6XPFA7ZKeqGj6QVfvqlBZfexGukjX1dLkRFvg9B0irMpPVyNO7NTESUz8C0ZkpIfExwGc7/aL3qOvqf07bOkIbYyk8ox399czn9/t91M/tzUfnqiBf+xZ01gyY3PlTjT/8nxTvpvKX/wm6/z1Kr7pBMzu+z9vwDyiZPqGFPXySoJtNUQyAdkuEV3eTmHdIdg1QI8lutQ+YRjRzuKQ23mi3dzW8JYQutsavM8Ez6Wb1HXMC2k0+1C2k+vhQxroZH0GlMaXqWNxXd6iFV1URQsqOsDhQZdJVRaq71i5Vr3nD+FIq9qnUcSk99zNscVnJXtftGt/+Q+V2P6z06iu08rPfnFuBsz02xrPhZAbcx51nobN6UzJ/+LdKZveoJ3VEuUd+pWOPr1X7xj9iP+UVqnRvUH7f3WiHQaUBAQUB4NMIMhMc+2yAp4aeiETTjAFdSjHRmhjKa3rKq2sAyc447wTxPLoJ/Jy3PHnegXQNDtQZgL5G9eTQ8VnGlCTvpqX7ukLvJCmBm/b/hAEZhrKFPtkzwM6HGfYWsfK19E+U6FnDLu/fafSnf6v83ofV28aiDE9m93uRed7B2Brj2fAyBtA10EK1r3D327MpzuCg7+pPaaw4Rhd+iq2gI+pLH1F8/x0afRbwlr5bkfQSFaf2YUnwNmLw64CWP6wU1AlqAHVUwyqPYJIme9oYKLNhj1A+hwqihv6oRoRxg/oF/AIzqJfl3rJu7ANh04eYnxJWThYGlNhekulOMKNlx3MYUzxOQH7jkp7omXCN9WZfKk0zKYz1qTaxW7nffUOZwpB6sMzGsMKy6YWKLdqsBVeekwn6FWM8F9IgD3MvwACPMrug9XOvn+7Y3/rJHXxKeT45UxnbiQ3+gqKlEfbYx4Ubno8noTt7U+hPdHi8DkCQaLsoYoDOpKiWPc6EbI+Gn+abQfSAju642pioJZhg1cfjOb1gToWaLbLr2z3AcYmF+OwEPQBQ+y9r18Ir1is+sALVA0fZCOy16moJFZS31cVODqzX6jSeUOYMnVHcGszAC+WMqqnlii+8Uum171Jm/fW8vzHvXTx7qPIrPlXwsh7gNsGhCkz4Kod3+PxMQxQ9kVl9lZKLeBeMUBobVPn4Lo3zcYza2BMYPmOh59fYol5fW7W1QkKAqOEiqHhT19Q4pmkOaeSGJ0nY7hGDwv4guxpCD/AYjNzX1ZHlpw66Y7Iiv7r6KTHAliGf282Rn55ksoahgEFQRfrxgoTNXFX2CblO5lyVGXyFL7OMt29RbNUWduldgnt9fTAuPMCfA/iu9FeNrQ/mhlcwoHHzm8T/AtrSOD9tVGH38PGffVXVkZ3hFZ8I74RF2ujO8YUqJy/DzHwIryibtnhhIxK8mUg8/1B6YdJUyk6z8WpKhQn2l04yEPKxpYjHBiZeVczFGP77OgMA3aooYG8ONvW/AeSc/LyrupA1IQjsS02N43OamMLcbKefkYQeF4BHTXntuuodcYWCiiem+XjHRUp0LVNk5IhmBnfyBa9R1fiKV40Z9cKP/we1r+A126AITwvJ3AR2dn5z7oXm8asyoNELvkyiR6BXqKnmw3PjGvv0Z3b/XEuiQypmca6hvKt8AyKW7mG8s1Yr0tB4+DJBBNPGW1gCihZF+n9phtkqHtFyuVe97/20sod3aXLPNhxn46zbVGEAzGBCZDM8yqzXzIB/IdTVDtmAYwCUVayZUlTp/tXq3fhu1aZ3YuU+x2x7EkGmbCygapWVaor2VsUqHtTqFONAEdd5YR8zaV5vmgJ0vuySQPKTlDeNtRS2J85t9Jkdu5ZffjXp9+OvCS6q6E7SfMEJTxe8C3pmEMBefFCFw9vR5wdZH8liOcyoq4OXJJhEVQEw0tnFunF3mJGGjU68uFdiDlE8MaLpI5NKrfq8Fvzhv4UnEyqMvKjpF3+jqb1PKDe8J6SrFJlz5POMGagnau99qHaQJVJYUbbRexapY9XlzG7foxRfxUr2LlMJK+3AXfh2+EhIakGfEh1d9ALmm8y0vbO6yo7r8iTMwc8U9x7VqYLyqCq2QijGJoP08stZlrxWHRvfT73Pemlyfp8sM+AwwDMmD8hnPPOoFqbxu0wjWbzYUJigYbiB99yvwsFtfBfuBb5EllCqn4Z1Z5DEGGlnkPwTmsI/VOy8SSs//t/xPi508SE4nzJ7882QWn6Cl1noJTnyL7J+jLshwkc3IrzP5Q/yRdOYmqluJTIwOLyb1ujguDPGfn2njvz4r9XdX+Grip1sXc/Qk2BAAefeeFYzJ3IqJ5YpuXQL3w76YyXoPfE2dkOQdwTGOr957AsapRHz/2ifEYAJtxD9o4/nE7wwUmXDboXvMeSHn9Pkjh8pN/ggk+D9wTws4yKYKXSpsuwTWvORv8KhtzgUQ7khDqrmZQVz3TNe65+Qhm5gEyl05pc6dDBI61kEdVVjtn786Xt09Od/z4vYT+G2xoXH/VJkgVLL3qmeK29Fv29lLoL/38y0ijz3cG6frWyWDxhf4/gvmufzjb30ZyAKvOyQPbhd+SM7goRl1t2AD34jKoT3i04KZsRLsM65GUbhxnmDWXPu1seXl12AX3hBy7ioZ/ZtU+7YbkU6FqlrzVYmacuZg9CTwsTwpIfmf/o1hOcvT/f4q7bt5IcAweLgAfnqk++Fc++lj7/qeP6qyX3RzAh2I0C+3l+5rW8SQ/zNxDAZPGU153tjGw/6S4neBvya4YwY4BxgwmqixyGPC78Pp0aA5bYWf7zbZcHNQaKbIN5U+H04BQLGxn9XZvAU919xOcwrX3H1FBfI2D3gVui0XesUWbyVLxuTWxsYnXE7z4oBzpUCfkr0OahhY/jq2z4Yi881sDkrMM6aAc6dgr5D9KfQ73tCHYN5/f2YgKV/5hsYmD/Iszj737Z/0sQ632rHWmFe4YytoFPlDhOu4t690NvNOrK188b+ITczBe57YDYTbPu+XYLb6r8T47afU5jXGHByiVRkkGvvhv7+5HtvwXO30ZOswVa07ZxV0MmVQCXZd/R1qO/ke2/yczvWLtw/Z9sEF8n4IccbITPhrWCqug1ui72abtubJ9Abfv8nzd9odsGEGPRF6AXozRJcV9fZS3lvjeDGQJ+GdkAXanDdXMe3DvAniw+N8+ajmyD/tbkc9EYH18F1cZ1abpSc3P4L6pwGd0Nfgh6CeEPodQsuy2W67O43EpQLhuMA4e9X3wDd2CB/y7RV9bMl81voFw16GItmkuM3PLSqgS1vCAzpJFObs3NpOee+Ppc4Dd+7YJV+Nh7i2K/fzhKA+/4FF/4/1bQiTx452C4AAAAASUVORK5CYII="

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1452 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1454 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/chrome.e815bf0e.png";

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAPRJREFUWAljYBgFoyEwGgKjIUBCCPz//58ViBcDcTEJ2qijFGgpDxDvAmIY6AEyGKljOgFTgBaJAfEZmM1Q+hWQViKglXJpoCXKQHwHaimMugdkqFJuOgETgJYYA/FLmK1Q+gKQliSglXJpoCWuQPwZaimM2g9k8FFuOsIErIkIaEk0UMl8IGZFKGX4A2QvBeKfSGIkMxkZGdPxagJaXgzE/4CYJgDdciZ0AXrzWdAtBAZRL9DrL4DiNIkCdPtw8oGOoEsixOkAkATQEQOXDWEuAzpi4AoiJEcMXFGM5IiBq4yQHDFw1THMEaP0aAiMhsCwCwEAHHN7swnrg74AAAAASUVORK5CYII="

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAO9JREFUWAljYBgFoyEwGgKjIUClEPj//38xEC8GYlYqGUmcMUALGYG4B4hhYBeQwUOcbiqoAlqmBMSvYLZD6TNAWowKxhNnBNAyVSC+B7UcRt0BMpSJM4EKqoCWSQLxBZjtUPolkDamgvHEGQG0jA+I9wMxMvgM5LjiMoERXQKoeCa6GIl8dqD6aCBmQdL3G8hOYGRkXIYkhp2J7HQqs/8BzStGt5UJXYDefORggtk9C8Ygk6YsCsi0FKwNGMQkJ0JK7EPRC7R84LIh0PKBK4iAlg9sUQx0wMBWRrCEAHTIwFTHMAeM0qMhMBoCQzYEAOQQdgSxR/GmAAAAAElFTkSuQmCC"

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAtAAAACQCAYAAAAhkFzZAAAAAXNSR0IArs4c6QAAD3pJREFUeAHt3QuPHMUVBlCvgRgIiRTzigQKBIW8haJI/P9fkIcSIAQISCjkQQwhAQUcbDb3LlM3Ne2erZ5dr3d25pRUdHXV7Z7uM2PzuRkv165pBAgQIECAAAECBAgsFjhaXKmQAIGDEjg+Ps7fH65HH22nNVm/TU/XbeqzNtvSY1ptXmcb9+dYTdda22817Zi5+dPW+uPPWtdeM7fH/c5kv1/rx9Pj+rV+vLRu0zE539a+6sZtfrRtrz+q69fPckwe364vt/14unayf3R0lFuNAAECawLT3+DXFu0QIHD/BCKQZoBr/aFu3Ob6bb+e4/y1mutLt9vUbjpnvJxGgEAIDIN21MwG8G5+23PcXb1uHtePc3/aaz0Cf65pBAhcsIAAfcHATn/5AqvgmiG0hdI2bvsZNvvxpiC7ZL7VzJ3v8jFcAQEChyCwMWDHzU/Xcr8C+GR9yXzWtN7OdVeQDxVtrwUE6L1+e3fz5rpA24LrNNC2/Vx/OHpf14/7ujbO7bRmNyFcFQECBPZboAXrFsRP25/WZBi/E71C+WTcznWyLrDv9wdpF+9OgN7Fd+WSrykCbgujGV5PG8+t93PTINvCrc/dJb/HXp4AAQJ7JtC+QtOCddv2ATwDec63bT+em6v1COg51giUgCBTFFdr0D3FbYG1bTOktnHb9nP9eG495zQCBAgQIEBgXaCF7LatgB1lc3Oj9ZNjPD1fR74qewL0A3qnIvCmdYbT8/YWgL13D+i98zIECBAgQOACBfLpeQvguT1Xj0DuJ8dc4JvVTi2ENYmZ7eop73kDbzs+g69GgAABAgQIELhIgfbk+1xBPC7wjqfjm9+mvQ3QEX4zuD4SvW37cT/X5lvQ7bf5HV6NAAECBAgQIHCIAu0vc86F8S8DpPVcz3Hb1jhCeM7tXdvJAB3ht31NIcNtC7j9dsl4794sN0SAAAECBAgQuIICFajj2peM14J4hPCd+0ucFxKgV9/3fSyQWgDeFHjbk+C2bfUXcl1X8APnkgkQIECAAAEChy7QnoRn+O4DeAvabduvtdrPL+J74ecOqquw/GTc0M3o34r+xKr7+kNAaAQIECBAgAABApcmkOH7s1X/NLYfR//ovKH6zAE6gnMG5edXPZ82awQIECBAgAABAgR2XeDzuMA/Z48gneF667Z1gI7gnE+Zfx79qa1fzQEECBAgQIAAAQIEdkfgVlzKaxGk8+n04rY4QEdwzu8p/yj696MvPm7xlSgkQIAAAQIECBAg8OAF8mdnvxf9jxGk8/vUw7YoCEd4fibO9IvoN4ZnVECAAAECBAgQIEDg6gncjkv+bYToD0eXPgzQEZ6/Fyd5JfqwdvRi1gkQIECAAAECBAjssEA+jf5dhOj3T7vGU0NxhOcfxsH5tQ2NAAECBAgQIECAwKEI5Nc53tp0sxsDdITnn8VBL2060DwBAgQIECBAgACBPRZ4N0L063P3N/uzmiM854+nE57nxMwRIECAAAECBAgcgsBLq0x8z73eE6Cj8NtRld951ggQIECAAAECBAgcssArq2y8ZrAWoKMg/1far0Z/aK3KDgECBAgQIECAAIHDE8hM/OoqI9fdrwXomH05+uO1akCAAAECBAgQIEDgsAUyG2dGrlYBOpL1ozH7Yq0YECBAgAABAgQIECCQAi+usvKJRgXo2PtBdF/dOGHxDwIECBAgQIAAAQIlkBk5s/JJOwnQkagfi70XVnM2BAgQIECAAAECBAisC7ywyszX2hPo52K9jddL7REgQIAAAQIECBAgkFk5M3OF5meZECBAgAABAgQIECBwqsBJZr4ej6K/EWU3Ty21SIAAAQIECBAgQIDAzczO+Sj6aRYECBAgQIAAAQIECCwSeDoDtKfPi6wUESBAgAABAgQIELh2MwN0/vxnjQABAgQIECBAgACBscCjGaBvjOtUECBAgAABAgQIECAQAjc8gfY5IECAAAECBAgQILBcwBPo5VYqCRAgQIAAAQIECHz9BDqfQmsECBAgQIAAAQIECIwFrgvPYyQVBAgQIECAAAECBEpAgC4KAwIECBAgQIAAAQJjAQF6bKSCAAECBAgQIECAQAkI0EVhQIAAAQIECBAgQGAsIECPjVQQIECAAAECBAgQKAEBuigMCBAgQIAAAQIECIwFBOixkQoCBAgQIECAAAECJSBAF4UBAQIECBAgQIAAgbGAAD02UkGAAAECBAgQIECgBAToojAgQIAAAQIECBAgMBYQoMdGKggQIECAAAECBAiUgABdFAYECBAgQIAAAQIExgIC9NhIBQECBAgQIECAAIESEKCLwoAAAQIECBAgQIDAWECAHhupIECAAAECBAgQIFACAnRRGBAgQIAAAQIECBAYCwjQYyMVBAgQIECAAAECBEpAgC4KAwIECBAgQIAAAQJjAQF6bKSCAAECBAgQIECAQAkI0EVhQIAAAQIECBAgQGAsIECPjVQQIECAAAECBAgQKAEBuigMCBAgQIAAAQIECIwFBOixkQoCBAgQIECAAAECJSBAF4UBAQIECBAgQIAAgbGAAD02UkGAAAECBAgQIECgBAToojAgQIAAAQIECBAgMBYQoMdGKggQIECAAAECBAiUgABdFAYECBAgQIAAAQIExgIC9NhIBQECBAgQIECAAIESEKCLwoAAAQIECBAgQIDAWECAHhupIECAAAECBAgQIFACAnRRGBAgQIAAAQIECBAYCwjQYyMVBAgQIECAAAECBEpAgC4KAwIECBAgQIAAAQJjAQF6bKSCAAECBAgQIECAQAkI0EVhQIAAAQIECBAgQGAsIECPjVQQIECAAAECBAgQKAEBuigMCBAgQIAAAQIECIwFBOixkQoCBAgQIECAAAECJSBAF4UBAQIECBAgQIAAgbGAAD02UkGAAAECBAgQIECgBAToojAgQIAAAQIECBAgMBYQoMdGKggQIECAAAECBAiUgABdFAYECBAgQIAAAQIExgIC9NhIBQECBAgQIECAAIESEKCLwoAAAQIECBAgQIDAWECAHhupIECAAAECBAgQIFACAnRRGBAgQIAAAQIECBAYCwjQYyMVBAgQIECAAAECBEpAgC4KAwIECBAgQIAAAQJjAQF6bKSCAAECBAgQIECAQAkI0EVhQIAAAQIECBAgQGAsIECPjVQQIECAAAECBAgQKAEBuigMCBAgQIAAAQIECIwFBOixkQoCBAgQIECAAAECJSBAF4UBAQIECBAgQIAAgbGAAD02UkGAAAECBAgQIECgBAToojAgQIAAAQIECBAgMBYQoMdGKggQIECAAAECBAiUgABdFAYECBAgQIAAAQIExgIC9NhIBQECBAgQIECAAIESEKCLwoAAAQIECBAgQIDAWECAHhupIECAAAECBAgQIFACAnRRGBAgQIAAAQIECBAYCwjQYyMVBAgQIECAAAECBEpAgC4KAwIECBAgQIAAAQJjAQF6bKSCAAECBAgQIECAQAkI0EVhQIAAAQIECBAgQGAsIECPjVQQIECAAAECBAgQKAEBuigMCBAgQIAAAQIECIwFBOixkQoCBAgQIECAAAECJSBAF4UBAQIECBAgQIAAgbGAAD02UkGAAAECBAgQIECgBAToojAgQIAAAQIECBAgMBYQoMdGKggQIECAAAECBAiUgABdFAYECBAgQIAAAQIExgIC9NhIBQECBAgQIECAAIESEKCLwoAAAQIECBAgQIDAWECAHhupIECAAAECBAgQIFACAnRRGBAgQIAAAQIECBAYC2SAvjMuU0GAAAECBAgQIECAQAjcFaB9DggQIECAAAECBAgsF7idAfo/y+tVEiBAgAABAgQIEDhogZMA/dlBE7h5AgQIECBAgAABAssFPs0n0J8sr1dJgAABAgQIECBA4KAF/pUB+u8HTeDmCRAgQIAAAQIECCwXuHX96Ojoi6j/5/JjVBIgQIAAAQIECBA4SIFPIjt/lk+gs/3t641/EiBAgAABAgQIECCwQeCDnBegN+iYJkCAAAECBAgQIDAR+H+AzkfRsXgyMSmyS4AAAQIECBAgQIBA/L3ByMy3E6I9gc7xm9GPc6ARIECAAAECBAgQIFACmZH/0PYqQEeizv+hynttwZYAAQIECBAgQIAAgROBdyMrf9osKkCvJt6O7Zdt0ZYAAQIECBAgQIDAgQvkT6x7qzdYC9CRrP8bi7+K7qscvZIxAQIECBAgQIDAoQq8Fhn5Tn/zawE6F6LgH7F5vS8yJkCAAAECBAgQIHCAAm9ENv7r9L7vCdBZEIX5Xej3p8X2CRAgQIAAAQIECByIQH7v+U9z9/rw3ORq7vexfSj6c6fUWCJAYD8E8mtbff9qsp9rS+ayJlvWZ2vbfjw3N7d+v+vmXqOf68fttdt2bu0sc3PHzL1G1jXL/kHHUS6sWhtPt7nc5vrx/ZibO8dZXmPumKXnXlo39xppmce3Pt3P+aVzeX6NAIH9FfhL3Nobm26v/41otub4+PjlWPjx7KJJAvsjkCGm70vCYtafte6sxy19zcXnjz9d5zk1AgS2EIh/N24TtqehfLp/nnPNHXvR5x9mhy0olRLYRYF34qLePO3fj4t+EcRvFN+NE/0yej6R1gicVaCFvwx3u9LvnvYL5Kw36jgCBAjss8DqDxCZCTKs71JflGv2+b1xb+cSyJ9E9+vIBR+OzrL4gxa/WJ6Ik/00+rOjk1q/dIHTgurduLq2PjfOuQsJt4LqpX8uXAABAgT2WqD7LwMXEerzDwyZm9ofHDaN5157cd7a6zdot2/uo7i830RW+XzJZW79hsaH88k48U+if2fJC6i51gJpblvPgNrG/XY6n/v5Y1P6+bbf5tbCcLzxeT6NAAECBAgQ2BGBLtifFrrz76VlOG8BPfczjLe5Nt/vt/GmujhcGwhkcH478lP+FLrFbesA3c4cH4b8Wsfz0Z+Jnm/gVWkZOFtobSG0hdKcb3Otpm1zvq/bVFvHC7NX5SPhOgkQIECAwP4JRFZrATu305A9ncv1udDeztGOb3XT48+cKS9BPrNgBuZ3IqtlgN66nftmV2/OU/HK+dWO3H5z66uYD60VRON8LcTOhdaldSfnCKhE0wgQIECAAAECBO6TwOopewvb/bYF735uGr7n9lv93PE5t237dxxwK3oG548jD+ZD0TO3cwfo6SsHYN7U49EfiZ5/ksnXmIbc2veUNnQ0AgQIECBAgACBxQKDp+uZPdtXXG/H+At5czGtQgIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIDAVRH4H0fdR9/BdlAhAAAAAElFTkSuQmCC"

/***/ }),
/* 1460 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1461 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 1463 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(238);
module.exports = __webpack_require__(237);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.15e431be.js